"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __knownSymbol = (name, symbol) => {
  if (symbol = Symbol[name])
    return symbol;
  throw Error("Symbol." + name + " is not defined");
};
var __pow = Math.pow;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __restKey = (key) => typeof key === "symbol" ? key : key + "";
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from2, except, desc) => {
  if (from2 && typeof from2 === "object" || typeof from2 === "function") {
    for (let key of __getOwnPropNames(from2))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from2[key], enumerable: !(desc = __getOwnPropDesc(from2, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x2) => x2.done ? resolve(x2.value) : Promise.resolve(x2.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
var __await = function(promise, isYieldStar) {
  this[0] = promise;
  this[1] = isYieldStar;
};
var __yieldStar = (value) => {
  var obj = value[__knownSymbol("asyncIterator")];
  var isAwait = false;
  var method4;
  var it = {};
  if (obj == null) {
    obj = value[__knownSymbol("iterator")]();
    method4 = (k) => it[k] = (x2) => obj[k](x2);
  } else {
    obj = obj.call(value);
    method4 = (k) => it[k] = (v) => {
      if (isAwait) {
        isAwait = false;
        if (k === "throw")
          throw v;
        return v;
      }
      isAwait = true;
      return {
        done: false,
        value: new __await(new Promise((resolve) => {
          var x2 = obj[k](v);
          if (!(x2 instanceof Object))
            throw TypeError("Object expected");
          resolve(x2);
        }), 1)
      };
    };
  }
  return it[__knownSymbol("iterator")] = () => it, method4("next"), "throw" in obj ? method4("throw") : it.throw = (x2) => {
    throw x2;
  }, "return" in obj && method4("return"), it;
};

// ../../node_modules/classnames/index.js
var require_classnames = __commonJS({
  "../../node_modules/classnames/index.js"(exports, module2) {
    "use strict";
    (function() {
      "use strict";
      var hasOwn = {}.hasOwnProperty;
      function classNames54() {
        var classes = "";
        for (var i = 0; i < arguments.length; i++) {
          var arg = arguments[i];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames54.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (typeof module2 !== "undefined" && module2.exports) {
        classNames54.default = classNames54;
        module2.exports = classNames54;
      } else if (typeof define === "function" && typeof define.amd === "object" && define.amd) {
        define("classnames", [], function() {
          return classNames54;
        });
      } else {
        window.classNames = classNames54;
      }
    })();
  }
});

// ../../node_modules/rc-util/node_modules/react-is/cjs/react-is.production.min.js
var require_react_is_production_min = __commonJS({
  "../../node_modules/rc-util/node_modules/react-is/cjs/react-is.production.min.js"(exports) {
    "use strict";
    var b = Symbol.for("react.element");
    var c = Symbol.for("react.portal");
    var d = Symbol.for("react.fragment");
    var e = Symbol.for("react.strict_mode");
    var f = Symbol.for("react.profiler");
    var g = Symbol.for("react.provider");
    var h = Symbol.for("react.context");
    var k = Symbol.for("react.server_context");
    var l = Symbol.for("react.forward_ref");
    var m = Symbol.for("react.suspense");
    var n = Symbol.for("react.suspense_list");
    var p = Symbol.for("react.memo");
    var q = Symbol.for("react.lazy");
    var t = Symbol.for("react.offscreen");
    var u;
    u = Symbol.for("react.module.reference");
    function v(a) {
      if ("object" === typeof a && null !== a) {
        var r = a.$$typeof;
        switch (r) {
          case b:
            switch (a = a.type, a) {
              case d:
              case f:
              case e:
              case m:
              case n:
                return a;
              default:
                switch (a = a && a.$$typeof, a) {
                  case k:
                  case h:
                  case l:
                  case q:
                  case p:
                  case g:
                    return a;
                  default:
                    return r;
                }
            }
          case c:
            return r;
        }
      }
    }
    exports.ContextConsumer = h;
    exports.ContextProvider = g;
    exports.Element = b;
    exports.ForwardRef = l;
    exports.Fragment = d;
    exports.Lazy = q;
    exports.Memo = p;
    exports.Portal = c;
    exports.Profiler = f;
    exports.StrictMode = e;
    exports.Suspense = m;
    exports.SuspenseList = n;
    exports.isAsyncMode = function() {
      return false;
    };
    exports.isConcurrentMode = function() {
      return false;
    };
    exports.isContextConsumer = function(a) {
      return v(a) === h;
    };
    exports.isContextProvider = function(a) {
      return v(a) === g;
    };
    exports.isElement = function(a) {
      return "object" === typeof a && null !== a && a.$$typeof === b;
    };
    exports.isForwardRef = function(a) {
      return v(a) === l;
    };
    exports.isFragment = function(a) {
      return v(a) === d;
    };
    exports.isLazy = function(a) {
      return v(a) === q;
    };
    exports.isMemo = function(a) {
      return v(a) === p;
    };
    exports.isPortal = function(a) {
      return v(a) === c;
    };
    exports.isProfiler = function(a) {
      return v(a) === f;
    };
    exports.isStrictMode = function(a) {
      return v(a) === e;
    };
    exports.isSuspense = function(a) {
      return v(a) === m;
    };
    exports.isSuspenseList = function(a) {
      return v(a) === n;
    };
    exports.isValidElementType = function(a) {
      return "string" === typeof a || "function" === typeof a || a === d || a === f || a === e || a === m || a === n || a === t || "object" === typeof a && null !== a && (a.$$typeof === q || a.$$typeof === p || a.$$typeof === g || a.$$typeof === h || a.$$typeof === l || a.$$typeof === u || void 0 !== a.getModuleId) ? true : false;
    };
    exports.typeOf = v;
  }
});

// ../../node_modules/rc-util/node_modules/react-is/cjs/react-is.development.js
var require_react_is_development = __commonJS({
  "../../node_modules/rc-util/node_modules/react-is/cjs/react-is.development.js"(exports) {
    "use strict";
    if (process.env.NODE_ENV !== "production") {
      (function() {
        "use strict";
        var REACT_ELEMENT_TYPE = Symbol.for("react.element");
        var REACT_PORTAL_TYPE = Symbol.for("react.portal");
        var REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
        var REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode");
        var REACT_PROFILER_TYPE = Symbol.for("react.profiler");
        var REACT_PROVIDER_TYPE = Symbol.for("react.provider");
        var REACT_CONTEXT_TYPE = Symbol.for("react.context");
        var REACT_SERVER_CONTEXT_TYPE = Symbol.for("react.server_context");
        var REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref");
        var REACT_SUSPENSE_TYPE = Symbol.for("react.suspense");
        var REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list");
        var REACT_MEMO_TYPE = Symbol.for("react.memo");
        var REACT_LAZY_TYPE = Symbol.for("react.lazy");
        var REACT_OFFSCREEN_TYPE = Symbol.for("react.offscreen");
        var enableScopeAPI = false;
        var enableCacheElement = false;
        var enableTransitionTracing = false;
        var enableLegacyHidden = false;
        var enableDebugTracing = false;
        var REACT_MODULE_REFERENCE;
        {
          REACT_MODULE_REFERENCE = Symbol.for("react.module.reference");
        }
        function isValidElementType(type4) {
          if (typeof type4 === "string" || typeof type4 === "function") {
            return true;
          }
          if (type4 === REACT_FRAGMENT_TYPE || type4 === REACT_PROFILER_TYPE || enableDebugTracing || type4 === REACT_STRICT_MODE_TYPE || type4 === REACT_SUSPENSE_TYPE || type4 === REACT_SUSPENSE_LIST_TYPE || enableLegacyHidden || type4 === REACT_OFFSCREEN_TYPE || enableScopeAPI || enableCacheElement || enableTransitionTracing) {
            return true;
          }
          if (typeof type4 === "object" && type4 !== null) {
            if (type4.$$typeof === REACT_LAZY_TYPE || type4.$$typeof === REACT_MEMO_TYPE || type4.$$typeof === REACT_PROVIDER_TYPE || type4.$$typeof === REACT_CONTEXT_TYPE || type4.$$typeof === REACT_FORWARD_REF_TYPE || // This needs to include all possible module reference object
            // types supported by any Flight configuration anywhere since
            // we don't know which Flight build this will end up being used
            // with.
            type4.$$typeof === REACT_MODULE_REFERENCE || type4.getModuleId !== void 0) {
              return true;
            }
          }
          return false;
        }
        function typeOf(object4) {
          if (typeof object4 === "object" && object4 !== null) {
            var $$typeof = object4.$$typeof;
            switch ($$typeof) {
              case REACT_ELEMENT_TYPE:
                var type4 = object4.type;
                switch (type4) {
                  case REACT_FRAGMENT_TYPE:
                  case REACT_PROFILER_TYPE:
                  case REACT_STRICT_MODE_TYPE:
                  case REACT_SUSPENSE_TYPE:
                  case REACT_SUSPENSE_LIST_TYPE:
                    return type4;
                  default:
                    var $$typeofType = type4 && type4.$$typeof;
                    switch ($$typeofType) {
                      case REACT_SERVER_CONTEXT_TYPE:
                      case REACT_CONTEXT_TYPE:
                      case REACT_FORWARD_REF_TYPE:
                      case REACT_LAZY_TYPE:
                      case REACT_MEMO_TYPE:
                      case REACT_PROVIDER_TYPE:
                        return $$typeofType;
                      default:
                        return $$typeof;
                    }
                }
              case REACT_PORTAL_TYPE:
                return $$typeof;
            }
          }
          return void 0;
        }
        var ContextConsumer = REACT_CONTEXT_TYPE;
        var ContextProvider = REACT_PROVIDER_TYPE;
        var Element2 = REACT_ELEMENT_TYPE;
        var ForwardRef = REACT_FORWARD_REF_TYPE;
        var Fragment17 = REACT_FRAGMENT_TYPE;
        var Lazy = REACT_LAZY_TYPE;
        var Memo = REACT_MEMO_TYPE;
        var Portal2 = REACT_PORTAL_TYPE;
        var Profiler = REACT_PROFILER_TYPE;
        var StrictMode = REACT_STRICT_MODE_TYPE;
        var Suspense = REACT_SUSPENSE_TYPE;
        var SuspenseList = REACT_SUSPENSE_LIST_TYPE;
        var hasWarnedAboutDeprecatedIsAsyncMode = false;
        var hasWarnedAboutDeprecatedIsConcurrentMode = false;
        function isAsyncMode(object4) {
          {
            if (!hasWarnedAboutDeprecatedIsAsyncMode) {
              hasWarnedAboutDeprecatedIsAsyncMode = true;
              console["warn"]("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isConcurrentMode(object4) {
          {
            if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
              hasWarnedAboutDeprecatedIsConcurrentMode = true;
              console["warn"]("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.");
            }
          }
          return false;
        }
        function isContextConsumer(object4) {
          return typeOf(object4) === REACT_CONTEXT_TYPE;
        }
        function isContextProvider(object4) {
          return typeOf(object4) === REACT_PROVIDER_TYPE;
        }
        function isElement(object4) {
          return typeof object4 === "object" && object4 !== null && object4.$$typeof === REACT_ELEMENT_TYPE;
        }
        function isForwardRef(object4) {
          return typeOf(object4) === REACT_FORWARD_REF_TYPE;
        }
        function isFragment4(object4) {
          return typeOf(object4) === REACT_FRAGMENT_TYPE;
        }
        function isLazy(object4) {
          return typeOf(object4) === REACT_LAZY_TYPE;
        }
        function isMemo2(object4) {
          return typeOf(object4) === REACT_MEMO_TYPE;
        }
        function isPortal(object4) {
          return typeOf(object4) === REACT_PORTAL_TYPE;
        }
        function isProfiler(object4) {
          return typeOf(object4) === REACT_PROFILER_TYPE;
        }
        function isStrictMode(object4) {
          return typeOf(object4) === REACT_STRICT_MODE_TYPE;
        }
        function isSuspense(object4) {
          return typeOf(object4) === REACT_SUSPENSE_TYPE;
        }
        function isSuspenseList(object4) {
          return typeOf(object4) === REACT_SUSPENSE_LIST_TYPE;
        }
        exports.ContextConsumer = ContextConsumer;
        exports.ContextProvider = ContextProvider;
        exports.Element = Element2;
        exports.ForwardRef = ForwardRef;
        exports.Fragment = Fragment17;
        exports.Lazy = Lazy;
        exports.Memo = Memo;
        exports.Portal = Portal2;
        exports.Profiler = Profiler;
        exports.StrictMode = StrictMode;
        exports.Suspense = Suspense;
        exports.SuspenseList = SuspenseList;
        exports.isAsyncMode = isAsyncMode;
        exports.isConcurrentMode = isConcurrentMode;
        exports.isContextConsumer = isContextConsumer;
        exports.isContextProvider = isContextProvider;
        exports.isElement = isElement;
        exports.isForwardRef = isForwardRef;
        exports.isFragment = isFragment4;
        exports.isLazy = isLazy;
        exports.isMemo = isMemo2;
        exports.isPortal = isPortal;
        exports.isProfiler = isProfiler;
        exports.isStrictMode = isStrictMode;
        exports.isSuspense = isSuspense;
        exports.isSuspenseList = isSuspenseList;
        exports.isValidElementType = isValidElementType;
        exports.typeOf = typeOf;
      })();
    }
  }
});

// ../../node_modules/rc-util/node_modules/react-is/index.js
var require_react_is = __commonJS({
  "../../node_modules/rc-util/node_modules/react-is/index.js"(exports, module2) {
    "use strict";
    if (process.env.NODE_ENV === "production") {
      module2.exports = require_react_is_production_min();
    } else {
      module2.exports = require_react_is_development();
    }
  }
});

// ../../node_modules/toggle-selection/index.js
var require_toggle_selection = __commonJS({
  "../../node_modules/toggle-selection/index.js"(exports, module2) {
    "use strict";
    module2.exports = function() {
      var selection = document.getSelection();
      if (!selection.rangeCount) {
        return function() {
        };
      }
      var active = document.activeElement;
      var ranges = [];
      for (var i = 0; i < selection.rangeCount; i++) {
        ranges.push(selection.getRangeAt(i));
      }
      switch (active.tagName.toUpperCase()) {
        case "INPUT":
        case "TEXTAREA":
          active.blur();
          break;
        default:
          active = null;
          break;
      }
      selection.removeAllRanges();
      return function() {
        selection.type === "Caret" && selection.removeAllRanges();
        if (!selection.rangeCount) {
          ranges.forEach(function(range4) {
            selection.addRange(range4);
          });
        }
        active && active.focus();
      };
    };
  }
});

// ../../node_modules/copy-to-clipboard/index.js
var require_copy_to_clipboard = __commonJS({
  "../../node_modules/copy-to-clipboard/index.js"(exports, module2) {
    "use strict";
    var deselectCurrent = require_toggle_selection();
    var clipboardToIE11Formatting = {
      "text/plain": "Text",
      "text/html": "Url",
      "default": "Text"
    };
    var defaultMessage = "Copy to clipboard: #{key}, Enter";
    function format2(message2) {
      var copyKey = (/mac os x/i.test(navigator.userAgent) ? "\u2318" : "Ctrl") + "+C";
      return message2.replace(/#{\s*key\s*}/g, copyKey);
    }
    function copy4(text, options) {
      var debug, message2, reselectPrevious, range4, selection, mark, success = false;
      if (!options) {
        options = {};
      }
      debug = options.debug || false;
      try {
        reselectPrevious = deselectCurrent();
        range4 = document.createRange();
        selection = document.getSelection();
        mark = document.createElement("span");
        mark.textContent = text;
        mark.ariaHidden = "true";
        mark.style.all = "unset";
        mark.style.position = "fixed";
        mark.style.top = 0;
        mark.style.clip = "rect(0, 0, 0, 0)";
        mark.style.whiteSpace = "pre";
        mark.style.webkitUserSelect = "text";
        mark.style.MozUserSelect = "text";
        mark.style.msUserSelect = "text";
        mark.style.userSelect = "text";
        mark.addEventListener("copy", function(e) {
          e.stopPropagation();
          if (options.format) {
            e.preventDefault();
            if (typeof e.clipboardData === "undefined") {
              debug && console.warn("unable to use e.clipboardData");
              debug && console.warn("trying IE specific stuff");
              window.clipboardData.clearData();
              var format3 = clipboardToIE11Formatting[options.format] || clipboardToIE11Formatting["default"];
              window.clipboardData.setData(format3, text);
            } else {
              e.clipboardData.clearData();
              e.clipboardData.setData(options.format, text);
            }
          }
          if (options.onCopy) {
            e.preventDefault();
            options.onCopy(e.clipboardData);
          }
        });
        document.body.appendChild(mark);
        range4.selectNodeContents(mark);
        selection.addRange(range4);
        var successful = document.execCommand("copy");
        if (!successful) {
          throw new Error("copy command was unsuccessful");
        }
        success = true;
      } catch (err) {
        debug && console.error("unable to copy using execCommand: ", err);
        debug && console.warn("trying IE specific stuff");
        try {
          window.clipboardData.setData(options.format || "text", text);
          options.onCopy && options.onCopy(window.clipboardData);
          success = true;
        } catch (err2) {
          debug && console.error("unable to copy using clipboardData: ", err2);
          debug && console.error("falling back to prompt");
          message2 = format2("message" in options ? options.message : defaultMessage);
          window.prompt(message2, text);
        }
      } finally {
        if (selection) {
          if (typeof selection.removeRange == "function") {
            selection.removeRange(range4);
          } else {
            selection.removeAllRanges();
          }
        }
        if (mark) {
          document.body.removeChild(mark);
        }
        reselectPrevious();
      }
      return success;
    }
    module2.exports = copy4;
  }
});

// ../../node_modules/@ckeditor/ckeditor5-build-classic/build/ckeditor.js
var require_ckeditor = __commonJS({
  "../../node_modules/@ckeditor/ckeditor5-build-classic/build/ckeditor.js"(exports, module2) {
    "use strict";
    !function(t) {
      const e = t.en = t.en || {};
      e.dictionary = Object.assign(e.dictionary || {}, { "%0 of %1": "%0 of %1", Accept: "Accept", "Align cell text to the bottom": "Align cell text to the bottom", "Align cell text to the center": "Align cell text to the center", "Align cell text to the left": "Align cell text to the left", "Align cell text to the middle": "Align cell text to the middle", "Align cell text to the right": "Align cell text to the right", "Align cell text to the top": "Align cell text to the top", "Align table to the left": "Align table to the left", "Align table to the right": "Align table to the right", Alignment: "Alignment", Aquamarine: "Aquamarine", Background: "Background", Black: "Black", "Block quote": "Block quote", Blue: "Blue", Bold: "Bold", Border: "Border", "Break text": "Break text", "Bulleted List": "Bulleted List", "Bulleted list styles toolbar": "Bulleted list styles toolbar", Cancel: "Cancel", "Cannot access default workspace.": "Cannot access default workspace.", "Cannot determine a category for the uploaded file.": "Cannot determine a category for the uploaded file.", "Cannot upload file:": "Cannot upload file:", "Caption for image: %0": "Caption for image: %0", "Caption for the image": "Caption for the image", "Cell properties": "Cell properties", "Center table": "Center table", "Centered image": "Centered image", "Change image text alternative": "Change image text alternative", "Choose heading": "Choose heading", Circle: "Circle", Clear: "Clear", "Click to edit block": "Click to edit block", Code: "Code", Color: "Color", "Color picker": "Color picker", Column: "Column", "Could not insert image at the current position.": "Could not insert image at the current position.", "Could not obtain resized image URL.": "Could not obtain resized image URL.", Dashed: "Dashed", Decimal: "Decimal", "Decimal with leading zero": "Decimal with leading zero", "Decrease indent": "Decrease indent", "Delete column": "Delete column", "Delete row": "Delete row", "Dim grey": "Dim grey", Dimensions: "Dimensions", Disc: "Disc", Dotted: "Dotted", Double: "Double", Downloadable: "Downloadable", "Drag to move": "Drag to move", "Dropdown toolbar": "Dropdown toolbar", "Edit block": "Edit block", "Edit image": "Edit image", "Edit link": "Edit link", "Editor block content toolbar": "Editor block content toolbar", "Editor contextual toolbar": "Editor contextual toolbar", "Editor editing area: %0": "Editor editing area: %0", "Editor toolbar": "Editor toolbar", "Enter image caption": "Enter image caption", "Enter table caption": "Enter table caption", "Failed to determine category of edited image.": "Failed to determine category of edited image.", "Full size image": "Full size image", Green: "Green", Grey: "Grey", Groove: "Groove", "Header column": "Header column", "Header row": "Header row", Heading: "Heading", "Heading 1": "Heading 1", "Heading 2": "Heading 2", "Heading 3": "Heading 3", "Heading 4": "Heading 4", "Heading 5": "Heading 5", "Heading 6": "Heading 6", Height: "Height", HEX: "HEX", "Horizontal text alignment toolbar": "Horizontal text alignment toolbar", "Image resize list": "Image resize list", "Image toolbar": "Image toolbar", "image widget": "image widget", "In line": "In line", "Increase indent": "Increase indent", Insert: "Insert", "Insert column left": "Insert column left", "Insert column right": "Insert column right", "Insert image": "Insert image", "Insert image or file": "Insert image or file", "Insert image via URL": "Insert image via URL", "Insert image with file manager": "Insert image with file manager", "Insert media": "Insert media", "Insert paragraph after block": "Insert paragraph after block", "Insert paragraph before block": "Insert paragraph before block", "Insert row above": "Insert row above", "Insert row below": "Insert row below", "Insert table": "Insert table", "Insert with file manager": "Insert with file manager", "Inserting image failed": "Inserting image failed", Inset: "Inset", Italic: "Italic", "Justify cell text": "Justify cell text", "Left aligned image": "Left aligned image", "Light blue": "Light blue", "Light green": "Light green", "Light grey": "Light grey", Link: "Link", "Link image": "Link image", "Link URL": "Link URL", "List properties": "List properties", "Lower-latin": "Lower-latin", "Lower\u2013roman": "Lower\u2013roman", "Media toolbar": "Media toolbar", "Media URL": "Media URL", "media widget": "media widget", "Merge cell down": "Merge cell down", "Merge cell left": "Merge cell left", "Merge cell right": "Merge cell right", "Merge cell up": "Merge cell up", "Merge cells": "Merge cells", Next: "Next", "No results found": "No results found", "No searchable items": "No searchable items", None: "None", "Numbered List": "Numbered List", "Numbered list styles toolbar": "Numbered list styles toolbar", "Open file manager": "Open file manager", "Open in a new tab": "Open in a new tab", "Open link in new tab": "Open link in new tab", "Open media in new tab": "Open media in new tab", Orange: "Orange", Original: "Original", Outset: "Outset", Padding: "Padding", Paragraph: "Paragraph", "Paste the media URL in the input.": "Paste the media URL in the input.", "Press Enter to type after or press Shift + Enter to type before the widget": "Press Enter to type after or press Shift + Enter to type before the widget", Previous: "Previous", "Processing the edited image.": "Processing the edited image.", Purple: "Purple", Red: "Red", Redo: "Redo", "Remove color": "Remove color", "Replace from computer": "Replace from computer", "Replace image": "Replace image", "Replace image from computer": "Replace image from computer", "Replace image with file manager": "Replace image with file manager", "Replace with file manager": "Replace with file manager", "Resize image": "Resize image", "Resize image to %0": "Resize image to %0", "Resize image to the original size": "Resize image to the original size", "Restore default": "Restore default", "Reversed order": "Reversed order", "Rich Text Editor": "Rich Text Editor", Ridge: "Ridge", "Right aligned image": "Right aligned image", Row: "Row", Save: "Save", "Select all": "Select all", "Select column": "Select column", "Select row": "Select row", "Selecting resized image failed": "Selecting resized image failed", "Server failed to process the image.": "Server failed to process the image.", "Show more items": "Show more items", "Side image": "Side image", Solid: "Solid", "Split cell horizontally": "Split cell horizontally", "Split cell vertically": "Split cell vertically", Square: "Square", "Start at": "Start at", "Start index must be greater than 0.": "Start index must be greater than 0.", Strikethrough: "Strikethrough", Style: "Style", Subscript: "Subscript", Superscript: "Superscript", "Table alignment toolbar": "Table alignment toolbar", "Table cell text alignment": "Table cell text alignment", "Table properties": "Table properties", "Table toolbar": "Table toolbar", "Text alternative": "Text alternative", 'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".': 'The color is invalid. Try "#FF0000" or "rgb(255,0,0)" or "red".', "The URL must not be empty.": "The URL must not be empty.", 'The value is invalid. Try "10px" or "2em" or simply "2".': 'The value is invalid. Try "10px" or "2em" or simply "2".', "This link has no URL": "This link has no URL", "This media URL is not supported.": "This media URL is not supported.", "Tip: Paste the URL into the content to embed faster.": "Tip: Paste the URL into the content to embed faster.", "To-do List": "To-do List", "Toggle caption off": "Toggle caption off", "Toggle caption on": "Toggle caption on", "Toggle the circle list style": "Toggle the circle list style", "Toggle the decimal list style": "Toggle the decimal list style", "Toggle the decimal with leading zero list style": "Toggle the decimal with leading zero list style", "Toggle the disc list style": "Toggle the disc list style", "Toggle the lower\u2013latin list style": "Toggle the lower\u2013latin list style", "Toggle the lower\u2013roman list style": "Toggle the lower\u2013roman list style", "Toggle the square list style": "Toggle the square list style", "Toggle the upper\u2013latin list style": "Toggle the upper\u2013latin list style", "Toggle the upper\u2013roman list style": "Toggle the upper\u2013roman list style", Turquoise: "Turquoise", "Type or paste your content here.": "Type or paste your content here.", "Type your title": "Type your title", Underline: "Underline", Undo: "Undo", Unlink: "Unlink", Update: "Update", "Update image URL": "Update image URL", "Upload failed": "Upload failed", "Upload from computer": "Upload from computer", "Upload image from computer": "Upload image from computer", "Upload in progress": "Upload in progress", "Upper-latin": "Upper-latin", "Upper-roman": "Upper-roman", "Vertical text alignment toolbar": "Vertical text alignment toolbar", White: "White", "Widget toolbar": "Widget toolbar", Width: "Width", "Wrap text": "Wrap text", Yellow: "Yellow" });
    }(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})), /*!
     * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
     * For licensing, see LICENSE.md.
     */
    function(t, e) {
      "object" == typeof exports && "object" == typeof module2 ? module2.exports = e() : "function" == typeof define && define.amd ? define([], e) : "object" == typeof exports ? exports.ClassicEditor = e() : t.ClassicEditor = e();
    }(self, () => (() => {
      var t = { 4959: (t2, e2, n2) => {
        const o2 = n2(1103), i = {};
        for (const t3 of Object.keys(o2))
          i[o2[t3]] = t3;
        const r = { rgb: { channels: 3, labels: "rgb" }, hsl: { channels: 3, labels: "hsl" }, hsv: { channels: 3, labels: "hsv" }, hwb: { channels: 3, labels: "hwb" }, cmyk: { channels: 4, labels: "cmyk" }, xyz: { channels: 3, labels: "xyz" }, lab: { channels: 3, labels: "lab" }, lch: { channels: 3, labels: "lch" }, hex: { channels: 1, labels: ["hex"] }, keyword: { channels: 1, labels: ["keyword"] }, ansi16: { channels: 1, labels: ["ansi16"] }, ansi256: { channels: 1, labels: ["ansi256"] }, hcg: { channels: 3, labels: ["h", "c", "g"] }, apple: { channels: 3, labels: ["r16", "g16", "b16"] }, gray: { channels: 1, labels: ["gray"] } };
        t2.exports = r;
        for (const t3 of Object.keys(r)) {
          if (!("channels" in r[t3]))
            throw new Error("missing channels property: " + t3);
          if (!("labels" in r[t3]))
            throw new Error("missing channel labels property: " + t3);
          if (r[t3].labels.length !== r[t3].channels)
            throw new Error("channel and label counts mismatch: " + t3);
          const { channels: e3, labels: n3 } = r[t3];
          delete r[t3].channels, delete r[t3].labels, Object.defineProperty(r[t3], "channels", { value: e3 }), Object.defineProperty(r[t3], "labels", { value: n3 });
        }
        r.rgb.hsl = function(t3) {
          const e3 = t3[0] / 255, n3 = t3[1] / 255, o3 = t3[2] / 255, i2 = Math.min(e3, n3, o3), r2 = Math.max(e3, n3, o3), s2 = r2 - i2;
          let a, c;
          r2 === i2 ? a = 0 : e3 === r2 ? a = (n3 - o3) / s2 : n3 === r2 ? a = 2 + (o3 - e3) / s2 : o3 === r2 && (a = 4 + (e3 - n3) / s2), a = Math.min(60 * a, 360), a < 0 && (a += 360);
          const l = (i2 + r2) / 2;
          return c = r2 === i2 ? 0 : l <= 0.5 ? s2 / (r2 + i2) : s2 / (2 - r2 - i2), [a, 100 * c, 100 * l];
        }, r.rgb.hsv = function(t3) {
          let e3, n3, o3, i2, r2;
          const s2 = t3[0] / 255, a = t3[1] / 255, c = t3[2] / 255, l = Math.max(s2, a, c), d = l - Math.min(s2, a, c), h = function(t4) {
            return (l - t4) / 6 / d + 0.5;
          };
          return 0 === d ? (i2 = 0, r2 = 0) : (r2 = d / l, e3 = h(s2), n3 = h(a), o3 = h(c), s2 === l ? i2 = o3 - n3 : a === l ? i2 = 1 / 3 + e3 - o3 : c === l && (i2 = 2 / 3 + n3 - e3), i2 < 0 ? i2 += 1 : i2 > 1 && (i2 -= 1)), [360 * i2, 100 * r2, 100 * l];
        }, r.rgb.hwb = function(t3) {
          const e3 = t3[0], n3 = t3[1];
          let o3 = t3[2];
          const i2 = r.rgb.hsl(t3)[0], s2 = 1 / 255 * Math.min(e3, Math.min(n3, o3));
          return o3 = 1 - 1 / 255 * Math.max(e3, Math.max(n3, o3)), [i2, 100 * s2, 100 * o3];
        }, r.rgb.cmyk = function(t3) {
          const e3 = t3[0] / 255, n3 = t3[1] / 255, o3 = t3[2] / 255, i2 = Math.min(1 - e3, 1 - n3, 1 - o3);
          return [100 * ((1 - e3 - i2) / (1 - i2) || 0), 100 * ((1 - n3 - i2) / (1 - i2) || 0), 100 * ((1 - o3 - i2) / (1 - i2) || 0), 100 * i2];
        }, r.rgb.keyword = function(t3) {
          const e3 = i[t3];
          if (e3)
            return e3;
          let n3, r2 = 1 / 0;
          for (const e4 of Object.keys(o2)) {
            const i2 = o2[e4], c = (a = i2, __pow((s2 = t3)[0] - a[0], 2) + __pow(s2[1] - a[1], 2) + __pow(s2[2] - a[2], 2));
            c < r2 && (r2 = c, n3 = e4);
          }
          var s2, a;
          return n3;
        }, r.keyword.rgb = function(t3) {
          return o2[t3];
        }, r.rgb.xyz = function(t3) {
          let e3 = t3[0] / 255, n3 = t3[1] / 255, o3 = t3[2] / 255;
          e3 = e3 > 0.04045 ? __pow((e3 + 0.055) / 1.055, 2.4) : e3 / 12.92, n3 = n3 > 0.04045 ? __pow((n3 + 0.055) / 1.055, 2.4) : n3 / 12.92, o3 = o3 > 0.04045 ? __pow((o3 + 0.055) / 1.055, 2.4) : o3 / 12.92;
          return [100 * (0.4124 * e3 + 0.3576 * n3 + 0.1805 * o3), 100 * (0.2126 * e3 + 0.7152 * n3 + 0.0722 * o3), 100 * (0.0193 * e3 + 0.1192 * n3 + 0.9505 * o3)];
        }, r.rgb.lab = function(t3) {
          const e3 = r.rgb.xyz(t3);
          let n3 = e3[0], o3 = e3[1], i2 = e3[2];
          n3 /= 95.047, o3 /= 100, i2 /= 108.883, n3 = n3 > 8856e-6 ? __pow(n3, 1 / 3) : 7.787 * n3 + 16 / 116, o3 = o3 > 8856e-6 ? __pow(o3, 1 / 3) : 7.787 * o3 + 16 / 116, i2 = i2 > 8856e-6 ? __pow(i2, 1 / 3) : 7.787 * i2 + 16 / 116;
          return [116 * o3 - 16, 500 * (n3 - o3), 200 * (o3 - i2)];
        }, r.hsl.rgb = function(t3) {
          const e3 = t3[0] / 360, n3 = t3[1] / 100, o3 = t3[2] / 100;
          let i2, r2, s2;
          if (0 === n3)
            return s2 = 255 * o3, [s2, s2, s2];
          i2 = o3 < 0.5 ? o3 * (1 + n3) : o3 + n3 - o3 * n3;
          const a = 2 * o3 - i2, c = [0, 0, 0];
          for (let t4 = 0; t4 < 3; t4++)
            r2 = e3 + 1 / 3 * -(t4 - 1), r2 < 0 && r2++, r2 > 1 && r2--, s2 = 6 * r2 < 1 ? a + 6 * (i2 - a) * r2 : 2 * r2 < 1 ? i2 : 3 * r2 < 2 ? a + (i2 - a) * (2 / 3 - r2) * 6 : a, c[t4] = 255 * s2;
          return c;
        }, r.hsl.hsv = function(t3) {
          const e3 = t3[0];
          let n3 = t3[1] / 100, o3 = t3[2] / 100, i2 = n3;
          const r2 = Math.max(o3, 0.01);
          o3 *= 2, n3 *= o3 <= 1 ? o3 : 2 - o3, i2 *= r2 <= 1 ? r2 : 2 - r2;
          return [e3, 100 * (0 === o3 ? 2 * i2 / (r2 + i2) : 2 * n3 / (o3 + n3)), 100 * ((o3 + n3) / 2)];
        }, r.hsv.rgb = function(t3) {
          const e3 = t3[0] / 60, n3 = t3[1] / 100;
          let o3 = t3[2] / 100;
          const i2 = Math.floor(e3) % 6, r2 = e3 - Math.floor(e3), s2 = 255 * o3 * (1 - n3), a = 255 * o3 * (1 - n3 * r2), c = 255 * o3 * (1 - n3 * (1 - r2));
          switch (o3 *= 255, i2) {
            case 0:
              return [o3, c, s2];
            case 1:
              return [a, o3, s2];
            case 2:
              return [s2, o3, c];
            case 3:
              return [s2, a, o3];
            case 4:
              return [c, s2, o3];
            case 5:
              return [o3, s2, a];
          }
        }, r.hsv.hsl = function(t3) {
          const e3 = t3[0], n3 = t3[1] / 100, o3 = t3[2] / 100, i2 = Math.max(o3, 0.01);
          let r2, s2;
          s2 = (2 - n3) * o3;
          const a = (2 - n3) * i2;
          return r2 = n3 * i2, r2 /= a <= 1 ? a : 2 - a, r2 = r2 || 0, s2 /= 2, [e3, 100 * r2, 100 * s2];
        }, r.hwb.rgb = function(t3) {
          const e3 = t3[0] / 360;
          let n3 = t3[1] / 100, o3 = t3[2] / 100;
          const i2 = n3 + o3;
          let r2;
          i2 > 1 && (n3 /= i2, o3 /= i2);
          const s2 = Math.floor(6 * e3), a = 1 - o3;
          r2 = 6 * e3 - s2, 0 != (1 & s2) && (r2 = 1 - r2);
          const c = n3 + r2 * (a - n3);
          let l, d, h;
          switch (s2) {
            default:
            case 6:
            case 0:
              l = a, d = c, h = n3;
              break;
            case 1:
              l = c, d = a, h = n3;
              break;
            case 2:
              l = n3, d = a, h = c;
              break;
            case 3:
              l = n3, d = c, h = a;
              break;
            case 4:
              l = c, d = n3, h = a;
              break;
            case 5:
              l = a, d = n3, h = c;
          }
          return [255 * l, 255 * d, 255 * h];
        }, r.cmyk.rgb = function(t3) {
          const e3 = t3[0] / 100, n3 = t3[1] / 100, o3 = t3[2] / 100, i2 = t3[3] / 100;
          return [255 * (1 - Math.min(1, e3 * (1 - i2) + i2)), 255 * (1 - Math.min(1, n3 * (1 - i2) + i2)), 255 * (1 - Math.min(1, o3 * (1 - i2) + i2))];
        }, r.xyz.rgb = function(t3) {
          const e3 = t3[0] / 100, n3 = t3[1] / 100, o3 = t3[2] / 100;
          let i2, r2, s2;
          return i2 = 3.2406 * e3 + -1.5372 * n3 + -0.4986 * o3, r2 = -0.9689 * e3 + 1.8758 * n3 + 0.0415 * o3, s2 = 0.0557 * e3 + -0.204 * n3 + 1.057 * o3, i2 = i2 > 31308e-7 ? 1.055 * __pow(i2, 1 / 2.4) - 0.055 : 12.92 * i2, r2 = r2 > 31308e-7 ? 1.055 * __pow(r2, 1 / 2.4) - 0.055 : 12.92 * r2, s2 = s2 > 31308e-7 ? 1.055 * __pow(s2, 1 / 2.4) - 0.055 : 12.92 * s2, i2 = Math.min(Math.max(0, i2), 1), r2 = Math.min(Math.max(0, r2), 1), s2 = Math.min(Math.max(0, s2), 1), [255 * i2, 255 * r2, 255 * s2];
        }, r.xyz.lab = function(t3) {
          let e3 = t3[0], n3 = t3[1], o3 = t3[2];
          e3 /= 95.047, n3 /= 100, o3 /= 108.883, e3 = e3 > 8856e-6 ? __pow(e3, 1 / 3) : 7.787 * e3 + 16 / 116, n3 = n3 > 8856e-6 ? __pow(n3, 1 / 3) : 7.787 * n3 + 16 / 116, o3 = o3 > 8856e-6 ? __pow(o3, 1 / 3) : 7.787 * o3 + 16 / 116;
          return [116 * n3 - 16, 500 * (e3 - n3), 200 * (n3 - o3)];
        }, r.lab.xyz = function(t3) {
          let e3, n3, o3;
          n3 = (t3[0] + 16) / 116, e3 = t3[1] / 500 + n3, o3 = n3 - t3[2] / 200;
          const i2 = __pow(n3, 3), r2 = __pow(e3, 3), s2 = __pow(o3, 3);
          return n3 = i2 > 8856e-6 ? i2 : (n3 - 16 / 116) / 7.787, e3 = r2 > 8856e-6 ? r2 : (e3 - 16 / 116) / 7.787, o3 = s2 > 8856e-6 ? s2 : (o3 - 16 / 116) / 7.787, e3 *= 95.047, n3 *= 100, o3 *= 108.883, [e3, n3, o3];
        }, r.lab.lch = function(t3) {
          const e3 = t3[0], n3 = t3[1], o3 = t3[2];
          let i2;
          i2 = 360 * Math.atan2(o3, n3) / 2 / Math.PI, i2 < 0 && (i2 += 360);
          return [e3, Math.sqrt(n3 * n3 + o3 * o3), i2];
        }, r.lch.lab = function(t3) {
          const e3 = t3[0], n3 = t3[1], o3 = t3[2] / 360 * 2 * Math.PI;
          return [e3, n3 * Math.cos(o3), n3 * Math.sin(o3)];
        }, r.rgb.ansi16 = function(t3, e3 = null) {
          const [n3, o3, i2] = t3;
          let s2 = null === e3 ? r.rgb.hsv(t3)[2] : e3;
          if (s2 = Math.round(s2 / 50), 0 === s2)
            return 30;
          let a = 30 + (Math.round(i2 / 255) << 2 | Math.round(o3 / 255) << 1 | Math.round(n3 / 255));
          return 2 === s2 && (a += 60), a;
        }, r.hsv.ansi16 = function(t3) {
          return r.rgb.ansi16(r.hsv.rgb(t3), t3[2]);
        }, r.rgb.ansi256 = function(t3) {
          const e3 = t3[0], n3 = t3[1], o3 = t3[2];
          if (e3 === n3 && n3 === o3)
            return e3 < 8 ? 16 : e3 > 248 ? 231 : Math.round((e3 - 8) / 247 * 24) + 232;
          return 16 + 36 * Math.round(e3 / 255 * 5) + 6 * Math.round(n3 / 255 * 5) + Math.round(o3 / 255 * 5);
        }, r.ansi16.rgb = function(t3) {
          let e3 = t3 % 10;
          if (0 === e3 || 7 === e3)
            return t3 > 50 && (e3 += 3.5), e3 = e3 / 10.5 * 255, [e3, e3, e3];
          const n3 = 0.5 * (1 + ~~(t3 > 50));
          return [(1 & e3) * n3 * 255, (e3 >> 1 & 1) * n3 * 255, (e3 >> 2 & 1) * n3 * 255];
        }, r.ansi256.rgb = function(t3) {
          if (t3 >= 232) {
            const e4 = 10 * (t3 - 232) + 8;
            return [e4, e4, e4];
          }
          let e3;
          t3 -= 16;
          return [Math.floor(t3 / 36) / 5 * 255, Math.floor((e3 = t3 % 36) / 6) / 5 * 255, e3 % 6 / 5 * 255];
        }, r.rgb.hex = function(t3) {
          const e3 = (((255 & Math.round(t3[0])) << 16) + ((255 & Math.round(t3[1])) << 8) + (255 & Math.round(t3[2]))).toString(16).toUpperCase();
          return "000000".substring(e3.length) + e3;
        }, r.hex.rgb = function(t3) {
          const e3 = t3.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
          if (!e3)
            return [0, 0, 0];
          let n3 = e3[0];
          3 === e3[0].length && (n3 = n3.split("").map((t4) => t4 + t4).join(""));
          const o3 = parseInt(n3, 16);
          return [o3 >> 16 & 255, o3 >> 8 & 255, 255 & o3];
        }, r.rgb.hcg = function(t3) {
          const e3 = t3[0] / 255, n3 = t3[1] / 255, o3 = t3[2] / 255, i2 = Math.max(Math.max(e3, n3), o3), r2 = Math.min(Math.min(e3, n3), o3), s2 = i2 - r2;
          let a, c;
          return a = s2 < 1 ? r2 / (1 - s2) : 0, c = s2 <= 0 ? 0 : i2 === e3 ? (n3 - o3) / s2 % 6 : i2 === n3 ? 2 + (o3 - e3) / s2 : 4 + (e3 - n3) / s2, c /= 6, c %= 1, [360 * c, 100 * s2, 100 * a];
        }, r.hsl.hcg = function(t3) {
          const e3 = t3[1] / 100, n3 = t3[2] / 100, o3 = n3 < 0.5 ? 2 * e3 * n3 : 2 * e3 * (1 - n3);
          let i2 = 0;
          return o3 < 1 && (i2 = (n3 - 0.5 * o3) / (1 - o3)), [t3[0], 100 * o3, 100 * i2];
        }, r.hsv.hcg = function(t3) {
          const e3 = t3[1] / 100, n3 = t3[2] / 100, o3 = e3 * n3;
          let i2 = 0;
          return o3 < 1 && (i2 = (n3 - o3) / (1 - o3)), [t3[0], 100 * o3, 100 * i2];
        }, r.hcg.rgb = function(t3) {
          const e3 = t3[0] / 360, n3 = t3[1] / 100, o3 = t3[2] / 100;
          if (0 === n3)
            return [255 * o3, 255 * o3, 255 * o3];
          const i2 = [0, 0, 0], r2 = e3 % 1 * 6, s2 = r2 % 1, a = 1 - s2;
          let c = 0;
          switch (Math.floor(r2)) {
            case 0:
              i2[0] = 1, i2[1] = s2, i2[2] = 0;
              break;
            case 1:
              i2[0] = a, i2[1] = 1, i2[2] = 0;
              break;
            case 2:
              i2[0] = 0, i2[1] = 1, i2[2] = s2;
              break;
            case 3:
              i2[0] = 0, i2[1] = a, i2[2] = 1;
              break;
            case 4:
              i2[0] = s2, i2[1] = 0, i2[2] = 1;
              break;
            default:
              i2[0] = 1, i2[1] = 0, i2[2] = a;
          }
          return c = (1 - n3) * o3, [255 * (n3 * i2[0] + c), 255 * (n3 * i2[1] + c), 255 * (n3 * i2[2] + c)];
        }, r.hcg.hsv = function(t3) {
          const e3 = t3[1] / 100, n3 = e3 + t3[2] / 100 * (1 - e3);
          let o3 = 0;
          return n3 > 0 && (o3 = e3 / n3), [t3[0], 100 * o3, 100 * n3];
        }, r.hcg.hsl = function(t3) {
          const e3 = t3[1] / 100, n3 = t3[2] / 100 * (1 - e3) + 0.5 * e3;
          let o3 = 0;
          return n3 > 0 && n3 < 0.5 ? o3 = e3 / (2 * n3) : n3 >= 0.5 && n3 < 1 && (o3 = e3 / (2 * (1 - n3))), [t3[0], 100 * o3, 100 * n3];
        }, r.hcg.hwb = function(t3) {
          const e3 = t3[1] / 100, n3 = e3 + t3[2] / 100 * (1 - e3);
          return [t3[0], 100 * (n3 - e3), 100 * (1 - n3)];
        }, r.hwb.hcg = function(t3) {
          const e3 = t3[1] / 100, n3 = 1 - t3[2] / 100, o3 = n3 - e3;
          let i2 = 0;
          return o3 < 1 && (i2 = (n3 - o3) / (1 - o3)), [t3[0], 100 * o3, 100 * i2];
        }, r.apple.rgb = function(t3) {
          return [t3[0] / 65535 * 255, t3[1] / 65535 * 255, t3[2] / 65535 * 255];
        }, r.rgb.apple = function(t3) {
          return [t3[0] / 255 * 65535, t3[1] / 255 * 65535, t3[2] / 255 * 65535];
        }, r.gray.rgb = function(t3) {
          return [t3[0] / 100 * 255, t3[0] / 100 * 255, t3[0] / 100 * 255];
        }, r.gray.hsl = function(t3) {
          return [0, 0, t3[0]];
        }, r.gray.hsv = r.gray.hsl, r.gray.hwb = function(t3) {
          return [0, 100, t3[0]];
        }, r.gray.cmyk = function(t3) {
          return [0, 0, 0, t3[0]];
        }, r.gray.lab = function(t3) {
          return [t3[0], 0, 0];
        }, r.gray.hex = function(t3) {
          const e3 = 255 & Math.round(t3[0] / 100 * 255), n3 = ((e3 << 16) + (e3 << 8) + e3).toString(16).toUpperCase();
          return "000000".substring(n3.length) + n3;
        }, r.rgb.gray = function(t3) {
          return [(t3[0] + t3[1] + t3[2]) / 3 / 255 * 100];
        };
      }, 841: (t2, e2, n2) => {
        const o2 = n2(4959), i = n2(9325), r = {};
        Object.keys(o2).forEach((t3) => {
          r[t3] = {}, Object.defineProperty(r[t3], "channels", { value: o2[t3].channels }), Object.defineProperty(r[t3], "labels", { value: o2[t3].labels });
          const e3 = i(t3);
          Object.keys(e3).forEach((n3) => {
            const o3 = e3[n3];
            r[t3][n3] = function(t4) {
              const e4 = function(...e5) {
                const n4 = e5[0];
                if (null == n4)
                  return n4;
                n4.length > 1 && (e5 = n4);
                const o4 = t4(e5);
                if ("object" == typeof o4)
                  for (let t5 = o4.length, e6 = 0; e6 < t5; e6++)
                    o4[e6] = Math.round(o4[e6]);
                return o4;
              };
              return "conversion" in t4 && (e4.conversion = t4.conversion), e4;
            }(o3), r[t3][n3].raw = function(t4) {
              const e4 = function(...e5) {
                const n4 = e5[0];
                return null == n4 ? n4 : (n4.length > 1 && (e5 = n4), t4(e5));
              };
              return "conversion" in t4 && (e4.conversion = t4.conversion), e4;
            }(o3);
          });
        }), t2.exports = r;
      }, 9325: (t2, e2, n2) => {
        const o2 = n2(4959);
        function i(t3) {
          const e3 = function() {
            const t4 = {}, e4 = Object.keys(o2);
            for (let n4 = e4.length, o3 = 0; o3 < n4; o3++)
              t4[e4[o3]] = { distance: -1, parent: null };
            return t4;
          }(), n3 = [t3];
          for (e3[t3].distance = 0; n3.length; ) {
            const t4 = n3.pop(), i2 = Object.keys(o2[t4]);
            for (let o3 = i2.length, r2 = 0; r2 < o3; r2++) {
              const o4 = i2[r2], s3 = e3[o4];
              -1 === s3.distance && (s3.distance = e3[t4].distance + 1, s3.parent = t4, n3.unshift(o4));
            }
          }
          return e3;
        }
        function r(t3, e3) {
          return function(n3) {
            return e3(t3(n3));
          };
        }
        function s2(t3, e3) {
          const n3 = [e3[t3].parent, t3];
          let i2 = o2[e3[t3].parent][t3], s3 = e3[t3].parent;
          for (; e3[s3].parent; )
            n3.unshift(e3[s3].parent), i2 = r(o2[e3[s3].parent][s3], i2), s3 = e3[s3].parent;
          return i2.conversion = n3, i2;
        }
        t2.exports = function(t3) {
          const e3 = i(t3), n3 = {}, o3 = Object.keys(e3);
          for (let t4 = o3.length, i2 = 0; i2 < t4; i2++) {
            const t5 = o3[i2];
            null !== e3[t5].parent && (n3[t5] = s2(t5, e3));
          }
          return n3;
        };
      }, 1103: (t2) => {
        "use strict";
        t2.exports = { aliceblue: [240, 248, 255], antiquewhite: [250, 235, 215], aqua: [0, 255, 255], aquamarine: [127, 255, 212], azure: [240, 255, 255], beige: [245, 245, 220], bisque: [255, 228, 196], black: [0, 0, 0], blanchedalmond: [255, 235, 205], blue: [0, 0, 255], blueviolet: [138, 43, 226], brown: [165, 42, 42], burlywood: [222, 184, 135], cadetblue: [95, 158, 160], chartreuse: [127, 255, 0], chocolate: [210, 105, 30], coral: [255, 127, 80], cornflowerblue: [100, 149, 237], cornsilk: [255, 248, 220], crimson: [220, 20, 60], cyan: [0, 255, 255], darkblue: [0, 0, 139], darkcyan: [0, 139, 139], darkgoldenrod: [184, 134, 11], darkgray: [169, 169, 169], darkgreen: [0, 100, 0], darkgrey: [169, 169, 169], darkkhaki: [189, 183, 107], darkmagenta: [139, 0, 139], darkolivegreen: [85, 107, 47], darkorange: [255, 140, 0], darkorchid: [153, 50, 204], darkred: [139, 0, 0], darksalmon: [233, 150, 122], darkseagreen: [143, 188, 143], darkslateblue: [72, 61, 139], darkslategray: [47, 79, 79], darkslategrey: [47, 79, 79], darkturquoise: [0, 206, 209], darkviolet: [148, 0, 211], deeppink: [255, 20, 147], deepskyblue: [0, 191, 255], dimgray: [105, 105, 105], dimgrey: [105, 105, 105], dodgerblue: [30, 144, 255], firebrick: [178, 34, 34], floralwhite: [255, 250, 240], forestgreen: [34, 139, 34], fuchsia: [255, 0, 255], gainsboro: [220, 220, 220], ghostwhite: [248, 248, 255], gold: [255, 215, 0], goldenrod: [218, 165, 32], gray: [128, 128, 128], green: [0, 128, 0], greenyellow: [173, 255, 47], grey: [128, 128, 128], honeydew: [240, 255, 240], hotpink: [255, 105, 180], indianred: [205, 92, 92], indigo: [75, 0, 130], ivory: [255, 255, 240], khaki: [240, 230, 140], lavender: [230, 230, 250], lavenderblush: [255, 240, 245], lawngreen: [124, 252, 0], lemonchiffon: [255, 250, 205], lightblue: [173, 216, 230], lightcoral: [240, 128, 128], lightcyan: [224, 255, 255], lightgoldenrodyellow: [250, 250, 210], lightgray: [211, 211, 211], lightgreen: [144, 238, 144], lightgrey: [211, 211, 211], lightpink: [255, 182, 193], lightsalmon: [255, 160, 122], lightseagreen: [32, 178, 170], lightskyblue: [135, 206, 250], lightslategray: [119, 136, 153], lightslategrey: [119, 136, 153], lightsteelblue: [176, 196, 222], lightyellow: [255, 255, 224], lime: [0, 255, 0], limegreen: [50, 205, 50], linen: [250, 240, 230], magenta: [255, 0, 255], maroon: [128, 0, 0], mediumaquamarine: [102, 205, 170], mediumblue: [0, 0, 205], mediumorchid: [186, 85, 211], mediumpurple: [147, 112, 219], mediumseagreen: [60, 179, 113], mediumslateblue: [123, 104, 238], mediumspringgreen: [0, 250, 154], mediumturquoise: [72, 209, 204], mediumvioletred: [199, 21, 133], midnightblue: [25, 25, 112], mintcream: [245, 255, 250], mistyrose: [255, 228, 225], moccasin: [255, 228, 181], navajowhite: [255, 222, 173], navy: [0, 0, 128], oldlace: [253, 245, 230], olive: [128, 128, 0], olivedrab: [107, 142, 35], orange: [255, 165, 0], orangered: [255, 69, 0], orchid: [218, 112, 214], palegoldenrod: [238, 232, 170], palegreen: [152, 251, 152], paleturquoise: [175, 238, 238], palevioletred: [219, 112, 147], papayawhip: [255, 239, 213], peachpuff: [255, 218, 185], peru: [205, 133, 63], pink: [255, 192, 203], plum: [221, 160, 221], powderblue: [176, 224, 230], purple: [128, 0, 128], rebeccapurple: [102, 51, 153], red: [255, 0, 0], rosybrown: [188, 143, 143], royalblue: [65, 105, 225], saddlebrown: [139, 69, 19], salmon: [250, 128, 114], sandybrown: [244, 164, 96], seagreen: [46, 139, 87], seashell: [255, 245, 238], sienna: [160, 82, 45], silver: [192, 192, 192], skyblue: [135, 206, 235], slateblue: [106, 90, 205], slategray: [112, 128, 144], slategrey: [112, 128, 144], snow: [255, 250, 250], springgreen: [0, 255, 127], steelblue: [70, 130, 180], tan: [210, 180, 140], teal: [0, 128, 128], thistle: [216, 191, 216], tomato: [255, 99, 71], turquoise: [64, 224, 208], violet: [238, 130, 238], wheat: [245, 222, 179], white: [255, 255, 255], whitesmoke: [245, 245, 245], yellow: [255, 255, 0], yellowgreen: [154, 205, 50] };
      }, 8603: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-content code{background-color:hsla(0,0%,78%,.3);border-radius:2px;padding:.15em}.ck.ck-editor__editable .ck-code_selected{background-color:hsla(0,0%,78%,.5)}", "", { version: 3, sources: ["webpack://./../ckeditor5-basic-styles/theme/code.css"], names: [], mappings: "AAKA,iBACC,kCAAuC,CAEvC,iBAAkB,CADlB,aAED,CAEA,0CACC,kCACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content code {\n	background-color: hsla(0, 0%, 78%, 0.3);\n	padding: .15em;\n	border-radius: 2px;\n}\n\n.ck.ck-editor__editable .ck-code_selected  {\n	background-color: hsla(0, 0%, 78%, 0.5);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3062: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-content blockquote{border-left:5px solid #ccc;font-style:italic;margin-left:0;margin-right:0;overflow:hidden;padding-left:1.5em;padding-right:1.5em}.ck-content[dir=rtl] blockquote{border-left:0;border-right:5px solid #ccc}", "", { version: 3, sources: ["webpack://./../ckeditor5-block-quote/theme/blockquote.css"], names: [], mappings: "AAKA,uBAWC,0BAAsC,CADtC,iBAAkB,CAFlB,aAAc,CACd,cAAe,CAPf,eAAgB,CAIhB,kBAAmB,CADnB,mBAOD,CAEA,gCACC,aAAc,CACd,2BACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content blockquote {\n	/* See #12 */\n	overflow: hidden;\n\n	/* https://github.com/ckeditor/ckeditor5-block-quote/issues/15 */\n	padding-right: 1.5em;\n	padding-left: 1.5em;\n\n	margin-left: 0;\n	margin-right: 0;\n	font-style: italic;\n	border-left: solid 5px hsl(0, 0%, 80%);\n}\n\n.ck-content[dir="rtl"] blockquote {\n	border-left: 0;\n	border-right: solid 5px hsl(0, 0%, 80%);\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 443: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ':root{--ck-image-processing-highlight-color:#f9fafa;--ck-image-processing-background-color:#e3e5e8}.ck.ck-editor__editable .image.image-processing{position:relative}.ck.ck-editor__editable .image.image-processing:before{animation:ck-image-processing-animation 2s linear infinite;background:linear-gradient(90deg,var(--ck-image-processing-background-color),var(--ck-image-processing-highlight-color),var(--ck-image-processing-background-color));background-size:200% 100%;content:"";height:100%;left:0;position:absolute;top:0;width:100%;z-index:1}.ck.ck-editor__editable .image.image-processing img{height:100%}@keyframes ck-image-processing-animation{0%{background-position:200% 0}to{background-position:-200% 0}}', "", { version: 3, sources: ["webpack://./../ckeditor5-ckbox/theme/ckboximageedit.css"], names: [], mappings: "AAKA,MAEC,6CAAyD,CACzD,8CACD,CAIE,gDACC,iBA2BD,CAzBC,uDAmBC,0DAA2D,CAR3D,oKAKC,CACD,yBAA0B,CAhB1B,UAAW,CAOX,WAAY,CAHZ,MAAO,CAFP,iBAAkB,CAClB,KAAM,CAKN,UAAW,CAHX,SAcD,CAEA,oDACC,WACD,CAKH,yCACC,GACC,0BACD,CACA,GACC,2BACD,CACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	/* Based on default CKBox theme colors */\n	--ck-image-processing-highlight-color: hsl(220, 10%, 98%);\n	--ck-image-processing-background-color: hsl(220, 10%, 90%);\n}\n\n.ck.ck-editor__editable {\n	& .image {\n		&.image-processing {\n			position: relative;\n\n			&:before {\n				content: '';\n\n				position: absolute;\n				top: 0;\n				left: 0;\n				z-index: 1;\n\n				height: 100%;\n				width: 100%;\n\n				background: linear-gradient(\n					90deg,\n					var(--ck-image-processing-background-color),\n					var(--ck-image-processing-highlight-color),\n					var(--ck-image-processing-background-color)\n				);\n				background-size: 200% 100%;\n\n				animation: ck-image-processing-animation 2s linear infinite;\n			}\n\n			& img {\n				height: 100%;\n			}\n		}\n	}\n}\n\n@keyframes ck-image-processing-animation {\n	0% {\n		background-position: 200% 0;\n	}\n	100% {\n		background-position: -200% 0;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 903: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, '.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position{display:inline;pointer-events:none;position:relative}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{position:absolute;width:0}.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__selection-handle,.ck.ck-editor__editable .ck-widget:-webkit-drag>.ck-widget__type-around{display:none}.ck.ck-clipboard-drop-target-line{pointer-events:none;position:absolute}:root{--ck-clipboard-drop-target-dot-width:12px;--ck-clipboard-drop-target-dot-height:8px;--ck-clipboard-drop-target-color:var(--ck-color-focus-border)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);bottom:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);margin-left:-1px;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5)}.ck.ck-editor__editable .ck.ck-clipboard-drop-target-position span:after{border-color:var(--ck-clipboard-drop-target-color) transparent transparent transparent;border-style:solid;border-width:calc(var(--ck-clipboard-drop-target-dot-height)) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5);content:"";display:block;height:0;left:50%;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-height)*-.5);transform:translateX(-50%);width:0}.ck.ck-editor__editable .ck-widget.ck-clipboard-drop-target-range{outline:var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color)!important}.ck.ck-editor__editable .ck-widget:-webkit-drag{zoom:.6;outline:none!important}.ck.ck-clipboard-drop-target-line{background:var(--ck-clipboard-drop-target-color);border:1px solid var(--ck-clipboard-drop-target-color);height:0;margin-top:-1px}.ck.ck-clipboard-drop-target-line:before{border-style:solid;content:"";height:0;position:absolute;top:calc(var(--ck-clipboard-drop-target-dot-width)*-.5);width:0}[dir=ltr] .ck.ck-clipboard-drop-target-line:before{border-color:transparent transparent transparent var(--ck-clipboard-drop-target-color);border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0 calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height);left:-1px}[dir=rtl] .ck.ck-clipboard-drop-target-line:before{border-color:transparent var(--ck-clipboard-drop-target-color) transparent transparent;border-width:calc(var(--ck-clipboard-drop-target-dot-width)*.5) var(--ck-clipboard-drop-target-dot-height) calc(var(--ck-clipboard-drop-target-dot-width)*.5) 0;right:-1px}', "", { version: 3, sources: ["webpack://./../ckeditor5-clipboard/theme/clipboard.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-clipboard/clipboard.css"], names: [], mappings: "AASC,8DACC,cAAe,CAEf,mBAAoB,CADpB,iBAOD,CAJC,mEACC,iBAAkB,CAClB,OACD,CAWA,qJACC,YACD,CAIF,kCAEC,mBAAoB,CADpB,iBAED,CC9BA,MACC,yCAA0C,CAC1C,yCAA0C,CAC1C,6DACD,CAOE,mEAIC,gDAAiD,CADjD,sDAAuD,CAFvD,2DAA8D,CAI9D,gBAAiB,CAHjB,wDAqBD,CAfC,yEAWC,sFAAuF,CAEvF,kBAAmB,CADnB,qKAA0K,CAX1K,UAAW,CAIX,aAAc,CAFd,QAAS,CAIT,QAAS,CADT,iBAAkB,CAElB,wDAA2D,CAE3D,0BAA2B,CAR3B,OAYD,CAOF,kEACC,gGACD,CAKA,gDACC,OAAS,CACT,sBACD,CAGD,kCAGC,gDAAiD,CADjD,sDAAuD,CADvD,QAAS,CAGT,eAwBD,CAtBC,yCAMC,kBAAmB,CALnB,UAAW,CAIX,QAAS,CAHT,iBAAkB,CAClB,uDAA0D,CAC1D,OAiBD,CArBA,mDAYE,sFAAuF,CADvF,+JAAoK,CAFpK,SAYF,CArBA,mDAmBE,sFAAuF,CADvF,+JAAmK,CAFnK,UAKF", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n	/*\n	 * Vertical drop target (in text).\n	 */\n	& .ck.ck-clipboard-drop-target-position {\n		display: inline;\n		position: relative;\n		pointer-events: none;\n\n		& span {\n			position: absolute;\n			width: 0;\n		}\n	}\n\n	/*\n	 * Styles of the widget being dragged (its preview).\n	 */\n	& .ck-widget:-webkit-drag {\n		& > .ck-widget__selection-handle {\n			display: none;\n		}\n\n		& > .ck-widget__type-around {\n			display: none;\n		}\n	}\n}\n\n.ck.ck-clipboard-drop-target-line {\n	position: absolute;\n	pointer-events: none;\n}\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

:root {
	--ck-clipboard-drop-target-dot-width: 12px;
	--ck-clipboard-drop-target-dot-height: 8px;
	--ck-clipboard-drop-target-color: var(--ck-color-focus-border);
}

.ck.ck-editor__editable {
	/*
	 * Vertical drop target (in text).
	 */
	& .ck.ck-clipboard-drop-target-position {
		& span {
			bottom: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));
			top: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));
			border: 1px solid var(--ck-clipboard-drop-target-color);
			background: var(--ck-clipboard-drop-target-color);
			margin-left: -1px;

			/* The triangle above the marker */
			&::after {
				content: '';
				width: 0;
				height: 0;

				display: block;
				position: absolute;
				left: 50%;
				top: calc(-.5 * var(--ck-clipboard-drop-target-dot-height));

				transform: translateX(-50%);
				border-color: var(--ck-clipboard-drop-target-color) transparent transparent transparent;
				border-width: calc(var(--ck-clipboard-drop-target-dot-height)) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width));
				border-style: solid;
			}
		}
	}

	/*
	 * Styles of the widget that it a drop target.
	 */
	& .ck-widget.ck-clipboard-drop-target-range {
		outline: var(--ck-widget-outline-thickness) solid var(--ck-clipboard-drop-target-color) !important;
	}

	/*
	 * Styles of the widget being dragged (its preview).
	 */
	& .ck-widget:-webkit-drag {
		zoom: 0.6;
		outline: none !important;
	}
}

.ck.ck-clipboard-drop-target-line {
	height: 0;
	border: 1px solid var(--ck-clipboard-drop-target-color);
	background: var(--ck-clipboard-drop-target-color);
	margin-top: -1px;

	&::before {
		content: '';
		position: absolute;
		top: calc(-.5 * var(--ck-clipboard-drop-target-dot-width));
		width: 0;
		height: 0;
		border-style: solid;

		@mixin ck-dir ltr {
			left: -1px;

			border-width: calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0 calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height);
			border-color: transparent transparent transparent var(--ck-clipboard-drop-target-color);
		}

		@mixin ck-dir rtl {
			right: -1px;

			border-width:calc(.5 * var(--ck-clipboard-drop-target-dot-width)) var(--ck-clipboard-drop-target-dot-height) calc(.5 * var(--ck-clipboard-drop-target-dot-width)) 0;
			border-color: transparent var(--ck-clipboard-drop-target-color) transparent transparent;
		}
	}
}
`], sourceRoot: "" }]);
        const a = s2;
      }, 3143: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-editor{position:relative}.ck.ck-editor .ck-editor__top .ck-sticky-panel .ck-toolbar{z-index:var(--ck-z-modal)}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-editor__top .ck-sticky-panel .ck-toolbar{border-bottom-width:0}.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar{border-bottom-width:1px;border-radius:0}.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar,.ck.ck-editor__top .ck-sticky-panel .ck-sticky-panel__content_sticky .ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:0}.ck.ck-editor__main>.ck-editor__editable{background:var(--ck-color-base-background);border-radius:0}.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable,.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}.ck.ck-editor__main>.ck-editor__editable:not(.ck-focused){border-color:var(--ck-color-base-border)}", "", { version: 3, sources: ["webpack://./../ckeditor5-editor-classic/theme/classiceditor.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-editor-classic/classiceditor.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAKA,cAIC,iBAMD,CAJC,2DAEC,yBACD,CCLC,gDCED,eDKC,CAPA,uICMA,qCAAsC,CDJpC,2BAA4B,CAC5B,4BAIF,CAPA,gDAMC,qBACD,CAEA,iFACC,uBAAwB,CCR1B,eDaC,CANA,yMCHA,qCAAsC,CDOpC,eAEF,CAKF,yCAEC,0CAA2C,CCpB3C,eD8BD,CAZA,yHCdE,qCAAsC,CDmBtC,wBAAyB,CACzB,yBAMF,CAHC,0DACC,wCACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor {\n	/* All the elements within `.ck-editor` are positioned relatively to it.\n	 If any element needs to be positioned with respect to the <body>, etc.,\n	 it must land outside of the `.ck-editor` in DOM. */\n	position: relative;\n\n	& .ck-editor__top .ck-sticky-panel .ck-toolbar {\n		/* https://github.com/ckeditor/ckeditor5-editor-classic/issues/62 */\n		z-index: var(--ck-z-modal);\n	}\n}\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../mixins/_rounded.css";

.ck.ck-editor__top {
	& .ck-sticky-panel {
		& .ck-toolbar {
			@mixin ck-rounded-corners {
				border-bottom-left-radius: 0;
				border-bottom-right-radius: 0;
			}

			border-bottom-width: 0;
		}

		& .ck-sticky-panel__content_sticky .ck-toolbar {
			border-bottom-width: 1px;

			@mixin ck-rounded-corners {
				border-radius: 0;
			}
		}
	}
}

/* Note: Use ck-editor__main to make sure these styles don't apply to other editor types */
.ck.ck-editor__main > .ck-editor__editable {
	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/113 */
	background: var(--ck-color-base-background);

	@mixin ck-rounded-corners {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
	}

	&:not(.ck-focused) {
		border-color: var(--ck-color-base-border);
	}
}
`, "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4717: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck .ck-placeholder,.ck.ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{content:attr(data-placeholder);left:0;pointer-events:none;position:absolute;right:0}.ck.ck-read-only .ck-placeholder:before{display:none}.ck.ck-reset_all .ck-placeholder{position:relative}.ck .ck-placeholder:before,.ck.ck-placeholder:before{color:var(--ck-color-engine-placeholder-text);cursor:text}", "", { version: 3, sources: ["webpack://./../ckeditor5-engine/theme/placeholder.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-engine/placeholder.css"], names: [], mappings: "AAMA,uCAEC,iBAWD,CATC,qDAIC,8BAA+B,CAF/B,MAAO,CAKP,mBAAoB,CANpB,iBAAkB,CAElB,OAKD,CAKA,wCACC,YACD,CAQD,iCACC,iBACD,CC5BC,qDAEC,6CAA8C,CAD9C,WAED", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder,\n.ck .ck-placeholder {\n	position: relative;\n\n	&::before {\n		position: absolute;\n		left: 0;\n		right: 0;\n		content: attr(data-placeholder);\n\n		/* See ckeditor/ckeditor5#469. */\n		pointer-events: none;\n	}\n}\n\n/* See ckeditor/ckeditor5#1987. */\n.ck.ck-read-only .ck-placeholder {\n	&::before {\n		display: none;\n	}\n}\n\n/*\n * Rules for the `ck-placeholder` are loaded before the rules for `ck-reset_all` in the base CKEditor 5 DLL build.\n * This fix overwrites the incorrectly set `position: static` from `ck-reset_all`.\n * See https://github.com/ckeditor/ckeditor5/issues/11418.\n */\n.ck.ck-reset_all .ck-placeholder {\n	position: relative;\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* See ckeditor/ckeditor5#936. */\n.ck.ck-placeholder, .ck .ck-placeholder {\n	&::before {\n		cursor: text;\n		color: var(--ck-color-engine-placeholder-text);\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 9315: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-editor__editable span[data-ck-unsafe-element]{display:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-engine/theme/renderer.css"], names: [], mappings: "AAMA,qDACC,YACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Elements marked by the Renderer as hidden should be invisible in the editor. */\n.ck.ck-editor__editable span[data-ck-unsafe-element] {\n	display: none;\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 8733: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-heading_heading1{font-size:20px}.ck.ck-heading_heading2{font-size:17px}.ck.ck-heading_heading3{font-size:14px}.ck[class*=ck-heading_heading]{font-weight:700}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__button .ck-button__label{width:8em}.ck.ck-dropdown.ck-heading-dropdown .ck-dropdown__panel .ck-list__item{min-width:18em}", "", { version: 3, sources: ["webpack://./../ckeditor5-heading/theme/heading.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-heading/heading.css"], names: [], mappings: "AAKA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,wBACC,cACD,CAEA,+BACC,eACD,CCZC,2EACC,SACD,CAEA,uEACC,cACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-heading_heading1 {\n	font-size: 20px;\n}\n\n.ck.ck-heading_heading2 {\n	font-size: 17px;\n}\n\n.ck.ck-heading_heading3 {\n	font-size: 14px;\n}\n\n.ck[class*="ck-heading_heading"] {\n	font-weight: bold;\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Resize dropdown's button label. */\n.ck.ck-dropdown.ck-heading-dropdown {\n	& .ck-dropdown__button .ck-button__label {\n		width: 8em;\n	}\n\n	& .ck-dropdown__panel .ck-list__item {\n		min-width: 18em;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3508: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-content .image{clear:both;display:table;margin:.9em auto;min-width:50px;text-align:center}.ck-content .image img{display:block;height:auto;margin:0 auto;max-width:100%;min-width:100%}.ck-content .image-inline{align-items:flex-start;display:inline-flex;max-width:100%}.ck-content .image-inline picture{display:flex}.ck-content .image-inline img,.ck-content .image-inline picture{flex-grow:1;flex-shrink:1;max-width:100%}.ck.ck-editor__editable .image>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}.ck.ck-editor__editable .image{z-index:1}.ck.ck-editor__editable .image.ck-widget_selected{z-index:2}.ck.ck-editor__editable .image-inline{z-index:1}.ck.ck-editor__editable .image-inline.ck-widget_selected{z-index:2}.ck.ck-editor__editable .image-inline.ck-widget_selected ::selection{display:none}.ck.ck-editor__editable .image-inline img{height:auto}.ck.ck-editor__editable td .image-inline img,.ck.ck-editor__editable th .image-inline img{max-width:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/image.css"], names: [], mappings: "AAMC,mBAEC,UAAW,CADX,aAAc,CAOd,gBAAkB,CAGlB,cAAe,CARf,iBA2BD,CAjBC,uBAEC,aAAc,CAad,WAAY,CAVZ,aAAc,CAGd,cAAe,CAGf,cAKD,CAGD,0BAYC,sBAAuB,CANvB,mBAAoB,CAGpB,cAoBD,CAdC,kCACC,YACD,CAGA,gEAGC,WAAY,CACZ,aAAc,CAGd,cACD,CAUD,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAKA,+BACC,SASD,CAHC,kDACC,SACD,CAMD,sCACC,SAkBD,CAZC,yDACC,SAUD,CAHC,qEACC,YACD,CAMF,0CACC,WACD,CAMC,0FACC,cACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content {\n	& .image {\n		display: table;\n		clear: both;\n		text-align: center;\n\n		/* Make sure there is some space between the content and the image. Center image by default. */\n		/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n	 	to avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n		margin: 0.9em auto;\n\n		/* Make sure the caption will be displayed properly (See: https://github.com/ckeditor/ckeditor5/issues/1870). */\n		min-width: 50px;\n\n		& img {\n			/* Prevent unnecessary margins caused by line-height (see #44). */\n			display: block;\n\n			/* Center the image if its width is smaller than the content\'s width. */\n			margin: 0 auto;\n\n			/* Make sure the image never exceeds the size of the parent container (ckeditor/ckeditor5-ui#67). */\n			max-width: 100%;\n\n			/* Make sure the image is never smaller than the parent container (See: https://github.com/ckeditor/ckeditor5/issues/9300). */\n			min-width: 100%;\n\n			/* Keep proportions of the block image if the height is set and the image is wider than the editor width.\n			See https://github.com/ckeditor/ckeditor5/issues/14542. */\n			height: auto;\n		}\n	}\n\n	& .image-inline {\n		/*\n		 * Normally, the .image-inline would have "display: inline-block" and "img { width: 100% }" (to follow the wrapper while resizing).\n		 * Unfortunately, together with "srcset", it gets automatically stretched up to the width of the editing root.\n		 * This strange behavior does not happen with inline-flex.\n		 */\n		display: inline-flex;\n\n		/* While being resized, don\'t allow the image to exceed the width of the editing root. */\n		max-width: 100%;\n\n		/* This is required by Safari to resize images in a sensible way. Without this, the browser breaks the ratio. */\n		align-items: flex-start;\n\n		/* When the picture is present it must act as a flex container to let the img resize properly */\n		& picture {\n			display: flex;\n		}\n\n		/* When the picture is present, it must act like a resizable img. */\n		& picture,\n		& img {\n			/* This is necessary for the img to span the entire .image-inline wrapper and to resize properly. */\n			flex-grow: 1;\n			flex-shrink: 1;\n\n			/* Prevents overflowing the editing root boundaries when an inline image is very wide. */\n			max-width: 100%;\n		}\n	}\n}\n\n.ck.ck-editor__editable {\n	/*\n	 * Inhertit the content styles padding of the <figcaption> in case the integration overrides `text-align: center`\n	 * of `.image` (e.g. to the left/right). This ensures the placeholder stays at the padding just like the native\n	 * caret does, and not at the edge of <figcaption>.\n	 */\n	& .image > figcaption.ck-placeholder::before {\n		padding-left: inherit;\n		padding-right: inherit;\n\n		/*\n		 * Make sure the image caption placeholder doesn\'t overflow the placeholder area.\n		 * See https://github.com/ckeditor/ckeditor5/issues/9162.\n		 */\n		white-space: nowrap;\n		overflow: hidden;\n		text-overflow: ellipsis;\n	}\n\n	/*\n	 * See https://github.com/ckeditor/ckeditor5/issues/15115.\n	 */\n	& .image {\n		z-index: 1;\n\n		/*\n		 * Make sure the selected image always stays on top of its siblings.\n		 * See https://github.com/ckeditor/ckeditor5/issues/9108.\n		 */\n		&.ck-widget_selected {\n			z-index: 2;\n		}\n	}\n\n	/*\n	 * See https://github.com/ckeditor/ckeditor5/issues/15115.\n	 */\n	& .image-inline {\n		z-index: 1;\n\n		/*\n		 * Make sure the selected inline image always stays on top of its siblings.\n		 * See https://github.com/ckeditor/ckeditor5/issues/9108.\n		 */\n		&.ck-widget_selected {\n			z-index: 2;\n\n			/*\n			 * Make sure the native browser selection style is not displayed.\n			 * Inline image widgets have their own styles for the selected state and\n			 * leaving this up to the browser is asking for a visual collision.\n			 */\n			& ::selection {\n				display: none;\n			}\n		}\n	}\n\n	/* Keep proportions of the inline image if the height is set and the image is wider than the editor width.\n	See https://github.com/ckeditor/ckeditor5/issues/14542. */\n	& .image-inline img {\n		height: auto;\n	}\n\n	/* The inline image nested in the table should have its original size if not resized.\n	See https://github.com/ckeditor/ckeditor5/issues/9117. */\n	& td,\n	& th {\n		& .image-inline img {\n			max-width: none;\n		}\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 2640: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-color-image-caption-background:#f7f7f7;--ck-color-image-caption-text:#333;--ck-color-image-caption-highligted-background:#fd0}.ck-content .image>figcaption{background-color:var(--ck-color-image-caption-background);caption-side:bottom;color:var(--ck-color-image-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;word-break:break-word}.ck.ck-editor__editable .image>figcaption.image__caption_highlighted{animation:ck-image-caption-highlight .6s ease-out}@keyframes ck-image-caption-highlight{0%{background-color:var(--ck-color-image-caption-highligted-background)}to{background-color:var(--ck-color-image-caption-background)}}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imagecaption.css"], names: [], mappings: "AAKA,MACC,2CAAoD,CACpD,kCAA8C,CAC9C,mDACD,CAGA,8BAKC,yDAA0D,CAH1D,mBAAoB,CAEpB,wCAAyC,CAHzC,qBAAsB,CAMtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,qBAMD,CAGA,qEACC,iDACD,CAEA,sCACC,GACC,oEACD,CAEA,GACC,yDACD,CACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-color-image-caption-background: hsl(0, 0%, 97%);\n	--ck-color-image-caption-text: hsl(0, 0%, 20%);\n	--ck-color-image-caption-highligted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .image > figcaption {\n	display: table-caption;\n	caption-side: bottom;\n	word-break: break-word;\n	color: var(--ck-color-image-caption-text);\n	background-color: var(--ck-color-image-caption-background);\n	padding: .6em;\n	font-size: .75em;\n	outline-offset: -1px;\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .image > figcaption.image__caption_highlighted {\n	animation: ck-image-caption-highlight .6s ease-out;\n}\n\n@keyframes ck-image-caption-highlight {\n	0% {\n		background-color: var(--ck-color-image-caption-highligted-background);\n	}\n\n	100% {\n		background-color: var(--ck-color-image-caption-background);\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3535: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-image-insert-url .ck-image-insert-url__action-row{display:grid;grid-template-columns:repeat(2,1fr)}:root{--ck-image-insert-insert-by-url-width:250px}.ck.ck-image-insert-url{--ck-input-width:100%}.ck.ck-image-insert-url .ck-image-insert-url__action-row{grid-column-gap:var(--ck-spacing-large);margin-top:var(--ck-spacing-large)}.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button-cancel,.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button-save{justify-content:center;min-width:auto}.ck.ck-image-insert-url .ck-image-insert-url__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}.ck.ck-image-insert-form>.ck.ck-button{display:block;padding:var(--ck-list-button-padding);width:100%}[dir=ltr] .ck.ck-image-insert-form>.ck.ck-button{text-align:left}[dir=rtl] .ck.ck-image-insert-form>.ck.ck-button{text-align:right}.ck.ck-image-insert-form>.ck.ck-collapsible:not(:first-child){border-top:1px solid var(--ck-color-base-border)}.ck.ck-image-insert-form>.ck.ck-collapsible:not(:last-child){border-bottom:1px solid var(--ck-color-base-border)}.ck.ck-image-insert-form>.ck.ck-collapsible,.ck.ck-image-insert-form>.ck.ck-image-insert-url{min-width:var(--ck-image-insert-insert-by-url-width)}.ck.ck-image-insert-form>.ck.ck-image-insert-url{padding:var(--ck-spacing-large)}.ck.ck-image-insert-form:focus{outline:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imageinsert.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageinsert.css"], names: [], mappings: "AAMC,yDACC,YAAa,CACb,mCACD,CCFD,MACC,2CACD,CAEA,wBACC,qBAgBD,CAdC,yDACC,uCAAwC,CACxC,kCAWD,CATC,oJAEC,sBAAuB,CACvB,cACD,CAEA,sFACC,0BACD,CAKD,uCACC,aAAc,CAEd,qCAAsC,CADtC,UAUD,CAZA,iDAME,eAMF,CAZA,iDAUE,gBAEF,CAGC,8DACC,gDACD,CAEA,6DACC,mDACD,CAMD,6FAJC,oDAOD,CAHA,iDAEC,+BACD,CAEA,+BACC,YACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-image-insert-url {\n	& .ck-image-insert-url__action-row {\n		display: grid;\n		grid-template-columns: repeat(2, 1fr);\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n	--ck-image-insert-insert-by-url-width: 250px;\n}\n\n.ck.ck-image-insert-url {\n	--ck-input-width: 100%;\n\n	& .ck-image-insert-url__action-row {\n		grid-column-gap: var(--ck-spacing-large);\n		margin-top: var(--ck-spacing-large);\n\n		& .ck-button-save,\n		& .ck-button-cancel {\n			justify-content: center;\n			min-width: auto;\n		}\n\n		& .ck-button .ck-button__label {\n			color: var(--ck-color-text);\n		}\n	}\n}\n\n.ck.ck-image-insert-form {\n	& > .ck.ck-button {\n		display: block;\n		width: 100%;\n		padding: var(--ck-list-button-padding);\n\n		@mixin ck-dir ltr {\n			text-align: left;\n		}\n\n		@mixin ck-dir rtl {\n			text-align: right;\n		}\n	}\n\n	& > .ck.ck-collapsible {\n		&:not(:first-child) {\n			border-top: 1px solid var(--ck-color-base-border);\n		}\n\n		&:not(:last-child) {\n			border-bottom: 1px solid var(--ck-color-base-border);\n		}\n\n		min-width: var(--ck-image-insert-insert-by-url-width);\n	}\n\n	/* This is the case when there are no other integrations configured than insert by URL */\n	& > .ck.ck-image-insert-url {\n		min-width: var(--ck-image-insert-insert-by-url-width);\n		padding: var(--ck-spacing-large);\n	}\n\n	&:focus {\n		outline: none;\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 2873: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-editor__editable img.image_placeholder{background-size:100% 100%}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imageplaceholder.css"], names: [], mappings: "AAMC,8CACC,yBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n	& img.image_placeholder {\n		background-size: 100% 100%;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 6270: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-content img.image_resized{height:auto}.ck-content .image.image_resized{box-sizing:border-box;display:block;max-width:100%}.ck-content .image.image_resized img{width:100%}.ck-content .image.image_resized>figcaption{display:block}.ck.ck-editor__editable td .image-inline.image_resized img,.ck.ck-editor__editable th .image-inline.image_resized img{max-width:100%}[dir=ltr] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon{margin-left:var(--ck-spacing-standard)}.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label{width:4em}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imageresize.css"], names: [], mappings: "AAMA,8BACC,WACD,CAEA,iCAQC,qBAAsB,CADtB,aAAc,CANd,cAkBD,CATC,qCAEC,UACD,CAEA,4CAEC,aACD,CAQC,sHACC,cACD,CAIF,oFACC,uCACD,CAEA,oFACC,sCACD,CAEA,oEACC,SACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Preserve aspect ratio of the resized image after introducing image height attribute. */\n.ck-content img.image_resized {\n	height: auto;\n}\n\n.ck-content .image.image_resized {\n	max-width: 100%;\n	/*\n	The `<figure>` element for resized images must not use `display:table` as browsers do not support `max-width` for it well.\n	See https://stackoverflow.com/questions/4019604/chrome-safari-ignoring-max-width-in-table/14420691#14420691 for more.\n	Fortunately, since we control the width, there is no risk that the image will look bad.\n	*/\n	display: block;\n	box-sizing: border-box;\n\n	& img {\n		/* For resized images it is the `<figure>` element that determines the image width. */\n		width: 100%;\n	}\n\n	& > figcaption {\n		/* The `<figure>` element uses `display:block`, so `<figcaption>` also has to. */\n		display: block;\n	}\n}\n\n.ck.ck-editor__editable {\n	/* The resized inline image nested in the table should respect its parent size.\n	See https://github.com/ckeditor/ckeditor5/issues/9117. */\n	& td,\n	& th {\n		& .image-inline.image_resized img {\n			max-width: 100%;\n		}\n	}\n}\n\n[dir="ltr"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n	margin-right: var(--ck-spacing-standard);\n}\n\n[dir="rtl"] .ck.ck-button.ck-button_with-text.ck-resize-image-button .ck-button__icon {\n	margin-left: var(--ck-spacing-standard);\n}\n\n.ck.ck-dropdown .ck-button.ck-resize-image-button .ck-button__label {\n	width: 4em;\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 5083: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-image-style-spacing:1.5em;--ck-inline-image-style-spacing:calc(var(--ck-image-style-spacing)/2)}.ck-content .image-style-block-align-left,.ck-content .image-style-block-align-right{max-width:calc(100% - var(--ck-image-style-spacing))}.ck-content .image-style-align-left,.ck-content .image-style-align-right{clear:none}.ck-content .image-style-side{float:right;margin-left:var(--ck-image-style-spacing);max-width:50%}.ck-content .image-style-align-left{float:left;margin-right:var(--ck-image-style-spacing)}.ck-content .image-style-align-center{margin-left:auto;margin-right:auto}.ck-content .image-style-align-right{float:right;margin-left:var(--ck-image-style-spacing)}.ck-content .image-style-block-align-right{margin-left:auto;margin-right:0}.ck-content .image-style-block-align-left{margin-left:0;margin-right:auto}.ck-content p+.image-style-align-left,.ck-content p+.image-style-align-right,.ck-content p+.image-style-side{margin-top:0}.ck-content .image-inline.image-style-align-left,.ck-content .image-inline.image-style-align-right{margin-bottom:var(--ck-inline-image-style-spacing);margin-top:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-left{margin-right:var(--ck-inline-image-style-spacing)}.ck-content .image-inline.image-style-align-right{margin-left:var(--ck-inline-image-style-spacing)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-background)}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__action:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton.ck-splitbutton_flatten:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover):after{display:none}.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__action:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled),.ck.ck-splitbutton.ck-splitbutton_flatten.ck-splitbutton_open:hover>.ck-splitbutton__arrow:not(.ck-disabled):not(:hover){background-color:var(--ck-color-button-on-hover-background)}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imagestyle.css"], names: [], mappings: "AAKA,MACC,8BAA+B,CAC/B,qEACD,CAMC,qFAEC,oDACD,CAIA,yEAEC,UACD,CAEA,8BACC,WAAY,CACZ,yCAA0C,CAC1C,aACD,CAEA,oCACC,UAAW,CACX,0CACD,CAEA,sCACC,gBAAiB,CACjB,iBACD,CAEA,qCACC,WAAY,CACZ,yCACD,CAEA,2CAEC,gBAAiB,CADjB,cAED,CAEA,0CACC,aAAc,CACd,iBACD,CAGA,6GAGC,YACD,CAGC,mGAGC,kDAAmD,CADnD,+CAED,CAEA,iDACC,iDACD,CAEA,kDACC,gDACD,CAUC,0lBAGC,qDAKD,CAHC,8nBACC,YACD,CAKD,oVAGC,2DACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-image-style-spacing: 1.5em;\n	--ck-inline-image-style-spacing: calc(var(--ck-image-style-spacing) / 2);\n}\n\n.ck-content {\n	/* Provides a minimal side margin for the left and right aligned images, so that the user has a visual feedback\n	confirming successful application of the style if image width exceeds the editor's size.\n	See https://github.com/ckeditor/ckeditor5/issues/9342 */\n	& .image-style-block-align-left,\n	& .image-style-block-align-right {\n		max-width: calc(100% - var(--ck-image-style-spacing));\n	}\n\n	/* Allows displaying multiple floating images in the same line.\n	See https://github.com/ckeditor/ckeditor5/issues/9183#issuecomment-804988132 */\n	& .image-style-align-left,\n	& .image-style-align-right {\n		clear: none;\n	}\n\n	& .image-style-side {\n		float: right;\n		margin-left: var(--ck-image-style-spacing);\n		max-width: 50%;\n	}\n\n	& .image-style-align-left {\n		float: left;\n		margin-right: var(--ck-image-style-spacing);\n	}\n\n	& .image-style-align-center {\n		margin-left: auto;\n		margin-right: auto;\n	}\n\n	& .image-style-align-right {\n		float: right;\n		margin-left: var(--ck-image-style-spacing);\n	}\n\n	& .image-style-block-align-right {\n		margin-right: 0;\n		margin-left: auto;\n	}\n\n	& .image-style-block-align-left {\n		margin-left: 0;\n		margin-right: auto;\n	}\n\n	/* Simulates margin collapsing with the preceding paragraph, which does not work for the floating elements. */\n	& p + .image-style-align-left,\n	& p + .image-style-align-right,\n	& p + .image-style-side {\n		margin-top: 0;\n	}\n\n	& .image-inline {\n		&.image-style-align-left,\n		&.image-style-align-right {\n			margin-top: var(--ck-inline-image-style-spacing);\n			margin-bottom: var(--ck-inline-image-style-spacing);\n		}\n\n		&.image-style-align-left {\n			margin-right: var(--ck-inline-image-style-spacing);\n		}\n\n		&.image-style-align-right {\n			margin-left: var(--ck-inline-image-style-spacing);\n		}\n	}\n}\n\n.ck.ck-splitbutton {\n	/* The button should display as a regular drop-down if the action button\n	is forced to fire the same action as the arrow button. */\n	&.ck-splitbutton_flatten {\n		&:hover,\n		&.ck-splitbutton_open {\n			& > .ck-splitbutton__action:not(.ck-disabled),\n			& > .ck-splitbutton__arrow:not(.ck-disabled),\n			& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n				background-color: var(--ck-color-button-on-background);\n\n				&::after {\n					display: none;\n				}\n			}\n		}\n\n		&.ck-splitbutton_open:hover {\n			& > .ck-splitbutton__action:not(.ck-disabled),\n			& > .ck-splitbutton__arrow:not(.ck-disabled),\n			& > .ck-splitbutton__arrow:not(.ck-disabled):not(:hover) {\n				background-color: var(--ck-color-button-on-hover-background);\n			}\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4036: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, '.ck-image-upload-complete-icon{border-radius:50%;display:block;position:absolute;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);z-index:1}.ck-image-upload-complete-icon:after{content:"";position:absolute}:root{--ck-color-image-upload-icon:#fff;--ck-color-image-upload-icon-background:#008a00;--ck-image-upload-icon-size:20;--ck-image-upload-icon-width:2px;--ck-image-upload-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck-image-upload-complete-icon{animation-delay:0ms,3s;animation-duration:.5s,.5s;animation-fill-mode:forwards,forwards;animation-name:ck-upload-complete-icon-show,ck-upload-complete-icon-hide;background:var(--ck-color-image-upload-icon-background);font-size:calc(1px*var(--ck-image-upload-icon-size));height:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size));opacity:0;overflow:hidden;width:calc(var(--ck-image-upload-icon-is-visible)*var(--ck-image-upload-icon-size))}.ck-image-upload-complete-icon:after{animation-delay:.5s;animation-duration:.5s;animation-fill-mode:forwards;animation-name:ck-upload-complete-icon-check;border-right:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);border-top:var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);box-sizing:border-box;height:0;left:25%;opacity:0;top:50%;transform:scaleX(-1) rotate(135deg);transform-origin:left top;width:0}@keyframes ck-upload-complete-icon-show{0%{opacity:0}to{opacity:1}}@keyframes ck-upload-complete-icon-hide{0%{opacity:1}to{opacity:0}}@keyframes ck-upload-complete-icon-check{0%{height:0;opacity:1;width:0}33%{height:0;width:.3em}to{height:.45em;opacity:1;width:.3em}}', "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imageuploadicon.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadicon.css"], names: [], mappings: "AAKA,+BAUC,iBAAkB,CATlB,aAAc,CACd,iBAAkB,CAOlB,sCAAwC,CADxC,oCAAsC,CAGtC,SAMD,CAJC,qCACC,UAAW,CACX,iBACD,CChBD,MACC,iCAA8C,CAC9C,+CAA4D,CAG5D,8BAA+B,CAC/B,gCAAiC,CACjC,4DACD,CAEA,+BAWC,sBAA4B,CAN5B,0BAAgC,CADhC,qCAAuC,CADvC,wEAA0E,CAD1E,uDAAwD,CAMxD,oDAAuD,CAWvD,oFAAuF,CAlBvF,SAAU,CAgBV,eAAgB,CAChB,mFA0BD,CAtBC,qCAgBC,mBAAsB,CADtB,sBAAyB,CAEzB,4BAA6B,CAH7B,4CAA6C,CAF7C,sFAAuF,CADvF,oFAAqF,CASrF,qBAAsB,CAdtB,QAAS,CAJT,QAAS,CAGT,SAAU,CADV,OAAQ,CAKR,mCAAoC,CACpC,yBAA0B,CAH1B,OAcD,CAGD,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,wCACC,GACC,SACD,CAEA,GACC,SACD,CACD,CAEA,yCACC,GAGC,QAAS,CAFT,SAAU,CACV,OAED,CACA,IAEC,QAAS,CADT,UAED,CACA,GAGC,YAAc,CAFd,SAAU,CACV,UAED,CACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-image-upload-complete-icon {\n	display: block;\n	position: absolute;\n\n	/*\n	 * Smaller images should have the icon closer to the border.\n	 * Match the icon position with the linked image indicator brought by the link image feature.\n	 */\n	top: min(var(--ck-spacing-medium), 6%);\n	right: min(var(--ck-spacing-medium), 6%);\n	border-radius: 50%;\n	z-index: 1;\n\n	&::after {\n		content: "";\n		position: absolute;\n	}\n}\n', '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-color-image-upload-icon: hsl(0, 0%, 100%);\n	--ck-color-image-upload-icon-background: hsl(120, 100%, 27%);\n\n	/* Match the icon size with the linked image indicator brought by the link image feature. */\n	--ck-image-upload-icon-size: 20;\n	--ck-image-upload-icon-width: 2px;\n	--ck-image-upload-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck-image-upload-complete-icon {\n	opacity: 0;\n	background: var(--ck-color-image-upload-icon-background);\n	animation-name: ck-upload-complete-icon-show, ck-upload-complete-icon-hide;\n	animation-fill-mode: forwards, forwards;\n	animation-duration: 500ms, 500ms;\n\n	/* To make animation scalable. */\n	font-size: calc(1px * var(--ck-image-upload-icon-size));\n\n	/* Hide completed upload icon after 3 seconds. */\n	animation-delay: 0ms, 3000ms;\n\n	/*\n	 * Use CSS math to simulate container queries.\n	 * https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n	 */\n	overflow: hidden;\n	width: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n	height: calc(var(--ck-image-upload-icon-is-visible) * var(--ck-image-upload-icon-size));\n\n	/* This is check icon element made from border-width mixed with animations. */\n	&::after {\n		/* Because of border transformation we need to "hard code" left position. */\n		left: 25%;\n\n		top: 50%;\n		opacity: 0;\n		height: 0;\n		width: 0;\n\n		transform: scaleX(-1) rotate(135deg);\n		transform-origin: left top;\n		border-top: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n		border-right: var(--ck-image-upload-icon-width) solid var(--ck-color-image-upload-icon);\n\n		animation-name: ck-upload-complete-icon-check;\n		animation-duration: 500ms;\n		animation-delay: 500ms;\n		animation-fill-mode: forwards;\n\n		/* #1095. While reset is not providing proper box-sizing for pseudoelements, we need to handle it. */\n		box-sizing: border-box;\n	}\n}\n\n@keyframes ck-upload-complete-icon-show {\n	from {\n		opacity: 0;\n	}\n\n	to {\n		opacity: 1;\n	}\n}\n\n@keyframes ck-upload-complete-icon-hide {\n	from {\n		opacity: 1;\n	}\n\n	to {\n		opacity: 0;\n	}\n}\n\n@keyframes ck-upload-complete-icon-check {\n	0% {\n		opacity: 1;\n		width: 0;\n		height: 0;\n	}\n	33% {\n		width: 0.3em;\n		height: 0;\n	}\n	100% {\n		opacity: 1;\n		width: 0.3em;\n		height: 0.45em;\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 3773: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, '.ck .ck-upload-placeholder-loader{align-items:center;display:flex;justify-content:center;left:0;position:absolute;top:0}.ck .ck-upload-placeholder-loader:before{content:"";position:relative}:root{--ck-color-upload-placeholder-loader:#b3b3b3;--ck-upload-placeholder-loader-size:32px;--ck-upload-placeholder-image-aspect-ratio:2.8}.ck .ck-image-upload-placeholder{margin:0;width:100%}.ck .ck-image-upload-placeholder.image-inline{width:calc(var(--ck-upload-placeholder-loader-size)*2*var(--ck-upload-placeholder-image-aspect-ratio))}.ck .ck-image-upload-placeholder img{aspect-ratio:var(--ck-upload-placeholder-image-aspect-ratio)}.ck .ck-upload-placeholder-loader{height:100%;width:100%}.ck .ck-upload-placeholder-loader:before{animation:ck-upload-placeholder-loader 1s linear infinite;border-radius:50%;border-right:2px solid transparent;border-top:3px solid var(--ck-color-upload-placeholder-loader);height:var(--ck-upload-placeholder-loader-size);width:var(--ck-upload-placeholder-loader-size)}@keyframes ck-upload-placeholder-loader{to{transform:rotate(1turn)}}', "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imageuploadloader.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadloader.css"], names: [], mappings: "AAKA,kCAGC,kBAAmB,CADnB,YAAa,CAEb,sBAAuB,CAEvB,MAAO,CALP,iBAAkB,CAIlB,KAOD,CAJC,yCACC,UAAW,CACX,iBACD,CCXD,MACC,4CAAqD,CACrD,wCAAyC,CACzC,8CACD,CAEA,iCAGC,QAAS,CADT,UAgBD,CAbC,8CACC,sGACD,CAEA,qCAOC,4DACD,CAGD,kCAEC,WAAY,CADZ,UAWD,CARC,yCAMC,yDAA0D,CAH1D,iBAAkB,CAElB,kCAAmC,CADnC,8DAA+D,CAF/D,+CAAgD,CADhD,8CAMD,CAGD,wCACC,GACC,uBACD,CACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-upload-placeholder-loader {\n	position: absolute;\n	display: flex;\n	align-items: center;\n	justify-content: center;\n	top: 0;\n	left: 0;\n\n	&::before {\n		content: '';\n		position: relative;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-color-upload-placeholder-loader: hsl(0, 0%, 70%);\n	--ck-upload-placeholder-loader-size: 32px;\n	--ck-upload-placeholder-image-aspect-ratio: 2.8;\n}\n\n.ck .ck-image-upload-placeholder {\n	/* We need to control the full width of the SVG gray background. */\n	width: 100%;\n	margin: 0;\n\n	&.image-inline {\n		width: calc( 2 * var(--ck-upload-placeholder-loader-size) * var(--ck-upload-placeholder-image-aspect-ratio) );\n	}\n\n	& img {\n		/*\n		 * This is an arbitrary aspect for a 1x1 px GIF to display to the user. Not too tall, not too short.\n		 * There's nothing special about this number except that it should make the image placeholder look like\n		 * a real image during this short period after the upload started and before the image was read from the\n		 * file system (and a rich preview was loaded).\n		 */\n		aspect-ratio: var(--ck-upload-placeholder-image-aspect-ratio);\n	}\n}\n\n.ck .ck-upload-placeholder-loader {\n	width: 100%;\n	height: 100%;\n\n	&::before {\n		width: var(--ck-upload-placeholder-loader-size);\n		height: var(--ck-upload-placeholder-loader-size);\n		border-radius: 50%;\n		border-top: 3px solid var(--ck-color-upload-placeholder-loader);\n		border-right: 2px solid transparent;\n		animation: ck-upload-placeholder-loader 1s linear infinite;\n	}\n}\n\n@keyframes ck-upload-placeholder-loader {\n	to {\n		transform: rotate( 360deg );\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3689: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-editor__editable .image,.ck.ck-editor__editable .image-inline{position:relative}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{left:0;position:absolute;top:0}.ck.ck-editor__editable .image-inline.ck-appear,.ck.ck-editor__editable .image.ck-appear{animation:fadeIn .7s}.ck.ck-editor__editable .image .ck-progress-bar,.ck.ck-editor__editable .image-inline .ck-progress-bar{background:var(--ck-color-upload-bar-background);height:2px;transition:width .1s;width:0}@keyframes fadeIn{0%{opacity:0}to{opacity:1}}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/imageuploadprogress.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-image/imageuploadprogress.css"], names: [], mappings: "AAMC,qEAEC,iBACD,CAGA,uGAIC,MAAO,CAFP,iBAAkB,CAClB,KAED,CCRC,yFACC,oBACD,CAID,uGAIC,gDAAiD,CAFjD,UAAW,CAGX,oBAAuB,CAFvB,OAGD,CAGD,kBACC,GAAO,SAAY,CACnB,GAAO,SAAY,CACpB", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n	& .image,\n	& .image-inline {\n		position: relative;\n	}\n\n	/* Upload progress bar. */\n	& .image .ck-progress-bar,\n	& .image-inline .ck-progress-bar {\n		position: absolute;\n		top: 0;\n		left: 0;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n	& .image,\n	& .image-inline {\n		/* Showing animation. */\n		&.ck-appear {\n			animation: fadeIn 700ms;\n		}\n	}\n\n	/* Upload progress bar. */\n	& .image .ck-progress-bar,\n	& .image-inline .ck-progress-bar {\n		height: 2px;\n		width: 0;\n		background: var(--ck-color-upload-bar-background);\n		transition: width 100ms;\n	}\n}\n\n@keyframes fadeIn {\n	from { opacity: 0; }\n	to   { opacity: 1; }\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 1905: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-text-alternative-form{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-text-alternative-form .ck-labeled-field-view{display:inline-block}.ck.ck-text-alternative-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-text-alternative-form{flex-wrap:wrap}.ck.ck-text-alternative-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-text-alternative-form .ck-button{flex-basis:50%}}", "", { version: 3, sources: ["webpack://./../ckeditor5-image/theme/textalternativeform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css"], names: [], mappings: "AAOA,6BACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,oDACC,oBACD,CAEA,uCACC,YACD,CCZA,oCDCD,6BAcE,cAUF,CARE,oDACC,eACD,CAEA,wCACC,cACD,CCrBD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-text-alternative-form {\n	display: flex;\n	flex-direction: row;\n	flex-wrap: nowrap;\n\n	& .ck-labeled-field-view {\n		display: inline-block;\n	}\n\n	& .ck-label {\n		display: none;\n	}\n\n	@mixin ck-media-phone {\n		flex-wrap: wrap;\n\n		& .ck-labeled-field-view {\n			flex-basis: 100%;\n		}\n\n		& .ck-button {\n			flex-basis: 50%;\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n	@media screen and (max-width: 600px) {\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 9773: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck .ck-link_selected{background:var(--ck-color-link-selected-background)}.ck .ck-link_selected span.image-inline{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background)}.ck .ck-fake-link-selection{background:var(--ck-color-link-fake-selection)}.ck .ck-fake-link-selection_collapsed{border-right:1px solid var(--ck-color-base-text);height:100%;margin-right:-1px;outline:1px solid hsla(0,0%,100%,.5)}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/link.css"], names: [], mappings: "AAMA,sBACC,mDAMD,CAHC,wCACC,yFACD,CAOD,4BACC,8CACD,CAGA,sCAEC,gDAAiD,CADjD,WAAY,CAEZ,iBAAkB,CAClB,oCACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/* Class added to span element surrounding currently selected link. */\n.ck .ck-link_selected {\n	background: var(--ck-color-link-selected-background);\n\n	/* Give linked inline images some outline to let the user know they are also part of the link. */\n	& span.image-inline {\n		outline: var(--ck-widget-outline-thickness) solid var(--ck-color-link-selected-background);\n	}\n}\n\n/*\n * Classes used by the "fake visual selection" displayed in the content when an input\n * in the link UI has focus (the browser does not render the native selection in this state).\n */\n.ck .ck-fake-link-selection {\n	background: var(--ck-color-link-fake-selection);\n}\n\n/* A collapsed fake visual selection. */\n.ck .ck-fake-link-selection_collapsed {\n	height: 100%;\n	border-right: 1px solid var(--ck-color-base-text);\n	margin-right: -1px;\n	outline: solid 1px hsla(0, 0%, 100%, .5);\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 2347: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-link-actions{display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-link-actions .ck-link-actions__preview{display:inline-block}.ck.ck-link-actions .ck-link-actions__preview .ck-button__label{overflow:hidden}@media screen and (max-width:600px){.ck.ck-link-actions{flex-wrap:wrap}.ck.ck-link-actions .ck-link-actions__preview{flex-basis:100%}.ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){flex-basis:50%}}.ck.ck-link-actions .ck-button.ck-link-actions__preview{padding-left:0;padding-right:0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{color:var(--ck-color-link-default);cursor:pointer;max-width:var(--ck-input-width);min-width:3em;padding:0 var(--ck-spacing-medium);text-align:center;text-overflow:ellipsis}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label:hover{text-decoration:underline}.ck.ck-link-actions .ck-button.ck-link-actions__preview,.ck.ck-link-actions .ck-button.ck-link-actions__preview:active,.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus,.ck.ck-link-actions .ck-button.ck-link-actions__preview:hover{background:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:active{box-shadow:none}.ck.ck-link-actions .ck-button.ck-link-actions__preview:focus .ck-button__label{text-decoration:underline}[dir=ltr] .ck.ck-link-actions .ck-button:not(:first-child),[dir=rtl] .ck.ck-link-actions .ck-button:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-link-actions .ck-button.ck-link-actions__preview{margin:var(--ck-spacing-standard) var(--ck-spacing-standard) 0}.ck.ck-link-actions .ck-button.ck-link-actions__preview .ck-button__label{max-width:100%;min-width:0}[dir=ltr] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview),[dir=rtl] .ck.ck-link-actions .ck-button:not(.ck-link-actions__preview){margin-left:0}}", "", { version: 3, sources: ["webpack://./../ckeditor5-link/theme/linkactions.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/linkactions.css"], names: [], mappings: "AAOA,oBACC,YAAa,CACb,kBAAmB,CACnB,gBAqBD,CAnBC,8CACC,oBAKD,CAHC,gEACC,eACD,CCXD,oCDCD,oBAcE,cAUF,CARE,8CACC,eACD,CAEA,8DACC,cACD,CCrBD,CCIA,wDACC,cAAe,CACf,eAmCD,CAjCC,0EAEC,kCAAmC,CAEnC,cAAe,CAIf,+BAAgC,CAChC,aAAc,CARd,kCAAmC,CASnC,iBAAkB,CAPlB,sBAYD,CAHC,gFACC,yBACD,CAGD,mPAIC,eACD,CAEA,+DACC,eACD,CAGC,gFACC,yBACD,CAWD,qHACC,sCACD,CDtDD,oCC0DC,wDACC,8DAMD,CAJC,0EAEC,cAAe,CADf,WAED,CAGD,gJAME,aAEF,CDzED", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-actions {\n	display: flex;\n	flex-direction: row;\n	flex-wrap: nowrap;\n\n	& .ck-link-actions__preview {\n		display: inline-block;\n\n		& .ck-button__label {\n			overflow: hidden;\n		}\n	}\n\n	@mixin ck-media-phone {\n		flex-wrap: wrap;\n\n		& .ck-link-actions__preview {\n			flex-basis: 100%;\n		}\n\n		& .ck-button:not(.ck-link-actions__preview) {\n			flex-basis: 50%;\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n	@media screen and (max-width: 600px) {\n		@mixin-content;\n	}\n}\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_unselectable.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";
@import "../mixins/_focus.css";
@import "../mixins/_shadow.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";

.ck.ck-link-actions {
	& .ck-button.ck-link-actions__preview {
		padding-left: 0;
		padding-right: 0;

		& .ck-button__label {
			padding: 0 var(--ck-spacing-medium);
			color: var(--ck-color-link-default);
			text-overflow: ellipsis;
			cursor: pointer;

			/* Match the box model of the link editor form's input so the balloon
			does not change width when moving between actions and the form. */
			max-width: var(--ck-input-width);
			min-width: 3em;
			text-align: center;

			&:hover {
				text-decoration: underline;
			}
		}

		&,
		&:hover,
		&:focus,
		&:active {
			background: none;
		}

		&:active {
			box-shadow: none;
		}

		&:focus {
			& .ck-button__label {
				text-decoration: underline;
			}
		}
	}

	@mixin ck-dir ltr {
		& .ck-button:not(:first-child) {
			margin-left: var(--ck-spacing-standard);
		}
	}

	@mixin ck-dir rtl {
		& .ck-button:not(:last-child) {
			margin-left: var(--ck-spacing-standard);
		}
	}

	@mixin ck-media-phone {
		& .ck-button.ck-link-actions__preview {
			margin: var(--ck-spacing-standard) var(--ck-spacing-standard) 0;

			& .ck-button__label {
				min-width: 0;
				max-width: 100%;
			}
		}

		& .ck-button:not(.ck-link-actions__preview) {
			@mixin ck-dir ltr {
				margin-left: 0;
			}

			@mixin ck-dir rtl {
				margin-left: 0;
			}
		}
	}
}
`], sourceRoot: "" }]);
        const a = s2;
      }, 7754: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-link-form{display:flex}.ck.ck-link-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-link-form{flex-wrap:wrap}.ck.ck-link-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-link-form .ck-button{flex-basis:50%}}.ck.ck-link-form_layout-vertical{display:block}.ck.ck-link-form_layout-vertical .ck-button.ck-button-cancel,.ck.ck-link-form_layout-vertical .ck-button.ck-button-save{margin-top:var(--ck-spacing-medium)}.ck.ck-link-form_layout-vertical{min-width:var(--ck-input-width);padding:0}.ck.ck-link-form_layout-vertical .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small)}.ck.ck-link-form_layout-vertical .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-link-form_layout-vertical>.ck-button{border-radius:0;margin:0;padding:var(--ck-spacing-standard);width:50%}.ck.ck-link-form_layout-vertical>.ck-button:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-link-form_layout-vertical>.ck-button,[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button{margin-left:0}[dir=rtl] .ck.ck-link-form_layout-vertical>.ck-button:last-of-type{border-right:1px solid var(--ck-color-base-border)}.ck.ck-link-form_layout-vertical .ck.ck-list{margin:var(--ck-spacing-standard) var(--ck-spacing-large)}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton{padding:0;width:100%}.ck.ck-link-form_layout-vertical .ck.ck-list .ck-button.ck-switchbutton:hover{background:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-link/theme/linkform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/linkform.css"], names: [], mappings: "AAOA,iBACC,YAiBD,CAfC,2BACC,YACD,CCNA,oCDCD,iBAQE,cAUF,CARE,wCACC,eACD,CAEA,4BACC,cACD,CCfD,CDuBD,iCACC,aAYD,CALE,wHAEC,mCACD,CE/BF,iCAEC,+BAAgC,CADhC,SAgDD,CA7CC,wDACC,8EAMD,CAJC,uEACC,WAAY,CACZ,UACD,CAGD,4CAIC,eAAgB,CAFhB,QAAS,CADT,kCAAmC,CAEnC,SAkBD,CAfC,wDACC,gDACD,CARD,4GAeE,aAMF,CAJE,mEACC,kDACD,CAKF,6CACC,yDAUD,CARC,wEACC,SAAU,CACV,UAKD,CAHC,8EACC,eACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-link-form {\n	display: flex;\n\n	& .ck-label {\n		display: none;\n	}\n\n	@mixin ck-media-phone {\n		flex-wrap: wrap;\n\n		& .ck-labeled-field-view {\n			flex-basis: 100%;\n		}\n\n		& .ck-button {\n			flex-basis: 50%;\n		}\n	}\n}\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n	display: block;\n\n	/*\n	 * Whether the form is in the responsive mode or not, if there are decorator buttons\n	 * keep the top margin of action buttons medium.\n	 */\n	& .ck-button {\n		&.ck-button-save,\n		&.ck-button-cancel {\n			margin-top: var(--ck-spacing-medium);\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n	@media screen and (max-width: 600px) {\n		@mixin-content;\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/*\n * Style link form differently when manual decorators are available.\n * See: https://github.com/ckeditor/ckeditor5-link/issues/186.\n */\n.ck.ck-link-form_layout-vertical {\n	padding: 0;\n	min-width: var(--ck-input-width);\n\n	& .ck-labeled-field-view {\n		margin: var(--ck-spacing-large) var(--ck-spacing-large) var(--ck-spacing-small);\n\n		& .ck-input-text {\n			min-width: 0;\n			width: 100%;\n		}\n	}\n\n	& > .ck-button {\n		padding: var(--ck-spacing-standard);\n		margin: 0;\n		width: 50%;\n		border-radius: 0;\n\n		&:not(:focus) {\n			border-top: 1px solid var(--ck-color-base-border);\n		}\n\n		@mixin ck-dir ltr {\n			margin-left: 0;\n		}\n\n		@mixin ck-dir rtl {\n			margin-left: 0;\n\n			&:last-of-type {\n				border-right: 1px solid var(--ck-color-base-border);\n			}\n		}\n	}\n\n	/* Using additional `.ck` class for stronger CSS specificity than `.ck.ck-link-form > :not(:first-child)`. */\n	& .ck.ck-list {\n		margin: var(--ck-spacing-standard) var(--ck-spacing-large);\n\n		& .ck-button.ck-switchbutton {\n			padding: 0;\n			width: 100%;\n\n			&:hover {\n				background: none;\n			}\n		}\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 111: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, '.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{display:block;position:absolute}:root{--ck-link-image-indicator-icon-size:20;--ck-link-image-indicator-icon-is-visible:clamp(0px,100% - 50px,1px)}.ck.ck-editor__editable a span.image-inline:after,.ck.ck-editor__editable figure.image>a:after{background-color:rgba(0,0,0,.4);background-image:url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+");background-position:50%;background-repeat:no-repeat;background-size:14px;border-radius:100%;content:"";height:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size));overflow:hidden;right:min(var(--ck-spacing-medium),6%);top:min(var(--ck-spacing-medium),6%);width:calc(var(--ck-link-image-indicator-icon-is-visible)*var(--ck-link-image-indicator-icon-size))}', "", { version: 3, sources: ["webpack://./../ckeditor5-link/theme/linkimage.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-link/linkimage.css"], names: [], mappings: "AASE,+FACC,aAAc,CACd,iBACD,CCPF,MAEC,sCAAuC,CACvC,oEACD,CAME,+FAUC,+BAAqC,CACrC,83BAA+3B,CAG/3B,uBAA2B,CAD3B,2BAA4B,CAD5B,oBAAqB,CAGrB,kBAAmB,CAdnB,UAAW,CAsBX,oGAAuG,CAFvG,eAAgB,CAbhB,sCAAwC,CADxC,oCAAsC,CAetC,mGAED", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-editor__editable {\n	/* Linked image indicator */\n	& figure.image > a,\n	& a span.image-inline {\n		&::after {\n			display: block;\n			position: absolute;\n		}\n	}\n}\n\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	/* Match the icon size with the upload indicator brought by the image upload feature. */\n	--ck-link-image-indicator-icon-size: 20;\n	--ck-link-image-indicator-icon-is-visible: clamp(0px, 100% - 50px, 1px);\n}\n\n.ck.ck-editor__editable {\n	/* Linked image indicator */\n	& figure.image > a,\n	& a span.image-inline {\n		&::after {\n			content: "";\n\n			/*\n			 * Smaller images should have the icon closer to the border.\n			 * Match the icon position with the upload indicator brought by the image upload feature.\n			 */\n			top: min(var(--ck-spacing-medium), 6%);\n			right: min(var(--ck-spacing-medium), 6%);\n\n			background-color: hsla(0, 0%, 0%, .4);\n			background-image: url("data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjAgMjAiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PHBhdGggZmlsbD0iI2ZmZiIgZD0ibTExLjA3NyAxNSAuOTkxLTEuNDE2YS43NS43NSAwIDEgMSAxLjIyOS44NmwtMS4xNDggMS42NGEuNzQ4Ljc0OCAwIDAgMS0uMjE3LjIwNiA1LjI1MSA1LjI1MSAwIDAgMS04LjUwMy01Ljk1NS43NDEuNzQxIDAgMCAxIC4xMi0uMjc0bDEuMTQ3LTEuNjM5YS43NS43NSAwIDEgMSAxLjIyOC44Nkw0LjkzMyAxMC43bC4wMDYuMDAzYTMuNzUgMy43NSAwIDAgMCA2LjEzMiA0LjI5NGwuMDA2LjAwNHptNS40OTQtNS4zMzVhLjc0OC43NDggMCAwIDEtLjEyLjI3NGwtMS4xNDcgMS42MzlhLjc1Ljc1IDAgMSAxLTEuMjI4LS44NmwuODYtMS4yM2EzLjc1IDMuNzUgMCAwIDAtNi4xNDQtNC4zMDFsLS44NiAxLjIyOWEuNzUuNzUgMCAwIDEtMS4yMjktLjg2bDEuMTQ4LTEuNjRhLjc0OC43NDggMCAwIDEgLjIxNy0uMjA2IDUuMjUxIDUuMjUxIDAgMCAxIDguNTAzIDUuOTU1em0tNC41NjMtMi41MzJhLjc1Ljc1IDAgMCAxIC4xODQgMS4wNDVsLTMuMTU1IDQuNTA1YS43NS43NSAwIDEgMS0xLjIyOS0uODZsMy4xNTUtNC41MDZhLjc1Ljc1IDAgMCAxIDEuMDQ1LS4xODR6Ii8+PC9zdmc+");\n			background-size: 14px;\n			background-repeat: no-repeat;\n			background-position: center;\n			border-radius: 100%;\n\n			/*\n			* Use CSS math to simulate container queries.\n			* https://css-tricks.com/the-raven-technique-one-step-closer-to-container-queries/#what-about-showing-and-hiding-things\n			*/\n			overflow: hidden;\n			width: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n			height: calc(var(--ck-link-image-indicator-icon-is-visible) * var(--ck-link-image-indicator-icon-size));\n		}\n	}\n}\n\n'], sourceRoot: "" }]);
        const a = s2;
      }, 5730: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-editor__editable .ck-list-bogus-paragraph{display:block}", "", { version: 3, sources: ["webpack://./../ckeditor5-list/theme/documentlist.css"], names: [], mappings: "AAKA,8CACC,aACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-editor__editable .ck-list-bogus-paragraph {\n	display: block;\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4564: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-content ol{list-style-type:decimal}.ck-content ol ol{list-style-type:lower-latin}.ck-content ol ol ol{list-style-type:lower-roman}.ck-content ol ol ol ol{list-style-type:upper-latin}.ck-content ol ol ol ol ol{list-style-type:upper-roman}.ck-content ul{list-style-type:disc}.ck-content ul ul{list-style-type:circle}.ck-content ul ul ul,.ck-content ul ul ul ul{list-style-type:square}", "", { version: 3, sources: ["webpack://./../ckeditor5-list/theme/list.css"], names: [], mappings: "AAKA,eACC,uBAiBD,CAfC,kBACC,2BAaD,CAXC,qBACC,2BASD,CAPC,wBACC,2BAKD,CAHC,2BACC,2BACD,CAMJ,eACC,oBAaD,CAXC,kBACC,sBASD,CAJE,6CACC,sBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content ol {\n	list-style-type: decimal;\n\n	& ol {\n		list-style-type: lower-latin;\n\n		& ol {\n			list-style-type: lower-roman;\n\n			& ol {\n				list-style-type: upper-latin;\n\n				& ol {\n					list-style-type: upper-roman;\n				}\n			}\n		}\n	}\n}\n\n.ck-content ul {\n	list-style-type: disc;\n\n	& ul {\n		list-style-type: circle;\n\n		& ul {\n			list-style-type: square;\n\n			& ul {\n				list-style-type: square;\n			}\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 6082: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-list-properties.ck-list-properties_without-styles{padding:var(--ck-spacing-large)}.ck.ck-list-properties.ck-list-properties_without-styles>*{min-width:14em}.ck.ck-list-properties.ck-list-properties_without-styles>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-list-styles-list{grid-template-columns:repeat(4,auto)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible{border-top:1px solid var(--ck-color-base-border)}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*{width:100%}.ck.ck-list-properties.ck-list-properties_with-numbered-properties>.ck-collapsible>.ck-collapsible__children>*+*{margin-top:var(--ck-spacing-standard)}.ck.ck-list-properties .ck.ck-numbered-list-properties__start-index .ck-input{min-width:auto;width:100%}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order{background:transparent;margin-bottom:calc(var(--ck-spacing-tiny)*-1);padding-left:0;padding-right:0}.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:active,.ck.ck-list-properties .ck.ck-numbered-list-properties__reversed-order:hover{background:none;border-color:transparent;box-shadow:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-list/listproperties.css"], names: [], mappings: "AAOC,yDACC,+BASD,CAPC,2DACC,cAKD,CAHC,6DACC,qCACD,CASD,wFACC,oCACD,CAGA,mFACC,gDAWD,CARE,+GACC,UAKD,CAHC,iHACC,qCACD,CAMJ,8EACC,cAAe,CACf,UACD,CAEA,uEACC,sBAAuB,CAGvB,6CAAgD,CAFhD,cAAe,CACf,eAQD,CALC,2JAGC,eAAgB,CADhB,wBAAyB,CADzB,eAGD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-properties {\n	/* When there are no list styles and there is no collapsible. */\n	&.ck-list-properties_without-styles {\n		padding: var(--ck-spacing-large);\n\n		& > * {\n			min-width: 14em;\n\n			& + * {\n				margin-top: var(--ck-spacing-standard);\n			}\n		}\n	}\n\n	/*\n	 * When the numbered list property fields (start at, reversed) should be displayed,\n	 * more horizontal space is needed. Reconfigure the style grid to create that space.\n	 */\n	&.ck-list-properties_with-numbered-properties {\n		& > .ck-list-styles-list {\n			grid-template-columns: repeat( 4, auto );\n		}\n\n		/* When list styles are rendered and property fields are in a collapsible. */\n		& > .ck-collapsible {\n			border-top: 1px solid var(--ck-color-base-border);\n\n			& > .ck-collapsible__children {\n				& > * {\n					width: 100%;\n\n					& + * {\n						margin-top: var(--ck-spacing-standard);\n					}\n				}\n			}\n		}\n	}\n\n	& .ck.ck-numbered-list-properties__start-index .ck-input {\n		min-width: auto;\n		width: 100%;\n	}\n\n	& .ck.ck-numbered-list-properties__reversed-order {\n		background: transparent;\n		padding-left: 0;\n		padding-right: 0;\n		margin-bottom: calc(-1 * var(--ck-spacing-tiny));\n\n		&:active, &:hover {\n			box-shadow: none;\n			border-color: transparent;\n			background: none;\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 2417: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-list-styles-list{display:grid}:root{--ck-list-style-button-size:44px}.ck.ck-list-styles-list{column-gap:var(--ck-spacing-medium);grid-template-columns:repeat(3,auto);padding:var(--ck-spacing-large);row-gap:var(--ck-spacing-medium)}.ck.ck-list-styles-list .ck-button{box-sizing:content-box;margin:0;padding:0}.ck.ck-list-styles-list .ck-button,.ck.ck-list-styles-list .ck-button .ck-icon{height:var(--ck-list-style-button-size);width:var(--ck-list-style-button-size)}", "", { version: 3, sources: ["webpack://./../ckeditor5-list/theme/liststyles.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-list/liststyles.css"], names: [], mappings: "AAKA,wBACC,YACD,CCFA,MACC,gCACD,CAEA,wBAGC,mCAAoC,CAFpC,oCAAwC,CAGxC,+BAAgC,CAFhC,gCA4BD,CAxBC,mCAiBC,sBAAuB,CAPvB,QAAS,CANT,SAmBD,CAJC,+EAhBA,uCAAwC,CADxC,sCAoBA", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-list-styles-list {\n	display: grid;\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-list-style-button-size: 44px;\n}\n\n.ck.ck-list-styles-list {\n	grid-template-columns: repeat( 3, auto );\n	row-gap: var(--ck-spacing-medium);\n	column-gap: var(--ck-spacing-medium);\n	padding: var(--ck-spacing-large);\n\n	& .ck-button {\n		/* Make the button look like a thumbnail (the icon "takes it all"). */\n		width: var(--ck-list-style-button-size);\n		height: var(--ck-list-style-button-size);\n		padding: 0;\n\n		/*\n		 * Buttons are aligned by the grid so disable default button margins to not collide with the\n		 * gaps in the grid.\n		 */\n		margin: 0;\n\n		/*\n		 * Make sure the button border (which is displayed on focus, BTW) does not steal pixels\n		 * from the button dimensions and, as a result, decrease the size of the icon\n		 * (which becomes blurry as it scales down).\n		 */\n		box-sizing: content-box;\n\n		& .ck-icon {\n			width: var(--ck-list-style-button-size);\n			height: var(--ck-list-style-button-size);\n		}\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 1199: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ':root{--ck-todo-list-checkmark-size:16px}.ck-content .todo-list{list-style:none}.ck-content .todo-list li{margin-bottom:5px;position:relative}.ck-content .todo-list li .todo-list{margin-top:5px}.ck-content .todo-list .todo-list__label>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-content[dir=rtl] .todo-list .todo-list__label>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-content .todo-list .todo-list__label>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}.ck-content .todo-list .todo-list__label>input:after{border-color:transparent;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:content-box;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-content .todo-list .todo-list__label>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-content .todo-list .todo-list__label>input[checked]:after{border-color:#fff}.ck-content .todo-list .todo-list__label .todo-list__label__description{vertical-align:middle}.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}.ck-editor__editable.ck-content .todo-list .todo-list__label>input,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{cursor:pointer}.ck-editor__editable.ck-content .todo-list .todo-list__label>input:hover:before,.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:hover:before{box-shadow:0 0 0 5px rgba(0,0,0,.1)}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input{-webkit-appearance:none;border:0;display:inline-block;height:var(--ck-todo-list-checkmark-size);left:-25px;margin-left:0;margin-right:-15px;position:relative;right:0;vertical-align:middle;width:var(--ck-todo-list-checkmark-size)}.ck-editor__editable.ck-content[dir=rtl] .todo-list .todo-list__label>span[contenteditable=false]>input{left:0;margin-left:-15px;margin-right:0;right:-25px}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:before{border:1px solid #333;border-radius:2px;box-sizing:border-box;content:"";display:block;height:100%;position:absolute;transition:box-shadow .25s ease-in-out;width:100%}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input:after{border-color:transparent;border-style:solid;border-width:0 calc(var(--ck-todo-list-checkmark-size)/8) calc(var(--ck-todo-list-checkmark-size)/8) 0;box-sizing:content-box;content:"";display:block;height:calc(var(--ck-todo-list-checkmark-size)/2.6);left:calc(var(--ck-todo-list-checkmark-size)/3);pointer-events:none;position:absolute;top:calc(var(--ck-todo-list-checkmark-size)/5.3);transform:rotate(45deg);width:calc(var(--ck-todo-list-checkmark-size)/5.3)}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:before{background:#26ab33;border-color:#26ab33}.ck-editor__editable.ck-content .todo-list .todo-list__label>span[contenteditable=false]>input[checked]:after{border-color:#fff}.ck-editor__editable.ck-content .todo-list .todo-list__label.todo-list__label_without-description input[type=checkbox]{position:absolute}', "", { version: 3, sources: ["webpack://./../ckeditor5-list/theme/todolist.css"], names: [], mappings: "AAKA,MACC,kCACD,CAwEA,uBACC,eAwBD,CAtBC,0BAEC,iBAAkB,CADlB,iBAMD,CAHC,qCACC,cACD,CAIA,+CAlFD,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAiFC,CAFA,wDAhEA,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAgEA,CA5DD,sDAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UAKD,CAEA,qDAaC,wBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,sBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+DACC,kBAA8B,CAC9B,oBACD,CAEA,8DACC,iBACD,CAwBA,wEACC,qBACD,CAEA,mGACC,iBACD,CAYD,kKAEC,cAKD,CAHC,4LACC,mCACD,CAMD,+FApHA,uBAAwB,CAQxB,QAAS,CAPT,oBAAqB,CAGrB,yCAA0C,CAO1C,UAAW,CAGX,aAAc,CAFd,kBAAmB,CAVnB,iBAAkB,CAWlB,OAAQ,CARR,qBAAsB,CAFtB,wCAmHA,CAFA,wGAlGC,MAAO,CAGP,iBAAkB,CAFlB,cAAe,CACf,WAkGD,CA9FA,sGAOC,qBAAiC,CACjC,iBAAkB,CALlB,qBAAsB,CACtB,UAAW,CAHX,aAAc,CAKd,WAAY,CAJZ,iBAAkB,CAOlB,sCAAwC,CAJxC,UAKD,CAEA,qGAaC,wBAAyB,CADzB,kBAAmB,CAEnB,sGAA+G,CAX/G,sBAAuB,CAEvB,UAAW,CAJX,aAAc,CAUd,mDAAwD,CAHxD,+CAAoD,CAJpD,mBAAoB,CAFpB,iBAAkB,CAOlB,gDAAqD,CAMrD,uBAAwB,CALxB,kDAMD,CAGC,+GACC,kBAA8B,CAC9B,oBACD,CAEA,8GACC,iBACD,CA2DA,uHACC,iBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-todo-list-checkmark-size: 16px;\n}\n\n@define-mixin todo-list-checkbox {\n	-webkit-appearance: none;\n	display: inline-block;\n	position: relative;\n	width: var(--ck-todo-list-checkmark-size);\n	height: var(--ck-todo-list-checkmark-size);\n	vertical-align: middle;\n\n	/* Needed on iOS */\n	border: 0;\n\n	/* LTR styles */\n	left: -25px;\n	margin-right: -15px;\n	right: 0;\n	margin-left: 0;\n\n	/* RTL styles */\n	@nest [dir=rtl]& {\n		left: 0;\n		margin-right: 0;\n		right: -25px;\n		margin-left: -15px;\n	}\n\n	&::before {\n		display: block;\n		position: absolute;\n		box-sizing: border-box;\n		content: '';\n		width: 100%;\n		height: 100%;\n		border: 1px solid hsl(0, 0%, 20%);\n		border-radius: 2px;\n		transition: 250ms ease-in-out box-shadow;\n	}\n\n	&::after {\n		display: block;\n		position: absolute;\n		box-sizing: content-box;\n		pointer-events: none;\n		content: '';\n\n		/* Calculate tick position, size and border-width proportional to the checkmark size. */\n		left: calc( var(--ck-todo-list-checkmark-size) / 3 );\n		top: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n		width: calc( var(--ck-todo-list-checkmark-size) / 5.3 );\n		height: calc( var(--ck-todo-list-checkmark-size) / 2.6 );\n		border-style: solid;\n		border-color: transparent;\n		border-width: 0 calc( var(--ck-todo-list-checkmark-size) / 8 ) calc( var(--ck-todo-list-checkmark-size) / 8 ) 0;\n		transform: rotate(45deg);\n	}\n\n	&[checked] {\n		&::before {\n			background: hsl(126, 64%, 41%);\n			border-color: hsl(126, 64%, 41%);\n		}\n\n		&::after {\n			border-color: hsl(0, 0%, 100%);\n		}\n	}\n}\n\n/*\n * To-do list content styles.\n */\n.ck-content .todo-list {\n	list-style: none;\n\n	& li {\n		position: relative;\n		margin-bottom: 5px;\n\n		& .todo-list {\n			margin-top: 5px;\n		}\n	}\n\n	& .todo-list__label {\n		& > input {\n			@mixin todo-list-checkbox;\n		}\n\n		& .todo-list__label__description {\n			vertical-align: middle;\n		}\n\n		&.todo-list__label_without-description input[type=checkbox] {\n			position: absolute;\n		}\n	}\n}\n\n/*\n * To-do list editing view styles.\n */\n.ck-editor__editable.ck-content .todo-list .todo-list__label {\n	/*\n	 * To-do list should be interactive only during the editing\n	 * (https://github.com/ckeditor/ckeditor5/issues/2090).\n	 */\n	& > input,\n	& > span[contenteditable=false] > input {\n		cursor: pointer;\n\n		&:hover::before {\n			box-shadow: 0 0 0 5px hsla(0, 0%, 0%, 0.1);\n		}\n	}\n\n	/*\n	 * Document Lists - editing view has an additional span around checkbox.\n	 */\n	& > span[contenteditable=false] > input {\n		@mixin todo-list-checkbox;\n	}\n\n	&.todo-list__label_without-description {\n		& input[type=checkbox] {\n			position: absolute;\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4652: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-content .media{clear:both;display:block;margin:.9em 0;min-width:15em}", "", { version: 3, sources: ["webpack://./../ckeditor5-media-embed/theme/mediaembed.css"], names: [], mappings: "AAKA,mBAGC,UAAW,CASX,aAAc,CAJd,aAAe,CAQf,cACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-content .media {\n	/* Don\'t allow floated content overlap the media.\n	https://github.com/ckeditor/ckeditor5-media-embed/issues/53 */\n	clear: both;\n\n	/* Make sure there is some space between the content and the media. */\n	/* The first value should be equal to --ck-spacing-large variable if used in the editor context\n	to avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */\n	margin: 0.9em 0;\n\n	/* Make sure media is not overriden with Bootstrap default `flex` value.\n	See: https://github.com/ckeditor/ckeditor5/issues/1373. */\n	display: block;\n\n	/* Give the media some minimal width in the content to prevent them\n	from being "squashed" in tight spaces, e.g. in table cells (#44) */\n	min-width: 15em;\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 7442: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, '.ck-media__wrapper .ck-media__placeholder{align-items:center;display:flex;flex-direction:column}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url{max-width:100%;position:relative}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url .ck-media__placeholder__url__text{display:block;overflow:hidden}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon *,.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck-media__placeholder__icon *{display:none}.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper>:not(.ck-media__placeholder),.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder{pointer-events:none}:root{--ck-media-embed-placeholder-icon-size:3em;--ck-color-media-embed-placeholder-url-text:#757575;--ck-color-media-embed-placeholder-url-text-hover:var(--ck-color-base-text)}.ck-media__wrapper{margin:0 auto}.ck-media__wrapper .ck-media__placeholder{background:var(--ck-color-base-foreground);padding:calc(var(--ck-spacing-standard)*3)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon{background-position:50%;background-size:cover;height:var(--ck-media-embed-placeholder-icon-size);margin-bottom:var(--ck-spacing-large);min-width:var(--ck-media-embed-placeholder-icon-size)}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__icon .ck-icon{height:100%;width:100%}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text{color:var(--ck-color-media-embed-placeholder-url-text);font-style:italic;text-align:center;text-overflow:ellipsis;white-space:nowrap}.ck-media__wrapper .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:var(--ck-color-media-embed-placeholder-url-text-hover);cursor:pointer;text-decoration:underline}.ck-media__wrapper[data-oembed-url*="open.spotify.com"]{max-height:380px;max-width:300px}.ck-media__wrapper[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon,.ck-media__wrapper[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder{background:#4268b3}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAyNCIgaGVpZ2h0PSIxMDI0IiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxwYXRoIGQ9Ik05NjcuNDg0IDBINTYuNTE3QzI1LjMwNCAwIDAgMjUuMzA0IDAgNTYuNTE3djkxMC45NjZDMCA5OTguNjk0IDI1LjI5NyAxMDI0IDU2LjUyMiAxMDI0SDU0N1Y2MjhINDE0VjQ3M2gxMzNWMzU5LjAyOWMwLTEzMi4yNjIgODAuNzczLTIwNC4yODIgMTk4Ljc1Ni0yMDQuMjgyIDU2LjUxMyAwIDEwNS4wODYgNC4yMDggMTE5LjI0NCA2LjA4OVYyOTlsLTgxLjYxNi4wMzdjLTYzLjk5MyAwLTc2LjM4NCAzMC40OTItNzYuMzg0IDc1LjIzNlY0NzNoMTUzLjQ4N2wtMTkuOTg2IDE1NUg3MDd2Mzk2aDI2MC40ODRjMzEuMjEzIDAgNTYuNTE2LTI1LjMwMyA1Ni41MTYtNTYuNTE2VjU2LjUxNUMxMDI0IDI1LjMwMyA5OTguNjk3IDAgOTY3LjQ4NCAwIiBmaWxsPSIjRkZGRkZFIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#cdf}.ck-media__wrapper[data-oembed-url*="facebook.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder{background:linear-gradient(-135deg,#1400c7,#b800b1,#f50000)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,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)}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text{color:#ffe0fe}.ck-media__wrapper[data-oembed-url*="instagram.com"] .ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder{background:linear-gradient(90deg,#71c6f4,#0d70a5)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__icon{background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0MDAgNDAwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA0MDAgNDAwIiB4bWw6c3BhY2U9InByZXNlcnZlIj48cGF0aCBkPSJNNDAwIDIwMGMwIDExMC41LTg5LjUgMjAwLTIwMCAyMDBTMCAzMTAuNSAwIDIwMCA4OS41IDAgMjAwIDBzMjAwIDg5LjUgMjAwIDIwMHpNMTYzLjQgMzA1LjVjODguNyAwIDEzNy4yLTczLjUgMTM3LjItMTM3LjIgMC0yLjEgMC00LjItLjEtNi4yIDkuNC02LjggMTcuNi0xNS4zIDI0LjEtMjUtOC42IDMuOC0xNy45IDYuNC0yNy43IDcuNiAxMC02IDE3LjYtMTUuNCAyMS4yLTI2LjctOS4zIDUuNS0xOS42IDkuNS0zMC42IDExLjctOC44LTkuNC0yMS4zLTE1LjItMzUuMi0xNS4yLTI2LjYgMC00OC4yIDIxLjYtNDguMiA0OC4yIDAgMy44LjQgNy41IDEuMyAxMS00MC4xLTItNzUuNi0yMS4yLTk5LjQtNTAuNC00LjEgNy4xLTYuNSAxNS40LTYuNSAyNC4yIDAgMTYuNyA4LjUgMzEuNSAyMS41IDQwLjEtNy45LS4yLTE1LjMtMi40LTIxLjgtNnYuNmMwIDIzLjQgMTYuNiA0Mi44IDM4LjcgNDcuMy00IDEuMS04LjMgMS43LTEyLjcgMS43LTMuMSAwLTYuMS0uMy05LjEtLjkgNi4xIDE5LjIgMjMuOSAzMy4xIDQ1IDMzLjUtMTYuNSAxMi45LTM3LjMgMjAuNi01OS45IDIwLjYtMy45IDAtNy43LS4yLTExLjUtLjcgMjEuMSAxMy44IDQ2LjUgMjEuOCA3My43IDIxLjgiIHN0eWxlPSJmaWxsOiNmZmYiLz48L3N2Zz4=)}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text{color:#b8e6ff}.ck-media__wrapper[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder .ck-media__placeholder__url__text:hover{color:#fff}', "", { version: 3, sources: ["webpack://./../ckeditor5-media-embed/theme/mediaembedediting.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-media-embed/mediaembedediting.css"], names: [], mappings: "AAMC,0CAGC,kBAAmB,CAFnB,YAAa,CACb,qBAcD,CAXC,sEAEC,cAAe,CAEf,iBAMD,CAJC,wGAEC,aAAc,CADd,eAED,CAWD,6kBACC,YACD,CAYF,2LACC,mBACD,CC1CA,MACC,0CAA2C,CAE3C,mDAA4D,CAC5D,2EACD,CAEA,mBACC,aA+FD,CA7FC,0CAEC,0CAA2C,CAD3C,0CA6BD,CA1BC,uEAIC,uBAA2B,CAC3B,qBAAsB,CAHtB,kDAAmD,CACnD,qCAAsC,CAFtC,qDAUD,CAJC,gFAEC,WAAY,CADZ,UAED,CAGD,4EACC,sDAAuD,CAGvD,iBAAkB,CADlB,iBAAkB,CAElB,sBAAuB,CAHvB,kBAUD,CALC,kFACC,4DAA6D,CAC7D,cAAe,CACf,yBACD,CAIF,wDAEC,gBAAiB,CADjB,eAED,CAEA,4UAIC,wvGACD,CAEA,2EACC,kBAaD,CAXC,wGACC,orBACD,CAEA,6GACC,UAKD,CAHC,mHACC,UACD,CAIF,4EACC,2DAcD,CAZC,yGACC,4jHACD,CAGA,8GACC,aAKD,CAHC,oHACC,UACD,CAIF,6EAEC,iDAaD,CAXC,0GACC,wiCACD,CAEA,+GACC,aAKD,CAHC,qHACC,UACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck-media__wrapper {\n	& .ck-media__placeholder {\n		display: flex;\n		flex-direction: column;\n		align-items: center;\n\n		& .ck-media__placeholder__url {\n			/* Otherwise the URL will overflow when the content is very narrow. */\n			max-width: 100%;\n\n			position: relative;\n\n			& .ck-media__placeholder__url__text {\n				overflow: hidden;\n				display: block;\n			}\n		}\n	}\n\n	&[data-oembed-url*="twitter.com"],\n	&[data-oembed-url*="google.com/maps"],\n	&[data-oembed-url*="goo.gl/maps"],\n	&[data-oembed-url*="maps.google.com"],\n	&[data-oembed-url*="maps.app.goo.gl"],\n	&[data-oembed-url*="facebook.com"],\n	&[data-oembed-url*="instagram.com"] {\n		& .ck-media__placeholder__icon * {\n			display: none;\n		}\n	}\n}\n\n/* Disable all mouse interaction as long as the editor is not read\u2013only.\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/58 */\n.ck-editor__editable:not(.ck-read-only) .ck-media__wrapper > *:not(.ck-media__placeholder) {\n	pointer-events: none;\n}\n\n/* Disable all mouse interaction when the widget is not selected (e.g. to avoid opening links by accident).\n   https://github.com/ckeditor/ckeditor5-media-embed/issues/18 */\n.ck-editor__editable:not(.ck-read-only) .ck-widget:not(.ck-widget_selected) .ck-media__placeholder {\n	pointer-events: none;\n}\n', '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-media-embed-placeholder-icon-size: 3em;\n\n	--ck-color-media-embed-placeholder-url-text: hsl(0, 0%, 46%);\n	--ck-color-media-embed-placeholder-url-text-hover: var(--ck-color-base-text);\n}\n\n.ck-media__wrapper {\n	margin: 0 auto;\n\n	& .ck-media__placeholder {\n		padding: calc( 3 * var(--ck-spacing-standard) );\n		background: var(--ck-color-base-foreground);\n\n		& .ck-media__placeholder__icon {\n			min-width: var(--ck-media-embed-placeholder-icon-size);\n			height: var(--ck-media-embed-placeholder-icon-size);\n			margin-bottom: var(--ck-spacing-large);\n			background-position: center;\n			background-size: cover;\n\n			& .ck-icon {\n				width: 100%;\n				height: 100%;\n			}\n		}\n\n		& .ck-media__placeholder__url__text {\n			color: var(--ck-color-media-embed-placeholder-url-text);\n			white-space: nowrap;\n			text-align: center;\n			font-style: italic;\n			text-overflow: ellipsis;\n\n			&:hover {\n				color: var(--ck-color-media-embed-placeholder-url-text-hover);\n				cursor: pointer;\n				text-decoration: underline;\n			}\n		}\n	}\n\n	&[data-oembed-url*="open.spotify.com"] {\n		max-width: 300px;\n		max-height: 380px;\n	}\n\n	&[data-oembed-url*="google.com/maps"] .ck-media__placeholder__icon,\n	&[data-oembed-url*="goo.gl/maps"] .ck-media__placeholder__icon,\n	&[data-oembed-url*="maps.google.com"] .ck-media__placeholder__icon,\n	&[data-oembed-url*="maps.app.goo.gl"] .ck-media__placeholder__icon {\n		background-image: url(data:image/svg+xml;base64,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);\n	}\n\n	&[data-oembed-url*="facebook.com"] .ck-media__placeholder {\n		background: hsl(220, 46%, 48%);\n\n		& .ck-media__placeholder__icon {\n			background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSIxMDI0cHgiIGhlaWdodD0iMTAyNHB4IiB2aWV3Qm94PSIwIDAgMTAyNCAxMDI0IiB2ZXJzaW9uPSIxLjEiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiPiAgICAgICAgPHRpdGxlPkZpbGwgMTwvdGl0bGU+ICAgIDxkZXNjPkNyZWF0ZWQgd2l0aCBTa2V0Y2guPC9kZXNjPiAgICA8ZGVmcz48L2RlZnM+ICAgIDxnIGlkPSJQYWdlLTEiIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPiAgICAgICAgPGcgaWQ9ImZMb2dvX1doaXRlIiBmaWxsPSIjRkZGRkZFIj4gICAgICAgICAgICA8cGF0aCBkPSJNOTY3LjQ4NCwwIEw1Ni41MTcsMCBDMjUuMzA0LDAgMCwyNS4zMDQgMCw1Ni41MTcgTDAsOTY3LjQ4MyBDMCw5OTguNjk0IDI1LjI5NywxMDI0IDU2LjUyMiwxMDI0IEw1NDcsMTAyNCBMNTQ3LDYyOCBMNDE0LDYyOCBMNDE0LDQ3MyBMNTQ3LDQ3MyBMNTQ3LDM1OS4wMjkgQzU0NywyMjYuNzY3IDYyNy43NzMsMTU0Ljc0NyA3NDUuNzU2LDE1NC43NDcgQzgwMi4yNjksMTU0Ljc0NyA4NTAuODQyLDE1OC45NTUgODY1LDE2MC44MzYgTDg2NSwyOTkgTDc4My4zODQsMjk5LjAzNyBDNzE5LjM5MSwyOTkuMDM3IDcwNywzMjkuNTI5IDcwNywzNzQuMjczIEw3MDcsNDczIEw4NjAuNDg3LDQ3MyBMODQwLjUwMSw2MjggTDcwNyw2MjggTDcwNywxMDI0IEw5NjcuNDg0LDEwMjQgQzk5OC42OTcsMTAyNCAxMDI0LDk5OC42OTcgMTAyNCw5NjcuNDg0IEwxMDI0LDU2LjUxNSBDMTAyNCwyNS4zMDMgOTk4LjY5NywwIDk2Ny40ODQsMCIgaWQ9IkZpbGwtMSI+PC9wYXRoPiAgICAgICAgPC9nPiAgICA8L2c+PC9zdmc+);\n		}\n\n		& .ck-media__placeholder__url__text {\n			color: hsl(220, 100%, 90%);\n\n			&:hover {\n				color: hsl(0, 0%, 100%);\n			}\n		}\n	}\n\n	&[data-oembed-url*="instagram.com"] .ck-media__placeholder {\n		background: linear-gradient(-135deg,hsl(246, 100%, 39%),hsl(302, 100%, 36%),hsl(0, 100%, 48%));\n\n		& .ck-media__placeholder__icon {\n			background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz48c3ZnIHdpZHRoPSI1MDRweCIgaGVpZ2h0PSI1MDRweCIgdmlld0JveD0iMCAwIDUwNCA1MDQiIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+ICAgICAgICA8dGl0bGU+Z2x5cGgtbG9nb19NYXkyMDE2PC90aXRsZT4gICAgPGRlc2M+Q3JlYXRlZCB3aXRoIFNrZXRjaC48L2Rlc2M+ICAgIDxkZWZzPiAgICAgICAgPHBvbHlnb24gaWQ9InBhdGgtMSIgcG9pbnRzPSIwIDAuMTU5IDUwMy44NDEgMC4xNTkgNTAzLjg0MSA1MDMuOTQgMCA1MDMuOTQiPjwvcG9seWdvbj4gICAgPC9kZWZzPiAgICA8ZyBpZD0iZ2x5cGgtbG9nb19NYXkyMDE2IiBzdHJva2U9Im5vbmUiIHN0cm9rZS13aWR0aD0iMSIgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4gICAgICAgIDxnIGlkPSJHcm91cC0zIj4gICAgICAgICAgICA8bWFzayBpZD0ibWFzay0yIiBmaWxsPSJ3aGl0ZSI+ICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI3BhdGgtMSI+PC91c2U+ICAgICAgICAgICAgPC9tYXNrPiAgICAgICAgICAgIDxnIGlkPSJDbGlwLTIiPjwvZz4gICAgICAgICAgICA8cGF0aCBkPSJNMjUxLjkyMSwwLjE1OSBDMTgzLjUwMywwLjE1OSAxNzQuOTI0LDAuNDQ5IDE0OC4wNTQsMS42NzUgQzEyMS4yNCwyLjg5OCAxMDIuOTI3LDcuMTU3IDg2LjkwMywxMy4zODUgQzcwLjMzNywxOS44MjIgNTYuMjg4LDI4LjQzNiA0Mi4yODIsNDIuNDQxIEMyOC4yNzcsNTYuNDQ3IDE5LjY2Myw3MC40OTYgMTMuMjI2LDg3LjA2MiBDNi45OTgsMTAzLjA4NiAyLjczOSwxMjEuMzk5IDEuNTE2LDE0OC4yMTMgQzAuMjksMTc1LjA4MyAwLDE4My42NjIgMCwyNTIuMDggQzAsMzIwLjQ5NyAwLjI5LDMyOS4wNzYgMS41MTYsMzU1Ljk0NiBDMi43MzksMzgyLjc2IDYuOTk4LDQwMS4wNzMgMTMuMjI2LDQxNy4wOTcgQzE5LjY2Myw0MzMuNjYzIDI4LjI3Nyw0NDcuNzEyIDQyLjI4Miw0NjEuNzE4IEM1Ni4yODgsNDc1LjcyMyA3MC4zMzcsNDg0LjMzNyA4Ni45MDMsNDkwLjc3NSBDMTAyLjkyNyw0OTcuMDAyIDEyMS4yNCw1MDEuMjYxIDE0OC4wNTQsNTAyLjQ4NCBDMTc0LjkyNCw1MDMuNzEgMTgzLjUwMyw1MDQgMjUxLjkyMSw1MDQgQzMyMC4zMzgsNTA0IDMyOC45MTcsNTAzLjcxIDM1NS43ODcsNTAyLjQ4NCBDMzgyLjYwMSw1MDEuMjYxIDQwMC45MTQsNDk3LjAwMiA0MTYuOTM4LDQ5MC43NzUgQzQzMy41MDQsNDg0LjMzNyA0NDcuNTUzLDQ3NS43MjMgNDYxLjU1OSw0NjEuNzE4IEM0NzUuNTY0LDQ0Ny43MTIgNDg0LjE3OCw0MzMuNjYzIDQ5MC42MTYsNDE3LjA5NyBDNDk2Ljg0Myw0MDEuMDczIDUwMS4xMDIsMzgyLjc2IDUwMi4zMjUsMzU1Ljk0NiBDNTAzLjU1MSwzMjkuMDc2IDUwMy44NDEsMzIwLjQ5NyA1MDMuODQxLDI1Mi4wOCBDNTAzLjg0MSwxODMuNjYyIDUwMy41NTEsMTc1LjA4MyA1MDIuMzI1LDE0OC4yMTMgQzUwMS4xMDIsMTIxLjM5OSA0OTYuODQzLDEwMy4wODYgNDkwLjYxNiw4Ny4wNjIgQzQ4NC4xNzgsNzAuNDk2IDQ3NS41NjQsNTYuNDQ3IDQ2MS41NTksNDIuNDQxIEM0NDcuNTUzLDI4LjQzNiA0MzMuNTA0LDE5LjgyMiA0MTYuOTM4LDEzLjM4NSBDNDAwLjkxNCw3LjE1NyAzODIuNjAxLDIuODk4IDM1NS43ODcsMS42NzUgQzMyOC45MTcsMC40NDkgMzIwLjMzOCwwLjE1OSAyNTEuOTIxLDAuMTU5IFogTTI1MS45MjEsNDUuNTUgQzMxOS4xODYsNDUuNTUgMzI3LjE1NCw0NS44MDcgMzUzLjcxOCw0Ny4wMTkgQzM3OC4yOCw0OC4xMzkgMzkxLjYxOSw1Mi4yNDMgNDAwLjQ5Niw1NS42OTMgQzQxMi4yNTUsNjAuMjYzIDQyMC42NDcsNjUuNzIyIDQyOS40NjIsNzQuNTM4IEM0MzguMjc4LDgzLjM1MyA0NDMuNzM3LDkxLjc0NSA0NDguMzA3LDEwMy41MDQgQzQ1MS43NTcsMTEyLjM4MSA0NTUuODYxLDEyNS43MiA0NTYuOTgxLDE1MC4yODIgQzQ1OC4xOTMsMTc2Ljg0NiA0NTguNDUsMTg0LjgxNCA0NTguNDUsMjUyLjA4IEM0NTguNDUsMzE5LjM0NSA0NTguMTkzLDMyNy4zMTMgNDU2Ljk4MSwzNTMuODc3IEM0NTUuODYxLDM3OC40MzkgNDUxLjc1NywzOTEuNzc4IDQ0OC4zMDcsNDAwLjY1NSBDNDQzLjczNyw0MTIuNDE0IDQzOC4yNzgsNDIwLjgwNiA0MjkuNDYyLDQyOS42MjEgQzQyMC42NDcsNDM4LjQzNyA0MTIuMjU1LDQ0My44OTYgNDAwLjQ5Niw0NDguNDY2IEMzOTEuNjE5LDQ1MS45MTYgMzc4LjI4LDQ1Ni4wMiAzNTMuNzE4LDQ1Ny4xNCBDMzI3LjE1OCw0NTguMzUyIDMxOS4xOTEsNDU4LjYwOSAyNTEuOTIxLDQ1OC42MDkgQzE4NC42NSw0NTguNjA5IDE3Ni42ODQsNDU4LjM1MiAxNTAuMTIzLDQ1Ny4xNCBDMTI1LjU2MSw0NTYuMDIgMTEyLjIyMiw0NTEuOTE2IDEwMy4zNDUsNDQ4LjQ2NiBDOTEuNTg2LDQ0My44OTYgODMuMTk0LDQzOC40MzcgNzQuMzc5LDQyOS42MjEgQzY1LjU2NCw0MjAuODA2IDYwLjEwNCw0MTIuNDE0IDU1LjUzNCw0MDAuNjU1IEM1Mi4wODQsMzkxLjc3OCA0Ny45OCwzNzguNDM5IDQ2Ljg2LDM1My44NzcgQzQ1LjY0OCwzMjcuMzEzIDQ1LjM5MSwzMTkuMzQ1IDQ1LjM5MSwyNTIuMDggQzQ1LjM5MSwxODQuODE0IDQ1LjY0OCwxNzYuODQ2IDQ2Ljg2LDE1MC4yODIgQzQ3Ljk4LDEyNS43MiA1Mi4wODQsMTEyLjM4MSA1NS41MzQsMTAzLjUwNCBDNjAuMTA0LDkxLjc0NSA2NS41NjMsODMuMzUzIDc0LjM3OSw3NC41MzggQzgzLjE5NCw2NS43MjIgOTEuNTg2LDYwLjI2MyAxMDMuMzQ1LDU1LjY5MyBDMTEyLjIyMiw1Mi4yNDMgMTI1LjU2MSw0OC4xMzkgMTUwLjEyMyw0Ny4wMTkgQzE3Ni42ODcsNDUuODA3IDE4NC42NTUsNDUuNTUgMjUxLjkyMSw0NS41NSBaIiBpZD0iRmlsbC0xIiBmaWxsPSIjRkZGRkZGIiBtYXNrPSJ1cmwoI21hc2stMikiPjwvcGF0aD4gICAgICAgIDwvZz4gICAgICAgIDxwYXRoIGQ9Ik0yNTEuOTIxLDMzNi4wNTMgQzIwNS41NDMsMzM2LjA1MyAxNjcuOTQ3LDI5OC40NTcgMTY3Ljk0NywyNTIuMDggQzE2Ny45NDcsMjA1LjcwMiAyMDUuNTQzLDE2OC4xMDYgMjUxLjkyMSwxNjguMTA2IEMyOTguMjk4LDE2OC4xMDYgMzM1Ljg5NCwyMDUuNzAyIDMzNS44OTQsMjUyLjA4IEMzMzUuODk0LDI5OC40NTcgMjk4LjI5OCwzMzYuMDUzIDI1MS45MjEsMzM2LjA1MyBaIE0yNTEuOTIxLDEyMi43MTUgQzE4MC40NzQsMTIyLjcxNSAxMjIuNTU2LDE4MC42MzMgMTIyLjU1NiwyNTIuMDggQzEyMi41NTYsMzIzLjUyNiAxODAuNDc0LDM4MS40NDQgMjUxLjkyMSwzODEuNDQ0IEMzMjMuMzY3LDM4MS40NDQgMzgxLjI4NSwzMjMuNTI2IDM4MS4yODUsMjUyLjA4IEMzODEuMjg1LDE4MC42MzMgMzIzLjM2NywxMjIuNzE1IDI1MS45MjEsMTIyLjcxNSBaIiBpZD0iRmlsbC00IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+ICAgICAgICA8cGF0aCBkPSJNNDE2LjYyNywxMTcuNjA0IEM0MTYuNjI3LDEzNC4zIDQwMy4wOTIsMTQ3LjgzNCAzODYuMzk2LDE0Ny44MzQgQzM2OS43MDEsMTQ3LjgzNCAzNTYuMTY2LDEzNC4zIDM1Ni4xNjYsMTE3LjYwNCBDMzU2LjE2NiwxMDAuOTA4IDM2OS43MDEsODcuMzczIDM4Ni4zOTYsODcuMzczIEM0MDMuMDkyLDg3LjM3MyA0MTYuNjI3LDEwMC45MDggNDE2LjYyNywxMTcuNjA0IiBpZD0iRmlsbC01IiBmaWxsPSIjRkZGRkZGIj48L3BhdGg+ICAgIDwvZz48L3N2Zz4=);\n		}\n\n		/* stylelint-disable-next-line no-descending-specificity */\n		& .ck-media__placeholder__url__text {\n			color: hsl(302, 100%, 94%);\n\n			&:hover {\n				color: hsl(0, 0%, 100%);\n			}\n		}\n	}\n\n	&[data-oembed-url*="twitter.com"] .ck.ck-media__placeholder {\n		/* Use gradient to contrast with focused widget (ckeditor/ckeditor5-media-embed#22). */\n		background: linear-gradient( to right, hsl(201, 85%, 70%), hsl(201, 85%, 35%) );\n\n		& .ck-media__placeholder__icon {\n			background-image: url(data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz48c3ZnIHZlcnNpb249IjEuMSIgaWQ9IldoaXRlIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCIgdmlld0JveD0iMCAwIDQwMCA0MDAiIHN0eWxlPSJlbmFibGUtYmFja2dyb3VuZDpuZXcgMCAwIDQwMCA0MDA7IiB4bWw6c3BhY2U9InByZXNlcnZlIj48c3R5bGUgdHlwZT0idGV4dC9jc3MiPi5zdDB7ZmlsbDojRkZGRkZGO308L3N0eWxlPjxwYXRoIGNsYXNzPSJzdDAiIGQ9Ik00MDAsMjAwYzAsMTEwLjUtODkuNSwyMDAtMjAwLDIwMFMwLDMxMC41LDAsMjAwUzg5LjUsMCwyMDAsMFM0MDAsODkuNSw0MDAsMjAweiBNMTYzLjQsMzA1LjVjODguNywwLDEzNy4yLTczLjUsMTM3LjItMTM3LjJjMC0yLjEsMC00LjItMC4xLTYuMmM5LjQtNi44LDE3LjYtMTUuMywyNC4xLTI1Yy04LjYsMy44LTE3LjksNi40LTI3LjcsNy42YzEwLTYsMTcuNi0xNS40LDIxLjItMjYuN2MtOS4zLDUuNS0xOS42LDkuNS0zMC42LDExLjdjLTguOC05LjQtMjEuMy0xNS4yLTM1LjItMTUuMmMtMjYuNiwwLTQ4LjIsMjEuNi00OC4yLDQ4LjJjMCwzLjgsMC40LDcuNSwxLjMsMTFjLTQwLjEtMi03NS42LTIxLjItOTkuNC01MC40Yy00LjEsNy4xLTYuNSwxNS40LTYuNSwyNC4yYzAsMTYuNyw4LjUsMzEuNSwyMS41LDQwLjFjLTcuOS0wLjItMTUuMy0yLjQtMjEuOC02YzAsMC4yLDAsMC40LDAsMC42YzAsMjMuNCwxNi42LDQyLjgsMzguNyw0Ny4zYy00LDEuMS04LjMsMS43LTEyLjcsMS43Yy0zLjEsMC02LjEtMC4zLTkuMS0wLjljNi4xLDE5LjIsMjMuOSwzMy4xLDQ1LDMzLjVjLTE2LjUsMTIuOS0zNy4zLDIwLjYtNTkuOSwyMC42Yy0zLjksMC03LjctMC4yLTExLjUtMC43QzExMC44LDI5Ny41LDEzNi4yLDMwNS41LDE2My40LDMwNS41Ii8+PC9zdmc+);\n		}\n\n		& .ck-media__placeholder__url__text {\n			color: hsl(201, 100%, 86%);\n\n			&:hover {\n				color: hsl(0, 0%, 100%);\n			}\n		}\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 9292: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-media-form{align-items:flex-start;display:flex;flex-direction:row;flex-wrap:nowrap}.ck.ck-media-form .ck-labeled-field-view{display:inline-block}.ck.ck-media-form .ck-label{display:none}@media screen and (max-width:600px){.ck.ck-media-form{flex-wrap:wrap}.ck.ck-media-form .ck-labeled-field-view{flex-basis:100%}.ck.ck-media-form .ck-button{flex-basis:50%}}", "", { version: 3, sources: ["webpack://./../ckeditor5-media-embed/theme/mediaform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css"], names: [], mappings: "AAOA,kBAEC,sBAAuB,CADvB,YAAa,CAEb,kBAAmB,CACnB,gBAqBD,CAnBC,yCACC,oBACD,CAEA,4BACC,YACD,CCbA,oCDCD,kBAeE,cAUF,CARE,yCACC,eACD,CAEA,6BACC,cACD,CCtBD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck.ck-media-form {\n	display: flex;\n	align-items: flex-start;\n	flex-direction: row;\n	flex-wrap: nowrap;\n\n	& .ck-labeled-field-view {\n		display: inline-block;\n	}\n\n	& .ck-label {\n		display: none;\n	}\n\n	@mixin ck-media-phone {\n		flex-wrap: wrap;\n\n		& .ck-labeled-field-view {\n			flex-basis: 100%;\n		}\n\n		& .ck-button {\n			flex-basis: 50%;\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n	@media screen and (max-width: 600px) {\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 7368: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-input-color{display:flex;flex-direction:row-reverse;width:100%}.ck.ck-input-color>input.ck.ck-input-text{flex-grow:1;min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown{min-width:auto}.ck.ck-input-color>div.ck.ck-dropdown>.ck-input-color__button .ck-dropdown__arrow{display:none}.ck.ck-input-color .ck.ck-input-color__button{display:flex}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview{overflow:hidden;position:relative}.ck.ck-input-color .ck.ck-input-color__button .ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{display:block;position:absolute}[dir=ltr] .ck.ck-input-color>.ck.ck-input-text{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-input-text{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-input-color>.ck.ck-input-text:focus{z-index:0}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{padding:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-left-radius:0;border-top-left-radius:0}[dir=ltr] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-left:1px solid transparent}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button{border-bottom-right-radius:0;border-top-right-radius:0}[dir=rtl] .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button:not(:focus){border-right:1px solid transparent}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button.ck-disabled{background:var(--ck-color-input-disabled-background)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border-radius:0}.ck-rounded-corners .ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview,.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview{border:1px solid var(--ck-color-input-border);height:20px;width:20px}.ck.ck-input-color>.ck.ck-dropdown>.ck.ck-button.ck-input-color__button>.ck.ck-input-color__button__preview>.ck.ck-input-color__button__preview__no-color-indicator{background:red;border-radius:2px;height:150%;left:50%;top:-30%;transform:rotate(45deg);transform-origin:50%;width:8%}.ck.ck-input-color .ck.ck-input-color__remove-color{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard);width:100%}.ck.ck-input-color .ck.ck-input-color__remove-color:not(:focus){border-bottom:1px solid var(--ck-color-input-border)}[dir=ltr] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-right-radius:0}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color{border-top-left-radius:0}.ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-input-color .ck.ck-input-color__remove-color .ck.ck-icon{margin-left:var(--ck-spacing-standard);margin-right:0}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/colorinput.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/colorinput.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAKA,mBAEC,YAAa,CACb,0BAA2B,CAF3B,UAgCD,CA5BC,0CAEC,WAAY,CADZ,cAED,CAEA,sCACC,cAMD,CAHC,kFACC,YACD,CAGD,8CAEC,YAWD,CATC,kFAEC,eAAgB,CADhB,iBAOD,CAJC,0IAEC,aAAc,CADd,iBAED,CC1BF,+CAGE,4BAA6B,CAD7B,yBAcF,CAhBA,+CAQE,2BAA4B,CAD5B,wBASF,CAHC,2CACC,SACD,CAIA,wEACC,SA0CD,CA3CA,kFAKE,2BAA4B,CAD5B,wBAuCF,CApCE,8FACC,iCACD,CATF,kFAcE,4BAA6B,CAD7B,yBA8BF,CA3BE,8FACC,kCACD,CAGD,oFACC,oDACD,CAEA,4GC1CF,eD2DE,CAjBA,+PCtCD,qCDuDC,CAjBA,4GAKC,6CAA8C,CAD9C,WAAY,CADZ,UAcD,CAVC,oKAKC,cAA6B,CAC7B,iBAAkB,CAHlB,WAAY,CADZ,QAAS,CADT,QAAS,CAMT,uBAAwB,CACxB,oBAAqB,CAJrB,QAKD,CAKH,oDAIC,2BAA4B,CAC5B,4BAA6B,CAH7B,qEAAwE,CADxE,UA0BD,CApBC,gEACC,oDACD,CATD,8DAYE,yBAeF,CA3BA,8DAgBE,wBAWF,CARC,gEACC,uCAMD,CAPA,0EAKE,sCAAuC,CADvC,cAGF", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-input-color {\n	width: 100%;\n	display: flex;\n	flex-direction: row-reverse;\n\n	& > input.ck.ck-input-text {\n		min-width: auto;\n		flex-grow: 1;\n	}\n\n	& > div.ck.ck-dropdown {\n		min-width: auto;\n\n		/* This dropdown has no arrow but a color preview instead. */\n		& > .ck-input-color__button .ck-dropdown__arrow {\n			display: none;\n		}\n	}\n\n	& .ck.ck-input-color__button {\n		/* Resolving issue with misaligned buttons on Safari (see #10589) */\n		display: flex;\n\n		& .ck.ck-input-color__button__preview {\n			position: relative;\n			overflow: hidden;\n\n			& > .ck.ck-input-color__button__preview__no-color-indicator {\n				position: absolute;\n				display: block;\n			}\n		}\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n@import "../mixins/_rounded.css";\n\n.ck.ck-input-color {\n	& > .ck.ck-input-text {\n		@mixin ck-dir ltr {\n			border-top-right-radius: 0;\n			border-bottom-right-radius: 0;\n		}\n\n		@mixin ck-dir rtl {\n			border-top-left-radius: 0;\n			border-bottom-left-radius: 0;\n		}\n\n		/* Make sure the focused input is always on top of the dropdown button so its\n		   outline and border are never cropped (also when the input is read-only). */\n		&:focus {\n			z-index: 0;\n		}\n	}\n\n	& > .ck.ck-dropdown {\n		& > .ck.ck-button.ck-input-color__button {\n			padding: 0;\n\n			@mixin ck-dir ltr {\n				border-top-left-radius: 0;\n				border-bottom-left-radius: 0;\n\n				&:not(:focus) {\n					border-left: 1px solid transparent;\n				}\n			}\n\n			@mixin ck-dir rtl {\n				border-top-right-radius: 0;\n				border-bottom-right-radius: 0;\n\n				&:not(:focus) {\n					border-right: 1px solid transparent;\n				}\n			}\n\n			&.ck-disabled {\n				background: var(--ck-color-input-disabled-background);\n			}\n\n			& > .ck.ck-input-color__button__preview {\n				@mixin ck-rounded-corners;\n\n				width: 20px;\n				height: 20px;\n				border: 1px solid var(--ck-color-input-border);\n\n				& > .ck.ck-input-color__button__preview__no-color-indicator {\n					top: -30%;\n					left: 50%;\n					height: 150%;\n					width: 8%;\n					background: hsl(0, 100%, 50%);\n					border-radius: 2px;\n					transform: rotate(45deg);\n					transform-origin: 50%;\n				}\n			}\n		}\n	}\n\n	& .ck.ck-input-color__remove-color {\n		width: 100%;\n		padding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n\n		border-bottom-left-radius: 0;\n		border-bottom-right-radius: 0;\n\n		&:not(:focus) {\n			border-bottom: 1px solid var(--ck-color-input-border);\n		}\n\n		@mixin ck-dir ltr {\n			border-top-right-radius: 0;\n		}\n\n		@mixin ck-dir rtl {\n			border-top-left-radius: 0;\n		}\n\n		& .ck.ck-icon {\n			margin-right: var(--ck-spacing-standard);\n\n			@mixin ck-dir rtl {\n				margin-right: 0;\n				margin-left: var(--ck-spacing-standard);\n			}\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4070: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-form{padding:0 0 var(--ck-spacing-large)}.ck.ck-form:focus{outline:none}.ck.ck-form .ck.ck-input-text{min-width:100%;width:0}.ck.ck-form .ck.ck-dropdown{min-width:100%}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button:not(:focus){border:1px solid var(--ck-color-base-border)}.ck.ck-form .ck.ck-dropdown .ck-dropdown__button .ck-button__label{width:100%}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/form.css"], names: [], mappings: "AAKA,YACC,mCAyBD,CAvBC,kBAEC,YACD,CAEA,8BACC,cAAe,CACf,OACD,CAEA,4BACC,cAWD,CARE,6DACC,4CACD,CAEA,mEACC,UACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form {\n	padding: 0 0 var(--ck-spacing-large);\n\n	&:focus {\n		/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n		outline: none;\n	}\n\n	& .ck.ck-input-text {\n		min-width: 100%;\n		width: 0;\n	}\n\n	& .ck.ck-dropdown {\n		min-width: 100%;\n\n		& .ck-dropdown__button {\n			&:not(:focus) {\n				border: 1px solid var(--ck-color-base-border);\n			}\n\n			& .ck-button__label {\n				width: 100%;\n			}\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 9247: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-form__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__row>:not(.ck-label){flex-grow:1}.ck.ck-form__row.ck-table-form__action-row .ck-button-cancel,.ck.ck-form__row.ck-table-form__action-row .ck-button-save{justify-content:center}.ck.ck-form__row{padding:var(--ck-spacing-standard) var(--ck-spacing-large) 0}[dir=ltr] .ck.ck-form__row>:not(.ck-label)+*{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-form__row>:not(.ck-label)+*{margin-right:var(--ck-spacing-large)}.ck.ck-form__row>.ck-label{min-width:100%;width:100%}.ck.ck-form__row.ck-table-form__action-row{margin-top:var(--ck-spacing-large)}.ck.ck-form__row.ck-table-form__action-row .ck-button .ck-button__label{color:var(--ck-color-text)}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/formrow.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/formrow.css"], names: [], mappings: "AAKA,iBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAaD,CAVC,iCACC,WACD,CAGC,wHAEC,sBACD,CCbF,iBACC,4DA2BD,CAvBE,6CAEE,mCAMF,CARA,6CAME,oCAEF,CAGD,2BAEC,cAAe,CADf,UAED,CAEA,2CACC,kCAKD,CAHC,wEACC,0BACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__row {\n	display: flex;\n	flex-direction: row;\n	flex-wrap: nowrap;\n	justify-content: space-between;\n\n	/* Ignore labels that work as fieldset legends */\n	& > *:not(.ck-label) {\n		flex-grow: 1;\n	}\n\n	&.ck-table-form__action-row {\n		& .ck-button-save,\n		& .ck-button-cancel {\n			justify-content: center;\n		}\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-form__row {\n	padding: var(--ck-spacing-standard) var(--ck-spacing-large) 0;\n\n	/* Ignore labels that work as fieldset legends */\n	& > *:not(.ck-label) {\n		& + * {\n			@mixin ck-dir ltr {\n				margin-left: var(--ck-spacing-large);\n			}\n\n			@mixin ck-dir rtl {\n				margin-right: var(--ck-spacing-large);\n			}\n		}\n	}\n\n	& > .ck-label {\n		width: 100%;\n		min-width: 100%;\n	}\n\n	&.ck-table-form__action-row {\n		margin-top: var(--ck-spacing-large);\n\n		& .ck-button .ck-button__label {\n			color: var(--ck-color-text);\n		}\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 1613: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck .ck-insert-table-dropdown__grid{display:flex;flex-direction:row;flex-wrap:wrap}:root{--ck-insert-table-dropdown-padding:10px;--ck-insert-table-dropdown-box-height:11px;--ck-insert-table-dropdown-box-width:12px;--ck-insert-table-dropdown-box-margin:1px}.ck .ck-insert-table-dropdown__grid{padding:var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;width:calc(var(--ck-insert-table-dropdown-box-width)*10 + var(--ck-insert-table-dropdown-box-margin)*20 + var(--ck-insert-table-dropdown-padding)*2)}.ck .ck-insert-table-dropdown__label,.ck[dir=rtl] .ck-insert-table-dropdown__label{text-align:center}.ck .ck-insert-table-dropdown-grid-box{border:1px solid var(--ck-color-base-border);border-radius:1px;margin:var(--ck-insert-table-dropdown-box-margin);min-height:var(--ck-insert-table-dropdown-box-height);min-width:var(--ck-insert-table-dropdown-box-width);outline:none;transition:none}.ck .ck-insert-table-dropdown-grid-box:focus{box-shadow:none}.ck .ck-insert-table-dropdown-grid-box.ck-on{background:var(--ck-color-focus-outer-shadow);border-color:var(--ck-color-focus-border)}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/inserttable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/inserttable.css"], names: [], mappings: "AAKA,oCACC,YAAa,CACb,kBAAmB,CACnB,cACD,CCJA,MACC,uCAAwC,CACxC,0CAA2C,CAC3C,yCAA0C,CAC1C,yCACD,CAEA,oCAGC,yFAA0F,CAD1F,oJAED,CAEA,mFAEC,iBACD,CAEA,uCAIC,4CAA6C,CAC7C,iBAAkB,CAFlB,iDAAkD,CADlD,qDAAsD,CADtD,mDAAoD,CAKpD,YAAa,CACb,eAUD,CARC,6CACC,eACD,CAEA,6CAEC,6CAA8C,CAD9C,yCAED", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-insert-table-dropdown__grid {\n	display: flex;\n	flex-direction: row;\n	flex-wrap: wrap;\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-insert-table-dropdown-padding: 10px;\n	--ck-insert-table-dropdown-box-height: 11px;\n	--ck-insert-table-dropdown-box-width: 12px;\n	--ck-insert-table-dropdown-box-margin: 1px;\n}\n\n.ck .ck-insert-table-dropdown__grid {\n	/* The width of a container should match 10 items in a row so there will be a 10x10 grid. */\n	width: calc(var(--ck-insert-table-dropdown-box-width) * 10 + var(--ck-insert-table-dropdown-box-margin) * 20 + var(--ck-insert-table-dropdown-padding) * 2);\n	padding: var(--ck-insert-table-dropdown-padding) var(--ck-insert-table-dropdown-padding) 0;\n}\n\n.ck .ck-insert-table-dropdown__label,\n.ck[dir=rtl] .ck-insert-table-dropdown__label {\n	text-align: center;\n}\n\n.ck .ck-insert-table-dropdown-grid-box {\n	min-width: var(--ck-insert-table-dropdown-box-width);\n	min-height: var(--ck-insert-table-dropdown-box-height);\n	margin: var(--ck-insert-table-dropdown-box-margin);\n	border: 1px solid var(--ck-color-base-border);\n	border-radius: 1px;\n	outline: none;\n	transition: none;\n\n	&:focus {\n		box-shadow: none;\n	}\n\n	&.ck-on {\n		border-color: var(--ck-color-focus-border);\n		background: var(--ck-color-focus-outer-shadow);\n	}\n}\n\n"], sourceRoot: "" }]);
        const a = s2;
      }, 6306: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-content .table{display:table;margin:.9em auto}.ck-content .table table{border:1px double #b3b3b3;border-collapse:collapse;border-spacing:0;height:100%;width:100%}.ck-content .table table td,.ck-content .table table th{border:1px solid #bfbfbf;min-width:2em;padding:.4em}.ck-content .table table th{background:rgba(0,0,0,.05);font-weight:700}.ck-content[dir=rtl] .table th{text-align:right}.ck-content[dir=ltr] .table th{text-align:left}.ck-editor__editable .ck-table-bogus-paragraph{display:inline-block;width:100%}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/table.css"], names: [], mappings: "AAKA,mBAKC,aAAc,CADd,gBAiCD,CA9BC,yBAYC,yBAAkC,CAVlC,wBAAyB,CACzB,gBAAiB,CAKjB,WAAY,CADZ,UAsBD,CAfC,wDAQC,wBAAiC,CANjC,aAAc,CACd,YAMD,CAEA,4BAEC,0BAA+B,CAD/B,eAED,CAMF,+BACC,gBACD,CAEA,+BACC,eACD,CAEA,+CAKC,oBAAqB,CAMrB,UACD", sourcesContent: [`/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck-content .table {
	/* Give the table widget some air and center it horizontally */
	/* The first value should be equal to --ck-spacing-large variable if used in the editor context
	to avoid the content jumping (See https://github.com/ckeditor/ckeditor5/issues/9825). */
	margin: 0.9em auto;
	display: table;

	& table {
		/* The table cells should have slight borders */
		border-collapse: collapse;
		border-spacing: 0;

		/* Table width and height are set on the parent <figure>. Make sure the table inside stretches
		to the full dimensions of the container (https://github.com/ckeditor/ckeditor5/issues/6186). */
		width: 100%;
		height: 100%;

		/* The outer border of the table should be slightly darker than the inner lines.
		Also see https://github.com/ckeditor/ckeditor5-table/issues/50. */
		border: 1px double hsl(0, 0%, 70%);

		& td,
		& th {
			min-width: 2em;
			padding: .4em;

			/* The border is inherited from .ck-editor__nested-editable styles, so theoretically it's not necessary here.
			However, the border is a content style, so it should use .ck-content (so it works outside the editor).
			Hence, the duplication. See https://github.com/ckeditor/ckeditor5/issues/6314 */
			border: 1px solid hsl(0, 0%, 75%);
		}

		& th {
			font-weight: bold;
			background: hsla(0, 0%, 0%, 5%);
		}
	}
}

/* Text alignment of the table header should match the editor settings and override the native browser styling,
when content is available outside the editor. See https://github.com/ckeditor/ckeditor5/issues/6638 */
.ck-content[dir="rtl"] .table th {
	text-align: right;
}

.ck-content[dir="ltr"] .table th {
	text-align: left;
}

.ck-editor__editable .ck-table-bogus-paragraph {
	/*
	 * Use display:inline-block to force Chrome/Safari to limit text mutations to this element.
	 * See https://github.com/ckeditor/ckeditor5/issues/6062.
	 */
	display: inline-block;

	/*
	 * Inline HTML elements nested in the span should always be dimensioned in relation to the whole cell width.
	 * See https://github.com/ckeditor/ckeditor5/issues/9117.
	 */
	width: 100%;
}
`], sourceRoot: "" }]);
        const a = s2;
      }, 2128: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-color-selector-caption-background:#f7f7f7;--ck-color-selector-caption-text:#333;--ck-color-selector-caption-highlighted-background:#fd0}.ck-content .table>figcaption{background-color:var(--ck-color-selector-caption-background);caption-side:top;color:var(--ck-color-selector-caption-text);display:table-caption;font-size:.75em;outline-offset:-1px;padding:.6em;text-align:center;word-break:break-word}.ck.ck-editor__editable .table>figcaption.table__caption_highlighted{animation:ck-table-caption-highlight .6s ease-out}.ck.ck-editor__editable .table>figcaption.ck-placeholder:before{overflow:hidden;padding-left:inherit;padding-right:inherit;text-overflow:ellipsis;white-space:nowrap}@keyframes ck-table-caption-highlight{0%{background-color:var(--ck-color-selector-caption-highlighted-background)}to{background-color:var(--ck-color-selector-caption-background)}}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/tablecaption.css"], names: [], mappings: "AAKA,MACC,8CAAuD,CACvD,qCAAiD,CACjD,uDACD,CAGA,8BAMC,4DAA6D,CAJ7D,gBAAiB,CAGjB,2CAA4C,CAJ5C,qBAAsB,CAOtB,eAAgB,CAChB,mBAAoB,CAFpB,YAAa,CAHb,iBAAkB,CADlB,qBAOD,CAIC,qEACC,iDACD,CAEA,gEASC,eAAgB,CARhB,oBAAqB,CACrB,qBAAsB,CAQtB,sBAAuB,CAFvB,kBAGD,CAGD,sCACC,GACC,wEACD,CAEA,GACC,4DACD,CACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-color-selector-caption-background: hsl(0, 0%, 97%);\n	--ck-color-selector-caption-text: hsl(0, 0%, 20%);\n	--ck-color-selector-caption-highlighted-background: hsl(52deg 100% 50%);\n}\n\n/* Content styles */\n.ck-content .table > figcaption {\n	display: table-caption;\n	caption-side: top;\n	word-break: break-word;\n	text-align: center;\n	color: var(--ck-color-selector-caption-text);\n	background-color: var(--ck-color-selector-caption-background);\n	padding: .6em;\n	font-size: .75em;\n	outline-offset: -1px;\n}\n\n/* Editing styles */\n.ck.ck-editor__editable .table > figcaption {\n	&.table__caption_highlighted {\n		animation: ck-table-caption-highlight .6s ease-out;\n	}\n\n	&.ck-placeholder::before {\n		padding-left: inherit;\n		padding-right: inherit;\n\n		/*\n		 * Make sure the table caption placeholder doesn't overflow the placeholder area.\n		 * See https://github.com/ckeditor/ckeditor5/issues/9162.\n		 */\n		white-space: nowrap;\n		overflow: hidden;\n		text-overflow: ellipsis;\n	}\n}\n\n@keyframes ck-table-caption-highlight {\n	0% {\n		background-color: var(--ck-color-selector-caption-highlighted-background);\n	}\n\n	100% {\n		background-color: var(--ck-color-selector-caption-background);\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 5087: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row{flex-wrap:wrap}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:first-of-type{flex-grow:0.57}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar:last-of-type{flex-grow:0.43}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar .ck-button{flex-grow:1}.ck.ck-table-cell-properties-form{width:320px}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__padding-row{align-self:flex-end;padding:0;width:25%}.ck.ck-table-cell-properties-form .ck-form__row.ck-table-cell-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/tablecellproperties.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tablecellproperties.css"], names: [], mappings: "AAOE,6FACC,cAiBD,CAdE,0HAEC,cACD,CAEA,yHAEC,cACD,CAEA,uHACC,WACD,CClBJ,kCACC,WAkBD,CAfE,2FACC,mBAAoB,CACpB,SAAU,CACV,SACD,CAGC,4GACC,eAAgB,CAGhB,qCACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n	& .ck-form__row {\n		&.ck-table-cell-properties-form__alignment-row {\n			flex-wrap: wrap;\n\n			& .ck.ck-toolbar {\n				&:first-of-type {\n					/* 4 buttons out of 7 (h-alignment + v-alignment) = 0.57 */\n					flex-grow: 0.57;\n				}\n\n				&:last-of-type {\n					/* 3 buttons out of 7 (h-alignment + v-alignment) = 0.43 */\n					flex-grow: 0.43;\n				}\n\n				& .ck-button {\n					flex-grow: 1;\n				}\n			}\n		}\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-cell-properties-form {\n	width: 320px;\n\n	& .ck-form__row {\n		&.ck-table-cell-properties-form__padding-row {\n			align-self: flex-end;\n			padding: 0;\n			width: 25%;\n		}\n\n		&.ck-table-cell-properties-form__alignment-row {\n			& .ck.ck-toolbar {\n				background: none;\n\n				/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n				margin-top: var(--ck-spacing-standard);\n			}\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4101: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-color-selector-column-resizer-hover:var(--ck-color-base-active);--ck-table-column-resizer-width:7px;--ck-table-column-resizer-position-offset:calc(var(--ck-table-column-resizer-width)*-0.5 - 0.5px)}.ck-content .table .ck-table-resized{table-layout:fixed}.ck-content .table table{overflow:hidden}.ck-content .table td,.ck-content .table th{overflow-wrap:break-word;position:relative}.ck.ck-editor__editable .table .ck-table-column-resizer{bottom:0;cursor:col-resize;position:absolute;right:var(--ck-table-column-resizer-position-offset);top:0;user-select:none;width:var(--ck-table-column-resizer-width);z-index:var(--ck-z-default)}.ck.ck-editor__editable .table[draggable] .ck-table-column-resizer,.ck.ck-editor__editable.ck-column-resize_disabled .table .ck-table-column-resizer{display:none}.ck.ck-editor__editable .table .ck-table-column-resizer:hover,.ck.ck-editor__editable .table .ck-table-column-resizer__active{background-color:var(--ck-color-selector-column-resizer-hover);bottom:-999999px;opacity:.25;top:-999999px}.ck.ck-editor__editable[dir=rtl] .table .ck-table-column-resizer{left:var(--ck-table-column-resizer-position-offset);right:unset}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/tablecolumnresize.css"], names: [], mappings: "AAKA,MACC,oEAAqE,CACrE,mCAAoC,CAIpC,iGACD,CAEA,qCACC,kBACD,CAEA,yBACC,eACD,CAEA,4CAIC,wBAAyB,CACzB,iBACD,CAEA,wDAGC,QAAS,CAGT,iBAAkB,CALlB,iBAAkB,CAGlB,oDAAqD,CAFrD,KAAM,CAKN,gBAAiB,CAFjB,0CAA2C,CAG3C,2BACD,CAQA,qJACC,YACD,CAEA,8HAEC,8DAA+D,CAO/D,gBAAiB,CANjB,WAAa,CAKb,aAED,CAEA,iEACC,mDAAoD,CACpD,WACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-color-selector-column-resizer-hover: var(--ck-color-base-active);\n	--ck-table-column-resizer-width: 7px;\n\n	/* The offset used for absolute positioning of the resizer element, so that it is placed exactly above the cell border.\n	   The value is: minus half the width of the resizer decreased additionaly by the half the width of the border (0.5px). */\n	--ck-table-column-resizer-position-offset: calc(var(--ck-table-column-resizer-width) * -0.5 - 0.5px);\n}\n\n.ck-content .table .ck-table-resized {\n	table-layout: fixed;\n}\n\n.ck-content .table table {\n	overflow: hidden;\n}\n\n.ck-content .table td,\n.ck-content .table th {\n	/* To prevent text overflowing beyond its cell when columns are resized by resize handler\n	(https://github.com/ckeditor/ckeditor5/pull/14379#issuecomment-1589460978). */\n	overflow-wrap: break-word;\n	position: relative;\n}\n\n.ck.ck-editor__editable .table .ck-table-column-resizer {\n	position: absolute;\n	top: 0;\n	bottom: 0;\n	right: var(--ck-table-column-resizer-position-offset);\n	width: var(--ck-table-column-resizer-width);\n	cursor: col-resize;\n	user-select: none;\n	z-index: var(--ck-z-default);\n}\n\n.ck.ck-editor__editable.ck-column-resize_disabled .table .ck-table-column-resizer {\n	display: none;\n}\n\n/* The resizer elements, which are extended to an extremely high height, break the drag & drop feature in Chrome. To make it work again,\n   all resizers must be hidden while the table is dragged. */\n.ck.ck-editor__editable .table[draggable] .ck-table-column-resizer {\n	display: none;\n}\n\n.ck.ck-editor__editable .table .ck-table-column-resizer:hover,\n.ck.ck-editor__editable .table .ck-table-column-resizer__active {\n	background-color: var(--ck-color-selector-column-resizer-hover);\n	opacity: 0.25;\n	/* The resizer element resides in each cell so to occupy the entire height of the table, which is unknown from a CSS point of view,\n	   it is extended to an extremely high height. Even for screens with a very high pixel density, the resizer will fulfill its role as\n	   it should, i.e. for a screen of 476 ppi the total height of the resizer will take over 350 sheets of A4 format, which is totally\n	   unrealistic height for a single table. */\n	top: -999999px;\n	bottom: -999999px;\n}\n\n.ck.ck-editor__editable[dir=rtl] .table .ck-table-column-resizer {\n	left: var(--ck-table-column-resizer-position-offset);\n	right: unset;\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3881: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-color-selector-focused-cell-background:rgba(158,201,250,.3)}.ck-widget.table td.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table td.ck-editor__nested-editable:focus,.ck-widget.table th.ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck-widget.table th.ck-editor__nested-editable:focus{background:var(--ck-color-selector-focused-cell-background);border-style:none;outline:1px solid var(--ck-color-focus-border);outline-offset:-1px}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableediting.css"], names: [], mappings: "AAKA,MACC,gEACD,CAKE,8QAGC,2DAA4D,CAK5D,iBAAkB,CAClB,8CAA+C,CAC/C,mBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-color-selector-focused-cell-background: hsla(212, 90%, 80%, .3);\n}\n\n.ck-widget.table {\n	& td,\n	& th {\n		&.ck-editor__nested-editable.ck-editor__nested-editable_focused,\n		&.ck-editor__nested-editable:focus {\n			/* A very slight background to highlight the focused cell */\n			background: var(--ck-color-selector-focused-cell-background);\n\n			/* Fixes the problem where surrounding cells cover the focused cell's border.\n			It does not fix the problem in all places but the UX is improved.\n			See https://github.com/ckeditor/ckeditor5-table/issues/29. */\n			border-style: none;\n			outline: 1px solid var(--ck-color-focus-border);\n			outline-offset: -1px; /* progressive enhancement - no IE support */\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 6237: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, '.ck.ck-table-form .ck-form__row.ck-table-form__background-row,.ck.ck-table-form .ck-form__row.ck-table-form__border-row{flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{align-items:center;flex-wrap:wrap}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view{align-items:center;display:flex;flex-direction:column-reverse}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-labeled-field-view .ck.ck-dropdown,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{flex-grow:0}.ck.ck-table-form .ck.ck-labeled-field-view{position:relative}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{bottom:calc(var(--ck-table-properties-error-arrow-size)*-1);left:50%;position:absolute;transform:translate(-50%,100%);z-index:1}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{content:"";left:50%;position:absolute;top:calc(var(--ck-table-properties-error-arrow-size)*-1);transform:translateX(-50%)}:root{--ck-table-properties-error-arrow-size:6px;--ck-table-properties-min-error-width:150px}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-labeled-field-view>.ck-label{font-size:var(--ck-font-size-tiny);text-align:center}.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-style,.ck.ck-table-form .ck-form__row.ck-table-form__border-row .ck-table-form__border-width{max-width:80px;min-width:80px;width:80px}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row{padding:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__height,.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimensions-row__width{margin:0}.ck.ck-table-form .ck-form__row.ck-table-form__dimensions-row .ck-table-form__dimension-operator{align-self:flex-end;display:inline-block;height:var(--ck-ui-component-min-height);line-height:var(--ck-ui-component-min-height);margin:0 var(--ck-spacing-small)}.ck.ck-table-form .ck.ck-labeled-field-view{padding-top:var(--ck-spacing-standard)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{border-radius:0}.ck-rounded-corners .ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status,.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{background:var(--ck-color-base-error);color:var(--ck-color-base-background);min-width:var(--ck-table-properties-min-error-width);padding:var(--ck-spacing-small) var(--ck-spacing-medium);text-align:center}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status:after{border-color:transparent transparent var(--ck-color-base-error) transparent;border-style:solid;border-width:0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size)}.ck.ck-table-form .ck.ck-labeled-field-view .ck.ck-labeled-field-view__status{animation:ck-table-form-labeled-view-status-appear .15s ease both}.ck.ck-table-form .ck.ck-labeled-field-view .ck-input.ck-error:not(:focus)+.ck.ck-labeled-field-view__status{display:none}@keyframes ck-table-form-labeled-view-status-appear{0%{opacity:0}to{opacity:1}}', "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/tableform.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableform.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAWE,wHACC,cACD,CAEA,8DAEC,kBAAmB,CADnB,cAgBD,CAbC,qFAGC,kBAAmB,CAFnB,YAAa,CACb,6BAMD,CAEA,sMACC,WACD,CAIF,4CAEC,iBAoBD,CAlBC,8EAGC,2DAAgE,CADhE,QAAS,CADT,iBAAkB,CAGlB,8BAA+B,CAG/B,SAUD,CAPC,oFACC,UAAW,CAGX,QAAS,CAFT,iBAAkB,CAClB,wDAA6D,CAE7D,0BACD,CChDH,MACC,0CAA2C,CAC3C,2CACD,CAMI,2FACC,kCAAmC,CACnC,iBACD,CAGD,8KAIC,cAAe,CADf,cAAe,CADf,UAGD,CAGD,8DACC,SAcD,CAZC,yMAEC,QACD,CAEA,iGACC,mBAAoB,CACpB,oBAAqB,CACrB,wCAAyC,CACzC,6CAA8C,CAC9C,gCACD,CAIF,4CACC,sCAyBD,CAvBC,8ECxCD,eDyDC,CAjBA,mMCpCA,qCDqDA,CAjBA,8EAGC,qCAAsC,CACtC,qCAAsC,CAEtC,oDAAqD,CADrD,wDAAyD,CAEzD,iBAUD,CAPC,oFACC,2EAA4E,CAE5E,kBAAmB,CADnB,kJAED,CAdD,8EAgBC,iEACD,CAGA,6GACC,YACD,CAIF,oDACC,GACC,SACD,CAEA,GACC,SACD,CACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-form {\n	& .ck-form__row {\n		&.ck-table-form__border-row {\n			flex-wrap: wrap;\n		}\n\n		&.ck-table-form__background-row {\n			flex-wrap: wrap;\n		}\n\n		&.ck-table-form__dimensions-row {\n			flex-wrap: wrap;\n			align-items: center;\n\n			& .ck-labeled-field-view {\n				display: flex;\n				flex-direction: column-reverse;\n				align-items: center;\n\n				& .ck.ck-dropdown {\n					flex-grow: 0;\n				}\n			}\n\n			& .ck-table-form__dimension-operator {\n				flex-grow: 0;\n			}\n		}\n	}\n\n	& .ck.ck-labeled-field-view {\n		/* Allow absolute positioning of the status (error) balloons. */\n		position: relative;\n\n		& .ck.ck-labeled-field-view__status {\n			position: absolute;\n			left: 50%;\n			bottom: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n			transform: translate(-50%,100%);\n\n			/* Make sure the balloon status stays on top of other form elements. */\n			z-index: 1;\n\n			/* The arrow pointing towards the field. */\n			&::after {\n				content: "";\n				position: absolute;\n				top: calc( -1 * var(--ck-table-properties-error-arrow-size) );\n				left: 50%;\n				transform: translateX( -50% );\n			}\n		}\n	}\n}\n', '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_rounded.css";\n\n:root {\n	--ck-table-properties-error-arrow-size: 6px;\n	--ck-table-properties-min-error-width: 150px;\n}\n\n.ck.ck-table-form {\n	& .ck-form__row {\n		&.ck-table-form__border-row {\n			& .ck-labeled-field-view {\n				& > .ck-label {\n					font-size: var(--ck-font-size-tiny);\n					text-align: center;\n				}\n			}\n\n			& .ck-table-form__border-style,\n			& .ck-table-form__border-width {\n				width: 80px;\n				min-width: 80px;\n				max-width: 80px;\n			}\n		}\n\n		&.ck-table-form__dimensions-row {\n			padding: 0;\n\n			& .ck-table-form__dimensions-row__width,\n			& .ck-table-form__dimensions-row__height {\n				margin: 0\n			}\n\n			& .ck-table-form__dimension-operator {\n				align-self: flex-end;\n				display: inline-block;\n				height: var(--ck-ui-component-min-height);\n				line-height: var(--ck-ui-component-min-height);\n				margin: 0 var(--ck-spacing-small);\n			}\n		}\n	}\n\n	& .ck.ck-labeled-field-view {\n		padding-top: var(--ck-spacing-standard);\n\n		& .ck.ck-labeled-field-view__status {\n			@mixin ck-rounded-corners;\n\n			background: var(--ck-color-base-error);\n			color: var(--ck-color-base-background);\n			padding: var(--ck-spacing-small) var(--ck-spacing-medium);\n			min-width: var(--ck-table-properties-min-error-width);\n			text-align: center;\n\n			/* The arrow pointing towards the field. */\n			&::after {\n				border-color: transparent transparent var(--ck-color-base-error) transparent;\n				border-width: 0 var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size) var(--ck-table-properties-error-arrow-size);\n				border-style: solid;\n			}\n\n			animation: ck-table-form-labeled-view-status-appear .15s ease both;\n		}\n\n		/* Hide the error balloon when the field is blurred. Makes the experience much more clear. */\n		& .ck-input.ck-error:not(:focus) + .ck.ck-labeled-field-view__status {\n			display: none;\n		}\n	}\n}\n\n@keyframes ck-table-form-labeled-view-status-appear {\n	0% {\n		opacity: 0;\n	}\n\n	100% {\n		opacity: 1;\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 7341: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-content:baseline;flex-basis:0;flex-wrap:wrap}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items{flex-wrap:nowrap}.ck.ck-table-properties-form{width:320px}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row{align-self:flex-end;padding:0}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar{background:none;margin-top:var(--ck-spacing-standard)}.ck.ck-table-properties-form .ck-form__row.ck-table-properties-form__alignment-row .ck.ck-toolbar .ck-toolbar__items>*{width:40px}", "", { version: 3, sources: ["webpack://./../ckeditor5-table/theme/tableproperties.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableproperties.css"], names: [], mappings: "AAOE,mFAGC,sBAAuB,CADvB,YAAa,CADb,cAOD,CAHC,qHACC,gBACD,CCTH,6BACC,WAmBD,CAhBE,mFACC,mBAAoB,CACpB,SAYD,CAVC,kGACC,eAAgB,CAGhB,qCAKD,CAHC,uHACC,UACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n	& .ck-form__row {\n		&.ck-table-properties-form__alignment-row {\n			flex-wrap: wrap;\n			flex-basis: 0;\n			align-content: baseline;\n\n			& .ck.ck-toolbar .ck-toolbar__items {\n				flex-wrap: nowrap;\n			}\n		}\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-table-properties-form {\n	width: 320px;\n\n	& .ck-form__row {\n		&.ck-table-properties-form__alignment-row {\n			align-self: flex-end;\n			padding: 0;\n\n			& .ck.ck-toolbar {\n				background: none;\n\n				/* Compensate for missing input label that would push the margin (toolbar has no inputs). */\n				margin-top: var(--ck-spacing-standard);\n\n				& .ck-toolbar__items > * {\n					width: 40px;\n				}\n			}\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 6945: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ':root{--ck-table-selected-cell-background:rgba(158,207,250,.3)}.ck.ck-editor__editable .table table td.ck-editor__editable_selected,.ck.ck-editor__editable .table table th.ck-editor__editable_selected{box-shadow:unset;caret-color:transparent;outline:unset;position:relative}.ck.ck-editor__editable .table table td.ck-editor__editable_selected:after,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:after{background-color:var(--ck-table-selected-cell-background);bottom:0;content:"";left:0;pointer-events:none;position:absolute;right:0;top:0}.ck.ck-editor__editable .table table td.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table td.ck-editor__editable_selected:focus,.ck.ck-editor__editable .table table th.ck-editor__editable_selected ::selection,.ck.ck-editor__editable .table table th.ck-editor__editable_selected:focus{background-color:transparent}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget{outline:unset}.ck.ck-editor__editable .table table td.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle,.ck.ck-editor__editable .table table th.ck-editor__editable_selected .ck-widget>.ck-widget__selection-handle{display:none}', "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-table/tableselection.css"], names: [], mappings: "AAKA,MACC,wDACD,CAGC,0IAKC,gBAAiB,CAFjB,uBAAwB,CACxB,aAAc,CAFd,iBAiCD,CA3BC,sJAGC,yDAA0D,CAK1D,QAAS,CAPT,UAAW,CAKX,MAAO,CAJP,mBAAoB,CAEpB,iBAAkB,CAGlB,OAAQ,CAFR,KAID,CAEA,wTAEC,4BACD,CAMA,gKACC,aAKD,CAHC,0NACC,YACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-table-selected-cell-background: hsla(208, 90%, 80%, .3);\n}\n\n.ck.ck-editor__editable .table table {\n	& td.ck-editor__editable_selected,\n	& th.ck-editor__editable_selected {\n		position: relative;\n		caret-color: transparent;\n		outline: unset;\n		box-shadow: unset;\n\n		/* https://github.com/ckeditor/ckeditor5/issues/6446 */\n		&:after {\n			content: '';\n			pointer-events: none;\n			background-color: var(--ck-table-selected-cell-background);\n			position: absolute;\n			top: 0;\n			left: 0;\n			right: 0;\n			bottom: 0;\n		}\n\n		& ::selection,\n		&:focus {\n			background-color: transparent;\n		}\n\n		/*\n		 * To reduce the amount of noise, all widgets in the table selection have no outline and no selection handle.\n		 * See https://github.com/ckeditor/ckeditor5/issues/9491.\n		 */\n		& .ck-widget {\n			outline: unset;\n\n			& > .ck-widget__selection-handle {\n				display: none;\n			}\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3210: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-aria-live-announcer{left:-10000px;position:absolute;top:-10000px}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/arialiveannouncer/arialiveannouncer.css"], names: [], mappings: "AAKA,2BAEC,aAAc,CADd,iBAAkB,CAElB,YACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-aria-live-announcer {\n	position: absolute;\n	left: -10000px;\n	top: -10000px;\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 8157: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-autocomplete{position:relative}.ck.ck-autocomplete>.ck-search__results{position:absolute;z-index:var(--ck-z-modal)}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{bottom:100%}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{bottom:auto;top:100%}.ck.ck-autocomplete>.ck-search__results{border-radius:0}.ck-rounded-corners .ck.ck-autocomplete>.ck-search__results,.ck.ck-autocomplete>.ck-search__results.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-autocomplete>.ck-search__results{background:var(--ck-color-base-background);border:1px solid var(--ck-color-dropdown-panel-border);box-shadow:var(--ck-drop-shadow),0 0;max-height:200px;min-width:auto;overflow-y:auto}.ck.ck-autocomplete>.ck-search__results.ck-search__results_n{border-bottom-left-radius:0;border-bottom-right-radius:0;margin-bottom:-1px}.ck.ck-autocomplete>.ck-search__results.ck-search__results_s{border-top-left-radius:0;border-top-right-radius:0;margin-top:-1px}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/autocomplete/autocomplete.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/autocomplete/autocomplete.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,oBACC,iBAeD,CAbC,wCACC,iBAAkB,CAClB,yBAUD,CARC,6DACC,WACD,CAEA,6DAEC,WAAY,CADZ,QAED,CCVD,wCCEA,eDuBA,CAzBA,uHCMC,qCDmBD,CAzBA,wCAMC,0CAA2C,CAC3C,sDAAuD,CEPxD,oCAA8B,CFI7B,gBAAiB,CAIjB,cAAe,CAHf,eAoBD,CAfC,6DACC,2BAA4B,CAC5B,4BAA6B,CAG7B,kBACD,CAEA,6DACC,wBAAyB,CACzB,yBAA0B,CAG1B,eACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-autocomplete {\n	position: relative;\n\n	& > .ck-search__results {\n		position: absolute;\n		z-index: var(--ck-z-modal);\n\n		&.ck-search__results_n {\n			bottom: 100%;\n		}\n\n		&.ck-search__results_s {\n			top: 100%;\n			bottom: auto;\n		}\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_rounded.css";\n@import "@ckeditor/ckeditor5-theme-lark/theme/mixins/_shadow.css";\n\n.ck.ck-autocomplete {\n	& > .ck-search__results {\n		@mixin ck-rounded-corners;\n		@mixin ck-drop-shadow;\n\n		max-height: 200px;\n		overflow-y: auto;\n		background: var(--ck-color-base-background);\n		border: 1px solid var(--ck-color-dropdown-panel-border);\n		min-width: auto;\n\n		&.ck-search__results_n {\n			border-bottom-left-radius: 0;\n			border-bottom-right-radius: 0;\n\n			/* Prevent duplicated borders between the input and the results pane. */\n			margin-bottom: -1px;\n		}\n\n		&.ck-search__results_s {\n			border-top-left-radius: 0;\n			border-top-right-radius: 0;\n\n			/* Prevent duplicated borders between the input and the results pane. */\n			margin-top: -1px;\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n	box-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n	@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4906: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-button,a.ck.ck-button{align-items:center;display:inline-flex;position:relative;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}[dir=ltr] .ck.ck-button,[dir=ltr] a.ck.ck-button{justify-content:left}[dir=rtl] .ck.ck-button,[dir=rtl] a.ck.ck-button{justify-content:right}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{display:none}.ck.ck-button.ck-button_with-text .ck-button__label,a.ck.ck-button.ck-button_with-text .ck-button__label{display:inline-block}.ck.ck-button:not(.ck-button_with-text),a.ck.ck-button:not(.ck-button_with-text){justify-content:center}.ck.ck-button,a.ck.ck-button{background:var(--ck-color-button-default-background)}.ck.ck-button:not(.ck-disabled):hover,a.ck.ck-button:not(.ck-disabled):hover{background:var(--ck-color-button-default-hover-background)}.ck.ck-button:not(.ck-disabled):active,a.ck.ck-button:not(.ck-disabled):active{background:var(--ck-color-button-default-active-background)}.ck.ck-button.ck-disabled,a.ck.ck-button.ck-disabled{background:var(--ck-color-button-default-disabled-background)}.ck.ck-button,a.ck.ck-button{border-radius:0}.ck-rounded-corners .ck.ck-button,.ck-rounded-corners a.ck.ck-button,.ck.ck-button.ck-rounded-corners,a.ck.ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-button,a.ck.ck-button{-webkit-appearance:none;border:1px solid transparent;cursor:default;font-size:inherit;line-height:1;min-height:var(--ck-ui-component-min-height);min-width:var(--ck-ui-component-min-height);padding:var(--ck-spacing-tiny);text-align:center;transition:box-shadow .2s ease-in-out,border .2s ease-in-out;vertical-align:middle;white-space:nowrap}.ck.ck-button:active,.ck.ck-button:focus,a.ck.ck-button:active,a.ck.ck-button:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-button .ck-button__icon use,.ck.ck-button .ck-button__icon use *,a.ck.ck-button .ck-button__icon use,a.ck.ck-button .ck-button__icon use *{color:inherit}.ck.ck-button .ck-button__label,a.ck.ck-button .ck-button__label{color:inherit;cursor:inherit;font-size:inherit;font-weight:inherit;vertical-align:middle}[dir=ltr] .ck.ck-button .ck-button__label,[dir=ltr] a.ck.ck-button .ck-button__label{text-align:left}[dir=rtl] .ck.ck-button .ck-button__label,[dir=rtl] a.ck.ck-button .ck-button__label{text-align:right}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{color:inherit}[dir=ltr] .ck.ck-button .ck-button__keystroke,[dir=ltr] a.ck.ck-button .ck-button__keystroke{margin-left:var(--ck-spacing-large)}[dir=rtl] .ck.ck-button .ck-button__keystroke,[dir=rtl] a.ck.ck-button .ck-button__keystroke{margin-right:var(--ck-spacing-large)}.ck.ck-button .ck-button__keystroke,a.ck.ck-button .ck-button__keystroke{font-weight:700;opacity:.7}.ck.ck-button.ck-disabled:active,.ck.ck-button.ck-disabled:focus,a.ck.ck-button.ck-disabled:active,a.ck.ck-button.ck-disabled:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-button.ck-disabled .ck-button__icon,.ck.ck-button.ck-disabled .ck-button__label,a.ck.ck-button.ck-disabled .ck-button__icon,a.ck.ck-button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-disabled .ck-button__keystroke,a.ck.ck-button.ck-disabled .ck-button__keystroke{opacity:.3}.ck.ck-button.ck-button_with-text,a.ck.ck-button.ck-button_with-text{padding:var(--ck-spacing-tiny) var(--ck-spacing-standard)}[dir=ltr] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=ltr] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:calc(var(--ck-spacing-small)*-1);margin-right:var(--ck-spacing-small)}[dir=rtl] .ck.ck-button.ck-button_with-text .ck-button__icon,[dir=rtl] a.ck.ck-button.ck-button_with-text .ck-button__icon{margin-left:var(--ck-spacing-small);margin-right:calc(var(--ck-spacing-small)*-1)}.ck.ck-button.ck-button_with-keystroke .ck-button__label,a.ck.ck-button.ck-button_with-keystroke .ck-button__label{flex-grow:1}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{background:var(--ck-color-button-on-background)}.ck.ck-button.ck-on:not(.ck-disabled):hover,a.ck.ck-button.ck-on:not(.ck-disabled):hover{background:var(--ck-color-button-on-hover-background)}.ck.ck-button.ck-on:not(.ck-disabled):active,a.ck.ck-button.ck-on:not(.ck-disabled):active{background:var(--ck-color-button-on-active-background)}.ck.ck-button.ck-on.ck-disabled,a.ck.ck-button.ck-on.ck-disabled{background:var(--ck-color-button-on-disabled-background)}.ck.ck-button.ck-on,a.ck.ck-button.ck-on{color:var(--ck-color-button-on-color)}.ck.ck-button.ck-button-save,a.ck.ck-button.ck-button-save{color:var(--ck-color-button-save)}.ck.ck-button.ck-button-cancel,a.ck.ck-button.ck-button-cancel{color:var(--ck-color-button-cancel)}.ck.ck-button-action,a.ck.ck-button-action{background:var(--ck-color-button-action-background)}.ck.ck-button-action:not(.ck-disabled):hover,a.ck.ck-button-action:not(.ck-disabled):hover{background:var(--ck-color-button-action-hover-background)}.ck.ck-button-action:not(.ck-disabled):active,a.ck.ck-button-action:not(.ck-disabled):active{background:var(--ck-color-button-action-active-background)}.ck.ck-button-action.ck-disabled,a.ck.ck-button-action.ck-disabled{background:var(--ck-color-button-action-disabled-background)}.ck.ck-button-action,a.ck.ck-button-action{color:var(--ck-color-button-action-text)}.ck.ck-button-bold,a.ck.ck-button-bold{font-weight:700}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/button/button.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/button.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/mixins/_button.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css"], names: [], mappings: "AAQA,6BAMC,kBAAmB,CADnB,mBAAoB,CADpB,iBAAkB,CCHlB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD0BD,CA9BA,iDASE,oBAqBF,CA9BA,iDAaE,qBAiBF,CAdC,iEACC,YACD,CAGC,yGACC,oBACD,CAID,iFACC,sBACD,CEzBD,6BCAC,oDD4ID,CCzIE,6EACC,0DACD,CAEA,+EACC,2DACD,CAID,qDACC,6DACD,CDfD,6BEDC,eF6ID,CA5IA,wIEGE,qCFyIF,CA5IA,6BA6BC,uBAAwB,CANxB,4BAA6B,CAjB7B,cAAe,CAcf,iBAAkB,CAHlB,aAAc,CAJd,4CAA6C,CAD7C,2CAA4C,CAJ5C,8BAA+B,CAC/B,iBAAkB,CAiBlB,4DAA8D,CAnB9D,qBAAsB,CAFtB,kBAuID,CA7GC,oFGhCA,2BAA2B,CCF3B,2CAA8B,CDC9B,YHqCA,CAIC,kJAEC,aACD,CAGD,iEAIC,aAAc,CACd,cAAe,CAHf,iBAAkB,CAClB,mBAAoB,CAMpB,qBASD,CAlBA,qFAYE,eAMF,CAlBA,qFAgBE,gBAEF,CAEA,yEACC,aAYD,CAbA,6FAIE,mCASF,CAbA,6FAQE,oCAKF,CAbA,yEAWC,eAAiB,CACjB,UACD,CAIC,oIIrFD,oDJyFC,CAOA,gLKhGD,kCLkGC,CAEA,iGACC,UACD,CAGD,qEACC,yDAcD,CAXC,2HAEE,4CAA+C,CAC/C,oCAOF,CAVA,2HAQE,mCAAoC,CADpC,6CAGF,CAKA,mHACC,WACD,CAID,yCC/HA,+CDmIA,CChIC,yFACC,qDACD,CAEA,2FACC,sDACD,CAID,iEACC,wDACD,CDgHA,yCAGC,qCACD,CAEA,2DACC,iCACD,CAEA,+DACC,mCACD,CAID,2CC/IC,mDDoJD,CCjJE,2FACC,yDACD,CAEA,6FACC,0DACD,CAID,mEACC,4DACD,CDgID,2CAIC,wCACD,CAEA,uCAEC,eACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n@import "../../mixins/_dir.css";\n\n.ck.ck-button,\na.ck.ck-button {\n	@mixin ck-unselectable;\n\n	position: relative;\n	display: inline-flex;\n	align-items: center;\n\n	@mixin ck-dir ltr {\n		justify-content: left;\n	}\n\n	@mixin ck-dir rtl {\n		justify-content: right;\n	}\n\n	& .ck-button__label {\n		display: none;\n	}\n\n	&.ck-button_with-text {\n		& .ck-button__label {\n			display: inline-block;\n		}\n	}\n\n	/* Center the icon horizontally in a button without text. */\n	&:not(.ck-button_with-text)  {\n		justify-content: center;\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n	-moz-user-select: none;\n	-webkit-user-select: none;\n	-ms-user-select: none;\n	user-select: none\n}\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_focus.css";
@import "../../../mixins/_shadow.css";
@import "../../../mixins/_disabled.css";
@import "../../../mixins/_rounded.css";
@import "../../mixins/_button.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

.ck.ck-button,
a.ck.ck-button {
	@mixin ck-button-colors --ck-color-button-default;
	@mixin ck-rounded-corners;

	white-space: nowrap;
	cursor: default;
	vertical-align: middle;
	padding: var(--ck-spacing-tiny);
	text-align: center;

	/* A very important piece of styling. Go to variable declaration to learn more. */
	min-width: var(--ck-ui-component-min-height);
	min-height: var(--ck-ui-component-min-height);

	/* Normalize the height of the line. Removing this will break consistent height
	among text and text-less buttons (with icons). */
	line-height: 1;

	/* Enable font size inheritance, which allows fluid UI scaling. */
	font-size: inherit;

	/* Avoid flickering when the foucs border shows up. */
	border: 1px solid transparent;

	/* Apply some smooth transition to the box-shadow and border. */
	transition: box-shadow .2s ease-in-out, border .2s ease-in-out;

	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/189 */
	-webkit-appearance: none;

	&:active,
	&:focus {
		@mixin ck-focus-ring;
		@mixin ck-box-shadow var(--ck-focus-outer-shadow);
	}

	/* Allow icon coloring using the text "color" property. */
	& .ck-button__icon {
		& use,
		& use * {
			color: inherit;
		}
	}

	& .ck-button__label {
		/* Enable font size inheritance, which allows fluid UI scaling. */
		font-size: inherit;
		font-weight: inherit;
		color: inherit;
		cursor: inherit;

		/* Must be consistent with .ck-icon's vertical align. Otherwise, buttons with and
		without labels (but with icons) have different sizes in Chrome */
		vertical-align: middle;

		@mixin ck-dir ltr {
			text-align: left;
		}

		@mixin ck-dir rtl {
			text-align: right;
		}
	}

	& .ck-button__keystroke {
		color: inherit;

		@mixin ck-dir ltr {
			margin-left: var(--ck-spacing-large);
		}

		@mixin ck-dir rtl {
			margin-right: var(--ck-spacing-large);
		}

		font-weight: bold;
		opacity: .7;
	}

	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */
	&.ck-disabled {
		&:active,
		&:focus {
			/* The disabled button should have a slightly less visible shadow when focused. */
			@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);
		}

		& .ck-button__icon {
			@mixin ck-disabled;
		}

		/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */
		& .ck-button__label {
			@mixin ck-disabled;
		}

		& .ck-button__keystroke {
			opacity: .3;
		}
	}

	&.ck-button_with-text {
		padding: var(--ck-spacing-tiny) var(--ck-spacing-standard);

		/* stylelint-disable-next-line no-descending-specificity */
		& .ck-button__icon {
			@mixin ck-dir ltr {
				margin-left: calc(-1 * var(--ck-spacing-small));
				margin-right: var(--ck-spacing-small);
			}

			@mixin ck-dir rtl {
				margin-right: calc(-1 * var(--ck-spacing-small));
				margin-left: var(--ck-spacing-small);
			}
		}
	}

	&.ck-button_with-keystroke {
		/* stylelint-disable-next-line no-descending-specificity */
		& .ck-button__label {
			flex-grow: 1;
		}
	}

	/* A style of the button which is currently on, e.g. its feature is active. */
	&.ck-on {
		@mixin ck-button-colors --ck-color-button-on;

		color: var(--ck-color-button-on-color);
	}

	&.ck-button-save {
		color: var(--ck-color-button-save);
	}

	&.ck-button-cancel {
		color: var(--ck-color-button-cancel);
	}
}

/* A style of the button which handles the primary action. */
.ck.ck-button-action,
a.ck.ck-button-action {
	@mixin ck-button-colors --ck-color-button-action;

	color: var(--ck-color-button-action-text);
}

.ck.ck-button-bold,
a.ck.ck-button-bold {
	font-weight: bold;
}
`, "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements a button of given background color.\n *\n * @param {String} $background - Background color of the button.\n * @param {String} $border - Border color of the button.\n */\n@define-mixin ck-button-colors $prefix {\n	background: var($(prefix)-background);\n\n	&:not(.ck-disabled) {\n		&:hover {\n			background: var($(prefix)-hover-background);\n		}\n\n		&:active {\n			background: var($(prefix)-active-background);\n		}\n	}\n\n	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/98 */\n	&.ck-disabled {\n		background: var($(prefix)-disabled-background);\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n	/* Disable native outline. */\n	outline: none;\n	border: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n	box-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n	@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n	opacity: var(--ck-disabled-opacity);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 5332: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{display:block}:root{--ck-switch-button-toggle-width:2.6153846154em;--ck-switch-button-toggle-inner-size:calc(1.07692em + 1px);--ck-switch-button-translation:calc(var(--ck-switch-button-toggle-width) - var(--ck-switch-button-toggle-inner-size) - 2px);--ck-switch-button-inner-hover-shadow:0 0 0 5px var(--ck-color-switch-button-inner-shadow)}.ck.ck-button.ck-switchbutton,.ck.ck-button.ck-switchbutton.ck-on:active,.ck.ck-button.ck-switchbutton.ck-on:focus,.ck.ck-button.ck-switchbutton.ck-on:hover,.ck.ck-button.ck-switchbutton:active,.ck.ck-button.ck-switchbutton:focus,.ck.ck-button.ck-switchbutton:hover{background:transparent;color:inherit}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__label{margin-right:calc(var(--ck-spacing-large)*2)}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__label{margin-left:calc(var(--ck-spacing-large)*2)}.ck.ck-button.ck-switchbutton .ck-button__toggle{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle,.ck.ck-button.ck-switchbutton .ck-button__toggle.ck-rounded-corners{border-radius:var(--ck-border-radius)}[dir=ltr] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-left:auto}[dir=rtl] .ck.ck-button.ck-switchbutton .ck-button__toggle{margin-right:auto}.ck.ck-button.ck-switchbutton .ck-button__toggle{background:var(--ck-color-switch-button-off-background);border:1px solid transparent;transition:background .4s ease,box-shadow .2s ease-in-out,outline .2s ease-in-out;width:var(--ck-switch-button-toggle-width)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{border-radius:0}.ck-rounded-corners .ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner,.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner.ck-rounded-corners{border-radius:var(--ck-border-radius);border-radius:calc(var(--ck-border-radius)*.5)}.ck.ck-button.ck-switchbutton .ck-button__toggle .ck-button__toggle__inner{background:var(--ck-color-switch-button-inner-background);height:var(--ck-switch-button-toggle-inner-size);transition:all .3s ease;width:var(--ck-switch-button-toggle-inner-size)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover{background:var(--ck-color-switch-button-off-hover-background)}.ck.ck-button.ck-switchbutton .ck-button__toggle:hover .ck-button__toggle__inner{box-shadow:var(--ck-switch-button-inner-hover-shadow)}.ck.ck-button.ck-switchbutton.ck-disabled .ck-button__toggle{opacity:var(--ck-disabled-opacity)}.ck.ck-button.ck-switchbutton:focus{border-color:transparent;box-shadow:none;outline:none}.ck.ck-button.ck-switchbutton:focus .ck-button__toggle{box-shadow:0 0 0 1px var(--ck-color-base-background),0 0 0 5px var(--ck-color-focus-outer-shadow);outline:var(--ck-focus-ring);outline-offset:1px}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle{background:var(--ck-color-switch-button-on-background)}.ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle:hover{background:var(--ck-color-switch-button-on-hover-background)}[dir=ltr] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(var( --ck-switch-button-translation ))}[dir=rtl] .ck.ck-button.ck-switchbutton.ck-on .ck-button__toggle .ck-button__toggle__inner{transform:translateX(calc(var( --ck-switch-button-translation )*-1))}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/button/switchbutton.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/button/switchbutton.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css"], names: [], mappings: "AASE,4HACC,aACD,CCCF,MAEC,8CAA+C,CAE/C,0DAAgE,CAChE,2HAIC,CACD,0FACD,CAOC,0QAEC,sBAAuB,CADvB,aAED,CAEA,0DAGE,4CAOF,CAVA,0DAQE,2CAEF,CAEA,iDCpCA,eD4EA,CAxCA,yIChCC,qCDwED,CAxCA,2DAKE,gBAmCF,CAxCA,2DAUE,iBA8BF,CAxCA,iDAkBC,uDAAwD,CAFxD,4BAA6B,CAD7B,iFAAsF,CAEtF,0CAuBD,CApBC,2ECxDD,eDmEC,CAXA,6LCpDA,qCAAsC,CDsDpC,8CASF,CAXA,2EAOC,yDAA0D,CAD1D,gDAAiD,CAIjD,uBAA0B,CAL1B,+CAMD,CAEA,uDACC,6DAKD,CAHC,iFACC,qDACD,CAIF,6DEhFA,kCFkFA,CAGA,oCACC,wBAAyB,CAEzB,eAAgB,CADhB,YAQD,CALC,uDACC,iGAAmG,CAEnG,4BAA6B,CAD7B,kBAED,CAKA,uDACC,sDAkBD,CAhBC,6DACC,4DACD,CAEA,2FAKE,2DAMF,CAXA,2FASE,oEAEF", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-button.ck-switchbutton {\n	& .ck-button__toggle {\n		display: block;\n\n		& .ck-button__toggle__inner {\n			display: block;\n		}\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n/* Note: To avoid rendering issues (aliasing) but to preserve the responsive nature\nof the component, floating\u2013point numbers have been used which, for the default font size\n(see: --ck-font-size-base), will generate simple integers. */\n:root {\n	/* 34px at 13px font-size */\n	--ck-switch-button-toggle-width: 2.6153846154em;\n	/* 14px at 13px font-size */\n	--ck-switch-button-toggle-inner-size: calc(1.0769230769em + 1px);\n	--ck-switch-button-translation: calc(\n		var(--ck-switch-button-toggle-width) -\n		var(--ck-switch-button-toggle-inner-size) -\n		2px /* Border */\n	);\n	--ck-switch-button-inner-hover-shadow: 0 0 0 5px var(--ck-color-switch-button-inner-shadow);\n}\n\n.ck.ck-button.ck-switchbutton {\n	/* Unlike a regular button, the switch button text color and background should never change.\n	 * Changing toggle switch (background, outline) is enough to carry the information about the\n	 * state of the entire component (https://github.com/ckeditor/ckeditor5/issues/12519)\n	 */\n	&, &:hover, &:focus, &:active, &.ck-on:hover, &.ck-on:focus, &.ck-on:active {\n		color: inherit;\n		background: transparent;\n	}\n\n	& .ck-button__label {\n		@mixin ck-dir ltr {\n			/* Separate the label from the switch */\n			margin-right: calc(2 * var(--ck-spacing-large));\n		}\n\n		@mixin ck-dir rtl {\n			/* Separate the label from the switch */\n			margin-left: calc(2 * var(--ck-spacing-large));\n		}\n	}\n\n	& .ck-button__toggle {\n		@mixin ck-rounded-corners;\n\n		@mixin ck-dir ltr {\n			/* Make sure the toggle is always to the right as far as possible. */\n			margin-left: auto;\n		}\n\n		@mixin ck-dir rtl {\n			/* Make sure the toggle is always to the left as far as possible. */\n			margin-right: auto;\n		}\n\n		/* Apply some smooth transition to the box-shadow and border. */\n		/* Gently animate the background color of the toggle switch */\n		transition: background 400ms ease, box-shadow .2s ease-in-out, outline .2s ease-in-out;\n		border: 1px solid transparent;\n		width: var(--ck-switch-button-toggle-width);\n		background: var(--ck-color-switch-button-off-background);\n\n		& .ck-button__toggle__inner {\n			@mixin ck-rounded-corners {\n				border-radius: calc(.5 * var(--ck-border-radius));\n			}\n\n			width: var(--ck-switch-button-toggle-inner-size);\n			height: var(--ck-switch-button-toggle-inner-size);\n			background: var(--ck-color-switch-button-inner-background);\n\n			/* Gently animate the inner part of the toggle switch */\n			transition: all 300ms ease;\n		}\n\n		&:hover {\n			background: var(--ck-color-switch-button-off-hover-background);\n\n			& .ck-button__toggle__inner {\n				box-shadow: var(--ck-switch-button-inner-hover-shadow);\n			}\n		}\n	}\n\n	&.ck-disabled .ck-button__toggle {\n		@mixin ck-disabled;\n	}\n\n	/* Overriding default .ck-button:focus styles + an outline around the toogle */\n	&:focus {\n		border-color: transparent;\n		outline: none;\n		box-shadow: none;\n\n		& .ck-button__toggle {\n			box-shadow: 0 0 0 1px var(--ck-color-base-background), 0 0 0 5px var(--ck-color-focus-outer-shadow);\n			outline-offset: 1px;\n			outline: var(--ck-focus-ring);\n		}\n	}\n\n	/* stylelint-disable-next-line no-descending-specificity */\n	&.ck-on {\n		& .ck-button__toggle {\n			background: var(--ck-color-switch-button-on-background);\n\n			&:hover {\n				background: var(--ck-color-switch-button-on-hover-background);\n			}\n\n			& .ck-button__toggle__inner {\n				/*\n				* Move the toggle switch to the right. It will be animated.\n				*/\n				@mixin ck-dir ltr {\n					transform: translateX( var( --ck-switch-button-translation ) );\n				}\n\n				@mixin ck-dir rtl {\n					transform: translateX( calc( -1 * var( --ck-switch-button-translation ) ) );\n				}\n			}\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n	opacity: var(--ck-disabled-opacity);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 8010: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-collapsible.ck-collapsible_collapsed>.ck-collapsible__children{display:none}:root{--ck-collapsible-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-collapsible>.ck.ck-button{border-radius:0;color:inherit;font-weight:700;padding:var(--ck-list-button-padding);width:100%}.ck.ck-collapsible>.ck.ck-button:focus{background:transparent}.ck.ck-collapsible>.ck.ck-button:active,.ck.ck-collapsible>.ck.ck-button:hover:not(:focus),.ck.ck-collapsible>.ck.ck-button:not(:focus){background:transparent;border-color:transparent;box-shadow:none}.ck.ck-collapsible>.ck.ck-button>.ck-icon{margin-right:var(--ck-spacing-medium);width:var(--ck-collapsible-arrow-size)}.ck.ck-collapsible>.ck-collapsible__children{padding:var(--ck-spacing-medium) var(--ck-spacing-large) var(--ck-spacing-large)}.ck.ck-collapsible.ck-collapsible_collapsed>.ck.ck-button .ck-icon{transform:rotate(-90deg)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/collapsible/collapsible.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/collapsible/collapsible.css"], names: [], mappings: "AAMC,sEACC,YACD,CCHD,MACC,yDACD,CAGC,iCAIC,eAAgB,CAChB,aAAc,CAHd,eAAiB,CACjB,qCAAsC,CAFtC,UAoBD,CAdC,uCACC,sBACD,CAEA,wIACC,sBAAuB,CACvB,wBAAyB,CACzB,eACD,CAEA,0CACC,qCAAsC,CACtC,sCACD,CAGD,6CACC,gFACD,CAGC,mEACC,wBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-collapsible.ck-collapsible_collapsed {\n	& > .ck-collapsible__children {\n		display: none;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-collapsible-arrow-size: calc(0.5 * var(--ck-icon-size));\n}\n\n.ck.ck-collapsible {\n	& > .ck.ck-button {\n		width: 100%;\n		font-weight: bold;\n		padding: var(--ck-list-button-padding);\n		border-radius: 0;\n		color: inherit;\n\n		&:focus {\n			background: transparent;\n		}\n\n		&:active, &:not(:focus), &:hover:not(:focus) {\n			background: transparent;\n			border-color: transparent;\n			box-shadow: none;\n		}\n\n		& > .ck-icon {\n			margin-right: var(--ck-spacing-medium);\n			width: var(--ck-collapsible-arrow-size);\n		}\n	}\n\n	& > .ck-collapsible__children {\n		padding: var(--ck-spacing-medium) var(--ck-spacing-large) var(--ck-spacing-large);\n	}\n\n	&.ck-collapsible_collapsed {\n		& > .ck.ck-button .ck-icon {\n			transform: rotate(-90deg);\n		}\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 6781: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-color-grid{display:grid}:root{--ck-color-grid-tile-size:24px;--ck-color-color-grid-check-icon:#166fd4}.ck.ck-color-grid{grid-gap:5px;padding:8px}.ck.ck-color-grid__tile{border:0;height:var(--ck-color-grid-tile-size);min-height:var(--ck-color-grid-tile-size);min-width:var(--ck-color-grid-tile-size);padding:0;transition:box-shadow .2s ease;width:var(--ck-color-grid-tile-size)}.ck.ck-color-grid__tile.ck-disabled{cursor:unset;transition:unset}.ck.ck-color-grid__tile.ck-color-selector__color-tile_bordered{box-shadow:0 0 0 1px var(--ck-color-base-border)}.ck.ck-color-grid__tile .ck.ck-icon{color:var(--ck-color-color-grid-check-icon);display:none}.ck.ck-color-grid__tile.ck-on{box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-base-text)}.ck.ck-color-grid__tile.ck-on .ck.ck-icon{display:block}.ck.ck-color-grid__tile.ck-on,.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){border:0}.ck.ck-color-grid__tile:focus:not(.ck-disabled),.ck.ck-color-grid__tile:hover:not(.ck-disabled){box-shadow:inset 0 0 0 1px var(--ck-color-base-background),0 0 0 2px var(--ck-color-focus-border)}.ck.ck-color-grid__label{padding:0 var(--ck-spacing-standard)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/colorgrid/colorgrid.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorgrid/colorgrid.css"], names: [], mappings: "AAKA,kBACC,YACD,CCAA,MACC,8BAA+B,CAK/B,wCACD,CAEA,kBACC,YAAa,CACb,WACD,CAEA,wBAOC,QAAS,CALT,qCAAsC,CAEtC,yCAA0C,CAD1C,wCAAyC,CAEzC,SAAU,CACV,8BAA+B,CAL/B,oCAyCD,CAjCC,oCACC,YAAa,CACb,gBACD,CAEA,+DACC,gDACD,CAEA,oCAEC,2CAA4C,CAD5C,YAED,CAEA,8BACC,8FAKD,CAHC,0CACC,aACD,CAGD,8HAIC,QACD,CAEA,gGAEC,iGACD,CAGD,yBACC,oCACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-color-grid {\n	display: grid;\n}\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";

:root {
	--ck-color-grid-tile-size: 24px;

	/* Not using global colors here because these may change but some colors in a pallette
	 * require special treatment. For instance, this ensures no matter what the UI text color is,
	 * the check icon will look good on the black color tile. */
	--ck-color-color-grid-check-icon: hsl(212, 81%, 46%);
}

.ck.ck-color-grid {
	grid-gap: 5px;
	padding: 8px;
}

.ck.ck-color-grid__tile {
	width: var(--ck-color-grid-tile-size);
	height: var(--ck-color-grid-tile-size);
	min-width: var(--ck-color-grid-tile-size);
	min-height: var(--ck-color-grid-tile-size);
	padding: 0;
	transition: .2s ease box-shadow;
	border: 0;

	&.ck-disabled {
		cursor: unset;
		transition: unset;
	}

	&.ck-color-selector__color-tile_bordered {
		box-shadow: 0 0 0 1px var(--ck-color-base-border);
	}

	& .ck.ck-icon {
		display: none;
		color: var(--ck-color-color-grid-check-icon);
	}

	&.ck-on {
		box-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-base-text);

		& .ck.ck-icon {
			display: block;
		}
	}

	&.ck-on,
	&:focus:not( .ck-disabled ),
	&:hover:not( .ck-disabled ) {
		/* Disable the default .ck-button's border ring. */
		border: 0;
	}

	&:focus:not( .ck-disabled ),
	&:hover:not( .ck-disabled ) {
		box-shadow: inset 0 0 0 1px var(--ck-color-base-background), 0 0 0 2px var(--ck-color-focus-border);
	}
}

.ck.ck-color-grid__label {
	padding: 0 var(--ck-spacing-standard);
}
`], sourceRoot: "" }]);
        const a = s2;
      }, 3398: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".color-picker-hex-input{width:max-content}.color-picker-hex-input .ck.ck-input{min-width:unset}.ck.ck-color-picker__row{display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between;margin:var(--ck-spacing-large) 0 0;width:unset}.ck.ck-color-picker__row .ck.ck-labeled-field-view{padding-top:unset}.ck.ck-color-picker__row .ck.ck-input-text{width:unset}.ck.ck-color-picker__row .ck-color-picker__hash-view{padding-right:var(--ck-spacing-medium);padding-top:var(--ck-spacing-tiny)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/colorpicker/colorpicker.css"], names: [], mappings: "AAKA,wBACC,iBAKD,CAHC,qCACC,eACD,CAGD,yBACC,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CACjB,6BAA8B,CAC9B,kCAAmC,CACnC,WAcD,CAZC,mDACC,iBACD,CAEA,2CACC,WACD,CAEA,qDAEC,sCAAuC,CADvC,kCAED", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.color-picker-hex-input {\n	width: max-content;\n\n	& .ck.ck-input {\n		min-width: unset;\n	}\n}\n\n.ck.ck-color-picker__row {\n	display: flex;\n	flex-direction: row;\n	flex-wrap: nowrap;\n	justify-content: space-between;\n	margin: var(--ck-spacing-large) 0 0;\n	width: unset;\n\n	& .ck.ck-labeled-field-view {\n		padding-top: unset;\n	}\n\n	& .ck.ck-input-text {\n		width: unset;\n	}\n\n	& .ck-color-picker__hash-view {\n		padding-top: var(--ck-spacing-tiny);\n		padding-right: var(--ck-spacing-medium);\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4157: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{align-items:center;display:flex}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{justify-content:flex-start}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{display:flex;flex-direction:row;justify-content:space-around}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-cancel,.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar .ck-button-save{flex:1}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker,.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__remove-color{width:100%}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker{border-bottom-left-radius:0;border-bottom-right-radius:0;padding:calc(var(--ck-spacing-standard)/2) var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker:not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-color-selector .ck-color-grids-fragment .ck-button.ck-color-selector__color-picker .ck.ck-icon{margin-left:var(--ck-spacing-standard)}.ck.ck-color-selector .ck-color-grids-fragment label.ck.ck-color-grid__label{font-weight:unset}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker{padding:8px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker{height:100px;min-width:180px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation){border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue){border-radius:0 0 var(--ck-border-radius) var(--ck-border-radius)}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(hue-pointer),.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-picker .hex-color-picker::part(saturation-pointer){height:15px;width:15px}.ck.ck-color-selector .ck-color-picker-fragment .ck.ck-color-selector_action-bar{padding:0 8px 8px}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/colorselector/colorselector.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/colorselector/colorselector.css"], names: [], mappings: "AAUE,oLAGC,kBAAmB,CADnB,YAMD,CARA,wMAME,0BAEF,CAKA,iFACC,YAAa,CACb,kBAAmB,CACnB,4BAMD,CAJC,oMAEC,MACD,CCrBD,oLAEC,UACD,CAEA,0FAEC,2BAA4B,CAC5B,4BAA6B,CAF7B,qEAiBD,CAbC,sGACC,gDACD,CAEA,gHAEE,uCAMF,CARA,gHAME,sCAEF,CAGD,6EACC,iBACD,CAKA,oEACC,WAoBD,CAlBC,sFACC,YAAa,CACb,eAeD,CAbC,wGACC,iEACD,CAEA,iGACC,iEACD,CAEA,yNAGC,WAAY,CADZ,UAED,CAIF,iFACC,iBACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n	/* View fragment with color grids. */\n	& .ck-color-grids-fragment {\n		& .ck-button.ck-color-selector__remove-color,\n		& .ck-button.ck-color-selector__color-picker {\n			display: flex;\n			align-items: center;\n\n			@mixin ck-dir rtl {\n				justify-content: flex-start;\n			}\n		}\n	}\n\n	/* View fragment with a color picker. */\n	& .ck-color-picker-fragment {\n		& .ck.ck-color-selector_action-bar {\n			display: flex;\n			flex-direction: row;\n			justify-content: space-around;\n\n			& .ck-button-save,\n			& .ck-button-cancel {\n				flex: 1\n			}\n		}\n	}\n}\n', '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-color-selector {\n	/* View fragment with color grids. */\n	& .ck-color-grids-fragment {\n		& .ck-button.ck-color-selector__remove-color,\n		& .ck-button.ck-color-selector__color-picker {\n			width: 100%;\n		}\n\n		& .ck-button.ck-color-selector__color-picker {\n			padding: calc(var(--ck-spacing-standard) / 2) var(--ck-spacing-standard);\n			border-bottom-left-radius: 0;\n			border-bottom-right-radius: 0;\n\n			&:not(:focus) {\n				border-top: 1px solid var(--ck-color-base-border);\n			}\n\n			& .ck.ck-icon {\n				@mixin ck-dir ltr {\n					margin-right: var(--ck-spacing-standard);\n				}\n\n				@mixin ck-dir rtl {\n					margin-left: var(--ck-spacing-standard);\n				}\n			}\n		}\n\n		& label.ck.ck-color-grid__label {\n			font-weight: unset;\n		}\n	}\n\n	/* View fragment with a color picker. */\n	& .ck-color-picker-fragment {\n		& .ck.ck-color-picker {\n			padding: 8px;\n\n			& .hex-color-picker {\n				height: 100px;\n				min-width: 180px;\n\n				&::part(saturation) {\n					border-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n				}\n\n				&::part(hue) {\n					border-radius: 0 0 var(--ck-border-radius) var(--ck-border-radius);\n				}\n\n				&::part(saturation-pointer),\n				&::part(hue-pointer) {\n					width: 15px;\n					height: 15px;\n				}\n			}\n		}\n\n		& .ck.ck-color-selector_action-bar {\n			padding: 0 8px 8px;\n		}\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 5485: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-dropdown-max-width:75vw}.ck.ck-dropdown{display:inline-block;position:relative}.ck.ck-dropdown .ck-dropdown__arrow{pointer-events:none;z-index:var(--ck-z-default)}.ck.ck-dropdown .ck-button.ck-dropdown__button{width:100%}.ck.ck-dropdown .ck-dropdown__panel{display:none;max-width:var(--ck-dropdown-max-width);position:absolute;z-index:var(--ck-z-modal)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel-visible{display:inline-block}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw{bottom:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{bottom:auto;top:100%}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se{left:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw{right:0}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_n,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_s{left:50%;transform:translateX(-50%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nmw,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_smw{left:75%;transform:translateX(-75%)}.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_nme,.ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sme{left:25%;transform:translateX(-25%)}.ck.ck-toolbar .ck-dropdown__panel{z-index:calc(var(--ck-z-modal) + 1)}:root{--ck-dropdown-arrow-size:calc(var(--ck-icon-size)*0.5)}.ck.ck-dropdown{font-size:inherit}.ck.ck-dropdown .ck-dropdown__arrow{width:var(--ck-dropdown-arrow-size)}[dir=ltr] .ck.ck-dropdown .ck-dropdown__arrow{margin-left:var(--ck-spacing-standard);right:var(--ck-spacing-standard)}[dir=rtl] .ck.ck-dropdown .ck-dropdown__arrow{left:var(--ck-spacing-standard);margin-right:var(--ck-spacing-small)}.ck.ck-dropdown.ck-disabled .ck-dropdown__arrow{opacity:var(--ck-disabled-opacity)}[dir=ltr] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-left:var(--ck-spacing-small)}[dir=rtl] .ck.ck-dropdown .ck-button.ck-dropdown__button:not(.ck-button_with-text){padding-right:var(--ck-spacing-small)}.ck.ck-dropdown .ck-button.ck-dropdown__button .ck-button__label{overflow:hidden;text-overflow:ellipsis;width:7em}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-disabled .ck-button__label{opacity:var(--ck-disabled-opacity)}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on{border-bottom-left-radius:0;border-bottom-right-radius:0}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-dropdown__button_label-width_auto .ck-button__label{width:auto}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active{box-shadow:none}.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-off:active:focus,.ck.ck-dropdown .ck-button.ck-dropdown__button.ck-on:active:focus{box-shadow:var(--ck-focus-outer-shadow),0 0}.ck.ck-dropdown__panel{border-radius:0}.ck-rounded-corners .ck.ck-dropdown__panel,.ck.ck-dropdown__panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-dropdown__panel{background:var(--ck-color-dropdown-panel-background);border:1px solid var(--ck-color-dropdown-panel-border);bottom:0;box-shadow:var(--ck-drop-shadow),0 0;min-width:100%}.ck.ck-dropdown__panel.ck-dropdown__panel_se{border-top-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_sw{border-top-right-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_ne{border-bottom-left-radius:0}.ck.ck-dropdown__panel.ck-dropdown__panel_nw{border-bottom-right-radius:0}.ck.ck-dropdown__panel:focus{outline:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/dropdown/dropdown.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/dropdown.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_disabled.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAKA,MACC,4BACD,CAEA,gBACC,oBAAqB,CACrB,iBA2ED,CAzEC,oCACC,mBAAoB,CACpB,2BACD,CAGA,+CACC,UACD,CAEA,oCACC,YAAa,CAEb,sCAAuC,CAEvC,iBAAkB,CAHlB,yBA4DD,CAvDC,+DACC,oBACD,CAEA,mSAKC,WACD,CAEA,mSAUC,WAAY,CADZ,QAED,CAEA,oHAEC,MACD,CAEA,oHAEC,OACD,CAEA,kHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAEA,sHAGC,QAAS,CACT,0BACD,CAQF,mCACC,mCACD,CCpFA,MACC,sDACD,CAEA,gBAEC,iBA2ED,CAzEC,oCACC,mCACD,CAGC,8CAIC,sCAAuC,CAHvC,gCAID,CAIA,8CACC,+BAAgC,CAGhC,oCACD,CAGD,gDC/BA,kCDiCA,CAIE,mFAEC,oCACD,CAIA,mFAEC,qCACD,CAID,iEAEC,eAAgB,CAChB,sBAAuB,CAFvB,SAGD,CAGA,6EC1DD,kCD4DC,CAGA,qDACC,2BAA4B,CAC5B,4BACD,CAEA,sGACC,UACD,CAGA,yHAEC,eAKD,CAHC,qIE7EF,2CF+EE,CAKH,uBGlFC,eHkHD,CAhCA,qFG9EE,qCH8GF,CAhCA,uBAIC,oDAAqD,CACrD,sDAAuD,CACvD,QAAS,CE1FT,oCAA8B,CF6F9B,cAuBD,CAnBC,6CACC,wBACD,CAEA,6CACC,yBACD,CAEA,6CACC,2BACD,CAEA,6CACC,4BACD,CAEA,6BACC,YACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-dropdown-max-width: 75vw;\n}\n\n.ck.ck-dropdown {\n	display: inline-block;\n	position: relative;\n\n	& .ck-dropdown__arrow {\n		pointer-events: none;\n		z-index: var(--ck-z-default);\n	}\n\n	/* Dropdown button should span horizontally, e.g. in vertical toolbars */\n	& .ck-button.ck-dropdown__button {\n		width: 100%;\n	}\n\n	& .ck-dropdown__panel {\n		display: none;\n		z-index: var(--ck-z-modal);\n		max-width: var(--ck-dropdown-max-width);\n\n		position: absolute;\n\n		&.ck-dropdown__panel-visible {\n			display: inline-block;\n		}\n\n		&.ck-dropdown__panel_ne,\n		&.ck-dropdown__panel_nw,\n		&.ck-dropdown__panel_n,\n		&.ck-dropdown__panel_nmw,\n		&.ck-dropdown__panel_nme {\n			bottom: 100%;\n		}\n\n		&.ck-dropdown__panel_se,\n		&.ck-dropdown__panel_sw,\n		&.ck-dropdown__panel_smw,\n		&.ck-dropdown__panel_sme,\n		&.ck-dropdown__panel_s {\n			/*\n			 * Using transform: translate3d( 0, 100%, 0 ) causes blurry dropdown on Chrome 67-78+ on non-retina displays.\n			 * See https://github.com/ckeditor/ckeditor5/issues/1053.\n			 */\n			top: 100%;\n			bottom: auto;\n		}\n\n		&.ck-dropdown__panel_ne,\n		&.ck-dropdown__panel_se {\n			left: 0px;\n		}\n\n		&.ck-dropdown__panel_nw,\n		&.ck-dropdown__panel_sw {\n			right: 0px;\n		}\n\n		&.ck-dropdown__panel_s,\n		&.ck-dropdown__panel_n {\n			/* Positioning panels relative to the center of the button */\n			left: 50%;\n			transform: translateX(-50%);\n		}\n\n		&.ck-dropdown__panel_nmw,\n		&.ck-dropdown__panel_smw {\n			/* Positioning panels relative to the middle-west of the button */\n			left: 75%;\n			transform: translateX(-75%);\n		}\n\n		&.ck-dropdown__panel_nme,\n		&.ck-dropdown__panel_sme {\n			/* Positioning panels relative to the middle-east of the button */\n			left: 25%;\n			transform: translateX(-25%);\n		}\n	}\n}\n\n/*\n * Toolbar dropdown panels should be always above the UI (eg. other dropdown panels) from the editor's content.\n * See https://github.com/ckeditor/ckeditor5/issues/7874\n */\n.ck.ck-toolbar .ck-dropdown__panel {\n	z-index: calc( var(--ck-z-modal) + 1 );\n}\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";
@import "../../../mixins/_disabled.css";
@import "../../../mixins/_shadow.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

:root {
	--ck-dropdown-arrow-size: calc(0.5 * var(--ck-icon-size));
}

.ck.ck-dropdown {
	/* Enable font size inheritance, which allows fluid UI scaling. */
	font-size: inherit;

	& .ck-dropdown__arrow {
		width: var(--ck-dropdown-arrow-size);
	}

	@mixin ck-dir ltr {
		& .ck-dropdown__arrow {
			right: var(--ck-spacing-standard);

			/* A space to accommodate the triangle. */
			margin-left: var(--ck-spacing-standard);
		}
	}

	@mixin ck-dir rtl {
		& .ck-dropdown__arrow {
			left: var(--ck-spacing-standard);

			/* A space to accommodate the triangle. */
			margin-right: var(--ck-spacing-small);
		}
	}

	&.ck-disabled .ck-dropdown__arrow {
		@mixin ck-disabled;
	}

	& .ck-button.ck-dropdown__button {
		@mixin ck-dir ltr {
			&:not(.ck-button_with-text) {
				/* Make sure dropdowns with just an icon have the right inner spacing */
				padding-left: var(--ck-spacing-small);
			}
		}

		@mixin ck-dir rtl {
			&:not(.ck-button_with-text) {
				/* Make sure dropdowns with just an icon have the right inner spacing */
				padding-right: var(--ck-spacing-small);
			}
		}

		/* #23 */
		& .ck-button__label {
			width: 7em;
			overflow: hidden;
			text-overflow: ellipsis;
		}

		/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/70 */
		&.ck-disabled .ck-button__label {
			@mixin ck-disabled;
		}

		/* https://github.com/ckeditor/ckeditor5/issues/816 */
		&.ck-on {
			border-bottom-left-radius: 0;
			border-bottom-right-radius: 0;
		}

		&.ck-dropdown__button_label-width_auto .ck-button__label {
			width: auto;
		}

		/* https://github.com/ckeditor/ckeditor5/issues/8699 */
		&.ck-off:active,
		&.ck-on:active {
			box-shadow: none;

			&:focus {
				@mixin ck-box-shadow var(--ck-focus-outer-shadow);
			}
		}
	}
}

.ck.ck-dropdown__panel {
	@mixin ck-rounded-corners;
	@mixin ck-drop-shadow;

	background: var(--ck-color-dropdown-panel-background);
	border: 1px solid var(--ck-color-dropdown-panel-border);
	bottom: 0;

	/* Make sure the panel is at least as wide as the drop-down's button. */
	min-width: 100%;

	/* Disabled corner border radius to be consistent with the .dropdown__button
	https://github.com/ckeditor/ckeditor5/issues/816 */
	&.ck-dropdown__panel_se {
		border-top-left-radius: 0;
	}

	&.ck-dropdown__panel_sw {
		border-top-right-radius: 0;
	}

	&.ck-dropdown__panel_ne {
		border-bottom-left-radius: 0;
	}

	&.ck-dropdown__panel_nw {
		border-bottom-right-radius: 0;
	}

	&:focus {
		outline: none;
	}
}
`, "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which indicates that an element holding it is disabled.\n */\n@define-mixin ck-disabled {\n	opacity: var(--ck-disabled-opacity);\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n	box-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n	@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3949: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-dropdown .ck-dropdown__panel .ck-list{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list,.ck.ck-dropdown .ck-dropdown__panel .ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:first-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-bottom-left-radius:0;border-bottom-right-radius:0;border-top-left-radius:0}.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button{border-radius:0}.ck-rounded-corners .ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button,.ck.ck-dropdown .ck-dropdown__panel .ck-list .ck-list__item:last-child .ck-button.ck-rounded-corners{border-radius:var(--ck-border-radius);border-top-left-radius:0;border-top-right-radius:0}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/listdropdown.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,6CCIC,eDqBD,CAzBA,iICQE,qCAAsC,CDJtC,wBAqBF,CAfE,mFCND,eDYC,CANA,6MCFA,qCAAsC,CDKpC,2BAA4B,CAC5B,4BAA6B,CAF7B,wBAIF,CAEA,kFCdD,eDmBC,CALA,2MCVA,qCAAsC,CDYpC,wBAAyB,CACzB,yBAEF", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-dropdown .ck-dropdown__panel .ck-list {\n	/* Disabled radius of top-left border to be consistent with .dropdown__button\n	https://github.com/ckeditor/ckeditor5/issues/816 */\n	@mixin ck-rounded-corners {\n		border-top-left-radius: 0;\n	}\n\n	/* Make sure the button belonging to the first/last child of the list goes well with the\n	border radius of the entire panel. */\n	& .ck-list__item {\n		&:first-child .ck-button {\n			@mixin ck-rounded-corners {\n				border-top-left-radius: 0;\n				border-bottom-left-radius: 0;\n				border-bottom-right-radius: 0;\n			}\n		}\n\n		&:last-child .ck-button {\n			@mixin ck-rounded-corners {\n				border-top-left-radius: 0;\n				border-top-right-radius: 0;\n			}\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 7686: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, '.ck.ck-splitbutton{font-size:inherit}.ck.ck-splitbutton .ck-splitbutton__action:focus{z-index:calc(var(--ck-z-default) + 1)}:root{--ck-color-split-button-hover-background:#ebebeb;--ck-color-split-button-hover-border:#b3b3b3}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-right-radius:unset;border-top-right-radius:unset}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__action{border-bottom-left-radius:unset;border-top-left-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow{min-width:unset}[dir=ltr] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-left-radius:unset;border-top-left-radius:unset}[dir=rtl] .ck.ck-splitbutton>.ck-splitbutton__arrow{border-bottom-right-radius:unset;border-top-right-radius:unset}.ck.ck-splitbutton>.ck-splitbutton__arrow svg{width:var(--ck-dropdown-arrow-size)}.ck.ck-splitbutton>.ck-splitbutton__arrow:not(:focus){border-bottom-width:0;border-top-width:0}.ck.ck-splitbutton.ck-splitbutton_open>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover),.ck.ck-splitbutton:hover>.ck-button:not(.ck-on):not(.ck-disabled):not(:hover){background:var(--ck-color-split-button-hover-background)}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{background-color:var(--ck-color-split-button-hover-border);content:"";height:100%;position:absolute;width:1px}.ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:focus:after,.ck.ck-splitbutton:hover>.ck-splitbutton__arrow:focus:after{--ck-color-split-button-hover-border:var(--ck-color-focus-border)}[dir=ltr] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=ltr] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{left:-1px}[dir=rtl] .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow:not(.ck-disabled):after,[dir=rtl] .ck.ck-splitbutton:hover>.ck-splitbutton__arrow:not(.ck-disabled):after{right:-1px}.ck.ck-splitbutton.ck-splitbutton_open{border-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__action,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__action{border-bottom-left-radius:0}.ck-rounded-corners .ck.ck-splitbutton.ck-splitbutton_open>.ck-splitbutton__arrow,.ck.ck-splitbutton.ck-splitbutton_open.ck-rounded-corners>.ck-splitbutton__arrow{border-bottom-right-radius:0}', "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/dropdown/splitbutton.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/splitbutton.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAKA,mBAEC,iBAKD,CAHC,iDACC,qCACD,CCJD,MACC,gDAAyD,CACzD,4CACD,CAMC,oIAKE,gCAAiC,CADjC,6BASF,CAbA,oIAWE,+BAAgC,CADhC,4BAGF,CAEA,0CAGC,eAiBD,CApBA,oDAQE,+BAAgC,CADhC,4BAaF,CApBA,oDAcE,gCAAiC,CADjC,6BAOF,CAHC,8CACC,mCACD,CAKD,sDAEC,qBAAwB,CADxB,kBAED,CAQC,0KACC,wDACD,CAIA,8JAKC,0DAA2D,CAJ3D,UAAW,CAGX,WAAY,CAFZ,iBAAkB,CAClB,SAGD,CAGA,sIACC,iEACD,CAGC,kLACC,SACD,CAIA,kLACC,UACD,CAMF,uCCzFA,eDmGA,CAVA,qHCrFC,qCD+FD,CARE,qKACC,2BACD,CAEA,mKACC,4BACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-splitbutton {\n	/* Enable font size inheritance, which allows fluid UI scaling. */\n	font-size: inherit;\n\n	& .ck-splitbutton__action:focus {\n		z-index: calc(var(--ck-z-default) + 1);\n	}\n}\n\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";

:root {
	--ck-color-split-button-hover-background: hsl(0, 0%, 92%);
	--ck-color-split-button-hover-border: hsl(0, 0%, 70%);
}

.ck.ck-splitbutton {
	/*
	 * Note: ck-rounded and ck-dir mixins don't go together (because they both use @nest).
	 */
	&:hover > .ck-splitbutton__action,
	&.ck-splitbutton_open > .ck-splitbutton__action {
		@nest [dir="ltr"] & {
			/* Don't round the action button on the right side */
			border-top-right-radius: unset;
			border-bottom-right-radius: unset;
		}

		@nest [dir="rtl"] & {
			/* Don't round the action button on the left side */
			border-top-left-radius: unset;
			border-bottom-left-radius: unset;
		}
	}

	& > .ck-splitbutton__arrow {
		/* It's a text-less button and since the icon is positioned absolutely in such situation,
		it must get some arbitrary min-width. */
		min-width: unset;

		@nest [dir="ltr"] & {
			/* Don't round the arrow button on the left side */
			border-top-left-radius: unset;
			border-bottom-left-radius: unset;
		}

		@nest [dir="rtl"] & {
			/* Don't round the arrow button on the right side */
			border-top-right-radius: unset;
			border-bottom-right-radius: unset;
		}

		& svg {
			width: var(--ck-dropdown-arrow-size);
		}
	}

	/* Make sure the divider stretches 100% height of the button
	https://github.com/ckeditor/ckeditor5/issues/10936 */
	& > .ck-splitbutton__arrow:not(:focus) {
		border-top-width: 0px;
		border-bottom-width: 0px;
	}

	/* When the split button is "open" (the arrow is on) or being hovered, it should get some styling
	as a whole. The background of both buttons should stand out and there should be a visual
	separation between both buttons. */
	&.ck-splitbutton_open,
	&:hover {
		/* When the split button hovered as a whole, not as individual buttons. */
		& > .ck-button:not(.ck-on):not(.ck-disabled):not(:hover) {
			background: var(--ck-color-split-button-hover-background);
		}

		/* Splitbutton separator needs to be set with the ::after pseudoselector
		to display properly the borders on focus */
		& > .ck-splitbutton__arrow:not(.ck-disabled)::after {
			content: '';
			position: absolute;
			width: 1px;
			height: 100%;
			background-color: var(--ck-color-split-button-hover-border);
		}

		/* Make sure the divider between the buttons looks fine when the button is focused */
		& > .ck-splitbutton__arrow:focus::after {
			--ck-color-split-button-hover-border: var(--ck-color-focus-border);
		}

		@nest [dir="ltr"] & {
			& > .ck-splitbutton__arrow:not(.ck-disabled)::after {
				left: -1px;
			}
		}

		@nest [dir="rtl"] & {
			& > .ck-splitbutton__arrow:not(.ck-disabled)::after {
				right: -1px;
			}
		}
	}

	/* Don't round the bottom left and right corners of the buttons when "open"
	https://github.com/ckeditor/ckeditor5/issues/816 */
	&.ck-splitbutton_open {
		@mixin ck-rounded-corners {
			& > .ck-splitbutton__action {
				border-bottom-left-radius: 0;
			}

			& > .ck-splitbutton__arrow {
				border-bottom-right-radius: 0;
			}
		}
	}
}
`, "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 7339: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-toolbar-dropdown-max-width:60vw}.ck.ck-toolbar-dropdown>.ck-dropdown__panel{max-width:var(--ck-toolbar-dropdown-max-width);width:max-content}.ck.ck-toolbar-dropdown>.ck-dropdown__panel .ck-button:focus{z-index:calc(var(--ck-z-default) + 1)}.ck.ck-toolbar-dropdown .ck-toolbar{border:0}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/dropdown/toolbardropdown.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/dropdown/toolbardropdown.css"], names: [], mappings: "AAKA,MACC,oCACD,CAEA,4CAGC,8CAA+C,CAD/C,iBAQD,CAJE,6DACC,qCACD,CCZF,oCACC,QACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-toolbar-dropdown-max-width: 60vw;\n}\n\n.ck.ck-toolbar-dropdown > .ck-dropdown__panel {\n	/* https://github.com/ckeditor/ckeditor5/issues/5586 */\n	width: max-content;\n	max-width: var(--ck-toolbar-dropdown-max-width);\n\n	& .ck-button {\n		&:focus {\n			z-index: calc(var(--ck-z-default) + 1);\n		}\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-toolbar-dropdown .ck-toolbar {\n	border: 0;\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 9688: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-color-editable-blur-selection:#d9d9d9}.ck.ck-editor__editable:not(.ck-editor__nested-editable){border-radius:0}.ck-rounded-corners .ck.ck-editor__editable:not(.ck-editor__nested-editable),.ck.ck-editor__editable.ck-rounded-corners:not(.ck-editor__nested-editable){border-radius:var(--ck-border-radius)}.ck.ck-editor__editable.ck-focused:not(.ck-editor__nested-editable){border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck.ck-editor__editable_inline{border:1px solid transparent;overflow:auto;padding:0 var(--ck-spacing-standard)}.ck.ck-editor__editable_inline[dir=ltr]{text-align:left}.ck.ck-editor__editable_inline[dir=rtl]{text-align:right}.ck.ck-editor__editable_inline>:first-child{margin-top:var(--ck-spacing-large)}.ck.ck-editor__editable_inline>:last-child{margin-bottom:var(--ck-spacing-large)}.ck.ck-editor__editable_inline.ck-blurred ::selection{background:var(--ck-color-editable-blur-selection)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_n]:after{border-bottom-color:var(--ck-color-panel-background)}.ck.ck-balloon-panel.ck-toolbar-container[class*=arrow_s]:after{border-top-color:var(--ck-color-panel-background)}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/editorui/editorui.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAWA,MACC,0CACD,CAEA,yDCJC,eDWD,CAPA,yJCAE,qCDOF,CAJC,oEEPA,2BAA2B,CCF3B,qCAA8B,CDC9B,YFWA,CAGD,+BAGC,4BAA6B,CAF7B,aAAc,CACd,oCA6BD,CA1BC,wCACC,eACD,CAEA,wCACC,gBACD,CAGA,4CACC,kCACD,CAGA,2CAKC,qCACD,CAGA,sDACC,kDACD,CAKA,gEACC,oDACD,CAIA,gEACC,iDACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_disabled.css";\n@import "../../../mixins/_shadow.css";\n@import "../../../mixins/_focus.css";\n@import "../../mixins/_button.css";\n\n:root {\n	--ck-color-editable-blur-selection: hsl(0, 0%, 85%);\n}\n\n.ck.ck-editor__editable:not(.ck-editor__nested-editable) {\n	@mixin ck-rounded-corners;\n\n	&.ck-focused {\n		@mixin ck-focus-ring;\n		@mixin ck-box-shadow var(--ck-inner-shadow);\n	}\n}\n\n.ck.ck-editor__editable_inline {\n	overflow: auto;\n	padding: 0 var(--ck-spacing-standard);\n	border: 1px solid transparent;\n\n	&[dir="ltr"] {\n		text-align: left;\n	}\n\n	&[dir="rtl"] {\n		text-align: right;\n	}\n\n	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/116 */\n	& > *:first-child {\n		margin-top: var(--ck-spacing-large);\n	}\n\n	/* https://github.com/ckeditor/ckeditor5/issues/847 */\n	& > *:last-child {\n		/*\n		 * This value should match with the default margins of the block elements (like .media or .image)\n		 * to avoid a content jumping when the fake selection container shows up (See https://github.com/ckeditor/ckeditor5/issues/9825).\n		 */\n		margin-bottom: var(--ck-spacing-large);\n	}\n\n	/* https://github.com/ckeditor/ckeditor5/issues/6517 */\n	&.ck-blurred ::selection {\n		background: var(--ck-color-editable-blur-selection);\n	}\n}\n\n/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/111 */\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_n"] {\n	&::after {\n		border-bottom-color: var(--ck-color-panel-background);\n	}\n}\n\n.ck.ck-balloon-panel.ck-toolbar-container[class*="arrow_s"] {\n	&::after {\n		border-top-color: var(--ck-color-panel-background);\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n	/* Disable native outline. */\n	outline: none;\n	border: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n	box-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n	@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 8847: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-form__header{align-items:center;display:flex;flex-direction:row;flex-wrap:nowrap;justify-content:space-between}.ck.ck-form__header h2.ck-form__header__label{flex-grow:1}:root{--ck-form-header-height:38px}.ck.ck-form__header{border-bottom:1px solid var(--ck-color-base-border);height:var(--ck-form-header-height);line-height:var(--ck-form-header-height);padding:var(--ck-spacing-small) var(--ck-spacing-large)}[dir=ltr] .ck.ck-form__header .ck-icon{margin-right:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-form__header .ck-icon{margin-left:var(--ck-spacing-medium)}.ck.ck-form__header .ck-form__header__label{font-weight:700}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/formheader/formheader.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/formheader/formheader.css"], names: [], mappings: "AAKA,oBAIC,kBAAmB,CAHnB,YAAa,CACb,kBAAmB,CACnB,gBAAiB,CAEjB,6BAKD,CAHC,8CACC,WACD,CCPD,MACC,4BACD,CAEA,oBAIC,mDAAoD,CAFpD,mCAAoC,CACpC,wCAAyC,CAFzC,uDAkBD,CAbC,uCAEE,qCAMF,CARA,uCAME,oCAEF,CAEA,4CACC,eACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-form__header {\n	display: flex;\n	flex-direction: row;\n	flex-wrap: nowrap;\n	align-items: center;\n	justify-content: space-between;\n\n	& h2.ck-form__header__label {\n		flex-grow: 1;\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n	--ck-form-header-height: 38px;\n}\n\n.ck.ck-form__header {\n	padding: var(--ck-spacing-small) var(--ck-spacing-large);\n	height: var(--ck-form-header-height);\n	line-height: var(--ck-form-header-height);\n	border-bottom: 1px solid var(--ck-color-base-border);\n\n	& .ck-icon {\n		@mixin ck-dir ltr {\n			margin-right: var(--ck-spacing-medium);\n		}\n\n		@mixin ck-dir rtl {\n			margin-left: var(--ck-spacing-medium);\n		}\n	}\n\n	& .ck-form__header__label {\n		font-weight: bold;\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 8960: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-highlighted-text mark{background:var(--ck-color-highlight-background);font-size:inherit;font-weight:inherit;line-height:inherit;vertical-align:initial}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/highlightedtext/highlightedtext.css"], names: [], mappings: "AAKA,6BACC,+CAAgD,CAIhD,iBAAkB,CAFlB,mBAAoB,CACpB,mBAAoB,CAFpB,sBAID", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-highlighted-text mark {\n	background: var(--ck-color-highlight-background);\n	vertical-align: initial;\n	font-weight: inherit;\n	line-height: inherit;\n	font-size: inherit;\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 6574: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-icon{vertical-align:middle}:root{--ck-icon-size:calc(var(--ck-line-height-base)*var(--ck-font-size-normal))}.ck.ck-icon{font-size:.8333350694em;height:var(--ck-icon-size);width:var(--ck-icon-size);will-change:transform}.ck.ck-icon,.ck.ck-icon *{cursor:inherit}.ck.ck-icon.ck-icon_inherit-color,.ck.ck-icon.ck-icon_inherit-color *{color:inherit}.ck.ck-icon.ck-icon_inherit-color :not([fill]){fill:currentColor}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/icon/icon.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/icon/icon.css"], names: [], mappings: "AAKA,YACC,qBACD,CCFA,MACC,0EACD,CAEA,YAKC,uBAAwB,CAHxB,0BAA2B,CAD3B,yBAA0B,CAU1B,qBAoBD,CAlBC,0BALA,cAQA,CAMC,sEACC,aAMD,CAJC,+CAEC,iBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-icon {\n	vertical-align: middle;\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-icon-size: calc(var(--ck-line-height-base) * var(--ck-font-size-normal));\n}\n\n.ck.ck-icon {\n	width: var(--ck-icon-size);\n	height: var(--ck-icon-size);\n\n	/* Multiplied by the height of the line in "px" should give SVG "viewport" dimensions */\n	font-size: .8333350694em;\n\n	/* Inherit cursor style (#5). */\n	cursor: inherit;\n\n	/* This will prevent blurry icons on Firefox. See #340. */\n	will-change: transform;\n\n	& * {\n		/* Inherit cursor style (#5). */\n		cursor: inherit;\n	}\n\n	/* Allows dynamic coloring of an icon by inheriting its color from the parent. */\n	&.ck-icon_inherit-color {\n		color: inherit;\n\n		& * {\n			color: inherit;\n\n			&:not([fill]) {\n				/* Needed by FF. */\n				fill: currentColor;\n			}\n		}\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 4879: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-input-width:18em;--ck-input-text-width:var(--ck-input-width)}.ck.ck-input{border-radius:0}.ck-rounded-corners .ck.ck-input,.ck.ck-input.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-input{background:var(--ck-color-input-background);border:1px solid var(--ck-color-input-border);min-height:var(--ck-ui-component-min-height);min-width:var(--ck-input-width);padding:var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);transition:box-shadow .1s ease-in-out,border .1s ease-in-out}.ck.ck-input:focus{border:var(--ck-focus-ring);box-shadow:var(--ck-focus-outer-shadow),0 0;outline:none}.ck.ck-input[readonly]{background:var(--ck-color-input-disabled-background);border:1px solid var(--ck-color-input-disabled-border);color:var(--ck-color-input-disabled-text)}.ck.ck-input[readonly]:focus{box-shadow:var(--ck-focus-disabled-outer-shadow),0 0}.ck.ck-input.ck-error{animation:ck-input-shake .3s ease both;border-color:var(--ck-color-input-error-border)}.ck.ck-input.ck-error:focus{box-shadow:var(--ck-focus-error-outer-shadow),0 0}@keyframes ck-input-shake{20%{transform:translateX(-2px)}40%{transform:translateX(2px)}60%{transform:translateX(-1px)}80%{transform:translateX(1px)}}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/input/input.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AASA,MACC,qBAAsB,CAGtB,2CACD,CAEA,aCLC,eD2CD,CAtCA,iECDE,qCDuCF,CAtCA,aAGC,2CAA4C,CAC5C,6CAA8C,CAK9C,4CAA6C,CAH7C,+BAAgC,CADhC,6DAA8D,CAO9D,4DA0BD,CAxBC,mBEnBA,2BAA2B,CCF3B,2CAA8B,CDC9B,YFuBA,CAEA,uBAEC,oDAAqD,CADrD,sDAAuD,CAEvD,yCAMD,CAJC,6BG/BD,oDHkCC,CAGD,sBAEC,sCAAuC,CADvC,+CAMD,CAHC,4BGzCD,iDH2CC,CAIF,0BACC,IACC,0BACD,CAEA,IACC,yBACD,CAEA,IACC,0BACD,CAEA,IACC,yBACD,CACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_focus.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n	--ck-input-width: 18em;\n\n	/* Backward compatibility. */\n	--ck-input-text-width: var(--ck-input-width);\n}\n\n.ck.ck-input {\n	@mixin ck-rounded-corners;\n\n	background: var(--ck-color-input-background);\n	border: 1px solid var(--ck-color-input-border);\n	padding: var(--ck-spacing-extra-tiny) var(--ck-spacing-medium);\n	min-width: var(--ck-input-width);\n\n	/* This is important to stay of the same height as surrounding buttons */\n	min-height: var(--ck-ui-component-min-height);\n\n	/* Apply some smooth transition to the box-shadow and border. */\n	transition: box-shadow .1s ease-in-out, border .1s ease-in-out;\n\n	&:focus {\n		@mixin ck-focus-ring;\n		@mixin ck-box-shadow var(--ck-focus-outer-shadow);\n	}\n\n	&[readonly] {\n		border: 1px solid var(--ck-color-input-disabled-border);\n		background: var(--ck-color-input-disabled-background);\n		color: var(--ck-color-input-disabled-text);\n\n		&:focus {\n			/* The read-only input should have a slightly less visible shadow when focused. */\n			@mixin ck-box-shadow var(--ck-focus-disabled-outer-shadow);\n		}\n	}\n\n	&.ck-error {\n		border-color: var(--ck-color-input-error-border);\n		animation: ck-input-shake .3s ease both;\n\n		&:focus {\n			@mixin ck-box-shadow var(--ck-focus-error-outer-shadow);\n		}\n	}\n}\n\n@keyframes ck-input-shake {\n	20% {\n		transform: translateX(-2px);\n	}\n\n	40% {\n		transform: translateX(2px);\n	}\n\n	60% {\n		transform: translateX(-1px);\n	}\n\n	80% {\n		transform: translateX(1px);\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n	/* Disable native outline. */\n	outline: none;\n	border: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n	box-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n	@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3662: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-label{display:block}.ck.ck-voice-label{display:none}.ck.ck-label{font-weight:700}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/label/label.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/label/label.css"], names: [], mappings: "AAKA,aACC,aACD,CAEA,mBACC,YACD,CCNA,aACC,eACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n	display: block;\n}\n\n.ck.ck-voice-label {\n	display: none;\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-label {\n	font-weight: bold;\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 2577: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{display:flex;position:relative}.ck.ck-labeled-field-view .ck.ck-label{display:block;position:absolute}:root{--ck-labeled-field-view-transition:.1s cubic-bezier(0,0,0.24,0.95);--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-spacing-medium);--ck-labeled-field-label-default-position-x:var(--ck-spacing-medium);--ck-labeled-field-label-default-position-y:calc(var(--ck-font-size-base)*0.6);--ck-color-labeled-field-label-background:var(--ck-color-base-background)}.ck.ck-labeled-field-view{border-radius:0}.ck-rounded-corners .ck.ck-labeled-field-view,.ck.ck-labeled-field-view.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper{width:100%}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{top:0}[dir=ltr] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{left:0;transform:translate(var(--ck-spacing-medium),-6px) scale(.75);transform-origin:0 0}[dir=rtl] .ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{right:0;transform:translate(calc(var(--ck-spacing-medium)*-1),-6px) scale(.75);transform-origin:100% 0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:var(--ck-color-labeled-field-label-background);font-weight:400;line-height:normal;max-width:100%;overflow:hidden;padding:0 calc(var(--ck-font-size-tiny)*.5);pointer-events:none;text-overflow:ellipsis;transition:transform var(--ck-labeled-field-view-transition),padding var(--ck-labeled-field-view-transition),background var(--ck-labeled-field-view-transition)}.ck.ck-labeled-field-view.ck-error .ck-input:not([readonly])+.ck.ck-label,.ck.ck-labeled-field-view.ck-error>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view .ck-labeled-field-view__status{font-size:var(--ck-font-size-small);margin-top:var(--ck-spacing-small);white-space:normal}.ck.ck-labeled-field-view .ck-labeled-field-view__status.ck-labeled-field-view__status_error{color:var(--ck-color-base-error)}.ck.ck-labeled-field-view.ck-disabled>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{color:var(--ck-color-input-disabled-text)}[dir=ltr] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=ltr] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(var(--ck-labeled-field-label-default-position-x),var(--ck-labeled-field-label-default-position-y)) scale(1)}[dir=rtl] .ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,[dir=rtl] .ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{transform:translate(calc(var(--ck-labeled-field-label-default-position-x)*-1),var(--ck-labeled-field-label-default-position-y)) scale(1)}.ck.ck-labeled-field-view.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label,.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{background:transparent;max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width));padding:0}.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck.ck-button{background:transparent}.ck.ck-labeled-field-view.ck-labeled-field-view_empty>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown>.ck-button>.ck-button__label{opacity:0}.ck.ck-labeled-field-view.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder)>.ck.ck-labeled-field-view__input-wrapper>.ck-dropdown+.ck-label{max-width:calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard))}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/labeledfield/labeledfieldview.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/labeledfield/labeledfieldview.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAMC,mEACC,YAAa,CACb,iBACD,CAEA,uCACC,aAAc,CACd,iBACD,CCND,MACC,kEAAsE,CACtE,gFAAiF,CACjF,oEAAqE,CACrE,8EAAiF,CACjF,yEACD,CAEA,0BCLC,eD+GD,CA1GA,2FCDE,qCD2GF,CAvGC,mEACC,UAoCD,CAlCC,gFACC,KAgCD,CAjCA,0FAIE,MAAS,CAGT,6DAA+D,CAF/D,oBA4BF,CAjCA,0FAWE,OAAU,CAEV,sEAA0E,CAD1E,uBAqBF,CAjCA,gFAkBC,yDAA0D,CAG1D,eAAmB,CADnB,kBAAoB,CAOpB,cAAe,CAFf,eAAgB,CANhB,2CAA8C,CAH9C,mBAAoB,CAQpB,sBAAuB,CAKvB,+JAID,CAQA,mKACC,gCACD,CAGD,yDACC,mCAAoC,CACpC,kCAAmC,CAInC,kBAKD,CAHC,6FACC,gCACD,CAID,4OAEC,yCACD,CAIA,4WAGE,+HAYF,CAfA,4WAOE,wIAQF,CAfA,wVAaC,sBAAuB,CAFvB,iEAAkE,CAGlE,SACD,CAKA,8FACC,sBACD,CAGA,yIACC,SACD,CAGA,kMACC,8HACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-labeled-field-view {\n	& > .ck.ck-labeled-field-view__input-wrapper {\n		display: flex;\n		position: relative;\n	}\n\n	& .ck.ck-label {\n		display: block;\n		position: absolute;\n	}\n}\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";
@import "../../../mixins/_rounded.css";

:root {
	--ck-labeled-field-view-transition: .1s cubic-bezier(0, 0, 0.24, 0.95);
	--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-spacing-medium);
	--ck-labeled-field-label-default-position-x: var(--ck-spacing-medium);
	--ck-labeled-field-label-default-position-y: calc(0.6 * var(--ck-font-size-base));
	--ck-color-labeled-field-label-background: var(--ck-color-base-background);
}

.ck.ck-labeled-field-view {
	@mixin ck-rounded-corners;

	& > .ck.ck-labeled-field-view__input-wrapper {
		width: 100%;

		& > .ck.ck-label {
			top: 0px;

			@mixin ck-dir ltr {
				left: 0px;
				transform-origin: 0 0;
				/* By default, display the label scaled down above the field. */
				transform: translate(var(--ck-spacing-medium), -6px) scale(.75);
			}

			@mixin ck-dir rtl {
				right: 0px;
				transform-origin: 100% 0;
				transform: translate(calc(-1 * var(--ck-spacing-medium)), -6px) scale(.75);
			}

			pointer-events: none;

			background: var(--ck-color-labeled-field-label-background);
			padding: 0 calc(.5 * var(--ck-font-size-tiny));
			line-height: initial;
			font-weight: normal;

			/* Prevent overflow when the label is longer than the input */
			text-overflow: ellipsis;
			overflow: hidden;

			max-width: 100%;

			transition:
				transform var(--ck-labeled-field-view-transition),
				padding var(--ck-labeled-field-view-transition),
				background var(--ck-labeled-field-view-transition);
		}
	}

	&.ck-error {
		& > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
			color: var(--ck-color-base-error);
		}

		& .ck-input:not([readonly]) + .ck.ck-label {
			color: var(--ck-color-base-error);
		}
	}

	& .ck-labeled-field-view__status {
		font-size: var(--ck-font-size-small);
		margin-top: var(--ck-spacing-small);

		/* Let the info wrap to the next line to avoid stretching the layout horizontally.
		The status could be very long. */
		white-space: normal;

		&.ck-labeled-field-view__status_error {
			color: var(--ck-color-base-error);
		}
	}

	/* Disabled fields and fields that have no focus should fade out. */
	&.ck-disabled > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,
	&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
		color: var(--ck-color-input-disabled-text);
	}

	/* Fields that are disabled or not focused and without a placeholder should have full-sized labels. */
	/* stylelint-disable-next-line no-descending-specificity */
	&.ck-disabled.ck-labeled-field-view_empty:not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label,
	&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
		@mixin ck-dir ltr {
			transform: translate(var(--ck-labeled-field-label-default-position-x), var(--ck-labeled-field-label-default-position-y)) scale(1);
		}

		@mixin ck-dir rtl {
			transform: translate(calc(-1 * var(--ck-labeled-field-label-default-position-x)), var(--ck-labeled-field-label-default-position-y)) scale(1);
		}

		/* Compensate for the default translate position. */
		max-width: calc(var(--ck-labeled-field-empty-unfocused-max-width));

		background: transparent;
		padding: 0;
	}

	/*------ DropdownView integration ----------------------------------------------------------------------------------- */

	/* Make sure dropdown' background color in any of dropdown's state does not collide with labeled field. */
	& > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck.ck-button {
		background: transparent;
	}

	/* When the dropdown is "empty", the labeled field label replaces its label. */
	&.ck-labeled-field-view_empty > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown > .ck-button > .ck-button__label {
		opacity: 0;
	}

	/* Make sure the label of the empty, unfocused input does not cover the dropdown arrow. */
	&.ck-labeled-field-view_empty:not(.ck-labeled-field-view_focused):not(.ck-labeled-field-view_placeholder) > .ck.ck-labeled-field-view__input-wrapper > .ck-dropdown + .ck-label {
		max-width: calc(var(--ck-labeled-field-empty-unfocused-max-width) - var(--ck-dropdown-arrow-size) - var(--ck-spacing-standard));
	}
}
`, "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 1046: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-list{display:flex;flex-direction:column;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-list .ck-list__item,.ck.ck-list .ck-list__separator{display:block}.ck.ck-list .ck-list__item>:focus{position:relative;z-index:var(--ck-z-default)}:root{--ck-list-button-padding:calc(var(--ck-line-height-base)*0.2*var(--ck-font-size-base)) calc(var(--ck-line-height-base)*0.4*var(--ck-font-size-base))}.ck.ck-list{border-radius:0}.ck-rounded-corners .ck.ck-list,.ck.ck-list.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-list{background:var(--ck-color-list-background);list-style-type:none}.ck.ck-list__item{cursor:default;min-width:12em}.ck.ck-list__item .ck-button{border-radius:0;min-height:unset;width:100%}[dir=ltr] .ck.ck-list__item .ck-button{text-align:left}[dir=rtl] .ck.ck-list__item .ck-button{text-align:right}.ck.ck-list__item .ck-button{padding:var(--ck-list-button-padding)}.ck.ck-list__item .ck-button .ck-button__label{line-height:calc(var(--ck-line-height-base)*1.2*var(--ck-font-size-base))}.ck.ck-list__item .ck-button:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on{background:var(--ck-color-list-button-on-background);color:var(--ck-color-list-button-on-text)}.ck.ck-list__item .ck-button.ck-on:active{box-shadow:none}.ck.ck-list__item .ck-button.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-on-background-focus)}.ck.ck-list__item .ck-button.ck-on:focus:not(.ck-switchbutton):not(.ck-disabled){border-color:var(--ck-color-base-background)}.ck.ck-list__item .ck-button:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background)}.ck.ck-list__item .ck-switchbutton.ck-on{background:var(--ck-color-list-background);color:inherit}.ck.ck-list__item .ck-switchbutton.ck-on:hover:not(.ck-disabled){background:var(--ck-color-list-button-hover-background);color:inherit}.ck-list .ck-list__group{padding-top:var(--ck-spacing-medium);:not(.ck-hidden)~&{border-top:1px solid var(--ck-color-base-border)}}.ck-list .ck-list__group>.ck-label{font-size:11px;font-weight:700;padding:var(--ck-spacing-medium) var(--ck-spacing-medium) 0 var(--ck-spacing-medium)}.ck.ck-list__separator{background:var(--ck-color-base-border);height:1px;width:100%}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/list/list.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/list/list.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,YAGC,YAAa,CACb,qBAAsB,CCFtB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBDaD,CAZC,2DAEC,aACD,CAKA,kCACC,iBAAkB,CAClB,2BACD,CEdD,MACC,oJAGD,CAEA,YCLC,eDUD,CALA,+DCDE,qCDMF,CALA,YAIC,0CAA2C,CAD3C,oBAED,CAEA,kBACC,cAAe,CACf,cAgED,CA9DC,6BAGC,eAAgB,CAFhB,gBAAiB,CACjB,UA6CD,CA/CA,uCAME,eAyCF,CA/CA,uCAUE,gBAqCF,CA/CA,6BAgBC,qCA+BD,CA7BC,+CAEC,yEACD,CAEA,oCACC,eACD,CAEA,mCACC,oDAAqD,CACrD,yCAaD,CAXC,0CACC,eACD,CAEA,2DACC,0DACD,CAEA,iFACC,4CACD,CAGD,qDACC,uDACD,CAMA,yCACC,0CAA2C,CAC3C,aAMD,CAJC,iEACC,uDAAwD,CACxD,aACD,CAKH,yBACC,oCAAqC,CAGrC,mBACC,gDACD,CAOD,CALC,mCACC,cAAe,CACf,eAAiB,CACjB,oFACD,CAGD,uBAGC,sCAAuC,CAFvC,UAAW,CACX,UAED", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-list {\n	@mixin ck-unselectable;\n\n	display: flex;\n	flex-direction: column;\n\n	& .ck-list__item,\n	& .ck-list__separator {\n		display: block;\n	}\n\n	/* Make sure that whatever child of the list item gets focus, it remains on the\n	top. Thanks to that, styles like box-shadow, outline, etc. are not masked by\n	adjacent list items. */\n	& .ck-list__item > *:focus {\n		position: relative;\n		z-index: var(--ck-z-default);\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n	-moz-user-select: none;\n	-webkit-user-select: none;\n	-ms-user-select: none;\n	user-select: none\n}\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_disabled.css";
@import "../../../mixins/_rounded.css";
@import "../../../mixins/_shadow.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

:root {
	--ck-list-button-padding:
		calc(.2 * var(--ck-line-height-base) * var(--ck-font-size-base))
		calc(.4 * var(--ck-line-height-base) * var(--ck-font-size-base));
}

.ck.ck-list {
	@mixin ck-rounded-corners;

	list-style-type: none;
	background: var(--ck-color-list-background);
}

.ck.ck-list__item {
	cursor: default;
	min-width: 12em;

	& .ck-button {
		min-height: unset;
		width: 100%;
		border-radius: 0;

		@mixin ck-dir ltr {
			text-align: left;
		}

		@mixin ck-dir rtl {
			text-align: right;
		}

		/* List items should have the same height. Use absolute units to make sure it is so
		   because e.g. different heading styles may have different height
		   https://github.com/ckeditor/ckeditor5-heading/issues/63 */
		padding: var(--ck-list-button-padding);

		& .ck-button__label {
			/* https://github.com/ckeditor/ckeditor5-heading/issues/63 */
			line-height: calc(1.2 * var(--ck-line-height-base) * var(--ck-font-size-base));
		}

		&:active {
			box-shadow: none;
		}

		&.ck-on {
			background: var(--ck-color-list-button-on-background);
			color: var(--ck-color-list-button-on-text);

			&:active {
				box-shadow: none;
			}

			&:hover:not(.ck-disabled) {
				background: var(--ck-color-list-button-on-background-focus);
			}

			&:focus:not(.ck-switchbutton):not(.ck-disabled) {
				border-color: var(--ck-color-base-background);
			}
		}

		&:hover:not(.ck-disabled) {
			background: var(--ck-color-list-button-hover-background);
		}
	}

	/* It's unnecessary to change the background/text of a switch toggle; it has different ways
	of conveying its state (like the switcher) */
	& .ck-switchbutton {
		&.ck-on {
			background: var(--ck-color-list-background);
			color: inherit;

			&:hover:not(.ck-disabled) {
				background: var(--ck-color-list-button-hover-background);
				color: inherit;
			}
		}
	}
}

.ck-list .ck-list__group {
	padding-top: var(--ck-spacing-medium);

	/* The group should have a border when it's not the first item. */
	*:not(.ck-hidden) ~ & {
		border-top: 1px solid var(--ck-color-base-border);
	}

	& > .ck-label {
		font-size: 11px;
		font-weight: bold;
		padding: var(--ck-spacing-medium) var(--ck-spacing-medium) 0 var(--ck-spacing-medium);
	}
}

.ck.ck-list__separator {
	height: 1px;
	width: 100%;
	background: var(--ck-color-base-border);
}
`, "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 8793: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ':root{--ck-balloon-panel-arrow-z-index:calc(var(--ck-z-default) - 3)}.ck.ck-balloon-panel{display:none;position:absolute;z-index:var(--ck-z-modal)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{content:"";position:absolute}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_n]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_n]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel[class*=arrow_s]:before{z-index:var(--ck-balloon-panel-arrow-z-index)}.ck.ck-balloon-panel[class*=arrow_s]:after{z-index:calc(var(--ck-balloon-panel-arrow-z-index) + 1)}.ck.ck-balloon-panel.ck-balloon-panel_visible{display:block}:root{--ck-balloon-border-width:1px;--ck-balloon-arrow-offset:2px;--ck-balloon-arrow-height:10px;--ck-balloon-arrow-half-width:8px;--ck-balloon-arrow-drop-shadow:0 2px 2px var(--ck-color-shadow-drop)}.ck.ck-balloon-panel{border-radius:0}.ck-rounded-corners .ck.ck-balloon-panel,.ck.ck-balloon-panel.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-balloon-panel{background:var(--ck-color-panel-background);border:var(--ck-balloon-border-width) solid var(--ck-color-panel-border);box-shadow:var(--ck-drop-shadow),0 0;min-height:15px}.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:after,.ck.ck-balloon-panel.ck-balloon-panel_with-arrow:before{border-style:solid;height:0;width:0}.ck.ck-balloon-panel[class*=arrow_n]:after,.ck.ck-balloon-panel[class*=arrow_n]:before{border-width:0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_n]:before{border-color:transparent transparent var(--ck-color-panel-border) transparent;margin-top:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_n]:after{border-color:transparent transparent var(--ck-color-panel-background) transparent;margin-top:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_s]:after,.ck.ck-balloon-panel[class*=arrow_s]:before{border-width:var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width)}.ck.ck-balloon-panel[class*=arrow_s]:before{border-color:var(--ck-color-panel-border) transparent transparent;filter:drop-shadow(var(--ck-balloon-arrow-drop-shadow));margin-bottom:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_s]:after{border-color:var(--ck-color-panel-background) transparent transparent transparent;margin-bottom:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_e]:after,.ck.ck-balloon-panel[class*=arrow_e]:before{border-width:var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height)}.ck.ck-balloon-panel[class*=arrow_e]:before{border-color:transparent transparent transparent var(--ck-color-panel-border);margin-right:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_e]:after{border-color:transparent transparent transparent var(--ck-color-panel-background);margin-right:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel[class*=arrow_w]:after,.ck.ck-balloon-panel[class*=arrow_w]:before{border-width:var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0}.ck.ck-balloon-panel[class*=arrow_w]:before{border-color:transparent var(--ck-color-panel-border) transparent transparent;margin-left:calc(var(--ck-balloon-border-width)*-1)}.ck.ck-balloon-panel[class*=arrow_w]:after{border-color:transparent var(--ck-color-panel-background) transparent transparent;margin-left:calc(var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width))}.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_n:before{left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nw:before{left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_ne:before{right:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_s:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:50%;margin-left:calc(var(--ck-balloon-arrow-half-width)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_se:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);right:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_sme:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_smw:before{bottom:calc(var(--ck-balloon-arrow-height)*-1);left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nme:before{margin-right:calc(var(--ck-balloon-arrow-half-width)*2);right:25%;top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_nmw:before{left:25%;margin-left:calc(var(--ck-balloon-arrow-half-width)*2);top:calc(var(--ck-balloon-arrow-height)*-1)}.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_e:before{margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);right:calc(var(--ck-balloon-arrow-height)*-1);top:50%}.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:after,.ck.ck-balloon-panel.ck-balloon-panel_arrow_w:before{left:calc(var(--ck-balloon-arrow-height)*-1);margin-top:calc(var(--ck-balloon-arrow-half-width)*-1);top:50%}', "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/panel/balloonpanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonpanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,MAEC,8DACD,CAEA,qBACC,YAAa,CACb,iBAAkB,CAElB,yBAyCD,CAtCE,+GAEC,UAAW,CACX,iBACD,CAEA,wDACC,6CACD,CAEA,uDACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAIA,4CACC,6CACD,CAEA,2CACC,uDACD,CAGD,8CACC,aACD,CC9CD,MACC,6BAA8B,CAC9B,6BAA8B,CAC9B,8BAA+B,CAC/B,iCAAkC,CAClC,oEACD,CAEA,qBCLC,eDmMD,CA9LA,iFCDE,qCD+LF,CA9LA,qBAMC,2CAA4C,CAC5C,wEAAyE,CEdzE,oCAA8B,CFW9B,eA0LD,CApLE,+GAIC,kBAAmB,CADnB,QAAS,CADT,OAGD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,kDACD,CAEA,2CACC,iFAAkF,CAClF,gFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,iEAAkE,CAClE,uDAAwD,CACxD,qDACD,CAEA,2CACC,iFAAkF,CAClF,mFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,oDACD,CAEA,2CACC,iFAAkF,CAClF,kFACD,CAIA,uFAEC,mHACD,CAEA,4CACC,6EAA8E,CAC9E,mDACD,CAEA,2CACC,iFAAkF,CAClF,iFACD,CAIA,yGAEC,QAAS,CACT,uDAA0D,CAC1D,2CACD,CAIA,2GAEC,+CAAkD,CAClD,2CACD,CAIA,2GAEC,gDAAmD,CACnD,2CACD,CAIA,yGAIC,8CAAiD,CAFjD,QAAS,CACT,uDAED,CAIA,2GAGC,8CAAiD,CADjD,+CAED,CAIA,2GAGC,8CAAiD,CADjD,gDAED,CAIA,6GAIC,8CAAiD,CADjD,uDAA0D,CAD1D,SAGD,CAIA,6GAIC,8CAAiD,CAFjD,QAAS,CACT,sDAED,CAIA,6GAGC,uDAA0D,CAD1D,SAAU,CAEV,2CACD,CAIA,6GAEC,QAAS,CACT,sDAAyD,CACzD,2CACD,CAIA,yGAGC,sDAAyD,CADzD,6CAAgD,CAEhD,OACD,CAIA,yGAEC,4CAA+C,CAC/C,sDAAyD,CACzD,OACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	/* Make sure the balloon arrow does not float over its children. */\n	--ck-balloon-panel-arrow-z-index: calc(var(--ck-z-default) - 3);\n}\n\n.ck.ck-balloon-panel {\n	display: none;\n	position: absolute;\n\n	z-index: var(--ck-z-modal);\n\n	&.ck-balloon-panel_with-arrow {\n		&::before,\n		&::after {\n			content: "";\n			position: absolute;\n		}\n\n		&::before {\n			z-index: var(--ck-balloon-panel-arrow-z-index);\n		}\n\n		&::after {\n			z-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n		}\n	}\n\n	&[class*="arrow_n"] {\n		&::before {\n			z-index: var(--ck-balloon-panel-arrow-z-index);\n		}\n\n		&::after {\n			z-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n		}\n	}\n\n	&[class*="arrow_s"] {\n		&::before {\n			z-index: var(--ck-balloon-panel-arrow-z-index);\n		}\n\n		&::after {\n			z-index: calc(var(--ck-balloon-panel-arrow-z-index) + 1);\n		}\n	}\n\n	&.ck-balloon-panel_visible {\n		display: block;\n	}\n}\n', '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n@import "../../../mixins/_shadow.css";\n\n:root {\n	--ck-balloon-border-width: 1px;\n	--ck-balloon-arrow-offset: 2px;\n	--ck-balloon-arrow-height: 10px;\n	--ck-balloon-arrow-half-width: 8px;\n	--ck-balloon-arrow-drop-shadow: 0 2px 2px var(--ck-color-shadow-drop);\n}\n\n.ck.ck-balloon-panel {\n	@mixin ck-rounded-corners;\n	@mixin ck-drop-shadow;\n\n	min-height: 15px;\n\n	background: var(--ck-color-panel-background);\n	border: var(--ck-balloon-border-width) solid var(--ck-color-panel-border);\n\n	&.ck-balloon-panel_with-arrow {\n		&::before,\n		&::after {\n			width: 0;\n			height: 0;\n			border-style: solid;\n		}\n	}\n\n	&[class*="arrow_n"] {\n		&::before,\n		&::after {\n			border-width: 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width);\n		}\n\n		&::before {\n			border-color: transparent transparent var(--ck-color-panel-border) transparent;\n			margin-top: calc( -1 * var(--ck-balloon-border-width) );\n		}\n\n		&::after {\n			border-color: transparent transparent var(--ck-color-panel-background) transparent;\n			margin-top: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n		}\n	}\n\n	&[class*="arrow_s"] {\n		&::before,\n		&::after {\n			border-width: var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width);\n		}\n\n		&::before {\n			border-color: var(--ck-color-panel-border) transparent transparent;\n			filter: drop-shadow(var(--ck-balloon-arrow-drop-shadow));\n			margin-bottom: calc( -1 * var(--ck-balloon-border-width) );\n		}\n\n		&::after {\n			border-color: var(--ck-color-panel-background) transparent transparent transparent;\n			margin-bottom: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n		}\n	}\n\n	&[class*="arrow_e"] {\n		&::before,\n		&::after {\n			border-width: var(--ck-balloon-arrow-half-width) 0 var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height);\n		}\n\n		&::before {\n			border-color: transparent transparent transparent var(--ck-color-panel-border);\n			margin-right: calc( -1 * var(--ck-balloon-border-width) );\n		}\n\n		&::after {\n			border-color: transparent transparent transparent var(--ck-color-panel-background);\n			margin-right: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n		}\n	}\n\n	&[class*="arrow_w"] {\n		&::before,\n		&::after {\n			border-width: var(--ck-balloon-arrow-half-width) var(--ck-balloon-arrow-height) var(--ck-balloon-arrow-half-width) 0;\n		}\n\n		&::before {\n			border-color: transparent var(--ck-color-panel-border) transparent transparent;\n			margin-left: calc( -1 * var(--ck-balloon-border-width) );\n		}\n\n		&::after {\n			border-color: transparent var(--ck-color-panel-background) transparent transparent;\n			margin-left: calc( var(--ck-balloon-arrow-offset) - var(--ck-balloon-border-width) );\n		}\n	}\n\n	&.ck-balloon-panel_arrow_n {\n		&::before,\n		&::after {\n			left: 50%;\n			margin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n			top: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_nw {\n		&::before,\n		&::after {\n			left: calc(2 * var(--ck-balloon-arrow-half-width));\n			top: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_ne {\n		&::before,\n		&::after {\n			right: calc(2 * var(--ck-balloon-arrow-half-width));\n			top: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_s {\n		&::before,\n		&::after {\n			left: 50%;\n			margin-left: calc(-1 * var(--ck-balloon-arrow-half-width));\n			bottom: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_sw {\n		&::before,\n		&::after {\n			left: calc(2 * var(--ck-balloon-arrow-half-width));\n			bottom: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_se {\n		&::before,\n		&::after {\n			right: calc(2 * var(--ck-balloon-arrow-half-width));\n			bottom: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_sme {\n		&::before,\n		&::after {\n			right: 25%;\n			margin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n			bottom: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_smw {\n		&::before,\n		&::after {\n			left: 25%;\n			margin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n			bottom: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_nme {\n		&::before,\n		&::after {\n			right: 25%;\n			margin-right: calc(2 * var(--ck-balloon-arrow-half-width));\n			top: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_nmw {\n		&::before,\n		&::after {\n			left: 25%;\n			margin-left: calc(2 * var(--ck-balloon-arrow-half-width));\n			top: calc(-1 * var(--ck-balloon-arrow-height));\n		}\n	}\n\n	&.ck-balloon-panel_arrow_e {\n		&::before,\n		&::after {\n			right: calc(-1 * var(--ck-balloon-arrow-height));\n			margin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n			top: 50%;\n		}\n	}\n\n	&.ck-balloon-panel_arrow_w {\n		&::before,\n		&::after {\n			left: calc(-1 * var(--ck-balloon-arrow-height));\n			margin-top: calc(-1 * var(--ck-balloon-arrow-half-width));\n			top: 50%;\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n	box-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n	@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4650: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck .ck-balloon-rotator__navigation{align-items:center;display:flex;justify-content:center}.ck .ck-balloon-rotator__content .ck-toolbar{justify-content:center}.ck .ck-balloon-rotator__navigation{background:var(--ck-color-toolbar-background);border-bottom:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation>*{margin-bottom:var(--ck-spacing-small);margin-right:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck .ck-balloon-rotator__navigation .ck-balloon-rotator__counter{margin-left:var(--ck-spacing-small);margin-right:var(--ck-spacing-standard)}.ck .ck-balloon-rotator__content .ck.ck-annotation-wrapper{box-shadow:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/panel/balloonrotator.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/balloonrotator.css"], names: [], mappings: "AAKA,oCAEC,kBAAmB,CADnB,YAAa,CAEb,sBACD,CAKA,6CACC,sBACD,CCXA,oCACC,6CAA8C,CAC9C,sDAAuD,CACvD,iCAgBD,CAbC,sCAGC,qCAAsC,CAFtC,oCAAqC,CACrC,kCAED,CAGA,iEAIC,mCAAoC,CAHpC,uCAID,CAMA,2DACC,eACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n	display: flex;\n	align-items: center;\n	justify-content: center;\n}\n\n/* Buttons inside a toolbar should be centered when rotator bar is wider.\n * See: https://github.com/ckeditor/ckeditor5-ui/issues/495\n */\n.ck .ck-balloon-rotator__content .ck-toolbar {\n	justify-content: center;\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-balloon-rotator__navigation {\n	background: var(--ck-color-toolbar-background);\n	border-bottom: 1px solid var(--ck-color-toolbar-border);\n	padding: 0 var(--ck-spacing-small);\n\n	/* Let's keep similar appearance to `ck-toolbar`. */\n	& > * {\n		margin-right: var(--ck-spacing-small);\n		margin-top: var(--ck-spacing-small);\n		margin-bottom: var(--ck-spacing-small);\n	}\n\n	/* Gives counter more breath than buttons. */\n	& .ck-balloon-rotator__counter {\n		margin-right: var(--ck-spacing-standard);\n\n		/* We need to use smaller margin because of previous button's right margin. */\n		margin-left: var(--ck-spacing-small);\n	}\n}\n\n.ck .ck-balloon-rotator__content {\n\n	/* Disable default annotation shadow inside rotator with fake panels. */\n	& .ck.ck-annotation-wrapper {\n		box-shadow: none;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 7676: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck .ck-fake-panel{position:absolute;z-index:calc(var(--ck-z-modal) - 1)}.ck .ck-fake-panel div{position:absolute}.ck .ck-fake-panel div:first-child{z-index:2}.ck .ck-fake-panel div:nth-child(2){z-index:1}:root{--ck-balloon-fake-panel-offset-horizontal:6px;--ck-balloon-fake-panel-offset-vertical:6px}.ck .ck-fake-panel div{background:var(--ck-color-panel-background);border:1px solid var(--ck-color-panel-border);border-radius:var(--ck-border-radius);box-shadow:var(--ck-drop-shadow),0 0;height:100%;min-height:15px;width:100%}.ck .ck-fake-panel div:first-child{margin-left:var(--ck-balloon-fake-panel-offset-horizontal);margin-top:var(--ck-balloon-fake-panel-offset-vertical)}.ck .ck-fake-panel div:nth-child(2){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*2);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*2)}.ck .ck-fake-panel div:nth-child(3){margin-left:calc(var(--ck-balloon-fake-panel-offset-horizontal)*3);margin-top:calc(var(--ck-balloon-fake-panel-offset-vertical)*3)}.ck .ck-balloon-panel_arrow_s+.ck-fake-panel,.ck .ck-balloon-panel_arrow_se+.ck-fake-panel,.ck .ck-balloon-panel_arrow_sw+.ck-fake-panel{--ck-balloon-fake-panel-offset-vertical:-6px}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/panel/fakepanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/fakepanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,mBACC,iBAAkB,CAGlB,mCACD,CAEA,uBACC,iBACD,CAEA,mCACC,SACD,CAEA,oCACC,SACD,CCfA,MACC,6CAA8C,CAC9C,2CACD,CAGA,uBAKC,2CAA4C,CAC5C,6CAA8C,CAC9C,qCAAsC,CCXtC,oCAA8B,CDc9B,WAAY,CAPZ,eAAgB,CAMhB,UAED,CAEA,mCACC,0DAA2D,CAC3D,uDACD,CAEA,oCACC,kEAAqE,CACrE,+DACD,CACA,oCACC,kEAAqE,CACrE,+DACD,CAGA,yIAGC,4CACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-fake-panel {\n	position: absolute;\n\n	/* Fake panels should be placed under main balloon content. */\n	z-index: calc(var(--ck-z-modal) - 1);\n}\n\n.ck .ck-fake-panel div {\n	position: absolute;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n	z-index: 2;\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n	z-index: 1;\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n:root {\n	--ck-balloon-fake-panel-offset-horizontal: 6px;\n	--ck-balloon-fake-panel-offset-vertical: 6px;\n}\n\n/* Let\'s use `.ck-balloon-panel` appearance. See: balloonpanel.css. */\n.ck .ck-fake-panel div {\n	@mixin ck-drop-shadow;\n\n	min-height: 15px;\n\n	background: var(--ck-color-panel-background);\n	border: 1px solid var(--ck-color-panel-border);\n	border-radius: var(--ck-border-radius);\n\n	width: 100%;\n	height: 100%;\n}\n\n.ck .ck-fake-panel div:nth-child( 1 ) {\n	margin-left: var(--ck-balloon-fake-panel-offset-horizontal);\n	margin-top: var(--ck-balloon-fake-panel-offset-vertical);\n}\n\n.ck .ck-fake-panel div:nth-child( 2 ) {\n	margin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 2);\n	margin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 2);\n}\n.ck .ck-fake-panel div:nth-child( 3 ) {\n	margin-left: calc(var(--ck-balloon-fake-panel-offset-horizontal) * 3);\n	margin-top: calc(var(--ck-balloon-fake-panel-offset-vertical) * 3);\n}\n\n/* If balloon is positioned above element, we need to move fake panel to the top. */\n.ck .ck-balloon-panel_arrow_s + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_se + .ck-fake-panel,\n.ck .ck-balloon-panel_arrow_sw + .ck-fake-panel {\n	--ck-balloon-fake-panel-offset-vertical: -6px;\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n	box-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n	@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 5868: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-sticky-panel .ck-sticky-panel__content_sticky{position:fixed;top:0;z-index:var(--ck-z-modal)}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky_bottom-limit{position:absolute;top:auto}.ck.ck-sticky-panel .ck-sticky-panel__content_sticky{border-top-left-radius:0;border-top-right-radius:0;border-width:0 1px 1px;box-shadow:var(--ck-drop-shadow),0 0}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/panel/stickypanel.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/panel/stickypanel.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAMC,qDAEC,cAAe,CACf,KAAM,CAFN,yBAGD,CAEA,kEAEC,iBAAkB,CADlB,QAED,CCPA,qDAIC,wBAAyB,CACzB,yBAA0B,CAF1B,sBAAuB,CCFxB,oCDKA", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-sticky-panel {\n	& .ck-sticky-panel__content_sticky {\n		z-index: var(--ck-z-modal); /* #315 */\n		position: fixed;\n		top: 0;\n	}\n\n	& .ck-sticky-panel__content_sticky_bottom-limit {\n		top: auto;\n		position: absolute;\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_shadow.css";\n\n.ck.ck-sticky-panel {\n	& .ck-sticky-panel__content_sticky {\n		@mixin ck-drop-shadow;\n\n		border-width: 0 1px 1px;\n		border-top-left-radius: 0;\n		border-top-right-radius: 0;\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n	box-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n	@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 6764: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, '.ck-vertical-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck-vertical-form .ck-button:focus:after{display:none}@media screen and (max-width:600px){.ck.ck-responsive-form .ck-button:after{bottom:-1px;content:"";position:absolute;right:-1px;top:-1px;width:0;z-index:1}.ck.ck-responsive-form .ck-button:focus:after{display:none}}.ck-vertical-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form{padding:var(--ck-spacing-large)}.ck.ck-responsive-form:focus{outline:none}[dir=ltr] .ck.ck-responsive-form>:not(:first-child),[dir=rtl] .ck.ck-responsive-form>:not(:last-child){margin-left:var(--ck-spacing-standard)}@media screen and (max-width:600px){.ck.ck-responsive-form{padding:0;width:calc(var(--ck-input-width)*.8)}.ck.ck-responsive-form .ck-labeled-field-view{margin:var(--ck-spacing-large) var(--ck-spacing-large) 0}.ck.ck-responsive-form .ck-labeled-field-view .ck-input-text{min-width:0;width:100%}.ck.ck-responsive-form .ck-labeled-field-view .ck-labeled-field-view__error{white-space:normal}.ck.ck-responsive-form>.ck-button:nth-last-child(2):after{border-right:1px solid var(--ck-color-base-border)}.ck.ck-responsive-form>.ck-button:last-child,.ck.ck-responsive-form>.ck-button:nth-last-child(2){border-radius:0;margin-top:var(--ck-spacing-large);padding:var(--ck-spacing-standard)}.ck.ck-responsive-form>.ck-button:last-child:not(:focus),.ck.ck-responsive-form>.ck-button:nth-last-child(2):not(:focus){border-top:1px solid var(--ck-color-base-border)}[dir=ltr] .ck.ck-responsive-form>.ck-button:last-child,[dir=ltr] .ck.ck-responsive-form>.ck-button:nth-last-child(2),[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2){margin-left:0}[dir=rtl] .ck.ck-responsive-form>.ck-button:last-child:last-of-type,[dir=rtl] .ck.ck-responsive-form>.ck-button:nth-last-child(2):last-of-type{border-right:1px solid var(--ck-color-base-border)}}', "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/responsive-form/responsiveform.css", "webpack://./../ckeditor5-ui/theme/mixins/_rwd.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/responsive-form/responsiveform.css"], names: [], mappings: "AAQC,mCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,yCACC,YACD,CCdA,oCDoBE,wCAMC,WAAY,CALZ,UAAW,CAEX,iBAAkB,CAClB,UAAW,CACX,QAAS,CAHT,OAAQ,CAKR,SACD,CAEA,8CACC,YACD,CC9BF,CCAD,qDACC,kDACD,CAEA,uBACC,+BAmED,CAjEC,6BAEC,YACD,CASC,uGACC,sCACD,CDvBD,oCCMD,uBAqBE,SAAU,CACV,oCA8CF,CA5CE,8CACC,wDAWD,CATC,6DACC,WAAY,CACZ,UACD,CAGA,4EACC,kBACD,CAKA,0DACC,kDACD,CAGD,iGAIC,eAAgB,CADhB,kCAAmC,CADnC,kCAmBD,CAfC,yHACC,gDACD,CARD,0OAeE,aAMF,CAJE,+IACC,kDACD,CDpEH", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n\n.ck-vertical-form .ck-button {\n	&::after {\n		content: "";\n		width: 0;\n		position: absolute;\n		right: -1px;\n		top: -1px;\n		bottom: -1px;\n		z-index: 1;\n	}\n\n	&:focus::after {\n		display: none;\n	}\n}\n\n.ck.ck-responsive-form {\n	@mixin ck-media-phone {\n		& .ck-button {\n			&::after {\n				content: "";\n				width: 0;\n				position: absolute;\n				right: -1px;\n				top: -1px;\n				bottom: -1px;\n				z-index: 1;\n			}\n\n			&:focus::after {\n				display: none;\n			}\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@define-mixin ck-media-phone {\n	@media screen and (max-width: 600px) {\n		@mixin-content;\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_rwd.css";\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck-vertical-form > .ck-button:nth-last-child(2)::after {\n	border-right: 1px solid var(--ck-color-base-border);\n}\n\n.ck.ck-responsive-form {\n	padding: var(--ck-spacing-large);\n\n	&:focus {\n		/* See: https://github.com/ckeditor/ckeditor5/issues/4773 */\n		outline: none;\n	}\n\n	@mixin ck-dir ltr {\n		& > :not(:first-child) {\n			margin-left: var(--ck-spacing-standard);\n		}\n	}\n\n	@mixin ck-dir rtl {\n		& > :not(:last-child) {\n			margin-left: var(--ck-spacing-standard);\n		}\n	}\n\n	@mixin ck-media-phone {\n		padding: 0;\n		width: calc(.8 * var(--ck-input-width));\n\n		& .ck-labeled-field-view {\n			margin: var(--ck-spacing-large) var(--ck-spacing-large) 0;\n\n			& .ck-input-text {\n				min-width: 0;\n				width: 100%;\n			}\n\n			/* Let the long error messages wrap in the narrow form. */\n			& .ck-labeled-field-view__error {\n				white-space: normal;\n			}\n		}\n\n		/* Styles for two last buttons in the form (save&cancel, edit&unlink, etc.). */\n		& > .ck-button:nth-last-child(2) {\n			&::after {\n				border-right: 1px solid var(--ck-color-base-border);\n			}\n		}\n\n		& > .ck-button:nth-last-child(1),\n		& > .ck-button:nth-last-child(2) {\n			padding: var(--ck-spacing-standard);\n			margin-top: var(--ck-spacing-large);\n			border-radius: 0;\n\n			&:not(:focus) {\n				border-top: 1px solid var(--ck-color-base-border);\n			}\n\n			@mixin ck-dir ltr {\n				margin-left: 0;\n			}\n\n			@mixin ck-dir rtl {\n				margin-left: 0;\n\n				&:last-of-type {\n					border-right: 1px solid var(--ck-color-base-border);\n				}\n			}\n		}\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 6770: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{position:absolute;top:50%;transform:translateY(-50%)}[dir=ltr] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{left:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view>.ck-labeled-field-view__input-wrapper>.ck-icon{right:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view .ck-search__reset{position:absolute;top:50%;transform:translateY(-50%)}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{display:block}.ck.ck-search>.ck-search__results>.ck-search__info:not(.ck-hidden)~*{display:none}:root{--ck-search-field-view-horizontal-spacing:calc(var(--ck-icon-size) + var(--ck-spacing-medium))}.ck.ck-search>.ck-labeled-field-view .ck-input{width:100%}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon{--ck-labeled-field-label-default-position-x:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon>.ck-labeled-field-view__input-wrapper>.ck-icon{opacity:.5;pointer-events:none}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input,[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-icon .ck-input:not(.ck-input-text_empty){padding-left:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset{--ck-labeled-field-empty-unfocused-max-width:100% - 2 * var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset.ck-labeled-field-view_empty{--ck-labeled-field-empty-unfocused-max-width:100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{background:none;min-height:auto;min-width:auto;opacity:.5;padding:0}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{right:var(--ck-spacing-medium)}[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset{left:var(--ck-spacing-medium)}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-search__reset:hover{opacity:1}.ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{width:100%}[dir=ltr] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input:not(.ck-input-text_empty),[dir=rtl] .ck.ck-search>.ck-labeled-field-view.ck-search__query_with-reset .ck-input{padding-right:var(--ck-search-field-view-horizontal-spacing)}.ck.ck-search>.ck-search__results{min-width:100%}.ck.ck-search>.ck-search__results>.ck-search__info{padding:var(--ck-spacing-medium) var(--ck-spacing-large);width:100%}.ck.ck-search>.ck-search__results>.ck-search__info *{white-space:normal}.ck.ck-search>.ck-search__results>.ck-search__info>span:first-child{font-weight:700}.ck.ck-search>.ck-search__results>.ck-search__info>span:last-child{margin-top:var(--ck-spacing-medium)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/search/search.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/search/search.css"], names: [], mappings: "AASE,oFACC,iBAAkB,CAClB,OAAQ,CACR,0BASD,CAZA,8FAME,6BAMF,CAZA,8FAUE,8BAEF,CAEA,uDACC,iBAAkB,CAClB,OAAQ,CACR,0BACD,CAKC,oEACC,aACD,CAGA,qEACC,YACD,CChCH,MACC,8FACD,CAIE,+CACC,UACD,CAEA,gEACC,0FAoBD,CAlBC,+GACC,UAAW,CACX,mBACD,CAEA,0EACC,UAWD,CAJE,kMACC,2DACD,CAKH,iEACC,sGAwCD,CAtCC,6FACC,6HACD,CAEA,mFAIC,eAAgB,CAFhB,eAAgB,CADhB,cAAe,CAIf,UAAW,CACX,SAaD,CAnBA,6FASE,8BAUF,CAnBA,6FAaE,6BAMF,CAHC,yFACC,SACD,CAGD,2EACC,UAWD,CAZA,oMAUE,4DAEF,CAIF,kCACC,cAkBD,CAhBC,mDAEC,wDAAyD,CADzD,UAcD,CAXC,qDACC,kBACD,CAEA,oEACC,eACD,CAEA,mEACC,mCACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n.ck.ck-search {\n	& > .ck-labeled-field-view {\n		& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n			position: absolute;\n			top: 50%;\n			transform: translateY(-50%);\n\n			@mixin ck-dir ltr {\n				left: var(--ck-spacing-medium);\n			}\n\n			@mixin ck-dir rtl {\n				right: var(--ck-spacing-medium);\n			}\n		}\n\n		& .ck-search__reset {\n			position: absolute;\n			top: 50%;\n			transform: translateY(-50%);\n		}\n	}\n\n	& > .ck-search__results {\n		& > .ck-search__info {\n			& > span:first-child {\n				display: block;\n			}\n\n			/* Hide the filtered view when nothing was found */\n			&:not(.ck-hidden) ~ * {\n				display: none;\n			}\n		}\n	}\n}\n', '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";\n\n:root {\n	--ck-search-field-view-horizontal-spacing: calc(var(--ck-icon-size) + var(--ck-spacing-medium));\n}\n\n.ck.ck-search {\n	& > .ck-labeled-field-view {\n		& .ck-input {\n			width: 100%;\n		}\n\n		&.ck-search__query_with-icon {\n			--ck-labeled-field-label-default-position-x: var(--ck-search-field-view-horizontal-spacing);\n\n			& > .ck-labeled-field-view__input-wrapper > .ck-icon {\n				opacity: .5;\n				pointer-events: none;\n			}\n\n			& .ck-input {\n				width: 100%;\n\n				@mixin ck-dir ltr {\n					padding-left: var(--ck-search-field-view-horizontal-spacing);\n				}\n\n				@mixin ck-dir rtl {\n					&:not(.ck-input-text_empty) {\n						padding-left: var(--ck-search-field-view-horizontal-spacing);\n					}\n				}\n			}\n		}\n\n		&.ck-search__query_with-reset {\n			--ck-labeled-field-empty-unfocused-max-width: 100% - 2 * var(--ck-search-field-view-horizontal-spacing);\n\n			&.ck-labeled-field-view_empty {\n				--ck-labeled-field-empty-unfocused-max-width: 100% - var(--ck-search-field-view-horizontal-spacing) - var(--ck-spacing-medium);\n			}\n\n			& .ck-search__reset {\n				min-width: auto;\n				min-height: auto;\n\n				background: none;\n				opacity: .5;\n				padding: 0;\n\n				@mixin ck-dir ltr {\n					right: var(--ck-spacing-medium);\n				}\n\n				@mixin ck-dir rtl {\n					left: var(--ck-spacing-medium);\n				}\n\n				&:hover {\n					opacity: 1;\n				}\n			}\n\n			& .ck-input {\n				width: 100%;\n\n				@mixin ck-dir ltr {\n					&:not(.ck-input-text_empty) {\n						padding-right: var(--ck-search-field-view-horizontal-spacing);\n					}\n				}\n\n				@mixin ck-dir rtl {\n					padding-right: var(--ck-search-field-view-horizontal-spacing);\n				}\n			}\n		}\n	}\n\n	& > .ck-search__results {\n		min-width: 100%;\n\n		& > .ck-search__info {\n			width: 100%;\n			padding: var(--ck-spacing-medium) var(--ck-spacing-large);\n\n			& * {\n				white-space: normal;\n			}\n\n			& > span:first-child {\n				font-weight: bold;\n			}\n\n			& > span:last-child {\n				margin-top: var(--ck-spacing-medium);\n			}\n		}\n	}\n}\n\n'], sourceRoot: "" }]);
        const a = s2;
      }, 498: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-spinner-container{display:block;position:relative}.ck.ck-spinner{left:0;margin:0 auto;position:absolute;right:0;top:50%;transform:translateY(-50%);z-index:1}:root{--ck-toolbar-spinner-size:18px}.ck.ck-spinner-container{animation:rotate 1.5s linear infinite}.ck.ck-spinner,.ck.ck-spinner-container{height:var(--ck-toolbar-spinner-size);width:var(--ck-toolbar-spinner-size)}.ck.ck-spinner{border:2px solid var(--ck-color-text);border-radius:50%;border-top:2px solid transparent}@keyframes rotate{to{transform:rotate(1turn)}}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/spinner/spinner.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/spinner/spinner.css"], names: [], mappings: "AASA,yBACC,aAAc,CACd,iBACD,CAEA,eAGC,MAAO,CAEP,aAAc,CAJd,iBAAkB,CAGlB,OAAQ,CAFR,OAAQ,CAIR,0BAA2B,CAC3B,SACD,CCjBA,MACC,8BACD,CAEA,yBAGC,qCACD,CAEA,wCAJC,qCAAsC,CADtC,oCAWD,CANA,eAKC,qCAA6B,CAF7B,iBAAkB,CAElB,gCACD,CAEA,kBACC,GACC,uBACD,CACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n	display: block;\n	position: relative;\n}\n\n.ck.ck-spinner {\n	position: absolute;\n	top: 50%;\n	left: 0;\n	right: 0;\n	margin: 0 auto;\n	transform: translateY(-50%);\n	z-index: 1;\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-toolbar-spinner-size: 18px;\n}\n\n.ck.ck-spinner-container {\n	width: var(--ck-toolbar-spinner-size);\n	height: var(--ck-toolbar-spinner-size);\n	animation: 1.5s infinite rotate linear;\n}\n\n.ck.ck-spinner {\n	width: var(--ck-toolbar-spinner-size);\n	height: var(--ck-toolbar-spinner-size);\n	border-radius: 50%;\n	border: 2px solid var(--ck-color-text);\n	border-top-color: transparent;\n}\n\n@keyframes rotate {\n	to {\n		transform: rotate(360deg)\n	}\n}\n\n"], sourceRoot: "" }]);
        const a = s2;
      }, 8182: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-textarea{overflow-x:hidden}", "", { version: 3, sources: ["webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/textarea/textarea.css"], names: [], mappings: "AASA,aACC,iBACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/*\n * This fixes a problem in Firefox when the initial height of the complement does not match the number of rows.\n * This bug is especially visible when rows=1.\n */\n.ck-textarea {\n	overflow-x: hidden\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 9695: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-block-toolbar-button{position:absolute;z-index:var(--ck-z-default)}:root{--ck-color-block-toolbar-button:var(--ck-color-text);--ck-block-toolbar-button-size:var(--ck-font-size-normal)}.ck.ck-block-toolbar-button{color:var(--ck-color-block-toolbar-button);font-size:var(--ck-block-toolbar-size)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/toolbar/blocktoolbar.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/blocktoolbar.css"], names: [], mappings: "AAKA,4BACC,iBAAkB,CAClB,2BACD,CCHA,MACC,oDAAqD,CACrD,yDACD,CAEA,4BACC,0CAA2C,CAC3C,sCACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-block-toolbar-button {\n	position: absolute;\n	z-index: var(--ck-z-default);\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-color-block-toolbar-button: var(--ck-color-text);\n	--ck-block-toolbar-button-size: var(--ck-font-size-normal);\n}\n\n.ck.ck-block-toolbar-button {\n	color: var(--ck-color-block-toolbar-button);\n	font-size: var(--ck-block-toolbar-size);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 5542: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-toolbar{align-items:center;display:flex;flex-flow:row nowrap;-moz-user-select:none;-webkit-user-select:none;-ms-user-select:none;user-select:none}.ck.ck-toolbar>.ck-toolbar__items{align-items:center;display:flex;flex-flow:row wrap;flex-grow:1}.ck.ck-toolbar .ck.ck-toolbar__separator{display:inline-block}.ck.ck-toolbar .ck.ck-toolbar__separator:first-child,.ck.ck-toolbar .ck.ck-toolbar__separator:last-child{display:none}.ck.ck-toolbar .ck-toolbar__line-break{flex-basis:100%}.ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items{flex-direction:column}.ck.ck-toolbar.ck-toolbar_floating>.ck-toolbar__items{flex-wrap:nowrap}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck-dropdown__button .ck-dropdown__arrow{display:none}.ck.ck-toolbar{border-radius:0}.ck-rounded-corners .ck.ck-toolbar,.ck.ck-toolbar.ck-rounded-corners{border-radius:var(--ck-border-radius)}.ck.ck-toolbar{background:var(--ck-color-toolbar-background);border:1px solid var(--ck-color-toolbar-border);padding:0 var(--ck-spacing-small)}.ck.ck-toolbar .ck.ck-toolbar__separator{align-self:stretch;background:var(--ck-color-toolbar-border);margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small);min-width:1px;width:1px}.ck.ck-toolbar .ck-toolbar__line-break{height:0}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break){margin-right:var(--ck-spacing-small)}.ck.ck-toolbar>.ck-toolbar__items:empty+.ck.ck-toolbar__separator{display:none}.ck.ck-toolbar>.ck-toolbar__items>:not(.ck-toolbar__line-break),.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown{margin-bottom:var(--ck-spacing-small);margin-top:var(--ck-spacing-small)}.ck.ck-toolbar.ck-toolbar_vertical{padding:0}.ck.ck-toolbar.ck-toolbar_vertical>.ck-toolbar__items>.ck{border-radius:0;margin:0;width:100%}.ck.ck-toolbar.ck-toolbar_compact{padding:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>*{margin:0}.ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>:not(:first-child):not(:last-child){border-radius:0}.ck.ck-toolbar>.ck.ck-toolbar__grouped-dropdown>.ck.ck-button.ck-dropdown__button{padding-left:var(--ck-spacing-tiny)}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-dropdown__panel{min-width:auto}.ck.ck-toolbar .ck-toolbar__nested-toolbar-dropdown>.ck-button>.ck-button__label{max-width:7em;width:auto}.ck.ck-toolbar:focus{outline:none}.ck-toolbar-container .ck.ck-toolbar{border:0}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck{margin-right:0}.ck.ck-toolbar[dir=rtl]:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck,[dir=rtl] .ck.ck-toolbar:not(.ck-toolbar_compact)>.ck-toolbar__items>.ck{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-left:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:first-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=rtl]>.ck-toolbar__items>.ck:last-child,[dir=rtl] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=rtl]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=rtl]>.ck.ck-toolbar__separator,[dir=rtl] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=rtl] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-left:var(--ck-spacing-small)}.ck.ck-toolbar[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar>.ck-toolbar__items>.ck:last-child{margin-right:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:first-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:first-child{border-bottom-right-radius:0;border-top-right-radius:0}.ck.ck-toolbar.ck-toolbar_compact[dir=ltr]>.ck-toolbar__items>.ck:last-child,[dir=ltr] .ck.ck-toolbar.ck-toolbar_compact>.ck-toolbar__items>.ck:last-child{border-bottom-left-radius:0;border-top-left-radius:0}.ck.ck-toolbar.ck-toolbar_grouping[dir=ltr]>.ck-toolbar__items:not(:empty):not(:only-child),.ck.ck-toolbar[dir=ltr]>.ck.ck-toolbar__separator,[dir=ltr] .ck.ck-toolbar.ck-toolbar_grouping>.ck-toolbar__items:not(:empty):not(:only-child),[dir=ltr] .ck.ck-toolbar>.ck.ck-toolbar__separator{margin-right:var(--ck-spacing-small)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/toolbar/toolbar.css", "webpack://./../ckeditor5-ui/theme/mixins/_unselectable.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/toolbar/toolbar.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_rounded.css"], names: [], mappings: "AAOA,eAKC,kBAAmB,CAFnB,YAAa,CACb,oBAAqB,CCFrB,qBAAsB,CACtB,wBAAyB,CACzB,oBAAqB,CACrB,gBD6CD,CA3CC,kCAGC,kBAAmB,CAFnB,YAAa,CACb,kBAAmB,CAEnB,WAED,CAEA,yCACC,oBAWD,CAJC,yGAEC,YACD,CAGD,uCACC,eACD,CAEA,sDACC,gBACD,CAEA,sDACC,qBACD,CAEA,sDACC,gBACD,CAGC,yFACC,YACD,CE/CF,eCGC,eDwGD,CA3GA,qECOE,qCDoGF,CA3GA,eAGC,6CAA8C,CAE9C,+CAAgD,CADhD,iCAuGD,CApGC,yCACC,kBAAmB,CAGnB,yCAA0C,CAO1C,qCAAsC,CADtC,kCAAmC,CAPnC,aAAc,CADd,SAUD,CAEA,uCACC,QACD,CAGC,gEAEC,oCACD,CAIA,kEACC,YACD,CAGD,gHAIC,qCAAsC,CADtC,kCAED,CAEA,mCAEC,SAaD,CAVC,0DAQC,eAAgB,CAHhB,QAAS,CAHT,UAOD,CAGD,kCAEC,SAWD,CATC,uDAEC,QAMD,CAHC,yFACC,eACD,CASD,kFACC,mCACD,CAMA,wEACC,cACD,CAEA,iFACC,aAAc,CACd,UACD,CAGD,qBACC,YACD,CAtGD,qCAyGE,QAEF,CAYC,+FACC,cACD,CAEA,iJAEC,mCACD,CAEA,qHACC,aACD,CAIC,6JAEC,2BAA4B,CAD5B,wBAED,CAGA,2JAEC,4BAA6B,CAD7B,yBAED,CASD,8RACC,mCACD,CAWA,qHACC,cACD,CAIC,6JAEC,4BAA6B,CAD7B,yBAED,CAGA,2JAEC,2BAA4B,CAD5B,wBAED,CASD,8RACC,oCACD", sourcesContent: ['/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../mixins/_unselectable.css";\n\n.ck.ck-toolbar {\n	@mixin ck-unselectable;\n\n	display: flex;\n	flex-flow: row nowrap;\n	align-items: center;\n\n	& > .ck-toolbar__items {\n		display: flex;\n		flex-flow: row wrap;\n		align-items: center;\n		flex-grow: 1;\n\n	}\n\n	& .ck.ck-toolbar__separator {\n		display: inline-block;\n\n		/*\n		 * A leading or trailing separator makes no sense (separates from nothing on one side).\n		 * For instance, it can happen when toolbar items (also separators) are getting grouped one by one and\n		 * moved to another toolbar in the dropdown.\n		 */\n		&:first-child,\n		&:last-child {\n			display: none;\n		}\n	}\n\n	& .ck-toolbar__line-break {\n		flex-basis: 100%;\n	}\n\n	&.ck-toolbar_grouping > .ck-toolbar__items {\n		flex-wrap: nowrap;\n	}\n\n	&.ck-toolbar_vertical > .ck-toolbar__items {\n		flex-direction: column;\n	}\n\n	&.ck-toolbar_floating > .ck-toolbar__items {\n		flex-wrap: nowrap;\n	}\n\n	& > .ck.ck-toolbar__grouped-dropdown {\n		& > .ck-dropdown__button .ck-dropdown__arrow {\n			display: none;\n		}\n	}\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Makes element unselectable.\n */\n@define-mixin ck-unselectable {\n	-moz-user-select: none;\n	-webkit-user-select: none;\n	-ms-user-select: none;\n	user-select: none\n}\n", `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

@import "../../../mixins/_rounded.css";
@import "@ckeditor/ckeditor5-ui/theme/mixins/_dir.css";

.ck.ck-toolbar {
	@mixin ck-rounded-corners;

	background: var(--ck-color-toolbar-background);
	padding: 0 var(--ck-spacing-small);
	border: 1px solid var(--ck-color-toolbar-border);

	& .ck.ck-toolbar__separator {
		align-self: stretch;
		width: 1px;
		min-width: 1px;
		background: var(--ck-color-toolbar-border);

		/*
		 * These margins make the separators look better in balloon toolbars (when aligned with the "tip").
		 * See https://github.com/ckeditor/ckeditor5/issues/7493.
		 */
		margin-top: var(--ck-spacing-small);
		margin-bottom: var(--ck-spacing-small);
	}

	& .ck-toolbar__line-break {
		height: 0;
	}

	& > .ck-toolbar__items {
		& > *:not(.ck-toolbar__line-break) {
			/* (#11) Separate toolbar items. */
			margin-right: var(--ck-spacing-small);
		}

		/* Don't display a separator after an empty items container, for instance,
		when all items were grouped */
		&:empty + .ck.ck-toolbar__separator {
			display: none;
		}
	}

	& > .ck-toolbar__items > *:not(.ck-toolbar__line-break),
	& > .ck.ck-toolbar__grouped-dropdown {
		/* Make sure items wrapped to the next line have v-spacing */
		margin-top: var(--ck-spacing-small);
		margin-bottom: var(--ck-spacing-small);
	}

	&.ck-toolbar_vertical {
		/* Items in a vertical toolbar span the entire width. */
		padding: 0;

		/* Specificity matters here. See https://github.com/ckeditor/ckeditor5-theme-lark/issues/168. */
		& > .ck-toolbar__items > .ck {
			/* Items in a vertical toolbar should span the horizontal space. */
			width: 100%;

			/* Items in a vertical toolbar should have no margin. */
			margin: 0;

			/* Items in a vertical toolbar span the entire width so rounded corners are pointless. */
			border-radius: 0;
		}
	}

	&.ck-toolbar_compact {
		/* No spacing around items. */
		padding: 0;

		& > .ck-toolbar__items > * {
			/* Compact toolbar items have no spacing between them. */
			margin: 0;

			/* "Middle" children should have no rounded corners. */
			&:not(:first-child):not(:last-child) {
				border-radius: 0;
			}
		}
	}

	& > .ck.ck-toolbar__grouped-dropdown {
		/*
		 * Dropdown button has asymmetric padding to fit the arrow.
		 * This button has no arrow so let's revert that padding back to normal.
		 */
		& > .ck.ck-button.ck-dropdown__button {
			padding-left: var(--ck-spacing-tiny);
		}
	}

	/* A drop-down containing the nested toolbar with configured items. */
	& .ck-toolbar__nested-toolbar-dropdown {
		/* Prevent empty space in the panel when the dropdown label is visible and long but the toolbar has few items. */
		& > .ck-dropdown__panel {
			min-width: auto;
		}

		& > .ck-button > .ck-button__label {
			max-width: 7em;
			width: auto;
		}
	}

	&:focus {
		outline: none;
	}

	@nest .ck-toolbar-container & {
		border: 0;
	}
}

/* stylelint-disable */

/*
 * Styles for RTL toolbars.
 *
 * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"
 * because its parent is not controlled by the editor framework.
 */
[dir="rtl"] .ck.ck-toolbar,
.ck.ck-toolbar[dir="rtl"] {
	& > .ck-toolbar__items > .ck {
		margin-right: 0;
	}

	&:not(.ck-toolbar_compact) > .ck-toolbar__items > .ck {
		/* (#11) Separate toolbar items. */
		margin-left: var(--ck-spacing-small);
	}

	& > .ck-toolbar__items > .ck:last-child {
		margin-left: 0;
	}

	&.ck-toolbar_compact > .ck-toolbar__items > .ck {
		/* No rounded corners on the right side of the first child. */
		&:first-child {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}

		/* No rounded corners on the left side of the last child. */
		&:last-child {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}
	}

	/* Separate the the separator form the grouping dropdown when some items are grouped. */
	& > .ck.ck-toolbar__separator {
		margin-left: var(--ck-spacing-small);
	}

	/* Some spacing between the items and the separator before the grouped items dropdown. */
	&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {
		margin-left: var(--ck-spacing-small);
	}
}

/*
 * Styles for LTR toolbars.
 *
 * Note: In some cases (e.g. a decoupled editor), the toolbar has its own "dir"
 * because its parent is not controlled by the editor framework.
 */
[dir="ltr"] .ck.ck-toolbar,
.ck.ck-toolbar[dir="ltr"] {
	& > .ck-toolbar__items > .ck:last-child {
		margin-right: 0;
	}

	&.ck-toolbar_compact > .ck-toolbar__items > .ck {
		/* No rounded corners on the right side of the first child. */
		&:first-child {
			border-top-right-radius: 0;
			border-bottom-right-radius: 0;
		}

		/* No rounded corners on the left side of the last child. */
		&:last-child {
			border-top-left-radius: 0;
			border-bottom-left-radius: 0;
		}
	}

	/* Separate the the separator form the grouping dropdown when some items are grouped. */
	& > .ck.ck-toolbar__separator {
		margin-right: var(--ck-spacing-small);
	}

	/* Some spacing between the items and the separator before the grouped items dropdown. */
	&.ck-toolbar_grouping > .ck-toolbar__items:not(:empty):not(:only-child) {
		margin-right: var(--ck-spacing-small);
	}
}

/* stylelint-enable */
`, "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Implements rounded corner interface for .ck-rounded-corners class.\n *\n * @see $ck-border-radius\n */\n@define-mixin ck-rounded-corners {\n	border-radius: 0;\n\n	@nest .ck-rounded-corners &,\n	&.ck-rounded-corners {\n		border-radius: var(--ck-border-radius);\n		@mixin-content;\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3332: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck.ck-balloon-panel.ck-tooltip{--ck-balloon-border-width:0px;--ck-balloon-arrow-offset:0px;--ck-balloon-arrow-half-width:4px;--ck-balloon-arrow-height:4px;--ck-tooltip-text-padding:4px;--ck-color-panel-background:var(--ck-color-tooltip-background);padding:0 var(--ck-spacing-medium);pointer-events:none;z-index:calc(var(--ck-z-modal) + 100)}.ck.ck-balloon-panel.ck-tooltip .ck-tooltip__text{color:var(--ck-color-tooltip-text);font-size:.9em;line-height:1.5}.ck.ck-balloon-panel.ck-tooltip.ck-tooltip_multi-line .ck-tooltip__text{display:inline-block;padding:var(--ck-tooltip-text-padding) 0;white-space:break-spaces}.ck.ck-balloon-panel.ck-tooltip{box-shadow:none}.ck.ck-balloon-panel.ck-tooltip:before{display:none}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/components/tooltip/tooltip.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/components/tooltip/tooltip.css"], names: [], mappings: "AAKA,gCCGC,6BAA8B,CAC9B,6BAA8B,CAC9B,iCAAkC,CAClC,6BAA8B,CAC9B,6BAA8B,CAC9B,8DAA+D,CAE/D,kCAAmC,CDRnC,mBAAoB,CAEpB,qCACD,CCOC,kDAGC,kCAAmC,CAFnC,cAAe,CACf,eAED,CAEA,wEAEC,oBAAqB,CACrB,wCAAyC,CAFzC,wBAGD,CApBD,gCAuBC,eAMD,CAHC,uCACC,YACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-balloon-panel.ck-tooltip {\n	/* Keep tooltips transparent for any interactions. */\n	pointer-events: none;\n\n	z-index: calc( var(--ck-z-modal) + 100 );\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../../../mixins/_rounded.css";\n\n.ck.ck-balloon-panel.ck-tooltip {\n	--ck-balloon-border-width: 0px;\n	--ck-balloon-arrow-offset: 0px;\n	--ck-balloon-arrow-half-width: 4px;\n	--ck-balloon-arrow-height: 4px;\n	--ck-tooltip-text-padding: 4px;\n	--ck-color-panel-background: var(--ck-color-tooltip-background);\n\n	padding: 0 var(--ck-spacing-medium);\n\n	& .ck-tooltip__text {\n		font-size: .9em;\n		line-height: 1.5;\n		color: var(--ck-color-tooltip-text);\n	}\n\n	&.ck-tooltip_multi-line .ck-tooltip__text {\n		white-space: break-spaces;\n		display: inline-block;\n		padding: var(--ck-tooltip-text-padding) 0;\n	}\n\n	/* Reset balloon panel styles */\n	box-shadow: none;\n\n	/* Hide the default shadow of the .ck-balloon-panel tip */\n	&::before {\n		display: none;\n	}\n}\n'], sourceRoot: "" }]);
        const a = s2;
      }, 4793: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck-hidden{display:none!important}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{box-sizing:border-box;height:auto;position:static;width:auto}:root{--ck-z-default:1;--ck-z-modal:calc(var(--ck-z-default) + 999)}.ck-transitions-disabled,.ck-transitions-disabled *{transition:none!important}:root{--ck-powered-by-line-height:10px;--ck-powered-by-padding-vertical:2px;--ck-powered-by-padding-horizontal:4px;--ck-powered-by-text-color:#4f4f4f;--ck-powered-by-border-radius:var(--ck-border-radius);--ck-powered-by-background:#fff;--ck-powered-by-border-color:var(--ck-color-focus-border)}.ck.ck-balloon-panel.ck-powered-by-balloon{--ck-border-radius:var(--ck-powered-by-border-radius);background:var(--ck-powered-by-background);box-shadow:none;min-height:unset;z-index:calc(var(--ck-z-modal) - 1)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by{line-height:var(--ck-powered-by-line-height)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by a{align-items:center;cursor:pointer;display:flex;filter:grayscale(80%);line-height:var(--ck-powered-by-line-height);opacity:.66;padding:var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal)}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-powered-by__label{color:var(--ck-powered-by-text-color);cursor:pointer;font-size:7.5px;font-weight:700;letter-spacing:-.2px;line-height:normal;margin-right:4px;padding-left:2px;text-transform:uppercase}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by .ck-icon{cursor:pointer;display:block}.ck.ck-balloon-panel.ck-powered-by-balloon .ck.ck-powered-by:hover a{filter:grayscale(0);opacity:1}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_inside]{border-color:transparent}.ck.ck-balloon-panel.ck-powered-by-balloon[class*=position_border]{border:var(--ck-focus-ring);border-color:var(--ck-powered-by-border-color)}:root{--ck-color-base-foreground:#fafafa;--ck-color-base-background:#fff;--ck-color-base-border:#ccced1;--ck-color-base-action:#53a336;--ck-color-base-focus:#6cb5f9;--ck-color-base-text:#333;--ck-color-base-active:#2977ff;--ck-color-base-active-focus:#0d65ff;--ck-color-base-error:#db3700;--ck-color-focus-border-coordinates:218,81.8%,56.9%;--ck-color-focus-border:hsl(var(--ck-color-focus-border-coordinates));--ck-color-focus-outer-shadow:#cae1fc;--ck-color-focus-disabled-shadow:rgba(119,186,248,.3);--ck-color-focus-error-shadow:rgba(255,64,31,.3);--ck-color-text:var(--ck-color-base-text);--ck-color-shadow-drop:rgba(0,0,0,.15);--ck-color-shadow-drop-active:rgba(0,0,0,.2);--ck-color-shadow-inner:rgba(0,0,0,.1);--ck-color-button-default-background:transparent;--ck-color-button-default-hover-background:#f0f0f0;--ck-color-button-default-active-background:#f0f0f0;--ck-color-button-default-disabled-background:transparent;--ck-color-button-on-background:#f0f7ff;--ck-color-button-on-hover-background:#dbecff;--ck-color-button-on-active-background:#dbecff;--ck-color-button-on-disabled-background:#f0f2f4;--ck-color-button-on-color:#2977ff;--ck-color-button-action-background:var(--ck-color-base-action);--ck-color-button-action-hover-background:#4d9d30;--ck-color-button-action-active-background:#4d9d30;--ck-color-button-action-disabled-background:#7ec365;--ck-color-button-action-text:var(--ck-color-base-background);--ck-color-button-save:#008a00;--ck-color-button-cancel:#db3700;--ck-color-switch-button-off-background:#939393;--ck-color-switch-button-off-hover-background:#7d7d7d;--ck-color-switch-button-on-background:var(--ck-color-button-action-background);--ck-color-switch-button-on-hover-background:#4d9d30;--ck-color-switch-button-inner-background:var(--ck-color-base-background);--ck-color-switch-button-inner-shadow:rgba(0,0,0,.1);--ck-color-dropdown-panel-background:var(--ck-color-base-background);--ck-color-dropdown-panel-border:var(--ck-color-base-border);--ck-color-input-background:var(--ck-color-base-background);--ck-color-input-border:var(--ck-color-base-border);--ck-color-input-error-border:var(--ck-color-base-error);--ck-color-input-text:var(--ck-color-base-text);--ck-color-input-disabled-background:#f2f2f2;--ck-color-input-disabled-border:var(--ck-color-base-border);--ck-color-input-disabled-text:#757575;--ck-color-list-background:var(--ck-color-base-background);--ck-color-list-button-hover-background:var(--ck-color-button-default-hover-background);--ck-color-list-button-on-background:var(--ck-color-button-on-color);--ck-color-list-button-on-background-focus:var(--ck-color-button-on-color);--ck-color-list-button-on-text:var(--ck-color-base-background);--ck-color-panel-background:var(--ck-color-base-background);--ck-color-panel-border:var(--ck-color-base-border);--ck-color-toolbar-background:var(--ck-color-base-background);--ck-color-toolbar-border:var(--ck-color-base-border);--ck-color-tooltip-background:var(--ck-color-base-text);--ck-color-tooltip-text:var(--ck-color-base-background);--ck-color-engine-placeholder-text:#707070;--ck-color-upload-bar-background:#6cb5f9;--ck-color-link-default:#0000f0;--ck-color-link-selected-background:rgba(31,176,255,.1);--ck-color-link-fake-selection:rgba(31,176,255,.3);--ck-color-highlight-background:#ff0;--ck-color-light-red:#fcc;--ck-disabled-opacity:.5;--ck-focus-outer-shadow-geometry:0 0 0 3px;--ck-focus-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);--ck-focus-disabled-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);--ck-focus-error-outer-shadow:var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);--ck-focus-ring:1px solid var(--ck-color-focus-border);--ck-font-size-base:13px;--ck-line-height-base:1.84615;--ck-font-face:Helvetica,Arial,Tahoma,Verdana,Sans-Serif;--ck-font-size-tiny:0.7em;--ck-font-size-small:0.75em;--ck-font-size-normal:1em;--ck-font-size-big:1.4em;--ck-font-size-large:1.8em;--ck-ui-component-min-height:2.3em}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset,.ck.ck-reset_all{word-wrap:break-word;background:transparent;border:0;margin:0;padding:0;text-decoration:none;transition:none;vertical-align:middle}.ck-reset_all :not(.ck-reset_all-excluded *),.ck.ck-reset_all{border-collapse:collapse;color:var(--ck-color-text);cursor:auto;float:none;font:normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);text-align:left;white-space:nowrap}.ck-reset_all .ck-rtl :not(.ck-reset_all-excluded *){text-align:right}.ck-reset_all iframe:not(.ck-reset_all-excluded *){vertical-align:inherit}.ck-reset_all textarea:not(.ck-reset_all-excluded *){white-space:pre-wrap}.ck-reset_all input[type=password]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text]:not(.ck-reset_all-excluded *),.ck-reset_all textarea:not(.ck-reset_all-excluded *){cursor:text}.ck-reset_all input[type=password][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all input[type=text][disabled]:not(.ck-reset_all-excluded *),.ck-reset_all textarea[disabled]:not(.ck-reset_all-excluded *){cursor:default}.ck-reset_all fieldset:not(.ck-reset_all-excluded *){border:2px groove #dfdee3;padding:10px}.ck-reset_all button:not(.ck-reset_all-excluded *)::-moz-focus-inner{border:0;padding:0}.ck[dir=rtl],.ck[dir=rtl] .ck{text-align:right}:root{--ck-border-radius:2px;--ck-inner-shadow:2px 2px 3px var(--ck-color-shadow-inner) inset;--ck-drop-shadow:0 1px 2px 1px var(--ck-color-shadow-drop);--ck-drop-shadow-active:0 3px 6px 1px var(--ck-color-shadow-drop-active);--ck-spacing-unit:0.6em;--ck-spacing-large:calc(var(--ck-spacing-unit)*1.5);--ck-spacing-standard:var(--ck-spacing-unit);--ck-spacing-medium:calc(var(--ck-spacing-unit)*0.8);--ck-spacing-small:calc(var(--ck-spacing-unit)*0.5);--ck-spacing-tiny:calc(var(--ck-spacing-unit)*0.3);--ck-spacing-extra-tiny:calc(var(--ck-spacing-unit)*0.16)}", "", { version: 3, sources: ["webpack://./../ckeditor5-ui/theme/globals/_hidden.css", "webpack://./../ckeditor5-ui/theme/globals/_reset.css", "webpack://./../ckeditor5-ui/theme/globals/_zindex.css", "webpack://./../ckeditor5-ui/theme/globals/_transition.css", "webpack://./../ckeditor5-ui/theme/globals/_poweredby.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_colors.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_disabled.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_fonts.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_reset.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_rounded.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_shadow.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-ui/globals/_spacing.css"], names: [], mappings: "AAQA,WAGC,sBACD,CCPA,2EAGC,qBAAsB,CAEtB,WAAY,CACZ,eAAgB,CAFhB,UAGD,CCPA,MACC,gBAAiB,CACjB,4CACD,CCAA,oDAEC,yBACD,CCNA,MACC,gCAAiC,CACjC,oCAAqC,CACrC,sCAAuC,CACvC,kCAA2C,CAC3C,qDAAsD,CACtD,+BAA4C,CAC5C,yDACD,CAEA,2CACC,qDAAsD,CAGtD,0CAA2C,CAD3C,eAAgB,CAEhB,gBAAiB,CACjB,mCAiDD,CA/CC,6DACC,4CAoCD,CAlCC,+DAGC,kBAAmB,CAFnB,cAAe,CACf,YAAa,CAGb,qBAAsB,CACtB,4CAA6C,CAF7C,WAAY,CAGZ,qFACD,CAEA,mFASC,qCAAsC,CAFtC,cAAe,CANf,eAAgB,CAIhB,eAAiB,CAHjB,oBAAqB,CAMrB,kBAAmB,CAFnB,gBAAiB,CAHjB,gBAAiB,CACjB,wBAOD,CAEA,sEAEC,cAAe,CADf,aAED,CAGC,qEACC,mBAAqB,CACrB,SACD,CAIF,mEACC,wBACD,CAEA,mEACC,2BAA4B,CAC5B,8CACD,CChED,MACC,kCAAmD,CACnD,+BAAoD,CACpD,8BAAkD,CAClD,8BAAuD,CACvD,6BAAmD,CACnD,yBAA+C,CAC/C,8BAAsD,CACtD,oCAA4D,CAC5D,6BAAkD,CAIlD,mDAA4D,CAC5D,qEAA+E,CAC/E,qCAA4D,CAC5D,qDAA8D,CAC9D,gDAAyD,CACzD,yCAAqD,CACrD,sCAAsD,CACtD,4CAA0D,CAC1D,sCAAsD,CAItD,gDAAuD,CACvD,kDAAiE,CACjE,mDAAkE,CAClE,yDAA8D,CAE9D,uCAA6D,CAC7D,6CAAoE,CACpE,8CAAoE,CACpE,gDAAiE,CACjE,kCAAyD,CAGzD,+DAAsE,CACtE,iDAAsE,CACtE,kDAAsE,CACtE,oDAAoE,CACpE,6DAAsE,CAEtE,8BAAoD,CACpD,gCAAqD,CAErD,+CAA8D,CAC9D,qDAAiE,CACjE,+EAAqF,CACrF,oDAAuE,CACvE,yEAA8E,CAC9E,oDAAgE,CAIhE,oEAA2E,CAC3E,4DAAoE,CAIpE,2DAAoE,CACpE,mDAA6D,CAC7D,wDAAgE,CAChE,+CAA0D,CAC1D,4CAA2D,CAC3D,4DAAoE,CACpE,sCAAsD,CAItD,0DAAmE,CACnE,uFAA6F,CAC7F,oEAA2E,CAC3E,0EAA+E,CAC/E,8DAAsE,CAItE,2DAAoE,CACpE,mDAA6D,CAI7D,6DAAsE,CACtE,qDAA+D,CAI/D,uDAAgE,CAChE,uDAAiE,CAIjE,0CAAyD,CAIzD,wCAA2D,CAI3D,+BAAoD,CACpD,uDAAmE,CACnE,kDAAgE,CAIhE,oCAAyD,CAIzD,yBAAgD,CC3GhD,wBAAyB,CCAzB,0CAA2C,CAK3C,gGAAiG,CAKjG,4GAA6G,CAK7G,sGAAuG,CAKvG,sDAAuD,CCvBvD,wBAAyB,CACzB,6BAA8B,CAC9B,wDAA6D,CAE7D,yBAA0B,CAC1B,2BAA4B,CAC5B,yBAA0B,CAC1B,wBAAyB,CACzB,0BAA2B,CCJ3B,kCJ2GD,CIrGA,2EAaC,oBAAqB,CANrB,sBAAuB,CADvB,QAAS,CAFT,QAAS,CACT,SAAU,CAGV,oBAAqB,CAErB,eAAgB,CADhB,qBAKD,CAKA,8DAGC,wBAAyB,CAEzB,0BAA2B,CAG3B,WAAY,CACZ,UAAW,CALX,iGAAkG,CAElG,eAAgB,CAChB,kBAGD,CAGC,qDACC,gBACD,CAEA,mDAEC,sBACD,CAEA,qDACC,oBACD,CAEA,mLAGC,WACD,CAEA,iNAGC,cACD,CAEA,qDAEC,yBAAoC,CADpC,YAED,CAEA,qEAGC,QAAQ,CADR,SAED,CAMD,8BAEC,gBACD,CCnFA,MACC,sBAAuB,CCAvB,gEAAiE,CAKjE,0DAA2D,CAK3D,wEAAyE,CCbzE,uBAA8B,CAC9B,mDAA2D,CAC3D,4CAAkD,CAClD,oDAA4D,CAC5D,mDAA2D,CAC3D,kDAA2D,CAC3D,yDFFD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class which hides an element in DOM.\n */\n.ck-hidden {\n	/* Override selector specificity. Otherwise, all elements with some display\n	style defined will override this one, which is not a desired result. */\n	display: none !important;\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n	box-sizing: border-box;\n	width: auto;\n	height: auto;\n	position: static;\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-z-default: 1;\n	--ck-z-modal: calc( var(--ck-z-default) + 999 );\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A class that disables all transitions of the element and its children.\n */\n.ck-transitions-disabled,\n.ck-transitions-disabled * {\n	transition: none !important;\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-powered-by-line-height: 10px;\n	--ck-powered-by-padding-vertical: 2px;\n	--ck-powered-by-padding-horizontal: 4px;\n	--ck-powered-by-text-color: hsl(0, 0%, 31%);\n	--ck-powered-by-border-radius: var(--ck-border-radius);\n	--ck-powered-by-background: hsl(0, 0%, 100%);\n	--ck-powered-by-border-color: var(--ck-color-focus-border);\n}\n\n.ck.ck-balloon-panel.ck-powered-by-balloon {\n	--ck-border-radius: var(--ck-powered-by-border-radius);\n\n	box-shadow: none;\n	background: var(--ck-powered-by-background);\n	min-height: unset;\n	z-index: calc( var(--ck-z-modal) - 1 );\n\n	& .ck.ck-powered-by {\n		line-height: var(--ck-powered-by-line-height);\n\n		& a {\n			cursor: pointer;\n			display: flex;\n			align-items: center;\n			opacity: .66;\n			filter: grayscale(80%);\n			line-height: var(--ck-powered-by-line-height);\n			padding: var(--ck-powered-by-padding-vertical) var(--ck-powered-by-padding-horizontal);\n		}\n\n		& .ck-powered-by__label {\n			font-size: 7.5px;\n			letter-spacing: -.2px;\n			padding-left: 2px;\n			text-transform: uppercase;\n			font-weight: bold;\n			margin-right: 4px;\n			cursor: pointer;\n			line-height: normal;\n			color: var(--ck-powered-by-text-color);\n\n		}\n\n		& .ck-icon {\n			display: block;\n			cursor: pointer;\n		}\n\n		&:hover {\n			& a {\n				filter: grayscale(0%);\n				opacity: 1;\n			}\n		}\n	}\n\n	&[class*="position_inside"] {\n		border-color: transparent;\n	}\n\n	&[class*="position_border"] {\n		border: var(--ck-focus-ring);\n		border-color: var(--ck-powered-by-border-color);\n	}\n}\n\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-color-base-foreground: 								hsl(0, 0%, 98%);\n	--ck-color-base-background: 								hsl(0, 0%, 100%);\n	--ck-color-base-border: 									hsl(220, 6%, 81%);\n	--ck-color-base-action: 									hsl(104, 50.2%, 42.5%);\n	--ck-color-base-focus: 										hsl(209, 92%, 70%);\n	--ck-color-base-text: 										hsl(0, 0%, 20%);\n	--ck-color-base-active: 									hsl(218.1, 100%, 58%);\n	--ck-color-base-active-focus:								hsl(218.2, 100%, 52.5%);\n	--ck-color-base-error:										hsl(15, 100%, 43%);\n\n	/* -- Generic colors ------------------------------------------------------------------------ */\n\n	--ck-color-focus-border-coordinates: 						218, 81.8%, 56.9%;\n	--ck-color-focus-border: 									hsl(var(--ck-color-focus-border-coordinates));\n	--ck-color-focus-outer-shadow:								hsl(212.4, 89.3%, 89%);\n	--ck-color-focus-disabled-shadow:							hsla(209, 90%, 72%,.3);\n	--ck-color-focus-error-shadow:								hsla(9,100%,56%,.3);\n	--ck-color-text: 											var(--ck-color-base-text);\n	--ck-color-shadow-drop: 									hsla(0, 0%, 0%, 0.15);\n	--ck-color-shadow-drop-active:								hsla(0, 0%, 0%, 0.2);\n	--ck-color-shadow-inner: 									hsla(0, 0%, 0%, 0.1);\n\n	/* -- Buttons ------------------------------------------------------------------------------- */\n\n	--ck-color-button-default-background: 						transparent;\n	--ck-color-button-default-hover-background: 				hsl(0, 0%, 94.1%);\n	--ck-color-button-default-active-background: 				hsl(0, 0%, 94.1%);\n	--ck-color-button-default-disabled-background: 				transparent;\n\n	--ck-color-button-on-background: 							hsl(212, 100%, 97.1%);\n	--ck-color-button-on-hover-background: 						hsl(211.7, 100%, 92.9%);\n	--ck-color-button-on-active-background: 					hsl(211.7, 100%, 92.9%);\n	--ck-color-button-on-disabled-background: 					hsl(211, 15%, 95%);\n	--ck-color-button-on-color:									hsl(218.1, 100%, 58%);\n\n\n	--ck-color-button-action-background: 						var(--ck-color-base-action);\n	--ck-color-button-action-hover-background: 					hsl(104, 53.2%, 40.2%);\n	--ck-color-button-action-active-background: 				hsl(104, 53.2%, 40.2%);\n	--ck-color-button-action-disabled-background: 				hsl(104, 44%, 58%);\n	--ck-color-button-action-text: 								var(--ck-color-base-background);\n\n	--ck-color-button-save: 									hsl(120, 100%, 27%);\n	--ck-color-button-cancel: 									hsl(15, 100%, 43%);\n\n	--ck-color-switch-button-off-background:					hsl(0, 0%, 57.6%);\n	--ck-color-switch-button-off-hover-background:				hsl(0, 0%, 49%);\n	--ck-color-switch-button-on-background:						var(--ck-color-button-action-background);\n	--ck-color-switch-button-on-hover-background:				hsl(104, 53.2%, 40.2%);\n	--ck-color-switch-button-inner-background:					var(--ck-color-base-background);\n	--ck-color-switch-button-inner-shadow:						hsla(0, 0%, 0%, 0.1);\n\n	/* -- Dropdown ------------------------------------------------------------------------------ */\n\n	--ck-color-dropdown-panel-background: 						var(--ck-color-base-background);\n	--ck-color-dropdown-panel-border: 							var(--ck-color-base-border);\n\n	/* -- Input --------------------------------------------------------------------------------- */\n\n	--ck-color-input-background: 								var(--ck-color-base-background);\n	--ck-color-input-border: 									var(--ck-color-base-border);\n	--ck-color-input-error-border:								var(--ck-color-base-error);\n	--ck-color-input-text: 										var(--ck-color-base-text);\n	--ck-color-input-disabled-background: 						hsl(0, 0%, 95%);\n	--ck-color-input-disabled-border: 							var(--ck-color-base-border);\n	--ck-color-input-disabled-text: 							hsl(0, 0%, 46%);\n\n	/* -- List ---------------------------------------------------------------------------------- */\n\n	--ck-color-list-background: 								var(--ck-color-base-background);\n	--ck-color-list-button-hover-background: 					var(--ck-color-button-default-hover-background);\n	--ck-color-list-button-on-background: 						var(--ck-color-button-on-color);\n	--ck-color-list-button-on-background-focus: 				var(--ck-color-button-on-color);\n	--ck-color-list-button-on-text:								var(--ck-color-base-background);\n\n	/* -- Panel --------------------------------------------------------------------------------- */\n\n	--ck-color-panel-background: 								var(--ck-color-base-background);\n	--ck-color-panel-border: 									var(--ck-color-base-border);\n\n	/* -- Toolbar ------------------------------------------------------------------------------- */\n\n	--ck-color-toolbar-background: 								var(--ck-color-base-background);\n	--ck-color-toolbar-border: 									var(--ck-color-base-border);\n\n	/* -- Tooltip ------------------------------------------------------------------------------- */\n\n	--ck-color-tooltip-background: 								var(--ck-color-base-text);\n	--ck-color-tooltip-text: 									var(--ck-color-base-background);\n\n	/* -- Engine -------------------------------------------------------------------------------- */\n\n	--ck-color-engine-placeholder-text: 						hsl(0, 0%, 44%);\n\n	/* -- Upload -------------------------------------------------------------------------------- */\n\n	--ck-color-upload-bar-background:		 					hsl(209, 92%, 70%);\n\n	/* -- Link -------------------------------------------------------------------------------- */\n\n	--ck-color-link-default:									hsl(240, 100%, 47%);\n	--ck-color-link-selected-background:						hsla(201, 100%, 56%, 0.1);\n	--ck-color-link-fake-selection:								hsla(201, 100%, 56%, 0.3);\n\n	/* -- Search result highlight ---------------------------------------------------------------- */\n\n	--ck-color-highlight-background:							hsl(60, 100%, 50%);\n\n	/* -- Generic colors ------------------------------------------------------------------------- */\n\n	--ck-color-light-red:										hsl(0, 100%, 90%);\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	/**\n	 * An opacity value of disabled UI item.\n	 */\n	--ck-disabled-opacity: .5;\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	/**\n	 * The geometry of the of focused element's outer shadow.\n	 */\n	--ck-focus-outer-shadow-geometry: 0 0 0 3px;\n\n	/**\n	 * A visual style of focused element's outer shadow.\n	 */\n	--ck-focus-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-outer-shadow);\n\n	/**\n	 * A visual style of focused element's outer shadow (when disabled).\n	 */\n	--ck-focus-disabled-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-disabled-shadow);\n\n	/**\n	 * A visual style of focused element's outer shadow (when has errors).\n	 */\n	--ck-focus-error-outer-shadow: var(--ck-focus-outer-shadow-geometry) var(--ck-color-focus-error-shadow);\n\n	/**\n	 * A visual style of focused element's border or outline.\n	 */\n	--ck-focus-ring: 1px solid var(--ck-color-focus-border);\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-font-size-base: 13px;\n	--ck-line-height-base: 1.84615;\n	--ck-font-face: Helvetica, Arial, Tahoma, Verdana, Sans-Serif;\n\n	--ck-font-size-tiny: 0.7em;\n	--ck-font-size-small: 0.75em;\n	--ck-font-size-normal: 1em;\n	--ck-font-size-big: 1.4em;\n	--ck-font-size-large: 1.8em;\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	/* This is super-important. This is **manually** adjusted so a button without an icon\n	is never smaller than a button with icon, additionally making sure that text-less buttons\n	are perfect squares. The value is also shared by other components which should stay "in-line"\n	with buttons. */\n	--ck-ui-component-min-height: 2.3em;\n}\n\n/**\n * Resets an element, ignoring its children.\n */\n.ck.ck-reset,\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n	/* Do not include inheritable rules here. */\n	margin: 0;\n	padding: 0;\n	border: 0;\n	background: transparent;\n	text-decoration: none;\n	vertical-align: middle;\n	transition: none;\n\n	/* https://github.com/ckeditor/ckeditor5-theme-lark/issues/105 */\n	word-wrap: break-word;\n}\n\n/**\n * Resets an element AND its children.\n */\n.ck.ck-reset_all,\n.ck-reset_all *:not(.ck-reset_all-excluded *) {\n	/* These are rule inherited by all children elements. */\n	border-collapse: collapse;\n	font: normal normal normal var(--ck-font-size-base)/var(--ck-line-height-base) var(--ck-font-face);\n	color: var(--ck-color-text);\n	text-align: left;\n	white-space: nowrap;\n	cursor: auto;\n	float: none;\n}\n\n.ck-reset_all {\n	& .ck-rtl *:not(.ck-reset_all-excluded *) {\n		text-align: right;\n	}\n\n	& iframe:not(.ck-reset_all-excluded *) {\n		/* For IE */\n		vertical-align: inherit;\n	}\n\n	& textarea:not(.ck-reset_all-excluded *) {\n		white-space: pre-wrap;\n	}\n\n	& textarea:not(.ck-reset_all-excluded *),\n	& input[type="text"]:not(.ck-reset_all-excluded *),\n	& input[type="password"]:not(.ck-reset_all-excluded *) {\n		cursor: text;\n	}\n\n	& textarea[disabled]:not(.ck-reset_all-excluded *),\n	& input[type="text"][disabled]:not(.ck-reset_all-excluded *),\n	& input[type="password"][disabled]:not(.ck-reset_all-excluded *) {\n		cursor: default;\n	}\n\n	& fieldset:not(.ck-reset_all-excluded *) {\n		padding: 10px;\n		border: 2px groove hsl(255, 7%, 88%);\n	}\n\n	& button:not(.ck-reset_all-excluded *)::-moz-focus-inner {\n		/* See http://stackoverflow.com/questions/5517744/remove-extra-button-spacing-padding-in-firefox */\n		padding: 0;\n		border: 0\n	}\n}\n\n/**\n * Default UI rules for RTL languages.\n */\n.ck[dir="rtl"],\n.ck[dir="rtl"] .ck {\n	text-align: right;\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * Default border-radius value.\n */\n:root{\n	--ck-border-radius: 2px;\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	/**\n	 * A visual style of element's inner shadow (i.e. input).\n	 */\n	--ck-inner-shadow: 2px 2px 3px var(--ck-color-shadow-inner) inset;\n\n	/**\n	 * A visual style of element's drop shadow (i.e. panel).\n	 */\n	--ck-drop-shadow: 0 1px 2px 1px var(--ck-color-shadow-drop);\n\n	/**\n	 * A visual style of element's active shadow (i.e. comment or suggestion).\n	 */\n	--ck-drop-shadow-active: 0 3px 6px 1px var(--ck-color-shadow-drop-active);\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-spacing-unit: 						0.6em;\n	--ck-spacing-large: 					calc(var(--ck-spacing-unit) * 1.5);\n	--ck-spacing-standard: 					var(--ck-spacing-unit);\n	--ck-spacing-medium: 					calc(var(--ck-spacing-unit) * 0.8);\n	--ck-spacing-small: 					calc(var(--ck-spacing-unit) * 0.5);\n	--ck-spacing-tiny: 						calc(var(--ck-spacing-unit) * 0.3);\n	--ck-spacing-extra-tiny: 				calc(var(--ck-spacing-unit) * 0.16);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 3488: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ":root{--ck-color-resizer:var(--ck-color-focus-border);--ck-color-resizer-tooltip-background:#262626;--ck-color-resizer-tooltip-text:#f2f2f2;--ck-resizer-border-radius:var(--ck-border-radius);--ck-resizer-tooltip-offset:10px;--ck-resizer-tooltip-height:calc(var(--ck-spacing-small)*2 + 10px)}.ck .ck-widget,.ck .ck-widget.ck-widget_with-selection-handle{position:relative}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{position:absolute}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{display:block}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{visibility:visible}.ck .ck-size-view{background:var(--ck-color-resizer-tooltip-background);border:1px solid var(--ck-color-resizer-tooltip-text);border-radius:var(--ck-resizer-border-radius);color:var(--ck-color-resizer-tooltip-text);display:block;font-size:var(--ck-font-size-tiny);height:var(--ck-resizer-tooltip-height);line-height:var(--ck-resizer-tooltip-height);padding:0 var(--ck-spacing-small)}.ck .ck-size-view.ck-orientation-above-center,.ck .ck-size-view.ck-orientation-bottom-left,.ck .ck-size-view.ck-orientation-bottom-right,.ck .ck-size-view.ck-orientation-top-left,.ck .ck-size-view.ck-orientation-top-right{position:absolute}.ck .ck-size-view.ck-orientation-top-left{left:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-top-right{right:var(--ck-resizer-tooltip-offset);top:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-right{bottom:var(--ck-resizer-tooltip-offset);right:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-bottom-left{bottom:var(--ck-resizer-tooltip-offset);left:var(--ck-resizer-tooltip-offset)}.ck .ck-size-view.ck-orientation-above-center{left:50%;top:calc(var(--ck-resizer-tooltip-height)*-1);transform:translate(-50%)}:root{--ck-widget-outline-thickness:3px;--ck-widget-handler-icon-size:16px;--ck-widget-handler-animation-duration:200ms;--ck-widget-handler-animation-curve:ease;--ck-color-widget-blurred-border:#dedede;--ck-color-widget-hover-border:#ffc83d;--ck-color-widget-editable-focus-background:var(--ck-color-base-background);--ck-color-widget-drag-handler-icon-color:var(--ck-color-base-background)}.ck .ck-widget{outline-color:transparent;outline-style:solid;outline-width:var(--ck-widget-outline-thickness);transition:outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_selected,.ck .ck-widget.ck-widget_selected:hover{outline:var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border)}.ck .ck-widget:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-editor__nested-editable{border:1px solid transparent}.ck .ck-editor__nested-editable.ck-editor__nested-editable_focused,.ck .ck-editor__nested-editable:focus{background-color:var(--ck-color-widget-editable-focus-background);border:var(--ck-focus-ring);box-shadow:var(--ck-inner-shadow),0 0;outline:none}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{background-color:transparent;border-radius:var(--ck-border-radius) var(--ck-border-radius) 0 0;box-sizing:border-box;left:calc(0px - var(--ck-widget-outline-thickness));opacity:0;padding:4px;top:0;transform:translateY(-100%);transition:background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon{color:var(--ck-color-widget-drag-handler-icon-color);height:var(--ck-widget-handler-icon-size);width:var(--ck-widget-handler-icon-size)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:0;transition:opacity .3s var(--ck-widget-handler-animation-curve)}.ck .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover .ck-icon .ck-icon__selected-indicator{opacity:1}.ck .ck-widget.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle{background-color:var(--ck-color-widget-hover-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{background-color:var(--ck-color-focus-border);opacity:1}.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator,.ck .ck-widget.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle .ck-icon .ck-icon__selected-indicator{opacity:1}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle{left:auto;right:calc(0px - var(--ck-widget-outline-thickness))}.ck.ck-editor__editable.ck-read-only .ck-widget{transition:none}.ck.ck-editor__editable.ck-read-only .ck-widget:not(.ck-widget_selected){--ck-widget-outline-thickness:0px}.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle,.ck.ck-editor__editable.ck-read-only .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected:hover{outline-color:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle:hover>.ck-widget__selection-handle:hover,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle,.ck.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected.ck-widget_with-selection-handle>.ck-widget__selection-handle:hover{background:var(--ck-color-widget-blurred-border)}.ck.ck-editor__editable blockquote>.ck-widget.ck-widget_with-selection-handle:first-child,.ck.ck-editor__editable>.ck-widget.ck-widget_with-selection-handle:first-child{margin-top:calc(1em + var(--ck-widget-handler-icon-size))}", "", { version: 3, sources: ["webpack://./../ckeditor5-widget/theme/widget.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-widget/widget.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_focus.css", "webpack://./../ckeditor5-theme-lark/theme/mixins/_shadow.css"], names: [], mappings: "AAKA,MACC,+CAAgD,CAChD,6CAAsD,CACtD,uCAAgD,CAEhD,kDAAmD,CACnD,gCAAiC,CACjC,kEACD,CAOA,8DAEC,iBAqBD,CAnBC,4EACC,iBAOD,CALC,qFAGC,aACD,CASD,iLACC,kBACD,CAGD,kBACC,qDAAsD,CAEtD,qDAAsD,CACtD,6CAA8C,CAF9C,0CAA2C,CAI3C,aAAc,CADd,kCAAmC,CAGnC,uCAAwC,CACxC,4CAA6C,CAF7C,iCAsCD,CAlCC,8NAKC,iBACD,CAEA,0CAEC,qCAAsC,CADtC,oCAED,CAEA,2CAEC,sCAAuC,CADvC,oCAED,CAEA,8CACC,uCAAwC,CACxC,sCACD,CAEA,6CACC,uCAAwC,CACxC,qCACD,CAGA,8CAEC,QAAS,CADT,6CAAgD,CAEhD,yBACD,CCjFD,MACC,iCAAkC,CAClC,kCAAmC,CACnC,4CAA6C,CAC7C,wCAAyC,CAEzC,wCAAiD,CACjD,sCAAkD,CAClD,2EAA4E,CAC5E,yEACD,CAEA,eAGC,yBAA0B,CAD1B,mBAAoB,CADpB,gDAAiD,CAGjD,6GAUD,CARC,0EAEC,6EACD,CAEA,qBACC,iDACD,CAGD,gCACC,4BAWD,CAPC,yGAKC,iEAAkE,CCnCnE,2BAA2B,CCF3B,qCAA8B,CDC9B,YDqCA,CAIA,4EAKC,4BAA6B,CAa7B,iEAAkE,CAhBlE,qBAAsB,CAoBtB,mDAAoD,CAhBpD,SAAU,CALV,WAAY,CAsBZ,KAAM,CAFN,2BAA4B,CAT5B,6SAgCD,CAnBC,qFAIC,oDAAqD,CADrD,yCAA0C,CAD1C,wCAWD,CANC,kHACC,SAAU,CAGV,+DACD,CAID,wHACC,SACD,CAID,kFAEC,oDAAqD,CADrD,SAED,CAKC,oMAEC,6CAA8C,CAD9C,SAOD,CAHC,gRACC,SACD,CAOH,qFACC,SAAU,CACV,oDACD,CAGA,gDAEC,eAkBD,CAhBC,yEAOC,iCACD,CAGC,gOAEC,gDACD,CAOD,wIAEC,mDAQD,CALE,ghBAEC,gDACD,CAKH,yKAOC,yDACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-color-resizer: var(--ck-color-focus-border);\n	--ck-color-resizer-tooltip-background: hsl(0, 0%, 15%);\n	--ck-color-resizer-tooltip-text: hsl(0, 0%, 95%);\n\n	--ck-resizer-border-radius: var(--ck-border-radius);\n	--ck-resizer-tooltip-offset: 10px;\n	--ck-resizer-tooltip-height: calc(var(--ck-spacing-small) * 2 + 10px);\n}\n\n.ck .ck-widget {\n	/* This is neccessary for type around UI to be positioned properly. */\n	position: relative;\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n	/* Make the widget wrapper a relative positioning container for the drag handle. */\n	position: relative;\n\n	& .ck-widget__selection-handle {\n		position: absolute;\n\n		& .ck-icon {\n			/* Make sure the icon in not a subject to font-size or line-height to avoid\n			unnecessary spacing around it. */\n			display: block;\n		}\n	}\n\n	/* Show the selection handle on mouse hover over the widget, but not for nested widgets. */\n	&:hover > .ck-widget__selection-handle {\n		visibility: visible;\n	}\n\n	/* Show the selection handle when the widget is selected, but not for nested widgets. */\n	&.ck-widget_selected > .ck-widget__selection-handle {\n		visibility: visible;\n	}\n}\n\n.ck .ck-size-view {\n	background: var(--ck-color-resizer-tooltip-background);\n	color: var(--ck-color-resizer-tooltip-text);\n	border: 1px solid var(--ck-color-resizer-tooltip-text);\n	border-radius: var(--ck-resizer-border-radius);\n	font-size: var(--ck-font-size-tiny);\n	display: block;\n	padding: 0 var(--ck-spacing-small);\n	height: var(--ck-resizer-tooltip-height);\n	line-height: var(--ck-resizer-tooltip-height);\n\n	&.ck-orientation-top-left,\n	&.ck-orientation-top-right,\n	&.ck-orientation-bottom-right,\n	&.ck-orientation-bottom-left,\n	&.ck-orientation-above-center {\n		position: absolute;\n	}\n\n	&.ck-orientation-top-left {\n		top: var(--ck-resizer-tooltip-offset);\n		left: var(--ck-resizer-tooltip-offset);\n	}\n\n	&.ck-orientation-top-right {\n		top: var(--ck-resizer-tooltip-offset);\n		right: var(--ck-resizer-tooltip-offset);\n	}\n\n	&.ck-orientation-bottom-right {\n		bottom: var(--ck-resizer-tooltip-offset);\n		right: var(--ck-resizer-tooltip-offset);\n	}\n\n	&.ck-orientation-bottom-left {\n		bottom: var(--ck-resizer-tooltip-offset);\n		left: var(--ck-resizer-tooltip-offset);\n	}\n\n	/* Class applied if the widget is too small to contain the size label */\n	&.ck-orientation-above-center {\n		top: calc(var(--ck-resizer-tooltip-height) * -1);\n		left: 50%;\n		transform: translate(-50%);\n	}\n}\n", '/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n@import "../mixins/_focus.css";\n@import "../mixins/_shadow.css";\n\n:root {\n	--ck-widget-outline-thickness: 3px;\n	--ck-widget-handler-icon-size: 16px;\n	--ck-widget-handler-animation-duration: 200ms;\n	--ck-widget-handler-animation-curve: ease;\n\n	--ck-color-widget-blurred-border: hsl(0, 0%, 87%);\n	--ck-color-widget-hover-border: hsl(43, 100%, 62%);\n	--ck-color-widget-editable-focus-background: var(--ck-color-base-background);\n	--ck-color-widget-drag-handler-icon-color: var(--ck-color-base-background);\n}\n\n.ck .ck-widget {\n	outline-width: var(--ck-widget-outline-thickness);\n	outline-style: solid;\n	outline-color: transparent;\n	transition: outline-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n	&.ck-widget_selected,\n	&.ck-widget_selected:hover {\n		outline: var(--ck-widget-outline-thickness) solid var(--ck-color-focus-border);\n	}\n\n	&:hover {\n		outline-color: var(--ck-color-widget-hover-border);\n	}\n}\n\n.ck .ck-editor__nested-editable {\n	border: 1px solid transparent;\n\n	/* The :focus style is applied before .ck-editor__nested-editable_focused class is rendered in the view.\n	These styles show a different border for a blink of an eye, so `:focus` need to have same styles applied. */\n	&.ck-editor__nested-editable_focused,\n	&:focus {\n		@mixin ck-focus-ring;\n		@mixin ck-box-shadow var(--ck-inner-shadow);\n\n		background-color: var(--ck-color-widget-editable-focus-background);\n	}\n}\n\n.ck .ck-widget.ck-widget_with-selection-handle {\n	& .ck-widget__selection-handle {\n		padding: 4px;\n		box-sizing: border-box;\n\n		/* Background and opacity will be animated as the handler shows up or the widget gets selected. */\n		background-color: transparent;\n		opacity: 0;\n\n		/* Transition:\n		   * background-color for the .ck-widget_selected state change,\n		   * visibility for hiding the handler,\n		   * opacity for the proper look of the icon when the handler disappears. */\n		transition:\n			background-color var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n			visibility var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),\n			opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);\n\n		/* Make only top corners round. */\n		border-radius: var(--ck-border-radius) var(--ck-border-radius) 0 0;\n\n		/* Place the drag handler outside the widget wrapper. */\n		transform: translateY(-100%);\n		left: calc(0px - var(--ck-widget-outline-thickness));\n		top: 0;\n\n		& .ck-icon {\n			/* Make sure the dimensions of the icon are independent of the fon-size of the content. */\n			width: var(--ck-widget-handler-icon-size);\n			height: var(--ck-widget-handler-icon-size);\n			color: var(--ck-color-widget-drag-handler-icon-color);\n\n			/* The "selected" part of the icon is invisible by default */\n			& .ck-icon__selected-indicator {\n				opacity: 0;\n\n				/* Note: The animation is longer on purpose. Simply feels better. */\n				transition: opacity 300ms var(--ck-widget-handler-animation-curve);\n			}\n		}\n\n		/* Advertise using the look of the icon that once clicked the handler, the widget will be selected. */\n		&:hover .ck-icon .ck-icon__selected-indicator {\n			opacity: 1;\n		}\n	}\n\n	/* Show the selection handler on mouse hover over the widget, but not for nested widgets. */\n	&:hover > .ck-widget__selection-handle {\n		opacity: 1;\n		background-color: var(--ck-color-widget-hover-border);\n	}\n\n	/* Show the selection handler when the widget is selected, but not for nested widgets. */\n	&.ck-widget_selected,\n	&.ck-widget_selected:hover {\n		& > .ck-widget__selection-handle {\n			opacity: 1;\n			background-color: var(--ck-color-focus-border);\n\n			/* When the widget is selected, notify the user using the proper look of the icon. */\n			& .ck-icon .ck-icon__selected-indicator {\n				opacity: 1;\n			}\n		}\n	}\n}\n\n/* In a RTL environment, align the selection handler to the right side of the widget */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__selection-handle {\n	left: auto;\n	right: calc(0px - var(--ck-widget-outline-thickness));\n}\n\n/* https://github.com/ckeditor/ckeditor5/issues/6415 */\n.ck.ck-editor__editable.ck-read-only .ck-widget {\n	/* Prevent the :hover outline from showing up because of the used outline-color transition. */\n	transition: none;\n\n	&:not(.ck-widget_selected) {\n		/* Disable visual effects of hover/active widget when CKEditor is in readOnly mode.\n		 * See: https://github.com/ckeditor/ckeditor5/issues/1261\n		 *\n		 * Leave the unit because this custom property is used in calc() by other features.\n		 * See: https://github.com/ckeditor/ckeditor5/issues/6775\n		 */\n		--ck-widget-outline-thickness: 0px;\n	}\n\n	&.ck-widget_with-selection-handle {\n		& .ck-widget__selection-handle,\n		& .ck-widget__selection-handle:hover {\n			background: var(--ck-color-widget-blurred-border);\n		}\n	}\n}\n\n/* Style the widget when it\'s selected but the editable it belongs to lost focus. */\n/* stylelint-disable-next-line no-descending-specificity */\n.ck.ck-editor__editable.ck-blurred .ck-widget {\n	&.ck-widget_selected,\n	&.ck-widget_selected:hover {\n		outline-color: var(--ck-color-widget-blurred-border);\n\n		&.ck-widget_with-selection-handle {\n			& > .ck-widget__selection-handle,\n			& > .ck-widget__selection-handle:hover {\n				background: var(--ck-color-widget-blurred-border);\n			}\n		}\n	}\n}\n\n.ck.ck-editor__editable > .ck-widget.ck-widget_with-selection-handle:first-child,\n.ck.ck-editor__editable blockquote > .ck-widget.ck-widget_with-selection-handle:first-child {\n	/* Do not crop selection handler if a widget is a first-child in the blockquote or in the root editable.\n	In fact, anything with overflow: hidden.\n	https://github.com/ckeditor/ckeditor5-block-quote/issues/28\n	https://github.com/ckeditor/ckeditor5-widget/issues/44\n	https://github.com/ckeditor/ckeditor5-widget/issues/66 */\n	margin-top: calc(1em + var(--ck-widget-handler-icon-size));\n}\n', "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A visual style of focused element's border.\n */\n@define-mixin ck-focus-ring {\n	/* Disable native outline. */\n	outline: none;\n	border: var(--ck-focus-ring)\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n/**\n * A helper to combine multiple shadows.\n */\n@define-mixin ck-box-shadow $shadowA, $shadowB: 0 0 {\n	box-shadow: $shadowA, $shadowB;\n}\n\n/**\n * Gives an element a drop shadow so it looks like a floating panel.\n */\n@define-mixin ck-drop-shadow {\n	@mixin ck-box-shadow var(--ck-drop-shadow);\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 8506: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, ".ck .ck-widget_with-resizer{position:relative}.ck .ck-widget__resizer{display:none;left:0;pointer-events:none;position:absolute;top:0}.ck-focused .ck-widget_with-resizer.ck-widget_selected>.ck-widget__resizer{display:block}.ck .ck-widget__resizer__handle{pointer-events:all;position:absolute}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{cursor:nwse-resize}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left,.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{cursor:nesw-resize}:root{--ck-resizer-size:10px;--ck-resizer-offset:calc(var(--ck-resizer-size)/-2 - 2px);--ck-resizer-border-width:1px}.ck .ck-widget__resizer{outline:1px solid var(--ck-color-resizer)}.ck .ck-widget__resizer__handle{background:var(--ck-color-focus-border);border:var(--ck-resizer-border-width) solid #fff;border-radius:var(--ck-resizer-border-radius);height:var(--ck-resizer-size);width:var(--ck-resizer-size)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-left{left:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-top-right{right:var(--ck-resizer-offset);top:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-right{bottom:var(--ck-resizer-offset);right:var(--ck-resizer-offset)}.ck .ck-widget__resizer__handle.ck-widget__resizer__handle-bottom-left{bottom:var(--ck-resizer-offset);left:var(--ck-resizer-offset)}", "", { version: 3, sources: ["webpack://./../ckeditor5-widget/theme/widgetresize.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-widget/widgetresize.css"], names: [], mappings: "AAKA,4BAEC,iBACD,CAEA,wBACC,YAAa,CAMb,MAAO,CAFP,mBAAoB,CAHpB,iBAAkB,CAMlB,KACD,CAGC,2EACC,aACD,CAGD,gCAIC,kBAAmB,CAHnB,iBAcD,CATC,4IAEC,kBACD,CAEA,4IAEC,kBACD,CCpCD,MACC,sBAAuB,CAGvB,yDAAiE,CACjE,6BACD,CAEA,wBACC,yCACD,CAEA,gCAGC,uCAAwC,CACxC,gDAA6D,CAC7D,6CAA8C,CAH9C,6BAA8B,CAD9B,4BAyBD,CAnBC,oEAEC,6BAA8B,CAD9B,4BAED,CAEA,qEAEC,8BAA+B,CAD/B,4BAED,CAEA,wEACC,+BAAgC,CAChC,8BACD,CAEA,uEACC,+BAAgC,CAChC,6BACD", sourcesContent: ["/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n.ck .ck-widget_with-resizer {\n	/* Make the widget wrapper a relative positioning container for the drag handle. */\n	position: relative;\n}\n\n.ck .ck-widget__resizer {\n	display: none;\n	position: absolute;\n\n	/* The wrapper itself should not interfere with the pointer device, only the handles should. */\n	pointer-events: none;\n\n	left: 0;\n	top: 0;\n}\n\n.ck-focused .ck-widget_with-resizer.ck-widget_selected {\n	& > .ck-widget__resizer {\n		display: block;\n	}\n}\n\n.ck .ck-widget__resizer__handle {\n	position: absolute;\n\n	/* Resizers are the only UI elements that should interfere with a pointer device. */\n	pointer-events: all;\n\n	&.ck-widget__resizer__handle-top-left,\n	&.ck-widget__resizer__handle-bottom-right {\n		cursor: nwse-resize;\n	}\n\n	&.ck-widget__resizer__handle-top-right,\n	&.ck-widget__resizer__handle-bottom-left {\n		cursor: nesw-resize;\n	}\n}\n", "/*\n * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.\n * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license\n */\n\n:root {\n	--ck-resizer-size: 10px;\n\n	/* Set the resizer with a 50% offset. */\n	--ck-resizer-offset: calc( ( var(--ck-resizer-size) / -2 ) - 2px);\n	--ck-resizer-border-width: 1px;\n}\n\n.ck .ck-widget__resizer {\n	outline: 1px solid var(--ck-color-resizer);\n}\n\n.ck .ck-widget__resizer__handle {\n	width: var(--ck-resizer-size);\n	height: var(--ck-resizer-size);\n	background: var(--ck-color-focus-border);\n	border: var(--ck-resizer-border-width) solid hsl(0, 0%, 100%);\n	border-radius: var(--ck-resizer-border-radius);\n\n	&.ck-widget__resizer__handle-top-left {\n		top: var(--ck-resizer-offset);\n		left: var(--ck-resizer-offset);\n	}\n\n	&.ck-widget__resizer__handle-top-right {\n		top: var(--ck-resizer-offset);\n		right: var(--ck-resizer-offset);\n	}\n\n	&.ck-widget__resizer__handle-bottom-right {\n		bottom: var(--ck-resizer-offset);\n		right: var(--ck-resizer-offset);\n	}\n\n	&.ck-widget__resizer__handle-bottom-left {\n		bottom: var(--ck-resizer-offset);\n		left: var(--ck-resizer-offset);\n	}\n}\n"], sourceRoot: "" }]);
        const a = s2;
      }, 4921: (t2, e2, n2) => {
        "use strict";
        n2.d(e2, { Z: () => a });
        var o2 = n2(1799), i = n2.n(o2), r = n2(2609), s2 = n2.n(r)()(i());
        s2.push([t2.id, '.ck .ck-widget .ck-widget__type-around__button{display:block;overflow:hidden;position:absolute;z-index:var(--ck-z-default)}.ck .ck-widget .ck-widget__type-around__button svg{left:50%;position:absolute;top:50%;z-index:calc(var(--ck-z-default) + 2)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_before{left:min(10%,30px);top:calc(var(--ck-widget-outline-thickness)*-.5);transform:translateY(-50%)}.ck .ck-widget .ck-widget__type-around__button.ck-widget__type-around__button_after{bottom:calc(var(--ck-widget-outline-thickness)*-.5);right:min(10%,30px);transform:translateY(50%)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{content:"";display:block;left:1px;position:absolute;top:1px;z-index:calc(var(--ck-z-default) + 1)}.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:none;left:0;position:absolute;right:0}.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__fake-caret{left:calc(var(--ck-widget-outline-thickness)*-1);right:calc(var(--ck-widget-outline-thickness)*-1)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__fake-caret{display:block;top:calc(var(--ck-widget-outline-thickness)*-1 - 1px)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__fake-caret{bottom:calc(var(--ck-widget-outline-thickness)*-1 - 1px);display:block}.ck.ck-editor__editable.ck-read-only .ck-widget__type-around,.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around,.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around{display:none}:root{--ck-widget-type-around-button-size:20px;--ck-color-widget-type-around-button-active:var(--ck-color-focus-border);--ck-color-widget-type-around-button-hover:var(--ck-color-widget-hover-border);--ck-color-widget-type-around-button-blurred-editable:var(--ck-color-widget-blurred-border);--ck-color-widget-type-around-button-radar-start-alpha:0;--ck-color-widget-type-around-button-radar-end-alpha:.3;--ck-color-widget-type-around-button-icon:var(--ck-color-base-background)}.ck .ck-widget .ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button);border-radius:100px;height:var(--ck-widget-type-around-button-size);opacity:0;pointer-events:none;transition:opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve),background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);width:var(--ck-widget-type-around-button-size)}.ck .ck-widget .ck-widget__type-around__button svg{height:8px;margin-top:1px;transform:translate(-50%,-50%);transition:transform .5s ease;width:10px}.ck .ck-widget .ck-widget__type-around__button svg *{stroke-dasharray:10;stroke-dashoffset:0;fill:none;stroke:var(--ck-color-widget-type-around-button-icon);stroke-width:1.5px;stroke-linecap:round;stroke-linejoin:round}.ck .ck-widget .ck-widget__type-around__button svg line{stroke-dasharray:7}.ck .ck-widget .ck-widget__type-around__button:hover{animation:ck-widget-type-around-button-sonar 1s ease infinite}.ck .ck-widget .ck-widget__type-around__button:hover svg polyline{animation:ck-widget-type-around-arrow-dash 2s linear}.ck .ck-widget .ck-widget__type-around__button:hover svg line{animation:ck-widget-type-around-arrow-tip-dash 2s linear}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:1;pointer-events:auto}.ck .ck-widget:not(.ck-widget_selected)>.ck-widget__type-around>.ck-widget__type-around__button{background:var(--ck-color-widget-type-around-button-hover)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover{background:var(--ck-color-widget-type-around-button-active)}.ck .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:after,.ck .ck-widget>.ck-widget__type-around>.ck-widget__type-around__button:hover:after{background:linear-gradient(135deg,hsla(0,0%,100%,0),hsla(0,0%,100%,.3));border-radius:100px;height:calc(var(--ck-widget-type-around-button-size) - 2px);width:calc(var(--ck-widget-type-around-button-size) - 2px)}.ck .ck-widget.ck-widget_with-selection-handle>.ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:20px}.ck .ck-widget .ck-widget__type-around__fake-caret{animation:ck-widget-type-around-fake-caret-pulse 1s linear infinite normal forwards;background:var(--ck-color-base-text);height:1px;outline:1px solid hsla(0,0%,100%,.5);pointer-events:none}.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_after,.ck .ck-widget.ck-widget_selected.ck-widget_type-around_show-fake-caret_before{outline-color:transparent}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected:hover,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected:hover{outline-color:var(--ck-color-widget-hover-border)}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after>.ck-widget__type-around>.ck-widget__type-around__button,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_after.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_selected.ck-widget_with-resizer>.ck-widget__resizer,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected:hover>.ck-widget__selection-handle,.ck .ck-widget.ck-widget_type-around_show-fake-caret_before.ck-widget_with-selection-handle.ck-widget_selected>.ck-widget__selection-handle{opacity:0}.ck[dir=rtl] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around>.ck-widget__type-around__button_before{margin-left:0;margin-right:20px}.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button,.ck-editor__nested-editable.ck-editor__editable_selected .ck-widget:hover>.ck-widget__type-around>.ck-widget__type-around__button{opacity:0;pointer-events:none}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover){background:var(--ck-color-widget-type-around-button-blurred-editable)}.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected>.ck-widget__type-around>.ck-widget__type-around__button:not(:hover) svg *{stroke:#999}@keyframes ck-widget-type-around-arrow-dash{0%{stroke-dashoffset:10}20%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-arrow-tip-dash{0%,20%{stroke-dashoffset:7}40%,to{stroke-dashoffset:0}}@keyframes ck-widget-type-around-button-sonar{0%{box-shadow:0 0 0 0 hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}50%{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-end-alpha))}to{box-shadow:0 0 0 5px hsla(var(--ck-color-focus-border-coordinates),var(--ck-color-widget-type-around-button-radar-start-alpha))}}@keyframes ck-widget-type-around-fake-caret-pulse{0%{opacity:1}49%{opacity:1}50%{opacity:0}99%{opacity:0}to{opacity:1}}', "", { version: 3, sources: ["webpack://./../ckeditor5-widget/theme/widgettypearound.css", "webpack://./../ckeditor5-theme-lark/theme/ckeditor5-widget/widgettypearound.css"], names: [], mappings: "AASC,+CACC,aAAc,CAEd,eAAgB,CADhB,iBAAkB,CAElB,2BAwBD,CAtBC,mDAGC,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAEA,qFAGC,kBAAoB,CADpB,gDAAoD,CAGpD,0BACD,CAEA,oFAEC,mDAAuD,CACvD,mBAAqB,CAErB,yBACD,CAUA,mLACC,UAAW,CACX,aAAc,CAGd,QAAS,CAFT,iBAAkB,CAClB,OAAQ,CAER,qCACD,CAMD,2EACC,YAAa,CAEb,MAAO,CADP,iBAAkB,CAElB,OACD,CAOA,iFACC,gDAAqD,CACrD,iDACD,CAKA,wHAEC,aAAc,CADd,qDAED,CAKA,uHACC,wDAA6D,CAC7D,aACD,CAoBD,mOACC,YACD,CC3GA,MACC,wCAAyC,CACzC,wEAAyE,CACzE,8EAA+E,CAC/E,2FAA4F,CAC5F,wDAAyD,CACzD,uDAAwD,CACxD,yEACD,CAgBC,+CAGC,oDAAqD,CACrD,mBAAoB,CAFpB,+CAAgD,CAVjD,SAAU,CACV,mBAAoB,CAYnB,uMAAyM,CAJzM,8CAkDD,CA1CC,mDAEC,UAAW,CAGX,cAAe,CAFf,8BAA+B,CAC/B,6BAA8B,CAH9B,UAoBD,CAdC,qDACC,mBAAoB,CACpB,mBAAoB,CAEpB,SAAU,CACV,qDAAsD,CACtD,kBAAmB,CACnB,oBAAqB,CACrB,qBACD,CAEA,wDACC,kBACD,CAGD,qDAIC,6DAcD,CARE,kEACC,oDACD,CAEA,8DACC,wDACD,CAUF,uKAvED,SAAU,CACV,mBAwEC,CAOD,gGACC,0DACD,CAOA,uKAEC,2DAQD,CANC,mLAIC,uEAAkF,CADlF,mBAAoB,CADpB,2DAA4D,CAD5D,0DAID,CAOD,8GACC,gBACD,CAKA,mDAGC,mFAAoF,CAOpF,oCAAqC,CARrC,UAAW,CAOX,oCAAwC,CARxC,mBAUD,CAOC,6JAEC,yBACD,CAUA,yKACC,iDACD,CAMA,uOAlJD,SAAU,CACV,mBAmJC,CAoBA,6yBACC,SACD,CASF,uHACC,aAAc,CACd,iBACD,CAYG,iRAlMF,SAAU,CACV,mBAmME,CAQH,kIACC,qEAKD,CAHC,wIACC,WACD,CAGD,4CACC,GACC,oBACD,CACA,OACC,mBACD,CACD,CAEA,gDACC,OACC,mBACD,CACA,OACC,mBACD,CACD,CAEA,8CACC,GACC,6HACD,CACA,IACC,6HACD,CACA,GACC,+HACD,CACD,CAEA,kDACC,GACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,IACC,SACD,CACA,GACC,SACD,CACD", sourcesContent: [`/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

.ck .ck-widget {
	/*
	 * Styles of the type around buttons
	 */
	& .ck-widget__type-around__button {
		display: block;
		position: absolute;
		overflow: hidden;
		z-index: var(--ck-z-default);

		& svg {
			position: absolute;
			top: 50%;
			left: 50%;
			z-index: calc(var(--ck-z-default) + 2);
		}

		&.ck-widget__type-around__button_before {
			/* Place it in the middle of the outline */
			top: calc(-0.5 * var(--ck-widget-outline-thickness));
			left: min(10%, 30px);

			transform: translateY(-50%);
		}

		&.ck-widget__type-around__button_after {
			/* Place it in the middle of the outline */
			bottom: calc(-0.5 * var(--ck-widget-outline-thickness));
			right: min(10%, 30px);

			transform: translateY(50%);
		}
	}

	/*
	 * Styles for the buttons when:
	 * - the widget is selected,
	 * - or the button is being hovered (regardless of the widget state).
	 */
	&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,
	& > .ck-widget__type-around > .ck-widget__type-around__button:hover {
		&::after {
			content: "";
			display: block;
			position: absolute;
			top: 1px;
			left: 1px;
			z-index: calc(var(--ck-z-default) + 1);
		}
	}

	/*
	 * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.
	 */
	& > .ck-widget__type-around > .ck-widget__type-around__fake-caret {
		display: none;
		position: absolute;
		left: 0;
		right: 0;
	}

	/*
	 * When the widget is hovered the "fake caret" would normally be narrower than the
	 * extra outline displayed around the widget. Let's extend the "fake caret" to match
	 * the full width of the widget.
	 */
	&:hover > .ck-widget__type-around > .ck-widget__type-around__fake-caret {
		left: calc( -1 * var(--ck-widget-outline-thickness) );
		right: calc( -1 * var(--ck-widget-outline-thickness) );
	}

	/*
	 * Styles for the horizontal "fake caret" when it should be displayed before the widget (backward keyboard navigation).
	 */
	&.ck-widget_type-around_show-fake-caret_before > .ck-widget__type-around > .ck-widget__type-around__fake-caret {
		top: calc( -1 * var(--ck-widget-outline-thickness) - 1px );
		display: block;
	}

	/*
	 * Styles for the horizontal "fake caret" when it should be displayed after the widget (forward keyboard navigation).
	 */
	&.ck-widget_type-around_show-fake-caret_after > .ck-widget__type-around > .ck-widget__type-around__fake-caret {
		bottom: calc( -1 * var(--ck-widget-outline-thickness) - 1px );
		display: block;
	}
}

/*
 * Integration with the read-only mode of the editor.
 */
.ck.ck-editor__editable.ck-read-only .ck-widget__type-around {
	display: none;
}

/*
 * Integration with the restricted editing mode (feature) of the editor.
 */
.ck.ck-editor__editable.ck-restricted-editing_mode_restricted .ck-widget__type-around {
	display: none;
}

/*
 * Integration with the #isEnabled property of the WidgetTypeAround plugin.
 */
.ck.ck-editor__editable.ck-widget__type-around_disabled .ck-widget__type-around {
	display: none;
}
`, `/*
 * Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

:root {
	--ck-widget-type-around-button-size: 20px;
	--ck-color-widget-type-around-button-active: var(--ck-color-focus-border);
	--ck-color-widget-type-around-button-hover: var(--ck-color-widget-hover-border);
	--ck-color-widget-type-around-button-blurred-editable: var(--ck-color-widget-blurred-border);
	--ck-color-widget-type-around-button-radar-start-alpha: 0;
	--ck-color-widget-type-around-button-radar-end-alpha: .3;
	--ck-color-widget-type-around-button-icon: var(--ck-color-base-background);
}

@define-mixin ck-widget-type-around-button-visible {
	opacity: 1;
	pointer-events: auto;
}

@define-mixin ck-widget-type-around-button-hidden {
	opacity: 0;
	pointer-events: none;
}

.ck .ck-widget {
	/*
	 * Styles of the type around buttons
	 */
	& .ck-widget__type-around__button {
		width: var(--ck-widget-type-around-button-size);
		height: var(--ck-widget-type-around-button-size);
		background: var(--ck-color-widget-type-around-button);
		border-radius: 100px;
		transition: opacity var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve), background var(--ck-widget-handler-animation-duration) var(--ck-widget-handler-animation-curve);

		@mixin ck-widget-type-around-button-hidden;

		& svg {
			width: 10px;
			height: 8px;
			transform: translate(-50%,-50%);
			transition: transform .5s ease;
			margin-top: 1px;

			& * {
				stroke-dasharray: 10;
				stroke-dashoffset: 0;

				fill: none;
				stroke: var(--ck-color-widget-type-around-button-icon);
				stroke-width: 1.5px;
				stroke-linecap: round;
				stroke-linejoin: round;
			}

			& line {
				stroke-dasharray: 7;
			}
		}

		&:hover {
			/*
			 * Display the "sonar" around the button when hovered.
			 */
			animation: ck-widget-type-around-button-sonar 1s ease infinite;

			/*
			 * Animate active button's icon.
			 */
			& svg {
				& polyline {
					animation: ck-widget-type-around-arrow-dash 2s linear;
				}

				& line {
					animation: ck-widget-type-around-arrow-tip-dash 2s linear;
				}
			}
		}
	}

	/*
	 * Show type around buttons when the widget gets selected or being hovered.
	 */
	&.ck-widget_selected,
	&:hover {
		& > .ck-widget__type-around > .ck-widget__type-around__button {
			@mixin ck-widget-type-around-button-visible;
		}
	}

	/*
	 * Styles for the buttons when the widget is NOT selected (but the buttons are visible
	 * and still can be hovered).
	 */
	&:not(.ck-widget_selected) > .ck-widget__type-around > .ck-widget__type-around__button {
		background: var(--ck-color-widget-type-around-button-hover);
	}

	/*
	 * Styles for the buttons when:
	 * - the widget is selected,
	 * - or the button is being hovered (regardless of the widget state).
	 */
	&.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button,
	& > .ck-widget__type-around > .ck-widget__type-around__button:hover {
		background: var(--ck-color-widget-type-around-button-active);

		&::after {
			width: calc(var(--ck-widget-type-around-button-size) - 2px);
			height: calc(var(--ck-widget-type-around-button-size) - 2px);
			border-radius: 100px;
			background: linear-gradient(135deg, hsla(0,0%,100%,0) 0%, hsla(0,0%,100%,.3) 100%);
		}
	}

	/*
	 * Styles for the "before" button when the widget has a selection handle. Because some space
	 * is consumed by the handle, the button must be moved slightly to the right to let it breathe.
	 */
	&.ck-widget_with-selection-handle > .ck-widget__type-around > .ck-widget__type-around__button_before {
		margin-left: 20px;
	}

	/*
	 * Styles for the horizontal "fake caret" which is displayed when the user navigates using the keyboard.
	 */
	& .ck-widget__type-around__fake-caret {
		pointer-events: none;
		height: 1px;
		animation: ck-widget-type-around-fake-caret-pulse linear 1s infinite normal forwards;

		/*
		 * The semi-transparent-outline+background combo improves the contrast
		 * when the background underneath the fake caret is dark.
		 */
		outline: solid 1px hsla(0, 0%, 100%, .5);
		background: var(--ck-color-base-text);
	}

	/*
	 * Styles of the widget when the "fake caret" is blinking (e.g. upon keyboard navigation).
	 * Despite the widget being physically selected in the model, its outline should disappear.
	 */
	&.ck-widget_selected {
		&.ck-widget_type-around_show-fake-caret_before,
		&.ck-widget_type-around_show-fake-caret_after {
			outline-color: transparent;
		}
	}

	&.ck-widget_type-around_show-fake-caret_before,
	&.ck-widget_type-around_show-fake-caret_after {
		/*
		 * When the "fake caret" is visible we simulate that the widget is not selected
		 * (despite being physically selected), so the outline color should be for the
		 * unselected widget.
		 */
		&.ck-widget_selected:hover {
			outline-color: var(--ck-color-widget-hover-border);
		}

		/*
		 * Styles of the type around buttons when the "fake caret" is blinking (e.g. upon keyboard navigation).
		 * In this state, the type around buttons would collide with the fake carets so they should disappear.
		 */
		& > .ck-widget__type-around > .ck-widget__type-around__button {
			@mixin ck-widget-type-around-button-hidden;
		}

		/*
		 * Fake horizontal caret integration with the selection handle. When the caret is visible, simply
		 * hide the handle because it intersects with the caret (and does not make much sense anyway).
		 */
		&.ck-widget_with-selection-handle {
			&.ck-widget_selected,
			&.ck-widget_selected:hover {
				& > .ck-widget__selection-handle {
					opacity: 0
				}
			}
		}

		/*
		 * Fake horizontal caret integration with the resize UI. When the caret is visible, simply
		 * hide the resize UI because it creates too much noise. It can be visible when the user
		 * hovers the widget, though.
		 */
		&.ck-widget_selected.ck-widget_with-resizer > .ck-widget__resizer {
			opacity: 0
		}
	}
}

/*
 * Styles for the "before" button when the widget has a selection handle in an RTL environment.
 * The selection handler is aligned to the right side of the widget so there is no need to create
 * additional space for it next to the "before" button.
 */
.ck[dir="rtl"] .ck-widget.ck-widget_with-selection-handle .ck-widget__type-around > .ck-widget__type-around__button_before {
	margin-left: 0;
	margin-right: 20px;
}

/*
 * Hide type around buttons when the widget is selected as a child of a selected
 * nested editable (e.g. mulit-cell table selection).
 *
 * See https://github.com/ckeditor/ckeditor5/issues/7263.
 */
.ck-editor__nested-editable.ck-editor__editable_selected {
	& .ck-widget {
		&.ck-widget_selected,
		&:hover {
			& > .ck-widget__type-around > .ck-widget__type-around__button {
				@mixin ck-widget-type-around-button-hidden;
			}
		}
	}
}

/*
 * Styles for the buttons when the widget is selected but the user clicked outside of the editor (blurred the editor).
 */
.ck-editor__editable.ck-blurred .ck-widget.ck-widget_selected > .ck-widget__type-around > .ck-widget__type-around__button:not(:hover) {
	background: var(--ck-color-widget-type-around-button-blurred-editable);

	& svg * {
		stroke: hsl(0,0%,60%);
	}
}

@keyframes ck-widget-type-around-arrow-dash {
	0% {
		stroke-dashoffset: 10;
	}
	20%, 100% {
		stroke-dashoffset: 0;
	}
}

@keyframes ck-widget-type-around-arrow-tip-dash {
	0%, 20% {
		stroke-dashoffset: 7;
	}
	40%, 100% {
		stroke-dashoffset: 0;
	}
}

@keyframes ck-widget-type-around-button-sonar {
	0% {
		box-shadow: 0 0 0 0 hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));
	}
	50% {
		box-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-end-alpha));
	}
	100% {
		box-shadow: 0 0 0 5px hsla(var(--ck-color-focus-border-coordinates), var(--ck-color-widget-type-around-button-radar-start-alpha));
	}
}

@keyframes ck-widget-type-around-fake-caret-pulse {
	0% {
		opacity: 1;
	}
	49% {
		opacity: 1;
	}
	50% {
		opacity: 0;
	}
	99% {
		opacity: 0;
	}
	100% {
		opacity: 1;
	}
}
`], sourceRoot: "" }]);
        const a = s2;
      }, 2609: (t2) => {
        "use strict";
        t2.exports = function(t3) {
          var e2 = [];
          return e2.toString = function() {
            return this.map(function(e3) {
              var n2 = t3(e3);
              return e3[2] ? "@media ".concat(e3[2], " {").concat(n2, "}") : n2;
            }).join("");
          }, e2.i = function(t4, n2, o2) {
            "string" == typeof t4 && (t4 = [[null, t4, ""]]);
            var i = {};
            if (o2)
              for (var r = 0; r < this.length; r++) {
                var s2 = this[r][0];
                null != s2 && (i[s2] = true);
              }
            for (var a = 0; a < t4.length; a++) {
              var c = [].concat(t4[a]);
              o2 && i[c[0]] || (n2 && (c[2] ? c[2] = "".concat(n2, " and ").concat(c[2]) : c[2] = n2), e2.push(c));
            }
          }, e2;
        };
      }, 1799: (t2) => {
        "use strict";
        function e2(t3, e3) {
          return function(t4) {
            if (Array.isArray(t4))
              return t4;
          }(t3) || function(t4, e4) {
            var n3 = t4 && ("undefined" != typeof Symbol && t4[Symbol.iterator] || t4["@@iterator"]);
            if (null == n3)
              return;
            var o2, i, r = [], s2 = true, a = false;
            try {
              for (n3 = n3.call(t4); !(s2 = (o2 = n3.next()).done) && (r.push(o2.value), !e4 || r.length !== e4); s2 = true)
                ;
            } catch (t5) {
              a = true, i = t5;
            } finally {
              try {
                s2 || null == n3.return || n3.return();
              } finally {
                if (a)
                  throw i;
              }
            }
            return r;
          }(t3, e3) || function(t4, e4) {
            if (!t4)
              return;
            if ("string" == typeof t4)
              return n2(t4, e4);
            var o2 = Object.prototype.toString.call(t4).slice(8, -1);
            "Object" === o2 && t4.constructor && (o2 = t4.constructor.name);
            if ("Map" === o2 || "Set" === o2)
              return Array.from(t4);
            if ("Arguments" === o2 || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(o2))
              return n2(t4, e4);
          }(t3, e3) || function() {
            throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
          }();
        }
        function n2(t3, e3) {
          (null == e3 || e3 > t3.length) && (e3 = t3.length);
          for (var n3 = 0, o2 = new Array(e3); n3 < e3; n3++)
            o2[n3] = t3[n3];
          return o2;
        }
        t2.exports = function(t3) {
          var n3 = e2(t3, 4), o2 = n3[1], i = n3[3];
          if (!i)
            return o2;
          if ("function" == typeof btoa) {
            var r = btoa(unescape(encodeURIComponent(JSON.stringify(i)))), s2 = "sourceMappingURL=data:application/json;charset=utf-8;base64,".concat(r), a = "/*# ".concat(s2, " */"), c = i.sources.map(function(t4) {
              return "/*# sourceURL=".concat(i.sourceRoot || "").concat(t4, " */");
            });
            return [o2].concat(c).concat([a]).join("\n");
          }
          return [o2].join("\n");
        };
      }, 6062: (t2, e2, n2) => {
        "use strict";
        var o2, i = function() {
          return void 0 === o2 && (o2 = Boolean(window && document && document.all && !window.atob)), o2;
        }, r = function() {
          var t3 = {};
          return function(e3) {
            if (void 0 === t3[e3]) {
              var n3 = document.querySelector(e3);
              if (window.HTMLIFrameElement && n3 instanceof window.HTMLIFrameElement)
                try {
                  n3 = n3.contentDocument.head;
                } catch (t4) {
                  n3 = null;
                }
              t3[e3] = n3;
            }
            return t3[e3];
          };
        }(), s2 = [];
        function a(t3) {
          for (var e3 = -1, n3 = 0; n3 < s2.length; n3++)
            if (s2[n3].identifier === t3) {
              e3 = n3;
              break;
            }
          return e3;
        }
        function c(t3, e3) {
          for (var n3 = {}, o3 = [], i2 = 0; i2 < t3.length; i2++) {
            var r2 = t3[i2], c2 = e3.base ? r2[0] + e3.base : r2[0], l2 = n3[c2] || 0, d2 = "".concat(c2, " ").concat(l2);
            n3[c2] = l2 + 1;
            var h2 = a(d2), u2 = { css: r2[1], media: r2[2], sourceMap: r2[3] };
            -1 !== h2 ? (s2[h2].references++, s2[h2].updater(u2)) : s2.push({ identifier: d2, updater: f(u2, e3), references: 1 }), o3.push(d2);
          }
          return o3;
        }
        function l(t3) {
          var e3 = document.createElement("style"), o3 = t3.attributes || {};
          if (void 0 === o3.nonce) {
            var i2 = n2.nc;
            i2 && (o3.nonce = i2);
          }
          if (Object.keys(o3).forEach(function(t4) {
            e3.setAttribute(t4, o3[t4]);
          }), "function" == typeof t3.insert)
            t3.insert(e3);
          else {
            var s3 = r(t3.insert || "head");
            if (!s3)
              throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            s3.appendChild(e3);
          }
          return e3;
        }
        var d, h = (d = [], function(t3, e3) {
          return d[t3] = e3, d.filter(Boolean).join("\n");
        });
        function u(t3, e3, n3, o3) {
          var i2 = n3 ? "" : o3.media ? "@media ".concat(o3.media, " {").concat(o3.css, "}") : o3.css;
          if (t3.styleSheet)
            t3.styleSheet.cssText = h(e3, i2);
          else {
            var r2 = document.createTextNode(i2), s3 = t3.childNodes;
            s3[e3] && t3.removeChild(s3[e3]), s3.length ? t3.insertBefore(r2, s3[e3]) : t3.appendChild(r2);
          }
        }
        function g(t3, e3, n3) {
          var o3 = n3.css, i2 = n3.media, r2 = n3.sourceMap;
          if (i2 ? t3.setAttribute("media", i2) : t3.removeAttribute("media"), r2 && "undefined" != typeof btoa && (o3 += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r2)))), " */")), t3.styleSheet)
            t3.styleSheet.cssText = o3;
          else {
            for (; t3.firstChild; )
              t3.removeChild(t3.firstChild);
            t3.appendChild(document.createTextNode(o3));
          }
        }
        var p = null, m = 0;
        function f(t3, e3) {
          var n3, o3, i2;
          if (e3.singleton) {
            var r2 = m++;
            n3 = p || (p = l(e3)), o3 = u.bind(null, n3, r2, false), i2 = u.bind(null, n3, r2, true);
          } else
            n3 = l(e3), o3 = g.bind(null, n3, e3), i2 = function() {
              !function(t4) {
                if (null === t4.parentNode)
                  return false;
                t4.parentNode.removeChild(t4);
              }(n3);
            };
          return o3(t3), function(e4) {
            if (e4) {
              if (e4.css === t3.css && e4.media === t3.media && e4.sourceMap === t3.sourceMap)
                return;
              o3(t3 = e4);
            } else
              i2();
          };
        }
        t2.exports = function(t3, e3) {
          (e3 = e3 || {}).singleton || "boolean" == typeof e3.singleton || (e3.singleton = i());
          var n3 = c(t3 = t3 || [], e3);
          return function(t4) {
            if (t4 = t4 || [], "[object Array]" === Object.prototype.toString.call(t4)) {
              for (var o3 = 0; o3 < n3.length; o3++) {
                var i2 = a(n3[o3]);
                s2[i2].references--;
              }
              for (var r2 = c(t4, e3), l2 = 0; l2 < n3.length; l2++) {
                var d2 = a(n3[l2]);
                0 === s2[d2].references && (s2[d2].updater(), s2.splice(d2, 1));
              }
              n3 = r2;
            }
          };
        };
      } }, e = {};
      function n(o2) {
        var i = e[o2];
        if (void 0 !== i)
          return i.exports;
        var r = e[o2] = { id: o2, exports: {} };
        return t[o2](r, r.exports, n), r.exports;
      }
      n.n = (t2) => {
        var e2 = t2 && t2.__esModule ? () => t2.default : () => t2;
        return n.d(e2, { a: e2 }), e2;
      }, n.d = (t2, e2) => {
        for (var o2 in e2)
          n.o(e2, o2) && !n.o(t2, o2) && Object.defineProperty(t2, o2, { enumerable: true, get: e2[o2] });
      }, n.o = (t2, e2) => Object.prototype.hasOwnProperty.call(t2, e2), n.nc = void 0;
      var o = {};
      return (() => {
        "use strict";
        function t2({ emitter: t3, activator: e3, callback: n2, contextElements: o2 }) {
          t3.listenTo(document, "mousedown", (t4, i2) => {
            if (!e3())
              return;
            const r2 = "function" == typeof i2.composedPath ? i2.composedPath() : [], s3 = "function" == typeof o2 ? o2() : o2;
            for (const t5 of s3)
              if (t5.contains(i2.target) || r2.includes(t5))
                return;
            n2();
          });
        }
        function e2(t3) {
          return class extends t3 {
            disableCssTransitions() {
              this._isCssTransitionsDisabled = true;
            }
            enableCssTransitions() {
              this._isCssTransitionsDisabled = false;
            }
            constructor(...t4) {
              super(...t4), this.set("_isCssTransitionsDisabled", false), this.initializeCssTransitionDisablerMixin();
            }
            initializeCssTransitionDisablerMixin() {
              this.extendTemplate({ attributes: { class: [this.bindTemplate.if("_isCssTransitionsDisabled", "ck-transitions-disabled")] } });
            }
          };
        }
        function i({ view: t3 }) {
          t3.listenTo(t3.element, "submit", (e3, n2) => {
            n2.preventDefault(), t3.fire("submit");
          }, { useCapture: true });
        }
        n.d(o, { default: () => iI });
        const r = function() {
          try {
            return navigator.userAgent.toLowerCase();
          } catch (t3) {
            return "";
          }
        }();
        var s2;
        const a = { isMac: c(r), isWindows: (s2 = r, s2.indexOf("windows") > -1), isGecko: function(t3) {
          return !!t3.match(/gecko\/\d+/);
        }(r), isSafari: function(t3) {
          return t3.indexOf(" applewebkit/") > -1 && -1 === t3.indexOf("chrome");
        }(r), isiOS: function(t3) {
          return !!t3.match(/iphone|ipad/i) || c(t3) && navigator.maxTouchPoints > 0;
        }(r), isAndroid: function(t3) {
          return t3.indexOf("android") > -1;
        }(r), isBlink: function(t3) {
          return t3.indexOf("chrome/") > -1 && t3.indexOf("edge/") < 0;
        }(r), features: { isRegExpUnicodePropertySupported: function() {
          let t3 = false;
          try {
            t3 = 0 === "\u0107".search(new RegExp("[\\p{L}]", "u"));
          } catch (t4) {
          }
          return t3;
        }() } };
        function c(t3) {
          return t3.indexOf("macintosh") > -1;
        }
        function l(t3, e3, n2, o2) {
          n2 = n2 || function(t4, e4) {
            return t4 === e4;
          };
          const i2 = Array.isArray(t3) ? t3 : Array.prototype.slice.call(t3), r2 = Array.isArray(e3) ? e3 : Array.prototype.slice.call(e3), s3 = function(t4, e4, n3) {
            const o3 = d(t4, e4, n3);
            if (-1 === o3)
              return { firstIndex: -1, lastIndexOld: -1, lastIndexNew: -1 };
            const i3 = h(t4, o3), r3 = h(e4, o3), s4 = d(i3, r3, n3), a3 = t4.length - s4, c2 = e4.length - s4;
            return { firstIndex: o3, lastIndexOld: a3, lastIndexNew: c2 };
          }(i2, r2, n2), a2 = o2 ? function(t4, e4) {
            const { firstIndex: n3, lastIndexOld: o3, lastIndexNew: i3 } = t4;
            if (-1 === n3)
              return Array(e4).fill("equal");
            let r3 = [];
            n3 > 0 && (r3 = r3.concat(Array(n3).fill("equal")));
            i3 - n3 > 0 && (r3 = r3.concat(Array(i3 - n3).fill("insert")));
            o3 - n3 > 0 && (r3 = r3.concat(Array(o3 - n3).fill("delete")));
            i3 < e4 && (r3 = r3.concat(Array(e4 - i3).fill("equal")));
            return r3;
          }(s3, r2.length) : function(t4, e4) {
            const n3 = [], { firstIndex: o3, lastIndexOld: i3, lastIndexNew: r3 } = e4;
            r3 - o3 > 0 && n3.push({ index: o3, type: "insert", values: t4.slice(o3, r3) });
            i3 - o3 > 0 && n3.push({ index: o3 + (r3 - o3), type: "delete", howMany: i3 - o3 });
            return n3;
          }(r2, s3);
          return a2;
        }
        function d(t3, e3, n2) {
          for (let o2 = 0; o2 < Math.max(t3.length, e3.length); o2++)
            if (void 0 === t3[o2] || void 0 === e3[o2] || !n2(t3[o2], e3[o2]))
              return o2;
          return -1;
        }
        function h(t3, e3) {
          return t3.slice(e3).reverse();
        }
        function u(t3, e3, n2) {
          n2 = n2 || function(t4, e4) {
            return t4 === e4;
          };
          const o2 = t3.length, i2 = e3.length;
          if (o2 > 200 || i2 > 200 || o2 + i2 > 300)
            return u.fastDiff(t3, e3, n2, true);
          let r2, s3;
          if (i2 < o2) {
            const n3 = t3;
            t3 = e3, e3 = n3, r2 = "delete", s3 = "insert";
          } else
            r2 = "insert", s3 = "delete";
          const a2 = t3.length, c2 = e3.length, l2 = c2 - a2, d2 = {}, h2 = {};
          function g2(o3) {
            const i3 = (void 0 !== h2[o3 - 1] ? h2[o3 - 1] : -1) + 1, l3 = void 0 !== h2[o3 + 1] ? h2[o3 + 1] : -1, u2 = i3 > l3 ? -1 : 1;
            d2[o3 + u2] && (d2[o3] = d2[o3 + u2].slice(0)), d2[o3] || (d2[o3] = []), d2[o3].push(i3 > l3 ? r2 : s3);
            let g3 = Math.max(i3, l3), p3 = g3 - o3;
            for (; p3 < a2 && g3 < c2 && n2(t3[p3], e3[g3]); )
              p3++, g3++, d2[o3].push("equal");
            return g3;
          }
          let p2, m2 = 0;
          do {
            for (p2 = -m2; p2 < l2; p2++)
              h2[p2] = g2(p2);
            for (p2 = l2 + m2; p2 > l2; p2--)
              h2[p2] = g2(p2);
            h2[l2] = g2(l2), m2++;
          } while (h2[l2] !== c2);
          return d2[l2].slice(1);
        }
        u.fastDiff = l;
        const g = function() {
          return function t3() {
            t3.called = true;
          };
        };
        class p {
          constructor(t3, e3) {
            this.source = t3, this.name = e3, this.path = [], this.stop = g(), this.off = g();
          }
        }
        const m = new Array(256).fill("").map((t3, e3) => ("0" + e3.toString(16)).slice(-2));
        function f() {
          const t3 = 4294967296 * Math.random() >>> 0, e3 = 4294967296 * Math.random() >>> 0, n2 = 4294967296 * Math.random() >>> 0, o2 = 4294967296 * Math.random() >>> 0;
          return "e" + m[t3 >> 0 & 255] + m[t3 >> 8 & 255] + m[t3 >> 16 & 255] + m[t3 >> 24 & 255] + m[e3 >> 0 & 255] + m[e3 >> 8 & 255] + m[e3 >> 16 & 255] + m[e3 >> 24 & 255] + m[n2 >> 0 & 255] + m[n2 >> 8 & 255] + m[n2 >> 16 & 255] + m[n2 >> 24 & 255] + m[o2 >> 0 & 255] + m[o2 >> 8 & 255] + m[o2 >> 16 & 255] + m[o2 >> 24 & 255];
        }
        const k = { get(t3 = "normal") {
          return "number" != typeof t3 ? this[t3] || this.normal : t3;
        }, highest: 1e5, high: 1e3, normal: 0, low: -1e3, lowest: -1e5 };
        function b(t3, e3) {
          const n2 = k.get(e3.priority);
          for (let o2 = 0; o2 < t3.length; o2++)
            if (k.get(t3[o2].priority) < n2)
              return void t3.splice(o2, 0, e3);
          t3.push(e3);
        }
        const w = "https://ckeditor.com/docs/ckeditor5/latest/support/error-codes.html";
        class A extends Error {
          constructor(t3, e3, n2) {
            super(function(t4, e4) {
              const n3 = /* @__PURE__ */ new WeakSet(), o2 = (t5, e5) => {
                if ("object" == typeof e5 && null !== e5) {
                  if (n3.has(e5))
                    return `[object ${e5.constructor.name}]`;
                  n3.add(e5);
                }
                return e5;
              }, i2 = e4 ? ` ${JSON.stringify(e4, o2)}` : "", r2 = v(t4);
              return t4 + i2 + r2;
            }(t3, n2)), this.name = "CKEditorError", this.context = e3, this.data = n2;
          }
          is(t3) {
            return "CKEditorError" === t3;
          }
          static rethrowUnexpectedError(t3, e3) {
            if (t3.is && t3.is("CKEditorError"))
              throw t3;
            const n2 = new A(t3.message, e3);
            throw n2.stack = t3.stack, n2;
          }
        }
        function C(t3, e3) {
          console.warn(...y2(t3, e3));
        }
        function _(t3, e3) {
          console.error(...y2(t3, e3));
        }
        function v(t3) {
          return `
Read more: ${w}#error-${t3}`;
        }
        function y2(t3, e3) {
          const n2 = v(t3);
          return e3 ? [t3, e3, n2] : [t3, n2];
        }
        const x2 = "40.2.0", E = new Date(2023, 11, 12);
        if (globalThis.CKEDITOR_VERSION)
          throw new A("ckeditor-duplicated-modules", null);
        globalThis.CKEDITOR_VERSION = x2;
        const D = Symbol("listeningTo"), I = Symbol("emitterId"), S = Symbol("delegations"), T = M(Object);
        function M(t3) {
          if (!t3)
            return T;
          return class extends t3 {
            on(t4, e3, n2) {
              this.listenTo(this, t4, e3, n2);
            }
            once(t4, e3, n2) {
              let o2 = false;
              this.listenTo(this, t4, (t5, ...n3) => {
                o2 || (o2 = true, t5.off(), e3.call(this, t5, ...n3));
              }, n2);
            }
            off(t4, e3) {
              this.stopListening(this, t4, e3);
            }
            listenTo(t4, e3, n2, o2 = {}) {
              let i2, r2;
              this[D] || (this[D] = {});
              const s3 = this[D];
              N(t4) || B(t4);
              const a2 = N(t4);
              (i2 = s3[a2]) || (i2 = s3[a2] = { emitter: t4, callbacks: {} }), (r2 = i2.callbacks[e3]) || (r2 = i2.callbacks[e3] = []), r2.push(n2), function(t5, e4, n3, o3, i3) {
                e4._addEventListener ? e4._addEventListener(n3, o3, i3) : t5._addEventListener.call(e4, n3, o3, i3);
              }(this, t4, e3, n2, o2);
            }
            stopListening(t4, e3, n2) {
              const o2 = this[D];
              let i2 = t4 && N(t4);
              const r2 = o2 && i2 ? o2[i2] : void 0, s3 = r2 && e3 ? r2.callbacks[e3] : void 0;
              if (!(!o2 || t4 && !r2 || e3 && !s3))
                if (n2) {
                  R(this, t4, e3, n2);
                  -1 !== s3.indexOf(n2) && (1 === s3.length ? delete r2.callbacks[e3] : R(this, t4, e3, n2));
                } else if (s3) {
                  for (; n2 = s3.pop(); )
                    R(this, t4, e3, n2);
                  delete r2.callbacks[e3];
                } else if (r2) {
                  for (e3 in r2.callbacks)
                    this.stopListening(t4, e3);
                  delete o2[i2];
                } else {
                  for (i2 in o2)
                    this.stopListening(o2[i2].emitter);
                  delete this[D];
                }
            }
            fire(t4, ...e3) {
              try {
                const n2 = t4 instanceof p ? t4 : new p(this, t4), o2 = n2.name;
                let i2 = O(this, o2);
                if (n2.path.push(this), i2) {
                  const t5 = [n2, ...e3];
                  i2 = Array.from(i2);
                  for (let e4 = 0; e4 < i2.length && (i2[e4].callback.apply(this, t5), n2.off.called && (delete n2.off.called, this._removeEventListener(o2, i2[e4].callback)), !n2.stop.called); e4++)
                    ;
                }
                const r2 = this[S];
                if (r2) {
                  const t5 = r2.get(o2), i3 = r2.get("*");
                  t5 && L(t5, n2, e3), i3 && L(i3, n2, e3);
                }
                return n2.return;
              } catch (t5) {
                A.rethrowUnexpectedError(t5, this);
              }
            }
            delegate(...t4) {
              return { to: (e3, n2) => {
                this[S] || (this[S] = /* @__PURE__ */ new Map()), t4.forEach((t5) => {
                  const o2 = this[S].get(t5);
                  o2 ? o2.set(e3, n2) : this[S].set(t5, /* @__PURE__ */ new Map([[e3, n2]]));
                });
              } };
            }
            stopDelegating(t4, e3) {
              if (this[S])
                if (t4)
                  if (e3) {
                    const n2 = this[S].get(t4);
                    n2 && n2.delete(e3);
                  } else
                    this[S].delete(t4);
                else
                  this[S].clear();
            }
            _addEventListener(t4, e3, n2) {
              !function(t5, e4) {
                const n3 = P(t5);
                if (n3[e4])
                  return;
                let o3 = e4, i3 = null;
                const r2 = [];
                for (; "" !== o3 && !n3[o3]; )
                  n3[o3] = { callbacks: [], childEvents: [] }, r2.push(n3[o3]), i3 && n3[o3].childEvents.push(i3), i3 = o3, o3 = o3.substr(0, o3.lastIndexOf(":"));
                if ("" !== o3) {
                  for (const t6 of r2)
                    t6.callbacks = n3[o3].callbacks.slice();
                  n3[o3].childEvents.push(i3);
                }
              }(this, t4);
              const o2 = z(this, t4), i2 = { callback: e3, priority: k.get(n2.priority) };
              for (const t5 of o2)
                b(t5, i2);
            }
            _removeEventListener(t4, e3) {
              const n2 = z(this, t4);
              for (const t5 of n2)
                for (let n3 = 0; n3 < t5.length; n3++)
                  t5[n3].callback == e3 && (t5.splice(n3, 1), n3--);
            }
          };
        }
        function B(t3, e3) {
          t3[I] || (t3[I] = e3 || f());
        }
        function N(t3) {
          return t3[I];
        }
        function P(t3) {
          return t3._events || Object.defineProperty(t3, "_events", { value: {} }), t3._events;
        }
        function z(t3, e3) {
          const n2 = P(t3)[e3];
          if (!n2)
            return [];
          let o2 = [n2.callbacks];
          for (let e4 = 0; e4 < n2.childEvents.length; e4++) {
            const i2 = z(t3, n2.childEvents[e4]);
            o2 = o2.concat(i2);
          }
          return o2;
        }
        function O(t3, e3) {
          let n2;
          return t3._events && (n2 = t3._events[e3]) && n2.callbacks.length ? n2.callbacks : e3.indexOf(":") > -1 ? O(t3, e3.substr(0, e3.lastIndexOf(":"))) : null;
        }
        function L(t3, e3, n2) {
          for (let [o2, i2] of t3) {
            i2 ? "function" == typeof i2 && (i2 = i2(e3.name)) : i2 = e3.name;
            const t4 = new p(e3.source, i2);
            t4.path = [...e3.path], o2.fire(t4, ...n2);
          }
        }
        function R(t3, e3, n2, o2) {
          e3._removeEventListener ? e3._removeEventListener(n2, o2) : t3._removeEventListener.call(e3, n2, o2);
        }
        ["on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach((t3) => {
          M[t3] = T.prototype[t3];
        });
        const j = function(t3) {
          var e3 = typeof t3;
          return null != t3 && ("object" == e3 || "function" == e3);
        }, F = Symbol("observableProperties"), V = Symbol("boundObservables"), U = Symbol("boundProperties"), H = Symbol("decoratedMethods"), q = Symbol("decoratedOriginal"), G = W(M());
        function W(t3) {
          if (!t3)
            return G;
          return class extends t3 {
            set(t4, e3) {
              if (j(t4))
                return void Object.keys(t4).forEach((e4) => {
                  this.set(e4, t4[e4]);
                }, this);
              K(this);
              const n2 = this[F];
              if (t4 in this && !n2.has(t4))
                throw new A("observable-set-cannot-override", this);
              Object.defineProperty(this, t4, { enumerable: true, configurable: true, get: () => n2.get(t4), set(e4) {
                const o2 = n2.get(t4);
                let i2 = this.fire(`set:${t4}`, t4, e4, o2);
                void 0 === i2 && (i2 = e4), o2 === i2 && n2.has(t4) || (n2.set(t4, i2), this.fire(`change:${t4}`, t4, i2, o2));
              } }), this[t4] = e3;
            }
            bind(...t4) {
              if (!t4.length || !$(t4))
                throw new A("observable-bind-wrong-properties", this);
              if (new Set(t4).size !== t4.length)
                throw new A("observable-bind-duplicate-properties", this);
              K(this);
              const e3 = this[U];
              t4.forEach((t5) => {
                if (e3.has(t5))
                  throw new A("observable-bind-rebind", this);
              });
              const n2 = /* @__PURE__ */ new Map();
              return t4.forEach((t5) => {
                const o2 = { property: t5, to: [] };
                e3.set(t5, o2), n2.set(t5, o2);
              }), { to: Z, toMany: Y, _observable: this, _bindProperties: t4, _to: [], _bindings: n2 };
            }
            unbind(...t4) {
              if (!this[F])
                return;
              const e3 = this[U], n2 = this[V];
              if (t4.length) {
                if (!$(t4))
                  throw new A("observable-unbind-wrong-properties", this);
                t4.forEach((t5) => {
                  const o2 = e3.get(t5);
                  o2 && (o2.to.forEach(([t6, e4]) => {
                    const i2 = n2.get(t6), r2 = i2[e4];
                    r2.delete(o2), r2.size || delete i2[e4], Object.keys(i2).length || (n2.delete(t6), this.stopListening(t6, "change"));
                  }), e3.delete(t5));
                });
              } else
                n2.forEach((t5, e4) => {
                  this.stopListening(e4, "change");
                }), n2.clear(), e3.clear();
            }
            decorate(t4) {
              K(this);
              const e3 = this[t4];
              if (!e3)
                throw new A("observablemixin-cannot-decorate-undefined", this, { object: this, methodName: t4 });
              this.on(t4, (t5, n2) => {
                t5.return = e3.apply(this, n2);
              }), this[t4] = function(...e4) {
                return this.fire(t4, e4);
              }, this[t4][q] = e3, this[H] || (this[H] = []), this[H].push(t4);
            }
            stopListening(t4, e3, n2) {
              if (!t4 && this[H]) {
                for (const t5 of this[H])
                  this[t5] = this[t5][q];
                delete this[H];
              }
              super.stopListening(t4, e3, n2);
            }
          };
        }
        function K(t3) {
          t3[F] || (Object.defineProperty(t3, F, { value: /* @__PURE__ */ new Map() }), Object.defineProperty(t3, V, { value: /* @__PURE__ */ new Map() }), Object.defineProperty(t3, U, { value: /* @__PURE__ */ new Map() }));
        }
        function Z(...t3) {
          const e3 = function(...t4) {
            if (!t4.length)
              throw new A("observable-bind-to-parse-error", null);
            const e4 = { to: [] };
            let n3;
            "function" == typeof t4[t4.length - 1] && (e4.callback = t4.pop());
            return t4.forEach((t5) => {
              if ("string" == typeof t5)
                n3.properties.push(t5);
              else {
                if ("object" != typeof t5)
                  throw new A("observable-bind-to-parse-error", null);
                n3 = { observable: t5, properties: [] }, e4.to.push(n3);
              }
            }), e4;
          }(...t3), n2 = Array.from(this._bindings.keys()), o2 = n2.length;
          if (!e3.callback && e3.to.length > 1)
            throw new A("observable-bind-to-no-callback", this);
          if (o2 > 1 && e3.callback)
            throw new A("observable-bind-to-extra-callback", this);
          var i2;
          e3.to.forEach((t4) => {
            if (t4.properties.length && t4.properties.length !== o2)
              throw new A("observable-bind-to-properties-length", this);
            t4.properties.length || (t4.properties = this._bindProperties);
          }), this._to = e3.to, e3.callback && (this._bindings.get(n2[0]).callback = e3.callback), i2 = this._observable, this._to.forEach((t4) => {
            const e4 = i2[V];
            let n3;
            e4.get(t4.observable) || i2.listenTo(t4.observable, "change", (o3, r2) => {
              n3 = e4.get(t4.observable)[r2], n3 && n3.forEach((t5) => {
                Q(i2, t5.property);
              });
            });
          }), function(t4) {
            let e4;
            t4._bindings.forEach((n3, o3) => {
              t4._to.forEach((i3) => {
                e4 = i3.properties[n3.callback ? 0 : t4._bindProperties.indexOf(o3)], n3.to.push([i3.observable, e4]), function(t5, e5, n4, o4) {
                  const i4 = t5[V], r2 = i4.get(n4), s3 = r2 || {};
                  s3[o4] || (s3[o4] = /* @__PURE__ */ new Set());
                  s3[o4].add(e5), r2 || i4.set(n4, s3);
                }(t4._observable, n3, i3.observable, e4);
              });
            });
          }(this), this._bindProperties.forEach((t4) => {
            Q(this._observable, t4);
          });
        }
        function Y(t3, e3, n2) {
          if (this._bindings.size > 1)
            throw new A("observable-bind-to-many-not-one-binding", this);
          this.to(...function(t4, e4) {
            const n3 = t4.map((t5) => [t5, e4]);
            return Array.prototype.concat.apply([], n3);
          }(t3, e3), n2);
        }
        function $(t3) {
          return t3.every((t4) => "string" == typeof t4);
        }
        function Q(t3, e3) {
          const n2 = t3[U].get(e3);
          let o2;
          n2.callback ? o2 = n2.callback.apply(t3, n2.to.map((t4) => t4[0][t4[1]])) : (o2 = n2.to[0], o2 = o2[0][o2[1]]), Object.prototype.hasOwnProperty.call(t3, e3) ? t3[e3] = o2 : t3.set(e3, o2);
        }
        ["set", "bind", "unbind", "decorate", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach((t3) => {
          W[t3] = G.prototype[t3];
        });
        class J {
          constructor() {
            this._replacedElements = [];
          }
          replace(t3, e3) {
            this._replacedElements.push({ element: t3, newElement: e3 }), t3.style.display = "none", e3 && t3.parentNode.insertBefore(e3, t3.nextSibling);
          }
          restore() {
            this._replacedElements.forEach(({ element: t3, newElement: e3 }) => {
              t3.style.display = "", e3 && e3.remove();
            }), this._replacedElements = [];
          }
        }
        function X(t3) {
          let e3 = 0;
          for (const n2 of t3)
            e3++;
          return e3;
        }
        function tt(t3, e3) {
          const n2 = Math.min(t3.length, e3.length);
          for (let o2 = 0; o2 < n2; o2++)
            if (t3[o2] != e3[o2])
              return o2;
          return t3.length == e3.length ? "same" : t3.length < e3.length ? "prefix" : "extension";
        }
        function et(t3) {
          return !(!t3 || !t3[Symbol.iterator]);
        }
        const nt = "object" == typeof global && global && global.Object === Object && global;
        var ot = "object" == typeof self && self && self.Object === Object && self;
        const it = nt || ot || Function("return this")();
        const rt = it.Symbol;
        var st = Object.prototype, at = st.hasOwnProperty, ct = st.toString, lt = rt ? rt.toStringTag : void 0;
        const dt = function(t3) {
          var e3 = at.call(t3, lt), n2 = t3[lt];
          try {
            t3[lt] = void 0;
            var o2 = true;
          } catch (t4) {
          }
          var i2 = ct.call(t3);
          return o2 && (e3 ? t3[lt] = n2 : delete t3[lt]), i2;
        };
        var ht = Object.prototype.toString;
        const ut = function(t3) {
          return ht.call(t3);
        };
        var gt = rt ? rt.toStringTag : void 0;
        const pt = function(t3) {
          return null == t3 ? void 0 === t3 ? "[object Undefined]" : "[object Null]" : gt && gt in Object(t3) ? dt(t3) : ut(t3);
        };
        const mt = Array.isArray;
        const ft = function(t3) {
          return null != t3 && "object" == typeof t3;
        };
        const kt = function(t3) {
          return "string" == typeof t3 || !mt(t3) && ft(t3) && "[object String]" == pt(t3);
        };
        function bt(t3, e3, n2 = {}, o2 = []) {
          const i2 = n2 && n2.xmlns, r2 = i2 ? t3.createElementNS(i2, e3) : t3.createElement(e3);
          for (const t4 in n2)
            r2.setAttribute(t4, n2[t4]);
          !kt(o2) && et(o2) || (o2 = [o2]);
          for (let e4 of o2)
            kt(e4) && (e4 = t3.createTextNode(e4)), r2.appendChild(e4);
          return r2;
        }
        const wt = function(t3, e3) {
          return function(n2) {
            return t3(e3(n2));
          };
        };
        const At = wt(Object.getPrototypeOf, Object);
        var Ct = Function.prototype, _t = Object.prototype, vt = Ct.toString, yt = _t.hasOwnProperty, xt = vt.call(Object);
        const Et = function(t3) {
          if (!ft(t3) || "[object Object]" != pt(t3))
            return false;
          var e3 = At(t3);
          if (null === e3)
            return true;
          var n2 = yt.call(e3, "constructor") && e3.constructor;
          return "function" == typeof n2 && n2 instanceof n2 && vt.call(n2) == xt;
        };
        const Dt = function() {
          this.__data__ = [], this.size = 0;
        };
        const It = function(t3, e3) {
          return t3 === e3 || t3 != t3 && e3 != e3;
        };
        const St = function(t3, e3) {
          for (var n2 = t3.length; n2--; )
            if (It(t3[n2][0], e3))
              return n2;
          return -1;
        };
        var Tt = Array.prototype.splice;
        const Mt = function(t3) {
          var e3 = this.__data__, n2 = St(e3, t3);
          return !(n2 < 0) && (n2 == e3.length - 1 ? e3.pop() : Tt.call(e3, n2, 1), --this.size, true);
        };
        const Bt = function(t3) {
          var e3 = this.__data__, n2 = St(e3, t3);
          return n2 < 0 ? void 0 : e3[n2][1];
        };
        const Nt = function(t3) {
          return St(this.__data__, t3) > -1;
        };
        const Pt = function(t3, e3) {
          var n2 = this.__data__, o2 = St(n2, t3);
          return o2 < 0 ? (++this.size, n2.push([t3, e3])) : n2[o2][1] = e3, this;
        };
        function zt(t3) {
          var e3 = -1, n2 = null == t3 ? 0 : t3.length;
          for (this.clear(); ++e3 < n2; ) {
            var o2 = t3[e3];
            this.set(o2[0], o2[1]);
          }
        }
        zt.prototype.clear = Dt, zt.prototype.delete = Mt, zt.prototype.get = Bt, zt.prototype.has = Nt, zt.prototype.set = Pt;
        const Ot = zt;
        const Lt = function() {
          this.__data__ = new Ot(), this.size = 0;
        };
        const Rt = function(t3) {
          var e3 = this.__data__, n2 = e3.delete(t3);
          return this.size = e3.size, n2;
        };
        const jt = function(t3) {
          return this.__data__.get(t3);
        };
        const Ft = function(t3) {
          return this.__data__.has(t3);
        };
        const Vt = function(t3) {
          if (!j(t3))
            return false;
          var e3 = pt(t3);
          return "[object Function]" == e3 || "[object GeneratorFunction]" == e3 || "[object AsyncFunction]" == e3 || "[object Proxy]" == e3;
        };
        const Ut = it["__core-js_shared__"];
        var Ht = function() {
          var t3 = /[^.]+$/.exec(Ut && Ut.keys && Ut.keys.IE_PROTO || "");
          return t3 ? "Symbol(src)_1." + t3 : "";
        }();
        const qt = function(t3) {
          return !!Ht && Ht in t3;
        };
        var Gt = Function.prototype.toString;
        const Wt = function(t3) {
          if (null != t3) {
            try {
              return Gt.call(t3);
            } catch (t4) {
            }
            try {
              return t3 + "";
            } catch (t4) {
            }
          }
          return "";
        };
        var Kt = /^\[object .+?Constructor\]$/, Zt = Function.prototype, Yt = Object.prototype, $t = Zt.toString, Qt = Yt.hasOwnProperty, Jt = RegExp("^" + $t.call(Qt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        const Xt = function(t3) {
          return !(!j(t3) || qt(t3)) && (Vt(t3) ? Jt : Kt).test(Wt(t3));
        };
        const te = function(t3, e3) {
          return null == t3 ? void 0 : t3[e3];
        };
        const ee = function(t3, e3) {
          var n2 = te(t3, e3);
          return Xt(n2) ? n2 : void 0;
        };
        const ne = ee(it, "Map");
        const oe = ee(Object, "create");
        const ie = function() {
          this.__data__ = oe ? oe(null) : {}, this.size = 0;
        };
        const re = function(t3) {
          var e3 = this.has(t3) && delete this.__data__[t3];
          return this.size -= e3 ? 1 : 0, e3;
        };
        var se = Object.prototype.hasOwnProperty;
        const ae = function(t3) {
          var e3 = this.__data__;
          if (oe) {
            var n2 = e3[t3];
            return "__lodash_hash_undefined__" === n2 ? void 0 : n2;
          }
          return se.call(e3, t3) ? e3[t3] : void 0;
        };
        var ce = Object.prototype.hasOwnProperty;
        const le = function(t3) {
          var e3 = this.__data__;
          return oe ? void 0 !== e3[t3] : ce.call(e3, t3);
        };
        const de = function(t3, e3) {
          var n2 = this.__data__;
          return this.size += this.has(t3) ? 0 : 1, n2[t3] = oe && void 0 === e3 ? "__lodash_hash_undefined__" : e3, this;
        };
        function he(t3) {
          var e3 = -1, n2 = null == t3 ? 0 : t3.length;
          for (this.clear(); ++e3 < n2; ) {
            var o2 = t3[e3];
            this.set(o2[0], o2[1]);
          }
        }
        he.prototype.clear = ie, he.prototype.delete = re, he.prototype.get = ae, he.prototype.has = le, he.prototype.set = de;
        const ue = he;
        const ge = function() {
          this.size = 0, this.__data__ = { hash: new ue(), map: new (ne || Ot)(), string: new ue() };
        };
        const pe = function(t3) {
          var e3 = typeof t3;
          return "string" == e3 || "number" == e3 || "symbol" == e3 || "boolean" == e3 ? "__proto__" !== t3 : null === t3;
        };
        const me = function(t3, e3) {
          var n2 = t3.__data__;
          return pe(e3) ? n2["string" == typeof e3 ? "string" : "hash"] : n2.map;
        };
        const fe = function(t3) {
          var e3 = me(this, t3).delete(t3);
          return this.size -= e3 ? 1 : 0, e3;
        };
        const ke = function(t3) {
          return me(this, t3).get(t3);
        };
        const be = function(t3) {
          return me(this, t3).has(t3);
        };
        const we = function(t3, e3) {
          var n2 = me(this, t3), o2 = n2.size;
          return n2.set(t3, e3), this.size += n2.size == o2 ? 0 : 1, this;
        };
        function Ae(t3) {
          var e3 = -1, n2 = null == t3 ? 0 : t3.length;
          for (this.clear(); ++e3 < n2; ) {
            var o2 = t3[e3];
            this.set(o2[0], o2[1]);
          }
        }
        Ae.prototype.clear = ge, Ae.prototype.delete = fe, Ae.prototype.get = ke, Ae.prototype.has = be, Ae.prototype.set = we;
        const Ce = Ae;
        const _e = function(t3, e3) {
          var n2 = this.__data__;
          if (n2 instanceof Ot) {
            var o2 = n2.__data__;
            if (!ne || o2.length < 199)
              return o2.push([t3, e3]), this.size = ++n2.size, this;
            n2 = this.__data__ = new Ce(o2);
          }
          return n2.set(t3, e3), this.size = n2.size, this;
        };
        function ve(t3) {
          var e3 = this.__data__ = new Ot(t3);
          this.size = e3.size;
        }
        ve.prototype.clear = Lt, ve.prototype.delete = Rt, ve.prototype.get = jt, ve.prototype.has = Ft, ve.prototype.set = _e;
        const ye = ve;
        const xe = function(t3, e3) {
          for (var n2 = -1, o2 = null == t3 ? 0 : t3.length; ++n2 < o2 && false !== e3(t3[n2], n2, t3); )
            ;
          return t3;
        };
        const Ee = function() {
          try {
            var t3 = ee(Object, "defineProperty");
            return t3({}, "", {}), t3;
          } catch (t4) {
          }
        }();
        const De = function(t3, e3, n2) {
          "__proto__" == e3 && Ee ? Ee(t3, e3, { configurable: true, enumerable: true, value: n2, writable: true }) : t3[e3] = n2;
        };
        var Ie = Object.prototype.hasOwnProperty;
        const Se = function(t3, e3, n2) {
          var o2 = t3[e3];
          Ie.call(t3, e3) && It(o2, n2) && (void 0 !== n2 || e3 in t3) || De(t3, e3, n2);
        };
        const Te = function(t3, e3, n2, o2) {
          var i2 = !n2;
          n2 || (n2 = {});
          for (var r2 = -1, s3 = e3.length; ++r2 < s3; ) {
            var a2 = e3[r2], c2 = o2 ? o2(n2[a2], t3[a2], a2, n2, t3) : void 0;
            void 0 === c2 && (c2 = t3[a2]), i2 ? De(n2, a2, c2) : Se(n2, a2, c2);
          }
          return n2;
        };
        const Me = function(t3, e3) {
          for (var n2 = -1, o2 = Array(t3); ++n2 < t3; )
            o2[n2] = e3(n2);
          return o2;
        };
        const Be = function(t3) {
          return ft(t3) && "[object Arguments]" == pt(t3);
        };
        var Ne = Object.prototype, Pe = Ne.hasOwnProperty, ze = Ne.propertyIsEnumerable;
        const Oe = Be(function() {
          return arguments;
        }()) ? Be : function(t3) {
          return ft(t3) && Pe.call(t3, "callee") && !ze.call(t3, "callee");
        };
        const Le = function() {
          return false;
        };
        var Re = "object" == typeof exports && exports && !exports.nodeType && exports, je = Re && "object" == typeof module2 && module2 && !module2.nodeType && module2, Fe = je && je.exports === Re ? it.Buffer : void 0;
        const Ve = (Fe ? Fe.isBuffer : void 0) || Le;
        var Ue = /^(?:0|[1-9]\d*)$/;
        const He = function(t3, e3) {
          var n2 = typeof t3;
          return !!(e3 = null == e3 ? 9007199254740991 : e3) && ("number" == n2 || "symbol" != n2 && Ue.test(t3)) && t3 > -1 && t3 % 1 == 0 && t3 < e3;
        };
        const qe = function(t3) {
          return "number" == typeof t3 && t3 > -1 && t3 % 1 == 0 && t3 <= 9007199254740991;
        };
        var Ge = {};
        Ge["[object Float32Array]"] = Ge["[object Float64Array]"] = Ge["[object Int8Array]"] = Ge["[object Int16Array]"] = Ge["[object Int32Array]"] = Ge["[object Uint8Array]"] = Ge["[object Uint8ClampedArray]"] = Ge["[object Uint16Array]"] = Ge["[object Uint32Array]"] = true, Ge["[object Arguments]"] = Ge["[object Array]"] = Ge["[object ArrayBuffer]"] = Ge["[object Boolean]"] = Ge["[object DataView]"] = Ge["[object Date]"] = Ge["[object Error]"] = Ge["[object Function]"] = Ge["[object Map]"] = Ge["[object Number]"] = Ge["[object Object]"] = Ge["[object RegExp]"] = Ge["[object Set]"] = Ge["[object String]"] = Ge["[object WeakMap]"] = false;
        const We = function(t3) {
          return ft(t3) && qe(t3.length) && !!Ge[pt(t3)];
        };
        const Ke = function(t3) {
          return function(e3) {
            return t3(e3);
          };
        };
        var Ze = "object" == typeof exports && exports && !exports.nodeType && exports, Ye = Ze && "object" == typeof module2 && module2 && !module2.nodeType && module2, $e = Ye && Ye.exports === Ze && nt.process;
        const Qe = function() {
          try {
            var t3 = Ye && Ye.require && Ye.require("util").types;
            return t3 || $e && $e.binding && $e.binding("util");
          } catch (t4) {
          }
        }();
        var Je = Qe && Qe.isTypedArray;
        const Xe = Je ? Ke(Je) : We;
        var tn = Object.prototype.hasOwnProperty;
        const en = function(t3, e3) {
          var n2 = mt(t3), o2 = !n2 && Oe(t3), i2 = !n2 && !o2 && Ve(t3), r2 = !n2 && !o2 && !i2 && Xe(t3), s3 = n2 || o2 || i2 || r2, a2 = s3 ? Me(t3.length, String) : [], c2 = a2.length;
          for (var l2 in t3)
            !e3 && !tn.call(t3, l2) || s3 && ("length" == l2 || i2 && ("offset" == l2 || "parent" == l2) || r2 && ("buffer" == l2 || "byteLength" == l2 || "byteOffset" == l2) || He(l2, c2)) || a2.push(l2);
          return a2;
        };
        var nn = Object.prototype;
        const on = function(t3) {
          var e3 = t3 && t3.constructor;
          return t3 === ("function" == typeof e3 && e3.prototype || nn);
        };
        const rn = wt(Object.keys, Object);
        var sn = Object.prototype.hasOwnProperty;
        const an = function(t3) {
          if (!on(t3))
            return rn(t3);
          var e3 = [];
          for (var n2 in Object(t3))
            sn.call(t3, n2) && "constructor" != n2 && e3.push(n2);
          return e3;
        };
        const cn = function(t3) {
          return null != t3 && qe(t3.length) && !Vt(t3);
        };
        const ln = function(t3) {
          return cn(t3) ? en(t3) : an(t3);
        };
        const dn = function(t3, e3) {
          return t3 && Te(e3, ln(e3), t3);
        };
        const hn = function(t3) {
          var e3 = [];
          if (null != t3)
            for (var n2 in Object(t3))
              e3.push(n2);
          return e3;
        };
        var un = Object.prototype.hasOwnProperty;
        const gn = function(t3) {
          if (!j(t3))
            return hn(t3);
          var e3 = on(t3), n2 = [];
          for (var o2 in t3)
            ("constructor" != o2 || !e3 && un.call(t3, o2)) && n2.push(o2);
          return n2;
        };
        const pn = function(t3) {
          return cn(t3) ? en(t3, true) : gn(t3);
        };
        const mn = function(t3, e3) {
          return t3 && Te(e3, pn(e3), t3);
        };
        var fn = "object" == typeof exports && exports && !exports.nodeType && exports, kn = fn && "object" == typeof module2 && module2 && !module2.nodeType && module2, bn = kn && kn.exports === fn ? it.Buffer : void 0, wn = bn ? bn.allocUnsafe : void 0;
        const An = function(t3, e3) {
          if (e3)
            return t3.slice();
          var n2 = t3.length, o2 = wn ? wn(n2) : new t3.constructor(n2);
          return t3.copy(o2), o2;
        };
        const Cn = function(t3, e3) {
          var n2 = -1, o2 = t3.length;
          for (e3 || (e3 = Array(o2)); ++n2 < o2; )
            e3[n2] = t3[n2];
          return e3;
        };
        const _n = function(t3, e3) {
          for (var n2 = -1, o2 = null == t3 ? 0 : t3.length, i2 = 0, r2 = []; ++n2 < o2; ) {
            var s3 = t3[n2];
            e3(s3, n2, t3) && (r2[i2++] = s3);
          }
          return r2;
        };
        const vn = function() {
          return [];
        };
        var yn = Object.prototype.propertyIsEnumerable, xn = Object.getOwnPropertySymbols;
        const En = xn ? function(t3) {
          return null == t3 ? [] : (t3 = Object(t3), _n(xn(t3), function(e3) {
            return yn.call(t3, e3);
          }));
        } : vn;
        const Dn = function(t3, e3) {
          return Te(t3, En(t3), e3);
        };
        const In = function(t3, e3) {
          for (var n2 = -1, o2 = e3.length, i2 = t3.length; ++n2 < o2; )
            t3[i2 + n2] = e3[n2];
          return t3;
        };
        const Sn = Object.getOwnPropertySymbols ? function(t3) {
          for (var e3 = []; t3; )
            In(e3, En(t3)), t3 = At(t3);
          return e3;
        } : vn;
        const Tn = function(t3, e3) {
          return Te(t3, Sn(t3), e3);
        };
        const Mn = function(t3, e3, n2) {
          var o2 = e3(t3);
          return mt(t3) ? o2 : In(o2, n2(t3));
        };
        const Bn = function(t3) {
          return Mn(t3, ln, En);
        };
        const Nn = function(t3) {
          return Mn(t3, pn, Sn);
        };
        const Pn = ee(it, "DataView");
        const zn = ee(it, "Promise");
        const On = ee(it, "Set");
        const Ln = ee(it, "WeakMap");
        var Rn = "[object Map]", jn = "[object Promise]", Fn = "[object Set]", Vn = "[object WeakMap]", Un = "[object DataView]", Hn = Wt(Pn), qn = Wt(ne), Gn = Wt(zn), Wn = Wt(On), Kn = Wt(Ln), Zn = pt;
        (Pn && Zn(new Pn(new ArrayBuffer(1))) != Un || ne && Zn(new ne()) != Rn || zn && Zn(zn.resolve()) != jn || On && Zn(new On()) != Fn || Ln && Zn(new Ln()) != Vn) && (Zn = function(t3) {
          var e3 = pt(t3), n2 = "[object Object]" == e3 ? t3.constructor : void 0, o2 = n2 ? Wt(n2) : "";
          if (o2)
            switch (o2) {
              case Hn:
                return Un;
              case qn:
                return Rn;
              case Gn:
                return jn;
              case Wn:
                return Fn;
              case Kn:
                return Vn;
            }
          return e3;
        });
        const Yn = Zn;
        var $n = Object.prototype.hasOwnProperty;
        const Qn = function(t3) {
          var e3 = t3.length, n2 = new t3.constructor(e3);
          return e3 && "string" == typeof t3[0] && $n.call(t3, "index") && (n2.index = t3.index, n2.input = t3.input), n2;
        };
        const Jn = it.Uint8Array;
        const Xn = function(t3) {
          var e3 = new t3.constructor(t3.byteLength);
          return new Jn(e3).set(new Jn(t3)), e3;
        };
        const to = function(t3, e3) {
          var n2 = e3 ? Xn(t3.buffer) : t3.buffer;
          return new t3.constructor(n2, t3.byteOffset, t3.byteLength);
        };
        var eo = /\w*$/;
        const no = function(t3) {
          var e3 = new t3.constructor(t3.source, eo.exec(t3));
          return e3.lastIndex = t3.lastIndex, e3;
        };
        var oo = rt ? rt.prototype : void 0, io = oo ? oo.valueOf : void 0;
        const ro = function(t3) {
          return io ? Object(io.call(t3)) : {};
        };
        const so = function(t3, e3) {
          var n2 = e3 ? Xn(t3.buffer) : t3.buffer;
          return new t3.constructor(n2, t3.byteOffset, t3.length);
        };
        const ao = function(t3, e3, n2) {
          var o2 = t3.constructor;
          switch (e3) {
            case "[object ArrayBuffer]":
              return Xn(t3);
            case "[object Boolean]":
            case "[object Date]":
              return new o2(+t3);
            case "[object DataView]":
              return to(t3, n2);
            case "[object Float32Array]":
            case "[object Float64Array]":
            case "[object Int8Array]":
            case "[object Int16Array]":
            case "[object Int32Array]":
            case "[object Uint8Array]":
            case "[object Uint8ClampedArray]":
            case "[object Uint16Array]":
            case "[object Uint32Array]":
              return so(t3, n2);
            case "[object Map]":
            case "[object Set]":
              return new o2();
            case "[object Number]":
            case "[object String]":
              return new o2(t3);
            case "[object RegExp]":
              return no(t3);
            case "[object Symbol]":
              return ro(t3);
          }
        };
        var co = Object.create;
        const lo = function() {
          function t3() {
          }
          return function(e3) {
            if (!j(e3))
              return {};
            if (co)
              return co(e3);
            t3.prototype = e3;
            var n2 = new t3();
            return t3.prototype = void 0, n2;
          };
        }();
        const ho = function(t3) {
          return "function" != typeof t3.constructor || on(t3) ? {} : lo(At(t3));
        };
        const uo = function(t3) {
          return ft(t3) && "[object Map]" == Yn(t3);
        };
        var go = Qe && Qe.isMap;
        const po = go ? Ke(go) : uo;
        const mo = function(t3) {
          return ft(t3) && "[object Set]" == Yn(t3);
        };
        var fo = Qe && Qe.isSet;
        const ko = fo ? Ke(fo) : mo;
        var bo = "[object Arguments]", wo = "[object Function]", Ao = "[object Object]", Co = {};
        Co[bo] = Co["[object Array]"] = Co["[object ArrayBuffer]"] = Co["[object DataView]"] = Co["[object Boolean]"] = Co["[object Date]"] = Co["[object Float32Array]"] = Co["[object Float64Array]"] = Co["[object Int8Array]"] = Co["[object Int16Array]"] = Co["[object Int32Array]"] = Co["[object Map]"] = Co["[object Number]"] = Co[Ao] = Co["[object RegExp]"] = Co["[object Set]"] = Co["[object String]"] = Co["[object Symbol]"] = Co["[object Uint8Array]"] = Co["[object Uint8ClampedArray]"] = Co["[object Uint16Array]"] = Co["[object Uint32Array]"] = true, Co["[object Error]"] = Co[wo] = Co["[object WeakMap]"] = false;
        const _o = function t3(e3, n2, o2, i2, r2, s3) {
          var a2, c2 = 1 & n2, l2 = 2 & n2, d2 = 4 & n2;
          if (o2 && (a2 = r2 ? o2(e3, i2, r2, s3) : o2(e3)), void 0 !== a2)
            return a2;
          if (!j(e3))
            return e3;
          var h2 = mt(e3);
          if (h2) {
            if (a2 = Qn(e3), !c2)
              return Cn(e3, a2);
          } else {
            var u2 = Yn(e3), g2 = u2 == wo || "[object GeneratorFunction]" == u2;
            if (Ve(e3))
              return An(e3, c2);
            if (u2 == Ao || u2 == bo || g2 && !r2) {
              if (a2 = l2 || g2 ? {} : ho(e3), !c2)
                return l2 ? Tn(e3, mn(a2, e3)) : Dn(e3, dn(a2, e3));
            } else {
              if (!Co[u2])
                return r2 ? e3 : {};
              a2 = ao(e3, u2, c2);
            }
          }
          s3 || (s3 = new ye());
          var p2 = s3.get(e3);
          if (p2)
            return p2;
          s3.set(e3, a2), ko(e3) ? e3.forEach(function(i3) {
            a2.add(t3(i3, n2, o2, i3, e3, s3));
          }) : po(e3) && e3.forEach(function(i3, r3) {
            a2.set(r3, t3(i3, n2, o2, r3, e3, s3));
          });
          var m2 = h2 ? void 0 : (d2 ? l2 ? Nn : Bn : l2 ? pn : ln)(e3);
          return xe(m2 || e3, function(i3, r3) {
            m2 && (i3 = e3[r3 = i3]), Se(a2, r3, t3(i3, n2, o2, r3, e3, s3));
          }), a2;
        };
        const vo = function(t3, e3) {
          return _o(t3, 5, e3 = "function" == typeof e3 ? e3 : void 0);
        };
        const yo = function(t3) {
          return ft(t3) && 1 === t3.nodeType && !Et(t3);
        };
        class xo {
          constructor(t3, e3) {
            this._config = {}, e3 && this.define(Eo(e3)), t3 && this._setObjectToTarget(this._config, t3);
          }
          set(t3, e3) {
            this._setToTarget(this._config, t3, e3);
          }
          define(t3, e3) {
            this._setToTarget(this._config, t3, e3, true);
          }
          get(t3) {
            return this._getFromSource(this._config, t3);
          }
          *names() {
            for (const t3 of Object.keys(this._config))
              yield t3;
          }
          _setToTarget(t3, e3, n2, o2 = false) {
            if (Et(e3))
              return void this._setObjectToTarget(t3, e3, o2);
            const i2 = e3.split(".");
            e3 = i2.pop();
            for (const e4 of i2)
              Et(t3[e4]) || (t3[e4] = {}), t3 = t3[e4];
            if (Et(n2))
              return Et(t3[e3]) || (t3[e3] = {}), t3 = t3[e3], void this._setObjectToTarget(t3, n2, o2);
            o2 && void 0 !== t3[e3] || (t3[e3] = n2);
          }
          _getFromSource(t3, e3) {
            const n2 = e3.split(".");
            e3 = n2.pop();
            for (const e4 of n2) {
              if (!Et(t3[e4])) {
                t3 = null;
                break;
              }
              t3 = t3[e4];
            }
            return t3 ? Eo(t3[e3]) : void 0;
          }
          _setObjectToTarget(t3, e3, n2) {
            Object.keys(e3).forEach((o2) => {
              this._setToTarget(t3, o2, e3[o2], n2);
            });
          }
        }
        function Eo(t3) {
          return vo(t3, Do);
        }
        function Do(t3) {
          return yo(t3) || "function" == typeof t3 ? t3 : void 0;
        }
        function Io(t3) {
          if (t3) {
            if (t3.defaultView)
              return t3 instanceof t3.defaultView.Document;
            if (t3.ownerDocument && t3.ownerDocument.defaultView)
              return t3 instanceof t3.ownerDocument.defaultView.Node;
          }
          return false;
        }
        function So(t3) {
          const e3 = Object.prototype.toString.apply(t3);
          return "[object Window]" == e3 || "[object global]" == e3;
        }
        const To = Mo(M());
        function Mo(t3) {
          if (!t3)
            return To;
          return class extends t3 {
            listenTo(t4, e3, n2, o2 = {}) {
              if (Io(t4) || So(t4)) {
                const i2 = { capture: !!o2.useCapture, passive: !!o2.usePassive }, r2 = this._getProxyEmitter(t4, i2) || new Bo(t4, i2);
                this.listenTo(r2, e3, n2, o2);
              } else
                super.listenTo(t4, e3, n2, o2);
            }
            stopListening(t4, e3, n2) {
              if (Io(t4) || So(t4)) {
                const o2 = this._getAllProxyEmitters(t4);
                for (const t5 of o2)
                  this.stopListening(t5, e3, n2);
              } else
                super.stopListening(t4, e3, n2);
            }
            _getProxyEmitter(t4, e3) {
              return function(t5, e4) {
                const n2 = t5[D];
                return n2 && n2[e4] ? n2[e4].emitter : null;
              }(this, No(t4, e3));
            }
            _getAllProxyEmitters(t4) {
              return [{ capture: false, passive: false }, { capture: false, passive: true }, { capture: true, passive: false }, { capture: true, passive: true }].map((e3) => this._getProxyEmitter(t4, e3)).filter((t5) => !!t5);
            }
          };
        }
        ["_getProxyEmitter", "_getAllProxyEmitters", "on", "once", "off", "listenTo", "stopListening", "fire", "delegate", "stopDelegating", "_addEventListener", "_removeEventListener"].forEach((t3) => {
          Mo[t3] = To.prototype[t3];
        });
        class Bo extends M() {
          constructor(t3, e3) {
            super(), B(this, No(t3, e3)), this._domNode = t3, this._options = e3;
          }
          attach(t3) {
            if (this._domListeners && this._domListeners[t3])
              return;
            const e3 = this._createDomListener(t3);
            this._domNode.addEventListener(t3, e3, this._options), this._domListeners || (this._domListeners = {}), this._domListeners[t3] = e3;
          }
          detach(t3) {
            let e3;
            !this._domListeners[t3] || (e3 = this._events[t3]) && e3.callbacks.length || this._domListeners[t3].removeListener();
          }
          _addEventListener(t3, e3, n2) {
            this.attach(t3), M().prototype._addEventListener.call(this, t3, e3, n2);
          }
          _removeEventListener(t3, e3) {
            M().prototype._removeEventListener.call(this, t3, e3), this.detach(t3);
          }
          _createDomListener(t3) {
            const e3 = (e4) => {
              this.fire(t3, e4);
            };
            return e3.removeListener = () => {
              this._domNode.removeEventListener(t3, e3, this._options), delete this._domListeners[t3];
            }, e3;
          }
        }
        function No(t3, e3) {
          let n2 = function(t4) {
            return t4["data-ck-expando"] || (t4["data-ck-expando"] = f());
          }(t3);
          for (const t4 of Object.keys(e3).sort())
            e3[t4] && (n2 += "-" + t4);
          return n2;
        }
        let Po;
        try {
          Po = { window, document };
        } catch (t3) {
          Po = { window: {}, document: {} };
        }
        const zo = Po;
        function Oo(t3) {
          return "[object Text]" == Object.prototype.toString.call(t3);
        }
        function Lo(t3) {
          return "[object Range]" == Object.prototype.toString.apply(t3);
        }
        function Ro(t3) {
          const e3 = t3.ownerDocument.defaultView.getComputedStyle(t3);
          return { top: parseInt(e3.borderTopWidth, 10), right: parseInt(e3.borderRightWidth, 10), bottom: parseInt(e3.borderBottomWidth, 10), left: parseInt(e3.borderLeftWidth, 10) };
        }
        function jo(t3) {
          return t3 && t3.parentNode ? t3.offsetParent === zo.document.body ? null : t3.offsetParent : null;
        }
        const Fo = ["top", "right", "bottom", "left", "width", "height"];
        class Vo {
          constructor(t3) {
            const e3 = Lo(t3);
            if (Object.defineProperty(this, "_source", { value: t3._source || t3, writable: true, enumerable: false }), qo(t3) || e3)
              if (e3) {
                const e4 = Vo.getDomRangeRects(t3);
                Uo(this, Vo.getBoundingRect(e4));
              } else
                Uo(this, t3.getBoundingClientRect());
            else if (So(t3)) {
              const { innerWidth: e4, innerHeight: n2 } = t3;
              Uo(this, { top: 0, right: e4, bottom: n2, left: 0, width: e4, height: n2 });
            } else
              Uo(this, t3);
          }
          clone() {
            return new Vo(this);
          }
          moveTo(t3, e3) {
            return this.top = e3, this.right = t3 + this.width, this.bottom = e3 + this.height, this.left = t3, this;
          }
          moveBy(t3, e3) {
            return this.top += e3, this.right += t3, this.left += t3, this.bottom += e3, this;
          }
          getIntersection(t3) {
            const e3 = { top: Math.max(this.top, t3.top), right: Math.min(this.right, t3.right), bottom: Math.min(this.bottom, t3.bottom), left: Math.max(this.left, t3.left), width: 0, height: 0 };
            if (e3.width = e3.right - e3.left, e3.height = e3.bottom - e3.top, e3.width < 0 || e3.height < 0)
              return null;
            {
              const t4 = new Vo(e3);
              return t4._source = this._source, t4;
            }
          }
          getIntersectionArea(t3) {
            const e3 = this.getIntersection(t3);
            return e3 ? e3.getArea() : 0;
          }
          getArea() {
            return this.width * this.height;
          }
          getVisible() {
            const t3 = this._source;
            let e3 = this.clone();
            if (Ho(t3))
              return e3;
            let n2, o2 = t3, i2 = t3.parentNode || t3.commonAncestorContainer;
            for (; i2 && !Ho(i2); ) {
              const t4 = "visible" === ((r2 = i2) instanceof HTMLElement ? r2.ownerDocument.defaultView.getComputedStyle(r2).overflow : "visible");
              o2 instanceof HTMLElement && "absolute" === Go(o2) && (n2 = o2);
              const s3 = Go(i2);
              if (t4 || n2 && ("relative" === s3 && t4 || "relative" !== s3)) {
                o2 = i2, i2 = i2.parentNode;
                continue;
              }
              const a2 = new Vo(i2), c2 = e3.getIntersection(a2);
              if (!c2)
                return null;
              c2.getArea() < e3.getArea() && (e3 = c2), o2 = i2, i2 = i2.parentNode;
            }
            var r2;
            return e3;
          }
          isEqual(t3) {
            for (const e3 of Fo)
              if (this[e3] !== t3[e3])
                return false;
            return true;
          }
          contains(t3) {
            const e3 = this.getIntersection(t3);
            return !(!e3 || !e3.isEqual(t3));
          }
          toAbsoluteRect() {
            const { scrollX: t3, scrollY: e3 } = zo.window, n2 = this.clone().moveBy(t3, e3);
            if (qo(n2._source)) {
              const t4 = jo(n2._source);
              t4 && function(t5, e4) {
                const n3 = new Vo(e4), o2 = Ro(e4);
                let i2 = 0, r2 = 0;
                i2 -= n3.left, r2 -= n3.top, i2 += e4.scrollLeft, r2 += e4.scrollTop, i2 -= o2.left, r2 -= o2.top, t5.moveBy(i2, r2);
              }(n2, t4);
            }
            return n2;
          }
          excludeScrollbarsAndBorders() {
            const t3 = this._source;
            let e3, n2, o2;
            if (So(t3))
              e3 = t3.innerWidth - t3.document.documentElement.clientWidth, n2 = t3.innerHeight - t3.document.documentElement.clientHeight, o2 = t3.getComputedStyle(t3.document.documentElement).direction;
            else {
              const i2 = Ro(t3);
              e3 = t3.offsetWidth - t3.clientWidth - i2.left - i2.right, n2 = t3.offsetHeight - t3.clientHeight - i2.top - i2.bottom, o2 = t3.ownerDocument.defaultView.getComputedStyle(t3).direction, this.left += i2.left, this.top += i2.top, this.right -= i2.right, this.bottom -= i2.bottom, this.width = this.right - this.left, this.height = this.bottom - this.top;
            }
            return this.width -= e3, "ltr" === o2 ? this.right -= e3 : this.left += e3, this.height -= n2, this.bottom -= n2, this;
          }
          static getDomRangeRects(t3) {
            const e3 = [], n2 = Array.from(t3.getClientRects());
            if (n2.length)
              for (const t4 of n2)
                e3.push(new Vo(t4));
            else {
              let n3 = t3.startContainer;
              Oo(n3) && (n3 = n3.parentNode);
              const o2 = new Vo(n3.getBoundingClientRect());
              o2.right = o2.left, o2.width = 0, e3.push(o2);
            }
            return e3;
          }
          static getBoundingRect(t3) {
            const e3 = { left: Number.POSITIVE_INFINITY, top: Number.POSITIVE_INFINITY, right: Number.NEGATIVE_INFINITY, bottom: Number.NEGATIVE_INFINITY, width: 0, height: 0 };
            let n2 = 0;
            for (const o2 of t3)
              n2++, e3.left = Math.min(e3.left, o2.left), e3.top = Math.min(e3.top, o2.top), e3.right = Math.max(e3.right, o2.right), e3.bottom = Math.max(e3.bottom, o2.bottom);
            return 0 == n2 ? null : (e3.width = e3.right - e3.left, e3.height = e3.bottom - e3.top, new Vo(e3));
          }
        }
        function Uo(t3, e3) {
          for (const n2 of Fo)
            t3[n2] = e3[n2];
        }
        function Ho(t3) {
          return !!qo(t3) && t3 === t3.ownerDocument.body;
        }
        function qo(t3) {
          return null !== t3 && "object" == typeof t3 && 1 === t3.nodeType && "function" == typeof t3.getBoundingClientRect;
        }
        function Go(t3) {
          return t3 instanceof HTMLElement ? t3.ownerDocument.defaultView.getComputedStyle(t3).position : "static";
        }
        const Wo = class {
          constructor(t3, e3) {
            Wo._observerInstance || Wo._createObserver(), this._element = t3, this._callback = e3, Wo._addElementCallback(t3, e3), Wo._observerInstance.observe(t3);
          }
          get element() {
            return this._element;
          }
          destroy() {
            Wo._deleteElementCallback(this._element, this._callback);
          }
          static _addElementCallback(t3, e3) {
            Wo._elementCallbacks || (Wo._elementCallbacks = /* @__PURE__ */ new Map());
            let n2 = Wo._elementCallbacks.get(t3);
            n2 || (n2 = /* @__PURE__ */ new Set(), Wo._elementCallbacks.set(t3, n2)), n2.add(e3);
          }
          static _deleteElementCallback(t3, e3) {
            const n2 = Wo._getElementCallbacks(t3);
            n2 && (n2.delete(e3), n2.size || (Wo._elementCallbacks.delete(t3), Wo._observerInstance.unobserve(t3))), Wo._elementCallbacks && !Wo._elementCallbacks.size && (Wo._observerInstance = null, Wo._elementCallbacks = null);
          }
          static _getElementCallbacks(t3) {
            return Wo._elementCallbacks ? Wo._elementCallbacks.get(t3) : null;
          }
          static _createObserver() {
            Wo._observerInstance = new zo.window.ResizeObserver((t3) => {
              for (const e3 of t3) {
                const t4 = Wo._getElementCallbacks(e3.target);
                if (t4)
                  for (const n2 of t4)
                    n2(e3);
              }
            });
          }
        };
        let Ko = Wo;
        function Zo(t3, e3) {
          t3 instanceof HTMLTextAreaElement && (t3.value = e3), t3.innerHTML = e3;
        }
        function Yo(t3) {
          return (e3) => e3 + t3;
        }
        function $o(t3) {
          let e3 = 0;
          for (; t3.previousSibling; )
            t3 = t3.previousSibling, e3++;
          return e3;
        }
        function Qo(t3, e3, n2) {
          t3.insertBefore(n2, t3.childNodes[e3] || null);
        }
        function Jo(t3) {
          return t3 && t3.nodeType === Node.COMMENT_NODE;
        }
        function Xo(t3) {
          return !!(t3 && t3.getClientRects && t3.getClientRects().length);
        }
        Ko._observerInstance = null, Ko._elementCallbacks = null;
        var ti = Math.pow;
        function ei({ element: t3, target: e3, positions: n2, limiter: o2, fitInViewport: i2, viewportOffsetConfig: r2 }) {
          Vt(e3) && (e3 = e3()), Vt(o2) && (o2 = o2());
          const s3 = jo(t3), a2 = function(t4) {
            t4 = Object.assign({ top: 0, bottom: 0, left: 0, right: 0 }, t4);
            const e4 = new Vo(zo.window);
            return e4.top += t4.top, e4.height -= t4.top, e4.bottom -= t4.bottom, e4.height -= t4.bottom, e4;
          }(r2), c2 = new Vo(t3), l2 = ni(e3, a2);
          let d2;
          if (!l2 || !a2.getIntersection(l2))
            return null;
          const h2 = { targetRect: l2, elementRect: c2, positionedElementAncestor: s3, viewportRect: a2 };
          if (o2 || i2) {
            if (o2) {
              const t4 = ni(o2, a2);
              t4 && (h2.limiterRect = t4);
            }
            d2 = function(t4, e4) {
              const { elementRect: n3 } = e4, o3 = n3.getArea(), i3 = t4.map((t5) => new oi(t5, e4)).filter((t5) => !!t5.name);
              let r3 = 0, s4 = null;
              for (const t5 of i3) {
                const { limiterIntersectionArea: e5, viewportIntersectionArea: n4 } = t5;
                if (e5 === o3)
                  return t5;
                const i4 = ti(n4, 2) + ti(e5, 2);
                i4 > r3 && (r3 = i4, s4 = t5);
              }
              return s4;
            }(n2, h2);
          } else
            d2 = new oi(n2[0], h2);
          return d2;
        }
        function ni(t3, e3) {
          const n2 = new Vo(t3).getVisible();
          return n2 ? n2.getIntersection(e3) : null;
        }
        class oi {
          constructor(t3, e3) {
            const n2 = t3(e3.targetRect, e3.elementRect, e3.viewportRect, e3.limiterRect);
            if (!n2)
              return;
            const { left: o2, top: i2, name: r2, config: s3 } = n2;
            this.name = r2, this.config = s3, this._positioningFunctionCoordinates = { left: o2, top: i2 }, this._options = e3;
          }
          get left() {
            return this._absoluteRect.left;
          }
          get top() {
            return this._absoluteRect.top;
          }
          get limiterIntersectionArea() {
            const t3 = this._options.limiterRect;
            return t3 ? t3.getIntersectionArea(this._rect) : 0;
          }
          get viewportIntersectionArea() {
            return this._options.viewportRect.getIntersectionArea(this._rect);
          }
          get _rect() {
            return this._cachedRect || (this._cachedRect = this._options.elementRect.clone().moveTo(this._positioningFunctionCoordinates.left, this._positioningFunctionCoordinates.top)), this._cachedRect;
          }
          get _absoluteRect() {
            return this._cachedAbsoluteRect || (this._cachedAbsoluteRect = this._rect.toAbsoluteRect()), this._cachedAbsoluteRect;
          }
        }
        function ii(t3) {
          const e3 = t3.parentNode;
          e3 && e3.removeChild(t3);
        }
        function ri({ window: t3, rect: e3, alignToTop: n2, forceScroll: o2, viewportOffset: i2 }) {
          const r2 = e3.clone().moveBy(0, i2.bottom), s3 = e3.clone().moveBy(0, -i2.top), a2 = new Vo(t3).excludeScrollbarsAndBorders(), c2 = n2 && o2, l2 = [s3, r2].every((t4) => a2.contains(t4));
          let { scrollX: d2, scrollY: h2 } = t3;
          const u2 = d2, g2 = h2;
          c2 ? h2 -= a2.top - e3.top + i2.top : l2 || (ci(s3, a2) ? h2 -= a2.top - e3.top + i2.top : ai(r2, a2) && (h2 += n2 ? e3.top - a2.top - i2.top : e3.bottom - a2.bottom + i2.bottom)), l2 || (li(e3, a2) ? d2 -= a2.left - e3.left + i2.left : di(e3, a2) && (d2 += e3.right - a2.right + i2.right)), d2 == u2 && h2 === g2 || t3.scrollTo(d2, h2);
        }
        function si({ parent: t3, getRect: e3, alignToTop: n2, forceScroll: o2, ancestorOffset: i2 = 0, limiterElement: r2 }) {
          const s3 = hi(t3), a2 = n2 && o2;
          let c2, l2, d2;
          const h2 = r2 || s3.document.body;
          for (; t3 != h2; )
            l2 = e3(), c2 = new Vo(t3).excludeScrollbarsAndBorders(), d2 = c2.contains(l2), a2 ? t3.scrollTop -= c2.top - l2.top + i2 : d2 || (ci(l2, c2) ? t3.scrollTop -= c2.top - l2.top + i2 : ai(l2, c2) && (t3.scrollTop += n2 ? l2.top - c2.top - i2 : l2.bottom - c2.bottom + i2)), d2 || (li(l2, c2) ? t3.scrollLeft -= c2.left - l2.left + i2 : di(l2, c2) && (t3.scrollLeft += l2.right - c2.right + i2)), t3 = t3.parentNode;
        }
        function ai(t3, e3) {
          return t3.bottom > e3.bottom;
        }
        function ci(t3, e3) {
          return t3.top < e3.top;
        }
        function li(t3, e3) {
          return t3.left < e3.left;
        }
        function di(t3, e3) {
          return t3.right > e3.right;
        }
        function hi(t3) {
          return Lo(t3) ? t3.startContainer.ownerDocument.defaultView : t3.ownerDocument.defaultView;
        }
        function ui(t3) {
          if (Lo(t3)) {
            let e3 = t3.commonAncestorContainer;
            return Oo(e3) && (e3 = e3.parentNode), e3;
          }
          return t3.parentNode;
        }
        function gi(t3, e3) {
          const n2 = hi(t3), o2 = new Vo(t3);
          if (n2 === e3)
            return o2;
          {
            let t4 = n2;
            for (; t4 != e3; ) {
              const e4 = t4.frameElement, n3 = new Vo(e4).excludeScrollbarsAndBorders();
              o2.moveBy(n3.left, n3.top), t4 = t4.parent;
            }
          }
          return o2;
        }
        const pi3 = { ctrl: "\u2303", cmd: "\u2318", alt: "\u2325", shift: "\u21E7" }, mi = { ctrl: "Ctrl+", alt: "Alt+", shift: "Shift+" }, fi = function() {
          const t3 = { arrowleft: 37, arrowup: 38, arrowright: 39, arrowdown: 40, backspace: 8, delete: 46, enter: 13, space: 32, esc: 27, tab: 9, ctrl: 1114112, shift: 2228224, alt: 4456448, cmd: 8912896 };
          for (let e3 = 65; e3 <= 90; e3++) {
            t3[String.fromCharCode(e3).toLowerCase()] = e3;
          }
          for (let e3 = 48; e3 <= 57; e3++)
            t3[e3 - 48] = e3;
          for (let e3 = 112; e3 <= 123; e3++)
            t3["f" + (e3 - 111)] = e3;
          for (const e3 of "`-=[];',./\\")
            t3[e3] = e3.charCodeAt(0);
          return t3;
        }(), ki = Object.fromEntries(Object.entries(fi).map(([t3, e3]) => [e3, t3.charAt(0).toUpperCase() + t3.slice(1)]));
        function bi(t3) {
          let e3;
          if ("string" == typeof t3) {
            if (e3 = fi[t3.toLowerCase()], !e3)
              throw new A("keyboard-unknown-key", null, { key: t3 });
          } else
            e3 = t3.keyCode + (t3.altKey ? fi.alt : 0) + (t3.ctrlKey ? fi.ctrl : 0) + (t3.shiftKey ? fi.shift : 0) + (t3.metaKey ? fi.cmd : 0);
          return e3;
        }
        function wi(t3) {
          return "string" == typeof t3 && (t3 = function(t4) {
            return t4.split("+").map((t5) => t5.trim());
          }(t3)), t3.map((t4) => "string" == typeof t4 ? function(t5) {
            if (t5.endsWith("!"))
              return bi(t5.slice(0, -1));
            const e3 = bi(t5);
            return (a.isMac || a.isiOS) && e3 == fi.ctrl ? fi.cmd : e3;
          }(t4) : t4).reduce((t4, e3) => e3 + t4, 0);
        }
        function Ai(t3) {
          let e3 = wi(t3);
          return Object.entries(a.isMac || a.isiOS ? pi3 : mi).reduce((t4, [n2, o2]) => (0 != (e3 & fi[n2]) && (e3 &= ~fi[n2], t4 += o2), t4), "") + (e3 ? ki[e3] : "");
        }
        function Ci(t3, e3) {
          const n2 = "ltr" === e3;
          switch (t3) {
            case fi.arrowleft:
              return n2 ? "left" : "right";
            case fi.arrowright:
              return n2 ? "right" : "left";
            case fi.arrowup:
              return "up";
            case fi.arrowdown:
              return "down";
          }
        }
        function _i(t3) {
          return Array.isArray(t3) ? t3 : [t3];
        }
        function vi(t3, e3, n2 = 1) {
          if ("number" != typeof n2)
            throw new A("translation-service-quantity-not-a-number", null, { quantity: n2 });
          const o2 = Object.keys(zo.window.CKEDITOR_TRANSLATIONS).length;
          1 === o2 && (t3 = Object.keys(zo.window.CKEDITOR_TRANSLATIONS)[0]);
          const i2 = e3.id || e3.string;
          if (0 === o2 || !function(t4, e4) {
            return !!zo.window.CKEDITOR_TRANSLATIONS[t4] && !!zo.window.CKEDITOR_TRANSLATIONS[t4].dictionary[e4];
          }(t3, i2))
            return 1 !== n2 ? e3.plural : e3.string;
          const r2 = zo.window.CKEDITOR_TRANSLATIONS[t3].dictionary, s3 = zo.window.CKEDITOR_TRANSLATIONS[t3].getPluralForm || ((t4) => 1 === t4 ? 0 : 1), a2 = r2[i2];
          if ("string" == typeof a2)
            return a2;
          return a2[Number(s3(n2))];
        }
        zo.window.CKEDITOR_TRANSLATIONS || (zo.window.CKEDITOR_TRANSLATIONS = {});
        const yi = ["ar", "ara", "fa", "per", "fas", "he", "heb", "ku", "kur", "ug", "uig"];
        function xi(t3) {
          return yi.includes(t3) ? "rtl" : "ltr";
        }
        class Ei {
          constructor({ uiLanguage: t3 = "en", contentLanguage: e3 } = {}) {
            this.uiLanguage = t3, this.contentLanguage = e3 || this.uiLanguage, this.uiLanguageDirection = xi(this.uiLanguage), this.contentLanguageDirection = xi(this.contentLanguage), this.t = (t4, e4) => this._t(t4, e4);
          }
          get language() {
            return console.warn("locale-deprecated-language-property: The Locale#language property has been deprecated and will be removed in the near future. Please use #uiLanguage and #contentLanguage properties instead."), this.uiLanguage;
          }
          _t(t3, e3 = []) {
            e3 = _i(e3), "string" == typeof t3 && (t3 = { string: t3 });
            const n2 = !!t3.plural ? e3[0] : 1;
            return function(t4, e4) {
              return t4.replace(/%(\d+)/g, (t5, n3) => n3 < e4.length ? e4[n3] : t5);
            }(vi(this.uiLanguage, t3, n2), e3);
          }
        }
        class Di extends M() {
          constructor(t3 = {}, e3 = {}) {
            super();
            const n2 = et(t3);
            if (n2 || (e3 = t3), this._items = [], this._itemMap = /* @__PURE__ */ new Map(), this._idProperty = e3.idProperty || "id", this._bindToExternalToInternalMap = /* @__PURE__ */ new WeakMap(), this._bindToInternalToExternalMap = /* @__PURE__ */ new WeakMap(), this._skippedIndexesFromExternal = [], n2)
              for (const e4 of t3)
                this._items.push(e4), this._itemMap.set(this._getItemIdBeforeAdding(e4), e4);
          }
          get length() {
            return this._items.length;
          }
          get first() {
            return this._items[0] || null;
          }
          get last() {
            return this._items[this.length - 1] || null;
          }
          add(t3, e3) {
            return this.addMany([t3], e3);
          }
          addMany(t3, e3) {
            if (void 0 === e3)
              e3 = this._items.length;
            else if (e3 > this._items.length || e3 < 0)
              throw new A("collection-add-item-invalid-index", this);
            let n2 = 0;
            for (const o2 of t3) {
              const t4 = this._getItemIdBeforeAdding(o2), i2 = e3 + n2;
              this._items.splice(i2, 0, o2), this._itemMap.set(t4, o2), this.fire("add", o2, i2), n2++;
            }
            return this.fire("change", { added: t3, removed: [], index: e3 }), this;
          }
          get(t3) {
            let e3;
            if ("string" == typeof t3)
              e3 = this._itemMap.get(t3);
            else {
              if ("number" != typeof t3)
                throw new A("collection-get-invalid-arg", this);
              e3 = this._items[t3];
            }
            return e3 || null;
          }
          has(t3) {
            if ("string" == typeof t3)
              return this._itemMap.has(t3);
            {
              const e3 = t3[this._idProperty];
              return e3 && this._itemMap.has(e3);
            }
          }
          getIndex(t3) {
            let e3;
            return e3 = "string" == typeof t3 ? this._itemMap.get(t3) : t3, e3 ? this._items.indexOf(e3) : -1;
          }
          remove(t3) {
            const [e3, n2] = this._remove(t3);
            return this.fire("change", { added: [], removed: [e3], index: n2 }), e3;
          }
          map(t3, e3) {
            return this._items.map(t3, e3);
          }
          forEach(t3, e3) {
            this._items.forEach(t3, e3);
          }
          find(t3, e3) {
            return this._items.find(t3, e3);
          }
          filter(t3, e3) {
            return this._items.filter(t3, e3);
          }
          clear() {
            this._bindToCollection && (this.stopListening(this._bindToCollection), this._bindToCollection = null);
            const t3 = Array.from(this._items);
            for (; this.length; )
              this._remove(0);
            this.fire("change", { added: [], removed: t3, index: 0 });
          }
          bindTo(t3) {
            if (this._bindToCollection)
              throw new A("collection-bind-to-rebind", this);
            return this._bindToCollection = t3, { as: (t4) => {
              this._setUpBindToBinding((e3) => new t4(e3));
            }, using: (t4) => {
              "function" == typeof t4 ? this._setUpBindToBinding(t4) : this._setUpBindToBinding((e3) => e3[t4]);
            } };
          }
          _setUpBindToBinding(t3) {
            const e3 = this._bindToCollection, n2 = (n3, o2, i2) => {
              const r2 = e3._bindToCollection == this, s3 = e3._bindToInternalToExternalMap.get(o2);
              if (r2 && s3)
                this._bindToExternalToInternalMap.set(o2, s3), this._bindToInternalToExternalMap.set(s3, o2);
              else {
                const n4 = t3(o2);
                if (!n4)
                  return void this._skippedIndexesFromExternal.push(i2);
                let r3 = i2;
                for (const t4 of this._skippedIndexesFromExternal)
                  i2 > t4 && r3--;
                for (const t4 of e3._skippedIndexesFromExternal)
                  r3 >= t4 && r3++;
                this._bindToExternalToInternalMap.set(o2, n4), this._bindToInternalToExternalMap.set(n4, o2), this.add(n4, r3);
                for (let t4 = 0; t4 < e3._skippedIndexesFromExternal.length; t4++)
                  r3 <= e3._skippedIndexesFromExternal[t4] && e3._skippedIndexesFromExternal[t4]++;
              }
            };
            for (const t4 of e3)
              n2(0, t4, e3.getIndex(t4));
            this.listenTo(e3, "add", n2), this.listenTo(e3, "remove", (t4, e4, n3) => {
              const o2 = this._bindToExternalToInternalMap.get(e4);
              o2 && this.remove(o2), this._skippedIndexesFromExternal = this._skippedIndexesFromExternal.reduce((t5, e5) => (n3 < e5 && t5.push(e5 - 1), n3 > e5 && t5.push(e5), t5), []);
            });
          }
          _getItemIdBeforeAdding(t3) {
            const e3 = this._idProperty;
            let n2;
            if (e3 in t3) {
              if (n2 = t3[e3], "string" != typeof n2)
                throw new A("collection-add-invalid-id", this);
              if (this.get(n2))
                throw new A("collection-add-item-already-exists", this);
            } else
              t3[e3] = n2 = f();
            return n2;
          }
          _remove(t3) {
            let e3, n2, o2, i2 = false;
            const r2 = this._idProperty;
            if ("string" == typeof t3 ? (n2 = t3, o2 = this._itemMap.get(n2), i2 = !o2, o2 && (e3 = this._items.indexOf(o2))) : "number" == typeof t3 ? (e3 = t3, o2 = this._items[e3], i2 = !o2, o2 && (n2 = o2[r2])) : (o2 = t3, n2 = o2[r2], e3 = this._items.indexOf(o2), i2 = -1 == e3 || !this._itemMap.get(n2)), i2)
              throw new A("collection-remove-404", this);
            this._items.splice(e3, 1), this._itemMap.delete(n2);
            const s3 = this._bindToInternalToExternalMap.get(o2);
            return this._bindToInternalToExternalMap.delete(o2), this._bindToExternalToInternalMap.delete(s3), this.fire("remove", o2, e3), [o2, e3];
          }
          [Symbol.iterator]() {
            return this._items[Symbol.iterator]();
          }
        }
        function Ii(t3) {
          const e3 = t3.next();
          return e3.done ? null : e3.value;
        }
        class Si extends Mo(W()) {
          constructor() {
            super(), this._elements = /* @__PURE__ */ new Set(), this._nextEventLoopTimeout = null, this.set("isFocused", false), this.set("focusedElement", null);
          }
          add(t3) {
            if (this._elements.has(t3))
              throw new A("focustracker-add-element-already-exist", this);
            this.listenTo(t3, "focus", () => this._focus(t3), { useCapture: true }), this.listenTo(t3, "blur", () => this._blur(), { useCapture: true }), this._elements.add(t3);
          }
          remove(t3) {
            t3 === this.focusedElement && this._blur(), this._elements.has(t3) && (this.stopListening(t3), this._elements.delete(t3));
          }
          destroy() {
            this.stopListening();
          }
          _focus(t3) {
            clearTimeout(this._nextEventLoopTimeout), this.focusedElement = t3, this.isFocused = true;
          }
          _blur() {
            clearTimeout(this._nextEventLoopTimeout), this._nextEventLoopTimeout = setTimeout(() => {
              this.focusedElement = null, this.isFocused = false;
            }, 0);
          }
        }
        class Ti {
          constructor() {
            this._listener = new (Mo())();
          }
          listenTo(t3) {
            this._listener.listenTo(t3, "keydown", (t4, e3) => {
              this._listener.fire("_keydown:" + bi(e3), e3);
            });
          }
          set(t3, e3, n2 = {}) {
            const o2 = wi(t3), i2 = n2.priority;
            this._listener.listenTo(this._listener, "_keydown:" + o2, (t4, n3) => {
              e3(n3, () => {
                n3.preventDefault(), n3.stopPropagation(), t4.stop();
              }), t4.return = true;
            }, { priority: i2 });
          }
          press(t3) {
            return !!this._listener.fire("_keydown:" + bi(t3), t3);
          }
          stopListening(t3) {
            this._listener.stopListening(t3);
          }
          destroy() {
            this.stopListening();
          }
        }
        function Mi(t3) {
          return et(t3) ? new Map(t3) : function(t4) {
            const e3 = /* @__PURE__ */ new Map();
            for (const n2 in t4)
              e3.set(n2, t4[n2]);
            return e3;
          }(t3);
        }
        Math.pow;
        function Bi(t3, e3) {
          let n2;
          function o2(...i2) {
            o2.cancel(), n2 = setTimeout(() => t3(...i2), e3);
          }
          return o2.cancel = () => {
            clearTimeout(n2);
          }, o2;
        }
        function Ni(t3, e3) {
          return !!(n2 = t3.charAt(e3 - 1)) && 1 == n2.length && /[\ud800-\udbff]/.test(n2) && function(t4) {
            return !!t4 && 1 == t4.length && /[\udc00-\udfff]/.test(t4);
          }(t3.charAt(e3));
          var n2;
        }
        function Pi(t3, e3) {
          return !!(n2 = t3.charAt(e3)) && 1 == n2.length && /[\u0300-\u036f\u1ab0-\u1aff\u1dc0-\u1dff\u20d0-\u20ff\ufe20-\ufe2f]/.test(n2);
          var n2;
        }
        const zi = function() {
          const t3 = [new RegExp("\\p{Emoji}[\\u{E0020}-\\u{E007E}]+\\u{E007F}", "u"), new RegExp("\\p{Emoji}\\u{FE0F}?\\u{20E3}", "u"), new RegExp("\\p{Emoji}\\u{FE0F}", "u"), new RegExp("(?=\\p{General_Category=Other_Symbol})\\p{Emoji}\\p{Emoji_Modifier}*", "u")], e3 = new RegExp("\\p{Regional_Indicator}{2}", "u").source, n2 = "(?:" + t3.map((t4) => t4.source).join("|") + ")";
          return new RegExp(`${e3}|${n2}(?:\u200D${n2})*`, "ug");
        }();
        function Oi(t3, e3) {
          const n2 = String(t3).matchAll(zi);
          return Array.from(n2).some((t4) => t4.index < e3 && e3 < t4.index + t4[0].length);
        }
        class Li extends Di {
          constructor(t3 = []) {
            super(t3, { idProperty: "viewUid" }), this.on("add", (t4, e3, n2) => {
              this._renderViewIntoCollectionParent(e3, n2);
            }), this.on("remove", (t4, e3) => {
              e3.element && this._parentElement && e3.element.remove();
            }), this._parentElement = null;
          }
          destroy() {
            this.map((t3) => t3.destroy());
          }
          setParent(t3) {
            this._parentElement = t3;
            for (const t4 of this)
              this._renderViewIntoCollectionParent(t4);
          }
          delegate(...t3) {
            if (!t3.length || !t3.every((t4) => "string" == typeof t4))
              throw new A("ui-viewcollection-delegate-wrong-events", this);
            return { to: (e3) => {
              for (const n2 of this)
                for (const o2 of t3)
                  n2.delegate(o2).to(e3);
              this.on("add", (n2, o2) => {
                for (const n3 of t3)
                  o2.delegate(n3).to(e3);
              }), this.on("remove", (n2, o2) => {
                for (const n3 of t3)
                  o2.stopDelegating(n3, e3);
              });
            } };
          }
          _renderViewIntoCollectionParent(t3, e3) {
            t3.isRendered || t3.render(), t3.element && this._parentElement && this._parentElement.insertBefore(t3.element, this._parentElement.children[e3]);
          }
          remove(t3) {
            return super.remove(t3);
          }
        }
        var Ri = n(6062), ji = n.n(Ri), Fi = n(4793), Vi = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Fi.Z, Vi);
        Fi.Z.locals;
        class Ui extends Mo(W()) {
          constructor(t3) {
            super(), this.element = null, this.isRendered = false, this.locale = t3, this.t = t3 && t3.t, this._viewCollections = new Di(), this._unboundChildren = this.createCollection(), this._viewCollections.on("add", (e3, n2) => {
              n2.locale = t3, n2.t = t3 && t3.t;
            }), this.decorate("render");
          }
          get bindTemplate() {
            return this._bindTemplate ? this._bindTemplate : this._bindTemplate = Hi.bind(this, this);
          }
          createCollection(t3) {
            const e3 = new Li(t3);
            return this._viewCollections.add(e3), e3;
          }
          registerChild(t3) {
            et(t3) || (t3 = [t3]);
            for (const e3 of t3)
              this._unboundChildren.add(e3);
          }
          deregisterChild(t3) {
            et(t3) || (t3 = [t3]);
            for (const e3 of t3)
              this._unboundChildren.remove(e3);
          }
          setTemplate(t3) {
            this.template = new Hi(t3);
          }
          extendTemplate(t3) {
            Hi.extend(this.template, t3);
          }
          render() {
            if (this.isRendered)
              throw new A("ui-view-render-already-rendered", this);
            this.template && (this.element = this.template.render(), this.registerChild(this.template.getViews())), this.isRendered = true;
          }
          destroy() {
            this.stopListening(), this._viewCollections.map((t3) => t3.destroy()), this.template && this.template._revertData && this.template.revert(this.element);
          }
        }
        class Hi extends M() {
          constructor(t3) {
            super(), Object.assign(this, Xi(Ji(t3))), this._isRendered = false, this._revertData = null;
          }
          render() {
            const t3 = this._renderNode({ intoFragment: true });
            return this._isRendered = true, t3;
          }
          apply(t3) {
            return this._revertData = { children: [], bindings: [], attributes: {} }, this._renderNode({ node: t3, intoFragment: false, isApplying: true, revertData: this._revertData }), t3;
          }
          revert(t3) {
            if (!this._revertData)
              throw new A("ui-template-revert-not-applied", [this, t3]);
            this._revertTemplateFromNode(t3, this._revertData);
          }
          *getViews() {
            yield* __yieldStar(function* t3(e3) {
              if (e3.children)
                for (const n2 of e3.children)
                  rr(n2) ? yield n2 : sr(n2) && (yield* __yieldStar(t3(n2)));
            }(this));
          }
          static bind(t3, e3) {
            return { to: (n2, o2) => new Gi({ eventNameOrFunction: n2, attribute: n2, observable: t3, emitter: e3, callback: o2 }), if: (n2, o2, i2) => new Wi({ observable: t3, emitter: e3, attribute: n2, valueIfTrue: o2, callback: i2 }) };
          }
          static extend(t3, e3) {
            if (t3._isRendered)
              throw new A("template-extend-render", [this, t3]);
            or(t3, Xi(Ji(e3)));
          }
          _renderNode(t3) {
            let e3;
            if (e3 = t3.node ? this.tag && this.text : this.tag ? this.text : !this.text, e3)
              throw new A("ui-template-wrong-syntax", this);
            return this.text ? this._renderText(t3) : this._renderElement(t3);
          }
          _renderElement(t3) {
            let e3 = t3.node;
            return e3 || (e3 = t3.node = document.createElementNS(this.ns || "http://www.w3.org/1999/xhtml", this.tag)), this._renderAttributes(t3), this._renderElementChildren(t3), this._setUpListeners(t3), e3;
          }
          _renderText(t3) {
            let e3 = t3.node;
            return e3 ? t3.revertData.text = e3.textContent : e3 = t3.node = document.createTextNode(""), Ki(this.text) ? this._bindToObservable({ schema: this.text, updater: Yi(e3), data: t3 }) : e3.textContent = this.text.join(""), e3;
          }
          _renderAttributes(t3) {
            if (!this.attributes)
              return;
            const e3 = t3.node, n2 = t3.revertData;
            for (const o2 in this.attributes) {
              const i2 = e3.getAttribute(o2), r2 = this.attributes[o2];
              n2 && (n2.attributes[o2] = i2);
              const s3 = cr(r2) ? r2[0].ns : null;
              if (Ki(r2)) {
                const a2 = cr(r2) ? r2[0].value : r2;
                n2 && lr(o2) && a2.unshift(i2), this._bindToObservable({ schema: a2, updater: $i(e3, o2, s3), data: t3 });
              } else if ("style" == o2 && "string" != typeof r2[0])
                this._renderStyleAttribute(r2[0], t3);
              else {
                n2 && i2 && lr(o2) && r2.unshift(i2);
                const t4 = r2.map((t5) => t5 && t5.value || t5).reduce((t5, e4) => t5.concat(e4), []).reduce(er, "");
                ir(t4) || e3.setAttributeNS(s3, o2, t4);
              }
            }
          }
          _renderStyleAttribute(t3, e3) {
            const n2 = e3.node;
            for (const o2 in t3) {
              const i2 = t3[o2];
              Ki(i2) ? this._bindToObservable({ schema: [i2], updater: Qi(n2, o2), data: e3 }) : n2.style[o2] = i2;
            }
          }
          _renderElementChildren(t3) {
            const e3 = t3.node, n2 = t3.intoFragment ? document.createDocumentFragment() : e3, o2 = t3.isApplying;
            let i2 = 0;
            for (const r2 of this.children)
              if (ar(r2)) {
                if (!o2) {
                  r2.setParent(e3);
                  for (const t4 of r2)
                    n2.appendChild(t4.element);
                }
              } else if (rr(r2))
                o2 || (r2.isRendered || r2.render(), n2.appendChild(r2.element));
              else if (Io(r2))
                n2.appendChild(r2);
              else if (o2) {
                const e4 = { children: [], bindings: [], attributes: {} };
                t3.revertData.children.push(e4), r2._renderNode({ intoFragment: false, node: n2.childNodes[i2++], isApplying: true, revertData: e4 });
              } else
                n2.appendChild(r2.render());
            t3.intoFragment && e3.appendChild(n2);
          }
          _setUpListeners(t3) {
            if (this.eventListeners)
              for (const e3 in this.eventListeners) {
                const n2 = this.eventListeners[e3].map((n3) => {
                  const [o2, i2] = e3.split("@");
                  return n3.activateDomEventListener(o2, i2, t3);
                });
                t3.revertData && t3.revertData.bindings.push(n2);
              }
          }
          _bindToObservable({ schema: t3, updater: e3, data: n2 }) {
            const o2 = n2.revertData;
            Zi(t3, e3, n2);
            const i2 = t3.filter((t4) => !ir(t4)).filter((t4) => t4.observable).map((o3) => o3.activateAttributeListener(t3, e3, n2));
            o2 && o2.bindings.push(i2);
          }
          _revertTemplateFromNode(t3, e3) {
            for (const t4 of e3.bindings)
              for (const e4 of t4)
                e4();
            if (e3.text)
              return void (t3.textContent = e3.text);
            const n2 = t3;
            for (const t4 in e3.attributes) {
              const o2 = e3.attributes[t4];
              null === o2 ? n2.removeAttribute(t4) : n2.setAttribute(t4, o2);
            }
            for (let t4 = 0; t4 < e3.children.length; ++t4)
              this._revertTemplateFromNode(n2.childNodes[t4], e3.children[t4]);
          }
        }
        class qi {
          constructor(t3) {
            this.attribute = t3.attribute, this.observable = t3.observable, this.emitter = t3.emitter, this.callback = t3.callback;
          }
          getValue(t3) {
            const e3 = this.observable[this.attribute];
            return this.callback ? this.callback(e3, t3) : e3;
          }
          activateAttributeListener(t3, e3, n2) {
            const o2 = () => Zi(t3, e3, n2);
            return this.emitter.listenTo(this.observable, `change:${this.attribute}`, o2), () => {
              this.emitter.stopListening(this.observable, `change:${this.attribute}`, o2);
            };
          }
        }
        class Gi extends qi {
          constructor(t3) {
            super(t3), this.eventNameOrFunction = t3.eventNameOrFunction;
          }
          activateDomEventListener(t3, e3, n2) {
            const o2 = (t4, n3) => {
              e3 && !n3.target.matches(e3) || ("function" == typeof this.eventNameOrFunction ? this.eventNameOrFunction(n3) : this.observable.fire(this.eventNameOrFunction, n3));
            };
            return this.emitter.listenTo(n2.node, t3, o2), () => {
              this.emitter.stopListening(n2.node, t3, o2);
            };
          }
        }
        class Wi extends qi {
          constructor(t3) {
            super(t3), this.valueIfTrue = t3.valueIfTrue;
          }
          getValue(t3) {
            return !ir(super.getValue(t3)) && (this.valueIfTrue || true);
          }
        }
        function Ki(t3) {
          return !!t3 && (t3.value && (t3 = t3.value), Array.isArray(t3) ? t3.some(Ki) : t3 instanceof qi);
        }
        function Zi(t3, e3, { node: n2 }) {
          const o2 = function(t4, e4) {
            return t4.map((t5) => t5 instanceof qi ? t5.getValue(e4) : t5);
          }(t3, n2);
          let i2;
          i2 = 1 == t3.length && t3[0] instanceof Wi ? o2[0] : o2.reduce(er, ""), ir(i2) ? e3.remove() : e3.set(i2);
        }
        function Yi(t3) {
          return { set(e3) {
            t3.textContent = e3;
          }, remove() {
            t3.textContent = "";
          } };
        }
        function $i(t3, e3, n2) {
          return { set(o2) {
            t3.setAttributeNS(n2, e3, o2);
          }, remove() {
            t3.removeAttributeNS(n2, e3);
          } };
        }
        function Qi(t3, e3) {
          return { set(n2) {
            t3.style[e3] = n2;
          }, remove() {
            t3.style[e3] = null;
          } };
        }
        function Ji(t3) {
          return vo(t3, (t4) => {
            if (t4 && (t4 instanceof qi || sr(t4) || rr(t4) || ar(t4)))
              return t4;
          });
        }
        function Xi(t3) {
          if ("string" == typeof t3 ? t3 = function(t4) {
            return { text: [t4] };
          }(t3) : t3.text && function(t4) {
            t4.text = _i(t4.text);
          }(t3), t3.on && (t3.eventListeners = function(t4) {
            for (const e3 in t4)
              tr(t4, e3);
            return t4;
          }(t3.on), delete t3.on), !t3.text) {
            t3.attributes && function(t4) {
              for (const e4 in t4)
                t4[e4].value && (t4[e4].value = _i(t4[e4].value)), tr(t4, e4);
            }(t3.attributes);
            const e3 = [];
            if (t3.children)
              if (ar(t3.children))
                e3.push(t3.children);
              else
                for (const n2 of t3.children)
                  sr(n2) || rr(n2) || Io(n2) ? e3.push(n2) : e3.push(new Hi(n2));
            t3.children = e3;
          }
          return t3;
        }
        function tr(t3, e3) {
          t3[e3] = _i(t3[e3]);
        }
        function er(t3, e3) {
          return ir(e3) ? t3 : ir(t3) ? e3 : `${t3} ${e3}`;
        }
        function nr(t3, e3) {
          for (const n2 in e3)
            t3[n2] ? t3[n2].push(...e3[n2]) : t3[n2] = e3[n2];
        }
        function or(t3, e3) {
          if (e3.attributes && (t3.attributes || (t3.attributes = {}), nr(t3.attributes, e3.attributes)), e3.eventListeners && (t3.eventListeners || (t3.eventListeners = {}), nr(t3.eventListeners, e3.eventListeners)), e3.text && t3.text.push(...e3.text), e3.children && e3.children.length) {
            if (t3.children.length != e3.children.length)
              throw new A("ui-template-extend-children-mismatch", t3);
            let n2 = 0;
            for (const o2 of e3.children)
              or(t3.children[n2++], o2);
          }
        }
        function ir(t3) {
          return !t3 && 0 !== t3;
        }
        function rr(t3) {
          return t3 instanceof Ui;
        }
        function sr(t3) {
          return t3 instanceof Hi;
        }
        function ar(t3) {
          return t3 instanceof Li;
        }
        function cr(t3) {
          return j(t3[0]) && t3[0].ns;
        }
        function lr(t3) {
          return "class" == t3 || "style" == t3;
        }
        class dr extends Li {
          constructor(t3, e3 = []) {
            super(e3), this.locale = t3;
          }
          get bodyCollectionContainer() {
            return this._bodyCollectionContainer;
          }
          attachToDom() {
            this._bodyCollectionContainer = new Hi({ tag: "div", attributes: { class: ["ck", "ck-reset_all", "ck-body", "ck-rounded-corners"], dir: this.locale.uiLanguageDirection }, children: this }).render();
            let t3 = document.querySelector(".ck-body-wrapper");
            t3 || (t3 = bt(document, "div", { class: "ck-body-wrapper" }), document.body.appendChild(t3)), t3.appendChild(this._bodyCollectionContainer);
          }
          detachFromDom() {
            super.destroy(), this._bodyCollectionContainer && this._bodyCollectionContainer.remove();
            const t3 = document.querySelector(".ck-body-wrapper");
            t3 && 0 == t3.childElementCount && t3.remove();
          }
        }
        var hr = n(6574), ur = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(hr.Z, ur);
        hr.Z.locals;
        const gr = class extends Ui {
          constructor() {
            super();
            const t3 = this.bindTemplate;
            this.set("content", ""), this.set("viewBox", "0 0 20 20"), this.set("fillColor", ""), this.set("isColorInherited", true), this.set("isVisible", true), this.setTemplate({ tag: "svg", ns: "http://www.w3.org/2000/svg", attributes: { class: ["ck", "ck-icon", t3.if("isVisible", "ck-hidden", (t4) => !t4), "ck-reset_all-excluded", t3.if("isColorInherited", "ck-icon_inherit-color")], viewBox: t3.to("viewBox") } });
          }
          render() {
            super.render(), this._updateXMLContent(), this._colorFillPaths(), this.on("change:content", () => {
              this._updateXMLContent(), this._colorFillPaths();
            }), this.on("change:fillColor", () => {
              this._colorFillPaths();
            });
          }
          _updateXMLContent() {
            if (this.content) {
              const t3 = new DOMParser().parseFromString(this.content.trim(), "image/svg+xml").querySelector("svg"), e3 = t3.getAttribute("viewBox");
              e3 && (this.viewBox = e3);
              for (const { name: e4, value: n2 } of Array.from(t3.attributes))
                gr.presentationalAttributeNames.includes(e4) && this.element.setAttribute(e4, n2);
              for (; this.element.firstChild; )
                this.element.removeChild(this.element.firstChild);
              for (; t3.childNodes.length > 0; )
                this.element.appendChild(t3.childNodes[0]);
            }
          }
          _colorFillPaths() {
            this.fillColor && this.element.querySelectorAll(".ck-icon__fill").forEach((t3) => {
              t3.style.fill = this.fillColor;
            });
          }
        };
        let pr = gr;
        pr.presentationalAttributeNames = ["alignment-baseline", "baseline-shift", "clip-path", "clip-rule", "color", "color-interpolation", "color-interpolation-filters", "color-rendering", "cursor", "direction", "display", "dominant-baseline", "fill", "fill-opacity", "fill-rule", "filter", "flood-color", "flood-opacity", "font-family", "font-size", "font-size-adjust", "font-stretch", "font-style", "font-variant", "font-weight", "image-rendering", "letter-spacing", "lighting-color", "marker-end", "marker-mid", "marker-start", "mask", "opacity", "overflow", "paint-order", "pointer-events", "shape-rendering", "stop-color", "stop-opacity", "stroke", "stroke-dasharray", "stroke-dashoffset", "stroke-linecap", "stroke-linejoin", "stroke-miterlimit", "stroke-opacity", "stroke-width", "text-anchor", "text-decoration", "text-overflow", "text-rendering", "transform", "unicode-bidi", "vector-effect", "visibility", "white-space", "word-spacing", "writing-mode"];
        class mr extends Ui {
          constructor() {
            super(), this.set({ style: void 0, text: void 0, id: void 0 });
            const t3 = this.bindTemplate;
            this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__label"], style: t3.to("style"), id: t3.to("id") }, children: [{ text: t3.to("text") }] });
          }
        }
        var fr = n(4906), kr = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(fr.Z, kr);
        fr.Z.locals;
        class br extends Ui {
          constructor(t3, e3 = new mr()) {
            super(t3), this._focusDelayed = null;
            const n2 = this.bindTemplate, o2 = f();
            this.set("ariaLabel", void 0), this.set("ariaLabelledBy", `ck-editor__aria-label_${o2}`), this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", true), this.set("isOn", false), this.set("isVisible", true), this.set("isToggleable", false), this.set("keystroke", void 0), this.set("label", void 0), this.set("role", void 0), this.set("tabindex", -1), this.set("tooltip", false), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", false), this.set("withKeystroke", false), this.children = this.createCollection(), this.labelView = this._setupLabelView(e3), this.iconView = new pr(), this.iconView.extendTemplate({ attributes: { class: "ck-button__icon" } }), this.keystrokeView = this._createKeystrokeView(), this.bind("_tooltipString").to(this, "tooltip", this, "label", this, "keystroke", this._getTooltipString.bind(this));
            const i2 = { tag: "button", attributes: { class: ["ck", "ck-button", n2.to("class"), n2.if("isEnabled", "ck-disabled", (t4) => !t4), n2.if("isVisible", "ck-hidden", (t4) => !t4), n2.to("isOn", (t4) => t4 ? "ck-on" : "ck-off"), n2.if("withText", "ck-button_with-text"), n2.if("withKeystroke", "ck-button_with-keystroke")], role: n2.to("role"), type: n2.to("type", (t4) => t4 || "button"), tabindex: n2.to("tabindex"), "aria-label": n2.to("ariaLabel"), "aria-labelledby": n2.to("ariaLabelledBy"), "aria-disabled": n2.if("isEnabled", true, (t4) => !t4), "aria-pressed": n2.to("isOn", (t4) => !!this.isToggleable && String(!!t4)), "data-cke-tooltip-text": n2.to("_tooltipString"), "data-cke-tooltip-position": n2.to("tooltipPosition") }, children: this.children, on: { click: n2.to((t4) => {
              this.isEnabled ? this.fire("execute") : t4.preventDefault();
            }) } };
            a.isSafari && (this._focusDelayed || (this._focusDelayed = Bi(() => this.focus(), 0)), i2.on.mousedown = n2.to(() => {
              this._focusDelayed();
            }), i2.on.mouseup = n2.to(() => {
              this._focusDelayed.cancel();
            })), this.setTemplate(i2);
          }
          render() {
            super.render(), this.icon && (this.iconView.bind("content").to(this, "icon"), this.children.add(this.iconView)), this.children.add(this.labelView), this.withKeystroke && this.keystroke && this.children.add(this.keystrokeView);
          }
          focus() {
            this.element.focus();
          }
          destroy() {
            this._focusDelayed && this._focusDelayed.cancel(), super.destroy();
          }
          _setupLabelView(t3) {
            return t3.bind("text", "style", "id").to(this, "label", "labelStyle", "ariaLabelledBy"), t3;
          }
          _createKeystrokeView() {
            const t3 = new Ui();
            return t3.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__keystroke"] }, children: [{ text: this.bindTemplate.to("keystroke", (t4) => Ai(t4)) }] }), t3;
          }
          _getTooltipString(t3, e3, n2) {
            return t3 ? "string" == typeof t3 ? t3 : (n2 && (n2 = Ai(n2)), t3 instanceof Function ? t3(e3, n2) : `${e3}${n2 ? ` (${n2})` : ""}`) : "";
          }
        }
        var wr = n(5332), Ar = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(wr.Z, Ar);
        wr.Z.locals;
        class Cr extends br {
          constructor(t3) {
            super(t3), this.isToggleable = true, this.toggleSwitchView = this._createToggleView(), this.extendTemplate({ attributes: { class: "ck-switchbutton" } });
          }
          render() {
            super.render(), this.children.add(this.toggleSwitchView);
          }
          _createToggleView() {
            const t3 = new Ui();
            return t3.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-button__toggle"] }, children: [{ tag: "span", attributes: { class: ["ck", "ck-button__toggle__inner"] } }] }), t3;
          }
        }
        var _r = n(6781), vr = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(_r.Z, vr);
        _r.Z.locals;
        n(1103);
        n(841);
        var yr = n(3662), xr = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(yr.Z, xr);
        yr.Z.locals;
        class Er extends Ui {
          constructor(t3) {
            super(t3), this.set("text", void 0), this.set("for", void 0), this.id = `ck-editor__label_${f()}`;
            const e3 = this.bindTemplate;
            this.setTemplate({ tag: "label", attributes: { class: ["ck", "ck-label"], id: this.id, for: e3.to("for") }, children: [{ text: e3.to("text") }] });
          }
        }
        var Dr = n(2577), Ir = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Dr.Z, Ir);
        Dr.Z.locals;
        class Sr extends Ui {
          constructor(t3, e3) {
            super(t3);
            const n2 = `ck-labeled-field-view-${f()}`, o2 = `ck-labeled-field-view-status-${f()}`;
            this.fieldView = e3(this, n2, o2), this.set("label", void 0), this.set("isEnabled", true), this.set("isEmpty", true), this.set("isFocused", false), this.set("errorText", null), this.set("infoText", null), this.set("class", void 0), this.set("placeholder", void 0), this.labelView = this._createLabelView(n2), this.statusView = this._createStatusView(o2), this.fieldWrapperChildren = this.createCollection([this.fieldView, this.labelView]), this.bind("_statusText").to(this, "errorText", this, "infoText", (t4, e4) => t4 || e4);
            const i2 = this.bindTemplate;
            this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-labeled-field-view", i2.to("class"), i2.if("isEnabled", "ck-disabled", (t4) => !t4), i2.if("isEmpty", "ck-labeled-field-view_empty"), i2.if("isFocused", "ck-labeled-field-view_focused"), i2.if("placeholder", "ck-labeled-field-view_placeholder"), i2.if("errorText", "ck-error")] }, children: [{ tag: "div", attributes: { class: ["ck", "ck-labeled-field-view__input-wrapper"] }, children: this.fieldWrapperChildren }, this.statusView] });
          }
          _createLabelView(t3) {
            const e3 = new Er(this.locale);
            return e3.for = t3, e3.bind("text").to(this, "label"), e3;
          }
          _createStatusView(t3) {
            const e3 = new Ui(this.locale), n2 = this.bindTemplate;
            return e3.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-labeled-field-view__status", n2.if("errorText", "ck-labeled-field-view__status_error"), n2.if("_statusText", "ck-hidden", (t4) => !t4)], id: t3, role: n2.if("errorText", "alert") }, children: [{ text: n2.to("_statusText") }] }), e3;
          }
          focus(t3) {
            this.fieldView.focus(t3);
          }
        }
        class Tr extends Ui {
          constructor(t3) {
            super(t3), this.set("value", void 0), this.set("id", void 0), this.set("placeholder", void 0), this.set("isReadOnly", false), this.set("hasError", false), this.set("ariaDescribedById", void 0), this.focusTracker = new Si(), this.bind("isFocused").to(this.focusTracker), this.set("isEmpty", true);
            const e3 = this.bindTemplate;
            this.setTemplate({ tag: "input", attributes: { class: ["ck", "ck-input", e3.if("isFocused", "ck-input_focused"), e3.if("isEmpty", "ck-input-text_empty"), e3.if("hasError", "ck-error")], id: e3.to("id"), placeholder: e3.to("placeholder"), readonly: e3.to("isReadOnly"), "aria-invalid": e3.if("hasError", true), "aria-describedby": e3.to("ariaDescribedById") }, on: { input: e3.to((...t4) => {
              this.fire("input", ...t4), this._updateIsEmpty();
            }), change: e3.to(this._updateIsEmpty.bind(this)) } });
          }
          render() {
            super.render(), this.focusTracker.add(this.element), this._setDomElementValue(this.value), this._updateIsEmpty(), this.on("change:value", (t3, e3, n2) => {
              this._setDomElementValue(n2), this._updateIsEmpty();
            });
          }
          destroy() {
            super.destroy(), this.focusTracker.destroy();
          }
          select() {
            this.element.select();
          }
          focus() {
            this.element.focus();
          }
          reset() {
            this.value = this.element.value = "", this._updateIsEmpty();
          }
          _updateIsEmpty() {
            this.isEmpty = !this.element.value;
          }
          _setDomElementValue(t3) {
            this.element.value = t3 || 0 === t3 ? t3 : "";
          }
        }
        var Mr = n(4879), Br = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Mr.Z, Br);
        Mr.Z.locals;
        class Nr extends Tr {
          constructor(t3) {
            super(t3), this.set("inputMode", "text");
            const e3 = this.bindTemplate;
            this.extendTemplate({ attributes: { inputmode: e3.to("inputMode") } });
          }
        }
        class Pr extends Nr {
          constructor(t3) {
            super(t3), this.extendTemplate({ attributes: { type: "text", class: ["ck-input-text"] } });
          }
        }
        var zr = n(8182), Or = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(zr.Z, Or);
        zr.Z.locals;
        class Lr extends Ui {
          constructor(t3) {
            super(t3);
            const e3 = this.bindTemplate;
            this.set("isVisible", false), this.set("position", "se"), this.children = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-reset", "ck-dropdown__panel", e3.to("position", (t4) => `ck-dropdown__panel_${t4}`), e3.if("isVisible", "ck-dropdown__panel-visible")], tabindex: "-1" }, children: this.children, on: { selectstart: e3.to((t4) => {
              "input" !== t4.target.tagName.toLocaleLowerCase() && t4.preventDefault();
            }) } });
          }
          focus() {
            if (this.children.length) {
              const t3 = this.children.first;
              "function" == typeof t3.focus ? t3.focus() : C("ui-dropdown-panel-focus-child-missing-focus", { childView: this.children.first, dropdownPanel: this });
            }
          }
          focusLast() {
            if (this.children.length) {
              const t3 = this.children.last;
              "function" == typeof t3.focusLast ? t3.focusLast() : t3.focus();
            }
          }
        }
        var Rr = n(5485), jr = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Rr.Z, jr);
        Rr.Z.locals;
        const Fr = class extends Ui {
          constructor(t3, e3, n2) {
            super(t3);
            const o2 = this.bindTemplate;
            this.buttonView = e3, this.panelView = n2, this.set("isOpen", false), this.set("isEnabled", true), this.set("class", void 0), this.set("id", void 0), this.set("panelPosition", "auto"), this.panelView.bind("isVisible").to(this, "isOpen"), this.keystrokes = new Ti(), this.focusTracker = new Si(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-dropdown", o2.to("class"), o2.if("isEnabled", "ck-disabled", (t4) => !t4)], id: o2.to("id"), "aria-describedby": o2.to("ariaDescribedById") }, children: [e3, n2] }), e3.extendTemplate({ attributes: { class: ["ck-dropdown__button"], "data-cke-tooltip-disabled": o2.to("isOpen") } });
          }
          render() {
            super.render(), this.focusTracker.add(this.buttonView.element), this.focusTracker.add(this.panelView.element), this.listenTo(this.buttonView, "open", () => {
              this.isOpen = !this.isOpen;
            }), this.on("change:isOpen", (t4, e3, n2) => {
              if (n2)
                if ("auto" === this.panelPosition) {
                  const t5 = Fr._getOptimalPosition({ element: this.panelView.element, target: this.buttonView.element, fitInViewport: true, positions: this._panelPositions });
                  this.panelView.position = t5 ? t5.name : this._panelPositions[0].name;
                } else
                  this.panelView.position = this.panelPosition;
            }), this.keystrokes.listenTo(this.element);
            const t3 = (t4, e3) => {
              this.isOpen && (this.isOpen = false, e3());
            };
            this.keystrokes.set("arrowdown", (t4, e3) => {
              this.buttonView.isEnabled && !this.isOpen && (this.isOpen = true, e3());
            }), this.keystrokes.set("arrowright", (t4, e3) => {
              this.isOpen && e3();
            }), this.keystrokes.set("arrowleft", t3), this.keystrokes.set("esc", t3);
          }
          focus() {
            this.buttonView.focus();
          }
          get _panelPositions() {
            const { south: t3, north: e3, southEast: n2, southWest: o2, northEast: i2, northWest: r2, southMiddleEast: s3, southMiddleWest: a2, northMiddleEast: c2, northMiddleWest: l2 } = Fr.defaultPanelPositions;
            return "rtl" !== this.locale.uiLanguageDirection ? [n2, o2, s3, a2, t3, i2, r2, c2, l2, e3] : [o2, n2, a2, s3, t3, r2, i2, l2, c2, e3];
          }
        };
        let Vr = Fr;
        Vr.defaultPanelPositions = { south: (t3, e3) => ({ top: t3.bottom, left: t3.left - (e3.width - t3.width) / 2, name: "s" }), southEast: (t3) => ({ top: t3.bottom, left: t3.left, name: "se" }), southWest: (t3, e3) => ({ top: t3.bottom, left: t3.left - e3.width + t3.width, name: "sw" }), southMiddleEast: (t3, e3) => ({ top: t3.bottom, left: t3.left - (e3.width - t3.width) / 4, name: "sme" }), southMiddleWest: (t3, e3) => ({ top: t3.bottom, left: t3.left - 3 * (e3.width - t3.width) / 4, name: "smw" }), north: (t3, e3) => ({ top: t3.top - e3.height, left: t3.left - (e3.width - t3.width) / 2, name: "n" }), northEast: (t3, e3) => ({ top: t3.top - e3.height, left: t3.left, name: "ne" }), northWest: (t3, e3) => ({ top: t3.top - e3.height, left: t3.left - e3.width + t3.width, name: "nw" }), northMiddleEast: (t3, e3) => ({ top: t3.top - e3.height, left: t3.left - (e3.width - t3.width) / 4, name: "nme" }), northMiddleWest: (t3, e3) => ({ top: t3.top - e3.height, left: t3.left - 3 * (e3.width - t3.width) / 4, name: "nmw" }) }, Vr._getOptimalPosition = ei;
        const Ur = '<svg viewBox="0 0 10 10" xmlns="http://www.w3.org/2000/svg"><path d="M.941 4.523a.75.75 0 1 1 1.06-1.06l3.006 3.005 3.005-3.005a.75.75 0 1 1 1.06 1.06l-3.549 3.55a.75.75 0 0 1-1.168-.136L.941 4.523z"/></svg>';
        class Hr extends br {
          constructor(t3) {
            super(t3), this.arrowView = this._createArrowView(), this.extendTemplate({ attributes: { "aria-haspopup": true, "aria-expanded": this.bindTemplate.to("isOn", (t4) => String(t4)) } }), this.delegate("execute").to(this, "open");
          }
          render() {
            super.render(), this.children.add(this.arrowView);
          }
          _createArrowView() {
            const t3 = new pr();
            return t3.content = Ur, t3.extendTemplate({ attributes: { class: "ck-dropdown__arrow" } }), t3;
          }
        }
        class qr extends M() {
          constructor(t3) {
            if (super(), this.focusables = t3.focusables, this.focusTracker = t3.focusTracker, this.keystrokeHandler = t3.keystrokeHandler, this.actions = t3.actions, t3.actions && t3.keystrokeHandler)
              for (const e3 in t3.actions) {
                let n2 = t3.actions[e3];
                "string" == typeof n2 && (n2 = [n2]);
                for (const o2 of n2)
                  t3.keystrokeHandler.set(o2, (t4, n3) => {
                    this[e3](), n3();
                  });
              }
            this.on("forwardCycle", () => this.focusFirst(), { priority: "low" }), this.on("backwardCycle", () => this.focusLast(), { priority: "low" });
          }
          get first() {
            return this.focusables.find(Gr) || null;
          }
          get last() {
            return this.focusables.filter(Gr).slice(-1)[0] || null;
          }
          get next() {
            return this._getFocusableItem(1);
          }
          get previous() {
            return this._getFocusableItem(-1);
          }
          get current() {
            let t3 = null;
            return null === this.focusTracker.focusedElement ? null : (this.focusables.find((e3, n2) => {
              const o2 = e3.element === this.focusTracker.focusedElement;
              return o2 && (t3 = n2), o2;
            }), t3);
          }
          focusFirst() {
            this._focus(this.first, 1);
          }
          focusLast() {
            this._focus(this.last, -1);
          }
          focusNext() {
            const t3 = this.next;
            t3 && this.focusables.getIndex(t3) === this.current || (t3 === this.first ? this.fire("forwardCycle") : this._focus(t3, 1));
          }
          focusPrevious() {
            const t3 = this.previous;
            t3 && this.focusables.getIndex(t3) === this.current || (t3 === this.last ? this.fire("backwardCycle") : this._focus(t3, -1));
          }
          _focus(t3, e3) {
            t3 && t3.focus(e3);
          }
          _getFocusableItem(t3) {
            const e3 = this.current, n2 = this.focusables.length;
            if (!n2)
              return null;
            if (null === e3)
              return this[1 === t3 ? "first" : "last"];
            let o2 = (e3 + n2 + t3) % n2;
            do {
              const e4 = this.focusables.get(o2);
              if (Gr(e4))
                return e4;
              o2 = (o2 + n2 + t3) % n2;
            } while (o2 !== e3);
            return null;
          }
        }
        function Gr(t3) {
          return !(!("focus" in t3) || !Xo(t3.element));
        }
        class Wr extends Ui {
          constructor(t3) {
            super(t3), this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-toolbar__separator"] } });
          }
        }
        class Kr extends Ui {
          constructor(t3) {
            super(t3), this.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-toolbar__line-break"] } });
          }
        }
        var Zr = Object.defineProperty, Yr = Object.getOwnPropertySymbols, $r = Object.prototype.hasOwnProperty, Qr = Object.prototype.propertyIsEnumerable, Jr = (t3, e3, n2) => e3 in t3 ? Zr(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, Xr = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            $r.call(e3, n2) && Jr(t3, n2, e3[n2]);
          if (Yr)
            for (var n2 of Yr(e3))
              Qr.call(e3, n2) && Jr(t3, n2, e3[n2]);
          return t3;
        };
        function ts(t3) {
          if (Array.isArray(t3))
            return { items: t3, removeItems: [] };
          const e3 = { items: [], removeItems: [] };
          return t3 ? Xr(Xr({}, e3), t3) : e3;
        }
        class es extends W() {
          constructor(t3) {
            super(), this._disableStack = /* @__PURE__ */ new Set(), this.editor = t3, this.set("isEnabled", true);
          }
          forceDisabled(t3) {
            this._disableStack.add(t3), 1 == this._disableStack.size && (this.on("set:isEnabled", ns, { priority: "highest" }), this.isEnabled = false);
          }
          clearForceDisabled(t3) {
            this._disableStack.delete(t3), 0 == this._disableStack.size && (this.off("set:isEnabled", ns), this.isEnabled = true);
          }
          destroy() {
            this.stopListening();
          }
          static get isContextPlugin() {
            return false;
          }
        }
        function ns(t3) {
          t3.return = false, t3.stop();
        }
        class os extends W() {
          constructor(t3) {
            super(), this.editor = t3, this.set("value", void 0), this.set("isEnabled", false), this._affectsData = true, this._isEnabledBasedOnSelection = true, this._disableStack = /* @__PURE__ */ new Set(), this.decorate("execute"), this.listenTo(this.editor.model.document, "change", () => {
              this.refresh();
            }), this.listenTo(t3, "change:isReadOnly", () => {
              this.refresh();
            }), this.on("set:isEnabled", (e3) => {
              if (!this.affectsData)
                return;
              const n2 = t3.model.document.selection, o2 = !("$graveyard" == n2.getFirstPosition().root.rootName) && t3.model.canEditAt(n2);
              (t3.isReadOnly || this._isEnabledBasedOnSelection && !o2) && (e3.return = false, e3.stop());
            }, { priority: "highest" }), this.on("execute", (t4) => {
              this.isEnabled || t4.stop();
            }, { priority: "high" });
          }
          get affectsData() {
            return this._affectsData;
          }
          set affectsData(t3) {
            this._affectsData = t3;
          }
          refresh() {
            this.isEnabled = true;
          }
          forceDisabled(t3) {
            this._disableStack.add(t3), 1 == this._disableStack.size && (this.on("set:isEnabled", is, { priority: "highest" }), this.isEnabled = false);
          }
          clearForceDisabled(t3) {
            this._disableStack.delete(t3), 0 == this._disableStack.size && (this.off("set:isEnabled", is), this.refresh());
          }
          execute(...t3) {
          }
          destroy() {
            this.stopListening();
          }
        }
        function is(t3) {
          t3.return = false, t3.stop();
        }
        class rs extends os {
          constructor() {
            super(...arguments), this._childCommandsDefinitions = [];
          }
          refresh() {
          }
          execute(...t3) {
            const e3 = this._getFirstEnabledCommand();
            return !!e3 && e3.execute(t3);
          }
          registerChildCommand(t3, e3 = {}) {
            b(this._childCommandsDefinitions, { command: t3, priority: e3.priority || "normal" }), t3.on("change:isEnabled", () => this._checkEnabled()), this._checkEnabled();
          }
          _checkEnabled() {
            this.isEnabled = !!this._getFirstEnabledCommand();
          }
          _getFirstEnabledCommand() {
            const t3 = this._childCommandsDefinitions.find(({ command: t4 }) => t4.isEnabled);
            return t3 && t3.command;
          }
        }
        class ss extends M() {
          constructor(t3, e3 = [], n2 = []) {
            super(), this._plugins = /* @__PURE__ */ new Map(), this._context = t3, this._availablePlugins = /* @__PURE__ */ new Map();
            for (const t4 of e3)
              t4.pluginName && this._availablePlugins.set(t4.pluginName, t4);
            this._contextPlugins = /* @__PURE__ */ new Map();
            for (const [t4, e4] of n2)
              this._contextPlugins.set(t4, e4), this._contextPlugins.set(e4, t4), t4.pluginName && this._availablePlugins.set(t4.pluginName, t4);
          }
          *[Symbol.iterator]() {
            for (const t3 of this._plugins)
              "function" == typeof t3[0] && (yield t3);
          }
          get(t3) {
            const e3 = this._plugins.get(t3);
            if (!e3) {
              let e4 = t3;
              throw "function" == typeof t3 && (e4 = t3.pluginName || t3.name), new A("plugincollection-plugin-not-loaded", this._context, { plugin: e4 });
            }
            return e3;
          }
          has(t3) {
            return this._plugins.has(t3);
          }
          init(t3, e3 = [], n2 = []) {
            const o2 = this, i2 = this._context;
            !function t4(e4, n3 = /* @__PURE__ */ new Set()) {
              e4.forEach((e5) => {
                a2(e5) && (n3.has(e5) || (n3.add(e5), e5.pluginName && !o2._availablePlugins.has(e5.pluginName) && o2._availablePlugins.set(e5.pluginName, e5), e5.requires && t4(e5.requires, n3)));
              });
            }(t3), h2(t3);
            const r2 = [...function t4(e4, n3 = /* @__PURE__ */ new Set()) {
              return e4.map((t5) => a2(t5) ? t5 : o2._availablePlugins.get(t5)).reduce((e5, o3) => n3.has(o3) ? e5 : (n3.add(o3), o3.requires && (h2(o3.requires, o3), t4(o3.requires, n3).forEach((t5) => e5.add(t5))), e5.add(o3)), /* @__PURE__ */ new Set());
            }(t3.filter((t4) => !l2(t4, e3)))];
            !function(t4, e4) {
              for (const n3 of e4) {
                if ("function" != typeof n3)
                  throw new A("plugincollection-replace-plugin-invalid-type", null, { pluginItem: n3 });
                const e5 = n3.pluginName;
                if (!e5)
                  throw new A("plugincollection-replace-plugin-missing-name", null, { pluginItem: n3 });
                if (n3.requires && n3.requires.length)
                  throw new A("plugincollection-plugin-for-replacing-cannot-have-dependencies", null, { pluginName: e5 });
                const i3 = o2._availablePlugins.get(e5);
                if (!i3)
                  throw new A("plugincollection-plugin-for-replacing-not-exist", null, { pluginName: e5 });
                const r3 = t4.indexOf(i3);
                if (-1 === r3) {
                  if (o2._contextPlugins.has(i3))
                    return;
                  throw new A("plugincollection-plugin-for-replacing-not-loaded", null, { pluginName: e5 });
                }
                if (i3.requires && i3.requires.length)
                  throw new A("plugincollection-replaced-plugin-cannot-have-dependencies", null, { pluginName: e5 });
                t4.splice(r3, 1, n3), o2._availablePlugins.set(e5, n3);
              }
            }(r2, n2);
            const s3 = r2.map((t4) => {
              let e4 = o2._contextPlugins.get(t4);
              return e4 = e4 || new t4(i2), o2._add(t4, e4), e4;
            });
            return u2(s3, "init").then(() => u2(s3, "afterInit")).then(() => s3);
            function a2(t4) {
              return "function" == typeof t4;
            }
            function c2(t4) {
              return a2(t4) && !!t4.isContextPlugin;
            }
            function l2(t4, e4) {
              return e4.some((e5) => e5 === t4 || (d2(t4) === e5 || d2(e5) === t4));
            }
            function d2(t4) {
              return a2(t4) ? t4.pluginName || t4.name : t4;
            }
            function h2(t4, n3 = null) {
              t4.map((t5) => a2(t5) ? t5 : o2._availablePlugins.get(t5) || t5).forEach((t5) => {
                !function(t6, e4) {
                  if (a2(t6))
                    return;
                  if (e4)
                    throw new A("plugincollection-soft-required", i2, { missingPlugin: t6, requiredBy: d2(e4) });
                  throw new A("plugincollection-plugin-not-found", i2, { plugin: t6 });
                }(t5, n3), function(t6, e4) {
                  if (!c2(e4))
                    return;
                  if (c2(t6))
                    return;
                  throw new A("plugincollection-context-required", i2, { plugin: d2(t6), requiredBy: d2(e4) });
                }(t5, n3), function(t6, n4) {
                  if (!n4)
                    return;
                  if (!l2(t6, e3))
                    return;
                  throw new A("plugincollection-required", i2, { plugin: d2(t6), requiredBy: d2(n4) });
                }(t5, n3);
              });
            }
            function u2(t4, e4) {
              return t4.reduce((t5, n3) => n3[e4] ? o2._contextPlugins.has(n3) ? t5 : t5.then(n3[e4].bind(n3)) : t5, Promise.resolve());
            }
          }
          destroy() {
            const t3 = [];
            for (const [, e3] of this)
              "function" != typeof e3.destroy || this._contextPlugins.has(e3) || t3.push(e3.destroy());
            return Promise.all(t3);
          }
          _add(t3, e3) {
            this._plugins.set(t3, e3);
            const n2 = t3.pluginName;
            if (n2) {
              if (this._plugins.has(n2))
                throw new A("plugincollection-plugin-name-conflict", null, { pluginName: n2, plugin1: this._plugins.get(n2).constructor, plugin2: t3 });
              this._plugins.set(n2, e3);
            }
          }
        }
        class as {
          constructor(t3) {
            this._contextOwner = null, this.config = new xo(t3, this.constructor.defaultConfig);
            const e3 = this.constructor.builtinPlugins;
            this.config.define("plugins", e3), this.plugins = new ss(this, e3);
            const n2 = this.config.get("language") || {};
            this.locale = new Ei({ uiLanguage: "string" == typeof n2 ? n2 : n2.ui, contentLanguage: this.config.get("language.content") }), this.t = this.locale.t, this.editors = new Di();
          }
          initPlugins() {
            const t3 = this.config.get("plugins") || [], e3 = this.config.get("substitutePlugins") || [];
            for (const n2 of t3.concat(e3)) {
              if ("function" != typeof n2)
                throw new A("context-initplugins-constructor-only", null, { Plugin: n2 });
              if (true !== n2.isContextPlugin)
                throw new A("context-initplugins-invalid-plugin", null, { Plugin: n2 });
            }
            return this.plugins.init(t3, [], e3);
          }
          destroy() {
            return Promise.all(Array.from(this.editors, (t3) => t3.destroy())).then(() => this.plugins.destroy());
          }
          _addEditor(t3, e3) {
            if (this._contextOwner)
              throw new A("context-addeditor-private-context");
            this.editors.add(t3), e3 && (this._contextOwner = t3);
          }
          _removeEditor(t3) {
            return this.editors.has(t3) && this.editors.remove(t3), this._contextOwner === t3 ? this.destroy() : Promise.resolve();
          }
          _getEditorConfig() {
            const t3 = {};
            for (const e3 of this.config.names())
              ["plugins", "removePlugins", "extraPlugins"].includes(e3) || (t3[e3] = this.config.get(e3));
            return t3;
          }
          static create(t3) {
            return new Promise((e3) => {
              const n2 = new this(t3);
              e3(n2.initPlugins().then(() => n2));
            });
          }
        }
        class cs extends W() {
          constructor(t3) {
            super(), this.context = t3;
          }
          destroy() {
            this.stopListening();
          }
          static get isContextPlugin() {
            return true;
          }
        }
        class ls extends Ti {
          constructor(t3) {
            super(), this.editor = t3;
          }
          set(t3, e3, n2 = {}) {
            if ("string" == typeof e3) {
              const t4 = e3;
              e3 = (e4, n3) => {
                this.editor.execute(t4), n3();
              };
            }
            super.set(t3, e3, n2);
          }
        }
        var ds = n(4717), hs = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(ds.Z, hs);
        ds.Z.locals;
        const us = /* @__PURE__ */ new WeakMap();
        let gs = false;
        function ps({ view: t3, element: e3, text: n2, isDirectHost: o2 = true, keepOnFocus: i2 = false }) {
          const r2 = t3.document;
          function s3(n3) {
            us.get(r2).set(e3, { text: n3, isDirectHost: o2, keepOnFocus: i2, hostElement: o2 ? e3 : null }), t3.change((t4) => fs(r2, t4));
          }
          us.has(r2) || (us.set(r2, /* @__PURE__ */ new Map()), r2.registerPostFixer((t4) => fs(r2, t4)), r2.on("change:isComposing", () => {
            t3.change((t4) => fs(r2, t4));
          }, { priority: "high" })), e3.is("editableElement") && e3.on("change:placeholder", (t4, e4, n3) => {
            s3(n3);
          }), e3.placeholder ? s3(e3.placeholder) : n2 && s3(n2), n2 && function() {
            gs || C("enableplaceholder-deprecated-text-option");
            gs = true;
          }();
        }
        function ms(t3, e3) {
          return !!e3.hasClass("ck-placeholder") && (t3.removeClass("ck-placeholder", e3), true);
        }
        function fs(t3, e3) {
          const n2 = us.get(t3), o2 = [];
          let i2 = false;
          for (const [t4, r2] of n2)
            r2.isDirectHost && (o2.push(t4), ks(e3, t4, r2) && (i2 = true));
          for (const [t4, r2] of n2) {
            if (r2.isDirectHost)
              continue;
            const n3 = bs(t4);
            n3 && (o2.includes(n3) || (r2.hostElement = n3, ks(e3, t4, r2) && (i2 = true)));
          }
          return i2;
        }
        function ks(t3, e3, n2) {
          const { text: o2, isDirectHost: i2, hostElement: r2 } = n2;
          let s3 = false;
          r2.getAttribute("data-placeholder") !== o2 && (t3.setAttribute("data-placeholder", o2, r2), s3 = true);
          return (i2 || 1 == e3.childCount) && function(t4, e4) {
            if (!t4.isAttached())
              return false;
            if (Array.from(t4.getChildren()).some((t5) => !t5.is("uiElement")))
              return false;
            const n3 = t4.document, o3 = n3.selection.anchor;
            return !(n3.isComposing && o3 && o3.parent === t4 || !e4 && n3.isFocused && (!o3 || o3.parent === t4));
          }(r2, n2.keepOnFocus) ? function(t4, e4) {
            return !e4.hasClass("ck-placeholder") && (t4.addClass("ck-placeholder", e4), true);
          }(t3, r2) && (s3 = true) : ms(t3, r2) && (s3 = true), s3;
        }
        function bs(t3) {
          if (t3.childCount) {
            const e3 = t3.getChild(0);
            if (e3.is("element") && !e3.is("uiElement") && !e3.is("attributeElement"))
              return e3;
          }
          return null;
        }
        class ws {
          is() {
            throw new Error("is() method is abstract");
          }
        }
        const As = function(t3) {
          return _o(t3, 4);
        };
        class Cs extends M(ws) {
          constructor(t3) {
            super(), this.document = t3, this.parent = null;
          }
          get index() {
            let t3;
            if (!this.parent)
              return null;
            if (-1 == (t3 = this.parent.getChildIndex(this)))
              throw new A("view-node-not-found-in-parent", this);
            return t3;
          }
          get nextSibling() {
            const t3 = this.index;
            return null !== t3 && this.parent.getChild(t3 + 1) || null;
          }
          get previousSibling() {
            const t3 = this.index;
            return null !== t3 && this.parent.getChild(t3 - 1) || null;
          }
          get root() {
            let t3 = this;
            for (; t3.parent; )
              t3 = t3.parent;
            return t3;
          }
          isAttached() {
            return this.root.is("rootElement");
          }
          getPath() {
            const t3 = [];
            let e3 = this;
            for (; e3.parent; )
              t3.unshift(e3.index), e3 = e3.parent;
            return t3;
          }
          getAncestors(t3 = {}) {
            const e3 = [];
            let n2 = t3.includeSelf ? this : this.parent;
            for (; n2; )
              e3[t3.parentFirst ? "push" : "unshift"](n2), n2 = n2.parent;
            return e3;
          }
          getCommonAncestor(t3, e3 = {}) {
            const n2 = this.getAncestors(e3), o2 = t3.getAncestors(e3);
            let i2 = 0;
            for (; n2[i2] == o2[i2] && n2[i2]; )
              i2++;
            return 0 === i2 ? null : n2[i2 - 1];
          }
          isBefore(t3) {
            if (this == t3)
              return false;
            if (this.root !== t3.root)
              return false;
            const e3 = this.getPath(), n2 = t3.getPath(), o2 = tt(e3, n2);
            switch (o2) {
              case "prefix":
                return true;
              case "extension":
                return false;
              default:
                return e3[o2] < n2[o2];
            }
          }
          isAfter(t3) {
            return this != t3 && (this.root === t3.root && !this.isBefore(t3));
          }
          _remove() {
            this.parent._removeChildren(this.index);
          }
          _fireChange(t3, e3) {
            this.fire(`change:${t3}`, e3), this.parent && this.parent._fireChange(t3, e3);
          }
          toJSON() {
            const t3 = As(this);
            return delete t3.parent, t3;
          }
        }
        Cs.prototype.is = function(t3) {
          return "node" === t3 || "view:node" === t3;
        };
        class _s extends Cs {
          constructor(t3, e3) {
            super(t3), this._textData = e3;
          }
          get data() {
            return this._textData;
          }
          get _data() {
            return this.data;
          }
          set _data(t3) {
            this._fireChange("text", this), this._textData = t3;
          }
          isSimilar(t3) {
            return t3 instanceof _s && (this === t3 || this.data === t3.data);
          }
          _clone() {
            return new _s(this.document, this.data);
          }
        }
        _s.prototype.is = function(t3) {
          return "$text" === t3 || "view:$text" === t3 || "text" === t3 || "view:text" === t3 || "node" === t3 || "view:node" === t3;
        };
        class vs extends ws {
          constructor(t3, e3, n2) {
            if (super(), this.textNode = t3, e3 < 0 || e3 > t3.data.length)
              throw new A("view-textproxy-wrong-offsetintext", this);
            if (n2 < 0 || e3 + n2 > t3.data.length)
              throw new A("view-textproxy-wrong-length", this);
            this.data = t3.data.substring(e3, e3 + n2), this.offsetInText = e3;
          }
          get offsetSize() {
            return this.data.length;
          }
          get isPartial() {
            return this.data.length !== this.textNode.data.length;
          }
          get parent() {
            return this.textNode.parent;
          }
          get root() {
            return this.textNode.root;
          }
          get document() {
            return this.textNode.document;
          }
          getAncestors(t3 = {}) {
            const e3 = [];
            let n2 = t3.includeSelf ? this.textNode : this.parent;
            for (; null !== n2; )
              e3[t3.parentFirst ? "push" : "unshift"](n2), n2 = n2.parent;
            return e3;
          }
        }
        vs.prototype.is = function(t3) {
          return "$textProxy" === t3 || "view:$textProxy" === t3 || "textProxy" === t3 || "view:textProxy" === t3;
        };
        class ys {
          constructor(...t3) {
            this._patterns = [], this.add(...t3);
          }
          add(...t3) {
            for (let e3 of t3)
              ("string" == typeof e3 || e3 instanceof RegExp) && (e3 = { name: e3 }), this._patterns.push(e3);
          }
          match(...t3) {
            for (const e3 of t3)
              for (const t4 of this._patterns) {
                const n2 = xs(e3, t4);
                if (n2)
                  return { element: e3, pattern: t4, match: n2 };
              }
            return null;
          }
          matchAll(...t3) {
            const e3 = [];
            for (const n2 of t3)
              for (const t4 of this._patterns) {
                const o2 = xs(n2, t4);
                o2 && e3.push({ element: n2, pattern: t4, match: o2 });
              }
            return e3.length > 0 ? e3 : null;
          }
          getElementName() {
            if (1 !== this._patterns.length)
              return null;
            const t3 = this._patterns[0], e3 = t3.name;
            return "function" == typeof t3 || !e3 || e3 instanceof RegExp ? null : e3;
          }
        }
        function xs(t3, e3) {
          if ("function" == typeof e3)
            return e3(t3);
          const n2 = {};
          return e3.name && (n2.name = function(t4, e4) {
            if (t4 instanceof RegExp)
              return !!e4.match(t4);
            return t4 === e4;
          }(e3.name, t3.name), !n2.name) || e3.attributes && (n2.attributes = function(t4, e4) {
            const n3 = new Set(e4.getAttributeKeys());
            Et(t4) ? (void 0 !== t4.style && C("matcher-pattern-deprecated-attributes-style-key", t4), void 0 !== t4.class && C("matcher-pattern-deprecated-attributes-class-key", t4)) : (n3.delete("style"), n3.delete("class"));
            return Es(t4, n3, (t5) => e4.getAttribute(t5));
          }(e3.attributes, t3), !n2.attributes) || e3.classes && (n2.classes = function(t4, e4) {
            return Es(t4, e4.getClassNames(), () => {
            });
          }(e3.classes, t3), !n2.classes) || e3.styles && (n2.styles = function(t4, e4) {
            return Es(t4, e4.getStyleNames(true), (t5) => e4.getStyle(t5));
          }(e3.styles, t3), !n2.styles) ? null : n2;
        }
        function Es(t3, e3, n2) {
          const o2 = function(t4) {
            if (Array.isArray(t4))
              return t4.map((t5) => Et(t5) ? (void 0 !== t5.key && void 0 !== t5.value || C("matcher-pattern-missing-key-or-value", t5), [t5.key, t5.value]) : [t5, true]);
            if (Et(t4))
              return Object.entries(t4);
            return [[t4, true]];
          }(t3), i2 = Array.from(e3), r2 = [];
          if (o2.forEach(([t4, e4]) => {
            i2.forEach((o3) => {
              (function(t5, e5) {
                return true === t5 || t5 === e5 || t5 instanceof RegExp && e5.match(t5);
              })(t4, o3) && function(t5, e5, n3) {
                if (true === t5)
                  return true;
                const o4 = n3(e5);
                return t5 === o4 || t5 instanceof RegExp && !!String(o4).match(t5);
              }(e4, o3, n2) && r2.push(o3);
            });
          }), o2.length && !(r2.length < o2.length))
            return r2;
        }
        const Ds = function(t3) {
          return "symbol" == typeof t3 || ft(t3) && "[object Symbol]" == pt(t3);
        };
        var Is = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Ss = /^\w*$/;
        const Ts = function(t3, e3) {
          if (mt(t3))
            return false;
          var n2 = typeof t3;
          return !("number" != n2 && "symbol" != n2 && "boolean" != n2 && null != t3 && !Ds(t3)) || (Ss.test(t3) || !Is.test(t3) || null != e3 && t3 in Object(e3));
        };
        function Ms(t3, e3) {
          if ("function" != typeof t3 || null != e3 && "function" != typeof e3)
            throw new TypeError("Expected a function");
          var n2 = function() {
            var o2 = arguments, i2 = e3 ? e3.apply(this, o2) : o2[0], r2 = n2.cache;
            if (r2.has(i2))
              return r2.get(i2);
            var s3 = t3.apply(this, o2);
            return n2.cache = r2.set(i2, s3) || r2, s3;
          };
          return n2.cache = new (Ms.Cache || Ce)(), n2;
        }
        Ms.Cache = Ce;
        const Bs = Ms;
        const Ns = function(t3) {
          var e3 = Bs(t3, function(t4) {
            return 500 === n2.size && n2.clear(), t4;
          }), n2 = e3.cache;
          return e3;
        };
        var Ps = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, zs = /\\(\\)?/g, Os = Ns(function(t3) {
          var e3 = [];
          return 46 === t3.charCodeAt(0) && e3.push(""), t3.replace(Ps, function(t4, n2, o2, i2) {
            e3.push(o2 ? i2.replace(zs, "$1") : n2 || t4);
          }), e3;
        });
        const Ls = Os;
        const Rs = function(t3, e3) {
          for (var n2 = -1, o2 = null == t3 ? 0 : t3.length, i2 = Array(o2); ++n2 < o2; )
            i2[n2] = e3(t3[n2], n2, t3);
          return i2;
        };
        var js = rt ? rt.prototype : void 0, Fs = js ? js.toString : void 0;
        const Vs = function t3(e3) {
          if ("string" == typeof e3)
            return e3;
          if (mt(e3))
            return Rs(e3, t3) + "";
          if (Ds(e3))
            return Fs ? Fs.call(e3) : "";
          var n2 = e3 + "";
          return "0" == n2 && 1 / e3 == -Infinity ? "-0" : n2;
        };
        const Us = function(t3) {
          return null == t3 ? "" : Vs(t3);
        };
        const Hs = function(t3, e3) {
          return mt(t3) ? t3 : Ts(t3, e3) ? [t3] : Ls(Us(t3));
        };
        const qs = function(t3) {
          var e3 = null == t3 ? 0 : t3.length;
          return e3 ? t3[e3 - 1] : void 0;
        };
        const Gs = function(t3) {
          if ("string" == typeof t3 || Ds(t3))
            return t3;
          var e3 = t3 + "";
          return "0" == e3 && 1 / t3 == -Infinity ? "-0" : e3;
        };
        const Ws = function(t3, e3) {
          for (var n2 = 0, o2 = (e3 = Hs(e3, t3)).length; null != t3 && n2 < o2; )
            t3 = t3[Gs(e3[n2++])];
          return n2 && n2 == o2 ? t3 : void 0;
        };
        const Ks = function(t3, e3, n2) {
          var o2 = -1, i2 = t3.length;
          e3 < 0 && (e3 = -e3 > i2 ? 0 : i2 + e3), (n2 = n2 > i2 ? i2 : n2) < 0 && (n2 += i2), i2 = e3 > n2 ? 0 : n2 - e3 >>> 0, e3 >>>= 0;
          for (var r2 = Array(i2); ++o2 < i2; )
            r2[o2] = t3[o2 + e3];
          return r2;
        };
        const Zs = function(t3, e3) {
          return e3.length < 2 ? t3 : Ws(t3, Ks(e3, 0, -1));
        };
        const Ys = function(t3, e3) {
          return e3 = Hs(e3, t3), null == (t3 = Zs(t3, e3)) || delete t3[Gs(qs(e3))];
        };
        const $s = function(t3, e3) {
          return null == t3 || Ys(t3, e3);
        };
        const Qs = function(t3, e3, n2) {
          var o2 = null == t3 ? void 0 : Ws(t3, e3);
          return void 0 === o2 ? n2 : o2;
        };
        const Js = function(t3, e3, n2) {
          (void 0 !== n2 && !It(t3[e3], n2) || void 0 === n2 && !(e3 in t3)) && De(t3, e3, n2);
        };
        const Xs = function(t3) {
          return function(e3, n2, o2) {
            for (var i2 = -1, r2 = Object(e3), s3 = o2(e3), a2 = s3.length; a2--; ) {
              var c2 = s3[t3 ? a2 : ++i2];
              if (false === n2(r2[c2], c2, r2))
                break;
            }
            return e3;
          };
        }();
        const ta = function(t3) {
          return ft(t3) && cn(t3);
        };
        const ea = function(t3, e3) {
          if (("constructor" !== e3 || "function" != typeof t3[e3]) && "__proto__" != e3)
            return t3[e3];
        };
        const na = function(t3) {
          return Te(t3, pn(t3));
        };
        const oa = function(t3, e3, n2, o2, i2, r2, s3) {
          var a2 = ea(t3, n2), c2 = ea(e3, n2), l2 = s3.get(c2);
          if (l2)
            Js(t3, n2, l2);
          else {
            var d2 = r2 ? r2(a2, c2, n2 + "", t3, e3, s3) : void 0, h2 = void 0 === d2;
            if (h2) {
              var u2 = mt(c2), g2 = !u2 && Ve(c2), p2 = !u2 && !g2 && Xe(c2);
              d2 = c2, u2 || g2 || p2 ? mt(a2) ? d2 = a2 : ta(a2) ? d2 = Cn(a2) : g2 ? (h2 = false, d2 = An(c2, true)) : p2 ? (h2 = false, d2 = so(c2, true)) : d2 = [] : Et(c2) || Oe(c2) ? (d2 = a2, Oe(a2) ? d2 = na(a2) : j(a2) && !Vt(a2) || (d2 = ho(c2))) : h2 = false;
            }
            h2 && (s3.set(c2, d2), i2(d2, c2, o2, r2, s3), s3.delete(c2)), Js(t3, n2, d2);
          }
        };
        const ia = function t3(e3, n2, o2, i2, r2) {
          e3 !== n2 && Xs(n2, function(s3, a2) {
            if (r2 || (r2 = new ye()), j(s3))
              oa(e3, n2, a2, o2, t3, i2, r2);
            else {
              var c2 = i2 ? i2(ea(e3, a2), s3, a2 + "", e3, n2, r2) : void 0;
              void 0 === c2 && (c2 = s3), Js(e3, a2, c2);
            }
          }, pn);
        };
        const ra = function(t3) {
          return t3;
        };
        const sa = function(t3, e3, n2) {
          switch (n2.length) {
            case 0:
              return t3.call(e3);
            case 1:
              return t3.call(e3, n2[0]);
            case 2:
              return t3.call(e3, n2[0], n2[1]);
            case 3:
              return t3.call(e3, n2[0], n2[1], n2[2]);
          }
          return t3.apply(e3, n2);
        };
        var aa = Math.max;
        const ca = function(t3, e3, n2) {
          return e3 = aa(void 0 === e3 ? t3.length - 1 : e3, 0), function() {
            for (var o2 = arguments, i2 = -1, r2 = aa(o2.length - e3, 0), s3 = Array(r2); ++i2 < r2; )
              s3[i2] = o2[e3 + i2];
            i2 = -1;
            for (var a2 = Array(e3 + 1); ++i2 < e3; )
              a2[i2] = o2[i2];
            return a2[e3] = n2(s3), sa(t3, this, a2);
          };
        };
        const la = function(t3) {
          return function() {
            return t3;
          };
        };
        const da = Ee ? function(t3, e3) {
          return Ee(t3, "toString", { configurable: true, enumerable: false, value: la(e3), writable: true });
        } : ra;
        var ha = Date.now;
        const ua = function(t3) {
          var e3 = 0, n2 = 0;
          return function() {
            var o2 = ha(), i2 = 16 - (o2 - n2);
            if (n2 = o2, i2 > 0) {
              if (++e3 >= 800)
                return arguments[0];
            } else
              e3 = 0;
            return t3.apply(void 0, arguments);
          };
        };
        const ga = ua(da);
        const pa = function(t3, e3) {
          return ga(ca(t3, e3, ra), t3 + "");
        };
        const ma = function(t3, e3, n2) {
          if (!j(n2))
            return false;
          var o2 = typeof e3;
          return !!("number" == o2 ? cn(n2) && He(e3, n2.length) : "string" == o2 && e3 in n2) && It(n2[e3], t3);
        };
        const fa = function(t3) {
          return pa(function(e3, n2) {
            var o2 = -1, i2 = n2.length, r2 = i2 > 1 ? n2[i2 - 1] : void 0, s3 = i2 > 2 ? n2[2] : void 0;
            for (r2 = t3.length > 3 && "function" == typeof r2 ? (i2--, r2) : void 0, s3 && ma(n2[0], n2[1], s3) && (r2 = i2 < 3 ? void 0 : r2, i2 = 1), e3 = Object(e3); ++o2 < i2; ) {
              var a2 = n2[o2];
              a2 && t3(e3, a2, o2, r2);
            }
            return e3;
          });
        };
        const ka = fa(function(t3, e3, n2) {
          ia(t3, e3, n2);
        });
        const ba = function(t3, e3, n2, o2) {
          if (!j(t3))
            return t3;
          for (var i2 = -1, r2 = (e3 = Hs(e3, t3)).length, s3 = r2 - 1, a2 = t3; null != a2 && ++i2 < r2; ) {
            var c2 = Gs(e3[i2]), l2 = n2;
            if ("__proto__" === c2 || "constructor" === c2 || "prototype" === c2)
              return t3;
            if (i2 != s3) {
              var d2 = a2[c2];
              void 0 === (l2 = o2 ? o2(d2, c2, a2) : void 0) && (l2 = j(d2) ? d2 : He(e3[i2 + 1]) ? [] : {});
            }
            Se(a2, c2, l2), a2 = a2[c2];
          }
          return t3;
        };
        const wa = function(t3, e3, n2) {
          return null == t3 ? t3 : ba(t3, e3, n2);
        };
        class Aa {
          constructor(t3) {
            this._styles = {}, this._styleProcessor = t3;
          }
          get isEmpty() {
            return !Object.entries(this._styles).length;
          }
          get size() {
            return this.isEmpty ? 0 : this.getStyleNames().length;
          }
          setTo(t3) {
            this.clear();
            const e3 = function(t4) {
              let e4 = null, n2 = 0, o2 = 0, i2 = null;
              const r2 = /* @__PURE__ */ new Map();
              if ("" === t4)
                return r2;
              ";" != t4.charAt(t4.length - 1) && (t4 += ";");
              for (let s3 = 0; s3 < t4.length; s3++) {
                const a2 = t4.charAt(s3);
                if (null === e4)
                  switch (a2) {
                    case ":":
                      i2 || (i2 = t4.substr(n2, s3 - n2), o2 = s3 + 1);
                      break;
                    case '"':
                    case "'":
                      e4 = a2;
                      break;
                    case ";": {
                      const e5 = t4.substr(o2, s3 - o2);
                      i2 && r2.set(i2.trim(), e5.trim()), i2 = null, n2 = s3 + 1;
                      break;
                    }
                  }
                else
                  a2 === e4 && (e4 = null);
              }
              return r2;
            }(t3);
            for (const [t4, n2] of e3)
              this._styleProcessor.toNormalizedForm(t4, n2, this._styles);
          }
          has(t3) {
            if (this.isEmpty)
              return false;
            const e3 = this._styleProcessor.getReducedForm(t3, this._styles).find(([e4]) => e4 === t3);
            return Array.isArray(e3);
          }
          set(t3, e3) {
            if (j(t3))
              for (const [e4, n2] of Object.entries(t3))
                this._styleProcessor.toNormalizedForm(e4, n2, this._styles);
            else
              this._styleProcessor.toNormalizedForm(t3, e3, this._styles);
          }
          remove(t3) {
            const e3 = _a(t3);
            $s(this._styles, e3), delete this._styles[t3], this._cleanEmptyObjectsOnPath(e3);
          }
          getNormalized(t3) {
            return this._styleProcessor.getNormalized(t3, this._styles);
          }
          toString() {
            return this.isEmpty ? "" : this._getStylesEntries().map((t3) => t3.join(":")).sort().join(";") + ";";
          }
          getAsString(t3) {
            if (this.isEmpty)
              return;
            if (this._styles[t3] && !j(this._styles[t3]))
              return this._styles[t3];
            const e3 = this._styleProcessor.getReducedForm(t3, this._styles).find(([e4]) => e4 === t3);
            return Array.isArray(e3) ? e3[1] : void 0;
          }
          getStyleNames(t3 = false) {
            if (this.isEmpty)
              return [];
            if (t3)
              return this._styleProcessor.getStyleNames(this._styles);
            return this._getStylesEntries().map(([t4]) => t4);
          }
          clear() {
            this._styles = {};
          }
          _getStylesEntries() {
            const t3 = [], e3 = Object.keys(this._styles);
            for (const n2 of e3)
              t3.push(...this._styleProcessor.getReducedForm(n2, this._styles));
            return t3;
          }
          _cleanEmptyObjectsOnPath(t3) {
            const e3 = t3.split(".");
            if (!(e3.length > 1))
              return;
            const n2 = e3.splice(0, e3.length - 1).join("."), o2 = Qs(this._styles, n2);
            if (!o2)
              return;
            !Object.keys(o2).length && this.remove(n2);
          }
        }
        class Ca {
          constructor() {
            this._normalizers = /* @__PURE__ */ new Map(), this._extractors = /* @__PURE__ */ new Map(), this._reducers = /* @__PURE__ */ new Map(), this._consumables = /* @__PURE__ */ new Map();
          }
          toNormalizedForm(t3, e3, n2) {
            if (j(e3))
              va(n2, _a(t3), e3);
            else if (this._normalizers.has(t3)) {
              const o2 = this._normalizers.get(t3), { path: i2, value: r2 } = o2(e3);
              va(n2, i2, r2);
            } else
              va(n2, t3, e3);
          }
          getNormalized(t3, e3) {
            if (!t3)
              return ka({}, e3);
            if (void 0 !== e3[t3])
              return e3[t3];
            if (this._extractors.has(t3)) {
              const n2 = this._extractors.get(t3);
              if ("string" == typeof n2)
                return Qs(e3, n2);
              const o2 = n2(t3, e3);
              if (o2)
                return o2;
            }
            return Qs(e3, _a(t3));
          }
          getReducedForm(t3, e3) {
            const n2 = this.getNormalized(t3, e3);
            if (void 0 === n2)
              return [];
            if (this._reducers.has(t3)) {
              return this._reducers.get(t3)(n2);
            }
            return [[t3, n2]];
          }
          getStyleNames(t3) {
            const e3 = Array.from(this._consumables.keys()).filter((e4) => {
              const n3 = this.getNormalized(e4, t3);
              return n3 && "object" == typeof n3 ? Object.keys(n3).length : n3;
            }), n2 = /* @__PURE__ */ new Set([...e3, ...Object.keys(t3)]);
            return Array.from(n2);
          }
          getRelatedStyles(t3) {
            return this._consumables.get(t3) || [];
          }
          setNormalizer(t3, e3) {
            this._normalizers.set(t3, e3);
          }
          setExtractor(t3, e3) {
            this._extractors.set(t3, e3);
          }
          setReducer(t3, e3) {
            this._reducers.set(t3, e3);
          }
          setStyleRelation(t3, e3) {
            this._mapStyleNames(t3, e3);
            for (const n2 of e3)
              this._mapStyleNames(n2, [t3]);
          }
          _mapStyleNames(t3, e3) {
            this._consumables.has(t3) || this._consumables.set(t3, []), this._consumables.get(t3).push(...e3);
          }
        }
        function _a(t3) {
          return t3.replace("-", ".");
        }
        function va(t3, e3, n2) {
          let o2 = n2;
          j(n2) && (o2 = ka({}, Qs(t3, e3), n2)), wa(t3, e3, o2);
        }
        class ya extends Cs {
          constructor(t3, e3, n2, o2) {
            if (super(t3), this._unsafeAttributesToRender = [], this._customProperties = /* @__PURE__ */ new Map(), this.name = e3, this._attrs = function(t4) {
              const e4 = Mi(t4);
              for (const [t5, n3] of e4)
                null === n3 ? e4.delete(t5) : "string" != typeof n3 && e4.set(t5, String(n3));
              return e4;
            }(n2), this._children = [], o2 && this._insertChild(0, o2), this._classes = /* @__PURE__ */ new Set(), this._attrs.has("class")) {
              const t4 = this._attrs.get("class");
              xa(this._classes, t4), this._attrs.delete("class");
            }
            this._styles = new Aa(this.document.stylesProcessor), this._attrs.has("style") && (this._styles.setTo(this._attrs.get("style")), this._attrs.delete("style"));
          }
          get childCount() {
            return this._children.length;
          }
          get isEmpty() {
            return 0 === this._children.length;
          }
          getChild(t3) {
            return this._children[t3];
          }
          getChildIndex(t3) {
            return this._children.indexOf(t3);
          }
          getChildren() {
            return this._children[Symbol.iterator]();
          }
          *getAttributeKeys() {
            this._classes.size > 0 && (yield "class"), this._styles.isEmpty || (yield "style"), yield* __yieldStar(this._attrs.keys());
          }
          *getAttributes() {
            yield* __yieldStar(this._attrs.entries()), this._classes.size > 0 && (yield ["class", this.getAttribute("class")]), this._styles.isEmpty || (yield ["style", this.getAttribute("style")]);
          }
          getAttribute(t3) {
            if ("class" == t3)
              return this._classes.size > 0 ? [...this._classes].join(" ") : void 0;
            if ("style" == t3) {
              const t4 = this._styles.toString();
              return "" == t4 ? void 0 : t4;
            }
            return this._attrs.get(t3);
          }
          hasAttribute(t3) {
            return "class" == t3 ? this._classes.size > 0 : "style" == t3 ? !this._styles.isEmpty : this._attrs.has(t3);
          }
          isSimilar(t3) {
            if (!(t3 instanceof ya))
              return false;
            if (this === t3)
              return true;
            if (this.name != t3.name)
              return false;
            if (this._attrs.size !== t3._attrs.size || this._classes.size !== t3._classes.size || this._styles.size !== t3._styles.size)
              return false;
            for (const [e3, n2] of this._attrs)
              if (!t3._attrs.has(e3) || t3._attrs.get(e3) !== n2)
                return false;
            for (const e3 of this._classes)
              if (!t3._classes.has(e3))
                return false;
            for (const e3 of this._styles.getStyleNames())
              if (!t3._styles.has(e3) || t3._styles.getAsString(e3) !== this._styles.getAsString(e3))
                return false;
            return true;
          }
          hasClass(...t3) {
            for (const e3 of t3)
              if (!this._classes.has(e3))
                return false;
            return true;
          }
          getClassNames() {
            return this._classes.keys();
          }
          getStyle(t3) {
            return this._styles.getAsString(t3);
          }
          getNormalizedStyle(t3) {
            return this._styles.getNormalized(t3);
          }
          getStyleNames(t3) {
            return this._styles.getStyleNames(t3);
          }
          hasStyle(...t3) {
            for (const e3 of t3)
              if (!this._styles.has(e3))
                return false;
            return true;
          }
          findAncestor(...t3) {
            const e3 = new ys(...t3);
            let n2 = this.parent;
            for (; n2 && !n2.is("documentFragment"); ) {
              if (e3.match(n2))
                return n2;
              n2 = n2.parent;
            }
            return null;
          }
          getCustomProperty(t3) {
            return this._customProperties.get(t3);
          }
          *getCustomProperties() {
            yield* __yieldStar(this._customProperties.entries());
          }
          getIdentity() {
            const t3 = Array.from(this._classes).sort().join(","), e3 = this._styles.toString(), n2 = Array.from(this._attrs).map((t4) => `${t4[0]}="${t4[1]}"`).sort().join(" ");
            return this.name + ("" == t3 ? "" : ` class="${t3}"`) + (e3 ? ` style="${e3}"` : "") + ("" == n2 ? "" : ` ${n2}`);
          }
          shouldRenderUnsafeAttribute(t3) {
            return this._unsafeAttributesToRender.includes(t3);
          }
          _clone(t3 = false) {
            const e3 = [];
            if (t3)
              for (const n3 of this.getChildren())
                e3.push(n3._clone(t3));
            const n2 = new this.constructor(this.document, this.name, this._attrs, e3);
            return n2._classes = new Set(this._classes), n2._styles.set(this._styles.getNormalized()), n2._customProperties = new Map(this._customProperties), n2.getFillerOffset = this.getFillerOffset, n2._unsafeAttributesToRender = this._unsafeAttributesToRender, n2;
          }
          _appendChild(t3) {
            return this._insertChild(this.childCount, t3);
          }
          _insertChild(t3, e3) {
            this._fireChange("children", this);
            let n2 = 0;
            const o2 = function(t4, e4) {
              if ("string" == typeof e4)
                return [new _s(t4, e4)];
              et(e4) || (e4 = [e4]);
              return Array.from(e4).map((e5) => "string" == typeof e5 ? new _s(t4, e5) : e5 instanceof vs ? new _s(t4, e5.data) : e5);
            }(this.document, e3);
            for (const e4 of o2)
              null !== e4.parent && e4._remove(), e4.parent = this, e4.document = this.document, this._children.splice(t3, 0, e4), t3++, n2++;
            return n2;
          }
          _removeChildren(t3, e3 = 1) {
            this._fireChange("children", this);
            for (let n2 = t3; n2 < t3 + e3; n2++)
              this._children[n2].parent = null;
            return this._children.splice(t3, e3);
          }
          _setAttribute(t3, e3) {
            const n2 = String(e3);
            this._fireChange("attributes", this), "class" == t3 ? xa(this._classes, n2) : "style" == t3 ? this._styles.setTo(n2) : this._attrs.set(t3, n2);
          }
          _removeAttribute(t3) {
            return this._fireChange("attributes", this), "class" == t3 ? this._classes.size > 0 && (this._classes.clear(), true) : "style" == t3 ? !this._styles.isEmpty && (this._styles.clear(), true) : this._attrs.delete(t3);
          }
          _addClass(t3) {
            this._fireChange("attributes", this);
            for (const e3 of _i(t3))
              this._classes.add(e3);
          }
          _removeClass(t3) {
            this._fireChange("attributes", this);
            for (const e3 of _i(t3))
              this._classes.delete(e3);
          }
          _setStyle(t3, e3) {
            this._fireChange("attributes", this), "string" != typeof t3 ? this._styles.set(t3) : this._styles.set(t3, e3);
          }
          _removeStyle(t3) {
            this._fireChange("attributes", this);
            for (const e3 of _i(t3))
              this._styles.remove(e3);
          }
          _setCustomProperty(t3, e3) {
            this._customProperties.set(t3, e3);
          }
          _removeCustomProperty(t3) {
            return this._customProperties.delete(t3);
          }
        }
        function xa(t3, e3) {
          const n2 = e3.split(/\s+/);
          t3.clear(), n2.forEach((e4) => t3.add(e4));
        }
        ya.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("element" === t3 || "view:element" === t3) : "element" === t3 || "view:element" === t3 || "node" === t3 || "view:node" === t3;
        };
        class Ea extends ya {
          constructor(t3, e3, n2, o2) {
            super(t3, e3, n2, o2), this.getFillerOffset = Da;
          }
        }
        function Da() {
          const t3 = [...this.getChildren()], e3 = t3[this.childCount - 1];
          if (e3 && e3.is("element", "br"))
            return this.childCount;
          for (const e4 of t3)
            if (!e4.is("uiElement"))
              return null;
          return this.childCount;
        }
        Ea.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("containerElement" === t3 || "view:containerElement" === t3 || "element" === t3 || "view:element" === t3) : "containerElement" === t3 || "view:containerElement" === t3 || "element" === t3 || "view:element" === t3 || "node" === t3 || "view:node" === t3;
        };
        class Ia extends W(Ea) {
          constructor(t3, e3, n2, o2) {
            super(t3, e3, n2, o2), this.set("isReadOnly", false), this.set("isFocused", false), this.set("placeholder", void 0), this.bind("isReadOnly").to(t3), this.bind("isFocused").to(t3, "isFocused", (e4) => e4 && t3.selection.editableElement == this), this.listenTo(t3.selection, "change", () => {
              this.isFocused = t3.isFocused && t3.selection.editableElement == this;
            });
          }
          destroy() {
            this.stopListening();
          }
        }
        Ia.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("editableElement" === t3 || "view:editableElement" === t3 || "containerElement" === t3 || "view:containerElement" === t3 || "element" === t3 || "view:element" === t3) : "editableElement" === t3 || "view:editableElement" === t3 || "containerElement" === t3 || "view:containerElement" === t3 || "element" === t3 || "view:element" === t3 || "node" === t3 || "view:node" === t3;
        };
        const Sa = Symbol("rootName");
        class Ta extends Ia {
          constructor(t3, e3) {
            super(t3, e3), this.rootName = "main";
          }
          get rootName() {
            return this.getCustomProperty(Sa);
          }
          set rootName(t3) {
            this._setCustomProperty(Sa, t3);
          }
          set _name(t3) {
            this.name = t3;
          }
        }
        Ta.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("rootElement" === t3 || "view:rootElement" === t3 || "editableElement" === t3 || "view:editableElement" === t3 || "containerElement" === t3 || "view:containerElement" === t3 || "element" === t3 || "view:element" === t3) : "rootElement" === t3 || "view:rootElement" === t3 || "editableElement" === t3 || "view:editableElement" === t3 || "containerElement" === t3 || "view:containerElement" === t3 || "element" === t3 || "view:element" === t3 || "node" === t3 || "view:node" === t3;
        };
        class Ma {
          constructor(t3 = {}) {
            if (!t3.boundaries && !t3.startPosition)
              throw new A("view-tree-walker-no-start-position", null);
            if (t3.direction && "forward" != t3.direction && "backward" != t3.direction)
              throw new A("view-tree-walker-unknown-direction", t3.startPosition, { direction: t3.direction });
            this.boundaries = t3.boundaries || null, t3.startPosition ? this._position = Ba._createAt(t3.startPosition) : this._position = Ba._createAt(t3.boundaries["backward" == t3.direction ? "end" : "start"]), this.direction = t3.direction || "forward", this.singleCharacters = !!t3.singleCharacters, this.shallow = !!t3.shallow, this.ignoreElementEnd = !!t3.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null;
          }
          [Symbol.iterator]() {
            return this;
          }
          get position() {
            return this._position;
          }
          skip(t3) {
            let e3, n2;
            do {
              n2 = this.position, e3 = this.next();
            } while (!e3.done && t3(e3.value));
            e3.done || (this._position = n2);
          }
          next() {
            return "forward" == this.direction ? this._next() : this._previous();
          }
          _next() {
            let t3 = this.position.clone();
            const e3 = this.position, n2 = t3.parent;
            if (null === n2.parent && t3.offset === n2.childCount)
              return { done: true, value: void 0 };
            if (n2 === this._boundaryEndParent && t3.offset == this.boundaries.end.offset)
              return { done: true, value: void 0 };
            let o2;
            if (n2 instanceof _s) {
              if (t3.isAtEnd)
                return this._position = Ba._createAfter(n2), this._next();
              o2 = n2.data[t3.offset];
            } else
              o2 = n2.getChild(t3.offset);
            if (o2 instanceof ya) {
              if (this.shallow) {
                if (this.boundaries && this.boundaries.end.isBefore(t3))
                  return { done: true, value: void 0 };
                t3.offset++;
              } else
                t3 = new Ba(o2, 0);
              return this._position = t3, this._formatReturnValue("elementStart", o2, e3, t3, 1);
            }
            if (o2 instanceof _s) {
              if (this.singleCharacters)
                return t3 = new Ba(o2, 0), this._position = t3, this._next();
              let n3, i2 = o2.data.length;
              return o2 == this._boundaryEndParent ? (i2 = this.boundaries.end.offset, n3 = new vs(o2, 0, i2), t3 = Ba._createAfter(n3)) : (n3 = new vs(o2, 0, o2.data.length), t3.offset++), this._position = t3, this._formatReturnValue("text", n3, e3, t3, i2);
            }
            if ("string" == typeof o2) {
              let o3;
              if (this.singleCharacters)
                o3 = 1;
              else {
                o3 = (n2 === this._boundaryEndParent ? this.boundaries.end.offset : n2.data.length) - t3.offset;
              }
              const i2 = new vs(n2, t3.offset, o3);
              return t3.offset += o3, this._position = t3, this._formatReturnValue("text", i2, e3, t3, o3);
            }
            return t3 = Ba._createAfter(n2), this._position = t3, this.ignoreElementEnd ? this._next() : this._formatReturnValue("elementEnd", n2, e3, t3);
          }
          _previous() {
            let t3 = this.position.clone();
            const e3 = this.position, n2 = t3.parent;
            if (null === n2.parent && 0 === t3.offset)
              return { done: true, value: void 0 };
            if (n2 == this._boundaryStartParent && t3.offset == this.boundaries.start.offset)
              return { done: true, value: void 0 };
            let o2;
            if (n2 instanceof _s) {
              if (t3.isAtStart)
                return this._position = Ba._createBefore(n2), this._previous();
              o2 = n2.data[t3.offset - 1];
            } else
              o2 = n2.getChild(t3.offset - 1);
            if (o2 instanceof ya)
              return this.shallow ? (t3.offset--, this._position = t3, this._formatReturnValue("elementStart", o2, e3, t3, 1)) : (t3 = new Ba(o2, o2.childCount), this._position = t3, this.ignoreElementEnd ? this._previous() : this._formatReturnValue("elementEnd", o2, e3, t3));
            if (o2 instanceof _s) {
              if (this.singleCharacters)
                return t3 = new Ba(o2, o2.data.length), this._position = t3, this._previous();
              let n3, i2 = o2.data.length;
              if (o2 == this._boundaryStartParent) {
                const e4 = this.boundaries.start.offset;
                n3 = new vs(o2, e4, o2.data.length - e4), i2 = n3.data.length, t3 = Ba._createBefore(n3);
              } else
                n3 = new vs(o2, 0, o2.data.length), t3.offset--;
              return this._position = t3, this._formatReturnValue("text", n3, e3, t3, i2);
            }
            if ("string" == typeof o2) {
              let o3;
              if (this.singleCharacters)
                o3 = 1;
              else {
                const e4 = n2 === this._boundaryStartParent ? this.boundaries.start.offset : 0;
                o3 = t3.offset - e4;
              }
              t3.offset -= o3;
              const i2 = new vs(n2, t3.offset, o3);
              return this._position = t3, this._formatReturnValue("text", i2, e3, t3, o3);
            }
            return t3 = Ba._createBefore(n2), this._position = t3, this._formatReturnValue("elementStart", n2, e3, t3, 1);
          }
          _formatReturnValue(t3, e3, n2, o2, i2) {
            return e3 instanceof vs && (e3.offsetInText + e3.data.length == e3.textNode.data.length && ("forward" != this.direction || this.boundaries && this.boundaries.end.isEqual(this.position) ? n2 = Ba._createAfter(e3.textNode) : (o2 = Ba._createAfter(e3.textNode), this._position = o2)), 0 === e3.offsetInText && ("backward" != this.direction || this.boundaries && this.boundaries.start.isEqual(this.position) ? n2 = Ba._createBefore(e3.textNode) : (o2 = Ba._createBefore(e3.textNode), this._position = o2))), { done: false, value: { type: t3, item: e3, previousPosition: n2, nextPosition: o2, length: i2 } };
          }
        }
        class Ba extends ws {
          constructor(t3, e3) {
            super(), this.parent = t3, this.offset = e3;
          }
          get nodeAfter() {
            return this.parent.is("$text") ? null : this.parent.getChild(this.offset) || null;
          }
          get nodeBefore() {
            return this.parent.is("$text") ? null : this.parent.getChild(this.offset - 1) || null;
          }
          get isAtStart() {
            return 0 === this.offset;
          }
          get isAtEnd() {
            const t3 = this.parent.is("$text") ? this.parent.data.length : this.parent.childCount;
            return this.offset === t3;
          }
          get root() {
            return this.parent.root;
          }
          get editableElement() {
            let t3 = this.parent;
            for (; !(t3 instanceof Ia); ) {
              if (!t3.parent)
                return null;
              t3 = t3.parent;
            }
            return t3;
          }
          getShiftedBy(t3) {
            const e3 = Ba._createAt(this), n2 = e3.offset + t3;
            return e3.offset = n2 < 0 ? 0 : n2, e3;
          }
          getLastMatchingPosition(t3, e3 = {}) {
            e3.startPosition = this;
            const n2 = new Ma(e3);
            return n2.skip(t3), n2.position;
          }
          getAncestors() {
            return this.parent.is("documentFragment") ? [this.parent] : this.parent.getAncestors({ includeSelf: true });
          }
          getCommonAncestor(t3) {
            const e3 = this.getAncestors(), n2 = t3.getAncestors();
            let o2 = 0;
            for (; e3[o2] == n2[o2] && e3[o2]; )
              o2++;
            return 0 === o2 ? null : e3[o2 - 1];
          }
          isEqual(t3) {
            return this.parent == t3.parent && this.offset == t3.offset;
          }
          isBefore(t3) {
            return "before" == this.compareWith(t3);
          }
          isAfter(t3) {
            return "after" == this.compareWith(t3);
          }
          compareWith(t3) {
            if (this.root !== t3.root)
              return "different";
            if (this.isEqual(t3))
              return "same";
            const e3 = this.parent.is("node") ? this.parent.getPath() : [], n2 = t3.parent.is("node") ? t3.parent.getPath() : [];
            e3.push(this.offset), n2.push(t3.offset);
            const o2 = tt(e3, n2);
            switch (o2) {
              case "prefix":
                return "before";
              case "extension":
                return "after";
              default:
                return e3[o2] < n2[o2] ? "before" : "after";
            }
          }
          getWalker(t3 = {}) {
            return t3.startPosition = this, new Ma(t3);
          }
          clone() {
            return new Ba(this.parent, this.offset);
          }
          static _createAt(t3, e3) {
            if (t3 instanceof Ba)
              return new this(t3.parent, t3.offset);
            {
              const n2 = t3;
              if ("end" == e3)
                e3 = n2.is("$text") ? n2.data.length : n2.childCount;
              else {
                if ("before" == e3)
                  return this._createBefore(n2);
                if ("after" == e3)
                  return this._createAfter(n2);
                if (0 !== e3 && !e3)
                  throw new A("view-createpositionat-offset-required", n2);
              }
              return new Ba(n2, e3);
            }
          }
          static _createAfter(t3) {
            if (t3.is("$textProxy"))
              return new Ba(t3.textNode, t3.offsetInText + t3.data.length);
            if (!t3.parent)
              throw new A("view-position-after-root", t3, { root: t3 });
            return new Ba(t3.parent, t3.index + 1);
          }
          static _createBefore(t3) {
            if (t3.is("$textProxy"))
              return new Ba(t3.textNode, t3.offsetInText);
            if (!t3.parent)
              throw new A("view-position-before-root", t3, { root: t3 });
            return new Ba(t3.parent, t3.index);
          }
        }
        Ba.prototype.is = function(t3) {
          return "position" === t3 || "view:position" === t3;
        };
        class Na extends ws {
          constructor(t3, e3 = null) {
            super(), this.start = t3.clone(), this.end = e3 ? e3.clone() : t3.clone();
          }
          *[Symbol.iterator]() {
            yield* __yieldStar(new Ma({ boundaries: this, ignoreElementEnd: true }));
          }
          get isCollapsed() {
            return this.start.isEqual(this.end);
          }
          get isFlat() {
            return this.start.parent === this.end.parent;
          }
          get root() {
            return this.start.root;
          }
          getEnlarged() {
            let t3 = this.start.getLastMatchingPosition(Pa, { direction: "backward" }), e3 = this.end.getLastMatchingPosition(Pa);
            return t3.parent.is("$text") && t3.isAtStart && (t3 = Ba._createBefore(t3.parent)), e3.parent.is("$text") && e3.isAtEnd && (e3 = Ba._createAfter(e3.parent)), new Na(t3, e3);
          }
          getTrimmed() {
            let t3 = this.start.getLastMatchingPosition(Pa);
            if (t3.isAfter(this.end) || t3.isEqual(this.end))
              return new Na(t3, t3);
            let e3 = this.end.getLastMatchingPosition(Pa, { direction: "backward" });
            const n2 = t3.nodeAfter, o2 = e3.nodeBefore;
            return n2 && n2.is("$text") && (t3 = new Ba(n2, 0)), o2 && o2.is("$text") && (e3 = new Ba(o2, o2.data.length)), new Na(t3, e3);
          }
          isEqual(t3) {
            return this == t3 || this.start.isEqual(t3.start) && this.end.isEqual(t3.end);
          }
          containsPosition(t3) {
            return t3.isAfter(this.start) && t3.isBefore(this.end);
          }
          containsRange(t3, e3 = false) {
            t3.isCollapsed && (e3 = false);
            const n2 = this.containsPosition(t3.start) || e3 && this.start.isEqual(t3.start), o2 = this.containsPosition(t3.end) || e3 && this.end.isEqual(t3.end);
            return n2 && o2;
          }
          getDifference(t3) {
            const e3 = [];
            return this.isIntersecting(t3) ? (this.containsPosition(t3.start) && e3.push(new Na(this.start, t3.start)), this.containsPosition(t3.end) && e3.push(new Na(t3.end, this.end))) : e3.push(this.clone()), e3;
          }
          getIntersection(t3) {
            if (this.isIntersecting(t3)) {
              let e3 = this.start, n2 = this.end;
              return this.containsPosition(t3.start) && (e3 = t3.start), this.containsPosition(t3.end) && (n2 = t3.end), new Na(e3, n2);
            }
            return null;
          }
          getWalker(t3 = {}) {
            return t3.boundaries = this, new Ma(t3);
          }
          getCommonAncestor() {
            return this.start.getCommonAncestor(this.end);
          }
          getContainedElement() {
            if (this.isCollapsed)
              return null;
            let t3 = this.start.nodeAfter, e3 = this.end.nodeBefore;
            return this.start.parent.is("$text") && this.start.isAtEnd && this.start.parent.nextSibling && (t3 = this.start.parent.nextSibling), this.end.parent.is("$text") && this.end.isAtStart && this.end.parent.previousSibling && (e3 = this.end.parent.previousSibling), t3 && t3.is("element") && t3 === e3 ? t3 : null;
          }
          clone() {
            return new Na(this.start, this.end);
          }
          *getItems(t3 = {}) {
            t3.boundaries = this, t3.ignoreElementEnd = true;
            const e3 = new Ma(t3);
            for (const t4 of e3)
              yield t4.item;
          }
          *getPositions(t3 = {}) {
            t3.boundaries = this;
            const e3 = new Ma(t3);
            yield e3.position;
            for (const t4 of e3)
              yield t4.nextPosition;
          }
          isIntersecting(t3) {
            return this.start.isBefore(t3.end) && this.end.isAfter(t3.start);
          }
          static _createFromParentsAndOffsets(t3, e3, n2, o2) {
            return new this(new Ba(t3, e3), new Ba(n2, o2));
          }
          static _createFromPositionAndShift(t3, e3) {
            const n2 = t3, o2 = t3.getShiftedBy(e3);
            return e3 > 0 ? new this(n2, o2) : new this(o2, n2);
          }
          static _createIn(t3) {
            return this._createFromParentsAndOffsets(t3, 0, t3, t3.childCount);
          }
          static _createOn(t3) {
            const e3 = t3.is("$textProxy") ? t3.offsetSize : 1;
            return this._createFromPositionAndShift(Ba._createBefore(t3), e3);
          }
        }
        function Pa(t3) {
          return !(!t3.item.is("attributeElement") && !t3.item.is("uiElement"));
        }
        Na.prototype.is = function(t3) {
          return "range" === t3 || "view:range" === t3;
        };
        class za extends M(ws) {
          constructor(...t3) {
            super(), this._ranges = [], this._lastRangeBackward = false, this._isFake = false, this._fakeSelectionLabel = "", t3.length && this.setTo(...t3);
          }
          get isFake() {
            return this._isFake;
          }
          get fakeSelectionLabel() {
            return this._fakeSelectionLabel;
          }
          get anchor() {
            if (!this._ranges.length)
              return null;
            const t3 = this._ranges[this._ranges.length - 1];
            return (this._lastRangeBackward ? t3.end : t3.start).clone();
          }
          get focus() {
            if (!this._ranges.length)
              return null;
            const t3 = this._ranges[this._ranges.length - 1];
            return (this._lastRangeBackward ? t3.start : t3.end).clone();
          }
          get isCollapsed() {
            return 1 === this.rangeCount && this._ranges[0].isCollapsed;
          }
          get rangeCount() {
            return this._ranges.length;
          }
          get isBackward() {
            return !this.isCollapsed && this._lastRangeBackward;
          }
          get editableElement() {
            return this.anchor ? this.anchor.editableElement : null;
          }
          *getRanges() {
            for (const t3 of this._ranges)
              yield t3.clone();
          }
          getFirstRange() {
            let t3 = null;
            for (const e3 of this._ranges)
              t3 && !e3.start.isBefore(t3.start) || (t3 = e3);
            return t3 ? t3.clone() : null;
          }
          getLastRange() {
            let t3 = null;
            for (const e3 of this._ranges)
              t3 && !e3.end.isAfter(t3.end) || (t3 = e3);
            return t3 ? t3.clone() : null;
          }
          getFirstPosition() {
            const t3 = this.getFirstRange();
            return t3 ? t3.start.clone() : null;
          }
          getLastPosition() {
            const t3 = this.getLastRange();
            return t3 ? t3.end.clone() : null;
          }
          isEqual(t3) {
            if (this.isFake != t3.isFake)
              return false;
            if (this.isFake && this.fakeSelectionLabel != t3.fakeSelectionLabel)
              return false;
            if (this.rangeCount != t3.rangeCount)
              return false;
            if (0 === this.rangeCount)
              return true;
            if (!this.anchor.isEqual(t3.anchor) || !this.focus.isEqual(t3.focus))
              return false;
            for (const e3 of this._ranges) {
              let n2 = false;
              for (const o2 of t3._ranges)
                if (e3.isEqual(o2)) {
                  n2 = true;
                  break;
                }
              if (!n2)
                return false;
            }
            return true;
          }
          isSimilar(t3) {
            if (this.isBackward != t3.isBackward)
              return false;
            const e3 = X(this.getRanges());
            if (e3 != X(t3.getRanges()))
              return false;
            if (0 == e3)
              return true;
            for (let e4 of this.getRanges()) {
              e4 = e4.getTrimmed();
              let n2 = false;
              for (let o2 of t3.getRanges())
                if (o2 = o2.getTrimmed(), e4.start.isEqual(o2.start) && e4.end.isEqual(o2.end)) {
                  n2 = true;
                  break;
                }
              if (!n2)
                return false;
            }
            return true;
          }
          getSelectedElement() {
            return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
          }
          setTo(...t3) {
            let [e3, n2, o2] = t3;
            if ("object" == typeof n2 && (o2 = n2, n2 = void 0), null === e3)
              this._setRanges([]), this._setFakeOptions(o2);
            else if (e3 instanceof za || e3 instanceof Oa)
              this._setRanges(e3.getRanges(), e3.isBackward), this._setFakeOptions({ fake: e3.isFake, label: e3.fakeSelectionLabel });
            else if (e3 instanceof Na)
              this._setRanges([e3], o2 && o2.backward), this._setFakeOptions(o2);
            else if (e3 instanceof Ba)
              this._setRanges([new Na(e3)]), this._setFakeOptions(o2);
            else if (e3 instanceof Cs) {
              const t4 = !!o2 && !!o2.backward;
              let i2;
              if (void 0 === n2)
                throw new A("view-selection-setto-required-second-parameter", this);
              i2 = "in" == n2 ? Na._createIn(e3) : "on" == n2 ? Na._createOn(e3) : new Na(Ba._createAt(e3, n2)), this._setRanges([i2], t4), this._setFakeOptions(o2);
            } else {
              if (!et(e3))
                throw new A("view-selection-setto-not-selectable", this);
              this._setRanges(e3, o2 && o2.backward), this._setFakeOptions(o2);
            }
            this.fire("change");
          }
          setFocus(t3, e3) {
            if (null === this.anchor)
              throw new A("view-selection-setfocus-no-ranges", this);
            const n2 = Ba._createAt(t3, e3);
            if ("same" == n2.compareWith(this.focus))
              return;
            const o2 = this.anchor;
            this._ranges.pop(), "before" == n2.compareWith(o2) ? this._addRange(new Na(n2, o2), true) : this._addRange(new Na(o2, n2)), this.fire("change");
          }
          _setRanges(t3, e3 = false) {
            t3 = Array.from(t3), this._ranges = [];
            for (const e4 of t3)
              this._addRange(e4);
            this._lastRangeBackward = !!e3;
          }
          _setFakeOptions(t3 = {}) {
            this._isFake = !!t3.fake, this._fakeSelectionLabel = t3.fake && t3.label || "";
          }
          _addRange(t3, e3 = false) {
            if (!(t3 instanceof Na))
              throw new A("view-selection-add-range-not-range", this);
            this._pushRange(t3), this._lastRangeBackward = !!e3;
          }
          _pushRange(t3) {
            for (const e3 of this._ranges)
              if (t3.isIntersecting(e3))
                throw new A("view-selection-range-intersects", this, { addedRange: t3, intersectingRange: e3 });
            this._ranges.push(new Na(t3.start, t3.end));
          }
        }
        za.prototype.is = function(t3) {
          return "selection" === t3 || "view:selection" === t3;
        };
        class Oa extends M(ws) {
          constructor(...t3) {
            super(), this._selection = new za(), this._selection.delegate("change").to(this), t3.length && this._selection.setTo(...t3);
          }
          get isFake() {
            return this._selection.isFake;
          }
          get fakeSelectionLabel() {
            return this._selection.fakeSelectionLabel;
          }
          get anchor() {
            return this._selection.anchor;
          }
          get focus() {
            return this._selection.focus;
          }
          get isCollapsed() {
            return this._selection.isCollapsed;
          }
          get rangeCount() {
            return this._selection.rangeCount;
          }
          get isBackward() {
            return this._selection.isBackward;
          }
          get editableElement() {
            return this._selection.editableElement;
          }
          get _ranges() {
            return this._selection._ranges;
          }
          *getRanges() {
            yield* __yieldStar(this._selection.getRanges());
          }
          getFirstRange() {
            return this._selection.getFirstRange();
          }
          getLastRange() {
            return this._selection.getLastRange();
          }
          getFirstPosition() {
            return this._selection.getFirstPosition();
          }
          getLastPosition() {
            return this._selection.getLastPosition();
          }
          getSelectedElement() {
            return this._selection.getSelectedElement();
          }
          isEqual(t3) {
            return this._selection.isEqual(t3);
          }
          isSimilar(t3) {
            return this._selection.isSimilar(t3);
          }
          _setTo(...t3) {
            this._selection.setTo(...t3);
          }
          _setFocus(t3, e3) {
            this._selection.setFocus(t3, e3);
          }
        }
        Oa.prototype.is = function(t3) {
          return "selection" === t3 || "documentSelection" == t3 || "view:selection" == t3 || "view:documentSelection" == t3;
        };
        class La extends p {
          constructor(t3, e3, n2) {
            super(t3, e3), this.startRange = n2, this._eventPhase = "none", this._currentTarget = null;
          }
          get eventPhase() {
            return this._eventPhase;
          }
          get currentTarget() {
            return this._currentTarget;
          }
        }
        const Ra = Symbol("bubbling contexts");
        function ja(t3) {
          return class extends t3 {
            fire(t4, ...e3) {
              try {
                const n2 = t4 instanceof p ? t4 : new p(this, t4), o2 = Ha(this);
                if (!o2.size)
                  return;
                if (Fa(n2, "capturing", this), Va(o2, "$capture", n2, ...e3))
                  return n2.return;
                const i2 = n2.startRange || this.selection.getFirstRange(), r2 = i2 ? i2.getContainedElement() : null, s3 = !!r2 && Boolean(Ua(o2, r2));
                let a2 = r2 || function(t5) {
                  if (!t5)
                    return null;
                  const e4 = t5.start.parent, n3 = t5.end.parent, o3 = e4.getPath(), i3 = n3.getPath();
                  return o3.length > i3.length ? e4 : n3;
                }(i2);
                if (Fa(n2, "atTarget", a2), !s3) {
                  if (Va(o2, "$text", n2, ...e3))
                    return n2.return;
                  Fa(n2, "bubbling", a2);
                }
                for (; a2; ) {
                  if (a2.is("rootElement")) {
                    if (Va(o2, "$root", n2, ...e3))
                      return n2.return;
                  } else if (a2.is("element") && Va(o2, a2.name, n2, ...e3))
                    return n2.return;
                  if (Va(o2, a2, n2, ...e3))
                    return n2.return;
                  a2 = a2.parent, Fa(n2, "bubbling", a2);
                }
                return Fa(n2, "bubbling", this), Va(o2, "$document", n2, ...e3), n2.return;
              } catch (t5) {
                A.rethrowUnexpectedError(t5, this);
              }
            }
            _addEventListener(t4, e3, n2) {
              const o2 = _i(n2.context || "$document"), i2 = Ha(this);
              for (const r2 of o2) {
                let o3 = i2.get(r2);
                o3 || (o3 = new (M())(), i2.set(r2, o3)), this.listenTo(o3, t4, e3, n2);
              }
            }
            _removeEventListener(t4, e3) {
              const n2 = Ha(this);
              for (const o2 of n2.values())
                this.stopListening(o2, t4, e3);
            }
          };
        }
        {
          const t3 = ja(Object);
          ["fire", "_addEventListener", "_removeEventListener"].forEach((e3) => {
            ja[e3] = t3.prototype[e3];
          });
        }
        function Fa(t3, e3, n2) {
          t3 instanceof La && (t3._eventPhase = e3, t3._currentTarget = n2);
        }
        function Va(t3, e3, n2, ...o2) {
          const i2 = "string" == typeof e3 ? t3.get(e3) : Ua(t3, e3);
          return !!i2 && (i2.fire(n2, ...o2), n2.stop.called);
        }
        function Ua(t3, e3) {
          for (const [n2, o2] of t3)
            if ("function" == typeof n2 && n2(e3))
              return o2;
          return null;
        }
        function Ha(t3) {
          return t3[Ra] || (t3[Ra] = /* @__PURE__ */ new Map()), t3[Ra];
        }
        class qa extends ja(W()) {
          constructor(t3) {
            super(), this._postFixers = /* @__PURE__ */ new Set(), this.selection = new Oa(), this.roots = new Di({ idProperty: "rootName" }), this.stylesProcessor = t3, this.set("isReadOnly", false), this.set("isFocused", false), this.set("isSelecting", false), this.set("isComposing", false);
          }
          getRoot(t3 = "main") {
            return this.roots.get(t3);
          }
          registerPostFixer(t3) {
            this._postFixers.add(t3);
          }
          destroy() {
            this.roots.forEach((t3) => t3.destroy()), this.stopListening();
          }
          _callPostFixers(t3) {
            let e3 = false;
            do {
              for (const n2 of this._postFixers)
                if (e3 = n2(t3), e3)
                  break;
            } while (e3);
          }
        }
        class Ga extends ya {
          constructor(t3, e3, n2, o2) {
            super(t3, e3, n2, o2), this._priority = 10, this._id = null, this._clonesGroup = null, this.getFillerOffset = Wa;
          }
          get priority() {
            return this._priority;
          }
          get id() {
            return this._id;
          }
          getElementsWithSameId() {
            if (null === this.id)
              throw new A("attribute-element-get-elements-with-same-id-no-id", this);
            return new Set(this._clonesGroup);
          }
          isSimilar(t3) {
            return null !== this.id || null !== t3.id ? this.id === t3.id : super.isSimilar(t3) && this.priority == t3.priority;
          }
          _clone(t3 = false) {
            const e3 = super._clone(t3);
            return e3._priority = this._priority, e3._id = this._id, e3;
          }
        }
        function Wa() {
          if (Ka(this))
            return null;
          let t3 = this.parent;
          for (; t3 && t3.is("attributeElement"); ) {
            if (Ka(t3) > 1)
              return null;
            t3 = t3.parent;
          }
          return !t3 || Ka(t3) > 1 ? null : this.childCount;
        }
        function Ka(t3) {
          return Array.from(t3.getChildren()).filter((t4) => !t4.is("uiElement")).length;
        }
        Ga.DEFAULT_PRIORITY = 10, Ga.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("attributeElement" === t3 || "view:attributeElement" === t3 || "element" === t3 || "view:element" === t3) : "attributeElement" === t3 || "view:attributeElement" === t3 || "element" === t3 || "view:element" === t3 || "node" === t3 || "view:node" === t3;
        };
        class Za extends ya {
          constructor(t3, e3, n2, o2) {
            super(t3, e3, n2, o2), this.getFillerOffset = Ya;
          }
          _insertChild(t3, e3) {
            if (e3 && (e3 instanceof Cs || Array.from(e3).length > 0))
              throw new A("view-emptyelement-cannot-add", [this, e3]);
            return 0;
          }
        }
        function Ya() {
          return null;
        }
        Za.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("emptyElement" === t3 || "view:emptyElement" === t3 || "element" === t3 || "view:element" === t3) : "emptyElement" === t3 || "view:emptyElement" === t3 || "element" === t3 || "view:element" === t3 || "node" === t3 || "view:node" === t3;
        };
        class $a extends ya {
          constructor(t3, e3, n2, o2) {
            super(t3, e3, n2, o2), this.getFillerOffset = Ja;
          }
          _insertChild(t3, e3) {
            if (e3 && (e3 instanceof Cs || Array.from(e3).length > 0))
              throw new A("view-uielement-cannot-add", [this, e3]);
            return 0;
          }
          render(t3, e3) {
            return this.toDomElement(t3);
          }
          toDomElement(t3) {
            const e3 = t3.createElement(this.name);
            for (const t4 of this.getAttributeKeys())
              e3.setAttribute(t4, this.getAttribute(t4));
            return e3;
          }
        }
        function Qa(t3) {
          t3.document.on("arrowKey", (e3, n2) => function(t4, e4, n3) {
            if (e4.keyCode == fi.arrowright) {
              const t5 = e4.domTarget.ownerDocument.defaultView.getSelection(), o2 = 1 == t5.rangeCount && t5.getRangeAt(0).collapsed;
              if (o2 || e4.shiftKey) {
                const e5 = t5.focusNode, i2 = t5.focusOffset, r2 = n3.domPositionToView(e5, i2);
                if (null === r2)
                  return;
                let s3 = false;
                const a2 = r2.getLastMatchingPosition((t6) => (t6.item.is("uiElement") && (s3 = true), !(!t6.item.is("uiElement") && !t6.item.is("attributeElement"))));
                if (s3) {
                  const e6 = n3.viewPositionToDom(a2);
                  o2 ? t5.collapse(e6.parent, e6.offset) : t5.extend(e6.parent, e6.offset);
                }
              }
            }
          }(0, n2, t3.domConverter), { priority: "low" });
        }
        function Ja() {
          return null;
        }
        $a.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("uiElement" === t3 || "view:uiElement" === t3 || "element" === t3 || "view:element" === t3) : "uiElement" === t3 || "view:uiElement" === t3 || "element" === t3 || "view:element" === t3 || "node" === t3 || "view:node" === t3;
        };
        class Xa extends ya {
          constructor(t3, e3, n2, o2) {
            super(t3, e3, n2, o2), this.getFillerOffset = tc;
          }
          _insertChild(t3, e3) {
            if (e3 && (e3 instanceof Cs || Array.from(e3).length > 0))
              throw new A("view-rawelement-cannot-add", [this, e3]);
            return 0;
          }
          render(t3, e3) {
          }
        }
        function tc() {
          return null;
        }
        Xa.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("rawElement" === t3 || "view:rawElement" === t3 || "element" === t3 || "view:element" === t3) : "rawElement" === t3 || "view:rawElement" === t3 || t3 === this.name || t3 === "view:" + this.name || "element" === t3 || "view:element" === t3 || "node" === t3 || "view:node" === t3;
        };
        class ec extends M(ws) {
          constructor(t3, e3) {
            super(), this._children = [], this._customProperties = /* @__PURE__ */ new Map(), this.document = t3, e3 && this._insertChild(0, e3);
          }
          [Symbol.iterator]() {
            return this._children[Symbol.iterator]();
          }
          get childCount() {
            return this._children.length;
          }
          get isEmpty() {
            return 0 === this.childCount;
          }
          get root() {
            return this;
          }
          get parent() {
            return null;
          }
          get name() {
          }
          get getFillerOffset() {
          }
          getCustomProperty(t3) {
            return this._customProperties.get(t3);
          }
          *getCustomProperties() {
            yield* __yieldStar(this._customProperties.entries());
          }
          _appendChild(t3) {
            return this._insertChild(this.childCount, t3);
          }
          getChild(t3) {
            return this._children[t3];
          }
          getChildIndex(t3) {
            return this._children.indexOf(t3);
          }
          getChildren() {
            return this._children[Symbol.iterator]();
          }
          _insertChild(t3, e3) {
            this._fireChange("children", this);
            let n2 = 0;
            const o2 = function(t4, e4) {
              if ("string" == typeof e4)
                return [new _s(t4, e4)];
              et(e4) || (e4 = [e4]);
              return Array.from(e4).map((e5) => "string" == typeof e5 ? new _s(t4, e5) : e5 instanceof vs ? new _s(t4, e5.data) : e5);
            }(this.document, e3);
            for (const e4 of o2)
              null !== e4.parent && e4._remove(), e4.parent = this, this._children.splice(t3, 0, e4), t3++, n2++;
            return n2;
          }
          _removeChildren(t3, e3 = 1) {
            this._fireChange("children", this);
            for (let n2 = t3; n2 < t3 + e3; n2++)
              this._children[n2].parent = null;
            return this._children.splice(t3, e3);
          }
          _fireChange(t3, e3) {
            this.fire("change:" + t3, e3);
          }
          _setCustomProperty(t3, e3) {
            this._customProperties.set(t3, e3);
          }
          _removeCustomProperty(t3) {
            return this._customProperties.delete(t3);
          }
        }
        ec.prototype.is = function(t3) {
          return "documentFragment" === t3 || "view:documentFragment" === t3;
        };
        class nc {
          constructor(t3) {
            this._cloneGroups = /* @__PURE__ */ new Map(), this._slotFactory = null, this.document = t3;
          }
          setSelection(...t3) {
            this.document.selection._setTo(...t3);
          }
          setSelectionFocus(t3, e3) {
            this.document.selection._setFocus(t3, e3);
          }
          createDocumentFragment(t3) {
            return new ec(this.document, t3);
          }
          createText(t3) {
            return new _s(this.document, t3);
          }
          createAttributeElement(t3, e3, n2 = {}) {
            const o2 = new Ga(this.document, t3, e3);
            return "number" == typeof n2.priority && (o2._priority = n2.priority), n2.id && (o2._id = n2.id), n2.renderUnsafeAttributes && o2._unsafeAttributesToRender.push(...n2.renderUnsafeAttributes), o2;
          }
          createContainerElement(t3, e3, n2 = {}, o2 = {}) {
            let i2 = null;
            Et(n2) ? o2 = n2 : i2 = n2;
            const r2 = new Ea(this.document, t3, e3, i2);
            return o2.renderUnsafeAttributes && r2._unsafeAttributesToRender.push(...o2.renderUnsafeAttributes), r2;
          }
          createEditableElement(t3, e3, n2 = {}) {
            const o2 = new Ia(this.document, t3, e3);
            return n2.renderUnsafeAttributes && o2._unsafeAttributesToRender.push(...n2.renderUnsafeAttributes), o2;
          }
          createEmptyElement(t3, e3, n2 = {}) {
            const o2 = new Za(this.document, t3, e3);
            return n2.renderUnsafeAttributes && o2._unsafeAttributesToRender.push(...n2.renderUnsafeAttributes), o2;
          }
          createUIElement(t3, e3, n2) {
            const o2 = new $a(this.document, t3, e3);
            return n2 && (o2.render = n2), o2;
          }
          createRawElement(t3, e3, n2, o2 = {}) {
            const i2 = new Xa(this.document, t3, e3);
            return n2 && (i2.render = n2), o2.renderUnsafeAttributes && i2._unsafeAttributesToRender.push(...o2.renderUnsafeAttributes), i2;
          }
          setAttribute(t3, e3, n2) {
            n2._setAttribute(t3, e3);
          }
          removeAttribute(t3, e3) {
            e3._removeAttribute(t3);
          }
          addClass(t3, e3) {
            e3._addClass(t3);
          }
          removeClass(t3, e3) {
            e3._removeClass(t3);
          }
          setStyle(t3, e3, n2) {
            Et(t3) && void 0 === n2 ? e3._setStyle(t3) : n2._setStyle(t3, e3);
          }
          removeStyle(t3, e3) {
            e3._removeStyle(t3);
          }
          setCustomProperty(t3, e3, n2) {
            n2._setCustomProperty(t3, e3);
          }
          removeCustomProperty(t3, e3) {
            return e3._removeCustomProperty(t3);
          }
          breakAttributes(t3) {
            return t3 instanceof Ba ? this._breakAttributes(t3) : this._breakAttributesRange(t3);
          }
          breakContainer(t3) {
            const e3 = t3.parent;
            if (!e3.is("containerElement"))
              throw new A("view-writer-break-non-container-element", this.document);
            if (!e3.parent)
              throw new A("view-writer-break-root", this.document);
            if (t3.isAtStart)
              return Ba._createBefore(e3);
            if (!t3.isAtEnd) {
              const n2 = e3._clone(false);
              this.insert(Ba._createAfter(e3), n2);
              const o2 = new Na(t3, Ba._createAt(e3, "end")), i2 = new Ba(n2, 0);
              this.move(o2, i2);
            }
            return Ba._createAfter(e3);
          }
          mergeAttributes(t3) {
            const e3 = t3.offset, n2 = t3.parent;
            if (n2.is("$text"))
              return t3;
            if (n2.is("attributeElement") && 0 === n2.childCount) {
              const t4 = n2.parent, e4 = n2.index;
              return n2._remove(), this._removeFromClonedElementsGroup(n2), this.mergeAttributes(new Ba(t4, e4));
            }
            const o2 = n2.getChild(e3 - 1), i2 = n2.getChild(e3);
            if (!o2 || !i2)
              return t3;
            if (o2.is("$text") && i2.is("$text"))
              return ac(o2, i2);
            if (o2.is("attributeElement") && i2.is("attributeElement") && o2.isSimilar(i2)) {
              const t4 = o2.childCount;
              return o2._appendChild(i2.getChildren()), i2._remove(), this._removeFromClonedElementsGroup(i2), this.mergeAttributes(new Ba(o2, t4));
            }
            return t3;
          }
          mergeContainers(t3) {
            const e3 = t3.nodeBefore, n2 = t3.nodeAfter;
            if (!(e3 && n2 && e3.is("containerElement") && n2.is("containerElement")))
              throw new A("view-writer-merge-containers-invalid-position", this.document);
            const o2 = e3.getChild(e3.childCount - 1), i2 = o2 instanceof _s ? Ba._createAt(o2, "end") : Ba._createAt(e3, "end");
            return this.move(Na._createIn(n2), Ba._createAt(e3, "end")), this.remove(Na._createOn(n2)), i2;
          }
          insert(t3, e3) {
            lc(e3 = et(e3) ? [...e3] : [e3], this.document);
            const n2 = e3.reduce((t4, e4) => {
              const n3 = t4[t4.length - 1], o3 = !e4.is("uiElement");
              return n3 && n3.breakAttributes == o3 ? n3.nodes.push(e4) : t4.push({ breakAttributes: o3, nodes: [e4] }), t4;
            }, []);
            let o2 = null, i2 = t3;
            for (const { nodes: t4, breakAttributes: e4 } of n2) {
              const n3 = this._insertNodes(i2, t4, e4);
              o2 || (o2 = n3.start), i2 = n3.end;
            }
            return o2 ? new Na(o2, i2) : new Na(t3);
          }
          remove(t3) {
            const e3 = t3 instanceof Na ? t3 : Na._createOn(t3);
            if (hc(e3, this.document), e3.isCollapsed)
              return new ec(this.document);
            const { start: n2, end: o2 } = this._breakAttributesRange(e3, true), i2 = n2.parent, r2 = o2.offset - n2.offset, s3 = i2._removeChildren(n2.offset, r2);
            for (const t4 of s3)
              this._removeFromClonedElementsGroup(t4);
            const a2 = this.mergeAttributes(n2);
            return e3.start = a2, e3.end = a2.clone(), new ec(this.document, s3);
          }
          clear(t3, e3) {
            hc(t3, this.document);
            const n2 = t3.getWalker({ direction: "backward", ignoreElementEnd: true });
            for (const o2 of n2) {
              const n3 = o2.item;
              let i2;
              if (n3.is("element") && e3.isSimilar(n3))
                i2 = Na._createOn(n3);
              else if (!o2.nextPosition.isAfter(t3.start) && n3.is("$textProxy")) {
                const t4 = n3.getAncestors().find((t5) => t5.is("element") && e3.isSimilar(t5));
                t4 && (i2 = Na._createIn(t4));
              }
              i2 && (i2.end.isAfter(t3.end) && (i2.end = t3.end), i2.start.isBefore(t3.start) && (i2.start = t3.start), this.remove(i2));
            }
          }
          move(t3, e3) {
            let n2;
            if (e3.isAfter(t3.end)) {
              const o2 = (e3 = this._breakAttributes(e3, true)).parent, i2 = o2.childCount;
              t3 = this._breakAttributesRange(t3, true), n2 = this.remove(t3), e3.offset += o2.childCount - i2;
            } else
              n2 = this.remove(t3);
            return this.insert(e3, n2);
          }
          wrap(t3, e3) {
            if (!(e3 instanceof Ga))
              throw new A("view-writer-wrap-invalid-attribute", this.document);
            if (hc(t3, this.document), t3.isCollapsed) {
              let o2 = t3.start;
              o2.parent.is("element") && (n2 = o2.parent, !Array.from(n2.getChildren()).some((t4) => !t4.is("uiElement"))) && (o2 = o2.getLastMatchingPosition((t4) => t4.item.is("uiElement"))), o2 = this._wrapPosition(o2, e3);
              const i2 = this.document.selection;
              return i2.isCollapsed && i2.getFirstPosition().isEqual(t3.start) && this.setSelection(o2), new Na(o2);
            }
            return this._wrapRange(t3, e3);
            var n2;
          }
          unwrap(t3, e3) {
            if (!(e3 instanceof Ga))
              throw new A("view-writer-unwrap-invalid-attribute", this.document);
            if (hc(t3, this.document), t3.isCollapsed)
              return t3;
            const { start: n2, end: o2 } = this._breakAttributesRange(t3, true), i2 = n2.parent, r2 = this._unwrapChildren(i2, n2.offset, o2.offset, e3), s3 = this.mergeAttributes(r2.start);
            s3.isEqual(r2.start) || r2.end.offset--;
            const a2 = this.mergeAttributes(r2.end);
            return new Na(s3, a2);
          }
          rename(t3, e3) {
            const n2 = new Ea(this.document, t3, e3.getAttributes());
            return this.insert(Ba._createAfter(e3), n2), this.move(Na._createIn(e3), Ba._createAt(n2, 0)), this.remove(Na._createOn(e3)), n2;
          }
          clearClonedElementsGroup(t3) {
            this._cloneGroups.delete(t3);
          }
          createPositionAt(t3, e3) {
            return Ba._createAt(t3, e3);
          }
          createPositionAfter(t3) {
            return Ba._createAfter(t3);
          }
          createPositionBefore(t3) {
            return Ba._createBefore(t3);
          }
          createRange(t3, e3) {
            return new Na(t3, e3);
          }
          createRangeOn(t3) {
            return Na._createOn(t3);
          }
          createRangeIn(t3) {
            return Na._createIn(t3);
          }
          createSelection(...t3) {
            return new za(...t3);
          }
          createSlot(t3 = "children") {
            if (!this._slotFactory)
              throw new A("view-writer-invalid-create-slot-context", this.document);
            return this._slotFactory(this, t3);
          }
          _registerSlotFactory(t3) {
            this._slotFactory = t3;
          }
          _clearSlotFactory() {
            this._slotFactory = null;
          }
          _insertNodes(t3, e3, n2) {
            let o2, i2;
            if (o2 = n2 ? oc(t3) : t3.parent.is("$text") ? t3.parent.parent : t3.parent, !o2)
              throw new A("view-writer-invalid-position-container", this.document);
            i2 = n2 ? this._breakAttributes(t3, true) : t3.parent.is("$text") ? sc(t3) : t3;
            const r2 = o2._insertChild(i2.offset, e3);
            for (const t4 of e3)
              this._addToClonedElementsGroup(t4);
            const s3 = i2.getShiftedBy(r2), a2 = this.mergeAttributes(i2);
            a2.isEqual(i2) || s3.offset--;
            const c2 = this.mergeAttributes(s3);
            return new Na(a2, c2);
          }
          _wrapChildren(t3, e3, n2, o2) {
            let i2 = e3;
            const r2 = [];
            for (; i2 < n2; ) {
              const e4 = t3.getChild(i2), n3 = e4.is("$text"), s4 = e4.is("attributeElement");
              if (s4 && this._wrapAttributeElement(o2, e4))
                r2.push(new Ba(t3, i2));
              else if (n3 || !s4 || ic(o2, e4)) {
                const n4 = o2._clone();
                e4._remove(), n4._appendChild(e4), t3._insertChild(i2, n4), this._addToClonedElementsGroup(n4), r2.push(new Ba(t3, i2));
              } else
                this._wrapChildren(e4, 0, e4.childCount, o2);
              i2++;
            }
            let s3 = 0;
            for (const t4 of r2) {
              if (t4.offset -= s3, t4.offset == e3)
                continue;
              this.mergeAttributes(t4).isEqual(t4) || (s3++, n2--);
            }
            return Na._createFromParentsAndOffsets(t3, e3, t3, n2);
          }
          _unwrapChildren(t3, e3, n2, o2) {
            let i2 = e3;
            const r2 = [];
            for (; i2 < n2; ) {
              const e4 = t3.getChild(i2);
              if (e4.is("attributeElement"))
                if (e4.isSimilar(o2)) {
                  const o3 = e4.getChildren(), s4 = e4.childCount;
                  e4._remove(), t3._insertChild(i2, o3), this._removeFromClonedElementsGroup(e4), r2.push(new Ba(t3, i2), new Ba(t3, i2 + s4)), i2 += s4, n2 += s4 - 1;
                } else
                  this._unwrapAttributeElement(o2, e4) ? (r2.push(new Ba(t3, i2), new Ba(t3, i2 + 1)), i2++) : (this._unwrapChildren(e4, 0, e4.childCount, o2), i2++);
              else
                i2++;
            }
            let s3 = 0;
            for (const t4 of r2) {
              if (t4.offset -= s3, t4.offset == e3 || t4.offset == n2)
                continue;
              this.mergeAttributes(t4).isEqual(t4) || (s3++, n2--);
            }
            return Na._createFromParentsAndOffsets(t3, e3, t3, n2);
          }
          _wrapRange(t3, e3) {
            const { start: n2, end: o2 } = this._breakAttributesRange(t3, true), i2 = n2.parent, r2 = this._wrapChildren(i2, n2.offset, o2.offset, e3), s3 = this.mergeAttributes(r2.start);
            s3.isEqual(r2.start) || r2.end.offset--;
            const a2 = this.mergeAttributes(r2.end);
            return new Na(s3, a2);
          }
          _wrapPosition(t3, e3) {
            if (e3.isSimilar(t3.parent))
              return rc(t3.clone());
            t3.parent.is("$text") && (t3 = sc(t3));
            const n2 = this.createAttributeElement("_wrapPosition-fake-element");
            n2._priority = Number.POSITIVE_INFINITY, n2.isSimilar = () => false, t3.parent._insertChild(t3.offset, n2);
            const o2 = new Na(t3, t3.getShiftedBy(1));
            this.wrap(o2, e3);
            const i2 = new Ba(n2.parent, n2.index);
            n2._remove();
            const r2 = i2.nodeBefore, s3 = i2.nodeAfter;
            return r2 instanceof _s && s3 instanceof _s ? ac(r2, s3) : rc(i2);
          }
          _wrapAttributeElement(t3, e3) {
            if (!uc(t3, e3))
              return false;
            if (t3.name !== e3.name || t3.priority !== e3.priority)
              return false;
            for (const n2 of t3.getAttributeKeys())
              if ("class" !== n2 && "style" !== n2 && e3.hasAttribute(n2) && e3.getAttribute(n2) !== t3.getAttribute(n2))
                return false;
            for (const n2 of t3.getStyleNames())
              if (e3.hasStyle(n2) && e3.getStyle(n2) !== t3.getStyle(n2))
                return false;
            for (const n2 of t3.getAttributeKeys())
              "class" !== n2 && "style" !== n2 && (e3.hasAttribute(n2) || this.setAttribute(n2, t3.getAttribute(n2), e3));
            for (const n2 of t3.getStyleNames())
              e3.hasStyle(n2) || this.setStyle(n2, t3.getStyle(n2), e3);
            for (const n2 of t3.getClassNames())
              e3.hasClass(n2) || this.addClass(n2, e3);
            return true;
          }
          _unwrapAttributeElement(t3, e3) {
            if (!uc(t3, e3))
              return false;
            if (t3.name !== e3.name || t3.priority !== e3.priority)
              return false;
            for (const n2 of t3.getAttributeKeys())
              if ("class" !== n2 && "style" !== n2 && (!e3.hasAttribute(n2) || e3.getAttribute(n2) !== t3.getAttribute(n2)))
                return false;
            if (!e3.hasClass(...t3.getClassNames()))
              return false;
            for (const n2 of t3.getStyleNames())
              if (!e3.hasStyle(n2) || e3.getStyle(n2) !== t3.getStyle(n2))
                return false;
            for (const n2 of t3.getAttributeKeys())
              "class" !== n2 && "style" !== n2 && this.removeAttribute(n2, e3);
            return this.removeClass(Array.from(t3.getClassNames()), e3), this.removeStyle(Array.from(t3.getStyleNames()), e3), true;
          }
          _breakAttributesRange(t3, e3 = false) {
            const n2 = t3.start, o2 = t3.end;
            if (hc(t3, this.document), t3.isCollapsed) {
              const n3 = this._breakAttributes(t3.start, e3);
              return new Na(n3, n3);
            }
            const i2 = this._breakAttributes(o2, e3), r2 = i2.parent.childCount, s3 = this._breakAttributes(n2, e3);
            return i2.offset += i2.parent.childCount - r2, new Na(s3, i2);
          }
          _breakAttributes(t3, e3 = false) {
            const n2 = t3.offset, o2 = t3.parent;
            if (t3.parent.is("emptyElement"))
              throw new A("view-writer-cannot-break-empty-element", this.document);
            if (t3.parent.is("uiElement"))
              throw new A("view-writer-cannot-break-ui-element", this.document);
            if (t3.parent.is("rawElement"))
              throw new A("view-writer-cannot-break-raw-element", this.document);
            if (!e3 && o2.is("$text") && dc(o2.parent))
              return t3.clone();
            if (dc(o2))
              return t3.clone();
            if (o2.is("$text"))
              return this._breakAttributes(sc(t3), e3);
            if (n2 == o2.childCount) {
              const t4 = new Ba(o2.parent, o2.index + 1);
              return this._breakAttributes(t4, e3);
            }
            if (0 === n2) {
              const t4 = new Ba(o2.parent, o2.index);
              return this._breakAttributes(t4, e3);
            }
            {
              const t4 = o2.index + 1, i2 = o2._clone();
              o2.parent._insertChild(t4, i2), this._addToClonedElementsGroup(i2);
              const r2 = o2.childCount - n2, s3 = o2._removeChildren(n2, r2);
              i2._appendChild(s3);
              const a2 = new Ba(o2.parent, t4);
              return this._breakAttributes(a2, e3);
            }
          }
          _addToClonedElementsGroup(t3) {
            if (!t3.root.is("rootElement"))
              return;
            if (t3.is("element"))
              for (const e4 of t3.getChildren())
                this._addToClonedElementsGroup(e4);
            const e3 = t3.id;
            if (!e3)
              return;
            let n2 = this._cloneGroups.get(e3);
            n2 || (n2 = /* @__PURE__ */ new Set(), this._cloneGroups.set(e3, n2)), n2.add(t3), t3._clonesGroup = n2;
          }
          _removeFromClonedElementsGroup(t3) {
            if (t3.is("element"))
              for (const e4 of t3.getChildren())
                this._removeFromClonedElementsGroup(e4);
            const e3 = t3.id;
            if (!e3)
              return;
            const n2 = this._cloneGroups.get(e3);
            n2 && n2.delete(t3);
          }
        }
        function oc(t3) {
          let e3 = t3.parent;
          for (; !dc(e3); ) {
            if (!e3)
              return;
            e3 = e3.parent;
          }
          return e3;
        }
        function ic(t3, e3) {
          return t3.priority < e3.priority || !(t3.priority > e3.priority) && t3.getIdentity() < e3.getIdentity();
        }
        function rc(t3) {
          const e3 = t3.nodeBefore;
          if (e3 && e3.is("$text"))
            return new Ba(e3, e3.data.length);
          const n2 = t3.nodeAfter;
          return n2 && n2.is("$text") ? new Ba(n2, 0) : t3;
        }
        function sc(t3) {
          if (t3.offset == t3.parent.data.length)
            return new Ba(t3.parent.parent, t3.parent.index + 1);
          if (0 === t3.offset)
            return new Ba(t3.parent.parent, t3.parent.index);
          const e3 = t3.parent.data.slice(t3.offset);
          return t3.parent._data = t3.parent.data.slice(0, t3.offset), t3.parent.parent._insertChild(t3.parent.index + 1, new _s(t3.root.document, e3)), new Ba(t3.parent.parent, t3.parent.index + 1);
        }
        function ac(t3, e3) {
          const n2 = t3.data.length;
          return t3._data += e3.data, e3._remove(), new Ba(t3, n2);
        }
        const cc = [_s, Ga, Ea, Za, Xa, $a];
        function lc(t3, e3) {
          for (const n2 of t3) {
            if (!cc.some((t4) => n2 instanceof t4))
              throw new A("view-writer-insert-invalid-node-type", e3);
            n2.is("$text") || lc(n2.getChildren(), e3);
          }
        }
        function dc(t3) {
          return t3 && (t3.is("containerElement") || t3.is("documentFragment"));
        }
        function hc(t3, e3) {
          const n2 = oc(t3.start), o2 = oc(t3.end);
          if (!n2 || !o2 || n2 !== o2)
            throw new A("view-writer-invalid-range-container", e3);
        }
        function uc(t3, e3) {
          return null === t3.id && null === e3.id;
        }
        const gc = (t3) => t3.createTextNode("\xA0"), pc = (t3) => {
          const e3 = t3.createElement("span");
          return e3.dataset.ckeFiller = "true", e3.innerText = "\xA0", e3;
        }, mc = (t3) => {
          const e3 = t3.createElement("br");
          return e3.dataset.ckeFiller = "true", e3;
        }, fc = 7, kc = "\u2060".repeat(fc);
        function bc(t3) {
          return "string" == typeof t3 ? t3.substr(0, fc) === kc : Oo(t3) && t3.data.substr(0, fc) === kc;
        }
        function wc(t3) {
          return t3.data.length == fc && bc(t3);
        }
        function Ac(t3) {
          const e3 = "string" == typeof t3 ? t3 : t3.data;
          return bc(t3) ? e3.slice(fc) : e3;
        }
        function Cc(t3, e3) {
          if (e3.keyCode == fi.arrowleft) {
            const t4 = e3.domTarget.ownerDocument.defaultView.getSelection();
            if (1 == t4.rangeCount && t4.getRangeAt(0).collapsed) {
              const e4 = t4.getRangeAt(0).startContainer, n2 = t4.getRangeAt(0).startOffset;
              bc(e4) && n2 <= fc && t4.collapse(e4, 0);
            }
          }
        }
        var _c = n(9315), vc = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(_c.Z, vc);
        _c.Z.locals;
        class yc extends W() {
          constructor(t3, e3) {
            super(), this.domDocuments = /* @__PURE__ */ new Set(), this.markedAttributes = /* @__PURE__ */ new Set(), this.markedChildren = /* @__PURE__ */ new Set(), this.markedTexts = /* @__PURE__ */ new Set(), this._inlineFiller = null, this._fakeSelectionContainer = null, this.domConverter = t3, this.selection = e3, this.set("isFocused", false), this.set("isSelecting", false), a.isBlink && !a.isAndroid && this.on("change:isSelecting", () => {
              this.isSelecting || this.render();
            }), this.set("isComposing", false), this.on("change:isComposing", () => {
              this.isComposing || this.render();
            });
          }
          markToSync(t3, e3) {
            if ("text" === t3)
              this.domConverter.mapViewToDom(e3.parent) && this.markedTexts.add(e3);
            else {
              if (!this.domConverter.mapViewToDom(e3))
                return;
              if ("attributes" === t3)
                this.markedAttributes.add(e3);
              else {
                if ("children" !== t3) {
                  throw new A("view-renderer-unknown-type", this);
                }
                this.markedChildren.add(e3);
              }
            }
          }
          render() {
            if (this.isComposing && !a.isAndroid)
              return;
            let t3 = null;
            const e3 = !(a.isBlink && !a.isAndroid) || !this.isSelecting;
            for (const t4 of this.markedChildren)
              this._updateChildrenMappings(t4);
            e3 ? (this._inlineFiller && !this._isSelectionInInlineFiller() && this._removeInlineFiller(), this._inlineFiller ? t3 = this._getInlineFillerPosition() : this._needsInlineFillerAtSelection() && (t3 = this.selection.getFirstPosition(), this.markedChildren.add(t3.parent))) : this._inlineFiller && this._inlineFiller.parentNode && (t3 = this.domConverter.domPositionToView(this._inlineFiller), t3 && t3.parent.is("$text") && (t3 = Ba._createBefore(t3.parent)));
            for (const t4 of this.markedAttributes)
              this._updateAttrs(t4);
            for (const e4 of this.markedChildren)
              this._updateChildren(e4, { inlineFillerPosition: t3 });
            for (const e4 of this.markedTexts)
              !this.markedChildren.has(e4.parent) && this.domConverter.mapViewToDom(e4.parent) && this._updateText(e4, { inlineFillerPosition: t3 });
            if (e3)
              if (t3) {
                const e4 = this.domConverter.viewPositionToDom(t3), n2 = e4.parent.ownerDocument;
                bc(e4.parent) ? this._inlineFiller = e4.parent : this._inlineFiller = xc(n2, e4.parent, e4.offset);
              } else
                this._inlineFiller = null;
            this._updateFocus(), this._updateSelection(), this.domConverter._clearTemporaryCustomProperties(), this.markedTexts.clear(), this.markedAttributes.clear(), this.markedChildren.clear();
          }
          _updateChildrenMappings(t3) {
            const e3 = this.domConverter.mapViewToDom(t3);
            if (!e3)
              return;
            const n2 = Array.from(e3.childNodes), o2 = Array.from(this.domConverter.viewChildrenToDom(t3, { withChildren: false })), i2 = this._diffNodeLists(n2, o2), r2 = this._findUpdateActions(i2, n2, o2, Ec);
            if (-1 !== r2.indexOf("update")) {
              const e4 = { equal: 0, insert: 0, delete: 0 };
              for (const i3 of r2)
                if ("update" === i3) {
                  const i4 = e4.equal + e4.insert, r3 = e4.equal + e4.delete, s3 = t3.getChild(i4);
                  !s3 || s3.is("uiElement") || s3.is("rawElement") || this._updateElementMappings(s3, n2[r3]), ii(o2[i4]), e4.equal++;
                } else
                  e4[i3]++;
            }
          }
          _updateElementMappings(t3, e3) {
            this.domConverter.unbindDomElement(e3), this.domConverter.bindElements(e3, t3), this.markedChildren.add(t3), this.markedAttributes.add(t3);
          }
          _getInlineFillerPosition() {
            const t3 = this.selection.getFirstPosition();
            return t3.parent.is("$text") ? Ba._createBefore(t3.parent) : t3;
          }
          _isSelectionInInlineFiller() {
            if (1 != this.selection.rangeCount || !this.selection.isCollapsed)
              return false;
            const t3 = this.selection.getFirstPosition(), e3 = this.domConverter.viewPositionToDom(t3);
            return !!(e3 && Oo(e3.parent) && bc(e3.parent));
          }
          _removeInlineFiller() {
            const t3 = this._inlineFiller;
            if (!bc(t3))
              throw new A("view-renderer-filler-was-lost", this);
            wc(t3) ? t3.remove() : t3.data = t3.data.substr(fc), this._inlineFiller = null;
          }
          _needsInlineFillerAtSelection() {
            if (1 != this.selection.rangeCount || !this.selection.isCollapsed)
              return false;
            const t3 = this.selection.getFirstPosition(), e3 = t3.parent, n2 = t3.offset;
            if (!this.domConverter.mapViewToDom(e3.root))
              return false;
            if (!e3.is("element"))
              return false;
            if (!function(t4) {
              if ("false" == t4.getAttribute("contenteditable"))
                return false;
              const e4 = t4.findAncestor((t5) => t5.hasAttribute("contenteditable"));
              return !e4 || "true" == e4.getAttribute("contenteditable");
            }(e3))
              return false;
            if (n2 === e3.getFillerOffset())
              return false;
            const o2 = t3.nodeBefore, i2 = t3.nodeAfter;
            return !(o2 instanceof _s || i2 instanceof _s) && (!a.isAndroid || !o2 && !i2);
          }
          _updateText(t3, e3) {
            const n2 = this.domConverter.findCorrespondingDomText(t3);
            let o2 = this.domConverter.viewToDom(t3).data;
            const i2 = e3.inlineFillerPosition;
            i2 && i2.parent == t3.parent && i2.offset == t3.index && (o2 = kc + o2), Sc(n2, o2);
          }
          _updateAttrs(t3) {
            const e3 = this.domConverter.mapViewToDom(t3);
            if (!e3)
              return;
            const n2 = Array.from(e3.attributes).map((t4) => t4.name), o2 = t3.getAttributeKeys();
            for (const n3 of o2)
              this.domConverter.setDomElementAttribute(e3, n3, t3.getAttribute(n3), t3);
            for (const o3 of n2)
              t3.hasAttribute(o3) || this.domConverter.removeDomElementAttribute(e3, o3);
          }
          _updateChildren(t3, e3) {
            const n2 = this.domConverter.mapViewToDom(t3);
            if (!n2)
              return;
            if (a.isAndroid) {
              let t4 = null;
              for (const e4 of Array.from(n2.childNodes)) {
                if (t4 && Oo(t4) && Oo(e4)) {
                  n2.normalize();
                  break;
                }
                t4 = e4;
              }
            }
            const o2 = e3.inlineFillerPosition, i2 = n2.childNodes, r2 = Array.from(this.domConverter.viewChildrenToDom(t3, { bind: true }));
            o2 && o2.parent === t3 && xc(n2.ownerDocument, r2, o2.offset);
            const s3 = this._diffNodeLists(i2, r2), c2 = this._findUpdateActions(s3, i2, r2, Dc);
            let l2 = 0;
            const d2 = /* @__PURE__ */ new Set();
            for (const t4 of c2)
              "delete" === t4 ? (d2.add(i2[l2]), ii(i2[l2])) : "equal" !== t4 && "update" !== t4 || l2++;
            l2 = 0;
            for (const t4 of c2)
              "insert" === t4 ? (Qo(n2, l2, r2[l2]), l2++) : "update" === t4 ? (Sc(i2[l2], r2[l2].data), l2++) : "equal" === t4 && (this._markDescendantTextToSync(this.domConverter.domToView(r2[l2])), l2++);
            for (const t4 of d2)
              t4.parentNode || this.domConverter.unbindDomElement(t4);
          }
          _diffNodeLists(t3, e3) {
            return t3 = function(t4, e4) {
              const n2 = Array.from(t4);
              if (0 == n2.length || !e4)
                return n2;
              const o2 = n2[n2.length - 1];
              o2 == e4 && n2.pop();
              return n2;
            }(t3, this._fakeSelectionContainer), u(t3, e3, Ic.bind(null, this.domConverter));
          }
          _findUpdateActions(t3, e3, n2, o2) {
            if (-1 === t3.indexOf("insert") || -1 === t3.indexOf("delete"))
              return t3;
            let i2 = [], r2 = [], s3 = [];
            const a2 = { equal: 0, insert: 0, delete: 0 };
            for (const c2 of t3)
              "insert" === c2 ? s3.push(n2[a2.equal + a2.insert]) : "delete" === c2 ? r2.push(e3[a2.equal + a2.delete]) : (i2 = i2.concat(u(r2, s3, o2).map((t4) => "equal" === t4 ? "update" : t4)), i2.push("equal"), r2 = [], s3 = []), a2[c2]++;
            return i2.concat(u(r2, s3, o2).map((t4) => "equal" === t4 ? "update" : t4));
          }
          _markDescendantTextToSync(t3) {
            if (t3) {
              if (t3.is("$text"))
                this.markedTexts.add(t3);
              else if (t3.is("element"))
                for (const e3 of t3.getChildren())
                  this._markDescendantTextToSync(e3);
            }
          }
          _updateSelection() {
            if (a.isBlink && !a.isAndroid && this.isSelecting && !this.markedChildren.size)
              return;
            if (0 === this.selection.rangeCount)
              return this._removeDomSelection(), void this._removeFakeSelection();
            const t3 = this.domConverter.mapViewToDom(this.selection.editableElement);
            this.isFocused && t3 && (this.selection.isFake ? this._updateFakeSelection(t3) : this._fakeSelectionContainer && this._fakeSelectionContainer.isConnected ? (this._removeFakeSelection(), this._updateDomSelection(t3)) : this.isComposing && a.isAndroid || this._updateDomSelection(t3));
          }
          _updateFakeSelection(t3) {
            const e3 = t3.ownerDocument;
            this._fakeSelectionContainer || (this._fakeSelectionContainer = function(t4) {
              const e4 = t4.createElement("div");
              return e4.className = "ck-fake-selection-container", Object.assign(e4.style, { position: "fixed", top: 0, left: "-9999px", width: "42px" }), e4.textContent = "\xA0", e4;
            }(e3));
            const n2 = this._fakeSelectionContainer;
            if (this.domConverter.bindFakeSelection(n2, this.selection), !this._fakeSelectionNeedsUpdate(t3))
              return;
            n2.parentElement && n2.parentElement == t3 || t3.appendChild(n2), n2.textContent = this.selection.fakeSelectionLabel || "\xA0";
            const o2 = e3.getSelection(), i2 = e3.createRange();
            o2.removeAllRanges(), i2.selectNodeContents(n2), o2.addRange(i2);
          }
          _updateDomSelection(t3) {
            const e3 = t3.ownerDocument.defaultView.getSelection();
            if (!this._domSelectionNeedsUpdate(e3))
              return;
            const n2 = this.domConverter.viewPositionToDom(this.selection.anchor), o2 = this.domConverter.viewPositionToDom(this.selection.focus);
            e3.setBaseAndExtent(n2.parent, n2.offset, o2.parent, o2.offset), a.isGecko && function(t4, e4) {
              const n3 = t4.parent;
              if (n3.nodeType != Node.ELEMENT_NODE || t4.offset != n3.childNodes.length - 1)
                return;
              const o3 = n3.childNodes[t4.offset];
              o3 && "BR" == o3.tagName && e4.addRange(e4.getRangeAt(0));
            }(o2, e3);
          }
          _domSelectionNeedsUpdate(t3) {
            if (!this.domConverter.isDomSelectionCorrect(t3))
              return true;
            const e3 = t3 && this.domConverter.domSelectionToView(t3);
            return (!e3 || !this.selection.isEqual(e3)) && !(!this.selection.isCollapsed && this.selection.isSimilar(e3));
          }
          _fakeSelectionNeedsUpdate(t3) {
            const e3 = this._fakeSelectionContainer, n2 = t3.ownerDocument.getSelection();
            return !e3 || e3.parentElement !== t3 || (n2.anchorNode !== e3 && !e3.contains(n2.anchorNode) || e3.textContent !== this.selection.fakeSelectionLabel);
          }
          _removeDomSelection() {
            for (const t3 of this.domDocuments) {
              const e3 = t3.getSelection();
              if (e3.rangeCount) {
                const n2 = t3.activeElement, o2 = this.domConverter.mapDomToView(n2);
                n2 && o2 && e3.removeAllRanges();
              }
            }
          }
          _removeFakeSelection() {
            const t3 = this._fakeSelectionContainer;
            t3 && t3.remove();
          }
          _updateFocus() {
            if (this.isFocused) {
              const t3 = this.selection.editableElement;
              t3 && this.domConverter.focus(t3);
            }
          }
        }
        function xc(t3, e3, n2) {
          const o2 = e3 instanceof Array ? e3 : e3.childNodes, i2 = o2[n2];
          if (Oo(i2))
            return i2.data = kc + i2.data, i2;
          {
            const i3 = t3.createTextNode(kc);
            return Array.isArray(e3) ? o2.splice(n2, 0, i3) : Qo(e3, n2, i3), i3;
          }
        }
        function Ec(t3, e3) {
          return Io(t3) && Io(e3) && !Oo(t3) && !Oo(e3) && !Jo(t3) && !Jo(e3) && t3.tagName.toLowerCase() === e3.tagName.toLowerCase();
        }
        function Dc(t3, e3) {
          return Io(t3) && Io(e3) && Oo(t3) && Oo(e3);
        }
        function Ic(t3, e3, n2) {
          return e3 === n2 || (Oo(e3) && Oo(n2) ? e3.data === n2.data : !(!t3.isBlockFiller(e3) || !t3.isBlockFiller(n2)));
        }
        function Sc(t3, e3) {
          const n2 = t3.data;
          if (n2 == e3)
            return;
          const o2 = l(n2, e3);
          for (const e4 of o2)
            "insert" === e4.type ? t3.insertData(e4.index, e4.values.join("")) : t3.deleteData(e4.index, e4.howMany);
        }
        const Tc = mc(zo.document), Mc = gc(zo.document), Bc = pc(zo.document), Nc = "data-ck-unsafe-attribute-", Pc = "data-ck-unsafe-element";
        class zc {
          constructor(t3, { blockFillerMode: e3, renderingMode: n2 = "editing" } = {}) {
            this._domToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToDomMapping = /* @__PURE__ */ new WeakMap(), this._fakeSelectionMapping = /* @__PURE__ */ new WeakMap(), this._rawContentElementMatcher = new ys(), this._inlineObjectElementMatcher = new ys(), this._elementsWithTemporaryCustomProperties = /* @__PURE__ */ new Set(), this.document = t3, this.renderingMode = n2, this.blockFillerMode = e3 || ("editing" === n2 ? "br" : "nbsp"), this.preElements = ["pre"], this.blockElements = ["address", "article", "aside", "blockquote", "caption", "center", "dd", "details", "dir", "div", "dl", "dt", "fieldset", "figcaption", "figure", "footer", "form", "h1", "h2", "h3", "h4", "h5", "h6", "header", "hgroup", "legend", "li", "main", "menu", "nav", "ol", "p", "pre", "section", "summary", "table", "tbody", "td", "tfoot", "th", "thead", "tr", "ul"], this.inlineObjectElements = ["object", "iframe", "input", "button", "textarea", "select", "option", "video", "embed", "audio", "img", "canvas"], this.unsafeElements = ["script", "style"], this._domDocument = "editing" === this.renderingMode ? zo.document : zo.document.implementation.createHTMLDocument("");
          }
          bindFakeSelection(t3, e3) {
            this._fakeSelectionMapping.set(t3, new za(e3));
          }
          fakeSelectionToView(t3) {
            return this._fakeSelectionMapping.get(t3);
          }
          bindElements(t3, e3) {
            this._domToViewMapping.set(t3, e3), this._viewToDomMapping.set(e3, t3);
          }
          unbindDomElement(t3) {
            const e3 = this._domToViewMapping.get(t3);
            if (e3) {
              this._domToViewMapping.delete(t3), this._viewToDomMapping.delete(e3);
              for (const e4 of Array.from(t3.children))
                this.unbindDomElement(e4);
            }
          }
          bindDocumentFragments(t3, e3) {
            this._domToViewMapping.set(t3, e3), this._viewToDomMapping.set(e3, t3);
          }
          shouldRenderAttribute(t3, e3, n2) {
            return "data" === this.renderingMode || !(t3 = t3.toLowerCase()).startsWith("on") && (("srcdoc" !== t3 || !e3.match(/\bon\S+\s*=|javascript:|<\s*\/*script/i)) && ("img" === n2 && ("src" === t3 || "srcset" === t3) || ("source" === n2 && "srcset" === t3 || !e3.match(/^\s*(javascript:|data:(image\/svg|text\/x?html))/i))));
          }
          setContentOf(t3, e3) {
            if ("data" === this.renderingMode)
              return void (t3.innerHTML = e3);
            const n2 = new DOMParser().parseFromString(e3, "text/html"), o2 = n2.createDocumentFragment(), i2 = n2.body.childNodes;
            for (; i2.length > 0; )
              o2.appendChild(i2[0]);
            const r2 = n2.createTreeWalker(o2, NodeFilter.SHOW_ELEMENT), s3 = [];
            let a2;
            for (; a2 = r2.nextNode(); )
              s3.push(a2);
            for (const t4 of s3) {
              for (const e5 of t4.getAttributeNames())
                this.setDomElementAttribute(t4, e5, t4.getAttribute(e5));
              const e4 = t4.tagName.toLowerCase();
              this._shouldRenameElement(e4) && (jc(e4), t4.replaceWith(this._createReplacementDomElement(e4, t4)));
            }
            for (; t3.firstChild; )
              t3.firstChild.remove();
            t3.append(o2);
          }
          viewToDom(t3, e3 = {}) {
            if (t3.is("$text")) {
              const e4 = this._processDataFromViewText(t3);
              return this._domDocument.createTextNode(e4);
            }
            {
              const n2 = t3;
              if (this.mapViewToDom(n2)) {
                if (!n2.getCustomProperty("editingPipeline:doNotReuseOnce"))
                  return this.mapViewToDom(n2);
                this._elementsWithTemporaryCustomProperties.add(n2);
              }
              let o2;
              if (n2.is("documentFragment"))
                o2 = this._domDocument.createDocumentFragment(), e3.bind && this.bindDocumentFragments(o2, n2);
              else {
                if (n2.is("uiElement"))
                  return o2 = "$comment" === n2.name ? this._domDocument.createComment(n2.getCustomProperty("$rawContent")) : n2.render(this._domDocument, this), e3.bind && this.bindElements(o2, n2), o2;
                this._shouldRenameElement(n2.name) ? (jc(n2.name), o2 = this._createReplacementDomElement(n2.name)) : o2 = n2.hasAttribute("xmlns") ? this._domDocument.createElementNS(n2.getAttribute("xmlns"), n2.name) : this._domDocument.createElement(n2.name), n2.is("rawElement") && n2.render(o2, this), e3.bind && this.bindElements(o2, n2);
                for (const t4 of n2.getAttributeKeys())
                  this.setDomElementAttribute(o2, t4, n2.getAttribute(t4), n2);
              }
              if (false !== e3.withChildren)
                for (const t4 of this.viewChildrenToDom(n2, e3))
                  o2.appendChild(t4);
              return o2;
            }
          }
          setDomElementAttribute(t3, e3, n2, o2) {
            const i2 = this.shouldRenderAttribute(e3, n2, t3.tagName.toLowerCase()) || o2 && o2.shouldRenderUnsafeAttribute(e3);
            i2 || C("domconverter-unsafe-attribute-detected", { domElement: t3, key: e3, value: n2 }), function(t4) {
              try {
                zo.document.createAttribute(t4);
              } catch (t5) {
                return false;
              }
              return true;
            }(e3) ? (t3.hasAttribute(e3) && !i2 ? t3.removeAttribute(e3) : t3.hasAttribute(Nc + e3) && i2 && t3.removeAttribute(Nc + e3), t3.setAttribute(i2 ? e3 : Nc + e3, n2)) : C("domconverter-invalid-attribute-detected", { domElement: t3, key: e3, value: n2 });
          }
          removeDomElementAttribute(t3, e3) {
            e3 != Pc && (t3.removeAttribute(e3), t3.removeAttribute(Nc + e3));
          }
          *viewChildrenToDom(t3, e3 = {}) {
            const n2 = t3.getFillerOffset && t3.getFillerOffset();
            let o2 = 0;
            for (const i2 of t3.getChildren()) {
              n2 === o2 && (yield this._getBlockFiller());
              const t4 = i2.is("element") && !!i2.getCustomProperty("dataPipeline:transparentRendering") && !Ii(i2.getAttributes());
              t4 && "data" == this.renderingMode ? yield* __yieldStar(this.viewChildrenToDom(i2, e3)) : (t4 && C("domconverter-transparent-rendering-unsupported-in-editing-pipeline", { viewElement: i2 }), yield this.viewToDom(i2, e3)), o2++;
            }
            n2 === o2 && (yield this._getBlockFiller());
          }
          viewRangeToDom(t3) {
            const e3 = this.viewPositionToDom(t3.start), n2 = this.viewPositionToDom(t3.end), o2 = this._domDocument.createRange();
            return o2.setStart(e3.parent, e3.offset), o2.setEnd(n2.parent, n2.offset), o2;
          }
          viewPositionToDom(t3) {
            const e3 = t3.parent;
            if (e3.is("$text")) {
              const n2 = this.findCorrespondingDomText(e3);
              if (!n2)
                return null;
              let o2 = t3.offset;
              return bc(n2) && (o2 += fc), { parent: n2, offset: o2 };
            }
            {
              let n2, o2, i2;
              if (0 === t3.offset) {
                if (n2 = this.mapViewToDom(e3), !n2)
                  return null;
                i2 = n2.childNodes[0];
              } else {
                const e4 = t3.nodeBefore;
                if (o2 = e4.is("$text") ? this.findCorrespondingDomText(e4) : this.mapViewToDom(e4), !o2)
                  return null;
                n2 = o2.parentNode, i2 = o2.nextSibling;
              }
              if (Oo(i2) && bc(i2))
                return { parent: i2, offset: fc };
              return { parent: n2, offset: o2 ? $o(o2) + 1 : 0 };
            }
          }
          domToView(t3, e3 = {}) {
            const n2 = [], o2 = this._domToView(t3, e3, n2), i2 = o2.next().value;
            return i2 ? (o2.next(), this._processDomInlineNodes(null, n2, e3), i2.is("$text") && 0 == i2.data.length ? null : i2) : null;
          }
          *domChildrenToView(t3, e3 = {}, n2 = []) {
            for (let o2 = 0; o2 < t3.childNodes.length; o2++) {
              const i2 = t3.childNodes[o2], r2 = this._domToView(i2, e3, n2), s3 = r2.next().value;
              null !== s3 && (this._isBlockViewElement(s3) && this._processDomInlineNodes(t3, n2, e3), yield s3, r2.next());
            }
            this._processDomInlineNodes(t3, n2, e3);
          }
          domSelectionToView(t3) {
            if (function(t4) {
              if (!a.isGecko)
                return false;
              if (!t4.rangeCount)
                return false;
              const e4 = t4.getRangeAt(0).startContainer;
              try {
                Object.prototype.toString.call(e4);
              } catch (t5) {
                return true;
              }
              return false;
            }(t3))
              return new za([]);
            if (1 === t3.rangeCount) {
              let e4 = t3.getRangeAt(0).startContainer;
              Oo(e4) && (e4 = e4.parentNode);
              const n3 = this.fakeSelectionToView(e4);
              if (n3)
                return n3;
            }
            const e3 = this.isDomSelectionBackward(t3), n2 = [];
            for (let e4 = 0; e4 < t3.rangeCount; e4++) {
              const o2 = t3.getRangeAt(e4), i2 = this.domRangeToView(o2);
              i2 && n2.push(i2);
            }
            return new za(n2, { backward: e3 });
          }
          domRangeToView(t3) {
            const e3 = this.domPositionToView(t3.startContainer, t3.startOffset), n2 = this.domPositionToView(t3.endContainer, t3.endOffset);
            return e3 && n2 ? new Na(e3, n2) : null;
          }
          domPositionToView(t3, e3 = 0) {
            if (this.isBlockFiller(t3))
              return this.domPositionToView(t3.parentNode, $o(t3));
            const n2 = this.mapDomToView(t3);
            if (n2 && (n2.is("uiElement") || n2.is("rawElement")))
              return Ba._createBefore(n2);
            if (Oo(t3)) {
              if (wc(t3))
                return this.domPositionToView(t3.parentNode, $o(t3));
              const n3 = this.findCorrespondingViewText(t3);
              let o2 = e3;
              return n3 ? (bc(t3) && (o2 -= fc, o2 = o2 < 0 ? 0 : o2), new Ba(n3, o2)) : null;
            }
            if (0 === e3) {
              const e4 = this.mapDomToView(t3);
              if (e4)
                return new Ba(e4, 0);
            } else {
              const n3 = t3.childNodes[e3 - 1];
              if (Oo(n3) && wc(n3) || n3 && this.isBlockFiller(n3))
                return this.domPositionToView(n3.parentNode, $o(n3));
              const o2 = Oo(n3) ? this.findCorrespondingViewText(n3) : this.mapDomToView(n3);
              if (o2 && o2.parent)
                return new Ba(o2.parent, o2.index + 1);
            }
            return null;
          }
          mapDomToView(t3) {
            return this.getHostViewElement(t3) || this._domToViewMapping.get(t3);
          }
          findCorrespondingViewText(t3) {
            if (wc(t3))
              return null;
            const e3 = this.getHostViewElement(t3);
            if (e3)
              return e3;
            const n2 = t3.previousSibling;
            if (n2) {
              if (!this.isElement(n2))
                return null;
              const t4 = this.mapDomToView(n2);
              if (t4) {
                const e4 = t4.nextSibling;
                return e4 instanceof _s ? e4 : null;
              }
            } else {
              const e4 = this.mapDomToView(t3.parentNode);
              if (e4) {
                const t4 = e4.getChild(0);
                return t4 instanceof _s ? t4 : null;
              }
            }
            return null;
          }
          mapViewToDom(t3) {
            return this._viewToDomMapping.get(t3);
          }
          findCorrespondingDomText(t3) {
            const e3 = t3.previousSibling;
            return e3 && this.mapViewToDom(e3) ? this.mapViewToDom(e3).nextSibling : !e3 && t3.parent && this.mapViewToDom(t3.parent) ? this.mapViewToDom(t3.parent).childNodes[0] : null;
          }
          focus(t3) {
            const e3 = this.mapViewToDom(t3);
            if (e3 && e3.ownerDocument.activeElement !== e3) {
              const { scrollX: t4, scrollY: n2 } = zo.window, o2 = [];
              Lc(e3, (t5) => {
                const { scrollLeft: e4, scrollTop: n3 } = t5;
                o2.push([e4, n3]);
              }), e3.focus(), Lc(e3, (t5) => {
                const [e4, n3] = o2.shift();
                t5.scrollLeft = e4, t5.scrollTop = n3;
              }), zo.window.scrollTo(t4, n2);
            }
          }
          _clearDomSelection() {
            const t3 = this.mapViewToDom(this.document.selection.editableElement);
            if (!t3)
              return;
            const e3 = t3.ownerDocument.defaultView.getSelection(), n2 = this.domSelectionToView(e3);
            n2 && n2.rangeCount > 0 && e3.removeAllRanges();
          }
          isElement(t3) {
            return t3 && t3.nodeType == Node.ELEMENT_NODE;
          }
          isDocumentFragment(t3) {
            return t3 && t3.nodeType == Node.DOCUMENT_FRAGMENT_NODE;
          }
          isBlockFiller(t3) {
            return "br" == this.blockFillerMode ? t3.isEqualNode(Tc) : !("BR" !== t3.tagName || !Rc(t3, this.blockElements) || 1 !== t3.parentNode.childNodes.length) || (t3.isEqualNode(Bc) || function(t4, e3) {
              const n2 = t4.isEqualNode(Mc);
              return n2 && Rc(t4, e3) && 1 === t4.parentNode.childNodes.length;
            }(t3, this.blockElements));
          }
          isDomSelectionBackward(t3) {
            if (t3.isCollapsed)
              return false;
            const e3 = this._domDocument.createRange();
            try {
              e3.setStart(t3.anchorNode, t3.anchorOffset), e3.setEnd(t3.focusNode, t3.focusOffset);
            } catch (t4) {
              return false;
            }
            const n2 = e3.collapsed;
            return e3.detach(), n2;
          }
          getHostViewElement(t3) {
            const e3 = function(t4) {
              const e4 = [];
              let n2 = t4;
              for (; n2 && n2.nodeType != Node.DOCUMENT_NODE; )
                e4.unshift(n2), n2 = n2.parentNode;
              return e4;
            }(t3);
            for (e3.pop(); e3.length; ) {
              const t4 = e3.pop(), n2 = this._domToViewMapping.get(t4);
              if (n2 && (n2.is("uiElement") || n2.is("rawElement")))
                return n2;
            }
            return null;
          }
          isDomSelectionCorrect(t3) {
            return this._isDomSelectionPositionCorrect(t3.anchorNode, t3.anchorOffset) && this._isDomSelectionPositionCorrect(t3.focusNode, t3.focusOffset);
          }
          registerRawContentMatcher(t3) {
            this._rawContentElementMatcher.add(t3);
          }
          registerInlineObjectMatcher(t3) {
            this._inlineObjectElementMatcher.add(t3);
          }
          _clearTemporaryCustomProperties() {
            for (const t3 of this._elementsWithTemporaryCustomProperties)
              t3._removeCustomProperty("editingPipeline:doNotReuseOnce");
            this._elementsWithTemporaryCustomProperties.clear();
          }
          _getBlockFiller() {
            switch (this.blockFillerMode) {
              case "nbsp":
                return gc(this._domDocument);
              case "markedNbsp":
                return pc(this._domDocument);
              case "br":
                return mc(this._domDocument);
            }
          }
          _isDomSelectionPositionCorrect(t3, e3) {
            if (Oo(t3) && bc(t3) && e3 < fc)
              return false;
            if (this.isElement(t3) && bc(t3.childNodes[e3]))
              return false;
            const n2 = this.mapDomToView(t3);
            return !n2 || !n2.is("uiElement") && !n2.is("rawElement");
          }
          *_domToView(t3, e3, n2) {
            if (this.isBlockFiller(t3))
              return null;
            const o2 = this.getHostViewElement(t3);
            if (o2)
              return o2;
            if (Jo(t3) && e3.skipComments)
              return null;
            if (Oo(t3)) {
              if (wc(t3))
                return null;
              {
                const e4 = t3.data;
                if ("" === e4)
                  return null;
                const o3 = new _s(this.document, e4);
                return n2.push(o3), o3;
              }
            }
            {
              let o3 = this.mapDomToView(t3);
              if (o3)
                return this._isInlineObjectElement(o3) && n2.push(o3), o3;
              if (this.isDocumentFragment(t3))
                o3 = new ec(this.document), e3.bind && this.bindDocumentFragments(t3, o3);
              else {
                o3 = this._createViewElement(t3, e3), e3.bind && this.bindElements(t3, o3);
                const i3 = t3.attributes;
                if (i3)
                  for (let t4 = i3.length, e4 = 0; e4 < t4; e4++)
                    o3._setAttribute(i3[e4].name, i3[e4].value);
                if (this._isViewElementWithRawContent(o3, e3))
                  return o3._setCustomProperty("$rawContent", t3.innerHTML), this._isBlockViewElement(o3) || n2.push(o3), o3;
                if (Jo(t3))
                  return o3._setCustomProperty("$rawContent", t3.data), o3;
              }
              yield o3;
              const i2 = [];
              if (false !== e3.withChildren)
                for (const n3 of this.domChildrenToView(t3, e3, i2))
                  o3._appendChild(n3);
              if (this._isInlineObjectElement(o3))
                n2.push(o3);
              else
                for (const t4 of i2)
                  n2.push(t4);
            }
          }
          _processDomInlineNodes(t3, e3, n2) {
            if (!e3.length)
              return;
            if (t3 && !this.isDocumentFragment(t3) && !this._isBlockDomElement(t3))
              return;
            let o2 = false;
            for (let t4 = 0; t4 < e3.length; t4++) {
              const i2 = e3[t4];
              if (!i2.is("$text")) {
                o2 = false;
                continue;
              }
              let r2, s3 = false;
              if (Oc(i2, this.preElements))
                r2 = Ac(i2.data);
              else {
                r2 = i2.data.replace(/[ \n\t\r]{1,}/g, " "), s3 = /[^\S\u00A0]/.test(r2.charAt(r2.length - 1));
                const a2 = t4 > 0 ? e3[t4 - 1] : null, c2 = t4 + 1 < e3.length ? e3[t4 + 1] : null, l2 = !a2 || a2.is("element") && "br" == a2.name || o2, d2 = !c2 && !bc(i2.data);
                false !== n2.withChildren && (l2 && (r2 = r2.replace(/^ /, "")), d2 && (r2 = r2.replace(/ $/, ""))), r2 = Ac(r2), r2 = r2.replace(/ \u00A0/g, "  ");
                const h2 = c2 && c2.is("element") && "br" != c2.name, u2 = c2 && c2.is("$text") && " " == c2.data.charAt(0);
                (/[ \u00A0]\u00A0$/.test(r2) || !c2 || h2 || u2) && (r2 = r2.replace(/\u00A0$/, " ")), (l2 || a2 && a2.is("element") && "br" != a2.name) && (r2 = r2.replace(/^\u00A0/, " "));
              }
              0 == r2.length && i2.parent ? (i2._remove(), e3.splice(t4, 1), t4--) : (i2._data = r2, o2 = s3);
            }
            e3.length = 0;
          }
          _processDataFromViewText(t3) {
            let e3 = t3.data;
            if (t3.getAncestors().some((t4) => this.preElements.includes(t4.name)))
              return e3;
            if (" " == e3.charAt(0)) {
              const n2 = this._getTouchingInlineViewNode(t3, false);
              !(n2 && n2.is("$textProxy") && this._nodeEndsWithSpace(n2)) && n2 || (e3 = "\xA0" + e3.substr(1));
            }
            if (" " == e3.charAt(e3.length - 1)) {
              const n2 = this._getTouchingInlineViewNode(t3, true), o2 = n2 && n2.is("$textProxy") && " " == n2.data.charAt(0);
              " " != e3.charAt(e3.length - 2) && n2 && !o2 || (e3 = e3.substr(0, e3.length - 1) + "\xA0");
            }
            return e3.replace(/ {2}/g, " \xA0");
          }
          _nodeEndsWithSpace(t3) {
            if (t3.getAncestors().some((t4) => this.preElements.includes(t4.name)))
              return false;
            const e3 = this._processDataFromViewText(t3);
            return " " == e3.charAt(e3.length - 1);
          }
          _getTouchingInlineViewNode(t3, e3) {
            const n2 = new Ma({ startPosition: e3 ? Ba._createAfter(t3) : Ba._createBefore(t3), direction: e3 ? "forward" : "backward" });
            for (const t4 of n2) {
              if (t4.item.is("element", "br"))
                return null;
              if (this._isInlineObjectElement(t4.item))
                return t4.item;
              if (t4.item.is("containerElement"))
                return null;
              if (t4.item.is("$textProxy"))
                return t4.item;
            }
            return null;
          }
          _isBlockDomElement(t3) {
            return this.isElement(t3) && this.blockElements.includes(t3.tagName.toLowerCase());
          }
          _isBlockViewElement(t3) {
            return t3.is("element") && this.blockElements.includes(t3.name);
          }
          _isInlineObjectElement(t3) {
            return !!t3.is("element") && ("br" == t3.name || this.inlineObjectElements.includes(t3.name) || !!this._inlineObjectElementMatcher.match(t3));
          }
          _createViewElement(t3, e3) {
            if (Jo(t3))
              return new $a(this.document, "$comment");
            const n2 = e3.keepOriginalCase ? t3.tagName : t3.tagName.toLowerCase();
            return new ya(this.document, n2);
          }
          _isViewElementWithRawContent(t3, e3) {
            return false !== e3.withChildren && t3.is("element") && !!this._rawContentElementMatcher.match(t3);
          }
          _shouldRenameElement(t3) {
            const e3 = t3.toLowerCase();
            return "editing" === this.renderingMode && this.unsafeElements.includes(e3);
          }
          _createReplacementDomElement(t3, e3) {
            const n2 = this._domDocument.createElement("span");
            if (n2.setAttribute(Pc, t3), e3) {
              for (; e3.firstChild; )
                n2.appendChild(e3.firstChild);
              for (const t4 of e3.getAttributeNames())
                n2.setAttribute(t4, e3.getAttribute(t4));
            }
            return n2;
          }
        }
        function Oc(t3, e3) {
          return t3.getAncestors().some((t4) => t4.is("element") && e3.includes(t4.name));
        }
        function Lc(t3, e3) {
          let n2 = t3;
          for (; n2; )
            e3(n2), n2 = n2.parentElement;
        }
        function Rc(t3, e3) {
          const n2 = t3.parentNode;
          return !!n2 && !!n2.tagName && e3.includes(n2.tagName.toLowerCase());
        }
        function jc(t3) {
          "script" === t3 && C("domconverter-unsafe-script-element-detected"), "style" === t3 && C("domconverter-unsafe-style-element-detected");
        }
        class Fc extends Mo() {
          constructor(t3) {
            super(), this._isEnabled = false, this.view = t3, this.document = t3.document;
          }
          get isEnabled() {
            return this._isEnabled;
          }
          enable() {
            this._isEnabled = true;
          }
          disable() {
            this._isEnabled = false;
          }
          destroy() {
            this.disable(), this.stopListening();
          }
          checkShouldIgnoreEventFromTarget(t3) {
            return t3 && 3 === t3.nodeType && (t3 = t3.parentNode), !(!t3 || 1 !== t3.nodeType) && t3.matches("[data-cke-ignore-events], [data-cke-ignore-events] *");
          }
        }
        const Vc = fa(function(t3, e3) {
          Te(e3, pn(e3), t3);
        });
        class Uc {
          constructor(t3, e3, n2) {
            this.view = t3, this.document = t3.document, this.domEvent = e3, this.domTarget = e3.target, Vc(this, n2);
          }
          get target() {
            return this.view.domConverter.mapDomToView(this.domTarget);
          }
          preventDefault() {
            this.domEvent.preventDefault();
          }
          stopPropagation() {
            this.domEvent.stopPropagation();
          }
        }
        class Hc extends Fc {
          constructor() {
            super(...arguments), this.useCapture = false;
          }
          observe(t3) {
            ("string" == typeof this.domEventType ? [this.domEventType] : this.domEventType).forEach((e3) => {
              this.listenTo(t3, e3, (t4, e4) => {
                this.isEnabled && !this.checkShouldIgnoreEventFromTarget(e4.target) && this.onDomEvent(e4);
              }, { useCapture: this.useCapture });
            });
          }
          stopObserving(t3) {
            this.stopListening(t3);
          }
          fire(t3, e3, n2) {
            this.isEnabled && this.document.fire(t3, new Uc(this.view, e3, n2));
          }
        }
        class qc extends Hc {
          constructor() {
            super(...arguments), this.domEventType = ["keydown", "keyup"];
          }
          onDomEvent(t3) {
            const e3 = { keyCode: t3.keyCode, altKey: t3.altKey, ctrlKey: t3.ctrlKey, shiftKey: t3.shiftKey, metaKey: t3.metaKey, get keystroke() {
              return bi(this);
            } };
            this.fire(t3.type, t3, e3);
          }
        }
        const Gc = function() {
          return it.Date.now();
        };
        var Wc = /\s/;
        const Kc = function(t3) {
          for (var e3 = t3.length; e3-- && Wc.test(t3.charAt(e3)); )
            ;
          return e3;
        };
        var Zc = /^\s+/;
        const Yc = function(t3) {
          return t3 ? t3.slice(0, Kc(t3) + 1).replace(Zc, "") : t3;
        };
        var $c = /^[-+]0x[0-9a-f]+$/i, Qc = /^0b[01]+$/i, Jc = /^0o[0-7]+$/i, Xc = parseInt;
        const tl = function(t3) {
          if ("number" == typeof t3)
            return t3;
          if (Ds(t3))
            return NaN;
          if (j(t3)) {
            var e3 = "function" == typeof t3.valueOf ? t3.valueOf() : t3;
            t3 = j(e3) ? e3 + "" : e3;
          }
          if ("string" != typeof t3)
            return 0 === t3 ? t3 : +t3;
          t3 = Yc(t3);
          var n2 = Qc.test(t3);
          return n2 || Jc.test(t3) ? Xc(t3.slice(2), n2 ? 2 : 8) : $c.test(t3) ? NaN : +t3;
        };
        var el = Math.max, nl = Math.min;
        const ol = function(t3, e3, n2) {
          var o2, i2, r2, s3, a2, c2, l2 = 0, d2 = false, h2 = false, u2 = true;
          if ("function" != typeof t3)
            throw new TypeError("Expected a function");
          function g2(e4) {
            var n3 = o2, r3 = i2;
            return o2 = i2 = void 0, l2 = e4, s3 = t3.apply(r3, n3);
          }
          function p2(t4) {
            var n3 = t4 - c2;
            return void 0 === c2 || n3 >= e3 || n3 < 0 || h2 && t4 - l2 >= r2;
          }
          function m2() {
            var t4 = Gc();
            if (p2(t4))
              return f2(t4);
            a2 = setTimeout(m2, function(t5) {
              var n3 = e3 - (t5 - c2);
              return h2 ? nl(n3, r2 - (t5 - l2)) : n3;
            }(t4));
          }
          function f2(t4) {
            return a2 = void 0, u2 && o2 ? g2(t4) : (o2 = i2 = void 0, s3);
          }
          function k2() {
            var t4 = Gc(), n3 = p2(t4);
            if (o2 = arguments, i2 = this, c2 = t4, n3) {
              if (void 0 === a2)
                return function(t5) {
                  return l2 = t5, a2 = setTimeout(m2, e3), d2 ? g2(t5) : s3;
                }(c2);
              if (h2)
                return clearTimeout(a2), a2 = setTimeout(m2, e3), g2(c2);
            }
            return void 0 === a2 && (a2 = setTimeout(m2, e3)), s3;
          }
          return e3 = tl(e3) || 0, j(n2) && (d2 = !!n2.leading, r2 = (h2 = "maxWait" in n2) ? el(tl(n2.maxWait) || 0, e3) : r2, u2 = "trailing" in n2 ? !!n2.trailing : u2), k2.cancel = function() {
            void 0 !== a2 && clearTimeout(a2), l2 = 0, o2 = c2 = i2 = a2 = void 0;
          }, k2.flush = function() {
            return void 0 === a2 ? s3 : f2(Gc());
          }, k2;
        };
        class il extends Fc {
          constructor(t3) {
            super(t3), this._fireSelectionChangeDoneDebounced = ol((t4) => {
              this.document.fire("selectionChangeDone", t4);
            }, 200);
          }
          observe() {
            const t3 = this.document;
            t3.on("arrowKey", (e3, n2) => {
              t3.selection.isFake && this.isEnabled && n2.preventDefault();
            }, { context: "$capture" }), t3.on("arrowKey", (e3, n2) => {
              t3.selection.isFake && this.isEnabled && this._handleSelectionMove(n2.keyCode);
            }, { priority: "lowest" });
          }
          stopObserving() {
          }
          destroy() {
            super.destroy(), this._fireSelectionChangeDoneDebounced.cancel();
          }
          _handleSelectionMove(t3) {
            const e3 = this.document.selection, n2 = new za(e3.getRanges(), { backward: e3.isBackward, fake: false });
            t3 != fi.arrowleft && t3 != fi.arrowup || n2.setTo(n2.getFirstPosition()), t3 != fi.arrowright && t3 != fi.arrowdown || n2.setTo(n2.getLastPosition());
            const o2 = { oldSelection: e3, newSelection: n2, domSelection: null };
            this.document.fire("selectionChange", o2), this._fireSelectionChangeDoneDebounced(o2);
          }
        }
        const rl = function(t3) {
          return this.__data__.set(t3, "__lodash_hash_undefined__"), this;
        };
        const sl = function(t3) {
          return this.__data__.has(t3);
        };
        function al(t3) {
          var e3 = -1, n2 = null == t3 ? 0 : t3.length;
          for (this.__data__ = new Ce(); ++e3 < n2; )
            this.add(t3[e3]);
        }
        al.prototype.add = al.prototype.push = rl, al.prototype.has = sl;
        const cl = al;
        const ll = function(t3, e3) {
          for (var n2 = -1, o2 = null == t3 ? 0 : t3.length; ++n2 < o2; )
            if (e3(t3[n2], n2, t3))
              return true;
          return false;
        };
        const dl = function(t3, e3) {
          return t3.has(e3);
        };
        const hl = function(t3, e3, n2, o2, i2, r2) {
          var s3 = 1 & n2, a2 = t3.length, c2 = e3.length;
          if (a2 != c2 && !(s3 && c2 > a2))
            return false;
          var l2 = r2.get(t3), d2 = r2.get(e3);
          if (l2 && d2)
            return l2 == e3 && d2 == t3;
          var h2 = -1, u2 = true, g2 = 2 & n2 ? new cl() : void 0;
          for (r2.set(t3, e3), r2.set(e3, t3); ++h2 < a2; ) {
            var p2 = t3[h2], m2 = e3[h2];
            if (o2)
              var f2 = s3 ? o2(m2, p2, h2, e3, t3, r2) : o2(p2, m2, h2, t3, e3, r2);
            if (void 0 !== f2) {
              if (f2)
                continue;
              u2 = false;
              break;
            }
            if (g2) {
              if (!ll(e3, function(t4, e4) {
                if (!dl(g2, e4) && (p2 === t4 || i2(p2, t4, n2, o2, r2)))
                  return g2.push(e4);
              })) {
                u2 = false;
                break;
              }
            } else if (p2 !== m2 && !i2(p2, m2, n2, o2, r2)) {
              u2 = false;
              break;
            }
          }
          return r2.delete(t3), r2.delete(e3), u2;
        };
        const ul = function(t3) {
          var e3 = -1, n2 = Array(t3.size);
          return t3.forEach(function(t4, o2) {
            n2[++e3] = [o2, t4];
          }), n2;
        };
        const gl = function(t3) {
          var e3 = -1, n2 = Array(t3.size);
          return t3.forEach(function(t4) {
            n2[++e3] = t4;
          }), n2;
        };
        var pl = rt ? rt.prototype : void 0, ml = pl ? pl.valueOf : void 0;
        const fl = function(t3, e3, n2, o2, i2, r2, s3) {
          switch (n2) {
            case "[object DataView]":
              if (t3.byteLength != e3.byteLength || t3.byteOffset != e3.byteOffset)
                return false;
              t3 = t3.buffer, e3 = e3.buffer;
            case "[object ArrayBuffer]":
              return !(t3.byteLength != e3.byteLength || !r2(new Jn(t3), new Jn(e3)));
            case "[object Boolean]":
            case "[object Date]":
            case "[object Number]":
              return It(+t3, +e3);
            case "[object Error]":
              return t3.name == e3.name && t3.message == e3.message;
            case "[object RegExp]":
            case "[object String]":
              return t3 == e3 + "";
            case "[object Map]":
              var a2 = ul;
            case "[object Set]":
              var c2 = 1 & o2;
              if (a2 || (a2 = gl), t3.size != e3.size && !c2)
                return false;
              var l2 = s3.get(t3);
              if (l2)
                return l2 == e3;
              o2 |= 2, s3.set(t3, e3);
              var d2 = hl(a2(t3), a2(e3), o2, i2, r2, s3);
              return s3.delete(t3), d2;
            case "[object Symbol]":
              if (ml)
                return ml.call(t3) == ml.call(e3);
          }
          return false;
        };
        var kl = Object.prototype.hasOwnProperty;
        const bl = function(t3, e3, n2, o2, i2, r2) {
          var s3 = 1 & n2, a2 = Bn(t3), c2 = a2.length;
          if (c2 != Bn(e3).length && !s3)
            return false;
          for (var l2 = c2; l2--; ) {
            var d2 = a2[l2];
            if (!(s3 ? d2 in e3 : kl.call(e3, d2)))
              return false;
          }
          var h2 = r2.get(t3), u2 = r2.get(e3);
          if (h2 && u2)
            return h2 == e3 && u2 == t3;
          var g2 = true;
          r2.set(t3, e3), r2.set(e3, t3);
          for (var p2 = s3; ++l2 < c2; ) {
            var m2 = t3[d2 = a2[l2]], f2 = e3[d2];
            if (o2)
              var k2 = s3 ? o2(f2, m2, d2, e3, t3, r2) : o2(m2, f2, d2, t3, e3, r2);
            if (!(void 0 === k2 ? m2 === f2 || i2(m2, f2, n2, o2, r2) : k2)) {
              g2 = false;
              break;
            }
            p2 || (p2 = "constructor" == d2);
          }
          if (g2 && !p2) {
            var b10 = t3.constructor, w2 = e3.constructor;
            b10 == w2 || !("constructor" in t3) || !("constructor" in e3) || "function" == typeof b10 && b10 instanceof b10 && "function" == typeof w2 && w2 instanceof w2 || (g2 = false);
          }
          return r2.delete(t3), r2.delete(e3), g2;
        };
        var wl = "[object Arguments]", Al = "[object Array]", Cl = "[object Object]", _l = Object.prototype.hasOwnProperty;
        const vl = function(t3, e3, n2, o2, i2, r2) {
          var s3 = mt(t3), a2 = mt(e3), c2 = s3 ? Al : Yn(t3), l2 = a2 ? Al : Yn(e3), d2 = (c2 = c2 == wl ? Cl : c2) == Cl, h2 = (l2 = l2 == wl ? Cl : l2) == Cl, u2 = c2 == l2;
          if (u2 && Ve(t3)) {
            if (!Ve(e3))
              return false;
            s3 = true, d2 = false;
          }
          if (u2 && !d2)
            return r2 || (r2 = new ye()), s3 || Xe(t3) ? hl(t3, e3, n2, o2, i2, r2) : fl(t3, e3, c2, n2, o2, i2, r2);
          if (!(1 & n2)) {
            var g2 = d2 && _l.call(t3, "__wrapped__"), p2 = h2 && _l.call(e3, "__wrapped__");
            if (g2 || p2) {
              var m2 = g2 ? t3.value() : t3, f2 = p2 ? e3.value() : e3;
              return r2 || (r2 = new ye()), i2(m2, f2, n2, o2, r2);
            }
          }
          return !!u2 && (r2 || (r2 = new ye()), bl(t3, e3, n2, o2, i2, r2));
        };
        const yl = function t3(e3, n2, o2, i2, r2) {
          return e3 === n2 || (null == e3 || null == n2 || !ft(e3) && !ft(n2) ? e3 != e3 && n2 != n2 : vl(e3, n2, o2, i2, t3, r2));
        };
        const xl = function(t3, e3, n2) {
          var o2 = (n2 = "function" == typeof n2 ? n2 : void 0) ? n2(t3, e3) : void 0;
          return void 0 === o2 ? yl(t3, e3, void 0, n2) : !!o2;
        };
        class El extends Fc {
          constructor(t3) {
            super(t3), this._config = { childList: true, characterData: true, subtree: true }, this.domConverter = t3.domConverter, this.renderer = t3._renderer, this._domElements = /* @__PURE__ */ new Set(), this._mutationObserver = new window.MutationObserver(this._onMutations.bind(this));
          }
          flush() {
            this._onMutations(this._mutationObserver.takeRecords());
          }
          observe(t3) {
            this._domElements.add(t3), this.isEnabled && this._mutationObserver.observe(t3, this._config);
          }
          stopObserving(t3) {
            if (this._domElements.delete(t3), this.isEnabled) {
              this._mutationObserver.disconnect();
              for (const t4 of this._domElements)
                this._mutationObserver.observe(t4, this._config);
            }
          }
          enable() {
            super.enable();
            for (const t3 of this._domElements)
              this._mutationObserver.observe(t3, this._config);
          }
          disable() {
            super.disable(), this._mutationObserver.disconnect();
          }
          destroy() {
            super.destroy(), this._mutationObserver.disconnect();
          }
          _onMutations(t3) {
            if (0 === t3.length)
              return;
            const e3 = this.domConverter, n2 = /* @__PURE__ */ new Set(), o2 = /* @__PURE__ */ new Set();
            for (const n3 of t3) {
              const t4 = e3.mapDomToView(n3.target);
              t4 && (t4.is("uiElement") || t4.is("rawElement") || "childList" !== n3.type || this._isBogusBrMutation(n3) || o2.add(t4));
            }
            for (const i3 of t3) {
              const t4 = e3.mapDomToView(i3.target);
              if ((!t4 || !t4.is("uiElement") && !t4.is("rawElement")) && "characterData" === i3.type) {
                const t5 = e3.findCorrespondingViewText(i3.target);
                t5 && !o2.has(t5.parent) ? n2.add(t5) : !t5 && bc(i3.target) && o2.add(e3.mapDomToView(i3.target.parentNode));
              }
            }
            let i2 = false;
            for (const t4 of n2)
              i2 = true, this.renderer.markToSync("text", t4);
            for (const t4 of o2) {
              const n3 = e3.mapViewToDom(t4), o3 = Array.from(t4.getChildren()), r2 = Array.from(e3.domChildrenToView(n3, { withChildren: false }));
              xl(o3, r2, Dl) || (i2 = true, this.renderer.markToSync("children", t4));
            }
            i2 && this.view.forceRender();
          }
          _isBogusBrMutation(t3) {
            let e3 = null;
            return null === t3.nextSibling && 0 === t3.removedNodes.length && 1 == t3.addedNodes.length && (e3 = this.domConverter.domToView(t3.addedNodes[0], { withChildren: false })), e3 && e3.is("element", "br");
          }
        }
        function Dl(t3, e3) {
          if (!Array.isArray(t3))
            return t3 === e3 || !(!t3.is("$text") || !e3.is("$text")) && t3.data === e3.data;
        }
        class Il extends Hc {
          constructor(t3) {
            super(t3), this._isFocusChanging = false, this.domEventType = ["focus", "blur"], this.useCapture = true;
            const e3 = this.document;
            e3.on("focus", () => {
              this._isFocusChanging = true, this._renderTimeoutId = setTimeout(() => {
                this.flush(), t3.change(() => {
                });
              }, 50);
            }), e3.on("blur", (n2, o2) => {
              const i2 = e3.selection.editableElement;
              null !== i2 && i2 !== o2.target || (e3.isFocused = false, this._isFocusChanging = false, t3.change(() => {
              }));
            });
          }
          flush() {
            this._isFocusChanging && (this._isFocusChanging = false, this.document.isFocused = true);
          }
          onDomEvent(t3) {
            this.fire(t3.type, t3);
          }
          destroy() {
            this._renderTimeoutId && clearTimeout(this._renderTimeoutId), super.destroy();
          }
        }
        class Sl extends Fc {
          constructor(t3) {
            super(t3), this.mutationObserver = t3.getObserver(El), this.focusObserver = t3.getObserver(Il), this.selection = this.document.selection, this.domConverter = t3.domConverter, this._documents = /* @__PURE__ */ new WeakSet(), this._fireSelectionChangeDoneDebounced = ol((t4) => {
              this.document.fire("selectionChangeDone", t4);
            }, 200), this._clearInfiniteLoopInterval = setInterval(() => this._clearInfiniteLoop(), 1e3), this._documentIsSelectingInactivityTimeoutDebounced = ol(() => this.document.isSelecting = false, 5e3), this._loopbackCounter = 0;
          }
          observe(t3) {
            const e3 = t3.ownerDocument, n2 = () => {
              this.document.isSelecting && (this._handleSelectionChange(null, e3), this.document.isSelecting = false, this._documentIsSelectingInactivityTimeoutDebounced.cancel());
            };
            this.listenTo(t3, "selectstart", () => {
              this.document.isSelecting = true, this._documentIsSelectingInactivityTimeoutDebounced();
            }, { priority: "highest" }), this.listenTo(t3, "keydown", n2, { priority: "highest", useCapture: true }), this.listenTo(t3, "keyup", n2, { priority: "highest", useCapture: true }), this._documents.has(e3) || (this.listenTo(e3, "mouseup", n2, { priority: "highest", useCapture: true }), this.listenTo(e3, "selectionchange", (t4, n3) => {
              this.document.isComposing && !a.isAndroid || (this._handleSelectionChange(n3, e3), this._documentIsSelectingInactivityTimeoutDebounced());
            }), this._documents.add(e3));
          }
          stopObserving(t3) {
            this.stopListening(t3);
          }
          destroy() {
            super.destroy(), clearInterval(this._clearInfiniteLoopInterval), this._fireSelectionChangeDoneDebounced.cancel(), this._documentIsSelectingInactivityTimeoutDebounced.cancel();
          }
          _reportInfiniteLoop() {
          }
          _handleSelectionChange(t3, e3) {
            if (!this.isEnabled)
              return;
            const n2 = e3.defaultView.getSelection();
            if (this.checkShouldIgnoreEventFromTarget(n2.anchorNode))
              return;
            this.mutationObserver.flush();
            const o2 = this.domConverter.domSelectionToView(n2);
            if (0 != o2.rangeCount) {
              if (this.view.hasDomSelection = true, this.focusObserver.flush(), !this.selection.isEqual(o2) || !this.domConverter.isDomSelectionCorrect(n2))
                if (++this._loopbackCounter > 60)
                  this._reportInfiniteLoop();
                else if (this.selection.isSimilar(o2))
                  this.view.forceRender();
                else {
                  const t4 = { oldSelection: this.selection, newSelection: o2, domSelection: n2 };
                  this.document.fire("selectionChange", t4), this._fireSelectionChangeDoneDebounced(t4);
                }
            } else
              this.view.hasDomSelection = false;
          }
          _clearInfiniteLoop() {
            this._loopbackCounter = 0;
          }
        }
        class Tl extends Hc {
          constructor(t3) {
            super(t3), this.domEventType = ["compositionstart", "compositionupdate", "compositionend"];
            const e3 = this.document;
            e3.on("compositionstart", () => {
              e3.isComposing = true;
            }, { priority: "low" }), e3.on("compositionend", () => {
              e3.isComposing = false;
            }, { priority: "low" });
          }
          onDomEvent(t3) {
            this.fire(t3.type, t3, { data: t3.data });
          }
        }
        class Ml {
          constructor(t3, e3 = {}) {
            this._files = e3.cacheFiles ? Bl(t3) : null, this._native = t3;
          }
          get files() {
            return this._files || (this._files = Bl(this._native)), this._files;
          }
          get types() {
            return this._native.types;
          }
          getData(t3) {
            return this._native.getData(t3);
          }
          setData(t3, e3) {
            this._native.setData(t3, e3);
          }
          set effectAllowed(t3) {
            this._native.effectAllowed = t3;
          }
          get effectAllowed() {
            return this._native.effectAllowed;
          }
          set dropEffect(t3) {
            this._native.dropEffect = t3;
          }
          get dropEffect() {
            return this._native.dropEffect;
          }
          setDragImage(t3, e3, n2) {
            this._native.setDragImage(t3, e3, n2);
          }
          get isCanceled() {
            return "none" == this._native.dropEffect || !!this._native.mozUserCancelled;
          }
        }
        function Bl(t3) {
          const e3 = Array.from(t3.files || []), n2 = Array.from(t3.items || []);
          return e3.length ? e3 : n2.filter((t4) => "file" === t4.kind).map((t4) => t4.getAsFile());
        }
        class Nl extends Hc {
          constructor() {
            super(...arguments), this.domEventType = "beforeinput";
          }
          onDomEvent(t3) {
            const e3 = t3.getTargetRanges(), n2 = this.view, o2 = n2.document;
            let i2 = null, r2 = null, s3 = [];
            if (t3.dataTransfer && (i2 = new Ml(t3.dataTransfer)), null !== t3.data ? r2 = t3.data : i2 && (r2 = i2.getData("text/plain")), o2.selection.isFake)
              s3 = Array.from(o2.selection.getRanges());
            else if (e3.length)
              s3 = e3.map((t4) => {
                const e4 = n2.domConverter.domPositionToView(t4.startContainer, t4.startOffset), o3 = n2.domConverter.domPositionToView(t4.endContainer, t4.endOffset);
                return e4 ? n2.createRange(e4, o3) : o3 ? n2.createRange(o3) : void 0;
              }).filter((t4) => !!t4);
            else if (a.isAndroid) {
              const e4 = t3.target.ownerDocument.defaultView.getSelection();
              s3 = Array.from(n2.domConverter.domSelectionToView(e4).getRanges());
            }
            if (a.isAndroid && "insertCompositionText" == t3.inputType && r2 && r2.endsWith("\n"))
              this.fire(t3.type, t3, { inputType: "insertParagraph", targetRanges: [n2.createRange(s3[0].end)] });
            else if ("insertText" == t3.inputType && r2 && r2.includes("\n")) {
              const e4 = r2.split(/\n{1,2}/g);
              let n3 = s3;
              for (let r3 = 0; r3 < e4.length; r3++) {
                const s4 = e4[r3];
                "" != s4 && (this.fire(t3.type, t3, { data: s4, dataTransfer: i2, targetRanges: n3, inputType: t3.inputType, isComposing: t3.isComposing }), n3 = [o2.selection.getFirstRange()]), r3 + 1 < e4.length && (this.fire(t3.type, t3, { inputType: "insertParagraph", targetRanges: n3 }), n3 = [o2.selection.getFirstRange()]);
              }
            } else
              this.fire(t3.type, t3, { data: r2, dataTransfer: i2, targetRanges: s3, inputType: t3.inputType, isComposing: t3.isComposing });
          }
        }
        class Pl extends Fc {
          constructor(t3) {
            super(t3), this.document.on("keydown", (t4, e3) => {
              if (this.isEnabled && ((n2 = e3.keyCode) == fi.arrowright || n2 == fi.arrowleft || n2 == fi.arrowup || n2 == fi.arrowdown)) {
                const n3 = new La(this.document, "arrowKey", this.document.selection.getFirstRange());
                this.document.fire(n3, e3), n3.stop.called && t4.stop();
              }
              var n2;
            });
          }
          observe() {
          }
          stopObserving() {
          }
        }
        class zl extends Fc {
          constructor(t3) {
            super(t3);
            const e3 = this.document;
            e3.on("keydown", (t4, n2) => {
              if (!this.isEnabled || n2.keyCode != fi.tab || n2.ctrlKey)
                return;
              const o2 = new La(e3, "tab", e3.selection.getFirstRange());
              e3.fire(o2, n2), o2.stop.called && t4.stop();
            });
          }
          observe() {
          }
          stopObserving() {
          }
        }
        const Ol = function(t3) {
          return _o(t3, 5);
        };
        class Ll extends W() {
          constructor(t3) {
            super(), this.domRoots = /* @__PURE__ */ new Map(), this._initialDomRootAttributes = /* @__PURE__ */ new WeakMap(), this._observers = /* @__PURE__ */ new Map(), this._ongoingChange = false, this._postFixersInProgress = false, this._renderingDisabled = false, this._hasChangedSinceTheLastRendering = false, this.document = new qa(t3), this.domConverter = new zc(this.document), this.set("isRenderingInProgress", false), this.set("hasDomSelection", false), this._renderer = new yc(this.domConverter, this.document.selection), this._renderer.bind("isFocused", "isSelecting", "isComposing").to(this.document, "isFocused", "isSelecting", "isComposing"), this._writer = new nc(this.document), this.addObserver(El), this.addObserver(Il), this.addObserver(Sl), this.addObserver(qc), this.addObserver(il), this.addObserver(Tl), this.addObserver(Pl), this.addObserver(Nl), this.addObserver(zl), this.document.on("arrowKey", Cc, { priority: "low" }), Qa(this), this.on("render", () => {
              this._render(), this.document.fire("layoutChanged"), this._hasChangedSinceTheLastRendering = false;
            }), this.listenTo(this.document.selection, "change", () => {
              this._hasChangedSinceTheLastRendering = true;
            }), this.listenTo(this.document, "change:isFocused", () => {
              this._hasChangedSinceTheLastRendering = true;
            }), a.isiOS && this.listenTo(this.document, "blur", (t4, e3) => {
              this.domConverter.mapDomToView(e3.domEvent.relatedTarget) || this.domConverter._clearDomSelection();
            });
          }
          attachDomRoot(t3, e3 = "main") {
            const n2 = this.document.getRoot(e3);
            n2._name = t3.tagName.toLowerCase();
            const o2 = {};
            for (const { name: e4, value: i3 } of Array.from(t3.attributes))
              o2[e4] = i3, "class" === e4 ? this._writer.addClass(i3.split(" "), n2) : this._writer.setAttribute(e4, i3, n2);
            this._initialDomRootAttributes.set(t3, o2);
            const i2 = () => {
              this._writer.setAttribute("contenteditable", (!n2.isReadOnly).toString(), n2), n2.isReadOnly ? this._writer.addClass("ck-read-only", n2) : this._writer.removeClass("ck-read-only", n2);
            };
            i2(), this.domRoots.set(e3, t3), this.domConverter.bindElements(t3, n2), this._renderer.markToSync("children", n2), this._renderer.markToSync("attributes", n2), this._renderer.domDocuments.add(t3.ownerDocument), n2.on("change:children", (t4, e4) => this._renderer.markToSync("children", e4)), n2.on("change:attributes", (t4, e4) => this._renderer.markToSync("attributes", e4)), n2.on("change:text", (t4, e4) => this._renderer.markToSync("text", e4)), n2.on("change:isReadOnly", () => this.change(i2)), n2.on("change", () => {
              this._hasChangedSinceTheLastRendering = true;
            });
            for (const n3 of this._observers.values())
              n3.observe(t3, e3);
          }
          detachDomRoot(t3) {
            const e3 = this.domRoots.get(t3);
            Array.from(e3.attributes).forEach(({ name: t4 }) => e3.removeAttribute(t4));
            const n2 = this._initialDomRootAttributes.get(e3);
            for (const t4 in n2)
              e3.setAttribute(t4, n2[t4]);
            this.domRoots.delete(t3), this.domConverter.unbindDomElement(e3);
            for (const t4 of this._observers.values())
              t4.stopObserving(e3);
          }
          getDomRoot(t3 = "main") {
            return this.domRoots.get(t3);
          }
          addObserver(t3) {
            let e3 = this._observers.get(t3);
            if (e3)
              return e3;
            e3 = new t3(this), this._observers.set(t3, e3);
            for (const [t4, n2] of this.domRoots)
              e3.observe(n2, t4);
            return e3.enable(), e3;
          }
          getObserver(t3) {
            return this._observers.get(t3);
          }
          disableObservers() {
            for (const t3 of this._observers.values())
              t3.disable();
          }
          enableObservers() {
            for (const t3 of this._observers.values())
              t3.enable();
          }
          scrollToTheSelection({ alignToTop: t3, forceScroll: e3, viewportOffset: n2 = 20, ancestorOffset: o2 = 20 } = {}) {
            const i2 = this.document.selection.getFirstRange();
            if (!i2)
              return;
            const r2 = Ol({ alignToTop: t3, forceScroll: e3, viewportOffset: n2, ancestorOffset: o2 });
            "number" == typeof n2 && (n2 = { top: n2, bottom: n2, left: n2, right: n2 });
            const s3 = { target: this.domConverter.viewRangeToDom(i2), viewportOffset: n2, ancestorOffset: o2, alignToTop: t3, forceScroll: e3 };
            this.fire("scrollToTheSelection", s3, r2), function({ target: t4, viewportOffset: e4 = 0, ancestorOffset: n3 = 0, alignToTop: o3, forceScroll: i3 }) {
              const r3 = hi(t4);
              let s4 = r3, a2 = null;
              for (e4 = function(t5) {
                return "number" == typeof t5 ? { top: t5, bottom: t5, left: t5, right: t5 } : t5;
              }(e4); s4; ) {
                let c2;
                c2 = ui(s4 == r3 ? t4 : a2), si({ parent: c2, getRect: () => gi(t4, s4), alignToTop: o3, ancestorOffset: n3, forceScroll: i3 });
                const l2 = gi(t4, s4);
                if (ri({ window: s4, rect: l2, viewportOffset: e4, alignToTop: o3, forceScroll: i3 }), s4.parent != s4) {
                  if (a2 = s4.frameElement, s4 = s4.parent, !a2)
                    return;
                } else
                  s4 = null;
              }
            }(s3);
          }
          focus() {
            if (!this.document.isFocused) {
              const t3 = this.document.selection.editableElement;
              t3 && (this.domConverter.focus(t3), this.forceRender());
            }
          }
          change(t3) {
            if (this.isRenderingInProgress || this._postFixersInProgress)
              throw new A("cannot-change-view-tree", this);
            try {
              if (this._ongoingChange)
                return t3(this._writer);
              this._ongoingChange = true;
              const e3 = t3(this._writer);
              return this._ongoingChange = false, !this._renderingDisabled && this._hasChangedSinceTheLastRendering && (this._postFixersInProgress = true, this.document._callPostFixers(this._writer), this._postFixersInProgress = false, this.fire("render")), e3;
            } catch (t4) {
              A.rethrowUnexpectedError(t4, this);
            }
          }
          forceRender() {
            this._hasChangedSinceTheLastRendering = true, this.getObserver(Il).flush(), this.change(() => {
            });
          }
          destroy() {
            for (const t3 of this._observers.values())
              t3.destroy();
            this.document.destroy(), this.stopListening();
          }
          createPositionAt(t3, e3) {
            return Ba._createAt(t3, e3);
          }
          createPositionAfter(t3) {
            return Ba._createAfter(t3);
          }
          createPositionBefore(t3) {
            return Ba._createBefore(t3);
          }
          createRange(t3, e3) {
            return new Na(t3, e3);
          }
          createRangeOn(t3) {
            return Na._createOn(t3);
          }
          createRangeIn(t3) {
            return Na._createIn(t3);
          }
          createSelection(...t3) {
            return new za(...t3);
          }
          _disableRendering(t3) {
            this._renderingDisabled = t3, 0 == t3 && this.change(() => {
            });
          }
          _render() {
            this.isRenderingInProgress = true, this.disableObservers(), this._renderer.render(), this.enableObservers(), this.isRenderingInProgress = false;
          }
        }
        class Rl {
          is() {
            throw new Error("is() method is abstract");
          }
        }
        class jl extends Rl {
          constructor(t3) {
            super(), this.parent = null, this._attrs = Mi(t3);
          }
          get document() {
            return null;
          }
          get index() {
            let t3;
            if (!this.parent)
              return null;
            if (null === (t3 = this.parent.getChildIndex(this)))
              throw new A("model-node-not-found-in-parent", this);
            return t3;
          }
          get startOffset() {
            let t3;
            if (!this.parent)
              return null;
            if (null === (t3 = this.parent.getChildStartOffset(this)))
              throw new A("model-node-not-found-in-parent", this);
            return t3;
          }
          get offsetSize() {
            return 1;
          }
          get endOffset() {
            return this.parent ? this.startOffset + this.offsetSize : null;
          }
          get nextSibling() {
            const t3 = this.index;
            return null !== t3 && this.parent.getChild(t3 + 1) || null;
          }
          get previousSibling() {
            const t3 = this.index;
            return null !== t3 && this.parent.getChild(t3 - 1) || null;
          }
          get root() {
            let t3 = this;
            for (; t3.parent; )
              t3 = t3.parent;
            return t3;
          }
          isAttached() {
            return null !== this.parent && this.root.isAttached();
          }
          getPath() {
            const t3 = [];
            let e3 = this;
            for (; e3.parent; )
              t3.unshift(e3.startOffset), e3 = e3.parent;
            return t3;
          }
          getAncestors(t3 = {}) {
            const e3 = [];
            let n2 = t3.includeSelf ? this : this.parent;
            for (; n2; )
              e3[t3.parentFirst ? "push" : "unshift"](n2), n2 = n2.parent;
            return e3;
          }
          getCommonAncestor(t3, e3 = {}) {
            const n2 = this.getAncestors(e3), o2 = t3.getAncestors(e3);
            let i2 = 0;
            for (; n2[i2] == o2[i2] && n2[i2]; )
              i2++;
            return 0 === i2 ? null : n2[i2 - 1];
          }
          isBefore(t3) {
            if (this == t3)
              return false;
            if (this.root !== t3.root)
              return false;
            const e3 = this.getPath(), n2 = t3.getPath(), o2 = tt(e3, n2);
            switch (o2) {
              case "prefix":
                return true;
              case "extension":
                return false;
              default:
                return e3[o2] < n2[o2];
            }
          }
          isAfter(t3) {
            return this != t3 && (this.root === t3.root && !this.isBefore(t3));
          }
          hasAttribute(t3) {
            return this._attrs.has(t3);
          }
          getAttribute(t3) {
            return this._attrs.get(t3);
          }
          getAttributes() {
            return this._attrs.entries();
          }
          getAttributeKeys() {
            return this._attrs.keys();
          }
          toJSON() {
            const t3 = {};
            return this._attrs.size && (t3.attributes = Array.from(this._attrs).reduce((t4, e3) => (t4[e3[0]] = e3[1], t4), {})), t3;
          }
          _clone(t3) {
            return new this.constructor(this._attrs);
          }
          _remove() {
            this.parent._removeChildren(this.index);
          }
          _setAttribute(t3, e3) {
            this._attrs.set(t3, e3);
          }
          _setAttributesTo(t3) {
            this._attrs = Mi(t3);
          }
          _removeAttribute(t3) {
            return this._attrs.delete(t3);
          }
          _clearAttributes() {
            this._attrs.clear();
          }
        }
        jl.prototype.is = function(t3) {
          return "node" === t3 || "model:node" === t3;
        };
        class Fl {
          constructor(t3) {
            this._nodes = [], t3 && this._insertNodes(0, t3);
          }
          [Symbol.iterator]() {
            return this._nodes[Symbol.iterator]();
          }
          get length() {
            return this._nodes.length;
          }
          get maxOffset() {
            return this._nodes.reduce((t3, e3) => t3 + e3.offsetSize, 0);
          }
          getNode(t3) {
            return this._nodes[t3] || null;
          }
          getNodeIndex(t3) {
            const e3 = this._nodes.indexOf(t3);
            return -1 == e3 ? null : e3;
          }
          getNodeStartOffset(t3) {
            const e3 = this.getNodeIndex(t3);
            return null === e3 ? null : this._nodes.slice(0, e3).reduce((t4, e4) => t4 + e4.offsetSize, 0);
          }
          indexToOffset(t3) {
            if (t3 == this._nodes.length)
              return this.maxOffset;
            const e3 = this._nodes[t3];
            if (!e3)
              throw new A("model-nodelist-index-out-of-bounds", this);
            return this.getNodeStartOffset(e3);
          }
          offsetToIndex(t3) {
            let e3 = 0;
            for (const n2 of this._nodes) {
              if (t3 >= e3 && t3 < e3 + n2.offsetSize)
                return this.getNodeIndex(n2);
              e3 += n2.offsetSize;
            }
            if (e3 != t3)
              throw new A("model-nodelist-offset-out-of-bounds", this, { offset: t3, nodeList: this });
            return this.length;
          }
          _insertNodes(t3, e3) {
            for (const t4 of e3)
              if (!(t4 instanceof jl))
                throw new A("model-nodelist-insertnodes-not-node", this);
            this._nodes = function(t4, e4, n2, o2) {
              if (Math.max(e4.length, t4.length) > 1e4)
                return t4.slice(0, n2).concat(e4).concat(t4.slice(n2 + o2, t4.length));
              {
                const i2 = Array.from(t4);
                return i2.splice(n2, o2, ...e4), i2;
              }
            }(this._nodes, Array.from(e3), t3, 0);
          }
          _removeNodes(t3, e3 = 1) {
            return this._nodes.splice(t3, e3);
          }
          toJSON() {
            return this._nodes.map((t3) => t3.toJSON());
          }
        }
        class Vl extends jl {
          constructor(t3, e3) {
            super(e3), this._data = t3 || "";
          }
          get offsetSize() {
            return this.data.length;
          }
          get data() {
            return this._data;
          }
          toJSON() {
            const t3 = super.toJSON();
            return t3.data = this.data, t3;
          }
          _clone() {
            return new Vl(this.data, this.getAttributes());
          }
          static fromJSON(t3) {
            return new Vl(t3.data, t3.attributes);
          }
        }
        Vl.prototype.is = function(t3) {
          return "$text" === t3 || "model:$text" === t3 || "text" === t3 || "model:text" === t3 || "node" === t3 || "model:node" === t3;
        };
        class Ul extends Rl {
          constructor(t3, e3, n2) {
            if (super(), this.textNode = t3, e3 < 0 || e3 > t3.offsetSize)
              throw new A("model-textproxy-wrong-offsetintext", this);
            if (n2 < 0 || e3 + n2 > t3.offsetSize)
              throw new A("model-textproxy-wrong-length", this);
            this.data = t3.data.substring(e3, e3 + n2), this.offsetInText = e3;
          }
          get startOffset() {
            return null !== this.textNode.startOffset ? this.textNode.startOffset + this.offsetInText : null;
          }
          get offsetSize() {
            return this.data.length;
          }
          get endOffset() {
            return null !== this.startOffset ? this.startOffset + this.offsetSize : null;
          }
          get isPartial() {
            return this.offsetSize !== this.textNode.offsetSize;
          }
          get parent() {
            return this.textNode.parent;
          }
          get root() {
            return this.textNode.root;
          }
          getPath() {
            const t3 = this.textNode.getPath();
            return t3.length > 0 && (t3[t3.length - 1] += this.offsetInText), t3;
          }
          getAncestors(t3 = {}) {
            const e3 = [];
            let n2 = t3.includeSelf ? this : this.parent;
            for (; n2; )
              e3[t3.parentFirst ? "push" : "unshift"](n2), n2 = n2.parent;
            return e3;
          }
          hasAttribute(t3) {
            return this.textNode.hasAttribute(t3);
          }
          getAttribute(t3) {
            return this.textNode.getAttribute(t3);
          }
          getAttributes() {
            return this.textNode.getAttributes();
          }
          getAttributeKeys() {
            return this.textNode.getAttributeKeys();
          }
        }
        Ul.prototype.is = function(t3) {
          return "$textProxy" === t3 || "model:$textProxy" === t3 || "textProxy" === t3 || "model:textProxy" === t3;
        };
        class Hl extends jl {
          constructor(t3, e3, n2) {
            super(e3), this._children = new Fl(), this.name = t3, n2 && this._insertChild(0, n2);
          }
          get childCount() {
            return this._children.length;
          }
          get maxOffset() {
            return this._children.maxOffset;
          }
          get isEmpty() {
            return 0 === this.childCount;
          }
          getChild(t3) {
            return this._children.getNode(t3);
          }
          getChildren() {
            return this._children[Symbol.iterator]();
          }
          getChildIndex(t3) {
            return this._children.getNodeIndex(t3);
          }
          getChildStartOffset(t3) {
            return this._children.getNodeStartOffset(t3);
          }
          offsetToIndex(t3) {
            return this._children.offsetToIndex(t3);
          }
          getNodeByPath(t3) {
            let e3 = this;
            for (const n2 of t3)
              e3 = e3.getChild(e3.offsetToIndex(n2));
            return e3;
          }
          findAncestor(t3, e3 = {}) {
            let n2 = e3.includeSelf ? this : this.parent;
            for (; n2; ) {
              if (n2.name === t3)
                return n2;
              n2 = n2.parent;
            }
            return null;
          }
          toJSON() {
            const t3 = super.toJSON();
            if (t3.name = this.name, this._children.length > 0) {
              t3.children = [];
              for (const e3 of this._children)
                t3.children.push(e3.toJSON());
            }
            return t3;
          }
          _clone(t3 = false) {
            const e3 = t3 ? Array.from(this._children).map((t4) => t4._clone(true)) : void 0;
            return new Hl(this.name, this.getAttributes(), e3);
          }
          _appendChild(t3) {
            this._insertChild(this.childCount, t3);
          }
          _insertChild(t3, e3) {
            const n2 = function(t4) {
              if ("string" == typeof t4)
                return [new Vl(t4)];
              et(t4) || (t4 = [t4]);
              return Array.from(t4).map((t5) => "string" == typeof t5 ? new Vl(t5) : t5 instanceof Ul ? new Vl(t5.data, t5.getAttributes()) : t5);
            }(e3);
            for (const t4 of n2)
              null !== t4.parent && t4._remove(), t4.parent = this;
            this._children._insertNodes(t3, n2);
          }
          _removeChildren(t3, e3 = 1) {
            const n2 = this._children._removeNodes(t3, e3);
            for (const t4 of n2)
              t4.parent = null;
            return n2;
          }
          static fromJSON(t3) {
            let e3;
            if (t3.children) {
              e3 = [];
              for (const n2 of t3.children)
                n2.name ? e3.push(Hl.fromJSON(n2)) : e3.push(Vl.fromJSON(n2));
            }
            return new Hl(t3.name, t3.attributes, e3);
          }
        }
        Hl.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("element" === t3 || "model:element" === t3) : "element" === t3 || "model:element" === t3 || "node" === t3 || "model:node" === t3;
        };
        class ql {
          constructor(t3) {
            if (!t3 || !t3.boundaries && !t3.startPosition)
              throw new A("model-tree-walker-no-start-position", null);
            const e3 = t3.direction || "forward";
            if ("forward" != e3 && "backward" != e3)
              throw new A("model-tree-walker-unknown-direction", t3, { direction: e3 });
            this.direction = e3, this.boundaries = t3.boundaries || null, t3.startPosition ? this._position = t3.startPosition.clone() : this._position = Wl._createAt(this.boundaries["backward" == this.direction ? "end" : "start"]), this.position.stickiness = "toNone", this.singleCharacters = !!t3.singleCharacters, this.shallow = !!t3.shallow, this.ignoreElementEnd = !!t3.ignoreElementEnd, this._boundaryStartParent = this.boundaries ? this.boundaries.start.parent : null, this._boundaryEndParent = this.boundaries ? this.boundaries.end.parent : null, this._visitedParent = this.position.parent;
          }
          [Symbol.iterator]() {
            return this;
          }
          get position() {
            return this._position;
          }
          skip(t3) {
            let e3, n2, o2, i2;
            do {
              o2 = this.position, i2 = this._visitedParent, { done: e3, value: n2 } = this.next();
            } while (!e3 && t3(n2));
            e3 || (this._position = o2, this._visitedParent = i2);
          }
          next() {
            return "forward" == this.direction ? this._next() : this._previous();
          }
          _next() {
            const t3 = this.position, e3 = this.position.clone(), n2 = this._visitedParent;
            if (null === n2.parent && e3.offset === n2.maxOffset)
              return { done: true, value: void 0 };
            if (n2 === this._boundaryEndParent && e3.offset == this.boundaries.end.offset)
              return { done: true, value: void 0 };
            const o2 = Kl(e3, n2), i2 = o2 || Zl(e3, n2, o2);
            if (i2 instanceof Hl) {
              if (this.shallow) {
                if (this.boundaries && this.boundaries.end.isBefore(e3))
                  return { done: true, value: void 0 };
                e3.offset++;
              } else
                e3.path.push(0), this._visitedParent = i2;
              return this._position = e3, Gl("elementStart", i2, t3, e3, 1);
            }
            if (i2 instanceof Vl) {
              let o3;
              if (this.singleCharacters)
                o3 = 1;
              else {
                let t4 = i2.endOffset;
                this._boundaryEndParent == n2 && this.boundaries.end.offset < t4 && (t4 = this.boundaries.end.offset), o3 = t4 - e3.offset;
              }
              const r2 = e3.offset - i2.startOffset, s3 = new Ul(i2, r2, o3);
              return e3.offset += o3, this._position = e3, Gl("text", s3, t3, e3, o3);
            }
            return e3.path.pop(), e3.offset++, this._position = e3, this._visitedParent = n2.parent, this.ignoreElementEnd ? this._next() : Gl("elementEnd", n2, t3, e3);
          }
          _previous() {
            const t3 = this.position, e3 = this.position.clone(), n2 = this._visitedParent;
            if (null === n2.parent && 0 === e3.offset)
              return { done: true, value: void 0 };
            if (n2 == this._boundaryStartParent && e3.offset == this.boundaries.start.offset)
              return { done: true, value: void 0 };
            const o2 = e3.parent, i2 = Kl(e3, o2), r2 = i2 || Yl(e3, o2, i2);
            if (r2 instanceof Hl)
              return e3.offset--, this.shallow ? (this._position = e3, Gl("elementStart", r2, t3, e3, 1)) : (e3.path.push(r2.maxOffset), this._position = e3, this._visitedParent = r2, this.ignoreElementEnd ? this._previous() : Gl("elementEnd", r2, t3, e3));
            if (r2 instanceof Vl) {
              let o3;
              if (this.singleCharacters)
                o3 = 1;
              else {
                let t4 = r2.startOffset;
                this._boundaryStartParent == n2 && this.boundaries.start.offset > t4 && (t4 = this.boundaries.start.offset), o3 = e3.offset - t4;
              }
              const i3 = e3.offset - r2.startOffset, s3 = new Ul(r2, i3 - o3, o3);
              return e3.offset -= o3, this._position = e3, Gl("text", s3, t3, e3, o3);
            }
            return e3.path.pop(), this._position = e3, this._visitedParent = n2.parent, Gl("elementStart", n2, t3, e3, 1);
          }
        }
        function Gl(t3, e3, n2, o2, i2) {
          return { done: false, value: { type: t3, item: e3, previousPosition: n2, nextPosition: o2, length: i2 } };
        }
        class Wl extends Rl {
          constructor(t3, e3, n2 = "toNone") {
            if (super(), !t3.is("element") && !t3.is("documentFragment"))
              throw new A("model-position-root-invalid", t3);
            if (!(e3 instanceof Array) || 0 === e3.length)
              throw new A("model-position-path-incorrect-format", t3, { path: e3 });
            t3.is("rootElement") ? e3 = e3.slice() : (e3 = [...t3.getPath(), ...e3], t3 = t3.root), this.root = t3, this.path = e3, this.stickiness = n2;
          }
          get offset() {
            return this.path[this.path.length - 1];
          }
          set offset(t3) {
            this.path[this.path.length - 1] = t3;
          }
          get parent() {
            let t3 = this.root;
            for (let e3 = 0; e3 < this.path.length - 1; e3++)
              if (t3 = t3.getChild(t3.offsetToIndex(this.path[e3])), !t3)
                throw new A("model-position-path-incorrect", this, { position: this });
            if (t3.is("$text"))
              throw new A("model-position-path-incorrect", this, { position: this });
            return t3;
          }
          get index() {
            return this.parent.offsetToIndex(this.offset);
          }
          get textNode() {
            return Kl(this, this.parent);
          }
          get nodeAfter() {
            const t3 = this.parent;
            return Zl(this, t3, Kl(this, t3));
          }
          get nodeBefore() {
            const t3 = this.parent;
            return Yl(this, t3, Kl(this, t3));
          }
          get isAtStart() {
            return 0 === this.offset;
          }
          get isAtEnd() {
            return this.offset == this.parent.maxOffset;
          }
          compareWith(t3) {
            if (this.root != t3.root)
              return "different";
            const e3 = tt(this.path, t3.path);
            switch (e3) {
              case "same":
                return "same";
              case "prefix":
                return "before";
              case "extension":
                return "after";
              default:
                return this.path[e3] < t3.path[e3] ? "before" : "after";
            }
          }
          getLastMatchingPosition(t3, e3 = {}) {
            e3.startPosition = this;
            const n2 = new ql(e3);
            return n2.skip(t3), n2.position;
          }
          getParentPath() {
            return this.path.slice(0, -1);
          }
          getAncestors() {
            const t3 = this.parent;
            return t3.is("documentFragment") ? [t3] : t3.getAncestors({ includeSelf: true });
          }
          findAncestor(t3) {
            const e3 = this.parent;
            return e3.is("element") ? e3.findAncestor(t3, { includeSelf: true }) : null;
          }
          getCommonPath(t3) {
            if (this.root != t3.root)
              return [];
            const e3 = tt(this.path, t3.path), n2 = "string" == typeof e3 ? Math.min(this.path.length, t3.path.length) : e3;
            return this.path.slice(0, n2);
          }
          getCommonAncestor(t3) {
            const e3 = this.getAncestors(), n2 = t3.getAncestors();
            let o2 = 0;
            for (; e3[o2] == n2[o2] && e3[o2]; )
              o2++;
            return 0 === o2 ? null : e3[o2 - 1];
          }
          getShiftedBy(t3) {
            const e3 = this.clone(), n2 = e3.offset + t3;
            return e3.offset = n2 < 0 ? 0 : n2, e3;
          }
          isAfter(t3) {
            return "after" == this.compareWith(t3);
          }
          isBefore(t3) {
            return "before" == this.compareWith(t3);
          }
          isEqual(t3) {
            return "same" == this.compareWith(t3);
          }
          isTouching(t3) {
            if (this.root !== t3.root)
              return false;
            const e3 = Math.min(this.path.length, t3.path.length);
            for (let n2 = 0; n2 < e3; n2++) {
              const e4 = this.path[n2] - t3.path[n2];
              if (e4 < -1 || e4 > 1)
                return false;
              if (1 === e4)
                return $l(t3, this, n2);
              if (-1 === e4)
                return $l(this, t3, n2);
            }
            return this.path.length === t3.path.length || (this.path.length > t3.path.length ? Ql(this.path, e3) : Ql(t3.path, e3));
          }
          hasSameParentAs(t3) {
            if (this.root !== t3.root)
              return false;
            return "same" == tt(this.getParentPath(), t3.getParentPath());
          }
          getTransformedByOperation(t3) {
            let e3;
            switch (t3.type) {
              case "insert":
                e3 = this._getTransformedByInsertOperation(t3);
                break;
              case "move":
              case "remove":
              case "reinsert":
                e3 = this._getTransformedByMoveOperation(t3);
                break;
              case "split":
                e3 = this._getTransformedBySplitOperation(t3);
                break;
              case "merge":
                e3 = this._getTransformedByMergeOperation(t3);
                break;
              default:
                e3 = Wl._createAt(this);
            }
            return e3;
          }
          _getTransformedByInsertOperation(t3) {
            return this._getTransformedByInsertion(t3.position, t3.howMany);
          }
          _getTransformedByMoveOperation(t3) {
            return this._getTransformedByMove(t3.sourcePosition, t3.targetPosition, t3.howMany);
          }
          _getTransformedBySplitOperation(t3) {
            const e3 = t3.movedRange;
            return e3.containsPosition(this) || e3.start.isEqual(this) && "toNext" == this.stickiness ? this._getCombined(t3.splitPosition, t3.moveTargetPosition) : t3.graveyardPosition ? this._getTransformedByMove(t3.graveyardPosition, t3.insertionPosition, 1) : this._getTransformedByInsertion(t3.insertionPosition, 1);
          }
          _getTransformedByMergeOperation(t3) {
            const e3 = t3.movedRange;
            let n2;
            return e3.containsPosition(this) || e3.start.isEqual(this) ? (n2 = this._getCombined(t3.sourcePosition, t3.targetPosition), t3.sourcePosition.isBefore(t3.targetPosition) && (n2 = n2._getTransformedByDeletion(t3.deletionPosition, 1))) : n2 = this.isEqual(t3.deletionPosition) ? Wl._createAt(t3.deletionPosition) : this._getTransformedByMove(t3.deletionPosition, t3.graveyardPosition, 1), n2;
          }
          _getTransformedByDeletion(t3, e3) {
            const n2 = Wl._createAt(this);
            if (this.root != t3.root)
              return n2;
            if ("same" == tt(t3.getParentPath(), this.getParentPath())) {
              if (t3.offset < this.offset) {
                if (t3.offset + e3 > this.offset)
                  return null;
                n2.offset -= e3;
              }
            } else if ("prefix" == tt(t3.getParentPath(), this.getParentPath())) {
              const o2 = t3.path.length - 1;
              if (t3.offset <= this.path[o2]) {
                if (t3.offset + e3 > this.path[o2])
                  return null;
                n2.path[o2] -= e3;
              }
            }
            return n2;
          }
          _getTransformedByInsertion(t3, e3) {
            const n2 = Wl._createAt(this);
            if (this.root != t3.root)
              return n2;
            if ("same" == tt(t3.getParentPath(), this.getParentPath()))
              (t3.offset < this.offset || t3.offset == this.offset && "toPrevious" != this.stickiness) && (n2.offset += e3);
            else if ("prefix" == tt(t3.getParentPath(), this.getParentPath())) {
              const o2 = t3.path.length - 1;
              t3.offset <= this.path[o2] && (n2.path[o2] += e3);
            }
            return n2;
          }
          _getTransformedByMove(t3, e3, n2) {
            if (e3 = e3._getTransformedByDeletion(t3, n2), t3.isEqual(e3))
              return Wl._createAt(this);
            const o2 = this._getTransformedByDeletion(t3, n2);
            return null === o2 || t3.isEqual(this) && "toNext" == this.stickiness || t3.getShiftedBy(n2).isEqual(this) && "toPrevious" == this.stickiness ? this._getCombined(t3, e3) : o2._getTransformedByInsertion(e3, n2);
          }
          _getCombined(t3, e3) {
            const n2 = t3.path.length - 1, o2 = Wl._createAt(e3);
            return o2.stickiness = this.stickiness, o2.offset = o2.offset + this.path[n2] - t3.offset, o2.path = [...o2.path, ...this.path.slice(n2 + 1)], o2;
          }
          toJSON() {
            return { root: this.root.toJSON(), path: Array.from(this.path), stickiness: this.stickiness };
          }
          clone() {
            return new this.constructor(this.root, this.path, this.stickiness);
          }
          static _createAt(t3, e3, n2 = "toNone") {
            if (t3 instanceof Wl)
              return new Wl(t3.root, t3.path, t3.stickiness);
            {
              const o2 = t3;
              if ("end" == e3)
                e3 = o2.maxOffset;
              else {
                if ("before" == e3)
                  return this._createBefore(o2, n2);
                if ("after" == e3)
                  return this._createAfter(o2, n2);
                if (0 !== e3 && !e3)
                  throw new A("model-createpositionat-offset-required", [this, t3]);
              }
              if (!o2.is("element") && !o2.is("documentFragment"))
                throw new A("model-position-parent-incorrect", [this, t3]);
              const i2 = o2.getPath();
              return i2.push(e3), new this(o2.root, i2, n2);
            }
          }
          static _createAfter(t3, e3) {
            if (!t3.parent)
              throw new A("model-position-after-root", [this, t3], { root: t3 });
            return this._createAt(t3.parent, t3.endOffset, e3);
          }
          static _createBefore(t3, e3) {
            if (!t3.parent)
              throw new A("model-position-before-root", t3, { root: t3 });
            return this._createAt(t3.parent, t3.startOffset, e3);
          }
          static fromJSON(t3, e3) {
            if ("$graveyard" === t3.root) {
              const n2 = new Wl(e3.graveyard, t3.path);
              return n2.stickiness = t3.stickiness, n2;
            }
            if (!e3.getRoot(t3.root))
              throw new A("model-position-fromjson-no-root", e3, { rootName: t3.root });
            return new Wl(e3.getRoot(t3.root), t3.path, t3.stickiness);
          }
        }
        function Kl(t3, e3) {
          const n2 = e3.getChild(e3.offsetToIndex(t3.offset));
          return n2 && n2.is("$text") && n2.startOffset < t3.offset ? n2 : null;
        }
        function Zl(t3, e3, n2) {
          return null !== n2 ? null : e3.getChild(e3.offsetToIndex(t3.offset));
        }
        function Yl(t3, e3, n2) {
          return null !== n2 ? null : e3.getChild(e3.offsetToIndex(t3.offset) - 1);
        }
        function $l(t3, e3, n2) {
          return n2 + 1 !== t3.path.length && (!!Ql(e3.path, n2 + 1) && !!function(t4, e4) {
            let n3 = t4.parent, o2 = t4.path.length - 1, i2 = 0;
            for (; o2 >= e4; ) {
              if (t4.path[o2] + i2 !== n3.maxOffset)
                return false;
              i2 = 1, o2--, n3 = n3.parent;
            }
            return true;
          }(t3, n2 + 1));
        }
        function Ql(t3, e3) {
          for (; e3 < t3.length; ) {
            if (0 !== t3[e3])
              return false;
            e3++;
          }
          return true;
        }
        Wl.prototype.is = function(t3) {
          return "position" === t3 || "model:position" === t3;
        };
        class Jl extends Rl {
          constructor(t3, e3) {
            super(), this.start = Wl._createAt(t3), this.end = e3 ? Wl._createAt(e3) : Wl._createAt(t3), this.start.stickiness = this.isCollapsed ? "toNone" : "toNext", this.end.stickiness = this.isCollapsed ? "toNone" : "toPrevious";
          }
          *[Symbol.iterator]() {
            yield* __yieldStar(new ql({ boundaries: this, ignoreElementEnd: true }));
          }
          get isCollapsed() {
            return this.start.isEqual(this.end);
          }
          get isFlat() {
            return "same" == tt(this.start.getParentPath(), this.end.getParentPath());
          }
          get root() {
            return this.start.root;
          }
          containsPosition(t3) {
            return t3.isAfter(this.start) && t3.isBefore(this.end);
          }
          containsRange(t3, e3 = false) {
            t3.isCollapsed && (e3 = false);
            const n2 = this.containsPosition(t3.start) || e3 && this.start.isEqual(t3.start), o2 = this.containsPosition(t3.end) || e3 && this.end.isEqual(t3.end);
            return n2 && o2;
          }
          containsItem(t3) {
            const e3 = Wl._createBefore(t3);
            return this.containsPosition(e3) || this.start.isEqual(e3);
          }
          isEqual(t3) {
            return this.start.isEqual(t3.start) && this.end.isEqual(t3.end);
          }
          isIntersecting(t3) {
            return this.start.isBefore(t3.end) && this.end.isAfter(t3.start);
          }
          getDifference(t3) {
            const e3 = [];
            return this.isIntersecting(t3) ? (this.containsPosition(t3.start) && e3.push(new Jl(this.start, t3.start)), this.containsPosition(t3.end) && e3.push(new Jl(t3.end, this.end))) : e3.push(new Jl(this.start, this.end)), e3;
          }
          getIntersection(t3) {
            if (this.isIntersecting(t3)) {
              let e3 = this.start, n2 = this.end;
              return this.containsPosition(t3.start) && (e3 = t3.start), this.containsPosition(t3.end) && (n2 = t3.end), new Jl(e3, n2);
            }
            return null;
          }
          getJoined(t3, e3 = false) {
            let n2 = this.isIntersecting(t3);
            if (n2 || (n2 = this.start.isBefore(t3.start) ? e3 ? this.end.isTouching(t3.start) : this.end.isEqual(t3.start) : e3 ? t3.end.isTouching(this.start) : t3.end.isEqual(this.start)), !n2)
              return null;
            let o2 = this.start, i2 = this.end;
            return t3.start.isBefore(o2) && (o2 = t3.start), t3.end.isAfter(i2) && (i2 = t3.end), new Jl(o2, i2);
          }
          getMinimalFlatRanges() {
            const t3 = [], e3 = this.start.getCommonPath(this.end).length, n2 = Wl._createAt(this.start);
            let o2 = n2.parent;
            for (; n2.path.length > e3 + 1; ) {
              const e4 = o2.maxOffset - n2.offset;
              0 !== e4 && t3.push(new Jl(n2, n2.getShiftedBy(e4))), n2.path = n2.path.slice(0, -1), n2.offset++, o2 = o2.parent;
            }
            for (; n2.path.length <= this.end.path.length; ) {
              const e4 = this.end.path[n2.path.length - 1], o3 = e4 - n2.offset;
              0 !== o3 && t3.push(new Jl(n2, n2.getShiftedBy(o3))), n2.offset = e4, n2.path.push(0);
            }
            return t3;
          }
          getWalker(t3 = {}) {
            return t3.boundaries = this, new ql(t3);
          }
          *getItems(t3 = {}) {
            t3.boundaries = this, t3.ignoreElementEnd = true;
            const e3 = new ql(t3);
            for (const t4 of e3)
              yield t4.item;
          }
          *getPositions(t3 = {}) {
            t3.boundaries = this;
            const e3 = new ql(t3);
            yield e3.position;
            for (const t4 of e3)
              yield t4.nextPosition;
          }
          getTransformedByOperation(t3) {
            switch (t3.type) {
              case "insert":
                return this._getTransformedByInsertOperation(t3);
              case "move":
              case "remove":
              case "reinsert":
                return this._getTransformedByMoveOperation(t3);
              case "split":
                return [this._getTransformedBySplitOperation(t3)];
              case "merge":
                return [this._getTransformedByMergeOperation(t3)];
            }
            return [new Jl(this.start, this.end)];
          }
          getTransformedByOperations(t3) {
            const e3 = [new Jl(this.start, this.end)];
            for (const n2 of t3)
              for (let t4 = 0; t4 < e3.length; t4++) {
                const o2 = e3[t4].getTransformedByOperation(n2);
                e3.splice(t4, 1, ...o2), t4 += o2.length - 1;
              }
            for (let t4 = 0; t4 < e3.length; t4++) {
              const n2 = e3[t4];
              for (let o2 = t4 + 1; o2 < e3.length; o2++) {
                const t5 = e3[o2];
                (n2.containsRange(t5) || t5.containsRange(n2) || n2.isEqual(t5)) && e3.splice(o2, 1);
              }
            }
            return e3;
          }
          getCommonAncestor() {
            return this.start.getCommonAncestor(this.end);
          }
          getContainedElement() {
            if (this.isCollapsed)
              return null;
            const t3 = this.start.nodeAfter, e3 = this.end.nodeBefore;
            return t3 && t3.is("element") && t3 === e3 ? t3 : null;
          }
          toJSON() {
            return { start: this.start.toJSON(), end: this.end.toJSON() };
          }
          clone() {
            return new this.constructor(this.start, this.end);
          }
          _getTransformedByInsertOperation(t3, e3 = false) {
            return this._getTransformedByInsertion(t3.position, t3.howMany, e3);
          }
          _getTransformedByMoveOperation(t3, e3 = false) {
            const n2 = t3.sourcePosition, o2 = t3.howMany, i2 = t3.targetPosition;
            return this._getTransformedByMove(n2, i2, o2, e3);
          }
          _getTransformedBySplitOperation(t3) {
            const e3 = this.start._getTransformedBySplitOperation(t3);
            let n2 = this.end._getTransformedBySplitOperation(t3);
            return this.end.isEqual(t3.insertionPosition) && (n2 = this.end.getShiftedBy(1)), e3.root != n2.root && (n2 = this.end.getShiftedBy(-1)), new Jl(e3, n2);
          }
          _getTransformedByMergeOperation(t3) {
            if (this.start.isEqual(t3.targetPosition) && this.end.isEqual(t3.deletionPosition))
              return new Jl(this.start);
            let e3 = this.start._getTransformedByMergeOperation(t3), n2 = this.end._getTransformedByMergeOperation(t3);
            return e3.root != n2.root && (n2 = this.end.getShiftedBy(-1)), e3.isAfter(n2) ? (t3.sourcePosition.isBefore(t3.targetPosition) ? (e3 = Wl._createAt(n2), e3.offset = 0) : (t3.deletionPosition.isEqual(e3) || (n2 = t3.deletionPosition), e3 = t3.targetPosition), new Jl(e3, n2)) : new Jl(e3, n2);
          }
          _getTransformedByInsertion(t3, e3, n2 = false) {
            if (n2 && this.containsPosition(t3))
              return [new Jl(this.start, t3), new Jl(t3.getShiftedBy(e3), this.end._getTransformedByInsertion(t3, e3))];
            {
              const n3 = new Jl(this.start, this.end);
              return n3.start = n3.start._getTransformedByInsertion(t3, e3), n3.end = n3.end._getTransformedByInsertion(t3, e3), [n3];
            }
          }
          _getTransformedByMove(t3, e3, n2, o2 = false) {
            if (this.isCollapsed) {
              const o3 = this.start._getTransformedByMove(t3, e3, n2);
              return [new Jl(o3)];
            }
            const i2 = Jl._createFromPositionAndShift(t3, n2), r2 = e3._getTransformedByDeletion(t3, n2);
            if (this.containsPosition(e3) && !o2 && (i2.containsPosition(this.start) || i2.containsPosition(this.end))) {
              const o3 = this.start._getTransformedByMove(t3, e3, n2), i3 = this.end._getTransformedByMove(t3, e3, n2);
              return [new Jl(o3, i3)];
            }
            let s3;
            const a2 = this.getDifference(i2);
            let c2 = null;
            const l2 = this.getIntersection(i2);
            if (1 == a2.length ? c2 = new Jl(a2[0].start._getTransformedByDeletion(t3, n2), a2[0].end._getTransformedByDeletion(t3, n2)) : 2 == a2.length && (c2 = new Jl(this.start, this.end._getTransformedByDeletion(t3, n2))), s3 = c2 ? c2._getTransformedByInsertion(r2, n2, null !== l2 || o2) : [], l2) {
              const t4 = new Jl(l2.start._getCombined(i2.start, r2), l2.end._getCombined(i2.start, r2));
              2 == s3.length ? s3.splice(1, 0, t4) : s3.push(t4);
            }
            return s3;
          }
          _getTransformedByDeletion(t3, e3) {
            let n2 = this.start._getTransformedByDeletion(t3, e3), o2 = this.end._getTransformedByDeletion(t3, e3);
            return null == n2 && null == o2 ? null : (null == n2 && (n2 = t3), null == o2 && (o2 = t3), new Jl(n2, o2));
          }
          static _createFromPositionAndShift(t3, e3) {
            const n2 = t3, o2 = t3.getShiftedBy(e3);
            return e3 > 0 ? new this(n2, o2) : new this(o2, n2);
          }
          static _createIn(t3) {
            return new this(Wl._createAt(t3, 0), Wl._createAt(t3, t3.maxOffset));
          }
          static _createOn(t3) {
            return this._createFromPositionAndShift(Wl._createBefore(t3), t3.offsetSize);
          }
          static _createFromRanges(t3) {
            if (0 === t3.length)
              throw new A("range-create-from-ranges-empty-array", null);
            if (1 == t3.length)
              return t3[0].clone();
            const e3 = t3[0];
            t3.sort((t4, e4) => t4.start.isAfter(e4.start) ? 1 : -1);
            const n2 = t3.indexOf(e3), o2 = new this(e3.start, e3.end);
            if (n2 > 0)
              for (let e4 = n2 - 1; t3[e4].end.isEqual(o2.start); e4++)
                o2.start = Wl._createAt(t3[e4].start);
            for (let e4 = n2 + 1; e4 < t3.length && t3[e4].start.isEqual(o2.end); e4++)
              o2.end = Wl._createAt(t3[e4].end);
            return o2;
          }
          static fromJSON(t3, e3) {
            return new this(Wl.fromJSON(t3.start, e3), Wl.fromJSON(t3.end, e3));
          }
        }
        Jl.prototype.is = function(t3) {
          return "range" === t3 || "model:range" === t3;
        };
        class Xl extends M() {
          constructor() {
            super(), this._modelToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelLengthCallbacks = /* @__PURE__ */ new Map(), this._markerNameToElements = /* @__PURE__ */ new Map(), this._elementToMarkerNames = /* @__PURE__ */ new Map(), this._deferredBindingRemovals = /* @__PURE__ */ new Map(), this._unboundMarkerNames = /* @__PURE__ */ new Set(), this.on("modelToViewPosition", (t3, e3) => {
              if (e3.viewPosition)
                return;
              const n2 = this._modelToViewMapping.get(e3.modelPosition.parent);
              if (!n2)
                throw new A("mapping-model-position-view-parent-not-found", this, { modelPosition: e3.modelPosition });
              e3.viewPosition = this.findPositionIn(n2, e3.modelPosition.offset);
            }, { priority: "low" }), this.on("viewToModelPosition", (t3, e3) => {
              if (e3.modelPosition)
                return;
              const n2 = this.findMappedViewAncestor(e3.viewPosition), o2 = this._viewToModelMapping.get(n2), i2 = this._toModelOffset(e3.viewPosition.parent, e3.viewPosition.offset, n2);
              e3.modelPosition = Wl._createAt(o2, i2);
            }, { priority: "low" });
          }
          bindElements(t3, e3) {
            this._modelToViewMapping.set(t3, e3), this._viewToModelMapping.set(e3, t3);
          }
          unbindViewElement(t3, e3 = {}) {
            const n2 = this.toModelElement(t3);
            if (this._elementToMarkerNames.has(t3))
              for (const e4 of this._elementToMarkerNames.get(t3))
                this._unboundMarkerNames.add(e4);
            e3.defer ? this._deferredBindingRemovals.set(t3, t3.root) : (this._viewToModelMapping.delete(t3), this._modelToViewMapping.get(n2) == t3 && this._modelToViewMapping.delete(n2));
          }
          unbindModelElement(t3) {
            const e3 = this.toViewElement(t3);
            this._modelToViewMapping.delete(t3), this._viewToModelMapping.get(e3) == t3 && this._viewToModelMapping.delete(e3);
          }
          bindElementToMarker(t3, e3) {
            const n2 = this._markerNameToElements.get(e3) || /* @__PURE__ */ new Set();
            n2.add(t3);
            const o2 = this._elementToMarkerNames.get(t3) || /* @__PURE__ */ new Set();
            o2.add(e3), this._markerNameToElements.set(e3, n2), this._elementToMarkerNames.set(t3, o2);
          }
          unbindElementFromMarkerName(t3, e3) {
            const n2 = this._markerNameToElements.get(e3);
            n2 && (n2.delete(t3), 0 == n2.size && this._markerNameToElements.delete(e3));
            const o2 = this._elementToMarkerNames.get(t3);
            o2 && (o2.delete(e3), 0 == o2.size && this._elementToMarkerNames.delete(t3));
          }
          flushUnboundMarkerNames() {
            const t3 = Array.from(this._unboundMarkerNames);
            return this._unboundMarkerNames.clear(), t3;
          }
          flushDeferredBindings() {
            for (const [t3, e3] of this._deferredBindingRemovals)
              t3.root == e3 && this.unbindViewElement(t3);
            this._deferredBindingRemovals = /* @__PURE__ */ new Map();
          }
          clearBindings() {
            this._modelToViewMapping = /* @__PURE__ */ new WeakMap(), this._viewToModelMapping = /* @__PURE__ */ new WeakMap(), this._markerNameToElements = /* @__PURE__ */ new Map(), this._elementToMarkerNames = /* @__PURE__ */ new Map(), this._unboundMarkerNames = /* @__PURE__ */ new Set(), this._deferredBindingRemovals = /* @__PURE__ */ new Map();
          }
          toModelElement(t3) {
            return this._viewToModelMapping.get(t3);
          }
          toViewElement(t3) {
            return this._modelToViewMapping.get(t3);
          }
          toModelRange(t3) {
            return new Jl(this.toModelPosition(t3.start), this.toModelPosition(t3.end));
          }
          toViewRange(t3) {
            return new Na(this.toViewPosition(t3.start), this.toViewPosition(t3.end));
          }
          toModelPosition(t3) {
            const e3 = { viewPosition: t3, mapper: this };
            return this.fire("viewToModelPosition", e3), e3.modelPosition;
          }
          toViewPosition(t3, e3 = {}) {
            const n2 = { modelPosition: t3, mapper: this, isPhantom: e3.isPhantom };
            return this.fire("modelToViewPosition", n2), n2.viewPosition;
          }
          markerNameToElements(t3) {
            const e3 = this._markerNameToElements.get(t3);
            if (!e3)
              return null;
            const n2 = /* @__PURE__ */ new Set();
            for (const t4 of e3)
              if (t4.is("attributeElement"))
                for (const e4 of t4.getElementsWithSameId())
                  n2.add(e4);
              else
                n2.add(t4);
            return n2;
          }
          registerViewToModelLength(t3, e3) {
            this._viewToModelLengthCallbacks.set(t3, e3);
          }
          findMappedViewAncestor(t3) {
            let e3 = t3.parent;
            for (; !this._viewToModelMapping.has(e3); )
              e3 = e3.parent;
            return e3;
          }
          _toModelOffset(t3, e3, n2) {
            if (n2 != t3) {
              return this._toModelOffset(t3.parent, t3.index, n2) + this._toModelOffset(t3, e3, t3);
            }
            if (t3.is("$text"))
              return e3;
            let o2 = 0;
            for (let n3 = 0; n3 < e3; n3++)
              o2 += this.getModelLength(t3.getChild(n3));
            return o2;
          }
          getModelLength(t3) {
            if (this._viewToModelLengthCallbacks.get(t3.name)) {
              return this._viewToModelLengthCallbacks.get(t3.name)(t3);
            }
            if (this._viewToModelMapping.has(t3))
              return 1;
            if (t3.is("$text"))
              return t3.data.length;
            if (t3.is("uiElement"))
              return 0;
            {
              let e3 = 0;
              for (const n2 of t3.getChildren())
                e3 += this.getModelLength(n2);
              return e3;
            }
          }
          findPositionIn(t3, e3) {
            let n2, o2 = 0, i2 = 0, r2 = 0;
            if (t3.is("$text"))
              return new Ba(t3, e3);
            for (; i2 < e3; )
              n2 = t3.getChild(r2), o2 = this.getModelLength(n2), i2 += o2, r2++;
            return i2 == e3 ? this._moveViewPositionToTextNode(new Ba(t3, r2)) : this.findPositionIn(n2, e3 - (i2 - o2));
          }
          _moveViewPositionToTextNode(t3) {
            const e3 = t3.nodeBefore, n2 = t3.nodeAfter;
            return e3 instanceof _s ? new Ba(e3, e3.data.length) : n2 instanceof _s ? new Ba(n2, 0) : t3;
          }
        }
        class td {
          constructor() {
            this._consumable = /* @__PURE__ */ new Map(), this._textProxyRegistry = /* @__PURE__ */ new Map();
          }
          add(t3, e3) {
            e3 = ed(e3), t3 instanceof Ul && (t3 = this._getSymbolForTextProxy(t3)), this._consumable.has(t3) || this._consumable.set(t3, /* @__PURE__ */ new Map()), this._consumable.get(t3).set(e3, true);
          }
          consume(t3, e3) {
            return e3 = ed(e3), t3 instanceof Ul && (t3 = this._getSymbolForTextProxy(t3)), !!this.test(t3, e3) && (this._consumable.get(t3).set(e3, false), true);
          }
          test(t3, e3) {
            e3 = ed(e3), t3 instanceof Ul && (t3 = this._getSymbolForTextProxy(t3));
            const n2 = this._consumable.get(t3);
            if (void 0 === n2)
              return null;
            const o2 = n2.get(e3);
            return void 0 === o2 ? null : o2;
          }
          revert(t3, e3) {
            e3 = ed(e3), t3 instanceof Ul && (t3 = this._getSymbolForTextProxy(t3));
            const n2 = this.test(t3, e3);
            return false === n2 ? (this._consumable.get(t3).set(e3, true), true) : true !== n2 && null;
          }
          verifyAllConsumed(t3) {
            const e3 = [];
            for (const [n2, o2] of this._consumable)
              for (const [i2, r2] of o2) {
                const o3 = i2.split(":")[0];
                r2 && t3 == o3 && e3.push({ event: i2, item: n2.name || n2.description });
              }
            if (e3.length)
              throw new A("conversion-model-consumable-not-consumed", null, { items: e3 });
          }
          _getSymbolForTextProxy(t3) {
            let e3 = null;
            const n2 = this._textProxyRegistry.get(t3.startOffset);
            if (n2) {
              const o2 = n2.get(t3.endOffset);
              o2 && (e3 = o2.get(t3.parent));
            }
            return e3 || (e3 = this._addSymbolForTextProxy(t3)), e3;
          }
          _addSymbolForTextProxy(t3) {
            const e3 = t3.startOffset, n2 = t3.endOffset, o2 = t3.parent, i2 = Symbol("$textProxy:" + t3.data);
            let r2, s3;
            return r2 = this._textProxyRegistry.get(e3), r2 || (r2 = /* @__PURE__ */ new Map(), this._textProxyRegistry.set(e3, r2)), s3 = r2.get(n2), s3 || (s3 = /* @__PURE__ */ new Map(), r2.set(n2, s3)), s3.set(o2, i2), i2;
          }
        }
        function ed(t3) {
          const e3 = t3.split(":");
          return "insert" == e3[0] ? e3[0] : "addMarker" == e3[0] || "removeMarker" == e3[0] ? t3 : e3.length > 1 ? e3[0] + ":" + e3[1] : e3[0];
        }
        var nd = Object.defineProperty, od = Object.defineProperties, id = Object.getOwnPropertyDescriptors, rd = Object.getOwnPropertySymbols, sd = Object.prototype.hasOwnProperty, ad = Object.prototype.propertyIsEnumerable, cd = (t3, e3, n2) => e3 in t3 ? nd(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, ld = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            sd.call(e3, n2) && cd(t3, n2, e3[n2]);
          if (rd)
            for (var n2 of rd(e3))
              ad.call(e3, n2) && cd(t3, n2, e3[n2]);
          return t3;
        }, dd = (t3, e3) => od(t3, id(e3));
        class hd extends M() {
          constructor(t3) {
            super(), this._conversionApi = ld({ dispatcher: this }, t3), this._firedEventsMap = /* @__PURE__ */ new WeakMap();
          }
          convertChanges(t3, e3, n2) {
            const o2 = this._createConversionApi(n2, t3.getRefreshedItems());
            for (const e4 of t3.getMarkersToRemove())
              this._convertMarkerRemove(e4.name, e4.range, o2);
            const i2 = this._reduceChanges(t3.getChanges());
            for (const t4 of i2)
              "insert" === t4.type ? this._convertInsert(Jl._createFromPositionAndShift(t4.position, t4.length), o2) : "reinsert" === t4.type ? this._convertReinsert(Jl._createFromPositionAndShift(t4.position, t4.length), o2) : "remove" === t4.type ? this._convertRemove(t4.position, t4.length, t4.name, o2) : this._convertAttribute(t4.range, t4.attributeKey, t4.attributeOldValue, t4.attributeNewValue, o2);
            o2.mapper.flushDeferredBindings();
            for (const t4 of o2.mapper.flushUnboundMarkerNames()) {
              const n3 = e3.get(t4).getRange();
              this._convertMarkerRemove(t4, n3, o2), this._convertMarkerAdd(t4, n3, o2);
            }
            for (const e4 of t3.getMarkersToAdd())
              this._convertMarkerAdd(e4.name, e4.range, o2);
            o2.consumable.verifyAllConsumed("insert");
          }
          convert(t3, e3, n2, o2 = {}) {
            const i2 = this._createConversionApi(n2, void 0, o2);
            this._convertInsert(t3, i2);
            for (const [t4, n3] of e3)
              this._convertMarkerAdd(t4, n3, i2);
            i2.consumable.verifyAllConsumed("insert");
          }
          convertSelection(t3, e3, n2) {
            const o2 = this._createConversionApi(n2);
            this.fire("cleanSelection", { selection: t3 }, o2);
            const i2 = t3.getFirstPosition().root;
            if (!o2.mapper.toViewElement(i2))
              return;
            const r2 = Array.from(e3.getMarkersAtPosition(t3.getFirstPosition()));
            if (this._addConsumablesForSelection(o2.consumable, t3, r2), this.fire("selection", { selection: t3 }, o2), t3.isCollapsed) {
              for (const e4 of r2)
                if (o2.consumable.test(t3, "addMarker:" + e4.name)) {
                  const n3 = e4.getRange();
                  if (!ud(t3.getFirstPosition(), e4, o2.mapper))
                    continue;
                  const i3 = { item: t3, markerName: e4.name, markerRange: n3 };
                  this.fire(`addMarker:${e4.name}`, i3, o2);
                }
              for (const e4 of t3.getAttributeKeys())
                if (o2.consumable.test(t3, "attribute:" + e4)) {
                  const n3 = { item: t3, range: t3.getFirstRange(), attributeKey: e4, attributeOldValue: null, attributeNewValue: t3.getAttribute(e4) };
                  this.fire(`attribute:${e4}:$text`, n3, o2);
                }
            }
          }
          _convertInsert(t3, e3, n2 = {}) {
            n2.doNotAddConsumables || this._addConsumablesForInsert(e3.consumable, t3);
            for (const n3 of Array.from(t3.getWalker({ shallow: true })).map(gd))
              this._testAndFire("insert", n3, e3);
          }
          _convertRemove(t3, e3, n2, o2) {
            this.fire(`remove:${n2}`, { position: t3, length: e3 }, o2);
          }
          _convertAttribute(t3, e3, n2, o2, i2) {
            this._addConsumablesForRange(i2.consumable, t3, `attribute:${e3}`);
            for (const r2 of t3) {
              const t4 = { item: r2.item, range: Jl._createFromPositionAndShift(r2.previousPosition, r2.length), attributeKey: e3, attributeOldValue: n2, attributeNewValue: o2 };
              this._testAndFire(`attribute:${e3}`, t4, i2);
            }
          }
          _convertReinsert(t3, e3) {
            const n2 = Array.from(t3.getWalker({ shallow: true }));
            this._addConsumablesForInsert(e3.consumable, n2);
            for (const t4 of n2.map(gd))
              this._testAndFire("insert", dd(ld({}, t4), { reconversion: true }), e3);
          }
          _convertMarkerAdd(t3, e3, n2) {
            if ("$graveyard" == e3.root.rootName)
              return;
            const o2 = `addMarker:${t3}`;
            if (n2.consumable.add(e3, o2), this.fire(o2, { markerName: t3, markerRange: e3 }, n2), n2.consumable.consume(e3, o2)) {
              this._addConsumablesForRange(n2.consumable, e3, o2);
              for (const i2 of e3.getItems()) {
                if (!n2.consumable.test(i2, o2))
                  continue;
                const r2 = { item: i2, range: Jl._createOn(i2), markerName: t3, markerRange: e3 };
                this.fire(o2, r2, n2);
              }
            }
          }
          _convertMarkerRemove(t3, e3, n2) {
            "$graveyard" != e3.root.rootName && this.fire(`removeMarker:${t3}`, { markerName: t3, markerRange: e3 }, n2);
          }
          _reduceChanges(t3) {
            const e3 = { changes: t3 };
            return this.fire("reduceChanges", e3), e3.changes;
          }
          _addConsumablesForInsert(t3, e3) {
            for (const n2 of e3) {
              const e4 = n2.item;
              if (null === t3.test(e4, "insert")) {
                t3.add(e4, "insert");
                for (const n3 of e4.getAttributeKeys())
                  t3.add(e4, "attribute:" + n3);
              }
            }
            return t3;
          }
          _addConsumablesForRange(t3, e3, n2) {
            for (const o2 of e3.getItems())
              t3.add(o2, n2);
            return t3;
          }
          _addConsumablesForSelection(t3, e3, n2) {
            t3.add(e3, "selection");
            for (const o2 of n2)
              t3.add(e3, "addMarker:" + o2.name);
            for (const n3 of e3.getAttributeKeys())
              t3.add(e3, "attribute:" + n3);
            return t3;
          }
          _testAndFire(t3, e3, n2) {
            const o2 = function(t4, e4) {
              const n3 = e4.item.is("element") ? e4.item.name : "$text";
              return `${t4}:${n3}`;
            }(t3, e3), i2 = e3.item.is("$textProxy") ? n2.consumable._getSymbolForTextProxy(e3.item) : e3.item, r2 = this._firedEventsMap.get(n2), s3 = r2.get(i2);
            if (s3) {
              if (s3.has(o2))
                return;
              s3.add(o2);
            } else
              r2.set(i2, /* @__PURE__ */ new Set([o2]));
            this.fire(o2, e3, n2);
          }
          _testAndFireAddAttributes(t3, e3) {
            const n2 = { item: t3, range: Jl._createOn(t3) };
            for (const t4 of n2.item.getAttributeKeys())
              n2.attributeKey = t4, n2.attributeOldValue = null, n2.attributeNewValue = n2.item.getAttribute(t4), this._testAndFire(`attribute:${t4}`, n2, e3);
          }
          _createConversionApi(t3, e3 = /* @__PURE__ */ new Set(), n2 = {}) {
            const o2 = dd(ld({}, this._conversionApi), { consumable: new td(), writer: t3, options: n2, convertItem: (t4) => this._convertInsert(Jl._createOn(t4), o2), convertChildren: (t4) => this._convertInsert(Jl._createIn(t4), o2, { doNotAddConsumables: true }), convertAttributes: (t4) => this._testAndFireAddAttributes(t4, o2), canReuseView: (t4) => !e3.has(o2.mapper.toModelElement(t4)) });
            return this._firedEventsMap.set(o2, /* @__PURE__ */ new Map()), o2;
          }
        }
        function ud(t3, e3, n2) {
          const o2 = e3.getRange(), i2 = Array.from(t3.getAncestors());
          i2.shift(), i2.reverse();
          return !i2.some((t4) => {
            if (o2.containsItem(t4)) {
              return !!n2.toViewElement(t4).getCustomProperty("addHighlight");
            }
          });
        }
        function gd(t3) {
          return { item: t3.item, range: Jl._createFromPositionAndShift(t3.previousPosition, t3.length) };
        }
        class pd extends M(Rl) {
          constructor(...t3) {
            super(), this._lastRangeBackward = false, this._attrs = /* @__PURE__ */ new Map(), this._ranges = [], t3.length && this.setTo(...t3);
          }
          get anchor() {
            if (this._ranges.length > 0) {
              const t3 = this._ranges[this._ranges.length - 1];
              return this._lastRangeBackward ? t3.end : t3.start;
            }
            return null;
          }
          get focus() {
            if (this._ranges.length > 0) {
              const t3 = this._ranges[this._ranges.length - 1];
              return this._lastRangeBackward ? t3.start : t3.end;
            }
            return null;
          }
          get isCollapsed() {
            return 1 === this._ranges.length && this._ranges[0].isCollapsed;
          }
          get rangeCount() {
            return this._ranges.length;
          }
          get isBackward() {
            return !this.isCollapsed && this._lastRangeBackward;
          }
          isEqual(t3) {
            if (this.rangeCount != t3.rangeCount)
              return false;
            if (0 === this.rangeCount)
              return true;
            if (!this.anchor.isEqual(t3.anchor) || !this.focus.isEqual(t3.focus))
              return false;
            for (const e3 of this._ranges) {
              let n2 = false;
              for (const o2 of t3._ranges)
                if (e3.isEqual(o2)) {
                  n2 = true;
                  break;
                }
              if (!n2)
                return false;
            }
            return true;
          }
          *getRanges() {
            for (const t3 of this._ranges)
              yield new Jl(t3.start, t3.end);
          }
          getFirstRange() {
            let t3 = null;
            for (const e3 of this._ranges)
              t3 && !e3.start.isBefore(t3.start) || (t3 = e3);
            return t3 ? new Jl(t3.start, t3.end) : null;
          }
          getLastRange() {
            let t3 = null;
            for (const e3 of this._ranges)
              t3 && !e3.end.isAfter(t3.end) || (t3 = e3);
            return t3 ? new Jl(t3.start, t3.end) : null;
          }
          getFirstPosition() {
            const t3 = this.getFirstRange();
            return t3 ? t3.start.clone() : null;
          }
          getLastPosition() {
            const t3 = this.getLastRange();
            return t3 ? t3.end.clone() : null;
          }
          setTo(...t3) {
            let [e3, n2, o2] = t3;
            if ("object" == typeof n2 && (o2 = n2, n2 = void 0), null === e3)
              this._setRanges([]);
            else if (e3 instanceof pd)
              this._setRanges(e3.getRanges(), e3.isBackward);
            else if (e3 && "function" == typeof e3.getRanges)
              this._setRanges(e3.getRanges(), e3.isBackward);
            else if (e3 instanceof Jl)
              this._setRanges([e3], !!o2 && !!o2.backward);
            else if (e3 instanceof Wl)
              this._setRanges([new Jl(e3)]);
            else if (e3 instanceof jl) {
              const t4 = !!o2 && !!o2.backward;
              let i2;
              if ("in" == n2)
                i2 = Jl._createIn(e3);
              else if ("on" == n2)
                i2 = Jl._createOn(e3);
              else {
                if (void 0 === n2)
                  throw new A("model-selection-setto-required-second-parameter", [this, e3]);
                i2 = new Jl(Wl._createAt(e3, n2));
              }
              this._setRanges([i2], t4);
            } else {
              if (!et(e3))
                throw new A("model-selection-setto-not-selectable", [this, e3]);
              this._setRanges(e3, o2 && !!o2.backward);
            }
          }
          _setRanges(t3, e3 = false) {
            const n2 = Array.from(t3), o2 = n2.some((e4) => {
              if (!(e4 instanceof Jl))
                throw new A("model-selection-set-ranges-not-range", [this, t3]);
              return this._ranges.every((t4) => !t4.isEqual(e4));
            });
            (n2.length !== this._ranges.length || o2) && (this._replaceAllRanges(n2), this._lastRangeBackward = !!e3, this.fire("change:range", { directChange: true }));
          }
          setFocus(t3, e3) {
            if (null === this.anchor)
              throw new A("model-selection-setfocus-no-ranges", [this, t3]);
            const n2 = Wl._createAt(t3, e3);
            if ("same" == n2.compareWith(this.focus))
              return;
            const o2 = this.anchor;
            this._ranges.length && this._popRange(), "before" == n2.compareWith(o2) ? (this._pushRange(new Jl(n2, o2)), this._lastRangeBackward = true) : (this._pushRange(new Jl(o2, n2)), this._lastRangeBackward = false), this.fire("change:range", { directChange: true });
          }
          getAttribute(t3) {
            return this._attrs.get(t3);
          }
          getAttributes() {
            return this._attrs.entries();
          }
          getAttributeKeys() {
            return this._attrs.keys();
          }
          hasAttribute(t3) {
            return this._attrs.has(t3);
          }
          removeAttribute(t3) {
            this.hasAttribute(t3) && (this._attrs.delete(t3), this.fire("change:attribute", { attributeKeys: [t3], directChange: true }));
          }
          setAttribute(t3, e3) {
            this.getAttribute(t3) !== e3 && (this._attrs.set(t3, e3), this.fire("change:attribute", { attributeKeys: [t3], directChange: true }));
          }
          getSelectedElement() {
            return 1 !== this.rangeCount ? null : this.getFirstRange().getContainedElement();
          }
          *getSelectedBlocks() {
            const t3 = /* @__PURE__ */ new WeakSet();
            for (const e3 of this.getRanges()) {
              const n2 = kd(e3.start, t3);
              wd(n2, e3) && (yield n2);
              for (const n3 of e3.getWalker()) {
                const o3 = n3.item;
                "elementEnd" == n3.type && fd(o3, t3, e3) && (yield o3);
              }
              const o2 = kd(e3.end, t3);
              Ad(o2, e3) && (yield o2);
            }
          }
          containsEntireContent(t3 = this.anchor.root) {
            const e3 = Wl._createAt(t3, 0), n2 = Wl._createAt(t3, "end");
            return e3.isTouching(this.getFirstPosition()) && n2.isTouching(this.getLastPosition());
          }
          _pushRange(t3) {
            this._checkRange(t3), this._ranges.push(new Jl(t3.start, t3.end));
          }
          _checkRange(t3) {
            for (let e3 = 0; e3 < this._ranges.length; e3++)
              if (t3.isIntersecting(this._ranges[e3]))
                throw new A("model-selection-range-intersects", [this, t3], { addedRange: t3, intersectingRange: this._ranges[e3] });
          }
          _replaceAllRanges(t3) {
            this._removeAllRanges();
            for (const e3 of t3)
              this._pushRange(e3);
          }
          _removeAllRanges() {
            for (; this._ranges.length > 0; )
              this._popRange();
          }
          _popRange() {
            this._ranges.pop();
          }
        }
        function md(t3, e3) {
          return !e3.has(t3) && (e3.add(t3), t3.root.document.model.schema.isBlock(t3) && !!t3.parent);
        }
        function fd(t3, e3, n2) {
          return md(t3, e3) && bd(t3, n2);
        }
        function kd(t3, e3) {
          const n2 = t3.parent.root.document.model.schema, o2 = t3.parent.getAncestors({ parentFirst: true, includeSelf: true });
          let i2 = false;
          const r2 = o2.find((t4) => !i2 && (i2 = n2.isLimit(t4), !i2 && md(t4, e3)));
          return o2.forEach((t4) => e3.add(t4)), r2;
        }
        function bd(t3, e3) {
          const n2 = function(t4) {
            const e4 = t4.root.document.model.schema;
            let n3 = t4.parent;
            for (; n3; ) {
              if (e4.isBlock(n3))
                return n3;
              n3 = n3.parent;
            }
          }(t3);
          if (!n2)
            return true;
          return !e3.containsRange(Jl._createOn(n2), true);
        }
        function wd(t3, e3) {
          return !!t3 && (!(!e3.isCollapsed && !t3.isEmpty) || !e3.start.isTouching(Wl._createAt(t3, t3.maxOffset)) && bd(t3, e3));
        }
        function Ad(t3, e3) {
          return !!t3 && (!(!e3.isCollapsed && !t3.isEmpty) || !e3.end.isTouching(Wl._createAt(t3, 0)) && bd(t3, e3));
        }
        pd.prototype.is = function(t3) {
          return "selection" === t3 || "model:selection" === t3;
        };
        class Cd extends M(Jl) {
          constructor(t3, e3) {
            super(t3, e3), _d.call(this);
          }
          detach() {
            this.stopListening();
          }
          toRange() {
            return new Jl(this.start, this.end);
          }
          static fromRange(t3) {
            return new Cd(t3.start, t3.end);
          }
        }
        function _d() {
          this.listenTo(this.root.document.model, "applyOperation", (t3, e3) => {
            const n2 = e3[0];
            n2.isDocumentOperation && vd.call(this, n2);
          }, { priority: "low" });
        }
        function vd(t3) {
          const e3 = this.getTransformedByOperation(t3), n2 = Jl._createFromRanges(e3), o2 = !n2.isEqual(this), i2 = function(t4, e4) {
            switch (e4.type) {
              case "insert":
                return t4.containsPosition(e4.position);
              case "move":
              case "remove":
              case "reinsert":
              case "merge":
                return t4.containsPosition(e4.sourcePosition) || t4.start.isEqual(e4.sourcePosition) || t4.containsPosition(e4.targetPosition);
              case "split":
                return t4.containsPosition(e4.splitPosition) || t4.containsPosition(e4.insertionPosition);
            }
            return false;
          }(this, t3);
          let r2 = null;
          if (o2) {
            "$graveyard" == n2.root.rootName && (r2 = "remove" == t3.type ? t3.sourcePosition : t3.deletionPosition);
            const e4 = this.toRange();
            this.start = n2.start, this.end = n2.end, this.fire("change:range", e4, { deletionPosition: r2 });
          } else
            i2 && this.fire("change:content", this.toRange(), { deletionPosition: r2 });
        }
        Cd.prototype.is = function(t3) {
          return "liveRange" === t3 || "model:liveRange" === t3 || "range" == t3 || "model:range" === t3;
        };
        const yd = "selection:";
        class xd extends M(Rl) {
          constructor(t3) {
            super(), this._selection = new Ed(t3), this._selection.delegate("change:range").to(this), this._selection.delegate("change:attribute").to(this), this._selection.delegate("change:marker").to(this);
          }
          get isCollapsed() {
            return this._selection.isCollapsed;
          }
          get anchor() {
            return this._selection.anchor;
          }
          get focus() {
            return this._selection.focus;
          }
          get rangeCount() {
            return this._selection.rangeCount;
          }
          get hasOwnRange() {
            return this._selection.hasOwnRange;
          }
          get isBackward() {
            return this._selection.isBackward;
          }
          get isGravityOverridden() {
            return this._selection.isGravityOverridden;
          }
          get markers() {
            return this._selection.markers;
          }
          get _ranges() {
            return this._selection._ranges;
          }
          getRanges() {
            return this._selection.getRanges();
          }
          getFirstPosition() {
            return this._selection.getFirstPosition();
          }
          getLastPosition() {
            return this._selection.getLastPosition();
          }
          getFirstRange() {
            return this._selection.getFirstRange();
          }
          getLastRange() {
            return this._selection.getLastRange();
          }
          getSelectedBlocks() {
            return this._selection.getSelectedBlocks();
          }
          getSelectedElement() {
            return this._selection.getSelectedElement();
          }
          containsEntireContent(t3) {
            return this._selection.containsEntireContent(t3);
          }
          destroy() {
            this._selection.destroy();
          }
          getAttributeKeys() {
            return this._selection.getAttributeKeys();
          }
          getAttributes() {
            return this._selection.getAttributes();
          }
          getAttribute(t3) {
            return this._selection.getAttribute(t3);
          }
          hasAttribute(t3) {
            return this._selection.hasAttribute(t3);
          }
          refresh() {
            this._selection.updateMarkers(), this._selection._updateAttributes(false);
          }
          observeMarkers(t3) {
            this._selection.observeMarkers(t3);
          }
          _setFocus(t3, e3) {
            this._selection.setFocus(t3, e3);
          }
          _setTo(...t3) {
            this._selection.setTo(...t3);
          }
          _setAttribute(t3, e3) {
            this._selection.setAttribute(t3, e3);
          }
          _removeAttribute(t3) {
            this._selection.removeAttribute(t3);
          }
          _getStoredAttributes() {
            return this._selection.getStoredAttributes();
          }
          _overrideGravity() {
            return this._selection.overrideGravity();
          }
          _restoreGravity(t3) {
            this._selection.restoreGravity(t3);
          }
          static _getStoreAttributeKey(t3) {
            return yd + t3;
          }
          static _isStoreAttributeKey(t3) {
            return t3.startsWith(yd);
          }
        }
        xd.prototype.is = function(t3) {
          return "selection" === t3 || "model:selection" == t3 || "documentSelection" == t3 || "model:documentSelection" == t3;
        };
        class Ed extends pd {
          constructor(t3) {
            super(), this.markers = new Di({ idProperty: "name" }), this._attributePriority = /* @__PURE__ */ new Map(), this._selectionRestorePosition = null, this._hasChangedRange = false, this._overriddenGravityRegister = /* @__PURE__ */ new Set(), this._observedMarkers = /* @__PURE__ */ new Set(), this._model = t3.model, this._document = t3, this.listenTo(this._model, "applyOperation", (t4, e3) => {
              const n2 = e3[0];
              n2.isDocumentOperation && "marker" != n2.type && "rename" != n2.type && "noop" != n2.type && (0 == this._ranges.length && this._selectionRestorePosition && this._fixGraveyardSelection(this._selectionRestorePosition), this._selectionRestorePosition = null, this._hasChangedRange && (this._hasChangedRange = false, this.fire("change:range", { directChange: false })));
            }, { priority: "lowest" }), this.on("change:range", () => {
              this._validateSelectionRanges(this.getRanges());
            }), this.listenTo(this._model.markers, "update", (t4, e3, n2, o2) => {
              this._updateMarker(e3, o2);
            }), this.listenTo(this._document, "change", (t4, e3) => {
              !function(t5, e4) {
                const n2 = t5.document.differ;
                for (const o2 of n2.getChanges()) {
                  if ("insert" != o2.type)
                    continue;
                  const n3 = o2.position.parent;
                  o2.length === n3.maxOffset && t5.enqueueChange(e4, (t6) => {
                    const e5 = Array.from(n3.getAttributeKeys()).filter((t7) => t7.startsWith(yd));
                    for (const o3 of e5)
                      t6.removeAttribute(o3, n3);
                  });
                }
              }(this._model, e3);
            });
          }
          get isCollapsed() {
            return 0 === this._ranges.length ? this._document._getDefaultRange().isCollapsed : super.isCollapsed;
          }
          get anchor() {
            return super.anchor || this._document._getDefaultRange().start;
          }
          get focus() {
            return super.focus || this._document._getDefaultRange().end;
          }
          get rangeCount() {
            return this._ranges.length ? this._ranges.length : 1;
          }
          get hasOwnRange() {
            return this._ranges.length > 0;
          }
          get isGravityOverridden() {
            return !!this._overriddenGravityRegister.size;
          }
          destroy() {
            for (let t3 = 0; t3 < this._ranges.length; t3++)
              this._ranges[t3].detach();
            this.stopListening();
          }
          *getRanges() {
            this._ranges.length ? yield* __yieldStar(super.getRanges()) : yield this._document._getDefaultRange();
          }
          getFirstRange() {
            return super.getFirstRange() || this._document._getDefaultRange();
          }
          getLastRange() {
            return super.getLastRange() || this._document._getDefaultRange();
          }
          setTo(...t3) {
            super.setTo(...t3), this._updateAttributes(true), this.updateMarkers();
          }
          setFocus(t3, e3) {
            super.setFocus(t3, e3), this._updateAttributes(true), this.updateMarkers();
          }
          setAttribute(t3, e3) {
            if (this._setAttribute(t3, e3)) {
              const e4 = [t3];
              this.fire("change:attribute", { attributeKeys: e4, directChange: true });
            }
          }
          removeAttribute(t3) {
            if (this._removeAttribute(t3)) {
              const e3 = [t3];
              this.fire("change:attribute", { attributeKeys: e3, directChange: true });
            }
          }
          overrideGravity() {
            const t3 = f();
            return this._overriddenGravityRegister.add(t3), 1 === this._overriddenGravityRegister.size && this._updateAttributes(true), t3;
          }
          restoreGravity(t3) {
            if (!this._overriddenGravityRegister.has(t3))
              throw new A("document-selection-gravity-wrong-restore", this, { uid: t3 });
            this._overriddenGravityRegister.delete(t3), this.isGravityOverridden || this._updateAttributes(true);
          }
          observeMarkers(t3) {
            this._observedMarkers.add(t3), this.updateMarkers();
          }
          _replaceAllRanges(t3) {
            this._validateSelectionRanges(t3), super._replaceAllRanges(t3);
          }
          _popRange() {
            this._ranges.pop().detach();
          }
          _pushRange(t3) {
            const e3 = this._prepareRange(t3);
            e3 && this._ranges.push(e3);
          }
          _validateSelectionRanges(t3) {
            for (const e3 of t3)
              if (!this._document._validateSelectionRange(e3))
                throw new A("document-selection-wrong-position", this, { range: e3 });
          }
          _prepareRange(t3) {
            if (this._checkRange(t3), t3.root == this._document.graveyard)
              return;
            const e3 = Cd.fromRange(t3);
            return e3.on("change:range", (t4, n2, o2) => {
              if (this._hasChangedRange = true, e3.root == this._document.graveyard) {
                this._selectionRestorePosition = o2.deletionPosition;
                const t5 = this._ranges.indexOf(e3);
                this._ranges.splice(t5, 1), e3.detach();
              }
            }), e3;
          }
          updateMarkers() {
            if (!this._observedMarkers.size)
              return;
            const t3 = [];
            let e3 = false;
            for (const e4 of this._model.markers) {
              const n3 = e4.name.split(":", 1)[0];
              if (!this._observedMarkers.has(n3))
                continue;
              const o2 = e4.getRange();
              for (const n4 of this.getRanges())
                o2.containsRange(n4, !n4.isCollapsed) && t3.push(e4);
            }
            const n2 = Array.from(this.markers);
            for (const n3 of t3)
              this.markers.has(n3) || (this.markers.add(n3), e3 = true);
            for (const n3 of Array.from(this.markers))
              t3.includes(n3) || (this.markers.remove(n3), e3 = true);
            e3 && this.fire("change:marker", { oldMarkers: n2, directChange: false });
          }
          _updateMarker(t3, e3) {
            const n2 = t3.name.split(":", 1)[0];
            if (!this._observedMarkers.has(n2))
              return;
            let o2 = false;
            const i2 = Array.from(this.markers), r2 = this.markers.has(t3);
            if (e3) {
              let n3 = false;
              for (const t4 of this.getRanges())
                if (e3.containsRange(t4, !t4.isCollapsed)) {
                  n3 = true;
                  break;
                }
              n3 && !r2 ? (this.markers.add(t3), o2 = true) : !n3 && r2 && (this.markers.remove(t3), o2 = true);
            } else
              r2 && (this.markers.remove(t3), o2 = true);
            o2 && this.fire("change:marker", { oldMarkers: i2, directChange: false });
          }
          _updateAttributes(t3) {
            const e3 = Mi(this._getSurroundingAttributes()), n2 = Mi(this.getAttributes());
            if (t3)
              this._attributePriority = /* @__PURE__ */ new Map(), this._attrs = /* @__PURE__ */ new Map();
            else
              for (const [t4, e4] of this._attributePriority)
                "low" == e4 && (this._attrs.delete(t4), this._attributePriority.delete(t4));
            this._setAttributesTo(e3);
            const o2 = [];
            for (const [t4, e4] of this.getAttributes())
              n2.has(t4) && n2.get(t4) === e4 || o2.push(t4);
            for (const [t4] of n2)
              this.hasAttribute(t4) || o2.push(t4);
            o2.length > 0 && this.fire("change:attribute", { attributeKeys: o2, directChange: false });
          }
          _setAttribute(t3, e3, n2 = true) {
            const o2 = n2 ? "normal" : "low";
            if ("low" == o2 && "normal" == this._attributePriority.get(t3))
              return false;
            return super.getAttribute(t3) !== e3 && (this._attrs.set(t3, e3), this._attributePriority.set(t3, o2), true);
          }
          _removeAttribute(t3, e3 = true) {
            const n2 = e3 ? "normal" : "low";
            return ("low" != n2 || "normal" != this._attributePriority.get(t3)) && (this._attributePriority.set(t3, n2), !!super.hasAttribute(t3) && (this._attrs.delete(t3), true));
          }
          _setAttributesTo(t3) {
            const e3 = /* @__PURE__ */ new Set();
            for (const [e4, n2] of this.getAttributes())
              t3.get(e4) !== n2 && this._removeAttribute(e4, false);
            for (const [n2, o2] of t3) {
              this._setAttribute(n2, o2, false) && e3.add(n2);
            }
            return e3;
          }
          *getStoredAttributes() {
            const t3 = this.getFirstPosition().parent;
            if (this.isCollapsed && t3.isEmpty) {
              for (const e3 of t3.getAttributeKeys())
                if (e3.startsWith(yd)) {
                  const n2 = e3.substr(10);
                  yield [n2, t3.getAttribute(e3)];
                }
            }
          }
          _getSurroundingAttributes() {
            const t3 = this.getFirstPosition(), e3 = this._model.schema;
            if ("$graveyard" == t3.root.rootName)
              return null;
            let n2 = null;
            if (this.isCollapsed) {
              const o2 = t3.textNode ? t3.textNode : t3.nodeBefore, i2 = t3.textNode ? t3.textNode : t3.nodeAfter;
              if (this.isGravityOverridden || (n2 = Dd(o2, e3)), n2 || (n2 = Dd(i2, e3)), !this.isGravityOverridden && !n2) {
                let t4 = o2;
                for (; t4 && !n2; )
                  t4 = t4.previousSibling, n2 = Dd(t4, e3);
              }
              if (!n2) {
                let t4 = i2;
                for (; t4 && !n2; )
                  t4 = t4.nextSibling, n2 = Dd(t4, e3);
              }
              n2 || (n2 = this.getStoredAttributes());
            } else {
              const t4 = this.getFirstRange();
              for (const o2 of t4) {
                if (o2.item.is("element") && e3.isObject(o2.item)) {
                  n2 = Dd(o2.item, e3);
                  break;
                }
                if ("text" == o2.type) {
                  n2 = o2.item.getAttributes();
                  break;
                }
              }
            }
            return n2;
          }
          _fixGraveyardSelection(t3) {
            const e3 = this._model.schema.getNearestSelectionRange(t3);
            e3 && this._pushRange(e3);
          }
        }
        function Dd(t3, e3) {
          if (!t3)
            return null;
          if (t3 instanceof Ul || t3 instanceof Vl)
            return t3.getAttributes();
          if (!e3.isInline(t3))
            return null;
          if (!e3.isObject(t3))
            return [];
          const n2 = [];
          for (const [o2, i2] of t3.getAttributes())
            e3.checkAttribute("$text", o2) && false !== e3.getAttributeProperties(o2).copyFromObject && n2.push([o2, i2]);
          return n2;
        }
        class Id {
          constructor(t3) {
            this._dispatchers = t3;
          }
          add(t3) {
            for (const e3 of this._dispatchers)
              t3(e3);
            return this;
          }
        }
        class Sd extends Id {
          elementToElement(t3) {
            return this.add(function(t4) {
              const e3 = Bd(t4.model), n2 = Nd(t4.view, "container");
              e3.attributes.length && (e3.children = true);
              return (o2) => {
                o2.on(`insert:${e3.name}`, function(t5, e4 = Vd) {
                  return (n3, o3, i2) => {
                    if (!e4(o3.item, i2.consumable, { preflight: true }))
                      return;
                    const r2 = t5(o3.item, i2, o3);
                    if (!r2)
                      return;
                    e4(o3.item, i2.consumable);
                    const s3 = i2.mapper.toViewPosition(o3.range.start);
                    i2.mapper.bindElements(o3.item, r2), i2.writer.insert(s3, r2), i2.convertAttributes(o3.item), jd(r2, o3.item.getChildren(), i2, { reconversion: o3.reconversion });
                  };
                }(n2, Rd(e3)), { priority: t4.converterPriority || "normal" }), (e3.children || e3.attributes.length) && o2.on("reduceChanges", Ld(e3), { priority: "low" });
              };
            }(t3));
          }
          elementToStructure(t3) {
            return this.add(function(t4) {
              const e3 = Bd(t4.model), n2 = Nd(t4.view, "container");
              return e3.children = true, (o2) => {
                if (o2._conversionApi.schema.checkChild(e3.name, "$text"))
                  throw new A("conversion-element-to-structure-disallowed-text", o2, { elementName: e3.name });
                var i2, r2;
                o2.on(`insert:${e3.name}`, (i2 = n2, r2 = Rd(e3), (t5, e4, n3) => {
                  if (!r2(e4.item, n3.consumable, { preflight: true }))
                    return;
                  const o3 = /* @__PURE__ */ new Map();
                  n3.writer._registerSlotFactory(function(t6, e5, n4) {
                    return (o4, i3) => {
                      const r3 = o4.createContainerElement("$slot");
                      let s4 = null;
                      if ("children" === i3)
                        s4 = Array.from(t6.getChildren());
                      else {
                        if ("function" != typeof i3)
                          throw new A("conversion-slot-mode-unknown", n4.dispatcher, { modeOrFilter: i3 });
                        s4 = Array.from(t6.getChildren()).filter((t7) => i3(t7));
                      }
                      return e5.set(r3, s4), r3;
                    };
                  }(e4.item, o3, n3));
                  const s3 = i2(e4.item, n3, e4);
                  if (n3.writer._clearSlotFactory(), !s3)
                    return;
                  !function(t6, e5, n4) {
                    const o4 = Array.from(e5.values()).flat(), i3 = new Set(o4);
                    if (i3.size != o4.length)
                      throw new A("conversion-slot-filter-overlap", n4.dispatcher, { element: t6 });
                    if (i3.size != t6.childCount)
                      throw new A("conversion-slot-filter-incomplete", n4.dispatcher, { element: t6 });
                  }(e4.item, o3, n3), r2(e4.item, n3.consumable);
                  const a2 = n3.mapper.toViewPosition(e4.range.start);
                  n3.mapper.bindElements(e4.item, s3), n3.writer.insert(a2, s3), n3.convertAttributes(e4.item), function(t6, e5, n4, o4) {
                    n4.mapper.on("modelToViewPosition", s4, { priority: "highest" });
                    let i3 = null, r3 = null;
                    for ([i3, r3] of e5)
                      jd(t6, r3, n4, o4), n4.writer.move(n4.writer.createRangeIn(i3), n4.writer.createPositionBefore(i3)), n4.writer.remove(i3);
                    function s4(t7, e6) {
                      const n5 = e6.modelPosition.nodeAfter, o5 = r3.indexOf(n5);
                      o5 < 0 || (e6.viewPosition = e6.mapper.findPositionIn(i3, o5));
                    }
                    n4.mapper.off("modelToViewPosition", s4);
                  }(s3, o3, n3, { reconversion: e4.reconversion });
                }), { priority: t4.converterPriority || "normal" }), o2.on("reduceChanges", Ld(e3), { priority: "low" });
              };
            }(t3));
          }
          attributeToElement(t3) {
            return this.add(function(t4) {
              t4 = Ol(t4);
              let e3 = t4.model;
              "string" == typeof e3 && (e3 = { key: e3 });
              let n2 = `attribute:${e3.key}`;
              e3.name && (n2 += ":" + e3.name);
              if (e3.values)
                for (const n3 of e3.values)
                  t4.view[n3] = Nd(t4.view[n3], "attribute");
              else
                t4.view = Nd(t4.view, "attribute");
              const o2 = Pd(t4);
              return (e4) => {
                e4.on(n2, function(t5) {
                  return (e5, n3, o3) => {
                    if (!o3.consumable.test(n3.item, e5.name))
                      return;
                    const i2 = t5(n3.attributeOldValue, o3, n3), r2 = t5(n3.attributeNewValue, o3, n3);
                    if (!i2 && !r2)
                      return;
                    o3.consumable.consume(n3.item, e5.name);
                    const s3 = o3.writer, a2 = s3.document.selection;
                    if (n3.item instanceof pd || n3.item instanceof xd)
                      s3.wrap(a2.getFirstRange(), r2);
                    else {
                      let t6 = o3.mapper.toViewRange(n3.range);
                      null !== n3.attributeOldValue && i2 && (t6 = s3.unwrap(t6, i2)), null !== n3.attributeNewValue && r2 && s3.wrap(t6, r2);
                    }
                  };
                }(o2), { priority: t4.converterPriority || "normal" });
              };
            }(t3));
          }
          attributeToAttribute(t3) {
            return this.add(function(t4) {
              t4 = Ol(t4);
              let e3 = t4.model;
              "string" == typeof e3 && (e3 = { key: e3 });
              let n2 = `attribute:${e3.key}`;
              e3.name && (n2 += ":" + e3.name);
              if (e3.values)
                for (const n3 of e3.values)
                  t4.view[n3] = zd(t4.view[n3]);
              else
                t4.view = zd(t4.view);
              const o2 = Pd(t4);
              return (e4) => {
                var i2;
                e4.on(n2, (i2 = o2, (t5, e5, n3) => {
                  if (!n3.consumable.test(e5.item, t5.name))
                    return;
                  const o3 = i2(e5.attributeOldValue, n3, e5), r2 = i2(e5.attributeNewValue, n3, e5);
                  if (!o3 && !r2)
                    return;
                  n3.consumable.consume(e5.item, t5.name);
                  const s3 = n3.mapper.toViewElement(e5.item), a2 = n3.writer;
                  if (!s3)
                    throw new A("conversion-attribute-to-attribute-on-text", n3.dispatcher, e5);
                  if (null !== e5.attributeOldValue && o3)
                    if ("class" == o3.key) {
                      const t6 = _i(o3.value);
                      for (const e6 of t6)
                        a2.removeClass(e6, s3);
                    } else if ("style" == o3.key) {
                      const t6 = Object.keys(o3.value);
                      for (const e6 of t6)
                        a2.removeStyle(e6, s3);
                    } else
                      a2.removeAttribute(o3.key, s3);
                  if (null !== e5.attributeNewValue && r2)
                    if ("class" == r2.key) {
                      const t6 = _i(r2.value);
                      for (const e6 of t6)
                        a2.addClass(e6, s3);
                    } else if ("style" == r2.key) {
                      const t6 = Object.keys(r2.value);
                      for (const e6 of t6)
                        a2.setStyle(e6, r2.value[e6], s3);
                    } else
                      a2.setAttribute(r2.key, r2.value, s3);
                }), { priority: t4.converterPriority || "normal" });
              };
            }(t3));
          }
          markerToElement(t3) {
            return this.add(function(t4) {
              const e3 = Nd(t4.view, "ui");
              return (n2) => {
                var o2;
                n2.on(`addMarker:${t4.model}`, (o2 = e3, (t5, e4, n3) => {
                  e4.isOpening = true;
                  const i2 = o2(e4, n3);
                  e4.isOpening = false;
                  const r2 = o2(e4, n3);
                  if (!i2 || !r2)
                    return;
                  const s3 = e4.markerRange;
                  if (s3.isCollapsed && !n3.consumable.consume(s3, t5.name))
                    return;
                  for (const e5 of s3)
                    if (!n3.consumable.consume(e5.item, t5.name))
                      return;
                  const a2 = n3.mapper, c2 = n3.writer;
                  c2.insert(a2.toViewPosition(s3.start), i2), n3.mapper.bindElementToMarker(i2, e4.markerName), s3.isCollapsed || (c2.insert(a2.toViewPosition(s3.end), r2), n3.mapper.bindElementToMarker(r2, e4.markerName)), t5.stop();
                }), { priority: t4.converterPriority || "normal" }), n2.on(`removeMarker:${t4.model}`, (t5, e4, n3) => {
                  const o3 = n3.mapper.markerNameToElements(e4.markerName);
                  if (o3) {
                    for (const t6 of o3)
                      n3.mapper.unbindElementFromMarkerName(t6, e4.markerName), n3.writer.clear(n3.writer.createRangeOn(t6), t6);
                    n3.writer.clearClonedElementsGroup(e4.markerName), t5.stop();
                  }
                }, { priority: t4.converterPriority || "normal" });
              };
            }(t3));
          }
          markerToHighlight(t3) {
            return this.add(function(t4) {
              return (e3) => {
                var n2;
                e3.on(`addMarker:${t4.model}`, (n2 = t4.view, (t5, e4, o2) => {
                  if (!e4.item)
                    return;
                  if (!(e4.item instanceof pd || e4.item instanceof xd || e4.item.is("$textProxy")))
                    return;
                  const i2 = Od(n2, e4, o2);
                  if (!i2)
                    return;
                  if (!o2.consumable.consume(e4.item, t5.name))
                    return;
                  const r2 = o2.writer, s3 = Td(r2, i2), a2 = r2.document.selection;
                  if (e4.item instanceof pd || e4.item instanceof xd)
                    r2.wrap(a2.getFirstRange(), s3);
                  else {
                    const t6 = o2.mapper.toViewRange(e4.range), n3 = r2.wrap(t6, s3);
                    for (const t7 of n3.getItems())
                      if (t7.is("attributeElement") && t7.isSimilar(s3)) {
                        o2.mapper.bindElementToMarker(t7, e4.markerName);
                        break;
                      }
                  }
                }), { priority: t4.converterPriority || "normal" }), e3.on(`addMarker:${t4.model}`, function(t5) {
                  return (e4, n3, o2) => {
                    if (!n3.item)
                      return;
                    if (!(n3.item instanceof Hl))
                      return;
                    const i2 = Od(t5, n3, o2);
                    if (!i2)
                      return;
                    if (!o2.consumable.test(n3.item, e4.name))
                      return;
                    const r2 = o2.mapper.toViewElement(n3.item);
                    if (r2 && r2.getCustomProperty("addHighlight")) {
                      o2.consumable.consume(n3.item, e4.name);
                      for (const t6 of Jl._createIn(n3.item))
                        o2.consumable.consume(t6.item, e4.name);
                      r2.getCustomProperty("addHighlight")(r2, i2, o2.writer), o2.mapper.bindElementToMarker(r2, n3.markerName);
                    }
                  };
                }(t4.view), { priority: t4.converterPriority || "normal" }), e3.on(`removeMarker:${t4.model}`, function(t5) {
                  return (e4, n3, o2) => {
                    if (n3.markerRange.isCollapsed)
                      return;
                    const i2 = Od(t5, n3, o2);
                    if (!i2)
                      return;
                    const r2 = Td(o2.writer, i2), s3 = o2.mapper.markerNameToElements(n3.markerName);
                    if (s3) {
                      for (const t6 of s3)
                        if (o2.mapper.unbindElementFromMarkerName(t6, n3.markerName), t6.is("attributeElement"))
                          o2.writer.unwrap(o2.writer.createRangeOn(t6), r2);
                        else {
                          t6.getCustomProperty("removeHighlight")(t6, i2.id, o2.writer);
                        }
                      o2.writer.clearClonedElementsGroup(n3.markerName), e4.stop();
                    }
                  };
                }(t4.view), { priority: t4.converterPriority || "normal" });
              };
            }(t3));
          }
          markerToData(t3) {
            return this.add(function(t4) {
              t4 = Ol(t4);
              const e3 = t4.model;
              let n2 = t4.view;
              n2 || (n2 = (n3) => ({ group: e3, name: n3.substr(t4.model.length + 1) }));
              return (o2) => {
                var i2;
                o2.on(`addMarker:${e3}`, (i2 = n2, (t5, e4, n3) => {
                  const o3 = i2(e4.markerName, n3);
                  if (!o3)
                    return;
                  const r2 = e4.markerRange;
                  n3.consumable.consume(r2, t5.name) && (Md(r2, false, n3, e4, o3), Md(r2, true, n3, e4, o3), t5.stop());
                }), { priority: t4.converterPriority || "normal" }), o2.on(`removeMarker:${e3}`, function(t5) {
                  return (e4, n3, o3) => {
                    const i3 = t5(n3.markerName, o3);
                    if (!i3)
                      return;
                    const r2 = o3.mapper.markerNameToElements(n3.markerName);
                    if (r2) {
                      for (const t6 of r2)
                        o3.mapper.unbindElementFromMarkerName(t6, n3.markerName), t6.is("containerElement") ? (s3(`data-${i3.group}-start-before`, t6), s3(`data-${i3.group}-start-after`, t6), s3(`data-${i3.group}-end-before`, t6), s3(`data-${i3.group}-end-after`, t6)) : o3.writer.clear(o3.writer.createRangeOn(t6), t6);
                      o3.writer.clearClonedElementsGroup(n3.markerName), e4.stop();
                    }
                    function s3(t6, e5) {
                      if (e5.hasAttribute(t6)) {
                        const n4 = new Set(e5.getAttribute(t6).split(","));
                        n4.delete(i3.name), 0 == n4.size ? o3.writer.removeAttribute(t6, e5) : o3.writer.setAttribute(t6, Array.from(n4).join(","), e5);
                      }
                    }
                  };
                }(n2), { priority: t4.converterPriority || "normal" });
              };
            }(t3));
          }
        }
        function Td(t3, e3) {
          const n2 = t3.createAttributeElement("span", e3.attributes);
          return e3.classes && n2._addClass(e3.classes), "number" == typeof e3.priority && (n2._priority = e3.priority), n2._id = e3.id, n2;
        }
        function Md(t3, e3, n2, o2, i2) {
          const r2 = e3 ? t3.start : t3.end, s3 = r2.nodeAfter && r2.nodeAfter.is("element") ? r2.nodeAfter : null, a2 = r2.nodeBefore && r2.nodeBefore.is("element") ? r2.nodeBefore : null;
          if (s3 || a2) {
            let t4, r3;
            e3 && s3 || !e3 && !a2 ? (t4 = s3, r3 = true) : (t4 = a2, r3 = false);
            const c2 = n2.mapper.toViewElement(t4);
            if (c2)
              return void function(t5, e4, n3, o3, i3, r4) {
                const s4 = `data-${r4.group}-${e4 ? "start" : "end"}-${n3 ? "before" : "after"}`, a3 = t5.hasAttribute(s4) ? t5.getAttribute(s4).split(",") : [];
                a3.unshift(r4.name), o3.writer.setAttribute(s4, a3.join(","), t5), o3.mapper.bindElementToMarker(t5, i3.markerName);
              }(c2, e3, r3, n2, o2, i2);
          }
          !function(t4, e4, n3, o3, i3) {
            const r3 = `${i3.group}-${e4 ? "start" : "end"}`, s4 = i3.name ? { name: i3.name } : null, a3 = n3.writer.createUIElement(r3, s4);
            n3.writer.insert(t4, a3), n3.mapper.bindElementToMarker(a3, o3.markerName);
          }(n2.mapper.toViewPosition(r2), e3, n2, o2, i2);
        }
        function Bd(t3) {
          return "string" == typeof t3 && (t3 = { name: t3 }), { name: t3.name, attributes: t3.attributes ? _i(t3.attributes) : [], children: !!t3.children };
        }
        function Nd(t3, e3) {
          return "function" == typeof t3 ? t3 : (n2, o2) => function(t4, e4, n3) {
            "string" == typeof t4 && (t4 = { name: t4 });
            let o3;
            const i2 = e4.writer, r2 = Object.assign({}, t4.attributes);
            if ("container" == n3)
              o3 = i2.createContainerElement(t4.name, r2);
            else if ("attribute" == n3) {
              const e5 = { priority: t4.priority || Ga.DEFAULT_PRIORITY };
              o3 = i2.createAttributeElement(t4.name, r2, e5);
            } else
              o3 = i2.createUIElement(t4.name, r2);
            if (t4.styles) {
              const e5 = Object.keys(t4.styles);
              for (const n4 of e5)
                i2.setStyle(n4, t4.styles[n4], o3);
            }
            if (t4.classes) {
              const e5 = t4.classes;
              if ("string" == typeof e5)
                i2.addClass(e5, o3);
              else
                for (const t5 of e5)
                  i2.addClass(t5, o3);
            }
            return o3;
          }(t3, o2, e3);
        }
        function Pd(t3) {
          return t3.model.values ? (e3, n2, o2) => {
            const i2 = t3.view[e3];
            return i2 ? i2(e3, n2, o2) : null;
          } : t3.view;
        }
        function zd(t3) {
          return "string" == typeof t3 ? (e3) => ({ key: t3, value: e3 }) : "object" == typeof t3 ? t3.value ? () => t3 : (e3) => ({ key: t3.key, value: e3 }) : t3;
        }
        function Od(t3, e3, n2) {
          const o2 = "function" == typeof t3 ? t3(e3, n2) : t3;
          return o2 ? (o2.priority || (o2.priority = 10), o2.id || (o2.id = e3.markerName), o2) : null;
        }
        function Ld(t3) {
          const e3 = function(t4) {
            return (e4, n2) => {
              if (!e4.is("element", t4.name))
                return false;
              if ("attribute" == n2.type) {
                if (t4.attributes.includes(n2.attributeKey))
                  return true;
              } else if (t4.children)
                return true;
              return false;
            };
          }(t3);
          return (t4, n2) => {
            const o2 = [];
            n2.reconvertedElements || (n2.reconvertedElements = /* @__PURE__ */ new Set());
            for (const t5 of n2.changes) {
              const i2 = "attribute" == t5.type ? t5.range.start.nodeAfter : t5.position.parent;
              if (i2 && e3(i2, t5)) {
                if (!n2.reconvertedElements.has(i2)) {
                  n2.reconvertedElements.add(i2);
                  const t6 = Wl._createBefore(i2);
                  let e4 = o2.length;
                  for (let n3 = o2.length - 1; n3 >= 0; n3--) {
                    const i3 = o2[n3], r2 = ("attribute" == i3.type ? i3.range.start : i3.position).compareWith(t6);
                    if ("before" == r2 || "remove" == i3.type && "same" == r2)
                      break;
                    e4 = n3;
                  }
                  o2.splice(e4, 0, { type: "remove", name: i2.name, position: t6, length: 1 }, { type: "reinsert", name: i2.name, position: t6, length: 1 });
                }
              } else
                o2.push(t5);
            }
            n2.changes = o2;
          };
        }
        function Rd(t3) {
          return (e3, n2, o2 = {}) => {
            const i2 = ["insert"];
            for (const n3 of t3.attributes)
              e3.hasAttribute(n3) && i2.push(`attribute:${n3}`);
            return !!i2.every((t4) => n2.test(e3, t4)) && (o2.preflight || i2.forEach((t4) => n2.consume(e3, t4)), true);
          };
        }
        function jd(t3, e3, n2, o2) {
          for (const i2 of e3)
            Fd(t3.root, i2, n2, o2) || n2.convertItem(i2);
        }
        function Fd(t3, e3, n2, o2) {
          const { writer: i2, mapper: r2 } = n2;
          if (!o2.reconversion)
            return false;
          const s3 = r2.toViewElement(e3);
          return !(!s3 || s3.root == t3) && (!!n2.canReuseView(s3) && (i2.move(i2.createRangeOn(s3), r2.toViewPosition(Wl._createBefore(e3))), true));
        }
        function Vd(t3, e3, { preflight: n2 } = {}) {
          return n2 ? e3.test(t3, "insert") : e3.consume(t3, "insert");
        }
        function Ud(t3) {
          const { schema: e3, document: n2 } = t3.model;
          for (const o2 of n2.getRoots())
            if (o2.isEmpty && !e3.checkChild(o2, "$text") && e3.checkChild(o2, "paragraph"))
              return t3.insertElement("paragraph", o2), true;
          return false;
        }
        function Hd(t3, e3, n2) {
          const o2 = n2.createContext(t3);
          return !!n2.checkChild(o2, "paragraph") && !!n2.checkChild(o2.push("paragraph"), e3);
        }
        function qd(t3, e3) {
          const n2 = e3.createElement("paragraph");
          return e3.insert(n2, t3), e3.createPositionAt(n2, 0);
        }
        var Gd = Object.defineProperty, Wd = Object.defineProperties, Kd = Object.getOwnPropertyDescriptors, Zd = Object.getOwnPropertySymbols, Yd = Object.prototype.hasOwnProperty, $d = Object.prototype.propertyIsEnumerable, Qd = (t3, e3, n2) => e3 in t3 ? Gd(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2;
        class Jd extends Id {
          elementToElement(t3) {
            return this.add(Xd(t3));
          }
          elementToAttribute(t3) {
            return this.add(function(t4) {
              t4 = Ol(t4), nh(t4);
              const e3 = oh(t4, false), n2 = th(t4.view), o2 = n2 ? `element:${n2}` : "element";
              return (n3) => {
                n3.on(o2, e3, { priority: t4.converterPriority || "low" });
              };
            }(t3));
          }
          attributeToAttribute(t3) {
            return this.add(function(t4) {
              t4 = Ol(t4);
              let e3 = null;
              ("string" == typeof t4.view || t4.view.key) && (e3 = function(t5) {
                "string" == typeof t5.view && (t5.view = { key: t5.view });
                const e4 = t5.view.key;
                let n3;
                if ("class" == e4 || "style" == e4) {
                  n3 = { ["class" == e4 ? "classes" : "styles"]: t5.view.value };
                } else {
                  n3 = { attributes: { [e4]: void 0 === t5.view.value ? /[\s\S]*/ : t5.view.value } };
                }
                t5.view.name && (n3.name = t5.view.name);
                return t5.view = n3, e4;
              }(t4));
              nh(t4, e3);
              const n2 = oh(t4, true);
              return (e4) => {
                e4.on("element", n2, { priority: t4.converterPriority || "low" });
              };
            }(t3));
          }
          elementToMarker(t3) {
            return this.add(function(t4) {
              const e3 = function(t5) {
                return (e4, n3) => {
                  const o3 = "string" == typeof t5 ? t5 : t5(e4, n3);
                  return n3.writer.createElement("$marker", { "data-name": o3 });
                };
              }(t4.model);
              return Xd((n2 = ((t5, e4) => {
                for (var n3 in e4 || (e4 = {}))
                  Yd.call(e4, n3) && Qd(t5, n3, e4[n3]);
                if (Zd)
                  for (var n3 of Zd(e4))
                    $d.call(e4, n3) && Qd(t5, n3, e4[n3]);
                return t5;
              })({}, t4), o2 = { model: e3 }, Wd(n2, Kd(o2))));
              var n2, o2;
            }(t3));
          }
          dataToMarker(t3) {
            return this.add(function(t4) {
              t4 = Ol(t4), t4.model || (t4.model = (e4) => e4 ? t4.view + ":" + e4 : t4.view);
              const e3 = { view: t4.view, model: t4.model }, n2 = eh(ih(e3, "start")), o2 = eh(ih(e3, "end"));
              return (i2) => {
                i2.on(`element:${t4.view}-start`, n2, { priority: t4.converterPriority || "normal" }), i2.on(`element:${t4.view}-end`, o2, { priority: t4.converterPriority || "normal" });
                const r2 = k.low, s3 = k.highest, a2 = k.get(t4.converterPriority) / s3;
                i2.on("element", function(t5) {
                  return (e4, n3, o3) => {
                    const i3 = `data-${t5.view}`;
                    function r3(e5, i4) {
                      for (const r4 of i4) {
                        const i5 = t5.model(r4, o3), s4 = o3.writer.createElement("$marker", { "data-name": i5 });
                        o3.writer.insert(s4, e5), n3.modelCursor.isEqual(e5) ? n3.modelCursor = n3.modelCursor.getShiftedBy(1) : n3.modelCursor = n3.modelCursor._getTransformedByInsertion(e5, 1), n3.modelRange = n3.modelRange._getTransformedByInsertion(e5, 1)[0];
                      }
                    }
                    (o3.consumable.test(n3.viewItem, { attributes: i3 + "-end-after" }) || o3.consumable.test(n3.viewItem, { attributes: i3 + "-start-after" }) || o3.consumable.test(n3.viewItem, { attributes: i3 + "-end-before" }) || o3.consumable.test(n3.viewItem, { attributes: i3 + "-start-before" })) && (n3.modelRange || Object.assign(n3, o3.convertChildren(n3.viewItem, n3.modelCursor)), o3.consumable.consume(n3.viewItem, { attributes: i3 + "-end-after" }) && r3(n3.modelRange.end, n3.viewItem.getAttribute(i3 + "-end-after").split(",")), o3.consumable.consume(n3.viewItem, { attributes: i3 + "-start-after" }) && r3(n3.modelRange.end, n3.viewItem.getAttribute(i3 + "-start-after").split(",")), o3.consumable.consume(n3.viewItem, { attributes: i3 + "-end-before" }) && r3(n3.modelRange.start, n3.viewItem.getAttribute(i3 + "-end-before").split(",")), o3.consumable.consume(n3.viewItem, { attributes: i3 + "-start-before" }) && r3(n3.modelRange.start, n3.viewItem.getAttribute(i3 + "-start-before").split(",")));
                  };
                }(e3), { priority: r2 + a2 });
              };
            }(t3));
          }
        }
        function Xd(t3) {
          const e3 = eh(t3 = Ol(t3)), n2 = th(t3.view), o2 = n2 ? `element:${n2}` : "element";
          return (n3) => {
            n3.on(o2, e3, { priority: t3.converterPriority || "normal" });
          };
        }
        function th(t3) {
          return "string" == typeof t3 ? t3 : "object" == typeof t3 && "string" == typeof t3.name ? t3.name : null;
        }
        function eh(t3) {
          const e3 = new ys(t3.view);
          return (n2, o2, i2) => {
            const r2 = e3.match(o2.viewItem);
            if (!r2)
              return;
            const s3 = r2.match;
            if (s3.name = true, !i2.consumable.test(o2.viewItem, s3))
              return;
            const a2 = function(t4, e4, n3) {
              return t4 instanceof Function ? t4(e4, n3) : n3.writer.createElement(t4);
            }(t3.model, o2.viewItem, i2);
            a2 && i2.safeInsert(a2, o2.modelCursor) && (i2.consumable.consume(o2.viewItem, s3), i2.convertChildren(o2.viewItem, a2), i2.updateConversionResult(a2, o2));
          };
        }
        function nh(t3, e3 = null) {
          const n2 = null === e3 || ((t4) => t4.getAttribute(e3)), o2 = "object" != typeof t3.model ? t3.model : t3.model.key, i2 = "object" != typeof t3.model || void 0 === t3.model.value ? n2 : t3.model.value;
          t3.model = { key: o2, value: i2 };
        }
        function oh(t3, e3) {
          const n2 = new ys(t3.view);
          return (o2, i2, r2) => {
            if (!i2.modelRange && e3)
              return;
            const s3 = n2.match(i2.viewItem);
            if (!s3)
              return;
            if (!function(t4, e4) {
              const n3 = "function" == typeof t4 ? t4(e4) : t4;
              if ("object" == typeof n3 && !th(n3))
                return false;
              return !n3.classes && !n3.attributes && !n3.styles;
            }(t3.view, i2.viewItem) ? delete s3.match.name : s3.match.name = true, !r2.consumable.test(i2.viewItem, s3.match))
              return;
            const a2 = t3.model.key, c2 = "function" == typeof t3.model.value ? t3.model.value(i2.viewItem, r2) : t3.model.value;
            if (null === c2)
              return;
            i2.modelRange || Object.assign(i2, r2.convertChildren(i2.viewItem, i2.modelCursor));
            const l2 = function(t4, e4, n3, o3) {
              let i3 = false;
              for (const r3 of Array.from(t4.getItems({ shallow: n3 })))
                o3.schema.checkAttribute(r3, e4.key) && (i3 = true, r3.hasAttribute(e4.key) || o3.writer.setAttribute(e4.key, e4.value, r3));
              return i3;
            }(i2.modelRange, { key: a2, value: c2 }, e3, r2);
            l2 && (r2.consumable.test(i2.viewItem, { name: true }) && (s3.match.name = true), r2.consumable.consume(i2.viewItem, s3.match));
          };
        }
        function ih(t3, e3) {
          return { view: `${t3.view}-${e3}`, model: (e4, n2) => {
            const o2 = e4.getAttribute("name"), i2 = t3.model(o2, n2);
            return n2.writer.createElement("$marker", { "data-name": i2 });
          } };
        }
        function rh(t3) {
          t3.document.registerPostFixer((e3) => function(t4, e4) {
            const n2 = e4.document.selection, o2 = e4.schema, i2 = [];
            let r2 = false;
            for (const t5 of n2.getRanges()) {
              const e5 = sh(t5, o2);
              e5 && !e5.isEqual(t5) ? (i2.push(e5), r2 = true) : i2.push(t5);
            }
            r2 && t4.setSelection(function(t5) {
              const e5 = [...t5], n3 = /* @__PURE__ */ new Set();
              let o3 = 1;
              for (; o3 < e5.length; ) {
                const t6 = e5[o3], i3 = e5.slice(0, o3);
                for (const [r3, s3] of i3.entries())
                  if (!n3.has(r3)) {
                    if (t6.isEqual(s3))
                      n3.add(r3);
                    else if (t6.isIntersecting(s3)) {
                      n3.add(r3), n3.add(o3);
                      const i4 = t6.getJoined(s3);
                      e5.push(i4);
                    }
                  }
                o3++;
              }
              return e5.filter((t6, e6) => !n3.has(e6));
            }(i2), { backward: n2.isBackward });
            return false;
          }(e3, t3));
        }
        function sh(t3, e3) {
          return t3.isCollapsed ? function(t4, e4) {
            const n2 = t4.start, o2 = e4.getNearestSelectionRange(n2);
            if (!o2) {
              const t5 = n2.getAncestors().reverse().find((t6) => e4.isObject(t6));
              return t5 ? Jl._createOn(t5) : null;
            }
            if (!o2.isCollapsed)
              return o2;
            const i2 = o2.start;
            if (n2.isEqual(i2))
              return null;
            return new Jl(i2);
          }(t3, e3) : function(t4, e4) {
            const { start: n2, end: o2 } = t4, i2 = e4.checkChild(n2, "$text"), r2 = e4.checkChild(o2, "$text"), s3 = e4.getLimitElement(n2), a2 = e4.getLimitElement(o2);
            if (s3 === a2) {
              if (i2 && r2)
                return null;
              if (function(t5, e5, n3) {
                const o3 = t5.nodeAfter && !n3.isLimit(t5.nodeAfter) || n3.checkChild(t5, "$text"), i3 = e5.nodeBefore && !n3.isLimit(e5.nodeBefore) || n3.checkChild(e5, "$text");
                return o3 || i3;
              }(n2, o2, e4)) {
                const t5 = n2.nodeAfter && e4.isSelectable(n2.nodeAfter) ? null : e4.getNearestSelectionRange(n2, "forward"), i3 = o2.nodeBefore && e4.isSelectable(o2.nodeBefore) ? null : e4.getNearestSelectionRange(o2, "backward"), r3 = t5 ? t5.start : n2, s4 = i3 ? i3.end : o2;
                return new Jl(r3, s4);
              }
            }
            const c2 = s3 && !s3.is("rootElement"), l2 = a2 && !a2.is("rootElement");
            if (c2 || l2) {
              const t5 = n2.nodeAfter && o2.nodeBefore && n2.nodeAfter.parent === o2.nodeBefore.parent, i3 = c2 && (!t5 || !ch(n2.nodeAfter, e4)), r3 = l2 && (!t5 || !ch(o2.nodeBefore, e4));
              let d2 = n2, h2 = o2;
              return i3 && (d2 = Wl._createBefore(ah(s3, e4))), r3 && (h2 = Wl._createAfter(ah(a2, e4))), new Jl(d2, h2);
            }
            return null;
          }(t3, e3);
        }
        function ah(t3, e3) {
          let n2 = t3, o2 = n2;
          for (; e3.isLimit(o2) && o2.parent; )
            n2 = o2, o2 = o2.parent;
          return n2;
        }
        function ch(t3, e3) {
          return t3 && e3.isSelectable(t3);
        }
        class lh extends W() {
          constructor(t3, e3) {
            super(), this.model = t3, this.view = new Ll(e3), this.mapper = new Xl(), this.downcastDispatcher = new hd({ mapper: this.mapper, schema: t3.schema });
            const n2 = this.model.document, o2 = n2.selection, i2 = this.model.markers;
            var r2, s3, c2;
            this.listenTo(this.model, "_beforeChanges", () => {
              this.view._disableRendering(true);
            }, { priority: "highest" }), this.listenTo(this.model, "_afterChanges", () => {
              this.view._disableRendering(false);
            }, { priority: "lowest" }), this.listenTo(n2, "change", () => {
              this.view.change((t4) => {
                this.downcastDispatcher.convertChanges(n2.differ, i2, t4), this.downcastDispatcher.convertSelection(o2, i2, t4);
              });
            }, { priority: "low" }), this.listenTo(this.view.document, "selectionChange", function(t4, e4) {
              return (n3, o3) => {
                const i3 = o3.newSelection, r3 = [];
                for (const t5 of i3.getRanges())
                  r3.push(e4.toModelRange(t5));
                const s4 = t4.createSelection(r3, { backward: i3.isBackward });
                s4.isEqual(t4.document.selection) || t4.change((t5) => {
                  t5.setSelection(s4);
                });
              };
            }(this.model, this.mapper)), this.listenTo(this.view.document, "beforeinput", (r2 = this.mapper, s3 = this.model.schema, c2 = this.view, (t4, e4) => {
              if (!c2.document.isComposing || a.isAndroid)
                for (let t5 = 0; t5 < e4.targetRanges.length; t5++) {
                  const n3 = e4.targetRanges[t5], o3 = r2.toModelRange(n3), i3 = sh(o3, s3);
                  i3 && !i3.isEqual(o3) && (e4.targetRanges[t5] = r2.toViewRange(i3));
                }
            }), { priority: "high" }), this.downcastDispatcher.on("insert:$text", (t4, e4, n3) => {
              if (!n3.consumable.consume(e4.item, t4.name))
                return;
              const o3 = n3.writer, i3 = n3.mapper.toViewPosition(e4.range.start), r3 = o3.createText(e4.item.data);
              o3.insert(i3, r3);
            }, { priority: "lowest" }), this.downcastDispatcher.on("insert", (t4, e4, n3) => {
              n3.convertAttributes(e4.item), e4.reconversion || !e4.item.is("element") || e4.item.isEmpty || n3.convertChildren(e4.item);
            }, { priority: "lowest" }), this.downcastDispatcher.on("remove", (t4, e4, n3) => {
              const o3 = n3.mapper.toViewPosition(e4.position), i3 = e4.position.getShiftedBy(e4.length), r3 = n3.mapper.toViewPosition(i3, { isPhantom: true }), s4 = n3.writer.createRange(o3, r3), a2 = n3.writer.remove(s4.getTrimmed());
              for (const t5 of n3.writer.createRangeIn(a2).getItems())
                n3.mapper.unbindViewElement(t5, { defer: true });
            }, { priority: "low" }), this.downcastDispatcher.on("cleanSelection", (t4, e4, n3) => {
              const o3 = n3.writer, i3 = o3.document.selection;
              for (const t5 of i3.getRanges())
                t5.isCollapsed && t5.end.parent.isAttached() && n3.writer.mergeAttributes(t5.start);
              o3.setSelection(null);
            }), this.downcastDispatcher.on("selection", (t4, e4, n3) => {
              const o3 = e4.selection;
              if (o3.isCollapsed)
                return;
              if (!n3.consumable.consume(o3, "selection"))
                return;
              const i3 = [];
              for (const t5 of o3.getRanges())
                i3.push(n3.mapper.toViewRange(t5));
              n3.writer.setSelection(i3, { backward: o3.isBackward });
            }, { priority: "low" }), this.downcastDispatcher.on("selection", (t4, e4, n3) => {
              const o3 = e4.selection;
              if (!o3.isCollapsed)
                return;
              if (!n3.consumable.consume(o3, "selection"))
                return;
              const i3 = n3.writer, r3 = o3.getFirstPosition(), s4 = n3.mapper.toViewPosition(r3), a2 = i3.breakAttributes(s4);
              i3.setSelection(a2);
            }, { priority: "low" }), this.view.document.roots.bindTo(this.model.document.roots).using((t4) => {
              if ("$graveyard" == t4.rootName)
                return null;
              const e4 = new Ta(this.view.document, t4.name);
              return e4.rootName = t4.rootName, this.mapper.bindElements(t4, e4), e4;
            });
          }
          destroy() {
            this.view.destroy(), this.stopListening();
          }
          reconvertMarker(t3) {
            const e3 = "string" == typeof t3 ? t3 : t3.name, n2 = this.model.markers.get(e3);
            if (!n2)
              throw new A("editingcontroller-reconvertmarker-marker-not-exist", this, { markerName: e3 });
            this.model.change(() => {
              this.model.markers._refresh(n2);
            });
          }
          reconvertItem(t3) {
            this.model.change(() => {
              this.model.document.differ._refreshItem(t3);
            });
          }
        }
        class dh {
          constructor() {
            this._consumables = /* @__PURE__ */ new Map();
          }
          add(t3, e3) {
            let n2;
            t3.is("$text") || t3.is("documentFragment") ? this._consumables.set(t3, true) : (this._consumables.has(t3) ? n2 = this._consumables.get(t3) : (n2 = new uh(t3), this._consumables.set(t3, n2)), n2.add(e3));
          }
          test(t3, e3) {
            const n2 = this._consumables.get(t3);
            return void 0 === n2 ? null : t3.is("$text") || t3.is("documentFragment") ? n2 : n2.test(e3);
          }
          consume(t3, e3) {
            return !!this.test(t3, e3) && (t3.is("$text") || t3.is("documentFragment") ? this._consumables.set(t3, false) : this._consumables.get(t3).consume(e3), true);
          }
          revert(t3, e3) {
            const n2 = this._consumables.get(t3);
            void 0 !== n2 && (t3.is("$text") || t3.is("documentFragment") ? this._consumables.set(t3, true) : n2.revert(e3));
          }
          static consumablesFromElement(t3) {
            const e3 = { element: t3, name: true, attributes: [], classes: [], styles: [] }, n2 = t3.getAttributeKeys();
            for (const t4 of n2)
              "style" != t4 && "class" != t4 && e3.attributes.push(t4);
            const o2 = t3.getClassNames();
            for (const t4 of o2)
              e3.classes.push(t4);
            const i2 = t3.getStyleNames();
            for (const t4 of i2)
              e3.styles.push(t4);
            return e3;
          }
          static createFrom(t3, e3) {
            if (e3 || (e3 = new dh()), t3.is("$text"))
              return e3.add(t3), e3;
            t3.is("element") && e3.add(t3, dh.consumablesFromElement(t3)), t3.is("documentFragment") && e3.add(t3);
            for (const n2 of t3.getChildren())
              e3 = dh.createFrom(n2, e3);
            return e3;
          }
        }
        const hh = ["attributes", "classes", "styles"];
        class uh {
          constructor(t3) {
            this.element = t3, this._canConsumeName = null, this._consumables = { attributes: /* @__PURE__ */ new Map(), styles: /* @__PURE__ */ new Map(), classes: /* @__PURE__ */ new Map() };
          }
          add(t3) {
            t3.name && (this._canConsumeName = true);
            for (const e3 of hh)
              e3 in t3 && this._add(e3, t3[e3]);
          }
          test(t3) {
            if (t3.name && !this._canConsumeName)
              return this._canConsumeName;
            for (const e3 of hh)
              if (e3 in t3) {
                const n2 = this._test(e3, t3[e3]);
                if (true !== n2)
                  return n2;
              }
            return true;
          }
          consume(t3) {
            t3.name && (this._canConsumeName = false);
            for (const e3 of hh)
              e3 in t3 && this._consume(e3, t3[e3]);
          }
          revert(t3) {
            t3.name && (this._canConsumeName = true);
            for (const e3 of hh)
              e3 in t3 && this._revert(e3, t3[e3]);
          }
          _add(t3, e3) {
            const n2 = mt(e3) ? e3 : [e3], o2 = this._consumables[t3];
            for (const e4 of n2) {
              if ("attributes" === t3 && ("class" === e4 || "style" === e4))
                throw new A("viewconsumable-invalid-attribute", this);
              if (o2.set(e4, true), "styles" === t3)
                for (const t4 of this.element.document.stylesProcessor.getRelatedStyles(e4))
                  o2.set(t4, true);
            }
          }
          _test(t3, e3) {
            const n2 = mt(e3) ? e3 : [e3], o2 = this._consumables[t3];
            for (const e4 of n2)
              if ("attributes" !== t3 || "class" !== e4 && "style" !== e4) {
                const t4 = o2.get(e4);
                if (void 0 === t4)
                  return null;
                if (!t4)
                  return false;
              } else {
                const t4 = "class" == e4 ? "classes" : "styles", n3 = this._test(t4, [...this._consumables[t4].keys()]);
                if (true !== n3)
                  return n3;
              }
            return true;
          }
          _consume(t3, e3) {
            const n2 = mt(e3) ? e3 : [e3], o2 = this._consumables[t3];
            for (const e4 of n2)
              if ("attributes" !== t3 || "class" !== e4 && "style" !== e4) {
                if (o2.set(e4, false), "styles" == t3)
                  for (const t4 of this.element.document.stylesProcessor.getRelatedStyles(e4))
                    o2.set(t4, false);
              } else {
                const t4 = "class" == e4 ? "classes" : "styles";
                this._consume(t4, [...this._consumables[t4].keys()]);
              }
          }
          _revert(t3, e3) {
            const n2 = mt(e3) ? e3 : [e3], o2 = this._consumables[t3];
            for (const e4 of n2)
              if ("attributes" !== t3 || "class" !== e4 && "style" !== e4) {
                false === o2.get(e4) && o2.set(e4, true);
              } else {
                const t4 = "class" == e4 ? "classes" : "styles";
                this._revert(t4, [...this._consumables[t4].keys()]);
              }
          }
        }
        class gh extends W() {
          constructor() {
            super(), this._sourceDefinitions = {}, this._attributeProperties = {}, this.decorate("checkChild"), this.decorate("checkAttribute"), this.on("checkAttribute", (t3, e3) => {
              e3[0] = new ph(e3[0]);
            }, { priority: "highest" }), this.on("checkChild", (t3, e3) => {
              e3[0] = new ph(e3[0]), e3[1] = this.getDefinition(e3[1]);
            }, { priority: "highest" });
          }
          register(t3, e3) {
            if (this._sourceDefinitions[t3])
              throw new A("schema-cannot-register-item-twice", this, { itemName: t3 });
            this._sourceDefinitions[t3] = [Object.assign({}, e3)], this._clearCache();
          }
          extend(t3, e3) {
            if (!this._sourceDefinitions[t3])
              throw new A("schema-cannot-extend-missing-item", this, { itemName: t3 });
            this._sourceDefinitions[t3].push(Object.assign({}, e3)), this._clearCache();
          }
          getDefinitions() {
            return this._compiledDefinitions || this._compile(), this._compiledDefinitions;
          }
          getDefinition(t3) {
            let e3;
            return e3 = "string" == typeof t3 ? t3 : "is" in t3 && (t3.is("$text") || t3.is("$textProxy")) ? "$text" : t3.name, this.getDefinitions()[e3];
          }
          isRegistered(t3) {
            return !!this.getDefinition(t3);
          }
          isBlock(t3) {
            const e3 = this.getDefinition(t3);
            return !(!e3 || !e3.isBlock);
          }
          isLimit(t3) {
            const e3 = this.getDefinition(t3);
            return !!e3 && !(!e3.isLimit && !e3.isObject);
          }
          isObject(t3) {
            const e3 = this.getDefinition(t3);
            return !!e3 && !!(e3.isObject || e3.isLimit && e3.isSelectable && e3.isContent);
          }
          isInline(t3) {
            const e3 = this.getDefinition(t3);
            return !(!e3 || !e3.isInline);
          }
          isSelectable(t3) {
            const e3 = this.getDefinition(t3);
            return !!e3 && !(!e3.isSelectable && !e3.isObject);
          }
          isContent(t3) {
            const e3 = this.getDefinition(t3);
            return !!e3 && !(!e3.isContent && !e3.isObject);
          }
          checkChild(t3, e3) {
            return !!e3 && this._checkContextMatch(e3, t3);
          }
          checkAttribute(t3, e3) {
            const n2 = this.getDefinition(t3.last);
            return !!n2 && n2.allowAttributes.includes(e3);
          }
          checkMerge(t3, e3) {
            if (t3 instanceof Wl) {
              const e4 = t3.nodeBefore, n2 = t3.nodeAfter;
              if (!(e4 instanceof Hl))
                throw new A("schema-check-merge-no-element-before", this);
              if (!(n2 instanceof Hl))
                throw new A("schema-check-merge-no-element-after", this);
              return this.checkMerge(e4, n2);
            }
            for (const n2 of e3.getChildren())
              if (!this.checkChild(t3, n2))
                return false;
            return true;
          }
          addChildCheck(t3) {
            this.on("checkChild", (e3, [n2, o2]) => {
              if (!o2)
                return;
              const i2 = t3(n2, o2);
              "boolean" == typeof i2 && (e3.stop(), e3.return = i2);
            }, { priority: "high" });
          }
          addAttributeCheck(t3) {
            this.on("checkAttribute", (e3, [n2, o2]) => {
              const i2 = t3(n2, o2);
              "boolean" == typeof i2 && (e3.stop(), e3.return = i2);
            }, { priority: "high" });
          }
          setAttributeProperties(t3, e3) {
            this._attributeProperties[t3] = Object.assign(this.getAttributeProperties(t3), e3);
          }
          getAttributeProperties(t3) {
            return this._attributeProperties[t3] || {};
          }
          getLimitElement(t3) {
            let e3;
            if (t3 instanceof Wl)
              e3 = t3.parent;
            else {
              e3 = (t3 instanceof Jl ? [t3] : Array.from(t3.getRanges())).reduce((t4, e4) => {
                const n2 = e4.getCommonAncestor();
                return t4 ? t4.getCommonAncestor(n2, { includeSelf: true }) : n2;
              }, null);
            }
            for (; !this.isLimit(e3) && e3.parent; )
              e3 = e3.parent;
            return e3;
          }
          checkAttributeInSelection(t3, e3) {
            if (t3.isCollapsed) {
              const n2 = [...t3.getFirstPosition().getAncestors(), new Vl("", t3.getAttributes())];
              return this.checkAttribute(n2, e3);
            }
            {
              const n2 = t3.getRanges();
              for (const t4 of n2)
                for (const n3 of t4)
                  if (this.checkAttribute(n3.item, e3))
                    return true;
            }
            return false;
          }
          *getValidRanges(t3, e3) {
            t3 = function* (t4) {
              for (const e4 of t4)
                yield* __yieldStar(e4.getMinimalFlatRanges());
            }(t3);
            for (const n2 of t3)
              yield* __yieldStar(this._getValidRangesForRange(n2, e3));
          }
          getNearestSelectionRange(t3, e3 = "both") {
            if ("$graveyard" == t3.root.rootName)
              return null;
            if (this.checkChild(t3, "$text"))
              return new Jl(t3);
            let n2, o2;
            const i2 = t3.getAncestors().reverse().find((t4) => this.isLimit(t4)) || t3.root;
            "both" != e3 && "backward" != e3 || (n2 = new ql({ boundaries: Jl._createIn(i2), startPosition: t3, direction: "backward" })), "both" != e3 && "forward" != e3 || (o2 = new ql({ boundaries: Jl._createIn(i2), startPosition: t3 }));
            for (const t4 of function* (t5, e4) {
              let n3 = false;
              for (; !n3; ) {
                if (n3 = true, t5) {
                  const e5 = t5.next();
                  e5.done || (n3 = false, yield { walker: t5, value: e5.value });
                }
                if (e4) {
                  const t6 = e4.next();
                  t6.done || (n3 = false, yield { walker: e4, value: t6.value });
                }
              }
            }(n2, o2)) {
              const e4 = t4.walker == n2 ? "elementEnd" : "elementStart", o3 = t4.value;
              if (o3.type == e4 && this.isObject(o3.item))
                return Jl._createOn(o3.item);
              if (this.checkChild(o3.nextPosition, "$text"))
                return new Jl(o3.nextPosition);
            }
            return null;
          }
          findAllowedParent(t3, e3) {
            let n2 = t3.parent;
            for (; n2; ) {
              if (this.checkChild(n2, e3))
                return n2;
              if (this.isLimit(n2))
                return null;
              n2 = n2.parent;
            }
            return null;
          }
          setAllowedAttributes(t3, e3, n2) {
            const o2 = n2.model;
            for (const [i2, r2] of Object.entries(e3))
              o2.schema.checkAttribute(t3, i2) && n2.setAttribute(i2, r2, t3);
          }
          removeDisallowedAttributes(t3, e3) {
            for (const n2 of t3)
              if (n2.is("$text"))
                Dh(this, n2, e3);
              else {
                const t4 = Jl._createIn(n2).getPositions();
                for (const n3 of t4) {
                  Dh(this, n3.nodeBefore || n3.parent, e3);
                }
              }
          }
          getAttributesWithProperty(t3, e3, n2) {
            const o2 = {};
            for (const [i2, r2] of t3.getAttributes()) {
              const t4 = this.getAttributeProperties(i2);
              void 0 !== t4[e3] && (void 0 !== n2 && n2 !== t4[e3] || (o2[i2] = r2));
            }
            return o2;
          }
          createContext(t3) {
            return new ph(t3);
          }
          _clearCache() {
            this._compiledDefinitions = null;
          }
          _compile() {
            const t3 = {}, e3 = this._sourceDefinitions, n2 = Object.keys(e3);
            for (const o2 of n2)
              t3[o2] = mh(e3[o2], o2);
            for (const e4 of n2)
              fh(t3, e4);
            for (const e4 of n2)
              kh(t3, e4);
            for (const e4 of n2)
              bh(t3, e4);
            for (const e4 of n2)
              wh(t3, e4), Ah(t3, e4);
            for (const e4 of n2)
              Ch(t3, e4), _h(t3, e4), vh(t3, e4);
            this._compiledDefinitions = t3;
          }
          _checkContextMatch(t3, e3, n2 = e3.length - 1) {
            const o2 = e3.getItem(n2);
            if (t3.allowIn.includes(o2.name)) {
              if (0 == n2)
                return true;
              {
                const t4 = this.getDefinition(o2);
                return this._checkContextMatch(t4, e3, n2 - 1);
              }
            }
            return false;
          }
          *_getValidRangesForRange(t3, e3) {
            let n2 = t3.start, o2 = t3.start;
            for (const i2 of t3.getItems({ shallow: true }))
              i2.is("element") && (yield* __yieldStar(this._getValidRangesForRange(Jl._createIn(i2), e3))), this.checkAttribute(i2, e3) || (n2.isEqual(o2) || (yield new Jl(n2, o2)), n2 = Wl._createAfter(i2)), o2 = Wl._createAfter(i2);
            n2.isEqual(o2) || (yield new Jl(n2, o2));
          }
        }
        class ph {
          constructor(t3) {
            if (t3 instanceof ph)
              return t3;
            let e3;
            e3 = "string" == typeof t3 ? [t3] : Array.isArray(t3) ? t3 : t3.getAncestors({ includeSelf: true }), this._items = e3.map(Eh);
          }
          get length() {
            return this._items.length;
          }
          get last() {
            return this._items[this._items.length - 1];
          }
          [Symbol.iterator]() {
            return this._items[Symbol.iterator]();
          }
          push(t3) {
            const e3 = new ph([t3]);
            return e3._items = [...this._items, ...e3._items], e3;
          }
          getItem(t3) {
            return this._items[t3];
          }
          *getNames() {
            yield* __yieldStar(this._items.map((t3) => t3.name));
          }
          endsWith(t3) {
            return Array.from(this.getNames()).join(" ").endsWith(t3);
          }
          startsWith(t3) {
            return Array.from(this.getNames()).join(" ").startsWith(t3);
          }
        }
        function mh(t3, e3) {
          const n2 = { name: e3, allowIn: [], allowContentOf: [], allowWhere: [], allowAttributes: [], allowAttributesOf: [], allowChildren: [], inheritTypesFrom: [] };
          return function(t4, e4) {
            for (const n3 of t4) {
              const t5 = Object.keys(n3).filter((t6) => t6.startsWith("is"));
              for (const o2 of t5)
                e4[o2] = !!n3[o2];
            }
          }(t3, n2), yh(t3, n2, "allowIn"), yh(t3, n2, "allowContentOf"), yh(t3, n2, "allowWhere"), yh(t3, n2, "allowAttributes"), yh(t3, n2, "allowAttributesOf"), yh(t3, n2, "allowChildren"), yh(t3, n2, "inheritTypesFrom"), function(t4, e4) {
            for (const n3 of t4) {
              const t5 = n3.inheritAllFrom;
              t5 && (e4.allowContentOf.push(t5), e4.allowWhere.push(t5), e4.allowAttributesOf.push(t5), e4.inheritTypesFrom.push(t5));
            }
          }(t3, n2), n2;
        }
        function fh(t3, e3) {
          const n2 = t3[e3];
          for (const o2 of n2.allowChildren) {
            const n3 = t3[o2];
            n3 && n3.allowIn.push(e3);
          }
          n2.allowChildren.length = 0;
        }
        function kh(t3, e3) {
          for (const n2 of t3[e3].allowContentOf)
            if (t3[n2]) {
              xh(t3, n2).forEach((t4) => {
                t4.allowIn.push(e3);
              });
            }
          delete t3[e3].allowContentOf;
        }
        function bh(t3, e3) {
          for (const n2 of t3[e3].allowWhere) {
            const o2 = t3[n2];
            if (o2) {
              const n3 = o2.allowIn;
              t3[e3].allowIn.push(...n3);
            }
          }
          delete t3[e3].allowWhere;
        }
        function wh(t3, e3) {
          for (const n2 of t3[e3].allowAttributesOf) {
            const o2 = t3[n2];
            if (o2) {
              const n3 = o2.allowAttributes;
              t3[e3].allowAttributes.push(...n3);
            }
          }
          delete t3[e3].allowAttributesOf;
        }
        function Ah(t3, e3) {
          const n2 = t3[e3];
          for (const e4 of n2.inheritTypesFrom) {
            const o2 = t3[e4];
            if (o2) {
              const t4 = Object.keys(o2).filter((t5) => t5.startsWith("is"));
              for (const e5 of t4)
                e5 in n2 || (n2[e5] = o2[e5]);
            }
          }
          delete n2.inheritTypesFrom;
        }
        function Ch(t3, e3) {
          const n2 = t3[e3], o2 = n2.allowIn.filter((e4) => t3[e4]);
          n2.allowIn = Array.from(new Set(o2));
        }
        function _h(t3, e3) {
          const n2 = t3[e3];
          for (const o2 of n2.allowIn) {
            t3[o2].allowChildren.push(e3);
          }
        }
        function vh(t3, e3) {
          const n2 = t3[e3];
          n2.allowAttributes = Array.from(new Set(n2.allowAttributes));
        }
        function yh(t3, e3, n2) {
          for (const o2 of t3) {
            const t4 = o2[n2];
            "string" == typeof t4 ? e3[n2].push(t4) : Array.isArray(t4) && e3[n2].push(...t4);
          }
        }
        function xh(t3, e3) {
          const n2 = t3[e3];
          return (o2 = t3, Object.keys(o2).map((t4) => o2[t4])).filter((t4) => t4.allowIn.includes(n2.name));
          var o2;
        }
        function Eh(t3) {
          return "string" == typeof t3 || t3.is("documentFragment") ? { name: "string" == typeof t3 ? t3 : "$documentFragment", *getAttributeKeys() {
          }, getAttribute() {
          } } : { name: t3.is("element") ? t3.name : "$text", *getAttributeKeys() {
            yield* __yieldStar(t3.getAttributeKeys());
          }, getAttribute: (e3) => t3.getAttribute(e3) };
        }
        function Dh(t3, e3, n2) {
          for (const o2 of e3.getAttributeKeys())
            t3.checkAttribute(e3, o2) || n2.removeAttribute(o2, e3);
        }
        var Ih = Object.defineProperty, Sh = Object.defineProperties, Th = Object.getOwnPropertyDescriptors, Mh = Object.getOwnPropertySymbols, Bh = Object.prototype.hasOwnProperty, Nh = Object.prototype.propertyIsEnumerable, Ph = (t3, e3, n2) => e3 in t3 ? Ih(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2;
        class zh extends M() {
          constructor(t3) {
            var e3;
            super(), this._splitParts = /* @__PURE__ */ new Map(), this._cursorParents = /* @__PURE__ */ new Map(), this._modelCursor = null, this._emptyElementsToKeep = /* @__PURE__ */ new Set(), this.conversionApi = (e3 = ((t4, e4) => {
              for (var n2 in e4 || (e4 = {}))
                Bh.call(e4, n2) && Ph(t4, n2, e4[n2]);
              if (Mh)
                for (var n2 of Mh(e4))
                  Nh.call(e4, n2) && Ph(t4, n2, e4[n2]);
              return t4;
            })({}, t3), Sh(e3, Th({ consumable: null, writer: null, store: null, convertItem: (t4, e4) => this._convertItem(t4, e4), convertChildren: (t4, e4) => this._convertChildren(t4, e4), safeInsert: (t4, e4) => this._safeInsert(t4, e4), updateConversionResult: (t4, e4) => this._updateConversionResult(t4, e4), splitToAllowedParent: (t4, e4) => this._splitToAllowedParent(t4, e4), getSplitParts: (t4) => this._getSplitParts(t4), keepEmptyElement: (t4) => this._keepEmptyElement(t4) })));
          }
          convert(t3, e3, n2 = ["$root"]) {
            this.fire("viewCleanup", t3), this._modelCursor = function(t4, e4) {
              let n3;
              for (const o3 of new ph(t4)) {
                const t5 = {};
                for (const e5 of o3.getAttributeKeys())
                  t5[e5] = o3.getAttribute(e5);
                const i3 = e4.createElement(o3.name, t5);
                n3 && e4.insert(i3, n3), n3 = Wl._createAt(i3, 0);
              }
              return n3;
            }(n2, e3), this.conversionApi.writer = e3, this.conversionApi.consumable = dh.createFrom(t3), this.conversionApi.store = {};
            const { modelRange: o2 } = this._convertItem(t3, this._modelCursor), i2 = e3.createDocumentFragment();
            if (o2) {
              this._removeEmptyElements();
              for (const t4 of Array.from(this._modelCursor.parent.getChildren()))
                e3.append(t4, i2);
              i2.markers = function(t4, e4) {
                const n3 = /* @__PURE__ */ new Set(), o3 = /* @__PURE__ */ new Map(), i3 = Jl._createIn(t4).getItems();
                for (const t5 of i3)
                  t5.is("element", "$marker") && n3.add(t5);
                for (const t5 of n3) {
                  const n4 = t5.getAttribute("data-name"), i4 = e4.createPositionBefore(t5);
                  o3.has(n4) ? o3.get(n4).end = i4.clone() : o3.set(n4, new Jl(i4.clone())), e4.remove(t5);
                }
                return o3;
              }(i2, e3);
            }
            return this._modelCursor = null, this._splitParts.clear(), this._cursorParents.clear(), this._emptyElementsToKeep.clear(), this.conversionApi.writer = null, this.conversionApi.store = null, i2;
          }
          _convertItem(t3, e3) {
            const n2 = { viewItem: t3, modelCursor: e3, modelRange: null };
            if (t3.is("element") ? this.fire(`element:${t3.name}`, n2, this.conversionApi) : t3.is("$text") ? this.fire("text", n2, this.conversionApi) : this.fire("documentFragment", n2, this.conversionApi), n2.modelRange && !(n2.modelRange instanceof Jl))
              throw new A("view-conversion-dispatcher-incorrect-result", this);
            return { modelRange: n2.modelRange, modelCursor: n2.modelCursor };
          }
          _convertChildren(t3, e3) {
            let n2 = e3.is("position") ? e3 : Wl._createAt(e3, 0);
            const o2 = new Jl(n2);
            for (const e4 of Array.from(t3.getChildren())) {
              const t4 = this._convertItem(e4, n2);
              t4.modelRange instanceof Jl && (o2.end = t4.modelRange.end, n2 = t4.modelCursor);
            }
            return { modelRange: o2, modelCursor: n2 };
          }
          _safeInsert(t3, e3) {
            const n2 = this._splitToAllowedParent(t3, e3);
            return !!n2 && (this.conversionApi.writer.insert(t3, n2.position), true);
          }
          _updateConversionResult(t3, e3) {
            const n2 = this._getSplitParts(t3), o2 = this.conversionApi.writer;
            e3.modelRange || (e3.modelRange = o2.createRange(o2.createPositionBefore(t3), o2.createPositionAfter(n2[n2.length - 1])));
            const i2 = this._cursorParents.get(t3);
            e3.modelCursor = i2 ? o2.createPositionAt(i2, 0) : e3.modelRange.end;
          }
          _splitToAllowedParent(t3, e3) {
            const { schema: n2, writer: o2 } = this.conversionApi;
            let i2 = n2.findAllowedParent(e3, t3);
            if (i2) {
              if (i2 === e3.parent)
                return { position: e3 };
              this._modelCursor.parent.getAncestors().includes(i2) && (i2 = null);
            }
            if (!i2)
              return Hd(e3, t3, n2) ? { position: qd(e3, o2) } : null;
            const r2 = this.conversionApi.writer.split(e3, i2), s3 = [];
            for (const t4 of r2.range.getWalker())
              if ("elementEnd" == t4.type)
                s3.push(t4.item);
              else {
                const e4 = s3.pop(), n3 = t4.item;
                this._registerSplitPair(e4, n3);
              }
            const a2 = r2.range.end.parent;
            return this._cursorParents.set(t3, a2), { position: r2.position, cursorParent: a2 };
          }
          _registerSplitPair(t3, e3) {
            this._splitParts.has(t3) || this._splitParts.set(t3, [t3]);
            const n2 = this._splitParts.get(t3);
            this._splitParts.set(e3, n2), n2.push(e3);
          }
          _getSplitParts(t3) {
            let e3;
            return e3 = this._splitParts.has(t3) ? this._splitParts.get(t3) : [t3], e3;
          }
          _keepEmptyElement(t3) {
            this._emptyElementsToKeep.add(t3);
          }
          _removeEmptyElements() {
            let t3 = false;
            for (const e3 of this._splitParts.keys())
              e3.isEmpty && !this._emptyElementsToKeep.has(e3) && (this.conversionApi.writer.remove(e3), this._splitParts.delete(e3), t3 = true);
            t3 && this._removeEmptyElements();
          }
        }
        class Oh {
          getHtml(t3) {
            const e3 = zo.document.implementation.createHTMLDocument("").createElement("div");
            return e3.appendChild(t3), e3.innerHTML;
          }
        }
        class Lh {
          constructor(t3) {
            this.skipComments = true, this.domParser = new DOMParser(), this.domConverter = new zc(t3, { renderingMode: "data" }), this.htmlWriter = new Oh();
          }
          toData(t3) {
            const e3 = this.domConverter.viewToDom(t3);
            return this.htmlWriter.getHtml(e3);
          }
          toView(t3) {
            const e3 = this._toDom(t3);
            return this.domConverter.domToView(e3, { skipComments: this.skipComments });
          }
          registerRawContentMatcher(t3) {
            this.domConverter.registerRawContentMatcher(t3);
          }
          useFillerType(t3) {
            this.domConverter.blockFillerMode = "marked" == t3 ? "markedNbsp" : "nbsp";
          }
          _toDom(t3) {
            t3.match(/<(?:html|body|head|meta)(?:\s[^>]*)?>/i) || (t3 = `<body>${t3}</body>`);
            const e3 = this.domParser.parseFromString(t3, "text/html"), n2 = e3.createDocumentFragment(), o2 = e3.body.childNodes;
            for (; o2.length > 0; )
              n2.appendChild(o2[0]);
            return n2;
          }
        }
        class Rh extends M() {
          constructor(t3, e3) {
            super(), this.model = t3, this.mapper = new Xl(), this.downcastDispatcher = new hd({ mapper: this.mapper, schema: t3.schema }), this.downcastDispatcher.on("insert:$text", (t4, e4, n2) => {
              if (!n2.consumable.consume(e4.item, t4.name))
                return;
              const o2 = n2.writer, i2 = n2.mapper.toViewPosition(e4.range.start), r2 = o2.createText(e4.item.data);
              o2.insert(i2, r2);
            }, { priority: "lowest" }), this.downcastDispatcher.on("insert", (t4, e4, n2) => {
              n2.convertAttributes(e4.item), e4.reconversion || !e4.item.is("element") || e4.item.isEmpty || n2.convertChildren(e4.item);
            }, { priority: "lowest" }), this.upcastDispatcher = new zh({ schema: t3.schema }), this.viewDocument = new qa(e3), this.stylesProcessor = e3, this.htmlProcessor = new Lh(this.viewDocument), this.processor = this.htmlProcessor, this._viewWriter = new nc(this.viewDocument), this.upcastDispatcher.on("text", (t4, e4, { schema: n2, consumable: o2, writer: i2 }) => {
              let r2 = e4.modelCursor;
              if (!o2.test(e4.viewItem))
                return;
              if (!n2.checkChild(r2, "$text")) {
                if (!Hd(r2, "$text", n2))
                  return;
                if (0 == e4.viewItem.data.trim().length)
                  return;
                const t5 = r2.nodeBefore;
                r2 = qd(r2, i2), t5 && t5.is("element", "$marker") && (i2.move(i2.createRangeOn(t5), r2), r2 = i2.createPositionAfter(t5));
              }
              o2.consume(e4.viewItem);
              const s3 = i2.createText(e4.viewItem.data);
              i2.insert(s3, r2), e4.modelRange = i2.createRange(r2, r2.getShiftedBy(s3.offsetSize)), e4.modelCursor = e4.modelRange.end;
            }, { priority: "lowest" }), this.upcastDispatcher.on("element", (t4, e4, n2) => {
              if (!e4.modelRange && n2.consumable.consume(e4.viewItem, { name: true })) {
                const { modelRange: t5, modelCursor: o2 } = n2.convertChildren(e4.viewItem, e4.modelCursor);
                e4.modelRange = t5, e4.modelCursor = o2;
              }
            }, { priority: "lowest" }), this.upcastDispatcher.on("documentFragment", (t4, e4, n2) => {
              if (!e4.modelRange && n2.consumable.consume(e4.viewItem, { name: true })) {
                const { modelRange: t5, modelCursor: o2 } = n2.convertChildren(e4.viewItem, e4.modelCursor);
                e4.modelRange = t5, e4.modelCursor = o2;
              }
            }, { priority: "lowest" }), W().prototype.decorate.call(this, "init"), W().prototype.decorate.call(this, "set"), W().prototype.decorate.call(this, "get"), W().prototype.decorate.call(this, "toView"), W().prototype.decorate.call(this, "toModel"), this.on("init", () => {
              this.fire("ready");
            }, { priority: "lowest" }), this.on("ready", () => {
              this.model.enqueueChange({ isUndoable: false }, Ud);
            }, { priority: "lowest" });
          }
          get(t3 = {}) {
            const { rootName: e3 = "main", trim: n2 = "empty" } = t3;
            if (!this._checkIfRootsExists([e3]))
              throw new A("datacontroller-get-non-existent-root", this);
            const o2 = this.model.document.getRoot(e3);
            return o2.isAttached() || C("datacontroller-get-detached-root", this), "empty" !== n2 || this.model.hasContent(o2, { ignoreWhitespaces: true }) ? this.stringify(o2, t3) : "";
          }
          stringify(t3, e3 = {}) {
            const n2 = this.toView(t3, e3);
            return this.processor.toData(n2);
          }
          toView(t3, e3 = {}) {
            const n2 = this.viewDocument, o2 = this._viewWriter;
            this.mapper.clearBindings();
            const i2 = Jl._createIn(t3), r2 = new ec(n2);
            this.mapper.bindElements(t3, r2);
            const s3 = t3.is("documentFragment") ? t3.markers : function(t4) {
              const e4 = [], n3 = t4.root.document;
              if (!n3)
                return /* @__PURE__ */ new Map();
              const o3 = Jl._createIn(t4);
              for (const t5 of n3.model.markers) {
                const n4 = t5.getRange(), i3 = n4.isCollapsed, r3 = n4.start.isEqual(o3.start) || n4.end.isEqual(o3.end);
                if (i3 && r3)
                  e4.push([t5.name, n4]);
                else {
                  const i4 = o3.getIntersection(n4);
                  i4 && e4.push([t5.name, i4]);
                }
              }
              return e4.sort(([t5, e5], [n4, o4]) => {
                if ("after" !== e5.end.compareWith(o4.start))
                  return 1;
                if ("before" !== e5.start.compareWith(o4.end))
                  return -1;
                switch (e5.start.compareWith(o4.start)) {
                  case "before":
                    return 1;
                  case "after":
                    return -1;
                  default:
                    switch (e5.end.compareWith(o4.end)) {
                      case "before":
                        return 1;
                      case "after":
                        return -1;
                      default:
                        return n4.localeCompare(t5);
                    }
                }
              }), new Map(e4);
            }(t3);
            return this.downcastDispatcher.convert(i2, s3, o2, e3), r2;
          }
          init(t3) {
            if (this.model.document.version)
              throw new A("datacontroller-init-document-not-empty", this);
            let e3 = {};
            if ("string" == typeof t3 ? e3.main = t3 : e3 = t3, !this._checkIfRootsExists(Object.keys(e3)))
              throw new A("datacontroller-init-non-existent-root", this);
            return this.model.enqueueChange({ isUndoable: false }, (t4) => {
              for (const n2 of Object.keys(e3)) {
                const o2 = this.model.document.getRoot(n2);
                t4.insert(this.parse(e3[n2], o2), o2, 0);
              }
            }), Promise.resolve();
          }
          set(t3, e3 = {}) {
            let n2 = {};
            if ("string" == typeof t3 ? n2.main = t3 : n2 = t3, !this._checkIfRootsExists(Object.keys(n2)))
              throw new A("datacontroller-set-non-existent-root", this);
            this.model.enqueueChange(e3.batchType || {}, (t4) => {
              t4.setSelection(null), t4.removeSelectionAttribute(this.model.document.selection.getAttributeKeys());
              for (const e4 of Object.keys(n2)) {
                const o2 = this.model.document.getRoot(e4);
                t4.remove(t4.createRangeIn(o2)), t4.insert(this.parse(n2[e4], o2), o2, 0);
              }
            });
          }
          parse(t3, e3 = "$root") {
            const n2 = this.processor.toView(t3);
            return this.toModel(n2, e3);
          }
          toModel(t3, e3 = "$root") {
            return this.model.change((n2) => this.upcastDispatcher.convert(t3, n2, e3));
          }
          addStyleProcessorRules(t3) {
            t3(this.stylesProcessor);
          }
          registerRawContentMatcher(t3) {
            this.processor && this.processor !== this.htmlProcessor && this.processor.registerRawContentMatcher(t3), this.htmlProcessor.registerRawContentMatcher(t3);
          }
          destroy() {
            this.stopListening();
          }
          _checkIfRootsExists(t3) {
            for (const e3 of t3)
              if (!this.model.document.getRoot(e3))
                return false;
            return true;
          }
        }
        class jh {
          constructor(t3, e3) {
            this._helpers = /* @__PURE__ */ new Map(), this._downcast = _i(t3), this._createConversionHelpers({ name: "downcast", dispatchers: this._downcast, isDowncast: true }), this._upcast = _i(e3), this._createConversionHelpers({ name: "upcast", dispatchers: this._upcast, isDowncast: false });
          }
          addAlias(t3, e3) {
            const n2 = this._downcast.includes(e3);
            if (!this._upcast.includes(e3) && !n2)
              throw new A("conversion-add-alias-dispatcher-not-registered", this);
            this._createConversionHelpers({ name: t3, dispatchers: [e3], isDowncast: n2 });
          }
          for(t3) {
            if (!this._helpers.has(t3))
              throw new A("conversion-for-unknown-group", this);
            return this._helpers.get(t3);
          }
          elementToElement(t3) {
            this.for("downcast").elementToElement(t3);
            for (const { model: e3, view: n2 } of Fh(t3))
              this.for("upcast").elementToElement({ model: e3, view: n2, converterPriority: t3.converterPriority });
          }
          attributeToElement(t3) {
            this.for("downcast").attributeToElement(t3);
            for (const { model: e3, view: n2 } of Fh(t3))
              this.for("upcast").elementToAttribute({ view: n2, model: e3, converterPriority: t3.converterPriority });
          }
          attributeToAttribute(t3) {
            this.for("downcast").attributeToAttribute(t3);
            for (const { model: e3, view: n2 } of Fh(t3))
              this.for("upcast").attributeToAttribute({ view: n2, model: e3 });
          }
          _createConversionHelpers({ name: t3, dispatchers: e3, isDowncast: n2 }) {
            if (this._helpers.has(t3))
              throw new A("conversion-group-exists", this);
            const o2 = n2 ? new Sd(e3) : new Jd(e3);
            this._helpers.set(t3, o2);
          }
        }
        function* Fh(t3) {
          if (t3.model.values)
            for (const e3 of t3.model.values) {
              const n2 = { key: t3.model.key, value: e3 }, o2 = t3.view[e3], i2 = t3.upcastAlso ? t3.upcastAlso[e3] : void 0;
              yield* __yieldStar(Vh(n2, o2, i2));
            }
          else
            yield* __yieldStar(Vh(t3.model, t3.view, t3.upcastAlso));
        }
        function* Vh(t3, e3, n2) {
          if (yield { model: t3, view: e3 }, n2)
            for (const e4 of _i(n2))
              yield { model: t3, view: e4 };
        }
        class Uh {
          constructor(t3) {
            this.baseVersion = t3, this.isDocumentOperation = null !== this.baseVersion, this.batch = null;
          }
          _validate() {
          }
          toJSON() {
            const t3 = Object.assign({}, this);
            return t3.__className = this.constructor.className, delete t3.batch, delete t3.isDocumentOperation, t3;
          }
          static get className() {
            return "Operation";
          }
          static fromJSON(t3, e3) {
            return new this(t3.baseVersion);
          }
        }
        function Hh(t3, e3) {
          const n2 = Wh(e3), o2 = n2.reduce((t4, e4) => t4 + e4.offsetSize, 0), i2 = t3.parent;
          Zh(t3);
          const r2 = t3.index;
          return i2._insertChild(r2, n2), Kh(i2, r2 + n2.length), Kh(i2, r2), new Jl(t3, t3.getShiftedBy(o2));
        }
        function qh(t3) {
          if (!t3.isFlat)
            throw new A("operation-utils-remove-range-not-flat", this);
          const e3 = t3.start.parent;
          Zh(t3.start), Zh(t3.end);
          const n2 = e3._removeChildren(t3.start.index, t3.end.index - t3.start.index);
          return Kh(e3, t3.start.index), n2;
        }
        function Gh(t3, e3) {
          if (!t3.isFlat)
            throw new A("operation-utils-move-range-not-flat", this);
          const n2 = qh(t3);
          return Hh(e3 = e3._getTransformedByDeletion(t3.start, t3.end.offset - t3.start.offset), n2);
        }
        function Wh(t3) {
          const e3 = [];
          !function t4(n2) {
            if ("string" == typeof n2)
              e3.push(new Vl(n2));
            else if (n2 instanceof Ul)
              e3.push(new Vl(n2.data, n2.getAttributes()));
            else if (n2 instanceof jl)
              e3.push(n2);
            else if (et(n2))
              for (const e4 of n2)
                t4(e4);
            else {
            }
          }(t3);
          for (let t4 = 1; t4 < e3.length; t4++) {
            const n2 = e3[t4], o2 = e3[t4 - 1];
            n2 instanceof Vl && o2 instanceof Vl && Yh(n2, o2) && (e3.splice(t4 - 1, 2, new Vl(o2.data + n2.data, o2.getAttributes())), t4--);
          }
          return e3;
        }
        function Kh(t3, e3) {
          const n2 = t3.getChild(e3 - 1), o2 = t3.getChild(e3);
          if (n2 && o2 && n2.is("$text") && o2.is("$text") && Yh(n2, o2)) {
            const i2 = new Vl(n2.data + o2.data, n2.getAttributes());
            t3._removeChildren(e3 - 1, 2), t3._insertChild(e3 - 1, i2);
          }
        }
        function Zh(t3) {
          const e3 = t3.textNode, n2 = t3.parent;
          if (e3) {
            const o2 = t3.offset - e3.startOffset, i2 = e3.index;
            n2._removeChildren(i2, 1);
            const r2 = new Vl(e3.data.substr(0, o2), e3.getAttributes()), s3 = new Vl(e3.data.substr(o2), e3.getAttributes());
            n2._insertChild(i2, [r2, s3]);
          }
        }
        function Yh(t3, e3) {
          const n2 = t3.getAttributes(), o2 = e3.getAttributes();
          for (const t4 of n2) {
            if (t4[1] !== e3.getAttribute(t4[0]))
              return false;
            o2.next();
          }
          return o2.next().done;
        }
        class $h extends Uh {
          constructor(t3, e3, n2, o2) {
            super(o2), this.sourcePosition = t3.clone(), this.sourcePosition.stickiness = "toNext", this.howMany = e3, this.targetPosition = n2.clone(), this.targetPosition.stickiness = "toNone";
          }
          get type() {
            return "$graveyard" == this.targetPosition.root.rootName ? "remove" : "$graveyard" == this.sourcePosition.root.rootName ? "reinsert" : "move";
          }
          get affectedSelectable() {
            return [Jl._createFromPositionAndShift(this.sourcePosition, this.howMany), Jl._createFromPositionAndShift(this.targetPosition, 0)];
          }
          clone() {
            return new $h(this.sourcePosition, this.howMany, this.targetPosition, this.baseVersion);
          }
          getMovedRangeStart() {
            return this.targetPosition._getTransformedByDeletion(this.sourcePosition, this.howMany);
          }
          getReversed() {
            const t3 = this.sourcePosition._getTransformedByInsertion(this.targetPosition, this.howMany);
            return new $h(this.getMovedRangeStart(), this.howMany, t3, this.baseVersion + 1);
          }
          _validate() {
            const t3 = this.sourcePosition.parent, e3 = this.targetPosition.parent, n2 = this.sourcePosition.offset, o2 = this.targetPosition.offset;
            if (n2 + this.howMany > t3.maxOffset)
              throw new A("move-operation-nodes-do-not-exist", this);
            if (t3 === e3 && n2 < o2 && o2 < n2 + this.howMany)
              throw new A("move-operation-range-into-itself", this);
            if (this.sourcePosition.root == this.targetPosition.root && "prefix" == tt(this.sourcePosition.getParentPath(), this.targetPosition.getParentPath())) {
              const t4 = this.sourcePosition.path.length - 1;
              if (this.targetPosition.path[t4] >= n2 && this.targetPosition.path[t4] < n2 + this.howMany)
                throw new A("move-operation-node-into-itself", this);
            }
          }
          _execute() {
            Gh(Jl._createFromPositionAndShift(this.sourcePosition, this.howMany), this.targetPosition);
          }
          toJSON() {
            const t3 = super.toJSON();
            return t3.sourcePosition = this.sourcePosition.toJSON(), t3.targetPosition = this.targetPosition.toJSON(), t3;
          }
          static get className() {
            return "MoveOperation";
          }
          static fromJSON(t3, e3) {
            const n2 = Wl.fromJSON(t3.sourcePosition, e3), o2 = Wl.fromJSON(t3.targetPosition, e3);
            return new this(n2, t3.howMany, o2, t3.baseVersion);
          }
        }
        class Qh extends Uh {
          constructor(t3, e3, n2) {
            super(n2), this.position = t3.clone(), this.position.stickiness = "toNone", this.nodes = new Fl(Wh(e3)), this.shouldReceiveAttributes = false;
          }
          get type() {
            return "insert";
          }
          get howMany() {
            return this.nodes.maxOffset;
          }
          get affectedSelectable() {
            return this.position.clone();
          }
          clone() {
            const t3 = new Fl([...this.nodes].map((t4) => t4._clone(true))), e3 = new Qh(this.position, t3, this.baseVersion);
            return e3.shouldReceiveAttributes = this.shouldReceiveAttributes, e3;
          }
          getReversed() {
            const t3 = this.position.root.document.graveyard, e3 = new Wl(t3, [0]);
            return new $h(this.position, this.nodes.maxOffset, e3, this.baseVersion + 1);
          }
          _validate() {
            const t3 = this.position.parent;
            if (!t3 || t3.maxOffset < this.position.offset)
              throw new A("insert-operation-position-invalid", this);
          }
          _execute() {
            const t3 = this.nodes;
            this.nodes = new Fl([...t3].map((t4) => t4._clone(true))), Hh(this.position, t3);
          }
          toJSON() {
            const t3 = super.toJSON();
            return t3.position = this.position.toJSON(), t3.nodes = this.nodes.toJSON(), t3;
          }
          static get className() {
            return "InsertOperation";
          }
          static fromJSON(t3, e3) {
            const n2 = [];
            for (const e4 of t3.nodes)
              e4.name ? n2.push(Hl.fromJSON(e4)) : n2.push(Vl.fromJSON(e4));
            const o2 = new Qh(Wl.fromJSON(t3.position, e3), n2, t3.baseVersion);
            return o2.shouldReceiveAttributes = t3.shouldReceiveAttributes, o2;
          }
        }
        class Jh extends Uh {
          constructor(t3, e3, n2, o2, i2) {
            super(i2), this.splitPosition = t3.clone(), this.splitPosition.stickiness = "toNext", this.howMany = e3, this.insertionPosition = n2, this.graveyardPosition = o2 ? o2.clone() : null, this.graveyardPosition && (this.graveyardPosition.stickiness = "toNext");
          }
          get type() {
            return "split";
          }
          get moveTargetPosition() {
            const t3 = this.insertionPosition.path.slice();
            return t3.push(0), new Wl(this.insertionPosition.root, t3);
          }
          get movedRange() {
            const t3 = this.splitPosition.getShiftedBy(Number.POSITIVE_INFINITY);
            return new Jl(this.splitPosition, t3);
          }
          get affectedSelectable() {
            const t3 = [Jl._createFromPositionAndShift(this.splitPosition, 0), Jl._createFromPositionAndShift(this.insertionPosition, 0)];
            return this.graveyardPosition && t3.push(Jl._createFromPositionAndShift(this.graveyardPosition, 0)), t3;
          }
          clone() {
            return new Jh(this.splitPosition, this.howMany, this.insertionPosition, this.graveyardPosition, this.baseVersion);
          }
          getReversed() {
            const t3 = this.splitPosition.root.document.graveyard, e3 = new Wl(t3, [0]);
            return new Xh(this.moveTargetPosition, this.howMany, this.splitPosition, e3, this.baseVersion + 1);
          }
          _validate() {
            const t3 = this.splitPosition.parent, e3 = this.splitPosition.offset;
            if (!t3 || t3.maxOffset < e3)
              throw new A("split-operation-position-invalid", this);
            if (!t3.parent)
              throw new A("split-operation-split-in-root", this);
            if (this.howMany != t3.maxOffset - this.splitPosition.offset)
              throw new A("split-operation-how-many-invalid", this);
            if (this.graveyardPosition && !this.graveyardPosition.nodeAfter)
              throw new A("split-operation-graveyard-position-invalid", this);
          }
          _execute() {
            const t3 = this.splitPosition.parent;
            if (this.graveyardPosition)
              Gh(Jl._createFromPositionAndShift(this.graveyardPosition, 1), this.insertionPosition);
            else {
              const e3 = t3._clone();
              Hh(this.insertionPosition, e3);
            }
            Gh(new Jl(Wl._createAt(t3, this.splitPosition.offset), Wl._createAt(t3, t3.maxOffset)), this.moveTargetPosition);
          }
          toJSON() {
            const t3 = super.toJSON();
            return t3.splitPosition = this.splitPosition.toJSON(), t3.insertionPosition = this.insertionPosition.toJSON(), this.graveyardPosition && (t3.graveyardPosition = this.graveyardPosition.toJSON()), t3;
          }
          static get className() {
            return "SplitOperation";
          }
          static getInsertionPosition(t3) {
            const e3 = t3.path.slice(0, -1);
            return e3[e3.length - 1]++, new Wl(t3.root, e3, "toPrevious");
          }
          static fromJSON(t3, e3) {
            const n2 = Wl.fromJSON(t3.splitPosition, e3), o2 = Wl.fromJSON(t3.insertionPosition, e3), i2 = t3.graveyardPosition ? Wl.fromJSON(t3.graveyardPosition, e3) : null;
            return new this(n2, t3.howMany, o2, i2, t3.baseVersion);
          }
        }
        class Xh extends Uh {
          constructor(t3, e3, n2, o2, i2) {
            super(i2), this.sourcePosition = t3.clone(), this.sourcePosition.stickiness = "toPrevious", this.howMany = e3, this.targetPosition = n2.clone(), this.targetPosition.stickiness = "toNext", this.graveyardPosition = o2.clone();
          }
          get type() {
            return "merge";
          }
          get deletionPosition() {
            return new Wl(this.sourcePosition.root, this.sourcePosition.path.slice(0, -1));
          }
          get movedRange() {
            const t3 = this.sourcePosition.getShiftedBy(Number.POSITIVE_INFINITY);
            return new Jl(this.sourcePosition, t3);
          }
          get affectedSelectable() {
            const t3 = this.sourcePosition.parent;
            return [Jl._createOn(t3), Jl._createFromPositionAndShift(this.targetPosition, 0), Jl._createFromPositionAndShift(this.graveyardPosition, 0)];
          }
          clone() {
            return new Xh(this.sourcePosition, this.howMany, this.targetPosition, this.graveyardPosition, this.baseVersion);
          }
          getReversed() {
            const t3 = this.targetPosition._getTransformedByMergeOperation(this), e3 = this.sourcePosition.path.slice(0, -1), n2 = new Wl(this.sourcePosition.root, e3)._getTransformedByMergeOperation(this);
            return new Jh(t3, this.howMany, n2, this.graveyardPosition, this.baseVersion + 1);
          }
          _validate() {
            const t3 = this.sourcePosition.parent, e3 = this.targetPosition.parent;
            if (!t3.parent)
              throw new A("merge-operation-source-position-invalid", this);
            if (!e3.parent)
              throw new A("merge-operation-target-position-invalid", this);
            if (this.howMany != t3.maxOffset)
              throw new A("merge-operation-how-many-invalid", this);
          }
          _execute() {
            const t3 = this.sourcePosition.parent;
            Gh(Jl._createIn(t3), this.targetPosition), Gh(Jl._createOn(t3), this.graveyardPosition);
          }
          toJSON() {
            const t3 = super.toJSON();
            return t3.sourcePosition = t3.sourcePosition.toJSON(), t3.targetPosition = t3.targetPosition.toJSON(), t3.graveyardPosition = t3.graveyardPosition.toJSON(), t3;
          }
          static get className() {
            return "MergeOperation";
          }
          static fromJSON(t3, e3) {
            const n2 = Wl.fromJSON(t3.sourcePosition, e3), o2 = Wl.fromJSON(t3.targetPosition, e3), i2 = Wl.fromJSON(t3.graveyardPosition, e3);
            return new this(n2, t3.howMany, o2, i2, t3.baseVersion);
          }
        }
        class tu extends Uh {
          constructor(t3, e3, n2, o2, i2, r2) {
            super(r2), this.name = t3, this.oldRange = e3 ? e3.clone() : null, this.newRange = n2 ? n2.clone() : null, this.affectsData = i2, this._markers = o2;
          }
          get type() {
            return "marker";
          }
          get affectedSelectable() {
            const t3 = [];
            return this.oldRange && t3.push(this.oldRange.clone()), this.newRange && (this.oldRange ? t3.push(...this.newRange.getDifference(this.oldRange)) : t3.push(this.newRange.clone())), t3;
          }
          clone() {
            return new tu(this.name, this.oldRange, this.newRange, this._markers, this.affectsData, this.baseVersion);
          }
          getReversed() {
            return new tu(this.name, this.newRange, this.oldRange, this._markers, this.affectsData, this.baseVersion + 1);
          }
          _execute() {
            this.newRange ? this._markers._set(this.name, this.newRange, true, this.affectsData) : this._markers._remove(this.name);
          }
          toJSON() {
            const t3 = super.toJSON();
            return this.oldRange && (t3.oldRange = this.oldRange.toJSON()), this.newRange && (t3.newRange = this.newRange.toJSON()), delete t3._markers, t3;
          }
          static get className() {
            return "MarkerOperation";
          }
          static fromJSON(t3, e3) {
            return new tu(t3.name, t3.oldRange ? Jl.fromJSON(t3.oldRange, e3) : null, t3.newRange ? Jl.fromJSON(t3.newRange, e3) : null, e3.model.markers, t3.affectsData, t3.baseVersion);
          }
        }
        const eu = function(t3, e3) {
          return yl(t3, e3);
        };
        class nu extends Uh {
          constructor(t3, e3, n2, o2, i2) {
            super(i2), this.range = t3.clone(), this.key = e3, this.oldValue = void 0 === n2 ? null : n2, this.newValue = void 0 === o2 ? null : o2;
          }
          get type() {
            return null === this.oldValue ? "addAttribute" : null === this.newValue ? "removeAttribute" : "changeAttribute";
          }
          get affectedSelectable() {
            return this.range.clone();
          }
          clone() {
            return new nu(this.range, this.key, this.oldValue, this.newValue, this.baseVersion);
          }
          getReversed() {
            return new nu(this.range, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
          }
          toJSON() {
            const t3 = super.toJSON();
            return t3.range = this.range.toJSON(), t3;
          }
          _validate() {
            if (!this.range.isFlat)
              throw new A("attribute-operation-range-not-flat", this);
            for (const t3 of this.range.getItems({ shallow: true })) {
              if (null !== this.oldValue && !eu(t3.getAttribute(this.key), this.oldValue))
                throw new A("attribute-operation-wrong-old-value", this, { item: t3, key: this.key, value: this.oldValue });
              if (null === this.oldValue && null !== this.newValue && t3.hasAttribute(this.key))
                throw new A("attribute-operation-attribute-exists", this, { node: t3, key: this.key });
            }
          }
          _execute() {
            eu(this.oldValue, this.newValue) || function(t3, e3, n2) {
              Zh(t3.start), Zh(t3.end);
              for (const o2 of t3.getItems({ shallow: true })) {
                const t4 = o2.is("$textProxy") ? o2.textNode : o2;
                null !== n2 ? t4._setAttribute(e3, n2) : t4._removeAttribute(e3), Kh(t4.parent, t4.index);
              }
              Kh(t3.end.parent, t3.end.index);
            }(this.range, this.key, this.newValue);
          }
          static get className() {
            return "AttributeOperation";
          }
          static fromJSON(t3, e3) {
            return new nu(Jl.fromJSON(t3.range, e3), t3.key, t3.oldValue, t3.newValue, t3.baseVersion);
          }
        }
        class ou extends Uh {
          get type() {
            return "noop";
          }
          get affectedSelectable() {
            return null;
          }
          clone() {
            return new ou(this.baseVersion);
          }
          getReversed() {
            return new ou(this.baseVersion + 1);
          }
          _execute() {
          }
          static get className() {
            return "NoOperation";
          }
        }
        class iu extends Uh {
          constructor(t3, e3, n2, o2) {
            super(o2), this.position = t3, this.position.stickiness = "toNext", this.oldName = e3, this.newName = n2;
          }
          get type() {
            return "rename";
          }
          get affectedSelectable() {
            return this.position.nodeAfter;
          }
          clone() {
            return new iu(this.position.clone(), this.oldName, this.newName, this.baseVersion);
          }
          getReversed() {
            return new iu(this.position.clone(), this.newName, this.oldName, this.baseVersion + 1);
          }
          _validate() {
            const t3 = this.position.nodeAfter;
            if (!(t3 instanceof Hl))
              throw new A("rename-operation-wrong-position", this);
            if (t3.name !== this.oldName)
              throw new A("rename-operation-wrong-name", this);
          }
          _execute() {
            this.position.nodeAfter.name = this.newName;
          }
          toJSON() {
            const t3 = super.toJSON();
            return t3.position = this.position.toJSON(), t3;
          }
          static get className() {
            return "RenameOperation";
          }
          static fromJSON(t3, e3) {
            return new iu(Wl.fromJSON(t3.position, e3), t3.oldName, t3.newName, t3.baseVersion);
          }
        }
        class ru extends Uh {
          constructor(t3, e3, n2, o2, i2) {
            super(i2), this.root = t3, this.key = e3, this.oldValue = void 0 === n2 ? null : n2, this.newValue = void 0 === o2 ? null : o2;
          }
          get type() {
            return null === this.oldValue ? "addRootAttribute" : null === this.newValue ? "removeRootAttribute" : "changeRootAttribute";
          }
          get affectedSelectable() {
            return this.root;
          }
          clone() {
            return new ru(this.root, this.key, this.oldValue, this.newValue, this.baseVersion);
          }
          getReversed() {
            return new ru(this.root, this.key, this.newValue, this.oldValue, this.baseVersion + 1);
          }
          _validate() {
            if (this.root != this.root.root || this.root.is("documentFragment"))
              throw new A("rootattribute-operation-not-a-root", this, { root: this.root, key: this.key });
            if (null !== this.oldValue && this.root.getAttribute(this.key) !== this.oldValue)
              throw new A("rootattribute-operation-wrong-old-value", this, { root: this.root, key: this.key });
            if (null === this.oldValue && null !== this.newValue && this.root.hasAttribute(this.key))
              throw new A("rootattribute-operation-attribute-exists", this, { root: this.root, key: this.key });
          }
          _execute() {
            null !== this.newValue ? this.root._setAttribute(this.key, this.newValue) : this.root._removeAttribute(this.key);
          }
          toJSON() {
            const t3 = super.toJSON();
            return t3.root = this.root.toJSON(), t3;
          }
          static get className() {
            return "RootAttributeOperation";
          }
          static fromJSON(t3, e3) {
            if (!e3.getRoot(t3.root))
              throw new A("rootattribute-operation-fromjson-no-root", this, { rootName: t3.root });
            return new ru(e3.getRoot(t3.root), t3.key, t3.oldValue, t3.newValue, t3.baseVersion);
          }
        }
        class su extends Uh {
          constructor(t3, e3, n2, o2, i2) {
            if (super(i2), this.rootName = t3, this.elementName = e3, this.isAdd = n2, this._document = o2, !this._document.getRoot(this.rootName)) {
              this._document.createRoot(this.elementName, this.rootName)._isAttached = false;
            }
          }
          get type() {
            return this.isAdd ? "addRoot" : "detachRoot";
          }
          get affectedSelectable() {
            return this._document.getRoot(this.rootName);
          }
          clone() {
            return new su(this.rootName, this.elementName, this.isAdd, this._document, this.baseVersion);
          }
          getReversed() {
            return new su(this.rootName, this.elementName, !this.isAdd, this._document, this.baseVersion + 1);
          }
          _execute() {
            this._document.getRoot(this.rootName)._isAttached = this.isAdd;
          }
          toJSON() {
            const t3 = super.toJSON();
            return delete t3._document, t3;
          }
          static get className() {
            return "RootOperation";
          }
          static fromJSON(t3, e3) {
            return new su(t3.rootName, t3.elementName, t3.isAdd, e3, t3.baseVersion);
          }
        }
        const au = {};
        au[nu.className] = nu, au[Qh.className] = Qh, au[tu.className] = tu, au[$h.className] = $h, au[ou.className] = ou, au[Uh.className] = Uh, au[iu.className] = iu, au[ru.className] = ru, au[su.className] = su, au[Jh.className] = Jh, au[Xh.className] = Xh;
        class cu {
          static fromJSON(t3, e3) {
            return au[t3.__className].fromJSON(t3, e3);
          }
        }
        const lu = /* @__PURE__ */ new Map();
        function du(t3, e3, n2) {
          let o2 = lu.get(t3);
          o2 || (o2 = /* @__PURE__ */ new Map(), lu.set(t3, o2)), o2.set(e3, n2);
        }
        function hu(t3) {
          return [t3];
        }
        function uu(t3, e3, n2 = {}) {
          const o2 = function(t4, e4) {
            const n3 = lu.get(t4);
            return n3 && n3.has(e4) ? n3.get(e4) : hu;
          }(t3.constructor, e3.constructor);
          try {
            return o2(t3 = t3.clone(), e3, n2);
          } catch (t4) {
            throw t4;
          }
        }
        function gu(t3, e3, n2) {
          t3 = t3.slice(), e3 = e3.slice();
          const o2 = new pu(n2.document, n2.useRelations, n2.forceWeakRemove);
          o2.setOriginalOperations(t3), o2.setOriginalOperations(e3);
          const i2 = o2.originalOperations;
          if (0 == t3.length || 0 == e3.length)
            return { operationsA: t3, operationsB: e3, originalOperations: i2 };
          const r2 = /* @__PURE__ */ new WeakMap();
          for (const e4 of t3)
            r2.set(e4, 0);
          const s3 = { nextBaseVersionA: t3[t3.length - 1].baseVersion + 1, nextBaseVersionB: e3[e3.length - 1].baseVersion + 1, originalOperationsACount: t3.length, originalOperationsBCount: e3.length };
          let a2 = 0;
          for (; a2 < t3.length; ) {
            const n3 = t3[a2], i3 = r2.get(n3);
            if (i3 == e3.length) {
              a2++;
              continue;
            }
            const s4 = e3[i3], c2 = uu(n3, s4, o2.getContext(n3, s4, true)), l2 = uu(s4, n3, o2.getContext(s4, n3, false));
            o2.updateRelation(n3, s4), o2.setOriginalOperations(c2, n3), o2.setOriginalOperations(l2, s4);
            for (const t4 of c2)
              r2.set(t4, i3 + l2.length);
            t3.splice(a2, 1, ...c2), e3.splice(i3, 1, ...l2);
          }
          if (n2.padWithNoOps) {
            const n3 = t3.length - s3.originalOperationsACount, o3 = e3.length - s3.originalOperationsBCount;
            fu(t3, o3 - n3), fu(e3, n3 - o3);
          }
          return mu(t3, s3.nextBaseVersionB), mu(e3, s3.nextBaseVersionA), { operationsA: t3, operationsB: e3, originalOperations: i2 };
        }
        class pu {
          constructor(t3, e3, n2 = false) {
            this.originalOperations = /* @__PURE__ */ new Map(), this._history = t3.history, this._useRelations = e3, this._forceWeakRemove = !!n2, this._relations = /* @__PURE__ */ new Map();
          }
          setOriginalOperations(t3, e3 = null) {
            const n2 = e3 ? this.originalOperations.get(e3) : null;
            for (const e4 of t3)
              this.originalOperations.set(e4, n2 || e4);
          }
          updateRelation(t3, e3) {
            if (t3 instanceof $h)
              e3 instanceof Xh ? t3.targetPosition.isEqual(e3.sourcePosition) || e3.movedRange.containsPosition(t3.targetPosition) ? this._setRelation(t3, e3, "insertAtSource") : t3.targetPosition.isEqual(e3.deletionPosition) ? this._setRelation(t3, e3, "insertBetween") : t3.targetPosition.isAfter(e3.sourcePosition) && this._setRelation(t3, e3, "moveTargetAfter") : e3 instanceof $h && (t3.targetPosition.isEqual(e3.sourcePosition) || t3.targetPosition.isBefore(e3.sourcePosition) ? this._setRelation(t3, e3, "insertBefore") : this._setRelation(t3, e3, "insertAfter"));
            else if (t3 instanceof Jh) {
              if (e3 instanceof Xh)
                t3.splitPosition.isBefore(e3.sourcePosition) && this._setRelation(t3, e3, "splitBefore");
              else if (e3 instanceof $h)
                if (t3.splitPosition.isEqual(e3.sourcePosition) || t3.splitPosition.isBefore(e3.sourcePosition))
                  this._setRelation(t3, e3, "splitBefore");
                else {
                  const n2 = Jl._createFromPositionAndShift(e3.sourcePosition, e3.howMany);
                  if (t3.splitPosition.hasSameParentAs(e3.sourcePosition) && n2.containsPosition(t3.splitPosition)) {
                    const o2 = n2.end.offset - t3.splitPosition.offset, i2 = t3.splitPosition.offset - n2.start.offset;
                    this._setRelation(t3, e3, { howMany: o2, offset: i2 });
                  }
                }
            } else if (t3 instanceof Xh)
              e3 instanceof Xh ? (t3.targetPosition.isEqual(e3.sourcePosition) || this._setRelation(t3, e3, "mergeTargetNotMoved"), t3.sourcePosition.isEqual(e3.targetPosition) && this._setRelation(t3, e3, "mergeSourceNotMoved"), t3.sourcePosition.isEqual(e3.sourcePosition) && this._setRelation(t3, e3, "mergeSameElement")) : e3 instanceof Jh && t3.sourcePosition.isEqual(e3.splitPosition) && this._setRelation(t3, e3, "splitAtSource");
            else if (t3 instanceof tu) {
              const n2 = t3.newRange;
              if (!n2)
                return;
              if (e3 instanceof $h) {
                const o2 = Jl._createFromPositionAndShift(e3.sourcePosition, e3.howMany), i2 = o2.containsPosition(n2.start) || o2.start.isEqual(n2.start), r2 = o2.containsPosition(n2.end) || o2.end.isEqual(n2.end);
                !i2 && !r2 || o2.containsRange(n2) || this._setRelation(t3, e3, { side: i2 ? "left" : "right", path: i2 ? n2.start.path.slice() : n2.end.path.slice() });
              } else if (e3 instanceof Xh) {
                const o2 = n2.start.isEqual(e3.targetPosition), i2 = n2.start.isEqual(e3.deletionPosition), r2 = n2.end.isEqual(e3.deletionPosition), s3 = n2.end.isEqual(e3.sourcePosition);
                (o2 || i2 || r2 || s3) && this._setRelation(t3, e3, { wasInLeftElement: o2, wasStartBeforeMergedElement: i2, wasEndBeforeMergedElement: r2, wasInRightElement: s3 });
              }
            }
          }
          getContext(t3, e3, n2) {
            return { aIsStrong: n2, aWasUndone: this._wasUndone(t3), bWasUndone: this._wasUndone(e3), abRelation: this._useRelations ? this._getRelation(t3, e3) : null, baRelation: this._useRelations ? this._getRelation(e3, t3) : null, forceWeakRemove: this._forceWeakRemove };
          }
          _wasUndone(t3) {
            const e3 = this.originalOperations.get(t3);
            return e3.wasUndone || this._history.isUndoneOperation(e3);
          }
          _getRelation(t3, e3) {
            const n2 = this.originalOperations.get(e3), o2 = this._history.getUndoneOperation(n2);
            if (!o2)
              return null;
            const i2 = this.originalOperations.get(t3), r2 = this._relations.get(i2);
            return r2 && r2.get(o2) || null;
          }
          _setRelation(t3, e3, n2) {
            const o2 = this.originalOperations.get(t3), i2 = this.originalOperations.get(e3);
            let r2 = this._relations.get(o2);
            r2 || (r2 = /* @__PURE__ */ new Map(), this._relations.set(o2, r2)), r2.set(i2, n2);
          }
        }
        function mu(t3, e3) {
          for (const n2 of t3)
            n2.baseVersion = e3++;
        }
        function fu(t3, e3) {
          for (let n2 = 0; n2 < e3; n2++)
            t3.push(new ou(0));
        }
        function ku(t3, e3, n2) {
          const o2 = t3.nodes.getNode(0).getAttribute(e3);
          if (o2 == n2)
            return null;
          const i2 = new Jl(t3.position, t3.position.getShiftedBy(t3.howMany));
          return new nu(i2, e3, o2, n2, 0);
        }
        function bu(t3, e3) {
          return null === t3.targetPosition._getTransformedByDeletion(e3.sourcePosition, e3.howMany);
        }
        function wu(t3, e3) {
          const n2 = [];
          for (let o2 = 0; o2 < t3.length; o2++) {
            const i2 = t3[o2], r2 = new $h(i2.start, i2.end.offset - i2.start.offset, e3, 0);
            n2.push(r2);
            for (let e4 = o2 + 1; e4 < t3.length; e4++)
              t3[e4] = t3[e4]._getTransformedByMove(r2.sourcePosition, r2.targetPosition, r2.howMany)[0];
            e3 = e3._getTransformedByMove(r2.sourcePosition, r2.targetPosition, r2.howMany);
          }
          return n2;
        }
        du(nu, nu, (t3, e3, n2) => {
          if (t3.key === e3.key && t3.range.start.hasSameParentAs(e3.range.start)) {
            const o2 = t3.range.getDifference(e3.range).map((e4) => new nu(e4, t3.key, t3.oldValue, t3.newValue, 0)), i2 = t3.range.getIntersection(e3.range);
            return i2 && n2.aIsStrong && o2.push(new nu(i2, e3.key, e3.newValue, t3.newValue, 0)), 0 == o2.length ? [new ou(0)] : o2;
          }
          return [t3];
        }), du(nu, Qh, (t3, e3) => {
          if (t3.range.start.hasSameParentAs(e3.position) && t3.range.containsPosition(e3.position)) {
            const n2 = t3.range._getTransformedByInsertion(e3.position, e3.howMany, !e3.shouldReceiveAttributes).map((e4) => new nu(e4, t3.key, t3.oldValue, t3.newValue, t3.baseVersion));
            if (e3.shouldReceiveAttributes) {
              const o2 = ku(e3, t3.key, t3.oldValue);
              o2 && n2.unshift(o2);
            }
            return n2;
          }
          return t3.range = t3.range._getTransformedByInsertion(e3.position, e3.howMany, false)[0], [t3];
        }), du(nu, Xh, (t3, e3) => {
          const n2 = [];
          t3.range.start.hasSameParentAs(e3.deletionPosition) && (t3.range.containsPosition(e3.deletionPosition) || t3.range.start.isEqual(e3.deletionPosition)) && n2.push(Jl._createFromPositionAndShift(e3.graveyardPosition, 1));
          const o2 = t3.range._getTransformedByMergeOperation(e3);
          return o2.isCollapsed || n2.push(o2), n2.map((e4) => new nu(e4, t3.key, t3.oldValue, t3.newValue, t3.baseVersion));
        }), du(nu, $h, (t3, e3) => {
          const n2 = function(t4, e4) {
            const n3 = Jl._createFromPositionAndShift(e4.sourcePosition, e4.howMany);
            let o2 = null, i2 = [];
            n3.containsRange(t4, true) ? o2 = t4 : t4.start.hasSameParentAs(n3.start) ? (i2 = t4.getDifference(n3), o2 = t4.getIntersection(n3)) : i2 = [t4];
            const r2 = [];
            for (let t5 of i2) {
              t5 = t5._getTransformedByDeletion(e4.sourcePosition, e4.howMany);
              const n4 = e4.getMovedRangeStart(), o3 = t5.start.hasSameParentAs(n4), i3 = t5._getTransformedByInsertion(n4, e4.howMany, o3);
              r2.push(...i3);
            }
            o2 && r2.push(o2._getTransformedByMove(e4.sourcePosition, e4.targetPosition, e4.howMany, false)[0]);
            return r2;
          }(t3.range, e3);
          return n2.map((e4) => new nu(e4, t3.key, t3.oldValue, t3.newValue, t3.baseVersion));
        }), du(nu, Jh, (t3, e3) => {
          if (t3.range.end.isEqual(e3.insertionPosition))
            return e3.graveyardPosition || t3.range.end.offset++, [t3];
          if (t3.range.start.hasSameParentAs(e3.splitPosition) && t3.range.containsPosition(e3.splitPosition)) {
            const n2 = t3.clone();
            return n2.range = new Jl(e3.moveTargetPosition.clone(), t3.range.end._getCombined(e3.splitPosition, e3.moveTargetPosition)), t3.range.end = e3.splitPosition.clone(), t3.range.end.stickiness = "toPrevious", [t3, n2];
          }
          return t3.range = t3.range._getTransformedBySplitOperation(e3), [t3];
        }), du(Qh, nu, (t3, e3) => {
          const n2 = [t3];
          if (t3.shouldReceiveAttributes && t3.position.hasSameParentAs(e3.range.start) && e3.range.containsPosition(t3.position)) {
            const o2 = ku(t3, e3.key, e3.newValue);
            o2 && n2.push(o2);
          }
          return n2;
        }), du(Qh, Qh, (t3, e3, n2) => (t3.position.isEqual(e3.position) && n2.aIsStrong || (t3.position = t3.position._getTransformedByInsertOperation(e3)), [t3])), du(Qh, $h, (t3, e3) => (t3.position = t3.position._getTransformedByMoveOperation(e3), [t3])), du(Qh, Jh, (t3, e3) => (t3.position = t3.position._getTransformedBySplitOperation(e3), [t3])), du(Qh, Xh, (t3, e3) => (t3.position = t3.position._getTransformedByMergeOperation(e3), [t3])), du(tu, Qh, (t3, e3) => (t3.oldRange && (t3.oldRange = t3.oldRange._getTransformedByInsertOperation(e3)[0]), t3.newRange && (t3.newRange = t3.newRange._getTransformedByInsertOperation(e3)[0]), [t3])), du(tu, tu, (t3, e3, n2) => {
          if (t3.name == e3.name) {
            if (!n2.aIsStrong)
              return [new ou(0)];
            t3.oldRange = e3.newRange ? e3.newRange.clone() : null;
          }
          return [t3];
        }), du(tu, Xh, (t3, e3) => (t3.oldRange && (t3.oldRange = t3.oldRange._getTransformedByMergeOperation(e3)), t3.newRange && (t3.newRange = t3.newRange._getTransformedByMergeOperation(e3)), [t3])), du(tu, $h, (t3, e3, n2) => {
          if (t3.oldRange && (t3.oldRange = Jl._createFromRanges(t3.oldRange._getTransformedByMoveOperation(e3))), t3.newRange) {
            if (n2.abRelation) {
              const o2 = Jl._createFromRanges(t3.newRange._getTransformedByMoveOperation(e3));
              if ("left" == n2.abRelation.side && e3.targetPosition.isEqual(t3.newRange.start))
                return t3.newRange.end = o2.end, t3.newRange.start.path = n2.abRelation.path, [t3];
              if ("right" == n2.abRelation.side && e3.targetPosition.isEqual(t3.newRange.end))
                return t3.newRange.start = o2.start, t3.newRange.end.path = n2.abRelation.path, [t3];
            }
            t3.newRange = Jl._createFromRanges(t3.newRange._getTransformedByMoveOperation(e3));
          }
          return [t3];
        }), du(tu, Jh, (t3, e3, n2) => {
          if (t3.oldRange && (t3.oldRange = t3.oldRange._getTransformedBySplitOperation(e3)), t3.newRange) {
            if (n2.abRelation) {
              const o2 = t3.newRange._getTransformedBySplitOperation(e3);
              return t3.newRange.start.isEqual(e3.splitPosition) && n2.abRelation.wasStartBeforeMergedElement ? t3.newRange.start = Wl._createAt(e3.insertionPosition) : t3.newRange.start.isEqual(e3.splitPosition) && !n2.abRelation.wasInLeftElement && (t3.newRange.start = Wl._createAt(e3.moveTargetPosition)), t3.newRange.end.isEqual(e3.splitPosition) && n2.abRelation.wasInRightElement ? t3.newRange.end = Wl._createAt(e3.moveTargetPosition) : t3.newRange.end.isEqual(e3.splitPosition) && n2.abRelation.wasEndBeforeMergedElement ? t3.newRange.end = Wl._createAt(e3.insertionPosition) : t3.newRange.end = o2.end, [t3];
            }
            t3.newRange = t3.newRange._getTransformedBySplitOperation(e3);
          }
          return [t3];
        }), du(Xh, Qh, (t3, e3) => (t3.sourcePosition.hasSameParentAs(e3.position) && (t3.howMany += e3.howMany), t3.sourcePosition = t3.sourcePosition._getTransformedByInsertOperation(e3), t3.targetPosition = t3.targetPosition._getTransformedByInsertOperation(e3), [t3])), du(Xh, Xh, (t3, e3, n2) => {
          if (t3.sourcePosition.isEqual(e3.sourcePosition) && t3.targetPosition.isEqual(e3.targetPosition)) {
            if (n2.bWasUndone) {
              const n3 = e3.graveyardPosition.path.slice();
              return n3.push(0), t3.sourcePosition = new Wl(e3.graveyardPosition.root, n3), t3.howMany = 0, [t3];
            }
            return [new ou(0)];
          }
          if (t3.sourcePosition.isEqual(e3.sourcePosition) && !t3.targetPosition.isEqual(e3.targetPosition) && !n2.bWasUndone && "splitAtSource" != n2.abRelation) {
            const o2 = "$graveyard" == t3.targetPosition.root.rootName, i2 = "$graveyard" == e3.targetPosition.root.rootName;
            if (i2 && !o2 || !(o2 && !i2) && n2.aIsStrong) {
              const n3 = e3.targetPosition._getTransformedByMergeOperation(e3), o3 = t3.targetPosition._getTransformedByMergeOperation(e3);
              return [new $h(n3, t3.howMany, o3, 0)];
            }
            return [new ou(0)];
          }
          return t3.sourcePosition.hasSameParentAs(e3.targetPosition) && (t3.howMany += e3.howMany), t3.sourcePosition = t3.sourcePosition._getTransformedByMergeOperation(e3), t3.targetPosition = t3.targetPosition._getTransformedByMergeOperation(e3), t3.graveyardPosition.isEqual(e3.graveyardPosition) && n2.aIsStrong || (t3.graveyardPosition = t3.graveyardPosition._getTransformedByMergeOperation(e3)), [t3];
        }), du(Xh, $h, (t3, e3, n2) => {
          const o2 = Jl._createFromPositionAndShift(e3.sourcePosition, e3.howMany);
          return "remove" == e3.type && !n2.bWasUndone && !n2.forceWeakRemove && t3.deletionPosition.hasSameParentAs(e3.sourcePosition) && o2.containsPosition(t3.sourcePosition) ? [new ou(0)] : (t3.sourcePosition.hasSameParentAs(e3.targetPosition) && (t3.howMany += e3.howMany), t3.sourcePosition.hasSameParentAs(e3.sourcePosition) && (t3.howMany -= e3.howMany), t3.sourcePosition = t3.sourcePosition._getTransformedByMoveOperation(e3), t3.targetPosition = t3.targetPosition._getTransformedByMoveOperation(e3), t3.graveyardPosition.isEqual(e3.targetPosition) || (t3.graveyardPosition = t3.graveyardPosition._getTransformedByMoveOperation(e3)), [t3]);
        }), du(Xh, Jh, (t3, e3, n2) => {
          if (e3.graveyardPosition && (t3.graveyardPosition = t3.graveyardPosition._getTransformedByDeletion(e3.graveyardPosition, 1), t3.deletionPosition.isEqual(e3.graveyardPosition) && (t3.howMany = e3.howMany)), t3.targetPosition.isEqual(e3.splitPosition)) {
            const o2 = 0 != e3.howMany, i2 = e3.graveyardPosition && t3.deletionPosition.isEqual(e3.graveyardPosition);
            if (o2 || i2 || "mergeTargetNotMoved" == n2.abRelation)
              return t3.sourcePosition = t3.sourcePosition._getTransformedBySplitOperation(e3), [t3];
          }
          if (t3.sourcePosition.isEqual(e3.splitPosition)) {
            if ("mergeSourceNotMoved" == n2.abRelation)
              return t3.howMany = 0, t3.targetPosition = t3.targetPosition._getTransformedBySplitOperation(e3), [t3];
            if ("mergeSameElement" == n2.abRelation || t3.sourcePosition.offset > 0)
              return t3.sourcePosition = e3.moveTargetPosition.clone(), t3.targetPosition = t3.targetPosition._getTransformedBySplitOperation(e3), [t3];
          }
          return t3.sourcePosition.hasSameParentAs(e3.splitPosition) && (t3.howMany = e3.splitPosition.offset), t3.sourcePosition = t3.sourcePosition._getTransformedBySplitOperation(e3), t3.targetPosition = t3.targetPosition._getTransformedBySplitOperation(e3), [t3];
        }), du($h, Qh, (t3, e3) => {
          const n2 = Jl._createFromPositionAndShift(t3.sourcePosition, t3.howMany)._getTransformedByInsertOperation(e3, false)[0];
          return t3.sourcePosition = n2.start, t3.howMany = n2.end.offset - n2.start.offset, t3.targetPosition.isEqual(e3.position) || (t3.targetPosition = t3.targetPosition._getTransformedByInsertOperation(e3)), [t3];
        }), du($h, $h, (t3, e3, n2) => {
          const o2 = Jl._createFromPositionAndShift(t3.sourcePosition, t3.howMany), i2 = Jl._createFromPositionAndShift(e3.sourcePosition, e3.howMany);
          let r2, s3 = n2.aIsStrong, a2 = !n2.aIsStrong;
          if ("insertBefore" == n2.abRelation || "insertAfter" == n2.baRelation ? a2 = true : "insertAfter" != n2.abRelation && "insertBefore" != n2.baRelation || (a2 = false), r2 = t3.targetPosition.isEqual(e3.targetPosition) && a2 ? t3.targetPosition._getTransformedByDeletion(e3.sourcePosition, e3.howMany) : t3.targetPosition._getTransformedByMove(e3.sourcePosition, e3.targetPosition, e3.howMany), bu(t3, e3) && bu(e3, t3))
            return [e3.getReversed()];
          if (o2.containsPosition(e3.targetPosition) && o2.containsRange(i2, true))
            return o2.start = o2.start._getTransformedByMove(e3.sourcePosition, e3.targetPosition, e3.howMany), o2.end = o2.end._getTransformedByMove(e3.sourcePosition, e3.targetPosition, e3.howMany), wu([o2], r2);
          if (i2.containsPosition(t3.targetPosition) && i2.containsRange(o2, true))
            return o2.start = o2.start._getCombined(e3.sourcePosition, e3.getMovedRangeStart()), o2.end = o2.end._getCombined(e3.sourcePosition, e3.getMovedRangeStart()), wu([o2], r2);
          const c2 = tt(t3.sourcePosition.getParentPath(), e3.sourcePosition.getParentPath());
          if ("prefix" == c2 || "extension" == c2)
            return o2.start = o2.start._getTransformedByMove(e3.sourcePosition, e3.targetPosition, e3.howMany), o2.end = o2.end._getTransformedByMove(e3.sourcePosition, e3.targetPosition, e3.howMany), wu([o2], r2);
          "remove" != t3.type || "remove" == e3.type || n2.aWasUndone || n2.forceWeakRemove ? "remove" == t3.type || "remove" != e3.type || n2.bWasUndone || n2.forceWeakRemove || (s3 = false) : s3 = true;
          const l2 = [], d2 = o2.getDifference(i2);
          for (const t4 of d2) {
            t4.start = t4.start._getTransformedByDeletion(e3.sourcePosition, e3.howMany), t4.end = t4.end._getTransformedByDeletion(e3.sourcePosition, e3.howMany);
            const n3 = "same" == tt(t4.start.getParentPath(), e3.getMovedRangeStart().getParentPath()), o3 = t4._getTransformedByInsertion(e3.getMovedRangeStart(), e3.howMany, n3);
            l2.push(...o3);
          }
          const h2 = o2.getIntersection(i2);
          return null !== h2 && s3 && (h2.start = h2.start._getCombined(e3.sourcePosition, e3.getMovedRangeStart()), h2.end = h2.end._getCombined(e3.sourcePosition, e3.getMovedRangeStart()), 0 === l2.length ? l2.push(h2) : 1 == l2.length ? i2.start.isBefore(o2.start) || i2.start.isEqual(o2.start) ? l2.unshift(h2) : l2.push(h2) : l2.splice(1, 0, h2)), 0 === l2.length ? [new ou(t3.baseVersion)] : wu(l2, r2);
        }), du($h, Jh, (t3, e3, n2) => {
          let o2 = t3.targetPosition.clone();
          t3.targetPosition.isEqual(e3.insertionPosition) && e3.graveyardPosition && "moveTargetAfter" != n2.abRelation || (o2 = t3.targetPosition._getTransformedBySplitOperation(e3));
          const i2 = Jl._createFromPositionAndShift(t3.sourcePosition, t3.howMany);
          if (i2.end.isEqual(e3.insertionPosition))
            return e3.graveyardPosition || t3.howMany++, t3.targetPosition = o2, [t3];
          if (i2.start.hasSameParentAs(e3.splitPosition) && i2.containsPosition(e3.splitPosition)) {
            let t4 = new Jl(e3.splitPosition, i2.end);
            t4 = t4._getTransformedBySplitOperation(e3);
            return wu([new Jl(i2.start, e3.splitPosition), t4], o2);
          }
          t3.targetPosition.isEqual(e3.splitPosition) && "insertAtSource" == n2.abRelation && (o2 = e3.moveTargetPosition), t3.targetPosition.isEqual(e3.insertionPosition) && "insertBetween" == n2.abRelation && (o2 = t3.targetPosition);
          const r2 = [i2._getTransformedBySplitOperation(e3)];
          if (e3.graveyardPosition) {
            const o3 = i2.start.isEqual(e3.graveyardPosition) || i2.containsPosition(e3.graveyardPosition);
            t3.howMany > 1 && o3 && !n2.aWasUndone && r2.push(Jl._createFromPositionAndShift(e3.insertionPosition, 1));
          }
          return wu(r2, o2);
        }), du($h, Xh, (t3, e3, n2) => {
          const o2 = Jl._createFromPositionAndShift(t3.sourcePosition, t3.howMany);
          if (e3.deletionPosition.hasSameParentAs(t3.sourcePosition) && o2.containsPosition(e3.sourcePosition)) {
            if ("remove" != t3.type || n2.forceWeakRemove) {
              if (1 == t3.howMany)
                return n2.bWasUndone ? (t3.sourcePosition = e3.graveyardPosition.clone(), t3.targetPosition = t3.targetPosition._getTransformedByMergeOperation(e3), [t3]) : [new ou(0)];
            } else if (!n2.aWasUndone) {
              const n3 = [];
              let o3 = e3.graveyardPosition.clone(), i3 = e3.targetPosition._getTransformedByMergeOperation(e3);
              t3.howMany > 1 && (n3.push(new $h(t3.sourcePosition, t3.howMany - 1, t3.targetPosition, 0)), o3 = o3._getTransformedByMove(t3.sourcePosition, t3.targetPosition, t3.howMany - 1), i3 = i3._getTransformedByMove(t3.sourcePosition, t3.targetPosition, t3.howMany - 1));
              const r2 = e3.deletionPosition._getCombined(t3.sourcePosition, t3.targetPosition), s3 = new $h(o3, 1, r2, 0), a2 = s3.getMovedRangeStart().path.slice();
              a2.push(0);
              const c2 = new Wl(s3.targetPosition.root, a2);
              i3 = i3._getTransformedByMove(o3, r2, 1);
              const l2 = new $h(i3, e3.howMany, c2, 0);
              return n3.push(s3), n3.push(l2), n3;
            }
          }
          const i2 = Jl._createFromPositionAndShift(t3.sourcePosition, t3.howMany)._getTransformedByMergeOperation(e3);
          return t3.sourcePosition = i2.start, t3.howMany = i2.end.offset - i2.start.offset, t3.targetPosition = t3.targetPosition._getTransformedByMergeOperation(e3), [t3];
        }), du(iu, Qh, (t3, e3) => (t3.position = t3.position._getTransformedByInsertOperation(e3), [t3])), du(iu, Xh, (t3, e3) => t3.position.isEqual(e3.deletionPosition) ? (t3.position = e3.graveyardPosition.clone(), t3.position.stickiness = "toNext", [t3]) : (t3.position = t3.position._getTransformedByMergeOperation(e3), [t3])), du(iu, $h, (t3, e3) => (t3.position = t3.position._getTransformedByMoveOperation(e3), [t3])), du(iu, iu, (t3, e3, n2) => {
          if (t3.position.isEqual(e3.position)) {
            if (!n2.aIsStrong)
              return [new ou(0)];
            t3.oldName = e3.newName;
          }
          return [t3];
        }), du(iu, Jh, (t3, e3) => {
          if ("same" == tt(t3.position.path, e3.splitPosition.getParentPath()) && !e3.graveyardPosition) {
            const e4 = new iu(t3.position.getShiftedBy(1), t3.oldName, t3.newName, 0);
            return [t3, e4];
          }
          return t3.position = t3.position._getTransformedBySplitOperation(e3), [t3];
        }), du(ru, ru, (t3, e3, n2) => {
          if (t3.root === e3.root && t3.key === e3.key) {
            if (!n2.aIsStrong || t3.newValue === e3.newValue)
              return [new ou(0)];
            t3.oldValue = e3.newValue;
          }
          return [t3];
        }), du(su, su, (t3, e3) => t3.rootName === e3.rootName && t3.isAdd === e3.isAdd ? [new ou(0)] : [t3]), du(Jh, Qh, (t3, e3) => (t3.splitPosition.hasSameParentAs(e3.position) && t3.splitPosition.offset < e3.position.offset && (t3.howMany += e3.howMany), t3.splitPosition = t3.splitPosition._getTransformedByInsertOperation(e3), t3.insertionPosition = t3.insertionPosition._getTransformedByInsertOperation(e3), [t3])), du(Jh, Xh, (t3, e3, n2) => {
          if (!t3.graveyardPosition && !n2.bWasUndone && t3.splitPosition.hasSameParentAs(e3.sourcePosition)) {
            const n3 = e3.graveyardPosition.path.slice();
            n3.push(0);
            const o2 = new Wl(e3.graveyardPosition.root, n3), i2 = Jh.getInsertionPosition(new Wl(e3.graveyardPosition.root, n3)), r2 = new Jh(o2, 0, i2, null, 0);
            return t3.splitPosition = t3.splitPosition._getTransformedByMergeOperation(e3), t3.insertionPosition = Jh.getInsertionPosition(t3.splitPosition), t3.graveyardPosition = r2.insertionPosition.clone(), t3.graveyardPosition.stickiness = "toNext", [r2, t3];
          }
          return t3.splitPosition.hasSameParentAs(e3.deletionPosition) && !t3.splitPosition.isAfter(e3.deletionPosition) && t3.howMany--, t3.splitPosition.hasSameParentAs(e3.targetPosition) && (t3.howMany += e3.howMany), t3.splitPosition = t3.splitPosition._getTransformedByMergeOperation(e3), t3.insertionPosition = Jh.getInsertionPosition(t3.splitPosition), t3.graveyardPosition && (t3.graveyardPosition = t3.graveyardPosition._getTransformedByMergeOperation(e3)), [t3];
        }), du(Jh, $h, (t3, e3, n2) => {
          const o2 = Jl._createFromPositionAndShift(e3.sourcePosition, e3.howMany);
          if (t3.graveyardPosition) {
            const i3 = o2.start.isEqual(t3.graveyardPosition) || o2.containsPosition(t3.graveyardPosition);
            if (!n2.bWasUndone && i3) {
              const n3 = t3.splitPosition._getTransformedByMoveOperation(e3), o3 = t3.graveyardPosition._getTransformedByMoveOperation(e3), i4 = o3.path.slice();
              i4.push(0);
              const r2 = new Wl(o3.root, i4);
              return [new $h(n3, t3.howMany, r2, 0)];
            }
            t3.graveyardPosition = t3.graveyardPosition._getTransformedByMoveOperation(e3);
          }
          const i2 = t3.splitPosition.isEqual(e3.targetPosition);
          if (i2 && ("insertAtSource" == n2.baRelation || "splitBefore" == n2.abRelation))
            return t3.howMany += e3.howMany, t3.splitPosition = t3.splitPosition._getTransformedByDeletion(e3.sourcePosition, e3.howMany), t3.insertionPosition = Jh.getInsertionPosition(t3.splitPosition), [t3];
          if (i2 && n2.abRelation && n2.abRelation.howMany) {
            const { howMany: e4, offset: o3 } = n2.abRelation;
            return t3.howMany += e4, t3.splitPosition = t3.splitPosition.getShiftedBy(o3), [t3];
          }
          if (t3.splitPosition.hasSameParentAs(e3.sourcePosition) && o2.containsPosition(t3.splitPosition)) {
            const n3 = e3.howMany - (t3.splitPosition.offset - e3.sourcePosition.offset);
            return t3.howMany -= n3, t3.splitPosition.hasSameParentAs(e3.targetPosition) && t3.splitPosition.offset < e3.targetPosition.offset && (t3.howMany += e3.howMany), t3.splitPosition = e3.sourcePosition.clone(), t3.insertionPosition = Jh.getInsertionPosition(t3.splitPosition), [t3];
          }
          return e3.sourcePosition.isEqual(e3.targetPosition) || (t3.splitPosition.hasSameParentAs(e3.sourcePosition) && t3.splitPosition.offset <= e3.sourcePosition.offset && (t3.howMany -= e3.howMany), t3.splitPosition.hasSameParentAs(e3.targetPosition) && t3.splitPosition.offset < e3.targetPosition.offset && (t3.howMany += e3.howMany)), t3.splitPosition.stickiness = "toNone", t3.splitPosition = t3.splitPosition._getTransformedByMoveOperation(e3), t3.splitPosition.stickiness = "toNext", t3.graveyardPosition ? t3.insertionPosition = t3.insertionPosition._getTransformedByMoveOperation(e3) : t3.insertionPosition = Jh.getInsertionPosition(t3.splitPosition), [t3];
        }), du(Jh, Jh, (t3, e3, n2) => {
          if (t3.splitPosition.isEqual(e3.splitPosition)) {
            if (!t3.graveyardPosition && !e3.graveyardPosition)
              return [new ou(0)];
            if (t3.graveyardPosition && e3.graveyardPosition && t3.graveyardPosition.isEqual(e3.graveyardPosition))
              return [new ou(0)];
            if ("splitBefore" == n2.abRelation)
              return t3.howMany = 0, t3.graveyardPosition = t3.graveyardPosition._getTransformedBySplitOperation(e3), [t3];
          }
          if (t3.graveyardPosition && e3.graveyardPosition && t3.graveyardPosition.isEqual(e3.graveyardPosition)) {
            const o2 = "$graveyard" == t3.splitPosition.root.rootName, i2 = "$graveyard" == e3.splitPosition.root.rootName;
            if (i2 && !o2 || !(o2 && !i2) && n2.aIsStrong) {
              const n3 = [];
              return e3.howMany && n3.push(new $h(e3.moveTargetPosition, e3.howMany, e3.splitPosition, 0)), t3.howMany && n3.push(new $h(t3.splitPosition, t3.howMany, t3.moveTargetPosition, 0)), n3;
            }
            return [new ou(0)];
          }
          if (t3.graveyardPosition && (t3.graveyardPosition = t3.graveyardPosition._getTransformedBySplitOperation(e3)), t3.splitPosition.isEqual(e3.insertionPosition) && "splitBefore" == n2.abRelation)
            return t3.howMany++, [t3];
          if (e3.splitPosition.isEqual(t3.insertionPosition) && "splitBefore" == n2.baRelation) {
            const n3 = e3.insertionPosition.path.slice();
            n3.push(0);
            const o2 = new Wl(e3.insertionPosition.root, n3);
            return [t3, new $h(t3.insertionPosition, 1, o2, 0)];
          }
          return t3.splitPosition.hasSameParentAs(e3.splitPosition) && t3.splitPosition.offset < e3.splitPosition.offset && (t3.howMany -= e3.howMany), t3.splitPosition = t3.splitPosition._getTransformedBySplitOperation(e3), t3.insertionPosition = Jh.getInsertionPosition(t3.splitPosition), [t3];
        });
        class Au extends M(Wl) {
          constructor(t3, e3, n2 = "toNone") {
            if (super(t3, e3, n2), !this.root.is("rootElement"))
              throw new A("model-liveposition-root-not-rootelement", t3);
            Cu.call(this);
          }
          detach() {
            this.stopListening();
          }
          toPosition() {
            return new Wl(this.root, this.path.slice(), this.stickiness);
          }
          static fromPosition(t3, e3) {
            return new this(t3.root, t3.path.slice(), e3 || t3.stickiness);
          }
        }
        function Cu() {
          this.listenTo(this.root.document.model, "applyOperation", (t3, e3) => {
            const n2 = e3[0];
            n2.isDocumentOperation && _u.call(this, n2);
          }, { priority: "low" });
        }
        function _u(t3) {
          const e3 = this.getTransformedByOperation(t3);
          if (!this.isEqual(e3)) {
            const t4 = this.toPosition();
            this.path = e3.path, this.root = e3.root, this.fire("change", t4);
          }
        }
        Au.prototype.is = function(t3) {
          return "livePosition" === t3 || "model:livePosition" === t3 || "position" == t3 || "model:position" === t3;
        };
        class vu {
          constructor(t3 = {}) {
            "string" == typeof t3 && (t3 = "transparent" === t3 ? { isUndoable: false } : {}, C("batch-constructor-deprecated-string-type"));
            const { isUndoable: e3 = true, isLocal: n2 = true, isUndo: o2 = false, isTyping: i2 = false } = t3;
            this.operations = [], this.isUndoable = e3, this.isLocal = n2, this.isUndo = o2, this.isTyping = i2;
          }
          get type() {
            return C("batch-type-deprecated"), "default";
          }
          get baseVersion() {
            for (const t3 of this.operations)
              if (null !== t3.baseVersion)
                return t3.baseVersion;
            return null;
          }
          addOperation(t3) {
            return t3.batch = this, this.operations.push(t3), t3;
          }
        }
        var yu = Object.defineProperty, xu = Object.defineProperties, Eu = Object.getOwnPropertyDescriptors, Du = Object.getOwnPropertySymbols, Iu = Object.prototype.hasOwnProperty, Su = Object.prototype.propertyIsEnumerable, Tu = (t3, e3, n2) => e3 in t3 ? yu(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, Mu = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            Iu.call(e3, n2) && Tu(t3, n2, e3[n2]);
          if (Du)
            for (var n2 of Du(e3))
              Su.call(e3, n2) && Tu(t3, n2, e3[n2]);
          return t3;
        };
        class Bu {
          constructor(t3) {
            this._changesInElement = /* @__PURE__ */ new Map(), this._elementSnapshots = /* @__PURE__ */ new Map(), this._changedMarkers = /* @__PURE__ */ new Map(), this._changedRoots = /* @__PURE__ */ new Map(), this._changeCount = 0, this._cachedChanges = null, this._cachedChangesWithGraveyard = null, this._refreshedItems = /* @__PURE__ */ new Set(), this._markerCollection = t3;
          }
          get isEmpty() {
            return 0 == this._changesInElement.size && 0 == this._changedMarkers.size && 0 == this._changedRoots.size;
          }
          bufferOperation(t3) {
            const e3 = t3;
            switch (e3.type) {
              case "insert":
                if (this._isInInsertedElement(e3.position.parent))
                  return;
                this._markInsert(e3.position.parent, e3.position.offset, e3.nodes.maxOffset);
                break;
              case "addAttribute":
              case "removeAttribute":
              case "changeAttribute":
                for (const t4 of e3.range.getItems({ shallow: true }))
                  this._isInInsertedElement(t4.parent) || this._markAttribute(t4);
                break;
              case "remove":
              case "move":
              case "reinsert": {
                if (e3.sourcePosition.isEqual(e3.targetPosition) || e3.sourcePosition.getShiftedBy(e3.howMany).isEqual(e3.targetPosition))
                  return;
                const t4 = this._isInInsertedElement(e3.sourcePosition.parent), n2 = this._isInInsertedElement(e3.targetPosition.parent);
                t4 || this._markRemove(e3.sourcePosition.parent, e3.sourcePosition.offset, e3.howMany), n2 || this._markInsert(e3.targetPosition.parent, e3.getMovedRangeStart().offset, e3.howMany);
                break;
              }
              case "rename": {
                if (this._isInInsertedElement(e3.position.parent))
                  return;
                this._markRemove(e3.position.parent, e3.position.offset, 1), this._markInsert(e3.position.parent, e3.position.offset, 1);
                const t4 = Jl._createFromPositionAndShift(e3.position, 1);
                for (const e4 of this._markerCollection.getMarkersIntersectingRange(t4)) {
                  const t5 = e4.getData();
                  this.bufferMarkerChange(e4.name, t5, t5);
                }
                break;
              }
              case "split": {
                const t4 = e3.splitPosition.parent;
                this._isInInsertedElement(t4) || this._markRemove(t4, e3.splitPosition.offset, e3.howMany), this._isInInsertedElement(e3.insertionPosition.parent) || this._markInsert(e3.insertionPosition.parent, e3.insertionPosition.offset, 1), e3.graveyardPosition && this._markRemove(e3.graveyardPosition.parent, e3.graveyardPosition.offset, 1);
                break;
              }
              case "merge": {
                const t4 = e3.sourcePosition.parent;
                this._isInInsertedElement(t4.parent) || this._markRemove(t4.parent, t4.startOffset, 1);
                const n2 = e3.graveyardPosition.parent;
                this._markInsert(n2, e3.graveyardPosition.offset, 1);
                const o2 = e3.targetPosition.parent;
                this._isInInsertedElement(o2) || this._markInsert(o2, e3.targetPosition.offset, t4.maxOffset);
                break;
              }
              case "detachRoot":
              case "addRoot": {
                const t4 = e3.affectedSelectable;
                if (!t4._isLoaded)
                  return;
                if (t4.isAttached() == e3.isAdd)
                  return;
                this._bufferRootStateChange(e3.rootName, e3.isAdd);
                break;
              }
              case "addRootAttribute":
              case "removeRootAttribute":
              case "changeRootAttribute": {
                if (!e3.root._isLoaded)
                  return;
                const t4 = e3.root.rootName;
                this._bufferRootAttributeChange(t4, e3.key, e3.oldValue, e3.newValue);
                break;
              }
            }
            this._cachedChanges = null;
          }
          bufferMarkerChange(t3, e3, n2) {
            e3.range && e3.range.root.is("rootElement") && !e3.range.root._isLoaded && (e3.range = null), n2.range && n2.range.root.is("rootElement") && !n2.range.root._isLoaded && (n2.range = null);
            let o2 = this._changedMarkers.get(t3);
            o2 ? o2.newMarkerData = n2 : (o2 = { newMarkerData: n2, oldMarkerData: e3 }, this._changedMarkers.set(t3, o2)), null == o2.oldMarkerData.range && null == n2.range && this._changedMarkers.delete(t3);
          }
          getMarkersToRemove() {
            const t3 = [];
            for (const [e3, n2] of this._changedMarkers)
              null != n2.oldMarkerData.range && t3.push({ name: e3, range: n2.oldMarkerData.range });
            return t3;
          }
          getMarkersToAdd() {
            const t3 = [];
            for (const [e3, n2] of this._changedMarkers)
              null != n2.newMarkerData.range && t3.push({ name: e3, range: n2.newMarkerData.range });
            return t3;
          }
          getChangedMarkers() {
            return Array.from(this._changedMarkers).map(([t3, e3]) => ({ name: t3, data: { oldRange: e3.oldMarkerData.range, newRange: e3.newMarkerData.range } }));
          }
          hasDataChanges() {
            if (this._changesInElement.size > 0)
              return true;
            if (this._changedRoots.size > 0)
              return true;
            for (const { newMarkerData: t3, oldMarkerData: e3 } of this._changedMarkers.values()) {
              if (t3.affectsData !== e3.affectsData)
                return true;
              if (t3.affectsData) {
                const n2 = t3.range && !e3.range, o2 = !t3.range && e3.range, i2 = t3.range && e3.range && !t3.range.isEqual(e3.range);
                if (n2 || o2 || i2)
                  return true;
              }
            }
            return false;
          }
          getChanges(t3 = {}) {
            if (this._cachedChanges)
              return t3.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
            let e3 = [];
            for (const t4 of this._changesInElement.keys()) {
              const n2 = this._changesInElement.get(t4).sort((t5, e4) => t5.offset === e4.offset ? t5.type != e4.type ? "remove" == t5.type ? -1 : 1 : 0 : t5.offset < e4.offset ? -1 : 1), o2 = this._elementSnapshots.get(t4), i2 = Nu(t4.getChildren()), r2 = Pu(o2.length, n2);
              let s3 = 0, a2 = 0;
              for (const n3 of r2)
                if ("i" === n3)
                  e3.push(this._getInsertDiff(t4, s3, i2[s3])), s3++;
                else if ("r" === n3)
                  e3.push(this._getRemoveDiff(t4, s3, o2[a2])), a2++;
                else if ("a" === n3) {
                  const n4 = i2[s3].attributes, r3 = o2[a2].attributes;
                  let c2;
                  if ("$text" == i2[s3].name)
                    c2 = new Jl(Wl._createAt(t4, s3), Wl._createAt(t4, s3 + 1));
                  else {
                    const e4 = t4.offsetToIndex(s3);
                    c2 = new Jl(Wl._createAt(t4, s3), Wl._createAt(t4.getChild(e4), 0));
                  }
                  e3.push(...this._getAttributesDiff(c2, r3, n4)), s3++, a2++;
                } else
                  s3++, a2++;
            }
            e3.sort((t4, e4) => t4.position.root != e4.position.root ? t4.position.root.rootName < e4.position.root.rootName ? -1 : 1 : t4.position.isEqual(e4.position) ? t4.changeCount - e4.changeCount : t4.position.isBefore(e4.position) ? -1 : 1);
            for (let t4 = 1, n2 = 0; t4 < e3.length; t4++) {
              const o2 = e3[n2], i2 = e3[t4], r2 = "remove" == o2.type && "remove" == i2.type && "$text" == o2.name && "$text" == i2.name && o2.position.isEqual(i2.position), s3 = "insert" == o2.type && "insert" == i2.type && "$text" == o2.name && "$text" == i2.name && o2.position.parent == i2.position.parent && o2.position.offset + o2.length == i2.position.offset, a2 = "attribute" == o2.type && "attribute" == i2.type && o2.position.parent == i2.position.parent && o2.range.isFlat && i2.range.isFlat && o2.position.offset + o2.length == i2.position.offset && o2.attributeKey == i2.attributeKey && o2.attributeOldValue == i2.attributeOldValue && o2.attributeNewValue == i2.attributeNewValue;
              r2 || s3 || a2 ? (o2.length++, a2 && (o2.range.end = o2.range.end.getShiftedBy(1)), e3[t4] = null) : n2 = t4;
            }
            e3 = e3.filter((t4) => t4);
            for (const t4 of e3)
              delete t4.changeCount, "attribute" == t4.type && (delete t4.position, delete t4.length);
            return this._changeCount = 0, this._cachedChangesWithGraveyard = e3, this._cachedChanges = e3.filter(zu), t3.includeChangesInGraveyard ? this._cachedChangesWithGraveyard.slice() : this._cachedChanges.slice();
          }
          getChangedRoots() {
            return Array.from(this._changedRoots.values()).map((t3) => {
              const e3 = Mu({}, t3);
              return void 0 !== e3.state && delete e3.attributes, e3;
            });
          }
          getRefreshedItems() {
            return new Set(this._refreshedItems);
          }
          reset() {
            this._changesInElement.clear(), this._elementSnapshots.clear(), this._changedMarkers.clear(), this._changedRoots.clear(), this._refreshedItems = /* @__PURE__ */ new Set(), this._cachedChanges = null;
          }
          _bufferRootStateChange(t3, e3) {
            if (!this._changedRoots.has(t3))
              return void this._changedRoots.set(t3, { name: t3, state: e3 ? "attached" : "detached" });
            const n2 = this._changedRoots.get(t3);
            void 0 !== n2.state ? (delete n2.state, void 0 === n2.attributes && this._changedRoots.delete(t3)) : n2.state = e3 ? "attached" : "detached";
          }
          _bufferRootAttributeChange(t3, e3, n2, o2) {
            const i2 = this._changedRoots.get(t3) || { name: t3 }, r2 = i2.attributes || {};
            if (r2[e3]) {
              const t4 = r2[e3];
              o2 === t4.oldValue ? delete r2[e3] : t4.newValue = o2;
            } else
              r2[e3] = { oldValue: n2, newValue: o2 };
            0 === Object.entries(r2).length ? (delete i2.attributes, void 0 === i2.state && this._changedRoots.delete(t3)) : (i2.attributes = r2, this._changedRoots.set(t3, i2));
          }
          _refreshItem(t3) {
            if (this._isInInsertedElement(t3.parent))
              return;
            this._markRemove(t3.parent, t3.startOffset, t3.offsetSize), this._markInsert(t3.parent, t3.startOffset, t3.offsetSize), this._refreshedItems.add(t3);
            const e3 = Jl._createOn(t3);
            for (const t4 of this._markerCollection.getMarkersIntersectingRange(e3)) {
              const e4 = t4.getData();
              this.bufferMarkerChange(t4.name, e4, e4);
            }
            this._cachedChanges = null;
          }
          _bufferRootLoad(t3) {
            if (t3.isAttached()) {
              this._bufferRootStateChange(t3.rootName, true), this._markInsert(t3, 0, t3.maxOffset);
              for (const e4 of t3.getAttributeKeys())
                this._bufferRootAttributeChange(t3.rootName, e4, null, t3.getAttribute(e4));
              for (const n2 of this._markerCollection)
                if (n2.getRange().root == t3) {
                  const t4 = n2.getData();
                  this.bufferMarkerChange(n2.name, (e3 = Mu({}, t4), xu(e3, Eu({ range: null }))), t4);
                }
              var e3;
            }
          }
          _markInsert(t3, e3, n2) {
            if (t3.root.is("rootElement") && !t3.root._isLoaded)
              return;
            const o2 = { type: "insert", offset: e3, howMany: n2, count: this._changeCount++ };
            this._markChange(t3, o2);
          }
          _markRemove(t3, e3, n2) {
            if (t3.root.is("rootElement") && !t3.root._isLoaded)
              return;
            const o2 = { type: "remove", offset: e3, howMany: n2, count: this._changeCount++ };
            this._markChange(t3, o2), this._removeAllNestedChanges(t3, e3, n2);
          }
          _markAttribute(t3) {
            if (t3.root.is("rootElement") && !t3.root._isLoaded)
              return;
            const e3 = { type: "attribute", offset: t3.startOffset, howMany: t3.offsetSize, count: this._changeCount++ };
            this._markChange(t3.parent, e3);
          }
          _markChange(t3, e3) {
            this._makeSnapshot(t3);
            const n2 = this._getChangesForElement(t3);
            this._handleChange(e3, n2), n2.push(e3);
            for (let t4 = 0; t4 < n2.length; t4++)
              n2[t4].howMany < 1 && (n2.splice(t4, 1), t4--);
          }
          _getChangesForElement(t3) {
            let e3;
            return this._changesInElement.has(t3) ? e3 = this._changesInElement.get(t3) : (e3 = [], this._changesInElement.set(t3, e3)), e3;
          }
          _makeSnapshot(t3) {
            this._elementSnapshots.has(t3) || this._elementSnapshots.set(t3, Nu(t3.getChildren()));
          }
          _handleChange(t3, e3) {
            t3.nodesToHandle = t3.howMany;
            for (const n2 of e3) {
              const o2 = t3.offset + t3.howMany, i2 = n2.offset + n2.howMany;
              if ("insert" == t3.type && ("insert" == n2.type && (t3.offset <= n2.offset ? n2.offset += t3.howMany : t3.offset < i2 && (n2.howMany += t3.nodesToHandle, t3.nodesToHandle = 0)), "remove" == n2.type && t3.offset < n2.offset && (n2.offset += t3.howMany), "attribute" == n2.type)) {
                if (t3.offset <= n2.offset)
                  n2.offset += t3.howMany;
                else if (t3.offset < i2) {
                  const i3 = n2.howMany;
                  n2.howMany = t3.offset - n2.offset, e3.unshift({ type: "attribute", offset: o2, howMany: i3 - n2.howMany, count: this._changeCount++ });
                }
              }
              if ("remove" == t3.type) {
                if ("insert" == n2.type) {
                  if (o2 <= n2.offset)
                    n2.offset -= t3.howMany;
                  else if (o2 <= i2)
                    if (t3.offset < n2.offset) {
                      const e4 = o2 - n2.offset;
                      n2.offset = t3.offset, n2.howMany -= e4, t3.nodesToHandle -= e4;
                    } else
                      n2.howMany -= t3.nodesToHandle, t3.nodesToHandle = 0;
                  else if (t3.offset <= n2.offset)
                    t3.nodesToHandle -= n2.howMany, n2.howMany = 0;
                  else if (t3.offset < i2) {
                    const e4 = i2 - t3.offset;
                    n2.howMany -= e4, t3.nodesToHandle -= e4;
                  }
                }
                if ("remove" == n2.type && (o2 <= n2.offset ? n2.offset -= t3.howMany : t3.offset < n2.offset && (t3.nodesToHandle += n2.howMany, n2.howMany = 0)), "attribute" == n2.type) {
                  if (o2 <= n2.offset)
                    n2.offset -= t3.howMany;
                  else if (t3.offset < n2.offset) {
                    const e4 = o2 - n2.offset;
                    n2.offset = t3.offset, n2.howMany -= e4;
                  } else if (t3.offset < i2)
                    if (o2 <= i2) {
                      const o3 = n2.howMany;
                      n2.howMany = t3.offset - n2.offset;
                      const i3 = o3 - n2.howMany - t3.nodesToHandle;
                      e3.unshift({ type: "attribute", offset: t3.offset, howMany: i3, count: this._changeCount++ });
                    } else
                      n2.howMany -= i2 - t3.offset;
                }
              }
              if ("attribute" == t3.type) {
                if ("insert" == n2.type)
                  if (t3.offset < n2.offset && o2 > n2.offset) {
                    if (o2 > i2) {
                      const t4 = { type: "attribute", offset: i2, howMany: o2 - i2, count: this._changeCount++ };
                      this._handleChange(t4, e3), e3.push(t4);
                    }
                    t3.nodesToHandle = n2.offset - t3.offset, t3.howMany = t3.nodesToHandle;
                  } else
                    t3.offset >= n2.offset && t3.offset < i2 && (o2 > i2 ? (t3.nodesToHandle = o2 - i2, t3.offset = i2) : t3.nodesToHandle = 0);
                if ("remove" == n2.type && t3.offset < n2.offset && o2 > n2.offset) {
                  const i3 = { type: "attribute", offset: n2.offset, howMany: o2 - n2.offset, count: this._changeCount++ };
                  this._handleChange(i3, e3), e3.push(i3), t3.nodesToHandle = n2.offset - t3.offset, t3.howMany = t3.nodesToHandle;
                }
                "attribute" == n2.type && (t3.offset >= n2.offset && o2 <= i2 ? (t3.nodesToHandle = 0, t3.howMany = 0, t3.offset = 0) : t3.offset <= n2.offset && o2 >= i2 && (n2.howMany = 0));
              }
            }
            t3.howMany = t3.nodesToHandle, delete t3.nodesToHandle;
          }
          _getInsertDiff(t3, e3, n2) {
            return { type: "insert", position: Wl._createAt(t3, e3), name: n2.name, attributes: new Map(n2.attributes), length: 1, changeCount: this._changeCount++ };
          }
          _getRemoveDiff(t3, e3, n2) {
            return { type: "remove", position: Wl._createAt(t3, e3), name: n2.name, attributes: new Map(n2.attributes), length: 1, changeCount: this._changeCount++ };
          }
          _getAttributesDiff(t3, e3, n2) {
            const o2 = [];
            n2 = new Map(n2);
            for (const [i2, r2] of e3) {
              const e4 = n2.has(i2) ? n2.get(i2) : null;
              e4 !== r2 && o2.push({ type: "attribute", position: t3.start, range: t3.clone(), length: 1, attributeKey: i2, attributeOldValue: r2, attributeNewValue: e4, changeCount: this._changeCount++ }), n2.delete(i2);
            }
            for (const [e4, i2] of n2)
              o2.push({ type: "attribute", position: t3.start, range: t3.clone(), length: 1, attributeKey: e4, attributeOldValue: null, attributeNewValue: i2, changeCount: this._changeCount++ });
            return o2;
          }
          _isInInsertedElement(t3) {
            const e3 = t3.parent;
            if (!e3)
              return false;
            const n2 = this._changesInElement.get(e3), o2 = t3.startOffset;
            if (n2) {
              for (const t4 of n2)
                if ("insert" == t4.type && o2 >= t4.offset && o2 < t4.offset + t4.howMany)
                  return true;
            }
            return this._isInInsertedElement(e3);
          }
          _removeAllNestedChanges(t3, e3, n2) {
            const o2 = new Jl(Wl._createAt(t3, e3), Wl._createAt(t3, e3 + n2));
            for (const t4 of o2.getItems({ shallow: true }))
              t4.is("element") && (this._elementSnapshots.delete(t4), this._changesInElement.delete(t4), this._removeAllNestedChanges(t4, 0, t4.maxOffset));
          }
        }
        function Nu(t3) {
          const e3 = [];
          for (const n2 of t3)
            if (n2.is("$text"))
              for (let t4 = 0; t4 < n2.data.length; t4++)
                e3.push({ name: "$text", attributes: new Map(n2.getAttributes()) });
            else
              e3.push({ name: n2.name, attributes: new Map(n2.getAttributes()) });
          return e3;
        }
        function Pu(t3, e3) {
          const n2 = [];
          let o2 = 0, i2 = 0;
          for (const t4 of e3) {
            if (t4.offset > o2) {
              for (let e4 = 0; e4 < t4.offset - o2; e4++)
                n2.push("e");
              i2 += t4.offset - o2;
            }
            if ("insert" == t4.type) {
              for (let e4 = 0; e4 < t4.howMany; e4++)
                n2.push("i");
              o2 = t4.offset + t4.howMany;
            } else if ("remove" == t4.type) {
              for (let e4 = 0; e4 < t4.howMany; e4++)
                n2.push("r");
              o2 = t4.offset, i2 += t4.howMany;
            } else
              n2.push(..."a".repeat(t4.howMany).split("")), o2 = t4.offset + t4.howMany, i2 += t4.howMany;
          }
          if (i2 < t3)
            for (let e4 = 0; e4 < t3 - i2 - o2; e4++)
              n2.push("e");
          return n2;
        }
        function zu(t3) {
          const e3 = "position" in t3 && "$graveyard" == t3.position.root.rootName, n2 = "range" in t3 && "$graveyard" == t3.range.root.rootName;
          return !e3 && !n2;
        }
        class Ou {
          constructor() {
            this._operations = [], this._undoPairs = /* @__PURE__ */ new Map(), this._undoneOperations = /* @__PURE__ */ new Set(), this._baseVersionToOperationIndex = /* @__PURE__ */ new Map(), this._version = 0, this._gaps = /* @__PURE__ */ new Map();
          }
          get version() {
            return this._version;
          }
          set version(t3) {
            this._operations.length && t3 > this._version + 1 && this._gaps.set(this._version, t3), this._version = t3;
          }
          get lastOperation() {
            return this._operations[this._operations.length - 1];
          }
          addOperation(t3) {
            if (t3.baseVersion !== this.version)
              throw new A("model-document-history-addoperation-incorrect-version", this, { operation: t3, historyVersion: this.version });
            this._operations.push(t3), this._version++, this._baseVersionToOperationIndex.set(t3.baseVersion, this._operations.length - 1);
          }
          getOperations(t3, e3 = this.version) {
            if (!this._operations.length)
              return [];
            const n2 = this._operations[0];
            void 0 === t3 && (t3 = n2.baseVersion);
            let o2 = e3 - 1;
            for (const [e4, n3] of this._gaps)
              t3 > e4 && t3 < n3 && (t3 = n3), o2 > e4 && o2 < n3 && (o2 = e4 - 1);
            if (o2 < n2.baseVersion || t3 > this.lastOperation.baseVersion)
              return [];
            let i2 = this._baseVersionToOperationIndex.get(t3);
            void 0 === i2 && (i2 = 0);
            let r2 = this._baseVersionToOperationIndex.get(o2);
            return void 0 === r2 && (r2 = this._operations.length - 1), this._operations.slice(i2, r2 + 1);
          }
          getOperation(t3) {
            const e3 = this._baseVersionToOperationIndex.get(t3);
            if (void 0 !== e3)
              return this._operations[e3];
          }
          setOperationAsUndone(t3, e3) {
            this._undoPairs.set(e3, t3), this._undoneOperations.add(t3);
          }
          isUndoingOperation(t3) {
            return this._undoPairs.has(t3);
          }
          isUndoneOperation(t3) {
            return this._undoneOperations.has(t3);
          }
          getUndoneOperation(t3) {
            return this._undoPairs.get(t3);
          }
          reset() {
            this._version = 0, this._undoPairs = /* @__PURE__ */ new Map(), this._operations = [], this._undoneOperations = /* @__PURE__ */ new Set(), this._gaps = /* @__PURE__ */ new Map(), this._baseVersionToOperationIndex = /* @__PURE__ */ new Map();
          }
        }
        class Lu extends Hl {
          constructor(t3, e3, n2 = "main") {
            super(e3), this._isAttached = true, this._isLoaded = true, this._document = t3, this.rootName = n2;
          }
          get document() {
            return this._document;
          }
          isAttached() {
            return this._isAttached;
          }
          toJSON() {
            return this.rootName;
          }
        }
        Lu.prototype.is = function(t3, e3) {
          return e3 ? e3 === this.name && ("rootElement" === t3 || "model:rootElement" === t3 || "element" === t3 || "model:element" === t3) : "rootElement" === t3 || "model:rootElement" === t3 || "element" === t3 || "model:element" === t3 || "node" === t3 || "model:node" === t3;
        };
        var Ru = Object.defineProperty, ju = Object.defineProperties, Fu = Object.getOwnPropertyDescriptors, Vu = Object.getOwnPropertySymbols, Uu = Object.prototype.hasOwnProperty, Hu = Object.prototype.propertyIsEnumerable, qu = (t3, e3, n2) => e3 in t3 ? Ru(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, Gu = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            Uu.call(e3, n2) && qu(t3, n2, e3[n2]);
          if (Vu)
            for (var n2 of Vu(e3))
              Hu.call(e3, n2) && qu(t3, n2, e3[n2]);
          return t3;
        }, Wu = (t3, e3) => ju(t3, Fu(e3));
        const Ku = "$graveyard";
        class Zu extends M() {
          constructor(t3) {
            super(), this.model = t3, this.history = new Ou(), this.selection = new xd(this), this.roots = new Di({ idProperty: "rootName" }), this.differ = new Bu(t3.markers), this.isReadOnly = false, this._postFixers = /* @__PURE__ */ new Set(), this._hasSelectionChangedFromTheLastChangeBlock = false, this.createRoot("$root", Ku), this.listenTo(t3, "applyOperation", (t4, e3) => {
              const n2 = e3[0];
              n2.isDocumentOperation && this.differ.bufferOperation(n2);
            }, { priority: "high" }), this.listenTo(t3, "applyOperation", (t4, e3) => {
              const n2 = e3[0];
              n2.isDocumentOperation && this.history.addOperation(n2);
            }, { priority: "low" }), this.listenTo(this.selection, "change", () => {
              this._hasSelectionChangedFromTheLastChangeBlock = true;
            }), this.listenTo(t3.markers, "update", (t4, e3, n2, o2, i2) => {
              const r2 = Wu(Gu({}, e3.getData()), { range: o2 });
              this.differ.bufferMarkerChange(e3.name, i2, r2), null === n2 && e3.on("change", (t5, n3) => {
                const o3 = e3.getData();
                this.differ.bufferMarkerChange(e3.name, Wu(Gu({}, o3), { range: n3 }), o3);
              });
            }), this.registerPostFixer((t4) => {
              let e3 = false;
              for (const n2 of this.roots)
                n2.isAttached() || n2.isEmpty || (t4.remove(t4.createRangeIn(n2)), e3 = true);
              for (const n2 of this.model.markers)
                n2.getRange().root.isAttached() || (t4.removeMarker(n2), e3 = true);
              return e3;
            });
          }
          get version() {
            return this.history.version;
          }
          set version(t3) {
            this.history.version = t3;
          }
          get graveyard() {
            return this.getRoot(Ku);
          }
          createRoot(t3 = "$root", e3 = "main") {
            if (this.roots.get(e3))
              throw new A("model-document-createroot-name-exists", this, { name: e3 });
            const n2 = new Lu(this, t3, e3);
            return this.roots.add(n2), n2;
          }
          destroy() {
            this.selection.destroy(), this.stopListening();
          }
          getRoot(t3 = "main") {
            return this.roots.get(t3);
          }
          getRootNames(t3 = false) {
            return this.getRoots(t3).map((t4) => t4.rootName);
          }
          getRoots(t3 = false) {
            return this.roots.filter((e3) => e3 != this.graveyard && (t3 || e3.isAttached()) && e3._isLoaded);
          }
          registerPostFixer(t3) {
            this._postFixers.add(t3);
          }
          toJSON() {
            const t3 = As(this);
            return t3.selection = "[engine.model.DocumentSelection]", t3.model = "[engine.model.Model]", t3;
          }
          _handleChangeBlock(t3) {
            this._hasDocumentChangedFromTheLastChangeBlock() && (this._callPostFixers(t3), this.selection.refresh(), this.differ.hasDataChanges() ? this.fire("change:data", t3.batch) : this.fire("change", t3.batch), this.selection.refresh(), this.differ.reset()), this._hasSelectionChangedFromTheLastChangeBlock = false;
          }
          _hasDocumentChangedFromTheLastChangeBlock() {
            return !this.differ.isEmpty || this._hasSelectionChangedFromTheLastChangeBlock;
          }
          _getDefaultRoot() {
            const t3 = this.getRoots();
            return t3.length ? t3[0] : this.graveyard;
          }
          _getDefaultRange() {
            const t3 = this._getDefaultRoot(), e3 = this.model, n2 = e3.schema, o2 = e3.createPositionFromPath(t3, [0]);
            return n2.getNearestSelectionRange(o2) || e3.createRange(o2);
          }
          _validateSelectionRange(t3) {
            return Yu(t3.start) && Yu(t3.end);
          }
          _callPostFixers(t3) {
            let e3 = false;
            do {
              for (const n2 of this._postFixers)
                if (this.selection.refresh(), e3 = n2(t3), e3)
                  break;
            } while (e3);
          }
        }
        function Yu(t3) {
          const e3 = t3.textNode;
          if (e3) {
            const n2 = e3.data, o2 = t3.offset - e3.startOffset;
            return !Ni(n2, o2) && !Pi(n2, o2);
          }
          return true;
        }
        var $u = Object.defineProperty, Qu = Object.defineProperties, Ju = Object.getOwnPropertyDescriptors, Xu = Object.getOwnPropertySymbols, tg = Object.prototype.hasOwnProperty, eg = Object.prototype.propertyIsEnumerable, ng = (t3, e3, n2) => e3 in t3 ? $u(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2;
        class og extends M() {
          constructor() {
            super(...arguments), this._markers = /* @__PURE__ */ new Map();
          }
          [Symbol.iterator]() {
            return this._markers.values();
          }
          has(t3) {
            const e3 = t3 instanceof ig ? t3.name : t3;
            return this._markers.has(e3);
          }
          get(t3) {
            return this._markers.get(t3) || null;
          }
          _set(t3, e3, n2 = false, o2 = false) {
            const i2 = t3 instanceof ig ? t3.name : t3;
            if (i2.includes(","))
              throw new A("markercollection-incorrect-marker-name", this);
            const r2 = this._markers.get(i2);
            if (r2) {
              const t4 = r2.getData(), s4 = r2.getRange();
              let a3 = false;
              return s4.isEqual(e3) || (r2._attachLiveRange(Cd.fromRange(e3)), a3 = true), n2 != r2.managedUsingOperations && (r2._managedUsingOperations = n2, a3 = true), "boolean" == typeof o2 && o2 != r2.affectsData && (r2._affectsData = o2, a3 = true), a3 && this.fire(`update:${i2}`, r2, s4, e3, t4), r2;
            }
            const s3 = Cd.fromRange(e3), a2 = new ig(i2, s3, n2, o2);
            var c2;
            return this._markers.set(i2, a2), this.fire(`update:${i2}`, a2, null, e3, (c2 = ((t4, e4) => {
              for (var n3 in e4 || (e4 = {}))
                tg.call(e4, n3) && ng(t4, n3, e4[n3]);
              if (Xu)
                for (var n3 of Xu(e4))
                  eg.call(e4, n3) && ng(t4, n3, e4[n3]);
              return t4;
            })({}, a2.getData()), Qu(c2, Ju({ range: null })))), a2;
          }
          _remove(t3) {
            const e3 = t3 instanceof ig ? t3.name : t3, n2 = this._markers.get(e3);
            return !!n2 && (this._markers.delete(e3), this.fire(`update:${e3}`, n2, n2.getRange(), null, n2.getData()), this._destroyMarker(n2), true);
          }
          _refresh(t3) {
            const e3 = t3 instanceof ig ? t3.name : t3, n2 = this._markers.get(e3);
            if (!n2)
              throw new A("markercollection-refresh-marker-not-exists", this);
            const o2 = n2.getRange();
            this.fire(`update:${e3}`, n2, o2, o2, n2.getData());
          }
          *getMarkersAtPosition(t3) {
            for (const e3 of this)
              e3.getRange().containsPosition(t3) && (yield e3);
          }
          *getMarkersIntersectingRange(t3) {
            for (const e3 of this)
              null !== e3.getRange().getIntersection(t3) && (yield e3);
          }
          destroy() {
            for (const t3 of this._markers.values())
              this._destroyMarker(t3);
            this._markers = null, this.stopListening();
          }
          *getMarkersGroup(t3) {
            for (const e3 of this._markers.values())
              e3.name.startsWith(t3 + ":") && (yield e3);
          }
          _destroyMarker(t3) {
            t3.stopListening(), t3._detachLiveRange();
          }
        }
        class ig extends M(Rl) {
          constructor(t3, e3, n2, o2) {
            super(), this.name = t3, this._liveRange = this._attachLiveRange(e3), this._managedUsingOperations = n2, this._affectsData = o2;
          }
          get managedUsingOperations() {
            if (!this._liveRange)
              throw new A("marker-destroyed", this);
            return this._managedUsingOperations;
          }
          get affectsData() {
            if (!this._liveRange)
              throw new A("marker-destroyed", this);
            return this._affectsData;
          }
          getData() {
            return { range: this.getRange(), affectsData: this.affectsData, managedUsingOperations: this.managedUsingOperations };
          }
          getStart() {
            if (!this._liveRange)
              throw new A("marker-destroyed", this);
            return this._liveRange.start.clone();
          }
          getEnd() {
            if (!this._liveRange)
              throw new A("marker-destroyed", this);
            return this._liveRange.end.clone();
          }
          getRange() {
            if (!this._liveRange)
              throw new A("marker-destroyed", this);
            return this._liveRange.toRange();
          }
          _attachLiveRange(t3) {
            return this._liveRange && this._detachLiveRange(), t3.delegate("change:range").to(this), t3.delegate("change:content").to(this), this._liveRange = t3, t3;
          }
          _detachLiveRange() {
            this._liveRange.stopDelegating("change:range", this), this._liveRange.stopDelegating("change:content", this), this._liveRange.detach(), this._liveRange = null;
          }
        }
        ig.prototype.is = function(t3) {
          return "marker" === t3 || "model:marker" === t3;
        };
        class rg extends Uh {
          constructor(t3, e3) {
            super(null), this.sourcePosition = t3.clone(), this.howMany = e3;
          }
          get type() {
            return "detach";
          }
          get affectedSelectable() {
            return null;
          }
          toJSON() {
            const t3 = super.toJSON();
            return t3.sourcePosition = this.sourcePosition.toJSON(), t3;
          }
          _validate() {
            if (this.sourcePosition.root.document)
              throw new A("detach-operation-on-document-node", this);
          }
          _execute() {
            qh(Jl._createFromPositionAndShift(this.sourcePosition, this.howMany));
          }
          static get className() {
            return "DetachOperation";
          }
        }
        class sg extends Rl {
          constructor(t3) {
            super(), this.markers = /* @__PURE__ */ new Map(), this._children = new Fl(), t3 && this._insertChild(0, t3);
          }
          [Symbol.iterator]() {
            return this.getChildren();
          }
          get childCount() {
            return this._children.length;
          }
          get maxOffset() {
            return this._children.maxOffset;
          }
          get isEmpty() {
            return 0 === this.childCount;
          }
          get nextSibling() {
            return null;
          }
          get previousSibling() {
            return null;
          }
          get root() {
            return this;
          }
          get parent() {
            return null;
          }
          get document() {
            return null;
          }
          isAttached() {
            return false;
          }
          getAncestors() {
            return [];
          }
          getChild(t3) {
            return this._children.getNode(t3);
          }
          getChildren() {
            return this._children[Symbol.iterator]();
          }
          getChildIndex(t3) {
            return this._children.getNodeIndex(t3);
          }
          getChildStartOffset(t3) {
            return this._children.getNodeStartOffset(t3);
          }
          getPath() {
            return [];
          }
          getNodeByPath(t3) {
            let e3 = this;
            for (const n2 of t3)
              e3 = e3.getChild(e3.offsetToIndex(n2));
            return e3;
          }
          offsetToIndex(t3) {
            return this._children.offsetToIndex(t3);
          }
          toJSON() {
            const t3 = [];
            for (const e3 of this._children)
              t3.push(e3.toJSON());
            return t3;
          }
          static fromJSON(t3) {
            const e3 = [];
            for (const n2 of t3)
              n2.name ? e3.push(Hl.fromJSON(n2)) : e3.push(Vl.fromJSON(n2));
            return new sg(e3);
          }
          _appendChild(t3) {
            this._insertChild(this.childCount, t3);
          }
          _insertChild(t3, e3) {
            const n2 = function(t4) {
              if ("string" == typeof t4)
                return [new Vl(t4)];
              et(t4) || (t4 = [t4]);
              return Array.from(t4).map((t5) => "string" == typeof t5 ? new Vl(t5) : t5 instanceof Ul ? new Vl(t5.data, t5.getAttributes()) : t5);
            }(e3);
            for (const t4 of n2)
              null !== t4.parent && t4._remove(), t4.parent = this;
            this._children._insertNodes(t3, n2);
          }
          _removeChildren(t3, e3 = 1) {
            const n2 = this._children._removeNodes(t3, e3);
            for (const t4 of n2)
              t4.parent = null;
            return n2;
          }
        }
        sg.prototype.is = function(t3) {
          return "documentFragment" === t3 || "model:documentFragment" === t3;
        };
        class ag {
          constructor(t3, e3) {
            this.model = t3, this.batch = e3;
          }
          createText(t3, e3) {
            return new Vl(t3, e3);
          }
          createElement(t3, e3) {
            return new Hl(t3, e3);
          }
          createDocumentFragment() {
            return new sg();
          }
          cloneElement(t3, e3 = true) {
            return t3._clone(e3);
          }
          insert(t3, e3, n2 = 0) {
            if (this._assertWriterUsedCorrectly(), t3 instanceof Vl && "" == t3.data)
              return;
            const o2 = Wl._createAt(e3, n2);
            if (t3.parent) {
              if (ug(t3.root, o2.root))
                return void this.move(Jl._createOn(t3), o2);
              if (t3.root.document)
                throw new A("model-writer-insert-forbidden-move", this);
              this.remove(t3);
            }
            const i2 = o2.root.document ? o2.root.document.version : null, r2 = new Qh(o2, t3, i2);
            if (t3 instanceof Vl && (r2.shouldReceiveAttributes = true), this.batch.addOperation(r2), this.model.applyOperation(r2), t3 instanceof sg)
              for (const [e4, n3] of t3.markers) {
                const t4 = Wl._createAt(n3.root, 0), i3 = { range: new Jl(n3.start._getCombined(t4, o2), n3.end._getCombined(t4, o2)), usingOperation: true, affectsData: true };
                this.model.markers.has(e4) ? this.updateMarker(e4, i3) : this.addMarker(e4, i3);
              }
          }
          insertText(t3, e3, n2, o2) {
            e3 instanceof sg || e3 instanceof Hl || e3 instanceof Wl ? this.insert(this.createText(t3), e3, n2) : this.insert(this.createText(t3, e3), n2, o2);
          }
          insertElement(t3, e3, n2, o2) {
            e3 instanceof sg || e3 instanceof Hl || e3 instanceof Wl ? this.insert(this.createElement(t3), e3, n2) : this.insert(this.createElement(t3, e3), n2, o2);
          }
          append(t3, e3) {
            this.insert(t3, e3, "end");
          }
          appendText(t3, e3, n2) {
            e3 instanceof sg || e3 instanceof Hl ? this.insert(this.createText(t3), e3, "end") : this.insert(this.createText(t3, e3), n2, "end");
          }
          appendElement(t3, e3, n2) {
            e3 instanceof sg || e3 instanceof Hl ? this.insert(this.createElement(t3), e3, "end") : this.insert(this.createElement(t3, e3), n2, "end");
          }
          setAttribute(t3, e3, n2) {
            if (this._assertWriterUsedCorrectly(), n2 instanceof Jl) {
              const o2 = n2.getMinimalFlatRanges();
              for (const n3 of o2)
                cg(this, t3, e3, n3);
            } else
              lg(this, t3, e3, n2);
          }
          setAttributes(t3, e3) {
            for (const [n2, o2] of Mi(t3))
              this.setAttribute(n2, o2, e3);
          }
          removeAttribute(t3, e3) {
            if (this._assertWriterUsedCorrectly(), e3 instanceof Jl) {
              const n2 = e3.getMinimalFlatRanges();
              for (const e4 of n2)
                cg(this, t3, null, e4);
            } else
              lg(this, t3, null, e3);
          }
          clearAttributes(t3) {
            this._assertWriterUsedCorrectly();
            const e3 = (t4) => {
              for (const e4 of t4.getAttributeKeys())
                this.removeAttribute(e4, t4);
            };
            if (t3 instanceof Jl)
              for (const n2 of t3.getItems())
                e3(n2);
            else
              e3(t3);
          }
          move(t3, e3, n2) {
            if (this._assertWriterUsedCorrectly(), !(t3 instanceof Jl))
              throw new A("writer-move-invalid-range", this);
            if (!t3.isFlat)
              throw new A("writer-move-range-not-flat", this);
            const o2 = Wl._createAt(e3, n2);
            if (o2.isEqual(t3.start))
              return;
            if (this._addOperationForAffectedMarkers("move", t3), !ug(t3.root, o2.root))
              throw new A("writer-move-different-document", this);
            const i2 = t3.root.document ? t3.root.document.version : null, r2 = new $h(t3.start, t3.end.offset - t3.start.offset, o2, i2);
            this.batch.addOperation(r2), this.model.applyOperation(r2);
          }
          remove(t3) {
            this._assertWriterUsedCorrectly();
            const e3 = (t3 instanceof Jl ? t3 : Jl._createOn(t3)).getMinimalFlatRanges().reverse();
            for (const t4 of e3)
              this._addOperationForAffectedMarkers("move", t4), hg(t4.start, t4.end.offset - t4.start.offset, this.batch, this.model);
          }
          merge(t3) {
            this._assertWriterUsedCorrectly();
            const e3 = t3.nodeBefore, n2 = t3.nodeAfter;
            if (this._addOperationForAffectedMarkers("merge", t3), !(e3 instanceof Hl))
              throw new A("writer-merge-no-element-before", this);
            if (!(n2 instanceof Hl))
              throw new A("writer-merge-no-element-after", this);
            t3.root.document ? this._merge(t3) : this._mergeDetached(t3);
          }
          createPositionFromPath(t3, e3, n2) {
            return this.model.createPositionFromPath(t3, e3, n2);
          }
          createPositionAt(t3, e3) {
            return this.model.createPositionAt(t3, e3);
          }
          createPositionAfter(t3) {
            return this.model.createPositionAfter(t3);
          }
          createPositionBefore(t3) {
            return this.model.createPositionBefore(t3);
          }
          createRange(t3, e3) {
            return this.model.createRange(t3, e3);
          }
          createRangeIn(t3) {
            return this.model.createRangeIn(t3);
          }
          createRangeOn(t3) {
            return this.model.createRangeOn(t3);
          }
          createSelection(...t3) {
            return this.model.createSelection(...t3);
          }
          _mergeDetached(t3) {
            const e3 = t3.nodeBefore, n2 = t3.nodeAfter;
            this.move(Jl._createIn(n2), Wl._createAt(e3, "end")), this.remove(n2);
          }
          _merge(t3) {
            const e3 = Wl._createAt(t3.nodeBefore, "end"), n2 = Wl._createAt(t3.nodeAfter, 0), o2 = t3.root.document.graveyard, i2 = new Wl(o2, [0]), r2 = t3.root.document.version, s3 = new Xh(n2, t3.nodeAfter.maxOffset, e3, i2, r2);
            this.batch.addOperation(s3), this.model.applyOperation(s3);
          }
          rename(t3, e3) {
            if (this._assertWriterUsedCorrectly(), !(t3 instanceof Hl))
              throw new A("writer-rename-not-element-instance", this);
            const n2 = t3.root.document ? t3.root.document.version : null, o2 = new iu(Wl._createBefore(t3), t3.name, e3, n2);
            this.batch.addOperation(o2), this.model.applyOperation(o2);
          }
          split(t3, e3) {
            this._assertWriterUsedCorrectly();
            let n2, o2, i2 = t3.parent;
            if (!i2.parent)
              throw new A("writer-split-element-no-parent", this);
            if (e3 || (e3 = i2.parent), !t3.parent.getAncestors({ includeSelf: true }).includes(e3))
              throw new A("writer-split-invalid-limit-element", this);
            do {
              const e4 = i2.root.document ? i2.root.document.version : null, r2 = i2.maxOffset - t3.offset, s3 = Jh.getInsertionPosition(t3), a2 = new Jh(t3, r2, s3, null, e4);
              this.batch.addOperation(a2), this.model.applyOperation(a2), n2 || o2 || (n2 = i2, o2 = t3.parent.nextSibling), i2 = (t3 = this.createPositionAfter(t3.parent)).parent;
            } while (i2 !== e3);
            return { position: t3, range: new Jl(Wl._createAt(n2, "end"), Wl._createAt(o2, 0)) };
          }
          wrap(t3, e3) {
            if (this._assertWriterUsedCorrectly(), !t3.isFlat)
              throw new A("writer-wrap-range-not-flat", this);
            const n2 = e3 instanceof Hl ? e3 : new Hl(e3);
            if (n2.childCount > 0)
              throw new A("writer-wrap-element-not-empty", this);
            if (null !== n2.parent)
              throw new A("writer-wrap-element-attached", this);
            this.insert(n2, t3.start);
            const o2 = new Jl(t3.start.getShiftedBy(1), t3.end.getShiftedBy(1));
            this.move(o2, Wl._createAt(n2, 0));
          }
          unwrap(t3) {
            if (this._assertWriterUsedCorrectly(), null === t3.parent)
              throw new A("writer-unwrap-element-no-parent", this);
            this.move(Jl._createIn(t3), this.createPositionAfter(t3)), this.remove(t3);
          }
          addMarker(t3, e3) {
            if (this._assertWriterUsedCorrectly(), !e3 || "boolean" != typeof e3.usingOperation)
              throw new A("writer-addmarker-no-usingoperation", this);
            const n2 = e3.usingOperation, o2 = e3.range, i2 = void 0 !== e3.affectsData && e3.affectsData;
            if (this.model.markers.has(t3))
              throw new A("writer-addmarker-marker-exists", this);
            if (!o2)
              throw new A("writer-addmarker-no-range", this);
            return n2 ? (dg(this, t3, null, o2, i2), this.model.markers.get(t3)) : this.model.markers._set(t3, o2, n2, i2);
          }
          updateMarker(t3, e3) {
            this._assertWriterUsedCorrectly();
            const n2 = "string" == typeof t3 ? t3 : t3.name, o2 = this.model.markers.get(n2);
            if (!o2)
              throw new A("writer-updatemarker-marker-not-exists", this);
            if (!e3)
              return C("writer-updatemarker-reconvert-using-editingcontroller", { markerName: n2 }), void this.model.markers._refresh(o2);
            const i2 = "boolean" == typeof e3.usingOperation, r2 = "boolean" == typeof e3.affectsData, s3 = r2 ? e3.affectsData : o2.affectsData;
            if (!i2 && !e3.range && !r2)
              throw new A("writer-updatemarker-wrong-options", this);
            const a2 = o2.getRange(), c2 = e3.range ? e3.range : a2;
            i2 && e3.usingOperation !== o2.managedUsingOperations ? e3.usingOperation ? dg(this, n2, null, c2, s3) : (dg(this, n2, a2, null, s3), this.model.markers._set(n2, c2, void 0, s3)) : o2.managedUsingOperations ? dg(this, n2, a2, c2, s3) : this.model.markers._set(n2, c2, void 0, s3);
          }
          removeMarker(t3) {
            this._assertWriterUsedCorrectly();
            const e3 = "string" == typeof t3 ? t3 : t3.name;
            if (!this.model.markers.has(e3))
              throw new A("writer-removemarker-no-marker", this);
            const n2 = this.model.markers.get(e3);
            if (!n2.managedUsingOperations)
              return void this.model.markers._remove(e3);
            dg(this, e3, n2.getRange(), null, n2.affectsData);
          }
          addRoot(t3, e3 = "$root") {
            this._assertWriterUsedCorrectly();
            const n2 = this.model.document.getRoot(t3);
            if (n2 && n2.isAttached())
              throw new A("writer-addroot-root-exists", this);
            const o2 = this.model.document, i2 = new su(t3, e3, true, o2, o2.version);
            return this.batch.addOperation(i2), this.model.applyOperation(i2), this.model.document.getRoot(t3);
          }
          detachRoot(t3) {
            this._assertWriterUsedCorrectly();
            const e3 = "string" == typeof t3 ? this.model.document.getRoot(t3) : t3;
            if (!e3 || !e3.isAttached())
              throw new A("writer-detachroot-no-root", this);
            for (const t4 of this.model.markers)
              t4.getRange().root === e3 && this.removeMarker(t4);
            for (const t4 of e3.getAttributeKeys())
              this.removeAttribute(t4, e3);
            this.remove(this.createRangeIn(e3));
            const n2 = this.model.document, o2 = new su(e3.rootName, e3.name, false, n2, n2.version);
            this.batch.addOperation(o2), this.model.applyOperation(o2);
          }
          setSelection(...t3) {
            this._assertWriterUsedCorrectly(), this.model.document.selection._setTo(...t3);
          }
          setSelectionFocus(t3, e3) {
            this._assertWriterUsedCorrectly(), this.model.document.selection._setFocus(t3, e3);
          }
          setSelectionAttribute(t3, e3) {
            if (this._assertWriterUsedCorrectly(), "string" == typeof t3)
              this._setSelectionAttribute(t3, e3);
            else
              for (const [e4, n2] of Mi(t3))
                this._setSelectionAttribute(e4, n2);
          }
          removeSelectionAttribute(t3) {
            if (this._assertWriterUsedCorrectly(), "string" == typeof t3)
              this._removeSelectionAttribute(t3);
            else
              for (const e3 of t3)
                this._removeSelectionAttribute(e3);
          }
          overrideSelectionGravity() {
            return this.model.document.selection._overrideGravity();
          }
          restoreSelectionGravity(t3) {
            this.model.document.selection._restoreGravity(t3);
          }
          _setSelectionAttribute(t3, e3) {
            const n2 = this.model.document.selection;
            if (n2.isCollapsed && n2.anchor.parent.isEmpty) {
              const o2 = xd._getStoreAttributeKey(t3);
              this.setAttribute(o2, e3, n2.anchor.parent);
            }
            n2._setAttribute(t3, e3);
          }
          _removeSelectionAttribute(t3) {
            const e3 = this.model.document.selection;
            if (e3.isCollapsed && e3.anchor.parent.isEmpty) {
              const n2 = xd._getStoreAttributeKey(t3);
              this.removeAttribute(n2, e3.anchor.parent);
            }
            e3._removeAttribute(t3);
          }
          _assertWriterUsedCorrectly() {
            if (this.model._currentWriter !== this)
              throw new A("writer-incorrect-use", this);
          }
          _addOperationForAffectedMarkers(t3, e3) {
            for (const n2 of this.model.markers) {
              if (!n2.managedUsingOperations)
                continue;
              const o2 = n2.getRange();
              let i2 = false;
              if ("move" === t3) {
                const t4 = e3;
                i2 = t4.containsPosition(o2.start) || t4.start.isEqual(o2.start) || t4.containsPosition(o2.end) || t4.end.isEqual(o2.end);
              } else {
                const t4 = e3, n3 = t4.nodeBefore, r2 = t4.nodeAfter, s3 = o2.start.parent == n3 && o2.start.isAtEnd, a2 = o2.end.parent == r2 && 0 == o2.end.offset, c2 = o2.end.nodeAfter == r2, l2 = o2.start.nodeAfter == r2;
                i2 = s3 || a2 || c2 || l2;
              }
              i2 && this.updateMarker(n2.name, { range: o2 });
            }
          }
        }
        function cg(t3, e3, n2, o2) {
          const i2 = t3.model, r2 = i2.document;
          let s3, a2, c2, l2 = o2.start;
          for (const t4 of o2.getWalker({ shallow: true }))
            c2 = t4.item.getAttribute(e3), s3 && a2 != c2 && (a2 != n2 && d2(), l2 = s3), s3 = t4.nextPosition, a2 = c2;
          function d2() {
            const o3 = new Jl(l2, s3), c3 = o3.root.document ? r2.version : null, d3 = new nu(o3, e3, a2, n2, c3);
            t3.batch.addOperation(d3), i2.applyOperation(d3);
          }
          s3 instanceof Wl && s3 != l2 && a2 != n2 && d2();
        }
        function lg(t3, e3, n2, o2) {
          const i2 = t3.model, r2 = i2.document, s3 = o2.getAttribute(e3);
          let a2, c2;
          if (s3 != n2) {
            if (o2.root === o2) {
              const t4 = o2.document ? r2.version : null;
              c2 = new ru(o2, e3, s3, n2, t4);
            } else {
              a2 = new Jl(Wl._createBefore(o2), t3.createPositionAfter(o2));
              const i3 = a2.root.document ? r2.version : null;
              c2 = new nu(a2, e3, s3, n2, i3);
            }
            t3.batch.addOperation(c2), i2.applyOperation(c2);
          }
        }
        function dg(t3, e3, n2, o2, i2) {
          const r2 = t3.model, s3 = r2.document, a2 = new tu(e3, n2, o2, r2.markers, !!i2, s3.version);
          t3.batch.addOperation(a2), r2.applyOperation(a2);
        }
        function hg(t3, e3, n2, o2) {
          let i2;
          if (t3.root.document) {
            const n3 = o2.document, r2 = new Wl(n3.graveyard, [0]);
            i2 = new $h(t3, e3, r2, n3.version);
          } else
            i2 = new rg(t3, e3);
          n2.addOperation(i2), o2.applyOperation(i2);
        }
        function ug(t3, e3) {
          return t3 === e3 || t3 instanceof Lu && e3 instanceof Lu;
        }
        function gg(t3, e3, n2 = {}) {
          if (e3.isCollapsed)
            return;
          const o2 = e3.getFirstRange();
          if ("$graveyard" == o2.root.rootName)
            return;
          const i2 = t3.schema;
          t3.change((t4) => {
            if (!n2.doNotResetEntireContent && function(t5, e4) {
              const n3 = t5.getLimitElement(e4);
              if (!e4.containsEntireContent(n3))
                return false;
              const o3 = e4.getFirstRange();
              if (o3.start.parent == o3.end.parent)
                return false;
              return t5.checkChild(n3, "paragraph");
            }(i2, e3))
              return void function(t5, e4) {
                const n3 = t5.model.schema.getLimitElement(e4);
                t5.remove(t5.createRangeIn(n3)), kg(t5, t5.createPositionAt(n3, 0), e4);
              }(t4, e3);
            const r2 = {};
            if (!n2.doNotAutoparagraph) {
              const t5 = e3.getSelectedElement();
              t5 && Object.assign(r2, i2.getAttributesWithProperty(t5, "copyOnReplace", true));
            }
            const [s3, a2] = function(t5) {
              const e4 = t5.root.document.model, n3 = t5.start;
              let o3 = t5.end;
              if (e4.hasContent(t5, { ignoreMarkers: true })) {
                const n4 = function(t6) {
                  const e5 = t6.parent, n5 = e5.root.document.model.schema, o4 = e5.getAncestors({ parentFirst: true, includeSelf: true });
                  for (const t7 of o4) {
                    if (n5.isLimit(t7))
                      return null;
                    if (n5.isBlock(t7))
                      return t7;
                  }
                }(o3);
                if (n4 && o3.isTouching(e4.createPositionAt(n4, 0))) {
                  const n5 = e4.createSelection(t5);
                  e4.modifySelection(n5, { direction: "backward" });
                  const i3 = n5.getLastPosition(), r3 = e4.createRange(i3, o3);
                  e4.hasContent(r3, { ignoreMarkers: true }) || (o3 = i3);
                }
              }
              return [Au.fromPosition(n3, "toPrevious"), Au.fromPosition(o3, "toNext")];
            }(o2);
            s3.isTouching(a2) || t4.remove(t4.createRange(s3, a2)), n2.leaveUnmerged || (!function(t5, e4, n3) {
              const o3 = t5.model;
              if (!fg(t5.model.schema, e4, n3))
                return;
              const [i3, r3] = function(t6, e5) {
                const n4 = t6.getAncestors(), o4 = e5.getAncestors();
                let i4 = 0;
                for (; n4[i4] && n4[i4] == o4[i4]; )
                  i4++;
                return [n4[i4], o4[i4]];
              }(e4, n3);
              if (!i3 || !r3)
                return;
              !o3.hasContent(i3, { ignoreMarkers: true }) && o3.hasContent(r3, { ignoreMarkers: true }) ? mg(t5, e4, n3, i3.parent) : pg(t5, e4, n3, i3.parent);
            }(t4, s3, a2), i2.removeDisallowedAttributes(s3.parent.getChildren(), t4)), bg(t4, e3, s3), !n2.doNotAutoparagraph && function(t5, e4) {
              const n3 = t5.checkChild(e4, "$text"), o3 = t5.checkChild(e4, "paragraph");
              return !n3 && o3;
            }(i2, s3) && kg(t4, s3, e3, r2), s3.detach(), a2.detach();
          });
        }
        function pg(t3, e3, n2, o2) {
          const i2 = e3.parent, r2 = n2.parent;
          if (i2 != o2 && r2 != o2) {
            for (e3 = t3.createPositionAfter(i2), (n2 = t3.createPositionBefore(r2)).isEqual(e3) || t3.insert(r2, e3), t3.merge(e3); n2.parent.isEmpty; ) {
              const e4 = n2.parent;
              n2 = t3.createPositionBefore(e4), t3.remove(e4);
            }
            fg(t3.model.schema, e3, n2) && pg(t3, e3, n2, o2);
          }
        }
        function mg(t3, e3, n2, o2) {
          const i2 = e3.parent, r2 = n2.parent;
          if (i2 != o2 && r2 != o2) {
            for (e3 = t3.createPositionAfter(i2), (n2 = t3.createPositionBefore(r2)).isEqual(e3) || t3.insert(i2, n2); e3.parent.isEmpty; ) {
              const n3 = e3.parent;
              e3 = t3.createPositionBefore(n3), t3.remove(n3);
            }
            n2 = t3.createPositionBefore(r2), function(t4, e4) {
              const n3 = e4.nodeBefore, o3 = e4.nodeAfter;
              n3.name != o3.name && t4.rename(n3, o3.name);
              t4.clearAttributes(n3), t4.setAttributes(Object.fromEntries(o3.getAttributes()), n3), t4.merge(e4);
            }(t3, n2), fg(t3.model.schema, e3, n2) && mg(t3, e3, n2, o2);
          }
        }
        function fg(t3, e3, n2) {
          const o2 = e3.parent, i2 = n2.parent;
          return o2 != i2 && (!t3.isLimit(o2) && !t3.isLimit(i2) && function(t4, e4, n3) {
            const o3 = new Jl(t4, e4);
            for (const t5 of o3.getWalker())
              if (n3.isLimit(t5.item))
                return false;
            return true;
          }(e3, n2, t3));
        }
        function kg(t3, e3, n2, o2 = {}) {
          const i2 = t3.createElement("paragraph");
          t3.model.schema.setAllowedAttributes(i2, o2, t3), t3.insert(i2, e3), bg(t3, n2, t3.createPositionAt(i2, 0));
        }
        function bg(t3, e3, n2) {
          e3 instanceof xd ? t3.setSelection(n2) : e3.setTo(n2);
        }
        function wg(t3, e3) {
          const n2 = [];
          Array.from(t3.getItems({ direction: "backward" })).map((t4) => e3.createRangeOn(t4)).filter((e4) => (e4.start.isAfter(t3.start) || e4.start.isEqual(t3.start)) && (e4.end.isBefore(t3.end) || e4.end.isEqual(t3.end))).forEach((t4) => {
            n2.push(t4.start.parent), e3.remove(t4);
          }), n2.forEach((t4) => {
            let n3 = t4;
            for (; n3.parent && n3.isEmpty; ) {
              const t5 = e3.createRangeOn(n3);
              n3 = n3.parent, e3.remove(t5);
            }
          });
        }
        class Ag {
          constructor(t3, e3, n2) {
            this._firstNode = null, this._lastNode = null, this._lastAutoParagraph = null, this._filterAttributesOf = [], this._affectedStart = null, this._affectedEnd = null, this._nodeToSelect = null, this.model = t3, this.writer = e3, this.position = n2, this.canMergeWith = /* @__PURE__ */ new Set([this.position.parent]), this.schema = t3.schema, this._documentFragment = e3.createDocumentFragment(), this._documentFragmentPosition = e3.createPositionAt(this._documentFragment, 0);
          }
          handleNodes(t3) {
            for (const e3 of Array.from(t3))
              this._handleNode(e3);
            this._insertPartialFragment(), this._lastAutoParagraph && this._updateLastNodeFromAutoParagraph(this._lastAutoParagraph), this._mergeOnRight(), this.schema.removeDisallowedAttributes(this._filterAttributesOf, this.writer), this._filterAttributesOf = [];
          }
          _updateLastNodeFromAutoParagraph(t3) {
            const e3 = this.writer.createPositionAfter(this._lastNode), n2 = this.writer.createPositionAfter(t3);
            if (n2.isAfter(e3)) {
              if (this._lastNode = t3, this.position.parent != t3 || !this.position.isAtEnd)
                throw new A("insertcontent-invalid-insertion-position", this);
              this.position = n2, this._setAffectedBoundaries(this.position);
            }
          }
          getSelectionRange() {
            return this._nodeToSelect ? Jl._createOn(this._nodeToSelect) : this.model.schema.getNearestSelectionRange(this.position);
          }
          getAffectedRange() {
            return this._affectedStart ? new Jl(this._affectedStart, this._affectedEnd) : null;
          }
          destroy() {
            this._affectedStart && this._affectedStart.detach(), this._affectedEnd && this._affectedEnd.detach();
          }
          _handleNode(t3) {
            if (this.schema.isObject(t3))
              return void this._handleObject(t3);
            let e3 = this._checkAndAutoParagraphToAllowedPosition(t3);
            e3 || (e3 = this._checkAndSplitToAllowedPosition(t3), e3) ? (this._appendToFragment(t3), this._firstNode || (this._firstNode = t3), this._lastNode = t3) : this._handleDisallowedNode(t3);
          }
          _insertPartialFragment() {
            if (this._documentFragment.isEmpty)
              return;
            const t3 = Au.fromPosition(this.position, "toNext");
            this._setAffectedBoundaries(this.position), this._documentFragment.getChild(0) == this._firstNode && (this.writer.insert(this._firstNode, this.position), this._mergeOnLeft(), this.position = t3.toPosition()), this._documentFragment.isEmpty || this.writer.insert(this._documentFragment, this.position), this._documentFragmentPosition = this.writer.createPositionAt(this._documentFragment, 0), this.position = t3.toPosition(), t3.detach();
          }
          _handleObject(t3) {
            this._checkAndSplitToAllowedPosition(t3) ? this._appendToFragment(t3) : this._tryAutoparagraphing(t3);
          }
          _handleDisallowedNode(t3) {
            t3.is("element") ? this.handleNodes(t3.getChildren()) : this._tryAutoparagraphing(t3);
          }
          _appendToFragment(t3) {
            if (!this.schema.checkChild(this.position, t3))
              throw new A("insertcontent-wrong-position", this, { node: t3, position: this.position });
            this.writer.insert(t3, this._documentFragmentPosition), this._documentFragmentPosition = this._documentFragmentPosition.getShiftedBy(t3.offsetSize), this.schema.isObject(t3) && !this.schema.checkChild(this.position, "$text") ? this._nodeToSelect = t3 : this._nodeToSelect = null, this._filterAttributesOf.push(t3);
          }
          _setAffectedBoundaries(t3) {
            this._affectedStart || (this._affectedStart = Au.fromPosition(t3, "toPrevious")), this._affectedEnd && !this._affectedEnd.isBefore(t3) || (this._affectedEnd && this._affectedEnd.detach(), this._affectedEnd = Au.fromPosition(t3, "toNext"));
          }
          _mergeOnLeft() {
            const t3 = this._firstNode;
            if (!(t3 instanceof Hl))
              return;
            if (!this._canMergeLeft(t3))
              return;
            const e3 = Au._createBefore(t3);
            e3.stickiness = "toNext";
            const n2 = Au.fromPosition(this.position, "toNext");
            this._affectedStart.isEqual(e3) && (this._affectedStart.detach(), this._affectedStart = Au._createAt(e3.nodeBefore, "end", "toPrevious")), this._firstNode === this._lastNode && (this._firstNode = e3.nodeBefore, this._lastNode = e3.nodeBefore), this.writer.merge(e3), e3.isEqual(this._affectedEnd) && this._firstNode === this._lastNode && (this._affectedEnd.detach(), this._affectedEnd = Au._createAt(e3.nodeBefore, "end", "toNext")), this.position = n2.toPosition(), n2.detach(), this._filterAttributesOf.push(this.position.parent), e3.detach();
          }
          _mergeOnRight() {
            const t3 = this._lastNode;
            if (!(t3 instanceof Hl))
              return;
            if (!this._canMergeRight(t3))
              return;
            const e3 = Au._createAfter(t3);
            if (e3.stickiness = "toNext", !this.position.isEqual(e3))
              throw new A("insertcontent-invalid-insertion-position", this);
            this.position = Wl._createAt(e3.nodeBefore, "end");
            const n2 = Au.fromPosition(this.position, "toPrevious");
            this._affectedEnd.isEqual(e3) && (this._affectedEnd.detach(), this._affectedEnd = Au._createAt(e3.nodeBefore, "end", "toNext")), this._firstNode === this._lastNode && (this._firstNode = e3.nodeBefore, this._lastNode = e3.nodeBefore), this.writer.merge(e3), e3.getShiftedBy(-1).isEqual(this._affectedStart) && this._firstNode === this._lastNode && (this._affectedStart.detach(), this._affectedStart = Au._createAt(e3.nodeBefore, 0, "toPrevious")), this.position = n2.toPosition(), n2.detach(), this._filterAttributesOf.push(this.position.parent), e3.detach();
          }
          _canMergeLeft(t3) {
            const e3 = t3.previousSibling;
            return e3 instanceof Hl && this.canMergeWith.has(e3) && this.model.schema.checkMerge(e3, t3);
          }
          _canMergeRight(t3) {
            const e3 = t3.nextSibling;
            return e3 instanceof Hl && this.canMergeWith.has(e3) && this.model.schema.checkMerge(t3, e3);
          }
          _tryAutoparagraphing(t3) {
            const e3 = this.writer.createElement("paragraph");
            this._getAllowedIn(this.position.parent, e3) && this.schema.checkChild(e3, t3) && (e3._appendChild(t3), this._handleNode(e3));
          }
          _checkAndAutoParagraphToAllowedPosition(t3) {
            if (this.schema.checkChild(this.position.parent, t3))
              return true;
            if (!this.schema.checkChild(this.position.parent, "paragraph") || !this.schema.checkChild("paragraph", t3))
              return false;
            this._insertPartialFragment();
            const e3 = this.writer.createElement("paragraph");
            return this.writer.insert(e3, this.position), this._setAffectedBoundaries(this.position), this._lastAutoParagraph = e3, this.position = this.writer.createPositionAt(e3, 0), true;
          }
          _checkAndSplitToAllowedPosition(t3) {
            const e3 = this._getAllowedIn(this.position.parent, t3);
            if (!e3)
              return false;
            for (e3 != this.position.parent && this._insertPartialFragment(); e3 != this.position.parent; )
              if (this.position.isAtStart) {
                const t4 = this.position.parent;
                this.position = this.writer.createPositionBefore(t4), t4.isEmpty && t4.parent === e3 && this.writer.remove(t4);
              } else if (this.position.isAtEnd)
                this.position = this.writer.createPositionAfter(this.position.parent);
              else {
                const t4 = this.writer.createPositionAfter(this.position.parent);
                this._setAffectedBoundaries(this.position), this.writer.split(this.position), this.position = t4, this.canMergeWith.add(this.position.nodeAfter);
              }
            return true;
          }
          _getAllowedIn(t3, e3) {
            return this.schema.checkChild(t3, e3) ? t3 : this.schema.isLimit(t3) ? null : this._getAllowedIn(t3.parent, e3);
          }
        }
        function Cg(t3, e3, n2 = "auto") {
          const o2 = t3.getSelectedElement();
          if (o2 && e3.schema.isObject(o2) && !e3.schema.isInline(o2))
            return "before" == n2 || "after" == n2 ? e3.createRange(e3.createPositionAt(o2, n2)) : e3.createRangeOn(o2);
          const i2 = Ii(t3.getSelectedBlocks());
          if (!i2)
            return e3.createRange(t3.focus);
          if (i2.isEmpty)
            return e3.createRange(e3.createPositionAt(i2, 0));
          const r2 = e3.createPositionAfter(i2);
          return t3.focus.isTouching(r2) ? e3.createRange(r2) : e3.createRange(e3.createPositionBefore(i2));
        }
        function _g(t3, e3, n2, o2 = {}) {
          if (!t3.schema.isObject(e3))
            throw new A("insertobject-element-not-an-object", t3, { object: e3 });
          const i2 = n2 || t3.document.selection;
          let r2 = i2;
          o2.findOptimalPosition && t3.schema.isBlock(e3) && (r2 = t3.createSelection(Cg(i2, t3, o2.findOptimalPosition)));
          const s3 = Ii(i2.getSelectedBlocks()), a2 = {};
          return s3 && Object.assign(a2, t3.schema.getAttributesWithProperty(s3, "copyOnReplace", true)), t3.change((n3) => {
            r2.isCollapsed || t3.deleteContent(r2, { doNotAutoparagraph: true });
            let i3 = e3;
            const s4 = r2.anchor.parent;
            !t3.schema.checkChild(s4, e3) && t3.schema.checkChild(s4, "paragraph") && t3.schema.checkChild("paragraph", e3) && (i3 = n3.createElement("paragraph"), n3.insert(e3, i3)), t3.schema.setAllowedAttributes(i3, a2, n3);
            const c2 = t3.insertContent(i3, r2);
            return c2.isCollapsed || o2.setSelection && function(t4, e4, n4, o3) {
              const i4 = t4.model;
              if ("on" == n4)
                return void t4.setSelection(e4, "on");
              if ("after" != n4)
                throw new A("insertobject-invalid-place-parameter-value", i4);
              let r3 = e4.nextSibling;
              if (i4.schema.isInline(e4))
                return void t4.setSelection(e4, "after");
              const s5 = r3 && i4.schema.checkChild(r3, "$text");
              !s5 && i4.schema.checkChild(e4.parent, "paragraph") && (r3 = t4.createElement("paragraph"), i4.schema.setAllowedAttributes(r3, o3, t4), i4.insertContent(r3, t4.createPositionAfter(e4)));
              r3 && t4.setSelection(r3, 0);
            }(n3, e3, o2.setSelection, a2), c2;
          });
        }
        const vg = ' ,.?!:;"-()';
        function yg(t3, e3) {
          const { isForward: n2, walker: o2, unit: i2, schema: r2, treatEmojiAsSingleUnit: s3 } = t3, { type: a2, item: c2, nextPosition: l2 } = e3;
          if ("text" == a2)
            return "word" === t3.unit ? function(t4, e4) {
              let n3 = t4.position.textNode;
              n3 || (n3 = e4 ? t4.position.nodeAfter : t4.position.nodeBefore);
              for (; n3 && n3.is("$text"); ) {
                const o3 = t4.position.offset - n3.startOffset;
                if (Dg(n3, o3, e4))
                  n3 = e4 ? t4.position.nodeAfter : t4.position.nodeBefore;
                else {
                  if (Eg(n3.data, o3, e4))
                    break;
                  t4.next();
                }
              }
              return t4.position;
            }(o2, n2) : function(t4, e4, n3) {
              const o3 = t4.position.textNode;
              if (o3) {
                const i3 = o3.data;
                let r3 = t4.position.offset - o3.startOffset;
                for (; Ni(i3, r3) || "character" == e4 && Pi(i3, r3) || n3 && Oi(i3, r3); )
                  t4.next(), r3 = t4.position.offset - o3.startOffset;
              }
              return t4.position;
            }(o2, i2, s3);
          if (a2 == (n2 ? "elementStart" : "elementEnd")) {
            if (r2.isSelectable(c2))
              return Wl._createAt(c2, n2 ? "after" : "before");
            if (r2.checkChild(l2, "$text"))
              return l2;
          } else {
            if (r2.isLimit(c2))
              return void o2.skip(() => true);
            if (r2.checkChild(l2, "$text"))
              return l2;
          }
        }
        function xg(t3, e3) {
          const n2 = t3.root, o2 = Wl._createAt(n2, e3 ? "end" : 0);
          return e3 ? new Jl(t3, o2) : new Jl(o2, t3);
        }
        function Eg(t3, e3, n2) {
          const o2 = e3 + (n2 ? 0 : -1);
          return vg.includes(t3.charAt(o2));
        }
        function Dg(t3, e3, n2) {
          return e3 === (n2 ? t3.offsetSize : 0);
        }
        class Ig extends W() {
          constructor() {
            super(), this.markers = new og(), this.document = new Zu(this), this.schema = new gh(), this._pendingChanges = [], this._currentWriter = null, ["deleteContent", "modifySelection", "getSelectedContent", "applyOperation"].forEach((t3) => this.decorate(t3)), this.on("applyOperation", (t3, e3) => {
              e3[0]._validate();
            }, { priority: "highest" }), this.schema.register("$root", { isLimit: true }), this.schema.register("$container", { allowIn: ["$root", "$container"] }), this.schema.register("$block", { allowIn: ["$root", "$container"], isBlock: true }), this.schema.register("$blockObject", { allowWhere: "$block", isBlock: true, isObject: true }), this.schema.register("$inlineObject", { allowWhere: "$text", allowAttributesOf: "$text", isInline: true, isObject: true }), this.schema.register("$text", { allowIn: "$block", isInline: true, isContent: true }), this.schema.register("$clipboardHolder", { allowContentOf: "$root", allowChildren: "$text", isLimit: true }), this.schema.register("$documentFragment", { allowContentOf: "$root", allowChildren: "$text", isLimit: true }), this.schema.register("$marker"), this.schema.addChildCheck((t3, e3) => {
              if ("$marker" === e3.name)
                return true;
            }), rh(this), this.document.registerPostFixer(Ud), this.on("insertContent", (t3, [e3, n2]) => {
              t3.return = function(t4, e4, n3) {
                return t4.change((o2) => {
                  const i2 = n3 || t4.document.selection;
                  i2.isCollapsed || t4.deleteContent(i2, { doNotAutoparagraph: true });
                  const r2 = new Ag(t4, o2, i2.anchor), s3 = [];
                  let a2;
                  if (e4.is("documentFragment")) {
                    if (e4.markers.size) {
                      const t5 = [];
                      for (const [n4, o3] of e4.markers) {
                        const { start: e5, end: i3 } = o3, r3 = e5.isEqual(i3);
                        t5.push({ position: e5, name: n4, isCollapsed: r3 }, { position: i3, name: n4, isCollapsed: r3 });
                      }
                      t5.sort(({ position: t6 }, { position: e5 }) => t6.isBefore(e5) ? 1 : -1);
                      for (const { position: n4, name: i3, isCollapsed: r3 } of t5) {
                        let t6 = null, a3 = null;
                        const c3 = n4.parent === e4 && n4.isAtStart, l3 = n4.parent === e4 && n4.isAtEnd;
                        c3 || l3 ? r3 && (a3 = c3 ? "start" : "end") : (t6 = o2.createElement("$marker"), o2.insert(t6, n4)), s3.push({ name: i3, element: t6, collapsed: a3 });
                      }
                    }
                    a2 = e4.getChildren();
                  } else
                    a2 = [e4];
                  r2.handleNodes(a2);
                  let c2 = r2.getSelectionRange();
                  if (e4.is("documentFragment") && s3.length) {
                    const t5 = c2 ? Cd.fromRange(c2) : null, e5 = {};
                    for (let t6 = s3.length - 1; t6 >= 0; t6--) {
                      const { name: n4, element: i3, collapsed: a3 } = s3[t6], c3 = !e5[n4];
                      if (c3 && (e5[n4] = []), i3) {
                        const t7 = o2.createPositionAt(i3, "before");
                        e5[n4].push(t7), o2.remove(i3);
                      } else {
                        const t7 = r2.getAffectedRange();
                        if (!t7) {
                          a3 && e5[n4].push(r2.position);
                          continue;
                        }
                        a3 ? e5[n4].push(t7[a3]) : e5[n4].push(c3 ? t7.start : t7.end);
                      }
                    }
                    for (const [t6, [n4, i3]] of Object.entries(e5))
                      n4 && i3 && n4.root === i3.root && o2.addMarker(t6, { usingOperation: true, affectsData: true, range: new Jl(n4, i3) });
                    t5 && (c2 = t5.toRange(), t5.detach());
                  }
                  c2 && (i2 instanceof xd ? o2.setSelection(c2) : i2.setTo(c2));
                  const l2 = r2.getAffectedRange() || t4.createRange(i2.anchor);
                  return r2.destroy(), l2;
                });
              }(this, e3, n2);
            }), this.on("insertObject", (t3, [e3, n2, o2]) => {
              t3.return = _g(this, e3, n2, o2);
            }), this.on("canEditAt", (t3) => {
              const e3 = !this.document.isReadOnly;
              t3.return = e3, e3 || t3.stop();
            });
          }
          change(t3) {
            try {
              return 0 === this._pendingChanges.length ? (this._pendingChanges.push({ batch: new vu(), callback: t3 }), this._runPendingChanges()[0]) : t3(this._currentWriter);
            } catch (t4) {
              A.rethrowUnexpectedError(t4, this);
            }
          }
          enqueueChange(t3, e3) {
            try {
              t3 ? "function" == typeof t3 ? (e3 = t3, t3 = new vu()) : t3 instanceof vu || (t3 = new vu(t3)) : t3 = new vu(), this._pendingChanges.push({ batch: t3, callback: e3 }), 1 == this._pendingChanges.length && this._runPendingChanges();
            } catch (t4) {
              A.rethrowUnexpectedError(t4, this);
            }
          }
          applyOperation(t3) {
            t3._execute();
          }
          insertContent(t3, e3, n2, ...o2) {
            const i2 = Sg(e3, n2);
            return this.fire("insertContent", [t3, i2, n2, ...o2]);
          }
          insertObject(t3, e3, n2, o2, ...i2) {
            const r2 = Sg(e3, n2);
            return this.fire("insertObject", [t3, r2, o2, o2, ...i2]);
          }
          deleteContent(t3, e3) {
            gg(this, t3, e3);
          }
          modifySelection(t3, e3) {
            !function(t4, e4, n2 = {}) {
              const o2 = t4.schema, i2 = "backward" != n2.direction, r2 = n2.unit ? n2.unit : "character", s3 = !!n2.treatEmojiAsSingleUnit, a2 = e4.focus, c2 = new ql({ boundaries: xg(a2, i2), singleCharacters: true, direction: i2 ? "forward" : "backward" }), l2 = { walker: c2, schema: o2, isForward: i2, unit: r2, treatEmojiAsSingleUnit: s3 };
              let d2;
              for (; d2 = c2.next(); ) {
                if (d2.done)
                  return;
                const n3 = yg(l2, d2.value);
                if (n3)
                  return void (e4 instanceof xd ? t4.change((t5) => {
                    t5.setSelectionFocus(n3);
                  }) : e4.setFocus(n3));
              }
            }(this, t3, e3);
          }
          getSelectedContent(t3) {
            return function(t4, e3) {
              return t4.change((t5) => {
                const n2 = t5.createDocumentFragment(), o2 = e3.getFirstRange();
                if (!o2 || o2.isCollapsed)
                  return n2;
                const i2 = o2.start.root, r2 = o2.start.getCommonPath(o2.end), s3 = i2.getNodeByPath(r2);
                let a2;
                a2 = o2.start.parent == o2.end.parent ? o2 : t5.createRange(t5.createPositionAt(s3, o2.start.path[r2.length]), t5.createPositionAt(s3, o2.end.path[r2.length] + 1));
                const c2 = a2.end.offset - a2.start.offset;
                for (const e4 of a2.getItems({ shallow: true }))
                  e4.is("$textProxy") ? t5.appendText(e4.data, e4.getAttributes(), n2) : t5.append(t5.cloneElement(e4, true), n2);
                if (a2 != o2) {
                  const e4 = o2._getTransformedByMove(a2.start, t5.createPositionAt(n2, 0), c2)[0], i3 = t5.createRange(t5.createPositionAt(n2, 0), e4.start);
                  wg(t5.createRange(e4.end, t5.createPositionAt(n2, "end")), t5), wg(i3, t5);
                }
                return n2;
              });
            }(this, t3);
          }
          hasContent(t3, e3 = {}) {
            const n2 = t3 instanceof Jl ? t3 : Jl._createIn(t3);
            if (n2.isCollapsed)
              return false;
            const { ignoreWhitespaces: o2 = false, ignoreMarkers: i2 = false } = e3;
            if (!i2) {
              for (const t4 of this.markers.getMarkersIntersectingRange(n2))
                if (t4.affectsData)
                  return true;
            }
            for (const t4 of n2.getItems())
              if (this.schema.isContent(t4)) {
                if (!t4.is("$textProxy"))
                  return true;
                if (!o2)
                  return true;
                if (-1 !== t4.data.search(/\S/))
                  return true;
              }
            return false;
          }
          canEditAt(t3) {
            const e3 = Sg(t3);
            return this.fire("canEditAt", [e3]);
          }
          createPositionFromPath(t3, e3, n2) {
            return new Wl(t3, e3, n2);
          }
          createPositionAt(t3, e3) {
            return Wl._createAt(t3, e3);
          }
          createPositionAfter(t3) {
            return Wl._createAfter(t3);
          }
          createPositionBefore(t3) {
            return Wl._createBefore(t3);
          }
          createRange(t3, e3) {
            return new Jl(t3, e3);
          }
          createRangeIn(t3) {
            return Jl._createIn(t3);
          }
          createRangeOn(t3) {
            return Jl._createOn(t3);
          }
          createSelection(...t3) {
            return new pd(...t3);
          }
          createBatch(t3) {
            return new vu(t3);
          }
          createOperationFromJSON(t3) {
            return cu.fromJSON(t3, this.document);
          }
          destroy() {
            this.document.destroy(), this.stopListening();
          }
          _runPendingChanges() {
            const t3 = [];
            this.fire("_beforeChanges");
            try {
              for (; this._pendingChanges.length; ) {
                const e3 = this._pendingChanges[0].batch;
                this._currentWriter = new ag(this, e3);
                const n2 = this._pendingChanges[0].callback(this._currentWriter);
                t3.push(n2), this.document._handleChangeBlock(this._currentWriter), this._pendingChanges.shift(), this._currentWriter = null;
              }
            } finally {
              this._pendingChanges.length = 0, this._currentWriter = null, this.fire("_afterChanges");
            }
            return t3;
          }
        }
        function Sg(t3, e3) {
          if (t3)
            return t3 instanceof pd || t3 instanceof xd ? t3 : t3 instanceof jl ? e3 || 0 === e3 ? new pd(t3, e3) : t3.is("rootElement") ? new pd(t3, "in") : new pd(t3, "on") : new pd(t3);
        }
        class Tg extends Hc {
          constructor() {
            super(...arguments), this.domEventType = "click";
          }
          onDomEvent(t3) {
            this.fire(t3.type, t3);
          }
        }
        class Mg extends Hc {
          constructor() {
            super(...arguments), this.domEventType = ["mousedown", "mouseup", "mouseover", "mouseout"];
          }
          onDomEvent(t3) {
            this.fire(t3.type, t3);
          }
        }
        class Bg {
          constructor(t3) {
            this.document = t3;
          }
          createDocumentFragment(t3) {
            return new ec(this.document, t3);
          }
          createElement(t3, e3, n2) {
            return new ya(this.document, t3, e3, n2);
          }
          createText(t3) {
            return new _s(this.document, t3);
          }
          clone(t3, e3 = false) {
            return t3._clone(e3);
          }
          appendChild(t3, e3) {
            return e3._appendChild(t3);
          }
          insertChild(t3, e3, n2) {
            return n2._insertChild(t3, e3);
          }
          removeChildren(t3, e3, n2) {
            return n2._removeChildren(t3, e3);
          }
          remove(t3) {
            const e3 = t3.parent;
            return e3 ? this.removeChildren(e3.getChildIndex(t3), 1, e3) : [];
          }
          replace(t3, e3) {
            const n2 = t3.parent;
            if (n2) {
              const o2 = n2.getChildIndex(t3);
              return this.removeChildren(o2, 1, n2), this.insertChild(o2, e3, n2), true;
            }
            return false;
          }
          unwrapElement(t3) {
            const e3 = t3.parent;
            if (e3) {
              const n2 = e3.getChildIndex(t3);
              this.remove(t3), this.insertChild(n2, t3.getChildren(), e3);
            }
          }
          rename(t3, e3) {
            const n2 = new ya(this.document, t3, e3.getAttributes(), e3.getChildren());
            return this.replace(e3, n2) ? n2 : null;
          }
          setAttribute(t3, e3, n2) {
            n2._setAttribute(t3, e3);
          }
          removeAttribute(t3, e3) {
            e3._removeAttribute(t3);
          }
          addClass(t3, e3) {
            e3._addClass(t3);
          }
          removeClass(t3, e3) {
            e3._removeClass(t3);
          }
          setStyle(t3, e3, n2) {
            Et(t3) && void 0 === n2 ? e3._setStyle(t3) : n2._setStyle(t3, e3);
          }
          removeStyle(t3, e3) {
            e3._removeStyle(t3);
          }
          setCustomProperty(t3, e3, n2) {
            n2._setCustomProperty(t3, e3);
          }
          removeCustomProperty(t3, e3) {
            return e3._removeCustomProperty(t3);
          }
          createPositionAt(t3, e3) {
            return Ba._createAt(t3, e3);
          }
          createPositionAfter(t3) {
            return Ba._createAfter(t3);
          }
          createPositionBefore(t3) {
            return Ba._createBefore(t3);
          }
          createRange(t3, e3) {
            return new Na(t3, e3);
          }
          createRangeOn(t3) {
            return Na._createOn(t3);
          }
          createRangeIn(t3) {
            return Na._createIn(t3);
          }
          createSelection(...t3) {
            return new za(...t3);
          }
        }
        class Ng {
          constructor() {
            this._commands = /* @__PURE__ */ new Map();
          }
          add(t3, e3) {
            this._commands.set(t3, e3);
          }
          get(t3) {
            return this._commands.get(t3);
          }
          execute(t3, ...e3) {
            const n2 = this.get(t3);
            if (!n2)
              throw new A("commandcollection-command-not-found", this, { commandName: t3 });
            return n2.execute(...e3);
          }
          *names() {
            yield* __yieldStar(this._commands.keys());
          }
          *commands() {
            yield* __yieldStar(this._commands.values());
          }
          [Symbol.iterator]() {
            return this._commands[Symbol.iterator]();
          }
          destroy() {
            for (const t3 of this.commands())
              t3.destroy();
          }
        }
        class Pg extends W() {
          constructor(t3 = {}) {
            super();
            const e3 = this.constructor, n2 = t3.language || e3.defaultConfig && e3.defaultConfig.language;
            this._context = t3.context || new as({ language: n2 }), this._context._addEditor(this, !t3.context);
            const o2 = Array.from(e3.builtinPlugins || []);
            this.config = new xo(t3, e3.defaultConfig), this.config.define("plugins", o2), this.config.define(this._context._getEditorConfig()), this.plugins = new ss(this, o2, this._context.plugins), this.locale = this._context.locale, this.t = this.locale.t, this._readOnlyLocks = /* @__PURE__ */ new Set(), this.commands = new Ng(), this.set("state", "initializing"), this.once("ready", () => this.state = "ready", { priority: "high" }), this.once("destroy", () => this.state = "destroyed", { priority: "high" }), this.model = new Ig(), this.on("change:isReadOnly", () => {
              this.model.document.isReadOnly = this.isReadOnly;
            });
            const i2 = new Ca();
            this.data = new Rh(this.model, i2), this.editing = new lh(this.model, i2), this.editing.view.document.bind("isReadOnly").to(this), this.conversion = new jh([this.editing.downcastDispatcher, this.data.downcastDispatcher], this.data.upcastDispatcher), this.conversion.addAlias("dataDowncast", this.data.downcastDispatcher), this.conversion.addAlias("editingDowncast", this.editing.downcastDispatcher), this.keystrokes = new ls(this), this.keystrokes.listenTo(this.editing.view.document);
          }
          get isReadOnly() {
            return this._readOnlyLocks.size > 0;
          }
          set isReadOnly(t3) {
            throw new A("editor-isreadonly-has-no-setter");
          }
          enableReadOnlyMode(t3) {
            if ("string" != typeof t3 && "symbol" != typeof t3)
              throw new A("editor-read-only-lock-id-invalid", null, { lockId: t3 });
            this._readOnlyLocks.has(t3) || (this._readOnlyLocks.add(t3), 1 === this._readOnlyLocks.size && this.fire("change:isReadOnly", "isReadOnly", true, false));
          }
          disableReadOnlyMode(t3) {
            if ("string" != typeof t3 && "symbol" != typeof t3)
              throw new A("editor-read-only-lock-id-invalid", null, { lockId: t3 });
            this._readOnlyLocks.has(t3) && (this._readOnlyLocks.delete(t3), 0 === this._readOnlyLocks.size && this.fire("change:isReadOnly", "isReadOnly", false, true));
          }
          initPlugins() {
            const t3 = this.config, e3 = t3.get("plugins"), n2 = t3.get("removePlugins") || [], o2 = t3.get("extraPlugins") || [], i2 = t3.get("substitutePlugins") || [];
            return this.plugins.init(e3.concat(o2), n2, i2);
          }
          destroy() {
            let t3 = Promise.resolve();
            return "initializing" == this.state && (t3 = new Promise((t4) => this.once("ready", t4))), t3.then(() => {
              this.fire("destroy"), this.stopListening(), this.commands.destroy();
            }).then(() => this.plugins.destroy()).then(() => {
              this.model.destroy(), this.data.destroy(), this.editing.destroy(), this.keystrokes.destroy();
            }).then(() => this._context._removeEditor(this));
          }
          execute(t3, ...e3) {
            try {
              return this.commands.execute(t3, ...e3);
            } catch (t4) {
              A.rethrowUnexpectedError(t4, this);
            }
          }
          focus() {
            this.editing.view.focus();
          }
          static create(...t3) {
            throw new Error("This is an abstract method.");
          }
        }
        function zg(t3) {
          return class extends t3 {
            setData(t4) {
              this.data.set(t4);
            }
            getData(t4) {
              return this.data.get(t4);
            }
          };
        }
        {
          const t3 = zg(Object);
          zg.setData = t3.prototype.setData, zg.getData = t3.prototype.getData;
        }
        function Og(t3) {
          return class extends t3 {
            updateSourceElement(t4) {
              if (!this.sourceElement)
                throw new A("editor-missing-sourceelement", this);
              const e3 = this.config.get("updateSourceElementOnDestroy"), n2 = this.sourceElement instanceof HTMLTextAreaElement;
              if (!e3 && !n2)
                return void Zo(this.sourceElement, "");
              const o2 = "string" == typeof t4 ? t4 : this.data.get();
              Zo(this.sourceElement, o2);
            }
          };
        }
        Og.updateSourceElement = Og(Object).prototype.updateSourceElement;
        class Lg extends cs {
          static get pluginName() {
            return "PendingActions";
          }
          init() {
            this.set("hasAny", false), this._actions = new Di({ idProperty: "_id" }), this._actions.delegate("add", "remove").to(this);
          }
          add(t3) {
            if ("string" != typeof t3)
              throw new A("pendingactions-add-invalid-message", this);
            const e3 = new (W())();
            return e3.set("message", t3), this._actions.add(e3), this.hasAny = true, e3;
          }
          remove(t3) {
            this._actions.remove(t3), this.hasAny = !!this._actions.length;
          }
          get first() {
            return this._actions.get(0);
          }
          [Symbol.iterator]() {
            return this._actions[Symbol.iterator]();
          }
        }
        const Rg = { bold: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.187 17H5.773c-.637 0-1.092-.138-1.364-.415-.273-.277-.409-.718-.409-1.323V4.738c0-.617.14-1.062.419-1.332.279-.27.73-.406 1.354-.406h4.68c.69 0 1.288.041 1.793.124.506.083.96.242 1.36.478.341.197.644.447.906.75a3.262 3.262 0 0 1 .808 2.162c0 1.401-.722 2.426-2.167 3.075C15.05 10.175 16 11.315 16 13.01a3.756 3.756 0 0 1-2.296 3.504 6.1 6.1 0 0 1-1.517.377c-.571.073-1.238.11-2 .11zm-.217-6.217H7v4.087h3.069c1.977 0 2.965-.69 2.965-2.072 0-.707-.256-1.22-.768-1.537-.512-.319-1.277-.478-2.296-.478zM7 5.13v3.619h2.606c.729 0 1.292-.067 1.69-.2a1.6 1.6 0 0 0 .91-.765c.165-.267.247-.566.247-.897 0-.707-.26-1.176-.778-1.409-.519-.232-1.31-.348-2.375-.348H7z"/></svg>', cancel: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.591 10.177 4.243 4.242a1 1 0 0 1-1.415 1.415l-4.242-4.243-4.243 4.243a1 1 0 0 1-1.414-1.415l4.243-4.242L4.52 5.934A1 1 0 0 1 5.934 4.52l4.243 4.243 4.242-4.243a1 1 0 1 1 1.415 1.414l-4.243 4.243z"/></svg>', caption: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 16h9a1 1 0 0 1 0 2H2a1 1 0 0 1 0-2z"/><path d="M17 1a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h14zm0 1.5H3a.5.5 0 0 0-.492.41L2.5 3v9a.5.5 0 0 0 .41.492L3 12.5h14a.5.5 0 0 0 .492-.41L17.5 12V3a.5.5 0 0 0-.41-.492L17 2.5z" fill-opacity=".6"/></svg>', check: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.972 16.615a.997.997 0 0 1-.744-.292l-4.596-4.596a1 1 0 1 1 1.414-1.414l3.926 3.926 9.937-9.937a1 1 0 0 1 1.414 1.415L7.717 16.323a.997.997 0 0 1-.745.292z"/></svg>', cog: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.333 2 .19 2.263a5.899 5.899 0 0 1 1.458.604L14.714 3.4 16.6 5.286l-1.467 1.733c.263.452.468.942.605 1.46L18 8.666v2.666l-2.263.19a5.899 5.899 0 0 1-.604 1.458l1.467 1.733-1.886 1.886-1.733-1.467a5.899 5.899 0 0 1-1.46.605L11.334 18H8.667l-.19-2.263a5.899 5.899 0 0 1-1.458-.604L5.286 16.6 3.4 14.714l1.467-1.733a5.899 5.899 0 0 1-.604-1.458L2 11.333V8.667l2.262-.189a5.899 5.899 0 0 1 .605-1.459L3.4 5.286 5.286 3.4l1.733 1.467a5.899 5.899 0 0 1 1.46-.605L8.666 2h2.666zM10 6.267a3.733 3.733 0 1 0 0 7.466 3.733 3.733 0 0 0 0-7.466z"/></svg>', eraser: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m8.636 9.531-2.758 3.94a.5.5 0 0 0 .122.696l3.224 2.284h1.314l2.636-3.736L8.636 9.53zm.288 8.451L5.14 15.396a2 2 0 0 1-.491-2.786l6.673-9.53a2 2 0 0 1 2.785-.49l3.742 2.62a2 2 0 0 1 .491 2.785l-7.269 10.053-2.147-.066z"/><path d="M4 18h5.523v-1H4zm-2 0h1v-1H2z"/></svg>', history: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11 1a9 9 0 1 1-8.027 13.075l1.128-1.129A7.502 7.502 0 0 0 18.5 10a7.5 7.5 0 1 0-14.962.759l-.745-.746-.76.76A9 9 0 0 1 11 1z"/><path d="M.475 8.17a.75.75 0 0 1 .978.047l.075.082 1.284 1.643 1.681-1.284a.75.75 0 0 1 .978.057l.073.083a.75.75 0 0 1-.057.978l-.083.073-2.27 1.737a.75.75 0 0 1-.973-.052l-.074-.082-1.741-2.23a.75.75 0 0 1 .13-1.052z"/><path d="M11.5 5v4.999l3.196 3.196-1.06 1.06L10.1 10.72l-.1-.113V5z"/></svg>', image: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.66 9.118a.693.693 0 0 1 .956.032l3.65 3.411 2.422-2.238a.695.695 0 0 1 .945 0L17.5 13.6V2.5h-15v11.1l4.16-4.482ZM17.8 1c.652 0 1.2.47 1.2 1.1v12.862c0 .64-.532 1.038-1.184 1.038H2.184C1.532 16 1 15.603 1 14.962V2.1C1 1.47 1.537 1 2.2 1h15.6Zm-5.655 6a2.129 2.129 0 0 1 .157-2.364 2.133 2.133 0 1 1-.157 2.363Z"/></svg>', imageUpload: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.2 1C.536 1 0 1.47 0 2.1v12.863C0 15.603.547 16 1.199 16h6.3c.908-1.19 1.892-2.41 2.8-3.6L6.615 9.15a.694.694 0 0 0-.957-.033L1.5 13.5v-11h15v6c.6.6 1.012.857 1.5 1.5V2.1c0-.63-.55-1.1-1.201-1.1h-15.6Zm11.724 2.805a2.133 2.133 0 0 0-.998.283 2.129 2.129 0 0 0-.992 1.295c-.074.27-.095.55-.057.828a2.136 2.136 0 0 0 1.56 1.783 2.13 2.13 0 0 0 2.612-1.506 2.129 2.129 0 0 0-2.125-2.683Z"/><path d="M15.208 19.011c.436 0 .79-.327.79-.763v-5.4l2.059 2.455a.79.79 0 0 0 1.212-1.015l-3.352-3.995a.79.79 0 0 0-.996-.179.786.786 0 0 0-.299.221l-3.35 3.99a.79.79 0 1 0 1.21 1.017L14.5 12.9v5.3c0 .437.272.811.709.811Z"/></svg>', imageAssetManager: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M1.201 1C.54 1 0 1.47 0 2.1v12.86c0 .64.448 1.029 1.1 1.039h6.4v-6l-.885-.85a.692.692 0 0 0-.955-.033L1.5 13.5v-11h15V10H18V2.1c0-.63-.547-1.1-1.2-1.1H1.202Zm11.723 2.805a2.129 2.129 0 0 0-1.621.832A2.125 2.125 0 0 0 11.146 7a2.13 2.13 0 0 0 3.905-.512 2.135 2.135 0 0 0-.76-2.244 2.13 2.13 0 0 0-1.367-.44Z"/><path clip-rule="evenodd" d="M19.5 12.5v6.156c0 .224-.192.439-.35.597a.844.844 0 0 1-.597.247H9.834a.844.844 0 0 1-.843-.844v-7.312a.844.844 0 0 1 .843-.844h2.532c.223 0 .476.049.634.207l1 .793h4.5c.224 0 .491.214.65.372.158.158.35.404.35.628ZM18 13h-4.5l-1-1h-2v6H18v-5Z"/></svg>', imageUrl: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_355_284)"><path d="M1.201 1C.54 1 0 1.47 0 2.1v12.863C0 15.603.548 16 1.2 16H8c.022-1.034.222-1.961.783-2.9L9.5 12 6.617 9.15a.694.694 0 0 0-.957-.033L1.5 13.5v-11h15v5.8c.58.188 1.012.43 1.5.8v-7c0-.63-.547-1.1-1.2-1.1H1.202Zm11.723 2.805a2.133 2.133 0 0 0-.996.283 2.131 2.131 0 0 0-.994 1.295 2.136 2.136 0 0 0 1.506 2.611 2.13 2.13 0 0 0 2.61-1.505 2.128 2.128 0 0 0-2.126-2.684Z"/><path d="M16.63 10.294a3.003 3.003 0 0 0-4.142.887l-.117.177a.649.649 0 0 0-.096.493.665.665 0 0 0 .278.417.7.7 0 0 0 .944-.233 1.741 1.741 0 0 1 2.478-.464 1.869 1.869 0 0 1 .476 2.55.634.634 0 0 0-.071.5.648.648 0 0 0 .309.397.628.628 0 0 0 .869-.19l.027-.042a3.226 3.226 0 0 0-.956-4.492Zm-6.061 3.781-.044.065a3.228 3.228 0 0 0 .82 4.404 3.005 3.005 0 0 0 4.275-.799l.13-.196a.626.626 0 0 0 .092-.475.642.642 0 0 0-.268-.402.713.713 0 0 0-.99.26l-.018.028a1.742 1.742 0 0 1-2.477.462 1.87 1.87 0 0 1-.476-2.551l.03-.047a.647.647 0 0 0 .086-.485.66.66 0 0 0-.275-.407l-.04-.027a.609.609 0 0 0-.845.17Z"/><path d="M15.312 13.925c.24-.36.154-.837-.19-1.067-.346-.229-.82-.123-1.059.237l-1.268 1.907c-.239.36-.153.837.192 1.066.345.23.818.124 1.057-.236l1.268-1.907Z"/></g><defs><clipPath id="clip0_355_284"><rect width="20" height="20"/></clipPath></defs></svg>', lowVision: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5.085 6.22 2.943 4.078a.75.75 0 1 1 1.06-1.06l2.592 2.59A11.094 11.094 0 0 1 10 5.068c4.738 0 8.578 3.101 8.578 5.083 0 1.197-1.401 2.803-3.555 3.887l1.714 1.713a.75.75 0 0 1-.09 1.138.488.488 0 0 1-.15.084.75.75 0 0 1-.821-.16L6.17 7.304c-.258.11-.51.233-.757.365l6.239 6.24-.006.005.78.78c-.388.094-.78.166-1.174.215l-1.11-1.11h.011L4.55 8.197a7.2 7.2 0 0 0-.665.514l-.112.098 4.897 4.897-.005.006 1.276 1.276a10.164 10.164 0 0 1-1.477-.117l-.479-.479-.009.009-4.863-4.863-.022.031a2.563 2.563 0 0 0-.124.2c-.043.077-.08.158-.108.241a.534.534 0 0 0-.028.133.29.29 0 0 0 .008.072.927.927 0 0 0 .082.226c.067.133.145.26.234.379l3.242 3.365.025.01.59.623c-3.265-.918-5.59-3.155-5.59-4.668 0-1.194 1.448-2.838 3.663-3.93zm7.07.531a4.632 4.632 0 0 1 1.108 5.992l.345.344.046-.018a9.313 9.313 0 0 0 2-1.112c.256-.187.5-.392.727-.613.137-.134.27-.277.392-.431.072-.091.141-.185.203-.286.057-.093.107-.19.148-.292a.72.72 0 0 0 .036-.12.29.29 0 0 0 .008-.072.492.492 0 0 0-.028-.133.999.999 0 0 0-.036-.096 2.165 2.165 0 0 0-.071-.145 2.917 2.917 0 0 0-.125-.2 3.592 3.592 0 0 0-.263-.335 5.444 5.444 0 0 0-.53-.523 7.955 7.955 0 0 0-1.054-.768 9.766 9.766 0 0 0-1.879-.891c-.337-.118-.68-.219-1.027-.301zm-2.85.21-.069.002a.508.508 0 0 0-.254.097.496.496 0 0 0-.104.679.498.498 0 0 0 .326.199l.045.005c.091.003.181.003.272.012a2.45 2.45 0 0 1 2.017 1.513c.024.061.043.125.069.185a.494.494 0 0 0 .45.287h.008a.496.496 0 0 0 .35-.158.482.482 0 0 0 .13-.335.638.638 0 0 0-.048-.219 3.379 3.379 0 0 0-.36-.723 3.438 3.438 0 0 0-2.791-1.543l-.028-.001h-.013z"/></svg>\n', textAlternative: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M.91 10.488A.909.909 0 0 0 0 11.4v6.877c0 .505.405.91.91.91h18.178a.909.909 0 0 0 .912-.91V11.4a.91.91 0 0 0-.912-.912H.91Zm2.758 1.5h1.947l2.135 5.7H5.898l-.28-.946H3.601l-.278.945H1.516l2.152-5.7Zm4.947 0h1.801v4.3h2.7v1.4h-4.5v-5.7Zm4.5 0h5.4v1.4h-1.798v4.3h-1.701v-4.3h-1.9v-1.4Zm-8.517 1.457-.614 2.059h1.262l-.648-2.06Z"/><path d="M3.035 0C2.446 0 2 .54 2 1.098V9.5h1.5v-8h13v8H18V1.098C18 .539 17.48 0 16.9 0H3.035Zm10.453 2.61a1.885 1.885 0 0 0-1.442.736 1.894 1.894 0 0 0-.376 1.396 1.89 1.89 0 0 0 1.387 1.58c.485.13 1.004.063 1.439-.187a1.887 1.887 0 0 0-1.008-3.526ZM7.463 7.163a.611.611 0 0 0-.432.154L5.071 9.5h5.119L7.88 7.348a.627.627 0 0 0-.417-.184Zm6.236 1.059a.62.62 0 0 0-.42.164L12.07 9.5h2.969l-.92-1.113a.617.617 0 0 0-.42-.164Z"/></svg>', loupe: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.68 13.74h-.001l4.209 4.208a1 1 0 1 0 1.414-1.414l-4.267-4.268a6 6 0 1 0-1.355 1.474ZM13 9a4 4 0 1 1-8 0 4 4 0 0 1 8 0Z"/></svg>', importExport: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M19 4.5 14 0H3v12.673l.868-1.041c.185-.222.4-.402.632-.54V1.5h8v5h5v7.626a2.24 2.24 0 0 1 1.5.822V4.5ZM14 5V2l3.3 3H14Zm-3.692 12.5c.062.105.133.206.213.303L11.52 19H8v-.876a2.243 2.243 0 0 0 1.82-.624h.488Zm7.518-.657a.75.75 0 0 0-1.152-.96L15.5 17.29V12H14v5.29l-1.174-1.408a.75.75 0 0 0-1.152.96l2.346 2.816a.95.95 0 0 0 1.46 0l2.346-2.815Zm-15.056-.38a.75.75 0 0 1-.096-1.056l2.346-2.815a.95.95 0 0 1 1.46 0l2.346 2.815a.75.75 0 1 1-1.152.96L6.5 14.96V20H5v-5.04l-1.174 1.408a.75.75 0 0 1-1.056.096Z"/></svg>', paragraph: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10.5 5.5H7v5h3.5a2.5 2.5 0 1 0 0-5zM5 3h6.5v.025a5 5 0 0 1 0 9.95V13H7v4a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1z"/></svg>', plus: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M10 2a1 1 0 0 0-1 1v6H3a1 1 0 1 0 0 2h6v6a1 1 0 1 0 2 0v-6h6a1 1 0 1 0 0-2h-6V3a1 1 0 0 0-1-1Z"/></svg>', text: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.816 11.5 7.038 4.785 4.261 11.5h5.555Zm.62 1.5H3.641l-1.666 4.028H.312l5.789-14h1.875l5.789 14h-1.663L10.436 13Z"/><path d="m12.09 17-.534-1.292.848-1.971.545 1.319L12.113 17h-.023Zm1.142-5.187.545 1.319L15.5 9.13l1.858 4.316h-3.45l.398.965h3.467L18.887 17H20l-3.873-9h-1.254l-1.641 3.813Z"/></svg>', alignBottom: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.239 13.938-2.88-1.663a.75.75 0 0 1 .75-1.3L9 12.067V4.75a.75.75 0 1 1 1.5 0v7.318l1.89-1.093a.75.75 0 0 1 .75 1.3l-2.879 1.663a.752.752 0 0 1-.511.187.752.752 0 0 1-.511-.187zM4.25 17a.75.75 0 1 1 0-1.5h10.5a.75.75 0 0 1 0 1.5H4.25z"/></svg>', alignMiddle: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M9.75 11.875a.752.752 0 0 1 .508.184l2.883 1.666a.75.75 0 0 1-.659 1.344l-.091-.044-1.892-1.093.001 4.318a.75.75 0 1 1-1.5 0v-4.317l-1.89 1.092a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .51-.187zM15.25 9a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM9.75.375a.75.75 0 0 1 .75.75v4.318l1.89-1.093.092-.045a.75.75 0 0 1 .659 1.344l-2.883 1.667a.752.752 0 0 1-.508.184.752.752 0 0 1-.511-.187L6.359 5.65a.75.75 0 0 1 .75-1.299L9 5.442V1.125a.75.75 0 0 1 .75-.75z"/></svg>', alignTop: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m10.261 7.062 2.88 1.663a.75.75 0 0 1-.75 1.3L10.5 8.933v7.317a.75.75 0 1 1-1.5 0V8.932l-1.89 1.093a.75.75 0 0 1-.75-1.3l2.879-1.663a.752.752 0 0 1 .511-.187.752.752 0 0 1 .511.187zM15.25 4a.75.75 0 1 1 0 1.5H4.75a.75.75 0 0 1 0-1.5h10.5z"/></svg>', alignLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>', alignCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm2.286 4c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h9.928a.75.75 0 1 0 0-1.5H5.036a.75.75 0 0 0-.75.75z"/></svg>', alignRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M18 3.75a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 8a.75.75 0 0 1-.75.75H2.75a.75.75 0 1 1 0-1.5h14.5a.75.75 0 0 1 .75.75zm0 4a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75zm0-8a.75.75 0 0 1-.75.75H7.321a.75.75 0 1 1 0-1.5h9.929a.75.75 0 0 1 .75.75z"/></svg>', alignJustify: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0 4c0 .414.336.75.75.75h9.929a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm0-8c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75z"/></svg>', objectLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zm0-3H18v1.5h-4.5zm0-3H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>', objectCenter: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M15.003 7v5.5a1 1 0 0 1-1 1H5.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H6.5V12h6.997V7.5z"/></svg>', objectRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2zm0-9h5v1.5H2zm0 3h5v1.5H2zm0 3h5v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>', objectFullWidth: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18 7v5.5a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h14a1 1 0 0 1 1 1zm-1.505.5H3.504V12h12.991V7.5z"/></svg>', objectInline: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm11.5 9H18v1.5h-4.5zM2 15h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>', objectBlockLeft: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M12.003 7v5.5a1 1 0 0 1-1 1H2.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H3.5V12h6.997V7.5z"/></svg>', objectBlockRight: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path opacity=".5" d="M2 3h16v1.5H2zm0 12h16v1.5H2z"/><path d="M18.003 7v5.5a1 1 0 0 1-1 1H8.996a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h8.007a1 1 0 0 1 1 1zm-1.506.5H9.5V12h6.997V7.5z"/></svg>', objectSizeFull: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M18.095 2H1.905C.853 2 0 2.895 0 4v12c0 1.105.853 2 1.905 2h16.19C19.147 18 20 17.105 20 16V4c0-1.105-.853-2-1.905-2zm0 1.5c.263 0 .476.224.476.5v12c0 .276-.213.5-.476.5H1.905a.489.489 0 0 1-.476-.5V4c0-.276.213-.5.476-.5h16.19z"/></svg>', objectSizeLarge: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M13 6H2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h11a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V8a.5.5 0 0 1 .5-.5h11z"/></svg>', objectSizeSmall: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M7 10H2a2 2 0 0 0-2 2v4a2 2 0 0 0 2 2h5a2 2 0 0 0 2-2v-4a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5h5z"/></svg>', objectSizeMedium: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M2.5 17v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zm2 0v1h-1v-1h1zM1 15.5v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm-19-2v1H0v-1h1zm19 0v1h-1v-1h1zm0-2v1h-1v-1h1zm-19 0v1H0v-1h1zM14.5 2v1h-1V2h1zm2 0v1h-1V2h1zm2 0v1h-1V2h1zm-8 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm-2 0v1h-1V2h1zm8 0v1h-1V2h1zm-10 0v1h-1V2h1z"/><path d="M10 8H2a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2v-6a2 2 0 0 0-2-2zm0 1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-6a.5.5 0 0 1 .5-.5h8z"/></svg>', pencil: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m7.3 17.37-.061.088a1.518 1.518 0 0 1-.934.535l-4.178.663-.806-4.153a1.495 1.495 0 0 1 .187-1.058l.056-.086L8.77 2.639c.958-1.351 2.803-1.076 4.296-.03 1.497 1.047 2.387 2.693 1.433 4.055L7.3 17.37zM9.14 4.728l-5.545 8.346 3.277 2.294 5.544-8.346L9.14 4.728zM6.07 16.512l-3.276-2.295.53 2.73 2.746-.435zM9.994 3.506 13.271 5.8c.316-.452-.16-1.333-1.065-1.966-.905-.634-1.895-.78-2.212-.328zM8 18.5 9.375 17H19v1.5H8z"/></svg>', pilcrow: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M6.999 2H15a1 1 0 0 1 0 2h-1.004v13a1 1 0 1 1-2 0V4H8.999v13a1 1 0 1 1-2 0v-7A4 4 0 0 1 3 6a4 4 0 0 1 3.999-4z"/></svg>', quote: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 10.423a6.5 6.5 0 0 1 6.056-6.408l.038.67C6.448 5.423 5.354 7.663 5.22 10H9c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574zm8 0a6.5 6.5 0 0 1 6.056-6.408l.038.67c-2.646.739-3.74 2.979-3.873 5.315H17c.552 0 .5.432.5.986v4.511c0 .554-.448.503-1 .503h-5c-.552 0-.5-.449-.5-1.003v-4.574z"/></svg>', threeVerticalDots: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><circle cx="9.5" cy="4.5" r="1.5"/><circle cx="9.5" cy="10.5" r="1.5"/><circle cx="9.5" cy="16.5" r="1.5"/></svg>', dragIndicator: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M5 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 3.25a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 10a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M5 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/><path d="M12 16.75a1.5 1.5 0 1 0 3 0 1.5 1.5 0 1 0-3 0"/></svg>' };
        var jg = n(5542), Fg = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(jg.Z, Fg);
        jg.Z.locals;
        const { threeVerticalDots: Vg } = Rg, Ug = { alignLeft: Rg.alignLeft, bold: Rg.bold, importExport: Rg.importExport, paragraph: Rg.paragraph, plus: Rg.plus, text: Rg.text, threeVerticalDots: Rg.threeVerticalDots, pilcrow: Rg.pilcrow, dragIndicator: Rg.dragIndicator };
        class Hg extends Ui {
          constructor(t3, e3) {
            super(t3);
            const n2 = this.bindTemplate, o2 = this.t;
            this.options = e3 || {}, this.set("ariaLabel", o2("Editor toolbar")), this.set("maxWidth", "auto"), this.items = this.createCollection(), this.focusTracker = new Si(), this.keystrokes = new Ti(), this.set("class", void 0), this.set("isCompact", false), this.itemsView = new qg(t3), this.children = this.createCollection(), this.children.add(this.itemsView), this.focusables = this.createCollection();
            const i2 = "rtl" === t3.uiLanguageDirection;
            this._focusCycler = new qr({ focusables: this.focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: [i2 ? "arrowright" : "arrowleft", "arrowup"], focusNext: [i2 ? "arrowleft" : "arrowright", "arrowdown"] } });
            const r2 = ["ck", "ck-toolbar", n2.to("class"), n2.if("isCompact", "ck-toolbar_compact")];
            var s3;
            this.options.shouldGroupWhenFull && this.options.isFloating && r2.push("ck-toolbar_floating"), this.setTemplate({ tag: "div", attributes: { class: r2, role: "toolbar", "aria-label": n2.to("ariaLabel"), style: { maxWidth: n2.to("maxWidth") }, tabindex: -1 }, children: this.children, on: { mousedown: (s3 = this, s3.bindTemplate.to((t4) => {
              t4.target === s3.element && t4.preventDefault();
            })) } }), this._behavior = this.options.shouldGroupWhenFull ? new Wg(this) : new Gg(this);
          }
          render() {
            super.render(), this.focusTracker.add(this.element);
            for (const t3 of this.items)
              this.focusTracker.add(t3.element);
            this.items.on("add", (t3, e3) => {
              this.focusTracker.add(e3.element);
            }), this.items.on("remove", (t3, e3) => {
              this.focusTracker.remove(e3.element);
            }), this.keystrokes.listenTo(this.element), this._behavior.render(this);
          }
          destroy() {
            return this._behavior.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy(), super.destroy();
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          focusLast() {
            this._focusCycler.focusLast();
          }
          fillFromConfig(t3, e3, n2) {
            this.items.addMany(this._buildItemsFromConfig(t3, e3, n2));
          }
          _buildItemsFromConfig(t3, e3, n2) {
            const o2 = ts(t3), i2 = n2 || o2.removeItems;
            return this._cleanItemsConfiguration(o2.items, e3, i2).map((t4) => j(t4) ? this._createNestedToolbarDropdown(t4, e3, i2) : "|" === t4 ? new Wr() : "-" === t4 ? new Kr() : e3.create(t4)).filter((t4) => !!t4);
          }
          _cleanItemsConfiguration(t3, e3, n2) {
            const o2 = t3.filter((t4, o3, i2) => "|" === t4 || -1 === n2.indexOf(t4) && ("-" === t4 ? !this.options.shouldGroupWhenFull || (C("toolbarview-line-break-ignored-when-grouping-items", i2), false) : !(!j(t4) && !e3.has(t4)) || (C("toolbarview-item-unavailable", { item: t4 }), false)));
            return this._cleanSeparatorsAndLineBreaks(o2);
          }
          _cleanSeparatorsAndLineBreaks(t3) {
            const e3 = (t4) => "-" !== t4 && "|" !== t4, n2 = t3.length, o2 = t3.findIndex(e3);
            if (-1 === o2)
              return [];
            const i2 = n2 - t3.slice().reverse().findIndex(e3);
            return t3.slice(o2, i2).filter((t4, n3, o3) => {
              if (e3(t4))
                return true;
              return !(n3 > 0 && o3[n3 - 1] === t4);
            });
          }
          _createNestedToolbarDropdown(t3, e3, n2) {
            let { label: o2, icon: i2, items: r2, tooltip: s3 = true, withText: a2 = false } = t3;
            if (r2 = this._cleanItemsConfiguration(r2, e3, n2), !r2.length)
              return null;
            const c2 = sp(this.locale);
            return o2 || C("toolbarview-nested-toolbar-dropdown-missing-label", t3), c2.class = "ck-toolbar__nested-toolbar-dropdown", c2.buttonView.set({ label: o2, tooltip: s3, withText: !!a2 }), false !== i2 ? c2.buttonView.icon = Ug[i2] || i2 || Vg : c2.buttonView.withText = true, ap(c2, () => c2.toolbarView._buildItemsFromConfig(r2, e3, n2)), c2;
          }
        }
        class qg extends Ui {
          constructor(t3) {
            super(t3), this.children = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-toolbar__items"] }, children: this.children });
          }
        }
        class Gg {
          constructor(t3) {
            const e3 = t3.bindTemplate;
            t3.set("isVertical", false), t3.itemsView.children.bindTo(t3.items).using((t4) => t4), t3.focusables.bindTo(t3.items).using((t4) => t4), t3.extendTemplate({ attributes: { class: [e3.if("isVertical", "ck-toolbar_vertical")] } });
          }
          render() {
          }
          destroy() {
          }
        }
        class Wg {
          constructor(t3) {
            this.resizeObserver = null, this.cachedPadding = null, this.shouldUpdateGroupingOnNextResize = false, this.view = t3, this.viewChildren = t3.children, this.viewFocusables = t3.focusables, this.viewItemsView = t3.itemsView, this.viewFocusTracker = t3.focusTracker, this.viewLocale = t3.locale, this.ungroupedItems = t3.createCollection(), this.groupedItems = t3.createCollection(), this.groupedItemsDropdown = this._createGroupedItemsDropdown(), t3.itemsView.children.bindTo(this.ungroupedItems).using((t4) => t4), this.ungroupedItems.on("change", this._updateFocusCycleableItems.bind(this)), t3.children.on("change", this._updateFocusCycleableItems.bind(this)), t3.items.on("change", (t4, e3) => {
              const n2 = e3.index, o2 = Array.from(e3.added);
              for (const t5 of e3.removed)
                n2 >= this.ungroupedItems.length ? this.groupedItems.remove(t5) : this.ungroupedItems.remove(t5);
              for (let t5 = n2; t5 < n2 + o2.length; t5++) {
                const e4 = o2[t5 - n2];
                t5 > this.ungroupedItems.length ? this.groupedItems.add(e4, t5 - this.ungroupedItems.length) : this.ungroupedItems.add(e4, t5);
              }
              this._updateGrouping();
            }), t3.extendTemplate({ attributes: { class: ["ck-toolbar_grouping"] } });
          }
          render(t3) {
            this.viewElement = t3.element, this._enableGroupingOnResize(), this._enableGroupingOnMaxWidthChange(t3);
          }
          destroy() {
            this.groupedItemsDropdown.destroy(), this.resizeObserver.destroy();
          }
          _updateGrouping() {
            if (!this.viewElement.ownerDocument.body.contains(this.viewElement))
              return;
            if (!Xo(this.viewElement))
              return void (this.shouldUpdateGroupingOnNextResize = true);
            const t3 = this.groupedItems.length;
            let e3;
            for (; this._areItemsOverflowing; )
              this._groupLastItem(), e3 = true;
            if (!e3 && this.groupedItems.length) {
              for (; this.groupedItems.length && !this._areItemsOverflowing; )
                this._ungroupFirstItem();
              this._areItemsOverflowing && this._groupLastItem();
            }
            this.groupedItems.length !== t3 && this.view.fire("groupedItemsUpdate");
          }
          get _areItemsOverflowing() {
            if (!this.ungroupedItems.length)
              return false;
            const t3 = this.viewElement, e3 = this.viewLocale.uiLanguageDirection, n2 = new Vo(t3.lastChild), o2 = new Vo(t3);
            if (!this.cachedPadding) {
              const n3 = zo.window.getComputedStyle(t3), o3 = "ltr" === e3 ? "paddingRight" : "paddingLeft";
              this.cachedPadding = Number.parseInt(n3[o3]);
            }
            return "ltr" === e3 ? n2.right > o2.right - this.cachedPadding : n2.left < o2.left + this.cachedPadding;
          }
          _enableGroupingOnResize() {
            let t3;
            this.resizeObserver = new Ko(this.viewElement, (e3) => {
              t3 && t3 === e3.contentRect.width && !this.shouldUpdateGroupingOnNextResize || (this.shouldUpdateGroupingOnNextResize = false, this._updateGrouping(), t3 = e3.contentRect.width);
            }), this._updateGrouping();
          }
          _enableGroupingOnMaxWidthChange(t3) {
            t3.on("change:maxWidth", () => {
              this._updateGrouping();
            });
          }
          _groupLastItem() {
            this.groupedItems.length || (this.viewChildren.add(new Wr()), this.viewChildren.add(this.groupedItemsDropdown), this.viewFocusTracker.add(this.groupedItemsDropdown.element)), this.groupedItems.add(this.ungroupedItems.remove(this.ungroupedItems.last), 0);
          }
          _ungroupFirstItem() {
            this.ungroupedItems.add(this.groupedItems.remove(this.groupedItems.first)), this.groupedItems.length || (this.viewChildren.remove(this.groupedItemsDropdown), this.viewChildren.remove(this.viewChildren.last), this.viewFocusTracker.remove(this.groupedItemsDropdown.element));
          }
          _createGroupedItemsDropdown() {
            const t3 = this.viewLocale, e3 = t3.t, n2 = sp(t3);
            return n2.class = "ck-toolbar__grouped-dropdown", n2.panelPosition = "ltr" === t3.uiLanguageDirection ? "sw" : "se", ap(n2, this.groupedItems), n2.buttonView.set({ label: e3("Show more items"), tooltip: true, tooltipPosition: "rtl" === t3.uiLanguageDirection ? "se" : "sw", icon: Vg }), n2;
          }
          _updateFocusCycleableItems() {
            this.viewFocusables.clear(), this.ungroupedItems.map((t3) => {
              this.viewFocusables.add(t3);
            }), this.groupedItems.length && this.viewFocusables.add(this.groupedItemsDropdown);
          }
        }
        class Kg extends Ui {
          constructor(t3) {
            super(t3);
            const e3 = this.bindTemplate;
            this.set("isVisible", true), this.children = this.createCollection(), this.setTemplate({ tag: "li", attributes: { class: ["ck", "ck-list__item", e3.if("isVisible", "ck-hidden", (t4) => !t4)], role: "presentation" }, children: this.children });
          }
          focus() {
            this.children.first && this.children.first.focus();
          }
        }
        class Zg extends Ui {
          constructor(t3) {
            super(t3), this.setTemplate({ tag: "li", attributes: { class: ["ck", "ck-list__separator"] } });
          }
        }
        class Yg extends Ui {
          constructor(t3, e3 = new Er()) {
            super(t3);
            const n2 = this.bindTemplate, o2 = new Jg(t3);
            this.set({ label: "", isVisible: true }), this.labelView = e3, this.labelView.bind("text").to(this, "label"), this.children = this.createCollection(), this.children.addMany([this.labelView, o2]), o2.set({ role: "group", ariaLabelledBy: e3.id }), o2.focusTracker.destroy(), o2.keystrokes.destroy(), this.items = o2.items, this.setTemplate({ tag: "li", attributes: { role: "presentation", class: ["ck", "ck-list__group", n2.if("isVisible", "ck-hidden", (t4) => !t4)] }, children: this.children });
          }
          focus() {
            if (this.items) {
              const t3 = this.items.find((t4) => !(t4 instanceof Zg));
              t3 && t3.focus();
            }
          }
        }
        var $g = n(1046), Qg = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()($g.Z, Qg);
        $g.Z.locals;
        class Jg extends Ui {
          constructor(t3) {
            super(t3), this._listItemGroupToChangeListeners = /* @__PURE__ */ new WeakMap();
            const e3 = this.bindTemplate;
            this.focusables = new Li(), this.items = this.createCollection(), this.focusTracker = new Si(), this.keystrokes = new Ti(), this._focusCycler = new qr({ focusables: this.focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "arrowup", focusNext: "arrowdown" } }), this.set("ariaLabel", void 0), this.set("ariaLabelledBy", void 0), this.set("role", void 0), this.setTemplate({ tag: "ul", attributes: { class: ["ck", "ck-reset", "ck-list"], role: e3.to("role"), "aria-label": e3.to("ariaLabel"), "aria-labelledby": e3.to("ariaLabelledBy") }, children: this.items });
          }
          render() {
            super.render();
            for (const t3 of this.items)
              t3 instanceof Yg ? this._registerFocusableItemsGroup(t3) : t3 instanceof Kg && this._registerFocusableListItem(t3);
            this.items.on("change", (t3, e3) => {
              for (const t4 of e3.removed)
                t4 instanceof Yg ? this._deregisterFocusableItemsGroup(t4) : this._deregisterFocusableListItem(t4);
              for (const t4 of Array.from(e3.added).reverse())
                t4 instanceof Yg ? this._registerFocusableItemsGroup(t4, e3.index) : this._registerFocusableListItem(t4, e3.index);
            }), this.keystrokes.listenTo(this.element);
          }
          destroy() {
            super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          focusFirst() {
            this._focusCycler.focusFirst();
          }
          focusLast() {
            this._focusCycler.focusLast();
          }
          _registerFocusableListItem(t3, e3) {
            this.focusTracker.add(t3.element), this.focusables.add(t3, e3);
          }
          _deregisterFocusableListItem(t3) {
            this.focusTracker.remove(t3.element), this.focusables.remove(t3);
          }
          _getOnGroupItemsChangeCallback(t3) {
            return (e3, n2) => {
              for (const t4 of n2.removed)
                this._deregisterFocusableListItem(t4);
              for (const e4 of Array.from(n2.added).reverse())
                this._registerFocusableListItem(e4, this.items.getIndex(t3) + n2.index);
            };
          }
          _registerFocusableItemsGroup(t3, e3) {
            Array.from(t3.items).forEach((t4, n3) => {
              const o2 = void 0 !== e3 ? e3 + n3 : void 0;
              this._registerFocusableListItem(t4, o2);
            });
            const n2 = this._getOnGroupItemsChangeCallback(t3);
            this._listItemGroupToChangeListeners.set(t3, n2), t3.items.on("change", n2);
          }
          _deregisterFocusableItemsGroup(t3) {
            for (const e3 of t3.items)
              this._deregisterFocusableListItem(e3);
            t3.items.off("change", this._listItemGroupToChangeListeners.get(t3)), this._listItemGroupToChangeListeners.delete(t3);
          }
        }
        var Xg = n(7686), tp = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Xg.Z, tp);
        Xg.Z.locals;
        class ep extends Ui {
          constructor(t3, e3) {
            super(t3);
            const n2 = this.bindTemplate;
            this.set("class", void 0), this.set("labelStyle", void 0), this.set("icon", void 0), this.set("isEnabled", true), this.set("isOn", false), this.set("isToggleable", false), this.set("isVisible", true), this.set("keystroke", void 0), this.set("withKeystroke", false), this.set("label", void 0), this.set("tabindex", -1), this.set("tooltip", false), this.set("tooltipPosition", "s"), this.set("type", "button"), this.set("withText", false), this.children = this.createCollection(), this.actionView = this._createActionView(e3), this.arrowView = this._createArrowView(), this.keystrokes = new Ti(), this.focusTracker = new Si(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-splitbutton", n2.to("class"), n2.if("isVisible", "ck-hidden", (t4) => !t4), this.arrowView.bindTemplate.if("isOn", "ck-splitbutton_open")] }, children: this.children });
          }
          render() {
            super.render(), this.children.add(this.actionView), this.children.add(this.arrowView), this.focusTracker.add(this.actionView.element), this.focusTracker.add(this.arrowView.element), this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", (t3, e3) => {
              this.focusTracker.focusedElement === this.actionView.element && (this.arrowView.focus(), e3());
            }), this.keystrokes.set("arrowleft", (t3, e3) => {
              this.focusTracker.focusedElement === this.arrowView.element && (this.actionView.focus(), e3());
            });
          }
          destroy() {
            super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
          focus() {
            this.actionView.focus();
          }
          _createActionView(t3) {
            const e3 = t3 || new br();
            return t3 || e3.bind("icon", "isEnabled", "isOn", "isToggleable", "keystroke", "label", "tabindex", "tooltip", "tooltipPosition", "type", "withText").to(this), e3.extendTemplate({ attributes: { class: "ck-splitbutton__action" } }), e3.delegate("execute").to(this), e3;
          }
          _createArrowView() {
            const t3 = new br(), e3 = t3.bindTemplate;
            return t3.icon = Ur, t3.extendTemplate({ attributes: { class: ["ck-splitbutton__arrow"], "data-cke-tooltip-disabled": e3.to("isOn"), "aria-haspopup": true, "aria-expanded": e3.to("isOn", (t4) => String(t4)) } }), t3.bind("isEnabled").to(this), t3.bind("label").to(this), t3.bind("tooltip").to(this), t3.delegate("execute").to(this, "open"), t3;
          }
        }
        var np = n(7339), op = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(np.Z, op);
        np.Z.locals;
        var ip = n(3949), rp = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(ip.Z, rp);
        ip.Z.locals;
        function sp(e3, n2 = Hr) {
          const o2 = "function" == typeof n2 ? new n2(e3) : n2, i2 = new Lr(e3), r2 = new Vr(e3, o2, i2);
          return o2.bind("isEnabled").to(r2), o2 instanceof ep ? o2.arrowView.bind("isOn").to(r2, "isOpen") : o2.bind("isOn").to(r2, "isOpen"), function(e4) {
            (function(e5) {
              e5.on("render", () => {
                t2({ emitter: e5, activator: () => e5.isOpen, callback: () => {
                  e5.isOpen = false;
                }, contextElements: () => [e5.element, ...e5.focusTracker._elements] });
              });
            })(e4), function(t3) {
              t3.on("execute", (e5) => {
                e5.source instanceof Cr || (t3.isOpen = false);
              });
            }(e4), function(t3) {
              t3.focusTracker.on("change:isFocused", (e5, n3, o3) => {
                t3.isOpen && !o3 && (t3.isOpen = false);
              });
            }(e4), function(t3) {
              t3.keystrokes.set("arrowdown", (e5, n3) => {
                t3.isOpen && (t3.panelView.focus(), n3());
              }), t3.keystrokes.set("arrowup", (e5, n3) => {
                t3.isOpen && (t3.panelView.focusLast(), n3());
              });
            }(e4), function(t3) {
              t3.on("change:isOpen", (e5, n3, o3) => {
                if (o3)
                  return;
                const i3 = t3.panelView.element;
                i3 && i3.contains(zo.document.activeElement) && t3.buttonView.focus();
              });
            }(e4), function(t3) {
              t3.on("change:isOpen", (e5, n3, o3) => {
                o3 && t3.panelView.focus();
              }, { priority: "low" });
            }(e4);
          }(r2), r2;
        }
        function ap(t3, e3, n2 = {}) {
          t3.extendTemplate({ attributes: { class: ["ck-toolbar-dropdown"] } }), t3.isOpen ? cp(t3, e3, n2) : t3.once("change:isOpen", () => cp(t3, e3, n2), { priority: "highest" }), n2.enableActiveItemFocusOnDropdownOpen && hp(t3, () => t3.toolbarView.items.find((t4) => t4.isOn));
        }
        function cp(t3, e3, n2) {
          const o2 = t3.locale, i2 = o2.t, r2 = t3.toolbarView = new Hg(o2), s3 = "function" == typeof e3 ? e3() : e3;
          r2.ariaLabel = n2.ariaLabel || i2("Dropdown toolbar"), n2.maxWidth && (r2.maxWidth = n2.maxWidth), n2.class && (r2.class = n2.class), n2.isCompact && (r2.isCompact = n2.isCompact), n2.isVertical && (r2.isVertical = true), s3 instanceof Li ? r2.items.bindTo(s3).using((t4) => t4) : r2.items.addMany(s3), t3.panelView.children.add(r2), r2.items.delegate("execute").to(t3);
        }
        function lp(t3, e3, n2 = {}) {
          t3.isOpen ? dp(t3, e3, n2) : t3.once("change:isOpen", () => dp(t3, e3, n2), { priority: "highest" }), hp(t3, () => t3.listView.items.find((t4) => t4 instanceof Kg && t4.children.first.isOn));
        }
        function dp(t3, e3, n2) {
          const o2 = t3.locale, i2 = t3.listView = new Jg(o2), r2 = "function" == typeof e3 ? e3() : e3;
          i2.ariaLabel = n2.ariaLabel, i2.role = n2.role, up(t3, i2.items, r2, o2), t3.panelView.children.add(i2), i2.items.delegate("execute").to(t3);
        }
        function hp(t3, e3) {
          t3.on("change:isOpen", () => {
            if (!t3.isOpen)
              return;
            const n2 = e3();
            n2 && ("function" == typeof n2.focus ? n2.focus() : C("ui-dropdown-focus-child-on-open-child-missing-focus", { view: n2 }));
          }, { priority: k.low - 10 });
        }
        function up(t3, e3, n2, o2) {
          e3.bindTo(n2).using((e4) => {
            if ("separator" === e4.type)
              return new Zg(o2);
            if ("group" === e4.type) {
              const n3 = new Yg(o2);
              return n3.set({ label: e4.label }), up(t3, n3.items, e4.items, o2), n3.items.delegate("execute").to(t3), n3;
            }
            if ("button" === e4.type || "switchbutton" === e4.type) {
              const t4 = new Kg(o2);
              let n3;
              return "button" === e4.type ? (n3 = new br(o2), n3.extendTemplate({ attributes: { "aria-checked": n3.bindTemplate.to("isOn") } })) : n3 = new Cr(o2), n3.bind(...Object.keys(e4.model)).to(e4.model), n3.delegate("execute").to(t4), t4.children.add(n3), t4;
            }
            return null;
          });
        }
        const gp = (t3, e3, n2) => {
          const o2 = new Pr(t3.locale);
          return o2.set({ id: e3, ariaDescribedById: n2 }), o2.bind("isReadOnly").to(t3, "isEnabled", (t4) => !t4), o2.bind("hasError").to(t3, "errorText", (t4) => !!t4), o2.on("input", () => {
            t3.errorText = null;
          }), t3.bind("isEmpty", "isFocused", "placeholder").to(o2), o2;
        }, pp = (t3, e3 = 0, n2 = 1) => t3 > n2 ? n2 : t3 < e3 ? e3 : t3, mp = (t3, e3 = 0, n2 = Math.pow(10, e3)) => Math.round(n2 * t3) / n2, fp = (Math.PI, (t3) => ("#" === t3[0] && (t3 = t3.substring(1)), t3.length < 6 ? { r: parseInt(t3[0] + t3[0], 16), g: parseInt(t3[1] + t3[1], 16), b: parseInt(t3[2] + t3[2], 16), a: 4 === t3.length ? mp(parseInt(t3[3] + t3[3], 16) / 255, 2) : 1 } : { r: parseInt(t3.substring(0, 2), 16), g: parseInt(t3.substring(2, 4), 16), b: parseInt(t3.substring(4, 6), 16), a: 8 === t3.length ? mp(parseInt(t3.substring(6, 8), 16) / 255, 2) : 1 })), kp = ({ h: t3, s: e3, v: n2, a: o2 }) => {
          const i2 = (200 - e3) * n2 / 100;
          return { h: mp(t3), s: mp(i2 > 0 && i2 < 200 ? e3 * n2 / 100 / (i2 <= 100 ? i2 : 200 - i2) * 100 : 0), l: mp(i2 / 2), a: mp(o2, 2) };
        }, bp = (t3) => {
          const { h: e3, s: n2, l: o2 } = kp(t3);
          return `hsl(${e3}, ${n2}%, ${o2}%)`;
        }, wp = ({ h: t3, s: e3, v: n2, a: o2 }) => {
          t3 = t3 / 360 * 6, e3 /= 100, n2 /= 100;
          const i2 = Math.floor(t3), r2 = n2 * (1 - e3), s3 = n2 * (1 - (t3 - i2) * e3), a2 = n2 * (1 - (1 - t3 + i2) * e3), c2 = i2 % 6;
          return { r: mp(255 * [n2, s3, r2, r2, a2, n2][c2]), g: mp(255 * [a2, n2, n2, s3, r2, r2][c2]), b: mp(255 * [r2, r2, a2, n2, n2, s3][c2]), a: mp(o2, 2) };
        }, Ap = (t3) => {
          const e3 = t3.toString(16);
          return e3.length < 2 ? "0" + e3 : e3;
        }, Cp = ({ r: t3, g: e3, b: n2, a: o2 }) => {
          const i2 = o2 < 1 ? Ap(mp(255 * o2)) : "";
          return "#" + Ap(t3) + Ap(e3) + Ap(n2) + i2;
        }, _p = ({ r: t3, g: e3, b: n2, a: o2 }) => {
          const i2 = Math.max(t3, e3, n2), r2 = i2 - Math.min(t3, e3, n2), s3 = r2 ? i2 === t3 ? (e3 - n2) / r2 : i2 === e3 ? 2 + (n2 - t3) / r2 : 4 + (t3 - e3) / r2 : 0;
          return { h: mp(60 * (s3 < 0 ? s3 + 6 : s3)), s: mp(i2 ? r2 / i2 * 100 : 0), v: mp(i2 / 255 * 100), a: o2 };
        }, vp = (t3, e3) => {
          if (t3 === e3)
            return true;
          for (const n2 in t3)
            if (t3[n2] !== e3[n2])
              return false;
          return true;
        }, yp = {}, xp = (t3) => {
          let e3 = yp[t3];
          return e3 || (e3 = document.createElement("template"), e3.innerHTML = t3, yp[t3] = e3), e3;
        }, Ep = (t3, e3, n2) => {
          t3.dispatchEvent(new CustomEvent(e3, { bubbles: true, detail: n2 }));
        };
        let Dp = false;
        const Ip = (t3) => "touches" in t3, Sp = (t3, e3) => {
          const n2 = Ip(e3) ? e3.touches[0] : e3, o2 = t3.el.getBoundingClientRect();
          Ep(t3.el, "move", t3.getMove({ x: pp((n2.pageX - (o2.left + window.pageXOffset)) / o2.width), y: pp((n2.pageY - (o2.top + window.pageYOffset)) / o2.height) }));
        };
        class Tp {
          constructor(t3, e3, n2, o2) {
            const i2 = xp(`<div role="slider" tabindex="0" part="${e3}" ${n2}><div part="${e3}-pointer"></div></div>`);
            t3.appendChild(i2.content.cloneNode(true));
            const r2 = t3.querySelector(`[part=${e3}]`);
            r2.addEventListener("mousedown", this), r2.addEventListener("touchstart", this), r2.addEventListener("keydown", this), this.el = r2, this.xy = o2, this.nodes = [r2.firstChild, r2];
          }
          set dragging(t3) {
            const e3 = t3 ? document.addEventListener : document.removeEventListener;
            e3(Dp ? "touchmove" : "mousemove", this), e3(Dp ? "touchend" : "mouseup", this);
          }
          handleEvent(t3) {
            switch (t3.type) {
              case "mousedown":
              case "touchstart":
                if (t3.preventDefault(), !((t4) => !(Dp && !Ip(t4) || (Dp || (Dp = Ip(t4)), 0)))(t3) || !Dp && 0 != t3.button)
                  return;
                this.el.focus(), Sp(this, t3), this.dragging = true;
                break;
              case "mousemove":
              case "touchmove":
                t3.preventDefault(), Sp(this, t3);
                break;
              case "mouseup":
              case "touchend":
                this.dragging = false;
                break;
              case "keydown":
                ((t4, e3) => {
                  const n2 = e3.keyCode;
                  n2 > 40 || t4.xy && n2 < 37 || n2 < 33 || (e3.preventDefault(), Ep(t4.el, "move", t4.getMove({ x: 39 === n2 ? 0.01 : 37 === n2 ? -0.01 : 34 === n2 ? 0.05 : 33 === n2 ? -0.05 : 35 === n2 ? 1 : 36 === n2 ? -1 : 0, y: 40 === n2 ? 0.01 : 38 === n2 ? -0.01 : 0 }, true)));
                })(this, t3);
            }
          }
          style(t3) {
            t3.forEach((t4, e3) => {
              for (const n2 in t4)
                this.nodes[e3].style.setProperty(n2, t4[n2]);
            });
          }
        }
        class Mp extends Tp {
          constructor(t3) {
            super(t3, "hue", 'aria-label="Hue" aria-valuemin="0" aria-valuemax="360"', false);
          }
          update({ h: t3 }) {
            this.h = t3, this.style([{ left: t3 / 360 * 100 + "%", color: bp({ h: t3, s: 100, v: 100, a: 1 }) }]), this.el.setAttribute("aria-valuenow", `${mp(t3)}`);
          }
          getMove(t3, e3) {
            return { h: e3 ? pp(this.h + 360 * t3.x, 0, 360) : 360 * t3.x };
          }
        }
        class Bp extends Tp {
          constructor(t3) {
            super(t3, "saturation", 'aria-label="Color"', true);
          }
          update(t3) {
            this.hsva = t3, this.style([{ top: 100 - t3.v + "%", left: `${t3.s}%`, color: bp(t3) }, { "background-color": bp({ h: t3.h, s: 100, v: 100, a: 1 }) }]), this.el.setAttribute("aria-valuetext", `Saturation ${mp(t3.s)}%, Brightness ${mp(t3.v)}%`);
          }
          getMove(t3, e3) {
            return { s: e3 ? pp(this.hsva.s + 100 * t3.x, 0, 100) : 100 * t3.x, v: e3 ? pp(this.hsva.v - 100 * t3.y, 0, 100) : Math.round(100 - 100 * t3.y) };
          }
        }
        const Np = Symbol("same"), Pp = Symbol("color"), zp = Symbol("hsva"), Op2 = Symbol("update"), Lp = Symbol("parts"), Rp = Symbol("css"), jp = Symbol("sliders");
        class Fp extends HTMLElement {
          static get observedAttributes() {
            return ["color"];
          }
          get [Rp]() {
            return [':host{display:flex;flex-direction:column;position:relative;width:200px;height:200px;user-select:none;-webkit-user-select:none;cursor:default}:host([hidden]){display:none!important}[role=slider]{position:relative;touch-action:none;user-select:none;-webkit-user-select:none;outline:0}[role=slider]:last-child{border-radius:0 0 8px 8px}[part$=pointer]{position:absolute;z-index:1;box-sizing:border-box;width:28px;height:28px;display:flex;place-content:center center;transform:translate(-50%,-50%);background-color:#fff;border:2px solid #fff;border-radius:50%;box-shadow:0 2px 4px rgba(0,0,0,.2)}[part$=pointer]::after{content:"";width:100%;height:100%;border-radius:inherit;background-color:currentColor}[role=slider]:focus [part$=pointer]{transform:translate(-50%,-50%) scale(1.1)}', "[part=hue]{flex:0 0 24px;background:linear-gradient(to right,red 0,#ff0 17%,#0f0 33%,#0ff 50%,#00f 67%,#f0f 83%,red 100%)}[part=hue-pointer]{top:50%;z-index:2}", "[part=saturation]{flex-grow:1;border-color:transparent;border-bottom:12px solid #000;border-radius:8px 8px 0 0;background-image:linear-gradient(to top,#000,transparent),linear-gradient(to right,#fff,rgba(255,255,255,0));box-shadow:inset 0 0 0 1px rgba(0,0,0,.05)}[part=saturation-pointer]{z-index:3}"];
          }
          get [jp]() {
            return [Bp, Mp];
          }
          get color() {
            return this[Pp];
          }
          set color(t3) {
            if (!this[Np](t3)) {
              const e3 = this.colorModel.toHsva(t3);
              this[Op2](e3), this[Pp] = t3;
            }
          }
          constructor() {
            super();
            const t3 = xp(`<style>${this[Rp].join("")}</style>`), e3 = this.attachShadow({ mode: "open" });
            e3.appendChild(t3.content.cloneNode(true)), e3.addEventListener("move", this), this[Lp] = this[jp].map((t4) => new t4(e3));
          }
          connectedCallback() {
            if (this.hasOwnProperty("color")) {
              const t3 = this.color;
              delete this.color, this.color = t3;
            } else
              this.color || (this.color = this.colorModel.defaultColor);
          }
          attributeChangedCallback(t3, e3, n2) {
            const o2 = this.colorModel.fromAttr(n2);
            this[Np](o2) || (this.color = o2);
          }
          handleEvent(t3) {
            const e3 = this[zp], n2 = __spreadValues(__spreadValues({}, e3), t3.detail);
            let o2;
            this[Op2](n2), vp(n2, e3) || this[Np](o2 = this.colorModel.fromHsva(n2)) || (this[Pp] = o2, Ep(this, "color-changed", { value: o2 }));
          }
          [Np](t3) {
            return this.color && this.colorModel.equal(t3, this.color);
          }
          [Op2](t3) {
            this[zp] = t3, this[Lp].forEach((e3) => e3.update(t3));
          }
        }
        const Vp = { defaultColor: "#000", toHsva: (t3) => _p(fp(t3)), fromHsva: ({ h: t3, s: e3, v: n2 }) => Cp(wp({ h: t3, s: e3, v: n2, a: 1 })), equal: (t3, e3) => t3.toLowerCase() === e3.toLowerCase() || vp(fp(t3), fp(e3)), fromAttr: (t3) => t3 };
        class Up extends Fp {
          get colorModel() {
            return Vp;
          }
        }
        customElements.define("hex-color-picker", class extends Up {
        });
        var Hp = n(3398), qp = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Hp.Z, qp);
        Hp.Z.locals;
        W(Di);
        Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        var Gp = n(4157), Wp = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Gp.Z, Wp);
        Gp.Z.locals;
        class Kp {
          constructor(t3) {
            this._components = /* @__PURE__ */ new Map(), this.editor = t3;
          }
          *names() {
            for (const t3 of this._components.values())
              yield t3.originalName;
          }
          add(t3, e3) {
            this._components.set(Zp(t3), { callback: e3, originalName: t3 });
          }
          create(t3) {
            if (!this.has(t3))
              throw new A("componentfactory-item-missing", this, { name: t3 });
            return this._components.get(Zp(t3)).callback(this.editor.locale);
          }
          has(t3) {
            return this._components.has(Zp(t3));
          }
        }
        function Zp(t3) {
          return String(t3).toLowerCase();
        }
        var Yp = n(8793), $p = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Yp.Z, $p);
        Yp.Z.locals;
        var Qp = Object.defineProperty, Jp = Object.getOwnPropertySymbols, Xp = Object.prototype.hasOwnProperty, tm = Object.prototype.propertyIsEnumerable, em = (t3, e3, n2) => e3 in t3 ? Qp(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, nm = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            Xp.call(e3, n2) && em(t3, n2, e3[n2]);
          if (Jp)
            for (var n2 of Jp(e3))
              tm.call(e3, n2) && em(t3, n2, e3[n2]);
          return t3;
        };
        const om = Yo("px"), im = zo.document.body, rm = { top: -99999, left: -99999, name: "arrowless", config: { withArrow: false } }, sm = class extends Ui {
          constructor(t3) {
            super(t3);
            const e3 = this.bindTemplate;
            this.set("top", 0), this.set("left", 0), this.set("position", "arrow_nw"), this.set("isVisible", false), this.set("withArrow", true), this.set("class", void 0), this._pinWhenIsVisibleCallback = null, this.content = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-balloon-panel", e3.to("position", (t4) => `ck-balloon-panel_${t4}`), e3.if("isVisible", "ck-balloon-panel_visible"), e3.if("withArrow", "ck-balloon-panel_with-arrow"), e3.to("class")], style: { top: e3.to("top", om), left: e3.to("left", om) } }, children: this.content });
          }
          show() {
            this.isVisible = true;
          }
          hide() {
            this.isVisible = false;
          }
          attachTo(t3) {
            this.show();
            const e3 = sm.defaultPositions, n2 = Object.assign({}, { element: this.element, positions: [e3.southArrowNorth, e3.southArrowNorthMiddleWest, e3.southArrowNorthMiddleEast, e3.southArrowNorthWest, e3.southArrowNorthEast, e3.northArrowSouth, e3.northArrowSouthMiddleWest, e3.northArrowSouthMiddleEast, e3.northArrowSouthWest, e3.northArrowSouthEast, e3.viewportStickyNorth], limiter: im, fitInViewport: true }, t3), o2 = sm._getOptimalPosition(n2) || rm, i2 = parseInt(o2.left), r2 = parseInt(o2.top), s3 = o2.name, a2 = o2.config || {}, { withArrow: c2 = true } = a2;
            this.top = r2, this.left = i2, this.position = s3, this.withArrow = c2;
          }
          pin(t3) {
            this.unpin(), this._pinWhenIsVisibleCallback = () => {
              this.isVisible ? this._startPinning(t3) : this._stopPinning();
            }, this._startPinning(t3), this.listenTo(this, "change:isVisible", this._pinWhenIsVisibleCallback);
          }
          unpin() {
            this._pinWhenIsVisibleCallback && (this._stopPinning(), this.stopListening(this, "change:isVisible", this._pinWhenIsVisibleCallback), this._pinWhenIsVisibleCallback = null, this.hide());
          }
          _startPinning(t3) {
            this.attachTo(t3);
            const e3 = cm(t3.target), n2 = t3.limiter ? cm(t3.limiter) : im;
            this.listenTo(zo.document, "scroll", (o2, i2) => {
              const r2 = i2.target, s3 = e3 && r2.contains(e3), a2 = n2 && r2.contains(n2);
              !s3 && !a2 && e3 && n2 || this.attachTo(t3);
            }, { useCapture: true }), this.listenTo(zo.window, "resize", () => {
              this.attachTo(t3);
            });
          }
          _stopPinning() {
            this.stopListening(zo.document, "scroll"), this.stopListening(zo.window, "resize");
          }
        };
        let am = sm;
        function cm(t3) {
          return yo(t3) ? t3 : Lo(t3) ? t3.commonAncestorContainer : "function" == typeof t3 ? cm(t3()) : null;
        }
        function lm(t3 = {}) {
          const { sideOffset: e3 = am.arrowSideOffset, heightOffset: n2 = am.arrowHeightOffset, stickyVerticalOffset: o2 = am.stickyVerticalOffset, config: i2 } = t3;
          return { northWestArrowSouthWest: (t4, n3) => nm({ top: r2(t4, n3), left: t4.left - e3, name: "arrow_sw" }, i2 && { config: i2 }), northWestArrowSouthMiddleWest: (t4, n3) => nm({ top: r2(t4, n3), left: t4.left - 0.25 * n3.width - e3, name: "arrow_smw" }, i2 && { config: i2 }), northWestArrowSouth: (t4, e4) => nm({ top: r2(t4, e4), left: t4.left - e4.width / 2, name: "arrow_s" }, i2 && { config: i2 }), northWestArrowSouthMiddleEast: (t4, n3) => nm({ top: r2(t4, n3), left: t4.left - 0.75 * n3.width + e3, name: "arrow_sme" }, i2 && { config: i2 }), northWestArrowSouthEast: (t4, n3) => nm({ top: r2(t4, n3), left: t4.left - n3.width + e3, name: "arrow_se" }, i2 && { config: i2 }), northArrowSouthWest: (t4, n3) => nm({ top: r2(t4, n3), left: t4.left + t4.width / 2 - e3, name: "arrow_sw" }, i2 && { config: i2 }), northArrowSouthMiddleWest: (t4, n3) => nm({ top: r2(t4, n3), left: t4.left + t4.width / 2 - 0.25 * n3.width - e3, name: "arrow_smw" }, i2 && { config: i2 }), northArrowSouth: (t4, e4) => nm({ top: r2(t4, e4), left: t4.left + t4.width / 2 - e4.width / 2, name: "arrow_s" }, i2 && { config: i2 }), northArrowSouthMiddleEast: (t4, n3) => nm({ top: r2(t4, n3), left: t4.left + t4.width / 2 - 0.75 * n3.width + e3, name: "arrow_sme" }, i2 && { config: i2 }), northArrowSouthEast: (t4, n3) => nm({ top: r2(t4, n3), left: t4.left + t4.width / 2 - n3.width + e3, name: "arrow_se" }, i2 && { config: i2 }), northEastArrowSouthWest: (t4, n3) => nm({ top: r2(t4, n3), left: t4.right - e3, name: "arrow_sw" }, i2 && { config: i2 }), northEastArrowSouthMiddleWest: (t4, n3) => nm({ top: r2(t4, n3), left: t4.right - 0.25 * n3.width - e3, name: "arrow_smw" }, i2 && { config: i2 }), northEastArrowSouth: (t4, e4) => nm({ top: r2(t4, e4), left: t4.right - e4.width / 2, name: "arrow_s" }, i2 && { config: i2 }), northEastArrowSouthMiddleEast: (t4, n3) => nm({ top: r2(t4, n3), left: t4.right - 0.75 * n3.width + e3, name: "arrow_sme" }, i2 && { config: i2 }), northEastArrowSouthEast: (t4, n3) => nm({ top: r2(t4, n3), left: t4.right - n3.width + e3, name: "arrow_se" }, i2 && { config: i2 }), southWestArrowNorthWest: (t4) => nm({ top: s3(t4), left: t4.left - e3, name: "arrow_nw" }, i2 && { config: i2 }), southWestArrowNorthMiddleWest: (t4, n3) => nm({ top: s3(t4), left: t4.left - 0.25 * n3.width - e3, name: "arrow_nmw" }, i2 && { config: i2 }), southWestArrowNorth: (t4, e4) => nm({ top: s3(t4), left: t4.left - e4.width / 2, name: "arrow_n" }, i2 && { config: i2 }), southWestArrowNorthMiddleEast: (t4, n3) => nm({ top: s3(t4), left: t4.left - 0.75 * n3.width + e3, name: "arrow_nme" }, i2 && { config: i2 }), southWestArrowNorthEast: (t4, n3) => nm({ top: s3(t4), left: t4.left - n3.width + e3, name: "arrow_ne" }, i2 && { config: i2 }), southArrowNorthWest: (t4) => nm({ top: s3(t4), left: t4.left + t4.width / 2 - e3, name: "arrow_nw" }, i2 && { config: i2 }), southArrowNorthMiddleWest: (t4, n3) => nm({ top: s3(t4), left: t4.left + t4.width / 2 - 0.25 * n3.width - e3, name: "arrow_nmw" }, i2 && { config: i2 }), southArrowNorth: (t4, e4) => nm({ top: s3(t4), left: t4.left + t4.width / 2 - e4.width / 2, name: "arrow_n" }, i2 && { config: i2 }), southArrowNorthMiddleEast: (t4, n3) => nm({ top: s3(t4), left: t4.left + t4.width / 2 - 0.75 * n3.width + e3, name: "arrow_nme" }, i2 && { config: i2 }), southArrowNorthEast: (t4, n3) => nm({ top: s3(t4), left: t4.left + t4.width / 2 - n3.width + e3, name: "arrow_ne" }, i2 && { config: i2 }), southEastArrowNorthWest: (t4) => nm({ top: s3(t4), left: t4.right - e3, name: "arrow_nw" }, i2 && { config: i2 }), southEastArrowNorthMiddleWest: (t4, n3) => nm({ top: s3(t4), left: t4.right - 0.25 * n3.width - e3, name: "arrow_nmw" }, i2 && { config: i2 }), southEastArrowNorth: (t4, e4) => nm({ top: s3(t4), left: t4.right - e4.width / 2, name: "arrow_n" }, i2 && { config: i2 }), southEastArrowNorthMiddleEast: (t4, n3) => nm({ top: s3(t4), left: t4.right - 0.75 * n3.width + e3, name: "arrow_nme" }, i2 && { config: i2 }), southEastArrowNorthEast: (t4, n3) => nm({ top: s3(t4), left: t4.right - n3.width + e3, name: "arrow_ne" }, i2 && { config: i2 }), westArrowEast: (t4, e4) => nm({ top: t4.top + t4.height / 2 - e4.height / 2, left: t4.left - e4.width - n2, name: "arrow_e" }, i2 && { config: i2 }), eastArrowWest: (t4, e4) => nm({ top: t4.top + t4.height / 2 - e4.height / 2, left: t4.right + n2, name: "arrow_w" }, i2 && { config: i2 }), viewportStickyNorth: (t4, e4, n3, r3) => {
            const s4 = r3 || n3;
            return t4.getIntersection(s4) ? s4.height - t4.height > o2 ? null : { top: s4.top + o2, left: t4.left + t4.width / 2 - e4.width / 2, name: "arrowless", config: nm({ withArrow: false }, i2) } : null;
          } };
          function r2(t4, e4) {
            return t4.top - e4.height - n2;
          }
          function s3(t4) {
            return t4.bottom + n2;
          }
        }
        am.arrowSideOffset = 25, am.arrowHeightOffset = 10, am.stickyVerticalOffset = 20, am._getOptimalPosition = ei, am.defaultPositions = lm();
        var dm = n(3332), hm = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(dm.Z, hm);
        dm.Z.locals;
        const um = "ck-tooltip", gm = class extends Mo() {
          constructor(t3) {
            if (super(), this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this._resizeObserver = null, gm._editors.add(t3), gm._instance)
              return gm._instance;
            gm._instance = this, this.tooltipTextView = new Ui(t3.locale), this.tooltipTextView.set("text", ""), this.tooltipTextView.setTemplate({ tag: "span", attributes: { class: ["ck", "ck-tooltip__text"] }, children: [{ text: this.tooltipTextView.bindTemplate.to("text") }] }), this.balloonPanelView = new am(t3.locale), this.balloonPanelView.class = um, this.balloonPanelView.content.add(this.tooltipTextView), this._pinTooltipDebounced = ol(this._pinTooltip, 600), this.listenTo(zo.document, "mouseenter", this._onEnterOrFocus.bind(this), { useCapture: true }), this.listenTo(zo.document, "mouseleave", this._onLeaveOrBlur.bind(this), { useCapture: true }), this.listenTo(zo.document, "focus", this._onEnterOrFocus.bind(this), { useCapture: true }), this.listenTo(zo.document, "blur", this._onLeaveOrBlur.bind(this), { useCapture: true }), this.listenTo(zo.document, "scroll", this._onScroll.bind(this), { useCapture: true }), this._watchdogExcluded = true;
          }
          destroy(t3) {
            const e3 = t3.ui.view && t3.ui.view.body;
            gm._editors.delete(t3), this.stopListening(t3.ui), e3 && e3.has(this.balloonPanelView) && e3.remove(this.balloonPanelView), gm._editors.size || (this._unpinTooltip(), this.balloonPanelView.destroy(), this.stopListening(), gm._instance = null);
          }
          static getPositioningFunctions(t3) {
            const e3 = gm.defaultBalloonPositions;
            return { s: [e3.southArrowNorth, e3.southArrowNorthEast, e3.southArrowNorthWest], n: [e3.northArrowSouth], e: [e3.eastArrowWest], w: [e3.westArrowEast], sw: [e3.southArrowNorthEast], se: [e3.southArrowNorthWest] }[t3];
          }
          _onEnterOrFocus(t3, { target: e3 }) {
            const n2 = mm(e3);
            var o2;
            n2 && (n2 !== this._currentElementWithTooltip && (this._unpinTooltip(), this._pinTooltipDebounced(n2, { text: (o2 = n2).dataset.ckeTooltipText, position: o2.dataset.ckeTooltipPosition || "s", cssClass: o2.dataset.ckeTooltipClass || "" })));
          }
          _onLeaveOrBlur(t3, { target: e3, relatedTarget: n2 }) {
            if ("mouseleave" === t3.name) {
              if (!yo(e3))
                return;
              if (this._currentElementWithTooltip && e3 !== this._currentElementWithTooltip)
                return;
              const t4 = mm(e3), o2 = mm(n2);
              t4 && t4 !== o2 && this._unpinTooltip();
            } else {
              if (this._currentElementWithTooltip && e3 !== this._currentElementWithTooltip)
                return;
              this._unpinTooltip();
            }
          }
          _onScroll(t3, { target: e3 }) {
            this._currentElementWithTooltip && (e3.contains(this.balloonPanelView.element) && e3.contains(this._currentElementWithTooltip) || this._unpinTooltip());
          }
          _pinTooltip(t3, { text: e3, position: n2, cssClass: o2 }) {
            const i2 = Ii(gm._editors.values()).ui.view.body;
            i2.has(this.balloonPanelView) || i2.add(this.balloonPanelView), this.tooltipTextView.text = e3, this.balloonPanelView.pin({ target: t3, positions: gm.getPositioningFunctions(n2) }), this._resizeObserver = new Ko(t3, () => {
              Xo(t3) || this._unpinTooltip();
            }), this.balloonPanelView.class = [um, o2].filter((t4) => t4).join(" ");
            for (const t4 of gm._editors)
              this.listenTo(t4.ui, "update", this._updateTooltipPosition.bind(this), { priority: "low" });
            this._currentElementWithTooltip = t3, this._currentTooltipPosition = n2;
          }
          _unpinTooltip() {
            this._pinTooltipDebounced.cancel(), this.balloonPanelView.unpin();
            for (const t3 of gm._editors)
              this.stopListening(t3.ui, "update");
            this._currentElementWithTooltip = null, this._currentTooltipPosition = null, this._resizeObserver && this._resizeObserver.destroy();
          }
          _updateTooltipPosition() {
            Xo(this._currentElementWithTooltip) ? this.balloonPanelView.pin({ target: this._currentElementWithTooltip, positions: gm.getPositioningFunctions(this._currentTooltipPosition) }) : this._unpinTooltip();
          }
        };
        let pm = gm;
        function mm(t3) {
          return yo(t3) ? t3.closest("[data-cke-tooltip-text]:not([data-cke-tooltip-disabled])") : null;
        }
        pm.defaultBalloonPositions = lm({ heightOffset: 5, sideOffset: 13 }), pm._editors = /* @__PURE__ */ new Set(), pm._instance = null;
        const fm = function(t3, e3, n2) {
          var o2 = true, i2 = true;
          if ("function" != typeof t3)
            throw new TypeError("Expected a function");
          return j(n2) && (o2 = "leading" in n2 ? !!n2.leading : o2, i2 = "trailing" in n2 ? !!n2.trailing : i2), ol(t3, e3, { leading: o2, maxWait: e3, trailing: i2 });
        };
        var km = Object.defineProperty, bm = Object.getOwnPropertySymbols, wm = Object.prototype.hasOwnProperty, Am = Object.prototype.propertyIsEnumerable, Cm = (t3, e3, n2) => e3 in t3 ? km(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, _m = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            wm.call(e3, n2) && Cm(t3, n2, e3[n2]);
          if (bm)
            for (var n2 of bm(e3))
              Am.call(e3, n2) && Cm(t3, n2, e3[n2]);
          return t3;
        };
        const vm = 50, ym = 350, xm = "Powered by";
        class Em extends Mo() {
          constructor(t3) {
            super(), this.editor = t3, this._balloonView = null, this._lastFocusedEditableElement = null, this._showBalloonThrottled = fm(this._showBalloon.bind(this), 50, { leading: true }), t3.on("ready", this._handleEditorReady.bind(this));
          }
          destroy() {
            const t3 = this._balloonView;
            t3 && (t3.unpin(), this._balloonView = null), this._showBalloonThrottled.cancel(), this.stopListening();
          }
          _handleEditorReady() {
            const t3 = this.editor;
            (!!t3.config.get("ui.poweredBy.forceVisible") || "VALID" !== function(t4) {
              function e3(t5) {
                return t5.length >= 40 && t5.length <= 255 ? "VALID" : "INVALID";
              }
              if (!t4)
                return "INVALID";
              let n2 = "";
              try {
                n2 = atob(t4);
              } catch (t5) {
                return "INVALID";
              }
              const o2 = n2.split("-"), i2 = o2[0], r2 = o2[1];
              if (!r2)
                return e3(t4);
              try {
                atob(r2);
              } catch (n3) {
                try {
                  if (atob(i2), !atob(i2).length)
                    return e3(t4);
                } catch (n4) {
                  return e3(t4);
                }
              }
              if (i2.length < 40 || i2.length > 255)
                return "INVALID";
              let s3 = "";
              try {
                atob(i2), s3 = atob(r2);
              } catch (t5) {
                return "INVALID";
              }
              if (8 !== s3.length)
                return "INVALID";
              const a2 = Number(s3.substring(0, 4)), c2 = Number(s3.substring(4, 6)) - 1, l2 = Number(s3.substring(6, 8)), d2 = new Date(a2, c2, l2);
              return d2 < E || isNaN(Number(d2)) ? "INVALID" : "VALID";
            }(t3.config.get("licenseKey"))) && t3.ui.view && (t3.ui.focusTracker.on("change:isFocused", (t4, e3, n2) => {
              this._updateLastFocusedEditableElement(), n2 ? this._showBalloon() : this._hideBalloon();
            }), t3.ui.focusTracker.on("change:focusedElement", (t4, e3, n2) => {
              this._updateLastFocusedEditableElement(), n2 && this._showBalloon();
            }), t3.ui.on("update", () => {
              this._showBalloonThrottled();
            }));
          }
          _createBalloonView() {
            const t3 = this.editor, e3 = this._balloonView = new am(), n2 = Sm(t3), o2 = new Dm(t3.locale, n2.label);
            e3.content.add(o2), e3.set({ class: "ck-powered-by-balloon" }), t3.ui.view.body.add(e3), t3.ui.focusTracker.add(e3.element), this._balloonView = e3;
          }
          _showBalloon() {
            if (!this._lastFocusedEditableElement)
              return;
            const t3 = function(t4, e3) {
              const n2 = Sm(t4), o2 = "right" === n2.side ? function(t5, e4) {
                return Im(t5, e4, (t6, n3) => t6.left + t6.width - n3.width - e4.horizontalOffset);
              }(e3, n2) : function(t5, e4) {
                return Im(t5, e4, (t6) => t6.left + e4.horizontalOffset);
              }(e3, n2);
              return { target: e3, positions: [o2] };
            }(this.editor, this._lastFocusedEditableElement);
            t3 && (this._balloonView || this._createBalloonView(), this._balloonView.pin(t3));
          }
          _hideBalloon() {
            this._balloonView && this._balloonView.unpin();
          }
          _updateLastFocusedEditableElement() {
            const t3 = this.editor, e3 = t3.ui.focusTracker.isFocused, n2 = t3.ui.focusTracker.focusedElement;
            if (!e3 || !n2)
              return void (this._lastFocusedEditableElement = null);
            const o2 = Array.from(t3.ui.getEditableElementsNames()).map((e4) => t3.ui.getEditableElement(e4));
            o2.includes(n2) ? this._lastFocusedEditableElement = n2 : this._lastFocusedEditableElement = o2[0];
          }
        }
        class Dm extends Ui {
          constructor(t3, e3) {
            super(t3);
            const n2 = new pr(), o2 = this.bindTemplate;
            n2.set({ content: '<svg xmlns="http://www.w3.org/2000/svg" width="53" height="10" viewBox="0 0 53 10"><path fill="#1C2331" d="M31.724 1.492a15.139 15.139 0 0 0 .045 1.16 2.434 2.434 0 0 0-.687-.34 3.68 3.68 0 0 0-1.103-.166 2.332 2.332 0 0 0-1.14.255 1.549 1.549 0 0 0-.686.87c-.15.41-.225.98-.225 1.712 0 .939.148 1.659.444 2.161.297.503.792.754 1.487.754.452.015.9-.094 1.294-.316.296-.174.557-.4.771-.669l.14.852h1.282V.007h-1.623v1.485ZM31 6.496a1.77 1.77 0 0 1-.494.061.964.964 0 0 1-.521-.127.758.758 0 0 1-.296-.466 3.984 3.984 0 0 1-.093-.992 4.208 4.208 0 0 1 .098-1.052.753.753 0 0 1 .307-.477 1.08 1.08 0 0 1 .55-.122c.233-.004.466.026.69.089l.483.144v2.553c-.11.076-.213.143-.307.2a1.73 1.73 0 0 1-.417.189ZM35.68 0l-.702.004c-.322.002-.482.168-.48.497l.004.581c.002.33.164.493.486.49l.702-.004c.322-.002.481-.167.48-.496L36.165.49c-.002-.33-.164-.493-.486-.491ZM36.145 2.313l-1.612.01.034 5.482 1.613-.01-.035-5.482ZM39.623.79 37.989.8 38 2.306l-.946.056.006 1.009.949-.006.024 2.983c.003.476.143.844.419 1.106.275.26.658.39 1.148.387.132 0 .293-.01.483-.03.19-.02.38-.046.57-.08.163-.028.324-.068.482-.119l-.183-1.095-.702.004a.664.664 0 0 1-.456-.123.553.553 0 0 1-.14-.422l-.016-2.621 1.513-.01-.006-1.064-1.514.01-.01-1.503ZM46.226 2.388c-.41-.184-.956-.274-1.636-.27-.673.004-1.215.101-1.627.29-.402.179-.72.505-.888.91-.18.419-.268.979-.264 1.68.004.688.1 1.24.285 1.655.172.404.495.724.9.894.414.18.957.268 1.63.264.68-.004 1.224-.099 1.632-.284.4-.176.714-.501.878-.905.176-.418.263-.971.258-1.658-.004-.702-.097-1.261-.28-1.677a1.696 1.696 0 0 0-.888-.9Zm-.613 3.607a.77.77 0 0 1-.337.501 1.649 1.649 0 0 1-1.317.009.776.776 0 0 1-.343-.497 4.066 4.066 0 0 1-.105-1.02 4.136 4.136 0 0 1 .092-1.03.786.786 0 0 1 .337-.507 1.59 1.59 0 0 1 1.316-.008.79.79 0 0 1 .344.502c.078.337.113.683.105 1.03.012.343-.019.685-.092 1.02ZM52.114 2.07a2.67 2.67 0 0 0-1.128.278c-.39.191-.752.437-1.072.73l-.157-.846-1.273.008.036 5.572 1.623-.01-.024-3.78c.35-.124.646-.22.887-.286.26-.075.53-.114.8-.118l.45-.003.144-1.546-.286.001ZM22.083 7.426l-1.576-2.532a2.137 2.137 0 0 0-.172-.253 1.95 1.95 0 0 0-.304-.29.138.138 0 0 1 .042-.04 1.7 1.7 0 0 0 .328-.374l1.75-2.71c.01-.015.025-.028.024-.048-.01-.01-.021-.007-.031-.007L20.49 1.17a.078.078 0 0 0-.075.045l-.868 1.384c-.23.366-.46.732-.688 1.099a.108.108 0 0 1-.112.06c-.098-.005-.196-.001-.294-.002-.018 0-.038.006-.055-.007.002-.02.002-.039.005-.058a4.6 4.6 0 0 0 .046-.701V1.203c0-.02-.009-.032-.03-.03h-.033L16.93 1.17c-.084 0-.073-.01-.073.076v6.491c-.001.018.006.028.025.027h1.494c.083 0 .072.007.072-.071v-2.19c0-.055-.003-.11-.004-.166a3.366 3.366 0 0 0-.05-.417h.06c.104 0 .209.002.313-.002a.082.082 0 0 1 .084.05c.535.913 1.07 1.824 1.607 2.736a.104.104 0 0 0 .103.062c.554-.003 1.107-.002 1.66-.002l.069-.003-.019-.032-.188-.304ZM27.112 6.555c-.005-.08-.004-.08-.082-.08h-2.414c-.053 0-.106-.003-.159-.011a.279.279 0 0 1-.246-.209.558.558 0 0 1-.022-.15c0-.382 0-.762-.002-1.143 0-.032.007-.049.042-.044h2.504c.029.003.037-.012.034-.038V3.814c0-.089.013-.078-.076-.078h-2.44c-.07 0-.062.003-.062-.06v-.837c0-.047.004-.093.013-.14a.283.283 0 0 1 .241-.246.717.717 0 0 1 .146-.011h2.484c.024.002.035-.009.036-.033l.003-.038.03-.496c.01-.183.024-.365.034-.548.005-.085.003-.087-.082-.094-.218-.018-.437-.038-.655-.05a17.845 17.845 0 0 0-.657-.026 72.994 72.994 0 0 0-1.756-.016 1.7 1.7 0 0 0-.471.064 1.286 1.286 0 0 0-.817.655c-.099.196-.149.413-.145.633v3.875c0 .072.003.144.011.216a1.27 1.27 0 0 0 .711 1.029c.228.113.48.167.734.158.757-.005 1.515.002 2.272-.042.274-.016.548-.034.82-.053.03-.002.043-.008.04-.041-.008-.104-.012-.208-.019-.312a69.964 69.964 0 0 1-.05-.768ZM16.14 7.415l-.127-1.075c-.004-.03-.014-.04-.044-.037a13.125 13.125 0 0 1-.998.073c-.336.01-.672.02-1.008.016-.116-.001-.233-.014-.347-.039a.746.746 0 0 1-.45-.262c-.075-.1-.132-.211-.167-.33a3.324 3.324 0 0 1-.126-.773 9.113 9.113 0 0 1-.015-.749c0-.285.022-.57.065-.852.023-.158.066-.312.127-.46a.728.728 0 0 1 .518-.443 1.64 1.64 0 0 1 .397-.048c.628-.001 1.255.003 1.882.05.022.001.033-.006.036-.026l.003-.031.06-.55c.019-.177.036-.355.057-.532.004-.034-.005-.046-.04-.056a5.595 5.595 0 0 0-1.213-.21 10.783 10.783 0 0 0-.708-.02c-.24-.003-.48.01-.719.041a3.477 3.477 0 0 0-.625.14 1.912 1.912 0 0 0-.807.497c-.185.2-.33.433-.424.688a4.311 4.311 0 0 0-.24 1.096c-.031.286-.045.572-.042.86-.006.43.024.86.091 1.286.04.25.104.497.193.734.098.279.26.53.473.734.214.205.473.358.756.446.344.11.702.17 1.063.177a8.505 8.505 0 0 0 1.578-.083 6.11 6.11 0 0 0 .766-.18c.03-.008.047-.023.037-.057a.157.157 0 0 1-.003-.025Z"/><path fill="#AFE229" d="M6.016 6.69a1.592 1.592 0 0 0-.614.21c-.23.132-.422.32-.56.546-.044.072-.287.539-.287.539l-.836 1.528.009.006c.038.025.08.046.123.063.127.046.26.07.395.073.505.023 1.011-.007 1.517-.003.29.009.58.002.869-.022a.886.886 0 0 0 .395-.116.962.962 0 0 0 .312-.286c.056-.083.114-.163.164-.249.24-.408.48-.816.718-1.226.075-.128.148-.257.222-.386l.112-.192a1.07 1.07 0 0 0 .153-.518l-1.304.023s-1.258-.005-1.388.01Z"/><path fill="#771BFF" d="m2.848 9.044.76-1.39.184-.352c-.124-.067-.245-.14-.367-.21-.346-.204-.706-.384-1.045-.6a.984.984 0 0 1-.244-.207c-.108-.134-.136-.294-.144-.46-.021-.409-.002-.818-.009-1.227-.003-.195 0-.39.003-.585.004-.322.153-.553.427-.713l.833-.488c.22-.13.44-.257.662-.385.05-.029.105-.052.158-.077.272-.128.519-.047.76.085l.044.028c.123.06.242.125.358.196.318.178.635.357.952.537.095.056.187.117.275.184.194.144.254.35.266.578.016.284.007.569.006.853-.001.28.004.558 0 .838.592-.003 1.259 0 1.259 0l.723-.013c-.003-.292-.007-.584-.007-.876 0-.524.015-1.048-.016-1.571-.024-.42-.135-.8-.492-1.067a5.02 5.02 0 0 0-.506-.339A400.52 400.52 0 0 0 5.94.787C5.722.664 5.513.524 5.282.423 5.255.406 5.228.388 5.2.373 4.758.126 4.305-.026 3.807.21c-.097.046-.197.087-.29.14A699.896 699.896 0 0 0 .783 1.948c-.501.294-.773.717-.778 1.31-.004.36-.009.718-.001 1.077.016.754-.017 1.508.024 2.261.016.304.07.6.269.848.127.15.279.28.448.382.622.4 1.283.734 1.92 1.11l.183.109Z"/></svg>\n', isColorInherited: false }), n2.extendTemplate({ attributes: { style: { width: "53px", height: "10px" } } }), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-powered-by"], "aria-hidden": true }, children: [{ tag: "a", attributes: { href: "https://ckeditor.com/?utm_source=ckeditor&utm_medium=referral&utm_campaign=701Dn000000hVgmIAE_powered_by_ckeditor_logo", target: "_blank", tabindex: "-1" }, children: [...e3 ? [{ tag: "span", attributes: { class: ["ck", "ck-powered-by__label"] }, children: [e3] }] : [], n2], on: { dragstart: o2.to((t4) => t4.preventDefault()) } }] });
          }
        }
        function Im(t3, e3, n2) {
          return (o2, i2) => {
            const r2 = new Vo(t3);
            if (r2.width < ym || r2.height < vm)
              return null;
            let s3;
            s3 = "inside" === e3.position ? r2.bottom - i2.height : r2.bottom - i2.height / 2, s3 -= e3.verticalOffset;
            const a2 = n2(r2, i2), c2 = o2.clone().moveTo(a2, s3).getIntersection(i2.clone().moveTo(a2, s3)).getVisible();
            return !c2 || c2.getArea() < i2.getArea() ? null : { top: s3, left: a2, name: `position_${e3.position}-side_${e3.side}`, config: { withArrow: false } };
          };
        }
        function Sm(t3) {
          const e3 = t3.config.get("ui.poweredBy"), n2 = e3 && e3.position || "border";
          return _m({ position: n2, label: xm, verticalOffset: "inside" === n2 ? 5 : 0, horizontalOffset: 5, side: "ltr" === t3.locale.contentLanguageDirection ? "right" : "left" }, e3);
        }
        var Tm = n(3210), Mm = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Tm.Z, Mm);
        Tm.Z.locals;
        class Bm {
          constructor(t3) {
            this.editor = t3;
          }
          announce(t3, e3, n2 = "polite") {
            const o2 = this.editor;
            this.view || (this.view = new Nm(o2.locale), o2.ui.view.body.add(this.view));
            let i2 = this.view.regionViews.find((e4) => e4.regionName === t3);
            i2 || (i2 = new Pm(this.view.locale), this.view.regionViews.add(i2)), i2.set({ regionName: t3, text: e3, politeness: n2 });
          }
        }
        class Nm extends Ui {
          constructor(t3) {
            super(t3), this.regionViews = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-aria-live-announcer"] }, children: this.regionViews });
          }
        }
        class Pm extends Ui {
          constructor(t3) {
            super(t3);
            const e3 = this.bindTemplate;
            this.set("regionName", ""), this.set("text", ""), this.set("politeness", "polite"), this.setTemplate({ tag: "div", attributes: { role: "region", "data-region": e3.to("regionName"), "aria-live": e3.to("politeness") }, children: [{ text: e3.to("text") }] });
          }
        }
        var zm = Object.defineProperty, Om = Object.getOwnPropertySymbols, Lm = Object.prototype.hasOwnProperty, Rm = Object.prototype.propertyIsEnumerable, jm = (t3, e3, n2) => e3 in t3 ? zm(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2;
        class Fm extends W() {
          constructor(t3) {
            super(), this.isReady = false, this._editableElementsMap = /* @__PURE__ */ new Map(), this._focusableToolbarDefinitions = [];
            const e3 = t3.editing.view;
            this.editor = t3, this.componentFactory = new Kp(t3), this.focusTracker = new Si(), this.tooltipManager = new pm(t3), this.poweredBy = new Em(t3), this.ariaLiveAnnouncer = new Bm(t3), this.set("viewportOffset", this._readViewportOffsetFromConfig()), this.once("ready", () => {
              this.isReady = true;
            }), this.listenTo(e3.document, "layoutChanged", this.update.bind(this)), this.listenTo(e3, "scrollToTheSelection", this._handleScrollToTheSelection.bind(this)), this._initFocusTracking();
          }
          get element() {
            return null;
          }
          update() {
            this.fire("update");
          }
          destroy() {
            this.stopListening(), this.focusTracker.destroy(), this.tooltipManager.destroy(this.editor), this.poweredBy.destroy();
            for (const t3 of this._editableElementsMap.values())
              t3.ckeditorInstance = null, this.editor.keystrokes.stopListening(t3);
            this._editableElementsMap = /* @__PURE__ */ new Map(), this._focusableToolbarDefinitions = [];
          }
          setEditableElement(t3, e3) {
            this._editableElementsMap.set(t3, e3), e3.ckeditorInstance || (e3.ckeditorInstance = this.editor), this.focusTracker.add(e3);
            const n2 = () => {
              this.editor.editing.view.getDomRoot(t3) || this.editor.keystrokes.listenTo(e3);
            };
            this.isReady ? n2() : this.once("ready", n2);
          }
          removeEditableElement(t3) {
            const e3 = this._editableElementsMap.get(t3);
            e3 && (this._editableElementsMap.delete(t3), this.editor.keystrokes.stopListening(e3), this.focusTracker.remove(e3), e3.ckeditorInstance = null);
          }
          getEditableElement(t3 = "main") {
            return this._editableElementsMap.get(t3);
          }
          getEditableElementsNames() {
            return this._editableElementsMap.keys();
          }
          addToolbar(t3, e3 = {}) {
            t3.isRendered ? (this.focusTracker.add(t3.element), this.editor.keystrokes.listenTo(t3.element)) : t3.once("render", () => {
              this.focusTracker.add(t3.element), this.editor.keystrokes.listenTo(t3.element);
            }), this._focusableToolbarDefinitions.push({ toolbarView: t3, options: e3 });
          }
          get _editableElements() {
            return console.warn("editor-ui-deprecated-editable-elements: The EditorUI#_editableElements property has been deprecated and will be removed in the near future.", { editorUI: this }), this._editableElementsMap;
          }
          _readViewportOffsetFromConfig() {
            const t3 = this.editor, e3 = t3.config.get("ui.viewportOffset");
            if (e3)
              return e3;
            const n2 = t3.config.get("toolbar.viewportTopOffset");
            return n2 ? (console.warn("editor-ui-deprecated-viewport-offset-config: The `toolbar.vieportTopOffset` configuration option is deprecated. It will be removed from future CKEditor versions. Use `ui.viewportOffset.top` instead."), { top: n2 }) : { top: 0 };
          }
          _initFocusTracking() {
            const t3 = this.editor, e3 = t3.editing.view;
            let n2, o2;
            t3.keystrokes.set("Alt+F10", (t4, i2) => {
              const r2 = this.focusTracker.focusedElement;
              Array.from(this._editableElementsMap.values()).includes(r2) && !Array.from(e3.domRoots.values()).includes(r2) && (n2 = r2);
              const s3 = this._getCurrentFocusedToolbarDefinition();
              s3 && o2 || (o2 = this._getFocusableCandidateToolbarDefinitions());
              for (let t5 = 0; t5 < o2.length; t5++) {
                const t6 = o2.shift();
                if (o2.push(t6), t6 !== s3 && this._focusFocusableCandidateToolbar(t6)) {
                  s3 && s3.options.afterBlur && s3.options.afterBlur();
                  break;
                }
              }
              i2();
            }), t3.keystrokes.set("Esc", (e4, o3) => {
              const i2 = this._getCurrentFocusedToolbarDefinition();
              i2 && (n2 ? (n2.focus(), n2 = null) : t3.editing.view.focus(), i2.options.afterBlur && i2.options.afterBlur(), o3());
            });
          }
          _getFocusableCandidateToolbarDefinitions() {
            const t3 = [];
            for (const e3 of this._focusableToolbarDefinitions) {
              const { toolbarView: n2, options: o2 } = e3;
              (Xo(n2.element) || o2.beforeFocus) && t3.push(e3);
            }
            return t3.sort((t4, e3) => Vm(t4) - Vm(e3)), t3;
          }
          _getCurrentFocusedToolbarDefinition() {
            for (const t3 of this._focusableToolbarDefinitions)
              if (t3.toolbarView.element && t3.toolbarView.element.contains(this.focusTracker.focusedElement))
                return t3;
            return null;
          }
          _focusFocusableCandidateToolbar(t3) {
            const { toolbarView: e3, options: { beforeFocus: n2 } } = t3;
            return n2 && n2(), !!Xo(e3.element) && (e3.focus(), true);
          }
          _handleScrollToTheSelection(t3, e3) {
            const n2 = ((t4, e4) => {
              for (var n3 in e4 || (e4 = {}))
                Lm.call(e4, n3) && jm(t4, n3, e4[n3]);
              if (Om)
                for (var n3 of Om(e4))
                  Rm.call(e4, n3) && jm(t4, n3, e4[n3]);
              return t4;
            })({ top: 0, bottom: 0, left: 0, right: 0 }, this.viewportOffset);
            e3.viewportOffset.top += n2.top, e3.viewportOffset.bottom += n2.bottom, e3.viewportOffset.left += n2.left, e3.viewportOffset.right += n2.right;
          }
        }
        function Vm(t3) {
          const { toolbarView: e3, options: n2 } = t3;
          let o2 = 10;
          return Xo(e3.element) && o2--, n2.isContextual && o2--, o2;
        }
        var Um = n(9688), Hm = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Um.Z, Hm);
        Um.Z.locals;
        class qm extends Ui {
          constructor(t3) {
            super(t3), this.body = new dr(t3);
          }
          render() {
            super.render(), this.body.attachToDom();
          }
          destroy() {
            return this.body.detachFromDom(), super.destroy();
          }
        }
        class Gm extends qm {
          constructor(t3) {
            super(t3), this.top = this.createCollection(), this.main = this.createCollection(), this._voiceLabelView = this._createVoiceLabel(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-reset", "ck-editor", "ck-rounded-corners"], role: "application", dir: t3.uiLanguageDirection, lang: t3.uiLanguage, "aria-labelledby": this._voiceLabelView.id }, children: [this._voiceLabelView, { tag: "div", attributes: { class: ["ck", "ck-editor__top", "ck-reset_all"], role: "presentation" }, children: this.top }, { tag: "div", attributes: { class: ["ck", "ck-editor__main"], role: "presentation" }, children: this.main }] });
          }
          _createVoiceLabel() {
            const t3 = this.t, e3 = new Er();
            return e3.text = t3("Rich Text Editor"), e3.extendTemplate({ attributes: { class: "ck-voice-label" } }), e3;
          }
        }
        class Wm extends Ui {
          constructor(t3, e3, n2) {
            super(t3), this.name = null, this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-content", "ck-editor__editable", "ck-rounded-corners"], lang: t3.contentLanguage, dir: t3.contentLanguageDirection } }), this.set("isFocused", false), this._editableElement = n2, this._hasExternalElement = !!this._editableElement, this._editingView = e3;
          }
          render() {
            super.render(), this._hasExternalElement ? this.template.apply(this.element = this._editableElement) : this._editableElement = this.element, this.on("change:isFocused", () => this._updateIsFocusedClasses()), this._updateIsFocusedClasses();
          }
          destroy() {
            this._hasExternalElement && this.template.revert(this._editableElement), super.destroy();
          }
          get hasExternalElement() {
            return this._hasExternalElement;
          }
          _updateIsFocusedClasses() {
            const t3 = this._editingView;
            function e3(e4) {
              t3.change((n2) => {
                const o2 = t3.document.getRoot(e4.name);
                n2.addClass(e4.isFocused ? "ck-focused" : "ck-blurred", o2), n2.removeClass(e4.isFocused ? "ck-blurred" : "ck-focused", o2);
              });
            }
            t3.isRenderingInProgress ? function n2(o2) {
              t3.once("change:isRenderingInProgress", (t4, i2, r2) => {
                r2 ? n2(o2) : e3(o2);
              });
            }(this) : e3(this);
          }
        }
        class Km extends Wm {
          constructor(t3, e3, n2, o2 = {}) {
            super(t3, e3, n2);
            const i2 = t3.t;
            this.extendTemplate({ attributes: { role: "textbox", class: "ck-editor__editable_inline" } }), this._generateLabel = o2.label || (() => i2("Editor editing area: %0", this.name));
          }
          render() {
            super.render();
            const t3 = this._editingView;
            t3.change((e3) => {
              const n2 = t3.document.getRoot(this.name);
              e3.setAttribute("aria-label", this._generateLabel(this), n2);
            });
          }
        }
        var Zm = n(8847), Ym = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Zm.Z, Ym);
        Zm.Z.locals;
        class $m extends cs {
          static get pluginName() {
            return "Notification";
          }
          init() {
            this.on("show:warning", (t3, e3) => {
              window.alert(e3.message);
            }, { priority: "lowest" });
          }
          showSuccess(t3, e3 = {}) {
            this._showNotification({ message: t3, type: "success", namespace: e3.namespace, title: e3.title });
          }
          showInfo(t3, e3 = {}) {
            this._showNotification({ message: t3, type: "info", namespace: e3.namespace, title: e3.title });
          }
          showWarning(t3, e3 = {}) {
            this._showNotification({ message: t3, type: "warning", namespace: e3.namespace, title: e3.title });
          }
          _showNotification(t3) {
            const e3 = t3.namespace ? `show:${t3.type}:${t3.namespace}` : `show:${t3.type}`;
            this.fire(e3, { message: t3.message, type: t3.type, title: t3.title || "" });
          }
        }
        class Qm extends W() {
          constructor(t3, e3) {
            super(), e3 && Vc(this, e3), t3 && this.set(t3);
          }
        }
        var Jm = n(4650), Xm = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Jm.Z, Xm);
        Jm.Z.locals;
        var tf = n(7676), ef = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(tf.Z, ef);
        tf.Z.locals;
        const nf = Yo("px");
        class of extends es {
          constructor(t3) {
            super(t3), this._viewToStack = /* @__PURE__ */ new Map(), this._idToStack = /* @__PURE__ */ new Map(), this._view = null, this._rotatorView = null, this._fakePanelsView = null, this.positionLimiter = () => {
              const t4 = this.editor.editing.view, e3 = t4.document.selection.editableElement;
              return e3 ? t4.domConverter.mapViewToDom(e3.root) : null;
            }, this.set("visibleView", null), this.set("_numberOfStacks", 0), this.set("_singleViewMode", false);
          }
          static get pluginName() {
            return "ContextualBalloon";
          }
          destroy() {
            super.destroy(), this._view && this._view.destroy(), this._rotatorView && this._rotatorView.destroy(), this._fakePanelsView && this._fakePanelsView.destroy();
          }
          get view() {
            return this._view || this._createPanelView(), this._view;
          }
          hasView(t3) {
            return Array.from(this._viewToStack.keys()).includes(t3);
          }
          add(t3) {
            if (this._view || this._createPanelView(), this.hasView(t3.view))
              throw new A("contextualballoon-add-view-exist", [this, t3]);
            const e3 = t3.stackId || "main";
            if (!this._idToStack.has(e3))
              return this._idToStack.set(e3, /* @__PURE__ */ new Map([[t3.view, t3]])), this._viewToStack.set(t3.view, this._idToStack.get(e3)), this._numberOfStacks = this._idToStack.size, void (this._visibleStack && !t3.singleViewMode || this.showStack(e3));
            const n2 = this._idToStack.get(e3);
            t3.singleViewMode && this.showStack(e3), n2.set(t3.view, t3), this._viewToStack.set(t3.view, n2), n2 === this._visibleStack && this._showView(t3);
          }
          remove(t3) {
            if (!this.hasView(t3))
              throw new A("contextualballoon-remove-view-not-exist", [this, t3]);
            const e3 = this._viewToStack.get(t3);
            this._singleViewMode && this.visibleView === t3 && (this._singleViewMode = false), this.visibleView === t3 && (1 === e3.size ? this._idToStack.size > 1 ? this._showNextStack() : (this.view.hide(), this.visibleView = null, this._rotatorView.hideView()) : this._showView(Array.from(e3.values())[e3.size - 2])), 1 === e3.size ? (this._idToStack.delete(this._getStackId(e3)), this._numberOfStacks = this._idToStack.size) : e3.delete(t3), this._viewToStack.delete(t3);
          }
          updatePosition(t3) {
            t3 && (this._visibleStack.get(this.visibleView).position = t3), this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition();
          }
          showStack(t3) {
            this.visibleStack = t3;
            const e3 = this._idToStack.get(t3);
            if (!e3)
              throw new A("contextualballoon-showstack-stack-not-exist", this);
            this._visibleStack !== e3 && this._showView(Array.from(e3.values()).pop());
          }
          _createPanelView() {
            this._view = new am(this.editor.locale), this.editor.ui.view.body.add(this._view), this.editor.ui.focusTracker.add(this._view.element), this._rotatorView = this._createRotatorView(), this._fakePanelsView = this._createFakePanelsView();
          }
          get _visibleStack() {
            return this._viewToStack.get(this.visibleView);
          }
          _getStackId(t3) {
            return Array.from(this._idToStack.entries()).find((e3) => e3[1] === t3)[0];
          }
          _showNextStack() {
            const t3 = Array.from(this._idToStack.values());
            let e3 = t3.indexOf(this._visibleStack) + 1;
            t3[e3] || (e3 = 0), this.showStack(this._getStackId(t3[e3]));
          }
          _showPrevStack() {
            const t3 = Array.from(this._idToStack.values());
            let e3 = t3.indexOf(this._visibleStack) - 1;
            t3[e3] || (e3 = t3.length - 1), this.showStack(this._getStackId(t3[e3]));
          }
          _createRotatorView() {
            const t3 = new rf(this.editor.locale), e3 = this.editor.locale.t;
            return this.view.content.add(t3), t3.bind("isNavigationVisible").to(this, "_numberOfStacks", this, "_singleViewMode", (t4, e4) => !e4 && t4 > 1), t3.on("change:isNavigationVisible", () => this.updatePosition(), { priority: "low" }), t3.bind("counter").to(this, "visibleView", this, "_numberOfStacks", (t4, n2) => {
              if (n2 < 2)
                return "";
              const o2 = Array.from(this._idToStack.values()).indexOf(this._visibleStack) + 1;
              return e3("%0 of %1", [o2, n2]);
            }), t3.buttonNextView.on("execute", () => {
              t3.focusTracker.isFocused && this.editor.editing.view.focus(), this._showNextStack();
            }), t3.buttonPrevView.on("execute", () => {
              t3.focusTracker.isFocused && this.editor.editing.view.focus(), this._showPrevStack();
            }), t3;
          }
          _createFakePanelsView() {
            const t3 = new sf(this.editor.locale, this.view);
            return t3.bind("numberOfPanels").to(this, "_numberOfStacks", this, "_singleViewMode", (t4, e3) => !e3 && t4 >= 2 ? Math.min(t4 - 1, 2) : 0), t3.listenTo(this.view, "change:top", () => t3.updatePosition()), t3.listenTo(this.view, "change:left", () => t3.updatePosition()), this.editor.ui.view.body.add(t3), t3;
          }
          _showView({ view: t3, balloonClassName: e3 = "", withArrow: n2 = true, singleViewMode: o2 = false }) {
            this.view.class = e3, this.view.withArrow = n2, this._rotatorView.showView(t3), this.visibleView = t3, this.view.pin(this._getBalloonPosition()), this._fakePanelsView.updatePosition(), o2 && (this._singleViewMode = true);
          }
          _getBalloonPosition() {
            let t3 = Array.from(this._visibleStack.values()).pop().position;
            return t3 && (t3.limiter || (t3 = Object.assign({}, t3, { limiter: this.positionLimiter })), t3 = Object.assign({}, t3, { viewportOffsetConfig: this.editor.ui.viewportOffset })), t3;
          }
        }
        class rf extends Ui {
          constructor(t3) {
            super(t3);
            const e3 = t3.t, n2 = this.bindTemplate;
            this.set("isNavigationVisible", true), this.focusTracker = new Si(), this.buttonPrevView = this._createButtonView(e3("Previous"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.463 5.187a.888.888 0 1 1 1.254 1.255L9.16 10l3.557 3.557a.888.888 0 1 1-1.254 1.255L7.26 10.61a.888.888 0 0 1 .16-1.382l4.043-4.042z"/></svg>'), this.buttonNextView = this._createButtonView(e3("Next"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.537 14.813a.888.888 0 1 1-1.254-1.255L10.84 10 7.283 6.442a.888.888 0 1 1 1.254-1.255L12.74 9.39a.888.888 0 0 1-.16 1.382l-4.043 4.042z"/></svg>'), this.content = this.createCollection(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-balloon-rotator"], "z-index": "-1" }, children: [{ tag: "div", attributes: { class: ["ck-balloon-rotator__navigation", n2.to("isNavigationVisible", (t4) => t4 ? "" : "ck-hidden")] }, children: [this.buttonPrevView, { tag: "span", attributes: { class: ["ck-balloon-rotator__counter"] }, children: [{ text: n2.to("counter") }] }, this.buttonNextView] }, { tag: "div", attributes: { class: "ck-balloon-rotator__content" }, children: this.content }] });
          }
          render() {
            super.render(), this.focusTracker.add(this.element);
          }
          destroy() {
            super.destroy(), this.focusTracker.destroy();
          }
          showView(t3) {
            this.hideView(), this.content.add(t3);
          }
          hideView() {
            this.content.clear();
          }
          _createButtonView(t3, e3) {
            const n2 = new br(this.locale);
            return n2.set({ label: t3, icon: e3, tooltip: true }), n2;
          }
        }
        class sf extends Ui {
          constructor(t3, e3) {
            super(t3);
            const n2 = this.bindTemplate;
            this.set("top", 0), this.set("left", 0), this.set("height", 0), this.set("width", 0), this.set("numberOfPanels", 0), this.content = this.createCollection(), this._balloonPanelView = e3, this.setTemplate({ tag: "div", attributes: { class: ["ck-fake-panel", n2.to("numberOfPanels", (t4) => t4 ? "" : "ck-hidden")], style: { top: n2.to("top", nf), left: n2.to("left", nf), width: n2.to("width", nf), height: n2.to("height", nf) } }, children: this.content }), this.on("change:numberOfPanels", (t4, e4, n3, o2) => {
              n3 > o2 ? this._addPanels(n3 - o2) : this._removePanels(o2 - n3), this.updatePosition();
            });
          }
          _addPanels(t3) {
            for (; t3--; ) {
              const t4 = new Ui();
              t4.setTemplate({ tag: "div" }), this.content.add(t4), this.registerChild(t4);
            }
          }
          _removePanels(t3) {
            for (; t3--; ) {
              const t4 = this.content.last;
              this.content.remove(t4), this.deregisterChild(t4), t4.destroy();
            }
          }
          updatePosition() {
            if (this.numberOfPanels) {
              const { top: t3, left: e3 } = this._balloonPanelView, { width: n2, height: o2 } = new Vo(this._balloonPanelView.element);
              Object.assign(this, { top: t3, left: e3, width: n2, height: o2 });
            }
          }
        }
        var af = n(5868), cf = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(af.Z, cf);
        af.Z.locals;
        const lf = Yo("px");
        class df extends Ui {
          constructor(t3) {
            super(t3);
            const e3 = this.bindTemplate;
            this.set("isActive", false), this.set("isSticky", false), this.set("limiterElement", null), this.set("limiterBottomOffset", 50), this.set("viewportTopOffset", 0), this.set("_marginLeft", null), this.set("_isStickyToTheBottomOfLimiter", false), this.set("_stickyTopOffset", null), this.set("_stickyBottomOffset", null), this.content = this.createCollection(), this._contentPanelPlaceholder = new Hi({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel__placeholder"], style: { display: e3.to("isSticky", (t4) => t4 ? "block" : "none"), height: e3.to("isSticky", (t4) => t4 ? lf(this._contentPanelRect.height) : null) } } }).render(), this._contentPanel = new Hi({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel__content", e3.if("isSticky", "ck-sticky-panel__content_sticky"), e3.if("_isStickyToTheBottomOfLimiter", "ck-sticky-panel__content_sticky_bottom-limit")], style: { width: e3.to("isSticky", (t4) => t4 ? lf(this._contentPanelPlaceholder.getBoundingClientRect().width) : null), top: e3.to("_stickyTopOffset", (t4) => t4 ? lf(t4) : t4), bottom: e3.to("_stickyBottomOffset", (t4) => t4 ? lf(t4) : t4), marginLeft: e3.to("_marginLeft") } }, children: this.content }).render(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-sticky-panel"] }, children: [this._contentPanelPlaceholder, this._contentPanel] });
          }
          render() {
            super.render(), this.checkIfShouldBeSticky(), this.listenTo(zo.document, "scroll", () => {
              this.checkIfShouldBeSticky();
            }, { useCapture: true }), this.listenTo(this, "change:isActive", () => {
              this.checkIfShouldBeSticky();
            });
          }
          checkIfShouldBeSticky() {
            if (!this.limiterElement || !this.isActive)
              return void this._unstick();
            const t3 = new Vo(this.limiterElement);
            let e3 = t3.getVisible();
            if (e3) {
              const t4 = new Vo(zo.window);
              t4.top += this.viewportTopOffset, t4.height -= this.viewportTopOffset, e3 = e3.getIntersection(t4);
            }
            if (e3 && t3.top < e3.top) {
              const n2 = e3.top;
              if (n2 + this._contentPanelRect.height + this.limiterBottomOffset > e3.bottom) {
                const n3 = Math.max(t3.bottom - e3.bottom, 0) + this.limiterBottomOffset;
                t3.bottom - n3 > t3.top + this._contentPanelRect.height ? this._stickToBottomOfLimiter(n3) : this._unstick();
              } else
                this._contentPanelRect.height + this.limiterBottomOffset < t3.height ? this._stickToTopOfAncestors(n2) : this._unstick();
            } else
              this._unstick();
          }
          _stickToTopOfAncestors(t3) {
            this.isSticky = true, this._isStickyToTheBottomOfLimiter = false, this._stickyTopOffset = t3, this._stickyBottomOffset = null, this._marginLeft = lf(-zo.window.scrollX);
          }
          _stickToBottomOfLimiter(t3) {
            this.isSticky = true, this._isStickyToTheBottomOfLimiter = true, this._stickyTopOffset = null, this._stickyBottomOffset = t3, this._marginLeft = lf(-zo.window.scrollX);
          }
          _unstick() {
            this.isSticky = false, this._isStickyToTheBottomOfLimiter = false, this._stickyTopOffset = null, this._stickyBottomOffset = null, this._marginLeft = null;
          }
          get _contentPanelRect() {
            return new Vo(this._contentPanel);
          }
        }
        class hf extends Sr {
          constructor(t3, e3) {
            const n2 = t3.t, o2 = Object.assign({}, { showResetButton: true, showIcon: true, creator: gp }, e3);
            super(t3, o2.creator), this.label = e3.label, this._viewConfig = o2, this._viewConfig.showIcon && (this.iconView = new pr(), this.iconView.content = Rg.loupe, this.fieldWrapperChildren.add(this.iconView, 0), this.extendTemplate({ attributes: { class: "ck-search__query_with-icon" } })), this._viewConfig.showResetButton && (this.resetButtonView = new br(t3), this.resetButtonView.set({ label: n2("Clear"), icon: Rg.cancel, class: "ck-search__reset", isVisible: false, tooltip: true }), this.resetButtonView.on("execute", () => {
              this.reset(), this.focus(), this.fire("reset");
            }), this.resetButtonView.bind("isVisible").to(this.fieldView, "isEmpty", (t4) => !t4), this.fieldWrapperChildren.add(this.resetButtonView), this.extendTemplate({ attributes: { class: "ck-search__query_with-reset" } }));
          }
          reset() {
            this.fieldView.reset(), this._viewConfig.showResetButton && (this.resetButtonView.isVisible = false);
          }
        }
        class uf extends Ui {
          constructor() {
            super();
            const t3 = this.bindTemplate;
            this.set({ isVisible: false, primaryText: "", secondaryText: "" }), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-search__info", t3.if("isVisible", "ck-hidden", (t4) => !t4)], tabindex: -1 }, children: [{ tag: "span", children: [{ text: [t3.to("primaryText")] }] }, { tag: "span", children: [{ text: [t3.to("secondaryText")] }] }] });
          }
          focus() {
            this.element.focus();
          }
        }
        class gf extends Ui {
          constructor(t3) {
            super(t3), this.children = this.createCollection(), this.focusTracker = new Si(), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-search__results"], tabindex: -1 }, children: this.children }), this._focusCycler = new qr({ focusables: this.children, focusTracker: this.focusTracker });
          }
          render() {
            super.render();
            for (const t3 of this.children)
              this.focusTracker.add(t3.element);
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          focusFirst() {
            this._focusCycler.focusFirst();
          }
          focusLast() {
            this._focusCycler.focusLast();
          }
        }
        var pf = /[\\^$.*+?()[\]{}|]/g, mf = RegExp(pf.source);
        const ff = function(t3) {
          return (t3 = Us(t3)) && mf.test(t3) ? t3.replace(pf, "\\$&") : t3;
        };
        var kf = n(6770), bf = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(kf.Z, bf);
        kf.Z.locals;
        var wf = Object.defineProperty, Af = Object.getOwnPropertySymbols, Cf = Object.prototype.hasOwnProperty, _f = Object.prototype.propertyIsEnumerable, vf = (t3, e3, n2) => e3 in t3 ? wf(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2;
        class yf extends Ui {
          constructor(t3, e3) {
            super(t3), this._config = e3, this.filteredView = e3.filteredView, this.queryView = this._createSearchTextQueryView(), this.focusTracker = new Si(), this.keystrokes = new Ti(), this.resultsView = new gf(t3), this.children = this.createCollection(), this.focusableChildren = this.createCollection([this.queryView, this.resultsView]), this.set("isEnabled", true), this.set("resultsCount", 0), this.set("totalItemsCount", 0), e3.infoView && e3.infoView.instance ? this.infoView = e3.infoView.instance : (this.infoView = new uf(), this._enableDefaultInfoViewBehavior(), this.on("render", () => {
              this.search("");
            })), this.resultsView.children.addMany([this.infoView, this.filteredView]), this.focusCycler = new qr({ focusables: this.focusableChildren, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this.on("search", (t4, { resultsCount: e4, totalItemsCount: n2 }) => {
              this.resultsCount = e4, this.totalItemsCount = n2;
            }), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-search", e3.class || null], tabindex: "-1" }, children: this.children });
          }
          render() {
            super.render(), this.children.addMany([this.queryView, this.resultsView]);
            const t3 = (t4) => t4.stopPropagation();
            for (const t4 of this.focusableChildren)
              this.focusTracker.add(t4.element);
            this.keystrokes.listenTo(this.element), this.keystrokes.set("arrowright", t3), this.keystrokes.set("arrowleft", t3), this.keystrokes.set("arrowup", t3), this.keystrokes.set("arrowdown", t3);
          }
          focus() {
            this.queryView.focus();
          }
          reset() {
            this.queryView.reset(), this.search("");
          }
          search(t3) {
            const e3 = t3 ? new RegExp(ff(t3), "ig") : null, n2 = this.filteredView.filter(e3);
            this.fire("search", ((t4, e4) => {
              for (var n3 in e4 || (e4 = {}))
                Cf.call(e4, n3) && vf(t4, n3, e4[n3]);
              if (Af)
                for (var n3 of Af(e4))
                  _f.call(e4, n3) && vf(t4, n3, e4[n3]);
              return t4;
            })({ query: t3 }, n2));
          }
          _createSearchTextQueryView() {
            const t3 = new hf(this.locale, this._config.queryView);
            return this.listenTo(t3.fieldView, "input", () => {
              this.search(t3.fieldView.element.value);
            }), t3.on("reset", () => this.reset()), t3.bind("isEnabled").to(this), t3;
          }
          _enableDefaultInfoViewBehavior() {
            const t3 = this.locale.t, e3 = this.infoView;
            function n2(t4, { query: e4, resultsCount: n3, totalItemsCount: o2 }) {
              return "function" == typeof t4 ? t4(e4, n3, o2) : t4;
            }
            this.on("search", (o2, i2) => {
              if (i2.resultsCount)
                e3.set({ isVisible: false });
              else {
                const o3 = this._config.infoView && this._config.infoView.text;
                let r2, s3;
                i2.totalItemsCount ? o3 && o3.notFound ? (r2 = o3.notFound.primary, s3 = o3.notFound.secondary) : (r2 = t3("No results found"), s3 = "") : o3 && o3.noSearchableItems ? (r2 = o3.noSearchableItems.primary, s3 = o3.noSearchableItems.secondary) : (r2 = t3("No searchable items"), s3 = ""), e3.set({ primaryText: n2(r2, i2), secondaryText: n2(s3, i2), isVisible: true });
              }
            });
          }
        }
        var xf = n(8157), Ef = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(xf.Z, Ef);
        xf.Z.locals;
        const Df = class extends yf {
          constructor(t3, e3) {
            super(t3, e3), this._config = e3;
            const n2 = Yo("px");
            this.extendTemplate({ attributes: { class: ["ck-autocomplete"] } });
            const o2 = this.resultsView.bindTemplate;
            this.resultsView.set("isVisible", false), this.resultsView.set("_position", "s"), this.resultsView.set("_width", 0), this.resultsView.extendTemplate({ attributes: { class: [o2.if("isVisible", "ck-hidden", (t4) => !t4), o2.to("_position", (t4) => `ck-search__results_${t4}`)], style: { width: o2.to("_width", n2) } } }), this.focusTracker.on("change:isFocused", (t4, n3, o3) => {
              this._updateResultsVisibility(), o3 ? this.resultsView.element.scrollTop = 0 : e3.resetOnBlur && this.queryView.reset();
            }), this.on("search", () => {
              this._updateResultsVisibility(), this._updateResultsViewWidthAndPosition();
            }), this.keystrokes.set("esc", (t4, e4) => {
              this.resultsView.isVisible && (this.queryView.focus(), this.resultsView.isVisible = false, e4());
            }), this.listenTo(zo.document, "scroll", () => {
              this._updateResultsViewWidthAndPosition();
            }), this.on("change:isEnabled", () => {
              this._updateResultsVisibility();
            }), this.filteredView.on("execute", (t4, { value: e4 }) => {
              this.focus(), this.reset(), this.queryView.fieldView.value = this.queryView.fieldView.element.value = e4, this.resultsView.isVisible = false;
            }), this.resultsView.on("change:isVisible", () => {
              this._updateResultsViewWidthAndPosition();
            });
          }
          _updateResultsViewWidthAndPosition() {
            if (!this.resultsView.isVisible)
              return;
            this.resultsView._width = new Vo(this.queryView.fieldView.element).width;
            const t3 = Df._getOptimalPosition({ element: this.resultsView.element, target: this.queryView.element, fitInViewport: true, positions: Df.defaultResultsPositions });
            this.resultsView._position = t3 ? t3.name : "s";
          }
          _updateResultsVisibility() {
            const t3 = void 0 === this._config.queryMinChars ? 0 : this._config.queryMinChars, e3 = this.queryView.fieldView.element.value.length;
            this.resultsView.isVisible = this.focusTracker.isFocused && this.isEnabled && e3 >= t3;
          }
        };
        let If = Df;
        If.defaultResultsPositions = [(t3) => ({ top: t3.bottom, left: t3.left, name: "s" }), (t3, e3) => ({ top: t3.top - e3.height, left: t3.left, name: "n" })], If._getOptimalPosition = ei;
        var Sf = n(8960), Tf = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Sf.Z, Tf);
        Sf.Z.locals;
        var Mf = n(8010), Bf = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Mf.Z, Bf);
        Mf.Z.locals;
        class Nf extends Ui {
          constructor(t3, e3) {
            super(t3);
            const n2 = this.bindTemplate;
            this.set("isCollapsed", false), this.set("label", ""), this.buttonView = this._createButtonView(), this.children = this.createCollection(), this.set("_collapsibleAriaLabelUid", void 0), e3 && this.children.addMany(e3), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-collapsible", n2.if("isCollapsed", "ck-collapsible_collapsed")] }, children: [this.buttonView, { tag: "div", attributes: { class: ["ck", "ck-collapsible__children"], role: "region", hidden: n2.if("isCollapsed", "hidden"), "aria-labelledby": n2.to("_collapsibleAriaLabelUid") }, children: this.children }] });
          }
          render() {
            super.render(), this._collapsibleAriaLabelUid = this.buttonView.labelView.element.id;
          }
          focus() {
            this.buttonView.focus();
          }
          _createButtonView() {
            const t3 = new br(this.locale), e3 = t3.bindTemplate;
            return t3.set({ withText: true, icon: Ur }), t3.extendTemplate({ attributes: { "aria-expanded": e3.to("isOn", (t4) => String(t4)) } }), t3.bind("label").to(this), t3.bind("isOn").to(this, "isCollapsed", (t4) => !t4), t3.on("execute", () => {
              this.isCollapsed = !this.isCollapsed;
            }), t3;
          }
        }
        var Pf = n(498), zf = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Pf.Z, zf);
        Pf.Z.locals;
        Yo("px");
        var Of = n(9695), Lf = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Of.Z, Lf);
        Of.Z.locals, Yo("px");
        Yo("px");
        class Rf extends Fm {
          constructor(t3, e3) {
            super(t3), this.view = e3, this._toolbarConfig = ts(t3.config.get("toolbar")), this._elementReplacer = new J(), this.listenTo(t3.editing.view, "scrollToTheSelection", this._handleScrollToTheSelectionWithStickyPanel.bind(this));
          }
          get element() {
            return this.view.element;
          }
          init(t3) {
            const e3 = this.editor, n2 = this.view, o2 = e3.editing.view, i2 = n2.editable, r2 = o2.document.getRoot();
            i2.name = r2.rootName, n2.render();
            const s3 = i2.element;
            this.setEditableElement(i2.name, s3), n2.editable.bind("isFocused").to(this.focusTracker), o2.attachDomRoot(s3), t3 && this._elementReplacer.replace(t3, this.element), this._initPlaceholder(), this._initToolbar(), this.fire("ready");
          }
          destroy() {
            super.destroy();
            const t3 = this.view, e3 = this.editor.editing.view;
            this._elementReplacer.restore(), e3.detachDomRoot(t3.editable.name), t3.destroy();
          }
          _initToolbar() {
            const t3 = this.view;
            t3.stickyPanel.bind("isActive").to(this.focusTracker, "isFocused"), t3.stickyPanel.limiterElement = t3.element, t3.stickyPanel.bind("viewportTopOffset").to(this, "viewportOffset", ({ top: t4 }) => t4 || 0), t3.toolbar.fillFromConfig(this._toolbarConfig, this.componentFactory), this.addToolbar(t3.toolbar);
          }
          _initPlaceholder() {
            const t3 = this.editor, e3 = t3.editing.view, n2 = e3.document.getRoot(), o2 = t3.sourceElement;
            let i2;
            const r2 = t3.config.get("placeholder");
            r2 && (i2 = "string" == typeof r2 ? r2 : r2[this.view.editable.name]), !i2 && o2 && "textarea" === o2.tagName.toLowerCase() && (i2 = o2.getAttribute("placeholder")), i2 && (n2.placeholder = i2), ps({ view: e3, element: n2, isDirectHost: false, keepOnFocus: true });
          }
          _handleScrollToTheSelectionWithStickyPanel(t3, e3, n2) {
            const o2 = this.view.stickyPanel;
            if (o2.isSticky) {
              const t4 = new Vo(o2.element).height;
              e3.viewportOffset.top += t4;
            } else {
              const t4 = () => {
                this.editor.editing.view.scrollToTheSelection(n2);
              };
              this.listenTo(o2, "change:isSticky", t4), setTimeout(() => {
                this.stopListening(o2, "change:isSticky", t4);
              }, 20);
            }
          }
        }
        var jf = n(3143), Ff = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(jf.Z, Ff);
        jf.Z.locals;
        class Vf extends Gm {
          constructor(t3, e3, n2 = {}) {
            super(t3), this.stickyPanel = new df(t3), this.toolbar = new Hg(t3, { shouldGroupWhenFull: n2.shouldToolbarGroupWhenFull }), this.editable = new Km(t3, e3);
          }
          render() {
            super.render(), this.stickyPanel.content.add(this.toolbar), this.top.add(this.stickyPanel), this.main.add(this.editable);
          }
        }
        class Uf {
          constructor(t3) {
            if (this.crashes = [], this.state = "initializing", this._now = Date.now, this.crashes = [], this._crashNumberLimit = "number" == typeof t3.crashNumberLimit ? t3.crashNumberLimit : 3, this._minimumNonErrorTimePeriod = "number" == typeof t3.minimumNonErrorTimePeriod ? t3.minimumNonErrorTimePeriod : 5e3, this._boundErrorHandler = (t4) => {
              const e3 = "error" in t4 ? t4.error : t4.reason;
              e3 instanceof Error && this._handleError(e3, t4);
            }, this._listeners = {}, !this._restart)
              throw new Error("The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.");
          }
          destroy() {
            this._stopErrorHandling(), this._listeners = {};
          }
          on(t3, e3) {
            this._listeners[t3] || (this._listeners[t3] = []), this._listeners[t3].push(e3);
          }
          off(t3, e3) {
            this._listeners[t3] = this._listeners[t3].filter((t4) => t4 !== e3);
          }
          _fire(t3, ...e3) {
            const n2 = this._listeners[t3] || [];
            for (const t4 of n2)
              t4.apply(this, [null, ...e3]);
          }
          _startErrorHandling() {
            window.addEventListener("error", this._boundErrorHandler), window.addEventListener("unhandledrejection", this._boundErrorHandler);
          }
          _stopErrorHandling() {
            window.removeEventListener("error", this._boundErrorHandler), window.removeEventListener("unhandledrejection", this._boundErrorHandler);
          }
          _handleError(t3, e3) {
            if (this._shouldReactToError(t3)) {
              this.crashes.push({ message: t3.message, stack: t3.stack, filename: e3 instanceof ErrorEvent ? e3.filename : void 0, lineno: e3 instanceof ErrorEvent ? e3.lineno : void 0, colno: e3 instanceof ErrorEvent ? e3.colno : void 0, date: this._now() });
              const n2 = this._shouldRestart();
              this.state = "crashed", this._fire("stateChange"), this._fire("error", { error: t3, causesRestart: n2 }), n2 ? this._restart() : (this.state = "crashedPermanently", this._fire("stateChange"));
            }
          }
          _shouldReactToError(t3) {
            return t3.is && t3.is("CKEditorError") && void 0 !== t3.context && null !== t3.context && "ready" === this.state && this._isErrorComingFromThisItem(t3);
          }
          _shouldRestart() {
            if (this.crashes.length <= this._crashNumberLimit)
              return true;
            return (this.crashes[this.crashes.length - 1].date - this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date) / this._crashNumberLimit > this._minimumNonErrorTimePeriod;
          }
        }
        function Hf(t3, e3 = /* @__PURE__ */ new Set()) {
          const n2 = [t3], o2 = /* @__PURE__ */ new Set();
          let i2 = 0;
          for (; n2.length > i2; ) {
            const t4 = n2[i2++];
            if (!o2.has(t4) && qf(t4) && !e3.has(t4))
              if (o2.add(t4), Symbol.iterator in t4)
                try {
                  for (const e4 of t4)
                    n2.push(e4);
                } catch (t5) {
                }
              else
                for (const e4 in t4)
                  "defaultValue" !== e4 && n2.push(t4[e4]);
          }
          return o2;
        }
        function qf(t3) {
          const e3 = Object.prototype.toString.call(t3), n2 = typeof t3;
          return !("number" === n2 || "boolean" === n2 || "string" === n2 || "symbol" === n2 || "function" === n2 || "[object Date]" === e3 || "[object RegExp]" === e3 || "[object Module]" === e3 || null == t3 || t3._watchdogExcluded || t3 instanceof EventTarget || t3 instanceof Event);
        }
        function Gf(t3, e3, n2 = /* @__PURE__ */ new Set()) {
          if (t3 === e3 && ("object" == typeof (o2 = t3) && null !== o2))
            return true;
          var o2;
          const i2 = Hf(t3, n2), r2 = Hf(e3, n2);
          for (const t4 of i2)
            if (r2.has(t4))
              return true;
          return false;
        }
        var Wf = Object.defineProperty, Kf = Object.defineProperties, Zf = Object.getOwnPropertyDescriptors, Yf = Object.getOwnPropertySymbols, $f = Object.prototype.hasOwnProperty, Qf = Object.prototype.propertyIsEnumerable, Jf = (t3, e3, n2) => e3 in t3 ? Wf(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, Xf = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            $f.call(e3, n2) && Jf(t3, n2, e3[n2]);
          if (Yf)
            for (var n2 of Yf(e3))
              Qf.call(e3, n2) && Jf(t3, n2, e3[n2]);
          return t3;
        };
        class tk extends Uf {
          constructor(t3, e3 = {}) {
            super(e3), this._editor = null, this._initUsingData = true, this._editables = {}, this._throttledSave = fm(this._save.bind(this), "number" == typeof e3.saveInterval ? e3.saveInterval : 5e3), t3 && (this._creator = (e4, n2) => t3.create(e4, n2)), this._destructor = (t4) => t4.destroy();
          }
          get editor() {
            return this._editor;
          }
          get _item() {
            return this._editor;
          }
          setCreator(t3) {
            this._creator = t3;
          }
          setDestructor(t3) {
            this._destructor = t3;
          }
          _restart() {
            return Promise.resolve().then(() => (this.state = "initializing", this._fire("stateChange"), this._destroy())).catch((t3) => {
              console.error("An error happened during the editor destroying.", t3);
            }).then(() => {
              const t3 = {}, e3 = [], n2 = this._config.rootsAttributes || {}, o2 = {};
              for (const [i3, r3] of Object.entries(this._data.roots))
                r3.isLoaded ? (t3[i3] = "", o2[i3] = n2[i3] || {}) : e3.push(i3);
              const i2 = (r2 = Xf({}, this._config), s3 = { extraPlugins: this._config.extraPlugins || [], lazyRoots: e3, rootsAttributes: o2, _watchdogInitialData: this._data }, Kf(r2, Zf(s3)));
              var r2, s3;
              return delete i2.initialData, i2.extraPlugins.push(ek), this._initUsingData ? this.create(t3, i2, i2.context) : yo(this._elementOrData) ? this.create(this._elementOrData, i2, i2.context) : this.create(this._editables, i2, i2.context);
            }).then(() => {
              this._fire("restart");
            });
          }
          create(t3 = this._elementOrData, e3 = this._config, n2) {
            return Promise.resolve().then(() => (super._startErrorHandling(), this._elementOrData = t3, this._initUsingData = "string" == typeof t3 || Object.keys(t3).length > 0 && "string" == typeof Object.values(t3)[0], this._config = this._cloneEditorConfiguration(e3) || {}, this._config.context = n2, this._creator(t3, this._config))).then((t4) => {
              this._editor = t4, t4.model.document.on("change:data", this._throttledSave), this._lastDocumentVersion = t4.model.document.version, this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this.state = "ready", this._fire("stateChange");
            });
          }
          destroy() {
            return Promise.resolve().then(() => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
          }
          _destroy() {
            return Promise.resolve().then(() => {
              this._stopErrorHandling(), this._throttledSave.cancel();
              const t3 = this._editor;
              return this._editor = null, t3.model.document.off("change:data", this._throttledSave), this._destructor(t3);
            });
          }
          _save() {
            const t3 = this._editor.model.document.version;
            try {
              this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this._lastDocumentVersion = t3;
            } catch (t4) {
              console.error(t4, "An error happened during restoring editor data. Editor will be restored from the previously saved data.");
            }
          }
          _setExcludedProperties(t3) {
            this._excludedProps = t3;
          }
          _getData() {
            const t3 = this._editor, e3 = t3.model.document.roots.filter((t4) => t4.isAttached() && "$graveyard" != t4.rootName), { plugins: n2 } = t3, o2 = n2.has("CommentsRepository") && n2.get("CommentsRepository"), i2 = n2.has("TrackChanges") && n2.get("TrackChanges"), r2 = { roots: {}, markers: {}, commentThreads: JSON.stringify([]), suggestions: JSON.stringify([]) };
            e3.forEach((t4) => {
              r2.roots[t4.rootName] = { content: JSON.stringify(Array.from(t4.getChildren())), attributes: JSON.stringify(Array.from(t4.getAttributes())), isLoaded: t4._isLoaded };
            });
            for (const e4 of t3.model.markers)
              e4._affectsData && (r2.markers[e4.name] = { rangeJSON: e4.getRange().toJSON(), usingOperation: e4._managedUsingOperations, affectsData: e4._affectsData });
            return o2 && (r2.commentThreads = JSON.stringify(o2.getCommentThreads({ toJSON: true, skipNotAttached: true }))), i2 && (r2.suggestions = JSON.stringify(i2.getSuggestions({ toJSON: true, skipNotAttached: true }))), r2;
          }
          _getEditables() {
            const t3 = {};
            for (const e3 of this.editor.model.document.getRootNames()) {
              const n2 = this.editor.ui.getEditableElement(e3);
              n2 && (t3[e3] = n2);
            }
            return t3;
          }
          _isErrorComingFromThisItem(t3) {
            return Gf(this._editor, t3.context, this._excludedProps);
          }
          _cloneEditorConfiguration(t3) {
            return vo(t3, (t4, e3) => yo(t4) || "context" === e3 ? t4 : void 0);
          }
        }
        class ek {
          constructor(t3) {
            this.editor = t3, this._data = t3.config.get("_watchdogInitialData");
          }
          init() {
            this.editor.data.on("init", (t3) => {
              t3.stop(), this.editor.model.enqueueChange({ isUndoable: false }, (t4) => {
                this._restoreCollaborationData(), this._restoreEditorData(t4);
              }), this.editor.data.fire("ready");
            }, { priority: 999 });
          }
          _createNode(t3, e3) {
            if ("name" in e3) {
              const n2 = t3.createElement(e3.name, e3.attributes);
              if (e3.children)
                for (const o2 of e3.children)
                  n2._appendChild(this._createNode(t3, o2));
              return n2;
            }
            return t3.createText(e3.data, e3.attributes);
          }
          _restoreEditorData(t3) {
            const e3 = this.editor;
            Object.entries(this._data.roots).forEach(([n2, { content: o2, attributes: i2 }]) => {
              const r2 = JSON.parse(o2), s3 = JSON.parse(i2), a2 = e3.model.document.getRoot(n2);
              for (const [e4, n3] of s3)
                t3.setAttribute(e4, n3, a2);
              for (const e4 of r2) {
                const n3 = this._createNode(t3, e4);
                t3.insert(n3, a2, "end");
              }
            }), Object.entries(this._data.markers).forEach(([n2, o2]) => {
              const { document: i2 } = e3.model, r2 = o2, { rangeJSON: { start: s3, end: a2 } } = r2, c2 = ((t4, e4) => {
                var n3 = {};
                for (var o3 in t4)
                  $f.call(t4, o3) && e4.indexOf(o3) < 0 && (n3[o3] = t4[o3]);
                if (null != t4 && Yf)
                  for (var o3 of Yf(t4))
                    e4.indexOf(o3) < 0 && Qf.call(t4, o3) && (n3[o3] = t4[o3]);
                return n3;
              })(r2, ["rangeJSON"]), l2 = i2.getRoot(s3.root), d2 = t3.createPositionFromPath(l2, s3.path, s3.stickiness), h2 = t3.createPositionFromPath(l2, a2.path, a2.stickiness), u2 = t3.createRange(d2, h2);
              t3.addMarker(n2, Xf({ range: u2 }, c2));
            });
          }
          _restoreCollaborationData() {
            const t3 = JSON.parse(this._data.commentThreads), e3 = JSON.parse(this._data.suggestions);
            t3.forEach((t4) => {
              const e4 = this.editor.config.get("collaboration.channelId"), n2 = this.editor.plugins.get("CommentsRepository");
              if (n2.hasCommentThread(t4.threadId)) {
                n2.getCommentThread(t4.threadId).remove();
              }
              n2.addCommentThread(Xf({ channelId: e4 }, t4));
            }), e3.forEach((t4) => {
              const e4 = this.editor.plugins.get("TrackChangesEditing");
              if (e4.hasSuggestion(t4.id)) {
                e4.getSuggestion(t4.id).attributes = t4.attributes;
              } else
                e4.addSuggestionData(t4);
            });
          }
        }
        const nk = Symbol("MainQueueId");
        class ok {
          constructor() {
            this._onEmptyCallbacks = [], this._queues = /* @__PURE__ */ new Map(), this._activeActions = 0;
          }
          onEmpty(t3) {
            this._onEmptyCallbacks.push(t3);
          }
          enqueue(t3, e3) {
            const n2 = t3 === nk;
            this._activeActions++, this._queues.get(t3) || this._queues.set(t3, Promise.resolve());
            const o2 = (n2 ? Promise.all(this._queues.values()) : Promise.all([this._queues.get(nk), this._queues.get(t3)])).then(e3), i2 = o2.catch(() => {
            });
            return this._queues.set(t3, i2), o2.finally(() => {
              this._activeActions--, this._queues.get(t3) === i2 && 0 === this._activeActions && this._onEmptyCallbacks.forEach((t4) => t4());
            });
          }
        }
        function ik(t3) {
          return Array.isArray(t3) ? t3 : [t3];
        }
        class rk extends zg(Og(Pg)) {
          constructor(t3, e3 = {}) {
            if (!sk(t3) && void 0 !== e3.initialData)
              throw new A("editor-create-initial-data", null);
            super(e3), void 0 === this.config.get("initialData") && this.config.set("initialData", function(t4) {
              return sk(t4) ? (e4 = t4, e4 instanceof HTMLTextAreaElement ? e4.value : e4.innerHTML) : t4;
              var e4;
            }(t3)), sk(t3) && (this.sourceElement = t3), this.model.document.createRoot();
            const n2 = !this.config.get("toolbar.shouldNotGroupWhenFull"), o2 = new Vf(this.locale, this.editing.view, { shouldToolbarGroupWhenFull: n2 });
            this.ui = new Rf(this, o2), function(t4) {
              if (!Vt(t4.updateSourceElement))
                throw new A("attachtoform-missing-elementapi-interface", t4);
              const e4 = t4.sourceElement;
              if (function(t5) {
                return !!t5 && "textarea" === t5.tagName.toLowerCase();
              }(e4) && e4.form) {
                let n3;
                const o3 = e4.form, i2 = () => t4.updateSourceElement();
                Vt(o3.submit) && (n3 = o3.submit, o3.submit = () => {
                  i2(), n3.apply(o3);
                }), o3.addEventListener("submit", i2), t4.on("destroy", () => {
                  o3.removeEventListener("submit", i2), n3 && (o3.submit = n3);
                });
              }
            }(this);
          }
          destroy() {
            return this.sourceElement && this.updateSourceElement(), this.ui.destroy(), super.destroy();
          }
          static create(t3, e3 = {}) {
            return new Promise((n2) => {
              const o2 = new this(t3, e3);
              n2(o2.initPlugins().then(() => o2.ui.init(sk(t3) ? t3 : null)).then(() => o2.data.init(o2.config.get("initialData"))).then(() => o2.fire("ready")).then(() => o2));
            });
          }
        }
        function sk(t3) {
          return yo(t3);
        }
        rk.Context = as, rk.EditorWatchdog = tk, rk.ContextWatchdog = class extends Uf {
          constructor(t3, e3 = {}) {
            super(e3), this._watchdogs = /* @__PURE__ */ new Map(), this._context = null, this._contextProps = /* @__PURE__ */ new Set(), this._actionQueues = new ok(), this._watchdogConfig = e3, this._creator = (e4) => t3.create(e4), this._destructor = (t4) => t4.destroy(), this._actionQueues.onEmpty(() => {
              "initializing" === this.state && (this.state = "ready", this._fire("stateChange"));
            });
          }
          setCreator(t3) {
            this._creator = t3;
          }
          setDestructor(t3) {
            this._destructor = t3;
          }
          get context() {
            return this._context;
          }
          create(t3 = {}) {
            return this._actionQueues.enqueue(nk, () => (this._contextConfig = t3, this._create()));
          }
          getItem(t3) {
            return this._getWatchdog(t3)._item;
          }
          getItemState(t3) {
            return this._getWatchdog(t3).state;
          }
          add(t3) {
            const e3 = ik(t3);
            return Promise.all(e3.map((t4) => this._actionQueues.enqueue(t4.id, () => {
              if ("destroyed" === this.state)
                throw new Error("Cannot add items to destroyed watchdog.");
              if (!this._context)
                throw new Error("Context was not created yet. You should call the `ContextWatchdog#create()` method first.");
              let e4;
              if (this._watchdogs.has(t4.id))
                throw new Error(`Item with the given id is already added: '${t4.id}'.`);
              if ("editor" === t4.type)
                return e4 = new tk(null, this._watchdogConfig), e4.setCreator(t4.creator), e4._setExcludedProperties(this._contextProps), t4.destructor && e4.setDestructor(t4.destructor), this._watchdogs.set(t4.id, e4), e4.on("error", (n2, { error: o2, causesRestart: i2 }) => {
                  this._fire("itemError", { itemId: t4.id, error: o2 }), i2 && this._actionQueues.enqueue(t4.id, () => new Promise((n3) => {
                    const o3 = () => {
                      e4.off("restart", o3), this._fire("itemRestart", { itemId: t4.id }), n3();
                    };
                    e4.on("restart", o3);
                  }));
                }), e4.create(t4.sourceElementOrData, t4.config, this._context);
              throw new Error(`Not supported item type: '${t4.type}'.`);
            })));
          }
          remove(t3) {
            const e3 = ik(t3);
            return Promise.all(e3.map((t4) => this._actionQueues.enqueue(t4, () => {
              const e4 = this._getWatchdog(t4);
              return this._watchdogs.delete(t4), e4.destroy();
            })));
          }
          destroy() {
            return this._actionQueues.enqueue(nk, () => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
          }
          _restart() {
            return this._actionQueues.enqueue(nk, () => (this.state = "initializing", this._fire("stateChange"), this._destroy().catch((t3) => {
              console.error("An error happened during destroying the context or items.", t3);
            }).then(() => this._create()).then(() => this._fire("restart"))));
          }
          _create() {
            return Promise.resolve().then(() => (this._startErrorHandling(), this._creator(this._contextConfig))).then((t3) => (this._context = t3, this._contextProps = Hf(this._context), Promise.all(Array.from(this._watchdogs.values()).map((t4) => (t4._setExcludedProperties(this._contextProps), t4.create(void 0, void 0, this._context))))));
          }
          _destroy() {
            return Promise.resolve().then(() => {
              this._stopErrorHandling();
              const t3 = this._context;
              return this._context = null, this._contextProps = /* @__PURE__ */ new Set(), Promise.all(Array.from(this._watchdogs.values()).map((t4) => t4.destroy())).then(() => this._destructor(t3));
            });
          }
          _getWatchdog(t3) {
            const e3 = this._watchdogs.get(t3);
            if (!e3)
              throw new Error(`Item with the given id was not registered: ${t3}.`);
            return e3;
          }
          _isErrorComingFromThisItem(t3) {
            for (const e3 of this._watchdogs.values())
              if (e3._isErrorComingFromThisItem(t3))
                return false;
            return Gf(this._context, t3.context);
          }
        };
        class ak extends Hc {
          constructor(t3) {
            super(t3), this.domEventType = ["paste", "copy", "cut", "drop", "dragover", "dragstart", "dragend", "dragenter", "dragleave"];
            const e3 = this.document;
            function n2(t4) {
              return (n3, o2) => {
                o2.preventDefault();
                const i2 = o2.dropRange ? [o2.dropRange] : null, r2 = new p(e3, t4);
                e3.fire(r2, { dataTransfer: o2.dataTransfer, method: n3.name, targetRanges: i2, target: o2.target, domEvent: o2.domEvent }), r2.stop.called && o2.stopPropagation();
              };
            }
            this.listenTo(e3, "paste", n2("clipboardInput"), { priority: "low" }), this.listenTo(e3, "drop", n2("clipboardInput"), { priority: "low" }), this.listenTo(e3, "dragover", n2("dragging"), { priority: "low" });
          }
          onDomEvent(t3) {
            const e3 = "clipboardData" in t3 ? t3.clipboardData : t3.dataTransfer, n2 = "drop" == t3.type || "paste" == t3.type, o2 = { dataTransfer: new Ml(e3, { cacheFiles: n2 }) };
            "drop" != t3.type && "dragover" != t3.type || (o2.dropRange = function(t4, e4) {
              const n3 = e4.target.ownerDocument, o3 = e4.clientX, i2 = e4.clientY;
              let r2;
              n3.caretRangeFromPoint && n3.caretRangeFromPoint(o3, i2) ? r2 = n3.caretRangeFromPoint(o3, i2) : e4.rangeParent && (r2 = n3.createRange(), r2.setStart(e4.rangeParent, e4.rangeOffset), r2.collapse(true));
              if (r2)
                return t4.domConverter.domRangeToView(r2);
              return null;
            }(this.view, t3)), this.fire(t3.type, t3, o2);
          }
        }
        const ck = ["figcaption", "li"], lk = ["ol", "ul"];
        function dk(t3) {
          if (t3.is("$text") || t3.is("$textProxy"))
            return t3.data;
          if (t3.is("element", "img") && t3.hasAttribute("alt"))
            return t3.getAttribute("alt");
          if (t3.is("element", "br"))
            return "\n";
          let e3 = "", n2 = null;
          for (const o2 of t3.getChildren())
            e3 += hk(o2, n2) + dk(o2), n2 = o2;
          return e3;
        }
        function hk(t3, e3) {
          return e3 ? t3.is("element", "li") && !t3.isEmpty && t3.getChild(0).is("containerElement") || lk.includes(t3.name) && lk.includes(e3.name) ? "\n\n" : t3.is("containerElement") || e3.is("containerElement") ? ck.includes(t3.name) || ck.includes(e3.name) ? "\n" : "\n\n" : "" : "";
        }
        class uk extends es {
          static get pluginName() {
            return "ClipboardPipeline";
          }
          init() {
            this.editor.editing.view.addObserver(ak), this._setupPasteDrop(), this._setupCopyCut();
          }
          _fireOutputTransformationEvent(t3, e3, n2) {
            const o2 = this.editor.model.getSelectedContent(e3);
            this.fire("outputTransformation", { dataTransfer: t3, content: o2, method: n2 });
          }
          _setupPasteDrop() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.editing.view, o2 = n2.document;
            this.listenTo(o2, "clipboardInput", (e4, n3) => {
              "paste" != n3.method || t3.model.canEditAt(t3.model.document.selection) || e4.stop();
            }, { priority: "highest" }), this.listenTo(o2, "clipboardInput", (t4, e4) => {
              const o3 = e4.dataTransfer;
              let i2;
              if (e4.content)
                i2 = e4.content;
              else {
                let t5 = "";
                o3.getData("text/html") ? t5 = function(t6) {
                  return t6.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (t7, e5) => 1 == e5.length ? " " : e5).replace(/<!--[\s\S]*?-->/g, "");
                }(o3.getData("text/html")) : o3.getData("text/plain") && (((r2 = (r2 = o3.getData("text/plain")).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/\r?\n\r?\n/g, "</p><p>").replace(/\r?\n/g, "<br>").replace(/\t/g, "&nbsp;&nbsp;&nbsp;&nbsp;").replace(/^\s/, "&nbsp;").replace(/\s$/, "&nbsp;").replace(/\s\s/g, " &nbsp;")).includes("</p><p>") || r2.includes("<br>")) && (r2 = `<p>${r2}</p>`), t5 = r2), i2 = this.editor.data.htmlProcessor.toView(t5);
              }
              var r2;
              const s3 = new p(this, "inputTransformation");
              this.fire(s3, { content: i2, dataTransfer: o3, targetRanges: e4.targetRanges, method: e4.method }), s3.stop.called && t4.stop(), n2.scrollToTheSelection();
            }, { priority: "low" }), this.listenTo(this, "inputTransformation", (t4, n3) => {
              if (n3.content.isEmpty)
                return;
              const o3 = this.editor.data.toModel(n3.content, "$clipboardHolder");
              0 != o3.childCount && (t4.stop(), e3.change(() => {
                this.fire("contentInsertion", { content: o3, method: n3.method, dataTransfer: n3.dataTransfer, targetRanges: n3.targetRanges });
              }));
            }, { priority: "low" }), this.listenTo(this, "contentInsertion", (t4, n3) => {
              n3.resultRange = e3.insertContent(n3.content);
            }, { priority: "low" });
          }
          _setupCopyCut() {
            const t3 = this.editor, e3 = t3.model.document, n2 = t3.editing.view.document, o2 = (t4, n3) => {
              const o3 = n3.dataTransfer;
              n3.preventDefault(), this._fireOutputTransformationEvent(o3, e3.selection, t4.name);
            };
            this.listenTo(n2, "copy", o2, { priority: "low" }), this.listenTo(n2, "cut", (e4, n3) => {
              t3.model.canEditAt(t3.model.document.selection) ? o2(e4, n3) : n3.preventDefault();
            }, { priority: "low" }), this.listenTo(this, "outputTransformation", (e4, o3) => {
              const i2 = t3.data.toView(o3.content);
              n2.fire("clipboardOutput", { dataTransfer: o3.dataTransfer, content: i2, method: o3.method });
            }, { priority: "low" }), this.listenTo(n2, "clipboardOutput", (n3, o3) => {
              o3.content.isEmpty || (o3.dataTransfer.setData("text/html", this.editor.data.htmlProcessor.toData(o3.content)), o3.dataTransfer.setData("text/plain", dk(o3.content))), "cut" == o3.method && t3.model.deleteContent(e3.selection);
            }, { priority: "low" });
          }
        }
        class gk {
          constructor(t3, e3 = 20) {
            this._batch = null, this.model = t3, this._size = 0, this.limit = e3, this._isLocked = false, this._changeCallback = (t4, e4) => {
              e4.isLocal && e4.isUndoable && e4 !== this._batch && this._reset(true);
            }, this._selectionChangeCallback = () => {
              this._reset();
            }, this.model.document.on("change", this._changeCallback), this.model.document.selection.on("change:range", this._selectionChangeCallback), this.model.document.selection.on("change:attribute", this._selectionChangeCallback);
          }
          get batch() {
            return this._batch || (this._batch = this.model.createBatch({ isTyping: true })), this._batch;
          }
          get size() {
            return this._size;
          }
          input(t3) {
            this._size += t3, this._size >= this.limit && this._reset(true);
          }
          get isLocked() {
            return this._isLocked;
          }
          lock() {
            this._isLocked = true;
          }
          unlock() {
            this._isLocked = false;
          }
          destroy() {
            this.model.document.off("change", this._changeCallback), this.model.document.selection.off("change:range", this._selectionChangeCallback), this.model.document.selection.off("change:attribute", this._selectionChangeCallback);
          }
          _reset(t3 = false) {
            this.isLocked && !t3 || (this._batch = null, this._size = 0);
          }
        }
        class pk extends os {
          constructor(t3, e3) {
            super(t3), this._buffer = new gk(t3.model, e3), this._isEnabledBasedOnSelection = false;
          }
          get buffer() {
            return this._buffer;
          }
          destroy() {
            super.destroy(), this._buffer.destroy();
          }
          execute(t3 = {}) {
            const e3 = this.editor.model, n2 = e3.document, o2 = t3.text || "", i2 = o2.length;
            let r2 = n2.selection;
            if (t3.selection ? r2 = t3.selection : t3.range && (r2 = e3.createSelection(t3.range)), !e3.canEditAt(r2))
              return;
            const s3 = t3.resultRange;
            e3.enqueueChange(this._buffer.batch, (t4) => {
              this._buffer.lock();
              const a2 = Array.from(n2.selection.getAttributes());
              e3.deleteContent(r2), o2 && e3.insertContent(t4.createText(o2, a2), r2), s3 ? t4.setSelection(s3) : r2.is("documentSelection") || t4.setSelection(r2), this._buffer.unlock(), this._buffer.input(i2);
            });
          }
        }
        const mk = ["insertText", "insertReplacementText"];
        class fk extends Fc {
          constructor(t3) {
            super(t3), this.focusObserver = t3.getObserver(Il), a.isAndroid && mk.push("insertCompositionText");
            const e3 = t3.document;
            e3.on("beforeinput", (n2, o2) => {
              if (!this.isEnabled)
                return;
              const { data: i2, targetRanges: r2, inputType: s3, domEvent: a2 } = o2;
              if (!mk.includes(s3))
                return;
              this.focusObserver.flush();
              const c2 = new p(e3, "insertText");
              e3.fire(c2, new Uc(t3, a2, { text: i2, selection: t3.createSelection(r2) })), c2.stop.called && n2.stop();
            }), e3.on("compositionend", (n2, { data: o2, domEvent: i2 }) => {
              this.isEnabled && !a.isAndroid && o2 && e3.fire("insertText", new Uc(t3, i2, { text: o2, selection: e3.selection }));
            }, { priority: "lowest" });
          }
          observe() {
          }
          stopObserving() {
          }
        }
        class kk extends es {
          static get pluginName() {
            return "Input";
          }
          init() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.editing.view, o2 = e3.document.selection;
            n2.addObserver(fk);
            const i2 = new pk(t3, t3.config.get("typing.undoStep") || 20);
            t3.commands.add("insertText", i2), t3.commands.add("input", i2), this.listenTo(n2.document, "insertText", (o3, i3) => {
              n2.document.isComposing || i3.preventDefault();
              const { text: r2, selection: s3, resultRange: c2 } = i3, l2 = Array.from(s3.getRanges()).map((e4) => t3.editing.mapper.toModelRange(e4));
              let d2 = r2;
              if (a.isAndroid) {
                const t4 = Array.from(l2[0].getItems()).reduce((t5, e4) => t5 + (e4.is("$textProxy") ? e4.data : ""), "");
                t4 && (t4.length <= d2.length ? d2.startsWith(t4) && (d2 = d2.substring(t4.length), l2[0].start = l2[0].start.getShiftedBy(t4.length)) : t4.startsWith(d2) && (l2[0].start = l2[0].start.getShiftedBy(d2.length), d2 = ""));
              }
              const h2 = { text: d2, selection: e3.createSelection(l2) };
              c2 && (h2.resultRange = t3.editing.mapper.toModelRange(c2)), t3.execute("insertText", h2), n2.scrollToTheSelection();
            }), a.isAndroid ? this.listenTo(n2.document, "keydown", (t4, r2) => {
              !o2.isCollapsed && 229 == r2.keyCode && n2.document.isComposing && bk(e3, i2);
            }) : this.listenTo(n2.document, "compositionstart", () => {
              o2.isCollapsed || bk(e3, i2);
            });
          }
        }
        function bk(t3, e3) {
          if (!e3.isEnabled)
            return;
          const n2 = e3.buffer;
          n2.lock(), t3.enqueueChange(n2.batch, () => {
            t3.deleteContent(t3.document.selection);
          }), n2.unlock();
        }
        class wk extends os {
          constructor(t3, e3) {
            super(t3), this.direction = e3, this._buffer = new gk(t3.model, t3.config.get("typing.undoStep")), this._isEnabledBasedOnSelection = false;
          }
          get buffer() {
            return this._buffer;
          }
          execute(t3 = {}) {
            const e3 = this.editor.model, n2 = e3.document;
            e3.enqueueChange(this._buffer.batch, (o2) => {
              this._buffer.lock();
              const i2 = o2.createSelection(t3.selection || n2.selection);
              if (!e3.canEditAt(i2))
                return;
              const r2 = t3.sequence || 1, s3 = i2.isCollapsed;
              if (i2.isCollapsed && e3.modifySelection(i2, { direction: this.direction, unit: t3.unit, treatEmojiAsSingleUnit: true }), this._shouldEntireContentBeReplacedWithParagraph(r2))
                return void this._replaceEntireContentWithParagraph(o2);
              if (this._shouldReplaceFirstBlockWithParagraph(i2, r2))
                return void this.editor.execute("paragraph", { selection: i2 });
              if (i2.isCollapsed)
                return;
              let a2 = 0;
              i2.getFirstRange().getMinimalFlatRanges().forEach((t4) => {
                a2 += X(t4.getWalker({ singleCharacters: true, ignoreElementEnd: true, shallow: true }));
              }), e3.deleteContent(i2, { doNotResetEntireContent: s3, direction: this.direction }), this._buffer.input(a2), o2.setSelection(i2), this._buffer.unlock();
            });
          }
          _shouldEntireContentBeReplacedWithParagraph(t3) {
            if (t3 > 1)
              return false;
            const e3 = this.editor.model, n2 = e3.document.selection, o2 = e3.schema.getLimitElement(n2);
            if (!(n2.isCollapsed && n2.containsEntireContent(o2)))
              return false;
            if (!e3.schema.checkChild(o2, "paragraph"))
              return false;
            const i2 = o2.getChild(0);
            return !i2 || !i2.is("element", "paragraph");
          }
          _replaceEntireContentWithParagraph(t3) {
            const e3 = this.editor.model, n2 = e3.document.selection, o2 = e3.schema.getLimitElement(n2), i2 = t3.createElement("paragraph");
            t3.remove(t3.createRangeIn(o2)), t3.insert(i2, o2), t3.setSelection(i2, 0);
          }
          _shouldReplaceFirstBlockWithParagraph(t3, e3) {
            const n2 = this.editor.model;
            if (e3 > 1 || "backward" != this.direction)
              return false;
            if (!t3.isCollapsed)
              return false;
            const o2 = t3.getFirstPosition(), i2 = n2.schema.getLimitElement(o2), r2 = i2.getChild(0);
            return o2.parent == r2 && (!!t3.containsEntireContent(r2) && (!!n2.schema.checkChild(i2, "paragraph") && "paragraph" != r2.name));
          }
        }
        const Ak = "word", Ck = "selection", _k = "backward", vk = "forward", yk = { deleteContent: { unit: Ck, direction: _k }, deleteContentBackward: { unit: "codePoint", direction: _k }, deleteWordBackward: { unit: Ak, direction: _k }, deleteHardLineBackward: { unit: Ck, direction: _k }, deleteSoftLineBackward: { unit: Ck, direction: _k }, deleteContentForward: { unit: "character", direction: vk }, deleteWordForward: { unit: Ak, direction: vk }, deleteHardLineForward: { unit: Ck, direction: vk }, deleteSoftLineForward: { unit: Ck, direction: vk } };
        class xk extends Fc {
          constructor(t3) {
            super(t3);
            const e3 = t3.document;
            let n2 = 0;
            e3.on("keydown", () => {
              n2++;
            }), e3.on("keyup", () => {
              n2 = 0;
            }), e3.on("beforeinput", (o2, i2) => {
              if (!this.isEnabled)
                return;
              const { targetRanges: r2, domEvent: s3, inputType: c2 } = i2, l2 = yk[c2];
              if (!l2)
                return;
              const d2 = { direction: l2.direction, unit: l2.unit, sequence: n2 };
              d2.unit == Ck && (d2.selectionToRemove = t3.createSelection(r2[0])), "deleteContentBackward" === c2 && (a.isAndroid && (d2.sequence = 1), function(t4) {
                if (1 != t4.length || t4[0].isCollapsed)
                  return false;
                const e4 = t4[0].getWalker({ direction: "backward", singleCharacters: true, ignoreElementEnd: true });
                let n3 = 0;
                for (const { nextPosition: t5 } of e4) {
                  if (t5.parent.is("$text")) {
                    const e5 = t5.parent.data, o3 = t5.offset;
                    if (Ni(e5, o3) || Pi(e5, o3) || Oi(e5, o3))
                      continue;
                    n3++;
                  } else
                    n3++;
                  if (n3 > 1)
                    return true;
                }
                return false;
              }(r2) && (d2.unit = Ck, d2.selectionToRemove = t3.createSelection(r2)));
              const h2 = new La(e3, "delete", r2[0]);
              e3.fire(h2, new Uc(t3, s3, d2)), h2.stop.called && o2.stop();
            }), a.isBlink && function(t4) {
              const e4 = t4.view, n3 = e4.document;
              let o2 = null, i2 = false;
              function r2(t5) {
                return t5 == fi.backspace || t5 == fi.delete;
              }
              function s3(t5) {
                return t5 == fi.backspace ? _k : vk;
              }
              n3.on("keydown", (t5, { keyCode: e5 }) => {
                o2 = e5, i2 = false;
              }), n3.on("keyup", (a2, { keyCode: c2, domEvent: l2 }) => {
                const d2 = n3.selection, h2 = t4.isEnabled && c2 == o2 && r2(c2) && !d2.isCollapsed && !i2;
                if (o2 = null, h2) {
                  const t5 = d2.getFirstRange(), o3 = new La(n3, "delete", t5), i3 = { unit: Ck, direction: s3(c2), selectionToRemove: d2 };
                  n3.fire(o3, new Uc(e4, l2, i3));
                }
              }), n3.on("beforeinput", (t5, { inputType: e5 }) => {
                const n4 = yk[e5];
                r2(o2) && n4 && n4.direction == s3(o2) && (i2 = true);
              }, { priority: "high" }), n3.on("beforeinput", (t5, { inputType: e5, data: n4 }) => {
                o2 == fi.delete && "insertText" == e5 && "\x7F" == n4 && t5.stop();
              }, { priority: "high" });
            }(this);
          }
          observe() {
          }
          stopObserving() {
          }
        }
        class Ek extends es {
          static get pluginName() {
            return "Delete";
          }
          init() {
            const t3 = this.editor, e3 = t3.editing.view, n2 = e3.document, o2 = t3.model.document;
            e3.addObserver(xk), this._undoOnBackspace = false;
            const i2 = new wk(t3, "forward");
            t3.commands.add("deleteForward", i2), t3.commands.add("forwardDelete", i2), t3.commands.add("delete", new wk(t3, "backward")), this.listenTo(n2, "delete", (o3, i3) => {
              n2.isComposing || i3.preventDefault();
              const { direction: r2, sequence: s3, selectionToRemove: a2, unit: c2 } = i3, l2 = "forward" === r2 ? "deleteForward" : "delete", d2 = { sequence: s3 };
              if ("selection" == c2) {
                const e4 = Array.from(a2.getRanges()).map((e5) => t3.editing.mapper.toModelRange(e5));
                d2.selection = t3.model.createSelection(e4);
              } else
                d2.unit = c2;
              t3.execute(l2, d2), e3.scrollToTheSelection();
            }, { priority: "low" }), this.editor.plugins.has("UndoEditing") && (this.listenTo(n2, "delete", (e4, n3) => {
              this._undoOnBackspace && "backward" == n3.direction && 1 == n3.sequence && "codePoint" == n3.unit && (this._undoOnBackspace = false, t3.execute("undo"), n3.preventDefault(), e4.stop());
            }, { context: "$capture" }), this.listenTo(o2, "change", () => {
              this._undoOnBackspace = false;
            }));
          }
          requestUndoOnBackspace() {
            this.editor.plugins.has("UndoEditing") && (this._undoOnBackspace = true);
          }
        }
        class Dk extends es {
          static get requires() {
            return [kk, Ek];
          }
          static get pluginName() {
            return "Typing";
          }
        }
        function Ik(t3, e3) {
          let n2 = t3.start;
          return { text: Array.from(t3.getWalker({ ignoreElementEnd: false })).reduce((t4, { item: o2 }) => o2.is("$text") || o2.is("$textProxy") ? t4 + o2.data : (n2 = e3.createPositionAfter(o2), ""), ""), range: e3.createRange(n2, t3.end) };
        }
        class Sk extends W() {
          constructor(t3, e3) {
            super(), this.model = t3, this.testCallback = e3, this._hasMatch = false, this.set("isEnabled", true), this.on("change:isEnabled", () => {
              this.isEnabled ? this._startListening() : (this.stopListening(t3.document.selection), this.stopListening(t3.document));
            }), this._startListening();
          }
          get hasMatch() {
            return this._hasMatch;
          }
          _startListening() {
            const t3 = this.model.document;
            this.listenTo(t3.selection, "change:range", (e3, { directChange: n2 }) => {
              n2 && (t3.selection.isCollapsed ? this._evaluateTextBeforeSelection("selection") : this.hasMatch && (this.fire("unmatched"), this._hasMatch = false));
            }), this.listenTo(t3, "change:data", (t4, e3) => {
              !e3.isUndo && e3.isLocal && this._evaluateTextBeforeSelection("data", { batch: e3 });
            });
          }
          _evaluateTextBeforeSelection(t3, e3 = {}) {
            const n2 = this.model, o2 = n2.document.selection, i2 = n2.createRange(n2.createPositionAt(o2.focus.parent, 0), o2.focus), { text: r2, range: s3 } = Ik(i2, n2), a2 = this.testCallback(r2);
            if (!a2 && this.hasMatch && this.fire("unmatched"), this._hasMatch = !!a2, a2) {
              const n3 = Object.assign(e3, { text: r2, range: s3 });
              "object" == typeof a2 && Object.assign(n3, a2), this.fire(`matched:${t3}`, n3);
            }
          }
        }
        class Tk extends es {
          constructor(t3) {
            super(t3), this._isNextGravityRestorationSkipped = false, this.attributes = /* @__PURE__ */ new Set(), this._overrideUid = null;
          }
          static get pluginName() {
            return "TwoStepCaretMovement";
          }
          init() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.editing.view, o2 = t3.locale, i2 = e3.document.selection;
            this.listenTo(n2.document, "arrowKey", (t4, e4) => {
              if (!i2.isCollapsed)
                return;
              if (e4.shiftKey || e4.altKey || e4.ctrlKey)
                return;
              const n3 = e4.keyCode == fi.arrowright, r2 = e4.keyCode == fi.arrowleft;
              if (!n3 && !r2)
                return;
              const s3 = o2.contentLanguageDirection;
              let a2 = false;
              a2 = "ltr" === s3 && n3 || "rtl" === s3 && r2 ? this._handleForwardMovement(e4) : this._handleBackwardMovement(e4), true === a2 && t4.stop();
            }, { context: "$text", priority: "highest" }), this.listenTo(i2, "change:range", (t4, e4) => {
              this._isNextGravityRestorationSkipped ? this._isNextGravityRestorationSkipped = false : this._isGravityOverridden && (!e4.directChange && Ok(i2.getFirstPosition(), this.attributes) || this._restoreGravity());
            }), this._enableClickingAfterNode(), this._enableInsertContentSelectionAttributesFixer(), this._handleDeleteContentAfterNode();
          }
          registerAttribute(t3) {
            this.attributes.add(t3);
          }
          _handleForwardMovement(t3) {
            const e3 = this.attributes, n2 = this.editor.model, o2 = n2.document.selection, i2 = o2.getFirstPosition();
            return !this._isGravityOverridden && ((!i2.isAtStart || !Mk(o2, e3)) && (!!Ok(i2, e3) && (Pk(t3), Mk(o2, e3) && Ok(i2, e3, true) ? Nk(n2, e3) : this._overrideGravity(), true)));
          }
          _handleBackwardMovement(t3) {
            const e3 = this.attributes, n2 = this.editor.model, o2 = n2.document.selection, i2 = o2.getFirstPosition();
            return this._isGravityOverridden ? (Pk(t3), this._restoreGravity(), Ok(i2, e3, true) ? Nk(n2, e3) : Bk(n2, e3, i2), true) : i2.isAtStart ? !!Mk(o2, e3) && (Pk(t3), Bk(n2, e3, i2), true) : !Mk(o2, e3) && Ok(i2, e3, true) ? (Pk(t3), Bk(n2, e3, i2), true) : !!zk(i2, e3) && (i2.isAtEnd && !Mk(o2, e3) && Ok(i2, e3) ? (Pk(t3), Bk(n2, e3, i2), true) : (this._isNextGravityRestorationSkipped = true, this._overrideGravity(), false));
          }
          _enableClickingAfterNode() {
            const t3 = this.editor, e3 = t3.model, n2 = e3.document.selection, o2 = t3.editing.view.document;
            t3.editing.view.addObserver(Mg);
            let i2 = false;
            this.listenTo(o2, "mousedown", () => {
              i2 = true;
            }), this.listenTo(o2, "selectionChange", () => {
              const t4 = this.attributes;
              if (!i2)
                return;
              if (i2 = false, !n2.isCollapsed)
                return;
              if (!Mk(n2, t4))
                return;
              const o3 = n2.getFirstPosition();
              Ok(o3, t4) && (o3.isAtStart || Ok(o3, t4, true) ? Nk(e3, t4) : this._isGravityOverridden || this._overrideGravity());
            });
          }
          _enableInsertContentSelectionAttributesFixer() {
            const t3 = this.editor.model, e3 = t3.document.selection, n2 = this.attributes;
            this.listenTo(t3, "insertContent", () => {
              const o2 = e3.getFirstPosition();
              Mk(e3, n2) && Ok(o2, n2) && Nk(t3, n2);
            }, { priority: "low" });
          }
          _handleDeleteContentAfterNode() {
            const t3 = this.editor, e3 = t3.model, n2 = e3.document.selection, o2 = t3.editing.view;
            let i2 = false, r2 = false;
            this.listenTo(o2.document, "delete", (t4, e4) => {
              i2 = "backward" === e4.direction;
            }, { priority: "high" }), this.listenTo(e3, "deleteContent", () => {
              if (!i2)
                return;
              const t4 = n2.getFirstPosition();
              r2 = Mk(n2, this.attributes) && !zk(t4, this.attributes);
            }, { priority: "high" }), this.listenTo(e3, "deleteContent", () => {
              i2 && (i2 = false, r2 || t3.model.enqueueChange(() => {
                const t4 = n2.getFirstPosition();
                Mk(n2, this.attributes) && Ok(t4, this.attributes) && (t4.isAtStart || Ok(t4, this.attributes, true) ? Nk(e3, this.attributes) : this._isGravityOverridden || this._overrideGravity());
              }));
            }, { priority: "low" });
          }
          get _isGravityOverridden() {
            return !!this._overrideUid;
          }
          _overrideGravity() {
            this._overrideUid = this.editor.model.change((t3) => t3.overrideSelectionGravity());
          }
          _restoreGravity() {
            this.editor.model.change((t3) => {
              t3.restoreSelectionGravity(this._overrideUid), this._overrideUid = null;
            });
          }
        }
        function Mk(t3, e3) {
          for (const n2 of e3)
            if (t3.hasAttribute(n2))
              return true;
          return false;
        }
        function Bk(t3, e3, n2) {
          const o2 = n2.nodeBefore;
          t3.change((n3) => {
            if (o2) {
              const e4 = [], i2 = t3.schema.isObject(o2) && t3.schema.isInline(o2);
              for (const [n4, r2] of o2.getAttributes())
                !t3.schema.checkAttribute("$text", n4) || i2 && false === t3.schema.getAttributeProperties(n4).copyFromObject || e4.push([n4, r2]);
              n3.setSelectionAttribute(e4);
            } else
              n3.removeSelectionAttribute(e3);
          });
        }
        function Nk(t3, e3) {
          t3.change((t4) => {
            t4.removeSelectionAttribute(e3);
          });
        }
        function Pk(t3) {
          t3.preventDefault();
        }
        function zk(t3, e3) {
          return Ok(t3.getShiftedBy(-1), e3);
        }
        function Ok(t3, e3, n2 = false) {
          const { nodeBefore: o2, nodeAfter: i2 } = t3;
          for (const t4 of e3) {
            const e4 = o2 ? o2.getAttribute(t4) : void 0, r2 = i2 ? i2.getAttribute(t4) : void 0;
            if ((!n2 || void 0 !== e4 && void 0 !== r2) && r2 !== e4)
              return true;
          }
          return false;
        }
        const Lk = { copyright: { from: "(c)", to: "\xA9" }, registeredTrademark: { from: "(r)", to: "\xAE" }, trademark: { from: "(tm)", to: "\u2122" }, oneHalf: { from: /(^|[^/a-z0-9])(1\/2)([^/a-z0-9])$/i, to: [null, "\xBD", null] }, oneThird: { from: /(^|[^/a-z0-9])(1\/3)([^/a-z0-9])$/i, to: [null, "\u2153", null] }, twoThirds: { from: /(^|[^/a-z0-9])(2\/3)([^/a-z0-9])$/i, to: [null, "\u2154", null] }, oneForth: { from: /(^|[^/a-z0-9])(1\/4)([^/a-z0-9])$/i, to: [null, "\xBC", null] }, threeQuarters: { from: /(^|[^/a-z0-9])(3\/4)([^/a-z0-9])$/i, to: [null, "\xBE", null] }, lessThanOrEqual: { from: "<=", to: "\u2264" }, greaterThanOrEqual: { from: ">=", to: "\u2265" }, notEqual: { from: "!=", to: "\u2260" }, arrowLeft: { from: "<-", to: "\u2190" }, arrowRight: { from: "->", to: "\u2192" }, horizontalEllipsis: { from: "...", to: "\u2026" }, enDash: { from: /(^| )(--)( )$/, to: [null, "\u2013", null] }, emDash: { from: /(^| )(---)( )$/, to: [null, "\u2014", null] }, quotesPrimary: { from: Hk('"'), to: [null, "\u201C", null, "\u201D"] }, quotesSecondary: { from: Hk("'"), to: [null, "\u2018", null, "\u2019"] }, quotesPrimaryEnGb: { from: Hk("'"), to: [null, "\u2018", null, "\u2019"] }, quotesSecondaryEnGb: { from: Hk('"'), to: [null, "\u201C", null, "\u201D"] }, quotesPrimaryPl: { from: Hk('"'), to: [null, "\u201E", null, "\u201D"] }, quotesSecondaryPl: { from: Hk("'"), to: [null, "\u201A", null, "\u2019"] } }, Rk = { symbols: ["copyright", "registeredTrademark", "trademark"], mathematical: ["oneHalf", "oneThird", "twoThirds", "oneForth", "threeQuarters", "lessThanOrEqual", "greaterThanOrEqual", "notEqual", "arrowLeft", "arrowRight"], typography: ["horizontalEllipsis", "enDash", "emDash"], quotes: ["quotesPrimary", "quotesSecondary"] }, jk = ["symbols", "mathematical", "typography", "quotes"];
        function Fk(t3) {
          return "string" == typeof t3 ? new RegExp(`(${ff(t3)})$`) : t3;
        }
        function Vk(t3) {
          return "string" == typeof t3 ? () => [t3] : t3 instanceof Array ? () => t3 : t3;
        }
        function Uk(t3) {
          return (t3.textNode ? t3.textNode : t3.nodeAfter).getAttributes();
        }
        function Hk(t3) {
          return new RegExp(`(^|\\s)(${t3})([^${t3}]*)(${t3})$`);
        }
        function qk(t3, e3, n2, o2) {
          return o2.createRange(Gk(t3, e3, n2, true, o2), Gk(t3, e3, n2, false, o2));
        }
        function Gk(t3, e3, n2, o2, i2) {
          let r2 = t3.textNode || (o2 ? t3.nodeBefore : t3.nodeAfter), s3 = null;
          for (; r2 && r2.getAttribute(e3) == n2; )
            s3 = r2, r2 = o2 ? r2.previousSibling : r2.nextSibling;
          return s3 ? i2.createPositionAt(s3, o2 ? "before" : "after") : t3;
        }
        function* Wk(t3, e3) {
          for (const n2 of e3)
            n2 && t3.getAttributeProperties(n2[0]).copyOnEnter && (yield n2);
        }
        class Kk extends os {
          execute() {
            this.editor.model.change((t3) => {
              this.enterBlock(t3), this.fire("afterExecute", { writer: t3 });
            });
          }
          enterBlock(t3) {
            const e3 = this.editor.model, n2 = e3.document.selection, o2 = e3.schema, i2 = n2.isCollapsed, r2 = n2.getFirstRange(), s3 = r2.start.parent, a2 = r2.end.parent;
            if (o2.isLimit(s3) || o2.isLimit(a2))
              return i2 || s3 != a2 || e3.deleteContent(n2), false;
            if (i2) {
              const e4 = Wk(t3.model.schema, n2.getAttributes());
              return Zk(t3, r2.start), t3.setSelectionAttribute(e4), true;
            }
            {
              const o3 = !(r2.start.isAtStart && r2.end.isAtEnd), i3 = s3 == a2;
              if (e3.deleteContent(n2, { leaveUnmerged: o3 }), o3) {
                if (i3)
                  return Zk(t3, n2.focus), true;
                t3.setSelection(a2, 0);
              }
            }
            return false;
          }
        }
        function Zk(t3, e3) {
          t3.split(e3), t3.setSelection(e3.parent.nextSibling, 0);
        }
        const Yk = { insertParagraph: { isSoft: false }, insertLineBreak: { isSoft: true } };
        class $k extends Fc {
          constructor(t3) {
            super(t3);
            const e3 = this.document;
            let n2 = false;
            e3.on("keydown", (t4, e4) => {
              n2 = e4.shiftKey;
            }), e3.on("beforeinput", (o2, i2) => {
              if (!this.isEnabled)
                return;
              let r2 = i2.inputType;
              a.isSafari && n2 && "insertParagraph" == r2 && (r2 = "insertLineBreak");
              const s3 = i2.domEvent, c2 = Yk[r2];
              if (!c2)
                return;
              const l2 = new La(e3, "enter", i2.targetRanges[0]);
              e3.fire(l2, new Uc(t3, s3, { isSoft: c2.isSoft })), l2.stop.called && o2.stop();
            });
          }
          observe() {
          }
          stopObserving() {
          }
        }
        class Qk extends es {
          static get pluginName() {
            return "Enter";
          }
          init() {
            const t3 = this.editor, e3 = t3.editing.view, n2 = e3.document;
            e3.addObserver($k), t3.commands.add("enter", new Kk(t3)), this.listenTo(n2, "enter", (o2, i2) => {
              n2.isComposing || i2.preventDefault(), i2.isSoft || (t3.execute("enter"), e3.scrollToTheSelection());
            }, { priority: "low" });
          }
        }
        class Jk extends os {
          execute() {
            const t3 = this.editor.model, e3 = t3.document;
            t3.change((n2) => {
              !function(t4, e4, n3) {
                const o2 = n3.isCollapsed, i2 = n3.getFirstRange(), r2 = i2.start.parent, s3 = i2.end.parent, a2 = r2 == s3;
                if (o2) {
                  const o3 = Wk(t4.schema, n3.getAttributes());
                  Xk(t4, e4, i2.end), e4.removeSelectionAttribute(n3.getAttributeKeys()), e4.setSelectionAttribute(o3);
                } else {
                  const o3 = !(i2.start.isAtStart && i2.end.isAtEnd);
                  t4.deleteContent(n3, { leaveUnmerged: o3 }), a2 ? Xk(t4, e4, n3.focus) : o3 && e4.setSelection(s3, 0);
                }
              }(t3, n2, e3.selection), this.fire("afterExecute", { writer: n2 });
            });
          }
          refresh() {
            const t3 = this.editor.model, e3 = t3.document;
            this.isEnabled = function(t4, e4) {
              if (e4.rangeCount > 1)
                return false;
              const n2 = e4.anchor;
              if (!n2 || !t4.checkChild(n2, "softBreak"))
                return false;
              const o2 = e4.getFirstRange(), i2 = o2.start.parent, r2 = o2.end.parent;
              if ((tb(i2, t4) || tb(r2, t4)) && i2 !== r2)
                return false;
              return true;
            }(t3.schema, e3.selection);
          }
        }
        function Xk(t3, e3, n2) {
          const o2 = e3.createElement("softBreak");
          t3.insertContent(o2, n2), e3.setSelection(o2, "after");
        }
        function tb(t3, e3) {
          return !t3.is("rootElement") && (e3.isLimit(t3) || tb(t3.parent, e3));
        }
        class eb extends es {
          static get pluginName() {
            return "ShiftEnter";
          }
          init() {
            const t3 = this.editor, e3 = t3.model.schema, n2 = t3.conversion, o2 = t3.editing.view, i2 = o2.document;
            e3.register("softBreak", { allowWhere: "$text", isInline: true }), n2.for("upcast").elementToElement({ model: "softBreak", view: "br" }), n2.for("downcast").elementToElement({ model: "softBreak", view: (t4, { writer: e4 }) => e4.createEmptyElement("br") }), o2.addObserver($k), t3.commands.add("shiftEnter", new Jk(t3)), this.listenTo(i2, "enter", (e4, n3) => {
              i2.isComposing || n3.preventDefault(), n3.isSoft && (t3.execute("shiftEnter"), o2.scrollToTheSelection());
            }, { priority: "low" });
          }
        }
        class nb extends M() {
          constructor() {
            super(...arguments), this._stack = [];
          }
          add(t3, e3) {
            const n2 = this._stack, o2 = n2[0];
            this._insertDescriptor(t3);
            const i2 = n2[0];
            o2 === i2 || ob(o2, i2) || this.fire("change:top", { oldDescriptor: o2, newDescriptor: i2, writer: e3 });
          }
          remove(t3, e3) {
            const n2 = this._stack, o2 = n2[0];
            this._removeDescriptor(t3);
            const i2 = n2[0];
            o2 === i2 || ob(o2, i2) || this.fire("change:top", { oldDescriptor: o2, newDescriptor: i2, writer: e3 });
          }
          _insertDescriptor(t3) {
            const e3 = this._stack, n2 = e3.findIndex((e4) => e4.id === t3.id);
            if (ob(t3, e3[n2]))
              return;
            n2 > -1 && e3.splice(n2, 1);
            let o2 = 0;
            for (; e3[o2] && ib(e3[o2], t3); )
              o2++;
            e3.splice(o2, 0, t3);
          }
          _removeDescriptor(t3) {
            const e3 = this._stack, n2 = e3.findIndex((e4) => e4.id === t3);
            n2 > -1 && e3.splice(n2, 1);
          }
        }
        function ob(t3, e3) {
          return t3 && e3 && t3.priority == e3.priority && rb(t3.classes) == rb(e3.classes);
        }
        function ib(t3, e3) {
          return t3.priority > e3.priority || !(t3.priority < e3.priority) && rb(t3.classes) > rb(e3.classes);
        }
        function rb(t3) {
          return Array.isArray(t3) ? t3.sort().join(",") : t3;
        }
        const sb = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M4 0v1H1v3H0V.5A.5.5 0 0 1 .5 0H4zm8 0h3.5a.5.5 0 0 1 .5.5V4h-1V1h-3V0zM4 16H.5a.5.5 0 0 1-.5-.5V12h1v3h3v1zm8 0v-1h3v-3h1v3.5a.5.5 0 0 1-.5.5H12z"/><path fill-opacity=".256" d="M1 1h14v14H1z"/><g class="ck-icon__selected-indicator"><path d="M7 0h2v1H7V0zM0 7h1v2H0V7zm15 0h1v2h-1V7zm-8 8h2v1H7v-1z"/><path fill-opacity=".254" d="M1 1h14v14H1z"/></g></svg>', ab = "ck-widget", cb = "ck-widget_selected";
        function lb(t3) {
          return !!t3.is("element") && !!t3.getCustomProperty("widget");
        }
        function db(t3, e3, n2 = {}) {
          if (!t3.is("containerElement"))
            throw new A("widget-to-widget-wrong-element-type", null, { element: t3 });
          return e3.setAttribute("contenteditable", "false", t3), e3.addClass(ab, t3), e3.setCustomProperty("widget", true, t3), t3.getFillerOffset = fb, e3.setCustomProperty("widgetLabel", [], t3), n2.label && function(t4, e4) {
            const n3 = t4.getCustomProperty("widgetLabel");
            n3.push(e4);
          }(t3, n2.label), n2.hasSelectionHandle && function(t4, e4) {
            const n3 = e4.createUIElement("div", { class: "ck ck-widget__selection-handle" }, function(t5) {
              const e5 = this.toDomElement(t5), n4 = new pr();
              return n4.set("content", sb), n4.render(), e5.appendChild(n4.element), e5;
            });
            e4.insert(e4.createPositionAt(t4, 0), n3), e4.addClass(["ck-widget_with-selection-handle"], t4);
          }(t3, e3), gb(t3, e3), t3;
        }
        function hb(t3, e3, n2) {
          if (e3.classes && n2.addClass(_i(e3.classes), t3), e3.attributes)
            for (const o2 in e3.attributes)
              n2.setAttribute(o2, e3.attributes[o2], t3);
        }
        function ub(t3, e3, n2) {
          if (e3.classes && n2.removeClass(_i(e3.classes), t3), e3.attributes)
            for (const o2 in e3.attributes)
              n2.removeAttribute(o2, t3);
        }
        function gb(t3, e3, n2 = hb, o2 = ub) {
          const i2 = new nb();
          i2.on("change:top", (e4, i3) => {
            i3.oldDescriptor && o2(t3, i3.oldDescriptor, i3.writer), i3.newDescriptor && n2(t3, i3.newDescriptor, i3.writer);
          });
          e3.setCustomProperty("addHighlight", (t4, e4, n3) => i2.add(e4, n3), t3), e3.setCustomProperty("removeHighlight", (t4, e4, n3) => i2.remove(e4, n3), t3);
        }
        function pb(t3, e3, n2 = {}) {
          return e3.addClass(["ck-editor__editable", "ck-editor__nested-editable"], t3), e3.setAttribute("role", "textbox", t3), n2.label && e3.setAttribute("aria-label", n2.label, t3), e3.setAttribute("contenteditable", t3.isReadOnly ? "false" : "true", t3), t3.on("change:isReadOnly", (n3, o2, i2) => {
            e3.setAttribute("contenteditable", i2 ? "false" : "true", t3);
          }), t3.on("change:isFocused", (n3, o2, i2) => {
            i2 ? e3.addClass("ck-editor__nested-editable_focused", t3) : e3.removeClass("ck-editor__nested-editable_focused", t3);
          }), gb(t3, e3), t3;
        }
        function mb(t3, e3) {
          const n2 = t3.getSelectedElement();
          if (n2) {
            const o2 = wb(t3);
            if (o2)
              return e3.createRange(e3.createPositionAt(n2, o2));
          }
          return Cg(t3, e3);
        }
        function fb() {
          return null;
        }
        const kb = "widget-type-around";
        function bb(t3, e3, n2) {
          return !!t3 && lb(t3) && !n2.isInline(e3);
        }
        function wb(t3) {
          return t3.getAttribute(kb);
        }
        var Ab = n(4921), Cb = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Ab.Z, Cb);
        Ab.Z.locals;
        const _b = ["before", "after"], vb = new DOMParser().parseFromString('<svg viewBox="0 0 10 8" xmlns="http://www.w3.org/2000/svg"><path d="M9.055.263v3.972h-6.77M1 4.216l2-2.038m-2 2 2 2.038"/></svg>', "image/svg+xml").firstChild, yb = "ck-widget__type-around_disabled";
        class xb extends es {
          constructor() {
            super(...arguments), this._currentFakeCaretModelElement = null;
          }
          static get pluginName() {
            return "WidgetTypeAround";
          }
          static get requires() {
            return [Qk, Ek];
          }
          init() {
            const t3 = this.editor, e3 = t3.editing.view;
            this.on("change:isEnabled", (n2, o2, i2) => {
              e3.change((t4) => {
                for (const n3 of e3.document.roots)
                  i2 ? t4.removeClass(yb, n3) : t4.addClass(yb, n3);
              }), i2 || t3.model.change((t4) => {
                t4.removeSelectionAttribute(kb);
              });
            }), this._enableTypeAroundUIInjection(), this._enableInsertingParagraphsOnButtonClick(), this._enableInsertingParagraphsOnEnterKeypress(), this._enableInsertingParagraphsOnTypingKeystroke(), this._enableTypeAroundFakeCaretActivationUsingKeyboardArrows(), this._enableDeleteIntegration(), this._enableInsertContentIntegration(), this._enableInsertObjectIntegration(), this._enableDeleteContentIntegration();
          }
          destroy() {
            super.destroy(), this._currentFakeCaretModelElement = null;
          }
          _insertParagraph(t3, e3) {
            const n2 = this.editor, o2 = n2.editing.view, i2 = n2.model.schema.getAttributesWithProperty(t3, "copyOnReplace", true);
            n2.execute("insertParagraph", { position: n2.model.createPositionAt(t3, e3), attributes: i2 }), o2.focus(), o2.scrollToTheSelection();
          }
          _listenToIfEnabled(t3, e3, n2, o2) {
            this.listenTo(t3, e3, (...t4) => {
              this.isEnabled && n2(...t4);
            }, o2);
          }
          _insertParagraphAccordingToFakeCaretPosition() {
            const t3 = this.editor.model.document.selection, e3 = wb(t3);
            if (!e3)
              return false;
            const n2 = t3.getSelectedElement();
            return this._insertParagraph(n2, e3), true;
          }
          _enableTypeAroundUIInjection() {
            const t3 = this.editor, e3 = t3.model.schema, n2 = t3.locale.t, o2 = { before: n2("Insert paragraph before block"), after: n2("Insert paragraph after block") };
            t3.editing.downcastDispatcher.on("insert", (t4, i2, r2) => {
              const s3 = r2.mapper.toViewElement(i2.item);
              if (s3 && bb(s3, i2.item, e3)) {
                !function(t5, e4, n3) {
                  const o3 = t5.createUIElement("div", { class: "ck ck-reset_all ck-widget__type-around" }, function(t6) {
                    const n4 = this.toDomElement(t6);
                    return function(t7, e5) {
                      for (const n5 of _b) {
                        const o4 = new Hi({ tag: "div", attributes: { class: ["ck", "ck-widget__type-around__button", `ck-widget__type-around__button_${n5}`], title: e5[n5], "aria-hidden": "true" }, children: [t7.ownerDocument.importNode(vb, true)] });
                        t7.appendChild(o4.render());
                      }
                    }(n4, e4), function(t7) {
                      const e5 = new Hi({ tag: "div", attributes: { class: ["ck", "ck-widget__type-around__fake-caret"] } });
                      t7.appendChild(e5.render());
                    }(n4), n4;
                  });
                  t5.insert(t5.createPositionAt(n3, "end"), o3);
                }(r2.writer, o2, s3);
                s3.getCustomProperty("widgetLabel").push(() => this.isEnabled ? n2("Press Enter to type after or press Shift + Enter to type before the widget") : "");
              }
            }, { priority: "low" });
          }
          _enableTypeAroundFakeCaretActivationUsingKeyboardArrows() {
            const t3 = this.editor, e3 = t3.model, n2 = e3.document.selection, o2 = e3.schema, i2 = t3.editing.view;
            function r2(t4) {
              return `ck-widget_type-around_show-fake-caret_${t4}`;
            }
            this._listenToIfEnabled(i2.document, "arrowKey", (t4, e4) => {
              this._handleArrowKeyPress(t4, e4);
            }, { context: [lb, "$text"], priority: "high" }), this._listenToIfEnabled(n2, "change:range", (e4, n3) => {
              n3.directChange && t3.model.change((t4) => {
                t4.removeSelectionAttribute(kb);
              });
            }), this._listenToIfEnabled(e3.document, "change:data", () => {
              const e4 = n2.getSelectedElement();
              if (e4) {
                if (bb(t3.editing.mapper.toViewElement(e4), e4, o2))
                  return;
              }
              t3.model.change((t4) => {
                t4.removeSelectionAttribute(kb);
              });
            }), this._listenToIfEnabled(t3.editing.downcastDispatcher, "selection", (t4, e4, n3) => {
              const i3 = n3.writer;
              if (this._currentFakeCaretModelElement) {
                const t5 = n3.mapper.toViewElement(this._currentFakeCaretModelElement);
                t5 && (i3.removeClass(_b.map(r2), t5), this._currentFakeCaretModelElement = null);
              }
              const s3 = e4.selection.getSelectedElement();
              if (!s3)
                return;
              const a2 = n3.mapper.toViewElement(s3);
              if (!bb(a2, s3, o2))
                return;
              const c2 = wb(e4.selection);
              c2 && (i3.addClass(r2(c2), a2), this._currentFakeCaretModelElement = s3);
            }), this._listenToIfEnabled(t3.ui.focusTracker, "change:isFocused", (e4, n3, o3) => {
              o3 || t3.model.change((t4) => {
                t4.removeSelectionAttribute(kb);
              });
            });
          }
          _handleArrowKeyPress(t3, e3) {
            const n2 = this.editor, o2 = n2.model, i2 = o2.document.selection, r2 = o2.schema, s3 = n2.editing.view, a2 = function(t4, e4) {
              const n3 = Ci(t4, e4);
              return "down" === n3 || "right" === n3;
            }(e3.keyCode, n2.locale.contentLanguageDirection), c2 = s3.document.selection.getSelectedElement();
            let l2;
            bb(c2, n2.editing.mapper.toModelElement(c2), r2) ? l2 = this._handleArrowKeyPressOnSelectedWidget(a2) : i2.isCollapsed ? l2 = this._handleArrowKeyPressWhenSelectionNextToAWidget(a2) : e3.shiftKey || (l2 = this._handleArrowKeyPressWhenNonCollapsedSelection(a2)), l2 && (e3.preventDefault(), t3.stop());
          }
          _handleArrowKeyPressOnSelectedWidget(t3) {
            const e3 = this.editor.model, n2 = wb(e3.document.selection);
            return e3.change((e4) => {
              if (!n2)
                return e4.setSelectionAttribute(kb, t3 ? "after" : "before"), true;
              if (!(n2 === (t3 ? "after" : "before")))
                return e4.removeSelectionAttribute(kb), true;
              return false;
            });
          }
          _handleArrowKeyPressWhenSelectionNextToAWidget(t3) {
            const e3 = this.editor, n2 = e3.model, o2 = n2.schema, i2 = e3.plugins.get("Widget"), r2 = i2._getObjectElementNextToSelection(t3);
            return !!bb(e3.editing.mapper.toViewElement(r2), r2, o2) && (n2.change((e4) => {
              i2._setSelectionOverElement(r2), e4.setSelectionAttribute(kb, t3 ? "before" : "after");
            }), true);
          }
          _handleArrowKeyPressWhenNonCollapsedSelection(t3) {
            const e3 = this.editor, n2 = e3.model, o2 = n2.schema, i2 = e3.editing.mapper, r2 = n2.document.selection, s3 = t3 ? r2.getLastPosition().nodeBefore : r2.getFirstPosition().nodeAfter;
            return !!bb(i2.toViewElement(s3), s3, o2) && (n2.change((e4) => {
              e4.setSelection(s3, "on"), e4.setSelectionAttribute(kb, t3 ? "after" : "before");
            }), true);
          }
          _enableInsertingParagraphsOnButtonClick() {
            const t3 = this.editor, e3 = t3.editing.view;
            this._listenToIfEnabled(e3.document, "mousedown", (n2, o2) => {
              const i2 = o2.domTarget.closest(".ck-widget__type-around__button");
              if (!i2)
                return;
              const r2 = function(t4) {
                return t4.classList.contains("ck-widget__type-around__button_before") ? "before" : "after";
              }(i2), s3 = function(t4, e4) {
                const n3 = t4.closest(".ck-widget");
                return e4.mapDomToView(n3);
              }(i2, e3.domConverter), a2 = t3.editing.mapper.toModelElement(s3);
              this._insertParagraph(a2, r2), o2.preventDefault(), n2.stop();
            });
          }
          _enableInsertingParagraphsOnEnterKeypress() {
            const t3 = this.editor, e3 = t3.model.document.selection, n2 = t3.editing.view;
            this._listenToIfEnabled(n2.document, "enter", (n3, o2) => {
              if ("atTarget" != n3.eventPhase)
                return;
              const i2 = e3.getSelectedElement(), r2 = t3.editing.mapper.toViewElement(i2), s3 = t3.model.schema;
              let a2;
              this._insertParagraphAccordingToFakeCaretPosition() ? a2 = true : bb(r2, i2, s3) && (this._insertParagraph(i2, o2.isSoft ? "before" : "after"), a2 = true), a2 && (o2.preventDefault(), n3.stop());
            }, { context: lb });
          }
          _enableInsertingParagraphsOnTypingKeystroke() {
            const t3 = this.editor.editing.view.document;
            this._listenToIfEnabled(t3, "insertText", (e3, n2) => {
              this._insertParagraphAccordingToFakeCaretPosition() && (n2.selection = t3.selection);
            }, { priority: "high" }), a.isAndroid ? this._listenToIfEnabled(t3, "keydown", (t4, e3) => {
              229 == e3.keyCode && this._insertParagraphAccordingToFakeCaretPosition();
            }) : this._listenToIfEnabled(t3, "compositionstart", () => {
              this._insertParagraphAccordingToFakeCaretPosition();
            }, { priority: "high" });
          }
          _enableDeleteIntegration() {
            const t3 = this.editor, e3 = t3.editing.view, n2 = t3.model, o2 = n2.schema;
            this._listenToIfEnabled(e3.document, "delete", (e4, i2) => {
              if ("atTarget" != e4.eventPhase)
                return;
              const r2 = wb(n2.document.selection);
              if (!r2)
                return;
              const s3 = i2.direction, a2 = n2.document.selection.getSelectedElement(), c2 = "forward" == s3;
              if ("before" === r2 === c2)
                t3.execute("delete", { selection: n2.createSelection(a2, "on") });
              else {
                const e5 = o2.getNearestSelectionRange(n2.createPositionAt(a2, r2), s3);
                if (e5)
                  if (e5.isCollapsed) {
                    const i3 = n2.createSelection(e5.start);
                    if (n2.modifySelection(i3, { direction: s3 }), i3.focus.isEqual(e5.start)) {
                      const t4 = function(t5, e6) {
                        let n3 = e6;
                        for (const o3 of e6.getAncestors({ parentFirst: true })) {
                          if (o3.childCount > 1 || t5.isLimit(o3))
                            break;
                          n3 = o3;
                        }
                        return n3;
                      }(o2, e5.start.parent);
                      n2.deleteContent(n2.createSelection(t4, "on"), { doNotAutoparagraph: true });
                    } else
                      n2.change((n3) => {
                        n3.setSelection(e5), t3.execute(c2 ? "deleteForward" : "delete");
                      });
                  } else
                    n2.change((n3) => {
                      n3.setSelection(e5), t3.execute(c2 ? "deleteForward" : "delete");
                    });
              }
              i2.preventDefault(), e4.stop();
            }, { context: lb });
          }
          _enableInsertContentIntegration() {
            const t3 = this.editor, e3 = this.editor.model, n2 = e3.document.selection;
            this._listenToIfEnabled(t3.model, "insertContent", (t4, [o2, i2]) => {
              if (i2 && !i2.is("documentSelection"))
                return;
              const r2 = wb(n2);
              return r2 ? (t4.stop(), e3.change((t5) => {
                const i3 = n2.getSelectedElement(), s3 = e3.createPositionAt(i3, r2), a2 = t5.createSelection(s3), c2 = e3.insertContent(o2, a2);
                return t5.setSelection(a2), c2;
              })) : void 0;
            }, { priority: "high" });
          }
          _enableInsertObjectIntegration() {
            const t3 = this.editor, e3 = this.editor.model.document.selection;
            this._listenToIfEnabled(t3.model, "insertObject", (t4, n2) => {
              const [, o2, i2 = {}] = n2;
              if (o2 && !o2.is("documentSelection"))
                return;
              const r2 = wb(e3);
              r2 && (i2.findOptimalPosition = r2, n2[3] = i2);
            }, { priority: "high" });
          }
          _enableDeleteContentIntegration() {
            const t3 = this.editor, e3 = this.editor.model.document.selection;
            this._listenToIfEnabled(t3.model, "deleteContent", (t4, [n2]) => {
              if (n2 && !n2.is("documentSelection"))
                return;
              wb(e3) && t4.stop();
            }, { priority: "high" });
          }
        }
        function Eb(t3) {
          const e3 = t3.model;
          return (n2, o2) => {
            const i2 = o2.keyCode == fi.arrowup, r2 = o2.keyCode == fi.arrowdown, s3 = o2.shiftKey, a2 = e3.document.selection;
            if (!i2 && !r2)
              return;
            const c2 = r2;
            if (s3 && function(t4, e4) {
              return !t4.isCollapsed && t4.isBackward == e4;
            }(a2, c2))
              return;
            const l2 = function(t4, e4, n3) {
              const o3 = t4.model;
              if (n3) {
                const t5 = e4.isCollapsed ? e4.focus : e4.getLastPosition(), n4 = Db(o3, t5, "forward");
                if (!n4)
                  return null;
                const i3 = o3.createRange(t5, n4), r3 = Ib(o3.schema, i3, "backward");
                return r3 ? o3.createRange(t5, r3) : null;
              }
              {
                const t5 = e4.isCollapsed ? e4.focus : e4.getFirstPosition(), n4 = Db(o3, t5, "backward");
                if (!n4)
                  return null;
                const i3 = o3.createRange(n4, t5), r3 = Ib(o3.schema, i3, "forward");
                return r3 ? o3.createRange(r3, t5) : null;
              }
            }(t3, a2, c2);
            if (l2) {
              if (l2.isCollapsed) {
                if (a2.isCollapsed)
                  return;
                if (s3)
                  return;
              }
              (l2.isCollapsed || function(t4, e4, n3) {
                const o3 = t4.model, i3 = t4.view.domConverter;
                if (n3) {
                  const t5 = o3.createSelection(e4.start);
                  o3.modifySelection(t5), t5.focus.isAtEnd || e4.start.isEqual(t5.focus) || (e4 = o3.createRange(t5.focus, e4.end));
                }
                const r3 = t4.mapper.toViewRange(e4), s4 = i3.viewRangeToDom(r3), a3 = Vo.getDomRangeRects(s4);
                let c3;
                for (const t5 of a3)
                  if (void 0 !== c3) {
                    if (Math.round(t5.top) >= c3)
                      return false;
                    c3 = Math.max(c3, Math.round(t5.bottom));
                  } else
                    c3 = Math.round(t5.bottom);
                return true;
              }(t3, l2, c2)) && (e3.change((t4) => {
                const n3 = c2 ? l2.end : l2.start;
                if (s3) {
                  const o3 = e3.createSelection(a2.anchor);
                  o3.setFocus(n3), t4.setSelection(o3);
                } else
                  t4.setSelection(n3);
              }), n2.stop(), o2.preventDefault(), o2.stopPropagation());
            }
          };
        }
        function Db(t3, e3, n2) {
          const o2 = t3.schema, i2 = t3.createRangeIn(e3.root), r2 = "forward" == n2 ? "elementStart" : "elementEnd";
          for (const { previousPosition: t4, item: s3, type: a2 } of i2.getWalker({ startPosition: e3, direction: n2 })) {
            if (o2.isLimit(s3) && !o2.isInline(s3))
              return t4;
            if (a2 == r2 && o2.isBlock(s3))
              return null;
          }
          return null;
        }
        function Ib(t3, e3, n2) {
          const o2 = "backward" == n2 ? e3.end : e3.start;
          if (t3.checkChild(o2, "$text"))
            return o2;
          for (const { nextPosition: o3 } of e3.getWalker({ direction: n2 }))
            if (t3.checkChild(o3, "$text"))
              return o3;
          return null;
        }
        var Sb = n(3488), Tb = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Sb.Z, Tb);
        Sb.Z.locals;
        class Mb extends es {
          constructor() {
            super(...arguments), this._previouslySelected = /* @__PURE__ */ new Set();
          }
          static get pluginName() {
            return "Widget";
          }
          static get requires() {
            return [xb, Ek];
          }
          init() {
            const t3 = this.editor, e3 = t3.editing.view, n2 = e3.document;
            this.editor.editing.downcastDispatcher.on("selection", (e4, n3, o2) => {
              const i2 = o2.writer, r2 = n3.selection;
              if (r2.isCollapsed)
                return;
              const s3 = r2.getSelectedElement();
              if (!s3)
                return;
              const a2 = t3.editing.mapper.toViewElement(s3);
              var c2;
              lb(a2) && (o2.consumable.consume(r2, "selection") && i2.setSelection(i2.createRangeOn(a2), { fake: true, label: (c2 = a2, c2.getCustomProperty("widgetLabel").reduce((t4, e5) => "function" == typeof e5 ? t4 ? t4 + ". " + e5() : e5() : t4 ? t4 + ". " + e5 : e5, "")) }));
            }), this.editor.editing.downcastDispatcher.on("selection", (t4, e4, n3) => {
              this._clearPreviouslySelectedWidgets(n3.writer);
              const o2 = n3.writer, i2 = o2.document.selection;
              let r2 = null;
              for (const t5 of i2.getRanges())
                for (const e5 of t5) {
                  const t6 = e5.item;
                  lb(t6) && !Bb(t6, r2) && (o2.addClass(cb, t6), this._previouslySelected.add(t6), r2 = t6);
                }
            }, { priority: "low" }), e3.addObserver(Mg), this.listenTo(n2, "mousedown", (...t4) => this._onMousedown(...t4)), this.listenTo(n2, "arrowKey", (...t4) => {
              this._handleSelectionChangeOnArrowKeyPress(...t4);
            }, { context: [lb, "$text"] }), this.listenTo(n2, "arrowKey", (...t4) => {
              this._preventDefaultOnArrowKeyPress(...t4);
            }, { context: "$root" }), this.listenTo(n2, "arrowKey", Eb(this.editor.editing), { context: "$text" }), this.listenTo(n2, "delete", (t4, e4) => {
              this._handleDelete("forward" == e4.direction) && (e4.preventDefault(), t4.stop());
            }, { context: "$root" });
          }
          _onMousedown(t3, e3) {
            const n2 = this.editor, o2 = n2.editing.view, i2 = o2.document;
            let r2 = e3.target;
            if (e3.domEvent.detail >= 3)
              return void (this._selectBlockContent(r2) && e3.preventDefault());
            if (function(t4) {
              let e4 = t4;
              for (; e4; ) {
                if (e4.is("editableElement") && !e4.is("rootElement"))
                  return true;
                if (lb(e4))
                  return false;
                e4 = e4.parent;
              }
              return false;
            }(r2))
              return;
            if (!lb(r2) && (r2 = r2.findAncestor(lb), !r2))
              return;
            a.isAndroid && e3.preventDefault(), i2.isFocused || o2.focus();
            const s3 = n2.editing.mapper.toModelElement(r2);
            this._setSelectionOverElement(s3);
          }
          _selectBlockContent(t3) {
            const e3 = this.editor, n2 = e3.model, o2 = e3.editing.mapper, i2 = n2.schema, r2 = o2.findMappedViewAncestor(this.editor.editing.view.createPositionAt(t3, 0)), s3 = function(t4, e4) {
              for (const n3 of t4.getAncestors({ includeSelf: true, parentFirst: true })) {
                if (e4.checkChild(n3, "$text"))
                  return n3;
                if (e4.isLimit(n3) && !e4.isObject(n3))
                  break;
              }
              return null;
            }(o2.toModelElement(r2), n2.schema);
            return !!s3 && (n2.change((t4) => {
              const e4 = i2.isLimit(s3) ? null : function(t5, e5) {
                const n4 = new ql({ startPosition: t5 });
                for (const { item: t6 } of n4) {
                  if (e5.isLimit(t6) || !t6.is("element"))
                    return null;
                  if (e5.checkChild(t6, "$text"))
                    return t6;
                }
                return null;
              }(t4.createPositionAfter(s3), i2), n3 = t4.createPositionAt(s3, 0), o3 = e4 ? t4.createPositionAt(e4, 0) : t4.createPositionAt(s3, "end");
              t4.setSelection(t4.createRange(n3, o3));
            }), true);
          }
          _handleSelectionChangeOnArrowKeyPress(t3, e3) {
            const n2 = e3.keyCode, o2 = this.editor.model, i2 = o2.schema, r2 = o2.document.selection, s3 = r2.getSelectedElement(), a2 = Ci(n2, this.editor.locale.contentLanguageDirection), c2 = "down" == a2 || "right" == a2, l2 = "up" == a2 || "down" == a2;
            if (s3 && i2.isObject(s3)) {
              const n3 = c2 ? r2.getLastPosition() : r2.getFirstPosition(), s4 = i2.getNearestSelectionRange(n3, c2 ? "forward" : "backward");
              return void (s4 && (o2.change((t4) => {
                t4.setSelection(s4);
              }), e3.preventDefault(), t3.stop()));
            }
            if (!r2.isCollapsed && !e3.shiftKey) {
              const n3 = r2.getFirstPosition(), s4 = r2.getLastPosition(), a3 = n3.nodeAfter, l3 = s4.nodeBefore;
              return void ((a3 && i2.isObject(a3) || l3 && i2.isObject(l3)) && (o2.change((t4) => {
                t4.setSelection(c2 ? s4 : n3);
              }), e3.preventDefault(), t3.stop()));
            }
            if (!r2.isCollapsed)
              return;
            const d2 = this._getObjectElementNextToSelection(c2);
            if (d2 && i2.isObject(d2)) {
              if (i2.isInline(d2) && l2)
                return;
              this._setSelectionOverElement(d2), e3.preventDefault(), t3.stop();
            }
          }
          _preventDefaultOnArrowKeyPress(t3, e3) {
            const n2 = this.editor.model, o2 = n2.schema, i2 = n2.document.selection.getSelectedElement();
            i2 && o2.isObject(i2) && (e3.preventDefault(), t3.stop());
          }
          _handleDelete(t3) {
            const e3 = this.editor.model.document.selection;
            if (!this.editor.model.canEditAt(e3))
              return;
            if (!e3.isCollapsed)
              return;
            const n2 = this._getObjectElementNextToSelection(t3);
            return n2 ? (this.editor.model.change((t4) => {
              let o2 = e3.anchor.parent;
              for (; o2.isEmpty; ) {
                const e4 = o2;
                o2 = e4.parent, t4.remove(e4);
              }
              this._setSelectionOverElement(n2);
            }), true) : void 0;
          }
          _setSelectionOverElement(t3) {
            this.editor.model.change((e3) => {
              e3.setSelection(e3.createRangeOn(t3));
            });
          }
          _getObjectElementNextToSelection(t3) {
            const e3 = this.editor.model, n2 = e3.schema, o2 = e3.document.selection, i2 = e3.createSelection(o2);
            if (e3.modifySelection(i2, { direction: t3 ? "forward" : "backward" }), i2.isEqual(o2))
              return null;
            const r2 = t3 ? i2.focus.nodeBefore : i2.focus.nodeAfter;
            return r2 && n2.isObject(r2) ? r2 : null;
          }
          _clearPreviouslySelectedWidgets(t3) {
            for (const e3 of this._previouslySelected)
              t3.removeClass(cb, e3);
            this._previouslySelected.clear();
          }
        }
        function Bb(t3, e3) {
          return !!e3 && Array.from(t3.getAncestors()).includes(e3);
        }
        class Nb extends es {
          constructor() {
            super(...arguments), this._toolbarDefinitions = /* @__PURE__ */ new Map();
          }
          static get requires() {
            return [of];
          }
          static get pluginName() {
            return "WidgetToolbarRepository";
          }
          init() {
            const t3 = this.editor;
            if (t3.plugins.has("BalloonToolbar")) {
              const e3 = t3.plugins.get("BalloonToolbar");
              this.listenTo(e3, "show", (e4) => {
                (function(t4) {
                  const e5 = t4.getSelectedElement();
                  return !(!e5 || !lb(e5));
                })(t3.editing.view.document.selection) && e4.stop();
              }, { priority: "high" });
            }
            this._balloon = this.editor.plugins.get("ContextualBalloon"), this.on("change:isEnabled", () => {
              this._updateToolbarsVisibility();
            }), this.listenTo(t3.ui, "update", () => {
              this._updateToolbarsVisibility();
            }), this.listenTo(t3.ui.focusTracker, "change:isFocused", () => {
              this._updateToolbarsVisibility();
            }, { priority: "low" });
          }
          destroy() {
            super.destroy();
            for (const t3 of this._toolbarDefinitions.values())
              t3.view.destroy();
          }
          register(t3, { ariaLabel: e3, items: n2, getRelatedElement: o2, balloonClassName: i2 = "ck-toolbar-container" }) {
            if (!n2.length)
              return void C("widget-toolbar-no-items", { toolbarId: t3 });
            const r2 = this.editor, s3 = r2.t, a2 = new Hg(r2.locale);
            if (a2.ariaLabel = e3 || s3("Widget toolbar"), this._toolbarDefinitions.has(t3))
              throw new A("widget-toolbar-duplicated", this, { toolbarId: t3 });
            const c2 = { view: a2, getRelatedElement: o2, balloonClassName: i2, itemsConfig: n2, initialized: false };
            r2.ui.addToolbar(a2, { isContextual: true, beforeFocus: () => {
              const t4 = o2(r2.editing.view.document.selection);
              t4 && this._showToolbar(c2, t4);
            }, afterBlur: () => {
              this._hideToolbar(c2);
            } }), this._toolbarDefinitions.set(t3, c2);
          }
          _updateToolbarsVisibility() {
            let t3 = 0, e3 = null, n2 = null;
            for (const o2 of this._toolbarDefinitions.values()) {
              const i2 = o2.getRelatedElement(this.editor.editing.view.document.selection);
              if (this.isEnabled && i2)
                if (this.editor.ui.focusTracker.isFocused) {
                  const r2 = i2.getAncestors().length;
                  r2 > t3 && (t3 = r2, e3 = i2, n2 = o2);
                } else
                  this._isToolbarVisible(o2) && this._hideToolbar(o2);
              else
                this._isToolbarInBalloon(o2) && this._hideToolbar(o2);
            }
            n2 && this._showToolbar(n2, e3);
          }
          _hideToolbar(t3) {
            this._balloon.remove(t3.view), this.stopListening(this._balloon, "change:visibleView");
          }
          _showToolbar(t3, e3) {
            this._isToolbarVisible(t3) ? Pb(this.editor, e3) : this._isToolbarInBalloon(t3) || (t3.initialized || (t3.initialized = true, t3.view.fillFromConfig(t3.itemsConfig, this.editor.ui.componentFactory)), this._balloon.add({ view: t3.view, position: zb(this.editor, e3), balloonClassName: t3.balloonClassName }), this.listenTo(this._balloon, "change:visibleView", () => {
              for (const t4 of this._toolbarDefinitions.values())
                if (this._isToolbarVisible(t4)) {
                  const e4 = t4.getRelatedElement(this.editor.editing.view.document.selection);
                  Pb(this.editor, e4);
                }
            }));
          }
          _isToolbarVisible(t3) {
            return this._balloon.visibleView === t3.view;
          }
          _isToolbarInBalloon(t3) {
            return this._balloon.hasView(t3.view);
          }
        }
        function Pb(t3, e3) {
          const n2 = t3.plugins.get("ContextualBalloon"), o2 = zb(t3, e3);
          n2.updatePosition(o2);
        }
        function zb(t3, e3) {
          const n2 = t3.editing.view, o2 = am.defaultPositions;
          return { target: n2.domConverter.mapViewToDom(e3), positions: [o2.northArrowSouth, o2.northArrowSouthWest, o2.northArrowSouthEast, o2.southArrowNorth, o2.southArrowNorthWest, o2.southArrowNorthEast, o2.viewportStickyNorth] };
        }
        W();
        Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        W();
        var Ob = n(8506), Lb = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Ob.Z, Lb);
        Ob.Z.locals;
        const Rb = Yo("px");
        class jb extends Ui {
          constructor() {
            super();
            const t3 = this.bindTemplate;
            this.set({ isVisible: false, left: null, top: null, width: null }), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-clipboard-drop-target-line", t3.if("isVisible", "ck-hidden", (t4) => !t4)], style: { left: t3.to("left", (t4) => Rb(t4)), top: t3.to("top", (t4) => Rb(t4)), width: t3.to("width", (t4) => Rb(t4)) } } });
          }
        }
        class Fb extends es {
          constructor() {
            super(...arguments), this.removeDropMarkerDelayed = Bi(() => this.removeDropMarker(), 40), this._updateDropMarkerThrottled = fm((t3) => this._updateDropMarker(t3), 40), this._reconvertMarkerThrottled = fm(() => {
              this.editor.model.markers.has("drop-target") && this.editor.editing.reconvertMarker("drop-target");
            }, 0), this._dropTargetLineView = new jb(), this._domEmitter = new (Mo())(), this._scrollables = /* @__PURE__ */ new Map();
          }
          static get pluginName() {
            return "DragDropTarget";
          }
          init() {
            this._setupDropMarker();
          }
          destroy() {
            this._domEmitter.stopListening();
            for (const { resizeObserver: t3 } of this._scrollables.values())
              t3.destroy();
            return this._updateDropMarkerThrottled.cancel(), this.removeDropMarkerDelayed.cancel(), this._reconvertMarkerThrottled.cancel(), super.destroy();
          }
          updateDropMarker(t3, e3, n2, o2, i2, r2) {
            this.removeDropMarkerDelayed.cancel();
            const s3 = Vb(this.editor, t3, e3, n2, o2, i2, r2);
            if (s3)
              return r2 && r2.containsRange(s3) ? this.removeDropMarker() : void this._updateDropMarkerThrottled(s3);
          }
          getFinalDropRange(t3, e3, n2, o2, i2, r2) {
            const s3 = Vb(this.editor, t3, e3, n2, o2, i2, r2);
            return this.removeDropMarker(), s3;
          }
          removeDropMarker() {
            const t3 = this.editor.model;
            this.removeDropMarkerDelayed.cancel(), this._updateDropMarkerThrottled.cancel(), this._dropTargetLineView.isVisible = false, t3.markers.has("drop-target") && t3.change((t4) => {
              t4.removeMarker("drop-target");
            });
          }
          _setupDropMarker() {
            const t3 = this.editor;
            t3.ui.view.body.add(this._dropTargetLineView), t3.conversion.for("editingDowncast").markerToHighlight({ model: "drop-target", view: { classes: ["ck-clipboard-drop-target-range"] } }), t3.conversion.for("editingDowncast").markerToElement({ model: "drop-target", view: (e3, { writer: n2 }) => {
              if (t3.model.schema.checkChild(e3.markerRange.start, "$text"))
                return this._dropTargetLineView.isVisible = false, this._createDropTargetPosition(n2);
              e3.markerRange.isCollapsed ? this._updateDropTargetLine(e3.markerRange) : this._dropTargetLineView.isVisible = false;
            } });
          }
          _updateDropMarker(t3) {
            const e3 = this.editor, n2 = e3.model.markers;
            e3.model.change((e4) => {
              n2.has("drop-target") ? n2.get("drop-target").getRange().isEqual(t3) || e4.updateMarker("drop-target", { range: t3 }) : e4.addMarker("drop-target", { range: t3, usingOperation: false, affectsData: false });
            });
          }
          _createDropTargetPosition(t3) {
            return t3.createUIElement("span", { class: "ck ck-clipboard-drop-target-position" }, function(t4) {
              const e3 = this.toDomElement(t4);
              return e3.append("\u2060", t4.createElement("span"), "\u2060"), e3;
            });
          }
          _updateDropTargetLine(t3) {
            const e3 = this.editor.editing, n2 = t3.start.nodeBefore, o2 = t3.start.nodeAfter, i2 = t3.start.parent, r2 = n2 ? e3.mapper.toViewElement(n2) : null, s3 = r2 ? e3.view.domConverter.mapViewToDom(r2) : null, a2 = o2 ? e3.mapper.toViewElement(o2) : null, c2 = a2 ? e3.view.domConverter.mapViewToDom(a2) : null, l2 = e3.mapper.toViewElement(i2), d2 = e3.view.domConverter.mapViewToDom(l2), h2 = this._getScrollableRect(l2), { scrollX: u2, scrollY: g2 } = zo.window, p2 = s3 ? new Vo(s3) : null, m2 = c2 ? new Vo(c2) : null, f2 = new Vo(d2).excludeScrollbarsAndBorders(), k2 = p2 ? p2.bottom : f2.top, b10 = m2 ? m2.top : f2.bottom, w2 = zo.window.getComputedStyle(d2), A2 = k2 <= b10 ? (k2 + b10) / 2 : b10;
            if (h2.top < A2 && A2 < h2.bottom) {
              const t4 = f2.left + parseFloat(w2.paddingLeft), e4 = f2.right - parseFloat(w2.paddingRight), n3 = Math.max(t4 + u2, h2.left), o3 = Math.min(e4 + u2, h2.right);
              this._dropTargetLineView.set({ isVisible: true, left: n3, top: A2 + g2, width: o3 - n3 });
            } else
              this._dropTargetLineView.isVisible = false;
          }
          _getScrollableRect(t3) {
            const e3 = t3.root.rootName;
            let n2;
            if (this._scrollables.has(e3))
              n2 = this._scrollables.get(e3).domElement;
            else {
              n2 = function(t4) {
                let e4 = t4;
                do {
                  e4 = e4.parentElement;
                  const t5 = zo.window.getComputedStyle(e4).overflowY;
                  if ("auto" == t5 || "scroll" == t5)
                    break;
                } while ("BODY" != e4.tagName);
                return e4;
              }(this.editor.editing.view.domConverter.mapViewToDom(t3)), this._domEmitter.listenTo(n2, "scroll", this._reconvertMarkerThrottled, { usePassive: true });
              const o2 = new Ko(n2, this._reconvertMarkerThrottled);
              this._scrollables.set(e3, { domElement: n2, resizeObserver: o2 });
            }
            return new Vo(n2).excludeScrollbarsAndBorders();
          }
        }
        function Vb(t3, e3, n2, o2, i2, r2, s3) {
          const a2 = t3.model, c2 = t3.editing.mapper;
          let l2 = Gb(t3, e3);
          for (; l2; ) {
            if (!r2) {
              if (a2.schema.checkChild(l2, "$text")) {
                if (n2) {
                  const e4 = n2[0].start, r3 = c2.toModelPosition(e4);
                  if (!s3 || Array.from(s3.getItems()).every((t4) => a2.schema.checkChild(r3, t4))) {
                    if (a2.schema.checkChild(r3, "$text"))
                      return a2.createRange(r3);
                    if (e4)
                      return Hb(t3, Gb(t3, e4.parent), o2, i2);
                  }
                }
              } else if (a2.schema.isInline(l2))
                return Hb(t3, l2, o2, i2);
            }
            if (a2.schema.isBlock(l2))
              return Hb(t3, l2, o2, i2);
            if (a2.schema.checkChild(l2, "$block")) {
              const e4 = Array.from(l2.getChildren()).filter((e5) => e5.is("element") && !Ub(t3, e5));
              let n3 = 0, r3 = e4.length;
              if (0 == r3)
                return a2.createRange(a2.createPositionAt(l2, "end"));
              for (; n3 < r3 - 1; ) {
                const s4 = Math.floor((n3 + r3) / 2);
                "before" == qb(t3, e4[s4], o2, i2) ? r3 = s4 : n3 = s4;
              }
              return Hb(t3, e4[n3], o2, i2);
            }
            l2 = l2.parent;
          }
          return null;
        }
        function Ub(t3, e3) {
          const n2 = t3.editing.mapper, o2 = t3.editing.view.domConverter, i2 = n2.toViewElement(e3), r2 = o2.mapViewToDom(i2);
          return "none" != zo.window.getComputedStyle(r2).float;
        }
        function Hb(t3, e3, n2, o2) {
          const i2 = t3.model;
          return i2.createRange(i2.createPositionAt(e3, qb(t3, e3, n2, o2)));
        }
        function qb(t3, e3, n2, o2) {
          const i2 = t3.editing.mapper, r2 = t3.editing.view.domConverter, s3 = i2.toViewElement(e3), a2 = r2.mapViewToDom(s3), c2 = new Vo(a2);
          return t3.model.schema.isInline(e3) ? n2 < (c2.left + c2.right) / 2 ? "before" : "after" : o2 < (c2.top + c2.bottom) / 2 ? "before" : "after";
        }
        function Gb(t3, e3) {
          const n2 = t3.editing.mapper, o2 = t3.editing.view, i2 = n2.toModelElement(e3);
          if (i2)
            return i2;
          const r2 = o2.createPositionBefore(e3), s3 = n2.findMappedViewAncestor(r2);
          return n2.toModelElement(s3);
        }
        var Wb = Object.defineProperty, Kb = Object.defineProperties, Zb = Object.getOwnPropertyDescriptors, Yb = Object.getOwnPropertySymbols, $b = Object.prototype.hasOwnProperty, Qb = Object.prototype.propertyIsEnumerable, Jb = (t3, e3, n2) => e3 in t3 ? Wb(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2;
        class Xb extends es {
          constructor() {
            super(...arguments), this._isBlockDragging = false, this._domEmitter = new (Mo())();
          }
          static get pluginName() {
            return "DragDropBlockToolbar";
          }
          init() {
            const t3 = this.editor;
            if (this.listenTo(t3, "change:isReadOnly", (t4, e3, n2) => {
              n2 ? (this.forceDisabled("readOnlyMode"), this._isBlockDragging = false) : this.clearForceDisabled("readOnlyMode");
            }), a.isAndroid && this.forceDisabled("noAndroidSupport"), t3.plugins.has("BlockToolbar")) {
              const e3 = t3.plugins.get("BlockToolbar").buttonView.element;
              this._domEmitter.listenTo(e3, "dragstart", (t4, e4) => this._handleBlockDragStart(e4)), this._domEmitter.listenTo(zo.document, "dragover", (t4, e4) => this._handleBlockDragging(e4)), this._domEmitter.listenTo(zo.document, "drop", (t4, e4) => this._handleBlockDragging(e4)), this._domEmitter.listenTo(zo.document, "dragend", () => this._handleBlockDragEnd(), { useCapture: true }), this.isEnabled && e3.setAttribute("draggable", "true"), this.on("change:isEnabled", (t4, n2, o2) => {
                e3.setAttribute("draggable", o2 ? "true" : "false");
              });
            }
          }
          destroy() {
            return this._domEmitter.stopListening(), super.destroy();
          }
          _handleBlockDragStart(t3) {
            if (!this.isEnabled)
              return;
            const e3 = this.editor.model, n2 = e3.document.selection, o2 = this.editor.editing.view, i2 = Array.from(n2.getSelectedBlocks()), r2 = e3.createRange(e3.createPositionBefore(i2[0]), e3.createPositionAfter(i2[i2.length - 1]));
            e3.change((t4) => t4.setSelection(r2)), this._isBlockDragging = true, o2.focus(), o2.getObserver(ak).onDomEvent(t3);
          }
          _handleBlockDragging(t3) {
            if (!this.isEnabled || !this._isBlockDragging)
              return;
            const e3 = t3.clientX + ("ltr" == this.editor.locale.contentLanguageDirection ? 100 : -100), n2 = t3.clientY, o2 = document.elementFromPoint(e3, n2), i2 = this.editor.editing.view;
            var r2, s3;
            o2 && o2.closest(".ck-editor__editable") && i2.getObserver(ak).onDomEvent((r2 = ((t4, e4) => {
              for (var n3 in e4 || (e4 = {}))
                $b.call(e4, n3) && Jb(t4, n3, e4[n3]);
              if (Yb)
                for (var n3 of Yb(e4))
                  Qb.call(e4, n3) && Jb(t4, n3, e4[n3]);
              return t4;
            })({}, t3), s3 = { type: t3.type, dataTransfer: t3.dataTransfer, target: o2, clientX: e3, clientY: n2, preventDefault: () => t3.preventDefault(), stopPropagation: () => t3.stopPropagation() }, Kb(r2, Zb(s3))));
          }
          _handleBlockDragEnd() {
            this._isBlockDragging = false;
          }
        }
        var tw = n(903), ew = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(tw.Z, ew);
        tw.Z.locals;
        class nw extends es {
          constructor() {
            super(...arguments), this._clearDraggableAttributesDelayed = Bi(() => this._clearDraggableAttributes(), 40), this._blockMode = false, this._domEmitter = new (Mo())();
          }
          static get pluginName() {
            return "DragDrop";
          }
          static get requires() {
            return [uk, Mb, Fb, Xb];
          }
          init() {
            const t3 = this.editor, e3 = t3.editing.view;
            this._draggedRange = null, this._draggingUid = "", this._draggableElement = null, e3.addObserver(ak), e3.addObserver(Mg), this._setupDragging(), this._setupContentInsertionIntegration(), this._setupClipboardInputIntegration(), this._setupDraggableAttributeHandling(), this.listenTo(t3, "change:isReadOnly", (t4, e4, n2) => {
              n2 ? this.forceDisabled("readOnlyMode") : this.clearForceDisabled("readOnlyMode");
            }), this.on("change:isEnabled", (t4, e4, n2) => {
              n2 || this._finalizeDragging(false);
            }), a.isAndroid && this.forceDisabled("noAndroidSupport");
          }
          destroy() {
            return this._draggedRange && (this._draggedRange.detach(), this._draggedRange = null), this._previewContainer && this._previewContainer.remove(), this._domEmitter.stopListening(), this._clearDraggableAttributesDelayed.cancel(), super.destroy();
          }
          _setupDragging() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.editing.view, o2 = n2.document, i2 = t3.plugins.get(Fb);
            this.listenTo(o2, "dragstart", (t4, n3) => {
              if (n3.target && n3.target.is("editableElement"))
                return void n3.preventDefault();
              if (this._prepareDraggedRange(n3.target), !this._draggedRange)
                return void n3.preventDefault();
              this._draggingUid = f(), n3.dataTransfer.effectAllowed = this.isEnabled ? "copyMove" : "copy", n3.dataTransfer.setData("application/ckeditor5-dragging-uid", this._draggingUid);
              const o3 = e3.createSelection(this._draggedRange.toRange());
              this.editor.plugins.get("ClipboardPipeline")._fireOutputTransformationEvent(n3.dataTransfer, o3, "dragstart");
              const { dataTransfer: i3, domTarget: r2, domEvent: s3 } = n3, { clientX: a2 } = s3;
              this._updatePreview({ dataTransfer: i3, domTarget: r2, clientX: a2 }), n3.stopPropagation(), this.isEnabled || (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
            }, { priority: "low" }), this.listenTo(o2, "dragend", (t4, e4) => {
              this._finalizeDragging(!e4.dataTransfer.isCanceled && "move" == e4.dataTransfer.dropEffect);
            }, { priority: "low" }), this._domEmitter.listenTo(zo.document, "dragend", () => {
              this._blockMode = false;
            }, { useCapture: true }), this.listenTo(o2, "dragenter", () => {
              this.isEnabled && n2.focus();
            }), this.listenTo(o2, "dragleave", () => {
              i2.removeDropMarkerDelayed();
            }), this.listenTo(o2, "dragging", (t4, e4) => {
              if (!this.isEnabled)
                return void (e4.dataTransfer.dropEffect = "none");
              const { clientX: n3, clientY: o3 } = e4.domEvent;
              i2.updateDropMarker(e4.target, e4.targetRanges, n3, o3, this._blockMode, this._draggedRange), this._draggedRange || (e4.dataTransfer.dropEffect = "copy"), a.isGecko || ("copy" == e4.dataTransfer.effectAllowed ? e4.dataTransfer.dropEffect = "copy" : ["all", "copyMove"].includes(e4.dataTransfer.effectAllowed) && (e4.dataTransfer.dropEffect = "move")), t4.stop();
            }, { priority: "low" });
          }
          _setupClipboardInputIntegration() {
            const t3 = this.editor, e3 = t3.editing.view.document, n2 = t3.plugins.get(Fb);
            this.listenTo(e3, "clipboardInput", (e4, o2) => {
              if ("drop" != o2.method)
                return;
              const { clientX: i2, clientY: r2 } = o2.domEvent, s3 = n2.getFinalDropRange(o2.target, o2.targetRanges, i2, r2, this._blockMode, this._draggedRange);
              if (!s3)
                return this._finalizeDragging(false), void e4.stop();
              this._draggedRange && this._draggingUid != o2.dataTransfer.getData("application/ckeditor5-dragging-uid") && (this._draggedRange.detach(), this._draggedRange = null, this._draggingUid = "");
              if ("move" == ow(o2.dataTransfer) && this._draggedRange && this._draggedRange.containsRange(s3, true))
                return this._finalizeDragging(false), void e4.stop();
              o2.targetRanges = [t3.editing.mapper.toViewRange(s3)];
            }, { priority: "high" });
          }
          _setupContentInsertionIntegration() {
            const t3 = this.editor.plugins.get(uk);
            t3.on("contentInsertion", (t4, e3) => {
              if (!this.isEnabled || "drop" !== e3.method)
                return;
              const n2 = e3.targetRanges.map((t5) => this.editor.editing.mapper.toModelRange(t5));
              this.editor.model.change((t5) => t5.setSelection(n2));
            }, { priority: "high" }), t3.on("contentInsertion", (t4, e3) => {
              if (!this.isEnabled || "drop" !== e3.method)
                return;
              const n2 = "move" == ow(e3.dataTransfer), o2 = !e3.resultRange || !e3.resultRange.isCollapsed;
              this._finalizeDragging(o2 && n2);
            }, { priority: "lowest" });
          }
          _setupDraggableAttributeHandling() {
            const t3 = this.editor, e3 = t3.editing.view, n2 = e3.document;
            this.listenTo(n2, "mousedown", (o2, i2) => {
              if (a.isAndroid || !i2)
                return;
              this._clearDraggableAttributesDelayed.cancel();
              let r2 = iw(i2.target);
              if (a.isBlink && !t3.isReadOnly && !r2 && !n2.selection.isCollapsed) {
                const t4 = n2.selection.getSelectedElement();
                t4 && lb(t4) || (r2 = n2.selection.editableElement);
              }
              r2 && (e3.change((t4) => {
                t4.setAttribute("draggable", "true", r2);
              }), this._draggableElement = t3.editing.mapper.toModelElement(r2));
            }), this.listenTo(n2, "mouseup", () => {
              a.isAndroid || this._clearDraggableAttributesDelayed();
            });
          }
          _clearDraggableAttributes() {
            const t3 = this.editor.editing;
            t3.view.change((e3) => {
              this._draggableElement && "$graveyard" != this._draggableElement.root.rootName && e3.removeAttribute("draggable", t3.mapper.toViewElement(this._draggableElement)), this._draggableElement = null;
            });
          }
          _finalizeDragging(t3) {
            const e3 = this.editor, n2 = e3.model;
            if (e3.plugins.get(Fb).removeDropMarker(), this._clearDraggableAttributes(), e3.plugins.has("WidgetToolbarRepository")) {
              e3.plugins.get("WidgetToolbarRepository").clearForceDisabled("dragDrop");
            }
            this._draggingUid = "", this._previewContainer && (this._previewContainer.remove(), this._previewContainer = void 0), this._draggedRange && (t3 && this.isEnabled && n2.change((t4) => {
              const e4 = n2.createSelection(this._draggedRange);
              n2.deleteContent(e4, { doNotAutoparagraph: true });
              const o2 = e4.getFirstPosition().parent;
              o2.isEmpty && !n2.schema.checkChild(o2, "$text") && n2.schema.checkChild(o2, "paragraph") && t4.insertElement("paragraph", o2, 0);
            }), this._draggedRange.detach(), this._draggedRange = null);
          }
          _prepareDraggedRange(t3) {
            const e3 = this.editor, n2 = e3.model, o2 = n2.document.selection, i2 = t3 ? iw(t3) : null;
            if (i2) {
              const t4 = e3.editing.mapper.toModelElement(i2);
              if (this._draggedRange = Cd.fromRange(n2.createRangeOn(t4)), this._blockMode = n2.schema.isBlock(t4), e3.plugins.has("WidgetToolbarRepository")) {
                e3.plugins.get("WidgetToolbarRepository").forceDisabled("dragDrop");
              }
              return;
            }
            if (o2.isCollapsed && !o2.getFirstPosition().parent.isEmpty)
              return;
            const r2 = Array.from(o2.getSelectedBlocks()), s3 = o2.getFirstRange();
            if (0 == r2.length)
              return void (this._draggedRange = Cd.fromRange(s3));
            const a2 = rw(n2, r2);
            if (r2.length > 1)
              this._draggedRange = Cd.fromRange(a2), this._blockMode = true;
            else if (1 == r2.length) {
              const t4 = s3.start.isTouching(a2.start) && s3.end.isTouching(a2.end);
              this._draggedRange = Cd.fromRange(t4 ? a2 : s3), this._blockMode = t4;
            }
            n2.change((t4) => t4.setSelection(this._draggedRange.toRange()));
          }
          _updatePreview({ dataTransfer: t3, domTarget: e3, clientX: n2 }) {
            const o2 = this.editor.editing.view, i2 = o2.document.selection.editableElement, r2 = o2.domConverter.mapViewToDom(i2), s3 = zo.window.getComputedStyle(r2);
            this._previewContainer ? this._previewContainer.firstElementChild && this._previewContainer.removeChild(this._previewContainer.firstElementChild) : (this._previewContainer = bt(zo.document, "div", { style: "position: fixed; left: -999999px;" }), zo.document.body.appendChild(this._previewContainer));
            const c2 = new Vo(r2);
            if (r2.contains(e3))
              return;
            const l2 = parseFloat(s3.paddingLeft), d2 = bt(zo.document, "div");
            d2.className = "ck ck-content", d2.style.width = s3.width, d2.style.paddingLeft = `${c2.left - n2 + l2}px`, a.isiOS && (d2.style.backgroundColor = "white"), d2.innerHTML = t3.getData("text/html"), t3.setDragImage(d2, 0, 0), this._previewContainer.appendChild(d2);
          }
        }
        function ow(t3) {
          return a.isGecko ? t3.dropEffect : ["all", "copyMove"].includes(t3.effectAllowed) ? "move" : "copy";
        }
        function iw(t3) {
          if (t3.is("editableElement"))
            return null;
          if (t3.hasClass("ck-widget__selection-handle"))
            return t3.findAncestor(lb);
          if (lb(t3))
            return t3;
          const e3 = t3.findAncestor((t4) => lb(t4) || t4.is("editableElement"));
          return lb(e3) ? e3 : null;
        }
        function rw(t3, e3) {
          const n2 = e3[0], o2 = e3[e3.length - 1], i2 = n2.getCommonAncestor(o2), r2 = t3.createPositionBefore(n2), s3 = t3.createPositionAfter(o2);
          if (i2 && i2.is("element") && !t3.schema.isLimit(i2)) {
            const e4 = t3.createRangeOn(i2), n3 = r2.isTouching(e4.start), o3 = s3.isTouching(e4.end);
            if (n3 && o3)
              return rw(t3, [i2]);
          }
          return t3.createRange(r2, s3);
        }
        class sw extends es {
          static get pluginName() {
            return "PastePlainText";
          }
          static get requires() {
            return [uk];
          }
          init() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.editing.view, o2 = n2.document, i2 = e3.document.selection;
            let r2 = false;
            n2.addObserver(ak), this.listenTo(o2, "keydown", (t4, e4) => {
              r2 = e4.shiftKey;
            }), t3.plugins.get(uk).on("contentInsertion", (t4, n3) => {
              (r2 || function(t5, e4) {
                if (t5.childCount > 1)
                  return false;
                const n4 = t5.getChild(0);
                if (e4.isObject(n4))
                  return false;
                return 0 == Array.from(n4.getAttributeKeys()).length;
              }(n3.content, e3.schema)) && e3.change((t5) => {
                const o3 = Array.from(i2.getAttributes()).filter(([t6]) => e3.schema.getAttributeProperties(t6).isFormatting);
                i2.isCollapsed || e3.deleteContent(i2, { doNotAutoparagraph: true }), o3.push(...i2.getAttributes());
                const r3 = t5.createRangeIn(n3.content);
                for (const e4 of r3.getItems())
                  e4.is("$textProxy") && t5.setAttributes(o3, e4);
              });
            });
          }
        }
        class aw extends es {
          static get pluginName() {
            return "Clipboard";
          }
          static get requires() {
            return [uk, nw, sw];
          }
        }
        class cw extends os {
          constructor(t3) {
            super(t3), this.affectsData = false;
          }
          execute() {
            const t3 = this.editor.model, e3 = t3.document.selection;
            let n2 = t3.schema.getLimitElement(e3);
            if (e3.containsEntireContent(n2) || !lw(t3.schema, n2))
              do {
                if (n2 = n2.parent, !n2)
                  return;
              } while (!lw(t3.schema, n2));
            t3.change((t4) => {
              t4.setSelection(n2, "in");
            });
          }
        }
        function lw(t3, e3) {
          return t3.isLimit(e3) && (t3.checkChild(e3, "$text") || t3.checkChild(e3, "paragraph"));
        }
        const dw = wi("Ctrl+A");
        class hw extends es {
          static get pluginName() {
            return "SelectAllEditing";
          }
          init() {
            const t3 = this.editor, e3 = t3.editing.view.document;
            t3.commands.add("selectAll", new cw(t3)), this.listenTo(e3, "keydown", (e4, n2) => {
              bi(n2) === dw && (t3.execute("selectAll"), n2.preventDefault());
            });
          }
        }
        class uw extends es {
          static get pluginName() {
            return "SelectAllUI";
          }
          init() {
            const t3 = this.editor;
            t3.ui.componentFactory.add("selectAll", (e3) => {
              const n2 = t3.commands.get("selectAll"), o2 = new br(e3), i2 = e3.t;
              return o2.set({ label: i2("Select all"), icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M.75 15.5a.75.75 0 0 1 .75.75V18l.008.09A.5.5 0 0 0 2 18.5h1.75a.75.75 0 1 1 0 1.5H1.5l-.144-.007a1.5 1.5 0 0 1-1.35-1.349L0 18.5v-2.25a.75.75 0 0 1 .75-.75zm18.5 0a.75.75 0 0 1 .75.75v2.25l-.007.144a1.5 1.5 0 0 1-1.349 1.35L18.5 20h-2.25a.75.75 0 1 1 0-1.5H18a.5.5 0 0 0 .492-.41L18.5 18v-1.75a.75.75 0 0 1 .75-.75zm-10.45 3c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2v-1.1c0-.11.09-.2.2-.2h1.6zm.45-5.5a.75.75 0 1 1 0 1.5h-8.5a.75.75 0 1 1 0-1.5h8.5zM1.3 11c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2v-1.6c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5H4.75a.75.75 0 1 1 0-1.5h10.5zM1.3 7c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2H.2a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm18.5 0c.11 0 .2.09.2.2v1.6a.2.2 0 0 1-.2.2h-1.1a.2.2 0 0 1-.2-.2V7.2c0-.11.09-.2.2-.2h1.1zm-4.55-2a.75.75 0 1 1 0 1.5h-2.5a.75.75 0 1 1 0-1.5h2.5zm-5 0a.75.75 0 1 1 0 1.5h-5.5a.75.75 0 0 1 0-1.5h5.5zm-6.5-5a.75.75 0 0 1 0 1.5H2a.5.5 0 0 0-.492.41L1.5 2v1.75a.75.75 0 0 1-1.5 0V1.5l.007-.144A1.5 1.5 0 0 1 1.356.006L1.5 0h2.25zM18.5 0l.144.007a1.5 1.5 0 0 1 1.35 1.349L20 1.5v2.25a.75.75 0 1 1-1.5 0V2l-.008-.09A.5.5 0 0 0 18 1.5h-1.75a.75.75 0 1 1 0-1.5h2.25zM8.8 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2H7.2a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6zm4 0c.11 0 .2.09.2.2v1.1a.2.2 0 0 1-.2.2h-1.6a.2.2 0 0 1-.2-.2V.2c0-.11.09-.2.2-.2h1.6z"/></svg>', keystroke: "Ctrl+A", tooltip: true }), o2.bind("isEnabled").to(n2, "isEnabled"), this.listenTo(o2, "execute", () => {
                t3.execute("selectAll"), t3.editing.view.focus();
              }), o2;
            });
          }
        }
        class gw extends es {
          static get requires() {
            return [hw, uw];
          }
          static get pluginName() {
            return "SelectAll";
          }
        }
        var pw = Object.defineProperty, mw = Object.getOwnPropertySymbols, fw = Object.prototype.hasOwnProperty, kw = Object.prototype.propertyIsEnumerable, bw = (t3, e3, n2) => e3 in t3 ? pw(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2;
        class ww extends os {
          constructor(t3) {
            super(t3), this._stack = [], this._createdBatches = /* @__PURE__ */ new WeakSet(), this.refresh(), this._isEnabledBasedOnSelection = false, this.listenTo(t3.data, "set", (t4, e3) => {
              e3[1] = ((t5, e4) => {
                for (var n3 in e4 || (e4 = {}))
                  fw.call(e4, n3) && bw(t5, n3, e4[n3]);
                if (mw)
                  for (var n3 of mw(e4))
                    kw.call(e4, n3) && bw(t5, n3, e4[n3]);
                return t5;
              })({}, e3[1]);
              const n2 = e3[1];
              n2.batchType || (n2.batchType = { isUndoable: false });
            }, { priority: "high" }), this.listenTo(t3.data, "set", (t4, e3) => {
              e3[1].batchType.isUndoable || this.clearStack();
            });
          }
          refresh() {
            this.isEnabled = this._stack.length > 0;
          }
          get createdBatches() {
            return this._createdBatches;
          }
          addBatch(t3) {
            const e3 = this.editor.model.document.selection, n2 = { ranges: e3.hasOwnRange ? Array.from(e3.getRanges()) : [], isBackward: e3.isBackward };
            this._stack.push({ batch: t3, selection: n2 }), this.refresh();
          }
          clearStack() {
            this._stack = [], this.refresh();
          }
          _restoreSelection(t3, e3, n2) {
            const o2 = this.editor.model, i2 = o2.document, r2 = [], s3 = t3.map((t4) => t4.getTransformedByOperations(n2)), a2 = s3.flat();
            for (const t4 of s3) {
              const e4 = t4.filter((t5) => t5.root != i2.graveyard).filter((t5) => !Cw(t5, a2));
              e4.length && (Aw(e4), r2.push(e4[0]));
            }
            r2.length && o2.change((t4) => {
              t4.setSelection(r2, { backward: e3 });
            });
          }
          _undo(t3, e3) {
            const n2 = this.editor.model, o2 = n2.document;
            this._createdBatches.add(e3);
            const i2 = t3.operations.slice().filter((t4) => t4.isDocumentOperation);
            i2.reverse();
            for (const t4 of i2) {
              const i3 = t4.baseVersion + 1, r2 = Array.from(o2.history.getOperations(i3)), s3 = gu([t4.getReversed()], r2, { useRelations: true, document: this.editor.model.document, padWithNoOps: false, forceWeakRemove: true }).operationsA;
              for (let i4 of s3) {
                const r3 = i4.affectedSelectable;
                r3 && !n2.canEditAt(r3) && (i4 = new ou(i4.baseVersion)), e3.addOperation(i4), n2.applyOperation(i4), o2.history.setOperationAsUndone(t4, i4);
              }
            }
          }
        }
        function Aw(t3) {
          t3.sort((t4, e3) => t4.start.isBefore(e3.start) ? -1 : 1);
          for (let e3 = 1; e3 < t3.length; e3++) {
            const n2 = t3[e3 - 1].getJoined(t3[e3], true);
            n2 && (e3--, t3.splice(e3, 2, n2));
          }
        }
        function Cw(t3, e3) {
          return e3.some((e4) => e4 !== t3 && e4.containsRange(t3, true));
        }
        class _w extends ww {
          execute(t3 = null) {
            const e3 = t3 ? this._stack.findIndex((e4) => e4.batch == t3) : this._stack.length - 1, n2 = this._stack.splice(e3, 1)[0], o2 = this.editor.model.createBatch({ isUndo: true });
            this.editor.model.enqueueChange(o2, () => {
              this._undo(n2.batch, o2);
              const t4 = this.editor.model.document.history.getOperations(n2.batch.baseVersion);
              this._restoreSelection(n2.selection.ranges, n2.selection.isBackward, t4);
            }), this.fire("revert", n2.batch, o2), this.refresh();
          }
        }
        class vw extends ww {
          execute() {
            const t3 = this._stack.pop(), e3 = this.editor.model.createBatch({ isUndo: true });
            this.editor.model.enqueueChange(e3, () => {
              const n2 = t3.batch.operations[t3.batch.operations.length - 1].baseVersion + 1, o2 = this.editor.model.document.history.getOperations(n2);
              this._restoreSelection(t3.selection.ranges, t3.selection.isBackward, o2), this._undo(t3.batch, e3);
            }), this.refresh();
          }
        }
        class yw extends es {
          constructor() {
            super(...arguments), this._batchRegistry = /* @__PURE__ */ new WeakSet();
          }
          static get pluginName() {
            return "UndoEditing";
          }
          init() {
            const t3 = this.editor;
            this._undoCommand = new _w(t3), this._redoCommand = new vw(t3), t3.commands.add("undo", this._undoCommand), t3.commands.add("redo", this._redoCommand), this.listenTo(t3.model, "applyOperation", (t4, e3) => {
              const n2 = e3[0];
              if (!n2.isDocumentOperation)
                return;
              const o2 = n2.batch, i2 = this._redoCommand.createdBatches.has(o2), r2 = this._undoCommand.createdBatches.has(o2);
              this._batchRegistry.has(o2) || (this._batchRegistry.add(o2), o2.isUndoable && (i2 ? this._undoCommand.addBatch(o2) : r2 || (this._undoCommand.addBatch(o2), this._redoCommand.clearStack())));
            }, { priority: "highest" }), this.listenTo(this._undoCommand, "revert", (t4, e3, n2) => {
              this._redoCommand.addBatch(n2);
            }), t3.keystrokes.set("CTRL+Z", "undo"), t3.keystrokes.set("CTRL+Y", "redo"), t3.keystrokes.set("CTRL+SHIFT+Z", "redo");
          }
        }
        const xw = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m5.042 9.367 2.189 1.837a.75.75 0 0 1-.965 1.149l-3.788-3.18a.747.747 0 0 1-.21-.284.75.75 0 0 1 .17-.945L6.23 4.762a.75.75 0 1 1 .964 1.15L4.863 7.866h8.917A.75.75 0 0 1 14 7.9a4 4 0 1 1-1.477 7.718l.344-1.489a2.5 2.5 0 1 0 1.094-4.73l.008-.032H5.042z"/></svg>', Ew = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m14.958 9.367-2.189 1.837a.75.75 0 0 0 .965 1.149l3.788-3.18a.747.747 0 0 0 .21-.284.75.75 0 0 0-.17-.945L13.77 4.762a.75.75 0 1 0-.964 1.15l2.331 1.955H6.22A.75.75 0 0 0 6 7.9a4 4 0 1 0 1.477 7.718l-.344-1.489A2.5 2.5 0 1 1 6.039 9.4l-.008-.032h8.927z"/></svg>';
        class Dw extends es {
          static get pluginName() {
            return "UndoUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.locale, n2 = t3.t, o2 = "ltr" == e3.uiLanguageDirection ? xw : Ew, i2 = "ltr" == e3.uiLanguageDirection ? Ew : xw;
            this._addButton("undo", n2("Undo"), "CTRL+Z", o2), this._addButton("redo", n2("Redo"), "CTRL+Y", i2);
          }
          _addButton(t3, e3, n2, o2) {
            const i2 = this.editor;
            i2.ui.componentFactory.add(t3, (r2) => {
              const s3 = i2.commands.get(t3), a2 = new br(r2);
              return a2.set({ label: e3, icon: o2, keystroke: n2, tooltip: true }), a2.bind("isEnabled").to(s3, "isEnabled"), this.listenTo(a2, "execute", () => {
                i2.execute(t3), i2.editing.view.focus();
              }), a2;
            });
          }
        }
        class Iw extends es {
          static get requires() {
            return [yw, Dw];
          }
          static get pluginName() {
            return "Undo";
          }
        }
        class Sw extends W() {
          constructor() {
            super();
            const t3 = new window.FileReader();
            this._reader = t3, this._data = void 0, this.set("loaded", 0), t3.onprogress = (t4) => {
              this.loaded = t4.loaded;
            };
          }
          get error() {
            return this._reader.error;
          }
          get data() {
            return this._data;
          }
          read(t3) {
            const e3 = this._reader;
            return this.total = t3.size, new Promise((n2, o2) => {
              e3.onload = () => {
                const t4 = e3.result;
                this._data = t4, n2(t4);
              }, e3.onerror = () => {
                o2("error");
              }, e3.onabort = () => {
                o2("aborted");
              }, this._reader.readAsDataURL(t3);
            });
          }
          abort() {
            this._reader.abort();
          }
        }
        class Tw extends es {
          constructor() {
            super(...arguments), this.loaders = new Di(), this._loadersMap = /* @__PURE__ */ new Map(), this._pendingAction = null;
          }
          static get pluginName() {
            return "FileRepository";
          }
          static get requires() {
            return [Lg];
          }
          init() {
            this.loaders.on("change", () => this._updatePendingAction()), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (t3, e3) => e3 ? t3 / e3 * 100 : 0);
          }
          getLoader(t3) {
            return this._loadersMap.get(t3) || null;
          }
          createLoader(t3) {
            if (!this.createUploadAdapter)
              return C("filerepository-no-upload-adapter"), null;
            const e3 = new Mw(Promise.resolve(t3), this.createUploadAdapter);
            return this.loaders.add(e3), this._loadersMap.set(t3, e3), t3 instanceof Promise && e3.file.then((t4) => {
              this._loadersMap.set(t4, e3);
            }).catch(() => {
            }), e3.on("change:uploaded", () => {
              let t4 = 0;
              for (const e4 of this.loaders)
                t4 += e4.uploaded;
              this.uploaded = t4;
            }), e3.on("change:uploadTotal", () => {
              let t4 = 0;
              for (const e4 of this.loaders)
                e4.uploadTotal && (t4 += e4.uploadTotal);
              this.uploadTotal = t4;
            }), e3;
          }
          destroyLoader(t3) {
            const e3 = t3 instanceof Mw ? t3 : this.getLoader(t3);
            e3._destroy(), this.loaders.remove(e3), this._loadersMap.forEach((t4, n2) => {
              t4 === e3 && this._loadersMap.delete(n2);
            });
          }
          _updatePendingAction() {
            const t3 = this.editor.plugins.get(Lg);
            if (this.loaders.length) {
              if (!this._pendingAction) {
                const e3 = this.editor.t, n2 = (t4) => `${e3("Upload in progress")} ${parseInt(t4)}%.`;
                this._pendingAction = t3.add(n2(this.uploadedPercent)), this._pendingAction.bind("message").to(this, "uploadedPercent", n2);
              }
            } else
              t3.remove(this._pendingAction), this._pendingAction = null;
          }
        }
        class Mw extends W() {
          constructor(t3, e3) {
            super(), this.id = f(), this._filePromiseWrapper = this._createFilePromiseWrapper(t3), this._adapter = e3(this), this._reader = new Sw(), this.set("status", "idle"), this.set("uploaded", 0), this.set("uploadTotal", null), this.bind("uploadedPercent").to(this, "uploaded", this, "uploadTotal", (t4, e4) => e4 ? t4 / e4 * 100 : 0), this.set("uploadResponse", null);
          }
          get file() {
            return this._filePromiseWrapper ? this._filePromiseWrapper.promise.then((t3) => this._filePromiseWrapper ? t3 : null) : Promise.resolve(null);
          }
          get data() {
            return this._reader.data;
          }
          read() {
            if ("idle" != this.status)
              throw new A("filerepository-read-wrong-status", this);
            return this.status = "reading", this.file.then((t3) => this._reader.read(t3)).then((t3) => {
              if ("reading" !== this.status)
                throw this.status;
              return this.status = "idle", t3;
            }).catch((t3) => {
              if ("aborted" === t3)
                throw this.status = "aborted", "aborted";
              throw this.status = "error", this._reader.error ? this._reader.error : t3;
            });
          }
          upload() {
            if ("idle" != this.status)
              throw new A("filerepository-upload-wrong-status", this);
            return this.status = "uploading", this.file.then(() => this._adapter.upload()).then((t3) => (this.uploadResponse = t3, this.status = "idle", t3)).catch((t3) => {
              if ("aborted" === this.status)
                throw "aborted";
              throw this.status = "error", t3;
            });
          }
          abort() {
            const t3 = this.status;
            this.status = "aborted", this._filePromiseWrapper.isFulfilled ? "reading" == t3 ? this._reader.abort() : "uploading" == t3 && this._adapter.abort && this._adapter.abort() : (this._filePromiseWrapper.promise.catch(() => {
            }), this._filePromiseWrapper.rejecter("aborted")), this._destroy();
          }
          _destroy() {
            this._filePromiseWrapper = void 0, this._reader = void 0, this._adapter = void 0, this.uploadResponse = void 0;
          }
          _createFilePromiseWrapper(t3) {
            const e3 = {};
            return e3.promise = new Promise((n2, o2) => {
              e3.rejecter = o2, e3.isFulfilled = false, t3.then((t4) => {
                e3.isFulfilled = true, n2(t4);
              }).catch((t4) => {
                e3.isFulfilled = true, o2(t4);
              });
            }), e3;
          }
        }
        class Bw extends br {
          constructor(t3) {
            super(t3), this.buttonView = this, this._fileInputView = new Nw(t3), this._fileInputView.bind("acceptedType").to(this), this._fileInputView.bind("allowMultipleFiles").to(this), this._fileInputView.delegate("done").to(this), this.on("execute", () => {
              this._fileInputView.open();
            }), this.extendTemplate({ attributes: { class: "ck-file-dialog-button" } });
          }
          render() {
            super.render(), this.children.add(this._fileInputView);
          }
        }
        class Nw extends Ui {
          constructor(t3) {
            super(t3), this.set("acceptedType", void 0), this.set("allowMultipleFiles", false);
            const e3 = this.bindTemplate;
            this.setTemplate({ tag: "input", attributes: { class: ["ck-hidden"], type: "file", tabindex: "-1", accept: e3.to("acceptedType"), multiple: e3.to("allowMultipleFiles") }, on: { change: e3.to(() => {
              this.element && this.element.files && this.element.files.length && this.fire("done", this.element.files), this.element.value = "";
            }) } });
          }
          open() {
            this.element.click();
          }
        }
        Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        const Pw = "ckCsrfToken", zw = "abcdefghijklmnopqrstuvwxyz0123456789";
        function Ow() {
          let t3 = function(t4) {
            t4 = t4.toLowerCase();
            const e4 = document.cookie.split(";");
            for (const n3 of e4) {
              const e5 = n3.split("=");
              if (decodeURIComponent(e5[0].trim().toLowerCase()) === t4)
                return decodeURIComponent(e5[1]);
            }
            return null;
          }(Pw);
          var e3, n2;
          return t3 && 40 == t3.length || (t3 = function(t4) {
            let e4 = "";
            const n3 = new Uint8Array(t4);
            window.crypto.getRandomValues(n3);
            for (let t5 = 0; t5 < n3.length; t5++) {
              const o2 = zw.charAt(n3[t5] % zw.length);
              e4 += Math.random() > 0.5 ? o2.toUpperCase() : o2;
            }
            return e4;
          }(40), e3 = Pw, n2 = t3, document.cookie = encodeURIComponent(e3) + "=" + encodeURIComponent(n2) + ";path=/"), t3;
        }
        class Lw {
          constructor(t3, e3, n2) {
            this.loader = t3, this.url = e3, this.t = n2;
          }
          upload() {
            return this.loader.file.then((t3) => new Promise((e3, n2) => {
              this._initRequest(), this._initListeners(e3, n2, t3), this._sendRequest(t3);
            }));
          }
          abort() {
            this.xhr && this.xhr.abort();
          }
          _initRequest() {
            const t3 = this.xhr = new XMLHttpRequest();
            t3.open("POST", this.url, true), t3.responseType = "json";
          }
          _initListeners(t3, e3, n2) {
            const o2 = this.xhr, i2 = this.loader, r2 = (0, this.t)("Cannot upload file:") + ` ${n2.name}.`;
            o2.addEventListener("error", () => e3(r2)), o2.addEventListener("abort", () => e3()), o2.addEventListener("load", () => {
              const n3 = o2.response;
              if (!n3 || !n3.uploaded)
                return e3(n3 && n3.error && n3.error.message ? n3.error.message : r2);
              t3({ default: n3.url });
            }), o2.upload && o2.upload.addEventListener("progress", (t4) => {
              t4.lengthComputable && (i2.uploadTotal = t4.total, i2.uploaded = t4.loaded);
            });
          }
          _sendRequest(t3) {
            const e3 = new FormData();
            e3.append("upload", t3), e3.append("ckCsrfToken", Ow()), this.xhr.send(e3);
          }
        }
        function Rw(t3, e3, n2, o2) {
          let i2, r2 = null;
          "function" == typeof o2 ? i2 = o2 : (r2 = t3.commands.get(o2), i2 = () => {
            t3.execute(o2);
          }), t3.model.document.on("change:data", (s3, a2) => {
            if (r2 && !r2.isEnabled || !e3.isEnabled)
              return;
            const c2 = Ii(t3.model.document.selection.getRanges());
            if (!c2.isCollapsed)
              return;
            if (a2.isUndo || !a2.isLocal)
              return;
            const l2 = Array.from(t3.model.document.differ.getChanges()), d2 = l2[0];
            if (1 != l2.length || "insert" !== d2.type || "$text" != d2.name || 1 != d2.length)
              return;
            const h2 = d2.position.parent;
            if (h2.is("element", "codeBlock"))
              return;
            if (h2.is("element", "listItem") && "function" != typeof o2 && !["numberedList", "bulletedList", "todoList"].includes(o2))
              return;
            if (r2 && true === r2.value)
              return;
            const u2 = h2.getChild(0), g2 = t3.model.createRangeOn(u2);
            if (!g2.containsRange(c2) && !c2.end.isEqual(g2.end))
              return;
            const p2 = n2.exec(u2.data.substr(0, c2.end.offset));
            p2 && t3.model.enqueueChange((e4) => {
              const n3 = e4.createPositionAt(h2, 0), o3 = e4.createPositionAt(h2, p2[0].length), r3 = new Cd(n3, o3);
              if (false !== i2({ match: p2 })) {
                e4.remove(r3);
                const n4 = t3.model.document.selection.getFirstRange(), o4 = e4.createRangeIn(h2);
                !h2.isEmpty || o4.isEqual(n4) || o4.containsRange(n4, true) || e4.remove(h2);
              }
              r3.detach(), t3.model.enqueueChange(() => {
                t3.plugins.get("Delete").requestUndoOnBackspace();
              });
            });
          });
        }
        function jw(t3, e3, n2, o2) {
          let i2, r2;
          n2 instanceof RegExp ? i2 = n2 : r2 = n2, r2 = r2 || ((t4) => {
            let e4;
            const n3 = [], o3 = [];
            for (; null !== (e4 = i2.exec(t4)) && !(e4 && e4.length < 4); ) {
              let { index: t5, 1: i3, 2: r3, 3: s3 } = e4;
              const a2 = i3 + r3 + s3;
              t5 += e4[0].length - a2.length;
              const c2 = [t5, t5 + i3.length], l2 = [t5 + i3.length + r3.length, t5 + i3.length + r3.length + s3.length];
              n3.push(c2), n3.push(l2), o3.push([t5 + i3.length, t5 + i3.length + r3.length]);
            }
            return { remove: n3, format: o3 };
          }), t3.model.document.on("change:data", (n3, i3) => {
            if (i3.isUndo || !i3.isLocal || !e3.isEnabled)
              return;
            const s3 = t3.model, a2 = s3.document.selection;
            if (!a2.isCollapsed)
              return;
            const c2 = Array.from(s3.document.differ.getChanges()), l2 = c2[0];
            if (1 != c2.length || "insert" !== l2.type || "$text" != l2.name || 1 != l2.length)
              return;
            const d2 = a2.focus, h2 = d2.parent, { text: u2, range: g2 } = function(t4, e4) {
              let n4 = t4.start;
              const o3 = Array.from(t4.getItems()).reduce((t5, o4) => !o4.is("$text") && !o4.is("$textProxy") || o4.getAttribute("code") ? (n4 = e4.createPositionAfter(o4), "") : t5 + o4.data, "");
              return { text: o3, range: e4.createRange(n4, t4.end) };
            }(s3.createRange(s3.createPositionAt(h2, 0), d2), s3), p2 = r2(u2), m2 = Fw(g2.start, p2.format, s3), f2 = Fw(g2.start, p2.remove, s3);
            m2.length && f2.length && s3.enqueueChange((e4) => {
              if (false !== o2(e4, m2)) {
                for (const t4 of f2.reverse())
                  e4.remove(t4);
                s3.enqueueChange(() => {
                  t3.plugins.get("Delete").requestUndoOnBackspace();
                });
              }
            });
          });
        }
        function Fw(t3, e3, n2) {
          return e3.filter((t4) => void 0 !== t4[0] && void 0 !== t4[1]).map((e4) => n2.createRange(t3.getShiftedBy(e4[0]), t3.getShiftedBy(e4[1])));
        }
        function Vw(t3, e3) {
          return (n2, o2) => {
            if (!t3.commands.get(e3).isEnabled)
              return false;
            const i2 = t3.model.schema.getValidRanges(o2, e3);
            for (const t4 of i2)
              n2.setAttribute(e3, true, t4);
            n2.removeSelectionAttribute(e3);
          };
        }
        class Uw extends os {
          constructor(t3, e3) {
            super(t3), this.attributeKey = e3;
          }
          refresh() {
            const t3 = this.editor.model, e3 = t3.document;
            this.value = this._getValueFromFirstAllowedNode(), this.isEnabled = t3.schema.checkAttributeInSelection(e3.selection, this.attributeKey);
          }
          execute(t3 = {}) {
            const e3 = this.editor.model, n2 = e3.document.selection, o2 = void 0 === t3.forceValue ? !this.value : t3.forceValue;
            e3.change((t4) => {
              if (n2.isCollapsed)
                o2 ? t4.setSelectionAttribute(this.attributeKey, true) : t4.removeSelectionAttribute(this.attributeKey);
              else {
                const i2 = e3.schema.getValidRanges(n2.getRanges(), this.attributeKey);
                for (const e4 of i2)
                  o2 ? t4.setAttribute(this.attributeKey, o2, e4) : t4.removeAttribute(this.attributeKey, e4);
              }
            });
          }
          _getValueFromFirstAllowedNode() {
            const t3 = this.editor.model, e3 = t3.schema, n2 = t3.document.selection;
            if (n2.isCollapsed)
              return n2.hasAttribute(this.attributeKey);
            for (const t4 of n2.getRanges())
              for (const n3 of t4.getItems())
                if (e3.checkAttribute(n3, this.attributeKey))
                  return n3.hasAttribute(this.attributeKey);
            return false;
          }
        }
        const Hw = "bold";
        class qw extends es {
          static get pluginName() {
            return "BoldEditing";
          }
          init() {
            const t3 = this.editor;
            t3.model.schema.extend("$text", { allowAttributes: Hw }), t3.model.schema.setAttributeProperties(Hw, { isFormatting: true, copyOnEnter: true }), t3.conversion.attributeToElement({ model: Hw, view: "strong", upcastAlso: ["b", (t4) => {
              const e3 = t4.getStyle("font-weight");
              return e3 && ("bold" == e3 || Number(e3) >= 600) ? { name: true, styles: ["font-weight"] } : null;
            }] }), t3.commands.add(Hw, new Uw(t3, Hw)), t3.keystrokes.set("CTRL+B", Hw);
          }
        }
        const Gw = "bold";
        class Ww extends es {
          static get pluginName() {
            return "BoldUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.t;
            t3.ui.componentFactory.add(Gw, (n2) => {
              const o2 = t3.commands.get(Gw), i2 = new br(n2);
              return i2.set({ label: e3("Bold"), icon: Rg.bold, keystroke: "CTRL+B", tooltip: true, isToggleable: true }), i2.bind("isOn", "isEnabled").to(o2, "value", "isEnabled"), this.listenTo(i2, "execute", () => {
                t3.execute(Gw), t3.editing.view.focus();
              }), i2;
            });
          }
        }
        var Kw = n(8603), Zw = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Kw.Z, Zw);
        Kw.Z.locals;
        const Yw = "italic";
        class $w extends es {
          static get pluginName() {
            return "ItalicEditing";
          }
          init() {
            const t3 = this.editor;
            t3.model.schema.extend("$text", { allowAttributes: Yw }), t3.model.schema.setAttributeProperties(Yw, { isFormatting: true, copyOnEnter: true }), t3.conversion.attributeToElement({ model: Yw, view: "i", upcastAlso: ["em", { styles: { "font-style": "italic" } }] }), t3.commands.add(Yw, new Uw(t3, Yw)), t3.keystrokes.set("CTRL+I", Yw);
          }
        }
        const Qw = "italic";
        class Jw extends es {
          static get pluginName() {
            return "ItalicUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.t;
            t3.ui.componentFactory.add(Qw, (n2) => {
              const o2 = t3.commands.get(Qw), i2 = new br(n2);
              return i2.set({ label: e3("Italic"), icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m9.586 14.633.021.004c-.036.335.095.655.393.962.082.083.173.15.274.201h1.474a.6.6 0 1 1 0 1.2H5.304a.6.6 0 0 1 0-1.2h1.15c.474-.07.809-.182 1.005-.334.157-.122.291-.32.404-.597l2.416-9.55a1.053 1.053 0 0 0-.281-.823 1.12 1.12 0 0 0-.442-.296H8.15a.6.6 0 0 1 0-1.2h6.443a.6.6 0 1 1 0 1.2h-1.195c-.376.056-.65.155-.823.296-.215.175-.423.439-.623.79l-2.366 9.347z"/></svg>', keystroke: "CTRL+I", tooltip: true, isToggleable: true }), i2.bind("isOn", "isEnabled").to(o2, "value", "isEnabled"), this.listenTo(i2, "execute", () => {
                t3.execute(Qw), t3.editing.view.focus();
              }), i2;
            });
          }
        }
        class Xw extends os {
          refresh() {
            this.value = this._getValue(), this.isEnabled = this._checkEnabled();
          }
          execute(t3 = {}) {
            const e3 = this.editor.model, n2 = e3.schema, o2 = e3.document.selection, i2 = Array.from(o2.getSelectedBlocks()), r2 = void 0 === t3.forceValue ? !this.value : t3.forceValue;
            e3.change((t4) => {
              if (r2) {
                const e4 = i2.filter((t5) => tA(t5) || nA(n2, t5));
                this._applyQuote(t4, e4);
              } else
                this._removeQuote(t4, i2.filter(tA));
            });
          }
          _getValue() {
            const t3 = Ii(this.editor.model.document.selection.getSelectedBlocks());
            return !(!t3 || !tA(t3));
          }
          _checkEnabled() {
            if (this.value)
              return true;
            const t3 = this.editor.model.document.selection, e3 = this.editor.model.schema, n2 = Ii(t3.getSelectedBlocks());
            return !!n2 && nA(e3, n2);
          }
          _removeQuote(t3, e3) {
            eA(t3, e3).reverse().forEach((e4) => {
              if (e4.start.isAtStart && e4.end.isAtEnd)
                return void t3.unwrap(e4.start.parent);
              if (e4.start.isAtStart) {
                const n3 = t3.createPositionBefore(e4.start.parent);
                return void t3.move(e4, n3);
              }
              e4.end.isAtEnd || t3.split(e4.end);
              const n2 = t3.createPositionAfter(e4.end.parent);
              t3.move(e4, n2);
            });
          }
          _applyQuote(t3, e3) {
            const n2 = [];
            eA(t3, e3).reverse().forEach((e4) => {
              let o2 = tA(e4.start);
              o2 || (o2 = t3.createElement("blockQuote"), t3.wrap(e4, o2)), n2.push(o2);
            }), n2.reverse().reduce((e4, n3) => e4.nextSibling == n3 ? (t3.merge(t3.createPositionAfter(e4)), e4) : n3);
          }
        }
        function tA(t3) {
          return "blockQuote" == t3.parent.name ? t3.parent : null;
        }
        function eA(t3, e3) {
          let n2, o2 = 0;
          const i2 = [];
          for (; o2 < e3.length; ) {
            const r2 = e3[o2], s3 = e3[o2 + 1];
            n2 || (n2 = t3.createPositionBefore(r2)), s3 && r2.nextSibling == s3 || (i2.push(t3.createRange(n2, t3.createPositionAfter(r2))), n2 = null), o2++;
          }
          return i2;
        }
        function nA(t3, e3) {
          const n2 = t3.checkChild(e3.parent, "blockQuote"), o2 = t3.checkChild(["$root", "blockQuote"], e3);
          return n2 && o2;
        }
        class oA extends es {
          static get pluginName() {
            return "BlockQuoteEditing";
          }
          static get requires() {
            return [Qk, Ek];
          }
          init() {
            const t3 = this.editor, e3 = t3.model.schema;
            t3.commands.add("blockQuote", new Xw(t3)), e3.register("blockQuote", { inheritAllFrom: "$container" }), t3.conversion.elementToElement({ model: "blockQuote", view: "blockquote" }), t3.model.document.registerPostFixer((n3) => {
              const o3 = t3.model.document.differ.getChanges();
              for (const t4 of o3)
                if ("insert" == t4.type) {
                  const o4 = t4.position.nodeAfter;
                  if (!o4)
                    continue;
                  if (o4.is("element", "blockQuote") && o4.isEmpty)
                    return n3.remove(o4), true;
                  if (o4.is("element", "blockQuote") && !e3.checkChild(t4.position, o4))
                    return n3.unwrap(o4), true;
                  if (o4.is("element")) {
                    const t5 = n3.createRangeIn(o4);
                    for (const o5 of t5.getItems())
                      if (o5.is("element", "blockQuote") && !e3.checkChild(n3.createPositionBefore(o5), o5))
                        return n3.unwrap(o5), true;
                  }
                } else if ("remove" == t4.type) {
                  const e4 = t4.position.parent;
                  if (e4.is("element", "blockQuote") && e4.isEmpty)
                    return n3.remove(e4), true;
                }
              return false;
            });
            const n2 = this.editor.editing.view.document, o2 = t3.model.document.selection, i2 = t3.commands.get("blockQuote");
            this.listenTo(n2, "enter", (e4, n3) => {
              if (!o2.isCollapsed || !i2.value)
                return;
              o2.getLastPosition().parent.isEmpty && (t3.execute("blockQuote"), t3.editing.view.scrollToTheSelection(), n3.preventDefault(), e4.stop());
            }, { context: "blockquote" }), this.listenTo(n2, "delete", (e4, n3) => {
              if ("backward" != n3.direction || !o2.isCollapsed || !i2.value)
                return;
              const r2 = o2.getLastPosition().parent;
              r2.isEmpty && !r2.previousSibling && (t3.execute("blockQuote"), t3.editing.view.scrollToTheSelection(), n3.preventDefault(), e4.stop());
            }, { context: "blockquote" });
          }
        }
        var iA = n(3062), rA = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(iA.Z, rA);
        iA.Z.locals;
        class sA extends es {
          static get pluginName() {
            return "BlockQuoteUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.t;
            t3.ui.componentFactory.add("blockQuote", (n2) => {
              const o2 = t3.commands.get("blockQuote"), i2 = new br(n2);
              return i2.set({ label: e3("Block quote"), icon: Rg.quote, tooltip: true, isToggleable: true }), i2.bind("isOn", "isEnabled").to(o2, "value", "isEnabled"), this.listenTo(i2, "execute", () => {
                t3.execute("blockQuote"), t3.editing.view.focus();
              }), i2;
            });
          }
        }
        class aA extends es {
          static get pluginName() {
            return "CKBoxUI";
          }
          afterInit() {
            const t3 = this.editor, e3 = t3.commands.get("ckbox");
            if (!e3)
              return;
            const n2 = t3.t;
            if (t3.ui.componentFactory.add("ckbox", (o2) => {
              const i2 = new br(o2);
              return i2.set({ label: n2("Open file manager"), icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>', tooltip: true }), i2.bind("isOn", "isEnabled").to(e3, "value", "isEnabled"), i2.on("execute", () => {
                t3.execute("ckbox");
              }), i2;
            }), t3.plugins.has("ImageInsertUI")) {
              const o2 = t3.plugins.get("ImageInsertUI");
              o2.registerIntegration({ name: "assetManager", observable: e3, buttonViewCreator: () => {
                const t4 = this.editor.ui.componentFactory.create("ckbox");
                return t4.icon = Rg.imageAssetManager, t4.bind("label").to(o2, "isImageSelected", (t5) => n2(t5 ? "Replace image with file manager" : "Insert image with file manager")), t4;
              }, formViewCreator: () => {
                const t4 = this.editor.ui.componentFactory.create("ckbox");
                return t4.icon = Rg.imageAssetManager, t4.withText = true, t4.bind("label").to(o2, "isImageSelected", (t5) => n2(t5 ? "Replace with file manager" : "Insert with file manager")), t4.on("execute", () => {
                  o2.dropdownView.isOpen = false;
                }), t4;
              } });
            }
          }
        }
        var cA = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z", "a", "b", "c", "d", "e", "f", "g", "h", "i", "j", "k", "l", "m", "n", "o", "p", "q", "r", "s", "t", "u", "v", "w", "x", "y", "z", "#", "$", "%", "*", "+", ",", "-", ".", ":", ";", "=", "?", "@", "[", "]", "^", "_", "{", "|", "}", "~"], lA = (t3) => {
          let e3 = 0;
          for (let n2 = 0; n2 < t3.length; n2++) {
            let o2 = t3[n2];
            e3 = 83 * e3 + cA.indexOf(o2);
          }
          return e3;
        }, dA = (t3) => {
          let e3 = t3 / 255;
          return e3 <= 0.04045 ? e3 / 12.92 : Math.pow((e3 + 0.055) / 1.055, 2.4);
        }, hA = (t3) => {
          let e3 = Math.max(0, Math.min(1, t3));
          return e3 <= 31308e-7 ? Math.trunc(12.92 * e3 * 255 + 0.5) : Math.trunc(255 * (1.055 * Math.pow(e3, 0.4166666666666667) - 0.055) + 0.5);
        }, uA = (t3, e3) => ((t4) => t4 < 0 ? -1 : 1)(t3) * Math.pow(Math.abs(t3), e3), gA = class extends Error {
          constructor(t3) {
            super(t3), this.name = "ValidationError", this.message = t3;
          }
        }, pA = (t3) => {
          if (!t3 || t3.length < 6)
            throw new gA("The blurhash string must be at least 6 characters");
          let e3 = lA(t3[0]), n2 = Math.floor(e3 / 9) + 1, o2 = e3 % 9 + 1;
          if (t3.length !== 4 + 2 * o2 * n2)
            throw new gA(`blurhash length mismatch: length is ${t3.length} but it should be ${4 + 2 * o2 * n2}`);
        }, mA = (t3) => {
          let e3 = t3 >> 8 & 255, n2 = 255 & t3;
          return [dA(t3 >> 16), dA(e3), dA(n2)];
        }, fA = (t3, e3) => {
          let n2 = Math.floor(t3 / 361), o2 = Math.floor(t3 / 19) % 19, i2 = t3 % 19;
          return [uA((n2 - 9) / 9, 2) * e3, uA((o2 - 9) / 9, 2) * e3, uA((i2 - 9) / 9, 2) * e3];
        }, kA = (t3, e3, n2, o2) => {
          pA(t3), o2 |= 1;
          let i2 = lA(t3[0]), r2 = Math.floor(i2 / 9) + 1, s3 = i2 % 9 + 1, a2 = (lA(t3[1]) + 1) / 166, c2 = new Array(s3 * r2);
          for (let e4 = 0; e4 < c2.length; e4++)
            if (0 === e4) {
              let n3 = lA(t3.substring(2, 6));
              c2[e4] = mA(n3);
            } else {
              let n3 = lA(t3.substring(4 + 2 * e4, 6 + 2 * e4));
              c2[e4] = fA(n3, a2 * o2);
            }
          let l2 = 4 * e3, d2 = new Uint8ClampedArray(l2 * n2);
          for (let t4 = 0; t4 < n2; t4++)
            for (let o3 = 0; o3 < e3; o3++) {
              let i3 = 0, a3 = 0, h2 = 0;
              for (let l3 = 0; l3 < r2; l3++)
                for (let r3 = 0; r3 < s3; r3++) {
                  let d3 = Math.cos(Math.PI * o3 * r3 / e3) * Math.cos(Math.PI * t4 * l3 / n2), u3 = c2[r3 + l3 * s3];
                  i3 += u3[0] * d3, a3 += u3[1] * d3, h2 += u3[2] * d3;
                }
              let u2 = hA(i3), g2 = hA(a3), p2 = hA(h2);
              d2[4 * o3 + 0 + t4 * l2] = u2, d2[4 * o3 + 1 + t4 * l2] = g2, d2[4 * o3 + 2 + t4 * l2] = p2, d2[4 * o3 + 3 + t4 * l2] = 255;
            }
          return d2;
        }, bA = Object.defineProperty, wA = Object.getOwnPropertySymbols, AA = Object.prototype.hasOwnProperty, CA = Object.prototype.propertyIsEnumerable, _A = (t3, e3, n2) => e3 in t3 ? bA(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2;
        function vA(t3) {
          const e3 = [];
          let n2 = 0;
          for (const o3 in t3) {
            const i2 = parseInt(o3, 10);
            isNaN(i2) || (i2 > n2 && (n2 = i2), e3.push(`${t3[o3]} ${o3}w`));
          }
          const o2 = [{ srcset: e3.join(","), sizes: `(max-width: ${n2}px) 100vw, ${n2}px`, type: "image/webp" }];
          return { imageFallbackUrl: t3.default, imageSources: o2 };
        }
        const yA = 32;
        function xA({ url: t3, method: e3 = "GET", data: n2, onUploadProgress: o2, signal: i2, authorization: r2 }) {
          const s3 = new XMLHttpRequest();
          s3.open(e3, t3.toString()), s3.setRequestHeader("Authorization", r2), s3.setRequestHeader("CKBox-Version", "CKEditor 5"), s3.responseType = "json";
          const a2 = () => {
            s3.abort();
          };
          return new Promise((t4, e4) => {
            i2.throwIfAborted(), i2.addEventListener("abort", a2), s3.addEventListener("loadstart", () => {
              i2.addEventListener("abort", a2);
            }), s3.addEventListener("loadend", () => {
              i2.removeEventListener("abort", a2);
            }), s3.addEventListener("error", () => {
              e4();
            }), s3.addEventListener("abort", () => {
              e4();
            }), s3.addEventListener("load", () => {
              const n3 = s3.response;
              if (!n3 || n3.statusCode >= 400)
                return e4(n3 && n3.message);
              t4(n3);
            }), o2 && s3.upload.addEventListener("progress", (t5) => {
              o2(t5);
            }), s3.send(n2);
          });
        }
        const EA = { "image/gif": "gif", "image/jpeg": "jpg", "image/png": "png", "image/webp": "webp", "image/bmp": "bmp", "image/tiff": "tiff" };
        function DA(t3, e3) {
          return n2 = this, o2 = null, i2 = function* () {
            try {
              const n3 = yield fetch(t3, ((t4, e4) => {
                for (var n4 in e4 || (e4 = {}))
                  AA.call(e4, n4) && _A(t4, n4, e4[n4]);
                if (wA)
                  for (var n4 of wA(e4))
                    CA.call(e4, n4) && _A(t4, n4, e4[n4]);
                return t4;
              })({ method: "HEAD", cache: "force-cache" }, e3));
              return n3.ok && n3.headers.get("content-type") || "";
            } catch (t4) {
              return "";
            }
          }, new Promise((t4, e4) => {
            var r2 = (t5) => {
              try {
                a2(i2.next(t5));
              } catch (t6) {
                e4(t6);
              }
            }, s3 = (t5) => {
              try {
                a2(i2.throw(t5));
              } catch (t6) {
                e4(t6);
              }
            }, a2 = (e5) => e5.done ? t4(e5.value) : Promise.resolve(e5.value).then(r2, s3);
            a2((i2 = i2.apply(n2, o2)).next());
          });
          var n2, o2, i2;
        }
        var IA = Object.defineProperty, SA = Object.getOwnPropertySymbols, TA = Object.prototype.hasOwnProperty, MA = Object.prototype.propertyIsEnumerable, BA = (t3, e3, n2) => e3 in t3 ? IA(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, NA = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            TA.call(e3, n2) && BA(t3, n2, e3[n2]);
          if (SA)
            for (var n2 of SA(e3))
              MA.call(e3, n2) && BA(t3, n2, e3[n2]);
          return t3;
        };
        class PA extends os {
          constructor(t3) {
            super(t3), this._chosenAssets = /* @__PURE__ */ new Set(), this._wrapper = null, this._initListeners();
          }
          refresh() {
            this.value = this._getValue(), this.isEnabled = this._checkEnabled();
          }
          execute() {
            this.fire("ckbox:open");
          }
          _getValue() {
            return null !== this._wrapper;
          }
          _checkEnabled() {
            const t3 = this.editor.commands.get("insertImage"), e3 = this.editor.commands.get("link");
            return !(!t3.isEnabled && !e3.isEnabled);
          }
          _prepareOptions() {
            const t3 = this.editor.config.get("ckbox");
            return { theme: t3.theme, language: t3.language, tokenUrl: t3.tokenUrl, serviceOrigin: t3.serviceOrigin, forceDemoLabel: t3.forceDemoLabel, dialog: { onClose: () => this.fire("ckbox:close") }, assets: { onChoose: (t4) => this.fire("ckbox:choose", t4) } };
          }
          _initListeners() {
            const t3 = this.editor, e3 = t3.model, n2 = !t3.config.get("ckbox.ignoreDataId");
            this.on("ckbox", () => {
              this.refresh();
            }, { priority: "low" }), this.on("ckbox:open", () => {
              this.isEnabled && !this.value && (this._wrapper = bt(document, "div", { class: "ck ckbox-wrapper" }), document.body.appendChild(this._wrapper), window.CKBox.mount(this._wrapper, this._prepareOptions()));
            }), this.on("ckbox:close", () => {
              this.value && (this._wrapper.remove(), this._wrapper = null, t3.editing.view.focus());
            }), this.on("ckbox:choose", (o2, i2) => {
              if (!this.isEnabled)
                return;
              const r2 = t3.commands.get("insertImage"), s3 = t3.commands.get("link"), a2 = function({ assets: t4, isImageAllowed: e4, isLinkAllowed: n3 }) {
                return t4.map((t5) => function(t6) {
                  const e5 = t6.data.metadata;
                  if (!e5)
                    return false;
                  return e5.width && e5.height;
                }(t5) ? { id: t5.data.id, type: "image", attributes: zA(t5) } : { id: t5.data.id, type: "link", attributes: OA(t5) }).filter((t5) => "image" === t5.type ? e4 : n3);
              }({ assets: i2, isImageAllowed: r2.isEnabled, isLinkAllowed: s3.isEnabled }), c2 = a2.length;
              0 !== c2 && (e3.change((t4) => {
                for (const e4 of a2) {
                  const o3 = e4 === a2[c2 - 1], i3 = 1 === c2;
                  this._insertAsset(e4, o3, t4, i3), n2 && (setTimeout(() => this._chosenAssets.delete(e4), 1e3), this._chosenAssets.add(e4));
                }
              }), t3.editing.view.focus());
            }), this.listenTo(t3, "destroy", () => {
              this.fire("ckbox:close"), this._chosenAssets.clear();
            });
          }
          _insertAsset(t3, e3, n2, o2) {
            const i2 = this.editor.model.document.selection;
            n2.removeSelectionAttribute("linkHref"), "image" === t3.type ? this._insertImage(t3) : this._insertLink(t3, n2, o2), e3 || n2.setSelection(i2.getLastPosition());
          }
          _insertImage(t3) {
            const e3 = this.editor, { imageFallbackUrl: n2, imageSources: o2, imageTextAlternative: i2, imageWidth: r2, imageHeight: s3, imagePlaceholder: a2 } = t3.attributes;
            e3.execute("insertImage", { source: NA({ src: n2, sources: o2, alt: i2, width: r2, height: s3 }, a2 ? { placeholder: a2 } : null) });
          }
          _insertLink(t3, e3, n2) {
            const o2 = this.editor, i2 = o2.model, r2 = i2.document.selection, { linkName: s3, linkHref: a2 } = t3.attributes;
            if (r2.isCollapsed) {
              const t4 = Mi(r2.getAttributes()), c2 = e3.createText(s3, t4);
              if (!n2) {
                const t5 = r2.getLastPosition(), n3 = t5.parent;
                "paragraph" === n3.name && n3.isEmpty || o2.execute("insertParagraph", { position: t5 });
                const s4 = i2.insertContent(c2);
                return e3.setSelection(s4), void o2.execute("link", a2);
              }
              const l2 = i2.insertContent(c2);
              e3.setSelection(l2);
            }
            o2.execute("link", a2);
          }
        }
        function zA(t3) {
          const { imageFallbackUrl: e3, imageSources: n2 } = vA(t3.data.imageUrls), { description: o2, width: i2, height: r2, blurHash: s3 } = t3.data.metadata, a2 = function(t4) {
            if (t4)
              try {
                const e4 = `${yA}px`, n3 = document.createElement("canvas");
                n3.setAttribute("width", e4), n3.setAttribute("height", e4);
                const o3 = n3.getContext("2d");
                if (!o3)
                  return;
                const i3 = o3.createImageData(yA, yA), r3 = kA(t4, yA, yA);
                return i3.data.set(r3), o3.putImageData(i3, 0, 0), n3.toDataURL();
              } catch (t5) {
                return;
              }
          }(s3);
          return NA({ imageFallbackUrl: e3, imageSources: n2, imageTextAlternative: o2 || "", imageWidth: i2, imageHeight: r2 }, a2 ? { imagePlaceholder: a2 } : null);
        }
        function OA(t3) {
          return { linkName: t3.data.name, linkHref: LA(t3) };
        }
        function LA(t3) {
          const e3 = new URL(t3.data.url);
          return e3.searchParams.set("download", "true"), e3.toString();
        }
        var RA = (t3, e3, n2) => new Promise((o2, i2) => {
          var r2 = (t4) => {
            try {
              a2(n2.next(t4));
            } catch (t5) {
              i2(t5);
            }
          }, s3 = (t4) => {
            try {
              a2(n2.throw(t4));
            } catch (t5) {
              i2(t5);
            }
          }, a2 = (t4) => t4.done ? o2(t4.value) : Promise.resolve(t4.value).then(r2, s3);
          a2((n2 = n2.apply(t3, e3)).next());
        });
        class jA extends es {
          static get pluginName() {
            return "CKBoxUtils";
          }
          static get requires() {
            return ["CloudServices"];
          }
          init() {
            return RA(this, null, function* () {
              const t3 = this.editor, e3 = !!t3.config.get("ckbox"), n2 = !!window.CKBox;
              if (!e3 && !n2)
                return;
              t3.config.define("ckbox", { serviceOrigin: "https://api.ckbox.io", defaultUploadCategories: null, ignoreDataId: false, language: t3.locale.uiLanguage, theme: "lark", tokenUrl: t3.config.get("cloudServices.tokenUrl") });
              const o2 = t3.plugins.get("CloudServices"), i2 = t3.config.get("cloudServices.tokenUrl"), r2 = t3.config.get("ckbox.tokenUrl");
              if (!r2)
                throw new A("ckbox-plugin-missing-token-url", this);
              this._token = r2 == i2 ? o2.token : yield o2.registerTokenUrl(r2);
            });
          }
          getToken() {
            return this._token;
          }
          getWorkspaceId() {
            const t3 = (0, this.editor.t)("Cannot access default workspace."), e3 = this.editor.config.get("ckbox.defaultUploadWorkspaceId"), n2 = function(t4, e4) {
              const [, n3] = t4.value.split("."), o2 = JSON.parse(atob(n3)), i2 = o2.auth && o2.auth.ckbox && o2.auth.ckbox.workspaces || [o2.aud];
              return e4 ? "superadmin" == (o2.auth && o2.auth.ckbox && o2.auth.ckbox.role) || i2.includes(e4) ? e4 : null : i2[0];
            }(this._token, e3);
            if (null == n2)
              throw _("ckbox-access-default-workspace-error"), t3;
            return n2;
          }
          getCategoryIdForFile(t3, e3) {
            return RA(this, null, function* () {
              const n2 = (0, this.editor.t)("Cannot determine a category for the uploaded file."), o2 = this.editor.config.get("ckbox.defaultUploadCategories"), i2 = this._getAvailableCategories(e3), r2 = "string" == typeof t3 ? (s3 = yield DA(t3, e3), EA[s3]) : function(t4) {
                const e4 = t4.name, n3 = new RegExp("\\.(?<ext>[^.]+)$");
                return e4.match(n3).groups.ext.toLowerCase();
              }(t3);
              var s3;
              const a2 = yield i2;
              if (!a2)
                throw n2;
              if (o2) {
                const t4 = Object.keys(o2).find((t5) => o2[t5].find((t6) => t6.toLowerCase() == r2));
                if (t4) {
                  const e4 = a2.find((e5) => e5.id === t4 || e5.name === t4);
                  if (!e4)
                    throw n2;
                  return e4.id;
                }
              }
              const c2 = a2.find((t4) => t4.extensions.find((t5) => t5.toLowerCase() == r2));
              if (!c2)
                throw n2;
              return c2.id;
            });
          }
          _getAvailableCategories(t3) {
            return RA(this, null, function* () {
              const e3 = this.editor, n2 = this._token, { signal: o2 } = t3, i2 = e3.config.get("ckbox.serviceOrigin"), r2 = this.getWorkspaceId();
              try {
                const t4 = [];
                let e4, n3 = 0;
                do {
                  const o3 = yield s3(n3);
                  t4.push(...o3.items), e4 = o3.totalCount - (n3 + 50), n3 += 50;
                } while (e4 > 0);
                return t4;
              } catch (t4) {
                return o2.throwIfAborted(), void _("ckbox-fetch-category-http-error");
              }
              function s3(t4) {
                const e4 = new URL("categories", i2);
                return e4.searchParams.set("limit", 50 .toString()), e4.searchParams.set("offset", t4.toString()), e4.searchParams.set("workspaceId", r2), xA({ url: e4, signal: o2, authorization: n2.value });
              }
            });
          }
        }
        var FA = (t3, e3, n2) => new Promise((o2, i2) => {
          var r2 = (t4) => {
            try {
              a2(n2.next(t4));
            } catch (t5) {
              i2(t5);
            }
          }, s3 = (t4) => {
            try {
              a2(n2.throw(t4));
            } catch (t5) {
              i2(t5);
            }
          }, a2 = (t4) => t4.done ? o2(t4.value) : Promise.resolve(t4.value).then(r2, s3);
          a2((n2 = n2.apply(t3, e3)).next());
        });
        class VA extends es {
          static get requires() {
            return ["ImageUploadEditing", "ImageUploadProgress", Tw, HA];
          }
          static get pluginName() {
            return "CKBoxUploadAdapter";
          }
          afterInit() {
            return FA(this, null, function* () {
              const t3 = this.editor, e3 = !!t3.config.get("ckbox"), n2 = !!window.CKBox;
              if (!e3 && !n2)
                return;
              const o2 = t3.plugins.get(Tw), i2 = t3.plugins.get(jA);
              o2.createUploadAdapter = (e4) => new UA(e4, t3, i2);
              const r2 = !t3.config.get("ckbox.ignoreDataId"), s3 = t3.plugins.get("ImageUploadEditing");
              r2 && s3.on("uploadComplete", (e4, { imageElement: n3, data: o3 }) => {
                t3.model.change((t4) => {
                  t4.setAttribute("ckboxImageId", o3.ckboxImageId, n3);
                });
              });
            });
          }
        }
        class UA {
          constructor(t3, e3, n2) {
            this.loader = t3, this.token = n2.getToken(), this.ckboxUtils = n2, this.editor = e3, this.controller = new AbortController(), this.serviceOrigin = e3.config.get("ckbox.serviceOrigin");
          }
          upload() {
            return FA(this, null, function* () {
              const t3 = this.ckboxUtils, e3 = this.editor.t, n2 = yield this.loader.file, o2 = yield t3.getCategoryIdForFile(n2, { signal: this.controller.signal }), i2 = new URL("assets", this.serviceOrigin), r2 = new FormData();
              i2.searchParams.set("workspaceId", t3.getWorkspaceId()), r2.append("categoryId", o2), r2.append("file", n2);
              return xA({ method: "POST", url: i2, data: r2, onUploadProgress: (t4) => {
                t4.lengthComputable && (this.loader.uploadTotal = t4.total, this.loader.uploaded = t4.loaded);
              }, signal: this.controller.signal, authorization: this.token.value }).then((t4) => FA(this, null, function* () {
                const e4 = vA(t4.imageUrls);
                return { ckboxImageId: t4.id, default: e4.imageFallbackUrl, sources: e4.imageSources };
              })).catch(() => {
                const t4 = e3("Cannot upload file:") + ` ${n2.name}.`;
                return Promise.reject(t4);
              });
            });
          }
          abort() {
            this.controller.abort();
          }
        }
        class HA extends es {
          static get pluginName() {
            return "CKBoxEditing";
          }
          static get requires() {
            return ["LinkEditing", "PictureEditing", VA, jA];
          }
          init() {
            const t3 = this.editor, e3 = !!t3.config.get("ckbox"), n2 = !!window.CKBox;
            (e3 || n2) && (this._checkImagePlugins(), t3.config.get("ckbox.ignoreDataId") || (this._initSchema(), this._initConversion(), this._initFixers()), n2 && t3.commands.add("ckbox", new PA(t3)));
          }
          _checkImagePlugins() {
            const t3 = this.editor;
            t3.plugins.has("ImageBlockEditing") || t3.plugins.has("ImageInlineEditing") || _("ckbox-plugin-image-feature-missing", t3);
          }
          _initSchema() {
            const t3 = this.editor.model.schema;
            t3.extend("$text", { allowAttributes: "ckboxLinkId" }), t3.isRegistered("imageBlock") && t3.extend("imageBlock", { allowAttributes: ["ckboxImageId", "ckboxLinkId"] }), t3.isRegistered("imageInline") && t3.extend("imageInline", { allowAttributes: ["ckboxImageId", "ckboxLinkId"] }), t3.addAttributeCheck((t4, e3) => {
              if (!!!t4.last.getAttribute("linkHref") && "ckboxLinkId" === e3)
                return false;
            });
          }
          _initConversion() {
            const t3 = this.editor;
            t3.conversion.for("downcast").add((t4) => {
              t4.on("attribute:ckboxLinkId:imageBlock", (t5, e4, n2) => {
                const { writer: o2, mapper: i2, consumable: r2 } = n2;
                if (!r2.consume(e4.item, t5.name))
                  return;
                const s3 = [...i2.toViewElement(e4.item).getChildren()].find((t6) => "a" === t6.name);
                s3 && (e4.item.hasAttribute("ckboxLinkId") ? o2.setAttribute("data-ckbox-resource-id", e4.item.getAttribute("ckboxLinkId"), s3) : o2.removeAttribute("data-ckbox-resource-id", s3));
              }, { priority: "low" }), t4.on("attribute:ckboxLinkId", (t5, e4, n2) => {
                const { writer: o2, mapper: i2, consumable: r2 } = n2;
                if (r2.consume(e4.item, t5.name)) {
                  if (e4.attributeOldValue) {
                    const t6 = GA(o2, e4.attributeOldValue);
                    o2.unwrap(i2.toViewRange(e4.range), t6);
                  }
                  if (e4.attributeNewValue) {
                    const t6 = GA(o2, e4.attributeNewValue);
                    if (e4.item.is("selection")) {
                      const e5 = o2.document.selection;
                      o2.wrap(e5.getFirstRange(), t6);
                    } else
                      o2.wrap(i2.toViewRange(e4.range), t6);
                  }
                }
              }, { priority: "low" });
            }), t3.conversion.for("upcast").add((t4) => {
              t4.on("element:a", (t5, e4, n2) => {
                const { writer: o2, consumable: i2 } = n2;
                if (!e4.viewItem.getAttribute("href"))
                  return;
                if (!i2.consume(e4.viewItem, { attributes: ["data-ckbox-resource-id"] }))
                  return;
                const r2 = e4.viewItem.getAttribute("data-ckbox-resource-id");
                if (r2)
                  if (e4.modelRange)
                    for (let t6 of e4.modelRange.getItems())
                      t6.is("$textProxy") && (t6 = t6.textNode), WA(t6) && o2.setAttribute("ckboxLinkId", r2, t6);
                  else {
                    const t6 = e4.modelCursor.nodeBefore || e4.modelCursor.parent;
                    o2.setAttribute("ckboxLinkId", r2, t6);
                  }
              }, { priority: "low" });
            }), t3.conversion.for("downcast").attributeToAttribute({ model: "ckboxImageId", view: "data-ckbox-resource-id" }), t3.conversion.for("upcast").elementToAttribute({ model: { key: "ckboxImageId", value: (t4) => t4.getAttribute("data-ckbox-resource-id") }, view: { attributes: { "data-ckbox-resource-id": /[\s\S]+/ } } });
            const e3 = t3.commands.get("replaceImageSource");
            e3 && this.listenTo(e3, "cleanupImage", (t4, [e4, n2]) => {
              e4.removeAttribute("ckboxImageId", n2);
            });
          }
          _initFixers() {
            const t3 = this.editor, e3 = t3.model, n2 = e3.document.selection;
            e3.document.registerPostFixer(function(t4) {
              return (e4) => {
                let n3 = false;
                const o2 = t4.model, i2 = t4.commands.get("ckbox");
                if (!i2)
                  return n3;
                for (const t5 of o2.document.differ.getChanges()) {
                  if ("insert" !== t5.type && "attribute" !== t5.type)
                    continue;
                  const o3 = "insert" === t5.type ? new Jl(t5.position, t5.position.getShiftedBy(t5.length)) : t5.range, r2 = "attribute" === t5.type && "linkHref" === t5.attributeKey && null === t5.attributeNewValue;
                  for (const t6 of o3.getItems()) {
                    if (r2 && t6.hasAttribute("ckboxLinkId")) {
                      e4.removeAttribute("ckboxLinkId", t6), n3 = true;
                      continue;
                    }
                    const o4 = qA(t6, i2._chosenAssets);
                    for (const i3 of o4) {
                      const o5 = "image" === i3.type ? "ckboxImageId" : "ckboxLinkId";
                      i3.id !== t6.getAttribute(o5) && (e4.setAttribute(o5, i3.id, t6), n3 = true);
                    }
                  }
                }
                return n3;
              };
            }(t3)), e3.document.registerPostFixer(function(t4) {
              return (e4) => !(t4.hasAttribute("linkHref") || !t4.hasAttribute("ckboxLinkId")) && (e4.removeSelectionAttribute("ckboxLinkId"), true);
            }(n2));
          }
        }
        function qA(t3, e3) {
          const n2 = t3.is("element", "imageInline") || t3.is("element", "imageBlock"), o2 = t3.hasAttribute("linkHref");
          return [...e3].filter((e4) => "image" === e4.type && n2 ? e4.attributes.imageFallbackUrl === t3.getAttribute("src") : "link" === e4.type && o2 ? e4.attributes.linkHref === t3.getAttribute("linkHref") : void 0);
        }
        function GA(t3, e3) {
          const n2 = t3.createAttributeElement("a", { "data-ckbox-resource-id": e3 }, { priority: 5 });
          return t3.setCustomProperty("link", true, n2), n2;
        }
        function WA(t3) {
          return !!t3.is("$text") || !(!t3.is("element", "imageInline") && !t3.is("element", "imageBlock"));
        }
        Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        var KA = n(443), ZA = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(KA.Z, ZA);
        KA.Z.locals;
        class YA extends es {
          static get pluginName() {
            return "CKFinderUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.ui.componentFactory, n2 = t3.t;
            if (e3.add("ckfinder", (e4) => {
              const o2 = t3.commands.get("ckfinder"), i2 = new br(e4);
              return i2.set({ label: n2("Insert image or file"), icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M11.627 16.5zm5.873-.196zm0-7.001V8h-13v8.5h4.341c.191.54.457 1.044.785 1.5H2a1.5 1.5 0 0 1-1.5-1.5v-13A1.5 1.5 0 0 1 2 2h4.5a1.5 1.5 0 0 1 1.06.44L9.122 4H16a1.5 1.5 0 0 1 1.5 1.5v1A1.5 1.5 0 0 1 19 8v2.531a6.027 6.027 0 0 0-1.5-1.228zM16 6.5v-1H8.5l-2-2H2v13h1V8a1.5 1.5 0 0 1 1.5-1.5H16z"/><path d="M14.5 19.5a5 5 0 1 1 0-10 5 5 0 0 1 0 10zM15 14v-2h-1v2h-2v1h2v2h1v-2h2v-1h-2z"/></svg>', tooltip: true }), i2.bind("isEnabled").to(o2), i2.on("execute", () => {
                t3.execute("ckfinder"), t3.editing.view.focus();
              }), i2;
            }), t3.plugins.has("ImageInsertUI")) {
              const e4 = t3.plugins.get("ImageInsertUI"), o2 = t3.commands.get("ckfinder");
              e4.registerIntegration({ name: "assetManager", observable: o2, buttonViewCreator: () => {
                const t4 = this.editor.ui.componentFactory.create("ckfinder");
                return t4.icon = Rg.imageAssetManager, t4.bind("label").to(e4, "isImageSelected", (t5) => n2(t5 ? "Replace image with file manager" : "Insert image with file manager")), t4;
              }, formViewCreator: () => {
                const t4 = this.editor.ui.componentFactory.create("ckfinder");
                return t4.icon = Rg.imageAssetManager, t4.withText = true, t4.bind("label").to(e4, "isImageSelected", (t5) => n2(t5 ? "Replace with file manager" : "Insert with file manager")), t4.on("execute", () => {
                  e4.dropdownView.isOpen = false;
                }), t4;
              } });
            }
          }
        }
        class $A extends os {
          constructor(t3) {
            super(t3), this.affectsData = false, this.stopListening(this.editor.model.document, "change"), this.listenTo(this.editor.model.document, "change", () => this.refresh(), { priority: "low" });
          }
          refresh() {
            const t3 = this.editor.commands.get("insertImage"), e3 = this.editor.commands.get("link");
            this.isEnabled = t3.isEnabled || e3.isEnabled;
          }
          execute() {
            const t3 = this.editor, e3 = this.editor.config.get("ckfinder.openerMethod") || "modal";
            if ("popup" != e3 && "modal" != e3)
              throw new A("ckfinder-unknown-openermethod", t3);
            const n2 = this.editor.config.get("ckfinder.options") || {};
            n2.chooseFiles = true;
            const o2 = n2.onInit;
            n2.language || (n2.language = t3.locale.uiLanguage), n2.onInit = (e4) => {
              o2 && o2(e4), e4.on("files:choose", (n3) => {
                const o3 = n3.data.files.toArray(), i2 = o3.filter((t4) => !t4.isImage()), r2 = o3.filter((t4) => t4.isImage());
                for (const e5 of i2)
                  t3.execute("link", e5.getUrl());
                const s3 = [];
                for (const t4 of r2) {
                  const n4 = t4.getUrl();
                  s3.push(n4 || e4.request("file:getProxyUrl", { file: t4 }));
                }
                s3.length && QA(t3, s3);
              }), e4.on("file:choose:resizedImage", (e5) => {
                const n3 = e5.data.resizedUrl;
                if (n3)
                  QA(t3, [n3]);
                else {
                  const e6 = t3.plugins.get("Notification"), n4 = t3.locale.t;
                  e6.showWarning(n4("Could not obtain resized image URL."), { title: n4("Selecting resized image failed"), namespace: "ckfinder" });
                }
              });
            }, window.CKFinder[e3](n2);
          }
        }
        function QA(t3, e3) {
          if (t3.commands.get("insertImage").isEnabled)
            t3.execute("insertImage", { source: e3 });
          else {
            const e4 = t3.plugins.get("Notification"), n2 = t3.locale.t;
            e4.showWarning(n2("Could not insert image at the current position."), { title: n2("Inserting image failed"), namespace: "ckfinder" });
          }
        }
        class JA extends es {
          static get pluginName() {
            return "CKFinderEditing";
          }
          static get requires() {
            return [$m, "LinkEditing"];
          }
          init() {
            const t3 = this.editor;
            if (!t3.plugins.has("ImageBlockEditing") && !t3.plugins.has("ImageInlineEditing"))
              throw new A("ckfinder-missing-image-plugin", t3);
            t3.commands.add("ckfinder", new $A(t3));
          }
        }
        class XA extends es {
          static get pluginName() {
            return "CloudServicesUploadAdapter";
          }
          static get requires() {
            return ["CloudServices", Tw];
          }
          init() {
            const t3 = this.editor, e3 = t3.plugins.get("CloudServices"), n2 = e3.token, o2 = e3.uploadUrl;
            if (!n2)
              return;
            const i2 = t3.plugins.get("CloudServicesCore");
            this._uploadGateway = i2.createUploadGateway(n2, o2), t3.plugins.get(Tw).createUploadAdapter = (t4) => new tC(this._uploadGateway, t4);
          }
        }
        class tC {
          constructor(t3, e3) {
            this.uploadGateway = t3, this.loader = e3;
          }
          upload() {
            return this.loader.file.then((t3) => (this.fileUploader = this.uploadGateway.upload(t3), this.fileUploader.on("progress", (t4, e3) => {
              this.loader.uploadTotal = e3.total, this.loader.uploaded = e3.uploaded;
            }), this.fileUploader.send()));
          }
          abort() {
            this.fileUploader.abort();
          }
        }
        class eC extends os {
          constructor(t3) {
            super(t3), this._isEnabledBasedOnSelection = false;
          }
          refresh() {
            const t3 = this.editor.model, e3 = Ii(t3.document.selection.getSelectedBlocks());
            this.value = !!e3 && e3.is("element", "paragraph"), this.isEnabled = !!e3 && nC(e3, t3.schema);
          }
          execute(t3 = {}) {
            const e3 = this.editor.model, n2 = e3.document, o2 = t3.selection || n2.selection;
            e3.canEditAt(o2) && e3.change((t4) => {
              const n3 = o2.getSelectedBlocks();
              for (const o3 of n3)
                !o3.is("element", "paragraph") && nC(o3, e3.schema) && t4.rename(o3, "paragraph");
            });
          }
        }
        function nC(t3, e3) {
          return e3.checkChild(t3.parent, "paragraph") && !e3.isObject(t3);
        }
        class oC extends os {
          constructor(t3) {
            super(t3), this._isEnabledBasedOnSelection = false;
          }
          execute(t3) {
            const e3 = this.editor.model, n2 = t3.attributes;
            let o2 = t3.position;
            e3.canEditAt(o2) && e3.change((t4) => {
              if (o2 = this._findPositionToInsertParagraph(o2, t4), !o2)
                return;
              const i2 = t4.createElement("paragraph");
              n2 && e3.schema.setAllowedAttributes(i2, n2, t4), e3.insertContent(i2, o2), t4.setSelection(i2, "in");
            });
          }
          _findPositionToInsertParagraph(t3, e3) {
            const n2 = this.editor.model;
            if (n2.schema.checkChild(t3, "paragraph"))
              return t3;
            const o2 = n2.schema.findAllowedParent(t3, "paragraph");
            if (!o2)
              return null;
            const i2 = t3.parent, r2 = n2.schema.checkChild(i2, "$text");
            return i2.isEmpty || r2 && t3.isAtEnd ? n2.createPositionAfter(i2) : !i2.isEmpty && r2 && t3.isAtStart ? n2.createPositionBefore(i2) : e3.split(t3, o2).position;
          }
        }
        const iC = class extends es {
          static get pluginName() {
            return "Paragraph";
          }
          init() {
            const t3 = this.editor, e3 = t3.model;
            t3.commands.add("paragraph", new eC(t3)), t3.commands.add("insertParagraph", new oC(t3)), e3.schema.register("paragraph", { inheritAllFrom: "$block" }), t3.conversion.elementToElement({ model: "paragraph", view: "p" }), t3.conversion.for("upcast").elementToElement({ model: (t4, { writer: e4 }) => iC.paragraphLikeElements.has(t4.name) ? t4.isEmpty ? null : e4.createElement("paragraph") : null, view: /.+/, converterPriority: "low" });
          }
        };
        let rC = iC;
        rC.paragraphLikeElements = /* @__PURE__ */ new Set(["blockquote", "dd", "div", "dt", "h1", "h2", "h3", "h4", "h5", "h6", "li", "p", "td", "th"]);
        class sC extends os {
          constructor(t3, e3) {
            super(t3), this.modelElements = e3;
          }
          refresh() {
            const t3 = Ii(this.editor.model.document.selection.getSelectedBlocks());
            this.value = !!t3 && this.modelElements.includes(t3.name) && t3.name, this.isEnabled = !!t3 && this.modelElements.some((e3) => aC(t3, e3, this.editor.model.schema));
          }
          execute(t3) {
            const e3 = this.editor.model, n2 = e3.document, o2 = t3.value;
            e3.change((t4) => {
              const i2 = Array.from(n2.selection.getSelectedBlocks()).filter((t5) => aC(t5, o2, e3.schema));
              for (const e4 of i2)
                e4.is("element", o2) || t4.rename(e4, o2);
            });
          }
        }
        function aC(t3, e3, n2) {
          return n2.checkChild(t3.parent, e3) && !n2.isObject(t3);
        }
        const cC = "paragraph";
        class lC extends es {
          static get pluginName() {
            return "HeadingEditing";
          }
          constructor(t3) {
            super(t3), t3.config.define("heading", { options: [{ model: "paragraph", title: "Paragraph", class: "ck-heading_paragraph" }, { model: "heading1", view: "h2", title: "Heading 1", class: "ck-heading_heading1" }, { model: "heading2", view: "h3", title: "Heading 2", class: "ck-heading_heading2" }, { model: "heading3", view: "h4", title: "Heading 3", class: "ck-heading_heading3" }] });
          }
          static get requires() {
            return [rC];
          }
          init() {
            const t3 = this.editor, e3 = t3.config.get("heading.options"), n2 = [];
            for (const o2 of e3)
              "paragraph" !== o2.model && (t3.model.schema.register(o2.model, { inheritAllFrom: "$block" }), t3.conversion.elementToElement(o2), n2.push(o2.model));
            this._addDefaultH1Conversion(t3), t3.commands.add("heading", new sC(t3, n2));
          }
          afterInit() {
            const t3 = this.editor, e3 = t3.commands.get("enter"), n2 = t3.config.get("heading.options");
            e3 && this.listenTo(e3, "afterExecute", (e4, o2) => {
              const i2 = t3.model.document.selection.getFirstPosition().parent;
              n2.some((t4) => i2.is("element", t4.model)) && !i2.is("element", cC) && 0 === i2.childCount && o2.writer.rename(i2, cC);
            });
          }
          _addDefaultH1Conversion(t3) {
            t3.conversion.for("upcast").elementToElement({ model: "heading1", view: "h1", converterPriority: k.low + 1 });
          }
        }
        var dC = n(8733), hC = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(dC.Z, hC);
        dC.Z.locals;
        class uC extends es {
          static get pluginName() {
            return "HeadingUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.t, n2 = function(t4) {
              const e4 = t4.t, n3 = { Paragraph: e4("Paragraph"), "Heading 1": e4("Heading 1"), "Heading 2": e4("Heading 2"), "Heading 3": e4("Heading 3"), "Heading 4": e4("Heading 4"), "Heading 5": e4("Heading 5"), "Heading 6": e4("Heading 6") };
              return t4.config.get("heading.options").map((t5) => {
                const e5 = n3[t5.title];
                return e5 && e5 != t5.title && (t5.title = e5), t5;
              });
            }(t3), o2 = e3("Choose heading"), i2 = e3("Heading");
            t3.ui.componentFactory.add("heading", (e4) => {
              const r2 = {}, s3 = new Di(), a2 = t3.commands.get("heading"), c2 = t3.commands.get("paragraph"), l2 = [a2];
              for (const t4 of n2) {
                const e5 = { type: "button", model: new Qm({ label: t4.title, class: t4.class, role: "menuitemradio", withText: true }) };
                "paragraph" === t4.model ? (e5.model.bind("isOn").to(c2, "value"), e5.model.set("commandName", "paragraph"), l2.push(c2)) : (e5.model.bind("isOn").to(a2, "value", (e6) => e6 === t4.model), e5.model.set({ commandName: "heading", commandValue: t4.model })), s3.add(e5), r2[t4.model] = t4.title;
              }
              const d2 = sp(e4);
              return lp(d2, s3, { ariaLabel: i2, role: "menu" }), d2.buttonView.set({ ariaLabel: i2, ariaLabelledBy: void 0, isOn: false, withText: true, tooltip: i2 }), d2.extendTemplate({ attributes: { class: ["ck-heading-dropdown"] } }), d2.bind("isEnabled").toMany(l2, "isEnabled", (...t4) => t4.some((t5) => t5)), d2.buttonView.bind("label").to(a2, "value", c2, "value", (t4, e5) => {
                const n3 = t4 || e5 && "paragraph";
                return "boolean" == typeof n3 ? o2 : r2[n3] ? r2[n3] : o2;
              }), this.listenTo(d2, "execute", (e5) => {
                const { commandName: n3, commandValue: o3 } = e5.source;
                t3.execute(n3, o3 ? { value: o3 } : void 0), t3.editing.view.focus();
              }), d2;
            });
          }
        }
        function gC(t3) {
          return t3.createContainerElement("figure", { class: "image" }, [t3.createEmptyElement("img"), t3.createSlot("children")]);
        }
        function pC(t3, e3) {
          const n2 = t3.plugins.get("ImageUtils"), o2 = t3.plugins.has("ImageInlineEditing") && t3.plugins.has("ImageBlockEditing");
          return (t4) => {
            if (!n2.isInlineImageView(t4))
              return null;
            if (!o2)
              return i2(t4);
            return ("block" == t4.getStyle("display") || t4.findAncestor(n2.isBlockImageView) ? "imageBlock" : "imageInline") !== e3 ? null : i2(t4);
          };
          function i2(t4) {
            const e4 = { name: true };
            return t4.hasAttribute("src") && (e4.attributes = ["src"]), e4;
          }
        }
        function mC(t3, e3) {
          const n2 = Ii(e3.getSelectedBlocks());
          return !n2 || t3.isObject(n2) || n2.isEmpty && "listItem" != n2.name ? "imageBlock" : "imageInline";
        }
        function fC(t3) {
          return t3 && t3.endsWith("px") ? parseInt(t3) : null;
        }
        function kC(t3) {
          const e3 = fC(t3.getStyle("width")), n2 = fC(t3.getStyle("height"));
          return !(!e3 || !n2);
        }
        var bC = Object.defineProperty, wC = Object.getOwnPropertySymbols, AC = Object.prototype.hasOwnProperty, CC = Object.prototype.propertyIsEnumerable, _C = (t3, e3, n2) => e3 in t3 ? bC(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, vC = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            AC.call(e3, n2) && _C(t3, n2, e3[n2]);
          if (wC)
            for (var n2 of wC(e3))
              CC.call(e3, n2) && _C(t3, n2, e3[n2]);
          return t3;
        };
        const yC = /^(image|image-inline)$/;
        class xC extends es {
          constructor() {
            super(...arguments), this._domEmitter = new (Mo())();
          }
          static get pluginName() {
            return "ImageUtils";
          }
          isImage(t3) {
            return this.isInlineImage(t3) || this.isBlockImage(t3);
          }
          isInlineImageView(t3) {
            return !!t3 && t3.is("element", "img");
          }
          isBlockImageView(t3) {
            return !!t3 && t3.is("element", "figure") && t3.hasClass("image");
          }
          insertImage(t3 = {}, e3 = null, n2 = null, o2 = {}) {
            const i2 = this.editor, r2 = i2.model, s3 = r2.document.selection, a2 = EC(i2, e3 || s3, n2);
            t3 = vC(vC({}, Object.fromEntries(s3.getAttributes())), t3);
            for (const e4 in t3)
              r2.schema.checkAttribute(a2, e4) || delete t3[e4];
            return r2.change((n3) => {
              const { setImageSizes: i3 = true } = o2, s4 = n3.createElement(a2, t3);
              return r2.insertObject(s4, e3, null, { setSelection: "on", findOptimalPosition: e3 || "imageInline" == a2 ? void 0 : "auto" }), s4.parent ? (i3 && this.setImageNaturalSizeAttributes(s4), s4) : null;
            });
          }
          setImageNaturalSizeAttributes(t3) {
            const e3 = t3.getAttribute("src");
            e3 && (t3.getAttribute("width") || t3.getAttribute("height") || this.editor.model.change((n2) => {
              const o2 = new zo.window.Image();
              this._domEmitter.listenTo(o2, "load", () => {
                t3.getAttribute("width") || t3.getAttribute("height") || this.editor.model.enqueueChange(n2.batch, (e4) => {
                  e4.setAttribute("width", o2.naturalWidth, t3), e4.setAttribute("height", o2.naturalHeight, t3);
                }), this._domEmitter.stopListening(o2, "load");
              }), o2.src = e3;
            }));
          }
          getClosestSelectedImageWidget(t3) {
            const e3 = t3.getFirstPosition();
            if (!e3)
              return null;
            const n2 = t3.getSelectedElement();
            if (n2 && this.isImageWidget(n2))
              return n2;
            let o2 = e3.parent;
            for (; o2; ) {
              if (o2.is("element") && this.isImageWidget(o2))
                return o2;
              o2 = o2.parent;
            }
            return null;
          }
          getClosestSelectedImageElement(t3) {
            const e3 = t3.getSelectedElement();
            return this.isImage(e3) ? e3 : t3.getFirstPosition().findAncestor("imageBlock");
          }
          getImageWidgetFromImageView(t3) {
            return t3.findAncestor({ classes: yC });
          }
          isImageAllowed() {
            const t3 = this.editor.model.document.selection;
            return function(t4, e3) {
              const n2 = EC(t4, e3, null);
              if ("imageBlock" == n2) {
                const n3 = function(t5, e4) {
                  const n4 = mb(t5, e4), o2 = n4.start.parent;
                  if (o2.isEmpty && !o2.is("element", "$root"))
                    return o2.parent;
                  return o2;
                }(e3, t4.model);
                if (t4.model.schema.checkChild(n3, "imageBlock"))
                  return true;
              } else if (t4.model.schema.checkChild(e3.focus, "imageInline"))
                return true;
              return false;
            }(this.editor, t3) && function(t4) {
              return [...t4.focus.getAncestors()].every((t5) => !t5.is("element", "imageBlock"));
            }(t3);
          }
          toImageWidget(t3, e3, n2) {
            e3.setCustomProperty("image", true, t3);
            return db(t3, e3, { label: () => {
              const e4 = this.findViewImgElement(t3).getAttribute("alt");
              return e4 ? `${e4} ${n2}` : n2;
            } });
          }
          isImageWidget(t3) {
            return !!t3.getCustomProperty("image") && lb(t3);
          }
          isBlockImage(t3) {
            return !!t3 && t3.is("element", "imageBlock");
          }
          isInlineImage(t3) {
            return !!t3 && t3.is("element", "imageInline");
          }
          findViewImgElement(t3) {
            if (this.isInlineImageView(t3))
              return t3;
            const e3 = this.editor.editing.view;
            for (const { item: n2 } of e3.createRangeIn(t3))
              if (this.isInlineImageView(n2))
                return n2;
          }
          destroy() {
            return this._domEmitter.stopListening(), super.destroy();
          }
        }
        function EC(t3, e3, n2) {
          const o2 = t3.model.schema, i2 = t3.config.get("image.insert.type");
          return t3.plugins.has("ImageBlockEditing") ? t3.plugins.has("ImageInlineEditing") ? n2 || ("inline" === i2 ? "imageInline" : "auto" !== i2 ? "imageBlock" : e3.is("selection") ? mC(o2, e3) : o2.checkChild(e3, "imageInline") ? "imageInline" : "imageBlock") : "imageBlock" : "imageInline";
        }
        Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        new RegExp(String(/^(http(s)?:\/\/)?[\w-]+\.[\w.~:/[\]@!$&'()*+,;=%-]+/.source + /\.(jpg|jpeg|png|gif|ico|webp|JPG|JPEG|PNG|GIF|ICO|WEBP)/.source + /(\?[\w.~:/[\]@!$&'()*+,;=%-]*)?/.source + /(#[\w.~:/[\]@!$&'()*+,;=%-]*)?$/.source));
        class DC extends os {
          refresh() {
            const t3 = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
            this.isEnabled = !!t3, this.isEnabled && t3.hasAttribute("alt") ? this.value = t3.getAttribute("alt") : this.value = false;
          }
          execute(t3) {
            const e3 = this.editor, n2 = e3.plugins.get("ImageUtils"), o2 = e3.model, i2 = n2.getClosestSelectedImageElement(o2.document.selection);
            o2.change((e4) => {
              e4.setAttribute("alt", t3.newValue, i2);
            });
          }
        }
        class IC extends es {
          static get requires() {
            return [xC];
          }
          static get pluginName() {
            return "ImageTextAlternativeEditing";
          }
          init() {
            this.editor.commands.add("imageTextAlternative", new DC(this.editor));
          }
        }
        var SC = n(1905), TC = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(SC.Z, TC);
        SC.Z.locals;
        var MC = n(6764), BC = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(MC.Z, BC);
        MC.Z.locals;
        class NC extends Ui {
          constructor(t3) {
            super(t3);
            const e3 = this.locale.t;
            this.focusTracker = new Si(), this.keystrokes = new Ti(), this.labeledInput = this._createLabeledInputView(), this.saveButtonView = this._createButton(e3("Save"), Rg.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(e3("Cancel"), Rg.cancel, "ck-button-cancel", "cancel"), this._focusables = new Li(), this._focusCycler = new qr({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this.setTemplate({ tag: "form", attributes: { class: ["ck", "ck-text-alternative-form", "ck-responsive-form"], tabindex: "-1" }, children: [this.labeledInput, this.saveButtonView, this.cancelButtonView] });
          }
          render() {
            super.render(), this.keystrokes.listenTo(this.element), i({ view: this }), [this.labeledInput, this.saveButtonView, this.cancelButtonView].forEach((t3) => {
              this._focusables.add(t3), this.focusTracker.add(t3.element);
            });
          }
          destroy() {
            super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
          _createButton(t3, e3, n2, o2) {
            const i2 = new br(this.locale);
            return i2.set({ label: t3, icon: e3, tooltip: true }), i2.extendTemplate({ attributes: { class: n2 } }), o2 && i2.delegate("execute").to(this, o2), i2;
          }
          _createLabeledInputView() {
            const t3 = this.locale.t, e3 = new Sr(this.locale, gp);
            return e3.label = t3("Text alternative"), e3;
          }
        }
        function PC(t3) {
          const e3 = t3.editing.view, n2 = am.defaultPositions, o2 = t3.plugins.get("ImageUtils");
          return { target: e3.domConverter.mapViewToDom(o2.getClosestSelectedImageWidget(e3.document.selection)), positions: [n2.northArrowSouth, n2.northArrowSouthWest, n2.northArrowSouthEast, n2.southArrowNorth, n2.southArrowNorthWest, n2.southArrowNorthEast, n2.viewportStickyNorth] };
        }
        class zC extends es {
          static get requires() {
            return [of];
          }
          static get pluginName() {
            return "ImageTextAlternativeUI";
          }
          init() {
            this._createButton();
          }
          destroy() {
            super.destroy(), this._form && this._form.destroy();
          }
          _createButton() {
            const t3 = this.editor, e3 = t3.t;
            t3.ui.componentFactory.add("imageTextAlternative", (n2) => {
              const o2 = t3.commands.get("imageTextAlternative"), i2 = new br(n2);
              return i2.set({ label: e3("Change image text alternative"), icon: Rg.textAlternative, tooltip: true }), i2.bind("isEnabled").to(o2, "isEnabled"), i2.bind("isOn").to(o2, "value", (t4) => !!t4), this.listenTo(i2, "execute", () => {
                this._showForm();
              }), i2;
            });
          }
          _createForm() {
            const n2 = this.editor, o2 = n2.editing.view.document, i2 = n2.plugins.get("ImageUtils");
            this._balloon = this.editor.plugins.get("ContextualBalloon"), this._form = new (e2(NC))(n2.locale), this._form.render(), this.listenTo(this._form, "submit", () => {
              n2.execute("imageTextAlternative", { newValue: this._form.labeledInput.fieldView.element.value }), this._hideForm(true);
            }), this.listenTo(this._form, "cancel", () => {
              this._hideForm(true);
            }), this._form.keystrokes.set("Esc", (t3, e3) => {
              this._hideForm(true), e3();
            }), this.listenTo(n2.ui, "update", () => {
              i2.getClosestSelectedImageWidget(o2.selection) ? this._isVisible && function(t3) {
                const e3 = t3.plugins.get("ContextualBalloon");
                if (t3.plugins.get("ImageUtils").getClosestSelectedImageWidget(t3.editing.view.document.selection)) {
                  const n3 = PC(t3);
                  e3.updatePosition(n3);
                }
              }(n2) : this._hideForm(true);
            }), t2({ emitter: this._form, activator: () => this._isVisible, contextElements: () => [this._balloon.view.element], callback: () => this._hideForm() });
          }
          _showForm() {
            if (this._isVisible)
              return;
            this._form || this._createForm();
            const t3 = this.editor, e3 = t3.commands.get("imageTextAlternative"), n2 = this._form.labeledInput;
            this._form.disableCssTransitions(), this._isInBalloon || this._balloon.add({ view: this._form, position: PC(t3) }), n2.fieldView.value = n2.fieldView.element.value = e3.value || "", this._form.labeledInput.fieldView.select(), this._form.enableCssTransitions();
          }
          _hideForm(t3 = false) {
            this._isInBalloon && (this._form.focusTracker.isFocused && this._form.saveButtonView.focus(), this._balloon.remove(this._form), t3 && this.editor.editing.view.focus());
          }
          get _isVisible() {
            return !!this._balloon && this._balloon.visibleView === this._form;
          }
          get _isInBalloon() {
            return !!this._balloon && this._balloon.hasView(this._form);
          }
        }
        class OC extends es {
          static get requires() {
            return [IC, zC];
          }
          static get pluginName() {
            return "ImageTextAlternative";
          }
        }
        function LC(t3, e3) {
          const n2 = (e4, n3, o2) => {
            if (!o2.consumable.consume(n3.item, e4.name))
              return;
            const i2 = o2.writer, r2 = o2.mapper.toViewElement(n3.item), s3 = t3.findViewImgElement(r2);
            null === n3.attributeNewValue ? (i2.removeAttribute("srcset", s3), i2.removeAttribute("sizes", s3)) : n3.attributeNewValue && (i2.setAttribute("srcset", n3.attributeNewValue, s3), i2.setAttribute("sizes", "100vw", s3));
          };
          return (t4) => {
            t4.on(`attribute:srcset:${e3}`, n2);
          };
        }
        function RC(t3, e3, n2) {
          const o2 = (e4, n3, o3) => {
            if (!o3.consumable.consume(n3.item, e4.name))
              return;
            const i2 = o3.writer, r2 = o3.mapper.toViewElement(n3.item), s3 = t3.findViewImgElement(r2);
            i2.setAttribute(n3.attributeKey, n3.attributeNewValue || "", s3);
          };
          return (t4) => {
            t4.on(`attribute:${n2}:${e3}`, o2);
          };
        }
        class jC extends Fc {
          observe(t3) {
            this.listenTo(t3, "load", (t4, e3) => {
              const n2 = e3.target;
              this.checkShouldIgnoreEventFromTarget(n2) || "IMG" == n2.tagName && this._fireEvents(e3);
            }, { useCapture: true });
          }
          stopObserving(t3) {
            this.stopListening(t3);
          }
          _fireEvents(t3) {
            this.isEnabled && (this.document.fire("layoutChanged"), this.document.fire("imageLoaded", t3));
          }
        }
        var FC = Object.defineProperty, VC = Object.getOwnPropertySymbols, UC = Object.prototype.hasOwnProperty, HC = Object.prototype.propertyIsEnumerable, qC = (t3, e3, n2) => e3 in t3 ? FC(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, GC = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            UC.call(e3, n2) && qC(t3, n2, e3[n2]);
          if (VC)
            for (var n2 of VC(e3))
              HC.call(e3, n2) && qC(t3, n2, e3[n2]);
          return t3;
        };
        class WC extends os {
          constructor(t3) {
            super(t3);
            const e3 = t3.config.get("image.insert.type");
            t3.plugins.has("ImageBlockEditing") || "block" === e3 && C("image-block-plugin-required"), t3.plugins.has("ImageInlineEditing") || "inline" === e3 && C("image-inline-plugin-required");
          }
          refresh() {
            const t3 = this.editor.plugins.get("ImageUtils");
            this.isEnabled = t3.isImageAllowed();
          }
          execute(t3) {
            const e3 = _i(t3.source), n2 = this.editor.model.document.selection, o2 = this.editor.plugins.get("ImageUtils"), i2 = Object.fromEntries(n2.getAttributes());
            e3.forEach((t4, e4) => {
              const r2 = n2.getSelectedElement();
              if ("string" == typeof t4 && (t4 = { src: t4 }), e4 && r2 && o2.isImage(r2)) {
                const e5 = this.editor.model.createPositionAfter(r2);
                o2.insertImage(GC(GC({}, t4), i2), e5);
              } else
                o2.insertImage(GC(GC({}, t4), i2));
            });
          }
        }
        class KC extends os {
          constructor(t3) {
            super(t3), this.decorate("cleanupImage");
          }
          refresh() {
            const t3 = this.editor.plugins.get("ImageUtils"), e3 = this.editor.model.document.selection.getSelectedElement();
            this.isEnabled = t3.isImage(e3), this.value = this.isEnabled ? e3.getAttribute("src") : null;
          }
          execute(t3) {
            const e3 = this.editor.model.document.selection.getSelectedElement(), n2 = this.editor.plugins.get("ImageUtils");
            this.editor.model.change((o2) => {
              o2.setAttribute("src", t3.source, e3), this.cleanupImage(o2, e3), n2.setImageNaturalSizeAttributes(e3);
            });
          }
          cleanupImage(t3, e3) {
            t3.removeAttribute("srcset", e3), t3.removeAttribute("sizes", e3), t3.removeAttribute("sources", e3), t3.removeAttribute("width", e3), t3.removeAttribute("height", e3), t3.removeAttribute("alt", e3);
          }
        }
        class ZC extends es {
          static get requires() {
            return [xC];
          }
          static get pluginName() {
            return "ImageEditing";
          }
          init() {
            const t3 = this.editor, e3 = t3.conversion;
            t3.editing.view.addObserver(jC), e3.for("upcast").attributeToAttribute({ view: { name: "img", key: "alt" }, model: "alt" }).attributeToAttribute({ view: { name: "img", key: "srcset" }, model: "srcset" });
            const n2 = new WC(t3), o2 = new KC(t3);
            t3.commands.add("insertImage", n2), t3.commands.add("replaceImageSource", o2), t3.commands.add("imageInsert", n2);
          }
        }
        class YC extends es {
          static get requires() {
            return [xC];
          }
          static get pluginName() {
            return "ImageSizeAttributes";
          }
          afterInit() {
            this._registerSchema(), this._registerConverters("imageBlock"), this._registerConverters("imageInline");
          }
          _registerSchema() {
            this.editor.plugins.has("ImageBlockEditing") && this.editor.model.schema.extend("imageBlock", { allowAttributes: ["width", "height"] }), this.editor.plugins.has("ImageInlineEditing") && this.editor.model.schema.extend("imageInline", { allowAttributes: ["width", "height"] });
          }
          _registerConverters(t3) {
            const e3 = this.editor, n2 = e3.plugins.get("ImageUtils"), o2 = "imageBlock" === t3 ? "figure" : "img";
            function i2(e4, o3, i3, r2) {
              e4.on(`attribute:${o3}:${t3}`, (e5, o4, s3) => {
                if (!s3.consumable.consume(o4.item, e5.name))
                  return;
                const a2 = s3.writer, c2 = s3.mapper.toViewElement(o4.item), l2 = n2.findViewImgElement(c2);
                if (null !== o4.attributeNewValue ? a2.setAttribute(i3, o4.attributeNewValue, l2) : a2.removeAttribute(i3, l2), o4.item.hasAttribute("sources"))
                  return;
                const d2 = o4.item.hasAttribute("resizedWidth");
                if ("imageInline" === t3 && !d2 && !r2)
                  return;
                const h2 = o4.item.getAttribute("width"), u2 = o4.item.getAttribute("height");
                h2 && u2 && a2.setStyle("aspect-ratio", `${h2}/${u2}`, l2);
              });
            }
            e3.conversion.for("upcast").attributeToAttribute({ view: { name: o2, styles: { width: /.+/ } }, model: { key: "width", value: (t4) => kC(t4) ? fC(t4.getStyle("width")) : null } }).attributeToAttribute({ view: { name: o2, key: "width" }, model: "width" }).attributeToAttribute({ view: { name: o2, styles: { height: /.+/ } }, model: { key: "height", value: (t4) => kC(t4) ? fC(t4.getStyle("height")) : null } }).attributeToAttribute({ view: { name: o2, key: "height" }, model: "height" }), e3.conversion.for("editingDowncast").add((t4) => {
              i2(t4, "width", "width", true), i2(t4, "height", "height", true);
            }), e3.conversion.for("dataDowncast").add((t4) => {
              i2(t4, "width", "width", false), i2(t4, "height", "height", false);
            });
          }
        }
        class $C extends os {
          constructor(t3, e3) {
            super(t3), this._modelElementName = e3;
          }
          refresh() {
            const t3 = this.editor.plugins.get("ImageUtils"), e3 = t3.getClosestSelectedImageElement(this.editor.model.document.selection);
            "imageBlock" === this._modelElementName ? this.isEnabled = t3.isInlineImage(e3) : this.isEnabled = t3.isBlockImage(e3);
          }
          execute(t3 = {}) {
            const e3 = this.editor, n2 = this.editor.model, o2 = e3.plugins.get("ImageUtils"), i2 = o2.getClosestSelectedImageElement(n2.document.selection), r2 = Object.fromEntries(i2.getAttributes());
            return r2.src || r2.uploadId ? n2.change((e4) => {
              const { setImageSizes: s3 = true } = t3, a2 = Array.from(n2.markers).filter((t4) => t4.getRange().containsItem(i2)), c2 = o2.insertImage(r2, n2.createSelection(i2, "on"), this._modelElementName, { setImageSizes: s3 });
              if (!c2)
                return null;
              const l2 = e4.createRangeOn(c2);
              for (const t4 of a2) {
                const n3 = t4.getRange(), o3 = "$graveyard" != n3.root.rootName ? n3.getJoined(l2, true) : l2;
                e4.updateMarker(t4, { range: o3 });
              }
              return { oldElement: i2, newElement: c2 };
            }) : null;
          }
        }
        var QC = n(2873), JC = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(QC.Z, JC);
        QC.Z.locals;
        class XC extends es {
          static get requires() {
            return [xC];
          }
          static get pluginName() {
            return "ImagePlaceholder";
          }
          afterInit() {
            this._setupSchema(), this._setupConversion(), this._setupLoadListener();
          }
          _setupSchema() {
            const t3 = this.editor.model.schema;
            t3.isRegistered("imageBlock") && t3.extend("imageBlock", { allowAttributes: ["placeholder"] }), t3.isRegistered("imageInline") && t3.extend("imageInline", { allowAttributes: ["placeholder"] });
          }
          _setupConversion() {
            const t3 = this.editor, e3 = t3.conversion, n2 = t3.plugins.get("ImageUtils");
            e3.for("editingDowncast").add((t4) => {
              t4.on("attribute:placeholder", (t5, e4, o2) => {
                if (!o2.consumable.test(e4.item, t5.name))
                  return;
                if (!e4.item.is("element", "imageBlock") && !e4.item.is("element", "imageInline"))
                  return;
                o2.consumable.consume(e4.item, t5.name);
                const i2 = o2.writer, r2 = o2.mapper.toViewElement(e4.item), s3 = n2.findViewImgElement(r2);
                e4.attributeNewValue ? (i2.addClass("image_placeholder", s3), i2.setStyle("background-image", `url(${e4.attributeNewValue})`, s3), i2.setCustomProperty("editingPipeline:doNotReuseOnce", true, s3)) : (i2.removeClass("image_placeholder", s3), i2.removeStyle("background-image", s3));
              });
            });
          }
          _setupLoadListener() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.editing, o2 = n2.view, i2 = t3.plugins.get("ImageUtils");
            o2.addObserver(jC), this.listenTo(o2.document, "imageLoaded", (t4, r2) => {
              const s3 = o2.domConverter.mapDomToView(r2.target);
              if (!s3)
                return;
              const a2 = i2.getImageWidgetFromImageView(s3);
              if (!a2)
                return;
              const c2 = n2.mapper.toModelElement(a2);
              c2 && c2.hasAttribute("placeholder") && e3.enqueueChange({ isUndoable: false }, (t5) => {
                t5.removeAttribute("placeholder", c2);
              });
            });
          }
        }
        class t_ extends es {
          static get requires() {
            return [ZC, YC, xC, XC, uk];
          }
          static get pluginName() {
            return "ImageBlockEditing";
          }
          init() {
            const t3 = this.editor;
            t3.model.schema.register("imageBlock", { inheritAllFrom: "$blockObject", allowAttributes: ["alt", "src", "srcset"] }), this._setupConversion(), t3.plugins.has("ImageInlineEditing") && (t3.commands.add("imageTypeBlock", new $C(this.editor, "imageBlock")), this._setupClipboardIntegration());
          }
          _setupConversion() {
            const t3 = this.editor, e3 = t3.t, n2 = t3.conversion, o2 = t3.plugins.get("ImageUtils");
            n2.for("dataDowncast").elementToStructure({ model: "imageBlock", view: (t4, { writer: e4 }) => gC(e4) }), n2.for("editingDowncast").elementToStructure({ model: "imageBlock", view: (t4, { writer: n3 }) => o2.toImageWidget(gC(n3), n3, e3("image widget")) }), n2.for("downcast").add(RC(o2, "imageBlock", "src")).add(RC(o2, "imageBlock", "alt")).add(LC(o2, "imageBlock")), n2.for("upcast").elementToElement({ view: pC(t3, "imageBlock"), model: (t4, { writer: e4 }) => e4.createElement("imageBlock", t4.hasAttribute("src") ? { src: t4.getAttribute("src") } : void 0) }).add(function(t4) {
              const e4 = (e5, n3, o3) => {
                if (!o3.consumable.test(n3.viewItem, { name: true, classes: "image" }))
                  return;
                const i2 = t4.findViewImgElement(n3.viewItem);
                if (!i2 || !o3.consumable.test(i2, { name: true }))
                  return;
                o3.consumable.consume(n3.viewItem, { name: true, classes: "image" });
                const r2 = Ii(o3.convertItem(i2, n3.modelCursor).modelRange.getItems());
                r2 ? (o3.convertChildren(n3.viewItem, r2), o3.updateConversionResult(r2, n3)) : o3.consumable.revert(n3.viewItem, { name: true, classes: "image" });
              };
              return (t5) => {
                t5.on("element:figure", e4);
              };
            }(o2));
          }
          _setupClipboardIntegration() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.editing.view, o2 = t3.plugins.get("ImageUtils"), i2 = t3.plugins.get("ClipboardPipeline");
            this.listenTo(i2, "inputTransformation", (i3, r2) => {
              const s3 = Array.from(r2.content.getChildren());
              let a2;
              if (!s3.every(o2.isInlineImageView))
                return;
              a2 = r2.targetRanges ? t3.editing.mapper.toModelRange(r2.targetRanges[0]) : e3.document.selection.getFirstRange();
              const c2 = e3.createSelection(a2);
              if ("imageBlock" === mC(e3.schema, c2)) {
                const t4 = new Bg(n2.document), e4 = s3.map((e5) => t4.createElement("figure", { class: "image" }, e5));
                r2.content = t4.createDocumentFragment(e4);
              }
            }), this.listenTo(i2, "contentInsertion", (t4, n3) => {
              "paste" === n3.method && e3.change((t5) => {
                const e4 = t5.createRangeIn(n3.content);
                for (const t6 of e4.getItems())
                  t6.is("element", "imageBlock") && o2.setImageNaturalSizeAttributes(t6);
              });
            });
          }
        }
        var e_ = n(3535), n_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(e_.Z, n_);
        e_.Z.locals;
        class o_ extends Ui {
          constructor(t3, e3 = []) {
            super(t3), this.focusTracker = new Si(), this.keystrokes = new Ti(), this._focusables = new Li(), this.children = this.createCollection(), this._focusCycler = new qr({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } });
            for (const t4 of e3)
              this.children.add(t4), this._focusables.add(t4), t4 instanceof Nf && this._focusables.addMany(t4.children);
            if (this._focusables.length > 1)
              for (const t4 of this._focusables)
                i_(t4) && (t4.focusCycler.on("forwardCycle", (t5) => {
                  this._focusCycler.focusNext(), t5.stop();
                }), t4.focusCycler.on("backwardCycle", (t5) => {
                  this._focusCycler.focusPrevious(), t5.stop();
                }));
            this.setTemplate({ tag: "form", attributes: { class: ["ck", "ck-image-insert-form"], tabindex: -1 }, children: this.children });
          }
          render() {
            super.render(), i({ view: this });
            for (const t4 of this._focusables)
              this.focusTracker.add(t4.element);
            this.keystrokes.listenTo(this.element);
            const t3 = (t4) => t4.stopPropagation();
            this.keystrokes.set("arrowright", t3), this.keystrokes.set("arrowleft", t3), this.keystrokes.set("arrowup", t3), this.keystrokes.set("arrowdown", t3);
          }
          destroy() {
            super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
          focus() {
            this._focusCycler.focusFirst();
          }
        }
        function i_(t3) {
          return "focusCycler" in t3;
        }
        class r_ extends es {
          constructor(t3) {
            super(t3), this._integrations = /* @__PURE__ */ new Map(), t3.config.define("image.insert.integrations", ["upload", "assetManager", "url"]);
          }
          static get pluginName() {
            return "ImageInsertUI";
          }
          static get requires() {
            return [xC];
          }
          init() {
            const t3 = this.editor, e3 = t3.model.document.selection, n2 = t3.plugins.get("ImageUtils");
            this.set("isImageSelected", false), this.listenTo(t3.model.document, "change", () => {
              this.isImageSelected = n2.isImage(e3.getSelectedElement());
            });
            const o2 = (t4) => this._createToolbarComponent(t4);
            t3.ui.componentFactory.add("insertImage", o2), t3.ui.componentFactory.add("imageInsert", o2);
          }
          registerIntegration({ name: t3, observable: e3, buttonViewCreator: n2, formViewCreator: o2, requiresForm: i2 }) {
            this._integrations.has(t3) && C("image-insert-integration-exists", { name: t3 }), this._integrations.set(t3, { observable: e3, buttonViewCreator: n2, formViewCreator: o2, requiresForm: !!i2 });
          }
          _createToolbarComponent(t3) {
            const e3 = this.editor, n2 = t3.t, o2 = this._prepareIntegrations();
            if (!o2.length)
              return null;
            let i2;
            const r2 = o2[0];
            if (1 == o2.length) {
              if (!r2.requiresForm)
                return r2.buttonViewCreator(true);
              i2 = r2.buttonViewCreator(true);
            } else {
              const e4 = r2.buttonViewCreator(false);
              i2 = new ep(t3, e4), i2.tooltip = true, i2.bind("label").to(this, "isImageSelected", (t4) => n2(t4 ? "Replace image" : "Insert image"));
            }
            const s3 = this.dropdownView = sp(t3, i2), a2 = o2.map(({ observable: t4 }) => t4);
            return s3.bind("isEnabled").toMany(a2, "isEnabled", (...t4) => t4.some((t5) => t5)), s3.once("change:isOpen", () => {
              const t4 = o2.map(({ formViewCreator: t5 }) => t5(1 == o2.length)), n3 = new o_(e3.locale, t4);
              s3.panelView.children.add(n3);
            }), s3;
          }
          _prepareIntegrations() {
            const t3 = this.editor.config.get("image.insert.integrations"), e3 = [];
            if (!t3.length)
              return C("image-insert-integrations-not-specified"), e3;
            for (const n2 of t3)
              this._integrations.has(n2) ? e3.push(this._integrations.get(n2)) : ["upload", "assetManager", "url"].includes(n2) || C("image-insert-unknown-integration", { item: n2 });
            return e3.length || C("image-insert-integrations-not-registered"), e3;
          }
        }
        var s_ = n(3508), a_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(s_.Z, a_);
        s_.Z.locals;
        class c_ extends es {
          static get requires() {
            return [t_, Mb, OC, r_];
          }
          static get pluginName() {
            return "ImageBlock";
          }
        }
        class l_ extends es {
          static get requires() {
            return [ZC, YC, xC, XC, uk];
          }
          static get pluginName() {
            return "ImageInlineEditing";
          }
          init() {
            const t3 = this.editor, e3 = t3.model.schema;
            e3.register("imageInline", { inheritAllFrom: "$inlineObject", allowAttributes: ["alt", "src", "srcset"] }), e3.addChildCheck((t4, e4) => {
              if (t4.endsWith("caption") && "imageInline" === e4.name)
                return false;
            }), this._setupConversion(), t3.plugins.has("ImageBlockEditing") && (t3.commands.add("imageTypeInline", new $C(this.editor, "imageInline")), this._setupClipboardIntegration());
          }
          _setupConversion() {
            const t3 = this.editor, e3 = t3.t, n2 = t3.conversion, o2 = t3.plugins.get("ImageUtils");
            n2.for("dataDowncast").elementToElement({ model: "imageInline", view: (t4, { writer: e4 }) => e4.createEmptyElement("img") }), n2.for("editingDowncast").elementToStructure({ model: "imageInline", view: (t4, { writer: n3 }) => o2.toImageWidget(function(t5) {
              return t5.createContainerElement("span", { class: "image-inline" }, t5.createEmptyElement("img"));
            }(n3), n3, e3("image widget")) }), n2.for("downcast").add(RC(o2, "imageInline", "src")).add(RC(o2, "imageInline", "alt")).add(LC(o2, "imageInline")), n2.for("upcast").elementToElement({ view: pC(t3, "imageInline"), model: (t4, { writer: e4 }) => e4.createElement("imageInline", t4.hasAttribute("src") ? { src: t4.getAttribute("src") } : void 0) });
          }
          _setupClipboardIntegration() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.editing.view, o2 = t3.plugins.get("ImageUtils"), i2 = t3.plugins.get("ClipboardPipeline");
            this.listenTo(i2, "inputTransformation", (i3, r2) => {
              const s3 = Array.from(r2.content.getChildren());
              let a2;
              if (!s3.every(o2.isBlockImageView))
                return;
              a2 = r2.targetRanges ? t3.editing.mapper.toModelRange(r2.targetRanges[0]) : e3.document.selection.getFirstRange();
              const c2 = e3.createSelection(a2);
              if ("imageInline" === mC(e3.schema, c2)) {
                const t4 = new Bg(n2.document), e4 = s3.map((e5) => 1 === e5.childCount ? (Array.from(e5.getAttributes()).forEach((n3) => t4.setAttribute(...n3, o2.findViewImgElement(e5))), e5.getChild(0)) : e5);
                r2.content = t4.createDocumentFragment(e4);
              }
            }), this.listenTo(i2, "contentInsertion", (t4, n3) => {
              "paste" === n3.method && e3.change((t5) => {
                const e4 = t5.createRangeIn(n3.content);
                for (const t6 of e4.getItems())
                  t6.is("element", "imageInline") && o2.setImageNaturalSizeAttributes(t6);
              });
            });
          }
        }
        class d_ extends es {
          static get requires() {
            return [l_, Mb, OC, r_];
          }
          static get pluginName() {
            return "ImageInline";
          }
        }
        class h_ extends es {
          static get pluginName() {
            return "ImageCaptionUtils";
          }
          static get requires() {
            return [xC];
          }
          getCaptionFromImageModelElement(t3) {
            for (const e3 of t3.getChildren())
              if (e3 && e3.is("element", "caption"))
                return e3;
            return null;
          }
          getCaptionFromModelSelection(t3) {
            const e3 = this.editor.plugins.get("ImageUtils"), n2 = t3.getFirstPosition().findAncestor("caption");
            return n2 && e3.isBlockImage(n2.parent) ? n2 : null;
          }
          matchImageCaptionViewElement(t3) {
            const e3 = this.editor.plugins.get("ImageUtils");
            return "figcaption" == t3.name && e3.isBlockImageView(t3.parent) ? { name: true } : null;
          }
        }
        class u_ extends os {
          refresh() {
            const t3 = this.editor, e3 = t3.plugins.get("ImageCaptionUtils"), n2 = t3.plugins.get("ImageUtils");
            if (!t3.plugins.has(t_))
              return this.isEnabled = false, void (this.value = false);
            const o2 = t3.model.document.selection, i2 = o2.getSelectedElement();
            if (!i2) {
              const t4 = e3.getCaptionFromModelSelection(o2);
              return this.isEnabled = !!t4, void (this.value = !!t4);
            }
            this.isEnabled = n2.isImage(i2), this.isEnabled ? this.value = !!e3.getCaptionFromImageModelElement(i2) : this.value = false;
          }
          execute(t3 = {}) {
            const { focusCaptionOnShow: e3 } = t3;
            this.editor.model.change((t4) => {
              this.value ? this._hideImageCaption(t4) : this._showImageCaption(t4, e3);
            });
          }
          _showImageCaption(t3, e3) {
            const n2 = this.editor.model.document.selection, o2 = this.editor.plugins.get("ImageCaptionEditing"), i2 = this.editor.plugins.get("ImageUtils");
            let r2 = n2.getSelectedElement();
            const s3 = o2._getSavedCaption(r2);
            i2.isInlineImage(r2) && (this.editor.execute("imageTypeBlock"), r2 = n2.getSelectedElement());
            const a2 = s3 || t3.createElement("caption");
            t3.append(a2, r2), e3 && t3.setSelection(a2, "in");
          }
          _hideImageCaption(t3) {
            const e3 = this.editor, n2 = e3.model.document.selection, o2 = e3.plugins.get("ImageCaptionEditing"), i2 = e3.plugins.get("ImageCaptionUtils");
            let r2, s3 = n2.getSelectedElement();
            s3 ? r2 = i2.getCaptionFromImageModelElement(s3) : (r2 = i2.getCaptionFromModelSelection(n2), s3 = r2.parent), o2._saveCaption(s3, r2), t3.setSelection(s3, "on"), t3.remove(r2);
          }
        }
        class g_ extends es {
          constructor(t3) {
            super(t3), this._savedCaptionsMap = /* @__PURE__ */ new WeakMap();
          }
          static get requires() {
            return [xC, h_];
          }
          static get pluginName() {
            return "ImageCaptionEditing";
          }
          init() {
            const t3 = this.editor, e3 = t3.model.schema;
            e3.isRegistered("caption") ? e3.extend("caption", { allowIn: "imageBlock" }) : e3.register("caption", { allowIn: "imageBlock", allowContentOf: "$block", isLimit: true }), t3.commands.add("toggleImageCaption", new u_(this.editor)), this._setupConversion(), this._setupImageTypeCommandsIntegration(), this._registerCaptionReconversion();
          }
          _setupConversion() {
            const t3 = this.editor, e3 = t3.editing.view, n2 = t3.plugins.get("ImageUtils"), o2 = t3.plugins.get("ImageCaptionUtils"), i2 = t3.t;
            t3.conversion.for("upcast").elementToElement({ view: (t4) => o2.matchImageCaptionViewElement(t4), model: "caption" }), t3.conversion.for("dataDowncast").elementToElement({ model: "caption", view: (t4, { writer: e4 }) => n2.isBlockImage(t4.parent) ? e4.createContainerElement("figcaption") : null }), t3.conversion.for("editingDowncast").elementToElement({ model: "caption", view: (t4, { writer: o3 }) => {
              if (!n2.isBlockImage(t4.parent))
                return null;
              const r2 = o3.createEditableElement("figcaption");
              o3.setCustomProperty("imageCaption", true, r2), r2.placeholder = i2("Enter image caption"), ps({ view: e3, element: r2, keepOnFocus: true });
              const s3 = t4.parent.getAttribute("alt");
              return pb(r2, o3, { label: s3 ? i2("Caption for image: %0", [s3]) : i2("Caption for the image") });
            } });
          }
          _setupImageTypeCommandsIntegration() {
            const t3 = this.editor, e3 = t3.plugins.get("ImageUtils"), n2 = t3.plugins.get("ImageCaptionUtils"), o2 = t3.commands.get("imageTypeInline"), i2 = t3.commands.get("imageTypeBlock"), r2 = (t4) => {
              if (!t4.return)
                return;
              const { oldElement: o3, newElement: i3 } = t4.return;
              if (!o3)
                return;
              if (e3.isBlockImage(o3)) {
                const t5 = n2.getCaptionFromImageModelElement(o3);
                if (t5)
                  return void this._saveCaption(i3, t5);
              }
              const r3 = this._getSavedCaption(o3);
              r3 && this._saveCaption(i3, r3);
            };
            o2 && this.listenTo(o2, "execute", r2, { priority: "low" }), i2 && this.listenTo(i2, "execute", r2, { priority: "low" });
          }
          _getSavedCaption(t3) {
            const e3 = this._savedCaptionsMap.get(t3);
            return e3 ? Hl.fromJSON(e3) : null;
          }
          _saveCaption(t3, e3) {
            this._savedCaptionsMap.set(t3, e3.toJSON());
          }
          _registerCaptionReconversion() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.plugins.get("ImageUtils"), o2 = t3.plugins.get("ImageCaptionUtils");
            e3.document.on("change:data", () => {
              const i2 = e3.document.differ.getChanges();
              for (const e4 of i2) {
                if ("alt" !== e4.attributeKey)
                  continue;
                const i3 = e4.range.start.nodeAfter;
                if (n2.isBlockImage(i3)) {
                  const e5 = o2.getCaptionFromImageModelElement(i3);
                  if (!e5)
                    return;
                  t3.editing.reconvertItem(e5);
                }
              }
            });
          }
        }
        class p_ extends es {
          static get requires() {
            return [h_];
          }
          static get pluginName() {
            return "ImageCaptionUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.editing.view, n2 = t3.plugins.get("ImageCaptionUtils"), o2 = t3.t;
            t3.ui.componentFactory.add("toggleImageCaption", (i2) => {
              const r2 = t3.commands.get("toggleImageCaption"), s3 = new br(i2);
              return s3.set({ icon: Rg.caption, tooltip: true, isToggleable: true }), s3.bind("isOn", "isEnabled").to(r2, "value", "isEnabled"), s3.bind("label").to(r2, "value", (t4) => o2(t4 ? "Toggle caption off" : "Toggle caption on")), this.listenTo(s3, "execute", () => {
                t3.execute("toggleImageCaption", { focusCaptionOnShow: true });
                const o3 = n2.getCaptionFromModelSelection(t3.model.document.selection);
                if (o3) {
                  const n3 = t3.editing.mapper.toViewElement(o3);
                  e3.scrollToTheSelection(), e3.change((t4) => {
                    t4.addClass("image__caption_highlighted", n3);
                  });
                }
                t3.editing.view.focus();
              }), s3;
            });
          }
        }
        var m_ = n(2640), f_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(m_.Z, f_);
        m_.Z.locals;
        function k_(t3) {
          const e3 = t3.map((t4) => t4.replace("+", "\\+"));
          return new RegExp(`^image\\/(${e3.join("|")})$`);
        }
        function b_(t3) {
          return new Promise((e3, n2) => {
            const o2 = t3.getAttribute("src");
            fetch(o2).then((t4) => t4.blob()).then((t4) => {
              const n3 = w_(t4, o2), i2 = n3.replace("image/", ""), r2 = new File([t4], `image.${i2}`, { type: n3 });
              e3(r2);
            }).catch((t4) => t4 && "TypeError" === t4.name ? function(t5) {
              return function(t6) {
                return new Promise((e4, n3) => {
                  const o3 = zo.document.createElement("img");
                  o3.addEventListener("load", () => {
                    const t7 = zo.document.createElement("canvas");
                    t7.width = o3.width, t7.height = o3.height;
                    t7.getContext("2d").drawImage(o3, 0, 0), t7.toBlob((t8) => t8 ? e4(t8) : n3());
                  }), o3.addEventListener("error", () => n3()), o3.src = t6;
                });
              }(t5).then((e4) => {
                const n3 = w_(e4, t5), o3 = n3.replace("image/", "");
                return new File([e4], `image.${o3}`, { type: n3 });
              });
            }(o2).then(e3).catch(n2) : n2(t4));
          });
        }
        function w_(t3, e3) {
          return t3.type ? t3.type : e3.match(/data:(image\/\w+);base64/) ? e3.match(/data:(image\/\w+);base64/)[1].toLowerCase() : "image/jpeg";
        }
        class A_ extends es {
          static get pluginName() {
            return "ImageUploadUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.t, n2 = (n3) => {
              const o2 = new Bw(n3), i2 = t3.commands.get("uploadImage"), r2 = t3.config.get("image.upload.types"), s3 = k_(r2);
              return o2.set({ acceptedType: r2.map((t4) => `image/${t4}`).join(","), allowMultipleFiles: true, label: e3("Upload image from computer"), icon: Rg.imageUpload, tooltip: true }), o2.bind("isEnabled").to(i2), o2.on("done", (e4, n4) => {
                const o3 = Array.from(n4).filter((t4) => s3.test(t4.type));
                o3.length && (t3.execute("uploadImage", { file: o3 }), t3.editing.view.focus());
              }), o2;
            };
            if (t3.ui.componentFactory.add("uploadImage", n2), t3.ui.componentFactory.add("imageUpload", n2), t3.plugins.has("ImageInsertUI")) {
              const n3 = t3.plugins.get("ImageInsertUI"), o2 = t3.commands.get("uploadImage");
              n3.registerIntegration({ name: "upload", observable: o2, buttonViewCreator: () => {
                const o3 = t3.ui.componentFactory.create("uploadImage");
                return o3.bind("label").to(n3, "isImageSelected", (t4) => e3(t4 ? "Replace image from computer" : "Upload image from computer")), o3;
              }, formViewCreator: () => {
                const o3 = t3.ui.componentFactory.create("uploadImage");
                return o3.withText = true, o3.bind("label").to(n3, "isImageSelected", (t4) => e3(t4 ? "Replace from computer" : "Upload from computer")), o3.on("execute", () => {
                  n3.dropdownView.isOpen = false;
                }), o3;
              } });
            }
          }
        }
        var C_ = n(3689), __ = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(C_.Z, __);
        C_.Z.locals;
        var v_ = n(4036), y_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(v_.Z, y_);
        v_.Z.locals;
        var x_ = n(3773), E_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(x_.Z, E_);
        x_.Z.locals;
        class D_ extends es {
          constructor(t3) {
            super(t3), this.uploadStatusChange = (t4, e3, n2) => {
              const o2 = this.editor, i2 = e3.item, r2 = i2.getAttribute("uploadId");
              if (!n2.consumable.consume(e3.item, t4.name))
                return;
              const s3 = o2.plugins.get("ImageUtils"), a2 = o2.plugins.get(Tw), c2 = r2 ? e3.attributeNewValue : null, l2 = this.placeholder, d2 = o2.editing.mapper.toViewElement(i2), h2 = n2.writer;
              if ("reading" == c2)
                return I_(d2, h2), void S_(s3, l2, d2, h2);
              if ("uploading" == c2) {
                const t5 = a2.loaders.get(r2);
                return I_(d2, h2), void (t5 ? (T_(d2, h2), function(t6, e4, n3, o3) {
                  const i3 = function(t7) {
                    const e5 = t7.createUIElement("div", { class: "ck-progress-bar" });
                    return t7.setCustomProperty("progressBar", true, e5), e5;
                  }(e4);
                  e4.insert(e4.createPositionAt(t6, "end"), i3), n3.on("change:uploadedPercent", (t7, e5, n4) => {
                    o3.change((t8) => {
                      t8.setStyle("width", n4 + "%", i3);
                    });
                  });
                }(d2, h2, t5, o2.editing.view), function(t6, e4, n3, o3) {
                  if (o3.data) {
                    const i3 = t6.findViewImgElement(e4);
                    n3.setAttribute("src", o3.data, i3);
                  }
                }(s3, d2, h2, t5)) : S_(s3, l2, d2, h2));
              }
              "complete" == c2 && a2.loaders.get(r2) && function(t5, e4, n3) {
                const o3 = e4.createUIElement("div", { class: "ck-image-upload-complete-icon" });
                e4.insert(e4.createPositionAt(t5, "end"), o3), setTimeout(() => {
                  n3.change((t6) => t6.remove(t6.createRangeOn(o3)));
                }, 3e3);
              }(d2, h2, o2.editing.view), function(t5, e4) {
                B_(t5, e4, "progressBar");
              }(d2, h2), T_(d2, h2), function(t5, e4) {
                e4.removeClass("ck-appear", t5);
              }(d2, h2);
            }, this.placeholder = "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";
          }
          static get pluginName() {
            return "ImageUploadProgress";
          }
          init() {
            const t3 = this.editor;
            t3.plugins.has("ImageBlockEditing") && t3.editing.downcastDispatcher.on("attribute:uploadStatus:imageBlock", this.uploadStatusChange), t3.plugins.has("ImageInlineEditing") && t3.editing.downcastDispatcher.on("attribute:uploadStatus:imageInline", this.uploadStatusChange);
          }
        }
        function I_(t3, e3) {
          t3.hasClass("ck-appear") || e3.addClass("ck-appear", t3);
        }
        function S_(t3, e3, n2, o2) {
          n2.hasClass("ck-image-upload-placeholder") || o2.addClass("ck-image-upload-placeholder", n2);
          const i2 = t3.findViewImgElement(n2);
          i2.getAttribute("src") !== e3 && o2.setAttribute("src", e3, i2), M_(n2, "placeholder") || o2.insert(o2.createPositionAfter(i2), function(t4) {
            const e4 = t4.createUIElement("div", { class: "ck-upload-placeholder-loader" });
            return t4.setCustomProperty("placeholder", true, e4), e4;
          }(o2));
        }
        function T_(t3, e3) {
          t3.hasClass("ck-image-upload-placeholder") && e3.removeClass("ck-image-upload-placeholder", t3), B_(t3, e3, "placeholder");
        }
        function M_(t3, e3) {
          for (const n2 of t3.getChildren())
            if (n2.getCustomProperty(e3))
              return n2;
        }
        function B_(t3, e3, n2) {
          const o2 = M_(t3, n2);
          o2 && e3.remove(e3.createRangeOn(o2));
        }
        var N_ = Object.defineProperty, P_ = Object.defineProperties, z_ = Object.getOwnPropertyDescriptors, O_ = Object.getOwnPropertySymbols, L_ = Object.prototype.hasOwnProperty, R_ = Object.prototype.propertyIsEnumerable, j_ = (t3, e3, n2) => e3 in t3 ? N_(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2;
        class F_ extends os {
          refresh() {
            const t3 = this.editor, e3 = t3.plugins.get("ImageUtils"), n2 = t3.model.document.selection.getSelectedElement();
            this.isEnabled = e3.isImageAllowed() || e3.isImage(n2);
          }
          execute(t3) {
            const e3 = _i(t3.file), n2 = this.editor.model.document.selection, o2 = this.editor.plugins.get("ImageUtils"), i2 = Object.fromEntries(n2.getAttributes());
            e3.forEach((t4, e4) => {
              const r2 = n2.getSelectedElement();
              if (e4 && r2 && o2.isImage(r2)) {
                const e5 = this.editor.model.createPositionAfter(r2);
                this._uploadImage(t4, i2, e5);
              } else
                this._uploadImage(t4, i2);
            });
          }
          _uploadImage(t3, e3, n2) {
            const o2 = this.editor, i2 = o2.plugins.get(Tw).createLoader(t3), r2 = o2.plugins.get("ImageUtils");
            var s3, a2;
            i2 && r2.insertImage((s3 = ((t4, e4) => {
              for (var n3 in e4 || (e4 = {}))
                L_.call(e4, n3) && j_(t4, n3, e4[n3]);
              if (O_)
                for (var n3 of O_(e4))
                  R_.call(e4, n3) && j_(t4, n3, e4[n3]);
              return t4;
            })({}, e3), a2 = { uploadId: i2.id }, P_(s3, z_(a2))), n2);
          }
        }
        class V_ extends es {
          constructor(t3) {
            super(t3), t3.config.define("image", { upload: { types: ["jpeg", "png", "gif", "bmp", "webp", "tiff"] } }), this._uploadImageElements = /* @__PURE__ */ new Map();
          }
          static get requires() {
            return [Tw, $m, uk, xC];
          }
          static get pluginName() {
            return "ImageUploadEditing";
          }
          init() {
            const t3 = this.editor, e3 = t3.model.document, n2 = t3.conversion, o2 = t3.plugins.get(Tw), i2 = t3.plugins.get("ImageUtils"), r2 = t3.plugins.get("ClipboardPipeline"), s3 = k_(t3.config.get("image.upload.types")), a2 = new F_(t3);
            t3.commands.add("uploadImage", a2), t3.commands.add("imageUpload", a2), n2.for("upcast").attributeToAttribute({ view: { name: "img", key: "uploadId" }, model: "uploadId" }), this.listenTo(t3.editing.view.document, "clipboardInput", (e4, n3) => {
              if (o3 = n3.dataTransfer, Array.from(o3.types).includes("text/html") && "" !== o3.getData("text/html"))
                return;
              var o3;
              const i3 = Array.from(n3.dataTransfer.files).filter((t4) => !!t4 && s3.test(t4.type));
              i3.length && (e4.stop(), t3.model.change((e5) => {
                n3.targetRanges && e5.setSelection(n3.targetRanges.map((e6) => t3.editing.mapper.toModelRange(e6))), t3.execute("uploadImage", { file: i3 });
              }));
            }), this.listenTo(r2, "inputTransformation", (e4, n3) => {
              const r3 = Array.from(t3.editing.view.createRangeIn(n3.content)).map((t4) => t4.item).filter((t4) => function(t5, e5) {
                return !(!t5.isInlineImageView(e5) || !e5.getAttribute("src") || !e5.getAttribute("src").match(/^data:image\/\w+;base64,/g) && !e5.getAttribute("src").match(/^blob:/g));
              }(i2, t4) && !t4.getAttribute("uploadProcessed")).map((t4) => ({ promise: b_(t4), imageElement: t4 }));
              if (!r3.length)
                return;
              const s4 = new Bg(t3.editing.view.document);
              for (const t4 of r3) {
                s4.setAttribute("uploadProcessed", true, t4.imageElement);
                const e5 = o2.createLoader(t4.promise);
                e5 && (s4.setAttribute("src", "", t4.imageElement), s4.setAttribute("uploadId", e5.id, t4.imageElement));
              }
            }), t3.editing.view.document.on("dragover", (t4, e4) => {
              e4.preventDefault();
            }), e3.on("change", () => {
              const n3 = e3.differ.getChanges({ includeChangesInGraveyard: true }).reverse(), i3 = /* @__PURE__ */ new Set();
              for (const e4 of n3)
                if ("insert" == e4.type && "$text" != e4.name) {
                  const n4 = e4.position.nodeAfter, r3 = "$graveyard" == e4.position.root.rootName;
                  for (const e5 of U_(t3, n4)) {
                    const t4 = e5.getAttribute("uploadId");
                    if (!t4)
                      continue;
                    const n5 = o2.loaders.get(t4);
                    n5 && (r3 ? i3.has(t4) || n5.abort() : (i3.add(t4), this._uploadImageElements.set(t4, e5), "idle" == n5.status && this._readAndUpload(n5)));
                  }
                }
            }), this.on("uploadComplete", (t4, { imageElement: e4, data: n3 }) => {
              const o3 = n3.urls ? n3.urls : n3;
              this.editor.model.change((t5) => {
                t5.setAttribute("src", o3.default, e4), this._parseAndSetSrcsetAttributeOnImage(o3, e4, t5), i2.setImageNaturalSizeAttributes(e4);
              });
            }, { priority: "low" });
          }
          afterInit() {
            const t3 = this.editor.model.schema;
            this.editor.plugins.has("ImageBlockEditing") && t3.extend("imageBlock", { allowAttributes: ["uploadId", "uploadStatus"] }), this.editor.plugins.has("ImageInlineEditing") && t3.extend("imageInline", { allowAttributes: ["uploadId", "uploadStatus"] });
          }
          _readAndUpload(t3) {
            const e3 = this.editor, n2 = e3.model, o2 = e3.locale.t, i2 = e3.plugins.get(Tw), r2 = e3.plugins.get($m), s3 = e3.plugins.get("ImageUtils"), c2 = this._uploadImageElements;
            return n2.enqueueChange({ isUndoable: false }, (e4) => {
              e4.setAttribute("uploadStatus", "reading", c2.get(t3.id));
            }), t3.read().then(() => {
              const o3 = t3.upload(), i3 = c2.get(t3.id);
              if (a.isSafari) {
                const t4 = e3.editing.mapper.toViewElement(i3), n3 = s3.findViewImgElement(t4);
                e3.editing.view.once("render", () => {
                  if (!n3.parent)
                    return;
                  const t5 = e3.editing.view.domConverter.mapViewToDom(n3.parent);
                  if (!t5)
                    return;
                  const o4 = t5.style.display;
                  t5.style.display = "none", t5._ckHack = t5.offsetHeight, t5.style.display = o4;
                });
              }
              return n2.enqueueChange({ isUndoable: false }, (t4) => {
                t4.setAttribute("uploadStatus", "uploading", i3);
              }), o3;
            }).then((e4) => {
              n2.enqueueChange({ isUndoable: false }, (n3) => {
                const o3 = c2.get(t3.id);
                n3.setAttribute("uploadStatus", "complete", o3), this.fire("uploadComplete", { data: e4, imageElement: o3 });
              }), l2();
            }).catch((e4) => {
              if ("error" !== t3.status && "aborted" !== t3.status)
                throw e4;
              "error" == t3.status && e4 && r2.showWarning(e4, { title: o2("Upload failed"), namespace: "upload" }), n2.enqueueChange({ isUndoable: false }, (e5) => {
                e5.remove(c2.get(t3.id));
              }), l2();
            });
            function l2() {
              n2.enqueueChange({ isUndoable: false }, (e4) => {
                const n3 = c2.get(t3.id);
                e4.removeAttribute("uploadId", n3), e4.removeAttribute("uploadStatus", n3), c2.delete(t3.id);
              }), i2.destroyLoader(t3);
            }
          }
          _parseAndSetSrcsetAttributeOnImage(t3, e3, n2) {
            let o2 = 0;
            const i2 = Object.keys(t3).filter((t4) => {
              const e4 = parseInt(t4, 10);
              if (!isNaN(e4))
                return o2 = Math.max(o2, e4), true;
            }).map((e4) => `${t3[e4]} ${e4}w`).join(", ");
            if ("" != i2) {
              const t4 = { srcset: i2 };
              e3.hasAttribute("width") || e3.hasAttribute("height") || (t4.width = o2), n2.setAttributes(t4, e3);
            }
          }
        }
        function U_(t3, e3) {
          const n2 = t3.plugins.get("ImageUtils");
          return Array.from(t3.model.createRangeOn(e3)).filter((t4) => n2.isImage(t4.item)).map((t4) => t4.item);
        }
        var H_ = n(6270), q_ = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(H_.Z, q_);
        H_.Z.locals;
        class G_ extends os {
          constructor(t3, e3) {
            super(t3), this._defaultStyles = { imageBlock: false, imageInline: false }, this._styles = new Map(e3.map((t4) => {
              if (t4.isDefault)
                for (const e4 of t4.modelElements)
                  this._defaultStyles[e4] = t4.name;
              return [t4.name, t4];
            }));
          }
          refresh() {
            const t3 = this.editor.plugins.get("ImageUtils").getClosestSelectedImageElement(this.editor.model.document.selection);
            this.isEnabled = !!t3, this.isEnabled ? t3.hasAttribute("imageStyle") ? this.value = t3.getAttribute("imageStyle") : this.value = this._defaultStyles[t3.name] : this.value = false;
          }
          execute(t3 = {}) {
            const e3 = this.editor, n2 = e3.model, o2 = e3.plugins.get("ImageUtils");
            n2.change((e4) => {
              const i2 = t3.value, { setImageSizes: r2 = true } = t3;
              let s3 = o2.getClosestSelectedImageElement(n2.document.selection);
              i2 && this.shouldConvertImageType(i2, s3) && (this.editor.execute(o2.isBlockImage(s3) ? "imageTypeInline" : "imageTypeBlock", { setImageSizes: r2 }), s3 = o2.getClosestSelectedImageElement(n2.document.selection)), !i2 || this._styles.get(i2).isDefault ? e4.removeAttribute("imageStyle", s3) : e4.setAttribute("imageStyle", i2, s3), r2 && o2.setImageNaturalSizeAttributes(s3);
            });
          }
          shouldConvertImageType(t3, e3) {
            return !this._styles.get(t3).modelElements.includes(e3.name);
          }
        }
        var W_ = Object.defineProperty, K_ = Object.getOwnPropertySymbols, Z_ = Object.prototype.hasOwnProperty, Y_ = Object.prototype.propertyIsEnumerable, $_ = (t3, e3, n2) => e3 in t3 ? W_(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, Q_ = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            Z_.call(e3, n2) && $_(t3, n2, e3[n2]);
          if (K_)
            for (var n2 of K_(e3))
              Y_.call(e3, n2) && $_(t3, n2, e3[n2]);
          return t3;
        };
        const { objectFullWidth: J_, objectInline: X_, objectLeft: tv, objectRight: ev, objectCenter: nv, objectBlockLeft: ov, objectBlockRight: iv } = Rg, rv = { get inline() {
          return { name: "inline", title: "In line", icon: X_, modelElements: ["imageInline"], isDefault: true };
        }, get alignLeft() {
          return { name: "alignLeft", title: "Left aligned image", icon: tv, modelElements: ["imageBlock", "imageInline"], className: "image-style-align-left" };
        }, get alignBlockLeft() {
          return { name: "alignBlockLeft", title: "Left aligned image", icon: ov, modelElements: ["imageBlock"], className: "image-style-block-align-left" };
        }, get alignCenter() {
          return { name: "alignCenter", title: "Centered image", icon: nv, modelElements: ["imageBlock"], className: "image-style-align-center" };
        }, get alignRight() {
          return { name: "alignRight", title: "Right aligned image", icon: ev, modelElements: ["imageBlock", "imageInline"], className: "image-style-align-right" };
        }, get alignBlockRight() {
          return { name: "alignBlockRight", title: "Right aligned image", icon: iv, modelElements: ["imageBlock"], className: "image-style-block-align-right" };
        }, get block() {
          return { name: "block", title: "Centered image", icon: nv, modelElements: ["imageBlock"], isDefault: true };
        }, get side() {
          return { name: "side", title: "Side image", icon: ev, modelElements: ["imageBlock"], className: "image-style-side" };
        } }, sv = { full: J_, left: ov, right: iv, center: nv, inlineLeft: tv, inlineRight: ev, inline: X_ }, av = [{ name: "imageStyle:wrapText", title: "Wrap text", defaultItem: "imageStyle:alignLeft", items: ["imageStyle:alignLeft", "imageStyle:alignRight"] }, { name: "imageStyle:breakText", title: "Break text", defaultItem: "imageStyle:block", items: ["imageStyle:alignBlockLeft", "imageStyle:block", "imageStyle:alignBlockRight"] }];
        function cv(t3) {
          C("image-style-configuration-definition-invalid", t3);
        }
        const lv = { normalizeStyles: function(t3) {
          return (t3.configuredStyles.options || []).map((t4) => function(t5) {
            t5 = "string" == typeof t5 ? rv[t5] ? Q_({}, rv[t5]) : { name: t5 } : function(t6, e3) {
              const n2 = Q_({}, e3);
              for (const o2 in t6)
                Object.prototype.hasOwnProperty.call(e3, o2) || (n2[o2] = t6[o2]);
              return n2;
            }(rv[t5.name], t5);
            "string" == typeof t5.icon && (t5.icon = sv[t5.icon] || t5.icon);
            return t5;
          }(t4)).filter((e3) => function(t4, { isBlockPluginLoaded: e4, isInlinePluginLoaded: n2 }) {
            const { modelElements: o2, name: i2 } = t4;
            if (!(o2 && o2.length && i2))
              return cv({ style: t4 }), false;
            {
              const i3 = [e4 ? "imageBlock" : null, n2 ? "imageInline" : null];
              if (!o2.some((t5) => i3.includes(t5)))
                return C("image-style-missing-dependency", { style: t4, missingPlugins: o2.map((t5) => "imageBlock" === t5 ? "ImageBlockEditing" : "ImageInlineEditing") }), false;
            }
            return true;
          }(e3, t3));
        }, getDefaultStylesConfiguration: function(t3, e3) {
          return t3 && e3 ? { options: ["inline", "alignLeft", "alignRight", "alignCenter", "alignBlockLeft", "alignBlockRight", "block", "side"] } : t3 ? { options: ["block", "side"] } : e3 ? { options: ["inline", "alignLeft", "alignRight"] } : {};
        }, getDefaultDropdownDefinitions: function(t3) {
          return t3.has("ImageBlockEditing") && t3.has("ImageInlineEditing") ? [...av] : [];
        }, warnInvalidStyle: cv, DEFAULT_OPTIONS: rv, DEFAULT_ICONS: sv, DEFAULT_DROPDOWN_DEFINITIONS: av };
        function dv(t3, e3) {
          for (const n2 of e3)
            if (n2.name === t3)
              return n2;
        }
        class hv extends es {
          static get pluginName() {
            return "ImageStyleEditing";
          }
          static get requires() {
            return [xC];
          }
          init() {
            const { normalizeStyles: t3, getDefaultStylesConfiguration: e3 } = lv, n2 = this.editor, o2 = n2.plugins.has("ImageBlockEditing"), i2 = n2.plugins.has("ImageInlineEditing");
            n2.config.define("image.styles", e3(o2, i2)), this.normalizedStyles = t3({ configuredStyles: n2.config.get("image.styles"), isBlockPluginLoaded: o2, isInlinePluginLoaded: i2 }), this._setupConversion(o2, i2), this._setupPostFixer(), n2.commands.add("imageStyle", new G_(n2, this.normalizedStyles));
          }
          _setupConversion(t3, e3) {
            const n2 = this.editor, o2 = n2.model.schema, i2 = (r2 = this.normalizedStyles, (t4, e4, n3) => {
              if (!n3.consumable.consume(e4.item, t4.name))
                return;
              const o3 = dv(e4.attributeNewValue, r2), i3 = dv(e4.attributeOldValue, r2), s4 = n3.mapper.toViewElement(e4.item), a2 = n3.writer;
              i3 && a2.removeClass(i3.className, s4), o3 && a2.addClass(o3.className, s4);
            });
            var r2;
            const s3 = function(t4) {
              const e4 = { imageInline: t4.filter((t5) => !t5.isDefault && t5.modelElements.includes("imageInline")), imageBlock: t4.filter((t5) => !t5.isDefault && t5.modelElements.includes("imageBlock")) };
              return (t5, n3, o3) => {
                if (!n3.modelRange)
                  return;
                const i3 = n3.viewItem, r3 = Ii(n3.modelRange.getItems());
                if (r3 && o3.schema.checkAttribute(r3, "imageStyle"))
                  for (const t6 of e4[r3.name])
                    o3.consumable.consume(i3, { classes: t6.className }) && o3.writer.setAttribute("imageStyle", t6.name, r3);
              };
            }(this.normalizedStyles);
            n2.editing.downcastDispatcher.on("attribute:imageStyle", i2), n2.data.downcastDispatcher.on("attribute:imageStyle", i2), t3 && (o2.extend("imageBlock", { allowAttributes: "imageStyle" }), n2.data.upcastDispatcher.on("element:figure", s3, { priority: "low" })), e3 && (o2.extend("imageInline", { allowAttributes: "imageStyle" }), n2.data.upcastDispatcher.on("element:img", s3, { priority: "low" }));
          }
          _setupPostFixer() {
            const t3 = this.editor, e3 = t3.model.document, n2 = t3.plugins.get(xC), o2 = new Map(this.normalizedStyles.map((t4) => [t4.name, t4]));
            e3.registerPostFixer((t4) => {
              let i2 = false;
              for (const r2 of e3.differ.getChanges())
                if ("insert" == r2.type || "attribute" == r2.type && "imageStyle" == r2.attributeKey) {
                  let e4 = "insert" == r2.type ? r2.position.nodeAfter : r2.range.start.nodeAfter;
                  if (e4 && e4.is("element", "paragraph") && e4.childCount > 0 && (e4 = e4.getChild(0)), !n2.isImage(e4))
                    continue;
                  const s3 = e4.getAttribute("imageStyle");
                  if (!s3)
                    continue;
                  const a2 = o2.get(s3);
                  a2 && a2.modelElements.includes(e4.name) || (t4.removeAttribute("imageStyle", e4), i2 = true);
                }
              return i2;
            });
          }
        }
        var uv = n(5083), gv = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(uv.Z, gv);
        uv.Z.locals;
        class pv extends es {
          static get requires() {
            return [hv];
          }
          static get pluginName() {
            return "ImageStyleUI";
          }
          get localizedDefaultStylesTitles() {
            const t3 = this.editor.t;
            return { "Wrap text": t3("Wrap text"), "Break text": t3("Break text"), "In line": t3("In line"), "Full size image": t3("Full size image"), "Side image": t3("Side image"), "Left aligned image": t3("Left aligned image"), "Centered image": t3("Centered image"), "Right aligned image": t3("Right aligned image") };
          }
          init() {
            const t3 = this.editor.plugins, e3 = this.editor.config.get("image.toolbar") || [], n2 = mv(t3.get("ImageStyleEditing").normalizedStyles, this.localizedDefaultStylesTitles);
            for (const t4 of n2)
              this._createButton(t4);
            const o2 = mv([...e3.filter(j), ...lv.getDefaultDropdownDefinitions(t3)], this.localizedDefaultStylesTitles);
            for (const t4 of o2)
              this._createDropdown(t4, n2);
          }
          _createDropdown(t3, e3) {
            const n2 = this.editor.ui.componentFactory;
            n2.add(t3.name, (o2) => {
              let i2;
              const { defaultItem: r2, items: s3, title: a2 } = t3, c2 = s3.filter((t4) => e3.find(({ name: e4 }) => fv(e4) === t4)).map((t4) => {
                const e4 = n2.create(t4);
                return t4 === r2 && (i2 = e4), e4;
              });
              s3.length !== c2.length && lv.warnInvalidStyle({ dropdown: t3 });
              const l2 = sp(o2, ep), d2 = l2.buttonView, h2 = d2.arrowView;
              return ap(l2, c2, { enableActiveItemFocusOnDropdownOpen: true }), d2.set({ label: kv(a2, i2.label), class: null, tooltip: true }), h2.unbind("label"), h2.set({ label: a2 }), d2.bind("icon").toMany(c2, "isOn", (...t4) => {
                const e4 = t4.findIndex(ra);
                return e4 < 0 ? i2.icon : c2[e4].icon;
              }), d2.bind("label").toMany(c2, "isOn", (...t4) => {
                const e4 = t4.findIndex(ra);
                return kv(a2, e4 < 0 ? i2.label : c2[e4].label);
              }), d2.bind("isOn").toMany(c2, "isOn", (...t4) => t4.some(ra)), d2.bind("class").toMany(c2, "isOn", (...t4) => t4.some(ra) ? "ck-splitbutton_flatten" : void 0), d2.on("execute", () => {
                c2.some(({ isOn: t4 }) => t4) ? l2.isOpen = !l2.isOpen : i2.fire("execute");
              }), l2.bind("isEnabled").toMany(c2, "isEnabled", (...t4) => t4.some(ra)), this.listenTo(l2, "execute", () => {
                this.editor.editing.view.focus();
              }), l2;
            });
          }
          _createButton(t3) {
            const e3 = t3.name;
            this.editor.ui.componentFactory.add(fv(e3), (n2) => {
              const o2 = this.editor.commands.get("imageStyle"), i2 = new br(n2);
              return i2.set({ label: t3.title, icon: t3.icon, tooltip: true, isToggleable: true }), i2.bind("isEnabled").to(o2, "isEnabled"), i2.bind("isOn").to(o2, "value", (t4) => t4 === e3), i2.on("execute", this._executeCommand.bind(this, e3)), i2;
            });
          }
          _executeCommand(t3) {
            this.editor.execute("imageStyle", { value: t3 }), this.editor.editing.view.focus();
          }
        }
        function mv(t3, e3) {
          for (const n2 of t3)
            e3[n2.title] && (n2.title = e3[n2.title]);
          return t3;
        }
        function fv(t3) {
          return `imageStyle:${t3}`;
        }
        function kv(t3, e3) {
          return (t3 ? t3 + ": " : "") + e3;
        }
        class bv extends es {
          static get pluginName() {
            return "IndentEditing";
          }
          init() {
            const t3 = this.editor;
            t3.commands.add("indent", new rs(t3)), t3.commands.add("outdent", new rs(t3));
          }
        }
        const wv = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zM1.632 6.95 5.02 9.358a.4.4 0 0 1-.013.661l-3.39 2.207A.4.4 0 0 1 1 11.892V7.275a.4.4 0 0 1 .632-.326z"/></svg>', Av = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2 3.75c0 .414.336.75.75.75h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 0 0-.75.75zm5 6c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM2.75 16.5h14.5a.75.75 0 1 0 0-1.5H2.75a.75.75 0 1 0 0 1.5zm1.618-9.55L.98 9.358a.4.4 0 0 0 .013.661l3.39 2.207A.4.4 0 0 0 5 11.892V7.275a.4.4 0 0 0-.632-.326z"/></svg>';
        class Cv extends es {
          static get pluginName() {
            return "IndentUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.locale, n2 = t3.t, o2 = "ltr" == e3.uiLanguageDirection ? wv : Av, i2 = "ltr" == e3.uiLanguageDirection ? Av : wv;
            this._defineButton("indent", n2("Increase indent"), o2), this._defineButton("outdent", n2("Decrease indent"), i2);
          }
          _defineButton(t3, e3, n2) {
            const o2 = this.editor;
            o2.ui.componentFactory.add(t3, (i2) => {
              const r2 = o2.commands.get(t3), s3 = new br(i2);
              return s3.set({ label: e3, icon: n2, tooltip: true }), s3.bind("isEnabled").to(r2, "isEnabled"), this.listenTo(s3, "execute", () => {
                o2.execute(t3), o2.editing.view.focus();
              }), s3;
            });
          }
        }
        class _v {
          constructor() {
            this._definitions = /* @__PURE__ */ new Set();
          }
          get length() {
            return this._definitions.size;
          }
          add(t3) {
            Array.isArray(t3) ? t3.forEach((t4) => this._definitions.add(t4)) : this._definitions.add(t3);
          }
          getDispatcher() {
            return (t3) => {
              t3.on("attribute:linkHref", (t4, e3, n2) => {
                if (!n2.consumable.test(e3.item, "attribute:linkHref"))
                  return;
                if (!e3.item.is("selection") && !n2.schema.isInline(e3.item))
                  return;
                const o2 = n2.writer, i2 = o2.document.selection;
                for (const t5 of this._definitions) {
                  const r2 = o2.createAttributeElement("a", t5.attributes, { priority: 5 });
                  t5.classes && o2.addClass(t5.classes, r2);
                  for (const e4 in t5.styles)
                    o2.setStyle(e4, t5.styles[e4], r2);
                  o2.setCustomProperty("link", true, r2), t5.callback(e3.attributeNewValue) ? e3.item.is("selection") ? o2.wrap(i2.getFirstRange(), r2) : o2.wrap(n2.mapper.toViewRange(e3.range), r2) : o2.unwrap(n2.mapper.toViewRange(e3.range), r2);
                }
              }, { priority: "high" });
            };
          }
          getDispatcherForLinkedImage() {
            return (t3) => {
              t3.on("attribute:linkHref:imageBlock", (t4, e3, { writer: n2, mapper: o2 }) => {
                const i2 = o2.toViewElement(e3.item), r2 = Array.from(i2.getChildren()).find((t5) => t5.is("element", "a"));
                for (const t5 of this._definitions) {
                  const o3 = Mi(t5.attributes);
                  if (t5.callback(e3.attributeNewValue)) {
                    for (const [t6, e4] of o3)
                      "class" === t6 ? n2.addClass(e4, r2) : n2.setAttribute(t6, e4, r2);
                    t5.classes && n2.addClass(t5.classes, r2);
                    for (const e4 in t5.styles)
                      n2.setStyle(e4, t5.styles[e4], r2);
                  } else {
                    for (const [t6, e4] of o3)
                      "class" === t6 ? n2.removeClass(e4, r2) : n2.removeAttribute(t6, r2);
                    t5.classes && n2.removeClass(t5.classes, r2);
                    for (const e4 in t5.styles)
                      n2.removeStyle(e4, r2);
                  }
                }
              });
            };
          }
        }
        const vv = function(t3, e3, n2) {
          var o2 = t3.length;
          return n2 = void 0 === n2 ? o2 : n2, !e3 && n2 >= o2 ? t3 : Ks(t3, e3, n2);
        };
        var yv = RegExp("[\\u200d\\ud800-\\udfff\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff\\ufe0e\\ufe0f]");
        const xv = function(t3) {
          return yv.test(t3);
        };
        const Ev = function(t3) {
          return t3.split("");
        };
        var Dv = "\\ud800-\\udfff", Iv = "[" + Dv + "]", Sv = "[\\u0300-\\u036f\\ufe20-\\ufe2f\\u20d0-\\u20ff]", Tv = "\\ud83c[\\udffb-\\udfff]", Mv = "[^" + Dv + "]", Bv = "(?:\\ud83c[\\udde6-\\uddff]){2}", Nv = "[\\ud800-\\udbff][\\udc00-\\udfff]", Pv = "(?:" + Sv + "|" + Tv + ")?", zv = "[\\ufe0e\\ufe0f]?", Ov = zv + Pv + ("(?:\\u200d(?:" + [Mv, Bv, Nv].join("|") + ")" + zv + Pv + ")*"), Lv = "(?:" + [Mv + Sv + "?", Sv, Bv, Nv, Iv].join("|") + ")", Rv = RegExp(Tv + "(?=" + Tv + ")|" + Lv + Ov, "g");
        const jv = function(t3) {
          return t3.match(Rv) || [];
        };
        const Fv = function(t3) {
          return xv(t3) ? jv(t3) : Ev(t3);
        };
        const Vv = function(t3) {
          return function(e3) {
            e3 = Us(e3);
            var n2 = xv(e3) ? Fv(e3) : void 0, o2 = n2 ? n2[0] : e3.charAt(0), i2 = n2 ? vv(n2, 1).join("") : e3.slice(1);
            return o2[t3]() + i2;
          };
        }("toUpperCase"), Uv = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205f\u3000]/g, Hv = /^(?:(?:https?|ftps?|mailto):|[^a-z]|[a-z+.-]+(?:[^a-z+.:-]|$))/i, qv = /^[\S]+@((?![-_])(?:[-\w\u00a1-\uffff]{0,63}[^-_]\.))+(?:[a-z\u00a1-\uffff]{2,})$/i, Gv = /^((\w+:(\/{2,})?)|(\W))/i, Wv = "Ctrl+K";
        function Kv(t3, { writer: e3 }) {
          const n2 = e3.createAttributeElement("a", { href: t3 }, { priority: 5 });
          return e3.setCustomProperty("link", true, n2), n2;
        }
        function Zv(t3) {
          const e3 = String(t3);
          return function(t4) {
            const e4 = t4.replace(Uv, "");
            return !!e4.match(Hv);
          }(e3) ? e3 : "#";
        }
        function Yv(t3, e3) {
          return !!t3 && e3.checkAttribute(t3.name, "linkHref");
        }
        function $v(t3, e3) {
          const n2 = (o2 = t3, qv.test(o2) ? "mailto:" : e3);
          var o2;
          const i2 = !!n2 && !Qv(t3);
          return t3 && i2 ? n2 + t3 : t3;
        }
        function Qv(t3) {
          return Gv.test(t3);
        }
        function Jv(t3) {
          window.open(t3, "_blank", "noopener");
        }
        class Xv extends os {
          constructor() {
            super(...arguments), this.manualDecorators = new Di(), this.automaticDecorators = new _v();
          }
          restoreManualDecoratorStates() {
            for (const t3 of this.manualDecorators)
              t3.value = this._getDecoratorStateFromModel(t3.id);
          }
          refresh() {
            const t3 = this.editor.model, e3 = t3.document.selection, n2 = e3.getSelectedElement() || Ii(e3.getSelectedBlocks());
            Yv(n2, t3.schema) ? (this.value = n2.getAttribute("linkHref"), this.isEnabled = t3.schema.checkAttribute(n2, "linkHref")) : (this.value = e3.getAttribute("linkHref"), this.isEnabled = t3.schema.checkAttributeInSelection(e3, "linkHref"));
            for (const t4 of this.manualDecorators)
              t4.value = this._getDecoratorStateFromModel(t4.id);
          }
          execute(t3, e3 = {}) {
            const n2 = this.editor.model, o2 = n2.document.selection, i2 = [], r2 = [];
            for (const t4 in e3)
              e3[t4] ? i2.push(t4) : r2.push(t4);
            n2.change((e4) => {
              if (o2.isCollapsed) {
                const s3 = o2.getFirstPosition();
                if (o2.hasAttribute("linkHref")) {
                  const a2 = ty(o2);
                  let c2 = qk(s3, "linkHref", o2.getAttribute("linkHref"), n2);
                  o2.getAttribute("linkHref") === a2 && (c2 = this._updateLinkContent(n2, e4, c2, t3)), e4.setAttribute("linkHref", t3, c2), i2.forEach((t4) => {
                    e4.setAttribute(t4, true, c2);
                  }), r2.forEach((t4) => {
                    e4.removeAttribute(t4, c2);
                  }), e4.setSelection(e4.createPositionAfter(c2.end.nodeBefore));
                } else if ("" !== t3) {
                  const r3 = Mi(o2.getAttributes());
                  r3.set("linkHref", t3), i2.forEach((t4) => {
                    r3.set(t4, true);
                  });
                  const { end: a2 } = n2.insertContent(e4.createText(t3, r3), s3);
                  e4.setSelection(a2);
                }
                ["linkHref", ...i2, ...r2].forEach((t4) => {
                  e4.removeSelectionAttribute(t4);
                });
              } else {
                const s3 = n2.schema.getValidRanges(o2.getRanges(), "linkHref"), a2 = [];
                for (const t4 of o2.getSelectedBlocks())
                  n2.schema.checkAttribute(t4, "linkHref") && a2.push(e4.createRangeOn(t4));
                const c2 = a2.slice();
                for (const t4 of s3)
                  this._isRangeToUpdate(t4, a2) && c2.push(t4);
                for (const s4 of c2) {
                  let a3 = s4;
                  if (1 === c2.length) {
                    const i3 = ty(o2);
                    o2.getAttribute("linkHref") === i3 && (a3 = this._updateLinkContent(n2, e4, s4, t3), e4.setSelection(e4.createSelection(a3)));
                  }
                  e4.setAttribute("linkHref", t3, a3), i2.forEach((t4) => {
                    e4.setAttribute(t4, true, a3);
                  }), r2.forEach((t4) => {
                    e4.removeAttribute(t4, a3);
                  });
                }
              }
            });
          }
          _getDecoratorStateFromModel(t3) {
            const e3 = this.editor.model, n2 = e3.document.selection, o2 = n2.getSelectedElement();
            return Yv(o2, e3.schema) ? o2.getAttribute(t3) : n2.getAttribute(t3);
          }
          _isRangeToUpdate(t3, e3) {
            for (const n2 of e3)
              if (n2.containsRange(t3))
                return false;
            return true;
          }
          _updateLinkContent(t3, e3, n2, o2) {
            const i2 = e3.createText(o2, { linkHref: o2 });
            return t3.insertContent(i2, n2);
          }
        }
        function ty(t3) {
          if (t3.isCollapsed) {
            const e3 = t3.getFirstPosition();
            return e3.textNode && e3.textNode.data;
          }
          {
            const e3 = Array.from(t3.getFirstRange().getItems());
            if (e3.length > 1)
              return null;
            const n2 = e3[0];
            return n2.is("$text") || n2.is("$textProxy") ? n2.data : null;
          }
        }
        class ey extends os {
          refresh() {
            const t3 = this.editor.model, e3 = t3.document.selection, n2 = e3.getSelectedElement();
            Yv(n2, t3.schema) ? this.isEnabled = t3.schema.checkAttribute(n2, "linkHref") : this.isEnabled = t3.schema.checkAttributeInSelection(e3, "linkHref");
          }
          execute() {
            const t3 = this.editor, e3 = this.editor.model, n2 = e3.document.selection, o2 = t3.commands.get("link");
            e3.change((t4) => {
              const i2 = n2.isCollapsed ? [qk(n2.getFirstPosition(), "linkHref", n2.getAttribute("linkHref"), e3)] : e3.schema.getValidRanges(n2.getRanges(), "linkHref");
              for (const e4 of i2)
                if (t4.removeAttribute("linkHref", e4), o2)
                  for (const n3 of o2.manualDecorators)
                    t4.removeAttribute(n3.id, e4);
            });
          }
        }
        class ny extends W() {
          constructor({ id: t3, label: e3, attributes: n2, classes: o2, styles: i2, defaultValue: r2 }) {
            super(), this.id = t3, this.set("value", void 0), this.defaultValue = r2, this.label = e3, this.attributes = n2, this.classes = o2, this.styles = i2;
          }
          _createPattern() {
            return { attributes: this.attributes, classes: this.classes, styles: this.styles };
          }
        }
        var oy = n(9773), iy = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(oy.Z, iy);
        oy.Z.locals;
        var ry = Object.defineProperty, sy = Object.getOwnPropertySymbols, ay = Object.prototype.hasOwnProperty, cy = Object.prototype.propertyIsEnumerable, ly = (t3, e3, n2) => e3 in t3 ? ry(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, dy = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            ay.call(e3, n2) && ly(t3, n2, e3[n2]);
          if (sy)
            for (var n2 of sy(e3))
              cy.call(e3, n2) && ly(t3, n2, e3[n2]);
          return t3;
        };
        const hy = "automatic", uy = /^(https?:)?\/\//;
        class gy extends es {
          static get pluginName() {
            return "LinkEditing";
          }
          static get requires() {
            return [Tk, kk, uk];
          }
          constructor(t3) {
            super(t3), t3.config.define("link", { addTargetToExternalLinks: false });
          }
          init() {
            const t3 = this.editor;
            t3.model.schema.extend("$text", { allowAttributes: "linkHref" }), t3.conversion.for("dataDowncast").attributeToElement({ model: "linkHref", view: Kv }), t3.conversion.for("editingDowncast").attributeToElement({ model: "linkHref", view: (t4, e4) => Kv(Zv(t4), e4) }), t3.conversion.for("upcast").elementToAttribute({ view: { name: "a", attributes: { href: true } }, model: { key: "linkHref", value: (t4) => t4.getAttribute("href") } }), t3.commands.add("link", new Xv(t3)), t3.commands.add("unlink", new ey(t3));
            const e3 = function(t4, e4) {
              const n2 = { "Open in a new tab": t4("Open in a new tab"), Downloadable: t4("Downloadable") };
              return e4.forEach((t5) => ("label" in t5 && n2[t5.label] && (t5.label = n2[t5.label]), t5)), e4;
            }(t3.t, function(t4) {
              const e4 = [];
              if (t4)
                for (const [n2, o2] of Object.entries(t4)) {
                  const t5 = Object.assign({}, o2, { id: `link${Vv(n2)}` });
                  e4.push(t5);
                }
              return e4;
            }(t3.config.get("link.decorators")));
            this._enableAutomaticDecorators(e3.filter((t4) => t4.mode === hy)), this._enableManualDecorators(e3.filter((t4) => "manual" === t4.mode));
            t3.plugins.get(Tk).registerAttribute("linkHref"), function(t4, e4, n2, o2) {
              const i2 = t4.editing.view, r2 = /* @__PURE__ */ new Set();
              i2.document.registerPostFixer((i3) => {
                const s3 = t4.model.document.selection;
                let a2 = false;
                if (s3.hasAttribute(e4)) {
                  const c2 = qk(s3.getFirstPosition(), e4, s3.getAttribute(e4), t4.model), l2 = t4.editing.mapper.toViewRange(c2);
                  for (const t5 of l2.getItems())
                    t5.is("element", n2) && !t5.hasClass(o2) && (i3.addClass(o2, t5), r2.add(t5), a2 = true);
                }
                return a2;
              }), t4.conversion.for("editingDowncast").add((t5) => {
                function e5() {
                  i2.change((t6) => {
                    for (const e6 of r2.values())
                      t6.removeClass(o2, e6), r2.delete(e6);
                  });
                }
                t5.on("insert", e5, { priority: "highest" }), t5.on("remove", e5, { priority: "highest" }), t5.on("attribute", e5, { priority: "highest" }), t5.on("selection", e5, { priority: "highest" });
              });
            }(t3, "linkHref", "a", "ck-link_selected"), this._enableLinkOpen(), this._enableSelectionAttributesFixer(), this._enableClipboardIntegration();
          }
          _enableAutomaticDecorators(t3) {
            const e3 = this.editor, n2 = e3.commands.get("link").automaticDecorators;
            e3.config.get("link.addTargetToExternalLinks") && n2.add({ id: "linkIsExternal", mode: hy, callback: (t4) => !!t4 && uy.test(t4), attributes: { target: "_blank", rel: "noopener noreferrer" } }), n2.add(t3), n2.length && e3.conversion.for("downcast").add(n2.getDispatcher());
          }
          _enableManualDecorators(t3) {
            if (!t3.length)
              return;
            const e3 = this.editor, n2 = e3.commands.get("link").manualDecorators;
            t3.forEach((t4) => {
              e3.model.schema.extend("$text", { allowAttributes: t4.id });
              const o2 = new ny(t4);
              n2.add(o2), e3.conversion.for("downcast").attributeToElement({ model: o2.id, view: (t5, { writer: e4, schema: n3 }, { item: i2 }) => {
                if ((i2.is("selection") || n3.isInline(i2)) && t5) {
                  const t6 = e4.createAttributeElement("a", o2.attributes, { priority: 5 });
                  o2.classes && e4.addClass(o2.classes, t6);
                  for (const n4 in o2.styles)
                    e4.setStyle(n4, o2.styles[n4], t6);
                  return e4.setCustomProperty("link", true, t6), t6;
                }
              } }), e3.conversion.for("upcast").elementToAttribute({ view: dy({ name: "a" }, o2._createPattern()), model: { key: o2.id } });
            });
          }
          _enableLinkOpen() {
            const t3 = this.editor, e3 = t3.editing.view.document;
            this.listenTo(e3, "click", (t4, e4) => {
              if (!(a.isMac ? e4.domEvent.metaKey : e4.domEvent.ctrlKey))
                return;
              let n2 = e4.domTarget;
              if ("a" != n2.tagName.toLowerCase() && (n2 = n2.closest("a")), !n2)
                return;
              const o2 = n2.getAttribute("href");
              o2 && (t4.stop(), e4.preventDefault(), Jv(o2));
            }, { context: "$capture" }), this.listenTo(e3, "keydown", (e4, n2) => {
              const o2 = t3.commands.get("link").value;
              !!o2 && n2.keyCode === fi.enter && n2.altKey && (e4.stop(), Jv(o2));
            });
          }
          _enableSelectionAttributesFixer() {
            const t3 = this.editor.model, e3 = t3.document.selection;
            this.listenTo(e3, "change:attribute", (n2, { attributeKeys: o2 }) => {
              o2.includes("linkHref") && !e3.hasAttribute("linkHref") && t3.change((e4) => {
                var n3;
                !function(t4, e5) {
                  t4.removeSelectionAttribute("linkHref");
                  for (const n4 of e5)
                    t4.removeSelectionAttribute(n4);
                }(e4, (n3 = t3.schema, n3.getDefinition("$text").allowAttributes.filter((t4) => t4.startsWith("link"))));
              });
            });
          }
          _enableClipboardIntegration() {
            const t3 = this.editor, e3 = t3.model, n2 = this.editor.config.get("link.defaultProtocol");
            n2 && this.listenTo(t3.plugins.get("ClipboardPipeline"), "contentInsertion", (t4, o2) => {
              e3.change((t5) => {
                const e4 = t5.createRangeIn(o2.content);
                for (const o3 of e4.getItems())
                  if (o3.hasAttribute("linkHref")) {
                    const e5 = $v(o3.getAttribute("linkHref"), n2);
                    t5.setAttribute("linkHref", e5, o3);
                  }
              });
            });
          }
        }
        var py = n(7754), my = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(py.Z, my);
        py.Z.locals;
        class fy extends Ui {
          constructor(t3, e3) {
            super(t3), this.focusTracker = new Si(), this.keystrokes = new Ti(), this._focusables = new Li();
            const n2 = t3.t;
            this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(n2("Save"), Rg.check, "ck-button-save"), this.saveButtonView.type = "submit", this.cancelButtonView = this._createButton(n2("Cancel"), Rg.cancel, "ck-button-cancel", "cancel"), this._manualDecoratorSwitches = this._createManualDecoratorSwitches(e3), this.children = this._createFormChildren(e3.manualDecorators), this._focusCycler = new qr({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } });
            const o2 = ["ck", "ck-link-form", "ck-responsive-form"];
            e3.manualDecorators.length && o2.push("ck-link-form_layout-vertical", "ck-vertical-form"), this.setTemplate({ tag: "form", attributes: { class: o2, tabindex: "-1" }, children: this.children });
          }
          getDecoratorSwitchesState() {
            return Array.from(this._manualDecoratorSwitches).reduce((t3, e3) => (t3[e3.name] = e3.isOn, t3), {});
          }
          render() {
            super.render(), i({ view: this });
            [this.urlInputView, ...this._manualDecoratorSwitches, this.saveButtonView, this.cancelButtonView].forEach((t3) => {
              this._focusables.add(t3), this.focusTracker.add(t3.element);
            }), this.keystrokes.listenTo(this.element);
          }
          destroy() {
            super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          _createUrlInput() {
            const t3 = this.locale.t, e3 = new Sr(this.locale, gp);
            return e3.label = t3("Link URL"), e3;
          }
          _createButton(t3, e3, n2, o2) {
            const i2 = new br(this.locale);
            return i2.set({ label: t3, icon: e3, tooltip: true }), i2.extendTemplate({ attributes: { class: n2 } }), o2 && i2.delegate("execute").to(this, o2), i2;
          }
          _createManualDecoratorSwitches(t3) {
            const e3 = this.createCollection();
            for (const n2 of t3.manualDecorators) {
              const o2 = new Cr(this.locale);
              o2.set({ name: n2.id, label: n2.label, withText: true }), o2.bind("isOn").toMany([n2, t3], "value", (t4, e4) => void 0 === e4 && void 0 === t4 ? !!n2.defaultValue : !!t4), o2.on("execute", () => {
                n2.set("value", !o2.isOn);
              }), e3.add(o2);
            }
            return e3;
          }
          _createFormChildren(t3) {
            const e3 = this.createCollection();
            if (e3.add(this.urlInputView), t3.length) {
              const t4 = new Ui();
              t4.setTemplate({ tag: "ul", children: this._manualDecoratorSwitches.map((t5) => ({ tag: "li", children: [t5], attributes: { class: ["ck", "ck-list__item"] } })), attributes: { class: ["ck", "ck-reset", "ck-list"] } }), e3.add(t4);
            }
            return e3.add(this.saveButtonView), e3.add(this.cancelButtonView), e3;
          }
        }
        var ky = n(2347), by = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(ky.Z, by);
        ky.Z.locals;
        class wy extends Ui {
          constructor(t3) {
            super(t3), this.focusTracker = new Si(), this.keystrokes = new Ti(), this._focusables = new Li();
            const e3 = t3.t;
            this.previewButtonView = this._createPreviewButton(), this.unlinkButtonView = this._createButton(e3("Unlink"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184zm4.919 10.562-1.414 1.414a.75.75 0 1 1-1.06-1.06l1.414-1.415-1.415-1.414a.75.75 0 0 1 1.061-1.06l1.414 1.414 1.414-1.415a.75.75 0 0 1 1.061 1.061l-1.414 1.414 1.414 1.415a.75.75 0 0 1-1.06 1.06l-1.415-1.414z"/></svg>', "unlink"), this.editButtonView = this._createButton(e3("Edit link"), Rg.pencil, "edit"), this.set("href", void 0), this._focusCycler = new qr({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this.setTemplate({ tag: "div", attributes: { class: ["ck", "ck-link-actions", "ck-responsive-form"], tabindex: "-1" }, children: [this.previewButtonView, this.editButtonView, this.unlinkButtonView] });
          }
          render() {
            super.render();
            [this.previewButtonView, this.editButtonView, this.unlinkButtonView].forEach((t3) => {
              this._focusables.add(t3), this.focusTracker.add(t3.element);
            }), this.keystrokes.listenTo(this.element);
          }
          destroy() {
            super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          _createButton(t3, e3, n2) {
            const o2 = new br(this.locale);
            return o2.set({ label: t3, icon: e3, tooltip: true }), o2.delegate("execute").to(this, n2), o2;
          }
          _createPreviewButton() {
            const t3 = new br(this.locale), e3 = this.bindTemplate, n2 = this.t;
            return t3.set({ withText: true, tooltip: n2("Open link in new tab") }), t3.extendTemplate({ attributes: { class: ["ck", "ck-link-actions__preview"], href: e3.to("href", (t4) => t4 && Zv(t4)), target: "_blank", rel: "noopener noreferrer" } }), t3.bind("label").to(this, "href", (t4) => t4 || n2("This link has no URL")), t3.bind("isEnabled").to(this, "href", (t4) => !!t4), t3.template.tag = "a", t3.template.eventListeners = {}, t3;
          }
        }
        const Ay = "link-ui";
        class Cy extends es {
          constructor() {
            super(...arguments), this.actionsView = null, this.formView = null;
          }
          static get requires() {
            return [of];
          }
          static get pluginName() {
            return "LinkUI";
          }
          init() {
            const t3 = this.editor;
            t3.editing.view.addObserver(Tg), this._balloon = t3.plugins.get(of), this._createToolbarLinkButton(), this._enableBalloonActivators(), t3.conversion.for("editingDowncast").markerToHighlight({ model: Ay, view: { classes: ["ck-fake-link-selection"] } }), t3.conversion.for("editingDowncast").markerToElement({ model: Ay, view: { name: "span", classes: ["ck-fake-link-selection", "ck-fake-link-selection_collapsed"] } });
          }
          destroy() {
            super.destroy(), this.formView && this.formView.destroy(), this.actionsView && this.actionsView.destroy();
          }
          _createViews() {
            this.actionsView = this._createActionsView(), this.formView = this._createFormView(), this._enableUserBalloonInteractions();
          }
          _createActionsView() {
            const t3 = this.editor, e3 = new wy(t3.locale), n2 = t3.commands.get("link"), o2 = t3.commands.get("unlink");
            return e3.bind("href").to(n2, "value"), e3.editButtonView.bind("isEnabled").to(n2), e3.unlinkButtonView.bind("isEnabled").to(o2), this.listenTo(e3, "edit", () => {
              this._addFormView();
            }), this.listenTo(e3, "unlink", () => {
              t3.execute("unlink"), this._hideUI();
            }), e3.keystrokes.set("Esc", (t4, e4) => {
              this._hideUI(), e4();
            }), e3.keystrokes.set(Wv, (t4, e4) => {
              this._addFormView(), e4();
            }), e3;
          }
          _createFormView() {
            const t3 = this.editor, n2 = t3.commands.get("link"), o2 = t3.config.get("link.defaultProtocol"), i2 = new (e2(fy))(t3.locale, n2);
            return i2.urlInputView.fieldView.bind("value").to(n2, "value"), i2.urlInputView.bind("isEnabled").to(n2, "isEnabled"), i2.saveButtonView.bind("isEnabled").to(n2), this.listenTo(i2, "submit", () => {
              const { value: e3 } = i2.urlInputView.fieldView.element, n3 = $v(e3, o2);
              t3.execute("link", n3, i2.getDecoratorSwitchesState()), this._closeFormView();
            }), this.listenTo(i2, "cancel", () => {
              this._closeFormView();
            }), i2.keystrokes.set("Esc", (t4, e3) => {
              this._closeFormView(), e3();
            }), i2;
          }
          _createToolbarLinkButton() {
            const t3 = this.editor, e3 = t3.commands.get("link"), n2 = t3.t;
            t3.ui.componentFactory.add("link", (t4) => {
              const o2 = new br(t4);
              return o2.isEnabled = true, o2.label = n2("Link"), o2.icon = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="m11.077 15 .991-1.416a.75.75 0 1 1 1.229.86l-1.148 1.64a.748.748 0 0 1-.217.206 5.251 5.251 0 0 1-8.503-5.955.741.741 0 0 1 .12-.274l1.147-1.639a.75.75 0 1 1 1.228.86L4.933 10.7l.006.003a3.75 3.75 0 0 0 6.132 4.294l.006.004zm5.494-5.335a.748.748 0 0 1-.12.274l-1.147 1.639a.75.75 0 1 1-1.228-.86l.86-1.23a3.75 3.75 0 0 0-6.144-4.301l-.86 1.229a.75.75 0 0 1-1.229-.86l1.148-1.64a.748.748 0 0 1 .217-.206 5.251 5.251 0 0 1 8.503 5.955zm-4.563-2.532a.75.75 0 0 1 .184 1.045l-3.155 4.505a.75.75 0 1 1-1.229-.86l3.155-4.506a.75.75 0 0 1 1.045-.184z"/></svg>', o2.keystroke = Wv, o2.tooltip = true, o2.isToggleable = true, o2.bind("isEnabled").to(e3, "isEnabled"), o2.bind("isOn").to(e3, "value", (t5) => !!t5), this.listenTo(o2, "execute", () => this._showUI(true)), o2;
            });
          }
          _enableBalloonActivators() {
            const t3 = this.editor, e3 = t3.editing.view.document;
            this.listenTo(e3, "click", () => {
              this._getSelectedLinkElement() && this._showUI();
            }), t3.keystrokes.set(Wv, (e4, n2) => {
              n2(), t3.commands.get("link").isEnabled && this._showUI(true);
            });
          }
          _enableUserBalloonInteractions() {
            this.editor.keystrokes.set("Tab", (t3, e3) => {
              this._areActionsVisible && !this.actionsView.focusTracker.isFocused && (this.actionsView.focus(), e3());
            }, { priority: "high" }), this.editor.keystrokes.set("Esc", (t3, e3) => {
              this._isUIVisible && (this._hideUI(), e3());
            }), t2({ emitter: this.formView, activator: () => this._isUIInPanel, contextElements: () => [this._balloon.view.element], callback: () => this._hideUI() });
          }
          _addActionsView() {
            this.actionsView || this._createViews(), this._areActionsInPanel || this._balloon.add({ view: this.actionsView, position: this._getBalloonPositionData() });
          }
          _addFormView() {
            if (this.formView || this._createViews(), this._isFormInPanel)
              return;
            const t3 = this.editor.commands.get("link");
            this.formView.disableCssTransitions(), this._balloon.add({ view: this.formView, position: this._getBalloonPositionData() }), this._balloon.visibleView === this.formView && this.formView.urlInputView.fieldView.select(), this.formView.enableCssTransitions(), this.formView.urlInputView.fieldView.element.value = t3.value || "";
          }
          _closeFormView() {
            const t3 = this.editor.commands.get("link");
            t3.restoreManualDecoratorStates(), void 0 !== t3.value ? this._removeFormView() : this._hideUI();
          }
          _removeFormView() {
            this._isFormInPanel && (this.formView.saveButtonView.focus(), this._balloon.remove(this.formView), this.editor.editing.view.focus(), this._hideFakeVisualSelection());
          }
          _showUI(t3 = false) {
            this.formView || this._createViews(), this._getSelectedLinkElement() ? (this._areActionsVisible ? this._addFormView() : this._addActionsView(), t3 && this._balloon.showStack("main")) : (this._showFakeVisualSelection(), this._addActionsView(), t3 && this._balloon.showStack("main"), this._addFormView()), this._startUpdatingUI();
          }
          _hideUI() {
            if (!this._isUIInPanel)
              return;
            const t3 = this.editor;
            this.stopListening(t3.ui, "update"), this.stopListening(this._balloon, "change:visibleView"), t3.editing.view.focus(), this._removeFormView(), this._balloon.remove(this.actionsView), this._hideFakeVisualSelection();
          }
          _startUpdatingUI() {
            const t3 = this.editor, e3 = t3.editing.view.document;
            let n2 = this._getSelectedLinkElement(), o2 = r2();
            const i2 = () => {
              const t4 = this._getSelectedLinkElement(), e4 = r2();
              n2 && !t4 || !n2 && e4 !== o2 ? this._hideUI() : this._isUIVisible && this._balloon.updatePosition(this._getBalloonPositionData()), n2 = t4, o2 = e4;
            };
            function r2() {
              return e3.selection.focus.getAncestors().reverse().find((t4) => t4.is("element"));
            }
            this.listenTo(t3.ui, "update", i2), this.listenTo(this._balloon, "change:visibleView", i2);
          }
          get _isFormInPanel() {
            return !!this.formView && this._balloon.hasView(this.formView);
          }
          get _areActionsInPanel() {
            return !!this.actionsView && this._balloon.hasView(this.actionsView);
          }
          get _areActionsVisible() {
            return !!this.actionsView && this._balloon.visibleView === this.actionsView;
          }
          get _isUIInPanel() {
            return this._isFormInPanel || this._areActionsInPanel;
          }
          get _isUIVisible() {
            const t3 = this._balloon.visibleView;
            return !!this.formView && t3 == this.formView || this._areActionsVisible;
          }
          _getBalloonPositionData() {
            const t3 = this.editor.editing.view, e3 = this.editor.model, n2 = t3.document;
            let o2;
            if (e3.markers.has(Ay)) {
              const e4 = Array.from(this.editor.editing.mapper.markerNameToElements(Ay)), n3 = t3.createRange(t3.createPositionBefore(e4[0]), t3.createPositionAfter(e4[e4.length - 1]));
              o2 = t3.domConverter.viewRangeToDom(n3);
            } else
              o2 = () => {
                const e4 = this._getSelectedLinkElement();
                return e4 ? t3.domConverter.mapViewToDom(e4) : t3.domConverter.viewRangeToDom(n2.selection.getFirstRange());
              };
            return { target: o2 };
          }
          _getSelectedLinkElement() {
            const t3 = this.editor.editing.view, e3 = t3.document.selection, n2 = e3.getSelectedElement();
            if (e3.isCollapsed || n2 && lb(n2))
              return _y(e3.getFirstPosition());
            {
              const n3 = e3.getFirstRange().getTrimmed(), o2 = _y(n3.start), i2 = _y(n3.end);
              return o2 && o2 == i2 && t3.createRangeIn(o2).getTrimmed().isEqual(n3) ? o2 : null;
            }
          }
          _showFakeVisualSelection() {
            const t3 = this.editor.model;
            t3.change((e3) => {
              const n2 = t3.document.selection.getFirstRange();
              if (t3.markers.has(Ay))
                e3.updateMarker(Ay, { range: n2 });
              else if (n2.start.isAtEnd) {
                const o2 = n2.start.getLastMatchingPosition(({ item: e4 }) => !t3.schema.isContent(e4), { boundaries: n2 });
                e3.addMarker(Ay, { usingOperation: false, affectsData: false, range: e3.createRange(o2, n2.end) });
              } else
                e3.addMarker(Ay, { usingOperation: false, affectsData: false, range: n2 });
            });
          }
          _hideFakeVisualSelection() {
            const t3 = this.editor.model;
            t3.markers.has(Ay) && t3.change((t4) => {
              t4.removeMarker(Ay);
            });
          }
        }
        function _y(t3) {
          return t3.getAncestors().find((t4) => {
            return (e3 = t4).is("attributeElement") && !!e3.getCustomProperty("link");
            var e3;
          }) || null;
        }
        const vy = new RegExp("(^|\\s)(((?:(?:(?:https?|ftp):)?\\/\\/)(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(((?!www\\.)|(www\\.))(?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.)+(?:[a-z\\u00a1-\\uffff]{2,63})))(?::\\d{2,5})?(?:[/?#]\\S*)?)|((www.|(\\S+@))((?![-_])(?:[-_a-z0-9\\u00a1-\\uffff]{1,63}\\.))+(?:[a-z\\u00a1-\\uffff]{2,63})))$", "i");
        class yy extends es {
          static get requires() {
            return [Ek, gy];
          }
          static get pluginName() {
            return "AutoLink";
          }
          init() {
            const t3 = this.editor.model.document.selection;
            t3.on("change:range", () => {
              this.isEnabled = !t3.anchor.parent.is("element", "codeBlock");
            }), this._enableTypingHandling();
          }
          afterInit() {
            this._enableEnterHandling(), this._enableShiftEnterHandling(), this._enablePasteLinking();
          }
          _expandLinkRange(t3, e3) {
            return e3.textNode && e3.textNode.hasAttribute("linkHref") ? qk(e3, "linkHref", e3.textNode.getAttribute("linkHref"), t3) : null;
          }
          _selectEntireLinks(t3, e3) {
            const n2 = this.editor.model, o2 = n2.document.selection, i2 = o2.getFirstPosition(), r2 = o2.getLastPosition();
            let s3 = e3.getJoined(this._expandLinkRange(n2, i2) || e3);
            s3 && (s3 = s3.getJoined(this._expandLinkRange(n2, r2) || e3)), s3 && (s3.start.isBefore(i2) || s3.end.isAfter(r2)) && t3.setSelection(s3);
          }
          _enablePasteLinking() {
            const t3 = this.editor, e3 = t3.model, n2 = e3.document.selection, o2 = t3.plugins.get("ClipboardPipeline"), i2 = t3.commands.get("link");
            o2.on("inputTransformation", (t4, o3) => {
              if (!this.isEnabled || !i2.isEnabled || n2.isCollapsed)
                return;
              if (n2.rangeCount > 1)
                return;
              const r2 = n2.getFirstRange(), s3 = o3.dataTransfer.getData("text/plain");
              if (!s3)
                return;
              const a2 = s3.match(vy);
              a2 && a2[2] === s3 && (e3.change((t5) => {
                this._selectEntireLinks(t5, r2), i2.execute(s3);
              }), t4.stop());
            }, { priority: "high" });
          }
          _enableTypingHandling() {
            const t3 = this.editor, e3 = new Sk(t3.model, (t4) => {
              if (!function(t5) {
                return t5.length > 4 && " " === t5[t5.length - 1] && " " !== t5[t5.length - 2];
              }(t4))
                return;
              const e4 = xy(t4.substr(0, t4.length - 1));
              return e4 ? { url: e4 } : void 0;
            });
            e3.on("matched:data", (e4, n2) => {
              const { batch: o2, range: i2, url: r2 } = n2;
              if (!o2.isTyping)
                return;
              const s3 = i2.end.getShiftedBy(-1), a2 = s3.getShiftedBy(-r2.length), c2 = t3.model.createRange(a2, s3);
              this._applyAutoLink(r2, c2);
            }), e3.bind("isEnabled").to(this);
          }
          _enableEnterHandling() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.commands.get("enter");
            n2 && n2.on("execute", () => {
              const t4 = e3.document.selection.getFirstPosition();
              if (!t4.parent.previousSibling)
                return;
              const n3 = e3.createRangeIn(t4.parent.previousSibling);
              this._checkAndApplyAutoLinkOnRange(n3);
            });
          }
          _enableShiftEnterHandling() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.commands.get("shiftEnter");
            n2 && n2.on("execute", () => {
              const t4 = e3.document.selection.getFirstPosition(), n3 = e3.createRange(e3.createPositionAt(t4.parent, 0), t4.getShiftedBy(-1));
              this._checkAndApplyAutoLinkOnRange(n3);
            });
          }
          _checkAndApplyAutoLinkOnRange(t3) {
            const e3 = this.editor.model, { text: n2, range: o2 } = Ik(t3, e3), i2 = xy(n2);
            if (i2) {
              const t4 = e3.createRange(o2.end.getShiftedBy(-i2.length), o2.end);
              this._applyAutoLink(i2, t4);
            }
          }
          _applyAutoLink(t3, e3) {
            const n2 = this.editor.model, o2 = $v(t3, this.editor.config.get("link.defaultProtocol"));
            this.isEnabled && function(t4, e4) {
              return e4.schema.checkAttributeInSelection(e4.createSelection(t4), "linkHref");
            }(e3, n2) && Qv(o2) && !function(t4) {
              const e4 = t4.start.nodeAfter;
              return !!e4 && e4.hasAttribute("linkHref");
            }(e3) && this._persistAutoLink(o2, e3);
          }
          _persistAutoLink(t3, e3) {
            const n2 = this.editor.model, o2 = this.editor.plugins.get("Delete");
            n2.enqueueChange((i2) => {
              i2.setAttribute("linkHref", t3, e3), n2.enqueueChange(() => {
                o2.requestUndoOnBackspace();
              });
            });
          }
        }
        function xy(t3) {
          const e3 = vy.exec(t3);
          return e3 ? e3[2] : null;
        }
        var Ey = n(111), Dy = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Ey.Z, Dy);
        Ey.Z.locals;
        Symbol.iterator;
        Symbol.iterator;
        Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        var Iy = n(5730), Sy = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Iy.Z, Sy);
        Iy.Z.locals;
        var Ty = n(4564), My = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Ty.Z, My);
        Ty.Z.locals;
        function By(t3, e3) {
          const n2 = e3.mapper, o2 = e3.writer, i2 = "numbered" == t3.getAttribute("listType") ? "ol" : "ul", r2 = function(t4) {
            const e4 = t4.createContainerElement("li");
            return e4.getFillerOffset = Vy, e4;
          }(o2), s3 = o2.createContainerElement(i2, null);
          return o2.insert(o2.createPositionAt(s3, 0), r2), n2.bindElements(t3, r2), r2;
        }
        function Ny(t3, e3, n2, o2) {
          const i2 = e3.parent, r2 = n2.mapper, s3 = n2.writer;
          let a2 = r2.toViewPosition(o2.createPositionBefore(t3));
          const c2 = Oy(t3.previousSibling, { sameIndent: true, smallerIndent: true, listIndent: t3.getAttribute("listIndent") }), l2 = t3.previousSibling;
          if (c2 && c2.getAttribute("listIndent") == t3.getAttribute("listIndent")) {
            const t4 = r2.toViewElement(c2);
            a2 = s3.breakContainer(s3.createPositionAfter(t4));
          } else if (l2 && "listItem" == l2.name) {
            a2 = r2.toViewPosition(o2.createPositionAt(l2, "end"));
            const t4 = r2.findMappedViewAncestor(a2), e4 = function(t5) {
              for (const e5 of t5.getChildren())
                if ("ul" == e5.name || "ol" == e5.name)
                  return e5;
              return null;
            }(t4);
            a2 = e4 ? s3.createPositionBefore(e4) : s3.createPositionAt(t4, "end");
          } else
            a2 = r2.toViewPosition(o2.createPositionBefore(t3));
          if (a2 = zy(a2), s3.insert(a2, i2), l2 && "listItem" == l2.name) {
            const t4 = r2.toViewElement(l2), n3 = s3.createRange(s3.createPositionAt(t4, 0), a2).getWalker({ ignoreElementEnd: true });
            for (const t5 of n3)
              if (t5.item.is("element", "li")) {
                const o3 = s3.breakContainer(s3.createPositionBefore(t5.item)), i3 = t5.item.parent, r3 = s3.createPositionAt(e3, "end");
                Py(s3, r3.nodeBefore, r3.nodeAfter), s3.move(s3.createRangeOn(i3), r3), n3._position = o3;
              }
          } else {
            const n3 = i2.nextSibling;
            if (n3 && (n3.is("element", "ul") || n3.is("element", "ol"))) {
              let o3 = null;
              for (const e4 of n3.getChildren()) {
                const n4 = r2.toModelElement(e4);
                if (!(n4 && n4.getAttribute("listIndent") > t3.getAttribute("listIndent")))
                  break;
                o3 = e4;
              }
              o3 && (s3.breakContainer(s3.createPositionAfter(o3)), s3.move(s3.createRangeOn(o3.parent), s3.createPositionAt(e3, "end")));
            }
          }
          Py(s3, i2, i2.nextSibling), Py(s3, i2.previousSibling, i2);
        }
        function Py(t3, e3, n2) {
          return !e3 || !n2 || "ul" != e3.name && "ol" != e3.name || e3.name != n2.name || e3.getAttribute("class") !== n2.getAttribute("class") ? null : t3.mergeContainers(t3.createPositionAfter(e3));
        }
        function zy(t3) {
          return t3.getLastMatchingPosition((t4) => t4.item.is("uiElement"));
        }
        function Oy(t3, e3) {
          const n2 = !!e3.sameIndent, o2 = !!e3.smallerIndent, i2 = e3.listIndent;
          let r2 = t3;
          for (; r2 && "listItem" == r2.name; ) {
            const t4 = r2.getAttribute("listIndent");
            if (n2 && i2 == t4 || o2 && i2 > t4)
              return r2;
            r2 = "forward" === e3.direction ? r2.nextSibling : r2.previousSibling;
          }
          return null;
        }
        function Ly(t3, e3, n2, o2) {
          t3.ui.componentFactory.add(e3, (i2) => {
            const r2 = t3.commands.get(e3), s3 = new br(i2);
            return s3.set({ label: n2, icon: o2, tooltip: true, isToggleable: true }), s3.bind("isOn", "isEnabled").to(r2, "value", "isEnabled"), s3.on("execute", () => {
              t3.execute(e3), t3.editing.view.focus();
            }), s3;
          });
        }
        function Ry(t3, e3) {
          const n2 = [], o2 = t3.parent, i2 = { ignoreElementEnd: false, startPosition: t3, shallow: true, direction: e3 }, r2 = o2.getAttribute("listIndent"), s3 = [...new ql(i2)].filter((t4) => t4.item.is("element")).map((t4) => t4.item);
          for (const t4 of s3) {
            if (!t4.is("element", "listItem"))
              break;
            if (t4.getAttribute("listIndent") < r2)
              break;
            if (!(t4.getAttribute("listIndent") > r2)) {
              if (t4.getAttribute("listType") !== o2.getAttribute("listType"))
                break;
              if (t4.getAttribute("listStyle") !== o2.getAttribute("listStyle"))
                break;
              if (t4.getAttribute("listReversed") !== o2.getAttribute("listReversed"))
                break;
              if (t4.getAttribute("listStart") !== o2.getAttribute("listStart"))
                break;
              "backward" === e3 ? n2.unshift(t4) : n2.push(t4);
            }
          }
          return n2;
        }
        const jy = ["disc", "circle", "square"], Fy = ["decimal", "decimal-leading-zero", "lower-roman", "upper-roman", "lower-latin", "upper-latin"];
        function Vy() {
          const t3 = !this.isEmpty && ("ul" == this.getChild(0).name || "ol" == this.getChild(0).name);
          return this.isEmpty || t3 ? 0 : Da.call(this);
        }
        class Uy extends es {
          static get pluginName() {
            return "ListUI";
          }
          init() {
            const t3 = this.editor.t;
            Ly(this.editor, "numberedList", t3("Numbered List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zM3.5 3v5H2V3.7H1v-1h2.5V3zM.343 17.857l2.59-3.257H2.92a.6.6 0 1 0-1.04 0H.302a2 2 0 1 1 3.995 0h-.001c-.048.405-.16.734-.333.988-.175.254-.59.692-1.244 1.312H4.3v1h-4l.043-.043zM7 14.75a.75.75 0 0 1 .75-.75h9.5a.75.75 0 1 1 0 1.5h-9.5a.75.75 0 0 1-.75-.75z"/></svg>'), Ly(this.editor, "bulletedList", t3("Bulleted List"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M7 5.75c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0C1 4.784 1.777 4 2.75 4c.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75C1.784 7.5 1 6.723 1 5.75zm6 9c0 .414.336.75.75.75h9.5a.75.75 0 1 0 0-1.5h-9.5a.75.75 0 0 0-.75.75zm-6 0c0-.966.777-1.75 1.75-1.75.966 0 1.75.777 1.75 1.75 0 .966-.777 1.75-1.75 1.75-.966 0-1.75-.777-1.75-1.75z"/></svg>');
          }
        }
        const Hy = {}, qy = {}, Gy = {}, Wy = [{ listStyle: "disc", typeAttribute: "disc", listType: "bulleted" }, { listStyle: "circle", typeAttribute: "circle", listType: "bulleted" }, { listStyle: "square", typeAttribute: "square", listType: "bulleted" }, { listStyle: "decimal", typeAttribute: "1", listType: "numbered" }, { listStyle: "decimal-leading-zero", typeAttribute: null, listType: "numbered" }, { listStyle: "lower-roman", typeAttribute: "i", listType: "numbered" }, { listStyle: "upper-roman", typeAttribute: "I", listType: "numbered" }, { listStyle: "lower-alpha", typeAttribute: "a", listType: "numbered" }, { listStyle: "upper-alpha", typeAttribute: "A", listType: "numbered" }, { listStyle: "lower-latin", typeAttribute: "a", listType: "numbered" }, { listStyle: "upper-latin", typeAttribute: "A", listType: "numbered" }];
        for (const { listStyle: t3, typeAttribute: e3, listType: n2 } of Wy)
          Hy[t3] = n2, qy[t3] = e3, e3 && (Gy[e3] = t3);
        var Ky = n(6082), Zy = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Ky.Z, Zy);
        Ky.Z.locals;
        var Yy = n(2417), $y = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Yy.Z, $y);
        Yy.Z.locals;
        class Qy extends os {
          constructor(t3, e3) {
            super(t3), this._indentBy = "forward" == e3 ? 1 : -1;
          }
          refresh() {
            this.isEnabled = this._checkEnabled();
          }
          execute() {
            const t3 = this.editor.model, e3 = t3.document;
            let n2 = Array.from(e3.selection.getSelectedBlocks());
            t3.change((t4) => {
              const e4 = n2[n2.length - 1];
              let o2 = e4.nextSibling;
              for (; o2 && "listItem" == o2.name && o2.getAttribute("listIndent") > e4.getAttribute("listIndent"); )
                n2.push(o2), o2 = o2.nextSibling;
              this._indentBy < 0 && (n2 = n2.reverse());
              for (const e5 of n2) {
                const n3 = e5.getAttribute("listIndent") + this._indentBy;
                n3 < 0 ? t4.rename(e5, "paragraph") : t4.setAttribute("listIndent", n3, e5);
              }
              this.fire("_executeCleanup", n2);
            });
          }
          _checkEnabled() {
            const t3 = Ii(this.editor.model.document.selection.getSelectedBlocks());
            if (!t3 || !t3.is("element", "listItem"))
              return false;
            if (this._indentBy > 0) {
              const e3 = t3.getAttribute("listIndent"), n2 = t3.getAttribute("listType");
              let o2 = t3.previousSibling;
              for (; o2 && o2.is("element", "listItem") && o2.getAttribute("listIndent") >= e3; ) {
                if (o2.getAttribute("listIndent") == e3)
                  return o2.getAttribute("listType") == n2;
                o2 = o2.previousSibling;
              }
              return false;
            }
            return true;
          }
        }
        class Jy extends os {
          constructor(t3, e3) {
            super(t3), this.type = e3;
          }
          refresh() {
            this.value = this._getValue(), this.isEnabled = this._checkEnabled();
          }
          execute(t3 = {}) {
            const e3 = this.editor.model, n2 = e3.document, o2 = Array.from(n2.selection.getSelectedBlocks()).filter((t4) => tx(t4, e3.schema)), i2 = void 0 !== t3.forceValue ? !t3.forceValue : this.value;
            e3.change((t4) => {
              if (i2) {
                let e4 = o2[o2.length - 1].nextSibling, n3 = Number.POSITIVE_INFINITY, i3 = [];
                for (; e4 && "listItem" == e4.name && 0 !== e4.getAttribute("listIndent"); ) {
                  const t5 = e4.getAttribute("listIndent");
                  t5 < n3 && (n3 = t5);
                  const o3 = t5 - n3;
                  i3.push({ element: e4, listIndent: o3 }), e4 = e4.nextSibling;
                }
                i3 = i3.reverse();
                for (const e5 of i3)
                  t4.setAttribute("listIndent", e5.listIndent, e5.element);
              }
              if (!i2) {
                let t5 = Number.POSITIVE_INFINITY;
                for (const e4 of o2)
                  e4.is("element", "listItem") && e4.getAttribute("listIndent") < t5 && (t5 = e4.getAttribute("listIndent"));
                t5 = 0 === t5 ? 1 : t5, Xy(o2, true, t5), Xy(o2, false, t5);
              }
              for (const e4 of o2.reverse())
                i2 && "listItem" == e4.name ? t4.rename(e4, "paragraph") : i2 || "listItem" == e4.name ? i2 || "listItem" != e4.name || e4.getAttribute("listType") == this.type || t4.setAttribute("listType", this.type, e4) : (t4.setAttributes({ listType: this.type, listIndent: 0 }, e4), t4.rename(e4, "listItem"));
              this.fire("_executeCleanup", o2);
            });
          }
          _getValue() {
            const t3 = Ii(this.editor.model.document.selection.getSelectedBlocks());
            return !!t3 && t3.is("element", "listItem") && t3.getAttribute("listType") == this.type;
          }
          _checkEnabled() {
            if (this.value)
              return true;
            const t3 = this.editor.model.document.selection, e3 = this.editor.model.schema, n2 = Ii(t3.getSelectedBlocks());
            return !!n2 && tx(n2, e3);
          }
        }
        function Xy(t3, e3, n2) {
          const o2 = e3 ? t3[0] : t3[t3.length - 1];
          if (o2.is("element", "listItem")) {
            let i2 = o2[e3 ? "previousSibling" : "nextSibling"], r2 = o2.getAttribute("listIndent");
            for (; i2 && i2.is("element", "listItem") && i2.getAttribute("listIndent") >= n2; )
              r2 > i2.getAttribute("listIndent") && (r2 = i2.getAttribute("listIndent")), i2.getAttribute("listIndent") == r2 && t3[e3 ? "unshift" : "push"](i2), i2 = i2[e3 ? "previousSibling" : "nextSibling"];
          }
        }
        function tx(t3, e3) {
          return e3.checkChild(t3.parent, "listItem") && !e3.isObject(t3);
        }
        class ex extends es {
          static get pluginName() {
            return "ListUtils";
          }
          getListTypeFromListStyleType(t3) {
            return function(t4) {
              return jy.includes(t4) ? "bulleted" : Fy.includes(t4) ? "numbered" : null;
            }(t3);
          }
          getSelectedListItems(t3) {
            return function(t4) {
              let e3 = [...t4.document.selection.getSelectedBlocks()].filter((t5) => t5.is("element", "listItem")).map((e4) => {
                const n2 = t4.change((t5) => t5.createPositionAt(e4, 0));
                return [...Ry(n2, "backward"), ...Ry(n2, "forward")];
              }).flat();
              return e3 = [...new Set(e3)], e3;
            }(t3);
          }
          getSiblingNodes(t3, e3) {
            return Ry(t3, e3);
          }
        }
        function nx(t3) {
          return (e3, n2, o2) => {
            const i2 = o2.consumable;
            if (!i2.test(n2.item, "insert") || !i2.test(n2.item, "attribute:listType") || !i2.test(n2.item, "attribute:listIndent"))
              return;
            i2.consume(n2.item, "insert"), i2.consume(n2.item, "attribute:listType"), i2.consume(n2.item, "attribute:listIndent");
            const r2 = n2.item;
            Ny(r2, By(r2, o2), o2, t3);
          };
        }
        const ox = (t3, e3, n2) => {
          if (!n2.consumable.test(e3.item, t3.name))
            return;
          const o2 = n2.mapper.toViewElement(e3.item), i2 = n2.writer;
          i2.breakContainer(i2.createPositionBefore(o2)), i2.breakContainer(i2.createPositionAfter(o2));
          const r2 = o2.parent, s3 = "numbered" == e3.attributeNewValue ? "ol" : "ul";
          i2.rename(s3, r2);
        }, ix = (t3, e3, n2) => {
          n2.consumable.consume(e3.item, t3.name);
          const o2 = n2.mapper.toViewElement(e3.item).parent, i2 = n2.writer;
          Py(i2, o2, o2.nextSibling), Py(i2, o2.previousSibling, o2);
        };
        const rx = (t3, e3, n2) => {
          if (n2.consumable.test(e3.item, t3.name) && "listItem" != e3.item.name) {
            let t4 = n2.mapper.toViewPosition(e3.range.start);
            const o2 = n2.writer, i2 = [];
            for (; ("ul" == t4.parent.name || "ol" == t4.parent.name) && (t4 = o2.breakContainer(t4), "li" == t4.parent.name); ) {
              const e4 = t4, n3 = o2.createPositionAt(t4.parent, "end");
              if (!e4.isEqual(n3)) {
                const t5 = o2.remove(o2.createRange(e4, n3));
                i2.push(t5);
              }
              t4 = o2.createPositionAfter(t4.parent);
            }
            if (i2.length > 0) {
              for (let e4 = 0; e4 < i2.length; e4++) {
                const n3 = t4.nodeBefore;
                if (t4 = o2.insert(t4, i2[e4]).end, e4 > 0) {
                  const e5 = Py(o2, n3, n3.nextSibling);
                  e5 && e5.parent == n3 && t4.offset--;
                }
              }
              Py(o2, t4.nodeBefore, t4.nodeAfter);
            }
          }
        }, sx = (t3, e3, n2) => {
          const o2 = n2.mapper.toViewPosition(e3.position), i2 = o2.nodeBefore, r2 = o2.nodeAfter;
          Py(n2.writer, i2, r2);
        }, ax = (t3, e3, n2) => {
          if (n2.consumable.consume(e3.viewItem, { name: true })) {
            const t4 = n2.writer, o2 = t4.createElement("listItem"), i2 = function(t5) {
              let e4 = 0, n3 = t5.parent;
              for (; n3; ) {
                if (n3.is("element", "li"))
                  e4++;
                else {
                  const t6 = n3.previousSibling;
                  t6 && t6.is("element", "li") && e4++;
                }
                n3 = n3.parent;
              }
              return e4;
            }(e3.viewItem);
            t4.setAttribute("listIndent", i2, o2);
            const r2 = e3.viewItem.parent && "ol" == e3.viewItem.parent.name ? "numbered" : "bulleted";
            if (t4.setAttribute("listType", r2, o2), !n2.safeInsert(o2, e3.modelCursor))
              return;
            const s3 = function(t5, e4, n3) {
              const { writer: o3, schema: i3 } = n3;
              let r3 = o3.createPositionAfter(t5);
              for (const s4 of e4)
                if ("ul" == s4.name || "ol" == s4.name)
                  r3 = n3.convertItem(s4, r3).modelCursor;
                else {
                  const e5 = n3.convertItem(s4, o3.createPositionAt(t5, "end")), a2 = e5.modelRange.start.nodeAfter;
                  a2 && a2.is("element") && !i3.checkChild(t5, a2.name) && (t5 = e5.modelCursor.parent.is("element", "listItem") ? e5.modelCursor.parent : ux(e5.modelCursor), r3 = o3.createPositionAfter(t5));
                }
              return r3;
            }(o2, e3.viewItem.getChildren(), n2);
            e3.modelRange = t4.createRange(e3.modelCursor, s3), n2.updateConversionResult(o2, e3);
          }
        }, cx = (t3, e3, n2) => {
          if (n2.consumable.test(e3.viewItem, { name: true })) {
            const t4 = Array.from(e3.viewItem.getChildren());
            for (const e4 of t4) {
              !(e4.is("element", "li") || px(e4)) && e4._remove();
            }
          }
        }, lx = (t3, e3, n2) => {
          if (n2.consumable.test(e3.viewItem, { name: true })) {
            if (0 === e3.viewItem.childCount)
              return;
            const t4 = [...e3.viewItem.getChildren()];
            let n3 = false;
            for (const e4 of t4)
              n3 && !px(e4) && e4._remove(), px(e4) && (n3 = true);
          }
        };
        function dx(t3) {
          return (e3, n2) => {
            if (n2.isPhantom)
              return;
            const o2 = n2.modelPosition.nodeBefore;
            if (o2 && o2.is("element", "listItem")) {
              const e4 = n2.mapper.toViewElement(o2), i2 = e4.getAncestors().find(px), r2 = t3.createPositionAt(e4, 0).getWalker();
              for (const t4 of r2) {
                if ("elementStart" == t4.type && t4.item.is("element", "li")) {
                  n2.viewPosition = t4.previousPosition;
                  break;
                }
                if ("elementEnd" == t4.type && t4.item == i2) {
                  n2.viewPosition = t4.nextPosition;
                  break;
                }
              }
            }
          };
        }
        const hx = function(t3, [e3, n2]) {
          const o2 = this;
          let i2, r2 = e3.is("documentFragment") ? e3.getChild(0) : e3;
          if (i2 = n2 ? o2.createSelection(n2) : o2.document.selection, r2 && r2.is("element", "listItem")) {
            const t4 = i2.getFirstPosition();
            let e4 = null;
            if (t4.parent.is("element", "listItem") ? e4 = t4.parent : t4.nodeBefore && t4.nodeBefore.is("element", "listItem") && (e4 = t4.nodeBefore), e4) {
              const t5 = e4.getAttribute("listIndent");
              if (t5 > 0)
                for (; r2 && r2.is("element", "listItem"); )
                  r2._setAttribute("listIndent", r2.getAttribute("listIndent") + t5), r2 = r2.nextSibling;
            }
          }
        };
        function ux(t3) {
          const e3 = new ql({ startPosition: t3 });
          let n2;
          do {
            n2 = e3.next();
          } while (!n2.value.item.is("element", "listItem"));
          return n2.value.item;
        }
        function gx(t3, e3, n2, o2, i2, r2) {
          const s3 = Oy(e3.nodeBefore, { sameIndent: true, smallerIndent: true, listIndent: t3 }), a2 = i2.mapper, c2 = i2.writer, l2 = s3 ? s3.getAttribute("listIndent") : null;
          let d2;
          if (s3)
            if (l2 == t3) {
              const t4 = a2.toViewElement(s3).parent;
              d2 = c2.createPositionAfter(t4);
            } else {
              const t4 = r2.createPositionAt(s3, "end");
              d2 = a2.toViewPosition(t4);
            }
          else
            d2 = n2;
          d2 = zy(d2);
          for (const t4 of [...o2.getChildren()])
            px(t4) && (d2 = c2.move(c2.createRangeOn(t4), d2).end, Py(c2, t4, t4.nextSibling), Py(c2, t4.previousSibling, t4));
        }
        function px(t3) {
          return t3.is("element", "ol") || t3.is("element", "ul");
        }
        class mx extends es {
          static get pluginName() {
            return "ListEditing";
          }
          static get requires() {
            return [Qk, Ek, ex];
          }
          init() {
            const t3 = this.editor;
            t3.model.schema.register("listItem", { inheritAllFrom: "$block", allowAttributes: ["listType", "listIndent"] });
            const e3 = t3.data, n2 = t3.editing;
            var o2;
            t3.model.document.registerPostFixer((e4) => function(t4, e5) {
              const n3 = t4.document.differ.getChanges(), o3 = /* @__PURE__ */ new Map();
              let i3 = false;
              for (const o4 of n3)
                if ("insert" == o4.type && "listItem" == o4.name)
                  r2(o4.position);
                else if ("insert" == o4.type && "listItem" != o4.name) {
                  if ("$text" != o4.name) {
                    const n4 = o4.position.nodeAfter;
                    n4.hasAttribute("listIndent") && (e5.removeAttribute("listIndent", n4), i3 = true), n4.hasAttribute("listType") && (e5.removeAttribute("listType", n4), i3 = true), n4.hasAttribute("listStyle") && (e5.removeAttribute("listStyle", n4), i3 = true), n4.hasAttribute("listReversed") && (e5.removeAttribute("listReversed", n4), i3 = true), n4.hasAttribute("listStart") && (e5.removeAttribute("listStart", n4), i3 = true);
                    for (const e6 of Array.from(t4.createRangeIn(n4)).filter((t5) => t5.item.is("element", "listItem")))
                      r2(e6.previousPosition);
                  }
                  r2(o4.position.getShiftedBy(o4.length));
                } else
                  "remove" == o4.type && "listItem" == o4.name ? r2(o4.position) : ("attribute" == o4.type && "listIndent" == o4.attributeKey || "attribute" == o4.type && "listType" == o4.attributeKey) && r2(o4.range.start);
              for (const t5 of o3.values())
                s3(t5), a2(t5);
              return i3;
              function r2(t5) {
                const e6 = t5.nodeBefore;
                if (e6 && e6.is("element", "listItem")) {
                  let t6 = e6;
                  if (o3.has(t6))
                    return;
                  for (let e7 = t6.previousSibling; e7 && e7.is("element", "listItem"); e7 = t6.previousSibling)
                    if (t6 = e7, o3.has(t6))
                      return;
                  o3.set(e6, t6);
                } else {
                  const e7 = t5.nodeAfter;
                  e7 && e7.is("element", "listItem") && o3.set(e7, e7);
                }
              }
              function s3(t5) {
                let n4 = 0, o4 = null;
                for (; t5 && t5.is("element", "listItem"); ) {
                  const r3 = t5.getAttribute("listIndent");
                  if (r3 > n4) {
                    let s4;
                    null === o4 ? (o4 = r3 - n4, s4 = n4) : (o4 > r3 && (o4 = r3), s4 = r3 - o4), e5.setAttribute("listIndent", s4, t5), i3 = true;
                  } else
                    o4 = null, n4 = t5.getAttribute("listIndent") + 1;
                  t5 = t5.nextSibling;
                }
              }
              function a2(t5) {
                let n4 = [], o4 = null;
                for (; t5 && t5.is("element", "listItem"); ) {
                  const r3 = t5.getAttribute("listIndent");
                  if (o4 && o4.getAttribute("listIndent") > r3 && (n4 = n4.slice(0, r3 + 1)), 0 != r3)
                    if (n4[r3]) {
                      const o5 = n4[r3];
                      t5.getAttribute("listType") != o5 && (e5.setAttribute("listType", o5, t5), i3 = true);
                    } else
                      n4[r3] = t5.getAttribute("listType");
                  o4 = t5, t5 = t5.nextSibling;
                }
              }
            }(t3.model, e4)), n2.mapper.registerViewToModelLength("li", fx), e3.mapper.registerViewToModelLength("li", fx), n2.mapper.on("modelToViewPosition", dx(n2.view)), n2.mapper.on("viewToModelPosition", (o2 = t3.model, (t4, e4) => {
              const n3 = e4.viewPosition, i3 = n3.parent, r2 = e4.mapper;
              if ("ul" == i3.name || "ol" == i3.name) {
                if (n3.isAtEnd) {
                  const t5 = r2.toModelElement(n3.nodeBefore), i4 = r2.getModelLength(n3.nodeBefore);
                  e4.modelPosition = o2.createPositionBefore(t5).getShiftedBy(i4);
                } else {
                  const t5 = r2.toModelElement(n3.nodeAfter);
                  e4.modelPosition = o2.createPositionBefore(t5);
                }
                t4.stop();
              } else if ("li" == i3.name && n3.nodeBefore && ("ul" == n3.nodeBefore.name || "ol" == n3.nodeBefore.name)) {
                const s3 = r2.toModelElement(i3);
                let a2 = 1, c2 = n3.nodeBefore;
                for (; c2 && px(c2); )
                  a2 += r2.getModelLength(c2), c2 = c2.previousSibling;
                e4.modelPosition = o2.createPositionBefore(s3).getShiftedBy(a2), t4.stop();
              }
            })), e3.mapper.on("modelToViewPosition", dx(n2.view)), t3.conversion.for("editingDowncast").add((e4) => {
              e4.on("insert", rx, { priority: "high" }), e4.on("insert:listItem", nx(t3.model)), e4.on("attribute:listType:listItem", ox, { priority: "high" }), e4.on("attribute:listType:listItem", ix, { priority: "low" }), e4.on("attribute:listIndent:listItem", function(t4) {
                return (e5, n3, o3) => {
                  if (!o3.consumable.consume(n3.item, "attribute:listIndent"))
                    return;
                  const i3 = o3.mapper.toViewElement(n3.item), r2 = o3.writer;
                  r2.breakContainer(r2.createPositionBefore(i3)), r2.breakContainer(r2.createPositionAfter(i3));
                  const s3 = i3.parent, a2 = s3.previousSibling, c2 = r2.createRangeOn(s3);
                  r2.remove(c2), a2 && a2.nextSibling && Py(r2, a2, a2.nextSibling), gx(n3.attributeOldValue + 1, n3.range.start, c2.start, i3, o3, t4), Ny(n3.item, i3, o3, t4);
                  for (const t5 of n3.item.getChildren())
                    o3.consumable.consume(t5, "insert");
                };
              }(t3.model)), e4.on("remove:listItem", function(t4) {
                return (e5, n3, o3) => {
                  const i3 = o3.mapper.toViewPosition(n3.position).getLastMatchingPosition((t5) => !t5.item.is("element", "li")).nodeAfter, r2 = o3.writer;
                  r2.breakContainer(r2.createPositionBefore(i3)), r2.breakContainer(r2.createPositionAfter(i3));
                  const s3 = i3.parent, a2 = s3.previousSibling, c2 = r2.createRangeOn(s3), l2 = r2.remove(c2);
                  a2 && a2.nextSibling && Py(r2, a2, a2.nextSibling), gx(o3.mapper.toModelElement(i3).getAttribute("listIndent") + 1, n3.position, c2.start, i3, o3, t4);
                  for (const t5 of r2.createRangeIn(l2).getItems())
                    o3.mapper.unbindViewElement(t5);
                  e5.stop();
                };
              }(t3.model)), e4.on("remove", sx, { priority: "low" });
            }), t3.conversion.for("dataDowncast").add((e4) => {
              e4.on("insert", rx, { priority: "high" }), e4.on("insert:listItem", nx(t3.model));
            }), t3.conversion.for("upcast").add((t4) => {
              t4.on("element:ul", cx, { priority: "high" }), t4.on("element:ol", cx, { priority: "high" }), t4.on("element:li", lx, { priority: "high" }), t4.on("element:li", ax);
            }), t3.model.on("insertContent", hx, { priority: "high" }), t3.commands.add("numberedList", new Jy(t3, "numbered")), t3.commands.add("bulletedList", new Jy(t3, "bulleted")), t3.commands.add("indentList", new Qy(t3, "forward")), t3.commands.add("outdentList", new Qy(t3, "backward"));
            const i2 = n2.view.document;
            this.listenTo(i2, "enter", (t4, e4) => {
              const n3 = this.editor.model.document, o3 = n3.selection.getLastPosition().parent;
              n3.selection.isCollapsed && "listItem" == o3.name && o3.isEmpty && (this.editor.execute("outdentList"), e4.preventDefault(), t4.stop());
            }, { context: "li" }), this.listenTo(i2, "delete", (t4, e4) => {
              if ("backward" !== e4.direction)
                return;
              const n3 = this.editor.model.document.selection;
              if (!n3.isCollapsed)
                return;
              const o3 = n3.getFirstPosition();
              if (!o3.isAtStart)
                return;
              const i3 = o3.parent;
              if ("listItem" !== i3.name)
                return;
              i3.previousSibling && "listItem" === i3.previousSibling.name || (this.editor.execute("outdentList"), e4.preventDefault(), t4.stop());
            }, { context: "li" }), this.listenTo(t3.editing.view.document, "tab", (e4, n3) => {
              const o3 = n3.shiftKey ? "outdentList" : "indentList";
              this.editor.commands.get(o3).isEnabled && (t3.execute(o3), n3.stopPropagation(), n3.preventDefault(), e4.stop());
            }, { context: "li" });
          }
          afterInit() {
            const t3 = this.editor.commands, e3 = t3.get("indent"), n2 = t3.get("outdent");
            e3 && e3.registerChildCommand(t3.get("indentList")), n2 && n2.registerChildCommand(t3.get("outdentList"));
          }
        }
        function fx(t3) {
          let e3 = 1;
          for (const n2 of t3.getChildren())
            if ("ul" == n2.name || "ol" == n2.name)
              for (const t4 of n2.getChildren())
                e3 += fx(t4);
          return e3;
        }
        wi("Ctrl+Enter");
        var kx = n(1199), bx = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(kx.Z, bx);
        kx.Z.locals;
        Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        wi("Ctrl+Enter");
        function wx(t3, e3) {
          const n2 = (n3, o2, i2) => {
            if (!i2.consumable.consume(o2.item, n3.name))
              return;
            const r2 = o2.attributeNewValue, s3 = i2.writer, a2 = i2.mapper.toViewElement(o2.item), c2 = [...a2.getChildren()].find((t4) => t4.getCustomProperty("media-content"));
            s3.remove(c2);
            const l2 = t3.getMediaViewElement(s3, r2, e3);
            s3.insert(s3.createPositionAt(a2, 0), l2);
          };
          return (t4) => {
            t4.on("attribute:url:media", n2);
          };
        }
        function Ax(t3, e3, n2, o2) {
          return t3.createContainerElement("figure", { class: "media" }, [e3.getMediaViewElement(t3, n2, o2), t3.createSlot()]);
        }
        function Cx(t3) {
          const e3 = t3.getSelectedElement();
          return e3 && e3.is("element", "media") ? e3 : null;
        }
        function _x(t3, e3, n2, o2) {
          t3.change((i2) => {
            const r2 = i2.createElement("media", { url: e3 });
            t3.insertObject(r2, n2, null, { setSelection: "on", findOptimalPosition: o2 ? "auto" : void 0 });
          });
        }
        class vx extends os {
          refresh() {
            const t3 = this.editor.model, e3 = t3.document.selection, n2 = Cx(e3);
            this.value = n2 ? n2.getAttribute("url") : void 0, this.isEnabled = function(t4) {
              const e4 = t4.getSelectedElement();
              return !!e4 && "media" === e4.name;
            }(e3) || function(t4, e4) {
              const n3 = mb(t4, e4);
              let o2 = n3.start.parent;
              o2.isEmpty && !e4.schema.isLimit(o2) && (o2 = o2.parent);
              return e4.schema.checkChild(o2, "media");
            }(e3, t3);
          }
          execute(t3) {
            const e3 = this.editor.model, n2 = e3.document.selection, o2 = Cx(n2);
            o2 ? e3.change((e4) => {
              e4.setAttribute("url", t3, o2);
            }) : _x(e3, t3, n2, true);
          }
        }
        class yx {
          constructor(t3, e3) {
            const n2 = e3.providers, o2 = e3.extraProviders || [], i2 = new Set(e3.removeProviders), r2 = n2.concat(o2).filter((t4) => {
              const e4 = t4.name;
              return e4 ? !i2.has(e4) : (C("media-embed-no-provider-name", { provider: t4 }), false);
            });
            this.locale = t3, this.providerDefinitions = r2;
          }
          hasMedia(t3) {
            return !!this._getMedia(t3);
          }
          getMediaViewElement(t3, e3, n2) {
            return this._getMedia(e3).getViewElement(t3, n2);
          }
          _getMedia(t3) {
            if (!t3)
              return new xx(this.locale);
            t3 = t3.trim();
            for (const e3 of this.providerDefinitions) {
              const n2 = e3.html, o2 = _i(e3.url);
              for (const e4 of o2) {
                const o3 = this._getUrlMatches(t3, e4);
                if (o3)
                  return new xx(this.locale, t3, o3, n2);
              }
            }
            return null;
          }
          _getUrlMatches(t3, e3) {
            let n2 = t3.match(e3);
            if (n2)
              return n2;
            let o2 = t3.replace(/^https?:\/\//, "");
            return n2 = o2.match(e3), n2 || (o2 = o2.replace(/^www\./, ""), n2 = o2.match(e3), n2 || null);
          }
        }
        class xx {
          constructor(t3, e3, n2, o2) {
            this.url = this._getValidUrl(e3), this._locale = t3, this._match = n2, this._previewRenderer = o2;
          }
          getViewElement(t3, e3) {
            const n2 = {};
            let o2;
            if (e3.renderForEditingView || e3.renderMediaPreview && this.url && this._previewRenderer) {
              this.url && (n2["data-oembed-url"] = this.url), e3.renderForEditingView && (n2.class = "ck-media__wrapper");
              const i2 = this._getPreviewHtml(e3);
              o2 = t3.createRawElement("div", n2, (t4, e4) => {
                e4.setContentOf(t4, i2);
              });
            } else
              this.url && (n2.url = this.url), o2 = t3.createEmptyElement(e3.elementName, n2);
            return t3.setCustomProperty("media-content", true, o2), o2;
          }
          _getPreviewHtml(t3) {
            return this._previewRenderer ? this._previewRenderer(this._match) : this.url && t3.renderForEditingView ? this._getPlaceholderHtml() : "";
          }
          _getPlaceholderHtml() {
            const t3 = new pr(), e3 = this._locale.t;
            t3.content = '<svg viewBox="0 0 64 42" xmlns="http://www.w3.org/2000/svg"><path d="M47.426 17V3.713L63.102 0v19.389h-.001l.001.272c0 1.595-2.032 3.43-4.538 4.098-2.506.668-4.538-.083-4.538-1.678 0-1.594 2.032-3.43 4.538-4.098.914-.244 2.032-.565 2.888-.603V4.516L49.076 7.447v9.556A1.014 1.014 0 0 0 49 17h-1.574zM29.5 17h-8.343a7.073 7.073 0 1 0-4.657 4.06v3.781H3.3a2.803 2.803 0 0 1-2.8-2.804V8.63a2.803 2.803 0 0 1 2.8-2.805h4.082L8.58 2.768A1.994 1.994 0 0 1 10.435 1.5h8.985c.773 0 1.477.448 1.805 1.149l1.488 3.177H26.7c1.546 0 2.8 1.256 2.8 2.805V17zm-11.637 0H17.5a1 1 0 0 0-1 1v.05A4.244 4.244 0 1 1 17.863 17zm29.684 2c.97 0 .953-.048.953.889v20.743c0 .953.016.905-.953.905H19.453c-.97 0-.953.048-.953-.905V19.89c0-.937-.016-.889.97-.889h28.077zm-4.701 19.338V22.183H24.154v16.155h18.692zM20.6 21.375v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616v-1.616H20.6zm0 3.231v1.616h1.616V37.53H20.6zm24.233-16.155v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615v-1.616h-1.615zm0 3.231v1.616h1.615V37.53h-1.615zM29.485 25.283a.4.4 0 0 1 .593-.35l9.05 4.977a.4.4 0 0 1 0 .701l-9.05 4.978a.4.4 0 0 1-.593-.35v-9.956z"/></svg>', t3.viewBox = "0 0 64 42";
            return new Hi({ tag: "div", attributes: { class: "ck ck-reset_all ck-media__placeholder" }, children: [{ tag: "div", attributes: { class: "ck-media__placeholder__icon" }, children: [t3] }, { tag: "a", attributes: { class: "ck-media__placeholder__url", target: "_blank", rel: "noopener noreferrer", href: this.url, "data-cke-tooltip-text": e3("Open media in new tab") }, children: [{ tag: "span", attributes: { class: "ck-media__placeholder__url__text" }, children: [this.url] }] }] }).render().outerHTML;
          }
          _getValidUrl(t3) {
            return t3 ? t3.match(/^https?/) ? t3 : "https://" + t3 : null;
          }
        }
        var Ex = n(7442), Dx = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Ex.Z, Dx);
        Ex.Z.locals;
        class Ix extends es {
          constructor(t3) {
            super(t3), t3.config.define("mediaEmbed", { elementName: "oembed", providers: [{ name: "dailymotion", url: [/^dailymotion\.com\/video\/(\w+)/, /^dai.ly\/(\w+)/], html: (t4) => `<div style="position: relative; padding-bottom: 100%; height: 0; "><iframe src="https://www.dailymotion.com/embed/video/${t4[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" width="480" height="270" allowfullscreen allow="autoplay"></iframe></div>` }, { name: "spotify", url: [/^open\.spotify\.com\/(artist\/\w+)/, /^open\.spotify\.com\/(album\/\w+)/, /^open\.spotify\.com\/(track\/\w+)/], html: (t4) => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 126%;"><iframe src="https://open.spotify.com/embed/${t4[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allowtransparency="true" allow="encrypted-media"></iframe></div>` }, { name: "youtube", url: [/^(?:m\.)?youtube\.com\/watch\?v=([\w-]+)(?:&t=(\d+))?/, /^(?:m\.)?youtube\.com\/v\/([\w-]+)(?:\?t=(\d+))?/, /^youtube\.com\/embed\/([\w-]+)(?:\?start=(\d+))?/, /^youtu\.be\/([\w-]+)(?:\?t=(\d+))?/], html: (t4) => {
              const e3 = t4[1], n2 = t4[2];
              return `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://www.youtube.com/embed/${e3}${n2 ? `?start=${n2}` : ""}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div>`;
            } }, { name: "vimeo", url: [/^vimeo\.com\/(\d+)/, /^vimeo\.com\/[^/]+\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/album\/[^/]+\/video\/(\d+)/, /^vimeo\.com\/channels\/[^/]+\/(\d+)/, /^vimeo\.com\/groups\/[^/]+\/videos\/(\d+)/, /^vimeo\.com\/ondemand\/[^/]+\/(\d+)/, /^player\.vimeo\.com\/video\/(\d+)/], html: (t4) => `<div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;"><iframe src="https://player.vimeo.com/video/${t4[1]}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>` }, { name: "instagram", url: /^instagram\.com\/p\/(\w+)/ }, { name: "twitter", url: /^twitter\.com/ }, { name: "googleMaps", url: [/^google\.com\/maps/, /^goo\.gl\/maps/, /^maps\.google\.com/, /^maps\.app\.goo\.gl/] }, { name: "flickr", url: /^flickr\.com/ }, { name: "facebook", url: /^facebook\.com/ }] }), this.registry = new yx(t3.locale, t3.config.get("mediaEmbed"));
          }
          static get pluginName() {
            return "MediaEmbedEditing";
          }
          init() {
            const t3 = this.editor, e3 = t3.model.schema, n2 = t3.t, o2 = t3.conversion, i2 = t3.config.get("mediaEmbed.previewsInData"), r2 = t3.config.get("mediaEmbed.elementName"), s3 = this.registry;
            t3.commands.add("mediaEmbed", new vx(t3)), e3.register("media", { inheritAllFrom: "$blockObject", allowAttributes: ["url"] }), o2.for("dataDowncast").elementToStructure({ model: "media", view: (t4, { writer: e4 }) => {
              const n3 = t4.getAttribute("url");
              return Ax(e4, s3, n3, { elementName: r2, renderMediaPreview: !!n3 && i2 });
            } }), o2.for("dataDowncast").add(wx(s3, { elementName: r2, renderMediaPreview: i2 })), o2.for("editingDowncast").elementToStructure({ model: "media", view: (t4, { writer: e4 }) => {
              const o3 = t4.getAttribute("url");
              return function(t5, e5, n3) {
                return e5.setCustomProperty("media", true, t5), db(t5, e5, { label: n3 });
              }(Ax(e4, s3, o3, { elementName: r2, renderForEditingView: true }), e4, n2("media widget"));
            } }), o2.for("editingDowncast").add(wx(s3, { elementName: r2, renderForEditingView: true })), o2.for("upcast").elementToElement({ view: (t4) => ["oembed", r2].includes(t4.name) && t4.getAttribute("url") ? { name: true } : null, model: (t4, { writer: e4 }) => {
              const n3 = t4.getAttribute("url");
              return s3.hasMedia(n3) ? e4.createElement("media", { url: n3 }) : null;
            } }).elementToElement({ view: { name: "div", attributes: { "data-oembed-url": true } }, model: (t4, { writer: e4 }) => {
              const n3 = t4.getAttribute("data-oembed-url");
              return s3.hasMedia(n3) ? e4.createElement("media", { url: n3 }) : null;
            } }).add((t4) => {
              t4.on("element:figure", (t5, e4, n3) => {
                if (!n3.consumable.consume(e4.viewItem, { name: true, classes: "media" }))
                  return;
                const { modelRange: o3, modelCursor: i3 } = n3.convertChildren(e4.viewItem, e4.modelCursor);
                e4.modelRange = o3, e4.modelCursor = i3;
                Ii(o3.getItems()) || n3.consumable.revert(e4.viewItem, { name: true, classes: "media" });
              });
            });
          }
        }
        const Sx = /^(?:http(s)?:\/\/)?[\w-]+\.[\w-.~:/?#[\]@!$&'()*+,;=%]+$/;
        class Tx extends es {
          constructor(t3) {
            super(t3), this._timeoutId = null, this._positionToInsert = null;
          }
          static get requires() {
            return [aw, Ek, Iw];
          }
          static get pluginName() {
            return "AutoMediaEmbed";
          }
          init() {
            const t3 = this.editor, e3 = t3.model.document, n2 = t3.plugins.get("ClipboardPipeline");
            this.listenTo(n2, "inputTransformation", () => {
              const t4 = e3.selection.getFirstRange(), n3 = Au.fromPosition(t4.start);
              n3.stickiness = "toPrevious";
              const o2 = Au.fromPosition(t4.end);
              o2.stickiness = "toNext", e3.once("change:data", () => {
                this._embedMediaBetweenPositions(n3, o2), n3.detach(), o2.detach();
              }, { priority: "high" });
            });
            t3.commands.get("undo").on("execute", () => {
              this._timeoutId && (zo.window.clearTimeout(this._timeoutId), this._positionToInsert.detach(), this._timeoutId = null, this._positionToInsert = null);
            }, { priority: "high" });
          }
          _embedMediaBetweenPositions(t3, e3) {
            const n2 = this.editor, o2 = n2.plugins.get(Ix).registry, i2 = new Cd(t3, e3), r2 = i2.getWalker({ ignoreElementEnd: true });
            let s3 = "";
            for (const t4 of r2)
              t4.item.is("$textProxy") && (s3 += t4.item.data);
            if (s3 = s3.trim(), !s3.match(Sx))
              return void i2.detach();
            if (!o2.hasMedia(s3))
              return void i2.detach();
            n2.commands.get("mediaEmbed").isEnabled ? (this._positionToInsert = Au.fromPosition(t3), this._timeoutId = zo.window.setTimeout(() => {
              n2.model.change((t4) => {
                this._timeoutId = null, t4.remove(i2), i2.detach();
                let e4 = null;
                "$graveyard" !== this._positionToInsert.root.rootName && (e4 = this._positionToInsert), _x(n2.model, s3, e4, false), this._positionToInsert.detach(), this._positionToInsert = null;
              }), n2.plugins.get(Ek).requestUndoOnBackspace();
            }, 100)) : i2.detach();
          }
        }
        var Mx = n(9292), Bx = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(Mx.Z, Bx);
        Mx.Z.locals;
        class Nx extends Ui {
          constructor(t3, e3) {
            super(e3);
            const n2 = e3.t;
            this.focusTracker = new Si(), this.keystrokes = new Ti(), this.set("mediaURLInputValue", ""), this.urlInputView = this._createUrlInput(), this.saveButtonView = this._createButton(n2("Save"), Rg.check, "ck-button-save"), this.saveButtonView.type = "submit", this.saveButtonView.bind("isEnabled").to(this, "mediaURLInputValue", (t4) => !!t4), this.cancelButtonView = this._createButton(n2("Cancel"), Rg.cancel, "ck-button-cancel", "cancel"), this._focusables = new Li(), this._focusCycler = new qr({ focusables: this._focusables, focusTracker: this.focusTracker, keystrokeHandler: this.keystrokes, actions: { focusPrevious: "shift + tab", focusNext: "tab" } }), this._validators = t3, this.setTemplate({ tag: "form", attributes: { class: ["ck", "ck-media-form", "ck-responsive-form"], tabindex: "-1" }, children: [this.urlInputView, this.saveButtonView, this.cancelButtonView] });
          }
          render() {
            super.render(), i({ view: this });
            [this.urlInputView, this.saveButtonView, this.cancelButtonView].forEach((t4) => {
              this._focusables.add(t4), this.focusTracker.add(t4.element);
            }), this.keystrokes.listenTo(this.element);
            const t3 = (t4) => t4.stopPropagation();
            this.keystrokes.set("arrowright", t3), this.keystrokes.set("arrowleft", t3), this.keystrokes.set("arrowup", t3), this.keystrokes.set("arrowdown", t3);
          }
          destroy() {
            super.destroy(), this.focusTracker.destroy(), this.keystrokes.destroy();
          }
          focus() {
            this._focusCycler.focusFirst();
          }
          get url() {
            return this.urlInputView.fieldView.element.value.trim();
          }
          set url(t3) {
            this.urlInputView.fieldView.element.value = t3.trim();
          }
          isValid() {
            this.resetFormStatus();
            for (const t3 of this._validators) {
              const e3 = t3(this);
              if (e3)
                return this.urlInputView.errorText = e3, false;
            }
            return true;
          }
          resetFormStatus() {
            this.urlInputView.errorText = null, this.urlInputView.infoText = this._urlInputViewInfoDefault;
          }
          _createUrlInput() {
            const t3 = this.locale.t, e3 = new Sr(this.locale, gp), n2 = e3.fieldView;
            return this._urlInputViewInfoDefault = t3("Paste the media URL in the input."), this._urlInputViewInfoTip = t3("Tip: Paste the URL into the content to embed faster."), e3.label = t3("Media URL"), e3.infoText = this._urlInputViewInfoDefault, n2.on("input", () => {
              e3.infoText = n2.element.value ? this._urlInputViewInfoTip : this._urlInputViewInfoDefault, this.mediaURLInputValue = n2.element.value.trim();
            }), e3;
          }
          _createButton(t3, e3, n2, o2) {
            const i2 = new br(this.locale);
            return i2.set({ label: t3, icon: e3, tooltip: true }), i2.extendTemplate({ attributes: { class: n2 } }), o2 && i2.delegate("execute").to(this, o2), i2;
          }
        }
        class Px extends es {
          static get requires() {
            return [Ix];
          }
          static get pluginName() {
            return "MediaEmbedUI";
          }
          init() {
            const t3 = this.editor, e3 = t3.commands.get("mediaEmbed");
            t3.ui.componentFactory.add("mediaEmbed", (t4) => {
              const n2 = sp(t4);
              return this._setUpDropdown(n2, e3), n2;
            });
          }
          _setUpDropdown(t3, n2) {
            const o2 = this.editor, i2 = o2.t, r2 = t3.buttonView, s3 = o2.plugins.get(Ix).registry;
            t3.once("change:isOpen", () => {
              const i3 = new (e2(Nx))(function(t4, e3) {
                return [(e4) => {
                  if (!e4.url.length)
                    return t4("The URL must not be empty.");
                }, (n3) => {
                  if (!e3.hasMedia(n3.url))
                    return t4("This media URL is not supported.");
                }];
              }(o2.t, s3), o2.locale);
              t3.panelView.children.add(i3), r2.on("open", () => {
                i3.disableCssTransitions(), i3.url = n2.value || "", i3.urlInputView.fieldView.select(), i3.enableCssTransitions();
              }, { priority: "low" }), t3.on("submit", () => {
                i3.isValid() && (o2.execute("mediaEmbed", i3.url), o2.editing.view.focus());
              }), t3.on("change:isOpen", () => i3.resetFormStatus()), t3.on("cancel", () => {
                o2.editing.view.focus();
              }), i3.delegate("submit", "cancel").to(t3), i3.urlInputView.fieldView.bind("value").to(n2, "value"), i3.urlInputView.bind("isEnabled").to(n2, "isEnabled");
            }), t3.bind("isEnabled").to(n2), r2.set({ label: i2("Insert media"), icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M18.68 3.03c.6 0 .59-.03.59.55v12.84c0 .59.01.56-.59.56H1.29c-.6 0-.59.03-.59-.56V3.58c0-.58-.01-.55.6-.55h17.38zM15.77 15V5H4.2v10h11.57zM2 4v1h1V4H2zm0 2v1h1V6H2zm0 2v1h1V8H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zm0 2v1h1v-1H2zM17 4v1h1V4h-1zm0 2v1h1V6h-1zm0 2v1h1V8h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zm0 2v1h1v-1h-1zM7.5 7.177a.4.4 0 0 1 .593-.351l5.133 2.824a.4.4 0 0 1 0 .7l-5.133 2.824a.4.4 0 0 1-.593-.35V7.176v.001z"/></svg>', tooltip: true });
          }
        }
        var zx = n(4652), Ox = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(zx.Z, Ox);
        zx.Z.locals;
        function Lx(t3, e3) {
          if (!t3.childCount)
            return;
          const n2 = new Bg(t3.document), o2 = function(t4, e4) {
            const n3 = e4.createRangeIn(t4), o3 = new ys({ name: /^p|h\d+$/, styles: { "mso-list": /.*/ } }), i3 = [];
            for (const t5 of n3)
              if ("elementStart" === t5.type && o3.match(t5.item)) {
                const e5 = Fx(t5.item);
                i3.push({ element: t5.item, id: e5.id, order: e5.order, indent: e5.indent });
              }
            return i3;
          }(t3, n2);
          if (!o2.length)
            return;
          let i2 = null, r2 = 1;
          o2.forEach((t4, s3) => {
            const a2 = function(t5, e4) {
              if (!t5)
                return true;
              if (t5.id !== e4.id)
                return e4.indent - t5.indent != 1;
              const n3 = e4.element.previousSibling;
              if (!n3)
                return true;
              return o3 = n3, !(o3.is("element", "ol") || o3.is("element", "ul"));
              var o3;
            }(o2[s3 - 1], t4), c2 = a2 ? null : o2[s3 - 1], l2 = (h2 = t4, (d2 = c2) ? h2.indent - d2.indent : h2.indent - 1);
            var d2, h2;
            if (a2 && (i2 = null, r2 = 1), !i2 || 0 !== l2) {
              const o3 = function(t5, e4) {
                const n3 = new RegExp(`@list l${t5.id}:level${t5.indent}\\s*({[^}]*)`, "gi"), o4 = /mso-level-number-format:([^;]{0,100});/gi, i3 = /mso-level-start-at:\s{0,100}([0-9]{0,10})\s{0,100};/gi, r3 = n3.exec(e4);
                let s4 = "decimal", a3 = "ol", c3 = null;
                if (r3 && r3[1]) {
                  const e5 = o4.exec(r3[1]);
                  if (e5 && e5[1] && (s4 = e5[1].trim(), a3 = "bullet" !== s4 && "image" !== s4 ? "ol" : "ul"), "bullet" === s4) {
                    const e6 = function(t6) {
                      const e7 = function(t7) {
                        if (t7.getChild(0).is("$text"))
                          return null;
                        for (const e8 of t7.getChildren()) {
                          if (!e8.is("element", "span"))
                            continue;
                          const t8 = e8.getChild(0);
                          if (t8)
                            return t8.is("$text") ? t8 : t8.getChild(0);
                        }
                        return null;
                      }(t6);
                      if (!e7)
                        return null;
                      const n4 = e7._data;
                      if ("o" === n4)
                        return "circle";
                      if ("\xB7" === n4)
                        return "disc";
                      if ("\xA7" === n4)
                        return "square";
                      return null;
                    }(t5.element);
                    e6 && (s4 = e6);
                  } else {
                    const t6 = i3.exec(r3[1]);
                    t6 && t6[1] && (c3 = parseInt(t6[1]));
                  }
                }
                return { type: a3, startIndex: c3, style: Rx(s4) };
              }(t4, e3);
              if (i2) {
                if (t4.indent > r2) {
                  const t5 = i2.getChild(i2.childCount - 1), e4 = t5.getChild(t5.childCount - 1);
                  i2 = jx(o3, e4, n2), r2 += 1;
                } else if (t4.indent < r2) {
                  const e4 = r2 - t4.indent;
                  i2 = function(t5, e5) {
                    const n3 = t5.getAncestors({ parentFirst: true });
                    let o4 = null, i3 = 0;
                    for (const t6 of n3)
                      if ((t6.is("element", "ul") || t6.is("element", "ol")) && i3++, i3 === e5) {
                        o4 = t6;
                        break;
                      }
                    return o4;
                  }(i2, e4), r2 = t4.indent;
                }
              } else
                i2 = jx(o3, t4.element, n2);
              t4.indent <= r2 && (i2.is("element", o3.type) || (i2 = n2.rename(o3.type, i2)));
            }
            const u2 = function(t5, e4) {
              return function(t6, e5) {
                const n3 = new ys({ name: "span", styles: { "mso-list": "Ignore" } }), o3 = e5.createRangeIn(t6);
                for (const t7 of o3)
                  "elementStart" === t7.type && n3.match(t7.item) && e5.remove(t7.item);
              }(t5, e4), e4.removeStyle("text-indent", t5), e4.rename("li", t5);
            }(t4.element, n2);
            n2.appendChild(u2, i2);
          });
        }
        function Rx(t3) {
          if (t3.startsWith("arabic-leading-zero"))
            return "decimal-leading-zero";
          switch (t3) {
            case "alpha-upper":
              return "upper-alpha";
            case "alpha-lower":
              return "lower-alpha";
            case "roman-upper":
              return "upper-roman";
            case "roman-lower":
              return "lower-roman";
            case "circle":
            case "disc":
            case "square":
              return t3;
            default:
              return null;
          }
        }
        function jx(t3, e3, n2) {
          const o2 = e3.parent, i2 = n2.createElement(t3.type), r2 = o2.getChildIndex(e3) + 1;
          return n2.insertChild(r2, i2, o2), t3.style && n2.setStyle("list-style-type", t3.style, i2), t3.startIndex && t3.startIndex > 1 && n2.setAttribute("start", t3.startIndex, i2), i2;
        }
        function Fx(t3) {
          const e3 = {}, n2 = t3.getStyle("mso-list");
          if (n2) {
            const t4 = n2.match(/(^|\s{1,100})l(\d+)/i), o2 = n2.match(/\s{0,100}lfo(\d+)/i), i2 = n2.match(/\s{0,100}level(\d+)/i);
            t4 && o2 && i2 && (e3.id = t4[2], e3.order = o2[1], e3.indent = parseInt(i2[1]));
          }
          return e3;
        }
        function Vx(t3, e3) {
          if (!t3.childCount)
            return;
          const n2 = new Bg(t3.document), o2 = function(t4, e4) {
            const n3 = e4.createRangeIn(t4), o3 = new ys({ name: /v:(.+)/ }), i3 = [];
            for (const t5 of n3) {
              if ("elementStart" != t5.type)
                continue;
              const e5 = t5.item, n4 = e5.previousSibling, r2 = n4 && n4.is("element") ? n4.name : null;
              o3.match(e5) && e5.getAttribute("o:gfxdata") && "v:shapetype" !== r2 && i3.push(t5.item.getAttribute("id"));
            }
            return i3;
          }(t3, n2);
          !function(t4, e4, n3) {
            const o3 = n3.createRangeIn(e4), i3 = new ys({ name: "img" }), r2 = [];
            for (const e5 of o3)
              if (e5.item.is("element") && i3.match(e5.item)) {
                const n4 = e5.item, o4 = n4.getAttribute("v:shapes") ? n4.getAttribute("v:shapes").split(" ") : [];
                o4.length && o4.every((e6) => t4.indexOf(e6) > -1) ? r2.push(n4) : n4.getAttribute("src") || r2.push(n4);
              }
            for (const t5 of r2)
              n3.remove(t5);
          }(o2, t3, n2), function(t4, e4, n3) {
            const o3 = n3.createRangeIn(e4), i3 = [];
            for (const e5 of o3)
              if ("elementStart" == e5.type && e5.item.is("element", "v:shape")) {
                const n4 = e5.item.getAttribute("id");
                if (t4.includes(n4))
                  continue;
                r2(e5.item.parent.getChildren(), n4) || i3.push(e5.item);
              }
            for (const t5 of i3) {
              const e5 = { src: s3(t5) };
              t5.hasAttribute("alt") && (e5.alt = t5.getAttribute("alt"));
              const o4 = n3.createElement("img", e5);
              n3.insertChild(t5.index + 1, o4, t5.parent);
            }
            function r2(t5, e5) {
              for (const n4 of t5)
                if (n4.is("element")) {
                  if ("img" == n4.name && n4.getAttribute("v:shapes") == e5)
                    return true;
                  if (r2(n4.getChildren(), e5))
                    return true;
                }
              return false;
            }
            function s3(t5) {
              for (const e5 of t5.getChildren())
                if (e5.is("element") && e5.getAttribute("src"))
                  return e5.getAttribute("src");
            }
          }(o2, t3, n2), function(t4, e4) {
            const n3 = e4.createRangeIn(t4), o3 = new ys({ name: /v:(.+)/ }), i3 = [];
            for (const t5 of n3)
              "elementStart" == t5.type && o3.match(t5.item) && i3.push(t5.item);
            for (const t5 of i3)
              e4.remove(t5);
          }(t3, n2);
          const i2 = function(t4, e4) {
            const n3 = e4.createRangeIn(t4), o3 = new ys({ name: "img" }), i3 = [];
            for (const t5 of n3)
              t5.item.is("element") && o3.match(t5.item) && t5.item.getAttribute("src").startsWith("file://") && i3.push(t5.item);
            return i3;
          }(t3, n2);
          i2.length && function(t4, e4, n3) {
            if (t4.length === e4.length)
              for (let o3 = 0; o3 < t4.length; o3++) {
                const i3 = `data:${e4[o3].type};base64,${Ux(e4[o3].hex)}`;
                n3.setAttribute("src", i3, t4[o3]);
              }
          }(i2, function(t4) {
            if (!t4)
              return [];
            const e4 = /{\\pict[\s\S]+?\\bliptag-?\d+(\\blipupi-?\d+)?({\\\*\\blipuid\s?[\da-fA-F]+)?[\s}]*?/, n3 = new RegExp("(?:(" + e4.source + "))([\\da-fA-F\\s]+)\\}", "g"), o3 = t4.match(n3), i3 = [];
            if (o3)
              for (const t5 of o3) {
                let n4 = false;
                t5.includes("\\pngblip") ? n4 = "image/png" : t5.includes("\\jpegblip") && (n4 = "image/jpeg"), n4 && i3.push({ hex: t5.replace(e4, "").replace(/[^\da-fA-F]/g, ""), type: n4 });
              }
            return i3;
          }(e3), n2);
        }
        function Ux(t3) {
          return btoa(t3.match(/\w{2}/g).map((t4) => String.fromCharCode(parseInt(t4, 16))).join(""));
        }
        const Hx = /<meta\s*name="?generator"?\s*content="?microsoft\s*word\s*\d+"?\/?>/i, qx = /xmlns:o="urn:schemas-microsoft-com/i;
        class Gx {
          constructor(t3) {
            this.document = t3;
          }
          isActive(t3) {
            return Hx.test(t3) || qx.test(t3);
          }
          execute(t3) {
            const { body: e3, stylesString: n2 } = t3._parsedData;
            Lx(e3, n2), Vx(e3, t3.dataTransfer.getData("text/rtf")), function(t4) {
              const e4 = [], n3 = new Bg(t4.document);
              for (const { item: o2 } of n3.createRangeIn(t4))
                if (o2.is("element")) {
                  for (const t5 of o2.getClassNames())
                    /\bmso/gi.exec(t5) && n3.removeClass(t5, o2);
                  for (const t5 of o2.getStyleNames())
                    /\bmso/gi.exec(t5) && n3.removeStyle(t5, o2);
                  o2.is("element", "w:sdt") && e4.push(o2);
                }
              for (const t5 of e4) {
                const e5 = t5.parent, o2 = e5.getChildIndex(t5);
                n3.insertChild(o2, t5.getChildren(), e5), n3.remove(t5);
              }
            }(e3), t3.content = e3;
          }
        }
        function Wx(t3, e3, n2, { blockElements: o2, inlineObjectElements: i2 }) {
          let r2 = n2.createPositionAt(t3, "forward" == e3 ? "after" : "before");
          return r2 = r2.getLastMatchingPosition(({ item: t4 }) => t4.is("element") && !o2.includes(t4.name) && !i2.includes(t4.name), { direction: e3 }), "forward" == e3 ? r2.nodeAfter : r2.nodeBefore;
        }
        function Kx(t3, e3) {
          return !!t3 && t3.is("element") && e3.includes(t3.name);
        }
        const Zx = /id=("|')docs-internal-guid-[-0-9a-f]+("|')/i;
        class Yx {
          constructor(t3) {
            this.document = t3;
          }
          isActive(t3) {
            return Zx.test(t3);
          }
          execute(t3) {
            const e3 = new Bg(this.document), { body: n2 } = t3._parsedData;
            !function(t4, e4) {
              for (const n3 of t4.getChildren())
                if (n3.is("element", "b") && "normal" === n3.getStyle("font-weight")) {
                  const o2 = t4.getChildIndex(n3);
                  e4.remove(n3), e4.insertChild(o2, n3.getChildren(), t4);
                }
            }(n2, e3), function(t4, e4) {
              for (const n3 of e4.createRangeIn(t4)) {
                const t5 = n3.item;
                if (t5.is("element", "li")) {
                  const n4 = t5.getChild(0);
                  n4 && n4.is("element", "p") && e4.unwrapElement(n4);
                }
              }
            }(n2, e3), function(t4, e4) {
              const n3 = new qa(e4.document.stylesProcessor), o2 = new zc(n3, { renderingMode: "data" }), i2 = o2.blockElements, r2 = o2.inlineObjectElements, s3 = [];
              for (const n4 of e4.createRangeIn(t4)) {
                const t5 = n4.item;
                if (t5.is("element", "br")) {
                  const n5 = Wx(t5, "forward", e4, { blockElements: i2, inlineObjectElements: r2 }), o3 = Wx(t5, "backward", e4, { blockElements: i2, inlineObjectElements: r2 }), a2 = Kx(n5, i2);
                  (Kx(o3, i2) || a2) && s3.push(t5);
                }
              }
              for (const t5 of s3)
                t5.hasClass("Apple-interchange-newline") ? e4.remove(t5) : e4.replace(t5, e4.createElement("p"));
            }(n2, e3), t3.content = n2;
          }
        }
        const $x = /<google-sheets-html-origin/i;
        class Qx {
          constructor(t3) {
            this.document = t3;
          }
          isActive(t3) {
            return $x.test(t3);
          }
          execute(t3) {
            const e3 = new Bg(this.document), { body: n2 } = t3._parsedData;
            !function(t4, e4) {
              for (const n3 of t4.getChildren())
                if (n3.is("element", "google-sheets-html-origin")) {
                  const o2 = t4.getChildIndex(n3);
                  e4.remove(n3), e4.insertChild(o2, n3.getChildren(), t4);
                }
            }(n2, e3), function(t4, e4) {
              for (const n3 of t4.getChildren())
                n3.is("element", "table") && n3.hasAttribute("xmlns") && e4.removeAttribute("xmlns", n3);
            }(n2, e3), function(t4, e4) {
              for (const n3 of t4.getChildren())
                n3.is("element", "table") && "0px" === n3.getStyle("width") && e4.removeStyle("width", n3);
            }(n2, e3), function(t4, e4) {
              for (const n3 of Array.from(t4.getChildren()))
                n3.is("element", "style") && e4.remove(n3);
            }(n2, e3), t3.content = n2;
          }
        }
        function Jx(t3) {
          return t3.replace(/<span(?: class="Apple-converted-space"|)>(\s+)<\/span>/g, (t4, e3) => 1 === e3.length ? " " : Array(e3.length + 1).join("\xA0 ").substr(0, e3.length));
        }
        function Xx(t3, e3) {
          const n2 = new DOMParser(), o2 = function(t4) {
            return Jx(Jx(t4)).replace(/(<span\s+style=['"]mso-spacerun:yes['"]>[^\S\r\n]*?)[\r\n]+([^\S\r\n]*<\/span>)/g, "$1$2").replace(/<span\s+style=['"]mso-spacerun:yes['"]><\/span>/g, "").replace(/(<span\s+style=['"]letter-spacing:[^'"]+?['"]>)[\r\n]+(<\/span>)/g, "$1 $2").replace(/ <\//g, "\xA0</").replace(/ <o:p><\/o:p>/g, "\xA0<o:p></o:p>").replace(/<o:p>(&nbsp;|\u00A0)<\/o:p>/g, "").replace(/>([^\S\r\n]*[\r\n]\s*)</g, "><");
          }(function(t4) {
            const e4 = "</body>", n3 = "</html>", o3 = t4.indexOf(e4);
            if (o3 < 0)
              return t4;
            const i3 = t4.indexOf(n3, o3 + e4.length);
            return t4.substring(0, o3 + e4.length) + (i3 >= 0 ? t4.substring(i3) : "");
          }(t3 = (t3 = t3.replace(/<!--\[if gte vml 1]>/g, "")).replace(/<o:SmartTagType(?:\s+[^\s>=]+(?:="[^"]*")?)*\s*\/?>/gi, ""))), i2 = n2.parseFromString(o2, "text/html");
          !function(t4) {
            t4.querySelectorAll("span[style*=spacerun]").forEach((t5) => {
              const e4 = t5, n3 = e4.innerText.length || 0;
              e4.innerText = Array(n3 + 1).join("\xA0 ").substr(0, n3);
            });
          }(i2);
          const r2 = i2.body.innerHTML, s3 = function(t4, e4) {
            const n3 = new qa(e4), o3 = new zc(n3, { renderingMode: "data" }), i3 = t4.createDocumentFragment(), r3 = t4.body.childNodes;
            for (; r3.length > 0; )
              i3.appendChild(r3[0]);
            return o3.domToView(i3, { skipComments: true });
          }(i2, e3), a2 = function(t4) {
            const e4 = [], n3 = [], o3 = Array.from(t4.getElementsByTagName("style"));
            for (const t5 of o3)
              t5.sheet && t5.sheet.cssRules && t5.sheet.cssRules.length && (e4.push(t5.sheet), n3.push(t5.innerHTML));
            return { styles: e4, stylesString: n3.join(" ") };
          }(i2);
          return { body: s3, bodyString: r2, styles: a2.styles, stylesString: a2.stylesString };
        }
        Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        function tE(t3, e3, n2, o2, i2 = 1) {
          null != e3 && null != i2 && e3 > i2 ? o2.setAttribute(t3, e3, n2) : o2.removeAttribute(t3, n2);
        }
        function eE(t3, e3, n2 = {}) {
          const o2 = t3.createElement("tableCell", n2);
          return t3.insertElement("paragraph", o2), t3.insert(o2, e3), o2;
        }
        function nE(t3, e3) {
          const n2 = e3.parent.parent, o2 = parseInt(n2.getAttribute("headingColumns") || "0"), { column: i2 } = t3.getCellLocation(e3);
          return !!o2 && i2 < o2;
        }
        function oE() {
          return (t3) => {
            t3.on("element:table", (t4, e3, n2) => {
              const o2 = e3.viewItem;
              if (!n2.consumable.test(o2, { name: true }))
                return;
              const { rows: i2, headingRows: r2, headingColumns: s3 } = function(t5) {
                let e4, n3 = 0;
                const o3 = [], i3 = [];
                let r3;
                for (const s4 of Array.from(t5.getChildren())) {
                  if ("tbody" !== s4.name && "thead" !== s4.name && "tfoot" !== s4.name)
                    continue;
                  "thead" !== s4.name || r3 || (r3 = s4);
                  const t6 = Array.from(s4.getChildren()).filter((t7) => t7.is("element", "tr"));
                  for (const a3 of t6)
                    if (r3 && s4 === r3 || "tbody" === s4.name && Array.from(a3.getChildren()).length && Array.from(a3.getChildren()).every((t7) => t7.is("element", "th")))
                      n3++, o3.push(a3);
                    else {
                      i3.push(a3);
                      const t7 = rE(a3);
                      (!e4 || t7 < e4) && (e4 = t7);
                    }
                }
                return { headingRows: n3, headingColumns: e4 || 0, rows: [...o3, ...i3] };
              }(o2), a2 = {};
              s3 && (a2.headingColumns = s3), r2 && (a2.headingRows = r2);
              const c2 = n2.writer.createElement("table", a2);
              if (n2.safeInsert(c2, e3.modelCursor)) {
                if (n2.consumable.consume(o2, { name: true }), i2.forEach((t5) => n2.convertItem(t5, n2.writer.createPositionAt(c2, "end"))), n2.convertChildren(o2, n2.writer.createPositionAt(c2, "end")), c2.isEmpty) {
                  const t5 = n2.writer.createElement("tableRow");
                  n2.writer.insert(t5, n2.writer.createPositionAt(c2, "end")), eE(n2.writer, n2.writer.createPositionAt(t5, "end"));
                }
                n2.updateConversionResult(c2, e3);
              }
            });
          };
        }
        function iE(t3) {
          return (e3) => {
            e3.on(`element:${t3}`, (t4, e4, { writer: n2 }) => {
              if (!e4.modelRange)
                return;
              const o2 = e4.modelRange.start.nodeAfter, i2 = n2.createPositionAt(o2, 0);
              if (e4.viewItem.isEmpty)
                return void n2.insertElement("paragraph", i2);
              const r2 = Array.from(o2.getChildren());
              if (r2.every((t5) => t5.is("element", "$marker"))) {
                const t5 = n2.createElement("paragraph");
                n2.insert(t5, n2.createPositionAt(o2, 0));
                for (const e5 of r2)
                  n2.move(n2.createRangeOn(e5), n2.createPositionAt(t5, "end"));
              }
            }, { priority: "low" });
          };
        }
        function rE(t3) {
          let e3 = 0, n2 = 0;
          const o2 = Array.from(t3.getChildren()).filter((t4) => "th" === t4.name || "td" === t4.name);
          for (; n2 < o2.length && "th" === o2[n2].name; ) {
            const t4 = o2[n2];
            e3 += parseInt(t4.getAttribute("colspan") || "1"), n2++;
          }
          return e3;
        }
        class sE {
          constructor(t3, e3 = {}) {
            this._jumpedToStartRow = false, this._table = t3, this._startRow = void 0 !== e3.row ? e3.row : e3.startRow || 0, this._endRow = void 0 !== e3.row ? e3.row : e3.endRow, this._startColumn = void 0 !== e3.column ? e3.column : e3.startColumn || 0, this._endColumn = void 0 !== e3.column ? e3.column : e3.endColumn, this._includeAllSlots = !!e3.includeAllSlots, this._skipRows = /* @__PURE__ */ new Set(), this._row = 0, this._rowIndex = 0, this._column = 0, this._cellIndex = 0, this._spannedCells = /* @__PURE__ */ new Map(), this._nextCellAtColumn = -1;
          }
          [Symbol.iterator]() {
            return this;
          }
          next() {
            this._canJumpToStartRow() && this._jumpToNonSpannedRowClosestToStartRow();
            const t3 = this._table.getChild(this._rowIndex);
            if (!t3 || this._isOverEndRow())
              return { done: true, value: void 0 };
            if (!t3.is("element", "tableRow"))
              return this._rowIndex++, this.next();
            if (this._isOverEndColumn())
              return this._advanceToNextRow();
            let e3 = null;
            const n2 = this._getSpanned();
            if (n2)
              this._includeAllSlots && !this._shouldSkipSlot() && (e3 = this._formatOutValue(n2.cell, n2.row, n2.column));
            else {
              const n3 = t3.getChild(this._cellIndex);
              if (!n3)
                return this._advanceToNextRow();
              const o2 = parseInt(n3.getAttribute("colspan") || "1"), i2 = parseInt(n3.getAttribute("rowspan") || "1");
              (o2 > 1 || i2 > 1) && this._recordSpans(n3, i2, o2), this._shouldSkipSlot() || (e3 = this._formatOutValue(n3)), this._nextCellAtColumn = this._column + o2;
            }
            return this._column++, this._column == this._nextCellAtColumn && this._cellIndex++, e3 || this.next();
          }
          skipRow(t3) {
            this._skipRows.add(t3);
          }
          _advanceToNextRow() {
            return this._row++, this._rowIndex++, this._column = 0, this._cellIndex = 0, this._nextCellAtColumn = -1, this.next();
          }
          _isOverEndRow() {
            return void 0 !== this._endRow && this._row > this._endRow;
          }
          _isOverEndColumn() {
            return void 0 !== this._endColumn && this._column > this._endColumn;
          }
          _formatOutValue(t3, e3 = this._row, n2 = this._column) {
            return { done: false, value: new aE(this, t3, e3, n2) };
          }
          _shouldSkipSlot() {
            const t3 = this._skipRows.has(this._row), e3 = this._row < this._startRow, n2 = this._column < this._startColumn, o2 = void 0 !== this._endColumn && this._column > this._endColumn;
            return t3 || e3 || n2 || o2;
          }
          _getSpanned() {
            const t3 = this._spannedCells.get(this._row);
            return t3 && t3.get(this._column) || null;
          }
          _recordSpans(t3, e3, n2) {
            const o2 = { cell: t3, row: this._row, column: this._column };
            for (let t4 = this._row; t4 < this._row + e3; t4++)
              for (let e4 = this._column; e4 < this._column + n2; e4++)
                t4 == this._row && e4 == this._column || this._markSpannedCell(t4, e4, o2);
          }
          _markSpannedCell(t3, e3, n2) {
            this._spannedCells.has(t3) || this._spannedCells.set(t3, /* @__PURE__ */ new Map());
            this._spannedCells.get(t3).set(e3, n2);
          }
          _canJumpToStartRow() {
            return !!this._startRow && this._startRow > 0 && !this._jumpedToStartRow;
          }
          _jumpToNonSpannedRowClosestToStartRow() {
            const t3 = this._getRowLength(0);
            for (let e3 = this._startRow; !this._jumpedToStartRow; e3--)
              t3 === this._getRowLength(e3) && (this._row = e3, this._rowIndex = e3, this._jumpedToStartRow = true);
          }
          _getRowLength(t3) {
            return [...this._table.getChild(t3).getChildren()].reduce((t4, e3) => t4 + parseInt(e3.getAttribute("colspan") || "1"), 0);
          }
        }
        class aE {
          constructor(t3, e3, n2, o2) {
            this.cell = e3, this.row = t3._row, this.column = t3._column, this.cellAnchorRow = n2, this.cellAnchorColumn = o2, this._cellIndex = t3._cellIndex, this._rowIndex = t3._rowIndex, this._table = t3._table;
          }
          get isAnchor() {
            return this.row === this.cellAnchorRow && this.column === this.cellAnchorColumn;
          }
          get cellWidth() {
            return parseInt(this.cell.getAttribute("colspan") || "1");
          }
          get cellHeight() {
            return parseInt(this.cell.getAttribute("rowspan") || "1");
          }
          get rowIndex() {
            return this._rowIndex;
          }
          getPositionBefore() {
            return this._table.root.document.model.createPositionAt(this._table.getChild(this.row), this._cellIndex);
          }
        }
        function cE(t3, e3) {
          return (n2, { writer: o2 }) => {
            const i2 = n2.getAttribute("headingRows") || 0, r2 = o2.createContainerElement("table", null, []), s3 = o2.createContainerElement("figure", { class: "table" }, r2);
            i2 > 0 && o2.insert(o2.createPositionAt(r2, "end"), o2.createContainerElement("thead", null, o2.createSlot((t4) => t4.is("element", "tableRow") && t4.index < i2))), i2 < t3.getRows(n2) && o2.insert(o2.createPositionAt(r2, "end"), o2.createContainerElement("tbody", null, o2.createSlot((t4) => t4.is("element", "tableRow") && t4.index >= i2)));
            for (const { positionOffset: t4, filter: n3 } of e3.additionalSlots)
              o2.insert(o2.createPositionAt(r2, t4), o2.createSlot(n3));
            return o2.insert(o2.createPositionAt(r2, "after"), o2.createSlot((t4) => !t4.is("element", "tableRow") && !e3.additionalSlots.some(({ filter: e4 }) => e4(t4)))), e3.asWidget ? function(t4, e4) {
              return e4.setCustomProperty("table", true, t4), db(t4, e4, { hasSelectionHandle: true });
            }(s3, o2) : s3;
          };
        }
        function lE(t3 = {}) {
          return (e3, { writer: n2 }) => {
            const o2 = e3.parent, i2 = o2.parent, r2 = i2.getChildIndex(o2), s3 = new sE(i2, { row: r2 }), a2 = i2.getAttribute("headingRows") || 0, c2 = i2.getAttribute("headingColumns") || 0;
            let l2 = null;
            for (const o3 of s3)
              if (o3.cell == e3) {
                const e4 = o3.row < a2 || o3.column < c2 ? "th" : "td";
                l2 = t3.asWidget ? pb(n2.createEditableElement(e4), n2) : n2.createContainerElement(e4);
                break;
              }
            return l2;
          };
        }
        function dE(t3 = {}) {
          return (e3, { writer: n2 }) => {
            if (!e3.parent.is("element", "tableCell"))
              return null;
            if (!hE(e3))
              return null;
            if (t3.asWidget)
              return n2.createContainerElement("span", { class: "ck-table-bogus-paragraph" });
            {
              const t4 = n2.createContainerElement("p");
              return n2.setCustomProperty("dataPipeline:transparentRendering", true, t4), t4;
            }
          };
        }
        function hE(t3) {
          return 1 == t3.parent.childCount && !!t3.getAttributeKeys().next().done;
        }
        class uE extends os {
          refresh() {
            const t3 = this.editor.model, e3 = t3.document.selection, n2 = t3.schema;
            this.isEnabled = function(t4, e4) {
              const n3 = t4.getFirstPosition().parent, o2 = n3 === n3.root ? n3 : n3.parent;
              return e4.checkChild(o2, "table");
            }(e3, n2);
          }
          execute(t3 = {}) {
            const e3 = this.editor, n2 = e3.model, o2 = e3.plugins.get("TableUtils"), i2 = e3.config.get("table.defaultHeadings.rows"), r2 = e3.config.get("table.defaultHeadings.columns");
            void 0 === t3.headingRows && i2 && (t3.headingRows = i2), void 0 === t3.headingColumns && r2 && (t3.headingColumns = r2), n2.change((e4) => {
              const i3 = o2.createTable(e4, t3);
              n2.insertObject(i3, null, null, { findOptimalPosition: "auto" }), e4.setSelection(e4.createPositionAt(i3.getNodeByPath([0, 0, 0]), 0));
            });
          }
        }
        class gE extends os {
          constructor(t3, e3 = {}) {
            super(t3), this.order = e3.order || "below";
          }
          refresh() {
            const t3 = this.editor.model.document.selection, e3 = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(t3).length;
            this.isEnabled = e3;
          }
          execute() {
            const t3 = this.editor, e3 = t3.model.document.selection, n2 = t3.plugins.get("TableUtils"), o2 = "above" === this.order, i2 = n2.getSelectionAffectedTableCells(e3), r2 = n2.getRowIndexes(i2), s3 = o2 ? r2.first : r2.last, a2 = i2[0].findAncestor("table");
            n2.insertRows(a2, { at: o2 ? s3 : s3 + 1, copyStructureFromAbove: !o2 });
          }
        }
        class pE extends os {
          constructor(t3, e3 = {}) {
            super(t3), this.order = e3.order || "right";
          }
          refresh() {
            const t3 = this.editor.model.document.selection, e3 = !!this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(t3).length;
            this.isEnabled = e3;
          }
          execute() {
            const t3 = this.editor, e3 = t3.model.document.selection, n2 = t3.plugins.get("TableUtils"), o2 = "left" === this.order, i2 = n2.getSelectionAffectedTableCells(e3), r2 = n2.getColumnIndexes(i2), s3 = o2 ? r2.first : r2.last, a2 = i2[0].findAncestor("table");
            n2.insertColumns(a2, { columns: 1, at: o2 ? s3 : s3 + 1 });
          }
        }
        class mE extends os {
          constructor(t3, e3 = {}) {
            super(t3), this.direction = e3.direction || "horizontally";
          }
          refresh() {
            const t3 = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
            this.isEnabled = 1 === t3.length;
          }
          execute() {
            const t3 = this.editor.plugins.get("TableUtils"), e3 = t3.getSelectionAffectedTableCells(this.editor.model.document.selection)[0];
            "horizontally" === this.direction ? t3.splitCellHorizontally(e3, 2) : t3.splitCellVertically(e3, 2);
          }
        }
        function fE(t3, e3, n2) {
          const { startRow: o2, startColumn: i2, endRow: r2, endColumn: s3 } = e3, a2 = n2.createElement("table"), c2 = r2 - o2 + 1;
          for (let t4 = 0; t4 < c2; t4++)
            n2.insertElement("tableRow", a2, "end");
          const l2 = [...new sE(t3, { startRow: o2, endRow: r2, startColumn: i2, endColumn: s3, includeAllSlots: true })];
          for (const { row: t4, column: e4, cell: c3, isAnchor: d2, cellAnchorRow: h2, cellAnchorColumn: u2 } of l2) {
            const l3 = t4 - o2, g2 = a2.getChild(l3);
            if (d2) {
              const o3 = n2.cloneElement(c3);
              n2.append(o3, g2), CE(o3, t4, e4, r2, s3, n2);
            } else
              (h2 < o2 || u2 < i2) && eE(n2, n2.createPositionAt(g2, "end"));
          }
          return function(t4, e4, n3, o3, i3) {
            const r3 = parseInt(e4.getAttribute("headingRows") || "0");
            if (r3 > 0) {
              tE("headingRows", r3 - n3, t4, i3, 0);
            }
            const s4 = parseInt(e4.getAttribute("headingColumns") || "0");
            if (s4 > 0) {
              tE("headingColumns", s4 - o3, t4, i3, 0);
            }
          }(a2, t3, o2, i2, n2), a2;
        }
        function kE(t3, e3, n2 = 0) {
          const o2 = [], i2 = new sE(t3, { startRow: n2, endRow: e3 - 1 });
          for (const t4 of i2) {
            const { row: n3, cellHeight: i3 } = t4;
            n3 < e3 && e3 <= n3 + i3 - 1 && o2.push(t4);
          }
          return o2;
        }
        function bE(t3, e3, n2) {
          const o2 = t3.parent, i2 = o2.parent, r2 = o2.index, s3 = e3 - r2, a2 = {}, c2 = parseInt(t3.getAttribute("rowspan")) - s3;
          c2 > 1 && (a2.rowspan = c2);
          const l2 = parseInt(t3.getAttribute("colspan") || "1");
          l2 > 1 && (a2.colspan = l2);
          const d2 = r2 + s3, h2 = [...new sE(i2, { startRow: r2, endRow: d2, includeAllSlots: true })];
          let u2, g2 = null;
          for (const e4 of h2) {
            const { row: o3, column: i3, cell: r3 } = e4;
            r3 === t3 && void 0 === u2 && (u2 = i3), void 0 !== u2 && u2 === i3 && o3 === d2 && (g2 = eE(n2, e4.getPositionBefore(), a2));
          }
          return tE("rowspan", s3, t3, n2), g2;
        }
        function wE(t3, e3) {
          const n2 = [], o2 = new sE(t3);
          for (const t4 of o2) {
            const { column: o3, cellWidth: i2 } = t4;
            o3 < e3 && e3 <= o3 + i2 - 1 && n2.push(t4);
          }
          return n2;
        }
        function AE(t3, e3, n2, o2) {
          const i2 = n2 - e3, r2 = {}, s3 = parseInt(t3.getAttribute("colspan")) - i2;
          s3 > 1 && (r2.colspan = s3);
          const a2 = parseInt(t3.getAttribute("rowspan") || "1");
          a2 > 1 && (r2.rowspan = a2);
          const c2 = eE(o2, o2.createPositionAfter(t3), r2);
          return tE("colspan", i2, t3, o2), c2;
        }
        function CE(t3, e3, n2, o2, i2, r2) {
          const s3 = parseInt(t3.getAttribute("colspan") || "1"), a2 = parseInt(t3.getAttribute("rowspan") || "1");
          if (n2 + s3 - 1 > i2) {
            tE("colspan", i2 - n2 + 1, t3, r2, 1);
          }
          if (e3 + a2 - 1 > o2) {
            tE("rowspan", o2 - e3 + 1, t3, r2, 1);
          }
        }
        function _E(t3, e3) {
          const n2 = e3.getColumns(t3), o2 = new Array(n2).fill(0);
          for (const { column: e4 } of new sE(t3))
            o2[e4]++;
          const i2 = o2.reduce((t4, e4, n3) => e4 ? t4 : [...t4, n3], []);
          if (i2.length > 0) {
            const n3 = i2[i2.length - 1];
            return e3.removeColumns(t3, { at: n3 }), true;
          }
          return false;
        }
        function vE(t3, e3) {
          const n2 = [], o2 = e3.getRows(t3);
          for (let e4 = 0; e4 < o2; e4++) {
            t3.getChild(e4).isEmpty && n2.push(e4);
          }
          if (n2.length > 0) {
            const o3 = n2[n2.length - 1];
            return e3.removeRows(t3, { at: o3 }), true;
          }
          return false;
        }
        function yE(t3, e3) {
          _E(t3, e3) || vE(t3, e3);
        }
        function xE(t3, e3) {
          const n2 = Array.from(new sE(t3, { startColumn: e3.firstColumn, endColumn: e3.lastColumn, row: e3.lastRow }));
          if (n2.every(({ cellHeight: t4 }) => 1 === t4))
            return e3.lastRow;
          const o2 = n2[0].cellHeight - 1;
          return e3.lastRow + o2;
        }
        function EE(t3, e3) {
          const n2 = Array.from(new sE(t3, { startRow: e3.firstRow, endRow: e3.lastRow, column: e3.lastColumn }));
          if (n2.every(({ cellWidth: t4 }) => 1 === t4))
            return e3.lastColumn;
          const o2 = n2[0].cellWidth - 1;
          return e3.lastColumn + o2;
        }
        class DE extends os {
          constructor(t3, e3) {
            super(t3), this.direction = e3.direction, this.isHorizontal = "right" == this.direction || "left" == this.direction;
          }
          refresh() {
            const t3 = this._getMergeableCell();
            this.value = t3, this.isEnabled = !!t3;
          }
          execute() {
            const t3 = this.editor.model, e3 = t3.document, n2 = this.editor.plugins.get("TableUtils").getTableCellsContainingSelection(e3.selection)[0], o2 = this.value, i2 = this.direction;
            t3.change((t4) => {
              const e4 = "right" == i2 || "down" == i2, r2 = e4 ? n2 : o2, s3 = e4 ? o2 : n2, a2 = s3.parent;
              !function(t5, e5, n3) {
                IE(t5) || (IE(e5) && n3.remove(n3.createRangeIn(e5)), n3.move(n3.createRangeIn(t5), n3.createPositionAt(e5, "end")));
                n3.remove(t5);
              }(s3, r2, t4);
              const c2 = this.isHorizontal ? "colspan" : "rowspan", l2 = parseInt(n2.getAttribute(c2) || "1"), d2 = parseInt(o2.getAttribute(c2) || "1");
              t4.setAttribute(c2, l2 + d2, r2), t4.setSelection(t4.createRangeIn(r2));
              const h2 = this.editor.plugins.get("TableUtils");
              yE(a2.findAncestor("table"), h2);
            });
          }
          _getMergeableCell() {
            const t3 = this.editor.model.document, e3 = this.editor.plugins.get("TableUtils"), n2 = e3.getTableCellsContainingSelection(t3.selection)[0];
            if (!n2)
              return;
            const o2 = this.isHorizontal ? function(t4, e4, n3) {
              const o3 = t4.parent, i3 = o3.parent, r3 = "right" == e4 ? t4.nextSibling : t4.previousSibling, s3 = (i3.getAttribute("headingColumns") || 0) > 0;
              if (!r3)
                return;
              const a2 = "right" == e4 ? t4 : r3, c2 = "right" == e4 ? r3 : t4, { column: l2 } = n3.getCellLocation(a2), { column: d2 } = n3.getCellLocation(c2), h2 = parseInt(a2.getAttribute("colspan") || "1"), u2 = nE(n3, a2), g2 = nE(n3, c2);
              if (s3 && u2 != g2)
                return;
              return l2 + h2 === d2 ? r3 : void 0;
            }(n2, this.direction, e3) : function(t4, e4, n3) {
              const o3 = t4.parent, i3 = o3.parent, r3 = i3.getChildIndex(o3);
              if ("down" == e4 && r3 === n3.getRows(i3) - 1 || "up" == e4 && 0 === r3)
                return null;
              const s3 = parseInt(t4.getAttribute("rowspan") || "1"), a2 = i3.getAttribute("headingRows") || 0, c2 = "down" == e4 && r3 + s3 === a2, l2 = "up" == e4 && r3 === a2;
              if (a2 && (c2 || l2))
                return null;
              const d2 = parseInt(t4.getAttribute("rowspan") || "1"), h2 = "down" == e4 ? r3 + d2 : r3, u2 = [...new sE(i3, { endRow: h2 })], g2 = u2.find((e5) => e5.cell === t4), p2 = g2.column, m2 = u2.find(({ row: t5, cellHeight: n4, column: o4 }) => o4 === p2 && ("down" == e4 ? t5 === h2 : h2 === t5 + n4));
              return m2 && m2.cell ? m2.cell : null;
            }(n2, this.direction, e3);
            if (!o2)
              return;
            const i2 = this.isHorizontal ? "rowspan" : "colspan", r2 = parseInt(n2.getAttribute(i2) || "1");
            return parseInt(o2.getAttribute(i2) || "1") === r2 ? o2 : void 0;
          }
        }
        function IE(t3) {
          const e3 = t3.getChild(0);
          return 1 == t3.childCount && e3.is("element", "paragraph") && e3.isEmpty;
        }
        class SE extends os {
          refresh() {
            const t3 = this.editor.plugins.get("TableUtils"), e3 = t3.getSelectionAffectedTableCells(this.editor.model.document.selection), n2 = e3[0];
            if (n2) {
              const o2 = n2.findAncestor("table"), i2 = t3.getRows(o2) - 1, r2 = t3.getRowIndexes(e3), s3 = 0 === r2.first && r2.last === i2;
              this.isEnabled = !s3;
            } else
              this.isEnabled = false;
          }
          execute() {
            const t3 = this.editor.model, e3 = this.editor.plugins.get("TableUtils"), n2 = e3.getSelectionAffectedTableCells(t3.document.selection), o2 = e3.getRowIndexes(n2), i2 = n2[0], r2 = i2.findAncestor("table"), s3 = e3.getCellLocation(i2).column;
            t3.change((t4) => {
              const n3 = o2.last - o2.first + 1;
              e3.removeRows(r2, { at: o2.first, rows: n3 });
              const i3 = function(t5, e4, n4, o3) {
                const i4 = t5.getChild(Math.min(e4, o3 - 1));
                let r3 = i4.getChild(0), s4 = 0;
                for (const t6 of i4.getChildren()) {
                  if (s4 > n4)
                    return r3;
                  r3 = t6, s4 += parseInt(t6.getAttribute("colspan") || "1");
                }
                return r3;
              }(r2, o2.first, s3, e3.getRows(r2));
              t4.setSelection(t4.createPositionAt(i3, 0));
            });
          }
        }
        class TE extends os {
          refresh() {
            const t3 = this.editor.plugins.get("TableUtils"), e3 = t3.getSelectionAffectedTableCells(this.editor.model.document.selection), n2 = e3[0];
            if (n2) {
              const o2 = n2.findAncestor("table"), i2 = t3.getColumns(o2), { first: r2, last: s3 } = t3.getColumnIndexes(e3);
              this.isEnabled = s3 - r2 < i2 - 1;
            } else
              this.isEnabled = false;
          }
          execute() {
            const t3 = this.editor.plugins.get("TableUtils"), [e3, n2] = function(t4, e4) {
              const n3 = e4.getSelectionAffectedTableCells(t4), o3 = n3[0], i3 = n3.pop(), r3 = [o3, i3];
              return o3.isBefore(i3) ? r3 : r3.reverse();
            }(this.editor.model.document.selection, t3), o2 = e3.parent.parent, i2 = [...new sE(o2)], r2 = { first: i2.find((t4) => t4.cell === e3).column, last: i2.find((t4) => t4.cell === n2).column }, s3 = function(t4, e4, n3, o3) {
              const i3 = parseInt(n3.getAttribute("colspan") || "1");
              return i3 > 1 ? n3 : e4.previousSibling || n3.nextSibling ? n3.nextSibling || e4.previousSibling : o3.first ? t4.reverse().find(({ column: t5 }) => t5 < o3.first).cell : t4.reverse().find(({ column: t5 }) => t5 > o3.last).cell;
            }(i2, e3, n2, r2);
            this.editor.model.change((e4) => {
              const n3 = r2.last - r2.first + 1;
              t3.removeColumns(o2, { at: r2.first, columns: n3 }), e4.setSelection(e4.createPositionAt(s3, 0));
            });
          }
        }
        class ME extends os {
          refresh() {
            const t3 = this.editor.plugins.get("TableUtils"), e3 = this.editor.model, n2 = t3.getSelectionAffectedTableCells(e3.document.selection), o2 = n2.length > 0;
            this.isEnabled = o2, this.value = o2 && n2.every((t4) => this._isInHeading(t4, t4.parent.parent));
          }
          execute(t3 = {}) {
            if (t3.forceValue === this.value)
              return;
            const e3 = this.editor.plugins.get("TableUtils"), n2 = this.editor.model, o2 = e3.getSelectionAffectedTableCells(n2.document.selection), i2 = o2[0].findAncestor("table"), { first: r2, last: s3 } = e3.getRowIndexes(o2), a2 = this.value ? r2 : s3 + 1, c2 = i2.getAttribute("headingRows") || 0;
            n2.change((t4) => {
              if (a2) {
                const e4 = kE(i2, a2, a2 > c2 ? c2 : 0);
                for (const { cell: n3 } of e4)
                  bE(n3, a2, t4);
              }
              tE("headingRows", a2, i2, t4, 0);
            });
          }
          _isInHeading(t3, e3) {
            const n2 = parseInt(e3.getAttribute("headingRows") || "0");
            return !!n2 && t3.parent.index < n2;
          }
        }
        class BE extends os {
          refresh() {
            const t3 = this.editor.model, e3 = this.editor.plugins.get("TableUtils"), n2 = e3.getSelectionAffectedTableCells(t3.document.selection), o2 = n2.length > 0;
            this.isEnabled = o2, this.value = o2 && n2.every((t4) => nE(e3, t4));
          }
          execute(t3 = {}) {
            if (t3.forceValue === this.value)
              return;
            const e3 = this.editor.plugins.get("TableUtils"), n2 = this.editor.model, o2 = e3.getSelectionAffectedTableCells(n2.document.selection), i2 = o2[0].findAncestor("table"), { first: r2, last: s3 } = e3.getColumnIndexes(o2), a2 = this.value ? r2 : s3 + 1;
            n2.change((t4) => {
              if (a2) {
                const e4 = wE(i2, a2);
                for (const { cell: n3, column: o3 } of e4)
                  AE(n3, o3, a2, t4);
              }
              tE("headingColumns", a2, i2, t4, 0);
            });
          }
        }
        function NE(t3) {
          if (t3.is("element", "tableColumnGroup"))
            return t3;
          const e3 = t3.getChildren();
          return Array.from(e3).find((t4) => t4.is("element", "tableColumnGroup"));
        }
        function PE(t3) {
          const e3 = NE(t3);
          return e3 ? Array.from(e3.getChildren()) : [];
        }
        class zE extends es {
          static get pluginName() {
            return "TableUtils";
          }
          init() {
            this.decorate("insertColumns"), this.decorate("insertRows");
          }
          getCellLocation(t3) {
            const e3 = t3.parent, n2 = e3.parent, o2 = n2.getChildIndex(e3), i2 = new sE(n2, { row: o2 });
            for (const { cell: e4, row: n3, column: o3 } of i2)
              if (e4 === t3)
                return { row: n3, column: o3 };
          }
          createTable(t3, e3) {
            const n2 = t3.createElement("table"), o2 = e3.rows || 2, i2 = e3.columns || 2;
            return OE(t3, n2, 0, o2, i2), e3.headingRows && tE("headingRows", Math.min(e3.headingRows, o2), n2, t3, 0), e3.headingColumns && tE("headingColumns", Math.min(e3.headingColumns, i2), n2, t3, 0), n2;
          }
          insertRows(t3, e3 = {}) {
            const n2 = this.editor.model, o2 = e3.at || 0, i2 = e3.rows || 1, r2 = void 0 !== e3.copyStructureFromAbove, s3 = e3.copyStructureFromAbove ? o2 - 1 : o2, a2 = this.getRows(t3), c2 = this.getColumns(t3);
            if (o2 > a2)
              throw new A("tableutils-insertrows-insert-out-of-range", this, { options: e3 });
            n2.change((e4) => {
              const n3 = t3.getAttribute("headingRows") || 0;
              if (n3 > o2 && tE("headingRows", n3 + i2, t3, e4, 0), !r2 && (0 === o2 || o2 === a2))
                return void OE(e4, t3, o2, i2, c2);
              const l2 = r2 ? Math.max(o2, s3) : o2, d2 = new sE(t3, { endRow: l2 }), h2 = new Array(c2).fill(1);
              for (const { row: t4, column: n4, cellHeight: a3, cellWidth: c3, cell: l3 } of d2) {
                const d3 = t4 + a3 - 1, u2 = t4 <= s3 && s3 <= d3;
                t4 < o2 && o2 <= d3 ? (e4.setAttribute("rowspan", a3 + i2, l3), h2[n4] = -c3) : r2 && u2 && (h2[n4] = c3);
              }
              for (let n4 = 0; n4 < i2; n4++) {
                const n5 = e4.createElement("tableRow");
                e4.insert(n5, t3, o2);
                for (let t4 = 0; t4 < h2.length; t4++) {
                  const o3 = h2[t4], i3 = e4.createPositionAt(n5, "end");
                  o3 > 0 && eE(e4, i3, o3 > 1 ? { colspan: o3 } : void 0), t4 += Math.abs(o3) - 1;
                }
              }
            });
          }
          insertColumns(t3, e3 = {}) {
            const n2 = this.editor.model, o2 = e3.at || 0, i2 = e3.columns || 1;
            n2.change((e4) => {
              const n3 = t3.getAttribute("headingColumns");
              o2 < n3 && e4.setAttribute("headingColumns", n3 + i2, t3);
              const r2 = this.getColumns(t3);
              if (0 === o2 || r2 === o2) {
                for (const n4 of t3.getChildren())
                  n4.is("element", "tableRow") && LE(i2, e4, e4.createPositionAt(n4, o2 ? "end" : 0));
                return;
              }
              const s3 = new sE(t3, { column: o2, includeAllSlots: true });
              for (const t4 of s3) {
                const { row: n4, cell: r3, cellAnchorColumn: a2, cellAnchorRow: c2, cellWidth: l2, cellHeight: d2 } = t4;
                if (a2 < o2) {
                  e4.setAttribute("colspan", l2 + i2, r3);
                  const t5 = c2 + d2 - 1;
                  for (let e5 = n4; e5 <= t5; e5++)
                    s3.skipRow(e5);
                } else
                  LE(i2, e4, t4.getPositionBefore());
              }
            });
          }
          removeRows(t3, e3) {
            const n2 = this.editor.model, o2 = e3.rows || 1, i2 = this.getRows(t3), r2 = e3.at, s3 = r2 + o2 - 1;
            if (s3 > i2 - 1)
              throw new A("tableutils-removerows-row-index-out-of-range", this, { table: t3, options: e3 });
            n2.change((e4) => {
              const n3 = { first: r2, last: s3 }, { cellsToMove: o3, cellsToTrim: i3 } = function(t4, { first: e5, last: n4 }) {
                const o4 = /* @__PURE__ */ new Map(), i4 = [];
                for (const { row: r3, column: s4, cellHeight: a2, cell: c2 } of new sE(t4, { endRow: n4 })) {
                  const t5 = r3 + a2 - 1;
                  if (r3 >= e5 && r3 <= n4 && t5 > n4) {
                    const t6 = a2 - (n4 - r3 + 1);
                    o4.set(s4, { cell: c2, rowspan: t6 });
                  }
                  if (r3 < e5 && t5 >= e5) {
                    let o5;
                    o5 = t5 >= n4 ? n4 - e5 + 1 : t5 - e5 + 1, i4.push({ cell: c2, rowspan: a2 - o5 });
                  }
                }
                return { cellsToMove: o4, cellsToTrim: i4 };
              }(t3, n3);
              if (o3.size) {
                !function(t4, e5, n4, o4) {
                  const i4 = new sE(t4, { includeAllSlots: true, row: e5 }), r3 = [...i4], s4 = t4.getChild(e5);
                  let a2;
                  for (const { column: t5, cell: e6, isAnchor: i5 } of r3)
                    if (n4.has(t5)) {
                      const { cell: e7, rowspan: i6 } = n4.get(t5), r4 = a2 ? o4.createPositionAfter(a2) : o4.createPositionAt(s4, 0);
                      o4.move(o4.createRangeOn(e7), r4), tE("rowspan", i6, e7, o4), a2 = e7;
                    } else
                      i5 && (a2 = e6);
                }(t3, s3 + 1, o3, e4);
              }
              for (let n4 = s3; n4 >= r2; n4--)
                e4.remove(t3.getChild(n4));
              for (const { rowspan: t4, cell: n4 } of i3)
                tE("rowspan", t4, n4, e4);
              !function(t4, { first: e5, last: n4 }, o4) {
                const i4 = t4.getAttribute("headingRows") || 0;
                if (e5 < i4) {
                  tE("headingRows", n4 < i4 ? i4 - (n4 - e5 + 1) : e5, t4, o4, 0);
                }
              }(t3, n3, e4), _E(t3, this) || vE(t3, this);
            });
          }
          removeColumns(t3, e3) {
            const n2 = this.editor.model, o2 = e3.at, i2 = e3.columns || 1, r2 = e3.at + i2 - 1;
            n2.change((e4) => {
              !function(t4, e5, n4) {
                const o3 = t4.getAttribute("headingColumns") || 0;
                if (o3 && e5.first < o3) {
                  const i3 = Math.min(o3 - 1, e5.last) - e5.first + 1;
                  n4.setAttribute("headingColumns", o3 - i3, t4);
                }
              }(t3, { first: o2, last: r2 }, e4);
              const n3 = PE(t3);
              for (let i3 = r2; i3 >= o2; i3--) {
                for (const { cell: n4, column: o3, cellWidth: r3 } of [...new sE(t3)])
                  o3 <= i3 && r3 > 1 && o3 + r3 > i3 ? tE("colspan", r3 - 1, n4, e4) : o3 === i3 && e4.remove(n4);
                if (n3[i3]) {
                  const t4 = 0 === i3 ? n3[1] : n3[i3 - 1], o3 = parseFloat(n3[i3].getAttribute("columnWidth")), r3 = parseFloat(t4.getAttribute("columnWidth"));
                  e4.remove(n3[i3]), e4.setAttribute("columnWidth", o3 + r3 + "%", t4);
                }
              }
              vE(t3, this) || _E(t3, this);
            });
          }
          splitCellVertically(t3, e3 = 2) {
            const n2 = this.editor.model, o2 = t3.parent.parent, i2 = parseInt(t3.getAttribute("rowspan") || "1"), r2 = parseInt(t3.getAttribute("colspan") || "1");
            n2.change((n3) => {
              if (r2 > 1) {
                const { newCellsSpan: o3, updatedSpan: s3 } = RE(r2, e3);
                tE("colspan", s3, t3, n3);
                const a2 = {};
                o3 > 1 && (a2.colspan = o3), i2 > 1 && (a2.rowspan = i2);
                LE(r2 > e3 ? e3 - 1 : r2 - 1, n3, n3.createPositionAfter(t3), a2);
              }
              if (r2 < e3) {
                const s3 = e3 - r2, a2 = [...new sE(o2)], { column: c2 } = a2.find(({ cell: e4 }) => e4 === t3), l2 = a2.filter(({ cell: e4, cellWidth: n4, column: o3 }) => e4 !== t3 && o3 === c2 || o3 < c2 && o3 + n4 > c2);
                for (const { cell: t4, cellWidth: e4 } of l2)
                  n3.setAttribute("colspan", e4 + s3, t4);
                const d2 = {};
                i2 > 1 && (d2.rowspan = i2), LE(s3, n3, n3.createPositionAfter(t3), d2);
                const h2 = o2.getAttribute("headingColumns") || 0;
                h2 > c2 && tE("headingColumns", h2 + s3, o2, n3);
              }
            });
          }
          splitCellHorizontally(t3, e3 = 2) {
            const n2 = this.editor.model, o2 = t3.parent, i2 = o2.parent, r2 = i2.getChildIndex(o2), s3 = parseInt(t3.getAttribute("rowspan") || "1"), a2 = parseInt(t3.getAttribute("colspan") || "1");
            n2.change((n3) => {
              if (s3 > 1) {
                const o3 = [...new sE(i2, { startRow: r2, endRow: r2 + s3 - 1, includeAllSlots: true })], { newCellsSpan: c2, updatedSpan: l2 } = RE(s3, e3);
                tE("rowspan", l2, t3, n3);
                const { column: d2 } = o3.find(({ cell: e4 }) => e4 === t3), h2 = {};
                c2 > 1 && (h2.rowspan = c2), a2 > 1 && (h2.colspan = a2);
                for (const t4 of o3) {
                  const { column: e4, row: o4 } = t4;
                  o4 >= r2 + l2 && e4 === d2 && (o4 + r2 + l2) % c2 == 0 && LE(1, n3, t4.getPositionBefore(), h2);
                }
              }
              if (s3 < e3) {
                const o3 = e3 - s3, c2 = [...new sE(i2, { startRow: 0, endRow: r2 })];
                for (const { cell: e4, cellHeight: i3, row: s4 } of c2)
                  if (e4 !== t3 && s4 + i3 > r2) {
                    const t4 = i3 + o3;
                    n3.setAttribute("rowspan", t4, e4);
                  }
                const l2 = {};
                a2 > 1 && (l2.colspan = a2), OE(n3, i2, r2 + 1, o3, 1, l2);
                const d2 = i2.getAttribute("headingRows") || 0;
                d2 > r2 && tE("headingRows", d2 + o3, i2, n3);
              }
            });
          }
          getColumns(t3) {
            return [...t3.getChild(0).getChildren()].reduce((t4, e3) => t4 + parseInt(e3.getAttribute("colspan") || "1"), 0);
          }
          getRows(t3) {
            return Array.from(t3.getChildren()).reduce((t4, e3) => e3.is("element", "tableRow") ? t4 + 1 : t4, 0);
          }
          createTableWalker(t3, e3 = {}) {
            return new sE(t3, e3);
          }
          getSelectedTableCells(t3) {
            const e3 = [];
            for (const n2 of this.sortRanges(t3.getRanges())) {
              const t4 = n2.getContainedElement();
              t4 && t4.is("element", "tableCell") && e3.push(t4);
            }
            return e3;
          }
          getTableCellsContainingSelection(t3) {
            const e3 = [];
            for (const n2 of t3.getRanges()) {
              const t4 = n2.start.findAncestor("tableCell");
              t4 && e3.push(t4);
            }
            return e3;
          }
          getSelectionAffectedTableCells(t3) {
            const e3 = this.getSelectedTableCells(t3);
            return e3.length ? e3 : this.getTableCellsContainingSelection(t3);
          }
          getRowIndexes(t3) {
            const e3 = t3.map((t4) => t4.parent.index);
            return this._getFirstLastIndexesObject(e3);
          }
          getColumnIndexes(t3) {
            const e3 = t3[0].findAncestor("table"), n2 = [...new sE(e3)].filter((e4) => t3.includes(e4.cell)).map((t4) => t4.column);
            return this._getFirstLastIndexesObject(n2);
          }
          isSelectionRectangular(t3) {
            if (t3.length < 2 || !this._areCellInTheSameTableSection(t3))
              return false;
            const e3 = /* @__PURE__ */ new Set(), n2 = /* @__PURE__ */ new Set();
            let o2 = 0;
            for (const i3 of t3) {
              const { row: t4, column: r2 } = this.getCellLocation(i3), s3 = parseInt(i3.getAttribute("rowspan")) || 1, a2 = parseInt(i3.getAttribute("colspan")) || 1;
              e3.add(t4), n2.add(r2), s3 > 1 && e3.add(t4 + s3 - 1), a2 > 1 && n2.add(r2 + a2 - 1), o2 += s3 * a2;
            }
            const i2 = function(t4, e4) {
              const n3 = Array.from(t4.values()), o3 = Array.from(e4.values()), i3 = Math.max(...n3), r2 = Math.min(...n3), s3 = Math.max(...o3), a2 = Math.min(...o3);
              return (i3 - r2 + 1) * (s3 - a2 + 1);
            }(e3, n2);
            return i2 == o2;
          }
          sortRanges(t3) {
            return Array.from(t3).sort(jE);
          }
          _getFirstLastIndexesObject(t3) {
            const e3 = t3.sort((t4, e4) => t4 - e4);
            return { first: e3[0], last: e3[e3.length - 1] };
          }
          _areCellInTheSameTableSection(t3) {
            const e3 = t3[0].findAncestor("table"), n2 = this.getRowIndexes(t3), o2 = parseInt(e3.getAttribute("headingRows")) || 0;
            if (!this._areIndexesInSameSection(n2, o2))
              return false;
            const i2 = this.getColumnIndexes(t3), r2 = parseInt(e3.getAttribute("headingColumns")) || 0;
            return this._areIndexesInSameSection(i2, r2);
          }
          _areIndexesInSameSection({ first: t3, last: e3 }, n2) {
            return t3 < n2 === e3 < n2;
          }
        }
        function OE(t3, e3, n2, o2, i2, r2 = {}) {
          for (let s3 = 0; s3 < o2; s3++) {
            const o3 = t3.createElement("tableRow");
            t3.insert(o3, e3, n2), LE(i2, t3, t3.createPositionAt(o3, "end"), r2);
          }
        }
        function LE(t3, e3, n2, o2 = {}) {
          for (let i2 = 0; i2 < t3; i2++)
            eE(e3, n2, o2);
        }
        function RE(t3, e3) {
          if (t3 < e3)
            return { newCellsSpan: 1, updatedSpan: 1 };
          const n2 = Math.floor(t3 / e3);
          return { newCellsSpan: n2, updatedSpan: t3 - n2 * e3 + n2 };
        }
        function jE(t3, e3) {
          const n2 = t3.start, o2 = e3.start;
          return n2.isBefore(o2) ? -1 : 1;
        }
        class FE extends os {
          refresh() {
            const t3 = this.editor.plugins.get(zE), e3 = t3.getSelectedTableCells(this.editor.model.document.selection);
            this.isEnabled = t3.isSelectionRectangular(e3);
          }
          execute() {
            const t3 = this.editor.model, e3 = this.editor.plugins.get(zE);
            t3.change((n2) => {
              const o2 = e3.getSelectedTableCells(t3.document.selection), i2 = o2.shift(), { mergeWidth: r2, mergeHeight: s3 } = function(t4, e4, n3) {
                let o3 = 0, i3 = 0;
                for (const t5 of e4) {
                  const { row: e5, column: r4 } = n3.getCellLocation(t5);
                  o3 = HE(t5, r4, o3, "colspan"), i3 = HE(t5, e5, i3, "rowspan");
                }
                const { row: r3, column: s4 } = n3.getCellLocation(t4), a2 = o3 - s4, c2 = i3 - r3;
                return { mergeWidth: a2, mergeHeight: c2 };
              }(i2, o2, e3);
              tE("colspan", r2, i2, n2), tE("rowspan", s3, i2, n2);
              for (const t4 of o2)
                VE(t4, i2, n2);
              yE(i2.findAncestor("table"), e3), n2.setSelection(i2, "in");
            });
          }
        }
        function VE(t3, e3, n2) {
          UE(t3) || (UE(e3) && n2.remove(n2.createRangeIn(e3)), n2.move(n2.createRangeIn(t3), n2.createPositionAt(e3, "end"))), n2.remove(t3);
        }
        function UE(t3) {
          const e3 = t3.getChild(0);
          return 1 == t3.childCount && e3.is("element", "paragraph") && e3.isEmpty;
        }
        function HE(t3, e3, n2, o2) {
          const i2 = parseInt(t3.getAttribute(o2) || "1");
          return Math.max(n2, e3 + i2);
        }
        class qE extends os {
          constructor(t3) {
            super(t3), this.affectsData = false;
          }
          refresh() {
            const t3 = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
            this.isEnabled = t3.length > 0;
          }
          execute() {
            const t3 = this.editor.model, e3 = this.editor.plugins.get("TableUtils"), n2 = e3.getSelectionAffectedTableCells(t3.document.selection), o2 = e3.getRowIndexes(n2), i2 = n2[0].findAncestor("table"), r2 = [];
            for (let e4 = o2.first; e4 <= o2.last; e4++)
              for (const n3 of i2.getChild(e4).getChildren())
                r2.push(t3.createRangeOn(n3));
            t3.change((t4) => {
              t4.setSelection(r2);
            });
          }
        }
        class GE extends os {
          constructor(t3) {
            super(t3), this.affectsData = false;
          }
          refresh() {
            const t3 = this.editor.plugins.get("TableUtils").getSelectionAffectedTableCells(this.editor.model.document.selection);
            this.isEnabled = t3.length > 0;
          }
          execute() {
            const t3 = this.editor.plugins.get("TableUtils"), e3 = this.editor.model, n2 = t3.getSelectionAffectedTableCells(e3.document.selection), o2 = n2[0], i2 = n2.pop(), r2 = o2.findAncestor("table"), s3 = t3.getCellLocation(o2), a2 = t3.getCellLocation(i2), c2 = Math.min(s3.column, a2.column), l2 = Math.max(s3.column, a2.column), d2 = [];
            for (const t4 of new sE(r2, { startColumn: c2, endColumn: l2 }))
              d2.push(e3.createRangeOn(t4.cell));
            e3.change((t4) => {
              t4.setSelection(d2);
            });
          }
        }
        function WE(t3) {
          t3.document.registerPostFixer((e3) => function(t4, e4) {
            const n2 = e4.document.differ.getChanges();
            let o2 = false;
            const i2 = /* @__PURE__ */ new Set();
            for (const e5 of n2) {
              let n3 = null;
              "insert" == e5.type && "table" == e5.name && (n3 = e5.position.nodeAfter), "insert" != e5.type && "remove" != e5.type || "tableRow" != e5.name && "tableCell" != e5.name || (n3 = e5.position.findAncestor("table")), YE(e5) && (n3 = e5.range.start.findAncestor("table")), n3 && !i2.has(n3) && (o2 = KE(n3, t4) || o2, o2 = ZE(n3, t4) || o2, i2.add(n3));
            }
            return o2;
          }(e3, t3));
        }
        function KE(t3, e3) {
          let n2 = false;
          const o2 = function(t4) {
            const e4 = parseInt(t4.getAttribute("headingRows") || "0"), n3 = Array.from(t4.getChildren()).reduce((t5, e5) => e5.is("element", "tableRow") ? t5 + 1 : t5, 0), o3 = [];
            for (const { row: i2, cell: r2, cellHeight: s3 } of new sE(t4)) {
              if (s3 < 2)
                continue;
              const t5 = i2 < e4 ? e4 : n3;
              if (i2 + s3 > t5) {
                const e5 = t5 - i2;
                o3.push({ cell: r2, rowspan: e5 });
              }
            }
            return o3;
          }(t3);
          if (o2.length) {
            n2 = true;
            for (const t4 of o2)
              tE("rowspan", t4.rowspan, t4.cell, e3, 1);
          }
          return n2;
        }
        function ZE(t3, e3) {
          let n2 = false;
          const o2 = function(t4) {
            const e4 = new Array(t4.childCount).fill(0);
            for (const { rowIndex: n3 } of new sE(t4, { includeAllSlots: true }))
              e4[n3]++;
            return e4;
          }(t3), i2 = [];
          for (const [e4, n3] of o2.entries())
            !n3 && t3.getChild(e4).is("element", "tableRow") && i2.push(e4);
          if (i2.length) {
            n2 = true;
            for (const n3 of i2.reverse())
              e3.remove(t3.getChild(n3)), o2.splice(n3, 1);
          }
          const r2 = o2.filter((e4, n3) => t3.getChild(n3).is("element", "tableRow")), s3 = r2[0];
          if (!r2.every((t4) => t4 === s3)) {
            const o3 = r2.reduce((t4, e4) => e4 > t4 ? e4 : t4, 0);
            for (const [i3, s4] of r2.entries()) {
              const r3 = o3 - s4;
              if (r3) {
                for (let n3 = 0; n3 < r3; n3++)
                  eE(e3, e3.createPositionAt(t3.getChild(i3), "end"));
                n2 = true;
              }
            }
          }
          return n2;
        }
        function YE(t3) {
          if ("attribute" !== t3.type)
            return false;
          const e3 = t3.attributeKey;
          return "headingRows" === e3 || "colspan" === e3 || "rowspan" === e3;
        }
        function $E(t3) {
          t3.document.registerPostFixer((e3) => function(t4, e4) {
            const n2 = e4.document.differ.getChanges();
            let o2 = false;
            for (const e5 of n2)
              "insert" == e5.type && "table" == e5.name && (o2 = QE(e5.position.nodeAfter, t4) || o2), "insert" == e5.type && "tableRow" == e5.name && (o2 = JE(e5.position.nodeAfter, t4) || o2), "insert" == e5.type && "tableCell" == e5.name && (o2 = XE(e5.position.nodeAfter, t4) || o2), "remove" != e5.type && "insert" != e5.type || !tD(e5) || (o2 = XE(e5.position.parent, t4) || o2);
            return o2;
          }(e3, t3));
        }
        function QE(t3, e3) {
          let n2 = false;
          for (const o2 of t3.getChildren())
            o2.is("element", "tableRow") && (n2 = JE(o2, e3) || n2);
          return n2;
        }
        function JE(t3, e3) {
          let n2 = false;
          for (const o2 of t3.getChildren())
            n2 = XE(o2, e3) || n2;
          return n2;
        }
        function XE(t3, e3) {
          if (0 == t3.childCount)
            return e3.insertElement("paragraph", t3), true;
          const n2 = Array.from(t3.getChildren()).filter((t4) => t4.is("$text"));
          for (const t4 of n2)
            e3.wrap(e3.createRangeOn(t4), "paragraph");
          return !!n2.length;
        }
        function tD(t3) {
          return !!t3.position.parent.is("element", "tableCell") && ("insert" == t3.type && "$text" == t3.name || "remove" == t3.type);
        }
        function eD(t3, e3) {
          if (!t3.is("element", "paragraph"))
            return false;
          const n2 = e3.toViewElement(t3);
          return !!n2 && hE(t3) !== n2.is("element", "span");
        }
        var nD = n(3881), oD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(nD.Z, oD);
        nD.Z.locals;
        class iD extends es {
          constructor(t3) {
            super(t3), this._additionalSlots = [];
          }
          static get pluginName() {
            return "TableEditing";
          }
          static get requires() {
            return [zE];
          }
          init() {
            const t3 = this.editor, e3 = t3.model, n2 = e3.schema, o2 = t3.conversion, i2 = t3.plugins.get(zE);
            n2.register("table", { inheritAllFrom: "$blockObject", allowAttributes: ["headingRows", "headingColumns"] }), n2.register("tableRow", { allowIn: "table", isLimit: true }), n2.register("tableCell", { allowContentOf: "$container", allowIn: "tableRow", allowAttributes: ["colspan", "rowspan"], isLimit: true, isSelectable: true }), o2.for("upcast").add((t4) => {
              t4.on("element:figure", (t5, e4, n3) => {
                if (!n3.consumable.test(e4.viewItem, { name: true, classes: "table" }))
                  return;
                const o3 = function(t6) {
                  for (const e5 of t6.getChildren())
                    if (e5.is("element", "table"))
                      return e5;
                }(e4.viewItem);
                if (!o3 || !n3.consumable.test(o3, { name: true }))
                  return;
                n3.consumable.consume(e4.viewItem, { name: true, classes: "table" });
                const i3 = Ii(n3.convertItem(o3, e4.modelCursor).modelRange.getItems());
                i3 ? (n3.convertChildren(e4.viewItem, n3.writer.createPositionAt(i3, "end")), n3.updateConversionResult(i3, e4)) : n3.consumable.revert(e4.viewItem, { name: true, classes: "table" });
              });
            }), o2.for("upcast").add(oE()), o2.for("editingDowncast").elementToStructure({ model: { name: "table", attributes: ["headingRows"] }, view: cE(i2, { asWidget: true, additionalSlots: this._additionalSlots }) }), o2.for("dataDowncast").elementToStructure({ model: { name: "table", attributes: ["headingRows"] }, view: cE(i2, { additionalSlots: this._additionalSlots }) }), o2.for("upcast").elementToElement({ model: "tableRow", view: "tr" }), o2.for("upcast").add((t4) => {
              t4.on("element:tr", (t5, e4) => {
                e4.viewItem.isEmpty && 0 == e4.modelCursor.index && t5.stop();
              }, { priority: "high" });
            }), o2.for("downcast").elementToElement({ model: "tableRow", view: (t4, { writer: e4 }) => t4.isEmpty ? e4.createEmptyElement("tr") : e4.createContainerElement("tr") }), o2.for("upcast").elementToElement({ model: "tableCell", view: "td" }), o2.for("upcast").elementToElement({ model: "tableCell", view: "th" }), o2.for("upcast").add(iE("td")), o2.for("upcast").add(iE("th")), o2.for("editingDowncast").elementToElement({ model: "tableCell", view: lE({ asWidget: true }) }), o2.for("dataDowncast").elementToElement({ model: "tableCell", view: lE() }), o2.for("editingDowncast").elementToElement({ model: "paragraph", view: dE({ asWidget: true }), converterPriority: "high" }), o2.for("dataDowncast").elementToElement({ model: "paragraph", view: dE(), converterPriority: "high" }), o2.for("downcast").attributeToAttribute({ model: "colspan", view: "colspan" }), o2.for("upcast").attributeToAttribute({ model: { key: "colspan", value: rD("colspan") }, view: "colspan" }), o2.for("downcast").attributeToAttribute({ model: "rowspan", view: "rowspan" }), o2.for("upcast").attributeToAttribute({ model: { key: "rowspan", value: rD("rowspan") }, view: "rowspan" }), t3.config.define("table.defaultHeadings.rows", 0), t3.config.define("table.defaultHeadings.columns", 0), t3.commands.add("insertTable", new uE(t3)), t3.commands.add("insertTableRowAbove", new gE(t3, { order: "above" })), t3.commands.add("insertTableRowBelow", new gE(t3, { order: "below" })), t3.commands.add("insertTableColumnLeft", new pE(t3, { order: "left" })), t3.commands.add("insertTableColumnRight", new pE(t3, { order: "right" })), t3.commands.add("removeTableRow", new SE(t3)), t3.commands.add("removeTableColumn", new TE(t3)), t3.commands.add("splitTableCellVertically", new mE(t3, { direction: "vertically" })), t3.commands.add("splitTableCellHorizontally", new mE(t3, { direction: "horizontally" })), t3.commands.add("mergeTableCells", new FE(t3)), t3.commands.add("mergeTableCellRight", new DE(t3, { direction: "right" })), t3.commands.add("mergeTableCellLeft", new DE(t3, { direction: "left" })), t3.commands.add("mergeTableCellDown", new DE(t3, { direction: "down" })), t3.commands.add("mergeTableCellUp", new DE(t3, { direction: "up" })), t3.commands.add("setTableColumnHeader", new BE(t3)), t3.commands.add("setTableRowHeader", new ME(t3)), t3.commands.add("selectTableRow", new qE(t3)), t3.commands.add("selectTableColumn", new GE(t3)), WE(e3), $E(e3), this.listenTo(e3.document, "change:data", () => {
              !function(t4, e4) {
                const n3 = t4.document.differ;
                for (const t5 of n3.getChanges()) {
                  let n4, o3 = false;
                  if ("attribute" == t5.type) {
                    const e5 = t5.range.start.nodeAfter;
                    if (!e5 || !e5.is("element", "table"))
                      continue;
                    if ("headingRows" != t5.attributeKey && "headingColumns" != t5.attributeKey)
                      continue;
                    n4 = e5, o3 = "headingRows" == t5.attributeKey;
                  } else
                    "tableRow" != t5.name && "tableCell" != t5.name || (n4 = t5.position.findAncestor("table"), o3 = "tableRow" == t5.name);
                  if (!n4)
                    continue;
                  const i3 = n4.getAttribute("headingRows") || 0, r2 = n4.getAttribute("headingColumns") || 0, s3 = new sE(n4);
                  for (const t6 of s3) {
                    const n5 = t6.row < i3 || t6.column < r2 ? "th" : "td", s4 = e4.mapper.toViewElement(t6.cell);
                    s4 && s4.is("element") && s4.name != n5 && e4.reconvertItem(o3 ? t6.cell.parent : t6.cell);
                  }
                }
              }(e3, t3.editing), function(t4, e4) {
                const n3 = t4.document.differ, o3 = /* @__PURE__ */ new Set();
                for (const t5 of n3.getChanges()) {
                  const e5 = "attribute" == t5.type ? t5.range.start.parent : t5.position.parent;
                  e5.is("element", "tableCell") && o3.add(e5);
                }
                for (const t5 of o3.values()) {
                  const n4 = Array.from(t5.getChildren()).filter((t6) => eD(t6, e4.mapper));
                  for (const t6 of n4)
                    e4.reconvertItem(t6);
                }
              }(e3, t3.editing);
            });
          }
          registerAdditionalSlot(t3) {
            this._additionalSlots.push(t3);
          }
        }
        function rD(t3) {
          return (e3) => {
            const n2 = parseInt(e3.getAttribute(t3));
            return Number.isNaN(n2) || n2 <= 0 ? null : n2;
          };
        }
        var sD = n(1613), aD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(sD.Z, aD);
        sD.Z.locals;
        class cD extends Ui {
          constructor(t3) {
            super(t3);
            const e3 = this.bindTemplate;
            this.items = this._createGridCollection(), this.keystrokes = new Ti(), this.focusTracker = new Si(), this.set("rows", 0), this.set("columns", 0), this.bind("label").to(this, "columns", this, "rows", (t4, e4) => `${e4} \xD7 ${t4}`), this.setTemplate({ tag: "div", attributes: { class: ["ck"] }, children: [{ tag: "div", attributes: { class: ["ck-insert-table-dropdown__grid"] }, on: { "mouseover@.ck-insert-table-dropdown-grid-box": e3.to("boxover") }, children: this.items }, { tag: "div", attributes: { class: ["ck", "ck-insert-table-dropdown__label"], "aria-hidden": true }, children: [{ text: e3.to("label") }] }], on: { mousedown: e3.to((t4) => {
              t4.preventDefault();
            }), click: e3.to(() => {
              this.fire("execute");
            }) } }), this.on("boxover", (t4, e4) => {
              const { row: n2, column: o2 } = e4.target.dataset;
              this.items.get(10 * (parseInt(n2, 10) - 1) + (parseInt(o2, 10) - 1)).focus();
            }), this.focusTracker.on("change:focusedElement", (t4, e4, n2) => {
              if (!n2)
                return;
              const { row: o2, column: i2 } = n2.dataset;
              this.set({ rows: parseInt(o2), columns: parseInt(i2) });
            }), this.on("change:columns", () => this._highlightGridBoxes()), this.on("change:rows", () => this._highlightGridBoxes());
          }
          render() {
            super.render(), function({ keystrokeHandler: t3, focusTracker: e3, gridItems: n2, numberOfColumns: o2, uiLanguageDirection: i2 }) {
              const r2 = "number" == typeof o2 ? () => o2 : o2;
              function s3(t4) {
                return (o3) => {
                  const i3 = n2.find((t5) => t5.element === e3.focusedElement), r3 = n2.getIndex(i3), s4 = t4(r3, n2);
                  n2.get(s4).focus(), o3.stopPropagation(), o3.preventDefault();
                };
              }
              function a2(t4, e4) {
                return t4 === e4 - 1 ? 0 : t4 + 1;
              }
              function c2(t4, e4) {
                return 0 === t4 ? e4 - 1 : t4 - 1;
              }
              t3.set("arrowright", s3((t4, e4) => "rtl" === i2 ? c2(t4, e4.length) : a2(t4, e4.length))), t3.set("arrowleft", s3((t4, e4) => "rtl" === i2 ? a2(t4, e4.length) : c2(t4, e4.length))), t3.set("arrowup", s3((t4, e4) => {
                let n3 = t4 - r2();
                return n3 < 0 && (n3 = t4 + r2() * Math.floor(e4.length / r2()), n3 > e4.length - 1 && (n3 -= r2())), n3;
              })), t3.set("arrowdown", s3((t4, e4) => {
                let n3 = t4 + r2();
                return n3 > e4.length - 1 && (n3 = t4 % r2()), n3;
              }));
            }({ keystrokeHandler: this.keystrokes, focusTracker: this.focusTracker, gridItems: this.items, numberOfColumns: 10, uiLanguageDirection: this.locale && this.locale.uiLanguageDirection });
            for (const t3 of this.items)
              this.focusTracker.add(t3.element);
            this.keystrokes.listenTo(this.element);
          }
          focus() {
            this.items.get(0).focus();
          }
          focusLast() {
            this.items.get(0).focus();
          }
          _highlightGridBoxes() {
            const t3 = this.rows, e3 = this.columns;
            this.items.map((n2, o2) => {
              const i2 = Math.floor(o2 / 10) < t3 && o2 % 10 < e3;
              n2.set("isOn", i2);
            });
          }
          _createGridButton(t3, e3, n2, o2) {
            const i2 = new br(t3);
            return i2.set({ label: o2, class: "ck-insert-table-dropdown-grid-box" }), i2.extendTemplate({ attributes: { "data-row": e3, "data-column": n2 } }), i2;
          }
          _createGridCollection() {
            const t3 = [];
            for (let e3 = 0; e3 < 100; e3++) {
              const n2 = Math.floor(e3 / 10), o2 = e3 % 10, i2 = `${n2 + 1} \xD7 ${o2 + 1}`;
              t3.push(this._createGridButton(this.locale, n2 + 1, o2 + 1, i2));
            }
            return this.createCollection(t3);
          }
        }
        class lD extends es {
          static get pluginName() {
            return "TableUI";
          }
          init() {
            const t3 = this.editor, e3 = this.editor.t, n2 = "ltr" === t3.locale.contentLanguageDirection;
            t3.ui.componentFactory.add("insertTable", (n3) => {
              const o2 = t3.commands.get("insertTable"), i2 = sp(n3);
              let r2;
              return i2.bind("isEnabled").to(o2), i2.buttonView.set({ icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M3 6v3h4V6H3zm0 4v3h4v-3H3zm0 4v3h4v-3H3zm5 3h4v-3H8v3zm5 0h4v-3h-4v3zm4-4v-3h-4v3h4zm0-4V6h-4v3h4zm1.5 8a1.5 1.5 0 0 1-1.5 1.5H3A1.5 1.5 0 0 1 1.5 17V4c.222-.863 1.068-1.5 2-1.5h13c.932 0 1.778.637 2 1.5v13zM12 13v-3H8v3h4zm0-4V6H8v3h4z"/></svg>', label: e3("Insert table"), tooltip: true }), i2.on("change:isOpen", () => {
                r2 || (r2 = new cD(n3), i2.panelView.children.add(r2), r2.delegate("execute").to(i2), i2.on("execute", () => {
                  t3.execute("insertTable", { rows: r2.rows, columns: r2.columns }), t3.editing.view.focus();
                }));
              }), i2;
            }), t3.ui.componentFactory.add("tableColumn", (t4) => {
              const o2 = [{ type: "switchbutton", model: { commandName: "setTableColumnHeader", label: e3("Header column"), bindIsOn: true } }, { type: "separator" }, { type: "button", model: { commandName: n2 ? "insertTableColumnLeft" : "insertTableColumnRight", label: e3("Insert column left") } }, { type: "button", model: { commandName: n2 ? "insertTableColumnRight" : "insertTableColumnLeft", label: e3("Insert column right") } }, { type: "button", model: { commandName: "removeTableColumn", label: e3("Delete column") } }, { type: "button", model: { commandName: "selectTableColumn", label: e3("Select column") } }];
              return this._prepareDropdown(e3("Column"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M18 7v1H2V7h16zm0 5v1H2v-1h16z" opacity=".6"/><path d="M14 1v18a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1h6a1 1 0 0 1 1 1zm-2 1H8v4h4V2zm0 6H8v4h4V8zm0 6H8v4h4v-4z"/></svg>', o2, t4);
            }), t3.ui.componentFactory.add("tableRow", (t4) => {
              const n3 = [{ type: "switchbutton", model: { commandName: "setTableRowHeader", label: e3("Header row"), bindIsOn: true } }, { type: "separator" }, { type: "button", model: { commandName: "insertTableRowAbove", label: e3("Insert row above") } }, { type: "button", model: { commandName: "insertTableRowBelow", label: e3("Insert row below") } }, { type: "button", model: { commandName: "removeTableRow", label: e3("Delete row") } }, { type: "button", model: { commandName: "selectTableRow", label: e3("Select row") } }];
              return this._prepareDropdown(e3("Row"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v16h-1V2z" opacity=".6"/><path d="M1 6h18a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1zm1 2v4h4V8H2zm6 0v4h4V8H8zm6 0v4h4V8h-4z"/></svg>', n3, t4);
            }), t3.ui.componentFactory.add("mergeTableCells", (t4) => {
              const o2 = [{ type: "button", model: { commandName: "mergeTableCellUp", label: e3("Merge cell up") } }, { type: "button", model: { commandName: n2 ? "mergeTableCellRight" : "mergeTableCellLeft", label: e3("Merge cell right") } }, { type: "button", model: { commandName: "mergeTableCellDown", label: e3("Merge cell down") } }, { type: "button", model: { commandName: n2 ? "mergeTableCellLeft" : "mergeTableCellRight", label: e3("Merge cell left") } }, { type: "separator" }, { type: "button", model: { commandName: "splitTableCellVertically", label: e3("Split cell vertically") } }, { type: "button", model: { commandName: "splitTableCellHorizontally", label: e3("Split cell horizontally") } }];
              return this._prepareMergeSplitButtonDropdown(e3("Merge cells"), '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M2.5 1h15A1.5 1.5 0 0 1 19 2.5v15a1.5 1.5 0 0 1-1.5 1.5h-15A1.5 1.5 0 0 1 1 17.5v-15A1.5 1.5 0 0 1 2.5 1zM2 2v16h16V2H2z" opacity=".6"/><path d="M7 2h1v16H7V2zm5 0h1v7h-1V2zm6 5v1H2V7h16zM8 12v1H2v-1h6z" opacity=".6"/><path d="M7 7h12a1 1 0 0 1 1 1v11a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1zm1 2v9h10V9H8z"/></svg>', o2, t4);
            });
          }
          _prepareDropdown(t3, e3, n2, o2) {
            const i2 = this.editor, r2 = sp(o2), s3 = this._fillDropdownWithListOptions(r2, n2);
            return r2.buttonView.set({ label: t3, icon: e3, tooltip: true }), r2.bind("isEnabled").toMany(s3, "isEnabled", (...t4) => t4.some((t5) => t5)), this.listenTo(r2, "execute", (t4) => {
              i2.execute(t4.source.commandName), t4.source instanceof Cr || i2.editing.view.focus();
            }), r2;
          }
          _prepareMergeSplitButtonDropdown(t3, e3, n2, o2) {
            const i2 = this.editor, r2 = sp(o2, ep), s3 = "mergeTableCells", a2 = i2.commands.get(s3), c2 = this._fillDropdownWithListOptions(r2, n2);
            return r2.buttonView.set({ label: t3, icon: e3, tooltip: true, isEnabled: true }), r2.bind("isEnabled").toMany([a2, ...c2], "isEnabled", (...t4) => t4.some((t5) => t5)), this.listenTo(r2.buttonView, "execute", () => {
              i2.execute(s3), i2.editing.view.focus();
            }), this.listenTo(r2, "execute", (t4) => {
              i2.execute(t4.source.commandName), i2.editing.view.focus();
            }), r2;
          }
          _fillDropdownWithListOptions(t3, e3) {
            const n2 = this.editor, o2 = [], i2 = new Di();
            for (const t4 of e3)
              dD(t4, n2, o2, i2);
            return lp(t3, i2), o2;
          }
        }
        function dD(t3, e3, n2, o2) {
          if ("button" === t3.type || "switchbutton" === t3.type) {
            const o3 = t3.model = new Qm(t3.model), { commandName: i2, bindIsOn: r2 } = t3.model, s3 = e3.commands.get(i2);
            n2.push(s3), o3.set({ commandName: i2 }), o3.bind("isEnabled").to(s3), r2 && o3.bind("isOn").to(s3, "value"), o3.set({ withText: true });
          }
          o2.add(t3);
        }
        var hD = n(6945), uD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(hD.Z, uD);
        hD.Z.locals;
        class gD extends es {
          static get pluginName() {
            return "TableSelection";
          }
          static get requires() {
            return [zE, zE];
          }
          init() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.editing.view;
            this.listenTo(e3, "deleteContent", (t4, e4) => this._handleDeleteContent(t4, e4), { priority: "high" }), this.listenTo(n2.document, "insertText", (t4, e4) => this._handleInsertTextEvent(t4, e4), { priority: "high" }), this._defineSelectionConverter(), this._enablePluginDisabling();
          }
          getSelectedTableCells() {
            const t3 = this.editor.plugins.get(zE), e3 = this.editor.model.document.selection, n2 = t3.getSelectedTableCells(e3);
            return 0 == n2.length ? null : n2;
          }
          getSelectionAsFragment() {
            const t3 = this.editor.plugins.get(zE), e3 = this.getSelectedTableCells();
            return e3 ? this.editor.model.change((n2) => {
              const o2 = n2.createDocumentFragment(), { first: i2, last: r2 } = t3.getColumnIndexes(e3), { first: s3, last: a2 } = t3.getRowIndexes(e3), c2 = e3[0].findAncestor("table");
              let l2 = a2, d2 = r2;
              if (t3.isSelectionRectangular(e3)) {
                const t4 = { firstColumn: i2, lastColumn: r2, firstRow: s3, lastRow: a2 };
                l2 = xE(c2, t4), d2 = EE(c2, t4);
              }
              const h2 = fE(c2, { startRow: s3, startColumn: i2, endRow: l2, endColumn: d2 }, n2);
              return n2.insert(h2, o2, 0), o2;
            }) : null;
          }
          setCellSelection(t3, e3) {
            const n2 = this._getCellsToSelect(t3, e3);
            this.editor.model.change((t4) => {
              t4.setSelection(n2.cells.map((e4) => t4.createRangeOn(e4)), { backward: n2.backward });
            });
          }
          getFocusCell() {
            const t3 = [...this.editor.model.document.selection.getRanges()].pop().getContainedElement();
            return t3 && t3.is("element", "tableCell") ? t3 : null;
          }
          getAnchorCell() {
            const t3 = Ii(this.editor.model.document.selection.getRanges()).getContainedElement();
            return t3 && t3.is("element", "tableCell") ? t3 : null;
          }
          _defineSelectionConverter() {
            const t3 = this.editor, e3 = /* @__PURE__ */ new Set();
            t3.conversion.for("editingDowncast").add((t4) => t4.on("selection", (t5, n2, o2) => {
              const i2 = o2.writer;
              !function(t6) {
                for (const n3 of e3)
                  t6.removeClass("ck-editor__editable_selected", n3);
                e3.clear();
              }(i2);
              const r2 = this.getSelectedTableCells();
              if (!r2)
                return;
              for (const t6 of r2) {
                const n3 = o2.mapper.toViewElement(t6);
                i2.addClass("ck-editor__editable_selected", n3), e3.add(n3);
              }
              const s3 = o2.mapper.toViewElement(r2[r2.length - 1]);
              i2.setSelection(s3, 0);
            }, { priority: "lowest" }));
          }
          _enablePluginDisabling() {
            const t3 = this.editor;
            this.on("change:isEnabled", () => {
              if (!this.isEnabled) {
                const e3 = this.getSelectedTableCells();
                if (!e3)
                  return;
                t3.model.change((n2) => {
                  const o2 = n2.createPositionAt(e3[0], 0), i2 = t3.model.schema.getNearestSelectionRange(o2);
                  n2.setSelection(i2);
                });
              }
            });
          }
          _handleDeleteContent(t3, e3) {
            const n2 = this.editor.plugins.get(zE), o2 = e3[0], i2 = e3[1], r2 = this.editor.model, s3 = !i2 || "backward" == i2.direction, a2 = n2.getSelectedTableCells(o2);
            a2.length && (t3.stop(), r2.change((t4) => {
              const e4 = a2[s3 ? a2.length - 1 : 0];
              r2.change((t5) => {
                for (const e5 of a2)
                  r2.deleteContent(t5.createSelection(e5, "in"));
              });
              const n3 = r2.schema.getNearestSelectionRange(t4.createPositionAt(e4, 0));
              o2.is("documentSelection") ? t4.setSelection(n3) : o2.setTo(n3);
            }));
          }
          _handleInsertTextEvent(t3, e3) {
            const n2 = this.editor, o2 = this.getSelectedTableCells();
            if (!o2)
              return;
            const i2 = n2.editing.view, r2 = n2.editing.mapper, s3 = o2.map((t4) => i2.createRangeOn(r2.toViewElement(t4)));
            e3.selection = i2.createSelection(s3);
          }
          _getCellsToSelect(t3, e3) {
            const n2 = this.editor.plugins.get("TableUtils"), o2 = n2.getCellLocation(t3), i2 = n2.getCellLocation(e3), r2 = Math.min(o2.row, i2.row), s3 = Math.max(o2.row, i2.row), a2 = Math.min(o2.column, i2.column), c2 = Math.max(o2.column, i2.column), l2 = new Array(s3 - r2 + 1).fill(null).map(() => []), d2 = { startRow: r2, endRow: s3, startColumn: a2, endColumn: c2 };
            for (const { row: e4, cell: n3 } of new sE(t3.findAncestor("table"), d2))
              l2[e4 - r2].push(n3);
            const h2 = i2.row < o2.row, u2 = i2.column < o2.column;
            return h2 && l2.reverse(), u2 && l2.forEach((t4) => t4.reverse()), { cells: l2.flat(), backward: h2 || u2 };
          }
        }
        class pD extends es {
          static get pluginName() {
            return "TableClipboard";
          }
          static get requires() {
            return [gD, zE];
          }
          init() {
            const t3 = this.editor, e3 = t3.editing.view.document;
            this.listenTo(e3, "copy", (t4, e4) => this._onCopyCut(t4, e4)), this.listenTo(e3, "cut", (t4, e4) => this._onCopyCut(t4, e4)), this.listenTo(t3.model, "insertContent", (t4, [e4, n2]) => this._onInsertContent(t4, e4, n2), { priority: "high" }), this.decorate("_replaceTableSlotCell");
          }
          _onCopyCut(t3, e3) {
            const n2 = this.editor.plugins.get(gD);
            if (!n2.getSelectedTableCells())
              return;
            if ("cut" == t3.name && !this.editor.model.canEditAt(this.editor.model.document.selection))
              return;
            e3.preventDefault(), t3.stop();
            const o2 = this.editor.data, i2 = this.editor.editing.view.document, r2 = o2.toView(n2.getSelectionAsFragment());
            i2.fire("clipboardOutput", { dataTransfer: e3.dataTransfer, content: r2, method: t3.name });
          }
          _onInsertContent(t3, e3, n2) {
            if (n2 && !n2.is("documentSelection"))
              return;
            const o2 = this.editor.model, i2 = this.editor.plugins.get(zE);
            let r2 = this.getTableIfOnlyTableInContent(e3, o2);
            if (!r2)
              return;
            const s3 = i2.getSelectionAffectedTableCells(o2.document.selection);
            s3.length ? (t3.stop(), o2.change((t4) => {
              const e4 = { width: i2.getColumns(r2), height: i2.getRows(r2) }, n3 = function(t5, e5, n4, o4) {
                const i3 = t5[0].findAncestor("table"), r3 = o4.getColumnIndexes(t5), s4 = o4.getRowIndexes(t5), a3 = { firstColumn: r3.first, lastColumn: r3.last, firstRow: s4.first, lastRow: s4.last }, c3 = 1 === t5.length;
                c3 && (a3.lastRow += e5.height - 1, a3.lastColumn += e5.width - 1, function(t6, e6, n5, o5) {
                  const i4 = o5.getColumns(t6), r4 = o5.getRows(t6);
                  n5 > i4 && o5.insertColumns(t6, { at: i4, columns: n5 - i4 });
                  e6 > r4 && o5.insertRows(t6, { at: r4, rows: e6 - r4 });
                }(i3, a3.lastRow + 1, a3.lastColumn + 1, o4));
                c3 || !o4.isSelectionRectangular(t5) ? function(t6, e6, n5) {
                  const { firstRow: o5, lastRow: i4, firstColumn: r4, lastColumn: s5 } = e6, a4 = { first: o5, last: i4 }, c4 = { first: r4, last: s5 };
                  fD(t6, r4, a4, n5), fD(t6, s5 + 1, a4, n5), mD(t6, o5, c4, n5), mD(t6, i4 + 1, c4, n5, o5);
                }(i3, a3, n4) : (a3.lastRow = xE(i3, a3), a3.lastColumn = EE(i3, a3));
                return a3;
              }(s3, e4, t4, i2), o3 = n3.lastRow - n3.firstRow + 1, a2 = n3.lastColumn - n3.firstColumn + 1, c2 = { startRow: 0, startColumn: 0, endRow: Math.min(o3, e4.height) - 1, endColumn: Math.min(a2, e4.width) - 1 };
              r2 = fE(r2, c2, t4);
              const l2 = s3[0].findAncestor("table"), d2 = this._replaceSelectedCellsWithPasted(r2, e4, l2, n3, t4);
              if (this.editor.plugins.get("TableSelection").isEnabled) {
                const e5 = i2.sortRanges(d2.map((e6) => t4.createRangeOn(e6)));
                t4.setSelection(e5);
              } else
                t4.setSelection(d2[0], 0);
            })) : yE(r2, i2);
          }
          _replaceSelectedCellsWithPasted(t3, e3, n2, o2, i2) {
            const { width: r2, height: s3 } = e3, a2 = function(t4, e4, n3) {
              const o3 = new Array(n3).fill(null).map(() => new Array(e4).fill(null));
              for (const { column: e5, row: n4, cell: i3 } of new sE(t4))
                o3[n4][e5] = i3;
              return o3;
            }(t3, r2, s3), c2 = [...new sE(n2, { startRow: o2.firstRow, endRow: o2.lastRow, startColumn: o2.firstColumn, endColumn: o2.lastColumn, includeAllSlots: true })], l2 = [];
            let d2;
            for (const t4 of c2) {
              const { row: e4, column: n3 } = t4;
              n3 === o2.firstColumn && (d2 = t4.getPositionBefore());
              const c3 = e4 - o2.firstRow, h3 = n3 - o2.firstColumn, u3 = a2[c3 % s3][h3 % r2], g3 = u3 ? i2.cloneElement(u3) : null, p3 = this._replaceTableSlotCell(t4, g3, d2, i2);
              p3 && (CE(p3, e4, n3, o2.lastRow, o2.lastColumn, i2), l2.push(p3), d2 = i2.createPositionAfter(p3));
            }
            const h2 = parseInt(n2.getAttribute("headingRows") || "0"), u2 = parseInt(n2.getAttribute("headingColumns") || "0"), g2 = o2.firstRow < h2 && h2 <= o2.lastRow, p2 = o2.firstColumn < u2 && u2 <= o2.lastColumn;
            if (g2) {
              const t4 = mD(n2, h2, { first: o2.firstColumn, last: o2.lastColumn }, i2, o2.firstRow);
              l2.push(...t4);
            }
            if (p2) {
              const t4 = fD(n2, u2, { first: o2.firstRow, last: o2.lastRow }, i2);
              l2.push(...t4);
            }
            return l2;
          }
          _replaceTableSlotCell(t3, e3, n2, o2) {
            const { cell: i2, isAnchor: r2 } = t3;
            return r2 && o2.remove(i2), e3 ? (o2.insert(e3, n2), e3) : null;
          }
          getTableIfOnlyTableInContent(t3, e3) {
            if (!t3.is("documentFragment") && !t3.is("element"))
              return null;
            if (t3.is("element", "table"))
              return t3;
            if (1 == t3.childCount && t3.getChild(0).is("element", "table"))
              return t3.getChild(0);
            const n2 = e3.createRangeIn(t3);
            for (const t4 of n2.getItems())
              if (t4.is("element", "table")) {
                const o2 = e3.createRange(n2.start, e3.createPositionBefore(t4));
                if (e3.hasContent(o2, { ignoreWhitespaces: true }))
                  return null;
                const i2 = e3.createRange(e3.createPositionAfter(t4), n2.end);
                return e3.hasContent(i2, { ignoreWhitespaces: true }) ? null : t4;
              }
            return null;
          }
        }
        function mD(t3, e3, n2, o2, i2 = 0) {
          if (e3 < 1)
            return;
          return kE(t3, e3, i2).filter(({ column: t4, cellWidth: e4 }) => kD(t4, e4, n2)).map(({ cell: t4 }) => bE(t4, e3, o2));
        }
        function fD(t3, e3, n2, o2) {
          if (e3 < 1)
            return;
          return wE(t3, e3).filter(({ row: t4, cellHeight: e4 }) => kD(t4, e4, n2)).map(({ cell: t4, column: n3 }) => AE(t4, n3, e3, o2));
        }
        function kD(t3, e3, n2) {
          const o2 = t3 + e3 - 1, { first: i2, last: r2 } = n2;
          return t3 >= i2 && t3 <= r2 || t3 < i2 && o2 >= i2;
        }
        class bD extends es {
          static get pluginName() {
            return "TableKeyboard";
          }
          static get requires() {
            return [gD, zE];
          }
          init() {
            const t3 = this.editor.editing.view.document;
            this.listenTo(t3, "arrowKey", (...t4) => this._onArrowKey(...t4), { context: "table" }), this.listenTo(t3, "tab", (...t4) => this._handleTabOnSelectedTable(...t4), { context: "figure" }), this.listenTo(t3, "tab", (...t4) => this._handleTab(...t4), { context: ["th", "td"] });
          }
          _handleTabOnSelectedTable(t3, e3) {
            const n2 = this.editor, o2 = n2.model.document.selection.getSelectedElement();
            o2 && o2.is("element", "table") && (e3.preventDefault(), e3.stopPropagation(), t3.stop(), n2.model.change((t4) => {
              t4.setSelection(t4.createRangeIn(o2.getChild(0).getChild(0)));
            }));
          }
          _handleTab(t3, e3) {
            const n2 = this.editor, o2 = this.editor.plugins.get(zE), i2 = this.editor.plugins.get("TableSelection"), r2 = n2.model.document.selection, s3 = !e3.shiftKey;
            let a2 = o2.getTableCellsContainingSelection(r2)[0];
            if (a2 || (a2 = i2.getFocusCell()), !a2)
              return;
            e3.preventDefault(), e3.stopPropagation(), t3.stop();
            const c2 = a2.parent, l2 = c2.parent, d2 = l2.getChildIndex(c2), h2 = c2.getChildIndex(a2), u2 = 0 === h2;
            if (!s3 && u2 && 0 === d2)
              return void n2.model.change((t4) => {
                t4.setSelection(t4.createRangeOn(l2));
              });
            const g2 = h2 === c2.childCount - 1, p2 = d2 === o2.getRows(l2) - 1;
            if (s3 && p2 && g2 && (n2.execute("insertTableRowBelow"), d2 === o2.getRows(l2) - 1))
              return void n2.model.change((t4) => {
                t4.setSelection(t4.createRangeOn(l2));
              });
            let m2;
            if (s3 && g2) {
              const t4 = l2.getChild(d2 + 1);
              m2 = t4.getChild(0);
            } else if (!s3 && u2) {
              const t4 = l2.getChild(d2 - 1);
              m2 = t4.getChild(t4.childCount - 1);
            } else
              m2 = c2.getChild(h2 + (s3 ? 1 : -1));
            n2.model.change((t4) => {
              t4.setSelection(t4.createRangeIn(m2));
            });
          }
          _onArrowKey(t3, e3) {
            const n2 = this.editor, o2 = Ci(e3.keyCode, n2.locale.contentLanguageDirection);
            this._handleArrowKeys(o2, e3.shiftKey) && (e3.preventDefault(), e3.stopPropagation(), t3.stop());
          }
          _handleArrowKeys(t3, e3) {
            const n2 = this.editor.plugins.get(zE), o2 = this.editor.plugins.get("TableSelection"), i2 = this.editor.model, r2 = i2.document.selection, s3 = ["right", "down"].includes(t3), a2 = n2.getSelectedTableCells(r2);
            if (a2.length) {
              let n3;
              return n3 = e3 ? o2.getFocusCell() : s3 ? a2[a2.length - 1] : a2[0], this._navigateFromCellInDirection(n3, t3, e3), true;
            }
            const c2 = r2.focus.findAncestor("tableCell");
            if (!c2)
              return false;
            if (!r2.isCollapsed)
              if (e3) {
                if (r2.isBackward == s3 && !r2.containsEntireContent(c2))
                  return false;
              } else {
                const t4 = r2.getSelectedElement();
                if (!t4 || !i2.schema.isObject(t4))
                  return false;
              }
            return !!this._isSelectionAtCellEdge(r2, c2, s3) && (this._navigateFromCellInDirection(c2, t3, e3), true);
          }
          _isSelectionAtCellEdge(t3, e3, n2) {
            const o2 = this.editor.model, i2 = this.editor.model.schema, r2 = n2 ? t3.getLastPosition() : t3.getFirstPosition();
            if (!i2.getLimitElement(r2).is("element", "tableCell")) {
              return o2.createPositionAt(e3, n2 ? "end" : 0).isTouching(r2);
            }
            const s3 = o2.createSelection(r2);
            return o2.modifySelection(s3, { direction: n2 ? "forward" : "backward" }), r2.isEqual(s3.focus);
          }
          _navigateFromCellInDirection(t3, e3, n2 = false) {
            const o2 = this.editor.model, i2 = t3.findAncestor("table"), r2 = [...new sE(i2, { includeAllSlots: true })], { row: s3, column: a2 } = r2[r2.length - 1], c2 = r2.find(({ cell: e4 }) => e4 == t3);
            let { row: l2, column: d2 } = c2;
            switch (e3) {
              case "left":
                d2--;
                break;
              case "up":
                l2--;
                break;
              case "right":
                d2 += c2.cellWidth;
                break;
              case "down":
                l2 += c2.cellHeight;
            }
            if (l2 < 0 || l2 > s3 || d2 < 0 && l2 <= 0 || d2 > a2 && l2 >= s3)
              return void o2.change((t4) => {
                t4.setSelection(t4.createRangeOn(i2));
              });
            d2 < 0 ? (d2 = n2 ? 0 : a2, l2--) : d2 > a2 && (d2 = n2 ? a2 : 0, l2++);
            const h2 = r2.find((t4) => t4.row == l2 && t4.column == d2).cell, u2 = ["right", "down"].includes(e3), g2 = this.editor.plugins.get("TableSelection");
            if (n2 && g2.isEnabled) {
              const e4 = g2.getAnchorCell() || t3;
              g2.setCellSelection(e4, h2);
            } else {
              const t4 = o2.createPositionAt(h2, u2 ? 0 : "end");
              o2.change((e4) => {
                e4.setSelection(t4);
              });
            }
          }
        }
        class wD extends Hc {
          constructor() {
            super(...arguments), this.domEventType = ["mousemove", "mouseleave"];
          }
          onDomEvent(t3) {
            this.fire(t3.type, t3);
          }
        }
        class AD extends es {
          static get pluginName() {
            return "TableMouse";
          }
          static get requires() {
            return [gD, zE];
          }
          init() {
            this.editor.editing.view.addObserver(wD), this._enableShiftClickSelection(), this._enableMouseDragSelection();
          }
          _enableShiftClickSelection() {
            const t3 = this.editor, e3 = t3.plugins.get(zE);
            let n2 = false;
            const o2 = t3.plugins.get(gD);
            this.listenTo(t3.editing.view.document, "mousedown", (i2, r2) => {
              const s3 = t3.model.document.selection;
              if (!this.isEnabled || !o2.isEnabled)
                return;
              if (!r2.domEvent.shiftKey)
                return;
              const a2 = o2.getAnchorCell() || e3.getTableCellsContainingSelection(s3)[0];
              if (!a2)
                return;
              const c2 = this._getModelTableCellFromDomEvent(r2);
              c2 && CD(a2, c2) && (n2 = true, o2.setCellSelection(a2, c2), r2.preventDefault());
            }), this.listenTo(t3.editing.view.document, "mouseup", () => {
              n2 = false;
            }), this.listenTo(t3.editing.view.document, "selectionChange", (t4) => {
              n2 && t4.stop();
            }, { priority: "highest" });
          }
          _enableMouseDragSelection() {
            const t3 = this.editor;
            let e3, n2, o2 = false, i2 = false;
            const r2 = t3.plugins.get(gD);
            this.listenTo(t3.editing.view.document, "mousedown", (t4, n3) => {
              this.isEnabled && r2.isEnabled && (n3.domEvent.shiftKey || n3.domEvent.ctrlKey || n3.domEvent.altKey || (e3 = this._getModelTableCellFromDomEvent(n3)));
            }), this.listenTo(t3.editing.view.document, "mousemove", (t4, s3) => {
              if (!s3.domEvent.buttons)
                return;
              if (!e3)
                return;
              const a2 = this._getModelTableCellFromDomEvent(s3);
              a2 && CD(e3, a2) && (n2 = a2, o2 || n2 == e3 || (o2 = true)), o2 && (i2 = true, r2.setCellSelection(e3, n2), s3.preventDefault());
            }), this.listenTo(t3.editing.view.document, "mouseup", () => {
              o2 = false, i2 = false, e3 = null, n2 = null;
            }), this.listenTo(t3.editing.view.document, "selectionChange", (t4) => {
              i2 && t4.stop();
            }, { priority: "highest" });
          }
          _getModelTableCellFromDomEvent(t3) {
            const e3 = t3.target, n2 = this.editor.editing.view.createPositionAt(e3, 0);
            return this.editor.editing.mapper.toModelPosition(n2).parent.findAncestor("tableCell", { includeSelf: true });
          }
        }
        function CD(t3, e3) {
          return t3.parent.parent == e3.parent.parent;
        }
        var _D = n(6306), vD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(_D.Z, vD);
        _D.Z.locals;
        function yD(t3) {
          const e3 = t3.getSelectedElement();
          return e3 && ED(e3) ? e3 : null;
        }
        function xD(t3) {
          const e3 = t3.getFirstPosition();
          if (!e3)
            return null;
          let n2 = e3.parent;
          for (; n2; ) {
            if (n2.is("element") && ED(n2))
              return n2;
            n2 = n2.parent;
          }
          return null;
        }
        function ED(t3) {
          return !!t3.getCustomProperty("table") && lb(t3);
        }
        var DD = n(7368), ID = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(DD.Z, ID);
        DD.Z.locals;
        Object.defineProperty, Object.defineProperties, Object.getOwnPropertyDescriptors, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        var SD = n(9247), TD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(SD.Z, TD);
        SD.Z.locals;
        var MD = n(4070), BD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(MD.Z, BD);
        MD.Z.locals;
        var ND = n(6237), PD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(ND.Z, PD);
        ND.Z.locals;
        var zD = n(5087), OD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(zD.Z, OD);
        zD.Z.locals;
        const LD = am.defaultPositions;
        LD.northArrowSouth, LD.northArrowSouthWest, LD.northArrowSouthEast, LD.southArrowNorth, LD.southArrowNorthWest, LD.southArrowNorthEast, LD.viewportStickyNorth;
        Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        Object.defineProperty, Object.getOwnPropertySymbols, Object.prototype.hasOwnProperty, Object.prototype.propertyIsEnumerable;
        var RD = n(7341), jD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(RD.Z, jD);
        RD.Z.locals;
        var FD = n(2128), VD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(FD.Z, VD);
        FD.Z.locals;
        var UD = n(4101), HD = { injectType: "singletonStyleTag", attributes: { "data-cke": true }, insert: "head", singleton: true };
        ji()(UD.Z, HD);
        UD.Z.locals;
        var qD = Object.defineProperty, GD = Object.getOwnPropertySymbols, WD = Object.prototype.hasOwnProperty, KD = Object.prototype.propertyIsEnumerable, ZD = (t3, e3, n2) => e3 in t3 ? qD(t3, e3, { enumerable: true, configurable: true, writable: true, value: n2 }) : t3[e3] = n2, YD = (t3, e3) => {
          for (var n2 in e3 || (e3 = {}))
            WD.call(e3, n2) && ZD(t3, n2, e3[n2]);
          if (GD)
            for (var n2 of GD(e3))
              KD.call(e3, n2) && ZD(t3, n2, e3[n2]);
          return t3;
        };
        const $D = { autoRefresh: true }, QD = 36e5;
        class JD extends W() {
          constructor(t3, e3 = {}) {
            if (super(), !t3)
              throw new A("token-missing-token-url", this);
            e3.initValue && this._validateTokenValue(e3.initValue), this.set("value", e3.initValue), this._refresh = "function" == typeof t3 ? t3 : () => {
              return e4 = t3, new Promise((t4, n2) => {
                const o2 = new XMLHttpRequest();
                o2.open("GET", e4), o2.addEventListener("load", () => {
                  const e5 = o2.status, i2 = o2.response;
                  return e5 < 200 || e5 > 299 ? n2(new A("token-cannot-download-new-token", null)) : t4(i2);
                }), o2.addEventListener("error", () => n2(new Error("Network Error"))), o2.addEventListener("abort", () => n2(new Error("Abort"))), o2.send();
              });
              var e4;
            }, this._options = YD(YD({}, $D), e3);
          }
          init() {
            return new Promise((t3, e3) => {
              this.value ? (this._options.autoRefresh && this._registerRefreshTokenTimeout(), t3(this)) : this.refreshToken().then(t3).catch(e3);
            });
          }
          refreshToken() {
            return this._refresh().then((t3) => (this._validateTokenValue(t3), this.set("value", t3), this._options.autoRefresh && this._registerRefreshTokenTimeout(), this));
          }
          destroy() {
            clearTimeout(this._tokenRefreshTimeout);
          }
          _validateTokenValue(t3) {
            const e3 = "string" == typeof t3, n2 = !/^".*"$/.test(t3), o2 = e3 && 3 === t3.split(".").length;
            if (!n2 || !o2)
              throw new A("token-not-in-jwt-format", this);
          }
          _registerRefreshTokenTimeout() {
            const t3 = this._getTokenRefreshTimeoutTime();
            clearTimeout(this._tokenRefreshTimeout), this._tokenRefreshTimeout = setTimeout(() => {
              this.refreshToken();
            }, t3);
          }
          _getTokenRefreshTimeoutTime() {
            try {
              const [, t3] = this.value.split("."), { exp: e3 } = JSON.parse(atob(t3));
              if (!e3)
                return QD;
              return Math.floor((1e3 * e3 - Date.now()) / 2);
            } catch (t3) {
              return QD;
            }
          }
          static create(t3, e3 = {}) {
            return new JD(t3, e3).init();
          }
        }
        const XD = /^data:(\S*?);base64,/;
        class tI extends M() {
          constructor(t3, e3, n2) {
            if (super(), !t3)
              throw new A("fileuploader-missing-file", null);
            if (!e3)
              throw new A("fileuploader-missing-token", null);
            if (!n2)
              throw new A("fileuploader-missing-api-address", null);
            this.file = function(t4) {
              if ("string" != typeof t4)
                return false;
              const e4 = t4.match(XD);
              return !(!e4 || !e4.length);
            }(t3) ? function(t4, e4 = 512) {
              try {
                const n3 = t4.match(XD)[1], o2 = atob(t4.replace(XD, "")), i2 = [];
                for (let t5 = 0; t5 < o2.length; t5 += e4) {
                  const n4 = o2.slice(t5, t5 + e4), r2 = new Array(n4.length);
                  for (let t6 = 0; t6 < n4.length; t6++)
                    r2[t6] = n4.charCodeAt(t6);
                  i2.push(new Uint8Array(r2));
                }
                return new Blob(i2, { type: n3 });
              } catch (t5) {
                throw new A("fileuploader-decoding-image-data-error", null);
              }
            }(t3) : t3, this._token = e3, this._apiAddress = n2;
          }
          onProgress(t3) {
            return this.on("progress", (e3, n2) => t3(n2)), this;
          }
          onError(t3) {
            return this.once("error", (e3, n2) => t3(n2)), this;
          }
          abort() {
            this.xhr.abort();
          }
          send() {
            return this._prepareRequest(), this._attachXHRListeners(), this._sendRequest();
          }
          _prepareRequest() {
            const t3 = new XMLHttpRequest();
            t3.open("POST", this._apiAddress), t3.setRequestHeader("Authorization", this._token.value), t3.responseType = "json", this.xhr = t3;
          }
          _attachXHRListeners() {
            const t3 = this.xhr, e3 = (t4) => () => this.fire("error", t4);
            t3.addEventListener("error", e3("Network Error")), t3.addEventListener("abort", e3("Abort")), t3.upload && t3.upload.addEventListener("progress", (t4) => {
              t4.lengthComputable && this.fire("progress", { total: t4.total, uploaded: t4.loaded });
            }), t3.addEventListener("load", () => {
              const e4 = t3.status, n2 = t3.response;
              if (e4 < 200 || e4 > 299)
                return this.fire("error", n2.message || n2.error);
            });
          }
          _sendRequest() {
            const t3 = new FormData(), e3 = this.xhr;
            return t3.append("file", this.file), new Promise((n2, o2) => {
              e3.addEventListener("load", () => {
                const t4 = e3.status, i2 = e3.response;
                return t4 < 200 || t4 > 299 ? i2.message ? o2(new A("fileuploader-uploading-data-failed", this, { message: i2.message })) : o2(i2.error) : n2(i2);
              }), e3.addEventListener("error", () => o2(new Error("Network Error"))), e3.addEventListener("abort", () => o2(new Error("Abort"))), e3.send(t3);
            });
          }
        }
        class eI {
          constructor(t3, e3) {
            if (!t3)
              throw new A("uploadgateway-missing-token", null);
            if (!e3)
              throw new A("uploadgateway-missing-api-address", null);
            this._token = t3, this._apiAddress = e3;
          }
          upload(t3) {
            return new tI(t3, this._token, this._apiAddress);
          }
        }
        class nI extends cs {
          static get pluginName() {
            return "CloudServicesCore";
          }
          createToken(t3, e3) {
            return new JD(t3, e3);
          }
          createUploadGateway(t3, e3) {
            return new eI(t3, e3);
          }
        }
        var oI = (t3, e3, n2) => new Promise((o2, i2) => {
          var r2 = (t4) => {
            try {
              a2(n2.next(t4));
            } catch (t5) {
              i2(t5);
            }
          }, s3 = (t4) => {
            try {
              a2(n2.throw(t4));
            } catch (t5) {
              i2(t5);
            }
          }, a2 = (t4) => t4.done ? o2(t4.value) : Promise.resolve(t4.value).then(r2, s3);
          a2((n2 = n2.apply(t3, e3)).next());
        });
        class iI extends rk {
        }
        iI.builtinPlugins = [class extends es {
          static get requires() {
            return [aw, Qk, gw, eb, Dk, Iw];
          }
          static get pluginName() {
            return "Essentials";
          }
        }, class extends es {
          static get requires() {
            return [Tw];
          }
          static get pluginName() {
            return "CKFinderUploadAdapter";
          }
          init() {
            const t3 = this.editor.config.get("ckfinder.uploadUrl");
            t3 && (this.editor.plugins.get(Tw).createUploadAdapter = (e3) => new Lw(e3, t3, this.editor.t));
          }
        }, class extends es {
          static get requires() {
            return [Ek];
          }
          static get pluginName() {
            return "Autoformat";
          }
          afterInit() {
            this._addListAutoformats(), this._addBasicStylesAutoformats(), this._addHeadingAutoformats(), this._addBlockQuoteAutoformats(), this._addCodeBlockAutoformats(), this._addHorizontalLineAutoformats();
          }
          _addListAutoformats() {
            const t3 = this.editor.commands;
            t3.get("bulletedList") && Rw(this.editor, this, /^[*-]\s$/, "bulletedList"), t3.get("numberedList") && Rw(this.editor, this, /^1[.|)]\s$/, "numberedList"), t3.get("todoList") && Rw(this.editor, this, /^\[\s?\]\s$/, "todoList"), t3.get("checkTodoList") && Rw(this.editor, this, /^\[\s?x\s?\]\s$/, () => {
              this.editor.execute("todoList"), this.editor.execute("checkTodoList");
            });
          }
          _addBasicStylesAutoformats() {
            const t3 = this.editor.commands;
            if (t3.get("bold")) {
              const t4 = Vw(this.editor, "bold");
              jw(this.editor, this, /(?:^|\s)(\*\*)([^*]+)(\*\*)$/g, t4), jw(this.editor, this, /(?:^|\s)(__)([^_]+)(__)$/g, t4);
            }
            if (t3.get("italic")) {
              const t4 = Vw(this.editor, "italic");
              jw(this.editor, this, /(?:^|\s)(\*)([^*_]+)(\*)$/g, t4), jw(this.editor, this, /(?:^|\s)(_)([^_]+)(_)$/g, t4);
            }
            if (t3.get("code")) {
              const t4 = Vw(this.editor, "code");
              jw(this.editor, this, /(`)([^`]+)(`)$/g, t4);
            }
            if (t3.get("strikethrough")) {
              const t4 = Vw(this.editor, "strikethrough");
              jw(this.editor, this, /(~~)([^~]+)(~~)$/g, t4);
            }
          }
          _addHeadingAutoformats() {
            const t3 = this.editor.commands.get("heading");
            t3 && t3.modelElements.filter((t4) => t4.match(/^heading[1-6]$/)).forEach((e3) => {
              const n2 = e3[7], o2 = new RegExp(`^(#{${n2}})\\s$`);
              Rw(this.editor, this, o2, () => {
                if (!t3.isEnabled || t3.value === e3)
                  return false;
                this.editor.execute("heading", { value: e3 });
              });
            });
          }
          _addBlockQuoteAutoformats() {
            this.editor.commands.get("blockQuote") && Rw(this.editor, this, /^>\s$/, "blockQuote");
          }
          _addCodeBlockAutoformats() {
            const t3 = this.editor, e3 = t3.model.document.selection;
            t3.commands.get("codeBlock") && Rw(t3, this, /^```$/, () => {
              if (e3.getFirstPosition().parent.is("element", "listItem"))
                return false;
              this.editor.execute("codeBlock", { usePreviousLanguageChoice: true });
            });
          }
          _addHorizontalLineAutoformats() {
            this.editor.commands.get("horizontalLine") && Rw(this.editor, this, /^---$/, "horizontalLine");
          }
        }, class extends es {
          static get requires() {
            return [qw, Ww];
          }
          static get pluginName() {
            return "Bold";
          }
        }, class extends es {
          static get requires() {
            return [$w, Jw];
          }
          static get pluginName() {
            return "Italic";
          }
        }, class extends es {
          static get requires() {
            return [oA, sA];
          }
          static get pluginName() {
            return "BlockQuote";
          }
        }, class extends es {
          static get pluginName() {
            return "CKBox";
          }
          static get requires() {
            return [HA, aA];
          }
        }, class extends es {
          static get pluginName() {
            return "CKFinder";
          }
          static get requires() {
            return ["Link", "CKFinderUploadAdapter", JA, YA];
          }
        }, class extends cs {
          constructor() {
            super(...arguments), this.token = null, this._tokens = /* @__PURE__ */ new Map();
          }
          static get pluginName() {
            return "CloudServices";
          }
          static get requires() {
            return [nI];
          }
          init() {
            return oI(this, null, function* () {
              const t3 = this.context.config.get("cloudServices") || {};
              for (const [e4, n2] of Object.entries(t3))
                this[e4] = n2;
              if (!this.tokenUrl)
                return void (this.token = null);
              const e3 = this.context.plugins.get("CloudServicesCore");
              this.token = yield e3.createToken(this.tokenUrl).init(), this._tokens.set(this.tokenUrl, this.token);
            });
          }
          registerTokenUrl(t3) {
            return oI(this, null, function* () {
              if (this._tokens.has(t3))
                return this.getTokenFor(t3);
              const e3 = this.context.plugins.get("CloudServicesCore"), n2 = yield e3.createToken(t3).init();
              return this._tokens.set(t3, n2), n2;
            });
          }
          getTokenFor(t3) {
            const e3 = this._tokens.get(t3);
            if (!e3)
              throw new A("cloudservices-token-not-registered", this);
            return e3;
          }
          destroy() {
            super.destroy();
            for (const t3 of this._tokens.values())
              t3.destroy();
          }
        }, class extends es {
          static get pluginName() {
            return "EasyImage";
          }
          static get requires() {
            return [XA, "ImageUpload"];
          }
          init() {
            const t3 = this.editor;
            t3.plugins.has("ImageBlockEditing") || t3.plugins.has("ImageInlineEditing") || C("easy-image-image-feature-missing", t3);
          }
        }, class extends es {
          static get requires() {
            return [lC, uC];
          }
          static get pluginName() {
            return "Heading";
          }
        }, class extends es {
          static get requires() {
            return [c_, d_];
          }
          static get pluginName() {
            return "Image";
          }
        }, class extends es {
          static get requires() {
            return [g_, p_];
          }
          static get pluginName() {
            return "ImageCaption";
          }
        }, class extends es {
          static get requires() {
            return [hv, pv];
          }
          static get pluginName() {
            return "ImageStyle";
          }
        }, class extends es {
          static get requires() {
            return [Nb, xC];
          }
          static get pluginName() {
            return "ImageToolbar";
          }
          afterInit() {
            const t3 = this.editor, e3 = t3.t, n2 = t3.plugins.get(Nb), o2 = t3.plugins.get("ImageUtils");
            var i2;
            n2.register("image", { ariaLabel: e3("Image toolbar"), items: (i2 = t3.config.get("image.toolbar") || [], i2.map((t4) => j(t4) ? t4.name : t4)), getRelatedElement: (t4) => o2.getClosestSelectedImageWidget(t4) });
          }
        }, class extends es {
          static get pluginName() {
            return "ImageUpload";
          }
          static get requires() {
            return [V_, A_, D_];
          }
        }, class extends es {
          static get pluginName() {
            return "Indent";
          }
          static get requires() {
            return [bv, Cv];
          }
        }, class extends es {
          static get requires() {
            return [gy, Cy, yy];
          }
          static get pluginName() {
            return "Link";
          }
        }, class extends es {
          static get requires() {
            return [mx, Uy];
          }
          static get pluginName() {
            return "List";
          }
        }, class extends es {
          static get requires() {
            return [Ix, Px, Tx, Mb];
          }
          static get pluginName() {
            return "MediaEmbed";
          }
        }, rC, class extends es {
          static get pluginName() {
            return "PasteFromOffice";
          }
          static get requires() {
            return [uk];
          }
          init() {
            const t3 = this.editor, e3 = t3.plugins.get("ClipboardPipeline"), n2 = t3.editing.view.document, o2 = [];
            o2.push(new Gx(n2)), o2.push(new Yx(n2)), o2.push(new Qx(n2)), e3.on("inputTransformation", (e4, i2) => {
              if (i2._isTransformedWithPasteFromOffice)
                return;
              if (t3.model.document.selection.getFirstPosition().parent.is("element", "codeBlock"))
                return;
              const r2 = i2.dataTransfer.getData("text/html"), s3 = o2.find((t4) => t4.isActive(r2));
              s3 && (i2._parsedData || (i2._parsedData = Xx(r2, n2.stylesProcessor)), s3.execute(i2), i2._isTransformedWithPasteFromOffice = true);
            }, { priority: "high" });
          }
        }, class extends es {
          static get requires() {
            return [ZC, xC];
          }
          static get pluginName() {
            return "PictureEditing";
          }
          afterInit() {
            const t3 = this.editor;
            t3.plugins.has("ImageBlockEditing") && t3.model.schema.extend("imageBlock", { allowAttributes: ["sources"] }), t3.plugins.has("ImageInlineEditing") && t3.model.schema.extend("imageInline", { allowAttributes: ["sources"] }), this._setupConversion(), this._setupImageUploadEditingIntegration();
          }
          _setupConversion() {
            const t3 = this.editor, e3 = t3.conversion, n2 = t3.plugins.get("ImageUtils");
            e3.for("upcast").add(function(t4) {
              const e4 = ["srcset", "media", "type", "sizes"], n3 = (n4, o2, i2) => {
                const r2 = o2.viewItem;
                if (!i2.consumable.test(r2, { name: true }))
                  return;
                const s3 = /* @__PURE__ */ new Map();
                for (const t5 of r2.getChildren())
                  if (t5.is("element", "source")) {
                    const n5 = {};
                    for (const o3 of e4)
                      t5.hasAttribute(o3) && i2.consumable.test(t5, { attributes: o3 }) && (n5[o3] = t5.getAttribute(o3));
                    Object.keys(n5).length && s3.set(t5, n5);
                  }
                const a2 = t4.findViewImgElement(r2);
                if (!a2)
                  return;
                let c2 = o2.modelCursor.parent;
                if (!c2.is("element", "imageBlock")) {
                  const t5 = i2.convertItem(a2, o2.modelCursor);
                  o2.modelRange = t5.modelRange, o2.modelCursor = t5.modelCursor, c2 = Ii(t5.modelRange.getItems());
                }
                i2.consumable.consume(r2, { name: true });
                for (const [t5, e5] of s3)
                  i2.consumable.consume(t5, { attributes: Object.keys(e5) });
                s3.size && i2.writer.setAttribute("sources", Array.from(s3.values()), c2), i2.convertChildren(r2, c2);
              };
              return (t5) => {
                t5.on("element:picture", n3);
              };
            }(n2)), e3.for("downcast").add(function(t4) {
              const e4 = (e5, n3, o2) => {
                if (!o2.consumable.consume(n3.item, e5.name))
                  return;
                const i2 = o2.writer, r2 = o2.mapper.toViewElement(n3.item), s3 = t4.findViewImgElement(r2), a2 = n3.attributeNewValue;
                if (a2 && a2.length) {
                  const t5 = i2.createContainerElement("picture", null, a2.map((t6) => i2.createEmptyElement("source", t6))), e6 = [];
                  let n4 = s3.parent;
                  for (; n4 && n4.is("attributeElement"); ) {
                    const t6 = n4.parent;
                    i2.unwrap(i2.createRangeOn(s3), n4), e6.unshift(n4), n4 = t6;
                  }
                  i2.insert(i2.createPositionBefore(s3), t5), i2.move(i2.createRangeOn(s3), i2.createPositionAt(t5, "end"));
                  for (const n5 of e6)
                    i2.wrap(i2.createRangeOn(t5), n5);
                } else if (s3.parent.is("element", "picture")) {
                  const t5 = s3.parent;
                  i2.move(i2.createRangeOn(s3), i2.createPositionBefore(t5)), i2.remove(t5);
                }
              };
              return (t5) => {
                t5.on("attribute:sources:imageBlock", e4), t5.on("attribute:sources:imageInline", e4);
              };
            }(n2));
          }
          _setupImageUploadEditingIntegration() {
            const t3 = this.editor;
            if (!t3.plugins.has("ImageUploadEditing"))
              return;
            const e3 = t3.plugins.get("ImageUploadEditing");
            this.listenTo(e3, "uploadComplete", (e4, { imageElement: n2, data: o2 }) => {
              const i2 = o2.sources;
              i2 && t3.model.change((t4) => {
                t4.setAttributes({ sources: i2 }, n2);
              });
            });
          }
        }, class extends es {
          static get requires() {
            return [iD, lD, gD, AD, bD, pD, Mb];
          }
          static get pluginName() {
            return "Table";
          }
        }, class extends es {
          static get requires() {
            return [Nb];
          }
          static get pluginName() {
            return "TableToolbar";
          }
          afterInit() {
            const t3 = this.editor, e3 = t3.t, n2 = t3.plugins.get(Nb), o2 = t3.config.get("table.contentToolbar"), i2 = t3.config.get("table.tableToolbar");
            o2 && n2.register("tableContent", { ariaLabel: e3("Table toolbar"), items: o2, getRelatedElement: xD }), i2 && n2.register("table", { ariaLabel: e3("Table toolbar"), items: i2, getRelatedElement: yD });
          }
        }, class extends es {
          static get requires() {
            return ["Delete", "Input"];
          }
          static get pluginName() {
            return "TextTransformation";
          }
          constructor(t3) {
            super(t3), t3.config.define("typing", { transformations: { include: jk } });
          }
          init() {
            const t3 = this.editor.model.document.selection;
            t3.on("change:range", () => {
              this.isEnabled = !t3.anchor.parent.is("element", "codeBlock");
            }), this._enableTransformationWatchers();
          }
          _enableTransformationWatchers() {
            const t3 = this.editor, e3 = t3.model, n2 = t3.plugins.get("Delete"), o2 = function(t4) {
              const e4 = t4.extra || [], n3 = t4.remove || [], o3 = (t5) => !n3.includes(t5);
              return function(t5) {
                const e5 = /* @__PURE__ */ new Set();
                for (const n4 of t5)
                  if ("string" == typeof n4 && Rk[n4])
                    for (const t6 of Rk[n4])
                      e5.add(t6);
                  else
                    e5.add(n4);
                return Array.from(e5);
              }(t4.include.concat(e4).filter(o3)).filter(o3).map((t5) => "string" == typeof t5 && Lk[t5] ? Lk[t5] : t5).filter((t5) => "object" == typeof t5).map((t5) => ({ from: Fk(t5.from), to: Vk(t5.to) }));
            }(t3.config.get("typing.transformations")), i2 = new Sk(t3.model, (t4) => {
              for (const e4 of o2) {
                if (e4.from.test(t4))
                  return { normalizedTransformation: e4 };
              }
            });
            i2.on("matched:data", (t4, o3) => {
              if (!o3.batch.isTyping)
                return;
              const { from: i3, to: r2 } = o3.normalizedTransformation, s3 = i3.exec(o3.text), a2 = r2(s3.slice(1)), c2 = o3.range;
              let l2 = s3.index;
              e3.enqueueChange((t5) => {
                for (let n3 = 1; n3 < s3.length; n3++) {
                  const o4 = s3[n3], i4 = a2[n3 - 1];
                  if (null == i4) {
                    l2 += o4.length;
                    continue;
                  }
                  const r3 = c2.start.getShiftedBy(l2), d2 = e3.createRange(r3, r3.getShiftedBy(o4.length)), h2 = Uk(r3);
                  e3.insertContent(t5.createText(i4, h2), d2), l2 += i4.length;
                }
                e3.enqueueChange(() => {
                  n2.requestUndoOnBackspace();
                });
              });
            }), i2.bind("isEnabled").to(this);
          }
        }], iI.defaultConfig = { toolbar: { items: ["undo", "redo", "|", "heading", "|", "bold", "italic", "|", "link", "uploadImage", "insertTable", "blockQuote", "mediaEmbed", "|", "bulletedList", "numberedList", "outdent", "indent"] }, image: { toolbar: ["imageStyle:inline", "imageStyle:block", "imageStyle:side", "|", "toggleImageCaption", "imageTextAlternative"] }, table: { contentToolbar: ["tableColumn", "tableRow", "mergeTableCells"] }, language: "en" };
      })(), o = o.default;
    })());
  }
});

// ../../node_modules/@ckeditor/ckeditor5-react/dist/index.js
var require_dist = __commonJS({
  "../../node_modules/@ckeditor/ckeditor5-react/dist/index.js"(exports, module2) {
    "use strict";
    !function(t, e) {
      "object" == typeof exports && "object" == typeof module2 ? module2.exports = e(require("react")) : "function" == typeof define && define.amd ? define(["react"], e) : "object" == typeof exports ? exports.CKEditor = e(require("react")) : t.CKEditor = e(t.React);
    }(self, (t) => (() => {
      var e = { 703: (t2, e2, r2) => {
        "use strict";
        var o2 = r2(414);
        function n2() {
        }
        function s2() {
        }
        s2.resetWarningCache = n2, t2.exports = function() {
          function t3(t4, e4, r4, n3, s3, i) {
            if (i !== o2) {
              var a = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
              throw a.name = "Invariant Violation", a;
            }
          }
          function e3() {
            return t3;
          }
          t3.isRequired = t3;
          var r3 = { array: t3, bigint: t3, bool: t3, func: t3, number: t3, object: t3, string: t3, symbol: t3, any: t3, arrayOf: e3, element: t3, elementType: t3, instanceOf: e3, node: t3, objectOf: e3, oneOf: e3, oneOfType: e3, shape: e3, exact: e3, checkPropTypes: s2, resetWarningCache: n2 };
          return r3.PropTypes = r3, r3;
        };
      }, 697: (t2, e2, r2) => {
        t2.exports = r2(703)();
      }, 414: (t2) => {
        "use strict";
        t2.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
      }, 787: (e2) => {
        "use strict";
        e2.exports = t;
      } }, r = {};
      function o(t2) {
        var n2 = r[t2];
        if (void 0 !== n2)
          return n2.exports;
        var s2 = r[t2] = { exports: {} };
        return e[t2](s2, s2.exports, o), s2.exports;
      }
      o.n = (t2) => {
        var e2 = t2 && t2.__esModule ? () => t2.default : () => t2;
        return o.d(e2, { a: e2 }), e2;
      }, o.d = (t2, e2) => {
        for (var r2 in e2)
          o.o(e2, r2) && !o.o(t2, r2) && Object.defineProperty(t2, r2, { enumerable: true, get: e2[r2] });
      }, o.o = (t2, e2) => Object.prototype.hasOwnProperty.call(t2, e2), o.r = (t2) => {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(t2, Symbol.toStringTag, { value: "Module" }), Object.defineProperty(t2, "__esModule", { value: true });
      };
      var n = {};
      return (() => {
        "use strict";
        o.r(n), o.d(n, { CKEditor: () => eo, CKEditorContext: () => Zr, useMultiRootEditor: () => no });
        var t2 = o(787), e2 = o.n(t2), r2 = o(697), s2 = o.n(r2);
        const i = new Array(256).fill("").map((t3, e3) => ("0" + e3.toString(16)).slice(-2));
        class a {
          constructor(t3) {
            if (this.crashes = [], this.state = "initializing", this._now = Date.now, this.crashes = [], this._crashNumberLimit = "number" == typeof t3.crashNumberLimit ? t3.crashNumberLimit : 3, this._minimumNonErrorTimePeriod = "number" == typeof t3.minimumNonErrorTimePeriod ? t3.minimumNonErrorTimePeriod : 5e3, this._boundErrorHandler = (t4) => {
              const e3 = "error" in t4 ? t4.error : t4.reason;
              e3 instanceof Error && this._handleError(e3, t4);
            }, this._listeners = {}, !this._restart)
              throw new Error("The Watchdog class was split into the abstract `Watchdog` class and the `EditorWatchdog` class. Please, use `EditorWatchdog` if you have used the `Watchdog` class previously.");
          }
          destroy() {
            this._stopErrorHandling(), this._listeners = {};
          }
          on(t3, e3) {
            this._listeners[t3] || (this._listeners[t3] = []), this._listeners[t3].push(e3);
          }
          off(t3, e3) {
            this._listeners[t3] = this._listeners[t3].filter((t4) => t4 !== e3);
          }
          _fire(t3, ...e3) {
            const r3 = this._listeners[t3] || [];
            for (const t4 of r3)
              t4.apply(this, [null, ...e3]);
          }
          _startErrorHandling() {
            window.addEventListener("error", this._boundErrorHandler), window.addEventListener("unhandledrejection", this._boundErrorHandler);
          }
          _stopErrorHandling() {
            window.removeEventListener("error", this._boundErrorHandler), window.removeEventListener("unhandledrejection", this._boundErrorHandler);
          }
          _handleError(t3, e3) {
            if (this._shouldReactToError(t3)) {
              this.crashes.push({ message: t3.message, stack: t3.stack, filename: e3 instanceof ErrorEvent ? e3.filename : void 0, lineno: e3 instanceof ErrorEvent ? e3.lineno : void 0, colno: e3 instanceof ErrorEvent ? e3.colno : void 0, date: this._now() });
              const r3 = this._shouldRestart();
              this.state = "crashed", this._fire("stateChange"), this._fire("error", { error: t3, causesRestart: r3 }), r3 ? this._restart() : (this.state = "crashedPermanently", this._fire("stateChange"));
            }
          }
          _shouldReactToError(t3) {
            return t3.is && t3.is("CKEditorError") && void 0 !== t3.context && null !== t3.context && "ready" === this.state && this._isErrorComingFromThisItem(t3);
          }
          _shouldRestart() {
            if (this.crashes.length <= this._crashNumberLimit)
              return true;
            return (this.crashes[this.crashes.length - 1].date - this.crashes[this.crashes.length - 1 - this._crashNumberLimit].date) / this._crashNumberLimit > this._minimumNonErrorTimePeriod;
          }
        }
        function c(t3, e3 = /* @__PURE__ */ new Set()) {
          const r3 = [t3], o2 = /* @__PURE__ */ new Set();
          let n2 = 0;
          for (; r3.length > n2; ) {
            const t4 = r3[n2++];
            if (!o2.has(t4) && u(t4) && !e3.has(t4))
              if (o2.add(t4), Symbol.iterator in t4)
                try {
                  for (const e4 of t4)
                    r3.push(e4);
                } catch (t5) {
                }
              else
                for (const e4 in t4)
                  "defaultValue" !== e4 && r3.push(t4[e4]);
          }
          return o2;
        }
        function u(t3) {
          const e3 = Object.prototype.toString.call(t3), r3 = typeof t3;
          return !("number" === r3 || "boolean" === r3 || "string" === r3 || "symbol" === r3 || "function" === r3 || "[object Date]" === e3 || "[object RegExp]" === e3 || "[object Module]" === e3 || null == t3 || t3._watchdogExcluded || t3 instanceof EventTarget || t3 instanceof Event);
        }
        function d(t3, e3, r3 = /* @__PURE__ */ new Set()) {
          if (t3 === e3 && ("object" == typeof (o2 = t3) && null !== o2))
            return true;
          var o2;
          const n2 = c(t3, r3), s3 = c(e3, r3);
          for (const t4 of n2)
            if (s3.has(t4))
              return true;
          return false;
        }
        const h = function(t3) {
          var e3 = typeof t3;
          return null != t3 && ("object" == e3 || "function" == e3);
        };
        const l = "object" == typeof global && global && global.Object === Object && global;
        var f = "object" == typeof self && self && self.Object === Object && self;
        const p = l || f || Function("return this")();
        const g = function() {
          return p.Date.now();
        };
        var _ = /\s/;
        const y2 = function(t3) {
          for (var e3 = t3.length; e3-- && _.test(t3.charAt(e3)); )
            ;
          return e3;
        };
        var b = /^\s+/;
        const m = function(t3) {
          return t3 ? t3.slice(0, y2(t3) + 1).replace(b, "") : t3;
        };
        const v = p.Symbol;
        var w = Object.prototype, j = w.hasOwnProperty, E = w.toString, x2 = v ? v.toStringTag : void 0;
        const O = function(t3) {
          var e3 = j.call(t3, x2), r3 = t3[x2];
          try {
            t3[x2] = void 0;
            var o2 = true;
          } catch (t4) {
          }
          var n2 = E.call(t3);
          return o2 && (e3 ? t3[x2] = r3 : delete t3[x2]), n2;
        };
        var C = Object.prototype.toString;
        const R = function(t3) {
          return C.call(t3);
        };
        var A = v ? v.toStringTag : void 0;
        const S = function(t3) {
          return null == t3 ? void 0 === t3 ? "[object Undefined]" : "[object Null]" : A && A in Object(t3) ? O(t3) : R(t3);
        };
        const P = function(t3) {
          return null != t3 && "object" == typeof t3;
        };
        const T = function(t3) {
          return "symbol" == typeof t3 || P(t3) && "[object Symbol]" == S(t3);
        };
        var D = /^[-+]0x[0-9a-f]+$/i, N = /^0b[01]+$/i, W = /^0o[0-7]+$/i, k = parseInt;
        const I = function(t3) {
          if ("number" == typeof t3)
            return t3;
          if (T(t3))
            return NaN;
          if (h(t3)) {
            var e3 = "function" == typeof t3.valueOf ? t3.valueOf() : t3;
            t3 = h(e3) ? e3 + "" : e3;
          }
          if ("string" != typeof t3)
            return 0 === t3 ? t3 : +t3;
          t3 = m(t3);
          var r3 = N.test(t3);
          return r3 || W.test(t3) ? k(t3.slice(2), r3 ? 2 : 8) : D.test(t3) ? NaN : +t3;
        };
        var z = Math.max, U = Math.min;
        const M = function(t3, e3, r3) {
          var o2, n2, s3, i2, a2, c2, u2 = 0, d2 = false, l2 = false, f2 = true;
          if ("function" != typeof t3)
            throw new TypeError("Expected a function");
          function p2(e4) {
            var r4 = o2, s4 = n2;
            return o2 = n2 = void 0, u2 = e4, i2 = t3.apply(s4, r4);
          }
          function _2(t4) {
            var r4 = t4 - c2;
            return void 0 === c2 || r4 >= e3 || r4 < 0 || l2 && t4 - u2 >= s3;
          }
          function y3() {
            var t4 = g();
            if (_2(t4))
              return b10(t4);
            a2 = setTimeout(y3, function(t5) {
              var r4 = e3 - (t5 - c2);
              return l2 ? U(r4, s3 - (t5 - u2)) : r4;
            }(t4));
          }
          function b10(t4) {
            return a2 = void 0, f2 && o2 ? p2(t4) : (o2 = n2 = void 0, i2);
          }
          function m2() {
            var t4 = g(), r4 = _2(t4);
            if (o2 = arguments, n2 = this, c2 = t4, r4) {
              if (void 0 === a2)
                return function(t5) {
                  return u2 = t5, a2 = setTimeout(y3, e3), d2 ? p2(t5) : i2;
                }(c2);
              if (l2)
                return clearTimeout(a2), a2 = setTimeout(y3, e3), p2(c2);
            }
            return void 0 === a2 && (a2 = setTimeout(y3, e3)), i2;
          }
          return e3 = I(e3) || 0, h(r3) && (d2 = !!r3.leading, s3 = (l2 = "maxWait" in r3) ? z(I(r3.maxWait) || 0, e3) : s3, f2 = "trailing" in r3 ? !!r3.trailing : f2), m2.cancel = function() {
            void 0 !== a2 && clearTimeout(a2), u2 = 0, o2 = c2 = n2 = a2 = void 0;
          }, m2.flush = function() {
            return void 0 === a2 ? i2 : b10(g());
          }, m2;
        };
        const F = function(t3, e3, r3) {
          var o2 = true, n2 = true;
          if ("function" != typeof t3)
            throw new TypeError("Expected a function");
          return h(r3) && (o2 = "leading" in r3 ? !!r3.leading : o2, n2 = "trailing" in r3 ? !!r3.trailing : n2), M(t3, e3, { leading: o2, maxWait: e3, trailing: n2 });
        };
        const L = function(t3, e3) {
          return function(r3) {
            return t3(e3(r3));
          };
        };
        const q = L(Object.getPrototypeOf, Object);
        var J = Function.prototype, B = Object.prototype, $ = J.toString, H = B.hasOwnProperty, K = $.call(Object);
        const V = function(t3) {
          if (!P(t3) || "[object Object]" != S(t3))
            return false;
          var e3 = q(t3);
          if (null === e3)
            return true;
          var r3 = H.call(e3, "constructor") && e3.constructor;
          return "function" == typeof r3 && r3 instanceof r3 && $.call(r3) == K;
        };
        const Q = function(t3) {
          return P(t3) && 1 === t3.nodeType && !V(t3);
        };
        const G = function() {
          this.__data__ = [], this.size = 0;
        };
        const Y = function(t3, e3) {
          return t3 === e3 || t3 != t3 && e3 != e3;
        };
        const X = function(t3, e3) {
          for (var r3 = t3.length; r3--; )
            if (Y(t3[r3][0], e3))
              return r3;
          return -1;
        };
        var Z = Array.prototype.splice;
        const tt = function(t3) {
          var e3 = this.__data__, r3 = X(e3, t3);
          return !(r3 < 0) && (r3 == e3.length - 1 ? e3.pop() : Z.call(e3, r3, 1), --this.size, true);
        };
        const et = function(t3) {
          var e3 = this.__data__, r3 = X(e3, t3);
          return r3 < 0 ? void 0 : e3[r3][1];
        };
        const rt = function(t3) {
          return X(this.__data__, t3) > -1;
        };
        const ot = function(t3, e3) {
          var r3 = this.__data__, o2 = X(r3, t3);
          return o2 < 0 ? (++this.size, r3.push([t3, e3])) : r3[o2][1] = e3, this;
        };
        function nt(t3) {
          var e3 = -1, r3 = null == t3 ? 0 : t3.length;
          for (this.clear(); ++e3 < r3; ) {
            var o2 = t3[e3];
            this.set(o2[0], o2[1]);
          }
        }
        nt.prototype.clear = G, nt.prototype.delete = tt, nt.prototype.get = et, nt.prototype.has = rt, nt.prototype.set = ot;
        const st = nt;
        const it = function() {
          this.__data__ = new st(), this.size = 0;
        };
        const at = function(t3) {
          var e3 = this.__data__, r3 = e3.delete(t3);
          return this.size = e3.size, r3;
        };
        const ct = function(t3) {
          return this.__data__.get(t3);
        };
        const ut = function(t3) {
          return this.__data__.has(t3);
        };
        const dt = function(t3) {
          if (!h(t3))
            return false;
          var e3 = S(t3);
          return "[object Function]" == e3 || "[object GeneratorFunction]" == e3 || "[object AsyncFunction]" == e3 || "[object Proxy]" == e3;
        };
        const ht = p["__core-js_shared__"];
        var lt = function() {
          var t3 = /[^.]+$/.exec(ht && ht.keys && ht.keys.IE_PROTO || "");
          return t3 ? "Symbol(src)_1." + t3 : "";
        }();
        const ft = function(t3) {
          return !!lt && lt in t3;
        };
        var pt = Function.prototype.toString;
        const gt = function(t3) {
          if (null != t3) {
            try {
              return pt.call(t3);
            } catch (t4) {
            }
            try {
              return t3 + "";
            } catch (t4) {
            }
          }
          return "";
        };
        var _t = /^\[object .+?Constructor\]$/, yt = Function.prototype, bt = Object.prototype, mt = yt.toString, vt = bt.hasOwnProperty, wt = RegExp("^" + mt.call(vt).replace(/[\\^$.*+?()[\]{}|]/g, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$");
        const jt = function(t3) {
          return !(!h(t3) || ft(t3)) && (dt(t3) ? wt : _t).test(gt(t3));
        };
        const Et = function(t3, e3) {
          return null == t3 ? void 0 : t3[e3];
        };
        const xt = function(t3, e3) {
          var r3 = Et(t3, e3);
          return jt(r3) ? r3 : void 0;
        };
        const Ot = xt(p, "Map");
        const Ct = xt(Object, "create");
        const Rt = function() {
          this.__data__ = Ct ? Ct(null) : {}, this.size = 0;
        };
        const At = function(t3) {
          var e3 = this.has(t3) && delete this.__data__[t3];
          return this.size -= e3 ? 1 : 0, e3;
        };
        var St = Object.prototype.hasOwnProperty;
        const Pt = function(t3) {
          var e3 = this.__data__;
          if (Ct) {
            var r3 = e3[t3];
            return "__lodash_hash_undefined__" === r3 ? void 0 : r3;
          }
          return St.call(e3, t3) ? e3[t3] : void 0;
        };
        var Tt = Object.prototype.hasOwnProperty;
        const Dt = function(t3) {
          var e3 = this.__data__;
          return Ct ? void 0 !== e3[t3] : Tt.call(e3, t3);
        };
        const Nt = function(t3, e3) {
          var r3 = this.__data__;
          return this.size += this.has(t3) ? 0 : 1, r3[t3] = Ct && void 0 === e3 ? "__lodash_hash_undefined__" : e3, this;
        };
        function Wt(t3) {
          var e3 = -1, r3 = null == t3 ? 0 : t3.length;
          for (this.clear(); ++e3 < r3; ) {
            var o2 = t3[e3];
            this.set(o2[0], o2[1]);
          }
        }
        Wt.prototype.clear = Rt, Wt.prototype.delete = At, Wt.prototype.get = Pt, Wt.prototype.has = Dt, Wt.prototype.set = Nt;
        const kt = Wt;
        const It = function() {
          this.size = 0, this.__data__ = { hash: new kt(), map: new (Ot || st)(), string: new kt() };
        };
        const zt = function(t3) {
          var e3 = typeof t3;
          return "string" == e3 || "number" == e3 || "symbol" == e3 || "boolean" == e3 ? "__proto__" !== t3 : null === t3;
        };
        const Ut = function(t3, e3) {
          var r3 = t3.__data__;
          return zt(e3) ? r3["string" == typeof e3 ? "string" : "hash"] : r3.map;
        };
        const Mt = function(t3) {
          var e3 = Ut(this, t3).delete(t3);
          return this.size -= e3 ? 1 : 0, e3;
        };
        const Ft = function(t3) {
          return Ut(this, t3).get(t3);
        };
        const Lt = function(t3) {
          return Ut(this, t3).has(t3);
        };
        const qt = function(t3, e3) {
          var r3 = Ut(this, t3), o2 = r3.size;
          return r3.set(t3, e3), this.size += r3.size == o2 ? 0 : 1, this;
        };
        function Jt(t3) {
          var e3 = -1, r3 = null == t3 ? 0 : t3.length;
          for (this.clear(); ++e3 < r3; ) {
            var o2 = t3[e3];
            this.set(o2[0], o2[1]);
          }
        }
        Jt.prototype.clear = It, Jt.prototype.delete = Mt, Jt.prototype.get = Ft, Jt.prototype.has = Lt, Jt.prototype.set = qt;
        const Bt = Jt;
        const $t = function(t3, e3) {
          var r3 = this.__data__;
          if (r3 instanceof st) {
            var o2 = r3.__data__;
            if (!Ot || o2.length < 199)
              return o2.push([t3, e3]), this.size = ++r3.size, this;
            r3 = this.__data__ = new Bt(o2);
          }
          return r3.set(t3, e3), this.size = r3.size, this;
        };
        function Ht(t3) {
          var e3 = this.__data__ = new st(t3);
          this.size = e3.size;
        }
        Ht.prototype.clear = it, Ht.prototype.delete = at, Ht.prototype.get = ct, Ht.prototype.has = ut, Ht.prototype.set = $t;
        const Kt = Ht;
        const Vt = function(t3, e3) {
          for (var r3 = -1, o2 = null == t3 ? 0 : t3.length; ++r3 < o2 && false !== e3(t3[r3], r3, t3); )
            ;
          return t3;
        };
        const Qt = function() {
          try {
            var t3 = xt(Object, "defineProperty");
            return t3({}, "", {}), t3;
          } catch (t4) {
          }
        }();
        const Gt = function(t3, e3, r3) {
          "__proto__" == e3 && Qt ? Qt(t3, e3, { configurable: true, enumerable: true, value: r3, writable: true }) : t3[e3] = r3;
        };
        var Yt = Object.prototype.hasOwnProperty;
        const Xt = function(t3, e3, r3) {
          var o2 = t3[e3];
          Yt.call(t3, e3) && Y(o2, r3) && (void 0 !== r3 || e3 in t3) || Gt(t3, e3, r3);
        };
        const Zt = function(t3, e3, r3, o2) {
          var n2 = !r3;
          r3 || (r3 = {});
          for (var s3 = -1, i2 = e3.length; ++s3 < i2; ) {
            var a2 = e3[s3], c2 = o2 ? o2(r3[a2], t3[a2], a2, r3, t3) : void 0;
            void 0 === c2 && (c2 = t3[a2]), n2 ? Gt(r3, a2, c2) : Xt(r3, a2, c2);
          }
          return r3;
        };
        const te = function(t3, e3) {
          for (var r3 = -1, o2 = Array(t3); ++r3 < t3; )
            o2[r3] = e3(r3);
          return o2;
        };
        const ee = function(t3) {
          return P(t3) && "[object Arguments]" == S(t3);
        };
        var re = Object.prototype, oe = re.hasOwnProperty, ne = re.propertyIsEnumerable;
        const se = ee(function() {
          return arguments;
        }()) ? ee : function(t3) {
          return P(t3) && oe.call(t3, "callee") && !ne.call(t3, "callee");
        };
        const ie = Array.isArray;
        const ae = function() {
          return false;
        };
        var ce = "object" == typeof exports && exports && !exports.nodeType && exports, ue = ce && "object" == typeof module2 && module2 && !module2.nodeType && module2, de = ue && ue.exports === ce ? p.Buffer : void 0;
        const he = (de ? de.isBuffer : void 0) || ae;
        var le = /^(?:0|[1-9]\d*)$/;
        const fe = function(t3, e3) {
          var r3 = typeof t3;
          return !!(e3 = null == e3 ? 9007199254740991 : e3) && ("number" == r3 || "symbol" != r3 && le.test(t3)) && t3 > -1 && t3 % 1 == 0 && t3 < e3;
        };
        const pe = function(t3) {
          return "number" == typeof t3 && t3 > -1 && t3 % 1 == 0 && t3 <= 9007199254740991;
        };
        var ge = {};
        ge["[object Float32Array]"] = ge["[object Float64Array]"] = ge["[object Int8Array]"] = ge["[object Int16Array]"] = ge["[object Int32Array]"] = ge["[object Uint8Array]"] = ge["[object Uint8ClampedArray]"] = ge["[object Uint16Array]"] = ge["[object Uint32Array]"] = true, ge["[object Arguments]"] = ge["[object Array]"] = ge["[object ArrayBuffer]"] = ge["[object Boolean]"] = ge["[object DataView]"] = ge["[object Date]"] = ge["[object Error]"] = ge["[object Function]"] = ge["[object Map]"] = ge["[object Number]"] = ge["[object Object]"] = ge["[object RegExp]"] = ge["[object Set]"] = ge["[object String]"] = ge["[object WeakMap]"] = false;
        const _e = function(t3) {
          return P(t3) && pe(t3.length) && !!ge[S(t3)];
        };
        const ye = function(t3) {
          return function(e3) {
            return t3(e3);
          };
        };
        var be = "object" == typeof exports && exports && !exports.nodeType && exports, me = be && "object" == typeof module2 && module2 && !module2.nodeType && module2, ve = me && me.exports === be && l.process;
        const we = function() {
          try {
            var t3 = me && me.require && me.require("util").types;
            return t3 || ve && ve.binding && ve.binding("util");
          } catch (t4) {
          }
        }();
        var je = we && we.isTypedArray;
        const Ee = je ? ye(je) : _e;
        var xe = Object.prototype.hasOwnProperty;
        const Oe = function(t3, e3) {
          var r3 = ie(t3), o2 = !r3 && se(t3), n2 = !r3 && !o2 && he(t3), s3 = !r3 && !o2 && !n2 && Ee(t3), i2 = r3 || o2 || n2 || s3, a2 = i2 ? te(t3.length, String) : [], c2 = a2.length;
          for (var u2 in t3)
            !e3 && !xe.call(t3, u2) || i2 && ("length" == u2 || n2 && ("offset" == u2 || "parent" == u2) || s3 && ("buffer" == u2 || "byteLength" == u2 || "byteOffset" == u2) || fe(u2, c2)) || a2.push(u2);
          return a2;
        };
        var Ce = Object.prototype;
        const Re = function(t3) {
          var e3 = t3 && t3.constructor;
          return t3 === ("function" == typeof e3 && e3.prototype || Ce);
        };
        const Ae = L(Object.keys, Object);
        var Se = Object.prototype.hasOwnProperty;
        const Pe = function(t3) {
          if (!Re(t3))
            return Ae(t3);
          var e3 = [];
          for (var r3 in Object(t3))
            Se.call(t3, r3) && "constructor" != r3 && e3.push(r3);
          return e3;
        };
        const Te = function(t3) {
          return null != t3 && pe(t3.length) && !dt(t3);
        };
        const De = function(t3) {
          return Te(t3) ? Oe(t3) : Pe(t3);
        };
        const Ne = function(t3, e3) {
          return t3 && Zt(e3, De(e3), t3);
        };
        const We = function(t3) {
          var e3 = [];
          if (null != t3)
            for (var r3 in Object(t3))
              e3.push(r3);
          return e3;
        };
        var ke = Object.prototype.hasOwnProperty;
        const Ie = function(t3) {
          if (!h(t3))
            return We(t3);
          var e3 = Re(t3), r3 = [];
          for (var o2 in t3)
            ("constructor" != o2 || !e3 && ke.call(t3, o2)) && r3.push(o2);
          return r3;
        };
        const ze = function(t3) {
          return Te(t3) ? Oe(t3, true) : Ie(t3);
        };
        const Ue = function(t3, e3) {
          return t3 && Zt(e3, ze(e3), t3);
        };
        var Me = "object" == typeof exports && exports && !exports.nodeType && exports, Fe = Me && "object" == typeof module2 && module2 && !module2.nodeType && module2, Le = Fe && Fe.exports === Me ? p.Buffer : void 0, qe = Le ? Le.allocUnsafe : void 0;
        const Je = function(t3, e3) {
          if (e3)
            return t3.slice();
          var r3 = t3.length, o2 = qe ? qe(r3) : new t3.constructor(r3);
          return t3.copy(o2), o2;
        };
        const Be = function(t3, e3) {
          var r3 = -1, o2 = t3.length;
          for (e3 || (e3 = Array(o2)); ++r3 < o2; )
            e3[r3] = t3[r3];
          return e3;
        };
        const $e = function(t3, e3) {
          for (var r3 = -1, o2 = null == t3 ? 0 : t3.length, n2 = 0, s3 = []; ++r3 < o2; ) {
            var i2 = t3[r3];
            e3(i2, r3, t3) && (s3[n2++] = i2);
          }
          return s3;
        };
        const He = function() {
          return [];
        };
        var Ke = Object.prototype.propertyIsEnumerable, Ve = Object.getOwnPropertySymbols;
        const Qe = Ve ? function(t3) {
          return null == t3 ? [] : (t3 = Object(t3), $e(Ve(t3), function(e3) {
            return Ke.call(t3, e3);
          }));
        } : He;
        const Ge = function(t3, e3) {
          return Zt(t3, Qe(t3), e3);
        };
        const Ye = function(t3, e3) {
          for (var r3 = -1, o2 = e3.length, n2 = t3.length; ++r3 < o2; )
            t3[n2 + r3] = e3[r3];
          return t3;
        };
        const Xe = Object.getOwnPropertySymbols ? function(t3) {
          for (var e3 = []; t3; )
            Ye(e3, Qe(t3)), t3 = q(t3);
          return e3;
        } : He;
        const Ze = function(t3, e3) {
          return Zt(t3, Xe(t3), e3);
        };
        const tr = function(t3, e3, r3) {
          var o2 = e3(t3);
          return ie(t3) ? o2 : Ye(o2, r3(t3));
        };
        const er = function(t3) {
          return tr(t3, De, Qe);
        };
        const rr = function(t3) {
          return tr(t3, ze, Xe);
        };
        const or = xt(p, "DataView");
        const nr = xt(p, "Promise");
        const sr = xt(p, "Set");
        const ir = xt(p, "WeakMap");
        var ar = "[object Map]", cr = "[object Promise]", ur = "[object Set]", dr = "[object WeakMap]", hr = "[object DataView]", lr = gt(or), fr = gt(Ot), pr = gt(nr), gr = gt(sr), _r = gt(ir), yr = S;
        (or && yr(new or(new ArrayBuffer(1))) != hr || Ot && yr(new Ot()) != ar || nr && yr(nr.resolve()) != cr || sr && yr(new sr()) != ur || ir && yr(new ir()) != dr) && (yr = function(t3) {
          var e3 = S(t3), r3 = "[object Object]" == e3 ? t3.constructor : void 0, o2 = r3 ? gt(r3) : "";
          if (o2)
            switch (o2) {
              case lr:
                return hr;
              case fr:
                return ar;
              case pr:
                return cr;
              case gr:
                return ur;
              case _r:
                return dr;
            }
          return e3;
        });
        const br = yr;
        var mr = Object.prototype.hasOwnProperty;
        const vr = function(t3) {
          var e3 = t3.length, r3 = new t3.constructor(e3);
          return e3 && "string" == typeof t3[0] && mr.call(t3, "index") && (r3.index = t3.index, r3.input = t3.input), r3;
        };
        const wr = p.Uint8Array;
        const jr = function(t3) {
          var e3 = new t3.constructor(t3.byteLength);
          return new wr(e3).set(new wr(t3)), e3;
        };
        const Er = function(t3, e3) {
          var r3 = e3 ? jr(t3.buffer) : t3.buffer;
          return new t3.constructor(r3, t3.byteOffset, t3.byteLength);
        };
        var xr = /\w*$/;
        const Or = function(t3) {
          var e3 = new t3.constructor(t3.source, xr.exec(t3));
          return e3.lastIndex = t3.lastIndex, e3;
        };
        var Cr = v ? v.prototype : void 0, Rr = Cr ? Cr.valueOf : void 0;
        const Ar = function(t3) {
          return Rr ? Object(Rr.call(t3)) : {};
        };
        const Sr = function(t3, e3) {
          var r3 = e3 ? jr(t3.buffer) : t3.buffer;
          return new t3.constructor(r3, t3.byteOffset, t3.length);
        };
        const Pr = function(t3, e3, r3) {
          var o2 = t3.constructor;
          switch (e3) {
            case "[object ArrayBuffer]":
              return jr(t3);
            case "[object Boolean]":
            case "[object Date]":
              return new o2(+t3);
            case "[object DataView]":
              return Er(t3, r3);
            case "[object Float32Array]":
            case "[object Float64Array]":
            case "[object Int8Array]":
            case "[object Int16Array]":
            case "[object Int32Array]":
            case "[object Uint8Array]":
            case "[object Uint8ClampedArray]":
            case "[object Uint16Array]":
            case "[object Uint32Array]":
              return Sr(t3, r3);
            case "[object Map]":
            case "[object Set]":
              return new o2();
            case "[object Number]":
            case "[object String]":
              return new o2(t3);
            case "[object RegExp]":
              return Or(t3);
            case "[object Symbol]":
              return Ar(t3);
          }
        };
        var Tr = Object.create;
        const Dr = function() {
          function t3() {
          }
          return function(e3) {
            if (!h(e3))
              return {};
            if (Tr)
              return Tr(e3);
            t3.prototype = e3;
            var r3 = new t3();
            return t3.prototype = void 0, r3;
          };
        }();
        const Nr = function(t3) {
          return "function" != typeof t3.constructor || Re(t3) ? {} : Dr(q(t3));
        };
        const Wr = function(t3) {
          return P(t3) && "[object Map]" == br(t3);
        };
        var kr = we && we.isMap;
        const Ir = kr ? ye(kr) : Wr;
        const zr = function(t3) {
          return P(t3) && "[object Set]" == br(t3);
        };
        var Ur = we && we.isSet;
        const Mr = Ur ? ye(Ur) : zr;
        var Fr = "[object Arguments]", Lr = "[object Function]", qr = "[object Object]", Jr = {};
        Jr[Fr] = Jr["[object Array]"] = Jr["[object ArrayBuffer]"] = Jr["[object DataView]"] = Jr["[object Boolean]"] = Jr["[object Date]"] = Jr["[object Float32Array]"] = Jr["[object Float64Array]"] = Jr["[object Int8Array]"] = Jr["[object Int16Array]"] = Jr["[object Int32Array]"] = Jr["[object Map]"] = Jr["[object Number]"] = Jr[qr] = Jr["[object RegExp]"] = Jr["[object Set]"] = Jr["[object String]"] = Jr["[object Symbol]"] = Jr["[object Uint8Array]"] = Jr["[object Uint8ClampedArray]"] = Jr["[object Uint16Array]"] = Jr["[object Uint32Array]"] = true, Jr["[object Error]"] = Jr[Lr] = Jr["[object WeakMap]"] = false;
        const Br = function t3(e3, r3, o2, n2, s3, i2) {
          var a2, c2 = 1 & r3, u2 = 2 & r3, d2 = 4 & r3;
          if (o2 && (a2 = s3 ? o2(e3, n2, s3, i2) : o2(e3)), void 0 !== a2)
            return a2;
          if (!h(e3))
            return e3;
          var l2 = ie(e3);
          if (l2) {
            if (a2 = vr(e3), !c2)
              return Be(e3, a2);
          } else {
            var f2 = br(e3), p2 = f2 == Lr || "[object GeneratorFunction]" == f2;
            if (he(e3))
              return Je(e3, c2);
            if (f2 == qr || f2 == Fr || p2 && !s3) {
              if (a2 = u2 || p2 ? {} : Nr(e3), !c2)
                return u2 ? Ze(e3, Ue(a2, e3)) : Ge(e3, Ne(a2, e3));
            } else {
              if (!Jr[f2])
                return s3 ? e3 : {};
              a2 = Pr(e3, f2, c2);
            }
          }
          i2 || (i2 = new Kt());
          var g2 = i2.get(e3);
          if (g2)
            return g2;
          i2.set(e3, a2), Mr(e3) ? e3.forEach(function(n3) {
            a2.add(t3(n3, r3, o2, n3, e3, i2));
          }) : Ir(e3) && e3.forEach(function(n3, s4) {
            a2.set(s4, t3(n3, r3, o2, s4, e3, i2));
          });
          var _2 = l2 ? void 0 : (d2 ? u2 ? rr : er : u2 ? ze : De)(e3);
          return Vt(_2 || e3, function(n3, s4) {
            _2 && (n3 = e3[s4 = n3]), Xt(a2, s4, t3(n3, r3, o2, s4, e3, i2));
          }), a2;
        };
        const $r = function(t3, e3) {
          return Br(t3, 5, e3 = "function" == typeof e3 ? e3 : void 0);
        };
        class Hr extends a {
          constructor(t3, e3 = {}) {
            super(e3), this._editor = null, this._initUsingData = true, this._editables = {}, this._throttledSave = F(this._save.bind(this), "number" == typeof e3.saveInterval ? e3.saveInterval : 5e3), t3 && (this._creator = (e4, r3) => t3.create(e4, r3)), this._destructor = (t4) => t4.destroy();
          }
          get editor() {
            return this._editor;
          }
          get _item() {
            return this._editor;
          }
          setCreator(t3) {
            this._creator = t3;
          }
          setDestructor(t3) {
            this._destructor = t3;
          }
          _restart() {
            return Promise.resolve().then(() => (this.state = "initializing", this._fire("stateChange"), this._destroy())).catch((t3) => {
              console.error("An error happened during the editor destroying.", t3);
            }).then(() => {
              const t3 = {}, e3 = [], r3 = this._config.rootsAttributes || {}, o2 = {};
              for (const [n3, s3] of Object.entries(this._data.roots))
                s3.isLoaded ? (t3[n3] = "", o2[n3] = r3[n3] || {}) : e3.push(n3);
              const n2 = __spreadProps(__spreadValues({}, this._config), { extraPlugins: this._config.extraPlugins || [], lazyRoots: e3, rootsAttributes: o2, _watchdogInitialData: this._data });
              return delete n2.initialData, n2.extraPlugins.push(Kr), this._initUsingData ? this.create(t3, n2, n2.context) : Q(this._elementOrData) ? this.create(this._elementOrData, n2, n2.context) : this.create(this._editables, n2, n2.context);
            }).then(() => {
              this._fire("restart");
            });
          }
          create(t3 = this._elementOrData, e3 = this._config, r3) {
            return Promise.resolve().then(() => (super._startErrorHandling(), this._elementOrData = t3, this._initUsingData = "string" == typeof t3 || Object.keys(t3).length > 0 && "string" == typeof Object.values(t3)[0], this._config = this._cloneEditorConfiguration(e3) || {}, this._config.context = r3, this._creator(t3, this._config))).then((t4) => {
              this._editor = t4, t4.model.document.on("change:data", this._throttledSave), this._lastDocumentVersion = t4.model.document.version, this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this.state = "ready", this._fire("stateChange");
            });
          }
          destroy() {
            return Promise.resolve().then(() => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
          }
          _destroy() {
            return Promise.resolve().then(() => {
              this._stopErrorHandling(), this._throttledSave.cancel();
              const t3 = this._editor;
              return this._editor = null, t3.model.document.off("change:data", this._throttledSave), this._destructor(t3);
            });
          }
          _save() {
            const t3 = this._editor.model.document.version;
            try {
              this._data = this._getData(), this._initUsingData || (this._editables = this._getEditables()), this._lastDocumentVersion = t3;
            } catch (t4) {
              console.error(t4, "An error happened during restoring editor data. Editor will be restored from the previously saved data.");
            }
          }
          _setExcludedProperties(t3) {
            this._excludedProps = t3;
          }
          _getData() {
            const t3 = this._editor, e3 = t3.model.document.roots.filter((t4) => t4.isAttached() && "$graveyard" != t4.rootName), { plugins: r3 } = t3, o2 = r3.has("CommentsRepository") && r3.get("CommentsRepository"), n2 = r3.has("TrackChanges") && r3.get("TrackChanges"), s3 = { roots: {}, markers: {}, commentThreads: JSON.stringify([]), suggestions: JSON.stringify([]) };
            e3.forEach((t4) => {
              s3.roots[t4.rootName] = { content: JSON.stringify(Array.from(t4.getChildren())), attributes: JSON.stringify(Array.from(t4.getAttributes())), isLoaded: t4._isLoaded };
            });
            for (const e4 of t3.model.markers)
              e4._affectsData && (s3.markers[e4.name] = { rangeJSON: e4.getRange().toJSON(), usingOperation: e4._managedUsingOperations, affectsData: e4._affectsData });
            return o2 && (s3.commentThreads = JSON.stringify(o2.getCommentThreads({ toJSON: true, skipNotAttached: true }))), n2 && (s3.suggestions = JSON.stringify(n2.getSuggestions({ toJSON: true, skipNotAttached: true }))), s3;
          }
          _getEditables() {
            const t3 = {};
            for (const e3 of this.editor.model.document.getRootNames()) {
              const r3 = this.editor.ui.getEditableElement(e3);
              r3 && (t3[e3] = r3);
            }
            return t3;
          }
          _isErrorComingFromThisItem(t3) {
            return d(this._editor, t3.context, this._excludedProps);
          }
          _cloneEditorConfiguration(t3) {
            return $r(t3, (t4, e3) => Q(t4) || "context" === e3 ? t4 : void 0);
          }
        }
        class Kr {
          constructor(t3) {
            this.editor = t3, this._data = t3.config.get("_watchdogInitialData");
          }
          init() {
            this.editor.data.on("init", (t3) => {
              t3.stop(), this.editor.model.enqueueChange({ isUndoable: false }, (t4) => {
                this._restoreCollaborationData(), this._restoreEditorData(t4);
              }), this.editor.data.fire("ready");
            }, { priority: 999 });
          }
          _createNode(t3, e3) {
            if ("name" in e3) {
              const r3 = t3.createElement(e3.name, e3.attributes);
              if (e3.children)
                for (const o2 of e3.children)
                  r3._appendChild(this._createNode(t3, o2));
              return r3;
            }
            return t3.createText(e3.data, e3.attributes);
          }
          _restoreEditorData(t3) {
            const e3 = this.editor;
            Object.entries(this._data.roots).forEach(([r3, { content: o2, attributes: n2 }]) => {
              const s3 = JSON.parse(o2), i2 = JSON.parse(n2), a2 = e3.model.document.getRoot(r3);
              for (const [e4, r4] of i2)
                t3.setAttribute(e4, r4, a2);
              for (const e4 of s3) {
                const r4 = this._createNode(t3, e4);
                t3.insert(r4, a2, "end");
              }
            }), Object.entries(this._data.markers).forEach(([r3, o2]) => {
              const { document: n2 } = e3.model, _a = o2, { rangeJSON: { start: s3, end: i2 } } = _a, a2 = __objRest(_a, ["rangeJSON"]), c2 = n2.getRoot(s3.root), u2 = t3.createPositionFromPath(c2, s3.path, s3.stickiness), d2 = t3.createPositionFromPath(c2, i2.path, i2.stickiness), h2 = t3.createRange(u2, d2);
              t3.addMarker(r3, __spreadValues({ range: h2 }, a2));
            });
          }
          _restoreCollaborationData() {
            const t3 = JSON.parse(this._data.commentThreads), e3 = JSON.parse(this._data.suggestions);
            t3.forEach((t4) => {
              const e4 = this.editor.config.get("collaboration.channelId"), r3 = this.editor.plugins.get("CommentsRepository");
              if (r3.hasCommentThread(t4.threadId)) {
                r3.getCommentThread(t4.threadId).remove();
              }
              r3.addCommentThread(__spreadValues({ channelId: e4 }, t4));
            }), e3.forEach((t4) => {
              const e4 = this.editor.plugins.get("TrackChangesEditing");
              if (e4.hasSuggestion(t4.id)) {
                e4.getSuggestion(t4.id).attributes = t4.attributes;
              } else
                e4.addSuggestionData(t4);
            });
          }
        }
        const Vr = Symbol("MainQueueId");
        class Qr extends a {
          constructor(t3, e3 = {}) {
            super(e3), this._watchdogs = /* @__PURE__ */ new Map(), this._context = null, this._contextProps = /* @__PURE__ */ new Set(), this._actionQueues = new Gr(), this._watchdogConfig = e3, this._creator = (e4) => t3.create(e4), this._destructor = (t4) => t4.destroy(), this._actionQueues.onEmpty(() => {
              "initializing" === this.state && (this.state = "ready", this._fire("stateChange"));
            });
          }
          setCreator(t3) {
            this._creator = t3;
          }
          setDestructor(t3) {
            this._destructor = t3;
          }
          get context() {
            return this._context;
          }
          create(t3 = {}) {
            return this._actionQueues.enqueue(Vr, () => (this._contextConfig = t3, this._create()));
          }
          getItem(t3) {
            return this._getWatchdog(t3)._item;
          }
          getItemState(t3) {
            return this._getWatchdog(t3).state;
          }
          add(t3) {
            const e3 = Yr(t3);
            return Promise.all(e3.map((t4) => this._actionQueues.enqueue(t4.id, () => {
              if ("destroyed" === this.state)
                throw new Error("Cannot add items to destroyed watchdog.");
              if (!this._context)
                throw new Error("Context was not created yet. You should call the `ContextWatchdog#create()` method first.");
              let e4;
              if (this._watchdogs.has(t4.id))
                throw new Error(`Item with the given id is already added: '${t4.id}'.`);
              if ("editor" === t4.type)
                return e4 = new Hr(null, this._watchdogConfig), e4.setCreator(t4.creator), e4._setExcludedProperties(this._contextProps), t4.destructor && e4.setDestructor(t4.destructor), this._watchdogs.set(t4.id, e4), e4.on("error", (r3, { error: o2, causesRestart: n2 }) => {
                  this._fire("itemError", { itemId: t4.id, error: o2 }), n2 && this._actionQueues.enqueue(t4.id, () => new Promise((r4) => {
                    const o3 = () => {
                      e4.off("restart", o3), this._fire("itemRestart", { itemId: t4.id }), r4();
                    };
                    e4.on("restart", o3);
                  }));
                }), e4.create(t4.sourceElementOrData, t4.config, this._context);
              throw new Error(`Not supported item type: '${t4.type}'.`);
            })));
          }
          remove(t3) {
            const e3 = Yr(t3);
            return Promise.all(e3.map((t4) => this._actionQueues.enqueue(t4, () => {
              const e4 = this._getWatchdog(t4);
              return this._watchdogs.delete(t4), e4.destroy();
            })));
          }
          destroy() {
            return this._actionQueues.enqueue(Vr, () => (this.state = "destroyed", this._fire("stateChange"), super.destroy(), this._destroy()));
          }
          _restart() {
            return this._actionQueues.enqueue(Vr, () => (this.state = "initializing", this._fire("stateChange"), this._destroy().catch((t3) => {
              console.error("An error happened during destroying the context or items.", t3);
            }).then(() => this._create()).then(() => this._fire("restart"))));
          }
          _create() {
            return Promise.resolve().then(() => (this._startErrorHandling(), this._creator(this._contextConfig))).then((t3) => (this._context = t3, this._contextProps = c(this._context), Promise.all(Array.from(this._watchdogs.values()).map((t4) => (t4._setExcludedProperties(this._contextProps), t4.create(void 0, void 0, this._context))))));
          }
          _destroy() {
            return Promise.resolve().then(() => {
              this._stopErrorHandling();
              const t3 = this._context;
              return this._context = null, this._contextProps = /* @__PURE__ */ new Set(), Promise.all(Array.from(this._watchdogs.values()).map((t4) => t4.destroy())).then(() => this._destructor(t3));
            });
          }
          _getWatchdog(t3) {
            const e3 = this._watchdogs.get(t3);
            if (!e3)
              throw new Error(`Item with the given id was not registered: ${t3}.`);
            return e3;
          }
          _isErrorComingFromThisItem(t3) {
            for (const e3 of this._watchdogs.values())
              if (e3._isErrorComingFromThisItem(t3))
                return false;
            return d(this._context, t3.context);
          }
        }
        class Gr {
          constructor() {
            this._onEmptyCallbacks = [], this._queues = /* @__PURE__ */ new Map(), this._activeActions = 0;
          }
          onEmpty(t3) {
            this._onEmptyCallbacks.push(t3);
          }
          enqueue(t3, e3) {
            const r3 = t3 === Vr;
            this._activeActions++, this._queues.get(t3) || this._queues.set(t3, Promise.resolve());
            const o2 = (r3 ? Promise.all(this._queues.values()) : Promise.all([this._queues.get(Vr), this._queues.get(t3)])).then(e3), n2 = o2.catch(() => {
            });
            return this._queues.set(t3, n2), o2.finally(() => {
              this._activeActions--, this._queues.get(t3) === n2 && 0 === this._activeActions && this._onEmptyCallbacks.forEach((t4) => t4());
            });
          }
        }
        function Yr(t3) {
          return Array.isArray(t3) ? t3 : [t3];
        }
        const Xr = e2().createContext("contextWatchdog");
        class Zr extends e2().Component {
          constructor(t3, e3) {
            super(t3, e3), this.contextWatchdog = null, this.props.isLayoutReady && this._initializeContextWatchdog(this.props.config);
          }
          shouldComponentUpdate(t3) {
            return this._shouldComponentUpdate(t3);
          }
          _shouldComponentUpdate(t3) {
            return __async(this, null, function* () {
              return t3.id !== this.props.id && (this.contextWatchdog && (yield this.contextWatchdog.destroy()), yield this._initializeContextWatchdog(t3.config)), t3.isLayoutReady && !this.contextWatchdog ? (yield this._initializeContextWatchdog(t3.config), true) : this.props.children !== t3.children;
            });
          }
          render() {
            return e2().createElement(Xr.Provider, { value: this.contextWatchdog }, this.props.children);
          }
          componentWillUnmount() {
            this._destroyContext();
          }
          _initializeContextWatchdog(t3) {
            return __async(this, null, function* () {
              this.contextWatchdog = new Qr(this.props.context, this.props.watchdogConfig), this.contextWatchdog.on("error", (t4, e3) => {
                this.props.onError(e3.error, { phase: "runtime", willContextRestart: e3.causesRestart });
              }), this.contextWatchdog.on("stateChange", () => {
                "ready" === this.contextWatchdog.state && this.props.onReady && this.props.onReady(this.contextWatchdog.context);
              }), yield this.contextWatchdog.create(t3).catch((t4) => {
                this.props.onError(t4, { phase: "initialization", willContextRestart: false });
              });
            });
          }
          _destroyContext() {
            return __async(this, null, function* () {
              this.contextWatchdog && (yield this.contextWatchdog.destroy(), this.contextWatchdog = null);
            });
          }
        }
        Zr.defaultProps = { isLayoutReady: true, onError: (t3, e3) => console.error(t3, e3) }, Zr.propTypes = { id: s2().string, isLayoutReady: s2().bool, context: s2().func, watchdogConfig: s2().object, config: s2().object, onReady: s2().func, onError: s2().func };
        const to = "Lock from React integration (@ckeditor/ckeditor5-react)";
        class eo extends e2().Component {
          constructor(t3) {
            super(t3), this.editorDestructionInProgress = null, this.domContainer = e2().createRef(), this.watchdog = null;
            const { CKEDITOR_VERSION: r3 } = window;
            if (r3) {
              const [t4] = r3.split(".").map(Number);
              t4 < 37 && console.warn("The <CKEditor> component requires using CKEditor 5 in version 37 or higher.");
            } else
              console.warn('Cannot find the "CKEDITOR_VERSION" in the "window" scope.');
          }
          get editor() {
            return this.props.disableWatchdog ? this.instance : this.watchdog ? this.watchdog.editor : null;
          }
          shouldComponentUpdate(t3) {
            return !!this.editor && (t3.id !== this.props.id || (t3.disableWatchdog !== this.props.disableWatchdog || (this._shouldUpdateEditor(t3) && this.editor.data.set(t3.data), "disabled" in t3 && (t3.disabled ? this.editor.enableReadOnlyMode(to) : this.editor.disableReadOnlyMode(to)), false)));
          }
          componentDidMount() {
            return __async(this, null, function* () {
              yield this._initializeEditor();
            });
          }
          componentDidUpdate() {
            return __async(this, null, function* () {
              yield this._destroyEditor(), yield this._initializeEditor();
            });
          }
          componentWillUnmount() {
            return __async(this, null, function* () {
              yield this._destroyEditor();
            });
          }
          render() {
            return e2().createElement("div", { ref: this.domContainer });
          }
          _initializeEditor() {
            return __async(this, null, function* () {
              yield this.editorDestructionInProgress, this.props.disableWatchdog ? this.instance = yield this._createEditor(this.domContainer.current, this._getConfig()) : this.watchdog || (this.context instanceof Qr ? this.watchdog = new ro(this.context) : this.watchdog = new eo._EditorWatchdog(this.props.editor, this.props.watchdogConfig), this.watchdog.setCreator((t3, e3) => this._createEditor(t3, e3)), this.watchdog.on("error", (t3, { error: e3, causesRestart: r3 }) => {
                (this.props.onError || console.error)(e3, { phase: "runtime", willEditorRestart: r3 });
              }), yield this.watchdog.create(this.domContainer.current, this._getConfig()).catch((t3) => {
                (this.props.onError || console.error)(t3, { phase: "initialization", willEditorRestart: false });
              }));
            });
          }
          _createEditor(t3, e3) {
            return this.props.editor.create(t3, e3).then((t4) => {
              "disabled" in this.props && this.props.disabled && t4.enableReadOnlyMode(to);
              const e4 = t4.model.document, r3 = t4.editing.view.document;
              return e4.on("change:data", (e5) => {
                this.props.onChange && this.props.onChange(e5, t4);
              }), r3.on("focus", (e5) => {
                this.props.onFocus && this.props.onFocus(e5, t4);
              }), r3.on("blur", (e5) => {
                this.props.onBlur && this.props.onBlur(e5, t4);
              }), setTimeout(() => {
                this.props.onReady && this.props.onReady(t4);
              }), t4;
            });
          }
          _destroyEditor() {
            return __async(this, null, function* () {
              this.editorDestructionInProgress = new Promise((t3) => {
                setTimeout(() => __async(this, null, function* () {
                  return this.watchdog ? (yield this.watchdog.destroy(), this.watchdog = null, t3()) : this.instance ? (yield this.instance.destroy(), this.instance = null, t3()) : void t3();
                }));
              });
            });
          }
          _shouldUpdateEditor(t3) {
            return this.props.data !== t3.data && this.editor.data.get() !== t3.data;
          }
          _getConfig() {
            const t3 = this.props.config || {};
            return this.props.data && t3.initialData && console.warn("Editor data should be provided either using `config.initialData` or `content` property. The config value takes precedence over `content` property and will be used when both are specified."), __spreadProps(__spreadValues({}, t3), { initialData: t3.initialData || this.props.data || "" });
          }
        }
        eo.contextType = Xr, eo.propTypes = { editor: s2().func.isRequired, data: s2().string, config: s2().object, disableWatchdog: s2().bool, watchdogConfig: s2().object, onChange: s2().func, onReady: s2().func, onFocus: s2().func, onBlur: s2().func, onError: s2().func, disabled: s2().bool, id: s2().any }, eo._EditorWatchdog = Hr;
        class ro {
          constructor(t3) {
            this._contextWatchdog = t3, this._id = function() {
              const t4 = 4294967296 * Math.random() >>> 0, e3 = 4294967296 * Math.random() >>> 0, r3 = 4294967296 * Math.random() >>> 0, o2 = 4294967296 * Math.random() >>> 0;
              return "e" + i[t4 >> 0 & 255] + i[t4 >> 8 & 255] + i[t4 >> 16 & 255] + i[t4 >> 24 & 255] + i[e3 >> 0 & 255] + i[e3 >> 8 & 255] + i[e3 >> 16 & 255] + i[e3 >> 24 & 255] + i[r3 >> 0 & 255] + i[r3 >> 8 & 255] + i[r3 >> 16 & 255] + i[r3 >> 24 & 255] + i[o2 >> 0 & 255] + i[o2 >> 8 & 255] + i[o2 >> 16 & 255] + i[o2 >> 24 & 255];
            }();
          }
          setCreator(t3) {
            this._creator = t3;
          }
          create(t3, e3) {
            return this._contextWatchdog.add({ sourceElementOrData: t3, config: e3, creator: this._creator, id: this._id, type: "editor" });
          }
          on(t3, e3) {
            this._contextWatchdog.on("itemError", (t4, { itemId: r3, error: o2 }) => {
              r3 === this._id && e3(null, { error: o2, causesRestart: void 0 });
            });
          }
          destroy() {
            return "ready" === this._contextWatchdog.state ? this._contextWatchdog.remove(this._id) : Promise.resolve();
          }
          get editor() {
            return this._contextWatchdog.getItem(this._id);
          }
        }
        const oo = "Lock from React integration (@ckeditor/ckeditor5-react)", no = (r3) => {
          let o2 = null;
          const n2 = (0, t2.useRef)(null), s3 = (0, t2.useContext)(Xr), [i2, a2] = (0, t2.useState)(null), [c2, u2] = (0, t2.useState)(r3.data), [d2, h2] = (0, t2.useState)(r3.rootsAttributes || {}), [l2, f2] = (0, t2.useState)([]), p2 = (0, t2.useRef)(true), g2 = (0, t2.useRef)(null), _2 = e2().createElement("div", { ref: g2 });
          (0, t2.useEffect)(() => ((() => __async(exports, null, function* () {
            yield n2.current, false !== r3.isLayoutReady && w2();
          }))(), () => {
            v2().then(() => {
              n2.current = null;
            });
          }), [r3.isLayoutReady]), (0, t2.useEffect)(() => {
            i2 && (r3.disabled ? i2.enableReadOnlyMode(oo) : i2.disableReadOnlyMode(oo));
          }, [r3.disabled]), (0, t2.useEffect)(() => {
            const t3 = g2.current;
            if (i2 && !n2.current) {
              const e3 = i2.getFullData();
              u2(__spreadValues({}, e3)), h2(__spreadValues({}, i2.getRootsAttributes())), f2([...Object.keys(e3).map((t4) => b10(i2, t4))]), t3 && t3.appendChild(i2.ui.view.toolbar.element);
            }
            return () => {
              t3 && t3.firstChild && t3.removeChild(t3.firstChild);
            };
          }, [i2 && i2.id]);
          const y3 = () => {
            const t3 = r3.config || {};
            return r3.data && t3.initialData && console.warn("Editor data should be provided either using `config.initialData` or `data` property. The config value takes precedence over `data` property and will be used when both are specified."), __spreadProps(__spreadValues({}, t3), { rootsAttributes: d2 });
          }, b10 = (t3, r4) => e2().createElement("div", { id: r4, key: r4, ref: (e3) => {
            if (e3) {
              const o3 = t3.ui.view.createEditable(r4, e3);
              t3.ui.addEditable(o3), t3.editing.view.forceRender();
            }
          } }), m2 = (t3, e3) => r3.editor.create(t3, e3).then((t4) => {
            r3.disabled && r3.disabled && t4.enableReadOnlyMode(oo);
            const e4 = t4.model.document, o3 = t4.editing.view.document;
            return e4.on("change:data", (e5) => ((t5, e6) => {
              const o4 = t5.model.document, n3 = {}, s4 = {};
              o4.differ.getChanges().forEach((e7) => {
                let r4;
                if (r4 = "insert" == e7.type || "remove" == e7.type ? e7.position.root : e7.range.root, !r4.isAttached())
                  return;
                const { rootName: o5 } = r4;
                n3[o5] = t5.getData({ rootName: o5 });
              }), o4.differ.getChangedRoots().forEach((e7) => {
                if (e7.state)
                  return void (void 0 !== n3[e7.name] && delete n3[e7.name]);
                const r4 = e7.name;
                s4[r4] = t5.getRootAttributes(r4);
              }), Object.keys(n3).length && u2((t6) => __spreadValues(__spreadValues({}, t6), n3)), Object.keys(s4).length && h2((t6) => __spreadValues(__spreadValues({}, t6), s4)), r3.onChange && r3.onChange(e6, t5);
            })(t4, e5)), t4.on("addRoot", (e5, r4) => ((t5, e6, r5) => {
              const o4 = r5.rootName, n3 = b10(t5, o4);
              u2((e7) => __spreadProps(__spreadValues({}, e7), { [o4]: t5.getData({ rootName: o4 }) })), h2((e7) => __spreadProps(__spreadValues({}, e7), { [o4]: t5.getRootAttributes(o4) })), f2((t6) => [...t6, n3]);
            })(t4, 0, r4)), t4.on("detachRoot", (e5, r4) => ((t5, e6, r5) => {
              const o4 = r5.rootName;
              f2((t6) => t6.filter((t7) => t7.props.id !== o4)), u2((t6) => {
                const _a = t6, { [o4]: e7 } = _a, r6 = __objRest(_a, [__restKey(o4)]);
                return __spreadValues({}, r6);
              }), h2((t6) => {
                const _a = t6, { [o4]: e7 } = _a, r6 = __objRest(_a, [__restKey(o4)]);
                return __spreadValues({}, r6);
              }), t5.detachEditable(r5);
            })(t4, 0, r4)), o3.on("focus", (e5) => {
              r3.onFocus && r3.onFocus(e5, t4);
            }), o3.on("blur", (e5) => {
              r3.onBlur && r3.onBlur(e5, t4);
            }), a2(t4), r3.onReady && r3.onReady(t4), t4;
          }), v2 = () => __async(exports, null, function* () {
            a2(null), u2({}), h2({}), f2([]), n2.current = new Promise((t3) => {
              setTimeout(() => __async(exports, null, function* () {
                return o2 ? (yield o2.destroy(), o2 = null, t3()) : i2 ? (yield i2.destroy(), t3()) : void t3();
              }));
            });
          }), w2 = () => __async(exports, null, function* () {
            r3.disableWatchdog ? yield m2(r3.data, y3()) : o2 || (o2 = s3 instanceof Qr ? new ro(s3) : new Hr(r3.editor, r3.watchdogConfig), o2.setCreator((t3, e3) => m2(t3, e3)), o2.on("error", (t3, { error: e3, causesRestart: o3 }) => {
              (r3.onError || console.error)(e3, { phase: "runtime", willEditorRestart: o3 });
            }), yield o2.create(c2, y3()).catch((t3) => {
              (r3.onError || console.error)(t3, { phase: "initialization", willEditorRestart: false });
            }));
          });
          (0, t2.useEffect)(() => {
            if (i2 && p2.current) {
              p2.current = false;
              const t3 = Object.keys(c2), e3 = Object.keys(d2);
              if (!t3.every((t4) => e3.includes(t4)))
                throw new Error("`data` and `attributes` objects must have the same keys (roots).");
              const r4 = i2.getFullData(), o3 = i2.getRootsAttributes(), { addedKeys: n3, removedKeys: s4 } = j2(r4, c2 || {}), a3 = t3.some((t4) => void 0 !== r4[t4] && JSON.stringify(r4[t4]) !== JSON.stringify(c2[t4])), u3 = e3.filter((t4) => JSON.stringify(o3[t4]) !== JSON.stringify(d2[t4]));
              i2.model.change((t4) => {
                E2(n3), x3(s4), a3 && O2(), u3.length && C2(t4, u3);
              });
            }
          }, [c2, d2]);
          const j2 = (t3, e3) => {
            const r4 = Object.keys(t3), o3 = Object.keys(e3);
            return { addedKeys: o3.filter((t4) => !r4.includes(t4)), removedKeys: r4.filter((t4) => !o3.includes(t4)) };
          }, E2 = (t3) => {
            t3.forEach((t4) => {
              i2.addRoot(t4, { data: c2[t4] || "", attributes: (null == d2 ? void 0 : d2[t4]) || {}, isUndoable: true });
            });
          }, x3 = (t3) => {
            t3.forEach((t4) => {
              i2.detachRoot(t4, true);
            });
          }, O2 = () => {
            i2.data.set(c2, { suppressErrorInCollaboration: true });
          }, C2 = (t3, e3) => {
            e3.forEach((e4) => {
              Object.keys(d2[e4]).forEach((t4) => {
                i2.registerRootAttribute(t4);
              }), t3.clearAttributes(i2.model.document.getRoot(e4)), t3.setAttributes(d2[e4], i2.model.document.getRoot(e4));
            });
          }, R2 = (0, t2.useCallback)((t3) => {
            p2.current = true, u2(t3);
          }, [u2]), A2 = (0, t2.useCallback)((t3) => {
            p2.current = true, h2(t3);
          }, [h2]);
          return { editor: i2, editableElements: l2, toolbarElement: _2, data: c2, setData: R2, attributes: d2, setAttributes: A2 };
        };
      })(), n;
    })());
  }
});

// ../../node_modules/axios/lib/helpers/bind.js
var require_bind = __commonJS({
  "../../node_modules/axios/lib/helpers/bind.js"(exports, module2) {
    "use strict";
    module2.exports = function bind(fn, thisArg) {
      return function wrap() {
        var args = new Array(arguments.length);
        for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i];
        }
        return fn.apply(thisArg, args);
      };
    };
  }
});

// ../../node_modules/axios/lib/utils.js
var require_utils = __commonJS({
  "../../node_modules/axios/lib/utils.js"(exports, module2) {
    "use strict";
    var bind = require_bind();
    var toString = Object.prototype.toString;
    var kindOf = function(cache) {
      return function(thing) {
        var str = toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
      };
    }(/* @__PURE__ */ Object.create(null));
    function kindOfTest(type4) {
      type4 = type4.toLowerCase();
      return function isKindOf(thing) {
        return kindOf(thing) === type4;
      };
    }
    function isArray(val) {
      return Array.isArray(val);
    }
    function isUndefined(val) {
      return typeof val === "undefined";
    }
    function isBuffer(val) {
      return val !== null && !isUndefined(val) && val.constructor !== null && !isUndefined(val.constructor) && typeof val.constructor.isBuffer === "function" && val.constructor.isBuffer(val);
    }
    var isArrayBuffer = kindOfTest("ArrayBuffer");
    function isArrayBufferView(val) {
      var result;
      if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) {
        result = ArrayBuffer.isView(val);
      } else {
        result = val && val.buffer && isArrayBuffer(val.buffer);
      }
      return result;
    }
    function isString3(val) {
      return typeof val === "string";
    }
    function isNumber2(val) {
      return typeof val === "number";
    }
    function isObject3(val) {
      return val !== null && typeof val === "object";
    }
    function isPlainObject2(val) {
      if (kindOf(val) !== "object") {
        return false;
      }
      var prototype = Object.getPrototypeOf(val);
      return prototype === null || prototype === Object.prototype;
    }
    var isDate2 = kindOfTest("Date");
    var isFile = kindOfTest("File");
    var isBlob = kindOfTest("Blob");
    var isFileList = kindOfTest("FileList");
    function isFunction(val) {
      return toString.call(val) === "[object Function]";
    }
    function isStream(val) {
      return isObject3(val) && isFunction(val.pipe);
    }
    function isFormData(thing) {
      var pattern4 = "[object FormData]";
      return thing && (typeof FormData === "function" && thing instanceof FormData || toString.call(thing) === pattern4 || isFunction(thing.toString) && thing.toString() === pattern4);
    }
    var isURLSearchParams = kindOfTest("URLSearchParams");
    function trim3(str) {
      return str.trim ? str.trim() : str.replace(/^\s+|\s+$/g, "");
    }
    function isStandardBrowserEnv() {
      if (typeof navigator !== "undefined" && (navigator.product === "ReactNative" || navigator.product === "NativeScript" || navigator.product === "NS")) {
        return false;
      }
      return typeof window !== "undefined" && typeof document !== "undefined";
    }
    function forEach(obj, fn) {
      if (obj === null || typeof obj === "undefined") {
        return;
      }
      if (typeof obj !== "object") {
        obj = [obj];
      }
      if (isArray(obj)) {
        for (var i = 0, l = obj.length; i < l; i++) {
          fn.call(null, obj[i], i, obj);
        }
      } else {
        for (var key in obj) {
          if (Object.prototype.hasOwnProperty.call(obj, key)) {
            fn.call(null, obj[key], key, obj);
          }
        }
      }
    }
    function merge3() {
      var result = {};
      function assignValue(val, key) {
        if (isPlainObject2(result[key]) && isPlainObject2(val)) {
          result[key] = merge3(result[key], val);
        } else if (isPlainObject2(val)) {
          result[key] = merge3({}, val);
        } else if (isArray(val)) {
          result[key] = val.slice();
        } else {
          result[key] = val;
        }
      }
      for (var i = 0, l = arguments.length; i < l; i++) {
        forEach(arguments[i], assignValue);
      }
      return result;
    }
    function extend(a, b, thisArg) {
      forEach(b, function assignValue(val, key) {
        if (thisArg && typeof val === "function") {
          a[key] = bind(val, thisArg);
        } else {
          a[key] = val;
        }
      });
      return a;
    }
    function stripBOM(content) {
      if (content.charCodeAt(0) === 65279) {
        content = content.slice(1);
      }
      return content;
    }
    function inherits(constructor, superConstructor, props, descriptors) {
      constructor.prototype = Object.create(superConstructor.prototype, descriptors);
      constructor.prototype.constructor = constructor;
      props && Object.assign(constructor.prototype, props);
    }
    function toFlatObject(sourceObj, destObj, filter) {
      var props;
      var i;
      var prop;
      var merged = {};
      destObj = destObj || {};
      do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while (i-- > 0) {
          prop = props[i];
          if (!merged[prop]) {
            destObj[prop] = sourceObj[prop];
            merged[prop] = true;
          }
        }
        sourceObj = Object.getPrototypeOf(sourceObj);
      } while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
      return destObj;
    }
    function endsWith(str, searchString, position2) {
      str = String(str);
      if (position2 === void 0 || position2 > str.length) {
        position2 = str.length;
      }
      position2 -= searchString.length;
      var lastIndex = str.indexOf(searchString, position2);
      return lastIndex !== -1 && lastIndex === position2;
    }
    function toArray5(thing) {
      if (!thing)
        return null;
      var i = thing.length;
      if (isUndefined(i))
        return null;
      var arr = new Array(i);
      while (i-- > 0) {
        arr[i] = thing[i];
      }
      return arr;
    }
    var isTypedArray = function(TypedArray) {
      return function(thing) {
        return TypedArray && thing instanceof TypedArray;
      };
    }(typeof Uint8Array !== "undefined" && Object.getPrototypeOf(Uint8Array));
    module2.exports = {
      isArray,
      isArrayBuffer,
      isBuffer,
      isFormData,
      isArrayBufferView,
      isString: isString3,
      isNumber: isNumber2,
      isObject: isObject3,
      isPlainObject: isPlainObject2,
      isUndefined,
      isDate: isDate2,
      isFile,
      isBlob,
      isFunction,
      isStream,
      isURLSearchParams,
      isStandardBrowserEnv,
      forEach,
      merge: merge3,
      extend,
      trim: trim3,
      stripBOM,
      inherits,
      toFlatObject,
      kindOf,
      kindOfTest,
      endsWith,
      toArray: toArray5,
      isTypedArray,
      isFileList
    };
  }
});

// ../../node_modules/axios/lib/helpers/buildURL.js
var require_buildURL = __commonJS({
  "../../node_modules/axios/lib/helpers/buildURL.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function encode(val) {
      return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
    }
    module2.exports = function buildURL(url2, params, paramsSerializer) {
      if (!params) {
        return url2;
      }
      var serializedParams;
      if (paramsSerializer) {
        serializedParams = paramsSerializer(params);
      } else if (utils.isURLSearchParams(params)) {
        serializedParams = params.toString();
      } else {
        var parts = [];
        utils.forEach(params, function serialize3(val, key) {
          if (val === null || typeof val === "undefined") {
            return;
          }
          if (utils.isArray(val)) {
            key = key + "[]";
          } else {
            val = [val];
          }
          utils.forEach(val, function parseValue(v) {
            if (utils.isDate(v)) {
              v = v.toISOString();
            } else if (utils.isObject(v)) {
              v = JSON.stringify(v);
            }
            parts.push(encode(key) + "=" + encode(v));
          });
        });
        serializedParams = parts.join("&");
      }
      if (serializedParams) {
        var hashmarkIndex = url2.indexOf("#");
        if (hashmarkIndex !== -1) {
          url2 = url2.slice(0, hashmarkIndex);
        }
        url2 += (url2.indexOf("?") === -1 ? "?" : "&") + serializedParams;
      }
      return url2;
    };
  }
});

// ../../node_modules/axios/lib/core/InterceptorManager.js
var require_InterceptorManager = __commonJS({
  "../../node_modules/axios/lib/core/InterceptorManager.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function InterceptorManager() {
      this.handlers = [];
    }
    InterceptorManager.prototype.use = function use(fulfilled, rejected, options) {
      this.handlers.push({
        fulfilled,
        rejected,
        synchronous: options ? options.synchronous : false,
        runWhen: options ? options.runWhen : null
      });
      return this.handlers.length - 1;
    };
    InterceptorManager.prototype.eject = function eject(id) {
      if (this.handlers[id]) {
        this.handlers[id] = null;
      }
    };
    InterceptorManager.prototype.forEach = function forEach(fn) {
      utils.forEach(this.handlers, function forEachHandler(h) {
        if (h !== null) {
          fn(h);
        }
      });
    };
    module2.exports = InterceptorManager;
  }
});

// ../../node_modules/axios/lib/helpers/normalizeHeaderName.js
var require_normalizeHeaderName = __commonJS({
  "../../node_modules/axios/lib/helpers/normalizeHeaderName.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function normalizeHeaderName(headers, normalizedName) {
      utils.forEach(headers, function processHeader(value, name) {
        if (name !== normalizedName && name.toUpperCase() === normalizedName.toUpperCase()) {
          headers[normalizedName] = value;
          delete headers[name];
        }
      });
    };
  }
});

// ../../node_modules/axios/lib/core/AxiosError.js
var require_AxiosError = __commonJS({
  "../../node_modules/axios/lib/core/AxiosError.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function AxiosError(message2, code, config, request, response) {
      Error.call(this);
      this.message = message2;
      this.name = "AxiosError";
      code && (this.code = code);
      config && (this.config = config);
      request && (this.request = request);
      response && (this.response = response);
    }
    utils.inherits(AxiosError, Error, {
      toJSON: function toJSON() {
        return {
          // Standard
          message: this.message,
          name: this.name,
          // Microsoft
          description: this.description,
          number: this.number,
          // Mozilla
          fileName: this.fileName,
          lineNumber: this.lineNumber,
          columnNumber: this.columnNumber,
          stack: this.stack,
          // Axios
          config: this.config,
          code: this.code,
          status: this.response && this.response.status ? this.response.status : null
        };
      }
    });
    var prototype = AxiosError.prototype;
    var descriptors = {};
    [
      "ERR_BAD_OPTION_VALUE",
      "ERR_BAD_OPTION",
      "ECONNABORTED",
      "ETIMEDOUT",
      "ERR_NETWORK",
      "ERR_FR_TOO_MANY_REDIRECTS",
      "ERR_DEPRECATED",
      "ERR_BAD_RESPONSE",
      "ERR_BAD_REQUEST",
      "ERR_CANCELED"
      // eslint-disable-next-line func-names
    ].forEach(function(code) {
      descriptors[code] = { value: code };
    });
    Object.defineProperties(AxiosError, descriptors);
    Object.defineProperty(prototype, "isAxiosError", { value: true });
    AxiosError.from = function(error, code, config, request, response, customProps) {
      var axiosError = Object.create(prototype);
      utils.toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
      });
      AxiosError.call(axiosError, error.message, code, config, request, response);
      axiosError.name = error.name;
      customProps && Object.assign(axiosError, customProps);
      return axiosError;
    };
    module2.exports = AxiosError;
  }
});

// ../../node_modules/axios/lib/defaults/transitional.js
var require_transitional = __commonJS({
  "../../node_modules/axios/lib/defaults/transitional.js"(exports, module2) {
    "use strict";
    module2.exports = {
      silentJSONParsing: true,
      forcedJSONParsing: true,
      clarifyTimeoutError: false
    };
  }
});

// ../../node_modules/axios/lib/helpers/toFormData.js
var require_toFormData = __commonJS({
  "../../node_modules/axios/lib/helpers/toFormData.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    function toFormData(obj, formData) {
      formData = formData || new FormData();
      var stack = [];
      function convertValue(value) {
        if (value === null)
          return "";
        if (utils.isDate(value)) {
          return value.toISOString();
        }
        if (utils.isArrayBuffer(value) || utils.isTypedArray(value)) {
          return typeof Blob === "function" ? new Blob([value]) : Buffer.from(value);
        }
        return value;
      }
      function build(data, parentKey) {
        if (utils.isPlainObject(data) || utils.isArray(data)) {
          if (stack.indexOf(data) !== -1) {
            throw Error("Circular reference detected in " + parentKey);
          }
          stack.push(data);
          utils.forEach(data, function each3(value, key) {
            if (utils.isUndefined(value))
              return;
            var fullKey = parentKey ? parentKey + "." + key : key;
            var arr;
            if (value && !parentKey && typeof value === "object") {
              if (utils.endsWith(key, "{}")) {
                value = JSON.stringify(value);
              } else if (utils.endsWith(key, "[]") && (arr = utils.toArray(value))) {
                arr.forEach(function(el) {
                  !utils.isUndefined(el) && formData.append(fullKey, convertValue(el));
                });
                return;
              }
            }
            build(value, fullKey);
          });
          stack.pop();
        } else {
          formData.append(parentKey, convertValue(data));
        }
      }
      build(obj);
      return formData;
    }
    module2.exports = toFormData;
  }
});

// ../../node_modules/axios/lib/core/settle.js
var require_settle = __commonJS({
  "../../node_modules/axios/lib/core/settle.js"(exports, module2) {
    "use strict";
    var AxiosError = require_AxiosError();
    module2.exports = function settle(resolve, reject, response) {
      var validateStatus = response.config.validateStatus;
      if (!response.status || !validateStatus || validateStatus(response.status)) {
        resolve(response);
      } else {
        reject(new AxiosError(
          "Request failed with status code " + response.status,
          [AxiosError.ERR_BAD_REQUEST, AxiosError.ERR_BAD_RESPONSE][Math.floor(response.status / 100) - 4],
          response.config,
          response.request,
          response
        ));
      }
    };
  }
});

// ../../node_modules/axios/lib/helpers/cookies.js
var require_cookies = __commonJS({
  "../../node_modules/axios/lib/helpers/cookies.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs support document.cookie
      function standardBrowserEnv() {
        return {
          write: function write(name, value, expires, path2, domain, secure) {
            var cookie = [];
            cookie.push(name + "=" + encodeURIComponent(value));
            if (utils.isNumber(expires)) {
              cookie.push("expires=" + new Date(expires).toGMTString());
            }
            if (utils.isString(path2)) {
              cookie.push("path=" + path2);
            }
            if (utils.isString(domain)) {
              cookie.push("domain=" + domain);
            }
            if (secure === true) {
              cookie.push("secure");
            }
            document.cookie = cookie.join("; ");
          },
          read: function read(name) {
            var match2 = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
            return match2 ? decodeURIComponent(match2[3]) : null;
          },
          remove: function remove2(name) {
            this.write(name, "", Date.now() - 864e5);
          }
        };
      }()
    ) : (
      // Non standard browser env (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return {
          write: function write() {
          },
          read: function read() {
            return null;
          },
          remove: function remove2() {
          }
        };
      }()
    );
  }
});

// ../../node_modules/axios/lib/helpers/isAbsoluteURL.js
var require_isAbsoluteURL = __commonJS({
  "../../node_modules/axios/lib/helpers/isAbsoluteURL.js"(exports, module2) {
    "use strict";
    module2.exports = function isAbsoluteURL(url2) {
      return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url2);
    };
  }
});

// ../../node_modules/axios/lib/helpers/combineURLs.js
var require_combineURLs = __commonJS({
  "../../node_modules/axios/lib/helpers/combineURLs.js"(exports, module2) {
    "use strict";
    module2.exports = function combineURLs(baseURL, relativeURL) {
      return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
    };
  }
});

// ../../node_modules/axios/lib/core/buildFullPath.js
var require_buildFullPath = __commonJS({
  "../../node_modules/axios/lib/core/buildFullPath.js"(exports, module2) {
    "use strict";
    var isAbsoluteURL = require_isAbsoluteURL();
    var combineURLs = require_combineURLs();
    module2.exports = function buildFullPath(baseURL, requestedURL) {
      if (baseURL && !isAbsoluteURL(requestedURL)) {
        return combineURLs(baseURL, requestedURL);
      }
      return requestedURL;
    };
  }
});

// ../../node_modules/axios/lib/helpers/parseHeaders.js
var require_parseHeaders = __commonJS({
  "../../node_modules/axios/lib/helpers/parseHeaders.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var ignoreDuplicateOf = [
      "age",
      "authorization",
      "content-length",
      "content-type",
      "etag",
      "expires",
      "from",
      "host",
      "if-modified-since",
      "if-unmodified-since",
      "last-modified",
      "location",
      "max-forwards",
      "proxy-authorization",
      "referer",
      "retry-after",
      "user-agent"
    ];
    module2.exports = function parseHeaders(headers) {
      var parsed = {};
      var key;
      var val;
      var i;
      if (!headers) {
        return parsed;
      }
      utils.forEach(headers.split("\n"), function parser(line3) {
        i = line3.indexOf(":");
        key = utils.trim(line3.substr(0, i)).toLowerCase();
        val = utils.trim(line3.substr(i + 1));
        if (key) {
          if (parsed[key] && ignoreDuplicateOf.indexOf(key) >= 0) {
            return;
          }
          if (key === "set-cookie") {
            parsed[key] = (parsed[key] ? parsed[key] : []).concat([val]);
          } else {
            parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
          }
        }
      });
      return parsed;
    };
  }
});

// ../../node_modules/axios/lib/helpers/isURLSameOrigin.js
var require_isURLSameOrigin = __commonJS({
  "../../node_modules/axios/lib/helpers/isURLSameOrigin.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = utils.isStandardBrowserEnv() ? (
      // Standard browser envs have full support of the APIs needed to test
      // whether the request URL is of the same origin as current location.
      function standardBrowserEnv() {
        var msie = /(msie|trident)/i.test(navigator.userAgent);
        var urlParsingNode = document.createElement("a");
        var originURL;
        function resolveURL(url2) {
          var href = url2;
          if (msie) {
            urlParsingNode.setAttribute("href", href);
            href = urlParsingNode.href;
          }
          urlParsingNode.setAttribute("href", href);
          return {
            href: urlParsingNode.href,
            protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, "") : "",
            host: urlParsingNode.host,
            search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, "") : "",
            hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, "") : "",
            hostname: urlParsingNode.hostname,
            port: urlParsingNode.port,
            pathname: urlParsingNode.pathname.charAt(0) === "/" ? urlParsingNode.pathname : "/" + urlParsingNode.pathname
          };
        }
        originURL = resolveURL(window.location.href);
        return function isURLSameOrigin(requestURL) {
          var parsed = utils.isString(requestURL) ? resolveURL(requestURL) : requestURL;
          return parsed.protocol === originURL.protocol && parsed.host === originURL.host;
        };
      }()
    ) : (
      // Non standard browser envs (web workers, react-native) lack needed support.
      function nonStandardBrowserEnv() {
        return function isURLSameOrigin() {
          return true;
        };
      }()
    );
  }
});

// ../../node_modules/axios/lib/cancel/CanceledError.js
var require_CanceledError = __commonJS({
  "../../node_modules/axios/lib/cancel/CanceledError.js"(exports, module2) {
    "use strict";
    var AxiosError = require_AxiosError();
    var utils = require_utils();
    function CanceledError(message2) {
      AxiosError.call(this, message2 == null ? "canceled" : message2, AxiosError.ERR_CANCELED);
      this.name = "CanceledError";
    }
    utils.inherits(CanceledError, AxiosError, {
      __CANCEL__: true
    });
    module2.exports = CanceledError;
  }
});

// ../../node_modules/axios/lib/helpers/parseProtocol.js
var require_parseProtocol = __commonJS({
  "../../node_modules/axios/lib/helpers/parseProtocol.js"(exports, module2) {
    "use strict";
    module2.exports = function parseProtocol(url2) {
      var match2 = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url2);
      return match2 && match2[1] || "";
    };
  }
});

// ../../node_modules/axios/lib/adapters/xhr.js
var require_xhr = __commonJS({
  "../../node_modules/axios/lib/adapters/xhr.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var cookies = require_cookies();
    var buildURL = require_buildURL();
    var buildFullPath = require_buildFullPath();
    var parseHeaders = require_parseHeaders();
    var isURLSameOrigin = require_isURLSameOrigin();
    var transitionalDefaults = require_transitional();
    var AxiosError = require_AxiosError();
    var CanceledError = require_CanceledError();
    var parseProtocol = require_parseProtocol();
    module2.exports = function xhrAdapter(config) {
      return new Promise(function dispatchXhrRequest(resolve, reject) {
        var requestData = config.data;
        var requestHeaders = config.headers;
        var responseType = config.responseType;
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        if (utils.isFormData(requestData) && utils.isStandardBrowserEnv()) {
          delete requestHeaders["Content-Type"];
        }
        var request = new XMLHttpRequest();
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password ? unescape(encodeURIComponent(config.auth.password)) : "";
          requestHeaders.Authorization = "Basic " + btoa(username + ":" + password);
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        request.open(config.method.toUpperCase(), buildURL(fullPath, config.params, config.paramsSerializer), true);
        request.timeout = config.timeout;
        function onloadend() {
          if (!request) {
            return;
          }
          var responseHeaders = "getAllResponseHeaders" in request ? parseHeaders(request.getAllResponseHeaders()) : null;
          var responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
          var response = {
            data: responseData,
            status: request.status,
            statusText: request.statusText,
            headers: responseHeaders,
            config,
            request
          };
          settle(function _resolve(value) {
            resolve(value);
            done();
          }, function _reject(err) {
            reject(err);
            done();
          }, response);
          request = null;
        }
        if ("onloadend" in request) {
          request.onloadend = onloadend;
        } else {
          request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) {
              return;
            }
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) {
              return;
            }
            setTimeout(onloadend);
          };
        }
        request.onabort = function handleAbort() {
          if (!request) {
            return;
          }
          reject(new AxiosError("Request aborted", AxiosError.ECONNABORTED, config, request));
          request = null;
        };
        request.onerror = function handleError() {
          reject(new AxiosError("Network Error", AxiosError.ERR_NETWORK, config, request, request));
          request = null;
        };
        request.ontimeout = function handleTimeout() {
          var timeoutErrorMessage = config.timeout ? "timeout of " + config.timeout + "ms exceeded" : "timeout exceeded";
          var transitional = config.transitional || transitionalDefaults;
          if (config.timeoutErrorMessage) {
            timeoutErrorMessage = config.timeoutErrorMessage;
          }
          reject(new AxiosError(
            timeoutErrorMessage,
            transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
            config,
            request
          ));
          request = null;
        };
        if (utils.isStandardBrowserEnv()) {
          var xsrfValue = (config.withCredentials || isURLSameOrigin(fullPath)) && config.xsrfCookieName ? cookies.read(config.xsrfCookieName) : void 0;
          if (xsrfValue) {
            requestHeaders[config.xsrfHeaderName] = xsrfValue;
          }
        }
        if ("setRequestHeader" in request) {
          utils.forEach(requestHeaders, function setRequestHeader(val, key) {
            if (typeof requestData === "undefined" && key.toLowerCase() === "content-type") {
              delete requestHeaders[key];
            } else {
              request.setRequestHeader(key, val);
            }
          });
        }
        if (!utils.isUndefined(config.withCredentials)) {
          request.withCredentials = !!config.withCredentials;
        }
        if (responseType && responseType !== "json") {
          request.responseType = config.responseType;
        }
        if (typeof config.onDownloadProgress === "function") {
          request.addEventListener("progress", config.onDownloadProgress);
        }
        if (typeof config.onUploadProgress === "function" && request.upload) {
          request.upload.addEventListener("progress", config.onUploadProgress);
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (!request) {
              return;
            }
            reject(!cancel || cancel && cancel.type ? new CanceledError() : cancel);
            request.abort();
            request = null;
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (!requestData) {
          requestData = null;
        }
        var protocol = parseProtocol(fullPath);
        if (protocol && ["http", "https", "file"].indexOf(protocol) === -1) {
          reject(new AxiosError("Unsupported protocol " + protocol + ":", AxiosError.ERR_BAD_REQUEST, config));
          return;
        }
        request.send(requestData);
      });
    };
  }
});

// ../../node_modules/ms/index.js
var require_ms = __commonJS({
  "../../node_modules/ms/index.js"(exports, module2) {
    "use strict";
    var s2 = 1e3;
    var m = s2 * 60;
    var h = m * 60;
    var d = h * 24;
    var w = d * 7;
    var y2 = d * 365.25;
    module2.exports = function(val, options) {
      options = options || {};
      var type4 = typeof val;
      if (type4 === "string" && val.length > 0) {
        return parse2(val);
      } else if (type4 === "number" && isFinite(val)) {
        return options.long ? fmtLong(val) : fmtShort(val);
      }
      throw new Error(
        "val is not a non-empty string or a valid number. val=" + JSON.stringify(val)
      );
    };
    function parse2(str) {
      str = String(str);
      if (str.length > 100) {
        return;
      }
      var match2 = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(
        str
      );
      if (!match2) {
        return;
      }
      var n = parseFloat(match2[1]);
      var type4 = (match2[2] || "ms").toLowerCase();
      switch (type4) {
        case "years":
        case "year":
        case "yrs":
        case "yr":
        case "y":
          return n * y2;
        case "weeks":
        case "week":
        case "w":
          return n * w;
        case "days":
        case "day":
        case "d":
          return n * d;
        case "hours":
        case "hour":
        case "hrs":
        case "hr":
        case "h":
          return n * h;
        case "minutes":
        case "minute":
        case "mins":
        case "min":
        case "m":
          return n * m;
        case "seconds":
        case "second":
        case "secs":
        case "sec":
        case "s":
          return n * s2;
        case "milliseconds":
        case "millisecond":
        case "msecs":
        case "msec":
        case "ms":
          return n;
        default:
          return void 0;
      }
    }
    function fmtShort(ms) {
      var msAbs = Math.abs(ms);
      if (msAbs >= d) {
        return Math.round(ms / d) + "d";
      }
      if (msAbs >= h) {
        return Math.round(ms / h) + "h";
      }
      if (msAbs >= m) {
        return Math.round(ms / m) + "m";
      }
      if (msAbs >= s2) {
        return Math.round(ms / s2) + "s";
      }
      return ms + "ms";
    }
    function fmtLong(ms) {
      var msAbs = Math.abs(ms);
      if (msAbs >= d) {
        return plural(ms, msAbs, d, "day");
      }
      if (msAbs >= h) {
        return plural(ms, msAbs, h, "hour");
      }
      if (msAbs >= m) {
        return plural(ms, msAbs, m, "minute");
      }
      if (msAbs >= s2) {
        return plural(ms, msAbs, s2, "second");
      }
      return ms + " ms";
    }
    function plural(ms, msAbs, n, name) {
      var isPlural = msAbs >= n * 1.5;
      return Math.round(ms / n) + " " + name + (isPlural ? "s" : "");
    }
  }
});

// ../../node_modules/debug/src/common.js
var require_common = __commonJS({
  "../../node_modules/debug/src/common.js"(exports, module2) {
    "use strict";
    function setup(env2) {
      createDebug.debug = createDebug;
      createDebug.default = createDebug;
      createDebug.coerce = coerce;
      createDebug.disable = disable;
      createDebug.enable = enable;
      createDebug.enabled = enabled;
      createDebug.humanize = require_ms();
      createDebug.destroy = destroy3;
      Object.keys(env2).forEach((key) => {
        createDebug[key] = env2[key];
      });
      createDebug.names = [];
      createDebug.skips = [];
      createDebug.formatters = {};
      function selectColor(namespace) {
        let hash = 0;
        for (let i = 0; i < namespace.length; i++) {
          hash = (hash << 5) - hash + namespace.charCodeAt(i);
          hash |= 0;
        }
        return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
      }
      createDebug.selectColor = selectColor;
      function createDebug(namespace) {
        let prevTime;
        let enableOverride = null;
        let namespacesCache;
        let enabledCache;
        function debug(...args) {
          if (!debug.enabled) {
            return;
          }
          const self2 = debug;
          const curr = Number(/* @__PURE__ */ new Date());
          const ms = curr - (prevTime || curr);
          self2.diff = ms;
          self2.prev = prevTime;
          self2.curr = curr;
          prevTime = curr;
          args[0] = createDebug.coerce(args[0]);
          if (typeof args[0] !== "string") {
            args.unshift("%O");
          }
          let index2 = 0;
          args[0] = args[0].replace(/%([a-zA-Z%])/g, (match2, format2) => {
            if (match2 === "%%") {
              return "%";
            }
            index2++;
            const formatter = createDebug.formatters[format2];
            if (typeof formatter === "function") {
              const val = args[index2];
              match2 = formatter.call(self2, val);
              args.splice(index2, 1);
              index2--;
            }
            return match2;
          });
          createDebug.formatArgs.call(self2, args);
          const logFn = self2.log || createDebug.log;
          logFn.apply(self2, args);
        }
        debug.namespace = namespace;
        debug.useColors = createDebug.useColors();
        debug.color = createDebug.selectColor(namespace);
        debug.extend = extend;
        debug.destroy = createDebug.destroy;
        Object.defineProperty(debug, "enabled", {
          enumerable: true,
          configurable: false,
          get: () => {
            if (enableOverride !== null) {
              return enableOverride;
            }
            if (namespacesCache !== createDebug.namespaces) {
              namespacesCache = createDebug.namespaces;
              enabledCache = createDebug.enabled(namespace);
            }
            return enabledCache;
          },
          set: (v) => {
            enableOverride = v;
          }
        });
        if (typeof createDebug.init === "function") {
          createDebug.init(debug);
        }
        return debug;
      }
      function extend(namespace, delimiter2) {
        const newDebug = createDebug(this.namespace + (typeof delimiter2 === "undefined" ? ":" : delimiter2) + namespace);
        newDebug.log = this.log;
        return newDebug;
      }
      function enable(namespaces) {
        createDebug.save(namespaces);
        createDebug.namespaces = namespaces;
        createDebug.names = [];
        createDebug.skips = [];
        let i;
        const split = (typeof namespaces === "string" ? namespaces : "").split(/[\s,]+/);
        const len = split.length;
        for (i = 0; i < len; i++) {
          if (!split[i]) {
            continue;
          }
          namespaces = split[i].replace(/\*/g, ".*?");
          if (namespaces[0] === "-") {
            createDebug.skips.push(new RegExp("^" + namespaces.slice(1) + "$"));
          } else {
            createDebug.names.push(new RegExp("^" + namespaces + "$"));
          }
        }
      }
      function disable() {
        const namespaces = [
          ...createDebug.names.map(toNamespace),
          ...createDebug.skips.map(toNamespace).map((namespace) => "-" + namespace)
        ].join(",");
        createDebug.enable("");
        return namespaces;
      }
      function enabled(name) {
        if (name[name.length - 1] === "*") {
          return true;
        }
        let i;
        let len;
        for (i = 0, len = createDebug.skips.length; i < len; i++) {
          if (createDebug.skips[i].test(name)) {
            return false;
          }
        }
        for (i = 0, len = createDebug.names.length; i < len; i++) {
          if (createDebug.names[i].test(name)) {
            return true;
          }
        }
        return false;
      }
      function toNamespace(regexp4) {
        return regexp4.toString().substring(2, regexp4.toString().length - 2).replace(/\.\*\?$/, "*");
      }
      function coerce(val) {
        if (val instanceof Error) {
          return val.stack || val.message;
        }
        return val;
      }
      function destroy3() {
        console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
      }
      createDebug.enable(createDebug.load());
      return createDebug;
    }
    module2.exports = setup;
  }
});

// ../../node_modules/debug/src/browser.js
var require_browser = __commonJS({
  "../../node_modules/debug/src/browser.js"(exports, module2) {
    "use strict";
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.storage = localstorage();
    exports.destroy = (() => {
      let warned2 = false;
      return () => {
        if (!warned2) {
          warned2 = true;
          console.warn("Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`.");
        }
      };
    })();
    exports.colors = [
      "#0000CC",
      "#0000FF",
      "#0033CC",
      "#0033FF",
      "#0066CC",
      "#0066FF",
      "#0099CC",
      "#0099FF",
      "#00CC00",
      "#00CC33",
      "#00CC66",
      "#00CC99",
      "#00CCCC",
      "#00CCFF",
      "#3300CC",
      "#3300FF",
      "#3333CC",
      "#3333FF",
      "#3366CC",
      "#3366FF",
      "#3399CC",
      "#3399FF",
      "#33CC00",
      "#33CC33",
      "#33CC66",
      "#33CC99",
      "#33CCCC",
      "#33CCFF",
      "#6600CC",
      "#6600FF",
      "#6633CC",
      "#6633FF",
      "#66CC00",
      "#66CC33",
      "#9900CC",
      "#9900FF",
      "#9933CC",
      "#9933FF",
      "#99CC00",
      "#99CC33",
      "#CC0000",
      "#CC0033",
      "#CC0066",
      "#CC0099",
      "#CC00CC",
      "#CC00FF",
      "#CC3300",
      "#CC3333",
      "#CC3366",
      "#CC3399",
      "#CC33CC",
      "#CC33FF",
      "#CC6600",
      "#CC6633",
      "#CC9900",
      "#CC9933",
      "#CCCC00",
      "#CCCC33",
      "#FF0000",
      "#FF0033",
      "#FF0066",
      "#FF0099",
      "#FF00CC",
      "#FF00FF",
      "#FF3300",
      "#FF3333",
      "#FF3366",
      "#FF3399",
      "#FF33CC",
      "#FF33FF",
      "#FF6600",
      "#FF6633",
      "#FF9900",
      "#FF9933",
      "#FFCC00",
      "#FFCC33"
    ];
    function useColors() {
      if (typeof window !== "undefined" && window.process && (window.process.type === "renderer" || window.process.__nwjs)) {
        return true;
      }
      if (typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
        return false;
      }
      return typeof document !== "undefined" && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
      typeof window !== "undefined" && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
      // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
      typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
      typeof navigator !== "undefined" && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    function formatArgs(args) {
      args[0] = (this.useColors ? "%c" : "") + this.namespace + (this.useColors ? " %c" : " ") + args[0] + (this.useColors ? "%c " : " ") + "+" + module2.exports.humanize(this.diff);
      if (!this.useColors) {
        return;
      }
      const c = "color: " + this.color;
      args.splice(1, 0, c, "color: inherit");
      let index2 = 0;
      let lastC = 0;
      args[0].replace(/%[a-zA-Z%]/g, (match2) => {
        if (match2 === "%%") {
          return;
        }
        index2++;
        if (match2 === "%c") {
          lastC = index2;
        }
      });
      args.splice(lastC, 0, c);
    }
    exports.log = console.debug || console.log || (() => {
    });
    function save(namespaces) {
      try {
        if (namespaces) {
          exports.storage.setItem("debug", namespaces);
        } else {
          exports.storage.removeItem("debug");
        }
      } catch (error) {
      }
    }
    function load() {
      let r;
      try {
        r = exports.storage.getItem("debug");
      } catch (error) {
      }
      if (!r && typeof process !== "undefined" && "env" in process) {
        r = process.env.DEBUG;
      }
      return r;
    }
    function localstorage() {
      try {
        return localStorage;
      } catch (error) {
      }
    }
    module2.exports = require_common()(exports);
    var { formatters } = module2.exports;
    formatters.j = function(v) {
      try {
        return JSON.stringify(v);
      } catch (error) {
        return "[UnexpectedJSONParseError]: " + error.message;
      }
    };
  }
});

// ../../node_modules/has-flag/index.js
var require_has_flag = __commonJS({
  "../../node_modules/has-flag/index.js"(exports, module2) {
    "use strict";
    module2.exports = (flag, argv = process.argv) => {
      const prefix = flag.startsWith("-") ? "" : flag.length === 1 ? "-" : "--";
      const position2 = argv.indexOf(prefix + flag);
      const terminatorPosition = argv.indexOf("--");
      return position2 !== -1 && (terminatorPosition === -1 || position2 < terminatorPosition);
    };
  }
});

// ../../node_modules/supports-color/index.js
var require_supports_color = __commonJS({
  "../../node_modules/supports-color/index.js"(exports, module2) {
    "use strict";
    var os = require("os");
    var tty = require("tty");
    var hasFlag = require_has_flag();
    var { env: env2 } = process;
    var forceColor;
    if (hasFlag("no-color") || hasFlag("no-colors") || hasFlag("color=false") || hasFlag("color=never")) {
      forceColor = 0;
    } else if (hasFlag("color") || hasFlag("colors") || hasFlag("color=true") || hasFlag("color=always")) {
      forceColor = 1;
    }
    if ("FORCE_COLOR" in env2) {
      if (env2.FORCE_COLOR === "true") {
        forceColor = 1;
      } else if (env2.FORCE_COLOR === "false") {
        forceColor = 0;
      } else {
        forceColor = env2.FORCE_COLOR.length === 0 ? 1 : Math.min(parseInt(env2.FORCE_COLOR, 10), 3);
      }
    }
    function translateLevel(level) {
      if (level === 0) {
        return false;
      }
      return {
        level,
        hasBasic: true,
        has256: level >= 2,
        has16m: level >= 3
      };
    }
    function supportsColor(haveStream, streamIsTTY) {
      if (forceColor === 0) {
        return 0;
      }
      if (hasFlag("color=16m") || hasFlag("color=full") || hasFlag("color=truecolor")) {
        return 3;
      }
      if (hasFlag("color=256")) {
        return 2;
      }
      if (haveStream && !streamIsTTY && forceColor === void 0) {
        return 0;
      }
      const min3 = forceColor || 0;
      if (env2.TERM === "dumb") {
        return min3;
      }
      if (process.platform === "win32") {
        const osRelease = os.release().split(".");
        if (Number(osRelease[0]) >= 10 && Number(osRelease[2]) >= 10586) {
          return Number(osRelease[2]) >= 14931 ? 3 : 2;
        }
        return 1;
      }
      if ("CI" in env2) {
        if (["TRAVIS", "CIRCLECI", "APPVEYOR", "GITLAB_CI", "GITHUB_ACTIONS", "BUILDKITE"].some((sign2) => sign2 in env2) || env2.CI_NAME === "codeship") {
          return 1;
        }
        return min3;
      }
      if ("TEAMCITY_VERSION" in env2) {
        return /^(9\.(0*[1-9]\d*)\.|\d{2,}\.)/.test(env2.TEAMCITY_VERSION) ? 1 : 0;
      }
      if (env2.COLORTERM === "truecolor") {
        return 3;
      }
      if ("TERM_PROGRAM" in env2) {
        const version2 = parseInt((env2.TERM_PROGRAM_VERSION || "").split(".")[0], 10);
        switch (env2.TERM_PROGRAM) {
          case "iTerm.app":
            return version2 >= 3 ? 3 : 2;
          case "Apple_Terminal":
            return 2;
        }
      }
      if (/-256(color)?$/i.test(env2.TERM)) {
        return 2;
      }
      if (/^screen|^xterm|^vt100|^vt220|^rxvt|color|ansi|cygwin|linux/i.test(env2.TERM)) {
        return 1;
      }
      if ("COLORTERM" in env2) {
        return 1;
      }
      return min3;
    }
    function getSupportLevel(stream) {
      const level = supportsColor(stream, stream && stream.isTTY);
      return translateLevel(level);
    }
    module2.exports = {
      supportsColor: getSupportLevel,
      stdout: translateLevel(supportsColor(true, tty.isatty(1))),
      stderr: translateLevel(supportsColor(true, tty.isatty(2)))
    };
  }
});

// ../../node_modules/debug/src/node.js
var require_node = __commonJS({
  "../../node_modules/debug/src/node.js"(exports, module2) {
    "use strict";
    var tty = require("tty");
    var util = require("util");
    exports.init = init;
    exports.log = log;
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.destroy = util.deprecate(
      () => {
      },
      "Instance method `debug.destroy()` is deprecated and no longer does anything. It will be removed in the next major version of `debug`."
    );
    exports.colors = [6, 2, 3, 4, 5, 1];
    try {
      const supportsColor = require_supports_color();
      if (supportsColor && (supportsColor.stderr || supportsColor).level >= 2) {
        exports.colors = [
          20,
          21,
          26,
          27,
          32,
          33,
          38,
          39,
          40,
          41,
          42,
          43,
          44,
          45,
          56,
          57,
          62,
          63,
          68,
          69,
          74,
          75,
          76,
          77,
          78,
          79,
          80,
          81,
          92,
          93,
          98,
          99,
          112,
          113,
          128,
          129,
          134,
          135,
          148,
          149,
          160,
          161,
          162,
          163,
          164,
          165,
          166,
          167,
          168,
          169,
          170,
          171,
          172,
          173,
          178,
          179,
          184,
          185,
          196,
          197,
          198,
          199,
          200,
          201,
          202,
          203,
          204,
          205,
          206,
          207,
          208,
          209,
          214,
          215,
          220,
          221
        ];
      }
    } catch (error) {
    }
    exports.inspectOpts = Object.keys(process.env).filter((key) => {
      return /^debug_/i.test(key);
    }).reduce((obj, key) => {
      const prop = key.substring(6).toLowerCase().replace(/_([a-z])/g, (_, k) => {
        return k.toUpperCase();
      });
      let val = process.env[key];
      if (/^(yes|on|true|enabled)$/i.test(val)) {
        val = true;
      } else if (/^(no|off|false|disabled)$/i.test(val)) {
        val = false;
      } else if (val === "null") {
        val = null;
      } else {
        val = Number(val);
      }
      obj[prop] = val;
      return obj;
    }, {});
    function useColors() {
      return "colors" in exports.inspectOpts ? Boolean(exports.inspectOpts.colors) : tty.isatty(process.stderr.fd);
    }
    function formatArgs(args) {
      const { namespace: name, useColors: useColors2 } = this;
      if (useColors2) {
        const c = this.color;
        const colorCode = "\x1B[3" + (c < 8 ? c : "8;5;" + c);
        const prefix = `  ${colorCode};1m${name} \x1B[0m`;
        args[0] = prefix + args[0].split("\n").join("\n" + prefix);
        args.push(colorCode + "m+" + module2.exports.humanize(this.diff) + "\x1B[0m");
      } else {
        args[0] = getDate() + name + " " + args[0];
      }
    }
    function getDate() {
      if (exports.inspectOpts.hideDate) {
        return "";
      }
      return (/* @__PURE__ */ new Date()).toISOString() + " ";
    }
    function log(...args) {
      return process.stderr.write(util.format(...args) + "\n");
    }
    function save(namespaces) {
      if (namespaces) {
        process.env.DEBUG = namespaces;
      } else {
        delete process.env.DEBUG;
      }
    }
    function load() {
      return process.env.DEBUG;
    }
    function init(debug) {
      debug.inspectOpts = {};
      const keys3 = Object.keys(exports.inspectOpts);
      for (let i = 0; i < keys3.length; i++) {
        debug.inspectOpts[keys3[i]] = exports.inspectOpts[keys3[i]];
      }
    }
    module2.exports = require_common()(exports);
    var { formatters } = module2.exports;
    formatters.o = function(v) {
      this.inspectOpts.colors = this.useColors;
      return util.inspect(v, this.inspectOpts).split("\n").map((str) => str.trim()).join(" ");
    };
    formatters.O = function(v) {
      this.inspectOpts.colors = this.useColors;
      return util.inspect(v, this.inspectOpts);
    };
  }
});

// ../../node_modules/debug/src/index.js
var require_src = __commonJS({
  "../../node_modules/debug/src/index.js"(exports, module2) {
    "use strict";
    if (typeof process === "undefined" || process.type === "renderer" || process.browser === true || process.__nwjs) {
      module2.exports = require_browser();
    } else {
      module2.exports = require_node();
    }
  }
});

// ../../node_modules/follow-redirects/debug.js
var require_debug = __commonJS({
  "../../node_modules/follow-redirects/debug.js"(exports, module2) {
    "use strict";
    var debug;
    module2.exports = function() {
      if (!debug) {
        try {
          debug = require_src()("follow-redirects");
        } catch (error) {
        }
        if (typeof debug !== "function") {
          debug = function() {
          };
        }
      }
      debug.apply(null, arguments);
    };
  }
});

// ../../node_modules/follow-redirects/index.js
var require_follow_redirects = __commonJS({
  "../../node_modules/follow-redirects/index.js"(exports, module2) {
    "use strict";
    var url2 = require("url");
    var URL2 = url2.URL;
    var http = require("http");
    var https = require("https");
    var Writable = require("stream").Writable;
    var assert = require("assert");
    var debug = require_debug();
    var useNativeURL = false;
    try {
      assert(new URL2());
    } catch (error) {
      useNativeURL = error.code === "ERR_INVALID_URL";
    }
    var preservedUrlFields = [
      "auth",
      "host",
      "hostname",
      "href",
      "path",
      "pathname",
      "port",
      "protocol",
      "query",
      "search",
      "hash"
    ];
    var events = ["abort", "aborted", "connect", "error", "socket", "timeout"];
    var eventHandlers = /* @__PURE__ */ Object.create(null);
    events.forEach(function(event) {
      eventHandlers[event] = function(arg1, arg2, arg3) {
        this._redirectable.emit(event, arg1, arg2, arg3);
      };
    });
    var InvalidUrlError = createErrorType(
      "ERR_INVALID_URL",
      "Invalid URL",
      TypeError
    );
    var RedirectionError = createErrorType(
      "ERR_FR_REDIRECTION_FAILURE",
      "Redirected request failed"
    );
    var TooManyRedirectsError = createErrorType(
      "ERR_FR_TOO_MANY_REDIRECTS",
      "Maximum number of redirects exceeded",
      RedirectionError
    );
    var MaxBodyLengthExceededError = createErrorType(
      "ERR_FR_MAX_BODY_LENGTH_EXCEEDED",
      "Request body larger than maxBodyLength limit"
    );
    var WriteAfterEndError = createErrorType(
      "ERR_STREAM_WRITE_AFTER_END",
      "write after end"
    );
    var destroy3 = Writable.prototype.destroy || noop7;
    function RedirectableRequest(options, responseCallback) {
      Writable.call(this);
      this._sanitizeOptions(options);
      this._options = options;
      this._ended = false;
      this._ending = false;
      this._redirectCount = 0;
      this._redirects = [];
      this._requestBodyLength = 0;
      this._requestBodyBuffers = [];
      if (responseCallback) {
        this.on("response", responseCallback);
      }
      var self2 = this;
      this._onNativeResponse = function(response) {
        try {
          self2._processResponse(response);
        } catch (cause) {
          self2.emit("error", cause instanceof RedirectionError ? cause : new RedirectionError({ cause }));
        }
      };
      this._performRequest();
    }
    RedirectableRequest.prototype = Object.create(Writable.prototype);
    RedirectableRequest.prototype.abort = function() {
      destroyRequest(this._currentRequest);
      this._currentRequest.abort();
      this.emit("abort");
    };
    RedirectableRequest.prototype.destroy = function(error) {
      destroyRequest(this._currentRequest, error);
      destroy3.call(this, error);
      return this;
    };
    RedirectableRequest.prototype.write = function(data, encoding, callback) {
      if (this._ending) {
        throw new WriteAfterEndError();
      }
      if (!isString3(data) && !isBuffer(data)) {
        throw new TypeError("data should be a string, Buffer or Uint8Array");
      }
      if (isFunction(encoding)) {
        callback = encoding;
        encoding = null;
      }
      if (data.length === 0) {
        if (callback) {
          callback();
        }
        return;
      }
      if (this._requestBodyLength + data.length <= this._options.maxBodyLength) {
        this._requestBodyLength += data.length;
        this._requestBodyBuffers.push({ data, encoding });
        this._currentRequest.write(data, encoding, callback);
      } else {
        this.emit("error", new MaxBodyLengthExceededError());
        this.abort();
      }
    };
    RedirectableRequest.prototype.end = function(data, encoding, callback) {
      if (isFunction(data)) {
        callback = data;
        data = encoding = null;
      } else if (isFunction(encoding)) {
        callback = encoding;
        encoding = null;
      }
      if (!data) {
        this._ended = this._ending = true;
        this._currentRequest.end(null, null, callback);
      } else {
        var self2 = this;
        var currentRequest = this._currentRequest;
        this.write(data, encoding, function() {
          self2._ended = true;
          currentRequest.end(null, null, callback);
        });
        this._ending = true;
      }
    };
    RedirectableRequest.prototype.setHeader = function(name, value) {
      this._options.headers[name] = value;
      this._currentRequest.setHeader(name, value);
    };
    RedirectableRequest.prototype.removeHeader = function(name) {
      delete this._options.headers[name];
      this._currentRequest.removeHeader(name);
    };
    RedirectableRequest.prototype.setTimeout = function(msecs, callback) {
      var self2 = this;
      function destroyOnTimeout(socket) {
        socket.setTimeout(msecs);
        socket.removeListener("timeout", socket.destroy);
        socket.addListener("timeout", socket.destroy);
      }
      function startTimer(socket) {
        if (self2._timeout) {
          clearTimeout(self2._timeout);
        }
        self2._timeout = setTimeout(function() {
          self2.emit("timeout");
          clearTimer();
        }, msecs);
        destroyOnTimeout(socket);
      }
      function clearTimer() {
        if (self2._timeout) {
          clearTimeout(self2._timeout);
          self2._timeout = null;
        }
        self2.removeListener("abort", clearTimer);
        self2.removeListener("error", clearTimer);
        self2.removeListener("response", clearTimer);
        self2.removeListener("close", clearTimer);
        if (callback) {
          self2.removeListener("timeout", callback);
        }
        if (!self2.socket) {
          self2._currentRequest.removeListener("socket", startTimer);
        }
      }
      if (callback) {
        this.on("timeout", callback);
      }
      if (this.socket) {
        startTimer(this.socket);
      } else {
        this._currentRequest.once("socket", startTimer);
      }
      this.on("socket", destroyOnTimeout);
      this.on("abort", clearTimer);
      this.on("error", clearTimer);
      this.on("response", clearTimer);
      this.on("close", clearTimer);
      return this;
    };
    [
      "flushHeaders",
      "getHeader",
      "setNoDelay",
      "setSocketKeepAlive"
    ].forEach(function(method4) {
      RedirectableRequest.prototype[method4] = function(a, b) {
        return this._currentRequest[method4](a, b);
      };
    });
    ["aborted", "connection", "socket"].forEach(function(property) {
      Object.defineProperty(RedirectableRequest.prototype, property, {
        get: function() {
          return this._currentRequest[property];
        }
      });
    });
    RedirectableRequest.prototype._sanitizeOptions = function(options) {
      if (!options.headers) {
        options.headers = {};
      }
      if (options.host) {
        if (!options.hostname) {
          options.hostname = options.host;
        }
        delete options.host;
      }
      if (!options.pathname && options.path) {
        var searchPos = options.path.indexOf("?");
        if (searchPos < 0) {
          options.pathname = options.path;
        } else {
          options.pathname = options.path.substring(0, searchPos);
          options.search = options.path.substring(searchPos);
        }
      }
    };
    RedirectableRequest.prototype._performRequest = function() {
      var protocol = this._options.protocol;
      var nativeProtocol = this._options.nativeProtocols[protocol];
      if (!nativeProtocol) {
        throw new TypeError("Unsupported protocol " + protocol);
      }
      if (this._options.agents) {
        var scheme = protocol.slice(0, -1);
        this._options.agent = this._options.agents[scheme];
      }
      var request = this._currentRequest = nativeProtocol.request(this._options, this._onNativeResponse);
      request._redirectable = this;
      for (var event of events) {
        request.on(event, eventHandlers[event]);
      }
      this._currentUrl = /^\//.test(this._options.path) ? url2.format(this._options) : (
        // When making a request to a proxy, […]
        // a client MUST send the target URI in absolute-form […].
        this._options.path
      );
      if (this._isRedirect) {
        var i = 0;
        var self2 = this;
        var buffers = this._requestBodyBuffers;
        (function writeNext(error) {
          if (request === self2._currentRequest) {
            if (error) {
              self2.emit("error", error);
            } else if (i < buffers.length) {
              var buffer = buffers[i++];
              if (!request.finished) {
                request.write(buffer.data, buffer.encoding, writeNext);
              }
            } else if (self2._ended) {
              request.end();
            }
          }
        })();
      }
    };
    RedirectableRequest.prototype._processResponse = function(response) {
      var statusCode = response.statusCode;
      if (this._options.trackRedirects) {
        this._redirects.push({
          url: this._currentUrl,
          headers: response.headers,
          statusCode
        });
      }
      var location = response.headers.location;
      if (!location || this._options.followRedirects === false || statusCode < 300 || statusCode >= 400) {
        response.responseUrl = this._currentUrl;
        response.redirects = this._redirects;
        this.emit("response", response);
        this._requestBodyBuffers = [];
        return;
      }
      destroyRequest(this._currentRequest);
      response.destroy();
      if (++this._redirectCount > this._options.maxRedirects) {
        throw new TooManyRedirectsError();
      }
      var requestHeaders;
      var beforeRedirect = this._options.beforeRedirect;
      if (beforeRedirect) {
        requestHeaders = Object.assign({
          // The Host header was set by nativeProtocol.request
          Host: response.req.getHeader("host")
        }, this._options.headers);
      }
      var method4 = this._options.method;
      if ((statusCode === 301 || statusCode === 302) && this._options.method === "POST" || // RFC7231§6.4.4: The 303 (See Other) status code indicates that
      // the server is redirecting the user agent to a different resource […]
      // A user agent can perform a retrieval request targeting that URI
      // (a GET or HEAD request if using HTTP) […]
      statusCode === 303 && !/^(?:GET|HEAD)$/.test(this._options.method)) {
        this._options.method = "GET";
        this._requestBodyBuffers = [];
        removeMatchingHeaders(/^content-/i, this._options.headers);
      }
      var currentHostHeader = removeMatchingHeaders(/^host$/i, this._options.headers);
      var currentUrlParts = parseUrl(this._currentUrl);
      var currentHost = currentHostHeader || currentUrlParts.host;
      var currentUrl = /^\w+:/.test(location) ? this._currentUrl : url2.format(Object.assign(currentUrlParts, { host: currentHost }));
      var redirectUrl = resolveUrl(location, currentUrl);
      debug("redirecting to", redirectUrl.href);
      this._isRedirect = true;
      spreadUrlObject(redirectUrl, this._options);
      if (redirectUrl.protocol !== currentUrlParts.protocol && redirectUrl.protocol !== "https:" || redirectUrl.host !== currentHost && !isSubdomain(redirectUrl.host, currentHost)) {
        removeMatchingHeaders(/^(?:authorization|cookie)$/i, this._options.headers);
      }
      if (isFunction(beforeRedirect)) {
        var responseDetails = {
          headers: response.headers,
          statusCode
        };
        var requestDetails = {
          url: currentUrl,
          method: method4,
          headers: requestHeaders
        };
        beforeRedirect(this._options, responseDetails, requestDetails);
        this._sanitizeOptions(this._options);
      }
      this._performRequest();
    };
    function wrap(protocols) {
      var exports2 = {
        maxRedirects: 21,
        maxBodyLength: 10 * 1024 * 1024
      };
      var nativeProtocols = {};
      Object.keys(protocols).forEach(function(scheme) {
        var protocol = scheme + ":";
        var nativeProtocol = nativeProtocols[protocol] = protocols[scheme];
        var wrappedProtocol = exports2[scheme] = Object.create(nativeProtocol);
        function request(input, options, callback) {
          if (isURL(input)) {
            input = spreadUrlObject(input);
          } else if (isString3(input)) {
            input = spreadUrlObject(parseUrl(input));
          } else {
            callback = options;
            options = validateUrl(input);
            input = { protocol };
          }
          if (isFunction(options)) {
            callback = options;
            options = null;
          }
          options = Object.assign({
            maxRedirects: exports2.maxRedirects,
            maxBodyLength: exports2.maxBodyLength
          }, input, options);
          options.nativeProtocols = nativeProtocols;
          if (!isString3(options.host) && !isString3(options.hostname)) {
            options.hostname = "::1";
          }
          assert.equal(options.protocol, protocol, "protocol mismatch");
          debug("options", options);
          return new RedirectableRequest(options, callback);
        }
        function get2(input, options, callback) {
          var wrappedRequest = wrappedProtocol.request(input, options, callback);
          wrappedRequest.end();
          return wrappedRequest;
        }
        Object.defineProperties(wrappedProtocol, {
          request: { value: request, configurable: true, enumerable: true, writable: true },
          get: { value: get2, configurable: true, enumerable: true, writable: true }
        });
      });
      return exports2;
    }
    function noop7() {
    }
    function parseUrl(input) {
      var parsed;
      if (useNativeURL) {
        parsed = new URL2(input);
      } else {
        parsed = validateUrl(url2.parse(input));
        if (!isString3(parsed.protocol)) {
          throw new InvalidUrlError({ input });
        }
      }
      return parsed;
    }
    function resolveUrl(relative, base) {
      return useNativeURL ? new URL2(relative, base) : parseUrl(url2.resolve(base, relative));
    }
    function validateUrl(input) {
      if (/^\[/.test(input.hostname) && !/^\[[:0-9a-f]+\]$/i.test(input.hostname)) {
        throw new InvalidUrlError({ input: input.href || input });
      }
      if (/^\[/.test(input.host) && !/^\[[:0-9a-f]+\](:\d+)?$/i.test(input.host)) {
        throw new InvalidUrlError({ input: input.href || input });
      }
      return input;
    }
    function spreadUrlObject(urlObject, target) {
      var spread = target || {};
      for (var key of preservedUrlFields) {
        spread[key] = urlObject[key];
      }
      if (spread.hostname.startsWith("[")) {
        spread.hostname = spread.hostname.slice(1, -1);
      }
      if (spread.port !== "") {
        spread.port = Number(spread.port);
      }
      spread.path = spread.search ? spread.pathname + spread.search : spread.pathname;
      return spread;
    }
    function removeMatchingHeaders(regex, headers) {
      var lastValue;
      for (var header in headers) {
        if (regex.test(header)) {
          lastValue = headers[header];
          delete headers[header];
        }
      }
      return lastValue === null || typeof lastValue === "undefined" ? void 0 : String(lastValue).trim();
    }
    function createErrorType(code, message2, baseClass) {
      function CustomError(properties) {
        Error.captureStackTrace(this, this.constructor);
        Object.assign(this, properties || {});
        this.code = code;
        this.message = this.cause ? message2 + ": " + this.cause.message : message2;
      }
      CustomError.prototype = new (baseClass || Error)();
      Object.defineProperties(CustomError.prototype, {
        constructor: {
          value: CustomError,
          enumerable: false
        },
        name: {
          value: "Error [" + code + "]",
          enumerable: false
        }
      });
      return CustomError;
    }
    function destroyRequest(request, error) {
      for (var event of events) {
        request.removeListener(event, eventHandlers[event]);
      }
      request.on("error", noop7);
      request.destroy(error);
    }
    function isSubdomain(subdomain, domain) {
      assert(isString3(subdomain) && isString3(domain));
      var dot = subdomain.length - domain.length - 1;
      return dot > 0 && subdomain[dot] === "." && subdomain.endsWith(domain);
    }
    function isString3(value) {
      return typeof value === "string" || value instanceof String;
    }
    function isFunction(value) {
      return typeof value === "function";
    }
    function isBuffer(value) {
      return typeof value === "object" && "length" in value;
    }
    function isURL(value) {
      return URL2 && value instanceof URL2;
    }
    module2.exports = wrap({ http, https });
    module2.exports.wrap = wrap;
  }
});

// ../../node_modules/axios/lib/env/data.js
var require_data = __commonJS({
  "../../node_modules/axios/lib/env/data.js"(exports, module2) {
    "use strict";
    module2.exports = {
      "version": "0.27.2"
    };
  }
});

// ../../node_modules/axios/lib/adapters/http.js
var require_http = __commonJS({
  "../../node_modules/axios/lib/adapters/http.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var settle = require_settle();
    var buildFullPath = require_buildFullPath();
    var buildURL = require_buildURL();
    var http = require("http");
    var https = require("https");
    var httpFollow = require_follow_redirects().http;
    var httpsFollow = require_follow_redirects().https;
    var url2 = require("url");
    var zlib = require("zlib");
    var VERSION = require_data().version;
    var transitionalDefaults = require_transitional();
    var AxiosError = require_AxiosError();
    var CanceledError = require_CanceledError();
    var isHttps = /https:?/;
    var supportedProtocols = ["http:", "https:", "file:"];
    function setProxy(options, proxy, location) {
      options.hostname = proxy.host;
      options.host = proxy.host;
      options.port = proxy.port;
      options.path = location;
      if (proxy.auth) {
        var base64 = Buffer.from(proxy.auth.username + ":" + proxy.auth.password, "utf8").toString("base64");
        options.headers["Proxy-Authorization"] = "Basic " + base64;
      }
      options.beforeRedirect = function beforeRedirect(redirection) {
        redirection.headers.host = redirection.host;
        setProxy(redirection, proxy, redirection.href);
      };
    }
    module2.exports = function httpAdapter(config) {
      return new Promise(function dispatchHttpRequest(resolvePromise, rejectPromise) {
        var onCanceled;
        function done() {
          if (config.cancelToken) {
            config.cancelToken.unsubscribe(onCanceled);
          }
          if (config.signal) {
            config.signal.removeEventListener("abort", onCanceled);
          }
        }
        var resolve = function resolve2(value) {
          done();
          resolvePromise(value);
        };
        var rejected = false;
        var reject = function reject2(value) {
          done();
          rejected = true;
          rejectPromise(value);
        };
        var data = config.data;
        var headers = config.headers;
        var headerNames = {};
        Object.keys(headers).forEach(function storeLowerName(name) {
          headerNames[name.toLowerCase()] = name;
        });
        if ("user-agent" in headerNames) {
          if (!headers[headerNames["user-agent"]]) {
            delete headers[headerNames["user-agent"]];
          }
        } else {
          headers["User-Agent"] = "axios/" + VERSION;
        }
        if (utils.isFormData(data) && utils.isFunction(data.getHeaders)) {
          Object.assign(headers, data.getHeaders());
        } else if (data && !utils.isStream(data)) {
          if (Buffer.isBuffer(data)) {
          } else if (utils.isArrayBuffer(data)) {
            data = Buffer.from(new Uint8Array(data));
          } else if (utils.isString(data)) {
            data = Buffer.from(data, "utf-8");
          } else {
            return reject(new AxiosError(
              "Data after transformation must be a string, an ArrayBuffer, a Buffer, or a Stream",
              AxiosError.ERR_BAD_REQUEST,
              config
            ));
          }
          if (config.maxBodyLength > -1 && data.length > config.maxBodyLength) {
            return reject(new AxiosError(
              "Request body larger than maxBodyLength limit",
              AxiosError.ERR_BAD_REQUEST,
              config
            ));
          }
          if (!headerNames["content-length"]) {
            headers["Content-Length"] = data.length;
          }
        }
        var auth = void 0;
        if (config.auth) {
          var username = config.auth.username || "";
          var password = config.auth.password || "";
          auth = username + ":" + password;
        }
        var fullPath = buildFullPath(config.baseURL, config.url);
        var parsed = url2.parse(fullPath);
        var protocol = parsed.protocol || supportedProtocols[0];
        if (supportedProtocols.indexOf(protocol) === -1) {
          return reject(new AxiosError(
            "Unsupported protocol " + protocol,
            AxiosError.ERR_BAD_REQUEST,
            config
          ));
        }
        if (!auth && parsed.auth) {
          var urlAuth = parsed.auth.split(":");
          var urlUsername = urlAuth[0] || "";
          var urlPassword = urlAuth[1] || "";
          auth = urlUsername + ":" + urlPassword;
        }
        if (auth && headerNames.authorization) {
          delete headers[headerNames.authorization];
        }
        var isHttpsRequest = isHttps.test(protocol);
        var agent = isHttpsRequest ? config.httpsAgent : config.httpAgent;
        try {
          buildURL(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, "");
        } catch (err) {
          var customErr = new Error(err.message);
          customErr.config = config;
          customErr.url = config.url;
          customErr.exists = true;
          reject(customErr);
        }
        var options = {
          path: buildURL(parsed.path, config.params, config.paramsSerializer).replace(/^\?/, ""),
          method: config.method.toUpperCase(),
          headers,
          agent,
          agents: { http: config.httpAgent, https: config.httpsAgent },
          auth
        };
        if (config.socketPath) {
          options.socketPath = config.socketPath;
        } else {
          options.hostname = parsed.hostname;
          options.port = parsed.port;
        }
        var proxy = config.proxy;
        if (!proxy && proxy !== false) {
          var proxyEnv = protocol.slice(0, -1) + "_proxy";
          var proxyUrl = process.env[proxyEnv] || process.env[proxyEnv.toUpperCase()];
          if (proxyUrl) {
            var parsedProxyUrl = url2.parse(proxyUrl);
            var noProxyEnv = process.env.no_proxy || process.env.NO_PROXY;
            var shouldProxy = true;
            if (noProxyEnv) {
              var noProxy = noProxyEnv.split(",").map(function trim3(s2) {
                return s2.trim();
              });
              shouldProxy = !noProxy.some(function proxyMatch(proxyElement) {
                if (!proxyElement) {
                  return false;
                }
                if (proxyElement === "*") {
                  return true;
                }
                if (proxyElement[0] === "." && parsed.hostname.substr(parsed.hostname.length - proxyElement.length) === proxyElement) {
                  return true;
                }
                return parsed.hostname === proxyElement;
              });
            }
            if (shouldProxy) {
              proxy = {
                host: parsedProxyUrl.hostname,
                port: parsedProxyUrl.port,
                protocol: parsedProxyUrl.protocol
              };
              if (parsedProxyUrl.auth) {
                var proxyUrlAuth = parsedProxyUrl.auth.split(":");
                proxy.auth = {
                  username: proxyUrlAuth[0],
                  password: proxyUrlAuth[1]
                };
              }
            }
          }
        }
        if (proxy) {
          options.headers.host = parsed.hostname + (parsed.port ? ":" + parsed.port : "");
          setProxy(options, proxy, protocol + "//" + parsed.hostname + (parsed.port ? ":" + parsed.port : "") + options.path);
        }
        var transport;
        var isHttpsProxy = isHttpsRequest && (proxy ? isHttps.test(proxy.protocol) : true);
        if (config.transport) {
          transport = config.transport;
        } else if (config.maxRedirects === 0) {
          transport = isHttpsProxy ? https : http;
        } else {
          if (config.maxRedirects) {
            options.maxRedirects = config.maxRedirects;
          }
          if (config.beforeRedirect) {
            options.beforeRedirect = config.beforeRedirect;
          }
          transport = isHttpsProxy ? httpsFollow : httpFollow;
        }
        if (config.maxBodyLength > -1) {
          options.maxBodyLength = config.maxBodyLength;
        }
        if (config.insecureHTTPParser) {
          options.insecureHTTPParser = config.insecureHTTPParser;
        }
        var req = transport.request(options, function handleResponse(res) {
          if (req.aborted)
            return;
          var stream = res;
          var lastRequest = res.req || req;
          if (res.statusCode !== 204 && lastRequest.method !== "HEAD" && config.decompress !== false) {
            switch (res.headers["content-encoding"]) {
              case "gzip":
              case "compress":
              case "deflate":
                stream = stream.pipe(zlib.createUnzip());
                delete res.headers["content-encoding"];
                break;
            }
          }
          var response = {
            status: res.statusCode,
            statusText: res.statusMessage,
            headers: res.headers,
            config,
            request: lastRequest
          };
          if (config.responseType === "stream") {
            response.data = stream;
            settle(resolve, reject, response);
          } else {
            var responseBuffer = [];
            var totalResponseBytes = 0;
            stream.on("data", function handleStreamData(chunk) {
              responseBuffer.push(chunk);
              totalResponseBytes += chunk.length;
              if (config.maxContentLength > -1 && totalResponseBytes > config.maxContentLength) {
                rejected = true;
                stream.destroy();
                reject(new AxiosError(
                  "maxContentLength size of " + config.maxContentLength + " exceeded",
                  AxiosError.ERR_BAD_RESPONSE,
                  config,
                  lastRequest
                ));
              }
            });
            stream.on("aborted", function handlerStreamAborted() {
              if (rejected) {
                return;
              }
              stream.destroy();
              reject(new AxiosError(
                "maxContentLength size of " + config.maxContentLength + " exceeded",
                AxiosError.ERR_BAD_RESPONSE,
                config,
                lastRequest
              ));
            });
            stream.on("error", function handleStreamError(err) {
              if (req.aborted)
                return;
              reject(AxiosError.from(err, null, config, lastRequest));
            });
            stream.on("end", function handleStreamEnd() {
              try {
                var responseData = responseBuffer.length === 1 ? responseBuffer[0] : Buffer.concat(responseBuffer);
                if (config.responseType !== "arraybuffer") {
                  responseData = responseData.toString(config.responseEncoding);
                  if (!config.responseEncoding || config.responseEncoding === "utf8") {
                    responseData = utils.stripBOM(responseData);
                  }
                }
                response.data = responseData;
              } catch (err) {
                reject(AxiosError.from(err, null, config, response.request, response));
              }
              settle(resolve, reject, response);
            });
          }
        });
        req.on("error", function handleRequestError(err) {
          reject(AxiosError.from(err, null, config, req));
        });
        req.on("socket", function handleRequestSocket(socket) {
          socket.setKeepAlive(true, 1e3 * 60);
        });
        if (config.timeout) {
          var timeout = parseInt(config.timeout, 10);
          if (isNaN(timeout)) {
            reject(new AxiosError(
              "error trying to parse `config.timeout` to int",
              AxiosError.ERR_BAD_OPTION_VALUE,
              config,
              req
            ));
            return;
          }
          req.setTimeout(timeout, function handleRequestTimeout() {
            req.abort();
            var transitional = config.transitional || transitionalDefaults;
            reject(new AxiosError(
              "timeout of " + timeout + "ms exceeded",
              transitional.clarifyTimeoutError ? AxiosError.ETIMEDOUT : AxiosError.ECONNABORTED,
              config,
              req
            ));
          });
        }
        if (config.cancelToken || config.signal) {
          onCanceled = function(cancel) {
            if (req.aborted)
              return;
            req.abort();
            reject(!cancel || cancel && cancel.type ? new CanceledError() : cancel);
          };
          config.cancelToken && config.cancelToken.subscribe(onCanceled);
          if (config.signal) {
            config.signal.aborted ? onCanceled() : config.signal.addEventListener("abort", onCanceled);
          }
        }
        if (utils.isStream(data)) {
          data.on("error", function handleStreamError(err) {
            reject(AxiosError.from(err, config, null, req));
          }).pipe(req);
        } else {
          req.end(data);
        }
      });
    };
  }
});

// ../../node_modules/delayed-stream/lib/delayed_stream.js
var require_delayed_stream = __commonJS({
  "../../node_modules/delayed-stream/lib/delayed_stream.js"(exports, module2) {
    "use strict";
    var Stream = require("stream").Stream;
    var util = require("util");
    module2.exports = DelayedStream;
    function DelayedStream() {
      this.source = null;
      this.dataSize = 0;
      this.maxDataSize = 1024 * 1024;
      this.pauseStream = true;
      this._maxDataSizeExceeded = false;
      this._released = false;
      this._bufferedEvents = [];
    }
    util.inherits(DelayedStream, Stream);
    DelayedStream.create = function(source, options) {
      var delayedStream = new this();
      options = options || {};
      for (var option in options) {
        delayedStream[option] = options[option];
      }
      delayedStream.source = source;
      var realEmit = source.emit;
      source.emit = function() {
        delayedStream._handleEmit(arguments);
        return realEmit.apply(source, arguments);
      };
      source.on("error", function() {
      });
      if (delayedStream.pauseStream) {
        source.pause();
      }
      return delayedStream;
    };
    Object.defineProperty(DelayedStream.prototype, "readable", {
      configurable: true,
      enumerable: true,
      get: function() {
        return this.source.readable;
      }
    });
    DelayedStream.prototype.setEncoding = function() {
      return this.source.setEncoding.apply(this.source, arguments);
    };
    DelayedStream.prototype.resume = function() {
      if (!this._released) {
        this.release();
      }
      this.source.resume();
    };
    DelayedStream.prototype.pause = function() {
      this.source.pause();
    };
    DelayedStream.prototype.release = function() {
      this._released = true;
      this._bufferedEvents.forEach(function(args) {
        this.emit.apply(this, args);
      }.bind(this));
      this._bufferedEvents = [];
    };
    DelayedStream.prototype.pipe = function() {
      var r = Stream.prototype.pipe.apply(this, arguments);
      this.resume();
      return r;
    };
    DelayedStream.prototype._handleEmit = function(args) {
      if (this._released) {
        this.emit.apply(this, args);
        return;
      }
      if (args[0] === "data") {
        this.dataSize += args[1].length;
        this._checkIfMaxDataSizeExceeded();
      }
      this._bufferedEvents.push(args);
    };
    DelayedStream.prototype._checkIfMaxDataSizeExceeded = function() {
      if (this._maxDataSizeExceeded) {
        return;
      }
      if (this.dataSize <= this.maxDataSize) {
        return;
      }
      this._maxDataSizeExceeded = true;
      var message2 = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";
      this.emit("error", new Error(message2));
    };
  }
});

// ../../node_modules/combined-stream/lib/combined_stream.js
var require_combined_stream = __commonJS({
  "../../node_modules/combined-stream/lib/combined_stream.js"(exports, module2) {
    "use strict";
    var util = require("util");
    var Stream = require("stream").Stream;
    var DelayedStream = require_delayed_stream();
    module2.exports = CombinedStream;
    function CombinedStream() {
      this.writable = false;
      this.readable = true;
      this.dataSize = 0;
      this.maxDataSize = 2 * 1024 * 1024;
      this.pauseStreams = true;
      this._released = false;
      this._streams = [];
      this._currentStream = null;
      this._insideLoop = false;
      this._pendingNext = false;
    }
    util.inherits(CombinedStream, Stream);
    CombinedStream.create = function(options) {
      var combinedStream = new this();
      options = options || {};
      for (var option in options) {
        combinedStream[option] = options[option];
      }
      return combinedStream;
    };
    CombinedStream.isStreamLike = function(stream) {
      return typeof stream !== "function" && typeof stream !== "string" && typeof stream !== "boolean" && typeof stream !== "number" && !Buffer.isBuffer(stream);
    };
    CombinedStream.prototype.append = function(stream) {
      var isStreamLike = CombinedStream.isStreamLike(stream);
      if (isStreamLike) {
        if (!(stream instanceof DelayedStream)) {
          var newStream = DelayedStream.create(stream, {
            maxDataSize: Infinity,
            pauseStream: this.pauseStreams
          });
          stream.on("data", this._checkDataSize.bind(this));
          stream = newStream;
        }
        this._handleErrors(stream);
        if (this.pauseStreams) {
          stream.pause();
        }
      }
      this._streams.push(stream);
      return this;
    };
    CombinedStream.prototype.pipe = function(dest, options) {
      Stream.prototype.pipe.call(this, dest, options);
      this.resume();
      return dest;
    };
    CombinedStream.prototype._getNext = function() {
      this._currentStream = null;
      if (this._insideLoop) {
        this._pendingNext = true;
        return;
      }
      this._insideLoop = true;
      try {
        do {
          this._pendingNext = false;
          this._realGetNext();
        } while (this._pendingNext);
      } finally {
        this._insideLoop = false;
      }
    };
    CombinedStream.prototype._realGetNext = function() {
      var stream = this._streams.shift();
      if (typeof stream == "undefined") {
        this.end();
        return;
      }
      if (typeof stream !== "function") {
        this._pipeNext(stream);
        return;
      }
      var getStream = stream;
      getStream(function(stream2) {
        var isStreamLike = CombinedStream.isStreamLike(stream2);
        if (isStreamLike) {
          stream2.on("data", this._checkDataSize.bind(this));
          this._handleErrors(stream2);
        }
        this._pipeNext(stream2);
      }.bind(this));
    };
    CombinedStream.prototype._pipeNext = function(stream) {
      this._currentStream = stream;
      var isStreamLike = CombinedStream.isStreamLike(stream);
      if (isStreamLike) {
        stream.on("end", this._getNext.bind(this));
        stream.pipe(this, { end: false });
        return;
      }
      var value = stream;
      this.write(value);
      this._getNext();
    };
    CombinedStream.prototype._handleErrors = function(stream) {
      var self2 = this;
      stream.on("error", function(err) {
        self2._emitError(err);
      });
    };
    CombinedStream.prototype.write = function(data) {
      this.emit("data", data);
    };
    CombinedStream.prototype.pause = function() {
      if (!this.pauseStreams) {
        return;
      }
      if (this.pauseStreams && this._currentStream && typeof this._currentStream.pause == "function")
        this._currentStream.pause();
      this.emit("pause");
    };
    CombinedStream.prototype.resume = function() {
      if (!this._released) {
        this._released = true;
        this.writable = true;
        this._getNext();
      }
      if (this.pauseStreams && this._currentStream && typeof this._currentStream.resume == "function")
        this._currentStream.resume();
      this.emit("resume");
    };
    CombinedStream.prototype.end = function() {
      this._reset();
      this.emit("end");
    };
    CombinedStream.prototype.destroy = function() {
      this._reset();
      this.emit("close");
    };
    CombinedStream.prototype._reset = function() {
      this.writable = false;
      this._streams = [];
      this._currentStream = null;
    };
    CombinedStream.prototype._checkDataSize = function() {
      this._updateDataSize();
      if (this.dataSize <= this.maxDataSize) {
        return;
      }
      var message2 = "DelayedStream#maxDataSize of " + this.maxDataSize + " bytes exceeded.";
      this._emitError(new Error(message2));
    };
    CombinedStream.prototype._updateDataSize = function() {
      this.dataSize = 0;
      var self2 = this;
      this._streams.forEach(function(stream) {
        if (!stream.dataSize) {
          return;
        }
        self2.dataSize += stream.dataSize;
      });
      if (this._currentStream && this._currentStream.dataSize) {
        this.dataSize += this._currentStream.dataSize;
      }
    };
    CombinedStream.prototype._emitError = function(err) {
      this._reset();
      this.emit("error", err);
    };
  }
});

// ../../node_modules/mime-db/db.json
var require_db = __commonJS({
  "../../node_modules/mime-db/db.json"(exports, module2) {
    module2.exports = {
      "application/1d-interleaved-parityfec": {
        source: "iana"
      },
      "application/3gpdash-qoe-report+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/3gpp-ims+xml": {
        source: "iana",
        compressible: true
      },
      "application/3gpphal+json": {
        source: "iana",
        compressible: true
      },
      "application/3gpphalforms+json": {
        source: "iana",
        compressible: true
      },
      "application/a2l": {
        source: "iana"
      },
      "application/ace+cbor": {
        source: "iana"
      },
      "application/activemessage": {
        source: "iana"
      },
      "application/activity+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-costmap+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-costmapfilter+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-directory+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-endpointcost+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-endpointcostparams+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-endpointprop+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-endpointpropparams+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-error+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-networkmap+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-networkmapfilter+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-updatestreamcontrol+json": {
        source: "iana",
        compressible: true
      },
      "application/alto-updatestreamparams+json": {
        source: "iana",
        compressible: true
      },
      "application/aml": {
        source: "iana"
      },
      "application/andrew-inset": {
        source: "iana",
        extensions: ["ez"]
      },
      "application/applefile": {
        source: "iana"
      },
      "application/applixware": {
        source: "apache",
        extensions: ["aw"]
      },
      "application/at+jwt": {
        source: "iana"
      },
      "application/atf": {
        source: "iana"
      },
      "application/atfx": {
        source: "iana"
      },
      "application/atom+xml": {
        source: "iana",
        compressible: true,
        extensions: ["atom"]
      },
      "application/atomcat+xml": {
        source: "iana",
        compressible: true,
        extensions: ["atomcat"]
      },
      "application/atomdeleted+xml": {
        source: "iana",
        compressible: true,
        extensions: ["atomdeleted"]
      },
      "application/atomicmail": {
        source: "iana"
      },
      "application/atomsvc+xml": {
        source: "iana",
        compressible: true,
        extensions: ["atomsvc"]
      },
      "application/atsc-dwd+xml": {
        source: "iana",
        compressible: true,
        extensions: ["dwd"]
      },
      "application/atsc-dynamic-event-message": {
        source: "iana"
      },
      "application/atsc-held+xml": {
        source: "iana",
        compressible: true,
        extensions: ["held"]
      },
      "application/atsc-rdt+json": {
        source: "iana",
        compressible: true
      },
      "application/atsc-rsat+xml": {
        source: "iana",
        compressible: true,
        extensions: ["rsat"]
      },
      "application/atxml": {
        source: "iana"
      },
      "application/auth-policy+xml": {
        source: "iana",
        compressible: true
      },
      "application/bacnet-xdd+zip": {
        source: "iana",
        compressible: false
      },
      "application/batch-smtp": {
        source: "iana"
      },
      "application/bdoc": {
        compressible: false,
        extensions: ["bdoc"]
      },
      "application/beep+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/calendar+json": {
        source: "iana",
        compressible: true
      },
      "application/calendar+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xcs"]
      },
      "application/call-completion": {
        source: "iana"
      },
      "application/cals-1840": {
        source: "iana"
      },
      "application/captive+json": {
        source: "iana",
        compressible: true
      },
      "application/cbor": {
        source: "iana"
      },
      "application/cbor-seq": {
        source: "iana"
      },
      "application/cccex": {
        source: "iana"
      },
      "application/ccmp+xml": {
        source: "iana",
        compressible: true
      },
      "application/ccxml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["ccxml"]
      },
      "application/cdfx+xml": {
        source: "iana",
        compressible: true,
        extensions: ["cdfx"]
      },
      "application/cdmi-capability": {
        source: "iana",
        extensions: ["cdmia"]
      },
      "application/cdmi-container": {
        source: "iana",
        extensions: ["cdmic"]
      },
      "application/cdmi-domain": {
        source: "iana",
        extensions: ["cdmid"]
      },
      "application/cdmi-object": {
        source: "iana",
        extensions: ["cdmio"]
      },
      "application/cdmi-queue": {
        source: "iana",
        extensions: ["cdmiq"]
      },
      "application/cdni": {
        source: "iana"
      },
      "application/cea": {
        source: "iana"
      },
      "application/cea-2018+xml": {
        source: "iana",
        compressible: true
      },
      "application/cellml+xml": {
        source: "iana",
        compressible: true
      },
      "application/cfw": {
        source: "iana"
      },
      "application/city+json": {
        source: "iana",
        compressible: true
      },
      "application/clr": {
        source: "iana"
      },
      "application/clue+xml": {
        source: "iana",
        compressible: true
      },
      "application/clue_info+xml": {
        source: "iana",
        compressible: true
      },
      "application/cms": {
        source: "iana"
      },
      "application/cnrp+xml": {
        source: "iana",
        compressible: true
      },
      "application/coap-group+json": {
        source: "iana",
        compressible: true
      },
      "application/coap-payload": {
        source: "iana"
      },
      "application/commonground": {
        source: "iana"
      },
      "application/conference-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/cose": {
        source: "iana"
      },
      "application/cose-key": {
        source: "iana"
      },
      "application/cose-key-set": {
        source: "iana"
      },
      "application/cpl+xml": {
        source: "iana",
        compressible: true,
        extensions: ["cpl"]
      },
      "application/csrattrs": {
        source: "iana"
      },
      "application/csta+xml": {
        source: "iana",
        compressible: true
      },
      "application/cstadata+xml": {
        source: "iana",
        compressible: true
      },
      "application/csvm+json": {
        source: "iana",
        compressible: true
      },
      "application/cu-seeme": {
        source: "apache",
        extensions: ["cu"]
      },
      "application/cwt": {
        source: "iana"
      },
      "application/cybercash": {
        source: "iana"
      },
      "application/dart": {
        compressible: true
      },
      "application/dash+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mpd"]
      },
      "application/dash-patch+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mpp"]
      },
      "application/dashdelta": {
        source: "iana"
      },
      "application/davmount+xml": {
        source: "iana",
        compressible: true,
        extensions: ["davmount"]
      },
      "application/dca-rft": {
        source: "iana"
      },
      "application/dcd": {
        source: "iana"
      },
      "application/dec-dx": {
        source: "iana"
      },
      "application/dialog-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/dicom": {
        source: "iana"
      },
      "application/dicom+json": {
        source: "iana",
        compressible: true
      },
      "application/dicom+xml": {
        source: "iana",
        compressible: true
      },
      "application/dii": {
        source: "iana"
      },
      "application/dit": {
        source: "iana"
      },
      "application/dns": {
        source: "iana"
      },
      "application/dns+json": {
        source: "iana",
        compressible: true
      },
      "application/dns-message": {
        source: "iana"
      },
      "application/docbook+xml": {
        source: "apache",
        compressible: true,
        extensions: ["dbk"]
      },
      "application/dots+cbor": {
        source: "iana"
      },
      "application/dskpp+xml": {
        source: "iana",
        compressible: true
      },
      "application/dssc+der": {
        source: "iana",
        extensions: ["dssc"]
      },
      "application/dssc+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xdssc"]
      },
      "application/dvcs": {
        source: "iana"
      },
      "application/ecmascript": {
        source: "iana",
        compressible: true,
        extensions: ["es", "ecma"]
      },
      "application/edi-consent": {
        source: "iana"
      },
      "application/edi-x12": {
        source: "iana",
        compressible: false
      },
      "application/edifact": {
        source: "iana",
        compressible: false
      },
      "application/efi": {
        source: "iana"
      },
      "application/elm+json": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/elm+xml": {
        source: "iana",
        compressible: true
      },
      "application/emergencycalldata.cap+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/emergencycalldata.comment+xml": {
        source: "iana",
        compressible: true
      },
      "application/emergencycalldata.control+xml": {
        source: "iana",
        compressible: true
      },
      "application/emergencycalldata.deviceinfo+xml": {
        source: "iana",
        compressible: true
      },
      "application/emergencycalldata.ecall.msd": {
        source: "iana"
      },
      "application/emergencycalldata.providerinfo+xml": {
        source: "iana",
        compressible: true
      },
      "application/emergencycalldata.serviceinfo+xml": {
        source: "iana",
        compressible: true
      },
      "application/emergencycalldata.subscriberinfo+xml": {
        source: "iana",
        compressible: true
      },
      "application/emergencycalldata.veds+xml": {
        source: "iana",
        compressible: true
      },
      "application/emma+xml": {
        source: "iana",
        compressible: true,
        extensions: ["emma"]
      },
      "application/emotionml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["emotionml"]
      },
      "application/encaprtp": {
        source: "iana"
      },
      "application/epp+xml": {
        source: "iana",
        compressible: true
      },
      "application/epub+zip": {
        source: "iana",
        compressible: false,
        extensions: ["epub"]
      },
      "application/eshop": {
        source: "iana"
      },
      "application/exi": {
        source: "iana",
        extensions: ["exi"]
      },
      "application/expect-ct-report+json": {
        source: "iana",
        compressible: true
      },
      "application/express": {
        source: "iana",
        extensions: ["exp"]
      },
      "application/fastinfoset": {
        source: "iana"
      },
      "application/fastsoap": {
        source: "iana"
      },
      "application/fdt+xml": {
        source: "iana",
        compressible: true,
        extensions: ["fdt"]
      },
      "application/fhir+json": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/fhir+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/fido.trusted-apps+json": {
        compressible: true
      },
      "application/fits": {
        source: "iana"
      },
      "application/flexfec": {
        source: "iana"
      },
      "application/font-sfnt": {
        source: "iana"
      },
      "application/font-tdpfr": {
        source: "iana",
        extensions: ["pfr"]
      },
      "application/font-woff": {
        source: "iana",
        compressible: false
      },
      "application/framework-attributes+xml": {
        source: "iana",
        compressible: true
      },
      "application/geo+json": {
        source: "iana",
        compressible: true,
        extensions: ["geojson"]
      },
      "application/geo+json-seq": {
        source: "iana"
      },
      "application/geopackage+sqlite3": {
        source: "iana"
      },
      "application/geoxacml+xml": {
        source: "iana",
        compressible: true
      },
      "application/gltf-buffer": {
        source: "iana"
      },
      "application/gml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["gml"]
      },
      "application/gpx+xml": {
        source: "apache",
        compressible: true,
        extensions: ["gpx"]
      },
      "application/gxf": {
        source: "apache",
        extensions: ["gxf"]
      },
      "application/gzip": {
        source: "iana",
        compressible: false,
        extensions: ["gz"]
      },
      "application/h224": {
        source: "iana"
      },
      "application/held+xml": {
        source: "iana",
        compressible: true
      },
      "application/hjson": {
        extensions: ["hjson"]
      },
      "application/http": {
        source: "iana"
      },
      "application/hyperstudio": {
        source: "iana",
        extensions: ["stk"]
      },
      "application/ibe-key-request+xml": {
        source: "iana",
        compressible: true
      },
      "application/ibe-pkg-reply+xml": {
        source: "iana",
        compressible: true
      },
      "application/ibe-pp-data": {
        source: "iana"
      },
      "application/iges": {
        source: "iana"
      },
      "application/im-iscomposing+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/index": {
        source: "iana"
      },
      "application/index.cmd": {
        source: "iana"
      },
      "application/index.obj": {
        source: "iana"
      },
      "application/index.response": {
        source: "iana"
      },
      "application/index.vnd": {
        source: "iana"
      },
      "application/inkml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["ink", "inkml"]
      },
      "application/iotp": {
        source: "iana"
      },
      "application/ipfix": {
        source: "iana",
        extensions: ["ipfix"]
      },
      "application/ipp": {
        source: "iana"
      },
      "application/isup": {
        source: "iana"
      },
      "application/its+xml": {
        source: "iana",
        compressible: true,
        extensions: ["its"]
      },
      "application/java-archive": {
        source: "apache",
        compressible: false,
        extensions: ["jar", "war", "ear"]
      },
      "application/java-serialized-object": {
        source: "apache",
        compressible: false,
        extensions: ["ser"]
      },
      "application/java-vm": {
        source: "apache",
        compressible: false,
        extensions: ["class"]
      },
      "application/javascript": {
        source: "iana",
        charset: "UTF-8",
        compressible: true,
        extensions: ["js", "mjs"]
      },
      "application/jf2feed+json": {
        source: "iana",
        compressible: true
      },
      "application/jose": {
        source: "iana"
      },
      "application/jose+json": {
        source: "iana",
        compressible: true
      },
      "application/jrd+json": {
        source: "iana",
        compressible: true
      },
      "application/jscalendar+json": {
        source: "iana",
        compressible: true
      },
      "application/json": {
        source: "iana",
        charset: "UTF-8",
        compressible: true,
        extensions: ["json", "map"]
      },
      "application/json-patch+json": {
        source: "iana",
        compressible: true
      },
      "application/json-seq": {
        source: "iana"
      },
      "application/json5": {
        extensions: ["json5"]
      },
      "application/jsonml+json": {
        source: "apache",
        compressible: true,
        extensions: ["jsonml"]
      },
      "application/jwk+json": {
        source: "iana",
        compressible: true
      },
      "application/jwk-set+json": {
        source: "iana",
        compressible: true
      },
      "application/jwt": {
        source: "iana"
      },
      "application/kpml-request+xml": {
        source: "iana",
        compressible: true
      },
      "application/kpml-response+xml": {
        source: "iana",
        compressible: true
      },
      "application/ld+json": {
        source: "iana",
        compressible: true,
        extensions: ["jsonld"]
      },
      "application/lgr+xml": {
        source: "iana",
        compressible: true,
        extensions: ["lgr"]
      },
      "application/link-format": {
        source: "iana"
      },
      "application/load-control+xml": {
        source: "iana",
        compressible: true
      },
      "application/lost+xml": {
        source: "iana",
        compressible: true,
        extensions: ["lostxml"]
      },
      "application/lostsync+xml": {
        source: "iana",
        compressible: true
      },
      "application/lpf+zip": {
        source: "iana",
        compressible: false
      },
      "application/lxf": {
        source: "iana"
      },
      "application/mac-binhex40": {
        source: "iana",
        extensions: ["hqx"]
      },
      "application/mac-compactpro": {
        source: "apache",
        extensions: ["cpt"]
      },
      "application/macwriteii": {
        source: "iana"
      },
      "application/mads+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mads"]
      },
      "application/manifest+json": {
        source: "iana",
        charset: "UTF-8",
        compressible: true,
        extensions: ["webmanifest"]
      },
      "application/marc": {
        source: "iana",
        extensions: ["mrc"]
      },
      "application/marcxml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mrcx"]
      },
      "application/mathematica": {
        source: "iana",
        extensions: ["ma", "nb", "mb"]
      },
      "application/mathml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mathml"]
      },
      "application/mathml-content+xml": {
        source: "iana",
        compressible: true
      },
      "application/mathml-presentation+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-associated-procedure-description+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-deregister+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-envelope+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-msk+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-msk-response+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-protection-description+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-reception-report+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-register+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-register-response+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-schedule+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbms-user-service-description+xml": {
        source: "iana",
        compressible: true
      },
      "application/mbox": {
        source: "iana",
        extensions: ["mbox"]
      },
      "application/media-policy-dataset+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mpf"]
      },
      "application/media_control+xml": {
        source: "iana",
        compressible: true
      },
      "application/mediaservercontrol+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mscml"]
      },
      "application/merge-patch+json": {
        source: "iana",
        compressible: true
      },
      "application/metalink+xml": {
        source: "apache",
        compressible: true,
        extensions: ["metalink"]
      },
      "application/metalink4+xml": {
        source: "iana",
        compressible: true,
        extensions: ["meta4"]
      },
      "application/mets+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mets"]
      },
      "application/mf4": {
        source: "iana"
      },
      "application/mikey": {
        source: "iana"
      },
      "application/mipc": {
        source: "iana"
      },
      "application/missing-blocks+cbor-seq": {
        source: "iana"
      },
      "application/mmt-aei+xml": {
        source: "iana",
        compressible: true,
        extensions: ["maei"]
      },
      "application/mmt-usd+xml": {
        source: "iana",
        compressible: true,
        extensions: ["musd"]
      },
      "application/mods+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mods"]
      },
      "application/moss-keys": {
        source: "iana"
      },
      "application/moss-signature": {
        source: "iana"
      },
      "application/mosskey-data": {
        source: "iana"
      },
      "application/mosskey-request": {
        source: "iana"
      },
      "application/mp21": {
        source: "iana",
        extensions: ["m21", "mp21"]
      },
      "application/mp4": {
        source: "iana",
        extensions: ["mp4s", "m4p"]
      },
      "application/mpeg4-generic": {
        source: "iana"
      },
      "application/mpeg4-iod": {
        source: "iana"
      },
      "application/mpeg4-iod-xmt": {
        source: "iana"
      },
      "application/mrb-consumer+xml": {
        source: "iana",
        compressible: true
      },
      "application/mrb-publish+xml": {
        source: "iana",
        compressible: true
      },
      "application/msc-ivr+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/msc-mixer+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/msword": {
        source: "iana",
        compressible: false,
        extensions: ["doc", "dot"]
      },
      "application/mud+json": {
        source: "iana",
        compressible: true
      },
      "application/multipart-core": {
        source: "iana"
      },
      "application/mxf": {
        source: "iana",
        extensions: ["mxf"]
      },
      "application/n-quads": {
        source: "iana",
        extensions: ["nq"]
      },
      "application/n-triples": {
        source: "iana",
        extensions: ["nt"]
      },
      "application/nasdata": {
        source: "iana"
      },
      "application/news-checkgroups": {
        source: "iana",
        charset: "US-ASCII"
      },
      "application/news-groupinfo": {
        source: "iana",
        charset: "US-ASCII"
      },
      "application/news-transmission": {
        source: "iana"
      },
      "application/nlsml+xml": {
        source: "iana",
        compressible: true
      },
      "application/node": {
        source: "iana",
        extensions: ["cjs"]
      },
      "application/nss": {
        source: "iana"
      },
      "application/oauth-authz-req+jwt": {
        source: "iana"
      },
      "application/oblivious-dns-message": {
        source: "iana"
      },
      "application/ocsp-request": {
        source: "iana"
      },
      "application/ocsp-response": {
        source: "iana"
      },
      "application/octet-stream": {
        source: "iana",
        compressible: false,
        extensions: ["bin", "dms", "lrf", "mar", "so", "dist", "distz", "pkg", "bpk", "dump", "elc", "deploy", "exe", "dll", "deb", "dmg", "iso", "img", "msi", "msp", "msm", "buffer"]
      },
      "application/oda": {
        source: "iana",
        extensions: ["oda"]
      },
      "application/odm+xml": {
        source: "iana",
        compressible: true
      },
      "application/odx": {
        source: "iana"
      },
      "application/oebps-package+xml": {
        source: "iana",
        compressible: true,
        extensions: ["opf"]
      },
      "application/ogg": {
        source: "iana",
        compressible: false,
        extensions: ["ogx"]
      },
      "application/omdoc+xml": {
        source: "apache",
        compressible: true,
        extensions: ["omdoc"]
      },
      "application/onenote": {
        source: "apache",
        extensions: ["onetoc", "onetoc2", "onetmp", "onepkg"]
      },
      "application/opc-nodeset+xml": {
        source: "iana",
        compressible: true
      },
      "application/oscore": {
        source: "iana"
      },
      "application/oxps": {
        source: "iana",
        extensions: ["oxps"]
      },
      "application/p21": {
        source: "iana"
      },
      "application/p21+zip": {
        source: "iana",
        compressible: false
      },
      "application/p2p-overlay+xml": {
        source: "iana",
        compressible: true,
        extensions: ["relo"]
      },
      "application/parityfec": {
        source: "iana"
      },
      "application/passport": {
        source: "iana"
      },
      "application/patch-ops-error+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xer"]
      },
      "application/pdf": {
        source: "iana",
        compressible: false,
        extensions: ["pdf"]
      },
      "application/pdx": {
        source: "iana"
      },
      "application/pem-certificate-chain": {
        source: "iana"
      },
      "application/pgp-encrypted": {
        source: "iana",
        compressible: false,
        extensions: ["pgp"]
      },
      "application/pgp-keys": {
        source: "iana",
        extensions: ["asc"]
      },
      "application/pgp-signature": {
        source: "iana",
        extensions: ["asc", "sig"]
      },
      "application/pics-rules": {
        source: "apache",
        extensions: ["prf"]
      },
      "application/pidf+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/pidf-diff+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/pkcs10": {
        source: "iana",
        extensions: ["p10"]
      },
      "application/pkcs12": {
        source: "iana"
      },
      "application/pkcs7-mime": {
        source: "iana",
        extensions: ["p7m", "p7c"]
      },
      "application/pkcs7-signature": {
        source: "iana",
        extensions: ["p7s"]
      },
      "application/pkcs8": {
        source: "iana",
        extensions: ["p8"]
      },
      "application/pkcs8-encrypted": {
        source: "iana"
      },
      "application/pkix-attr-cert": {
        source: "iana",
        extensions: ["ac"]
      },
      "application/pkix-cert": {
        source: "iana",
        extensions: ["cer"]
      },
      "application/pkix-crl": {
        source: "iana",
        extensions: ["crl"]
      },
      "application/pkix-pkipath": {
        source: "iana",
        extensions: ["pkipath"]
      },
      "application/pkixcmp": {
        source: "iana",
        extensions: ["pki"]
      },
      "application/pls+xml": {
        source: "iana",
        compressible: true,
        extensions: ["pls"]
      },
      "application/poc-settings+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/postscript": {
        source: "iana",
        compressible: true,
        extensions: ["ai", "eps", "ps"]
      },
      "application/ppsp-tracker+json": {
        source: "iana",
        compressible: true
      },
      "application/problem+json": {
        source: "iana",
        compressible: true
      },
      "application/problem+xml": {
        source: "iana",
        compressible: true
      },
      "application/provenance+xml": {
        source: "iana",
        compressible: true,
        extensions: ["provx"]
      },
      "application/prs.alvestrand.titrax-sheet": {
        source: "iana"
      },
      "application/prs.cww": {
        source: "iana",
        extensions: ["cww"]
      },
      "application/prs.cyn": {
        source: "iana",
        charset: "7-BIT"
      },
      "application/prs.hpub+zip": {
        source: "iana",
        compressible: false
      },
      "application/prs.nprend": {
        source: "iana"
      },
      "application/prs.plucker": {
        source: "iana"
      },
      "application/prs.rdf-xml-crypt": {
        source: "iana"
      },
      "application/prs.xsf+xml": {
        source: "iana",
        compressible: true
      },
      "application/pskc+xml": {
        source: "iana",
        compressible: true,
        extensions: ["pskcxml"]
      },
      "application/pvd+json": {
        source: "iana",
        compressible: true
      },
      "application/qsig": {
        source: "iana"
      },
      "application/raml+yaml": {
        compressible: true,
        extensions: ["raml"]
      },
      "application/raptorfec": {
        source: "iana"
      },
      "application/rdap+json": {
        source: "iana",
        compressible: true
      },
      "application/rdf+xml": {
        source: "iana",
        compressible: true,
        extensions: ["rdf", "owl"]
      },
      "application/reginfo+xml": {
        source: "iana",
        compressible: true,
        extensions: ["rif"]
      },
      "application/relax-ng-compact-syntax": {
        source: "iana",
        extensions: ["rnc"]
      },
      "application/remote-printing": {
        source: "iana"
      },
      "application/reputon+json": {
        source: "iana",
        compressible: true
      },
      "application/resource-lists+xml": {
        source: "iana",
        compressible: true,
        extensions: ["rl"]
      },
      "application/resource-lists-diff+xml": {
        source: "iana",
        compressible: true,
        extensions: ["rld"]
      },
      "application/rfc+xml": {
        source: "iana",
        compressible: true
      },
      "application/riscos": {
        source: "iana"
      },
      "application/rlmi+xml": {
        source: "iana",
        compressible: true
      },
      "application/rls-services+xml": {
        source: "iana",
        compressible: true,
        extensions: ["rs"]
      },
      "application/route-apd+xml": {
        source: "iana",
        compressible: true,
        extensions: ["rapd"]
      },
      "application/route-s-tsid+xml": {
        source: "iana",
        compressible: true,
        extensions: ["sls"]
      },
      "application/route-usd+xml": {
        source: "iana",
        compressible: true,
        extensions: ["rusd"]
      },
      "application/rpki-ghostbusters": {
        source: "iana",
        extensions: ["gbr"]
      },
      "application/rpki-manifest": {
        source: "iana",
        extensions: ["mft"]
      },
      "application/rpki-publication": {
        source: "iana"
      },
      "application/rpki-roa": {
        source: "iana",
        extensions: ["roa"]
      },
      "application/rpki-updown": {
        source: "iana"
      },
      "application/rsd+xml": {
        source: "apache",
        compressible: true,
        extensions: ["rsd"]
      },
      "application/rss+xml": {
        source: "apache",
        compressible: true,
        extensions: ["rss"]
      },
      "application/rtf": {
        source: "iana",
        compressible: true,
        extensions: ["rtf"]
      },
      "application/rtploopback": {
        source: "iana"
      },
      "application/rtx": {
        source: "iana"
      },
      "application/samlassertion+xml": {
        source: "iana",
        compressible: true
      },
      "application/samlmetadata+xml": {
        source: "iana",
        compressible: true
      },
      "application/sarif+json": {
        source: "iana",
        compressible: true
      },
      "application/sarif-external-properties+json": {
        source: "iana",
        compressible: true
      },
      "application/sbe": {
        source: "iana"
      },
      "application/sbml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["sbml"]
      },
      "application/scaip+xml": {
        source: "iana",
        compressible: true
      },
      "application/scim+json": {
        source: "iana",
        compressible: true
      },
      "application/scvp-cv-request": {
        source: "iana",
        extensions: ["scq"]
      },
      "application/scvp-cv-response": {
        source: "iana",
        extensions: ["scs"]
      },
      "application/scvp-vp-request": {
        source: "iana",
        extensions: ["spq"]
      },
      "application/scvp-vp-response": {
        source: "iana",
        extensions: ["spp"]
      },
      "application/sdp": {
        source: "iana",
        extensions: ["sdp"]
      },
      "application/secevent+jwt": {
        source: "iana"
      },
      "application/senml+cbor": {
        source: "iana"
      },
      "application/senml+json": {
        source: "iana",
        compressible: true
      },
      "application/senml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["senmlx"]
      },
      "application/senml-etch+cbor": {
        source: "iana"
      },
      "application/senml-etch+json": {
        source: "iana",
        compressible: true
      },
      "application/senml-exi": {
        source: "iana"
      },
      "application/sensml+cbor": {
        source: "iana"
      },
      "application/sensml+json": {
        source: "iana",
        compressible: true
      },
      "application/sensml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["sensmlx"]
      },
      "application/sensml-exi": {
        source: "iana"
      },
      "application/sep+xml": {
        source: "iana",
        compressible: true
      },
      "application/sep-exi": {
        source: "iana"
      },
      "application/session-info": {
        source: "iana"
      },
      "application/set-payment": {
        source: "iana"
      },
      "application/set-payment-initiation": {
        source: "iana",
        extensions: ["setpay"]
      },
      "application/set-registration": {
        source: "iana"
      },
      "application/set-registration-initiation": {
        source: "iana",
        extensions: ["setreg"]
      },
      "application/sgml": {
        source: "iana"
      },
      "application/sgml-open-catalog": {
        source: "iana"
      },
      "application/shf+xml": {
        source: "iana",
        compressible: true,
        extensions: ["shf"]
      },
      "application/sieve": {
        source: "iana",
        extensions: ["siv", "sieve"]
      },
      "application/simple-filter+xml": {
        source: "iana",
        compressible: true
      },
      "application/simple-message-summary": {
        source: "iana"
      },
      "application/simplesymbolcontainer": {
        source: "iana"
      },
      "application/sipc": {
        source: "iana"
      },
      "application/slate": {
        source: "iana"
      },
      "application/smil": {
        source: "iana"
      },
      "application/smil+xml": {
        source: "iana",
        compressible: true,
        extensions: ["smi", "smil"]
      },
      "application/smpte336m": {
        source: "iana"
      },
      "application/soap+fastinfoset": {
        source: "iana"
      },
      "application/soap+xml": {
        source: "iana",
        compressible: true
      },
      "application/sparql-query": {
        source: "iana",
        extensions: ["rq"]
      },
      "application/sparql-results+xml": {
        source: "iana",
        compressible: true,
        extensions: ["srx"]
      },
      "application/spdx+json": {
        source: "iana",
        compressible: true
      },
      "application/spirits-event+xml": {
        source: "iana",
        compressible: true
      },
      "application/sql": {
        source: "iana"
      },
      "application/srgs": {
        source: "iana",
        extensions: ["gram"]
      },
      "application/srgs+xml": {
        source: "iana",
        compressible: true,
        extensions: ["grxml"]
      },
      "application/sru+xml": {
        source: "iana",
        compressible: true,
        extensions: ["sru"]
      },
      "application/ssdl+xml": {
        source: "apache",
        compressible: true,
        extensions: ["ssdl"]
      },
      "application/ssml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["ssml"]
      },
      "application/stix+json": {
        source: "iana",
        compressible: true
      },
      "application/swid+xml": {
        source: "iana",
        compressible: true,
        extensions: ["swidtag"]
      },
      "application/tamp-apex-update": {
        source: "iana"
      },
      "application/tamp-apex-update-confirm": {
        source: "iana"
      },
      "application/tamp-community-update": {
        source: "iana"
      },
      "application/tamp-community-update-confirm": {
        source: "iana"
      },
      "application/tamp-error": {
        source: "iana"
      },
      "application/tamp-sequence-adjust": {
        source: "iana"
      },
      "application/tamp-sequence-adjust-confirm": {
        source: "iana"
      },
      "application/tamp-status-query": {
        source: "iana"
      },
      "application/tamp-status-response": {
        source: "iana"
      },
      "application/tamp-update": {
        source: "iana"
      },
      "application/tamp-update-confirm": {
        source: "iana"
      },
      "application/tar": {
        compressible: true
      },
      "application/taxii+json": {
        source: "iana",
        compressible: true
      },
      "application/td+json": {
        source: "iana",
        compressible: true
      },
      "application/tei+xml": {
        source: "iana",
        compressible: true,
        extensions: ["tei", "teicorpus"]
      },
      "application/tetra_isi": {
        source: "iana"
      },
      "application/thraud+xml": {
        source: "iana",
        compressible: true,
        extensions: ["tfi"]
      },
      "application/timestamp-query": {
        source: "iana"
      },
      "application/timestamp-reply": {
        source: "iana"
      },
      "application/timestamped-data": {
        source: "iana",
        extensions: ["tsd"]
      },
      "application/tlsrpt+gzip": {
        source: "iana"
      },
      "application/tlsrpt+json": {
        source: "iana",
        compressible: true
      },
      "application/tnauthlist": {
        source: "iana"
      },
      "application/token-introspection+jwt": {
        source: "iana"
      },
      "application/toml": {
        compressible: true,
        extensions: ["toml"]
      },
      "application/trickle-ice-sdpfrag": {
        source: "iana"
      },
      "application/trig": {
        source: "iana",
        extensions: ["trig"]
      },
      "application/ttml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["ttml"]
      },
      "application/tve-trigger": {
        source: "iana"
      },
      "application/tzif": {
        source: "iana"
      },
      "application/tzif-leap": {
        source: "iana"
      },
      "application/ubjson": {
        compressible: false,
        extensions: ["ubj"]
      },
      "application/ulpfec": {
        source: "iana"
      },
      "application/urc-grpsheet+xml": {
        source: "iana",
        compressible: true
      },
      "application/urc-ressheet+xml": {
        source: "iana",
        compressible: true,
        extensions: ["rsheet"]
      },
      "application/urc-targetdesc+xml": {
        source: "iana",
        compressible: true,
        extensions: ["td"]
      },
      "application/urc-uisocketdesc+xml": {
        source: "iana",
        compressible: true
      },
      "application/vcard+json": {
        source: "iana",
        compressible: true
      },
      "application/vcard+xml": {
        source: "iana",
        compressible: true
      },
      "application/vemmi": {
        source: "iana"
      },
      "application/vividence.scriptfile": {
        source: "apache"
      },
      "application/vnd.1000minds.decision-model+xml": {
        source: "iana",
        compressible: true,
        extensions: ["1km"]
      },
      "application/vnd.3gpp-prose+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp-prose-pc3ch+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp-v2x-local-service-information": {
        source: "iana"
      },
      "application/vnd.3gpp.5gnas": {
        source: "iana"
      },
      "application/vnd.3gpp.access-transfer-events+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.bsf+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.gmop+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.gtpc": {
        source: "iana"
      },
      "application/vnd.3gpp.interworking-data": {
        source: "iana"
      },
      "application/vnd.3gpp.lpp": {
        source: "iana"
      },
      "application/vnd.3gpp.mc-signalling-ear": {
        source: "iana"
      },
      "application/vnd.3gpp.mcdata-affiliation-command+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcdata-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcdata-payload": {
        source: "iana"
      },
      "application/vnd.3gpp.mcdata-service-config+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcdata-signalling": {
        source: "iana"
      },
      "application/vnd.3gpp.mcdata-ue-config+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcdata-user-profile+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-affiliation-command+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-floor-request+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-location-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-mbms-usage-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-service-config+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-signed+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-ue-config+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-ue-init-config+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcptt-user-profile+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcvideo-affiliation-command+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcvideo-affiliation-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcvideo-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcvideo-location-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcvideo-mbms-usage-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcvideo-service-config+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcvideo-transmission-request+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcvideo-ue-config+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mcvideo-user-profile+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.mid-call+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.ngap": {
        source: "iana"
      },
      "application/vnd.3gpp.pfcp": {
        source: "iana"
      },
      "application/vnd.3gpp.pic-bw-large": {
        source: "iana",
        extensions: ["plb"]
      },
      "application/vnd.3gpp.pic-bw-small": {
        source: "iana",
        extensions: ["psb"]
      },
      "application/vnd.3gpp.pic-bw-var": {
        source: "iana",
        extensions: ["pvb"]
      },
      "application/vnd.3gpp.s1ap": {
        source: "iana"
      },
      "application/vnd.3gpp.sms": {
        source: "iana"
      },
      "application/vnd.3gpp.sms+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.srvcc-ext+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.srvcc-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.state-and-event-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp.ussd+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp2.bcmcsinfo+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.3gpp2.sms": {
        source: "iana"
      },
      "application/vnd.3gpp2.tcap": {
        source: "iana",
        extensions: ["tcap"]
      },
      "application/vnd.3lightssoftware.imagescal": {
        source: "iana"
      },
      "application/vnd.3m.post-it-notes": {
        source: "iana",
        extensions: ["pwn"]
      },
      "application/vnd.accpac.simply.aso": {
        source: "iana",
        extensions: ["aso"]
      },
      "application/vnd.accpac.simply.imp": {
        source: "iana",
        extensions: ["imp"]
      },
      "application/vnd.acucobol": {
        source: "iana",
        extensions: ["acu"]
      },
      "application/vnd.acucorp": {
        source: "iana",
        extensions: ["atc", "acutc"]
      },
      "application/vnd.adobe.air-application-installer-package+zip": {
        source: "apache",
        compressible: false,
        extensions: ["air"]
      },
      "application/vnd.adobe.flash.movie": {
        source: "iana"
      },
      "application/vnd.adobe.formscentral.fcdt": {
        source: "iana",
        extensions: ["fcdt"]
      },
      "application/vnd.adobe.fxp": {
        source: "iana",
        extensions: ["fxp", "fxpl"]
      },
      "application/vnd.adobe.partial-upload": {
        source: "iana"
      },
      "application/vnd.adobe.xdp+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xdp"]
      },
      "application/vnd.adobe.xfdf": {
        source: "iana",
        extensions: ["xfdf"]
      },
      "application/vnd.aether.imp": {
        source: "iana"
      },
      "application/vnd.afpc.afplinedata": {
        source: "iana"
      },
      "application/vnd.afpc.afplinedata-pagedef": {
        source: "iana"
      },
      "application/vnd.afpc.cmoca-cmresource": {
        source: "iana"
      },
      "application/vnd.afpc.foca-charset": {
        source: "iana"
      },
      "application/vnd.afpc.foca-codedfont": {
        source: "iana"
      },
      "application/vnd.afpc.foca-codepage": {
        source: "iana"
      },
      "application/vnd.afpc.modca": {
        source: "iana"
      },
      "application/vnd.afpc.modca-cmtable": {
        source: "iana"
      },
      "application/vnd.afpc.modca-formdef": {
        source: "iana"
      },
      "application/vnd.afpc.modca-mediummap": {
        source: "iana"
      },
      "application/vnd.afpc.modca-objectcontainer": {
        source: "iana"
      },
      "application/vnd.afpc.modca-overlay": {
        source: "iana"
      },
      "application/vnd.afpc.modca-pagesegment": {
        source: "iana"
      },
      "application/vnd.age": {
        source: "iana",
        extensions: ["age"]
      },
      "application/vnd.ah-barcode": {
        source: "iana"
      },
      "application/vnd.ahead.space": {
        source: "iana",
        extensions: ["ahead"]
      },
      "application/vnd.airzip.filesecure.azf": {
        source: "iana",
        extensions: ["azf"]
      },
      "application/vnd.airzip.filesecure.azs": {
        source: "iana",
        extensions: ["azs"]
      },
      "application/vnd.amadeus+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.amazon.ebook": {
        source: "apache",
        extensions: ["azw"]
      },
      "application/vnd.amazon.mobi8-ebook": {
        source: "iana"
      },
      "application/vnd.americandynamics.acc": {
        source: "iana",
        extensions: ["acc"]
      },
      "application/vnd.amiga.ami": {
        source: "iana",
        extensions: ["ami"]
      },
      "application/vnd.amundsen.maze+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.android.ota": {
        source: "iana"
      },
      "application/vnd.android.package-archive": {
        source: "apache",
        compressible: false,
        extensions: ["apk"]
      },
      "application/vnd.anki": {
        source: "iana"
      },
      "application/vnd.anser-web-certificate-issue-initiation": {
        source: "iana",
        extensions: ["cii"]
      },
      "application/vnd.anser-web-funds-transfer-initiation": {
        source: "apache",
        extensions: ["fti"]
      },
      "application/vnd.antix.game-component": {
        source: "iana",
        extensions: ["atx"]
      },
      "application/vnd.apache.arrow.file": {
        source: "iana"
      },
      "application/vnd.apache.arrow.stream": {
        source: "iana"
      },
      "application/vnd.apache.thrift.binary": {
        source: "iana"
      },
      "application/vnd.apache.thrift.compact": {
        source: "iana"
      },
      "application/vnd.apache.thrift.json": {
        source: "iana"
      },
      "application/vnd.api+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.aplextor.warrp+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.apothekende.reservation+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.apple.installer+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mpkg"]
      },
      "application/vnd.apple.keynote": {
        source: "iana",
        extensions: ["key"]
      },
      "application/vnd.apple.mpegurl": {
        source: "iana",
        extensions: ["m3u8"]
      },
      "application/vnd.apple.numbers": {
        source: "iana",
        extensions: ["numbers"]
      },
      "application/vnd.apple.pages": {
        source: "iana",
        extensions: ["pages"]
      },
      "application/vnd.apple.pkpass": {
        compressible: false,
        extensions: ["pkpass"]
      },
      "application/vnd.arastra.swi": {
        source: "iana"
      },
      "application/vnd.aristanetworks.swi": {
        source: "iana",
        extensions: ["swi"]
      },
      "application/vnd.artisan+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.artsquare": {
        source: "iana"
      },
      "application/vnd.astraea-software.iota": {
        source: "iana",
        extensions: ["iota"]
      },
      "application/vnd.audiograph": {
        source: "iana",
        extensions: ["aep"]
      },
      "application/vnd.autopackage": {
        source: "iana"
      },
      "application/vnd.avalon+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.avistar+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.balsamiq.bmml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["bmml"]
      },
      "application/vnd.balsamiq.bmpr": {
        source: "iana"
      },
      "application/vnd.banana-accounting": {
        source: "iana"
      },
      "application/vnd.bbf.usp.error": {
        source: "iana"
      },
      "application/vnd.bbf.usp.msg": {
        source: "iana"
      },
      "application/vnd.bbf.usp.msg+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.bekitzur-stech+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.bint.med-content": {
        source: "iana"
      },
      "application/vnd.biopax.rdf+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.blink-idb-value-wrapper": {
        source: "iana"
      },
      "application/vnd.blueice.multipass": {
        source: "iana",
        extensions: ["mpm"]
      },
      "application/vnd.bluetooth.ep.oob": {
        source: "iana"
      },
      "application/vnd.bluetooth.le.oob": {
        source: "iana"
      },
      "application/vnd.bmi": {
        source: "iana",
        extensions: ["bmi"]
      },
      "application/vnd.bpf": {
        source: "iana"
      },
      "application/vnd.bpf3": {
        source: "iana"
      },
      "application/vnd.businessobjects": {
        source: "iana",
        extensions: ["rep"]
      },
      "application/vnd.byu.uapi+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.cab-jscript": {
        source: "iana"
      },
      "application/vnd.canon-cpdl": {
        source: "iana"
      },
      "application/vnd.canon-lips": {
        source: "iana"
      },
      "application/vnd.capasystems-pg+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.cendio.thinlinc.clientconf": {
        source: "iana"
      },
      "application/vnd.century-systems.tcp_stream": {
        source: "iana"
      },
      "application/vnd.chemdraw+xml": {
        source: "iana",
        compressible: true,
        extensions: ["cdxml"]
      },
      "application/vnd.chess-pgn": {
        source: "iana"
      },
      "application/vnd.chipnuts.karaoke-mmd": {
        source: "iana",
        extensions: ["mmd"]
      },
      "application/vnd.ciedi": {
        source: "iana"
      },
      "application/vnd.cinderella": {
        source: "iana",
        extensions: ["cdy"]
      },
      "application/vnd.cirpack.isdn-ext": {
        source: "iana"
      },
      "application/vnd.citationstyles.style+xml": {
        source: "iana",
        compressible: true,
        extensions: ["csl"]
      },
      "application/vnd.claymore": {
        source: "iana",
        extensions: ["cla"]
      },
      "application/vnd.cloanto.rp9": {
        source: "iana",
        extensions: ["rp9"]
      },
      "application/vnd.clonk.c4group": {
        source: "iana",
        extensions: ["c4g", "c4d", "c4f", "c4p", "c4u"]
      },
      "application/vnd.cluetrust.cartomobile-config": {
        source: "iana",
        extensions: ["c11amc"]
      },
      "application/vnd.cluetrust.cartomobile-config-pkg": {
        source: "iana",
        extensions: ["c11amz"]
      },
      "application/vnd.coffeescript": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.document": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.document-template": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.presentation": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.presentation-template": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.spreadsheet": {
        source: "iana"
      },
      "application/vnd.collabio.xodocuments.spreadsheet-template": {
        source: "iana"
      },
      "application/vnd.collection+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.collection.doc+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.collection.next+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.comicbook+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.comicbook-rar": {
        source: "iana"
      },
      "application/vnd.commerce-battelle": {
        source: "iana"
      },
      "application/vnd.commonspace": {
        source: "iana",
        extensions: ["csp"]
      },
      "application/vnd.contact.cmsg": {
        source: "iana",
        extensions: ["cdbcmsg"]
      },
      "application/vnd.coreos.ignition+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.cosmocaller": {
        source: "iana",
        extensions: ["cmc"]
      },
      "application/vnd.crick.clicker": {
        source: "iana",
        extensions: ["clkx"]
      },
      "application/vnd.crick.clicker.keyboard": {
        source: "iana",
        extensions: ["clkk"]
      },
      "application/vnd.crick.clicker.palette": {
        source: "iana",
        extensions: ["clkp"]
      },
      "application/vnd.crick.clicker.template": {
        source: "iana",
        extensions: ["clkt"]
      },
      "application/vnd.crick.clicker.wordbank": {
        source: "iana",
        extensions: ["clkw"]
      },
      "application/vnd.criticaltools.wbs+xml": {
        source: "iana",
        compressible: true,
        extensions: ["wbs"]
      },
      "application/vnd.cryptii.pipe+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.crypto-shade-file": {
        source: "iana"
      },
      "application/vnd.cryptomator.encrypted": {
        source: "iana"
      },
      "application/vnd.cryptomator.vault": {
        source: "iana"
      },
      "application/vnd.ctc-posml": {
        source: "iana",
        extensions: ["pml"]
      },
      "application/vnd.ctct.ws+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.cups-pdf": {
        source: "iana"
      },
      "application/vnd.cups-postscript": {
        source: "iana"
      },
      "application/vnd.cups-ppd": {
        source: "iana",
        extensions: ["ppd"]
      },
      "application/vnd.cups-raster": {
        source: "iana"
      },
      "application/vnd.cups-raw": {
        source: "iana"
      },
      "application/vnd.curl": {
        source: "iana"
      },
      "application/vnd.curl.car": {
        source: "apache",
        extensions: ["car"]
      },
      "application/vnd.curl.pcurl": {
        source: "apache",
        extensions: ["pcurl"]
      },
      "application/vnd.cyan.dean.root+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.cybank": {
        source: "iana"
      },
      "application/vnd.cyclonedx+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.cyclonedx+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.d2l.coursepackage1p0+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.d3m-dataset": {
        source: "iana"
      },
      "application/vnd.d3m-problem": {
        source: "iana"
      },
      "application/vnd.dart": {
        source: "iana",
        compressible: true,
        extensions: ["dart"]
      },
      "application/vnd.data-vision.rdz": {
        source: "iana",
        extensions: ["rdz"]
      },
      "application/vnd.datapackage+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dataresource+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dbf": {
        source: "iana",
        extensions: ["dbf"]
      },
      "application/vnd.debian.binary-package": {
        source: "iana"
      },
      "application/vnd.dece.data": {
        source: "iana",
        extensions: ["uvf", "uvvf", "uvd", "uvvd"]
      },
      "application/vnd.dece.ttml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["uvt", "uvvt"]
      },
      "application/vnd.dece.unspecified": {
        source: "iana",
        extensions: ["uvx", "uvvx"]
      },
      "application/vnd.dece.zip": {
        source: "iana",
        extensions: ["uvz", "uvvz"]
      },
      "application/vnd.denovo.fcselayout-link": {
        source: "iana",
        extensions: ["fe_launch"]
      },
      "application/vnd.desmume.movie": {
        source: "iana"
      },
      "application/vnd.dir-bi.plate-dl-nosuffix": {
        source: "iana"
      },
      "application/vnd.dm.delegation+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dna": {
        source: "iana",
        extensions: ["dna"]
      },
      "application/vnd.document+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dolby.mlp": {
        source: "apache",
        extensions: ["mlp"]
      },
      "application/vnd.dolby.mobile.1": {
        source: "iana"
      },
      "application/vnd.dolby.mobile.2": {
        source: "iana"
      },
      "application/vnd.doremir.scorecloud-binary-document": {
        source: "iana"
      },
      "application/vnd.dpgraph": {
        source: "iana",
        extensions: ["dpg"]
      },
      "application/vnd.dreamfactory": {
        source: "iana",
        extensions: ["dfac"]
      },
      "application/vnd.drive+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ds-keypoint": {
        source: "apache",
        extensions: ["kpxx"]
      },
      "application/vnd.dtg.local": {
        source: "iana"
      },
      "application/vnd.dtg.local.flash": {
        source: "iana"
      },
      "application/vnd.dtg.local.html": {
        source: "iana"
      },
      "application/vnd.dvb.ait": {
        source: "iana",
        extensions: ["ait"]
      },
      "application/vnd.dvb.dvbisl+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dvb.dvbj": {
        source: "iana"
      },
      "application/vnd.dvb.esgcontainer": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcdftnotifaccess": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcesgaccess": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcesgaccess2": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcesgpdd": {
        source: "iana"
      },
      "application/vnd.dvb.ipdcroaming": {
        source: "iana"
      },
      "application/vnd.dvb.iptv.alfec-base": {
        source: "iana"
      },
      "application/vnd.dvb.iptv.alfec-enhancement": {
        source: "iana"
      },
      "application/vnd.dvb.notif-aggregate-root+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dvb.notif-container+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dvb.notif-generic+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dvb.notif-ia-msglist+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dvb.notif-ia-registration-request+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dvb.notif-ia-registration-response+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dvb.notif-init+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.dvb.pfr": {
        source: "iana"
      },
      "application/vnd.dvb.service": {
        source: "iana",
        extensions: ["svc"]
      },
      "application/vnd.dxr": {
        source: "iana"
      },
      "application/vnd.dynageo": {
        source: "iana",
        extensions: ["geo"]
      },
      "application/vnd.dzr": {
        source: "iana"
      },
      "application/vnd.easykaraoke.cdgdownload": {
        source: "iana"
      },
      "application/vnd.ecdis-update": {
        source: "iana"
      },
      "application/vnd.ecip.rlp": {
        source: "iana"
      },
      "application/vnd.eclipse.ditto+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ecowin.chart": {
        source: "iana",
        extensions: ["mag"]
      },
      "application/vnd.ecowin.filerequest": {
        source: "iana"
      },
      "application/vnd.ecowin.fileupdate": {
        source: "iana"
      },
      "application/vnd.ecowin.series": {
        source: "iana"
      },
      "application/vnd.ecowin.seriesrequest": {
        source: "iana"
      },
      "application/vnd.ecowin.seriesupdate": {
        source: "iana"
      },
      "application/vnd.efi.img": {
        source: "iana"
      },
      "application/vnd.efi.iso": {
        source: "iana"
      },
      "application/vnd.emclient.accessrequest+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.enliven": {
        source: "iana",
        extensions: ["nml"]
      },
      "application/vnd.enphase.envoy": {
        source: "iana"
      },
      "application/vnd.eprints.data+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.epson.esf": {
        source: "iana",
        extensions: ["esf"]
      },
      "application/vnd.epson.msf": {
        source: "iana",
        extensions: ["msf"]
      },
      "application/vnd.epson.quickanime": {
        source: "iana",
        extensions: ["qam"]
      },
      "application/vnd.epson.salt": {
        source: "iana",
        extensions: ["slt"]
      },
      "application/vnd.epson.ssf": {
        source: "iana",
        extensions: ["ssf"]
      },
      "application/vnd.ericsson.quickcall": {
        source: "iana"
      },
      "application/vnd.espass-espass+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.eszigno3+xml": {
        source: "iana",
        compressible: true,
        extensions: ["es3", "et3"]
      },
      "application/vnd.etsi.aoc+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.asic-e+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.etsi.asic-s+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.etsi.cug+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.iptvcommand+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.iptvdiscovery+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.iptvprofile+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.iptvsad-bc+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.iptvsad-cod+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.iptvsad-npvr+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.iptvservice+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.iptvsync+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.iptvueprofile+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.mcid+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.mheg5": {
        source: "iana"
      },
      "application/vnd.etsi.overload-control-policy-dataset+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.pstn+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.sci+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.simservs+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.timestamp-token": {
        source: "iana"
      },
      "application/vnd.etsi.tsl+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.etsi.tsl.der": {
        source: "iana"
      },
      "application/vnd.eu.kasparian.car+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.eudora.data": {
        source: "iana"
      },
      "application/vnd.evolv.ecig.profile": {
        source: "iana"
      },
      "application/vnd.evolv.ecig.settings": {
        source: "iana"
      },
      "application/vnd.evolv.ecig.theme": {
        source: "iana"
      },
      "application/vnd.exstream-empower+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.exstream-package": {
        source: "iana"
      },
      "application/vnd.ezpix-album": {
        source: "iana",
        extensions: ["ez2"]
      },
      "application/vnd.ezpix-package": {
        source: "iana",
        extensions: ["ez3"]
      },
      "application/vnd.f-secure.mobile": {
        source: "iana"
      },
      "application/vnd.familysearch.gedcom+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.fastcopy-disk-image": {
        source: "iana"
      },
      "application/vnd.fdf": {
        source: "iana",
        extensions: ["fdf"]
      },
      "application/vnd.fdsn.mseed": {
        source: "iana",
        extensions: ["mseed"]
      },
      "application/vnd.fdsn.seed": {
        source: "iana",
        extensions: ["seed", "dataless"]
      },
      "application/vnd.ffsns": {
        source: "iana"
      },
      "application/vnd.ficlab.flb+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.filmit.zfc": {
        source: "iana"
      },
      "application/vnd.fints": {
        source: "iana"
      },
      "application/vnd.firemonkeys.cloudcell": {
        source: "iana"
      },
      "application/vnd.flographit": {
        source: "iana",
        extensions: ["gph"]
      },
      "application/vnd.fluxtime.clip": {
        source: "iana",
        extensions: ["ftc"]
      },
      "application/vnd.font-fontforge-sfd": {
        source: "iana"
      },
      "application/vnd.framemaker": {
        source: "iana",
        extensions: ["fm", "frame", "maker", "book"]
      },
      "application/vnd.frogans.fnc": {
        source: "iana",
        extensions: ["fnc"]
      },
      "application/vnd.frogans.ltf": {
        source: "iana",
        extensions: ["ltf"]
      },
      "application/vnd.fsc.weblaunch": {
        source: "iana",
        extensions: ["fsc"]
      },
      "application/vnd.fujifilm.fb.docuworks": {
        source: "iana"
      },
      "application/vnd.fujifilm.fb.docuworks.binder": {
        source: "iana"
      },
      "application/vnd.fujifilm.fb.docuworks.container": {
        source: "iana"
      },
      "application/vnd.fujifilm.fb.jfi+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.fujitsu.oasys": {
        source: "iana",
        extensions: ["oas"]
      },
      "application/vnd.fujitsu.oasys2": {
        source: "iana",
        extensions: ["oa2"]
      },
      "application/vnd.fujitsu.oasys3": {
        source: "iana",
        extensions: ["oa3"]
      },
      "application/vnd.fujitsu.oasysgp": {
        source: "iana",
        extensions: ["fg5"]
      },
      "application/vnd.fujitsu.oasysprs": {
        source: "iana",
        extensions: ["bh2"]
      },
      "application/vnd.fujixerox.art-ex": {
        source: "iana"
      },
      "application/vnd.fujixerox.art4": {
        source: "iana"
      },
      "application/vnd.fujixerox.ddd": {
        source: "iana",
        extensions: ["ddd"]
      },
      "application/vnd.fujixerox.docuworks": {
        source: "iana",
        extensions: ["xdw"]
      },
      "application/vnd.fujixerox.docuworks.binder": {
        source: "iana",
        extensions: ["xbd"]
      },
      "application/vnd.fujixerox.docuworks.container": {
        source: "iana"
      },
      "application/vnd.fujixerox.hbpl": {
        source: "iana"
      },
      "application/vnd.fut-misnet": {
        source: "iana"
      },
      "application/vnd.futoin+cbor": {
        source: "iana"
      },
      "application/vnd.futoin+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.fuzzysheet": {
        source: "iana",
        extensions: ["fzs"]
      },
      "application/vnd.genomatix.tuxedo": {
        source: "iana",
        extensions: ["txd"]
      },
      "application/vnd.gentics.grd+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.geo+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.geocube+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.geogebra.file": {
        source: "iana",
        extensions: ["ggb"]
      },
      "application/vnd.geogebra.slides": {
        source: "iana"
      },
      "application/vnd.geogebra.tool": {
        source: "iana",
        extensions: ["ggt"]
      },
      "application/vnd.geometry-explorer": {
        source: "iana",
        extensions: ["gex", "gre"]
      },
      "application/vnd.geonext": {
        source: "iana",
        extensions: ["gxt"]
      },
      "application/vnd.geoplan": {
        source: "iana",
        extensions: ["g2w"]
      },
      "application/vnd.geospace": {
        source: "iana",
        extensions: ["g3w"]
      },
      "application/vnd.gerber": {
        source: "iana"
      },
      "application/vnd.globalplatform.card-content-mgt": {
        source: "iana"
      },
      "application/vnd.globalplatform.card-content-mgt-response": {
        source: "iana"
      },
      "application/vnd.gmx": {
        source: "iana",
        extensions: ["gmx"]
      },
      "application/vnd.google-apps.document": {
        compressible: false,
        extensions: ["gdoc"]
      },
      "application/vnd.google-apps.presentation": {
        compressible: false,
        extensions: ["gslides"]
      },
      "application/vnd.google-apps.spreadsheet": {
        compressible: false,
        extensions: ["gsheet"]
      },
      "application/vnd.google-earth.kml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["kml"]
      },
      "application/vnd.google-earth.kmz": {
        source: "iana",
        compressible: false,
        extensions: ["kmz"]
      },
      "application/vnd.gov.sk.e-form+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.gov.sk.e-form+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.gov.sk.xmldatacontainer+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.grafeq": {
        source: "iana",
        extensions: ["gqf", "gqs"]
      },
      "application/vnd.gridmp": {
        source: "iana"
      },
      "application/vnd.groove-account": {
        source: "iana",
        extensions: ["gac"]
      },
      "application/vnd.groove-help": {
        source: "iana",
        extensions: ["ghf"]
      },
      "application/vnd.groove-identity-message": {
        source: "iana",
        extensions: ["gim"]
      },
      "application/vnd.groove-injector": {
        source: "iana",
        extensions: ["grv"]
      },
      "application/vnd.groove-tool-message": {
        source: "iana",
        extensions: ["gtm"]
      },
      "application/vnd.groove-tool-template": {
        source: "iana",
        extensions: ["tpl"]
      },
      "application/vnd.groove-vcard": {
        source: "iana",
        extensions: ["vcg"]
      },
      "application/vnd.hal+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.hal+xml": {
        source: "iana",
        compressible: true,
        extensions: ["hal"]
      },
      "application/vnd.handheld-entertainment+xml": {
        source: "iana",
        compressible: true,
        extensions: ["zmm"]
      },
      "application/vnd.hbci": {
        source: "iana",
        extensions: ["hbci"]
      },
      "application/vnd.hc+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.hcl-bireports": {
        source: "iana"
      },
      "application/vnd.hdt": {
        source: "iana"
      },
      "application/vnd.heroku+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.hhe.lesson-player": {
        source: "iana",
        extensions: ["les"]
      },
      "application/vnd.hl7cda+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/vnd.hl7v2+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/vnd.hp-hpgl": {
        source: "iana",
        extensions: ["hpgl"]
      },
      "application/vnd.hp-hpid": {
        source: "iana",
        extensions: ["hpid"]
      },
      "application/vnd.hp-hps": {
        source: "iana",
        extensions: ["hps"]
      },
      "application/vnd.hp-jlyt": {
        source: "iana",
        extensions: ["jlt"]
      },
      "application/vnd.hp-pcl": {
        source: "iana",
        extensions: ["pcl"]
      },
      "application/vnd.hp-pclxl": {
        source: "iana",
        extensions: ["pclxl"]
      },
      "application/vnd.httphone": {
        source: "iana"
      },
      "application/vnd.hydrostatix.sof-data": {
        source: "iana",
        extensions: ["sfd-hdstx"]
      },
      "application/vnd.hyper+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.hyper-item+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.hyperdrive+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.hzn-3d-crossword": {
        source: "iana"
      },
      "application/vnd.ibm.afplinedata": {
        source: "iana"
      },
      "application/vnd.ibm.electronic-media": {
        source: "iana"
      },
      "application/vnd.ibm.minipay": {
        source: "iana",
        extensions: ["mpy"]
      },
      "application/vnd.ibm.modcap": {
        source: "iana",
        extensions: ["afp", "listafp", "list3820"]
      },
      "application/vnd.ibm.rights-management": {
        source: "iana",
        extensions: ["irm"]
      },
      "application/vnd.ibm.secure-container": {
        source: "iana",
        extensions: ["sc"]
      },
      "application/vnd.iccprofile": {
        source: "iana",
        extensions: ["icc", "icm"]
      },
      "application/vnd.ieee.1905": {
        source: "iana"
      },
      "application/vnd.igloader": {
        source: "iana",
        extensions: ["igl"]
      },
      "application/vnd.imagemeter.folder+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.imagemeter.image+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.immervision-ivp": {
        source: "iana",
        extensions: ["ivp"]
      },
      "application/vnd.immervision-ivu": {
        source: "iana",
        extensions: ["ivu"]
      },
      "application/vnd.ims.imsccv1p1": {
        source: "iana"
      },
      "application/vnd.ims.imsccv1p2": {
        source: "iana"
      },
      "application/vnd.ims.imsccv1p3": {
        source: "iana"
      },
      "application/vnd.ims.lis.v2.result+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ims.lti.v2.toolconsumerprofile+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ims.lti.v2.toolproxy+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ims.lti.v2.toolproxy.id+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ims.lti.v2.toolsettings+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ims.lti.v2.toolsettings.simple+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.informedcontrol.rms+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.informix-visionary": {
        source: "iana"
      },
      "application/vnd.infotech.project": {
        source: "iana"
      },
      "application/vnd.infotech.project+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.innopath.wamp.notification": {
        source: "iana"
      },
      "application/vnd.insors.igm": {
        source: "iana",
        extensions: ["igm"]
      },
      "application/vnd.intercon.formnet": {
        source: "iana",
        extensions: ["xpw", "xpx"]
      },
      "application/vnd.intergeo": {
        source: "iana",
        extensions: ["i2g"]
      },
      "application/vnd.intertrust.digibox": {
        source: "iana"
      },
      "application/vnd.intertrust.nncp": {
        source: "iana"
      },
      "application/vnd.intu.qbo": {
        source: "iana",
        extensions: ["qbo"]
      },
      "application/vnd.intu.qfx": {
        source: "iana",
        extensions: ["qfx"]
      },
      "application/vnd.iptc.g2.catalogitem+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.iptc.g2.conceptitem+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.iptc.g2.knowledgeitem+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.iptc.g2.newsitem+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.iptc.g2.newsmessage+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.iptc.g2.packageitem+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.iptc.g2.planningitem+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ipunplugged.rcprofile": {
        source: "iana",
        extensions: ["rcprofile"]
      },
      "application/vnd.irepository.package+xml": {
        source: "iana",
        compressible: true,
        extensions: ["irp"]
      },
      "application/vnd.is-xpr": {
        source: "iana",
        extensions: ["xpr"]
      },
      "application/vnd.isac.fcs": {
        source: "iana",
        extensions: ["fcs"]
      },
      "application/vnd.iso11783-10+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.jam": {
        source: "iana",
        extensions: ["jam"]
      },
      "application/vnd.japannet-directory-service": {
        source: "iana"
      },
      "application/vnd.japannet-jpnstore-wakeup": {
        source: "iana"
      },
      "application/vnd.japannet-payment-wakeup": {
        source: "iana"
      },
      "application/vnd.japannet-registration": {
        source: "iana"
      },
      "application/vnd.japannet-registration-wakeup": {
        source: "iana"
      },
      "application/vnd.japannet-setstore-wakeup": {
        source: "iana"
      },
      "application/vnd.japannet-verification": {
        source: "iana"
      },
      "application/vnd.japannet-verification-wakeup": {
        source: "iana"
      },
      "application/vnd.jcp.javame.midlet-rms": {
        source: "iana",
        extensions: ["rms"]
      },
      "application/vnd.jisp": {
        source: "iana",
        extensions: ["jisp"]
      },
      "application/vnd.joost.joda-archive": {
        source: "iana",
        extensions: ["joda"]
      },
      "application/vnd.jsk.isdn-ngn": {
        source: "iana"
      },
      "application/vnd.kahootz": {
        source: "iana",
        extensions: ["ktz", "ktr"]
      },
      "application/vnd.kde.karbon": {
        source: "iana",
        extensions: ["karbon"]
      },
      "application/vnd.kde.kchart": {
        source: "iana",
        extensions: ["chrt"]
      },
      "application/vnd.kde.kformula": {
        source: "iana",
        extensions: ["kfo"]
      },
      "application/vnd.kde.kivio": {
        source: "iana",
        extensions: ["flw"]
      },
      "application/vnd.kde.kontour": {
        source: "iana",
        extensions: ["kon"]
      },
      "application/vnd.kde.kpresenter": {
        source: "iana",
        extensions: ["kpr", "kpt"]
      },
      "application/vnd.kde.kspread": {
        source: "iana",
        extensions: ["ksp"]
      },
      "application/vnd.kde.kword": {
        source: "iana",
        extensions: ["kwd", "kwt"]
      },
      "application/vnd.kenameaapp": {
        source: "iana",
        extensions: ["htke"]
      },
      "application/vnd.kidspiration": {
        source: "iana",
        extensions: ["kia"]
      },
      "application/vnd.kinar": {
        source: "iana",
        extensions: ["kne", "knp"]
      },
      "application/vnd.koan": {
        source: "iana",
        extensions: ["skp", "skd", "skt", "skm"]
      },
      "application/vnd.kodak-descriptor": {
        source: "iana",
        extensions: ["sse"]
      },
      "application/vnd.las": {
        source: "iana"
      },
      "application/vnd.las.las+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.las.las+xml": {
        source: "iana",
        compressible: true,
        extensions: ["lasxml"]
      },
      "application/vnd.laszip": {
        source: "iana"
      },
      "application/vnd.leap+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.liberty-request+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.llamagraphics.life-balance.desktop": {
        source: "iana",
        extensions: ["lbd"]
      },
      "application/vnd.llamagraphics.life-balance.exchange+xml": {
        source: "iana",
        compressible: true,
        extensions: ["lbe"]
      },
      "application/vnd.logipipe.circuit+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.loom": {
        source: "iana"
      },
      "application/vnd.lotus-1-2-3": {
        source: "iana",
        extensions: ["123"]
      },
      "application/vnd.lotus-approach": {
        source: "iana",
        extensions: ["apr"]
      },
      "application/vnd.lotus-freelance": {
        source: "iana",
        extensions: ["pre"]
      },
      "application/vnd.lotus-notes": {
        source: "iana",
        extensions: ["nsf"]
      },
      "application/vnd.lotus-organizer": {
        source: "iana",
        extensions: ["org"]
      },
      "application/vnd.lotus-screencam": {
        source: "iana",
        extensions: ["scm"]
      },
      "application/vnd.lotus-wordpro": {
        source: "iana",
        extensions: ["lwp"]
      },
      "application/vnd.macports.portpkg": {
        source: "iana",
        extensions: ["portpkg"]
      },
      "application/vnd.mapbox-vector-tile": {
        source: "iana",
        extensions: ["mvt"]
      },
      "application/vnd.marlin.drm.actiontoken+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.marlin.drm.conftoken+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.marlin.drm.license+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.marlin.drm.mdcf": {
        source: "iana"
      },
      "application/vnd.mason+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.maxar.archive.3tz+zip": {
        source: "iana",
        compressible: false
      },
      "application/vnd.maxmind.maxmind-db": {
        source: "iana"
      },
      "application/vnd.mcd": {
        source: "iana",
        extensions: ["mcd"]
      },
      "application/vnd.medcalcdata": {
        source: "iana",
        extensions: ["mc1"]
      },
      "application/vnd.mediastation.cdkey": {
        source: "iana",
        extensions: ["cdkey"]
      },
      "application/vnd.meridian-slingshot": {
        source: "iana"
      },
      "application/vnd.mfer": {
        source: "iana",
        extensions: ["mwf"]
      },
      "application/vnd.mfmp": {
        source: "iana",
        extensions: ["mfm"]
      },
      "application/vnd.micro+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.micrografx.flo": {
        source: "iana",
        extensions: ["flo"]
      },
      "application/vnd.micrografx.igx": {
        source: "iana",
        extensions: ["igx"]
      },
      "application/vnd.microsoft.portable-executable": {
        source: "iana"
      },
      "application/vnd.microsoft.windows.thumbnail-cache": {
        source: "iana"
      },
      "application/vnd.miele+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.mif": {
        source: "iana",
        extensions: ["mif"]
      },
      "application/vnd.minisoft-hp3000-save": {
        source: "iana"
      },
      "application/vnd.mitsubishi.misty-guard.trustweb": {
        source: "iana"
      },
      "application/vnd.mobius.daf": {
        source: "iana",
        extensions: ["daf"]
      },
      "application/vnd.mobius.dis": {
        source: "iana",
        extensions: ["dis"]
      },
      "application/vnd.mobius.mbk": {
        source: "iana",
        extensions: ["mbk"]
      },
      "application/vnd.mobius.mqy": {
        source: "iana",
        extensions: ["mqy"]
      },
      "application/vnd.mobius.msl": {
        source: "iana",
        extensions: ["msl"]
      },
      "application/vnd.mobius.plc": {
        source: "iana",
        extensions: ["plc"]
      },
      "application/vnd.mobius.txf": {
        source: "iana",
        extensions: ["txf"]
      },
      "application/vnd.mophun.application": {
        source: "iana",
        extensions: ["mpn"]
      },
      "application/vnd.mophun.certificate": {
        source: "iana",
        extensions: ["mpc"]
      },
      "application/vnd.motorola.flexsuite": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.adsi": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.fis": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.gotap": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.kmr": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.ttc": {
        source: "iana"
      },
      "application/vnd.motorola.flexsuite.wem": {
        source: "iana"
      },
      "application/vnd.motorola.iprm": {
        source: "iana"
      },
      "application/vnd.mozilla.xul+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xul"]
      },
      "application/vnd.ms-3mfdocument": {
        source: "iana"
      },
      "application/vnd.ms-artgalry": {
        source: "iana",
        extensions: ["cil"]
      },
      "application/vnd.ms-asf": {
        source: "iana"
      },
      "application/vnd.ms-cab-compressed": {
        source: "iana",
        extensions: ["cab"]
      },
      "application/vnd.ms-color.iccprofile": {
        source: "apache"
      },
      "application/vnd.ms-excel": {
        source: "iana",
        compressible: false,
        extensions: ["xls", "xlm", "xla", "xlc", "xlt", "xlw"]
      },
      "application/vnd.ms-excel.addin.macroenabled.12": {
        source: "iana",
        extensions: ["xlam"]
      },
      "application/vnd.ms-excel.sheet.binary.macroenabled.12": {
        source: "iana",
        extensions: ["xlsb"]
      },
      "application/vnd.ms-excel.sheet.macroenabled.12": {
        source: "iana",
        extensions: ["xlsm"]
      },
      "application/vnd.ms-excel.template.macroenabled.12": {
        source: "iana",
        extensions: ["xltm"]
      },
      "application/vnd.ms-fontobject": {
        source: "iana",
        compressible: true,
        extensions: ["eot"]
      },
      "application/vnd.ms-htmlhelp": {
        source: "iana",
        extensions: ["chm"]
      },
      "application/vnd.ms-ims": {
        source: "iana",
        extensions: ["ims"]
      },
      "application/vnd.ms-lrm": {
        source: "iana",
        extensions: ["lrm"]
      },
      "application/vnd.ms-office.activex+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ms-officetheme": {
        source: "iana",
        extensions: ["thmx"]
      },
      "application/vnd.ms-opentype": {
        source: "apache",
        compressible: true
      },
      "application/vnd.ms-outlook": {
        compressible: false,
        extensions: ["msg"]
      },
      "application/vnd.ms-package.obfuscated-opentype": {
        source: "apache"
      },
      "application/vnd.ms-pki.seccat": {
        source: "apache",
        extensions: ["cat"]
      },
      "application/vnd.ms-pki.stl": {
        source: "apache",
        extensions: ["stl"]
      },
      "application/vnd.ms-playready.initiator+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ms-powerpoint": {
        source: "iana",
        compressible: false,
        extensions: ["ppt", "pps", "pot"]
      },
      "application/vnd.ms-powerpoint.addin.macroenabled.12": {
        source: "iana",
        extensions: ["ppam"]
      },
      "application/vnd.ms-powerpoint.presentation.macroenabled.12": {
        source: "iana",
        extensions: ["pptm"]
      },
      "application/vnd.ms-powerpoint.slide.macroenabled.12": {
        source: "iana",
        extensions: ["sldm"]
      },
      "application/vnd.ms-powerpoint.slideshow.macroenabled.12": {
        source: "iana",
        extensions: ["ppsm"]
      },
      "application/vnd.ms-powerpoint.template.macroenabled.12": {
        source: "iana",
        extensions: ["potm"]
      },
      "application/vnd.ms-printdevicecapabilities+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ms-printing.printticket+xml": {
        source: "apache",
        compressible: true
      },
      "application/vnd.ms-printschematicket+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ms-project": {
        source: "iana",
        extensions: ["mpp", "mpt"]
      },
      "application/vnd.ms-tnef": {
        source: "iana"
      },
      "application/vnd.ms-windows.devicepairing": {
        source: "iana"
      },
      "application/vnd.ms-windows.nwprinting.oob": {
        source: "iana"
      },
      "application/vnd.ms-windows.printerpairing": {
        source: "iana"
      },
      "application/vnd.ms-windows.wsd.oob": {
        source: "iana"
      },
      "application/vnd.ms-wmdrm.lic-chlg-req": {
        source: "iana"
      },
      "application/vnd.ms-wmdrm.lic-resp": {
        source: "iana"
      },
      "application/vnd.ms-wmdrm.meter-chlg-req": {
        source: "iana"
      },
      "application/vnd.ms-wmdrm.meter-resp": {
        source: "iana"
      },
      "application/vnd.ms-word.document.macroenabled.12": {
        source: "iana",
        extensions: ["docm"]
      },
      "application/vnd.ms-word.template.macroenabled.12": {
        source: "iana",
        extensions: ["dotm"]
      },
      "application/vnd.ms-works": {
        source: "iana",
        extensions: ["wps", "wks", "wcm", "wdb"]
      },
      "application/vnd.ms-wpl": {
        source: "iana",
        extensions: ["wpl"]
      },
      "application/vnd.ms-xpsdocument": {
        source: "iana",
        compressible: false,
        extensions: ["xps"]
      },
      "application/vnd.msa-disk-image": {
        source: "iana"
      },
      "application/vnd.mseq": {
        source: "iana",
        extensions: ["mseq"]
      },
      "application/vnd.msign": {
        source: "iana"
      },
      "application/vnd.multiad.creator": {
        source: "iana"
      },
      "application/vnd.multiad.creator.cif": {
        source: "iana"
      },
      "application/vnd.music-niff": {
        source: "iana"
      },
      "application/vnd.musician": {
        source: "iana",
        extensions: ["mus"]
      },
      "application/vnd.muvee.style": {
        source: "iana",
        extensions: ["msty"]
      },
      "application/vnd.mynfc": {
        source: "iana",
        extensions: ["taglet"]
      },
      "application/vnd.nacamar.ybrid+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.ncd.control": {
        source: "iana"
      },
      "application/vnd.ncd.reference": {
        source: "iana"
      },
      "application/vnd.nearst.inv+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.nebumind.line": {
        source: "iana"
      },
      "application/vnd.nervana": {
        source: "iana"
      },
      "application/vnd.netfpx": {
        source: "iana"
      },
      "application/vnd.neurolanguage.nlu": {
        source: "iana",
        extensions: ["nlu"]
      },
      "application/vnd.nimn": {
        source: "iana"
      },
      "application/vnd.nintendo.nitro.rom": {
        source: "iana"
      },
      "application/vnd.nintendo.snes.rom": {
        source: "iana"
      },
      "application/vnd.nitf": {
        source: "iana",
        extensions: ["ntf", "nitf"]
      },
      "application/vnd.noblenet-directory": {
        source: "iana",
        extensions: ["nnd"]
      },
      "application/vnd.noblenet-sealer": {
        source: "iana",
        extensions: ["nns"]
      },
      "application/vnd.noblenet-web": {
        source: "iana",
        extensions: ["nnw"]
      },
      "application/vnd.nokia.catalogs": {
        source: "iana"
      },
      "application/vnd.nokia.conml+wbxml": {
        source: "iana"
      },
      "application/vnd.nokia.conml+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.nokia.iptv.config+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.nokia.isds-radio-presets": {
        source: "iana"
      },
      "application/vnd.nokia.landmark+wbxml": {
        source: "iana"
      },
      "application/vnd.nokia.landmark+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.nokia.landmarkcollection+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.nokia.n-gage.ac+xml": {
        source: "iana",
        compressible: true,
        extensions: ["ac"]
      },
      "application/vnd.nokia.n-gage.data": {
        source: "iana",
        extensions: ["ngdat"]
      },
      "application/vnd.nokia.n-gage.symbian.install": {
        source: "iana",
        extensions: ["n-gage"]
      },
      "application/vnd.nokia.ncd": {
        source: "iana"
      },
      "application/vnd.nokia.pcd+wbxml": {
        source: "iana"
      },
      "application/vnd.nokia.pcd+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.nokia.radio-preset": {
        source: "iana",
        extensions: ["rpst"]
      },
      "application/vnd.nokia.radio-presets": {
        source: "iana",
        extensions: ["rpss"]
      },
      "application/vnd.novadigm.edm": {
        source: "iana",
        extensions: ["edm"]
      },
      "application/vnd.novadigm.edx": {
        source: "iana",
        extensions: ["edx"]
      },
      "application/vnd.novadigm.ext": {
        source: "iana",
        extensions: ["ext"]
      },
      "application/vnd.ntt-local.content-share": {
        source: "iana"
      },
      "application/vnd.ntt-local.file-transfer": {
        source: "iana"
      },
      "application/vnd.ntt-local.ogw_remote-access": {
        source: "iana"
      },
      "application/vnd.ntt-local.sip-ta_remote": {
        source: "iana"
      },
      "application/vnd.ntt-local.sip-ta_tcp_stream": {
        source: "iana"
      },
      "application/vnd.oasis.opendocument.chart": {
        source: "iana",
        extensions: ["odc"]
      },
      "application/vnd.oasis.opendocument.chart-template": {
        source: "iana",
        extensions: ["otc"]
      },
      "application/vnd.oasis.opendocument.database": {
        source: "iana",
        extensions: ["odb"]
      },
      "application/vnd.oasis.opendocument.formula": {
        source: "iana",
        extensions: ["odf"]
      },
      "application/vnd.oasis.opendocument.formula-template": {
        source: "iana",
        extensions: ["odft"]
      },
      "application/vnd.oasis.opendocument.graphics": {
        source: "iana",
        compressible: false,
        extensions: ["odg"]
      },
      "application/vnd.oasis.opendocument.graphics-template": {
        source: "iana",
        extensions: ["otg"]
      },
      "application/vnd.oasis.opendocument.image": {
        source: "iana",
        extensions: ["odi"]
      },
      "application/vnd.oasis.opendocument.image-template": {
        source: "iana",
        extensions: ["oti"]
      },
      "application/vnd.oasis.opendocument.presentation": {
        source: "iana",
        compressible: false,
        extensions: ["odp"]
      },
      "application/vnd.oasis.opendocument.presentation-template": {
        source: "iana",
        extensions: ["otp"]
      },
      "application/vnd.oasis.opendocument.spreadsheet": {
        source: "iana",
        compressible: false,
        extensions: ["ods"]
      },
      "application/vnd.oasis.opendocument.spreadsheet-template": {
        source: "iana",
        extensions: ["ots"]
      },
      "application/vnd.oasis.opendocument.text": {
        source: "iana",
        compressible: false,
        extensions: ["odt"]
      },
      "application/vnd.oasis.opendocument.text-master": {
        source: "iana",
        extensions: ["odm"]
      },
      "application/vnd.oasis.opendocument.text-template": {
        source: "iana",
        extensions: ["ott"]
      },
      "application/vnd.oasis.opendocument.text-web": {
        source: "iana",
        extensions: ["oth"]
      },
      "application/vnd.obn": {
        source: "iana"
      },
      "application/vnd.ocf+cbor": {
        source: "iana"
      },
      "application/vnd.oci.image.manifest.v1+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oftn.l10n+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oipf.contentaccessdownload+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oipf.contentaccessstreaming+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oipf.cspg-hexbinary": {
        source: "iana"
      },
      "application/vnd.oipf.dae.svg+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oipf.dae.xhtml+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oipf.mippvcontrolmessage+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oipf.pae.gem": {
        source: "iana"
      },
      "application/vnd.oipf.spdiscovery+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oipf.spdlist+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oipf.ueprofile+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oipf.userprofile+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.olpc-sugar": {
        source: "iana",
        extensions: ["xo"]
      },
      "application/vnd.oma-scws-config": {
        source: "iana"
      },
      "application/vnd.oma-scws-http-request": {
        source: "iana"
      },
      "application/vnd.oma-scws-http-response": {
        source: "iana"
      },
      "application/vnd.oma.bcast.associated-procedure-parameter+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.bcast.drm-trigger+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.bcast.imd+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.bcast.ltkm": {
        source: "iana"
      },
      "application/vnd.oma.bcast.notification+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.bcast.provisioningtrigger": {
        source: "iana"
      },
      "application/vnd.oma.bcast.sgboot": {
        source: "iana"
      },
      "application/vnd.oma.bcast.sgdd+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.bcast.sgdu": {
        source: "iana"
      },
      "application/vnd.oma.bcast.simple-symbol-container": {
        source: "iana"
      },
      "application/vnd.oma.bcast.smartcard-trigger+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.bcast.sprov+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.bcast.stkm": {
        source: "iana"
      },
      "application/vnd.oma.cab-address-book+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.cab-feature-handler+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.cab-pcc+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.cab-subs-invite+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.cab-user-prefs+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.dcd": {
        source: "iana"
      },
      "application/vnd.oma.dcdc": {
        source: "iana"
      },
      "application/vnd.oma.dd2+xml": {
        source: "iana",
        compressible: true,
        extensions: ["dd2"]
      },
      "application/vnd.oma.drm.risd+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.group-usage-list+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.lwm2m+cbor": {
        source: "iana"
      },
      "application/vnd.oma.lwm2m+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.lwm2m+tlv": {
        source: "iana"
      },
      "application/vnd.oma.pal+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.poc.detailed-progress-report+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.poc.final-report+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.poc.groups+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.poc.invocation-descriptor+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.poc.optimized-progress-report+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.push": {
        source: "iana"
      },
      "application/vnd.oma.scidm.messages+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oma.xcap-directory+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.omads-email+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/vnd.omads-file+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/vnd.omads-folder+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/vnd.omaloc-supl-init": {
        source: "iana"
      },
      "application/vnd.onepager": {
        source: "iana"
      },
      "application/vnd.onepagertamp": {
        source: "iana"
      },
      "application/vnd.onepagertamx": {
        source: "iana"
      },
      "application/vnd.onepagertat": {
        source: "iana"
      },
      "application/vnd.onepagertatp": {
        source: "iana"
      },
      "application/vnd.onepagertatx": {
        source: "iana"
      },
      "application/vnd.openblox.game+xml": {
        source: "iana",
        compressible: true,
        extensions: ["obgx"]
      },
      "application/vnd.openblox.game-binary": {
        source: "iana"
      },
      "application/vnd.openeye.oeb": {
        source: "iana"
      },
      "application/vnd.openofficeorg.extension": {
        source: "apache",
        extensions: ["oxt"]
      },
      "application/vnd.openstreetmap.data+xml": {
        source: "iana",
        compressible: true,
        extensions: ["osm"]
      },
      "application/vnd.opentimestamps.ots": {
        source: "iana"
      },
      "application/vnd.openxmlformats-officedocument.custom-properties+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.customxmlproperties+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.drawing+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.drawingml.chart+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.extended-properties+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.comments+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.presentation": {
        source: "iana",
        compressible: false,
        extensions: ["pptx"]
      },
      "application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.presprops+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slide": {
        source: "iana",
        extensions: ["sldx"]
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slide+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slideshow": {
        source: "iana",
        extensions: ["ppsx"]
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.tags+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.template": {
        source: "iana",
        extensions: ["potx"]
      },
      "application/vnd.openxmlformats-officedocument.presentationml.template.main+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": {
        source: "iana",
        compressible: false,
        extensions: ["xlsx"]
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.template": {
        source: "iana",
        extensions: ["xltx"]
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.theme+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.themeoverride+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.vmldrawing": {
        source: "iana"
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document": {
        source: "iana",
        compressible: false,
        extensions: ["docx"]
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.template": {
        source: "iana",
        extensions: ["dotx"]
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-package.core-properties+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.openxmlformats-package.relationships+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oracle.resource+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.orange.indata": {
        source: "iana"
      },
      "application/vnd.osa.netdeploy": {
        source: "iana"
      },
      "application/vnd.osgeo.mapguide.package": {
        source: "iana",
        extensions: ["mgp"]
      },
      "application/vnd.osgi.bundle": {
        source: "iana"
      },
      "application/vnd.osgi.dp": {
        source: "iana",
        extensions: ["dp"]
      },
      "application/vnd.osgi.subsystem": {
        source: "iana",
        extensions: ["esa"]
      },
      "application/vnd.otps.ct-kip+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.oxli.countgraph": {
        source: "iana"
      },
      "application/vnd.pagerduty+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.palm": {
        source: "iana",
        extensions: ["pdb", "pqa", "oprc"]
      },
      "application/vnd.panoply": {
        source: "iana"
      },
      "application/vnd.paos.xml": {
        source: "iana"
      },
      "application/vnd.patentdive": {
        source: "iana"
      },
      "application/vnd.patientecommsdoc": {
        source: "iana"
      },
      "application/vnd.pawaafile": {
        source: "iana",
        extensions: ["paw"]
      },
      "application/vnd.pcos": {
        source: "iana"
      },
      "application/vnd.pg.format": {
        source: "iana",
        extensions: ["str"]
      },
      "application/vnd.pg.osasli": {
        source: "iana",
        extensions: ["ei6"]
      },
      "application/vnd.piaccess.application-licence": {
        source: "iana"
      },
      "application/vnd.picsel": {
        source: "iana",
        extensions: ["efif"]
      },
      "application/vnd.pmi.widget": {
        source: "iana",
        extensions: ["wg"]
      },
      "application/vnd.poc.group-advertisement+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.pocketlearn": {
        source: "iana",
        extensions: ["plf"]
      },
      "application/vnd.powerbuilder6": {
        source: "iana",
        extensions: ["pbd"]
      },
      "application/vnd.powerbuilder6-s": {
        source: "iana"
      },
      "application/vnd.powerbuilder7": {
        source: "iana"
      },
      "application/vnd.powerbuilder7-s": {
        source: "iana"
      },
      "application/vnd.powerbuilder75": {
        source: "iana"
      },
      "application/vnd.powerbuilder75-s": {
        source: "iana"
      },
      "application/vnd.preminet": {
        source: "iana"
      },
      "application/vnd.previewsystems.box": {
        source: "iana",
        extensions: ["box"]
      },
      "application/vnd.proteus.magazine": {
        source: "iana",
        extensions: ["mgz"]
      },
      "application/vnd.psfs": {
        source: "iana"
      },
      "application/vnd.publishare-delta-tree": {
        source: "iana",
        extensions: ["qps"]
      },
      "application/vnd.pvi.ptid1": {
        source: "iana",
        extensions: ["ptid"]
      },
      "application/vnd.pwg-multiplexed": {
        source: "iana"
      },
      "application/vnd.pwg-xhtml-print+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.qualcomm.brew-app-res": {
        source: "iana"
      },
      "application/vnd.quarantainenet": {
        source: "iana"
      },
      "application/vnd.quark.quarkxpress": {
        source: "iana",
        extensions: ["qxd", "qxt", "qwd", "qwt", "qxl", "qxb"]
      },
      "application/vnd.quobject-quoxdocument": {
        source: "iana"
      },
      "application/vnd.radisys.moml+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-audit+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-audit-conf+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-audit-conn+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-audit-dialog+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-audit-stream+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-conf+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-dialog+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-dialog-base+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-dialog-fax-detect+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-dialog-fax-sendrecv+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-dialog-group+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-dialog-speech+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.radisys.msml-dialog-transform+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.rainstor.data": {
        source: "iana"
      },
      "application/vnd.rapid": {
        source: "iana"
      },
      "application/vnd.rar": {
        source: "iana",
        extensions: ["rar"]
      },
      "application/vnd.realvnc.bed": {
        source: "iana",
        extensions: ["bed"]
      },
      "application/vnd.recordare.musicxml": {
        source: "iana",
        extensions: ["mxl"]
      },
      "application/vnd.recordare.musicxml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["musicxml"]
      },
      "application/vnd.renlearn.rlprint": {
        source: "iana"
      },
      "application/vnd.resilient.logic": {
        source: "iana"
      },
      "application/vnd.restful+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.rig.cryptonote": {
        source: "iana",
        extensions: ["cryptonote"]
      },
      "application/vnd.rim.cod": {
        source: "apache",
        extensions: ["cod"]
      },
      "application/vnd.rn-realmedia": {
        source: "apache",
        extensions: ["rm"]
      },
      "application/vnd.rn-realmedia-vbr": {
        source: "apache",
        extensions: ["rmvb"]
      },
      "application/vnd.route66.link66+xml": {
        source: "iana",
        compressible: true,
        extensions: ["link66"]
      },
      "application/vnd.rs-274x": {
        source: "iana"
      },
      "application/vnd.ruckus.download": {
        source: "iana"
      },
      "application/vnd.s3sms": {
        source: "iana"
      },
      "application/vnd.sailingtracker.track": {
        source: "iana",
        extensions: ["st"]
      },
      "application/vnd.sar": {
        source: "iana"
      },
      "application/vnd.sbm.cid": {
        source: "iana"
      },
      "application/vnd.sbm.mid2": {
        source: "iana"
      },
      "application/vnd.scribus": {
        source: "iana"
      },
      "application/vnd.sealed.3df": {
        source: "iana"
      },
      "application/vnd.sealed.csf": {
        source: "iana"
      },
      "application/vnd.sealed.doc": {
        source: "iana"
      },
      "application/vnd.sealed.eml": {
        source: "iana"
      },
      "application/vnd.sealed.mht": {
        source: "iana"
      },
      "application/vnd.sealed.net": {
        source: "iana"
      },
      "application/vnd.sealed.ppt": {
        source: "iana"
      },
      "application/vnd.sealed.tiff": {
        source: "iana"
      },
      "application/vnd.sealed.xls": {
        source: "iana"
      },
      "application/vnd.sealedmedia.softseal.html": {
        source: "iana"
      },
      "application/vnd.sealedmedia.softseal.pdf": {
        source: "iana"
      },
      "application/vnd.seemail": {
        source: "iana",
        extensions: ["see"]
      },
      "application/vnd.seis+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.sema": {
        source: "iana",
        extensions: ["sema"]
      },
      "application/vnd.semd": {
        source: "iana",
        extensions: ["semd"]
      },
      "application/vnd.semf": {
        source: "iana",
        extensions: ["semf"]
      },
      "application/vnd.shade-save-file": {
        source: "iana"
      },
      "application/vnd.shana.informed.formdata": {
        source: "iana",
        extensions: ["ifm"]
      },
      "application/vnd.shana.informed.formtemplate": {
        source: "iana",
        extensions: ["itp"]
      },
      "application/vnd.shana.informed.interchange": {
        source: "iana",
        extensions: ["iif"]
      },
      "application/vnd.shana.informed.package": {
        source: "iana",
        extensions: ["ipk"]
      },
      "application/vnd.shootproof+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.shopkick+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.shp": {
        source: "iana"
      },
      "application/vnd.shx": {
        source: "iana"
      },
      "application/vnd.sigrok.session": {
        source: "iana"
      },
      "application/vnd.simtech-mindmapper": {
        source: "iana",
        extensions: ["twd", "twds"]
      },
      "application/vnd.siren+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.smaf": {
        source: "iana",
        extensions: ["mmf"]
      },
      "application/vnd.smart.notebook": {
        source: "iana"
      },
      "application/vnd.smart.teacher": {
        source: "iana",
        extensions: ["teacher"]
      },
      "application/vnd.snesdev-page-table": {
        source: "iana"
      },
      "application/vnd.software602.filler.form+xml": {
        source: "iana",
        compressible: true,
        extensions: ["fo"]
      },
      "application/vnd.software602.filler.form-xml-zip": {
        source: "iana"
      },
      "application/vnd.solent.sdkm+xml": {
        source: "iana",
        compressible: true,
        extensions: ["sdkm", "sdkd"]
      },
      "application/vnd.spotfire.dxp": {
        source: "iana",
        extensions: ["dxp"]
      },
      "application/vnd.spotfire.sfs": {
        source: "iana",
        extensions: ["sfs"]
      },
      "application/vnd.sqlite3": {
        source: "iana"
      },
      "application/vnd.sss-cod": {
        source: "iana"
      },
      "application/vnd.sss-dtf": {
        source: "iana"
      },
      "application/vnd.sss-ntf": {
        source: "iana"
      },
      "application/vnd.stardivision.calc": {
        source: "apache",
        extensions: ["sdc"]
      },
      "application/vnd.stardivision.draw": {
        source: "apache",
        extensions: ["sda"]
      },
      "application/vnd.stardivision.impress": {
        source: "apache",
        extensions: ["sdd"]
      },
      "application/vnd.stardivision.math": {
        source: "apache",
        extensions: ["smf"]
      },
      "application/vnd.stardivision.writer": {
        source: "apache",
        extensions: ["sdw", "vor"]
      },
      "application/vnd.stardivision.writer-global": {
        source: "apache",
        extensions: ["sgl"]
      },
      "application/vnd.stepmania.package": {
        source: "iana",
        extensions: ["smzip"]
      },
      "application/vnd.stepmania.stepchart": {
        source: "iana",
        extensions: ["sm"]
      },
      "application/vnd.street-stream": {
        source: "iana"
      },
      "application/vnd.sun.wadl+xml": {
        source: "iana",
        compressible: true,
        extensions: ["wadl"]
      },
      "application/vnd.sun.xml.calc": {
        source: "apache",
        extensions: ["sxc"]
      },
      "application/vnd.sun.xml.calc.template": {
        source: "apache",
        extensions: ["stc"]
      },
      "application/vnd.sun.xml.draw": {
        source: "apache",
        extensions: ["sxd"]
      },
      "application/vnd.sun.xml.draw.template": {
        source: "apache",
        extensions: ["std"]
      },
      "application/vnd.sun.xml.impress": {
        source: "apache",
        extensions: ["sxi"]
      },
      "application/vnd.sun.xml.impress.template": {
        source: "apache",
        extensions: ["sti"]
      },
      "application/vnd.sun.xml.math": {
        source: "apache",
        extensions: ["sxm"]
      },
      "application/vnd.sun.xml.writer": {
        source: "apache",
        extensions: ["sxw"]
      },
      "application/vnd.sun.xml.writer.global": {
        source: "apache",
        extensions: ["sxg"]
      },
      "application/vnd.sun.xml.writer.template": {
        source: "apache",
        extensions: ["stw"]
      },
      "application/vnd.sus-calendar": {
        source: "iana",
        extensions: ["sus", "susp"]
      },
      "application/vnd.svd": {
        source: "iana",
        extensions: ["svd"]
      },
      "application/vnd.swiftview-ics": {
        source: "iana"
      },
      "application/vnd.sycle+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.syft+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.symbian.install": {
        source: "apache",
        extensions: ["sis", "sisx"]
      },
      "application/vnd.syncml+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true,
        extensions: ["xsm"]
      },
      "application/vnd.syncml.dm+wbxml": {
        source: "iana",
        charset: "UTF-8",
        extensions: ["bdm"]
      },
      "application/vnd.syncml.dm+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true,
        extensions: ["xdm"]
      },
      "application/vnd.syncml.dm.notification": {
        source: "iana"
      },
      "application/vnd.syncml.dmddf+wbxml": {
        source: "iana"
      },
      "application/vnd.syncml.dmddf+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true,
        extensions: ["ddf"]
      },
      "application/vnd.syncml.dmtnds+wbxml": {
        source: "iana"
      },
      "application/vnd.syncml.dmtnds+xml": {
        source: "iana",
        charset: "UTF-8",
        compressible: true
      },
      "application/vnd.syncml.ds.notification": {
        source: "iana"
      },
      "application/vnd.tableschema+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.tao.intent-module-archive": {
        source: "iana",
        extensions: ["tao"]
      },
      "application/vnd.tcpdump.pcap": {
        source: "iana",
        extensions: ["pcap", "cap", "dmp"]
      },
      "application/vnd.think-cell.ppttc+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.tmd.mediaflex.api+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.tml": {
        source: "iana"
      },
      "application/vnd.tmobile-livetv": {
        source: "iana",
        extensions: ["tmo"]
      },
      "application/vnd.tri.onesource": {
        source: "iana"
      },
      "application/vnd.trid.tpt": {
        source: "iana",
        extensions: ["tpt"]
      },
      "application/vnd.triscape.mxs": {
        source: "iana",
        extensions: ["mxs"]
      },
      "application/vnd.trueapp": {
        source: "iana",
        extensions: ["tra"]
      },
      "application/vnd.truedoc": {
        source: "iana"
      },
      "application/vnd.ubisoft.webplayer": {
        source: "iana"
      },
      "application/vnd.ufdl": {
        source: "iana",
        extensions: ["ufd", "ufdl"]
      },
      "application/vnd.uiq.theme": {
        source: "iana",
        extensions: ["utz"]
      },
      "application/vnd.umajin": {
        source: "iana",
        extensions: ["umj"]
      },
      "application/vnd.unity": {
        source: "iana",
        extensions: ["unityweb"]
      },
      "application/vnd.uoml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["uoml"]
      },
      "application/vnd.uplanet.alert": {
        source: "iana"
      },
      "application/vnd.uplanet.alert-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.bearer-choice": {
        source: "iana"
      },
      "application/vnd.uplanet.bearer-choice-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.cacheop": {
        source: "iana"
      },
      "application/vnd.uplanet.cacheop-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.channel": {
        source: "iana"
      },
      "application/vnd.uplanet.channel-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.list": {
        source: "iana"
      },
      "application/vnd.uplanet.list-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.listcmd": {
        source: "iana"
      },
      "application/vnd.uplanet.listcmd-wbxml": {
        source: "iana"
      },
      "application/vnd.uplanet.signal": {
        source: "iana"
      },
      "application/vnd.uri-map": {
        source: "iana"
      },
      "application/vnd.valve.source.material": {
        source: "iana"
      },
      "application/vnd.vcx": {
        source: "iana",
        extensions: ["vcx"]
      },
      "application/vnd.vd-study": {
        source: "iana"
      },
      "application/vnd.vectorworks": {
        source: "iana"
      },
      "application/vnd.vel+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.verimatrix.vcas": {
        source: "iana"
      },
      "application/vnd.veritone.aion+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.veryant.thin": {
        source: "iana"
      },
      "application/vnd.ves.encrypted": {
        source: "iana"
      },
      "application/vnd.vidsoft.vidconference": {
        source: "iana"
      },
      "application/vnd.visio": {
        source: "iana",
        extensions: ["vsd", "vst", "vss", "vsw"]
      },
      "application/vnd.visionary": {
        source: "iana",
        extensions: ["vis"]
      },
      "application/vnd.vividence.scriptfile": {
        source: "iana"
      },
      "application/vnd.vsf": {
        source: "iana",
        extensions: ["vsf"]
      },
      "application/vnd.wap.sic": {
        source: "iana"
      },
      "application/vnd.wap.slc": {
        source: "iana"
      },
      "application/vnd.wap.wbxml": {
        source: "iana",
        charset: "UTF-8",
        extensions: ["wbxml"]
      },
      "application/vnd.wap.wmlc": {
        source: "iana",
        extensions: ["wmlc"]
      },
      "application/vnd.wap.wmlscriptc": {
        source: "iana",
        extensions: ["wmlsc"]
      },
      "application/vnd.webturbo": {
        source: "iana",
        extensions: ["wtb"]
      },
      "application/vnd.wfa.dpp": {
        source: "iana"
      },
      "application/vnd.wfa.p2p": {
        source: "iana"
      },
      "application/vnd.wfa.wsc": {
        source: "iana"
      },
      "application/vnd.windows.devicepairing": {
        source: "iana"
      },
      "application/vnd.wmc": {
        source: "iana"
      },
      "application/vnd.wmf.bootstrap": {
        source: "iana"
      },
      "application/vnd.wolfram.mathematica": {
        source: "iana"
      },
      "application/vnd.wolfram.mathematica.package": {
        source: "iana"
      },
      "application/vnd.wolfram.player": {
        source: "iana",
        extensions: ["nbp"]
      },
      "application/vnd.wordperfect": {
        source: "iana",
        extensions: ["wpd"]
      },
      "application/vnd.wqd": {
        source: "iana",
        extensions: ["wqd"]
      },
      "application/vnd.wrq-hp3000-labelled": {
        source: "iana"
      },
      "application/vnd.wt.stf": {
        source: "iana",
        extensions: ["stf"]
      },
      "application/vnd.wv.csp+wbxml": {
        source: "iana"
      },
      "application/vnd.wv.csp+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.wv.ssp+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.xacml+json": {
        source: "iana",
        compressible: true
      },
      "application/vnd.xara": {
        source: "iana",
        extensions: ["xar"]
      },
      "application/vnd.xfdl": {
        source: "iana",
        extensions: ["xfdl"]
      },
      "application/vnd.xfdl.webform": {
        source: "iana"
      },
      "application/vnd.xmi+xml": {
        source: "iana",
        compressible: true
      },
      "application/vnd.xmpie.cpkg": {
        source: "iana"
      },
      "application/vnd.xmpie.dpkg": {
        source: "iana"
      },
      "application/vnd.xmpie.plan": {
        source: "iana"
      },
      "application/vnd.xmpie.ppkg": {
        source: "iana"
      },
      "application/vnd.xmpie.xlim": {
        source: "iana"
      },
      "application/vnd.yamaha.hv-dic": {
        source: "iana",
        extensions: ["hvd"]
      },
      "application/vnd.yamaha.hv-script": {
        source: "iana",
        extensions: ["hvs"]
      },
      "application/vnd.yamaha.hv-voice": {
        source: "iana",
        extensions: ["hvp"]
      },
      "application/vnd.yamaha.openscoreformat": {
        source: "iana",
        extensions: ["osf"]
      },
      "application/vnd.yamaha.openscoreformat.osfpvg+xml": {
        source: "iana",
        compressible: true,
        extensions: ["osfpvg"]
      },
      "application/vnd.yamaha.remote-setup": {
        source: "iana"
      },
      "application/vnd.yamaha.smaf-audio": {
        source: "iana",
        extensions: ["saf"]
      },
      "application/vnd.yamaha.smaf-phrase": {
        source: "iana",
        extensions: ["spf"]
      },
      "application/vnd.yamaha.through-ngn": {
        source: "iana"
      },
      "application/vnd.yamaha.tunnel-udpencap": {
        source: "iana"
      },
      "application/vnd.yaoweme": {
        source: "iana"
      },
      "application/vnd.yellowriver-custom-menu": {
        source: "iana",
        extensions: ["cmp"]
      },
      "application/vnd.youtube.yt": {
        source: "iana"
      },
      "application/vnd.zul": {
        source: "iana",
        extensions: ["zir", "zirz"]
      },
      "application/vnd.zzazz.deck+xml": {
        source: "iana",
        compressible: true,
        extensions: ["zaz"]
      },
      "application/voicexml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["vxml"]
      },
      "application/voucher-cms+json": {
        source: "iana",
        compressible: true
      },
      "application/vq-rtcpxr": {
        source: "iana"
      },
      "application/wasm": {
        source: "iana",
        compressible: true,
        extensions: ["wasm"]
      },
      "application/watcherinfo+xml": {
        source: "iana",
        compressible: true,
        extensions: ["wif"]
      },
      "application/webpush-options+json": {
        source: "iana",
        compressible: true
      },
      "application/whoispp-query": {
        source: "iana"
      },
      "application/whoispp-response": {
        source: "iana"
      },
      "application/widget": {
        source: "iana",
        extensions: ["wgt"]
      },
      "application/winhlp": {
        source: "apache",
        extensions: ["hlp"]
      },
      "application/wita": {
        source: "iana"
      },
      "application/wordperfect5.1": {
        source: "iana"
      },
      "application/wsdl+xml": {
        source: "iana",
        compressible: true,
        extensions: ["wsdl"]
      },
      "application/wspolicy+xml": {
        source: "iana",
        compressible: true,
        extensions: ["wspolicy"]
      },
      "application/x-7z-compressed": {
        source: "apache",
        compressible: false,
        extensions: ["7z"]
      },
      "application/x-abiword": {
        source: "apache",
        extensions: ["abw"]
      },
      "application/x-ace-compressed": {
        source: "apache",
        extensions: ["ace"]
      },
      "application/x-amf": {
        source: "apache"
      },
      "application/x-apple-diskimage": {
        source: "apache",
        extensions: ["dmg"]
      },
      "application/x-arj": {
        compressible: false,
        extensions: ["arj"]
      },
      "application/x-authorware-bin": {
        source: "apache",
        extensions: ["aab", "x32", "u32", "vox"]
      },
      "application/x-authorware-map": {
        source: "apache",
        extensions: ["aam"]
      },
      "application/x-authorware-seg": {
        source: "apache",
        extensions: ["aas"]
      },
      "application/x-bcpio": {
        source: "apache",
        extensions: ["bcpio"]
      },
      "application/x-bdoc": {
        compressible: false,
        extensions: ["bdoc"]
      },
      "application/x-bittorrent": {
        source: "apache",
        extensions: ["torrent"]
      },
      "application/x-blorb": {
        source: "apache",
        extensions: ["blb", "blorb"]
      },
      "application/x-bzip": {
        source: "apache",
        compressible: false,
        extensions: ["bz"]
      },
      "application/x-bzip2": {
        source: "apache",
        compressible: false,
        extensions: ["bz2", "boz"]
      },
      "application/x-cbr": {
        source: "apache",
        extensions: ["cbr", "cba", "cbt", "cbz", "cb7"]
      },
      "application/x-cdlink": {
        source: "apache",
        extensions: ["vcd"]
      },
      "application/x-cfs-compressed": {
        source: "apache",
        extensions: ["cfs"]
      },
      "application/x-chat": {
        source: "apache",
        extensions: ["chat"]
      },
      "application/x-chess-pgn": {
        source: "apache",
        extensions: ["pgn"]
      },
      "application/x-chrome-extension": {
        extensions: ["crx"]
      },
      "application/x-cocoa": {
        source: "nginx",
        extensions: ["cco"]
      },
      "application/x-compress": {
        source: "apache"
      },
      "application/x-conference": {
        source: "apache",
        extensions: ["nsc"]
      },
      "application/x-cpio": {
        source: "apache",
        extensions: ["cpio"]
      },
      "application/x-csh": {
        source: "apache",
        extensions: ["csh"]
      },
      "application/x-deb": {
        compressible: false
      },
      "application/x-debian-package": {
        source: "apache",
        extensions: ["deb", "udeb"]
      },
      "application/x-dgc-compressed": {
        source: "apache",
        extensions: ["dgc"]
      },
      "application/x-director": {
        source: "apache",
        extensions: ["dir", "dcr", "dxr", "cst", "cct", "cxt", "w3d", "fgd", "swa"]
      },
      "application/x-doom": {
        source: "apache",
        extensions: ["wad"]
      },
      "application/x-dtbncx+xml": {
        source: "apache",
        compressible: true,
        extensions: ["ncx"]
      },
      "application/x-dtbook+xml": {
        source: "apache",
        compressible: true,
        extensions: ["dtb"]
      },
      "application/x-dtbresource+xml": {
        source: "apache",
        compressible: true,
        extensions: ["res"]
      },
      "application/x-dvi": {
        source: "apache",
        compressible: false,
        extensions: ["dvi"]
      },
      "application/x-envoy": {
        source: "apache",
        extensions: ["evy"]
      },
      "application/x-eva": {
        source: "apache",
        extensions: ["eva"]
      },
      "application/x-font-bdf": {
        source: "apache",
        extensions: ["bdf"]
      },
      "application/x-font-dos": {
        source: "apache"
      },
      "application/x-font-framemaker": {
        source: "apache"
      },
      "application/x-font-ghostscript": {
        source: "apache",
        extensions: ["gsf"]
      },
      "application/x-font-libgrx": {
        source: "apache"
      },
      "application/x-font-linux-psf": {
        source: "apache",
        extensions: ["psf"]
      },
      "application/x-font-pcf": {
        source: "apache",
        extensions: ["pcf"]
      },
      "application/x-font-snf": {
        source: "apache",
        extensions: ["snf"]
      },
      "application/x-font-speedo": {
        source: "apache"
      },
      "application/x-font-sunos-news": {
        source: "apache"
      },
      "application/x-font-type1": {
        source: "apache",
        extensions: ["pfa", "pfb", "pfm", "afm"]
      },
      "application/x-font-vfont": {
        source: "apache"
      },
      "application/x-freearc": {
        source: "apache",
        extensions: ["arc"]
      },
      "application/x-futuresplash": {
        source: "apache",
        extensions: ["spl"]
      },
      "application/x-gca-compressed": {
        source: "apache",
        extensions: ["gca"]
      },
      "application/x-glulx": {
        source: "apache",
        extensions: ["ulx"]
      },
      "application/x-gnumeric": {
        source: "apache",
        extensions: ["gnumeric"]
      },
      "application/x-gramps-xml": {
        source: "apache",
        extensions: ["gramps"]
      },
      "application/x-gtar": {
        source: "apache",
        extensions: ["gtar"]
      },
      "application/x-gzip": {
        source: "apache"
      },
      "application/x-hdf": {
        source: "apache",
        extensions: ["hdf"]
      },
      "application/x-httpd-php": {
        compressible: true,
        extensions: ["php"]
      },
      "application/x-install-instructions": {
        source: "apache",
        extensions: ["install"]
      },
      "application/x-iso9660-image": {
        source: "apache",
        extensions: ["iso"]
      },
      "application/x-iwork-keynote-sffkey": {
        extensions: ["key"]
      },
      "application/x-iwork-numbers-sffnumbers": {
        extensions: ["numbers"]
      },
      "application/x-iwork-pages-sffpages": {
        extensions: ["pages"]
      },
      "application/x-java-archive-diff": {
        source: "nginx",
        extensions: ["jardiff"]
      },
      "application/x-java-jnlp-file": {
        source: "apache",
        compressible: false,
        extensions: ["jnlp"]
      },
      "application/x-javascript": {
        compressible: true
      },
      "application/x-keepass2": {
        extensions: ["kdbx"]
      },
      "application/x-latex": {
        source: "apache",
        compressible: false,
        extensions: ["latex"]
      },
      "application/x-lua-bytecode": {
        extensions: ["luac"]
      },
      "application/x-lzh-compressed": {
        source: "apache",
        extensions: ["lzh", "lha"]
      },
      "application/x-makeself": {
        source: "nginx",
        extensions: ["run"]
      },
      "application/x-mie": {
        source: "apache",
        extensions: ["mie"]
      },
      "application/x-mobipocket-ebook": {
        source: "apache",
        extensions: ["prc", "mobi"]
      },
      "application/x-mpegurl": {
        compressible: false
      },
      "application/x-ms-application": {
        source: "apache",
        extensions: ["application"]
      },
      "application/x-ms-shortcut": {
        source: "apache",
        extensions: ["lnk"]
      },
      "application/x-ms-wmd": {
        source: "apache",
        extensions: ["wmd"]
      },
      "application/x-ms-wmz": {
        source: "apache",
        extensions: ["wmz"]
      },
      "application/x-ms-xbap": {
        source: "apache",
        extensions: ["xbap"]
      },
      "application/x-msaccess": {
        source: "apache",
        extensions: ["mdb"]
      },
      "application/x-msbinder": {
        source: "apache",
        extensions: ["obd"]
      },
      "application/x-mscardfile": {
        source: "apache",
        extensions: ["crd"]
      },
      "application/x-msclip": {
        source: "apache",
        extensions: ["clp"]
      },
      "application/x-msdos-program": {
        extensions: ["exe"]
      },
      "application/x-msdownload": {
        source: "apache",
        extensions: ["exe", "dll", "com", "bat", "msi"]
      },
      "application/x-msmediaview": {
        source: "apache",
        extensions: ["mvb", "m13", "m14"]
      },
      "application/x-msmetafile": {
        source: "apache",
        extensions: ["wmf", "wmz", "emf", "emz"]
      },
      "application/x-msmoney": {
        source: "apache",
        extensions: ["mny"]
      },
      "application/x-mspublisher": {
        source: "apache",
        extensions: ["pub"]
      },
      "application/x-msschedule": {
        source: "apache",
        extensions: ["scd"]
      },
      "application/x-msterminal": {
        source: "apache",
        extensions: ["trm"]
      },
      "application/x-mswrite": {
        source: "apache",
        extensions: ["wri"]
      },
      "application/x-netcdf": {
        source: "apache",
        extensions: ["nc", "cdf"]
      },
      "application/x-ns-proxy-autoconfig": {
        compressible: true,
        extensions: ["pac"]
      },
      "application/x-nzb": {
        source: "apache",
        extensions: ["nzb"]
      },
      "application/x-perl": {
        source: "nginx",
        extensions: ["pl", "pm"]
      },
      "application/x-pilot": {
        source: "nginx",
        extensions: ["prc", "pdb"]
      },
      "application/x-pkcs12": {
        source: "apache",
        compressible: false,
        extensions: ["p12", "pfx"]
      },
      "application/x-pkcs7-certificates": {
        source: "apache",
        extensions: ["p7b", "spc"]
      },
      "application/x-pkcs7-certreqresp": {
        source: "apache",
        extensions: ["p7r"]
      },
      "application/x-pki-message": {
        source: "iana"
      },
      "application/x-rar-compressed": {
        source: "apache",
        compressible: false,
        extensions: ["rar"]
      },
      "application/x-redhat-package-manager": {
        source: "nginx",
        extensions: ["rpm"]
      },
      "application/x-research-info-systems": {
        source: "apache",
        extensions: ["ris"]
      },
      "application/x-sea": {
        source: "nginx",
        extensions: ["sea"]
      },
      "application/x-sh": {
        source: "apache",
        compressible: true,
        extensions: ["sh"]
      },
      "application/x-shar": {
        source: "apache",
        extensions: ["shar"]
      },
      "application/x-shockwave-flash": {
        source: "apache",
        compressible: false,
        extensions: ["swf"]
      },
      "application/x-silverlight-app": {
        source: "apache",
        extensions: ["xap"]
      },
      "application/x-sql": {
        source: "apache",
        extensions: ["sql"]
      },
      "application/x-stuffit": {
        source: "apache",
        compressible: false,
        extensions: ["sit"]
      },
      "application/x-stuffitx": {
        source: "apache",
        extensions: ["sitx"]
      },
      "application/x-subrip": {
        source: "apache",
        extensions: ["srt"]
      },
      "application/x-sv4cpio": {
        source: "apache",
        extensions: ["sv4cpio"]
      },
      "application/x-sv4crc": {
        source: "apache",
        extensions: ["sv4crc"]
      },
      "application/x-t3vm-image": {
        source: "apache",
        extensions: ["t3"]
      },
      "application/x-tads": {
        source: "apache",
        extensions: ["gam"]
      },
      "application/x-tar": {
        source: "apache",
        compressible: true,
        extensions: ["tar"]
      },
      "application/x-tcl": {
        source: "apache",
        extensions: ["tcl", "tk"]
      },
      "application/x-tex": {
        source: "apache",
        extensions: ["tex"]
      },
      "application/x-tex-tfm": {
        source: "apache",
        extensions: ["tfm"]
      },
      "application/x-texinfo": {
        source: "apache",
        extensions: ["texinfo", "texi"]
      },
      "application/x-tgif": {
        source: "apache",
        extensions: ["obj"]
      },
      "application/x-ustar": {
        source: "apache",
        extensions: ["ustar"]
      },
      "application/x-virtualbox-hdd": {
        compressible: true,
        extensions: ["hdd"]
      },
      "application/x-virtualbox-ova": {
        compressible: true,
        extensions: ["ova"]
      },
      "application/x-virtualbox-ovf": {
        compressible: true,
        extensions: ["ovf"]
      },
      "application/x-virtualbox-vbox": {
        compressible: true,
        extensions: ["vbox"]
      },
      "application/x-virtualbox-vbox-extpack": {
        compressible: false,
        extensions: ["vbox-extpack"]
      },
      "application/x-virtualbox-vdi": {
        compressible: true,
        extensions: ["vdi"]
      },
      "application/x-virtualbox-vhd": {
        compressible: true,
        extensions: ["vhd"]
      },
      "application/x-virtualbox-vmdk": {
        compressible: true,
        extensions: ["vmdk"]
      },
      "application/x-wais-source": {
        source: "apache",
        extensions: ["src"]
      },
      "application/x-web-app-manifest+json": {
        compressible: true,
        extensions: ["webapp"]
      },
      "application/x-www-form-urlencoded": {
        source: "iana",
        compressible: true
      },
      "application/x-x509-ca-cert": {
        source: "iana",
        extensions: ["der", "crt", "pem"]
      },
      "application/x-x509-ca-ra-cert": {
        source: "iana"
      },
      "application/x-x509-next-ca-cert": {
        source: "iana"
      },
      "application/x-xfig": {
        source: "apache",
        extensions: ["fig"]
      },
      "application/x-xliff+xml": {
        source: "apache",
        compressible: true,
        extensions: ["xlf"]
      },
      "application/x-xpinstall": {
        source: "apache",
        compressible: false,
        extensions: ["xpi"]
      },
      "application/x-xz": {
        source: "apache",
        extensions: ["xz"]
      },
      "application/x-zmachine": {
        source: "apache",
        extensions: ["z1", "z2", "z3", "z4", "z5", "z6", "z7", "z8"]
      },
      "application/x400-bp": {
        source: "iana"
      },
      "application/xacml+xml": {
        source: "iana",
        compressible: true
      },
      "application/xaml+xml": {
        source: "apache",
        compressible: true,
        extensions: ["xaml"]
      },
      "application/xcap-att+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xav"]
      },
      "application/xcap-caps+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xca"]
      },
      "application/xcap-diff+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xdf"]
      },
      "application/xcap-el+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xel"]
      },
      "application/xcap-error+xml": {
        source: "iana",
        compressible: true
      },
      "application/xcap-ns+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xns"]
      },
      "application/xcon-conference-info+xml": {
        source: "iana",
        compressible: true
      },
      "application/xcon-conference-info-diff+xml": {
        source: "iana",
        compressible: true
      },
      "application/xenc+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xenc"]
      },
      "application/xhtml+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xhtml", "xht"]
      },
      "application/xhtml-voice+xml": {
        source: "apache",
        compressible: true
      },
      "application/xliff+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xlf"]
      },
      "application/xml": {
        source: "iana",
        compressible: true,
        extensions: ["xml", "xsl", "xsd", "rng"]
      },
      "application/xml-dtd": {
        source: "iana",
        compressible: true,
        extensions: ["dtd"]
      },
      "application/xml-external-parsed-entity": {
        source: "iana"
      },
      "application/xml-patch+xml": {
        source: "iana",
        compressible: true
      },
      "application/xmpp+xml": {
        source: "iana",
        compressible: true
      },
      "application/xop+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xop"]
      },
      "application/xproc+xml": {
        source: "apache",
        compressible: true,
        extensions: ["xpl"]
      },
      "application/xslt+xml": {
        source: "iana",
        compressible: true,
        extensions: ["xsl", "xslt"]
      },
      "application/xspf+xml": {
        source: "apache",
        compressible: true,
        extensions: ["xspf"]
      },
      "application/xv+xml": {
        source: "iana",
        compressible: true,
        extensions: ["mxml", "xhvml", "xvml", "xvm"]
      },
      "application/yang": {
        source: "iana",
        extensions: ["yang"]
      },
      "application/yang-data+json": {
        source: "iana",
        compressible: true
      },
      "application/yang-data+xml": {
        source: "iana",
        compressible: true
      },
      "application/yang-patch+json": {
        source: "iana",
        compressible: true
      },
      "application/yang-patch+xml": {
        source: "iana",
        compressible: true
      },
      "application/yin+xml": {
        source: "iana",
        compressible: true,
        extensions: ["yin"]
      },
      "application/zip": {
        source: "iana",
        compressible: false,
        extensions: ["zip"]
      },
      "application/zlib": {
        source: "iana"
      },
      "application/zstd": {
        source: "iana"
      },
      "audio/1d-interleaved-parityfec": {
        source: "iana"
      },
      "audio/32kadpcm": {
        source: "iana"
      },
      "audio/3gpp": {
        source: "iana",
        compressible: false,
        extensions: ["3gpp"]
      },
      "audio/3gpp2": {
        source: "iana"
      },
      "audio/aac": {
        source: "iana"
      },
      "audio/ac3": {
        source: "iana"
      },
      "audio/adpcm": {
        source: "apache",
        extensions: ["adp"]
      },
      "audio/amr": {
        source: "iana",
        extensions: ["amr"]
      },
      "audio/amr-wb": {
        source: "iana"
      },
      "audio/amr-wb+": {
        source: "iana"
      },
      "audio/aptx": {
        source: "iana"
      },
      "audio/asc": {
        source: "iana"
      },
      "audio/atrac-advanced-lossless": {
        source: "iana"
      },
      "audio/atrac-x": {
        source: "iana"
      },
      "audio/atrac3": {
        source: "iana"
      },
      "audio/basic": {
        source: "iana",
        compressible: false,
        extensions: ["au", "snd"]
      },
      "audio/bv16": {
        source: "iana"
      },
      "audio/bv32": {
        source: "iana"
      },
      "audio/clearmode": {
        source: "iana"
      },
      "audio/cn": {
        source: "iana"
      },
      "audio/dat12": {
        source: "iana"
      },
      "audio/dls": {
        source: "iana"
      },
      "audio/dsr-es201108": {
        source: "iana"
      },
      "audio/dsr-es202050": {
        source: "iana"
      },
      "audio/dsr-es202211": {
        source: "iana"
      },
      "audio/dsr-es202212": {
        source: "iana"
      },
      "audio/dv": {
        source: "iana"
      },
      "audio/dvi4": {
        source: "iana"
      },
      "audio/eac3": {
        source: "iana"
      },
      "audio/encaprtp": {
        source: "iana"
      },
      "audio/evrc": {
        source: "iana"
      },
      "audio/evrc-qcp": {
        source: "iana"
      },
      "audio/evrc0": {
        source: "iana"
      },
      "audio/evrc1": {
        source: "iana"
      },
      "audio/evrcb": {
        source: "iana"
      },
      "audio/evrcb0": {
        source: "iana"
      },
      "audio/evrcb1": {
        source: "iana"
      },
      "audio/evrcnw": {
        source: "iana"
      },
      "audio/evrcnw0": {
        source: "iana"
      },
      "audio/evrcnw1": {
        source: "iana"
      },
      "audio/evrcwb": {
        source: "iana"
      },
      "audio/evrcwb0": {
        source: "iana"
      },
      "audio/evrcwb1": {
        source: "iana"
      },
      "audio/evs": {
        source: "iana"
      },
      "audio/flexfec": {
        source: "iana"
      },
      "audio/fwdred": {
        source: "iana"
      },
      "audio/g711-0": {
        source: "iana"
      },
      "audio/g719": {
        source: "iana"
      },
      "audio/g722": {
        source: "iana"
      },
      "audio/g7221": {
        source: "iana"
      },
      "audio/g723": {
        source: "iana"
      },
      "audio/g726-16": {
        source: "iana"
      },
      "audio/g726-24": {
        source: "iana"
      },
      "audio/g726-32": {
        source: "iana"
      },
      "audio/g726-40": {
        source: "iana"
      },
      "audio/g728": {
        source: "iana"
      },
      "audio/g729": {
        source: "iana"
      },
      "audio/g7291": {
        source: "iana"
      },
      "audio/g729d": {
        source: "iana"
      },
      "audio/g729e": {
        source: "iana"
      },
      "audio/gsm": {
        source: "iana"
      },
      "audio/gsm-efr": {
        source: "iana"
      },
      "audio/gsm-hr-08": {
        source: "iana"
      },
      "audio/ilbc": {
        source: "iana"
      },
      "audio/ip-mr_v2.5": {
        source: "iana"
      },
      "audio/isac": {
        source: "apache"
      },
      "audio/l16": {
        source: "iana"
      },
      "audio/l20": {
        source: "iana"
      },
      "audio/l24": {
        source: "iana",
        compressible: false
      },
      "audio/l8": {
        source: "iana"
      },
      "audio/lpc": {
        source: "iana"
      },
      "audio/melp": {
        source: "iana"
      },
      "audio/melp1200": {
        source: "iana"
      },
      "audio/melp2400": {
        source: "iana"
      },
      "audio/melp600": {
        source: "iana"
      },
      "audio/mhas": {
        source: "iana"
      },
      "audio/midi": {
        source: "apache",
        extensions: ["mid", "midi", "kar", "rmi"]
      },
      "audio/mobile-xmf": {
        source: "iana",
        extensions: ["mxmf"]
      },
      "audio/mp3": {
        compressible: false,
        extensions: ["mp3"]
      },
      "audio/mp4": {
        source: "iana",
        compressible: false,
        extensions: ["m4a", "mp4a"]
      },
      "audio/mp4a-latm": {
        source: "iana"
      },
      "audio/mpa": {
        source: "iana"
      },
      "audio/mpa-robust": {
        source: "iana"
      },
      "audio/mpeg": {
        source: "iana",
        compressible: false,
        extensions: ["mpga", "mp2", "mp2a", "mp3", "m2a", "m3a"]
      },
      "audio/mpeg4-generic": {
        source: "iana"
      },
      "audio/musepack": {
        source: "apache"
      },
      "audio/ogg": {
        source: "iana",
        compressible: false,
        extensions: ["oga", "ogg", "spx", "opus"]
      },
      "audio/opus": {
        source: "iana"
      },
      "audio/parityfec": {
        source: "iana"
      },
      "audio/pcma": {
        source: "iana"
      },
      "audio/pcma-wb": {
        source: "iana"
      },
      "audio/pcmu": {
        source: "iana"
      },
      "audio/pcmu-wb": {
        source: "iana"
      },
      "audio/prs.sid": {
        source: "iana"
      },
      "audio/qcelp": {
        source: "iana"
      },
      "audio/raptorfec": {
        source: "iana"
      },
      "audio/red": {
        source: "iana"
      },
      "audio/rtp-enc-aescm128": {
        source: "iana"
      },
      "audio/rtp-midi": {
        source: "iana"
      },
      "audio/rtploopback": {
        source: "iana"
      },
      "audio/rtx": {
        source: "iana"
      },
      "audio/s3m": {
        source: "apache",
        extensions: ["s3m"]
      },
      "audio/scip": {
        source: "iana"
      },
      "audio/silk": {
        source: "apache",
        extensions: ["sil"]
      },
      "audio/smv": {
        source: "iana"
      },
      "audio/smv-qcp": {
        source: "iana"
      },
      "audio/smv0": {
        source: "iana"
      },
      "audio/sofa": {
        source: "iana"
      },
      "audio/sp-midi": {
        source: "iana"
      },
      "audio/speex": {
        source: "iana"
      },
      "audio/t140c": {
        source: "iana"
      },
      "audio/t38": {
        source: "iana"
      },
      "audio/telephone-event": {
        source: "iana"
      },
      "audio/tetra_acelp": {
        source: "iana"
      },
      "audio/tetra_acelp_bb": {
        source: "iana"
      },
      "audio/tone": {
        source: "iana"
      },
      "audio/tsvcis": {
        source: "iana"
      },
      "audio/uemclip": {
        source: "iana"
      },
      "audio/ulpfec": {
        source: "iana"
      },
      "audio/usac": {
        source: "iana"
      },
      "audio/vdvi": {
        source: "iana"
      },
      "audio/vmr-wb": {
        source: "iana"
      },
      "audio/vnd.3gpp.iufp": {
        source: "iana"
      },
      "audio/vnd.4sb": {
        source: "iana"
      },
      "audio/vnd.audiokoz": {
        source: "iana"
      },
      "audio/vnd.celp": {
        source: "iana"
      },
      "audio/vnd.cisco.nse": {
        source: "iana"
      },
      "audio/vnd.cmles.radio-events": {
        source: "iana"
      },
      "audio/vnd.cns.anp1": {
        source: "iana"
      },
      "audio/vnd.cns.inf1": {
        source: "iana"
      },
      "audio/vnd.dece.audio": {
        source: "iana",
        extensions: ["uva", "uvva"]
      },
      "audio/vnd.digital-winds": {
        source: "iana",
        extensions: ["eol"]
      },
      "audio/vnd.dlna.adts": {
        source: "iana"
      },
      "audio/vnd.dolby.heaac.1": {
        source: "iana"
      },
      "audio/vnd.dolby.heaac.2": {
        source: "iana"
      },
      "audio/vnd.dolby.mlp": {
        source: "iana"
      },
      "audio/vnd.dolby.mps": {
        source: "iana"
      },
      "audio/vnd.dolby.pl2": {
        source: "iana"
      },
      "audio/vnd.dolby.pl2x": {
        source: "iana"
      },
      "audio/vnd.dolby.pl2z": {
        source: "iana"
      },
      "audio/vnd.dolby.pulse.1": {
        source: "iana"
      },
      "audio/vnd.dra": {
        source: "iana",
        extensions: ["dra"]
      },
      "audio/vnd.dts": {
        source: "iana",
        extensions: ["dts"]
      },
      "audio/vnd.dts.hd": {
        source: "iana",
        extensions: ["dtshd"]
      },
      "audio/vnd.dts.uhd": {
        source: "iana"
      },
      "audio/vnd.dvb.file": {
        source: "iana"
      },
      "audio/vnd.everad.plj": {
        source: "iana"
      },
      "audio/vnd.hns.audio": {
        source: "iana"
      },
      "audio/vnd.lucent.voice": {
        source: "iana",
        extensions: ["lvp"]
      },
      "audio/vnd.ms-playready.media.pya": {
        source: "iana",
        extensions: ["pya"]
      },
      "audio/vnd.nokia.mobile-xmf": {
        source: "iana"
      },
      "audio/vnd.nortel.vbk": {
        source: "iana"
      },
      "audio/vnd.nuera.ecelp4800": {
        source: "iana",
        extensions: ["ecelp4800"]
      },
      "audio/vnd.nuera.ecelp7470": {
        source: "iana",
        extensions: ["ecelp7470"]
      },
      "audio/vnd.nuera.ecelp9600": {
        source: "iana",
        extensions: ["ecelp9600"]
      },
      "audio/vnd.octel.sbc": {
        source: "iana"
      },
      "audio/vnd.presonus.multitrack": {
        source: "iana"
      },
      "audio/vnd.qcelp": {
        source: "iana"
      },
      "audio/vnd.rhetorex.32kadpcm": {
        source: "iana"
      },
      "audio/vnd.rip": {
        source: "iana",
        extensions: ["rip"]
      },
      "audio/vnd.rn-realaudio": {
        compressible: false
      },
      "audio/vnd.sealedmedia.softseal.mpeg": {
        source: "iana"
      },
      "audio/vnd.vmx.cvsd": {
        source: "iana"
      },
      "audio/vnd.wave": {
        compressible: false
      },
      "audio/vorbis": {
        source: "iana",
        compressible: false
      },
      "audio/vorbis-config": {
        source: "iana"
      },
      "audio/wav": {
        compressible: false,
        extensions: ["wav"]
      },
      "audio/wave": {
        compressible: false,
        extensions: ["wav"]
      },
      "audio/webm": {
        source: "apache",
        compressible: false,
        extensions: ["weba"]
      },
      "audio/x-aac": {
        source: "apache",
        compressible: false,
        extensions: ["aac"]
      },
      "audio/x-aiff": {
        source: "apache",
        extensions: ["aif", "aiff", "aifc"]
      },
      "audio/x-caf": {
        source: "apache",
        compressible: false,
        extensions: ["caf"]
      },
      "audio/x-flac": {
        source: "apache",
        extensions: ["flac"]
      },
      "audio/x-m4a": {
        source: "nginx",
        extensions: ["m4a"]
      },
      "audio/x-matroska": {
        source: "apache",
        extensions: ["mka"]
      },
      "audio/x-mpegurl": {
        source: "apache",
        extensions: ["m3u"]
      },
      "audio/x-ms-wax": {
        source: "apache",
        extensions: ["wax"]
      },
      "audio/x-ms-wma": {
        source: "apache",
        extensions: ["wma"]
      },
      "audio/x-pn-realaudio": {
        source: "apache",
        extensions: ["ram", "ra"]
      },
      "audio/x-pn-realaudio-plugin": {
        source: "apache",
        extensions: ["rmp"]
      },
      "audio/x-realaudio": {
        source: "nginx",
        extensions: ["ra"]
      },
      "audio/x-tta": {
        source: "apache"
      },
      "audio/x-wav": {
        source: "apache",
        extensions: ["wav"]
      },
      "audio/xm": {
        source: "apache",
        extensions: ["xm"]
      },
      "chemical/x-cdx": {
        source: "apache",
        extensions: ["cdx"]
      },
      "chemical/x-cif": {
        source: "apache",
        extensions: ["cif"]
      },
      "chemical/x-cmdf": {
        source: "apache",
        extensions: ["cmdf"]
      },
      "chemical/x-cml": {
        source: "apache",
        extensions: ["cml"]
      },
      "chemical/x-csml": {
        source: "apache",
        extensions: ["csml"]
      },
      "chemical/x-pdb": {
        source: "apache"
      },
      "chemical/x-xyz": {
        source: "apache",
        extensions: ["xyz"]
      },
      "font/collection": {
        source: "iana",
        extensions: ["ttc"]
      },
      "font/otf": {
        source: "iana",
        compressible: true,
        extensions: ["otf"]
      },
      "font/sfnt": {
        source: "iana"
      },
      "font/ttf": {
        source: "iana",
        compressible: true,
        extensions: ["ttf"]
      },
      "font/woff": {
        source: "iana",
        extensions: ["woff"]
      },
      "font/woff2": {
        source: "iana",
        extensions: ["woff2"]
      },
      "image/aces": {
        source: "iana",
        extensions: ["exr"]
      },
      "image/apng": {
        compressible: false,
        extensions: ["apng"]
      },
      "image/avci": {
        source: "iana",
        extensions: ["avci"]
      },
      "image/avcs": {
        source: "iana",
        extensions: ["avcs"]
      },
      "image/avif": {
        source: "iana",
        compressible: false,
        extensions: ["avif"]
      },
      "image/bmp": {
        source: "iana",
        compressible: true,
        extensions: ["bmp"]
      },
      "image/cgm": {
        source: "iana",
        extensions: ["cgm"]
      },
      "image/dicom-rle": {
        source: "iana",
        extensions: ["drle"]
      },
      "image/emf": {
        source: "iana",
        extensions: ["emf"]
      },
      "image/fits": {
        source: "iana",
        extensions: ["fits"]
      },
      "image/g3fax": {
        source: "iana",
        extensions: ["g3"]
      },
      "image/gif": {
        source: "iana",
        compressible: false,
        extensions: ["gif"]
      },
      "image/heic": {
        source: "iana",
        extensions: ["heic"]
      },
      "image/heic-sequence": {
        source: "iana",
        extensions: ["heics"]
      },
      "image/heif": {
        source: "iana",
        extensions: ["heif"]
      },
      "image/heif-sequence": {
        source: "iana",
        extensions: ["heifs"]
      },
      "image/hej2k": {
        source: "iana",
        extensions: ["hej2"]
      },
      "image/hsj2": {
        source: "iana",
        extensions: ["hsj2"]
      },
      "image/ief": {
        source: "iana",
        extensions: ["ief"]
      },
      "image/jls": {
        source: "iana",
        extensions: ["jls"]
      },
      "image/jp2": {
        source: "iana",
        compressible: false,
        extensions: ["jp2", "jpg2"]
      },
      "image/jpeg": {
        source: "iana",
        compressible: false,
        extensions: ["jpeg", "jpg", "jpe"]
      },
      "image/jph": {
        source: "iana",
        extensions: ["jph"]
      },
      "image/jphc": {
        source: "iana",
        extensions: ["jhc"]
      },
      "image/jpm": {
        source: "iana",
        compressible: false,
        extensions: ["jpm"]
      },
      "image/jpx": {
        source: "iana",
        compressible: false,
        extensions: ["jpx", "jpf"]
      },
      "image/jxr": {
        source: "iana",
        extensions: ["jxr"]
      },
      "image/jxra": {
        source: "iana",
        extensions: ["jxra"]
      },
      "image/jxrs": {
        source: "iana",
        extensions: ["jxrs"]
      },
      "image/jxs": {
        source: "iana",
        extensions: ["jxs"]
      },
      "image/jxsc": {
        source: "iana",
        extensions: ["jxsc"]
      },
      "image/jxsi": {
        source: "iana",
        extensions: ["jxsi"]
      },
      "image/jxss": {
        source: "iana",
        extensions: ["jxss"]
      },
      "image/ktx": {
        source: "iana",
        extensions: ["ktx"]
      },
      "image/ktx2": {
        source: "iana",
        extensions: ["ktx2"]
      },
      "image/naplps": {
        source: "iana"
      },
      "image/pjpeg": {
        compressible: false
      },
      "image/png": {
        source: "iana",
        compressible: false,
        extensions: ["png"]
      },
      "image/prs.btif": {
        source: "iana",
        extensions: ["btif"]
      },
      "image/prs.pti": {
        source: "iana",
        extensions: ["pti"]
      },
      "image/pwg-raster": {
        source: "iana"
      },
      "image/sgi": {
        source: "apache",
        extensions: ["sgi"]
      },
      "image/svg+xml": {
        source: "iana",
        compressible: true,
        extensions: ["svg", "svgz"]
      },
      "image/t38": {
        source: "iana",
        extensions: ["t38"]
      },
      "image/tiff": {
        source: "iana",
        compressible: false,
        extensions: ["tif", "tiff"]
      },
      "image/tiff-fx": {
        source: "iana",
        extensions: ["tfx"]
      },
      "image/vnd.adobe.photoshop": {
        source: "iana",
        compressible: true,
        extensions: ["psd"]
      },
      "image/vnd.airzip.accelerator.azv": {
        source: "iana",
        extensions: ["azv"]
      },
      "image/vnd.cns.inf2": {
        source: "iana"
      },
      "image/vnd.dece.graphic": {
        source: "iana",
        extensions: ["uvi", "uvvi", "uvg", "uvvg"]
      },
      "image/vnd.djvu": {
        source: "iana",
        extensions: ["djvu", "djv"]
      },
      "image/vnd.dvb.subtitle": {
        source: "iana",
        extensions: ["sub"]
      },
      "image/vnd.dwg": {
        source: "iana",
        extensions: ["dwg"]
      },
      "image/vnd.dxf": {
        source: "iana",
        extensions: ["dxf"]
      },
      "image/vnd.fastbidsheet": {
        source: "iana",
        extensions: ["fbs"]
      },
      "image/vnd.fpx": {
        source: "iana",
        extensions: ["fpx"]
      },
      "image/vnd.fst": {
        source: "iana",
        extensions: ["fst"]
      },
      "image/vnd.fujixerox.edmics-mmr": {
        source: "iana",
        extensions: ["mmr"]
      },
      "image/vnd.fujixerox.edmics-rlc": {
        source: "iana",
        extensions: ["rlc"]
      },
      "image/vnd.globalgraphics.pgb": {
        source: "iana"
      },
      "image/vnd.microsoft.icon": {
        source: "iana",
        compressible: true,
        extensions: ["ico"]
      },
      "image/vnd.mix": {
        source: "iana"
      },
      "image/vnd.mozilla.apng": {
        source: "iana"
      },
      "image/vnd.ms-dds": {
        compressible: true,
        extensions: ["dds"]
      },
      "image/vnd.ms-modi": {
        source: "iana",
        extensions: ["mdi"]
      },
      "image/vnd.ms-photo": {
        source: "apache",
        extensions: ["wdp"]
      },
      "image/vnd.net-fpx": {
        source: "iana",
        extensions: ["npx"]
      },
      "image/vnd.pco.b16": {
        source: "iana",
        extensions: ["b16"]
      },
      "image/vnd.radiance": {
        source: "iana"
      },
      "image/vnd.sealed.png": {
        source: "iana"
      },
      "image/vnd.sealedmedia.softseal.gif": {
        source: "iana"
      },
      "image/vnd.sealedmedia.softseal.jpg": {
        source: "iana"
      },
      "image/vnd.svf": {
        source: "iana"
      },
      "image/vnd.tencent.tap": {
        source: "iana",
        extensions: ["tap"]
      },
      "image/vnd.valve.source.texture": {
        source: "iana",
        extensions: ["vtf"]
      },
      "image/vnd.wap.wbmp": {
        source: "iana",
        extensions: ["wbmp"]
      },
      "image/vnd.xiff": {
        source: "iana",
        extensions: ["xif"]
      },
      "image/vnd.zbrush.pcx": {
        source: "iana",
        extensions: ["pcx"]
      },
      "image/webp": {
        source: "apache",
        extensions: ["webp"]
      },
      "image/wmf": {
        source: "iana",
        extensions: ["wmf"]
      },
      "image/x-3ds": {
        source: "apache",
        extensions: ["3ds"]
      },
      "image/x-cmu-raster": {
        source: "apache",
        extensions: ["ras"]
      },
      "image/x-cmx": {
        source: "apache",
        extensions: ["cmx"]
      },
      "image/x-freehand": {
        source: "apache",
        extensions: ["fh", "fhc", "fh4", "fh5", "fh7"]
      },
      "image/x-icon": {
        source: "apache",
        compressible: true,
        extensions: ["ico"]
      },
      "image/x-jng": {
        source: "nginx",
        extensions: ["jng"]
      },
      "image/x-mrsid-image": {
        source: "apache",
        extensions: ["sid"]
      },
      "image/x-ms-bmp": {
        source: "nginx",
        compressible: true,
        extensions: ["bmp"]
      },
      "image/x-pcx": {
        source: "apache",
        extensions: ["pcx"]
      },
      "image/x-pict": {
        source: "apache",
        extensions: ["pic", "pct"]
      },
      "image/x-portable-anymap": {
        source: "apache",
        extensions: ["pnm"]
      },
      "image/x-portable-bitmap": {
        source: "apache",
        extensions: ["pbm"]
      },
      "image/x-portable-graymap": {
        source: "apache",
        extensions: ["pgm"]
      },
      "image/x-portable-pixmap": {
        source: "apache",
        extensions: ["ppm"]
      },
      "image/x-rgb": {
        source: "apache",
        extensions: ["rgb"]
      },
      "image/x-tga": {
        source: "apache",
        extensions: ["tga"]
      },
      "image/x-xbitmap": {
        source: "apache",
        extensions: ["xbm"]
      },
      "image/x-xcf": {
        compressible: false
      },
      "image/x-xpixmap": {
        source: "apache",
        extensions: ["xpm"]
      },
      "image/x-xwindowdump": {
        source: "apache",
        extensions: ["xwd"]
      },
      "message/cpim": {
        source: "iana"
      },
      "message/delivery-status": {
        source: "iana"
      },
      "message/disposition-notification": {
        source: "iana",
        extensions: [
          "disposition-notification"
        ]
      },
      "message/external-body": {
        source: "iana"
      },
      "message/feedback-report": {
        source: "iana"
      },
      "message/global": {
        source: "iana",
        extensions: ["u8msg"]
      },
      "message/global-delivery-status": {
        source: "iana",
        extensions: ["u8dsn"]
      },
      "message/global-disposition-notification": {
        source: "iana",
        extensions: ["u8mdn"]
      },
      "message/global-headers": {
        source: "iana",
        extensions: ["u8hdr"]
      },
      "message/http": {
        source: "iana",
        compressible: false
      },
      "message/imdn+xml": {
        source: "iana",
        compressible: true
      },
      "message/news": {
        source: "iana"
      },
      "message/partial": {
        source: "iana",
        compressible: false
      },
      "message/rfc822": {
        source: "iana",
        compressible: true,
        extensions: ["eml", "mime"]
      },
      "message/s-http": {
        source: "iana"
      },
      "message/sip": {
        source: "iana"
      },
      "message/sipfrag": {
        source: "iana"
      },
      "message/tracking-status": {
        source: "iana"
      },
      "message/vnd.si.simp": {
        source: "iana"
      },
      "message/vnd.wfa.wsc": {
        source: "iana",
        extensions: ["wsc"]
      },
      "model/3mf": {
        source: "iana",
        extensions: ["3mf"]
      },
      "model/e57": {
        source: "iana"
      },
      "model/gltf+json": {
        source: "iana",
        compressible: true,
        extensions: ["gltf"]
      },
      "model/gltf-binary": {
        source: "iana",
        compressible: true,
        extensions: ["glb"]
      },
      "model/iges": {
        source: "iana",
        compressible: false,
        extensions: ["igs", "iges"]
      },
      "model/mesh": {
        source: "iana",
        compressible: false,
        extensions: ["msh", "mesh", "silo"]
      },
      "model/mtl": {
        source: "iana",
        extensions: ["mtl"]
      },
      "model/obj": {
        source: "iana",
        extensions: ["obj"]
      },
      "model/step": {
        source: "iana"
      },
      "model/step+xml": {
        source: "iana",
        compressible: true,
        extensions: ["stpx"]
      },
      "model/step+zip": {
        source: "iana",
        compressible: false,
        extensions: ["stpz"]
      },
      "model/step-xml+zip": {
        source: "iana",
        compressible: false,
        extensions: ["stpxz"]
      },
      "model/stl": {
        source: "iana",
        extensions: ["stl"]
      },
      "model/vnd.collada+xml": {
        source: "iana",
        compressible: true,
        extensions: ["dae"]
      },
      "model/vnd.dwf": {
        source: "iana",
        extensions: ["dwf"]
      },
      "model/vnd.flatland.3dml": {
        source: "iana"
      },
      "model/vnd.gdl": {
        source: "iana",
        extensions: ["gdl"]
      },
      "model/vnd.gs-gdl": {
        source: "apache"
      },
      "model/vnd.gs.gdl": {
        source: "iana"
      },
      "model/vnd.gtw": {
        source: "iana",
        extensions: ["gtw"]
      },
      "model/vnd.moml+xml": {
        source: "iana",
        compressible: true
      },
      "model/vnd.mts": {
        source: "iana",
        extensions: ["mts"]
      },
      "model/vnd.opengex": {
        source: "iana",
        extensions: ["ogex"]
      },
      "model/vnd.parasolid.transmit.binary": {
        source: "iana",
        extensions: ["x_b"]
      },
      "model/vnd.parasolid.transmit.text": {
        source: "iana",
        extensions: ["x_t"]
      },
      "model/vnd.pytha.pyox": {
        source: "iana"
      },
      "model/vnd.rosette.annotated-data-model": {
        source: "iana"
      },
      "model/vnd.sap.vds": {
        source: "iana",
        extensions: ["vds"]
      },
      "model/vnd.usdz+zip": {
        source: "iana",
        compressible: false,
        extensions: ["usdz"]
      },
      "model/vnd.valve.source.compiled-map": {
        source: "iana",
        extensions: ["bsp"]
      },
      "model/vnd.vtu": {
        source: "iana",
        extensions: ["vtu"]
      },
      "model/vrml": {
        source: "iana",
        compressible: false,
        extensions: ["wrl", "vrml"]
      },
      "model/x3d+binary": {
        source: "apache",
        compressible: false,
        extensions: ["x3db", "x3dbz"]
      },
      "model/x3d+fastinfoset": {
        source: "iana",
        extensions: ["x3db"]
      },
      "model/x3d+vrml": {
        source: "apache",
        compressible: false,
        extensions: ["x3dv", "x3dvz"]
      },
      "model/x3d+xml": {
        source: "iana",
        compressible: true,
        extensions: ["x3d", "x3dz"]
      },
      "model/x3d-vrml": {
        source: "iana",
        extensions: ["x3dv"]
      },
      "multipart/alternative": {
        source: "iana",
        compressible: false
      },
      "multipart/appledouble": {
        source: "iana"
      },
      "multipart/byteranges": {
        source: "iana"
      },
      "multipart/digest": {
        source: "iana"
      },
      "multipart/encrypted": {
        source: "iana",
        compressible: false
      },
      "multipart/form-data": {
        source: "iana",
        compressible: false
      },
      "multipart/header-set": {
        source: "iana"
      },
      "multipart/mixed": {
        source: "iana"
      },
      "multipart/multilingual": {
        source: "iana"
      },
      "multipart/parallel": {
        source: "iana"
      },
      "multipart/related": {
        source: "iana",
        compressible: false
      },
      "multipart/report": {
        source: "iana"
      },
      "multipart/signed": {
        source: "iana",
        compressible: false
      },
      "multipart/vnd.bint.med-plus": {
        source: "iana"
      },
      "multipart/voice-message": {
        source: "iana"
      },
      "multipart/x-mixed-replace": {
        source: "iana"
      },
      "text/1d-interleaved-parityfec": {
        source: "iana"
      },
      "text/cache-manifest": {
        source: "iana",
        compressible: true,
        extensions: ["appcache", "manifest"]
      },
      "text/calendar": {
        source: "iana",
        extensions: ["ics", "ifb"]
      },
      "text/calender": {
        compressible: true
      },
      "text/cmd": {
        compressible: true
      },
      "text/coffeescript": {
        extensions: ["coffee", "litcoffee"]
      },
      "text/cql": {
        source: "iana"
      },
      "text/cql-expression": {
        source: "iana"
      },
      "text/cql-identifier": {
        source: "iana"
      },
      "text/css": {
        source: "iana",
        charset: "UTF-8",
        compressible: true,
        extensions: ["css"]
      },
      "text/csv": {
        source: "iana",
        compressible: true,
        extensions: ["csv"]
      },
      "text/csv-schema": {
        source: "iana"
      },
      "text/directory": {
        source: "iana"
      },
      "text/dns": {
        source: "iana"
      },
      "text/ecmascript": {
        source: "iana"
      },
      "text/encaprtp": {
        source: "iana"
      },
      "text/enriched": {
        source: "iana"
      },
      "text/fhirpath": {
        source: "iana"
      },
      "text/flexfec": {
        source: "iana"
      },
      "text/fwdred": {
        source: "iana"
      },
      "text/gff3": {
        source: "iana"
      },
      "text/grammar-ref-list": {
        source: "iana"
      },
      "text/html": {
        source: "iana",
        compressible: true,
        extensions: ["html", "htm", "shtml"]
      },
      "text/jade": {
        extensions: ["jade"]
      },
      "text/javascript": {
        source: "iana",
        compressible: true
      },
      "text/jcr-cnd": {
        source: "iana"
      },
      "text/jsx": {
        compressible: true,
        extensions: ["jsx"]
      },
      "text/less": {
        compressible: true,
        extensions: ["less"]
      },
      "text/markdown": {
        source: "iana",
        compressible: true,
        extensions: ["markdown", "md"]
      },
      "text/mathml": {
        source: "nginx",
        extensions: ["mml"]
      },
      "text/mdx": {
        compressible: true,
        extensions: ["mdx"]
      },
      "text/mizar": {
        source: "iana"
      },
      "text/n3": {
        source: "iana",
        charset: "UTF-8",
        compressible: true,
        extensions: ["n3"]
      },
      "text/parameters": {
        source: "iana",
        charset: "UTF-8"
      },
      "text/parityfec": {
        source: "iana"
      },
      "text/plain": {
        source: "iana",
        compressible: true,
        extensions: ["txt", "text", "conf", "def", "list", "log", "in", "ini"]
      },
      "text/provenance-notation": {
        source: "iana",
        charset: "UTF-8"
      },
      "text/prs.fallenstein.rst": {
        source: "iana"
      },
      "text/prs.lines.tag": {
        source: "iana",
        extensions: ["dsc"]
      },
      "text/prs.prop.logic": {
        source: "iana"
      },
      "text/raptorfec": {
        source: "iana"
      },
      "text/red": {
        source: "iana"
      },
      "text/rfc822-headers": {
        source: "iana"
      },
      "text/richtext": {
        source: "iana",
        compressible: true,
        extensions: ["rtx"]
      },
      "text/rtf": {
        source: "iana",
        compressible: true,
        extensions: ["rtf"]
      },
      "text/rtp-enc-aescm128": {
        source: "iana"
      },
      "text/rtploopback": {
        source: "iana"
      },
      "text/rtx": {
        source: "iana"
      },
      "text/sgml": {
        source: "iana",
        extensions: ["sgml", "sgm"]
      },
      "text/shaclc": {
        source: "iana"
      },
      "text/shex": {
        source: "iana",
        extensions: ["shex"]
      },
      "text/slim": {
        extensions: ["slim", "slm"]
      },
      "text/spdx": {
        source: "iana",
        extensions: ["spdx"]
      },
      "text/strings": {
        source: "iana"
      },
      "text/stylus": {
        extensions: ["stylus", "styl"]
      },
      "text/t140": {
        source: "iana"
      },
      "text/tab-separated-values": {
        source: "iana",
        compressible: true,
        extensions: ["tsv"]
      },
      "text/troff": {
        source: "iana",
        extensions: ["t", "tr", "roff", "man", "me", "ms"]
      },
      "text/turtle": {
        source: "iana",
        charset: "UTF-8",
        extensions: ["ttl"]
      },
      "text/ulpfec": {
        source: "iana"
      },
      "text/uri-list": {
        source: "iana",
        compressible: true,
        extensions: ["uri", "uris", "urls"]
      },
      "text/vcard": {
        source: "iana",
        compressible: true,
        extensions: ["vcard"]
      },
      "text/vnd.a": {
        source: "iana"
      },
      "text/vnd.abc": {
        source: "iana"
      },
      "text/vnd.ascii-art": {
        source: "iana"
      },
      "text/vnd.curl": {
        source: "iana",
        extensions: ["curl"]
      },
      "text/vnd.curl.dcurl": {
        source: "apache",
        extensions: ["dcurl"]
      },
      "text/vnd.curl.mcurl": {
        source: "apache",
        extensions: ["mcurl"]
      },
      "text/vnd.curl.scurl": {
        source: "apache",
        extensions: ["scurl"]
      },
      "text/vnd.debian.copyright": {
        source: "iana",
        charset: "UTF-8"
      },
      "text/vnd.dmclientscript": {
        source: "iana"
      },
      "text/vnd.dvb.subtitle": {
        source: "iana",
        extensions: ["sub"]
      },
      "text/vnd.esmertec.theme-descriptor": {
        source: "iana",
        charset: "UTF-8"
      },
      "text/vnd.familysearch.gedcom": {
        source: "iana",
        extensions: ["ged"]
      },
      "text/vnd.ficlab.flt": {
        source: "iana"
      },
      "text/vnd.fly": {
        source: "iana",
        extensions: ["fly"]
      },
      "text/vnd.fmi.flexstor": {
        source: "iana",
        extensions: ["flx"]
      },
      "text/vnd.gml": {
        source: "iana"
      },
      "text/vnd.graphviz": {
        source: "iana",
        extensions: ["gv"]
      },
      "text/vnd.hans": {
        source: "iana"
      },
      "text/vnd.hgl": {
        source: "iana"
      },
      "text/vnd.in3d.3dml": {
        source: "iana",
        extensions: ["3dml"]
      },
      "text/vnd.in3d.spot": {
        source: "iana",
        extensions: ["spot"]
      },
      "text/vnd.iptc.newsml": {
        source: "iana"
      },
      "text/vnd.iptc.nitf": {
        source: "iana"
      },
      "text/vnd.latex-z": {
        source: "iana"
      },
      "text/vnd.motorola.reflex": {
        source: "iana"
      },
      "text/vnd.ms-mediapackage": {
        source: "iana"
      },
      "text/vnd.net2phone.commcenter.command": {
        source: "iana"
      },
      "text/vnd.radisys.msml-basic-layout": {
        source: "iana"
      },
      "text/vnd.senx.warpscript": {
        source: "iana"
      },
      "text/vnd.si.uricatalogue": {
        source: "iana"
      },
      "text/vnd.sosi": {
        source: "iana"
      },
      "text/vnd.sun.j2me.app-descriptor": {
        source: "iana",
        charset: "UTF-8",
        extensions: ["jad"]
      },
      "text/vnd.trolltech.linguist": {
        source: "iana",
        charset: "UTF-8"
      },
      "text/vnd.wap.si": {
        source: "iana"
      },
      "text/vnd.wap.sl": {
        source: "iana"
      },
      "text/vnd.wap.wml": {
        source: "iana",
        extensions: ["wml"]
      },
      "text/vnd.wap.wmlscript": {
        source: "iana",
        extensions: ["wmls"]
      },
      "text/vtt": {
        source: "iana",
        charset: "UTF-8",
        compressible: true,
        extensions: ["vtt"]
      },
      "text/x-asm": {
        source: "apache",
        extensions: ["s", "asm"]
      },
      "text/x-c": {
        source: "apache",
        extensions: ["c", "cc", "cxx", "cpp", "h", "hh", "dic"]
      },
      "text/x-component": {
        source: "nginx",
        extensions: ["htc"]
      },
      "text/x-fortran": {
        source: "apache",
        extensions: ["f", "for", "f77", "f90"]
      },
      "text/x-gwt-rpc": {
        compressible: true
      },
      "text/x-handlebars-template": {
        extensions: ["hbs"]
      },
      "text/x-java-source": {
        source: "apache",
        extensions: ["java"]
      },
      "text/x-jquery-tmpl": {
        compressible: true
      },
      "text/x-lua": {
        extensions: ["lua"]
      },
      "text/x-markdown": {
        compressible: true,
        extensions: ["mkd"]
      },
      "text/x-nfo": {
        source: "apache",
        extensions: ["nfo"]
      },
      "text/x-opml": {
        source: "apache",
        extensions: ["opml"]
      },
      "text/x-org": {
        compressible: true,
        extensions: ["org"]
      },
      "text/x-pascal": {
        source: "apache",
        extensions: ["p", "pas"]
      },
      "text/x-processing": {
        compressible: true,
        extensions: ["pde"]
      },
      "text/x-sass": {
        extensions: ["sass"]
      },
      "text/x-scss": {
        extensions: ["scss"]
      },
      "text/x-setext": {
        source: "apache",
        extensions: ["etx"]
      },
      "text/x-sfv": {
        source: "apache",
        extensions: ["sfv"]
      },
      "text/x-suse-ymp": {
        compressible: true,
        extensions: ["ymp"]
      },
      "text/x-uuencode": {
        source: "apache",
        extensions: ["uu"]
      },
      "text/x-vcalendar": {
        source: "apache",
        extensions: ["vcs"]
      },
      "text/x-vcard": {
        source: "apache",
        extensions: ["vcf"]
      },
      "text/xml": {
        source: "iana",
        compressible: true,
        extensions: ["xml"]
      },
      "text/xml-external-parsed-entity": {
        source: "iana"
      },
      "text/yaml": {
        compressible: true,
        extensions: ["yaml", "yml"]
      },
      "video/1d-interleaved-parityfec": {
        source: "iana"
      },
      "video/3gpp": {
        source: "iana",
        extensions: ["3gp", "3gpp"]
      },
      "video/3gpp-tt": {
        source: "iana"
      },
      "video/3gpp2": {
        source: "iana",
        extensions: ["3g2"]
      },
      "video/av1": {
        source: "iana"
      },
      "video/bmpeg": {
        source: "iana"
      },
      "video/bt656": {
        source: "iana"
      },
      "video/celb": {
        source: "iana"
      },
      "video/dv": {
        source: "iana"
      },
      "video/encaprtp": {
        source: "iana"
      },
      "video/ffv1": {
        source: "iana"
      },
      "video/flexfec": {
        source: "iana"
      },
      "video/h261": {
        source: "iana",
        extensions: ["h261"]
      },
      "video/h263": {
        source: "iana",
        extensions: ["h263"]
      },
      "video/h263-1998": {
        source: "iana"
      },
      "video/h263-2000": {
        source: "iana"
      },
      "video/h264": {
        source: "iana",
        extensions: ["h264"]
      },
      "video/h264-rcdo": {
        source: "iana"
      },
      "video/h264-svc": {
        source: "iana"
      },
      "video/h265": {
        source: "iana"
      },
      "video/iso.segment": {
        source: "iana",
        extensions: ["m4s"]
      },
      "video/jpeg": {
        source: "iana",
        extensions: ["jpgv"]
      },
      "video/jpeg2000": {
        source: "iana"
      },
      "video/jpm": {
        source: "apache",
        extensions: ["jpm", "jpgm"]
      },
      "video/jxsv": {
        source: "iana"
      },
      "video/mj2": {
        source: "iana",
        extensions: ["mj2", "mjp2"]
      },
      "video/mp1s": {
        source: "iana"
      },
      "video/mp2p": {
        source: "iana"
      },
      "video/mp2t": {
        source: "iana",
        extensions: ["ts"]
      },
      "video/mp4": {
        source: "iana",
        compressible: false,
        extensions: ["mp4", "mp4v", "mpg4"]
      },
      "video/mp4v-es": {
        source: "iana"
      },
      "video/mpeg": {
        source: "iana",
        compressible: false,
        extensions: ["mpeg", "mpg", "mpe", "m1v", "m2v"]
      },
      "video/mpeg4-generic": {
        source: "iana"
      },
      "video/mpv": {
        source: "iana"
      },
      "video/nv": {
        source: "iana"
      },
      "video/ogg": {
        source: "iana",
        compressible: false,
        extensions: ["ogv"]
      },
      "video/parityfec": {
        source: "iana"
      },
      "video/pointer": {
        source: "iana"
      },
      "video/quicktime": {
        source: "iana",
        compressible: false,
        extensions: ["qt", "mov"]
      },
      "video/raptorfec": {
        source: "iana"
      },
      "video/raw": {
        source: "iana"
      },
      "video/rtp-enc-aescm128": {
        source: "iana"
      },
      "video/rtploopback": {
        source: "iana"
      },
      "video/rtx": {
        source: "iana"
      },
      "video/scip": {
        source: "iana"
      },
      "video/smpte291": {
        source: "iana"
      },
      "video/smpte292m": {
        source: "iana"
      },
      "video/ulpfec": {
        source: "iana"
      },
      "video/vc1": {
        source: "iana"
      },
      "video/vc2": {
        source: "iana"
      },
      "video/vnd.cctv": {
        source: "iana"
      },
      "video/vnd.dece.hd": {
        source: "iana",
        extensions: ["uvh", "uvvh"]
      },
      "video/vnd.dece.mobile": {
        source: "iana",
        extensions: ["uvm", "uvvm"]
      },
      "video/vnd.dece.mp4": {
        source: "iana"
      },
      "video/vnd.dece.pd": {
        source: "iana",
        extensions: ["uvp", "uvvp"]
      },
      "video/vnd.dece.sd": {
        source: "iana",
        extensions: ["uvs", "uvvs"]
      },
      "video/vnd.dece.video": {
        source: "iana",
        extensions: ["uvv", "uvvv"]
      },
      "video/vnd.directv.mpeg": {
        source: "iana"
      },
      "video/vnd.directv.mpeg-tts": {
        source: "iana"
      },
      "video/vnd.dlna.mpeg-tts": {
        source: "iana"
      },
      "video/vnd.dvb.file": {
        source: "iana",
        extensions: ["dvb"]
      },
      "video/vnd.fvt": {
        source: "iana",
        extensions: ["fvt"]
      },
      "video/vnd.hns.video": {
        source: "iana"
      },
      "video/vnd.iptvforum.1dparityfec-1010": {
        source: "iana"
      },
      "video/vnd.iptvforum.1dparityfec-2005": {
        source: "iana"
      },
      "video/vnd.iptvforum.2dparityfec-1010": {
        source: "iana"
      },
      "video/vnd.iptvforum.2dparityfec-2005": {
        source: "iana"
      },
      "video/vnd.iptvforum.ttsavc": {
        source: "iana"
      },
      "video/vnd.iptvforum.ttsmpeg2": {
        source: "iana"
      },
      "video/vnd.motorola.video": {
        source: "iana"
      },
      "video/vnd.motorola.videop": {
        source: "iana"
      },
      "video/vnd.mpegurl": {
        source: "iana",
        extensions: ["mxu", "m4u"]
      },
      "video/vnd.ms-playready.media.pyv": {
        source: "iana",
        extensions: ["pyv"]
      },
      "video/vnd.nokia.interleaved-multimedia": {
        source: "iana"
      },
      "video/vnd.nokia.mp4vr": {
        source: "iana"
      },
      "video/vnd.nokia.videovoip": {
        source: "iana"
      },
      "video/vnd.objectvideo": {
        source: "iana"
      },
      "video/vnd.radgamettools.bink": {
        source: "iana"
      },
      "video/vnd.radgamettools.smacker": {
        source: "iana"
      },
      "video/vnd.sealed.mpeg1": {
        source: "iana"
      },
      "video/vnd.sealed.mpeg4": {
        source: "iana"
      },
      "video/vnd.sealed.swf": {
        source: "iana"
      },
      "video/vnd.sealedmedia.softseal.mov": {
        source: "iana"
      },
      "video/vnd.uvvu.mp4": {
        source: "iana",
        extensions: ["uvu", "uvvu"]
      },
      "video/vnd.vivo": {
        source: "iana",
        extensions: ["viv"]
      },
      "video/vnd.youtube.yt": {
        source: "iana"
      },
      "video/vp8": {
        source: "iana"
      },
      "video/vp9": {
        source: "iana"
      },
      "video/webm": {
        source: "apache",
        compressible: false,
        extensions: ["webm"]
      },
      "video/x-f4v": {
        source: "apache",
        extensions: ["f4v"]
      },
      "video/x-fli": {
        source: "apache",
        extensions: ["fli"]
      },
      "video/x-flv": {
        source: "apache",
        compressible: false,
        extensions: ["flv"]
      },
      "video/x-m4v": {
        source: "apache",
        extensions: ["m4v"]
      },
      "video/x-matroska": {
        source: "apache",
        compressible: false,
        extensions: ["mkv", "mk3d", "mks"]
      },
      "video/x-mng": {
        source: "apache",
        extensions: ["mng"]
      },
      "video/x-ms-asf": {
        source: "apache",
        extensions: ["asf", "asx"]
      },
      "video/x-ms-vob": {
        source: "apache",
        extensions: ["vob"]
      },
      "video/x-ms-wm": {
        source: "apache",
        extensions: ["wm"]
      },
      "video/x-ms-wmv": {
        source: "apache",
        compressible: false,
        extensions: ["wmv"]
      },
      "video/x-ms-wmx": {
        source: "apache",
        extensions: ["wmx"]
      },
      "video/x-ms-wvx": {
        source: "apache",
        extensions: ["wvx"]
      },
      "video/x-msvideo": {
        source: "apache",
        extensions: ["avi"]
      },
      "video/x-sgi-movie": {
        source: "apache",
        extensions: ["movie"]
      },
      "video/x-smv": {
        source: "apache",
        extensions: ["smv"]
      },
      "x-conference/x-cooltalk": {
        source: "apache",
        extensions: ["ice"]
      },
      "x-shader/x-fragment": {
        compressible: true
      },
      "x-shader/x-vertex": {
        compressible: true
      }
    };
  }
});

// ../../node_modules/mime-db/index.js
var require_mime_db = __commonJS({
  "../../node_modules/mime-db/index.js"(exports, module2) {
    "use strict";
    module2.exports = require_db();
  }
});

// ../../node_modules/mime-types/index.js
var require_mime_types = __commonJS({
  "../../node_modules/mime-types/index.js"(exports) {
    "use strict";
    var db = require_mime_db();
    var extname = require("path").extname;
    var EXTRACT_TYPE_REGEXP = /^\s*([^;\s]*)(?:;|\s|$)/;
    var TEXT_TYPE_REGEXP = /^text\//i;
    exports.charset = charset;
    exports.charsets = { lookup: charset };
    exports.contentType = contentType;
    exports.extension = extension;
    exports.extensions = /* @__PURE__ */ Object.create(null);
    exports.lookup = lookup;
    exports.types = /* @__PURE__ */ Object.create(null);
    populateMaps(exports.extensions, exports.types);
    function charset(type4) {
      if (!type4 || typeof type4 !== "string") {
        return false;
      }
      var match2 = EXTRACT_TYPE_REGEXP.exec(type4);
      var mime = match2 && db[match2[1].toLowerCase()];
      if (mime && mime.charset) {
        return mime.charset;
      }
      if (match2 && TEXT_TYPE_REGEXP.test(match2[1])) {
        return "UTF-8";
      }
      return false;
    }
    function contentType(str) {
      if (!str || typeof str !== "string") {
        return false;
      }
      var mime = str.indexOf("/") === -1 ? exports.lookup(str) : str;
      if (!mime) {
        return false;
      }
      if (mime.indexOf("charset") === -1) {
        var charset2 = exports.charset(mime);
        if (charset2)
          mime += "; charset=" + charset2.toLowerCase();
      }
      return mime;
    }
    function extension(type4) {
      if (!type4 || typeof type4 !== "string") {
        return false;
      }
      var match2 = EXTRACT_TYPE_REGEXP.exec(type4);
      var exts = match2 && exports.extensions[match2[1].toLowerCase()];
      if (!exts || !exts.length) {
        return false;
      }
      return exts[0];
    }
    function lookup(path2) {
      if (!path2 || typeof path2 !== "string") {
        return false;
      }
      var extension2 = extname("x." + path2).toLowerCase().substr(1);
      if (!extension2) {
        return false;
      }
      return exports.types[extension2] || false;
    }
    function populateMaps(extensions, types2) {
      var preference = ["nginx", "apache", void 0, "iana"];
      Object.keys(db).forEach(function forEachMimeType(type4) {
        var mime = db[type4];
        var exts = mime.extensions;
        if (!exts || !exts.length) {
          return;
        }
        extensions[type4] = exts;
        for (var i = 0; i < exts.length; i++) {
          var extension2 = exts[i];
          if (types2[extension2]) {
            var from2 = preference.indexOf(db[types2[extension2]].source);
            var to = preference.indexOf(mime.source);
            if (types2[extension2] !== "application/octet-stream" && (from2 > to || from2 === to && types2[extension2].substr(0, 12) === "application/")) {
              continue;
            }
          }
          types2[extension2] = type4;
        }
      });
    }
  }
});

// ../../node_modules/asynckit/lib/defer.js
var require_defer = __commonJS({
  "../../node_modules/asynckit/lib/defer.js"(exports, module2) {
    "use strict";
    module2.exports = defer;
    function defer(fn) {
      var nextTick = typeof setImmediate == "function" ? setImmediate : typeof process == "object" && typeof process.nextTick == "function" ? process.nextTick : null;
      if (nextTick) {
        nextTick(fn);
      } else {
        setTimeout(fn, 0);
      }
    }
  }
});

// ../../node_modules/asynckit/lib/async.js
var require_async = __commonJS({
  "../../node_modules/asynckit/lib/async.js"(exports, module2) {
    "use strict";
    var defer = require_defer();
    module2.exports = async;
    function async(callback) {
      var isAsync = false;
      defer(function() {
        isAsync = true;
      });
      return function async_callback(err, result) {
        if (isAsync) {
          callback(err, result);
        } else {
          defer(function nextTick_callback() {
            callback(err, result);
          });
        }
      };
    }
  }
});

// ../../node_modules/asynckit/lib/abort.js
var require_abort = __commonJS({
  "../../node_modules/asynckit/lib/abort.js"(exports, module2) {
    "use strict";
    module2.exports = abort;
    function abort(state) {
      Object.keys(state.jobs).forEach(clean.bind(state));
      state.jobs = {};
    }
    function clean(key) {
      if (typeof this.jobs[key] == "function") {
        this.jobs[key]();
      }
    }
  }
});

// ../../node_modules/asynckit/lib/iterate.js
var require_iterate = __commonJS({
  "../../node_modules/asynckit/lib/iterate.js"(exports, module2) {
    "use strict";
    var async = require_async();
    var abort = require_abort();
    module2.exports = iterate;
    function iterate(list, iterator, state, callback) {
      var key = state["keyedList"] ? state["keyedList"][state.index] : state.index;
      state.jobs[key] = runJob(iterator, key, list[key], function(error, output) {
        if (!(key in state.jobs)) {
          return;
        }
        delete state.jobs[key];
        if (error) {
          abort(state);
        } else {
          state.results[key] = output;
        }
        callback(error, state.results);
      });
    }
    function runJob(iterator, key, item, callback) {
      var aborter;
      if (iterator.length == 2) {
        aborter = iterator(item, async(callback));
      } else {
        aborter = iterator(item, key, async(callback));
      }
      return aborter;
    }
  }
});

// ../../node_modules/asynckit/lib/state.js
var require_state = __commonJS({
  "../../node_modules/asynckit/lib/state.js"(exports, module2) {
    "use strict";
    module2.exports = state;
    function state(list, sortMethod) {
      var isNamedList = !Array.isArray(list), initState = {
        index: 0,
        keyedList: isNamedList || sortMethod ? Object.keys(list) : null,
        jobs: {},
        results: isNamedList ? {} : [],
        size: isNamedList ? Object.keys(list).length : list.length
      };
      if (sortMethod) {
        initState.keyedList.sort(isNamedList ? sortMethod : function(a, b) {
          return sortMethod(list[a], list[b]);
        });
      }
      return initState;
    }
  }
});

// ../../node_modules/asynckit/lib/terminator.js
var require_terminator = __commonJS({
  "../../node_modules/asynckit/lib/terminator.js"(exports, module2) {
    "use strict";
    var abort = require_abort();
    var async = require_async();
    module2.exports = terminator;
    function terminator(callback) {
      if (!Object.keys(this.jobs).length) {
        return;
      }
      this.index = this.size;
      abort(this);
      async(callback)(null, this.results);
    }
  }
});

// ../../node_modules/asynckit/parallel.js
var require_parallel = __commonJS({
  "../../node_modules/asynckit/parallel.js"(exports, module2) {
    "use strict";
    var iterate = require_iterate();
    var initState = require_state();
    var terminator = require_terminator();
    module2.exports = parallel;
    function parallel(list, iterator, callback) {
      var state = initState(list);
      while (state.index < (state["keyedList"] || list).length) {
        iterate(list, iterator, state, function(error, result) {
          if (error) {
            callback(error, result);
            return;
          }
          if (Object.keys(state.jobs).length === 0) {
            callback(null, state.results);
            return;
          }
        });
        state.index++;
      }
      return terminator.bind(state, callback);
    }
  }
});

// ../../node_modules/asynckit/serialOrdered.js
var require_serialOrdered = __commonJS({
  "../../node_modules/asynckit/serialOrdered.js"(exports, module2) {
    "use strict";
    var iterate = require_iterate();
    var initState = require_state();
    var terminator = require_terminator();
    module2.exports = serialOrdered;
    module2.exports.ascending = ascending;
    module2.exports.descending = descending;
    function serialOrdered(list, iterator, sortMethod, callback) {
      var state = initState(list, sortMethod);
      iterate(list, iterator, state, function iteratorHandler(error, result) {
        if (error) {
          callback(error, result);
          return;
        }
        state.index++;
        if (state.index < (state["keyedList"] || list).length) {
          iterate(list, iterator, state, iteratorHandler);
          return;
        }
        callback(null, state.results);
      });
      return terminator.bind(state, callback);
    }
    function ascending(a, b) {
      return a < b ? -1 : a > b ? 1 : 0;
    }
    function descending(a, b) {
      return -1 * ascending(a, b);
    }
  }
});

// ../../node_modules/asynckit/serial.js
var require_serial = __commonJS({
  "../../node_modules/asynckit/serial.js"(exports, module2) {
    "use strict";
    var serialOrdered = require_serialOrdered();
    module2.exports = serial;
    function serial(list, iterator, callback) {
      return serialOrdered(list, iterator, null, callback);
    }
  }
});

// ../../node_modules/asynckit/index.js
var require_asynckit = __commonJS({
  "../../node_modules/asynckit/index.js"(exports, module2) {
    "use strict";
    module2.exports = {
      parallel: require_parallel(),
      serial: require_serial(),
      serialOrdered: require_serialOrdered()
    };
  }
});

// ../../node_modules/form-data/lib/populate.js
var require_populate = __commonJS({
  "../../node_modules/form-data/lib/populate.js"(exports, module2) {
    "use strict";
    module2.exports = function(dst, src) {
      Object.keys(src).forEach(function(prop) {
        dst[prop] = dst[prop] || src[prop];
      });
      return dst;
    };
  }
});

// ../../node_modules/form-data/lib/form_data.js
var require_form_data = __commonJS({
  "../../node_modules/form-data/lib/form_data.js"(exports, module2) {
    "use strict";
    var CombinedStream = require_combined_stream();
    var util = require("util");
    var path2 = require("path");
    var http = require("http");
    var https = require("https");
    var parseUrl = require("url").parse;
    var fs = require("fs");
    var Stream = require("stream").Stream;
    var mime = require_mime_types();
    var asynckit = require_asynckit();
    var populate = require_populate();
    module2.exports = FormData2;
    util.inherits(FormData2, CombinedStream);
    function FormData2(options) {
      if (!(this instanceof FormData2)) {
        return new FormData2(options);
      }
      this._overheadLength = 0;
      this._valueLength = 0;
      this._valuesToMeasure = [];
      CombinedStream.call(this);
      options = options || {};
      for (var option in options) {
        this[option] = options[option];
      }
    }
    FormData2.LINE_BREAK = "\r\n";
    FormData2.DEFAULT_CONTENT_TYPE = "application/octet-stream";
    FormData2.prototype.append = function(field, value, options) {
      options = options || {};
      if (typeof options == "string") {
        options = { filename: options };
      }
      var append3 = CombinedStream.prototype.append.bind(this);
      if (typeof value == "number") {
        value = "" + value;
      }
      if (util.isArray(value)) {
        this._error(new Error("Arrays are not supported."));
        return;
      }
      var header = this._multiPartHeader(field, value, options);
      var footer = this._multiPartFooter();
      append3(header);
      append3(value);
      append3(footer);
      this._trackLength(header, value, options);
    };
    FormData2.prototype._trackLength = function(header, value, options) {
      var valueLength = 0;
      if (options.knownLength != null) {
        valueLength += +options.knownLength;
      } else if (Buffer.isBuffer(value)) {
        valueLength = value.length;
      } else if (typeof value === "string") {
        valueLength = Buffer.byteLength(value);
      }
      this._valueLength += valueLength;
      this._overheadLength += Buffer.byteLength(header) + FormData2.LINE_BREAK.length;
      if (!value || !value.path && !(value.readable && value.hasOwnProperty("httpVersion")) && !(value instanceof Stream)) {
        return;
      }
      if (!options.knownLength) {
        this._valuesToMeasure.push(value);
      }
    };
    FormData2.prototype._lengthRetriever = function(value, callback) {
      if (value.hasOwnProperty("fd")) {
        if (value.end != void 0 && value.end != Infinity && value.start != void 0) {
          callback(null, value.end + 1 - (value.start ? value.start : 0));
        } else {
          fs.stat(value.path, function(err, stat) {
            var fileSize;
            if (err) {
              callback(err);
              return;
            }
            fileSize = stat.size - (value.start ? value.start : 0);
            callback(null, fileSize);
          });
        }
      } else if (value.hasOwnProperty("httpVersion")) {
        callback(null, +value.headers["content-length"]);
      } else if (value.hasOwnProperty("httpModule")) {
        value.on("response", function(response) {
          value.pause();
          callback(null, +response.headers["content-length"]);
        });
        value.resume();
      } else {
        callback("Unknown stream");
      }
    };
    FormData2.prototype._multiPartHeader = function(field, value, options) {
      if (typeof options.header == "string") {
        return options.header;
      }
      var contentDisposition = this._getContentDisposition(value, options);
      var contentType = this._getContentType(value, options);
      var contents = "";
      var headers = {
        // add custom disposition as third element or keep it two elements if not
        "Content-Disposition": ["form-data", 'name="' + field + '"'].concat(contentDisposition || []),
        // if no content type. allow it to be empty array
        "Content-Type": [].concat(contentType || [])
      };
      if (typeof options.header == "object") {
        populate(headers, options.header);
      }
      var header;
      for (var prop in headers) {
        if (!headers.hasOwnProperty(prop))
          continue;
        header = headers[prop];
        if (header == null) {
          continue;
        }
        if (!Array.isArray(header)) {
          header = [header];
        }
        if (header.length) {
          contents += prop + ": " + header.join("; ") + FormData2.LINE_BREAK;
        }
      }
      return "--" + this.getBoundary() + FormData2.LINE_BREAK + contents + FormData2.LINE_BREAK;
    };
    FormData2.prototype._getContentDisposition = function(value, options) {
      var filename, contentDisposition;
      if (typeof options.filepath === "string") {
        filename = path2.normalize(options.filepath).replace(/\\/g, "/");
      } else if (options.filename || value.name || value.path) {
        filename = path2.basename(options.filename || value.name || value.path);
      } else if (value.readable && value.hasOwnProperty("httpVersion")) {
        filename = path2.basename(value.client._httpMessage.path || "");
      }
      if (filename) {
        contentDisposition = 'filename="' + filename + '"';
      }
      return contentDisposition;
    };
    FormData2.prototype._getContentType = function(value, options) {
      var contentType = options.contentType;
      if (!contentType && value.name) {
        contentType = mime.lookup(value.name);
      }
      if (!contentType && value.path) {
        contentType = mime.lookup(value.path);
      }
      if (!contentType && value.readable && value.hasOwnProperty("httpVersion")) {
        contentType = value.headers["content-type"];
      }
      if (!contentType && (options.filepath || options.filename)) {
        contentType = mime.lookup(options.filepath || options.filename);
      }
      if (!contentType && typeof value == "object") {
        contentType = FormData2.DEFAULT_CONTENT_TYPE;
      }
      return contentType;
    };
    FormData2.prototype._multiPartFooter = function() {
      return function(next2) {
        var footer = FormData2.LINE_BREAK;
        var lastPart = this._streams.length === 0;
        if (lastPart) {
          footer += this._lastBoundary();
        }
        next2(footer);
      }.bind(this);
    };
    FormData2.prototype._lastBoundary = function() {
      return "--" + this.getBoundary() + "--" + FormData2.LINE_BREAK;
    };
    FormData2.prototype.getHeaders = function(userHeaders) {
      var header;
      var formHeaders = {
        "content-type": "multipart/form-data; boundary=" + this.getBoundary()
      };
      for (header in userHeaders) {
        if (userHeaders.hasOwnProperty(header)) {
          formHeaders[header.toLowerCase()] = userHeaders[header];
        }
      }
      return formHeaders;
    };
    FormData2.prototype.setBoundary = function(boundary) {
      this._boundary = boundary;
    };
    FormData2.prototype.getBoundary = function() {
      if (!this._boundary) {
        this._generateBoundary();
      }
      return this._boundary;
    };
    FormData2.prototype.getBuffer = function() {
      var dataBuffer = new Buffer.alloc(0);
      var boundary = this.getBoundary();
      for (var i = 0, len = this._streams.length; i < len; i++) {
        if (typeof this._streams[i] !== "function") {
          if (Buffer.isBuffer(this._streams[i])) {
            dataBuffer = Buffer.concat([dataBuffer, this._streams[i]]);
          } else {
            dataBuffer = Buffer.concat([dataBuffer, Buffer.from(this._streams[i])]);
          }
          if (typeof this._streams[i] !== "string" || this._streams[i].substring(2, boundary.length + 2) !== boundary) {
            dataBuffer = Buffer.concat([dataBuffer, Buffer.from(FormData2.LINE_BREAK)]);
          }
        }
      }
      return Buffer.concat([dataBuffer, Buffer.from(this._lastBoundary())]);
    };
    FormData2.prototype._generateBoundary = function() {
      var boundary = "--------------------------";
      for (var i = 0; i < 24; i++) {
        boundary += Math.floor(Math.random() * 10).toString(16);
      }
      this._boundary = boundary;
    };
    FormData2.prototype.getLengthSync = function() {
      var knownLength = this._overheadLength + this._valueLength;
      if (this._streams.length) {
        knownLength += this._lastBoundary().length;
      }
      if (!this.hasKnownLength()) {
        this._error(new Error("Cannot calculate proper length in synchronous way."));
      }
      return knownLength;
    };
    FormData2.prototype.hasKnownLength = function() {
      var hasKnownLength = true;
      if (this._valuesToMeasure.length) {
        hasKnownLength = false;
      }
      return hasKnownLength;
    };
    FormData2.prototype.getLength = function(cb) {
      var knownLength = this._overheadLength + this._valueLength;
      if (this._streams.length) {
        knownLength += this._lastBoundary().length;
      }
      if (!this._valuesToMeasure.length) {
        process.nextTick(cb.bind(this, null, knownLength));
        return;
      }
      asynckit.parallel(this._valuesToMeasure, this._lengthRetriever, function(err, values) {
        if (err) {
          cb(err);
          return;
        }
        values.forEach(function(length2) {
          knownLength += length2;
        });
        cb(null, knownLength);
      });
    };
    FormData2.prototype.submit = function(params, cb) {
      var request, options, defaults = { method: "post" };
      if (typeof params == "string") {
        params = parseUrl(params);
        options = populate({
          port: params.port,
          path: params.pathname,
          host: params.hostname,
          protocol: params.protocol
        }, defaults);
      } else {
        options = populate(params, defaults);
        if (!options.port) {
          options.port = options.protocol == "https:" ? 443 : 80;
        }
      }
      options.headers = this.getHeaders(params.headers);
      if (options.protocol == "https:") {
        request = https.request(options);
      } else {
        request = http.request(options);
      }
      this.getLength(function(err, length2) {
        if (err && err !== "Unknown stream") {
          this._error(err);
          return;
        }
        if (length2) {
          request.setHeader("Content-Length", length2);
        }
        this.pipe(request);
        if (cb) {
          var onResponse;
          var callback = function(error, responce) {
            request.removeListener("error", callback);
            request.removeListener("response", onResponse);
            return cb.call(this, error, responce);
          };
          onResponse = callback.bind(this, null);
          request.on("error", callback);
          request.on("response", onResponse);
        }
      }.bind(this));
      return request;
    };
    FormData2.prototype._error = function(err) {
      if (!this.error) {
        this.error = err;
        this.pause();
        this.emit("error", err);
      }
    };
    FormData2.prototype.toString = function() {
      return "[object FormData]";
    };
  }
});

// ../../node_modules/axios/lib/defaults/env/FormData.js
var require_FormData = __commonJS({
  "../../node_modules/axios/lib/defaults/env/FormData.js"(exports, module2) {
    "use strict";
    module2.exports = require_form_data();
  }
});

// ../../node_modules/axios/lib/defaults/index.js
var require_defaults = __commonJS({
  "../../node_modules/axios/lib/defaults/index.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var normalizeHeaderName = require_normalizeHeaderName();
    var AxiosError = require_AxiosError();
    var transitionalDefaults = require_transitional();
    var toFormData = require_toFormData();
    var DEFAULT_CONTENT_TYPE = {
      "Content-Type": "application/x-www-form-urlencoded"
    };
    function setContentTypeIfUnset(headers, value) {
      if (!utils.isUndefined(headers) && utils.isUndefined(headers["Content-Type"])) {
        headers["Content-Type"] = value;
      }
    }
    function getDefaultAdapter() {
      var adapter;
      if (typeof XMLHttpRequest !== "undefined") {
        adapter = require_xhr();
      } else if (typeof process !== "undefined" && Object.prototype.toString.call(process) === "[object process]") {
        adapter = require_http();
      }
      return adapter;
    }
    function stringifySafely(rawValue, parser, encoder) {
      if (utils.isString(rawValue)) {
        try {
          (parser || JSON.parse)(rawValue);
          return utils.trim(rawValue);
        } catch (e) {
          if (e.name !== "SyntaxError") {
            throw e;
          }
        }
      }
      return (encoder || JSON.stringify)(rawValue);
    }
    var defaults = {
      transitional: transitionalDefaults,
      adapter: getDefaultAdapter(),
      transformRequest: [function transformRequest(data, headers) {
        normalizeHeaderName(headers, "Accept");
        normalizeHeaderName(headers, "Content-Type");
        if (utils.isFormData(data) || utils.isArrayBuffer(data) || utils.isBuffer(data) || utils.isStream(data) || utils.isFile(data) || utils.isBlob(data)) {
          return data;
        }
        if (utils.isArrayBufferView(data)) {
          return data.buffer;
        }
        if (utils.isURLSearchParams(data)) {
          setContentTypeIfUnset(headers, "application/x-www-form-urlencoded;charset=utf-8");
          return data.toString();
        }
        var isObjectPayload = utils.isObject(data);
        var contentType = headers && headers["Content-Type"];
        var isFileList;
        if ((isFileList = utils.isFileList(data)) || isObjectPayload && contentType === "multipart/form-data") {
          var _FormData = this.env && this.env.FormData;
          return toFormData(isFileList ? { "files[]": data } : data, _FormData && new _FormData());
        } else if (isObjectPayload || contentType === "application/json") {
          setContentTypeIfUnset(headers, "application/json");
          return stringifySafely(data);
        }
        return data;
      }],
      transformResponse: [function transformResponse(data) {
        var transitional = this.transitional || defaults.transitional;
        var silentJSONParsing = transitional && transitional.silentJSONParsing;
        var forcedJSONParsing = transitional && transitional.forcedJSONParsing;
        var strictJSONParsing = !silentJSONParsing && this.responseType === "json";
        if (strictJSONParsing || forcedJSONParsing && utils.isString(data) && data.length) {
          try {
            return JSON.parse(data);
          } catch (e) {
            if (strictJSONParsing) {
              if (e.name === "SyntaxError") {
                throw AxiosError.from(e, AxiosError.ERR_BAD_RESPONSE, this, null, this.response);
              }
              throw e;
            }
          }
        }
        return data;
      }],
      /**
       * A timeout in milliseconds to abort a request. If set to 0 (default) a
       * timeout is not created.
       */
      timeout: 0,
      xsrfCookieName: "XSRF-TOKEN",
      xsrfHeaderName: "X-XSRF-TOKEN",
      maxContentLength: -1,
      maxBodyLength: -1,
      env: {
        FormData: require_FormData()
      },
      validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
      },
      headers: {
        common: {
          "Accept": "application/json, text/plain, */*"
        }
      }
    };
    utils.forEach(["delete", "get", "head"], function forEachMethodNoData(method4) {
      defaults.headers[method4] = {};
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method4) {
      defaults.headers[method4] = utils.merge(DEFAULT_CONTENT_TYPE);
    });
    module2.exports = defaults;
  }
});

// ../../node_modules/axios/lib/core/transformData.js
var require_transformData = __commonJS({
  "../../node_modules/axios/lib/core/transformData.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var defaults = require_defaults();
    module2.exports = function transformData(data, headers, fns) {
      var context = this || defaults;
      utils.forEach(fns, function transform(fn) {
        data = fn.call(context, data, headers);
      });
      return data;
    };
  }
});

// ../../node_modules/axios/lib/cancel/isCancel.js
var require_isCancel = __commonJS({
  "../../node_modules/axios/lib/cancel/isCancel.js"(exports, module2) {
    "use strict";
    module2.exports = function isCancel(value) {
      return !!(value && value.__CANCEL__);
    };
  }
});

// ../../node_modules/axios/lib/core/dispatchRequest.js
var require_dispatchRequest = __commonJS({
  "../../node_modules/axios/lib/core/dispatchRequest.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var transformData = require_transformData();
    var isCancel = require_isCancel();
    var defaults = require_defaults();
    var CanceledError = require_CanceledError();
    function throwIfCancellationRequested(config) {
      if (config.cancelToken) {
        config.cancelToken.throwIfRequested();
      }
      if (config.signal && config.signal.aborted) {
        throw new CanceledError();
      }
    }
    module2.exports = function dispatchRequest(config) {
      throwIfCancellationRequested(config);
      config.headers = config.headers || {};
      config.data = transformData.call(
        config,
        config.data,
        config.headers,
        config.transformRequest
      );
      config.headers = utils.merge(
        config.headers.common || {},
        config.headers[config.method] || {},
        config.headers
      );
      utils.forEach(
        ["delete", "get", "head", "post", "put", "patch", "common"],
        function cleanHeaderConfig(method4) {
          delete config.headers[method4];
        }
      );
      var adapter = config.adapter || defaults.adapter;
      return adapter(config).then(function onAdapterResolution(response) {
        throwIfCancellationRequested(config);
        response.data = transformData.call(
          config,
          response.data,
          response.headers,
          config.transformResponse
        );
        return response;
      }, function onAdapterRejection(reason) {
        if (!isCancel(reason)) {
          throwIfCancellationRequested(config);
          if (reason && reason.response) {
            reason.response.data = transformData.call(
              config,
              reason.response.data,
              reason.response.headers,
              config.transformResponse
            );
          }
        }
        return Promise.reject(reason);
      });
    };
  }
});

// ../../node_modules/axios/lib/core/mergeConfig.js
var require_mergeConfig = __commonJS({
  "../../node_modules/axios/lib/core/mergeConfig.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function mergeConfig2(config1, config2) {
      config2 = config2 || {};
      var config = {};
      function getMergedValue(target, source) {
        if (utils.isPlainObject(target) && utils.isPlainObject(source)) {
          return utils.merge(target, source);
        } else if (utils.isPlainObject(source)) {
          return utils.merge({}, source);
        } else if (utils.isArray(source)) {
          return source.slice();
        }
        return source;
      }
      function mergeDeepProperties(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function valueFromConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        }
      }
      function defaultToConfig2(prop) {
        if (!utils.isUndefined(config2[prop])) {
          return getMergedValue(void 0, config2[prop]);
        } else if (!utils.isUndefined(config1[prop])) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      function mergeDirectKeys(prop) {
        if (prop in config2) {
          return getMergedValue(config1[prop], config2[prop]);
        } else if (prop in config1) {
          return getMergedValue(void 0, config1[prop]);
        }
      }
      var mergeMap = {
        "url": valueFromConfig2,
        "method": valueFromConfig2,
        "data": valueFromConfig2,
        "baseURL": defaultToConfig2,
        "transformRequest": defaultToConfig2,
        "transformResponse": defaultToConfig2,
        "paramsSerializer": defaultToConfig2,
        "timeout": defaultToConfig2,
        "timeoutMessage": defaultToConfig2,
        "withCredentials": defaultToConfig2,
        "adapter": defaultToConfig2,
        "responseType": defaultToConfig2,
        "xsrfCookieName": defaultToConfig2,
        "xsrfHeaderName": defaultToConfig2,
        "onUploadProgress": defaultToConfig2,
        "onDownloadProgress": defaultToConfig2,
        "decompress": defaultToConfig2,
        "maxContentLength": defaultToConfig2,
        "maxBodyLength": defaultToConfig2,
        "beforeRedirect": defaultToConfig2,
        "transport": defaultToConfig2,
        "httpAgent": defaultToConfig2,
        "httpsAgent": defaultToConfig2,
        "cancelToken": defaultToConfig2,
        "socketPath": defaultToConfig2,
        "responseEncoding": defaultToConfig2,
        "validateStatus": mergeDirectKeys
      };
      utils.forEach(Object.keys(config1).concat(Object.keys(config2)), function computeConfigValue(prop) {
        var merge3 = mergeMap[prop] || mergeDeepProperties;
        var configValue = merge3(prop);
        utils.isUndefined(configValue) && merge3 !== mergeDirectKeys || (config[prop] = configValue);
      });
      return config;
    };
  }
});

// ../../node_modules/axios/lib/helpers/validator.js
var require_validator = __commonJS({
  "../../node_modules/axios/lib/helpers/validator.js"(exports, module2) {
    "use strict";
    var VERSION = require_data().version;
    var AxiosError = require_AxiosError();
    var validators2 = {};
    ["object", "boolean", "number", "function", "string", "symbol"].forEach(function(type4, i) {
      validators2[type4] = function validator(thing) {
        return typeof thing === type4 || "a" + (i < 1 ? "n " : " ") + type4;
      };
    });
    var deprecatedWarnings = {};
    validators2.transitional = function transitional(validator, version2, message2) {
      function formatMessage(opt, desc) {
        return "[Axios v" + VERSION + "] Transitional option '" + opt + "'" + desc + (message2 ? ". " + message2 : "");
      }
      return function(value, opt, opts) {
        if (validator === false) {
          throw new AxiosError(
            formatMessage(opt, " has been removed" + (version2 ? " in " + version2 : "")),
            AxiosError.ERR_DEPRECATED
          );
        }
        if (version2 && !deprecatedWarnings[opt]) {
          deprecatedWarnings[opt] = true;
          console.warn(
            formatMessage(
              opt,
              " has been deprecated since v" + version2 + " and will be removed in the near future"
            )
          );
        }
        return validator ? validator(value, opt, opts) : true;
      };
    };
    function assertOptions(options, schema, allowUnknown) {
      if (typeof options !== "object") {
        throw new AxiosError("options must be an object", AxiosError.ERR_BAD_OPTION_VALUE);
      }
      var keys3 = Object.keys(options);
      var i = keys3.length;
      while (i-- > 0) {
        var opt = keys3[i];
        var validator = schema[opt];
        if (validator) {
          var value = options[opt];
          var result = value === void 0 || validator(value, opt, options);
          if (result !== true) {
            throw new AxiosError("option " + opt + " must be " + result, AxiosError.ERR_BAD_OPTION_VALUE);
          }
          continue;
        }
        if (allowUnknown !== true) {
          throw new AxiosError("Unknown option " + opt, AxiosError.ERR_BAD_OPTION);
        }
      }
    }
    module2.exports = {
      assertOptions,
      validators: validators2
    };
  }
});

// ../../node_modules/axios/lib/core/Axios.js
var require_Axios = __commonJS({
  "../../node_modules/axios/lib/core/Axios.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var buildURL = require_buildURL();
    var InterceptorManager = require_InterceptorManager();
    var dispatchRequest = require_dispatchRequest();
    var mergeConfig2 = require_mergeConfig();
    var buildFullPath = require_buildFullPath();
    var validator = require_validator();
    var validators2 = validator.validators;
    function Axios3(instanceConfig) {
      this.defaults = instanceConfig;
      this.interceptors = {
        request: new InterceptorManager(),
        response: new InterceptorManager()
      };
    }
    Axios3.prototype.request = function request(configOrUrl, config) {
      if (typeof configOrUrl === "string") {
        config = config || {};
        config.url = configOrUrl;
      } else {
        config = configOrUrl || {};
      }
      config = mergeConfig2(this.defaults, config);
      if (config.method) {
        config.method = config.method.toLowerCase();
      } else if (this.defaults.method) {
        config.method = this.defaults.method.toLowerCase();
      } else {
        config.method = "get";
      }
      var transitional = config.transitional;
      if (transitional !== void 0) {
        validator.assertOptions(transitional, {
          silentJSONParsing: validators2.transitional(validators2.boolean),
          forcedJSONParsing: validators2.transitional(validators2.boolean),
          clarifyTimeoutError: validators2.transitional(validators2.boolean)
        }, false);
      }
      var requestInterceptorChain = [];
      var synchronousRequestInterceptors = true;
      this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
        if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) {
          return;
        }
        synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
        requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
      });
      var responseInterceptorChain = [];
      this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
        responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
      });
      var promise;
      if (!synchronousRequestInterceptors) {
        var chain = [dispatchRequest, void 0];
        Array.prototype.unshift.apply(chain, requestInterceptorChain);
        chain = chain.concat(responseInterceptorChain);
        promise = Promise.resolve(config);
        while (chain.length) {
          promise = promise.then(chain.shift(), chain.shift());
        }
        return promise;
      }
      var newConfig = config;
      while (requestInterceptorChain.length) {
        var onFulfilled = requestInterceptorChain.shift();
        var onRejected = requestInterceptorChain.shift();
        try {
          newConfig = onFulfilled(newConfig);
        } catch (error) {
          onRejected(error);
          break;
        }
      }
      try {
        promise = dispatchRequest(newConfig);
      } catch (error) {
        return Promise.reject(error);
      }
      while (responseInterceptorChain.length) {
        promise = promise.then(responseInterceptorChain.shift(), responseInterceptorChain.shift());
      }
      return promise;
    };
    Axios3.prototype.getUri = function getUri(config) {
      config = mergeConfig2(this.defaults, config);
      var fullPath = buildFullPath(config.baseURL, config.url);
      return buildURL(fullPath, config.params, config.paramsSerializer);
    };
    utils.forEach(["delete", "get", "head", "options"], function forEachMethodNoData(method4) {
      Axios3.prototype[method4] = function(url2, config) {
        return this.request(mergeConfig2(config || {}, {
          method: method4,
          url: url2,
          data: (config || {}).data
        }));
      };
    });
    utils.forEach(["post", "put", "patch"], function forEachMethodWithData(method4) {
      function generateHTTPMethod(isForm) {
        return function httpMethod(url2, data, config) {
          return this.request(mergeConfig2(config || {}, {
            method: method4,
            headers: isForm ? {
              "Content-Type": "multipart/form-data"
            } : {},
            url: url2,
            data
          }));
        };
      }
      Axios3.prototype[method4] = generateHTTPMethod();
      Axios3.prototype[method4 + "Form"] = generateHTTPMethod(true);
    });
    module2.exports = Axios3;
  }
});

// ../../node_modules/axios/lib/cancel/CancelToken.js
var require_CancelToken = __commonJS({
  "../../node_modules/axios/lib/cancel/CancelToken.js"(exports, module2) {
    "use strict";
    var CanceledError = require_CanceledError();
    function CancelToken(executor) {
      if (typeof executor !== "function") {
        throw new TypeError("executor must be a function.");
      }
      var resolvePromise;
      this.promise = new Promise(function promiseExecutor(resolve) {
        resolvePromise = resolve;
      });
      var token2 = this;
      this.promise.then(function(cancel) {
        if (!token2._listeners)
          return;
        var i;
        var l = token2._listeners.length;
        for (i = 0; i < l; i++) {
          token2._listeners[i](cancel);
        }
        token2._listeners = null;
      });
      this.promise.then = function(onfulfilled) {
        var _resolve;
        var promise = new Promise(function(resolve) {
          token2.subscribe(resolve);
          _resolve = resolve;
        }).then(onfulfilled);
        promise.cancel = function reject() {
          token2.unsubscribe(_resolve);
        };
        return promise;
      };
      executor(function cancel(message2) {
        if (token2.reason) {
          return;
        }
        token2.reason = new CanceledError(message2);
        resolvePromise(token2.reason);
      });
    }
    CancelToken.prototype.throwIfRequested = function throwIfRequested() {
      if (this.reason) {
        throw this.reason;
      }
    };
    CancelToken.prototype.subscribe = function subscribe(listener) {
      if (this.reason) {
        listener(this.reason);
        return;
      }
      if (this._listeners) {
        this._listeners.push(listener);
      } else {
        this._listeners = [listener];
      }
    };
    CancelToken.prototype.unsubscribe = function unsubscribe(listener) {
      if (!this._listeners) {
        return;
      }
      var index2 = this._listeners.indexOf(listener);
      if (index2 !== -1) {
        this._listeners.splice(index2, 1);
      }
    };
    CancelToken.source = function source() {
      var cancel;
      var token2 = new CancelToken(function executor(c) {
        cancel = c;
      });
      return {
        token: token2,
        cancel
      };
    };
    module2.exports = CancelToken;
  }
});

// ../../node_modules/axios/lib/helpers/spread.js
var require_spread = __commonJS({
  "../../node_modules/axios/lib/helpers/spread.js"(exports, module2) {
    "use strict";
    module2.exports = function spread(callback) {
      return function wrap(arr) {
        return callback.apply(null, arr);
      };
    };
  }
});

// ../../node_modules/axios/lib/helpers/isAxiosError.js
var require_isAxiosError = __commonJS({
  "../../node_modules/axios/lib/helpers/isAxiosError.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    module2.exports = function isAxiosError(payload) {
      return utils.isObject(payload) && payload.isAxiosError === true;
    };
  }
});

// ../../node_modules/axios/lib/axios.js
var require_axios = __commonJS({
  "../../node_modules/axios/lib/axios.js"(exports, module2) {
    "use strict";
    var utils = require_utils();
    var bind = require_bind();
    var Axios3 = require_Axios();
    var mergeConfig2 = require_mergeConfig();
    var defaults = require_defaults();
    function createInstance(defaultConfig2) {
      var context = new Axios3(defaultConfig2);
      var instance = bind(Axios3.prototype.request, context);
      utils.extend(instance, Axios3.prototype, context);
      utils.extend(instance, context);
      instance.create = function create2(instanceConfig) {
        return createInstance(mergeConfig2(defaultConfig2, instanceConfig));
      };
      return instance;
    }
    var axios3 = createInstance(defaults);
    axios3.Axios = Axios3;
    axios3.CanceledError = require_CanceledError();
    axios3.CancelToken = require_CancelToken();
    axios3.isCancel = require_isCancel();
    axios3.VERSION = require_data().version;
    axios3.toFormData = require_toFormData();
    axios3.AxiosError = require_AxiosError();
    axios3.Cancel = axios3.CanceledError;
    axios3.all = function all(promises) {
      return Promise.all(promises);
    };
    axios3.spread = require_spread();
    axios3.isAxiosError = require_isAxiosError();
    module2.exports = axios3;
    module2.exports.default = axios3;
  }
});

// ../../node_modules/axios/index.js
var require_axios2 = __commonJS({
  "../../node_modules/axios/index.js"(exports, module2) {
    "use strict";
    module2.exports = require_axios();
  }
});

// index.tsx
var lib_exports = {};
__export(lib_exports, {
  APP_URL: () => APP_URL,
  AgentTool: () => AgentTool,
  Authority: () => Authority,
  BASE_URL: () => BASE_URL,
  BarChart: () => BarChart,
  CardChart: () => CardChart,
  ChartHeader: () => ChartHeader,
  ChartSelection: () => ChartSelection,
  ColorPicker: () => ColorPicker,
  ComponentType: () => ComponentType,
  CreateMessages: () => CreateMessages,
  DataSourceStatus: () => DataSourceStatus,
  DataSourceType: () => DataSourceType,
  DatabaseType: () => DatabaseType,
  DeleteModal: () => DeleteModal,
  Editor: () => Editor,
  Empty: () => Empty4,
  EnterpriseConnectorType: () => EnterpriseConnectorType,
  FORMAT: () => FORMAT,
  FileType: () => FileType,
  GridItemType: () => GridItemType,
  IProductType: () => IProductType,
  LineChart: () => LineChart,
  Loading: () => Loading,
  NotificationType: () => NotificationType,
  PackageType: () => PackageType,
  PageType: () => PageType,
  PaginationComponent: () => PaginationComponent,
  PieChart: () => PieChart2,
  PositionType: () => PositionType,
  ProductTourType: () => ProductTourType,
  QUERIES: () => QUERIES,
  RadarChart: () => RadarChart2,
  STRIPE_TOKEN: () => STRIPE_TOKEN,
  UpdateConversation: () => UpdateConversation,
  WHITELISTED_URLS: () => WHITELISTED_URLS,
  addPaymentCard: () => addPaymentCard,
  addUsagePackage: () => addUsagePackage,
  associatePageChartGridItem: () => associatePageChartGridItem,
  associatePageTableGridItem: () => associatePageTableGridItem,
  axios: () => axios,
  cancelSubscription: () => cancelSubscription,
  changePassword: () => changePassword,
  chartType: () => chartType,
  chatType: () => chatType,
  checkSearchSession: () => checkSearchSession,
  confirmRegistration: () => confirmRegistration,
  contactEnterprisePackage: () => contactEnterprisePackage,
  contactSupport: () => contactSupport,
  createDashboard: () => createDashboard,
  createDatabase: () => createDatabase,
  createEnterpriseConnector: () => createEnterpriseConnector,
  createFile: () => createFile,
  createPackage: () => createPackage,
  createPage: () => createPage,
  createPageGridItem: () => createPageGridItem,
  currentUser: () => currentUser,
  dashboardCharts: () => dashboardCharts,
  dashboardDateFormatter: () => dashboardDateFormatter,
  dataCompany: () => dataCompany,
  dataRole: () => dataRole,
  datasetDateFormatter: () => datasetDateFormatter,
  deleteConversation: () => deleteConversation,
  deleteDashboards: () => deleteDashboards,
  deleteDatasources: () => deleteDatasources,
  deletePackage: () => deletePackage,
  deletePageGridItem: () => deletePageGridItem,
  deletePages: () => deletePages,
  deletePaymentCard: () => deletePaymentCard,
  deleteSearchHistory: () => deleteSearchHistory,
  deleteUsageCard: () => deleteUsageCard,
  demoAttempts: () => demoAttempts,
  demoChat: () => demoChat,
  demoChatWhisper: () => demoChatWhisper,
  demoExecuteSQL: () => demoExecuteSQL,
  demoExecuteSuggestion: () => demoExecuteSuggestion,
  demoSuggestions: () => demoSuggestions,
  downloadFile: () => downloadFile,
  editUsageProduct: () => editUsageProduct,
  enableTourVisited: () => enableTourVisited,
  exportSearchResponseExcel: () => exportSearchResponseExcel,
  forgetPassword: () => forgetPassword,
  formatDate: () => formatDate,
  generatePageGrids: () => generatePageGrids,
  getAccessToken: () => getAccessToken,
  getAllPackages: () => getAllPackages,
  getAllProducts: () => getAllProducts,
  getAllUsage: () => getAllUsage,
  getDashboardById: () => getDashboardById,
  getDashboardName: () => getDashboardName,
  getDashboards: () => getDashboards,
  getDataSourceSummary: () => getDataSourceSummary,
  getDataSources: () => getDataSources,
  getDatabase: () => getDatabase,
  getDatabases: () => getDatabases,
  getDiscussionMessages: () => getDiscussionMessages,
  getDiscussionsHistory: () => getDiscussionsHistory,
  getEnterpriseConnector: () => getEnterpriseConnector,
  getFile: () => getFile,
  getInvoicesData: () => getInvoicesData,
  getLatestSearch: () => getLatestSearch,
  getMarkedSearchHistory: () => getMarkedSearchHistory,
  getPackageById: () => getPackageById,
  getPageGridItem: () => getPageGridItem,
  getPageGridItems: () => getPageGridItems,
  getPaymentCards: () => getPaymentCards,
  getRecentSearch: () => getRecentSearch,
  getRefreshToken: () => getRefreshToken,
  getRelatedCacheKey: () => getRelatedCacheKey,
  getSearchHistory: () => getSearchHistory,
  getSearchRecommendations: () => getSearchRecommendations,
  getSearchSession: () => getSearchSession,
  getSearchSessionById: () => getSearchSessionById,
  getSearchSettings: () => getSearchSettings,
  getSearchSuggestions: () => getSearchSuggestions,
  getSmartSearchUsage: () => getSmartSearchUsage,
  getTopics: () => getTopics,
  getUsernameAccessToken: () => getUsernameAccessToken,
  getdocuments: () => getdocuments,
  gridStackCoordinates: () => gridStackCoordinates,
  increaseUsage: () => increaseUsage,
  isContainWhiteSpace: () => isContainWhiteSpace,
  isEmail: () => isEmail,
  isEmpty: () => isEmpty,
  isValidUrl: () => isValidUrl,
  jsonParseSingleQuotes: () => jsonParseSingleQuotes,
  login: () => login,
  numberCommasFormer: () => numberCommasFormer,
  openNotification: () => openNotification,
  persistNumberEntry: () => persistNumberEntry,
  promptUpdate: () => promptUpdate,
  queryClientConfig: () => queryClientConfig,
  refreshGridItemData: () => refreshGridItemData,
  refreshToken: () => refreshToken,
  register: () => register2,
  removeAccessToken: () => removeAccessToken,
  removeRefreshToken: () => removeRefreshToken,
  resendConfirmationCode: () => resendConfirmationCode,
  resetPassword: () => resetPassword,
  resetSearchSession: () => resetSearchSession,
  scrollBarStyles: () => scrollBarStyles,
  search: () => search,
  searchChat: () => searchChat,
  searchSettings: () => searchSettings,
  searchTools: () => searchTools,
  searchWhisper: () => searchWhisper,
  setAccessToken: () => setAccessToken,
  setDefaultPaymentCard: () => setDefaultPaymentCard,
  setRefreshToken: () => setRefreshToken,
  shareDashboard: () => shareDashboard,
  subscribeToPackage: () => subscribeToPackage,
  switchDataSourceStatus: () => switchDataSourceStatus,
  switchMarkedSearchHistory: () => switchMarkedSearchHistory,
  testConnectionDataBase: () => testConnectionDataBase,
  transformItemsToMappedObject: () => transformItemsToMappedObject,
  underScoreFormer: () => underScoreFormer,
  updateDashboard: () => updateDashboard,
  updateDatabase: () => updateDatabase,
  updateEnterpriseConnector: () => updateEnterpriseConnector,
  updateFile: () => updateFile,
  updateGridItem: () => updateGridItem,
  updatePackage: () => updatePackage,
  updatePackagesOrder: () => updatePackagesOrder,
  updatePage: () => updatePage,
  updatePageGridItemsPlacement: () => updatePageGridItemsPlacement,
  updatePageGridMatrice: () => updatePageGridMatrice,
  updatePagesOrder: () => updatePagesOrder,
  updateSearchReport: () => updateSearchReport,
  updateSettings: () => updateSettings,
  updateUser: () => updateUser,
  uploadFile: () => uploadFile,
  useAppLayout: () => useAppLayout,
  useDebounce: () => useDebounce,
  useDocumentTitle: () => useDocumentTitle,
  useMountedEffect: () => useMountedEffect,
  uuidV4Pattern: () => uuidV4Pattern
});
module.exports = __toCommonJS(lib_exports);

// components/Loading.tsx
var import_styled_components = __toESM(require("styled-components"));
var import_jsx_runtime = require("react/jsx-runtime");
var Loading = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime.jsxs)(StyledLoading, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {}),
    /* @__PURE__ */ (0, import_jsx_runtime.jsx)("div", {})
  ] });
};
var StyledLoading = import_styled_components.default.div`
  display: inline-block;
  position: relative;
  width: 100%;
  text-align: center;

  div {
    position: absolute;
    top: 100px;
    margin-left: calc(50% - 35px) !important;
    width: 10px;
    height: 10px;
    border-radius: 50%;
    background: #4974f6;
    animation-timing-function: cubic-bezier(0, 1, 1, 0);
  }
  div:nth-child(1) {
    left: 8px;
    animation: ellipsis1 0.6s infinite;
  }
  div:nth-child(2) {
    left: 8px;
    animation: ellipsis2 0.6s infinite;
  }
  div:nth-child(3) {
    left: 32px;
    animation: ellipsis2 0.6s infinite;
  }
  div:nth-child(4) {
    left: 56px;
    animation: ellipsis3 0.6s infinite;
  }

  @keyframes ellipsis1 {
    0% {
      transform: scale(0);
    }
    100% {
      transform: scale(1);
    }
  }
  @keyframes ellipsis3 {
    0% {
      transform: scale(1);
    }
    100% {
      transform: scale(0);
    }
  }
  @keyframes ellipsis2 {
    0% {
      transform: translate(0, 0);
    }
    100% {
      transform: translate(24px, 0);
    }
  }
`;

// ../../node_modules/@babel/runtime/helpers/esm/extends.js
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

// ../../node_modules/rc-resize-observer/es/index.js
var React7 = __toESM(require("react"));

// ../../node_modules/rc-util/es/Children/toArray.js
var import_react = __toESM(require("react"));
var import_react_is = __toESM(require_react_is());
function toArray(children) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var ret = [];
  import_react.default.Children.forEach(children, function(child) {
    if ((child === void 0 || child === null) && !option.keepEmpty) {
      return;
    }
    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if ((0, import_react_is.isFragment)(child) && child.props) {
      ret = ret.concat(toArray(child.props.children, option));
    } else {
      ret.push(child);
    }
  });
  return ret;
}

// ../../node_modules/rc-util/es/warning.js
var warned = {};
var preWarningFns = [];
var preMessage = function preMessage2(fn) {
  preWarningFns.push(fn);
};
function warning(valid, message2) {
  if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
    var finalMessage = preWarningFns.reduce(function(msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "warning");
    }, message2);
    if (finalMessage) {
      console.error("Warning: ".concat(finalMessage));
    }
  }
}
function note(valid, message2) {
  if (process.env.NODE_ENV !== "production" && !valid && console !== void 0) {
    var finalMessage = preWarningFns.reduce(function(msg, preMessageFn) {
      return preMessageFn(msg !== null && msg !== void 0 ? msg : "", "note");
    }, message2);
    if (finalMessage) {
      console.warn("Note: ".concat(finalMessage));
    }
  }
}
function resetWarned() {
  warned = {};
}
function call(method4, valid, message2) {
  if (!valid && !warned[message2]) {
    method4(false, message2);
    warned[message2] = true;
  }
}
function warningOnce(valid, message2) {
  call(warning, valid, message2);
}
function noteOnce(valid, message2) {
  call(note, valid, message2);
}
warningOnce.preMessage = preMessage;
warningOnce.resetWarned = resetWarned;
warningOnce.noteOnce = noteOnce;
var warning_default = warningOnce;

// ../../node_modules/@babel/runtime/helpers/esm/typeof.js
function _typeof(o) {
  "@babel/helpers - typeof";
  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o2) {
    return typeof o2;
  } : function(o2) {
    return o2 && "function" == typeof Symbol && o2.constructor === Symbol && o2 !== Symbol.prototype ? "symbol" : typeof o2;
  }, _typeof(o);
}

// ../../node_modules/@babel/runtime/helpers/esm/toPrimitive.js
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i))
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

// ../../node_modules/@babel/runtime/helpers/esm/toPropertyKey.js
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}

// ../../node_modules/@babel/runtime/helpers/esm/defineProperty.js
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

// ../../node_modules/@babel/runtime/helpers/esm/objectSpread2.js
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}

// ../../node_modules/rc-util/es/Dom/findDOMNode.js
var import_react2 = __toESM(require("react"));
var import_react_dom = __toESM(require("react-dom"));
function isDOM(node2) {
  return node2 instanceof HTMLElement || node2 instanceof SVGElement;
}
function findDOMNode(node2) {
  if (isDOM(node2)) {
    return node2;
  }
  if (node2 instanceof import_react2.default.Component) {
    return import_react_dom.default.findDOMNode(node2);
  }
  return null;
}

// ../../node_modules/rc-util/es/ref.js
var import_react3 = require("react");
var import_react_is2 = __toESM(require_react_is());

// ../../node_modules/rc-util/es/hooks/useMemo.js
var React3 = __toESM(require("react"));
function useMemo(getValue3, condition, shouldUpdate) {
  var cacheRef = React3.useRef({});
  if (!("value" in cacheRef.current) || shouldUpdate(cacheRef.current.condition, condition)) {
    cacheRef.current.value = getValue3();
    cacheRef.current.condition = condition;
  }
  return cacheRef.current.value;
}

// ../../node_modules/rc-util/es/ref.js
function fillRef(ref, node2) {
  if (typeof ref === "function") {
    ref(node2);
  } else if (_typeof(ref) === "object" && ref && "current" in ref) {
    ref.current = node2;
  }
}
function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }
  var refList = refs.filter(function(ref) {
    return ref;
  });
  if (refList.length <= 1) {
    return refList[0];
  }
  return function(node2) {
    refs.forEach(function(ref) {
      fillRef(ref, node2);
    });
  };
}
function useComposeRef() {
  for (var _len2 = arguments.length, refs = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    refs[_key2] = arguments[_key2];
  }
  return useMemo(function() {
    return composeRef.apply(void 0, refs);
  }, refs, function(prev2, next2) {
    return prev2.length !== next2.length || prev2.every(function(ref, i) {
      return ref !== next2[i];
    });
  });
}
function supportRef(nodeOrComponent) {
  var _type$prototype, _nodeOrComponent$prot;
  var type4 = (0, import_react_is2.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;
  if (typeof type4 === "function" && !((_type$prototype = type4.prototype) !== null && _type$prototype !== void 0 && _type$prototype.render)) {
    return false;
  }
  if (typeof nodeOrComponent === "function" && !((_nodeOrComponent$prot = nodeOrComponent.prototype) !== null && _nodeOrComponent$prot !== void 0 && _nodeOrComponent$prot.render)) {
    return false;
  }
  return true;
}

// ../../node_modules/rc-resize-observer/es/SingleObserver/index.js
var React6 = __toESM(require("react"));

// ../../node_modules/rc-resize-observer/es/Collection.js
var React4 = __toESM(require("react"));
var CollectionContext = /* @__PURE__ */ React4.createContext(null);
function Collection(_ref) {
  var children = _ref.children, onBatchResize = _ref.onBatchResize;
  var resizeIdRef = React4.useRef(0);
  var resizeInfosRef = React4.useRef([]);
  var onCollectionResize = React4.useContext(CollectionContext);
  var onResize2 = React4.useCallback(function(size, element, data) {
    resizeIdRef.current += 1;
    var currentId = resizeIdRef.current;
    resizeInfosRef.current.push({
      size,
      element,
      data
    });
    Promise.resolve().then(function() {
      if (currentId === resizeIdRef.current) {
        onBatchResize === null || onBatchResize === void 0 || onBatchResize(resizeInfosRef.current);
        resizeInfosRef.current = [];
      }
    });
    onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(size, element, data);
  }, [onBatchResize, onCollectionResize]);
  return /* @__PURE__ */ React4.createElement(CollectionContext.Provider, {
    value: onResize2
  }, children);
}

// ../../node_modules/resize-observer-polyfill/dist/ResizeObserver.es.js
var MapShim = function() {
  if (typeof Map !== "undefined") {
    return Map;
  }
  function getIndex(arr, key) {
    var result = -1;
    arr.some(function(entry, index2) {
      if (entry[0] === key) {
        result = index2;
        return true;
      }
      return false;
    });
    return result;
  }
  return (
    /** @class */
    function() {
      function class_1() {
        this.__entries__ = [];
      }
      Object.defineProperty(class_1.prototype, "size", {
        /**
         * @returns {boolean}
         */
        get: function() {
          return this.__entries__.length;
        },
        enumerable: true,
        configurable: true
      });
      class_1.prototype.get = function(key) {
        var index2 = getIndex(this.__entries__, key);
        var entry = this.__entries__[index2];
        return entry && entry[1];
      };
      class_1.prototype.set = function(key, value) {
        var index2 = getIndex(this.__entries__, key);
        if (~index2) {
          this.__entries__[index2][1] = value;
        } else {
          this.__entries__.push([key, value]);
        }
      };
      class_1.prototype.delete = function(key) {
        var entries = this.__entries__;
        var index2 = getIndex(entries, key);
        if (~index2) {
          entries.splice(index2, 1);
        }
      };
      class_1.prototype.has = function(key) {
        return !!~getIndex(this.__entries__, key);
      };
      class_1.prototype.clear = function() {
        this.__entries__.splice(0);
      };
      class_1.prototype.forEach = function(callback, ctx) {
        if (ctx === void 0) {
          ctx = null;
        }
        for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
          var entry = _a[_i];
          callback.call(ctx, entry[1], entry[0]);
        }
      };
      return class_1;
    }()
  );
}();
var isBrowser = typeof window !== "undefined" && typeof document !== "undefined" && window.document === document;
var global$1 = function() {
  if (typeof global !== "undefined" && global.Math === Math) {
    return global;
  }
  if (typeof self !== "undefined" && self.Math === Math) {
    return self;
  }
  if (typeof window !== "undefined" && window.Math === Math) {
    return window;
  }
  return Function("return this")();
}();
var requestAnimationFrame$1 = function() {
  if (typeof requestAnimationFrame === "function") {
    return requestAnimationFrame.bind(global$1);
  }
  return function(callback) {
    return setTimeout(function() {
      return callback(Date.now());
    }, 1e3 / 60);
  };
}();
var trailingTimeout = 2;
function throttle(callback, delay) {
  var leadingCall = false, trailingCall = false, lastCallTime = 0;
  function resolvePending() {
    if (leadingCall) {
      leadingCall = false;
      callback();
    }
    if (trailingCall) {
      proxy();
    }
  }
  function timeoutCallback() {
    requestAnimationFrame$1(resolvePending);
  }
  function proxy() {
    var timeStamp = Date.now();
    if (leadingCall) {
      if (timeStamp - lastCallTime < trailingTimeout) {
        return;
      }
      trailingCall = true;
    } else {
      leadingCall = true;
      trailingCall = false;
      setTimeout(timeoutCallback, delay);
    }
    lastCallTime = timeStamp;
  }
  return proxy;
}
var REFRESH_DELAY = 20;
var transitionKeys = ["top", "right", "bottom", "left", "width", "height", "size", "weight"];
var mutationObserverSupported = typeof MutationObserver !== "undefined";
var ResizeObserverController = (
  /** @class */
  function() {
    function ResizeObserverController2() {
      this.connected_ = false;
      this.mutationEventsAdded_ = false;
      this.mutationsObserver_ = null;
      this.observers_ = [];
      this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
      this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    ResizeObserverController2.prototype.addObserver = function(observer2) {
      if (!~this.observers_.indexOf(observer2)) {
        this.observers_.push(observer2);
      }
      if (!this.connected_) {
        this.connect_();
      }
    };
    ResizeObserverController2.prototype.removeObserver = function(observer2) {
      var observers2 = this.observers_;
      var index2 = observers2.indexOf(observer2);
      if (~index2) {
        observers2.splice(index2, 1);
      }
      if (!observers2.length && this.connected_) {
        this.disconnect_();
      }
    };
    ResizeObserverController2.prototype.refresh = function() {
      var changesDetected = this.updateObservers_();
      if (changesDetected) {
        this.refresh();
      }
    };
    ResizeObserverController2.prototype.updateObservers_ = function() {
      var activeObservers = this.observers_.filter(function(observer2) {
        return observer2.gatherActive(), observer2.hasActive();
      });
      activeObservers.forEach(function(observer2) {
        return observer2.broadcastActive();
      });
      return activeObservers.length > 0;
    };
    ResizeObserverController2.prototype.connect_ = function() {
      if (!isBrowser || this.connected_) {
        return;
      }
      document.addEventListener("transitionend", this.onTransitionEnd_);
      window.addEventListener("resize", this.refresh);
      if (mutationObserverSupported) {
        this.mutationsObserver_ = new MutationObserver(this.refresh);
        this.mutationsObserver_.observe(document, {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
        });
      } else {
        document.addEventListener("DOMSubtreeModified", this.refresh);
        this.mutationEventsAdded_ = true;
      }
      this.connected_ = true;
    };
    ResizeObserverController2.prototype.disconnect_ = function() {
      if (!isBrowser || !this.connected_) {
        return;
      }
      document.removeEventListener("transitionend", this.onTransitionEnd_);
      window.removeEventListener("resize", this.refresh);
      if (this.mutationsObserver_) {
        this.mutationsObserver_.disconnect();
      }
      if (this.mutationEventsAdded_) {
        document.removeEventListener("DOMSubtreeModified", this.refresh);
      }
      this.mutationsObserver_ = null;
      this.mutationEventsAdded_ = false;
      this.connected_ = false;
    };
    ResizeObserverController2.prototype.onTransitionEnd_ = function(_a) {
      var _b = _a.propertyName, propertyName = _b === void 0 ? "" : _b;
      var isReflowProperty = transitionKeys.some(function(key) {
        return !!~propertyName.indexOf(key);
      });
      if (isReflowProperty) {
        this.refresh();
      }
    };
    ResizeObserverController2.getInstance = function() {
      if (!this.instance_) {
        this.instance_ = new ResizeObserverController2();
      }
      return this.instance_;
    };
    ResizeObserverController2.instance_ = null;
    return ResizeObserverController2;
  }()
);
var defineConfigurable = function(target, props) {
  for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
    var key = _a[_i];
    Object.defineProperty(target, key, {
      value: props[key],
      enumerable: false,
      writable: false,
      configurable: true
    });
  }
  return target;
};
var getWindowOf = function(target) {
  var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
  return ownerGlobal || global$1;
};
var emptyRect = createRectInit(0, 0, 0, 0);
function toFloat(value) {
  return parseFloat(value) || 0;
}
function getBordersSize(styles) {
  var positions = [];
  for (var _i = 1; _i < arguments.length; _i++) {
    positions[_i - 1] = arguments[_i];
  }
  return positions.reduce(function(size, position2) {
    var value = styles["border-" + position2 + "-width"];
    return size + toFloat(value);
  }, 0);
}
function getPaddings(styles) {
  var positions = ["top", "right", "bottom", "left"];
  var paddings = {};
  for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
    var position2 = positions_1[_i];
    var value = styles["padding-" + position2];
    paddings[position2] = toFloat(value);
  }
  return paddings;
}
function getSVGContentRect(target) {
  var bbox = target.getBBox();
  return createRectInit(0, 0, bbox.width, bbox.height);
}
function getHTMLElementContentRect(target) {
  var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
  if (!clientWidth && !clientHeight) {
    return emptyRect;
  }
  var styles = getWindowOf(target).getComputedStyle(target);
  var paddings = getPaddings(styles);
  var horizPad = paddings.left + paddings.right;
  var vertPad = paddings.top + paddings.bottom;
  var width = toFloat(styles.width), height = toFloat(styles.height);
  if (styles.boxSizing === "border-box") {
    if (Math.round(width + horizPad) !== clientWidth) {
      width -= getBordersSize(styles, "left", "right") + horizPad;
    }
    if (Math.round(height + vertPad) !== clientHeight) {
      height -= getBordersSize(styles, "top", "bottom") + vertPad;
    }
  }
  if (!isDocumentElement(target)) {
    var vertScrollbar = Math.round(width + horizPad) - clientWidth;
    var horizScrollbar = Math.round(height + vertPad) - clientHeight;
    if (Math.abs(vertScrollbar) !== 1) {
      width -= vertScrollbar;
    }
    if (Math.abs(horizScrollbar) !== 1) {
      height -= horizScrollbar;
    }
  }
  return createRectInit(paddings.left, paddings.top, width, height);
}
var isSVGGraphicsElement = function() {
  if (typeof SVGGraphicsElement !== "undefined") {
    return function(target) {
      return target instanceof getWindowOf(target).SVGGraphicsElement;
    };
  }
  return function(target) {
    return target instanceof getWindowOf(target).SVGElement && typeof target.getBBox === "function";
  };
}();
function isDocumentElement(target) {
  return target === getWindowOf(target).document.documentElement;
}
function getContentRect(target) {
  if (!isBrowser) {
    return emptyRect;
  }
  if (isSVGGraphicsElement(target)) {
    return getSVGContentRect(target);
  }
  return getHTMLElementContentRect(target);
}
function createReadOnlyRect(_a) {
  var x2 = _a.x, y2 = _a.y, width = _a.width, height = _a.height;
  var Constr = typeof DOMRectReadOnly !== "undefined" ? DOMRectReadOnly : Object;
  var rect = Object.create(Constr.prototype);
  defineConfigurable(rect, {
    x: x2,
    y: y2,
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: height + y2,
    left: x2
  });
  return rect;
}
function createRectInit(x2, y2, width, height) {
  return { x: x2, y: y2, width, height };
}
var ResizeObservation = (
  /** @class */
  function() {
    function ResizeObservation2(target) {
      this.broadcastWidth = 0;
      this.broadcastHeight = 0;
      this.contentRect_ = createRectInit(0, 0, 0, 0);
      this.target = target;
    }
    ResizeObservation2.prototype.isActive = function() {
      var rect = getContentRect(this.target);
      this.contentRect_ = rect;
      return rect.width !== this.broadcastWidth || rect.height !== this.broadcastHeight;
    };
    ResizeObservation2.prototype.broadcastRect = function() {
      var rect = this.contentRect_;
      this.broadcastWidth = rect.width;
      this.broadcastHeight = rect.height;
      return rect;
    };
    return ResizeObservation2;
  }()
);
var ResizeObserverEntry = (
  /** @class */
  function() {
    function ResizeObserverEntry2(target, rectInit) {
      var contentRect = createReadOnlyRect(rectInit);
      defineConfigurable(this, { target, contentRect });
    }
    return ResizeObserverEntry2;
  }()
);
var ResizeObserverSPI = (
  /** @class */
  function() {
    function ResizeObserverSPI2(callback, controller, callbackCtx) {
      this.activeObservations_ = [];
      this.observations_ = new MapShim();
      if (typeof callback !== "function") {
        throw new TypeError("The callback provided as parameter 1 is not a function.");
      }
      this.callback_ = callback;
      this.controller_ = controller;
      this.callbackCtx_ = callbackCtx;
    }
    ResizeObserverSPI2.prototype.observe = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (observations.has(target)) {
        return;
      }
      observations.set(target, new ResizeObservation(target));
      this.controller_.addObserver(this);
      this.controller_.refresh();
    };
    ResizeObserverSPI2.prototype.unobserve = function(target) {
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      if (typeof Element === "undefined" || !(Element instanceof Object)) {
        return;
      }
      if (!(target instanceof getWindowOf(target).Element)) {
        throw new TypeError('parameter 1 is not of type "Element".');
      }
      var observations = this.observations_;
      if (!observations.has(target)) {
        return;
      }
      observations.delete(target);
      if (!observations.size) {
        this.controller_.removeObserver(this);
      }
    };
    ResizeObserverSPI2.prototype.disconnect = function() {
      this.clearActive();
      this.observations_.clear();
      this.controller_.removeObserver(this);
    };
    ResizeObserverSPI2.prototype.gatherActive = function() {
      var _this = this;
      this.clearActive();
      this.observations_.forEach(function(observation) {
        if (observation.isActive()) {
          _this.activeObservations_.push(observation);
        }
      });
    };
    ResizeObserverSPI2.prototype.broadcastActive = function() {
      if (!this.hasActive()) {
        return;
      }
      var ctx = this.callbackCtx_;
      var entries = this.activeObservations_.map(function(observation) {
        return new ResizeObserverEntry(observation.target, observation.broadcastRect());
      });
      this.callback_.call(ctx, entries, ctx);
      this.clearActive();
    };
    ResizeObserverSPI2.prototype.clearActive = function() {
      this.activeObservations_.splice(0);
    };
    ResizeObserverSPI2.prototype.hasActive = function() {
      return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI2;
  }()
);
var observers = typeof WeakMap !== "undefined" ? /* @__PURE__ */ new WeakMap() : new MapShim();
var ResizeObserver2 = (
  /** @class */
  function() {
    function ResizeObserver4(callback) {
      if (!(this instanceof ResizeObserver4)) {
        throw new TypeError("Cannot call a class as a function.");
      }
      if (!arguments.length) {
        throw new TypeError("1 argument required, but only 0 present.");
      }
      var controller = ResizeObserverController.getInstance();
      var observer2 = new ResizeObserverSPI(callback, controller, this);
      observers.set(this, observer2);
    }
    return ResizeObserver4;
  }()
);
[
  "observe",
  "unobserve",
  "disconnect"
].forEach(function(method4) {
  ResizeObserver2.prototype[method4] = function() {
    var _a;
    return (_a = observers.get(this))[method4].apply(_a, arguments);
  };
});
var index = function() {
  if (typeof global$1.ResizeObserver !== "undefined") {
    return global$1.ResizeObserver;
  }
  return ResizeObserver2;
}();
var ResizeObserver_es_default = index;

// ../../node_modules/rc-resize-observer/es/utils/observerUtil.js
var elementListeners = /* @__PURE__ */ new Map();
function onResize(entities) {
  entities.forEach(function(entity) {
    var _elementListeners$get;
    var target = entity.target;
    (_elementListeners$get = elementListeners.get(target)) === null || _elementListeners$get === void 0 || _elementListeners$get.forEach(function(listener) {
      return listener(target);
    });
  });
}
var resizeObserver = new ResizeObserver_es_default(onResize);
var _el = process.env.NODE_ENV !== "production" ? elementListeners : null;
var _rs = process.env.NODE_ENV !== "production" ? onResize : null;
function observe(element, callback) {
  if (!elementListeners.has(element)) {
    elementListeners.set(element, /* @__PURE__ */ new Set());
    resizeObserver.observe(element);
  }
  elementListeners.get(element).add(callback);
}
function unobserve(element, callback) {
  if (elementListeners.has(element)) {
    elementListeners.get(element).delete(callback);
    if (!elementListeners.get(element).size) {
      resizeObserver.unobserve(element);
      elementListeners.delete(element);
    }
  }
}

// ../../node_modules/@babel/runtime/helpers/esm/classCallCheck.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

// ../../node_modules/@babel/runtime/helpers/esm/createClass.js
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor)
      descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps)
    _defineProperties(Constructor.prototype, protoProps);
  if (staticProps)
    _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}

// ../../node_modules/@babel/runtime/helpers/esm/setPrototypeOf.js
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf3(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf(o, p);
}

// ../../node_modules/@babel/runtime/helpers/esm/inherits.js
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass)
    _setPrototypeOf(subClass, superClass);
}

// ../../node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf3(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf(o);
}

// ../../node_modules/@babel/runtime/helpers/esm/isNativeReflectConstruct.js
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch (t2) {
  }
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct3() {
    return !!t;
  })();
}

// ../../node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
function _assertThisInitialized(self2) {
  if (self2 === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self2;
}

// ../../node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
function _possibleConstructorReturn(self2, call2) {
  if (call2 && (_typeof(call2) === "object" || typeof call2 === "function")) {
    return call2;
  } else if (call2 !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return _assertThisInitialized(self2);
}

// ../../node_modules/@babel/runtime/helpers/esm/createSuper.js
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived), result;
    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return _possibleConstructorReturn(this, result);
  };
}

// ../../node_modules/rc-resize-observer/es/SingleObserver/DomWrapper.js
var React5 = __toESM(require("react"));
var DomWrapper = /* @__PURE__ */ function(_React$Component) {
  _inherits(DomWrapper3, _React$Component);
  var _super = _createSuper(DomWrapper3);
  function DomWrapper3() {
    _classCallCheck(this, DomWrapper3);
    return _super.apply(this, arguments);
  }
  _createClass(DomWrapper3, [{
    key: "render",
    value: function render2() {
      return this.props.children;
    }
  }]);
  return DomWrapper3;
}(React5.Component);

// ../../node_modules/rc-resize-observer/es/SingleObserver/index.js
function SingleObserver(props, ref) {
  var children = props.children, disabled = props.disabled;
  var elementRef = React6.useRef(null);
  var wrapperRef = React6.useRef(null);
  var onCollectionResize = React6.useContext(CollectionContext);
  var isRenderProps = typeof children === "function";
  var mergedChildren = isRenderProps ? children(elementRef) : children;
  var sizeRef = React6.useRef({
    width: -1,
    height: -1,
    offsetWidth: -1,
    offsetHeight: -1
  });
  var canRef = !isRenderProps && /* @__PURE__ */ React6.isValidElement(mergedChildren) && supportRef(mergedChildren);
  var originRef = canRef ? mergedChildren.ref : null;
  var mergedRef = useComposeRef(originRef, elementRef);
  var getDom = function getDom2() {
    var _elementRef$current;
    return findDOMNode(elementRef.current) || // Support `nativeElement` format
    (elementRef.current && _typeof(elementRef.current) === "object" ? findDOMNode((_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.nativeElement) : null) || findDOMNode(wrapperRef.current);
  };
  React6.useImperativeHandle(ref, function() {
    return getDom();
  });
  var propsRef = React6.useRef(props);
  propsRef.current = props;
  var onInternalResize = React6.useCallback(function(target) {
    var _propsRef$current = propsRef.current, onResize2 = _propsRef$current.onResize, data = _propsRef$current.data;
    var _target$getBoundingCl = target.getBoundingClientRect(), width = _target$getBoundingCl.width, height = _target$getBoundingCl.height;
    var offsetWidth = target.offsetWidth, offsetHeight = target.offsetHeight;
    var fixedWidth = Math.floor(width);
    var fixedHeight = Math.floor(height);
    if (sizeRef.current.width !== fixedWidth || sizeRef.current.height !== fixedHeight || sizeRef.current.offsetWidth !== offsetWidth || sizeRef.current.offsetHeight !== offsetHeight) {
      var size = {
        width: fixedWidth,
        height: fixedHeight,
        offsetWidth,
        offsetHeight
      };
      sizeRef.current = size;
      var mergedOffsetWidth = offsetWidth === Math.round(width) ? width : offsetWidth;
      var mergedOffsetHeight = offsetHeight === Math.round(height) ? height : offsetHeight;
      var sizeInfo = _objectSpread2(_objectSpread2({}, size), {}, {
        offsetWidth: mergedOffsetWidth,
        offsetHeight: mergedOffsetHeight
      });
      onCollectionResize === null || onCollectionResize === void 0 || onCollectionResize(sizeInfo, target, data);
      if (onResize2) {
        Promise.resolve().then(function() {
          onResize2(sizeInfo, target);
        });
      }
    }
  }, []);
  React6.useEffect(function() {
    var currentElement = getDom();
    if (currentElement && !disabled) {
      observe(currentElement, onInternalResize);
    }
    return function() {
      return unobserve(currentElement, onInternalResize);
    };
  }, [elementRef.current, disabled]);
  return /* @__PURE__ */ React6.createElement(DomWrapper, {
    ref: wrapperRef
  }, canRef ? /* @__PURE__ */ React6.cloneElement(mergedChildren, {
    ref: mergedRef
  }) : mergedChildren);
}
var RefSingleObserver = /* @__PURE__ */ React6.forwardRef(SingleObserver);
if (process.env.NODE_ENV !== "production") {
  RefSingleObserver.displayName = "SingleObserver";
}
var SingleObserver_default = RefSingleObserver;

// ../../node_modules/rc-resize-observer/es/index.js
var INTERNAL_PREFIX_KEY = "rc-observer-key";
function ResizeObserver3(props, ref) {
  var children = props.children;
  var childNodes = typeof children === "function" ? [children] : toArray(children);
  if (process.env.NODE_ENV !== "production") {
    if (childNodes.length > 1) {
      warning(false, "Find more than one child node with `children` in ResizeObserver. Please use ResizeObserver.Collection instead.");
    } else if (childNodes.length === 0) {
      warning(false, "`children` of ResizeObserver is empty. Nothing is in observe.");
    }
  }
  return childNodes.map(function(child, index2) {
    var key = (child === null || child === void 0 ? void 0 : child.key) || "".concat(INTERNAL_PREFIX_KEY, "-").concat(index2);
    return /* @__PURE__ */ React7.createElement(SingleObserver_default, _extends({}, props, {
      key,
      ref: index2 === 0 ? ref : void 0
    }), child);
  });
}
var RefResizeObserver = /* @__PURE__ */ React7.forwardRef(ResizeObserver3);
if (process.env.NODE_ENV !== "production") {
  RefResizeObserver.displayName = "ResizeObserver";
}
RefResizeObserver.Collection = Collection;
var es_default = RefResizeObserver;

// ../../node_modules/rc-util/es/omit.js
function omit(obj, fields) {
  var clone = _objectSpread2({}, obj);
  if (Array.isArray(fields)) {
    fields.forEach(function(key) {
      delete clone[key];
    });
  }
  return clone;
}

// ../../node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length)
    len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++)
    arr2[i] = arr[i];
  return arr2;
}

// ../../node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr))
    return _arrayLikeToArray(arr);
}

// ../../node_modules/@babel/runtime/helpers/esm/iterableToArray.js
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null)
    return Array.from(iter);
}

// ../../node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js
function _unsupportedIterableToArray(o, minLen) {
  if (!o)
    return;
  if (typeof o === "string")
    return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor)
    n = o.constructor.name;
  if (n === "Map" || n === "Set")
    return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return _arrayLikeToArray(o, minLen);
}

// ../../node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// ../../node_modules/@babel/runtime/helpers/esm/toConsumableArray.js
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

// ../../node_modules/rc-util/es/raf.js
var raf = function raf2(callback) {
  return +setTimeout(callback, 16);
};
var caf = function caf2(num) {
  return clearTimeout(num);
};
if (typeof window !== "undefined" && "requestAnimationFrame" in window) {
  raf = function raf3(callback) {
    return window.requestAnimationFrame(callback);
  };
  caf = function caf3(handle) {
    return window.cancelAnimationFrame(handle);
  };
}
var rafUUID = 0;
var rafIds = /* @__PURE__ */ new Map();
function cleanup(id) {
  rafIds.delete(id);
}
var wrapperRaf = function wrapperRaf2(callback) {
  var times = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  rafUUID += 1;
  var id = rafUUID;
  function callRef(leftTimes) {
    if (leftTimes === 0) {
      cleanup(id);
      callback();
    } else {
      var realId = raf(function() {
        callRef(leftTimes - 1);
      });
      rafIds.set(id, realId);
    }
  }
  callRef(times);
  return id;
};
wrapperRaf.cancel = function(id) {
  var realId = rafIds.get(id);
  cleanup(id);
  return caf(realId);
};
if (process.env.NODE_ENV !== "production") {
  wrapperRaf.ids = function() {
    return rafIds;
  };
}
var raf_default = wrapperRaf;

// ../../node_modules/antd/es/config-provider/index.js
var React36 = __toESM(require("react"));

// ../../node_modules/@babel/runtime/helpers/esm/arrayWithHoles.js
function _arrayWithHoles(arr) {
  if (Array.isArray(arr))
    return arr;
}

// ../../node_modules/@babel/runtime/helpers/esm/iterableToArrayLimit.js
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e, n, i, u, a = [], f = true, o = false;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t)
          return;
        f = false;
      } else
        for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = true)
          ;
    } catch (r2) {
      o = true, n = r2;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u))
          return;
      } finally {
        if (o)
          throw n;
      }
    }
    return a;
  }
}

// ../../node_modules/@babel/runtime/helpers/esm/nonIterableRest.js
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// ../../node_modules/@babel/runtime/helpers/esm/slicedToArray.js
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

// ../../node_modules/@emotion/hash/dist/hash.esm.js
function murmur2(str) {
  var h = 0;
  var k, i = 0, len = str.length;
  for (; len >= 4; ++i, len -= 4) {
    k = str.charCodeAt(i) & 255 | (str.charCodeAt(++i) & 255) << 8 | (str.charCodeAt(++i) & 255) << 16 | (str.charCodeAt(++i) & 255) << 24;
    k = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16);
    k ^= /* k >>> r: */
    k >>> 24;
    h = /* Math.imul(k, m): */
    (k & 65535) * 1540483477 + ((k >>> 16) * 59797 << 16) ^ /* Math.imul(h, m): */
    (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  switch (len) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 255) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 255) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 255;
      h = /* Math.imul(h, m): */
      (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  }
  h ^= h >>> 13;
  h = /* Math.imul(h, m): */
  (h & 65535) * 1540483477 + ((h >>> 16) * 59797 << 16);
  return ((h ^ h >>> 15) >>> 0).toString(36);
}
var hash_esm_default = murmur2;

// ../../node_modules/rc-util/es/Dom/canUseDom.js
function canUseDom() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
}

// ../../node_modules/rc-util/es/Dom/contains.js
function contains(root, n) {
  if (!root) {
    return false;
  }
  if (root.contains) {
    return root.contains(n);
  }
  var node2 = n;
  while (node2) {
    if (node2 === root) {
      return true;
    }
    node2 = node2.parentNode;
  }
  return false;
}

// ../../node_modules/rc-util/es/Dom/dynamicCSS.js
var APPEND_ORDER = "data-rc-order";
var APPEND_PRIORITY = "data-rc-priority";
var MARK_KEY = "rc-util-key";
var containerCache = /* @__PURE__ */ new Map();
function getMark() {
  var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, mark = _ref.mark;
  if (mark) {
    return mark.startsWith("data-") ? mark : "data-".concat(mark);
  }
  return MARK_KEY;
}
function getContainer(option) {
  if (option.attachTo) {
    return option.attachTo;
  }
  var head = document.querySelector("head");
  return head || document.body;
}
function getOrder(prepend) {
  if (prepend === "queue") {
    return "prependQueue";
  }
  return prepend ? "prepend" : "append";
}
function findStyles(container) {
  return Array.from((containerCache.get(container) || container).children).filter(function(node2) {
    return node2.tagName === "STYLE";
  });
}
function injectCSS(css2) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  if (!canUseDom()) {
    return null;
  }
  var csp = option.csp, prepend = option.prepend, _option$priority = option.priority, priority = _option$priority === void 0 ? 0 : _option$priority;
  var mergedOrder = getOrder(prepend);
  var isPrependQueue = mergedOrder === "prependQueue";
  var styleNode = document.createElement("style");
  styleNode.setAttribute(APPEND_ORDER, mergedOrder);
  if (isPrependQueue && priority) {
    styleNode.setAttribute(APPEND_PRIORITY, "".concat(priority));
  }
  if (csp !== null && csp !== void 0 && csp.nonce) {
    styleNode.nonce = csp === null || csp === void 0 ? void 0 : csp.nonce;
  }
  styleNode.innerHTML = css2;
  var container = getContainer(option);
  var firstChild = container.firstChild;
  if (prepend) {
    if (isPrependQueue) {
      var existStyle = findStyles(container).filter(function(node2) {
        if (!["prepend", "prependQueue"].includes(node2.getAttribute(APPEND_ORDER))) {
          return false;
        }
        var nodePriority = Number(node2.getAttribute(APPEND_PRIORITY) || 0);
        return priority >= nodePriority;
      });
      if (existStyle.length) {
        container.insertBefore(styleNode, existStyle[existStyle.length - 1].nextSibling);
        return styleNode;
      }
    }
    container.insertBefore(styleNode, firstChild);
  } else {
    container.appendChild(styleNode);
  }
  return styleNode;
}
function findExistNode(key) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var container = getContainer(option);
  return findStyles(container).find(function(node2) {
    return node2.getAttribute(getMark(option)) === key;
  });
}
function removeCSS(key) {
  var option = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var existNode = findExistNode(key, option);
  if (existNode) {
    var container = getContainer(option);
    container.removeChild(existNode);
  }
}
function syncRealContainer(container, option) {
  var cachedRealContainer = containerCache.get(container);
  if (!cachedRealContainer || !contains(document, cachedRealContainer)) {
    var placeholderStyle = injectCSS("", option);
    var parentNode = placeholderStyle.parentNode;
    containerCache.set(container, parentNode);
    container.removeChild(placeholderStyle);
  }
}
function updateCSS(css2, key) {
  var option = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var container = getContainer(option);
  syncRealContainer(container, option);
  var existNode = findExistNode(key, option);
  if (existNode) {
    var _option$csp, _option$csp2;
    if ((_option$csp = option.csp) !== null && _option$csp !== void 0 && _option$csp.nonce && existNode.nonce !== ((_option$csp2 = option.csp) === null || _option$csp2 === void 0 ? void 0 : _option$csp2.nonce)) {
      var _option$csp3;
      existNode.nonce = (_option$csp3 = option.csp) === null || _option$csp3 === void 0 ? void 0 : _option$csp3.nonce;
    }
    if (existNode.innerHTML !== css2) {
      existNode.innerHTML = css2;
    }
    return existNode;
  }
  var newNode = injectCSS(css2, option);
  newNode.setAttribute(getMark(option), key);
  return newNode;
}

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCacheToken.js
var import_react4 = require("react");

// ../../node_modules/@babel/runtime/helpers/esm/objectWithoutPropertiesLoose.js
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null)
    return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0)
      continue;
    target[key] = source[key];
  }
  return target;
}

// ../../node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
function _objectWithoutProperties(source, excluded) {
  if (source == null)
    return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0)
        continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key))
        continue;
      target[key] = source[key];
    }
  }
  return target;
}

// ../../node_modules/rc-util/es/isEqual.js
function isEqual(obj1, obj2) {
  var shallow = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  var refSet = /* @__PURE__ */ new Set();
  function deepEqual(a, b) {
    var level = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1;
    var circular = refSet.has(a);
    warning_default(!circular, "Warning: There may be circular references");
    if (circular) {
      return false;
    }
    if (a === b) {
      return true;
    }
    if (shallow && level > 1) {
      return false;
    }
    refSet.add(a);
    var newLevel = level + 1;
    if (Array.isArray(a)) {
      if (!Array.isArray(b) || a.length !== b.length) {
        return false;
      }
      for (var i = 0; i < a.length; i++) {
        if (!deepEqual(a[i], b[i], newLevel)) {
          return false;
        }
      }
      return true;
    }
    if (a && b && _typeof(a) === "object" && _typeof(b) === "object") {
      var keys3 = Object.keys(a);
      if (keys3.length !== Object.keys(b).length) {
        return false;
      }
      return keys3.every(function(key) {
        return deepEqual(a[key], b[key], newLevel);
      });
    }
    return false;
  }
  return deepEqual(obj1, obj2);
}
var isEqual_default = isEqual;

// ../../node_modules/@ant-design/cssinjs/es/StyleContext.js
var React8 = __toESM(require("react"));

// ../../node_modules/@ant-design/cssinjs/es/Cache.js
var SPLIT = "%";
var Entity = /* @__PURE__ */ function() {
  function Entity3(instanceId) {
    _classCallCheck(this, Entity3);
    _defineProperty(this, "instanceId", void 0);
    _defineProperty(this, "cache", /* @__PURE__ */ new Map());
    this.instanceId = instanceId;
  }
  _createClass(Entity3, [{
    key: "get",
    value: function get2(keys3) {
      return this.cache.get(keys3.join(SPLIT)) || null;
    }
  }, {
    key: "update",
    value: function update(keys3, valueFn) {
      var path2 = keys3.join(SPLIT);
      var prevValue = this.cache.get(path2);
      var nextValue = valueFn(prevValue);
      if (nextValue === null) {
        this.cache.delete(path2);
      } else {
        this.cache.set(path2, nextValue);
      }
    }
  }]);
  return Entity3;
}();
var Cache_default = Entity;

// ../../node_modules/@ant-design/cssinjs/es/StyleContext.js
var ATTR_TOKEN = "data-token-hash";
var ATTR_MARK = "data-css-hash";
var ATTR_CACHE_PATH = "data-cache-path";
var CSS_IN_JS_INSTANCE = "__cssinjs_instance__";
function createCache() {
  var cssinjsInstanceId = Math.random().toString(12).slice(2);
  if (typeof document !== "undefined" && document.head && document.body) {
    var styles = document.body.querySelectorAll("style[".concat(ATTR_MARK, "]")) || [];
    var firstChild = document.head.firstChild;
    Array.from(styles).forEach(function(style2) {
      style2[CSS_IN_JS_INSTANCE] = style2[CSS_IN_JS_INSTANCE] || cssinjsInstanceId;
      if (style2[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) {
        document.head.insertBefore(style2, firstChild);
      }
    });
    var styleHash = {};
    Array.from(document.querySelectorAll("style[".concat(ATTR_MARK, "]"))).forEach(function(style2) {
      var hash = style2.getAttribute(ATTR_MARK);
      if (styleHash[hash]) {
        if (style2[CSS_IN_JS_INSTANCE] === cssinjsInstanceId) {
          var _style$parentNode;
          (_style$parentNode = style2.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style2);
        }
      } else {
        styleHash[hash] = true;
      }
    });
  }
  return new Cache_default(cssinjsInstanceId);
}
var StyleContext = /* @__PURE__ */ React8.createContext({
  hashPriority: "low",
  cache: createCache(),
  defaultCache: true
});
var StyleContext_default = StyleContext;

// ../../node_modules/@ant-design/cssinjs/es/theme/ThemeCache.js
function sameDerivativeOption(left, right) {
  if (left.length !== right.length) {
    return false;
  }
  for (var i = 0; i < left.length; i++) {
    if (left[i] !== right[i]) {
      return false;
    }
  }
  return true;
}
var ThemeCache = /* @__PURE__ */ function() {
  function ThemeCache2() {
    _classCallCheck(this, ThemeCache2);
    _defineProperty(this, "cache", void 0);
    _defineProperty(this, "keys", void 0);
    _defineProperty(this, "cacheCallTimes", void 0);
    this.cache = /* @__PURE__ */ new Map();
    this.keys = [];
    this.cacheCallTimes = 0;
  }
  _createClass(ThemeCache2, [{
    key: "size",
    value: function size() {
      return this.keys.length;
    }
  }, {
    key: "internalGet",
    value: function internalGet(derivativeOption) {
      var _cache2, _cache3;
      var updateCallTimes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      var cache = {
        map: this.cache
      };
      derivativeOption.forEach(function(derivative2) {
        if (!cache) {
          cache = void 0;
        } else {
          var _cache;
          cache = (_cache = cache) === null || _cache === void 0 || (_cache = _cache.map) === null || _cache === void 0 ? void 0 : _cache.get(derivative2);
        }
      });
      if ((_cache2 = cache) !== null && _cache2 !== void 0 && _cache2.value && updateCallTimes) {
        cache.value[1] = this.cacheCallTimes++;
      }
      return (_cache3 = cache) === null || _cache3 === void 0 ? void 0 : _cache3.value;
    }
  }, {
    key: "get",
    value: function get2(derivativeOption) {
      var _this$internalGet;
      return (_this$internalGet = this.internalGet(derivativeOption, true)) === null || _this$internalGet === void 0 ? void 0 : _this$internalGet[0];
    }
  }, {
    key: "has",
    value: function has(derivativeOption) {
      return !!this.internalGet(derivativeOption);
    }
  }, {
    key: "set",
    value: function set2(derivativeOption, value) {
      var _this = this;
      if (!this.has(derivativeOption)) {
        if (this.size() + 1 > ThemeCache2.MAX_CACHE_SIZE + ThemeCache2.MAX_CACHE_OFFSET) {
          var _this$keys$reduce = this.keys.reduce(function(result, key) {
            var _result = _slicedToArray(result, 2), callTimes = _result[1];
            if (_this.internalGet(key)[1] < callTimes) {
              return [key, _this.internalGet(key)[1]];
            }
            return result;
          }, [this.keys[0], this.cacheCallTimes]), _this$keys$reduce2 = _slicedToArray(_this$keys$reduce, 1), targetKey = _this$keys$reduce2[0];
          this.delete(targetKey);
        }
        this.keys.push(derivativeOption);
      }
      var cache = this.cache;
      derivativeOption.forEach(function(derivative2, index2) {
        if (index2 === derivativeOption.length - 1) {
          cache.set(derivative2, {
            value: [value, _this.cacheCallTimes++]
          });
        } else {
          var cacheValue = cache.get(derivative2);
          if (!cacheValue) {
            cache.set(derivative2, {
              map: /* @__PURE__ */ new Map()
            });
          } else if (!cacheValue.map) {
            cacheValue.map = /* @__PURE__ */ new Map();
          }
          cache = cache.get(derivative2).map;
        }
      });
    }
  }, {
    key: "deleteByPath",
    value: function deleteByPath(currentCache, derivatives) {
      var cache = currentCache.get(derivatives[0]);
      if (derivatives.length === 1) {
        var _cache$value;
        if (!cache.map) {
          currentCache.delete(derivatives[0]);
        } else {
          currentCache.set(derivatives[0], {
            map: cache.map
          });
        }
        return (_cache$value = cache.value) === null || _cache$value === void 0 ? void 0 : _cache$value[0];
      }
      var result = this.deleteByPath(cache.map, derivatives.slice(1));
      if ((!cache.map || cache.map.size === 0) && !cache.value) {
        currentCache.delete(derivatives[0]);
      }
      return result;
    }
  }, {
    key: "delete",
    value: function _delete(derivativeOption) {
      if (this.has(derivativeOption)) {
        this.keys = this.keys.filter(function(item) {
          return !sameDerivativeOption(item, derivativeOption);
        });
        return this.deleteByPath(this.cache, derivativeOption);
      }
      return void 0;
    }
  }]);
  return ThemeCache2;
}();
_defineProperty(ThemeCache, "MAX_CACHE_SIZE", 20);
_defineProperty(ThemeCache, "MAX_CACHE_OFFSET", 5);

// ../../node_modules/@ant-design/cssinjs/es/theme/Theme.js
var uuid = 0;
var Theme = /* @__PURE__ */ function() {
  function Theme3(derivatives) {
    _classCallCheck(this, Theme3);
    _defineProperty(this, "derivatives", void 0);
    _defineProperty(this, "id", void 0);
    this.derivatives = Array.isArray(derivatives) ? derivatives : [derivatives];
    this.id = uuid;
    if (derivatives.length === 0) {
      warning(derivatives.length > 0, "[Ant Design CSS-in-JS] Theme should have at least one derivative function.");
    }
    uuid += 1;
  }
  _createClass(Theme3, [{
    key: "getDerivativeToken",
    value: function getDerivativeToken(token2) {
      return this.derivatives.reduce(function(result, derivative2) {
        return derivative2(token2, result);
      }, void 0);
    }
  }]);
  return Theme3;
}();

// ../../node_modules/@ant-design/cssinjs/es/theme/createTheme.js
var cacheThemes = new ThemeCache();
function createTheme(derivatives) {
  var derivativeArr = Array.isArray(derivatives) ? derivatives : [derivatives];
  if (!cacheThemes.has(derivativeArr)) {
    cacheThemes.set(derivativeArr, new Theme(derivativeArr));
  }
  return cacheThemes.get(derivativeArr);
}

// ../../node_modules/@ant-design/cssinjs/es/util/index.js
var resultCache = /* @__PURE__ */ new WeakMap();
var RESULT_VALUE = {};
function memoResult(callback, deps) {
  var current = resultCache;
  for (var i = 0; i < deps.length; i += 1) {
    var dep = deps[i];
    if (!current.has(dep)) {
      current.set(dep, /* @__PURE__ */ new WeakMap());
    }
    current = current.get(dep);
  }
  if (!current.has(RESULT_VALUE)) {
    current.set(RESULT_VALUE, callback());
  }
  return current.get(RESULT_VALUE);
}
var flattenTokenCache = /* @__PURE__ */ new WeakMap();
function flattenToken(token2) {
  var str = flattenTokenCache.get(token2) || "";
  if (!str) {
    Object.keys(token2).forEach(function(key) {
      var value = token2[key];
      str += key;
      if (value instanceof Theme) {
        str += value.id;
      } else if (value && _typeof(value) === "object") {
        str += flattenToken(value);
      } else {
        str += value;
      }
    });
    flattenTokenCache.set(token2, str);
  }
  return str;
}
function token2key(token2, salt) {
  return hash_esm_default("".concat(salt, "_").concat(flattenToken(token2)));
}
var randomSelectorKey = "random-".concat(Date.now(), "-").concat(Math.random()).replace(/\./g, "");
var checkContent = "_bAmBoO_";
function supportSelector(styleStr, handleElement, supportCheck) {
  if (canUseDom()) {
    var _getComputedStyle$con, _ele$parentNode;
    updateCSS(styleStr, randomSelectorKey);
    var _ele = document.createElement("div");
    _ele.style.position = "fixed";
    _ele.style.left = "0";
    _ele.style.top = "0";
    handleElement === null || handleElement === void 0 || handleElement(_ele);
    document.body.appendChild(_ele);
    if (process.env.NODE_ENV !== "production") {
      _ele.innerHTML = "Test";
      _ele.style.zIndex = "9999999";
    }
    var support = supportCheck ? supportCheck(_ele) : (_getComputedStyle$con = getComputedStyle(_ele).content) === null || _getComputedStyle$con === void 0 ? void 0 : _getComputedStyle$con.includes(checkContent);
    (_ele$parentNode = _ele.parentNode) === null || _ele$parentNode === void 0 || _ele$parentNode.removeChild(_ele);
    removeCSS(randomSelectorKey);
    return support;
  }
  return false;
}
var canLayer = void 0;
function supportLayer() {
  if (canLayer === void 0) {
    canLayer = supportSelector("@layer ".concat(randomSelectorKey, " { .").concat(randomSelectorKey, ' { content: "').concat(checkContent, '"!important; } }'), function(ele) {
      ele.className = randomSelectorKey;
    });
  }
  return canLayer;
}
var isClientSide = canUseDom();
function unit(num) {
  if (typeof num === "number") {
    return "".concat(num, "px");
  }
  return num;
}
function toStyleStr(style2, tokenKey, styleId) {
  var _objectSpread22;
  var customizeAttrs = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  var plain = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  if (plain) {
    return style2;
  }
  var attrs = _objectSpread2(_objectSpread2({}, customizeAttrs), {}, (_objectSpread22 = {}, _defineProperty(_objectSpread22, ATTR_TOKEN, tokenKey), _defineProperty(_objectSpread22, ATTR_MARK, styleId), _objectSpread22));
  var attrStr = Object.keys(attrs).map(function(attr) {
    var val = attrs[attr];
    return val ? "".concat(attr, '="').concat(val, '"') : null;
  }).filter(function(v) {
    return v;
  }).join(" ");
  return "<style ".concat(attrStr, ">").concat(style2, "</style>");
}

// ../../node_modules/@ant-design/cssinjs/es/util/css-variables.js
var token2CSSVar = function token2CSSVar2(token2) {
  var prefix = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  return "--".concat(prefix ? "".concat(prefix, "-") : "").concat(token2).replace(/([a-z0-9])([A-Z])/g, "$1-$2").replace(/([A-Z]+)([A-Z][a-z0-9]+)/g, "$1-$2").replace(/([a-z])([A-Z0-9])/g, "$1-$2").toLowerCase();
};
var serializeCSSVar = function serializeCSSVar2(cssVars, hashId, options) {
  if (!Object.keys(cssVars).length) {
    return "";
  }
  return ".".concat(hashId).concat(options !== null && options !== void 0 && options.scope ? ".".concat(options.scope) : "", "{").concat(Object.entries(cssVars).map(function(_ref) {
    var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
    return "".concat(key, ":").concat(value, ";");
  }).join(""), "}");
};
var transformToken = function transformToken2(token2, themeKey, config) {
  var cssVars = {};
  var result = {};
  Object.entries(token2).forEach(function(_ref3) {
    var _config$preserve, _config$ignore;
    var _ref4 = _slicedToArray(_ref3, 2), key = _ref4[0], value = _ref4[1];
    if (config !== null && config !== void 0 && (_config$preserve = config.preserve) !== null && _config$preserve !== void 0 && _config$preserve[key]) {
      result[key] = value;
    } else if ((typeof value === "string" || typeof value === "number") && !(config !== null && config !== void 0 && (_config$ignore = config.ignore) !== null && _config$ignore !== void 0 && _config$ignore[key])) {
      var _config$unitless;
      var cssVar = token2CSSVar(key, config === null || config === void 0 ? void 0 : config.prefix);
      cssVars[cssVar] = typeof value === "number" && !(config !== null && config !== void 0 && (_config$unitless = config.unitless) !== null && _config$unitless !== void 0 && _config$unitless[key]) ? "".concat(value, "px") : String(value);
      result[key] = "var(".concat(cssVar, ")");
    }
  });
  return [result, serializeCSSVar(cssVars, themeKey, {
    scope: config === null || config === void 0 ? void 0 : config.scope
  })];
};

// ../../node_modules/@ant-design/cssinjs/es/hooks/useGlobalCache.js
var React12 = __toESM(require("react"));

// ../../node_modules/rc-util/es/hooks/useLayoutEffect.js
var React9 = __toESM(require("react"));
var useInternalLayoutEffect = process.env.NODE_ENV !== "test" && canUseDom() ? React9.useLayoutEffect : React9.useEffect;
var useLayoutEffect2 = function useLayoutEffect3(callback, deps) {
  var firstMountRef = React9.useRef(true);
  useInternalLayoutEffect(function() {
    return callback(firstMountRef.current);
  }, deps);
  useInternalLayoutEffect(function() {
    firstMountRef.current = false;
    return function() {
      firstMountRef.current = true;
    };
  }, []);
};
var useLayoutUpdateEffect = function useLayoutUpdateEffect2(callback, deps) {
  useLayoutEffect2(function(firstMount) {
    if (!firstMount) {
      return callback();
    }
  }, deps);
};
var useLayoutEffect_default = useLayoutEffect2;

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCompatibleInsertionEffect.js
var React10 = __toESM(require("react"));
var fullClone = _objectSpread2({}, React10);
var useInsertionEffect = fullClone.useInsertionEffect;
var useInsertionEffectPolyfill = function useInsertionEffectPolyfill2(renderEffect, effect, deps) {
  React10.useMemo(renderEffect, deps);
  useLayoutEffect_default(function() {
    return effect(true);
  }, deps);
};
var useCompatibleInsertionEffect = useInsertionEffect ? function(renderEffect, effect, deps) {
  return useInsertionEffect(function() {
    renderEffect();
    return effect();
  }, deps);
} : useInsertionEffectPolyfill;
var useCompatibleInsertionEffect_default = useCompatibleInsertionEffect;

// ../../node_modules/@ant-design/cssinjs/es/hooks/useEffectCleanupRegister.js
var React11 = __toESM(require("react"));
var fullClone2 = _objectSpread2({}, React11);
var useInsertionEffect2 = fullClone2.useInsertionEffect;
var useCleanupRegister = function useCleanupRegister2(deps) {
  var effectCleanups = [];
  var cleanupFlag = false;
  function register3(fn) {
    if (cleanupFlag) {
      if (process.env.NODE_ENV !== "production") {
        warning(false, "[Ant Design CSS-in-JS] You are registering a cleanup function after unmount, which will not have any effect.");
      }
      return;
    }
    effectCleanups.push(fn);
  }
  React11.useEffect(function() {
    cleanupFlag = false;
    return function() {
      cleanupFlag = true;
      if (effectCleanups.length) {
        effectCleanups.forEach(function(fn) {
          return fn();
        });
      }
    };
  }, deps);
  return register3;
};
var useRun = function useRun2() {
  return function(fn) {
    fn();
  };
};
var useEffectCleanupRegister = typeof useInsertionEffect2 !== "undefined" ? useCleanupRegister : useRun;
var useEffectCleanupRegister_default = useEffectCleanupRegister;

// ../../node_modules/@ant-design/cssinjs/es/hooks/useHMR.js
function useProdHMR() {
  return false;
}
var webpackHMR = false;
function useDevHMR() {
  return webpackHMR;
}
var useHMR_default = process.env.NODE_ENV === "production" ? useProdHMR : useDevHMR;
if (process.env.NODE_ENV !== "production" && typeof module !== "undefined" && module && module.hot && typeof window !== "undefined") {
  win = window;
  if (typeof win.webpackHotUpdate === "function") {
    originWebpackHotUpdate = win.webpackHotUpdate;
    win.webpackHotUpdate = function() {
      webpackHMR = true;
      setTimeout(function() {
        webpackHMR = false;
      }, 0);
      return originWebpackHotUpdate.apply(void 0, arguments);
    };
  }
}
var win;
var originWebpackHotUpdate;

// ../../node_modules/@ant-design/cssinjs/es/hooks/useGlobalCache.js
function useGlobalCache(prefix, keyPath, cacheFn, onCacheRemove, onCacheEffect) {
  var _React$useContext = React12.useContext(StyleContext_default), globalCache = _React$useContext.cache;
  var fullPath = [prefix].concat(_toConsumableArray(keyPath));
  var deps = fullPath.join("_");
  var register3 = useEffectCleanupRegister_default([deps]);
  var HMRUpdate = useHMR_default();
  var buildCache = function buildCache2(updater) {
    globalCache.update(fullPath, function(prevCache) {
      var _ref = prevCache || [void 0, void 0], _ref2 = _slicedToArray(_ref, 2), _ref2$ = _ref2[0], times = _ref2$ === void 0 ? 0 : _ref2$, cache = _ref2[1];
      var tmpCache = cache;
      if (process.env.NODE_ENV !== "production" && cache && HMRUpdate) {
        onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(tmpCache, HMRUpdate);
        tmpCache = null;
      }
      var mergedCache = tmpCache || cacheFn();
      var data = [times, mergedCache];
      return updater ? updater(data) : data;
    });
  };
  React12.useMemo(
    function() {
      buildCache();
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [deps]
    /* eslint-enable */
  );
  var cacheEntity = globalCache.get(fullPath);
  if (process.env.NODE_ENV !== "production" && !cacheEntity) {
    buildCache();
    cacheEntity = globalCache.get(fullPath);
  }
  var cacheContent = cacheEntity[1];
  useCompatibleInsertionEffect_default(function() {
    onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
  }, function(polyfill) {
    buildCache(function(_ref3) {
      var _ref4 = _slicedToArray(_ref3, 2), times = _ref4[0], cache = _ref4[1];
      if (polyfill && times === 0) {
        onCacheEffect === null || onCacheEffect === void 0 || onCacheEffect(cacheContent);
      }
      return [times + 1, cache];
    });
    return function() {
      globalCache.update(fullPath, function(prevCache) {
        var _ref5 = prevCache || [], _ref6 = _slicedToArray(_ref5, 2), _ref6$ = _ref6[0], times = _ref6$ === void 0 ? 0 : _ref6$, cache = _ref6[1];
        var nextCount = times - 1;
        if (nextCount === 0) {
          register3(function() {
            if (polyfill || !globalCache.get(fullPath)) {
              onCacheRemove === null || onCacheRemove === void 0 || onCacheRemove(cache, false);
            }
          });
          return null;
        }
        return [times - 1, cache];
      });
    };
  }, [deps]);
  return cacheContent;
}

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCacheToken.js
var EMPTY_OVERRIDE = {};
var hashPrefix = process.env.NODE_ENV !== "production" ? "css-dev-only-do-not-override" : "css";
var tokenKeys = /* @__PURE__ */ new Map();
function recordCleanToken(tokenKey) {
  tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) + 1);
}
function removeStyleTags(key, instanceId) {
  if (typeof document !== "undefined") {
    var styles = document.querySelectorAll("style[".concat(ATTR_TOKEN, '="').concat(key, '"]'));
    styles.forEach(function(style2) {
      if (style2[CSS_IN_JS_INSTANCE] === instanceId) {
        var _style$parentNode;
        (_style$parentNode = style2.parentNode) === null || _style$parentNode === void 0 || _style$parentNode.removeChild(style2);
      }
    });
  }
}
var TOKEN_THRESHOLD = 0;
function cleanTokenStyle(tokenKey, instanceId) {
  tokenKeys.set(tokenKey, (tokenKeys.get(tokenKey) || 0) - 1);
  var tokenKeyList = Array.from(tokenKeys.keys());
  var cleanableKeyList = tokenKeyList.filter(function(key) {
    var count = tokenKeys.get(key) || 0;
    return count <= 0;
  });
  if (tokenKeyList.length - cleanableKeyList.length > TOKEN_THRESHOLD) {
    cleanableKeyList.forEach(function(key) {
      removeStyleTags(key, instanceId);
      tokenKeys.delete(key);
    });
  }
}
var getComputedToken = function getComputedToken2(originToken, overrideToken, theme, format2) {
  var derivativeToken = theme.getDerivativeToken(originToken);
  var mergedDerivativeToken = _objectSpread2(_objectSpread2({}, derivativeToken), overrideToken);
  if (format2) {
    mergedDerivativeToken = format2(mergedDerivativeToken);
  }
  return mergedDerivativeToken;
};
var TOKEN_PREFIX = "token";
function useCacheToken(theme, tokens) {
  var option = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var _useContext = (0, import_react4.useContext)(StyleContext_default), instanceId = _useContext.cache.instanceId, container = _useContext.container;
  var _option$salt = option.salt, salt = _option$salt === void 0 ? "" : _option$salt, _option$override = option.override, override = _option$override === void 0 ? EMPTY_OVERRIDE : _option$override, formatToken2 = option.formatToken, compute = option.getComputedToken, cssVar = option.cssVar;
  var mergedToken = memoResult(function() {
    return Object.assign.apply(Object, [{}].concat(_toConsumableArray(tokens)));
  }, tokens);
  var tokenStr = flattenToken(mergedToken);
  var overrideTokenStr = flattenToken(override);
  var cssVarStr = cssVar ? flattenToken(cssVar) : "";
  var cachedToken = useGlobalCache(TOKEN_PREFIX, [salt, theme.id, tokenStr, overrideTokenStr, cssVarStr], function() {
    var _cssVar$key;
    var mergedDerivativeToken = compute ? compute(mergedToken, override, theme) : getComputedToken(mergedToken, override, theme, formatToken2);
    var actualToken = _objectSpread2({}, mergedDerivativeToken);
    var cssVarsStr = "";
    if (!!cssVar) {
      var _transformToken = transformToken(mergedDerivativeToken, cssVar.key, {
        prefix: cssVar.prefix,
        ignore: cssVar.ignore,
        unitless: cssVar.unitless,
        preserve: cssVar.preserve
      });
      var _transformToken2 = _slicedToArray(_transformToken, 2);
      mergedDerivativeToken = _transformToken2[0];
      cssVarsStr = _transformToken2[1];
    }
    var tokenKey = token2key(mergedDerivativeToken, salt);
    mergedDerivativeToken._tokenKey = tokenKey;
    actualToken._tokenKey = token2key(actualToken, salt);
    var themeKey = (_cssVar$key = cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) !== null && _cssVar$key !== void 0 ? _cssVar$key : tokenKey;
    mergedDerivativeToken._themeKey = themeKey;
    recordCleanToken(themeKey);
    var hashId = "".concat(hashPrefix, "-").concat(hash_esm_default(tokenKey));
    mergedDerivativeToken._hashId = hashId;
    return [mergedDerivativeToken, hashId, actualToken, cssVarsStr, (cssVar === null || cssVar === void 0 ? void 0 : cssVar.key) || ""];
  }, function(cache) {
    cleanTokenStyle(cache[0]._themeKey, instanceId);
  }, function(_ref) {
    var _ref2 = _slicedToArray(_ref, 4), token2 = _ref2[0], cssVarsStr = _ref2[3];
    if (cssVar && cssVarsStr) {
      var style2 = updateCSS(cssVarsStr, hash_esm_default("css-variables-".concat(token2._themeKey)), {
        mark: ATTR_MARK,
        prepend: "queue",
        attachTo: container,
        priority: -999
      });
      style2[CSS_IN_JS_INSTANCE] = instanceId;
      style2.setAttribute(ATTR_TOKEN, token2._themeKey);
    }
  });
  return cachedToken;
}
var extract = function extract2(cache, effectStyles, options) {
  var _cache = _slicedToArray(cache, 5), realToken = _cache[2], styleStr = _cache[3], cssVarKey = _cache[4];
  var _ref3 = options || {}, plain = _ref3.plain;
  if (!styleStr) {
    return null;
  }
  var styleId = realToken._tokenKey;
  var order = -999;
  var sharedAttrs = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(order)
  };
  var styleText = toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCSSVarRegister.js
var import_react5 = require("react");

// ../../node_modules/@ant-design/cssinjs/es/hooks/useStyleRegister.js
var React13 = __toESM(require("react"));

// ../../node_modules/@emotion/unitless/dist/unitless.esm.js
var unitlessKeys = {
  animationIterationCount: 1,
  borderImageOutset: 1,
  borderImageSlice: 1,
  borderImageWidth: 1,
  boxFlex: 1,
  boxFlexGroup: 1,
  boxOrdinalGroup: 1,
  columnCount: 1,
  columns: 1,
  flex: 1,
  flexGrow: 1,
  flexPositive: 1,
  flexShrink: 1,
  flexNegative: 1,
  flexOrder: 1,
  gridRow: 1,
  gridRowEnd: 1,
  gridRowSpan: 1,
  gridRowStart: 1,
  gridColumn: 1,
  gridColumnEnd: 1,
  gridColumnSpan: 1,
  gridColumnStart: 1,
  msGridRow: 1,
  msGridRowSpan: 1,
  msGridColumn: 1,
  msGridColumnSpan: 1,
  fontWeight: 1,
  lineHeight: 1,
  opacity: 1,
  order: 1,
  orphans: 1,
  tabSize: 1,
  widows: 1,
  zIndex: 1,
  zoom: 1,
  WebkitLineClamp: 1,
  // SVG-related properties
  fillOpacity: 1,
  floodOpacity: 1,
  stopOpacity: 1,
  strokeDasharray: 1,
  strokeDashoffset: 1,
  strokeMiterlimit: 1,
  strokeOpacity: 1,
  strokeWidth: 1
};
var unitless_esm_default = unitlessKeys;

// ../../node_modules/stylis/src/Enum.js
var COMMENT = "comm";
var RULESET = "rule";
var DECLARATION = "decl";
var IMPORT = "@import";
var KEYFRAMES = "@keyframes";
var LAYER = "@layer";

// ../../node_modules/stylis/src/Utility.js
var abs = Math.abs;
var from = String.fromCharCode;
function trim(value) {
  return value.trim();
}
function replace(value, pattern4, replacement) {
  return value.replace(pattern4, replacement);
}
function indexof(value, search2, position2) {
  return value.indexOf(search2, position2);
}
function charat(value, index2) {
  return value.charCodeAt(index2) | 0;
}
function substr(value, begin, end) {
  return value.slice(begin, end);
}
function strlen(value) {
  return value.length;
}
function sizeof(value) {
  return value.length;
}
function append(value, array4) {
  return array4.push(value), value;
}

// ../../node_modules/stylis/src/Tokenizer.js
var line = 1;
var column = 1;
var length = 0;
var position = 0;
var character = 0;
var characters = "";
function node(value, root, parent, type4, props, children, length2, siblings) {
  return { value, root, parent, type: type4, props, children, line, column, length: length2, return: "", siblings };
}
function char() {
  return character;
}
function prev() {
  character = position > 0 ? charat(characters, --position) : 0;
  if (column--, character === 10)
    column = 1, line--;
  return character;
}
function next() {
  character = position < length ? charat(characters, position++) : 0;
  if (column++, character === 10)
    column = 1, line++;
  return character;
}
function peek() {
  return charat(characters, position);
}
function caret() {
  return position;
}
function slice(begin, end) {
  return substr(characters, begin, end);
}
function token(type4) {
  switch (type4) {
    case 0:
    case 9:
    case 10:
    case 13:
    case 32:
      return 5;
    case 33:
    case 43:
    case 44:
    case 47:
    case 62:
    case 64:
    case 126:
    case 59:
    case 123:
    case 125:
      return 4;
    case 58:
      return 3;
    case 34:
    case 39:
    case 40:
    case 91:
      return 2;
    case 41:
    case 93:
      return 1;
  }
  return 0;
}
function alloc(value) {
  return line = column = 1, length = strlen(characters = value), position = 0, [];
}
function dealloc(value) {
  return characters = "", value;
}
function delimit(type4) {
  return trim(slice(position - 1, delimiter(type4 === 91 ? type4 + 2 : type4 === 40 ? type4 + 1 : type4)));
}
function whitespace(type4) {
  while (character = peek())
    if (character < 33)
      next();
    else
      break;
  return token(type4) > 2 || token(character) > 3 ? "" : " ";
}
function escaping(index2, count) {
  while (--count && next())
    if (character < 48 || character > 102 || character > 57 && character < 65 || character > 70 && character < 97)
      break;
  return slice(index2, caret() + (count < 6 && peek() == 32 && next() == 32));
}
function delimiter(type4) {
  while (next())
    switch (character) {
      case type4:
        return position;
      case 34:
      case 39:
        if (type4 !== 34 && type4 !== 39)
          delimiter(character);
        break;
      case 40:
        if (type4 === 41)
          delimiter(type4);
        break;
      case 92:
        next();
        break;
    }
  return position;
}
function commenter(type4, index2) {
  while (next())
    if (type4 + character === 47 + 10)
      break;
    else if (type4 + character === 42 + 42 && peek() === 47)
      break;
  return "/*" + slice(index2, position - 1) + "*" + from(type4 === 47 ? type4 : next());
}
function identifier(index2) {
  while (!token(peek()))
    next();
  return slice(index2, position);
}

// ../../node_modules/stylis/src/Parser.js
function compile(value) {
  return dealloc(parse("", null, null, null, [""], value = alloc(value), 0, [0], value));
}
function parse(value, root, parent, rule, rules2, rulesets, pseudo, points, declarations) {
  var index2 = 0;
  var offset2 = 0;
  var length2 = pseudo;
  var atrule = 0;
  var property = 0;
  var previous = 0;
  var variable = 1;
  var scanning = 1;
  var ampersand = 1;
  var character2 = 0;
  var type4 = "";
  var props = rules2;
  var children = rulesets;
  var reference = rule;
  var characters2 = type4;
  while (scanning)
    switch (previous = character2, character2 = next()) {
      case 40:
        if (previous != 108 && charat(characters2, length2 - 1) == 58) {
          if (indexof(characters2 += replace(delimit(character2), "&", "&\f"), "&\f", abs(index2 ? points[index2 - 1] : 0)) != -1)
            ampersand = -1;
          break;
        }
      case 34:
      case 39:
      case 91:
        characters2 += delimit(character2);
        break;
      case 9:
      case 10:
      case 13:
      case 32:
        characters2 += whitespace(previous);
        break;
      case 92:
        characters2 += escaping(caret() - 1, 7);
        continue;
      case 47:
        switch (peek()) {
          case 42:
          case 47:
            append(comment(commenter(next(), caret()), root, parent, declarations), declarations);
            break;
          default:
            characters2 += "/";
        }
        break;
      case 123 * variable:
        points[index2++] = strlen(characters2) * ampersand;
      case 125 * variable:
      case 59:
      case 0:
        switch (character2) {
          case 0:
          case 125:
            scanning = 0;
          case 59 + offset2:
            if (ampersand == -1)
              characters2 = replace(characters2, /\f/g, "");
            if (property > 0 && strlen(characters2) - length2)
              append(property > 32 ? declaration(characters2 + ";", rule, parent, length2 - 1, declarations) : declaration(replace(characters2, " ", "") + ";", rule, parent, length2 - 2, declarations), declarations);
            break;
          case 59:
            characters2 += ";";
          default:
            append(reference = ruleset(characters2, root, parent, index2, offset2, rules2, points, type4, props = [], children = [], length2, rulesets), rulesets);
            if (character2 === 123)
              if (offset2 === 0)
                parse(characters2, root, reference, reference, props, rulesets, length2, points, children);
              else
                switch (atrule === 99 && charat(characters2, 3) === 110 ? 100 : atrule) {
                  case 100:
                  case 108:
                  case 109:
                  case 115:
                    parse(value, reference, reference, rule && append(ruleset(value, reference, reference, 0, 0, rules2, points, type4, rules2, props = [], length2, children), children), rules2, children, length2, points, rule ? props : children);
                    break;
                  default:
                    parse(characters2, reference, reference, reference, [""], children, 0, points, children);
                }
        }
        index2 = offset2 = property = 0, variable = ampersand = 1, type4 = characters2 = "", length2 = pseudo;
        break;
      case 58:
        length2 = 1 + strlen(characters2), property = previous;
      default:
        if (variable < 1) {
          if (character2 == 123)
            --variable;
          else if (character2 == 125 && variable++ == 0 && prev() == 125)
            continue;
        }
        switch (characters2 += from(character2), character2 * variable) {
          case 38:
            ampersand = offset2 > 0 ? 1 : (characters2 += "\f", -1);
            break;
          case 44:
            points[index2++] = (strlen(characters2) - 1) * ampersand, ampersand = 1;
            break;
          case 64:
            if (peek() === 45)
              characters2 += delimit(next());
            atrule = peek(), offset2 = length2 = strlen(type4 = characters2 += identifier(caret())), character2++;
            break;
          case 45:
            if (previous === 45 && strlen(characters2) == 2)
              variable = 0;
        }
    }
  return rulesets;
}
function ruleset(value, root, parent, index2, offset2, rules2, points, type4, props, children, length2, siblings) {
  var post = offset2 - 1;
  var rule = offset2 === 0 ? rules2 : [""];
  var size = sizeof(rule);
  for (var i = 0, j = 0, k = 0; i < index2; ++i)
    for (var x2 = 0, y2 = substr(value, post + 1, post = abs(j = points[i])), z = value; x2 < size; ++x2)
      if (z = trim(j > 0 ? rule[x2] + " " + y2 : replace(y2, /&\f/g, rule[x2])))
        props[k++] = z;
  return node(value, root, parent, offset2 === 0 ? RULESET : type4, props, children, length2, siblings);
}
function comment(value, root, parent, siblings) {
  return node(value, root, parent, COMMENT, from(char()), substr(value, 2, -2), 0, siblings);
}
function declaration(value, root, parent, length2, siblings) {
  return node(value, root, parent, DECLARATION, substr(value, 0, length2), substr(value, length2 + 1, -1), length2, siblings);
}

// ../../node_modules/stylis/src/Serializer.js
function serialize(children, callback) {
  var output = "";
  for (var i = 0; i < children.length; i++)
    output += callback(children[i], i, children, callback) || "";
  return output;
}
function stringify(element, index2, children, callback) {
  switch (element.type) {
    case LAYER:
      if (element.children.length)
        break;
    case IMPORT:
    case DECLARATION:
      return element.return = element.return || element.value;
    case COMMENT:
      return "";
    case KEYFRAMES:
      return element.return = element.value + "{" + serialize(element.children, callback) + "}";
    case RULESET:
      if (!strlen(element.value = element.props.join(",")))
        return "";
  }
  return strlen(children = serialize(element.children, callback)) ? element.return = element.value + "{" + children + "}" : "";
}

// ../../node_modules/@ant-design/cssinjs/es/linters/utils.js
function lintWarning(message2, info) {
  var path2 = info.path, parentSelectors = info.parentSelectors;
  warning_default(false, "[Ant Design CSS-in-JS] ".concat(path2 ? "Error in ".concat(path2, ": ") : "").concat(message2).concat(parentSelectors.length ? " Selector: ".concat(parentSelectors.join(" | ")) : ""));
}

// ../../node_modules/@ant-design/cssinjs/es/linters/contentQuotesLinter.js
var linter = function linter2(key, value, info) {
  if (key === "content") {
    var contentValuePattern = /(attr|counters?|url|(((repeating-)?(linear|radial))|conic)-gradient)\(|(no-)?(open|close)-quote/;
    var contentValues = ["normal", "none", "initial", "inherit", "unset"];
    if (typeof value !== "string" || contentValues.indexOf(value) === -1 && !contentValuePattern.test(value) && (value.charAt(0) !== value.charAt(value.length - 1) || value.charAt(0) !== '"' && value.charAt(0) !== "'")) {
      lintWarning("You seem to be using a value for 'content' without quotes, try replacing it with `content: '\"".concat(value, "\"'`."), info);
    }
  }
};
var contentQuotesLinter_default = linter;

// ../../node_modules/@ant-design/cssinjs/es/linters/hashedAnimationLinter.js
var linter3 = function linter4(key, value, info) {
  if (key === "animation") {
    if (info.hashId && value !== "none") {
      lintWarning("You seem to be using hashed animation '".concat(value, "', in which case 'animationName' with Keyframe as value is recommended."), info);
    }
  }
};
var hashedAnimationLinter_default = linter3;

// ../../node_modules/@ant-design/cssinjs/es/util/cacheMapUtil.js
var ATTR_CACHE_MAP = "data-ant-cssinjs-cache-path";
var CSS_FILE_STYLE = "_FILE_STYLE__";
var cachePathMap;
var fromCSSFile = true;
function prepare() {
  if (!cachePathMap) {
    cachePathMap = {};
    if (canUseDom()) {
      var div = document.createElement("div");
      div.className = ATTR_CACHE_MAP;
      div.style.position = "fixed";
      div.style.visibility = "hidden";
      div.style.top = "-9999px";
      document.body.appendChild(div);
      var content = getComputedStyle(div).content || "";
      content = content.replace(/^"/, "").replace(/"$/, "");
      content.split(";").forEach(function(item) {
        var _item$split = item.split(":"), _item$split2 = _slicedToArray(_item$split, 2), path2 = _item$split2[0], hash = _item$split2[1];
        cachePathMap[path2] = hash;
      });
      var inlineMapStyle = document.querySelector("style[".concat(ATTR_CACHE_MAP, "]"));
      if (inlineMapStyle) {
        var _inlineMapStyle$paren;
        fromCSSFile = false;
        (_inlineMapStyle$paren = inlineMapStyle.parentNode) === null || _inlineMapStyle$paren === void 0 || _inlineMapStyle$paren.removeChild(inlineMapStyle);
      }
      document.body.removeChild(div);
    }
  }
}
function existPath(path2) {
  prepare();
  return !!cachePathMap[path2];
}
function getStyleAndHash(path2) {
  var hash = cachePathMap[path2];
  var styleStr = null;
  if (hash && canUseDom()) {
    if (fromCSSFile) {
      styleStr = CSS_FILE_STYLE;
    } else {
      var _style = document.querySelector("style[".concat(ATTR_MARK, '="').concat(cachePathMap[path2], '"]'));
      if (_style) {
        styleStr = _style.innerHTML;
      } else {
        delete cachePathMap[path2];
      }
    }
  }
  return [styleStr, hash];
}

// ../../node_modules/@ant-design/cssinjs/es/hooks/useStyleRegister.js
var SKIP_CHECK = "_skip_check_";
var MULTI_VALUE = "_multi_value_";
function normalizeStyle(styleStr) {
  var serialized = serialize(compile(styleStr), stringify);
  return serialized.replace(/\{%%%\:[^;];}/g, ";");
}
function isCompoundCSSProperty(value) {
  return _typeof(value) === "object" && value && (SKIP_CHECK in value || MULTI_VALUE in value);
}
function injectSelectorHash(key, hashId, hashPriority) {
  if (!hashId) {
    return key;
  }
  var hashClassName = ".".concat(hashId);
  var hashSelector = hashPriority === "low" ? ":where(".concat(hashClassName, ")") : hashClassName;
  var keys3 = key.split(",").map(function(k) {
    var _firstPath$match;
    var fullPath = k.trim().split(/\s+/);
    var firstPath = fullPath[0] || "";
    var htmlElement = ((_firstPath$match = firstPath.match(/^\w+/)) === null || _firstPath$match === void 0 ? void 0 : _firstPath$match[0]) || "";
    firstPath = "".concat(htmlElement).concat(hashSelector).concat(firstPath.slice(htmlElement.length));
    return [firstPath].concat(_toConsumableArray(fullPath.slice(1))).join(" ");
  });
  return keys3.join(",");
}
var parseStyle = function parseStyle2(interpolation) {
  var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
    root: true,
    parentSelectors: []
  }, root = _ref.root, injectHash = _ref.injectHash, parentSelectors = _ref.parentSelectors;
  var hashId = config.hashId, layer = config.layer, path2 = config.path, hashPriority = config.hashPriority, _config$transformers = config.transformers, transformers = _config$transformers === void 0 ? [] : _config$transformers, _config$linters = config.linters, linters = _config$linters === void 0 ? [] : _config$linters;
  var styleStr = "";
  var effectStyle = {};
  function parseKeyframes(keyframes) {
    var animationName = keyframes.getName(hashId);
    if (!effectStyle[animationName]) {
      var _parseStyle = parseStyle2(keyframes.style, config, {
        root: false,
        parentSelectors
      }), _parseStyle2 = _slicedToArray(_parseStyle, 1), _parsedStr = _parseStyle2[0];
      effectStyle[animationName] = "@keyframes ".concat(keyframes.getName(hashId)).concat(_parsedStr);
    }
  }
  function flattenList(list) {
    var fullList = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    list.forEach(function(item) {
      if (Array.isArray(item)) {
        flattenList(item, fullList);
      } else if (item) {
        fullList.push(item);
      }
    });
    return fullList;
  }
  var flattenStyleList = flattenList(Array.isArray(interpolation) ? interpolation : [interpolation]);
  flattenStyleList.forEach(function(originStyle) {
    var style2 = typeof originStyle === "string" && !root ? {} : originStyle;
    if (typeof style2 === "string") {
      styleStr += "".concat(style2, "\n");
    } else if (style2._keyframe) {
      parseKeyframes(style2);
    } else {
      var mergedStyle = transformers.reduce(function(prev2, trans) {
        var _trans$visit;
        return (trans === null || trans === void 0 || (_trans$visit = trans.visit) === null || _trans$visit === void 0 ? void 0 : _trans$visit.call(trans, prev2)) || prev2;
      }, style2);
      Object.keys(mergedStyle).forEach(function(key) {
        var value = mergedStyle[key];
        if (_typeof(value) === "object" && value && (key !== "animationName" || !value._keyframe) && !isCompoundCSSProperty(value)) {
          var subInjectHash = false;
          var mergedKey = key.trim();
          var nextRoot = false;
          if ((root || injectHash) && hashId) {
            if (mergedKey.startsWith("@")) {
              subInjectHash = true;
            } else {
              mergedKey = injectSelectorHash(key, hashId, hashPriority);
            }
          } else if (root && !hashId && (mergedKey === "&" || mergedKey === "")) {
            mergedKey = "";
            nextRoot = true;
          }
          var _parseStyle3 = parseStyle2(value, config, {
            root: nextRoot,
            injectHash: subInjectHash,
            parentSelectors: [].concat(_toConsumableArray(parentSelectors), [mergedKey])
          }), _parseStyle4 = _slicedToArray(_parseStyle3, 2), _parsedStr2 = _parseStyle4[0], childEffectStyle = _parseStyle4[1];
          effectStyle = _objectSpread2(_objectSpread2({}, effectStyle), childEffectStyle);
          styleStr += "".concat(mergedKey).concat(_parsedStr2);
        } else {
          let appendStyle2 = function(cssKey, cssValue) {
            if (process.env.NODE_ENV !== "production" && (_typeof(value) !== "object" || !(value !== null && value !== void 0 && value[SKIP_CHECK]))) {
              [contentQuotesLinter_default, hashedAnimationLinter_default].concat(_toConsumableArray(linters)).forEach(function(linter5) {
                return linter5(cssKey, cssValue, {
                  path: path2,
                  hashId,
                  parentSelectors
                });
              });
            }
            var styleName = cssKey.replace(/[A-Z]/g, function(match2) {
              return "-".concat(match2.toLowerCase());
            });
            var formatValue = cssValue;
            if (!unitless_esm_default[cssKey] && typeof formatValue === "number" && formatValue !== 0) {
              formatValue = "".concat(formatValue, "px");
            }
            if (cssKey === "animationName" && cssValue !== null && cssValue !== void 0 && cssValue._keyframe) {
              parseKeyframes(cssValue);
              formatValue = cssValue.getName(hashId);
            }
            styleStr += "".concat(styleName, ":").concat(formatValue, ";");
          };
          var appendStyle = appendStyle2;
          var _value;
          var actualValue = (_value = value === null || value === void 0 ? void 0 : value.value) !== null && _value !== void 0 ? _value : value;
          if (_typeof(value) === "object" && value !== null && value !== void 0 && value[MULTI_VALUE] && Array.isArray(actualValue)) {
            actualValue.forEach(function(item) {
              appendStyle2(key, item);
            });
          } else {
            appendStyle2(key, actualValue);
          }
        }
      });
    }
  });
  if (!root) {
    styleStr = "{".concat(styleStr, "}");
  } else if (layer && supportLayer()) {
    var layerCells = layer.split(",");
    var layerName = layerCells[layerCells.length - 1].trim();
    styleStr = "@layer ".concat(layerName, " {").concat(styleStr, "}");
    if (layerCells.length > 1) {
      styleStr = "@layer ".concat(layer, "{%%%:%}").concat(styleStr);
    }
  }
  return [styleStr, effectStyle];
};
function uniqueHash(path2, styleStr) {
  return hash_esm_default("".concat(path2.join("%")).concat(styleStr));
}
function Empty() {
  return null;
}
var STYLE_PREFIX = "style";
function useStyleRegister(info, styleFn) {
  var token2 = info.token, path2 = info.path, hashId = info.hashId, layer = info.layer, nonce = info.nonce, clientOnly = info.clientOnly, _info$order = info.order, order = _info$order === void 0 ? 0 : _info$order;
  var _React$useContext = React13.useContext(StyleContext_default), autoClear = _React$useContext.autoClear, mock = _React$useContext.mock, defaultCache = _React$useContext.defaultCache, hashPriority = _React$useContext.hashPriority, container = _React$useContext.container, ssrInline = _React$useContext.ssrInline, transformers = _React$useContext.transformers, linters = _React$useContext.linters, cache = _React$useContext.cache;
  var tokenKey = token2._tokenKey;
  var fullPath = [tokenKey].concat(_toConsumableArray(path2));
  var isMergedClientSide = isClientSide;
  if (process.env.NODE_ENV !== "production" && mock !== void 0) {
    isMergedClientSide = mock === "client";
  }
  var _useGlobalCache = useGlobalCache(
    STYLE_PREFIX,
    fullPath,
    // Create cache if needed
    function() {
      var cachePath = fullPath.join("|");
      if (existPath(cachePath)) {
        var _getStyleAndHash = getStyleAndHash(cachePath), _getStyleAndHash2 = _slicedToArray(_getStyleAndHash, 2), inlineCacheStyleStr = _getStyleAndHash2[0], styleHash = _getStyleAndHash2[1];
        if (inlineCacheStyleStr) {
          return [inlineCacheStyleStr, tokenKey, styleHash, {}, clientOnly, order];
        }
      }
      var styleObj = styleFn();
      var _parseStyle5 = parseStyle(styleObj, {
        hashId,
        hashPriority,
        layer,
        path: path2.join("-"),
        transformers,
        linters
      }), _parseStyle6 = _slicedToArray(_parseStyle5, 2), parsedStyle = _parseStyle6[0], effectStyle = _parseStyle6[1];
      var styleStr = normalizeStyle(parsedStyle);
      var styleId = uniqueHash(fullPath, styleStr);
      return [styleStr, tokenKey, styleId, effectStyle, clientOnly, order];
    },
    // Remove cache if no need
    function(_ref2, fromHMR) {
      var _ref3 = _slicedToArray(_ref2, 3), styleId = _ref3[2];
      if ((fromHMR || autoClear) && isClientSide) {
        removeCSS(styleId, {
          mark: ATTR_MARK
        });
      }
    },
    // Effect: Inject style here
    function(_ref4) {
      var _ref5 = _slicedToArray(_ref4, 4), styleStr = _ref5[0], _ = _ref5[1], styleId = _ref5[2], effectStyle = _ref5[3];
      if (isMergedClientSide && styleStr !== CSS_FILE_STYLE) {
        var mergedCSSConfig = {
          mark: ATTR_MARK,
          prepend: "queue",
          attachTo: container,
          priority: order
        };
        var nonceStr = typeof nonce === "function" ? nonce() : nonce;
        if (nonceStr) {
          mergedCSSConfig.csp = {
            nonce: nonceStr
          };
        }
        var style2 = updateCSS(styleStr, styleId, mergedCSSConfig);
        style2[CSS_IN_JS_INSTANCE] = cache.instanceId;
        style2.setAttribute(ATTR_TOKEN, tokenKey);
        if (process.env.NODE_ENV !== "production") {
          style2.setAttribute(ATTR_CACHE_PATH, fullPath.join("|"));
        }
        Object.keys(effectStyle).forEach(function(effectKey) {
          updateCSS(normalizeStyle(effectStyle[effectKey]), "_effect-".concat(effectKey), mergedCSSConfig);
        });
      }
    }
  ), _useGlobalCache2 = _slicedToArray(_useGlobalCache, 3), cachedStyleStr = _useGlobalCache2[0], cachedTokenKey = _useGlobalCache2[1], cachedStyleId = _useGlobalCache2[2];
  return function(node2) {
    var styleNode;
    if (!ssrInline || isMergedClientSide || !defaultCache) {
      styleNode = /* @__PURE__ */ React13.createElement(Empty, null);
    } else {
      var _ref6;
      styleNode = /* @__PURE__ */ React13.createElement("style", _extends({}, (_ref6 = {}, _defineProperty(_ref6, ATTR_TOKEN, cachedTokenKey), _defineProperty(_ref6, ATTR_MARK, cachedStyleId), _ref6), {
        dangerouslySetInnerHTML: {
          __html: cachedStyleStr
        }
      }));
    }
    return /* @__PURE__ */ React13.createElement(React13.Fragment, null, styleNode, node2);
  };
}
var extract3 = function extract4(cache, effectStyles, options) {
  var _cache = _slicedToArray(cache, 6), styleStr = _cache[0], tokenKey = _cache[1], styleId = _cache[2], effectStyle = _cache[3], clientOnly = _cache[4], order = _cache[5];
  var _ref7 = options || {}, plain = _ref7.plain;
  if (clientOnly) {
    return null;
  }
  var keyStyleText = styleStr;
  var sharedAttrs = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(order)
  };
  keyStyleText = toStyleStr(styleStr, tokenKey, styleId, sharedAttrs, plain);
  if (effectStyle) {
    Object.keys(effectStyle).forEach(function(effectKey) {
      if (!effectStyles[effectKey]) {
        effectStyles[effectKey] = true;
        var effectStyleStr = normalizeStyle(effectStyle[effectKey]);
        keyStyleText += toStyleStr(effectStyleStr, tokenKey, "_effect-".concat(effectKey), sharedAttrs, plain);
      }
    });
  }
  return [order, styleId, keyStyleText];
};

// ../../node_modules/@ant-design/cssinjs/es/hooks/useCSSVarRegister.js
var CSS_VAR_PREFIX = "cssVar";
var useCSSVarRegister = function useCSSVarRegister2(config, fn) {
  var key = config.key, prefix = config.prefix, unitless2 = config.unitless, ignore2 = config.ignore, token2 = config.token, _config$scope = config.scope, scope = _config$scope === void 0 ? "" : _config$scope;
  var _useContext = (0, import_react5.useContext)(StyleContext_default), instanceId = _useContext.cache.instanceId, container = _useContext.container;
  var tokenKey = token2._tokenKey;
  var stylePath = [].concat(_toConsumableArray(config.path), [key, scope, tokenKey]);
  var cache = useGlobalCache(CSS_VAR_PREFIX, stylePath, function() {
    var originToken = fn();
    var _transformToken = transformToken(originToken, key, {
      prefix,
      unitless: unitless2,
      ignore: ignore2,
      scope
    }), _transformToken2 = _slicedToArray(_transformToken, 2), mergedToken = _transformToken2[0], cssVarsStr = _transformToken2[1];
    var styleId = uniqueHash(stylePath, cssVarsStr);
    return [mergedToken, cssVarsStr, styleId, key];
  }, function(_ref) {
    var _ref2 = _slicedToArray(_ref, 3), styleId = _ref2[2];
    if (isClientSide) {
      removeCSS(styleId, {
        mark: ATTR_MARK
      });
    }
  }, function(_ref3) {
    var _ref4 = _slicedToArray(_ref3, 3), cssVarsStr = _ref4[1], styleId = _ref4[2];
    if (!cssVarsStr) {
      return;
    }
    var style2 = updateCSS(cssVarsStr, styleId, {
      mark: ATTR_MARK,
      prepend: "queue",
      attachTo: container,
      priority: -999
    });
    style2[CSS_IN_JS_INSTANCE] = instanceId;
    style2.setAttribute(ATTR_TOKEN, key);
  });
  return cache;
};
var extract5 = function extract6(cache, effectStyles, options) {
  var _cache = _slicedToArray(cache, 4), styleStr = _cache[1], styleId = _cache[2], cssVarKey = _cache[3];
  var _ref5 = options || {}, plain = _ref5.plain;
  if (!styleStr) {
    return null;
  }
  var order = -999;
  var sharedAttrs = {
    "data-rc-order": "prependQueue",
    "data-rc-priority": "".concat(order)
  };
  var styleText = toStyleStr(styleStr, cssVarKey, styleId, sharedAttrs, plain);
  return [order, styleId, styleText];
};
var useCSSVarRegister_default = useCSSVarRegister;

// ../../node_modules/@ant-design/cssinjs/es/extractStyle.js
var _ExtractStyleFns;
var ExtractStyleFns = (_ExtractStyleFns = {}, _defineProperty(_ExtractStyleFns, STYLE_PREFIX, extract3), _defineProperty(_ExtractStyleFns, TOKEN_PREFIX, extract), _defineProperty(_ExtractStyleFns, CSS_VAR_PREFIX, extract5), _ExtractStyleFns);

// ../../node_modules/@ant-design/cssinjs/es/Keyframes.js
var Keyframe = /* @__PURE__ */ function() {
  function Keyframe2(name, style2) {
    _classCallCheck(this, Keyframe2);
    _defineProperty(this, "name", void 0);
    _defineProperty(this, "style", void 0);
    _defineProperty(this, "_keyframe", true);
    this.name = name;
    this.style = style2;
  }
  _createClass(Keyframe2, [{
    key: "getName",
    value: function getName() {
      var hashId = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
      return hashId ? "".concat(hashId, "-").concat(this.name) : this.name;
    }
  }]);
  return Keyframe2;
}();
var Keyframes_default = Keyframe;

// ../../node_modules/@ant-design/cssinjs/es/transformers/legacyLogicalProperties.js
function noSplit(list) {
  list.notSplit = true;
  return list;
}
var keyMap = {
  // Inset
  inset: ["top", "right", "bottom", "left"],
  insetBlock: ["top", "bottom"],
  insetBlockStart: ["top"],
  insetBlockEnd: ["bottom"],
  insetInline: ["left", "right"],
  insetInlineStart: ["left"],
  insetInlineEnd: ["right"],
  // Margin
  marginBlock: ["marginTop", "marginBottom"],
  marginBlockStart: ["marginTop"],
  marginBlockEnd: ["marginBottom"],
  marginInline: ["marginLeft", "marginRight"],
  marginInlineStart: ["marginLeft"],
  marginInlineEnd: ["marginRight"],
  // Padding
  paddingBlock: ["paddingTop", "paddingBottom"],
  paddingBlockStart: ["paddingTop"],
  paddingBlockEnd: ["paddingBottom"],
  paddingInline: ["paddingLeft", "paddingRight"],
  paddingInlineStart: ["paddingLeft"],
  paddingInlineEnd: ["paddingRight"],
  // Border
  borderBlock: noSplit(["borderTop", "borderBottom"]),
  borderBlockStart: noSplit(["borderTop"]),
  borderBlockEnd: noSplit(["borderBottom"]),
  borderInline: noSplit(["borderLeft", "borderRight"]),
  borderInlineStart: noSplit(["borderLeft"]),
  borderInlineEnd: noSplit(["borderRight"]),
  // Border width
  borderBlockWidth: ["borderTopWidth", "borderBottomWidth"],
  borderBlockStartWidth: ["borderTopWidth"],
  borderBlockEndWidth: ["borderBottomWidth"],
  borderInlineWidth: ["borderLeftWidth", "borderRightWidth"],
  borderInlineStartWidth: ["borderLeftWidth"],
  borderInlineEndWidth: ["borderRightWidth"],
  // Border style
  borderBlockStyle: ["borderTopStyle", "borderBottomStyle"],
  borderBlockStartStyle: ["borderTopStyle"],
  borderBlockEndStyle: ["borderBottomStyle"],
  borderInlineStyle: ["borderLeftStyle", "borderRightStyle"],
  borderInlineStartStyle: ["borderLeftStyle"],
  borderInlineEndStyle: ["borderRightStyle"],
  // Border color
  borderBlockColor: ["borderTopColor", "borderBottomColor"],
  borderBlockStartColor: ["borderTopColor"],
  borderBlockEndColor: ["borderBottomColor"],
  borderInlineColor: ["borderLeftColor", "borderRightColor"],
  borderInlineStartColor: ["borderLeftColor"],
  borderInlineEndColor: ["borderRightColor"],
  // Border radius
  borderStartStartRadius: ["borderTopLeftRadius"],
  borderStartEndRadius: ["borderTopRightRadius"],
  borderEndStartRadius: ["borderBottomLeftRadius"],
  borderEndEndRadius: ["borderBottomRightRadius"]
};

// ../../node_modules/@ant-design/icons/es/components/Context.js
var import_react6 = require("react");
var IconContext = /* @__PURE__ */ (0, import_react6.createContext)({});
var Context_default = IconContext;

// ../../node_modules/@babel/runtime/helpers/esm/toArray.js
function _toArray(arr) {
  return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest();
}

// ../../node_modules/rc-util/es/utils/get.js
function get(entity, path2) {
  var current = entity;
  for (var i = 0; i < path2.length; i += 1) {
    if (current === null || current === void 0) {
      return void 0;
    }
    current = current[path2[i]];
  }
  return current;
}

// ../../node_modules/rc-util/es/utils/set.js
function internalSet(entity, paths, value, removeIfUndefined) {
  if (!paths.length) {
    return value;
  }
  var _paths = _toArray(paths), path2 = _paths[0], restPath = _paths.slice(1);
  var clone;
  if (!entity && typeof path2 === "number") {
    clone = [];
  } else if (Array.isArray(entity)) {
    clone = _toConsumableArray(entity);
  } else {
    clone = _objectSpread2({}, entity);
  }
  if (removeIfUndefined && value === void 0 && restPath.length === 1) {
    delete clone[path2][restPath[0]];
  } else {
    clone[path2] = internalSet(clone[path2], restPath, value, removeIfUndefined);
  }
  return clone;
}
function set(entity, paths, value) {
  var removeIfUndefined = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  if (paths.length && removeIfUndefined && value === void 0 && !get(entity, paths.slice(0, -1))) {
    return entity;
  }
  return internalSet(entity, paths, value, removeIfUndefined);
}
function isObject(obj) {
  return _typeof(obj) === "object" && obj !== null && Object.getPrototypeOf(obj) === Object.prototype;
}
function createEmpty(source) {
  return Array.isArray(source) ? [] : {};
}
var keys = typeof Reflect === "undefined" ? Object.keys : Reflect.ownKeys;
function merge() {
  for (var _len = arguments.length, sources = new Array(_len), _key = 0; _key < _len; _key++) {
    sources[_key] = arguments[_key];
  }
  var clone = createEmpty(sources[0]);
  sources.forEach(function(src) {
    function internalMerge(path2, parentLoopSet) {
      var loopSet = new Set(parentLoopSet);
      var value = get(src, path2);
      var isArr = Array.isArray(value);
      if (isArr || isObject(value)) {
        if (!loopSet.has(value)) {
          loopSet.add(value);
          var originValue = get(clone, path2);
          if (isArr) {
            clone = set(clone, path2, []);
          } else if (!originValue || _typeof(originValue) !== "object") {
            clone = set(clone, path2, createEmpty(value));
          }
          keys(value).forEach(function(key) {
            internalMerge([].concat(_toConsumableArray(path2), [key]), loopSet);
          });
        }
      } else {
        clone = set(clone, path2, value);
      }
    }
    internalMerge([]);
  });
  return clone;
}

// ../../node_modules/antd/es/_util/warning.js
var React14 = __toESM(require("react"));
function noop() {
}
var deprecatedWarnList = null;
function resetWarned2() {
  deprecatedWarnList = null;
  resetWarned();
}
var warning2 = noop;
if (process.env.NODE_ENV !== "production") {
  warning2 = (valid, component, message2) => {
    warning_default(valid, `[antd: ${component}] ${message2}`);
    if (process.env.NODE_ENV === "test") {
      resetWarned2();
    }
  };
}
var WarningContext = /* @__PURE__ */ React14.createContext({});
var devUseWarning = process.env.NODE_ENV !== "production" ? (component) => {
  const {
    strict
  } = React14.useContext(WarningContext);
  const typeWarning = (valid, type4, message2) => {
    if (!valid) {
      if (strict === false && type4 === "deprecated") {
        const existWarning = deprecatedWarnList;
        if (!deprecatedWarnList) {
          deprecatedWarnList = {};
        }
        deprecatedWarnList[component] = deprecatedWarnList[component] || [];
        if (!deprecatedWarnList[component].includes(message2 || "")) {
          deprecatedWarnList[component].push(message2 || "");
        }
        if (!existWarning) {
          console.warn("[antd] There exists deprecated usage in your code:", deprecatedWarnList);
        }
      } else {
        process.env.NODE_ENV !== "production" ? warning2(valid, component, message2) : void 0;
      }
    }
  };
  typeWarning.deprecated = (valid, oldProp, newProp, message2) => {
    typeWarning(valid, "deprecated", `\`${oldProp}\` is deprecated. Please use \`${newProp}\` instead.${message2 ? ` ${message2}` : ""}`);
  };
  return typeWarning;
} : () => {
  const noopWarning = () => {
  };
  noopWarning.deprecated = noop;
  return noopWarning;
};
var warning_default2 = warning2;

// ../../node_modules/antd/es/form/validateMessagesContext.js
var import_react7 = require("react");
var validateMessagesContext_default = /* @__PURE__ */ (0, import_react7.createContext)(void 0);

// ../../node_modules/antd/es/locale/index.js
var React16 = __toESM(require("react"));

// ../../node_modules/rc-pagination/es/locale/en_US.js
var locale = {
  // Options
  items_per_page: "/ page",
  jump_to: "Go to",
  jump_to_confirm: "confirm",
  page: "Page",
  // Pagination
  prev_page: "Previous Page",
  next_page: "Next Page",
  prev_5: "Previous 5 Pages",
  next_5: "Next 5 Pages",
  prev_3: "Previous 3 Pages",
  next_3: "Next 3 Pages",
  page_size: "Page Size"
};
var en_US_default = locale;

// ../../node_modules/rc-picker/es/locale/en_US.js
var locale2 = {
  locale: "en_US",
  today: "Today",
  now: "Now",
  backToToday: "Back to today",
  ok: "OK",
  clear: "Clear",
  month: "Month",
  year: "Year",
  timeSelect: "select time",
  dateSelect: "select date",
  weekSelect: "Choose a week",
  monthSelect: "Choose a month",
  yearSelect: "Choose a year",
  decadeSelect: "Choose a decade",
  yearFormat: "YYYY",
  dateFormat: "M/D/YYYY",
  dayFormat: "D",
  dateTimeFormat: "M/D/YYYY HH:mm:ss",
  monthBeforeYear: true,
  previousMonth: "Previous month (PageUp)",
  nextMonth: "Next month (PageDown)",
  previousYear: "Last year (Control + left)",
  nextYear: "Next year (Control + right)",
  previousDecade: "Last decade",
  nextDecade: "Next decade",
  previousCentury: "Last century",
  nextCentury: "Next century"
};
var en_US_default2 = locale2;

// ../../node_modules/antd/es/time-picker/locale/en_US.js
var locale3 = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
var en_US_default3 = locale3;

// ../../node_modules/antd/es/date-picker/locale/en_US.js
var locale4 = {
  lang: Object.assign({
    placeholder: "Select date",
    yearPlaceholder: "Select year",
    quarterPlaceholder: "Select quarter",
    monthPlaceholder: "Select month",
    weekPlaceholder: "Select week",
    rangePlaceholder: ["Start date", "End date"],
    rangeYearPlaceholder: ["Start year", "End year"],
    rangeQuarterPlaceholder: ["Start quarter", "End quarter"],
    rangeMonthPlaceholder: ["Start month", "End month"],
    rangeWeekPlaceholder: ["Start week", "End week"]
  }, en_US_default2),
  timePickerLocale: Object.assign({}, en_US_default3)
};
var en_US_default4 = locale4;

// ../../node_modules/antd/es/calendar/locale/en_US.js
var en_US_default5 = en_US_default4;

// ../../node_modules/antd/es/locale/en_US.js
var typeTemplate = "${label} is not a valid ${type}";
var localeValues = {
  locale: "en",
  Pagination: en_US_default,
  DatePicker: en_US_default4,
  TimePicker: en_US_default3,
  Calendar: en_US_default5,
  global: {
    placeholder: "Please select"
  },
  Table: {
    filterTitle: "Filter menu",
    filterConfirm: "OK",
    filterReset: "Reset",
    filterEmptyText: "No filters",
    filterCheckall: "Select all items",
    filterSearchPlaceholder: "Search in filters",
    emptyText: "No data",
    selectAll: "Select current page",
    selectInvert: "Invert current page",
    selectNone: "Clear all data",
    selectionAll: "Select all data",
    sortTitle: "Sort",
    expand: "Expand row",
    collapse: "Collapse row",
    triggerDesc: "Click to sort descending",
    triggerAsc: "Click to sort ascending",
    cancelSort: "Click to cancel sorting"
  },
  Tour: {
    Next: "Next",
    Previous: "Previous",
    Finish: "Finish"
  },
  Modal: {
    okText: "OK",
    cancelText: "Cancel",
    justOkText: "OK"
  },
  Popconfirm: {
    okText: "OK",
    cancelText: "Cancel"
  },
  Transfer: {
    titles: ["", ""],
    searchPlaceholder: "Search here",
    itemUnit: "item",
    itemsUnit: "items",
    remove: "Remove",
    selectCurrent: "Select current page",
    removeCurrent: "Remove current page",
    selectAll: "Select all data",
    removeAll: "Remove all data",
    selectInvert: "Invert current page"
  },
  Upload: {
    uploading: "Uploading...",
    removeFile: "Remove file",
    uploadError: "Upload error",
    previewFile: "Preview file",
    downloadFile: "Download file"
  },
  Empty: {
    description: "No data"
  },
  Icon: {
    icon: "icon"
  },
  Text: {
    edit: "Edit",
    copy: "Copy",
    copied: "Copied",
    expand: "Expand"
  },
  PageHeader: {
    back: "Back"
  },
  Form: {
    optional: "(optional)",
    defaultValidateMessages: {
      default: "Field validation error for ${label}",
      required: "Please enter ${label}",
      enum: "${label} must be one of [${enum}]",
      whitespace: "${label} cannot be a blank character",
      date: {
        format: "${label} date format is invalid",
        parse: "${label} cannot be converted to a date",
        invalid: "${label} is an invalid date"
      },
      types: {
        string: typeTemplate,
        method: typeTemplate,
        array: typeTemplate,
        object: typeTemplate,
        number: typeTemplate,
        date: typeTemplate,
        boolean: typeTemplate,
        integer: typeTemplate,
        float: typeTemplate,
        regexp: typeTemplate,
        email: typeTemplate,
        url: typeTemplate,
        hex: typeTemplate
      },
      string: {
        len: "${label} must be ${len} characters",
        min: "${label} must be at least ${min} characters",
        max: "${label} must be up to ${max} characters",
        range: "${label} must be between ${min}-${max} characters"
      },
      number: {
        len: "${label} must be equal to ${len}",
        min: "${label} must be minimum ${min}",
        max: "${label} must be maximum ${max}",
        range: "${label} must be between ${min}-${max}"
      },
      array: {
        len: "Must be ${len} ${label}",
        min: "At least ${min} ${label}",
        max: "At most ${max} ${label}",
        range: "The amount of ${label} must be between ${min}-${max}"
      },
      pattern: {
        mismatch: "${label} does not match the pattern ${pattern}"
      }
    }
  },
  Image: {
    preview: "Preview"
  },
  QRCode: {
    expired: "QR code expired",
    refresh: "Refresh",
    scanned: "Scanned"
  },
  ColorPicker: {
    presetEmpty: "Empty"
  }
};
var en_US_default6 = localeValues;

// ../../node_modules/antd/es/modal/locale.js
var runtimeLocale = Object.assign({}, en_US_default6.Modal);
var localeList = [];
var generateLocale = () => localeList.reduce((merged, locale6) => Object.assign(Object.assign({}, merged), locale6), en_US_default6.Modal);
function changeConfirmLocale(newLocale) {
  if (newLocale) {
    const cloneLocale = Object.assign({}, newLocale);
    localeList.push(cloneLocale);
    runtimeLocale = generateLocale();
    return () => {
      localeList = localeList.filter((locale6) => locale6 !== cloneLocale);
      runtimeLocale = generateLocale();
    };
  }
  runtimeLocale = Object.assign({}, en_US_default6.Modal);
}
function getConfirmLocale() {
  return runtimeLocale;
}

// ../../node_modules/antd/es/locale/context.js
var import_react8 = require("react");
var LocaleContext = /* @__PURE__ */ (0, import_react8.createContext)(void 0);
var context_default = LocaleContext;

// ../../node_modules/antd/es/locale/useLocale.js
var React15 = __toESM(require("react"));
var useLocale = (componentName, defaultLocale) => {
  const fullLocale = React15.useContext(context_default);
  const getLocale = React15.useMemo(() => {
    var _a;
    const locale6 = defaultLocale || en_US_default6[componentName];
    const localeFromContext = (_a = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale[componentName]) !== null && _a !== void 0 ? _a : {};
    return Object.assign(Object.assign({}, typeof locale6 === "function" ? locale6() : locale6), localeFromContext || {});
  }, [componentName, defaultLocale, fullLocale]);
  const getLocaleCode = React15.useMemo(() => {
    const localeCode = fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.locale;
    if ((fullLocale === null || fullLocale === void 0 ? void 0 : fullLocale.exist) && !localeCode) {
      return en_US_default6.locale;
    }
    return localeCode;
  }, [fullLocale]);
  return [getLocale, getLocaleCode];
};
var useLocale_default = useLocale;

// ../../node_modules/antd/es/locale/index.js
var ANT_MARK = "internalMark";
var LocaleProvider = (props) => {
  const {
    locale: locale6 = {},
    children,
    _ANT_MARK__
  } = props;
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("LocaleProvider");
    process.env.NODE_ENV !== "production" ? warning6(_ANT_MARK__ === ANT_MARK, "deprecated", "`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale") : void 0;
  }
  React16.useEffect(() => {
    const clearLocale = changeConfirmLocale(locale6 && locale6.Modal);
    return clearLocale;
  }, [locale6]);
  const getMemoizedContextValue = React16.useMemo(() => Object.assign(Object.assign({}, locale6), {
    exist: true
  }), [locale6]);
  return /* @__PURE__ */ React16.createElement(context_default.Provider, {
    value: getMemoizedContextValue
  }, children);
};
if (process.env.NODE_ENV !== "production") {
  LocaleProvider.displayName = "LocaleProvider";
}
var locale_default = LocaleProvider;

// ../../node_modules/antd/es/theme/context.js
var import_react9 = __toESM(require("react"));

// ../../node_modules/@ctrl/tinycolor/dist/module/util.js
function bound01(n, max3) {
  if (isOnePointZero(n)) {
    n = "100%";
  }
  var isPercent = isPercentage(n);
  n = max3 === 360 ? n : Math.min(max3, Math.max(0, parseFloat(n)));
  if (isPercent) {
    n = parseInt(String(n * max3), 10) / 100;
  }
  if (Math.abs(n - max3) < 1e-6) {
    return 1;
  }
  if (max3 === 360) {
    n = (n < 0 ? n % max3 + max3 : n % max3) / parseFloat(String(max3));
  } else {
    n = n % max3 / parseFloat(String(max3));
  }
  return n;
}
function clamp01(val) {
  return Math.min(1, Math.max(0, val));
}
function isOnePointZero(n) {
  return typeof n === "string" && n.indexOf(".") !== -1 && parseFloat(n) === 1;
}
function isPercentage(n) {
  return typeof n === "string" && n.indexOf("%") !== -1;
}
function boundAlpha(a) {
  a = parseFloat(a);
  if (isNaN(a) || a < 0 || a > 1) {
    a = 1;
  }
  return a;
}
function convertToPercentage(n) {
  if (n <= 1) {
    return "".concat(Number(n) * 100, "%");
  }
  return n;
}
function pad2(c) {
  return c.length === 1 ? "0" + c : String(c);
}

// ../../node_modules/@ctrl/tinycolor/dist/module/conversion.js
function rgbToRgb(r, g, b) {
  return {
    r: bound01(r, 255) * 255,
    g: bound01(g, 255) * 255,
    b: bound01(b, 255) * 255
  };
}
function rgbToHsl(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max3 = Math.max(r, g, b);
  var min3 = Math.min(r, g, b);
  var h = 0;
  var s2 = 0;
  var l = (max3 + min3) / 2;
  if (max3 === min3) {
    s2 = 0;
    h = 0;
  } else {
    var d = max3 - min3;
    s2 = l > 0.5 ? d / (2 - max3 - min3) : d / (max3 + min3);
    switch (max3) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }
  return { h, s: s2, l };
}
function hue2rgb(p, q, t) {
  if (t < 0) {
    t += 1;
  }
  if (t > 1) {
    t -= 1;
  }
  if (t < 1 / 6) {
    return p + (q - p) * (6 * t);
  }
  if (t < 1 / 2) {
    return q;
  }
  if (t < 2 / 3) {
    return p + (q - p) * (2 / 3 - t) * 6;
  }
  return p;
}
function hslToRgb(h, s2, l) {
  var r;
  var g;
  var b;
  h = bound01(h, 360);
  s2 = bound01(s2, 100);
  l = bound01(l, 100);
  if (s2 === 0) {
    g = l;
    b = l;
    r = l;
  } else {
    var q = l < 0.5 ? l * (1 + s2) : l + s2 - l * s2;
    var p = 2 * l - q;
    r = hue2rgb(p, q, h + 1 / 3);
    g = hue2rgb(p, q, h);
    b = hue2rgb(p, q, h - 1 / 3);
  }
  return { r: r * 255, g: g * 255, b: b * 255 };
}
function rgbToHsv(r, g, b) {
  r = bound01(r, 255);
  g = bound01(g, 255);
  b = bound01(b, 255);
  var max3 = Math.max(r, g, b);
  var min3 = Math.min(r, g, b);
  var h = 0;
  var v = max3;
  var d = max3 - min3;
  var s2 = max3 === 0 ? 0 : d / max3;
  if (max3 === min3) {
    h = 0;
  } else {
    switch (max3) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
      default:
        break;
    }
    h /= 6;
  }
  return { h, s: s2, v };
}
function hsvToRgb(h, s2, v) {
  h = bound01(h, 360) * 6;
  s2 = bound01(s2, 100);
  v = bound01(v, 100);
  var i = Math.floor(h);
  var f = h - i;
  var p = v * (1 - s2);
  var q = v * (1 - f * s2);
  var t = v * (1 - (1 - f) * s2);
  var mod = i % 6;
  var r = [v, q, p, p, t, v][mod];
  var g = [t, v, v, q, p, p][mod];
  var b = [p, p, t, v, v, q][mod];
  return { r: r * 255, g: g * 255, b: b * 255 };
}
function rgbToHex(r, g, b, allow3Char) {
  var hex2 = [
    pad2(Math.round(r).toString(16)),
    pad2(Math.round(g).toString(16)),
    pad2(Math.round(b).toString(16))
  ];
  if (allow3Char && hex2[0].startsWith(hex2[0].charAt(1)) && hex2[1].startsWith(hex2[1].charAt(1)) && hex2[2].startsWith(hex2[2].charAt(1))) {
    return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0);
  }
  return hex2.join("");
}
function rgbaToHex(r, g, b, a, allow4Char) {
  var hex2 = [
    pad2(Math.round(r).toString(16)),
    pad2(Math.round(g).toString(16)),
    pad2(Math.round(b).toString(16)),
    pad2(convertDecimalToHex(a))
  ];
  if (allow4Char && hex2[0].startsWith(hex2[0].charAt(1)) && hex2[1].startsWith(hex2[1].charAt(1)) && hex2[2].startsWith(hex2[2].charAt(1)) && hex2[3].startsWith(hex2[3].charAt(1))) {
    return hex2[0].charAt(0) + hex2[1].charAt(0) + hex2[2].charAt(0) + hex2[3].charAt(0);
  }
  return hex2.join("");
}
function convertDecimalToHex(d) {
  return Math.round(parseFloat(d) * 255).toString(16);
}
function convertHexToDecimal(h) {
  return parseIntFromHex(h) / 255;
}
function parseIntFromHex(val) {
  return parseInt(val, 16);
}
function numberInputToObject(color2) {
  return {
    r: color2 >> 16,
    g: (color2 & 65280) >> 8,
    b: color2 & 255
  };
}

// ../../node_modules/@ctrl/tinycolor/dist/module/css-color-names.js
var names = {
  aliceblue: "#f0f8ff",
  antiquewhite: "#faebd7",
  aqua: "#00ffff",
  aquamarine: "#7fffd4",
  azure: "#f0ffff",
  beige: "#f5f5dc",
  bisque: "#ffe4c4",
  black: "#000000",
  blanchedalmond: "#ffebcd",
  blue: "#0000ff",
  blueviolet: "#8a2be2",
  brown: "#a52a2a",
  burlywood: "#deb887",
  cadetblue: "#5f9ea0",
  chartreuse: "#7fff00",
  chocolate: "#d2691e",
  coral: "#ff7f50",
  cornflowerblue: "#6495ed",
  cornsilk: "#fff8dc",
  crimson: "#dc143c",
  cyan: "#00ffff",
  darkblue: "#00008b",
  darkcyan: "#008b8b",
  darkgoldenrod: "#b8860b",
  darkgray: "#a9a9a9",
  darkgreen: "#006400",
  darkgrey: "#a9a9a9",
  darkkhaki: "#bdb76b",
  darkmagenta: "#8b008b",
  darkolivegreen: "#556b2f",
  darkorange: "#ff8c00",
  darkorchid: "#9932cc",
  darkred: "#8b0000",
  darksalmon: "#e9967a",
  darkseagreen: "#8fbc8f",
  darkslateblue: "#483d8b",
  darkslategray: "#2f4f4f",
  darkslategrey: "#2f4f4f",
  darkturquoise: "#00ced1",
  darkviolet: "#9400d3",
  deeppink: "#ff1493",
  deepskyblue: "#00bfff",
  dimgray: "#696969",
  dimgrey: "#696969",
  dodgerblue: "#1e90ff",
  firebrick: "#b22222",
  floralwhite: "#fffaf0",
  forestgreen: "#228b22",
  fuchsia: "#ff00ff",
  gainsboro: "#dcdcdc",
  ghostwhite: "#f8f8ff",
  goldenrod: "#daa520",
  gold: "#ffd700",
  gray: "#808080",
  green: "#008000",
  greenyellow: "#adff2f",
  grey: "#808080",
  honeydew: "#f0fff0",
  hotpink: "#ff69b4",
  indianred: "#cd5c5c",
  indigo: "#4b0082",
  ivory: "#fffff0",
  khaki: "#f0e68c",
  lavenderblush: "#fff0f5",
  lavender: "#e6e6fa",
  lawngreen: "#7cfc00",
  lemonchiffon: "#fffacd",
  lightblue: "#add8e6",
  lightcoral: "#f08080",
  lightcyan: "#e0ffff",
  lightgoldenrodyellow: "#fafad2",
  lightgray: "#d3d3d3",
  lightgreen: "#90ee90",
  lightgrey: "#d3d3d3",
  lightpink: "#ffb6c1",
  lightsalmon: "#ffa07a",
  lightseagreen: "#20b2aa",
  lightskyblue: "#87cefa",
  lightslategray: "#778899",
  lightslategrey: "#778899",
  lightsteelblue: "#b0c4de",
  lightyellow: "#ffffe0",
  lime: "#00ff00",
  limegreen: "#32cd32",
  linen: "#faf0e6",
  magenta: "#ff00ff",
  maroon: "#800000",
  mediumaquamarine: "#66cdaa",
  mediumblue: "#0000cd",
  mediumorchid: "#ba55d3",
  mediumpurple: "#9370db",
  mediumseagreen: "#3cb371",
  mediumslateblue: "#7b68ee",
  mediumspringgreen: "#00fa9a",
  mediumturquoise: "#48d1cc",
  mediumvioletred: "#c71585",
  midnightblue: "#191970",
  mintcream: "#f5fffa",
  mistyrose: "#ffe4e1",
  moccasin: "#ffe4b5",
  navajowhite: "#ffdead",
  navy: "#000080",
  oldlace: "#fdf5e6",
  olive: "#808000",
  olivedrab: "#6b8e23",
  orange: "#ffa500",
  orangered: "#ff4500",
  orchid: "#da70d6",
  palegoldenrod: "#eee8aa",
  palegreen: "#98fb98",
  paleturquoise: "#afeeee",
  palevioletred: "#db7093",
  papayawhip: "#ffefd5",
  peachpuff: "#ffdab9",
  peru: "#cd853f",
  pink: "#ffc0cb",
  plum: "#dda0dd",
  powderblue: "#b0e0e6",
  purple: "#800080",
  rebeccapurple: "#663399",
  red: "#ff0000",
  rosybrown: "#bc8f8f",
  royalblue: "#4169e1",
  saddlebrown: "#8b4513",
  salmon: "#fa8072",
  sandybrown: "#f4a460",
  seagreen: "#2e8b57",
  seashell: "#fff5ee",
  sienna: "#a0522d",
  silver: "#c0c0c0",
  skyblue: "#87ceeb",
  slateblue: "#6a5acd",
  slategray: "#708090",
  slategrey: "#708090",
  snow: "#fffafa",
  springgreen: "#00ff7f",
  steelblue: "#4682b4",
  tan: "#d2b48c",
  teal: "#008080",
  thistle: "#d8bfd8",
  tomato: "#ff6347",
  turquoise: "#40e0d0",
  violet: "#ee82ee",
  wheat: "#f5deb3",
  white: "#ffffff",
  whitesmoke: "#f5f5f5",
  yellow: "#ffff00",
  yellowgreen: "#9acd32"
};

// ../../node_modules/@ctrl/tinycolor/dist/module/format-input.js
function inputToRGB(color2) {
  var rgb = { r: 0, g: 0, b: 0 };
  var a = 1;
  var s2 = null;
  var v = null;
  var l = null;
  var ok = false;
  var format2 = false;
  if (typeof color2 === "string") {
    color2 = stringInputToObject(color2);
  }
  if (typeof color2 === "object") {
    if (isValidCSSUnit(color2.r) && isValidCSSUnit(color2.g) && isValidCSSUnit(color2.b)) {
      rgb = rgbToRgb(color2.r, color2.g, color2.b);
      ok = true;
      format2 = String(color2.r).substr(-1) === "%" ? "prgb" : "rgb";
    } else if (isValidCSSUnit(color2.h) && isValidCSSUnit(color2.s) && isValidCSSUnit(color2.v)) {
      s2 = convertToPercentage(color2.s);
      v = convertToPercentage(color2.v);
      rgb = hsvToRgb(color2.h, s2, v);
      ok = true;
      format2 = "hsv";
    } else if (isValidCSSUnit(color2.h) && isValidCSSUnit(color2.s) && isValidCSSUnit(color2.l)) {
      s2 = convertToPercentage(color2.s);
      l = convertToPercentage(color2.l);
      rgb = hslToRgb(color2.h, s2, l);
      ok = true;
      format2 = "hsl";
    }
    if (Object.prototype.hasOwnProperty.call(color2, "a")) {
      a = color2.a;
    }
  }
  a = boundAlpha(a);
  return {
    ok,
    format: color2.format || format2,
    r: Math.min(255, Math.max(rgb.r, 0)),
    g: Math.min(255, Math.max(rgb.g, 0)),
    b: Math.min(255, Math.max(rgb.b, 0)),
    a
  };
}
var CSS_INTEGER = "[-\\+]?\\d+%?";
var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";
var CSS_UNIT = "(?:".concat(CSS_NUMBER, ")|(?:").concat(CSS_INTEGER, ")");
var PERMISSIVE_MATCH3 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var PERMISSIVE_MATCH4 = "[\\s|\\(]+(".concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")[,|\\s]+(").concat(CSS_UNIT, ")\\s*\\)?");
var matchers = {
  CSS_UNIT: new RegExp(CSS_UNIT),
  rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
  rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
  hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
  hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
  hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
  hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
  hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
  hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
  hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
};
function stringInputToObject(color2) {
  color2 = color2.trim().toLowerCase();
  if (color2.length === 0) {
    return false;
  }
  var named = false;
  if (names[color2]) {
    color2 = names[color2];
    named = true;
  } else if (color2 === "transparent") {
    return { r: 0, g: 0, b: 0, a: 0, format: "name" };
  }
  var match2 = matchers.rgb.exec(color2);
  if (match2) {
    return { r: match2[1], g: match2[2], b: match2[3] };
  }
  match2 = matchers.rgba.exec(color2);
  if (match2) {
    return { r: match2[1], g: match2[2], b: match2[3], a: match2[4] };
  }
  match2 = matchers.hsl.exec(color2);
  if (match2) {
    return { h: match2[1], s: match2[2], l: match2[3] };
  }
  match2 = matchers.hsla.exec(color2);
  if (match2) {
    return { h: match2[1], s: match2[2], l: match2[3], a: match2[4] };
  }
  match2 = matchers.hsv.exec(color2);
  if (match2) {
    return { h: match2[1], s: match2[2], v: match2[3] };
  }
  match2 = matchers.hsva.exec(color2);
  if (match2) {
    return { h: match2[1], s: match2[2], v: match2[3], a: match2[4] };
  }
  match2 = matchers.hex8.exec(color2);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      a: convertHexToDecimal(match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  match2 = matchers.hex6.exec(color2);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1]),
      g: parseIntFromHex(match2[2]),
      b: parseIntFromHex(match2[3]),
      format: named ? "name" : "hex"
    };
  }
  match2 = matchers.hex4.exec(color2);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1] + match2[1]),
      g: parseIntFromHex(match2[2] + match2[2]),
      b: parseIntFromHex(match2[3] + match2[3]),
      a: convertHexToDecimal(match2[4] + match2[4]),
      format: named ? "name" : "hex8"
    };
  }
  match2 = matchers.hex3.exec(color2);
  if (match2) {
    return {
      r: parseIntFromHex(match2[1] + match2[1]),
      g: parseIntFromHex(match2[2] + match2[2]),
      b: parseIntFromHex(match2[3] + match2[3]),
      format: named ? "name" : "hex"
    };
  }
  return false;
}
function isValidCSSUnit(color2) {
  return Boolean(matchers.CSS_UNIT.exec(String(color2)));
}

// ../../node_modules/@ctrl/tinycolor/dist/module/index.js
var TinyColor = (
  /** @class */
  function() {
    function TinyColor2(color2, opts) {
      if (color2 === void 0) {
        color2 = "";
      }
      if (opts === void 0) {
        opts = {};
      }
      var _a;
      if (color2 instanceof TinyColor2) {
        return color2;
      }
      if (typeof color2 === "number") {
        color2 = numberInputToObject(color2);
      }
      this.originalInput = color2;
      var rgb = inputToRGB(color2);
      this.originalInput = color2;
      this.r = rgb.r;
      this.g = rgb.g;
      this.b = rgb.b;
      this.a = rgb.a;
      this.roundA = Math.round(100 * this.a) / 100;
      this.format = (_a = opts.format) !== null && _a !== void 0 ? _a : rgb.format;
      this.gradientType = opts.gradientType;
      if (this.r < 1) {
        this.r = Math.round(this.r);
      }
      if (this.g < 1) {
        this.g = Math.round(this.g);
      }
      if (this.b < 1) {
        this.b = Math.round(this.b);
      }
      this.isValid = rgb.ok;
    }
    TinyColor2.prototype.isDark = function() {
      return this.getBrightness() < 128;
    };
    TinyColor2.prototype.isLight = function() {
      return !this.isDark();
    };
    TinyColor2.prototype.getBrightness = function() {
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1e3;
    };
    TinyColor2.prototype.getLuminance = function() {
      var rgb = this.toRgb();
      var R;
      var G;
      var B;
      var RsRGB = rgb.r / 255;
      var GsRGB = rgb.g / 255;
      var BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) {
        R = RsRGB / 12.92;
      } else {
        R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      }
      if (GsRGB <= 0.03928) {
        G = GsRGB / 12.92;
      } else {
        G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      }
      if (BsRGB <= 0.03928) {
        B = BsRGB / 12.92;
      } else {
        B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      }
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    };
    TinyColor2.prototype.getAlpha = function() {
      return this.a;
    };
    TinyColor2.prototype.setAlpha = function(alpha) {
      this.a = boundAlpha(alpha);
      this.roundA = Math.round(100 * this.a) / 100;
      return this;
    };
    TinyColor2.prototype.isMonochrome = function() {
      var s2 = this.toHsl().s;
      return s2 === 0;
    };
    TinyColor2.prototype.toHsv = function() {
      var hsv = rgbToHsv(this.r, this.g, this.b);
      return { h: hsv.h * 360, s: hsv.s, v: hsv.v, a: this.a };
    };
    TinyColor2.prototype.toHsvString = function() {
      var hsv = rgbToHsv(this.r, this.g, this.b);
      var h = Math.round(hsv.h * 360);
      var s2 = Math.round(hsv.s * 100);
      var v = Math.round(hsv.v * 100);
      return this.a === 1 ? "hsv(".concat(h, ", ").concat(s2, "%, ").concat(v, "%)") : "hsva(".concat(h, ", ").concat(s2, "%, ").concat(v, "%, ").concat(this.roundA, ")");
    };
    TinyColor2.prototype.toHsl = function() {
      var hsl = rgbToHsl(this.r, this.g, this.b);
      return { h: hsl.h * 360, s: hsl.s, l: hsl.l, a: this.a };
    };
    TinyColor2.prototype.toHslString = function() {
      var hsl = rgbToHsl(this.r, this.g, this.b);
      var h = Math.round(hsl.h * 360);
      var s2 = Math.round(hsl.s * 100);
      var l = Math.round(hsl.l * 100);
      return this.a === 1 ? "hsl(".concat(h, ", ").concat(s2, "%, ").concat(l, "%)") : "hsla(".concat(h, ", ").concat(s2, "%, ").concat(l, "%, ").concat(this.roundA, ")");
    };
    TinyColor2.prototype.toHex = function(allow3Char) {
      if (allow3Char === void 0) {
        allow3Char = false;
      }
      return rgbToHex(this.r, this.g, this.b, allow3Char);
    };
    TinyColor2.prototype.toHexString = function(allow3Char) {
      if (allow3Char === void 0) {
        allow3Char = false;
      }
      return "#" + this.toHex(allow3Char);
    };
    TinyColor2.prototype.toHex8 = function(allow4Char) {
      if (allow4Char === void 0) {
        allow4Char = false;
      }
      return rgbaToHex(this.r, this.g, this.b, this.a, allow4Char);
    };
    TinyColor2.prototype.toHex8String = function(allow4Char) {
      if (allow4Char === void 0) {
        allow4Char = false;
      }
      return "#" + this.toHex8(allow4Char);
    };
    TinyColor2.prototype.toHexShortString = function(allowShortChar) {
      if (allowShortChar === void 0) {
        allowShortChar = false;
      }
      return this.a === 1 ? this.toHexString(allowShortChar) : this.toHex8String(allowShortChar);
    };
    TinyColor2.prototype.toRgb = function() {
      return {
        r: Math.round(this.r),
        g: Math.round(this.g),
        b: Math.round(this.b),
        a: this.a
      };
    };
    TinyColor2.prototype.toRgbString = function() {
      var r = Math.round(this.r);
      var g = Math.round(this.g);
      var b = Math.round(this.b);
      return this.a === 1 ? "rgb(".concat(r, ", ").concat(g, ", ").concat(b, ")") : "rgba(".concat(r, ", ").concat(g, ", ").concat(b, ", ").concat(this.roundA, ")");
    };
    TinyColor2.prototype.toPercentageRgb = function() {
      var fmt = function(x2) {
        return "".concat(Math.round(bound01(x2, 255) * 100), "%");
      };
      return {
        r: fmt(this.r),
        g: fmt(this.g),
        b: fmt(this.b),
        a: this.a
      };
    };
    TinyColor2.prototype.toPercentageRgbString = function() {
      var rnd = function(x2) {
        return Math.round(bound01(x2, 255) * 100);
      };
      return this.a === 1 ? "rgb(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%)") : "rgba(".concat(rnd(this.r), "%, ").concat(rnd(this.g), "%, ").concat(rnd(this.b), "%, ").concat(this.roundA, ")");
    };
    TinyColor2.prototype.toName = function() {
      if (this.a === 0) {
        return "transparent";
      }
      if (this.a < 1) {
        return false;
      }
      var hex2 = "#" + rgbToHex(this.r, this.g, this.b, false);
      for (var _i = 0, _a = Object.entries(names); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        if (hex2 === value) {
          return key;
        }
      }
      return false;
    };
    TinyColor2.prototype.toString = function(format2) {
      var formatSet = Boolean(format2);
      format2 = format2 !== null && format2 !== void 0 ? format2 : this.format;
      var formattedString = false;
      var hasAlpha = this.a < 1 && this.a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format2.startsWith("hex") || format2 === "name");
      if (needsAlphaFormat) {
        if (format2 === "name" && this.a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format2 === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format2 === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format2 === "hex" || format2 === "hex6") {
        formattedString = this.toHexString();
      }
      if (format2 === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format2 === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format2 === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format2 === "name") {
        formattedString = this.toName();
      }
      if (format2 === "hsl") {
        formattedString = this.toHslString();
      }
      if (format2 === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    };
    TinyColor2.prototype.toNumber = function() {
      return (Math.round(this.r) << 16) + (Math.round(this.g) << 8) + Math.round(this.b);
    };
    TinyColor2.prototype.clone = function() {
      return new TinyColor2(this.toString());
    };
    TinyColor2.prototype.lighten = function(amount) {
      if (amount === void 0) {
        amount = 10;
      }
      var hsl = this.toHsl();
      hsl.l += amount / 100;
      hsl.l = clamp01(hsl.l);
      return new TinyColor2(hsl);
    };
    TinyColor2.prototype.brighten = function(amount) {
      if (amount === void 0) {
        amount = 10;
      }
      var rgb = this.toRgb();
      rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
      rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
      rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
      return new TinyColor2(rgb);
    };
    TinyColor2.prototype.darken = function(amount) {
      if (amount === void 0) {
        amount = 10;
      }
      var hsl = this.toHsl();
      hsl.l -= amount / 100;
      hsl.l = clamp01(hsl.l);
      return new TinyColor2(hsl);
    };
    TinyColor2.prototype.tint = function(amount) {
      if (amount === void 0) {
        amount = 10;
      }
      return this.mix("white", amount);
    };
    TinyColor2.prototype.shade = function(amount) {
      if (amount === void 0) {
        amount = 10;
      }
      return this.mix("black", amount);
    };
    TinyColor2.prototype.desaturate = function(amount) {
      if (amount === void 0) {
        amount = 10;
      }
      var hsl = this.toHsl();
      hsl.s -= amount / 100;
      hsl.s = clamp01(hsl.s);
      return new TinyColor2(hsl);
    };
    TinyColor2.prototype.saturate = function(amount) {
      if (amount === void 0) {
        amount = 10;
      }
      var hsl = this.toHsl();
      hsl.s += amount / 100;
      hsl.s = clamp01(hsl.s);
      return new TinyColor2(hsl);
    };
    TinyColor2.prototype.greyscale = function() {
      return this.desaturate(100);
    };
    TinyColor2.prototype.spin = function(amount) {
      var hsl = this.toHsl();
      var hue = (hsl.h + amount) % 360;
      hsl.h = hue < 0 ? 360 + hue : hue;
      return new TinyColor2(hsl);
    };
    TinyColor2.prototype.mix = function(color2, amount) {
      if (amount === void 0) {
        amount = 50;
      }
      var rgb1 = this.toRgb();
      var rgb2 = new TinyColor2(color2).toRgb();
      var p = amount / 100;
      var rgba = {
        r: (rgb2.r - rgb1.r) * p + rgb1.r,
        g: (rgb2.g - rgb1.g) * p + rgb1.g,
        b: (rgb2.b - rgb1.b) * p + rgb1.b,
        a: (rgb2.a - rgb1.a) * p + rgb1.a
      };
      return new TinyColor2(rgba);
    };
    TinyColor2.prototype.analogous = function(results, slices) {
      if (results === void 0) {
        results = 6;
      }
      if (slices === void 0) {
        slices = 30;
      }
      var hsl = this.toHsl();
      var part = 360 / slices;
      var ret = [this];
      for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results; ) {
        hsl.h = (hsl.h + part) % 360;
        ret.push(new TinyColor2(hsl));
      }
      return ret;
    };
    TinyColor2.prototype.complement = function() {
      var hsl = this.toHsl();
      hsl.h = (hsl.h + 180) % 360;
      return new TinyColor2(hsl);
    };
    TinyColor2.prototype.monochromatic = function(results) {
      if (results === void 0) {
        results = 6;
      }
      var hsv = this.toHsv();
      var h = hsv.h;
      var s2 = hsv.s;
      var v = hsv.v;
      var res = [];
      var modification = 1 / results;
      while (results--) {
        res.push(new TinyColor2({ h, s: s2, v }));
        v = (v + modification) % 1;
      }
      return res;
    };
    TinyColor2.prototype.splitcomplement = function() {
      var hsl = this.toHsl();
      var h = hsl.h;
      return [
        this,
        new TinyColor2({ h: (h + 72) % 360, s: hsl.s, l: hsl.l }),
        new TinyColor2({ h: (h + 216) % 360, s: hsl.s, l: hsl.l })
      ];
    };
    TinyColor2.prototype.onBackground = function(background) {
      var fg = this.toRgb();
      var bg = new TinyColor2(background).toRgb();
      var alpha = fg.a + bg.a * (1 - fg.a);
      return new TinyColor2({
        r: (fg.r * fg.a + bg.r * bg.a * (1 - fg.a)) / alpha,
        g: (fg.g * fg.a + bg.g * bg.a * (1 - fg.a)) / alpha,
        b: (fg.b * fg.a + bg.b * bg.a * (1 - fg.a)) / alpha,
        a: alpha
      });
    };
    TinyColor2.prototype.triad = function() {
      return this.polyad(3);
    };
    TinyColor2.prototype.tetrad = function() {
      return this.polyad(4);
    };
    TinyColor2.prototype.polyad = function(n) {
      var hsl = this.toHsl();
      var h = hsl.h;
      var result = [this];
      var increment = 360 / n;
      for (var i = 1; i < n; i++) {
        result.push(new TinyColor2({ h: (h + i * increment) % 360, s: hsl.s, l: hsl.l }));
      }
      return result;
    };
    TinyColor2.prototype.equals = function(color2) {
      return this.toRgbString() === new TinyColor2(color2).toRgbString();
    };
    return TinyColor2;
  }()
);

// ../../node_modules/@ant-design/colors/es/generate.js
var hueStep = 2;
var saturationStep = 0.16;
var saturationStep2 = 0.05;
var brightnessStep1 = 0.05;
var brightnessStep2 = 0.15;
var lightColorCount = 5;
var darkColorCount = 4;
var darkColorMap = [{
  index: 7,
  opacity: 0.15
}, {
  index: 6,
  opacity: 0.25
}, {
  index: 5,
  opacity: 0.3
}, {
  index: 5,
  opacity: 0.45
}, {
  index: 5,
  opacity: 0.65
}, {
  index: 5,
  opacity: 0.85
}, {
  index: 4,
  opacity: 0.9
}, {
  index: 3,
  opacity: 0.95
}, {
  index: 2,
  opacity: 0.97
}, {
  index: 1,
  opacity: 0.98
}];
function toHsv(_ref) {
  var r = _ref.r, g = _ref.g, b = _ref.b;
  var hsv = rgbToHsv(r, g, b);
  return {
    h: hsv.h * 360,
    s: hsv.s,
    v: hsv.v
  };
}
function toHex(_ref2) {
  var r = _ref2.r, g = _ref2.g, b = _ref2.b;
  return "#".concat(rgbToHex(r, g, b, false));
}
function mix(rgb1, rgb2, amount) {
  var p = amount / 100;
  var rgb = {
    r: (rgb2.r - rgb1.r) * p + rgb1.r,
    g: (rgb2.g - rgb1.g) * p + rgb1.g,
    b: (rgb2.b - rgb1.b) * p + rgb1.b
  };
  return rgb;
}
function getHue(hsv, i, light) {
  var hue;
  if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
    hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
  } else {
    hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
  }
  if (hue < 0) {
    hue += 360;
  } else if (hue >= 360) {
    hue -= 360;
  }
  return hue;
}
function getSaturation(hsv, i, light) {
  if (hsv.h === 0 && hsv.s === 0) {
    return hsv.s;
  }
  var saturation;
  if (light) {
    saturation = hsv.s - saturationStep * i;
  } else if (i === darkColorCount) {
    saturation = hsv.s + saturationStep;
  } else {
    saturation = hsv.s + saturationStep2 * i;
  }
  if (saturation > 1) {
    saturation = 1;
  }
  if (light && i === lightColorCount && saturation > 0.1) {
    saturation = 0.1;
  }
  if (saturation < 0.06) {
    saturation = 0.06;
  }
  return Number(saturation.toFixed(2));
}
function getValue(hsv, i, light) {
  var value;
  if (light) {
    value = hsv.v + brightnessStep1 * i;
  } else {
    value = hsv.v - brightnessStep2 * i;
  }
  if (value > 1) {
    value = 1;
  }
  return Number(value.toFixed(2));
}
function generate(color2) {
  var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  var patterns = [];
  var pColor = inputToRGB(color2);
  for (var i = lightColorCount; i > 0; i -= 1) {
    var hsv = toHsv(pColor);
    var colorString = toHex(inputToRGB({
      h: getHue(hsv, i, true),
      s: getSaturation(hsv, i, true),
      v: getValue(hsv, i, true)
    }));
    patterns.push(colorString);
  }
  patterns.push(toHex(pColor));
  for (var _i = 1; _i <= darkColorCount; _i += 1) {
    var _hsv = toHsv(pColor);
    var _colorString = toHex(inputToRGB({
      h: getHue(_hsv, _i),
      s: getSaturation(_hsv, _i),
      v: getValue(_hsv, _i)
    }));
    patterns.push(_colorString);
  }
  if (opts.theme === "dark") {
    return darkColorMap.map(function(_ref3) {
      var index2 = _ref3.index, opacity = _ref3.opacity;
      var darkColorString = toHex(mix(inputToRGB(opts.backgroundColor || "#141414"), inputToRGB(patterns[index2]), opacity * 100));
      return darkColorString;
    });
  }
  return patterns;
}

// ../../node_modules/@ant-design/colors/es/index.js
var presetPrimaryColors = {
  red: "#F5222D",
  volcano: "#FA541C",
  orange: "#FA8C16",
  gold: "#FAAD14",
  yellow: "#FADB14",
  lime: "#A0D911",
  green: "#52C41A",
  cyan: "#13C2C2",
  blue: "#1677FF",
  geekblue: "#2F54EB",
  purple: "#722ED1",
  magenta: "#EB2F96",
  grey: "#666666"
};
var presetPalettes = {};
var presetDarkPalettes = {};
Object.keys(presetPrimaryColors).forEach(function(key) {
  presetPalettes[key] = generate(presetPrimaryColors[key]);
  presetPalettes[key].primary = presetPalettes[key][5];
  presetDarkPalettes[key] = generate(presetPrimaryColors[key], {
    theme: "dark",
    backgroundColor: "#141414"
  });
  presetDarkPalettes[key].primary = presetDarkPalettes[key][5];
});
var red = presetPalettes.red;
var volcano = presetPalettes.volcano;
var gold = presetPalettes.gold;
var orange = presetPalettes.orange;
var yellow = presetPalettes.yellow;
var lime = presetPalettes.lime;
var green = presetPalettes.green;
var cyan = presetPalettes.cyan;
var blue = presetPalettes.blue;
var geekblue = presetPalettes.geekblue;
var purple = presetPalettes.purple;
var magenta = presetPalettes.magenta;
var grey = presetPalettes.grey;
var gray = presetPalettes.grey;

// ../../node_modules/antd/es/theme/themes/shared/genControlHeight.js
var genControlHeight = (token2) => {
  const {
    controlHeight
  } = token2;
  return {
    controlHeightSM: controlHeight * 0.75,
    controlHeightXS: controlHeight * 0.5,
    controlHeightLG: controlHeight * 1.25
  };
};
var genControlHeight_default = genControlHeight;

// ../../node_modules/antd/es/theme/themes/shared/genSizeMapToken.js
function genSizeMapToken(token2) {
  const {
    sizeUnit,
    sizeStep
  } = token2;
  return {
    sizeXXL: sizeUnit * (sizeStep + 8),
    // 48
    sizeXL: sizeUnit * (sizeStep + 4),
    // 32
    sizeLG: sizeUnit * (sizeStep + 2),
    // 24
    sizeMD: sizeUnit * (sizeStep + 1),
    // 20
    sizeMS: sizeUnit * sizeStep,
    // 16
    size: sizeUnit * sizeStep,
    // 16
    sizeSM: sizeUnit * (sizeStep - 1),
    // 12
    sizeXS: sizeUnit * (sizeStep - 2),
    // 8
    sizeXXS: sizeUnit * (sizeStep - 3)
    // 4
  };
}

// ../../node_modules/antd/es/theme/themes/seed.js
var defaultPresetColors = {
  blue: "#1677ff",
  purple: "#722ED1",
  cyan: "#13C2C2",
  green: "#52C41A",
  magenta: "#EB2F96",
  pink: "#eb2f96",
  red: "#F5222D",
  orange: "#FA8C16",
  yellow: "#FADB14",
  volcano: "#FA541C",
  geekblue: "#2F54EB",
  gold: "#FAAD14",
  lime: "#A0D911"
};
var seedToken = Object.assign(Object.assign({}, defaultPresetColors), {
  // Color
  colorPrimary: "#1677ff",
  colorSuccess: "#52c41a",
  colorWarning: "#faad14",
  colorError: "#ff4d4f",
  colorInfo: "#1677ff",
  colorLink: "",
  colorTextBase: "",
  colorBgBase: "",
  // Font
  fontFamily: `-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol',
'Noto Color Emoji'`,
  fontFamilyCode: `'SFMono-Regular', Consolas, 'Liberation Mono', Menlo, Courier, monospace`,
  fontSize: 14,
  // Line
  lineWidth: 1,
  lineType: "solid",
  // Motion
  motionUnit: 0.1,
  motionBase: 0,
  motionEaseOutCirc: "cubic-bezier(0.08, 0.82, 0.17, 1)",
  motionEaseInOutCirc: "cubic-bezier(0.78, 0.14, 0.15, 0.86)",
  motionEaseOut: "cubic-bezier(0.215, 0.61, 0.355, 1)",
  motionEaseInOut: "cubic-bezier(0.645, 0.045, 0.355, 1)",
  motionEaseOutBack: "cubic-bezier(0.12, 0.4, 0.29, 1.46)",
  motionEaseInBack: "cubic-bezier(0.71, -0.46, 0.88, 0.6)",
  motionEaseInQuint: "cubic-bezier(0.755, 0.05, 0.855, 0.06)",
  motionEaseOutQuint: "cubic-bezier(0.23, 1, 0.32, 1)",
  // Radius
  borderRadius: 6,
  // Size
  sizeUnit: 4,
  sizeStep: 4,
  sizePopupArrow: 16,
  // Control Base
  controlHeight: 32,
  // zIndex
  zIndexBase: 0,
  zIndexPopupBase: 1e3,
  // Image
  opacityImage: 1,
  // Wireframe
  wireframe: false,
  // Motion
  motion: true
});
var seed_default = seedToken;

// ../../node_modules/antd/es/theme/themes/shared/genColorMapToken.js
function genColorMapToken(seed, _ref) {
  let {
    generateColorPalettes: generateColorPalettes2,
    generateNeutralColorPalettes: generateNeutralColorPalettes2
  } = _ref;
  const {
    colorSuccess: colorSuccessBase,
    colorWarning: colorWarningBase,
    colorError: colorErrorBase,
    colorInfo: colorInfoBase,
    colorPrimary: colorPrimaryBase,
    colorBgBase,
    colorTextBase
  } = seed;
  const primaryColors = generateColorPalettes2(colorPrimaryBase);
  const successColors = generateColorPalettes2(colorSuccessBase);
  const warningColors = generateColorPalettes2(colorWarningBase);
  const errorColors = generateColorPalettes2(colorErrorBase);
  const infoColors = generateColorPalettes2(colorInfoBase);
  const neutralColors = generateNeutralColorPalettes2(colorBgBase, colorTextBase);
  const colorLink = seed.colorLink || seed.colorInfo;
  const linkColors = generateColorPalettes2(colorLink);
  return Object.assign(Object.assign({}, neutralColors), {
    colorPrimaryBg: primaryColors[1],
    colorPrimaryBgHover: primaryColors[2],
    colorPrimaryBorder: primaryColors[3],
    colorPrimaryBorderHover: primaryColors[4],
    colorPrimaryHover: primaryColors[5],
    colorPrimary: primaryColors[6],
    colorPrimaryActive: primaryColors[7],
    colorPrimaryTextHover: primaryColors[8],
    colorPrimaryText: primaryColors[9],
    colorPrimaryTextActive: primaryColors[10],
    colorSuccessBg: successColors[1],
    colorSuccessBgHover: successColors[2],
    colorSuccessBorder: successColors[3],
    colorSuccessBorderHover: successColors[4],
    colorSuccessHover: successColors[4],
    colorSuccess: successColors[6],
    colorSuccessActive: successColors[7],
    colorSuccessTextHover: successColors[8],
    colorSuccessText: successColors[9],
    colorSuccessTextActive: successColors[10],
    colorErrorBg: errorColors[1],
    colorErrorBgHover: errorColors[2],
    colorErrorBorder: errorColors[3],
    colorErrorBorderHover: errorColors[4],
    colorErrorHover: errorColors[5],
    colorError: errorColors[6],
    colorErrorActive: errorColors[7],
    colorErrorTextHover: errorColors[8],
    colorErrorText: errorColors[9],
    colorErrorTextActive: errorColors[10],
    colorWarningBg: warningColors[1],
    colorWarningBgHover: warningColors[2],
    colorWarningBorder: warningColors[3],
    colorWarningBorderHover: warningColors[4],
    colorWarningHover: warningColors[4],
    colorWarning: warningColors[6],
    colorWarningActive: warningColors[7],
    colorWarningTextHover: warningColors[8],
    colorWarningText: warningColors[9],
    colorWarningTextActive: warningColors[10],
    colorInfoBg: infoColors[1],
    colorInfoBgHover: infoColors[2],
    colorInfoBorder: infoColors[3],
    colorInfoBorderHover: infoColors[4],
    colorInfoHover: infoColors[4],
    colorInfo: infoColors[6],
    colorInfoActive: infoColors[7],
    colorInfoTextHover: infoColors[8],
    colorInfoText: infoColors[9],
    colorInfoTextActive: infoColors[10],
    colorLinkHover: linkColors[4],
    colorLink: linkColors[6],
    colorLinkActive: linkColors[7],
    colorBgMask: new TinyColor("#000").setAlpha(0.45).toRgbString(),
    colorWhite: "#fff"
  });
}

// ../../node_modules/antd/es/theme/themes/shared/genRadius.js
var genRadius = (radiusBase) => {
  let radiusLG = radiusBase;
  let radiusSM = radiusBase;
  let radiusXS = radiusBase;
  let radiusOuter = radiusBase;
  if (radiusBase < 6 && radiusBase >= 5) {
    radiusLG = radiusBase + 1;
  } else if (radiusBase < 16 && radiusBase >= 6) {
    radiusLG = radiusBase + 2;
  } else if (radiusBase >= 16) {
    radiusLG = 16;
  }
  if (radiusBase < 7 && radiusBase >= 5) {
    radiusSM = 4;
  } else if (radiusBase < 8 && radiusBase >= 7) {
    radiusSM = 5;
  } else if (radiusBase < 14 && radiusBase >= 8) {
    radiusSM = 6;
  } else if (radiusBase < 16 && radiusBase >= 14) {
    radiusSM = 7;
  } else if (radiusBase >= 16) {
    radiusSM = 8;
  }
  if (radiusBase < 6 && radiusBase >= 2) {
    radiusXS = 1;
  } else if (radiusBase >= 6) {
    radiusXS = 2;
  }
  if (radiusBase > 4 && radiusBase < 8) {
    radiusOuter = 4;
  } else if (radiusBase >= 8) {
    radiusOuter = 6;
  }
  return {
    borderRadius: radiusBase,
    borderRadiusXS: radiusXS,
    borderRadiusSM: radiusSM,
    borderRadiusLG: radiusLG,
    borderRadiusOuter: radiusOuter
  };
};
var genRadius_default = genRadius;

// ../../node_modules/antd/es/theme/themes/shared/genCommonMapToken.js
function genCommonMapToken(token2) {
  const {
    motionUnit,
    motionBase,
    borderRadius,
    lineWidth
  } = token2;
  return Object.assign({
    // motion
    motionDurationFast: `${(motionBase + motionUnit).toFixed(1)}s`,
    motionDurationMid: `${(motionBase + motionUnit * 2).toFixed(1)}s`,
    motionDurationSlow: `${(motionBase + motionUnit * 3).toFixed(1)}s`,
    // line
    lineWidthBold: lineWidth + 1
  }, genRadius_default(borderRadius));
}

// ../../node_modules/antd/es/theme/themes/default/colorAlgorithm.js
var getAlphaColor = (baseColor, alpha) => new TinyColor(baseColor).setAlpha(alpha).toRgbString();
var getSolidColor = (baseColor, brightness) => {
  const instance = new TinyColor(baseColor);
  return instance.darken(brightness).toHexString();
};

// ../../node_modules/antd/es/theme/themes/default/colors.js
var generateColorPalettes = (baseColor) => {
  const colors = generate(baseColor);
  return {
    1: colors[0],
    2: colors[1],
    3: colors[2],
    4: colors[3],
    5: colors[4],
    6: colors[5],
    7: colors[6],
    8: colors[4],
    9: colors[5],
    10: colors[6]
    // 8: colors[7],
    // 9: colors[8],
    // 10: colors[9],
  };
};
var generateNeutralColorPalettes = (bgBaseColor, textBaseColor) => {
  const colorBgBase = bgBaseColor || "#fff";
  const colorTextBase = textBaseColor || "#000";
  return {
    colorBgBase,
    colorTextBase,
    colorText: getAlphaColor(colorTextBase, 0.88),
    colorTextSecondary: getAlphaColor(colorTextBase, 0.65),
    colorTextTertiary: getAlphaColor(colorTextBase, 0.45),
    colorTextQuaternary: getAlphaColor(colorTextBase, 0.25),
    colorFill: getAlphaColor(colorTextBase, 0.15),
    colorFillSecondary: getAlphaColor(colorTextBase, 0.06),
    colorFillTertiary: getAlphaColor(colorTextBase, 0.04),
    colorFillQuaternary: getAlphaColor(colorTextBase, 0.02),
    colorBgLayout: getSolidColor(colorBgBase, 4),
    colorBgContainer: getSolidColor(colorBgBase, 0),
    colorBgElevated: getSolidColor(colorBgBase, 0),
    colorBgSpotlight: getAlphaColor(colorTextBase, 0.85),
    colorBgBlur: "transparent",
    colorBorder: getSolidColor(colorBgBase, 15),
    colorBorderSecondary: getSolidColor(colorBgBase, 6)
  };
};

// ../../node_modules/antd/es/theme/themes/shared/genFontSizes.js
function getLineHeight(fontSize) {
  return (fontSize + 8) / fontSize;
}
function getFontSizes(base) {
  const fontSizes = new Array(10).fill(null).map((_, index2) => {
    const i = index2 - 1;
    const baseSize = base * Math.pow(2.71828, i / 5);
    const intSize = index2 > 1 ? Math.floor(baseSize) : Math.ceil(baseSize);
    return Math.floor(intSize / 2) * 2;
  });
  fontSizes[1] = base;
  return fontSizes.map((size) => ({
    size,
    lineHeight: getLineHeight(size)
  }));
}

// ../../node_modules/antd/es/theme/themes/shared/genFontMapToken.js
var genFontMapToken = (fontSize) => {
  const fontSizePairs = getFontSizes(fontSize);
  const fontSizes = fontSizePairs.map((pair) => pair.size);
  const lineHeights = fontSizePairs.map((pair) => pair.lineHeight);
  const fontSizeMD = fontSizes[1];
  const fontSizeSM = fontSizes[0];
  const fontSizeLG = fontSizes[2];
  const lineHeight = lineHeights[1];
  const lineHeightSM = lineHeights[0];
  const lineHeightLG = lineHeights[2];
  return {
    fontSizeSM,
    fontSize: fontSizeMD,
    fontSizeLG,
    fontSizeXL: fontSizes[3],
    fontSizeHeading1: fontSizes[6],
    fontSizeHeading2: fontSizes[5],
    fontSizeHeading3: fontSizes[4],
    fontSizeHeading4: fontSizes[3],
    fontSizeHeading5: fontSizes[2],
    lineHeight,
    lineHeightLG,
    lineHeightSM,
    fontHeight: Math.round(lineHeight * fontSizeMD),
    fontHeightLG: Math.round(lineHeightLG * fontSizeLG),
    fontHeightSM: Math.round(lineHeightSM * fontSizeSM),
    lineHeightHeading1: lineHeights[6],
    lineHeightHeading2: lineHeights[5],
    lineHeightHeading3: lineHeights[4],
    lineHeightHeading4: lineHeights[3],
    lineHeightHeading5: lineHeights[2]
  };
};
var genFontMapToken_default = genFontMapToken;

// ../../node_modules/antd/es/theme/themes/default/index.js
function derivative(token2) {
  const colorPalettes = Object.keys(defaultPresetColors).map((colorKey) => {
    const colors = generate(token2[colorKey]);
    return new Array(10).fill(1).reduce((prev2, _, i) => {
      prev2[`${colorKey}-${i + 1}`] = colors[i];
      prev2[`${colorKey}${i + 1}`] = colors[i];
      return prev2;
    }, {});
  }).reduce((prev2, cur) => {
    prev2 = Object.assign(Object.assign({}, prev2), cur);
    return prev2;
  }, {});
  return Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, token2), colorPalettes), genColorMapToken(token2, {
    generateColorPalettes,
    generateNeutralColorPalettes
  })), genFontMapToken_default(token2.fontSize)), genSizeMapToken(token2)), genControlHeight_default(token2)), genCommonMapToken(token2));
}

// ../../node_modules/antd/es/theme/context.js
var defaultTheme = createTheme(derivative);
var defaultConfig = {
  token: seed_default,
  override: {
    override: seed_default
  },
  hashed: true
};
var DesignTokenContext = /* @__PURE__ */ import_react9.default.createContext(defaultConfig);

// ../../node_modules/antd/es/config-provider/context.js
var React18 = __toESM(require("react"));
var defaultIconPrefixCls = "anticon";
var defaultGetPrefixCls = (suffixCls, customizePrefixCls) => {
  if (customizePrefixCls) {
    return customizePrefixCls;
  }
  return suffixCls ? `ant-${suffixCls}` : "ant";
};
var ConfigContext = /* @__PURE__ */ React18.createContext({
  // We provide a default function for Context without provider
  getPrefixCls: defaultGetPrefixCls,
  iconPrefixCls: defaultIconPrefixCls
});
var {
  Consumer: ConfigConsumer
} = ConfigContext;

// ../../node_modules/antd/es/config-provider/cssVariables.js
var dynamicStyleMark = `-ant-${Date.now()}-${Math.random()}`;
function getStyle(globalPrefixCls2, theme) {
  const variables = {};
  const formatColor = (color2, updater) => {
    let clone = color2.clone();
    clone = (updater === null || updater === void 0 ? void 0 : updater(clone)) || clone;
    return clone.toRgbString();
  };
  const fillColor = (colorVal, type4) => {
    const baseColor = new TinyColor(colorVal);
    const colorPalettes = generate(baseColor.toRgbString());
    variables[`${type4}-color`] = formatColor(baseColor);
    variables[`${type4}-color-disabled`] = colorPalettes[1];
    variables[`${type4}-color-hover`] = colorPalettes[4];
    variables[`${type4}-color-active`] = colorPalettes[6];
    variables[`${type4}-color-outline`] = baseColor.clone().setAlpha(0.2).toRgbString();
    variables[`${type4}-color-deprecated-bg`] = colorPalettes[0];
    variables[`${type4}-color-deprecated-border`] = colorPalettes[2];
  };
  if (theme.primaryColor) {
    fillColor(theme.primaryColor, "primary");
    const primaryColor = new TinyColor(theme.primaryColor);
    const primaryColors = generate(primaryColor.toRgbString());
    primaryColors.forEach((color2, index2) => {
      variables[`primary-${index2 + 1}`] = color2;
    });
    variables["primary-color-deprecated-l-35"] = formatColor(primaryColor, (c) => c.lighten(35));
    variables["primary-color-deprecated-l-20"] = formatColor(primaryColor, (c) => c.lighten(20));
    variables["primary-color-deprecated-t-20"] = formatColor(primaryColor, (c) => c.tint(20));
    variables["primary-color-deprecated-t-50"] = formatColor(primaryColor, (c) => c.tint(50));
    variables["primary-color-deprecated-f-12"] = formatColor(primaryColor, (c) => c.setAlpha(c.getAlpha() * 0.12));
    const primaryActiveColor = new TinyColor(primaryColors[0]);
    variables["primary-color-active-deprecated-f-30"] = formatColor(primaryActiveColor, (c) => c.setAlpha(c.getAlpha() * 0.3));
    variables["primary-color-active-deprecated-d-02"] = formatColor(primaryActiveColor, (c) => c.darken(2));
  }
  if (theme.successColor) {
    fillColor(theme.successColor, "success");
  }
  if (theme.warningColor) {
    fillColor(theme.warningColor, "warning");
  }
  if (theme.errorColor) {
    fillColor(theme.errorColor, "error");
  }
  if (theme.infoColor) {
    fillColor(theme.infoColor, "info");
  }
  const cssList = Object.keys(variables).map((key) => `--${globalPrefixCls2}-${key}: ${variables[key]};`);
  return `
  :root {
    ${cssList.join("\n")}
  }
  `.trim();
}
function registerTheme(globalPrefixCls2, theme) {
  const style2 = getStyle(globalPrefixCls2, theme);
  if (canUseDom()) {
    updateCSS(style2, `${dynamicStyleMark}-dynamic-theme`);
  } else {
    process.env.NODE_ENV !== "production" ? warning_default2(false, "ConfigProvider", "SSR do not support dynamic theme with css variables.") : void 0;
  }
}

// ../../node_modules/antd/es/config-provider/DisabledContext.js
var React19 = __toESM(require("react"));
var DisabledContext = /* @__PURE__ */ React19.createContext(false);
var DisabledContextProvider = (_ref) => {
  let {
    children,
    disabled
  } = _ref;
  const originDisabled = React19.useContext(DisabledContext);
  return /* @__PURE__ */ React19.createElement(DisabledContext.Provider, {
    value: disabled !== null && disabled !== void 0 ? disabled : originDisabled
  }, children);
};
var DisabledContext_default = DisabledContext;

// ../../node_modules/antd/es/config-provider/hooks/useConfig.js
var import_react10 = require("react");

// ../../node_modules/antd/es/config-provider/SizeContext.js
var React20 = __toESM(require("react"));
var SizeContext = /* @__PURE__ */ React20.createContext(void 0);
var SizeContextProvider = (_ref) => {
  let {
    children,
    size
  } = _ref;
  const originSize = React20.useContext(SizeContext);
  return /* @__PURE__ */ React20.createElement(SizeContext.Provider, {
    value: size || originSize
  }, children);
};
var SizeContext_default = SizeContext;

// ../../node_modules/antd/es/config-provider/hooks/useConfig.js
function useConfig() {
  const componentDisabled = (0, import_react10.useContext)(DisabledContext_default);
  const componentSize = (0, import_react10.useContext)(SizeContext_default);
  return {
    componentDisabled,
    componentSize
  };
}
var useConfig_default = useConfig;

// ../../node_modules/antd/es/theme/interface/presetColors.js
var PresetColors = ["blue", "purple", "cyan", "green", "magenta", "pink", "red", "orange", "yellow", "volcano", "geekblue", "lime", "gold"];

// ../../node_modules/antd/es/theme/useToken.js
var import_react11 = __toESM(require("react"));

// ../../node_modules/antd/es/version/version.js
var version_default = "5.13.1";

// ../../node_modules/antd/es/version/index.js
var version_default2 = version_default;

// ../../node_modules/antd/es/theme/util/getAlphaColor.js
function isStableColor(color2) {
  return color2 >= 0 && color2 <= 255;
}
function getAlphaColor2(frontColor, backgroundColor) {
  const {
    r: fR,
    g: fG,
    b: fB,
    a: originAlpha
  } = new TinyColor(frontColor).toRgb();
  if (originAlpha < 1) {
    return frontColor;
  }
  const {
    r: bR,
    g: bG,
    b: bB
  } = new TinyColor(backgroundColor).toRgb();
  for (let fA = 0.01; fA <= 1; fA += 0.01) {
    const r = Math.round((fR - bR * (1 - fA)) / fA);
    const g = Math.round((fG - bG * (1 - fA)) / fA);
    const b = Math.round((fB - bB * (1 - fA)) / fA);
    if (isStableColor(r) && isStableColor(g) && isStableColor(b)) {
      return new TinyColor({
        r,
        g,
        b,
        a: Math.round(fA * 100) / 100
      }).toRgbString();
    }
  }
  return new TinyColor({
    r: fR,
    g: fG,
    b: fB,
    a: 1
  }).toRgbString();
}
var getAlphaColor_default = getAlphaColor2;

// ../../node_modules/antd/es/theme/util/alias.js
var __rest = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
function formatToken(derivativeToken) {
  const {
    override
  } = derivativeToken, restToken = __rest(derivativeToken, ["override"]);
  const overrideTokens = Object.assign({}, override);
  Object.keys(seed_default).forEach((token2) => {
    delete overrideTokens[token2];
  });
  const mergedToken = Object.assign(Object.assign({}, restToken), overrideTokens);
  const screenXS = 480;
  const screenSM = 576;
  const screenMD = 768;
  const screenLG = 992;
  const screenXL = 1200;
  const screenXXL = 1600;
  if (mergedToken.motion === false) {
    const fastDuration = "0s";
    mergedToken.motionDurationFast = fastDuration;
    mergedToken.motionDurationMid = fastDuration;
    mergedToken.motionDurationSlow = fastDuration;
  }
  const aliasToken = Object.assign(Object.assign(Object.assign({}, mergedToken), {
    // ============== Background ============== //
    colorFillContent: mergedToken.colorFillSecondary,
    colorFillContentHover: mergedToken.colorFill,
    colorFillAlter: mergedToken.colorFillQuaternary,
    colorBgContainerDisabled: mergedToken.colorFillTertiary,
    // ============== Split ============== //
    colorBorderBg: mergedToken.colorBgContainer,
    colorSplit: getAlphaColor_default(mergedToken.colorBorderSecondary, mergedToken.colorBgContainer),
    // ============== Text ============== //
    colorTextPlaceholder: mergedToken.colorTextQuaternary,
    colorTextDisabled: mergedToken.colorTextQuaternary,
    colorTextHeading: mergedToken.colorText,
    colorTextLabel: mergedToken.colorTextSecondary,
    colorTextDescription: mergedToken.colorTextTertiary,
    colorTextLightSolid: mergedToken.colorWhite,
    colorHighlight: mergedToken.colorError,
    colorBgTextHover: mergedToken.colorFillSecondary,
    colorBgTextActive: mergedToken.colorFill,
    colorIcon: mergedToken.colorTextTertiary,
    colorIconHover: mergedToken.colorText,
    colorErrorOutline: getAlphaColor_default(mergedToken.colorErrorBg, mergedToken.colorBgContainer),
    colorWarningOutline: getAlphaColor_default(mergedToken.colorWarningBg, mergedToken.colorBgContainer),
    // Font
    fontSizeIcon: mergedToken.fontSizeSM,
    // Line
    lineWidthFocus: mergedToken.lineWidth * 4,
    // Control
    lineWidth: mergedToken.lineWidth,
    controlOutlineWidth: mergedToken.lineWidth * 2,
    // Checkbox size and expand icon size
    controlInteractiveSize: mergedToken.controlHeight / 2,
    controlItemBgHover: mergedToken.colorFillTertiary,
    controlItemBgActive: mergedToken.colorPrimaryBg,
    controlItemBgActiveHover: mergedToken.colorPrimaryBgHover,
    controlItemBgActiveDisabled: mergedToken.colorFill,
    controlTmpOutline: mergedToken.colorFillQuaternary,
    controlOutline: getAlphaColor_default(mergedToken.colorPrimaryBg, mergedToken.colorBgContainer),
    lineType: mergedToken.lineType,
    borderRadius: mergedToken.borderRadius,
    borderRadiusXS: mergedToken.borderRadiusXS,
    borderRadiusSM: mergedToken.borderRadiusSM,
    borderRadiusLG: mergedToken.borderRadiusLG,
    fontWeightStrong: 600,
    opacityLoading: 0.65,
    linkDecoration: "none",
    linkHoverDecoration: "none",
    linkFocusDecoration: "none",
    controlPaddingHorizontal: 12,
    controlPaddingHorizontalSM: 8,
    paddingXXS: mergedToken.sizeXXS,
    paddingXS: mergedToken.sizeXS,
    paddingSM: mergedToken.sizeSM,
    padding: mergedToken.size,
    paddingMD: mergedToken.sizeMD,
    paddingLG: mergedToken.sizeLG,
    paddingXL: mergedToken.sizeXL,
    paddingContentHorizontalLG: mergedToken.sizeLG,
    paddingContentVerticalLG: mergedToken.sizeMS,
    paddingContentHorizontal: mergedToken.sizeMS,
    paddingContentVertical: mergedToken.sizeSM,
    paddingContentHorizontalSM: mergedToken.size,
    paddingContentVerticalSM: mergedToken.sizeXS,
    marginXXS: mergedToken.sizeXXS,
    marginXS: mergedToken.sizeXS,
    marginSM: mergedToken.sizeSM,
    margin: mergedToken.size,
    marginMD: mergedToken.sizeMD,
    marginLG: mergedToken.sizeLG,
    marginXL: mergedToken.sizeXL,
    marginXXL: mergedToken.sizeXXL,
    boxShadow: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowSecondary: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTertiary: `
      0 1px 2px 0 rgba(0, 0, 0, 0.03),
      0 1px 6px -1px rgba(0, 0, 0, 0.02),
      0 2px 4px 0 rgba(0, 0, 0, 0.02)
    `,
    screenXS,
    screenXSMin: screenXS,
    screenXSMax: screenSM - 1,
    screenSM,
    screenSMMin: screenSM,
    screenSMMax: screenMD - 1,
    screenMD,
    screenMDMin: screenMD,
    screenMDMax: screenLG - 1,
    screenLG,
    screenLGMin: screenLG,
    screenLGMax: screenXL - 1,
    screenXL,
    screenXLMin: screenXL,
    screenXLMax: screenXXL - 1,
    screenXXL,
    screenXXLMin: screenXXL,
    boxShadowPopoverArrow: "2px 2px 5px rgba(0, 0, 0, 0.05)",
    boxShadowCard: `
      0 1px 2px -2px ${new TinyColor("rgba(0, 0, 0, 0.16)").toRgbString()},
      0 3px 6px 0 ${new TinyColor("rgba(0, 0, 0, 0.12)").toRgbString()},
      0 5px 12px 4px ${new TinyColor("rgba(0, 0, 0, 0.09)").toRgbString()}
    `,
    boxShadowDrawerRight: `
      -6px 0 16px 0 rgba(0, 0, 0, 0.08),
      -3px 0 6px -4px rgba(0, 0, 0, 0.12),
      -9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerLeft: `
      6px 0 16px 0 rgba(0, 0, 0, 0.08),
      3px 0 6px -4px rgba(0, 0, 0, 0.12),
      9px 0 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerUp: `
      0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12),
      0 9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowDrawerDown: `
      0 -6px 16px 0 rgba(0, 0, 0, 0.08),
      0 -3px 6px -4px rgba(0, 0, 0, 0.12),
      0 -9px 28px 8px rgba(0, 0, 0, 0.05)
    `,
    boxShadowTabsOverflowLeft: "inset 10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowRight: "inset -10px 0 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowTop: "inset 0 10px 8px -8px rgba(0, 0, 0, 0.08)",
    boxShadowTabsOverflowBottom: "inset 0 -10px 8px -8px rgba(0, 0, 0, 0.08)"
  }), overrideTokens);
  return aliasToken;
}

// ../../node_modules/antd/es/theme/useToken.js
var __rest2 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var unitless = {
  lineHeight: true,
  lineHeightSM: true,
  lineHeightLG: true,
  lineHeightHeading1: true,
  lineHeightHeading2: true,
  lineHeightHeading3: true,
  lineHeightHeading4: true,
  lineHeightHeading5: true,
  opacityLoading: true,
  fontWeightStrong: true,
  zIndexPopupBase: true,
  zIndexBase: true
};
var ignore = {
  size: true,
  sizeSM: true,
  sizeLG: true,
  sizeMD: true,
  sizeXS: true,
  sizeXXS: true,
  sizeMS: true,
  sizeXL: true,
  sizeXXL: true,
  sizeUnit: true,
  sizeStep: true,
  motionBase: true,
  motionUnit: true
};
var preserve = {
  screenXS: true,
  screenXSMin: true,
  screenXSMax: true,
  screenSM: true,
  screenSMMin: true,
  screenSMMax: true,
  screenMD: true,
  screenMDMin: true,
  screenMDMax: true,
  screenLG: true,
  screenLGMin: true,
  screenLGMax: true,
  screenXL: true,
  screenXLMin: true,
  screenXLMax: true,
  screenXXL: true,
  screenXXLMin: true
};
var getComputedToken3 = (originToken, overrideToken, theme) => {
  const derivativeToken = theme.getDerivativeToken(originToken);
  const {
    override
  } = overrideToken, components = __rest2(overrideToken, ["override"]);
  let mergedDerivativeToken = Object.assign(Object.assign({}, derivativeToken), {
    override
  });
  mergedDerivativeToken = formatToken(mergedDerivativeToken);
  if (components) {
    Object.entries(components).forEach((_ref) => {
      let [key, value] = _ref;
      const {
        theme: componentTheme
      } = value, componentTokens = __rest2(value, ["theme"]);
      let mergedComponentToken = componentTokens;
      if (componentTheme) {
        mergedComponentToken = getComputedToken3(Object.assign(Object.assign({}, mergedDerivativeToken), componentTokens), {
          override: componentTokens
        }, componentTheme);
      }
      mergedDerivativeToken[key] = mergedComponentToken;
    });
  }
  return mergedDerivativeToken;
};
function useToken() {
  const {
    token: rootDesignToken,
    hashed,
    theme,
    override,
    cssVar
  } = import_react11.default.useContext(DesignTokenContext);
  const salt = `${version_default2}-${hashed || ""}`;
  const mergedTheme = theme || defaultTheme;
  const [token2, hashId, realToken] = useCacheToken(mergedTheme, [seed_default, rootDesignToken], {
    salt,
    override,
    getComputedToken: getComputedToken3,
    // formatToken will not be consumed after 1.15.0 with getComputedToken.
    // But token will break if @ant-design/cssinjs is under 1.15.0 without it
    formatToken,
    cssVar: cssVar && {
      prefix: cssVar.prefix,
      key: cssVar.key,
      unitless,
      ignore,
      preserve
    }
  });
  return [mergedTheme, realToken, hashed ? hashId : "", token2, cssVar];
}

// ../../node_modules/antd/es/theme/util/genComponentStyleHook.js
var import_react12 = __toESM(require("react"));

// ../../node_modules/rc-util/es/hooks/useEvent.js
var React22 = __toESM(require("react"));
function useEvent(callback) {
  var fnRef = React22.useRef();
  fnRef.current = callback;
  var memoFn = React22.useCallback(function() {
    var _fnRef$current;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return (_fnRef$current = fnRef.current) === null || _fnRef$current === void 0 ? void 0 : _fnRef$current.call.apply(_fnRef$current, [fnRef].concat(args));
  }, []);
  return memoFn;
}

// ../../node_modules/rc-util/es/hooks/useState.js
var React23 = __toESM(require("react"));
function useSafeState(defaultValue) {
  var destroyRef = React23.useRef(false);
  var _React$useState = React23.useState(defaultValue), _React$useState2 = _slicedToArray(_React$useState, 2), value = _React$useState2[0], setValue = _React$useState2[1];
  React23.useEffect(function() {
    destroyRef.current = false;
    return function() {
      destroyRef.current = true;
    };
  }, []);
  function safeSetState(updater, ignoreDestroy) {
    if (ignoreDestroy && destroyRef.current) {
      return;
    }
    setValue(updater);
  }
  return [value, safeSetState];
}

// ../../node_modules/rc-util/es/hooks/useMergedState.js
function hasValue(value) {
  return value !== void 0;
}
function useMergedState(defaultStateValue, option) {
  var _ref = option || {}, defaultValue = _ref.defaultValue, value = _ref.value, onChange = _ref.onChange, postState = _ref.postState;
  var _useState = useSafeState(function() {
    if (hasValue(value)) {
      return value;
    } else if (hasValue(defaultValue)) {
      return typeof defaultValue === "function" ? defaultValue() : defaultValue;
    } else {
      return typeof defaultStateValue === "function" ? defaultStateValue() : defaultStateValue;
    }
  }), _useState2 = _slicedToArray(_useState, 2), innerValue = _useState2[0], setInnerValue = _useState2[1];
  var mergedValue = value !== void 0 ? value : innerValue;
  var postMergedValue = postState ? postState(mergedValue) : mergedValue;
  var onChangeFn = useEvent(onChange);
  var _useState3 = useSafeState([mergedValue]), _useState4 = _slicedToArray(_useState3, 2), prevValue = _useState4[0], setPrevValue = _useState4[1];
  useLayoutUpdateEffect(function() {
    var prev2 = prevValue[0];
    if (innerValue !== prev2) {
      onChangeFn(innerValue, prev2);
    }
  }, [prevValue]);
  useLayoutUpdateEffect(function() {
    if (!hasValue(value)) {
      setInnerValue(value);
    }
  }, [value]);
  var triggerChange = useEvent(function(updater, ignoreDestroy) {
    setInnerValue(updater, ignoreDestroy);
    setPrevValue([mergedValue], ignoreDestroy);
  });
  return [postMergedValue, triggerChange];
}

// ../../node_modules/antd/es/style/operationUnit.js
var operationUnit = (token2) => ({
  // FIXME: This use link but is a operation unit. Seems should be a colorPrimary.
  // And Typography use this to generate link style which should not do this.
  color: token2.colorLink,
  textDecoration: "none",
  outline: "none",
  cursor: "pointer",
  transition: `color ${token2.motionDurationSlow}`,
  "&:focus, &:hover": {
    color: token2.colorLinkHover
  },
  "&:active": {
    color: token2.colorLinkActive
  }
});

// ../../node_modules/antd/es/style/index.js
var textEllipsis = {
  overflow: "hidden",
  whiteSpace: "nowrap",
  textOverflow: "ellipsis"
};
var resetComponent = function(token2) {
  let needInheritFontFamily = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  return {
    boxSizing: "border-box",
    margin: 0,
    padding: 0,
    color: token2.colorText,
    fontSize: token2.fontSize,
    // font-variant: @font-variant-base;
    lineHeight: token2.lineHeight,
    listStyle: "none",
    // font-feature-settings: @font-feature-settings-base;
    fontFamily: needInheritFontFamily ? "inherit" : token2.fontFamily
  };
};
var resetIcon = () => ({
  display: "inline-flex",
  alignItems: "center",
  color: "inherit",
  fontStyle: "normal",
  lineHeight: 0,
  textAlign: "center",
  textTransform: "none",
  // for SVG icon, see https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
  verticalAlign: "-0.125em",
  textRendering: "optimizeLegibility",
  "-webkit-font-smoothing": "antialiased",
  "-moz-osx-font-smoothing": "grayscale",
  "> *": {
    lineHeight: 1
  },
  svg: {
    display: "inline-block"
  }
});
var clearFix = () => ({
  // https://github.com/ant-design/ant-design/issues/21301#issuecomment-583955229
  "&::before": {
    display: "table",
    content: '""'
  },
  "&::after": {
    // https://github.com/ant-design/ant-design/issues/21864
    display: "table",
    clear: "both",
    content: '""'
  }
});
var genLinkStyle = (token2) => ({
  a: {
    color: token2.colorLink,
    textDecoration: token2.linkDecoration,
    backgroundColor: "transparent",
    // remove the gray background on active links in IE 10.
    outline: "none",
    cursor: "pointer",
    transition: `color ${token2.motionDurationSlow}`,
    "-webkit-text-decoration-skip": "objects",
    // remove gaps in links underline in iOS 8+ and Safari 8+.
    "&:hover": {
      color: token2.colorLinkHover
    },
    "&:active": {
      color: token2.colorLinkActive
    },
    [`&:active,
  &:hover`]: {
      textDecoration: token2.linkHoverDecoration,
      outline: 0
    },
    // https://github.com/ant-design/ant-design/issues/22503
    "&:focus": {
      textDecoration: token2.linkFocusDecoration,
      outline: 0
    },
    "&[disabled]": {
      color: token2.colorTextDisabled,
      cursor: "not-allowed"
    }
  }
});
var genCommonStyle = (token2, componentPrefixCls) => {
  const {
    fontFamily,
    fontSize
  } = token2;
  const rootPrefixSelector = `[class^="${componentPrefixCls}"], [class*=" ${componentPrefixCls}"]`;
  return {
    [rootPrefixSelector]: {
      fontFamily,
      fontSize,
      boxSizing: "border-box",
      "&::before, &::after": {
        boxSizing: "border-box"
      },
      [rootPrefixSelector]: {
        boxSizing: "border-box",
        "&::before, &::after": {
          boxSizing: "border-box"
        }
      }
    }
  };
};
var genFocusOutline = (token2) => ({
  outline: `${unit(token2.lineWidthFocus)} solid ${token2.colorPrimaryBorder}`,
  outlineOffset: 1,
  transition: "outline-offset 0s, outline 0s"
});
var genFocusStyle = (token2) => ({
  "&:focus-visible": Object.assign({}, genFocusOutline(token2))
});

// ../../node_modules/antd/es/theme/util/calc/calculator.js
var AbstractCalculator = /* @__PURE__ */ _createClass(function AbstractCalculator2() {
  _classCallCheck(this, AbstractCalculator2);
});
var calculator_default = AbstractCalculator;

// ../../node_modules/antd/es/theme/util/calc/NumCalculator.js
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
var NumCalculator = /* @__PURE__ */ function(_AbstractCalculator) {
  _inherits(NumCalculator2, _AbstractCalculator);
  function NumCalculator2(num) {
    var _this;
    _classCallCheck(this, NumCalculator2);
    _this = _callSuper(this, NumCalculator2);
    _this.result = 0;
    if (num instanceof NumCalculator2) {
      _this.result = num.result;
    } else if (typeof num === "number") {
      _this.result = num;
    }
    return _this;
  }
  _createClass(NumCalculator2, [{
    key: "add",
    value: function add(num) {
      if (num instanceof NumCalculator2) {
        this.result += num.result;
      } else if (typeof num === "number") {
        this.result += num;
      }
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof NumCalculator2) {
        this.result -= num.result;
      } else if (typeof num === "number") {
        this.result -= num;
      }
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (num instanceof NumCalculator2) {
        this.result *= num.result;
      } else if (typeof num === "number") {
        this.result *= num;
      }
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (num instanceof NumCalculator2) {
        this.result /= num.result;
      } else if (typeof num === "number") {
        this.result /= num;
      }
      return this;
    }
  }, {
    key: "equal",
    value: function equal() {
      return this.result;
    }
  }]);
  return NumCalculator2;
}(calculator_default);

// ../../node_modules/antd/es/theme/util/calc/CSSCalculator.js
function _callSuper2(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
var CALC_UNIT = "CALC_UNIT";
function unit2(value) {
  if (typeof value === "number") {
    return `${value}${CALC_UNIT}`;
  }
  return value;
}
var CSSCalculator = /* @__PURE__ */ function(_AbstractCalculator) {
  _inherits(CSSCalculator2, _AbstractCalculator);
  function CSSCalculator2(num) {
    var _this;
    _classCallCheck(this, CSSCalculator2);
    _this = _callSuper2(this, CSSCalculator2);
    _this.result = "";
    if (num instanceof CSSCalculator2) {
      _this.result = `(${num.result})`;
    } else if (typeof num === "number") {
      _this.result = unit2(num);
    } else if (typeof num === "string") {
      _this.result = num;
    }
    return _this;
  }
  _createClass(CSSCalculator2, [{
    key: "add",
    value: function add(num) {
      if (num instanceof CSSCalculator2) {
        this.result = `${this.result} + ${num.getResult()}`;
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = `${this.result} + ${unit2(num)}`;
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "sub",
    value: function sub(num) {
      if (num instanceof CSSCalculator2) {
        this.result = `${this.result} - ${num.getResult()}`;
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = `${this.result} - ${unit2(num)}`;
      }
      this.lowPriority = true;
      return this;
    }
  }, {
    key: "mul",
    value: function mul(num) {
      if (this.lowPriority) {
        this.result = `(${this.result})`;
      }
      if (num instanceof CSSCalculator2) {
        this.result = `${this.result} * ${num.getResult(true)}`;
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = `${this.result} * ${num}`;
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "div",
    value: function div(num) {
      if (this.lowPriority) {
        this.result = `(${this.result})`;
      }
      if (num instanceof CSSCalculator2) {
        this.result = `${this.result} / ${num.getResult(true)}`;
      } else if (typeof num === "number" || typeof num === "string") {
        this.result = `${this.result} / ${num}`;
      }
      this.lowPriority = false;
      return this;
    }
  }, {
    key: "getResult",
    value: function getResult(force) {
      return this.lowPriority || force ? `(${this.result})` : this.result;
    }
  }, {
    key: "equal",
    value: function equal(options) {
      const {
        unit: cssUnit = true
      } = options || {};
      const regexp4 = new RegExp(`${CALC_UNIT}`, "g");
      this.result = this.result.replace(regexp4, cssUnit ? "px" : "");
      if (typeof this.lowPriority !== "undefined") {
        return `calc(${this.result})`;
      }
      return this.result;
    }
  }]);
  return CSSCalculator2;
}(calculator_default);

// ../../node_modules/antd/es/theme/util/calc/index.js
var genCalc = (type4) => {
  const Calculator = type4 === "css" ? CSSCalculator : NumCalculator;
  return (num) => new Calculator(num);
};
var calc_default = genCalc;

// ../../node_modules/antd/es/theme/util/maxmin.js
function genMaxMin(type4) {
  if (type4 === "js") {
    return {
      max: Math.max,
      min: Math.min
    };
  }
  return {
    max: function() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      return `max(${args.map((value) => unit(value)).join(",")})`;
    },
    min: function() {
      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }
      return `min(${args.map((value) => unit(value)).join(",")})`;
    }
  };
}

// ../../node_modules/antd/es/theme/util/statistic.js
var enableStatistic = process.env.NODE_ENV !== "production" || typeof CSSINJS_STATISTIC !== "undefined";
var recording = true;
function merge2() {
  for (var _len = arguments.length, objs = new Array(_len), _key = 0; _key < _len; _key++) {
    objs[_key] = arguments[_key];
  }
  if (!enableStatistic) {
    return Object.assign.apply(Object, [{}].concat(objs));
  }
  recording = false;
  const ret = {};
  objs.forEach((obj) => {
    const keys3 = Object.keys(obj);
    keys3.forEach((key) => {
      Object.defineProperty(ret, key, {
        configurable: true,
        enumerable: true,
        get: () => obj[key]
      });
    });
  });
  recording = true;
  return ret;
}
var statistic = {};
function noop2() {
}
var statisticToken = (token2) => {
  let tokenKeys2;
  let proxy = token2;
  let flush = noop2;
  if (enableStatistic && typeof Proxy !== "undefined") {
    tokenKeys2 = /* @__PURE__ */ new Set();
    proxy = new Proxy(token2, {
      get(obj, prop) {
        if (recording) {
          tokenKeys2.add(prop);
        }
        return obj[prop];
      }
    });
    flush = (componentName, componentToken) => {
      var _a;
      statistic[componentName] = {
        global: Array.from(tokenKeys2),
        component: Object.assign(Object.assign({}, (_a = statistic[componentName]) === null || _a === void 0 ? void 0 : _a.component), componentToken)
      };
    };
  }
  return {
    token: proxy,
    keys: tokenKeys2,
    flush
  };
};
var statistic_default = statisticToken;

// ../../node_modules/antd/es/theme/util/useResetIconStyle.js
var useResetIconStyle = (iconPrefixCls, csp) => {
  const [theme, token2] = useToken();
  return useStyleRegister({
    theme,
    token: token2,
    hashId: "",
    path: ["ant-design-icons", iconPrefixCls],
    nonce: () => csp === null || csp === void 0 ? void 0 : csp.nonce
  }, () => [{
    [`.${iconPrefixCls}`]: Object.assign(Object.assign({}, resetIcon()), {
      [`.${iconPrefixCls} .${iconPrefixCls}-icon`]: {
        display: "block"
      }
    })
  }]);
};
var useResetIconStyle_default = useResetIconStyle;

// ../../node_modules/antd/es/theme/util/genComponentStyleHook.js
var getDefaultComponentToken = (component, token2, getDefaultToken) => {
  var _a;
  if (typeof getDefaultToken === "function") {
    return getDefaultToken(merge2(token2, (_a = token2[component]) !== null && _a !== void 0 ? _a : {}));
  }
  return getDefaultToken !== null && getDefaultToken !== void 0 ? getDefaultToken : {};
};
var getComponentToken = (component, token2, defaultToken, options) => {
  const customToken = Object.assign({}, token2[component]);
  if (options === null || options === void 0 ? void 0 : options.deprecatedTokens) {
    const {
      deprecatedTokens
    } = options;
    deprecatedTokens.forEach((_ref) => {
      let [oldTokenKey, newTokenKey] = _ref;
      var _a;
      if (process.env.NODE_ENV !== "production") {
        process.env.NODE_ENV !== "production" ? warning_default(!(customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey]), `Component Token \`${String(oldTokenKey)}\` of ${component} is deprecated. Please use \`${String(newTokenKey)}\` instead.`) : void 0;
      }
      if ((customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey]) || (customToken === null || customToken === void 0 ? void 0 : customToken[newTokenKey])) {
        (_a = customToken[newTokenKey]) !== null && _a !== void 0 ? _a : customToken[newTokenKey] = customToken === null || customToken === void 0 ? void 0 : customToken[oldTokenKey];
      }
    });
  }
  const mergedToken = Object.assign(Object.assign({}, defaultToken), customToken);
  Object.keys(mergedToken).forEach((key) => {
    if (mergedToken[key] === token2[key]) {
      delete mergedToken[key];
    }
  });
  return mergedToken;
};
var getCompVarPrefix = (component, prefix) => `${[prefix, component.replace(/([A-Z]+)([A-Z][a-z]+)/g, "$1-$2").replace(/([a-z])([A-Z])/g, "$1-$2")].filter(Boolean).join("-")}`;
function genComponentStyleHook(componentName, styleFn, getDefaultToken) {
  let options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
  const cells = Array.isArray(componentName) ? componentName : [componentName, componentName];
  const [component] = cells;
  const concatComponent = cells.join("-");
  return (prefixCls) => {
    const [theme, realToken, hashId, token2, cssVar] = useToken();
    const {
      getPrefixCls,
      iconPrefixCls,
      csp
    } = (0, import_react12.useContext)(ConfigContext);
    const rootPrefixCls = getPrefixCls();
    const type4 = cssVar ? "css" : "js";
    const calc = calc_default(type4);
    const {
      max: max3,
      min: min3
    } = genMaxMin(type4);
    const sharedConfig = {
      theme,
      token: token2,
      hashId,
      nonce: () => csp === null || csp === void 0 ? void 0 : csp.nonce,
      clientOnly: options.clientOnly,
      // antd is always at top of styles
      order: options.order || -999
    };
    useStyleRegister(Object.assign(Object.assign({}, sharedConfig), {
      clientOnly: false,
      path: ["Shared", rootPrefixCls]
    }), () => [{
      // Link
      "&": genLinkStyle(token2)
    }]);
    useResetIconStyle_default(iconPrefixCls, csp);
    const wrapSSR = useStyleRegister(Object.assign(Object.assign({}, sharedConfig), {
      path: [concatComponent, prefixCls, iconPrefixCls]
    }), () => {
      if (options.injectStyle === false) {
        return [];
      }
      const {
        token: proxyToken,
        flush
      } = statistic_default(token2);
      const defaultComponentToken = getDefaultComponentToken(component, realToken, getDefaultToken);
      const componentCls = `.${prefixCls}`;
      const componentToken = getComponentToken(component, realToken, defaultComponentToken, {
        deprecatedTokens: options.deprecatedTokens
      });
      if (cssVar) {
        Object.keys(defaultComponentToken).forEach((key) => {
          defaultComponentToken[key] = `var(${token2CSSVar(key, getCompVarPrefix(component, cssVar.prefix))})`;
        });
      }
      const mergedToken = merge2(proxyToken, {
        componentCls,
        prefixCls,
        iconCls: `.${iconPrefixCls}`,
        antCls: `.${rootPrefixCls}`,
        calc,
        max: max3,
        min: min3
      }, cssVar ? defaultComponentToken : componentToken);
      const styleInterpolation = styleFn(mergedToken, {
        hashId,
        prefixCls,
        rootPrefixCls,
        iconPrefixCls
      });
      flush(component, componentToken);
      return [options.resetStyle === false ? null : genCommonStyle(mergedToken, prefixCls), styleInterpolation];
    });
    return [wrapSSR, hashId];
  };
}
var genSubStyleComponent = (componentName, styleFn, getDefaultToken, options) => {
  const useStyle = genComponentStyleHook(componentName, styleFn, getDefaultToken, Object.assign({
    resetStyle: false,
    // Sub Style should default after root one
    order: -998
  }, options));
  const StyledComponent = (_ref2) => {
    let {
      prefixCls
    } = _ref2;
    useStyle(prefixCls);
    return null;
  };
  if (process.env.NODE_ENV !== "production") {
    StyledComponent.displayName = `SubStyle_${Array.isArray(componentName) ? componentName.join(".") : componentName}`;
  }
  return StyledComponent;
};
var genCSSVarRegister = (component, getDefaultToken, options) => {
  function prefixToken(key) {
    return `${component}${key.slice(0, 1).toUpperCase()}${key.slice(1)}`;
  }
  const {
    unitless: originUnitless = {},
    injectStyle = true
  } = options !== null && options !== void 0 ? options : {};
  const compUnitless = {
    [prefixToken("zIndexPopup")]: true
  };
  Object.keys(originUnitless).forEach((key) => {
    compUnitless[prefixToken(key)] = originUnitless[key];
  });
  const CSSVarRegister = (_ref3) => {
    let {
      rootCls,
      cssVar
    } = _ref3;
    const [, realToken] = useToken();
    useCSSVarRegister_default({
      path: [component],
      prefix: cssVar.prefix,
      key: cssVar === null || cssVar === void 0 ? void 0 : cssVar.key,
      unitless: Object.assign(Object.assign({}, unitless), compUnitless),
      ignore,
      token: realToken,
      scope: rootCls
    }, () => {
      const defaultToken = getDefaultComponentToken(component, realToken, getDefaultToken);
      const componentToken = getComponentToken(component, realToken, defaultToken, {
        deprecatedTokens: options === null || options === void 0 ? void 0 : options.deprecatedTokens
      });
      Object.keys(defaultToken).forEach((key) => {
        componentToken[prefixToken(key)] = componentToken[key];
        delete componentToken[key];
      });
      return componentToken;
    });
    return null;
  };
  const useCSSVar = (rootCls) => {
    const [, , , , cssVar] = useToken();
    return [(node2) => injectStyle && cssVar ? /* @__PURE__ */ import_react12.default.createElement(import_react12.default.Fragment, null, /* @__PURE__ */ import_react12.default.createElement(CSSVarRegister, {
      rootCls,
      cssVar,
      component
    }), node2) : node2, cssVar === null || cssVar === void 0 ? void 0 : cssVar.key];
  };
  return useCSSVar;
};
var genStyleHooks = (component, styleFn, getDefaultToken, options) => {
  const useStyle = genComponentStyleHook(component, styleFn, getDefaultToken, options);
  const useCSSVar = genCSSVarRegister(Array.isArray(component) ? component[0] : component, getDefaultToken, options);
  return function(prefixCls) {
    let rootCls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : prefixCls;
    const [, hashId] = useStyle(prefixCls);
    const [wrapCSSVar, cssVarCls] = useCSSVar(rootCls);
    return [wrapCSSVar, hashId, cssVarCls];
  };
};

// ../../node_modules/antd/es/theme/util/genPresetColor.js
function genPresetColor(token2, genCss) {
  return PresetColors.reduce((prev2, colorKey) => {
    const lightColor = token2[`${colorKey}1`];
    const lightBorderColor = token2[`${colorKey}3`];
    const darkColor = token2[`${colorKey}6`];
    const textColor = token2[`${colorKey}7`];
    return Object.assign(Object.assign({}, prev2), genCss(colorKey, {
      lightColor,
      lightBorderColor,
      darkColor,
      textColor
    }));
  }, {});
}

// ../../node_modules/antd/es/config-provider/hooks/useThemeKey.js
var React25 = __toESM(require("react"));
var fullClone3 = Object.assign({}, React25);
var {
  useId
} = fullClone3;
var useEmptyId = () => "";
var useThemeKey = typeof useId === "undefined" ? useEmptyId : useId;
var useThemeKey_default = useThemeKey;

// ../../node_modules/antd/es/config-provider/hooks/useTheme.js
function useTheme(theme, parentTheme) {
  var _a;
  const warning6 = devUseWarning("ConfigProvider");
  const themeConfig = theme || {};
  const parentThemeConfig = themeConfig.inherit === false || !parentTheme ? defaultConfig : parentTheme;
  const themeKey = useThemeKey_default();
  if (process.env.NODE_ENV !== "production") {
    const cssVarEnabled = themeConfig.cssVar || parentThemeConfig.cssVar;
    const validKey = !!(typeof themeConfig.cssVar === "object" && ((_a = themeConfig.cssVar) === null || _a === void 0 ? void 0 : _a.key) || themeKey);
    process.env.NODE_ENV !== "production" ? warning6(!cssVarEnabled || validKey, "breaking", "Missing key in `cssVar` config. Please upgrade to React 18 or set `cssVar.key` manually in each ConfigProvider inside `cssVar` enabled ConfigProvider.") : void 0;
  }
  return useMemo(() => {
    var _a2, _b;
    if (!theme) {
      return parentTheme;
    }
    const mergedComponents = Object.assign({}, parentThemeConfig.components);
    Object.keys(theme.components || {}).forEach((componentName) => {
      mergedComponents[componentName] = Object.assign(Object.assign({}, mergedComponents[componentName]), theme.components[componentName]);
    });
    const cssVarKey = `css-var-${themeKey.replace(/:/g, "")}`;
    const mergedCssVar = ((_a2 = themeConfig.cssVar) !== null && _a2 !== void 0 ? _a2 : parentThemeConfig.cssVar) && Object.assign(Object.assign(Object.assign({
      prefix: "ant"
    }, typeof parentThemeConfig.cssVar === "object" ? parentThemeConfig.cssVar : {}), typeof themeConfig.cssVar === "object" ? themeConfig.cssVar : {}), {
      key: typeof themeConfig.cssVar === "object" && ((_b = themeConfig.cssVar) === null || _b === void 0 ? void 0 : _b.key) || cssVarKey
    });
    return Object.assign(Object.assign(Object.assign({}, parentThemeConfig), themeConfig), {
      token: Object.assign(Object.assign({}, parentThemeConfig.token), themeConfig.token),
      components: mergedComponents,
      cssVar: mergedCssVar
    });
  }, [themeConfig, parentThemeConfig], (prev2, next2) => prev2.some((prevTheme, index2) => {
    const nextTheme = next2[index2];
    return !isEqual_default(prevTheme, nextTheme, true);
  }));
}

// ../../node_modules/rc-motion/es/CSSMotion.js
var import_classnames = __toESM(require_classnames());
var React32 = __toESM(require("react"));
var import_react16 = require("react");

// ../../node_modules/rc-motion/es/context.js
var React26 = __toESM(require("react"));
var _excluded = ["children"];
var Context = /* @__PURE__ */ React26.createContext({});
function MotionProvider(_ref) {
  var children = _ref.children, props = _objectWithoutProperties(_ref, _excluded);
  return /* @__PURE__ */ React26.createElement(Context.Provider, {
    value: props
  }, children);
}

// ../../node_modules/rc-motion/es/DomWrapper.js
var React27 = __toESM(require("react"));
var DomWrapper2 = /* @__PURE__ */ function(_React$Component) {
  _inherits(DomWrapper3, _React$Component);
  var _super = _createSuper(DomWrapper3);
  function DomWrapper3() {
    _classCallCheck(this, DomWrapper3);
    return _super.apply(this, arguments);
  }
  _createClass(DomWrapper3, [{
    key: "render",
    value: function render2() {
      return this.props.children;
    }
  }]);
  return DomWrapper3;
}(React27.Component);
var DomWrapper_default = DomWrapper2;

// ../../node_modules/rc-motion/es/hooks/useStatus.js
var React31 = __toESM(require("react"));
var import_react15 = require("react");

// ../../node_modules/rc-motion/es/interface.js
var STATUS_NONE = "none";
var STATUS_APPEAR = "appear";
var STATUS_ENTER = "enter";
var STATUS_LEAVE = "leave";
var STEP_NONE = "none";
var STEP_PREPARE = "prepare";
var STEP_START = "start";
var STEP_ACTIVE = "active";
var STEP_ACTIVATED = "end";
var STEP_PREPARED = "prepared";

// ../../node_modules/rc-motion/es/hooks/useDomMotionEvents.js
var React28 = __toESM(require("react"));
var import_react13 = require("react");

// ../../node_modules/rc-motion/es/util/motion.js
function makePrefixMap(styleProp, eventName) {
  var prefixes = {};
  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
  prefixes["Webkit".concat(styleProp)] = "webkit".concat(eventName);
  prefixes["Moz".concat(styleProp)] = "moz".concat(eventName);
  prefixes["ms".concat(styleProp)] = "MS".concat(eventName);
  prefixes["O".concat(styleProp)] = "o".concat(eventName.toLowerCase());
  return prefixes;
}
function getVendorPrefixes(domSupport, win) {
  var prefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  };
  if (domSupport) {
    if (!("AnimationEvent" in win)) {
      delete prefixes.animationend.animation;
    }
    if (!("TransitionEvent" in win)) {
      delete prefixes.transitionend.transition;
    }
  }
  return prefixes;
}
var vendorPrefixes = getVendorPrefixes(canUseDom(), typeof window !== "undefined" ? window : {});
var style = {};
if (canUseDom()) {
  _document$createEleme = document.createElement("div");
  style = _document$createEleme.style;
}
var _document$createEleme;
var prefixedEventNames = {};
function getVendorPrefixedEventName(eventName) {
  if (prefixedEventNames[eventName]) {
    return prefixedEventNames[eventName];
  }
  var prefixMap = vendorPrefixes[eventName];
  if (prefixMap) {
    var stylePropList = Object.keys(prefixMap);
    var len = stylePropList.length;
    for (var i = 0; i < len; i += 1) {
      var styleProp = stylePropList[i];
      if (Object.prototype.hasOwnProperty.call(prefixMap, styleProp) && styleProp in style) {
        prefixedEventNames[eventName] = prefixMap[styleProp];
        return prefixedEventNames[eventName];
      }
    }
  }
  return "";
}
var internalAnimationEndName = getVendorPrefixedEventName("animationend");
var internalTransitionEndName = getVendorPrefixedEventName("transitionend");
var supportTransition = !!(internalAnimationEndName && internalTransitionEndName);
var animationEndName = internalAnimationEndName || "animationend";
var transitionEndName = internalTransitionEndName || "transitionend";
function getTransitionName(transitionName, transitionType) {
  if (!transitionName)
    return null;
  if (_typeof(transitionName) === "object") {
    var type4 = transitionType.replace(/-\w/g, function(match2) {
      return match2[1].toUpperCase();
    });
    return transitionName[type4];
  }
  return "".concat(transitionName, "-").concat(transitionType);
}

// ../../node_modules/rc-motion/es/hooks/useDomMotionEvents.js
var useDomMotionEvents_default = function(callback) {
  var cacheElementRef = (0, import_react13.useRef)();
  var callbackRef = (0, import_react13.useRef)(callback);
  callbackRef.current = callback;
  var onInternalMotionEnd = React28.useCallback(function(event) {
    callbackRef.current(event);
  }, []);
  function removeMotionEvents(element) {
    if (element) {
      element.removeEventListener(transitionEndName, onInternalMotionEnd);
      element.removeEventListener(animationEndName, onInternalMotionEnd);
    }
  }
  function patchMotionEvents(element) {
    if (cacheElementRef.current && cacheElementRef.current !== element) {
      removeMotionEvents(cacheElementRef.current);
    }
    if (element && element !== cacheElementRef.current) {
      element.addEventListener(transitionEndName, onInternalMotionEnd);
      element.addEventListener(animationEndName, onInternalMotionEnd);
      cacheElementRef.current = element;
    }
  }
  React28.useEffect(function() {
    return function() {
      removeMotionEvents(cacheElementRef.current);
    };
  }, []);
  return [patchMotionEvents, removeMotionEvents];
};

// ../../node_modules/rc-motion/es/hooks/useIsomorphicLayoutEffect.js
var import_react14 = require("react");
var useIsomorphicLayoutEffect = canUseDom() ? import_react14.useLayoutEffect : import_react14.useEffect;
var useIsomorphicLayoutEffect_default = useIsomorphicLayoutEffect;

// ../../node_modules/rc-motion/es/hooks/useStepQueue.js
var React30 = __toESM(require("react"));

// ../../node_modules/rc-motion/es/hooks/useNextFrame.js
var React29 = __toESM(require("react"));
var useNextFrame_default = function() {
  var nextFrameRef = React29.useRef(null);
  function cancelNextFrame() {
    raf_default.cancel(nextFrameRef.current);
  }
  function nextFrame(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2;
    cancelNextFrame();
    var nextFrameId = raf_default(function() {
      if (delay <= 1) {
        callback({
          isCanceled: function isCanceled() {
            return nextFrameId !== nextFrameRef.current;
          }
        });
      } else {
        nextFrame(callback, delay - 1);
      }
    });
    nextFrameRef.current = nextFrameId;
  }
  React29.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [nextFrame, cancelNextFrame];
};

// ../../node_modules/rc-motion/es/hooks/useStepQueue.js
var FULL_STEP_QUEUE = [STEP_PREPARE, STEP_START, STEP_ACTIVE, STEP_ACTIVATED];
var SIMPLE_STEP_QUEUE = [STEP_PREPARE, STEP_PREPARED];
var SkipStep = false;
var DoStep = true;
function isActive(step) {
  return step === STEP_ACTIVE || step === STEP_ACTIVATED;
}
var useStepQueue_default = function(status, prepareOnly, callback) {
  var _useState = useSafeState(STEP_NONE), _useState2 = _slicedToArray(_useState, 2), step = _useState2[0], setStep = _useState2[1];
  var _useNextFrame = useNextFrame_default(), _useNextFrame2 = _slicedToArray(_useNextFrame, 2), nextFrame = _useNextFrame2[0], cancelNextFrame = _useNextFrame2[1];
  function startQueue() {
    setStep(STEP_PREPARE, true);
  }
  var STEP_QUEUE = prepareOnly ? SIMPLE_STEP_QUEUE : FULL_STEP_QUEUE;
  useIsomorphicLayoutEffect_default(function() {
    if (step !== STEP_NONE && step !== STEP_ACTIVATED) {
      var index2 = STEP_QUEUE.indexOf(step);
      var nextStep = STEP_QUEUE[index2 + 1];
      var result = callback(step);
      if (result === SkipStep) {
        setStep(nextStep, true);
      } else if (nextStep) {
        nextFrame(function(info) {
          function doNext() {
            if (info.isCanceled())
              return;
            setStep(nextStep, true);
          }
          if (result === true) {
            doNext();
          } else {
            Promise.resolve(result).then(doNext);
          }
        });
      }
    }
  }, [status, step]);
  React30.useEffect(function() {
    return function() {
      cancelNextFrame();
    };
  }, []);
  return [startQueue, step];
};

// ../../node_modules/rc-motion/es/hooks/useStatus.js
function useStatus(supportMotion, visible, getElement, _ref) {
  var _ref$motionEnter = _ref.motionEnter, motionEnter = _ref$motionEnter === void 0 ? true : _ref$motionEnter, _ref$motionAppear = _ref.motionAppear, motionAppear = _ref$motionAppear === void 0 ? true : _ref$motionAppear, _ref$motionLeave = _ref.motionLeave, motionLeave = _ref$motionLeave === void 0 ? true : _ref$motionLeave, motionDeadline = _ref.motionDeadline, motionLeaveImmediately = _ref.motionLeaveImmediately, onAppearPrepare = _ref.onAppearPrepare, onEnterPrepare = _ref.onEnterPrepare, onLeavePrepare = _ref.onLeavePrepare, onAppearStart = _ref.onAppearStart, onEnterStart = _ref.onEnterStart, onLeaveStart = _ref.onLeaveStart, onAppearActive = _ref.onAppearActive, onEnterActive = _ref.onEnterActive, onLeaveActive = _ref.onLeaveActive, onAppearEnd = _ref.onAppearEnd, onEnterEnd = _ref.onEnterEnd, onLeaveEnd = _ref.onLeaveEnd, onVisibleChanged = _ref.onVisibleChanged;
  var _useState = useSafeState(), _useState2 = _slicedToArray(_useState, 2), asyncVisible = _useState2[0], setAsyncVisible = _useState2[1];
  var _useState3 = useSafeState(STATUS_NONE), _useState4 = _slicedToArray(_useState3, 2), status = _useState4[0], setStatus = _useState4[1];
  var _useState5 = useSafeState(null), _useState6 = _slicedToArray(_useState5, 2), style2 = _useState6[0], setStyle2 = _useState6[1];
  var mountedRef = (0, import_react15.useRef)(false);
  var deadlineRef = (0, import_react15.useRef)(null);
  function getDomElement() {
    return getElement();
  }
  var activeRef = (0, import_react15.useRef)(false);
  function updateMotionEndStatus() {
    setStatus(STATUS_NONE, true);
    setStyle2(null, true);
  }
  function onInternalMotionEnd(event) {
    var element = getDomElement();
    if (event && !event.deadline && event.target !== element) {
      return;
    }
    var currentActive = activeRef.current;
    var canEnd;
    if (status === STATUS_APPEAR && currentActive) {
      canEnd = onAppearEnd === null || onAppearEnd === void 0 ? void 0 : onAppearEnd(element, event);
    } else if (status === STATUS_ENTER && currentActive) {
      canEnd = onEnterEnd === null || onEnterEnd === void 0 ? void 0 : onEnterEnd(element, event);
    } else if (status === STATUS_LEAVE && currentActive) {
      canEnd = onLeaveEnd === null || onLeaveEnd === void 0 ? void 0 : onLeaveEnd(element, event);
    }
    if (status !== STATUS_NONE && currentActive && canEnd !== false) {
      updateMotionEndStatus();
    }
  }
  var _useDomMotionEvents = useDomMotionEvents_default(onInternalMotionEnd), _useDomMotionEvents2 = _slicedToArray(_useDomMotionEvents, 1), patchMotionEvents = _useDomMotionEvents2[0];
  var getEventHandlers = function getEventHandlers2(targetStatus) {
    var _ref2, _ref3, _ref4;
    switch (targetStatus) {
      case STATUS_APPEAR:
        return _ref2 = {}, _defineProperty(_ref2, STEP_PREPARE, onAppearPrepare), _defineProperty(_ref2, STEP_START, onAppearStart), _defineProperty(_ref2, STEP_ACTIVE, onAppearActive), _ref2;
      case STATUS_ENTER:
        return _ref3 = {}, _defineProperty(_ref3, STEP_PREPARE, onEnterPrepare), _defineProperty(_ref3, STEP_START, onEnterStart), _defineProperty(_ref3, STEP_ACTIVE, onEnterActive), _ref3;
      case STATUS_LEAVE:
        return _ref4 = {}, _defineProperty(_ref4, STEP_PREPARE, onLeavePrepare), _defineProperty(_ref4, STEP_START, onLeaveStart), _defineProperty(_ref4, STEP_ACTIVE, onLeaveActive), _ref4;
      default:
        return {};
    }
  };
  var eventHandlers = React31.useMemo(function() {
    return getEventHandlers(status);
  }, [status]);
  var _useStepQueue = useStepQueue_default(status, !supportMotion, function(newStep) {
    if (newStep === STEP_PREPARE) {
      var onPrepare = eventHandlers[STEP_PREPARE];
      if (!onPrepare) {
        return SkipStep;
      }
      return onPrepare(getDomElement());
    }
    if (step in eventHandlers) {
      var _eventHandlers$step;
      setStyle2(((_eventHandlers$step = eventHandlers[step]) === null || _eventHandlers$step === void 0 ? void 0 : _eventHandlers$step.call(eventHandlers, getDomElement(), null)) || null);
    }
    if (step === STEP_ACTIVE) {
      patchMotionEvents(getDomElement());
      if (motionDeadline > 0) {
        clearTimeout(deadlineRef.current);
        deadlineRef.current = setTimeout(function() {
          onInternalMotionEnd({
            deadline: true
          });
        }, motionDeadline);
      }
    }
    if (step === STEP_PREPARED) {
      updateMotionEndStatus();
    }
    return DoStep;
  }), _useStepQueue2 = _slicedToArray(_useStepQueue, 2), startStep = _useStepQueue2[0], step = _useStepQueue2[1];
  var active = isActive(step);
  activeRef.current = active;
  useIsomorphicLayoutEffect_default(function() {
    setAsyncVisible(visible);
    var isMounted = mountedRef.current;
    mountedRef.current = true;
    var nextStatus;
    if (!isMounted && visible && motionAppear) {
      nextStatus = STATUS_APPEAR;
    }
    if (isMounted && visible && motionEnter) {
      nextStatus = STATUS_ENTER;
    }
    if (isMounted && !visible && motionLeave || !isMounted && motionLeaveImmediately && !visible && motionLeave) {
      nextStatus = STATUS_LEAVE;
    }
    var nextEventHandlers = getEventHandlers(nextStatus);
    if (nextStatus && (supportMotion || nextEventHandlers[STEP_PREPARE])) {
      setStatus(nextStatus);
      startStep();
    } else {
      setStatus(STATUS_NONE);
    }
  }, [visible]);
  (0, import_react15.useEffect)(function() {
    if (
      // Cancel appear
      status === STATUS_APPEAR && !motionAppear || // Cancel enter
      status === STATUS_ENTER && !motionEnter || // Cancel leave
      status === STATUS_LEAVE && !motionLeave
    ) {
      setStatus(STATUS_NONE);
    }
  }, [motionAppear, motionEnter, motionLeave]);
  (0, import_react15.useEffect)(function() {
    return function() {
      mountedRef.current = false;
      clearTimeout(deadlineRef.current);
    };
  }, []);
  var firstMountChangeRef = React31.useRef(false);
  (0, import_react15.useEffect)(function() {
    if (asyncVisible) {
      firstMountChangeRef.current = true;
    }
    if (asyncVisible !== void 0 && status === STATUS_NONE) {
      if (firstMountChangeRef.current || asyncVisible) {
        onVisibleChanged === null || onVisibleChanged === void 0 ? void 0 : onVisibleChanged(asyncVisible);
      }
      firstMountChangeRef.current = true;
    }
  }, [asyncVisible, status]);
  var mergedStyle = style2;
  if (eventHandlers[STEP_PREPARE] && step === STEP_START) {
    mergedStyle = _objectSpread2({
      transition: "none"
    }, mergedStyle);
  }
  return [status, step, mergedStyle, asyncVisible !== null && asyncVisible !== void 0 ? asyncVisible : visible];
}

// ../../node_modules/rc-motion/es/CSSMotion.js
function genCSSMotion(config) {
  var transitionSupport = config;
  if (_typeof(config) === "object") {
    transitionSupport = config.transitionSupport;
  }
  function isSupportTransition(props, contextMotion) {
    return !!(props.motionName && transitionSupport && contextMotion !== false);
  }
  var CSSMotion = /* @__PURE__ */ React32.forwardRef(function(props, ref) {
    var _props$visible = props.visible, visible = _props$visible === void 0 ? true : _props$visible, _props$removeOnLeave = props.removeOnLeave, removeOnLeave = _props$removeOnLeave === void 0 ? true : _props$removeOnLeave, forceRender = props.forceRender, children = props.children, motionName = props.motionName, leavedClassName = props.leavedClassName, eventProps = props.eventProps;
    var _React$useContext = React32.useContext(Context), contextMotion = _React$useContext.motion;
    var supportMotion = isSupportTransition(props, contextMotion);
    var nodeRef = (0, import_react16.useRef)();
    var wrapperNodeRef = (0, import_react16.useRef)();
    function getDomElement() {
      try {
        return nodeRef.current instanceof HTMLElement ? nodeRef.current : findDOMNode(wrapperNodeRef.current);
      } catch (e) {
        return null;
      }
    }
    var _useStatus = useStatus(supportMotion, visible, getDomElement, props), _useStatus2 = _slicedToArray(_useStatus, 4), status = _useStatus2[0], statusStep = _useStatus2[1], statusStyle = _useStatus2[2], mergedVisible = _useStatus2[3];
    var renderedRef = React32.useRef(mergedVisible);
    if (mergedVisible) {
      renderedRef.current = true;
    }
    var setNodeRef = React32.useCallback(function(node2) {
      nodeRef.current = node2;
      fillRef(ref, node2);
    }, [ref]);
    var motionChildren;
    var mergedProps = _objectSpread2(_objectSpread2({}, eventProps), {}, {
      visible
    });
    if (!children) {
      motionChildren = null;
    } else if (status === STATUS_NONE) {
      if (mergedVisible) {
        motionChildren = children(_objectSpread2({}, mergedProps), setNodeRef);
      } else if (!removeOnLeave && renderedRef.current && leavedClassName) {
        motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
          className: leavedClassName
        }), setNodeRef);
      } else if (forceRender || !removeOnLeave && !leavedClassName) {
        motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
          style: {
            display: "none"
          }
        }), setNodeRef);
      } else {
        motionChildren = null;
      }
    } else {
      var _classNames;
      var statusSuffix;
      if (statusStep === STEP_PREPARE) {
        statusSuffix = "prepare";
      } else if (isActive(statusStep)) {
        statusSuffix = "active";
      } else if (statusStep === STEP_START) {
        statusSuffix = "start";
      }
      var motionCls = getTransitionName(motionName, "".concat(status, "-").concat(statusSuffix));
      motionChildren = children(_objectSpread2(_objectSpread2({}, mergedProps), {}, {
        className: (0, import_classnames.default)(getTransitionName(motionName, status), (_classNames = {}, _defineProperty(_classNames, motionCls, motionCls && statusSuffix), _defineProperty(_classNames, motionName, typeof motionName === "string"), _classNames)),
        style: statusStyle
      }), setNodeRef);
    }
    if (/* @__PURE__ */ React32.isValidElement(motionChildren) && supportRef(motionChildren)) {
      var _ref = motionChildren, originNodeRef = _ref.ref;
      if (!originNodeRef) {
        motionChildren = /* @__PURE__ */ React32.cloneElement(motionChildren, {
          ref: setNodeRef
        });
      }
    }
    return /* @__PURE__ */ React32.createElement(DomWrapper_default, {
      ref: wrapperNodeRef
    }, motionChildren);
  });
  CSSMotion.displayName = "CSSMotion";
  return CSSMotion;
}
var CSSMotion_default = genCSSMotion(supportTransition);

// ../../node_modules/rc-motion/es/CSSMotionList.js
var React33 = __toESM(require("react"));

// ../../node_modules/rc-motion/es/util/diff.js
var STATUS_ADD = "add";
var STATUS_KEEP = "keep";
var STATUS_REMOVE = "remove";
var STATUS_REMOVED = "removed";
function wrapKeyToObject(key) {
  var keyObj;
  if (key && _typeof(key) === "object" && "key" in key) {
    keyObj = key;
  } else {
    keyObj = {
      key
    };
  }
  return _objectSpread2(_objectSpread2({}, keyObj), {}, {
    key: String(keyObj.key)
  });
}
function parseKeys() {
  var keys3 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  return keys3.map(wrapKeyToObject);
}
function diffKeys() {
  var prevKeys = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var currentKeys = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var list = [];
  var currentIndex = 0;
  var currentLen = currentKeys.length;
  var prevKeyObjects = parseKeys(prevKeys);
  var currentKeyObjects = parseKeys(currentKeys);
  prevKeyObjects.forEach(function(keyObj) {
    var hit = false;
    for (var i = currentIndex; i < currentLen; i += 1) {
      var currentKeyObj = currentKeyObjects[i];
      if (currentKeyObj.key === keyObj.key) {
        if (currentIndex < i) {
          list = list.concat(currentKeyObjects.slice(currentIndex, i).map(function(obj) {
            return _objectSpread2(_objectSpread2({}, obj), {}, {
              status: STATUS_ADD
            });
          }));
          currentIndex = i;
        }
        list.push(_objectSpread2(_objectSpread2({}, currentKeyObj), {}, {
          status: STATUS_KEEP
        }));
        currentIndex += 1;
        hit = true;
        break;
      }
    }
    if (!hit) {
      list.push(_objectSpread2(_objectSpread2({}, keyObj), {}, {
        status: STATUS_REMOVE
      }));
    }
  });
  if (currentIndex < currentLen) {
    list = list.concat(currentKeyObjects.slice(currentIndex).map(function(obj) {
      return _objectSpread2(_objectSpread2({}, obj), {}, {
        status: STATUS_ADD
      });
    }));
  }
  var keys3 = {};
  list.forEach(function(_ref) {
    var key = _ref.key;
    keys3[key] = (keys3[key] || 0) + 1;
  });
  var duplicatedKeys = Object.keys(keys3).filter(function(key) {
    return keys3[key] > 1;
  });
  duplicatedKeys.forEach(function(matchKey) {
    list = list.filter(function(_ref2) {
      var key = _ref2.key, status = _ref2.status;
      return key !== matchKey || status !== STATUS_REMOVE;
    });
    list.forEach(function(node2) {
      if (node2.key === matchKey) {
        node2.status = STATUS_KEEP;
      }
    });
  });
  return list;
}

// ../../node_modules/rc-motion/es/CSSMotionList.js
var _excluded2 = ["component", "children", "onVisibleChanged", "onAllRemoved"];
var _excluded22 = ["status"];
var MOTION_PROP_NAMES = ["eventProps", "visible", "children", "motionName", "motionAppear", "motionEnter", "motionLeave", "motionLeaveImmediately", "motionDeadline", "removeOnLeave", "leavedClassName", "onAppearPrepare", "onAppearStart", "onAppearActive", "onAppearEnd", "onEnterStart", "onEnterActive", "onEnterEnd", "onLeaveStart", "onLeaveActive", "onLeaveEnd"];
function genCSSMotionList(transitionSupport) {
  var CSSMotion = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : CSSMotion_default;
  var CSSMotionList = /* @__PURE__ */ function(_React$Component) {
    _inherits(CSSMotionList2, _React$Component);
    var _super = _createSuper(CSSMotionList2);
    function CSSMotionList2() {
      var _this;
      _classCallCheck(this, CSSMotionList2);
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _this = _super.call.apply(_super, [this].concat(args));
      _defineProperty(_assertThisInitialized(_this), "state", {
        keyEntities: []
      });
      _defineProperty(_assertThisInitialized(_this), "removeKey", function(removeKey) {
        var keyEntities = _this.state.keyEntities;
        var nextKeyEntities = keyEntities.map(function(entity) {
          if (entity.key !== removeKey)
            return entity;
          return _objectSpread2(_objectSpread2({}, entity), {}, {
            status: STATUS_REMOVED
          });
        });
        _this.setState({
          keyEntities: nextKeyEntities
        });
        return nextKeyEntities.filter(function(_ref) {
          var status = _ref.status;
          return status !== STATUS_REMOVED;
        }).length;
      });
      return _this;
    }
    _createClass(CSSMotionList2, [{
      key: "render",
      value: function render2() {
        var _this2 = this;
        var keyEntities = this.state.keyEntities;
        var _this$props = this.props, component = _this$props.component, children = _this$props.children, _onVisibleChanged = _this$props.onVisibleChanged, onAllRemoved = _this$props.onAllRemoved, restProps = _objectWithoutProperties(_this$props, _excluded2);
        var Component6 = component || React33.Fragment;
        var motionProps = {};
        MOTION_PROP_NAMES.forEach(function(prop) {
          motionProps[prop] = restProps[prop];
          delete restProps[prop];
        });
        delete restProps.keys;
        return /* @__PURE__ */ React33.createElement(Component6, restProps, keyEntities.map(function(_ref2, index2) {
          var status = _ref2.status, eventProps = _objectWithoutProperties(_ref2, _excluded22);
          var visible = status === STATUS_ADD || status === STATUS_KEEP;
          return /* @__PURE__ */ React33.createElement(CSSMotion, _extends({}, motionProps, {
            key: eventProps.key,
            visible,
            eventProps,
            onVisibleChanged: function onVisibleChanged(changedVisible) {
              _onVisibleChanged === null || _onVisibleChanged === void 0 ? void 0 : _onVisibleChanged(changedVisible, {
                key: eventProps.key
              });
              if (!changedVisible) {
                var restKeysCount = _this2.removeKey(eventProps.key);
                if (restKeysCount === 0 && onAllRemoved) {
                  onAllRemoved();
                }
              }
            }
          }), function(props, ref) {
            return children(_objectSpread2(_objectSpread2({}, props), {}, {
              index: index2
            }), ref);
          });
        }));
      }
    }], [{
      key: "getDerivedStateFromProps",
      value: function getDerivedStateFromProps(_ref3, _ref4) {
        var keys3 = _ref3.keys;
        var keyEntities = _ref4.keyEntities;
        var parsedKeyObjects = parseKeys(keys3);
        var mixedKeyEntities = diffKeys(keyEntities, parsedKeyObjects);
        return {
          keyEntities: mixedKeyEntities.filter(function(entity) {
            var prevEntity = keyEntities.find(function(_ref5) {
              var key = _ref5.key;
              return entity.key === key;
            });
            if (prevEntity && prevEntity.status === STATUS_REMOVED && entity.status === STATUS_REMOVE) {
              return false;
            }
            return true;
          })
        };
      }
    }]);
    return CSSMotionList2;
  }(React33.Component);
  _defineProperty(CSSMotionList, "defaultProps", {
    component: "div"
  });
  return CSSMotionList;
}
var CSSMotionList_default = genCSSMotionList(supportTransition);

// ../../node_modules/rc-motion/es/index.js
var es_default2 = CSSMotion_default;

// ../../node_modules/antd/es/config-provider/MotionWrapper.js
var React34 = __toESM(require("react"));
function MotionWrapper(props) {
  const {
    children
  } = props;
  const [, token2] = useToken();
  const {
    motion
  } = token2;
  const needWrapMotionProviderRef = React34.useRef(false);
  needWrapMotionProviderRef.current = needWrapMotionProviderRef.current || motion === false;
  if (needWrapMotionProviderRef.current) {
    return /* @__PURE__ */ React34.createElement(MotionProvider, {
      motion
    }, children);
  }
  return children;
}

// ../../node_modules/antd/es/config-provider/PropWarning.js
var React35 = __toESM(require("react"));
var PropWarning = /* @__PURE__ */ React35.memo((_ref) => {
  let {
    dropdownMatchSelectWidth
  } = _ref;
  const warning6 = devUseWarning("ConfigProvider");
  warning6.deprecated(dropdownMatchSelectWidth === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth");
  return null;
});
if (process.env.NODE_ENV !== "production") {
  PropWarning.displayName = "PropWarning";
}
var PropWarning_default = process.env.NODE_ENV !== "production" ? PropWarning : () => null;

// ../../node_modules/antd/es/config-provider/index.js
var __rest3 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var existThemeConfig = false;
var warnContext = process.env.NODE_ENV !== "production" ? (componentName) => {
  process.env.NODE_ENV !== "production" ? warning_default2(!existThemeConfig, componentName, `Static function can not consume context like dynamic theme. Please use 'App' component instead.`) : void 0;
} : (
  /* istanbul ignore next */
  null
);
var PASSED_PROPS = ["getTargetContainer", "getPopupContainer", "renderEmpty", "pageHeader", "input", "pagination", "form", "select", "button"];
var defaultPrefixCls = "ant";
var globalPrefixCls;
var globalIconPrefixCls;
var globalTheme;
var globalHolderRender;
function getGlobalPrefixCls() {
  return globalPrefixCls || defaultPrefixCls;
}
function getGlobalIconPrefixCls() {
  return globalIconPrefixCls || defaultIconPrefixCls;
}
function isLegacyTheme(theme) {
  return Object.keys(theme).some((key) => key.endsWith("Color"));
}
var setGlobalConfig = (props) => {
  const {
    prefixCls,
    iconPrefixCls,
    theme,
    holderRender
  } = props;
  if (prefixCls !== void 0) {
    globalPrefixCls = prefixCls;
  }
  if (iconPrefixCls !== void 0) {
    globalIconPrefixCls = iconPrefixCls;
  }
  if ("holderRender" in props) {
    globalHolderRender = holderRender;
  }
  if (theme) {
    if (isLegacyTheme(theme)) {
      process.env.NODE_ENV !== "production" ? warning_default2(false, "ConfigProvider", "`config` of css variable theme is not work in v5. Please use new `theme` config instead.") : void 0;
      registerTheme(getGlobalPrefixCls(), theme);
    } else {
      globalTheme = theme;
    }
  }
};
var globalConfig = () => ({
  getIconPrefixCls: getGlobalIconPrefixCls,
  getRootPrefixCls: () => {
    if (globalPrefixCls) {
      return globalPrefixCls;
    }
    return getGlobalPrefixCls();
  },
  getTheme: () => globalTheme,
  holderRender: globalHolderRender
});
var ProviderChildren = (props) => {
  const {
    children,
    csp: customCsp,
    autoInsertSpaceInButton,
    alert,
    anchor,
    form,
    locale: locale6,
    componentSize,
    direction,
    space,
    virtual,
    dropdownMatchSelectWidth,
    popupMatchSelectWidth,
    popupOverflow,
    legacyLocale,
    parentContext,
    iconPrefixCls: customIconPrefixCls,
    theme,
    componentDisabled,
    segmented,
    statistic: statistic2,
    spin,
    calendar,
    carousel,
    cascader,
    collapse,
    typography,
    checkbox,
    descriptions,
    divider,
    drawer,
    skeleton,
    steps,
    image,
    layout,
    list,
    mentions,
    modal,
    progress,
    result,
    slider,
    breadcrumb,
    menu,
    pagination,
    input,
    empty,
    badge,
    radio,
    rate,
    switch: SWITCH,
    transfer,
    avatar,
    message: message2,
    tag,
    table,
    card,
    tabs,
    timeline,
    timePicker,
    upload,
    notification: notification2,
    tree,
    colorPicker,
    datePicker,
    rangePicker,
    flex,
    wave,
    dropdown,
    warning: warningConfig
  } = props;
  const getPrefixCls = React36.useCallback((suffixCls, customizePrefixCls) => {
    const {
      prefixCls
    } = props;
    if (customizePrefixCls) {
      return customizePrefixCls;
    }
    const mergedPrefixCls = prefixCls || parentContext.getPrefixCls("");
    return suffixCls ? `${mergedPrefixCls}-${suffixCls}` : mergedPrefixCls;
  }, [parentContext.getPrefixCls, props.prefixCls]);
  const iconPrefixCls = customIconPrefixCls || parentContext.iconPrefixCls || defaultIconPrefixCls;
  const csp = customCsp || parentContext.csp;
  useResetIconStyle_default(iconPrefixCls, csp);
  const mergedTheme = useTheme(theme, parentContext.theme);
  if (process.env.NODE_ENV !== "production") {
    existThemeConfig = existThemeConfig || !!mergedTheme;
  }
  const baseConfig = {
    csp,
    autoInsertSpaceInButton,
    alert,
    anchor,
    locale: locale6 || legacyLocale,
    direction,
    space,
    virtual,
    popupMatchSelectWidth: popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth,
    popupOverflow,
    getPrefixCls,
    iconPrefixCls,
    theme: mergedTheme,
    segmented,
    statistic: statistic2,
    spin,
    calendar,
    carousel,
    cascader,
    collapse,
    typography,
    checkbox,
    descriptions,
    divider,
    drawer,
    skeleton,
    steps,
    image,
    input,
    layout,
    list,
    mentions,
    modal,
    progress,
    result,
    slider,
    breadcrumb,
    menu,
    pagination,
    empty,
    badge,
    radio,
    rate,
    switch: SWITCH,
    transfer,
    avatar,
    message: message2,
    tag,
    table,
    card,
    tabs,
    timeline,
    timePicker,
    upload,
    notification: notification2,
    tree,
    colorPicker,
    datePicker,
    rangePicker,
    flex,
    wave,
    dropdown,
    warning: warningConfig
  };
  const config = Object.assign({}, parentContext);
  Object.keys(baseConfig).forEach((key) => {
    if (baseConfig[key] !== void 0) {
      config[key] = baseConfig[key];
    }
  });
  PASSED_PROPS.forEach((propName) => {
    const propValue = props[propName];
    if (propValue) {
      config[propName] = propValue;
    }
  });
  const memoedConfig = useMemo(() => config, config, (prevConfig, currentConfig) => {
    const prevKeys = Object.keys(prevConfig);
    const currentKeys = Object.keys(currentConfig);
    return prevKeys.length !== currentKeys.length || prevKeys.some((key) => prevConfig[key] !== currentConfig[key]);
  });
  const memoIconContextValue = React36.useMemo(() => ({
    prefixCls: iconPrefixCls,
    csp
  }), [iconPrefixCls, csp]);
  let childNode = /* @__PURE__ */ React36.createElement(React36.Fragment, null, /* @__PURE__ */ React36.createElement(PropWarning_default, {
    dropdownMatchSelectWidth
  }), children);
  const validateMessages = React36.useMemo(() => {
    var _a, _b, _c, _d;
    return merge(((_a = en_US_default6.Form) === null || _a === void 0 ? void 0 : _a.defaultValidateMessages) || {}, ((_c = (_b = memoedConfig.locale) === null || _b === void 0 ? void 0 : _b.Form) === null || _c === void 0 ? void 0 : _c.defaultValidateMessages) || {}, ((_d = memoedConfig.form) === null || _d === void 0 ? void 0 : _d.validateMessages) || {}, (form === null || form === void 0 ? void 0 : form.validateMessages) || {});
  }, [memoedConfig, form === null || form === void 0 ? void 0 : form.validateMessages]);
  if (Object.keys(validateMessages).length > 0) {
    childNode = /* @__PURE__ */ React36.createElement(validateMessagesContext_default.Provider, {
      value: validateMessages
    }, childNode);
  }
  if (locale6) {
    childNode = /* @__PURE__ */ React36.createElement(locale_default, {
      locale: locale6,
      _ANT_MARK__: ANT_MARK
    }, childNode);
  }
  if (iconPrefixCls || csp) {
    childNode = /* @__PURE__ */ React36.createElement(Context_default.Provider, {
      value: memoIconContextValue
    }, childNode);
  }
  if (componentSize) {
    childNode = /* @__PURE__ */ React36.createElement(SizeContextProvider, {
      size: componentSize
    }, childNode);
  }
  childNode = /* @__PURE__ */ React36.createElement(MotionWrapper, null, childNode);
  const memoTheme = React36.useMemo(() => {
    const _a = mergedTheme || {}, {
      algorithm,
      token: token2,
      components,
      cssVar
    } = _a, rest = __rest3(_a, ["algorithm", "token", "components", "cssVar"]);
    const themeObj = algorithm && (!Array.isArray(algorithm) || algorithm.length > 0) ? createTheme(algorithm) : defaultTheme;
    const parsedComponents = {};
    Object.entries(components || {}).forEach((_ref) => {
      let [componentName, componentToken] = _ref;
      const parsedToken = Object.assign({}, componentToken);
      if ("algorithm" in parsedToken) {
        if (parsedToken.algorithm === true) {
          parsedToken.theme = themeObj;
        } else if (Array.isArray(parsedToken.algorithm) || typeof parsedToken.algorithm === "function") {
          parsedToken.theme = createTheme(parsedToken.algorithm);
        }
        delete parsedToken.algorithm;
      }
      parsedComponents[componentName] = parsedToken;
    });
    const mergedToken = Object.assign(Object.assign({}, seed_default), token2);
    return Object.assign(Object.assign({}, rest), {
      theme: themeObj,
      token: mergedToken,
      components: parsedComponents,
      override: Object.assign({
        override: mergedToken
      }, parsedComponents),
      cssVar
    });
  }, [mergedTheme]);
  if (theme) {
    childNode = /* @__PURE__ */ React36.createElement(DesignTokenContext.Provider, {
      value: memoTheme
    }, childNode);
  }
  if (memoedConfig.warning) {
    childNode = /* @__PURE__ */ React36.createElement(WarningContext.Provider, {
      value: memoedConfig.warning
    }, childNode);
  }
  if (componentDisabled !== void 0) {
    childNode = /* @__PURE__ */ React36.createElement(DisabledContextProvider, {
      disabled: componentDisabled
    }, childNode);
  }
  return /* @__PURE__ */ React36.createElement(ConfigContext.Provider, {
    value: memoedConfig
  }, childNode);
};
var ConfigProvider = (props) => {
  const context = React36.useContext(ConfigContext);
  const antLocale = React36.useContext(context_default);
  return /* @__PURE__ */ React36.createElement(ProviderChildren, Object.assign({
    parentContext: context,
    legacyLocale: antLocale
  }, props));
};
ConfigProvider.ConfigContext = ConfigContext;
ConfigProvider.SizeContext = SizeContext_default;
ConfigProvider.config = setGlobalConfig;
ConfigProvider.useConfig = useConfig_default;
Object.defineProperty(ConfigProvider, "SizeContext", {
  get: () => {
    process.env.NODE_ENV !== "production" ? warning_default2(false, "ConfigProvider", "ConfigProvider.SizeContext is deprecated. Please use `ConfigProvider.useConfig().componentSize` instead.") : void 0;
    return SizeContext_default;
  }
});
if (process.env.NODE_ENV !== "production") {
  ConfigProvider.displayName = "ConfigProvider";
}
var config_provider_default = ConfigProvider;

// ../../node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js
var React40 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/CheckCircleFilled.js
var CheckCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 01-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z" } }] }, "name": "check-circle", "theme": "filled" };
var CheckCircleFilled_default = CheckCircleFilled;

// ../../node_modules/@ant-design/icons/es/components/AntdIcon.js
var React39 = __toESM(require("react"));
var import_classnames2 = __toESM(require_classnames());

// ../../node_modules/@ant-design/icons/es/components/IconBase.js
var React38 = __toESM(require("react"));

// ../../node_modules/rc-util/es/Dom/shadow.js
function getRoot(ele) {
  var _ele$getRootNode;
  return ele === null || ele === void 0 || (_ele$getRootNode = ele.getRootNode) === null || _ele$getRootNode === void 0 ? void 0 : _ele$getRootNode.call(ele);
}
function inShadow(ele) {
  return getRoot(ele) instanceof ShadowRoot;
}
function getShadowRoot(ele) {
  return inShadow(ele) ? getRoot(ele) : null;
}

// ../../node_modules/@ant-design/icons/es/utils.js
var import_react17 = __toESM(require("react"));
function camelCase(input) {
  return input.replace(/-(.)/g, function(match2, g) {
    return g.toUpperCase();
  });
}
function warning3(valid, message2) {
  warning_default(valid, "[@ant-design/icons] ".concat(message2));
}
function isIconDefinition(target) {
  return _typeof(target) === "object" && typeof target.name === "string" && typeof target.theme === "string" && (_typeof(target.icon) === "object" || typeof target.icon === "function");
}
function normalizeAttrs() {
  var attrs = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  return Object.keys(attrs).reduce(function(acc, key) {
    var val = attrs[key];
    switch (key) {
      case "class":
        acc.className = val;
        delete acc.class;
        break;
      default:
        delete acc[key];
        acc[camelCase(key)] = val;
    }
    return acc;
  }, {});
}
function generate2(node2, key, rootProps) {
  if (!rootProps) {
    return /* @__PURE__ */ import_react17.default.createElement(node2.tag, _objectSpread2({
      key
    }, normalizeAttrs(node2.attrs)), (node2.children || []).map(function(child, index2) {
      return generate2(child, "".concat(key, "-").concat(node2.tag, "-").concat(index2));
    }));
  }
  return /* @__PURE__ */ import_react17.default.createElement(node2.tag, _objectSpread2(_objectSpread2({
    key
  }, normalizeAttrs(node2.attrs)), rootProps), (node2.children || []).map(function(child, index2) {
    return generate2(child, "".concat(key, "-").concat(node2.tag, "-").concat(index2));
  }));
}
function getSecondaryColor(primaryColor) {
  return generate(primaryColor)[0];
}
function normalizeTwoToneColors(twoToneColor) {
  if (!twoToneColor) {
    return [];
  }
  return Array.isArray(twoToneColor) ? twoToneColor : [twoToneColor];
}
var iconStyles = "\n.anticon {\n  display: inline-block;\n  color: inherit;\n  font-style: normal;\n  line-height: 0;\n  text-align: center;\n  text-transform: none;\n  vertical-align: -0.125em;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n.anticon > * {\n  line-height: 1;\n}\n\n.anticon svg {\n  display: inline-block;\n}\n\n.anticon::before {\n  display: none;\n}\n\n.anticon .anticon-icon {\n  display: block;\n}\n\n.anticon[tabindex] {\n  cursor: pointer;\n}\n\n.anticon-spin::before,\n.anticon-spin {\n  display: inline-block;\n  -webkit-animation: loadingCircle 1s infinite linear;\n  animation: loadingCircle 1s infinite linear;\n}\n\n@-webkit-keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes loadingCircle {\n  100% {\n    -webkit-transform: rotate(360deg);\n    transform: rotate(360deg);\n  }\n}\n";
var useInsertStyles = function useInsertStyles2(eleRef) {
  var _useContext = (0, import_react17.useContext)(Context_default), csp = _useContext.csp, prefixCls = _useContext.prefixCls;
  var mergedStyleStr = iconStyles;
  if (prefixCls) {
    mergedStyleStr = mergedStyleStr.replace(/anticon/g, prefixCls);
  }
  (0, import_react17.useEffect)(function() {
    var ele = eleRef.current;
    var shadowRoot = getShadowRoot(ele);
    updateCSS(mergedStyleStr, "@ant-design-icons", {
      prepend: true,
      csp,
      attachTo: shadowRoot
    });
  }, []);
};

// ../../node_modules/@ant-design/icons/es/components/IconBase.js
var _excluded3 = ["icon", "className", "onClick", "style", "primaryColor", "secondaryColor"];
var twoToneColorPalette = {
  primaryColor: "#333",
  secondaryColor: "#E6E6E6",
  calculated: false
};
function setTwoToneColors(_ref) {
  var primaryColor = _ref.primaryColor, secondaryColor = _ref.secondaryColor;
  twoToneColorPalette.primaryColor = primaryColor;
  twoToneColorPalette.secondaryColor = secondaryColor || getSecondaryColor(primaryColor);
  twoToneColorPalette.calculated = !!secondaryColor;
}
function getTwoToneColors() {
  return _objectSpread2({}, twoToneColorPalette);
}
var IconBase = function IconBase2(props) {
  var icon = props.icon, className = props.className, onClick = props.onClick, style2 = props.style, primaryColor = props.primaryColor, secondaryColor = props.secondaryColor, restProps = _objectWithoutProperties(props, _excluded3);
  var svgRef = React38.useRef();
  var colors = twoToneColorPalette;
  if (primaryColor) {
    colors = {
      primaryColor,
      secondaryColor: secondaryColor || getSecondaryColor(primaryColor)
    };
  }
  useInsertStyles(svgRef);
  warning3(isIconDefinition(icon), "icon should be icon definiton, but got ".concat(icon));
  if (!isIconDefinition(icon)) {
    return null;
  }
  var target = icon;
  if (target && typeof target.icon === "function") {
    target = _objectSpread2(_objectSpread2({}, target), {}, {
      icon: target.icon(colors.primaryColor, colors.secondaryColor)
    });
  }
  return generate2(target.icon, "svg-".concat(target.name), _objectSpread2(_objectSpread2({
    className,
    onClick,
    style: style2,
    "data-icon": target.name,
    width: "1em",
    height: "1em",
    fill: "currentColor",
    "aria-hidden": "true"
  }, restProps), {}, {
    ref: svgRef
  }));
};
IconBase.displayName = "IconReact";
IconBase.getTwoToneColors = getTwoToneColors;
IconBase.setTwoToneColors = setTwoToneColors;
var IconBase_default = IconBase;

// ../../node_modules/@ant-design/icons/es/components/twoTonePrimaryColor.js
function setTwoToneColor(twoToneColor) {
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return IconBase_default.setTwoToneColors({
    primaryColor,
    secondaryColor
  });
}
function getTwoToneColor() {
  var colors = IconBase_default.getTwoToneColors();
  if (!colors.calculated) {
    return colors.primaryColor;
  }
  return [colors.primaryColor, colors.secondaryColor];
}

// ../../node_modules/@ant-design/icons/es/components/AntdIcon.js
var _excluded4 = ["className", "icon", "spin", "rotate", "tabIndex", "onClick", "twoToneColor"];
setTwoToneColor(blue.primary);
var Icon = /* @__PURE__ */ React39.forwardRef(function(props, ref) {
  var _classNames;
  var className = props.className, icon = props.icon, spin = props.spin, rotate = props.rotate, tabIndex = props.tabIndex, onClick = props.onClick, twoToneColor = props.twoToneColor, restProps = _objectWithoutProperties(props, _excluded4);
  var _React$useContext = React39.useContext(Context_default), _React$useContext$pre = _React$useContext.prefixCls, prefixCls = _React$useContext$pre === void 0 ? "anticon" : _React$useContext$pre, rootClassName = _React$useContext.rootClassName;
  var classString = (0, import_classnames2.default)(rootClassName, prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(icon.name), !!icon.name), _defineProperty(_classNames, "".concat(prefixCls, "-spin"), !!spin || icon.name === "loading"), _classNames), className);
  var iconTabIndex = tabIndex;
  if (iconTabIndex === void 0 && onClick) {
    iconTabIndex = -1;
  }
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : void 0;
  var _normalizeTwoToneColo = normalizeTwoToneColors(twoToneColor), _normalizeTwoToneColo2 = _slicedToArray(_normalizeTwoToneColo, 2), primaryColor = _normalizeTwoToneColo2[0], secondaryColor = _normalizeTwoToneColo2[1];
  return /* @__PURE__ */ React39.createElement("span", _extends({
    role: "img",
    "aria-label": icon.name
  }, restProps, {
    ref,
    tabIndex: iconTabIndex,
    onClick,
    className: classString
  }), /* @__PURE__ */ React39.createElement(IconBase_default, {
    icon,
    primaryColor,
    secondaryColor,
    style: svgStyle
  }));
});
Icon.displayName = "AntdIcon";
Icon.getTwoToneColor = getTwoToneColor;
Icon.setTwoToneColor = setTwoToneColor;
var AntdIcon_default = Icon;

// ../../node_modules/@ant-design/icons/es/icons/CheckCircleFilled.js
var CheckCircleFilled2 = function CheckCircleFilled3(props, ref) {
  return /* @__PURE__ */ React40.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: CheckCircleFilled_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  CheckCircleFilled2.displayName = "CheckCircleFilled";
}
var CheckCircleFilled_default2 = /* @__PURE__ */ React40.forwardRef(CheckCircleFilled2);

// ../../node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js
var React41 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/CloseCircleFilled.js
var CloseCircleFilled = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64c247.4 0 448 200.6 448 448S759.4 960 512 960 64 759.4 64 512 264.6 64 512 64zm127.98 274.82h-.04l-.08.06L512 466.75 384.14 338.88c-.04-.05-.06-.06-.08-.06a.12.12 0 00-.07 0c-.03 0-.05.01-.09.05l-45.02 45.02a.2.2 0 00-.05.09.12.12 0 000 .07v.02a.27.27 0 00.06.06L466.75 512 338.88 639.86c-.05.04-.06.06-.06.08a.12.12 0 000 .07c0 .03.01.05.05.09l45.02 45.02a.2.2 0 00.09.05.12.12 0 00.07 0c.02 0 .04-.01.08-.05L512 557.25l127.86 127.87c.04.04.06.05.08.05a.12.12 0 00.07 0c.03 0 .05-.01.09-.05l45.02-45.02a.2.2 0 00.05-.09.12.12 0 000-.07v-.02a.27.27 0 00-.05-.06L557.25 512l127.87-127.86c.04-.04.05-.06.05-.08a.12.12 0 000-.07c0-.03-.01-.05-.05-.09l-45.02-45.02a.2.2 0 00-.09-.05.12.12 0 00-.07 0z" } }] }, "name": "close-circle", "theme": "filled" };
var CloseCircleFilled_default = CloseCircleFilled;

// ../../node_modules/@ant-design/icons/es/icons/CloseCircleFilled.js
var CloseCircleFilled2 = function CloseCircleFilled3(props, ref) {
  return /* @__PURE__ */ React41.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: CloseCircleFilled_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  CloseCircleFilled2.displayName = "CloseCircleFilled";
}
var CloseCircleFilled_default2 = /* @__PURE__ */ React41.forwardRef(CloseCircleFilled2);

// ../../node_modules/@ant-design/icons/es/icons/CloseOutlined.js
var React42 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/CloseOutlined.js
var CloseOutlined = { "icon": { "tag": "svg", "attrs": { "fill-rule": "evenodd", "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M799.86 166.31c.02 0 .04.02.08.06l57.69 57.7c.04.03.05.05.06.08a.12.12 0 010 .06c0 .03-.02.05-.06.09L569.93 512l287.7 287.7c.04.04.05.06.06.09a.12.12 0 010 .07c0 .02-.02.04-.06.08l-57.7 57.69c-.03.04-.05.05-.07.06a.12.12 0 01-.07 0c-.03 0-.05-.02-.09-.06L512 569.93l-287.7 287.7c-.04.04-.06.05-.09.06a.12.12 0 01-.07 0c-.02 0-.04-.02-.08-.06l-57.69-57.7c-.04-.03-.05-.05-.06-.07a.12.12 0 010-.07c0-.03.02-.05.06-.09L454.07 512l-287.7-287.7c-.04-.04-.05-.06-.06-.09a.12.12 0 010-.07c0-.02.02-.04.06-.08l57.7-57.69c.03-.04.05-.05.07-.06a.12.12 0 01.07 0c.03 0 .05.02.09.06L512 454.07l287.7-287.7c.04-.04.06-.05.09-.06a.12.12 0 01.07 0z" } }] }, "name": "close", "theme": "outlined" };
var CloseOutlined_default = CloseOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CloseOutlined.js
var CloseOutlined2 = function CloseOutlined3(props, ref) {
  return /* @__PURE__ */ React42.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: CloseOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  CloseOutlined2.displayName = "CloseOutlined";
}
var CloseOutlined_default2 = /* @__PURE__ */ React42.forwardRef(CloseOutlined2);

// ../../node_modules/@ant-design/icons/es/icons/ExclamationCircleFilled.js
var React43 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/ExclamationCircleFilled.js
var ExclamationCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "exclamation-circle", "theme": "filled" };
var ExclamationCircleFilled_default = ExclamationCircleFilled;

// ../../node_modules/@ant-design/icons/es/icons/ExclamationCircleFilled.js
var ExclamationCircleFilled2 = function ExclamationCircleFilled3(props, ref) {
  return /* @__PURE__ */ React43.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: ExclamationCircleFilled_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  ExclamationCircleFilled2.displayName = "ExclamationCircleFilled";
}
var ExclamationCircleFilled_default2 = /* @__PURE__ */ React43.forwardRef(ExclamationCircleFilled2);

// ../../node_modules/@ant-design/icons/es/icons/InfoCircleFilled.js
var React44 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/InfoCircleFilled.js
var InfoCircleFilled = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 010-96 48.01 48.01 0 010 96z" } }] }, "name": "info-circle", "theme": "filled" };
var InfoCircleFilled_default = InfoCircleFilled;

// ../../node_modules/@ant-design/icons/es/icons/InfoCircleFilled.js
var InfoCircleFilled2 = function InfoCircleFilled3(props, ref) {
  return /* @__PURE__ */ React44.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: InfoCircleFilled_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  InfoCircleFilled2.displayName = "InfoCircleFilled";
}
var InfoCircleFilled_default2 = /* @__PURE__ */ React44.forwardRef(InfoCircleFilled2);

// ../../node_modules/rc-util/es/pickAttrs.js
var attributes = "accept acceptCharset accessKey action allowFullScreen allowTransparency\n    alt async autoComplete autoFocus autoPlay capture cellPadding cellSpacing challenge\n    charSet checked classID className colSpan cols content contentEditable contextMenu\n    controls coords crossOrigin data dateTime default defer dir disabled download draggable\n    encType form formAction formEncType formMethod formNoValidate formTarget frameBorder\n    headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity\n    is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media\n    mediaGroup method min minLength multiple muted name noValidate nonce open\n    optimum pattern placeholder poster preload radioGroup readOnly rel required\n    reversed role rowSpan rows sandbox scope scoped scrolling seamless selected\n    shape size sizes span spellCheck src srcDoc srcLang srcSet start step style\n    summary tabIndex target title type useMap value width wmode wrap";
var eventsName = "onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown\n    onKeyPress onKeyUp onFocus onBlur onChange onInput onSubmit onClick onContextMenu onDoubleClick\n    onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown\n    onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel\n    onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough\n    onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata\n    onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onError";
var propList = "".concat(attributes, " ").concat(eventsName).split(/[\s\n]+/);
var ariaPrefix = "aria-";
var dataPrefix = "data-";
function match(key, prefix) {
  return key.indexOf(prefix) === 0;
}
function pickAttrs(props) {
  var ariaOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var mergedConfig;
  if (ariaOnly === false) {
    mergedConfig = {
      aria: true,
      data: true,
      attr: true
    };
  } else if (ariaOnly === true) {
    mergedConfig = {
      aria: true
    };
  } else {
    mergedConfig = _objectSpread2({}, ariaOnly);
  }
  var attrs = {};
  Object.keys(props).forEach(function(key) {
    if (
      // Aria
      mergedConfig.aria && (key === "role" || match(key, ariaPrefix)) || // Data
      mergedConfig.data && match(key, dataPrefix) || // Attr
      mergedConfig.attr && propList.includes(key)
    ) {
      attrs[key] = props[key];
    }
  });
  return attrs;
}

// ../../node_modules/antd/es/_util/reactNode.js
var React45 = __toESM(require("react"));
var {
  isValidElement: isValidElement4
} = React45;
function isFragment3(child) {
  return child && isValidElement4(child) && child.type === React45.Fragment;
}
function replaceElement(element, replacement, props) {
  if (!isValidElement4(element)) {
    return replacement;
  }
  return /* @__PURE__ */ React45.cloneElement(element, typeof props === "function" ? props(element.props || {}) : props);
}
function cloneElement4(element, props) {
  return replaceElement(element, element, props);
}

// ../../node_modules/antd/es/config-provider/hooks/useCSSVarCls.js
var useCSSVarCls = (prefixCls) => {
  const [, , , , cssVar] = useToken();
  return cssVar ? `${prefixCls}-css-var` : "";
};
var useCSSVarCls_default = useCSSVarCls;

// ../../node_modules/antd/es/message/useMessage.js
var React55 = __toESM(require("react"));
var import_classnames6 = __toESM(require_classnames());

// ../../node_modules/rc-notification/es/hooks/useNotification.js
var React50 = __toESM(require("react"));

// ../../node_modules/rc-notification/es/Notifications.js
var React49 = __toESM(require("react"));
var import_react_dom2 = require("react-dom");

// ../../node_modules/rc-notification/es/NoticeList.js
var import_react19 = __toESM(require("react"));
var import_classnames4 = __toESM(require_classnames());

// ../../node_modules/rc-notification/es/Notice.js
var import_classnames3 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/KeyCode.js
var KeyCode = {
  /**
   * MAC_ENTER
   */
  MAC_ENTER: 3,
  /**
   * BACKSPACE
   */
  BACKSPACE: 8,
  /**
   * TAB
   */
  TAB: 9,
  /**
   * NUMLOCK on FF/Safari Mac
   */
  NUM_CENTER: 12,
  // NUMLOCK on FF/Safari Mac
  /**
   * ENTER
   */
  ENTER: 13,
  /**
   * SHIFT
   */
  SHIFT: 16,
  /**
   * CTRL
   */
  CTRL: 17,
  /**
   * ALT
   */
  ALT: 18,
  /**
   * PAUSE
   */
  PAUSE: 19,
  /**
   * CAPS_LOCK
   */
  CAPS_LOCK: 20,
  /**
   * ESC
   */
  ESC: 27,
  /**
   * SPACE
   */
  SPACE: 32,
  /**
   * PAGE_UP
   */
  PAGE_UP: 33,
  // also NUM_NORTH_EAST
  /**
   * PAGE_DOWN
   */
  PAGE_DOWN: 34,
  // also NUM_SOUTH_EAST
  /**
   * END
   */
  END: 35,
  // also NUM_SOUTH_WEST
  /**
   * HOME
   */
  HOME: 36,
  // also NUM_NORTH_WEST
  /**
   * LEFT
   */
  LEFT: 37,
  // also NUM_WEST
  /**
   * UP
   */
  UP: 38,
  // also NUM_NORTH
  /**
   * RIGHT
   */
  RIGHT: 39,
  // also NUM_EAST
  /**
   * DOWN
   */
  DOWN: 40,
  // also NUM_SOUTH
  /**
   * PRINT_SCREEN
   */
  PRINT_SCREEN: 44,
  /**
   * INSERT
   */
  INSERT: 45,
  // also NUM_INSERT
  /**
   * DELETE
   */
  DELETE: 46,
  // also NUM_DELETE
  /**
   * ZERO
   */
  ZERO: 48,
  /**
   * ONE
   */
  ONE: 49,
  /**
   * TWO
   */
  TWO: 50,
  /**
   * THREE
   */
  THREE: 51,
  /**
   * FOUR
   */
  FOUR: 52,
  /**
   * FIVE
   */
  FIVE: 53,
  /**
   * SIX
   */
  SIX: 54,
  /**
   * SEVEN
   */
  SEVEN: 55,
  /**
   * EIGHT
   */
  EIGHT: 56,
  /**
   * NINE
   */
  NINE: 57,
  /**
   * QUESTION_MARK
   */
  QUESTION_MARK: 63,
  // needs localization
  /**
   * A
   */
  A: 65,
  /**
   * B
   */
  B: 66,
  /**
   * C
   */
  C: 67,
  /**
   * D
   */
  D: 68,
  /**
   * E
   */
  E: 69,
  /**
   * F
   */
  F: 70,
  /**
   * G
   */
  G: 71,
  /**
   * H
   */
  H: 72,
  /**
   * I
   */
  I: 73,
  /**
   * J
   */
  J: 74,
  /**
   * K
   */
  K: 75,
  /**
   * L
   */
  L: 76,
  /**
   * M
   */
  M: 77,
  /**
   * N
   */
  N: 78,
  /**
   * O
   */
  O: 79,
  /**
   * P
   */
  P: 80,
  /**
   * Q
   */
  Q: 81,
  /**
   * R
   */
  R: 82,
  /**
   * S
   */
  S: 83,
  /**
   * T
   */
  T: 84,
  /**
   * U
   */
  U: 85,
  /**
   * V
   */
  V: 86,
  /**
   * W
   */
  W: 87,
  /**
   * X
   */
  X: 88,
  /**
   * Y
   */
  Y: 89,
  /**
   * Z
   */
  Z: 90,
  /**
   * META
   */
  META: 91,
  // WIN_KEY_LEFT
  /**
   * WIN_KEY_RIGHT
   */
  WIN_KEY_RIGHT: 92,
  /**
   * CONTEXT_MENU
   */
  CONTEXT_MENU: 93,
  /**
   * NUM_ZERO
   */
  NUM_ZERO: 96,
  /**
   * NUM_ONE
   */
  NUM_ONE: 97,
  /**
   * NUM_TWO
   */
  NUM_TWO: 98,
  /**
   * NUM_THREE
   */
  NUM_THREE: 99,
  /**
   * NUM_FOUR
   */
  NUM_FOUR: 100,
  /**
   * NUM_FIVE
   */
  NUM_FIVE: 101,
  /**
   * NUM_SIX
   */
  NUM_SIX: 102,
  /**
   * NUM_SEVEN
   */
  NUM_SEVEN: 103,
  /**
   * NUM_EIGHT
   */
  NUM_EIGHT: 104,
  /**
   * NUM_NINE
   */
  NUM_NINE: 105,
  /**
   * NUM_MULTIPLY
   */
  NUM_MULTIPLY: 106,
  /**
   * NUM_PLUS
   */
  NUM_PLUS: 107,
  /**
   * NUM_MINUS
   */
  NUM_MINUS: 109,
  /**
   * NUM_PERIOD
   */
  NUM_PERIOD: 110,
  /**
   * NUM_DIVISION
   */
  NUM_DIVISION: 111,
  /**
   * F1
   */
  F1: 112,
  /**
   * F2
   */
  F2: 113,
  /**
   * F3
   */
  F3: 114,
  /**
   * F4
   */
  F4: 115,
  /**
   * F5
   */
  F5: 116,
  /**
   * F6
   */
  F6: 117,
  /**
   * F7
   */
  F7: 118,
  /**
   * F8
   */
  F8: 119,
  /**
   * F9
   */
  F9: 120,
  /**
   * F10
   */
  F10: 121,
  /**
   * F11
   */
  F11: 122,
  /**
   * F12
   */
  F12: 123,
  /**
   * NUMLOCK
   */
  NUMLOCK: 144,
  /**
   * SEMICOLON
   */
  SEMICOLON: 186,
  // needs localization
  /**
   * DASH
   */
  DASH: 189,
  // needs localization
  /**
   * EQUALS
   */
  EQUALS: 187,
  // needs localization
  /**
   * COMMA
   */
  COMMA: 188,
  // needs localization
  /**
   * PERIOD
   */
  PERIOD: 190,
  // needs localization
  /**
   * SLASH
   */
  SLASH: 191,
  // needs localization
  /**
   * APOSTROPHE
   */
  APOSTROPHE: 192,
  // needs localization
  /**
   * SINGLE_QUOTE
   */
  SINGLE_QUOTE: 222,
  // needs localization
  /**
   * OPEN_SQUARE_BRACKET
   */
  OPEN_SQUARE_BRACKET: 219,
  // needs localization
  /**
   * BACKSLASH
   */
  BACKSLASH: 220,
  // needs localization
  /**
   * CLOSE_SQUARE_BRACKET
   */
  CLOSE_SQUARE_BRACKET: 221,
  // needs localization
  /**
   * WIN_KEY
   */
  WIN_KEY: 224,
  /**
   * MAC_FF_META
   */
  MAC_FF_META: 224,
  // Firefox (Gecko) fires this for the meta key instead of 91
  /**
   * WIN_IME
   */
  WIN_IME: 229,
  // ======================== Function ========================
  /**
   * whether text and modified key is entered at the same time.
   */
  isTextModifyingKeyEvent: function isTextModifyingKeyEvent(e) {
    var keyCode = e.keyCode;
    if (e.altKey && !e.ctrlKey || e.metaKey || // Function keys don't generate text
    keyCode >= KeyCode.F1 && keyCode <= KeyCode.F12) {
      return false;
    }
    switch (keyCode) {
      case KeyCode.ALT:
      case KeyCode.CAPS_LOCK:
      case KeyCode.CONTEXT_MENU:
      case KeyCode.CTRL:
      case KeyCode.DOWN:
      case KeyCode.END:
      case KeyCode.ESC:
      case KeyCode.HOME:
      case KeyCode.INSERT:
      case KeyCode.LEFT:
      case KeyCode.MAC_FF_META:
      case KeyCode.META:
      case KeyCode.NUMLOCK:
      case KeyCode.NUM_CENTER:
      case KeyCode.PAGE_DOWN:
      case KeyCode.PAGE_UP:
      case KeyCode.PAUSE:
      case KeyCode.PRINT_SCREEN:
      case KeyCode.RIGHT:
      case KeyCode.SHIFT:
      case KeyCode.UP:
      case KeyCode.WIN_KEY:
      case KeyCode.WIN_KEY_RIGHT:
        return false;
      default:
        return true;
    }
  },
  /**
   * whether character is entered.
   */
  isCharacterKey: function isCharacterKey(keyCode) {
    if (keyCode >= KeyCode.ZERO && keyCode <= KeyCode.NINE) {
      return true;
    }
    if (keyCode >= KeyCode.NUM_ZERO && keyCode <= KeyCode.NUM_MULTIPLY) {
      return true;
    }
    if (keyCode >= KeyCode.A && keyCode <= KeyCode.Z) {
      return true;
    }
    if (window.navigator.userAgent.indexOf("WebKit") !== -1 && keyCode === 0) {
      return true;
    }
    switch (keyCode) {
      case KeyCode.SPACE:
      case KeyCode.QUESTION_MARK:
      case KeyCode.NUM_PLUS:
      case KeyCode.NUM_MINUS:
      case KeyCode.NUM_PERIOD:
      case KeyCode.NUM_DIVISION:
      case KeyCode.SEMICOLON:
      case KeyCode.DASH:
      case KeyCode.EQUALS:
      case KeyCode.COMMA:
      case KeyCode.PERIOD:
      case KeyCode.SLASH:
      case KeyCode.APOSTROPHE:
      case KeyCode.SINGLE_QUOTE:
      case KeyCode.OPEN_SQUARE_BRACKET:
      case KeyCode.BACKSLASH:
      case KeyCode.CLOSE_SQUARE_BRACKET:
        return true;
      default:
        return false;
    }
  }
};
var KeyCode_default = KeyCode;

// ../../node_modules/rc-notification/es/Notice.js
var React46 = __toESM(require("react"));
var Notify = /* @__PURE__ */ React46.forwardRef(function(props, ref) {
  var prefixCls = props.prefixCls, style2 = props.style, className = props.className, _props$duration = props.duration, duration = _props$duration === void 0 ? 4.5 : _props$duration, eventKey = props.eventKey, content = props.content, closable = props.closable, _props$closeIcon = props.closeIcon, closeIcon = _props$closeIcon === void 0 ? "x" : _props$closeIcon, divProps = props.props, onClick = props.onClick, onNoticeClose = props.onNoticeClose, times = props.times, forcedHovering = props.hovering;
  var _React$useState = React46.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), hovering = _React$useState2[0], setHovering = _React$useState2[1];
  var mergedHovering = forcedHovering || hovering;
  var onInternalClose = function onInternalClose2() {
    onNoticeClose(eventKey);
  };
  var onCloseKeyDown = function onCloseKeyDown2(e) {
    if (e.key === "Enter" || e.code === "Enter" || e.keyCode === KeyCode_default.ENTER) {
      onInternalClose();
    }
  };
  React46.useEffect(function() {
    if (!mergedHovering && duration > 0) {
      var timeout = setTimeout(function() {
        onInternalClose();
      }, duration * 1e3);
      return function() {
        clearTimeout(timeout);
      };
    }
  }, [duration, mergedHovering, times]);
  var noticePrefixCls = "".concat(prefixCls, "-notice");
  return /* @__PURE__ */ React46.createElement("div", _extends({}, divProps, {
    ref,
    className: (0, import_classnames3.default)(noticePrefixCls, className, _defineProperty({}, "".concat(noticePrefixCls, "-closable"), closable)),
    style: style2,
    onMouseEnter: function onMouseEnter(e) {
      var _divProps$onMouseEnte;
      setHovering(true);
      divProps === null || divProps === void 0 || (_divProps$onMouseEnte = divProps.onMouseEnter) === null || _divProps$onMouseEnte === void 0 || _divProps$onMouseEnte.call(divProps, e);
    },
    onMouseLeave: function onMouseLeave(e) {
      var _divProps$onMouseLeav;
      setHovering(false);
      divProps === null || divProps === void 0 || (_divProps$onMouseLeav = divProps.onMouseLeave) === null || _divProps$onMouseLeav === void 0 || _divProps$onMouseLeav.call(divProps, e);
    },
    onClick
  }), /* @__PURE__ */ React46.createElement("div", {
    className: "".concat(noticePrefixCls, "-content")
  }, content), closable && /* @__PURE__ */ React46.createElement("a", {
    tabIndex: 0,
    className: "".concat(noticePrefixCls, "-close"),
    onKeyDown: onCloseKeyDown,
    onClick: function onClick2(e) {
      e.preventDefault();
      e.stopPropagation();
      onInternalClose();
    }
  }, closeIcon));
});
var Notice_default = Notify;

// ../../node_modules/rc-notification/es/NotificationProvider.js
var import_react18 = __toESM(require("react"));
var NotificationContext = /* @__PURE__ */ import_react18.default.createContext({});
var NotificationProvider = function NotificationProvider2(_ref) {
  var children = _ref.children, classNames54 = _ref.classNames;
  return /* @__PURE__ */ import_react18.default.createElement(NotificationContext.Provider, {
    value: {
      classNames: classNames54
    }
  }, children);
};
var NotificationProvider_default = NotificationProvider;

// ../../node_modules/rc-notification/es/hooks/useStack.js
var DEFAULT_OFFSET = 8;
var DEFAULT_THRESHOLD = 3;
var DEFAULT_GAP = 16;
var useStack = function useStack2(config) {
  var result = {
    offset: DEFAULT_OFFSET,
    threshold: DEFAULT_THRESHOLD,
    gap: DEFAULT_GAP
  };
  if (config && _typeof(config) === "object") {
    var _config$offset, _config$threshold, _config$gap;
    result.offset = (_config$offset = config.offset) !== null && _config$offset !== void 0 ? _config$offset : DEFAULT_OFFSET;
    result.threshold = (_config$threshold = config.threshold) !== null && _config$threshold !== void 0 ? _config$threshold : DEFAULT_THRESHOLD;
    result.gap = (_config$gap = config.gap) !== null && _config$gap !== void 0 ? _config$gap : DEFAULT_GAP;
  }
  return [!!config, result];
};
var useStack_default = useStack;

// ../../node_modules/rc-notification/es/NoticeList.js
var _excluded5 = ["className", "style", "classNames", "styles"];
var NoticeList = function NoticeList2(props) {
  var _clsx;
  var configList = props.configList, placement = props.placement, prefixCls = props.prefixCls, className = props.className, style2 = props.style, motion = props.motion, onAllNoticeRemoved = props.onAllNoticeRemoved, onNoticeClose = props.onNoticeClose, stackConfig = props.stack;
  var _useContext = (0, import_react19.useContext)(NotificationContext), ctxCls = _useContext.classNames;
  var dictRef = (0, import_react19.useRef)({});
  var _useState = (0, import_react19.useState)(null), _useState2 = _slicedToArray(_useState, 2), latestNotice = _useState2[0], setLatestNotice = _useState2[1];
  var _useState3 = (0, import_react19.useState)([]), _useState4 = _slicedToArray(_useState3, 2), hoverKeys = _useState4[0], setHoverKeys = _useState4[1];
  var keys3 = configList.map(function(config) {
    return {
      config,
      key: String(config.key)
    };
  });
  var _useStack = useStack_default(stackConfig), _useStack2 = _slicedToArray(_useStack, 2), stack = _useStack2[0], _useStack2$ = _useStack2[1], offset2 = _useStack2$.offset, threshold = _useStack2$.threshold, gap = _useStack2$.gap;
  var expanded = stack && (hoverKeys.length > 0 || keys3.length <= threshold);
  var placementMotion = typeof motion === "function" ? motion(placement) : motion;
  (0, import_react19.useEffect)(function() {
    if (stack && hoverKeys.length > 1) {
      setHoverKeys(function(prev2) {
        return prev2.filter(function(key) {
          return keys3.some(function(_ref) {
            var dataKey = _ref.key;
            return key === dataKey;
          });
        });
      });
    }
  }, [hoverKeys, keys3, stack]);
  (0, import_react19.useEffect)(function() {
    var _keys;
    if (stack && dictRef.current[(_keys = keys3[keys3.length - 1]) === null || _keys === void 0 ? void 0 : _keys.key]) {
      var _keys2;
      setLatestNotice(dictRef.current[(_keys2 = keys3[keys3.length - 1]) === null || _keys2 === void 0 ? void 0 : _keys2.key]);
    }
  }, [keys3, stack]);
  return /* @__PURE__ */ import_react19.default.createElement(CSSMotionList_default, _extends({
    key: placement,
    className: (0, import_classnames4.default)(prefixCls, "".concat(prefixCls, "-").concat(placement), ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.list, className, (_clsx = {}, _defineProperty(_clsx, "".concat(prefixCls, "-stack"), !!stack), _defineProperty(_clsx, "".concat(prefixCls, "-stack-expanded"), expanded), _clsx)),
    style: style2,
    keys: keys3,
    motionAppear: true
  }, placementMotion, {
    onAllRemoved: function onAllRemoved() {
      onAllNoticeRemoved(placement);
    }
  }), function(_ref2, nodeRef) {
    var config = _ref2.config, motionClassName = _ref2.className, motionStyle = _ref2.style, motionIndex = _ref2.index;
    var _ref3 = config, key = _ref3.key, times = _ref3.times;
    var strKey = String(key);
    var _ref4 = config, configClassName = _ref4.className, configStyle = _ref4.style, configClassNames = _ref4.classNames, configStyles = _ref4.styles, restConfig = _objectWithoutProperties(_ref4, _excluded5);
    var dataIndex = keys3.findIndex(function(item) {
      return item.key === strKey;
    });
    var stackStyle = {};
    if (stack) {
      var index2 = keys3.length - 1 - (dataIndex > -1 ? dataIndex : motionIndex - 1);
      var transformX = placement === "top" || placement === "bottom" ? "-50%" : "0";
      if (index2 > 0) {
        var _dictRef$current$strK, _dictRef$current$strK2, _dictRef$current$strK3;
        stackStyle.height = expanded ? (_dictRef$current$strK = dictRef.current[strKey]) === null || _dictRef$current$strK === void 0 ? void 0 : _dictRef$current$strK.offsetHeight : latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetHeight;
        var verticalOffset = 0;
        for (var i = 0; i < index2; i++) {
          var _dictRef$current$keys;
          verticalOffset += ((_dictRef$current$keys = dictRef.current[keys3[keys3.length - 1 - i].key]) === null || _dictRef$current$keys === void 0 ? void 0 : _dictRef$current$keys.offsetHeight) + gap;
        }
        var transformY = (expanded ? verticalOffset : index2 * offset2) * (placement.startsWith("top") ? 1 : -1);
        var scaleX = !expanded && latestNotice !== null && latestNotice !== void 0 && latestNotice.offsetWidth && (_dictRef$current$strK2 = dictRef.current[strKey]) !== null && _dictRef$current$strK2 !== void 0 && _dictRef$current$strK2.offsetWidth ? ((latestNotice === null || latestNotice === void 0 ? void 0 : latestNotice.offsetWidth) - offset2 * 2 * (index2 < 3 ? index2 : 3)) / ((_dictRef$current$strK3 = dictRef.current[strKey]) === null || _dictRef$current$strK3 === void 0 ? void 0 : _dictRef$current$strK3.offsetWidth) : 1;
        stackStyle.transform = "translate3d(".concat(transformX, ", ").concat(transformY, "px, 0) scaleX(").concat(scaleX, ")");
      } else {
        stackStyle.transform = "translate3d(".concat(transformX, ", 0, 0)");
      }
    }
    return /* @__PURE__ */ import_react19.default.createElement("div", {
      ref: nodeRef,
      className: (0, import_classnames4.default)("".concat(prefixCls, "-notice-wrapper"), motionClassName, configClassNames === null || configClassNames === void 0 ? void 0 : configClassNames.wrapper),
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, motionStyle), stackStyle), configStyles === null || configStyles === void 0 ? void 0 : configStyles.wrapper),
      onMouseEnter: function onMouseEnter() {
        return setHoverKeys(function(prev2) {
          return prev2.includes(strKey) ? prev2 : [].concat(_toConsumableArray(prev2), [strKey]);
        });
      },
      onMouseLeave: function onMouseLeave() {
        return setHoverKeys(function(prev2) {
          return prev2.filter(function(k) {
            return k !== strKey;
          });
        });
      }
    }, /* @__PURE__ */ import_react19.default.createElement(Notice_default, _extends({}, restConfig, {
      ref: function ref(node2) {
        if (dataIndex > -1) {
          dictRef.current[strKey] = node2;
        } else {
          delete dictRef.current[strKey];
        }
      },
      prefixCls,
      classNames: configClassNames,
      styles: configStyles,
      className: (0, import_classnames4.default)(configClassName, ctxCls === null || ctxCls === void 0 ? void 0 : ctxCls.notice),
      style: configStyle,
      times,
      key,
      eventKey: key,
      onNoticeClose,
      hovering: stack && hoverKeys.length > 0
    })));
  });
};
if (process.env.NODE_ENV !== "production") {
  NoticeList.displayName = "NoticeList";
}
var NoticeList_default = NoticeList;

// ../../node_modules/rc-notification/es/Notifications.js
var Notifications = /* @__PURE__ */ React49.forwardRef(function(props, ref) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-notification" : _props$prefixCls, container = props.container, motion = props.motion, maxCount = props.maxCount, className = props.className, style2 = props.style, onAllRemoved = props.onAllRemoved, stack = props.stack, renderNotifications3 = props.renderNotifications;
  var _React$useState = React49.useState([]), _React$useState2 = _slicedToArray(_React$useState, 2), configList = _React$useState2[0], setConfigList = _React$useState2[1];
  var onNoticeClose = function onNoticeClose2(key) {
    var _config$onClose;
    var config = configList.find(function(item) {
      return item.key === key;
    });
    config === null || config === void 0 || (_config$onClose = config.onClose) === null || _config$onClose === void 0 || _config$onClose.call(config);
    setConfigList(function(list) {
      return list.filter(function(item) {
        return item.key !== key;
      });
    });
  };
  React49.useImperativeHandle(ref, function() {
    return {
      open: function open3(config) {
        setConfigList(function(list) {
          var clone = _toConsumableArray(list);
          var index2 = clone.findIndex(function(item) {
            return item.key === config.key;
          });
          var innerConfig = _objectSpread2({}, config);
          if (index2 >= 0) {
            var _list$index;
            innerConfig.times = (((_list$index = list[index2]) === null || _list$index === void 0 ? void 0 : _list$index.times) || 0) + 1;
            clone[index2] = innerConfig;
          } else {
            innerConfig.times = 0;
            clone.push(innerConfig);
          }
          if (maxCount > 0 && clone.length > maxCount) {
            clone = clone.slice(-maxCount);
          }
          return clone;
        });
      },
      close: function close(key) {
        onNoticeClose(key);
      },
      destroy: function destroy3() {
        setConfigList([]);
      }
    };
  });
  var _React$useState3 = React49.useState({}), _React$useState4 = _slicedToArray(_React$useState3, 2), placements2 = _React$useState4[0], setPlacements = _React$useState4[1];
  React49.useEffect(function() {
    var nextPlacements = {};
    configList.forEach(function(config) {
      var _config$placement = config.placement, placement = _config$placement === void 0 ? "topRight" : _config$placement;
      if (placement) {
        nextPlacements[placement] = nextPlacements[placement] || [];
        nextPlacements[placement].push(config);
      }
    });
    Object.keys(placements2).forEach(function(placement) {
      nextPlacements[placement] = nextPlacements[placement] || [];
    });
    setPlacements(nextPlacements);
  }, [configList]);
  var onAllNoticeRemoved = function onAllNoticeRemoved2(placement) {
    setPlacements(function(originPlacements) {
      var clone = _objectSpread2({}, originPlacements);
      var list = clone[placement] || [];
      if (!list.length) {
        delete clone[placement];
      }
      return clone;
    });
  };
  var emptyRef = React49.useRef(false);
  React49.useEffect(function() {
    if (Object.keys(placements2).length > 0) {
      emptyRef.current = true;
    } else if (emptyRef.current) {
      onAllRemoved === null || onAllRemoved === void 0 || onAllRemoved();
      emptyRef.current = false;
    }
  }, [placements2]);
  if (!container) {
    return null;
  }
  var placementList = Object.keys(placements2);
  return /* @__PURE__ */ (0, import_react_dom2.createPortal)(/* @__PURE__ */ React49.createElement(React49.Fragment, null, placementList.map(function(placement) {
    var placementConfigList = placements2[placement];
    var list = /* @__PURE__ */ React49.createElement(NoticeList_default, {
      key: placement,
      configList: placementConfigList,
      placement,
      prefixCls,
      className: className === null || className === void 0 ? void 0 : className(placement),
      style: style2 === null || style2 === void 0 ? void 0 : style2(placement),
      motion,
      onNoticeClose,
      onAllNoticeRemoved,
      stack
    });
    return renderNotifications3 ? renderNotifications3(list, {
      prefixCls,
      key: placement
    }) : list;
  })), container);
});
if (process.env.NODE_ENV !== "production") {
  Notifications.displayName = "Notifications";
}
var Notifications_default = Notifications;

// ../../node_modules/rc-notification/es/hooks/useNotification.js
var _excluded6 = ["getContainer", "motion", "prefixCls", "maxCount", "className", "style", "onAllRemoved", "stack", "renderNotifications"];
var defaultGetContainer = function defaultGetContainer2() {
  return document.body;
};
var uniqueKey = 0;
function mergeConfig() {
  var clone = {};
  for (var _len = arguments.length, objList = new Array(_len), _key = 0; _key < _len; _key++) {
    objList[_key] = arguments[_key];
  }
  objList.forEach(function(obj) {
    if (obj) {
      Object.keys(obj).forEach(function(key) {
        var val = obj[key];
        if (val !== void 0) {
          clone[key] = val;
        }
      });
    }
  });
  return clone;
}
function useNotification() {
  var rootConfig = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var _rootConfig$getContai = rootConfig.getContainer, getContainer2 = _rootConfig$getContai === void 0 ? defaultGetContainer : _rootConfig$getContai, motion = rootConfig.motion, prefixCls = rootConfig.prefixCls, maxCount = rootConfig.maxCount, className = rootConfig.className, style2 = rootConfig.style, onAllRemoved = rootConfig.onAllRemoved, stack = rootConfig.stack, renderNotifications3 = rootConfig.renderNotifications, shareConfig = _objectWithoutProperties(rootConfig, _excluded6);
  var _React$useState = React50.useState(), _React$useState2 = _slicedToArray(_React$useState, 2), container = _React$useState2[0], setContainer = _React$useState2[1];
  var notificationsRef = React50.useRef();
  var contextHolder = /* @__PURE__ */ React50.createElement(Notifications_default, {
    container,
    ref: notificationsRef,
    prefixCls,
    motion,
    maxCount,
    className,
    style: style2,
    onAllRemoved,
    stack,
    renderNotifications: renderNotifications3
  });
  var _React$useState3 = React50.useState([]), _React$useState4 = _slicedToArray(_React$useState3, 2), taskQueue3 = _React$useState4[0], setTaskQueue = _React$useState4[1];
  var api = React50.useMemo(function() {
    return {
      open: function open3(config) {
        var mergedConfig = mergeConfig(shareConfig, config);
        if (mergedConfig.key === null || mergedConfig.key === void 0) {
          mergedConfig.key = "rc-notification-".concat(uniqueKey);
          uniqueKey += 1;
        }
        setTaskQueue(function(queue) {
          return [].concat(_toConsumableArray(queue), [{
            type: "open",
            config: mergedConfig
          }]);
        });
      },
      close: function close(key) {
        setTaskQueue(function(queue) {
          return [].concat(_toConsumableArray(queue), [{
            type: "close",
            key
          }]);
        });
      },
      destroy: function destroy3() {
        setTaskQueue(function(queue) {
          return [].concat(_toConsumableArray(queue), [{
            type: "destroy"
          }]);
        });
      }
    };
  }, []);
  React50.useEffect(function() {
    setContainer(getContainer2());
  });
  React50.useEffect(function() {
    if (notificationsRef.current && taskQueue3.length) {
      taskQueue3.forEach(function(task) {
        switch (task.type) {
          case "open":
            notificationsRef.current.open(task.config);
            break;
          case "close":
            notificationsRef.current.close(task.key);
            break;
          case "destroy":
            notificationsRef.current.destroy();
            break;
        }
      });
      setTaskQueue(function(oriQueue) {
        return oriQueue.filter(function(task) {
          return !taskQueue3.includes(task);
        });
      });
    }
  }, [taskQueue3]);
  return [api, contextHolder];
}

// ../../node_modules/@ant-design/icons/es/icons/LoadingOutlined.js
var React51 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/LoadingOutlined.js
var LoadingOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 1024 1024", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 00-94.3-139.9 437.71 437.71 0 00-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z" } }] }, "name": "loading", "theme": "outlined" };
var LoadingOutlined_default = LoadingOutlined;

// ../../node_modules/@ant-design/icons/es/icons/LoadingOutlined.js
var LoadingOutlined2 = function LoadingOutlined3(props, ref) {
  return /* @__PURE__ */ React51.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: LoadingOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  LoadingOutlined2.displayName = "LoadingOutlined";
}
var LoadingOutlined_default2 = /* @__PURE__ */ React51.forwardRef(LoadingOutlined2);

// ../../node_modules/antd/es/message/PurePanel.js
var import_classnames5 = __toESM(require_classnames());
var React54 = __toESM(require("react"));

// ../../node_modules/antd/es/_util/hooks/useZIndex.js
var import_react21 = __toESM(require("react"));

// ../../node_modules/antd/es/_util/zindexContext.js
var import_react20 = __toESM(require("react"));
var zIndexContext = /* @__PURE__ */ import_react20.default.createContext(void 0);
if (process.env.NODE_ENV !== "production") {
  zIndexContext.displayName = "zIndexContext";
}
var zindexContext_default = zIndexContext;

// ../../node_modules/antd/es/_util/hooks/useZIndex.js
var CONTAINER_OFFSET = 100;
var CONTAINER_OFFSET_MAX_COUNT = 10;
var CONTAINER_MAX_OFFSET = CONTAINER_OFFSET * CONTAINER_OFFSET_MAX_COUNT;
var containerBaseZIndexOffset = {
  Modal: CONTAINER_OFFSET,
  Drawer: CONTAINER_OFFSET,
  Popover: CONTAINER_OFFSET,
  Popconfirm: CONTAINER_OFFSET,
  Tooltip: CONTAINER_OFFSET,
  Tour: CONTAINER_OFFSET
};
var consumerBaseZIndexOffset = {
  SelectLike: 50,
  Dropdown: 50,
  DatePicker: 50,
  Menu: 50,
  ImagePreview: 1
};
function isContainerType(type4) {
  return type4 in containerBaseZIndexOffset;
}
function useZIndex(componentType, customZIndex) {
  const [, token2] = useToken();
  const parentZIndex = import_react21.default.useContext(zindexContext_default);
  const isContainer = isContainerType(componentType);
  if (customZIndex !== void 0) {
    return [customZIndex, customZIndex];
  }
  let zIndex = parentZIndex !== null && parentZIndex !== void 0 ? parentZIndex : 0;
  if (isContainer) {
    zIndex += // Use preset token zIndex by default but not stack when has parent container
    (parentZIndex ? 0 : token2.zIndexPopupBase) + // Container offset
    containerBaseZIndexOffset[componentType];
    zIndex = Math.min(zIndex, token2.zIndexPopupBase + CONTAINER_MAX_OFFSET);
  } else {
    zIndex += consumerBaseZIndexOffset[componentType];
  }
  return [parentZIndex === void 0 ? customZIndex : zIndex, zIndex];
}

// ../../node_modules/antd/es/message/style/index.js
var genMessageStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    boxShadow,
    colorText,
    colorSuccess,
    colorError,
    colorWarning,
    colorInfo,
    fontSizeLG,
    motionEaseInOutCirc,
    motionDurationSlow,
    marginXS,
    paddingXS,
    borderRadiusLG,
    zIndexPopup,
    // Custom token
    contentPadding,
    contentBg
  } = token2;
  const noticeCls = `${componentCls}-notice`;
  const messageMoveIn = new Keyframes_default("MessageMoveIn", {
    "0%": {
      padding: 0,
      transform: "translateY(-100%)",
      opacity: 0
    },
    "100%": {
      padding: paddingXS,
      transform: "translateY(0)",
      opacity: 1
    }
  });
  const messageMoveOut = new Keyframes_default("MessageMoveOut", {
    "0%": {
      maxHeight: token2.height,
      padding: paddingXS,
      opacity: 1
    },
    "100%": {
      maxHeight: 0,
      padding: 0,
      opacity: 0
    }
  });
  const noticeStyle = {
    padding: paddingXS,
    textAlign: "center",
    [`${componentCls}-custom-content > ${iconCls}`]: {
      verticalAlign: "text-bottom",
      marginInlineEnd: marginXS,
      // affected by ltr or rtl
      fontSize: fontSizeLG
    },
    [`${noticeCls}-content`]: {
      display: "inline-block",
      padding: contentPadding,
      background: contentBg,
      borderRadius: borderRadiusLG,
      boxShadow,
      pointerEvents: "all"
    },
    [`${componentCls}-success > ${iconCls}`]: {
      color: colorSuccess
    },
    [`${componentCls}-error > ${iconCls}`]: {
      color: colorError
    },
    [`${componentCls}-warning > ${iconCls}`]: {
      color: colorWarning
    },
    [`${componentCls}-info > ${iconCls},
      ${componentCls}-loading > ${iconCls}`]: {
      color: colorInfo
    }
  };
  return [
    // ============================ Holder ============================
    {
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        color: colorText,
        position: "fixed",
        top: marginXS,
        width: "100%",
        pointerEvents: "none",
        zIndex: zIndexPopup,
        [`${componentCls}-move-up`]: {
          animationFillMode: "forwards"
        },
        [`
        ${componentCls}-move-up-appear,
        ${componentCls}-move-up-enter
      `]: {
          animationName: messageMoveIn,
          animationDuration: motionDurationSlow,
          animationPlayState: "paused",
          animationTimingFunction: motionEaseInOutCirc
        },
        [`
        ${componentCls}-move-up-appear${componentCls}-move-up-appear-active,
        ${componentCls}-move-up-enter${componentCls}-move-up-enter-active
      `]: {
          animationPlayState: "running"
        },
        [`${componentCls}-move-up-leave`]: {
          animationName: messageMoveOut,
          animationDuration: motionDurationSlow,
          animationPlayState: "paused",
          animationTimingFunction: motionEaseInOutCirc
        },
        [`${componentCls}-move-up-leave${componentCls}-move-up-leave-active`]: {
          animationPlayState: "running"
        },
        "&-rtl": {
          direction: "rtl",
          span: {
            direction: "rtl"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [componentCls]: {
        [`${noticeCls}-wrapper`]: Object.assign({}, noticeStyle)
      }
    },
    // ============================= Pure =============================
    {
      [`${componentCls}-notice-pure-panel`]: Object.assign(Object.assign({}, noticeStyle), {
        padding: 0,
        textAlign: "start"
      })
    }
  ];
};
var prepareComponentToken = (token2) => ({
  zIndexPopup: token2.zIndexPopupBase + CONTAINER_MAX_OFFSET + 10,
  contentBg: token2.colorBgElevated,
  contentPadding: `${(token2.controlHeightLG - token2.fontSize * token2.lineHeight) / 2}px ${token2.paddingSM}px`
});
var style_default = genStyleHooks("Message", (token2) => {
  const combinedToken = merge2(token2, {
    height: 150
  });
  return [genMessageStyle(combinedToken)];
}, prepareComponentToken);

// ../../node_modules/antd/es/message/PurePanel.js
var __rest4 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var TypeIcon = {
  info: /* @__PURE__ */ React54.createElement(InfoCircleFilled_default2, null),
  success: /* @__PURE__ */ React54.createElement(CheckCircleFilled_default2, null),
  error: /* @__PURE__ */ React54.createElement(CloseCircleFilled_default2, null),
  warning: /* @__PURE__ */ React54.createElement(ExclamationCircleFilled_default2, null),
  loading: /* @__PURE__ */ React54.createElement(LoadingOutlined_default2, null)
};
var PureContent = (_ref) => {
  let {
    prefixCls,
    type: type4,
    icon,
    children
  } = _ref;
  return /* @__PURE__ */ React54.createElement("div", {
    className: (0, import_classnames5.default)(`${prefixCls}-custom-content`, `${prefixCls}-${type4}`)
  }, icon || TypeIcon[type4], /* @__PURE__ */ React54.createElement("span", null, children));
};
var PurePanel = (props) => {
  const {
    prefixCls: staticPrefixCls,
    className,
    type: type4,
    icon,
    content
  } = props, restProps = __rest4(props, ["prefixCls", "className", "type", "icon", "content"]);
  const {
    getPrefixCls
  } = React54.useContext(ConfigContext);
  const prefixCls = staticPrefixCls || getPrefixCls("message");
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default(prefixCls, rootCls);
  return wrapCSSVar(/* @__PURE__ */ React54.createElement(Notice_default, Object.assign({}, restProps, {
    prefixCls,
    className: (0, import_classnames5.default)(className, hashId, `${prefixCls}-notice-pure-panel`, cssVarCls, rootCls),
    eventKey: "pure",
    duration: null,
    content: /* @__PURE__ */ React54.createElement(PureContent, {
      prefixCls,
      type: type4,
      icon
    }, content)
  })));
};
var PurePanel_default = PurePanel;

// ../../node_modules/antd/es/message/util.js
function getMotion(prefixCls, transitionName) {
  return {
    motionName: transitionName !== null && transitionName !== void 0 ? transitionName : `${prefixCls}-move-up`
  };
}
function wrapPromiseFn(openFn) {
  let closeFn;
  const closePromise = new Promise((resolve) => {
    closeFn = openFn(() => {
      resolve(true);
    });
  });
  const result = () => {
    closeFn === null || closeFn === void 0 ? void 0 : closeFn();
  };
  result.then = (filled, rejected) => closePromise.then(filled, rejected);
  result.promise = closePromise;
  return result;
}

// ../../node_modules/antd/es/message/useMessage.js
var __rest5 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var DEFAULT_OFFSET2 = 8;
var DEFAULT_DURATION = 3;
var Wrapper = (_ref) => {
  let {
    children,
    prefixCls
  } = _ref;
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default(prefixCls, rootCls);
  return wrapCSSVar(/* @__PURE__ */ React55.createElement(NotificationProvider_default, {
    classNames: {
      list: (0, import_classnames6.default)(hashId, cssVarCls, rootCls)
    }
  }, children));
};
var renderNotifications = (node2, _ref2) => {
  let {
    prefixCls,
    key
  } = _ref2;
  return /* @__PURE__ */ React55.createElement(Wrapper, {
    prefixCls,
    key
  }, node2);
};
var Holder = /* @__PURE__ */ React55.forwardRef((props, ref) => {
  const {
    top,
    prefixCls: staticPrefixCls,
    getContainer: staticGetContainer,
    maxCount,
    duration = DEFAULT_DURATION,
    rtl,
    transitionName,
    onAllRemoved
  } = props;
  const {
    getPrefixCls,
    getPopupContainer,
    message: message2,
    direction
  } = React55.useContext(ConfigContext);
  const prefixCls = staticPrefixCls || getPrefixCls("message");
  const getStyle3 = () => ({
    left: "50%",
    transform: "translateX(-50%)",
    top: top !== null && top !== void 0 ? top : DEFAULT_OFFSET2
  });
  const getClassName = () => (0, import_classnames6.default)({
    [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === "rtl"
  });
  const getNotificationMotion = () => getMotion(prefixCls, transitionName);
  const mergedCloseIcon = /* @__PURE__ */ React55.createElement("span", {
    className: `${prefixCls}-close-x`
  }, /* @__PURE__ */ React55.createElement(CloseOutlined_default2, {
    className: `${prefixCls}-close-icon`
  }));
  const [api, holder] = useNotification({
    prefixCls,
    style: getStyle3,
    className: getClassName,
    motion: getNotificationMotion,
    closable: false,
    closeIcon: mergedCloseIcon,
    duration,
    getContainer: () => (staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
    maxCount,
    onAllRemoved,
    renderNotifications
  });
  React55.useImperativeHandle(ref, () => Object.assign(Object.assign({}, api), {
    prefixCls,
    message: message2
  }));
  return holder;
});
var keyIndex = 0;
function useInternalMessage(messageConfig) {
  const holderRef = React55.useRef(null);
  const warning6 = devUseWarning("Message");
  const wrapAPI = React55.useMemo(() => {
    const close = (key) => {
      var _a;
      (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.close(key);
    };
    const open3 = (config) => {
      if (!holderRef.current) {
        process.env.NODE_ENV !== "production" ? warning6(false, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.") : void 0;
        const fakeResult = () => {
        };
        fakeResult.then = () => {
        };
        return fakeResult;
      }
      const {
        open: originOpen,
        prefixCls,
        message: message2
      } = holderRef.current;
      const noticePrefixCls = `${prefixCls}-notice`;
      const {
        content,
        icon,
        type: type4,
        key,
        className,
        style: style2,
        onClose
      } = config, restConfig = __rest5(config, ["content", "icon", "type", "key", "className", "style", "onClose"]);
      let mergedKey = key;
      if (mergedKey === void 0 || mergedKey === null) {
        keyIndex += 1;
        mergedKey = `antd-message-${keyIndex}`;
      }
      return wrapPromiseFn((resolve) => {
        originOpen(Object.assign(Object.assign({}, restConfig), {
          key: mergedKey,
          content: /* @__PURE__ */ React55.createElement(PureContent, {
            prefixCls,
            type: type4,
            icon
          }, content),
          placement: "top",
          className: (0, import_classnames6.default)(type4 && `${noticePrefixCls}-${type4}`, className, message2 === null || message2 === void 0 ? void 0 : message2.className),
          style: Object.assign(Object.assign({}, message2 === null || message2 === void 0 ? void 0 : message2.style), style2),
          onClose: () => {
            onClose === null || onClose === void 0 ? void 0 : onClose();
            resolve();
          }
        }));
        return () => {
          close(mergedKey);
        };
      });
    };
    const destroy3 = (key) => {
      var _a;
      if (key !== void 0) {
        close(key);
      } else {
        (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.destroy();
      }
    };
    const clone = {
      open: open3,
      destroy: destroy3
    };
    const keys3 = ["info", "success", "warning", "error", "loading"];
    keys3.forEach((type4) => {
      const typeOpen2 = (jointContent, duration, onClose) => {
        let config;
        if (jointContent && typeof jointContent === "object" && "content" in jointContent) {
          config = jointContent;
        } else {
          config = {
            content: jointContent
          };
        }
        let mergedDuration;
        let mergedOnClose;
        if (typeof duration === "function") {
          mergedOnClose = duration;
        } else {
          mergedDuration = duration;
          mergedOnClose = onClose;
        }
        const mergedConfig = Object.assign(Object.assign({
          onClose: mergedOnClose,
          duration: mergedDuration
        }, config), {
          type: type4
        });
        return open3(mergedConfig);
      };
      clone[type4] = typeOpen2;
    });
    return clone;
  }, []);
  return [wrapAPI, /* @__PURE__ */ React55.createElement(Holder, Object.assign({
    key: "message-holder"
  }, messageConfig, {
    ref: holderRef
  }))];
}
function useMessage(messageConfig) {
  return useInternalMessage(messageConfig);
}

// ../../node_modules/antd/es/modal/useModal/index.js
var React102 = __toESM(require("react"));

// ../../node_modules/antd/es/_util/hooks/usePatchElement.js
var React56 = __toESM(require("react"));
function usePatchElement() {
  const [elements, setElements] = React56.useState([]);
  const patchElement = React56.useCallback((element) => {
    setElements((originElements) => [].concat(_toConsumableArray(originElements), [element]));
    return () => {
      setElements((originElements) => originElements.filter((ele) => ele !== element));
    };
  }, []);
  return [elements, patchElement];
}

// ../../node_modules/antd/es/modal/confirm.js
var import_react40 = __toESM(require("react"));

// ../../node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js
function _regeneratorRuntime() {
  "use strict";
  _regeneratorRuntime = function _regeneratorRuntime2() {
    return e;
  };
  var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t2, e2, r2) {
    t2[e2] = r2.value;
  }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
  function define2(t2, e2, r2) {
    return Object.defineProperty(t2, e2, {
      value: r2,
      enumerable: true,
      configurable: true,
      writable: true
    }), t2[e2];
  }
  try {
    define2({}, "");
  } catch (t2) {
    define2 = function define3(t3, e2, r2) {
      return t3[e2] = r2;
    };
  }
  function wrap(t2, e2, r2, n2) {
    var i2 = e2 && e2.prototype instanceof Generator ? e2 : Generator, a2 = Object.create(i2.prototype), c2 = new Context3(n2 || []);
    return o(a2, "_invoke", {
      value: makeInvokeMethod(t2, r2, c2)
    }), a2;
  }
  function tryCatch(t2, e2, r2) {
    try {
      return {
        type: "normal",
        arg: t2.call(e2, r2)
      };
    } catch (t3) {
      return {
        type: "throw",
        arg: t3
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart", l = "suspendedYield", f = "executing", s2 = "completed", y2 = {};
  function Generator() {
  }
  function GeneratorFunction() {
  }
  function GeneratorFunctionPrototype() {
  }
  var p = {};
  define2(p, a, function() {
    return this;
  });
  var d = Object.getPrototypeOf, v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t2) {
    ["next", "throw", "return"].forEach(function(e2) {
      define2(t2, e2, function(t3) {
        return this._invoke(e2, t3);
      });
    });
  }
  function AsyncIterator2(t2, e2) {
    function invoke(r3, o2, i2, a2) {
      var c2 = tryCatch(t2[r3], t2, o2);
      if ("throw" !== c2.type) {
        var u2 = c2.arg, h2 = u2.value;
        return h2 && "object" == _typeof(h2) && n.call(h2, "__await") ? e2.resolve(h2.__await).then(function(t3) {
          invoke("next", t3, i2, a2);
        }, function(t3) {
          invoke("throw", t3, i2, a2);
        }) : e2.resolve(h2).then(function(t3) {
          u2.value = t3, i2(u2);
        }, function(t3) {
          return invoke("throw", t3, i2, a2);
        });
      }
      a2(c2.arg);
    }
    var r2;
    o(this, "_invoke", {
      value: function value(t3, n2) {
        function callInvokeWithMethodAndArg() {
          return new e2(function(e3, r3) {
            invoke(t3, n2, e3, r3);
          });
        }
        return r2 = r2 ? r2.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e2, r2, n2) {
    var o2 = h;
    return function(i2, a2) {
      if (o2 === f)
        throw new Error("Generator is already running");
      if (o2 === s2) {
        if ("throw" === i2)
          throw a2;
        return {
          value: t,
          done: true
        };
      }
      for (n2.method = i2, n2.arg = a2; ; ) {
        var c2 = n2.delegate;
        if (c2) {
          var u2 = maybeInvokeDelegate(c2, n2);
          if (u2) {
            if (u2 === y2)
              continue;
            return u2;
          }
        }
        if ("next" === n2.method)
          n2.sent = n2._sent = n2.arg;
        else if ("throw" === n2.method) {
          if (o2 === h)
            throw o2 = s2, n2.arg;
          n2.dispatchException(n2.arg);
        } else
          "return" === n2.method && n2.abrupt("return", n2.arg);
        o2 = f;
        var p2 = tryCatch(e2, r2, n2);
        if ("normal" === p2.type) {
          if (o2 = n2.done ? s2 : l, p2.arg === y2)
            continue;
          return {
            value: p2.arg,
            done: n2.done
          };
        }
        "throw" === p2.type && (o2 = s2, n2.method = "throw", n2.arg = p2.arg);
      }
    };
  }
  function maybeInvokeDelegate(e2, r2) {
    var n2 = r2.method, o2 = e2.iterator[n2];
    if (o2 === t)
      return r2.delegate = null, "throw" === n2 && e2.iterator["return"] && (r2.method = "return", r2.arg = t, maybeInvokeDelegate(e2, r2), "throw" === r2.method) || "return" !== n2 && (r2.method = "throw", r2.arg = new TypeError("The iterator does not provide a '" + n2 + "' method")), y2;
    var i2 = tryCatch(o2, e2.iterator, r2.arg);
    if ("throw" === i2.type)
      return r2.method = "throw", r2.arg = i2.arg, r2.delegate = null, y2;
    var a2 = i2.arg;
    return a2 ? a2.done ? (r2[e2.resultName] = a2.value, r2.next = e2.nextLoc, "return" !== r2.method && (r2.method = "next", r2.arg = t), r2.delegate = null, y2) : a2 : (r2.method = "throw", r2.arg = new TypeError("iterator result is not an object"), r2.delegate = null, y2);
  }
  function pushTryEntry(t2) {
    var e2 = {
      tryLoc: t2[0]
    };
    1 in t2 && (e2.catchLoc = t2[1]), 2 in t2 && (e2.finallyLoc = t2[2], e2.afterLoc = t2[3]), this.tryEntries.push(e2);
  }
  function resetTryEntry(t2) {
    var e2 = t2.completion || {};
    e2.type = "normal", delete e2.arg, t2.completion = e2;
  }
  function Context3(t2) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t2.forEach(pushTryEntry, this), this.reset(true);
  }
  function values(e2) {
    if (e2 || "" === e2) {
      var r2 = e2[a];
      if (r2)
        return r2.call(e2);
      if ("function" == typeof e2.next)
        return e2;
      if (!isNaN(e2.length)) {
        var o2 = -1, i2 = function next2() {
          for (; ++o2 < e2.length; )
            if (n.call(e2, o2))
              return next2.value = e2[o2], next2.done = false, next2;
          return next2.value = t, next2.done = true, next2;
        };
        return i2.next = i2;
      }
    }
    throw new TypeError(_typeof(e2) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: true
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: true
  }), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t2) {
    var e2 = "function" == typeof t2 && t2.constructor;
    return !!e2 && (e2 === GeneratorFunction || "GeneratorFunction" === (e2.displayName || e2.name));
  }, e.mark = function(t2) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t2, GeneratorFunctionPrototype) : (t2.__proto__ = GeneratorFunctionPrototype, define2(t2, u, "GeneratorFunction")), t2.prototype = Object.create(g), t2;
  }, e.awrap = function(t2) {
    return {
      __await: t2
    };
  }, defineIteratorMethods(AsyncIterator2.prototype), define2(AsyncIterator2.prototype, c, function() {
    return this;
  }), e.AsyncIterator = AsyncIterator2, e.async = function(t2, r2, n2, o2, i2) {
    void 0 === i2 && (i2 = Promise);
    var a2 = new AsyncIterator2(wrap(t2, r2, n2, o2), i2);
    return e.isGeneratorFunction(r2) ? a2 : a2.next().then(function(t3) {
      return t3.done ? t3.value : a2.next();
    });
  }, defineIteratorMethods(g), define2(g, u, "Generator"), define2(g, a, function() {
    return this;
  }), define2(g, "toString", function() {
    return "[object Generator]";
  }), e.keys = function(t2) {
    var e2 = Object(t2), r2 = [];
    for (var n2 in e2)
      r2.push(n2);
    return r2.reverse(), function next2() {
      for (; r2.length; ) {
        var t3 = r2.pop();
        if (t3 in e2)
          return next2.value = t3, next2.done = false, next2;
      }
      return next2.done = true, next2;
    };
  }, e.values = values, Context3.prototype = {
    constructor: Context3,
    reset: function reset(e2) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = false, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e2)
        for (var r2 in this)
          "t" === r2.charAt(0) && n.call(this, r2) && !isNaN(+r2.slice(1)) && (this[r2] = t);
    },
    stop: function stop() {
      this.done = true;
      var t2 = this.tryEntries[0].completion;
      if ("throw" === t2.type)
        throw t2.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e2) {
      if (this.done)
        throw e2;
      var r2 = this;
      function handle(n2, o3) {
        return a2.type = "throw", a2.arg = e2, r2.next = n2, o3 && (r2.method = "next", r2.arg = t), !!o3;
      }
      for (var o2 = this.tryEntries.length - 1; o2 >= 0; --o2) {
        var i2 = this.tryEntries[o2], a2 = i2.completion;
        if ("root" === i2.tryLoc)
          return handle("end");
        if (i2.tryLoc <= this.prev) {
          var c2 = n.call(i2, "catchLoc"), u2 = n.call(i2, "finallyLoc");
          if (c2 && u2) {
            if (this.prev < i2.catchLoc)
              return handle(i2.catchLoc, true);
            if (this.prev < i2.finallyLoc)
              return handle(i2.finallyLoc);
          } else if (c2) {
            if (this.prev < i2.catchLoc)
              return handle(i2.catchLoc, true);
          } else {
            if (!u2)
              throw new Error("try statement without catch or finally");
            if (this.prev < i2.finallyLoc)
              return handle(i2.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t2, e2) {
      for (var r2 = this.tryEntries.length - 1; r2 >= 0; --r2) {
        var o2 = this.tryEntries[r2];
        if (o2.tryLoc <= this.prev && n.call(o2, "finallyLoc") && this.prev < o2.finallyLoc) {
          var i2 = o2;
          break;
        }
      }
      i2 && ("break" === t2 || "continue" === t2) && i2.tryLoc <= e2 && e2 <= i2.finallyLoc && (i2 = null);
      var a2 = i2 ? i2.completion : {};
      return a2.type = t2, a2.arg = e2, i2 ? (this.method = "next", this.next = i2.finallyLoc, y2) : this.complete(a2);
    },
    complete: function complete(t2, e2) {
      if ("throw" === t2.type)
        throw t2.arg;
      return "break" === t2.type || "continue" === t2.type ? this.next = t2.arg : "return" === t2.type ? (this.rval = this.arg = t2.arg, this.method = "return", this.next = "end") : "normal" === t2.type && e2 && (this.next = e2), y2;
    },
    finish: function finish(t2) {
      for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
        var r2 = this.tryEntries[e2];
        if (r2.finallyLoc === t2)
          return this.complete(r2.completion, r2.afterLoc), resetTryEntry(r2), y2;
      }
    },
    "catch": function _catch(t2) {
      for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
        var r2 = this.tryEntries[e2];
        if (r2.tryLoc === t2) {
          var n2 = r2.completion;
          if ("throw" === n2.type) {
            var o2 = n2.arg;
            resetTryEntry(r2);
          }
          return o2;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e2, r2, n2) {
      return this.delegate = {
        iterator: values(e2),
        resultName: r2,
        nextLoc: n2
      }, "next" === this.method && (this.arg = t), y2;
    }
  }, e;
}

// ../../node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function() {
    var self2 = this, args = arguments;
    return new Promise(function(resolve, reject) {
      var gen = fn.apply(self2, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(void 0);
    });
  };
}

// ../../node_modules/rc-util/es/React/render.js
var ReactDOM2 = __toESM(require("react-dom"));
var fullClone4 = _objectSpread2({}, ReactDOM2);
var version = fullClone4.version;
var reactRender = fullClone4.render;
var unmountComponentAtNode = fullClone4.unmountComponentAtNode;
var createRoot;
try {
  mainVersion = Number((version || "").split(".")[0]);
  if (mainVersion >= 18) {
    createRoot = fullClone4.createRoot;
  }
} catch (e) {
}
var mainVersion;
function toggleWarning(skip) {
  var __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = fullClone4.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
  if (__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED && _typeof(__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === "object") {
    __SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.usingClientEntryPoint = skip;
  }
}
var MARK = "__rc_react_root__";
function modernRender(node2, container) {
  toggleWarning(true);
  var root = container[MARK] || createRoot(container);
  toggleWarning(false);
  root.render(node2);
  container[MARK] = root;
}
function legacyRender(node2, container) {
  reactRender(node2, container);
}
function render(node2, container) {
  if (createRoot) {
    modernRender(node2, container);
    return;
  }
  legacyRender(node2, container);
}
function modernUnmount(_x) {
  return _modernUnmount.apply(this, arguments);
}
function _modernUnmount() {
  _modernUnmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(container) {
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1)
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", Promise.resolve().then(function() {
              var _container$MARK;
              (_container$MARK = container[MARK]) === null || _container$MARK === void 0 || _container$MARK.unmount();
              delete container[MARK];
            }));
          case 1:
          case "end":
            return _context.stop();
        }
    }, _callee);
  }));
  return _modernUnmount.apply(this, arguments);
}
function legacyUnmount(container) {
  unmountComponentAtNode(container);
}
function unmount(_x2) {
  return _unmount.apply(this, arguments);
}
function _unmount() {
  _unmount = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(container) {
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1)
        switch (_context2.prev = _context2.next) {
          case 0:
            if (!(createRoot !== void 0)) {
              _context2.next = 2;
              break;
            }
            return _context2.abrupt("return", modernUnmount(container));
          case 2:
            legacyUnmount(container);
          case 3:
          case "end":
            return _context2.stop();
        }
    }, _callee2);
  }));
  return _unmount.apply(this, arguments);
}

// ../../node_modules/antd/es/modal/ConfirmDialog.js
var React99 = __toESM(require("react"));
var import_classnames19 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/motion.js
var getTransitionName2 = (rootPrefixCls, motion, transitionName) => {
  if (transitionName !== void 0) {
    return transitionName;
  }
  return `${rootPrefixCls}-${motion}`;
};

// ../../node_modules/antd/es/modal/components/ConfirmCancelBtn.js
var import_react29 = __toESM(require("react"));

// ../../node_modules/antd/es/_util/ActionButton.js
var React67 = __toESM(require("react"));

// ../../node_modules/antd/es/button/button.js
var import_react27 = __toESM(require("react"));
var import_classnames13 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/wave/index.js
var import_classnames8 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/Dom/isVisible.js
var isVisible_default = function(element) {
  if (!element) {
    return false;
  }
  if (element instanceof Element) {
    if (element.offsetParent) {
      return true;
    }
    if (element.getBBox) {
      var _getBBox = element.getBBox(), width = _getBBox.width, height = _getBBox.height;
      if (width || height) {
        return true;
      }
    }
    if (element.getBoundingClientRect) {
      var _element$getBoundingC = element.getBoundingClientRect(), _width = _element$getBoundingC.width, _height = _element$getBoundingC.height;
      if (_width || _height) {
        return true;
      }
    }
  }
  return false;
};

// ../../node_modules/antd/es/_util/wave/index.js
var import_react22 = __toESM(require("react"));

// ../../node_modules/antd/es/_util/wave/style.js
var genWaveStyle = (token2) => {
  const {
    componentCls,
    colorPrimary
  } = token2;
  return {
    [componentCls]: {
      position: "absolute",
      background: "transparent",
      pointerEvents: "none",
      boxSizing: "border-box",
      color: `var(--wave-color, ${colorPrimary})`,
      boxShadow: `0 0 0 0 currentcolor`,
      opacity: 0.2,
      // =================== Motion ===================
      "&.wave-motion-appear": {
        transition: [`box-shadow 0.4s ${token2.motionEaseOutCirc}`, `opacity 2s ${token2.motionEaseOutCirc}`].join(","),
        "&-active": {
          boxShadow: `0 0 0 6px currentcolor`,
          opacity: 0
        },
        "&.wave-quick": {
          transition: [`box-shadow 0.3s ${token2.motionEaseInOut}`, `opacity 0.35s ${token2.motionEaseInOut}`].join(",")
        }
      }
    }
  };
};
var style_default2 = genComponentStyleHook("Wave", (token2) => [genWaveStyle(token2)]);

// ../../node_modules/antd/es/_util/wave/useWave.js
var React58 = __toESM(require("react"));

// ../../node_modules/antd/es/_util/wave/WaveEffect.js
var import_classnames7 = __toESM(require_classnames());
var React57 = __toESM(require("react"));

// ../../node_modules/antd/es/_util/wave/util.js
function isNotGrey(color2) {
  const match2 = (color2 || "").match(/rgba?\((\d*), (\d*), (\d*)(, [\d.]*)?\)/);
  if (match2 && match2[1] && match2[2] && match2[3]) {
    return !(match2[1] === match2[2] && match2[2] === match2[3]);
  }
  return true;
}
function isValidWaveColor(color2) {
  return color2 && color2 !== "#fff" && color2 !== "#ffffff" && color2 !== "rgb(255, 255, 255)" && color2 !== "rgba(255, 255, 255, 1)" && isNotGrey(color2) && !/rgba\((?:\d*, ){3}0\)/.test(color2) && // any transparent rgba color
  color2 !== "transparent";
}
function getTargetWaveColor(node2) {
  const {
    borderTopColor,
    borderColor,
    backgroundColor
  } = getComputedStyle(node2);
  if (isValidWaveColor(borderTopColor)) {
    return borderTopColor;
  }
  if (isValidWaveColor(borderColor)) {
    return borderColor;
  }
  if (isValidWaveColor(backgroundColor)) {
    return backgroundColor;
  }
  return null;
}

// ../../node_modules/antd/es/_util/wave/interface.js
var TARGET_CLS = "ant-wave-target";

// ../../node_modules/antd/es/_util/wave/WaveEffect.js
function validateNum(value) {
  return Number.isNaN(value) ? 0 : value;
}
var WaveEffect = (props) => {
  const {
    className,
    target,
    component
  } = props;
  const divRef = React57.useRef(null);
  const [color2, setWaveColor] = React57.useState(null);
  const [borderRadius, setBorderRadius] = React57.useState([]);
  const [left, setLeft] = React57.useState(0);
  const [top, setTop] = React57.useState(0);
  const [width, setWidth] = React57.useState(0);
  const [height, setHeight] = React57.useState(0);
  const [enabled, setEnabled] = React57.useState(false);
  const waveStyle = {
    left,
    top,
    width,
    height,
    borderRadius: borderRadius.map((radius) => `${radius}px`).join(" ")
  };
  if (color2) {
    waveStyle["--wave-color"] = color2;
  }
  function syncPos() {
    const nodeStyle = getComputedStyle(target);
    setWaveColor(getTargetWaveColor(target));
    const isStatic = nodeStyle.position === "static";
    const {
      borderLeftWidth,
      borderTopWidth
    } = nodeStyle;
    setLeft(isStatic ? target.offsetLeft : validateNum(-parseFloat(borderLeftWidth)));
    setTop(isStatic ? target.offsetTop : validateNum(-parseFloat(borderTopWidth)));
    setWidth(target.offsetWidth);
    setHeight(target.offsetHeight);
    const {
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius
    } = nodeStyle;
    setBorderRadius([borderTopLeftRadius, borderTopRightRadius, borderBottomRightRadius, borderBottomLeftRadius].map((radius) => validateNum(parseFloat(radius))));
  }
  React57.useEffect(() => {
    if (target) {
      const id = raf_default(() => {
        syncPos();
        setEnabled(true);
      });
      let resizeObserver2;
      if (typeof ResizeObserver !== "undefined") {
        resizeObserver2 = new ResizeObserver(syncPos);
        resizeObserver2.observe(target);
      }
      return () => {
        raf_default.cancel(id);
        resizeObserver2 === null || resizeObserver2 === void 0 ? void 0 : resizeObserver2.disconnect();
      };
    }
  }, []);
  if (!enabled) {
    return null;
  }
  const isSmallComponent = (component === "Checkbox" || component === "Radio") && (target === null || target === void 0 ? void 0 : target.classList.contains(TARGET_CLS));
  return /* @__PURE__ */ React57.createElement(es_default2, {
    visible: true,
    motionAppear: true,
    motionName: "wave-motion",
    motionDeadline: 5e3,
    onAppearEnd: (_, event) => {
      var _a;
      if (event.deadline || event.propertyName === "opacity") {
        const holder = (_a = divRef.current) === null || _a === void 0 ? void 0 : _a.parentElement;
        unmount(holder).then(() => {
          holder === null || holder === void 0 ? void 0 : holder.remove();
        });
      }
      return false;
    }
  }, (_ref) => {
    let {
      className: motionClassName
    } = _ref;
    return /* @__PURE__ */ React57.createElement("div", {
      ref: divRef,
      className: (0, import_classnames7.default)(className, {
        "wave-quick": isSmallComponent
      }, motionClassName),
      style: waveStyle
    });
  });
};
var showWaveEffect = (target, info) => {
  var _a;
  const {
    component
  } = info;
  if (component === "Checkbox" && !((_a = target.querySelector("input")) === null || _a === void 0 ? void 0 : _a.checked)) {
    return;
  }
  const holder = document.createElement("div");
  holder.style.position = "absolute";
  holder.style.left = "0px";
  holder.style.top = "0px";
  target === null || target === void 0 ? void 0 : target.insertBefore(holder, target === null || target === void 0 ? void 0 : target.firstChild);
  render(/* @__PURE__ */ React57.createElement(WaveEffect, Object.assign({}, info, {
    target
  })), holder);
};
var WaveEffect_default = showWaveEffect;

// ../../node_modules/antd/es/_util/wave/useWave.js
function useWave(nodeRef, className, component) {
  const {
    wave
  } = React58.useContext(ConfigContext);
  const [, token2, hashId] = useToken();
  const showWave = useEvent((event) => {
    const node2 = nodeRef.current;
    if ((wave === null || wave === void 0 ? void 0 : wave.disabled) || !node2) {
      return;
    }
    const targetNode = node2.querySelector(`.${TARGET_CLS}`) || node2;
    const {
      showEffect
    } = wave || {};
    (showEffect || WaveEffect_default)(targetNode, {
      className,
      token: token2,
      component,
      event,
      hashId
    });
  });
  const rafId = React58.useRef();
  const showDebounceWave = (event) => {
    raf_default.cancel(rafId.current);
    rafId.current = raf_default(() => {
      showWave(event);
    });
  };
  return showDebounceWave;
}

// ../../node_modules/antd/es/_util/wave/index.js
var Wave = (props) => {
  const {
    children,
    disabled,
    component
  } = props;
  const {
    getPrefixCls
  } = (0, import_react22.useContext)(ConfigContext);
  const containerRef = (0, import_react22.useRef)(null);
  const prefixCls = getPrefixCls("wave");
  const [, hashId] = style_default2(prefixCls);
  const showWave = useWave(containerRef, (0, import_classnames8.default)(prefixCls, hashId), component);
  import_react22.default.useEffect(() => {
    const node2 = containerRef.current;
    if (!node2 || node2.nodeType !== 1 || disabled) {
      return;
    }
    const onClick = (e) => {
      if (!isVisible_default(e.target) || // No need wave
      !node2.getAttribute || node2.getAttribute("disabled") || node2.disabled || node2.className.includes("disabled") || node2.className.includes("-leave")) {
        return;
      }
      showWave(e);
    };
    node2.addEventListener("click", onClick, true);
    return () => {
      node2.removeEventListener("click", onClick, true);
    };
  }, [disabled]);
  if (!/* @__PURE__ */ import_react22.default.isValidElement(children)) {
    return children !== null && children !== void 0 ? children : null;
  }
  const ref = supportRef(children) ? composeRef(children.ref, containerRef) : containerRef;
  return cloneElement4(children, {
    ref
  });
};
if (process.env.NODE_ENV !== "production") {
  Wave.displayName = "Wave";
}
var wave_default = Wave;

// ../../node_modules/antd/es/config-provider/hooks/useSize.js
var import_react23 = __toESM(require("react"));
var useSize = (customSize) => {
  const size = import_react23.default.useContext(SizeContext_default);
  const mergedSize = import_react23.default.useMemo(() => {
    if (!customSize) {
      return size;
    }
    if (typeof customSize === "string") {
      return customSize !== null && customSize !== void 0 ? customSize : size;
    }
    if (customSize instanceof Function) {
      return customSize(size);
    }
    return size;
  }, [customSize, size]);
  return mergedSize;
};
var useSize_default = useSize;

// ../../node_modules/antd/es/space/Compact.js
var import_classnames9 = __toESM(require_classnames());
var React61 = __toESM(require("react"));
var SpaceCompactItemContext = /* @__PURE__ */ React61.createContext(null);
var useCompactItemContext = (prefixCls, direction) => {
  const compactItemContext = React61.useContext(SpaceCompactItemContext);
  const compactItemClassnames = React61.useMemo(() => {
    if (!compactItemContext) {
      return "";
    }
    const {
      compactDirection,
      isFirstItem,
      isLastItem
    } = compactItemContext;
    const separator = compactDirection === "vertical" ? "-vertical-" : "-";
    return (0, import_classnames9.default)(`${prefixCls}-compact${separator}item`, {
      [`${prefixCls}-compact${separator}first-item`]: isFirstItem,
      [`${prefixCls}-compact${separator}last-item`]: isLastItem,
      [`${prefixCls}-compact${separator}item-rtl`]: direction === "rtl"
    });
  }, [prefixCls, direction, compactItemContext]);
  return {
    compactSize: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactSize,
    compactDirection: compactItemContext === null || compactItemContext === void 0 ? void 0 : compactItemContext.compactDirection,
    compactItemClassnames
  };
};
var NoCompactStyle = (_ref) => {
  let {
    children
  } = _ref;
  return /* @__PURE__ */ React61.createElement(SpaceCompactItemContext.Provider, {
    value: null
  }, children);
};

// ../../node_modules/antd/es/button/button-group.js
var React62 = __toESM(require("react"));
var import_classnames10 = __toESM(require_classnames());
var __rest6 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var GroupSizeContext = /* @__PURE__ */ React62.createContext(void 0);
var ButtonGroup = (props) => {
  const {
    getPrefixCls,
    direction
  } = React62.useContext(ConfigContext);
  const {
    prefixCls: customizePrefixCls,
    size,
    className
  } = props, others = __rest6(props, ["prefixCls", "size", "className"]);
  const prefixCls = getPrefixCls("btn-group", customizePrefixCls);
  const [, , hashId] = useToken();
  let sizeCls = "";
  switch (size) {
    case "large":
      sizeCls = "lg";
      break;
    case "small":
      sizeCls = "sm";
      break;
    case "middle":
    default:
  }
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Button.Group");
    process.env.NODE_ENV !== "production" ? warning6(!size || ["large", "small", "middle"].includes(size), "usage", "Invalid prop `size`.") : void 0;
  }
  const classes = (0, import_classnames10.default)(prefixCls, {
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, className, hashId);
  return /* @__PURE__ */ React62.createElement(GroupSizeContext.Provider, {
    value: size
  }, /* @__PURE__ */ React62.createElement("div", Object.assign({}, others, {
    className: classes
  })));
};
var button_group_default = ButtonGroup;

// ../../node_modules/antd/es/button/buttonHelpers.js
var import_react24 = __toESM(require("react"));
var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);
function convertLegacyProps(type4) {
  if (type4 === "danger") {
    return {
      danger: true
    };
  }
  return {
    type: type4
  };
}
function isString(str) {
  return typeof str === "string";
}
function isUnBorderedButtonType(type4) {
  return type4 === "text" || type4 === "link";
}
function splitCNCharsBySpace(child, needInserted) {
  if (child === null || child === void 0) {
    return;
  }
  const SPACE = needInserted ? " " : "";
  if (typeof child !== "string" && typeof child !== "number" && isString(child.type) && isTwoCNChar(child.props.children)) {
    return cloneElement4(child, {
      children: child.props.children.split("").join(SPACE)
    });
  }
  if (isString(child)) {
    return isTwoCNChar(child) ? /* @__PURE__ */ import_react24.default.createElement("span", null, child.split("").join(SPACE)) : /* @__PURE__ */ import_react24.default.createElement("span", null, child);
  }
  if (isFragment3(child)) {
    return /* @__PURE__ */ import_react24.default.createElement("span", null, child);
  }
  return child;
}
function spaceChildren(children, needInserted) {
  let isPrevChildPure = false;
  const childList = [];
  import_react24.default.Children.forEach(children, (child) => {
    const type4 = typeof child;
    const isCurrentChildPure = type4 === "string" || type4 === "number";
    if (isPrevChildPure && isCurrentChildPure) {
      const lastIndex = childList.length - 1;
      const lastChild = childList[lastIndex];
      childList[lastIndex] = `${lastChild}${child}`;
    } else {
      childList.push(child);
    }
    isPrevChildPure = isCurrentChildPure;
  });
  return import_react24.default.Children.map(childList, (child) => splitCNCharsBySpace(child, needInserted));
}

// ../../node_modules/antd/es/button/IconWrapper.js
var import_react25 = __toESM(require("react"));
var import_classnames11 = __toESM(require_classnames());
var IconWrapper = /* @__PURE__ */ (0, import_react25.forwardRef)((props, ref) => {
  const {
    className,
    style: style2,
    children,
    prefixCls
  } = props;
  const iconWrapperCls = (0, import_classnames11.default)(`${prefixCls}-icon`, className);
  return /* @__PURE__ */ import_react25.default.createElement("span", {
    ref,
    className: iconWrapperCls,
    style: style2
  }, children);
});
var IconWrapper_default = IconWrapper;

// ../../node_modules/antd/es/button/LoadingIcon.js
var import_classnames12 = __toESM(require_classnames());
var import_react26 = __toESM(require("react"));
var InnerLoadingIcon = /* @__PURE__ */ (0, import_react26.forwardRef)((_ref, ref) => {
  let {
    prefixCls,
    className,
    style: style2,
    iconClassName
  } = _ref;
  const mergedIconCls = (0, import_classnames12.default)(`${prefixCls}-loading-icon`, className);
  return /* @__PURE__ */ import_react26.default.createElement(IconWrapper_default, {
    prefixCls,
    className: mergedIconCls,
    style: style2,
    ref
  }, /* @__PURE__ */ import_react26.default.createElement(LoadingOutlined_default2, {
    className: iconClassName
  }));
});
var getCollapsedWidth = () => ({
  width: 0,
  opacity: 0,
  transform: "scale(0)"
});
var getRealWidth = (node2) => ({
  width: node2.scrollWidth,
  opacity: 1,
  transform: "scale(1)"
});
var LoadingIcon = (props) => {
  const {
    prefixCls,
    loading,
    existIcon,
    className,
    style: style2
  } = props;
  const visible = !!loading;
  if (existIcon) {
    return /* @__PURE__ */ import_react26.default.createElement(InnerLoadingIcon, {
      prefixCls,
      className,
      style: style2
    });
  }
  return /* @__PURE__ */ import_react26.default.createElement(es_default2, {
    visible,
    // We do not really use this motionName
    motionName: `${prefixCls}-loading-icon-motion`,
    motionLeave: visible,
    removeOnLeave: true,
    onAppearStart: getCollapsedWidth,
    onAppearActive: getRealWidth,
    onEnterStart: getCollapsedWidth,
    onEnterActive: getRealWidth,
    onLeaveStart: getRealWidth,
    onLeaveActive: getCollapsedWidth
  }, (_ref2, ref) => {
    let {
      className: motionCls,
      style: motionStyle
    } = _ref2;
    return /* @__PURE__ */ import_react26.default.createElement(InnerLoadingIcon, {
      prefixCls,
      className,
      style: Object.assign(Object.assign({}, style2), motionStyle),
      ref,
      iconClassName: motionCls
    });
  });
};
var LoadingIcon_default = LoadingIcon;

// ../../node_modules/antd/es/button/style/group.js
var genButtonBorderStyle = (buttonTypeCls, borderColor) => ({
  // Border
  [`> span, > ${buttonTypeCls}`]: {
    "&:not(:last-child)": {
      [`&, & > ${buttonTypeCls}`]: {
        "&:not(:disabled)": {
          borderInlineEndColor: borderColor
        }
      }
    },
    "&:not(:first-child)": {
      [`&, & > ${buttonTypeCls}`]: {
        "&:not(:disabled)": {
          borderInlineStartColor: borderColor
        }
      }
    }
  }
});
var genGroupStyle = (token2) => {
  const {
    componentCls,
    fontSize,
    lineWidth,
    groupBorderColor,
    colorErrorHover
  } = token2;
  return {
    [`${componentCls}-group`]: [
      {
        position: "relative",
        display: "inline-flex",
        // Border
        [`> span, > ${componentCls}`]: {
          "&:not(:last-child)": {
            [`&, & > ${componentCls}`]: {
              borderStartEndRadius: 0,
              borderEndEndRadius: 0
            }
          },
          "&:not(:first-child)": {
            marginInlineStart: token2.calc(lineWidth).mul(-1).equal(),
            [`&, & > ${componentCls}`]: {
              borderStartStartRadius: 0,
              borderEndStartRadius: 0
            }
          }
        },
        [componentCls]: {
          position: "relative",
          zIndex: 1,
          [`&:hover,
          &:focus,
          &:active`]: {
            zIndex: 2
          },
          "&[disabled]": {
            zIndex: 0
          }
        },
        [`${componentCls}-icon-only`]: {
          fontSize
        }
      },
      // Border Color
      genButtonBorderStyle(`${componentCls}-primary`, groupBorderColor),
      genButtonBorderStyle(`${componentCls}-danger`, colorErrorHover)
    ]
  };
};
var group_default = genGroupStyle;

// ../../node_modules/antd/es/button/style/token.js
var prepareToken = (token2) => {
  const {
    paddingInline,
    onlyIconSize,
    paddingBlock
  } = token2;
  const buttonToken = merge2(token2, {
    buttonPaddingHorizontal: paddingInline,
    buttonPaddingVertical: paddingBlock,
    buttonIconOnlyFontSize: onlyIconSize
  });
  return buttonToken;
};
var prepareComponentToken2 = (token2) => {
  var _a, _b, _c, _d, _e, _f;
  const contentFontSize = (_a = token2.contentFontSize) !== null && _a !== void 0 ? _a : token2.fontSize;
  const contentFontSizeSM = (_b = token2.contentFontSizeSM) !== null && _b !== void 0 ? _b : token2.fontSize;
  const contentFontSizeLG = (_c = token2.contentFontSizeLG) !== null && _c !== void 0 ? _c : token2.fontSizeLG;
  const contentLineHeight = (_d = token2.contentLineHeight) !== null && _d !== void 0 ? _d : getLineHeight(contentFontSize);
  const contentLineHeightSM = (_e = token2.contentLineHeightSM) !== null && _e !== void 0 ? _e : getLineHeight(contentFontSizeSM);
  const contentLineHeightLG = (_f = token2.contentLineHeightLG) !== null && _f !== void 0 ? _f : getLineHeight(contentFontSizeLG);
  return {
    fontWeight: 400,
    defaultShadow: `0 ${token2.controlOutlineWidth}px 0 ${token2.controlTmpOutline}`,
    primaryShadow: `0 ${token2.controlOutlineWidth}px 0 ${token2.controlOutline}`,
    dangerShadow: `0 ${token2.controlOutlineWidth}px 0 ${token2.colorErrorOutline}`,
    primaryColor: token2.colorTextLightSolid,
    dangerColor: token2.colorTextLightSolid,
    borderColorDisabled: token2.colorBorder,
    defaultGhostColor: token2.colorBgContainer,
    ghostBg: "transparent",
    defaultGhostBorderColor: token2.colorBgContainer,
    paddingInline: token2.paddingContentHorizontal - token2.lineWidth,
    paddingInlineLG: token2.paddingContentHorizontal - token2.lineWidth,
    paddingInlineSM: 8 - token2.lineWidth,
    onlyIconSize: token2.fontSizeLG,
    onlyIconSizeSM: token2.fontSizeLG - 2,
    onlyIconSizeLG: token2.fontSizeLG + 2,
    groupBorderColor: token2.colorPrimaryHover,
    linkHoverBg: "transparent",
    textHoverBg: token2.colorBgTextHover,
    defaultColor: token2.colorText,
    defaultBg: token2.colorBgContainer,
    defaultBorderColor: token2.colorBorder,
    defaultBorderColorDisabled: token2.colorBorder,
    contentFontSize,
    contentFontSizeSM,
    contentFontSizeLG,
    contentLineHeight,
    contentLineHeightSM,
    contentLineHeightLG,
    paddingBlock: Math.max((token2.controlHeight - contentFontSize * contentLineHeight) / 2 - token2.lineWidth, 0),
    paddingBlockSM: Math.max((token2.controlHeightSM - contentFontSizeSM * contentLineHeightSM) / 2 - token2.lineWidth, 0),
    paddingBlockLG: Math.max((token2.controlHeightLG - contentFontSizeLG * contentLineHeightLG) / 2 - token2.lineWidth, 0)
  };
};

// ../../node_modules/antd/es/button/style/index.js
var genSharedButtonStyle = (token2) => {
  const {
    componentCls,
    iconCls,
    fontWeight
  } = token2;
  return {
    [componentCls]: {
      outline: "none",
      position: "relative",
      display: "inline-block",
      fontWeight,
      whiteSpace: "nowrap",
      textAlign: "center",
      backgroundImage: "none",
      background: "transparent",
      border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
      cursor: "pointer",
      transition: `all ${token2.motionDurationMid} ${token2.motionEaseInOut}`,
      userSelect: "none",
      touchAction: "manipulation",
      color: token2.colorText,
      "&:disabled > *": {
        pointerEvents: "none"
      },
      "> span": {
        display: "inline-block"
      },
      [`${componentCls}-icon`]: {
        lineHeight: 0
      },
      // Leave a space between icon and text.
      [`> ${iconCls} + span, > span + ${iconCls}`]: {
        marginInlineStart: token2.marginXS
      },
      [`&:not(${componentCls}-icon-only) > ${componentCls}-icon`]: {
        [`&${componentCls}-loading-icon, &:not(:last-child)`]: {
          marginInlineEnd: token2.marginXS
        }
      },
      "> a": {
        color: "currentColor"
      },
      "&:not(:disabled)": Object.assign({}, genFocusStyle(token2)),
      [`&${componentCls}-two-chinese-chars::first-letter`]: {
        letterSpacing: "0.34em"
      },
      [`&${componentCls}-two-chinese-chars > *:not(${iconCls})`]: {
        marginInlineEnd: "-0.34em",
        letterSpacing: "0.34em"
      },
      // make `btn-icon-only` not too narrow
      [`&-icon-only${componentCls}-compact-item`]: {
        flex: "none"
      }
    }
  };
};
var genHoverActiveButtonStyle = (btnCls, hoverStyle, activeStyle) => ({
  [`&:not(:disabled):not(${btnCls}-disabled)`]: {
    "&:hover": hoverStyle,
    "&:active": activeStyle
  }
});
var genCircleButtonStyle = (token2) => ({
  minWidth: token2.controlHeight,
  paddingInlineStart: 0,
  paddingInlineEnd: 0,
  borderRadius: "50%"
});
var genRoundButtonStyle = (token2) => ({
  borderRadius: token2.controlHeight,
  paddingInlineStart: token2.calc(token2.controlHeight).div(2).equal(),
  paddingInlineEnd: token2.calc(token2.controlHeight).div(2).equal()
});
var genDisabledStyle = (token2) => ({
  cursor: "not-allowed",
  borderColor: token2.borderColorDisabled,
  color: token2.colorTextDisabled,
  background: token2.colorBgContainerDisabled,
  boxShadow: "none"
});
var genGhostButtonStyle = (btnCls, background, textColor, borderColor, textColorDisabled, borderColorDisabled, hoverStyle, activeStyle) => ({
  [`&${btnCls}-background-ghost`]: Object.assign(Object.assign({
    color: textColor || void 0,
    background,
    borderColor: borderColor || void 0,
    boxShadow: "none"
  }, genHoverActiveButtonStyle(btnCls, Object.assign({
    background
  }, hoverStyle), Object.assign({
    background
  }, activeStyle))), {
    "&:disabled": {
      cursor: "not-allowed",
      color: textColorDisabled || void 0,
      borderColor: borderColorDisabled || void 0
    }
  })
});
var genSolidDisabledButtonStyle = (token2) => ({
  [`&:disabled, &${token2.componentCls}-disabled`]: Object.assign({}, genDisabledStyle(token2))
});
var genSolidButtonStyle = (token2) => Object.assign({}, genSolidDisabledButtonStyle(token2));
var genPureDisabledButtonStyle = (token2) => ({
  [`&:disabled, &${token2.componentCls}-disabled`]: {
    cursor: "not-allowed",
    color: token2.colorTextDisabled
  }
});
var genDefaultButtonStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genSolidButtonStyle(token2)), {
  background: token2.defaultBg,
  borderColor: token2.defaultBorderColor,
  color: token2.defaultColor,
  boxShadow: token2.defaultShadow
}), genHoverActiveButtonStyle(token2.componentCls, {
  color: token2.colorPrimaryHover,
  borderColor: token2.colorPrimaryHover
}, {
  color: token2.colorPrimaryActive,
  borderColor: token2.colorPrimaryActive
})), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.defaultGhostColor, token2.defaultGhostBorderColor, token2.colorTextDisabled, token2.colorBorder)), {
  [`&${token2.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    color: token2.colorError,
    borderColor: token2.colorError
  }, genHoverActiveButtonStyle(token2.componentCls, {
    color: token2.colorErrorHover,
    borderColor: token2.colorErrorBorderHover
  }, {
    color: token2.colorErrorActive,
    borderColor: token2.colorErrorActive
  })), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorError, token2.colorError, token2.colorTextDisabled, token2.colorBorder)), genSolidDisabledButtonStyle(token2))
});
var genPrimaryButtonStyle = (token2) => Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genSolidButtonStyle(token2)), {
  color: token2.primaryColor,
  background: token2.colorPrimary,
  boxShadow: token2.primaryShadow
}), genHoverActiveButtonStyle(token2.componentCls, {
  color: token2.colorTextLightSolid,
  background: token2.colorPrimaryHover
}, {
  color: token2.colorTextLightSolid,
  background: token2.colorPrimaryActive
})), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorPrimary, token2.colorPrimary, token2.colorTextDisabled, token2.colorBorder, {
  color: token2.colorPrimaryHover,
  borderColor: token2.colorPrimaryHover
}, {
  color: token2.colorPrimaryActive,
  borderColor: token2.colorPrimaryActive
})), {
  [`&${token2.componentCls}-dangerous`]: Object.assign(Object.assign(Object.assign({
    background: token2.colorError,
    boxShadow: token2.dangerShadow,
    color: token2.dangerColor
  }, genHoverActiveButtonStyle(token2.componentCls, {
    background: token2.colorErrorHover
  }, {
    background: token2.colorErrorActive
  })), genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorError, token2.colorError, token2.colorTextDisabled, token2.colorBorder, {
    color: token2.colorErrorHover,
    borderColor: token2.colorErrorHover
  }, {
    color: token2.colorErrorActive,
    borderColor: token2.colorErrorActive
  })), genSolidDisabledButtonStyle(token2))
});
var genDashedButtonStyle = (token2) => Object.assign(Object.assign({}, genDefaultButtonStyle(token2)), {
  borderStyle: "dashed"
});
var genLinkButtonStyle = (token2) => Object.assign(Object.assign(Object.assign({
  color: token2.colorLink
}, genHoverActiveButtonStyle(token2.componentCls, {
  color: token2.colorLinkHover,
  background: token2.linkHoverBg
}, {
  color: token2.colorLinkActive
})), genPureDisabledButtonStyle(token2)), {
  [`&${token2.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: token2.colorError
  }, genHoverActiveButtonStyle(token2.componentCls, {
    color: token2.colorErrorHover
  }, {
    color: token2.colorErrorActive
  })), genPureDisabledButtonStyle(token2))
});
var genTextButtonStyle = (token2) => Object.assign(Object.assign(Object.assign({}, genHoverActiveButtonStyle(token2.componentCls, {
  color: token2.colorText,
  background: token2.textHoverBg
}, {
  color: token2.colorText,
  background: token2.colorBgTextActive
})), genPureDisabledButtonStyle(token2)), {
  [`&${token2.componentCls}-dangerous`]: Object.assign(Object.assign({
    color: token2.colorError
  }, genPureDisabledButtonStyle(token2)), genHoverActiveButtonStyle(token2.componentCls, {
    color: token2.colorErrorHover,
    background: token2.colorErrorBg
  }, {
    color: token2.colorErrorHover,
    background: token2.colorErrorBg
  }))
});
var genTypeButtonStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-default`]: genDefaultButtonStyle(token2),
    [`${componentCls}-primary`]: genPrimaryButtonStyle(token2),
    [`${componentCls}-dashed`]: genDashedButtonStyle(token2),
    [`${componentCls}-link`]: genLinkButtonStyle(token2),
    [`${componentCls}-text`]: genTextButtonStyle(token2),
    [`${componentCls}-ghost`]: genGhostButtonStyle(token2.componentCls, token2.ghostBg, token2.colorBgContainer, token2.colorBgContainer, token2.colorTextDisabled, token2.colorBorder)
  };
};
var genSizeButtonStyle = function(token2) {
  let sizePrefixCls = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
  const {
    componentCls,
    controlHeight,
    fontSize,
    lineHeight,
    borderRadius,
    buttonPaddingHorizontal,
    iconCls,
    buttonPaddingVertical
  } = token2;
  const iconOnlyCls = `${componentCls}-icon-only`;
  return [
    // Size
    {
      [`${componentCls}${sizePrefixCls}`]: {
        fontSize,
        lineHeight,
        height: controlHeight,
        padding: `${unit(buttonPaddingVertical)} ${unit(buttonPaddingHorizontal)}`,
        borderRadius,
        [`&${iconOnlyCls}`]: {
          width: controlHeight,
          paddingInlineStart: 0,
          paddingInlineEnd: 0,
          [`&${componentCls}-round`]: {
            width: "auto"
          },
          [iconCls]: {
            fontSize: token2.buttonIconOnlyFontSize
          }
        },
        // Loading
        [`&${componentCls}-loading`]: {
          opacity: token2.opacityLoading,
          cursor: "default"
        },
        [`${componentCls}-loading-icon`]: {
          transition: `width ${token2.motionDurationSlow} ${token2.motionEaseInOut}, opacity ${token2.motionDurationSlow} ${token2.motionEaseInOut}`
        }
      }
    },
    // Shape - patch prefixCls again to override solid border radius style
    {
      [`${componentCls}${componentCls}-circle${sizePrefixCls}`]: genCircleButtonStyle(token2)
    },
    {
      [`${componentCls}${componentCls}-round${sizePrefixCls}`]: genRoundButtonStyle(token2)
    }
  ];
};
var genSizeBaseButtonStyle = (token2) => genSizeButtonStyle(merge2(token2, {
  fontSize: token2.contentFontSize,
  lineHeight: token2.contentLineHeight
}));
var genSizeSmallButtonStyle = (token2) => {
  const smallToken = merge2(token2, {
    controlHeight: token2.controlHeightSM,
    fontSize: token2.contentFontSizeSM,
    lineHeight: token2.contentLineHeightSM,
    padding: token2.paddingXS,
    buttonPaddingHorizontal: token2.paddingInlineSM,
    buttonPaddingVertical: token2.paddingBlockSM,
    borderRadius: token2.borderRadiusSM,
    buttonIconOnlyFontSize: token2.onlyIconSizeSM
  });
  return genSizeButtonStyle(smallToken, `${token2.componentCls}-sm`);
};
var genSizeLargeButtonStyle = (token2) => {
  const largeToken = merge2(token2, {
    controlHeight: token2.controlHeightLG,
    fontSize: token2.contentFontSizeLG,
    lineHeight: token2.contentLineHeightLG,
    buttonPaddingHorizontal: token2.paddingInlineLG,
    buttonPaddingVertical: token2.paddingBlockLG,
    borderRadius: token2.borderRadiusLG,
    buttonIconOnlyFontSize: token2.onlyIconSizeLG
  });
  return genSizeButtonStyle(largeToken, `${token2.componentCls}-lg`);
};
var genBlockButtonStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: {
      [`&${componentCls}-block`]: {
        width: "100%"
      }
    }
  };
};
var style_default3 = genStyleHooks("Button", (token2) => {
  const buttonToken = prepareToken(token2);
  return [
    // Shared
    genSharedButtonStyle(buttonToken),
    // Size
    genSizeSmallButtonStyle(buttonToken),
    genSizeBaseButtonStyle(buttonToken),
    genSizeLargeButtonStyle(buttonToken),
    // Block
    genBlockButtonStyle(buttonToken),
    // Group (type, ghost, danger, loading)
    genTypeButtonStyle(buttonToken),
    // Button Group
    group_default(buttonToken)
  ];
}, prepareComponentToken2, {
  unitless: {
    fontWeight: true,
    contentLineHeight: true,
    contentLineHeightSM: true,
    contentLineHeightLG: true
  }
});

// ../../node_modules/antd/es/style/compact-item.js
function compactItemBorder(token2, parentCls, options) {
  const {
    focusElCls,
    focus: focus2,
    borderElCls
  } = options;
  const childCombinator = borderElCls ? "> *" : "";
  const hoverEffects = ["hover", focus2 ? "focus" : null, "active"].filter(Boolean).map((n) => `&:${n} ${childCombinator}`).join(",");
  return {
    [`&-item:not(${parentCls}-last-item)`]: {
      marginInlineEnd: token2.calc(token2.lineWidth).mul(-1).equal()
    },
    "&-item": Object.assign(Object.assign({
      [hoverEffects]: {
        zIndex: 2
      }
    }, focusElCls ? {
      [`&${focusElCls}`]: {
        zIndex: 2
      }
    } : {}), {
      [`&[disabled] ${childCombinator}`]: {
        zIndex: 0
      }
    })
  };
}
function compactItemBorderRadius(prefixCls, parentCls, options) {
  const {
    borderElCls
  } = options;
  const childCombinator = borderElCls ? `> ${borderElCls}` : "";
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item) ${childCombinator}`]: {
      borderRadius: 0
    },
    [`&-item:not(${parentCls}-last-item)${parentCls}-first-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`&-item:not(${parentCls}-first-item)${parentCls}-last-item`]: {
      [`& ${childCombinator}, &${prefixCls}-sm ${childCombinator}, &${prefixCls}-lg ${childCombinator}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    }
  };
}
function genCompactItemStyle(token2) {
  let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
    focus: true
  };
  const {
    componentCls
  } = token2;
  const compactCls = `${componentCls}-compact`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemBorder(token2, compactCls, options)), compactItemBorderRadius(componentCls, compactCls, options))
  };
}

// ../../node_modules/antd/es/style/compact-item-vertical.js
function compactItemVerticalBorder(token2, parentCls) {
  return {
    // border collapse
    [`&-item:not(${parentCls}-last-item)`]: {
      marginBottom: token2.calc(token2.lineWidth).mul(-1).equal()
    },
    "&-item": {
      "&:hover,&:focus,&:active": {
        zIndex: 2
      },
      "&[disabled]": {
        zIndex: 0
      }
    }
  };
}
function compactItemBorderVerticalRadius(prefixCls, parentCls) {
  return {
    [`&-item:not(${parentCls}-first-item):not(${parentCls}-last-item)`]: {
      borderRadius: 0
    },
    [`&-item${parentCls}-first-item:not(${parentCls}-last-item)`]: {
      [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
        borderEndEndRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&-item${parentCls}-last-item:not(${parentCls}-first-item)`]: {
      [`&, &${prefixCls}-sm, &${prefixCls}-lg`]: {
        borderStartStartRadius: 0,
        borderStartEndRadius: 0
      }
    }
  };
}
function genCompactItemVerticalStyle(token2) {
  const compactCls = `${token2.componentCls}-compact-vertical`;
  return {
    [compactCls]: Object.assign(Object.assign({}, compactItemVerticalBorder(token2, compactCls)), compactItemBorderVerticalRadius(token2.componentCls, compactCls))
  };
}

// ../../node_modules/antd/es/button/style/compactCmp.js
var genButtonCompactStyle = (token2) => {
  const {
    componentCls,
    calc
  } = token2;
  return {
    [componentCls]: {
      // Special styles for Primary Button
      [`&-compact-item${componentCls}-primary`]: {
        [`&:not([disabled]) + ${componentCls}-compact-item${componentCls}-primary:not([disabled])`]: {
          position: "relative",
          "&:before": {
            position: "absolute",
            top: calc(token2.lineWidth).mul(-1).equal(),
            insetInlineStart: calc(token2.lineWidth).mul(-1).equal(),
            display: "inline-block",
            width: token2.lineWidth,
            height: `calc(100% + ${unit(token2.lineWidth)} * 2)`,
            backgroundColor: token2.colorPrimaryHover,
            content: '""'
          }
        }
      },
      // Special styles for Primary Button
      "&-compact-vertical-item": {
        [`&${componentCls}-primary`]: {
          [`&:not([disabled]) + ${componentCls}-compact-vertical-item${componentCls}-primary:not([disabled])`]: {
            position: "relative",
            "&:before": {
              position: "absolute",
              top: calc(token2.lineWidth).mul(-1).equal(),
              insetInlineStart: calc(token2.lineWidth).mul(-1).equal(),
              display: "inline-block",
              width: `calc(100% + ${unit(token2.lineWidth)} * 2)`,
              height: token2.lineWidth,
              backgroundColor: token2.colorPrimaryHover,
              content: '""'
            }
          }
        }
      }
    }
  };
};
var compactCmp_default = genSubStyleComponent(["Button", "compact"], (token2) => {
  const buttonToken = prepareToken(token2);
  return [
    // Space Compact
    genCompactItemStyle(buttonToken),
    genCompactItemVerticalStyle(buttonToken),
    genButtonCompactStyle(buttonToken)
  ];
}, prepareComponentToken2);

// ../../node_modules/antd/es/button/button.js
var __rest7 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
function getLoadingConfig(loading) {
  if (typeof loading === "object" && loading) {
    let delay = loading === null || loading === void 0 ? void 0 : loading.delay;
    delay = !Number.isNaN(delay) && typeof delay === "number" ? delay : 0;
    return {
      loading: delay <= 0,
      delay
    };
  }
  return {
    loading: !!loading,
    delay: 0
  };
}
var InternalButton = (props, ref) => {
  var _a, _b;
  const {
    loading = false,
    prefixCls: customizePrefixCls,
    type: type4 = "default",
    danger,
    shape = "default",
    size: customizeSize,
    styles,
    disabled: customDisabled,
    className,
    rootClassName,
    children,
    icon,
    ghost = false,
    block = false,
    // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.
    htmlType = "button",
    classNames: customClassNames,
    style: customStyle = {}
  } = props, rest = __rest7(props, ["loading", "prefixCls", "type", "danger", "shape", "size", "styles", "disabled", "className", "rootClassName", "children", "icon", "ghost", "block", "htmlType", "classNames", "style"]);
  const {
    getPrefixCls,
    autoInsertSpaceInButton,
    direction,
    button
  } = (0, import_react27.useContext)(ConfigContext);
  const prefixCls = getPrefixCls("btn", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default3(prefixCls);
  const disabled = (0, import_react27.useContext)(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const groupSize = (0, import_react27.useContext)(GroupSizeContext);
  const loadingOrDelay = (0, import_react27.useMemo)(() => getLoadingConfig(loading), [loading]);
  const [innerLoading, setLoading] = (0, import_react27.useState)(loadingOrDelay.loading);
  const [hasTwoCNChar, setHasTwoCNChar] = (0, import_react27.useState)(false);
  const internalRef = /* @__PURE__ */ (0, import_react27.createRef)();
  const buttonRef = composeRef(ref, internalRef);
  const needInserted = import_react27.Children.count(children) === 1 && !icon && !isUnBorderedButtonType(type4);
  (0, import_react27.useEffect)(() => {
    let delayTimer = null;
    if (loadingOrDelay.delay > 0) {
      delayTimer = setTimeout(() => {
        delayTimer = null;
        setLoading(true);
      }, loadingOrDelay.delay);
    } else {
      setLoading(loadingOrDelay.loading);
    }
    function cleanupTimer() {
      if (delayTimer) {
        clearTimeout(delayTimer);
        delayTimer = null;
      }
    }
    return cleanupTimer;
  }, [loadingOrDelay]);
  (0, import_react27.useEffect)(() => {
    if (!buttonRef || !buttonRef.current || autoInsertSpaceInButton === false) {
      return;
    }
    const buttonText = buttonRef.current.textContent;
    if (needInserted && isTwoCNChar(buttonText)) {
      if (!hasTwoCNChar) {
        setHasTwoCNChar(true);
      }
    } else if (hasTwoCNChar) {
      setHasTwoCNChar(false);
    }
  }, [buttonRef]);
  const handleClick = (e) => {
    const {
      onClick
    } = props;
    if (innerLoading || mergedDisabled) {
      e.preventDefault();
      return;
    }
    onClick === null || onClick === void 0 ? void 0 : onClick(e);
  };
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Button");
    process.env.NODE_ENV !== "production" ? warning6(!(typeof icon === "string" && icon.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${icon}\` at https://ant.design/components/icon`) : void 0;
    process.env.NODE_ENV !== "production" ? warning6(!(ghost && isUnBorderedButtonType(type4)), "usage", "`link` or `text` button can't be a `ghost` button.") : void 0;
  }
  const autoInsertSpace = autoInsertSpaceInButton !== false;
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const sizeClassNameMap = {
    large: "lg",
    small: "sm",
    middle: void 0
  };
  const sizeFullName = useSize_default((ctxSize) => {
    var _a2, _b2;
    return (_b2 = (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a2 !== void 0 ? _a2 : groupSize) !== null && _b2 !== void 0 ? _b2 : ctxSize;
  });
  const sizeCls = sizeFullName ? sizeClassNameMap[sizeFullName] || "" : "";
  const iconType = innerLoading ? "loading" : icon;
  const linkButtonRestProps = omit(rest, ["navigate"]);
  const classes = (0, import_classnames13.default)(prefixCls, hashId, cssVarCls, {
    [`${prefixCls}-${shape}`]: shape !== "default" && shape,
    [`${prefixCls}-${type4}`]: type4,
    [`${prefixCls}-${sizeCls}`]: sizeCls,
    [`${prefixCls}-icon-only`]: !children && children !== 0 && !!iconType,
    [`${prefixCls}-background-ghost`]: ghost && !isUnBorderedButtonType(type4),
    [`${prefixCls}-loading`]: innerLoading,
    [`${prefixCls}-two-chinese-chars`]: hasTwoCNChar && autoInsertSpace && !innerLoading,
    [`${prefixCls}-block`]: block,
    [`${prefixCls}-dangerous`]: !!danger,
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, compactItemClassnames, className, rootClassName, button === null || button === void 0 ? void 0 : button.className);
  const fullStyle = Object.assign(Object.assign({}, button === null || button === void 0 ? void 0 : button.style), customStyle);
  const iconClasses = (0, import_classnames13.default)(customClassNames === null || customClassNames === void 0 ? void 0 : customClassNames.icon, (_a = button === null || button === void 0 ? void 0 : button.classNames) === null || _a === void 0 ? void 0 : _a.icon);
  const iconStyle = Object.assign(Object.assign({}, (styles === null || styles === void 0 ? void 0 : styles.icon) || {}), ((_b = button === null || button === void 0 ? void 0 : button.styles) === null || _b === void 0 ? void 0 : _b.icon) || {});
  const iconNode = icon && !innerLoading ? /* @__PURE__ */ import_react27.default.createElement(IconWrapper_default, {
    prefixCls,
    className: iconClasses,
    style: iconStyle
  }, icon) : /* @__PURE__ */ import_react27.default.createElement(LoadingIcon_default, {
    existIcon: !!icon,
    prefixCls,
    loading: !!innerLoading
  });
  const kids = children || children === 0 ? spaceChildren(children, needInserted && autoInsertSpace) : null;
  if (linkButtonRestProps.href !== void 0) {
    return wrapCSSVar(/* @__PURE__ */ import_react27.default.createElement("a", Object.assign({}, linkButtonRestProps, {
      className: (0, import_classnames13.default)(classes, {
        [`${prefixCls}-disabled`]: mergedDisabled
      }),
      href: mergedDisabled ? void 0 : linkButtonRestProps.href,
      style: fullStyle,
      onClick: handleClick,
      ref: buttonRef,
      tabIndex: mergedDisabled ? -1 : 0
    }), iconNode, kids));
  }
  let buttonNode = /* @__PURE__ */ import_react27.default.createElement("button", Object.assign({}, rest, {
    type: htmlType,
    className: classes,
    style: fullStyle,
    onClick: handleClick,
    disabled: mergedDisabled,
    ref: buttonRef
  }), iconNode, kids, compactItemClassnames && /* @__PURE__ */ import_react27.default.createElement(compactCmp_default, {
    key: "compact",
    prefixCls
  }));
  if (!isUnBorderedButtonType(type4)) {
    buttonNode = /* @__PURE__ */ import_react27.default.createElement(wave_default, {
      component: "Button",
      disabled: !!innerLoading
    }, buttonNode);
  }
  return wrapCSSVar(buttonNode);
};
var Button = /* @__PURE__ */ (0, import_react27.forwardRef)(InternalButton);
if (process.env.NODE_ENV !== "production") {
  Button.displayName = "Button";
}
Button.Group = button_group_default;
Button.__ANT_BUTTON = true;
var button_default = Button;

// ../../node_modules/antd/es/button/index.js
var button_default2 = button_default;

// ../../node_modules/antd/es/_util/ActionButton.js
function isThenable(thing) {
  return !!(thing && thing.then);
}
var ActionButton = (props) => {
  const {
    type: type4,
    children,
    prefixCls,
    buttonProps,
    close,
    autoFocus,
    emitEvent,
    isSilent,
    quitOnNullishReturnValue,
    actionFn
  } = props;
  const clickedRef = React67.useRef(false);
  const buttonRef = React67.useRef(null);
  const [loading, setLoading] = useSafeState(false);
  const onInternalClose = function() {
    close === null || close === void 0 ? void 0 : close.apply(void 0, arguments);
  };
  React67.useEffect(() => {
    let timeoutId = null;
    if (autoFocus) {
      timeoutId = setTimeout(() => {
        var _a;
        (_a = buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus();
      });
    }
    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, []);
  const handlePromiseOnOk = (returnValueOfOnOk) => {
    if (!isThenable(returnValueOfOnOk)) {
      return;
    }
    setLoading(true);
    returnValueOfOnOk.then(function() {
      setLoading(false, true);
      onInternalClose.apply(void 0, arguments);
      clickedRef.current = false;
    }, (e) => {
      setLoading(false, true);
      clickedRef.current = false;
      if (isSilent === null || isSilent === void 0 ? void 0 : isSilent()) {
        return;
      }
      return Promise.reject(e);
    });
  };
  const onClick = (e) => {
    if (clickedRef.current) {
      return;
    }
    clickedRef.current = true;
    if (!actionFn) {
      onInternalClose();
      return;
    }
    let returnValueOfOnOk;
    if (emitEvent) {
      returnValueOfOnOk = actionFn(e);
      if (quitOnNullishReturnValue && !isThenable(returnValueOfOnOk)) {
        clickedRef.current = false;
        onInternalClose(e);
        return;
      }
    } else if (actionFn.length) {
      returnValueOfOnOk = actionFn(close);
      clickedRef.current = false;
    } else {
      returnValueOfOnOk = actionFn();
      if (!returnValueOfOnOk) {
        onInternalClose();
        return;
      }
    }
    handlePromiseOnOk(returnValueOfOnOk);
  };
  return /* @__PURE__ */ React67.createElement(button_default2, Object.assign({}, convertLegacyProps(type4), {
    onClick,
    loading,
    prefixCls
  }, buttonProps, {
    ref: buttonRef
  }), children);
};
var ActionButton_default = ActionButton;

// ../../node_modules/antd/es/modal/context.js
var import_react28 = __toESM(require("react"));
var ModalContext = /* @__PURE__ */ import_react28.default.createContext({});
var {
  Provider: ModalContextProvider
} = ModalContext;

// ../../node_modules/antd/es/modal/components/ConfirmCancelBtn.js
var ConfirmCancelBtn = () => {
  const {
    autoFocusButton,
    cancelButtonProps,
    cancelTextLocale,
    isSilent,
    mergedOkCancel,
    rootPrefixCls,
    close,
    onCancel,
    onConfirm
  } = (0, import_react29.useContext)(ModalContext);
  return mergedOkCancel ? /* @__PURE__ */ import_react29.default.createElement(ActionButton_default, {
    isSilent,
    actionFn: onCancel,
    close: function() {
      close === null || close === void 0 ? void 0 : close.apply(void 0, arguments);
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(false);
    },
    autoFocus: autoFocusButton === "cancel",
    buttonProps: cancelButtonProps,
    prefixCls: `${rootPrefixCls}-btn`
  }, cancelTextLocale) : null;
};
var ConfirmCancelBtn_default = ConfirmCancelBtn;

// ../../node_modules/antd/es/modal/components/ConfirmOkBtn.js
var import_react30 = __toESM(require("react"));
var ConfirmOkBtn = () => {
  const {
    autoFocusButton,
    close,
    isSilent,
    okButtonProps,
    rootPrefixCls,
    okTextLocale,
    okType,
    onConfirm,
    onOk
  } = (0, import_react30.useContext)(ModalContext);
  return /* @__PURE__ */ import_react30.default.createElement(ActionButton_default, {
    isSilent,
    type: okType || "primary",
    actionFn: onOk,
    close: function() {
      close === null || close === void 0 ? void 0 : close.apply(void 0, arguments);
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(true);
    },
    autoFocus: autoFocusButton === "ok",
    buttonProps: okButtonProps,
    prefixCls: `${rootPrefixCls}-btn`
  }, okTextLocale);
};
var ConfirmOkBtn_default = ConfirmOkBtn;

// ../../node_modules/antd/es/modal/Modal.js
var React98 = __toESM(require("react"));
var import_classnames18 = __toESM(require_classnames());

// ../../node_modules/@rc-component/portal/es/Portal.js
var React74 = __toESM(require("react"));
var import_react_dom3 = require("react-dom");

// ../../node_modules/@rc-component/portal/es/Context.js
var React71 = __toESM(require("react"));
var OrderContext = /* @__PURE__ */ React71.createContext(null);
var Context_default2 = OrderContext;

// ../../node_modules/@rc-component/portal/es/useDom.js
var React72 = __toESM(require("react"));
var EMPTY_LIST = [];
function useDom(render2, debug) {
  var _React$useState = React72.useState(function() {
    if (!canUseDom()) {
      return null;
    }
    var defaultEle = document.createElement("div");
    if (process.env.NODE_ENV !== "production" && debug) {
      defaultEle.setAttribute("data-debug", debug);
    }
    return defaultEle;
  }), _React$useState2 = _slicedToArray(_React$useState, 1), ele = _React$useState2[0];
  var appendedRef = React72.useRef(false);
  var queueCreate = React72.useContext(Context_default2);
  var _React$useState3 = React72.useState(EMPTY_LIST), _React$useState4 = _slicedToArray(_React$useState3, 2), queue = _React$useState4[0], setQueue = _React$useState4[1];
  var mergedQueueCreate = queueCreate || (appendedRef.current ? void 0 : function(appendFn) {
    setQueue(function(origin) {
      var newQueue = [appendFn].concat(_toConsumableArray(origin));
      return newQueue;
    });
  });
  function append3() {
    if (!ele.parentElement) {
      document.body.appendChild(ele);
    }
    appendedRef.current = true;
  }
  function cleanup2() {
    var _ele$parentElement;
    (_ele$parentElement = ele.parentElement) === null || _ele$parentElement === void 0 ? void 0 : _ele$parentElement.removeChild(ele);
    appendedRef.current = false;
  }
  useLayoutEffect_default(function() {
    if (render2) {
      if (queueCreate) {
        queueCreate(append3);
      } else {
        append3();
      }
    } else {
      cleanup2();
    }
    return cleanup2;
  }, [render2]);
  useLayoutEffect_default(function() {
    if (queue.length) {
      queue.forEach(function(appendFn) {
        return appendFn();
      });
      setQueue(EMPTY_LIST);
    }
  }, [queue]);
  return [ele, mergedQueueCreate];
}

// ../../node_modules/@rc-component/portal/es/useScrollLocker.js
var React73 = __toESM(require("react"));

// ../../node_modules/rc-util/es/getScrollBarSize.js
var cached;
function getScrollBarSize(fresh) {
  if (typeof document === "undefined") {
    return 0;
  }
  if (fresh || cached === void 0) {
    var inner = document.createElement("div");
    inner.style.width = "100%";
    inner.style.height = "200px";
    var outer = document.createElement("div");
    var outerStyle = outer.style;
    outerStyle.position = "absolute";
    outerStyle.top = "0";
    outerStyle.left = "0";
    outerStyle.pointerEvents = "none";
    outerStyle.visibility = "hidden";
    outerStyle.width = "200px";
    outerStyle.height = "150px";
    outerStyle.overflow = "hidden";
    outer.appendChild(inner);
    document.body.appendChild(outer);
    var widthContained = inner.offsetWidth;
    outer.style.overflow = "scroll";
    var widthScroll = inner.offsetWidth;
    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }
    document.body.removeChild(outer);
    cached = widthContained - widthScroll;
  }
  return cached;
}
function ensureSize(str) {
  var match2 = str.match(/^(.*)px$/);
  var value = Number(match2 === null || match2 === void 0 ? void 0 : match2[1]);
  return Number.isNaN(value) ? getScrollBarSize() : value;
}
function getTargetScrollBarSize(target) {
  if (typeof document === "undefined" || !target || !(target instanceof Element)) {
    return {
      width: 0,
      height: 0
    };
  }
  var _getComputedStyle = getComputedStyle(target, "::-webkit-scrollbar"), width = _getComputedStyle.width, height = _getComputedStyle.height;
  return {
    width: ensureSize(width),
    height: ensureSize(height)
  };
}

// ../../node_modules/@rc-component/portal/es/util.js
function isBodyOverflowing() {
  return document.body.scrollHeight > (window.innerHeight || document.documentElement.clientHeight) && window.innerWidth > document.body.offsetWidth;
}

// ../../node_modules/@rc-component/portal/es/useScrollLocker.js
var UNIQUE_ID = "rc-util-locker-".concat(Date.now());
var uuid2 = 0;
function useScrollLocker(lock) {
  var mergedLock = !!lock;
  var _React$useState = React73.useState(function() {
    uuid2 += 1;
    return "".concat(UNIQUE_ID, "_").concat(uuid2);
  }), _React$useState2 = _slicedToArray(_React$useState, 1), id = _React$useState2[0];
  useLayoutEffect_default(function() {
    if (mergedLock) {
      var scrollbarSize = getTargetScrollBarSize(document.body).width;
      var isOverflow = isBodyOverflowing();
      updateCSS("\nhtml body {\n  overflow-y: hidden;\n  ".concat(isOverflow ? "width: calc(100% - ".concat(scrollbarSize, "px);") : "", "\n}"), id);
    } else {
      removeCSS(id);
    }
    return function() {
      removeCSS(id);
    };
  }, [mergedLock, id]);
}

// ../../node_modules/@rc-component/portal/es/mock.js
var inline = false;
function inlineMock(nextInline) {
  if (typeof nextInline === "boolean") {
    inline = nextInline;
  }
  return inline;
}

// ../../node_modules/@rc-component/portal/es/Portal.js
var getPortalContainer = function getPortalContainer2(getContainer2) {
  if (getContainer2 === false) {
    return false;
  }
  if (!canUseDom() || !getContainer2) {
    return null;
  }
  if (typeof getContainer2 === "string") {
    return document.querySelector(getContainer2);
  }
  if (typeof getContainer2 === "function") {
    return getContainer2();
  }
  return getContainer2;
};
var Portal = /* @__PURE__ */ React74.forwardRef(function(props, ref) {
  var open3 = props.open, autoLock = props.autoLock, getContainer2 = props.getContainer, debug = props.debug, _props$autoDestroy = props.autoDestroy, autoDestroy = _props$autoDestroy === void 0 ? true : _props$autoDestroy, children = props.children;
  var _React$useState = React74.useState(open3), _React$useState2 = _slicedToArray(_React$useState, 2), shouldRender = _React$useState2[0], setShouldRender = _React$useState2[1];
  var mergedRender = shouldRender || open3;
  if (process.env.NODE_ENV !== "production") {
    warning_default(canUseDom() || !open3, "Portal only work in client side. Please call 'useEffect' to show Portal instead default render in SSR.");
  }
  React74.useEffect(function() {
    if (autoDestroy || open3) {
      setShouldRender(open3);
    }
  }, [open3, autoDestroy]);
  var _React$useState3 = React74.useState(function() {
    return getPortalContainer(getContainer2);
  }), _React$useState4 = _slicedToArray(_React$useState3, 2), innerContainer = _React$useState4[0], setInnerContainer = _React$useState4[1];
  React74.useEffect(function() {
    var customizeContainer = getPortalContainer(getContainer2);
    setInnerContainer(customizeContainer !== null && customizeContainer !== void 0 ? customizeContainer : null);
  });
  var _useDom = useDom(mergedRender && !innerContainer, debug), _useDom2 = _slicedToArray(_useDom, 2), defaultContainer = _useDom2[0], queueCreate = _useDom2[1];
  var mergedContainer = innerContainer !== null && innerContainer !== void 0 ? innerContainer : defaultContainer;
  useScrollLocker(autoLock && open3 && canUseDom() && (mergedContainer === defaultContainer || mergedContainer === document.body));
  var childRef = null;
  if (children && supportRef(children) && ref) {
    var _ref = children;
    childRef = _ref.ref;
  }
  var mergedRef = useComposeRef(childRef, ref);
  if (!mergedRender || !canUseDom() || innerContainer === void 0) {
    return null;
  }
  var renderInline = mergedContainer === false || inlineMock();
  var reffedChildren = children;
  if (ref) {
    reffedChildren = /* @__PURE__ */ React74.cloneElement(children, {
      ref: mergedRef
    });
  }
  return /* @__PURE__ */ React74.createElement(Context_default2.Provider, {
    value: queueCreate
  }, renderInline ? reffedChildren : /* @__PURE__ */ (0, import_react_dom3.createPortal)(reffedChildren, mergedContainer));
});
if (process.env.NODE_ENV !== "production") {
  Portal.displayName = "Portal";
}
var Portal_default = Portal;

// ../../node_modules/@rc-component/portal/es/index.js
var es_default3 = Portal_default;

// ../../node_modules/rc-dialog/es/DialogWrap.js
var React82 = __toESM(require("react"));

// ../../node_modules/rc-dialog/es/context.js
var React75 = __toESM(require("react"));
var RefContext = /* @__PURE__ */ React75.createContext({});

// ../../node_modules/rc-dialog/es/Dialog/index.js
var import_classnames17 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/hooks/useId.js
var React76 = __toESM(require("react"));
function getUseId() {
  var fullClone5 = _objectSpread2({}, React76);
  return fullClone5.useId;
}
var uuid3 = 0;
var useOriginId = getUseId();
var useId_default = useOriginId ? (
  // Use React `useId`
  function useId2(id) {
    var reactId = useOriginId();
    if (id) {
      return id;
    }
    if (process.env.NODE_ENV === "test") {
      return "test-id";
    }
    return reactId;
  }
) : (
  // Use compatible of `useId`
  function useCompatId(id) {
    var _React$useState = React76.useState("ssr-id"), _React$useState2 = _slicedToArray(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
    React76.useEffect(function() {
      var nextId = uuid3;
      uuid3 += 1;
      setInnerId("rc_unique_".concat(nextId));
    }, []);
    if (id) {
      return id;
    }
    if (process.env.NODE_ENV === "test") {
      return "test-id";
    }
    return innerId;
  }
);

// ../../node_modules/rc-dialog/es/Dialog/index.js
var React81 = __toESM(require("react"));
var import_react33 = require("react");

// ../../node_modules/rc-dialog/es/util.js
function getMotionName(prefixCls, transitionName, animationName) {
  var motionName = transitionName;
  if (!motionName && animationName) {
    motionName = "".concat(prefixCls, "-").concat(animationName);
  }
  return motionName;
}
function getScroll(w, top) {
  var ret = w["page".concat(top ? "Y" : "X", "Offset")];
  var method4 = "scroll".concat(top ? "Top" : "Left");
  if (typeof ret !== "number") {
    var d = w.document;
    ret = d.documentElement[method4];
    if (typeof ret !== "number") {
      ret = d.body[method4];
    }
  }
  return ret;
}
function offset(el) {
  var rect = el.getBoundingClientRect();
  var pos = {
    left: rect.left,
    top: rect.top
  };
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScroll(w);
  pos.top += getScroll(w, true);
  return pos;
}

// ../../node_modules/rc-dialog/es/Dialog/Content/index.js
var React79 = __toESM(require("react"));
var import_react32 = require("react");
var import_classnames15 = __toESM(require_classnames());

// ../../node_modules/rc-dialog/es/Dialog/Content/Panel.js
var import_classnames14 = __toESM(require_classnames());
var import_react31 = __toESM(require("react"));

// ../../node_modules/rc-dialog/es/Dialog/Content/MemoChildren.js
var React77 = __toESM(require("react"));
var MemoChildren_default = /* @__PURE__ */ React77.memo(function(_ref) {
  var children = _ref.children;
  return children;
}, function(_, _ref2) {
  var shouldUpdate = _ref2.shouldUpdate;
  return !shouldUpdate;
});

// ../../node_modules/rc-dialog/es/Dialog/Content/Panel.js
var sentinelStyle = {
  width: 0,
  height: 0,
  overflow: "hidden",
  outline: "none"
};
var Panel = /* @__PURE__ */ import_react31.default.forwardRef(function(props, ref) {
  var prefixCls = props.prefixCls, className = props.className, style2 = props.style, title = props.title, ariaId = props.ariaId, footer = props.footer, closable = props.closable, closeIcon = props.closeIcon, onClose = props.onClose, children = props.children, bodyStyle = props.bodyStyle, bodyProps = props.bodyProps, modalRender = props.modalRender, onMouseDown = props.onMouseDown, onMouseUp = props.onMouseUp, holderRef = props.holderRef, visible = props.visible, forceRender = props.forceRender, width = props.width, height = props.height, modalClassNames = props.classNames, modalStyles = props.styles;
  var _React$useContext = import_react31.default.useContext(RefContext), panelRef = _React$useContext.panel;
  var mergedRef = useComposeRef(holderRef, panelRef);
  var sentinelStartRef = (0, import_react31.useRef)();
  var sentinelEndRef = (0, import_react31.useRef)();
  import_react31.default.useImperativeHandle(ref, function() {
    return {
      focus: function focus2() {
        var _sentinelStartRef$cur;
        (_sentinelStartRef$cur = sentinelStartRef.current) === null || _sentinelStartRef$cur === void 0 || _sentinelStartRef$cur.focus();
      },
      changeActive: function changeActive(next2) {
        var _document = document, activeElement = _document.activeElement;
        if (next2 && activeElement === sentinelEndRef.current) {
          sentinelStartRef.current.focus();
        } else if (!next2 && activeElement === sentinelStartRef.current) {
          sentinelEndRef.current.focus();
        }
      }
    };
  });
  var contentStyle = {};
  if (width !== void 0) {
    contentStyle.width = width;
  }
  if (height !== void 0) {
    contentStyle.height = height;
  }
  var footerNode;
  if (footer) {
    footerNode = /* @__PURE__ */ import_react31.default.createElement("div", {
      className: (0, import_classnames14.default)("".concat(prefixCls, "-footer"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.footer),
      style: _objectSpread2({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.footer)
    }, footer);
  }
  var headerNode;
  if (title) {
    headerNode = /* @__PURE__ */ import_react31.default.createElement("div", {
      className: (0, import_classnames14.default)("".concat(prefixCls, "-header"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.header),
      style: _objectSpread2({}, modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.header)
    }, /* @__PURE__ */ import_react31.default.createElement("div", {
      className: "".concat(prefixCls, "-title"),
      id: ariaId
    }, title));
  }
  var closer;
  if (closable) {
    closer = /* @__PURE__ */ import_react31.default.createElement("button", {
      type: "button",
      onClick: onClose,
      "aria-label": "Close",
      className: "".concat(prefixCls, "-close")
    }, closeIcon || /* @__PURE__ */ import_react31.default.createElement("span", {
      className: "".concat(prefixCls, "-close-x")
    }));
  }
  var content = /* @__PURE__ */ import_react31.default.createElement("div", {
    className: (0, import_classnames14.default)("".concat(prefixCls, "-content"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.content),
    style: modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.content
  }, closer, headerNode, /* @__PURE__ */ import_react31.default.createElement("div", _extends({
    className: (0, import_classnames14.default)("".concat(prefixCls, "-body"), modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.body),
    style: _objectSpread2(_objectSpread2({}, bodyStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.body)
  }, bodyProps), children), footerNode);
  return /* @__PURE__ */ import_react31.default.createElement("div", {
    key: "dialog-element",
    role: "dialog",
    "aria-labelledby": title ? ariaId : null,
    "aria-modal": "true",
    ref: mergedRef,
    style: _objectSpread2(_objectSpread2({}, style2), contentStyle),
    className: (0, import_classnames14.default)(prefixCls, className),
    onMouseDown,
    onMouseUp
  }, /* @__PURE__ */ import_react31.default.createElement("div", {
    tabIndex: 0,
    ref: sentinelStartRef,
    style: sentinelStyle,
    "aria-hidden": "true"
  }), /* @__PURE__ */ import_react31.default.createElement(MemoChildren_default, {
    shouldUpdate: visible || forceRender
  }, modalRender ? modalRender(content) : content), /* @__PURE__ */ import_react31.default.createElement("div", {
    tabIndex: 0,
    ref: sentinelEndRef,
    style: sentinelStyle,
    "aria-hidden": "true"
  }));
});
if (process.env.NODE_ENV !== "production") {
  Panel.displayName = "Panel";
}
var Panel_default = Panel;

// ../../node_modules/rc-dialog/es/Dialog/Content/index.js
var Content = /* @__PURE__ */ React79.forwardRef(function(props, ref) {
  var prefixCls = props.prefixCls, title = props.title, style2 = props.style, className = props.className, visible = props.visible, forceRender = props.forceRender, destroyOnClose = props.destroyOnClose, motionName = props.motionName, ariaId = props.ariaId, onVisibleChanged = props.onVisibleChanged, mousePosition2 = props.mousePosition;
  var dialogRef = (0, import_react32.useRef)();
  var _React$useState = React79.useState(), _React$useState2 = _slicedToArray(_React$useState, 2), transformOrigin = _React$useState2[0], setTransformOrigin = _React$useState2[1];
  var contentStyle = {};
  if (transformOrigin) {
    contentStyle.transformOrigin = transformOrigin;
  }
  function onPrepare() {
    var elementOffset = offset(dialogRef.current);
    setTransformOrigin(mousePosition2 ? "".concat(mousePosition2.x - elementOffset.left, "px ").concat(mousePosition2.y - elementOffset.top, "px") : "");
  }
  return /* @__PURE__ */ React79.createElement(es_default2, {
    visible,
    onVisibleChanged,
    onAppearPrepare: onPrepare,
    onEnterPrepare: onPrepare,
    forceRender,
    motionName,
    removeOnLeave: destroyOnClose,
    ref: dialogRef
  }, function(_ref, motionRef) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    return /* @__PURE__ */ React79.createElement(Panel_default, _extends({}, props, {
      ref,
      title,
      ariaId,
      prefixCls,
      holderRef: motionRef,
      style: _objectSpread2(_objectSpread2(_objectSpread2({}, motionStyle), style2), contentStyle),
      className: (0, import_classnames15.default)(className, motionClassName)
    }));
  });
});
Content.displayName = "Content";
var Content_default = Content;

// ../../node_modules/rc-dialog/es/Dialog/Mask.js
var React80 = __toESM(require("react"));
var import_classnames16 = __toESM(require_classnames());
function Mask(props) {
  var prefixCls = props.prefixCls, style2 = props.style, visible = props.visible, maskProps = props.maskProps, motionName = props.motionName, className = props.className;
  return /* @__PURE__ */ React80.createElement(es_default2, {
    key: "mask",
    visible,
    motionName,
    leavedClassName: "".concat(prefixCls, "-mask-hidden")
  }, function(_ref, ref) {
    var motionClassName = _ref.className, motionStyle = _ref.style;
    return /* @__PURE__ */ React80.createElement("div", _extends({
      ref,
      style: _objectSpread2(_objectSpread2({}, motionStyle), style2),
      className: (0, import_classnames16.default)("".concat(prefixCls, "-mask"), motionClassName, className)
    }, maskProps));
  });
}

// ../../node_modules/rc-dialog/es/Dialog/index.js
function Dialog(props) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-dialog" : _props$prefixCls, zIndex = props.zIndex, _props$visible = props.visible, visible = _props$visible === void 0 ? false : _props$visible, _props$keyboard = props.keyboard, keyboard = _props$keyboard === void 0 ? true : _props$keyboard, _props$focusTriggerAf = props.focusTriggerAfterClose, focusTriggerAfterClose = _props$focusTriggerAf === void 0 ? true : _props$focusTriggerAf, wrapStyle = props.wrapStyle, wrapClassName = props.wrapClassName, wrapProps = props.wrapProps, onClose = props.onClose, afterOpenChange = props.afterOpenChange, afterClose = props.afterClose, transitionName = props.transitionName, animation = props.animation, _props$closable = props.closable, closable = _props$closable === void 0 ? true : _props$closable, _props$mask = props.mask, mask = _props$mask === void 0 ? true : _props$mask, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, maskStyle = props.maskStyle, maskProps = props.maskProps, rootClassName = props.rootClassName, modalClassNames = props.classNames, modalStyles = props.styles;
  if (process.env.NODE_ENV !== "production") {
    ["wrapStyle", "bodyStyle", "maskStyle"].forEach(function(prop) {
      warning(!(prop in props), "".concat(prop, " is deprecated, please use styles instead."));
    });
    if ("wrapClassName" in props) {
      warning(false, "wrapClassName is deprecated, please use classNames instead.");
    }
  }
  var lastOutSideActiveElementRef = (0, import_react33.useRef)();
  var wrapperRef = (0, import_react33.useRef)();
  var contentRef = (0, import_react33.useRef)();
  var _React$useState = React81.useState(visible), _React$useState2 = _slicedToArray(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
  var ariaId = useId_default();
  function saveLastOutSideActiveElementRef() {
    if (!contains(wrapperRef.current, document.activeElement)) {
      lastOutSideActiveElementRef.current = document.activeElement;
    }
  }
  function focusDialogContent() {
    if (!contains(wrapperRef.current, document.activeElement)) {
      var _contentRef$current;
      (_contentRef$current = contentRef.current) === null || _contentRef$current === void 0 || _contentRef$current.focus();
    }
  }
  function onDialogVisibleChanged(newVisible) {
    if (newVisible) {
      focusDialogContent();
    } else {
      setAnimatedVisible(false);
      if (mask && lastOutSideActiveElementRef.current && focusTriggerAfterClose) {
        try {
          lastOutSideActiveElementRef.current.focus({
            preventScroll: true
          });
        } catch (e) {
        }
        lastOutSideActiveElementRef.current = null;
      }
      if (animatedVisible) {
        afterClose === null || afterClose === void 0 || afterClose();
      }
    }
    afterOpenChange === null || afterOpenChange === void 0 || afterOpenChange(newVisible);
  }
  function onInternalClose(e) {
    onClose === null || onClose === void 0 || onClose(e);
  }
  var contentClickRef = (0, import_react33.useRef)(false);
  var contentTimeoutRef = (0, import_react33.useRef)();
  var onContentMouseDown = function onContentMouseDown2() {
    clearTimeout(contentTimeoutRef.current);
    contentClickRef.current = true;
  };
  var onContentMouseUp = function onContentMouseUp2() {
    contentTimeoutRef.current = setTimeout(function() {
      contentClickRef.current = false;
    });
  };
  var onWrapperClick = null;
  if (maskClosable) {
    onWrapperClick = function onWrapperClick2(e) {
      if (contentClickRef.current) {
        contentClickRef.current = false;
      } else if (wrapperRef.current === e.target) {
        onInternalClose(e);
      }
    };
  }
  function onWrapperKeyDown(e) {
    if (keyboard && e.keyCode === KeyCode_default.ESC) {
      e.stopPropagation();
      onInternalClose(e);
      return;
    }
    if (visible) {
      if (e.keyCode === KeyCode_default.TAB) {
        contentRef.current.changeActive(!e.shiftKey);
      }
    }
  }
  (0, import_react33.useEffect)(function() {
    if (visible) {
      setAnimatedVisible(true);
      saveLastOutSideActiveElementRef();
    }
  }, [visible]);
  (0, import_react33.useEffect)(function() {
    return function() {
      clearTimeout(contentTimeoutRef.current);
    };
  }, []);
  return /* @__PURE__ */ React81.createElement("div", _extends({
    className: (0, import_classnames17.default)("".concat(prefixCls, "-root"), rootClassName)
  }, pickAttrs(props, {
    data: true
  })), /* @__PURE__ */ React81.createElement(Mask, {
    prefixCls,
    visible: mask && visible,
    motionName: getMotionName(prefixCls, maskTransitionName, maskAnimation),
    style: _objectSpread2(_objectSpread2({
      zIndex
    }, maskStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.mask),
    maskProps,
    className: modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.mask
  }), /* @__PURE__ */ React81.createElement("div", _extends({
    tabIndex: -1,
    onKeyDown: onWrapperKeyDown,
    className: (0, import_classnames17.default)("".concat(prefixCls, "-wrap"), wrapClassName, modalClassNames === null || modalClassNames === void 0 ? void 0 : modalClassNames.wrapper),
    ref: wrapperRef,
    onClick: onWrapperClick,
    style: _objectSpread2(_objectSpread2(_objectSpread2({
      zIndex
    }, wrapStyle), modalStyles === null || modalStyles === void 0 ? void 0 : modalStyles.wrapper), {}, {
      display: !animatedVisible ? "none" : null
    })
  }, wrapProps), /* @__PURE__ */ React81.createElement(Content_default, _extends({}, props, {
    onMouseDown: onContentMouseDown,
    onMouseUp: onContentMouseUp,
    ref: contentRef,
    closable,
    ariaId,
    prefixCls,
    visible: visible && animatedVisible,
    onClose: onInternalClose,
    onVisibleChanged: onDialogVisibleChanged,
    motionName: getMotionName(prefixCls, transitionName, animation)
  }))));
}

// ../../node_modules/rc-dialog/es/DialogWrap.js
var DialogWrap = function DialogWrap2(props) {
  var visible = props.visible, getContainer2 = props.getContainer, forceRender = props.forceRender, _props$destroyOnClose = props.destroyOnClose, destroyOnClose = _props$destroyOnClose === void 0 ? false : _props$destroyOnClose, _afterClose = props.afterClose, panelRef = props.panelRef;
  var _React$useState = React82.useState(visible), _React$useState2 = _slicedToArray(_React$useState, 2), animatedVisible = _React$useState2[0], setAnimatedVisible = _React$useState2[1];
  var refContext = React82.useMemo(function() {
    return {
      panel: panelRef
    };
  }, [panelRef]);
  React82.useEffect(function() {
    if (visible) {
      setAnimatedVisible(true);
    }
  }, [visible]);
  if (!forceRender && destroyOnClose && !animatedVisible) {
    return null;
  }
  return /* @__PURE__ */ React82.createElement(RefContext.Provider, {
    value: refContext
  }, /* @__PURE__ */ React82.createElement(es_default3, {
    open: visible || forceRender || animatedVisible,
    autoDestroy: false,
    getContainer: getContainer2,
    autoLock: visible || animatedVisible
  }, /* @__PURE__ */ React82.createElement(Dialog, _extends({}, props, {
    destroyOnClose,
    afterClose: function afterClose() {
      _afterClose === null || _afterClose === void 0 || _afterClose();
      setAnimatedVisible(false);
    }
  }))));
};
DialogWrap.displayName = "Dialog";
var DialogWrap_default = DialogWrap;

// ../../node_modules/rc-dialog/es/index.js
var es_default4 = DialogWrap_default;

// ../../node_modules/antd/es/_util/hooks/useClosable.js
var import_react34 = __toESM(require("react"));
function useInnerClosable(closable, closeIcon, defaultClosable) {
  if (typeof closable === "boolean") {
    return closable;
  }
  if (closeIcon === void 0) {
    return !!defaultClosable;
  }
  return closeIcon !== false && closeIcon !== null;
}
function useClosable(closable, closeIcon, customCloseIconRender) {
  let defaultCloseIcon = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : /* @__PURE__ */ import_react34.default.createElement(CloseOutlined_default2, null);
  let defaultClosable = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  const mergedClosable = useInnerClosable(closable, closeIcon, defaultClosable);
  if (!mergedClosable) {
    return [false, null];
  }
  const mergedCloseIcon = typeof closeIcon === "boolean" || closeIcon === void 0 || closeIcon === null ? defaultCloseIcon : closeIcon;
  return [true, customCloseIconRender ? customCloseIconRender(mergedCloseIcon) : mergedCloseIcon];
}
var useClosable_default = useClosable;

// ../../node_modules/rc-util/es/Dom/styleChecker.js
var isStyleNameSupport = function isStyleNameSupport2(styleName) {
  if (canUseDom() && window.document.documentElement) {
    var styleNameList = Array.isArray(styleName) ? styleName : [styleName];
    var documentElement = window.document.documentElement;
    return styleNameList.some(function(name) {
      return name in documentElement.style;
    });
  }
  return false;
};
var isStyleValueSupport = function isStyleValueSupport2(styleName, value) {
  if (!isStyleNameSupport(styleName)) {
    return false;
  }
  var ele = document.createElement("div");
  var origin = ele.style[styleName];
  ele.style[styleName] = value;
  return ele.style[styleName] !== origin;
};
function isStyleSupport(styleName, styleValue) {
  if (!Array.isArray(styleName) && styleValue !== void 0) {
    return isStyleValueSupport(styleName, styleValue);
  }
  return isStyleNameSupport(styleName);
}

// ../../node_modules/antd/es/_util/styleChecker.js
var canUseDocElement = () => canUseDom() && window.document.documentElement;

// ../../node_modules/antd/es/form/context.js
var React93 = __toESM(require("react"));
var import_react36 = require("react");

// ../../node_modules/rc-field-form/es/index.js
var React92 = __toESM(require("react"));

// ../../node_modules/rc-field-form/es/Field.js
var React87 = __toESM(require("react"));

// ../../node_modules/rc-field-form/es/FieldContext.js
var React84 = __toESM(require("react"));
var HOOK_MARK = "RC_FORM_INTERNAL_HOOKS";
var warningFunc = function warningFunc2() {
  warning_default(false, "Can not find FormContext. Please make sure you wrap Field under Form.");
};
var Context2 = /* @__PURE__ */ React84.createContext({
  getFieldValue: warningFunc,
  getFieldsValue: warningFunc,
  getFieldError: warningFunc,
  getFieldWarning: warningFunc,
  getFieldsError: warningFunc,
  isFieldsTouched: warningFunc,
  isFieldTouched: warningFunc,
  isFieldValidating: warningFunc,
  isFieldsValidating: warningFunc,
  resetFields: warningFunc,
  setFields: warningFunc,
  setFieldValue: warningFunc,
  setFieldsValue: warningFunc,
  validateFields: warningFunc,
  submit: warningFunc,
  getInternalHooks: function getInternalHooks() {
    warningFunc();
    return {
      dispatch: warningFunc,
      initEntityValue: warningFunc,
      registerField: warningFunc,
      useSubscribe: warningFunc,
      setInitialValues: warningFunc,
      destroyForm: warningFunc,
      setCallbacks: warningFunc,
      registerWatch: warningFunc,
      getFields: warningFunc,
      setValidateMessages: warningFunc,
      setPreserve: warningFunc,
      getInitialValue: warningFunc
    };
  }
});
var FieldContext_default = Context2;

// ../../node_modules/rc-field-form/es/ListContext.js
var React85 = __toESM(require("react"));
var ListContext = /* @__PURE__ */ React85.createContext(null);
var ListContext_default = ListContext;

// ../../node_modules/rc-field-form/es/utils/typeUtil.js
function toArray2(value) {
  if (value === void 0 || value === null) {
    return [];
  }
  return Array.isArray(value) ? value : [value];
}
function isFormInstance(form) {
  return form && !!form._init;
}

// ../../node_modules/async-validator/dist-web/index.js
function _extends2() {
  _extends2 = Object.assign ? Object.assign.bind() : function(target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends2.apply(this, arguments);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf2(subClass, superClass);
}
function _getPrototypeOf2(o) {
  _getPrototypeOf2 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf3(o2) {
    return o2.__proto__ || Object.getPrototypeOf(o2);
  };
  return _getPrototypeOf2(o);
}
function _setPrototypeOf2(o, p) {
  _setPrototypeOf2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf3(o2, p2) {
    o2.__proto__ = p2;
    return o2;
  };
  return _setPrototypeOf2(o, p);
}
function _isNativeReflectConstruct2() {
  if (typeof Reflect === "undefined" || !Reflect.construct)
    return false;
  if (Reflect.construct.sham)
    return false;
  if (typeof Proxy === "function")
    return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct2()) {
    _construct = Reflect.construct.bind();
  } else {
    _construct = function _construct2(Parent2, args2, Class2) {
      var a = [null];
      a.push.apply(a, args2);
      var Constructor = Function.bind.apply(Parent2, a);
      var instance = new Constructor();
      if (Class2)
        _setPrototypeOf2(instance, Class2.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? /* @__PURE__ */ new Map() : void 0;
  _wrapNativeSuper = function _wrapNativeSuper2(Class2) {
    if (Class2 === null || !_isNativeFunction(Class2))
      return Class2;
    if (typeof Class2 !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class2))
        return _cache.get(Class2);
      _cache.set(Class2, Wrapper3);
    }
    function Wrapper3() {
      return _construct(Class2, arguments, _getPrototypeOf2(this).constructor);
    }
    Wrapper3.prototype = Object.create(Class2.prototype, {
      constructor: {
        value: Wrapper3,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf2(Wrapper3, Class2);
  };
  return _wrapNativeSuper(Class);
}
var formatRegExp = /%[sdj%]/g;
var warning4 = function warning5() {
};
if (typeof process !== "undefined" && process.env && process.env.NODE_ENV !== "production" && typeof window !== "undefined" && typeof document !== "undefined") {
  warning4 = function warning6(type4, errors) {
    if (typeof console !== "undefined" && console.warn && typeof ASYNC_VALIDATOR_NO_WARNING === "undefined") {
      if (errors.every(function(e) {
        return typeof e === "string";
      })) {
        console.warn(type4, errors);
      }
    }
  };
}
function convertFieldsError(errors) {
  if (!errors || !errors.length)
    return null;
  var fields = {};
  errors.forEach(function(error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}
function format(template) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }
  var i = 0;
  var len = args.length;
  if (typeof template === "function") {
    return template.apply(null, args);
  }
  if (typeof template === "string") {
    var str = template.replace(formatRegExp, function(x2) {
      if (x2 === "%%") {
        return "%";
      }
      if (i >= len) {
        return x2;
      }
      switch (x2) {
        case "%s":
          return String(args[i++]);
        case "%d":
          return Number(args[i++]);
        case "%j":
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return "[Circular]";
          }
          break;
        default:
          return x2;
      }
    });
    return str;
  }
  return template;
}
function isNativeStringType(type4) {
  return type4 === "string" || type4 === "url" || type4 === "hex" || type4 === "email" || type4 === "date" || type4 === "pattern";
}
function isEmptyValue(value, type4) {
  if (value === void 0 || value === null) {
    return true;
  }
  if (type4 === "array" && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type4) && typeof value === "string" && !value) {
    return true;
  }
  return false;
}
function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;
  function count(errors) {
    results.push.apply(results, errors || []);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }
  arr.forEach(function(a) {
    func(a, count);
  });
}
function asyncSerialArray(arr, func, callback) {
  var index2 = 0;
  var arrLength = arr.length;
  function next2(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index2;
    index2 = index2 + 1;
    if (original < arrLength) {
      func(arr[original], next2);
    } else {
      callback([]);
    }
  }
  next2([]);
}
function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function(k) {
    ret.push.apply(ret, objArr[k] || []);
  });
  return ret;
}
var AsyncValidationError = /* @__PURE__ */ function(_Error) {
  _inheritsLoose(AsyncValidationError2, _Error);
  function AsyncValidationError2(errors, fields) {
    var _this;
    _this = _Error.call(this, "Async Validation Error") || this;
    _this.errors = errors;
    _this.fields = fields;
    return _this;
  }
  return AsyncValidationError2;
}(/* @__PURE__ */ _wrapNativeSuper(Error));
function asyncMap(objArr, option, func, callback, source) {
  if (option.first) {
    var _pending = new Promise(function(resolve, reject) {
      var next2 = function next3(errors) {
        callback(errors);
        return errors.length ? reject(new AsyncValidationError(errors, convertFieldsError(errors))) : resolve(source);
      };
      var flattenArr = flattenObjArr(objArr);
      asyncSerialArray(flattenArr, func, next2);
    });
    _pending["catch"](function(e) {
      return e;
    });
    return _pending;
  }
  var firstFields = option.firstFields === true ? Object.keys(objArr) : option.firstFields || [];
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function(resolve, reject) {
    var next2 = function next3(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject(new AsyncValidationError(results, convertFieldsError(results))) : resolve(source);
      }
    };
    if (!objArrKeys.length) {
      callback(results);
      resolve(source);
    }
    objArrKeys.forEach(function(key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next2);
      } else {
        asyncParallelArray(arr, func, next2);
      }
    });
  });
  pending["catch"](function(e) {
    return e;
  });
  return pending;
}
function isErrorObj(obj) {
  return !!(obj && obj.message !== void 0);
}
function getValue2(value, path2) {
  var v = value;
  for (var i = 0; i < path2.length; i++) {
    if (v == void 0) {
      return v;
    }
    v = v[path2[i]];
  }
  return v;
}
function complementError(rule, source) {
  return function(oe) {
    var fieldValue;
    if (rule.fullFields) {
      fieldValue = getValue2(source, rule.fullFields);
    } else {
      fieldValue = source[oe.field || rule.fullField];
    }
    if (isErrorObj(oe)) {
      oe.field = oe.field || rule.fullField;
      oe.fieldValue = fieldValue;
      return oe;
    }
    return {
      message: typeof oe === "function" ? oe() : oe,
      fieldValue,
      field: oe.field || rule.fullField
    };
  };
}
function deepMerge(target, source) {
  if (source) {
    for (var s2 in source) {
      if (source.hasOwnProperty(s2)) {
        var value = source[s2];
        if (typeof value === "object" && typeof target[s2] === "object") {
          target[s2] = _extends2({}, target[s2], value);
        } else {
          target[s2] = value;
        }
      }
    }
  }
  return target;
}
var required$1 = function required(rule, value, source, errors, options, type4) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || isEmptyValue(value, type4 || rule.type))) {
    errors.push(format(options.messages.required, rule.fullField));
  }
};
var whitespace2 = function whitespace3(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === "") {
    errors.push(format(options.messages.whitespace, rule.fullField));
  }
};
var urlReg;
var getUrlRegex = function() {
  if (urlReg) {
    return urlReg;
  }
  var word = "[a-fA-F\\d:]";
  var b = function b10(options) {
    return options && options.includeBoundaries ? "(?:(?<=\\s|^)(?=" + word + ")|(?<=" + word + ")(?=\\s|$))" : "";
  };
  var v4 = "(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}";
  var v6seg = "[a-fA-F\\d]{1,4}";
  var v6 = ("\n(?:\n(?:" + v6seg + ":){7}(?:" + v6seg + "|:)|                                    // 1:2:3:4:5:6:7::  1:2:3:4:5:6:7:8\n(?:" + v6seg + ":){6}(?:" + v4 + "|:" + v6seg + "|:)|                             // 1:2:3:4:5:6::    1:2:3:4:5:6::8   1:2:3:4:5:6::8  1:2:3:4:5:6::1.2.3.4\n(?:" + v6seg + ":){5}(?::" + v4 + "|(?::" + v6seg + "){1,2}|:)|                   // 1:2:3:4:5::      1:2:3:4:5::7:8   1:2:3:4:5::8    1:2:3:4:5::7:1.2.3.4\n(?:" + v6seg + ":){4}(?:(?::" + v6seg + "){0,1}:" + v4 + "|(?::" + v6seg + "){1,3}|:)| // 1:2:3:4::        1:2:3:4::6:7:8   1:2:3:4::8      1:2:3:4::6:7:1.2.3.4\n(?:" + v6seg + ":){3}(?:(?::" + v6seg + "){0,2}:" + v4 + "|(?::" + v6seg + "){1,4}|:)| // 1:2:3::          1:2:3::5:6:7:8   1:2:3::8        1:2:3::5:6:7:1.2.3.4\n(?:" + v6seg + ":){2}(?:(?::" + v6seg + "){0,3}:" + v4 + "|(?::" + v6seg + "){1,5}|:)| // 1:2::            1:2::4:5:6:7:8   1:2::8          1:2::4:5:6:7:1.2.3.4\n(?:" + v6seg + ":){1}(?:(?::" + v6seg + "){0,4}:" + v4 + "|(?::" + v6seg + "){1,6}|:)| // 1::              1::3:4:5:6:7:8   1::8            1::3:4:5:6:7:1.2.3.4\n(?::(?:(?::" + v6seg + "){0,5}:" + v4 + "|(?::" + v6seg + "){1,7}|:))             // ::2:3:4:5:6:7:8  ::2:3:4:5:6:7:8  ::8             ::1.2.3.4\n)(?:%[0-9a-zA-Z]{1,})?                                             // %eth0            %1\n").replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim();
  var v46Exact = new RegExp("(?:^" + v4 + "$)|(?:^" + v6 + "$)");
  var v4exact = new RegExp("^" + v4 + "$");
  var v6exact = new RegExp("^" + v6 + "$");
  var ip = function ip2(options) {
    return options && options.exact ? v46Exact : new RegExp("(?:" + b(options) + v4 + b(options) + ")|(?:" + b(options) + v6 + b(options) + ")", "g");
  };
  ip.v4 = function(options) {
    return options && options.exact ? v4exact : new RegExp("" + b(options) + v4 + b(options), "g");
  };
  ip.v6 = function(options) {
    return options && options.exact ? v6exact : new RegExp("" + b(options) + v6 + b(options), "g");
  };
  var protocol = "(?:(?:[a-z]+:)?//)";
  var auth = "(?:\\S+(?::\\S*)?@)?";
  var ipv4 = ip.v4().source;
  var ipv6 = ip.v6().source;
  var host = "(?:(?:[a-z\\u00a1-\\uffff0-9][-_]*)*[a-z\\u00a1-\\uffff0-9]+)";
  var domain = "(?:\\.(?:[a-z\\u00a1-\\uffff0-9]-*)*[a-z\\u00a1-\\uffff0-9]+)*";
  var tld = "(?:\\.(?:[a-z\\u00a1-\\uffff]{2,}))";
  var port = "(?::\\d{2,5})?";
  var path2 = '(?:[/?#][^\\s"]*)?';
  var regex = "(?:" + protocol + "|www\\.)" + auth + "(?:localhost|" + ipv4 + "|" + ipv6 + "|" + host + domain + tld + ")" + port + path2;
  urlReg = new RegExp("(?:^" + regex + "$)", "i");
  return urlReg;
};
var pattern$2 = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+\.)+[a-zA-Z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]{2,}))$/,
  // url: new RegExp(
  //   '^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-*)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$',
  //   'i',
  // ),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};
var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  "float": function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === "function" && typeof value.getMonth === "function" && typeof value.getYear === "function" && !isNaN(value.getTime());
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === "number";
  },
  object: function object(value) {
    return typeof value === "object" && !types.array(value);
  },
  method: function method(value) {
    return typeof value === "function";
  },
  email: function email(value) {
    return typeof value === "string" && value.length <= 320 && !!value.match(pattern$2.email);
  },
  url: function url(value) {
    return typeof value === "string" && value.length <= 2048 && !!value.match(getUrlRegex());
  },
  hex: function hex(value) {
    return typeof value === "string" && !!value.match(pattern$2.hex);
  }
};
var type$1 = function type(rule, value, source, errors, options) {
  if (rule.required && value === void 0) {
    required$1(rule, value, source, errors, options);
    return;
  }
  var custom = ["integer", "float", "array", "regexp", "object", "method", "email", "number", "date", "url", "hex"];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
  } else if (ruleType && typeof value !== rule.type) {
    errors.push(format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
};
var range = function range2(rule, value, source, errors, options) {
  var len = typeof rule.len === "number";
  var min3 = typeof rule.min === "number";
  var max3 = typeof rule.max === "number";
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === "number";
  var str = typeof value === "string";
  var arr = Array.isArray(value);
  if (num) {
    key = "number";
  } else if (str) {
    key = "string";
  } else if (arr) {
    key = "array";
  }
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    val = value.replace(spRegexp, "_").length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min3 && !max3 && val < rule.min) {
    errors.push(format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max3 && !min3 && val > rule.max) {
    errors.push(format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min3 && max3 && (val < rule.min || val > rule.max)) {
    errors.push(format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
};
var ENUM$1 = "enum";
var enumerable$1 = function enumerable(rule, value, source, errors, options) {
  rule[ENUM$1] = Array.isArray(rule[ENUM$1]) ? rule[ENUM$1] : [];
  if (rule[ENUM$1].indexOf(value) === -1) {
    errors.push(format(options.messages[ENUM$1], rule.fullField, rule[ENUM$1].join(", ")));
  }
};
var pattern$1 = function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === "string") {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
};
var rules = {
  required: required$1,
  whitespace: whitespace2,
  type: type$1,
  range,
  "enum": enumerable$1,
  pattern: pattern$1
};
var string = function string2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "string");
    if (!isEmptyValue(value, "string")) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
      rules.pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        rules.whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
};
var method2 = function method3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var number2 = function number3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === "") {
      value = void 0;
    }
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var _boolean = function _boolean2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var regexp2 = function regexp3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var integer2 = function integer3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var floatFn = function floatFn2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var array2 = function array3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((value === void 0 || value === null) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, "array");
    if (value !== void 0 && value !== null) {
      rules.type(rule, value, source, errors, options);
      rules.range(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var object2 = function object3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var ENUM = "enum";
var enumerable2 = function enumerable3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (value !== void 0) {
      rules[ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var pattern2 = function pattern3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "string") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "string")) {
      rules.pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var date2 = function date3(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, "date") && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
    if (!isEmptyValue(value, "date")) {
      var dateObject;
      if (value instanceof Date) {
        dateObject = value;
      } else {
        dateObject = new Date(value);
      }
      rules.type(rule, dateObject, source, errors, options);
      if (dateObject) {
        rules.range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
};
var required2 = function required3(rule, value, callback, source, options) {
  var errors = [];
  var type4 = Array.isArray(value) ? "array" : typeof value;
  rules.required(rule, value, source, errors, options, type4);
  callback(errors);
};
var type2 = function type3(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value, ruleType) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options, ruleType);
    if (!isEmptyValue(value, ruleType)) {
      rules.type(rule, value, source, errors, options);
    }
  }
  callback(errors);
};
var any = function any2(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (isEmptyValue(value) && !rule.required) {
      return callback();
    }
    rules.required(rule, value, source, errors, options);
  }
  callback(errors);
};
var validators = {
  string,
  method: method2,
  number: number2,
  "boolean": _boolean,
  regexp: regexp2,
  integer: integer2,
  "float": floatFn,
  array: array2,
  object: object2,
  "enum": enumerable2,
  pattern: pattern2,
  date: date2,
  url: type2,
  hex: type2,
  email: type2,
  required: required2,
  any
};
function newMessages() {
  return {
    "default": "Validation error on field %s",
    required: "%s is required",
    "enum": "%s must be one of %s",
    whitespace: "%s cannot be empty",
    date: {
      format: "%s date %s is invalid for format %s",
      parse: "%s date could not be parsed, %s is invalid ",
      invalid: "%s date %s is invalid"
    },
    types: {
      string: "%s is not a %s",
      method: "%s is not a %s (function)",
      array: "%s is not an %s",
      object: "%s is not an %s",
      number: "%s is not a %s",
      date: "%s is not a %s",
      "boolean": "%s is not a %s",
      integer: "%s is not an %s",
      "float": "%s is not a %s",
      regexp: "%s is not a valid %s",
      email: "%s is not a valid %s",
      url: "%s is not a valid %s",
      hex: "%s is not a valid %s"
    },
    string: {
      len: "%s must be exactly %s characters",
      min: "%s must be at least %s characters",
      max: "%s cannot be longer than %s characters",
      range: "%s must be between %s and %s characters"
    },
    number: {
      len: "%s must equal %s",
      min: "%s cannot be less than %s",
      max: "%s cannot be greater than %s",
      range: "%s must be between %s and %s"
    },
    array: {
      len: "%s must be exactly %s in length",
      min: "%s cannot be less than %s in length",
      max: "%s cannot be greater than %s in length",
      range: "%s must be between %s and %s in length"
    },
    pattern: {
      mismatch: "%s value %s does not match pattern %s"
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}
var messages = newMessages();
var Schema = /* @__PURE__ */ function() {
  function Schema2(descriptor) {
    this.rules = null;
    this._messages = messages;
    this.define(descriptor);
  }
  var _proto = Schema2.prototype;
  _proto.define = function define2(rules2) {
    var _this = this;
    if (!rules2) {
      throw new Error("Cannot configure a schema with no rules");
    }
    if (typeof rules2 !== "object" || Array.isArray(rules2)) {
      throw new Error("Rules must be an object");
    }
    this.rules = {};
    Object.keys(rules2).forEach(function(name) {
      var item = rules2[name];
      _this.rules[name] = Array.isArray(item) ? item : [item];
    });
  };
  _proto.messages = function messages2(_messages) {
    if (_messages) {
      this._messages = deepMerge(newMessages(), _messages);
    }
    return this._messages;
  };
  _proto.validate = function validate(source_, o, oc) {
    var _this2 = this;
    if (o === void 0) {
      o = {};
    }
    if (oc === void 0) {
      oc = function oc2() {
      };
    }
    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === "function") {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback(null, source);
      }
      return Promise.resolve(source);
    }
    function complete(results) {
      var errors = [];
      var fields = {};
      function add(e) {
        if (Array.isArray(e)) {
          var _errors;
          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }
      for (var i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        callback(null, source);
      } else {
        fields = convertFieldsError(errors);
        callback(errors, fields);
      }
    }
    if (options.messages) {
      var messages$1 = this.messages();
      if (messages$1 === messages) {
        messages$1 = newMessages();
      }
      deepMerge(messages$1, options.messages);
      options.messages = messages$1;
    } else {
      options.messages = this.messages();
    }
    var series = {};
    var keys3 = options.keys || Object.keys(this.rules);
    keys3.forEach(function(z) {
      var arr = _this2.rules[z];
      var value = source[z];
      arr.forEach(function(r) {
        var rule = r;
        if (typeof rule.transform === "function") {
          if (source === source_) {
            source = _extends2({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === "function") {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends2({}, rule);
        }
        rule.validator = _this2.getValidationMethod(rule);
        if (!rule.validator) {
          return;
        }
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this2.getType(rule);
        series[z] = series[z] || [];
        series[z].push({
          rule,
          value,
          source,
          field: z
        });
      });
    });
    var errorFields = {};
    return asyncMap(series, options, function(data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === "object" || rule.type === "array") && (typeof rule.fields === "object" || typeof rule.defaultField === "object");
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;
      function addFullField(key, schema) {
        return _extends2({}, schema, {
          fullField: rule.fullField + "." + key,
          fullFields: rule.fullFields ? [].concat(rule.fullFields, [key]) : [key]
        });
      }
      function cb(e) {
        if (e === void 0) {
          e = [];
        }
        var errorList = Array.isArray(e) ? e : [e];
        if (!options.suppressWarning && errorList.length) {
          Schema2.warning("async-validator:", errorList);
        }
        if (errorList.length && rule.message !== void 0) {
          errorList = [].concat(rule.message);
        }
        var filledErrors = errorList.map(complementError(rule, source));
        if (options.first && filledErrors.length) {
          errorFields[rule.field] = 1;
          return doIt(filledErrors);
        }
        if (!deep) {
          doIt(filledErrors);
        } else {
          if (rule.required && !data.value) {
            if (rule.message !== void 0) {
              filledErrors = [].concat(rule.message).map(complementError(rule, source));
            } else if (options.error) {
              filledErrors = [options.error(rule, format(options.messages.required, rule.field))];
            }
            return doIt(filledErrors);
          }
          var fieldsSchema = {};
          if (rule.defaultField) {
            Object.keys(data.value).map(function(key) {
              fieldsSchema[key] = rule.defaultField;
            });
          }
          fieldsSchema = _extends2({}, fieldsSchema, data.rule.fields);
          var paredFieldsSchema = {};
          Object.keys(fieldsSchema).forEach(function(field) {
            var fieldSchema = fieldsSchema[field];
            var fieldSchemaList = Array.isArray(fieldSchema) ? fieldSchema : [fieldSchema];
            paredFieldsSchema[field] = fieldSchemaList.map(addFullField.bind(null, field));
          });
          var schema = new Schema2(paredFieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function(errs) {
            var finalErrors = [];
            if (filledErrors && filledErrors.length) {
              finalErrors.push.apply(finalErrors, filledErrors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }
      var res;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        try {
          res = rule.validator(rule, data.value, cb, data.source, options);
        } catch (error) {
          console.error == null ? void 0 : console.error(error);
          if (!options.suppressValidatorError) {
            setTimeout(function() {
              throw error;
            }, 0);
          }
          cb(error.message);
        }
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(typeof rule.message === "function" ? rule.message(rule.fullField || rule.field) : rule.message || (rule.fullField || rule.field) + " fails");
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function() {
          return cb();
        }, function(e) {
          return cb(e);
        });
      }
    }, function(results) {
      complete(results);
    }, source);
  };
  _proto.getType = function getType2(rule) {
    if (rule.type === void 0 && rule.pattern instanceof RegExp) {
      rule.type = "pattern";
    }
    if (typeof rule.validator !== "function" && rule.type && !validators.hasOwnProperty(rule.type)) {
      throw new Error(format("Unknown rule type %s", rule.type));
    }
    return rule.type || "string";
  };
  _proto.getValidationMethod = function getValidationMethod(rule) {
    if (typeof rule.validator === "function") {
      return rule.validator;
    }
    var keys3 = Object.keys(rule);
    var messageIndex = keys3.indexOf("message");
    if (messageIndex !== -1) {
      keys3.splice(messageIndex, 1);
    }
    if (keys3.length === 1 && keys3[0] === "required") {
      return validators.required;
    }
    return validators[this.getType(rule)] || void 0;
  };
  return Schema2;
}();
Schema.register = function register(type4, validator) {
  if (typeof validator !== "function") {
    throw new Error("Cannot register a validator by type, validator is not a function");
  }
  validators[type4] = validator;
};
Schema.warning = warning4;
Schema.messages = messages;
Schema.validators = validators;

// ../../node_modules/rc-field-form/es/utils/validateUtil.js
var React86 = __toESM(require("react"));

// ../../node_modules/rc-field-form/es/utils/messages.js
var typeTemplate2 = "'${name}' is not a valid ${type}";
var defaultValidateMessages = {
  default: "Validation error on field '${name}'",
  required: "'${name}' is required",
  enum: "'${name}' must be one of [${enum}]",
  whitespace: "'${name}' cannot be empty",
  date: {
    format: "'${name}' is invalid for format date",
    parse: "'${name}' could not be parsed as date",
    invalid: "'${name}' is invalid date"
  },
  types: {
    string: typeTemplate2,
    method: typeTemplate2,
    array: typeTemplate2,
    object: typeTemplate2,
    number: typeTemplate2,
    date: typeTemplate2,
    boolean: typeTemplate2,
    integer: typeTemplate2,
    float: typeTemplate2,
    regexp: typeTemplate2,
    email: typeTemplate2,
    url: typeTemplate2,
    hex: typeTemplate2
  },
  string: {
    len: "'${name}' must be exactly ${len} characters",
    min: "'${name}' must be at least ${min} characters",
    max: "'${name}' cannot be longer than ${max} characters",
    range: "'${name}' must be between ${min} and ${max} characters"
  },
  number: {
    len: "'${name}' must equal ${len}",
    min: "'${name}' cannot be less than ${min}",
    max: "'${name}' cannot be greater than ${max}",
    range: "'${name}' must be between ${min} and ${max}"
  },
  array: {
    len: "'${name}' must be exactly ${len} in length",
    min: "'${name}' cannot be less than ${min} in length",
    max: "'${name}' cannot be greater than ${max} in length",
    range: "'${name}' must be between ${min} and ${max} in length"
  },
  pattern: {
    mismatch: "'${name}' does not match pattern ${pattern}"
  }
};

// ../../node_modules/rc-field-form/es/utils/validateUtil.js
var AsyncValidator = Schema;
function replaceMessage(template, kv) {
  return template.replace(/\$\{\w+\}/g, function(str) {
    var key = str.slice(2, -1);
    return kv[key];
  });
}
var CODE_LOGIC_ERROR = "CODE_LOGIC_ERROR";
function validateRule(_x, _x2, _x3, _x4, _x5) {
  return _validateRule.apply(this, arguments);
}
function _validateRule() {
  _validateRule = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee2(name, value, rule, options, messageVariables) {
    var cloneRule, originValidator, subRuleField, validator, messages2, result, subResults, kv, fillVariableResult;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1)
        switch (_context2.prev = _context2.next) {
          case 0:
            cloneRule = _objectSpread2({}, rule);
            delete cloneRule.ruleIndex;
            AsyncValidator.warning = function() {
              return void 0;
            };
            if (cloneRule.validator) {
              originValidator = cloneRule.validator;
              cloneRule.validator = function() {
                try {
                  return originValidator.apply(void 0, arguments);
                } catch (error) {
                  console.error(error);
                  return Promise.reject(CODE_LOGIC_ERROR);
                }
              };
            }
            subRuleField = null;
            if (cloneRule && cloneRule.type === "array" && cloneRule.defaultField) {
              subRuleField = cloneRule.defaultField;
              delete cloneRule.defaultField;
            }
            validator = new AsyncValidator(_defineProperty({}, name, [cloneRule]));
            messages2 = merge(defaultValidateMessages, options.validateMessages);
            validator.messages(messages2);
            result = [];
            _context2.prev = 10;
            _context2.next = 13;
            return Promise.resolve(validator.validate(_defineProperty({}, name, value), _objectSpread2({}, options)));
          case 13:
            _context2.next = 18;
            break;
          case 15:
            _context2.prev = 15;
            _context2.t0 = _context2["catch"](10);
            if (_context2.t0.errors) {
              result = _context2.t0.errors.map(function(_ref4, index2) {
                var message2 = _ref4.message;
                var mergedMessage = message2 === CODE_LOGIC_ERROR ? messages2.default : message2;
                return /* @__PURE__ */ React86.isValidElement(mergedMessage) ? (
                  // Wrap ReactNode with `key`
                  /* @__PURE__ */ React86.cloneElement(mergedMessage, {
                    key: "error_".concat(index2)
                  })
                ) : mergedMessage;
              });
            }
          case 18:
            if (!(!result.length && subRuleField)) {
              _context2.next = 23;
              break;
            }
            _context2.next = 21;
            return Promise.all(value.map(function(subValue, i) {
              return validateRule("".concat(name, ".").concat(i), subValue, subRuleField, options, messageVariables);
            }));
          case 21:
            subResults = _context2.sent;
            return _context2.abrupt("return", subResults.reduce(function(prev2, errors) {
              return [].concat(_toConsumableArray(prev2), _toConsumableArray(errors));
            }, []));
          case 23:
            kv = _objectSpread2(_objectSpread2({}, rule), {}, {
              name,
              enum: (rule.enum || []).join(", ")
            }, messageVariables);
            fillVariableResult = result.map(function(error) {
              if (typeof error === "string") {
                return replaceMessage(error, kv);
              }
              return error;
            });
            return _context2.abrupt("return", fillVariableResult);
          case 26:
          case "end":
            return _context2.stop();
        }
    }, _callee2, null, [[10, 15]]);
  }));
  return _validateRule.apply(this, arguments);
}
function validateRules(namePath, value, rules2, options, validateFirst, messageVariables) {
  var name = namePath.join(".");
  var filledRules = rules2.map(function(currentRule, ruleIndex) {
    var originValidatorFunc = currentRule.validator;
    var cloneRule = _objectSpread2(_objectSpread2({}, currentRule), {}, {
      ruleIndex
    });
    if (originValidatorFunc) {
      cloneRule.validator = function(rule, val, callback) {
        var hasPromise = false;
        var wrappedCallback = function wrappedCallback2() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          Promise.resolve().then(function() {
            warning_default(!hasPromise, "Your validator function has already return a promise. `callback` will be ignored.");
            if (!hasPromise) {
              callback.apply(void 0, args);
            }
          });
        };
        var promise = originValidatorFunc(rule, val, wrappedCallback);
        hasPromise = promise && typeof promise.then === "function" && typeof promise.catch === "function";
        warning_default(hasPromise, "`callback` is deprecated. Please return a promise instead.");
        if (hasPromise) {
          promise.then(function() {
            callback();
          }).catch(function(err) {
            callback(err || " ");
          });
        }
      };
    }
    return cloneRule;
  }).sort(function(_ref, _ref2) {
    var w1 = _ref.warningOnly, i1 = _ref.ruleIndex;
    var w2 = _ref2.warningOnly, i2 = _ref2.ruleIndex;
    if (!!w1 === !!w2) {
      return i1 - i2;
    }
    if (w1) {
      return 1;
    }
    return -1;
  });
  var summaryPromise;
  if (validateFirst === true) {
    summaryPromise = new Promise(/* @__PURE__ */ function() {
      var _ref3 = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee(resolve, reject) {
        var i, rule, errors;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1)
            switch (_context.prev = _context.next) {
              case 0:
                i = 0;
              case 1:
                if (!(i < filledRules.length)) {
                  _context.next = 12;
                  break;
                }
                rule = filledRules[i];
                _context.next = 5;
                return validateRule(name, value, rule, options, messageVariables);
              case 5:
                errors = _context.sent;
                if (!errors.length) {
                  _context.next = 9;
                  break;
                }
                reject([{
                  errors,
                  rule
                }]);
                return _context.abrupt("return");
              case 9:
                i += 1;
                _context.next = 1;
                break;
              case 12:
                resolve([]);
              case 13:
              case "end":
                return _context.stop();
            }
        }, _callee);
      }));
      return function(_x6, _x7) {
        return _ref3.apply(this, arguments);
      };
    }());
  } else {
    var rulePromises = filledRules.map(function(rule) {
      return validateRule(name, value, rule, options, messageVariables).then(function(errors) {
        return {
          errors,
          rule
        };
      });
    });
    summaryPromise = (validateFirst ? finishOnFirstFailed(rulePromises) : finishOnAllFailed(rulePromises)).then(function(errors) {
      return Promise.reject(errors);
    });
  }
  summaryPromise.catch(function(e) {
    return e;
  });
  return summaryPromise;
}
function finishOnAllFailed(_x8) {
  return _finishOnAllFailed.apply(this, arguments);
}
function _finishOnAllFailed() {
  _finishOnAllFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee3(rulePromises) {
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1)
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", Promise.all(rulePromises).then(function(errorsList) {
              var _ref5;
              var errors = (_ref5 = []).concat.apply(_ref5, _toConsumableArray(errorsList));
              return errors;
            }));
          case 1:
          case "end":
            return _context3.stop();
        }
    }, _callee3);
  }));
  return _finishOnAllFailed.apply(this, arguments);
}
function finishOnFirstFailed(_x9) {
  return _finishOnFirstFailed.apply(this, arguments);
}
function _finishOnFirstFailed() {
  _finishOnFirstFailed = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee4(rulePromises) {
    var count;
    return _regeneratorRuntime().wrap(function _callee4$(_context4) {
      while (1)
        switch (_context4.prev = _context4.next) {
          case 0:
            count = 0;
            return _context4.abrupt("return", new Promise(function(resolve) {
              rulePromises.forEach(function(promise) {
                promise.then(function(ruleError) {
                  if (ruleError.errors.length) {
                    resolve([ruleError]);
                  }
                  count += 1;
                  if (count === rulePromises.length) {
                    resolve([]);
                  }
                });
              });
            }));
          case 2:
          case "end":
            return _context4.stop();
        }
    }, _callee4);
  }));
  return _finishOnFirstFailed.apply(this, arguments);
}

// ../../node_modules/rc-field-form/es/utils/valueUtil.js
function getNamePath(path2) {
  return toArray2(path2);
}
function cloneByNamePathList(store, namePathList) {
  var newStore = {};
  namePathList.forEach(function(namePath) {
    var value = get(store, namePath);
    newStore = set(newStore, namePath, value);
  });
  return newStore;
}
function containsNamePath(namePathList, namePath) {
  var partialMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  return namePathList && namePathList.some(function(path2) {
    return matchNamePath(namePath, path2, partialMatch);
  });
}
function matchNamePath(namePath, subNamePath) {
  var partialMatch = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (!namePath || !subNamePath) {
    return false;
  }
  if (!partialMatch && namePath.length !== subNamePath.length) {
    return false;
  }
  return subNamePath.every(function(nameUnit, i) {
    return namePath[i] === nameUnit;
  });
}
function isSimilar(source, target) {
  if (source === target) {
    return true;
  }
  if (!source && target || source && !target) {
    return false;
  }
  if (!source || !target || _typeof(source) !== "object" || _typeof(target) !== "object") {
    return false;
  }
  var sourceKeys = Object.keys(source);
  var targetKeys = Object.keys(target);
  var keys3 = new Set([].concat(sourceKeys, targetKeys));
  return _toConsumableArray(keys3).every(function(key) {
    var sourceValue = source[key];
    var targetValue = target[key];
    if (typeof sourceValue === "function" && typeof targetValue === "function") {
      return true;
    }
    return sourceValue === targetValue;
  });
}
function defaultGetValueFromEvent(valuePropName) {
  var event = arguments.length <= 1 ? void 0 : arguments[1];
  if (event && event.target && _typeof(event.target) === "object" && valuePropName in event.target) {
    return event.target[valuePropName];
  }
  return event;
}
function move(array4, moveIndex, toIndex) {
  var length2 = array4.length;
  if (moveIndex < 0 || moveIndex >= length2 || toIndex < 0 || toIndex >= length2) {
    return array4;
  }
  var item = array4[moveIndex];
  var diff = moveIndex - toIndex;
  if (diff > 0) {
    return [].concat(_toConsumableArray(array4.slice(0, toIndex)), [item], _toConsumableArray(array4.slice(toIndex, moveIndex)), _toConsumableArray(array4.slice(moveIndex + 1, length2)));
  }
  if (diff < 0) {
    return [].concat(_toConsumableArray(array4.slice(0, moveIndex)), _toConsumableArray(array4.slice(moveIndex + 1, toIndex + 1)), [item], _toConsumableArray(array4.slice(toIndex + 1, length2)));
  }
  return array4;
}

// ../../node_modules/rc-field-form/es/Field.js
var _excluded7 = ["name"];
var EMPTY_ERRORS = [];
function requireUpdate(shouldUpdate, prev2, next2, prevValue, nextValue, info) {
  if (typeof shouldUpdate === "function") {
    return shouldUpdate(prev2, next2, "source" in info ? {
      source: info.source
    } : {});
  }
  return prevValue !== nextValue;
}
var Field = /* @__PURE__ */ function(_React$Component) {
  _inherits(Field2, _React$Component);
  var _super = _createSuper(Field2);
  function Field2(props) {
    var _this;
    _classCallCheck(this, Field2);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "state", {
      resetCount: 0
    });
    _defineProperty(_assertThisInitialized(_this), "cancelRegisterFunc", null);
    _defineProperty(_assertThisInitialized(_this), "mounted", false);
    _defineProperty(_assertThisInitialized(_this), "touched", false);
    _defineProperty(_assertThisInitialized(_this), "dirty", false);
    _defineProperty(_assertThisInitialized(_this), "validatePromise", void 0);
    _defineProperty(_assertThisInitialized(_this), "prevValidating", void 0);
    _defineProperty(_assertThisInitialized(_this), "errors", EMPTY_ERRORS);
    _defineProperty(_assertThisInitialized(_this), "warnings", EMPTY_ERRORS);
    _defineProperty(_assertThisInitialized(_this), "cancelRegister", function() {
      var _this$props = _this.props, preserve2 = _this$props.preserve, isListField = _this$props.isListField, name = _this$props.name;
      if (_this.cancelRegisterFunc) {
        _this.cancelRegisterFunc(isListField, preserve2, getNamePath(name));
      }
      _this.cancelRegisterFunc = null;
    });
    _defineProperty(_assertThisInitialized(_this), "getNamePath", function() {
      var _this$props2 = _this.props, name = _this$props2.name, fieldContext = _this$props2.fieldContext;
      var _fieldContext$prefixN = fieldContext.prefixName, prefixName = _fieldContext$prefixN === void 0 ? [] : _fieldContext$prefixN;
      return name !== void 0 ? [].concat(_toConsumableArray(prefixName), _toConsumableArray(name)) : [];
    });
    _defineProperty(_assertThisInitialized(_this), "getRules", function() {
      var _this$props3 = _this.props, _this$props3$rules = _this$props3.rules, rules2 = _this$props3$rules === void 0 ? [] : _this$props3$rules, fieldContext = _this$props3.fieldContext;
      return rules2.map(function(rule) {
        if (typeof rule === "function") {
          return rule(fieldContext);
        }
        return rule;
      });
    });
    _defineProperty(_assertThisInitialized(_this), "refresh", function() {
      if (!_this.mounted)
        return;
      _this.setState(function(_ref) {
        var resetCount = _ref.resetCount;
        return {
          resetCount: resetCount + 1
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "metaCache", null);
    _defineProperty(_assertThisInitialized(_this), "triggerMetaEvent", function(destroy3) {
      var onMetaChange = _this.props.onMetaChange;
      if (onMetaChange) {
        var _meta = _objectSpread2(_objectSpread2({}, _this.getMeta()), {}, {
          destroy: destroy3
        });
        if (!isEqual_default(_this.metaCache, _meta)) {
          onMetaChange(_meta);
        }
        _this.metaCache = _meta;
      } else {
        _this.metaCache = null;
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onStoreChange", function(prevStore, namePathList, info) {
      var _this$props4 = _this.props, shouldUpdate = _this$props4.shouldUpdate, _this$props4$dependen = _this$props4.dependencies, dependencies = _this$props4$dependen === void 0 ? [] : _this$props4$dependen, onReset = _this$props4.onReset;
      var store = info.store;
      var namePath = _this.getNamePath();
      var prevValue = _this.getValue(prevStore);
      var curValue = _this.getValue(store);
      var namePathMatch = namePathList && containsNamePath(namePathList, namePath);
      if (info.type === "valueUpdate" && info.source === "external" && prevValue !== curValue) {
        _this.touched = true;
        _this.dirty = true;
        _this.validatePromise = null;
        _this.errors = EMPTY_ERRORS;
        _this.warnings = EMPTY_ERRORS;
        _this.triggerMetaEvent();
      }
      switch (info.type) {
        case "reset":
          if (!namePathList || namePathMatch) {
            _this.touched = false;
            _this.dirty = false;
            _this.validatePromise = void 0;
            _this.errors = EMPTY_ERRORS;
            _this.warnings = EMPTY_ERRORS;
            _this.triggerMetaEvent();
            onReset === null || onReset === void 0 || onReset();
            _this.refresh();
            return;
          }
          break;
        case "remove": {
          if (shouldUpdate) {
            _this.reRender();
            return;
          }
          break;
        }
        case "setField": {
          var data = info.data;
          if (namePathMatch) {
            if ("touched" in data) {
              _this.touched = data.touched;
            }
            if ("validating" in data && !("originRCField" in data)) {
              _this.validatePromise = data.validating ? Promise.resolve([]) : null;
            }
            if ("errors" in data) {
              _this.errors = data.errors || EMPTY_ERRORS;
            }
            if ("warnings" in data) {
              _this.warnings = data.warnings || EMPTY_ERRORS;
            }
            _this.dirty = true;
            _this.triggerMetaEvent();
            _this.reRender();
            return;
          } else if ("value" in data && containsNamePath(namePathList, namePath, true)) {
            _this.reRender();
            return;
          }
          if (shouldUpdate && !namePath.length && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this.reRender();
            return;
          }
          break;
        }
        case "dependenciesUpdate": {
          var dependencyList = dependencies.map(getNamePath);
          if (dependencyList.some(function(dependency) {
            return containsNamePath(info.relatedFields, dependency);
          })) {
            _this.reRender();
            return;
          }
          break;
        }
        default:
          if (namePathMatch || (!dependencies.length || namePath.length || shouldUpdate) && requireUpdate(shouldUpdate, prevStore, store, prevValue, curValue, info)) {
            _this.reRender();
            return;
          }
          break;
      }
      if (shouldUpdate === true) {
        _this.reRender();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "validateRules", function(options) {
      var namePath = _this.getNamePath();
      var currentValue = _this.getValue();
      var _ref2 = options || {}, triggerName = _ref2.triggerName, _ref2$validateOnly = _ref2.validateOnly, validateOnly = _ref2$validateOnly === void 0 ? false : _ref2$validateOnly;
      var rootPromise = Promise.resolve().then(/* @__PURE__ */ _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee() {
        var _this$props5, _this$props5$validate, validateFirst, messageVariables, validateDebounce, filteredRules, promise;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1)
            switch (_context.prev = _context.next) {
              case 0:
                if (_this.mounted) {
                  _context.next = 2;
                  break;
                }
                return _context.abrupt("return", []);
              case 2:
                _this$props5 = _this.props, _this$props5$validate = _this$props5.validateFirst, validateFirst = _this$props5$validate === void 0 ? false : _this$props5$validate, messageVariables = _this$props5.messageVariables, validateDebounce = _this$props5.validateDebounce;
                filteredRules = _this.getRules();
                if (triggerName) {
                  filteredRules = filteredRules.filter(function(rule) {
                    return rule;
                  }).filter(function(rule) {
                    var validateTrigger = rule.validateTrigger;
                    if (!validateTrigger) {
                      return true;
                    }
                    var triggerList = toArray2(validateTrigger);
                    return triggerList.includes(triggerName);
                  });
                }
                if (!(validateDebounce && triggerName)) {
                  _context.next = 10;
                  break;
                }
                _context.next = 8;
                return new Promise(function(resolve) {
                  setTimeout(resolve, validateDebounce);
                });
              case 8:
                if (!(_this.validatePromise !== rootPromise)) {
                  _context.next = 10;
                  break;
                }
                return _context.abrupt("return", []);
              case 10:
                promise = validateRules(namePath, currentValue, filteredRules, options, validateFirst, messageVariables);
                promise.catch(function(e) {
                  return e;
                }).then(function() {
                  var ruleErrors = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : EMPTY_ERRORS;
                  if (_this.validatePromise === rootPromise) {
                    var _ruleErrors$forEach;
                    _this.validatePromise = null;
                    var nextErrors = [];
                    var nextWarnings = [];
                    (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref4) {
                      var warningOnly = _ref4.rule.warningOnly, _ref4$errors = _ref4.errors, errors = _ref4$errors === void 0 ? EMPTY_ERRORS : _ref4$errors;
                      if (warningOnly) {
                        nextWarnings.push.apply(nextWarnings, _toConsumableArray(errors));
                      } else {
                        nextErrors.push.apply(nextErrors, _toConsumableArray(errors));
                      }
                    });
                    _this.errors = nextErrors;
                    _this.warnings = nextWarnings;
                    _this.triggerMetaEvent();
                    _this.reRender();
                  }
                });
                return _context.abrupt("return", promise);
              case 13:
              case "end":
                return _context.stop();
            }
        }, _callee);
      })));
      if (validateOnly) {
        return rootPromise;
      }
      _this.validatePromise = rootPromise;
      _this.dirty = true;
      _this.errors = EMPTY_ERRORS;
      _this.warnings = EMPTY_ERRORS;
      _this.triggerMetaEvent();
      _this.reRender();
      return rootPromise;
    });
    _defineProperty(_assertThisInitialized(_this), "isFieldValidating", function() {
      return !!_this.validatePromise;
    });
    _defineProperty(_assertThisInitialized(_this), "isFieldTouched", function() {
      return _this.touched;
    });
    _defineProperty(_assertThisInitialized(_this), "isFieldDirty", function() {
      if (_this.dirty || _this.props.initialValue !== void 0) {
        return true;
      }
      var fieldContext = _this.props.fieldContext;
      var _fieldContext$getInte = fieldContext.getInternalHooks(HOOK_MARK), getInitialValue = _fieldContext$getInte.getInitialValue;
      if (getInitialValue(_this.getNamePath()) !== void 0) {
        return true;
      }
      return false;
    });
    _defineProperty(_assertThisInitialized(_this), "getErrors", function() {
      return _this.errors;
    });
    _defineProperty(_assertThisInitialized(_this), "getWarnings", function() {
      return _this.warnings;
    });
    _defineProperty(_assertThisInitialized(_this), "isListField", function() {
      return _this.props.isListField;
    });
    _defineProperty(_assertThisInitialized(_this), "isList", function() {
      return _this.props.isList;
    });
    _defineProperty(_assertThisInitialized(_this), "isPreserve", function() {
      return _this.props.preserve;
    });
    _defineProperty(_assertThisInitialized(_this), "getMeta", function() {
      _this.prevValidating = _this.isFieldValidating();
      var meta = {
        touched: _this.isFieldTouched(),
        validating: _this.prevValidating,
        errors: _this.errors,
        warnings: _this.warnings,
        name: _this.getNamePath(),
        validated: _this.validatePromise === null
      };
      return meta;
    });
    _defineProperty(_assertThisInitialized(_this), "getOnlyChild", function(children) {
      if (typeof children === "function") {
        var _meta2 = _this.getMeta();
        return _objectSpread2(_objectSpread2({}, _this.getOnlyChild(children(_this.getControlled(), _meta2, _this.props.fieldContext))), {}, {
          isFunction: true
        });
      }
      var childList = toArray(children);
      if (childList.length !== 1 || !/* @__PURE__ */ React87.isValidElement(childList[0])) {
        return {
          child: childList,
          isFunction: false
        };
      }
      return {
        child: childList[0],
        isFunction: false
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getValue", function(store) {
      var getFieldsValue = _this.props.fieldContext.getFieldsValue;
      var namePath = _this.getNamePath();
      return get(store || getFieldsValue(true), namePath);
    });
    _defineProperty(_assertThisInitialized(_this), "getControlled", function() {
      var childProps = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
      var _this$props6 = _this.props, trigger = _this$props6.trigger, validateTrigger = _this$props6.validateTrigger, getValueFromEvent = _this$props6.getValueFromEvent, normalize2 = _this$props6.normalize, valuePropName = _this$props6.valuePropName, getValueProps = _this$props6.getValueProps, fieldContext = _this$props6.fieldContext;
      var mergedValidateTrigger = validateTrigger !== void 0 ? validateTrigger : fieldContext.validateTrigger;
      var namePath = _this.getNamePath();
      var getInternalHooks3 = fieldContext.getInternalHooks, getFieldsValue = fieldContext.getFieldsValue;
      var _getInternalHooks = getInternalHooks3(HOOK_MARK), dispatch = _getInternalHooks.dispatch;
      var value = _this.getValue();
      var mergedGetValueProps = getValueProps || function(val) {
        return _defineProperty({}, valuePropName, val);
      };
      var originTriggerFunc = childProps[trigger];
      var control = _objectSpread2(_objectSpread2({}, childProps), mergedGetValueProps(value));
      control[trigger] = function() {
        _this.touched = true;
        _this.dirty = true;
        _this.triggerMetaEvent();
        var newValue;
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        if (getValueFromEvent) {
          newValue = getValueFromEvent.apply(void 0, args);
        } else {
          newValue = defaultGetValueFromEvent.apply(void 0, [valuePropName].concat(args));
        }
        if (normalize2) {
          newValue = normalize2(newValue, value, getFieldsValue(true));
        }
        dispatch({
          type: "updateValue",
          namePath,
          value: newValue
        });
        if (originTriggerFunc) {
          originTriggerFunc.apply(void 0, args);
        }
      };
      var validateTriggerList = toArray2(mergedValidateTrigger || []);
      validateTriggerList.forEach(function(triggerName) {
        var originTrigger = control[triggerName];
        control[triggerName] = function() {
          if (originTrigger) {
            originTrigger.apply(void 0, arguments);
          }
          var rules2 = _this.props.rules;
          if (rules2 && rules2.length) {
            dispatch({
              type: "validateField",
              namePath,
              triggerName
            });
          }
        };
      });
      return control;
    });
    if (props.fieldContext) {
      var getInternalHooks2 = props.fieldContext.getInternalHooks;
      var _getInternalHooks2 = getInternalHooks2(HOOK_MARK), initEntityValue = _getInternalHooks2.initEntityValue;
      initEntityValue(_assertThisInitialized(_this));
    }
    return _this;
  }
  _createClass(Field2, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props7 = this.props, shouldUpdate = _this$props7.shouldUpdate, fieldContext = _this$props7.fieldContext;
      this.mounted = true;
      if (fieldContext) {
        var getInternalHooks2 = fieldContext.getInternalHooks;
        var _getInternalHooks3 = getInternalHooks2(HOOK_MARK), registerField = _getInternalHooks3.registerField;
        this.cancelRegisterFunc = registerField(this);
      }
      if (shouldUpdate === true) {
        this.reRender();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelRegister();
      this.triggerMetaEvent(true);
      this.mounted = false;
    }
  }, {
    key: "reRender",
    value: function reRender() {
      if (!this.mounted)
        return;
      this.forceUpdate();
    }
  }, {
    key: "render",
    value: function render2() {
      var resetCount = this.state.resetCount;
      var children = this.props.children;
      var _this$getOnlyChild = this.getOnlyChild(children), child = _this$getOnlyChild.child, isFunction = _this$getOnlyChild.isFunction;
      var returnChildNode;
      if (isFunction) {
        returnChildNode = child;
      } else if (/* @__PURE__ */ React87.isValidElement(child)) {
        returnChildNode = /* @__PURE__ */ React87.cloneElement(child, this.getControlled(child.props));
      } else {
        warning_default(!child, "`children` of Field is not validate ReactElement.");
        returnChildNode = child;
      }
      return /* @__PURE__ */ React87.createElement(React87.Fragment, {
        key: resetCount
      }, returnChildNode);
    }
  }]);
  return Field2;
}(React87.Component);
_defineProperty(Field, "contextType", FieldContext_default);
_defineProperty(Field, "defaultProps", {
  trigger: "onChange",
  valuePropName: "value"
});
function WrapperField(_ref6) {
  var name = _ref6.name, restProps = _objectWithoutProperties(_ref6, _excluded7);
  var fieldContext = React87.useContext(FieldContext_default);
  var listContext = React87.useContext(ListContext_default);
  var namePath = name !== void 0 ? getNamePath(name) : void 0;
  var key = "keep";
  if (!restProps.isListField) {
    key = "_".concat((namePath || []).join("_"));
  }
  if (process.env.NODE_ENV !== "production" && restProps.preserve === false && restProps.isListField && namePath.length <= 1) {
    warning_default(false, "`preserve` should not apply on Form.List fields.");
  }
  return /* @__PURE__ */ React87.createElement(Field, _extends({
    key,
    name: namePath,
    isListField: !!listContext
  }, restProps, {
    fieldContext
  }));
}
var Field_default = WrapperField;

// ../../node_modules/rc-field-form/es/List.js
var React88 = __toESM(require("react"));
function List(_ref) {
  var name = _ref.name, initialValue = _ref.initialValue, children = _ref.children, rules2 = _ref.rules, validateTrigger = _ref.validateTrigger, isListField = _ref.isListField;
  var context = React88.useContext(FieldContext_default);
  var wrapperListContext = React88.useContext(ListContext_default);
  var keyRef = React88.useRef({
    keys: [],
    id: 0
  });
  var keyManager = keyRef.current;
  var prefixName = React88.useMemo(function() {
    var parentPrefixName = getNamePath(context.prefixName) || [];
    return [].concat(_toConsumableArray(parentPrefixName), _toConsumableArray(getNamePath(name)));
  }, [context.prefixName, name]);
  var fieldContext = React88.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, context), {}, {
      prefixName
    });
  }, [context, prefixName]);
  var listContext = React88.useMemo(function() {
    return {
      getKey: function getKey2(namePath) {
        var len = prefixName.length;
        var pathName = namePath[len];
        return [keyManager.keys[pathName], namePath.slice(len + 1)];
      }
    };
  }, [prefixName]);
  if (typeof children !== "function") {
    warning_default(false, "Form.List only accepts function as children.");
    return null;
  }
  var shouldUpdate = function shouldUpdate2(prevValue, nextValue, _ref2) {
    var source = _ref2.source;
    if (source === "internal") {
      return false;
    }
    return prevValue !== nextValue;
  };
  return /* @__PURE__ */ React88.createElement(ListContext_default.Provider, {
    value: listContext
  }, /* @__PURE__ */ React88.createElement(FieldContext_default.Provider, {
    value: fieldContext
  }, /* @__PURE__ */ React88.createElement(Field_default, {
    name: [],
    shouldUpdate,
    rules: rules2,
    validateTrigger,
    initialValue,
    isList: true,
    isListField: isListField !== null && isListField !== void 0 ? isListField : !!wrapperListContext
  }, function(_ref3, meta) {
    var _ref3$value = _ref3.value, value = _ref3$value === void 0 ? [] : _ref3$value, onChange = _ref3.onChange;
    var getFieldValue = context.getFieldValue;
    var getNewValue = function getNewValue2() {
      var values = getFieldValue(prefixName || []);
      return values || [];
    };
    var operations = {
      add: function add(defaultValue, index2) {
        var newValue = getNewValue();
        if (index2 >= 0 && index2 <= newValue.length) {
          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys.slice(0, index2)), [keyManager.id], _toConsumableArray(keyManager.keys.slice(index2)));
          onChange([].concat(_toConsumableArray(newValue.slice(0, index2)), [defaultValue], _toConsumableArray(newValue.slice(index2))));
        } else {
          if (process.env.NODE_ENV !== "production" && (index2 < 0 || index2 > newValue.length)) {
            warning_default(false, "The second parameter of the add function should be a valid positive number.");
          }
          keyManager.keys = [].concat(_toConsumableArray(keyManager.keys), [keyManager.id]);
          onChange([].concat(_toConsumableArray(newValue), [defaultValue]));
        }
        keyManager.id += 1;
      },
      remove: function remove2(index2) {
        var newValue = getNewValue();
        var indexSet = new Set(Array.isArray(index2) ? index2 : [index2]);
        if (indexSet.size <= 0) {
          return;
        }
        keyManager.keys = keyManager.keys.filter(function(_, keysIndex) {
          return !indexSet.has(keysIndex);
        });
        onChange(newValue.filter(function(_, valueIndex) {
          return !indexSet.has(valueIndex);
        }));
      },
      move: function move3(from2, to) {
        if (from2 === to) {
          return;
        }
        var newValue = getNewValue();
        if (from2 < 0 || from2 >= newValue.length || to < 0 || to >= newValue.length) {
          return;
        }
        keyManager.keys = move(keyManager.keys, from2, to);
        onChange(move(newValue, from2, to));
      }
    };
    var listValue = value || [];
    if (!Array.isArray(listValue)) {
      listValue = [];
      if (process.env.NODE_ENV !== "production") {
        warning_default(false, "Current value of '".concat(prefixName.join(" > "), "' is not an array type."));
      }
    }
    return children(listValue.map(function(__, index2) {
      var key = keyManager.keys[index2];
      if (key === void 0) {
        keyManager.keys[index2] = keyManager.id;
        key = keyManager.keys[index2];
        keyManager.id += 1;
      }
      return {
        name: index2,
        key,
        isListField: true
      };
    }), operations, meta);
  })));
}
var List_default = List;

// ../../node_modules/rc-field-form/es/useForm.js
var React89 = __toESM(require("react"));

// ../../node_modules/rc-field-form/es/utils/asyncUtil.js
function allPromiseFinish(promiseList) {
  var hasError = false;
  var count = promiseList.length;
  var results = [];
  if (!promiseList.length) {
    return Promise.resolve([]);
  }
  return new Promise(function(resolve, reject) {
    promiseList.forEach(function(promise, index2) {
      promise.catch(function(e) {
        hasError = true;
        return e;
      }).then(function(result) {
        count -= 1;
        results[index2] = result;
        if (count > 0) {
          return;
        }
        if (hasError) {
          reject(results);
        }
        resolve(results);
      });
    });
  });
}

// ../../node_modules/rc-field-form/es/utils/NameMap.js
var SPLIT2 = "__@field_split__";
function normalize(namePath) {
  return namePath.map(function(cell) {
    return "".concat(_typeof(cell), ":").concat(cell);
  }).join(SPLIT2);
}
var NameMap = /* @__PURE__ */ function() {
  function NameMap2() {
    _classCallCheck(this, NameMap2);
    _defineProperty(this, "kvs", /* @__PURE__ */ new Map());
  }
  _createClass(NameMap2, [{
    key: "set",
    value: function set2(key, value) {
      this.kvs.set(normalize(key), value);
    }
  }, {
    key: "get",
    value: function get2(key) {
      return this.kvs.get(normalize(key));
    }
  }, {
    key: "update",
    value: function update(key, updater) {
      var origin = this.get(key);
      var next2 = updater(origin);
      if (!next2) {
        this.delete(key);
      } else {
        this.set(key, next2);
      }
    }
  }, {
    key: "delete",
    value: function _delete(key) {
      this.kvs.delete(normalize(key));
    }
    // Since we only use this in test, let simply realize this
  }, {
    key: "map",
    value: function map2(callback) {
      return _toConsumableArray(this.kvs.entries()).map(function(_ref) {
        var _ref2 = _slicedToArray(_ref, 2), key = _ref2[0], value = _ref2[1];
        var cells = key.split(SPLIT2);
        return callback({
          key: cells.map(function(cell) {
            var _cell$match = cell.match(/^([^:]*):(.*)$/), _cell$match2 = _slicedToArray(_cell$match, 3), type4 = _cell$match2[1], unit3 = _cell$match2[2];
            return type4 === "number" ? Number(unit3) : unit3;
          }),
          value
        });
      });
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      var json = {};
      this.map(function(_ref3) {
        var key = _ref3.key, value = _ref3.value;
        json[key.join(".")] = value;
        return null;
      });
      return json;
    }
  }]);
  return NameMap2;
}();
var NameMap_default = NameMap;

// ../../node_modules/rc-field-form/es/useForm.js
var _excluded8 = ["name"];
var FormStore = /* @__PURE__ */ _createClass(function FormStore2(forceRootUpdate) {
  var _this = this;
  _classCallCheck(this, FormStore2);
  _defineProperty(this, "formHooked", false);
  _defineProperty(this, "forceRootUpdate", void 0);
  _defineProperty(this, "subscribable", true);
  _defineProperty(this, "store", {});
  _defineProperty(this, "fieldEntities", []);
  _defineProperty(this, "initialValues", {});
  _defineProperty(this, "callbacks", {});
  _defineProperty(this, "validateMessages", null);
  _defineProperty(this, "preserve", null);
  _defineProperty(this, "lastValidatePromise", null);
  _defineProperty(this, "getForm", function() {
    return {
      getFieldValue: _this.getFieldValue,
      getFieldsValue: _this.getFieldsValue,
      getFieldError: _this.getFieldError,
      getFieldWarning: _this.getFieldWarning,
      getFieldsError: _this.getFieldsError,
      isFieldsTouched: _this.isFieldsTouched,
      isFieldTouched: _this.isFieldTouched,
      isFieldValidating: _this.isFieldValidating,
      isFieldsValidating: _this.isFieldsValidating,
      resetFields: _this.resetFields,
      setFields: _this.setFields,
      setFieldValue: _this.setFieldValue,
      setFieldsValue: _this.setFieldsValue,
      validateFields: _this.validateFields,
      submit: _this.submit,
      _init: true,
      getInternalHooks: _this.getInternalHooks
    };
  });
  _defineProperty(this, "getInternalHooks", function(key) {
    if (key === HOOK_MARK) {
      _this.formHooked = true;
      return {
        dispatch: _this.dispatch,
        initEntityValue: _this.initEntityValue,
        registerField: _this.registerField,
        useSubscribe: _this.useSubscribe,
        setInitialValues: _this.setInitialValues,
        destroyForm: _this.destroyForm,
        setCallbacks: _this.setCallbacks,
        setValidateMessages: _this.setValidateMessages,
        getFields: _this.getFields,
        setPreserve: _this.setPreserve,
        getInitialValue: _this.getInitialValue,
        registerWatch: _this.registerWatch
      };
    }
    warning_default(false, "`getInternalHooks` is internal usage. Should not call directly.");
    return null;
  });
  _defineProperty(this, "useSubscribe", function(subscribable) {
    _this.subscribable = subscribable;
  });
  _defineProperty(this, "prevWithoutPreserves", null);
  _defineProperty(this, "setInitialValues", function(initialValues, init) {
    _this.initialValues = initialValues || {};
    if (init) {
      var _this$prevWithoutPres;
      var nextStore = merge(initialValues, _this.store);
      (_this$prevWithoutPres = _this.prevWithoutPreserves) === null || _this$prevWithoutPres === void 0 || _this$prevWithoutPres.map(function(_ref) {
        var namePath = _ref.key;
        nextStore = set(nextStore, namePath, get(initialValues, namePath));
      });
      _this.prevWithoutPreserves = null;
      _this.updateStore(nextStore);
    }
  });
  _defineProperty(this, "destroyForm", function() {
    var prevWithoutPreserves = new NameMap_default();
    _this.getFieldEntities(true).forEach(function(entity) {
      if (!_this.isMergedPreserve(entity.isPreserve())) {
        prevWithoutPreserves.set(entity.getNamePath(), true);
      }
    });
    _this.prevWithoutPreserves = prevWithoutPreserves;
  });
  _defineProperty(this, "getInitialValue", function(namePath) {
    var initValue = get(_this.initialValues, namePath);
    return namePath.length ? merge(initValue) : initValue;
  });
  _defineProperty(this, "setCallbacks", function(callbacks) {
    _this.callbacks = callbacks;
  });
  _defineProperty(this, "setValidateMessages", function(validateMessages) {
    _this.validateMessages = validateMessages;
  });
  _defineProperty(this, "setPreserve", function(preserve2) {
    _this.preserve = preserve2;
  });
  _defineProperty(this, "watchList", []);
  _defineProperty(this, "registerWatch", function(callback) {
    _this.watchList.push(callback);
    return function() {
      _this.watchList = _this.watchList.filter(function(fn) {
        return fn !== callback;
      });
    };
  });
  _defineProperty(this, "notifyWatch", function() {
    var namePath = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    if (_this.watchList.length) {
      var values = _this.getFieldsValue();
      var allValues = _this.getFieldsValue(true);
      _this.watchList.forEach(function(callback) {
        callback(values, allValues, namePath);
      });
    }
  });
  _defineProperty(this, "timeoutId", null);
  _defineProperty(this, "warningUnhooked", function() {
    if (process.env.NODE_ENV !== "production" && !_this.timeoutId && typeof window !== "undefined") {
      _this.timeoutId = setTimeout(function() {
        _this.timeoutId = null;
        if (!_this.formHooked) {
          warning_default(false, "Instance created by `useForm` is not connected to any Form element. Forget to pass `form` prop?");
        }
      });
    }
  });
  _defineProperty(this, "updateStore", function(nextStore) {
    _this.store = nextStore;
  });
  _defineProperty(this, "getFieldEntities", function() {
    var pure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    if (!pure) {
      return _this.fieldEntities;
    }
    return _this.fieldEntities.filter(function(field) {
      return field.getNamePath().length;
    });
  });
  _defineProperty(this, "getFieldsMap", function() {
    var pure = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var cache = new NameMap_default();
    _this.getFieldEntities(pure).forEach(function(field) {
      var namePath = field.getNamePath();
      cache.set(namePath, field);
    });
    return cache;
  });
  _defineProperty(this, "getFieldEntitiesForNamePathList", function(nameList) {
    if (!nameList) {
      return _this.getFieldEntities(true);
    }
    var cache = _this.getFieldsMap(true);
    return nameList.map(function(name) {
      var namePath = getNamePath(name);
      return cache.get(namePath) || {
        INVALIDATE_NAME_PATH: getNamePath(name)
      };
    });
  });
  _defineProperty(this, "getFieldsValue", function(nameList, filterFunc) {
    _this.warningUnhooked();
    var mergedNameList;
    var mergedFilterFunc;
    var mergedStrict;
    if (nameList === true || Array.isArray(nameList)) {
      mergedNameList = nameList;
      mergedFilterFunc = filterFunc;
    } else if (nameList && _typeof(nameList) === "object") {
      mergedStrict = nameList.strict;
      mergedFilterFunc = nameList.filter;
    }
    if (mergedNameList === true && !mergedFilterFunc) {
      return _this.store;
    }
    var fieldEntities = _this.getFieldEntitiesForNamePathList(Array.isArray(mergedNameList) ? mergedNameList : null);
    var filteredNameList = [];
    fieldEntities.forEach(function(entity) {
      var _isListField, _ref3;
      var namePath = "INVALIDATE_NAME_PATH" in entity ? entity.INVALIDATE_NAME_PATH : entity.getNamePath();
      if (mergedStrict) {
        var _isList, _ref2;
        if ((_isList = (_ref2 = entity).isList) !== null && _isList !== void 0 && _isList.call(_ref2)) {
          return;
        }
      } else if (!mergedNameList && (_isListField = (_ref3 = entity).isListField) !== null && _isListField !== void 0 && _isListField.call(_ref3)) {
        return;
      }
      if (!mergedFilterFunc) {
        filteredNameList.push(namePath);
      } else {
        var meta = "getMeta" in entity ? entity.getMeta() : null;
        if (mergedFilterFunc(meta)) {
          filteredNameList.push(namePath);
        }
      }
    });
    return cloneByNamePathList(_this.store, filteredNameList.map(getNamePath));
  });
  _defineProperty(this, "getFieldValue", function(name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    return get(_this.store, namePath);
  });
  _defineProperty(this, "getFieldsError", function(nameList) {
    _this.warningUnhooked();
    var fieldEntities = _this.getFieldEntitiesForNamePathList(nameList);
    return fieldEntities.map(function(entity, index2) {
      if (entity && !("INVALIDATE_NAME_PATH" in entity)) {
        return {
          name: entity.getNamePath(),
          errors: entity.getErrors(),
          warnings: entity.getWarnings()
        };
      }
      return {
        name: getNamePath(nameList[index2]),
        errors: [],
        warnings: []
      };
    });
  });
  _defineProperty(this, "getFieldError", function(name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    var fieldError = _this.getFieldsError([namePath])[0];
    return fieldError.errors;
  });
  _defineProperty(this, "getFieldWarning", function(name) {
    _this.warningUnhooked();
    var namePath = getNamePath(name);
    var fieldError = _this.getFieldsError([namePath])[0];
    return fieldError.warnings;
  });
  _defineProperty(this, "isFieldsTouched", function() {
    _this.warningUnhooked();
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var arg0 = args[0], arg1 = args[1];
    var namePathList;
    var isAllFieldsTouched = false;
    if (args.length === 0) {
      namePathList = null;
    } else if (args.length === 1) {
      if (Array.isArray(arg0)) {
        namePathList = arg0.map(getNamePath);
        isAllFieldsTouched = false;
      } else {
        namePathList = null;
        isAllFieldsTouched = arg0;
      }
    } else {
      namePathList = arg0.map(getNamePath);
      isAllFieldsTouched = arg1;
    }
    var fieldEntities = _this.getFieldEntities(true);
    var isFieldTouched = function isFieldTouched2(field) {
      return field.isFieldTouched();
    };
    if (!namePathList) {
      return isAllFieldsTouched ? fieldEntities.every(isFieldTouched) : fieldEntities.some(isFieldTouched);
    }
    var map2 = new NameMap_default();
    namePathList.forEach(function(shortNamePath) {
      map2.set(shortNamePath, []);
    });
    fieldEntities.forEach(function(field) {
      var fieldNamePath = field.getNamePath();
      namePathList.forEach(function(shortNamePath) {
        if (shortNamePath.every(function(nameUnit, i) {
          return fieldNamePath[i] === nameUnit;
        })) {
          map2.update(shortNamePath, function(list) {
            return [].concat(_toConsumableArray(list), [field]);
          });
        }
      });
    });
    var isNamePathListTouched = function isNamePathListTouched2(entities) {
      return entities.some(isFieldTouched);
    };
    var namePathListEntities = map2.map(function(_ref4) {
      var value = _ref4.value;
      return value;
    });
    return isAllFieldsTouched ? namePathListEntities.every(isNamePathListTouched) : namePathListEntities.some(isNamePathListTouched);
  });
  _defineProperty(this, "isFieldTouched", function(name) {
    _this.warningUnhooked();
    return _this.isFieldsTouched([name]);
  });
  _defineProperty(this, "isFieldsValidating", function(nameList) {
    _this.warningUnhooked();
    var fieldEntities = _this.getFieldEntities();
    if (!nameList) {
      return fieldEntities.some(function(testField) {
        return testField.isFieldValidating();
      });
    }
    var namePathList = nameList.map(getNamePath);
    return fieldEntities.some(function(testField) {
      var fieldNamePath = testField.getNamePath();
      return containsNamePath(namePathList, fieldNamePath) && testField.isFieldValidating();
    });
  });
  _defineProperty(this, "isFieldValidating", function(name) {
    _this.warningUnhooked();
    return _this.isFieldsValidating([name]);
  });
  _defineProperty(this, "resetWithFieldInitialValue", function() {
    var info = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var cache = new NameMap_default();
    var fieldEntities = _this.getFieldEntities(true);
    fieldEntities.forEach(function(field) {
      var initialValue = field.props.initialValue;
      var namePath = field.getNamePath();
      if (initialValue !== void 0) {
        var records = cache.get(namePath) || /* @__PURE__ */ new Set();
        records.add({
          entity: field,
          value: initialValue
        });
        cache.set(namePath, records);
      }
    });
    var resetWithFields = function resetWithFields2(entities) {
      entities.forEach(function(field) {
        var initialValue = field.props.initialValue;
        if (initialValue !== void 0) {
          var namePath = field.getNamePath();
          var formInitialValue = _this.getInitialValue(namePath);
          if (formInitialValue !== void 0) {
            warning_default(false, "Form already set 'initialValues' with path '".concat(namePath.join("."), "'. Field can not overwrite it."));
          } else {
            var records = cache.get(namePath);
            if (records && records.size > 1) {
              warning_default(false, "Multiple Field with path '".concat(namePath.join("."), "' set 'initialValue'. Can not decide which one to pick."));
            } else if (records) {
              var originValue = _this.getFieldValue(namePath);
              var isListField = field.isListField();
              if (!isListField && (!info.skipExist || originValue === void 0)) {
                _this.updateStore(set(_this.store, namePath, _toConsumableArray(records)[0].value));
              }
            }
          }
        }
      });
    };
    var requiredFieldEntities;
    if (info.entities) {
      requiredFieldEntities = info.entities;
    } else if (info.namePathList) {
      requiredFieldEntities = [];
      info.namePathList.forEach(function(namePath) {
        var records = cache.get(namePath);
        if (records) {
          var _requiredFieldEntitie;
          (_requiredFieldEntitie = requiredFieldEntities).push.apply(_requiredFieldEntitie, _toConsumableArray(_toConsumableArray(records).map(function(r) {
            return r.entity;
          })));
        }
      });
    } else {
      requiredFieldEntities = fieldEntities;
    }
    resetWithFields(requiredFieldEntities);
  });
  _defineProperty(this, "resetFields", function(nameList) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    if (!nameList) {
      _this.updateStore(merge(_this.initialValues));
      _this.resetWithFieldInitialValue();
      _this.notifyObservers(prevStore, null, {
        type: "reset"
      });
      _this.notifyWatch();
      return;
    }
    var namePathList = nameList.map(getNamePath);
    namePathList.forEach(function(namePath) {
      var initialValue = _this.getInitialValue(namePath);
      _this.updateStore(set(_this.store, namePath, initialValue));
    });
    _this.resetWithFieldInitialValue({
      namePathList
    });
    _this.notifyObservers(prevStore, namePathList, {
      type: "reset"
    });
    _this.notifyWatch(namePathList);
  });
  _defineProperty(this, "setFields", function(fields) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    var namePathList = [];
    fields.forEach(function(fieldData) {
      var name = fieldData.name, data = _objectWithoutProperties(fieldData, _excluded8);
      var namePath = getNamePath(name);
      namePathList.push(namePath);
      if ("value" in data) {
        _this.updateStore(set(_this.store, namePath, data.value));
      }
      _this.notifyObservers(prevStore, [namePath], {
        type: "setField",
        data: fieldData
      });
    });
    _this.notifyWatch(namePathList);
  });
  _defineProperty(this, "getFields", function() {
    var entities = _this.getFieldEntities(true);
    var fields = entities.map(function(field) {
      var namePath = field.getNamePath();
      var meta = field.getMeta();
      var fieldData = _objectSpread2(_objectSpread2({}, meta), {}, {
        name: namePath,
        value: _this.getFieldValue(namePath)
      });
      Object.defineProperty(fieldData, "originRCField", {
        value: true
      });
      return fieldData;
    });
    return fields;
  });
  _defineProperty(this, "initEntityValue", function(entity) {
    var initialValue = entity.props.initialValue;
    if (initialValue !== void 0) {
      var namePath = entity.getNamePath();
      var prevValue = get(_this.store, namePath);
      if (prevValue === void 0) {
        _this.updateStore(set(_this.store, namePath, initialValue));
      }
    }
  });
  _defineProperty(this, "isMergedPreserve", function(fieldPreserve) {
    var mergedPreserve = fieldPreserve !== void 0 ? fieldPreserve : _this.preserve;
    return mergedPreserve !== null && mergedPreserve !== void 0 ? mergedPreserve : true;
  });
  _defineProperty(this, "registerField", function(entity) {
    _this.fieldEntities.push(entity);
    var namePath = entity.getNamePath();
    _this.notifyWatch([namePath]);
    if (entity.props.initialValue !== void 0) {
      var prevStore = _this.store;
      _this.resetWithFieldInitialValue({
        entities: [entity],
        skipExist: true
      });
      _this.notifyObservers(prevStore, [entity.getNamePath()], {
        type: "valueUpdate",
        source: "internal"
      });
    }
    return function(isListField, preserve2) {
      var subNamePath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
      _this.fieldEntities = _this.fieldEntities.filter(function(item) {
        return item !== entity;
      });
      if (!_this.isMergedPreserve(preserve2) && (!isListField || subNamePath.length > 1)) {
        var defaultValue = isListField ? void 0 : _this.getInitialValue(namePath);
        if (namePath.length && _this.getFieldValue(namePath) !== defaultValue && _this.fieldEntities.every(function(field) {
          return (
            // Only reset when no namePath exist
            !matchNamePath(field.getNamePath(), namePath)
          );
        })) {
          var _prevStore = _this.store;
          _this.updateStore(set(_prevStore, namePath, defaultValue, true));
          _this.notifyObservers(_prevStore, [namePath], {
            type: "remove"
          });
          _this.triggerDependenciesUpdate(_prevStore, namePath);
        }
      }
      _this.notifyWatch([namePath]);
    };
  });
  _defineProperty(this, "dispatch", function(action) {
    switch (action.type) {
      case "updateValue": {
        var namePath = action.namePath, value = action.value;
        _this.updateValue(namePath, value);
        break;
      }
      case "validateField": {
        var _namePath = action.namePath, triggerName = action.triggerName;
        _this.validateFields([_namePath], {
          triggerName
        });
        break;
      }
      default:
    }
  });
  _defineProperty(this, "notifyObservers", function(prevStore, namePathList, info) {
    if (_this.subscribable) {
      var mergedInfo = _objectSpread2(_objectSpread2({}, info), {}, {
        store: _this.getFieldsValue(true)
      });
      _this.getFieldEntities().forEach(function(_ref5) {
        var onStoreChange = _ref5.onStoreChange;
        onStoreChange(prevStore, namePathList, mergedInfo);
      });
    } else {
      _this.forceRootUpdate();
    }
  });
  _defineProperty(this, "triggerDependenciesUpdate", function(prevStore, namePath) {
    var childrenFields = _this.getDependencyChildrenFields(namePath);
    if (childrenFields.length) {
      _this.validateFields(childrenFields);
    }
    _this.notifyObservers(prevStore, childrenFields, {
      type: "dependenciesUpdate",
      relatedFields: [namePath].concat(_toConsumableArray(childrenFields))
    });
    return childrenFields;
  });
  _defineProperty(this, "updateValue", function(name, value) {
    var namePath = getNamePath(name);
    var prevStore = _this.store;
    _this.updateStore(set(_this.store, namePath, value));
    _this.notifyObservers(prevStore, [namePath], {
      type: "valueUpdate",
      source: "internal"
    });
    _this.notifyWatch([namePath]);
    var childrenFields = _this.triggerDependenciesUpdate(prevStore, namePath);
    var onValuesChange = _this.callbacks.onValuesChange;
    if (onValuesChange) {
      var changedValues = cloneByNamePathList(_this.store, [namePath]);
      onValuesChange(changedValues, _this.getFieldsValue());
    }
    _this.triggerOnFieldsChange([namePath].concat(_toConsumableArray(childrenFields)));
  });
  _defineProperty(this, "setFieldsValue", function(store) {
    _this.warningUnhooked();
    var prevStore = _this.store;
    if (store) {
      var nextStore = merge(_this.store, store);
      _this.updateStore(nextStore);
    }
    _this.notifyObservers(prevStore, null, {
      type: "valueUpdate",
      source: "external"
    });
    _this.notifyWatch();
  });
  _defineProperty(this, "setFieldValue", function(name, value) {
    _this.setFields([{
      name,
      value
    }]);
  });
  _defineProperty(this, "getDependencyChildrenFields", function(rootNamePath) {
    var children = /* @__PURE__ */ new Set();
    var childrenFields = [];
    var dependencies2fields = new NameMap_default();
    _this.getFieldEntities().forEach(function(field) {
      var dependencies = field.props.dependencies;
      (dependencies || []).forEach(function(dependency) {
        var dependencyNamePath = getNamePath(dependency);
        dependencies2fields.update(dependencyNamePath, function() {
          var fields = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Set();
          fields.add(field);
          return fields;
        });
      });
    });
    var fillChildren = function fillChildren2(namePath) {
      var fields = dependencies2fields.get(namePath) || /* @__PURE__ */ new Set();
      fields.forEach(function(field) {
        if (!children.has(field)) {
          children.add(field);
          var fieldNamePath = field.getNamePath();
          if (field.isFieldDirty() && fieldNamePath.length) {
            childrenFields.push(fieldNamePath);
            fillChildren2(fieldNamePath);
          }
        }
      });
    };
    fillChildren(rootNamePath);
    return childrenFields;
  });
  _defineProperty(this, "triggerOnFieldsChange", function(namePathList, filedErrors) {
    var onFieldsChange = _this.callbacks.onFieldsChange;
    if (onFieldsChange) {
      var fields = _this.getFields();
      if (filedErrors) {
        var cache = new NameMap_default();
        filedErrors.forEach(function(_ref6) {
          var name = _ref6.name, errors = _ref6.errors;
          cache.set(name, errors);
        });
        fields.forEach(function(field) {
          field.errors = cache.get(field.name) || field.errors;
        });
      }
      var changedFields = fields.filter(function(_ref7) {
        var fieldName = _ref7.name;
        return containsNamePath(namePathList, fieldName);
      });
      if (changedFields.length) {
        onFieldsChange(changedFields, fields);
      }
    }
  });
  _defineProperty(this, "validateFields", function(arg1, arg2) {
    _this.warningUnhooked();
    var nameList;
    var options;
    if (Array.isArray(arg1) || typeof arg1 === "string" || typeof arg2 === "string") {
      nameList = arg1;
      options = arg2;
    } else {
      options = arg1;
    }
    var provideNameList = !!nameList;
    var namePathList = provideNameList ? nameList.map(getNamePath) : [];
    var promiseList = [];
    var TMP_SPLIT = String(Date.now());
    var validateNamePathList = /* @__PURE__ */ new Set();
    var _ref8 = options || {}, recursive = _ref8.recursive, dirty = _ref8.dirty;
    _this.getFieldEntities(true).forEach(function(field) {
      if (!provideNameList) {
        namePathList.push(field.getNamePath());
      }
      if (!field.props.rules || !field.props.rules.length) {
        return;
      }
      if (dirty && !field.isFieldDirty()) {
        return;
      }
      var fieldNamePath = field.getNamePath();
      validateNamePathList.add(fieldNamePath.join(TMP_SPLIT));
      if (!provideNameList || containsNamePath(namePathList, fieldNamePath, recursive)) {
        var promise = field.validateRules(_objectSpread2({
          validateMessages: _objectSpread2(_objectSpread2({}, defaultValidateMessages), _this.validateMessages)
        }, options));
        promiseList.push(promise.then(function() {
          return {
            name: fieldNamePath,
            errors: [],
            warnings: []
          };
        }).catch(function(ruleErrors) {
          var _ruleErrors$forEach;
          var mergedErrors = [];
          var mergedWarnings = [];
          (_ruleErrors$forEach = ruleErrors.forEach) === null || _ruleErrors$forEach === void 0 || _ruleErrors$forEach.call(ruleErrors, function(_ref9) {
            var warningOnly = _ref9.rule.warningOnly, errors = _ref9.errors;
            if (warningOnly) {
              mergedWarnings.push.apply(mergedWarnings, _toConsumableArray(errors));
            } else {
              mergedErrors.push.apply(mergedErrors, _toConsumableArray(errors));
            }
          });
          if (mergedErrors.length) {
            return Promise.reject({
              name: fieldNamePath,
              errors: mergedErrors,
              warnings: mergedWarnings
            });
          }
          return {
            name: fieldNamePath,
            errors: mergedErrors,
            warnings: mergedWarnings
          };
        }));
      }
    });
    var summaryPromise = allPromiseFinish(promiseList);
    _this.lastValidatePromise = summaryPromise;
    summaryPromise.catch(function(results) {
      return results;
    }).then(function(results) {
      var resultNamePathList = results.map(function(_ref10) {
        var name = _ref10.name;
        return name;
      });
      _this.notifyObservers(_this.store, resultNamePathList, {
        type: "validateFinish"
      });
      _this.triggerOnFieldsChange(resultNamePathList, results);
    });
    var returnPromise = summaryPromise.then(function() {
      if (_this.lastValidatePromise === summaryPromise) {
        return Promise.resolve(_this.getFieldsValue(namePathList));
      }
      return Promise.reject([]);
    }).catch(function(results) {
      var errorList = results.filter(function(result) {
        return result && result.errors.length;
      });
      return Promise.reject({
        values: _this.getFieldsValue(namePathList),
        errorFields: errorList,
        outOfDate: _this.lastValidatePromise !== summaryPromise
      });
    });
    returnPromise.catch(function(e) {
      return e;
    });
    var triggerNamePathList = namePathList.filter(function(namePath) {
      return validateNamePathList.has(namePath.join(TMP_SPLIT));
    });
    _this.triggerOnFieldsChange(triggerNamePathList);
    return returnPromise;
  });
  _defineProperty(this, "submit", function() {
    _this.warningUnhooked();
    _this.validateFields().then(function(values) {
      var onFinish = _this.callbacks.onFinish;
      if (onFinish) {
        try {
          onFinish(values);
        } catch (err) {
          console.error(err);
        }
      }
    }).catch(function(e) {
      var onFinishFailed = _this.callbacks.onFinishFailed;
      if (onFinishFailed) {
        onFinishFailed(e);
      }
    });
  });
  this.forceRootUpdate = forceRootUpdate;
});
function useForm(form) {
  var formRef = React89.useRef();
  var _React$useState = React89.useState({}), _React$useState2 = _slicedToArray(_React$useState, 2), forceUpdate = _React$useState2[1];
  if (!formRef.current) {
    if (form) {
      formRef.current = form;
    } else {
      var forceReRender = function forceReRender2() {
        forceUpdate({});
      };
      var formStore = new FormStore(forceReRender);
      formRef.current = formStore.getForm();
    }
  }
  return [formRef.current];
}
var useForm_default = useForm;

// ../../node_modules/rc-field-form/es/Form.js
var React91 = __toESM(require("react"));

// ../../node_modules/rc-field-form/es/FormContext.js
var React90 = __toESM(require("react"));
var FormContext = /* @__PURE__ */ React90.createContext({
  triggerFormChange: function triggerFormChange() {
  },
  triggerFormFinish: function triggerFormFinish() {
  },
  registerForm: function registerForm() {
  },
  unregisterForm: function unregisterForm() {
  }
});
var FormProvider = function FormProvider2(_ref) {
  var validateMessages = _ref.validateMessages, onFormChange = _ref.onFormChange, onFormFinish = _ref.onFormFinish, children = _ref.children;
  var formContext = React90.useContext(FormContext);
  var formsRef = React90.useRef({});
  return /* @__PURE__ */ React90.createElement(FormContext.Provider, {
    value: _objectSpread2(_objectSpread2({}, formContext), {}, {
      validateMessages: _objectSpread2(_objectSpread2({}, formContext.validateMessages), validateMessages),
      // =========================================================
      // =                  Global Form Control                  =
      // =========================================================
      triggerFormChange: function triggerFormChange2(name, changedFields) {
        if (onFormChange) {
          onFormChange(name, {
            changedFields,
            forms: formsRef.current
          });
        }
        formContext.triggerFormChange(name, changedFields);
      },
      triggerFormFinish: function triggerFormFinish2(name, values) {
        if (onFormFinish) {
          onFormFinish(name, {
            values,
            forms: formsRef.current
          });
        }
        formContext.triggerFormFinish(name, values);
      },
      registerForm: function registerForm2(name, form) {
        if (name) {
          formsRef.current = _objectSpread2(_objectSpread2({}, formsRef.current), {}, _defineProperty({}, name, form));
        }
        formContext.registerForm(name, form);
      },
      unregisterForm: function unregisterForm2(name) {
        var newForms = _objectSpread2({}, formsRef.current);
        delete newForms[name];
        formsRef.current = newForms;
        formContext.unregisterForm(name);
      }
    })
  }, children);
};
var FormContext_default = FormContext;

// ../../node_modules/rc-field-form/es/Form.js
var _excluded9 = ["name", "initialValues", "fields", "form", "preserve", "children", "component", "validateMessages", "validateTrigger", "onValuesChange", "onFieldsChange", "onFinish", "onFinishFailed"];
var Form = function Form2(_ref, ref) {
  var name = _ref.name, initialValues = _ref.initialValues, fields = _ref.fields, form = _ref.form, preserve2 = _ref.preserve, children = _ref.children, _ref$component = _ref.component, Component6 = _ref$component === void 0 ? "form" : _ref$component, validateMessages = _ref.validateMessages, _ref$validateTrigger = _ref.validateTrigger, validateTrigger = _ref$validateTrigger === void 0 ? "onChange" : _ref$validateTrigger, onValuesChange = _ref.onValuesChange, _onFieldsChange = _ref.onFieldsChange, _onFinish = _ref.onFinish, onFinishFailed = _ref.onFinishFailed, restProps = _objectWithoutProperties(_ref, _excluded9);
  var formContext = React91.useContext(FormContext_default);
  var _useForm = useForm_default(form), _useForm2 = _slicedToArray(_useForm, 1), formInstance = _useForm2[0];
  var _getInternalHooks = formInstance.getInternalHooks(HOOK_MARK), useSubscribe = _getInternalHooks.useSubscribe, setInitialValues = _getInternalHooks.setInitialValues, setCallbacks = _getInternalHooks.setCallbacks, setValidateMessages = _getInternalHooks.setValidateMessages, setPreserve = _getInternalHooks.setPreserve, destroyForm = _getInternalHooks.destroyForm;
  React91.useImperativeHandle(ref, function() {
    return formInstance;
  });
  React91.useEffect(function() {
    formContext.registerForm(name, formInstance);
    return function() {
      formContext.unregisterForm(name);
    };
  }, [formContext, formInstance, name]);
  setValidateMessages(_objectSpread2(_objectSpread2({}, formContext.validateMessages), validateMessages));
  setCallbacks({
    onValuesChange,
    onFieldsChange: function onFieldsChange(changedFields) {
      formContext.triggerFormChange(name, changedFields);
      if (_onFieldsChange) {
        for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          rest[_key - 1] = arguments[_key];
        }
        _onFieldsChange.apply(void 0, [changedFields].concat(rest));
      }
    },
    onFinish: function onFinish(values) {
      formContext.triggerFormFinish(name, values);
      if (_onFinish) {
        _onFinish(values);
      }
    },
    onFinishFailed
  });
  setPreserve(preserve2);
  var mountRef = React91.useRef(null);
  setInitialValues(initialValues, !mountRef.current);
  if (!mountRef.current) {
    mountRef.current = true;
  }
  React91.useEffect(
    function() {
      return destroyForm;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
  var childrenNode;
  var childrenRenderProps = typeof children === "function";
  if (childrenRenderProps) {
    var _values = formInstance.getFieldsValue(true);
    childrenNode = children(_values, formInstance);
  } else {
    childrenNode = children;
  }
  useSubscribe(!childrenRenderProps);
  var prevFieldsRef = React91.useRef();
  React91.useEffect(function() {
    if (!isSimilar(prevFieldsRef.current || [], fields || [])) {
      formInstance.setFields(fields || []);
    }
    prevFieldsRef.current = fields;
  }, [fields, formInstance]);
  var formContextValue = React91.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, formInstance), {}, {
      validateTrigger
    });
  }, [formInstance, validateTrigger]);
  var wrapperNode = /* @__PURE__ */ React91.createElement(ListContext_default.Provider, {
    value: null
  }, /* @__PURE__ */ React91.createElement(FieldContext_default.Provider, {
    value: formContextValue
  }, childrenNode));
  if (Component6 === false) {
    return wrapperNode;
  }
  return /* @__PURE__ */ React91.createElement(Component6, _extends({}, restProps, {
    onSubmit: function onSubmit(event) {
      event.preventDefault();
      event.stopPropagation();
      formInstance.submit();
    },
    onReset: function onReset(event) {
      var _restProps$onReset;
      event.preventDefault();
      formInstance.resetFields();
      (_restProps$onReset = restProps.onReset) === null || _restProps$onReset === void 0 || _restProps$onReset.call(restProps, event);
    }
  }), wrapperNode);
};
var Form_default = Form;

// ../../node_modules/rc-field-form/es/useWatch.js
var import_react35 = require("react");
function stringify2(value) {
  try {
    return JSON.stringify(value);
  } catch (err) {
    return Math.random();
  }
}
var useWatchWarning = process.env.NODE_ENV !== "production" ? function(namePath) {
  var fullyStr = namePath.join("__RC_FIELD_FORM_SPLIT__");
  var nameStrRef = (0, import_react35.useRef)(fullyStr);
  warning_default(nameStrRef.current === fullyStr, "`useWatch` is not support dynamic `namePath`. Please provide static instead.");
} : function() {
};
function useWatch() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var dependencies = args[0], _args$ = args[1], _form = _args$ === void 0 ? {} : _args$;
  var options = isFormInstance(_form) ? {
    form: _form
  } : _form;
  var form = options.form;
  var _useState = (0, import_react35.useState)(), _useState2 = _slicedToArray(_useState, 2), value = _useState2[0], setValue = _useState2[1];
  var valueStr = (0, import_react35.useMemo)(function() {
    return stringify2(value);
  }, [value]);
  var valueStrRef = (0, import_react35.useRef)(valueStr);
  valueStrRef.current = valueStr;
  var fieldContext = (0, import_react35.useContext)(FieldContext_default);
  var formInstance = form || fieldContext;
  var isValidForm = formInstance && formInstance._init;
  if (process.env.NODE_ENV !== "production") {
    warning_default(args.length === 2 ? form ? isValidForm : true : isValidForm, "useWatch requires a form instance since it can not auto detect from context.");
  }
  var namePath = getNamePath(dependencies);
  var namePathRef = (0, import_react35.useRef)(namePath);
  namePathRef.current = namePath;
  useWatchWarning(namePath);
  (0, import_react35.useEffect)(
    function() {
      if (!isValidForm) {
        return;
      }
      var getFieldsValue = formInstance.getFieldsValue, getInternalHooks2 = formInstance.getInternalHooks;
      var _getInternalHooks = getInternalHooks2(HOOK_MARK), registerWatch = _getInternalHooks.registerWatch;
      var getWatchValue = function getWatchValue2(values, allValues) {
        var watchValue = options.preserve ? allValues : values;
        return typeof dependencies === "function" ? dependencies(watchValue) : get(watchValue, namePathRef.current);
      };
      var cancelRegister = registerWatch(function(values, allValues) {
        var newValue = getWatchValue(values, allValues);
        var nextValueStr = stringify2(newValue);
        if (valueStrRef.current !== nextValueStr) {
          valueStrRef.current = nextValueStr;
          setValue(newValue);
        }
      });
      var initialValue = getWatchValue(getFieldsValue(), getFieldsValue(true));
      if (value !== initialValue) {
        setValue(initialValue);
      }
      return cancelRegister;
    },
    // We do not need re-register since namePath content is the same
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [isValidForm]
  );
  return value;
}
var useWatch_default = useWatch;

// ../../node_modules/rc-field-form/es/index.js
var InternalForm = /* @__PURE__ */ React92.forwardRef(Form_default);
var RefForm = InternalForm;
RefForm.FormProvider = FormProvider;
RefForm.Field = Field_default;
RefForm.List = List_default;
RefForm.useForm = useForm_default;
RefForm.useWatch = useWatch_default;

// ../../node_modules/antd/es/form/context.js
var FormItemInputContext = /* @__PURE__ */ React93.createContext({});
if (process.env.NODE_ENV !== "production") {
  FormItemInputContext.displayName = "FormItemInputContext";
}
var NoFormStyle = (_ref) => {
  let {
    children,
    status,
    override
  } = _ref;
  const formItemInputContext = (0, import_react36.useContext)(FormItemInputContext);
  const newFormItemInputContext = (0, import_react36.useMemo)(() => {
    const newContext = Object.assign({}, formItemInputContext);
    if (override) {
      delete newContext.isFormItemInput;
    }
    if (status) {
      delete newContext.status;
      delete newContext.hasFeedback;
      delete newContext.feedbackIcon;
    }
    return newContext;
  }, [status, override, formItemInputContext]);
  return /* @__PURE__ */ React93.createElement(FormItemInputContext.Provider, {
    value: newFormItemInputContext
  }, children);
};
var VariantContext = /* @__PURE__ */ (0, import_react36.createContext)(void 0);

// ../../node_modules/antd/es/watermark/context.js
var React94 = __toESM(require("react"));
function voidFunc() {
}
var WatermarkContext = /* @__PURE__ */ React94.createContext({
  add: voidFunc,
  remove: voidFunc
});
function usePanelRef(panelSelector) {
  const watermark = React94.useContext(WatermarkContext);
  const panelEleRef = React94.useRef();
  const panelRef = useEvent((ele) => {
    if (ele) {
      const innerContentEle = panelSelector ? ele.querySelector(panelSelector) : ele;
      watermark.add(innerContentEle);
      panelEleRef.current = innerContentEle;
    } else {
      watermark.remove(panelEleRef.current);
    }
  });
  return panelRef;
}

// ../../node_modules/antd/es/modal/shared.js
var import_react39 = __toESM(require("react"));

// ../../node_modules/antd/es/modal/components/NormalCancelBtn.js
var import_react37 = __toESM(require("react"));
var NormalCancelBtn = () => {
  const {
    cancelButtonProps,
    cancelTextLocale,
    onCancel
  } = (0, import_react37.useContext)(ModalContext);
  return /* @__PURE__ */ import_react37.default.createElement(button_default2, Object.assign({
    onClick: onCancel
  }, cancelButtonProps), cancelTextLocale);
};
var NormalCancelBtn_default = NormalCancelBtn;

// ../../node_modules/antd/es/modal/components/NormalOkBtn.js
var import_react38 = __toESM(require("react"));
var NormalOkBtn = () => {
  const {
    confirmLoading,
    okButtonProps,
    okType,
    okTextLocale,
    onOk
  } = (0, import_react38.useContext)(ModalContext);
  return /* @__PURE__ */ import_react38.default.createElement(button_default2, Object.assign({}, convertLegacyProps(okType), {
    loading: confirmLoading,
    onClick: onOk
  }, okButtonProps), okTextLocale);
};
var NormalOkBtn_default = NormalOkBtn;

// ../../node_modules/antd/es/modal/shared.js
function renderCloseIcon(prefixCls, closeIcon) {
  return /* @__PURE__ */ import_react39.default.createElement("span", {
    className: `${prefixCls}-close-x`
  }, closeIcon || /* @__PURE__ */ import_react39.default.createElement(CloseOutlined_default2, {
    className: `${prefixCls}-close-icon`
  }));
}
var Footer = (props) => {
  const {
    okText,
    okType = "primary",
    cancelText,
    confirmLoading,
    onOk,
    onCancel,
    okButtonProps,
    cancelButtonProps,
    footer
  } = props;
  const [locale6] = useLocale_default("Modal", getConfirmLocale());
  const okTextLocale = okText || (locale6 === null || locale6 === void 0 ? void 0 : locale6.okText);
  const cancelTextLocale = cancelText || (locale6 === null || locale6 === void 0 ? void 0 : locale6.cancelText);
  const btnCtxValue = {
    confirmLoading,
    okButtonProps,
    cancelButtonProps,
    okTextLocale,
    cancelTextLocale,
    okType,
    onOk,
    onCancel
  };
  const btnCtxValueMemo = import_react39.default.useMemo(() => btnCtxValue, _toConsumableArray(Object.values(btnCtxValue)));
  let footerNode;
  if (typeof footer === "function" || typeof footer === "undefined") {
    footerNode = /* @__PURE__ */ import_react39.default.createElement(import_react39.default.Fragment, null, /* @__PURE__ */ import_react39.default.createElement(NormalCancelBtn_default, null), /* @__PURE__ */ import_react39.default.createElement(NormalOkBtn_default, null));
    if (typeof footer === "function") {
      footerNode = footer(footerNode, {
        OkBtn: NormalOkBtn_default,
        CancelBtn: NormalCancelBtn_default
      });
    }
    footerNode = /* @__PURE__ */ import_react39.default.createElement(ModalContextProvider, {
      value: btnCtxValueMemo
    }, footerNode);
  } else {
    footerNode = footer;
  }
  return /* @__PURE__ */ import_react39.default.createElement(DisabledContextProvider, {
    disabled: false
  }, footerNode);
};

// ../../node_modules/antd/es/style/motion/motion.js
var initMotionCommon = (duration) => ({
  animationDuration: duration,
  animationFillMode: "both"
});
var initMotionCommonLeave = (duration) => ({
  animationDuration: duration,
  animationFillMode: "both"
});
var initMotion = function(motionCls, inKeyframes, outKeyframes, duration) {
  let sameLevel = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
  const sameLevelPrefix = sameLevel ? "&" : "";
  return {
    [`
      ${sameLevelPrefix}${motionCls}-enter,
      ${sameLevelPrefix}${motionCls}-appear
    `]: Object.assign(Object.assign({}, initMotionCommon(duration)), {
      animationPlayState: "paused"
    }),
    [`${sameLevelPrefix}${motionCls}-leave`]: Object.assign(Object.assign({}, initMotionCommonLeave(duration)), {
      animationPlayState: "paused"
    }),
    [`
      ${sameLevelPrefix}${motionCls}-enter${motionCls}-enter-active,
      ${sameLevelPrefix}${motionCls}-appear${motionCls}-appear-active
    `]: {
      animationName: inKeyframes,
      animationPlayState: "running"
    },
    [`${sameLevelPrefix}${motionCls}-leave${motionCls}-leave-active`]: {
      animationName: outKeyframes,
      animationPlayState: "running",
      pointerEvents: "none"
    }
  };
};

// ../../node_modules/antd/es/style/motion/fade.js
var fadeIn = new Keyframes_default("antFadeIn", {
  "0%": {
    opacity: 0
  },
  "100%": {
    opacity: 1
  }
});
var fadeOut = new Keyframes_default("antFadeOut", {
  "0%": {
    opacity: 1
  },
  "100%": {
    opacity: 0
  }
});
var initFadeMotion = function(token2) {
  let sameLevel = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  const {
    antCls
  } = token2;
  const motionCls = `${antCls}-fade`;
  const sameLevelPrefix = sameLevel ? "&" : "";
  return [initMotion(motionCls, fadeIn, fadeOut, token2.motionDurationMid, sameLevel), {
    [`
        ${sameLevelPrefix}${motionCls}-enter,
        ${sameLevelPrefix}${motionCls}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: "linear"
    },
    [`${sameLevelPrefix}${motionCls}-leave`]: {
      animationTimingFunction: "linear"
    }
  }];
};

// ../../node_modules/antd/es/style/motion/move.js
var moveDownIn = new Keyframes_default("antMoveDownIn", {
  "0%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
});
var moveDownOut = new Keyframes_default("antMoveDownOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, 100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
});
var moveLeftIn = new Keyframes_default("antMoveLeftIn", {
  "0%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
});
var moveLeftOut = new Keyframes_default("antMoveLeftOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(-100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
});
var moveRightIn = new Keyframes_default("antMoveRightIn", {
  "0%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
});
var moveRightOut = new Keyframes_default("antMoveRightOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(100%, 0, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
});
var moveUpIn = new Keyframes_default("antMoveUpIn", {
  "0%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  },
  "100%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  }
});
var moveUpOut = new Keyframes_default("antMoveUpOut", {
  "0%": {
    transform: "translate3d(0, 0, 0)",
    transformOrigin: "0 0",
    opacity: 1
  },
  "100%": {
    transform: "translate3d(0, -100%, 0)",
    transformOrigin: "0 0",
    opacity: 0
  }
});
var moveMotion = {
  "move-up": {
    inKeyframes: moveUpIn,
    outKeyframes: moveUpOut
  },
  "move-down": {
    inKeyframes: moveDownIn,
    outKeyframes: moveDownOut
  },
  "move-left": {
    inKeyframes: moveLeftIn,
    outKeyframes: moveLeftOut
  },
  "move-right": {
    inKeyframes: moveRightIn,
    outKeyframes: moveRightOut
  }
};
var initMoveMotion = (token2, motionName) => {
  const {
    antCls
  } = token2;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = moveMotion[motionName];
  return [initMotion(motionCls, inKeyframes, outKeyframes, token2.motionDurationMid), {
    [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
      opacity: 0,
      animationTimingFunction: token2.motionEaseOutCirc
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token2.motionEaseInOutCirc
    }
  }];
};

// ../../node_modules/antd/es/style/motion/slide.js
var slideUpIn = new Keyframes_default("antSlideUpIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
});
var slideUpOut = new Keyframes_default("antSlideUpOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
});
var slideDownIn = new Keyframes_default("antSlideDownIn", {
  "0%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  }
});
var slideDownOut = new Keyframes_default("antSlideDownOut", {
  "0%": {
    transform: "scaleY(1)",
    transformOrigin: "100% 100%",
    opacity: 1
  },
  "100%": {
    transform: "scaleY(0.8)",
    transformOrigin: "100% 100%",
    opacity: 0
  }
});
var slideLeftIn = new Keyframes_default("antSlideLeftIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  }
});
var slideLeftOut = new Keyframes_default("antSlideLeftOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "0% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "0% 0%",
    opacity: 0
  }
});
var slideRightIn = new Keyframes_default("antSlideRightIn", {
  "0%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  }
});
var slideRightOut = new Keyframes_default("antSlideRightOut", {
  "0%": {
    transform: "scaleX(1)",
    transformOrigin: "100% 0%",
    opacity: 1
  },
  "100%": {
    transform: "scaleX(0.8)",
    transformOrigin: "100% 0%",
    opacity: 0
  }
});
var slideMotion = {
  "slide-up": {
    inKeyframes: slideUpIn,
    outKeyframes: slideUpOut
  },
  "slide-down": {
    inKeyframes: slideDownIn,
    outKeyframes: slideDownOut
  },
  "slide-left": {
    inKeyframes: slideLeftIn,
    outKeyframes: slideLeftOut
  },
  "slide-right": {
    inKeyframes: slideRightIn,
    outKeyframes: slideRightOut
  }
};
var initSlideMotion = (token2, motionName) => {
  const {
    antCls
  } = token2;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = slideMotion[motionName];
  return [initMotion(motionCls, inKeyframes, outKeyframes, token2.motionDurationMid), {
    [`
      ${motionCls}-enter,
      ${motionCls}-appear
    `]: {
      transform: "scale(0)",
      transformOrigin: "0% 0%",
      opacity: 0,
      animationTimingFunction: token2.motionEaseOutQuint,
      [`&-prepare`]: {
        transform: "scale(1)"
      }
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token2.motionEaseInQuint
    }
  }];
};

// ../../node_modules/antd/es/style/motion/zoom.js
var zoomIn = new Keyframes_default("antZoomIn", {
  "0%": {
    transform: "scale(0.2)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
});
var zoomOut = new Keyframes_default("antZoomOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.2)",
    opacity: 0
  }
});
var zoomBigIn = new Keyframes_default("antZoomBigIn", {
  "0%": {
    transform: "scale(0.8)",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    opacity: 1
  }
});
var zoomBigOut = new Keyframes_default("antZoomBigOut", {
  "0%": {
    transform: "scale(1)"
  },
  "100%": {
    transform: "scale(0.8)",
    opacity: 0
  }
});
var zoomUpIn = new Keyframes_default("antZoomUpIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  }
});
var zoomUpOut = new Keyframes_default("antZoomUpOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 0%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 0%",
    opacity: 0
  }
});
var zoomLeftIn = new Keyframes_default("antZoomLeftIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  }
});
var zoomLeftOut = new Keyframes_default("antZoomLeftOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "0% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "0% 50%",
    opacity: 0
  }
});
var zoomRightIn = new Keyframes_default("antZoomRightIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  }
});
var zoomRightOut = new Keyframes_default("antZoomRightOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "100% 50%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "100% 50%",
    opacity: 0
  }
});
var zoomDownIn = new Keyframes_default("antZoomDownIn", {
  "0%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  },
  "100%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  }
});
var zoomDownOut = new Keyframes_default("antZoomDownOut", {
  "0%": {
    transform: "scale(1)",
    transformOrigin: "50% 100%"
  },
  "100%": {
    transform: "scale(0.8)",
    transformOrigin: "50% 100%",
    opacity: 0
  }
});
var zoomMotion = {
  zoom: {
    inKeyframes: zoomIn,
    outKeyframes: zoomOut
  },
  "zoom-big": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-big-fast": {
    inKeyframes: zoomBigIn,
    outKeyframes: zoomBigOut
  },
  "zoom-left": {
    inKeyframes: zoomLeftIn,
    outKeyframes: zoomLeftOut
  },
  "zoom-right": {
    inKeyframes: zoomRightIn,
    outKeyframes: zoomRightOut
  },
  "zoom-up": {
    inKeyframes: zoomUpIn,
    outKeyframes: zoomUpOut
  },
  "zoom-down": {
    inKeyframes: zoomDownIn,
    outKeyframes: zoomDownOut
  }
};
var initZoomMotion = (token2, motionName) => {
  const {
    antCls
  } = token2;
  const motionCls = `${antCls}-${motionName}`;
  const {
    inKeyframes,
    outKeyframes
  } = zoomMotion[motionName];
  return [initMotion(motionCls, inKeyframes, outKeyframes, motionName === "zoom-big-fast" ? token2.motionDurationFast : token2.motionDurationMid), {
    [`
        ${motionCls}-enter,
        ${motionCls}-appear
      `]: {
      transform: "scale(0)",
      opacity: 0,
      animationTimingFunction: token2.motionEaseOutCirc,
      "&-prepare": {
        transform: "none"
      }
    },
    [`${motionCls}-leave`]: {
      animationTimingFunction: token2.motionEaseInOutCirc
    }
  }];
};

// ../../node_modules/antd/es/modal/style/index.js
function box(position2) {
  return {
    position: position2,
    inset: 0
  };
}
var genModalMaskStyle = (token2) => {
  const {
    componentCls,
    antCls
  } = token2;
  return [{
    [`${componentCls}-root`]: {
      [`${componentCls}${antCls}-zoom-enter, ${componentCls}${antCls}-zoom-appear`]: {
        // reset scale avoid mousePosition bug
        transform: "none",
        opacity: 0,
        animationDuration: token2.motionDurationSlow,
        // https://github.com/ant-design/ant-design/issues/11777
        userSelect: "none"
      },
      // https://github.com/ant-design/ant-design/issues/37329
      // https://github.com/ant-design/ant-design/issues/40272
      [`${componentCls}${antCls}-zoom-leave ${componentCls}-content`]: {
        pointerEvents: "none"
      },
      [`${componentCls}-mask`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: token2.zIndexPopupBase,
        height: "100%",
        backgroundColor: token2.colorBgMask,
        pointerEvents: "none",
        [`${componentCls}-hidden`]: {
          display: "none"
        }
      }),
      [`${componentCls}-wrap`]: Object.assign(Object.assign({}, box("fixed")), {
        zIndex: token2.zIndexPopupBase,
        overflow: "auto",
        outline: 0,
        WebkitOverflowScrolling: "touch",
        // Note: Firefox not support `:has` yet
        [`&:has(${componentCls}${antCls}-zoom-enter), &:has(${componentCls}${antCls}-zoom-appear)`]: {
          pointerEvents: "none"
        }
      })
    }
  }, {
    [`${componentCls}-root`]: initFadeMotion(token2)
  }];
};
var genModalStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return [
    // ======================== Root =========================
    {
      [`${componentCls}-root`]: {
        [`${componentCls}-wrap-rtl`]: {
          direction: "rtl"
        },
        [`${componentCls}-centered`]: {
          textAlign: "center",
          "&::before": {
            display: "inline-block",
            width: 0,
            height: "100%",
            verticalAlign: "middle",
            content: '""'
          },
          [componentCls]: {
            top: 0,
            display: "inline-block",
            paddingBottom: 0,
            textAlign: "start",
            verticalAlign: "middle"
          }
        },
        [`@media (max-width: ${token2.screenSMMax}px)`]: {
          [componentCls]: {
            maxWidth: "calc(100vw - 16px)",
            margin: `${unit(token2.marginXS)} auto`
          },
          [`${componentCls}-centered`]: {
            [componentCls]: {
              flex: 1
            }
          }
        }
      }
    },
    // ======================== Modal ========================
    {
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        pointerEvents: "none",
        position: "relative",
        top: 100,
        width: "auto",
        maxWidth: `calc(100vw - ${unit(token2.calc(token2.margin).mul(2).equal())})`,
        margin: "0 auto",
        paddingBottom: token2.paddingLG,
        [`${componentCls}-title`]: {
          margin: 0,
          color: token2.titleColor,
          fontWeight: token2.fontWeightStrong,
          fontSize: token2.titleFontSize,
          lineHeight: token2.titleLineHeight,
          wordWrap: "break-word"
        },
        [`${componentCls}-content`]: {
          position: "relative",
          backgroundColor: token2.contentBg,
          backgroundClip: "padding-box",
          border: 0,
          borderRadius: token2.borderRadiusLG,
          boxShadow: token2.boxShadow,
          pointerEvents: "auto",
          padding: token2.contentPadding
        },
        [`${componentCls}-close`]: Object.assign({
          position: "absolute",
          top: token2.calc(token2.modalHeaderHeight).sub(token2.modalCloseBtnSize).div(2).equal(),
          insetInlineEnd: token2.calc(token2.modalHeaderHeight).sub(token2.modalCloseBtnSize).div(2).equal(),
          zIndex: token2.calc(token2.zIndexPopupBase).add(10).equal(),
          padding: 0,
          color: token2.modalCloseIconColor,
          fontWeight: token2.fontWeightStrong,
          lineHeight: 1,
          textDecoration: "none",
          background: "transparent",
          borderRadius: token2.borderRadiusSM,
          width: token2.modalCloseBtnSize,
          height: token2.modalCloseBtnSize,
          border: 0,
          outline: 0,
          cursor: "pointer",
          transition: `color ${token2.motionDurationMid}, background-color ${token2.motionDurationMid}`,
          "&-x": {
            display: "flex",
            fontSize: token2.fontSizeLG,
            fontStyle: "normal",
            lineHeight: `${unit(token2.modalCloseBtnSize)}`,
            justifyContent: "center",
            textTransform: "none",
            textRendering: "auto"
          },
          "&:hover": {
            color: token2.modalIconHoverColor,
            backgroundColor: token2.closeBtnHoverBg,
            textDecoration: "none"
          },
          "&:active": {
            backgroundColor: token2.closeBtnActiveBg
          }
        }, genFocusStyle(token2)),
        [`${componentCls}-header`]: {
          color: token2.colorText,
          background: token2.headerBg,
          borderRadius: `${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)} 0 0`,
          marginBottom: token2.headerMarginBottom,
          padding: token2.headerPadding,
          borderBottom: token2.headerBorderBottom
        },
        [`${componentCls}-body`]: {
          fontSize: token2.fontSize,
          lineHeight: token2.lineHeight,
          wordWrap: "break-word",
          padding: token2.bodyPadding
        },
        [`${componentCls}-footer`]: {
          textAlign: "end",
          background: token2.footerBg,
          marginTop: token2.footerMarginTop,
          padding: token2.footerPadding,
          borderTop: token2.footerBorderTop,
          borderRadius: token2.footerBorderRadius,
          [`> ${token2.antCls}-btn + ${token2.antCls}-btn`]: {
            marginInlineStart: token2.marginXS
          }
        },
        [`${componentCls}-open`]: {
          overflow: "hidden"
        }
      })
    },
    // ======================== Pure =========================
    {
      [`${componentCls}-pure-panel`]: {
        top: "auto",
        padding: 0,
        display: "flex",
        flexDirection: "column",
        [`${componentCls}-content,
          ${componentCls}-body,
          ${componentCls}-confirm-body-wrapper`]: {
          display: "flex",
          flexDirection: "column",
          flex: "auto"
        },
        [`${componentCls}-confirm-body`]: {
          marginBottom: "auto"
        }
      }
    }
  ];
};
var genRTLStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-root`]: {
      [`${componentCls}-wrap-rtl`]: {
        direction: "rtl",
        [`${componentCls}-confirm-body`]: {
          direction: "rtl"
        }
      }
    }
  };
};
var prepareToken2 = (token2) => {
  const headerPaddingVertical = token2.padding;
  const headerFontSize = token2.fontSizeHeading5;
  const headerLineHeight = token2.lineHeightHeading5;
  const modalToken = merge2(token2, {
    modalHeaderHeight: token2.calc(token2.calc(headerLineHeight).mul(headerFontSize).equal()).add(token2.calc(headerPaddingVertical).mul(2).equal()).equal(),
    modalFooterBorderColorSplit: token2.colorSplit,
    modalFooterBorderStyle: token2.lineType,
    modalFooterBorderWidth: token2.lineWidth,
    modalIconHoverColor: token2.colorIconHover,
    modalCloseIconColor: token2.colorIcon,
    modalCloseBtnSize: token2.fontHeight,
    modalConfirmIconSize: token2.fontHeight,
    modalTitleHeight: token2.calc(token2.titleFontSize).mul(token2.titleLineHeight).equal()
  });
  return modalToken;
};
var prepareComponentToken3 = (token2) => ({
  footerBg: "transparent",
  headerBg: token2.colorBgElevated,
  titleLineHeight: token2.lineHeightHeading5,
  titleFontSize: token2.fontSizeHeading5,
  contentBg: token2.colorBgElevated,
  titleColor: token2.colorTextHeading,
  // internal
  closeBtnHoverBg: token2.wireframe ? "transparent" : token2.colorFillContent,
  closeBtnActiveBg: token2.wireframe ? "transparent" : token2.colorFillContentHover,
  contentPadding: token2.wireframe ? 0 : `${unit(token2.paddingMD)} ${unit(token2.paddingContentHorizontalLG)}`,
  headerPadding: token2.wireframe ? `${unit(token2.padding)} ${unit(token2.paddingLG)}` : 0,
  headerBorderBottom: token2.wireframe ? `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}` : "none",
  headerMarginBottom: token2.wireframe ? 0 : token2.marginXS,
  bodyPadding: token2.wireframe ? token2.paddingLG : 0,
  footerPadding: token2.wireframe ? `${unit(token2.paddingXS)} ${unit(token2.padding)}` : 0,
  footerBorderTop: token2.wireframe ? `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}` : "none",
  footerBorderRadius: token2.wireframe ? `0 0 ${unit(token2.borderRadiusLG)} ${unit(token2.borderRadiusLG)}` : 0,
  footerMarginTop: token2.wireframe ? 0 : token2.marginSM,
  confirmBodyPadding: token2.wireframe ? `${unit(token2.padding * 2)} ${unit(token2.padding * 2)} ${unit(token2.paddingLG)}` : 0,
  confirmIconMarginInlineEnd: token2.wireframe ? token2.margin : token2.marginSM,
  confirmBtnsMarginTop: token2.wireframe ? token2.marginLG : token2.marginSM
});
var style_default4 = genStyleHooks("Modal", (token2) => {
  const modalToken = prepareToken2(token2);
  return [genModalStyle(modalToken), genRTLStyle(modalToken), genModalMaskStyle(modalToken), initZoomMotion(modalToken, "zoom")];
}, prepareComponentToken3, {
  unitless: {
    titleLineHeight: true
  }
});

// ../../node_modules/antd/es/modal/Modal.js
var __rest8 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var mousePosition;
var getClickPosition = (e) => {
  mousePosition = {
    x: e.pageX,
    y: e.pageY
  };
  setTimeout(() => {
    mousePosition = null;
  }, 100);
};
if (canUseDocElement()) {
  document.documentElement.addEventListener("click", getClickPosition, true);
}
var Modal = (props) => {
  var _a;
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction,
    modal
  } = React98.useContext(ConfigContext);
  const handleCancel = (e) => {
    const {
      onCancel
    } = props;
    onCancel === null || onCancel === void 0 ? void 0 : onCancel(e);
  };
  const handleOk = (e) => {
    const {
      onOk
    } = props;
    onOk === null || onOk === void 0 ? void 0 : onOk(e);
  };
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((_ref) => {
      let [deprecatedName, newName] = _ref;
      warning6.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
  }
  const {
    prefixCls: customizePrefixCls,
    className,
    rootClassName,
    open: open3,
    wrapClassName,
    centered,
    getContainer: getContainer2,
    closeIcon,
    closable,
    focusTriggerAfterClose = true,
    style: style2,
    // Deprecated
    visible,
    width = 520,
    footer,
    classNames: modalClassNames,
    styles: modalStyles
  } = props, restProps = __rest8(props, ["prefixCls", "className", "rootClassName", "open", "wrapClassName", "centered", "getContainer", "closeIcon", "closable", "focusTriggerAfterClose", "style", "visible", "width", "footer", "classNames", "styles"]);
  const prefixCls = getPrefixCls("modal", customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default4(prefixCls, rootCls);
  const wrapClassNameExtended = (0, import_classnames18.default)(wrapClassName, {
    [`${prefixCls}-centered`]: !!centered,
    [`${prefixCls}-wrap-rtl`]: direction === "rtl"
  });
  const dialogFooter = footer !== null && /* @__PURE__ */ React98.createElement(Footer, Object.assign({}, props, {
    onOk: handleOk,
    onCancel: handleCancel
  }));
  const [mergedClosable, mergedCloseIcon] = useClosable_default(closable, closeIcon, (icon) => renderCloseIcon(prefixCls, icon), /* @__PURE__ */ React98.createElement(CloseOutlined_default2, {
    className: `${prefixCls}-close-icon`
  }), true);
  const panelRef = usePanelRef(`.${prefixCls}-content`);
  const [zIndex, contextZIndex] = useZIndex("Modal", restProps.zIndex);
  return wrapCSSVar(/* @__PURE__ */ React98.createElement(NoCompactStyle, null, /* @__PURE__ */ React98.createElement(NoFormStyle, {
    status: true,
    override: true
  }, /* @__PURE__ */ React98.createElement(zindexContext_default.Provider, {
    value: contextZIndex
  }, /* @__PURE__ */ React98.createElement(es_default4, Object.assign({
    width
  }, restProps, {
    zIndex,
    getContainer: getContainer2 === void 0 ? getContextPopupContainer : getContainer2,
    prefixCls,
    rootClassName: (0, import_classnames18.default)(hashId, rootClassName, cssVarCls, rootCls),
    footer: dialogFooter,
    visible: open3 !== null && open3 !== void 0 ? open3 : visible,
    mousePosition: (_a = restProps.mousePosition) !== null && _a !== void 0 ? _a : mousePosition,
    onClose: handleCancel,
    closable: mergedClosable,
    closeIcon: mergedCloseIcon,
    focusTriggerAfterClose,
    transitionName: getTransitionName2(rootPrefixCls, "zoom", props.transitionName),
    maskTransitionName: getTransitionName2(rootPrefixCls, "fade", props.maskTransitionName),
    className: (0, import_classnames18.default)(hashId, className, modal === null || modal === void 0 ? void 0 : modal.className),
    style: Object.assign(Object.assign({}, modal === null || modal === void 0 ? void 0 : modal.style), style2),
    classNames: Object.assign(Object.assign({
      wrapper: wrapClassNameExtended
    }, modal === null || modal === void 0 ? void 0 : modal.classNames), modalClassNames),
    styles: Object.assign(Object.assign({}, modal === null || modal === void 0 ? void 0 : modal.styles), modalStyles),
    panelRef
  }))))));
};
var Modal_default = Modal;

// ../../node_modules/antd/es/modal/style/confirm.js
var genModalConfirmStyle = (token2) => {
  const {
    componentCls,
    titleFontSize,
    titleLineHeight,
    modalConfirmIconSize,
    fontSize,
    lineHeight,
    modalTitleHeight,
    fontHeight,
    confirmBodyPadding
  } = token2;
  const confirmComponentCls = `${componentCls}-confirm`;
  return {
    [confirmComponentCls]: {
      "&-rtl": {
        direction: "rtl"
      },
      [`${token2.antCls}-modal-header`]: {
        display: "none"
      },
      [`${confirmComponentCls}-body-wrapper`]: Object.assign({}, clearFix()),
      [`&${componentCls} ${componentCls}-body`]: {
        padding: confirmBodyPadding
      },
      // ====================== Body ======================
      [`${confirmComponentCls}-body`]: {
        display: "flex",
        flexWrap: "nowrap",
        alignItems: "start",
        [`> ${token2.iconCls}`]: {
          flex: "none",
          fontSize: modalConfirmIconSize,
          marginInlineEnd: token2.confirmIconMarginInlineEnd,
          marginTop: token2.calc(token2.calc(fontHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
        },
        [`&-has-title > ${token2.iconCls}`]: {
          marginTop: token2.calc(token2.calc(modalTitleHeight).sub(modalConfirmIconSize).equal()).div(2).equal()
        }
      },
      [`${confirmComponentCls}-paragraph`]: {
        display: "flex",
        flexDirection: "column",
        flex: "auto",
        rowGap: token2.marginXS,
        maxWidth: `calc(100% - ${unit(token2.calc(token2.modalConfirmIconSize).add(token2.marginSM).equal())})`
      },
      [`${confirmComponentCls}-title`]: {
        color: token2.colorTextHeading,
        fontWeight: token2.fontWeightStrong,
        fontSize: titleFontSize,
        lineHeight: titleLineHeight
      },
      [`${confirmComponentCls}-content`]: {
        color: token2.colorText,
        fontSize,
        lineHeight
      },
      // ===================== Footer =====================
      [`${confirmComponentCls}-btns`]: {
        textAlign: "end",
        marginTop: token2.confirmBtnsMarginTop,
        [`${token2.antCls}-btn + ${token2.antCls}-btn`]: {
          marginBottom: 0,
          marginInlineStart: token2.marginXS
        }
      }
    },
    [`${confirmComponentCls}-error ${confirmComponentCls}-body > ${token2.iconCls}`]: {
      color: token2.colorError
    },
    [`${confirmComponentCls}-warning ${confirmComponentCls}-body > ${token2.iconCls},
        ${confirmComponentCls}-confirm ${confirmComponentCls}-body > ${token2.iconCls}`]: {
      color: token2.colorWarning
    },
    [`${confirmComponentCls}-info ${confirmComponentCls}-body > ${token2.iconCls}`]: {
      color: token2.colorInfo
    },
    [`${confirmComponentCls}-success ${confirmComponentCls}-body > ${token2.iconCls}`]: {
      color: token2.colorSuccess
    }
  };
};
var confirm_default = genSubStyleComponent(["Modal", "confirm"], (token2) => {
  const modalToken = prepareToken2(token2);
  return [genModalConfirmStyle(modalToken)];
}, prepareComponentToken3, {
  // confirm is weak than modal since no conflict here
  order: -1e3
});

// ../../node_modules/antd/es/modal/ConfirmDialog.js
var __rest9 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
function ConfirmContent(props) {
  const {
    prefixCls,
    icon,
    okText,
    cancelText,
    confirmPrefixCls,
    type: type4,
    okCancel,
    footer,
    // Legacy for static function usage
    locale: staticLocale
  } = props, resetProps = __rest9(props, ["prefixCls", "icon", "okText", "cancelText", "confirmPrefixCls", "type", "okCancel", "footer", "locale"]);
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Modal");
    process.env.NODE_ENV !== "production" ? warning6(!(typeof icon === "string" && icon.length > 2), "breaking", `\`icon\` is using ReactNode instead of string naming in v4. Please check \`${icon}\` at https://ant.design/components/icon`) : void 0;
  }
  let mergedIcon = icon;
  if (!icon && icon !== null) {
    switch (type4) {
      case "info":
        mergedIcon = /* @__PURE__ */ React99.createElement(InfoCircleFilled_default2, null);
        break;
      case "success":
        mergedIcon = /* @__PURE__ */ React99.createElement(CheckCircleFilled_default2, null);
        break;
      case "error":
        mergedIcon = /* @__PURE__ */ React99.createElement(CloseCircleFilled_default2, null);
        break;
      default:
        mergedIcon = /* @__PURE__ */ React99.createElement(ExclamationCircleFilled_default2, null);
    }
  }
  const mergedOkCancel = okCancel !== null && okCancel !== void 0 ? okCancel : type4 === "confirm";
  const autoFocusButton = props.autoFocusButton === null ? false : props.autoFocusButton || "ok";
  const [locale6] = useLocale_default("Modal");
  const mergedLocale = staticLocale || locale6;
  const okTextLocale = okText || (mergedOkCancel ? mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.okText : mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.justOkText);
  const cancelTextLocale = cancelText || (mergedLocale === null || mergedLocale === void 0 ? void 0 : mergedLocale.cancelText);
  const btnCtxValue = Object.assign({
    autoFocusButton,
    cancelTextLocale,
    okTextLocale,
    mergedOkCancel
  }, resetProps);
  const btnCtxValueMemo = React99.useMemo(() => btnCtxValue, _toConsumableArray(Object.values(btnCtxValue)));
  const footerOriginNode = /* @__PURE__ */ React99.createElement(React99.Fragment, null, /* @__PURE__ */ React99.createElement(ConfirmCancelBtn_default, null), /* @__PURE__ */ React99.createElement(ConfirmOkBtn_default, null));
  const hasTitle = props.title !== void 0 && props.title !== null;
  const bodyCls = `${confirmPrefixCls}-body`;
  return /* @__PURE__ */ React99.createElement("div", {
    className: `${confirmPrefixCls}-body-wrapper`
  }, /* @__PURE__ */ React99.createElement("div", {
    className: (0, import_classnames19.default)(bodyCls, {
      [`${bodyCls}-has-title`]: hasTitle
    })
  }, mergedIcon, /* @__PURE__ */ React99.createElement("div", {
    className: `${confirmPrefixCls}-paragraph`
  }, hasTitle && /* @__PURE__ */ React99.createElement("span", {
    className: `${confirmPrefixCls}-title`
  }, props.title), /* @__PURE__ */ React99.createElement("div", {
    className: `${confirmPrefixCls}-content`
  }, props.content))), footer === void 0 || typeof footer === "function" ? /* @__PURE__ */ React99.createElement(ModalContextProvider, {
    value: btnCtxValueMemo
  }, /* @__PURE__ */ React99.createElement("div", {
    className: `${confirmPrefixCls}-btns`
  }, typeof footer === "function" ? footer(footerOriginNode, {
    OkBtn: ConfirmOkBtn_default,
    CancelBtn: ConfirmCancelBtn_default
  }) : footerOriginNode)) : footer, /* @__PURE__ */ React99.createElement(confirm_default, {
    prefixCls
  }));
}
var ConfirmDialog = (props) => {
  const {
    close,
    zIndex,
    afterClose,
    open: open3,
    keyboard,
    centered,
    getContainer: getContainer2,
    maskStyle,
    direction,
    prefixCls,
    wrapClassName,
    rootPrefixCls,
    bodyStyle,
    closable = false,
    closeIcon,
    modalRender,
    focusTriggerAfterClose,
    onConfirm,
    styles
  } = props;
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Modal");
    [["visible", "open"], ["bodyStyle", "styles.body"], ["maskStyle", "styles.mask"]].forEach((_ref) => {
      let [deprecatedName, newName] = _ref;
      warning6.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
  }
  const confirmPrefixCls = `${prefixCls}-confirm`;
  const width = props.width || 416;
  const style2 = props.style || {};
  const mask = props.mask === void 0 ? true : props.mask;
  const maskClosable = props.maskClosable === void 0 ? false : props.maskClosable;
  const classString = (0, import_classnames19.default)(confirmPrefixCls, `${confirmPrefixCls}-${props.type}`, {
    [`${confirmPrefixCls}-rtl`]: direction === "rtl"
  }, props.className);
  const [, token2] = useToken();
  const mergedZIndex = React99.useMemo(() => {
    if (zIndex !== void 0) {
      return zIndex;
    }
    return token2.zIndexPopupBase + CONTAINER_MAX_OFFSET;
  }, [zIndex, token2]);
  return /* @__PURE__ */ React99.createElement(Modal_default, {
    prefixCls,
    className: classString,
    wrapClassName: (0, import_classnames19.default)({
      [`${confirmPrefixCls}-centered`]: !!props.centered
    }, wrapClassName),
    onCancel: () => {
      close === null || close === void 0 ? void 0 : close({
        triggerCancel: true
      });
      onConfirm === null || onConfirm === void 0 ? void 0 : onConfirm(false);
    },
    open: open3,
    title: "",
    footer: null,
    transitionName: getTransitionName2(rootPrefixCls || "", "zoom", props.transitionName),
    maskTransitionName: getTransitionName2(rootPrefixCls || "", "fade", props.maskTransitionName),
    mask,
    maskClosable,
    style: style2,
    styles: Object.assign({
      body: bodyStyle,
      mask: maskStyle
    }, styles),
    width,
    zIndex: mergedZIndex,
    afterClose,
    keyboard,
    centered,
    getContainer: getContainer2,
    closable,
    closeIcon,
    modalRender,
    focusTriggerAfterClose
  }, /* @__PURE__ */ React99.createElement(ConfirmContent, Object.assign({}, props, {
    confirmPrefixCls
  })));
};
var ConfirmDialogWrapper = (props) => {
  const {
    rootPrefixCls,
    iconPrefixCls,
    direction,
    theme
  } = props;
  return /* @__PURE__ */ React99.createElement(config_provider_default, {
    prefixCls: rootPrefixCls,
    iconPrefixCls,
    direction,
    theme
  }, /* @__PURE__ */ React99.createElement(ConfirmDialog, Object.assign({}, props)));
};
if (process.env.NODE_ENV !== "production") {
  ConfirmDialog.displayName = "ConfirmDialog";
  ConfirmDialogWrapper.displayName = "ConfirmDialogWrapper";
}
var ConfirmDialog_default = ConfirmDialogWrapper;

// ../../node_modules/antd/es/modal/destroyFns.js
var destroyFns = [];
var destroyFns_default = destroyFns;

// ../../node_modules/antd/es/modal/confirm.js
var defaultRootPrefixCls = "";
function getRootPrefixCls() {
  return defaultRootPrefixCls;
}
var ConfirmDialogWrapper2 = (props) => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    getContainer: getContainer2,
    direction
  } = props;
  const runtimeLocale2 = getConfirmLocale();
  const config = (0, import_react40.useContext)(ConfigContext);
  const rootPrefixCls = customizePrefixCls || getRootPrefixCls() || config.getPrefixCls();
  const prefixCls = customizePrefixCls || `${rootPrefixCls}-modal`;
  let mergedGetContainer = getContainer2;
  if (mergedGetContainer === false) {
    mergedGetContainer = void 0;
    if (process.env.NODE_ENV !== "production") {
      process.env.NODE_ENV !== "production" ? warning_default2(false, "Modal", "Static method not support `getContainer` to be `false` since it do not have context env.") : void 0;
    }
  }
  return /* @__PURE__ */ import_react40.default.createElement(ConfirmDialog_default, Object.assign({}, props, {
    rootPrefixCls,
    prefixCls,
    iconPrefixCls: config.iconPrefixCls,
    theme: config.theme,
    direction: direction !== null && direction !== void 0 ? direction : config.direction,
    locale: (_b = (_a = config.locale) === null || _a === void 0 ? void 0 : _a.Modal) !== null && _b !== void 0 ? _b : runtimeLocale2,
    getContainer: mergedGetContainer
  }));
};
function confirm(config) {
  const global2 = globalConfig();
  if (process.env.NODE_ENV !== "production" && !global2.holderRender) {
    warnContext("Modal");
  }
  const container = document.createDocumentFragment();
  let currentConfig = Object.assign(Object.assign({}, config), {
    close,
    open: true
  });
  let timeoutId;
  function destroy3() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const triggerCancel = args.some((param) => param && param.triggerCancel);
    if (config.onCancel && triggerCancel) {
      config.onCancel.apply(config, [() => {
      }].concat(_toConsumableArray(args.slice(1))));
    }
    for (let i = 0; i < destroyFns_default.length; i++) {
      const fn = destroyFns_default[i];
      if (fn === close) {
        destroyFns_default.splice(i, 1);
        break;
      }
    }
    unmount(container);
  }
  function render2(props) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      const rootPrefixCls = global2.getRootPrefixCls();
      const iconPrefixCls = global2.getIconPrefixCls();
      const theme = global2.getTheme();
      const dom = /* @__PURE__ */ import_react40.default.createElement(ConfirmDialogWrapper2, Object.assign({}, props));
      render(/* @__PURE__ */ import_react40.default.createElement(config_provider_default, {
        prefixCls: rootPrefixCls,
        iconPrefixCls,
        theme
      }, global2.holderRender ? global2.holderRender(dom) : dom), container);
    });
  }
  function close() {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }
    currentConfig = Object.assign(Object.assign({}, currentConfig), {
      open: false,
      afterClose: () => {
        if (typeof config.afterClose === "function") {
          config.afterClose();
        }
        destroy3.apply(this, args);
      }
    });
    if (currentConfig.visible) {
      delete currentConfig.visible;
    }
    render2(currentConfig);
  }
  function update(configUpdate) {
    if (typeof configUpdate === "function") {
      currentConfig = configUpdate(currentConfig);
    } else {
      currentConfig = Object.assign(Object.assign({}, currentConfig), configUpdate);
    }
    render2(currentConfig);
  }
  render2(currentConfig);
  destroyFns_default.push(close);
  return {
    destroy: close,
    update
  };
}
function withWarn(props) {
  return Object.assign(Object.assign({}, props), {
    type: "warning"
  });
}
function withInfo(props) {
  return Object.assign(Object.assign({}, props), {
    type: "info"
  });
}
function withSuccess(props) {
  return Object.assign(Object.assign({}, props), {
    type: "success"
  });
}
function withError(props) {
  return Object.assign(Object.assign({}, props), {
    type: "error"
  });
}
function withConfirm(props) {
  return Object.assign(Object.assign({}, props), {
    type: "confirm"
  });
}
function modalGlobalConfig(_ref) {
  let {
    rootPrefixCls
  } = _ref;
  process.env.NODE_ENV !== "production" ? warning_default2(false, "Modal", "Modal.config is deprecated. Please use ConfigProvider.config instead.") : void 0;
  defaultRootPrefixCls = rootPrefixCls;
}

// ../../node_modules/antd/es/modal/useModal/HookModal.js
var React101 = __toESM(require("react"));
var __rest10 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var HookModal = (_a, ref) => {
  var _b;
  var {
    afterClose: hookAfterClose,
    config
  } = _a, restProps = __rest10(_a, ["afterClose", "config"]);
  const [open3, setOpen] = React101.useState(true);
  const [innerConfig, setInnerConfig] = React101.useState(config);
  const {
    direction,
    getPrefixCls
  } = React101.useContext(ConfigContext);
  const prefixCls = getPrefixCls("modal");
  const rootPrefixCls = getPrefixCls();
  const afterClose = () => {
    var _a2;
    hookAfterClose();
    (_a2 = innerConfig.afterClose) === null || _a2 === void 0 ? void 0 : _a2.call(innerConfig);
  };
  const close = function() {
    setOpen(false);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    const triggerCancel = args.some((param) => param && param.triggerCancel);
    if (innerConfig.onCancel && triggerCancel) {
      innerConfig.onCancel.apply(innerConfig, [() => {
      }].concat(_toConsumableArray(args.slice(1))));
    }
  };
  React101.useImperativeHandle(ref, () => ({
    destroy: close,
    update: (newConfig) => {
      setInnerConfig((originConfig) => Object.assign(Object.assign({}, originConfig), newConfig));
    }
  }));
  const mergedOkCancel = (_b = innerConfig.okCancel) !== null && _b !== void 0 ? _b : innerConfig.type === "confirm";
  const [contextLocale] = useLocale_default("Modal", en_US_default6.Modal);
  return /* @__PURE__ */ React101.createElement(ConfirmDialog_default, Object.assign({
    prefixCls,
    rootPrefixCls
  }, innerConfig, {
    close,
    open: open3,
    afterClose,
    okText: innerConfig.okText || (mergedOkCancel ? contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.okText : contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.justOkText),
    direction: innerConfig.direction || direction,
    cancelText: innerConfig.cancelText || (contextLocale === null || contextLocale === void 0 ? void 0 : contextLocale.cancelText)
  }, restProps));
};
var HookModal_default = /* @__PURE__ */ React101.forwardRef(HookModal);

// ../../node_modules/antd/es/modal/useModal/index.js
var uuid4 = 0;
var ElementsHolder = /* @__PURE__ */ React102.memo(/* @__PURE__ */ React102.forwardRef((_props, ref) => {
  const [elements, patchElement] = usePatchElement();
  React102.useImperativeHandle(ref, () => ({
    patchElement
  }), []);
  return /* @__PURE__ */ React102.createElement(React102.Fragment, null, elements);
}));
function useModal() {
  const holderRef = React102.useRef(null);
  const [actionQueue, setActionQueue] = React102.useState([]);
  React102.useEffect(() => {
    if (actionQueue.length) {
      const cloneQueue = _toConsumableArray(actionQueue);
      cloneQueue.forEach((action) => {
        action();
      });
      setActionQueue([]);
    }
  }, [actionQueue]);
  const getConfirmFunc = React102.useCallback((withFunc) => function hookConfirm(config) {
    var _a;
    uuid4 += 1;
    const modalRef = /* @__PURE__ */ React102.createRef();
    let resolvePromise;
    const promise = new Promise((resolve) => {
      resolvePromise = resolve;
    });
    let silent = false;
    let closeFunc;
    const modal = /* @__PURE__ */ React102.createElement(HookModal_default, {
      key: `modal-${uuid4}`,
      config: withFunc(config),
      ref: modalRef,
      afterClose: () => {
        closeFunc === null || closeFunc === void 0 ? void 0 : closeFunc();
      },
      isSilent: () => silent,
      onConfirm: (confirmed) => {
        resolvePromise(confirmed);
      }
    });
    closeFunc = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.patchElement(modal);
    if (closeFunc) {
      destroyFns_default.push(closeFunc);
    }
    const instance = {
      destroy: () => {
        function destroyAction() {
          var _a2;
          (_a2 = modalRef.current) === null || _a2 === void 0 ? void 0 : _a2.destroy();
        }
        if (modalRef.current) {
          destroyAction();
        } else {
          setActionQueue((prev2) => [].concat(_toConsumableArray(prev2), [destroyAction]));
        }
      },
      update: (newConfig) => {
        function updateAction() {
          var _a2;
          (_a2 = modalRef.current) === null || _a2 === void 0 ? void 0 : _a2.update(newConfig);
        }
        if (modalRef.current) {
          updateAction();
        } else {
          setActionQueue((prev2) => [].concat(_toConsumableArray(prev2), [updateAction]));
        }
      },
      then: (resolve) => {
        silent = true;
        return promise.then(resolve);
      }
    };
    return instance;
  }, []);
  const fns = React102.useMemo(() => ({
    info: getConfirmFunc(withInfo),
    success: getConfirmFunc(withSuccess),
    error: getConfirmFunc(withError),
    warning: getConfirmFunc(withWarn),
    confirm: getConfirmFunc(withConfirm)
  }), []);
  return [fns, /* @__PURE__ */ React102.createElement(ElementsHolder, {
    key: "modal-holder",
    ref: holderRef
  })];
}
var useModal_default = useModal;

// ../../node_modules/antd/es/notification/useNotification.js
var import_react41 = __toESM(require("react"));
var import_classnames21 = __toESM(require_classnames());

// ../../node_modules/antd/es/notification/PurePanel.js
var React103 = __toESM(require("react"));
var import_classnames20 = __toESM(require_classnames());

// ../../node_modules/antd/es/notification/style/placement.js
var genNotificationPlacementStyle = (token2) => {
  const {
    componentCls,
    notificationMarginEdge,
    animationMaxHeight
  } = token2;
  const noticeCls = `${componentCls}-notice`;
  const rightFadeIn = new Keyframes_default("antNotificationFadeIn", {
    "0%": {
      transform: `translate3d(100%, 0, 0)`,
      opacity: 0
    },
    "100%": {
      transform: `translate3d(0, 0, 0)`,
      opacity: 1
    }
  });
  const topFadeIn = new Keyframes_default("antNotificationTopFadeIn", {
    "0%": {
      top: -animationMaxHeight,
      opacity: 0
    },
    "100%": {
      top: 0,
      opacity: 1
    }
  });
  const bottomFadeIn = new Keyframes_default("antNotificationBottomFadeIn", {
    "0%": {
      bottom: token2.calc(animationMaxHeight).mul(-1).equal(),
      opacity: 0
    },
    "100%": {
      bottom: 0,
      opacity: 1
    }
  });
  const leftFadeIn = new Keyframes_default("antNotificationLeftFadeIn", {
    "0%": {
      transform: `translate3d(-100%, 0, 0)`,
      opacity: 0
    },
    "100%": {
      transform: `translate3d(0, 0, 0)`,
      opacity: 1
    }
  });
  return {
    [componentCls]: {
      [`&${componentCls}-top, &${componentCls}-bottom`]: {
        marginInline: 0,
        [noticeCls]: {
          marginInline: "auto auto"
        }
      },
      [`&${componentCls}-top`]: {
        [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
          animationName: topFadeIn
        }
      },
      [`&${componentCls}-bottom`]: {
        [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
          animationName: bottomFadeIn
        }
      },
      [`&${componentCls}-topRight, &${componentCls}-bottomRight`]: {
        [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
          animationName: rightFadeIn
        }
      },
      [`&${componentCls}-topLeft, &${componentCls}-bottomLeft`]: {
        marginRight: {
          value: 0,
          _skip_check_: true
        },
        marginLeft: {
          value: notificationMarginEdge,
          _skip_check_: true
        },
        [noticeCls]: {
          marginInlineEnd: "auto",
          marginInlineStart: 0
        },
        [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
          animationName: leftFadeIn
        }
      }
    }
  };
};
var placement_default = genNotificationPlacementStyle;

// ../../node_modules/antd/es/notification/interface.js
var NotificationPlacements = ["top", "topLeft", "topRight", "bottom", "bottomLeft", "bottomRight"];

// ../../node_modules/antd/es/notification/style/stack.js
var placementAlignProperty = {
  topLeft: "left",
  topRight: "right",
  bottomLeft: "left",
  bottomRight: "right",
  top: "left",
  bottom: "left"
};
var genPlacementStackStyle = (token2, placement) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-${placement}`]: {
      [`&${componentCls}-stack > ${componentCls}-notice-wrapper`]: {
        [placement.startsWith("top") ? "top" : "bottom"]: 0,
        [placementAlignProperty[placement]]: {
          value: 0,
          _skip_check_: true
        }
      }
    }
  };
};
var genStackChildrenStyle = (token2) => {
  const childrenStyle = {};
  for (let i = 1; i < token2.notificationStackLayer; i++) {
    childrenStyle[`&:nth-last-child(${i + 1})`] = {
      overflow: "hidden",
      [`& > ${token2.componentCls}-notice`]: {
        opacity: 0,
        transition: `opacity ${token2.motionDurationMid}`
      }
    };
  }
  return Object.assign({
    [`&:not(:nth-last-child(-n+${token2.notificationStackLayer}))`]: {
      opacity: 0,
      overflow: "hidden",
      color: "transparent",
      pointerEvents: "none"
    }
  }, childrenStyle);
};
var genStackedNoticeStyle = (token2) => {
  const childrenStyle = {};
  for (let i = 1; i < token2.notificationStackLayer; i++) {
    childrenStyle[`&:nth-last-child(${i + 1})`] = {
      background: token2.colorBgBlur,
      backdropFilter: "blur(10px)",
      "-webkit-backdrop-filter": "blur(10px)"
    };
  }
  return Object.assign({}, childrenStyle);
};
var genStackStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return Object.assign({
    [`${componentCls}-stack`]: {
      [`& > ${componentCls}-notice-wrapper`]: Object.assign({
        transition: `all ${token2.motionDurationSlow}, backdrop-filter 0s`,
        position: "absolute"
      }, genStackChildrenStyle(token2))
    },
    [`${componentCls}-stack:not(${componentCls}-stack-expanded)`]: {
      [`& > ${componentCls}-notice-wrapper`]: Object.assign({}, genStackedNoticeStyle(token2))
    },
    [`${componentCls}-stack${componentCls}-stack-expanded`]: {
      [`& > ${componentCls}-notice-wrapper`]: {
        "&:not(:nth-last-child(-n + 1))": {
          opacity: 1,
          overflow: "unset",
          color: "inherit",
          pointerEvents: "auto",
          [`& > ${token2.componentCls}-notice`]: {
            opacity: 1
          }
        },
        "&:after": {
          content: '""',
          position: "absolute",
          height: token2.margin,
          width: "100%",
          insetInline: 0,
          bottom: token2.calc(token2.margin).mul(-1).equal(),
          background: "transparent",
          pointerEvents: "auto"
        }
      }
    }
  }, NotificationPlacements.map((placement) => genPlacementStackStyle(token2, placement)).reduce((acc, cur) => Object.assign(Object.assign({}, acc), cur), {}));
};
var stack_default = genStackStyle;

// ../../node_modules/antd/es/notification/style/index.js
var genNoticeStyle = (token2) => {
  const {
    iconCls,
    componentCls,
    // .ant-notification
    boxShadow,
    fontSizeLG,
    notificationMarginBottom,
    borderRadiusLG,
    colorSuccess,
    colorInfo,
    colorWarning,
    colorError,
    colorTextHeading,
    notificationBg,
    notificationPadding,
    notificationMarginEdge,
    fontSize,
    lineHeight,
    width,
    notificationIconSize,
    colorText
  } = token2;
  const noticeCls = `${componentCls}-notice`;
  return {
    position: "relative",
    marginBottom: notificationMarginBottom,
    marginInlineStart: "auto",
    background: notificationBg,
    borderRadius: borderRadiusLG,
    boxShadow,
    [noticeCls]: {
      padding: notificationPadding,
      width,
      maxWidth: `calc(100vw - ${unit(token2.calc(notificationMarginEdge).mul(2).equal())})`,
      overflow: "hidden",
      lineHeight,
      wordWrap: "break-word"
    },
    [`${componentCls}-close-icon`]: {
      fontSize,
      cursor: "pointer"
    },
    [`${noticeCls}-message`]: {
      marginBottom: token2.marginXS,
      color: colorTextHeading,
      fontSize: fontSizeLG,
      lineHeight: token2.lineHeightLG
    },
    [`${noticeCls}-description`]: {
      fontSize,
      color: colorText
    },
    [`${noticeCls}-closable ${noticeCls}-message`]: {
      paddingInlineEnd: token2.paddingLG
    },
    [`${noticeCls}-with-icon ${noticeCls}-message`]: {
      marginBottom: token2.marginXS,
      marginInlineStart: token2.calc(token2.marginSM).add(notificationIconSize).equal(),
      fontSize: fontSizeLG
    },
    [`${noticeCls}-with-icon ${noticeCls}-description`]: {
      marginInlineStart: token2.calc(token2.marginSM).add(notificationIconSize).equal(),
      fontSize
    },
    // Icon & color style in different selector level
    // https://github.com/ant-design/ant-design/issues/16503
    // https://github.com/ant-design/ant-design/issues/15512
    [`${noticeCls}-icon`]: {
      position: "absolute",
      fontSize: notificationIconSize,
      lineHeight: 1,
      // icon-font
      [`&-success${iconCls}`]: {
        color: colorSuccess
      },
      [`&-info${iconCls}`]: {
        color: colorInfo
      },
      [`&-warning${iconCls}`]: {
        color: colorWarning
      },
      [`&-error${iconCls}`]: {
        color: colorError
      }
    },
    [`${noticeCls}-close`]: {
      position: "absolute",
      top: token2.notificationPaddingVertical,
      insetInlineEnd: token2.notificationPaddingHorizontal,
      color: token2.colorIcon,
      outline: "none",
      width: token2.notificationCloseButtonSize,
      height: token2.notificationCloseButtonSize,
      borderRadius: token2.borderRadiusSM,
      transition: `background-color ${token2.motionDurationMid}, color ${token2.motionDurationMid}`,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      "&:hover": {
        color: token2.colorIconHover,
        backgroundColor: token2.closeBtnHoverBg
      }
    },
    [`${noticeCls}-btn`]: {
      float: "right",
      marginTop: token2.marginSM
    }
  };
};
var genNotificationStyle = (token2) => {
  const {
    componentCls,
    // .ant-notification
    notificationMarginBottom,
    notificationMarginEdge,
    motionDurationMid,
    motionEaseInOut
  } = token2;
  const noticeCls = `${componentCls}-notice`;
  const fadeOut2 = new Keyframes_default("antNotificationFadeOut", {
    "0%": {
      maxHeight: token2.animationMaxHeight,
      marginBottom: notificationMarginBottom
    },
    "100%": {
      maxHeight: 0,
      marginBottom: 0,
      paddingTop: 0,
      paddingBottom: 0,
      opacity: 0
    }
  });
  return [
    // ============================ Holder ============================
    {
      [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
        position: "fixed",
        zIndex: token2.zIndexPopup,
        marginRight: {
          value: notificationMarginEdge,
          _skip_check_: true
        },
        [`${componentCls}-hook-holder`]: {
          position: "relative"
        },
        //  animation
        [`${componentCls}-fade-appear-prepare`]: {
          opacity: "0 !important"
        },
        [`${componentCls}-fade-enter, ${componentCls}-fade-appear`]: {
          animationDuration: token2.motionDurationMid,
          animationTimingFunction: motionEaseInOut,
          animationFillMode: "both",
          opacity: 0,
          animationPlayState: "paused"
        },
        [`${componentCls}-fade-leave`]: {
          animationTimingFunction: motionEaseInOut,
          animationFillMode: "both",
          animationDuration: motionDurationMid,
          animationPlayState: "paused"
        },
        [`${componentCls}-fade-enter${componentCls}-fade-enter-active, ${componentCls}-fade-appear${componentCls}-fade-appear-active`]: {
          animationPlayState: "running"
        },
        [`${componentCls}-fade-leave${componentCls}-fade-leave-active`]: {
          animationName: fadeOut2,
          animationPlayState: "running"
        },
        // RTL
        "&-rtl": {
          direction: "rtl",
          [`${noticeCls}-btn`]: {
            float: "left"
          }
        }
      })
    },
    // ============================ Notice ============================
    {
      [componentCls]: {
        [`${noticeCls}-wrapper`]: Object.assign({}, genNoticeStyle(token2))
      }
    }
  ];
};
var prepareComponentToken4 = (token2) => ({
  zIndexPopup: token2.zIndexPopupBase + CONTAINER_MAX_OFFSET + 50,
  width: 384,
  closeBtnHoverBg: token2.wireframe ? "transparent" : token2.colorFillContent
});
var prepareNotificationToken = (token2) => {
  const notificationPaddingVertical = token2.paddingMD;
  const notificationPaddingHorizontal = token2.paddingLG;
  const notificationToken = merge2(token2, {
    notificationBg: token2.colorBgElevated,
    notificationPaddingVertical,
    notificationPaddingHorizontal,
    notificationIconSize: token2.calc(token2.fontSizeLG).mul(token2.lineHeightLG).equal(),
    notificationCloseButtonSize: token2.calc(token2.controlHeightLG).mul(0.55).equal(),
    notificationMarginBottom: token2.margin,
    notificationPadding: `${unit(token2.paddingMD)} ${unit(token2.paddingContentHorizontalLG)}`,
    notificationMarginEdge: token2.marginLG,
    animationMaxHeight: 150,
    notificationStackLayer: 3
  });
  return notificationToken;
};
var style_default5 = genStyleHooks("Notification", (token2) => {
  const notificationToken = prepareNotificationToken(token2);
  return [genNotificationStyle(notificationToken), placement_default(notificationToken), stack_default(notificationToken)];
}, prepareComponentToken4);

// ../../node_modules/antd/es/notification/style/pure-panel.js
var pure_panel_default = genSubStyleComponent(["Notification", "PurePanel"], (token2) => {
  const noticeCls = `${token2.componentCls}-notice`;
  const notificationToken = prepareNotificationToken(token2);
  return {
    [`${noticeCls}-pure-panel`]: Object.assign(Object.assign({}, genNoticeStyle(notificationToken)), {
      width: notificationToken.width,
      maxWidth: `calc(100vw - ${unit(token2.calc(notificationToken.notificationMarginEdge).mul(2).equal())})`,
      margin: 0
    })
  };
}, prepareComponentToken4);

// ../../node_modules/antd/es/notification/PurePanel.js
var __rest11 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
function getCloseIcon(prefixCls, closeIcon) {
  if (closeIcon === null || closeIcon === false) {
    return null;
  }
  return closeIcon || /* @__PURE__ */ React103.createElement("span", {
    className: `${prefixCls}-close-x`
  }, /* @__PURE__ */ React103.createElement(CloseOutlined_default2, {
    className: `${prefixCls}-close-icon`
  }));
}
var typeToIcon = {
  success: CheckCircleFilled_default2,
  info: InfoCircleFilled_default2,
  error: CloseCircleFilled_default2,
  warning: ExclamationCircleFilled_default2
};
var PureContent2 = (props) => {
  const {
    prefixCls,
    icon,
    type: type4,
    message: message2,
    description,
    btn,
    role = "alert"
  } = props;
  let iconNode = null;
  if (icon) {
    iconNode = /* @__PURE__ */ React103.createElement("span", {
      className: `${prefixCls}-icon`
    }, icon);
  } else if (type4) {
    iconNode = /* @__PURE__ */ React103.createElement(typeToIcon[type4] || null, {
      className: (0, import_classnames20.default)(`${prefixCls}-icon`, `${prefixCls}-icon-${type4}`)
    });
  }
  return /* @__PURE__ */ React103.createElement("div", {
    className: (0, import_classnames20.default)({
      [`${prefixCls}-with-icon`]: iconNode
    }),
    role
  }, iconNode, /* @__PURE__ */ React103.createElement("div", {
    className: `${prefixCls}-message`
  }, message2), /* @__PURE__ */ React103.createElement("div", {
    className: `${prefixCls}-description`
  }, description), btn && /* @__PURE__ */ React103.createElement("div", {
    className: `${prefixCls}-btn`
  }, btn));
};
var PurePanel2 = (props) => {
  const {
    prefixCls: staticPrefixCls,
    className,
    icon,
    type: type4,
    message: message2,
    description,
    btn,
    closable = true,
    closeIcon,
    className: notificationClassName
  } = props, restProps = __rest11(props, ["prefixCls", "className", "icon", "type", "message", "description", "btn", "closable", "closeIcon", "className"]);
  const {
    getPrefixCls
  } = React103.useContext(ConfigContext);
  const prefixCls = staticPrefixCls || getPrefixCls("notification");
  const noticePrefixCls = `${prefixCls}-notice`;
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default5(prefixCls, rootCls);
  return wrapCSSVar(/* @__PURE__ */ React103.createElement("div", {
    className: (0, import_classnames20.default)(`${noticePrefixCls}-pure-panel`, hashId, className, cssVarCls, rootCls)
  }, /* @__PURE__ */ React103.createElement(pure_panel_default, {
    prefixCls
  }), /* @__PURE__ */ React103.createElement(Notice_default, Object.assign({}, restProps, {
    prefixCls,
    eventKey: "pure",
    duration: null,
    closable,
    className: (0, import_classnames20.default)({
      notificationClassName
    }),
    closeIcon: getCloseIcon(prefixCls, closeIcon),
    content: /* @__PURE__ */ React103.createElement(PureContent2, {
      prefixCls: noticePrefixCls,
      icon,
      type: type4,
      message: message2,
      description,
      btn
    })
  }))));
};
var PurePanel_default2 = PurePanel2;

// ../../node_modules/antd/es/notification/util.js
function getPlacementStyle(placement, top, bottom) {
  let style2;
  switch (placement) {
    case "top":
      style2 = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top,
        bottom: "auto"
      };
      break;
    case "topLeft":
      style2 = {
        left: 0,
        top,
        bottom: "auto"
      };
      break;
    case "topRight":
      style2 = {
        right: 0,
        top,
        bottom: "auto"
      };
      break;
    case "bottom":
      style2 = {
        left: "50%",
        transform: "translateX(-50%)",
        right: "auto",
        top: "auto",
        bottom
      };
      break;
    case "bottomLeft":
      style2 = {
        left: 0,
        top: "auto",
        bottom
      };
      break;
    default:
      style2 = {
        right: 0,
        top: "auto",
        bottom
      };
      break;
  }
  return style2;
}
function getMotion2(prefixCls) {
  return {
    motionName: `${prefixCls}-fade`
  };
}

// ../../node_modules/antd/es/notification/useNotification.js
var __rest12 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var DEFAULT_OFFSET3 = 24;
var DEFAULT_DURATION2 = 4.5;
var DEFAULT_PLACEMENT = "topRight";
var Wrapper2 = (_ref) => {
  let {
    children,
    prefixCls
  } = _ref;
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default5(prefixCls, rootCls);
  return wrapCSSVar(/* @__PURE__ */ import_react41.default.createElement(NotificationProvider_default, {
    classNames: {
      list: (0, import_classnames21.default)(hashId, cssVarCls, rootCls)
    }
  }, children));
};
var renderNotifications2 = (node2, _ref2) => {
  let {
    prefixCls,
    key
  } = _ref2;
  return /* @__PURE__ */ import_react41.default.createElement(Wrapper2, {
    prefixCls,
    key
  }, node2);
};
var Holder2 = /* @__PURE__ */ import_react41.default.forwardRef((props, ref) => {
  const {
    top,
    bottom,
    prefixCls: staticPrefixCls,
    getContainer: staticGetContainer,
    maxCount,
    rtl,
    onAllRemoved,
    stack
  } = props;
  const {
    getPrefixCls,
    getPopupContainer,
    notification: notification2,
    direction
  } = (0, import_react41.useContext)(ConfigContext);
  const [, token2] = useToken();
  const prefixCls = staticPrefixCls || getPrefixCls("notification");
  const getStyle3 = (placement) => getPlacementStyle(placement, top !== null && top !== void 0 ? top : DEFAULT_OFFSET3, bottom !== null && bottom !== void 0 ? bottom : DEFAULT_OFFSET3);
  const getClassName = () => (0, import_classnames21.default)({
    [`${prefixCls}-rtl`]: rtl !== null && rtl !== void 0 ? rtl : direction === "rtl"
  });
  const getNotificationMotion = () => getMotion2(prefixCls);
  const [api, holder] = useNotification({
    prefixCls,
    style: getStyle3,
    className: getClassName,
    motion: getNotificationMotion,
    closable: true,
    closeIcon: getCloseIcon(prefixCls),
    duration: DEFAULT_DURATION2,
    getContainer: () => (staticGetContainer === null || staticGetContainer === void 0 ? void 0 : staticGetContainer()) || (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer()) || document.body,
    maxCount,
    onAllRemoved,
    renderNotifications: renderNotifications2,
    stack: stack === false ? false : {
      threshold: typeof stack === "object" ? stack === null || stack === void 0 ? void 0 : stack.threshold : void 0,
      offset: 8,
      gap: token2.margin
    }
  });
  import_react41.default.useImperativeHandle(ref, () => Object.assign(Object.assign({}, api), {
    prefixCls,
    notification: notification2
  }));
  return holder;
});
function useInternalNotification(notificationConfig) {
  const holderRef = import_react41.default.useRef(null);
  const warning6 = devUseWarning("Notification");
  const wrapAPI = import_react41.default.useMemo(() => {
    const open3 = (config) => {
      var _a;
      if (!holderRef.current) {
        process.env.NODE_ENV !== "production" ? warning6(false, "usage", "You are calling notice in render which will break in React 18 concurrent mode. Please trigger in effect instead.") : void 0;
        return;
      }
      const {
        open: originOpen,
        prefixCls,
        notification: notification2
      } = holderRef.current;
      const noticePrefixCls = `${prefixCls}-notice`;
      const {
        message: message2,
        description,
        icon,
        type: type4,
        btn,
        className,
        style: style2,
        role = "alert",
        closeIcon
      } = config, restConfig = __rest12(config, ["message", "description", "icon", "type", "btn", "className", "style", "role", "closeIcon"]);
      const realCloseIcon = getCloseIcon(noticePrefixCls, closeIcon);
      return originOpen(Object.assign(Object.assign({
        // use placement from props instead of hard-coding "topRight"
        placement: (_a = notificationConfig === null || notificationConfig === void 0 ? void 0 : notificationConfig.placement) !== null && _a !== void 0 ? _a : DEFAULT_PLACEMENT
      }, restConfig), {
        content: /* @__PURE__ */ import_react41.default.createElement(PureContent2, {
          prefixCls: noticePrefixCls,
          icon,
          type: type4,
          message: message2,
          description,
          btn,
          role
        }),
        className: (0, import_classnames21.default)(type4 && `${noticePrefixCls}-${type4}`, className, notification2 === null || notification2 === void 0 ? void 0 : notification2.className),
        style: Object.assign(Object.assign({}, notification2 === null || notification2 === void 0 ? void 0 : notification2.style), style2),
        closeIcon: realCloseIcon,
        closable: !!realCloseIcon
      }));
    };
    const destroy3 = (key) => {
      var _a, _b;
      if (key !== void 0) {
        (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.close(key);
      } else {
        (_b = holderRef.current) === null || _b === void 0 ? void 0 : _b.destroy();
      }
    };
    const clone = {
      open: open3,
      destroy: destroy3
    };
    const keys3 = ["success", "info", "warning", "error"];
    keys3.forEach((type4) => {
      clone[type4] = (config) => open3(Object.assign(Object.assign({}, config), {
        type: type4
      }));
    });
    return clone;
  }, []);
  return [wrapAPI, /* @__PURE__ */ import_react41.default.createElement(Holder2, Object.assign({
    key: "notification-holder"
  }, notificationConfig, {
    ref: holderRef
  }))];
}
function useNotification2(notificationConfig) {
  return useInternalNotification(notificationConfig);
}

// ../../node_modules/antd/es/app/context.js
var import_react42 = __toESM(require("react"));
var AppConfigContext = /* @__PURE__ */ import_react42.default.createContext({});

// ../../node_modules/antd/es/_util/PurePanel.js
var React106 = __toESM(require("react"));
function withPureRenderTheme(Component6) {
  return (props) => /* @__PURE__ */ React106.createElement(config_provider_default, {
    theme: {
      token: {
        motion: false,
        zIndexPopupBase: 0
      }
    }
  }, /* @__PURE__ */ React106.createElement(Component6, Object.assign({}, props)));
}
var genPurePanel = (Component6, defaultPrefixCls2, getDropdownCls, postProps) => {
  const PurePanel6 = (props) => {
    const {
      prefixCls: customizePrefixCls,
      style: style2
    } = props;
    const holderRef = React106.useRef(null);
    const [popupHeight, setPopupHeight] = React106.useState(0);
    const [popupWidth, setPopupWidth] = React106.useState(0);
    const [open3, setOpen] = useMergedState(false, {
      value: props.open
    });
    const {
      getPrefixCls
    } = React106.useContext(ConfigContext);
    const prefixCls = getPrefixCls(defaultPrefixCls2 || "select", customizePrefixCls);
    React106.useEffect(() => {
      setOpen(true);
      if (typeof ResizeObserver !== "undefined") {
        const resizeObserver2 = new ResizeObserver((entries) => {
          const element = entries[0].target;
          setPopupHeight(element.offsetHeight + 8);
          setPopupWidth(element.offsetWidth);
        });
        const interval = setInterval(() => {
          var _a;
          const dropdownCls = getDropdownCls ? `.${getDropdownCls(prefixCls)}` : `.${prefixCls}-dropdown`;
          const popup = (_a = holderRef.current) === null || _a === void 0 ? void 0 : _a.querySelector(dropdownCls);
          if (popup) {
            clearInterval(interval);
            resizeObserver2.observe(popup);
          }
        }, 10);
        return () => {
          clearInterval(interval);
          resizeObserver2.disconnect();
        };
      }
    }, []);
    let mergedProps = Object.assign(Object.assign({}, props), {
      style: Object.assign(Object.assign({}, style2), {
        margin: 0
      }),
      open: open3,
      visible: open3,
      getPopupContainer: () => holderRef.current
    });
    if (postProps) {
      mergedProps = postProps(mergedProps);
    }
    const mergedStyle = {
      paddingBottom: popupHeight,
      position: "relative",
      minWidth: popupWidth
    };
    return /* @__PURE__ */ React106.createElement("div", {
      ref: holderRef,
      style: mergedStyle
    }, /* @__PURE__ */ React106.createElement(Component6, Object.assign({}, mergedProps)));
  };
  return withPureRenderTheme(PurePanel6);
};
var PurePanel_default3 = genPurePanel;

// ../../node_modules/antd/es/select/index.js
var React162 = __toESM(require("react"));
var import_classnames40 = __toESM(require_classnames());

// ../../node_modules/rc-select/es/Select.js
var React153 = __toESM(require("react"));

// ../../node_modules/rc-select/es/BaseSelect.js
var import_classnames33 = __toESM(require_classnames());

// ../../node_modules/rc-util/es/isMobile.js
var isMobile_default = function() {
  if (typeof navigator === "undefined" || typeof window === "undefined") {
    return false;
  }
  var agent = navigator.userAgent || navigator.vendor || window.opera;
  return /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(agent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw-(n|u)|c55\/|capi|ccwa|cdm-|cell|chtm|cldc|cmd-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc-s|devi|dica|dmob|do(c|p)o|ds(12|-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(-|_)|g1 u|g560|gene|gf-5|g-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd-(m|p|t)|hei-|hi(pt|ta)|hp( i|ip)|hs-c|ht(c(-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i-(20|go|ma)|i230|iac( |-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|-[a-w])|libw|lynx|m1-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|-([1-8]|c))|phil|pire|pl(ay|uc)|pn-2|po(ck|rt|se)|prox|psio|pt-g|qa-a|qc(07|12|21|32|60|-[2-7]|i-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h-|oo|p-)|sdk\/|se(c(-|0|1)|47|mc|nd|ri)|sgh-|shar|sie(-|m)|sk-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h-|v-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl-|tdg-|tel(i|m)|tim-|t-mo|to(pl|sh)|ts(70|m-|m3|m5)|tx-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas-|your|zeto|zte-/i.test(agent === null || agent === void 0 ? void 0 : agent.substr(0, 4));
};

// ../../node_modules/rc-select/es/BaseSelect.js
var React135 = __toESM(require("react"));

// ../../node_modules/rc-select/es/TransBtn.js
var React107 = __toESM(require("react"));
var import_classnames22 = __toESM(require_classnames());
var TransBtn = function TransBtn2(props) {
  var className = props.className, customizeIcon = props.customizeIcon, customizeIconProps = props.customizeIconProps, children = props.children, _onMouseDown = props.onMouseDown, onClick = props.onClick;
  var icon = typeof customizeIcon === "function" ? customizeIcon(customizeIconProps) : customizeIcon;
  return /* @__PURE__ */ React107.createElement("span", {
    className,
    onMouseDown: function onMouseDown(event) {
      event.preventDefault();
      _onMouseDown === null || _onMouseDown === void 0 || _onMouseDown(event);
    },
    style: {
      userSelect: "none",
      WebkitUserSelect: "none"
    },
    unselectable: "on",
    onClick,
    "aria-hidden": true
  }, icon !== void 0 ? icon : /* @__PURE__ */ React107.createElement("span", {
    className: (0, import_classnames22.default)(className.split(/\s+/).map(function(cls) {
      return "".concat(cls, "-icon");
    }))
  }, children));
};
var TransBtn_default = TransBtn;

// ../../node_modules/rc-select/es/hooks/useAllowClear.js
var import_react43 = __toESM(require("react"));
var useAllowClear = function useAllowClear2(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon) {
  var disabled = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
  var mergedSearchValue = arguments.length > 6 ? arguments[6] : void 0;
  var mode = arguments.length > 7 ? arguments[7] : void 0;
  var mergedClearIcon = import_react43.default.useMemo(function() {
    if (_typeof(allowClear) === "object") {
      return allowClear.clearIcon;
    }
    if (clearIcon) {
      return clearIcon;
    }
  }, [allowClear, clearIcon]);
  var mergedAllowClear = import_react43.default.useMemo(function() {
    if (!disabled && !!allowClear && (displayValues.length || mergedSearchValue) && !(mode === "combobox" && mergedSearchValue === "")) {
      return true;
    }
    return false;
  }, [allowClear, disabled, displayValues.length, mergedSearchValue, mode]);
  return {
    allowClear: mergedAllowClear,
    clearIcon: /* @__PURE__ */ import_react43.default.createElement(TransBtn_default, {
      className: "".concat(prefixCls, "-clear"),
      onMouseDown: onClearMouseDown,
      customizeIcon: mergedClearIcon
    }, "\xD7")
  };
};

// ../../node_modules/rc-select/es/hooks/useBaseProps.js
var React109 = __toESM(require("react"));
var BaseSelectContext = /* @__PURE__ */ React109.createContext(null);
function useBaseProps() {
  return React109.useContext(BaseSelectContext);
}

// ../../node_modules/rc-select/es/hooks/useDelayReset.js
var React110 = __toESM(require("react"));
function useDelayReset() {
  var timeout = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
  var _React$useState = React110.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), bool = _React$useState2[0], setBool = _React$useState2[1];
  var delayRef = React110.useRef(null);
  var cancelLatest = function cancelLatest2() {
    window.clearTimeout(delayRef.current);
  };
  React110.useEffect(function() {
    return cancelLatest;
  }, []);
  var delaySetBool = function delaySetBool2(value, callback) {
    cancelLatest();
    delayRef.current = window.setTimeout(function() {
      setBool(value);
      if (callback) {
        callback();
      }
    }, timeout);
  };
  return [bool, delaySetBool, cancelLatest];
}

// ../../node_modules/rc-select/es/hooks/useLock.js
var React111 = __toESM(require("react"));
function useLock() {
  var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 250;
  var lockRef = React111.useRef(null);
  var timeoutRef = React111.useRef(null);
  React111.useEffect(function() {
    return function() {
      window.clearTimeout(timeoutRef.current);
    };
  }, []);
  function doLock(locked) {
    if (locked || lockRef.current === null) {
      lockRef.current = locked;
    }
    window.clearTimeout(timeoutRef.current);
    timeoutRef.current = window.setTimeout(function() {
      lockRef.current = null;
    }, duration);
  }
  return [function() {
    return lockRef.current;
  }, doLock];
}

// ../../node_modules/rc-select/es/hooks/useSelectTriggerControl.js
var React112 = __toESM(require("react"));
function useSelectTriggerControl(elements, open3, triggerOpen, customizedTrigger) {
  var propsRef = React112.useRef(null);
  propsRef.current = {
    open: open3,
    triggerOpen,
    customizedTrigger
  };
  React112.useEffect(function() {
    function onGlobalMouseDown(event) {
      var _propsRef$current;
      if ((_propsRef$current = propsRef.current) !== null && _propsRef$current !== void 0 && _propsRef$current.customizedTrigger) {
        return;
      }
      var target = event.target;
      if (target.shadowRoot && event.composed) {
        target = event.composedPath()[0] || target;
      }
      if (propsRef.current.open && elements().filter(function(element) {
        return element;
      }).every(function(element) {
        return !element.contains(target) && element !== target;
      })) {
        propsRef.current.triggerOpen(false);
      }
    }
    window.addEventListener("mousedown", onGlobalMouseDown);
    return function() {
      return window.removeEventListener("mousedown", onGlobalMouseDown);
    };
  }, []);
}

// ../../node_modules/rc-select/es/Selector/index.js
var React122 = __toESM(require("react"));
var import_react47 = require("react");

// ../../node_modules/rc-select/es/Selector/MultipleSelector.js
var React120 = __toESM(require("react"));
var import_react46 = require("react");
var import_classnames27 = __toESM(require_classnames());

// ../../node_modules/rc-overflow/es/Overflow.js
var React117 = __toESM(require("react"));
var import_react45 = require("react");
var import_classnames25 = __toESM(require_classnames());

// ../../node_modules/rc-overflow/es/Item.js
var React113 = __toESM(require("react"));
var import_classnames23 = __toESM(require_classnames());
var _excluded10 = ["prefixCls", "invalidate", "item", "renderItem", "responsive", "responsiveDisabled", "registerSize", "itemKey", "className", "style", "children", "display", "order", "component"];
var UNDEFINED = void 0;
function InternalItem(props, ref) {
  var prefixCls = props.prefixCls, invalidate = props.invalidate, item = props.item, renderItem = props.renderItem, responsive = props.responsive, responsiveDisabled = props.responsiveDisabled, registerSize = props.registerSize, itemKey2 = props.itemKey, className = props.className, style2 = props.style, children = props.children, display = props.display, order = props.order, _props$component = props.component, Component6 = _props$component === void 0 ? "div" : _props$component, restProps = _objectWithoutProperties(props, _excluded10);
  var mergedHidden = responsive && !display;
  function internalRegisterSize(width) {
    registerSize(itemKey2, width);
  }
  React113.useEffect(function() {
    return function() {
      internalRegisterSize(null);
    };
  }, []);
  var childNode = renderItem && item !== UNDEFINED ? renderItem(item) : children;
  var overflowStyle;
  if (!invalidate) {
    overflowStyle = {
      opacity: mergedHidden ? 0 : 1,
      height: mergedHidden ? 0 : UNDEFINED,
      overflowY: mergedHidden ? "hidden" : UNDEFINED,
      order: responsive ? order : UNDEFINED,
      pointerEvents: mergedHidden ? "none" : UNDEFINED,
      position: mergedHidden ? "absolute" : UNDEFINED
    };
  }
  var overflowProps = {};
  if (mergedHidden) {
    overflowProps["aria-hidden"] = true;
  }
  var itemNode = /* @__PURE__ */ React113.createElement(Component6, _extends({
    className: (0, import_classnames23.default)(!invalidate && prefixCls, className),
    style: _objectSpread2(_objectSpread2({}, overflowStyle), style2)
  }, overflowProps, restProps, {
    ref
  }), childNode);
  if (responsive) {
    itemNode = /* @__PURE__ */ React113.createElement(es_default, {
      onResize: function onResize2(_ref) {
        var offsetWidth = _ref.offsetWidth;
        internalRegisterSize(offsetWidth);
      },
      disabled: responsiveDisabled
    }, itemNode);
  }
  return itemNode;
}
var Item = /* @__PURE__ */ React113.forwardRef(InternalItem);
Item.displayName = "Item";
var Item_default = Item;

// ../../node_modules/rc-overflow/es/hooks/useEffectState.js
var React114 = __toESM(require("react"));
var import_react_dom4 = require("react-dom");

// ../../node_modules/rc-overflow/es/hooks/channelUpdate.js
function channelUpdate(callback) {
  if (typeof MessageChannel === "undefined") {
    raf_default(callback);
  } else {
    var channel = new MessageChannel();
    channel.port1.onmessage = function() {
      return callback();
    };
    channel.port2.postMessage(void 0);
  }
}

// ../../node_modules/rc-overflow/es/hooks/useEffectState.js
function useBatcher() {
  var updateFuncRef = React114.useRef(null);
  var notifyEffectUpdate = function notifyEffectUpdate2(callback) {
    if (!updateFuncRef.current) {
      updateFuncRef.current = [];
      channelUpdate(function() {
        (0, import_react_dom4.unstable_batchedUpdates)(function() {
          updateFuncRef.current.forEach(function(fn) {
            fn();
          });
          updateFuncRef.current = null;
        });
      });
    }
    updateFuncRef.current.push(callback);
  };
  return notifyEffectUpdate;
}
function useEffectState(notifyEffectUpdate, defaultValue) {
  var _React$useState = React114.useState(defaultValue), _React$useState2 = _slicedToArray(_React$useState, 2), stateValue = _React$useState2[0], setStateValue = _React$useState2[1];
  var setEffectVal = useEvent(function(nextValue) {
    notifyEffectUpdate(function() {
      setStateValue(nextValue);
    });
  });
  return [stateValue, setEffectVal];
}

// ../../node_modules/rc-overflow/es/RawItem.js
var React116 = __toESM(require("react"));
var import_classnames24 = __toESM(require_classnames());

// ../../node_modules/rc-overflow/es/context.js
var import_react44 = __toESM(require("react"));
var OverflowContext = /* @__PURE__ */ import_react44.default.createContext(null);

// ../../node_modules/rc-overflow/es/RawItem.js
var _excluded11 = ["component"];
var _excluded23 = ["className"];
var _excluded32 = ["className"];
var InternalRawItem = function InternalRawItem2(props, ref) {
  var context = React116.useContext(OverflowContext);
  if (!context) {
    var _props$component = props.component, Component6 = _props$component === void 0 ? "div" : _props$component, _restProps = _objectWithoutProperties(props, _excluded11);
    return /* @__PURE__ */ React116.createElement(Component6, _extends({}, _restProps, {
      ref
    }));
  }
  var contextClassName = context.className, restContext = _objectWithoutProperties(context, _excluded23);
  var className = props.className, restProps = _objectWithoutProperties(props, _excluded32);
  return /* @__PURE__ */ React116.createElement(OverflowContext.Provider, {
    value: null
  }, /* @__PURE__ */ React116.createElement(Item_default, _extends({
    ref,
    className: (0, import_classnames24.default)(contextClassName, className)
  }, restContext, restProps)));
};
var RawItem = /* @__PURE__ */ React116.forwardRef(InternalRawItem);
RawItem.displayName = "RawItem";
var RawItem_default = RawItem;

// ../../node_modules/rc-overflow/es/Overflow.js
var _excluded12 = ["prefixCls", "data", "renderItem", "renderRawItem", "itemKey", "itemWidth", "ssr", "style", "className", "maxCount", "renderRest", "renderRawRest", "suffix", "component", "itemComponent", "onVisibleChange"];
var RESPONSIVE = "responsive";
var INVALIDATE = "invalidate";
function defaultRenderRest(omittedItems) {
  return "+ ".concat(omittedItems.length, " ...");
}
function Overflow(props, ref) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-overflow" : _props$prefixCls, _props$data = props.data, data = _props$data === void 0 ? [] : _props$data, renderItem = props.renderItem, renderRawItem = props.renderRawItem, itemKey2 = props.itemKey, _props$itemWidth = props.itemWidth, itemWidth = _props$itemWidth === void 0 ? 10 : _props$itemWidth, ssr = props.ssr, style2 = props.style, className = props.className, maxCount = props.maxCount, renderRest = props.renderRest, renderRawRest = props.renderRawRest, suffix = props.suffix, _props$component = props.component, Component6 = _props$component === void 0 ? "div" : _props$component, itemComponent = props.itemComponent, onVisibleChange = props.onVisibleChange, restProps = _objectWithoutProperties(props, _excluded12);
  var fullySSR = ssr === "full";
  var notifyEffectUpdate = useBatcher();
  var _useEffectState = useEffectState(notifyEffectUpdate, null), _useEffectState2 = _slicedToArray(_useEffectState, 2), containerWidth = _useEffectState2[0], setContainerWidth = _useEffectState2[1];
  var mergedContainerWidth = containerWidth || 0;
  var _useEffectState3 = useEffectState(notifyEffectUpdate, /* @__PURE__ */ new Map()), _useEffectState4 = _slicedToArray(_useEffectState3, 2), itemWidths = _useEffectState4[0], setItemWidths = _useEffectState4[1];
  var _useEffectState5 = useEffectState(notifyEffectUpdate, 0), _useEffectState6 = _slicedToArray(_useEffectState5, 2), prevRestWidth = _useEffectState6[0], setPrevRestWidth = _useEffectState6[1];
  var _useEffectState7 = useEffectState(notifyEffectUpdate, 0), _useEffectState8 = _slicedToArray(_useEffectState7, 2), restWidth = _useEffectState8[0], setRestWidth = _useEffectState8[1];
  var _useEffectState9 = useEffectState(notifyEffectUpdate, 0), _useEffectState10 = _slicedToArray(_useEffectState9, 2), suffixWidth = _useEffectState10[0], setSuffixWidth = _useEffectState10[1];
  var _useState = (0, import_react45.useState)(null), _useState2 = _slicedToArray(_useState, 2), suffixFixedStart = _useState2[0], setSuffixFixedStart = _useState2[1];
  var _useState3 = (0, import_react45.useState)(null), _useState4 = _slicedToArray(_useState3, 2), displayCount = _useState4[0], setDisplayCount = _useState4[1];
  var mergedDisplayCount = React117.useMemo(function() {
    if (displayCount === null && fullySSR) {
      return Number.MAX_SAFE_INTEGER;
    }
    return displayCount || 0;
  }, [displayCount, containerWidth]);
  var _useState5 = (0, import_react45.useState)(false), _useState6 = _slicedToArray(_useState5, 2), restReady = _useState6[0], setRestReady = _useState6[1];
  var itemPrefixCls = "".concat(prefixCls, "-item");
  var mergedRestWidth = Math.max(prevRestWidth, restWidth);
  var isResponsive = maxCount === RESPONSIVE;
  var shouldResponsive = data.length && isResponsive;
  var invalidate = maxCount === INVALIDATE;
  var showRest = shouldResponsive || typeof maxCount === "number" && data.length > maxCount;
  var mergedData = (0, import_react45.useMemo)(function() {
    var items = data;
    if (shouldResponsive) {
      if (containerWidth === null && fullySSR) {
        items = data;
      } else {
        items = data.slice(0, Math.min(data.length, mergedContainerWidth / itemWidth));
      }
    } else if (typeof maxCount === "number") {
      items = data.slice(0, maxCount);
    }
    return items;
  }, [data, itemWidth, containerWidth, maxCount, shouldResponsive]);
  var omittedItems = (0, import_react45.useMemo)(function() {
    if (shouldResponsive) {
      return data.slice(mergedDisplayCount + 1);
    }
    return data.slice(mergedData.length);
  }, [data, mergedData, shouldResponsive, mergedDisplayCount]);
  var getKey2 = (0, import_react45.useCallback)(function(item, index2) {
    var _ref;
    if (typeof itemKey2 === "function") {
      return itemKey2(item);
    }
    return (_ref = itemKey2 && (item === null || item === void 0 ? void 0 : item[itemKey2])) !== null && _ref !== void 0 ? _ref : index2;
  }, [itemKey2]);
  var mergedRenderItem = (0, import_react45.useCallback)(renderItem || function(item) {
    return item;
  }, [renderItem]);
  function updateDisplayCount(count, suffixFixedStartVal, notReady) {
    if (displayCount === count && (suffixFixedStartVal === void 0 || suffixFixedStartVal === suffixFixedStart)) {
      return;
    }
    setDisplayCount(count);
    if (!notReady) {
      setRestReady(count < data.length - 1);
      onVisibleChange === null || onVisibleChange === void 0 ? void 0 : onVisibleChange(count);
    }
    if (suffixFixedStartVal !== void 0) {
      setSuffixFixedStart(suffixFixedStartVal);
    }
  }
  function onOverflowResize(_, element) {
    setContainerWidth(element.clientWidth);
  }
  function registerSize(key, width) {
    setItemWidths(function(origin) {
      var clone = new Map(origin);
      if (width === null) {
        clone.delete(key);
      } else {
        clone.set(key, width);
      }
      return clone;
    });
  }
  function registerOverflowSize(_, width) {
    setRestWidth(width);
    setPrevRestWidth(restWidth);
  }
  function registerSuffixSize(_, width) {
    setSuffixWidth(width);
  }
  function getItemWidth(index2) {
    return itemWidths.get(getKey2(mergedData[index2], index2));
  }
  useLayoutEffect_default(function() {
    if (mergedContainerWidth && typeof mergedRestWidth === "number" && mergedData) {
      var totalWidth = suffixWidth;
      var len = mergedData.length;
      var lastIndex = len - 1;
      if (!len) {
        updateDisplayCount(0, null);
        return;
      }
      for (var i = 0; i < len; i += 1) {
        var currentItemWidth = getItemWidth(i);
        if (fullySSR) {
          currentItemWidth = currentItemWidth || 0;
        }
        if (currentItemWidth === void 0) {
          updateDisplayCount(i - 1, void 0, true);
          break;
        }
        totalWidth += currentItemWidth;
        if (
          // Only one means `totalWidth` is the final width
          lastIndex === 0 && totalWidth <= mergedContainerWidth || // Last two width will be the final width
          i === lastIndex - 1 && totalWidth + getItemWidth(lastIndex) <= mergedContainerWidth
        ) {
          updateDisplayCount(lastIndex, null);
          break;
        } else if (totalWidth + mergedRestWidth > mergedContainerWidth) {
          updateDisplayCount(i - 1, totalWidth - currentItemWidth - suffixWidth + restWidth);
          break;
        }
      }
      if (suffix && getItemWidth(0) + suffixWidth > mergedContainerWidth) {
        setSuffixFixedStart(null);
      }
    }
  }, [mergedContainerWidth, itemWidths, restWidth, suffixWidth, getKey2, mergedData]);
  var displayRest = restReady && !!omittedItems.length;
  var suffixStyle = {};
  if (suffixFixedStart !== null && shouldResponsive) {
    suffixStyle = {
      position: "absolute",
      left: suffixFixedStart,
      top: 0
    };
  }
  var itemSharedProps = {
    prefixCls: itemPrefixCls,
    responsive: shouldResponsive,
    component: itemComponent,
    invalidate
  };
  var internalRenderItemNode = renderRawItem ? function(item, index2) {
    var key = getKey2(item, index2);
    return /* @__PURE__ */ React117.createElement(OverflowContext.Provider, {
      key,
      value: _objectSpread2(_objectSpread2({}, itemSharedProps), {}, {
        order: index2,
        item,
        itemKey: key,
        registerSize,
        display: index2 <= mergedDisplayCount
      })
    }, renderRawItem(item, index2));
  } : function(item, index2) {
    var key = getKey2(item, index2);
    return /* @__PURE__ */ React117.createElement(Item_default, _extends({}, itemSharedProps, {
      order: index2,
      key,
      item,
      renderItem: mergedRenderItem,
      itemKey: key,
      registerSize,
      display: index2 <= mergedDisplayCount
    }));
  };
  var restNode;
  var restContextProps = {
    order: displayRest ? mergedDisplayCount : Number.MAX_SAFE_INTEGER,
    className: "".concat(itemPrefixCls, "-rest"),
    registerSize: registerOverflowSize,
    display: displayRest
  };
  if (!renderRawRest) {
    var mergedRenderRest = renderRest || defaultRenderRest;
    restNode = /* @__PURE__ */ React117.createElement(Item_default, _extends({}, itemSharedProps, restContextProps), typeof mergedRenderRest === "function" ? mergedRenderRest(omittedItems) : mergedRenderRest);
  } else if (renderRawRest) {
    restNode = /* @__PURE__ */ React117.createElement(OverflowContext.Provider, {
      value: _objectSpread2(_objectSpread2({}, itemSharedProps), restContextProps)
    }, renderRawRest(omittedItems));
  }
  var overflowNode = /* @__PURE__ */ React117.createElement(Component6, _extends({
    className: (0, import_classnames25.default)(!invalidate && prefixCls, className),
    style: style2,
    ref
  }, restProps), mergedData.map(internalRenderItemNode), showRest ? restNode : null, suffix && /* @__PURE__ */ React117.createElement(Item_default, _extends({}, itemSharedProps, {
    responsive: isResponsive,
    responsiveDisabled: !shouldResponsive,
    order: mergedDisplayCount,
    className: "".concat(itemPrefixCls, "-suffix"),
    registerSize: registerSuffixSize,
    display: true,
    style: suffixStyle
  }), suffix));
  if (isResponsive) {
    overflowNode = /* @__PURE__ */ React117.createElement(es_default, {
      onResize: onOverflowResize,
      disabled: !shouldResponsive
    }, overflowNode);
  }
  return overflowNode;
}
var ForwardOverflow = /* @__PURE__ */ React117.forwardRef(Overflow);
ForwardOverflow.displayName = "Overflow";
ForwardOverflow.Item = RawItem_default;
ForwardOverflow.RESPONSIVE = RESPONSIVE;
ForwardOverflow.INVALIDATE = INVALIDATE;
var Overflow_default = ForwardOverflow;

// ../../node_modules/rc-overflow/es/index.js
var es_default5 = Overflow_default;

// ../../node_modules/rc-select/es/Selector/Input.js
var React118 = __toESM(require("react"));
var import_classnames26 = __toESM(require_classnames());
var Input = function Input2(props, ref) {
  var _inputNode2;
  var prefixCls = props.prefixCls, id = props.id, inputElement = props.inputElement, disabled = props.disabled, tabIndex = props.tabIndex, autoFocus = props.autoFocus, autoComplete = props.autoComplete, editable = props.editable, activeDescendantId = props.activeDescendantId, value = props.value, maxLength = props.maxLength, _onKeyDown = props.onKeyDown, _onMouseDown = props.onMouseDown, _onChange = props.onChange, onPaste = props.onPaste, _onCompositionStart = props.onCompositionStart, _onCompositionEnd = props.onCompositionEnd, open3 = props.open, attrs = props.attrs;
  var inputNode = inputElement || /* @__PURE__ */ React118.createElement("input", null);
  var _inputNode = inputNode, originRef = _inputNode.ref, originProps = _inputNode.props;
  var onOriginKeyDown = originProps.onKeyDown, onOriginChange = originProps.onChange, onOriginMouseDown = originProps.onMouseDown, onOriginCompositionStart = originProps.onCompositionStart, onOriginCompositionEnd = originProps.onCompositionEnd, style2 = originProps.style;
  warning(!("maxLength" in inputNode.props), "Passing 'maxLength' to input element directly may not work because input in BaseSelect is controlled.");
  inputNode = /* @__PURE__ */ React118.cloneElement(inputNode, _objectSpread2(_objectSpread2(_objectSpread2({
    type: "search"
  }, originProps), {}, {
    // Override over origin props
    id,
    ref: composeRef(ref, originRef),
    disabled,
    tabIndex,
    autoComplete: autoComplete || "off",
    autoFocus,
    className: (0, import_classnames26.default)("".concat(prefixCls, "-selection-search-input"), (_inputNode2 = inputNode) === null || _inputNode2 === void 0 || (_inputNode2 = _inputNode2.props) === null || _inputNode2 === void 0 ? void 0 : _inputNode2.className),
    role: "combobox",
    "aria-expanded": open3 || false,
    "aria-haspopup": "listbox",
    "aria-owns": "".concat(id, "_list"),
    "aria-autocomplete": "list",
    "aria-controls": "".concat(id, "_list"),
    "aria-activedescendant": open3 ? activeDescendantId : void 0
  }, attrs), {}, {
    value: editable ? value : "",
    maxLength,
    readOnly: !editable,
    unselectable: !editable ? "on" : null,
    style: _objectSpread2(_objectSpread2({}, style2), {}, {
      opacity: editable ? null : 0
    }),
    onKeyDown: function onKeyDown(event) {
      _onKeyDown(event);
      if (onOriginKeyDown) {
        onOriginKeyDown(event);
      }
    },
    onMouseDown: function onMouseDown(event) {
      _onMouseDown(event);
      if (onOriginMouseDown) {
        onOriginMouseDown(event);
      }
    },
    onChange: function onChange(event) {
      _onChange(event);
      if (onOriginChange) {
        onOriginChange(event);
      }
    },
    onCompositionStart: function onCompositionStart(event) {
      _onCompositionStart(event);
      if (onOriginCompositionStart) {
        onOriginCompositionStart(event);
      }
    },
    onCompositionEnd: function onCompositionEnd(event) {
      _onCompositionEnd(event);
      if (onOriginCompositionEnd) {
        onOriginCompositionEnd(event);
      }
    },
    onPaste
  }));
  return inputNode;
};
var RefInput = /* @__PURE__ */ React118.forwardRef(Input);
if (process.env.NODE_ENV !== "production") {
  RefInput.displayName = "Input";
}
var Input_default = RefInput;

// ../../node_modules/rc-select/es/hooks/useLayoutEffect.js
var React119 = __toESM(require("react"));

// ../../node_modules/rc-select/es/utils/commonUtil.js
function toArray3(value) {
  if (Array.isArray(value)) {
    return value;
  }
  return value !== void 0 ? [value] : [];
}
var isClient = typeof window !== "undefined" && window.document && window.document.documentElement;
var isBrowserClient = process.env.NODE_ENV !== "test" && isClient;
function hasValue2(value) {
  return value !== void 0 && value !== null;
}
function isComboNoValue(value) {
  return !value && value !== 0;
}
function isTitleType(title) {
  return ["string", "number"].includes(_typeof(title));
}
function getTitle(item) {
  var title = void 0;
  if (item) {
    if (isTitleType(item.title)) {
      title = item.title.toString();
    } else if (isTitleType(item.label)) {
      title = item.label.toString();
    }
  }
  return title;
}

// ../../node_modules/rc-select/es/hooks/useLayoutEffect.js
function useLayoutEffect6(effect, deps) {
  if (isBrowserClient) {
    React119.useLayoutEffect(effect, deps);
  } else {
    React119.useEffect(effect, deps);
  }
}

// ../../node_modules/rc-select/es/Selector/MultipleSelector.js
function itemKey(value) {
  var _value$key;
  return (_value$key = value.key) !== null && _value$key !== void 0 ? _value$key : value.value;
}
var onPreventMouseDown = function onPreventMouseDown2(event) {
  event.preventDefault();
  event.stopPropagation();
};
var SelectSelector = function SelectSelector2(props) {
  var id = props.id, prefixCls = props.prefixCls, values = props.values, open3 = props.open, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, inputRef = props.inputRef, placeholder = props.placeholder, disabled = props.disabled, mode = props.mode, showSearch = props.showSearch, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, tabIndex = props.tabIndex, removeIcon = props.removeIcon, maxTagCount = props.maxTagCount, maxTagTextLength = props.maxTagTextLength, _props$maxTagPlacehol = props.maxTagPlaceholder, maxTagPlaceholder = _props$maxTagPlacehol === void 0 ? function(omittedValues) {
    return "+ ".concat(omittedValues.length, " ...");
  } : _props$maxTagPlacehol, tagRender = props.tagRender, onToggleOpen = props.onToggleOpen, onRemove = props.onRemove, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd;
  var measureRef = React120.useRef(null);
  var _useState = (0, import_react46.useState)(0), _useState2 = _slicedToArray(_useState, 2), inputWidth = _useState2[0], setInputWidth = _useState2[1];
  var _useState3 = (0, import_react46.useState)(false), _useState4 = _slicedToArray(_useState3, 2), focused = _useState4[0], setFocused = _useState4[1];
  var selectionPrefixCls = "".concat(prefixCls, "-selection");
  var inputValue = open3 || mode === "multiple" && autoClearSearchValue === false || mode === "tags" ? searchValue : "";
  var inputEditable = mode === "tags" || mode === "multiple" && autoClearSearchValue === false || showSearch && (open3 || focused);
  useLayoutEffect6(function() {
    setInputWidth(measureRef.current.scrollWidth);
  }, [inputValue]);
  var defaultRenderSelector = function defaultRenderSelector2(item, content, itemDisabled, closable, onClose) {
    return /* @__PURE__ */ React120.createElement("span", {
      title: getTitle(item),
      className: (0, import_classnames27.default)("".concat(selectionPrefixCls, "-item"), _defineProperty({}, "".concat(selectionPrefixCls, "-item-disabled"), itemDisabled))
    }, /* @__PURE__ */ React120.createElement("span", {
      className: "".concat(selectionPrefixCls, "-item-content")
    }, content), closable && /* @__PURE__ */ React120.createElement(TransBtn_default, {
      className: "".concat(selectionPrefixCls, "-item-remove"),
      onMouseDown: onPreventMouseDown,
      onClick: onClose,
      customizeIcon: removeIcon
    }, "\xD7"));
  };
  var customizeRenderSelector = function customizeRenderSelector2(value, content, itemDisabled, closable, onClose) {
    var onMouseDown = function onMouseDown2(e) {
      onPreventMouseDown(e);
      onToggleOpen(!open3);
    };
    return /* @__PURE__ */ React120.createElement("span", {
      onMouseDown
    }, tagRender({
      label: content,
      value,
      disabled: itemDisabled,
      closable,
      onClose
    }));
  };
  var renderItem = function renderItem2(valueItem) {
    var itemDisabled = valueItem.disabled, label = valueItem.label, value = valueItem.value;
    var closable = !disabled && !itemDisabled;
    var displayLabel = label;
    if (typeof maxTagTextLength === "number") {
      if (typeof label === "string" || typeof label === "number") {
        var strLabel = String(displayLabel);
        if (strLabel.length > maxTagTextLength) {
          displayLabel = "".concat(strLabel.slice(0, maxTagTextLength), "...");
        }
      }
    }
    var onClose = function onClose2(event) {
      if (event) {
        event.stopPropagation();
      }
      onRemove(valueItem);
    };
    return typeof tagRender === "function" ? customizeRenderSelector(value, displayLabel, itemDisabled, closable, onClose) : defaultRenderSelector(valueItem, displayLabel, itemDisabled, closable, onClose);
  };
  var renderRest = function renderRest2(omittedValues) {
    var content = typeof maxTagPlaceholder === "function" ? maxTagPlaceholder(omittedValues) : maxTagPlaceholder;
    return defaultRenderSelector({
      title: content
    }, content, false);
  };
  var inputNode = /* @__PURE__ */ React120.createElement("div", {
    className: "".concat(selectionPrefixCls, "-search"),
    style: {
      width: inputWidth
    },
    onFocus: function onFocus() {
      setFocused(true);
    },
    onBlur: function onBlur() {
      setFocused(false);
    }
  }, /* @__PURE__ */ React120.createElement(Input_default, {
    ref: inputRef,
    open: open3,
    prefixCls,
    id,
    inputElement: null,
    disabled,
    autoFocus,
    autoComplete,
    editable: inputEditable,
    activeDescendantId,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: onInputChange,
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    tabIndex,
    attrs: pickAttrs(props, true)
  }), /* @__PURE__ */ React120.createElement("span", {
    ref: measureRef,
    className: "".concat(selectionPrefixCls, "-search-mirror"),
    "aria-hidden": true
  }, inputValue, "\xA0"));
  var selectionNode = /* @__PURE__ */ React120.createElement(es_default5, {
    prefixCls: "".concat(selectionPrefixCls, "-overflow"),
    data: values,
    renderItem,
    renderRest,
    suffix: inputNode,
    itemKey,
    maxCount: maxTagCount
  });
  return /* @__PURE__ */ React120.createElement(React120.Fragment, null, selectionNode, !values.length && !inputValue && /* @__PURE__ */ React120.createElement("span", {
    className: "".concat(selectionPrefixCls, "-placeholder")
  }, placeholder));
};
var MultipleSelector_default = SelectSelector;

// ../../node_modules/rc-select/es/Selector/SingleSelector.js
var React121 = __toESM(require("react"));
var SingleSelector = function SingleSelector2(props) {
  var inputElement = props.inputElement, prefixCls = props.prefixCls, id = props.id, inputRef = props.inputRef, disabled = props.disabled, autoFocus = props.autoFocus, autoComplete = props.autoComplete, activeDescendantId = props.activeDescendantId, mode = props.mode, open3 = props.open, values = props.values, placeholder = props.placeholder, tabIndex = props.tabIndex, showSearch = props.showSearch, searchValue = props.searchValue, activeValue = props.activeValue, maxLength = props.maxLength, onInputKeyDown = props.onInputKeyDown, onInputMouseDown = props.onInputMouseDown, onInputChange = props.onInputChange, onInputPaste = props.onInputPaste, onInputCompositionStart = props.onInputCompositionStart, onInputCompositionEnd = props.onInputCompositionEnd, title = props.title;
  var _React$useState = React121.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), inputChanged = _React$useState2[0], setInputChanged = _React$useState2[1];
  var combobox = mode === "combobox";
  var inputEditable = combobox || showSearch;
  var item = values[0];
  var inputValue = searchValue || "";
  if (combobox && activeValue && !inputChanged) {
    inputValue = activeValue;
  }
  React121.useEffect(function() {
    if (combobox) {
      setInputChanged(false);
    }
  }, [combobox, activeValue]);
  var hasTextInput = mode !== "combobox" && !open3 && !showSearch ? false : !!inputValue;
  var selectionTitle = title === void 0 ? getTitle(item) : title;
  var placeholderNode = React121.useMemo(function() {
    if (item) {
      return null;
    }
    return /* @__PURE__ */ React121.createElement("span", {
      className: "".concat(prefixCls, "-selection-placeholder"),
      style: hasTextInput ? {
        visibility: "hidden"
      } : void 0
    }, placeholder);
  }, [item, hasTextInput, placeholder, prefixCls]);
  return /* @__PURE__ */ React121.createElement(React121.Fragment, null, /* @__PURE__ */ React121.createElement("span", {
    className: "".concat(prefixCls, "-selection-search")
  }, /* @__PURE__ */ React121.createElement(Input_default, {
    ref: inputRef,
    prefixCls,
    id,
    open: open3,
    inputElement,
    disabled,
    autoFocus,
    autoComplete,
    editable: inputEditable,
    activeDescendantId,
    value: inputValue,
    onKeyDown: onInputKeyDown,
    onMouseDown: onInputMouseDown,
    onChange: function onChange(e) {
      setInputChanged(true);
      onInputChange(e);
    },
    onPaste: onInputPaste,
    onCompositionStart: onInputCompositionStart,
    onCompositionEnd: onInputCompositionEnd,
    tabIndex,
    attrs: pickAttrs(props, true),
    maxLength: combobox ? maxLength : void 0
  })), !combobox && item ? /* @__PURE__ */ React121.createElement("span", {
    className: "".concat(prefixCls, "-selection-item"),
    title: selectionTitle,
    style: hasTextInput ? {
      visibility: "hidden"
    } : void 0
  }, item.label) : null, placeholderNode);
};
var SingleSelector_default = SingleSelector;

// ../../node_modules/rc-select/es/utils/keyUtil.js
function isValidateOpenKey(currentKeyCode) {
  return ![
    // System function button
    KeyCode_default.ESC,
    KeyCode_default.SHIFT,
    KeyCode_default.BACKSPACE,
    KeyCode_default.TAB,
    KeyCode_default.WIN_KEY,
    KeyCode_default.ALT,
    KeyCode_default.META,
    KeyCode_default.WIN_KEY_RIGHT,
    KeyCode_default.CTRL,
    KeyCode_default.SEMICOLON,
    KeyCode_default.EQUALS,
    KeyCode_default.CAPS_LOCK,
    KeyCode_default.CONTEXT_MENU,
    // F1-F12
    KeyCode_default.F1,
    KeyCode_default.F2,
    KeyCode_default.F3,
    KeyCode_default.F4,
    KeyCode_default.F5,
    KeyCode_default.F6,
    KeyCode_default.F7,
    KeyCode_default.F8,
    KeyCode_default.F9,
    KeyCode_default.F10,
    KeyCode_default.F11,
    KeyCode_default.F12
  ].includes(currentKeyCode);
}

// ../../node_modules/rc-select/es/Selector/index.js
var Selector = function Selector2(props, ref) {
  var inputRef = (0, import_react47.useRef)(null);
  var compositionStatusRef = (0, import_react47.useRef)(false);
  var prefixCls = props.prefixCls, open3 = props.open, mode = props.mode, showSearch = props.showSearch, tokenWithEnter = props.tokenWithEnter, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSubmit = props.onSearchSubmit, onToggleOpen = props.onToggleOpen, onInputKeyDown = props.onInputKeyDown, domRef = props.domRef;
  React122.useImperativeHandle(ref, function() {
    return {
      focus: function focus2() {
        inputRef.current.focus();
      },
      blur: function blur2() {
        inputRef.current.blur();
      }
    };
  });
  var _useLock = useLock(0), _useLock2 = _slicedToArray(_useLock, 2), getInputMouseDown = _useLock2[0], setInputMouseDown = _useLock2[1];
  var onInternalInputKeyDown = function onInternalInputKeyDown2(event) {
    var which = event.which;
    if (which === KeyCode_default.UP || which === KeyCode_default.DOWN) {
      event.preventDefault();
    }
    if (onInputKeyDown) {
      onInputKeyDown(event);
    }
    if (which === KeyCode_default.ENTER && mode === "tags" && !compositionStatusRef.current && !open3) {
      onSearchSubmit === null || onSearchSubmit === void 0 || onSearchSubmit(event.target.value);
    }
    if (isValidateOpenKey(which)) {
      onToggleOpen(true);
    }
  };
  var onInternalInputMouseDown = function onInternalInputMouseDown2() {
    setInputMouseDown(true);
  };
  var pastedTextRef = (0, import_react47.useRef)(null);
  var triggerOnSearch = function triggerOnSearch2(value) {
    if (onSearch(value, true, compositionStatusRef.current) !== false) {
      onToggleOpen(true);
    }
  };
  var onInputCompositionStart = function onInputCompositionStart2() {
    compositionStatusRef.current = true;
  };
  var onInputCompositionEnd = function onInputCompositionEnd2(e) {
    compositionStatusRef.current = false;
    if (mode !== "combobox") {
      triggerOnSearch(e.target.value);
    }
  };
  var onInputChange = function onInputChange2(event) {
    var value = event.target.value;
    if (tokenWithEnter && pastedTextRef.current && /[\r\n]/.test(pastedTextRef.current)) {
      var replacedText = pastedTextRef.current.replace(/[\r\n]+$/, "").replace(/\r\n/g, " ").replace(/[\r\n]/g, " ");
      value = value.replace(replacedText, pastedTextRef.current);
    }
    pastedTextRef.current = null;
    triggerOnSearch(value);
  };
  var onInputPaste = function onInputPaste2(e) {
    var clipboardData = e.clipboardData;
    var value = clipboardData === null || clipboardData === void 0 ? void 0 : clipboardData.getData("text");
    pastedTextRef.current = value || "";
  };
  var onClick = function onClick2(_ref) {
    var target = _ref.target;
    if (target !== inputRef.current) {
      var isIE = document.body.style.msTouchAction !== void 0;
      if (isIE) {
        setTimeout(function() {
          inputRef.current.focus();
        });
      } else {
        inputRef.current.focus();
      }
    }
  };
  var onMouseDown = function onMouseDown2(event) {
    var inputMouseDown = getInputMouseDown();
    if (event.target !== inputRef.current && !inputMouseDown && mode !== "combobox") {
      event.preventDefault();
    }
    if (mode !== "combobox" && (!showSearch || !inputMouseDown) || !open3) {
      if (open3 && autoClearSearchValue !== false) {
        onSearch("", true, false);
      }
      onToggleOpen();
    }
  };
  var sharedProps = {
    inputRef,
    onInputKeyDown: onInternalInputKeyDown,
    onInputMouseDown: onInternalInputMouseDown,
    onInputChange,
    onInputPaste,
    onInputCompositionStart,
    onInputCompositionEnd
  };
  var selectNode = mode === "multiple" || mode === "tags" ? /* @__PURE__ */ React122.createElement(MultipleSelector_default, _extends({}, props, sharedProps)) : /* @__PURE__ */ React122.createElement(SingleSelector_default, _extends({}, props, sharedProps));
  return /* @__PURE__ */ React122.createElement("div", {
    ref: domRef,
    className: "".concat(prefixCls, "-selector"),
    onClick,
    onMouseDown
  }, selectNode);
};
var ForwardSelector = /* @__PURE__ */ React122.forwardRef(Selector);
if (process.env.NODE_ENV !== "production") {
  ForwardSelector.displayName = "Selector";
}
var Selector_default = ForwardSelector;

// ../../node_modules/@rc-component/trigger/es/index.js
var import_classnames31 = __toESM(require_classnames());
var React132 = __toESM(require("react"));

// ../../node_modules/@rc-component/trigger/es/Popup/index.js
var import_classnames30 = __toESM(require_classnames());
var React126 = __toESM(require("react"));

// ../../node_modules/@rc-component/trigger/es/Popup/Arrow.js
var import_classnames28 = __toESM(require_classnames());
var React123 = __toESM(require("react"));
function Arrow(props) {
  var prefixCls = props.prefixCls, align = props.align, arrow = props.arrow, arrowPos = props.arrowPos;
  var _ref = arrow || {}, className = _ref.className, content = _ref.content;
  var _arrowPos$x = arrowPos.x, x2 = _arrowPos$x === void 0 ? 0 : _arrowPos$x, _arrowPos$y = arrowPos.y, y2 = _arrowPos$y === void 0 ? 0 : _arrowPos$y;
  var arrowRef = React123.useRef();
  if (!align || !align.points) {
    return null;
  }
  var alignStyle = {
    position: "absolute"
  };
  if (align.autoArrow !== false) {
    var popupPoints = align.points[0];
    var targetPoints = align.points[1];
    var popupTB = popupPoints[0];
    var popupLR = popupPoints[1];
    var targetTB = targetPoints[0];
    var targetLR = targetPoints[1];
    if (popupTB === targetTB || !["t", "b"].includes(popupTB)) {
      alignStyle.top = y2;
    } else if (popupTB === "t") {
      alignStyle.top = 0;
    } else {
      alignStyle.bottom = 0;
    }
    if (popupLR === targetLR || !["l", "r"].includes(popupLR)) {
      alignStyle.left = x2;
    } else if (popupLR === "l") {
      alignStyle.left = 0;
    } else {
      alignStyle.right = 0;
    }
  }
  return /* @__PURE__ */ React123.createElement("div", {
    ref: arrowRef,
    className: (0, import_classnames28.default)("".concat(prefixCls, "-arrow"), className),
    style: alignStyle
  }, content);
}

// ../../node_modules/@rc-component/trigger/es/Popup/Mask.js
var import_classnames29 = __toESM(require_classnames());
var React124 = __toESM(require("react"));
function Mask2(props) {
  var prefixCls = props.prefixCls, open3 = props.open, zIndex = props.zIndex, mask = props.mask, motion = props.motion;
  if (!mask) {
    return null;
  }
  return /* @__PURE__ */ React124.createElement(es_default2, _extends({}, motion, {
    motionAppear: true,
    visible: open3,
    removeOnLeave: true
  }), function(_ref) {
    var className = _ref.className;
    return /* @__PURE__ */ React124.createElement("div", {
      style: {
        zIndex
      },
      className: (0, import_classnames29.default)("".concat(prefixCls, "-mask"), className)
    });
  });
}

// ../../node_modules/@rc-component/trigger/es/Popup/PopupContent.js
var React125 = __toESM(require("react"));
var PopupContent = /* @__PURE__ */ React125.memo(function(_ref) {
  var children = _ref.children;
  return children;
}, function(_, next2) {
  return next2.cache;
});
if (process.env.NODE_ENV !== "production") {
  PopupContent.displayName = "PopupContent";
}
var PopupContent_default = PopupContent;

// ../../node_modules/@rc-component/trigger/es/Popup/index.js
var Popup = /* @__PURE__ */ React126.forwardRef(function(props, ref) {
  var popup = props.popup, className = props.className, prefixCls = props.prefixCls, style2 = props.style, target = props.target, _onVisibleChanged = props.onVisibleChanged, open3 = props.open, keepDom = props.keepDom, fresh = props.fresh, onClick = props.onClick, mask = props.mask, arrow = props.arrow, arrowPos = props.arrowPos, align = props.align, motion = props.motion, maskMotion = props.maskMotion, forceRender = props.forceRender, getPopupContainer = props.getPopupContainer, autoDestroy = props.autoDestroy, Portal2 = props.portal, zIndex = props.zIndex, onMouseEnter = props.onMouseEnter, onMouseLeave = props.onMouseLeave, onPointerEnter = props.onPointerEnter, ready = props.ready, offsetX = props.offsetX, offsetY = props.offsetY, offsetR = props.offsetR, offsetB = props.offsetB, onAlign = props.onAlign, onPrepare = props.onPrepare, stretch = props.stretch, targetWidth = props.targetWidth, targetHeight = props.targetHeight;
  var childNode = typeof popup === "function" ? popup() : popup;
  var isNodeVisible = open3 || keepDom;
  var getPopupContainerNeedParams = (getPopupContainer === null || getPopupContainer === void 0 ? void 0 : getPopupContainer.length) > 0;
  var _React$useState = React126.useState(!getPopupContainer || !getPopupContainerNeedParams), _React$useState2 = _slicedToArray(_React$useState, 2), show = _React$useState2[0], setShow = _React$useState2[1];
  useLayoutEffect_default(function() {
    if (!show && getPopupContainerNeedParams && target) {
      setShow(true);
    }
  }, [show, getPopupContainerNeedParams, target]);
  if (!show) {
    return null;
  }
  var AUTO = "auto";
  var offsetStyle = {
    left: "-1000vw",
    top: "-1000vh",
    right: AUTO,
    bottom: AUTO
  };
  if (ready || !open3) {
    var _experimental;
    var points = align.points;
    var dynamicInset = align.dynamicInset || ((_experimental = align._experimental) === null || _experimental === void 0 ? void 0 : _experimental.dynamicInset);
    var alignRight = dynamicInset && points[0][1] === "r";
    var alignBottom = dynamicInset && points[0][0] === "b";
    if (alignRight) {
      offsetStyle.right = offsetR;
      offsetStyle.left = AUTO;
    } else {
      offsetStyle.left = offsetX;
      offsetStyle.right = AUTO;
    }
    if (alignBottom) {
      offsetStyle.bottom = offsetB;
      offsetStyle.top = AUTO;
    } else {
      offsetStyle.top = offsetY;
      offsetStyle.bottom = AUTO;
    }
  }
  var miscStyle = {};
  if (stretch) {
    if (stretch.includes("height") && targetHeight) {
      miscStyle.height = targetHeight;
    } else if (stretch.includes("minHeight") && targetHeight) {
      miscStyle.minHeight = targetHeight;
    }
    if (stretch.includes("width") && targetWidth) {
      miscStyle.width = targetWidth;
    } else if (stretch.includes("minWidth") && targetWidth) {
      miscStyle.minWidth = targetWidth;
    }
  }
  if (!open3) {
    miscStyle.pointerEvents = "none";
  }
  return /* @__PURE__ */ React126.createElement(Portal2, {
    open: forceRender || isNodeVisible,
    getContainer: getPopupContainer && function() {
      return getPopupContainer(target);
    },
    autoDestroy
  }, /* @__PURE__ */ React126.createElement(Mask2, {
    prefixCls,
    open: open3,
    zIndex,
    mask,
    motion: maskMotion
  }), /* @__PURE__ */ React126.createElement(es_default, {
    onResize: onAlign,
    disabled: !open3
  }, function(resizeObserverRef) {
    return /* @__PURE__ */ React126.createElement(es_default2, _extends({
      motionAppear: true,
      motionEnter: true,
      motionLeave: true,
      removeOnLeave: false,
      forceRender,
      leavedClassName: "".concat(prefixCls, "-hidden")
    }, motion, {
      onAppearPrepare: onPrepare,
      onEnterPrepare: onPrepare,
      visible: open3,
      onVisibleChanged: function onVisibleChanged(nextVisible) {
        var _motion$onVisibleChan;
        motion === null || motion === void 0 || (_motion$onVisibleChan = motion.onVisibleChanged) === null || _motion$onVisibleChan === void 0 || _motion$onVisibleChan.call(motion, nextVisible);
        _onVisibleChanged(nextVisible);
      }
    }), function(_ref, motionRef) {
      var motionClassName = _ref.className, motionStyle = _ref.style;
      var cls = (0, import_classnames30.default)(prefixCls, motionClassName, className);
      return /* @__PURE__ */ React126.createElement("div", {
        ref: composeRef(resizeObserverRef, ref, motionRef),
        className: cls,
        style: _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({
          "--arrow-x": "".concat(arrowPos.x || 0, "px"),
          "--arrow-y": "".concat(arrowPos.y || 0, "px")
        }, offsetStyle), miscStyle), motionStyle), {}, {
          boxSizing: "border-box",
          zIndex
        }, style2),
        onMouseEnter,
        onMouseLeave,
        onPointerEnter,
        onClick
      }, arrow && /* @__PURE__ */ React126.createElement(Arrow, {
        prefixCls,
        arrow,
        arrowPos,
        align
      }), /* @__PURE__ */ React126.createElement(PopupContent_default, {
        cache: !open3 && !fresh
      }, childNode));
    });
  }));
});
if (process.env.NODE_ENV !== "production") {
  Popup.displayName = "Popup";
}
var Popup_default = Popup;

// ../../node_modules/@rc-component/trigger/es/TriggerWrapper.js
var React127 = __toESM(require("react"));
var TriggerWrapper = /* @__PURE__ */ React127.forwardRef(function(props, ref) {
  var children = props.children, getTriggerDOMNode = props.getTriggerDOMNode;
  var canUseRef = supportRef(children);
  var setRef = React127.useCallback(function(node2) {
    fillRef(ref, getTriggerDOMNode ? getTriggerDOMNode(node2) : node2);
  }, [getTriggerDOMNode]);
  var mergedRef = useComposeRef(setRef, children.ref);
  return canUseRef ? /* @__PURE__ */ React127.cloneElement(children, {
    ref: mergedRef
  }) : children;
});
if (process.env.NODE_ENV !== "production") {
  TriggerWrapper.displayName = "TriggerWrapper";
}
var TriggerWrapper_default = TriggerWrapper;

// ../../node_modules/@rc-component/trigger/es/context.js
var React128 = __toESM(require("react"));
var TriggerContext = /* @__PURE__ */ React128.createContext(null);
var context_default2 = TriggerContext;

// ../../node_modules/@rc-component/trigger/es/hooks/useAction.js
var React129 = __toESM(require("react"));
function toArray4(val) {
  return val ? Array.isArray(val) ? val : [val] : [];
}
function useAction(mobile, action, showAction, hideAction) {
  return React129.useMemo(function() {
    var mergedShowAction = toArray4(showAction !== null && showAction !== void 0 ? showAction : action);
    var mergedHideAction = toArray4(hideAction !== null && hideAction !== void 0 ? hideAction : action);
    var showActionSet = new Set(mergedShowAction);
    var hideActionSet = new Set(mergedHideAction);
    if (mobile) {
      if (showActionSet.has("hover")) {
        showActionSet.delete("hover");
        showActionSet.add("click");
      }
      if (hideActionSet.has("hover")) {
        hideActionSet.delete("hover");
        hideActionSet.add("click");
      }
    }
    return [showActionSet, hideActionSet];
  }, [mobile, action, showAction, hideAction]);
}

// ../../node_modules/@rc-component/trigger/es/hooks/useAlign.js
var React130 = __toESM(require("react"));

// ../../node_modules/@rc-component/trigger/es/util.js
function isPointsEq() {
  var a1 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
  var a2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
  var isAlignPoint = arguments.length > 2 ? arguments[2] : void 0;
  if (isAlignPoint) {
    return a1[0] === a2[0];
  }
  return a1[0] === a2[0] && a1[1] === a2[1];
}
function getAlignPopupClassName(builtinPlacements, prefixCls, align, isAlignPoint) {
  var points = align.points;
  var placements2 = Object.keys(builtinPlacements);
  for (var i = 0; i < placements2.length; i += 1) {
    var _builtinPlacements$pl;
    var placement = placements2[i];
    if (isPointsEq((_builtinPlacements$pl = builtinPlacements[placement]) === null || _builtinPlacements$pl === void 0 ? void 0 : _builtinPlacements$pl.points, points, isAlignPoint)) {
      return "".concat(prefixCls, "-placement-").concat(placement);
    }
  }
  return "";
}
function getMotion3(prefixCls, motion, animation, transitionName) {
  if (motion) {
    return motion;
  }
  if (animation) {
    return {
      motionName: "".concat(prefixCls, "-").concat(animation)
    };
  }
  if (transitionName) {
    return {
      motionName: transitionName
    };
  }
  return null;
}
function getWin(ele) {
  return ele.ownerDocument.defaultView;
}
function collectScroller(ele) {
  var scrollerList = [];
  var current = ele === null || ele === void 0 ? void 0 : ele.parentElement;
  var scrollStyle = ["hidden", "scroll", "clip", "auto"];
  while (current) {
    var _getWin$getComputedSt = getWin(current).getComputedStyle(current), overflowX = _getWin$getComputedSt.overflowX, overflowY = _getWin$getComputedSt.overflowY, overflow = _getWin$getComputedSt.overflow;
    if ([overflowX, overflowY, overflow].some(function(o) {
      return scrollStyle.includes(o);
    })) {
      scrollerList.push(current);
    }
    current = current.parentElement;
  }
  return scrollerList;
}
function toNum(num) {
  var defaultValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
  return Number.isNaN(num) ? defaultValue : num;
}
function getPxValue(val) {
  return toNum(parseFloat(val), 0);
}
function getVisibleArea(initArea, scrollerList) {
  var visibleArea = _objectSpread2({}, initArea);
  (scrollerList || []).forEach(function(ele) {
    if (ele instanceof HTMLBodyElement || ele instanceof HTMLHtmlElement) {
      return;
    }
    var _getWin$getComputedSt2 = getWin(ele).getComputedStyle(ele), overflow = _getWin$getComputedSt2.overflow, overflowClipMargin = _getWin$getComputedSt2.overflowClipMargin, borderTopWidth = _getWin$getComputedSt2.borderTopWidth, borderBottomWidth = _getWin$getComputedSt2.borderBottomWidth, borderLeftWidth = _getWin$getComputedSt2.borderLeftWidth, borderRightWidth = _getWin$getComputedSt2.borderRightWidth;
    var eleRect = ele.getBoundingClientRect();
    var eleOutHeight = ele.offsetHeight, eleInnerHeight = ele.clientHeight, eleOutWidth = ele.offsetWidth, eleInnerWidth = ele.clientWidth;
    var borderTopNum = getPxValue(borderTopWidth);
    var borderBottomNum = getPxValue(borderBottomWidth);
    var borderLeftNum = getPxValue(borderLeftWidth);
    var borderRightNum = getPxValue(borderRightWidth);
    var scaleX = toNum(Math.round(eleRect.width / eleOutWidth * 1e3) / 1e3);
    var scaleY = toNum(Math.round(eleRect.height / eleOutHeight * 1e3) / 1e3);
    var eleScrollWidth = (eleOutWidth - eleInnerWidth - borderLeftNum - borderRightNum) * scaleX;
    var eleScrollHeight = (eleOutHeight - eleInnerHeight - borderTopNum - borderBottomNum) * scaleY;
    var scaledBorderTopWidth = borderTopNum * scaleY;
    var scaledBorderBottomWidth = borderBottomNum * scaleY;
    var scaledBorderLeftWidth = borderLeftNum * scaleX;
    var scaledBorderRightWidth = borderRightNum * scaleX;
    var clipMarginWidth = 0;
    var clipMarginHeight = 0;
    if (overflow === "clip") {
      var clipNum = getPxValue(overflowClipMargin);
      clipMarginWidth = clipNum * scaleX;
      clipMarginHeight = clipNum * scaleY;
    }
    var eleLeft = eleRect.x + scaledBorderLeftWidth - clipMarginWidth;
    var eleTop = eleRect.y + scaledBorderTopWidth - clipMarginHeight;
    var eleRight = eleLeft + eleRect.width + 2 * clipMarginWidth - scaledBorderLeftWidth - scaledBorderRightWidth - eleScrollWidth;
    var eleBottom = eleTop + eleRect.height + 2 * clipMarginHeight - scaledBorderTopWidth - scaledBorderBottomWidth - eleScrollHeight;
    visibleArea.left = Math.max(visibleArea.left, eleLeft);
    visibleArea.top = Math.max(visibleArea.top, eleTop);
    visibleArea.right = Math.min(visibleArea.right, eleRight);
    visibleArea.bottom = Math.min(visibleArea.bottom, eleBottom);
  });
  return visibleArea;
}

// ../../node_modules/@rc-component/trigger/es/hooks/useAlign.js
function getUnitOffset(size) {
  var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var offsetStr = "".concat(offset2);
  var cells = offsetStr.match(/^(.*)\%$/);
  if (cells) {
    return size * (parseFloat(cells[1]) / 100);
  }
  return parseFloat(offsetStr);
}
function getNumberOffset(rect, offset2) {
  var _ref = offset2 || [], _ref2 = _slicedToArray(_ref, 2), offsetX = _ref2[0], offsetY = _ref2[1];
  return [getUnitOffset(rect.width, offsetX), getUnitOffset(rect.height, offsetY)];
}
function splitPoints() {
  var points = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
  return [points[0], points[1]];
}
function getAlignPoint(rect, points) {
  var topBottom = points[0];
  var leftRight = points[1];
  var x2;
  var y2;
  if (topBottom === "t") {
    y2 = rect.y;
  } else if (topBottom === "b") {
    y2 = rect.y + rect.height;
  } else {
    y2 = rect.y + rect.height / 2;
  }
  if (leftRight === "l") {
    x2 = rect.x;
  } else if (leftRight === "r") {
    x2 = rect.x + rect.width;
  } else {
    x2 = rect.x + rect.width / 2;
  }
  return {
    x: x2,
    y: y2
  };
}
function reversePoints(points, index2) {
  var reverseMap = {
    t: "b",
    b: "t",
    l: "r",
    r: "l"
  };
  return points.map(function(point2, i) {
    if (i === index2) {
      return reverseMap[point2] || "c";
    }
    return point2;
  }).join("");
}
function useAlign(open3, popupEle, target, placement, builtinPlacements, popupAlign, onPopupAlign) {
  var _React$useState = React130.useState({
    ready: false,
    offsetX: 0,
    offsetY: 0,
    offsetR: 0,
    offsetB: 0,
    arrowX: 0,
    arrowY: 0,
    scaleX: 1,
    scaleY: 1,
    align: builtinPlacements[placement] || {}
  }), _React$useState2 = _slicedToArray(_React$useState, 2), offsetInfo = _React$useState2[0], setOffsetInfo = _React$useState2[1];
  var alignCountRef = React130.useRef(0);
  var scrollerList = React130.useMemo(function() {
    if (!popupEle) {
      return [];
    }
    return collectScroller(popupEle);
  }, [popupEle]);
  var prevFlipRef = React130.useRef({});
  var resetFlipCache = function resetFlipCache2() {
    prevFlipRef.current = {};
  };
  if (!open3) {
    resetFlipCache();
  }
  var onAlign = useEvent(function() {
    if (popupEle && target && open3) {
      let getIntersectionVisibleArea2 = function(offsetX, offsetY) {
        var area = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : visibleArea;
        var l = popupRect.x + offsetX;
        var t = popupRect.y + offsetY;
        var r = l + popupWidth;
        var b = t + popupHeight;
        var visibleL = Math.max(l, area.left);
        var visibleT = Math.max(t, area.top);
        var visibleR = Math.min(r, area.right);
        var visibleB = Math.min(b, area.bottom);
        return Math.max(0, (visibleR - visibleL) * (visibleB - visibleT));
      }, syncNextPopupPosition2 = function() {
        nextPopupY = popupRect.y + nextOffsetY;
        nextPopupBottom = nextPopupY + popupHeight;
        nextPopupX = popupRect.x + nextOffsetX;
        nextPopupRight = nextPopupX + popupWidth;
      };
      var getIntersectionVisibleArea = getIntersectionVisibleArea2, syncNextPopupPosition = syncNextPopupPosition2;
      var _popupElement$parentE, _popupElement$parentE2;
      var popupElement = popupEle;
      var doc = popupElement.ownerDocument;
      var win = getWin(popupElement);
      var _win$getComputedStyle = win.getComputedStyle(popupElement), width = _win$getComputedStyle.width, height = _win$getComputedStyle.height, popupPosition = _win$getComputedStyle.position;
      var originLeft = popupElement.style.left;
      var originTop = popupElement.style.top;
      var originRight = popupElement.style.right;
      var originBottom = popupElement.style.bottom;
      var originOverflow = popupElement.style.overflow;
      var placementInfo = _objectSpread2(_objectSpread2({}, builtinPlacements[placement]), popupAlign);
      var placeholderElement = doc.createElement("div");
      (_popupElement$parentE = popupElement.parentElement) === null || _popupElement$parentE === void 0 || _popupElement$parentE.appendChild(placeholderElement);
      placeholderElement.style.left = "".concat(popupElement.offsetLeft, "px");
      placeholderElement.style.top = "".concat(popupElement.offsetTop, "px");
      placeholderElement.style.position = popupPosition;
      placeholderElement.style.height = "".concat(popupElement.offsetHeight, "px");
      placeholderElement.style.width = "".concat(popupElement.offsetWidth, "px");
      popupElement.style.left = "0";
      popupElement.style.top = "0";
      popupElement.style.right = "auto";
      popupElement.style.bottom = "auto";
      popupElement.style.overflow = "hidden";
      var targetRect;
      if (Array.isArray(target)) {
        targetRect = {
          x: target[0],
          y: target[1],
          width: 0,
          height: 0
        };
      } else {
        var rect = target.getBoundingClientRect();
        targetRect = {
          x: rect.x,
          y: rect.y,
          width: rect.width,
          height: rect.height
        };
      }
      var popupRect = popupElement.getBoundingClientRect();
      var _doc$documentElement = doc.documentElement, clientWidth = _doc$documentElement.clientWidth, clientHeight = _doc$documentElement.clientHeight, scrollWidth = _doc$documentElement.scrollWidth, scrollHeight = _doc$documentElement.scrollHeight, scrollTop = _doc$documentElement.scrollTop, scrollLeft = _doc$documentElement.scrollLeft;
      var popupHeight = popupRect.height;
      var popupWidth = popupRect.width;
      var targetHeight = targetRect.height;
      var targetWidth = targetRect.width;
      var visibleRegion = {
        left: 0,
        top: 0,
        right: clientWidth,
        bottom: clientHeight
      };
      var scrollRegion = {
        left: -scrollLeft,
        top: -scrollTop,
        right: scrollWidth - scrollLeft,
        bottom: scrollHeight - scrollTop
      };
      var htmlRegion = placementInfo.htmlRegion;
      var VISIBLE = "visible";
      var VISIBLE_FIRST = "visibleFirst";
      if (htmlRegion !== "scroll" && htmlRegion !== VISIBLE_FIRST) {
        htmlRegion = VISIBLE;
      }
      var isVisibleFirst = htmlRegion === VISIBLE_FIRST;
      var scrollRegionArea = getVisibleArea(scrollRegion, scrollerList);
      var visibleRegionArea = getVisibleArea(visibleRegion, scrollerList);
      var visibleArea = htmlRegion === VISIBLE ? visibleRegionArea : scrollRegionArea;
      var adjustCheckVisibleArea = isVisibleFirst ? visibleRegionArea : visibleArea;
      popupElement.style.left = "auto";
      popupElement.style.top = "auto";
      popupElement.style.right = "0";
      popupElement.style.bottom = "0";
      var popupMirrorRect = popupElement.getBoundingClientRect();
      popupElement.style.left = originLeft;
      popupElement.style.top = originTop;
      popupElement.style.right = originRight;
      popupElement.style.bottom = originBottom;
      popupElement.style.overflow = originOverflow;
      (_popupElement$parentE2 = popupElement.parentElement) === null || _popupElement$parentE2 === void 0 || _popupElement$parentE2.removeChild(placeholderElement);
      var _scaleX = toNum(Math.round(popupWidth / parseFloat(width) * 1e3) / 1e3);
      var _scaleY = toNum(Math.round(popupHeight / parseFloat(height) * 1e3) / 1e3);
      if (_scaleX === 0 || _scaleY === 0 || isDOM(target) && !isVisible_default(target)) {
        return;
      }
      var offset2 = placementInfo.offset, targetOffset2 = placementInfo.targetOffset;
      var _getNumberOffset = getNumberOffset(popupRect, offset2), _getNumberOffset2 = _slicedToArray(_getNumberOffset, 2), popupOffsetX = _getNumberOffset2[0], popupOffsetY = _getNumberOffset2[1];
      var _getNumberOffset3 = getNumberOffset(targetRect, targetOffset2), _getNumberOffset4 = _slicedToArray(_getNumberOffset3, 2), targetOffsetX = _getNumberOffset4[0], targetOffsetY = _getNumberOffset4[1];
      targetRect.x -= targetOffsetX;
      targetRect.y -= targetOffsetY;
      var _ref3 = placementInfo.points || [], _ref4 = _slicedToArray(_ref3, 2), popupPoint = _ref4[0], targetPoint = _ref4[1];
      var targetPoints = splitPoints(targetPoint);
      var popupPoints = splitPoints(popupPoint);
      var targetAlignPoint = getAlignPoint(targetRect, targetPoints);
      var popupAlignPoint = getAlignPoint(popupRect, popupPoints);
      var nextAlignInfo = _objectSpread2({}, placementInfo);
      var nextOffsetX = targetAlignPoint.x - popupAlignPoint.x + popupOffsetX;
      var nextOffsetY = targetAlignPoint.y - popupAlignPoint.y + popupOffsetY;
      var originIntersectionVisibleArea = getIntersectionVisibleArea2(nextOffsetX, nextOffsetY);
      var originIntersectionRecommendArea = getIntersectionVisibleArea2(nextOffsetX, nextOffsetY, visibleRegionArea);
      var targetAlignPointTL = getAlignPoint(targetRect, ["t", "l"]);
      var popupAlignPointTL = getAlignPoint(popupRect, ["t", "l"]);
      var targetAlignPointBR = getAlignPoint(targetRect, ["b", "r"]);
      var popupAlignPointBR = getAlignPoint(popupRect, ["b", "r"]);
      var overflow = placementInfo.overflow || {};
      var adjustX = overflow.adjustX, adjustY = overflow.adjustY, shiftX = overflow.shiftX, shiftY = overflow.shiftY;
      var supportAdjust = function supportAdjust2(val) {
        if (typeof val === "boolean") {
          return val;
        }
        return val >= 0;
      };
      var nextPopupY;
      var nextPopupBottom;
      var nextPopupX;
      var nextPopupRight;
      syncNextPopupPosition2();
      var needAdjustY = supportAdjust(adjustY);
      var sameTB = popupPoints[0] === targetPoints[0];
      if (needAdjustY && popupPoints[0] === "t" && (nextPopupBottom > adjustCheckVisibleArea.bottom || prevFlipRef.current.bt)) {
        var tmpNextOffsetY = nextOffsetY;
        if (sameTB) {
          tmpNextOffsetY -= popupHeight - targetHeight;
        } else {
          tmpNextOffsetY = targetAlignPointTL.y - popupAlignPointBR.y - popupOffsetY;
        }
        var newVisibleArea = getIntersectionVisibleArea2(nextOffsetX, tmpNextOffsetY);
        var newVisibleRecommendArea = getIntersectionVisibleArea2(nextOffsetX, tmpNextOffsetY, visibleRegionArea);
        if (
          // Of course use larger one
          newVisibleArea > originIntersectionVisibleArea || newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
          newVisibleRecommendArea >= originIntersectionRecommendArea)
        ) {
          prevFlipRef.current.bt = true;
          nextOffsetY = tmpNextOffsetY;
          popupOffsetY = -popupOffsetY;
          nextAlignInfo.points = [reversePoints(popupPoints, 0), reversePoints(targetPoints, 0)];
        } else {
          prevFlipRef.current.bt = false;
        }
      }
      if (needAdjustY && popupPoints[0] === "b" && (nextPopupY < adjustCheckVisibleArea.top || prevFlipRef.current.tb)) {
        var _tmpNextOffsetY = nextOffsetY;
        if (sameTB) {
          _tmpNextOffsetY += popupHeight - targetHeight;
        } else {
          _tmpNextOffsetY = targetAlignPointBR.y - popupAlignPointTL.y - popupOffsetY;
        }
        var _newVisibleArea = getIntersectionVisibleArea2(nextOffsetX, _tmpNextOffsetY);
        var _newVisibleRecommendArea = getIntersectionVisibleArea2(nextOffsetX, _tmpNextOffsetY, visibleRegionArea);
        if (
          // Of course use larger one
          _newVisibleArea > originIntersectionVisibleArea || _newVisibleArea === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
          _newVisibleRecommendArea >= originIntersectionRecommendArea)
        ) {
          prevFlipRef.current.tb = true;
          nextOffsetY = _tmpNextOffsetY;
          popupOffsetY = -popupOffsetY;
          nextAlignInfo.points = [reversePoints(popupPoints, 0), reversePoints(targetPoints, 0)];
        } else {
          prevFlipRef.current.tb = false;
        }
      }
      var needAdjustX = supportAdjust(adjustX);
      var sameLR = popupPoints[1] === targetPoints[1];
      if (needAdjustX && popupPoints[1] === "l" && (nextPopupRight > adjustCheckVisibleArea.right || prevFlipRef.current.rl)) {
        var tmpNextOffsetX = nextOffsetX;
        if (sameLR) {
          tmpNextOffsetX -= popupWidth - targetWidth;
        } else {
          tmpNextOffsetX = targetAlignPointTL.x - popupAlignPointBR.x - popupOffsetX;
        }
        var _newVisibleArea2 = getIntersectionVisibleArea2(tmpNextOffsetX, nextOffsetY);
        var _newVisibleRecommendArea2 = getIntersectionVisibleArea2(tmpNextOffsetX, nextOffsetY, visibleRegionArea);
        if (
          // Of course use larger one
          _newVisibleArea2 > originIntersectionVisibleArea || _newVisibleArea2 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
          _newVisibleRecommendArea2 >= originIntersectionRecommendArea)
        ) {
          prevFlipRef.current.rl = true;
          nextOffsetX = tmpNextOffsetX;
          popupOffsetX = -popupOffsetX;
          nextAlignInfo.points = [reversePoints(popupPoints, 1), reversePoints(targetPoints, 1)];
        } else {
          prevFlipRef.current.rl = false;
        }
      }
      if (needAdjustX && popupPoints[1] === "r" && (nextPopupX < adjustCheckVisibleArea.left || prevFlipRef.current.lr)) {
        var _tmpNextOffsetX = nextOffsetX;
        if (sameLR) {
          _tmpNextOffsetX += popupWidth - targetWidth;
        } else {
          _tmpNextOffsetX = targetAlignPointBR.x - popupAlignPointTL.x - popupOffsetX;
        }
        var _newVisibleArea3 = getIntersectionVisibleArea2(_tmpNextOffsetX, nextOffsetY);
        var _newVisibleRecommendArea3 = getIntersectionVisibleArea2(_tmpNextOffsetX, nextOffsetY, visibleRegionArea);
        if (
          // Of course use larger one
          _newVisibleArea3 > originIntersectionVisibleArea || _newVisibleArea3 === originIntersectionVisibleArea && (!isVisibleFirst || // Choose recommend one
          _newVisibleRecommendArea3 >= originIntersectionRecommendArea)
        ) {
          prevFlipRef.current.lr = true;
          nextOffsetX = _tmpNextOffsetX;
          popupOffsetX = -popupOffsetX;
          nextAlignInfo.points = [reversePoints(popupPoints, 1), reversePoints(targetPoints, 1)];
        } else {
          prevFlipRef.current.lr = false;
        }
      }
      syncNextPopupPosition2();
      var numShiftX = shiftX === true ? 0 : shiftX;
      if (typeof numShiftX === "number") {
        if (nextPopupX < visibleRegionArea.left) {
          nextOffsetX -= nextPopupX - visibleRegionArea.left - popupOffsetX;
          if (targetRect.x + targetWidth < visibleRegionArea.left + numShiftX) {
            nextOffsetX += targetRect.x - visibleRegionArea.left + targetWidth - numShiftX;
          }
        }
        if (nextPopupRight > visibleRegionArea.right) {
          nextOffsetX -= nextPopupRight - visibleRegionArea.right - popupOffsetX;
          if (targetRect.x > visibleRegionArea.right - numShiftX) {
            nextOffsetX += targetRect.x - visibleRegionArea.right + numShiftX;
          }
        }
      }
      var numShiftY = shiftY === true ? 0 : shiftY;
      if (typeof numShiftY === "number") {
        if (nextPopupY < visibleRegionArea.top) {
          nextOffsetY -= nextPopupY - visibleRegionArea.top - popupOffsetY;
          if (targetRect.y + targetHeight < visibleRegionArea.top + numShiftY) {
            nextOffsetY += targetRect.y - visibleRegionArea.top + targetHeight - numShiftY;
          }
        }
        if (nextPopupBottom > visibleRegionArea.bottom) {
          nextOffsetY -= nextPopupBottom - visibleRegionArea.bottom - popupOffsetY;
          if (targetRect.y > visibleRegionArea.bottom - numShiftY) {
            nextOffsetY += targetRect.y - visibleRegionArea.bottom + numShiftY;
          }
        }
      }
      var popupLeft = popupRect.x + nextOffsetX;
      var popupRight = popupLeft + popupWidth;
      var popupTop = popupRect.y + nextOffsetY;
      var popupBottom = popupTop + popupHeight;
      var targetLeft = targetRect.x;
      var targetRight = targetLeft + targetWidth;
      var targetTop = targetRect.y;
      var targetBottom = targetTop + targetHeight;
      var maxLeft = Math.max(popupLeft, targetLeft);
      var minRight = Math.min(popupRight, targetRight);
      var xCenter = (maxLeft + minRight) / 2;
      var nextArrowX = xCenter - popupLeft;
      var maxTop = Math.max(popupTop, targetTop);
      var minBottom = Math.min(popupBottom, targetBottom);
      var yCenter = (maxTop + minBottom) / 2;
      var nextArrowY = yCenter - popupTop;
      onPopupAlign === null || onPopupAlign === void 0 || onPopupAlign(popupEle, nextAlignInfo);
      var offsetX4Right = popupMirrorRect.right - popupRect.x - (nextOffsetX + popupRect.width);
      var offsetY4Bottom = popupMirrorRect.bottom - popupRect.y - (nextOffsetY + popupRect.height);
      setOffsetInfo({
        ready: true,
        offsetX: nextOffsetX / _scaleX,
        offsetY: nextOffsetY / _scaleY,
        offsetR: offsetX4Right / _scaleX,
        offsetB: offsetY4Bottom / _scaleY,
        arrowX: nextArrowX / _scaleX,
        arrowY: nextArrowY / _scaleY,
        scaleX: _scaleX,
        scaleY: _scaleY,
        align: nextAlignInfo
      });
    }
  });
  var triggerAlign = function triggerAlign2() {
    alignCountRef.current += 1;
    var id = alignCountRef.current;
    Promise.resolve().then(function() {
      if (alignCountRef.current === id) {
        onAlign();
      }
    });
  };
  var resetReady = function resetReady2() {
    setOffsetInfo(function(ori) {
      return _objectSpread2(_objectSpread2({}, ori), {}, {
        ready: false
      });
    });
  };
  useLayoutEffect_default(resetReady, [placement]);
  useLayoutEffect_default(function() {
    if (!open3) {
      resetReady();
    }
  }, [open3]);
  return [offsetInfo.ready, offsetInfo.offsetX, offsetInfo.offsetY, offsetInfo.offsetR, offsetInfo.offsetB, offsetInfo.arrowX, offsetInfo.arrowY, offsetInfo.scaleX, offsetInfo.scaleY, offsetInfo.align, triggerAlign];
}

// ../../node_modules/@rc-component/trigger/es/hooks/useWatch.js
function useWatch2(open3, target, popup, onAlign, onScroll) {
  useLayoutEffect_default(function() {
    if (open3 && target && popup) {
      let notifyScroll2 = function() {
        onAlign();
        onScroll();
      };
      var notifyScroll = notifyScroll2;
      var targetElement = target;
      var popupElement = popup;
      var targetScrollList = collectScroller(targetElement);
      var popupScrollList = collectScroller(popupElement);
      var win = getWin(popupElement);
      var mergedList = new Set([win].concat(_toConsumableArray(targetScrollList), _toConsumableArray(popupScrollList)));
      mergedList.forEach(function(scroller) {
        scroller.addEventListener("scroll", notifyScroll2, {
          passive: true
        });
      });
      win.addEventListener("resize", notifyScroll2, {
        passive: true
      });
      onAlign();
      return function() {
        mergedList.forEach(function(scroller) {
          scroller.removeEventListener("scroll", notifyScroll2);
          win.removeEventListener("resize", notifyScroll2);
        });
      };
    }
  }, [open3, target, popup]);
}

// ../../node_modules/@rc-component/trigger/es/hooks/useWinClick.js
var React131 = __toESM(require("react"));
function useWinClick(open3, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen) {
  var openRef = React131.useRef(open3);
  var lockRef = React131.useRef(false);
  if (openRef.current !== open3) {
    lockRef.current = true;
    openRef.current = open3;
  }
  React131.useEffect(function() {
    var id = raf_default(function() {
      lockRef.current = false;
    });
    return function() {
      raf_default.cancel(id);
    };
  }, [open3]);
  React131.useEffect(function() {
    if (clickToHide && popupEle && (!mask || maskClosable)) {
      var genClickEvents = function genClickEvents2() {
        var clickInside = false;
        var onWindowMouseDown = function onWindowMouseDown2(_ref) {
          var target = _ref.target;
          clickInside = inPopupOrChild(target);
        };
        var onWindowClick = function onWindowClick2(_ref2) {
          var target = _ref2.target;
          if (!lockRef.current && openRef.current && !clickInside && !inPopupOrChild(target)) {
            triggerOpen(false);
          }
        };
        return [onWindowMouseDown, onWindowClick];
      };
      var _genClickEvents = genClickEvents(), _genClickEvents2 = _slicedToArray(_genClickEvents, 2), onWinMouseDown = _genClickEvents2[0], onWinClick = _genClickEvents2[1];
      var _genClickEvents3 = genClickEvents(), _genClickEvents4 = _slicedToArray(_genClickEvents3, 2), onShadowMouseDown = _genClickEvents4[0], onShadowClick = _genClickEvents4[1];
      var win = getWin(popupEle);
      win.addEventListener("mousedown", onWinMouseDown, true);
      win.addEventListener("click", onWinClick, true);
      win.addEventListener("contextmenu", onWinClick, true);
      var targetShadowRoot = getShadowRoot(targetEle);
      if (targetShadowRoot) {
        targetShadowRoot.addEventListener("mousedown", onShadowMouseDown, true);
        targetShadowRoot.addEventListener("click", onShadowClick, true);
        targetShadowRoot.addEventListener("contextmenu", onShadowClick, true);
      }
      if (process.env.NODE_ENV !== "production") {
        var _targetEle$getRootNod, _popupEle$getRootNode;
        var targetRoot = targetEle === null || targetEle === void 0 || (_targetEle$getRootNod = targetEle.getRootNode) === null || _targetEle$getRootNod === void 0 ? void 0 : _targetEle$getRootNod.call(targetEle);
        var popupRoot = (_popupEle$getRootNode = popupEle.getRootNode) === null || _popupEle$getRootNode === void 0 ? void 0 : _popupEle$getRootNode.call(popupEle);
        warning(targetRoot === popupRoot, "trigger element and popup element should in same shadow root.");
      }
      return function() {
        win.removeEventListener("mousedown", onWinMouseDown, true);
        win.removeEventListener("click", onWinClick, true);
        win.removeEventListener("contextmenu", onWinClick, true);
        if (targetShadowRoot) {
          targetShadowRoot.removeEventListener("mousedown", onShadowMouseDown, true);
          targetShadowRoot.removeEventListener("click", onShadowClick, true);
          targetShadowRoot.removeEventListener("contextmenu", onShadowClick, true);
        }
      };
    }
  }, [clickToHide, targetEle, popupEle, mask, maskClosable]);
}

// ../../node_modules/@rc-component/trigger/es/index.js
var _excluded13 = ["prefixCls", "children", "action", "showAction", "hideAction", "popupVisible", "defaultPopupVisible", "onPopupVisibleChange", "afterPopupVisibleChange", "mouseEnterDelay", "mouseLeaveDelay", "focusDelay", "blurDelay", "mask", "maskClosable", "getPopupContainer", "forceRender", "autoDestroy", "destroyPopupOnHide", "popup", "popupClassName", "popupStyle", "popupPlacement", "builtinPlacements", "popupAlign", "zIndex", "stretch", "getPopupClassNameFromAlign", "fresh", "alignPoint", "onPopupClick", "onPopupAlign", "arrow", "popupMotion", "maskMotion", "popupTransitionName", "popupAnimation", "maskTransitionName", "maskAnimation", "className", "getTriggerDOMNode"];
function generateTrigger() {
  var PortalComponent = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : es_default3;
  var Trigger = /* @__PURE__ */ React132.forwardRef(function(props, ref) {
    var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-trigger-popup" : _props$prefixCls, children = props.children, _props$action = props.action, action = _props$action === void 0 ? "hover" : _props$action, showAction = props.showAction, hideAction = props.hideAction, popupVisible = props.popupVisible, defaultPopupVisible = props.defaultPopupVisible, onPopupVisibleChange = props.onPopupVisibleChange, afterPopupVisibleChange = props.afterPopupVisibleChange, mouseEnterDelay = props.mouseEnterDelay, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, focusDelay = props.focusDelay, blurDelay = props.blurDelay, mask = props.mask, _props$maskClosable = props.maskClosable, maskClosable = _props$maskClosable === void 0 ? true : _props$maskClosable, getPopupContainer = props.getPopupContainer, forceRender = props.forceRender, autoDestroy = props.autoDestroy, destroyPopupOnHide = props.destroyPopupOnHide, popup = props.popup, popupClassName = props.popupClassName, popupStyle = props.popupStyle, popupPlacement = props.popupPlacement, _props$builtinPlaceme = props.builtinPlacements, builtinPlacements = _props$builtinPlaceme === void 0 ? {} : _props$builtinPlaceme, popupAlign = props.popupAlign, zIndex = props.zIndex, stretch = props.stretch, getPopupClassNameFromAlign = props.getPopupClassNameFromAlign, fresh = props.fresh, alignPoint = props.alignPoint, onPopupClick = props.onPopupClick, onPopupAlign = props.onPopupAlign, arrow = props.arrow, popupMotion = props.popupMotion, maskMotion = props.maskMotion, popupTransitionName = props.popupTransitionName, popupAnimation = props.popupAnimation, maskTransitionName = props.maskTransitionName, maskAnimation = props.maskAnimation, className = props.className, getTriggerDOMNode = props.getTriggerDOMNode, restProps = _objectWithoutProperties(props, _excluded13);
    var mergedAutoDestroy = autoDestroy || destroyPopupOnHide || false;
    var _React$useState = React132.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
    useLayoutEffect_default(function() {
      setMobile(isMobile_default());
    }, []);
    var subPopupElements = React132.useRef({});
    var parentContext = React132.useContext(context_default2);
    var context = React132.useMemo(function() {
      return {
        registerSubPopup: function registerSubPopup(id2, subPopupEle) {
          subPopupElements.current[id2] = subPopupEle;
          parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id2, subPopupEle);
        }
      };
    }, [parentContext]);
    var id = useId_default();
    var _React$useState3 = React132.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), popupEle = _React$useState4[0], setPopupEle = _React$useState4[1];
    var setPopupRef = useEvent(function(node2) {
      if (isDOM(node2) && popupEle !== node2) {
        setPopupEle(node2);
      }
      parentContext === null || parentContext === void 0 || parentContext.registerSubPopup(id, node2);
    });
    var _React$useState5 = React132.useState(null), _React$useState6 = _slicedToArray(_React$useState5, 2), targetEle = _React$useState6[0], setTargetEle = _React$useState6[1];
    var externalForwardRef = React132.useRef(null);
    var setTargetRef = useEvent(function(node2) {
      if (isDOM(node2) && targetEle !== node2) {
        setTargetEle(node2);
        externalForwardRef.current = node2;
      }
    });
    var child = React132.Children.only(children);
    var originChildProps = (child === null || child === void 0 ? void 0 : child.props) || {};
    var cloneProps = {};
    var inPopupOrChild = useEvent(function(ele) {
      var _getShadowRoot, _getShadowRoot2;
      var childDOM = targetEle;
      return (childDOM === null || childDOM === void 0 ? void 0 : childDOM.contains(ele)) || ((_getShadowRoot = getShadowRoot(childDOM)) === null || _getShadowRoot === void 0 ? void 0 : _getShadowRoot.host) === ele || ele === childDOM || (popupEle === null || popupEle === void 0 ? void 0 : popupEle.contains(ele)) || ((_getShadowRoot2 = getShadowRoot(popupEle)) === null || _getShadowRoot2 === void 0 ? void 0 : _getShadowRoot2.host) === ele || ele === popupEle || Object.values(subPopupElements.current).some(function(subPopupEle) {
        return (subPopupEle === null || subPopupEle === void 0 ? void 0 : subPopupEle.contains(ele)) || ele === subPopupEle;
      });
    });
    var mergePopupMotion = getMotion3(prefixCls, popupMotion, popupAnimation, popupTransitionName);
    var mergeMaskMotion = getMotion3(prefixCls, maskMotion, maskAnimation, maskTransitionName);
    var _React$useState7 = React132.useState(defaultPopupVisible || false), _React$useState8 = _slicedToArray(_React$useState7, 2), internalOpen = _React$useState8[0], setInternalOpen = _React$useState8[1];
    var mergedOpen = popupVisible !== null && popupVisible !== void 0 ? popupVisible : internalOpen;
    var setMergedOpen = useEvent(function(nextOpen) {
      if (popupVisible === void 0) {
        setInternalOpen(nextOpen);
      }
    });
    useLayoutEffect_default(function() {
      setInternalOpen(popupVisible || false);
    }, [popupVisible]);
    var openRef = React132.useRef(mergedOpen);
    openRef.current = mergedOpen;
    var lastTriggerRef = React132.useRef([]);
    lastTriggerRef.current = [];
    var internalTriggerOpen = useEvent(function(nextOpen) {
      var _lastTriggerRef$curre;
      setMergedOpen(nextOpen);
      if (((_lastTriggerRef$curre = lastTriggerRef.current[lastTriggerRef.current.length - 1]) !== null && _lastTriggerRef$curre !== void 0 ? _lastTriggerRef$curre : mergedOpen) !== nextOpen) {
        lastTriggerRef.current.push(nextOpen);
        onPopupVisibleChange === null || onPopupVisibleChange === void 0 || onPopupVisibleChange(nextOpen);
      }
    });
    var delayRef = React132.useRef();
    var clearDelay = function clearDelay2() {
      clearTimeout(delayRef.current);
    };
    var triggerOpen = function triggerOpen2(nextOpen) {
      var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      clearDelay();
      if (delay === 0) {
        internalTriggerOpen(nextOpen);
      } else {
        delayRef.current = setTimeout(function() {
          internalTriggerOpen(nextOpen);
        }, delay * 1e3);
      }
    };
    React132.useEffect(function() {
      return clearDelay;
    }, []);
    var _React$useState9 = React132.useState(false), _React$useState10 = _slicedToArray(_React$useState9, 2), inMotion = _React$useState10[0], setInMotion = _React$useState10[1];
    useLayoutEffect_default(function(firstMount) {
      if (!firstMount || mergedOpen) {
        setInMotion(true);
      }
    }, [mergedOpen]);
    var _React$useState11 = React132.useState(null), _React$useState12 = _slicedToArray(_React$useState11, 2), motionPrepareResolve = _React$useState12[0], setMotionPrepareResolve = _React$useState12[1];
    var _React$useState13 = React132.useState([0, 0]), _React$useState14 = _slicedToArray(_React$useState13, 2), mousePos = _React$useState14[0], setMousePos = _React$useState14[1];
    var setMousePosByEvent = function setMousePosByEvent2(event) {
      setMousePos([event.clientX, event.clientY]);
    };
    var _useAlign = useAlign(mergedOpen, popupEle, alignPoint ? mousePos : targetEle, popupPlacement, builtinPlacements, popupAlign, onPopupAlign), _useAlign2 = _slicedToArray(_useAlign, 11), ready = _useAlign2[0], offsetX = _useAlign2[1], offsetY = _useAlign2[2], offsetR = _useAlign2[3], offsetB = _useAlign2[4], arrowX = _useAlign2[5], arrowY = _useAlign2[6], scaleX = _useAlign2[7], scaleY = _useAlign2[8], alignInfo = _useAlign2[9], onAlign = _useAlign2[10];
    var _useAction = useAction(mobile, action, showAction, hideAction), _useAction2 = _slicedToArray(_useAction, 2), showActions = _useAction2[0], hideActions = _useAction2[1];
    var clickToShow = showActions.has("click");
    var clickToHide = hideActions.has("click") || hideActions.has("contextMenu");
    var triggerAlign = useEvent(function() {
      if (!inMotion) {
        onAlign();
      }
    });
    var onScroll = function onScroll2() {
      if (openRef.current && alignPoint && clickToHide) {
        triggerOpen(false);
      }
    };
    useWatch2(mergedOpen, targetEle, popupEle, triggerAlign, onScroll);
    useLayoutEffect_default(function() {
      triggerAlign();
    }, [mousePos, popupPlacement]);
    useLayoutEffect_default(function() {
      if (mergedOpen && !(builtinPlacements !== null && builtinPlacements !== void 0 && builtinPlacements[popupPlacement])) {
        triggerAlign();
      }
    }, [JSON.stringify(popupAlign)]);
    var alignedClassName = React132.useMemo(function() {
      var baseClassName = getAlignPopupClassName(builtinPlacements, prefixCls, alignInfo, alignPoint);
      return (0, import_classnames31.default)(baseClassName, getPopupClassNameFromAlign === null || getPopupClassNameFromAlign === void 0 ? void 0 : getPopupClassNameFromAlign(alignInfo));
    }, [alignInfo, getPopupClassNameFromAlign, builtinPlacements, prefixCls, alignPoint]);
    React132.useImperativeHandle(ref, function() {
      return {
        nativeElement: externalForwardRef.current,
        forceAlign: triggerAlign
      };
    });
    var _React$useState15 = React132.useState(0), _React$useState16 = _slicedToArray(_React$useState15, 2), targetWidth = _React$useState16[0], setTargetWidth = _React$useState16[1];
    var _React$useState17 = React132.useState(0), _React$useState18 = _slicedToArray(_React$useState17, 2), targetHeight = _React$useState18[0], setTargetHeight = _React$useState18[1];
    var syncTargetSize = function syncTargetSize2() {
      if (stretch && targetEle) {
        var rect = targetEle.getBoundingClientRect();
        setTargetWidth(rect.width);
        setTargetHeight(rect.height);
      }
    };
    var onTargetResize = function onTargetResize2() {
      syncTargetSize();
      triggerAlign();
    };
    var onVisibleChanged = function onVisibleChanged2(visible) {
      setInMotion(false);
      onAlign();
      afterPopupVisibleChange === null || afterPopupVisibleChange === void 0 || afterPopupVisibleChange(visible);
    };
    var onPrepare = function onPrepare2() {
      return new Promise(function(resolve) {
        syncTargetSize();
        setMotionPrepareResolve(function() {
          return resolve;
        });
      });
    };
    useLayoutEffect_default(function() {
      if (motionPrepareResolve) {
        onAlign();
        motionPrepareResolve();
        setMotionPrepareResolve(null);
      }
    }, [motionPrepareResolve]);
    function wrapperAction(eventName, nextOpen, delay, preEvent) {
      cloneProps[eventName] = function(event) {
        var _originChildProps$eve;
        preEvent === null || preEvent === void 0 || preEvent(event);
        triggerOpen(nextOpen, delay);
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        (_originChildProps$eve = originChildProps[eventName]) === null || _originChildProps$eve === void 0 || _originChildProps$eve.call.apply(_originChildProps$eve, [originChildProps, event].concat(args));
      };
    }
    if (clickToShow || clickToHide) {
      cloneProps.onClick = function(event) {
        var _originChildProps$onC;
        if (openRef.current && clickToHide) {
          triggerOpen(false);
        } else if (!openRef.current && clickToShow) {
          setMousePosByEvent(event);
          triggerOpen(true);
        }
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        (_originChildProps$onC = originChildProps.onClick) === null || _originChildProps$onC === void 0 || _originChildProps$onC.call.apply(_originChildProps$onC, [originChildProps, event].concat(args));
      };
    }
    useWinClick(mergedOpen, clickToHide, targetEle, popupEle, mask, maskClosable, inPopupOrChild, triggerOpen);
    var hoverToShow = showActions.has("hover");
    var hoverToHide = hideActions.has("hover");
    var onPopupMouseEnter;
    var onPopupMouseLeave;
    if (hoverToShow) {
      wrapperAction("onMouseEnter", true, mouseEnterDelay, function(event) {
        setMousePosByEvent(event);
      });
      wrapperAction("onPointerEnter", true, mouseEnterDelay, function(event) {
        setMousePosByEvent(event);
      });
      onPopupMouseEnter = function onPopupMouseEnter2() {
        if (mergedOpen || inMotion) {
          triggerOpen(true, mouseEnterDelay);
        }
      };
      if (alignPoint) {
        cloneProps.onMouseMove = function(event) {
          var _originChildProps$onM;
          (_originChildProps$onM = originChildProps.onMouseMove) === null || _originChildProps$onM === void 0 || _originChildProps$onM.call(originChildProps, event);
        };
      }
    }
    if (hoverToHide) {
      wrapperAction("onMouseLeave", false, mouseLeaveDelay);
      wrapperAction("onPointerLeave", false, mouseLeaveDelay);
      onPopupMouseLeave = function onPopupMouseLeave2() {
        triggerOpen(false, mouseLeaveDelay);
      };
    }
    if (showActions.has("focus")) {
      wrapperAction("onFocus", true, focusDelay);
    }
    if (hideActions.has("focus")) {
      wrapperAction("onBlur", false, blurDelay);
    }
    if (showActions.has("contextMenu")) {
      cloneProps.onContextMenu = function(event) {
        var _originChildProps$onC2;
        if (openRef.current && hideActions.has("contextMenu")) {
          triggerOpen(false);
        } else {
          setMousePosByEvent(event);
          triggerOpen(true);
        }
        event.preventDefault();
        for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }
        (_originChildProps$onC2 = originChildProps.onContextMenu) === null || _originChildProps$onC2 === void 0 || _originChildProps$onC2.call.apply(_originChildProps$onC2, [originChildProps, event].concat(args));
      };
    }
    if (className) {
      cloneProps.className = (0, import_classnames31.default)(originChildProps.className, className);
    }
    var mergedChildrenProps = _objectSpread2(_objectSpread2({}, originChildProps), cloneProps);
    var passedProps = {};
    var passedEventList = ["onContextMenu", "onClick", "onMouseDown", "onTouchStart", "onMouseEnter", "onMouseLeave", "onFocus", "onBlur"];
    passedEventList.forEach(function(eventName) {
      if (restProps[eventName]) {
        passedProps[eventName] = function() {
          var _mergedChildrenProps$;
          for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
            args[_key4] = arguments[_key4];
          }
          (_mergedChildrenProps$ = mergedChildrenProps[eventName]) === null || _mergedChildrenProps$ === void 0 || _mergedChildrenProps$.call.apply(_mergedChildrenProps$, [mergedChildrenProps].concat(args));
          restProps[eventName].apply(restProps, args);
        };
      }
    });
    var triggerNode = /* @__PURE__ */ React132.cloneElement(child, _objectSpread2(_objectSpread2({}, mergedChildrenProps), passedProps));
    var arrowPos = {
      x: arrowX,
      y: arrowY
    };
    var innerArrow = arrow ? _objectSpread2({}, arrow !== true ? arrow : {}) : null;
    return /* @__PURE__ */ React132.createElement(React132.Fragment, null, /* @__PURE__ */ React132.createElement(es_default, {
      disabled: !mergedOpen,
      ref: setTargetRef,
      onResize: onTargetResize
    }, /* @__PURE__ */ React132.createElement(TriggerWrapper_default, {
      getTriggerDOMNode
    }, triggerNode)), /* @__PURE__ */ React132.createElement(context_default2.Provider, {
      value: context
    }, /* @__PURE__ */ React132.createElement(Popup_default, {
      portal: PortalComponent,
      ref: setPopupRef,
      prefixCls,
      popup,
      className: (0, import_classnames31.default)(popupClassName, alignedClassName),
      style: popupStyle,
      target: targetEle,
      onMouseEnter: onPopupMouseEnter,
      onMouseLeave: onPopupMouseLeave,
      onPointerEnter: onPopupMouseEnter,
      zIndex,
      open: mergedOpen,
      keepDom: inMotion,
      fresh,
      onClick: onPopupClick,
      mask,
      motion: mergePopupMotion,
      maskMotion: mergeMaskMotion,
      onVisibleChanged,
      onPrepare,
      forceRender,
      autoDestroy: mergedAutoDestroy,
      getPopupContainer,
      align: alignInfo,
      arrow: innerArrow,
      arrowPos,
      ready,
      offsetX,
      offsetY,
      offsetR,
      offsetB,
      onAlign: triggerAlign,
      stretch,
      targetWidth: targetWidth / scaleX,
      targetHeight: targetHeight / scaleY
    })));
  });
  if (process.env.NODE_ENV !== "production") {
    Trigger.displayName = "Trigger";
  }
  return Trigger;
}
var es_default6 = generateTrigger(es_default3);

// ../../node_modules/rc-select/es/SelectTrigger.js
var import_classnames32 = __toESM(require_classnames());
var React133 = __toESM(require("react"));
var _excluded14 = ["prefixCls", "disabled", "visible", "children", "popupElement", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "direction", "placement", "builtinPlacements", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "getPopupContainer", "empty", "getTriggerDOMNode", "onPopupVisibleChange", "onPopupMouseEnter"];
var getBuiltInPlacements = function getBuiltInPlacements2(dropdownMatchSelectWidth) {
  var adjustX = dropdownMatchSelectWidth === true ? 0 : 1;
  return {
    bottomLeft: {
      points: ["tl", "bl"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    bottomRight: {
      points: ["tr", "br"],
      offset: [0, 4],
      overflow: {
        adjustX,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topLeft: {
      points: ["bl", "tl"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      },
      htmlRegion: "scroll"
    },
    topRight: {
      points: ["br", "tr"],
      offset: [0, -4],
      overflow: {
        adjustX,
        adjustY: 1
      },
      htmlRegion: "scroll"
    }
  };
};
var SelectTrigger = function SelectTrigger2(props, ref) {
  var prefixCls = props.prefixCls, disabled = props.disabled, visible = props.visible, children = props.children, popupElement = props.popupElement, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, _props$direction = props.direction, direction = _props$direction === void 0 ? "ltr" : _props$direction, placement = props.placement, builtinPlacements = props.builtinPlacements, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, getPopupContainer = props.getPopupContainer, empty = props.empty, getTriggerDOMNode = props.getTriggerDOMNode, onPopupVisibleChange = props.onPopupVisibleChange, onPopupMouseEnter = props.onPopupMouseEnter, restProps = _objectWithoutProperties(props, _excluded14);
  var dropdownPrefixCls = "".concat(prefixCls, "-dropdown");
  var popupNode = popupElement;
  if (dropdownRender) {
    popupNode = dropdownRender(popupElement);
  }
  var mergedBuiltinPlacements2 = React133.useMemo(function() {
    return builtinPlacements || getBuiltInPlacements(dropdownMatchSelectWidth);
  }, [builtinPlacements, dropdownMatchSelectWidth]);
  var mergedTransitionName = animation ? "".concat(dropdownPrefixCls, "-").concat(animation) : transitionName;
  var isNumberPopupWidth = typeof dropdownMatchSelectWidth === "number";
  var stretch = React133.useMemo(function() {
    if (isNumberPopupWidth) {
      return null;
    }
    return dropdownMatchSelectWidth === false ? "minWidth" : "width";
  }, [dropdownMatchSelectWidth, isNumberPopupWidth]);
  var popupStyle = dropdownStyle;
  if (isNumberPopupWidth) {
    popupStyle = _objectSpread2(_objectSpread2({}, popupStyle), {}, {
      width: dropdownMatchSelectWidth
    });
  }
  var popupRef = React133.useRef(null);
  React133.useImperativeHandle(ref, function() {
    return {
      getPopupElement: function getPopupElement() {
        return popupRef.current;
      }
    };
  });
  return /* @__PURE__ */ React133.createElement(es_default6, _extends({}, restProps, {
    showAction: onPopupVisibleChange ? ["click"] : [],
    hideAction: onPopupVisibleChange ? ["click"] : [],
    popupPlacement: placement || (direction === "rtl" ? "bottomRight" : "bottomLeft"),
    builtinPlacements: mergedBuiltinPlacements2,
    prefixCls: dropdownPrefixCls,
    popupTransitionName: mergedTransitionName,
    popup: /* @__PURE__ */ React133.createElement("div", {
      ref: popupRef,
      onMouseEnter: onPopupMouseEnter
    }, popupNode),
    stretch,
    popupAlign: dropdownAlign,
    popupVisible: visible,
    getPopupContainer,
    popupClassName: (0, import_classnames32.default)(dropdownClassName, _defineProperty({}, "".concat(dropdownPrefixCls, "-empty"), empty)),
    popupStyle,
    getTriggerDOMNode,
    onPopupVisibleChange
  }), children);
};
var RefSelectTrigger = /* @__PURE__ */ React133.forwardRef(SelectTrigger);
if (process.env.NODE_ENV !== "production") {
  RefSelectTrigger.displayName = "SelectTrigger";
}
var SelectTrigger_default = RefSelectTrigger;

// ../../node_modules/rc-select/es/utils/valueUtil.js
function getKey(data, index2) {
  var key = data.key;
  var value;
  if ("value" in data) {
    value = data.value;
  }
  if (key !== null && key !== void 0) {
    return key;
  }
  if (value !== void 0) {
    return value;
  }
  return "rc-index-key-".concat(index2);
}
function fillFieldNames(fieldNames, childrenAsData) {
  var _ref = fieldNames || {}, label = _ref.label, value = _ref.value, options = _ref.options, groupLabel = _ref.groupLabel;
  var mergedLabel = label || (childrenAsData ? "children" : "label");
  return {
    label: mergedLabel,
    value: value || "value",
    options: options || "options",
    groupLabel: groupLabel || mergedLabel
  };
}
function flattenOptions(options) {
  var _ref2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, fieldNames = _ref2.fieldNames, childrenAsData = _ref2.childrenAsData;
  var flattenList = [];
  var _fillFieldNames = fillFieldNames(fieldNames, false), fieldLabel = _fillFieldNames.label, fieldValue = _fillFieldNames.value, fieldOptions = _fillFieldNames.options, groupLabel = _fillFieldNames.groupLabel;
  function dig(list, isGroupOption) {
    if (!Array.isArray(list)) {
      return;
    }
    list.forEach(function(data) {
      if (isGroupOption || !(fieldOptions in data)) {
        var value = data[fieldValue];
        flattenList.push({
          key: getKey(data, flattenList.length),
          groupOption: isGroupOption,
          data,
          label: data[fieldLabel],
          value
        });
      } else {
        var grpLabel = data[groupLabel];
        if (grpLabel === void 0 && childrenAsData) {
          grpLabel = data.label;
        }
        flattenList.push({
          key: getKey(data, flattenList.length),
          group: true,
          data,
          label: grpLabel
        });
        dig(data[fieldOptions], true);
      }
    });
  }
  dig(options, false);
  return flattenList;
}
function injectPropsWithOption(option) {
  var newOption = _objectSpread2({}, option);
  if (!("props" in newOption)) {
    Object.defineProperty(newOption, "props", {
      get: function get2() {
        warning_default(false, "Return type is option instead of Option instance. Please read value directly instead of reading from `props`.");
        return newOption;
      }
    });
  }
  return newOption;
}
var getSeparatedContent = function getSeparatedContent2(text, tokens, end) {
  if (!tokens || !tokens.length) {
    return null;
  }
  var match2 = false;
  var separate = function separate2(str, _ref3) {
    var _ref4 = _toArray(_ref3), token2 = _ref4[0], restTokens = _ref4.slice(1);
    if (!token2) {
      return [str];
    }
    var list2 = str.split(token2);
    match2 = match2 || list2.length > 1;
    return list2.reduce(function(prevList, unitStr) {
      return [].concat(_toConsumableArray(prevList), _toConsumableArray(separate2(unitStr, restTokens)));
    }, []).filter(Boolean);
  };
  var list = separate(text, tokens);
  if (match2) {
    return typeof end !== "undefined" ? list.slice(0, end) : list;
  } else {
    return null;
  }
};

// ../../node_modules/rc-select/es/SelectContext.js
var React134 = __toESM(require("react"));
var SelectContext = /* @__PURE__ */ React134.createContext(null);
var SelectContext_default = SelectContext;

// ../../node_modules/rc-select/es/BaseSelect.js
var _excluded15 = ["id", "prefixCls", "className", "showSearch", "tagRender", "direction", "omitDomProps", "displayValues", "onDisplayValuesChange", "emptyOptions", "notFoundContent", "onClear", "mode", "disabled", "loading", "getInputElement", "getRawInputElement", "open", "defaultOpen", "onDropdownVisibleChange", "activeValue", "onActiveValueChange", "activeDescendantId", "searchValue", "autoClearSearchValue", "onSearch", "onSearchSplit", "tokenSeparators", "allowClear", "suffixIcon", "clearIcon", "OptionList", "animation", "transitionName", "dropdownStyle", "dropdownClassName", "dropdownMatchSelectWidth", "dropdownRender", "dropdownAlign", "placement", "builtinPlacements", "getPopupContainer", "showAction", "onFocus", "onBlur", "onKeyUp", "onKeyDown", "onMouseDown"];
var DEFAULT_OMIT_PROPS = ["value", "onChange", "removeIcon", "placeholder", "autoFocus", "maxTagCount", "maxTagTextLength", "maxTagPlaceholder", "choiceTransitionName", "onInputKeyDown", "onPopupScroll", "tabIndex"];
var isMultiple = function isMultiple2(mode) {
  return mode === "tags" || mode === "multiple";
};
var BaseSelect = /* @__PURE__ */ React135.forwardRef(function(props, ref) {
  var _customizeRawInputEle, _classNames2;
  var id = props.id, prefixCls = props.prefixCls, className = props.className, showSearch = props.showSearch, tagRender = props.tagRender, direction = props.direction, omitDomProps = props.omitDomProps, displayValues = props.displayValues, onDisplayValuesChange = props.onDisplayValuesChange, emptyOptions = props.emptyOptions, _props$notFoundConten = props.notFoundContent, notFoundContent = _props$notFoundConten === void 0 ? "Not Found" : _props$notFoundConten, onClear = props.onClear, mode = props.mode, disabled = props.disabled, loading = props.loading, getInputElement = props.getInputElement, getRawInputElement = props.getRawInputElement, open3 = props.open, defaultOpen = props.defaultOpen, onDropdownVisibleChange = props.onDropdownVisibleChange, activeValue = props.activeValue, onActiveValueChange = props.onActiveValueChange, activeDescendantId = props.activeDescendantId, searchValue = props.searchValue, autoClearSearchValue = props.autoClearSearchValue, onSearch = props.onSearch, onSearchSplit = props.onSearchSplit, tokenSeparators = props.tokenSeparators, allowClear = props.allowClear, suffixIcon = props.suffixIcon, clearIcon = props.clearIcon, OptionList3 = props.OptionList, animation = props.animation, transitionName = props.transitionName, dropdownStyle = props.dropdownStyle, dropdownClassName = props.dropdownClassName, dropdownMatchSelectWidth = props.dropdownMatchSelectWidth, dropdownRender = props.dropdownRender, dropdownAlign = props.dropdownAlign, placement = props.placement, builtinPlacements = props.builtinPlacements, getPopupContainer = props.getPopupContainer, _props$showAction = props.showAction, showAction = _props$showAction === void 0 ? [] : _props$showAction, onFocus = props.onFocus, onBlur = props.onBlur, onKeyUp = props.onKeyUp, onKeyDown = props.onKeyDown, onMouseDown = props.onMouseDown, restProps = _objectWithoutProperties(props, _excluded15);
  var multiple = isMultiple(mode);
  var mergedShowSearch = (showSearch !== void 0 ? showSearch : multiple) || mode === "combobox";
  var domProps = _objectSpread2({}, restProps);
  DEFAULT_OMIT_PROPS.forEach(function(propName) {
    delete domProps[propName];
  });
  omitDomProps === null || omitDomProps === void 0 || omitDomProps.forEach(function(propName) {
    delete domProps[propName];
  });
  var _React$useState = React135.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), mobile = _React$useState2[0], setMobile = _React$useState2[1];
  React135.useEffect(function() {
    setMobile(isMobile_default());
  }, []);
  var containerRef = React135.useRef(null);
  var selectorDomRef = React135.useRef(null);
  var triggerRef = React135.useRef(null);
  var selectorRef = React135.useRef(null);
  var listRef = React135.useRef(null);
  var blurRef = React135.useRef(false);
  var _useDelayReset = useDelayReset(), _useDelayReset2 = _slicedToArray(_useDelayReset, 3), mockFocused = _useDelayReset2[0], setMockFocused = _useDelayReset2[1], cancelSetMockFocused = _useDelayReset2[2];
  React135.useImperativeHandle(ref, function() {
    var _selectorRef$current, _selectorRef$current2;
    return {
      focus: (_selectorRef$current = selectorRef.current) === null || _selectorRef$current === void 0 ? void 0 : _selectorRef$current.focus,
      blur: (_selectorRef$current2 = selectorRef.current) === null || _selectorRef$current2 === void 0 ? void 0 : _selectorRef$current2.blur,
      scrollTo: function scrollTo(arg) {
        var _listRef$current;
        return (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollTo(arg);
      }
    };
  });
  var mergedSearchValue = React135.useMemo(function() {
    var _displayValues$;
    if (mode !== "combobox") {
      return searchValue;
    }
    var val = (_displayValues$ = displayValues[0]) === null || _displayValues$ === void 0 ? void 0 : _displayValues$.value;
    return typeof val === "string" || typeof val === "number" ? String(val) : "";
  }, [searchValue, mode, displayValues]);
  var customizeInputElement = mode === "combobox" && typeof getInputElement === "function" && getInputElement() || null;
  var customizeRawInputElement = typeof getRawInputElement === "function" && getRawInputElement();
  var customizeRawInputRef = useComposeRef(selectorDomRef, customizeRawInputElement === null || customizeRawInputElement === void 0 || (_customizeRawInputEle = customizeRawInputElement.props) === null || _customizeRawInputEle === void 0 ? void 0 : _customizeRawInputEle.ref);
  var _React$useState3 = React135.useState(false), _React$useState4 = _slicedToArray(_React$useState3, 2), rendered = _React$useState4[0], setRendered = _React$useState4[1];
  useLayoutEffect_default(function() {
    setRendered(true);
  }, []);
  var _useMergedState = useMergedState(false, {
    defaultValue: defaultOpen,
    value: open3
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), innerOpen = _useMergedState2[0], setInnerOpen = _useMergedState2[1];
  var mergedOpen = rendered ? innerOpen : false;
  var emptyListContent = !notFoundContent && emptyOptions;
  if (disabled || emptyListContent && mergedOpen && mode === "combobox") {
    mergedOpen = false;
  }
  var triggerOpen = emptyListContent ? false : mergedOpen;
  var onToggleOpen = React135.useCallback(function(newOpen) {
    var nextOpen = newOpen !== void 0 ? newOpen : !mergedOpen;
    if (!disabled) {
      setInnerOpen(nextOpen);
      if (mergedOpen !== nextOpen) {
        onDropdownVisibleChange === null || onDropdownVisibleChange === void 0 || onDropdownVisibleChange(nextOpen);
      }
    }
  }, [disabled, mergedOpen, setInnerOpen, onDropdownVisibleChange]);
  var tokenWithEnter = React135.useMemo(function() {
    return (tokenSeparators || []).some(function(tokenSeparator) {
      return ["\n", "\r\n"].includes(tokenSeparator);
    });
  }, [tokenSeparators]);
  var _ref = React135.useContext(SelectContext_default) || {}, maxCount = _ref.maxCount, rawValues = _ref.rawValues;
  var onInternalSearch = function onInternalSearch2(searchText, fromTyping, isCompositing) {
    if ((rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount) {
      return;
    }
    var ret = true;
    var newSearchText = searchText;
    onActiveValueChange === null || onActiveValueChange === void 0 || onActiveValueChange(null);
    var separatedList = getSeparatedContent(searchText, tokenSeparators, maxCount && maxCount - rawValues.size);
    var patchLabels = isCompositing ? null : separatedList;
    if (mode !== "combobox" && patchLabels) {
      newSearchText = "";
      onSearchSplit === null || onSearchSplit === void 0 || onSearchSplit(patchLabels);
      onToggleOpen(false);
      ret = false;
    }
    if (onSearch && mergedSearchValue !== newSearchText) {
      onSearch(newSearchText, {
        source: fromTyping ? "typing" : "effect"
      });
    }
    return ret;
  };
  var onInternalSearchSubmit = function onInternalSearchSubmit2(searchText) {
    if (!searchText || !searchText.trim()) {
      return;
    }
    onSearch(searchText, {
      source: "submit"
    });
  };
  React135.useEffect(function() {
    if (!mergedOpen && !multiple && mode !== "combobox") {
      onInternalSearch("", false, false);
    }
  }, [mergedOpen]);
  React135.useEffect(function() {
    if (innerOpen && disabled) {
      setInnerOpen(false);
    }
    if (disabled && !blurRef.current) {
      setMockFocused(false);
    }
  }, [disabled]);
  var _useLock = useLock(), _useLock2 = _slicedToArray(_useLock, 2), getClearLock = _useLock2[0], setClearLock = _useLock2[1];
  var onInternalKeyDown = function onInternalKeyDown2(event) {
    var clearLock = getClearLock();
    var which = event.which;
    if (which === KeyCode_default.ENTER) {
      if (mode !== "combobox") {
        event.preventDefault();
      }
      if (!mergedOpen) {
        onToggleOpen(true);
      }
    }
    setClearLock(!!mergedSearchValue);
    if (which === KeyCode_default.BACKSPACE && !clearLock && multiple && !mergedSearchValue && displayValues.length) {
      var cloneDisplayValues = _toConsumableArray(displayValues);
      var removedDisplayValue = null;
      for (var i = cloneDisplayValues.length - 1; i >= 0; i -= 1) {
        var current = cloneDisplayValues[i];
        if (!current.disabled) {
          cloneDisplayValues.splice(i, 1);
          removedDisplayValue = current;
          break;
        }
      }
      if (removedDisplayValue) {
        onDisplayValuesChange(cloneDisplayValues, {
          type: "remove",
          values: [removedDisplayValue]
        });
      }
    }
    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }
    if (mergedOpen) {
      var _listRef$current2;
      (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.onKeyDown.apply(_listRef$current2, [event].concat(rest));
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown.apply(void 0, [event].concat(rest));
  };
  var onInternalKeyUp = function onInternalKeyUp2(event) {
    for (var _len2 = arguments.length, rest = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      rest[_key2 - 1] = arguments[_key2];
    }
    if (mergedOpen) {
      var _listRef$current3;
      (_listRef$current3 = listRef.current) === null || _listRef$current3 === void 0 || _listRef$current3.onKeyUp.apply(_listRef$current3, [event].concat(rest));
    }
    onKeyUp === null || onKeyUp === void 0 || onKeyUp.apply(void 0, [event].concat(rest));
  };
  var onSelectorRemove = function onSelectorRemove2(val) {
    var newValues = displayValues.filter(function(i) {
      return i !== val;
    });
    onDisplayValuesChange(newValues, {
      type: "remove",
      values: [val]
    });
  };
  var focusRef = React135.useRef(false);
  var onContainerFocus = function onContainerFocus2() {
    setMockFocused(true);
    if (!disabled) {
      if (onFocus && !focusRef.current) {
        onFocus.apply(void 0, arguments);
      }
      if (showAction.includes("focus")) {
        onToggleOpen(true);
      }
    }
    focusRef.current = true;
  };
  var onContainerBlur = function onContainerBlur2() {
    blurRef.current = true;
    setMockFocused(false, function() {
      focusRef.current = false;
      blurRef.current = false;
      onToggleOpen(false);
    });
    if (disabled) {
      return;
    }
    if (mergedSearchValue) {
      if (mode === "tags") {
        onSearch(mergedSearchValue, {
          source: "submit"
        });
      } else if (mode === "multiple") {
        onSearch("", {
          source: "blur"
        });
      }
    }
    if (onBlur) {
      onBlur.apply(void 0, arguments);
    }
  };
  var activeTimeoutIds = [];
  React135.useEffect(function() {
    return function() {
      activeTimeoutIds.forEach(function(timeoutId) {
        return clearTimeout(timeoutId);
      });
      activeTimeoutIds.splice(0, activeTimeoutIds.length);
    };
  }, []);
  var onInternalMouseDown = function onInternalMouseDown2(event) {
    var _triggerRef$current;
    var target = event.target;
    var popupElement = (_triggerRef$current = triggerRef.current) === null || _triggerRef$current === void 0 ? void 0 : _triggerRef$current.getPopupElement();
    if (popupElement && popupElement.contains(target)) {
      var timeoutId = setTimeout(function() {
        var index2 = activeTimeoutIds.indexOf(timeoutId);
        if (index2 !== -1) {
          activeTimeoutIds.splice(index2, 1);
        }
        cancelSetMockFocused();
        if (!mobile && !popupElement.contains(document.activeElement)) {
          var _selectorRef$current3;
          (_selectorRef$current3 = selectorRef.current) === null || _selectorRef$current3 === void 0 || _selectorRef$current3.focus();
        }
      });
      activeTimeoutIds.push(timeoutId);
    }
    for (var _len3 = arguments.length, restArgs = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
      restArgs[_key3 - 1] = arguments[_key3];
    }
    onMouseDown === null || onMouseDown === void 0 || onMouseDown.apply(void 0, [event].concat(restArgs));
  };
  var _React$useState5 = React135.useState({}), _React$useState6 = _slicedToArray(_React$useState5, 2), forceUpdate = _React$useState6[1];
  function onPopupMouseEnter() {
    forceUpdate({});
  }
  var onTriggerVisibleChange;
  if (customizeRawInputElement) {
    onTriggerVisibleChange = function onTriggerVisibleChange2(newOpen) {
      onToggleOpen(newOpen);
    };
  }
  useSelectTriggerControl(function() {
    var _triggerRef$current2;
    return [containerRef.current, (_triggerRef$current2 = triggerRef.current) === null || _triggerRef$current2 === void 0 ? void 0 : _triggerRef$current2.getPopupElement()];
  }, triggerOpen, onToggleOpen, !!customizeRawInputElement);
  var baseSelectContext = React135.useMemo(function() {
    return _objectSpread2(_objectSpread2({}, props), {}, {
      notFoundContent,
      open: mergedOpen,
      triggerOpen,
      id,
      showSearch: mergedShowSearch,
      multiple,
      toggleOpen: onToggleOpen
    });
  }, [props, notFoundContent, triggerOpen, mergedOpen, id, mergedShowSearch, multiple, onToggleOpen]);
  var showSuffixIcon = !!suffixIcon || loading;
  var arrowNode;
  if (showSuffixIcon) {
    arrowNode = /* @__PURE__ */ React135.createElement(TransBtn_default, {
      className: (0, import_classnames33.default)("".concat(prefixCls, "-arrow"), _defineProperty({}, "".concat(prefixCls, "-arrow-loading"), loading)),
      customizeIcon: suffixIcon,
      customizeIconProps: {
        loading,
        searchValue: mergedSearchValue,
        open: mergedOpen,
        focused: mockFocused,
        showSearch: mergedShowSearch
      }
    });
  }
  var onClearMouseDown = function onClearMouseDown2() {
    var _selectorRef$current4;
    onClear === null || onClear === void 0 || onClear();
    (_selectorRef$current4 = selectorRef.current) === null || _selectorRef$current4 === void 0 || _selectorRef$current4.focus();
    onDisplayValuesChange([], {
      type: "clear",
      values: displayValues
    });
    onInternalSearch("", false, false);
  };
  var _useAllowClear = useAllowClear(prefixCls, onClearMouseDown, displayValues, allowClear, clearIcon, disabled, mergedSearchValue, mode), mergedAllowClear = _useAllowClear.allowClear, clearNode = _useAllowClear.clearIcon;
  var optionList = /* @__PURE__ */ React135.createElement(OptionList3, {
    ref: listRef
  });
  var mergedClassName = (0, import_classnames33.default)(prefixCls, className, (_classNames2 = {}, _defineProperty(_classNames2, "".concat(prefixCls, "-focused"), mockFocused), _defineProperty(_classNames2, "".concat(prefixCls, "-multiple"), multiple), _defineProperty(_classNames2, "".concat(prefixCls, "-single"), !multiple), _defineProperty(_classNames2, "".concat(prefixCls, "-allow-clear"), allowClear), _defineProperty(_classNames2, "".concat(prefixCls, "-show-arrow"), showSuffixIcon), _defineProperty(_classNames2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_classNames2, "".concat(prefixCls, "-loading"), loading), _defineProperty(_classNames2, "".concat(prefixCls, "-open"), mergedOpen), _defineProperty(_classNames2, "".concat(prefixCls, "-customize-input"), customizeInputElement), _defineProperty(_classNames2, "".concat(prefixCls, "-show-search"), mergedShowSearch), _classNames2));
  var selectorNode = /* @__PURE__ */ React135.createElement(SelectTrigger_default, {
    ref: triggerRef,
    disabled,
    prefixCls,
    visible: triggerOpen,
    popupElement: optionList,
    animation,
    transitionName,
    dropdownStyle,
    dropdownClassName,
    direction,
    dropdownMatchSelectWidth,
    dropdownRender,
    dropdownAlign,
    placement,
    builtinPlacements,
    getPopupContainer,
    empty: emptyOptions,
    getTriggerDOMNode: function getTriggerDOMNode() {
      return selectorDomRef.current;
    },
    onPopupVisibleChange: onTriggerVisibleChange,
    onPopupMouseEnter
  }, customizeRawInputElement ? /* @__PURE__ */ React135.cloneElement(customizeRawInputElement, {
    ref: customizeRawInputRef
  }) : /* @__PURE__ */ React135.createElement(Selector_default, _extends({}, props, {
    domRef: selectorDomRef,
    prefixCls,
    inputElement: customizeInputElement,
    ref: selectorRef,
    id,
    showSearch: mergedShowSearch,
    autoClearSearchValue,
    mode,
    activeDescendantId,
    tagRender,
    values: displayValues,
    open: mergedOpen,
    onToggleOpen,
    activeValue,
    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    onSearchSubmit: onInternalSearchSubmit,
    onRemove: onSelectorRemove,
    tokenWithEnter
  })));
  var renderNode;
  if (customizeRawInputElement) {
    renderNode = selectorNode;
  } else {
    renderNode = /* @__PURE__ */ React135.createElement("div", _extends({
      className: mergedClassName
    }, domProps, {
      ref: containerRef,
      onMouseDown: onInternalMouseDown,
      onKeyDown: onInternalKeyDown,
      onKeyUp: onInternalKeyUp,
      onFocus: onContainerFocus,
      onBlur: onContainerBlur
    }), mockFocused && !mergedOpen && /* @__PURE__ */ React135.createElement("span", {
      "aria-live": "polite",
      style: {
        width: 0,
        height: 0,
        position: "absolute",
        overflow: "hidden",
        opacity: 0
      }
    }, "".concat(displayValues.map(function(_ref2) {
      var label = _ref2.label, value = _ref2.value;
      return ["number", "string"].includes(_typeof(label)) ? label : value;
    }).join(", "))), selectorNode, arrowNode, mergedAllowClear && clearNode);
  }
  return /* @__PURE__ */ React135.createElement(BaseSelectContext.Provider, {
    value: baseSelectContext
  }, renderNode);
});
if (process.env.NODE_ENV !== "production") {
  BaseSelect.displayName = "BaseSelect";
}
var BaseSelect_default = BaseSelect;

// ../../node_modules/rc-select/es/OptGroup.js
var OptGroup = function OptGroup2() {
  return null;
};
OptGroup.isSelectOptGroup = true;
var OptGroup_default = OptGroup;

// ../../node_modules/rc-select/es/Option.js
var Option = function Option2() {
  return null;
};
Option.isSelectOption = true;
var Option_default = Option;

// ../../node_modules/rc-select/es/OptionList.js
var import_classnames37 = __toESM(require_classnames());

// ../../node_modules/rc-virtual-list/es/List.js
var React144 = __toESM(require("react"));
var import_react52 = require("react");
var import_react_dom5 = require("react-dom");
var import_classnames36 = __toESM(require_classnames());

// ../../node_modules/rc-virtual-list/es/Filler.js
var React136 = __toESM(require("react"));
var import_classnames34 = __toESM(require_classnames());
var Filler = /* @__PURE__ */ React136.forwardRef(function(_ref, ref) {
  var height = _ref.height, offsetY = _ref.offsetY, offsetX = _ref.offsetX, children = _ref.children, prefixCls = _ref.prefixCls, onInnerResize = _ref.onInnerResize, innerProps = _ref.innerProps, rtl = _ref.rtl, extra = _ref.extra;
  var outerStyle = {};
  var innerStyle = {
    display: "flex",
    flexDirection: "column"
  };
  if (offsetY !== void 0) {
    var _objectSpread22;
    outerStyle = {
      height,
      position: "relative",
      overflow: "hidden"
    };
    innerStyle = _objectSpread2(_objectSpread2({}, innerStyle), {}, (_objectSpread22 = {
      transform: "translateY(".concat(offsetY, "px)")
    }, _defineProperty(_objectSpread22, rtl ? "marginRight" : "marginLeft", -offsetX), _defineProperty(_objectSpread22, "position", "absolute"), _defineProperty(_objectSpread22, "left", 0), _defineProperty(_objectSpread22, "right", 0), _defineProperty(_objectSpread22, "top", 0), _objectSpread22));
  }
  return /* @__PURE__ */ React136.createElement("div", {
    style: outerStyle
  }, /* @__PURE__ */ React136.createElement(es_default, {
    onResize: function onResize2(_ref2) {
      var offsetHeight = _ref2.offsetHeight;
      if (offsetHeight && onInnerResize) {
        onInnerResize();
      }
    }
  }, /* @__PURE__ */ React136.createElement("div", _extends({
    style: innerStyle,
    className: (0, import_classnames34.default)(_defineProperty({}, "".concat(prefixCls, "-holder-inner"), prefixCls)),
    ref
  }, innerProps), children, extra)));
});
Filler.displayName = "Filler";
var Filler_default = Filler;

// ../../node_modules/rc-virtual-list/es/ScrollBar.js
var React137 = __toESM(require("react"));
var import_classnames35 = __toESM(require_classnames());
function getPageXY(e, horizontal) {
  var obj = "touches" in e ? e.touches[0] : e;
  return obj[horizontal ? "pageX" : "pageY"];
}
var ScrollBar = /* @__PURE__ */ React137.forwardRef(function(props, ref) {
  var _classNames;
  var prefixCls = props.prefixCls, rtl = props.rtl, scrollOffset = props.scrollOffset, scrollRange = props.scrollRange, onStartMove = props.onStartMove, onStopMove = props.onStopMove, onScroll = props.onScroll, horizontal = props.horizontal, spinSize = props.spinSize, containerSize = props.containerSize, style2 = props.style, propsThumbStyle = props.thumbStyle;
  var _React$useState = React137.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), dragging = _React$useState2[0], setDragging = _React$useState2[1];
  var _React$useState3 = React137.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), pageXY = _React$useState4[0], setPageXY = _React$useState4[1];
  var _React$useState5 = React137.useState(null), _React$useState6 = _slicedToArray(_React$useState5, 2), startTop = _React$useState6[0], setStartTop = _React$useState6[1];
  var isLTR = !rtl;
  var scrollbarRef = React137.useRef();
  var thumbRef = React137.useRef();
  var _React$useState7 = React137.useState(false), _React$useState8 = _slicedToArray(_React$useState7, 2), visible = _React$useState8[0], setVisible = _React$useState8[1];
  var visibleTimeoutRef = React137.useRef();
  var delayHidden = function delayHidden2() {
    clearTimeout(visibleTimeoutRef.current);
    setVisible(true);
    visibleTimeoutRef.current = setTimeout(function() {
      setVisible(false);
    }, 3e3);
  };
  var enableScrollRange = scrollRange - containerSize || 0;
  var enableOffsetRange = containerSize - spinSize || 0;
  var canScroll = enableScrollRange > 0;
  var top = React137.useMemo(function() {
    if (scrollOffset === 0 || enableScrollRange === 0) {
      return 0;
    }
    var ptg = scrollOffset / enableScrollRange;
    return ptg * enableOffsetRange;
  }, [scrollOffset, enableScrollRange, enableOffsetRange]);
  var onContainerMouseDown = function onContainerMouseDown2(e) {
    e.stopPropagation();
    e.preventDefault();
  };
  var stateRef = React137.useRef({
    top,
    dragging,
    pageY: pageXY,
    startTop
  });
  stateRef.current = {
    top,
    dragging,
    pageY: pageXY,
    startTop
  };
  var onThumbMouseDown = function onThumbMouseDown2(e) {
    setDragging(true);
    setPageXY(getPageXY(e, horizontal));
    setStartTop(stateRef.current.top);
    onStartMove();
    e.stopPropagation();
    e.preventDefault();
  };
  React137.useEffect(function() {
    var onScrollbarTouchStart = function onScrollbarTouchStart2(e) {
      e.preventDefault();
    };
    var scrollbarEle = scrollbarRef.current;
    var thumbEle = thumbRef.current;
    scrollbarEle.addEventListener("touchstart", onScrollbarTouchStart);
    thumbEle.addEventListener("touchstart", onThumbMouseDown);
    return function() {
      scrollbarEle.removeEventListener("touchstart", onScrollbarTouchStart);
      thumbEle.removeEventListener("touchstart", onThumbMouseDown);
    };
  }, []);
  var enableScrollRangeRef = React137.useRef();
  enableScrollRangeRef.current = enableScrollRange;
  var enableOffsetRangeRef = React137.useRef();
  enableOffsetRangeRef.current = enableOffsetRange;
  React137.useEffect(function() {
    if (dragging) {
      var moveRafId;
      var onMouseMove = function onMouseMove2(e) {
        var _stateRef$current = stateRef.current, stateDragging = _stateRef$current.dragging, statePageY = _stateRef$current.pageY, stateStartTop = _stateRef$current.startTop;
        raf_default.cancel(moveRafId);
        if (stateDragging) {
          var offset2 = getPageXY(e, horizontal) - statePageY;
          var newTop = stateStartTop;
          if (!isLTR && horizontal) {
            newTop -= offset2;
          } else {
            newTop += offset2;
          }
          var tmpEnableScrollRange = enableScrollRangeRef.current;
          var tmpEnableOffsetRange = enableOffsetRangeRef.current;
          var ptg = tmpEnableOffsetRange ? newTop / tmpEnableOffsetRange : 0;
          var newScrollTop = Math.ceil(ptg * tmpEnableScrollRange);
          newScrollTop = Math.max(newScrollTop, 0);
          newScrollTop = Math.min(newScrollTop, tmpEnableScrollRange);
          moveRafId = raf_default(function() {
            onScroll(newScrollTop, horizontal);
          });
        }
      };
      var onMouseUp = function onMouseUp2() {
        setDragging(false);
        onStopMove();
      };
      window.addEventListener("mousemove", onMouseMove);
      window.addEventListener("touchmove", onMouseMove);
      window.addEventListener("mouseup", onMouseUp);
      window.addEventListener("touchend", onMouseUp);
      return function() {
        window.removeEventListener("mousemove", onMouseMove);
        window.removeEventListener("touchmove", onMouseMove);
        window.removeEventListener("mouseup", onMouseUp);
        window.removeEventListener("touchend", onMouseUp);
        raf_default.cancel(moveRafId);
      };
    }
  }, [dragging]);
  React137.useEffect(function() {
    delayHidden();
  }, [scrollOffset]);
  React137.useImperativeHandle(ref, function() {
    return {
      delayHidden
    };
  });
  var scrollbarPrefixCls = "".concat(prefixCls, "-scrollbar");
  var containerStyle = {
    position: "absolute",
    visibility: visible && canScroll ? null : "hidden"
  };
  var thumbStyle = {
    position: "absolute",
    background: "rgba(0, 0, 0, 0.5)",
    borderRadius: 99,
    cursor: "pointer",
    userSelect: "none"
  };
  if (horizontal) {
    containerStyle.height = 8;
    containerStyle.left = 0;
    containerStyle.right = 0;
    containerStyle.bottom = 0;
    thumbStyle.height = "100%";
    thumbStyle.width = spinSize;
    if (isLTR) {
      thumbStyle.left = top;
    } else {
      thumbStyle.right = top;
    }
  } else {
    containerStyle.width = 8;
    containerStyle.top = 0;
    containerStyle.bottom = 0;
    if (isLTR) {
      containerStyle.right = 0;
    } else {
      containerStyle.left = 0;
    }
    thumbStyle.width = "100%";
    thumbStyle.height = spinSize;
    thumbStyle.top = top;
  }
  return /* @__PURE__ */ React137.createElement("div", {
    ref: scrollbarRef,
    className: (0, import_classnames35.default)(scrollbarPrefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(scrollbarPrefixCls, "-horizontal"), horizontal), _defineProperty(_classNames, "".concat(scrollbarPrefixCls, "-vertical"), !horizontal), _defineProperty(_classNames, "".concat(scrollbarPrefixCls, "-visible"), visible), _classNames)),
    style: _objectSpread2(_objectSpread2({}, containerStyle), style2),
    onMouseDown: onContainerMouseDown,
    onMouseMove: delayHidden
  }, /* @__PURE__ */ React137.createElement("div", {
    ref: thumbRef,
    className: (0, import_classnames35.default)("".concat(scrollbarPrefixCls, "-thumb"), _defineProperty({}, "".concat(scrollbarPrefixCls, "-thumb-moving"), dragging)),
    style: _objectSpread2(_objectSpread2({}, thumbStyle), propsThumbStyle),
    onMouseDown: onThumbMouseDown
  }));
});
if (process.env.NODE_ENV !== "production") {
  ScrollBar.displayName = "ScrollBar";
}
var ScrollBar_default = ScrollBar;

// ../../node_modules/rc-virtual-list/es/hooks/useChildren.js
var React139 = __toESM(require("react"));

// ../../node_modules/rc-virtual-list/es/Item.js
var React138 = __toESM(require("react"));
function Item2(_ref) {
  var children = _ref.children, setRef = _ref.setRef;
  var refFunc = React138.useCallback(function(node2) {
    setRef(node2);
  }, []);
  return /* @__PURE__ */ React138.cloneElement(children, {
    ref: refFunc
  });
}

// ../../node_modules/rc-virtual-list/es/hooks/useChildren.js
function useChildren(list, startIndex, endIndex, scrollWidth, setNodeRef, renderFunc, _ref) {
  var getKey2 = _ref.getKey;
  return list.slice(startIndex, endIndex + 1).map(function(item, index2) {
    var eleIndex = startIndex + index2;
    var node2 = renderFunc(item, eleIndex, {
      style: {
        width: scrollWidth
      }
    });
    var key = getKey2(item);
    return /* @__PURE__ */ React139.createElement(Item2, {
      key,
      setRef: function setRef(ele) {
        return setNodeRef(item, ele);
      }
    }, node2);
  });
}

// ../../node_modules/rc-virtual-list/es/hooks/useHeights.js
var React140 = __toESM(require("react"));
var import_react48 = require("react");

// ../../node_modules/rc-virtual-list/es/utils/CacheMap.js
var CacheMap = /* @__PURE__ */ function() {
  function CacheMap2() {
    _classCallCheck(this, CacheMap2);
    this.maps = void 0;
    this.id = 0;
    this.maps = /* @__PURE__ */ Object.create(null);
  }
  _createClass(CacheMap2, [{
    key: "set",
    value: function set2(key, value) {
      this.maps[key] = value;
      this.id += 1;
    }
  }, {
    key: "get",
    value: function get2(key) {
      return this.maps[key];
    }
  }]);
  return CacheMap2;
}();
var CacheMap_default = CacheMap;

// ../../node_modules/rc-virtual-list/es/hooks/useHeights.js
function useHeights(getKey2, onItemAdd, onItemRemove) {
  var _React$useState = React140.useState(0), _React$useState2 = _slicedToArray(_React$useState, 2), updatedMark = _React$useState2[0], setUpdatedMark = _React$useState2[1];
  var instanceRef = (0, import_react48.useRef)(/* @__PURE__ */ new Map());
  var heightsRef = (0, import_react48.useRef)(new CacheMap_default());
  var collectRafRef = (0, import_react48.useRef)();
  function cancelRaf() {
    raf_default.cancel(collectRafRef.current);
  }
  function collectHeight() {
    var sync = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    cancelRaf();
    var doCollect = function doCollect2() {
      instanceRef.current.forEach(function(element, key) {
        if (element && element.offsetParent) {
          var htmlElement = findDOMNode(element);
          var offsetHeight = htmlElement.offsetHeight;
          if (heightsRef.current.get(key) !== offsetHeight) {
            heightsRef.current.set(key, htmlElement.offsetHeight);
          }
        }
      });
      setUpdatedMark(function(c) {
        return c + 1;
      });
    };
    if (sync) {
      doCollect();
    } else {
      collectRafRef.current = raf_default(doCollect);
    }
  }
  function setInstanceRef(item, instance) {
    var key = getKey2(item);
    var origin = instanceRef.current.get(key);
    if (instance) {
      instanceRef.current.set(key, instance);
      collectHeight();
    } else {
      instanceRef.current.delete(key);
    }
    if (!origin !== !instance) {
      if (instance) {
        onItemAdd === null || onItemAdd === void 0 ? void 0 : onItemAdd(item);
      } else {
        onItemRemove === null || onItemRemove === void 0 ? void 0 : onItemRemove(item);
      }
    }
  }
  (0, import_react48.useEffect)(function() {
    return cancelRaf;
  }, []);
  return [setInstanceRef, collectHeight, heightsRef.current, updatedMark];
}

// ../../node_modules/rc-virtual-list/es/hooks/useScrollTo.js
var React141 = __toESM(require("react"));
var MAX_TIMES = 10;
function useScrollTo(containerRef, data, heights, itemHeight, getKey2, collectHeight, syncScrollTop, triggerFlash) {
  var scrollRef = React141.useRef();
  var _React$useState = React141.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), syncState = _React$useState2[0], setSyncState = _React$useState2[1];
  useLayoutEffect_default(function() {
    if (syncState && syncState.times < MAX_TIMES) {
      if (!containerRef.current) {
        setSyncState(function(ori) {
          return _objectSpread2({}, ori);
        });
        return;
      }
      collectHeight();
      var targetAlign = syncState.targetAlign, originAlign = syncState.originAlign, index2 = syncState.index, offset2 = syncState.offset;
      var height = containerRef.current.clientHeight;
      var needCollectHeight = false;
      var newTargetAlign = targetAlign;
      var targetTop = null;
      if (height) {
        var mergedAlign = targetAlign || originAlign;
        var stackTop = 0;
        var itemTop = 0;
        var itemBottom = 0;
        var maxLen = Math.min(data.length - 1, index2);
        for (var i = 0; i <= maxLen; i += 1) {
          var key = getKey2(data[i]);
          itemTop = stackTop;
          var cacheHeight = heights.get(key);
          itemBottom = itemTop + (cacheHeight === void 0 ? itemHeight : cacheHeight);
          stackTop = itemBottom;
        }
        var leftHeight = mergedAlign === "top" ? offset2 : height - offset2;
        for (var _i = maxLen; _i >= 0; _i -= 1) {
          var _key = getKey2(data[_i]);
          var _cacheHeight = heights.get(_key);
          if (_cacheHeight === void 0) {
            needCollectHeight = true;
            break;
          }
          leftHeight -= _cacheHeight;
          if (leftHeight <= 0) {
            break;
          }
        }
        switch (mergedAlign) {
          case "top":
            targetTop = itemTop - offset2;
            break;
          case "bottom":
            targetTop = itemBottom - height + offset2;
            break;
          default: {
            var scrollTop = containerRef.current.scrollTop;
            var scrollBottom = scrollTop + height;
            if (itemTop < scrollTop) {
              newTargetAlign = "top";
            } else if (itemBottom > scrollBottom) {
              newTargetAlign = "bottom";
            }
          }
        }
        if (targetTop !== null) {
          syncScrollTop(targetTop);
        }
        if (targetTop !== syncState.lastTop) {
          needCollectHeight = true;
        }
      }
      if (needCollectHeight) {
        setSyncState(_objectSpread2(_objectSpread2({}, syncState), {}, {
          times: syncState.times + 1,
          targetAlign: newTargetAlign,
          lastTop: targetTop
        }));
      }
    } else if (process.env.NODE_ENV !== "production" && (syncState === null || syncState === void 0 ? void 0 : syncState.times) === MAX_TIMES) {
      warning_default(false, "Seems `scrollTo` with `rc-virtual-list` reach the max limitation. Please fire issue for us. Thanks.");
    }
  }, [syncState, containerRef.current]);
  return function(arg) {
    if (arg === null || arg === void 0) {
      triggerFlash();
      return;
    }
    raf_default.cancel(scrollRef.current);
    if (typeof arg === "number") {
      syncScrollTop(arg);
    } else if (arg && _typeof(arg) === "object") {
      var index2;
      var align = arg.align;
      if ("index" in arg) {
        index2 = arg.index;
      } else {
        index2 = data.findIndex(function(item) {
          return getKey2(item) === arg.key;
        });
      }
      var _arg$offset = arg.offset, offset2 = _arg$offset === void 0 ? 0 : _arg$offset;
      setSyncState({
        times: 0,
        index: index2,
        offset: offset2,
        originAlign: align
      });
    }
  };
}

// ../../node_modules/rc-virtual-list/es/hooks/useDiffItem.js
var React142 = __toESM(require("react"));

// ../../node_modules/rc-virtual-list/es/utils/algorithmUtil.js
function findListDiffIndex(originList, targetList, getKey2) {
  var originLen = originList.length;
  var targetLen = targetList.length;
  var shortList;
  var longList;
  if (originLen === 0 && targetLen === 0) {
    return null;
  }
  if (originLen < targetLen) {
    shortList = originList;
    longList = targetList;
  } else {
    shortList = targetList;
    longList = originList;
  }
  var notExistKey = {
    __EMPTY_ITEM__: true
  };
  function getItemKey(item) {
    if (item !== void 0) {
      return getKey2(item);
    }
    return notExistKey;
  }
  var diffIndex = null;
  var multiple = Math.abs(originLen - targetLen) !== 1;
  for (var i = 0; i < longList.length; i += 1) {
    var shortKey = getItemKey(shortList[i]);
    var longKey = getItemKey(longList[i]);
    if (shortKey !== longKey) {
      diffIndex = i;
      multiple = multiple || shortKey !== getItemKey(longList[i + 1]);
      break;
    }
  }
  return diffIndex === null ? null : {
    index: diffIndex,
    multiple
  };
}

// ../../node_modules/rc-virtual-list/es/hooks/useDiffItem.js
function useDiffItem(data, getKey2, onDiff) {
  var _React$useState = React142.useState(data), _React$useState2 = _slicedToArray(_React$useState, 2), prevData = _React$useState2[0], setPrevData = _React$useState2[1];
  var _React$useState3 = React142.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), diffItem = _React$useState4[0], setDiffItem = _React$useState4[1];
  React142.useEffect(function() {
    var diff = findListDiffIndex(prevData || [], data || [], getKey2);
    if ((diff === null || diff === void 0 ? void 0 : diff.index) !== void 0) {
      onDiff === null || onDiff === void 0 ? void 0 : onDiff(diff.index);
      setDiffItem(data[diff.index]);
    }
    setPrevData(data);
  }, [data]);
  return [diffItem];
}

// ../../node_modules/rc-virtual-list/es/hooks/useFrameWheel.js
var import_react50 = require("react");

// ../../node_modules/rc-virtual-list/es/utils/isFirefox.js
var isFF = (typeof navigator === "undefined" ? "undefined" : _typeof(navigator)) === "object" && /Firefox/i.test(navigator.userAgent);
var isFirefox_default = isFF;

// ../../node_modules/rc-virtual-list/es/hooks/useOriginScroll.js
var import_react49 = require("react");
var useOriginScroll_default = function(isScrollAtTop, isScrollAtBottom) {
  var lockRef = (0, import_react49.useRef)(false);
  var lockTimeoutRef = (0, import_react49.useRef)(null);
  function lockScroll() {
    clearTimeout(lockTimeoutRef.current);
    lockRef.current = true;
    lockTimeoutRef.current = setTimeout(function() {
      lockRef.current = false;
    }, 50);
  }
  var scrollPingRef = (0, import_react49.useRef)({
    top: isScrollAtTop,
    bottom: isScrollAtBottom
  });
  scrollPingRef.current.top = isScrollAtTop;
  scrollPingRef.current.bottom = isScrollAtBottom;
  return function(deltaY) {
    var smoothOffset = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var originScroll = (
      // Pass origin wheel when on the top
      deltaY < 0 && scrollPingRef.current.top || // Pass origin wheel when on the bottom
      deltaY > 0 && scrollPingRef.current.bottom
    );
    if (smoothOffset && originScroll) {
      clearTimeout(lockTimeoutRef.current);
      lockRef.current = false;
    } else if (!originScroll || lockRef.current) {
      lockScroll();
    }
    return !lockRef.current && originScroll;
  };
};

// ../../node_modules/rc-virtual-list/es/hooks/useFrameWheel.js
function useFrameWheel(inVirtual, isScrollAtTop, isScrollAtBottom, horizontalScroll, onWheelDelta) {
  var offsetRef = (0, import_react50.useRef)(0);
  var nextFrameRef = (0, import_react50.useRef)(null);
  var wheelValueRef = (0, import_react50.useRef)(null);
  var isMouseScrollRef = (0, import_react50.useRef)(false);
  var originScroll = useOriginScroll_default(isScrollAtTop, isScrollAtBottom);
  function onWheelY(event, deltaY) {
    raf_default.cancel(nextFrameRef.current);
    offsetRef.current += deltaY;
    wheelValueRef.current = deltaY;
    if (originScroll(deltaY))
      return;
    if (!isFirefox_default) {
      event.preventDefault();
    }
    nextFrameRef.current = raf_default(function() {
      var patchMultiple = isMouseScrollRef.current ? 10 : 1;
      onWheelDelta(offsetRef.current * patchMultiple);
      offsetRef.current = 0;
    });
  }
  function onWheelX(event, deltaX) {
    onWheelDelta(deltaX, true);
    if (!isFirefox_default) {
      event.preventDefault();
    }
  }
  var wheelDirectionRef = (0, import_react50.useRef)(null);
  var wheelDirectionCleanRef = (0, import_react50.useRef)(null);
  function onWheel(event) {
    if (!inVirtual)
      return;
    raf_default.cancel(wheelDirectionCleanRef.current);
    wheelDirectionCleanRef.current = raf_default(function() {
      wheelDirectionRef.current = null;
    }, 2);
    var deltaX = event.deltaX, deltaY = event.deltaY, shiftKey = event.shiftKey;
    var mergedDeltaX = deltaX;
    var mergedDeltaY = deltaY;
    if (wheelDirectionRef.current === "sx" || !wheelDirectionRef.current && (shiftKey || false) && deltaY && !deltaX) {
      mergedDeltaX = deltaY;
      mergedDeltaY = 0;
      wheelDirectionRef.current = "sx";
    }
    var absX = Math.abs(mergedDeltaX);
    var absY = Math.abs(mergedDeltaY);
    if (wheelDirectionRef.current === null) {
      wheelDirectionRef.current = horizontalScroll && absX > absY ? "x" : "y";
    }
    if (wheelDirectionRef.current === "y") {
      onWheelY(event, mergedDeltaY);
    } else {
      onWheelX(event, mergedDeltaX);
    }
  }
  function onFireFoxScroll(event) {
    if (!inVirtual)
      return;
    isMouseScrollRef.current = event.detail === wheelValueRef.current;
  }
  return [onWheel, onFireFoxScroll];
}

// ../../node_modules/rc-virtual-list/es/hooks/useMobileTouchMove.js
var import_react51 = require("react");
var SMOOTH_PTG = 14 / 15;
function useMobileTouchMove(inVirtual, listRef, callback) {
  var touchedRef = (0, import_react51.useRef)(false);
  var touchYRef = (0, import_react51.useRef)(0);
  var elementRef = (0, import_react51.useRef)(null);
  var intervalRef = (0, import_react51.useRef)(null);
  var cleanUpEvents;
  var onTouchMove = function onTouchMove2(e) {
    if (touchedRef.current) {
      var currentY = Math.ceil(e.touches[0].pageY);
      var offsetY = touchYRef.current - currentY;
      touchYRef.current = currentY;
      if (callback(offsetY)) {
        e.preventDefault();
      }
      clearInterval(intervalRef.current);
      intervalRef.current = setInterval(function() {
        offsetY *= SMOOTH_PTG;
        if (!callback(offsetY, true) || Math.abs(offsetY) <= 0.1) {
          clearInterval(intervalRef.current);
        }
      }, 16);
    }
  };
  var onTouchEnd = function onTouchEnd2() {
    touchedRef.current = false;
    cleanUpEvents();
  };
  var onTouchStart = function onTouchStart2(e) {
    cleanUpEvents();
    if (e.touches.length === 1 && !touchedRef.current) {
      touchedRef.current = true;
      touchYRef.current = Math.ceil(e.touches[0].pageY);
      elementRef.current = e.target;
      elementRef.current.addEventListener("touchmove", onTouchMove);
      elementRef.current.addEventListener("touchend", onTouchEnd);
    }
  };
  cleanUpEvents = function cleanUpEvents2() {
    if (elementRef.current) {
      elementRef.current.removeEventListener("touchmove", onTouchMove);
      elementRef.current.removeEventListener("touchend", onTouchEnd);
    }
  };
  useLayoutEffect_default(function() {
    if (inVirtual) {
      listRef.current.addEventListener("touchstart", onTouchStart);
    }
    return function() {
      var _listRef$current;
      (_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.removeEventListener("touchstart", onTouchStart);
      cleanUpEvents();
      clearInterval(intervalRef.current);
    };
  }, [inVirtual]);
}

// ../../node_modules/rc-virtual-list/es/utils/scrollbarUtil.js
var MIN_SIZE = 20;
function getSpinSize() {
  var containerSize = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  var scrollRange = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  var baseSize = containerSize / scrollRange * 100;
  if (isNaN(baseSize)) {
    baseSize = 0;
  }
  baseSize = Math.max(baseSize, MIN_SIZE);
  baseSize = Math.min(baseSize, containerSize / 2);
  return Math.floor(baseSize);
}

// ../../node_modules/rc-virtual-list/es/hooks/useGetSize.js
var React143 = __toESM(require("react"));
function useGetSize(mergedData, getKey2, heights, itemHeight) {
  var _React$useMemo = React143.useMemo(function() {
    return [/* @__PURE__ */ new Map(), []];
  }, [mergedData, heights.id, itemHeight]), _React$useMemo2 = _slicedToArray(_React$useMemo, 2), key2Index = _React$useMemo2[0], bottomList = _React$useMemo2[1];
  var getSize = function getSize2(startKey) {
    var endKey = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : startKey;
    var startIndex = key2Index.get(startKey);
    var endIndex = key2Index.get(endKey);
    if (startIndex === void 0 || endIndex === void 0) {
      var dataLen = mergedData.length;
      for (var i = bottomList.length; i < dataLen; i += 1) {
        var _heights$get;
        var item = mergedData[i];
        var key = getKey2(item);
        key2Index.set(key, i);
        var cacheHeight = (_heights$get = heights.get(key)) !== null && _heights$get !== void 0 ? _heights$get : itemHeight;
        bottomList[i] = (bottomList[i - 1] || 0) + cacheHeight;
        if (key === startKey) {
          startIndex = i;
        }
        if (key === endKey) {
          endIndex = i;
        }
        if (startIndex !== void 0 && endIndex !== void 0) {
          break;
        }
      }
    }
    return {
      top: bottomList[startIndex - 1] || 0,
      bottom: bottomList[endIndex]
    };
  };
  return getSize;
}

// ../../node_modules/rc-virtual-list/es/List.js
var _excluded16 = ["prefixCls", "className", "height", "itemHeight", "fullHeight", "style", "data", "children", "itemKey", "virtual", "direction", "scrollWidth", "component", "onScroll", "onVirtualScroll", "onVisibleChange", "innerProps", "extraRender", "styles"];
var EMPTY_DATA = [];
var ScrollStyle = {
  overflowY: "auto",
  overflowAnchor: "none"
};
function RawList(props, ref) {
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-virtual-list" : _props$prefixCls, className = props.className, height = props.height, itemHeight = props.itemHeight, _props$fullHeight = props.fullHeight, fullHeight = _props$fullHeight === void 0 ? true : _props$fullHeight, style2 = props.style, data = props.data, children = props.children, itemKey2 = props.itemKey, virtual = props.virtual, direction = props.direction, scrollWidth = props.scrollWidth, _props$component = props.component, Component6 = _props$component === void 0 ? "div" : _props$component, onScroll = props.onScroll, onVirtualScroll = props.onVirtualScroll, onVisibleChange = props.onVisibleChange, innerProps = props.innerProps, extraRender = props.extraRender, styles = props.styles, restProps = _objectWithoutProperties(props, _excluded16);
  var useVirtual = !!(virtual !== false && height && itemHeight);
  var inVirtual = useVirtual && data && (itemHeight * data.length > height || !!scrollWidth);
  var isRTL = direction === "rtl";
  var mergedClassName = (0, import_classnames36.default)(prefixCls, _defineProperty({}, "".concat(prefixCls, "-rtl"), isRTL), className);
  var mergedData = data || EMPTY_DATA;
  var componentRef = (0, import_react52.useRef)();
  var fillerInnerRef = (0, import_react52.useRef)();
  var _useState = (0, import_react52.useState)(0), _useState2 = _slicedToArray(_useState, 2), offsetTop = _useState2[0], setOffsetTop = _useState2[1];
  var _useState3 = (0, import_react52.useState)(0), _useState4 = _slicedToArray(_useState3, 2), offsetLeft = _useState4[0], setOffsetLeft = _useState4[1];
  var _useState5 = (0, import_react52.useState)(false), _useState6 = _slicedToArray(_useState5, 2), scrollMoving = _useState6[0], setScrollMoving = _useState6[1];
  var onScrollbarStartMove = function onScrollbarStartMove2() {
    setScrollMoving(true);
  };
  var onScrollbarStopMove = function onScrollbarStopMove2() {
    setScrollMoving(false);
  };
  var getKey2 = React144.useCallback(function(item) {
    if (typeof itemKey2 === "function") {
      return itemKey2(item);
    }
    return item === null || item === void 0 ? void 0 : item[itemKey2];
  }, [itemKey2]);
  var sharedConfig = {
    getKey: getKey2
  };
  function syncScrollTop(newTop) {
    setOffsetTop(function(origin) {
      var value;
      if (typeof newTop === "function") {
        value = newTop(origin);
      } else {
        value = newTop;
      }
      var alignedTop = keepInRange(value);
      componentRef.current.scrollTop = alignedTop;
      return alignedTop;
    });
  }
  var rangeRef = (0, import_react52.useRef)({
    start: 0,
    end: mergedData.length
  });
  var diffItemRef = (0, import_react52.useRef)();
  var _useDiffItem = useDiffItem(mergedData, getKey2), _useDiffItem2 = _slicedToArray(_useDiffItem, 1), diffItem = _useDiffItem2[0];
  diffItemRef.current = diffItem;
  var _useHeights = useHeights(getKey2, null, null), _useHeights2 = _slicedToArray(_useHeights, 4), setInstanceRef = _useHeights2[0], collectHeight = _useHeights2[1], heights = _useHeights2[2], heightUpdatedMark = _useHeights2[3];
  var _React$useMemo = React144.useMemo(function() {
    if (!useVirtual) {
      return {
        scrollHeight: void 0,
        start: 0,
        end: mergedData.length - 1,
        offset: void 0
      };
    }
    if (!inVirtual) {
      var _fillerInnerRef$curre;
      return {
        scrollHeight: ((_fillerInnerRef$curre = fillerInnerRef.current) === null || _fillerInnerRef$curre === void 0 ? void 0 : _fillerInnerRef$curre.offsetHeight) || 0,
        start: 0,
        end: mergedData.length - 1,
        offset: void 0
      };
    }
    var itemTop = 0;
    var startIndex;
    var startOffset;
    var endIndex;
    var dataLen = mergedData.length;
    for (var i = 0; i < dataLen; i += 1) {
      var item = mergedData[i];
      var key = getKey2(item);
      var cacheHeight = heights.get(key);
      var currentItemBottom = itemTop + (cacheHeight === void 0 ? itemHeight : cacheHeight);
      if (currentItemBottom >= offsetTop && startIndex === void 0) {
        startIndex = i;
        startOffset = itemTop;
      }
      if (currentItemBottom > offsetTop + height && endIndex === void 0) {
        endIndex = i;
      }
      itemTop = currentItemBottom;
    }
    if (startIndex === void 0) {
      startIndex = 0;
      startOffset = 0;
      endIndex = Math.ceil(height / itemHeight);
    }
    if (endIndex === void 0) {
      endIndex = mergedData.length - 1;
    }
    endIndex = Math.min(endIndex + 1, mergedData.length - 1);
    return {
      scrollHeight: itemTop,
      start: startIndex,
      end: endIndex,
      offset: startOffset
    };
  }, [inVirtual, useVirtual, offsetTop, mergedData, heightUpdatedMark, height]), scrollHeight = _React$useMemo.scrollHeight, start = _React$useMemo.start, end = _React$useMemo.end, fillerOffset = _React$useMemo.offset;
  rangeRef.current.start = start;
  rangeRef.current.end = end;
  var _React$useState = React144.useState({
    width: 0,
    height
  }), _React$useState2 = _slicedToArray(_React$useState, 2), size = _React$useState2[0], setSize = _React$useState2[1];
  var onHolderResize = function onHolderResize2(sizeInfo) {
    setSize({
      width: sizeInfo.width || sizeInfo.offsetWidth,
      height: sizeInfo.height || sizeInfo.offsetHeight
    });
  };
  var verticalScrollBarRef = (0, import_react52.useRef)();
  var horizontalScrollBarRef = (0, import_react52.useRef)();
  var horizontalScrollBarSpinSize = React144.useMemo(function() {
    return getSpinSize(size.width, scrollWidth);
  }, [size.width, scrollWidth]);
  var verticalScrollBarSpinSize = React144.useMemo(function() {
    return getSpinSize(size.height, scrollHeight);
  }, [size.height, scrollHeight]);
  var maxScrollHeight = scrollHeight - height;
  var maxScrollHeightRef = (0, import_react52.useRef)(maxScrollHeight);
  maxScrollHeightRef.current = maxScrollHeight;
  function keepInRange(newScrollTop) {
    var newTop = newScrollTop;
    if (!Number.isNaN(maxScrollHeightRef.current)) {
      newTop = Math.min(newTop, maxScrollHeightRef.current);
    }
    newTop = Math.max(newTop, 0);
    return newTop;
  }
  var isScrollAtTop = offsetTop <= 0;
  var isScrollAtBottom = offsetTop >= maxScrollHeight;
  var originScroll = useOriginScroll_default(isScrollAtTop, isScrollAtBottom);
  var getVirtualScrollInfo = function getVirtualScrollInfo2() {
    return {
      x: isRTL ? -offsetLeft : offsetLeft,
      y: offsetTop
    };
  };
  var lastVirtualScrollInfoRef = (0, import_react52.useRef)(getVirtualScrollInfo());
  var triggerScroll = useEvent(function() {
    if (onVirtualScroll) {
      var nextInfo = getVirtualScrollInfo();
      if (lastVirtualScrollInfoRef.current.x !== nextInfo.x || lastVirtualScrollInfoRef.current.y !== nextInfo.y) {
        onVirtualScroll(nextInfo);
        lastVirtualScrollInfoRef.current = nextInfo;
      }
    }
  });
  function onScrollBar(newScrollOffset, horizontal) {
    var newOffset = newScrollOffset;
    if (horizontal) {
      (0, import_react_dom5.flushSync)(function() {
        setOffsetLeft(newOffset);
      });
      triggerScroll();
    } else {
      syncScrollTop(newOffset);
    }
  }
  function onFallbackScroll(e) {
    var newScrollTop = e.currentTarget.scrollTop;
    if (newScrollTop !== offsetTop) {
      syncScrollTop(newScrollTop);
    }
    onScroll === null || onScroll === void 0 ? void 0 : onScroll(e);
    triggerScroll();
  }
  var keepInHorizontalRange = function keepInHorizontalRange2(nextOffsetLeft) {
    var tmpOffsetLeft = nextOffsetLeft;
    var max3 = scrollWidth - size.width;
    tmpOffsetLeft = Math.max(tmpOffsetLeft, 0);
    tmpOffsetLeft = Math.min(tmpOffsetLeft, max3);
    return tmpOffsetLeft;
  };
  var onWheelDelta = useEvent(function(offsetXY, fromHorizontal) {
    if (fromHorizontal) {
      (0, import_react_dom5.flushSync)(function() {
        setOffsetLeft(function(left) {
          var nextOffsetLeft = left + (isRTL ? -offsetXY : offsetXY);
          return keepInHorizontalRange(nextOffsetLeft);
        });
      });
      triggerScroll();
    } else {
      syncScrollTop(function(top) {
        var newTop = top + offsetXY;
        return newTop;
      });
    }
  });
  var _useFrameWheel = useFrameWheel(useVirtual, isScrollAtTop, isScrollAtBottom, !!scrollWidth, onWheelDelta), _useFrameWheel2 = _slicedToArray(_useFrameWheel, 2), onRawWheel = _useFrameWheel2[0], onFireFoxScroll = _useFrameWheel2[1];
  useMobileTouchMove(useVirtual, componentRef, function(deltaY, smoothOffset) {
    if (originScroll(deltaY, smoothOffset)) {
      return false;
    }
    onRawWheel({
      preventDefault: function preventDefault() {
      },
      deltaY
    });
    return true;
  });
  useLayoutEffect_default(function() {
    function onMozMousePixelScroll(e) {
      if (useVirtual) {
        e.preventDefault();
      }
    }
    var componentEle = componentRef.current;
    componentEle.addEventListener("wheel", onRawWheel);
    componentEle.addEventListener("DOMMouseScroll", onFireFoxScroll);
    componentEle.addEventListener("MozMousePixelScroll", onMozMousePixelScroll);
    return function() {
      componentEle.removeEventListener("wheel", onRawWheel);
      componentEle.removeEventListener("DOMMouseScroll", onFireFoxScroll);
      componentEle.removeEventListener("MozMousePixelScroll", onMozMousePixelScroll);
    };
  }, [useVirtual]);
  useLayoutEffect_default(function() {
    if (scrollWidth) {
      setOffsetLeft(function(left) {
        return keepInHorizontalRange(left);
      });
    }
  }, [size.width, scrollWidth]);
  var delayHideScrollBar = function delayHideScrollBar2() {
    var _verticalScrollBarRef, _horizontalScrollBarR;
    (_verticalScrollBarRef = verticalScrollBarRef.current) === null || _verticalScrollBarRef === void 0 ? void 0 : _verticalScrollBarRef.delayHidden();
    (_horizontalScrollBarR = horizontalScrollBarRef.current) === null || _horizontalScrollBarR === void 0 ? void 0 : _horizontalScrollBarR.delayHidden();
  };
  var _scrollTo = useScrollTo(componentRef, mergedData, heights, itemHeight, getKey2, function() {
    return collectHeight(true);
  }, syncScrollTop, delayHideScrollBar);
  React144.useImperativeHandle(ref, function() {
    return {
      getScrollInfo: getVirtualScrollInfo,
      scrollTo: function scrollTo(config) {
        function isPosScroll(arg) {
          return arg && _typeof(arg) === "object" && ("left" in arg || "top" in arg);
        }
        if (isPosScroll(config)) {
          if (config.left !== void 0) {
            setOffsetLeft(keepInHorizontalRange(config.left));
          }
          _scrollTo(config.top);
        } else {
          _scrollTo(config);
        }
      }
    };
  });
  useLayoutEffect_default(function() {
    if (onVisibleChange) {
      var renderList = mergedData.slice(start, end + 1);
      onVisibleChange(renderList, mergedData);
    }
  }, [start, end, mergedData]);
  var getSize = useGetSize(mergedData, getKey2, heights, itemHeight);
  var extraContent = extraRender === null || extraRender === void 0 ? void 0 : extraRender({
    start,
    end,
    virtual: inVirtual,
    offsetX: offsetLeft,
    offsetY: fillerOffset,
    rtl: isRTL,
    getSize
  });
  var listChildren = useChildren(mergedData, start, end, scrollWidth, setInstanceRef, children, sharedConfig);
  var componentStyle = null;
  if (height) {
    componentStyle = _objectSpread2(_defineProperty({}, fullHeight ? "height" : "maxHeight", height), ScrollStyle);
    if (useVirtual) {
      componentStyle.overflowY = "hidden";
      if (scrollWidth) {
        componentStyle.overflowX = "hidden";
      }
      if (scrollMoving) {
        componentStyle.pointerEvents = "none";
      }
    }
  }
  var containerProps = {};
  if (isRTL) {
    containerProps.dir = "rtl";
  }
  return /* @__PURE__ */ React144.createElement("div", _extends({
    style: _objectSpread2(_objectSpread2({}, style2), {}, {
      position: "relative"
    }),
    className: mergedClassName
  }, containerProps, restProps), /* @__PURE__ */ React144.createElement(es_default, {
    onResize: onHolderResize
  }, /* @__PURE__ */ React144.createElement(Component6, {
    className: "".concat(prefixCls, "-holder"),
    style: componentStyle,
    ref: componentRef,
    onScroll: onFallbackScroll,
    onMouseEnter: delayHideScrollBar
  }, /* @__PURE__ */ React144.createElement(Filler_default, {
    prefixCls,
    height: scrollHeight,
    offsetX: offsetLeft,
    offsetY: fillerOffset,
    scrollWidth,
    onInnerResize: collectHeight,
    ref: fillerInnerRef,
    innerProps,
    rtl: isRTL,
    extra: extraContent
  }, listChildren))), inVirtual && scrollHeight > height && /* @__PURE__ */ React144.createElement(ScrollBar_default, {
    ref: verticalScrollBarRef,
    prefixCls,
    scrollOffset: offsetTop,
    scrollRange: scrollHeight,
    rtl: isRTL,
    onScroll: onScrollBar,
    onStartMove: onScrollbarStartMove,
    onStopMove: onScrollbarStopMove,
    spinSize: verticalScrollBarSpinSize,
    containerSize: size.height,
    style: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBar,
    thumbStyle: styles === null || styles === void 0 ? void 0 : styles.verticalScrollBarThumb
  }), inVirtual && scrollWidth && /* @__PURE__ */ React144.createElement(ScrollBar_default, {
    ref: horizontalScrollBarRef,
    prefixCls,
    scrollOffset: offsetLeft,
    scrollRange: scrollWidth,
    rtl: isRTL,
    onScroll: onScrollBar,
    onStartMove: onScrollbarStartMove,
    onStopMove: onScrollbarStopMove,
    spinSize: horizontalScrollBarSpinSize,
    containerSize: size.width,
    horizontal: true,
    style: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBar,
    thumbStyle: styles === null || styles === void 0 ? void 0 : styles.horizontalScrollBarThumb
  }));
}
var List2 = /* @__PURE__ */ React144.forwardRef(RawList);
List2.displayName = "List";
var List_default2 = List2;

// ../../node_modules/rc-virtual-list/es/index.js
var es_default7 = List_default2;

// ../../node_modules/rc-select/es/OptionList.js
var React145 = __toESM(require("react"));
var import_react53 = require("react");

// ../../node_modules/rc-select/es/utils/platformUtil.js
function isPlatformMac() {
  return /(mac\sos|macintosh)/i.test(navigator.appVersion);
}

// ../../node_modules/rc-select/es/OptionList.js
var _excluded17 = ["disabled", "title", "children", "style", "className"];
function isTitleType2(content) {
  return typeof content === "string" || typeof content === "number";
}
var OptionList = function OptionList2(_, ref) {
  var _useBaseProps = useBaseProps(), prefixCls = _useBaseProps.prefixCls, id = _useBaseProps.id, open3 = _useBaseProps.open, multiple = _useBaseProps.multiple, mode = _useBaseProps.mode, searchValue = _useBaseProps.searchValue, toggleOpen = _useBaseProps.toggleOpen, notFoundContent = _useBaseProps.notFoundContent, onPopupScroll = _useBaseProps.onPopupScroll;
  var _React$useContext = React145.useContext(SelectContext_default), maxCount = _React$useContext.maxCount, flattenOptions2 = _React$useContext.flattenOptions, onActiveValue = _React$useContext.onActiveValue, defaultActiveFirstOption = _React$useContext.defaultActiveFirstOption, onSelect = _React$useContext.onSelect, menuItemSelectedIcon = _React$useContext.menuItemSelectedIcon, rawValues = _React$useContext.rawValues, fieldNames = _React$useContext.fieldNames, virtual = _React$useContext.virtual, direction = _React$useContext.direction, listHeight = _React$useContext.listHeight, listItemHeight = _React$useContext.listItemHeight, optionRender = _React$useContext.optionRender;
  var itemPrefixCls = "".concat(prefixCls, "-item");
  var memoFlattenOptions = useMemo(function() {
    return flattenOptions2;
  }, [open3, flattenOptions2], function(prev2, next2) {
    return next2[0] && prev2[1] !== next2[1];
  });
  var listRef = React145.useRef(null);
  var overMaxCount = React145.useMemo(function() {
    return multiple && typeof maxCount !== "undefined" && (rawValues === null || rawValues === void 0 ? void 0 : rawValues.size) >= maxCount;
  }, [multiple, maxCount, rawValues === null || rawValues === void 0 ? void 0 : rawValues.size]);
  var onListMouseDown = function onListMouseDown2(event) {
    event.preventDefault();
  };
  var scrollIntoView = function scrollIntoView2(args) {
    var _listRef$current;
    (_listRef$current = listRef.current) === null || _listRef$current === void 0 || _listRef$current.scrollTo(typeof args === "number" ? {
      index: args
    } : args);
  };
  var getEnabledActiveIndex = function getEnabledActiveIndex2(index2) {
    var offset2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
    var len = memoFlattenOptions.length;
    for (var i = 0; i < len; i += 1) {
      var current = (index2 + i * offset2 + len) % len;
      var _ref = memoFlattenOptions[current] || {}, group = _ref.group, data = _ref.data;
      if (!group && !(data !== null && data !== void 0 && data.disabled) && !overMaxCount) {
        return current;
      }
    }
    return -1;
  };
  var _React$useState = React145.useState(function() {
    return getEnabledActiveIndex(0);
  }), _React$useState2 = _slicedToArray(_React$useState, 2), activeIndex = _React$useState2[0], setActiveIndex = _React$useState2[1];
  var setActive = function setActive2(index2) {
    var fromKeyboard = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    setActiveIndex(index2);
    var info = {
      source: fromKeyboard ? "keyboard" : "mouse"
    };
    var flattenItem = memoFlattenOptions[index2];
    if (!flattenItem) {
      onActiveValue(null, -1, info);
      return;
    }
    onActiveValue(flattenItem.value, index2, info);
  };
  (0, import_react53.useEffect)(function() {
    setActive(defaultActiveFirstOption !== false ? getEnabledActiveIndex(0) : -1);
  }, [memoFlattenOptions.length, searchValue]);
  var isSelected = React145.useCallback(function(value) {
    return rawValues.has(value) && mode !== "combobox";
  }, [mode, _toConsumableArray(rawValues).toString(), rawValues.size]);
  (0, import_react53.useEffect)(function() {
    var timeoutId = setTimeout(function() {
      if (!multiple && open3 && rawValues.size === 1) {
        var value = Array.from(rawValues)[0];
        var index2 = memoFlattenOptions.findIndex(function(_ref2) {
          var data = _ref2.data;
          return data.value === value;
        });
        if (index2 !== -1) {
          setActive(index2);
          scrollIntoView(index2);
        }
      }
    });
    if (open3) {
      var _listRef$current2;
      (_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 || _listRef$current2.scrollTo(void 0);
    }
    return function() {
      return clearTimeout(timeoutId);
    };
  }, [open3, searchValue]);
  var onSelectValue = function onSelectValue2(value) {
    if (value !== void 0) {
      onSelect(value, {
        selected: !rawValues.has(value)
      });
    }
    if (!multiple) {
      toggleOpen(false);
    }
  };
  React145.useImperativeHandle(ref, function() {
    return {
      onKeyDown: function onKeyDown(event) {
        var which = event.which, ctrlKey = event.ctrlKey;
        switch (which) {
          case KeyCode_default.N:
          case KeyCode_default.P:
          case KeyCode_default.UP:
          case KeyCode_default.DOWN: {
            var offset2 = 0;
            if (which === KeyCode_default.UP) {
              offset2 = -1;
            } else if (which === KeyCode_default.DOWN) {
              offset2 = 1;
            } else if (isPlatformMac() && ctrlKey) {
              if (which === KeyCode_default.N) {
                offset2 = 1;
              } else if (which === KeyCode_default.P) {
                offset2 = -1;
              }
            }
            if (offset2 !== 0) {
              var nextActiveIndex = getEnabledActiveIndex(activeIndex + offset2, offset2);
              scrollIntoView(nextActiveIndex);
              setActive(nextActiveIndex, true);
            }
            break;
          }
          case KeyCode_default.ENTER: {
            var _item$data;
            var item = memoFlattenOptions[activeIndex];
            if (item && !(item !== null && item !== void 0 && (_item$data = item.data) !== null && _item$data !== void 0 && _item$data.disabled) && !overMaxCount) {
              onSelectValue(item.value);
            } else {
              onSelectValue(void 0);
            }
            if (open3) {
              event.preventDefault();
            }
            break;
          }
          case KeyCode_default.ESC: {
            toggleOpen(false);
            if (open3) {
              event.stopPropagation();
            }
          }
        }
      },
      onKeyUp: function onKeyUp() {
      },
      scrollTo: function scrollTo(index2) {
        scrollIntoView(index2);
      }
    };
  });
  if (memoFlattenOptions.length === 0) {
    return /* @__PURE__ */ React145.createElement("div", {
      role: "listbox",
      id: "".concat(id, "_list"),
      className: "".concat(itemPrefixCls, "-empty"),
      onMouseDown: onListMouseDown
    }, notFoundContent);
  }
  var omitFieldNameList = Object.keys(fieldNames).map(function(key) {
    return fieldNames[key];
  });
  var getLabel = function getLabel2(item) {
    return item.label;
  };
  function getItemAriaProps(item, index2) {
    var group = item.group;
    return {
      role: group ? "presentation" : "option",
      id: "".concat(id, "_list_").concat(index2)
    };
  }
  var renderItem = function renderItem2(index2) {
    var item = memoFlattenOptions[index2];
    if (!item) {
      return null;
    }
    var itemData = item.data || {};
    var value = itemData.value;
    var group = item.group;
    var attrs = pickAttrs(itemData, true);
    var mergedLabel = getLabel(item);
    return item ? /* @__PURE__ */ React145.createElement("div", _extends({
      "aria-label": typeof mergedLabel === "string" && !group ? mergedLabel : null
    }, attrs, {
      key: index2
    }, getItemAriaProps(item, index2), {
      "aria-selected": isSelected(value)
    }), value) : null;
  };
  var a11yProps = {
    role: "listbox",
    id: "".concat(id, "_list")
  };
  return /* @__PURE__ */ React145.createElement(React145.Fragment, null, virtual && /* @__PURE__ */ React145.createElement("div", _extends({}, a11yProps, {
    style: {
      height: 0,
      width: 0,
      overflow: "hidden"
    }
  }), renderItem(activeIndex - 1), renderItem(activeIndex), renderItem(activeIndex + 1)), /* @__PURE__ */ React145.createElement(es_default7, {
    itemKey: "key",
    ref: listRef,
    data: memoFlattenOptions,
    height: listHeight,
    itemHeight: listItemHeight,
    fullHeight: false,
    onMouseDown: onListMouseDown,
    onScroll: onPopupScroll,
    virtual,
    direction,
    innerProps: virtual ? null : a11yProps
  }, function(item, itemIndex) {
    var _classNames;
    var group = item.group, groupOption = item.groupOption, data = item.data, label = item.label, value = item.value;
    var key = data.key;
    if (group) {
      var _data$title;
      var groupTitle = (_data$title = data.title) !== null && _data$title !== void 0 ? _data$title : isTitleType2(label) ? label.toString() : void 0;
      return /* @__PURE__ */ React145.createElement("div", {
        className: (0, import_classnames37.default)(itemPrefixCls, "".concat(itemPrefixCls, "-group")),
        title: groupTitle
      }, label !== void 0 ? label : key);
    }
    var disabled = data.disabled, title = data.title, children = data.children, style2 = data.style, className = data.className, otherProps = _objectWithoutProperties(data, _excluded17);
    var passedProps = omit(otherProps, omitFieldNameList);
    var selected = isSelected(value);
    var mergedDisabled = disabled || !selected && overMaxCount;
    var optionPrefixCls = "".concat(itemPrefixCls, "-option");
    var optionClassName = (0, import_classnames37.default)(itemPrefixCls, optionPrefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(optionPrefixCls, "-grouped"), groupOption), _defineProperty(_classNames, "".concat(optionPrefixCls, "-active"), activeIndex === itemIndex && !mergedDisabled), _defineProperty(_classNames, "".concat(optionPrefixCls, "-disabled"), mergedDisabled), _defineProperty(_classNames, "".concat(optionPrefixCls, "-selected"), selected), _classNames));
    var mergedLabel = getLabel(item);
    var iconVisible = !menuItemSelectedIcon || typeof menuItemSelectedIcon === "function" || selected;
    var content = typeof mergedLabel === "number" ? mergedLabel : mergedLabel || value;
    var optionTitle = isTitleType2(content) ? content.toString() : void 0;
    if (title !== void 0) {
      optionTitle = title;
    }
    return /* @__PURE__ */ React145.createElement("div", _extends({}, pickAttrs(passedProps), !virtual ? getItemAriaProps(item, itemIndex) : {}, {
      "aria-selected": selected,
      className: optionClassName,
      title: optionTitle,
      onMouseMove: function onMouseMove() {
        if (activeIndex === itemIndex || mergedDisabled) {
          return;
        }
        setActive(itemIndex);
      },
      onClick: function onClick() {
        if (!mergedDisabled) {
          onSelectValue(value);
        }
      },
      style: style2
    }), /* @__PURE__ */ React145.createElement("div", {
      className: "".concat(optionPrefixCls, "-content")
    }, typeof optionRender === "function" ? optionRender(item, {
      index: itemIndex
    }) : content), /* @__PURE__ */ React145.isValidElement(menuItemSelectedIcon) || selected, iconVisible && /* @__PURE__ */ React145.createElement(TransBtn_default, {
      className: "".concat(itemPrefixCls, "-option-state"),
      customizeIcon: menuItemSelectedIcon,
      customizeIconProps: {
        value,
        disabled: mergedDisabled,
        isSelected: selected
      }
    }, selected ? "\u2713" : null));
  }));
};
var RefOptionList = /* @__PURE__ */ React145.forwardRef(OptionList);
if (process.env.NODE_ENV !== "production") {
  RefOptionList.displayName = "OptionList";
}
var OptionList_default = RefOptionList;

// ../../node_modules/rc-select/es/hooks/useCache.js
var React146 = __toESM(require("react"));
var useCache_default = function(labeledValues, valueOptions) {
  var cacheRef = React146.useRef({
    values: /* @__PURE__ */ new Map(),
    options: /* @__PURE__ */ new Map()
  });
  var filledLabeledValues = React146.useMemo(function() {
    var _cacheRef$current = cacheRef.current, prevValueCache = _cacheRef$current.values, prevOptionCache = _cacheRef$current.options;
    var patchedValues = labeledValues.map(function(item) {
      if (item.label === void 0) {
        var _prevValueCache$get;
        return _objectSpread2(_objectSpread2({}, item), {}, {
          label: (_prevValueCache$get = prevValueCache.get(item.value)) === null || _prevValueCache$get === void 0 ? void 0 : _prevValueCache$get.label
        });
      }
      return item;
    });
    var valueCache = /* @__PURE__ */ new Map();
    var optionCache = /* @__PURE__ */ new Map();
    patchedValues.forEach(function(item) {
      valueCache.set(item.value, item);
      optionCache.set(item.value, valueOptions.get(item.value) || prevOptionCache.get(item.value));
    });
    cacheRef.current.values = valueCache;
    cacheRef.current.options = optionCache;
    return patchedValues;
  }, [labeledValues, valueOptions]);
  var getOption = React146.useCallback(function(val) {
    return valueOptions.get(val) || cacheRef.current.options.get(val);
  }, [valueOptions]);
  return [filledLabeledValues, getOption];
};

// ../../node_modules/rc-select/es/hooks/useFilterOptions.js
var React147 = __toESM(require("react"));
function includes(test, search2) {
  return toArray3(test).join("").toUpperCase().includes(search2);
}
var useFilterOptions_default = function(options, fieldNames, searchValue, filterOption, optionFilterProp) {
  return React147.useMemo(function() {
    if (!searchValue || filterOption === false) {
      return options;
    }
    var fieldOptions = fieldNames.options, fieldLabel = fieldNames.label, fieldValue = fieldNames.value;
    var filteredOptions = [];
    var customizeFilter = typeof filterOption === "function";
    var upperSearch = searchValue.toUpperCase();
    var filterFunc = customizeFilter ? filterOption : function(_, option) {
      if (optionFilterProp) {
        return includes(option[optionFilterProp], upperSearch);
      }
      if (option[fieldOptions]) {
        return includes(option[fieldLabel !== "children" ? fieldLabel : "label"], upperSearch);
      }
      return includes(option[fieldValue], upperSearch);
    };
    var wrapOption = customizeFilter ? function(opt) {
      return injectPropsWithOption(opt);
    } : function(opt) {
      return opt;
    };
    options.forEach(function(item) {
      if (item[fieldOptions]) {
        var matchGroup = filterFunc(searchValue, wrapOption(item));
        if (matchGroup) {
          filteredOptions.push(item);
        } else {
          var subOptions = item[fieldOptions].filter(function(subItem) {
            return filterFunc(searchValue, wrapOption(subItem));
          });
          if (subOptions.length) {
            filteredOptions.push(_objectSpread2(_objectSpread2({}, item), {}, _defineProperty({}, fieldOptions, subOptions)));
          }
        }
        return;
      }
      if (filterFunc(searchValue, wrapOption(item))) {
        filteredOptions.push(item);
      }
    });
    return filteredOptions;
  }, [options, filterOption, optionFilterProp, searchValue, fieldNames]);
};

// ../../node_modules/rc-select/es/hooks/useId.js
var React148 = __toESM(require("react"));
var uuid5 = 0;
var isBrowserClient2 = process.env.NODE_ENV !== "test" && canUseDom();
function getUUID() {
  var retId;
  if (isBrowserClient2) {
    retId = uuid5;
    uuid5 += 1;
  } else {
    retId = "TEST_OR_SSR";
  }
  return retId;
}
function useId3(id) {
  var _React$useState = React148.useState(), _React$useState2 = _slicedToArray(_React$useState, 2), innerId = _React$useState2[0], setInnerId = _React$useState2[1];
  React148.useEffect(function() {
    setInnerId("rc_select_".concat(getUUID()));
  }, []);
  return id || innerId;
}

// ../../node_modules/rc-select/es/hooks/useOptions.js
var React150 = __toESM(require("react"));

// ../../node_modules/rc-select/es/utils/legacyUtil.js
var React149 = __toESM(require("react"));
var _excluded18 = ["children", "value"];
var _excluded24 = ["children"];
function convertNodeToOption(node2) {
  var _ref = node2, key = _ref.key, _ref$props = _ref.props, children = _ref$props.children, value = _ref$props.value, restProps = _objectWithoutProperties(_ref$props, _excluded18);
  return _objectSpread2({
    key,
    value: value !== void 0 ? value : key,
    children
  }, restProps);
}
function convertChildrenToData(nodes) {
  var optionOnly = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  return toArray(nodes).map(function(node2, index2) {
    if (!/* @__PURE__ */ React149.isValidElement(node2) || !node2.type) {
      return null;
    }
    var _ref2 = node2, isSelectOptGroup = _ref2.type.isSelectOptGroup, key = _ref2.key, _ref2$props = _ref2.props, children = _ref2$props.children, restProps = _objectWithoutProperties(_ref2$props, _excluded24);
    if (optionOnly || !isSelectOptGroup) {
      return convertNodeToOption(node2);
    }
    return _objectSpread2(_objectSpread2({
      key: "__RC_SELECT_GRP__".concat(key === null ? index2 : key, "__"),
      label: key
    }, restProps), {}, {
      options: convertChildrenToData(children)
    });
  }).filter(function(data) {
    return data;
  });
}

// ../../node_modules/rc-select/es/hooks/useOptions.js
var useOptions = function useOptions2(options, children, fieldNames, optionFilterProp, optionLabelProp) {
  return React150.useMemo(function() {
    var mergedOptions = options;
    var childrenAsData = !options;
    if (childrenAsData) {
      mergedOptions = convertChildrenToData(children);
    }
    var valueOptions = /* @__PURE__ */ new Map();
    var labelOptions = /* @__PURE__ */ new Map();
    var setLabelOptions = function setLabelOptions2(labelOptionsMap, option, key) {
      if (key && typeof key === "string") {
        labelOptionsMap.set(option[key], option);
      }
    };
    var dig = function dig2(optionList) {
      var isChildren = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      for (var i = 0; i < optionList.length; i += 1) {
        var option = optionList[i];
        if (!option[fieldNames.options] || isChildren) {
          valueOptions.set(option[fieldNames.value], option);
          setLabelOptions(labelOptions, option, fieldNames.label);
          setLabelOptions(labelOptions, option, optionFilterProp);
          setLabelOptions(labelOptions, option, optionLabelProp);
        } else {
          dig2(option[fieldNames.options], true);
        }
      }
    };
    dig(mergedOptions);
    return {
      options: mergedOptions,
      valueOptions,
      labelOptions
    };
  }, [options, children, fieldNames, optionFilterProp, optionLabelProp]);
};
var useOptions_default = useOptions;

// ../../node_modules/rc-select/es/hooks/useRefFunc.js
var React151 = __toESM(require("react"));
function useRefFunc(callback) {
  var funcRef = React151.useRef();
  funcRef.current = callback;
  var cacheFn = React151.useCallback(function() {
    return funcRef.current.apply(funcRef, arguments);
  }, []);
  return cacheFn;
}

// ../../node_modules/rc-select/es/utils/warningPropsUtil.js
var React152 = __toESM(require("react"));
function warningProps(props) {
  var mode = props.mode, options = props.options, children = props.children, backfill = props.backfill, allowClear = props.allowClear, placeholder = props.placeholder, getInputElement = props.getInputElement, showSearch = props.showSearch, onSearch = props.onSearch, defaultOpen = props.defaultOpen, autoFocus = props.autoFocus, labelInValue = props.labelInValue, value = props.value, inputValue = props.inputValue, optionLabelProp = props.optionLabelProp;
  var multiple = isMultiple(mode);
  var mergedShowSearch = showSearch !== void 0 ? showSearch : multiple || mode === "combobox";
  var mergedOptions = options || convertChildrenToData(children);
  warning_default(mode !== "tags" || mergedOptions.every(function(opt) {
    return !opt.disabled;
  }), "Please avoid setting option to disabled in tags mode since user can always type text as tag.");
  if (mode === "tags" || mode === "combobox") {
    var hasNumberValue = mergedOptions.some(function(item) {
      if (item.options) {
        return item.options.some(function(opt) {
          return typeof ("value" in opt ? opt.value : opt.key) === "number";
        });
      }
      return typeof ("value" in item ? item.value : item.key) === "number";
    });
    warning_default(!hasNumberValue, "`value` of Option should not use number type when `mode` is `tags` or `combobox`.");
  }
  warning_default(mode !== "combobox" || !optionLabelProp, "`combobox` mode not support `optionLabelProp`. Please set `value` on Option directly.");
  warning_default(mode === "combobox" || !backfill, "`backfill` only works with `combobox` mode.");
  warning_default(mode === "combobox" || !getInputElement, "`getInputElement` only work with `combobox` mode.");
  noteOnce(mode !== "combobox" || !getInputElement || !allowClear || !placeholder, "Customize `getInputElement` should customize clear and placeholder logic instead of configuring `allowClear` and `placeholder`.");
  if (onSearch && !mergedShowSearch && mode !== "combobox" && mode !== "tags") {
    warning_default(false, "`onSearch` should work with `showSearch` instead of use alone.");
  }
  noteOnce(!defaultOpen || autoFocus, "`defaultOpen` makes Select open without focus which means it will not close by click outside. You can set `autoFocus` if needed.");
  if (value !== void 0 && value !== null) {
    var values = toArray3(value);
    warning_default(!labelInValue || values.every(function(val) {
      return _typeof(val) === "object" && ("key" in val || "value" in val);
    }), "`value` should in shape of `{ value: string | number, label?: ReactNode }` when you set `labelInValue` to `true`");
    warning_default(!multiple || Array.isArray(value), "`value` should be array when `mode` is `multiple` or `tags`");
  }
  if (children) {
    var invalidateChildType = null;
    toArray(children).some(function(node2) {
      if (!/* @__PURE__ */ React152.isValidElement(node2) || !node2.type) {
        return false;
      }
      var _ref = node2, type4 = _ref.type;
      if (type4.isSelectOption) {
        return false;
      }
      if (type4.isSelectOptGroup) {
        var allChildrenValid = toArray(node2.props.children).every(function(subNode) {
          if (!/* @__PURE__ */ React152.isValidElement(subNode) || !node2.type || subNode.type.isSelectOption) {
            return true;
          }
          invalidateChildType = subNode.type;
          return false;
        });
        if (allChildrenValid) {
          return false;
        }
        return true;
      }
      invalidateChildType = type4;
      return true;
    });
    if (invalidateChildType) {
      warning_default(false, "`children` should be `Select.Option` or `Select.OptGroup` instead of `".concat(invalidateChildType.displayName || invalidateChildType.name || invalidateChildType, "`."));
    }
    warning_default(inputValue === void 0, "`inputValue` is deprecated, please use `searchValue` instead.");
  }
}
function warningNullOptions(options, fieldNames) {
  if (options) {
    var recursiveOptions = function recursiveOptions2(optionsList) {
      var inGroup = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      for (var i = 0; i < optionsList.length; i++) {
        var option = optionsList[i];
        if (option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.value] === null) {
          warning_default(false, "`value` in Select options should not be `null`.");
          return true;
        }
        if (!inGroup && Array.isArray(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options]) && recursiveOptions2(option[fieldNames === null || fieldNames === void 0 ? void 0 : fieldNames.options], true)) {
          break;
        }
      }
    };
    recursiveOptions(options);
  }
}
var warningPropsUtil_default = warningProps;

// ../../node_modules/rc-select/es/Select.js
var _excluded19 = ["id", "mode", "prefixCls", "backfill", "fieldNames", "inputValue", "searchValue", "onSearch", "autoClearSearchValue", "onSelect", "onDeselect", "dropdownMatchSelectWidth", "filterOption", "filterSort", "optionFilterProp", "optionLabelProp", "options", "optionRender", "children", "defaultActiveFirstOption", "menuItemSelectedIcon", "virtual", "direction", "listHeight", "listItemHeight", "value", "defaultValue", "labelInValue", "onChange", "maxCount"];
var OMIT_DOM_PROPS = ["inputValue"];
function isRawValue(value) {
  return !value || _typeof(value) !== "object";
}
var Select = /* @__PURE__ */ React153.forwardRef(function(props, ref) {
  var id = props.id, mode = props.mode, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-select" : _props$prefixCls, backfill = props.backfill, fieldNames = props.fieldNames, inputValue = props.inputValue, searchValue = props.searchValue, onSearch = props.onSearch, _props$autoClearSearc = props.autoClearSearchValue, autoClearSearchValue = _props$autoClearSearc === void 0 ? true : _props$autoClearSearc, onSelect = props.onSelect, onDeselect = props.onDeselect, _props$dropdownMatchS = props.dropdownMatchSelectWidth, dropdownMatchSelectWidth = _props$dropdownMatchS === void 0 ? true : _props$dropdownMatchS, filterOption = props.filterOption, filterSort = props.filterSort, optionFilterProp = props.optionFilterProp, optionLabelProp = props.optionLabelProp, options = props.options, optionRender = props.optionRender, children = props.children, defaultActiveFirstOption = props.defaultActiveFirstOption, menuItemSelectedIcon = props.menuItemSelectedIcon, virtual = props.virtual, direction = props.direction, _props$listHeight = props.listHeight, listHeight = _props$listHeight === void 0 ? 200 : _props$listHeight, _props$listItemHeight = props.listItemHeight, listItemHeight = _props$listItemHeight === void 0 ? 20 : _props$listItemHeight, value = props.value, defaultValue = props.defaultValue, labelInValue = props.labelInValue, onChange = props.onChange, maxCount = props.maxCount, restProps = _objectWithoutProperties(props, _excluded19);
  var mergedId = useId3(id);
  var multiple = isMultiple(mode);
  var childrenAsData = !!(!options && children);
  var mergedFilterOption = React153.useMemo(function() {
    if (filterOption === void 0 && mode === "combobox") {
      return false;
    }
    return filterOption;
  }, [filterOption, mode]);
  var mergedFieldNames = React153.useMemo(
    function() {
      return fillFieldNames(fieldNames, childrenAsData);
    },
    /* eslint-disable react-hooks/exhaustive-deps */
    [
      // We stringify fieldNames to avoid unnecessary re-renders.
      JSON.stringify(fieldNames),
      childrenAsData
    ]
    /* eslint-enable react-hooks/exhaustive-deps */
  );
  var _useMergedState = useMergedState("", {
    value: searchValue !== void 0 ? searchValue : inputValue,
    postState: function postState(search2) {
      return search2 || "";
    }
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedSearchValue = _useMergedState2[0], setSearchValue = _useMergedState2[1];
  var parsedOptions = useOptions_default(options, children, mergedFieldNames, optionFilterProp, optionLabelProp);
  var valueOptions = parsedOptions.valueOptions, labelOptions = parsedOptions.labelOptions, mergedOptions = parsedOptions.options;
  var convert2LabelValues = React153.useCallback(function(draftValues) {
    var valueList = toArray3(draftValues);
    return valueList.map(function(val) {
      var rawValue;
      var rawLabel;
      var rawKey;
      var rawDisabled;
      var rawTitle;
      if (isRawValue(val)) {
        rawValue = val;
      } else {
        var _val$value;
        rawKey = val.key;
        rawLabel = val.label;
        rawValue = (_val$value = val.value) !== null && _val$value !== void 0 ? _val$value : rawKey;
      }
      var option = valueOptions.get(rawValue);
      if (option) {
        var _option$key;
        if (rawLabel === void 0)
          rawLabel = option === null || option === void 0 ? void 0 : option[optionLabelProp || mergedFieldNames.label];
        if (rawKey === void 0)
          rawKey = (_option$key = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key !== void 0 ? _option$key : rawValue;
        rawDisabled = option === null || option === void 0 ? void 0 : option.disabled;
        rawTitle = option === null || option === void 0 ? void 0 : option.title;
        if (process.env.NODE_ENV !== "production" && !optionLabelProp) {
          var optionLabel = option === null || option === void 0 ? void 0 : option[mergedFieldNames.label];
          if (optionLabel !== void 0 && !/* @__PURE__ */ React153.isValidElement(optionLabel) && !/* @__PURE__ */ React153.isValidElement(rawLabel) && optionLabel !== rawLabel) {
            warning_default(false, "`label` of `value` is not same as `label` in Select options.");
          }
        }
      }
      return {
        label: rawLabel,
        value: rawValue,
        key: rawKey,
        disabled: rawDisabled,
        title: rawTitle
      };
    });
  }, [mergedFieldNames, optionLabelProp, valueOptions]);
  var _useMergedState3 = useMergedState(defaultValue, {
    value
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), internalValue = _useMergedState4[0], setInternalValue = _useMergedState4[1];
  var rawLabeledValues = React153.useMemo(function() {
    var _values$;
    var newInternalValue = multiple && internalValue === null ? [] : internalValue;
    var values = convert2LabelValues(newInternalValue);
    if (mode === "combobox" && isComboNoValue((_values$ = values[0]) === null || _values$ === void 0 ? void 0 : _values$.value)) {
      return [];
    }
    return values;
  }, [internalValue, convert2LabelValues, mode, multiple]);
  var _useCache = useCache_default(rawLabeledValues, valueOptions), _useCache2 = _slicedToArray(_useCache, 2), mergedValues = _useCache2[0], getMixedOption = _useCache2[1];
  var displayValues = React153.useMemo(function() {
    if (!mode && mergedValues.length === 1) {
      var firstValue = mergedValues[0];
      if (firstValue.value === null && (firstValue.label === null || firstValue.label === void 0)) {
        return [];
      }
    }
    return mergedValues.map(function(item) {
      var _item$label;
      return _objectSpread2(_objectSpread2({}, item), {}, {
        label: (_item$label = item.label) !== null && _item$label !== void 0 ? _item$label : item.value
      });
    });
  }, [mode, mergedValues]);
  var rawValues = React153.useMemo(function() {
    return new Set(mergedValues.map(function(val) {
      return val.value;
    }));
  }, [mergedValues]);
  React153.useEffect(function() {
    if (mode === "combobox") {
      var _mergedValues$;
      var strValue = (_mergedValues$ = mergedValues[0]) === null || _mergedValues$ === void 0 ? void 0 : _mergedValues$.value;
      setSearchValue(hasValue2(strValue) ? String(strValue) : "");
    }
  }, [mergedValues]);
  var createTagOption = useRefFunc(function(val, label) {
    var _ref;
    var mergedLabel = label !== null && label !== void 0 ? label : val;
    return _ref = {}, _defineProperty(_ref, mergedFieldNames.value, val), _defineProperty(_ref, mergedFieldNames.label, mergedLabel), _ref;
  });
  var filledTagOptions = React153.useMemo(function() {
    if (mode !== "tags") {
      return mergedOptions;
    }
    var cloneOptions = _toConsumableArray(mergedOptions);
    var existOptions = function existOptions2(val) {
      return valueOptions.has(val);
    };
    _toConsumableArray(mergedValues).sort(function(a, b) {
      return a.value < b.value ? -1 : 1;
    }).forEach(function(item) {
      var val = item.value;
      if (!existOptions(val)) {
        cloneOptions.push(createTagOption(val, item.label));
      }
    });
    return cloneOptions;
  }, [createTagOption, mergedOptions, valueOptions, mergedValues, mode]);
  var filteredOptions = useFilterOptions_default(filledTagOptions, mergedFieldNames, mergedSearchValue, mergedFilterOption, optionFilterProp);
  var filledSearchOptions = React153.useMemo(function() {
    if (mode !== "tags" || !mergedSearchValue || filteredOptions.some(function(item) {
      return item[optionFilterProp || "value"] === mergedSearchValue;
    })) {
      return filteredOptions;
    }
    if (filteredOptions.some(function(item) {
      return item[mergedFieldNames.value] === mergedSearchValue;
    })) {
      return filteredOptions;
    }
    return [createTagOption(mergedSearchValue)].concat(_toConsumableArray(filteredOptions));
  }, [createTagOption, optionFilterProp, mode, filteredOptions, mergedSearchValue, mergedFieldNames]);
  var orderedFilteredOptions = React153.useMemo(function() {
    if (!filterSort) {
      return filledSearchOptions;
    }
    return _toConsumableArray(filledSearchOptions).sort(function(a, b) {
      return filterSort(a, b);
    });
  }, [filledSearchOptions, filterSort]);
  var displayOptions = React153.useMemo(function() {
    return flattenOptions(orderedFilteredOptions, {
      fieldNames: mergedFieldNames,
      childrenAsData
    });
  }, [orderedFilteredOptions, mergedFieldNames, childrenAsData]);
  var triggerChange = function triggerChange2(values) {
    var labeledValues = convert2LabelValues(values);
    setInternalValue(labeledValues);
    if (onChange && // Trigger event only when value changed
    (labeledValues.length !== mergedValues.length || labeledValues.some(function(newVal, index2) {
      var _mergedValues$index;
      return ((_mergedValues$index = mergedValues[index2]) === null || _mergedValues$index === void 0 ? void 0 : _mergedValues$index.value) !== (newVal === null || newVal === void 0 ? void 0 : newVal.value);
    }))) {
      var returnValues = labelInValue ? labeledValues : labeledValues.map(function(v) {
        return v.value;
      });
      var returnOptions = labeledValues.map(function(v) {
        return injectPropsWithOption(getMixedOption(v.value));
      });
      onChange(
        // Value
        multiple ? returnValues : returnValues[0],
        // Option
        multiple ? returnOptions : returnOptions[0]
      );
    }
  };
  var _React$useState = React153.useState(null), _React$useState2 = _slicedToArray(_React$useState, 2), activeValue = _React$useState2[0], setActiveValue = _React$useState2[1];
  var _React$useState3 = React153.useState(0), _React$useState4 = _slicedToArray(_React$useState3, 2), accessibilityIndex = _React$useState4[0], setAccessibilityIndex = _React$useState4[1];
  var mergedDefaultActiveFirstOption = defaultActiveFirstOption !== void 0 ? defaultActiveFirstOption : mode !== "combobox";
  var onActiveValue = React153.useCallback(function(active, index2) {
    var _ref2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, _ref2$source = _ref2.source, source = _ref2$source === void 0 ? "keyboard" : _ref2$source;
    setAccessibilityIndex(index2);
    if (backfill && mode === "combobox" && active !== null && source === "keyboard") {
      setActiveValue(String(active));
    }
  }, [backfill, mode]);
  var triggerSelect = function triggerSelect2(val, selected, type4) {
    var getSelectEnt = function getSelectEnt2() {
      var _option$key2;
      var option = getMixedOption(val);
      return [labelInValue ? {
        label: option === null || option === void 0 ? void 0 : option[mergedFieldNames.label],
        value: val,
        key: (_option$key2 = option === null || option === void 0 ? void 0 : option.key) !== null && _option$key2 !== void 0 ? _option$key2 : val
      } : val, injectPropsWithOption(option)];
    };
    if (selected && onSelect) {
      var _getSelectEnt = getSelectEnt(), _getSelectEnt2 = _slicedToArray(_getSelectEnt, 2), wrappedValue = _getSelectEnt2[0], _option = _getSelectEnt2[1];
      onSelect(wrappedValue, _option);
    } else if (!selected && onDeselect && type4 !== "clear") {
      var _getSelectEnt3 = getSelectEnt(), _getSelectEnt4 = _slicedToArray(_getSelectEnt3, 2), _wrappedValue = _getSelectEnt4[0], _option2 = _getSelectEnt4[1];
      onDeselect(_wrappedValue, _option2);
    }
  };
  var onInternalSelect = useRefFunc(function(val, info) {
    var cloneValues;
    var mergedSelect = multiple ? info.selected : true;
    if (mergedSelect) {
      cloneValues = multiple ? [].concat(_toConsumableArray(mergedValues), [val]) : [val];
    } else {
      cloneValues = mergedValues.filter(function(v) {
        return v.value !== val;
      });
    }
    triggerChange(cloneValues);
    triggerSelect(val, mergedSelect);
    if (mode === "combobox") {
      setActiveValue("");
    } else if (!isMultiple || autoClearSearchValue) {
      setSearchValue("");
      setActiveValue("");
    }
  });
  var onDisplayValuesChange = function onDisplayValuesChange2(nextValues, info) {
    triggerChange(nextValues);
    var type4 = info.type, values = info.values;
    if (type4 === "remove" || type4 === "clear") {
      values.forEach(function(item) {
        triggerSelect(item.value, false, type4);
      });
    }
  };
  var onInternalSearch = function onInternalSearch2(searchText, info) {
    setSearchValue(searchText);
    setActiveValue(null);
    if (info.source === "submit") {
      var formatted = (searchText || "").trim();
      if (formatted) {
        var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues), [formatted])));
        triggerChange(newRawValues);
        triggerSelect(formatted, true);
        setSearchValue("");
      }
      return;
    }
    if (info.source !== "blur") {
      if (mode === "combobox") {
        triggerChange(searchText);
      }
      onSearch === null || onSearch === void 0 || onSearch(searchText);
    }
  };
  var onInternalSearchSplit = function onInternalSearchSplit2(words) {
    var patchValues = words;
    if (mode !== "tags") {
      patchValues = words.map(function(word) {
        var opt = labelOptions.get(word);
        return opt === null || opt === void 0 ? void 0 : opt.value;
      }).filter(function(val) {
        return val !== void 0;
      });
    }
    var newRawValues = Array.from(new Set([].concat(_toConsumableArray(rawValues), _toConsumableArray(patchValues))));
    triggerChange(newRawValues);
    newRawValues.forEach(function(newRawValue) {
      triggerSelect(newRawValue, true);
    });
  };
  var selectContext = React153.useMemo(function() {
    var realVirtual = virtual !== false && dropdownMatchSelectWidth !== false;
    return _objectSpread2(_objectSpread2({}, parsedOptions), {}, {
      flattenOptions: displayOptions,
      onActiveValue,
      defaultActiveFirstOption: mergedDefaultActiveFirstOption,
      onSelect: onInternalSelect,
      menuItemSelectedIcon,
      rawValues,
      fieldNames: mergedFieldNames,
      virtual: realVirtual,
      direction,
      listHeight,
      listItemHeight,
      childrenAsData,
      maxCount,
      optionRender
    });
  }, [maxCount, parsedOptions, displayOptions, onActiveValue, mergedDefaultActiveFirstOption, onInternalSelect, menuItemSelectedIcon, rawValues, mergedFieldNames, virtual, dropdownMatchSelectWidth, direction, listHeight, listItemHeight, childrenAsData, optionRender]);
  if (process.env.NODE_ENV !== "production") {
    warningPropsUtil_default(props);
    warningNullOptions(mergedOptions, mergedFieldNames);
  }
  return /* @__PURE__ */ React153.createElement(SelectContext_default.Provider, {
    value: selectContext
  }, /* @__PURE__ */ React153.createElement(BaseSelect_default, _extends({}, restProps, {
    // >>> MISC
    id: mergedId,
    prefixCls,
    ref,
    omitDomProps: OMIT_DOM_PROPS,
    mode,
    displayValues,
    onDisplayValuesChange,
    direction,
    searchValue: mergedSearchValue,
    onSearch: onInternalSearch,
    autoClearSearchValue,
    onSearchSplit: onInternalSearchSplit,
    dropdownMatchSelectWidth,
    OptionList: OptionList_default,
    emptyOptions: !displayOptions.length,
    activeValue,
    activeDescendantId: "".concat(mergedId, "_list_").concat(accessibilityIndex)
  })));
});
if (process.env.NODE_ENV !== "production") {
  Select.displayName = "Select";
}
var TypedSelect = Select;
TypedSelect.Option = Option_default;
TypedSelect.OptGroup = OptGroup_default;
var Select_default = TypedSelect;

// ../../node_modules/rc-select/es/index.js
var es_default8 = Select_default;

// ../../node_modules/antd/es/_util/statusUtils.js
var import_classnames38 = __toESM(require_classnames());
function getStatusClassNames(prefixCls, status, hasFeedback) {
  return (0, import_classnames38.default)({
    [`${prefixCls}-status-success`]: status === "success",
    [`${prefixCls}-status-warning`]: status === "warning",
    [`${prefixCls}-status-error`]: status === "error",
    [`${prefixCls}-status-validating`]: status === "validating",
    [`${prefixCls}-has-feedback`]: hasFeedback
  });
}
var getMergedStatus = (contextStatus, customStatus) => customStatus || contextStatus;

// ../../node_modules/antd/es/config-provider/defaultRenderEmpty.js
var import_react55 = __toESM(require("react"));

// ../../node_modules/antd/es/empty/index.js
var import_classnames39 = __toESM(require_classnames());
var React156 = __toESM(require("react"));

// ../../node_modules/antd/es/empty/empty.js
var React154 = __toESM(require("react"));
var Empty2 = () => {
  const [, token2] = useToken();
  const bgColor = new TinyColor(token2.colorBgBase);
  const themeStyle = bgColor.toHsl().l < 0.5 ? {
    opacity: 0.65
  } : {};
  return /* @__PURE__ */ React154.createElement("svg", {
    style: themeStyle,
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React154.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React154.createElement("g", {
    transform: "translate(24 31.67)"
  }, /* @__PURE__ */ React154.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /* @__PURE__ */ React154.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /* @__PURE__ */ React154.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /* @__PURE__ */ React154.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /* @__PURE__ */ React154.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /* @__PURE__ */ React154.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /* @__PURE__ */ React154.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /* @__PURE__ */ React154.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /* @__PURE__ */ React154.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};
if (process.env.NODE_ENV !== "production") {
  Empty2.displayName = "EmptyImage";
}
var empty_default = Empty2;

// ../../node_modules/antd/es/empty/simple.js
var React155 = __toESM(require("react"));
var import_react54 = require("react");
var Simple = () => {
  const [, token2] = useToken();
  const {
    colorFill,
    colorFillTertiary,
    colorFillQuaternary,
    colorBgContainer
  } = token2;
  const {
    borderColor,
    shadowColor,
    contentColor
  } = (0, import_react54.useMemo)(() => ({
    borderColor: new TinyColor(colorFill).onBackground(colorBgContainer).toHexShortString(),
    shadowColor: new TinyColor(colorFillTertiary).onBackground(colorBgContainer).toHexShortString(),
    contentColor: new TinyColor(colorFillQuaternary).onBackground(colorBgContainer).toHexShortString()
  }), [colorFill, colorFillTertiary, colorFillQuaternary, colorBgContainer]);
  return /* @__PURE__ */ React155.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /* @__PURE__ */ React155.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /* @__PURE__ */ React155.createElement("ellipse", {
    fill: shadowColor,
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /* @__PURE__ */ React155.createElement("g", {
    fillRule: "nonzero",
    stroke: borderColor
  }, /* @__PURE__ */ React155.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /* @__PURE__ */ React155.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: contentColor
  }))));
};
if (process.env.NODE_ENV !== "production") {
  Simple.displayName = "SimpleImage";
}
var simple_default = Simple;

// ../../node_modules/antd/es/empty/style/index.js
var genSharedEmptyStyle = (token2) => {
  const {
    componentCls,
    margin,
    marginXS,
    marginXL,
    fontSize,
    lineHeight
  } = token2;
  return {
    [componentCls]: {
      marginInline: marginXS,
      fontSize,
      lineHeight,
      textAlign: "center",
      // 原来 &-image 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${componentCls}-image`]: {
        height: token2.emptyImgHeight,
        marginBottom: marginXS,
        opacity: token2.opacityImage,
        img: {
          height: "100%"
        },
        svg: {
          maxWidth: "100%",
          height: "100%",
          margin: "auto"
        }
      },
      [`${componentCls}-description`]: {
        color: token2.colorText
      },
      // 原来 &-footer 没有父子结构，现在为了外层承担我们的hashId，改成父子结果
      [`${componentCls}-footer`]: {
        marginTop: margin
      },
      "&-normal": {
        marginBlock: marginXL,
        color: token2.colorTextDisabled,
        [`${componentCls}-description`]: {
          color: token2.colorTextDisabled
        },
        [`${componentCls}-image`]: {
          height: token2.emptyImgHeightMD
        }
      },
      "&-small": {
        marginBlock: marginXS,
        color: token2.colorTextDisabled,
        [`${componentCls}-image`]: {
          height: token2.emptyImgHeightSM
        }
      }
    }
  };
};
var style_default6 = genStyleHooks("Empty", (token2) => {
  const {
    componentCls,
    controlHeightLG,
    calc
  } = token2;
  const emptyToken = merge2(token2, {
    emptyImgCls: `${componentCls}-img`,
    emptyImgHeight: calc(controlHeightLG).mul(2.5).equal(),
    emptyImgHeightMD: controlHeightLG,
    emptyImgHeightSM: calc(controlHeightLG).mul(0.875).equal()
  });
  return [genSharedEmptyStyle(emptyToken)];
});

// ../../node_modules/antd/es/empty/index.js
var __rest13 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var defaultEmptyImg = /* @__PURE__ */ React156.createElement(empty_default, null);
var simpleEmptyImg = /* @__PURE__ */ React156.createElement(simple_default, null);
var Empty3 = (_a) => {
  var {
    className,
    rootClassName,
    prefixCls: customizePrefixCls,
    image = defaultEmptyImg,
    description,
    children,
    imageStyle,
    style: style2
  } = _a, restProps = __rest13(_a, ["className", "rootClassName", "prefixCls", "image", "description", "children", "imageStyle", "style"]);
  const {
    getPrefixCls,
    direction,
    empty
  } = React156.useContext(ConfigContext);
  const prefixCls = getPrefixCls("empty", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default6(prefixCls);
  const [locale6] = useLocale_default("Empty");
  const des = typeof description !== "undefined" ? description : locale6 === null || locale6 === void 0 ? void 0 : locale6.description;
  const alt = typeof des === "string" ? des : "empty";
  let imageNode = null;
  if (typeof image === "string") {
    imageNode = /* @__PURE__ */ React156.createElement("img", {
      alt,
      src: image
    });
  } else {
    imageNode = image;
  }
  return wrapCSSVar(/* @__PURE__ */ React156.createElement("div", Object.assign({
    className: (0, import_classnames39.default)(hashId, cssVarCls, prefixCls, empty === null || empty === void 0 ? void 0 : empty.className, {
      [`${prefixCls}-normal`]: image === simpleEmptyImg,
      [`${prefixCls}-rtl`]: direction === "rtl"
    }, className, rootClassName),
    style: Object.assign(Object.assign({}, empty === null || empty === void 0 ? void 0 : empty.style), style2)
  }, restProps), /* @__PURE__ */ React156.createElement("div", {
    className: `${prefixCls}-image`,
    style: imageStyle
  }, imageNode), des && /* @__PURE__ */ React156.createElement("div", {
    className: `${prefixCls}-description`
  }, des), children && /* @__PURE__ */ React156.createElement("div", {
    className: `${prefixCls}-footer`
  }, children)));
};
Empty3.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty3.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
if (process.env.NODE_ENV !== "production") {
  Empty3.displayName = "Empty";
}
var empty_default2 = Empty3;

// ../../node_modules/antd/es/config-provider/defaultRenderEmpty.js
var DefaultRenderEmpty = (props) => {
  const {
    componentName
  } = props;
  const {
    getPrefixCls
  } = (0, import_react55.useContext)(ConfigContext);
  const prefix = getPrefixCls("empty");
  switch (componentName) {
    case "Table":
    case "List":
      return /* @__PURE__ */ import_react55.default.createElement(empty_default2, {
        image: empty_default2.PRESENTED_IMAGE_SIMPLE
      });
    case "Select":
    case "TreeSelect":
    case "Cascader":
    case "Transfer":
    case "Mentions":
      return /* @__PURE__ */ import_react55.default.createElement(empty_default2, {
        image: empty_default2.PRESENTED_IMAGE_SIMPLE,
        className: `${prefix}-small`
      });
    default:
      return /* @__PURE__ */ import_react55.default.createElement(empty_default2, null);
  }
};
var defaultRenderEmpty_default = DefaultRenderEmpty;

// ../../node_modules/antd/es/form/hooks/useVariants.js
var import_react56 = require("react");
var Variants = ["outlined", "borderless", "filled"];
var useVariant = function(variant) {
  let legacyBordered = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
  const ctxVariant = (0, import_react56.useContext)(VariantContext);
  let mergedVariant;
  if (typeof variant !== "undefined") {
    mergedVariant = variant;
  } else if (legacyBordered === false) {
    mergedVariant = "borderless";
  } else {
    mergedVariant = ctxVariant !== null && ctxVariant !== void 0 ? ctxVariant : "outlined";
  }
  const enableVariantCls = Variants.includes(mergedVariant);
  return [mergedVariant, enableVariantCls];
};
var useVariants_default = useVariant;

// ../../node_modules/antd/es/select/mergedBuiltinPlacements.js
var getBuiltInPlacements3 = (popupOverflow) => {
  const htmlRegion = popupOverflow === "scroll" ? "scroll" : "visible";
  const sharedConfig = {
    overflow: {
      adjustX: true,
      adjustY: true,
      shiftY: true
    },
    htmlRegion,
    dynamicInset: true
  };
  return {
    bottomLeft: Object.assign(Object.assign({}, sharedConfig), {
      points: ["tl", "bl"],
      offset: [0, 4]
    }),
    bottomRight: Object.assign(Object.assign({}, sharedConfig), {
      points: ["tr", "br"],
      offset: [0, 4]
    }),
    topLeft: Object.assign(Object.assign({}, sharedConfig), {
      points: ["bl", "tl"],
      offset: [0, -4]
    }),
    topRight: Object.assign(Object.assign({}, sharedConfig), {
      points: ["br", "tr"],
      offset: [0, -4]
    })
  };
};
function mergedBuiltinPlacements(buildInPlacements, popupOverflow) {
  return buildInPlacements || getBuiltInPlacements3(popupOverflow);
}
var mergedBuiltinPlacements_default = mergedBuiltinPlacements;

// ../../node_modules/antd/es/select/style/dropdown.js
var genItemStyle = (token2) => {
  const {
    optionHeight,
    optionFontSize,
    optionLineHeight,
    optionPadding
  } = token2;
  return {
    position: "relative",
    display: "block",
    minHeight: optionHeight,
    padding: optionPadding,
    color: token2.colorText,
    fontWeight: "normal",
    fontSize: optionFontSize,
    lineHeight: optionLineHeight,
    boxSizing: "border-box"
  };
};
var genSingleStyle = (token2) => {
  const {
    antCls,
    componentCls
  } = token2;
  const selectItemCls = `${componentCls}-item`;
  const slideUpEnterActive = `&${antCls}-slide-up-enter${antCls}-slide-up-enter-active`;
  const slideUpAppearActive = `&${antCls}-slide-up-appear${antCls}-slide-up-appear-active`;
  const slideUpLeaveActive = `&${antCls}-slide-up-leave${antCls}-slide-up-leave-active`;
  const dropdownPlacementCls = `${componentCls}-dropdown-placement-`;
  return [
    {
      [`${componentCls}-dropdown`]: Object.assign(Object.assign({}, resetComponent(token2)), {
        position: "absolute",
        top: -9999,
        zIndex: token2.zIndexPopup,
        boxSizing: "border-box",
        padding: token2.paddingXXS,
        overflow: "hidden",
        fontSize: token2.fontSize,
        // Fix select render lag of long text in chrome
        // https://github.com/ant-design/ant-design/issues/11456
        // https://github.com/ant-design/ant-design/issues/11843
        fontVariant: "initial",
        backgroundColor: token2.colorBgElevated,
        borderRadius: token2.borderRadiusLG,
        outline: "none",
        boxShadow: token2.boxShadowSecondary,
        [`
          ${slideUpEnterActive}${dropdownPlacementCls}bottomLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}bottomLeft
        `]: {
          animationName: slideUpIn
        },
        [`
          ${slideUpEnterActive}${dropdownPlacementCls}topLeft,
          ${slideUpAppearActive}${dropdownPlacementCls}topLeft,
          ${slideUpEnterActive}${dropdownPlacementCls}topRight,
          ${slideUpAppearActive}${dropdownPlacementCls}topRight
        `]: {
          animationName: slideDownIn
        },
        [`${slideUpLeaveActive}${dropdownPlacementCls}bottomLeft`]: {
          animationName: slideUpOut
        },
        [`
          ${slideUpLeaveActive}${dropdownPlacementCls}topLeft,
          ${slideUpLeaveActive}${dropdownPlacementCls}topRight
        `]: {
          animationName: slideDownOut
        },
        "&-hidden": {
          display: "none"
        },
        [`${selectItemCls}`]: Object.assign(Object.assign({}, genItemStyle(token2)), {
          cursor: "pointer",
          transition: `background ${token2.motionDurationSlow} ease`,
          borderRadius: token2.borderRadiusSM,
          // =========== Group ============
          "&-group": {
            color: token2.colorTextDescription,
            fontSize: token2.fontSizeSM,
            cursor: "default"
          },
          // =========== Option ===========
          "&-option": {
            display: "flex",
            "&-content": Object.assign({
              flex: "auto"
            }, textEllipsis),
            "&-state": {
              flex: "none",
              display: "flex",
              alignItems: "center"
            },
            [`&-active:not(${selectItemCls}-option-disabled)`]: {
              backgroundColor: token2.optionActiveBg
            },
            [`&-selected:not(${selectItemCls}-option-disabled)`]: {
              color: token2.optionSelectedColor,
              fontWeight: token2.optionSelectedFontWeight,
              backgroundColor: token2.optionSelectedBg,
              [`${selectItemCls}-option-state`]: {
                color: token2.colorPrimary
              },
              [`&:has(+ ${selectItemCls}-option-selected:not(${selectItemCls}-option-disabled))`]: {
                borderEndStartRadius: 0,
                borderEndEndRadius: 0,
                [`& + ${selectItemCls}-option-selected:not(${selectItemCls}-option-disabled)`]: {
                  borderStartStartRadius: 0,
                  borderStartEndRadius: 0
                }
              }
            },
            "&-disabled": {
              [`&${selectItemCls}-option-selected`]: {
                backgroundColor: token2.colorBgContainerDisabled
              },
              color: token2.colorTextDisabled,
              cursor: "not-allowed"
            },
            "&-grouped": {
              paddingInlineStart: token2.calc(token2.controlPaddingHorizontal).mul(2).equal()
            }
          }
        }),
        // =========================== RTL ===========================
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Follow code may reuse in other components
    initSlideMotion(token2, "slide-up"),
    initSlideMotion(token2, "slide-down"),
    initMoveMotion(token2, "move-up"),
    initMoveMotion(token2, "move-down")
  ];
};
var dropdown_default = genSingleStyle;

// ../../node_modules/antd/es/select/style/multiple.js
var FIXED_ITEM_MARGIN = 2;
var getSelectItemStyle = (token2) => {
  const {
    multipleSelectItemHeight,
    selectHeight,
    lineWidth
  } = token2;
  const selectItemDist = token2.calc(selectHeight).sub(multipleSelectItemHeight).div(2).sub(lineWidth).equal();
  return selectItemDist;
};
function genSizeStyle(token2, suffix) {
  const {
    componentCls,
    iconCls
  } = token2;
  const selectOverflowPrefixCls = `${componentCls}-selection-overflow`;
  const selectItemHeight = token2.multipleSelectItemHeight;
  const selectItemDist = getSelectItemStyle(token2);
  const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
  return {
    [`${componentCls}-multiple${suffixCls}`]: {
      fontSize: token2.fontSize,
      /**
       * Do not merge `height` & `line-height` under style with `selection` & `search`, since chrome
       * may update to redesign with its align logic.
       */
      // =========================== Overflow ===========================
      [selectOverflowPrefixCls]: {
        position: "relative",
        display: "flex",
        flex: "auto",
        flexWrap: "wrap",
        maxWidth: "100%",
        "&-item": {
          flex: "none",
          alignSelf: "center",
          maxWidth: "100%",
          display: "inline-flex"
        }
      },
      // ========================= Selector =========================
      [`${componentCls}-selector`]: {
        display: "flex",
        flexWrap: "wrap",
        alignItems: "center",
        height: "100%",
        // Multiple is little different that horizontal is follow the vertical
        paddingInline: token2.calc(FIXED_ITEM_MARGIN).mul(2).equal(),
        paddingBlock: token2.calc(selectItemDist).sub(FIXED_ITEM_MARGIN).equal(),
        borderRadius: token2.borderRadius,
        [`${componentCls}-show-search&`]: {
          cursor: "text"
        },
        [`${componentCls}-disabled&`]: {
          background: token2.multipleSelectorBgDisabled,
          cursor: "not-allowed"
        },
        "&:after": {
          display: "inline-block",
          width: 0,
          margin: `${unit(FIXED_ITEM_MARGIN)} 0`,
          lineHeight: unit(selectItemHeight),
          visibility: "hidden",
          content: '"\\a0"'
        }
      },
      [`
        &${componentCls}-show-arrow ${componentCls}-selector,
        &${componentCls}-allow-clear ${componentCls}-selector
      `]: {
        paddingInlineEnd: token2.calc(token2.fontSizeIcon).add(token2.controlPaddingHorizontal).equal()
      },
      // ======================== Selections ========================
      [`${componentCls}-selection-item`]: {
        display: "flex",
        alignSelf: "center",
        flex: "none",
        boxSizing: "border-box",
        maxWidth: "100%",
        height: selectItemHeight,
        marginTop: FIXED_ITEM_MARGIN,
        marginBottom: FIXED_ITEM_MARGIN,
        lineHeight: unit(token2.calc(selectItemHeight).sub(token2.calc(token2.lineWidth).mul(2)).equal()),
        borderRadius: token2.borderRadiusSM,
        cursor: "default",
        transition: `font-size ${token2.motionDurationSlow}, line-height ${token2.motionDurationSlow}, height ${token2.motionDurationSlow}`,
        marginInlineEnd: token2.calc(FIXED_ITEM_MARGIN).mul(2).equal(),
        paddingInlineStart: token2.paddingXS,
        paddingInlineEnd: token2.calc(token2.paddingXS).div(2).equal(),
        [`${componentCls}-disabled&`]: {
          color: token2.multipleItemColorDisabled,
          borderColor: token2.multipleItemBorderColorDisabled,
          cursor: "not-allowed"
        },
        // It's ok not to do this, but 24px makes bottom narrow in view should adjust
        "&-content": {
          display: "inline-block",
          marginInlineEnd: token2.calc(token2.paddingXS).div(2).equal(),
          overflow: "hidden",
          whiteSpace: "pre",
          // fix whitespace wrapping. custom tags display all whitespace within.
          textOverflow: "ellipsis"
        },
        "&-remove": Object.assign(Object.assign({}, resetIcon()), {
          display: "inline-flex",
          alignItems: "center",
          color: token2.colorIcon,
          fontWeight: "bold",
          fontSize: 10,
          lineHeight: "inherit",
          cursor: "pointer",
          [`> ${iconCls}`]: {
            verticalAlign: "-0.2em"
          },
          "&:hover": {
            color: token2.colorIconHover
          }
        })
      },
      // ========================== Input ==========================
      [`${selectOverflowPrefixCls}-item + ${selectOverflowPrefixCls}-item`]: {
        [`${componentCls}-selection-search`]: {
          marginInlineStart: 0
        }
      },
      // https://github.com/ant-design/ant-design/issues/44754
      [`${selectOverflowPrefixCls}-item-suffix`]: {
        height: "100%"
      },
      [`${componentCls}-selection-search`]: {
        display: "inline-flex",
        position: "relative",
        maxWidth: "100%",
        marginInlineStart: token2.calc(token2.inputPaddingHorizontalBase).sub(selectItemDist).equal(),
        [`
          &-input,
          &-mirror
        `]: {
          height: selectItemHeight,
          fontFamily: token2.fontFamily,
          lineHeight: unit(selectItemHeight),
          transition: `all ${token2.motionDurationSlow}`
        },
        "&-input": {
          width: "100%",
          minWidth: 4.1
          // fix search cursor missing
        },
        "&-mirror": {
          position: "absolute",
          top: 0,
          insetInlineStart: 0,
          insetInlineEnd: "auto",
          zIndex: 999,
          whiteSpace: "pre",
          // fix whitespace wrapping caused width calculation bug
          visibility: "hidden"
        }
      },
      // ======================= Placeholder =======================
      [`${componentCls}-selection-placeholder`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: token2.inputPaddingHorizontalBase,
        insetInlineEnd: token2.inputPaddingHorizontalBase,
        transform: "translateY(-50%)",
        transition: `all ${token2.motionDurationSlow}`
      }
    }
  };
}
var genMultipleStyle = (token2) => {
  const {
    componentCls
  } = token2;
  const smallToken = merge2(token2, {
    selectHeight: token2.controlHeightSM,
    multipleSelectItemHeight: token2.controlHeightXS,
    borderRadius: token2.borderRadiusSM,
    borderRadiusSM: token2.borderRadiusXS
  });
  const largeToken = merge2(token2, {
    fontSize: token2.fontSizeLG,
    selectHeight: token2.controlHeightLG,
    multipleSelectItemHeight: token2.multipleItemHeightLG,
    borderRadius: token2.borderRadiusLG,
    borderRadiusSM: token2.borderRadius
  });
  return [
    genSizeStyle(token2),
    // ======================== Small ========================
    genSizeStyle(smallToken, "sm"),
    // Padding
    {
      [`${componentCls}-multiple${componentCls}-sm`]: {
        [`${componentCls}-selection-placeholder`]: {
          insetInline: token2.calc(token2.controlPaddingHorizontalSM).sub(token2.lineWidth).equal()
        },
        // https://github.com/ant-design/ant-design/issues/29559
        [`${componentCls}-selection-search`]: {
          marginInlineStart: 2
          // Magic Number
        }
      }
    },
    // ======================== Large ========================
    genSizeStyle(largeToken, "lg")
  ];
};
var multiple_default = genMultipleStyle;

// ../../node_modules/antd/es/select/style/single.js
function genSizeStyle2(token2, suffix) {
  const {
    componentCls,
    inputPaddingHorizontalBase,
    borderRadius
  } = token2;
  const selectHeightWithoutBorder = token2.calc(token2.controlHeight).sub(token2.calc(token2.lineWidth).mul(2)).equal();
  const suffixCls = suffix ? `${componentCls}-${suffix}` : "";
  return {
    [`${componentCls}-single${suffixCls}`]: {
      fontSize: token2.fontSize,
      height: token2.controlHeight,
      // ========================= Selector =========================
      [`${componentCls}-selector`]: Object.assign(Object.assign({}, resetComponent(token2, true)), {
        display: "flex",
        borderRadius,
        [`${componentCls}-selection-search`]: {
          position: "absolute",
          top: 0,
          insetInlineStart: inputPaddingHorizontalBase,
          insetInlineEnd: inputPaddingHorizontalBase,
          bottom: 0,
          "&-input": {
            width: "100%",
            WebkitAppearance: "textfield"
          }
        },
        [`
          ${componentCls}-selection-item,
          ${componentCls}-selection-placeholder
        `]: {
          padding: 0,
          lineHeight: unit(selectHeightWithoutBorder),
          transition: `all ${token2.motionDurationSlow}, visibility 0s`,
          alignSelf: "center"
        },
        [`${componentCls}-selection-placeholder`]: {
          transition: "none",
          pointerEvents: "none"
        },
        // For common baseline align
        [[
          "&:after",
          /* For '' value baseline align */
          `${componentCls}-selection-item:empty:after`,
          /* For undefined value baseline align */
          `${componentCls}-selection-placeholder:empty:after`
        ].join(",")]: {
          display: "inline-block",
          width: 0,
          visibility: "hidden",
          content: '"\\a0"'
        }
      }),
      [`
        &${componentCls}-show-arrow ${componentCls}-selection-item,
        &${componentCls}-show-arrow ${componentCls}-selection-placeholder
      `]: {
        paddingInlineEnd: token2.showArrowPaddingInlineEnd
      },
      // Opacity selection if open
      [`&${componentCls}-open ${componentCls}-selection-item`]: {
        color: token2.colorTextPlaceholder
      },
      // ========================== Input ==========================
      // We only change the style of non-customize input which is only support by `combobox` mode.
      // Not customize
      [`&:not(${componentCls}-customize-input)`]: {
        [`${componentCls}-selector`]: {
          width: "100%",
          height: "100%",
          padding: `0 ${unit(inputPaddingHorizontalBase)}`,
          [`${componentCls}-selection-search-input`]: {
            height: selectHeightWithoutBorder
          },
          "&:after": {
            lineHeight: unit(selectHeightWithoutBorder)
          }
        }
      },
      [`&${componentCls}-customize-input`]: {
        [`${componentCls}-selector`]: {
          "&:after": {
            display: "none"
          },
          [`${componentCls}-selection-search`]: {
            position: "static",
            width: "100%"
          },
          [`${componentCls}-selection-placeholder`]: {
            position: "absolute",
            insetInlineStart: 0,
            insetInlineEnd: 0,
            padding: `0 ${unit(inputPaddingHorizontalBase)}`,
            "&:after": {
              display: "none"
            }
          }
        }
      }
    }
  };
}
function genSingleStyle2(token2) {
  const {
    componentCls
  } = token2;
  const inputPaddingHorizontalSM = token2.calc(token2.controlPaddingHorizontalSM).sub(token2.lineWidth).equal();
  return [
    genSizeStyle2(token2),
    // ======================== Small ========================
    // Shared
    genSizeStyle2(merge2(token2, {
      controlHeight: token2.controlHeightSM,
      borderRadius: token2.borderRadiusSM
    }), "sm"),
    // padding
    {
      [`${componentCls}-single${componentCls}-sm`]: {
        [`&:not(${componentCls}-customize-input)`]: {
          [`${componentCls}-selection-search`]: {
            insetInlineStart: inputPaddingHorizontalSM,
            insetInlineEnd: inputPaddingHorizontalSM
          },
          [`${componentCls}-selector`]: {
            padding: `0 ${unit(inputPaddingHorizontalSM)}`
          },
          // With arrow should provides `padding-right` to show the arrow
          [`&${componentCls}-show-arrow ${componentCls}-selection-search`]: {
            insetInlineEnd: token2.calc(inputPaddingHorizontalSM).add(token2.calc(token2.fontSize).mul(1.5)).equal()
          },
          [`
            &${componentCls}-show-arrow ${componentCls}-selection-item,
            &${componentCls}-show-arrow ${componentCls}-selection-placeholder
          `]: {
            paddingInlineEnd: token2.calc(token2.fontSize).mul(1.5).equal()
          }
        }
      }
    },
    // ======================== Large ========================
    // Shared
    genSizeStyle2(merge2(token2, {
      controlHeight: token2.singleItemHeightLG,
      fontSize: token2.fontSizeLG,
      borderRadius: token2.borderRadiusLG
    }), "lg")
  ];
}

// ../../node_modules/antd/es/select/style/token.js
var prepareComponentToken5 = (token2) => {
  const {
    fontSize,
    lineHeight,
    controlHeight,
    controlPaddingHorizontal,
    zIndexPopupBase,
    colorText,
    fontWeightStrong,
    controlItemBgActive,
    controlItemBgHover,
    colorBgContainer,
    colorFillSecondary,
    controlHeightLG,
    controlHeightSM,
    colorBgContainerDisabled,
    colorTextDisabled
  } = token2;
  return {
    zIndexPopup: zIndexPopupBase + 50,
    optionSelectedColor: colorText,
    optionSelectedFontWeight: fontWeightStrong,
    optionSelectedBg: controlItemBgActive,
    optionActiveBg: controlItemBgHover,
    optionPadding: `${(controlHeight - fontSize * lineHeight) / 2}px ${controlPaddingHorizontal}px`,
    optionFontSize: fontSize,
    optionLineHeight: lineHeight,
    optionHeight: controlHeight,
    selectorBg: colorBgContainer,
    clearBg: colorBgContainer,
    singleItemHeightLG: controlHeightLG,
    multipleItemBg: colorFillSecondary,
    multipleItemBorderColor: "transparent",
    multipleItemHeight: controlHeightSM,
    multipleItemHeightLG: controlHeight,
    multipleSelectorBgDisabled: colorBgContainerDisabled,
    multipleItemColorDisabled: colorTextDisabled,
    multipleItemBorderColorDisabled: "transparent",
    showArrowPaddingInlineEnd: Math.ceil(token2.fontSize * 1.25)
  };
};

// ../../node_modules/antd/es/select/style/variants.js
var genBaseOutlinedStyle = (token2, options) => {
  const {
    componentCls,
    antCls,
    controlOutlineWidth
  } = token2;
  return {
    [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${options.borderColor}`,
      background: token2.selectorBg
    },
    [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
      [`&:hover ${componentCls}-selector`]: {
        borderColor: options.hoverBorderHover
      },
      [`${componentCls}-focused& ${componentCls}-selector`]: {
        borderColor: options.activeBorderColor,
        boxShadow: `0 0 0 ${unit(controlOutlineWidth)} ${options.activeShadowColor}`,
        outline: 0
      }
    }
  };
};
var genOutlinedStatusStyle = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}`]: Object.assign({}, genBaseOutlinedStyle(token2, options))
});
var genOutlinedStyle = (token2) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseOutlinedStyle(token2, {
    borderColor: token2.colorBorder,
    hoverBorderHover: token2.colorPrimaryHover,
    activeBorderColor: token2.colorPrimary,
    activeShadowColor: token2.controlOutline
  })), genOutlinedStatusStyle(token2, {
    status: "error",
    borderColor: token2.colorError,
    hoverBorderHover: token2.colorErrorHover,
    activeBorderColor: token2.colorError,
    activeShadowColor: token2.colorErrorOutline
  })), genOutlinedStatusStyle(token2, {
    status: "warning",
    borderColor: token2.colorWarning,
    hoverBorderHover: token2.colorWarningHover,
    activeBorderColor: token2.colorWarning,
    activeShadowColor: token2.colorWarningOutline
  })), {
    [`&${token2.componentCls}-disabled`]: {
      [`&:not(${token2.componentCls}-customize-input) ${token2.componentCls}-selector`]: {
        background: token2.colorBgContainerDisabled,
        color: token2.colorTextDisabled
      }
    },
    [`&${token2.componentCls}-multiple ${token2.componentCls}-selection-item`]: {
      background: token2.multipleItemBg,
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.multipleItemBorderColor}`
    }
  })
});
var genBaseFilledStyle = (token2, options) => {
  const {
    componentCls,
    antCls
  } = token2;
  return {
    [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: {
      background: options.bg,
      border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
      color: options.color
    },
    [`&:not(${componentCls}-disabled):not(${componentCls}-customize-input):not(${antCls}-pagination-size-changer)`]: {
      [`&:hover ${componentCls}-selector`]: {
        background: options.hoverBg
      },
      [`${componentCls}-focused& ${componentCls}-selector`]: {
        background: token2.selectorBg,
        borderColor: options.activeBorderColor,
        outline: 0
      }
    }
  };
};
var genFilledStatusStyle = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}`]: Object.assign({}, genBaseFilledStyle(token2, options))
});
var genFilledStyle = (token2) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseFilledStyle(token2, {
    bg: token2.colorFillTertiary,
    hoverBg: token2.colorFillSecondary,
    activeBorderColor: token2.colorPrimary,
    color: token2.colorText
  })), genFilledStatusStyle(token2, {
    status: "error",
    bg: token2.colorErrorBg,
    hoverBg: token2.colorErrorBgHover,
    activeBorderColor: token2.colorError,
    color: token2.colorError
  })), genFilledStatusStyle(token2, {
    status: "warning",
    bg: token2.colorWarningBg,
    hoverBg: token2.colorWarningBgHover,
    activeBorderColor: token2.colorWarning,
    color: token2.colorWarning
  })), {
    [`&${token2.componentCls}-disabled`]: {
      [`&:not(${token2.componentCls}-customize-input) ${token2.componentCls}-selector`]: {
        borderColor: token2.colorBorder,
        background: token2.colorBgContainerDisabled,
        color: token2.colorTextDisabled
      }
    },
    [`&${token2.componentCls}-multiple ${token2.componentCls}-selection-item`]: {
      background: token2.colorBgContainer,
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
    }
  })
});
var genBorderlessStyle = (token2) => ({
  "&-borderless": {
    [`${token2.componentCls}-selector`]: {
      background: "transparent",
      borderColor: "transparent"
    },
    [`&${token2.componentCls}-disabled`]: {
      [`&:not(${token2.componentCls}-customize-input) ${token2.componentCls}-selector`]: {
        color: token2.colorTextDisabled
      }
    },
    [`&${token2.componentCls}-multiple ${token2.componentCls}-selection-item`]: {
      background: token2.multipleItemBg,
      border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.multipleItemBorderColor}`
    }
  }
});
var genVariantsStyle = (token2) => ({
  [token2.componentCls]: Object.assign(Object.assign(Object.assign({}, genOutlinedStyle(token2)), genFilledStyle(token2)), genBorderlessStyle(token2))
});
var variants_default = genVariantsStyle;

// ../../node_modules/antd/es/select/style/index.js
var genSelectorStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    position: "relative",
    transition: `all ${token2.motionDurationMid} ${token2.motionEaseInOut}`,
    input: {
      cursor: "pointer"
    },
    [`${componentCls}-show-search&`]: {
      cursor: "text",
      input: {
        cursor: "auto",
        color: "inherit",
        height: "100%"
      }
    },
    [`${componentCls}-disabled&`]: {
      cursor: "not-allowed",
      input: {
        cursor: "not-allowed"
      }
    }
  };
};
var getSearchInputWithoutBorderStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-selection-search-input`]: {
      margin: 0,
      padding: 0,
      background: "transparent",
      border: "none",
      outline: "none",
      appearance: "none",
      fontFamily: "inherit",
      "&::-webkit-search-cancel-button": {
        display: "none",
        "-webkit-appearance": "none"
      }
    }
  };
};
var genBaseStyle = (token2) => {
  const {
    antCls,
    componentCls,
    inputPaddingHorizontalBase,
    iconCls
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign({}, resetComponent(token2)), {
      position: "relative",
      display: "inline-block",
      cursor: "pointer",
      [`&:not(${componentCls}-customize-input) ${componentCls}-selector`]: Object.assign(Object.assign({}, genSelectorStyle(token2)), getSearchInputWithoutBorderStyle(token2)),
      // ======================== Selection ========================
      [`${componentCls}-selection-item`]: Object.assign(Object.assign({
        flex: 1,
        fontWeight: "normal",
        position: "relative",
        userSelect: "none"
      }, textEllipsis), {
        // https://github.com/ant-design/ant-design/issues/40421
        [`> ${antCls}-typography`]: {
          display: "inline"
        }
      }),
      // ======================= Placeholder =======================
      [`${componentCls}-selection-placeholder`]: Object.assign(Object.assign({}, textEllipsis), {
        flex: 1,
        color: token2.colorTextPlaceholder,
        pointerEvents: "none"
      }),
      // ========================== Arrow ==========================
      [`${componentCls}-arrow`]: Object.assign(Object.assign({}, resetIcon()), {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: inputPaddingHorizontalBase,
        height: token2.fontSizeIcon,
        marginTop: token2.calc(token2.fontSizeIcon).mul(-1).div(2).equal(),
        color: token2.colorTextQuaternary,
        fontSize: token2.fontSizeIcon,
        lineHeight: 1,
        textAlign: "center",
        pointerEvents: "none",
        display: "flex",
        alignItems: "center",
        transition: `opacity ${token2.motionDurationSlow} ease`,
        [iconCls]: {
          verticalAlign: "top",
          transition: `transform ${token2.motionDurationSlow}`,
          "> svg": {
            verticalAlign: "top"
          },
          [`&:not(${componentCls}-suffix)`]: {
            pointerEvents: "auto"
          }
        },
        [`${componentCls}-disabled &`]: {
          cursor: "not-allowed"
        },
        "> *:not(:last-child)": {
          marginInlineEnd: 8
          // FIXME: magic
        }
      }),
      // ========================== Clear ==========================
      [`${componentCls}-clear`]: {
        position: "absolute",
        top: "50%",
        insetInlineStart: "auto",
        insetInlineEnd: inputPaddingHorizontalBase,
        zIndex: 1,
        display: "inline-block",
        width: token2.fontSizeIcon,
        height: token2.fontSizeIcon,
        marginTop: token2.calc(token2.fontSizeIcon).mul(-1).div(2).equal(),
        color: token2.colorTextQuaternary,
        fontSize: token2.fontSizeIcon,
        fontStyle: "normal",
        lineHeight: 1,
        textAlign: "center",
        textTransform: "none",
        cursor: "pointer",
        opacity: 0,
        transition: `color ${token2.motionDurationMid} ease, opacity ${token2.motionDurationSlow} ease`,
        textRendering: "auto",
        "&:before": {
          display: "block"
        },
        "&:hover": {
          color: token2.colorTextTertiary
        }
      },
      "&:hover": {
        [`${componentCls}-clear`]: {
          opacity: 1
        },
        // Should use the following selector, but since `:has` has poor compatibility,
        // we use `:not(:last-child)` instead, which may cause some problems in some cases.
        // [`${componentCls}-arrow:has(+ ${componentCls}-clear)`]: {
        [`${componentCls}-arrow:not(:last-child)`]: {
          opacity: 0
        }
      }
    }),
    // ========================= Feedback ==========================
    [`${componentCls}-has-feedback`]: {
      [`${componentCls}-clear`]: {
        insetInlineEnd: token2.calc(inputPaddingHorizontalBase).add(token2.fontSize).add(token2.paddingXS).equal()
      }
    }
  };
};
var genSelectStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return [
    {
      [componentCls]: {
        // ==================== In Form ====================
        [`&${componentCls}-in-form-item`]: {
          width: "100%"
        }
      }
    },
    // =====================================================
    // ==                       LTR                       ==
    // =====================================================
    // Base
    genBaseStyle(token2),
    // Single
    genSingleStyle2(token2),
    // Multiple
    multiple_default(token2),
    // Dropdown
    dropdown_default(token2),
    // =====================================================
    // ==                       RTL                       ==
    // =====================================================
    {
      [`${componentCls}-rtl`]: {
        direction: "rtl"
      }
    },
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(token2, {
      borderElCls: `${componentCls}-selector`,
      focusElCls: `${componentCls}-focused`
    })
  ];
};
var style_default7 = genStyleHooks("Select", (token2, _ref) => {
  let {
    rootPrefixCls
  } = _ref;
  const selectToken = merge2(token2, {
    rootPrefixCls,
    inputPaddingHorizontalBase: token2.calc(token2.paddingSM).sub(1).equal(),
    multipleSelectItemHeight: token2.multipleItemHeight,
    selectHeight: token2.controlHeight
  });
  return [genSelectStyle(selectToken), variants_default(selectToken)];
}, prepareComponentToken5, {
  unitless: {
    optionLineHeight: true,
    optionSelectedFontWeight: true
  }
});

// ../../node_modules/antd/es/select/useIcons.js
var React161 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons/es/icons/CheckOutlined.js
var React158 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/CheckOutlined.js
var CheckOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 00-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z" } }] }, "name": "check", "theme": "outlined" };
var CheckOutlined_default = CheckOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CheckOutlined.js
var CheckOutlined2 = function CheckOutlined3(props, ref) {
  return /* @__PURE__ */ React158.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: CheckOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  CheckOutlined2.displayName = "CheckOutlined";
}
var CheckOutlined_default2 = /* @__PURE__ */ React158.forwardRef(CheckOutlined2);

// ../../node_modules/@ant-design/icons/es/icons/DownOutlined.js
var React159 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/DownOutlined.js
var DownOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z" } }] }, "name": "down", "theme": "outlined" };
var DownOutlined_default = DownOutlined;

// ../../node_modules/@ant-design/icons/es/icons/DownOutlined.js
var DownOutlined2 = function DownOutlined3(props, ref) {
  return /* @__PURE__ */ React159.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: DownOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  DownOutlined2.displayName = "DownOutlined";
}
var DownOutlined_default2 = /* @__PURE__ */ React159.forwardRef(DownOutlined2);

// ../../node_modules/@ant-design/icons/es/icons/SearchOutlined.js
var React160 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/SearchOutlined.js
var SearchOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0011.6 0l43.6-43.5a8.2 8.2 0 000-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z" } }] }, "name": "search", "theme": "outlined" };
var SearchOutlined_default = SearchOutlined;

// ../../node_modules/@ant-design/icons/es/icons/SearchOutlined.js
var SearchOutlined2 = function SearchOutlined3(props, ref) {
  return /* @__PURE__ */ React160.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: SearchOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  SearchOutlined2.displayName = "SearchOutlined";
}
var SearchOutlined_default2 = /* @__PURE__ */ React160.forwardRef(SearchOutlined2);

// ../../node_modules/antd/es/select/useIcons.js
function useIcons(_ref) {
  let {
    suffixIcon,
    clearIcon,
    menuItemSelectedIcon,
    removeIcon,
    loading,
    multiple,
    hasFeedback,
    prefixCls,
    showSuffixIcon,
    feedbackIcon,
    showArrow,
    componentName
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning(componentName);
    warning6.deprecated(!clearIcon, "clearIcon", "allowClear={{ clearIcon: React.ReactNode }}");
  }
  const mergedClearIcon = clearIcon !== null && clearIcon !== void 0 ? clearIcon : /* @__PURE__ */ React161.createElement(CloseCircleFilled_default2, null);
  const getSuffixIconNode = (arrowIcon) => {
    if (suffixIcon === null && !hasFeedback && !showArrow) {
      return null;
    }
    return /* @__PURE__ */ React161.createElement(React161.Fragment, null, showSuffixIcon !== false && arrowIcon, hasFeedback && feedbackIcon);
  };
  let mergedSuffixIcon = null;
  if (suffixIcon !== void 0) {
    mergedSuffixIcon = getSuffixIconNode(suffixIcon);
  } else if (loading) {
    mergedSuffixIcon = getSuffixIconNode(/* @__PURE__ */ React161.createElement(LoadingOutlined_default2, {
      spin: true
    }));
  } else {
    const iconCls = `${prefixCls}-suffix`;
    mergedSuffixIcon = (_ref2) => {
      let {
        open: open3,
        showSearch
      } = _ref2;
      if (open3 && showSearch) {
        return getSuffixIconNode(/* @__PURE__ */ React161.createElement(SearchOutlined_default2, {
          className: iconCls
        }));
      }
      return getSuffixIconNode(/* @__PURE__ */ React161.createElement(DownOutlined_default2, {
        className: iconCls
      }));
    };
  }
  let mergedItemIcon = null;
  if (menuItemSelectedIcon !== void 0) {
    mergedItemIcon = menuItemSelectedIcon;
  } else if (multiple) {
    mergedItemIcon = /* @__PURE__ */ React161.createElement(CheckOutlined_default2, null);
  } else {
    mergedItemIcon = null;
  }
  let mergedRemoveIcon = null;
  if (removeIcon !== void 0) {
    mergedRemoveIcon = removeIcon;
  } else {
    mergedRemoveIcon = /* @__PURE__ */ React161.createElement(CloseOutlined_default2, null);
  }
  return {
    clearIcon: mergedClearIcon,
    suffixIcon: mergedSuffixIcon,
    itemIcon: mergedItemIcon,
    removeIcon: mergedRemoveIcon
  };
}

// ../../node_modules/antd/es/select/useShowArrow.js
function useShowArrow(suffixIcon, showArrow) {
  return showArrow !== void 0 ? showArrow : suffixIcon !== null;
}

// ../../node_modules/antd/es/select/index.js
var __rest14 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var SECRET_COMBOBOX_MODE_DO_NOT_USE = "SECRET_COMBOBOX_MODE_DO_NOT_USE";
var InternalSelect = (props, ref) => {
  var _a;
  const {
    prefixCls: customizePrefixCls,
    bordered,
    className,
    rootClassName,
    getPopupContainer,
    popupClassName,
    dropdownClassName,
    listHeight = 256,
    placement,
    listItemHeight: customListItemHeight,
    size: customizeSize,
    disabled: customDisabled,
    notFoundContent,
    status: customStatus,
    builtinPlacements,
    dropdownMatchSelectWidth,
    popupMatchSelectWidth,
    direction: propDirection,
    style: style2,
    allowClear,
    variant: customizeVariant,
    dropdownStyle,
    transitionName,
    tagRender,
    maxCount
  } = props, rest = __rest14(props, ["prefixCls", "bordered", "className", "rootClassName", "getPopupContainer", "popupClassName", "dropdownClassName", "listHeight", "placement", "listItemHeight", "size", "disabled", "notFoundContent", "status", "builtinPlacements", "dropdownMatchSelectWidth", "popupMatchSelectWidth", "direction", "style", "allowClear", "variant", "dropdownStyle", "transitionName", "tagRender", "maxCount"]);
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    renderEmpty,
    direction: contextDirection,
    virtual,
    popupMatchSelectWidth: contextPopupMatchSelectWidth,
    popupOverflow,
    select
  } = React162.useContext(ConfigContext);
  const [, token2] = useToken();
  const listItemHeight = customListItemHeight !== null && customListItemHeight !== void 0 ? customListItemHeight : token2 === null || token2 === void 0 ? void 0 : token2.controlHeight;
  const prefixCls = getPrefixCls("select", customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const direction = propDirection !== null && propDirection !== void 0 ? propDirection : contextDirection;
  const {
    compactSize,
    compactItemClassnames
  } = useCompactItemContext(prefixCls, direction);
  const [variant, enableVariantCls] = useVariants_default(customizeVariant, bordered);
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default7(prefixCls, rootCls);
  const mode = React162.useMemo(() => {
    const {
      mode: m
    } = props;
    if (m === "combobox") {
      return void 0;
    }
    if (m === SECRET_COMBOBOX_MODE_DO_NOT_USE) {
      return "combobox";
    }
    return m;
  }, [props.mode]);
  const isMultiple3 = mode === "multiple" || mode === "tags";
  const showSuffixIcon = useShowArrow(props.suffixIcon, props.showArrow);
  const mergedPopupMatchSelectWidth = (_a = popupMatchSelectWidth !== null && popupMatchSelectWidth !== void 0 ? popupMatchSelectWidth : dropdownMatchSelectWidth) !== null && _a !== void 0 ? _a : contextPopupMatchSelectWidth;
  const {
    status: contextStatus,
    hasFeedback,
    isFormItemInput,
    feedbackIcon
  } = React162.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  let mergedNotFound;
  if (notFoundContent !== void 0) {
    mergedNotFound = notFoundContent;
  } else if (mode === "combobox") {
    mergedNotFound = null;
  } else {
    mergedNotFound = (renderEmpty === null || renderEmpty === void 0 ? void 0 : renderEmpty("Select")) || /* @__PURE__ */ React162.createElement(defaultRenderEmpty_default, {
      componentName: "Select"
    });
  }
  const {
    suffixIcon,
    itemIcon,
    removeIcon,
    clearIcon
  } = useIcons(Object.assign(Object.assign({}, rest), {
    multiple: isMultiple3,
    hasFeedback,
    feedbackIcon,
    showSuffixIcon,
    prefixCls,
    componentName: "Select"
  }));
  const mergedAllowClear = allowClear === true ? {
    clearIcon
  } : allowClear;
  const selectProps = omit(rest, ["suffixIcon", "itemIcon"]);
  const mergedPopupClassName = (0, import_classnames40.default)(popupClassName || dropdownClassName, {
    [`${prefixCls}-dropdown-${direction}`]: direction === "rtl"
  }, rootClassName, cssVarCls, rootCls, hashId);
  const mergedSize = useSize_default((ctx) => {
    var _a2;
    return (_a2 = customizeSize !== null && customizeSize !== void 0 ? customizeSize : compactSize) !== null && _a2 !== void 0 ? _a2 : ctx;
  });
  const disabled = React162.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const mergedClassName = (0, import_classnames40.default)({
    [`${prefixCls}-lg`]: mergedSize === "large",
    [`${prefixCls}-sm`]: mergedSize === "small",
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-${variant}`]: enableVariantCls,
    [`${prefixCls}-in-form-item`]: isFormItemInput
  }, getStatusClassNames(prefixCls, mergedStatus, hasFeedback), compactItemClassnames, select === null || select === void 0 ? void 0 : select.className, className, rootClassName, cssVarCls, rootCls, hashId);
  const memoPlacement = React162.useMemo(() => {
    if (placement !== void 0) {
      return placement;
    }
    return direction === "rtl" ? "bottomRight" : "bottomLeft";
  }, [placement, direction]);
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Select");
    warning6.deprecated(!dropdownClassName, "dropdownClassName", "popupClassName");
    warning6.deprecated(dropdownMatchSelectWidth === void 0, "dropdownMatchSelectWidth", "popupMatchSelectWidth");
    process.env.NODE_ENV !== "production" ? warning6(!("showArrow" in props), "deprecated", "`showArrow` is deprecated which will be removed in next major version. It will be a default behavior, you can hide it by setting `suffixIcon` to null.") : void 0;
    warning6.deprecated(!("bordered" in props), "bordered", "variant");
    process.env.NODE_ENV !== "production" ? warning6(!(typeof maxCount !== "undefined" && !isMultiple3), "usage", "`maxCount` only works with mode `multiple` or `tags`") : void 0;
  }
  const [zIndex] = useZIndex("SelectLike", dropdownStyle === null || dropdownStyle === void 0 ? void 0 : dropdownStyle.zIndex);
  return wrapCSSVar(/* @__PURE__ */ React162.createElement(es_default8, Object.assign({
    ref,
    virtual,
    showSearch: select === null || select === void 0 ? void 0 : select.showSearch
  }, selectProps, {
    style: Object.assign(Object.assign({}, select === null || select === void 0 ? void 0 : select.style), style2),
    dropdownMatchSelectWidth: mergedPopupMatchSelectWidth,
    transitionName: getTransitionName2(rootPrefixCls, "slide-up", transitionName),
    builtinPlacements: mergedBuiltinPlacements_default(builtinPlacements, popupOverflow),
    listHeight,
    listItemHeight,
    mode,
    prefixCls,
    placement: memoPlacement,
    direction,
    suffixIcon,
    menuItemSelectedIcon: itemIcon,
    removeIcon,
    allowClear: mergedAllowClear,
    notFoundContent: mergedNotFound,
    className: mergedClassName,
    getPopupContainer: getPopupContainer || getContextPopupContainer,
    dropdownClassName: mergedPopupClassName,
    disabled: mergedDisabled,
    dropdownStyle: Object.assign(Object.assign({}, dropdownStyle), {
      zIndex
    }),
    maxCount: isMultiple3 ? maxCount : void 0,
    tagRender: isMultiple3 ? tagRender : void 0
  })));
};
if (process.env.NODE_ENV !== "production") {
  InternalSelect.displayName = "Select";
}
var Select2 = /* @__PURE__ */ React162.forwardRef(InternalSelect);
var PurePanel3 = PurePanel_default3(Select2);
Select2.SECRET_COMBOBOX_MODE_DO_NOT_USE = SECRET_COMBOBOX_MODE_DO_NOT_USE;
Select2.Option = Option_default;
Select2.OptGroup = OptGroup_default;
Select2._InternalPanelDoNotUseOrYouWillBeFired = PurePanel3;
if (process.env.NODE_ENV !== "production") {
  Select2.displayName = "Select";
}
var select_default = Select2;

// ../../node_modules/antd/es/_util/responsiveObserver.js
var import_react57 = __toESM(require("react"));
var responsiveArray = ["xxl", "xl", "lg", "md", "sm", "xs"];
var getResponsiveMap = (token2) => ({
  xs: `(max-width: ${token2.screenXSMax}px)`,
  sm: `(min-width: ${token2.screenSM}px)`,
  md: `(min-width: ${token2.screenMD}px)`,
  lg: `(min-width: ${token2.screenLG}px)`,
  xl: `(min-width: ${token2.screenXL}px)`,
  xxl: `(min-width: ${token2.screenXXL}px)`
});
var validateBreakpoints = (token2) => {
  const indexableToken = token2;
  const revBreakpoints = [].concat(responsiveArray).reverse();
  revBreakpoints.forEach((breakpoint, i) => {
    const breakpointUpper = breakpoint.toUpperCase();
    const screenMin = `screen${breakpointUpper}Min`;
    const screen = `screen${breakpointUpper}`;
    if (!(indexableToken[screenMin] <= indexableToken[screen])) {
      throw new Error(`${screenMin}<=${screen} fails : !(${indexableToken[screenMin]}<=${indexableToken[screen]})`);
    }
    if (i < revBreakpoints.length - 1) {
      const screenMax = `screen${breakpointUpper}Max`;
      if (!(indexableToken[screen] <= indexableToken[screenMax])) {
        throw new Error(`${screen}<=${screenMax} fails : !(${indexableToken[screen]}<=${indexableToken[screenMax]})`);
      }
      const nextBreakpointUpperMin = revBreakpoints[i + 1].toUpperCase();
      const nextScreenMin = `screen${nextBreakpointUpperMin}Min`;
      if (!(indexableToken[screenMax] <= indexableToken[nextScreenMin])) {
        throw new Error(`${screenMax}<=${nextScreenMin} fails : !(${indexableToken[screenMax]}<=${indexableToken[nextScreenMin]})`);
      }
    }
  });
  return token2;
};
function useResponsiveObserver() {
  const [, token2] = useToken();
  const responsiveMap = getResponsiveMap(validateBreakpoints(token2));
  return import_react57.default.useMemo(() => {
    const subscribers = /* @__PURE__ */ new Map();
    let subUid = -1;
    let screens = {};
    return {
      matchHandlers: {},
      dispatch(pointMap) {
        screens = pointMap;
        subscribers.forEach((func) => func(screens));
        return subscribers.size >= 1;
      },
      subscribe(func) {
        if (!subscribers.size)
          this.register();
        subUid += 1;
        subscribers.set(subUid, func);
        func(screens);
        return subUid;
      },
      unsubscribe(paramToken) {
        subscribers.delete(paramToken);
        if (!subscribers.size)
          this.unregister();
      },
      unregister() {
        Object.keys(responsiveMap).forEach((screen) => {
          const matchMediaQuery = responsiveMap[screen];
          const handler = this.matchHandlers[matchMediaQuery];
          handler === null || handler === void 0 ? void 0 : handler.mql.removeListener(handler === null || handler === void 0 ? void 0 : handler.listener);
        });
        subscribers.clear();
      },
      register() {
        Object.keys(responsiveMap).forEach((screen) => {
          const matchMediaQuery = responsiveMap[screen];
          const listener = (_ref) => {
            let {
              matches
            } = _ref;
            this.dispatch(Object.assign(Object.assign({}, screens), {
              [screen]: matches
            }));
          };
          const mql = window.matchMedia(matchMediaQuery);
          mql.addListener(listener);
          this.matchHandlers[matchMediaQuery] = {
            mql,
            listener
          };
          listener(mql);
        });
      },
      responsiveMap
    };
  }, [token2]);
}

// ../../node_modules/antd/es/grid/hooks/useBreakpoint.js
var import_react58 = require("react");

// ../../node_modules/antd/es/_util/hooks/useForceUpdate.js
var React164 = __toESM(require("react"));
function useForceUpdate() {
  const [, forceUpdate] = React164.useReducer((x2) => x2 + 1, 0);
  return forceUpdate;
}

// ../../node_modules/antd/es/grid/hooks/useBreakpoint.js
function useBreakpoint() {
  let refreshOnChange = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
  const screensRef = (0, import_react58.useRef)({});
  const forceUpdate = useForceUpdate();
  const responsiveObserver = useResponsiveObserver();
  useLayoutEffect_default(() => {
    const token2 = responsiveObserver.subscribe((supportScreens) => {
      screensRef.current = supportScreens;
      if (refreshOnChange) {
        forceUpdate();
      }
    });
    return () => responsiveObserver.unsubscribe(token2);
  }, []);
  return screensRef.current;
}
var useBreakpoint_default = useBreakpoint;

// ../../node_modules/antd/es/tooltip/index.js
var React168 = __toESM(require("react"));
var import_classnames44 = __toESM(require_classnames());

// ../../node_modules/rc-tooltip/es/Popup.js
var import_classnames41 = __toESM(require_classnames());
var React165 = __toESM(require("react"));
function Popup2(props) {
  var children = props.children, prefixCls = props.prefixCls, id = props.id, overlayInnerStyle = props.overlayInnerStyle, className = props.className, style2 = props.style;
  return /* @__PURE__ */ React165.createElement("div", {
    className: (0, import_classnames41.default)("".concat(prefixCls, "-content"), className),
    style: style2
  }, /* @__PURE__ */ React165.createElement("div", {
    className: "".concat(prefixCls, "-inner"),
    id,
    role: "tooltip",
    style: overlayInnerStyle
  }, typeof children === "function" ? children() : children));
}

// ../../node_modules/rc-tooltip/es/Tooltip.js
var React166 = __toESM(require("react"));
var import_react59 = require("react");

// ../../node_modules/rc-tooltip/es/placements.js
var autoAdjustOverflowTopBottom = {
  shiftX: 64,
  adjustY: 1
};
var autoAdjustOverflowLeftRight = {
  adjustX: 1,
  shiftY: true
};
var targetOffset = [0, 0];
var placements = {
  left: {
    points: ["cr", "cl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  },
  right: {
    points: ["cl", "cr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  top: {
    points: ["bc", "tc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  bottom: {
    points: ["tc", "bc"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  topLeft: {
    points: ["bl", "tl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  leftTop: {
    points: ["tr", "tl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  },
  topRight: {
    points: ["br", "tr"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, -4],
    targetOffset
  },
  rightTop: {
    points: ["tl", "tr"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  bottomRight: {
    points: ["tr", "br"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  rightBottom: {
    points: ["bl", "br"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [4, 0],
    targetOffset
  },
  bottomLeft: {
    points: ["tl", "bl"],
    overflow: autoAdjustOverflowTopBottom,
    offset: [0, 4],
    targetOffset
  },
  leftBottom: {
    points: ["br", "bl"],
    overflow: autoAdjustOverflowLeftRight,
    offset: [-4, 0],
    targetOffset
  }
};

// ../../node_modules/rc-tooltip/es/Tooltip.js
var _excluded20 = ["overlayClassName", "trigger", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "prefixCls", "children", "onVisibleChange", "afterVisibleChange", "transitionName", "animation", "motion", "placement", "align", "destroyTooltipOnHide", "defaultVisible", "getTooltipContainer", "overlayInnerStyle", "arrowContent", "overlay", "id", "showArrow"];
var Tooltip = function Tooltip2(props, ref) {
  var overlayClassName = props.overlayClassName, _props$trigger = props.trigger, trigger = _props$trigger === void 0 ? ["hover"] : _props$trigger, _props$mouseEnterDela = props.mouseEnterDelay, mouseEnterDelay = _props$mouseEnterDela === void 0 ? 0 : _props$mouseEnterDela, _props$mouseLeaveDela = props.mouseLeaveDelay, mouseLeaveDelay = _props$mouseLeaveDela === void 0 ? 0.1 : _props$mouseLeaveDela, overlayStyle = props.overlayStyle, _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-tooltip" : _props$prefixCls, children = props.children, onVisibleChange = props.onVisibleChange, afterVisibleChange = props.afterVisibleChange, transitionName = props.transitionName, animation = props.animation, motion = props.motion, _props$placement = props.placement, placement = _props$placement === void 0 ? "right" : _props$placement, _props$align = props.align, align = _props$align === void 0 ? {} : _props$align, _props$destroyTooltip = props.destroyTooltipOnHide, destroyTooltipOnHide = _props$destroyTooltip === void 0 ? false : _props$destroyTooltip, defaultVisible = props.defaultVisible, getTooltipContainer = props.getTooltipContainer, overlayInnerStyle = props.overlayInnerStyle, arrowContent = props.arrowContent, overlay = props.overlay, id = props.id, _props$showArrow = props.showArrow, showArrow = _props$showArrow === void 0 ? true : _props$showArrow, restProps = _objectWithoutProperties(props, _excluded20);
  var triggerRef = (0, import_react59.useRef)(null);
  (0, import_react59.useImperativeHandle)(ref, function() {
    return triggerRef.current;
  });
  var extraProps = _objectSpread2({}, restProps);
  if ("visible" in props) {
    extraProps.popupVisible = props.visible;
  }
  var getPopupElement = function getPopupElement2() {
    return /* @__PURE__ */ React166.createElement(Popup2, {
      key: "content",
      prefixCls,
      id,
      overlayInnerStyle
    }, overlay);
  };
  return /* @__PURE__ */ React166.createElement(es_default6, _extends({
    popupClassName: overlayClassName,
    prefixCls,
    popup: getPopupElement,
    action: trigger,
    builtinPlacements: placements,
    popupPlacement: placement,
    ref: triggerRef,
    popupAlign: align,
    getPopupContainer: getTooltipContainer,
    onPopupVisibleChange: onVisibleChange,
    afterPopupVisibleChange: afterVisibleChange,
    popupTransitionName: transitionName,
    popupAnimation: animation,
    popupMotion: motion,
    defaultPopupVisible: defaultVisible,
    autoDestroy: destroyTooltipOnHide,
    mouseLeaveDelay,
    popupStyle: overlayStyle,
    mouseEnterDelay,
    arrow: showArrow
  }, extraProps), children);
};
var Tooltip_default = /* @__PURE__ */ (0, import_react59.forwardRef)(Tooltip);

// ../../node_modules/rc-tooltip/es/index.js
var es_default9 = Tooltip_default;

// ../../node_modules/antd/es/style/roundedArrow.js
function getArrowToken(token2) {
  const {
    sizePopupArrow,
    borderRadiusXS,
    borderRadiusOuter
  } = token2;
  const unitWidth = sizePopupArrow / 2;
  const ax = 0;
  const ay = unitWidth;
  const bx = borderRadiusOuter * 1 / Math.sqrt(2);
  const by = unitWidth - borderRadiusOuter * (1 - 1 / Math.sqrt(2));
  const cx = unitWidth - borderRadiusXS * (1 / Math.sqrt(2));
  const cy = borderRadiusOuter * (Math.sqrt(2) - 1) + borderRadiusXS * (1 / Math.sqrt(2));
  const dx = 2 * unitWidth - cx;
  const dy = cy;
  const ex = 2 * unitWidth - bx;
  const ey = by;
  const fx = 2 * unitWidth - ax;
  const fy = ay;
  const shadowWidth = unitWidth * Math.sqrt(2) + borderRadiusOuter * (Math.sqrt(2) - 2);
  const polygonOffset = borderRadiusOuter * (Math.sqrt(2) - 1);
  const arrowPolygon = `polygon(${polygonOffset}px 100%, 50% ${polygonOffset}px, ${2 * unitWidth - polygonOffset}px 100%, ${polygonOffset}px 100%)`;
  const arrowPath = `path('M ${ax} ${ay} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${bx} ${by} L ${cx} ${cy} A ${borderRadiusXS} ${borderRadiusXS} 0 0 1 ${dx} ${dy} L ${ex} ${ey} A ${borderRadiusOuter} ${borderRadiusOuter} 0 0 0 ${fx} ${fy} Z')`;
  return {
    arrowShadowWidth: shadowWidth,
    arrowPath,
    arrowPolygon
  };
}
var genRoundedArrow = (token2, bgColor, boxShadow) => {
  const {
    sizePopupArrow,
    arrowPolygon,
    arrowPath,
    arrowShadowWidth,
    borderRadiusXS,
    calc
  } = token2;
  return {
    pointerEvents: "none",
    width: sizePopupArrow,
    height: sizePopupArrow,
    overflow: "hidden",
    "&::before": {
      position: "absolute",
      bottom: 0,
      insetInlineStart: 0,
      width: sizePopupArrow,
      height: calc(sizePopupArrow).div(2).equal(),
      background: bgColor,
      clipPath: {
        _multi_value_: true,
        value: [arrowPolygon, arrowPath]
      },
      content: '""'
    },
    "&::after": {
      content: '""',
      position: "absolute",
      width: arrowShadowWidth,
      height: arrowShadowWidth,
      bottom: 0,
      insetInline: 0,
      margin: "auto",
      borderRadius: {
        _skip_check_: true,
        value: `0 0 ${unit(borderRadiusXS)} 0`
      },
      transform: "translateY(50%) rotate(-135deg)",
      boxShadow,
      zIndex: 0,
      background: "transparent"
    }
  };
};

// ../../node_modules/antd/es/style/placementArrow.js
var MAX_VERTICAL_CONTENT_RADIUS = 8;
function getArrowOffsetToken(options) {
  const {
    contentRadius,
    limitVerticalRadius
  } = options;
  const arrowOffset = contentRadius > 12 ? contentRadius + 2 : 12;
  const arrowOffsetVertical = limitVerticalRadius ? MAX_VERTICAL_CONTENT_RADIUS : arrowOffset;
  return {
    arrowOffsetHorizontal: arrowOffset,
    arrowOffsetVertical
  };
}
function isInject(valid, code) {
  if (!valid) {
    return {};
  }
  return code;
}
function getArrowStyle(token2, colorBg, options) {
  const {
    componentCls,
    boxShadowPopoverArrow,
    arrowOffsetVertical,
    arrowOffsetHorizontal
  } = token2;
  const {
    arrowDistance = 0,
    arrowPlacement = {
      left: true,
      right: true,
      top: true,
      bottom: true
    }
  } = options || {};
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({
      // ============================ Basic ============================
      [`${componentCls}-arrow`]: [Object.assign(Object.assign({
        position: "absolute",
        zIndex: 1,
        display: "block"
      }, genRoundedArrow(token2, colorBg, boxShadowPopoverArrow)), {
        "&:before": {
          background: colorBg
        }
      })]
    }, isInject(!!arrowPlacement.top, {
      [[`&-placement-top > ${componentCls}-arrow`, `&-placement-topLeft > ${componentCls}-arrow`, `&-placement-topRight > ${componentCls}-arrow`].join(",")]: {
        bottom: arrowDistance,
        transform: "translateY(100%) rotate(180deg)"
      },
      [`&-placement-top > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: "50%"
        },
        transform: "translateX(-50%) translateY(100%) rotate(180deg)"
      },
      [`&-placement-topLeft > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: arrowOffsetHorizontal
        }
      },
      [`&-placement-topRight > ${componentCls}-arrow`]: {
        right: {
          _skip_check_: true,
          value: arrowOffsetHorizontal
        }
      }
    })), isInject(!!arrowPlacement.bottom, {
      [[`&-placement-bottom > ${componentCls}-arrow`, `&-placement-bottomLeft > ${componentCls}-arrow`, `&-placement-bottomRight > ${componentCls}-arrow`].join(",")]: {
        top: arrowDistance,
        transform: `translateY(-100%)`
      },
      [`&-placement-bottom > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: "50%"
        },
        transform: `translateX(-50%) translateY(-100%)`
      },
      [`&-placement-bottomLeft > ${componentCls}-arrow`]: {
        left: {
          _skip_check_: true,
          value: arrowOffsetHorizontal
        }
      },
      [`&-placement-bottomRight > ${componentCls}-arrow`]: {
        right: {
          _skip_check_: true,
          value: arrowOffsetHorizontal
        }
      }
    })), isInject(!!arrowPlacement.left, {
      [[`&-placement-left > ${componentCls}-arrow`, `&-placement-leftTop > ${componentCls}-arrow`, `&-placement-leftBottom > ${componentCls}-arrow`].join(",")]: {
        right: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: "translateX(100%) rotate(90deg)"
      },
      [`&-placement-left > ${componentCls}-arrow`]: {
        top: {
          _skip_check_: true,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(100%) rotate(90deg)"
      },
      [`&-placement-leftTop > ${componentCls}-arrow`]: {
        top: arrowOffsetVertical
      },
      [`&-placement-leftBottom > ${componentCls}-arrow`]: {
        bottom: arrowOffsetVertical
      }
    })), isInject(!!arrowPlacement.right, {
      [[`&-placement-right > ${componentCls}-arrow`, `&-placement-rightTop > ${componentCls}-arrow`, `&-placement-rightBottom > ${componentCls}-arrow`].join(",")]: {
        left: {
          _skip_check_: true,
          value: arrowDistance
        },
        transform: "translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-right > ${componentCls}-arrow`]: {
        top: {
          _skip_check_: true,
          value: "50%"
        },
        transform: "translateY(-50%) translateX(-100%) rotate(-90deg)"
      },
      [`&-placement-rightTop > ${componentCls}-arrow`]: {
        top: arrowOffsetVertical
      },
      [`&-placement-rightBottom > ${componentCls}-arrow`]: {
        bottom: arrowOffsetVertical
      }
    }))
  };
}

// ../../node_modules/antd/es/_util/placements.js
function getOverflowOptions(placement, arrowOffset, arrowWidth, autoAdjustOverflow) {
  if (autoAdjustOverflow === false) {
    return {
      adjustX: false,
      adjustY: false
    };
  }
  const overflow = autoAdjustOverflow && typeof autoAdjustOverflow === "object" ? autoAdjustOverflow : {};
  const baseOverflow = {};
  switch (placement) {
    case "top":
    case "bottom":
      baseOverflow.shiftX = arrowOffset.arrowOffsetHorizontal * 2 + arrowWidth;
      baseOverflow.shiftY = true;
      baseOverflow.adjustY = true;
      break;
    case "left":
    case "right":
      baseOverflow.shiftY = arrowOffset.arrowOffsetVertical * 2 + arrowWidth;
      baseOverflow.shiftX = true;
      baseOverflow.adjustX = true;
      break;
  }
  const mergedOverflow = Object.assign(Object.assign({}, baseOverflow), overflow);
  if (!mergedOverflow.shiftX) {
    mergedOverflow.adjustX = true;
  }
  if (!mergedOverflow.shiftY) {
    mergedOverflow.adjustY = true;
  }
  return mergedOverflow;
}
var PlacementAlignMap = {
  left: {
    points: ["cr", "cl"]
  },
  right: {
    points: ["cl", "cr"]
  },
  top: {
    points: ["bc", "tc"]
  },
  bottom: {
    points: ["tc", "bc"]
  },
  topLeft: {
    points: ["bl", "tl"]
  },
  leftTop: {
    points: ["tr", "tl"]
  },
  topRight: {
    points: ["br", "tr"]
  },
  rightTop: {
    points: ["tl", "tr"]
  },
  bottomRight: {
    points: ["tr", "br"]
  },
  rightBottom: {
    points: ["bl", "br"]
  },
  bottomLeft: {
    points: ["tl", "bl"]
  },
  leftBottom: {
    points: ["br", "bl"]
  }
};
var ArrowCenterPlacementAlignMap = {
  topLeft: {
    points: ["bl", "tc"]
  },
  leftTop: {
    points: ["tr", "cl"]
  },
  topRight: {
    points: ["br", "tc"]
  },
  rightTop: {
    points: ["tl", "cr"]
  },
  bottomRight: {
    points: ["tr", "bc"]
  },
  rightBottom: {
    points: ["bl", "cr"]
  },
  bottomLeft: {
    points: ["tl", "bc"]
  },
  leftBottom: {
    points: ["br", "cl"]
  }
};
var DisableAutoArrowList = /* @__PURE__ */ new Set(["topLeft", "topRight", "bottomLeft", "bottomRight", "leftTop", "leftBottom", "rightTop", "rightBottom"]);
function getPlacements(config) {
  const {
    arrowWidth,
    autoAdjustOverflow,
    arrowPointAtCenter,
    offset: offset2,
    borderRadius,
    visibleFirst
  } = config;
  const halfArrowWidth = arrowWidth / 2;
  const placementMap = {};
  Object.keys(PlacementAlignMap).forEach((key) => {
    const template = arrowPointAtCenter && ArrowCenterPlacementAlignMap[key] || PlacementAlignMap[key];
    const placementInfo = Object.assign(Object.assign({}, template), {
      offset: [0, 0],
      dynamicInset: true
    });
    placementMap[key] = placementInfo;
    if (DisableAutoArrowList.has(key)) {
      placementInfo.autoArrow = false;
    }
    switch (key) {
      case "top":
      case "topLeft":
      case "topRight":
        placementInfo.offset[1] = -halfArrowWidth - offset2;
        break;
      case "bottom":
      case "bottomLeft":
      case "bottomRight":
        placementInfo.offset[1] = halfArrowWidth + offset2;
        break;
      case "left":
      case "leftTop":
      case "leftBottom":
        placementInfo.offset[0] = -halfArrowWidth - offset2;
        break;
      case "right":
      case "rightTop":
      case "rightBottom":
        placementInfo.offset[0] = halfArrowWidth + offset2;
        break;
    }
    const arrowOffset = getArrowOffsetToken({
      contentRadius: borderRadius,
      limitVerticalRadius: true
    });
    if (arrowPointAtCenter) {
      switch (key) {
        case "topLeft":
        case "bottomLeft":
          placementInfo.offset[0] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
          break;
        case "topRight":
        case "bottomRight":
          placementInfo.offset[0] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
          break;
        case "leftTop":
        case "rightTop":
          placementInfo.offset[1] = -arrowOffset.arrowOffsetHorizontal - halfArrowWidth;
          break;
        case "leftBottom":
        case "rightBottom":
          placementInfo.offset[1] = arrowOffset.arrowOffsetHorizontal + halfArrowWidth;
          break;
      }
    }
    placementInfo.overflow = getOverflowOptions(key, arrowOffset, arrowWidth, autoAdjustOverflow);
    if (visibleFirst) {
      placementInfo.htmlRegion = "visibleFirst";
    }
  });
  return placementMap;
}

// ../../node_modules/antd/es/tooltip/PurePanel.js
var import_classnames43 = __toESM(require_classnames());
var React167 = __toESM(require("react"));

// ../../node_modules/antd/es/tooltip/style/index.js
var genTooltipStyle = (token2) => {
  const {
    componentCls,
    // ant-tooltip
    tooltipMaxWidth,
    tooltipColor,
    tooltipBg,
    tooltipBorderRadius,
    zIndexPopup,
    controlHeight,
    boxShadowSecondary,
    paddingSM,
    paddingXS
  } = token2;
  return [
    {
      [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), {
        position: "absolute",
        zIndex: zIndexPopup,
        display: "block",
        width: "max-content",
        maxWidth: tooltipMaxWidth,
        visibility: "visible",
        transformOrigin: `var(--arrow-x, 50%) var(--arrow-y, 50%)`,
        "&-hidden": {
          display: "none"
        },
        "--antd-arrow-background-color": tooltipBg,
        // Wrapper for the tooltip content
        [`${componentCls}-inner`]: {
          minWidth: controlHeight,
          minHeight: controlHeight,
          padding: `${unit(token2.calc(paddingSM).div(2).equal())} ${unit(paddingXS)}`,
          color: tooltipColor,
          textAlign: "start",
          textDecoration: "none",
          wordWrap: "break-word",
          backgroundColor: tooltipBg,
          borderRadius: tooltipBorderRadius,
          boxShadow: boxShadowSecondary,
          boxSizing: "border-box"
        },
        // Limit left and right placement radius
        [[`&-placement-left`, `&-placement-leftTop`, `&-placement-leftBottom`, `&-placement-right`, `&-placement-rightTop`, `&-placement-rightBottom`].join(",")]: {
          [`${componentCls}-inner`]: {
            borderRadius: token2.min(tooltipBorderRadius, MAX_VERTICAL_CONTENT_RADIUS)
          }
        },
        [`${componentCls}-content`]: {
          position: "relative"
        }
      }), genPresetColor(token2, (colorKey, _ref) => {
        let {
          darkColor
        } = _ref;
        return {
          [`&${componentCls}-${colorKey}`]: {
            [`${componentCls}-inner`]: {
              backgroundColor: darkColor
            },
            [`${componentCls}-arrow`]: {
              "--antd-arrow-background-color": darkColor
            }
          }
        };
      })), {
        // RTL
        "&-rtl": {
          direction: "rtl"
        }
      })
    },
    // Arrow Style
    getArrowStyle(token2, "var(--antd-arrow-background-color)"),
    // Pure Render
    {
      [`${componentCls}-pure`]: {
        position: "relative",
        maxWidth: "none",
        margin: token2.sizePopupArrow
      }
    }
  ];
};
var prepareComponentToken6 = (token2) => Object.assign(Object.assign({
  zIndexPopup: token2.zIndexPopupBase + 70
}, getArrowOffsetToken({
  contentRadius: token2.borderRadius,
  limitVerticalRadius: true
})), getArrowToken(merge2(token2, {
  borderRadiusOuter: Math.min(token2.borderRadiusOuter, 4)
})));
var style_default8 = function(prefixCls) {
  let injectStyle = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  const useStyle = genStyleHooks("Tooltip", (token2) => {
    const {
      borderRadius,
      colorTextLightSolid,
      colorBgSpotlight
    } = token2;
    const TooltipToken = merge2(token2, {
      // default variables
      tooltipMaxWidth: 250,
      tooltipColor: colorTextLightSolid,
      tooltipBorderRadius: borderRadius,
      tooltipBg: colorBgSpotlight
    });
    return [genTooltipStyle(TooltipToken), initZoomMotion(token2, "zoom-big-fast")];
  }, prepareComponentToken6, {
    resetStyle: false,
    // Popover use Tooltip as internal component. We do not need to handle this.
    injectStyle
  });
  return useStyle(prefixCls);
};

// ../../node_modules/antd/es/tooltip/util.js
var import_classnames42 = __toESM(require_classnames());

// ../../node_modules/antd/es/_util/colors.js
var inverseColors = PresetColors.map((color2) => `${color2}-inverse`);
function isPresetColor(color2) {
  let includeInverse = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
  if (includeInverse) {
    return [].concat(_toConsumableArray(inverseColors), _toConsumableArray(PresetColors)).includes(color2);
  }
  return PresetColors.includes(color2);
}

// ../../node_modules/antd/es/tooltip/util.js
function parseColor(prefixCls, color2) {
  const isInternalColor = isPresetColor(color2);
  const className = (0, import_classnames42.default)({
    [`${prefixCls}-${color2}`]: color2 && isInternalColor
  });
  const overlayStyle = {};
  const arrowStyle = {};
  if (color2 && !isInternalColor) {
    overlayStyle.background = color2;
    arrowStyle["--antd-arrow-background-color"] = color2;
  }
  return {
    className,
    overlayStyle,
    arrowStyle
  };
}

// ../../node_modules/antd/es/tooltip/PurePanel.js
var PurePanel4 = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className,
    placement = "top",
    title,
    color: color2,
    overlayInnerStyle
  } = props;
  const {
    getPrefixCls
  } = React167.useContext(ConfigContext);
  const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default8(prefixCls);
  const colorInfo = parseColor(prefixCls, color2);
  const arrowContentStyle = colorInfo.arrowStyle;
  const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
  const cls = (0, import_classnames43.default)(hashId, cssVarCls, prefixCls, `${prefixCls}-pure`, `${prefixCls}-placement-${placement}`, className, colorInfo.className);
  return wrapCSSVar(/* @__PURE__ */ React167.createElement("div", {
    className: cls,
    style: arrowContentStyle
  }, /* @__PURE__ */ React167.createElement("div", {
    className: `${prefixCls}-arrow`
  }), /* @__PURE__ */ React167.createElement(Popup2, Object.assign({}, props, {
    className: hashId,
    prefixCls,
    overlayInnerStyle: formattedOverlayInnerStyle
  }), title)));
};
var PurePanel_default4 = PurePanel4;

// ../../node_modules/antd/es/tooltip/index.js
var __rest15 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var Tooltip3 = /* @__PURE__ */ React168.forwardRef((props, ref) => {
  var _a, _b;
  const {
    prefixCls: customizePrefixCls,
    openClassName,
    getTooltipContainer,
    overlayClassName,
    color: color2,
    overlayInnerStyle,
    children,
    afterOpenChange,
    afterVisibleChange,
    destroyTooltipOnHide,
    arrow = true,
    title,
    overlay,
    builtinPlacements,
    arrowPointAtCenter = false,
    autoAdjustOverflow = true
  } = props;
  const mergedShowArrow = !!arrow;
  const [, token2] = useToken();
  const {
    getPopupContainer: getContextPopupContainer,
    getPrefixCls,
    direction
  } = React168.useContext(ConfigContext);
  const warning6 = devUseWarning("Tooltip");
  const tooltipRef = React168.useRef(null);
  const forceAlign = () => {
    var _a2;
    (_a2 = tooltipRef.current) === null || _a2 === void 0 ? void 0 : _a2.forceAlign();
  };
  React168.useImperativeHandle(ref, () => ({
    forceAlign,
    forcePopupAlign: () => {
      warning6.deprecated(false, "forcePopupAlign", "forceAlign");
      forceAlign();
    }
  }));
  if (process.env.NODE_ENV !== "production") {
    [["visible", "open"], ["defaultVisible", "defaultOpen"], ["onVisibleChange", "onOpenChange"], ["afterVisibleChange", "afterOpenChange"], ["arrowPointAtCenter", "arrow={{ pointAtCenter: true }}"]].forEach((_ref) => {
      let [deprecatedName, newName] = _ref;
      warning6.deprecated(!(deprecatedName in props), deprecatedName, newName);
    });
    process.env.NODE_ENV !== "production" ? warning6(!destroyTooltipOnHide || typeof destroyTooltipOnHide === "boolean", "usage", "`destroyTooltipOnHide` no need config `keepParent` anymore. Please use `boolean` value directly.") : void 0;
    process.env.NODE_ENV !== "production" ? warning6(!arrow || typeof arrow === "boolean" || !("arrowPointAtCenter" in arrow), "deprecated", "`arrowPointAtCenter` in `arrow` is deprecated. Please use `pointAtCenter` instead.") : void 0;
  }
  const [open3, setOpen] = useMergedState(false, {
    value: (_a = props.open) !== null && _a !== void 0 ? _a : props.visible,
    defaultValue: (_b = props.defaultOpen) !== null && _b !== void 0 ? _b : props.defaultVisible
  });
  const noTitle = !title && !overlay && title !== 0;
  const onOpenChange = (vis) => {
    var _a2, _b2;
    setOpen(noTitle ? false : vis);
    if (!noTitle) {
      (_a2 = props.onOpenChange) === null || _a2 === void 0 ? void 0 : _a2.call(props, vis);
      (_b2 = props.onVisibleChange) === null || _b2 === void 0 ? void 0 : _b2.call(props, vis);
    }
  };
  const tooltipPlacements = React168.useMemo(() => {
    var _a2, _b2;
    let mergedArrowPointAtCenter = arrowPointAtCenter;
    if (typeof arrow === "object") {
      mergedArrowPointAtCenter = (_b2 = (_a2 = arrow.pointAtCenter) !== null && _a2 !== void 0 ? _a2 : arrow.arrowPointAtCenter) !== null && _b2 !== void 0 ? _b2 : arrowPointAtCenter;
    }
    return builtinPlacements || getPlacements({
      arrowPointAtCenter: mergedArrowPointAtCenter,
      autoAdjustOverflow,
      arrowWidth: mergedShowArrow ? token2.sizePopupArrow : 0,
      borderRadius: token2.borderRadius,
      offset: token2.marginXXS,
      visibleFirst: true
    });
  }, [arrowPointAtCenter, arrow, builtinPlacements, token2]);
  const memoOverlay = React168.useMemo(() => {
    if (title === 0) {
      return title;
    }
    return overlay || title || "";
  }, [overlay, title]);
  const memoOverlayWrapper = /* @__PURE__ */ React168.createElement(NoCompactStyle, null, typeof memoOverlay === "function" ? memoOverlay() : memoOverlay);
  const {
    getPopupContainer,
    placement = "top",
    mouseEnterDelay = 0.1,
    mouseLeaveDelay = 0.1,
    overlayStyle,
    rootClassName
  } = props, otherProps = __rest15(props, ["getPopupContainer", "placement", "mouseEnterDelay", "mouseLeaveDelay", "overlayStyle", "rootClassName"]);
  const prefixCls = getPrefixCls("tooltip", customizePrefixCls);
  const rootPrefixCls = getPrefixCls();
  const injectFromPopover = props["data-popover-inject"];
  let tempOpen = open3;
  if (!("open" in props) && !("visible" in props) && noTitle) {
    tempOpen = false;
  }
  const child = isValidElement4(children) && !isFragment3(children) ? children : /* @__PURE__ */ React168.createElement("span", null, children);
  const childProps = child.props;
  const childCls = !childProps.className || typeof childProps.className === "string" ? (0, import_classnames44.default)(childProps.className, openClassName || `${prefixCls}-open`) : childProps.className;
  const [wrapCSSVar, hashId, cssVarCls] = style_default8(prefixCls, !injectFromPopover);
  const colorInfo = parseColor(prefixCls, color2);
  const arrowContentStyle = colorInfo.arrowStyle;
  const formattedOverlayInnerStyle = Object.assign(Object.assign({}, overlayInnerStyle), colorInfo.overlayStyle);
  const customOverlayClassName = (0, import_classnames44.default)(overlayClassName, {
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, colorInfo.className, rootClassName, hashId, cssVarCls);
  const [zIndex, contextZIndex] = useZIndex("Tooltip", otherProps.zIndex);
  const content = /* @__PURE__ */ React168.createElement(es_default9, Object.assign({}, otherProps, {
    zIndex,
    showArrow: mergedShowArrow,
    placement,
    mouseEnterDelay,
    mouseLeaveDelay,
    prefixCls,
    overlayClassName: customOverlayClassName,
    overlayStyle: Object.assign(Object.assign({}, arrowContentStyle), overlayStyle),
    getTooltipContainer: getPopupContainer || getTooltipContainer || getContextPopupContainer,
    ref: tooltipRef,
    builtinPlacements: tooltipPlacements,
    overlay: memoOverlayWrapper,
    visible: tempOpen,
    onVisibleChange: onOpenChange,
    afterVisibleChange: afterOpenChange !== null && afterOpenChange !== void 0 ? afterOpenChange : afterVisibleChange,
    overlayInnerStyle: formattedOverlayInnerStyle,
    arrowContent: /* @__PURE__ */ React168.createElement("span", {
      className: `${prefixCls}-arrow-content`
    }),
    motion: {
      motionName: getTransitionName2(rootPrefixCls, "zoom-big-fast", props.transitionName),
      motionDeadline: 1e3
    },
    destroyTooltipOnHide: !!destroyTooltipOnHide
  }), tempOpen ? cloneElement4(child, {
    className: childCls
  }) : child);
  return wrapCSSVar(/* @__PURE__ */ React168.createElement(zindexContext_default.Provider, {
    value: contextZIndex
  }, content));
});
if (process.env.NODE_ENV !== "production") {
  Tooltip3.displayName = "Tooltip";
}
Tooltip3._InternalPanelDoNotUseOrYouWillBeFired = PurePanel_default4;
var tooltip_default = Tooltip3;

// ../../node_modules/@ant-design/icons/es/icons/RightOutlined.js
var React169 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/RightOutlined.js
var RightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z" } }] }, "name": "right", "theme": "outlined" };
var RightOutlined_default = RightOutlined;

// ../../node_modules/@ant-design/icons/es/icons/RightOutlined.js
var RightOutlined2 = function RightOutlined3(props, ref) {
  return /* @__PURE__ */ React169.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: RightOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  RightOutlined2.displayName = "RightOutlined";
}
var RightOutlined_default2 = /* @__PURE__ */ React169.forwardRef(RightOutlined2);

// ../../node_modules/@ant-design/icons/es/icons/LeftOutlined.js
var React170 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/LeftOutlined.js
var LeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z" } }] }, "name": "left", "theme": "outlined" };
var LeftOutlined_default = LeftOutlined;

// ../../node_modules/@ant-design/icons/es/icons/LeftOutlined.js
var LeftOutlined2 = function LeftOutlined3(props, ref) {
  return /* @__PURE__ */ React170.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: LeftOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  LeftOutlined2.displayName = "LeftOutlined";
}
var LeftOutlined_default2 = /* @__PURE__ */ React170.forwardRef(LeftOutlined2);

// ../../node_modules/antd/es/input/style/token.js
function initInputToken(token2) {
  return merge2(token2, {
    inputAffixPadding: token2.paddingXXS
  });
}
var initComponentToken = (token2) => {
  const {
    controlHeight,
    fontSize,
    lineHeight,
    lineWidth,
    controlHeightSM,
    controlHeightLG,
    fontSizeLG,
    lineHeightLG,
    paddingSM,
    controlPaddingHorizontalSM,
    controlPaddingHorizontal,
    colorFillAlter,
    colorPrimaryHover,
    colorPrimary,
    controlOutlineWidth,
    controlOutline,
    colorErrorOutline,
    colorWarningOutline,
    colorBgContainer
  } = token2;
  return {
    paddingBlock: Math.max(Math.round((controlHeight - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
    paddingBlockSM: Math.max(Math.round((controlHeightSM - fontSize * lineHeight) / 2 * 10) / 10 - lineWidth, 0),
    paddingBlockLG: Math.ceil((controlHeightLG - fontSizeLG * lineHeightLG) / 2 * 10) / 10 - lineWidth,
    paddingInline: paddingSM - lineWidth,
    paddingInlineSM: controlPaddingHorizontalSM - lineWidth,
    paddingInlineLG: controlPaddingHorizontal - lineWidth,
    addonBg: colorFillAlter,
    activeBorderColor: colorPrimary,
    hoverBorderColor: colorPrimaryHover,
    activeShadow: `0 0 0 ${controlOutlineWidth}px ${controlOutline}`,
    errorActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorErrorOutline}`,
    warningActiveShadow: `0 0 0 ${controlOutlineWidth}px ${colorWarningOutline}`,
    hoverBg: colorBgContainer,
    activeBg: colorBgContainer,
    inputFontSize: fontSize,
    inputFontSizeLG: fontSizeLG,
    inputFontSizeSM: fontSize
  };
};

// ../../node_modules/antd/es/input/style/variants.js
var genHoverStyle = (token2) => ({
  borderColor: token2.hoverBorderColor,
  backgroundColor: token2.hoverBg
});
var genDisabledStyle2 = (token2) => ({
  color: token2.colorTextDisabled,
  backgroundColor: token2.colorBgContainerDisabled,
  borderColor: token2.colorBorder,
  boxShadow: "none",
  cursor: "not-allowed",
  opacity: 1,
  "&:hover:not([disabled])": Object.assign({}, genHoverStyle(merge2(token2, {
    hoverBorderColor: token2.colorBorder,
    hoverBg: token2.colorBgContainerDisabled
  })))
});
var genBaseOutlinedStyle2 = (token2, options) => ({
  background: token2.colorBgContainer,
  borderWidth: token2.lineWidth,
  borderStyle: token2.lineType,
  borderColor: options.borderColor,
  "&:hover": {
    borderColor: options.hoverBorderColor,
    backgroundColor: token2.hoverBg
  },
  "&:focus, &:focus-within": {
    borderColor: options.activeBorderColor,
    boxShadow: options.activeShadow,
    outline: 0,
    backgroundColor: token2.activeBg
  }
});
var genOutlinedStatusStyle2 = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}:not(${token2.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseOutlinedStyle2(token2, options)), {
    [`${token2.componentCls}-prefix, ${token2.componentCls}-suffix`]: {
      color: options.affixColor
    }
  })
});
var genOutlinedStyle2 = (token2, extraStyles) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseOutlinedStyle2(token2, {
    borderColor: token2.colorBorder,
    hoverBorderColor: token2.colorPrimaryHover,
    activeBorderColor: token2.colorPrimary,
    activeShadow: token2.activeShadow
  })), {
    [`&${token2.componentCls}-disabled, &[disabled]`]: Object.assign({}, genDisabledStyle2(token2))
  }), genOutlinedStatusStyle2(token2, {
    status: "error",
    borderColor: token2.colorError,
    hoverBorderColor: token2.colorErrorBorderHover,
    activeBorderColor: token2.colorError,
    activeShadow: token2.errorActiveShadow,
    affixColor: token2.colorError
  })), genOutlinedStatusStyle2(token2, {
    status: "warning",
    borderColor: token2.colorWarning,
    hoverBorderColor: token2.colorWarningBorderHover,
    activeBorderColor: token2.colorWarning,
    activeShadow: token2.warningActiveShadow,
    affixColor: token2.colorWarning
  })), extraStyles)
});
var genOutlinedGroupStatusStyle = (token2, options) => ({
  [`&${token2.componentCls}-group-wrapper-status-${options.status}`]: {
    [`${token2.componentCls}-group-addon`]: {
      borderColor: options.addonBorderColor,
      color: options.addonColor
    }
  }
});
var genOutlinedGroupStyle = (token2) => ({
  "&-outlined": Object.assign(Object.assign(Object.assign({
    [`${token2.componentCls}-group`]: {
      "&-addon": {
        background: token2.addonBg,
        border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
      },
      "&-addon:first-child": {
        borderInlineEnd: 0
      },
      "&-addon:last-child": {
        borderInlineStart: 0
      }
    }
  }, genOutlinedGroupStatusStyle(token2, {
    status: "error",
    addonBorderColor: token2.colorError,
    addonColor: token2.colorErrorText
  })), genOutlinedGroupStatusStyle(token2, {
    status: "warning",
    addonBorderColor: token2.colorWarning,
    addonColor: token2.colorWarningText
  })), {
    [`&${token2.componentCls}-group-wrapper-disabled`]: {
      [`${token2.componentCls}-group-addon`]: Object.assign({}, genDisabledStyle2(token2))
    }
  })
});
var genBorderlessStyle2 = (token2, extraStyles) => ({
  "&-borderless": Object.assign({
    background: "transparent",
    border: "none",
    "&:focus, &:focus-within": {
      outline: "none"
    },
    [`&${token2.componentCls}-disabled, &[disabled]`]: {
      color: token2.colorTextDisabled
    }
  }, extraStyles)
});
var genBaseFilledStyle2 = (token2, options) => ({
  background: options.bg,
  borderWidth: token2.lineWidth,
  borderStyle: token2.lineType,
  borderColor: "transparent",
  [`input&, & input, textarea&, & textarea`]: {
    color: options === null || options === void 0 ? void 0 : options.inputColor
  },
  "&:hover": {
    background: options.hoverBg
  },
  "&:focus, &:focus-within": {
    outline: 0,
    borderColor: options.activeBorderColor,
    backgroundColor: token2.activeBg
  }
});
var genFilledStatusStyle2 = (token2, options) => ({
  [`&${token2.componentCls}-status-${options.status}:not(${token2.componentCls}-disabled)`]: Object.assign(Object.assign({}, genBaseFilledStyle2(token2, options)), {
    [`${token2.componentCls}-prefix, ${token2.componentCls}-suffix`]: {
      color: options.affixColor
    }
  })
});
var genFilledStyle2 = (token2, extraStyles) => ({
  "&-filled": Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, genBaseFilledStyle2(token2, {
    bg: token2.colorFillTertiary,
    hoverBg: token2.colorFillSecondary,
    activeBorderColor: token2.colorPrimary
  })), {
    [`&${token2.componentCls}-disabled, &[disabled]`]: Object.assign({}, genDisabledStyle2(token2))
  }), genFilledStatusStyle2(token2, {
    status: "error",
    bg: token2.colorErrorBg,
    hoverBg: token2.colorErrorBgHover,
    activeBorderColor: token2.colorError,
    inputColor: token2.colorErrorText,
    affixColor: token2.colorError
  })), genFilledStatusStyle2(token2, {
    status: "warning",
    bg: token2.colorWarningBg,
    hoverBg: token2.colorWarningBgHover,
    activeBorderColor: token2.colorWarning,
    inputColor: token2.colorWarningText,
    affixColor: token2.colorWarning
  })), extraStyles)
});
var genFilledGroupStatusStyle = (token2, options) => ({
  [`&${token2.componentCls}-group-wrapper-status-${options.status}`]: {
    [`${token2.componentCls}-group-addon`]: {
      background: options.addonBg,
      color: options.addonColor
    }
  }
});
var genFilledGroupStyle = (token2) => ({
  "&-filled": Object.assign(Object.assign(Object.assign({
    [`${token2.componentCls}-group`]: {
      "&-addon": {
        background: token2.colorFillTertiary
      },
      [`${token2.componentCls}-filled:not(:focus):not(:focus-within)`]: {
        "&:not(:first-child)": {
          borderInlineStart: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
        },
        "&:not(:last-child)": {
          borderInlineEnd: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorSplit}`
        }
      }
    }
  }, genFilledGroupStatusStyle(token2, {
    status: "error",
    addonBg: token2.colorErrorBg,
    addonColor: token2.colorErrorText
  })), genFilledGroupStatusStyle(token2, {
    status: "warning",
    addonBg: token2.colorWarningBg,
    addonColor: token2.colorWarningText
  })), {
    [`&${token2.componentCls}-group-wrapper-disabled`]: {
      [`${token2.componentCls}-group`]: {
        "&-addon": {
          background: token2.colorFillTertiary,
          color: token2.colorTextDisabled
        },
        "&-addon:first-child": {
          borderInlineStart: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderTop: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderBottom: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
        },
        "&-addon:last-child": {
          borderInlineEnd: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderTop: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
          borderBottom: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`
        }
      }
    }
  })
});

// ../../node_modules/antd/es/input/style/index.js
var genPlaceholderStyle = (color2) => ({
  // Firefox
  "&::-moz-placeholder": {
    opacity: 1
  },
  "&::placeholder": {
    color: color2,
    userSelect: "none"
    // https://github.com/ant-design/ant-design/pull/32639
  },
  "&:placeholder-shown": {
    textOverflow: "ellipsis"
  }
});
var genInputLargeStyle = (token2) => {
  const {
    paddingBlockLG,
    lineHeightLG,
    borderRadiusLG,
    paddingInlineLG
  } = token2;
  return {
    padding: `${unit(paddingBlockLG)} ${unit(paddingInlineLG)}`,
    fontSize: token2.inputFontSizeLG,
    lineHeight: lineHeightLG,
    borderRadius: borderRadiusLG
  };
};
var genInputSmallStyle = (token2) => ({
  padding: `${unit(token2.paddingBlockSM)} ${unit(token2.paddingInlineSM)}`,
  fontSize: token2.inputFontSizeSM,
  borderRadius: token2.borderRadiusSM
});
var genBasicInputStyle = (token2) => Object.assign(Object.assign({
  position: "relative",
  display: "inline-block",
  width: "100%",
  minWidth: 0,
  padding: `${unit(token2.paddingBlock)} ${unit(token2.paddingInline)}`,
  color: token2.colorText,
  fontSize: token2.inputFontSize,
  lineHeight: token2.lineHeight,
  borderRadius: token2.borderRadius,
  transition: `all ${token2.motionDurationMid}`
}, genPlaceholderStyle(token2.colorTextPlaceholder)), {
  // Reset height for `textarea`s
  "textarea&": {
    maxWidth: "100%",
    // prevent textarea resize from coming out of its container
    height: "auto",
    minHeight: token2.controlHeight,
    lineHeight: token2.lineHeight,
    verticalAlign: "bottom",
    transition: `all ${token2.motionDurationSlow}, height 0s`,
    resize: "vertical"
  },
  // Size
  "&-lg": Object.assign({}, genInputLargeStyle(token2)),
  "&-sm": Object.assign({}, genInputSmallStyle(token2)),
  // RTL
  "&-rtl": {
    direction: "rtl"
  },
  "&-textarea-rtl": {
    direction: "rtl"
  }
});
var genInputGroupStyle = (token2) => {
  const {
    componentCls,
    antCls
  } = token2;
  return {
    position: "relative",
    display: "table",
    width: "100%",
    borderCollapse: "separate",
    borderSpacing: 0,
    // Undo padding and float of grid classes
    [`&[class*='col-']`]: {
      paddingInlineEnd: token2.paddingXS,
      "&:last-child": {
        paddingInlineEnd: 0
      }
    },
    // Sizing options
    [`&-lg ${componentCls}, &-lg > ${componentCls}-group-addon`]: Object.assign({}, genInputLargeStyle(token2)),
    [`&-sm ${componentCls}, &-sm > ${componentCls}-group-addon`]: Object.assign({}, genInputSmallStyle(token2)),
    // Fix https://github.com/ant-design/ant-design/issues/5754
    [`&-lg ${antCls}-select-single ${antCls}-select-selector`]: {
      height: token2.controlHeightLG
    },
    [`&-sm ${antCls}-select-single ${antCls}-select-selector`]: {
      height: token2.controlHeightSM
    },
    [`> ${componentCls}`]: {
      display: "table-cell",
      "&:not(:first-child):not(:last-child)": {
        borderRadius: 0
      }
    },
    [`${componentCls}-group`]: {
      [`&-addon, &-wrap`]: {
        display: "table-cell",
        width: 1,
        whiteSpace: "nowrap",
        verticalAlign: "middle",
        "&:not(:first-child):not(:last-child)": {
          borderRadius: 0
        }
      },
      "&-wrap > *": {
        display: "block !important"
      },
      "&-addon": {
        position: "relative",
        padding: `0 ${unit(token2.paddingInline)}`,
        color: token2.colorText,
        fontWeight: "normal",
        fontSize: token2.inputFontSize,
        textAlign: "center",
        borderRadius: token2.borderRadius,
        transition: `all ${token2.motionDurationSlow}`,
        lineHeight: 1,
        // Reset Select's style in addon
        [`${antCls}-select`]: {
          margin: `${unit(token2.calc(token2.paddingBlock).add(1).mul(-1).equal())} ${unit(token2.calc(token2.paddingInline).mul(-1).equal())}`,
          [`&${antCls}-select-single:not(${antCls}-select-customize-input):not(${antCls}-pagination-size-changer)`]: {
            [`${antCls}-select-selector`]: {
              backgroundColor: "inherit",
              border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
              boxShadow: "none"
            }
          },
          "&-open, &-focused": {
            [`${antCls}-select-selector`]: {
              color: token2.colorPrimary
            }
          }
        },
        // https://github.com/ant-design/ant-design/issues/31333
        [`${antCls}-cascader-picker`]: {
          margin: `-9px ${unit(token2.calc(token2.paddingInline).mul(-1).equal())}`,
          backgroundColor: "transparent",
          [`${antCls}-cascader-input`]: {
            textAlign: "start",
            border: 0,
            boxShadow: "none"
          }
        }
      }
    },
    [`${componentCls}`]: {
      width: "100%",
      marginBottom: 0,
      textAlign: "inherit",
      "&:focus": {
        zIndex: 1,
        // Fix https://gw.alipayobjects.com/zos/rmsportal/DHNpoqfMXSfrSnlZvhsJ.png
        borderInlineEndWidth: 1
      },
      "&:hover": {
        zIndex: 1,
        borderInlineEndWidth: 1,
        [`${componentCls}-search-with-button &`]: {
          zIndex: 0
        }
      }
    },
    // Reset rounded corners
    [`> ${componentCls}:first-child, ${componentCls}-group-addon:first-child`]: {
      borderStartEndRadius: 0,
      borderEndEndRadius: 0,
      // Reset Select's style in addon
      [`${antCls}-select ${antCls}-select-selector`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${componentCls}-affix-wrapper`]: {
      [`&:not(:first-child) ${componentCls}`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      },
      [`&:not(:last-child) ${componentCls}`]: {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0
      }
    },
    [`> ${componentCls}:last-child, ${componentCls}-group-addon:last-child`]: {
      borderStartStartRadius: 0,
      borderEndStartRadius: 0,
      // Reset Select's style in addon
      [`${antCls}-select ${antCls}-select-selector`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`${componentCls}-affix-wrapper`]: {
      "&:not(:last-child)": {
        borderStartEndRadius: 0,
        borderEndEndRadius: 0,
        [`${componentCls}-search &`]: {
          borderStartStartRadius: token2.borderRadius,
          borderEndStartRadius: token2.borderRadius
        }
      },
      [`&:not(:first-child), ${componentCls}-search &:not(:first-child)`]: {
        borderStartStartRadius: 0,
        borderEndStartRadius: 0
      }
    },
    [`&${componentCls}-group-compact`]: Object.assign(Object.assign({
      display: "block"
    }, clearFix()), {
      [`${componentCls}-group-addon, ${componentCls}-group-wrap, > ${componentCls}`]: {
        "&:not(:first-child):not(:last-child)": {
          borderInlineEndWidth: token2.lineWidth,
          "&:hover": {
            zIndex: 1
          },
          "&:focus": {
            zIndex: 1
          }
        }
      },
      "& > *": {
        display: "inline-block",
        float: "none",
        verticalAlign: "top",
        // https://github.com/ant-design/ant-design-pro/issues/139
        borderRadius: 0
      },
      [`
        & > ${componentCls}-affix-wrapper,
        & > ${componentCls}-number-affix-wrapper,
        & > ${antCls}-picker-range
      `]: {
        display: "inline-flex"
      },
      "& > *:not(:last-child)": {
        marginInlineEnd: token2.calc(token2.lineWidth).mul(-1).equal(),
        borderInlineEndWidth: token2.lineWidth
      },
      // Undo float for .ant-input-group .ant-input
      [`${componentCls}`]: {
        float: "none"
      },
      // reset border for Select, DatePicker, AutoComplete, Cascader, Mention, TimePicker, Input
      [`& > ${antCls}-select > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete ${componentCls},
      & > ${antCls}-cascader-picker ${componentCls},
      & > ${componentCls}-group-wrapper ${componentCls}`]: {
        borderInlineEndWidth: token2.lineWidth,
        borderRadius: 0,
        "&:hover": {
          zIndex: 1
        },
        "&:focus": {
          zIndex: 1
        }
      },
      [`& > ${antCls}-select-focused`]: {
        zIndex: 1
      },
      // update z-index for arrow icon
      [`& > ${antCls}-select > ${antCls}-select-arrow`]: {
        zIndex: 1
        // https://github.com/ant-design/ant-design/issues/20371
      },
      [`& > *:first-child,
      & > ${antCls}-select:first-child > ${antCls}-select-selector,
      & > ${antCls}-select-auto-complete:first-child ${componentCls},
      & > ${antCls}-cascader-picker:first-child ${componentCls}`]: {
        borderStartStartRadius: token2.borderRadius,
        borderEndStartRadius: token2.borderRadius
      },
      [`& > *:last-child,
      & > ${antCls}-select:last-child > ${antCls}-select-selector,
      & > ${antCls}-cascader-picker:last-child ${componentCls},
      & > ${antCls}-cascader-picker-focused:last-child ${componentCls}`]: {
        borderInlineEndWidth: token2.lineWidth,
        borderStartEndRadius: token2.borderRadius,
        borderEndEndRadius: token2.borderRadius
      },
      // https://github.com/ant-design/ant-design/issues/12493
      [`& > ${antCls}-select-auto-complete ${componentCls}`]: {
        verticalAlign: "top"
      },
      [`${componentCls}-group-wrapper + ${componentCls}-group-wrapper`]: {
        marginInlineStart: token2.calc(token2.lineWidth).mul(-1).equal(),
        [`${componentCls}-affix-wrapper`]: {
          borderRadius: 0
        }
      },
      [`${componentCls}-group-wrapper:not(:last-child)`]: {
        [`&${componentCls}-search > ${componentCls}-group`]: {
          [`& > ${componentCls}-group-addon > ${componentCls}-search-button`]: {
            borderRadius: 0
          },
          [`& > ${componentCls}`]: {
            borderStartStartRadius: token2.borderRadius,
            borderStartEndRadius: 0,
            borderEndEndRadius: 0,
            borderEndStartRadius: token2.borderRadius
          }
        }
      }
    })
  };
};
var genInputStyle = (token2) => {
  const {
    componentCls,
    controlHeightSM,
    lineWidth,
    calc
  } = token2;
  const FIXED_CHROME_COLOR_HEIGHT = 16;
  const colorSmallPadding = calc(controlHeightSM).sub(calc(lineWidth).mul(2)).sub(FIXED_CHROME_COLOR_HEIGHT).div(2).equal();
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), genBasicInputStyle(token2)), genOutlinedStyle2(token2)), genFilledStyle2(token2)), genBorderlessStyle2(token2)), {
      '&[type="color"]': {
        height: token2.controlHeight,
        [`&${componentCls}-lg`]: {
          height: token2.controlHeightLG
        },
        [`&${componentCls}-sm`]: {
          height: controlHeightSM,
          paddingTop: colorSmallPadding,
          paddingBottom: colorSmallPadding
        }
      },
      '&[type="search"]::-webkit-search-cancel-button, &[type="search"]::-webkit-search-decoration': {
        "-webkit-appearance": "none"
      }
    })
  };
};
var genAllowClearStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    // ========================= Input =========================
    [`${componentCls}-clear-icon`]: {
      margin: 0,
      color: token2.colorTextQuaternary,
      fontSize: token2.fontSizeIcon,
      verticalAlign: -1,
      // https://github.com/ant-design/ant-design/pull/18151
      // https://codesandbox.io/s/wizardly-sun-u10br
      cursor: "pointer",
      transition: `color ${token2.motionDurationSlow}`,
      "&:hover": {
        color: token2.colorTextTertiary
      },
      "&:active": {
        color: token2.colorText
      },
      "&-hidden": {
        visibility: "hidden"
      },
      "&-has-suffix": {
        margin: `0 ${unit(token2.inputAffixPadding)}`
      }
    }
  };
};
var genAffixStyle = (token2) => {
  const {
    componentCls,
    inputAffixPadding,
    colorTextDescription,
    motionDurationSlow,
    colorIcon,
    colorIconHover,
    iconCls
  } = token2;
  const affixCls = `${componentCls}-affix-wrapper`;
  return {
    [affixCls]: Object.assign(Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(token2)), {
      display: "inline-flex",
      [`&:not(${componentCls}-disabled):hover`]: {
        zIndex: 1,
        [`${componentCls}-search-with-button &`]: {
          zIndex: 0
        }
      },
      "&-focused, &:focus": {
        zIndex: 1
      },
      [`> input${componentCls}`]: {
        padding: 0,
        fontSize: "inherit",
        border: "none",
        borderRadius: 0,
        outline: "none",
        background: "transparent",
        color: "inherit",
        "&::-ms-reveal": {
          display: "none"
        },
        "&:focus": {
          boxShadow: "none !important"
        }
      },
      "&::before": {
        display: "inline-block",
        width: 0,
        visibility: "hidden",
        content: '"\\a0"'
      },
      [`${componentCls}`]: {
        "&-prefix, &-suffix": {
          display: "flex",
          flex: "none",
          alignItems: "center",
          "> *:not(:last-child)": {
            marginInlineEnd: token2.paddingXS
          }
        },
        "&-show-count-suffix": {
          color: colorTextDescription
        },
        "&-show-count-has-suffix": {
          marginInlineEnd: token2.paddingXXS
        },
        "&-prefix": {
          marginInlineEnd: inputAffixPadding
        },
        "&-suffix": {
          marginInlineStart: inputAffixPadding
        }
      }
    }), genAllowClearStyle(token2)), {
      // password
      [`${iconCls}${componentCls}-password-icon`]: {
        color: colorIcon,
        cursor: "pointer",
        transition: `all ${motionDurationSlow}`,
        "&:hover": {
          color: colorIconHover
        }
      }
    })
  };
};
var genGroupStyle2 = (token2) => {
  const {
    componentCls,
    borderRadiusLG,
    borderRadiusSM
  } = token2;
  return {
    [`${componentCls}-group`]: Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), genInputGroupStyle(token2)), {
      "&-rtl": {
        direction: "rtl"
      },
      "&-wrapper": Object.assign(Object.assign(Object.assign({
        display: "inline-block",
        width: "100%",
        textAlign: "start",
        verticalAlign: "top",
        "&-rtl": {
          direction: "rtl"
        },
        // Size
        "&-lg": {
          [`${componentCls}-group-addon`]: {
            borderRadius: borderRadiusLG,
            fontSize: token2.inputFontSizeLG
          }
        },
        "&-sm": {
          [`${componentCls}-group-addon`]: {
            borderRadius: borderRadiusSM
          }
        }
      }, genOutlinedGroupStyle(token2)), genFilledGroupStyle(token2)), {
        // '&-disabled': {
        //   [`${componentCls}-group-addon`]: {
        //     ...genDisabledStyle(token),
        //   },
        // },
        // Fix the issue of using icons in Space Compact mode
        // https://github.com/ant-design/ant-design/issues/42122
        [`&:not(${componentCls}-compact-first-item):not(${componentCls}-compact-last-item)${componentCls}-compact-item`]: {
          [`${componentCls}, ${componentCls}-group-addon`]: {
            borderRadius: 0
          }
        },
        [`&:not(${componentCls}-compact-last-item)${componentCls}-compact-first-item`]: {
          [`${componentCls}, ${componentCls}-group-addon`]: {
            borderStartEndRadius: 0,
            borderEndEndRadius: 0
          }
        },
        [`&:not(${componentCls}-compact-first-item)${componentCls}-compact-last-item`]: {
          [`${componentCls}, ${componentCls}-group-addon`]: {
            borderStartStartRadius: 0,
            borderEndStartRadius: 0
          }
        }
      })
    })
  };
};
var genSearchInputStyle = (token2) => {
  const {
    componentCls,
    antCls
  } = token2;
  const searchPrefixCls = `${componentCls}-search`;
  return {
    [searchPrefixCls]: {
      [`${componentCls}`]: {
        "&:hover, &:focus": {
          borderColor: token2.colorPrimaryHover,
          [`+ ${componentCls}-group-addon ${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
            borderInlineStartColor: token2.colorPrimaryHover
          }
        }
      },
      [`${componentCls}-affix-wrapper`]: {
        borderRadius: 0
      },
      // fix slight height diff in Firefox:
      // https://ant.design/components/auto-complete-cn/#components-auto-complete-demo-certain-category
      [`${componentCls}-lg`]: {
        lineHeight: token2.calc(token2.lineHeightLG).sub(2e-4).equal({
          unit: false
        })
      },
      [`> ${componentCls}-group`]: {
        [`> ${componentCls}-group-addon:last-child`]: {
          insetInlineStart: -1,
          padding: 0,
          border: 0,
          [`${searchPrefixCls}-button`]: {
            paddingTop: 0,
            paddingBottom: 0,
            borderStartStartRadius: 0,
            borderStartEndRadius: token2.borderRadius,
            borderEndEndRadius: token2.borderRadius,
            borderEndStartRadius: 0,
            boxShadow: "none"
          },
          [`${searchPrefixCls}-button:not(${antCls}-btn-primary)`]: {
            color: token2.colorTextDescription,
            "&:hover": {
              color: token2.colorPrimaryHover
            },
            "&:active": {
              color: token2.colorPrimaryActive
            },
            [`&${antCls}-btn-loading::before`]: {
              insetInlineStart: 0,
              insetInlineEnd: 0,
              insetBlockStart: 0,
              insetBlockEnd: 0
            }
          }
        }
      },
      [`${searchPrefixCls}-button`]: {
        height: token2.controlHeight,
        "&:hover, &:focus": {
          zIndex: 1
        }
      },
      [`&-large ${searchPrefixCls}-button`]: {
        height: token2.controlHeightLG
      },
      [`&-small ${searchPrefixCls}-button`]: {
        height: token2.controlHeightSM
      },
      "&-rtl": {
        direction: "rtl"
      },
      // ===================== Compact Item Customized Styles =====================
      [`&${componentCls}-compact-item`]: {
        [`&:not(${componentCls}-compact-last-item)`]: {
          [`${componentCls}-group-addon`]: {
            [`${componentCls}-search-button`]: {
              marginInlineEnd: token2.calc(token2.lineWidth).mul(-1).equal(),
              borderRadius: 0
            }
          }
        },
        [`&:not(${componentCls}-compact-first-item)`]: {
          [`${componentCls},${componentCls}-affix-wrapper`]: {
            borderRadius: 0
          }
        },
        [`> ${componentCls}-group-addon ${componentCls}-search-button,
        > ${componentCls},
        ${componentCls}-affix-wrapper`]: {
          "&:hover,&:focus,&:active": {
            zIndex: 2
          }
        },
        [`> ${componentCls}-affix-wrapper-focused`]: {
          zIndex: 2
        }
      }
    }
  };
};
var genTextAreaStyle = (token2) => {
  const {
    componentCls,
    paddingLG
  } = token2;
  const textareaPrefixCls = `${componentCls}-textarea`;
  return {
    [textareaPrefixCls]: {
      position: "relative",
      "&-show-count": {
        // https://github.com/ant-design/ant-design/issues/33049
        [`> ${componentCls}`]: {
          height: "100%"
        },
        [`${componentCls}-data-count`]: {
          position: "absolute",
          bottom: token2.calc(token2.fontSize).mul(token2.lineHeight).mul(-1).equal(),
          insetInlineEnd: 0,
          color: token2.colorTextDescription,
          whiteSpace: "nowrap",
          pointerEvents: "none"
        }
      },
      "&-allow-clear": {
        [`> ${componentCls}`]: {
          paddingInlineEnd: paddingLG
        }
      },
      [`&-affix-wrapper${textareaPrefixCls}-has-feedback`]: {
        [`${componentCls}`]: {
          paddingInlineEnd: paddingLG
        }
      },
      [`&-affix-wrapper${componentCls}-affix-wrapper`]: {
        padding: 0,
        [`> textarea${componentCls}`]: {
          fontSize: "inherit",
          border: "none",
          outline: "none",
          background: "transparent",
          "&:focus": {
            boxShadow: "none !important"
          }
        },
        [`${componentCls}-suffix`]: {
          margin: 0,
          "> *:not(:last-child)": {
            marginInline: 0
          },
          // Clear Icon
          [`${componentCls}-clear-icon`]: {
            position: "absolute",
            insetInlineEnd: token2.paddingXS,
            insetBlockStart: token2.paddingXS
          },
          // Feedback Icon
          [`${textareaPrefixCls}-suffix`]: {
            position: "absolute",
            top: 0,
            insetInlineEnd: token2.paddingInline,
            bottom: 0,
            zIndex: 1,
            display: "inline-flex",
            alignItems: "center",
            margin: "auto",
            pointerEvents: "none"
          }
        }
      }
    }
  };
};
var genRangeStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-out-of-range`]: {
      [`&, & input, & textarea, ${componentCls}-show-count-suffix, ${componentCls}-data-count`]: {
        color: token2.colorError
      }
    }
  };
};
var style_default9 = genStyleHooks("Input", (token2) => {
  const inputToken = merge2(token2, initInputToken(token2));
  return [
    genInputStyle(inputToken),
    genTextAreaStyle(inputToken),
    genAffixStyle(inputToken),
    genGroupStyle2(inputToken),
    genSearchInputStyle(inputToken),
    genRangeStyle(inputToken),
    // =====================================================
    // ==             Space Compact                       ==
    // =====================================================
    genCompactItemStyle(inputToken)
  ];
}, initComponentToken);

// ../../node_modules/rc-input/es/BaseInput.js
var import_classnames45 = __toESM(require_classnames());
var import_react60 = __toESM(require("react"));

// ../../node_modules/rc-input/es/utils/commonUtils.js
function hasAddon(props) {
  return !!(props.addonBefore || props.addonAfter);
}
function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}
function resolveOnChange(target, e, onChange, targetValue) {
  if (!onChange) {
    return;
  }
  var event = e;
  if (e.type === "click") {
    var currentTarget = target.cloneNode(true);
    event = Object.create(e, {
      target: {
        value: currentTarget
      },
      currentTarget: {
        value: currentTarget
      }
    });
    currentTarget.value = "";
    onChange(event);
    return;
  }
  if (target.type !== "file" && targetValue !== void 0) {
    var _currentTarget = target.cloneNode(true);
    event = Object.create(e, {
      target: {
        value: _currentTarget
      },
      currentTarget: {
        value: _currentTarget
      }
    });
    _currentTarget.value = targetValue;
    onChange(event);
    return;
  }
  onChange(event);
}

// ../../node_modules/rc-input/es/BaseInput.js
var BaseInput = function BaseInput2(props) {
  var _element$props, _element$props2;
  var inputEl = props.inputElement, children = props.children, prefixCls = props.prefixCls, prefix = props.prefix, suffix = props.suffix, addonBefore = props.addonBefore, addonAfter = props.addonAfter, className = props.className, style2 = props.style, disabled = props.disabled, readOnly = props.readOnly, focused = props.focused, triggerFocus3 = props.triggerFocus, allowClear = props.allowClear, value = props.value, handleReset = props.handleReset, hidden = props.hidden, classes = props.classes, classNames54 = props.classNames, dataAttrs = props.dataAttrs, styles = props.styles, components = props.components;
  var inputElement = children !== null && children !== void 0 ? children : inputEl;
  var AffixWrapperComponent = (components === null || components === void 0 ? void 0 : components.affixWrapper) || "span";
  var GroupWrapperComponent = (components === null || components === void 0 ? void 0 : components.groupWrapper) || "span";
  var WrapperComponent = (components === null || components === void 0 ? void 0 : components.wrapper) || "span";
  var GroupAddonComponent = (components === null || components === void 0 ? void 0 : components.groupAddon) || "span";
  var containerRef = (0, import_react60.useRef)(null);
  var onInputClick = function onInputClick2(e) {
    var _containerRef$current;
    if ((_containerRef$current = containerRef.current) !== null && _containerRef$current !== void 0 && _containerRef$current.contains(e.target)) {
      triggerFocus3 === null || triggerFocus3 === void 0 || triggerFocus3();
    }
  };
  var hasAffix = hasPrefixSuffix(props);
  var element = /* @__PURE__ */ (0, import_react60.cloneElement)(inputElement, {
    value,
    className: (0, import_classnames45.default)(inputElement.props.className, !hasAffix && (classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.variant)) || null
  });
  if (hasAffix) {
    var _clsx2;
    var clearIcon = null;
    if (allowClear) {
      var _clsx;
      var needClear = !disabled && !readOnly && value;
      var clearIconCls = "".concat(prefixCls, "-clear-icon");
      var iconNode = _typeof(allowClear) === "object" && allowClear !== null && allowClear !== void 0 && allowClear.clearIcon ? allowClear.clearIcon : "\u2716";
      clearIcon = /* @__PURE__ */ import_react60.default.createElement("span", {
        onClick: handleReset,
        onMouseDown: function onMouseDown(e) {
          return e.preventDefault();
        },
        className: (0, import_classnames45.default)(clearIconCls, (_clsx = {}, _defineProperty(_clsx, "".concat(clearIconCls, "-hidden"), !needClear), _defineProperty(_clsx, "".concat(clearIconCls, "-has-suffix"), !!suffix), _clsx)),
        role: "button",
        tabIndex: -1
      }, iconNode);
    }
    var affixWrapperPrefixCls = "".concat(prefixCls, "-affix-wrapper");
    var affixWrapperCls = (0, import_classnames45.default)(affixWrapperPrefixCls, (_clsx2 = {}, _defineProperty(_clsx2, "".concat(prefixCls, "-disabled"), disabled), _defineProperty(_clsx2, "".concat(affixWrapperPrefixCls, "-disabled"), disabled), _defineProperty(_clsx2, "".concat(affixWrapperPrefixCls, "-focused"), focused), _defineProperty(_clsx2, "".concat(affixWrapperPrefixCls, "-readonly"), readOnly), _defineProperty(_clsx2, "".concat(affixWrapperPrefixCls, "-input-with-clear-btn"), suffix && allowClear && value), _clsx2), classes === null || classes === void 0 ? void 0 : classes.affixWrapper, classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.affixWrapper, classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.variant);
    var suffixNode = (suffix || allowClear) && /* @__PURE__ */ import_react60.default.createElement("span", {
      className: (0, import_classnames45.default)("".concat(prefixCls, "-suffix"), classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.suffix),
      style: styles === null || styles === void 0 ? void 0 : styles.suffix
    }, clearIcon, suffix);
    element = /* @__PURE__ */ import_react60.default.createElement(AffixWrapperComponent, _extends({
      className: affixWrapperCls,
      style: styles === null || styles === void 0 ? void 0 : styles.affixWrapper,
      onClick: onInputClick
    }, dataAttrs === null || dataAttrs === void 0 ? void 0 : dataAttrs.affixWrapper, {
      ref: containerRef
    }), prefix && /* @__PURE__ */ import_react60.default.createElement("span", {
      className: (0, import_classnames45.default)("".concat(prefixCls, "-prefix"), classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.prefix),
      style: styles === null || styles === void 0 ? void 0 : styles.prefix
    }, prefix), element, suffixNode);
  }
  if (hasAddon(props)) {
    var wrapperCls = "".concat(prefixCls, "-group");
    var addonCls = "".concat(wrapperCls, "-addon");
    var groupWrapperCls = "".concat(wrapperCls, "-wrapper");
    var mergedWrapperClassName = (0, import_classnames45.default)("".concat(prefixCls, "-wrapper"), wrapperCls, classes === null || classes === void 0 ? void 0 : classes.wrapper, classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.wrapper);
    var mergedGroupClassName = (0, import_classnames45.default)(groupWrapperCls, _defineProperty({}, "".concat(groupWrapperCls, "-disabled"), disabled), classes === null || classes === void 0 ? void 0 : classes.group, classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.groupWrapper);
    element = /* @__PURE__ */ import_react60.default.createElement(GroupWrapperComponent, {
      className: mergedGroupClassName
    }, /* @__PURE__ */ import_react60.default.createElement(WrapperComponent, {
      className: mergedWrapperClassName
    }, addonBefore && /* @__PURE__ */ import_react60.default.createElement(GroupAddonComponent, {
      className: addonCls
    }, addonBefore), element, addonAfter && /* @__PURE__ */ import_react60.default.createElement(GroupAddonComponent, {
      className: addonCls
    }, addonAfter)));
  }
  return /* @__PURE__ */ import_react60.default.cloneElement(element, {
    className: (0, import_classnames45.default)((_element$props = element.props) === null || _element$props === void 0 ? void 0 : _element$props.className, className) || null,
    style: _objectSpread2(_objectSpread2({}, (_element$props2 = element.props) === null || _element$props2 === void 0 ? void 0 : _element$props2.style), style2),
    hidden
  });
};
var BaseInput_default = BaseInput;

// ../../node_modules/rc-input/es/Input.js
var import_classnames46 = __toESM(require_classnames());
var import_react61 = __toESM(require("react"));

// ../../node_modules/rc-input/es/hooks/useCount.js
var React172 = __toESM(require("react"));
var _excluded21 = ["show"];
function useCount(count, showCount) {
  return React172.useMemo(function() {
    var mergedConfig = {};
    if (showCount) {
      mergedConfig.show = _typeof(showCount) === "object" && showCount.formatter ? showCount.formatter : !!showCount;
    }
    mergedConfig = _objectSpread2(_objectSpread2({}, mergedConfig), count);
    var _ref = mergedConfig, show = _ref.show, rest = _objectWithoutProperties(_ref, _excluded21);
    return _objectSpread2(_objectSpread2({}, rest), {}, {
      show: !!show,
      showFormatter: typeof show === "function" ? show : void 0,
      strategy: rest.strategy || function(value) {
        return value.length;
      }
    });
  }, [count, showCount]);
}

// ../../node_modules/antd/es/input/Input.js
var import_react62 = __toESM(require("react"));
var import_classnames47 = __toESM(require_classnames());
function triggerFocus2(element, option) {
  if (!element) {
    return;
  }
  element.focus(option);
  const {
    cursor
  } = option || {};
  if (cursor) {
    const len = element.value.length;
    switch (cursor) {
      case "start":
        element.setSelectionRange(0, 0);
        break;
      case "end":
        element.setSelectionRange(len, len);
        break;
      default:
        element.setSelectionRange(0, len);
        break;
    }
  }
}

// ../../node_modules/antd/es/input/TextArea.js
var React177 = __toESM(require("react"));
var import_react64 = require("react");
var import_classnames50 = __toESM(require_classnames());

// ../../node_modules/rc-textarea/es/TextArea.js
var import_classnames49 = __toESM(require_classnames());
var import_react63 = __toESM(require("react"));

// ../../node_modules/rc-textarea/es/ResizableTextArea.js
var import_classnames48 = __toESM(require_classnames());
var React175 = __toESM(require("react"));

// ../../node_modules/rc-textarea/es/calculateNodeHeight.js
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important;\n  pointer-events: none !important;\n";
var SIZING_STYLE = ["letter-spacing", "line-height", "padding-top", "padding-bottom", "font-family", "font-weight", "font-size", "font-variant", "text-rendering", "text-transform", "width", "text-indent", "padding-left", "padding-right", "border-width", "box-sizing", "word-break", "white-space"];
var computedStyleCache = {};
var hiddenTextarea;
function calculateNodeStyling(node2) {
  var useCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var nodeRef = node2.getAttribute("id") || node2.getAttribute("data-reactid") || node2.getAttribute("name");
  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }
  var style2 = window.getComputedStyle(node2);
  var boxSizing = style2.getPropertyValue("box-sizing") || style2.getPropertyValue("-moz-box-sizing") || style2.getPropertyValue("-webkit-box-sizing");
  var paddingSize = parseFloat(style2.getPropertyValue("padding-bottom")) + parseFloat(style2.getPropertyValue("padding-top"));
  var borderSize = parseFloat(style2.getPropertyValue("border-bottom-width")) + parseFloat(style2.getPropertyValue("border-top-width"));
  var sizingStyle = SIZING_STYLE.map(function(name) {
    return "".concat(name, ":").concat(style2.getPropertyValue(name));
  }).join(";");
  var nodeInfo = {
    sizingStyle,
    paddingSize,
    borderSize,
    boxSizing
  };
  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }
  return nodeInfo;
}
function calculateAutoSizeStyle(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement("textarea");
    hiddenTextarea.setAttribute("tab-index", "-1");
    hiddenTextarea.setAttribute("aria-hidden", "true");
    document.body.appendChild(hiddenTextarea);
  }
  if (uiTextNode.getAttribute("wrap")) {
    hiddenTextarea.setAttribute("wrap", uiTextNode.getAttribute("wrap"));
  } else {
    hiddenTextarea.removeAttribute("wrap");
  }
  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache), paddingSize = _calculateNodeStyling.paddingSize, borderSize = _calculateNodeStyling.borderSize, boxSizing = _calculateNodeStyling.boxSizing, sizingStyle = _calculateNodeStyling.sizingStyle;
  hiddenTextarea.setAttribute("style", "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || "";
  var minHeight = void 0;
  var maxHeight = void 0;
  var overflowY;
  var height = hiddenTextarea.scrollHeight;
  if (boxSizing === "border-box") {
    height += borderSize;
  } else if (boxSizing === "content-box") {
    height -= paddingSize;
  }
  if (minRows !== null || maxRows !== null) {
    hiddenTextarea.value = " ";
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;
    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;
      if (boxSizing === "border-box") {
        minHeight = minHeight + paddingSize + borderSize;
      }
      height = Math.max(minHeight, height);
    }
    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;
      if (boxSizing === "border-box") {
        maxHeight = maxHeight + paddingSize + borderSize;
      }
      overflowY = height > maxHeight ? "" : "hidden";
      height = Math.min(maxHeight, height);
    }
  }
  var style2 = {
    height,
    overflowY,
    resize: "none"
  };
  if (minHeight) {
    style2.minHeight = minHeight;
  }
  if (maxHeight) {
    style2.maxHeight = maxHeight;
  }
  return style2;
}

// ../../node_modules/rc-textarea/es/ResizableTextArea.js
var _excluded25 = ["prefixCls", "onPressEnter", "defaultValue", "value", "autoSize", "onResize", "className", "style", "disabled", "onChange", "onInternalAutoSize"];
var RESIZE_START = 0;
var RESIZE_MEASURING = 1;
var RESIZE_STABLE = 2;
var ResizableTextArea = /* @__PURE__ */ React175.forwardRef(function(props, ref) {
  var _ref = props, prefixCls = _ref.prefixCls, onPressEnter = _ref.onPressEnter, defaultValue = _ref.defaultValue, value = _ref.value, autoSize = _ref.autoSize, onResize2 = _ref.onResize, className = _ref.className, style2 = _ref.style, disabled = _ref.disabled, onChange = _ref.onChange, onInternalAutoSize = _ref.onInternalAutoSize, restProps = _objectWithoutProperties(_ref, _excluded25);
  var _useMergedState = useMergedState(defaultValue, {
    value,
    postState: function postState(val) {
      return val !== null && val !== void 0 ? val : "";
    }
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), mergedValue = _useMergedState2[0], setMergedValue = _useMergedState2[1];
  var onInternalChange = function onInternalChange2(event) {
    setMergedValue(event.target.value);
    onChange === null || onChange === void 0 || onChange(event);
  };
  var textareaRef = React175.useRef();
  React175.useImperativeHandle(ref, function() {
    return {
      textArea: textareaRef.current
    };
  });
  var _React$useMemo = React175.useMemo(function() {
    if (autoSize && _typeof(autoSize) === "object") {
      return [autoSize.minRows, autoSize.maxRows];
    }
    return [];
  }, [autoSize]), _React$useMemo2 = _slicedToArray(_React$useMemo, 2), minRows = _React$useMemo2[0], maxRows = _React$useMemo2[1];
  var needAutoSize = !!autoSize;
  var fixFirefoxAutoScroll = function fixFirefoxAutoScroll2() {
    try {
      if (document.activeElement === textareaRef.current) {
        var _textareaRef$current = textareaRef.current, selectionStart = _textareaRef$current.selectionStart, selectionEnd = _textareaRef$current.selectionEnd, scrollTop = _textareaRef$current.scrollTop;
        textareaRef.current.setSelectionRange(selectionStart, selectionEnd);
        textareaRef.current.scrollTop = scrollTop;
      }
    } catch (e) {
    }
  };
  var _React$useState = React175.useState(RESIZE_STABLE), _React$useState2 = _slicedToArray(_React$useState, 2), resizeState = _React$useState2[0], setResizeState = _React$useState2[1];
  var _React$useState3 = React175.useState(), _React$useState4 = _slicedToArray(_React$useState3, 2), autoSizeStyle = _React$useState4[0], setAutoSizeStyle = _React$useState4[1];
  var startResize = function startResize2() {
    setResizeState(RESIZE_START);
    if (process.env.NODE_ENV === "test") {
      onInternalAutoSize === null || onInternalAutoSize === void 0 || onInternalAutoSize();
    }
  };
  useLayoutEffect_default(function() {
    if (needAutoSize) {
      startResize();
    }
  }, [value, minRows, maxRows, needAutoSize]);
  useLayoutEffect_default(function() {
    if (resizeState === RESIZE_START) {
      setResizeState(RESIZE_MEASURING);
    } else if (resizeState === RESIZE_MEASURING) {
      var textareaStyles = calculateAutoSizeStyle(textareaRef.current, false, minRows, maxRows);
      setResizeState(RESIZE_STABLE);
      setAutoSizeStyle(textareaStyles);
    } else {
      fixFirefoxAutoScroll();
    }
  }, [resizeState]);
  var resizeRafRef = React175.useRef();
  var cleanRaf = function cleanRaf2() {
    raf_default.cancel(resizeRafRef.current);
  };
  var onInternalResize = function onInternalResize2(size) {
    if (resizeState === RESIZE_STABLE) {
      onResize2 === null || onResize2 === void 0 || onResize2(size);
      if (autoSize) {
        cleanRaf();
        resizeRafRef.current = raf_default(function() {
          startResize();
        });
      }
    }
  };
  React175.useEffect(function() {
    return cleanRaf;
  }, []);
  var mergedAutoSizeStyle = needAutoSize ? autoSizeStyle : null;
  var mergedStyle = _objectSpread2(_objectSpread2({}, style2), mergedAutoSizeStyle);
  if (resizeState === RESIZE_START || resizeState === RESIZE_MEASURING) {
    mergedStyle.overflowY = "hidden";
    mergedStyle.overflowX = "hidden";
  }
  return /* @__PURE__ */ React175.createElement(es_default, {
    onResize: onInternalResize,
    disabled: !(autoSize || onResize2)
  }, /* @__PURE__ */ React175.createElement("textarea", _extends({}, restProps, {
    ref: textareaRef,
    style: mergedStyle,
    className: (0, import_classnames48.default)(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)),
    disabled,
    value: mergedValue,
    onChange: onInternalChange
  })));
});
var ResizableTextArea_default = ResizableTextArea;

// ../../node_modules/rc-textarea/es/TextArea.js
var _excluded26 = ["defaultValue", "value", "onFocus", "onBlur", "onChange", "allowClear", "maxLength", "onCompositionStart", "onCompositionEnd", "suffix", "prefixCls", "showCount", "count", "className", "style", "disabled", "hidden", "classNames", "styles", "onResize"];
var TextArea = /* @__PURE__ */ import_react63.default.forwardRef(function(_ref, ref) {
  var _countConfig$max, _clsx;
  var defaultValue = _ref.defaultValue, customValue = _ref.value, onFocus = _ref.onFocus, onBlur = _ref.onBlur, onChange = _ref.onChange, allowClear = _ref.allowClear, maxLength = _ref.maxLength, onCompositionStart = _ref.onCompositionStart, onCompositionEnd = _ref.onCompositionEnd, suffix = _ref.suffix, _ref$prefixCls = _ref.prefixCls, prefixCls = _ref$prefixCls === void 0 ? "rc-textarea" : _ref$prefixCls, showCount = _ref.showCount, count = _ref.count, className = _ref.className, style2 = _ref.style, disabled = _ref.disabled, hidden = _ref.hidden, classNames54 = _ref.classNames, styles = _ref.styles, onResize2 = _ref.onResize, rest = _objectWithoutProperties(_ref, _excluded26);
  var _useMergedState = useMergedState(defaultValue, {
    value: customValue,
    defaultValue
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), value = _useMergedState2[0], setValue = _useMergedState2[1];
  var formatValue = value === void 0 || value === null ? "" : String(value);
  var _React$useState = import_react63.default.useState(false), _React$useState2 = _slicedToArray(_React$useState, 2), focused = _React$useState2[0], setFocused = _React$useState2[1];
  var compositionRef = import_react63.default.useRef(false);
  var _React$useState3 = import_react63.default.useState(null), _React$useState4 = _slicedToArray(_React$useState3, 2), textareaResized = _React$useState4[0], setTextareaResized = _React$useState4[1];
  var resizableTextAreaRef = (0, import_react63.useRef)(null);
  var getTextArea = function getTextArea2() {
    var _resizableTextAreaRef;
    return (_resizableTextAreaRef = resizableTextAreaRef.current) === null || _resizableTextAreaRef === void 0 ? void 0 : _resizableTextAreaRef.textArea;
  };
  var focus2 = function focus3() {
    getTextArea().focus();
  };
  (0, import_react63.useImperativeHandle)(ref, function() {
    return {
      resizableTextArea: resizableTextAreaRef.current,
      focus: focus2,
      blur: function blur2() {
        getTextArea().blur();
      }
    };
  });
  (0, import_react63.useEffect)(function() {
    setFocused(function(prev2) {
      return !disabled && prev2;
    });
  }, [disabled]);
  var _React$useState5 = import_react63.default.useState(null), _React$useState6 = _slicedToArray(_React$useState5, 2), selection = _React$useState6[0], setSelection = _React$useState6[1];
  import_react63.default.useEffect(function() {
    if (selection) {
      var _getTextArea;
      (_getTextArea = getTextArea()).setSelectionRange.apply(_getTextArea, _toConsumableArray(selection));
    }
  }, [selection]);
  var countConfig = useCount(count, showCount);
  var mergedMax = (_countConfig$max = countConfig.max) !== null && _countConfig$max !== void 0 ? _countConfig$max : maxLength;
  var hasMaxLength = Number(mergedMax) > 0;
  var valueLength = countConfig.strategy(formatValue);
  var isOutOfRange = !!mergedMax && valueLength > mergedMax;
  var triggerChange = function triggerChange2(e, currentValue) {
    var cutValue = currentValue;
    if (!compositionRef.current && countConfig.exceedFormatter && countConfig.max && countConfig.strategy(currentValue) > countConfig.max) {
      cutValue = countConfig.exceedFormatter(currentValue, {
        max: countConfig.max
      });
      if (currentValue !== cutValue) {
        setSelection([getTextArea().selectionStart || 0, getTextArea().selectionEnd || 0]);
      }
    }
    setValue(cutValue);
    resolveOnChange(e.currentTarget, e, onChange, cutValue);
  };
  var onInternalCompositionStart = function onInternalCompositionStart2(e) {
    compositionRef.current = true;
    onCompositionStart === null || onCompositionStart === void 0 || onCompositionStart(e);
  };
  var onInternalCompositionEnd = function onInternalCompositionEnd2(e) {
    compositionRef.current = false;
    triggerChange(e, e.currentTarget.value);
    onCompositionEnd === null || onCompositionEnd === void 0 || onCompositionEnd(e);
  };
  var onInternalChange = function onInternalChange2(e) {
    triggerChange(e, e.target.value);
  };
  var handleKeyDown = function handleKeyDown2(e) {
    var onPressEnter = rest.onPressEnter, onKeyDown = rest.onKeyDown;
    if (e.key === "Enter" && onPressEnter) {
      onPressEnter(e);
    }
    onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
  };
  var handleFocus = function handleFocus2(e) {
    setFocused(true);
    onFocus === null || onFocus === void 0 || onFocus(e);
  };
  var handleBlur = function handleBlur2(e) {
    setFocused(false);
    onBlur === null || onBlur === void 0 || onBlur(e);
  };
  var handleReset = function handleReset2(e) {
    setValue("");
    focus2();
    resolveOnChange(getTextArea(), e, onChange);
  };
  var suffixNode = suffix;
  var dataCount;
  if (countConfig.show) {
    if (countConfig.showFormatter) {
      dataCount = countConfig.showFormatter({
        value: formatValue,
        count: valueLength,
        maxLength: mergedMax
      });
    } else {
      dataCount = "".concat(valueLength).concat(hasMaxLength ? " / ".concat(mergedMax) : "");
    }
    suffixNode = /* @__PURE__ */ import_react63.default.createElement(import_react63.default.Fragment, null, suffixNode, /* @__PURE__ */ import_react63.default.createElement("span", {
      className: (0, import_classnames49.default)("".concat(prefixCls, "-data-count"), classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.count),
      style: styles === null || styles === void 0 ? void 0 : styles.count
    }, dataCount));
  }
  var handleResize = function handleResize2(size) {
    var _getTextArea2;
    onResize2 === null || onResize2 === void 0 || onResize2(size);
    if ((_getTextArea2 = getTextArea()) !== null && _getTextArea2 !== void 0 && _getTextArea2.style.height) {
      setTextareaResized(true);
    }
  };
  var isPureTextArea = !rest.autoSize && !showCount && !allowClear;
  return /* @__PURE__ */ import_react63.default.createElement(BaseInput_default, {
    value: formatValue,
    allowClear,
    handleReset,
    suffix: suffixNode,
    prefixCls,
    classNames: _objectSpread2(_objectSpread2({}, classNames54), {}, {
      affixWrapper: (0, import_classnames49.default)(classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.affixWrapper, (_clsx = {}, _defineProperty(_clsx, "".concat(prefixCls, "-show-count"), showCount), _defineProperty(_clsx, "".concat(prefixCls, "-textarea-allow-clear"), allowClear), _clsx))
    }),
    disabled,
    focused,
    className: (0, import_classnames49.default)(className, isOutOfRange && "".concat(prefixCls, "-out-of-range")),
    style: _objectSpread2(_objectSpread2({}, style2), textareaResized && !isPureTextArea ? {
      height: "auto"
    } : {}),
    dataAttrs: {
      affixWrapper: {
        "data-count": typeof dataCount === "string" ? dataCount : void 0
      }
    },
    hidden
  }, /* @__PURE__ */ import_react63.default.createElement(ResizableTextArea_default, _extends({}, rest, {
    maxLength,
    onKeyDown: handleKeyDown,
    onChange: onInternalChange,
    onFocus: handleFocus,
    onBlur: handleBlur,
    onCompositionStart: onInternalCompositionStart,
    onCompositionEnd: onInternalCompositionEnd,
    className: (0, import_classnames49.default)(classNames54 === null || classNames54 === void 0 ? void 0 : classNames54.textarea),
    style: _objectSpread2(_objectSpread2({}, styles === null || styles === void 0 ? void 0 : styles.textarea), {}, {
      resize: style2 === null || style2 === void 0 ? void 0 : style2.resize
    }),
    disabled,
    prefixCls,
    onResize: handleResize,
    ref: resizableTextAreaRef
  })));
});
var TextArea_default = TextArea;

// ../../node_modules/rc-textarea/es/index.js
var es_default11 = TextArea_default;

// ../../node_modules/antd/es/input/TextArea.js
var __rest16 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var TextArea2 = /* @__PURE__ */ (0, import_react64.forwardRef)((props, ref) => {
  var _a;
  const {
    prefixCls: customizePrefixCls,
    bordered = true,
    size: customizeSize,
    disabled: customDisabled,
    status: customStatus,
    allowClear,
    classNames: classes,
    rootClassName,
    className,
    variant: customVariant
  } = props, rest = __rest16(props, ["prefixCls", "bordered", "size", "disabled", "status", "allowClear", "classNames", "rootClassName", "className", "variant"]);
  if (process.env.NODE_ENV !== "production") {
    const {
      deprecated
    } = devUseWarning("TextArea");
    deprecated(!("bordered" in props), "bordered", "variant");
  }
  const {
    getPrefixCls,
    direction
  } = React177.useContext(ConfigContext);
  const mergedSize = useSize_default(customizeSize);
  const disabled = React177.useContext(DisabledContext_default);
  const mergedDisabled = customDisabled !== null && customDisabled !== void 0 ? customDisabled : disabled;
  const {
    status: contextStatus,
    hasFeedback,
    feedbackIcon
  } = React177.useContext(FormItemInputContext);
  const mergedStatus = getMergedStatus(contextStatus, customStatus);
  const innerRef = React177.useRef(null);
  React177.useImperativeHandle(ref, () => {
    var _a2;
    return {
      resizableTextArea: (_a2 = innerRef.current) === null || _a2 === void 0 ? void 0 : _a2.resizableTextArea,
      focus: (option) => {
        var _a3, _b;
        triggerFocus2((_b = (_a3 = innerRef.current) === null || _a3 === void 0 ? void 0 : _a3.resizableTextArea) === null || _b === void 0 ? void 0 : _b.textArea, option);
      },
      blur: () => {
        var _a3;
        return (_a3 = innerRef.current) === null || _a3 === void 0 ? void 0 : _a3.blur();
      }
    };
  });
  const prefixCls = getPrefixCls("input", customizePrefixCls);
  let mergedAllowClear;
  if (typeof allowClear === "object" && (allowClear === null || allowClear === void 0 ? void 0 : allowClear.clearIcon)) {
    mergedAllowClear = allowClear;
  } else if (allowClear) {
    mergedAllowClear = {
      clearIcon: /* @__PURE__ */ React177.createElement(CloseCircleFilled_default2, null)
    };
  }
  const rootCls = useCSSVarCls_default(prefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default9(prefixCls, rootCls);
  const [variant, enableVariantCls] = useVariants_default(customVariant, bordered);
  return wrapCSSVar(/* @__PURE__ */ React177.createElement(es_default11, Object.assign({}, rest, {
    disabled: mergedDisabled,
    allowClear: mergedAllowClear,
    className: (0, import_classnames50.default)(cssVarCls, rootCls, className, rootClassName),
    classNames: Object.assign(Object.assign({}, classes), {
      textarea: (0, import_classnames50.default)({
        [`${prefixCls}-sm`]: mergedSize === "small",
        [`${prefixCls}-lg`]: mergedSize === "large"
      }, hashId, classes === null || classes === void 0 ? void 0 : classes.textarea),
      variant: (0, import_classnames50.default)({
        [`${prefixCls}-${variant}`]: enableVariantCls
      }, getStatusClassNames(prefixCls, mergedStatus)),
      affixWrapper: (0, import_classnames50.default)(`${prefixCls}-textarea-affix-wrapper`, {
        [`${prefixCls}-affix-wrapper-rtl`]: direction === "rtl",
        [`${prefixCls}-affix-wrapper-sm`]: mergedSize === "small",
        [`${prefixCls}-affix-wrapper-lg`]: mergedSize === "large",
        [`${prefixCls}-textarea-show-count`]: props.showCount || ((_a = props.count) === null || _a === void 0 ? void 0 : _a.show)
      }, hashId)
    }),
    prefixCls,
    suffix: hasFeedback && /* @__PURE__ */ React177.createElement("span", {
      className: `${prefixCls}-textarea-suffix`
    }, feedbackIcon),
    ref: innerRef
  })));
});
var TextArea_default2 = TextArea2;

// ../../node_modules/@ant-design/icons/es/icons/DoubleLeftOutlined.js
var React178 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/DoubleLeftOutlined.js
var DoubleLeftOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 000 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z" } }] }, "name": "double-left", "theme": "outlined" };
var DoubleLeftOutlined_default = DoubleLeftOutlined;

// ../../node_modules/@ant-design/icons/es/icons/DoubleLeftOutlined.js
var DoubleLeftOutlined2 = function DoubleLeftOutlined3(props, ref) {
  return /* @__PURE__ */ React178.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: DoubleLeftOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  DoubleLeftOutlined2.displayName = "DoubleLeftOutlined";
}
var DoubleLeftOutlined_default2 = /* @__PURE__ */ React178.forwardRef(DoubleLeftOutlined2);

// ../../node_modules/@ant-design/icons/es/icons/DoubleRightOutlined.js
var React179 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/DoubleRightOutlined.js
var DoubleRightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 00188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 00492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z" } }] }, "name": "double-right", "theme": "outlined" };
var DoubleRightOutlined_default = DoubleRightOutlined;

// ../../node_modules/@ant-design/icons/es/icons/DoubleRightOutlined.js
var DoubleRightOutlined2 = function DoubleRightOutlined3(props, ref) {
  return /* @__PURE__ */ React179.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: DoubleRightOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  DoubleRightOutlined2.displayName = "DoubleRightOutlined";
}
var DoubleRightOutlined_default2 = /* @__PURE__ */ React179.forwardRef(DoubleRightOutlined2);

// ../../node_modules/antd/es/pagination/Pagination.js
var import_classnames53 = __toESM(require_classnames());

// ../../node_modules/rc-pagination/es/Pagination.js
var import_classnames52 = __toESM(require_classnames());
var import_react67 = __toESM(require("react"));

// ../../node_modules/rc-pagination/es/locale/zh_CN.js
var locale5 = {
  // Options
  items_per_page: "\u6761/\u9875",
  jump_to: "\u8DF3\u81F3",
  jump_to_confirm: "\u786E\u5B9A",
  page: "\u9875",
  // Pagination
  prev_page: "\u4E0A\u4E00\u9875",
  next_page: "\u4E0B\u4E00\u9875",
  prev_5: "\u5411\u524D 5 \u9875",
  next_5: "\u5411\u540E 5 \u9875",
  prev_3: "\u5411\u524D 3 \u9875",
  next_3: "\u5411\u540E 3 \u9875",
  page_size: "\u9875\u7801"
};
var zh_CN_default = locale5;

// ../../node_modules/rc-pagination/es/Options.js
var import_react65 = __toESM(require("react"));
var defaultPageSizeOptions = ["10", "20", "50", "100"];
var Options = function Options2(props) {
  var _props$pageSizeOption = props.pageSizeOptions, pageSizeOptions = _props$pageSizeOption === void 0 ? defaultPageSizeOptions : _props$pageSizeOption, locale6 = props.locale, changeSize = props.changeSize, pageSize = props.pageSize, goButton = props.goButton, quickGo = props.quickGo, rootPrefixCls = props.rootPrefixCls, Select3 = props.selectComponentClass, selectPrefixCls = props.selectPrefixCls, disabled = props.disabled, buildOptionText = props.buildOptionText;
  var _React$useState = import_react65.default.useState(""), _React$useState2 = _slicedToArray(_React$useState, 2), goInputText = _React$useState2[0], setGoInputText = _React$useState2[1];
  var getValidValue = function getValidValue2() {
    return !goInputText || Number.isNaN(goInputText) ? void 0 : Number(goInputText);
  };
  var mergeBuildOptionText = typeof buildOptionText === "function" ? buildOptionText : function(value) {
    return "".concat(value, " ").concat(locale6.items_per_page);
  };
  var changeSizeHandle = function changeSizeHandle2(value) {
    changeSize === null || changeSize === void 0 || changeSize(Number(value));
  };
  var handleChange = function handleChange2(e) {
    setGoInputText(e.target.value);
  };
  var handleBlur = function handleBlur2(e) {
    if (goButton || goInputText === "") {
      return;
    }
    setGoInputText("");
    if (e.relatedTarget && (e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item-link")) >= 0 || e.relatedTarget.className.indexOf("".concat(rootPrefixCls, "-item")) >= 0)) {
      return;
    }
    quickGo === null || quickGo === void 0 || quickGo(getValidValue());
  };
  var go = function go2(e) {
    if (goInputText === "") {
      return;
    }
    if (e.keyCode === KeyCode_default.ENTER || e.type === "click") {
      setGoInputText("");
      quickGo === null || quickGo === void 0 || quickGo(getValidValue());
    }
  };
  var getPageSizeOptions = function getPageSizeOptions2() {
    if (pageSizeOptions.some(function(option) {
      return option.toString() === pageSize.toString();
    })) {
      return pageSizeOptions;
    }
    return pageSizeOptions.concat([pageSize.toString()]).sort(function(a, b) {
      var numberA = Number.isNaN(Number(a)) ? 0 : Number(a);
      var numberB = Number.isNaN(Number(b)) ? 0 : Number(b);
      return numberA - numberB;
    });
  };
  var prefixCls = "".concat(rootPrefixCls, "-options");
  if (!changeSize && !quickGo) {
    return null;
  }
  var changeSelect = null;
  var goInput = null;
  var gotoButton = null;
  if (changeSize && Select3) {
    var options = getPageSizeOptions().map(function(opt, i) {
      return /* @__PURE__ */ import_react65.default.createElement(Select3.Option, {
        key: i,
        value: opt.toString()
      }, mergeBuildOptionText(opt));
    });
    changeSelect = /* @__PURE__ */ import_react65.default.createElement(Select3, {
      disabled,
      prefixCls: selectPrefixCls,
      showSearch: false,
      className: "".concat(prefixCls, "-size-changer"),
      optionLabelProp: "children",
      popupMatchSelectWidth: false,
      value: (pageSize || pageSizeOptions[0]).toString(),
      onChange: changeSizeHandle,
      getPopupContainer: function getPopupContainer(triggerNode) {
        return triggerNode.parentNode;
      },
      "aria-label": locale6.page_size,
      defaultOpen: false
    }, options);
  }
  if (quickGo) {
    if (goButton) {
      gotoButton = typeof goButton === "boolean" ? /* @__PURE__ */ import_react65.default.createElement("button", {
        type: "button",
        onClick: go,
        onKeyUp: go,
        disabled,
        className: "".concat(prefixCls, "-quick-jumper-button")
      }, locale6.jump_to_confirm) : /* @__PURE__ */ import_react65.default.createElement("span", {
        onClick: go,
        onKeyUp: go
      }, goButton);
    }
    goInput = /* @__PURE__ */ import_react65.default.createElement("div", {
      className: "".concat(prefixCls, "-quick-jumper")
    }, locale6.jump_to, /* @__PURE__ */ import_react65.default.createElement("input", {
      disabled,
      type: "text",
      value: goInputText,
      onChange: handleChange,
      onKeyUp: go,
      onBlur: handleBlur,
      "aria-label": locale6.page
    }), locale6.page, gotoButton);
  }
  return /* @__PURE__ */ import_react65.default.createElement("li", {
    className: prefixCls
  }, changeSelect, goInput);
};
if (process.env.NODE_ENV !== "production") {
  Options.displayName = "Options";
}
var Options_default = Options;

// ../../node_modules/rc-pagination/es/Pager.js
var import_classnames51 = __toESM(require_classnames());
var import_react66 = __toESM(require("react"));
var Pager = function Pager2(props) {
  var _classNames;
  var rootPrefixCls = props.rootPrefixCls, page = props.page, active = props.active, className = props.className, showTitle = props.showTitle, onClick = props.onClick, onKeyPress = props.onKeyPress, itemRender = props.itemRender;
  var prefixCls = "".concat(rootPrefixCls, "-item");
  var cls = (0, import_classnames51.default)(prefixCls, "".concat(prefixCls, "-").concat(page), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-active"), active), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), !page), _classNames), className);
  var handleClick = function handleClick2() {
    onClick(page);
  };
  var handleKeyPress = function handleKeyPress2(e) {
    onKeyPress(e, onClick, page);
  };
  var pager = itemRender(page, "page", /* @__PURE__ */ import_react66.default.createElement("a", {
    rel: "nofollow"
  }, page));
  return pager ? /* @__PURE__ */ import_react66.default.createElement("li", {
    title: showTitle ? String(page) : null,
    className: cls,
    onClick: handleClick,
    onKeyDown: handleKeyPress,
    tabIndex: 0
  }, pager) : null;
};
if (process.env.NODE_ENV !== "production") {
  Pager.displayName = "Pager";
}
var Pager_default = Pager;

// ../../node_modules/rc-pagination/es/Pagination.js
var defaultItemRender = function defaultItemRender2(page, type4, element) {
  return element;
};
function noop3() {
}
function isInteger(v) {
  var value = Number(v);
  return typeof value === "number" && !Number.isNaN(value) && isFinite(value) && Math.floor(value) === value;
}
function calculatePage(p, pageSize, total) {
  var _pageSize = typeof p === "undefined" ? pageSize : p;
  return Math.floor((total - 1) / _pageSize) + 1;
}
var Pagination = function Pagination2(props) {
  var _classNames5;
  var _props$prefixCls = props.prefixCls, prefixCls = _props$prefixCls === void 0 ? "rc-pagination" : _props$prefixCls, _props$selectPrefixCl = props.selectPrefixCls, selectPrefixCls = _props$selectPrefixCl === void 0 ? "rc-select" : _props$selectPrefixCl, className = props.className, selectComponentClass = props.selectComponentClass, currentProp = props.current, _props$defaultCurrent = props.defaultCurrent, defaultCurrent = _props$defaultCurrent === void 0 ? 1 : _props$defaultCurrent, _props$total = props.total, total = _props$total === void 0 ? 0 : _props$total, pageSizeProp = props.pageSize, _props$defaultPageSiz = props.defaultPageSize, defaultPageSize = _props$defaultPageSiz === void 0 ? 10 : _props$defaultPageSiz, _props$onChange = props.onChange, onChange = _props$onChange === void 0 ? noop3 : _props$onChange, hideOnSinglePage = props.hideOnSinglePage, _props$showPrevNextJu = props.showPrevNextJumpers, showPrevNextJumpers = _props$showPrevNextJu === void 0 ? true : _props$showPrevNextJu, showQuickJumper = props.showQuickJumper, showLessItems = props.showLessItems, _props$showTitle = props.showTitle, showTitle = _props$showTitle === void 0 ? true : _props$showTitle, _props$onShowSizeChan = props.onShowSizeChange, onShowSizeChange = _props$onShowSizeChan === void 0 ? noop3 : _props$onShowSizeChan, _props$locale = props.locale, locale6 = _props$locale === void 0 ? zh_CN_default : _props$locale, style2 = props.style, _props$totalBoundaryS = props.totalBoundaryShowSizeChanger, totalBoundaryShowSizeChanger = _props$totalBoundaryS === void 0 ? 50 : _props$totalBoundaryS, disabled = props.disabled, simple = props.simple, showTotal = props.showTotal, showSizeChangerProp = props.showSizeChanger, pageSizeOptions = props.pageSizeOptions, _props$itemRender = props.itemRender, itemRender = _props$itemRender === void 0 ? defaultItemRender : _props$itemRender, jumpPrevIcon = props.jumpPrevIcon, jumpNextIcon = props.jumpNextIcon, prevIcon = props.prevIcon, nextIcon = props.nextIcon;
  var paginationRef = import_react67.default.useRef(null);
  var _useMergedState = useMergedState(10, {
    value: pageSizeProp,
    defaultValue: defaultPageSize
  }), _useMergedState2 = _slicedToArray(_useMergedState, 2), pageSize = _useMergedState2[0], setPageSize = _useMergedState2[1];
  var _useMergedState3 = useMergedState(1, {
    value: currentProp,
    defaultValue: defaultCurrent,
    postState: function postState(c) {
      return Math.max(1, Math.min(c, calculatePage(void 0, pageSize, total)));
    }
  }), _useMergedState4 = _slicedToArray(_useMergedState3, 2), current = _useMergedState4[0], setCurrent = _useMergedState4[1];
  var _React$useState = import_react67.default.useState(current), _React$useState2 = _slicedToArray(_React$useState, 2), internalInputVal = _React$useState2[0], setInternalInputVal = _React$useState2[1];
  (0, import_react67.useEffect)(function() {
    setInternalInputVal(current);
  }, [current]);
  var hasOnChange = onChange !== noop3;
  var hasCurrent = "current" in props;
  if (process.env.NODE_ENV !== "production") {
    warning_default(hasCurrent ? hasOnChange : true, "You provided a `current` prop to a Pagination component without an `onChange` handler. This will render a read-only component.");
  }
  var jumpPrevPage = Math.max(1, current - (showLessItems ? 3 : 5));
  var jumpNextPage = Math.min(calculatePage(void 0, pageSize, total), current + (showLessItems ? 3 : 5));
  function getItemIcon(icon, label) {
    var iconNode = icon || /* @__PURE__ */ import_react67.default.createElement("button", {
      type: "button",
      "aria-label": label,
      className: "".concat(prefixCls, "-item-link")
    });
    if (typeof icon === "function") {
      iconNode = /* @__PURE__ */ import_react67.default.createElement(icon, _objectSpread2({}, props));
    }
    return iconNode;
  }
  function getValidValue(e) {
    var inputValue = e.target.value;
    var allPages2 = calculatePage(void 0, pageSize, total);
    var value;
    if (inputValue === "") {
      value = inputValue;
    } else if (Number.isNaN(Number(inputValue))) {
      value = internalInputVal;
    } else if (inputValue >= allPages2) {
      value = allPages2;
    } else {
      value = Number(inputValue);
    }
    return value;
  }
  function isValid(page) {
    return isInteger(page) && page !== current && isInteger(total) && total > 0;
  }
  var shouldDisplayQuickJumper = total > pageSize ? showQuickJumper : false;
  function handleKeyDown(event) {
    if (event.keyCode === KeyCode_default.UP || event.keyCode === KeyCode_default.DOWN) {
      event.preventDefault();
    }
  }
  function handleKeyUp(event) {
    var value = getValidValue(event);
    if (value !== internalInputVal) {
      setInternalInputVal(value);
    }
    switch (event.keyCode) {
      case KeyCode_default.ENTER:
        handleChange(value);
        break;
      case KeyCode_default.UP:
        handleChange(value - 1);
        break;
      case KeyCode_default.DOWN:
        handleChange(value + 1);
        break;
      default:
        break;
    }
  }
  function handleBlur(event) {
    handleChange(getValidValue(event));
  }
  function changePageSize(size) {
    var newCurrent = calculatePage(size, pageSize, total);
    var nextCurrent = current > newCurrent && newCurrent !== 0 ? newCurrent : current;
    setPageSize(size);
    setInternalInputVal(nextCurrent);
    onShowSizeChange === null || onShowSizeChange === void 0 || onShowSizeChange(current, size);
    setCurrent(nextCurrent);
    onChange === null || onChange === void 0 || onChange(nextCurrent, size);
  }
  function handleChange(page) {
    if (isValid(page) && !disabled) {
      var currentPage = calculatePage(void 0, pageSize, total);
      var newPage = page;
      if (page > currentPage) {
        newPage = currentPage;
      } else if (page < 1) {
        newPage = 1;
      }
      if (newPage !== internalInputVal) {
        setInternalInputVal(newPage);
      }
      setCurrent(newPage);
      onChange === null || onChange === void 0 || onChange(newPage, pageSize);
      return newPage;
    }
    return current;
  }
  var hasPrev = current > 1;
  var hasNext = current < calculatePage(void 0, pageSize, total);
  var showSizeChanger = showSizeChangerProp !== null && showSizeChangerProp !== void 0 ? showSizeChangerProp : total > totalBoundaryShowSizeChanger;
  function prevHandle() {
    if (hasPrev)
      handleChange(current - 1);
  }
  function nextHandle() {
    if (hasNext)
      handleChange(current + 1);
  }
  function jumpPrevHandle() {
    handleChange(jumpPrevPage);
  }
  function jumpNextHandle() {
    handleChange(jumpNextPage);
  }
  function runIfEnter(event, callback) {
    if (event.key === "Enter" || event.charCode === KeyCode_default.ENTER || event.keyCode === KeyCode_default.ENTER) {
      for (var _len = arguments.length, restParams = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        restParams[_key - 2] = arguments[_key];
      }
      callback.apply(void 0, restParams);
    }
  }
  function runIfEnterPrev(event) {
    runIfEnter(event, prevHandle);
  }
  function runIfEnterNext(event) {
    runIfEnter(event, nextHandle);
  }
  function runIfEnterJumpPrev(event) {
    runIfEnter(event, jumpPrevHandle);
  }
  function runIfEnterJumpNext(event) {
    runIfEnter(event, jumpNextHandle);
  }
  function renderPrev(prevPage2) {
    var prevButton = itemRender(prevPage2, "prev", getItemIcon(prevIcon, "prev page"));
    return /* @__PURE__ */ import_react67.default.isValidElement(prevButton) ? /* @__PURE__ */ import_react67.default.cloneElement(prevButton, {
      disabled: !hasPrev
    }) : prevButton;
  }
  function renderNext(nextPage2) {
    var nextButton = itemRender(nextPage2, "next", getItemIcon(nextIcon, "next page"));
    return /* @__PURE__ */ import_react67.default.isValidElement(nextButton) ? /* @__PURE__ */ import_react67.default.cloneElement(nextButton, {
      disabled: !hasNext
    }) : nextButton;
  }
  function handleGoTO(event) {
    if (event.type === "click" || event.keyCode === KeyCode_default.ENTER) {
      handleChange(internalInputVal);
    }
  }
  var jumpPrev = null;
  var dataOrAriaAttributeProps = pickAttrs(props, {
    aria: true,
    data: true
  });
  var totalText = showTotal && /* @__PURE__ */ import_react67.default.createElement("li", {
    className: "".concat(prefixCls, "-total-text")
  }, showTotal(total, [total === 0 ? 0 : (current - 1) * pageSize + 1, current * pageSize > total ? total : current * pageSize]));
  var jumpNext = null;
  var allPages = calculatePage(void 0, pageSize, total);
  if (hideOnSinglePage && total <= pageSize) {
    return null;
  }
  var pagerList = [];
  var pagerProps = {
    rootPrefixCls: prefixCls,
    onClick: handleChange,
    onKeyPress: runIfEnter,
    showTitle,
    itemRender,
    page: -1
  };
  var prevPage = current - 1 > 0 ? current - 1 : 0;
  var nextPage = current + 1 < allPages ? current + 1 : allPages;
  var goButton = showQuickJumper && showQuickJumper.goButton;
  var gotoButton = goButton;
  var simplePager = null;
  if (simple) {
    if (goButton) {
      if (typeof goButton === "boolean") {
        gotoButton = /* @__PURE__ */ import_react67.default.createElement("button", {
          type: "button",
          onClick: handleGoTO,
          onKeyUp: handleGoTO
        }, locale6.jump_to_confirm);
      } else {
        gotoButton = /* @__PURE__ */ import_react67.default.createElement("span", {
          onClick: handleGoTO,
          onKeyUp: handleGoTO
        }, goButton);
      }
      gotoButton = /* @__PURE__ */ import_react67.default.createElement("li", {
        title: showTitle ? "".concat(locale6.jump_to).concat(current, "/").concat(allPages) : null,
        className: "".concat(prefixCls, "-simple-pager")
      }, gotoButton);
    }
    simplePager = /* @__PURE__ */ import_react67.default.createElement("li", {
      title: showTitle ? "".concat(current, "/").concat(allPages) : null,
      className: "".concat(prefixCls, "-simple-pager")
    }, /* @__PURE__ */ import_react67.default.createElement("input", {
      type: "text",
      value: internalInputVal,
      disabled,
      onKeyDown: handleKeyDown,
      onKeyUp: handleKeyUp,
      onChange: handleKeyUp,
      onBlur: handleBlur,
      size: 3
    }), /* @__PURE__ */ import_react67.default.createElement("span", {
      className: "".concat(prefixCls, "-slash")
    }, "/"), allPages);
  }
  var pageBufferSize = showLessItems ? 1 : 2;
  if (allPages <= 3 + pageBufferSize * 2) {
    if (!allPages) {
      pagerList.push(/* @__PURE__ */ import_react67.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: "noPager",
        page: 1,
        className: "".concat(prefixCls, "-item-disabled")
      })));
    }
    for (var i = 1; i <= allPages; i += 1) {
      pagerList.push(/* @__PURE__ */ import_react67.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: i,
        page: i,
        active: current === i
      })));
    }
  } else {
    var prevItemTitle = showLessItems ? locale6.prev_3 : locale6.prev_5;
    var nextItemTitle = showLessItems ? locale6.next_3 : locale6.next_5;
    var jumpPrevContent = itemRender(jumpPrevPage, "jump-prev", getItemIcon(jumpPrevIcon, "prev page"));
    var jumpNextContent = itemRender(jumpNextPage, "jump-next", getItemIcon(jumpNextIcon, "next page"));
    if (showPrevNextJumpers) {
      jumpPrev = jumpPrevContent ? /* @__PURE__ */ import_react67.default.createElement("li", {
        title: showTitle ? prevItemTitle : null,
        key: "prev",
        onClick: jumpPrevHandle,
        tabIndex: 0,
        onKeyDown: runIfEnterJumpPrev,
        className: (0, import_classnames52.default)("".concat(prefixCls, "-jump-prev"), _defineProperty({}, "".concat(prefixCls, "-jump-prev-custom-icon"), !!jumpPrevIcon))
      }, jumpPrevContent) : null;
      jumpNext = jumpNextContent ? /* @__PURE__ */ import_react67.default.createElement("li", {
        title: showTitle ? nextItemTitle : null,
        key: "next",
        onClick: jumpNextHandle,
        tabIndex: 0,
        onKeyDown: runIfEnterJumpNext,
        className: (0, import_classnames52.default)("".concat(prefixCls, "-jump-next"), _defineProperty({}, "".concat(prefixCls, "-jump-next-custom-icon"), !!jumpNextIcon))
      }, jumpNextContent) : null;
    }
    var left = Math.max(1, current - pageBufferSize);
    var right = Math.min(current + pageBufferSize, allPages);
    if (current - 1 <= pageBufferSize) {
      right = 1 + pageBufferSize * 2;
    }
    if (allPages - current <= pageBufferSize) {
      left = allPages - pageBufferSize * 2;
    }
    for (var _i = left; _i <= right; _i += 1) {
      pagerList.push(/* @__PURE__ */ import_react67.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: _i,
        page: _i,
        active: current === _i
      })));
    }
    if (current - 1 >= pageBufferSize * 2 && current !== 1 + 2) {
      pagerList[0] = /* @__PURE__ */ import_react67.default.cloneElement(pagerList[0], {
        className: (0, import_classnames52.default)("".concat(prefixCls, "-item-after-jump-prev"), pagerList[0].props.className)
      });
      pagerList.unshift(jumpPrev);
    }
    if (allPages - current >= pageBufferSize * 2 && current !== allPages - 2) {
      var lastOne = pagerList[pagerList.length - 1];
      pagerList[pagerList.length - 1] = /* @__PURE__ */ import_react67.default.cloneElement(lastOne, {
        className: (0, import_classnames52.default)("".concat(prefixCls, "-item-before-jump-next"), lastOne.props.className)
      });
      pagerList.push(jumpNext);
    }
    if (left !== 1) {
      pagerList.unshift(/* @__PURE__ */ import_react67.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: 1,
        page: 1
      })));
    }
    if (right !== allPages) {
      pagerList.push(/* @__PURE__ */ import_react67.default.createElement(Pager_default, _extends({}, pagerProps, {
        key: allPages,
        page: allPages
      })));
    }
  }
  var prev2 = renderPrev(prevPage);
  if (prev2) {
    var prevDisabled = !hasPrev || !allPages;
    prev2 = /* @__PURE__ */ import_react67.default.createElement("li", {
      title: showTitle ? locale6.prev_page : null,
      onClick: prevHandle,
      tabIndex: prevDisabled ? null : 0,
      onKeyDown: runIfEnterPrev,
      className: (0, import_classnames52.default)("".concat(prefixCls, "-prev"), _defineProperty({}, "".concat(prefixCls, "-disabled"), prevDisabled)),
      "aria-disabled": prevDisabled
    }, prev2);
  }
  var next2 = renderNext(nextPage);
  if (next2) {
    var nextDisabled, nextTabIndex;
    if (simple) {
      nextDisabled = !hasNext;
      nextTabIndex = hasPrev ? 0 : null;
    } else {
      nextDisabled = !hasNext || !allPages;
      nextTabIndex = nextDisabled ? null : 0;
    }
    next2 = /* @__PURE__ */ import_react67.default.createElement("li", {
      title: showTitle ? locale6.next_page : null,
      onClick: nextHandle,
      tabIndex: nextTabIndex,
      onKeyDown: runIfEnterNext,
      className: (0, import_classnames52.default)("".concat(prefixCls, "-next"), _defineProperty({}, "".concat(prefixCls, "-disabled"), nextDisabled)),
      "aria-disabled": nextDisabled
    }, next2);
  }
  var cls = (0, import_classnames52.default)(prefixCls, className, (_classNames5 = {}, _defineProperty(_classNames5, "".concat(prefixCls, "-simple"), simple), _defineProperty(_classNames5, "".concat(prefixCls, "-disabled"), disabled), _classNames5));
  return /* @__PURE__ */ import_react67.default.createElement("ul", _extends({
    className: cls,
    style: style2,
    ref: paginationRef
  }, dataOrAriaAttributeProps), totalText, prev2, simple ? simplePager : pagerList, next2, /* @__PURE__ */ import_react67.default.createElement(Options_default, {
    locale: locale6,
    rootPrefixCls: prefixCls,
    disabled,
    selectComponentClass,
    selectPrefixCls,
    changeSize: showSizeChanger ? changePageSize : null,
    pageSize,
    pageSizeOptions,
    quickGo: shouldDisplayQuickJumper ? handleChange : null,
    goButton: gotoButton
  }));
};
if (process.env.NODE_ENV !== "production") {
  Pagination.displayName = "Pagination";
}
var Pagination_default = Pagination;

// ../../node_modules/antd/es/pagination/Pagination.js
var React184 = __toESM(require("react"));

// ../../node_modules/antd/es/pagination/Select.js
var React183 = __toESM(require("react"));
var MiniSelect = (props) => /* @__PURE__ */ React183.createElement(select_default, Object.assign({}, props, {
  showSearch: true,
  size: "small"
}));
var MiddleSelect = (props) => /* @__PURE__ */ React183.createElement(select_default, Object.assign({}, props, {
  showSearch: true,
  size: "middle"
}));
MiniSelect.Option = select_default.Option;
MiddleSelect.Option = select_default.Option;

// ../../node_modules/antd/es/pagination/style/index.js
var genPaginationDisabledStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-disabled`]: {
      "&, &:hover": {
        cursor: "not-allowed",
        [`${componentCls}-item-link`]: {
          color: token2.colorTextDisabled,
          cursor: "not-allowed"
        }
      },
      "&:focus-visible": {
        cursor: "not-allowed",
        [`${componentCls}-item-link`]: {
          color: token2.colorTextDisabled,
          cursor: "not-allowed"
        }
      }
    },
    [`&${componentCls}-disabled`]: {
      cursor: "not-allowed",
      [`${componentCls}-item`]: {
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        a: {
          color: token2.colorTextDisabled,
          backgroundColor: "transparent",
          border: "none",
          cursor: "not-allowed"
        },
        "&-active": {
          borderColor: token2.colorBorder,
          backgroundColor: token2.itemActiveBgDisabled,
          "&:hover, &:active": {
            backgroundColor: token2.itemActiveBgDisabled
          },
          a: {
            color: token2.itemActiveColorDisabled
          }
        }
      },
      [`${componentCls}-item-link`]: {
        color: token2.colorTextDisabled,
        cursor: "not-allowed",
        "&:hover, &:active": {
          backgroundColor: "transparent"
        },
        [`${componentCls}-simple&`]: {
          backgroundColor: "transparent",
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      },
      [`${componentCls}-simple-pager`]: {
        color: token2.colorTextDisabled
      },
      [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
        [`${componentCls}-item-link-icon`]: {
          opacity: 0
        },
        [`${componentCls}-item-ellipsis`]: {
          opacity: 1
        }
      }
    },
    [`&${componentCls}-simple`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        [`&${componentCls}-disabled ${componentCls}-item-link`]: {
          "&:hover, &:active": {
            backgroundColor: "transparent"
          }
        }
      }
    }
  };
};
var genPaginationMiniStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`&${componentCls}-mini ${componentCls}-total-text, &${componentCls}-mini ${componentCls}-simple-pager`]: {
      height: token2.itemSizeSM,
      lineHeight: unit(token2.itemSizeSM)
    },
    [`&${componentCls}-mini ${componentCls}-item`]: {
      minWidth: token2.itemSizeSM,
      height: token2.itemSizeSM,
      margin: 0,
      lineHeight: unit(token2.calc(token2.itemSizeSM).sub(2).equal())
    },
    [`&${componentCls}-mini:not(${componentCls}-disabled) ${componentCls}-item:not(${componentCls}-item-active)`]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&:hover": {
        backgroundColor: token2.colorBgTextHover
      },
      "&:active": {
        backgroundColor: token2.colorBgTextActive
      }
    },
    [`&${componentCls}-mini ${componentCls}-prev, &${componentCls}-mini ${componentCls}-next`]: {
      minWidth: token2.itemSizeSM,
      height: token2.itemSizeSM,
      margin: 0,
      lineHeight: unit(token2.itemSizeSM)
    },
    [`&${componentCls}-mini:not(${componentCls}-disabled)`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        [`&:hover ${componentCls}-item-link`]: {
          backgroundColor: token2.colorBgTextHover
        },
        [`&:active ${componentCls}-item-link`]: {
          backgroundColor: token2.colorBgTextActive
        },
        [`&${componentCls}-disabled:hover ${componentCls}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`
    &${componentCls}-mini ${componentCls}-prev ${componentCls}-item-link,
    &${componentCls}-mini ${componentCls}-next ${componentCls}-item-link
    `]: {
      backgroundColor: "transparent",
      borderColor: "transparent",
      "&::after": {
        height: token2.itemSizeSM,
        lineHeight: unit(token2.itemSizeSM)
      }
    },
    [`&${componentCls}-mini ${componentCls}-jump-prev, &${componentCls}-mini ${componentCls}-jump-next`]: {
      height: token2.itemSizeSM,
      marginInlineEnd: 0,
      lineHeight: unit(token2.itemSizeSM)
    },
    [`&${componentCls}-mini ${componentCls}-options`]: {
      marginInlineStart: token2.paginationMiniOptionsMarginInlineStart,
      [`&-size-changer`]: {
        top: token2.miniOptionsSizeChangerTop
      },
      [`&-quick-jumper`]: {
        height: token2.itemSizeSM,
        lineHeight: unit(token2.itemSizeSM),
        input: Object.assign(Object.assign({}, genInputSmallStyle(token2)), {
          width: token2.paginationMiniQuickJumperInputWidth,
          height: token2.controlHeightSM
        })
      }
    }
  };
};
var genPaginationSimpleStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`
    &${componentCls}-simple ${componentCls}-prev,
    &${componentCls}-simple ${componentCls}-next
    `]: {
      height: token2.itemSizeSM,
      lineHeight: unit(token2.itemSizeSM),
      verticalAlign: "top",
      [`${componentCls}-item-link`]: {
        height: token2.itemSizeSM,
        backgroundColor: "transparent",
        border: 0,
        "&:hover": {
          backgroundColor: token2.colorBgTextHover
        },
        "&:active": {
          backgroundColor: token2.colorBgTextActive
        },
        "&::after": {
          height: token2.itemSizeSM,
          lineHeight: unit(token2.itemSizeSM)
        }
      }
    },
    [`&${componentCls}-simple ${componentCls}-simple-pager`]: {
      display: "inline-block",
      height: token2.itemSizeSM,
      marginInlineEnd: token2.marginXS,
      input: {
        boxSizing: "border-box",
        height: "100%",
        marginInlineEnd: token2.marginXS,
        padding: `0 ${unit(token2.paginationItemPaddingInline)}`,
        textAlign: "center",
        backgroundColor: token2.itemInputBg,
        border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
        borderRadius: token2.borderRadius,
        outline: "none",
        transition: `border-color ${token2.motionDurationMid}`,
        color: "inherit",
        "&:hover": {
          borderColor: token2.colorPrimary
        },
        "&:focus": {
          borderColor: token2.colorPrimaryHover,
          boxShadow: `${unit(token2.inputOutlineOffset)} 0 ${unit(token2.controlOutlineWidth)} ${token2.controlOutline}`
        },
        "&[disabled]": {
          color: token2.colorTextDisabled,
          backgroundColor: token2.colorBgContainerDisabled,
          borderColor: token2.colorBorder,
          cursor: "not-allowed"
        }
      }
    }
  };
};
var genPaginationJumpStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
      outline: 0,
      [`${componentCls}-item-container`]: {
        position: "relative",
        [`${componentCls}-item-link-icon`]: {
          color: token2.colorPrimary,
          fontSize: token2.fontSizeSM,
          opacity: 0,
          transition: `all ${token2.motionDurationMid}`,
          "&-svg": {
            top: 0,
            insetInlineEnd: 0,
            bottom: 0,
            insetInlineStart: 0,
            margin: "auto"
          }
        },
        [`${componentCls}-item-ellipsis`]: {
          position: "absolute",
          top: 0,
          insetInlineEnd: 0,
          bottom: 0,
          insetInlineStart: 0,
          display: "block",
          margin: "auto",
          color: token2.colorTextDisabled,
          fontFamily: "Arial, Helvetica, sans-serif",
          letterSpacing: token2.paginationEllipsisLetterSpacing,
          textAlign: "center",
          textIndent: token2.paginationEllipsisTextIndent,
          opacity: 1,
          transition: `all ${token2.motionDurationMid}`
        }
      },
      "&:hover": {
        [`${componentCls}-item-link-icon`]: {
          opacity: 1
        },
        [`${componentCls}-item-ellipsis`]: {
          opacity: 0
        }
      }
    },
    [`
    ${componentCls}-prev,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
      marginInlineEnd: token2.marginXS
    },
    [`
    ${componentCls}-prev,
    ${componentCls}-next,
    ${componentCls}-jump-prev,
    ${componentCls}-jump-next
    `]: {
      display: "inline-block",
      minWidth: token2.itemSize,
      height: token2.itemSize,
      color: token2.colorText,
      fontFamily: token2.fontFamily,
      lineHeight: `${unit(token2.itemSize)}`,
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      borderRadius: token2.borderRadius,
      cursor: "pointer",
      transition: `all ${token2.motionDurationMid}`
    },
    [`${componentCls}-prev, ${componentCls}-next`]: {
      fontFamily: "Arial, Helvetica, sans-serif",
      outline: 0,
      button: {
        color: token2.colorText,
        cursor: "pointer",
        userSelect: "none"
      },
      [`${componentCls}-item-link`]: {
        display: "block",
        width: "100%",
        height: "100%",
        padding: 0,
        fontSize: token2.fontSizeSM,
        textAlign: "center",
        backgroundColor: "transparent",
        border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
        borderRadius: token2.borderRadius,
        outline: "none",
        transition: `all ${token2.motionDurationMid}`
      },
      [`&:hover ${componentCls}-item-link`]: {
        backgroundColor: token2.colorBgTextHover
      },
      [`&:active ${componentCls}-item-link`]: {
        backgroundColor: token2.colorBgTextActive
      },
      [`&${componentCls}-disabled:hover`]: {
        [`${componentCls}-item-link`]: {
          backgroundColor: "transparent"
        }
      }
    },
    [`${componentCls}-slash`]: {
      marginInlineEnd: token2.paginationSlashMarginInlineEnd,
      marginInlineStart: token2.paginationSlashMarginInlineStart
    },
    [`${componentCls}-options`]: {
      display: "inline-block",
      marginInlineStart: token2.margin,
      verticalAlign: "middle",
      "&-size-changer.-select": {
        display: "inline-block",
        width: "auto"
      },
      "&-quick-jumper": {
        display: "inline-block",
        height: token2.controlHeight,
        marginInlineStart: token2.marginXS,
        lineHeight: unit(token2.controlHeight),
        verticalAlign: "top",
        input: Object.assign(Object.assign(Object.assign({}, genBasicInputStyle(token2)), genBaseOutlinedStyle2(token2, {
          borderColor: token2.colorBorder,
          hoverBorderColor: token2.colorPrimaryHover,
          activeBorderColor: token2.colorPrimary,
          activeShadow: token2.activeShadow
        })), {
          "&[disabled]": Object.assign({}, genDisabledStyle2(token2)),
          width: token2.calc(token2.controlHeightLG).mul(1.25).equal(),
          height: token2.controlHeight,
          boxSizing: "border-box",
          margin: 0,
          marginInlineStart: token2.marginXS,
          marginInlineEnd: token2.marginXS
        })
      }
    }
  };
};
var genPaginationItemStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}-item`]: {
      display: "inline-block",
      minWidth: token2.itemSize,
      height: token2.itemSize,
      marginInlineEnd: token2.marginXS,
      fontFamily: token2.fontFamily,
      lineHeight: unit(token2.calc(token2.itemSize).sub(2).equal()),
      textAlign: "center",
      verticalAlign: "middle",
      listStyle: "none",
      backgroundColor: "transparent",
      border: `${unit(token2.lineWidth)} ${token2.lineType} transparent`,
      borderRadius: token2.borderRadius,
      outline: 0,
      cursor: "pointer",
      userSelect: "none",
      a: {
        display: "block",
        padding: `0 ${unit(token2.paginationItemPaddingInline)}`,
        color: token2.colorText,
        "&:hover": {
          textDecoration: "none"
        }
      },
      [`&:not(${componentCls}-item-active)`]: {
        "&:hover": {
          transition: `all ${token2.motionDurationMid}`,
          backgroundColor: token2.colorBgTextHover
        },
        "&:active": {
          backgroundColor: token2.colorBgTextActive
        }
      },
      "&-active": {
        fontWeight: token2.fontWeightStrong,
        backgroundColor: token2.itemActiveBg,
        borderColor: token2.colorPrimary,
        a: {
          color: token2.colorPrimary
        },
        "&:hover": {
          borderColor: token2.colorPrimaryHover
        },
        "&:hover a": {
          color: token2.colorPrimaryHover
        }
      }
    }
  };
};
var genPaginationStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, resetComponent(token2)), {
      "ul, ol": {
        margin: 0,
        padding: 0,
        listStyle: "none"
      },
      "&::after": {
        display: "block",
        clear: "both",
        height: 0,
        overflow: "hidden",
        visibility: "hidden",
        content: '""'
      },
      [`${componentCls}-total-text`]: {
        display: "inline-block",
        height: token2.itemSize,
        marginInlineEnd: token2.marginXS,
        lineHeight: unit(token2.calc(token2.itemSize).sub(2).equal()),
        verticalAlign: "middle"
      }
    }), genPaginationItemStyle(token2)), genPaginationJumpStyle(token2)), genPaginationSimpleStyle(token2)), genPaginationMiniStyle(token2)), genPaginationDisabledStyle(token2)), {
      // media query style
      [`@media only screen and (max-width: ${token2.screenLG}px)`]: {
        [`${componentCls}-item`]: {
          "&-after-jump-prev, &-before-jump-next": {
            display: "none"
          }
        }
      },
      [`@media only screen and (max-width: ${token2.screenSM}px)`]: {
        [`${componentCls}-options`]: {
          display: "none"
        }
      }
    }),
    // rtl style
    [`&${token2.componentCls}-rtl`]: {
      direction: "rtl"
    }
  };
};
var genPaginationFocusStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}:not(${componentCls}-disabled)`]: {
      [`${componentCls}-item`]: Object.assign({}, genFocusStyle(token2)),
      [`${componentCls}-jump-prev, ${componentCls}-jump-next`]: {
        "&:focus-visible": Object.assign({
          [`${componentCls}-item-link-icon`]: {
            opacity: 1
          },
          [`${componentCls}-item-ellipsis`]: {
            opacity: 0
          }
        }, genFocusOutline(token2))
      },
      [`${componentCls}-prev, ${componentCls}-next`]: {
        [`&:focus-visible ${componentCls}-item-link`]: Object.assign({}, genFocusOutline(token2))
      }
    }
  };
};
var prepareComponentToken7 = (token2) => Object.assign({
  itemBg: token2.colorBgContainer,
  itemSize: token2.controlHeight,
  itemSizeSM: token2.controlHeightSM,
  itemActiveBg: token2.colorBgContainer,
  itemLinkBg: token2.colorBgContainer,
  itemActiveColorDisabled: token2.colorTextDisabled,
  itemActiveBgDisabled: token2.controlItemBgActiveDisabled,
  itemInputBg: token2.colorBgContainer,
  miniOptionsSizeChangerTop: 0
}, initComponentToken(token2));
var prepareToken3 = (token2) => merge2(token2, {
  inputOutlineOffset: 0,
  paginationMiniOptionsMarginInlineStart: token2.calc(token2.marginXXS).div(2).equal(),
  paginationMiniQuickJumperInputWidth: token2.calc(token2.controlHeightLG).mul(1.1).equal(),
  paginationItemPaddingInline: token2.calc(token2.marginXXS).mul(1.5).equal(),
  paginationEllipsisLetterSpacing: token2.calc(token2.marginXXS).div(2).equal(),
  paginationSlashMarginInlineStart: token2.marginXXS,
  paginationSlashMarginInlineEnd: token2.marginSM,
  paginationEllipsisTextIndent: "0.13em"
  // magic for ui experience
}, initInputToken(token2));
var style_default10 = genStyleHooks("Pagination", (token2) => {
  const paginationToken = prepareToken3(token2);
  return [genPaginationStyle(paginationToken), genPaginationFocusStyle(paginationToken)];
}, prepareComponentToken7);

// ../../node_modules/antd/es/pagination/style/bordered.js
var genBorderedStyle = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    [`${componentCls}${componentCls}-bordered${componentCls}-disabled:not(${componentCls}-mini)`]: {
      "&, &:hover": {
        [`${componentCls}-item-link`]: {
          borderColor: token2.colorBorder
        }
      },
      "&:focus-visible": {
        [`${componentCls}-item-link`]: {
          borderColor: token2.colorBorder
        }
      },
      [`${componentCls}-item, ${componentCls}-item-link`]: {
        backgroundColor: token2.colorBgContainerDisabled,
        borderColor: token2.colorBorder,
        [`&:hover:not(${componentCls}-item-active)`]: {
          backgroundColor: token2.colorBgContainerDisabled,
          borderColor: token2.colorBorder,
          a: {
            color: token2.colorTextDisabled
          }
        },
        [`&${componentCls}-item-active`]: {
          backgroundColor: token2.itemActiveBgDisabled
        }
      },
      [`${componentCls}-prev, ${componentCls}-next`]: {
        "&:hover button": {
          backgroundColor: token2.colorBgContainerDisabled,
          borderColor: token2.colorBorder,
          color: token2.colorTextDisabled
        },
        [`${componentCls}-item-link`]: {
          backgroundColor: token2.colorBgContainerDisabled,
          borderColor: token2.colorBorder
        }
      }
    },
    [`${componentCls}${componentCls}-bordered:not(${componentCls}-mini)`]: {
      [`${componentCls}-prev, ${componentCls}-next`]: {
        "&:hover button": {
          borderColor: token2.colorPrimaryHover,
          backgroundColor: token2.itemBg
        },
        [`${componentCls}-item-link`]: {
          backgroundColor: token2.itemLinkBg,
          borderColor: token2.colorBorder
        },
        [`&:hover ${componentCls}-item-link`]: {
          borderColor: token2.colorPrimary,
          backgroundColor: token2.itemBg,
          color: token2.colorPrimary
        },
        [`&${componentCls}-disabled`]: {
          [`${componentCls}-item-link`]: {
            borderColor: token2.colorBorder,
            color: token2.colorTextDisabled
          }
        }
      },
      [`${componentCls}-item`]: {
        backgroundColor: token2.itemBg,
        border: `${unit(token2.lineWidth)} ${token2.lineType} ${token2.colorBorder}`,
        [`&:hover:not(${componentCls}-item-active)`]: {
          borderColor: token2.colorPrimary,
          backgroundColor: token2.itemBg,
          a: {
            color: token2.colorPrimary
          }
        },
        "&-active": {
          borderColor: token2.colorPrimary
        }
      }
    }
  };
};
var bordered_default = genSubStyleComponent(["Pagination", "bordered"], (token2) => {
  const paginationToken = prepareToken3(token2);
  return [genBorderedStyle(paginationToken)];
}, prepareComponentToken7);

// ../../node_modules/antd/es/pagination/Pagination.js
var __rest17 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var Pagination3 = (props) => {
  const {
    prefixCls: customizePrefixCls,
    selectPrefixCls: customizeSelectPrefixCls,
    className,
    rootClassName,
    style: style2,
    size: customizeSize,
    locale: customLocale,
    selectComponentClass,
    responsive,
    showSizeChanger
  } = props, restProps = __rest17(props, ["prefixCls", "selectPrefixCls", "className", "rootClassName", "style", "size", "locale", "selectComponentClass", "responsive", "showSizeChanger"]);
  const {
    xs
  } = useBreakpoint_default(responsive);
  const [, token2] = useToken();
  const {
    getPrefixCls,
    direction,
    pagination = {}
  } = React184.useContext(ConfigContext);
  const prefixCls = getPrefixCls("pagination", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default10(prefixCls);
  const mergedShowSizeChanger = showSizeChanger !== null && showSizeChanger !== void 0 ? showSizeChanger : pagination.showSizeChanger;
  const iconsProps = React184.useMemo(() => {
    const ellipsis = /* @__PURE__ */ React184.createElement("span", {
      className: `${prefixCls}-item-ellipsis`
    }, "\u2022\u2022\u2022");
    const prevIcon = /* @__PURE__ */ React184.createElement("button", {
      className: `${prefixCls}-item-link`,
      type: "button",
      tabIndex: -1
    }, direction === "rtl" ? /* @__PURE__ */ React184.createElement(RightOutlined_default2, null) : /* @__PURE__ */ React184.createElement(LeftOutlined_default2, null));
    const nextIcon = /* @__PURE__ */ React184.createElement("button", {
      className: `${prefixCls}-item-link`,
      type: "button",
      tabIndex: -1
    }, direction === "rtl" ? /* @__PURE__ */ React184.createElement(LeftOutlined_default2, null) : /* @__PURE__ */ React184.createElement(RightOutlined_default2, null));
    const jumpPrevIcon = /* @__PURE__ */ React184.createElement("a", {
      className: `${prefixCls}-item-link`
    }, /* @__PURE__ */ React184.createElement("div", {
      className: `${prefixCls}-item-container`
    }, direction === "rtl" ? /* @__PURE__ */ React184.createElement(DoubleRightOutlined_default2, {
      className: `${prefixCls}-item-link-icon`
    }) : /* @__PURE__ */ React184.createElement(DoubleLeftOutlined_default2, {
      className: `${prefixCls}-item-link-icon`
    }), ellipsis));
    const jumpNextIcon = /* @__PURE__ */ React184.createElement("a", {
      className: `${prefixCls}-item-link`
    }, /* @__PURE__ */ React184.createElement("div", {
      className: `${prefixCls}-item-container`
    }, direction === "rtl" ? /* @__PURE__ */ React184.createElement(DoubleLeftOutlined_default2, {
      className: `${prefixCls}-item-link-icon`
    }) : /* @__PURE__ */ React184.createElement(DoubleRightOutlined_default2, {
      className: `${prefixCls}-item-link-icon`
    }), ellipsis));
    return {
      prevIcon,
      nextIcon,
      jumpPrevIcon,
      jumpNextIcon
    };
  }, [direction, prefixCls]);
  const [contextLocale] = useLocale_default("Pagination", en_US_default);
  const locale6 = Object.assign(Object.assign({}, contextLocale), customLocale);
  const mergedSize = useSize_default(customizeSize);
  const isSmall = mergedSize === "small" || !!(xs && !mergedSize && responsive);
  const selectPrefixCls = getPrefixCls("select", customizeSelectPrefixCls);
  const extendedClassName = (0, import_classnames53.default)({
    [`${prefixCls}-mini`]: isSmall,
    [`${prefixCls}-rtl`]: direction === "rtl",
    [`${prefixCls}-bordered`]: token2.wireframe
  }, pagination === null || pagination === void 0 ? void 0 : pagination.className, className, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, pagination === null || pagination === void 0 ? void 0 : pagination.style), style2);
  return wrapCSSVar(/* @__PURE__ */ React184.createElement(React184.Fragment, null, token2.wireframe && /* @__PURE__ */ React184.createElement(bordered_default, {
    prefixCls
  }), /* @__PURE__ */ React184.createElement(Pagination_default, Object.assign({}, iconsProps, restProps, {
    style: mergedStyle,
    prefixCls,
    selectPrefixCls,
    className: extendedClassName,
    selectComponentClass: selectComponentClass || (isSmall ? MiniSelect : MiddleSelect),
    locale: locale6,
    showSizeChanger: mergedShowSizeChanger
  }))));
};
if (process.env.NODE_ENV !== "production") {
  Pagination3.displayName = "Pagination";
}
var Pagination_default2 = Pagination3;

// ../../node_modules/antd/es/pagination/index.js
var pagination_default = Pagination_default2;

// ../../node_modules/antd/es/message/index.js
var import_react68 = __toESM(require("react"));
var message = null;
var act = (callback) => callback();
var taskQueue = [];
var defaultGlobalConfig = {};
function getGlobalContext() {
  const {
    getContainer: getContainer2,
    duration,
    rtl,
    maxCount,
    top
  } = defaultGlobalConfig;
  const mergedContainer = (getContainer2 === null || getContainer2 === void 0 ? void 0 : getContainer2()) || document.body;
  return {
    getContainer: () => mergedContainer,
    duration,
    rtl,
    maxCount,
    top
  };
}
var GlobalHolder = /* @__PURE__ */ import_react68.default.forwardRef((props, ref) => {
  const {
    messageConfig,
    sync
  } = props;
  const {
    getPrefixCls
  } = (0, import_react68.useContext)(ConfigContext);
  const prefixCls = defaultGlobalConfig.prefixCls || getPrefixCls("message");
  const appConfig = (0, import_react68.useContext)(AppConfigContext);
  const [api, holder] = useInternalMessage(Object.assign(Object.assign(Object.assign({}, messageConfig), {
    prefixCls
  }), appConfig.message));
  import_react68.default.useImperativeHandle(ref, () => {
    const instance = Object.assign({}, api);
    Object.keys(instance).forEach((method4) => {
      instance[method4] = function() {
        sync();
        return api[method4].apply(api, arguments);
      };
    });
    return {
      instance,
      sync
    };
  });
  return holder;
});
var GlobalHolderWrapper = /* @__PURE__ */ import_react68.default.forwardRef((_, ref) => {
  const [messageConfig, setMessageConfig] = import_react68.default.useState(getGlobalContext);
  const sync = () => {
    setMessageConfig(getGlobalContext);
  };
  import_react68.default.useEffect(sync, []);
  const global2 = globalConfig();
  const rootPrefixCls = global2.getRootPrefixCls();
  const rootIconPrefixCls = global2.getIconPrefixCls();
  const theme = global2.getTheme();
  const dom = /* @__PURE__ */ import_react68.default.createElement(GlobalHolder, {
    ref,
    sync,
    messageConfig
  });
  return /* @__PURE__ */ import_react68.default.createElement(config_provider_default, {
    prefixCls: rootPrefixCls,
    iconPrefixCls: rootIconPrefixCls,
    theme
  }, global2.holderRender ? global2.holderRender(dom) : dom);
});
function flushNotice() {
  if (!message) {
    const holderFragment = document.createDocumentFragment();
    const newMessage = {
      fragment: holderFragment
    };
    message = newMessage;
    act(() => {
      render(/* @__PURE__ */ import_react68.default.createElement(GlobalHolderWrapper, {
        ref: (node2) => {
          const {
            instance,
            sync
          } = node2 || {};
          Promise.resolve().then(() => {
            if (!newMessage.instance && instance) {
              newMessage.instance = instance;
              newMessage.sync = sync;
              flushNotice();
            }
          });
        }
      }), holderFragment);
    });
    return;
  }
  if (!message.instance) {
    return;
  }
  taskQueue.forEach((task) => {
    const {
      type: type4,
      skipped
    } = task;
    if (!skipped) {
      switch (type4) {
        case "open": {
          act(() => {
            const closeFn = message.instance.open(Object.assign(Object.assign({}, defaultGlobalConfig), task.config));
            closeFn === null || closeFn === void 0 ? void 0 : closeFn.then(task.resolve);
            task.setCloseFn(closeFn);
          });
          break;
        }
        case "destroy":
          act(() => {
            message === null || message === void 0 ? void 0 : message.instance.destroy(task.key);
          });
          break;
        default: {
          act(() => {
            var _message$instance;
            const closeFn = (_message$instance = message.instance)[type4].apply(_message$instance, _toConsumableArray(task.args));
            closeFn === null || closeFn === void 0 ? void 0 : closeFn.then(task.resolve);
            task.setCloseFn(closeFn);
          });
        }
      }
    }
  });
  taskQueue = [];
}
function setMessageGlobalConfig(config) {
  defaultGlobalConfig = Object.assign(Object.assign({}, defaultGlobalConfig), config);
  act(() => {
    var _a;
    (_a = message === null || message === void 0 ? void 0 : message.sync) === null || _a === void 0 ? void 0 : _a.call(message);
  });
}
function open(config) {
  const result = wrapPromiseFn((resolve) => {
    let closeFn;
    const task = {
      type: "open",
      config,
      resolve,
      setCloseFn: (fn) => {
        closeFn = fn;
      }
    };
    taskQueue.push(task);
    return () => {
      if (closeFn) {
        act(() => {
          closeFn();
        });
      } else {
        task.skipped = true;
      }
    };
  });
  flushNotice();
  return result;
}
function typeOpen(type4, args) {
  const global2 = globalConfig();
  if (process.env.NODE_ENV !== "production" && !global2.holderRender) {
    warnContext("message");
  }
  const result = wrapPromiseFn((resolve) => {
    let closeFn;
    const task = {
      type: type4,
      args,
      resolve,
      setCloseFn: (fn) => {
        closeFn = fn;
      }
    };
    taskQueue.push(task);
    return () => {
      if (closeFn) {
        act(() => {
          closeFn();
        });
      } else {
        task.skipped = true;
      }
    };
  });
  flushNotice();
  return result;
}
function destroy(key) {
  taskQueue.push({
    type: "destroy",
    key
  });
  flushNotice();
}
var methods = ["success", "info", "warning", "error", "loading"];
var baseStaticMethods = {
  open,
  destroy,
  config: setMessageGlobalConfig,
  useMessage,
  _InternalPanelDoNotUseOrYouWillBeFired: PurePanel_default
};
var staticMethods = baseStaticMethods;
methods.forEach((type4) => {
  staticMethods[type4] = function() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return typeOpen(type4, args);
  };
});
var noop4 = () => {
};
var actWrapper = noop4;
if (process.env.NODE_ENV === "test") {
  actWrapper = (wrapper) => {
    act = wrapper;
  };
}
var actDestroy = noop4;
if (process.env.NODE_ENV === "test") {
  actDestroy = () => {
    message = null;
  };
}
var message_default = staticMethods;

// ../../node_modules/antd/es/modal/PurePanel.js
var React186 = __toESM(require("react"));
var import_classnames54 = __toESM(require_classnames());
var __rest18 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var PurePanel5 = (props) => {
  const {
    prefixCls: customizePrefixCls,
    className,
    closeIcon,
    closable,
    type: type4,
    title,
    children,
    footer
  } = props, restProps = __rest18(props, ["prefixCls", "className", "closeIcon", "closable", "type", "title", "children", "footer"]);
  const {
    getPrefixCls
  } = React186.useContext(ConfigContext);
  const rootPrefixCls = getPrefixCls();
  const prefixCls = customizePrefixCls || getPrefixCls("modal");
  const rootCls = useCSSVarCls_default(rootPrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default4(prefixCls, rootCls);
  const confirmPrefixCls = `${prefixCls}-confirm`;
  let additionalProps = {};
  if (type4) {
    additionalProps = {
      closable: closable !== null && closable !== void 0 ? closable : false,
      title: "",
      footer: "",
      children: /* @__PURE__ */ React186.createElement(ConfirmContent, Object.assign({}, props, {
        prefixCls,
        confirmPrefixCls,
        rootPrefixCls,
        content: children
      }))
    };
  } else {
    additionalProps = {
      closable: closable !== null && closable !== void 0 ? closable : true,
      title,
      footer: footer !== null && /* @__PURE__ */ React186.createElement(Footer, Object.assign({}, props)),
      children
    };
  }
  return wrapCSSVar(/* @__PURE__ */ React186.createElement(Panel_default, Object.assign({
    prefixCls,
    className: (0, import_classnames54.default)(hashId, `${prefixCls}-pure-panel`, type4 && confirmPrefixCls, type4 && `${confirmPrefixCls}-${type4}`, className, cssVarCls, rootCls)
  }, restProps, {
    closeIcon: renderCloseIcon(prefixCls, closeIcon),
    closable
  }, additionalProps)));
};
var PurePanel_default5 = withPureRenderTheme(PurePanel5);

// ../../node_modules/antd/es/modal/index.js
function modalWarn(props) {
  return confirm(withWarn(props));
}
var Modal2 = Modal_default;
Modal2.useModal = useModal_default;
Modal2.info = function infoFn(props) {
  return confirm(withInfo(props));
};
Modal2.success = function successFn(props) {
  return confirm(withSuccess(props));
};
Modal2.error = function errorFn(props) {
  return confirm(withError(props));
};
Modal2.warning = modalWarn;
Modal2.warn = modalWarn;
Modal2.confirm = function confirmFn(props) {
  return confirm(withConfirm(props));
};
Modal2.destroyAll = function destroyAllFn() {
  while (destroyFns_default.length) {
    const close = destroyFns_default.pop();
    if (close) {
      close();
    }
  }
};
Modal2.config = modalGlobalConfig;
Modal2._InternalPanelDoNotUseOrYouWillBeFired = PurePanel_default5;
if (process.env.NODE_ENV !== "production") {
  Modal2.displayName = "Modal";
}
var modal_default = Modal2;

// ../../node_modules/antd/es/notification/index.js
var import_react69 = __toESM(require("react"));
var notification = null;
var act2 = (callback) => callback();
var taskQueue2 = [];
var defaultGlobalConfig2 = {};
function getGlobalContext2() {
  const {
    getContainer: getContainer2,
    rtl,
    maxCount,
    top,
    bottom
  } = defaultGlobalConfig2;
  const mergedContainer = (getContainer2 === null || getContainer2 === void 0 ? void 0 : getContainer2()) || document.body;
  return {
    getContainer: () => mergedContainer,
    rtl,
    maxCount,
    top,
    bottom
  };
}
var GlobalHolder2 = /* @__PURE__ */ import_react69.default.forwardRef((props, ref) => {
  const {
    notificationConfig,
    sync
  } = props;
  const {
    getPrefixCls
  } = (0, import_react69.useContext)(ConfigContext);
  const prefixCls = defaultGlobalConfig2.prefixCls || getPrefixCls("notification");
  const appConfig = (0, import_react69.useContext)(AppConfigContext);
  const [api, holder] = useInternalNotification(Object.assign(Object.assign(Object.assign({}, notificationConfig), {
    prefixCls
  }), appConfig.notification));
  import_react69.default.useEffect(sync, []);
  import_react69.default.useImperativeHandle(ref, () => {
    const instance = Object.assign({}, api);
    Object.keys(instance).forEach((method4) => {
      instance[method4] = function() {
        sync();
        return api[method4].apply(api, arguments);
      };
    });
    return {
      instance,
      sync
    };
  });
  return holder;
});
var GlobalHolderWrapper2 = /* @__PURE__ */ import_react69.default.forwardRef((_, ref) => {
  const [notificationConfig, setNotificationConfig] = import_react69.default.useState(getGlobalContext2);
  const sync = () => {
    setNotificationConfig(getGlobalContext2);
  };
  import_react69.default.useEffect(sync, []);
  const global2 = globalConfig();
  const rootPrefixCls = global2.getRootPrefixCls();
  const rootIconPrefixCls = global2.getIconPrefixCls();
  const theme = global2.getTheme();
  const dom = /* @__PURE__ */ import_react69.default.createElement(GlobalHolder2, {
    ref,
    sync,
    notificationConfig
  });
  return /* @__PURE__ */ import_react69.default.createElement(config_provider_default, {
    prefixCls: rootPrefixCls,
    iconPrefixCls: rootIconPrefixCls,
    theme
  }, global2.holderRender ? global2.holderRender(dom) : dom);
});
function flushNotice2() {
  if (!notification) {
    const holderFragment = document.createDocumentFragment();
    const newNotification = {
      fragment: holderFragment
    };
    notification = newNotification;
    act2(() => {
      render(/* @__PURE__ */ import_react69.default.createElement(GlobalHolderWrapper2, {
        ref: (node2) => {
          const {
            instance,
            sync
          } = node2 || {};
          Promise.resolve().then(() => {
            if (!newNotification.instance && instance) {
              newNotification.instance = instance;
              newNotification.sync = sync;
              flushNotice2();
            }
          });
        }
      }), holderFragment);
    });
    return;
  }
  if (!notification.instance) {
    return;
  }
  taskQueue2.forEach((task) => {
    switch (task.type) {
      case "open": {
        act2(() => {
          notification.instance.open(Object.assign(Object.assign({}, defaultGlobalConfig2), task.config));
        });
        break;
      }
      case "destroy":
        act2(() => {
          notification === null || notification === void 0 ? void 0 : notification.instance.destroy(task.key);
        });
        break;
    }
  });
  taskQueue2 = [];
}
function setNotificationGlobalConfig(config) {
  defaultGlobalConfig2 = Object.assign(Object.assign({}, defaultGlobalConfig2), config);
  act2(() => {
    var _a;
    (_a = notification === null || notification === void 0 ? void 0 : notification.sync) === null || _a === void 0 ? void 0 : _a.call(notification);
  });
}
function open2(config) {
  const global2 = globalConfig();
  if (process.env.NODE_ENV !== "production" && !global2.holderRender) {
    warnContext("notification");
  }
  taskQueue2.push({
    type: "open",
    config
  });
  flushNotice2();
}
function destroy2(key) {
  taskQueue2.push({
    type: "destroy",
    key
  });
  flushNotice2();
}
var methods2 = ["success", "info", "warning", "error"];
var baseStaticMethods2 = {
  open: open2,
  destroy: destroy2,
  config: setNotificationGlobalConfig,
  useNotification: useNotification2,
  _InternalPanelDoNotUseOrYouWillBeFired: PurePanel_default2
};
var staticMethods2 = baseStaticMethods2;
methods2.forEach((type4) => {
  staticMethods2[type4] = (config) => open2(Object.assign(Object.assign({}, config), {
    type: type4
  }));
});
var noop5 = () => {
};
var actWrapper2 = noop5;
if (process.env.NODE_ENV === "test") {
  actWrapper2 = (wrapper) => {
    act2 = wrapper;
  };
}
var actDestroy2 = noop5;
if (process.env.NODE_ENV === "test") {
  actDestroy2 = () => {
    notification = null;
  };
}
var notification_default = staticMethods2;

// ../../node_modules/antd/es/_util/transButton.js
var React188 = __toESM(require("react"));
var __rest19 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var inlineStyle = {
  border: 0,
  background: "transparent",
  padding: 0,
  lineHeight: "inherit",
  display: "inline-block"
};
var TransButton = /* @__PURE__ */ React188.forwardRef((props, ref) => {
  const onKeyDown = (event) => {
    const {
      keyCode
    } = event;
    if (keyCode === KeyCode_default.ENTER) {
      event.preventDefault();
    }
  };
  const onKeyUp = (event) => {
    const {
      keyCode
    } = event;
    const {
      onClick
    } = props;
    if (keyCode === KeyCode_default.ENTER && onClick) {
      onClick();
    }
  };
  const {
    style: style2,
    noStyle,
    disabled
  } = props, restProps = __rest19(props, ["style", "noStyle", "disabled"]);
  let mergedStyle = {};
  if (!noStyle) {
    mergedStyle = Object.assign({}, inlineStyle);
  }
  if (disabled) {
    mergedStyle.pointerEvents = "none";
  }
  mergedStyle = Object.assign(Object.assign({}, mergedStyle), style2);
  return /* @__PURE__ */ React188.createElement("div", Object.assign({
    role: "button",
    tabIndex: 0,
    ref
  }, restProps, {
    onKeyDown,
    onKeyUp,
    style: mergedStyle
  }));
});
var transButton_default = TransButton;

// ../../node_modules/antd/es/typography/Link.js
var React199 = __toESM(require("react"));

// ../../node_modules/antd/es/typography/Base/index.js
var React198 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons/es/icons/CopyOutlined.js
var React189 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/CopyOutlined.js
var CopyOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z" } }] }, "name": "copy", "theme": "outlined" };
var CopyOutlined_default = CopyOutlined;

// ../../node_modules/@ant-design/icons/es/icons/CopyOutlined.js
var CopyOutlined2 = function CopyOutlined3(props, ref) {
  return /* @__PURE__ */ React189.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: CopyOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  CopyOutlined2.displayName = "CopyOutlined";
}
var CopyOutlined_default2 = /* @__PURE__ */ React189.forwardRef(CopyOutlined2);

// ../../node_modules/@ant-design/icons/es/icons/EditOutlined.js
var React190 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/EditOutlined.js
var EditOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 000-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 009.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z" } }] }, "name": "edit", "theme": "outlined" };
var EditOutlined_default = EditOutlined;

// ../../node_modules/@ant-design/icons/es/icons/EditOutlined.js
var EditOutlined2 = function EditOutlined3(props, ref) {
  return /* @__PURE__ */ React190.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: EditOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  EditOutlined2.displayName = "EditOutlined";
}
var EditOutlined_default2 = /* @__PURE__ */ React190.forwardRef(EditOutlined2);

// ../../node_modules/antd/es/typography/Base/index.js
var import_classnames57 = __toESM(require_classnames());
var import_copy_to_clipboard = __toESM(require_copy_to_clipboard());

// ../../node_modules/@ant-design/icons/es/icons/EnterOutlined.js
var React191 = __toESM(require("react"));

// ../../node_modules/@ant-design/icons-svg/es/asn/EnterOutlined.js
var EnterOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "64 64 896 896", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 000 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z" } }] }, "name": "enter", "theme": "outlined" };
var EnterOutlined_default = EnterOutlined;

// ../../node_modules/@ant-design/icons/es/icons/EnterOutlined.js
var EnterOutlined2 = function EnterOutlined3(props, ref) {
  return /* @__PURE__ */ React191.createElement(AntdIcon_default, _extends({}, props, {
    ref,
    icon: EnterOutlined_default
  }));
};
if (process.env.NODE_ENV !== "production") {
  EnterOutlined2.displayName = "EnterOutlined";
}
var EnterOutlined_default2 = /* @__PURE__ */ React191.forwardRef(EnterOutlined2);

// ../../node_modules/antd/es/typography/Editable.js
var import_classnames55 = __toESM(require_classnames());
var React192 = __toESM(require("react"));

// ../../node_modules/antd/es/typography/style/mixins.js
var getTitleStyle = (fontSize, lineHeight, color2, token2) => {
  const {
    titleMarginBottom,
    fontWeightStrong
  } = token2;
  return {
    marginBottom: titleMarginBottom,
    color: color2,
    fontWeight: fontWeightStrong,
    fontSize,
    lineHeight
  };
};
var getTitleStyles = (token2) => {
  const headings = [1, 2, 3, 4, 5];
  const styles = {};
  headings.forEach((headingLevel) => {
    styles[`
      h${headingLevel}&,
      div&-h${headingLevel},
      div&-h${headingLevel} > textarea,
      h${headingLevel}
    `] = getTitleStyle(token2[`fontSizeHeading${headingLevel}`], token2[`lineHeightHeading${headingLevel}`], token2.colorTextHeading, token2);
  });
  return styles;
};
var getLinkStyles = (token2) => {
  const {
    componentCls
  } = token2;
  return {
    "a&, a": Object.assign(Object.assign({}, operationUnit(token2)), {
      textDecoration: token2.linkDecoration,
      "&:active, &:hover": {
        textDecoration: token2.linkHoverDecoration
      },
      [`&[disabled], &${componentCls}-disabled`]: {
        color: token2.colorTextDisabled,
        cursor: "not-allowed",
        "&:active, &:hover": {
          color: token2.colorTextDisabled
        },
        "&:active": {
          pointerEvents: "none"
        }
      }
    })
  };
};
var getResetStyles = (token2) => ({
  code: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.2em 0.1em",
    fontSize: "85%",
    fontFamily: token2.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3
  },
  kbd: {
    margin: "0 0.2em",
    paddingInline: "0.4em",
    paddingBlock: "0.15em 0.1em",
    fontSize: "90%",
    fontFamily: token2.fontFamilyCode,
    background: "rgba(150, 150, 150, 0.06)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderBottomWidth: 2,
    borderRadius: 3
  },
  mark: {
    padding: 0,
    // FIXME hardcode in v4
    backgroundColor: gold[2]
  },
  "u, ins": {
    textDecoration: "underline",
    textDecorationSkipInk: "auto"
  },
  "s, del": {
    textDecoration: "line-through"
  },
  strong: {
    fontWeight: 600
  },
  // list
  "ul, ol": {
    marginInline: 0,
    marginBlock: "0 1em",
    padding: 0,
    li: {
      marginInline: "20px 0",
      marginBlock: 0,
      paddingInline: "4px 0",
      paddingBlock: 0
    }
  },
  ul: {
    listStyleType: "circle",
    ul: {
      listStyleType: "disc"
    }
  },
  ol: {
    listStyleType: "decimal"
  },
  // pre & block
  "pre, blockquote": {
    margin: "1em 0"
  },
  pre: {
    padding: "0.4em 0.6em",
    whiteSpace: "pre-wrap",
    wordWrap: "break-word",
    background: "rgba(150, 150, 150, 0.1)",
    border: "1px solid rgba(100, 100, 100, 0.2)",
    borderRadius: 3,
    fontFamily: token2.fontFamilyCode,
    // Compatible for marked
    code: {
      display: "inline",
      margin: 0,
      padding: 0,
      fontSize: "inherit",
      fontFamily: "inherit",
      background: "transparent",
      border: 0
    }
  },
  blockquote: {
    paddingInline: "0.6em 0",
    paddingBlock: 0,
    borderInlineStart: "4px solid rgba(100, 100, 100, 0.2)",
    opacity: 0.85
  }
});
var getEditableStyles = (token2) => {
  const {
    componentCls,
    paddingSM
  } = token2;
  const inputShift = paddingSM;
  return {
    "&-edit-content": {
      position: "relative",
      "div&": {
        insetInlineStart: token2.calc(token2.paddingSM).mul(-1).equal(),
        marginTop: token2.calc(inputShift).mul(-1).equal(),
        marginBottom: `calc(1em - ${unit(inputShift)})`
      },
      [`${componentCls}-edit-content-confirm`]: {
        position: "absolute",
        insetInlineEnd: token2.calc(token2.marginXS).add(2).equal(),
        insetBlockEnd: token2.marginXS,
        color: token2.colorTextDescription,
        // default style
        fontWeight: "normal",
        fontSize: token2.fontSize,
        fontStyle: "normal",
        pointerEvents: "none"
      },
      textarea: {
        margin: "0!important",
        // Fix Editable Textarea flash in Firefox
        MozTransition: "none",
        height: "1em"
      }
    }
  };
};
var getCopyableStyles = (token2) => ({
  [`${token2.componentCls}-copy-success`]: {
    [`
    &,
    &:hover,
    &:focus`]: {
      color: token2.colorSuccess
    }
  },
  [`${token2.componentCls}-copy-icon-only`]: {
    marginInlineStart: 0
  }
});
var getEllipsisStyles = () => ({
  [`
  a&-ellipsis,
  span&-ellipsis
  `]: {
    display: "inline-block",
    maxWidth: "100%"
  },
  "&-single-line": {
    whiteSpace: "nowrap"
  },
  "&-ellipsis-single-line": {
    overflow: "hidden",
    textOverflow: "ellipsis",
    // https://blog.csdn.net/iefreer/article/details/50421025
    "a&, span&": {
      verticalAlign: "bottom"
    },
    "> code": {
      paddingBlock: 0,
      maxWidth: "calc(100% - 1.2em)",
      display: "inline-block",
      overflow: "hidden",
      textOverflow: "ellipsis",
      verticalAlign: "bottom",
      // https://github.com/ant-design/ant-design/issues/45953
      boxSizing: "content-box"
    }
  },
  "&-ellipsis-multiple-line": {
    display: "-webkit-box",
    overflow: "hidden",
    WebkitLineClamp: 3,
    WebkitBoxOrient: "vertical"
  }
});

// ../../node_modules/antd/es/typography/style/index.js
var genTypographyStyle = (token2) => {
  const {
    componentCls,
    titleMarginTop
  } = token2;
  return {
    [componentCls]: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({
      color: token2.colorText,
      wordBreak: "break-word",
      lineHeight: token2.lineHeight,
      [`&${componentCls}-secondary`]: {
        color: token2.colorTextDescription
      },
      [`&${componentCls}-success`]: {
        color: token2.colorSuccess
      },
      [`&${componentCls}-warning`]: {
        color: token2.colorWarning
      },
      [`&${componentCls}-danger`]: {
        color: token2.colorError,
        "a&:active, a&:focus": {
          color: token2.colorErrorActive
        },
        "a&:hover": {
          color: token2.colorErrorHover
        }
      },
      [`&${componentCls}-disabled`]: {
        color: token2.colorTextDisabled,
        cursor: "not-allowed",
        userSelect: "none"
      },
      [`
        div&,
        p
      `]: {
        marginBottom: "1em"
      }
    }, getTitleStyles(token2)), {
      [`
      & + h1${componentCls},
      & + h2${componentCls},
      & + h3${componentCls},
      & + h4${componentCls},
      & + h5${componentCls}
      `]: {
        marginTop: titleMarginTop
      },
      [`
      div,
      ul,
      li,
      p,
      h1,
      h2,
      h3,
      h4,
      h5`]: {
        [`
        + h1,
        + h2,
        + h3,
        + h4,
        + h5
        `]: {
          marginTop: titleMarginTop
        }
      }
    }), getResetStyles(token2)), getLinkStyles(token2)), {
      // Operation
      [`
        ${componentCls}-expand,
        ${componentCls}-edit,
        ${componentCls}-copy
      `]: Object.assign(Object.assign({}, operationUnit(token2)), {
        marginInlineStart: token2.marginXXS
      })
    }), getEditableStyles(token2)), getCopyableStyles(token2)), getEllipsisStyles()), {
      "&-rtl": {
        direction: "rtl"
      }
    })
  };
};
var prepareComponentToken8 = () => ({
  titleMarginTop: "1.2em",
  titleMarginBottom: "0.5em"
});
var style_default11 = genStyleHooks("Typography", (token2) => [genTypographyStyle(token2)], prepareComponentToken8);

// ../../node_modules/antd/es/typography/Editable.js
var Editable = (props) => {
  const {
    prefixCls,
    "aria-label": ariaLabel,
    className,
    style: style2,
    direction,
    maxLength,
    autoSize = true,
    value,
    onSave,
    onCancel,
    onEnd,
    component,
    enterIcon = /* @__PURE__ */ React192.createElement(EnterOutlined_default2, null)
  } = props;
  const ref = React192.useRef(null);
  const inComposition = React192.useRef(false);
  const lastKeyCode = React192.useRef();
  const [current, setCurrent] = React192.useState(value);
  React192.useEffect(() => {
    setCurrent(value);
  }, [value]);
  React192.useEffect(() => {
    if (ref.current && ref.current.resizableTextArea) {
      const {
        textArea
      } = ref.current.resizableTextArea;
      textArea.focus();
      const {
        length: length2
      } = textArea.value;
      textArea.setSelectionRange(length2, length2);
    }
  }, []);
  const onChange = (_ref) => {
    let {
      target
    } = _ref;
    setCurrent(target.value.replace(/[\n\r]/g, ""));
  };
  const onCompositionStart = () => {
    inComposition.current = true;
  };
  const onCompositionEnd = () => {
    inComposition.current = false;
  };
  const onKeyDown = (_ref2) => {
    let {
      keyCode
    } = _ref2;
    if (inComposition.current)
      return;
    lastKeyCode.current = keyCode;
  };
  const confirmChange = () => {
    onSave(current.trim());
  };
  const onKeyUp = (_ref3) => {
    let {
      keyCode,
      ctrlKey,
      altKey,
      metaKey,
      shiftKey
    } = _ref3;
    if (lastKeyCode.current === keyCode && !inComposition.current && !ctrlKey && !altKey && !metaKey && !shiftKey) {
      if (keyCode === KeyCode_default.ENTER) {
        confirmChange();
        onEnd === null || onEnd === void 0 ? void 0 : onEnd();
      } else if (keyCode === KeyCode_default.ESC) {
        onCancel();
      }
    }
  };
  const onBlur = () => {
    confirmChange();
  };
  const textClassName = component ? `${prefixCls}-${component}` : "";
  const [wrapCSSVar, hashId, cssVarCls] = style_default11(prefixCls);
  const textAreaClassName = (0, import_classnames55.default)(prefixCls, `${prefixCls}-edit-content`, {
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, className, textClassName, hashId, cssVarCls);
  return wrapCSSVar(/* @__PURE__ */ React192.createElement("div", {
    className: textAreaClassName,
    style: style2
  }, /* @__PURE__ */ React192.createElement(TextArea_default2, {
    ref,
    maxLength,
    value: current,
    onChange,
    onKeyDown,
    onKeyUp,
    onCompositionStart,
    onCompositionEnd,
    onBlur,
    "aria-label": ariaLabel,
    rows: 1,
    autoSize
  }), enterIcon !== null ? cloneElement4(enterIcon, {
    className: `${prefixCls}-edit-content-confirm`
  }) : null));
};
var Editable_default = Editable;

// ../../node_modules/antd/es/typography/hooks/useMergedConfig.js
var React193 = __toESM(require("react"));
function useMergedConfig(propConfig, templateConfig) {
  return React193.useMemo(() => {
    const support = !!propConfig;
    return [support, Object.assign(Object.assign({}, templateConfig), support && typeof propConfig === "object" ? propConfig : null)];
  }, [propConfig]);
}

// ../../node_modules/antd/es/typography/hooks/useUpdatedEffect.js
var React194 = __toESM(require("react"));
var useUpdatedEffect = (callback, conditions) => {
  const mountRef = React194.useRef(false);
  React194.useEffect(() => {
    if (mountRef.current) {
      callback();
    } else {
      mountRef.current = true;
    }
  }, conditions);
};
var useUpdatedEffect_default = useUpdatedEffect;

// ../../node_modules/antd/es/typography/Typography.js
var React195 = __toESM(require("react"));
var import_classnames56 = __toESM(require_classnames());
var __rest20 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var Typography = /* @__PURE__ */ React195.forwardRef((props, ref) => {
  const {
    prefixCls: customizePrefixCls,
    component: Component6 = "article",
    className,
    rootClassName,
    setContentRef,
    children,
    direction: typographyDirection,
    style: style2
  } = props, restProps = __rest20(props, ["prefixCls", "component", "className", "rootClassName", "setContentRef", "children", "direction", "style"]);
  const {
    getPrefixCls,
    direction: contextDirection,
    typography
  } = React195.useContext(ConfigContext);
  const direction = typographyDirection !== null && typographyDirection !== void 0 ? typographyDirection : contextDirection;
  let mergedRef = ref;
  if (setContentRef) {
    mergedRef = composeRef(ref, setContentRef);
  }
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Typography");
    warning6.deprecated(!setContentRef, "setContentRef", "ref");
  }
  const prefixCls = getPrefixCls("typography", customizePrefixCls);
  const [wrapCSSVar, hashId, cssVarCls] = style_default11(prefixCls);
  const componentClassName = (0, import_classnames56.default)(prefixCls, typography === null || typography === void 0 ? void 0 : typography.className, {
    [`${prefixCls}-rtl`]: direction === "rtl"
  }, className, rootClassName, hashId, cssVarCls);
  const mergedStyle = Object.assign(Object.assign({}, typography === null || typography === void 0 ? void 0 : typography.style), style2);
  return wrapCSSVar(
    // @ts-expect-error: Expression produces a union type that is too complex to represent.
    /* @__PURE__ */ React195.createElement(Component6, Object.assign({
      className: componentClassName,
      style: mergedStyle,
      ref: mergedRef
    }, restProps), children)
  );
});
if (process.env.NODE_ENV !== "production") {
  Typography.displayName = "Typography";
}
var Typography_default = Typography;

// ../../node_modules/antd/es/typography/Base/Ellipsis.js
var React196 = __toESM(require("react"));
function cuttable(node2) {
  const type4 = typeof node2;
  return type4 === "string" || type4 === "number";
}
function getNodesLen(nodeList) {
  let totalLen = 0;
  nodeList.forEach((node2) => {
    if (cuttable(node2)) {
      totalLen += String(node2).length;
    } else {
      totalLen += 1;
    }
  });
  return totalLen;
}
function sliceNodes(nodeList, len) {
  let currLen = 0;
  const currentNodeList = [];
  for (let i = 0; i < nodeList.length; i += 1) {
    if (currLen === len) {
      return currentNodeList;
    }
    const node2 = nodeList[i];
    const canCut = cuttable(node2);
    const nodeLen = canCut ? String(node2).length : 1;
    const nextLen = currLen + nodeLen;
    if (nextLen > len) {
      const restLen = len - currLen;
      currentNodeList.push(String(node2).slice(0, restLen));
      return currentNodeList;
    }
    currentNodeList.push(node2);
    currLen = nextLen;
  }
  return nodeList;
}
var NONE = 0;
var PREPARE = 1;
var WALKING = 2;
var DONE_WITH_ELLIPSIS = 3;
var DONE_WITHOUT_ELLIPSIS = 4;
var Ellipsis = (_ref) => {
  let {
    enabledMeasure,
    children,
    text,
    width,
    fontSize,
    rows,
    onEllipsis
  } = _ref;
  const [[startLen, midLen, endLen], setCutLength] = React196.useState([0, 0, 0]);
  const [lastLen, setLastLen] = React196.useState(0);
  const [walkingState, setWalkingState] = React196.useState(NONE);
  const [singleRowHeight, setSingleRowHeight] = React196.useState(0);
  const singleRowRef = React196.useRef(null);
  const midRowRef = React196.useRef(null);
  const nodeList = React196.useMemo(() => toArray(text), [text]);
  const totalLen = React196.useMemo(() => getNodesLen(nodeList), [nodeList]);
  const mergedChildren = React196.useMemo(() => {
    if (!enabledMeasure || walkingState !== DONE_WITH_ELLIPSIS) {
      if (lastLen && walkingState !== DONE_WITHOUT_ELLIPSIS && enabledMeasure)
        return children(sliceNodes(nodeList, lastLen), lastLen < totalLen);
      return children(nodeList, false);
    }
    return children(sliceNodes(nodeList, midLen), midLen < totalLen);
  }, [enabledMeasure, walkingState, children, nodeList, midLen, totalLen]);
  useLayoutEffect_default(() => {
    if (enabledMeasure && width && fontSize && totalLen) {
      setWalkingState(PREPARE);
      setCutLength([0, Math.ceil(totalLen / 2), totalLen]);
    }
  }, [enabledMeasure, width, fontSize, text, totalLen, rows]);
  useLayoutEffect_default(() => {
    var _a;
    if (walkingState === PREPARE) {
      setSingleRowHeight(((_a = singleRowRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0);
    }
  }, [walkingState]);
  useLayoutEffect_default(() => {
    var _a, _b;
    if (singleRowHeight) {
      if (walkingState === PREPARE) {
        const midHeight = ((_a = midRowRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) || 0;
        const maxHeight = rows * singleRowHeight;
        if (midHeight <= maxHeight) {
          setWalkingState(DONE_WITHOUT_ELLIPSIS);
          onEllipsis(false);
        } else {
          setWalkingState(WALKING);
        }
      } else if (walkingState === WALKING) {
        if (startLen !== endLen) {
          const midHeight = ((_b = midRowRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight) || 0;
          const maxHeight = rows * singleRowHeight;
          let nextStartLen = startLen;
          let nextEndLen = endLen;
          if (startLen === endLen - 1) {
            nextEndLen = startLen;
          } else if (midHeight <= maxHeight) {
            nextStartLen = midLen;
          } else {
            nextEndLen = midLen;
          }
          const nextMidLen = Math.ceil((nextStartLen + nextEndLen) / 2);
          setCutLength([nextStartLen, nextMidLen, nextEndLen]);
        } else {
          setWalkingState(DONE_WITH_ELLIPSIS);
          setLastLen(midLen);
          onEllipsis(true);
        }
      }
    }
  }, [walkingState, startLen, endLen, rows, singleRowHeight]);
  const measureStyle = {
    width,
    whiteSpace: "normal",
    margin: 0,
    padding: 0
  };
  const renderMeasure = (content, ref, style2) => /* @__PURE__ */ React196.createElement("span", {
    "aria-hidden": true,
    ref,
    style: Object.assign({
      position: "fixed",
      display: "block",
      left: 0,
      top: 0,
      zIndex: -9999,
      visibility: "hidden",
      pointerEvents: "none",
      fontSize: Math.ceil(fontSize / 2) * 2
    }, style2)
  }, content);
  const renderMeasureSlice = (len, ref) => {
    const sliceNodeList = sliceNodes(nodeList, len);
    return renderMeasure(children(sliceNodeList, true), ref, measureStyle);
  };
  return /* @__PURE__ */ React196.createElement(React196.Fragment, null, mergedChildren, enabledMeasure && walkingState !== DONE_WITH_ELLIPSIS && walkingState !== DONE_WITHOUT_ELLIPSIS && /* @__PURE__ */ React196.createElement(React196.Fragment, null, renderMeasure("lg", singleRowRef, {
    wordBreak: "keep-all",
    whiteSpace: "nowrap"
  }), walkingState === PREPARE ? renderMeasure(children(nodeList, false), midRowRef, measureStyle) : renderMeasureSlice(midLen, midRowRef)));
};
if (process.env.NODE_ENV !== "production") {
  Ellipsis.displayName = "Ellipsis";
}
var Ellipsis_default = Ellipsis;

// ../../node_modules/antd/es/typography/Base/EllipsisTooltip.js
var React197 = __toESM(require("react"));
var EllipsisTooltip = (_ref) => {
  let {
    enabledEllipsis,
    isEllipsis,
    children,
    tooltipProps
  } = _ref;
  if (!(tooltipProps === null || tooltipProps === void 0 ? void 0 : tooltipProps.title) || !enabledEllipsis) {
    return children;
  }
  return /* @__PURE__ */ React197.createElement(tooltip_default, Object.assign({
    open: isEllipsis ? void 0 : false
  }, tooltipProps), children);
};
if (process.env.NODE_ENV !== "production") {
  EllipsisTooltip.displayName = "EllipsisTooltip";
}
var EllipsisTooltip_default = EllipsisTooltip;

// ../../node_modules/antd/es/typography/Base/index.js
var __rest21 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
function wrapperDecorations(_ref, content) {
  let {
    mark,
    code,
    underline,
    delete: del,
    strong,
    keyboard,
    italic
  } = _ref;
  let currentContent = content;
  function wrap(tag, needed) {
    if (!needed) {
      return;
    }
    currentContent = /* @__PURE__ */ React198.createElement(tag, {}, currentContent);
  }
  wrap("strong", strong);
  wrap("u", underline);
  wrap("del", del);
  wrap("code", code);
  wrap("mark", mark);
  wrap("kbd", keyboard);
  wrap("i", italic);
  return currentContent;
}
function getNode(dom, defaultNode, needDom) {
  if (dom === true || dom === void 0) {
    return defaultNode;
  }
  return dom || needDom && defaultNode;
}
function toList(val) {
  if (val === false) {
    return [false, false];
  }
  return Array.isArray(val) ? val : [val];
}
var ELLIPSIS_STR = "...";
var Base = /* @__PURE__ */ React198.forwardRef((props, ref) => {
  var _a, _b, _c;
  const {
    prefixCls: customizePrefixCls,
    className,
    style: style2,
    type: type4,
    disabled,
    children,
    ellipsis,
    editable,
    copyable,
    component,
    title
  } = props, restProps = __rest21(props, ["prefixCls", "className", "style", "type", "disabled", "children", "ellipsis", "editable", "copyable", "component", "title"]);
  const {
    getPrefixCls,
    direction
  } = React198.useContext(ConfigContext);
  const [textLocale] = useLocale_default("Text");
  const typographyRef = React198.useRef(null);
  const editIconRef = React198.useRef(null);
  const prefixCls = getPrefixCls("typography", customizePrefixCls);
  const textProps = omit(restProps, ["mark", "code", "delete", "underline", "strong", "keyboard", "italic"]);
  const [enableEdit, editConfig] = useMergedConfig(editable);
  const [editing, setEditing] = useMergedState(false, {
    value: editConfig.editing
  });
  const {
    triggerType = ["icon"]
  } = editConfig;
  const triggerEdit = (edit) => {
    var _a2;
    if (edit) {
      (_a2 = editConfig.onStart) === null || _a2 === void 0 ? void 0 : _a2.call(editConfig);
    }
    setEditing(edit);
  };
  useUpdatedEffect_default(() => {
    var _a2;
    if (!editing) {
      (_a2 = editIconRef.current) === null || _a2 === void 0 ? void 0 : _a2.focus();
    }
  }, [editing]);
  const onEditClick = (e) => {
    e === null || e === void 0 ? void 0 : e.preventDefault();
    triggerEdit(true);
  };
  const onEditChange = (value) => {
    var _a2;
    (_a2 = editConfig.onChange) === null || _a2 === void 0 ? void 0 : _a2.call(editConfig, value);
    triggerEdit(false);
  };
  const onEditCancel = () => {
    var _a2;
    (_a2 = editConfig.onCancel) === null || _a2 === void 0 ? void 0 : _a2.call(editConfig);
    triggerEdit(false);
  };
  const [enableCopy, copyConfig] = useMergedConfig(copyable);
  const [copied, setCopied] = React198.useState(false);
  const copyIdRef = React198.useRef(null);
  const copyOptions = {};
  if (copyConfig.format) {
    copyOptions.format = copyConfig.format;
  }
  const cleanCopyId = () => {
    if (copyIdRef.current) {
      clearTimeout(copyIdRef.current);
    }
  };
  const onCopyClick = (e) => {
    var _a2;
    e === null || e === void 0 ? void 0 : e.preventDefault();
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    (0, import_copy_to_clipboard.default)(copyConfig.text || String(children) || "", copyOptions);
    setCopied(true);
    cleanCopyId();
    copyIdRef.current = setTimeout(() => {
      setCopied(false);
    }, 3e3);
    (_a2 = copyConfig.onCopy) === null || _a2 === void 0 ? void 0 : _a2.call(copyConfig, e);
  };
  React198.useEffect(() => cleanCopyId, []);
  const [isLineClampSupport, setIsLineClampSupport] = React198.useState(false);
  const [isTextOverflowSupport, setIsTextOverflowSupport] = React198.useState(false);
  const [expanded, setExpanded] = React198.useState(false);
  const [isJsEllipsis, setIsJsEllipsis] = React198.useState(false);
  const [isNativeEllipsis, setIsNativeEllipsis] = React198.useState(false);
  const [isNativeVisible, setIsNativeVisible] = React198.useState(true);
  const [enableEllipsis, ellipsisConfig] = useMergedConfig(ellipsis, {
    expandable: false
  });
  const mergedEnableEllipsis = enableEllipsis && !expanded;
  const {
    rows = 1
  } = ellipsisConfig;
  const needMeasureEllipsis = React198.useMemo(() => (
    // Disable ellipsis
    !mergedEnableEllipsis || // Provide suffix
    ellipsisConfig.suffix !== void 0 || ellipsisConfig.onEllipsis || // Can't use css ellipsis since we need to provide the place for button
    ellipsisConfig.expandable || enableEdit || enableCopy
  ), [mergedEnableEllipsis, ellipsisConfig, enableEdit, enableCopy]);
  useLayoutEffect_default(() => {
    if (enableEllipsis && !needMeasureEllipsis) {
      setIsLineClampSupport(isStyleSupport("webkitLineClamp"));
      setIsTextOverflowSupport(isStyleSupport("textOverflow"));
    }
  }, [needMeasureEllipsis, enableEllipsis]);
  const cssEllipsis = React198.useMemo(() => {
    if (needMeasureEllipsis) {
      return false;
    }
    if (rows === 1) {
      return isTextOverflowSupport;
    }
    return isLineClampSupport;
  }, [needMeasureEllipsis, isTextOverflowSupport, isLineClampSupport]);
  const isMergedEllipsis = mergedEnableEllipsis && (cssEllipsis ? isNativeEllipsis : isJsEllipsis);
  const cssTextOverflow = mergedEnableEllipsis && rows === 1 && cssEllipsis;
  const cssLineClamp = mergedEnableEllipsis && rows > 1 && cssEllipsis;
  const onExpandClick = (e) => {
    var _a2;
    setExpanded(true);
    (_a2 = ellipsisConfig.onExpand) === null || _a2 === void 0 ? void 0 : _a2.call(ellipsisConfig, e);
  };
  const [ellipsisWidth, setEllipsisWidth] = React198.useState(0);
  const [ellipsisFontSize, setEllipsisFontSize] = React198.useState(0);
  const onResize2 = (_ref2, element) => {
    let {
      offsetWidth
    } = _ref2;
    var _a2;
    setEllipsisWidth(offsetWidth);
    setEllipsisFontSize(parseInt((_a2 = window.getComputedStyle) === null || _a2 === void 0 ? void 0 : _a2.call(window, element).fontSize, 10) || 0);
  };
  const onJsEllipsis = (jsEllipsis) => {
    var _a2;
    setIsJsEllipsis(jsEllipsis);
    if (isJsEllipsis !== jsEllipsis) {
      (_a2 = ellipsisConfig.onEllipsis) === null || _a2 === void 0 ? void 0 : _a2.call(ellipsisConfig, jsEllipsis);
    }
  };
  React198.useEffect(() => {
    const textEle = typographyRef.current;
    if (enableEllipsis && cssEllipsis && textEle) {
      const currentEllipsis = cssLineClamp ? textEle.offsetHeight < textEle.scrollHeight : textEle.offsetWidth < textEle.scrollWidth;
      if (isNativeEllipsis !== currentEllipsis) {
        setIsNativeEllipsis(currentEllipsis);
      }
    }
  }, [enableEllipsis, cssEllipsis, children, cssLineClamp, isNativeVisible, ellipsisWidth]);
  React198.useEffect(() => {
    const textEle = typographyRef.current;
    if (typeof IntersectionObserver === "undefined" || !textEle || !cssEllipsis || !mergedEnableEllipsis) {
      return;
    }
    const observer2 = new IntersectionObserver(() => {
      setIsNativeVisible(!!textEle.offsetParent);
    });
    observer2.observe(textEle);
    return () => {
      observer2.disconnect();
    };
  }, [cssEllipsis, mergedEnableEllipsis]);
  let tooltipProps = {};
  if (ellipsisConfig.tooltip === true) {
    tooltipProps = {
      title: (_a = editConfig.text) !== null && _a !== void 0 ? _a : children
    };
  } else if (/* @__PURE__ */ React198.isValidElement(ellipsisConfig.tooltip)) {
    tooltipProps = {
      title: ellipsisConfig.tooltip
    };
  } else if (typeof ellipsisConfig.tooltip === "object") {
    tooltipProps = Object.assign({
      title: (_b = editConfig.text) !== null && _b !== void 0 ? _b : children
    }, ellipsisConfig.tooltip);
  } else {
    tooltipProps = {
      title: ellipsisConfig.tooltip
    };
  }
  const topAriaLabel = React198.useMemo(() => {
    const isValid = (val) => ["string", "number"].includes(typeof val);
    if (!enableEllipsis || cssEllipsis) {
      return void 0;
    }
    if (isValid(editConfig.text)) {
      return editConfig.text;
    }
    if (isValid(children)) {
      return children;
    }
    if (isValid(title)) {
      return title;
    }
    if (isValid(tooltipProps.title)) {
      return tooltipProps.title;
    }
    return void 0;
  }, [enableEllipsis, cssEllipsis, title, tooltipProps.title, isMergedEllipsis]);
  if (editing) {
    return /* @__PURE__ */ React198.createElement(Editable_default, {
      value: (_c = editConfig.text) !== null && _c !== void 0 ? _c : typeof children === "string" ? children : "",
      onSave: onEditChange,
      onCancel: onEditCancel,
      onEnd: editConfig.onEnd,
      prefixCls,
      className,
      style: style2,
      direction,
      component,
      maxLength: editConfig.maxLength,
      autoSize: editConfig.autoSize,
      enterIcon: editConfig.enterIcon
    });
  }
  const renderExpand = () => {
    const {
      expandable,
      symbol
    } = ellipsisConfig;
    if (!expandable)
      return null;
    let expandContent;
    if (symbol) {
      expandContent = symbol;
    } else {
      expandContent = textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand;
    }
    return /* @__PURE__ */ React198.createElement("a", {
      key: "expand",
      className: `${prefixCls}-expand`,
      onClick: onExpandClick,
      "aria-label": textLocale === null || textLocale === void 0 ? void 0 : textLocale.expand
    }, expandContent);
  };
  const renderEdit = () => {
    if (!enableEdit)
      return;
    const {
      icon,
      tooltip
    } = editConfig;
    const editTitle = toArray(tooltip)[0] || (textLocale === null || textLocale === void 0 ? void 0 : textLocale.edit);
    const ariaLabel = typeof editTitle === "string" ? editTitle : "";
    return triggerType.includes("icon") ? /* @__PURE__ */ React198.createElement(tooltip_default, {
      key: "edit",
      title: tooltip === false ? "" : editTitle
    }, /* @__PURE__ */ React198.createElement(transButton_default, {
      ref: editIconRef,
      className: `${prefixCls}-edit`,
      onClick: onEditClick,
      "aria-label": ariaLabel
    }, icon || /* @__PURE__ */ React198.createElement(EditOutlined_default2, {
      role: "button"
    }))) : null;
  };
  const renderCopy = () => {
    if (!enableCopy) {
      return null;
    }
    const {
      tooltips,
      icon
    } = copyConfig;
    const tooltipNodes = toList(tooltips);
    const iconNodes = toList(icon);
    const copyTitle = copied ? getNode(tooltipNodes[1], textLocale === null || textLocale === void 0 ? void 0 : textLocale.copied) : getNode(tooltipNodes[0], textLocale === null || textLocale === void 0 ? void 0 : textLocale.copy);
    const systemStr = copied ? textLocale === null || textLocale === void 0 ? void 0 : textLocale.copied : textLocale === null || textLocale === void 0 ? void 0 : textLocale.copy;
    const ariaLabel = typeof copyTitle === "string" ? copyTitle : systemStr;
    return /* @__PURE__ */ React198.createElement(tooltip_default, {
      key: "copy",
      title: copyTitle
    }, /* @__PURE__ */ React198.createElement(transButton_default, {
      className: (0, import_classnames57.default)(`${prefixCls}-copy`, {
        [`${prefixCls}-copy-success`]: copied,
        [`${prefixCls}-copy-icon-only`]: children === null || children === void 0
      }),
      onClick: onCopyClick,
      "aria-label": ariaLabel
    }, copied ? getNode(iconNodes[1], /* @__PURE__ */ React198.createElement(CheckOutlined_default2, null), true) : getNode(iconNodes[0], /* @__PURE__ */ React198.createElement(CopyOutlined_default2, null), true)));
  };
  const renderOperations = (renderExpanded) => [renderExpanded && renderExpand(), renderEdit(), renderCopy()];
  const renderEllipsis = (needEllipsis) => [needEllipsis && /* @__PURE__ */ React198.createElement("span", {
    "aria-hidden": true,
    key: "ellipsis"
  }, ELLIPSIS_STR), ellipsisConfig.suffix, renderOperations(needEllipsis)];
  return /* @__PURE__ */ React198.createElement(es_default, {
    onResize: onResize2,
    disabled: !mergedEnableEllipsis
  }, (resizeRef) => /* @__PURE__ */ React198.createElement(EllipsisTooltip_default, {
    tooltipProps,
    enabledEllipsis: mergedEnableEllipsis,
    isEllipsis: isMergedEllipsis
  }, /* @__PURE__ */ React198.createElement(Typography_default, Object.assign({
    className: (0, import_classnames57.default)({
      [`${prefixCls}-${type4}`]: type4,
      [`${prefixCls}-disabled`]: disabled,
      [`${prefixCls}-ellipsis`]: enableEllipsis,
      [`${prefixCls}-single-line`]: mergedEnableEllipsis && rows === 1,
      [`${prefixCls}-ellipsis-single-line`]: cssTextOverflow,
      [`${prefixCls}-ellipsis-multiple-line`]: cssLineClamp
    }, className),
    prefixCls: customizePrefixCls,
    style: Object.assign(Object.assign({}, style2), {
      WebkitLineClamp: cssLineClamp ? rows : void 0
    }),
    component,
    ref: composeRef(resizeRef, typographyRef, ref),
    direction,
    onClick: triggerType.includes("text") ? onEditClick : void 0,
    "aria-label": topAriaLabel === null || topAriaLabel === void 0 ? void 0 : topAriaLabel.toString(),
    title
  }, textProps), /* @__PURE__ */ React198.createElement(Ellipsis_default, {
    enabledMeasure: mergedEnableEllipsis && !cssEllipsis,
    text: children,
    rows,
    width: ellipsisWidth,
    fontSize: ellipsisFontSize,
    onEllipsis: onJsEllipsis
  }, (node2, needEllipsis) => {
    let renderNode = node2;
    if (node2.length && needEllipsis && topAriaLabel) {
      renderNode = /* @__PURE__ */ React198.createElement("span", {
        key: "show-content",
        "aria-hidden": true
      }, renderNode);
    }
    const wrappedContext = wrapperDecorations(props, /* @__PURE__ */ React198.createElement(React198.Fragment, null, renderNode, renderEllipsis(needEllipsis)));
    return wrappedContext;
  }))));
});
var Base_default = Base;

// ../../node_modules/antd/es/typography/Link.js
var __rest22 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var Link = /* @__PURE__ */ React199.forwardRef((_a, ref) => {
  var {
    ellipsis,
    rel
  } = _a, restProps = __rest22(_a, ["ellipsis", "rel"]);
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Typography.Link");
    process.env.NODE_ENV !== "production" ? warning6(typeof ellipsis !== "object", "usage", "`ellipsis` only supports boolean value.") : void 0;
  }
  const mergedProps = Object.assign(Object.assign({}, restProps), {
    rel: rel === void 0 && restProps.target === "_blank" ? "noopener noreferrer" : rel
  });
  delete mergedProps.navigate;
  return /* @__PURE__ */ React199.createElement(Base_default, Object.assign({}, mergedProps, {
    ref,
    ellipsis: !!ellipsis,
    component: "a"
  }));
});
var Link_default = Link;

// ../../node_modules/antd/es/typography/Paragraph.js
var React200 = __toESM(require("react"));
var Paragraph = /* @__PURE__ */ React200.forwardRef((props, ref) => /* @__PURE__ */ React200.createElement(Base_default, Object.assign({
  ref
}, props, {
  component: "div"
})));
var Paragraph_default = Paragraph;

// ../../node_modules/antd/es/typography/Text.js
var React201 = __toESM(require("react"));
var __rest23 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var Text = (_a, ref) => {
  var {
    ellipsis
  } = _a, restProps = __rest23(_a, ["ellipsis"]);
  const mergedEllipsis = React201.useMemo(() => {
    if (ellipsis && typeof ellipsis === "object") {
      return omit(ellipsis, ["expandable", "rows"]);
    }
    return ellipsis;
  }, [ellipsis]);
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Typography.Text");
    process.env.NODE_ENV !== "production" ? warning6(typeof ellipsis !== "object" || !ellipsis || !("expandable" in ellipsis) && !("rows" in ellipsis), "usage", "`ellipsis` do not support `expandable` or `rows` props.") : void 0;
  }
  return /* @__PURE__ */ React201.createElement(Base_default, Object.assign({
    ref
  }, restProps, {
    ellipsis: mergedEllipsis,
    component: "span"
  }));
};
var Text_default = /* @__PURE__ */ React201.forwardRef(Text);

// ../../node_modules/antd/es/typography/Title.js
var React202 = __toESM(require("react"));
var __rest24 = function(s2, e) {
  var t = {};
  for (var p in s2)
    if (Object.prototype.hasOwnProperty.call(s2, p) && e.indexOf(p) < 0)
      t[p] = s2[p];
  if (s2 != null && typeof Object.getOwnPropertySymbols === "function")
    for (var i = 0, p = Object.getOwnPropertySymbols(s2); i < p.length; i++) {
      if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s2, p[i]))
        t[p[i]] = s2[p[i]];
    }
  return t;
};
var TITLE_ELE_LIST = [1, 2, 3, 4, 5];
var Title = /* @__PURE__ */ React202.forwardRef((props, ref) => {
  const {
    level = 1
  } = props, restProps = __rest24(props, ["level"]);
  let component;
  if (process.env.NODE_ENV !== "production") {
    const warning6 = devUseWarning("Typography.Title");
    process.env.NODE_ENV !== "production" ? warning6(TITLE_ELE_LIST.includes(level), "usage", "Title only accept `1 | 2 | 3 | 4 | 5` as `level` value. And `5` need 4.6.0+ version.") : void 0;
  }
  if (TITLE_ELE_LIST.includes(level)) {
    component = `h${level}`;
  } else {
    component = "h1";
  }
  return /* @__PURE__ */ React202.createElement(Base_default, Object.assign({
    ref
  }, restProps, {
    component
  }));
});
var Title_default = Title;

// ../../node_modules/antd/es/typography/index.js
var Typography2 = Typography_default;
Typography2.Text = Text_default;
Typography2.Link = Link_default;
Typography2.Title = Title_default;
Typography2.Paragraph = Paragraph_default;
var typography_default = Typography2;

// components/PaginationComponent.tsx
var import_styled_components2 = __toESM(require("styled-components"));
var import_jsx_runtime2 = require("react/jsx-runtime");
var PaginationComponent = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange
}) => {
  return /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(StyledPagination, { children: /* @__PURE__ */ (0, import_jsx_runtime2.jsx)(
    pagination_default,
    {
      showSizeChanger: false,
      current: currentPage + 1,
      total: totalItems,
      pageSize: itemsPerPage,
      onChange: (pageNo) => onPageChange(pageNo - 1)
    }
  ) });
};
var StyledPagination = import_styled_components2.default.div`
  width: fit-content;
  margin-inline: auto;
  margin-bottom: 20px;
`;

// components/DeleteModal.tsx
var import_styled_components3 = require("styled-components");

// contexts/useAppLayout.ts
var import_zustand = __toESM(require("zustand"));
var import_middleware = require("zustand/middleware");
var useAppLayout = (0, import_zustand.default)(
  (0, import_middleware.persist)(
    (set2) => ({
      collapsed: false,
      isSmartSearchVisible: false,
      isResponseVisible: true,
      setCollapsed: (collapsed) => set2({ collapsed }),
      setSmartSearchVisible: (isSmartSearchVisible) => set2({ isSmartSearchVisible })
    }),
    {
      name: "app-layout"
    }
  )
);

// components/DeleteModal.tsx
var import_react70 = require("react");

// interfaces/datasource.interface.ts
var DataSourceType = /* @__PURE__ */ ((DataSourceType2) => {
  DataSourceType2["DATABASE"] = "DATABASE";
  DataSourceType2["FILE"] = "FILE";
  DataSourceType2["ENTERPRISE_CONNECTOR"] = "ENTERPRISE_CONNECTOR";
  DataSourceType2["CLOUD_STORAGE"] = "CLOUD_STORAGE";
  return DataSourceType2;
})(DataSourceType || {});
var DataSourceStatus = /* @__PURE__ */ ((DataSourceStatus2) => {
  DataSourceStatus2["DEACTIVATE"] = "DEACTIVATE";
  DataSourceStatus2["ACTIVE"] = "ACTIVE";
  return DataSourceStatus2;
})(DataSourceStatus || {});
var DatabaseType = /* @__PURE__ */ ((DatabaseType2) => {
  DatabaseType2["MYSQL"] = "MYSQL";
  DatabaseType2["SQLSERVER"] = "SQLSERVER";
  DatabaseType2["POSTGRESQL"] = "POSTGRESQL";
  DatabaseType2["SAP"] = "SAP";
  DatabaseType2["SAGE"] = "SAGE";
  return DatabaseType2;
})(DatabaseType || {});
var EnterpriseConnectorType = /* @__PURE__ */ ((EnterpriseConnectorType2) => {
  EnterpriseConnectorType2["JIRA"] = "JIRA";
  EnterpriseConnectorType2["SLACK"] = "SLACK";
  EnterpriseConnectorType2["TRELLO"] = "TRELLO";
  return EnterpriseConnectorType2;
})(EnterpriseConnectorType || {});
var FileType = /* @__PURE__ */ ((FileType2) => {
  FileType2["EXCEL"] = "EXCEL";
  FileType2["CSV"] = "CSV";
  FileType2["WORD"] = "WORD";
  FileType2["PDF"] = "PDF";
  FileType2["TXT"] = "TXT";
  FileType2["DRIVE"] = "DRIVE";
  FileType2["PPTX"] = "PPTX";
  return FileType2;
})(FileType || {});

// ../icons/components/AccountBallanceWalletIcon.tsx
var import_jsx_runtime3 = require("react/jsx-runtime");

// ../icons/components/AnthropicIcon.tsx
var import_jsx_runtime4 = require("react/jsx-runtime");

// ../icons/components/ArrowDownIcon.tsx
var import_jsx_runtime5 = require("react/jsx-runtime");

// ../icons/components/ArrowRightBottomIcon.tsx
var import_jsx_runtime6 = require("react/jsx-runtime");

// ../icons/components/ArrowRightIcon.tsx
var import_jsx_runtime7 = require("react/jsx-runtime");

// ../icons/components/AudioWaveIcon.tsx
var import_jsx_runtime8 = require("react/jsx-runtime");

// ../icons/components/BarChartIcon.tsx
var import_jsx_runtime9 = require("react/jsx-runtime");
var BarChartIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime9.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 28 27", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime9.jsx)(
    "path",
    {
      d: "M18.2396 22.6V14.9H22.7996V22.6H18.2396ZM11.3996 22.6V5H15.9596V22.6H11.3996ZM4.55957 22.6V10.5H9.11957V22.6H4.55957Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/BlurIcon.tsx
var import_jsx_runtime10 = require("react/jsx-runtime");

// ../icons/components/BoldIcon.tsx
var import_jsx_runtime11 = require("react/jsx-runtime");

// ../icons/components/BoxIcon.tsx
var import_jsx_runtime12 = require("react/jsx-runtime");

// ../icons/components/CalendarIcon.tsx
var import_jsx_runtime13 = require("react/jsx-runtime");

// ../icons/components/CallIcon.tsx
var import_jsx_runtime14 = require("react/jsx-runtime");

// ../icons/components/CardChartIcon.tsx
var import_jsx_runtime15 = require("react/jsx-runtime");
var CardChartIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime15.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 23 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime15.jsx)(
    "path",
    {
      d: "M2.3 20C1.6675 20 1.12604 19.7797 0.675625 19.3391C0.225208 18.8984 0 18.3688 0 17.75V4.25C0 3.63125 0.225208 3.10156 0.675625 2.66094C1.12604 2.22031 1.6675 2 2.3 2H15.64V4.25H2.3V17.75H20.7V4.25H15.64V2H20.7C21.3325 2 21.874 2.22031 22.3244 2.66094C22.7748 3.10156 23 3.63125 23 4.25V17.75C23 18.3688 22.7748 18.8984 22.3244 19.3391C21.874 19.7797 21.3325 20 20.7 20H2.3ZM11.5 12.1813H5.26534V9.67045H8.96714H10.9847H12.1984H14.011H16.0285H17.7038V12.1813H11.5Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/CardsIcon.tsx
var import_jsx_runtime16 = require("react/jsx-runtime");

// ../icons/components/CaretRightIcon.tsx
var import_jsx_runtime17 = require("react/jsx-runtime");

// ../icons/components/ChatChartIcon.tsx
var import_jsx_runtime18 = require("react/jsx-runtime");

// ../icons/components/ChatHistoryIcon.tsx
var import_jsx_runtime19 = require("react/jsx-runtime");
var ChatHistoryIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime19.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 20 20", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime19.jsx)(
    "path",
    {
      d: "M14.4825 14.5H14.4826C14.9467 14.5001 15.3917 14.6845 15.7198 15.0127C15.7198 15.0127 15.7198 15.0127 15.7199 15.0127L19.2861 18.5789L19.2865 18.5794C19.304 18.5969 19.3262 18.6088 19.3505 18.6137C19.3747 18.6185 19.3999 18.6161 19.4228 18.6066C19.4456 18.5972 19.4651 18.5812 19.4789 18.5606C19.4926 18.5401 19.5 18.5159 19.5 18.4912L14.4825 14.5ZM14.4825 14.5H2.5C1.96957 14.5 1.46086 14.2893 1.08579 13.9142C0.710714 13.5391 0.5 13.0304 0.5 12.5V2.5C0.5 1.96957 0.710714 1.46086 1.08579 1.08579C1.46086 0.710714 1.96957 0.5 2.5 0.5H17.5C18.0304 0.5 18.5391 0.710714 18.9142 1.08579C19.2893 1.46086 19.5 1.96957 19.5 2.5M14.4825 14.5L19.5 2.5M19.5 2.5V18.4911V2.5Z",
      stroke: "currentColor"
    }
  ) });
};

// ../icons/components/ChatLogoIcon.tsx
var import_jsx_runtime20 = require("react/jsx-runtime");

// ../icons/components/ChatPromptIcon.tsx
var import_jsx_runtime21 = require("react/jsx-runtime");

// ../icons/components/ChatTableIcon.tsx
var import_jsx_runtime22 = require("react/jsx-runtime");

// ../icons/components/ChatIcon.tsx
var import_jsx_runtime23 = require("react/jsx-runtime");

// ../icons/components/CheckMarkSimpleIcon.tsx
var import_jsx_runtime24 = require("react/jsx-runtime");

// ../icons/components/CheckMarkIcon.tsx
var import_jsx_runtime25 = require("react/jsx-runtime");

// ../icons/components/ChevronDoubleIcon.tsx
var import_jsx_runtime26 = require("react/jsx-runtime");

// ../icons/components/ClipboardIcon.tsx
var import_jsx_runtime27 = require("react/jsx-runtime");

// ../icons/components/CloseSquareIcon.tsx
var import_jsx_runtime28 = require("react/jsx-runtime");

// ../icons/components/CloseIcon.tsx
var import_jsx_runtime29 = require("react/jsx-runtime");

// ../icons/components/ClosedGateIcon.tsx
var import_jsx_runtime30 = require("react/jsx-runtime");

// ../icons/components/CloudIcon.tsx
var import_jsx_runtime31 = require("react/jsx-runtime");

// ../icons/components/CohereIcon.tsx
var import_jsx_runtime32 = require("react/jsx-runtime");

// ../icons/components/ColorBucketIcon.tsx
var import_jsx_runtime33 = require("react/jsx-runtime");

// ../icons/components/ColorPaletteIcon.tsx
var import_jsx_runtime34 = require("react/jsx-runtime");

// ../icons/components/ComponentIcon.tsx
var import_jsx_runtime35 = require("react/jsx-runtime");

// ../icons/components/CreditCardGearIcon.tsx
var import_jsx_runtime36 = require("react/jsx-runtime");

// ../icons/components/CreditCardIcon.tsx
var import_jsx_runtime37 = require("react/jsx-runtime");

// ../icons/components/CsvIcon.tsx
var import_jsx_runtime38 = require("react/jsx-runtime");

// ../icons/components/DashboardBackground_1Icon.tsx
var import_jsx_runtime39 = require("react/jsx-runtime");

// ../icons/components/DashboardBackground_2Icon.tsx
var import_jsx_runtime40 = require("react/jsx-runtime");

// ../icons/components/DashboardBackground_3Icon.tsx
var import_jsx_runtime41 = require("react/jsx-runtime");

// ../icons/components/DashboardBackground_4Icon.tsx
var import_jsx_runtime42 = require("react/jsx-runtime");

// ../icons/components/DashboardBackground_5Icon.tsx
var import_jsx_runtime43 = require("react/jsx-runtime");

// ../icons/components/DashboardBackground_6Icon.tsx
var import_jsx_runtime44 = require("react/jsx-runtime");

// ../icons/components/DashboardBackground_7Icon.tsx
var import_jsx_runtime45 = require("react/jsx-runtime");

// ../icons/components/DashboardBackground_8Icon.tsx
var import_jsx_runtime46 = require("react/jsx-runtime");

// ../icons/components/DashboardTheme_1Icon.tsx
var import_jsx_runtime47 = require("react/jsx-runtime");

// ../icons/components/DashboardTheme_2Icon.tsx
var import_jsx_runtime48 = require("react/jsx-runtime");

// ../icons/components/DashboardTheme_3Icon.tsx
var import_jsx_runtime49 = require("react/jsx-runtime");

// ../icons/components/DashboardTheme_4Icon.tsx
var import_jsx_runtime50 = require("react/jsx-runtime");

// ../icons/components/DashboardTheme_5Icon.tsx
var import_jsx_runtime51 = require("react/jsx-runtime");

// ../icons/components/DashboardTheme_6Icon.tsx
var import_jsx_runtime52 = require("react/jsx-runtime");

// ../icons/components/DashboardTheme_7Icon.tsx
var import_jsx_runtime53 = require("react/jsx-runtime");

// ../icons/components/DashboardTheme_8Icon.tsx
var import_jsx_runtime54 = require("react/jsx-runtime");

// ../icons/components/DashboardIcon.tsx
var import_jsx_runtime55 = require("react/jsx-runtime");
var DashboardIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime55.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 23 23", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: /* @__PURE__ */ (0, import_jsx_runtime55.jsx)(
    "path",
    {
      d: "M12.1894 8.73758V3.14893H19.641V8.73758H12.1894ZM2.875 12.4633V3.14893H10.3265V12.4633H2.875ZM12.1894 19.9149V10.6005H19.641V19.9149H12.1894ZM2.875 19.9149V14.3262H10.3265V19.9149H2.875ZM4.73788 10.6005H8.46365V5.01181H4.73788V10.6005ZM14.0523 18.052H17.7781V12.4633H14.0523V18.052ZM14.0523 6.87469H17.7781V5.01181H14.0523V6.87469ZM4.73788 18.052H8.46365V16.1891H4.73788V18.052Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/DataManagemenentIcon.tsx
var import_jsx_runtime56 = require("react/jsx-runtime");

// ../icons/components/DataSetIcon.tsx
var import_jsx_runtime57 = require("react/jsx-runtime");
var DataSetIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime57.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime57.jsx)(
    "path",
    {
      d: "M12 21C9.48333 21 7.35417 20.6125 5.6125 19.8375C3.87083 19.0625 3 18.1167 3 17V7C3 5.9 3.87917 4.95833 5.6375 4.175C7.39583 3.39167 9.51667 3 12 3C14.4833 3 16.6042 3.39167 18.3625 4.175C20.1208 4.95833 21 5.9 21 7V17C21 18.1167 20.1292 19.0625 18.3875 19.8375C16.6458 20.6125 14.5167 21 12 21ZM12 9.025C13.4833 9.025 14.975 8.8125 16.475 8.3875C17.975 7.9625 18.8167 7.50833 19 7.025C18.8167 6.54167 17.9792 6.08333 16.4875 5.65C14.9958 5.21667 13.5 5 12 5C10.4833 5 8.99583 5.2125 7.5375 5.6375C6.07917 6.0625 5.23333 6.525 5 7.025C5.23333 7.525 6.07917 7.98333 7.5375 8.4C8.99583 8.81667 10.4833 9.025 12 9.025ZM12 14C12.7 14 13.375 13.9667 14.025 13.9C14.675 13.8333 15.2958 13.7375 15.8875 13.6125C16.4792 13.4875 17.0375 13.3333 17.5625 13.15C18.0875 12.9667 18.5667 12.7583 19 12.525V9.525C18.5667 9.75833 18.0875 9.96667 17.5625 10.15C17.0375 10.3333 16.4792 10.4875 15.8875 10.6125C15.2958 10.7375 14.675 10.8333 14.025 10.9C13.375 10.9667 12.7 11 12 11C11.3 11 10.6167 10.9667 9.95 10.9C9.28333 10.8333 8.65417 10.7375 8.0625 10.6125C7.47083 10.4875 6.91667 10.3333 6.4 10.15C5.88333 9.96667 5.41667 9.75833 5 9.525V12.525C5.41667 12.7583 5.88333 12.9667 6.4 13.15C6.91667 13.3333 7.47083 13.4875 8.0625 13.6125C8.65417 13.7375 9.28333 13.8333 9.95 13.9C10.6167 13.9667 11.3 14 12 14ZM12 19C12.7667 19 13.5458 18.9417 14.3375 18.825C15.1292 18.7083 15.8583 18.5542 16.525 18.3625C17.1917 18.1708 17.75 17.9542 18.2 17.7125C18.65 17.4708 18.9167 17.225 19 16.975V14.525C18.5667 14.7583 18.0875 14.9667 17.5625 15.15C17.0375 15.3333 16.4792 15.4875 15.8875 15.6125C15.2958 15.7375 14.675 15.8333 14.025 15.9C13.375 15.9667 12.7 16 12 16C11.3 16 10.6167 15.9667 9.95 15.9C9.28333 15.8333 8.65417 15.7375 8.0625 15.6125C7.47083 15.4875 6.91667 15.3333 6.4 15.15C5.88333 14.9667 5.41667 14.7583 5 14.525V17C5.08333 17.25 5.34583 17.4917 5.7875 17.725C6.22917 17.9583 6.78333 18.1708 7.45 18.3625C8.11667 18.5542 8.85 18.7083 9.65 18.825C10.45 18.9417 11.2333 19 12 19Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/DataUsageIcon.tsx
var import_jsx_runtime58 = require("react/jsx-runtime");

// ../icons/components/DataVisualisationIcon.tsx
var import_jsx_runtime59 = require("react/jsx-runtime");

// ../icons/components/DragIndicatorIcon.tsx
var import_jsx_runtime60 = require("react/jsx-runtime");

// ../icons/components/EditNoteIcon.tsx
var import_jsx_runtime61 = require("react/jsx-runtime");

// ../icons/components/EditIcon.tsx
var import_jsx_runtime62 = require("react/jsx-runtime");
var EditIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 18 18", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime62.jsx)("g", { clipPath: "url(#clip0_2025_9118)", children: /* @__PURE__ */ (0, import_jsx_runtime62.jsx)(
    "path",
    {
      d: "M13.664 0.164035C13.7163 0.111651 13.7784 0.0700905 13.8467 0.0417332C13.915 0.013376 13.9883 -0.0012207 14.0623 -0.0012207C14.1363 -0.0012207 14.2095 0.013376 14.2779 0.0417332C14.3462 0.0700905 14.4083 0.111651 14.4605 0.164035L17.8355 3.53903C17.8879 3.59129 17.9295 3.65336 17.9578 3.7217C17.9862 3.79003 18.0008 3.8633 18.0008 3.93728C18.0008 4.01127 17.9862 4.08453 17.9578 4.15287C17.9295 4.22121 17.8879 4.28328 17.8355 4.33553L6.58553 15.5855C6.53155 15.6391 6.46725 15.6812 6.39653 15.7093L0.771532 17.9593C0.66931 18.0002 0.557327 18.0102 0.449466 17.9881C0.341605 17.966 0.24261 17.9127 0.164753 17.8348C0.0868953 17.757 0.0336002 17.658 0.0114743 17.5501C-0.0106516 17.4422 -0.000635168 17.3303 0.0402818 17.228L2.29028 11.603C2.31833 11.5323 2.36042 11.468 2.41403 11.414L13.664 0.164035ZM12.6077 2.81228L15.1873 5.39191L16.6419 3.93728L14.0623 1.35766L12.6077 2.81228ZM14.3919 6.18728L11.8123 3.60766L4.49978 10.9202V11.2498H5.06228C5.21147 11.2498 5.35454 11.309 5.46003 11.4145C5.56552 11.52 5.62478 11.6631 5.62478 11.8123V12.3748H6.18728C6.33647 12.3748 6.47954 12.434 6.58503 12.5395C6.69052 12.645 6.74978 12.7881 6.74978 12.9373V13.4998H7.07941L14.3919 6.18728ZM3.41078 12.0092L3.29153 12.1284L1.57253 16.427L5.87116 14.708L5.99041 14.5888C5.8831 14.5487 5.7906 14.4768 5.72526 14.3827C5.65992 14.2886 5.62487 14.1768 5.62478 14.0623V13.4998H5.06228C4.9131 13.4998 4.77002 13.4405 4.66453 13.335C4.55904 13.2295 4.49978 13.0865 4.49978 12.9373V12.3748H3.93728C3.82273 12.3747 3.71094 12.3396 3.61686 12.2743C3.52277 12.209 3.45087 12.1165 3.41078 12.0092Z",
      fill: "currentColor"
    }
  ) }) });
};

// ../icons/components/EditorIcon.tsx
var import_jsx_runtime63 = require("react/jsx-runtime");
var EditorIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime63.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 28 27", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime63.jsx)(
    "path",
    {
      d: "M7.97992 18.7008H15.9599V16.5008H7.97992V18.7008ZM7.97992 14.3008H19.3799V12.1008H7.97992V14.3008ZM7.97992 9.90078H19.3799V7.70078H7.97992V9.90078ZM5.69992 23.1008C5.07292 23.1008 4.53617 22.8854 4.08967 22.4545C3.64317 22.0237 3.41992 21.5058 3.41992 20.9008V5.50078C3.41992 4.89578 3.64317 4.37786 4.08967 3.94703C4.53617 3.5162 5.07292 3.30078 5.69992 3.30078H21.6599C22.2869 3.30078 22.8237 3.5162 23.2702 3.94703C23.7167 4.37786 23.9399 4.89578 23.9399 5.50078V20.9008C23.9399 21.5058 23.7167 22.0237 23.2702 22.4545C22.8237 22.8854 22.2869 23.1008 21.6599 23.1008H5.69992ZM5.69992 20.9008H21.6599V5.50078H5.69992V20.9008Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/ElasticsearchIcon.tsx
var import_jsx_runtime64 = require("react/jsx-runtime");

// ../icons/components/EmailIcon.tsx
var import_jsx_runtime65 = require("react/jsx-runtime");

// ../icons/components/EmptyIcon.tsx
var import_jsx_runtime66 = require("react/jsx-runtime");
var EmptyIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime66.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 100 100", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime66.jsx)(
    "path",
    {
      d: "M37.5 6.25V25H6.25V6.25H37.5ZM6.25 0C4.5924 0 3.00269 0.65848 1.83058 1.83058C0.65848 3.00269 0 4.5924 0 6.25L0 25C0 26.6576 0.65848 28.2473 1.83058 29.4194C3.00269 30.5915 4.5924 31.25 6.25 31.25H37.5C39.1576 31.25 40.7473 30.5915 41.9194 29.4194C43.0915 28.2473 43.75 26.6576 43.75 25V6.25C43.75 4.5924 43.0915 3.00269 41.9194 1.83058C40.7473 0.65848 39.1576 0 37.5 0L6.25 0ZM93.75 75V93.75H62.5V75H93.75ZM62.5 68.75C60.8424 68.75 59.2527 69.4085 58.0806 70.5806C56.9085 71.7527 56.25 73.3424 56.25 75V93.75C56.25 95.4076 56.9085 96.9973 58.0806 98.1694C59.2527 99.3415 60.8424 100 62.5 100H93.75C95.4076 100 96.9973 99.3415 98.1694 98.1694C99.3415 96.9973 100 95.4076 100 93.75V75C100 73.3424 99.3415 71.7527 98.1694 70.5806C96.9973 69.4085 95.4076 68.75 93.75 68.75H62.5ZM37.5 50V93.75H6.25V50H37.5ZM6.25 43.75C4.5924 43.75 3.00269 44.4085 1.83058 45.5806C0.65848 46.7527 0 48.3424 0 50L0 93.75C0 95.4076 0.65848 96.9973 1.83058 98.1694C3.00269 99.3415 4.5924 100 6.25 100H37.5C39.1576 100 40.7473 99.3415 41.9194 98.1694C43.0915 96.9973 43.75 95.4076 43.75 93.75V50C43.75 48.3424 43.0915 46.7527 41.9194 45.5806C40.7473 44.4085 39.1576 43.75 37.5 43.75H6.25ZM93.75 6.25V50H62.5V6.25H93.75ZM62.5 0C60.8424 0 59.2527 0.65848 58.0806 1.83058C56.9085 3.00269 56.25 4.5924 56.25 6.25V50C56.25 51.6576 56.9085 53.2473 58.0806 54.4194C59.2527 55.5915 60.8424 56.25 62.5 56.25H93.75C95.4076 56.25 96.9973 55.5915 98.1694 54.4194C99.3415 53.2473 100 51.6576 100 50V6.25C100 4.5924 99.3415 3.00269 98.1694 1.83058C96.9973 0.65848 95.4076 0 93.75 0L62.5 0Z",
      fill: "currentColor",
      fillOpacity: "0.6"
    }
  ) });
};

// ../icons/components/EntrepriseConnectorIcon.tsx
var import_jsx_runtime67 = require("react/jsx-runtime");
var EntrepriseConnectorIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime67.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime67.jsx)(
    "path",
    {
      d: "M19 9C18.05 9 17.225 8.71667 16.525 8.15C15.825 7.58333 15.3583 6.86667 15.125 6H8.85C8.66667 6.7 8.32083 7.30417 7.8125 7.8125C7.30417 8.32083 6.7 8.66667 6 8.85V15.125C6.86667 15.3583 7.58333 15.825 8.15 16.525C8.71667 17.225 9 18.05 9 19C9 20.1 8.60833 21.0417 7.825 21.825C7.04167 22.6083 6.1 23 5 23C3.9 23 2.95833 22.6083 2.175 21.825C1.39167 21.0417 1 20.1 1 19C1 18.05 1.28333 17.225 1.85 16.525C2.41667 15.825 3.13333 15.3583 4 15.125V8.85C3.13333 8.61667 2.41667 8.15 1.85 7.45C1.28333 6.75 1 5.93333 1 5C1 3.9 1.39167 2.95833 2.175 2.175C2.95833 1.39167 3.9 1 5 1C5.93333 1 6.75 1.28333 7.45 1.85C8.15 2.41667 8.61667 3.13333 8.85 4H15.125C15.3583 3.13333 15.825 2.41667 16.525 1.85C17.225 1.28333 18.05 1 19 1C20.1 1 21.0417 1.39167 21.825 2.175C22.6083 2.95833 23 3.9 23 5C23 6.1 22.6083 7.04167 21.825 7.825C21.0417 8.60833 20.1 9 19 9ZM5 21C5.55 21 6.02083 20.8 6.4125 20.4C6.80417 20 7 19.5333 7 19C7 18.45 6.80417 17.9792 6.4125 17.5875C6.02083 17.1958 5.55 17 5 17C4.46667 17 4 17.1958 3.6 17.5875C3.2 17.9792 3 18.45 3 19C3 19.5333 3.2 20 3.6 20.4C4 20.8 4.46667 21 5 21ZM5 7C5.55 7 6.02083 6.80417 6.4125 6.4125C6.80417 6.02083 7 5.55 7 5C7 4.45 6.80417 3.97917 6.4125 3.5875C6.02083 3.19583 5.55 3 5 3C4.46667 3 4 3.19583 3.6 3.5875C3.2 3.97917 3 4.45 3 5C3 5.55 3.2 6.02083 3.6 6.4125C4 6.80417 4.46667 7 5 7ZM19 23C17.9 23 16.9583 22.6083 16.175 21.825C15.3917 21.0417 15 20.1 15 19C15 17.9 15.3917 16.9583 16.175 16.175C16.9583 15.3917 17.9 15 19 15C20.1 15 21.0417 15.3917 21.825 16.175C22.6083 16.9583 23 17.9 23 19C23 20.1 22.6083 21.0417 21.825 21.825C21.0417 22.6083 20.1 23 19 23ZM19 21C19.55 21 20.0208 20.8 20.4125 20.4C20.8042 20 21 19.5333 21 19C21 18.45 20.8042 17.9792 20.4125 17.5875C20.0208 17.1958 19.55 17 19 17C18.45 17 17.9792 17.1958 17.5875 17.5875C17.1958 17.9792 17 18.45 17 19C17 19.5333 17.1958 20 17.5875 20.4C17.9792 20.8 18.45 21 19 21ZM19 7C19.55 7 20.0208 6.80417 20.4125 6.4125C20.8042 6.02083 21 5.55 21 5C21 4.45 20.8042 3.97917 20.4125 3.5875C20.0208 3.19583 19.55 3 19 3C18.45 3 17.9792 3.19583 17.5875 3.5875C17.1958 3.97917 17 4.45 17 5C17 5.55 17.1958 6.02083 17.5875 6.4125C17.9792 6.80417 18.45 7 19 7Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/EscalatingBarGraphIcon.tsx
var import_jsx_runtime68 = require("react/jsx-runtime");

// ../icons/components/ExcelIcon.tsx
var import_jsx_runtime69 = require("react/jsx-runtime");

// ../icons/components/ExclamationMarkIcon.tsx
var import_jsx_runtime70 = require("react/jsx-runtime");

// ../icons/components/ExpandIcon.tsx
var import_jsx_runtime71 = require("react/jsx-runtime");

// ../icons/components/ExportIcon.tsx
var import_jsx_runtime72 = require("react/jsx-runtime");

// ../icons/components/FacebookIcon.tsx
var import_jsx_runtime73 = require("react/jsx-runtime");

// ../icons/components/FileIcon.tsx
var import_jsx_runtime74 = require("react/jsx-runtime");
var FileIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime74.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 25 24", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime74.jsx)(
    "path",
    {
      d: "M6.60547 22C6.05547 22 5.58464 21.8042 5.19297 21.4125C4.8013 21.0208 4.60547 20.55 4.60547 20V4C4.60547 3.45 4.8013 2.97917 5.19297 2.5875C5.58464 2.19583 6.05547 2 6.60547 2H14.6055L20.6055 8V20C20.6055 20.55 20.4096 21.0208 20.018 21.4125C19.6263 21.8042 19.1555 22 18.6055 22H6.60547ZM13.6055 9V4H6.60547V20H18.6055V9H13.6055Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/FilledIcon.tsx
var import_jsx_runtime75 = require("react/jsx-runtime");

// ../icons/components/GalaxyStarIcon.tsx
var import_jsx_runtime76 = require("react/jsx-runtime");
var GalaxyStarIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)("svg", { width: "1em", height: "1em", viewBox: "0 0 28 33", fill: "none", children: [
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
      "path",
      {
        d: "M11.3443 21.6078C12.0842 21.6078 12.6905 21.0896 12.7932 20.3563C13.8105 13.825 14.7456 12.9157 21.3426 12.202C22.103 12.1141 22.6887 11.5078 22.6887 10.8038C22.6887 10.0901 22.1133 9.50351 21.3529 9.39595C14.797 8.52577 13.9852 7.76315 12.7932 1.24171C12.6596 0.518198 12.0739 0 11.3443 0C10.5942 0 9.99824 0.518198 9.87493 1.25149C8.87819 7.77293 7.9431 8.68221 1.35639 9.39595C0.575437 9.49373 0 10.0804 0 10.8038C0 11.5078 0.554886 12.0945 1.33584 12.202C7.902 13.0917 8.7035 13.8446 9.87493 20.366C10.0291 21.0993 10.625 21.6078 11.3443 21.6078Z",
        fill: "url(#paint0_linear_6275_15032)"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime76.jsx)(
      "path",
      {
        d: "M18.7135 30.0971C19.1707 30.0225 19.4931 29.6411 19.4827 29.1777C19.4527 25.0391 19.9388 24.3829 23.9434 23.2766C24.4044 23.1456 24.7052 22.7119 24.6342 22.2769C24.5623 21.8358 24.1476 21.5314 23.6668 21.5416C19.5279 21.665 18.9493 21.2756 17.5551 17.3659C17.3996 16.9323 16.9854 16.6711 16.5346 16.7447C16.0711 16.8203 15.755 17.2007 15.7528 17.6662C15.7945 21.7966 15.3083 22.4528 11.3101 23.5581C10.8374 23.6972 10.5409 24.1178 10.6139 24.5648C10.6849 24.9999 11.0869 25.3064 11.5804 25.2941C15.7276 25.1818 16.2988 25.5662 17.6803 29.4779C17.8495 29.9155 18.2691 30.1696 18.7135 30.0971Z",
        fill: "url(#paint1_linear_6275_15032)"
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)("defs", { children: [
      /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(
        "linearGradient",
        {
          id: "paint0_linear_6275_15032",
          x1: "4.31085",
          y1: "1.49559",
          x2: "11.3443",
          y2: "21.6078",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime76.jsx)("stop", { stopColor: "#16CCBF" }),
            /* @__PURE__ */ (0, import_jsx_runtime76.jsx)("stop", { offset: "1", stopColor: "#4974F6" })
          ]
        }
      ),
      /* @__PURE__ */ (0, import_jsx_runtime76.jsxs)(
        "linearGradient",
        {
          id: "paint1_linear_6275_15032",
          x1: "16.5346",
          y1: "16.7447",
          x2: "18.7135",
          y2: "30.0971",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ (0, import_jsx_runtime76.jsx)("stop", { stopColor: "#4974F6" }),
            /* @__PURE__ */ (0, import_jsx_runtime76.jsx)("stop", { offset: "1", stopColor: "#003FFF" })
          ]
        }
      )
    ] })
  ] });
};

// ../icons/components/GoogleDriveIcon.tsx
var import_jsx_runtime77 = require("react/jsx-runtime");

// ../icons/components/GoogleWifiIcon.tsx
var import_jsx_runtime78 = require("react/jsx-runtime");

// ../icons/components/GoogleIcon.tsx
var import_jsx_runtime79 = require("react/jsx-runtime");

// ../icons/components/HandThumbsDownIcon.tsx
var import_jsx_runtime80 = require("react/jsx-runtime");

// ../icons/components/HandThumbsUpIcon.tsx
var import_jsx_runtime81 = require("react/jsx-runtime");

// ../icons/components/HelpIcon.tsx
var import_jsx_runtime82 = require("react/jsx-runtime");

// ../icons/components/InfoIcon.tsx
var import_jsx_runtime83 = require("react/jsx-runtime");

// ../icons/components/InstagramIcon.tsx
var import_jsx_runtime84 = require("react/jsx-runtime");

// ../icons/components/ItalicIcon.tsx
var import_jsx_runtime85 = require("react/jsx-runtime");

// ../icons/components/JiraIcon.tsx
var import_jsx_runtime86 = require("react/jsx-runtime");

// ../icons/components/LeftArrowIcon.tsx
var import_jsx_runtime87 = require("react/jsx-runtime");

// ../icons/components/LegendIcon.tsx
var import_jsx_runtime88 = require("react/jsx-runtime");

// ../icons/components/LineChartIcon.tsx
var import_jsx_runtime89 = require("react/jsx-runtime");
var LineChartIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime89.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 28 27", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime89.jsx)(
    "path",
    {
      d: "M3.99027 20.3508L2.28027 18.7008L10.8303 10.4508L15.3903 14.8508L23.4843 6.05078L25.0803 7.59078L15.3903 18.1508L10.8303 13.7508L3.99027 20.3508Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/LineSeriesIcon.tsx
var import_jsx_runtime90 = require("react/jsx-runtime");

// ../icons/components/LinkIcon.tsx
var import_jsx_runtime91 = require("react/jsx-runtime");

// ../icons/components/LinkdinIcon.tsx
var import_jsx_runtime92 = require("react/jsx-runtime");

// ../icons/components/ListIcon.tsx
var import_jsx_runtime93 = require("react/jsx-runtime");

// ../icons/components/LocationIcon.tsx
var import_jsx_runtime94 = require("react/jsx-runtime");

// ../icons/components/LockIcon.tsx
var import_jsx_runtime95 = require("react/jsx-runtime");

// ../icons/components/LogoutIcon.tsx
var import_jsx_runtime96 = require("react/jsx-runtime");

// ../icons/components/MagicStickIcon.tsx
var import_jsx_runtime97 = require("react/jsx-runtime");

// ../icons/components/MailIcon.tsx
var import_jsx_runtime98 = require("react/jsx-runtime");

// ../icons/components/ManufacturingIcon.tsx
var import_jsx_runtime99 = require("react/jsx-runtime");

// ../icons/components/MasterCardIcon.tsx
var import_jsx_runtime100 = require("react/jsx-runtime");

// ../icons/components/MessageIcon.tsx
var import_jsx_runtime101 = require("react/jsx-runtime");

// ../icons/components/MetaIcon.tsx
var import_jsx_runtime102 = require("react/jsx-runtime");

// ../icons/components/MicroIcon.tsx
var import_jsx_runtime103 = require("react/jsx-runtime");

// ../icons/components/MongodbIcon.tsx
var import_jsx_runtime104 = require("react/jsx-runtime");

// ../icons/components/MoreStatisticIcon.tsx
var import_jsx_runtime105 = require("react/jsx-runtime");

// ../icons/components/MysqlIcon.tsx
var import_jsx_runtime106 = require("react/jsx-runtime");

// ../icons/components/NoCardIcon.tsx
var import_jsx_runtime107 = require("react/jsx-runtime");

// ../icons/components/NoDataIcon.tsx
var import_jsx_runtime108 = require("react/jsx-runtime");

// ../icons/components/NoPageIcon.tsx
var import_jsx_runtime109 = require("react/jsx-runtime");

// ../icons/components/NotificationIcon.tsx
var import_jsx_runtime110 = require("react/jsx-runtime");

// ../icons/components/OneGateLogo_1Icon.tsx
var import_jsx_runtime111 = require("react/jsx-runtime");

// ../icons/components/OneGateLogo_2Icon.tsx
var import_jsx_runtime112 = require("react/jsx-runtime");

// ../icons/components/OneGateLogo_3Icon.tsx
var import_jsx_runtime113 = require("react/jsx-runtime");

// ../icons/components/OpenIcon.tsx
var import_jsx_runtime114 = require("react/jsx-runtime");

// ../icons/components/OpenaiIcon.tsx
var import_jsx_runtime115 = require("react/jsx-runtime");

// ../icons/components/OpenedGateIcon.tsx
var import_jsx_runtime116 = require("react/jsx-runtime");

// ../icons/components/OracleIcon.tsx
var import_jsx_runtime117 = require("react/jsx-runtime");

// ../icons/components/PackageManagementIcon.tsx
var import_jsx_runtime118 = require("react/jsx-runtime");

// ../icons/components/PagesIcon.tsx
var import_jsx_runtime119 = require("react/jsx-runtime");

// ../icons/components/PdfIcon.tsx
var import_jsx_runtime120 = require("react/jsx-runtime");

// ../icons/components/PhoneIcon.tsx
var import_jsx_runtime121 = require("react/jsx-runtime");

// ../icons/components/PieChartIcon.tsx
var import_jsx_runtime122 = require("react/jsx-runtime");
var PieChartIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime122.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 28 27", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime122.jsx)(
    "path",
    {
      d: "M13.6803 24.1992C12.1033 24.1992 10.6213 23.9105 9.23427 23.333C7.84727 22.7555 6.64077 21.9717 5.61477 20.9817C4.58877 19.9917 3.77652 18.8276 3.17802 17.4892C2.57952 16.1509 2.28027 14.7209 2.28027 13.1992C2.28027 11.6592 2.57477 10.2246 3.16377 8.89547C3.75277 7.5663 4.56027 6.39755 5.58627 5.38922L13.6803 13.1992V2.19922C15.2573 2.19922 16.7393 2.48797 18.1263 3.06547C19.5133 3.64297 20.7198 4.42672 21.7458 5.41672C22.7718 6.40672 23.584 7.57089 24.1825 8.90922C24.781 10.2476 25.0803 11.6776 25.0803 13.1992C25.0803 14.7209 24.781 16.1509 24.1825 17.4892C23.584 18.8276 22.7718 19.9917 21.7458 20.9817C20.7198 21.9717 19.5133 22.7555 18.1263 23.333C16.7393 23.9105 15.2573 24.1992 13.6803 24.1992Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/PlusIcon.tsx
var import_jsx_runtime123 = require("react/jsx-runtime");

// ../icons/components/PointingArrowIcon.tsx
var import_jsx_runtime124 = require("react/jsx-runtime");

// ../icons/components/PolicyLogoIcon.tsx
var import_jsx_runtime125 = require("react/jsx-runtime");

// ../icons/components/PostgresqlIcon.tsx
var import_jsx_runtime126 = require("react/jsx-runtime");

// ../icons/components/PptIcon.tsx
var import_jsx_runtime127 = require("react/jsx-runtime");

// ../icons/components/ProfileAvatar_1Icon.tsx
var import_jsx_runtime128 = require("react/jsx-runtime");

// ../icons/components/ProfileAvatar_2Icon.tsx
var import_jsx_runtime129 = require("react/jsx-runtime");

// ../icons/components/ProfileAvatar_3Icon.tsx
var import_jsx_runtime130 = require("react/jsx-runtime");

// ../icons/components/ProfileAvatar_4Icon.tsx
var import_jsx_runtime131 = require("react/jsx-runtime");

// ../icons/components/ProfileAvatar_5Icon.tsx
var import_jsx_runtime132 = require("react/jsx-runtime");

// ../icons/components/ProfileInfoIcon.tsx
var import_jsx_runtime133 = require("react/jsx-runtime");

// ../icons/components/ProfileTheme_1Icon.tsx
var import_jsx_runtime134 = require("react/jsx-runtime");

// ../icons/components/ProfileTheme_2Icon.tsx
var import_jsx_runtime135 = require("react/jsx-runtime");

// ../icons/components/ProfileTheme_3Icon.tsx
var import_jsx_runtime136 = require("react/jsx-runtime");

// ../icons/components/ProfileTheme_4Icon.tsx
var import_jsx_runtime137 = require("react/jsx-runtime");

// ../icons/components/ProfileTheme_5Icon.tsx
var import_jsx_runtime138 = require("react/jsx-runtime");

// ../icons/components/ProfileIcon.tsx
var import_jsx_runtime139 = require("react/jsx-runtime");

// ../icons/components/QuestionMarkIcon.tsx
var import_jsx_runtime140 = require("react/jsx-runtime");

// ../icons/components/QuoteRequestIcon.tsx
var import_jsx_runtime141 = require("react/jsx-runtime");

// ../icons/components/RadarChartIcon.tsx
var import_jsx_runtime142 = require("react/jsx-runtime");
var RadarChartIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime142.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 28 27", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime142.jsx)(
    "path",
    {
      d: "M13.6803 24.1992C12.1033 24.1992 10.6213 23.9105 9.23427 23.333C7.84727 22.7555 6.64077 21.9717 5.61477 20.9817C4.58877 19.9917 3.77652 18.8276 3.17802 17.4892C2.57952 16.1509 2.28027 14.7209 2.28027 13.1992C2.28027 11.6776 2.57952 10.2476 3.17802 8.90922C3.77652 7.57089 4.58877 6.40672 5.61477 5.41672C6.64077 4.42672 7.84727 3.64297 9.23427 3.06547C10.6213 2.48797 12.1033 2.19922 13.6803 2.19922C15.2573 2.19922 16.7393 2.48797 18.1263 3.06547C19.5133 3.64297 20.7198 4.42672 21.7458 5.41672C22.7718 6.40672 23.584 7.57089 24.1825 8.90922C24.781 10.2476 25.0803 11.6776 25.0803 13.1992C25.0803 14.7209 24.781 16.1509 24.1825 17.4892C23.584 18.8276 22.7718 19.9917 21.7458 20.9817C20.7198 21.9717 19.5133 22.7555 18.1263 23.333C16.7393 23.9105 15.2573 24.1992 13.6803 24.1992ZM13.6803 21.9992C14.7443 21.9992 15.7465 21.8388 16.687 21.518C17.6275 21.1971 18.4873 20.7434 19.2663 20.1567L17.6418 18.5892C17.0908 18.9742 16.478 19.2721 15.8035 19.483C15.129 19.6938 14.4213 19.7992 13.6803 19.7992C11.7803 19.7992 10.1653 19.1576 8.83527 17.8742C7.50527 16.5909 6.84027 15.0326 6.84027 13.1992C6.84027 11.3659 7.50527 9.80755 8.83527 8.52422C10.1653 7.24089 11.7803 6.59922 13.6803 6.59922C15.5803 6.59922 17.1953 7.24089 18.5253 8.52422C19.8553 9.80755 20.5203 11.3659 20.5203 13.1992C20.5203 13.9142 20.4063 14.6017 20.1783 15.2617C19.9503 15.9217 19.6368 16.5176 19.2378 17.0492L20.8623 18.6167C21.4703 17.8651 21.9453 17.0309 22.2873 16.1142C22.6293 15.1976 22.8003 14.2259 22.8003 13.1992C22.8003 10.7426 21.9168 8.66172 20.1498 6.95672C18.3828 5.25172 16.2263 4.39922 13.6803 4.39922C11.1343 4.39922 8.97777 5.25172 7.21077 6.95672C5.44377 8.66172 4.56027 10.7426 4.56027 13.1992C4.56027 15.6559 5.44377 17.7367 7.21077 19.4417C8.97777 21.1467 11.1343 21.9992 13.6803 21.9992ZM13.6803 17.5992C14.0983 17.5992 14.502 17.5488 14.8915 17.448C15.281 17.3471 15.6468 17.1959 15.9888 16.9942L14.2503 15.3167C14.1553 15.3534 14.0603 15.3763 13.9653 15.3855C13.8703 15.3946 13.7753 15.3992 13.6803 15.3992C13.0533 15.3992 12.5165 15.1838 12.07 14.753C11.6235 14.3221 11.4003 13.8042 11.4003 13.1992C11.4003 12.5942 11.6235 12.0763 12.07 11.6455C12.5165 11.2146 13.0533 10.9992 13.6803 10.9992C14.3073 10.9992 14.844 11.2146 15.2905 11.6455C15.737 12.0763 15.9603 12.5942 15.9603 13.1992C15.9603 13.3092 15.9555 13.4146 15.946 13.5155C15.9365 13.6163 15.9128 13.7126 15.8748 13.8042L17.5848 15.4542C17.7938 15.1242 17.9553 14.7713 18.0693 14.3955C18.1833 14.0196 18.2403 13.6209 18.2403 13.1992C18.2403 11.9892 17.7938 10.9534 16.9008 10.0917C16.0078 9.23005 14.9343 8.79922 13.6803 8.79922C12.4263 8.79922 11.3528 9.23005 10.4598 10.0917C9.56677 10.9534 9.12027 11.9892 9.12027 13.1992C9.12027 14.4092 9.56677 15.4451 10.4598 16.3067C11.3528 17.1684 12.4263 17.5992 13.6803 17.5992Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/RedirectIcon.tsx
var import_jsx_runtime143 = require("react/jsx-runtime");

// ../icons/components/RefreshIcon.tsx
var import_jsx_runtime144 = require("react/jsx-runtime");

// ../icons/components/SageIcon.tsx
var import_jsx_runtime145 = require("react/jsx-runtime");

// ../icons/components/SapIcon.tsx
var import_jsx_runtime146 = require("react/jsx-runtime");

// ../icons/components/SavedIcon.tsx
var import_jsx_runtime147 = require("react/jsx-runtime");

// ../icons/components/SearchNoteIcon.tsx
var import_jsx_runtime148 = require("react/jsx-runtime");

// ../icons/components/SearchPlusIcon.tsx
var import_jsx_runtime149 = require("react/jsx-runtime");

// ../icons/components/SearchIcon.tsx
var import_jsx_runtime150 = require("react/jsx-runtime");

// ../icons/components/SendMoneyIcon.tsx
var import_jsx_runtime151 = require("react/jsx-runtime");

// ../icons/components/SettingsIcon.tsx
var import_jsx_runtime152 = require("react/jsx-runtime");

// ../icons/components/ShareIcon.tsx
var import_jsx_runtime153 = require("react/jsx-runtime");

// ../icons/components/SlackIcon.tsx
var import_jsx_runtime154 = require("react/jsx-runtime");

// ../icons/components/SortIcon.tsx
var import_jsx_runtime155 = require("react/jsx-runtime");

// ../icons/components/SpliteScreenIcon.tsx
var import_jsx_runtime156 = require("react/jsx-runtime");

// ../icons/components/SqlServerIcon.tsx
var import_jsx_runtime157 = require("react/jsx-runtime");

// ../icons/components/StackedbarChartIcon.tsx
var import_jsx_runtime158 = require("react/jsx-runtime");

// ../icons/components/StarChatIcon.tsx
var import_jsx_runtime159 = require("react/jsx-runtime");

// ../icons/components/StarSearchIcon.tsx
var import_jsx_runtime160 = require("react/jsx-runtime");

// ../icons/components/SubscriptionSettingsIcon.tsx
var import_jsx_runtime161 = require("react/jsx-runtime");

// ../icons/components/SuccessIcon.tsx
var import_jsx_runtime162 = require("react/jsx-runtime");

// ../icons/components/SummaryIcon.tsx
var import_jsx_runtime163 = require("react/jsx-runtime");

// ../icons/components/TableIcon.tsx
var import_jsx_runtime164 = require("react/jsx-runtime");
var TableIcon = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime164.jsx)("svg", { width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", children: /* @__PURE__ */ (0, import_jsx_runtime164.jsx)(
    "path",
    {
      d: "M3 19V5C3 4.45 3.19583 3.97917 3.5875 3.5875C3.97917 3.19583 4.45 3 5 3H19C19.55 3 20.0208 3.19583 20.4125 3.5875C20.8042 3.97917 21 4.45 21 5V19C21 19.55 20.8042 20.0208 20.4125 20.4125C20.0208 20.8042 19.55 21 19 21H5C4.45 21 3.97917 20.8042 3.5875 20.4125C3.19583 20.0208 3 19.55 3 19ZM5 9H19V5H5V9ZM10.325 14H13.675V11H10.325V14ZM10.325 19H13.675V16H10.325V19ZM5 14H8.325V11H5V14ZM15.675 14H19V11H15.675V14ZM5 19H8.325V16H5V19ZM15.675 19H19V16H15.675V19Z",
      fill: "currentColor"
    }
  ) });
};

// ../icons/components/TargetIcon.tsx
var import_jsx_runtime165 = require("react/jsx-runtime");

// ../icons/components/ThreeDotsIcon.tsx
var import_jsx_runtime166 = require("react/jsx-runtime");

// ../icons/components/TimingIcon.tsx
var import_jsx_runtime167 = require("react/jsx-runtime");

// ../icons/components/ToolsIcon.tsx
var import_jsx_runtime168 = require("react/jsx-runtime");

// ../icons/components/TrashIcon.tsx
var import_jsx_runtime169 = require("react/jsx-runtime");

// ../icons/components/TrelloIcon.tsx
var import_jsx_runtime170 = require("react/jsx-runtime");

// ../icons/components/TrialBankingIcon.tsx
var import_jsx_runtime171 = require("react/jsx-runtime");

// ../icons/components/TrialFacebookIcon.tsx
var import_jsx_runtime172 = require("react/jsx-runtime");

// ../icons/components/TrialInstagramIcon.tsx
var import_jsx_runtime173 = require("react/jsx-runtime");

// ../icons/components/TrialInsuranceIcon.tsx
var import_jsx_runtime174 = require("react/jsx-runtime");

// ../icons/components/TrialLandingIcon.tsx
var import_jsx_runtime175 = require("react/jsx-runtime");

// ../icons/components/TrialLinkedinIcon.tsx
var import_jsx_runtime176 = require("react/jsx-runtime");

// ../icons/components/TrialRetailIcon.tsx
var import_jsx_runtime177 = require("react/jsx-runtime");

// ../icons/components/TrialTwitterIcon.tsx
var import_jsx_runtime178 = require("react/jsx-runtime");

// ../icons/components/TwiterIcon.tsx
var import_jsx_runtime179 = require("react/jsx-runtime");

// ../icons/components/TxtIcon.tsx
var import_jsx_runtime180 = require("react/jsx-runtime");

// ../icons/components/TypeIcon.tsx
var import_jsx_runtime181 = require("react/jsx-runtime");

// ../icons/components/UnderlineIcon.tsx
var import_jsx_runtime182 = require("react/jsx-runtime");

// ../icons/components/UndoIcon.tsx
var import_jsx_runtime183 = require("react/jsx-runtime");

// ../icons/components/UploadIcon.tsx
var import_jsx_runtime184 = require("react/jsx-runtime");

// ../icons/components/UserManagementIcon.tsx
var import_jsx_runtime185 = require("react/jsx-runtime");

// ../icons/components/VerticalIcon.tsx
var import_jsx_runtime186 = require("react/jsx-runtime");

// ../icons/components/VisaCardIcon.tsx
var import_jsx_runtime187 = require("react/jsx-runtime");

// ../icons/components/WebIcon.tsx
var import_jsx_runtime188 = require("react/jsx-runtime");

// ../icons/components/WebPrivateIcon.tsx
var import_jsx_runtime189 = require("react/jsx-runtime");

// ../icons/components/WordIcon.tsx
var import_jsx_runtime190 = require("react/jsx-runtime");

// ../icons/components/YoutubeIcon.tsx
var import_jsx_runtime191 = require("react/jsx-runtime");

// components/DeleteModal.tsx
var import_jsx_runtime192 = require("react/jsx-runtime");
var DeleteModal = ({
  header,
  containerId,
  typeToDelete,
  isModalOpen,
  selectedTitle,
  handleCancel,
  handleConfirm,
  dataSourceType,
  message: message2,
  deleteLoading
}) => {
  const { isSmartSearchVisible } = useAppLayout();
  (0, import_react70.useEffect)(() => {
    if (isSmartSearchVisible)
      handleCancel();
  }, [isSmartSearchVisible]);
  return /* @__PURE__ */ (0, import_jsx_runtime192.jsxs)(
    StyledDeleteModal,
    {
      getContainer: containerId,
      open: isModalOpen,
      destroyOnClose: true,
      width: "30%",
      onCancel: handleCancel,
      styles: {
        mask: {
          position: "absolute",
          borderRadius: "20px 40px 40px 40px"
        }
      },
      closable: false,
      wrapClassName: "absolute-modal-wrap",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime192.jsx)("h3", { children: header }),
        /* @__PURE__ */ (0, import_jsx_runtime192.jsxs)("p", { className: "description", children: [
          "This ",
          typeToDelete,
          " will be deleted."
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime192.jsxs)(StyledDescription, { children: [
          /* @__PURE__ */ (0, import_jsx_runtime192.jsxs)("div", { children: [
            /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(StyledIcon, { children: dataSourceType === "ENTERPRISE_CONNECTOR" /* ENTERPRISE_CONNECTOR */ ? /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(EntrepriseConnectorIcon, {}) : dataSourceType === "FILE" /* FILE */ ? /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(FileIcon, {}) : dataSourceType === "DATABASE" /* DATABASE */ ? /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(DataSetIcon, {}) : typeToDelete === "conversation" ? /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(ChatHistoryIcon, {}) : /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(DashboardIcon, {}) }),
            /* @__PURE__ */ (0, import_jsx_runtime192.jsx)("p", { className: "selected-title", children: selectedTitle })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime192.jsx)("p", { className: "type", children: message2 })
        ] }),
        /* @__PURE__ */ (0, import_jsx_runtime192.jsxs)(StyledActionButtons, { $deleteLoading: deleteLoading, children: [
          /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(button_default2, { type: "default", onClick: handleCancel, children: "Cancel" }),
          /* @__PURE__ */ (0, import_jsx_runtime192.jsx)(
            button_default2,
            {
              type: "link",
              onClick: handleConfirm,
              style: { boxShadow: "none !important" },
              children: deleteLoading ? "Deleting..." : "Delete"
            }
          )
        ] })
      ]
    }
  );
};
var StyledDeleteModal = (0, import_styled_components3.styled)(modal_default)`
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  h3 {
    text-align: center;
    margin-top: 5px;
  }

  .description {
    text-align: center;
    margin: 12px;
    font-size: 12px;
  }

  .modal-title {
    color: #f00;
    font-size: 20px;
    font-weight: 500;
    margin-bottom: 20px;
    text-align: center;
  }

  .modal-warning {
    border: none;
    height: 63px;
    background-color: rgba(255, 233, 217, 1);
    border-left: 6px solid rgba(210, 125, 63, 1);
    border-radius: 14px;
    color: #7f160c;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;

    .anticon svg {
      font-size: 22px;
      color: rgba(210, 125, 63, 1);
    }
  }

  .ant-modal-content {
    // min-width: 388px;
    // padding: 25px 30px 20px;
    min-width: 350px;
    padding: 20px 30px;
    border-radius: 12px;
    width: 30%;
  }

  .ant-modal-footer {
    display: none;
    justify-content: center;
    margin-top: 20px !important;
    gap: 5px;
  }
`;
var StyledActionButtons = import_styled_components3.styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 20px;

  .ant-btn-default,
  .ant-btn-link {
    width: calc(50% - 30px);
    height: 40px;
    box-shadow: none !important;
    border: none;
    font-size: 12px;
  }
  .ant-btn-default {
    background: #eff1fd;
    color: #040726 !important;
    font-weight: 700;
  }
  .ant-btn-link {
    margin-left: 10px;
    background: #ffcdcd !important;
    color: #f00 !important;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    cursor: ${(props) => props.$deleteLoading ? "not-allowed" : "pointer"};

    &:focus,
    &:active {
      box-shadow: none !important;
      outline: none !important;
    }
    &&& {
      box-shadow: none !important;
      outline: none !important;
    }
  }
`;
var StyledDescription = import_styled_components3.styled.div`
  background: #eff1fd;
  border-radius: 10px;
  // padding: 14px 17px 17px;
  padding: 12px;

  & > div {
    display: flex;
    // justify-content: space-between;
    .ant-form-item {
      margin: 0;
    }
  }

  p {
    margin-block: 6px 0;
    font-size: 13px;
  }
  .selected-title {
    color: #6f7d98;
    font-weight: 700;
    line-height: normal;
    font-size: 12px;
    margin-left: 5px;
    overflow: hidden;
    word-break: break-word;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    -webkit-line-clamp: 1;
  }
  .type {
    margin-top: 5px;
    margin-left: 3px;
    font-size: 12px;
  }
`;
var StyledIcon = import_styled_components3.styled.div`
  display: flex;
  align-items: center;
  color: #6f7d98;
  font-size: 18px;
  margin-top: 5px;
`;

// components/Empty.tsx
var import_styled_components4 = require("styled-components");
var import_jsx_runtime193 = require("react/jsx-runtime");
var Empty4 = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime193.jsxs)(StyledEmpty, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime193.jsx)(EmptyIcon, {}),
    /* @__PURE__ */ (0, import_jsx_runtime193.jsx)("h2", { children: "No data found" })
  ] });
};
var StyledEmpty = import_styled_components4.styled.div`
  margin-top: 150px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 100px;

  h2 {
    width: 555px;
    height: 60px;
    color: #666666;
    text-align: center;
    font-size: 20px;
    font-weight: 700;
    line-height: 30px;
  }
`;

// components/Editor.tsx
var import_ckeditor5_build_classic = __toESM(require_ckeditor());
var import_ckeditor5_react = __toESM(require_dist());

// utils/general/axios.ts
var import_axios = __toESM(require_axios2());

// utils/general/auth-utils.ts
var setAccessToken = (token2) => {
  localStorage.setItem("access_token", token2);
};
var getAccessToken = () => {
  return typeof localStorage === "object" ? localStorage.getItem("access_token") : null;
};
var removeAccessToken = () => {
  if (getAccessToken() != null)
    localStorage.removeItem("access_token");
};
var setRefreshToken = (token2) => {
  localStorage.setItem("refresh_token", token2);
};
var getRefreshToken = () => {
  return typeof localStorage === "object" ? localStorage.getItem("refresh_token") : null;
};
var removeRefreshToken = () => {
  if (getRefreshToken() != null)
    localStorage.removeItem("refresh_token");
};
var getUsernameAccessToken = () => {
  const token2 = getAccessToken();
  return token2 ? JSON.parse(atob(token2.split(".")[1])).username : null;
};

// environments/environments.config.ts
var ENVIRONMENTS = {
  development: {
    // BASE_URL: "https://api-preprod.onegate.ai/api",
    BASE_URL: "https://api.onegate.ai/api",
    APP_URL: "http://localhost:3000",
    STRIPE_TOKEN: "pk_test_51OtXdICCRJcnUpTT9o9VuSCqMNfVRF3yhr23jiWoZ1TvLW772eweka0F4mMimrqmx2IcheWCEeQioqQbOMMQFQ5c00BEyNJROn"
  },
  preproduction: {
    BASE_URL: "https://api-preprod.onegate.ai/api",
    APP_URL: "https://workspace-preprod.onegate.ai",
    STRIPE_TOKEN: "pk_test_51OtXdICCRJcnUpTT9o9VuSCqMNfVRF3yhr23jiWoZ1TvLW772eweka0F4mMimrqmx2IcheWCEeQioqQbOMMQFQ5c00BEyNJROn"
  },
  production: {
    BASE_URL: "https://api.onegate.ai/api",
    APP_URL: "https://workspace.onegate.ai",
    STRIPE_TOKEN: "pk_live_51PH5Tp2M8qPwy5s1Es53IOuIkAykSSfuYf2HJDUlmYB40Ynopxiea9DfcxV95qZwNdmwpJyBZshWFWLKd5SyDX6Y00jna24lib"
  }
};

// utils/general/axios.ts
var hostname = window.location.hostname;
var env = ENVIRONMENTS[hostname === "localhost" ? "development" : hostname === "workspace.onegate.ai" ? "production" : "preproduction"];
var BASE_URL = env.BASE_URL;
var APP_URL = env.APP_URL;
var STRIPE_TOKEN = env.STRIPE_TOKEN;
var WHITELISTED_URLS = ["/package/all", "/account/refresh-token"];
var axios = import_axios.default.create({
  baseURL: BASE_URL
});
var authRequestInterceptor = (config) => {
  if (config.headers) {
    config.headers["Content-Type"] = "application/json";
    config.headers["Timezone-Val"] = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const token2 = getAccessToken();
    if (token2 && config.url && !WHITELISTED_URLS.includes(config.url)) {
      config.headers["authorization"] = `Bearer ${token2}`;
      config.withCredentials = true;
    }
  }
  return config;
};
axios.interceptors.request.use(authRequestInterceptor);
var axios_default = axios;

// utils/general/editor-upload-adapter.ts
var EditorUploadAdapter = class {
  constructor(loader) {
    this.loader = loader;
  }
  upload() {
    return this.loader.file.then((uploadedFile) => {
      return new Promise((resolve, reject) => {
        setTimeout(() => {
          const formData = new FormData();
          formData.append("file", uploadedFile);
          axios.post("/storage/public", formData, {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          }).then((response) => {
            if (response.data.fileKey) {
              resolve({
                default: `${BASE_URL}/storage/public/${response.data.fileKey}`
              });
            } else {
              message_default.error(`${uploadedFile.name} file upload failed.`);
            }
          }).catch((err) => {
            message_default.error(`${uploadedFile.name} file upload failed.`);
          });
        }, 1e3);
      });
    });
  }
  abort() {
  }
};

// components/Editor.tsx
var import_styled_components5 = __toESM(require("styled-components"));
var import_jsx_runtime194 = require("react/jsx-runtime");
var Editor = ({ data, onChange }) => {
  return /* @__PURE__ */ (0, import_jsx_runtime194.jsx)(StyledEditor, { children: /* @__PURE__ */ (0, import_jsx_runtime194.jsx)(
    import_ckeditor5_react.CKEditor,
    {
      data: data || "",
      editor: import_ckeditor5_build_classic.default,
      onReady: (e) => {
        e.plugins.get("FileRepository").createUploadAdapter = (loader) => new EditorUploadAdapter(loader);
      },
      onChange: (e, editor) => onChange(editor.getData())
    }
  ) });
};
var StyledEditor = import_styled_components5.default.div`
  height: 100%;
  min-width: 452px;

  .ck-editor,
  .ck-content {
    height: 100%;
  }

  .ck-editor__main {
    height: calc(100% - 40px);
  }
`;

// components/charts/ChartHeader.tsx
var import_react71 = require("react");
var import_styled_components6 = require("styled-components");
var import_jsx_runtime195 = require("react/jsx-runtime");
var ChartHeader = ({
  isEditable,
  title,
  titleBold,
  titleColor,
  titleUnderline,
  titleItalic,
  subtitleBold,
  subtitleColor,
  subtitleUnderline,
  subtitleItalic,
  subTitle,
  handleTitleChange,
  handleSubTitleChange
}) => {
  const titleStyle = {
    fontWeight: titleBold ? "bold" : "normal",
    color: titleColor,
    textDecoration: titleUnderline ? "underline" : "none",
    fontStyle: titleItalic ? "italic" : "normal"
  };
  const subtitleStyle = {
    fontWeight: subtitleBold ? "bold" : "normal",
    color: subtitleColor,
    textDecoration: subtitleUnderline ? "underline" : "none",
    fontStyle: subtitleItalic ? "italic" : "normal"
  };
  const [showTitleEditIcon, setShowTitleEditIcon] = (0, import_react71.useState)(false);
  const [showSubTitleEditIcon, setShowSubTitleEditIcon] = (0, import_react71.useState)(false);
  const handleEditTitleClick = () => {
    setShowTitleEditIcon(true);
  };
  const handleEditSubTitleClick = () => {
    setShowSubTitleEditIcon(true);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime195.jsxs)(StyledChartHeader, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime195.jsxs)(StyledTitle, { title: title ? true : false, children: [
      /* @__PURE__ */ (0, import_jsx_runtime195.jsx)(
        typography_default.Title,
        __spreadProps(__spreadValues({}, isEditable && {
          editable: {
            tooltip: false,
            enterIcon: null,
            onChange: (value) => {
              setShowTitleEditIcon(false);
              handleTitleChange == null ? void 0 : handleTitleChange(value);
            },
            text: title,
            triggerType: ["text"],
            editing: isEditable && showTitleEditIcon
          }
        }), {
          level: 3,
          style: titleStyle,
          children: title
        })
      ),
      isEditable && !showTitleEditIcon && /* @__PURE__ */ (0, import_jsx_runtime195.jsx)("div", { className: "edit-icon", onClick: handleEditTitleClick, children: /* @__PURE__ */ (0, import_jsx_runtime195.jsx)(EditIcon, {}) })
    ] }),
    /* @__PURE__ */ (0, import_jsx_runtime195.jsxs)(StyledSubTitle, { subTitle: subTitle ? true : false, children: [
      /* @__PURE__ */ (0, import_jsx_runtime195.jsx)(
        typography_default.Title,
        __spreadProps(__spreadValues({}, isEditable && {
          editable: {
            tooltip: false,
            enterIcon: null,
            onChange: (value) => {
              setShowSubTitleEditIcon(false);
              handleSubTitleChange == null ? void 0 : handleSubTitleChange(value);
            },
            text: subTitle,
            triggerType: ["text"],
            editing: isEditable && showSubTitleEditIcon
          }
        }), {
          level: 5,
          style: subtitleStyle,
          children: subTitle
        })
      ),
      isEditable && !showSubTitleEditIcon && /* @__PURE__ */ (0, import_jsx_runtime195.jsx)("div", { className: "edit-icon", onClick: handleEditSubTitleClick, children: /* @__PURE__ */ (0, import_jsx_runtime195.jsx)(EditIcon, {}) })
    ] })
  ] });
};
var StyledChartHeader = import_styled_components6.styled.div`
  h3.ant-typography {
    color: #040726;
    font-size: 21px;
  }
  h5.ant-typography {
    color: #00000099;
    font-size: 14px;
  }

  .ant-typography {
    line-height: 30.896px;
    margin-left: 20px;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
    max-width: 93%;
    width: fit-content;
    max-height: 35px;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    position: relative;
    overflow: hidden;
    word-break: break-all;
    padding: 0px !important;
    &:is(h3) {
      margin-right: 8px;
    }
    &:is(h5) {
      margin-right: 8px;
    }

    .ant-typography-edit {
      // position: absolute;
      position: relative;
      right: 0;
      top: 0;
    }
  }

  .ant-typography-edit-content {
    width: 93%;
    margin-top: 14px;
    &.ant-typography-h3 textarea {
      line-height: 1;
      font-size: 21px;
    }
    &.ant-typography-h5 textarea {
      line-height: 1.5;
      font-size: 14px;
      font-weight: 400;
    }
    textarea {
      height: 20px !important;
      overflow: hidden;
      resize: none;
      white-space: nowrap;
    }
  }
`;
var StyledTitle = import_styled_components6.styled.div`
  display: flex;
  align-items: center;
  // margin-top: 10px;
  min-height: ${(props) => props.title ? "30px" : "10px"};
  // min-height: 30px;
  .edit-icon {
    font-size: 18px;
    display: flex;
    color: #1677ff;
    cursor: pointer;
    height: 20px;
  }
`;
var StyledSubTitle = import_styled_components6.styled.div`
  display: flex;
  align-items: center;
  // min-height: 30px;
  min-height: ${(props) => props.subTitle ? "30px" : "10px"};
  .edit-icon {
    font-size: 18px;
    display: flex;
    color: #1677ff;
    cursor: pointer;
    height: 20px;
    // margin-top: 5px;
  }
`;

// components/ColorPicker.tsx
var import_react73 = require("react");
var import_styled_components7 = require("styled-components");

// utils/helpers/hooks.tsx
var import_react72 = require("react");
var useDebounce = (value, delay = 500) => {
  const [debouncedValue, setDebouncedValue] = (0, import_react72.useState)(value);
  (0, import_react72.useEffect)(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay]
    // Only re-call effect if value or delay changes
  );
  return debouncedValue;
};
var useMountedEffect = (func, deps) => {
  const didMount = (0, import_react72.useRef)(false);
  (0, import_react72.useEffect)(() => {
    if (didMount.current)
      func();
    else
      didMount.current = true;
  }, deps);
};
var useDocumentTitle = (title, prevailOnUnmount = false) => {
  const defaultTitle = (0, import_react72.useRef)(document.title);
  (0, import_react72.useEffect)(() => {
    document.title = title;
  }, [title]);
  (0, import_react72.useEffect)(
    () => () => {
      if (!prevailOnUnmount) {
        document.title = defaultTitle.current;
      }
    },
    []
  );
};

// components/ColorPicker.tsx
var import_jsx_runtime196 = require("react/jsx-runtime");
var ColorPicker = ({
  value,
  colorKey,
  onColorChange,
  colorValue
}) => {
  const [currentColor, setCurrentColor] = (0, import_react73.useState)(value);
  const debouncedColor = useDebounce(currentColor);
  const handleColortrigger = (key) => {
    const colorInput = document.getElementById(key);
    colorInput.click();
  };
  const handleColorChange = (e) => {
    setCurrentColor(e.target.value);
  };
  (0, import_react73.useEffect)(() => {
    onColorChange(colorKey, debouncedColor || value);
  }, [debouncedColor]);
  return /* @__PURE__ */ (0, import_jsx_runtime196.jsxs)(StyledColorPicker, { children: [
    /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(
      StyledColorsPicker,
      {
        $backgroundColor: value,
        onClick: () => handleColortrigger(colorKey)
      }
    ),
    /* @__PURE__ */ (0, import_jsx_runtime196.jsx)(
      "input",
      {
        id: colorKey,
        className: "colorInput",
        type: "color",
        value,
        onChange: handleColorChange
      }
    ),
    colorValue
  ] });
};
var StyledColorPicker = import_styled_components7.styled.div`
  display: flex;
  align-items: center;
  font-size: 13px;
  .colorInput {
    opacity: 0;
    // position: absolute;
    cursor: pointer;
    width: 0px;
  }
`;
var StyledColorsPicker = import_styled_components7.styled.div`
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: ${(p) => p.$backgroundColor};
  margin: 0px 10px;
  cursor: pointer;
  border: 1px solid #d9d9d9;
`;

// components/charts/BarChart.tsx
var import_react74 = require("react");
var import_styled_components8 = require("styled-components");

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Type.js
function isNaN2(value) {
  return Number(value) !== value;
}
function getType(value) {
  return {}.toString.call(value);
}
function toNumber(value) {
  if (value != null && !isNumber(value)) {
    let converted = Number(value);
    if (isNaN2(converted) && isString2(value) && value != "") {
      return toNumber(value.replace(/[^0-9.\-]+/g, ""));
    }
    return converted;
  }
  return value;
}
function toDate(value) {
  if (isDate(value)) {
    return new Date(value);
  } else if (isNumber(value)) {
    return new Date(value);
  } else {
    let num = Number(value);
    if (!isNumber(num)) {
      return new Date(value);
    } else {
      return new Date(num);
    }
  }
}
function numberToString(value) {
  if (isNaN2(value)) {
    return "NaN";
  }
  if (value === Infinity) {
    return "Infinity";
  }
  if (value === -Infinity) {
    return "-Infinity";
  }
  if (value === 0 && 1 / value === -Infinity) {
    return "-0";
  }
  let negative = value < 0;
  value = Math.abs(value);
  let parsed = /^([0-9]+)(?:\.([0-9]+))?(?:e[\+\-]([0-9]+))?$/.exec("" + value);
  let digits = parsed[1];
  let decimals = parsed[2] || "";
  let res;
  if (parsed[3] === void 0) {
    res = decimals === "" ? digits : digits + "." + decimals;
  } else {
    let exponent = +parsed[3];
    if (value < 1) {
      let zeros = exponent - 1;
      res = "0." + repeat("0", zeros) + digits + decimals;
    } else {
      let zeros = exponent - decimals.length;
      if (zeros === 0) {
        res = digits + decimals;
      } else if (zeros < 0) {
        res = digits + decimals.slice(0, zeros) + "." + decimals.slice(zeros);
      } else {
        res = digits + decimals + repeat("0", zeros);
      }
    }
  }
  return negative ? "-" + res : res;
}
function repeat(string3, amount) {
  return new Array(amount + 1).join(string3);
}
function isDate(value) {
  return getType(value) === "[object Date]";
}
function isString2(value) {
  return typeof value === "string";
}
function isNumber(value) {
  return typeof value === "number" && Number(value) == value;
}
function isObject2(value) {
  return typeof value === "object" && value !== null;
}
var PLACEHOLDER = "__\xA7\xA7\xA7__";
var PLACEHOLDER2 = "__\xA7\xA7\xA7\xA7__";

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Array.js
function indexOf(array4, value) {
  const length2 = array4.length;
  for (let i = 0; i < length2; ++i) {
    if (array4[i] === value) {
      return i;
    }
  }
  return -1;
}
function any3(array4, test) {
  const length2 = array4.length;
  for (let i = 0; i < length2; ++i) {
    if (test(array4[i])) {
      return true;
    }
  }
  return false;
}
function map(array4, fn) {
  const length2 = array4.length;
  const output = new Array(length2);
  for (let i = 0; i < length2; ++i) {
    output[i] = fn(array4[i], i);
  }
  return output;
}
function each(array4, fn) {
  const length2 = array4.length;
  for (let i = 0; i < length2; ++i) {
    fn(array4[i], i);
  }
}
function eachReverse(array4, fn) {
  let i = array4.length;
  while (i > 0) {
    --i;
    fn(array4[i], i);
  }
}
function eachContinue(array4, fn) {
  const length2 = array4.length;
  for (let i = 0; i < length2; ++i) {
    if (!fn(array4[i], i)) {
      break;
    }
  }
}
function remove(array4, element) {
  let found = false;
  let index2 = 0;
  for (; ; ) {
    index2 = array4.indexOf(element, index2);
    if (index2 === -1) {
      return found;
    } else {
      found = true;
      array4.splice(index2, 1);
    }
  }
}
function removeFirst(array4, element) {
  let index2 = array4.indexOf(element);
  if (index2 !== -1) {
    array4.splice(index2, 1);
    return true;
  } else {
    return false;
  }
}
function move2(array4, element, toIndex) {
  let index2 = indexOf(array4, element);
  if (index2 !== -1) {
    removeIndex(array4, index2);
  }
  if (toIndex == null) {
    array4.push(element);
  } else {
    insertIndex(array4, toIndex, element);
  }
}
function pushOne(array4, element) {
  if (array4.indexOf(element) === -1) {
    array4.push(element);
  }
}
function copy2(array4) {
  const length2 = array4.length;
  const output = new Array(length2);
  for (let i = 0; i < length2; ++i) {
    output[i] = array4[i];
  }
  return output;
}
function insertIndex(array4, index2, value) {
  array4.splice(index2, 0, value);
}
function removeIndex(array4, index2) {
  array4.splice(index2, 1);
}
function findIndex(array4, matches) {
  const length2 = array4.length;
  for (let i = 0; i < length2; ++i) {
    if (matches(array4[i], i)) {
      return i;
    }
  }
  return -1;
}
function findIndexReverse(array4, matches) {
  let i = array4.length;
  while (i > 0) {
    --i;
    if (matches(array4[i], i)) {
      return i;
    }
  }
  return -1;
}
function find(array4, matches) {
  const index2 = findIndex(array4, matches);
  if (index2 !== -1) {
    return array4[index2];
  }
}
function findReverse(array4, matches) {
  const index2 = findIndexReverse(array4, matches);
  if (index2 !== -1) {
    return array4[index2];
  }
}
function getSortedIndex(array4, ordering) {
  let start = 0;
  let end = array4.length;
  let found = false;
  while (start < end) {
    const pivot = start + end >> 1;
    const order = ordering(array4[pivot]);
    if (order < 0) {
      start = pivot + 1;
    } else if (order === 0) {
      found = true;
      start = pivot + 1;
    } else {
      end = pivot;
    }
  }
  return {
    found,
    index: found ? start - 1 : start
  };
}
function getFirstSortedIndex(array4, ordering) {
  let start = 0;
  let end = array4.length;
  let found = false;
  while (start < end) {
    const pivot = start + end >> 1;
    const order = ordering(array4[pivot]);
    if (order < 0) {
      start = pivot + 1;
    } else if (order === 0) {
      found = true;
      end = pivot;
    } else {
      end = pivot;
    }
  }
  return {
    found,
    index: start
  };
}
function keepIf(array4, keep) {
  let i = array4.length;
  while (i > 0) {
    --i;
    if (!keep(array4[i])) {
      array4.splice(i, 1);
    }
  }
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Disposer.js
var DisposerClass = class {
  /**
   * Constructor.
   */
  constructor() {
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._disposed = false;
  }
  /**
   * Checks if object is disposed.
   *
   * @return Disposed?
   */
  isDisposed() {
    return this._disposed;
  }
  /**
   * Disposes the object.
   */
  dispose() {
    if (!this._disposed) {
      this._disposed = true;
      this._dispose();
    }
  }
};
var Disposer = class {
  /**
   * Constructor.
   *
   * @param dispose  Function that disposes object
   */
  constructor(dispose) {
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_dispose", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._disposed = false;
    this._dispose = dispose;
  }
  /**
   * Checks if object is disposed.
   *
   * @return Disposed?
   */
  isDisposed() {
    return this._disposed;
  }
  /**
   * Disposes the object.
   */
  dispose() {
    if (!this._disposed) {
      this._disposed = true;
      this._dispose();
    }
  }
};
var ArrayDisposer = class extends DisposerClass {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_disposers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
  }
  _dispose() {
    each(this._disposers, (x2) => {
      x2.dispose();
    });
  }
};
var MultiDisposer = class extends DisposerClass {
  constructor(disposers) {
    super();
    Object.defineProperty(this, "_disposers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._disposers = disposers;
  }
  _dispose() {
    each(this._disposers, (x2) => {
      x2.dispose();
    });
  }
  get disposers() {
    return this._disposers;
  }
};
var CounterDisposer = class extends Disposer {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_counter", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
  }
  /**
   * [increment description]
   *
   * @todo Description
   */
  increment() {
    ++this._counter;
    return new Disposer(() => {
      --this._counter;
      if (this._counter === 0) {
        this.dispose();
      }
    });
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/EventDispatcher.js
var EventDispatcher = class {
  /**
   * Constructor
   */
  constructor() {
    Object.defineProperty(this, "_listeners", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_killed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_disabled", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_iterating", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_enabled", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._listeners = [];
    this._killed = [];
    this._disabled = {};
    this._iterating = 0;
    this._enabled = true;
    this._disposed = false;
  }
  /**
   * Returns if this object has been already disposed.
   *
   * @return Disposed?
   */
  isDisposed() {
    return this._disposed;
  }
  /**
   * Dispose (destroy) this object.
   */
  dispose() {
    if (!this._disposed) {
      this._disposed = true;
      const a = this._listeners;
      this._iterating = 1;
      this._listeners = null;
      this._disabled = null;
      try {
        each(a, (x2) => {
          x2.disposer.dispose();
        });
      } finally {
        this._killed = null;
        this._iterating = null;
      }
    }
  }
  /**
   * Checks if this particular event dispatcher has any listeners set.
   *
   * @return Has listeners?
   */
  hasListeners() {
    return this._listeners.length !== 0;
  }
  /**
   * Checks if this particular event dispatcher has any particular listeners set.
   *
   * @return Has particular event listeners?
   */
  hasListenersByType(type4) {
    return any3(this._listeners, (x2) => (x2.type === null || x2.type === type4) && !x2.killed);
  }
  /**
   * Enable dispatching of events if they were previously disabled by
   * `disable()`.
   */
  enable() {
    this._enabled = true;
  }
  /**
   * Disable dispatching of events until re-enabled by `enable()`.
   */
  disable() {
    this._enabled = false;
  }
  /**
   * Enable dispatching particular event, if it was disabled before by
   * `disableType()`.
   *
   * @param type Event type
   */
  enableType(type4) {
    delete this._disabled[type4];
  }
  /**
   * Disable dispatching of events for a certain event type.
   *
   * Optionally, can set how many dispatches to skip before automatically
   * re-enabling the dispatching.
   *
   * @param type    Event type
   * @param amount  Number of event dispatches to skip
   */
  disableType(type4, amount = Infinity) {
    this._disabled[type4] = amount;
  }
  /**
   * Removes listener from dispatcher.
   *
   * Will throw an exception if such listener does not exists.
   *
   * @param listener Listener to remove
   */
  _removeListener(listener) {
    if (this._iterating === 0) {
      const index2 = this._listeners.indexOf(listener);
      if (index2 === -1) {
        throw new Error("Invalid state: could not remove listener");
      }
      this._listeners.splice(index2, 1);
    } else {
      this._killed.push(listener);
    }
  }
  /**
   * Removes existing listener by certain parameters.
   *
   * @param once         Listener's once setting
   * @param type         Listener's type
   * @param callback     Callback function
   * @param context      Callback context
   */
  _removeExistingListener(once, type4, callback, context) {
    if (this._disposed) {
      throw new Error("EventDispatcher is disposed");
    }
    this._eachListener((info) => {
      if (info.once === once && // TODO is this correct ?
      info.type === type4 && (callback === void 0 || info.callback === callback) && info.context === context) {
        info.disposer.dispose();
      }
    });
  }
  /**
   * Checks if dispatching for particular event type is enabled.
   *
   * @param type  Event type
   * @return Enabled?
   */
  isEnabled(type4) {
    if (this._disposed) {
      throw new Error("EventDispatcher is disposed");
    }
    return this._enabled && this._listeners.length > 0 && this.hasListenersByType(type4) && this._disabled[type4] === void 0;
  }
  /**
   * Removes all listeners of a particular event type
   *
   * @param type  Listener's type
   */
  removeType(type4) {
    if (this._disposed) {
      throw new Error("EventDispatcher is disposed");
    }
    this._eachListener((info) => {
      if (info.type === type4) {
        info.disposer.dispose();
      }
    });
  }
  /**
   * Checks if there's already a listener with specific parameters.
   *
   * @param type      Listener's type
   * @param callback  Callback function
   * @param context   Callback context
   * @return Has listener?
   */
  has(type4, callback, context) {
    const index2 = findIndex(this._listeners, (info) => {
      return info.once !== true && // Ignoring "once" listeners
      info.type === type4 && (callback === void 0 || info.callback === callback) && info.context === context;
    });
    return index2 !== -1;
  }
  /**
   * Checks whether event of the particular type should be dispatched.
   *
   * @param type  Event type
   * @return Dispatch?
   */
  _shouldDispatch(type4) {
    if (this._disposed) {
      throw new Error("EventDispatcher is disposed");
    }
    const count = this._disabled[type4];
    if (!isNumber(count)) {
      return this._enabled;
    } else {
      if (count <= 1) {
        delete this._disabled[type4];
      } else {
        --this._disabled[type4];
      }
      return false;
    }
  }
  /**
   * [_eachListener description]
   *
   * All of this extra code is needed when a listener is removed while iterating
   *
   * @todo Description
   * @param fn [description]
   */
  _eachListener(fn) {
    ++this._iterating;
    try {
      each(this._listeners, fn);
    } finally {
      --this._iterating;
      if (this._iterating === 0 && this._killed.length !== 0) {
        each(this._killed, (killed) => {
          this._removeListener(killed);
        });
        this._killed.length = 0;
      }
    }
  }
  /**
   * Dispatches an event immediately without waiting for next cycle.
   *
   * @param type   Event type
   * @param event  Event object
   * @todo automatically add in type and target properties if they are missing
   */
  dispatch(type4, event) {
    if (this._shouldDispatch(type4)) {
      this._eachListener((listener) => {
        if (!listener.killed && (listener.type === null || listener.type === type4)) {
          listener.dispatch(type4, event);
        }
      });
    }
  }
  /**
   * Shelves the event to be dispatched within next update cycle.
   *
   * @param type   Event type
   * @param event  Event object
   * @todo automatically add in type and target properties if they are missing
   */
  /*public dispatchLater<Key extends keyof T>(type: Key, event: T[Key]): void {
      if (this._shouldDispatch(type)) {
          this._eachListener((listener) => {
              // TODO check if it's faster to use an object of listeners rather than a single big array
              if (!listener.killed && (listener.type === null || listener.type === type)) {
                  // TODO if the function throws, maybe it should keep going ?
                  // TODO dispatch during the update cycle, rather than using whenIdle
                  $async.whenIdle(() => {
                      if (!listener.killed) {
                          listener.dispatch(type, event);
                      }
                  });
              }
          });
      }
  }*/
  /**
   * Creates, catalogs and returns an [[EventListener]].
   *
   * Event listener can be disposed.
   *
   * @param once         Listener's once setting
   * @param type         Listener's type
   * @param callback     Callback function
   * @param context      Callback context
   * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
   * @param dispatch
   * @returns An event listener
   */
  _on(once, type4, callback, context, shouldClone, dispatch) {
    if (this._disposed) {
      throw new Error("EventDispatcher is disposed");
    }
    this._removeExistingListener(once, type4, callback, context);
    const info = {
      type: type4,
      callback,
      context,
      shouldClone,
      dispatch,
      killed: false,
      once,
      disposer: new Disposer(() => {
        info.killed = true;
        this._removeListener(info);
      })
    };
    this._listeners.push(info);
    return info;
  }
  /**
   * Creates an event listener to be invoked on **any** event.
   *
   * @param callback     Callback function
   * @param context      Callback context
   * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
   * @returns A disposable event listener
   */
  onAll(callback, context, shouldClone = true) {
    return this._on(false, null, callback, context, shouldClone, (_type, event) => callback.call(context, event)).disposer;
  }
  /**
   * Creates an event listener to be invoked on a specific event type.
   *
   * ```TypeScript
   * button.events.once("click", (ev) => {
   *   console.log("Button clicked");
   * }, this);
   * ```
   * ```JavaScript
   * button.events.once("click", (ev) => {
   *   console.log("Button clicked");
   * }, this);
   * ```
   *
   * The above will invoke our custom event handler whenever series we put
   * event on is hidden.
   *
   * @param type         Listener's type
   * @param callback     Callback function
   * @param context      Callback context
   * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
   * @returns A disposable event listener
   */
  on(type4, callback, context, shouldClone = true) {
    return this._on(false, type4, callback, context, shouldClone, (_type, event) => callback.call(context, event)).disposer;
  }
  /**
   * Creates an event listener to be invoked on a specific event type once.
   *
   * Once the event listener is invoked, it is automatically disposed.
   *
   * ```TypeScript
   * button.events.once("click", (ev) => {
   *   console.log("Button clicked");
   * }, this);
   * ```
   * ```JavaScript
   * button.events.once("click", (ev) => {
   *   console.log("Button clicked");
   * }, this);
   * ```
   *
   * The above will invoke our custom event handler the first time series we
   * put event on is hidden.
   *
   * @param type         Listener's type
   * @param callback     Callback function
   * @param context      Callback context
   * @param shouldClone  Whether the listener should be copied when the EventDispatcher is copied
   * @returns A disposable event listener
   */
  once(type4, callback, context, shouldClone = true) {
    const x2 = this._on(true, type4, callback, context, shouldClone, (_type, event) => {
      x2.disposer.dispose();
      callback.call(context, event);
    });
    return x2.disposer;
  }
  /**
   * Removes the event listener with specific parameters.
   *
   * @param type         Listener's type
   * @param callback     Callback function
   * @param context      Callback context
   */
  off(type4, callback, context) {
    this._removeExistingListener(false, type4, callback, context);
  }
  /**
   * Copies all dispatcher parameters, including listeners, from another event
   * dispatcher.
   *
   * @param source Source event dispatcher
   * @ignore
   */
  copyFrom(source) {
    if (this._disposed) {
      throw new Error("EventDispatcher is disposed");
    }
    if (source === this) {
      throw new Error("Cannot copyFrom the same TargetedEventDispatcher");
    }
    const disposers = [];
    each(source._listeners, (x2) => {
      if (!x2.killed && x2.shouldClone) {
        if (x2.type === null) {
          disposers.push(this.onAll(x2.callback, x2.context));
        } else if (x2.once) {
          disposers.push(this.once(x2.type, x2.callback, x2.context));
        } else {
          disposers.push(this.on(x2.type, x2.callback, x2.context));
        }
      }
    });
    return new MultiDisposer(disposers);
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/List.js
function checkBounds(index2, len) {
  if (!(index2 >= 0 && index2 < len)) {
    throw new Error("Index out of bounds: " + index2);
  }
}
var List3 = class {
  /**
   * Constructor
   *
   * @param initial  Inital list of values to add to list
   */
  constructor(initial = []) {
    Object.defineProperty(this, "_values", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "events", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new EventDispatcher()
    });
    this._values = initial;
  }
  /**
   * An array of values in the list.
   *
   * Do not use this property to add values. Rather use dedicated methods, like
   * `push()`, `removeIndex()`, etc.
   *
   * @readonly
   * @return List values
   */
  get values() {
    return this._values;
  }
  /**
   * Checks if list contains specific item reference.
   *
   * @param item  Item to search for
   * @return `true` if found, `false` if not found
   */
  contains(value) {
    return this._values.indexOf(value) !== -1;
  }
  /**
   * Removes specific item from the list.
   *
   * @param item An item to remove
   */
  removeValue(value) {
    let i = 0;
    let length2 = this._values.length;
    while (i < length2) {
      if (this._values[i] === value) {
        this.removeIndex(i);
        --length2;
      } else {
        ++i;
      }
    }
  }
  /**
   * Searches the list for specific item and returns its index.
   *
   * @param item  An item to search for
   * @return Index or -1 if not found
   */
  indexOf(value) {
    return indexOf(this._values, value);
  }
  /**
   * Number of items in list.
   *
   * @readonly
   * @return Number of items
   */
  get length() {
    return this._values.length;
  }
  /**
   * Checks if there's a value at specific index.
   *
   * @param index  Index
   * @return Value exists?
   */
  hasIndex(index2) {
    return index2 >= 0 && index2 < this._values.length;
  }
  /**
   * Returns an item at specified index.
   *
   * @param index  Index
   * @return List item
   */
  getIndex(index2) {
    return this._values[index2];
  }
  _onPush(newValue) {
    if (this.events.isEnabled("push")) {
      this.events.dispatch("push", {
        type: "push",
        target: this,
        newValue
      });
    }
  }
  _onInsertIndex(index2, newValue) {
    if (this.events.isEnabled("insertIndex")) {
      this.events.dispatch("insertIndex", {
        type: "insertIndex",
        target: this,
        index: index2,
        newValue
      });
    }
  }
  _onSetIndex(index2, oldValue, newValue) {
    if (this.events.isEnabled("setIndex")) {
      this.events.dispatch("setIndex", {
        type: "setIndex",
        target: this,
        index: index2,
        oldValue,
        newValue
      });
    }
  }
  _onRemoveIndex(index2, oldValue) {
    if (this.events.isEnabled("removeIndex")) {
      this.events.dispatch("removeIndex", {
        type: "removeIndex",
        target: this,
        index: index2,
        oldValue
      });
    }
  }
  _onMoveIndex(oldIndex, newIndex, value) {
    if (this.events.isEnabled("moveIndex")) {
      this.events.dispatch("moveIndex", {
        type: "moveIndex",
        target: this,
        oldIndex,
        newIndex,
        value
      });
    }
  }
  _onClear(oldValues) {
    if (this.events.isEnabled("clear")) {
      this.events.dispatch("clear", {
        type: "clear",
        target: this,
        oldValues
      });
    }
  }
  /**
   * Sets value at specific index.
   *
   * If there's already a value at the index, it is overwritten.
   *
   * @param index  Index
   * @param value  New value
   * @return New value
   */
  setIndex(index2, value) {
    checkBounds(index2, this._values.length);
    const oldValue = this._values[index2];
    if (oldValue !== value) {
      this._values[index2] = value;
      this._onSetIndex(index2, oldValue, value);
    }
    return oldValue;
  }
  /**
   * Adds an item to the list at a specific index, which pushes all the other
   * items further down the list.
   *
   * @param index Index
   * @param item  An item to add
   */
  insertIndex(index2, value) {
    checkBounds(index2, this._values.length + 1);
    insertIndex(this._values, index2, value);
    this._onInsertIndex(index2, value);
    return value;
  }
  /**
   * Swaps indexes of two items in the list.
   *
   * @param a  Item 1
   * @param b  Item 2
   */
  swap(a, b) {
    const len = this._values.length;
    checkBounds(a, len);
    checkBounds(b, len);
    if (a !== b) {
      const value_a = this._values[a];
      const value_b = this._values[b];
      this._values[a] = value_b;
      this._onSetIndex(a, value_a, value_b);
      this._values[b] = value_a;
      this._onSetIndex(b, value_b, value_a);
    }
  }
  /**
   * Removes a value at specific index.
   *
   * @param index  Index of value to remove
   * @return Removed value
   */
  removeIndex(index2) {
    checkBounds(index2, this._values.length);
    const oldValue = this._values[index2];
    removeIndex(this._values, index2);
    this._onRemoveIndex(index2, oldValue);
    return oldValue;
  }
  /**
   * Moves an item to a specific index within the list.
   *
   * If the index is not specified it will move the item to the end of the
   * list.
   *
   * @param value  Item to move
   * @param index  Index to place item at
   */
  moveValue(value, toIndex) {
    let index2 = this.indexOf(value);
    if (index2 !== -1) {
      removeIndex(this._values, index2);
      if (toIndex == null) {
        const toIndex2 = this._values.length;
        this._values.push(value);
        this._onMoveIndex(index2, toIndex2, value);
      } else {
        insertIndex(this._values, toIndex, value);
        this._onMoveIndex(index2, toIndex, value);
      }
    } else if (toIndex == null) {
      this._values.push(value);
      this._onPush(value);
    } else {
      insertIndex(this._values, toIndex, value);
      this._onInsertIndex(toIndex, value);
    }
    return value;
  }
  /**
   * Adds an item to the end of the list.
   *
   * @param item  An item to add
   */
  push(value) {
    this._values.push(value);
    this._onPush(value);
    return value;
  }
  /**
   * Adds an item as a first item in the list.
   *
   * @param item  An item to add
   */
  unshift(value) {
    this.insertIndex(0, value);
    return value;
  }
  /**
   * Adds multiple items to the list.
   *
   * @param items  An Array of items to add
   */
  pushAll(values) {
    each(values, (value) => {
      this.push(value);
    });
  }
  /**
   * Copies and adds items from abother list.
   *
   * @param source  A list top copy items from
   */
  copyFrom(source) {
    this.pushAll(source._values);
  }
  /**
   * Returns the last item from the list, and removes it.
   *
   * @return Item
   */
  pop() {
    let index2 = this._values.length - 1;
    return index2 < 0 ? void 0 : this.removeIndex(this._values.length - 1);
  }
  /**
   * Returns the first item from the list, and removes it.
   *
   * @return Item
   */
  shift() {
    return this._values.length ? this.removeIndex(0) : void 0;
  }
  /**
   * Sets multiple items to the list.
   *
   * All current items are removed.
   *
   * @param newArray  New items
   */
  setAll(newArray) {
    const old = this._values;
    this._values = [];
    this._onClear(old);
    each(newArray, (value) => {
      this._values.push(value);
      this._onPush(value);
    });
  }
  /**
   * Removes all items from the list.
   */
  clear() {
    this.setAll([]);
  }
  /**
   * Returns an ES6 iterator for the list.
   */
  *[Symbol.iterator]() {
    const length2 = this._values.length;
    for (let i = 0; i < length2; ++i) {
      yield this._values[i];
    }
  }
  /**
   * Calls `f` for each element in the list.
   *
   * `f` should have at least one parameter defined which will get a current
   * item, with optional second argument - index.
   */
  each(f) {
    each(this._values, f);
  }
  /**
   * Calls `f` for each element in the list, from right to left.
   *
   * `f` should have at least one parameter defined which will get a current
   * item, with optional second argument - index.
   */
  eachReverse(f) {
    eachReverse(this._values, f);
  }
};
var ListAutoDispose = class extends List3 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "autoDispose", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
  }
  _onSetIndex(index2, oldValue, newValue) {
    if (this.autoDispose) {
      oldValue.dispose();
    }
    super._onSetIndex(index2, oldValue, newValue);
  }
  _onRemoveIndex(index2, oldValue) {
    if (this.autoDispose) {
      oldValue.dispose();
    }
    super._onRemoveIndex(index2, oldValue);
  }
  _onClear(oldValues) {
    if (this.autoDispose) {
      each(oldValues, (x2) => {
        x2.dispose();
      });
    }
    super._onClear(oldValues);
  }
  isDisposed() {
    return this._disposed;
  }
  dispose() {
    if (!this._disposed) {
      this._disposed = true;
      if (this.autoDispose) {
        each(this._values, (x2) => {
          x2.dispose();
        });
      }
    }
  }
};
var ListTemplate = class extends ListAutoDispose {
  constructor(template, make) {
    super();
    Object.defineProperty(this, "template", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "make", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.template = template;
    this.make = make;
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Children.js
var Children3 = class extends List3 {
  constructor(container) {
    super();
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_container", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_events", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._container = container;
    this._events = this.events.onAll((change) => {
      if (change.type === "clear") {
        each(change.oldValues, (x2) => {
          this._onRemoved(x2);
        });
      } else if (change.type === "push") {
        this._onInserted(change.newValue);
      } else if (change.type === "setIndex") {
        this._onRemoved(change.oldValue);
        this._onInserted(change.newValue, change.index);
      } else if (change.type === "insertIndex") {
        this._onInserted(change.newValue, change.index);
      } else if (change.type === "removeIndex") {
        this._onRemoved(change.oldValue);
      } else if (change.type === "moveIndex") {
        this._onRemoved(change.value);
        this._onInserted(change.value, change.newIndex);
      } else {
        throw new Error("Unknown IListEvent type");
      }
    });
  }
  _onInserted(child, index2) {
    child._setParent(this._container, true);
    const childrenDisplay = this._container._childrenDisplay;
    if (index2 === void 0) {
      childrenDisplay.addChild(child._display);
    } else {
      childrenDisplay.addChildAt(child._display, index2);
    }
  }
  _onRemoved(child) {
    this._container._childrenDisplay.removeChild(child._display);
    this._container.markDirtyBounds();
    this._container.markDirty();
  }
  /**
   * Returns `true` if obejct is disposed.
   */
  isDisposed() {
    return this._disposed;
  }
  /**
   * Permanently dispose this object.
   */
  dispose() {
    if (!this._disposed) {
      this._disposed = true;
      this._events.dispose();
      each(this.values, (child) => {
        child.dispose();
      });
    }
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Percent.js
var Percent = class _Percent {
  /**
   * Constructor.
   *
   * @param percent  Percent value
   */
  constructor(percent2) {
    Object.defineProperty(this, "_value", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._value = percent2;
  }
  /**
   * Relative value.
   *
   * E.g. 100% is 1, 50% is 0.5, etc.
   *
   * This is useful to apply transformations to other values. E.g.:
   *
   * ```TypeScript
   * let value = 256;
   * let percent = new am5.p50;
   * console.log(value * percent.value); // outputs 128
   * ```
   * ```JavaScript
   * var value = 256;
   * var percent = new am5.p50;
   * console.log(value * percent.value); // outputs 128
   * ```
   *
   * Alternatively, you can use `am5.percent()` helper function:
   *
   * ```TypeScript
   * let value = 256;
   * let percent = am5.p50;
   * console.log(value * percent.value); // outputs 128
   * ```
   * ```JavaScript
   * var value = 256;
   * var percent = am5.p50;
   * console.log(value * percent.value); // outputs 128
   * ```
   *
   * @readonly
   * @return Relative value
   */
  get value() {
    return this._value / 100;
  }
  /**
   * Value in percent.
   *
   * @readonly
   * @return Percent
   */
  get percent() {
    return this._value;
  }
  toString() {
    return "" + this._value + "%";
  }
  interpolate(min3, max3) {
    return min3 + this.value * (max3 - min3);
  }
  static normalize(percent2, min3, max3) {
    if (percent2 instanceof _Percent) {
      return percent2;
    } else {
      if (min3 === max3) {
        return new _Percent(0);
      } else {
        return new _Percent(Math.min(Math.max((percent2 - min3) * (1 / (max3 - min3)), 0), 1) * 100);
      }
    }
  }
};
function percent(value) {
  return new Percent(value);
}
var p0 = percent(0);
var p100 = percent(100);
var p50 = percent(50);

// ../../node_modules/tslib/tslib.es6.mjs
function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function(resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function(resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Object.js
function keys2(object4) {
  return Object.keys(object4);
}
function keysOrdered(object4, order) {
  return keys2(object4).sort(order);
}
function copy3(object4) {
  return Object.assign({}, object4);
}
function each2(object4, f) {
  keys2(object4).forEach((key) => {
    f(key, object4[key]);
  });
}
function eachContinue2(object4, fn) {
  for (let key in object4) {
    if (hasKey(object4, key)) {
      if (!fn(key, object4[key])) {
        break;
      }
    }
  }
}
function hasKey(object4, key) {
  return {}.hasOwnProperty.call(object4, key);
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Utils.js
function removeElement(el) {
  if (el.parentNode) {
    el.parentNode.removeChild(el);
  }
}
function addEventListener(dom, type4, listener, options) {
  dom.addEventListener(type4, listener, options || false);
  return new Disposer(() => {
    dom.removeEventListener(type4, listener, options || false);
  });
}
function onZoom(listener) {
  return addEventListener(window, "resize", (_ev) => {
    listener();
  });
}
function supports(cap) {
  switch (cap) {
    case "touchevents":
      return window.hasOwnProperty("TouchEvent");
    case "pointerevents":
      return window.hasOwnProperty("PointerEvent");
    case "mouseevents":
      return window.hasOwnProperty("MouseEvent");
    case "wheelevents":
      return window.hasOwnProperty("WheelEvent");
    case "keyboardevents":
      return window.hasOwnProperty("KeyboardEvent");
  }
  return false;
}
function getPointerId(event) {
  let id = event.pointerId || 0;
  return id;
}
function blur() {
  if (document.activeElement && document.activeElement != document.body) {
    if (document.activeElement.blur) {
      document.activeElement.blur();
    } else {
      let input = document.createElement("button");
      input.style.position = "fixed";
      input.style.top = "0px";
      input.style.left = "-10000px";
      document.body.appendChild(input);
      input.focus();
      input.blur();
      document.body.removeChild(input);
    }
  }
}
function focus(el) {
  if (el) {
    el.focus();
  }
}
function getRendererEvent(key) {
  if (supports("pointerevents")) {
    return key;
  } else if (supports("touchevents")) {
    switch (key) {
      case "pointerover":
        return "touchstart";
      case "pointerout":
        return "touchend";
      case "pointerleave":
        return "touchend";
      case "pointerdown":
        return "touchstart";
      case "pointermove":
        return "touchmove";
      case "pointerup":
        return "touchend";
      case "click":
        return "click";
      case "dblclick":
        return "dblclick";
    }
  } else if (supports("mouseevents")) {
    switch (key) {
      case "pointerover":
        return "mouseover";
      case "pointerout":
        return "mouseout";
      case "pointerleave":
        return "mouseleave";
      case "pointerdown":
        return "mousedown";
      case "pointermove":
        return "mousemove";
      case "pointerup":
        return "mouseup";
      case "click":
        return "click";
      case "dblclick":
        return "dblclick";
    }
  }
  return key;
}
function isTouchEvent(ev) {
  if (typeof Touch !== "undefined" && ev instanceof Touch) {
    return true;
  } else if (typeof PointerEvent !== "undefined" && ev instanceof PointerEvent && ev.pointerType != null) {
    switch (ev.pointerType) {
      case "touch":
      case "pen":
      case 2:
        return true;
      case "mouse":
      case 4:
        return false;
      default:
        return !(ev instanceof MouseEvent);
    }
  } else if (ev.type != null) {
    if (ev.type.match(/^mouse/)) {
      return false;
    }
  }
  return true;
}
function setStyle(dom, property, value) {
  dom.style[property] = value;
}
function getStyle2(dom, property) {
  return dom.style[property];
}
function getEventTarget(event) {
  if (event.composedPath) {
    const path2 = event.composedPath();
    if (path2.length === 0) {
      return null;
    } else {
      return path2[0];
    }
  } else {
    return event.target;
  }
}
function contains2(a, b) {
  let cursor = b;
  while (true) {
    if (a === cursor) {
      return true;
    } else if (cursor.parentNode === null) {
      if (cursor.host == null) {
        return false;
      } else {
        cursor = cursor.host;
      }
    } else {
      cursor = cursor.parentNode;
    }
  }
}
function isLocalEvent(event, target) {
  return event.target && contains2(target.root.dom, event.target);
}
function setInteractive(target, interactive) {
  if (interactive) {
    target.style.pointerEvents = "auto";
  } else {
    target.style.pointerEvents = "none";
  }
}
function iOS() {
  return /apple/i.test(navigator.vendor) && "ontouchend" in document;
}
function getSafeResolution() {
  return iOS() ? 1 : void 0;
}
function relativeToValue(percent2, full) {
  if (isNumber(percent2)) {
    return percent2;
  } else if (percent2 != null && isNumber(percent2.value) && isNumber(full)) {
    return full * percent2.value;
  } else {
    return 0;
  }
}
function decimalPlaces(number4) {
  let match2 = ("" + number4).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
  if (!match2) {
    return 0;
  }
  return Math.max(0, (match2[1] ? match2[1].length : 0) - (match2[2] ? +match2[2] : 0));
}
function padString(value, len = 0, char2 = "0") {
  if (typeof value !== "string") {
    value = value.toString();
  }
  return len > value.length ? Array(len - value.length + 1).join(char2) + value : value;
}
function trimLeft(text) {
  return text.replace(/^[\s]*/, "");
}
function trimRight(text) {
  return text.replace(/[\s]*$/, "");
}
function trim2(text) {
  return trimLeft(trimRight(text));
}
function truncateTextWithEllipsis(text, maxLength, breakWords = false, ellipsis = "...") {
  if (text.length > maxLength) {
    let lastNonAlphanumericIndex = maxLength - 1;
    while (lastNonAlphanumericIndex >= 0 && text.charAt(lastNonAlphanumericIndex).match(/\w/)) {
      lastNonAlphanumericIndex--;
    }
    if (lastNonAlphanumericIndex >= 0 && breakWords == false) {
      return text.substring(0, lastNonAlphanumericIndex + 1) + "...";
    } else {
      return text.substring(0, maxLength) + ellipsis;
    }
  } else {
    return text;
  }
}
function getFormat(format2) {
  if (typeof format2 === "undefined") {
    return "string";
  }
  format2 = format2.toLowerCase().replace(/^\[[^\]]*\]/, "");
  format2 = format2.replace(/\[[^\]]+\]/, "");
  format2 = format2.trim();
  let hints = format2.match(/\/(date|number|duration)$/);
  if (hints) {
    return hints[1];
  }
  if (format2 === "number") {
    return "number";
  }
  if (format2 === "date") {
    return "date";
  }
  if (format2 === "duration") {
    return "duration";
  }
  if (format2.match(/[#0]/)) {
    return "number";
  }
  if (format2.match(/[ymwdhnsqaxkzgtei]/)) {
    return "date";
  }
  return "string";
}
function cleanFormat(format2) {
  return format2.replace(/\/(date|number|duration)$/i, "");
}
function stripTags(text) {
  return text ? text.replace(/<[^>]*>/g, "") : text;
}
function escapeForRgex(value) {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}
function getYearDay(date4, utc = false) {
  utc;
  const start = new Date(date4.getFullYear(), 0, 0);
  const diff = date4.getTime() - start.getTime() + (start.getTimezoneOffset() - date4.getTimezoneOffset()) * 60 * 1e3;
  const oneDay = 1e3 * 60 * 60 * 24;
  return Math.floor(diff / oneDay);
}
function getWeek(date4, _utc = false) {
  const d = new Date(Date.UTC(date4.getFullYear(), date4.getMonth(), date4.getDate()));
  const day = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - day);
  const firstDay = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return Math.ceil(((d.getTime() - firstDay.getTime()) / 864e5 + 1) / 7);
}
function getWeekYear(date4, _utc = false) {
  const d = new Date(Date.UTC(date4.getFullYear(), date4.getMonth(), date4.getDate()));
  const day = d.getUTCDay() || 7;
  d.setUTCDate(d.getUTCDate() + 4 - day);
  const firstDay = new Date(Date.UTC(d.getUTCFullYear(), 0, 1));
  return firstDay.getFullYear();
}
function getMonthWeek(date4, utc = false) {
  const firstWeek = getWeek(new Date(date4.getFullYear(), date4.getMonth(), 1), utc);
  let currentWeek = getWeek(date4, utc);
  if (currentWeek == 1) {
    currentWeek = 53;
  }
  return currentWeek - firstWeek + 1;
}
function getDayFromWeek(week, year, weekday = 1, utc = false) {
  let date4 = new Date(year, 0, 4, 0, 0, 0, 0);
  if (utc) {
    date4.setUTCFullYear(year);
  }
  let day = week * 7 + weekday - ((date4.getDay() || 7) + 3);
  return day;
}
function get12Hours(hours, base) {
  if (hours > 12) {
    hours -= 12;
  } else if (hours === 0) {
    hours = 12;
  }
  return base != null ? hours + (base - 1) : hours;
}
function getTimeZone(date4, long = false, savings = false, utc = false, timezone) {
  if (utc) {
    return long ? "Coordinated Universal Time" : "UTC";
  } else if (timezone) {
    const d1 = date4.toLocaleString("en-US", { timeZone: timezone });
    const d2 = date4.toLocaleString("en-US", { timeZone: timezone, timeZoneName: long ? "long" : "short" });
    return trim2(d2.substr(d1.length));
  }
  let wotz = date4.toLocaleString("UTC");
  let wtz = date4.toLocaleString("UTC", { timeZoneName: long ? "long" : "short" }).substr(wotz.length);
  if (savings === false) {
    wtz = wtz.replace(/ (standard|daylight|summer|winter) /i, " ");
  }
  return trim2(wtz);
}
function getTimezoneOffset(timezone) {
  const date4 = new Date(Date.UTC(2012, 0, 1, 0, 0, 0, 0));
  const utcDate = new Date(date4.toLocaleString("en-US", { timeZone: "UTC" }));
  const tzDate = new Date(date4.toLocaleString("en-US", { timeZone: timezone }));
  return (tzDate.getTime() - utcDate.getTime()) / 6e4 * -1;
}
function capitalizeFirst(text) {
  return text.charAt(0).toUpperCase() + text.slice(1);
}
function hslToRgb2(color2) {
  let r, g, b;
  let h = color2.h;
  let s2 = color2.s;
  let l = color2.l;
  if (s2 == 0) {
    r = g = b = l;
  } else {
    let hue2rgb2 = function hue2rgb3(p2, q2, t) {
      if (t < 0) {
        t += 1;
      }
      if (t > 1) {
        t -= 1;
      }
      if (t < 1 / 6) {
        return p2 + (q2 - p2) * 6 * t;
      }
      if (t < 1 / 2) {
        return q2;
      }
      if (t < 2 / 3) {
        return p2 + (q2 - p2) * (2 / 3 - t) * 6;
      }
      return p2;
    };
    let q = l < 0.5 ? l * (1 + s2) : l + s2 - l * s2;
    let p = 2 * l - q;
    r = hue2rgb2(p, q, h + 1 / 3);
    g = hue2rgb2(p, q, h);
    b = hue2rgb2(p, q, h - 1 / 3);
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };
}
function rgbToHsl2(color2) {
  let r = color2.r / 255;
  let g = color2.g / 255;
  let b = color2.b / 255;
  let max3 = Math.max(r, g, b);
  let min3 = Math.min(r, g, b);
  let h = 0;
  let s2 = 0;
  let l = (max3 + min3) / 2;
  if (max3 === min3) {
    h = s2 = 0;
  } else {
    let d = max3 - min3;
    s2 = l > 0.5 ? d / (2 - max3 - min3) : d / (max3 + min3);
    switch (max3) {
      case r:
        h = (g - b) / d + (g < b ? 6 : 0);
        break;
      case g:
        h = (b - r) / d + 2;
        break;
      case b:
        h = (r - g) / d + 4;
        break;
    }
    h /= 6;
  }
  return {
    h,
    s: s2,
    l
  };
}
function lighten(rgb, percent2) {
  if (rgb) {
    return {
      r: Math.max(0, Math.min(255, rgb.r + getLightnessStep(rgb.r, percent2))),
      g: Math.max(0, Math.min(255, rgb.g + getLightnessStep(rgb.g, percent2))),
      b: Math.max(0, Math.min(255, rgb.b + getLightnessStep(rgb.b, percent2))),
      a: rgb.a
    };
  } else {
    return rgb;
  }
}
function getLightnessStep(value, percent2) {
  let base = percent2 > 0 ? 255 - value : value;
  return Math.round(base * percent2);
}
function brighten(rgb, percent2) {
  if (rgb) {
    let base = Math.min(Math.max(rgb.r, rgb.g, rgb.b), 230);
    let step = getLightnessStep(base, percent2);
    return {
      r: Math.max(0, Math.min(255, Math.round(rgb.r + step))),
      g: Math.max(0, Math.min(255, Math.round(rgb.g + step))),
      b: Math.max(0, Math.min(255, Math.round(rgb.b + step))),
      a: rgb.a
    };
  } else {
    return rgb;
  }
}
function isLight(color2) {
  return (color2.r * 299 + color2.g * 587 + color2.b * 114) / 1e3 >= 128;
}
function saturate(rgb, saturation) {
  if (rgb === void 0 || saturation == 1) {
    return rgb;
  }
  let hsl = rgbToHsl2(rgb);
  hsl.s = saturation;
  return hslToRgb2(hsl);
}
function alternativeColor(color2, lightAlternative = { r: 255, g: 255, b: 255 }, darkAlternative = { r: 255, g: 255, b: 255 }) {
  let light = lightAlternative;
  let dark = darkAlternative;
  if (isLight(darkAlternative)) {
    light = darkAlternative;
    dark = lightAlternative;
  }
  return isLight(color2) ? dark : light;
}
function mergeTags(tags1, tags2) {
  if (!tags1) {
    tags1 = [];
  }
  return [...tags1, ...tags2].filter((value, index2, self2) => {
    return self2.indexOf(value) === index2;
  });
}
function sameBounds(a, b) {
  if (!b) {
    return false;
  }
  if (a.left != b.left) {
    return false;
  }
  if (a.right != b.right) {
    return false;
  }
  if (a.top != b.top) {
    return false;
  }
  if (a.bottom != b.bottom) {
    return false;
  }
  return true;
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Color.js
function string2hex(string3) {
  if (string3[0] === "#") {
    string3 = string3.substr(1);
  }
  if (string3.length == 3) {
    string3 = string3[0].repeat(2) + string3[1].repeat(2) + string3[2].repeat(2);
  }
  return parseInt(string3, 16);
}
function rgba2hex(color2) {
  color2 = color2.replace(/[ ]/g, "");
  let matches = color2.match(/^rgb\(([0-9]*),([0-9]*),([0-9]*)\)/i);
  if (matches) {
    matches.push("1");
  } else {
    matches = color2.match(/^rgba\(([0-9]*),([0-9]*),([0-9]*),([.0-9]*)\)/i);
    if (!matches) {
      return 0;
    }
  }
  let hex2 = "";
  for (let i = 1; i <= 3; i++) {
    let val = parseInt(matches[i]).toString(16);
    if (val.length == 1) {
      val = "0" + val;
    }
    hex2 += val;
  }
  return string2hex(hex2);
}
function color(input) {
  return Color.fromAny(input);
}
var Color = class _Color {
  constructor(hex2) {
    Object.defineProperty(this, "_hex", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._hex = hex2 | 0;
  }
  /**
   * Color numeric value.
   */
  get hex() {
    return this._hex;
  }
  /**
   * Value of color's R channel.
   * @return R value
   */
  get r() {
    return this._hex >>> 16;
  }
  /**
   * Value of color's G channel.
   * @return G value
   */
  get g() {
    return this._hex >> 8 & 255;
  }
  /**
   * Value of color's B channel.
   * @return B value
   */
  get b() {
    return this._hex & 255;
  }
  /**
   * Returns color CSS representation in form of `rgba(r, g, b, a)` string.
   *
   * @param   alpha  Opacity
   * @return         CSS string
   */
  toCSS(alpha = 1) {
    return "rgba(" + this.r + ", " + this.g + ", " + this.b + ", " + alpha + ")";
  }
  /**
   * Returns color CSS representation in form of `#rgb` string.
   *
   * @return         CSS string
   */
  toCSSHex() {
    return "#" + padString(this.r.toString(16), 2) + padString(this.g.toString(16), 2) + padString(this.b.toString(16), 2);
  }
  /**
   * Returns color's HSL info.
   * @param   alpha Opacity
   * @return        HSL info
   */
  toHSL(alpha = 1) {
    return rgbToHsl2({
      r: this.r,
      g: this.g,
      b: this.b,
      a: alpha
    });
  }
  /**
   * Converts HSL values into a new [[Color]] object.
   *
   * @param   h H value
   * @param   s S value
   * @param   l L value
   * @return    Color object
   */
  static fromHSL(h, s2, l) {
    const rgb = hslToRgb2({
      h,
      s: s2,
      l
    });
    return this.fromRGB(rgb.r, rgb.g, rgb.b);
  }
  toString() {
    return this.toCSSHex();
  }
  /**
   * Converts hex number into a new [[Color]] object.
   *
   * ```TypeScript
   * Color.fromHex(0xff0000) // red
   * ```
   * ```JavaScript
   * Color.fromHex(0xff0000) // red
   * ```
   *
   * @param   hex  Hex color
   * @return       Color
   */
  static fromHex(hex2) {
    return new _Color(hex2);
  }
  /**
   * Converts RGB values to a new [[Color]] object.
   *
   * @param   r  R value
   * @param   g  G value
   * @param   b  B value
   * @return     Color
   */
  static fromRGB(r, g, b) {
    return new _Color((b | 0) + (g << 8) + (r << 16));
  }
  /**
   * Converts RGB string to a new [[Color]] object.
   *
   * ```TypeScript
   * Color.fromString("#ff0000") // red
   * ```
   * ```JavaScript
   * Color.fromString("#ff0000") // red
   * ```
   *
   * @param   s  RGB string
   * @return     Color
   */
  static fromString(s2) {
    return new _Color(string2hex(s2));
  }
  /**
   * Converts CSS rgba() syntax to a new [[Color]] object.
   *
   * ```TypeScript
   * Color.fromCSS("rgba(255, 0, 0, 1)") // red
   * ```
   * ```JavaScript
   * Color.fromCSS("rgba(255, 0, 0, 1)") // red
   * ```
   *
   * @param  {string} s [description]
   * @return {Color}    [description]
   */
  static fromCSS(s2) {
    return new _Color(rgba2hex(s2));
  }
  /**
   * Convert to color from virtually anything.
   *
   * Will throw an exception if unable to resolve the color.
   *
   * @param   s  Source
   * @return     Color
   */
  static fromAny(s2) {
    if (isString2(s2)) {
      if (s2[0] == "#") {
        return _Color.fromString(s2);
      } else if (s2.substr(0, 3) == "rgb") {
        return _Color.fromCSS(s2);
      }
    } else if (isNumber(s2)) {
      return _Color.fromHex(s2);
    } else if (s2 instanceof _Color) {
      return _Color.fromHex(s2.hex);
    }
    throw new Error("Unknown color syntax: " + s2);
  }
  /**
   * Returns a new [[Color]] object based on either `lightAlternative` or
   * `darkAlternative` depending on which one is more contrasting with
   * the `color`.
   *
   * @param   color             Reference color
   * @param   lightAlternative  Light color
   * @param   darkAlternative   Dark color
   * @return                    Alternative color
   */
  static alternative(color2, lightAlternative, darkAlternative) {
    const rgb = alternativeColor({ r: color2.r, g: color2.g, b: color2.b }, lightAlternative ? { r: lightAlternative.r, g: lightAlternative.g, b: lightAlternative.b } : void 0, darkAlternative ? { r: darkAlternative.r, g: darkAlternative.g, b: darkAlternative.b } : void 0);
    return this.fromRGB(rgb.r, rgb.g, rgb.b);
  }
  /**
   * Returns an intermediate Color between two reference colors depending on
   * the progress (`diff`) between the two.
   *
   * @param   diff  Progress
   * @param   from  Source color
   * @param   to    Target color
   * @param   mode  Interpolation mode
   * @return        Color
   */
  static interpolate(diff, from2, to, mode = "rgb") {
    if (mode == "hsl") {
      const fromHSL = from2.toHSL();
      const toHSL = to.toHSL();
      return _Color.fromHSL(range3(diff, fromHSL.h, toHSL.h), range3(diff, fromHSL.s, toHSL.s), range3(diff, fromHSL.l, toHSL.l));
    } else {
      return _Color.fromRGB(range3(diff, from2.r, to.r), range3(diff, from2.g, to.g), range3(diff, from2.b, to.b));
    }
  }
  /**
   * Returns a new [[Color]] lightened by `percent` value.
   *
   * Use negative value to darken the color.
   *
   * @param   color    Source color
   * @param   percent  Percent
   * @return           New color
   */
  static lighten(color2, percent2) {
    const rgb = lighten({ r: color2.r, g: color2.g, b: color2.b }, percent2);
    return _Color.fromRGB(rgb.r, rgb.g, rgb.b);
  }
  /**
   * Returns a new [[Color]] brightened by `percent` value.
   *
   * Use negative value to dim the color.
   *
   * @param   color    Source color
   * @param   percent  Percent
   * @return           New color
   */
  static brighten(color2, percent2) {
    const rgb = brighten({ r: color2.r, g: color2.g, b: color2.b }, percent2);
    return _Color.fromRGB(rgb.r, rgb.g, rgb.b);
  }
  /**
   * Returns a new [[Color]] saturated by `percent` value.
   *
   * Value range is between `0` (fully desaturated), to `1` (full color).
   *
   * @param   color    Source color
   * @param   percent  Percent
   * @return           New color
   */
  static saturate(color2, percent2) {
    const rgb = saturate({ r: color2.r, g: color2.g, b: color2.b }, percent2);
    return _Color.fromRGB(rgb.r, rgb.g, rgb.b);
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Animation.js
function waitForAnimations(animations) {
  return __awaiter(this, void 0, void 0, function* () {
    if (animations !== void 0) {
      const promises = [];
      each2(animations, (_, animation) => {
        promises.push(animation.waitForStop());
      });
      yield Promise.all(promises);
    }
  });
}
function range3(diff, from2, to) {
  return from2 + diff * (to - from2);
}
function defaultInterpolate(diff, from2, to) {
  if (diff >= 1) {
    return to;
  } else {
    return from2;
  }
}
function percentInterpolate(diff, from2, to) {
  return new Percent(range3(diff, from2.percent, to.percent));
}
function colorInterpolate(diff, from2, to) {
  return Color.interpolate(diff, from2, to);
}
function getInterpolate(from2, to) {
  if (typeof from2 === "number" && typeof to === "number") {
    return range3;
  }
  if (from2 instanceof Percent && to instanceof Percent) {
    return percentInterpolate;
  }
  if (from2 instanceof Color && to instanceof Color) {
    return colorInterpolate;
  }
  return defaultInterpolate;
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Math.js
var PI = Math.PI;
var HALFPI = PI / 2;
var RADIANS = PI / 180;
var DEGREES = 180 / PI;
function round(value, precision, floor) {
  if (!isNumber(precision) || precision <= 0) {
    let rounded = Math.round(value);
    if (floor) {
      if (rounded - value == 0.5) {
        rounded--;
      }
    }
    return rounded;
  } else {
    let d = Math.pow(10, precision);
    return Math.round(value * d) / d;
  }
}
function ceil(value, precision) {
  if (!isNumber(precision) || precision <= 0) {
    return Math.ceil(value);
  } else {
    let d = Math.pow(10, precision);
    return Math.ceil(value * d) / d;
  }
}
function fitToRange(value, min3, max3) {
  return Math.min(Math.max(value, min3), max3);
}
function sin(angle) {
  return Math.sin(RADIANS * angle);
}
function cos(angle) {
  return Math.cos(RADIANS * angle);
}
function normalizeAngle(value) {
  value = value % 360;
  if (value < 0) {
    value += 360;
  }
  return value;
}
function getArcBounds(cx, cy, startAngle, endAngle, radius) {
  let minX = Number.MAX_VALUE;
  let minY = Number.MAX_VALUE;
  let maxX = -Number.MAX_VALUE;
  let maxY = -Number.MAX_VALUE;
  let bpoints = [];
  bpoints.push(getArcPoint(radius, startAngle));
  bpoints.push(getArcPoint(radius, endAngle));
  let fromAngle = Math.min(Math.floor(startAngle / 90) * 90, Math.floor(endAngle / 90) * 90);
  let toAngle = Math.max(Math.ceil(startAngle / 90) * 90, Math.ceil(endAngle / 90) * 90);
  for (let angle = fromAngle; angle <= toAngle; angle += 90) {
    if (angle >= startAngle && angle <= endAngle) {
      bpoints.push(getArcPoint(radius, angle));
    }
  }
  for (let i = 0; i < bpoints.length; i++) {
    let pt = bpoints[i];
    if (pt.x < minX) {
      minX = pt.x;
    }
    if (pt.y < minY) {
      minY = pt.y;
    }
    if (pt.x > maxX) {
      maxX = pt.x;
    }
    if (pt.y > maxY) {
      maxY = pt.y;
    }
  }
  return { left: cx + minX, top: cy + minY, right: cx + maxX, bottom: cy + maxY };
}
function getArcPoint(radius, arc) {
  return { x: radius * cos(arc), y: radius * sin(arc) };
}
function mergeBounds(bounds) {
  const len = bounds.length;
  if (len > 0) {
    let bound = bounds[0];
    let left = bound.left;
    let top = bound.top;
    let right = bound.right;
    let bottom = bound.bottom;
    if (len > 1) {
      for (let i = 1; i < len; i++) {
        bound = bounds[i];
        left = Math.min(bound.left, left);
        right = Math.max(bound.right, right);
        top = Math.min(bound.top, top);
        bottom = Math.max(bound.bottom, bottom);
      }
    }
    return { left, right, top, bottom };
  }
  return { left: 0, right: 0, top: 0, bottom: 0 };
}
function fitAngleToRange(value, startAngle, endAngle) {
  if (startAngle > endAngle) {
    let temp = startAngle;
    startAngle = endAngle;
    endAngle = temp;
  }
  value = normalizeAngle(value);
  let count = (startAngle - normalizeAngle(startAngle)) / 360;
  if (value < startAngle) {
    value += 360 * (count + 1);
  }
  let maxEnd = startAngle + (endAngle - startAngle) / 2 + 180;
  let maxStart = startAngle + (endAngle - startAngle) / 2 - 180;
  if (value > endAngle) {
    if (value - 360 > startAngle) {
      value -= 360;
    } else {
      if (value < maxEnd) {
        value = endAngle;
      } else {
        value = startAngle;
      }
    }
  }
  if (value < startAngle) {
    if (value > maxStart) {
      value = startAngle;
    } else {
      value = endAngle;
    }
  }
  return value;
}
function inBounds(point2, bounds) {
  if (point2.x >= bounds.left && point2.y >= bounds.top && point2.x <= bounds.right && point2.y <= bounds.bottom) {
    return true;
  }
  return false;
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Ease.js
function linear(t) {
  return t;
}
function cubic(t) {
  return t * t * t;
}
function out(ease) {
  return function(t) {
    return 1 - ease(1 - t);
  };
}
var b1 = 4 / 11;
var b2 = 6 / 11;
var b3 = 8 / 11;
var b4 = 3 / 4;
var b5 = 9 / 11;
var b6 = 10 / 11;
var b7 = 15 / 16;
var b8 = 21 / 22;
var b9 = 63 / 64;
var b0 = 1 / b1 / b1;
var tau = 2 * Math.PI;
var amplitude = 1;
var period = 0.3 / tau;
var s = Math.asin(1 / amplitude) * period;

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/States.js
var State = class {
  constructor(entity, settings) {
    Object.defineProperty(this, "_entity", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_settings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_userSettings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    this._entity = entity;
    this._settings = settings;
    each2(settings, (key) => {
      this._userSettings[key] = true;
    });
  }
  get(key, fallback) {
    const value = this._settings[key];
    if (value !== void 0) {
      return value;
    } else {
      return fallback;
    }
  }
  /**
   * @ignore
   */
  setRaw(key, value) {
    this._settings[key] = value;
  }
  /**
   * Sets a setting `value` for the specified `key` to be set when the state
   * is applied.
   *
   * @param   key       Setting key
   * @param   value     Setting value
   * @return            Setting value
   */
  set(key, value) {
    this._userSettings[key] = true;
    this.setRaw(key, value);
  }
  /**
   * Removes a setting value for the specified `key`.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
   * @param   key       Setting key
   */
  remove(key) {
    delete this._userSettings[key];
    delete this._settings[key];
  }
  /**
   * Sets multiple settings at once.
   *
   * `settings` must be an object with key: value pairs.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
   * @param settings Settings
   */
  setAll(settings) {
    keys2(settings).forEach((key) => {
      this.set(key, settings[key]);
    });
  }
  _eachSetting(f) {
    each2(this._settings, f);
  }
  /**
   * Applies the state to the target element.
   *
   * All setting values are set immediately.
   */
  apply() {
    const seen = {};
    seen["stateAnimationEasing"] = true;
    seen["stateAnimationDuration"] = true;
    const defaultState = this._entity.states.lookup("default");
    this._eachSetting((key, value) => {
      if (!seen[key]) {
        seen[key] = true;
        if (this !== defaultState) {
          if (!(key in defaultState._settings)) {
            defaultState._settings[key] = this._entity.get(key);
          }
        }
        this._entity.set(key, value);
      }
    });
  }
  /**
   * Applies the state to the target element.
   *
   * Returns an object representing all [[Animation]] objects created for
   * each setting key transition.
   *
   * @return           Animations
   */
  applyAnimate(duration) {
    if (duration == null) {
      duration = this._settings.stateAnimationDuration;
    }
    if (duration == null) {
      duration = this.get("stateAnimationDuration", this._entity.get("stateAnimationDuration", 0));
    }
    let easing = this._settings.stateAnimationEasing;
    if (easing == null) {
      easing = this.get("stateAnimationEasing", this._entity.get("stateAnimationEasing", cubic));
    }
    const defaultState = this._entity.states.lookup("default");
    const seen = {};
    seen["stateAnimationEasing"] = true;
    seen["stateAnimationDuration"] = true;
    const animations = {};
    this._eachSetting((key, value) => {
      if (!seen[key]) {
        seen[key] = true;
        if (this != defaultState) {
          if (!(key in defaultState._settings)) {
            defaultState._settings[key] = this._entity.get(key);
          }
        }
        const animation = this._entity.animate({
          key,
          to: value,
          duration,
          easing
        });
        if (animation) {
          animations[key] = animation;
        }
      }
    });
    return animations;
  }
};
var States = class {
  constructor(entity) {
    Object.defineProperty(this, "_states", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_entity", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._entity = entity;
  }
  /**
   * Checks if a state by `name` exists. Returns it there is one.
   *
   * @param  name  State name
   * @return       State
   */
  lookup(name) {
    return this._states[name];
  }
  /**
   * Sets supplied `settings` on a state by the `name`.
   *
   * If such state does not yet exists, it is created.
   *
   * @param   name      State name
   * @param   settings  Settings
   * @return            New State
   */
  create(name, settings) {
    const state = this._states[name];
    if (state) {
      state.setAll(settings);
      return state;
    } else {
      const state2 = new State(this._entity, settings);
      this._states[name] = state2;
      return state2;
    }
  }
  /**
   * Removes the state called `name`.
   *
   * @param   name      State name
   */
  remove(name) {
    delete this._states[name];
  }
  /**
   * Applies a named state to the target element.
   *
   * @param  newState  State name
   */
  apply(newState) {
    const state = this._states[newState];
    if (state) {
      state.apply();
    }
    this._entity._applyState(newState);
  }
  /**
   * Applies a named state to the element.
   *
   * Returns an object representing all [[Animation]] objects created for
   * each setting key transition.
   *
   * @param   newState  State name
   * @return            Animations
   */
  applyAnimate(newState, duration) {
    let animations;
    const state = this._states[newState];
    if (state) {
      animations = state.applyAnimate(duration);
    }
    this._entity._applyStateAnimated(newState, duration);
    return animations;
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/Registry.js
var Registry = class {
  constructor() {
    Object.defineProperty(this, "version", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "5.7.6"
    });
    Object.defineProperty(this, "licenses", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "entitiesById", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "rootElements", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
  }
};
var registry = new Registry();

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Order.js
function compare(left, right) {
  if (left === right) {
    return 0;
  } else if (left < right) {
    return -1;
  } else {
    return 1;
  }
}
function compareArray(left, right, f) {
  const leftLength = left.length;
  const rightLength = right.length;
  const length2 = Math.min(leftLength, rightLength);
  for (let i = 0; i < length2; ++i) {
    const order = f(left[i], right[i]);
    if (order !== 0) {
      return order;
    }
  }
  return compare(leftLength, rightLength);
}
function compareNumber(a, b) {
  if (a === b) {
    return 0;
  } else if (a < b) {
    return -1;
  } else {
    return 1;
  }
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Entity.js
var Adapters = class {
  constructor(entity) {
    Object.defineProperty(this, "_entity", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_callbacks", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_disabled", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    this._entity = entity;
  }
  /**
   * Add a function (`callback`) that will modify value for setting `key`.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/adapters/} for more info
   */
  add(key, callback) {
    let callbacks = this._callbacks[key];
    if (callbacks === void 0) {
      callbacks = this._callbacks[key] = [];
    }
    callbacks.push(callback);
    this._entity._markDirtyKey(key);
    return new Disposer(() => {
      if (removeFirst(callbacks, callback)) {
        this._entity._markDirtyKey(key);
      }
    });
  }
  /**
   * Removes all adapters for the specific key.
   *
   * @since 5.1.0
   */
  remove(key) {
    const callbacks = this._callbacks[key];
    if (callbacks !== void 0) {
      delete this._callbacks[key];
      if (callbacks.length !== 0) {
        this._entity._markDirtyKey(key);
      }
    }
  }
  /**
   * Enables (previously disabled) adapters for specific key.
   *
   * @since 5.1.0
   */
  enable(key) {
    if (this._disabled[key]) {
      delete this._disabled[key];
      this._entity._markDirtyKey(key);
    }
  }
  /**
   * Disables all adapters for specific key.
   *
   * @since 5.1.0
   */
  disable(key) {
    if (!this._disabled[key]) {
      this._disabled[key] = true;
      this._entity._markDirtyKey(key);
    }
  }
  /**
   * @ignore
   */
  fold(key, value) {
    if (!this._disabled[key]) {
      const callbacks = this._callbacks[key];
      if (callbacks !== void 0) {
        for (let i = 0, len = callbacks.length; i < len; ++i) {
          value = callbacks[i](value, this._entity, key);
        }
      }
    }
    return value;
  }
};
var Animation = class {
  constructor(animation, from2, to, duration, easing, loops, startingTime) {
    Object.defineProperty(this, "_animation", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_from", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_to", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_duration", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_easing", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_loops", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_interpolate", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_oldTime", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_time", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_stopped", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_playing", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "events", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new EventDispatcher()
    });
    this._animation = animation;
    this._from = from2;
    this._to = to;
    this._duration = duration;
    this._easing = easing;
    this._loops = loops;
    this._interpolate = getInterpolate(from2, to);
    this._oldTime = startingTime;
  }
  get to() {
    return this._to;
  }
  get from() {
    return this._from;
  }
  get playing() {
    return this._playing;
  }
  get stopped() {
    return this._stopped;
  }
  stop() {
    if (!this._stopped) {
      this._stopped = true;
      this._playing = false;
      if (this.events.isEnabled("stopped")) {
        this.events.dispatch("stopped", {
          type: "stopped",
          target: this
        });
      }
    }
  }
  pause() {
    this._playing = false;
    this._oldTime = null;
  }
  play() {
    if (!this._stopped && !this._playing) {
      this._playing = true;
      this._animation._startAnimation();
    }
  }
  get percentage() {
    return this._time / this._duration;
  }
  waitForStop() {
    return new Promise((resolve, _reject) => {
      if (this._stopped) {
        resolve();
      } else {
        const listener = () => {
          stopped.dispose();
          resolve();
        };
        const stopped = this.events.on("stopped", listener);
      }
    });
  }
  _checkEnded() {
    if (this._loops > 1) {
      --this._loops;
      return false;
    } else {
      return true;
    }
  }
  _run(currentTime) {
    if (this._oldTime !== null) {
      this._time += currentTime - this._oldTime;
      if (this._time > this._duration) {
        this._time = this._duration;
      }
    }
    this._oldTime = currentTime;
  }
  _reset(currentTime) {
    this._oldTime = currentTime;
    this._time = 0;
  }
  _value(diff) {
    return this._interpolate(this._easing(diff), this._from, this._to);
  }
};
var counter = 0;
var Settings = class {
  constructor(settings) {
    Object.defineProperty(this, "uid", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: ++counter
    });
    Object.defineProperty(this, "_settings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_privateSettings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_settingEvents", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_privateSettingEvents", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_prevSettings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_prevPrivateSettings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_animatingSettings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_animatingPrivateSettings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_playingAnimations", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_userProperties", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    this._settings = settings;
  }
  _checkDirty() {
    keys2(this._settings).forEach((key) => {
      this._userProperties[key] = true;
      this._markDirtyKey(key);
    });
  }
  /**
   * @ignore
   */
  resetUserSettings() {
    this._userProperties = {};
  }
  _runAnimation(currentTime) {
    if (!this.isDisposed()) {
      each2(this._animatingSettings, (key, animation) => {
        if (animation._stopped) {
          this._stopAnimation(key);
        } else if (animation._playing) {
          animation._run(currentTime);
          const diff = animation.percentage;
          if (diff >= 1) {
            if (animation._checkEnded()) {
              this.set(key, animation._value(1));
            } else {
              animation._reset(currentTime);
              this._set(key, animation._value(1));
            }
          } else {
            this._set(key, animation._value(diff));
          }
        }
      });
      each2(this._animatingPrivateSettings, (key, animation) => {
        if (animation._stopped) {
          this._stopAnimationPrivate(key);
        } else if (animation._playing) {
          animation._run(currentTime);
          const diff = animation.percentage;
          if (diff >= 1) {
            if (animation._checkEnded()) {
              this.setPrivate(key, animation._value(1));
            } else {
              animation._reset(currentTime);
              this._setPrivate(key, animation._value(1));
            }
          } else {
            this._setPrivate(key, animation._value(diff));
          }
        }
      });
      return this._playingAnimations !== 0;
    } else {
      return false;
    }
  }
  _markDirtyKey(_key) {
    this.markDirty();
  }
  _markDirtyPrivateKey(_key) {
    this.markDirty();
  }
  /**
   * Sets a callback function to invoke when specific key of settings changes
   * or is set.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
   * @param   key       Settings key
   * @param   callback  Callback
   * @return            Disposer for event
   */
  on(key, callback) {
    let events = this._settingEvents[key];
    if (events === void 0) {
      events = this._settingEvents[key] = [];
    }
    events.push(callback);
    return new Disposer(() => {
      removeFirst(events, callback);
      if (events.length === 0) {
        delete this._settingEvents[key];
      }
    });
  }
  /**
   * Sets a callback function to invoke when specific key of private settings
   * changes or is set.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/events/#Settings_value_change} for more info
   * @ignore
   * @param   key       Private settings key
   * @param   callback  Callback
   * @return            Disposer for event
   */
  onPrivate(key, callback) {
    let events = this._privateSettingEvents[key];
    if (events === void 0) {
      events = this._privateSettingEvents[key] = [];
    }
    events.push(callback);
    return new Disposer(() => {
      removeFirst(events, callback);
      if (events.length === 0) {
        delete this._privateSettingEvents[key];
      }
    });
  }
  /**
   * @ignore
   */
  getRaw(key, fallback) {
    const value = this._settings[key];
    if (value !== void 0) {
      return value;
    } else {
      return fallback;
    }
  }
  get(key, fallback) {
    return this.getRaw(key, fallback);
  }
  _sendKeyEvent(key, value) {
    const events = this._settingEvents[key];
    if (events !== void 0) {
      each(events, (callback) => {
        callback(value, this, key);
      });
    }
  }
  _sendPrivateKeyEvent(key, value) {
    const events = this._privateSettingEvents[key];
    if (events !== void 0) {
      each(events, (callback) => {
        callback(value, this, key);
      });
    }
  }
  /**
   * @ignore
   */
  _setRaw(key, old, value) {
    this._prevSettings[key] = old;
    this._sendKeyEvent(key, value);
  }
  /**
   * @ignore
   */
  setRaw(key, value) {
    const old = this._settings[key];
    this._settings[key] = value;
    if (old !== value) {
      this._setRaw(key, old, value);
    }
  }
  /**
   * @ignore
   */
  _set(key, value) {
    const old = this._settings[key];
    this._settings[key] = value;
    if (old !== value) {
      this._setRaw(key, old, value);
      this._markDirtyKey(key);
    }
  }
  _stopAnimation(key) {
    const animation = this._animatingSettings[key];
    if (animation) {
      --this._playingAnimations;
      delete this._animatingSettings[key];
      animation.stop();
    }
  }
  /**
   * Sets a setting `value` for the specified `key`, and returns the same `value`.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
   * @param   key       Setting key
   * @param   value     Setting value
   * @return            Setting value
   */
  set(key, value) {
    this._set(key, value);
    this._stopAnimation(key);
    return value;
  }
  /**
   * Removes a setting value for the specified `key`;
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
   * @param   key       Setting key
   */
  remove(key) {
    if (key in this._settings) {
      this._prevSettings[key] = this._settings[key];
      delete this._settings[key];
      this._sendKeyEvent(key, void 0);
      this._markDirtyKey(key);
    }
    this._stopAnimation(key);
  }
  /**
   * Removes all keys;
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
   */
  removeAll() {
    each(keys2(this._settings), (key) => {
      this.remove(key);
    });
  }
  /**
   * Returns a value of a private setting.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/#Private_settings} for more info
   */
  getPrivate(key, fallback) {
    const value = this._privateSettings[key];
    if (value !== void 0) {
      return value;
    } else {
      return fallback;
    }
  }
  /**
   * @ignore
   */
  _setPrivateRaw(key, old, value) {
    this._prevPrivateSettings[key] = old;
    this._sendPrivateKeyEvent(key, value);
  }
  /**
   * @ignore
   */
  setPrivateRaw(key, value) {
    const old = this._privateSettings[key];
    this._privateSettings[key] = value;
    if (old !== value) {
      this._setPrivateRaw(key, old, value);
    }
  }
  /**
   * @ignore
   */
  _setPrivate(key, value) {
    const old = this._privateSettings[key];
    this._privateSettings[key] = value;
    if (old !== value) {
      this._setPrivateRaw(key, old, value);
      this._markDirtyPrivateKey(key);
    }
  }
  _stopAnimationPrivate(key) {
    const animation = this._animatingPrivateSettings[key];
    if (animation) {
      --this._playingAnimations;
      animation.stop();
      delete this._animatingPrivateSettings[key];
    }
  }
  /**
   * @ignore
   */
  setPrivate(key, value) {
    this._setPrivate(key, value);
    this._stopAnimationPrivate(key);
    return value;
  }
  /**
   * @ignore
   */
  removePrivate(key) {
    if (key in this._privateSettings) {
      this._prevPrivateSettings[key] = this._privateSettings[key];
      delete this._privateSettings[key];
      this._markDirtyPrivateKey(key);
    }
    this._stopAnimationPrivate(key);
  }
  /**
   * Sets multiple settings at once.
   *
   * `settings` must be an object with key: value pairs.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
   * @param settings Settings
   */
  setAll(settings) {
    each2(settings, (key, value) => {
      this.set(key, value);
    });
  }
  /**
   * Animates setting values from current/start values to new ones.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/animations/#Animating_settings} for more info
   * @param   options  Animation options
   * @return           Animation object
   */
  animate(options) {
    const key = options.key;
    const to = options.to;
    const duration = options.duration || 0;
    const loops = options.loops || 1;
    const from2 = options.from === void 0 ? this.get(key) : options.from;
    const easing = options.easing === void 0 ? linear : options.easing;
    if (duration === 0) {
      this.set(key, to);
    } else {
      if (from2 === void 0 || from2 === to) {
        this.set(key, to);
      } else {
        this.set(key, from2);
        const animation2 = this._animatingSettings[key] = new Animation(this, from2, to, duration, easing, loops, this._animationTime());
        ++this._playingAnimations;
        this._startAnimation();
        return animation2;
      }
    }
    const animation = new Animation(this, from2, to, duration, easing, loops, null);
    animation.stop();
    return animation;
  }
  /**
   * @ignore
   */
  animatePrivate(options) {
    const key = options.key;
    const to = options.to;
    const duration = options.duration || 0;
    const loops = options.loops || 1;
    const from2 = options.from === void 0 ? this.getPrivate(key) : options.from;
    const easing = options.easing === void 0 ? linear : options.easing;
    if (duration === 0) {
      this.setPrivate(key, to);
    } else {
      if (from2 === void 0 || from2 === to) {
        this.setPrivate(key, to);
      } else {
        this.setPrivate(key, from2);
        const animation2 = this._animatingPrivateSettings[key] = new Animation(this, from2, to, duration, easing, loops, this._animationTime());
        ++this._playingAnimations;
        this._startAnimation();
        return animation2;
      }
    }
    const animation = new Animation(this, from2, to, duration, easing, loops, null);
    animation.stop();
    return animation;
  }
  _dispose() {
  }
  /**
   * Returns `true` if this element is disposed.
   *
   * @return Disposed
   */
  isDisposed() {
    return this._disposed;
  }
  /**
   * Disposes this object.
   */
  dispose() {
    if (!this._disposed) {
      this._disposed = true;
      this._dispose();
    }
  }
};
var Entity2 = class extends Settings {
  /**
   * IMPORTANT! Do not instantiate this class via `new Class()` syntax.
   *
   * Use static method `Class.new()` instead.
   *
   * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
   * @ignore
   */
  constructor(root, settings, isReal, templates = []) {
    super(settings);
    Object.defineProperty(this, "_root", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_user_id", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "states", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new States(this)
    });
    Object.defineProperty(this, "adapters", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new Adapters(this)
    });
    Object.defineProperty(this, "events", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._createEvents()
    });
    Object.defineProperty(this, "_userPrivateProperties", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_dirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_dirtyPrivate", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_template", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_templates", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_internalTemplates", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_defaultThemes", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_templateDisposers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_disposers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_runSetup", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "_disposerProperties", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    if (!isReal) {
      throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
    }
    this._root = root;
    this._internalTemplates = templates;
    if (settings.id) {
      this._registerId(settings.id);
    }
  }
  /**
   * Use this method to create an instance of this class.
   *
   * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
   * @param   root      Root element
   * @param   settings  Settings
   * @param   template  Template
   * @return            Instantiated object
   */
  static new(root, settings, template) {
    const x2 = new this(root, settings, true);
    x2._template = template;
    x2._afterNew();
    return x2;
  }
  static _new(root, settings, templates = []) {
    const x2 = new this(root, settings, true, templates);
    x2._afterNew();
    return x2;
  }
  _afterNew() {
    this._checkDirty();
    let shouldApply = false;
    const template = this._template;
    if (template) {
      shouldApply = true;
      template._setObjectTemplate(this);
    }
    each(this._internalTemplates, (template2) => {
      shouldApply = true;
      template2._setObjectTemplate(this);
    });
    if (shouldApply) {
      this._applyTemplates(false);
    }
    this.states.create("default", {});
    this._setDefaults();
  }
  // This is the same as _afterNew, except it also applies the themes.
  // This should only be used for classes which don't have a parent (because they extend from Entity and not Sprite).
  _afterNewApplyThemes() {
    this._checkDirty();
    const template = this._template;
    if (template) {
      template._setObjectTemplate(this);
    }
    each(this._internalTemplates, (template2) => {
      template2._setObjectTemplate(this);
    });
    this.states.create("default", {});
    this._setDefaults();
    this._applyThemes();
  }
  _createEvents() {
    return new EventDispatcher();
  }
  /**
   * @ignore
   */
  get classNames() {
    return this.constructor.classNames;
  }
  /**
   * @ignore
   */
  get className() {
    return this.constructor.className;
  }
  _setDefaults() {
  }
  _setDefault(key, value) {
    if (!(key in this._settings)) {
      super.set(key, value);
    }
  }
  _setRawDefault(key, value) {
    if (!(key in this._settings)) {
      super.setRaw(key, value);
    }
  }
  _clearDirty() {
    keys2(this._dirty).forEach((key) => {
      this._dirty[key] = false;
    });
    keys2(this._dirtyPrivate).forEach((key) => {
      this._dirtyPrivate[key] = false;
    });
  }
  /**
   * @ignore
   */
  isDirty(key) {
    return !!this._dirty[key];
  }
  /**
   * @ignore
   */
  isPrivateDirty(key) {
    return !!this._dirtyPrivate[key];
  }
  _markDirtyKey(key) {
    this._dirty[key] = true;
    super._markDirtyKey(key);
  }
  _markDirtyPrivateKey(key) {
    this._dirtyPrivate[key] = true;
    super._markDirtyKey(key);
  }
  /**
   * Checks if element is of certain class (or inherits one).
   *
   * @param   type  Class name to check
   * @return {boolean} Is of class?
   */
  isType(type4) {
    return this.classNames.indexOf(type4) !== -1;
  }
  _pushPropertyDisposer(key, disposer) {
    let disposers = this._disposerProperties[key];
    if (disposers === void 0) {
      disposers = this._disposerProperties[key] = [];
    }
    disposers.push(disposer);
    return disposer;
  }
  _disposeProperty(key) {
    const disposers = this._disposerProperties[key];
    if (disposers !== void 0) {
      each(disposers, (disposer) => {
        disposer.dispose();
      });
      delete this._disposerProperties[key];
    }
  }
  /**
   * @todo needs description
   * @param  value  Template
   */
  set template(value) {
    const template = this._template;
    if (template !== value) {
      this._template = value;
      if (template) {
        template._removeObjectTemplate(this);
      }
      if (value) {
        value._setObjectTemplate(this);
      }
      this._applyTemplates();
    }
  }
  get template() {
    return this._template;
  }
  /**
   * @ignore
   */
  markDirty() {
    this._root._addDirtyEntity(this);
  }
  _startAnimation() {
    this._root._addAnimation(this);
  }
  _animationTime() {
    return this._root.animationTime;
  }
  _applyState(_name) {
  }
  _applyStateAnimated(_name, _duration) {
  }
  get(key, fallback) {
    const value = this.adapters.fold(key, this._settings[key]);
    if (value !== void 0) {
      return value;
    } else {
      return fallback;
    }
  }
  /**
   * @ignore
   */
  isUserSetting(key) {
    return this._userProperties[key] || false;
  }
  /**
   * Sets a setting `value` for the specified `key`, and returns the same `value`.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
   * @param   key       Setting key
   * @param   value     Setting value
   * @return            Setting value
   */
  set(key, value) {
    this._userProperties[key] = true;
    return super.set(key, value);
  }
  /**
   * @ignore
   */
  setRaw(key, value) {
    this._userProperties[key] = true;
    super.setRaw(key, value);
  }
  /**
   * Sets a setting `value` for the specified `key` only if the value for this key was not set previously using set method, and returns the same `value`.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
   * @param   key       Setting key
   * @param   value     Setting value
   * @return            Setting value
   */
  _setSoft(key, value) {
    if (!this._userProperties[key]) {
      return super.set(key, value);
    }
    return value;
  }
  /**
   * Removes a setting value for the specified `key`.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/settings/} for more info
   * @param   key       Setting key
   */
  remove(key) {
    delete this._userProperties[key];
    this._removeTemplateProperty(key);
  }
  /**
   * @ignore
   */
  setPrivate(key, value) {
    this._userPrivateProperties[key] = true;
    return super.setPrivate(key, value);
  }
  /**
   * @ignore
   */
  setPrivateRaw(key, value) {
    this._userPrivateProperties[key] = true;
    super.setPrivateRaw(key, value);
  }
  /**
   * @ignore
   */
  removePrivate(key) {
    delete this._userPrivateProperties[key];
    this._removeTemplatePrivateProperty(key);
  }
  _setTemplateProperty(template, key, value) {
    if (!this._userProperties[key]) {
      const match2 = this._findTemplateByKey(key);
      if (template === match2) {
        super.set(key, value);
      }
    }
  }
  _setTemplatePrivateProperty(template, key, value) {
    if (!this._userPrivateProperties[key]) {
      const match2 = this._findTemplateByPrivateKey(key);
      if (template === match2) {
        super.setPrivate(key, value);
      }
    }
  }
  _removeTemplateProperty(key) {
    if (!this._userProperties[key]) {
      const match2 = this._findTemplateByKey(key);
      if (match2) {
        super.set(key, match2._settings[key]);
      } else {
        super.remove(key);
      }
    }
  }
  _removeTemplatePrivateProperty(key) {
    if (!this._userPrivateProperties[key]) {
      const match2 = this._findTemplateByPrivateKey(key);
      if (match2) {
        super.setPrivate(key, match2._privateSettings[key]);
      } else {
        super.removePrivate(key);
      }
    }
  }
  _walkParents(f) {
    f(this._root._rootContainer);
    f(this);
  }
  // TODO faster version of this method which is specialized to just 1 key
  _applyStateByKey(name) {
    const other = this.states.create(name, {});
    const seen = {};
    this._eachTemplate((template) => {
      const state = template.states.lookup(name);
      if (state) {
        state._apply(other, seen);
      }
    });
    each2(other._settings, (key) => {
      if (!seen[key] && !other._userSettings[key]) {
        other.remove(key);
      }
    });
  }
  _applyTemplate(template, state) {
    this._templateDisposers.push(template._apply(this, state));
    each2(template._settings, (key, value) => {
      if (!state.settings[key] && !this._userProperties[key]) {
        state.settings[key] = true;
        super.set(key, value);
      }
    });
    each2(template._privateSettings, (key, value) => {
      if (!state.privateSettings[key] && !this._userPrivateProperties[key]) {
        state.privateSettings[key] = true;
        super.setPrivate(key, value);
      }
    });
    if (this._runSetup && template.setup) {
      this._runSetup = false;
      template.setup(this);
    }
  }
  /**
   * Calls the closure with each template and returns the first template which is true
   */
  _findStaticTemplate(f) {
    if (this._template) {
      if (f(this._template)) {
        return this._template;
      }
    }
  }
  _eachTemplate(f) {
    this._findStaticTemplate((template) => {
      f(template);
      return false;
    });
    eachReverse(this._internalTemplates, f);
    each(this._templates, f);
  }
  _applyTemplates(remove2 = true) {
    if (remove2) {
      this._disposeTemplates();
    }
    const state = {
      settings: {},
      privateSettings: {},
      states: {}
    };
    this._eachTemplate((template) => {
      this._applyTemplate(template, state);
    });
    if (remove2) {
      each2(this._settings, (key) => {
        if (!this._userProperties[key] && !state.settings[key]) {
          super.remove(key);
        }
      });
      each2(this._privateSettings, (key) => {
        if (!this._userPrivateProperties[key] && !state.privateSettings[key]) {
          super.removePrivate(key);
        }
      });
    }
  }
  _findTemplate(f) {
    const value = this._findStaticTemplate(f);
    if (value === void 0) {
      const value2 = findReverse(this._internalTemplates, f);
      if (value2 === void 0) {
        return find(this._templates, f);
      } else {
        return value2;
      }
    } else {
      return value;
    }
  }
  _findTemplateByKey(key) {
    return this._findTemplate((template) => {
      return key in template._settings;
    });
  }
  _findTemplateByPrivateKey(key) {
    return this._findTemplate((template) => {
      return key in template._privateSettings;
    });
  }
  _disposeTemplates() {
    each(this._templateDisposers, (disposer) => {
      disposer.dispose();
    });
    this._templateDisposers.length = 0;
  }
  _removeTemplates() {
    each(this._templates, (template) => {
      template._removeObjectTemplate(this);
    });
    this._templates.length = 0;
  }
  _applyThemes(force = false) {
    let isConnected = false;
    const defaults = [];
    let themes = [];
    const themeTags = /* @__PURE__ */ new Set();
    const tags = this.get("themeTagsSelf");
    if (tags) {
      each(tags, (tag) => {
        themeTags.add(tag);
      });
    }
    this._walkParents((entity) => {
      if (entity === this._root._rootContainer) {
        isConnected = true;
      }
      if (entity._defaultThemes.length > 0) {
        defaults.push(entity._defaultThemes);
      }
      const theme = entity.get("themes");
      if (theme) {
        themes.push(theme);
      }
      const tags2 = entity.get("themeTags");
      if (tags2) {
        each(tags2, (tag) => {
          themeTags.add(tag);
        });
      }
    });
    themes = defaults.concat(themes);
    this._removeTemplates();
    if (isConnected || force) {
      eachReverse(this.classNames, (name) => {
        const allRules = [];
        each(themes, (themes2) => {
          each(themes2, (theme) => {
            const rules2 = theme._lookupRules(name);
            if (rules2) {
              eachReverse(rules2, (rule) => {
                const matches = rule.tags.every((tag) => {
                  return themeTags.has(tag);
                });
                if (matches) {
                  const result = getFirstSortedIndex(allRules, (x2) => {
                    const order = compare(rule.tags.length, x2.tags.length);
                    if (order === 0) {
                      return compareArray(rule.tags, x2.tags, compare);
                    } else {
                      return order;
                    }
                  });
                  allRules.splice(result.index, 0, rule);
                }
              });
            }
          });
        });
        each(allRules, (rule) => {
          this._templates.push(rule.template);
          rule.template._setObjectTemplate(this);
        });
      });
    }
    this._applyTemplates();
    if (isConnected || force) {
      this._runSetup = false;
    }
    return isConnected || force;
  }
  _changed() {
  }
  _beforeChanged() {
    if (this.isDirty("id")) {
      const id = this.get("id");
      if (id) {
        this._registerId(id);
      }
      const prevId = this._prevSettings.id;
      if (prevId) {
        delete registry.entitiesById[prevId];
      }
    }
  }
  _registerId(id) {
    if (registry.entitiesById[id] && registry.entitiesById[id] !== this) {
      throw new Error('An entity with id "' + id + '" already exists.');
    }
    registry.entitiesById[id] = this;
  }
  _afterChanged() {
  }
  /**
   * @ignore
   */
  addDisposer(disposer) {
    this._disposers.push(disposer);
    return disposer;
  }
  _dispose() {
    super._dispose();
    const template = this._template;
    if (template) {
      template._removeObjectTemplate(this);
    }
    each(this._internalTemplates, (template2) => {
      template2._removeObjectTemplate(this);
    });
    this._removeTemplates();
    this._disposeTemplates();
    this.events.dispose();
    this._disposers.forEach((x2) => {
      x2.dispose();
    });
    each2(this._disposerProperties, (_, disposers) => {
      each(disposers, (disposer) => {
        disposer.dispose();
      });
    });
    const id = this.get("id");
    if (id) {
      delete registry.entitiesById[id];
    }
  }
  /**
   * Creates and returns a "disposable" timeout.
   *
   * @param   fn     Callback
   * @param   delay  Delay in milliseconds
   * @return         Timeout disposer
   */
  setTimeout(fn, delay) {
    const id = setTimeout(() => {
      this.removeDispose(disposer);
      fn();
    }, delay);
    const disposer = new Disposer(() => {
      clearTimeout(id);
    });
    this._disposers.push(disposer);
    return disposer;
  }
  /**
   * @ignore
   */
  removeDispose(target) {
    if (!this.isDisposed()) {
      let index2 = indexOf(this._disposers, target);
      if (index2 > -1) {
        this._disposers.splice(index2, 1);
      }
    }
    target.dispose();
  }
  /**
   * @ignore
   */
  hasTag(tag) {
    return indexOf(this.get("themeTags", []), tag) !== -1;
  }
  /**
   * @ignore
   */
  addTag(tag) {
    if (!this.hasTag(tag)) {
      const tags = this.get("themeTags", []);
      tags.push(tag);
      this.set("themeTags", tags);
    }
  }
  /**
   * @ignore
   */
  removeTag(tag) {
    if (this.hasTag(tag)) {
      const tags = this.get("themeTags", []);
      remove(tags, tag);
      this.set("themeTags", tags);
    }
  }
  _t(text, locale6, ...rest) {
    return this._root.language.translate(text, locale6, ...rest);
  }
  /**
   * An instance of [[Root]] object.
   *
   * @readonly
   * @since 5.0.6
   * @return Root object
   */
  get root() {
    return this._root;
  }
};
Object.defineProperty(Entity2, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Entity"
});
Object.defineProperty(Entity2, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: ["Entity"]
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Template.js
var TemplateState = class {
  constructor(name, template, settings) {
    Object.defineProperty(this, "_settings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_template", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._name = name;
    this._template = template;
    this._settings = settings;
  }
  get(key, fallback) {
    const value = this._settings[key];
    if (value !== void 0) {
      return value;
    } else {
      return fallback;
    }
  }
  set(key, value) {
    this._settings[key] = value;
    this._template._stateChanged(this._name);
  }
  remove(key) {
    delete this._settings[key];
    this._template._stateChanged(this._name);
  }
  setAll(settings) {
    keys2(settings).forEach((key) => {
      this._settings[key] = settings[key];
    });
    this._template._stateChanged(this._name);
  }
  _apply(other, seen) {
    each2(this._settings, (key, value) => {
      if (!seen[key] && !other._userSettings[key]) {
        seen[key] = true;
        other.setRaw(key, value);
      }
    });
  }
};
var TemplateStates = class {
  constructor(template) {
    Object.defineProperty(this, "_template", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_states", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    this._template = template;
  }
  lookup(name) {
    return this._states[name];
  }
  create(name, settings) {
    const state = this._states[name];
    if (state) {
      state.setAll(settings);
      return state;
    } else {
      const state2 = new TemplateState(name, this._template, settings);
      this._states[name] = state2;
      this._template._stateChanged(name);
      return state2;
    }
  }
  remove(name) {
    delete this._states[name];
    this._template._stateChanged(name);
  }
  _apply(entity, state) {
    each2(this._states, (key, value) => {
      let seen = state.states[key];
      if (seen == null) {
        seen = state.states[key] = {};
      }
      const other = entity.states.create(key, {});
      value._apply(other, seen);
    });
  }
};
var TemplateAdapters = class {
  constructor() {
    Object.defineProperty(this, "_callbacks", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
  }
  add(key, callback) {
    let callbacks = this._callbacks[key];
    if (callbacks === void 0) {
      callbacks = this._callbacks[key] = [];
    }
    callbacks.push(callback);
    return new Disposer(() => {
      removeFirst(callbacks, callback);
      if (callbacks.length === 0) {
        delete this._callbacks[key];
      }
    });
  }
  remove(key) {
    const callbacks = this._callbacks[key];
    if (callbacks !== void 0) {
      delete this._callbacks[key];
    }
  }
  _apply(entity) {
    const disposers = [];
    each2(this._callbacks, (key, callbacks) => {
      each(callbacks, (callback) => {
        disposers.push(entity.adapters.add(key, callback));
      });
    });
    return new MultiDisposer(disposers);
  }
};
var Template = class _Template {
  constructor(settings, isReal) {
    Object.defineProperty(this, "_settings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_privateSettings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_settingEvents", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_privateSettingEvents", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_entities", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "states", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new TemplateStates(this)
    });
    Object.defineProperty(this, "adapters", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new TemplateAdapters()
    });
    Object.defineProperty(this, "events", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new EventDispatcher()
    });
    Object.defineProperty(this, "setup", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    if (!isReal) {
      throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
    }
    this._settings = settings;
  }
  /**
   * Use this method to create an instance of this class.
   *
   * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
   * @param   root      Root element
   * @param   settings  Settings
   * @param   template  Template
   * @return            Instantiated object
   */
  static new(settings) {
    return new _Template(settings, true);
  }
  /**
   * Array of all entities using this template.
   */
  get entities() {
    return this._entities;
  }
  get(key, fallback) {
    const value = this._settings[key];
    if (value !== void 0) {
      return value;
    } else {
      return fallback;
    }
  }
  setRaw(key, value) {
    this._settings[key] = value;
  }
  set(key, value) {
    if (this._settings[key] !== value) {
      this.setRaw(key, value);
      this._entities.forEach((entity) => {
        entity._setTemplateProperty(this, key, value);
      });
    }
  }
  remove(key) {
    if (key in this._settings) {
      delete this._settings[key];
      this._entities.forEach((entity) => {
        entity._removeTemplateProperty(key);
      });
    }
  }
  removeAll() {
    each2(this._settings, (key, _value) => {
      this.remove(key);
    });
  }
  getPrivate(key, fallback) {
    const value = this._privateSettings[key];
    if (value !== void 0) {
      return value;
    } else {
      return fallback;
    }
  }
  setPrivateRaw(key, value) {
    this._privateSettings[key] = value;
    return value;
  }
  setPrivate(key, value) {
    if (this._privateSettings[key] !== value) {
      this.setPrivateRaw(key, value);
      this._entities.forEach((entity) => {
        entity._setTemplatePrivateProperty(this, key, value);
      });
    }
    return value;
  }
  removePrivate(key) {
    if (key in this._privateSettings) {
      delete this._privateSettings[key];
      this._entities.forEach((entity) => {
        entity._removeTemplatePrivateProperty(key);
      });
    }
  }
  setAll(value) {
    each2(value, (key, value2) => {
      this.set(key, value2);
    });
  }
  // TODO code duplication with Properties
  on(key, callback) {
    let events = this._settingEvents[key];
    if (events === void 0) {
      events = this._settingEvents[key] = [];
    }
    events.push(callback);
    return new Disposer(() => {
      removeFirst(events, callback);
      if (events.length === 0) {
        delete this._settingEvents[key];
      }
    });
  }
  // TODO code duplication with Properties
  onPrivate(key, callback) {
    let events = this._privateSettingEvents[key];
    if (events === void 0) {
      events = this._privateSettingEvents[key] = [];
    }
    events.push(callback);
    return new Disposer(() => {
      removeFirst(events, callback);
      if (events.length === 0) {
        delete this._privateSettingEvents[key];
      }
    });
  }
  _apply(entity, state) {
    const disposers = [];
    each2(this._settingEvents, (key, events) => {
      each(events, (event) => {
        disposers.push(entity.on(key, event));
      });
    });
    each2(this._privateSettingEvents, (key, events) => {
      each(events, (event) => {
        disposers.push(entity.onPrivate(key, event));
      });
    });
    this.states._apply(entity, state);
    disposers.push(this.adapters._apply(entity));
    disposers.push(entity.events.copyFrom(this.events));
    return new MultiDisposer(disposers);
  }
  _setObjectTemplate(entity) {
    this._entities.push(entity);
  }
  _removeObjectTemplate(entity) {
    remove(this._entities, entity);
  }
  _stateChanged(name) {
    this._entities.forEach((entity) => {
      entity._applyStateByKey(name);
    });
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Sprite.js
var SpriteEventDispatcher = class _SpriteEventDispatcher extends EventDispatcher {
  constructor(sprite) {
    super();
    Object.defineProperty(this, "_sprite", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_rendererDisposers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_dispatchParents", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    this._sprite = sprite;
  }
  _makePointerEvent(key, event) {
    return {
      type: key,
      originalEvent: event.event,
      point: event.point,
      simulated: event.simulated,
      native: event.native,
      target: this._sprite
    };
  }
  _onRenderer(key, dispatch) {
    this._sprite.set("interactive", true);
    this._sprite._display.interactive = true;
    let events = this._rendererDisposers[key];
    if (events === void 0) {
      const disposer = this._sprite._display.on(key, (e) => {
        dispatch.call(this, e);
      });
      events = this._rendererDisposers[key] = new CounterDisposer(() => {
        delete this._rendererDisposers[key];
        disposer.dispose();
      });
    }
    return events.increment();
  }
  _on(once, type4, callback, context, shouldClone, dispatch) {
    const info = super._on(once, type4, callback, context, shouldClone, dispatch);
    const rendererEvent = _SpriteEventDispatcher.RENDERER_EVENTS[type4];
    if (rendererEvent !== void 0) {
      info.disposer = new MultiDisposer([
        info.disposer,
        this._onRenderer(type4, rendererEvent)
      ]);
    }
    return info;
  }
  /**
   * Will stop any bubbling up of the event to element's parents.
   *
   * Should be called in an event handler, e.g.:
   *
   * ```TypeScript
   * element.events.on("pointerdown", function(ev) {
   *   // Do something here and prevent from "pointerdown" bubbling up
   *   // ...
   *   ev.target.events.stopParentDispatch();
   * });
   * ```
   * ```JavaScript
   * element.events.on("pointerdown", function(ev) {
   *   // Do something here and prevent from "pointerdown" bubbling up
   *   // ...
   *   ev.target.events.stopParentDispatch();
   * });
   * ```
   */
  stopParentDispatch() {
    this._dispatchParents = false;
  }
  /**
   * @ignore
   */
  dispatchParents(type4, event) {
    const old = this._dispatchParents;
    this._dispatchParents = true;
    try {
      this.dispatch(type4, event);
      if (this._dispatchParents && this._sprite.parent) {
        this._sprite.parent.events.dispatchParents(type4, event);
      }
    } finally {
      this._dispatchParents = old;
    }
  }
};
Object.defineProperty(SpriteEventDispatcher, "RENDERER_EVENTS", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: {
    "click": function(event) {
      if (this.isEnabled("click") && !this._sprite.isDragging() && this._sprite._hasDown() && !this._sprite._hasMoved(this._makePointerEvent("click", event))) {
        this.dispatch("click", this._makePointerEvent("click", event));
      }
    },
    "rightclick": function(event) {
      if (this.isEnabled("rightclick")) {
        this.dispatch("rightclick", this._makePointerEvent("rightclick", event));
      }
    },
    "middleclick": function(event) {
      if (this.isEnabled("middleclick")) {
        this.dispatch("middleclick", this._makePointerEvent("middleclick", event));
      }
    },
    "dblclick": function(event) {
      this.dispatchParents("dblclick", this._makePointerEvent("dblclick", event));
    },
    "pointerover": function(event) {
      const sprite = this._sprite;
      let dispatch = true;
      if (sprite.getPrivate("trustBounds")) {
        sprite._getBounds();
        const bounds = sprite.globalBounds();
        if (!inBounds(event.point, bounds)) {
          dispatch = false;
          sprite._root._renderer.removeHovering(sprite._display);
        }
      }
      if (dispatch && this.isEnabled("pointerover")) {
        this.dispatch("pointerover", this._makePointerEvent("pointerover", event));
      }
    },
    "pointerout": function(event) {
      if (this.isEnabled("pointerout")) {
        this.dispatch("pointerout", this._makePointerEvent("pointerout", event));
      }
    },
    "pointerdown": function(event) {
      this.dispatchParents("pointerdown", this._makePointerEvent("pointerdown", event));
    },
    "pointerup": function(event) {
      if (this.isEnabled("pointerup")) {
        this.dispatch("pointerup", this._makePointerEvent("pointerup", event));
      }
    },
    "globalpointerup": function(event) {
      if (this.isEnabled("globalpointerup")) {
        this.dispatch("globalpointerup", this._makePointerEvent("globalpointerup", event));
      }
    },
    "globalpointermove": function(event) {
      if (this.isEnabled("globalpointermove")) {
        this.dispatch("globalpointermove", this._makePointerEvent("globalpointermove", event));
      }
    },
    "wheel": function(event) {
      this.dispatchParents("wheel", {
        type: "wheel",
        target: this._sprite,
        originalEvent: event.event,
        point: event.point
      });
    }
  }
});
var Sprite = class extends Entity2 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_adjustedLocalBounds", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: { left: 0, right: 0, top: 0, bottom: 0 }
    });
    Object.defineProperty(this, "_localBounds", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: { left: 0, right: 0, top: 0, bottom: 0 }
    });
    Object.defineProperty(this, "_parent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_dataItem", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_templateField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_sizeDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_isDragging", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_dragEvent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_dragPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_isHidden", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_isShowing", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_isHiding", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_isDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_downPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_downPoints", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_toggleDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_dragDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltipDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_hoverDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_focusDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltipMoveDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltipPointerDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_statesHandled", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
  }
  _afterNew() {
    this.setPrivateRaw("visible", true);
    super._afterNew();
  }
  _markDirtyKey(key) {
    super._markDirtyKey(key);
    if (key == "x" || key == "y" || key == "dx" || key == "dy") {
      this.markDirtyBounds();
      this._addPercentagePositionChildren();
      this.markDirtyPosition();
    }
  }
  _markDirtyPrivateKey(key) {
    super._markDirtyPrivateKey(key);
    if (key == "x" || key == "y") {
      this.markDirtyPosition();
    }
  }
  _removeTemplateField() {
    if (this._templateField) {
      this._templateField._removeObjectTemplate(this);
    }
  }
  _createEvents() {
    return new SpriteEventDispatcher(this);
  }
  _processTemplateField() {
    let template;
    const field = this.get("templateField");
    if (field) {
      const dataItem = this.dataItem;
      if (dataItem) {
        const context = dataItem.dataContext;
        if (context) {
          template = context[field];
          if (!(template instanceof Template) && template) {
            template = Template.new(template);
          }
        }
      }
    }
    if (this._templateField !== template) {
      this._removeTemplateField();
      this._templateField = template;
      if (template) {
        template._setObjectTemplate(this);
      }
      this._applyTemplates();
    }
  }
  // TODO change this to run before the element is added to the parent, so that way
  //      it doesn't need to apply the themes twice
  _setDataItem(dataItem) {
    const oldDataItem = this._dataItem;
    this._dataItem = dataItem;
    this._processTemplateField();
    const eventType = "dataitemchanged";
    if (dataItem != oldDataItem) {
      if (this.events.isEnabled(eventType)) {
        this.events.dispatch(eventType, {
          type: eventType,
          target: this,
          oldDataItem,
          newDataItem: dataItem
        });
      }
    }
  }
  /**
   * A [[DataItem]] used for this element.
   *
   * NOTE: data item is being assigned automatically in most cases where it
   * matters. Use this accessor to set data item only if you know what you're
   * doing.
   *
   * @param  value  Data item
   */
  set dataItem(value) {
    this._setDataItem(value);
  }
  /**
   * @return DataItem
   */
  get dataItem() {
    if (this._dataItem) {
      return this._dataItem;
    } else {
      let parent = this._parent;
      while (parent) {
        if (parent._dataItem) {
          return parent._dataItem;
        } else {
          parent = parent._parent;
        }
      }
    }
  }
  _addPercentageSizeChildren() {
    let parent = this.parent;
    if (parent) {
      if (this.get("width") instanceof Percent || this.get("height") instanceof Percent) {
        pushOne(parent._percentageSizeChildren, this);
      } else {
        removeFirst(parent._percentageSizeChildren, this);
      }
    }
  }
  _addPercentagePositionChildren() {
    let parent = this.parent;
    if (parent) {
      if (this.get("x") instanceof Percent || this.get("y") instanceof Percent) {
        pushOne(parent._percentagePositionChildren, this);
      } else {
        removeFirst(parent._percentagePositionChildren, this);
      }
    }
  }
  /**
   * @ignore
   */
  markDirtyPosition() {
    this._root._addDirtyPosition(this);
  }
  updatePivotPoint() {
    const bounds = this._localBounds;
    if (bounds) {
      const centerX = this.get("centerX");
      if (centerX != null) {
        this._display.pivot.x = bounds.left + relativeToValue(centerX, bounds.right - bounds.left);
      }
      const centerY = this.get("centerY");
      if (centerY != null) {
        this._display.pivot.y = bounds.top + relativeToValue(centerY, bounds.bottom - bounds.top);
      }
    }
  }
  _beforeChanged() {
    super._beforeChanged();
    this._handleStates();
    if (this.isDirty("tooltip")) {
      const previous = this._prevSettings.tooltip;
      if (previous) {
        previous.dispose();
      }
    }
    if (this.isDirty("layer") || this.isDirty("layerMargin")) {
      this._display.setLayer(this.get("layer"), this.get("layerMargin"));
      this.markDirtyLayer();
    }
    if (this.isDirty("tooltipPosition")) {
      const tooltipMoveDp = this._tooltipMoveDp;
      if (tooltipMoveDp) {
        tooltipMoveDp.dispose();
        this._tooltipMoveDp = void 0;
      }
      const tooltipPointerDp = this._tooltipPointerDp;
      if (tooltipPointerDp) {
        tooltipPointerDp.dispose();
        this._tooltipPointerDp = void 0;
      }
      if (this.get("tooltipPosition") == "pointer") {
        if (this.isHover()) {
          this._tooltipMoveDp = this.events.on("globalpointermove", (e) => {
            this.showTooltip(e.point);
          });
        }
        this._tooltipPointerDp = new MultiDisposer([
          this.events.on("pointerover", () => {
            this._tooltipMoveDp = this.events.on("globalpointermove", (e) => {
              this.showTooltip(e.point);
            });
          }),
          this.events.on("pointerout", () => {
            const tooltipMoveDp2 = this._tooltipMoveDp;
            if (tooltipMoveDp2) {
              tooltipMoveDp2.dispose();
              this._tooltipMoveDp = void 0;
            }
          })
        ]);
      }
    }
  }
  _handleStates() {
    if (!this._statesHandled) {
      if (this.isDirty("active")) {
        if (this.get("active")) {
          this.states.applyAnimate("active");
          this.set("ariaChecked", true);
        } else {
          if (!this.isHidden()) {
            this.states.applyAnimate("default");
          }
          this.set("ariaChecked", false);
        }
        this.markDirtyAccessibility();
      }
      if (this.isDirty("disabled")) {
        if (this.get("disabled")) {
          this.states.applyAnimate("disabled");
          this.set("ariaChecked", false);
        } else {
          if (!this.isHidden()) {
            this.states.applyAnimate("default");
          }
          this.set("ariaChecked", true);
        }
        this.markDirtyAccessibility();
      }
      this._statesHandled = true;
    }
  }
  _changed() {
    super._changed();
    const display = this._display;
    const events = this.events;
    if (this.isDirty("draggable")) {
      const draggable = this.get("draggable");
      if (draggable) {
        this.set("interactive", true);
        this._dragDp = new MultiDisposer([
          events.on("pointerdown", (ev) => {
            this.dragStart(ev);
          }),
          events.on("globalpointermove", (ev) => {
            this.dragMove(ev);
          }),
          events.on("globalpointerup", (ev) => {
            this.dragStop(ev);
          })
        ]);
      } else {
        if (this._dragDp) {
          this._dragDp.dispose();
          this._dragDp = void 0;
        }
      }
      display.cancelTouch = draggable ? true : false;
    }
    if (this.isDirty("tooltipText") || this.isDirty("tooltipHTML") || this.isDirty("showTooltipOn")) {
      const tooltipText = this.get("tooltipText");
      const tooltipHTML = this.get("tooltipHTML");
      const showTooltipOn = this.get("showTooltipOn", "hover");
      if (this._tooltipDp) {
        this._tooltipDp.dispose();
        this._tooltipDp = void 0;
      }
      if (tooltipText || tooltipHTML) {
        if (showTooltipOn == "click") {
          this._tooltipDp = new MultiDisposer([
            events.on("click", () => {
              this.setTimeout(() => this.showTooltip(), 10);
            }),
            addEventListener(document, "click", (_ev) => {
              this.hideTooltip();
            })
          ]);
          this._disposers.push(this._tooltipDp);
        } else if (showTooltipOn == "always") {
        } else {
          this._tooltipDp = new MultiDisposer([
            events.on("pointerover", () => {
              this.showTooltip();
            }),
            events.on("pointerout", () => {
              this.hideTooltip();
            })
          ]);
          this._disposers.push(this._tooltipDp);
        }
      }
    }
    if (this.isDirty("toggleKey")) {
      let toggleKey = this.get("toggleKey");
      if (toggleKey && toggleKey != "none") {
        this._toggleDp = events.on("click", () => {
          if (!this._isDragging) {
            this.set(toggleKey, !this.get(toggleKey));
          }
        });
      } else {
        if (this._toggleDp) {
          this._toggleDp.dispose();
          this._toggleDp = void 0;
        }
      }
    }
    if (this.isDirty("opacity")) {
      display.alpha = Math.max(0, this.get("opacity", 1));
      if (this.get("focusable")) {
        this.markDirtyAccessibility();
      }
    }
    if (this.isDirty("rotation")) {
      this.markDirtyBounds();
      display.angle = this.get("rotation", 0);
    }
    if (this.isDirty("scale")) {
      this.markDirtyBounds();
      display.scale = this.get("scale", 0);
    }
    if (this.isDirty("centerX") || this.isDirty("centerY")) {
      this.markDirtyBounds();
      this.updatePivotPoint();
    }
    if (this.isDirty("visible") || this.isPrivateDirty("visible") || this.isDirty("forceHidden")) {
      if (!this.get("visible") || !this.getPrivate("visible") || this.get("forceHidden")) {
        display.visible = false;
        this.hideTooltip();
      } else {
        display.visible = true;
      }
      this.markDirtyBounds();
      if (this.get("focusable")) {
        this.markDirtyAccessibility();
      }
    }
    if (this.isDirty("width") || this.isDirty("height")) {
      this.markDirtyBounds();
      this._addPercentageSizeChildren();
      const parent = this.parent;
      if (parent) {
        if (this.isDirty("width") && this.get("width") instanceof Percent || this.isDirty("height") && this.get("height") instanceof Percent) {
          parent.markDirty();
          parent._prevWidth = 0;
        }
      }
      this._sizeDirty = true;
    }
    if (this.isDirty("maxWidth") || this.isDirty("maxHeight") || this.isPrivateDirty("width") || this.isPrivateDirty("height") || this.isDirty("minWidth") || this.isDirty("minHeight") || this.isPrivateDirty("maxWidth") || this.isPrivateDirty("maxHeight") || this.isPrivateDirty("minWidth") || this.isPrivateDirty("minHeight")) {
      this.markDirtyBounds();
      this._sizeDirty = true;
    }
    if (this._sizeDirty) {
      this._updateSize();
    }
    if (this.isDirty("wheelable")) {
      const wheelable = this.get("wheelable");
      if (wheelable) {
        this.set("interactive", true);
      }
      display.wheelable = wheelable ? true : false;
    }
    if (this.isDirty("tabindexOrder") || this.isDirty("focusableGroup")) {
      if (this.get("focusable")) {
        this._root._registerTabindexOrder(this);
      } else {
        this._root._unregisterTabindexOrder(this);
      }
    }
    if (this.isDirty("filter")) {
      display.filter = this.get("filter");
    }
    let filter = this.get("filter", "");
    if (this.isDirty("blur")) {
      const blur2 = this.get("blur", 0);
      if (blur2 != 0) {
        filter += " blur(" + blur2 + "px)";
      }
    }
    if (this.isDirty("saturate")) {
      const saturate2 = this.get("saturate", 1);
      if (saturate2 != 1) {
        filter += " saturate(" + saturate2 + ")";
      }
    }
    if (this.isDirty("brightness")) {
      const brightness = this.get("brightness", 1);
      if (brightness != 1) {
        filter += " brightness(" + brightness + ")";
      }
    }
    if (this.isDirty("contrast")) {
      const contrast = this.get("contrast", 1);
      if (contrast != 1) {
        filter += " contrast(" + contrast + ")";
      }
    }
    if (this.isDirty("sepia")) {
      const sepia = this.get("sepia", 0);
      if (sepia != 0) {
        filter += " sepia(" + sepia + ")";
      }
    }
    if (this.isDirty("hue")) {
      const hue = this.get("hue", 0);
      if (hue != 0) {
        filter += " hue-rotate(" + hue + "deg)";
      }
    }
    if (this.isDirty("invert")) {
      const invert = this.get("invert", 0);
      if (invert != 0) {
        filter += " invert(" + invert + ")";
      }
    }
    if (filter) {
      display.filter = filter;
    }
    if (this.isDirty("cursorOverStyle")) {
      display.cursorOverStyle = this.get("cursorOverStyle");
    }
    if (this.isDirty("hoverOnFocus")) {
      if (this.get("hoverOnFocus")) {
        this._focusDp = new MultiDisposer([
          events.on("focus", () => {
            this.showTooltip();
          }),
          events.on("blur", () => {
            this.hideTooltip();
          })
        ]);
      } else {
        if (this._focusDp) {
          this._focusDp.dispose();
          this._focusDp = void 0;
        }
      }
    }
    if (this.isDirty("focusable")) {
      if (this.get("focusable")) {
        this._root._registerTabindexOrder(this);
      } else {
        this._root._unregisterTabindexOrder(this);
      }
      this.markDirtyAccessibility();
    }
    if (this.isPrivateDirty("focusable")) {
      this.markDirtyAccessibility();
    }
    if (this.isDirty("role") || this.isDirty("ariaLive") || this.isDirty("ariaChecked") || this.isDirty("ariaHidden") || this.isDirty("ariaOrientation") || this.isDirty("ariaValueNow") || this.isDirty("ariaValueMin") || this.isDirty("ariaValueMax") || this.isDirty("ariaValueText") || this.isDirty("ariaLabel") || this.isDirty("ariaControls")) {
      this.markDirtyAccessibility();
    }
    if (this.isDirty("exportable")) {
      display.exportable = this.get("exportable");
    }
    if (this.isDirty("interactive")) {
      const events2 = this.events;
      if (this.get("interactive")) {
        this._hoverDp = new MultiDisposer([
          events2.on("click", (ev) => {
            if (isTouchEvent(ev.originalEvent)) {
              if (!this.getPrivate("touchHovering")) {
                this.setTimeout(() => {
                  this._handleOver();
                  if (this.get("tooltipText") || this.get("tooltipHTML")) {
                    this.showTooltip();
                  }
                  this.setPrivateRaw("touchHovering", true);
                  this.events.dispatch("pointerover", {
                    type: "pointerover",
                    target: ev.target,
                    originalEvent: ev.originalEvent,
                    point: ev.point,
                    simulated: ev.simulated
                  });
                }, 10);
              }
            }
          }),
          events2.on("globalpointerup", (ev) => {
            if (isTouchEvent(ev.originalEvent)) {
              if (this.getPrivate("touchHovering")) {
                this._handleOut();
                if (this.get("tooltipText") || this.get("tooltipHTML")) {
                  this.hideTooltip();
                }
                this.setPrivateRaw("touchHovering", false);
                this.events.dispatch("pointerout", {
                  type: "pointerout",
                  target: ev.target,
                  originalEvent: ev.originalEvent,
                  point: ev.point,
                  simulated: ev.simulated
                });
              }
            }
            if (this._isDown) {
              this._handleUp(ev);
            }
          }),
          events2.on("pointerover", () => {
            this._handleOver();
          }),
          events2.on("pointerout", () => {
            this._handleOut();
          }),
          events2.on("pointerdown", (e) => {
            this._handleDown(e);
          })
        ]);
      } else {
        this._display.interactive = false;
        if (this._hoverDp) {
          this._hoverDp.dispose();
          this._hoverDp = void 0;
        }
      }
    }
    if (this.isDirty("forceInactive")) {
      this._display.inactive = this.get("forceInactive", null);
    }
    if (this.get("showTooltipOn") == "always" && this._display.visible) {
      this.showTooltip();
    }
  }
  /**
   * @ignore
   * @todo should this be user-accessible?
   */
  dragStart(e) {
    this._dragEvent = e;
    this.events.stopParentDispatch();
  }
  /**
   * @ignore
   * @todo should this be user-accessible?
   */
  dragStop(e) {
    this._dragEvent = void 0;
    this._dragPoint = void 0;
    this.events.stopParentDispatch();
    if (this._isDragging) {
      this._isDragging = false;
      const type4 = "dragstop";
      if (this.events.isEnabled(type4)) {
        this.events.dispatch(type4, {
          type: type4,
          target: this,
          originalEvent: e.originalEvent,
          point: e.point,
          simulated: e.simulated
        });
      }
    }
  }
  _handleOver() {
    if (!this.isHidden()) {
      if (this.get("active") && this.states.lookup("hoverActive")) {
        this.states.applyAnimate("hoverActive");
      } else if (this.get("disabled") && this.states.lookup("hoverDisabled")) {
        this.states.applyAnimate("hoverDisabled");
      } else {
        this.states.applyAnimate("hover");
      }
      if (this.get("draggable") && this._isDown && this.states.lookup("down")) {
        this.states.applyAnimate("down");
      }
    }
  }
  _handleOut() {
    if (!this.isHidden()) {
      if (this.get("active") && this.states.lookup("active")) {
        this.states.applyAnimate("active");
      } else if (this.get("disabled") && this.states.lookup("disabled")) {
        this.states.applyAnimate("disabled");
      } else {
        if (this.states.lookup("hover") || this.states.lookup("hoverActive")) {
          this.states.applyAnimate("default");
        }
      }
      if (this.get("draggable") && this._isDown && this.states.lookup("down")) {
        this.states.applyAnimate("down");
      }
    }
  }
  _handleUp(e) {
    if (!this.isHidden()) {
      if (this.get("active") && this.states.lookup("active")) {
        this.states.applyAnimate("active");
      } else if (this.get("disabled") && this.states.lookup("disabled")) {
        this.states.applyAnimate("disabled");
      } else if (this.states.lookup("down")) {
        if (this.isHover()) {
          this.states.applyAnimate("hover");
        } else {
          this.states.applyAnimate("default");
        }
      }
      this._downPoint = void 0;
      const pointerId = getPointerId(e.originalEvent);
      delete this._downPoints[pointerId];
      if (keys2(this._downPoints).length == 0) {
        this._isDown = false;
      }
    }
  }
  _hasMoved(e) {
    const pointerId = getPointerId(e.originalEvent);
    const downPoint = this._downPoints[pointerId];
    if (downPoint) {
      const x2 = Math.abs(downPoint.x - e.point.x);
      const y2 = Math.abs(downPoint.y - e.point.y);
      return x2 > 5 || y2 > 5;
    }
    return false;
  }
  _hasDown() {
    return keys2(this._downPoints).length > 0;
  }
  _handleDown(e) {
    const parent = this.parent;
    if (parent && !this.get("draggable")) {
      parent._handleDown(e);
    }
    if (this.get("interactive") && !this.isHidden()) {
      if (this.states.lookup("down")) {
        this.states.applyAnimate("down");
      }
      this._downPoint = {
        x: e.point.x,
        y: e.point.y
      };
      this._isDown = true;
      const pointerId = getPointerId(e.originalEvent);
      this._downPoints[pointerId] = {
        x: e.point.x,
        y: e.point.y
      };
    }
  }
  /**
   * @ignore
   * @todo should this be user-accessible?
   */
  dragMove(e) {
    let dragEvent = this._dragEvent;
    if (dragEvent) {
      if (dragEvent.simulated && !e.simulated) {
        return true;
      }
      let angle = 0;
      let parent = this.parent;
      while (parent != null) {
        angle += parent.get("rotation", 0);
        parent = parent.parent;
      }
      let x2 = e.point.x - dragEvent.point.x;
      let y2 = e.point.y - dragEvent.point.y;
      const events = this.events;
      if (dragEvent.simulated && !this._isDragging) {
        this._isDragging = true;
        this._dragEvent = e;
        this._dragPoint = {
          x: this.x(),
          y: this.y()
        };
        const type4 = "dragstart";
        if (events.isEnabled(type4)) {
          events.dispatch(type4, {
            type: type4,
            target: this,
            originalEvent: e.originalEvent,
            point: e.point,
            simulated: e.simulated
          });
        }
      }
      if (this._isDragging) {
        let dragPoint = this._dragPoint;
        this.set("x", dragPoint.x + x2 * cos(angle) + y2 * sin(angle));
        this.set("y", dragPoint.y + y2 * cos(angle) - x2 * sin(angle));
        const type4 = "dragged";
        if (events.isEnabled(type4)) {
          events.dispatch(type4, {
            type: type4,
            target: this,
            originalEvent: e.originalEvent,
            point: e.point,
            simulated: e.simulated
          });
        }
      } else {
        if (Math.hypot(x2, y2) > 5) {
          this._isDragging = true;
          this._dragEvent = e;
          this._dragPoint = {
            x: this.x(),
            y: this.y()
          };
          const type4 = "dragstart";
          if (events.isEnabled(type4)) {
            events.dispatch(type4, {
              type: type4,
              target: this,
              originalEvent: e.originalEvent,
              point: e.point,
              simulated: e.simulated
            });
          }
        }
      }
    }
  }
  _updateSize() {
  }
  _getBounds() {
    this._localBounds = this._display.getLocalBounds();
  }
  /**
   * Returns depth (how deep in the hierachy of the content tree) of this
   * element.
   *
   * @return Depth
   */
  depth() {
    let self2 = this.parent;
    let depth = 0;
    while (true) {
      if (self2) {
        ++depth;
        self2 = self2.parent;
      } else {
        return depth;
      }
    }
  }
  /**
   * @ignore
   */
  markDirtySize() {
    this._sizeDirty = true;
    this.markDirty();
  }
  /**
   * @ignore
   */
  markDirtyBounds() {
    const display = this._display;
    if (this.get("isMeasured")) {
      this._root._addDirtyBounds(this);
      display.isMeasured = true;
      display.invalidateBounds();
      const parent = this.parent;
      if (parent && this.get("position") != "absolute") {
        if (parent.get("width") == null || parent.get("height") == null || parent.get("layout")) {
          parent.markDirtyBounds();
        }
      }
      if (this.get("focusable") && this.isFocus()) {
        this.markDirtyAccessibility();
      }
    }
  }
  /**
   * @ignore
   */
  markDirtyAccessibility() {
    this._root._invalidateAccessibility(this);
  }
  /**
   * @ignore
   */
  markDirtyLayer() {
    this._display.markDirtyLayer(true);
  }
  /**
   * @ignore
   */
  markDirty() {
    super.markDirty();
    this.markDirtyLayer();
  }
  _updateBounds() {
    const oldBounds = this._adjustedLocalBounds;
    let newBounds;
    if (!this.get("visible") || !this.getPrivate("visible") || this.get("forceHidden")) {
      newBounds = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      };
      this._localBounds = newBounds;
      this._adjustedLocalBounds = newBounds;
    } else {
      this._getBounds();
      this._fixMinBounds(this._localBounds);
      this.updatePivotPoint();
      this._adjustedLocalBounds = this._display.getAdjustedBounds(this._localBounds);
      newBounds = this._adjustedLocalBounds;
    }
    if (!oldBounds || (oldBounds.left !== newBounds.left || oldBounds.top !== newBounds.top || oldBounds.right !== newBounds.right || oldBounds.bottom !== newBounds.bottom)) {
      const eventType = "boundschanged";
      if (this.events.isEnabled(eventType)) {
        this.events.dispatch(eventType, { type: eventType, target: this });
      }
      if (this.parent) {
        this.parent.markDirty();
        this.parent.markDirtyBounds();
      }
    }
  }
  _fixMinBounds(bounds) {
    let minWidth = this.get("minWidth", this.getPrivate("minWidth"));
    let minHeight = this.get("minHeight", this.getPrivate("minHeight"));
    if (isNumber(minWidth)) {
      if (bounds.right - bounds.left < minWidth) {
        bounds.right = bounds.left + minWidth;
      }
    }
    if (isNumber(minHeight)) {
      if (bounds.bottom - bounds.top < minHeight) {
        bounds.bottom = bounds.top + minHeight;
      }
    }
    let privateWidth = this.getPrivate("width");
    let privateHeight = this.getPrivate("height");
    if (isNumber(privateWidth)) {
      if (privateWidth > 0) {
        bounds.right = bounds.left + privateWidth;
      } else {
        bounds.left = bounds.right + privateWidth;
      }
    }
    if (isNumber(privateHeight)) {
      if (privateHeight > 0) {
        bounds.bottom = bounds.top + privateHeight;
      } else {
        bounds.top = bounds.bottom + privateHeight;
      }
    }
  }
  _removeParent(parent) {
    if (parent) {
      parent.children.removeValue(this);
      removeFirst(parent._percentageSizeChildren, this);
      removeFirst(parent._percentagePositionChildren, this);
    }
  }
  _clearDirty() {
    super._clearDirty();
    this._sizeDirty = false;
    this._statesHandled = false;
  }
  /**
   * Simulate hover over element.
   */
  hover() {
    this.showTooltip();
    this._handleOver();
  }
  /**
   * Simulate unhover over element.
   */
  unhover() {
    this.hideTooltip();
    this._handleOut();
  }
  /**
   * Shows element's [[Tooltip]].
   */
  showTooltip(point2) {
    const tooltip = this.getTooltip();
    const tooltipText = this.get("tooltipText");
    const tooltipHTML = this.get("tooltipHTML");
    if ((tooltipText || tooltipHTML) && tooltip) {
      const tooltipPosition = this.get("tooltipPosition");
      const tooltipTarget = this.getPrivate("tooltipTarget", this);
      if (tooltipPosition == "fixed" || !point2) {
        this._display._setMatrix();
        point2 = this.toGlobal(tooltipTarget._getTooltipPoint());
      }
      tooltip.set("pointTo", point2);
      tooltip.set("tooltipTarget", tooltipTarget);
      if (!tooltip.get("x")) {
        tooltip.set("x", point2.x);
      }
      if (!tooltip.get("y")) {
        tooltip.set("y", point2.y);
      }
      if (tooltipText) {
        tooltip.label.set("text", tooltipText);
      }
      if (tooltipHTML) {
        tooltip.label.set("html", tooltipHTML);
      }
      const dataItem = this.dataItem;
      if (dataItem) {
        tooltip.label._setDataItem(dataItem);
      }
      if (this.get("showTooltipOn") == "always" && (point2.x < 0 || point2.x > this._root.width() || point2.y < 0 || point2.y > this._root.height())) {
        this.hideTooltip();
        return;
      }
      tooltip.label.text.markDirtyText();
      const promise = tooltip.show();
      this.setPrivateRaw("showingTooltip", true);
      return promise;
    }
  }
  /**
   * Hides element's [[Tooltip]].
   */
  hideTooltip() {
    const tooltip = this.getTooltip();
    if (tooltip) {
      if (tooltip.get("tooltipTarget") == this.getPrivate("tooltipTarget", this) || this.get("tooltip") == tooltip) {
        let timeout = tooltip.get("keepTargetHover") && tooltip.get("stateAnimationDuration", 0) == 0 ? 400 : void 0;
        const promise = tooltip.hide(timeout);
        this.setPrivateRaw("showingTooltip", false);
        return promise;
      }
    }
  }
  _getTooltipPoint() {
    const bounds = this._localBounds;
    if (bounds) {
      let x2 = 0;
      let y2 = 0;
      if (!this.get("isMeasured")) {
        x2 = relativeToValue(this.get("tooltipX", 0), this.width());
        y2 = relativeToValue(this.get("tooltipY", 0), this.height());
      } else {
        x2 = bounds.left + relativeToValue(this.get("tooltipX", 0), bounds.right - bounds.left);
        y2 = bounds.top + relativeToValue(this.get("tooltipY", 0), bounds.bottom - bounds.top);
      }
      return { x: x2, y: y2 };
    }
    return { x: 0, y: 0 };
  }
  /**
   * Returns [[Tooltip]] used for this element.
   *
   * @return Tooltip
   */
  getTooltip() {
    let tooltip = this.get("tooltip");
    if (!tooltip) {
      let parent = this.parent;
      if (parent) {
        return parent.getTooltip();
      }
    } else {
      return tooltip;
    }
  }
  _updatePosition() {
    const parent = this.parent;
    let dx = this.get("dx", 0);
    let dy = this.get("dy", 0);
    let x2 = this.get("x");
    let _x = this.getPrivate("x");
    let xx = 0;
    let yy = 0;
    const position2 = this.get("position");
    if (x2 instanceof Percent) {
      if (parent) {
        x2 = parent.innerWidth() * x2.value + parent.get("paddingLeft", 0);
      } else {
        x2 = 0;
      }
    }
    if (isNumber(x2)) {
      xx = x2 + dx;
    } else {
      if (_x != null) {
        xx = _x;
      } else if (parent) {
        if (position2 == "relative") {
          xx = parent.get("paddingLeft", 0) + dx;
        }
      }
    }
    let y2 = this.get("y");
    let _y = this.getPrivate("y");
    if (y2 instanceof Percent) {
      if (parent) {
        y2 = parent.innerHeight() * y2.value + parent.get("paddingTop", 0);
      } else {
        y2 = 0;
      }
    }
    if (isNumber(y2)) {
      yy = y2 + dy;
    } else {
      if (_y != null) {
        yy = _y;
      } else if (parent) {
        if (position2 == "relative") {
          yy = parent.get("paddingTop", 0) + dy;
        }
      }
    }
    const display = this._display;
    if (display.x != xx || display.y != yy) {
      display.invalidateBounds();
      display.x = xx;
      display.y = yy;
      const eventType = "positionchanged";
      if (this.events.isEnabled(eventType)) {
        this.events.dispatch(eventType, { type: eventType, target: this });
      }
    }
    if (this.getPrivate("showingTooltip")) {
      this.showTooltip();
    }
  }
  /**
   * Returns element's actual X position in pixels.
   *
   * @return X (px)
   */
  x() {
    let x2 = this.get("x");
    let _x = this.getPrivate("x");
    const parent = this.parent;
    if (parent) {
      if (x2 instanceof Percent) {
        return relativeToValue(x2, parent.innerWidth()) + parent.get("paddingLeft", 0);
      } else {
        if (!isNumber(x2)) {
          if (_x != null) {
            return _x;
          } else {
            return parent.get("paddingLeft", this._display.x);
          }
        } else {
          return x2;
        }
      }
    }
    return this._display.x;
  }
  /**
   * Returns element's actual Y position in pixels.
   *
   * @return Y (px)
   */
  y() {
    let _y = this.getPrivate("y");
    if (_y != null) {
      return _y;
    }
    let y2 = this.get("y");
    const parent = this.parent;
    if (parent) {
      if (y2 instanceof Percent) {
        return relativeToValue(y2, parent.innerHeight()) + parent.get("paddingTop", 0);
      } else {
        if (!isNumber(y2)) {
          if (_y != null) {
            return _y;
          } else {
            return parent.get("paddingTop", this._display.y);
          }
        } else {
          return y2;
        }
      }
    }
    return this._display.y;
  }
  _dispose() {
    super._dispose();
    this._display.dispose();
    this._removeTemplateField();
    this._removeParent(this.parent);
    this._root._removeFocusElement(this);
    const tooltip = this.get("tooltip");
    if (tooltip) {
      tooltip.dispose();
    }
    this.markDirty();
  }
  /**
   * @ignore
   */
  adjustedLocalBounds() {
    this._fixMinBounds(this._adjustedLocalBounds);
    return this._adjustedLocalBounds;
  }
  /**
   * Returns local coordinates of the element's bounds.
   *
   * @ignore
   * @return Global bounds
   */
  localBounds() {
    return this._localBounds;
  }
  /**
   * Returns adjusted local coordinates of the element's bounds.
   *
   * @ignore
   * @return Global bounds
   */
  bounds() {
    const bounds = this._adjustedLocalBounds;
    const x2 = this.x();
    const y2 = this.y();
    return { left: bounds.left + x2, right: bounds.right + x2, top: bounds.top + y2, bottom: bounds.bottom + y2 };
  }
  /**
   * Returns global coordinates of the element's bounds.
   *
   * @ignore
   * @return Global bounds
   */
  globalBounds() {
    const bounds = this.localBounds();
    const p02 = this.toGlobal({ x: bounds.left, y: bounds.top });
    const p1 = this.toGlobal({ x: bounds.right, y: bounds.top });
    const p2 = this.toGlobal({ x: bounds.right, y: bounds.bottom });
    const p3 = this.toGlobal({ x: bounds.left, y: bounds.bottom });
    return {
      left: Math.min(p02.x, p1.x, p2.x, p3.x),
      top: Math.min(p02.y, p1.y, p2.y, p3.y),
      right: Math.max(p02.x, p1.x, p2.x, p3.x),
      bottom: Math.max(p02.y, p1.y, p2.y, p3.y)
    };
  }
  _onShow(_duration) {
  }
  _onHide(_duration) {
  }
  /**
   * Plays initial reveal animation regardless if element is currently hidden
   * or visible.
   *
   * @param   duration  Duration of the animation in milliseconds
   * @param   delay     Delay showing of the element by X milliseconds
   * @return            Promise
   */
  appear(duration, delay) {
    return __awaiter(this, void 0, void 0, function* () {
      yield this.hide(0);
      if (delay) {
        return new Promise((success, _error) => {
          this.setTimeout(() => {
            success(this.show(duration));
          }, delay);
        });
      } else {
        return this.show(duration);
      }
    });
  }
  /**
   * Shows currently hidden element and returns a `Promise` which completes
   * when all showing animations are finished.
   *
   * ```TypeScript
   * series.show().then(function(ev) {
   *   console.log("Series is now fully visible");
   * })
   * ```
   * ```JavaScript
   * series.show().then(function(ev) {
   *   console.log("Series is now fully visible");
   * })
   * ```
   *
   * @return Promise
   */
  show(duration) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._isShowing) {
        this._isHidden = false;
        this._isShowing = true;
        this._isHiding = false;
        if (this.states.lookup("default").get("visible")) {
          this.set("visible", true);
        }
        this._onShow(duration);
        const animations = this.states.applyAnimate("default", duration);
        yield waitForAnimations(animations);
        this._isShowing = false;
      }
    });
  }
  /**
   * Hides the element and returns a `Promise` which completes when all hiding
   * animations are finished.
   *
   * ```TypeScript
   * series.hide().then(function(ev) {
   *   console.log("Series finished hiding");
   * })
   * ```
   * ```JavaScript
   * series.hide().then(function(ev) {
   *   console.log("Series finished hiding");
   * })
   * ```
   *
   * @return Promise
   */
  hide(duration) {
    return __awaiter(this, void 0, void 0, function* () {
      if (!this._isHiding && !this._isHidden) {
        this._isHiding = true;
        this._isShowing = false;
        let state = this.states.lookup("hidden");
        if (!state) {
          state = this.states.create("hidden", {
            "opacity": 0,
            "visible": false
          });
        }
        this._isHidden = true;
        this._onHide(duration);
        const animations = this.states.applyAnimate("hidden", duration);
        yield waitForAnimations(animations);
        this._isHiding = false;
      }
    });
  }
  /**
   * Returns `true` if this element is currently hidden.
   *
   * @return Is hidden?
   */
  isHidden() {
    return this._isHidden;
  }
  /**
   * Returns `true` if this element is currently animating to a default state.
   *
   * @return Is showing?
   */
  isShowing() {
    return this._isShowing;
  }
  /**
   * Returns `true` if this element is currently animating to a hidden state.
   *
   * @return Is hiding?
   */
  isHiding() {
    return this._isHiding;
  }
  /**
   * Returns `true` if this element is currently hovered by a pointer.
   *
   * @return Is hovered?
   */
  isHover() {
    return this._display.hovering();
  }
  /**
   * Returns `true` if this element does currently have focus.
   *
   * @return Is focused?
   */
  isFocus() {
    return this._root.focused(this);
  }
  /**
   * Returns `true` if this element is currently being dragged.
   *
   * @return Is dragged?
   */
  isDragging() {
    return this._isDragging;
  }
  /**
   * Returns `false` if if either public or private setting `visible` is set
   * to `false`, or `forceHidden` is set to `true`.
   *
   * @return Visible?
   */
  isVisible() {
    if (this.get("visible") && this.getPrivate("visible") && !this.get("forceHidden")) {
      return true;
    }
    return false;
  }
  /**
   * Same as `isVisible()`, except it checks all ascendants, too.
   *
   * @since 5.2.7
   * @return Visible?
   */
  isVisibleDeep() {
    return this._parent ? this._parent.isVisibleDeep() && this.isVisible() : this.isVisible();
  }
  /**
   * Returns an actual opacity of the element, taking into account all parents.
   *
   * @return Opacity
   * @since 5.2.11
   */
  compositeOpacity() {
    const opacity = this.get("opacity", 1);
    return this._parent ? this._parent.compositeOpacity() * opacity : opacity;
  }
  /**
   * Returns width of this element in pixels.
   *
   * @return Width (px)
   */
  width() {
    let width = this.get("width");
    let maxWidth = this.get("maxWidth", this.getPrivate("maxWidth"));
    let minWidth = this.get("minWidth", this.getPrivate("minWidth"));
    let privateWidth = this.getPrivate("width");
    let w = 0;
    if (isNumber(privateWidth)) {
      w = privateWidth;
    } else {
      if (width == null) {
        if (this._adjustedLocalBounds) {
          w = this._adjustedLocalBounds.right - this._adjustedLocalBounds.left;
        }
      } else {
        if (width instanceof Percent) {
          const parent = this.parent;
          if (parent) {
            w = parent.innerWidth() * width.value;
          } else {
            w = this._root.width() * width.value;
          }
        } else if (isNumber(width)) {
          w = width;
        }
      }
    }
    if (isNumber(minWidth)) {
      w = Math.max(minWidth, w);
    }
    if (isNumber(maxWidth)) {
      w = Math.min(maxWidth, w);
    }
    return w;
  }
  /**
   * Returns maximum allowed width of this element in pixels.
   *
   * @return Maximum width (px)
   */
  maxWidth() {
    let maxWidth = this.get("maxWidth", this.getPrivate("maxWidth"));
    if (isNumber(maxWidth)) {
      return maxWidth;
    } else {
      let width = this.get("width");
      if (isNumber(width)) {
        return width;
      }
    }
    const parent = this.parent;
    if (parent) {
      return parent.innerWidth();
    }
    return this._root.width();
  }
  /**
   * Returns maximum allowed height of this element in pixels.
   *
   * @return Maximum height (px)
   */
  maxHeight() {
    let maxHeight = this.get("maxHeight", this.getPrivate("maxHeight"));
    if (isNumber(maxHeight)) {
      return maxHeight;
    } else {
      let height = this.get("height");
      if (isNumber(height)) {
        return height;
      }
    }
    const parent = this.parent;
    if (parent) {
      return parent.innerHeight();
    }
    return this._root.height();
  }
  /**
   * Returns height of this element in pixels.
   *
   * @return Height (px)
   */
  height() {
    let height = this.get("height");
    let maxHeight = this.get("maxHeight", this.getPrivate("maxHeight"));
    let minHeight = this.get("minHeight", this.getPrivate("minHeight"));
    let privateHeight = this.getPrivate("height");
    let h = 0;
    if (isNumber(privateHeight)) {
      h = privateHeight;
    } else {
      if (height == null) {
        if (this._adjustedLocalBounds) {
          h = this._adjustedLocalBounds.bottom - this._adjustedLocalBounds.top;
        }
      } else {
        if (height instanceof Percent) {
          const parent = this.parent;
          if (parent) {
            h = parent.innerHeight() * height.value;
          } else {
            h = this._root.height() * height.value;
          }
        } else if (isNumber(height)) {
          h = height;
        }
      }
    }
    if (isNumber(minHeight)) {
      h = Math.max(minHeight, h);
    }
    if (isNumber(maxHeight)) {
      h = Math.min(maxHeight, h);
    }
    return h;
  }
  _findStaticTemplate(f) {
    if (this._templateField && f(this._templateField)) {
      return this._templateField;
    }
    return super._findStaticTemplate(f);
  }
  _walkParents(f) {
    if (this._parent) {
      this._walkParent(f);
    }
  }
  _walkParent(f) {
    if (this._parent) {
      this._parent._walkParent(f);
    }
    f(this);
  }
  /**
   * Parent [[Container]] of this element.
   *
   * @return Parent container
   */
  get parent() {
    return this._parent;
  }
  _setParent(parent, updateChildren = false) {
    const prevParent = this._parent;
    if (parent !== prevParent) {
      this.markDirtyBounds();
      parent.markDirty();
      this._parent = parent;
      if (updateChildren) {
        this._removeParent(prevParent);
        if (parent) {
          this._addPercentageSizeChildren();
          this._addPercentagePositionChildren();
        }
      }
      this.markDirtyPosition();
      this._applyThemes();
    }
  }
  /**
   * Returns an instance of [[NumberFormatter]] used in this element.
   *
   * If this element does not have it set, global one form [[Root]] is used.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/using-formatters/} for more info
   * @return NumberFormatter instace
   */
  getNumberFormatter() {
    return this.get("numberFormatter", this._root.numberFormatter);
  }
  /**
   * Returns an instance of [[DateFormatter]] used in this element.
   *
   * If this element does not have it set, global one form [[Root]] is used.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/using-formatters/} for more info
   * @return DateFormatter instace
   */
  getDateFormatter() {
    return this.get("dateFormatter", this._root.dateFormatter);
  }
  /**
   * Returns an instance of [[DurationFormatter]] used in this element.
   *
   * If this element does not have it set, global one form [[Root]] is used.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/using-formatters/} for more info
   * @return DurationFormatter instace
   */
  getDurationFormatter() {
    return this.get("durationFormatter", this._root.durationFormatter);
  }
  /**
   * Converts X/Y coordinate within this element to a global coordinate.
   *
   * @param  point  Local coordinate
   * @return        Global coordinate
   */
  toGlobal(point2) {
    return this._display.toGlobal(point2);
  }
  /**
   * Converts global X/Y coordinate to a coordinate within this element.
   *
   * @param  point  Global coordinate
   * @return        Local coordinate
   */
  toLocal(point2) {
    return this._display.toLocal(point2);
  }
  _getDownPoint() {
    const id = this._getDownPointId();
    if (id) {
      return this._downPoints[id];
    }
  }
  _getDownPointId() {
    if (this._downPoints) {
      return keysOrdered(this._downPoints, (a, b) => {
        if (a > b) {
          return 1;
        }
        if (a < b) {
          return -1;
        }
        return 0;
      })[0];
    }
  }
  /**
   * Moves sprite to the end of the parent's children array.
   *
   * Depending on `layout` setting of the parten container, it may effect the
   * positioning or overlapping order of the elements.
   */
  toFront() {
    const parent = this.parent;
    if (parent) {
      parent.children.moveValue(this, parent.children.length - 1);
    }
  }
  /**
   * Moves sprite to the beginning of the parent's children array.
   *
   * Depending on `layout` setting of the parten container, it may effect the
   * positioning or overlapping order of the elements.
   */
  toBack() {
    const parent = this.parent;
    if (parent) {
      parent.children.moveValue(this, 0);
    }
  }
};
Object.defineProperty(Sprite, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Sprite"
});
Object.defineProperty(Sprite, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Entity2.classNames.concat([Sprite.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/patterns/Pattern.js
var Pattern = class extends Entity2 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_display", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._root._renderer.makeGraphics()
    });
    Object.defineProperty(this, "_backgroundDisplay", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._root._renderer.makeGraphics()
    });
    Object.defineProperty(this, "_clear", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_pattern", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  _afterNew() {
    super._afterNewApplyThemes();
  }
  get pattern() {
    return this._pattern;
  }
  _draw() {
  }
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("repetition") || this.isDirty("width") || this.isDirty("height") || this.isDirty("rotation") || this.isDirty("strokeWidth") || this.isDirty("strokeDasharray") || this.isDirty("strokeDashoffset") || this.isDirty("colorOpacity") || this.isDirty("fillOpacity")) {
      this._clear = true;
    }
    this._checkDirtyFill();
  }
  _checkDirtyFill() {
    if (this.isDirty("color") || this.isDirty("fill")) {
      this._clear = true;
    }
  }
  _changed() {
    super._changed();
    if (this._clear) {
      const repetition = this.get("repetition", "");
      const width = this.get("width", 100);
      const height = this.get("height", 100);
      const fill = this.get("fill");
      const fillOpacity = this.get("fillOpacity", 1);
      const backgroundDisplay = this._backgroundDisplay;
      const display = this._display;
      display.clear();
      backgroundDisplay.clear();
      if (fill && fillOpacity > 0) {
        backgroundDisplay.beginFill(fill, fillOpacity);
        backgroundDisplay.drawRect(0, 0, width, height);
        backgroundDisplay.endFill();
      }
      display.angle = this.get("rotation", 0);
      this._draw();
      this._pattern = this._root._renderer.createPattern(display, backgroundDisplay, repetition, width, height);
    }
    this._clear = false;
  }
};
Object.defineProperty(Pattern, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Pattern"
});
Object.defineProperty(Pattern, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Entity2.classNames.concat([Pattern.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/patterns/PicturePattern.js
var PicturePattern = class extends Pattern {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_image", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  _beforeChanged() {
    super._beforeChanged();
    this._clear = true;
    if (this.isDirty("src")) {
      this._load();
    }
    const canvas = this.get("canvas");
    if (canvas) {
      this.set("width", canvas.width);
      this.set("height", canvas.height);
    }
  }
  _draw() {
    super._draw();
    const image = this._image;
    if (image) {
      const patternWidth = this.get("width", 100);
      const patternHeight = this.get("height", 100);
      const fit = this.get("fit", "image");
      let width = 0;
      let height = 0;
      if (fit == "pattern") {
        width = patternWidth;
        height = patternHeight;
      } else {
        width = image.width;
        height = image.height;
        if (fit == "image") {
          this.set("width", width);
          this.set("height", height);
        }
      }
      const centered = this.get("centered", true);
      let x2 = 0;
      let y2 = 0;
      if (centered) {
        x2 = patternWidth / 2 - width / 2;
        y2 = patternHeight / 2 - height / 2;
      }
      this._display.image(image, width, height, x2, y2);
    }
    const canvas = this.get("canvas");
    if (canvas) {
      this._display.image(canvas, canvas.width, canvas.height, 0, 0);
    }
  }
  _load() {
    const src = this.get("src");
    if (src) {
      const image = new Image();
      image.src = src;
      image.decode().then(() => {
        this._image = image;
        this._draw();
        if (this.events.isEnabled("loaded")) {
          this.events.dispatch("loaded", { type: "loaded", target: this });
        }
      }).catch((_error) => {
      });
    }
  }
};
Object.defineProperty(PicturePattern, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "PicturePattern"
});
Object.defineProperty(PicturePattern, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Pattern.classNames.concat([PicturePattern.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/backend/Renderer.js
var BlendMode;
(function(BlendMode2) {
  BlendMode2["ADD"] = "lighter";
  BlendMode2["COLOR"] = "color";
  BlendMode2["COLOR_BURN"] = "color-burn";
  BlendMode2["COLOR_DODGE"] = "color-dodge";
  BlendMode2["DARKEN"] = "darken";
  BlendMode2["DIFFERENCE"] = "difference";
  BlendMode2["DST_OVER"] = "destination-over";
  BlendMode2["EXCLUSION"] = "exclusion";
  BlendMode2["HARD_LIGHT"] = "hard-light";
  BlendMode2["HUE"] = "hue";
  BlendMode2["LIGHTEN"] = "lighten";
  BlendMode2["LUMINOSITY"] = "luminosity";
  BlendMode2["MULTIPLY"] = "multiply";
  BlendMode2["NORMAL"] = "source-over";
  BlendMode2["OVERLAY"] = "overlay";
  BlendMode2["SATURATION"] = "saturation";
  BlendMode2["SCREEN"] = "screen";
  BlendMode2["SOFT_LIGHT"] = "soft-light";
  BlendMode2["SRC_ATOP"] = "source-atop";
  BlendMode2["XOR"] = "xor";
})(BlendMode || (BlendMode = {}));

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Graphics.js
var visualSettings = ["fill", "fillOpacity", "stroke", "strokeWidth", "strokeOpacity", "fillPattern", "strokePattern", "fillGradient", "strokeGradient", "strokeDasharray", "strokeDashoffset", "shadowBlur", "shadowColor", "shadowOpacity", "shadowOffsetX", "shadowOffsetY", "blur", "sepia", "invert", "brightness", "hue", "contrast", "saturate"];
var Graphics = class extends Sprite {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_display", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._root._renderer.makeGraphics()
    });
    Object.defineProperty(this, "_clear", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
  }
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("draw") || this.isDirty("svgPath")) {
      this.markDirtyBounds();
    }
    if (this.isDirty("fill") || this.isDirty("stroke") || this.isDirty("visible") || this.isDirty("forceHidden") || this.isDirty("scale") || this.isDirty("fillGradient") || this.isDirty("strokeGradient") || this.isDirty("fillPattern") || this.isDirty("strokePattern") || this.isDirty("fillOpacity") || this.isDirty("strokeOpacity") || this.isDirty("strokeWidth") || this.isDirty("draw") || this.isDirty("blendMode") || this.isDirty("strokeDasharray") || this.isDirty("strokeDashoffset") || this.isDirty("svgPath") || this.isDirty("lineJoin") || this.isDirty("shadowColor") || this.isDirty("shadowBlur") || this.isDirty("shadowOffsetX") || this.isDirty("shadowOffsetY")) {
      this._clear = true;
    }
    this._display.crisp = this.get("crisp", false);
    if (this.isDirty("fillGradient")) {
      const gradient = this.get("fillGradient");
      if (gradient) {
        this._display.isMeasured = true;
        const gradientTarget = gradient.get("target");
        if (gradientTarget) {
          this._disposers.push(gradientTarget.events.on("boundschanged", () => {
            this._markDirtyKey("fill");
          }));
          this._disposers.push(gradientTarget.events.on("positionchanged", () => {
            this._markDirtyKey("fill");
          }));
        }
      }
    }
    if (this.isDirty("strokeGradient")) {
      const gradient = this.get("strokeGradient");
      if (gradient) {
        this._display.isMeasured = true;
        const gradientTarget = gradient.get("target");
        if (gradientTarget) {
          this._disposers.push(gradientTarget.events.on("boundschanged", () => {
            this._markDirtyKey("stroke");
          }));
          this._disposers.push(gradientTarget.events.on("positionchanged", () => {
            this._markDirtyKey("stroke");
          }));
        }
      }
    }
  }
  _changed() {
    super._changed();
    if (this._clear) {
      this.markDirtyBounds();
      this.markDirtyLayer();
      this._display.clear();
      let strokeDasharray = this.get("strokeDasharray");
      if (isNumber(strokeDasharray)) {
        if (strokeDasharray < 0.5) {
          strokeDasharray = [0];
        } else {
          strokeDasharray = [strokeDasharray];
        }
      }
      this._display.setLineDash(strokeDasharray);
      const strokeDashoffset = this.get("strokeDashoffset");
      if (strokeDashoffset) {
        this._display.setLineDashOffset(strokeDashoffset);
      }
      const blendMode = this.get("blendMode", BlendMode.NORMAL);
      this._display.blendMode = blendMode;
      const draw = this.get("draw");
      if (draw) {
        draw(this._display, this);
      }
      const svgPath = this.get("svgPath");
      if (svgPath != null) {
        this._display.svgPath(svgPath);
      }
    }
  }
  _afterChanged() {
    super._afterChanged();
    if (this._clear) {
      const fill = this.get("fill");
      const fillGradient = this.get("fillGradient");
      const fillPattern = this.get("fillPattern");
      const fillOpacity = this.get("fillOpacity");
      const stroke = this.get("stroke");
      const strokeGradient = this.get("strokeGradient");
      const strokePattern = this.get("strokePattern");
      const shadowColor = this.get("shadowColor");
      const shadowBlur = this.get("shadowBlur");
      const shadowOffsetX = this.get("shadowOffsetX");
      const shadowOffsetY = this.get("shadowOffsetY");
      const shadowOpacity = this.get("shadowOpacity");
      if (shadowColor && (shadowBlur || shadowOffsetX || shadowOffsetY)) {
        this._display.shadow(shadowColor, shadowBlur, shadowOffsetX, shadowOffsetY, shadowOpacity);
      }
      if (fill && !fillGradient) {
        this._display.beginFill(fill, fillOpacity);
        this._display.endFill();
      }
      if (fillGradient) {
        if (fill) {
          const stops = fillGradient.get("stops", []);
          if (stops.length) {
            each(stops, (stop) => {
              if ((!stop.color || stop.colorInherited) && fill) {
                stop.color = fill;
                stop.colorInherited = true;
              }
              if (stop.opacity == null || stop.opacityInherited) {
                stop.opacity = fillOpacity;
                stop.opacityInherited = true;
              }
            });
          }
        }
        const gradient = fillGradient.getFill(this);
        if (gradient) {
          this._display.beginFill(gradient, fillOpacity);
          this._display.endFill();
        }
      }
      if (fillPattern) {
        const pattern4 = fillPattern.pattern;
        if (pattern4) {
          this._display.beginFill(pattern4, fillOpacity);
          this._display.endFill();
          if (fillPattern instanceof PicturePattern) {
            fillPattern.events.once("loaded", () => {
              this._clear = true;
              this.markDirty();
            });
          }
        }
      }
      if (stroke || strokeGradient || strokePattern) {
        const strokeOpacity = this.get("strokeOpacity");
        let strokeWidth = this.get("strokeWidth", 1);
        if (this.get("nonScalingStroke")) {
          strokeWidth = strokeWidth / this.get("scale", 1);
        }
        if (this.get("crisp")) {
          strokeWidth /= this._root._renderer.resolution;
        }
        const lineJoin = this.get("lineJoin");
        if (stroke && !strokeGradient) {
          this._display.lineStyle(strokeWidth, stroke, strokeOpacity, lineJoin);
          this._display.endStroke();
        }
        if (strokeGradient) {
          const stops = strokeGradient.get("stops", []);
          if (stops.length) {
            each(stops, (stop) => {
              if ((!stop.color || stop.colorInherited) && stroke) {
                stop.color = stroke;
                stop.colorInherited = true;
              }
              if (stop.opacity == null || stop.opacityInherited) {
                stop.opacity = strokeOpacity;
                stop.opacityInherited = true;
              }
            });
          }
          const gradient = strokeGradient.getFill(this);
          if (gradient) {
            this._display.lineStyle(strokeWidth, gradient, strokeOpacity, lineJoin);
            this._display.endStroke();
          }
        }
        if (strokePattern) {
          let pattern4 = strokePattern.pattern;
          if (pattern4) {
            this._display.lineStyle(strokeWidth, pattern4, strokeOpacity, lineJoin);
            this._display.endStroke();
            if (strokePattern instanceof PicturePattern) {
              strokePattern.events.once("loaded", () => {
                this._clear = true;
                this.markDirty();
              });
            }
          }
        }
      }
      if (this.getPrivate("showingTooltip")) {
        this.showTooltip();
      }
    }
    this._clear = false;
  }
};
Object.defineProperty(Graphics, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Graphics"
});
Object.defineProperty(Graphics, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Sprite.classNames.concat([Graphics.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Rectangle.js
var Rectangle = class extends Graphics {
  _afterNew() {
    super._afterNew();
    this._display.isMeasured = true;
    this.setPrivateRaw("trustBounds", true);
  }
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("width") || this.isDirty("height") || this.isPrivateDirty("width") || this.isPrivateDirty("height")) {
      this._clear = true;
    }
  }
  _changed() {
    super._changed();
    if (this._clear && !this.get("draw")) {
      this._draw();
    }
  }
  _draw() {
    this._display.drawRect(0, 0, this.width(), this.height());
  }
  _updateSize() {
    this.markDirty();
    this._clear = true;
  }
};
Object.defineProperty(Rectangle, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Rectangle"
});
Object.defineProperty(Rectangle, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Graphics.classNames.concat([Rectangle.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Layout.js
function eachChildren(container, f) {
  if (container.get("reverseChildren", false)) {
    container.children.eachReverse(f);
  } else {
    container.children.each(f);
  }
}
var Layout = class extends Entity2 {
};
Object.defineProperty(Layout, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Layout"
});
Object.defineProperty(Layout, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Entity2.classNames.concat([Layout.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/HorizontalLayout.js
var HorizontalLayout = class extends Layout {
  /**
   * @ignore
   */
  updateContainer(container) {
    let paddingLeft = container.get("paddingLeft", 0);
    let availableWidth = container.innerWidth();
    let totalPercent = 0;
    eachChildren(container, (child) => {
      if (child.isVisible()) {
        if (child.get("position") == "relative") {
          let childWidth = child.get("width");
          if (childWidth instanceof Percent) {
            totalPercent += childWidth.value;
            let w = availableWidth * childWidth.value;
            let minWidth = child.get("minWidth", child.getPrivate("minWidth", -Infinity));
            if (minWidth > w) {
              availableWidth -= minWidth;
              totalPercent -= childWidth.value;
            }
            let maxWidth = child.get("maxWidth", child.getPrivate("maxWidth", Infinity));
            if (w > maxWidth) {
              availableWidth -= maxWidth;
              totalPercent -= childWidth.value;
            }
          } else {
            if (!isNumber(childWidth)) {
              childWidth = child.width();
            }
            availableWidth -= childWidth + child.get("marginLeft", 0) + child.get("marginRight", 0);
          }
        }
      }
    });
    if (availableWidth <= 0 || availableWidth == Infinity) {
      availableWidth = 0.1;
    }
    eachChildren(container, (child) => {
      if (child.isVisible()) {
        if (child.get("position") == "relative") {
          let childWidth = child.get("width");
          if (childWidth instanceof Percent) {
            let privateWidth = availableWidth * childWidth.value / totalPercent - child.get("marginLeft", 0) - child.get("marginRight", 0);
            let minWidth = child.get("minWidth", child.getPrivate("minWidth", -Infinity));
            let maxWidth = child.get("maxWidth", child.getPrivate("maxWidth", Infinity));
            privateWidth = Math.min(Math.max(minWidth, privateWidth), maxWidth);
            child.setPrivate("width", privateWidth);
          } else {
            if (child._prevSettings.width instanceof Percent) {
              child.setPrivate("width", void 0);
            }
          }
        }
      }
    });
    let prevX = paddingLeft;
    eachChildren(container, (child) => {
      if (child.get("position") == "relative") {
        if (child.isVisible()) {
          let bounds = child.adjustedLocalBounds();
          let marginLeft = child.get("marginLeft", 0);
          let marginRight = child.get("marginRight", 0);
          let maxWidth = child.get("maxWidth");
          let left = bounds.left;
          let right = bounds.right;
          if (maxWidth) {
            if (right - left > maxWidth) {
              right = left + maxWidth;
            }
          }
          let x2 = prevX + marginLeft - left;
          child.setPrivate("x", x2);
          prevX = x2 + right + marginRight;
        } else {
          child.setPrivate("x", void 0);
        }
      }
    });
  }
};
Object.defineProperty(HorizontalLayout, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "HorizontalLayout"
});
Object.defineProperty(HorizontalLayout, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Layout.classNames.concat([HorizontalLayout.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/VerticalLayout.js
var VerticalLayout = class extends Layout {
  /**
   * @ignore
   */
  updateContainer(container) {
    let paddingTop = container.get("paddingTop", 0);
    let availableHeight = container.innerHeight();
    let totalPercent = 0;
    eachChildren(container, (child) => {
      if (child.isVisible()) {
        if (child.get("position") == "relative") {
          let childHeight = child.get("height");
          if (childHeight instanceof Percent) {
            totalPercent += childHeight.value;
            let h = availableHeight * childHeight.value;
            let minHeight = child.get("minHeight", child.getPrivate("minHeight", -Infinity));
            if (minHeight > h) {
              availableHeight -= minHeight;
              totalPercent -= childHeight.value;
            }
            let maxHeight = child.get("maxHeight", child.getPrivate("maxHeight", Infinity));
            if (h > maxHeight) {
              availableHeight -= maxHeight;
              totalPercent -= childHeight.value;
            }
          } else {
            if (!isNumber(childHeight)) {
              childHeight = child.height();
            }
            availableHeight -= childHeight + child.get("marginTop", 0) + child.get("marginBottom", 0);
          }
        }
      }
    });
    if (availableHeight <= 0 || availableHeight == Infinity) {
      availableHeight = 0.1;
    }
    eachChildren(container, (child) => {
      if (child.isVisible()) {
        if (child.get("position") == "relative") {
          let childHeight = child.get("height");
          if (childHeight instanceof Percent) {
            let privateHeight = availableHeight * childHeight.value / totalPercent - child.get("marginTop", 0) - child.get("marginBottom", 0);
            let minHeight = child.get("minHeight", child.getPrivate("minHeight", -Infinity));
            let maxHeight = child.get("maxHeight", child.getPrivate("maxHeight", Infinity));
            privateHeight = Math.min(Math.max(minHeight, privateHeight), maxHeight);
            child.setPrivate("height", privateHeight);
          } else {
            if (child._prevSettings.height instanceof Percent) {
              child.setPrivate("height", void 0);
            }
          }
        }
      }
    });
    let prevY = paddingTop;
    eachChildren(container, (child) => {
      if (child.get("position") == "relative") {
        if (child.isVisible()) {
          let bounds = child.adjustedLocalBounds();
          let marginTop = child.get("marginTop", 0);
          let top = bounds.top;
          let bottom = bounds.bottom;
          let maxHeight = child.get("maxHeight");
          if (maxHeight) {
            if (bottom - top > maxHeight) {
              bottom = top + maxHeight;
            }
          }
          let marginBottom = child.get("marginBottom", 0);
          let y2 = prevY + marginTop - top;
          child.setPrivate("y", y2);
          prevY = y2 + bottom + marginBottom;
        } else {
          child.setPrivate("y", void 0);
        }
      }
    });
  }
};
Object.defineProperty(VerticalLayout, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "VerticalLayout"
});
Object.defineProperty(VerticalLayout, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Layout.classNames.concat([VerticalLayout.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/GridLayout.js
var GridLayout = class extends Layout {
  _afterNew() {
    this._setRawDefault("maxColumns", Number.MAX_VALUE);
    super._afterNew();
  }
  /**
   * @ignore
   */
  updateContainer(container) {
    let paddingLeft = container.get("paddingLeft", 0);
    let paddingRight = container.get("paddingRight", 0);
    let paddingTop = container.get("paddingTop", 0);
    let availableWidth = container.maxWidth() - paddingLeft - paddingRight;
    let minCellWidth = availableWidth;
    let maxCellWidth = 1;
    eachChildren(container, (child) => {
      if (child.get("visible") && child.getPrivate("visible") && !child.get("forceHidden")) {
        if (child.get("position") != "absolute") {
          let childWidth = child.width();
          if (childWidth < minCellWidth) {
            minCellWidth = childWidth;
          }
          if (childWidth > maxCellWidth) {
            maxCellWidth = childWidth;
          }
        }
      }
    });
    minCellWidth = fitToRange(minCellWidth, 1, availableWidth);
    maxCellWidth = fitToRange(maxCellWidth, 1, availableWidth);
    let columnCount = 1;
    if (this.get("fixedWidthGrid")) {
      columnCount = availableWidth / maxCellWidth;
    } else {
      columnCount = availableWidth / minCellWidth;
    }
    columnCount = Math.max(1, Math.floor(columnCount));
    columnCount = Math.min(this.get("maxColumns", Number.MAX_VALUE), columnCount);
    let columnWidths = this.getColumnWidths(container, columnCount, maxCellWidth, availableWidth);
    let prevY = paddingTop;
    let column2 = 0;
    let maxColumnHeight = 0;
    columnCount = columnWidths.length;
    let prevX = paddingLeft;
    eachChildren(container, (child) => {
      if (child.get("position") == "relative" && child.isVisible()) {
        const marginTop = child.get("marginTop", 0);
        const marginBottom = child.get("marginBottom", 0);
        let bounds = child.adjustedLocalBounds();
        let marginLeft = child.get("marginLeft", 0);
        let marginRight = child.get("marginRight", 0);
        let x2 = prevX + marginLeft - bounds.left;
        let y2 = prevY + marginTop - bounds.top;
        child.setPrivate("x", x2);
        child.setPrivate("y", y2);
        prevX += columnWidths[column2] + marginRight;
        maxColumnHeight = Math.max(maxColumnHeight, child.height() + marginTop + marginBottom);
        column2++;
        if (column2 >= columnCount) {
          column2 = 0;
          prevX = paddingLeft;
          prevY += maxColumnHeight;
        }
      }
    });
  }
  /**
   * @ignore
   */
  getColumnWidths(container, columnCount, maxCellWidth, availableWidth) {
    let totalWidth = 0;
    let columnWidths = [];
    let column2 = 0;
    eachChildren(container, (child) => {
      let bounds = child.adjustedLocalBounds();
      if (child.get("position") != "absolute" && child.isVisible()) {
        if (this.get("fixedWidthGrid")) {
          columnWidths[column2] = maxCellWidth;
        } else {
          columnWidths[column2] = Math.max(columnWidths[column2] | 0, bounds.right - bounds.left + child.get("marginLeft", 0) + child.get("marginRight", 0));
        }
        if (column2 < container.children.length - 1) {
          column2++;
          if (column2 == columnCount) {
            column2 = 0;
          }
        }
      }
    });
    each(columnWidths, (w) => {
      totalWidth += w;
    });
    if (totalWidth > availableWidth) {
      if (columnCount > 2) {
        columnCount -= 1;
        return this.getColumnWidths(container, columnCount, maxCellWidth, availableWidth);
      } else {
        return [availableWidth];
      }
    }
    return columnWidths;
  }
};
Object.defineProperty(GridLayout, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "GridLayout"
});
Object.defineProperty(GridLayout, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Layout.classNames.concat([GridLayout.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/TextFormatter.js
var TextFormatter = class {
  /**
   * Replaces brackets with temporary placeholders.
   *
   * @ignore Exclude from docs
   * @param text  Input text
   * @return Escaped text
   */
  static escape(text) {
    return text.replace(/\[\[/g, this.prefix + "1").replace(/([^\/\]]{1})\]\]/g, "$1" + this.prefix + "2").replace(/\]\]/g, this.prefix + "2").replace(/\{\{/g, this.prefix + "3").replace(/\}\}/g, this.prefix + "4").replace(/\'\'/g, this.prefix + "5");
  }
  /**
   * Replaces placeholders back to brackets.
   *
   * @ignore Exclude from docs
   * @param text  Escaped text
   * @return Unescaped text
   */
  static unescape(text) {
    return text.replace(new RegExp(this.prefix + "1", "g"), "[[").replace(new RegExp(this.prefix + "2", "g"), "]]").replace(new RegExp(this.prefix + "3", "g"), "{{").replace(new RegExp(this.prefix + "4", "g"), "}}").replace(new RegExp(this.prefix + "5", "g"), "''");
  }
  /**
   * Cleans up the text text for leftover double square brackets.
   *
   * @ignore Exclude from docs
   * @param text  Input text
   * @return Cleaned up text
   */
  static cleanUp(text) {
    return text.replace(/\[\[/g, "[").replace(/\]\]/g, "]").replace(/\{\{/g, "{").replace(/\}\}/g, "}").replace(/\'\'/g, "'");
  }
  /**
   * Splits string into chunks. (style blocks, quoted blocks, regular blocks)
   *
   * If the second parameter `quotedBlocks` is set to `true` this method will
   * also single out text blocks enclosed within single quotes that no
   * formatting should be applied to, and they should be displayed as is.
   *
   * Default for the above is `false`, so that you can use single quote in text
   * without escaping it.
   *
   * If enabled, single quotes can be escaped by doubling it - adding two
   * single quotes, which will be replaced by a one single quote in the final
   * output.
   *
   * @ignore Exclude from docs
   * @param text          Text to chunk
   * @param quotedBlocks  Use quoted blocks
   * @param noFormatting  Formatting blocks will be treated as regular text
   * @return Array of string chunks
   */
  static chunk(text, quotedBlocks = false, noFormatting = false) {
    let res = [];
    text = this.escape(text);
    let chunks = quotedBlocks ? text.split("'") : [text];
    for (let i = 0; i < chunks.length; i++) {
      let chunk = chunks[i];
      if (chunk === "") {
        continue;
      }
      if (i % 2 === 0) {
        chunk = chunk.replace(/\]\[/g, "]" + PLACEHOLDER + "[");
        chunk = chunk.replace(/\[\]/g, "[ ]");
        let chunks2 = chunk.split(/[\[\]]+/);
        for (let i2 = 0; i2 < chunks2.length; i2++) {
          let chunk2 = this.cleanUp(this.unescape(chunks2[i2]));
          if (chunk2 === PLACEHOLDER) {
            continue;
          }
          if (chunk2 === "") {
            continue;
          }
          if (i2 % 2 === 0) {
            res.push({
              "type": "value",
              "text": chunk2
            });
          } else {
            res.push({
              "type": noFormatting ? "value" : "format",
              "text": "[" + chunk2 + "]"
            });
          }
        }
      } else {
        let chunks2 = chunk.split(/[\[\]]+/);
        for (let i2 = 0; i2 < chunks2.length; i2++) {
          let chunk2 = this.cleanUp(this.unescape(chunks2[i2]));
          if (chunk2 === "") {
            continue;
          }
          if (i2 % 2 === 0) {
            res.push({
              "type": "text",
              "text": chunk2
            });
          } else if (this.isImage(chunk2)) {
            res.push({
              "type": "image",
              "text": "[" + chunk2 + "]"
            });
          } else {
            res.push({
              "type": "format",
              "text": "[" + chunk2 + "]"
            });
          }
        }
      }
    }
    return res;
  }
  /**
   * Checks if supplied format contains image information and should be
   * formatted as such.
   * I.e.: `[img: myImage.png]`
   *
   * @ignore
   * @param  text  Format
   * @return true if it is an image
   */
  static isImage(text) {
    return text.match(/img[ ]?:/) ? true : false;
  }
  static getTextStyle(style2) {
    let format2 = {};
    if (style2 == "" || style2 == "[ ]") {
      return {};
    }
    const q = style2.match(/('[^']*')|("[^"]*")/gi);
    if (q) {
      for (let i = 0; i < q.length; i++) {
        style2 = style2.replace(q[i], q[i].replace(/['"]*/g, "").replace(/[ ]+/g, "+"));
      }
    }
    let b = style2.match(/([\w\-]*:[\s]?[^;\s\]]*)|(\#[\w]{1,6})|([\w\-]+)|(\/)/gi);
    if (!b) {
      return {};
    }
    for (let i = 0; i < b.length; i++) {
      if (b[i].match(/^(normal|bold|bolder|lighter|100|200|300|400|500|600|700|800|900)$/i)) {
        format2.fontWeight = b[i];
      } else if (b[i].match(/^(underline|line-through)$/i)) {
        format2.textDecoration = b[i];
      } else if (b[i] == "/") {
      } else if (!b[i].match(/:/)) {
        format2.fill = Color.fromString(b[i]);
      } else {
        const p = b[i].replace("+", " ").split(/:[ ]*/);
        format2[p[0]] = p[1];
      }
    }
    return format2;
  }
};
Object.defineProperty(TextFormatter, "prefix", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "__amcharts__"
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/PopulateString.js
function populateString(target, string3) {
  if (string3 != null) {
    string3 = "" + string3;
    string3 = TextFormatter.escape(string3);
    let tags = string3.match(/\{([^}]+)\}/g);
    let i;
    if (tags) {
      for (i = 0; i < tags.length; i++) {
        let tag = tags[i].replace(/\{([^}]+)\}/, "$1");
        let value = getTagValue(target, tag, "");
        if (value == null) {
          value = "";
        }
        string3 = string3.split(tags[i]).join(value);
      }
    }
    string3 = TextFormatter.unescape(string3);
  } else {
    string3 = "";
  }
  return string3;
}
function getTagValue(target, tagName, format2) {
  let value;
  const dataItem = target.dataItem;
  let parts = [];
  let reg = /(format[a-zA-Z]*)\((.*)\)|([^.]+)/g;
  let matches;
  while (true) {
    matches = reg.exec(tagName);
    if (matches === null) {
      break;
    }
    if (matches[3]) {
      parts.push({
        prop: matches[3]
      });
      const dateFields = target.getDateFormatter().get("dateFields", []);
      const numericFields = target.getNumberFormatter().get("numericFields", []);
      const durationFields = target.getDurationFormatter().get("durationFields", []);
      if (dateFields.indexOf(matches[3]) !== -1) {
        parts.push({
          method: "formatDate",
          params: []
        });
      } else if (numericFields.indexOf(matches[3]) !== -1) {
        parts.push({
          method: "formatNumber",
          params: []
        });
      } else if (durationFields.indexOf(matches[3]) !== -1) {
        parts.push({
          method: "formatDuration",
          params: []
        });
      }
    } else {
      let params = [];
      if (trim2(matches[2]) != "") {
        let reg2 = /'([^']*)'|"([^"]*)"|([0-9\-]+)/g;
        let matches2;
        while (true) {
          matches2 = reg2.exec(matches[2]);
          if (matches2 === null) {
            break;
          }
          params.push(matches2[1] || matches2[2] || matches2[3]);
        }
      }
      parts.push({
        method: matches[1],
        params
      });
    }
  }
  if (dataItem) {
    value = getTagValueFromObject(target, parts, dataItem._settings);
    if (value == null || isObject2(value)) {
      value = getTagValueFromObject(target, parts, dataItem);
    }
    let dataContext = dataItem.dataContext;
    if (value == null && dataContext) {
      value = getTagValueFromObject(target, parts, dataContext);
      if (value == null) {
        value = getTagValueFromObject(target, [{
          prop: tagName
        }], dataContext);
      }
      if (value == null && dataContext.dataContext) {
        value = getTagValueFromObject(target, parts, dataContext.dataContext);
      }
    }
    if (value == null && dataItem.component && dataItem.component.dataItem !== dataItem) {
      value = getTagValue(dataItem.component, tagName, format2);
    }
  }
  if (value == null) {
    value = getTagValueFromObject(target, parts, target);
  }
  if (value == null && target.parent) {
    value = getTagValue(target.parent, tagName, format2);
  }
  return value;
}
function getCustomDataValue(target, prop) {
  const customData = target.getPrivate("customData");
  if (isObject2(customData)) {
    return customData[prop];
  }
}
function getTagValueFromObject(target, parts, object4, format2) {
  let current = object4;
  let formatApplied = false;
  for (let i = 0, len = parts.length; i < len; i++) {
    let part = parts[i];
    if (part.prop) {
      if (current instanceof Sprite) {
        let tmp = current.get(part.prop);
        if (tmp == null)
          tmp = current.getPrivate(part.prop);
        if (tmp == null)
          tmp = getCustomDataValue(current, part.prop);
        if (tmp == null)
          tmp = current[part.prop];
        current = tmp;
      } else if (current.get) {
        let tmp = current.get(part.prop);
        if (tmp == null)
          tmp = current[part.prop];
        current = tmp;
      } else {
        current = current[part.prop];
      }
      if (current == null) {
        return;
      }
    } else {
      switch (part.method) {
        case "formatNumber":
          let numberValue = toNumber(current);
          if (numberValue != null) {
            current = target.getNumberFormatter().format(numberValue, format2 || part.params[0] || void 0);
            formatApplied = true;
          }
          break;
        case "formatDate":
          let dateValue = toDate(current);
          if (!isDate(dateValue) || isNaN2(dateValue.getTime())) {
            return;
          }
          if (dateValue != null) {
            current = target.getDateFormatter().format(dateValue, format2 || part.params[0] || void 0);
            formatApplied = true;
          }
          break;
        case "formatDuration":
          let durationValue = toNumber(current);
          if (durationValue != null) {
            current = target.getDurationFormatter().format(durationValue, format2 || part.params[0] || void 0, part.params[1] || void 0);
            formatApplied = true;
          }
          break;
        case "urlEncode":
        case "encodeURIComponent":
          current = encodeURIComponent(current);
          break;
        default:
          if (current[part.method]) {
            current[part.method].apply(object4, part.params);
          }
          break;
      }
    }
  }
  if (!formatApplied) {
    let formatParts = [{
      method: "",
      params: format2
    }];
    if (format2 == null) {
      if (isNumber(current)) {
        formatParts[0].method = "formatNumber";
        formatParts[0].params = "";
      } else if (isDate(current)) {
        formatParts[0].method = "formatDate";
        formatParts[0].params = "";
      }
    } else {
      let formatterType = getFormat(format2);
      if (formatterType === "number") {
        formatParts[0].method = "formatNumber";
      } else if (formatterType === "date") {
        formatParts[0].method = "formatDate";
      } else if (formatterType === "duration") {
        formatParts[0].method = "formatDuration";
      }
    }
    if (formatParts[0].method) {
      current = getTagValueFromObject(target, formatParts, current);
    }
  }
  return current;
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Container.js
var Container = class _Container extends Sprite {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_display", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._root._renderer.makeContainer()
    });
    Object.defineProperty(this, "_childrenDisplay", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._root._renderer.makeContainer()
    });
    Object.defineProperty(this, "children", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new Children3(this)
    });
    Object.defineProperty(this, "_percentageSizeChildren", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_percentagePositionChildren", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_prevWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_prevHeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_contentWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_contentHeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_contentMask", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_vsbd0", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_vsbd1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  _afterNew() {
    super._afterNew();
    this._display.addChild(this._childrenDisplay);
  }
  _dispose() {
    eachReverse(this.allChildren(), (child) => {
      child.dispose();
    });
    if (this.getPrivate("htmlElement")) {
      this._root._removeHTMLContent(this);
    }
    super._dispose();
  }
  _changed() {
    super._changed();
    if (this.isDirty("interactiveChildren")) {
      this._display.interactiveChildren = this.get("interactiveChildren", false);
    }
    if (this.isDirty("layout")) {
      this._prevWidth = 0;
      this._prevHeight = 0;
      this.markDirtyBounds();
      if (this._prevSettings.layout) {
        this.children.each((child) => {
          child.removePrivate("x");
          child.removePrivate("y");
        });
      }
    }
    if (this.isDirty("paddingTop") || this.isDirty("paddingBottom") || this.isDirty("paddingLeft") || this.isDirty("paddingRight")) {
      this.children.each((child) => {
        child.markDirtyPosition();
      });
    }
    if (this.isDirty("maskContent")) {
      const childrenDisplay = this._childrenDisplay;
      let contentMask = this._contentMask;
      if (this.get("maskContent")) {
        if (!contentMask) {
          contentMask = Rectangle.new(this._root, {
            x: -0.5,
            y: -0.5,
            width: this.width() + 1,
            height: this.height() + 1
          });
          this._contentMask = contentMask;
          childrenDisplay.addChildAt(contentMask._display, 0);
          childrenDisplay.mask = contentMask._display;
        }
      } else {
        if (contentMask) {
          childrenDisplay.removeChild(contentMask._display);
          childrenDisplay.mask = null;
          contentMask.dispose();
          this._contentMask = void 0;
        }
      }
    }
  }
  _updateSize() {
    super._updateSize();
    each(this._percentageSizeChildren, (child) => {
      child._updateSize();
    });
    each(this._percentagePositionChildren, (child) => {
      child.markDirtyPosition();
      child._updateSize();
    });
    this.updateBackground();
  }
  updateBackground() {
    const background = this.get("background");
    let bounds = this._localBounds;
    if (bounds && !this.isHidden()) {
      let x2 = bounds.left;
      let y2 = bounds.top;
      let w = bounds.right - x2;
      let h = bounds.bottom - y2;
      let maxWidth = this.get("maxWidth");
      let maxHeight = this.get("maxHeight");
      if (maxHeight) {
        if (h > maxHeight) {
          h = maxHeight;
        }
      }
      if (maxWidth) {
        if (w > maxWidth) {
          w = maxWidth;
        }
      }
      let width = this.width();
      let height = this.height();
      if (background) {
        background.setAll({ width: w, height: h, x: x2, y: y2 });
        if (this._display.interactive) {
          background._display.interactive = true;
        }
      }
      const contentMask = this._contentMask;
      if (contentMask) {
        contentMask.setAll({ width: width + 1, height: height + 1 });
      }
      const verticalScrollbar = this.get("verticalScrollbar");
      if (verticalScrollbar) {
        verticalScrollbar.set("height", height);
        verticalScrollbar.set("x", width - verticalScrollbar.width() - verticalScrollbar.get("marginRight", 0));
        verticalScrollbar.set("end", verticalScrollbar.get("start", 0) + height / this._contentHeight);
        const bg = verticalScrollbar.get("background");
        if (bg) {
          bg.setAll({ width: verticalScrollbar.width(), height });
        }
        let visible = true;
        if (this._contentHeight <= height) {
          visible = false;
        }
        verticalScrollbar.setPrivate("visible", visible);
      }
    }
  }
  _applyThemes(force = false) {
    if (super._applyThemes(force)) {
      this.eachChildren((child) => {
        child._applyThemes(force);
      });
      return true;
    } else {
      return false;
    }
  }
  _applyState(name) {
    super._applyState(name);
    if (this.get("setStateOnChildren")) {
      this.eachChildren((child) => {
        child.states.apply(name);
      });
    }
  }
  _applyStateAnimated(name, duration) {
    super._applyStateAnimated(name, duration);
    if (this.get("setStateOnChildren")) {
      this.eachChildren((child) => {
        child.states.applyAnimate(name, duration);
      });
    }
  }
  /**
   * Returns container's inner width (width without padding) in pixels.
   *
   * @return Inner width (px)
   */
  innerWidth() {
    return this.width() - this.get("paddingRight", 0) - this.get("paddingLeft", 0);
  }
  /**
   * Returns container's inner height (height without padding) in pixels.
   *
   * @return Inner height (px)
   */
  innerHeight() {
    return this.height() - this.get("paddingTop", 0) - this.get("paddingBottom", 0);
  }
  _getBounds() {
    let width = this.get("width");
    let height = this.get("height");
    let pWidth = this.getPrivate("width");
    let pHeight = this.getPrivate("height");
    let bounds = {
      left: 0,
      top: 0,
      right: this.width(),
      bottom: this.height()
    };
    let layout = this.get("layout");
    let horizontal = false;
    let vertical = false;
    if (layout instanceof HorizontalLayout || layout instanceof GridLayout) {
      horizontal = true;
    }
    if (layout instanceof VerticalLayout) {
      vertical = true;
    }
    if ((width != null || pWidth != null) && (height != null || pHeight != null) && !this.get("verticalScrollbar")) {
    } else {
      let m = Number.MAX_VALUE;
      let l = m;
      let r = -m;
      let t = m;
      let b = -m;
      const paddingLeft = this.get("paddingLeft", 0);
      const paddingTop = this.get("paddingTop", 0);
      const paddingRight = this.get("paddingRight", 0);
      const paddingBottom = this.get("paddingBottom", 0);
      this.children.each((child) => {
        if (child.get("position") != "absolute" && child.get("isMeasured")) {
          let childBounds = child.adjustedLocalBounds();
          let childX = child.x();
          let childY = child.y();
          let cl = childX + childBounds.left;
          let cr = childX + childBounds.right;
          let ct = childY + childBounds.top;
          let cb = childY + childBounds.bottom;
          if (horizontal) {
            cl -= child.get("marginLeft", 0);
            cr += child.get("marginRight", 0);
          }
          if (vertical) {
            ct -= child.get("marginTop", 0);
            cb += child.get("marginBottom", 0);
          }
          if (cl < l) {
            l = cl;
          }
          if (cr > r) {
            r = cr;
          }
          if (ct < t) {
            t = ct;
          }
          if (cb > b) {
            b = cb;
          }
        }
      });
      if (l == m) {
        l = 0;
      }
      if (r == -m) {
        r = 0;
      }
      if (t == m) {
        t = 0;
      }
      if (b == -m) {
        b = 0;
      }
      bounds.left = l - paddingLeft;
      bounds.top = t - paddingTop;
      bounds.right = r + paddingRight;
      bounds.bottom = b + paddingBottom;
      const minWidth = this.get("minWidth");
      if (isNumber(minWidth) && minWidth > 0) {
        if (bounds.right - bounds.left < minWidth) {
          if (bounds.right >= minWidth) {
            bounds.left = bounds.right - minWidth;
          } else {
            bounds.right = bounds.left + minWidth;
          }
        }
      }
      const minHeight = this.get("minHeight");
      if (isNumber(minHeight) && minHeight > 0) {
        if (bounds.bottom - bounds.top < minHeight) {
          if (bounds.bottom >= minHeight) {
            bounds.top = bounds.bottom - minHeight;
          } else {
            bounds.bottom = bounds.top + minHeight;
          }
        }
      }
    }
    this._contentWidth = bounds.right - bounds.left;
    this._contentHeight = bounds.bottom - bounds.top;
    if (isNumber(width)) {
      bounds.left = 0;
      bounds.right = width;
    }
    if (isNumber(pWidth)) {
      bounds.left = 0;
      bounds.right = pWidth;
    }
    if (isNumber(height)) {
      bounds.top = 0;
      bounds.bottom = height;
    }
    if (isNumber(pHeight)) {
      bounds.top = 0;
      bounds.bottom = pHeight;
    }
    this._localBounds = bounds;
  }
  _updateBounds() {
    const layout = this.get("layout");
    if (layout) {
      layout.updateContainer(this);
    }
    super._updateBounds();
    this.updateBackground();
  }
  /**
   * @ignore
   */
  markDirty() {
    super.markDirty();
    this._root._addDirtyParent(this);
  }
  _prepareChildren() {
    const innerWidth = this.innerWidth();
    const innerHeight = this.innerHeight();
    if (innerWidth != this._prevWidth || innerHeight != this._prevHeight) {
      let layout = this.get("layout");
      let horizontal = false;
      let vertical = false;
      if (layout) {
        if (layout instanceof HorizontalLayout || layout instanceof GridLayout) {
          horizontal = true;
        }
        if (layout instanceof VerticalLayout) {
          vertical = true;
        }
      }
      each(this._percentageSizeChildren, (child) => {
        if (!horizontal) {
          let width = child.get("width");
          if (width instanceof Percent) {
            child.setPrivate("width", width.value * innerWidth);
          }
        }
        if (!vertical) {
          let height = child.get("height");
          if (height instanceof Percent) {
            child.setPrivate("height", height.value * innerHeight);
          }
        }
      });
      each(this._percentagePositionChildren, (child) => {
        child.markDirtyPosition();
        child.markDirtyBounds();
      });
      this._prevWidth = innerWidth;
      this._prevHeight = innerHeight;
      this._sizeDirty = true;
      this.updateBackground();
    }
    this._handleStates();
  }
  _updateChildren() {
    if (this.isDirty("html")) {
      const html = this.get("html");
      if (html && html !== "") {
        this._root._setHTMLContent(this, populateString(this, this.get("html", "")));
      } else {
        this._root._removeHTMLContent(this);
      }
      this._root._positionHTMLElement(this);
    }
    if (this.isDirty("verticalScrollbar")) {
      const verticalScrollbar = this.get("verticalScrollbar");
      if (verticalScrollbar) {
        verticalScrollbar._setParent(this);
        verticalScrollbar.startGrip.setPrivate("visible", false);
        verticalScrollbar.endGrip.setPrivate("visible", false);
        this.set("maskContent", true);
        this.set("paddingRight", verticalScrollbar.width() + verticalScrollbar.get("marginRight", 0) + verticalScrollbar.get("marginLeft", 0));
        let background = this.get("background");
        if (!background) {
          background = this.set("background", Rectangle.new(this._root, {
            themeTags: ["background"],
            fillOpacity: 0,
            fill: this._root.interfaceColors.get("alternativeBackground")
          }));
        }
        this._vsbd0 = this.events.on("wheel", (event) => {
          const wheelEvent = event.originalEvent;
          if (isLocalEvent(wheelEvent, this)) {
            wheelEvent.preventDefault();
          } else {
            return;
          }
          let shiftY = wheelEvent.deltaY / 5e3;
          const start = verticalScrollbar.get("start", 0);
          const end = verticalScrollbar.get("end", 1);
          if (start + shiftY <= 0) {
            shiftY = -start;
          }
          if (end + shiftY >= 1) {
            shiftY = 1 - end;
          }
          if (start + shiftY >= 0 && end + shiftY <= 1) {
            verticalScrollbar.set("start", start + shiftY);
            verticalScrollbar.set("end", end + shiftY);
          }
        });
        this._disposers.push(this._vsbd0);
        this._vsbd1 = verticalScrollbar.events.on("rangechanged", () => {
          let h = this._contentHeight;
          const childrenDisplay = this._childrenDisplay;
          const contentMask = this._contentMask;
          childrenDisplay.y = -verticalScrollbar.get("start", 0) * h;
          childrenDisplay.markDirtyLayer();
          if (contentMask) {
            contentMask._display.y = -childrenDisplay.y;
            childrenDisplay.mask = contentMask._display;
          }
        });
        this._disposers.push(this._vsbd1);
        this._display.addChild(verticalScrollbar._display);
      } else {
        const previous = this._prevSettings.verticalScrollbar;
        if (previous) {
          this._display.removeChild(previous._display);
          if (this._vsbd0) {
            this._vsbd0.dispose();
          }
          if (this._vsbd1) {
            this._vsbd1.dispose();
          }
          const childrenDisplay = this._childrenDisplay;
          childrenDisplay.y = 0;
          this.setPrivate("height", void 0);
          this.set("maskContent", false);
          this.set("paddingRight", void 0);
        }
      }
    }
    if (this.isDirty("background")) {
      const previous = this._prevSettings["background"];
      if (previous) {
        this._display.removeChild(previous._display);
      }
      const background = this.get("background");
      if (background instanceof Sprite) {
        background.set("isMeasured", false);
        background._setParent(this);
        this._display.addChildAt(background._display, 0);
      }
    }
    if (this.isDirty("mask")) {
      const mask = this.get("mask");
      const previous = this._prevSettings["mask"];
      if (previous) {
        this._display.removeChild(previous._display);
        if (previous != mask) {
          previous.dispose();
        }
      }
      if (mask) {
        const parent = mask.parent;
        if (parent) {
          parent.children.removeValue(mask);
        }
        mask._setParent(this);
        this._display.addChildAt(mask._display, 0);
        this._childrenDisplay.mask = mask._display;
      }
    }
  }
  _processTemplateField() {
    super._processTemplateField();
    this.children.each((child) => {
      child._processTemplateField();
    });
  }
  /**
   * @ignore
   */
  walkChildren(f) {
    this.children.each((child) => {
      if (child instanceof _Container) {
        child.walkChildren(f);
      }
      f(child);
    });
  }
  eachChildren(f) {
    const background = this.get("background");
    if (background) {
      f(background);
    }
    const verticalScrollbar = this.get("verticalScrollbar");
    if (verticalScrollbar) {
      f(verticalScrollbar);
    }
    const mask = this.get("mask");
    if (mask) {
      f(mask);
    }
    this.children.values.forEach((child) => {
      f(child);
    });
  }
  allChildren() {
    const output = [];
    this.eachChildren((x2) => {
      output.push(x2);
    });
    return output;
  }
  _setDataItem(dataItem) {
    const updated = dataItem !== this._dataItem;
    super._setDataItem(dataItem);
    const html = this.get("html", "");
    if (html && html !== "" && updated) {
      this._root._setHTMLContent(this, populateString(this, html));
    }
  }
};
Object.defineProperty(Container, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Container"
});
Object.defineProperty(Container, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Sprite.classNames.concat([Container.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Text.js
var Text2 = class extends Sprite {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "textStyle", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._root._renderer.makeTextStyle()
    });
    Object.defineProperty(this, "_display", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._root._renderer.makeText("", this.textStyle)
    });
    Object.defineProperty(this, "_textStyles", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: [
        "textAlign",
        "fontFamily",
        "fontSize",
        "fontStyle",
        "fontWeight",
        "fontStyle",
        "fontVariant",
        "textDecoration",
        "shadowColor",
        "shadowBlur",
        "shadowOffsetX",
        "shadowOffsetY",
        "shadowOpacity",
        // "leading",
        // "letterSpacing",
        "lineHeight",
        "baselineRatio",
        //"padding",
        // "stroke",
        // "strokeThickness",
        // "trim",
        // "wordWrap",
        "direction",
        "textBaseline",
        "oversizedBehavior",
        "breakWords",
        "ellipsis",
        "minScale",
        "maxChars"
      ]
    });
    Object.defineProperty(this, "_originalScale", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  _updateBounds() {
    if (!this.get("text")) {
      let newBounds = {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      };
      this._adjustedLocalBounds = newBounds;
    } else {
      super._updateBounds();
    }
  }
  _changed() {
    super._changed();
    this._display.clear();
    let textStyle = this.textStyle;
    if (this.isDirty("opacity")) {
      let opacity = this.get("opacity", 1);
      this._display.alpha = opacity;
    }
    if (this.isDirty("text") || this.isDirty("populateText")) {
      this._display.text = this._getText();
      this.markDirtyBounds();
      if (this.get("role") == "tooltip") {
        this._root.updateTooltip(this);
      }
    }
    if (this.isPrivateDirty("tooltipElement")) {
      const tooltipElement = this.getPrivate("tooltipElement");
      if (tooltipElement) {
        this._disposers.push(new Disposer(() => {
          this._root._removeTooltipElement(this);
        }));
      }
    }
    if (this.isDirty("width")) {
      textStyle.wordWrapWidth = this.width();
      this.markDirtyBounds();
    }
    if (this.isDirty("oversizedBehavior")) {
      textStyle.oversizedBehavior = this.get("oversizedBehavior", "none");
      this.markDirtyBounds();
    }
    if (this.isDirty("breakWords")) {
      textStyle.breakWords = this.get("breakWords", false);
      this.markDirtyBounds();
    }
    if (this.isDirty("ellipsis")) {
      textStyle.ellipsis = this.get("ellipsis");
      this.markDirtyBounds();
    }
    if (this.isDirty("ignoreFormatting")) {
      textStyle.ignoreFormatting = this.get("ignoreFormatting", false);
      this.markDirtyBounds();
    }
    if (this.isDirty("minScale")) {
      textStyle.minScale = this.get("minScale", 0);
      this.markDirtyBounds();
    }
    if (this.isDirty("fill")) {
      let fill = this.get("fill");
      if (fill) {
        textStyle.fill = fill;
      }
    }
    if (this.isDirty("fillOpacity")) {
      let fillOpacity = this.get("fillOpacity", 1);
      if (fillOpacity) {
        textStyle.fillOpacity = fillOpacity;
      }
    }
    if (this.isDirty("maxWidth") || this.isPrivateDirty("maxWidth")) {
      textStyle.maxWidth = this.get("maxWidth", this.getPrivate("maxWidth"));
      this.markDirtyBounds();
    }
    if (this.isDirty("maxHeight") || this.isPrivateDirty("maxHeight")) {
      textStyle.maxHeight = this.get("maxHeight", this.getPrivate("maxHeight"));
      this.markDirtyBounds();
    }
    each(this._textStyles, (styleName) => {
      if (this._dirty[styleName]) {
        textStyle[styleName] = this.get(styleName);
        this.markDirtyBounds();
      }
    });
    textStyle["fontSize"] = this.get("fontSize");
    textStyle["fontFamily"] = this.get("fontFamily");
    this._display.style = textStyle;
    if (this.isDirty("role") && this.get("role") == "tooltip") {
      this._root.updateTooltip(this);
    }
  }
  _getText() {
    let text = this.get("text", "");
    if (this.get("maxChars")) {
      text = truncateTextWithEllipsis(text, this.get("maxChars", 1e8), this.get("breakWords"), this.get("ellipsis"));
    }
    return this.get("populateText") ? populateString(this, text) : text;
  }
  /**
   * Forces the text to be re-evaluated and re-populated.
   */
  markDirtyText() {
    this._display.text = this._getText();
    if (this.get("role") == "tooltip") {
      this._root.updateTooltip(this);
    }
    this.markDirtyBounds();
    this.markDirty();
  }
  _setDataItem(dataItem) {
    super._setDataItem(dataItem);
    if (this.get("populateText")) {
      this.markDirtyText();
    }
  }
  getNumberFormatter() {
    if (this.parent) {
      return this.parent.getNumberFormatter();
    } else {
      return super.getNumberFormatter();
    }
  }
  getDateFormatter() {
    if (this.parent) {
      return this.parent.getDateFormatter();
    } else {
      return super.getDateFormatter();
    }
  }
  getDurationFormatter() {
    if (this.parent) {
      return this.parent.getDurationFormatter();
    } else {
      return super.getDurationFormatter();
    }
  }
};
Object.defineProperty(Text2, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Text"
});
Object.defineProperty(Text2, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Sprite.classNames.concat([Text2.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/ResizeSensor.js
var Native = class {
  constructor() {
    Object.defineProperty(this, "_observer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_targets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    this._observer = new ResizeObserver((entries) => {
      each(entries, (entry) => {
        each(this._targets, (x2) => {
          if (x2.target === entry.target) {
            x2.callback();
          }
        });
      });
    });
  }
  addTarget(target, callback) {
    this._observer.observe(target, { box: "border-box" });
    this._targets.push({ target, callback });
  }
  removeTarget(target) {
    this._observer.unobserve(target);
    keepIf(this._targets, (x2) => {
      return x2.target !== target;
    });
  }
};
var Raf = class _Raf {
  constructor() {
    Object.defineProperty(this, "_timer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, "_targets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
  }
  addTarget(target, callback) {
    if (this._timer === null) {
      let lastTime = null;
      const loop = () => {
        const currentTime = Date.now();
        if (lastTime === null || currentTime > lastTime + _Raf.delay) {
          lastTime = currentTime;
          each(this._targets, (x2) => {
            let newSize = x2.target.getBoundingClientRect();
            if (newSize.width !== x2.size.width || newSize.height !== x2.size.height) {
              x2.size = newSize;
              x2.callback();
            }
          });
        }
        if (this._targets.length === 0) {
          this._timer = null;
        } else {
          this._timer = requestAnimationFrame(loop);
        }
      };
      this._timer = requestAnimationFrame(loop);
    }
    let size = { width: 0, height: 0, left: 0, right: 0, top: 0, bottom: 0, x: 0, y: 0 };
    this._targets.push({ target, callback, size });
  }
  removeTarget(target) {
    keepIf(this._targets, (x2) => {
      return x2.target !== target;
    });
    if (this._targets.length === 0) {
      if (this._timer !== null) {
        cancelAnimationFrame(this._timer);
        this._timer = null;
      }
    }
  }
};
Object.defineProperty(Raf, "delay", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: 200
});
var observer = null;
function makeSensor() {
  if (observer === null) {
    if (typeof ResizeObserver !== "undefined") {
      observer = new Native();
    } else {
      observer = new Raf();
    }
  }
  return observer;
}
var ResizeSensor = class {
  constructor(element, callback) {
    Object.defineProperty(this, "_sensor", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_element", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_listener", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_disposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    this._sensor = makeSensor();
    this._element = element;
    this._listener = onZoom(callback);
    this._sensor.addTarget(element, callback);
  }
  isDisposed() {
    return this._disposed;
  }
  dispose() {
    if (!this._disposed) {
      this._disposed = true;
      this._sensor.removeTarget(this._element);
      this._listener.dispose();
    }
  }
  get sensor() {
    return this._sensor;
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/InterfaceColors.js
var InterfaceColors = class extends Entity2 {
};
Object.defineProperty(InterfaceColors, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "InterfaceColors"
});
Object.defineProperty(InterfaceColors, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Entity2.classNames.concat([InterfaceColors.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Label.js
var Label = class extends Container {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_text", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_textKeys", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: [
        "text",
        "fill",
        "fillOpacity",
        "textAlign",
        "fontFamily",
        "fontSize",
        "fontStyle",
        "fontWeight",
        "fontStyle",
        "fontVariant",
        "textDecoration",
        "shadowColor",
        "shadowBlur",
        "shadowOffsetX",
        "shadowOffsetY",
        "shadowOpacity",
        // "leading",
        // "letterSpacing",
        "lineHeight",
        "baselineRatio",
        //"padding",
        // "stroke",
        // "strokeThickness",
        // "trim",
        // "wordWrap",
        "direction",
        "textBaseline",
        "oversizedBehavior",
        "breakWords",
        "ellipsis",
        "minScale",
        "populateText",
        "role",
        "ignoreFormatting",
        "maxChars"
      ]
    });
  }
  /**
   * @ignore Text is not to be used directly
   */
  get text() {
    return this._text;
  }
  _afterNew() {
    super._afterNew();
    this._makeText();
    each(this._textKeys, (property) => {
      const propValue = this.get(property);
      if (propValue != void 0) {
        this._text.set(property, propValue);
      }
    });
    if (this.get("html", "") !== "") {
      this._text.set("text", "");
    }
    this.onPrivate("maxWidth", () => {
      this._setMaxDimentions();
    });
    this.onPrivate("maxHeight", () => {
      this._setMaxDimentions();
    });
  }
  _makeText() {
    this._text = this.children.push(Text2.new(this._root, {}));
  }
  _updateChildren() {
    super._updateChildren();
    each(this._textKeys, (property) => {
      this._text.set(property, this.get(property));
    });
    if (this.isDirty("maxWidth")) {
      this._setMaxDimentions();
    }
    if (this.isDirty("maxHeight")) {
      this._setMaxDimentions();
    }
    if (this.isDirty("rotation")) {
      this._setMaxDimentions();
    }
    if (this.get("html", "") !== "") {
      this._text.set("text", "");
    } else {
      this._text.set("text", this.get("text"));
    }
    if (this.isDirty("textAlign") || this.isDirty("width")) {
      const textAlign = this.get("textAlign");
      let x2;
      if (this.get("width") != null) {
        if (textAlign == "right") {
          x2 = p100;
        } else if (textAlign == "center") {
          x2 = p50;
        } else {
          x2 = 0;
        }
      } else {
        if (textAlign == "left" || textAlign == "start") {
          x2 = this.get("paddingLeft");
        } else if (textAlign == "right" || textAlign == "end") {
          x2 = -this.get("paddingRight");
        }
      }
      this.text.set("x", x2);
    }
  }
  _setMaxDimentions() {
    const rotation = this.get("rotation");
    const vertical = rotation == 90 || rotation == 270 || rotation == -90;
    const maxWidth = this.get("maxWidth", this.getPrivate("maxWidth", Infinity));
    if (isNumber(maxWidth)) {
      this.text.set(vertical ? "maxHeight" : "maxWidth", maxWidth - this.get("paddingLeft", 0) - this.get("paddingRight", 0));
    } else {
      this.text.set(vertical ? "maxHeight" : "maxWidth", void 0);
    }
    const maxHeight = this.get("maxHeight", this.getPrivate("maxHeight", Infinity));
    if (isNumber(maxHeight)) {
      this.text.set(vertical ? "maxWidth" : "maxHeight", maxHeight - this.get("paddingTop", 0) - this.get("paddingBottom", 0));
    } else {
      this.text.set(vertical ? "maxWidth" : "maxHeight", void 0);
    }
  }
  _setDataItem(dataItem) {
    super._setDataItem(dataItem);
    this._markDirtyKey("text");
    if (this.text.get("populateText")) {
      this.text.markDirtyText();
    }
  }
  /**
   * Returns text with populated placeholders and formatting if `populateText` is
   * set to `true`.
   *
   * @return Populated text
   */
  getText() {
    return this._text._getText();
  }
};
Object.defineProperty(Label, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Label"
});
Object.defineProperty(Label, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Label.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/PointedRectangle.js
var PointedRectangle = class extends Graphics {
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("pointerBaseWidth") || this.isDirty("cornerRadius") || this.isDirty("pointerLength") || this.isDirty("pointerX") || this.isDirty("pointerY") || this.isDirty("width") || this.isDirty("height")) {
      this._clear = true;
    }
  }
  _changed() {
    super._changed();
    if (this._clear) {
      this.markDirtyBounds();
      let w = this.width();
      let h = this.height();
      if (w > 0 && h > 0) {
        let cr = this.get("cornerRadius", 8);
        cr = fitToRange(cr, 0, Math.min(w / 2, h / 2));
        let x2 = this.get("pointerX", 0);
        let y2 = this.get("pointerY", 0);
        let bwh = this.get("pointerBaseWidth", 15) / 2;
        let xtl = 0;
        let ytl = 0;
        let xtr = w;
        let ytr = 0;
        let xbr = w;
        let ybr = h;
        let xbl = 0;
        let ybl = h;
        let d1 = (x2 - xtl) * (ybr - ytl) - (y2 - ytl) * (xbr - xtl);
        let d2 = (x2 - xbl) * (ytr - ybl) - (y2 - ybl) * (xtr - xbl);
        const display = this._display;
        display.moveTo(cr, 0);
        if (d1 > 0 && d2 > 0) {
          let stemX = Math.round(fitToRange(x2, cr + bwh, w - bwh - cr));
          y2 = fitToRange(y2, -Infinity, 0);
          display.lineTo(stemX - bwh, 0);
          display.lineTo(x2, y2);
          display.lineTo(stemX + bwh, 0);
        }
        display.lineTo(w - cr, 0);
        display.arcTo(w, 0, w, cr, cr);
        if (d1 > 0 && d2 < 0) {
          let stemY = Math.round(fitToRange(y2, cr + bwh, h - bwh - cr));
          x2 = fitToRange(x2, w, Infinity);
          display.lineTo(w, cr);
          display.lineTo(w, Math.max(stemY - bwh, cr));
          display.lineTo(x2, y2);
          display.lineTo(w, stemY + bwh);
        }
        display.lineTo(w, h - cr);
        display.arcTo(w, h, w - cr, h, cr);
        if (d1 < 0 && d2 < 0) {
          let stemX = Math.round(fitToRange(x2, cr + bwh, w - bwh - cr));
          y2 = fitToRange(y2, h, Infinity);
          display.lineTo(w - cr, h);
          display.lineTo(stemX + bwh, h);
          display.lineTo(x2, y2);
          display.lineTo(stemX - bwh, h);
        }
        display.lineTo(cr, h);
        display.arcTo(0, h, 0, h - cr, cr);
        if (d1 < 0 && d2 > 0) {
          let stemY = Math.round(fitToRange(y2, cr + bwh, h - cr - bwh));
          x2 = fitToRange(x2, -Infinity, 0);
          display.lineTo(0, h - cr);
          display.lineTo(0, stemY + bwh);
          display.lineTo(x2, y2);
          display.lineTo(0, Math.max(stemY - bwh, cr));
        }
        display.lineTo(0, cr);
        display.arcTo(0, 0, cr, 0, cr);
        display.closePath();
      }
    }
  }
};
Object.defineProperty(PointedRectangle, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "PointedRectangle"
});
Object.defineProperty(PointedRectangle, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Graphics.classNames.concat([PointedRectangle.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Tooltip.js
var Tooltip4 = class extends Container {
  constructor(root, settings, isReal, templates = []) {
    super(root, settings, isReal, templates);
    Object.defineProperty(this, "_fx", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_fy", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_label", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_fillDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_strokeDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_labelDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_w", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_h", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_keepHoverDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_htmlContentHovered", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["tooltip"]);
    super._afterNew();
    this.set("background", PointedRectangle.new(this._root, {
      themeTags: ["tooltip", "background"]
    }));
    this._label = this.children.push(Label.new(this._root, {}));
    this._disposers.push(this._label.events.on("boundschanged", () => {
      this._updateBackground();
    }));
    this._disposers.push(this.on("bounds", () => {
      this._updateBackground();
    }));
    this._updateTextColor();
    this._root.tooltipContainer.children.push(this);
    this.hide(0);
    this._disposers.push(this.label.onPrivate("htmlElement", (htmlElement) => {
      if (htmlElement) {
        addEventListener(htmlElement, "pointerover", (_ev) => {
          this._htmlContentHovered = true;
        });
        addEventListener(htmlElement, "pointerout", (_ev) => {
          this._htmlContentHovered = false;
        });
      }
    }));
    this._root._tooltips.push(this);
  }
  /**
   * A [[Label]] element for the tooltip.
   *
   * @readonly
   * @return Label
   */
  get label() {
    return this._label;
  }
  /**
   * Permanently disposes the tooltip.
   */
  dispose() {
    super.dispose();
    remove(this._root._tooltips, this);
  }
  _updateChildren() {
    super._updateChildren();
    if (this.isDirty("pointerOrientation") || this.isPrivateDirty("minWidth") || this.isPrivateDirty("minHeight")) {
      this.get("background")._markDirtyKey("width");
    }
    const labelText = this.get("labelText");
    if (labelText != null) {
      this.label.set("text", this.get("labelText"));
    }
    const labelHTML = this.get("labelHTML");
    if (labelHTML != null) {
      this.label.set("html", this.get("labelHTML"));
    }
  }
  _changed() {
    super._changed();
    if (this.isDirty("pointTo") || this.isDirty("pointerOrientation")) {
      this._updateBackground();
    }
    if (this.isDirty("tooltipTarget")) {
      this.updateBackgroundColor();
    }
    if (this.isDirty("keepTargetHover")) {
      const keephover = this.get("keepTargetHover");
      if (keephover) {
        const bg = this.get("background");
        this._keepHoverDp = new MultiDisposer([
          bg.events.on("pointerover", (_ev) => {
            let target = this.get("tooltipTarget");
            if (target) {
              if (target.parent && target.parent.getPrivate("tooltipTarget") == target) {
                target = target.parent;
              }
              target.hover();
            }
          }),
          bg.events.on("pointerout", (_ev) => {
            let target = this.get("tooltipTarget");
            if (target) {
              if (target.parent && target.parent.getPrivate("tooltipTarget") == target) {
                target = target.parent;
              }
              if (!this._htmlContentHovered) {
                target.unhover();
              }
            }
          })
        ]);
        this.label.onPrivate("htmlElement", (htmlElement) => {
          if (this._keepHoverDp && htmlElement) {
            this._keepHoverDp.disposers.push(addEventListener(htmlElement, "pointerleave", (ev) => {
              const outEvent = this.root._renderer.getEvent(ev);
              bg.events.dispatch("pointerout", {
                type: "pointerout",
                originalEvent: outEvent.event,
                point: outEvent.point,
                simulated: false,
                target: bg
              });
            }));
          }
        });
      } else {
        if (this._keepHoverDp) {
          this._keepHoverDp.dispose();
          this._keepHoverDp = void 0;
        }
      }
    }
  }
  _onShow() {
    super._onShow();
    this.updateBackgroundColor();
  }
  updateBackgroundColor() {
    let tooltipTarget = this.get("tooltipTarget");
    const background = this.get("background");
    let fill;
    let stroke;
    if (tooltipTarget && background) {
      fill = tooltipTarget.get("fill");
      stroke = tooltipTarget.get("stroke");
      if (fill == null) {
        fill = stroke;
      }
      if (this.get("getFillFromSprite")) {
        if (this._fillDp) {
          this._fillDp.dispose();
        }
        if (fill != null) {
          background.set("fill", fill);
        }
        this._fillDp = tooltipTarget.on("fill", (fill2) => {
          if (fill2 != null) {
            background.set("fill", fill2);
            this._updateTextColor(fill2);
          }
        });
        this._disposers.push(this._fillDp);
      }
      if (this.get("getStrokeFromSprite")) {
        if (this._strokeDp) {
          this._strokeDp.dispose();
        }
        if (fill != null) {
          background.set("stroke", fill);
        }
        this._strokeDp = tooltipTarget.on("fill", (fill2) => {
          if (fill2 != null) {
            background.set("stroke", fill2);
          }
        });
        this._disposers.push(this._strokeDp);
      }
      if (this.get("getLabelFillFromSprite")) {
        if (this._labelDp) {
          this._labelDp.dispose();
        }
        if (fill != null) {
          this.label.set("fill", fill);
        }
        this._labelDp = tooltipTarget.on("fill", (fill2) => {
          if (fill2 != null) {
            this.label.set("fill", fill2);
          }
        });
        this._disposers.push(this._labelDp);
      }
    }
    this._updateTextColor(fill);
  }
  _updateTextColor(fill) {
    if (this.get("autoTextColor")) {
      if (fill == null) {
        fill = this.get("background").get("fill");
      }
      if (fill == null) {
        fill = this._root.interfaceColors.get("background");
      }
      if (fill instanceof Color) {
        this.label.set("fill", Color.alternative(fill, this._root.interfaceColors.get("alternativeText"), this._root.interfaceColors.get("text")));
      }
    }
  }
  _setDataItem(dataItem) {
    super._setDataItem(dataItem);
    this.label._setDataItem(dataItem);
  }
  _updateBackground() {
    super.updateBackground();
    const parent = this._root.container;
    if (parent) {
      let cw = 0.5;
      let ch = 0.5;
      let centerX = this.get("centerX");
      if (centerX instanceof Percent) {
        cw = centerX.value;
      }
      let centerY = this.get("centerY");
      if (centerY instanceof Percent) {
        ch = centerY.value;
      }
      let parentW = parent.width();
      let parentH = parent.height();
      let tooltipContainer = this.parent;
      let xx = 0;
      let yy = 0;
      if (tooltipContainer) {
        xx = tooltipContainer.x();
        yy = tooltipContainer.y();
        const layerMargin = tooltipContainer.get("layerMargin");
        if (layerMargin) {
          xx += layerMargin.left || 0;
          yy += layerMargin.top || 0;
          parentW += (layerMargin.left || 0) + (layerMargin.right || 0);
          parentH += (layerMargin.top || 0) + (layerMargin.bottom || 0);
        }
      }
      const bounds = this.get("bounds", { left: -xx, top: -yy, right: parentW - xx, bottom: parentH - yy });
      this._updateBounds();
      let w = this.width();
      let h = this.height();
      if (w === 0) {
        w = this._w;
      }
      if (h === 0) {
        h = this._h;
      }
      let pointTo = this.get("pointTo", { x: parentW / 2, y: parentH / 2 });
      let x2 = pointTo.x;
      let y2 = pointTo.y;
      let pointerOrientation = this.get("pointerOrientation");
      let background = this.get("background");
      let pointerLength = 0;
      let bgStrokeSizeY = 0;
      let bgStrokeSizeX = 0;
      if (background instanceof PointedRectangle) {
        pointerLength = background.get("pointerLength", 0);
        bgStrokeSizeY = background.get("strokeWidth", 0) / 2;
        bgStrokeSizeX = bgStrokeSizeY;
        background.set("width", w);
        background.set("height", h);
      }
      let pointerX = 0;
      let pointerY = 0;
      let boundsW = bounds.right - bounds.left;
      let boundsH = bounds.bottom - bounds.top;
      if (pointerOrientation == "horizontal" || pointerOrientation == "left" || pointerOrientation == "right") {
        bgStrokeSizeY = 0;
        if (pointerOrientation == "horizontal") {
          if (x2 > bounds.left + boundsW / 2) {
            x2 -= w * (1 - cw) + pointerLength;
            bgStrokeSizeX *= -1;
          } else {
            x2 += w * cw + pointerLength;
          }
        } else if (pointerOrientation == "left") {
          x2 += w * (1 - cw) + pointerLength;
        } else {
          x2 -= w * cw + pointerLength;
          bgStrokeSizeX *= -1;
        }
      } else {
        bgStrokeSizeX = 0;
        if (pointerOrientation == "vertical") {
          if (y2 > bounds.top + h / 2 + pointerLength) {
            y2 -= h * (1 - ch) + pointerLength;
          } else {
            y2 += h * ch + pointerLength;
            bgStrokeSizeY *= -1;
          }
        } else if (pointerOrientation == "down") {
          y2 -= h * (1 - ch) + pointerLength;
        } else {
          y2 += h * ch + pointerLength;
          bgStrokeSizeY *= -1;
        }
      }
      x2 = fitToRange(x2, bounds.left + w * cw, bounds.left + boundsW - w * (1 - cw)) + bgStrokeSizeX;
      y2 = fitToRange(y2, bounds.top + h * ch, bounds.top + boundsH - h * (1 - ch)) - bgStrokeSizeY;
      pointerX = pointTo.x - x2 + w * cw + bgStrokeSizeX;
      pointerY = pointTo.y - y2 + h * ch - bgStrokeSizeY;
      this._fx = x2;
      this._fy = y2;
      const animationDuration = this.get("animationDuration", 0);
      if (animationDuration > 0 && this.get("visible") && this.get("opacity") > 0.1) {
        const animationEasing = this.get("animationEasing");
        this.animate({ key: "x", to: x2, duration: animationDuration, easing: animationEasing });
        this.animate({ key: "y", to: y2, duration: animationDuration, easing: animationEasing });
      } else {
        this.set("x", x2);
        this.set("y", y2);
      }
      if (background instanceof PointedRectangle) {
        background.set("pointerX", pointerX);
        background.set("pointerY", pointerY);
      }
      if (w > 0) {
        this._w = w;
      }
      if (h > 0) {
        this._h = h;
      }
    }
  }
};
Object.defineProperty(Tooltip4, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Tooltip"
});
Object.defineProperty(Tooltip4, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Tooltip4.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/NumberFormatter.js
var NumberFormatter = class extends Entity2 {
  _setDefaults() {
    this._setDefault("negativeBase", 0);
    this._setDefault("numberFormat", "#,###.#####");
    this._setDefault("smallNumberThreshold", 1);
    const bns = "_big_number_suffix_";
    const sns = "_small_number_suffix_";
    const bs = "_byte_suffix_";
    this._setDefault("bigNumberPrefixes", [
      { "number": 1e3, "suffix": this._t(bns + "3") },
      { "number": 1e6, "suffix": this._t(bns + "6") },
      { "number": 1e9, "suffix": this._t(bns + "9") },
      { "number": 1e12, "suffix": this._t(bns + "12") },
      { "number": 1e15, "suffix": this._t(bns + "15") },
      { "number": 1e18, "suffix": this._t(bns + "18") },
      { "number": 1e21, "suffix": this._t(bns + "21") },
      { "number": 1e24, "suffix": this._t(bns + "24") }
    ]);
    this._setDefault("smallNumberPrefixes", [
      { "number": 1e-24, "suffix": this._t(sns + "24") },
      { "number": 1e-21, "suffix": this._t(sns + "21") },
      { "number": 1e-18, "suffix": this._t(sns + "18") },
      { "number": 1e-15, "suffix": this._t(sns + "15") },
      { "number": 1e-12, "suffix": this._t(sns + "12") },
      { "number": 1e-9, "suffix": this._t(sns + "9") },
      { "number": 1e-6, "suffix": this._t(sns + "6") },
      { "number": 1e-3, "suffix": this._t(sns + "3") }
    ]);
    this._setDefault("bytePrefixes", [
      { "number": 1, suffix: this._t(bs + "B") },
      { "number": 1024, suffix: this._t(bs + "KB") },
      { "number": 1048576, suffix: this._t(bs + "MB") },
      { "number": 1073741824, suffix: this._t(bs + "GB") },
      { "number": 1099511627776, suffix: this._t(bs + "TB") },
      { "number": 1125899906842624, suffix: this._t(bs + "PB") }
    ]);
    super._setDefaults();
  }
  _beforeChanged() {
    super._beforeChanged();
  }
  /**
   * Formats the number according to specific format.
   *
   * @param value   Value to format
   * @param format  Format to apply
   * @return Formatted number
   */
  format(value, format2, precision) {
    if (format2 == null || isString2(format2) && format2.toLowerCase() === "number") {
      format2 = this.get("numberFormat", "");
    }
    let formatted;
    let source = Number(value);
    if (isObject2(format2)) {
      try {
        if (this.get("intlLocales")) {
          return new Intl.NumberFormat(this.get("intlLocales"), format2).format(source);
        } else {
          return new Intl.NumberFormat(void 0, format2).format(source);
        }
      } catch (e) {
        return "Invalid";
      }
    } else {
      format2 = cleanFormat(format2);
      let info = this.parseFormat(format2, this._root.language);
      let details;
      if (source > this.get("negativeBase")) {
        details = info.positive;
      } else if (source < this.get("negativeBase")) {
        details = info.negative;
      } else {
        details = info.zero;
      }
      if (precision != null && !details.mod) {
        details = copy3(details);
        details.decimals.active = source == 0 ? 0 : precision;
      }
      formatted = details.template.split(PLACEHOLDER).join(this.applyFormat(source, details));
    }
    if (this.get("forceLTR") === true) {
      formatted = "\u200E" + formatted;
    }
    return formatted;
  }
  /**
   * Parses supplied format into structured object which can be used to format
   * the number.
   *
   * @param format Format string, i.e. "#,###.00"
   * @param language Language
   * @ignore
   */
  parseFormat(format2, language) {
    const thousandSeparator = language.translateEmpty("_thousandSeparator");
    const decimalSeparator = language.translateEmpty("_decimalSeparator");
    let info = {
      "positive": {
        "thousands": {
          "active": -1,
          "passive": -1,
          "interval": -1,
          "separator": thousandSeparator
        },
        "decimals": {
          "active": -1,
          "passive": -1,
          "separator": decimalSeparator
        },
        "template": "",
        "source": "",
        "parsed": false
      },
      "negative": {
        "thousands": {
          "active": -1,
          "passive": -1,
          "interval": -1,
          "separator": thousandSeparator
        },
        "decimals": {
          "active": -1,
          "passive": -1,
          "separator": decimalSeparator
        },
        "template": "",
        "source": "",
        "parsed": false
      },
      "zero": {
        "thousands": {
          "active": -1,
          "passive": -1,
          "interval": -1,
          "separator": thousandSeparator
        },
        "decimals": {
          "active": -1,
          "passive": -1,
          "separator": decimalSeparator
        },
        "template": "",
        "source": "",
        "parsed": false
      }
    };
    format2 = format2.replace("||", PLACEHOLDER2);
    let parts = format2.split("|");
    info.positive.source = parts[0];
    if (typeof parts[2] === "undefined") {
      info.zero = info.positive;
    } else {
      info.zero.source = parts[2];
    }
    if (typeof parts[1] === "undefined") {
      info.negative = info.positive;
    } else {
      info.negative.source = parts[1];
    }
    each2(info, (_part, item) => {
      if (item.parsed) {
        return;
      }
      let partFormat = item.source;
      if (partFormat.toLowerCase() === "number") {
        partFormat = this.get("numberFormat", "#,###.#####");
      }
      let chunks = TextFormatter.chunk(partFormat, true);
      for (let i = 0; i < chunks.length; i++) {
        let chunk = chunks[i];
        chunk.text = chunk.text.replace(PLACEHOLDER2, "|");
        if (chunk.type === "value") {
          let matches = chunk.text.match(/[#0.,]+[ ]?[abespABESP%!]?[abespABESP‰!]?/);
          if (matches) {
            if (matches === null || matches[0] === "") {
              item.template += chunk.text;
            } else {
              let mods = matches[0].match(/[abespABESP%‰!]{2}|[abespABESP%‰]{1}$/);
              if (mods) {
                item.mod = mods[0].toLowerCase();
                item.modSpacing = matches[0].match(/[ ]{1}[abespABESP%‰!]{1}$/) ? true : false;
              }
              let a = matches[0].split(".");
              if (a[0] === "") {
              } else {
                item.thousands.active = (a[0].match(/0/g) || []).length;
                item.thousands.passive = (a[0].match(/\#/g) || []).length + item.thousands.active;
                let b = a[0].split(",");
                if (b.length === 1) {
                } else {
                  item.thousands.interval = (b.pop() || "").length;
                  if (item.thousands.interval === 0) {
                    item.thousands.interval = -1;
                  }
                }
              }
              if (typeof a[1] === "undefined") {
              } else {
                item.decimals.active = (a[1].match(/0/g) || []).length;
                item.decimals.passive = (a[1].match(/\#/g) || []).length + item.decimals.active;
              }
              item.template += chunk.text.split(matches[0]).join(PLACEHOLDER);
            }
          }
        } else {
          item.template += chunk.text;
        }
      }
      item.parsed = true;
    });
    return info;
  }
  /**
   * Applies parsed format to a numeric value.
   *
   * @param value    Value
   * @param details  Parsed format as returned by parseFormat()
   * @return Formatted number
   * @ignore
   */
  applyFormat(value, details) {
    let negative = value < 0;
    value = Math.abs(value);
    let prefix = "", suffix = "";
    let mods = details.mod ? details.mod.split("") : [];
    if (mods.indexOf("b") !== -1) {
      let a2 = this.applyPrefix(value, this.get("bytePrefixes"), mods.indexOf("!") !== -1);
      value = a2[0];
      prefix = a2[1];
      suffix = a2[2];
      if (details.modSpacing) {
        suffix = " " + suffix;
      }
    } else if (mods.indexOf("a") !== -1) {
      let a2 = this.applyPrefix(value, value < this.get("smallNumberThreshold") ? this.get("smallNumberPrefixes") : this.get("bigNumberPrefixes"), mods.indexOf("!") !== -1);
      value = a2[0];
      prefix = a2[1];
      suffix = a2[2];
      if (details.modSpacing) {
        suffix = " " + suffix;
      }
    } else if (mods.indexOf("p") !== -1) {
      let ol = Math.min(value.toString().length + 2, 21);
      value = parseFloat(value.toPrecision(ol));
      prefix = this._root.language.translate("_percentPrefix");
      suffix = this._root.language.translate("_percentSuffix");
      if (prefix == "" && suffix == "") {
        suffix = "%";
      }
    } else if (mods.indexOf("%") !== -1) {
      let ol = Math.min(value.toString().length + 2, 21);
      value *= 100;
      value = parseFloat(value.toPrecision(ol));
      suffix = "%";
    } else if (mods.indexOf("\u2030") !== -1) {
      let ol = Math.min(value.toString().length + 3, 21);
      value *= 1e3;
      value = parseFloat(value.toPrecision(ol));
      suffix = "\u2030";
    }
    if (mods.indexOf("e") !== -1) {
      let exp;
      if (details.decimals.passive >= 0) {
        exp = value.toExponential(details.decimals.passive).split("e");
      } else {
        exp = value.toExponential().split("e");
      }
      value = Number(exp[0]);
      suffix = "e" + exp[1];
      if (details.modSpacing) {
        suffix = " " + suffix;
      }
    } else if (details.decimals.passive === 0) {
      value = Math.round(value);
    } else if (details.decimals.passive > 0) {
      let d = Math.pow(10, details.decimals.passive);
      value = Math.round(value * d) / d;
    }
    let res = "";
    let a = numberToString(value).split(".");
    let ints = a[0];
    if (ints.length < details.thousands.active) {
      ints = Array(details.thousands.active - ints.length + 1).join("0") + ints;
    }
    if (details.thousands.interval > 0) {
      let ip = [];
      let intsr = ints.split("").reverse().join("");
      for (let i = 0, len = ints.length; i <= len; i += details.thousands.interval) {
        let c = intsr.substr(i, details.thousands.interval).split("").reverse().join("");
        if (c !== "") {
          ip.unshift(c);
        }
      }
      ints = ip.join(details.thousands.separator);
    }
    res += ints;
    if (a.length === 1) {
      a.push("");
    }
    let decs = a[1];
    if (decs.length < details.decimals.active) {
      decs += Array(details.decimals.active - decs.length + 1).join("0");
    }
    if (decs !== "") {
      res += details.decimals.separator + decs;
    }
    if (res === "") {
      res = "0";
    }
    if (value !== 0 && negative && mods.indexOf("s") === -1) {
      res = "-" + res;
    }
    if (prefix) {
      res = prefix + res;
    }
    if (suffix) {
      res += suffix;
    }
    return res;
  }
  applyPrefix(value, prefixes, force = false) {
    let newvalue = value;
    let prefix = "";
    let suffix = "";
    let applied = false;
    let k = 1;
    for (let i = 0, len = prefixes.length; i < len; i++) {
      if (prefixes[i].number <= value) {
        if (prefixes[i].number === 0) {
          newvalue = 0;
        } else {
          newvalue = value / prefixes[i].number;
          k = prefixes[i].number;
        }
        prefix = prefixes[i].prefix;
        suffix = prefixes[i].suffix;
        applied = true;
      }
    }
    if (!applied && force && prefixes.length && value != 0) {
      newvalue = value / prefixes[0].number;
      prefix = prefixes[0].prefix;
      suffix = prefixes[0].suffix;
      applied = true;
    }
    if (applied) {
      newvalue = parseFloat(newvalue.toPrecision(Math.min(k.toString().length + Math.floor(newvalue).toString().replace(/[^0-9]*/g, "").length, 21)));
    }
    return [newvalue, prefix, suffix];
  }
  /**
   * Replaces brackets with temporary placeholders.
   *
   * @ignore Exclude from docs
   * @param text  Input text
   * @return Escaped text
   */
  escape(text) {
    return text.replace("||", PLACEHOLDER2);
  }
  /**
   * Replaces placeholders back to brackets.
   *
   * @ignore Exclude from docs
   * @param text  Escaped text
   * @return Unescaped text
   */
  unescape(text) {
    return text.replace(PLACEHOLDER2, "|");
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Timezone.js
function parseDate(timezone, date4) {
  let year = 0;
  let month = 0;
  let day = 1;
  let hour = 0;
  let minute = 0;
  let second = 0;
  let millisecond = 0;
  let weekday = 0;
  timezone.formatToParts(date4).forEach((x2) => {
    switch (x2.type) {
      case "year":
        year = +x2.value;
        break;
      case "month":
        month = +x2.value - 1;
        break;
      case "day":
        day = +x2.value;
        break;
      case "hour":
        hour = +x2.value;
        break;
      case "minute":
        minute = +x2.value;
        break;
      case "second":
        second = +x2.value;
        break;
      case "fractionalSecond":
        millisecond = +x2.value;
        break;
      case "weekday":
        switch (x2.value) {
          case "Sun":
            weekday = 0;
            break;
          case "Mon":
            weekday = 1;
            break;
          case "Tue":
            weekday = 2;
            break;
          case "Wed":
            weekday = 3;
            break;
          case "Thu":
            weekday = 4;
            break;
          case "Fri":
            weekday = 5;
            break;
          case "Sat":
            weekday = 6;
            break;
        }
    }
  });
  if (hour === 24) {
    hour = 0;
  }
  return { year, month, day, hour, minute, second, millisecond, weekday };
}
function toUTCDate(timezone, date4) {
  const { year, month, day, hour, minute, second, millisecond } = parseDate(timezone, date4);
  return Date.UTC(year, month, day, hour, minute, second, millisecond);
}
var Timezone = class {
  constructor(timezone, isReal) {
    Object.defineProperty(this, "_utc", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_dtf", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "name", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    if (!isReal) {
      throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
    }
    this.name = timezone;
    this._utc = new Intl.DateTimeFormat("UTC", {
      hour12: false,
      timeZone: "UTC",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      weekday: "short",
      fractionalSecondDigits: 3
    });
    this._dtf = new Intl.DateTimeFormat("UTC", {
      hour12: false,
      timeZone: timezone,
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      weekday: "short",
      fractionalSecondDigits: 3
    });
  }
  /**
   * Use this method to create an instance of this class.
   *
   * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
   * @param   timezone  IANA timezone
   * @return            Instantiated object
   */
  static new(timezone) {
    return new this(timezone, true);
  }
  convertLocal(date4) {
    const offset2 = this.offsetUTC(date4);
    const userOffset = date4.getTimezoneOffset();
    const output = new Date(date4);
    output.setUTCMinutes(output.getUTCMinutes() - (offset2 - userOffset));
    const newUserOffset = output.getTimezoneOffset();
    if (userOffset != newUserOffset) {
      output.setUTCMinutes(output.getUTCMinutes() + newUserOffset - userOffset);
    }
    return output;
  }
  offsetUTC(date4) {
    const utc = toUTCDate(this._utc, date4);
    const dtf = toUTCDate(this._dtf, date4);
    return (utc - dtf) / 6e4;
  }
  parseDate(date4) {
    return parseDate(this._dtf, date4);
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/DateFormatter.js
var DateFormatter = class extends Entity2 {
  _setDefaults() {
    this._setDefault("capitalize", true);
    this._setDefault("dateFormat", "yyyy-MM-dd");
    super._setDefaults();
  }
  _beforeChanged() {
    super._beforeChanged();
  }
  format(source, format2) {
    if (typeof format2 === "undefined" || format2 === "") {
      format2 = this.get("dateFormat", "yyyy-MM-dd");
    }
    let formatted;
    let date4 = source;
    if (isObject2(format2)) {
      try {
        const locales = this.get("intlLocales");
        if (locales) {
          return new Intl.DateTimeFormat(locales, format2).format(date4);
        } else {
          return new Intl.DateTimeFormat(void 0, format2).format(date4);
        }
      } catch (e) {
        return "Invalid";
      }
    }
    let info = this.parseFormat(format2);
    const timezone = this._root.timezone;
    if (timezone && !this._root.utc) {
      date4 = timezone.convertLocal(date4);
    }
    if (!isNumber(date4.getTime())) {
      return "Invalid date";
    }
    formatted = this.applyFormat(date4, info);
    if (this.get("capitalize")) {
      formatted = formatted.replace(/^.{1}/, formatted.substr(0, 1).toUpperCase());
    }
    return formatted;
  }
  /**
   * Applies format to Date.
   *
   * @param date      Date object
   * @param info      Parsed format information
   * @return Formatted date string
   */
  applyFormat(date4, info) {
    let res = info.template;
    let fullYear, month, weekday, day, hours, minutes, seconds, milliseconds, timestamp = date4.getTime();
    if (this._root.utc) {
      fullYear = date4.getUTCFullYear();
      month = date4.getUTCMonth();
      weekday = date4.getUTCDay();
      day = date4.getUTCDate();
      hours = date4.getUTCHours();
      minutes = date4.getUTCMinutes();
      seconds = date4.getUTCSeconds();
      milliseconds = date4.getUTCMilliseconds();
    } else {
      fullYear = date4.getFullYear();
      month = date4.getMonth();
      weekday = date4.getDay();
      day = date4.getDate();
      hours = date4.getHours();
      minutes = date4.getMinutes();
      seconds = date4.getSeconds();
      milliseconds = date4.getMilliseconds();
    }
    for (let i = 0, len = info.parts.length; i < len; i++) {
      let value = "";
      switch (info.parts[i]) {
        case "G":
          value = this._t(fullYear < 0 ? "_era_bc" : "_era_ad");
          break;
        case "yyyy":
          value = Math.abs(fullYear).toString();
          if (fullYear < 0) {
            value += this._t("_era_bc");
          }
          break;
        case "yyy":
        case "yy":
        case "y":
          value = Math.abs(fullYear).toString().substr(-info.parts[i].length);
          if (fullYear < 0) {
            value += this._t("_era_bc");
          }
          break;
        case "YYYY":
        case "YYY":
        case "YY":
        case "Y":
          let year = getWeekYear(date4, this._root.utc);
          if (info.parts[i] == "YYYY") {
            value = Math.abs(year).toString();
          } else {
            value = Math.abs(year).toString().substr(-info.parts[i].length);
          }
          if (year < 0) {
            value += this._t("_era_bc");
          }
          break;
        case "u":
          break;
        case "q":
          value = "" + Math.ceil((date4.getMonth() + 1) / 3);
          break;
        case "MMMMM":
          value = this._t(this._getMonth(month)).substr(0, 1);
          break;
        case "MMMM":
          value = this._t(this._getMonth(month));
          break;
        case "MMM":
          value = this._t(this._getShortMonth(month));
          break;
        case "MM":
          value = padString(month + 1, 2, "0");
          break;
        case "M":
          value = (month + 1).toString();
          break;
        case "ww":
          value = padString(getWeek(date4, this._root.utc), 2, "0");
          break;
        case "w":
          value = getWeek(date4, this._root.utc).toString();
          break;
        case "W":
          value = getMonthWeek(date4, this._root.utc).toString();
          break;
        case "dd":
          value = padString(day, 2, "0");
          break;
        case "d":
          value = day.toString();
          break;
        case "DD":
        case "DDD":
          value = padString(getYearDay(date4, this._root.utc).toString(), info.parts[i].length, "0");
          break;
        case "D":
          value = getYearDay(date4, this._root.utc).toString();
          break;
        case "F":
          break;
        case "g":
          break;
        case "t":
          value = this._root.language.translateFunc("_dateOrd").call(this, day);
          break;
        case "E":
          value = (weekday || 7).toString();
          break;
        case "EE":
          value = padString((weekday || 7).toString(), 2, "0");
          break;
        case "EEE":
        case "eee":
          value = this._t(this._getShortWeekday(weekday));
          break;
        case "EEEE":
        case "eeee":
          value = this._t(this._getWeekday(weekday));
          break;
        case "EEEEE":
        case "eeeee":
          value = this._t(this._getShortWeekday(weekday)).substr(0, 1);
          break;
        case "e":
        case "ee":
          value = (weekday - (this._root.locale.firstDayOfWeek || 1) + 1).toString();
          if (info.parts[i] == "ee") {
            value = padString(value, 2, "0");
          }
          break;
        case "a":
          if (hours >= 12) {
            value = this._t("PM");
          } else {
            value = this._t("AM");
          }
          break;
        case "aa":
          if (hours >= 12) {
            value = this._t("P.M.");
          } else {
            value = this._t("A.M.");
          }
          break;
        case "aaa":
          if (hours >= 12) {
            value = this._t("P");
          } else {
            value = this._t("A");
          }
          break;
        case "h":
          value = get12Hours(hours).toString();
          break;
        case "hh":
          value = padString(get12Hours(hours), 2, "0");
          break;
        case "H":
          value = hours.toString();
          break;
        case "HH":
          value = padString(hours, 2, "0");
          break;
        case "K":
          value = get12Hours(hours, 0).toString();
          break;
        case "KK":
          value = padString(get12Hours(hours, 0), 2, "0");
          break;
        case "k":
          value = (hours + 1).toString();
          break;
        case "kk":
          value = padString(hours + 1, 2, "0");
          break;
        case "m":
          value = minutes.toString();
          break;
        case "mm":
          value = padString(minutes, 2, "0");
          break;
        case "s":
          value = seconds.toString();
          break;
        case "ss":
          value = padString(seconds, 2, "0");
          break;
        case "S":
        case "SS":
        case "SSS":
          value = Math.round(milliseconds / 1e3 * Math.pow(10, info.parts[i].length)).toString();
          break;
        case "x":
          value = timestamp.toString();
          break;
        case "n":
        case "nn":
        case "nnn":
          value = padString(milliseconds, info.parts[i].length, "0");
          break;
        case "z":
          value = getTimeZone(date4, false, false, this._root.utc, this._root.timezone ? this._root.timezone.name : void 0).replace(/[+-]+[0-9]+$/, "");
          break;
        case "zz":
          value = getTimeZone(date4, true, false, this._root.utc, this._root.timezone ? this._root.timezone.name : void 0);
          break;
        case "zzz":
          value = getTimeZone(date4, false, true, this._root.utc, this._root.timezone ? this._root.timezone.name : void 0).replace(/[+-]+[0-9]+$/, "");
          break;
        case "zzzz":
          value = getTimeZone(date4, true, true, this._root.utc, this._root.timezone ? this._root.timezone.name : void 0);
          break;
        case "Z":
        case "ZZ":
          let timezone = this._root.utc ? "UTC" : this._root.timezone;
          if (timezone instanceof Timezone) {
            timezone = timezone.name;
          }
          const offset2 = timezone ? getTimezoneOffset(timezone) : date4.getTimezoneOffset();
          let tz = Math.abs(offset2) / 60;
          let tzh = Math.floor(tz);
          let tzm = tz * 60 - tzh * 60;
          if (this._root.utc) {
            tzh = 0;
            tzm = 0;
          }
          if (info.parts[i] == "Z") {
            value = "GMT";
            value += offset2 > 0 ? "-" : "+";
            value += padString(tzh, 2) + ":" + padString(tzm, 2);
          } else {
            value = offset2 > 0 ? "-" : "+";
            value += padString(tzh, 2) + padString(tzm, 2);
          }
          break;
        case "i":
          value = date4.toISOString();
          break;
        case "I":
          value = date4.toUTCString();
          break;
      }
      res = res.replace(PLACEHOLDER, value);
    }
    return res;
  }
  /**
   * Parses format into structured infromation.
   *
   * @param format Format template
   */
  parseFormat(format2) {
    let info = {
      "template": "",
      "parts": []
    };
    let chunks = TextFormatter.chunk(format2, true);
    for (let i = 0; i < chunks.length; i++) {
      let chunk = chunks[i];
      if (chunk.type === "value") {
        if (chunk.text.match(/^date$/i)) {
          let dateFormat = this.get("dateFormat", "yyyy-MM-dd");
          if (!isString2(dateFormat)) {
            dateFormat = "yyyy-MM-dd";
          }
          chunk.text = dateFormat;
        }
        let matches = chunk.text.match(/G|yyyy|yyy|yy|y|YYYY|YYY|YY|Y|u|q|MMMMM|MMMM|MMM|MM|M|ww|w|W|dd|d|DDD|DD|D|F|g|EEEEE|EEEE|EEE|EE|E|eeeee|eeee|eee|ee|e|aaa|aa|a|hh|h|HH|H|KK|K|kk|k|mm|m|ss|s|SSS|SS|S|A|zzzz|zzz|zz|z|ZZ|Z|t|x|nnn|nn|n|i|I/g);
        if (matches) {
          for (let x2 = 0; x2 < matches.length; x2++) {
            info.parts.push(matches[x2]);
            chunk.text = chunk.text.replace(matches[x2], PLACEHOLDER);
          }
        }
      }
      info.template += chunk.text;
    }
    return info;
  }
  _months() {
    return ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  }
  _getMonth(index2) {
    return this._months()[index2];
  }
  _shortMonths() {
    return ["Jan", "Feb", "Mar", "Apr", "May(short)", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
  }
  _getShortMonth(index2) {
    return this._shortMonths()[index2];
  }
  _weekdays() {
    return ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
  }
  _getWeekday(index2) {
    return this._weekdays()[index2];
  }
  _shortWeekdays() {
    return ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  }
  _getShortWeekday(index2) {
    return this._shortWeekdays()[index2];
  }
  parse(source, format2) {
    if (source instanceof Date) {
      return source;
    }
    if (isNumber(source)) {
      return new Date(source);
    }
    if (format2 == "x") {
      return new Date(parseInt(source));
    }
    if (!isString2(source)) {
      source = source.toString();
    }
    let res;
    let reg = "";
    format2 = cleanFormat(format2);
    format2 = format2.substr(0, source.length);
    let info = this.parseFormat(format2);
    let parsedIndexes = {
      "year": -1,
      "year3": -1,
      "year2": -1,
      "year1": -1,
      "month": -1,
      "monthShort": -1,
      "monthLong": -1,
      "weekdayShort": -1,
      "weekdayLong": -1,
      "day": -1,
      "yearDay": -1,
      "week": -1,
      "hourBase0": -1,
      "hour12Base0": -1,
      "hourBase1": -1,
      "hour12Base1": -1,
      "minute": -1,
      "second": -1,
      "millisecond": -1,
      "millisecondDigits": -1,
      "am": -1,
      "zone": -1,
      "timestamp": -1,
      "iso": -1
    };
    let resValues = {
      "year": 1970,
      "month": 0,
      "day": 1,
      "hour": 0,
      "minute": 0,
      "second": 0,
      "millisecond": 0,
      "timestamp": null,
      "offset": 0,
      "utc": this._root.utc
    };
    let indexAdjust = 0;
    let index2 = 0;
    for (let i = 0; i < info.parts.length; i++) {
      index2 = i + indexAdjust + 1;
      switch (info.parts[i]) {
        case "yyyy":
        case "YYYY":
          reg += "([0-9]{4})";
          parsedIndexes.year = index2;
          break;
        case "yyy":
        case "YYY":
          reg += "([0-9]{3})";
          parsedIndexes.year3 = index2;
          break;
        case "yy":
        case "YY":
          reg += "([0-9]{2})";
          parsedIndexes.year2 = index2;
          break;
        case "y":
        case "Y":
          reg += "([0-9]{1})";
          parsedIndexes.year1 = index2;
          break;
        case "MMMM":
          reg += "(" + this.getStringList(this._months()).join("|") + ")";
          parsedIndexes.monthLong = index2;
          break;
        case "MMM":
          reg += "(" + this.getStringList(this._shortMonths()).join("|") + ")";
          parsedIndexes.monthShort = index2;
          break;
        case "MM":
        case "M":
          reg += "([0-9]{2}|[0-9]{1})";
          parsedIndexes.month = index2;
          break;
        case "ww":
        case "w":
          reg += "([0-9]{2}|[0-9]{1})";
          parsedIndexes.week = index2;
          break;
        case "dd":
        case "d":
          reg += "([0-9]{2}|[0-9]{1})";
          parsedIndexes.day = index2;
          break;
        case "DDD":
        case "DD":
        case "D":
          reg += "([0-9]{3}|[0-9]{2}|[0-9]{1})";
          parsedIndexes.yearDay = index2;
          break;
        case "dddd":
          reg += "(" + this.getStringList(this._weekdays()).join("|") + ")";
          parsedIndexes.weekdayLong = index2;
          break;
        case "ddd":
          reg += "(" + this.getStringList(this._shortWeekdays()).join("|") + ")";
          parsedIndexes.weekdayShort = index2;
          break;
        case "aaa":
        case "aa":
        case "a":
          reg += "(" + this.getStringList(["AM", "PM", "A.M.", "P.M.", "A", "P"]).join("|") + ")";
          parsedIndexes.am = index2;
          break;
        case "hh":
        case "h":
          reg += "([0-9]{2}|[0-9]{1})";
          parsedIndexes.hour12Base1 = index2;
          break;
        case "HH":
        case "H":
          reg += "([0-9]{2}|[0-9]{1})";
          parsedIndexes.hourBase0 = index2;
          break;
        case "KK":
        case "K":
          reg += "([0-9]{2}|[0-9]{1})";
          parsedIndexes.hour12Base0 = index2;
          break;
        case "kk":
        case "k":
          reg += "([0-9]{2}|[0-9]{1})";
          parsedIndexes.hourBase1 = index2;
          break;
        case "mm":
        case "m":
          reg += "([0-9]{2}|[0-9]{1})";
          parsedIndexes.minute = index2;
          break;
        case "ss":
        case "s":
          reg += "([0-9]{2}|[0-9]{1})";
          parsedIndexes.second = index2;
          break;
        case "SSS":
        case "SS":
        case "S":
          reg += "([0-9]{3}|[0-9]{2}|[0-9]{1})";
          parsedIndexes.millisecond = index2;
          parsedIndexes.millisecondDigits = info.parts[i].length;
          break;
        case "nnn":
        case "nn":
        case "n":
          reg += "([0-9]{3}|[0-9]{2}|[0-9]{1})";
          parsedIndexes.millisecond = index2;
          break;
        case "x":
          reg += "([0-9]{1,})";
          parsedIndexes.timestamp = index2;
          break;
        case "Z":
          reg += "GMT([-+]+[0-9]{2}:[0-9]{2})";
          parsedIndexes.zone = index2;
          break;
        case "ZZ":
          reg += "([\\-+]+[0-9]{2}[0-9]{2})";
          parsedIndexes.zone = index2;
          break;
        case "i":
          reg += "([0-9]{4})-?([0-9]{2})-?([0-9]{2})T?([0-9]{2}):?([0-9]{2}):?([0-9]{2})\\.?([0-9]{0,3})([zZ]|[+\\-][0-9]{2}:?[0-9]{2}|$)";
          parsedIndexes.iso = index2;
          indexAdjust += 7;
          break;
        case "G":
        case "YYYY":
        case "YYY":
        case "YY":
        case "Y":
        case "MMMMM":
        case "W":
        case "EEEEE":
        case "EEEE":
        case "EEE":
        case "EE":
        case "E":
        case "eeeee":
        case "eeee":
        case "eee":
        case "ee":
        case "e":
        case "zzzz":
        case "zzz":
        case "zz":
        case "z":
        case "t":
          indexAdjust--;
          break;
      }
      reg += "[^0-9]*";
    }
    let regex = new RegExp(reg);
    let matches = source.match(regex);
    if (matches) {
      if (parsedIndexes.year > -1) {
        resValues.year = parseInt(matches[parsedIndexes.year]);
      }
      if (parsedIndexes.year3 > -1) {
        let val = parseInt(matches[parsedIndexes.year3]);
        val += 1e3;
        resValues.year = val;
      }
      if (parsedIndexes.year2 > -1) {
        let val = parseInt(matches[parsedIndexes.year2]);
        if (val > 50) {
          val += 1e3;
        } else {
          val += 2e3;
        }
        resValues.year = val;
      }
      if (parsedIndexes.year1 > -1) {
        let val = parseInt(matches[parsedIndexes.year1]);
        val = Math.floor((/* @__PURE__ */ new Date()).getFullYear() / 10) * 10 + val;
        resValues.year = val;
      }
      if (parsedIndexes.monthLong > -1) {
        resValues.month = this.resolveMonth(matches[parsedIndexes.monthLong]);
      }
      if (parsedIndexes.monthShort > -1) {
        resValues.month = this.resolveShortMonth(matches[parsedIndexes.monthShort]);
      }
      if (parsedIndexes.month > -1) {
        resValues.month = parseInt(matches[parsedIndexes.month]) - 1;
      }
      if (parsedIndexes.week > -1 && parsedIndexes.day === -1) {
        resValues.month = 0;
        resValues.day = getDayFromWeek(parseInt(matches[parsedIndexes.week]), resValues.year, 1, this._root.utc);
      }
      if (parsedIndexes.day > -1) {
        resValues.day = parseInt(matches[parsedIndexes.day]);
      }
      if (parsedIndexes.yearDay > -1) {
        resValues.month = 0;
        resValues.day = parseInt(matches[parsedIndexes.yearDay]);
      }
      if (parsedIndexes.hourBase0 > -1) {
        resValues.hour = parseInt(matches[parsedIndexes.hourBase0]);
      }
      if (parsedIndexes.hourBase1 > -1) {
        resValues.hour = parseInt(matches[parsedIndexes.hourBase1]) - 1;
      }
      if (parsedIndexes.hour12Base0 > -1) {
        let val = parseInt(matches[parsedIndexes.hour12Base0]);
        if (val == 11) {
          val = 0;
        }
        if (parsedIndexes.am > -1 && !this.isAm(matches[parsedIndexes.am])) {
          val += 12;
        }
        resValues.hour = val;
      }
      if (parsedIndexes.hour12Base1 > -1) {
        let val = parseInt(matches[parsedIndexes.hour12Base1]);
        if (val == 12) {
          val = 0;
        }
        if (parsedIndexes.am > -1 && !this.isAm(matches[parsedIndexes.am])) {
          val += 12;
        }
        resValues.hour = val;
      }
      if (parsedIndexes.minute > -1) {
        resValues.minute = parseInt(matches[parsedIndexes.minute]);
      }
      if (parsedIndexes.second > -1) {
        resValues.second = parseInt(matches[parsedIndexes.second]);
      }
      if (parsedIndexes.millisecond > -1) {
        let val = parseInt(matches[parsedIndexes.millisecond]);
        if (parsedIndexes.millisecondDigits == 2) {
          val *= 10;
        } else if (parsedIndexes.millisecondDigits == 1) {
          val *= 100;
        }
        resValues.millisecond = val;
      }
      if (parsedIndexes.timestamp > -1) {
        resValues.timestamp = parseInt(matches[parsedIndexes.timestamp]);
        const ts = new Date(resValues.timestamp);
        resValues.year = ts.getUTCFullYear();
        resValues.month = ts.getUTCMonth();
        resValues.day = ts.getUTCDate();
        resValues.hour = ts.getUTCHours();
        resValues.minute = ts.getUTCMinutes();
        resValues.second = ts.getUTCSeconds();
        resValues.millisecond = ts.getUTCMilliseconds();
      }
      if (parsedIndexes.zone > -1) {
        resValues.offset = this.resolveTimezoneOffset(new Date(resValues.year, resValues.month, resValues.day), matches[parsedIndexes.zone]);
      }
      if (parsedIndexes.iso > -1) {
        resValues.year = toNumber(matches[parsedIndexes.iso + 0]);
        resValues.month = toNumber(matches[parsedIndexes.iso + 1]) - 1;
        resValues.day = toNumber(matches[parsedIndexes.iso + 2]);
        resValues.hour = toNumber(matches[parsedIndexes.iso + 3]);
        resValues.minute = toNumber(matches[parsedIndexes.iso + 4]);
        resValues.second = toNumber(matches[parsedIndexes.iso + 5]);
        resValues.millisecond = toNumber(matches[parsedIndexes.iso + 6]);
        if (matches[parsedIndexes.iso + 7] == "Z" || matches[parsedIndexes.iso + 7] == "z") {
          resValues.utc = true;
        } else if (matches[parsedIndexes.iso + 7] != "") {
          resValues.offset = this.resolveTimezoneOffset(new Date(resValues.year, resValues.month, resValues.day), matches[parsedIndexes.iso + 7]);
        }
      }
      if (resValues.utc) {
        res = new Date(Date.UTC(resValues.year, resValues.month, resValues.day, resValues.hour, resValues.minute, resValues.second, resValues.millisecond));
      } else {
        res = new Date(resValues.year, resValues.month, resValues.day, resValues.hour, resValues.minute + resValues.offset, resValues.second, resValues.millisecond);
      }
    } else {
      res = new Date(source);
    }
    return res;
  }
  resolveTimezoneOffset(date4, zone) {
    let value = zone.match(/([+\-]?)([0-9]{2}):?([0-9]{2})/);
    if (value) {
      let match2 = zone.match(/([+\-]?)([0-9]{2}):?([0-9]{2})/);
      let dir = match2[1];
      let hour = match2[2];
      let minute = match2[3];
      let offset2 = parseInt(hour) * 60 + parseInt(minute);
      if (dir == "+") {
        offset2 *= -1;
      }
      let originalOffset = (date4 || /* @__PURE__ */ new Date()).getTimezoneOffset();
      let diff = offset2 - originalOffset;
      return diff;
    }
    return 0;
  }
  /**
   * Resolves month name (i.e. "December") into a month number (11).
   *
   * @param value  Month name
   * @return Month number
   */
  resolveMonth(value) {
    let month = this._months().indexOf(value);
    if (month > -1) {
      return month;
    }
    if (!this._root.language.isDefault()) {
      month = this._root.language.translateAll(this._months()).indexOf(value);
      if (month > -1) {
        return month;
      }
    }
    return 0;
  }
  /**
   * Resolves short month name (i.e. "Dec") into a month number.
   *
   * @param value  Short month name
   * @return Month number
   */
  resolveShortMonth(value) {
    let month = this._shortMonths().indexOf(value);
    if (month > -1) {
      return month;
    }
    month = this._months().indexOf(value);
    if (month > -1) {
      return month;
    }
    if (this._root.language && !this._root.language.isDefault()) {
      month = this._root.language.translateAll(this._shortMonths()).indexOf(value);
      if (month > -1) {
        return month;
      }
    }
    return 0;
  }
  /**
   * Checks if passed in string represents AM/PM notation in many of its
   * versions.
   *
   * @param value  Source string
   * @return Is it AM/PM?
   */
  isAm(value) {
    let list = this.getStringList(["AM", "A.M.", "A"]);
    return list.indexOf(value.toUpperCase()) > -1;
  }
  /**
   * Translates list of strings.
   *
   * @param list  Source strings
   * @return Translated strings
   */
  getStringList(list) {
    let res = [];
    for (let i = 0; i < list.length; i++) {
      if (this._root.language) {
        res.push(escapeForRgex(this._t(list[i])));
      } else {
        res.push(escapeForRgex(list[i]));
      }
    }
    return res;
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/DurationFormatter.js
var DurationFormatter = class extends Entity2 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_unitAliases", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        "Y": "y",
        "D": "d",
        "H": "h",
        "K": "h",
        "k": "h",
        "n": "S"
      }
    });
  }
  _setDefaults() {
    const dmillisecond = "_duration_millisecond";
    const dsecond = "_duration_second";
    const dminute = "_duration_minute";
    const dhour = "_duration_hour";
    const dday = "_duration_day";
    const dweek = "_duration_week";
    const dmonth = "_duration_month";
    const dyear = "_duration_year";
    const asecond = "_second";
    const aminute = "_minute";
    const ahour = "_hour";
    const aday = "_day";
    const aweek = "_week";
    const amonth = "_week";
    const ayear = "_year";
    this._setDefault("negativeBase", 0);
    this._setDefault("baseUnit", "second");
    this._setDefault("durationFormats", {
      "millisecond": {
        "millisecond": this._t(dmillisecond),
        "second": this._t(dmillisecond + asecond),
        "minute": this._t(dmillisecond + aminute),
        "hour": this._t(dmillisecond + ahour),
        "day": this._t(dmillisecond + aday),
        "week": this._t(dmillisecond + aweek),
        "month": this._t(dmillisecond + amonth),
        "year": this._t(dmillisecond + ayear)
      },
      "second": {
        "second": this._t(dsecond),
        "minute": this._t(dsecond + aminute),
        "hour": this._t(dsecond + ahour),
        "day": this._t(dsecond + aday),
        "week": this._t(dsecond + aweek),
        "month": this._t(dsecond + amonth),
        "year": this._t(dsecond + ayear)
      },
      "minute": {
        "minute": this._t(dminute),
        "hour": this._t(dminute + ahour),
        "day": this._t(dminute + aday),
        "week": this._t(dminute + aweek),
        "month": this._t(dminute + amonth),
        "year": this._t(dminute + ayear)
      },
      "hour": {
        "hour": this._t(dhour),
        "day": this._t(dhour + aday),
        "week": this._t(dhour + aweek),
        "month": this._t(dhour + amonth),
        "year": this._t(dhour + ayear)
      },
      "day": {
        "day": this._t(dday),
        "week": this._t(dday + aweek),
        "month": this._t(dday + amonth),
        "year": this._t(dday + ayear)
      },
      "week": {
        "week": this._t(dweek),
        "month": this._t(dweek + amonth),
        "year": this._t(dweek + ayear)
      },
      "month": {
        "month": this._t(dmonth),
        "year": this._t(dmonth + ayear)
      },
      "year": {
        "year": this._t(dyear)
      }
    });
    super._setDefaults();
  }
  _beforeChanged() {
    super._beforeChanged();
  }
  /**
   * Formats the number as duration.
   *
   * For example `1000` (base unit seconds) would be converted to `16:40` as in
   * 16 minutes and 40 seconds.
   *
   * @param value   Value to format
   * @param format  Format to apply
   * @param base    Override base unit
   * @return Formatted number
   */
  format(value, format2, base) {
    let baseUnit = base || this.get("baseUnit");
    if (typeof format2 === "undefined" || format2 === "") {
      if (this.get("durationFormat") != null) {
        format2 = this.get("durationFormat");
      } else {
        format2 = this.getFormat(toNumber(value), void 0, baseUnit);
      }
    }
    format2 = cleanFormat(format2);
    let info = this.parseFormat(format2, baseUnit);
    let source = Number(value);
    let details;
    if (source > this.get("negativeBase")) {
      details = info.positive;
    } else if (source < this.get("negativeBase")) {
      details = info.negative;
    } else {
      details = info.zero;
    }
    let formatted = this.applyFormat(source, details);
    if (details.color !== "") {
      formatted = "[" + details.color + "]" + formatted + "[/]";
    }
    return formatted;
  }
  /**
   * Parses supplied format into structured object which can be used to format
   * the number.
   *
   * @param format  Format string, i.e. "#,###.00"
   * @param base    Override base unit
   * @return Parsed information
   */
  parseFormat(format2, base) {
    let baseUnit = base || this.get("baseUnit");
    let info = {
      "positive": {
        "color": "",
        "template": "",
        "parts": [],
        "source": "",
        "baseUnit": baseUnit,
        "parsed": false,
        "absolute": false
      },
      "negative": {
        "color": "",
        "template": "",
        "parts": [],
        "source": "",
        "baseUnit": baseUnit,
        "parsed": false,
        "absolute": false
      },
      "zero": {
        "color": "",
        "template": "",
        "parts": [],
        "source": "",
        "baseUnit": baseUnit,
        "parsed": false,
        "absolute": false
      }
    };
    format2 = format2.replace("||", PLACEHOLDER2);
    let parts = format2.split("|");
    info.positive.source = parts[0];
    if (typeof parts[2] === "undefined") {
      info.zero = info.positive;
    } else {
      info.zero.source = parts[2];
    }
    if (typeof parts[1] === "undefined") {
      info.negative = info.positive;
    } else {
      info.negative.source = parts[1];
    }
    each2(info, (_part, item) => {
      if (item.parsed) {
        return;
      }
      let partFormat = item.source;
      let dirs = [];
      dirs = item.source.match(/^\[([^\]]*)\]/);
      if (dirs && dirs.length && dirs[0] !== "") {
        partFormat = item.source.substr(dirs[0].length);
        item.color = dirs[1];
      }
      let chunks = TextFormatter.chunk(partFormat, true);
      for (let i = 0; i < chunks.length; i++) {
        let chunk = chunks[i];
        chunk.text = chunk.text.replace(PLACEHOLDER2, "|");
        if (chunk.type === "value") {
          if (chunk.text.match(/[yYMdDwhHKkmsSn]+a/)) {
            item.absolute = true;
            chunk.text = chunk.text.replace(/([yYMdDwhHKkmsSn]+)a/, "$1");
          }
          let matches = chunk.text.match(/y+|Y+|M+|d+|D+|w+|h+|H+|K+|k+|m+|s+|S+|n+/g);
          if (matches) {
            for (let x2 = 0; x2 < matches.length; x2++) {
              if (matches[x2] == null) {
                matches[x2] = this._unitAliases[matches[x2]];
              }
              item.parts.push(matches[x2]);
              chunk.text = chunk.text.replace(matches[x2], PLACEHOLDER);
            }
          }
        }
        item.template += chunk.text;
      }
      item.parsed = true;
    });
    return info;
  }
  /**
   * Applies parsed format to a numeric value.
   *
   * @param value    Value
   * @param details  Parsed format as returned by {parseFormat}
   * @return Formatted duration
   */
  applyFormat(value, details) {
    let negative = !details.absolute && value < this.get("negativeBase");
    value = Math.abs(value);
    let tstamp = this.toTimeStamp(value, details.baseUnit);
    let res = details.template;
    for (let i = 0, len = details.parts.length; i < len; i++) {
      let part = details.parts[i];
      let unit3 = this._toTimeUnit(part.substr(0, 1));
      let digits = part.length;
      let ints = Math.floor(tstamp / this._getUnitValue(unit3));
      res = res.replace(PLACEHOLDER, padString(ints, digits, "0"));
      tstamp -= ints * this._getUnitValue(unit3);
    }
    if (negative) {
      res = "-" + res;
    }
    return res;
  }
  /**
   * Converts numeric value to timestamp in milliseconds.
   *
   * @param value     A source value
   * @param baseUnit  Base unit the source value is in: "q", "s", "i", "h", "d", "w", "m", "y"
   * @return Value representation as a timestamp in milliseconds
   */
  toTimeStamp(value, baseUnit) {
    return value * this._getUnitValue(baseUnit);
  }
  _toTimeUnit(code) {
    switch (code) {
      case "S":
        return "millisecond";
      case "s":
        return "second";
      case "m":
        return "minute";
      case "h":
        return "hour";
      case "d":
        return "day";
      case "w":
        return "week";
      case "M":
        return "month";
      case "y":
        return "year";
    }
    ;
  }
  /**
   * Returns appropriate default format for the value.
   *
   * If `maxValue` is sepcified, it will use that value to determine the time
   * unit for the format.
   *
   * For example if your `baseUnit` is `"second"` and you pass in `10`, you
   * will get `"10"`.
   *
   * However, you might want it to be formatted in the context of bigger scale,
   * say 10 minutes (600 seconds). If you pass in `600` as `maxValue`, all
   * values, including small ones will use format with minutes, e.g.:
   * `00:10`, `00:50`, `12: 30`, etc.
   *
   * @param value     Value to format
   * @param maxValue  Maximum value to be used to determine format
   * @param baseUnit  Base unit of the value
   * @return Format
   */
  getFormat(value, maxValue, baseUnit) {
    if (this.get("durationFormat") != null) {
      return this.get("durationFormat");
    }
    if (!baseUnit) {
      baseUnit = this.get("baseUnit");
    }
    if (maxValue != null && value != maxValue) {
      value = Math.abs(value);
      maxValue = Math.abs(maxValue);
      let maxUnit = this.getValueUnit(Math.max(value, maxValue), baseUnit);
      return this.get("durationFormats")[baseUnit][maxUnit];
    } else {
      let unit3 = this.getValueUnit(value, baseUnit);
      return this.get("durationFormats")[baseUnit][unit3];
    }
  }
  /**
   * Returns value's closest denominator time unit, e.g 100 seconds is
   * `"minute"`, while 59 seconds would still be `second`.
   *
   * @param value     Source duration value
   * @param baseUnit  Base unit
   * @return Denominator
   */
  getValueUnit(value, baseUnit) {
    if (!baseUnit) {
      baseUnit = this.get("baseUnit");
    }
    let currentUnit;
    let ms = this.getMilliseconds(value, baseUnit);
    eachContinue2(this._getUnitValues(), (key, val) => {
      if (key == baseUnit || currentUnit) {
        let num = ms / val;
        if (num <= 1) {
          if (!currentUnit) {
            currentUnit = key;
          }
          return false;
        }
        currentUnit = key;
      }
      return true;
    });
    return currentUnit;
  }
  /**
   * Converts value to milliseconds according to `baseUnit`.
   *
   * @param value     Source duration value
   * @param baseUnit  Base unit
   * @return Value in milliseconds
   */
  getMilliseconds(value, baseUnit) {
    if (!baseUnit) {
      baseUnit = this.get("baseUnit");
    }
    return value * this._getUnitValue(baseUnit);
  }
  _getUnitValue(timeUnit) {
    return this._getUnitValues()[timeUnit];
  }
  _getUnitValues() {
    return {
      "millisecond": 1,
      "second": 1e3,
      "minute": 6e4,
      "hour": 36e5,
      "day": 864e5,
      "week": 6048e5,
      "month": 2592e6,
      "year": 31536e6
    };
  }
};

// ../../node_modules/@amcharts/amcharts5/locales/en.js
var en_default = {
  "firstDayOfWeek": 1,
  // Number formatting options.
  // 
  // Please check with the local standards which separator is accepted to be
  // used for separating decimals, and which for thousands.
  "_decimalSeparator": ".",
  "_thousandSeparator": ",",
  // Position of the percent sign in numbers
  "_percentPrefix": null,
  "_percentSuffix": "%",
  // Suffixes for numbers
  // When formatting numbers, big or small numers might be reformatted to
  // shorter version, by applying a suffix.
  // 
  // For example, 1000000 might become "1m".
  // Or 1024 might become "1KB" if we're formatting byte numbers.
  // 
  // This section defines such suffixes for all such cases.
  "_big_number_suffix_3": "k",
  "_big_number_suffix_6": "M",
  "_big_number_suffix_9": "G",
  "_big_number_suffix_12": "T",
  "_big_number_suffix_15": "P",
  "_big_number_suffix_18": "E",
  "_big_number_suffix_21": "Z",
  "_big_number_suffix_24": "Y",
  "_small_number_suffix_3": "m",
  "_small_number_suffix_6": "\u03BC",
  "_small_number_suffix_9": "n",
  "_small_number_suffix_12": "p",
  "_small_number_suffix_15": "f",
  "_small_number_suffix_18": "a",
  "_small_number_suffix_21": "z",
  "_small_number_suffix_24": "y",
  "_byte_suffix_B": "B",
  "_byte_suffix_KB": "KB",
  "_byte_suffix_MB": "MB",
  "_byte_suffix_GB": "GB",
  "_byte_suffix_TB": "TB",
  "_byte_suffix_PB": "PB",
  // Default date formats for various periods.
  // 
  // This should reflect official or de facto formatting universally accepted
  // in the country translation is being made for
  // Available format codes here:
  // https://www.amcharts.com/docs/v5/concepts/formatters/formatting-dates/#Format_codes
  // 
  // This will be used when formatting date/time for particular granularity,
  // e.g. "_date_hour" will be shown whenever we need to show time as hours.
  // 
  // "date" is used as in default date format when showing standalone dates.
  "_date": "yyyy-MM-dd",
  "_date_millisecond": "mm:ss SSS",
  "_date_millisecond_full": "HH:mm:ss SSS",
  "_date_second": "HH:mm:ss",
  "_date_second_full": "HH:mm:ss",
  "_date_minute": "HH:mm",
  "_date_minute_full": "HH:mm - MMM dd, yyyy",
  "_date_hour": "HH:mm",
  "_date_hour_full": "HH:mm - MMM dd, yyyy",
  "_date_day": "MMM dd",
  "_date_day_full": "MMM dd, yyyy",
  "_date_week": "ww",
  "_date_week_full": "MMM dd, yyyy",
  "_date_month": "MMM",
  "_date_month_full": "MMM, yyyy",
  "_date_year": "yyyy",
  // Default duration formats for various base units.
  // 
  // This will be used by DurationFormatter to format numeric values into
  // duration.
  // 
  // Notice how each duration unit comes in several versions. This is to ensure
  // that each base unit is shown correctly.
  // 
  // For example, if we have baseUnit set to "second", meaning our duration is
  // in seconds.
  // 
  // If we pass in `50` to formatter, it will know that we have just 50 seconds
  // (less than a minute) so it will use format in `"_duration_second"` ("ss"),
  // and the formatted result will be in like `"50"`.
  // 
  // If we pass in `70`, which is more than a minute, the formatter will switch
  // to `"_duration_second_minute"` ("mm:ss"), resulting in "01:10" formatted
  // text.
  // 
  // Available codes here:
  // https://www.amcharts.com/docs/v4/concepts/formatters/formatting-duration/#Available_Codes
  "_duration_millisecond": "SSS",
  "_duration_millisecond_second": "ss.SSS",
  "_duration_millisecond_minute": "mm:ss SSS",
  "_duration_millisecond_hour": "hh:mm:ss SSS",
  "_duration_millisecond_day": "d'd' mm:ss SSS",
  "_duration_millisecond_week": "d'd' mm:ss SSS",
  "_duration_millisecond_month": "M'm' dd'd' mm:ss SSS",
  "_duration_millisecond_year": "y'y' MM'm' dd'd' mm:ss SSS",
  "_duration_second": "ss",
  "_duration_second_minute": "mm:ss",
  "_duration_second_hour": "hh:mm:ss",
  "_duration_second_day": "d'd' hh:mm:ss",
  "_duration_second_week": "d'd' hh:mm:ss",
  "_duration_second_month": "M'm' dd'd' hh:mm:ss",
  "_duration_second_year": "y'y' MM'm' dd'd' hh:mm:ss",
  "_duration_minute": "mm",
  "_duration_minute_hour": "hh:mm",
  "_duration_minute_day": "d'd' hh:mm",
  "_duration_minute_week": "d'd' hh:mm",
  "_duration_minute_month": "M'm' dd'd' hh:mm",
  "_duration_minute_year": "y'y' MM'm' dd'd' hh:mm",
  "_duration_hour": "hh'h'",
  "_duration_hour_day": "d'd' hh'h'",
  "_duration_hour_week": "d'd' hh'h'",
  "_duration_hour_month": "M'm' dd'd' hh'h'",
  "_duration_hour_year": "y'y' MM'm' dd'd' hh'h'",
  "_duration_day": "d'd'",
  "_duration_day_week": "d'd'",
  "_duration_day_month": "M'm' dd'd'",
  "_duration_day_year": "y'y' MM'm' dd'd'",
  "_duration_week": "w'w'",
  "_duration_week_month": "w'w'",
  "_duration_week_year": "w'w'",
  "_duration_month": "M'm'",
  "_duration_month_year": "y'y' MM'm'",
  "_duration_year": "y'y'",
  // Era translations
  "_era_ad": "AD",
  "_era_bc": "BC",
  // Day part, used in 12-hour formats, e.g. 5 P.M.
  // Please note that these come in 3 variants:
  // * one letter (e.g. "A")
  // * two letters (e.g. "AM")
  // * two letters with dots (e.g. "A.M.")
  // 
  // All three need to to be translated even if they are all the same. Some
  // users might use one, some the other.
  "A": "",
  "P": "",
  "AM": "",
  "PM": "",
  "A.M.": "",
  "P.M.": "",
  // Date-related stuff.
  // 
  // When translating months, if there's a difference, use the form which is
  // best for a full date, e.g. as you would use it in "2018 January 1".
  // 
  // Note that May is listed twice. This is because in English May is the same
  // in both long and short forms, while in other languages it may not be the
  // case. Translate "May" to full word, while "May(short)" to shortened
  // version.
  // 
  // Should month names and weekdays be capitalized or not?
  // 
  // Rule of thumb is this: if the names should always be capitalized,
  // regardless of name position within date ("January", "21st January 2018",
  // etc.) use capitalized names. Otherwise enter all lowercase.
  // 
  // The date formatter will automatically capitalize names if they are the
  // first (or only) word in resulting date.
  "January": "",
  "February": "",
  "March": "",
  "April": "",
  "May": "",
  "June": "",
  "July": "",
  "August": "",
  "September": "",
  "October": "",
  "November": "",
  "December": "",
  "Jan": "",
  "Feb": "",
  "Mar": "",
  "Apr": "",
  "May(short)": "May",
  "Jun": "",
  "Jul": "",
  "Aug": "",
  "Sep": "",
  "Oct": "",
  "Nov": "",
  "Dec": "",
  // Weekdays.
  "Sunday": "",
  "Monday": "",
  "Tuesday": "",
  "Wednesday": "",
  "Thursday": "",
  "Friday": "",
  "Saturday": "",
  "Sun": "",
  "Mon": "",
  "Tue": "",
  "Wed": "",
  "Thu": "",
  "Fri": "",
  "Sat": "",
  // Date ordinal function.
  // 
  // This is used when adding number ordinal when formatting days in dates.
  // 
  // E.g. "January 1st", "February 2nd".
  // 
  // The function accepts day number, and returns a string to be added to the
  // day, like in default English translation, if we pass in 2, we will receive
  // "nd" back.
  "_dateOrd": function(day) {
    let res = "th";
    if (day < 11 || day > 13) {
      switch (day % 10) {
        case 1:
          res = "st";
          break;
        case 2:
          res = "nd";
          break;
        case 3:
          res = "rd";
          break;
      }
    }
    return res;
  },
  // Various chart controls.
  // Shown as a tooltip on zoom out button.
  "Zoom Out": "",
  // Timeline buttons
  "Play": "",
  "Stop": "",
  // Chart's Legend screen reader title.
  "Legend": "",
  // Legend's item screen reader indicator.
  "Press ENTER to toggle": "",
  // Shown when the chart is busy loading something.
  "Loading": "",
  // Shown as the first button in the breadcrumb navigation, e.g.:
  // Home > First level > ...
  "Home": "",
  // Chart types.
  // Those are used as default screen reader titles for the main chart element
  // unless developer has set some more descriptive title.
  "Chart": "",
  "Serial chart": "",
  "X/Y chart": "",
  "Pie chart": "",
  "Gauge chart": "",
  "Radar chart": "",
  "Sankey diagram": "",
  "Flow diagram": "",
  "Chord diagram": "",
  "TreeMap chart": "",
  "Force directed tree": "",
  "Sliced chart": "",
  // Series types.
  // Used to name series by type for screen readers if they do not have their
  // name set.
  "Series": "",
  "Candlestick Series": "",
  "OHLC Series": "",
  "Column Series": "",
  "Line Series": "",
  "Pie Slice Series": "",
  "Funnel Series": "",
  "Pyramid Series": "",
  "X/Y Series": "",
  // Map-related stuff.
  "Map": "",
  "Press ENTER to zoom in": "",
  "Press ENTER to zoom out": "",
  "Use arrow keys to zoom in and out": "",
  "Use plus and minus keys on your keyboard to zoom in and out": "",
  // Export-related stuff.
  // These prompts are used in Export menu labels.
  // 
  // "Export" is the top-level menu item.
  // 
  // "Image", "Data", "Print" as second-level indicating type of export
  // operation.
  // 
  // Leave actual format untranslated, unless you absolutely know that they
  // would convey more meaning in some other way.
  "Export": "",
  "Image": "",
  "Data": "",
  "Print": "",
  "Press ENTER or use arrow keys to navigate": "",
  "Press ENTER to open": "",
  "Press ENTER to print.": "",
  "Press ENTER to export as %1.": "",
  "(Press ESC to close this message)": "",
  "Image Export Complete": "",
  "Export operation took longer than expected. Something might have gone wrong.": "",
  "Saved from": "",
  "PNG": "",
  "JPG": "",
  "GIF": "",
  "SVG": "",
  "PDF": "",
  "JSON": "",
  "CSV": "",
  "XLSX": "",
  "HTML": "",
  // Scrollbar-related stuff.
  // 
  // Scrollbar is a control which can zoom and pan the axes on the chart.
  // 
  // Each scrollbar has two grips: left or right (for horizontal scrollbar) or
  // upper and lower (for vertical one).
  // 
  // Prompts change in relation to whether Scrollbar is vertical or horizontal.
  // 
  // The final section is used to indicate the current range of selection.
  "Use TAB to select grip buttons or left and right arrows to change selection": "",
  "Use left and right arrows to move selection": "",
  "Use left and right arrows to move left selection": "",
  "Use left and right arrows to move right selection": "",
  "Use TAB select grip buttons or up and down arrows to change selection": "",
  "Use up and down arrows to move selection": "",
  "Use up and down arrows to move lower selection": "",
  "Use up and down arrows to move upper selection": "",
  "From %1 to %2": "",
  "From %1": "",
  "To %1": "",
  // Data loader-related.
  "No parser available for file: %1": "",
  "Error parsing file: %1": "",
  "Unable to load file: %1": "",
  "Invalid date": "",
  // Common actions
  "Close": "",
  "Minimize": ""
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Language.js
var Language = class extends Entity2 {
  _setDefaults() {
    this.setPrivate("defaultLocale", en_default);
    super._setDefaults();
  }
  /**
   * Returns a prompt translation.
   *
   * @param   prompt   Prompt to translate
   * @param   locale   Target locale
   * @param   ...rest  Parameters
   * @return           Translation
   */
  translate(prompt, locale6, ...rest) {
    if (!locale6) {
      locale6 = this._root.locale || this.getPrivate("defaultLocale");
    }
    let translation = prompt;
    let value = locale6[prompt];
    if (value === null) {
      translation = "";
    } else if (value != null) {
      if (value) {
        translation = value;
      }
    } else if (locale6 !== this.getPrivate("defaultLocale")) {
      return this.translate(prompt, this.getPrivate("defaultLocale"), ...rest);
    }
    if (rest.length) {
      for (let len = rest.length, i = 0; i < len; ++i) {
        translation = translation.split("%" + (i + 1)).join(rest[i]);
      }
    }
    return translation;
  }
  /**
   * Returns a prompt translation, including custom prompts.
   *
   * @param   prompt   Prompt to translate
   * @param   locale   Target locale
   * @param   ...rest  Parameters
   * @return           Translation
   */
  translateAny(prompt, locale6, ...rest) {
    return this.translate(prompt, locale6, ...rest);
  }
  /**
   * Add a custom prompt to locale.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/locales/creating-translations/#Extending_locale_with_custom_prompts}
   * @param  prompt       Source prompt
   * @param  translation  Tanslation
   * @param  locale       Target locale
   */
  setTranslationAny(prompt, translation, locale6) {
    const localeTarget = locale6 || this._root.locale;
    localeTarget[prompt] = translation;
  }
  /**
   * Add a batch of custom prompts.
   *
   * @since 5.3.3
   * @see {@link https://www.amcharts.com/docs/v5/concepts/locales/creating-translations/#Extending_locale_with_custom_prompts}
   * @param  translations  Translations
   * @param  locale        Target locale
   */
  setTranslationsAny(translations, locale6) {
    each2(translations, (key, val) => {
      this.setTranslationAny(key, val, locale6);
    });
  }
  translateEmpty(prompt, locale6, ...rest) {
    let translation = this.translate(prompt, locale6, ...rest);
    return translation == prompt ? "" : translation;
  }
  translateFunc(prompt, locale6) {
    if (this._root.locale[prompt]) {
      return this._root.locale[prompt];
    }
    if (locale6 !== this.getPrivate("defaultLocale")) {
      return this.translateFunc(prompt, this.getPrivate("defaultLocale"));
    }
    return () => {
      return "";
    };
  }
  /**
   * Translates a btach of prompts.
   *
   * @param  list    Array of prompts to translate
   * @param  locale  Target locale
   * @return         Array of translations
   */
  translateAll(list, locale6) {
    if (!this.isDefault()) {
      return map(list, (x2) => this.translate(x2, locale6));
    } else {
      return list;
    }
  }
  /**
   * Returns `true` if the currently selected locale is a default locale.
   *
   * @return `true` if locale is default; `false` if it is not.
   */
  isDefault() {
    return this.getPrivate("defaultLocale") === this._root.locale;
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/Theme.js
var Theme2 = class {
  constructor(root, isReal) {
    Object.defineProperty(this, "_root", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_rules", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    this._root = root;
    if (!isReal) {
      throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
    }
  }
  /**
   * Use this method to create an instance of this class.
   *
   * @see {@link https://www.amcharts.com/docs/v5/getting-started/#New_element_syntax} for more info
   * @param   root      Root element
   * @param   settings  Settings
   * @param   template  Template
   * @return            Instantiated object
   */
  static new(root) {
    const x2 = new this(root, true);
    x2.setupDefaultRules();
    return x2;
  }
  setupDefaultRules() {
  }
  /**
   * Looks up the rules for a specific theme class.
   *
   * @see {@link https://www.amcharts.com/docs/v5/themes/} for more info
   * @param   themeClass Theme class
   * @return             Array<IRule<A>>
   */
  _lookupRules(themeClass) {
    return this._rules[themeClass];
  }
  /**
   * Creates a [[Template]] for specific theme class and tags.
   *
   * NOTE: the difference from `rule()` is that `ruleRaw()` does not do any
   * type checks.
   *
   * @see {@link https://www.amcharts.com/docs/v5/themes/} for more info
   * @param   themeClass Theme class
   * @param   themeTags  Theme tags
   * @return             Template
   */
  ruleRaw(themeClass, themeTags = []) {
    let rules2 = this._rules[themeClass];
    if (!rules2) {
      rules2 = this._rules[themeClass] = [];
    }
    themeTags.sort(compare);
    const { index: index2, found } = getSortedIndex(rules2, (x2) => {
      const order = compare(x2.tags.length, themeTags.length);
      if (order === 0) {
        return compareArray(x2.tags, themeTags, compare);
      } else {
        return order;
      }
    });
    if (found) {
      return rules2[index2].template;
    } else {
      const template = Template.new({});
      rules2.splice(index2, 0, {
        tags: themeTags,
        template
      });
      return template;
    }
  }
  /**
   * Creates a [[Template]] for specific theme class and tags.
   *
   * @see {@link https://www.amcharts.com/docs/v5/themes/} for more info
   * @param   themeClass Theme class
   * @param   themeTags  Theme tags
   * @return             Template
   */
  rule(themeClass, themeTags = []) {
    return this.ruleRaw(themeClass, themeTags);
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/themes/DefaultTheme.js
function setColor(rule, key, ic, name) {
  rule.set(key, ic.get(name));
  ic.on(name, (value) => {
    rule.set(key, value);
  });
}
var DefaultTheme = class extends Theme2 {
  setupDefaultRules() {
    super.setupDefaultRules();
    const language = this._root.language;
    const ic = this._root.interfaceColors;
    const horizontalLayout = this._root.horizontalLayout;
    const verticalLayout = this._root.verticalLayout;
    const r = this.rule.bind(this);
    r("InterfaceColors").setAll({
      stroke: Color.fromHex(15066597),
      fill: Color.fromHex(15987699),
      primaryButton: Color.fromHex(6788316),
      primaryButtonHover: Color.fromHex(6779356),
      primaryButtonDown: Color.fromHex(6872182),
      primaryButtonActive: Color.fromHex(6872182),
      primaryButtonText: Color.fromHex(16777215),
      primaryButtonStroke: Color.fromHex(16777215),
      secondaryButton: Color.fromHex(14277081),
      secondaryButtonHover: Color.fromHex(10724259),
      secondaryButtonDown: Color.fromHex(9276813),
      secondaryButtonActive: Color.fromHex(15132390),
      secondaryButtonText: Color.fromHex(0),
      secondaryButtonStroke: Color.fromHex(16777215),
      grid: Color.fromHex(0),
      background: Color.fromHex(16777215),
      alternativeBackground: Color.fromHex(0),
      text: Color.fromHex(0),
      alternativeText: Color.fromHex(16777215),
      disabled: Color.fromHex(11382189),
      positive: Color.fromHex(5288704),
      negative: Color.fromHex(11730944)
    });
    {
      const rule = r("ColorSet");
      rule.setAll({
        passOptions: {
          hue: 0.05,
          saturation: 0,
          lightness: 0
        },
        colors: [
          Color.fromHex(6797276)
        ],
        step: 1,
        //baseColor: Color.fromRGB(103, 183, 220),
        //count: 20,
        reuse: false,
        startIndex: 0
      });
      rule.setPrivate("currentStep", 0);
      rule.setPrivate("currentPass", 0);
    }
    r("Entity").setAll({
      stateAnimationDuration: 0,
      stateAnimationEasing: out(cubic)
    });
    r("Component").setAll({
      interpolationDuration: 0,
      interpolationEasing: out(cubic)
    });
    r("Sprite").setAll({
      visible: true,
      scale: 1,
      opacity: 1,
      rotation: 0,
      position: "relative",
      tooltipX: p50,
      tooltipY: p50,
      tooltipPosition: "fixed",
      isMeasured: true
    });
    r("Sprite").states.create("default", { "visible": true, opacity: 1 });
    r("Container").setAll({
      interactiveChildren: true,
      setStateOnChildren: false
    });
    r("Graphics").setAll({
      strokeWidth: 1
    });
    r("Chart").setAll({
      width: p100,
      height: p100,
      interactiveChildren: false
    });
    r("Sprite", ["horizontal", "center"]).setAll({
      centerX: p50,
      x: p50
    });
    r("Sprite", ["vertical", "center"]).setAll({
      centerY: p50,
      y: p50
    });
    r("Container", ["horizontal", "layout"]).setAll({
      layout: horizontalLayout
    });
    r("Container", ["vertical", "layout"]).setAll({
      layout: verticalLayout
    });
    r("Pattern").setAll({
      repetition: "repeat",
      width: 50,
      height: 50,
      rotation: 0,
      fillOpacity: 1
    });
    r("LinePattern").setAll({
      gap: 6,
      colorOpacity: 1,
      width: 49,
      height: 49
    });
    r("RectanglePattern").setAll({
      gap: 6,
      checkered: false,
      centered: true,
      maxWidth: 5,
      maxHeight: 5,
      width: 48,
      height: 48,
      strokeWidth: 0
    });
    r("CirclePattern").setAll({
      gap: 5,
      checkered: false,
      centered: false,
      radius: 3,
      strokeWidth: 0,
      width: 45,
      height: 45
    });
    r("GrainPattern").setAll({
      width: 200,
      height: 200,
      colors: [Color.fromHex(0)],
      size: 1,
      horizontalGap: 0,
      verticalGap: 0,
      density: 1,
      minOpacity: 0,
      maxOpacity: 0.2
    });
    r("LinearGradient").setAll({
      rotation: 90
    });
    r("Legend").setAll({
      fillField: "fill",
      strokeField: "stroke",
      nameField: "name",
      layout: GridLayout.new(this._root, {}),
      layer: 30,
      clickTarget: "itemContainer"
    });
    r("Container", ["legend", "item", "itemcontainer"]).setAll({
      paddingLeft: 5,
      paddingRight: 5,
      paddingBottom: 5,
      paddingTop: 5,
      layout: horizontalLayout,
      setStateOnChildren: true,
      interactiveChildren: false,
      ariaChecked: true,
      focusable: true,
      ariaLabel: language.translate("Press ENTER to toggle"),
      role: "checkbox"
    });
    {
      const rule = r("Rectangle", ["legend", "item", "background"]);
      rule.setAll({
        fillOpacity: 0
      });
      setColor(rule, "fill", ic, "background");
    }
    r("Container", ["legend", "marker"]).setAll({
      setStateOnChildren: true,
      centerY: p50,
      paddingLeft: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingTop: 0,
      width: 18,
      height: 18
    });
    r("RoundedRectangle", ["legend", "marker", "rectangle"]).setAll({
      width: p100,
      height: p100,
      cornerRadiusBL: 3,
      cornerRadiusTL: 3,
      cornerRadiusBR: 3,
      cornerRadiusTR: 3
    });
    {
      const rule = r("RoundedRectangle", ["legend", "marker", "rectangle"]).states.create("disabled", {});
      setColor(rule, "fill", ic, "disabled");
      setColor(rule, "stroke", ic, "disabled");
    }
    r("Label", ["legend", "label"]).setAll({
      centerY: p50,
      marginLeft: 5,
      paddingRight: 0,
      paddingLeft: 0,
      paddingTop: 0,
      paddingBottom: 0,
      populateText: true
    });
    {
      const rule = r("Label", ["legend", "label"]).states.create("disabled", {});
      setColor(rule, "fill", ic, "disabled");
    }
    r("Label", ["legend", "value", "label"]).setAll({
      centerY: p50,
      marginLeft: 5,
      paddingRight: 0,
      paddingLeft: 0,
      paddingTop: 0,
      paddingBottom: 0,
      width: 50,
      centerX: p100,
      populateText: true
    });
    {
      const rule = r("Label", ["legend", "value", "label"]).states.create("disabled", {});
      setColor(rule, "fill", ic, "disabled");
    }
    r("HeatLegend").setAll({
      stepCount: 1
    });
    r("RoundedRectangle", ["heatlegend", "marker"]).setAll({
      cornerRadiusTR: 0,
      cornerRadiusBR: 0,
      cornerRadiusTL: 0,
      cornerRadiusBL: 0
    });
    r("RoundedRectangle", ["vertical", "heatlegend", "marker"]).setAll({
      height: p100,
      width: 15
    });
    r("RoundedRectangle", ["horizontal", "heatlegend", "marker"]).setAll({
      width: p100,
      height: 15
    });
    r("HeatLegend", ["vertical"]).setAll({
      height: p100
    });
    r("HeatLegend", ["horizontal"]).setAll({
      width: p100
    });
    r("Label", ["heatlegend", "start"]).setAll({
      paddingLeft: 5,
      paddingRight: 5,
      paddingTop: 5,
      paddingBottom: 5
    });
    r("Label", ["heatlegend", "end"]).setAll({
      paddingLeft: 5,
      paddingRight: 5,
      paddingTop: 5,
      paddingBottom: 5
    });
    {
      const rule = r("Label");
      rule.setAll({
        paddingTop: 8,
        paddingBottom: 8,
        paddingLeft: 10,
        paddingRight: 10,
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol"',
        fontSize: "1em",
        populateText: false
      });
      setColor(rule, "fill", ic, "text");
    }
    r("RadialLabel").setAll({
      textType: "regular",
      centerY: p50,
      centerX: p50,
      inside: false,
      radius: 0,
      baseRadius: p100,
      orientation: "auto",
      textAlign: "center"
    });
    r("RoundedRectangle").setAll({
      cornerRadiusTL: 8,
      cornerRadiusBL: 8,
      cornerRadiusTR: 8,
      cornerRadiusBR: 8
    });
    r("PointedRectangle").setAll({
      pointerBaseWidth: 15,
      pointerLength: 10,
      cornerRadius: 8
    });
    r("Slice").setAll({
      shiftRadius: 0,
      dRadius: 0,
      dInnerRadius: 0
    });
    {
      const rule = r("Tick");
      rule.setAll({
        strokeOpacity: 0.15,
        isMeasured: false,
        length: 4.5,
        position: "absolute",
        crisp: true
      });
      setColor(rule, "stroke", ic, "grid");
    }
    r("Bullet").setAll({
      locationX: 0.5,
      locationY: 0.5
    });
    r("Tooltip").setAll({
      position: "absolute",
      getFillFromSprite: true,
      getStrokeFromSprite: false,
      autoTextColor: true,
      paddingTop: 9,
      paddingBottom: 8,
      paddingLeft: 10,
      paddingRight: 10,
      marginBottom: 5,
      pointerOrientation: "vertical",
      centerX: p50,
      centerY: p50,
      animationEasing: out(cubic),
      exportable: false
      //layer: 100
    });
    r("Polygon").setAll({
      animationEasing: out(cubic)
    });
    {
      const rule = r("PointedRectangle", ["tooltip", "background"]);
      rule.setAll({
        strokeOpacity: 0.9,
        cornerRadius: 4,
        pointerLength: 4,
        pointerBaseWidth: 8,
        fillOpacity: 0.9,
        stroke: Color.fromHex(16777215)
      });
    }
    {
      const rule = r("Label", ["tooltip"]);
      rule.setAll({
        role: "tooltip",
        populateText: true,
        paddingRight: 0,
        paddingTop: 0,
        paddingLeft: 0,
        paddingBottom: 0
      });
      setColor(rule, "fill", ic, "alternativeText");
    }
    r("Button").setAll({
      paddingTop: 8,
      paddingBottom: 8,
      paddingLeft: 10,
      paddingRight: 10,
      interactive: true,
      layout: horizontalLayout,
      interactiveChildren: false,
      setStateOnChildren: true,
      focusable: true
    });
    r("Button").states.create("hover", {});
    r("Button").states.create("down", { stateAnimationDuration: 0 });
    r("Button").states.create("active", {});
    {
      const rule = r("RoundedRectangle", ["button", "background"]);
      setColor(rule, "fill", ic, "primaryButton");
      setColor(rule, "stroke", ic, "primaryButtonStroke");
    }
    {
      const rule = r("RoundedRectangle", ["button", "background"]).states.create("hover", {});
      setColor(rule, "fill", ic, "primaryButtonHover");
    }
    {
      const rule = r("RoundedRectangle", ["button", "background"]).states.create("down", { stateAnimationDuration: 0 });
      setColor(rule, "fill", ic, "primaryButtonDown");
    }
    {
      const rule = r("RoundedRectangle", ["button", "background"]).states.create("active", {});
      setColor(rule, "fill", ic, "primaryButtonActive");
    }
    {
      const rule = r("Graphics", ["button", "icon"]);
      setColor(rule, "stroke", ic, "primaryButtonText");
    }
    {
      const rule = r("Label", ["button"]);
      setColor(rule, "fill", ic, "primaryButtonText");
    }
    r("Button", ["zoom"]).setAll({
      paddingTop: 18,
      paddingBottom: 18,
      paddingLeft: 12,
      paddingRight: 12,
      centerX: 46,
      centerY: -10,
      y: 0,
      x: p100,
      role: "button",
      ariaLabel: language.translate("Zoom Out"),
      layer: 30
    });
    {
      const rule = r("RoundedRectangle", ["background", "button", "zoom"]);
      rule.setAll({
        cornerRadiusBL: 40,
        cornerRadiusBR: 40,
        cornerRadiusTL: 40,
        cornerRadiusTR: 40
      });
      setColor(rule, "fill", ic, "primaryButton");
    }
    {
      const rule = r("RoundedRectangle", ["background", "button", "zoom"]).states.create("hover", {});
      setColor(rule, "fill", ic, "primaryButtonHover");
    }
    {
      const rule = r("RoundedRectangle", ["background", "button", "zoom"]).states.create("down", { stateAnimationDuration: 0 });
      setColor(rule, "fill", ic, "primaryButtonDown");
    }
    {
      const rule = r("Graphics", ["icon", "button", "zoom"]);
      rule.setAll({
        crisp: true,
        strokeOpacity: 0.7,
        draw: (display) => {
          display.moveTo(0, 0);
          display.lineTo(12, 0);
        }
      });
      setColor(rule, "stroke", ic, "primaryButtonText");
    }
    r("Button", ["resize"]).setAll({
      paddingTop: 9,
      paddingBottom: 9,
      paddingLeft: 13,
      paddingRight: 13,
      draggable: true,
      centerX: p50,
      centerY: p50,
      position: "absolute",
      role: "slider",
      ariaValueMin: "0",
      ariaValueMax: "100",
      ariaLabel: language.translate("Use up and down arrows to move selection")
    });
    {
      const rule = r("RoundedRectangle", ["background", "resize", "button"]);
      rule.setAll({
        cornerRadiusBL: 40,
        cornerRadiusBR: 40,
        cornerRadiusTL: 40,
        cornerRadiusTR: 40
      });
      setColor(rule, "fill", ic, "secondaryButton");
      setColor(rule, "stroke", ic, "secondaryButtonStroke");
    }
    {
      const rule = r("RoundedRectangle", ["background", "resize", "button"]).states.create("hover", {});
      setColor(rule, "fill", ic, "secondaryButtonHover");
    }
    {
      const rule = r("RoundedRectangle", ["background", "resize", "button"]).states.create("down", { stateAnimationDuration: 0 });
      setColor(rule, "fill", ic, "secondaryButtonDown");
    }
    {
      const rule = r("Graphics", ["resize", "button", "icon"]);
      rule.setAll({
        interactive: false,
        crisp: true,
        strokeOpacity: 0.5,
        draw: (display) => {
          display.moveTo(0, 0.5);
          display.lineTo(0, 12.5);
          display.moveTo(4, 0.5);
          display.lineTo(4, 12.5);
        }
      });
      setColor(rule, "stroke", ic, "secondaryButtonText");
    }
    r("Button", ["resize", "vertical"]).setAll({
      rotation: 90,
      cursorOverStyle: "ns-resize"
    });
    r("Button", ["resize", "horizontal"]).setAll({
      cursorOverStyle: "ew-resize"
    });
    r("Button", ["play"]).setAll({
      paddingTop: 13,
      paddingBottom: 13,
      paddingLeft: 14,
      paddingRight: 14,
      ariaLabel: language.translate("Play"),
      toggleKey: "active"
    });
    {
      const rule = r("RoundedRectangle", ["play", "background"]);
      rule.setAll({
        strokeOpacity: 0.5,
        cornerRadiusBL: 100,
        cornerRadiusBR: 100,
        cornerRadiusTL: 100,
        cornerRadiusTR: 100
      });
      setColor(rule, "fill", ic, "primaryButton");
    }
    {
      const rule = r("Graphics", ["play", "icon"]);
      rule.setAll({
        stateAnimationDuration: 0,
        dx: 1,
        draw: (display) => {
          display.moveTo(0, -5);
          display.lineTo(8, 0);
          display.lineTo(0, 5);
          display.lineTo(0, -5);
        }
      });
      setColor(rule, "fill", ic, "primaryButtonText");
    }
    r("Graphics", ["play", "icon"]).states.create("default", {
      stateAnimationDuration: 0
    });
    r("Graphics", ["play", "icon"]).states.create("active", {
      stateAnimationDuration: 0,
      draw: (display) => {
        display.moveTo(-4, -5);
        display.lineTo(-1, -5);
        display.lineTo(-1, 5);
        display.lineTo(-4, 5);
        display.lineTo(-4, -5);
        display.moveTo(4, -5);
        display.lineTo(1, -5);
        display.lineTo(1, 5);
        display.lineTo(4, 5);
        display.lineTo(4, -5);
      }
    });
    r("Button", ["switch"]).setAll({
      paddingTop: 4,
      paddingBottom: 4,
      paddingLeft: 4,
      paddingRight: 4,
      ariaLabel: language.translate("Press ENTER to toggle"),
      toggleKey: "active",
      width: 40,
      height: 24,
      layout: null
    });
    {
      const rule = r("RoundedRectangle", ["switch", "background"]);
      rule.setAll({
        strokeOpacity: 0.5,
        cornerRadiusBL: 100,
        cornerRadiusBR: 100,
        cornerRadiusTL: 100,
        cornerRadiusTR: 100
      });
      setColor(rule, "fill", ic, "primaryButton");
    }
    {
      const rule = r("Circle", ["switch", "icon"]);
      rule.setAll({
        radius: 8,
        centerY: 0,
        centerX: 0,
        dx: 0
      });
      setColor(rule, "fill", ic, "primaryButtonText");
    }
    r("Graphics", ["switch", "icon"]).states.create("active", {
      dx: 16
    });
    r("Scrollbar").setAll({
      start: 0,
      end: 1,
      layer: 30,
      animationEasing: out(cubic)
    });
    r("Scrollbar", ["vertical"]).setAll({
      marginRight: 13,
      marginLeft: 13,
      minWidth: 12,
      height: p100
    });
    r("Scrollbar", ["horizontal"]).setAll({
      marginTop: 13,
      marginBottom: 13,
      minHeight: 12,
      width: p100
    });
    this.rule("Button", ["scrollbar"]).setAll({
      exportable: false
    });
    {
      const rule = r("RoundedRectangle", ["scrollbar", "main", "background"]);
      rule.setAll({
        cornerRadiusTL: 8,
        cornerRadiusBL: 8,
        cornerRadiusTR: 8,
        cornerRadiusBR: 8,
        fillOpacity: 0.8
      });
      setColor(rule, "fill", ic, "fill");
    }
    {
      const rule = r("RoundedRectangle", ["scrollbar", "thumb"]);
      rule.setAll({
        role: "slider",
        ariaLive: "polite",
        position: "absolute",
        draggable: true
      });
      setColor(rule, "fill", ic, "secondaryButton");
    }
    {
      const rule = r("RoundedRectangle", ["scrollbar", "thumb"]).states.create("hover", {});
      setColor(rule, "fill", ic, "secondaryButtonHover");
    }
    {
      const rule = r("RoundedRectangle", ["scrollbar", "thumb"]).states.create("down", { stateAnimationDuration: 0 });
      setColor(rule, "fill", ic, "secondaryButtonDown");
    }
    r("RoundedRectangle", ["scrollbar", "thumb", "vertical"]).setAll({
      x: p50,
      width: p100,
      centerX: p50,
      ariaLabel: language.translate("Use up and down arrows to move selection")
    });
    r("RoundedRectangle", ["scrollbar", "thumb", "horizontal"]).setAll({
      y: p50,
      centerY: p50,
      height: p100,
      ariaLabel: language.translate("Use left and right arrows to move selection")
    });
    {
      const rule = r("PointedRectangle", ["axis", "tooltip", "background"]);
      rule.setAll({
        cornerRadius: 0
      });
      setColor(rule, "fill", ic, "alternativeBackground");
    }
    r("Label", ["axis", "tooltip"]).setAll({
      role: void 0
    });
    r("Label", ["axis", "tooltip", "y"]).setAll({
      textAlign: "right"
    });
    r("Label", ["axis", "tooltip", "y", "opposite"]).setAll({
      textAlign: "left"
    });
    r("Label", ["axis", "tooltip", "x"]).setAll({
      textAlign: "center"
    });
    r("Tooltip", ["categoryaxis"]).setAll({
      labelText: "{category}"
    });
    r("Star").setAll({
      spikes: 5,
      innerRadius: 5,
      radius: 10
    });
    r("Tooltip", ["stock"]).setAll({
      paddingTop: 6,
      paddingBottom: 5,
      paddingLeft: 7,
      paddingRight: 7
    });
    r("PointedRectangle", ["tooltip", "stock", "axis"]).setAll({
      pointerLength: 0,
      pointerBaseWidth: 0,
      cornerRadius: 3
    });
    r("Label", ["tooltip", "stock"]).setAll({
      fontSize: "0.8em"
    });
    r("SpriteResizer").setAll({
      rotationStep: 10
    });
    {
      const rule = r("Container", ["resizer", "grip"]);
      rule.states.create("hover", {});
    }
    {
      const rule = r("RoundedRectangle", ["resizer", "grip"]);
      rule.setAll({
        strokeOpacity: 0.7,
        strokeWidth: 1,
        fillOpacity: 1,
        width: 12,
        height: 12
      });
      setColor(rule, "fill", ic, "background");
      setColor(rule, "stroke", ic, "alternativeBackground");
    }
    {
      const rule = r("RoundedRectangle", ["resizer", "grip", "outline"]);
      rule.setAll({
        strokeOpacity: 0,
        fillOpacity: 0,
        width: 20,
        height: 20
      });
      rule.states.create("hover", {
        fillOpacity: 0.3
      });
      setColor(rule, "fill", ic, "alternativeBackground");
    }
    r("RoundedRectangle", ["resizer", "grip", "left"]).setAll({
      cornerRadiusBL: 0,
      cornerRadiusBR: 0,
      cornerRadiusTL: 0,
      cornerRadiusTR: 0
    });
    r("RoundedRectangle", ["resizer", "grip", "right"]).setAll({
      cornerRadiusBL: 0,
      cornerRadiusBR: 0,
      cornerRadiusTL: 0,
      cornerRadiusTR: 0
    });
    {
      const rule = r("Rectangle", ["resizer", "rectangle"]);
      rule.setAll({
        strokeDasharray: [2, 2],
        strokeOpacity: 0.5,
        strokeWidth: 1
      });
      setColor(rule, "stroke", ic, "alternativeBackground");
    }
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Matrix.js
var Matrix = class {
  constructor(a = 1, b = 0, c = 0, d = 1, tx = 0, ty = 0) {
    Object.defineProperty(this, "a", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "b", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "c", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "d", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "tx", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "ty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.a = a;
    this.b = b;
    this.c = c;
    this.d = d;
    this.tx = tx;
    this.ty = ty;
  }
  /**
   * Sets the matrix based on all the available properties
   */
  setTransform(x2, y2, pivotX, pivotY, rotation, scale = 1) {
    this.a = Math.cos(rotation) * scale;
    this.b = Math.sin(rotation) * scale;
    this.c = -Math.sin(rotation) * scale;
    this.d = Math.cos(rotation) * scale;
    this.tx = x2 - (pivotX * this.a + pivotY * this.c);
    this.ty = y2 - (pivotX * this.b + pivotY * this.d);
  }
  /**
   * Get a new position with the current transformation applied.
   * Can be used to go from a child's coordinate space to the world coordinate space. (e.g. rendering)
   */
  apply(origin) {
    return {
      x: this.a * origin.x + this.c * origin.y + this.tx,
      y: this.b * origin.x + this.d * origin.y + this.ty
    };
  }
  /**
   * Get a new position with the inverse of the current transformation applied.
   * Can be used to go from the world coordinate space to a child's coordinate space. (e.g. input)
   */
  applyInverse(origin) {
    const id = 1 / (this.a * this.d + this.c * -this.b);
    return {
      x: this.d * id * origin.x + -this.c * id * origin.y + (this.ty * this.c - this.tx * this.d) * id,
      y: this.a * id * origin.y + -this.b * id * origin.x + (-this.ty * this.a + this.tx * this.b) * id
    };
  }
  /**
   * Appends the given Matrix to this Matrix.
   */
  append(matrix) {
    const a1 = this.a;
    const b12 = this.b;
    const c1 = this.c;
    const d1 = this.d;
    this.a = matrix.a * a1 + matrix.b * c1;
    this.b = matrix.a * b12 + matrix.b * d1;
    this.c = matrix.c * a1 + matrix.d * c1;
    this.d = matrix.c * b12 + matrix.d * d1;
    this.tx = matrix.tx * a1 + matrix.ty * c1 + this.tx;
    this.ty = matrix.tx * b12 + matrix.ty * d1 + this.ty;
  }
  /**
   * Prepends the given Matrix to this Matrix.
   */
  prepend(matrix) {
    const tx1 = this.tx;
    if (matrix.a !== 1 || matrix.b !== 0 || matrix.c !== 0 || matrix.d !== 1) {
      const a1 = this.a;
      const c1 = this.c;
      this.a = a1 * matrix.a + this.b * matrix.c;
      this.b = a1 * matrix.b + this.b * matrix.d;
      this.c = c1 * matrix.a + this.d * matrix.c;
      this.d = c1 * matrix.b + this.d * matrix.d;
    }
    this.tx = tx1 * matrix.a + this.ty * matrix.c + matrix.tx;
    this.ty = tx1 * matrix.b + this.ty * matrix.d + matrix.ty;
  }
  /**
   * Copies the other matrix's properties into this matrix
   */
  copyFrom(matrix) {
    this.a = matrix.a;
    this.b = matrix.b;
    this.c = matrix.c;
    this.d = matrix.d;
    this.tx = matrix.tx;
    this.ty = matrix.ty;
  }
};

// ../../node_modules/svg-arc-to-cubic-bezier/modules/index.js
var _slicedToArray2 = function() {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = void 0;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i)
          break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"])
          _i["return"]();
      } finally {
        if (_d)
          throw _e;
      }
    }
    return _arr;
  }
  return function(arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var TAU = Math.PI * 2;
var mapToEllipse = function mapToEllipse2(_ref, rx, ry, cosphi, sinphi, centerx, centery) {
  var x2 = _ref.x, y2 = _ref.y;
  x2 *= rx;
  y2 *= ry;
  var xp = cosphi * x2 - sinphi * y2;
  var yp = sinphi * x2 + cosphi * y2;
  return {
    x: xp + centerx,
    y: yp + centery
  };
};
var approxUnitArc = function approxUnitArc2(ang1, ang2) {
  var a = ang2 === 1.5707963267948966 ? 0.551915024494 : ang2 === -1.5707963267948966 ? -0.551915024494 : 4 / 3 * Math.tan(ang2 / 4);
  var x1 = Math.cos(ang1);
  var y1 = Math.sin(ang1);
  var x2 = Math.cos(ang1 + ang2);
  var y2 = Math.sin(ang1 + ang2);
  return [{
    x: x1 - y1 * a,
    y: y1 + x1 * a
  }, {
    x: x2 + y2 * a,
    y: y2 - x2 * a
  }, {
    x: x2,
    y: y2
  }];
};
var vectorAngle = function vectorAngle2(ux, uy, vx, vy) {
  var sign2 = ux * vy - uy * vx < 0 ? -1 : 1;
  var dot = ux * vx + uy * vy;
  if (dot > 1) {
    dot = 1;
  }
  if (dot < -1) {
    dot = -1;
  }
  return sign2 * Math.acos(dot);
};
var getArcCenter = function getArcCenter2(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp) {
  var rxsq = Math.pow(rx, 2);
  var rysq = Math.pow(ry, 2);
  var pxpsq = Math.pow(pxp, 2);
  var pypsq = Math.pow(pyp, 2);
  var radicant = rxsq * rysq - rxsq * pypsq - rysq * pxpsq;
  if (radicant < 0) {
    radicant = 0;
  }
  radicant /= rxsq * pypsq + rysq * pxpsq;
  radicant = Math.sqrt(radicant) * (largeArcFlag === sweepFlag ? -1 : 1);
  var centerxp = radicant * rx / ry * pyp;
  var centeryp = radicant * -ry / rx * pxp;
  var centerx = cosphi * centerxp - sinphi * centeryp + (px + cx) / 2;
  var centery = sinphi * centerxp + cosphi * centeryp + (py + cy) / 2;
  var vx1 = (pxp - centerxp) / rx;
  var vy1 = (pyp - centeryp) / ry;
  var vx2 = (-pxp - centerxp) / rx;
  var vy2 = (-pyp - centeryp) / ry;
  var ang1 = vectorAngle(1, 0, vx1, vy1);
  var ang2 = vectorAngle(vx1, vy1, vx2, vy2);
  if (sweepFlag === 0 && ang2 > 0) {
    ang2 -= TAU;
  }
  if (sweepFlag === 1 && ang2 < 0) {
    ang2 += TAU;
  }
  return [centerx, centery, ang1, ang2];
};
var arcToBezier = function arcToBezier2(_ref2) {
  var px = _ref2.px, py = _ref2.py, cx = _ref2.cx, cy = _ref2.cy, rx = _ref2.rx, ry = _ref2.ry, _ref2$xAxisRotation = _ref2.xAxisRotation, xAxisRotation = _ref2$xAxisRotation === void 0 ? 0 : _ref2$xAxisRotation, _ref2$largeArcFlag = _ref2.largeArcFlag, largeArcFlag = _ref2$largeArcFlag === void 0 ? 0 : _ref2$largeArcFlag, _ref2$sweepFlag = _ref2.sweepFlag, sweepFlag = _ref2$sweepFlag === void 0 ? 0 : _ref2$sweepFlag;
  var curves = [];
  if (rx === 0 || ry === 0) {
    return [];
  }
  var sinphi = Math.sin(xAxisRotation * TAU / 360);
  var cosphi = Math.cos(xAxisRotation * TAU / 360);
  var pxp = cosphi * (px - cx) / 2 + sinphi * (py - cy) / 2;
  var pyp = -sinphi * (px - cx) / 2 + cosphi * (py - cy) / 2;
  if (pxp === 0 && pyp === 0) {
    return [];
  }
  rx = Math.abs(rx);
  ry = Math.abs(ry);
  var lambda = Math.pow(pxp, 2) / Math.pow(rx, 2) + Math.pow(pyp, 2) / Math.pow(ry, 2);
  if (lambda > 1) {
    rx *= Math.sqrt(lambda);
    ry *= Math.sqrt(lambda);
  }
  var _getArcCenter = getArcCenter(px, py, cx, cy, rx, ry, largeArcFlag, sweepFlag, sinphi, cosphi, pxp, pyp), _getArcCenter2 = _slicedToArray2(_getArcCenter, 4), centerx = _getArcCenter2[0], centery = _getArcCenter2[1], ang1 = _getArcCenter2[2], ang2 = _getArcCenter2[3];
  var ratio = Math.abs(ang2) / (TAU / 4);
  if (Math.abs(1 - ratio) < 1e-7) {
    ratio = 1;
  }
  var segments = Math.max(Math.ceil(ratio), 1);
  ang2 /= segments;
  for (var i = 0; i < segments; i++) {
    curves.push(approxUnitArc(ang1, ang2));
    ang1 += ang2;
  }
  return curves.map(function(curve) {
    var _mapToEllipse = mapToEllipse(curve[0], rx, ry, cosphi, sinphi, centerx, centery), x1 = _mapToEllipse.x, y1 = _mapToEllipse.y;
    var _mapToEllipse2 = mapToEllipse(curve[1], rx, ry, cosphi, sinphi, centerx, centery), x2 = _mapToEllipse2.x, y2 = _mapToEllipse2.y;
    var _mapToEllipse3 = mapToEllipse(curve[2], rx, ry, cosphi, sinphi, centerx, centery), x3 = _mapToEllipse3.x, y3 = _mapToEllipse3.y;
    return { x1, y1, x2, y2, x: x3, y: y3 };
  });
};
var modules_default = arcToBezier;

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/backend/CanvasRenderer.js
function checkArgs(name, actual, expected) {
  if (actual !== expected) {
    throw new Error("Required " + expected + " arguments for " + name + " but got " + actual);
  }
}
function checkMinArgs(name, actual, expected) {
  if (actual < expected) {
    throw new Error("Required at least " + expected + " arguments for " + name + " but got " + actual);
  }
}
function checkEvenArgs(name, actual, expected) {
  checkMinArgs(name, actual, expected);
  if (actual % expected !== 0) {
    throw new Error("Arguments for " + name + " must be in pairs of " + expected);
  }
}
function splitArcFlags(args) {
  for (let i = 0; i < args.length; i += 7) {
    let index2 = i + 3;
    let flag = args[index2];
    if (flag.length > 1) {
      const a = /^([01])([01])(.*)$/.exec(flag);
      if (a !== null) {
        args.splice(index2, 0, a[1]);
        ++index2;
        args.splice(index2, 0, a[2]);
        ++index2;
        if (a[3].length > 0) {
          args[index2] = a[3];
        } else {
          args.splice(index2, 1);
        }
      }
    }
    ++index2;
    flag = args[index2];
    if (flag.length > 1) {
      const a = /^([01])(.+)$/.exec(flag);
      if (a !== null) {
        args.splice(index2, 0, a[1]);
        ++index2;
        args[index2] = a[2];
      }
    }
  }
}
function assertBinary(value) {
  if (value === 0 || value === 1) {
    return value;
  } else {
    throw new Error("Flag must be 0 or 1");
  }
}
function distributeId(id) {
  const rgb = [0, 0, 0];
  for (let i = 0; i < 24; i++) {
    rgb[i % 3] <<= 1;
    rgb[i % 3] |= id & 1;
    id >>= 1;
  }
  return (rgb[0] | 0) + (rgb[1] << 8) + (rgb[2] << 16);
}
function eachTargets(hitTarget, f) {
  for (; ; ) {
    if (hitTarget.interactive) {
      if (!f(hitTarget)) {
        break;
      }
    }
    if (hitTarget._parent) {
      hitTarget = hitTarget._parent;
    } else {
      break;
    }
  }
}
function onPointerEvent(element, name, f) {
  return addEventListener(element, getRendererEvent(name), (event) => {
    const target = getEventTarget(event);
    let touches = event.touches;
    if (touches) {
      if (touches.length == 0) {
        touches = event.changedTouches;
      }
      f(copy2(touches), target);
    } else {
      f([event], target);
    }
  });
}
function isTainted(image) {
  const canvas = document.createElement("canvas");
  canvas.width = 1;
  canvas.height = 1;
  const context = canvas.getContext("2d", { willReadFrequently: true });
  context.drawImage(image, 0, 0, 1, 1);
  try {
    context.getImageData(0, 0, 1, 1);
    return false;
  } catch (err) {
    console.warn('Image "' + image.src + '" is loaded from different host and is not covered by CORS policy. For more information about the implications read here: https://www.amcharts.com/docs/v5/concepts/cors');
    return true;
  }
}
function clearCanvas(view) {
  view.width = 0;
  view.height = 0;
  view.style.width = "0px";
  view.style.height = "0px";
}
function crisp(x2) {
  return Math.floor(x2) + 0.5;
}
var CanvasPivot = class {
  constructor() {
    Object.defineProperty(this, "_x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
  }
  get x() {
    return this._x;
  }
  get y() {
    return this._y;
  }
  set x(value) {
    this._x = value;
  }
  set y(value) {
    this._y = value;
  }
};
var CanvasDisplayObject = class extends DisposerClass {
  constructor(renderer) {
    super();
    Object.defineProperty(this, "_layer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "mask", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, "visible", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "exportable", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "interactive", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "inactive", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, "wheelable", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "cancelTouch", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "isMeasured", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "buttonMode", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "alpha", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "compoundAlpha", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "angle", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "scale", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "crisp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "pivot", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new CanvasPivot()
    });
    Object.defineProperty(this, "filter", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "cursorOverStyle", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_replacedCursorStyle", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_localMatrix", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new Matrix()
    });
    Object.defineProperty(this, "_matrix", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new Matrix()
    });
    Object.defineProperty(this, "_uMatrix", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new Matrix()
    });
    Object.defineProperty(this, "_renderer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_parent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_localBounds", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_bounds", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_colorId", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this._renderer = renderer;
  }
  subStatus(status) {
    return {
      inactive: this.inactive == null ? status.inactive : this.inactive,
      layer: this._layer || status.layer
    };
  }
  _dispose() {
    this._renderer._removeObject(this);
    this.getLayer().dirty = true;
  }
  getCanvas() {
    return this.getLayer().view;
  }
  getLayer() {
    let self2 = this;
    for (; ; ) {
      if (self2._layer) {
        return self2._layer;
      } else if (self2._parent) {
        self2 = self2._parent;
      } else {
        return this._renderer.defaultLayer;
      }
    }
  }
  setLayer(order, margin) {
    if (order == null) {
      this._layer = void 0;
    } else {
      const visible = true;
      this._layer = this._renderer.getLayer(order, visible);
      this._layer.visible = visible;
      this._layer.margin = margin;
      if (margin) {
        setInteractive(this._layer.view, false);
      }
      this._renderer._ghostLayer.setMargin(this._renderer.layers);
      if (this._parent) {
        this._parent.registerChildLayer(this._layer);
      }
      this._layer.dirty = true;
      this._renderer.resizeLayer(this._layer);
      this._renderer.resizeGhost();
    }
  }
  markDirtyLayer() {
    this.getLayer().dirty = true;
  }
  clear() {
    this.invalidateBounds();
  }
  invalidateBounds() {
    this._localBounds = void 0;
  }
  _addBounds(_bounds) {
  }
  _getColorId() {
    if (this._colorId === void 0) {
      this._colorId = this._renderer.paintId(this);
    }
    return this._colorId;
  }
  _isInteractive(status) {
    return !status.inactive && (this.interactive || this._renderer._forceInteractive > 0);
  }
  _isInteractiveMask(status) {
    return this._isInteractive(status);
  }
  contains(child) {
    for (; ; ) {
      if (child === this) {
        return true;
      } else if (child._parent) {
        child = child._parent;
      } else {
        return false;
      }
    }
  }
  toGlobal(point2) {
    return this._matrix.apply(point2);
  }
  toLocal(point2) {
    return this._matrix.applyInverse(point2);
  }
  getLocalMatrix() {
    this._uMatrix.setTransform(0, 0, this.pivot.x, this.pivot.y, this.angle * Math.PI / 180, this.scale);
    return this._uMatrix;
  }
  getLocalBounds() {
    if (!this._localBounds) {
      const bn = 1e7;
      this._localBounds = {
        left: bn,
        top: bn,
        right: -bn,
        bottom: -bn
      };
      this._addBounds(this._localBounds);
    }
    return this._localBounds;
  }
  getAdjustedBounds(bounds) {
    this._setMatrix();
    const matrix = this.getLocalMatrix();
    const p02 = matrix.apply({ x: bounds.left, y: bounds.top });
    const p1 = matrix.apply({ x: bounds.right, y: bounds.top });
    const p2 = matrix.apply({ x: bounds.right, y: bounds.bottom });
    const p3 = matrix.apply({ x: bounds.left, y: bounds.bottom });
    return {
      left: Math.min(p02.x, p1.x, p2.x, p3.x),
      top: Math.min(p02.y, p1.y, p2.y, p3.y),
      right: Math.max(p02.x, p1.x, p2.x, p3.x),
      bottom: Math.max(p02.y, p1.y, p2.y, p3.y)
    };
  }
  on(key, callback, context) {
    if (this.interactive) {
      return this._renderer._addEvent(this, key, callback, context);
    } else {
      return new Disposer(() => {
      });
    }
  }
  _setMatrix() {
    this._localMatrix.setTransform(
      this.x,
      this.y,
      this.pivot.x,
      this.pivot.y,
      // Converts degrees to radians
      this.angle * Math.PI / 180,
      this.scale
    );
    this._matrix.copyFrom(this._localMatrix);
    if (this._parent) {
      this._matrix.prepend(this._parent._matrix);
    }
  }
  _transform(context, resolution) {
    const m = this._matrix;
    let tx = m.tx * resolution;
    let ty = m.ty * resolution;
    if (this.crisp) {
      tx = crisp(tx);
      ty = crisp(ty);
    }
    context.setTransform(m.a * resolution, m.b * resolution, m.c * resolution, m.d * resolution, tx, ty);
  }
  _transformMargin(context, resolution, margin) {
    const m = this._matrix;
    context.setTransform(m.a * resolution, m.b * resolution, m.c * resolution, m.d * resolution, (m.tx + margin.left) * resolution, (m.ty + margin.top) * resolution);
  }
  _transformLayer(context, resolution, layer) {
    if (layer.margin) {
      this._transformMargin(context, layer.scale || resolution, layer.margin);
    } else {
      this._transform(context, layer.scale || resolution);
    }
  }
  render(status) {
    if (this.visible && (this.exportable !== false || !this._renderer._omitTainted)) {
      this._setMatrix();
      const subStatus = this.subStatus(status);
      const resolution = this._renderer.resolution;
      const layers = this._renderer.layers;
      const ghostLayer = this._renderer._ghostLayer;
      const ghostContext = ghostLayer.context;
      const mask = this.mask;
      if (mask) {
        mask._setMatrix();
      }
      each(layers, (layer) => {
        if (layer) {
          const context = layer.context;
          context.save();
          if (mask) {
            mask._transformLayer(context, resolution, layer);
            mask._runPath(context);
            context.clip();
          }
          context.globalAlpha = this.compoundAlpha * this.alpha;
          this._transformLayer(context, resolution, layer);
          if (this.filter) {
            context.filter = this.filter;
          }
        }
      });
      ghostContext.save();
      if (mask && this._isInteractiveMask(subStatus)) {
        mask._transformMargin(ghostContext, resolution, ghostLayer.margin);
        mask._runPath(ghostContext);
        ghostContext.clip();
      }
      this._transformMargin(ghostContext, resolution, ghostLayer.margin);
      this._render(subStatus);
      ghostContext.restore();
      each(layers, (layer) => {
        if (layer) {
          layer.context.restore();
        }
      });
    }
  }
  _render(status) {
    if (this.exportable === false) {
      status.layer.tainted = true;
    }
  }
  hovering() {
    return this._renderer._hovering.has(this);
  }
  dragging() {
    return this._renderer._dragging.some((x2) => x2.value === this);
  }
  shouldCancelTouch() {
    const renderer = this._renderer;
    if (renderer.tapToActivate && !renderer._touchActive) {
      return false;
    }
    if (this.cancelTouch) {
      return true;
    } else if (this._parent) {
      return this._parent.shouldCancelTouch();
    }
    return false;
  }
};
var CanvasContainer = class extends CanvasDisplayObject {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "interactiveChildren", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "_childLayers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_children", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
  }
  _isInteractiveMask(status) {
    return this.interactiveChildren || super._isInteractiveMask(status);
  }
  addChild(child) {
    child._parent = this;
    this._children.push(child);
    if (child._layer) {
      this.registerChildLayer(child._layer);
    }
  }
  addChildAt(child, index2) {
    child._parent = this;
    this._children.splice(index2, 0, child);
    if (child._layer) {
      this.registerChildLayer(child._layer);
    }
  }
  removeChild(child) {
    child._parent = void 0;
    removeFirst(this._children, child);
  }
  _render(status) {
    super._render(status);
    const renderer = this._renderer;
    if (this.interactive && this.interactiveChildren) {
      ++renderer._forceInteractive;
    }
    each(this._children, (child) => {
      child.compoundAlpha = this.compoundAlpha * this.alpha;
      child.render(status);
    });
    if (this.interactive && this.interactiveChildren) {
      --renderer._forceInteractive;
    }
  }
  registerChildLayer(layer) {
    if (!this._childLayers) {
      this._childLayers = [];
    }
    pushOne(this._childLayers, layer);
    if (this._parent) {
      this._parent.registerChildLayer(layer);
    }
  }
  markDirtyLayer(deep = false) {
    super.markDirtyLayer();
    if (deep && this._childLayers) {
      each(this._childLayers, (layer) => layer.dirty = true);
    }
  }
  _dispose() {
    super._dispose();
    if (this._childLayers) {
      each(this._childLayers, (layer) => {
        layer.dirty = true;
      });
    }
  }
};
function setPoint(bounds, point2) {
  bounds.left = Math.min(bounds.left, point2.x);
  bounds.top = Math.min(bounds.top, point2.y);
  bounds.right = Math.max(bounds.right, point2.x);
  bounds.bottom = Math.max(bounds.bottom, point2.y);
}
var Op = class {
  colorize(_context, _forceColor) {
  }
  path(_context) {
  }
  addBounds(_bounds) {
  }
};
var BeginPath = class extends Op {
  colorize(context, _forceColor) {
    context.beginPath();
  }
};
var BeginFill = class extends Op {
  constructor(color2) {
    super();
    Object.defineProperty(this, "color", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: color2
    });
  }
  colorize(context, forceColor) {
    if (forceColor !== void 0) {
      context.fillStyle = forceColor;
    } else {
      context.fillStyle = this.color;
    }
  }
};
var EndFill = class extends Op {
  constructor(clearShadow) {
    super();
    Object.defineProperty(this, "clearShadow", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: clearShadow
    });
  }
  colorize(context, _forceColor) {
    context.fill();
    if (this.clearShadow) {
      context.shadowColor = "";
      context.shadowBlur = 0;
      context.shadowOffsetX = 0;
      context.shadowOffsetY = 0;
    }
  }
};
var EndStroke = class extends Op {
  colorize(context, _forceColor) {
    context.stroke();
  }
};
var LineStyle = class extends Op {
  constructor(width, color2, lineJoin) {
    super();
    Object.defineProperty(this, "width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: width
    });
    Object.defineProperty(this, "color", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: color2
    });
    Object.defineProperty(this, "lineJoin", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: lineJoin
    });
  }
  colorize(context, forceColor) {
    if (forceColor !== void 0) {
      context.strokeStyle = forceColor;
    } else {
      context.strokeStyle = this.color;
    }
    context.lineWidth = this.width;
    if (this.lineJoin) {
      context.lineJoin = this.lineJoin;
    }
  }
};
var LineDash = class extends Op {
  constructor(dash) {
    super();
    Object.defineProperty(this, "dash", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: dash
    });
  }
  colorize(context, _forceColor) {
    context.setLineDash(this.dash);
  }
};
var LineDashOffset = class extends Op {
  constructor(dashOffset) {
    super();
    Object.defineProperty(this, "dashOffset", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: dashOffset
    });
  }
  colorize(context, _forceColor) {
    context.lineDashOffset = this.dashOffset;
  }
};
var DrawRect = class extends Op {
  constructor(x2, y2, width, height) {
    super();
    Object.defineProperty(this, "x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: x2
    });
    Object.defineProperty(this, "y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: y2
    });
    Object.defineProperty(this, "width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: width
    });
    Object.defineProperty(this, "height", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: height
    });
  }
  path(context) {
    context.rect(this.x, this.y, this.width, this.height);
  }
  addBounds(bounds) {
    const l = this.x;
    const t = this.y;
    const r = l + this.width;
    const b = t + this.height;
    setPoint(bounds, { x: l, y: t });
    setPoint(bounds, { x: r, y: t });
    setPoint(bounds, { x: l, y: b });
    setPoint(bounds, { x: r, y: b });
  }
};
var DrawCircle = class extends Op {
  constructor(x2, y2, radius) {
    super();
    Object.defineProperty(this, "x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: x2
    });
    Object.defineProperty(this, "y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: y2
    });
    Object.defineProperty(this, "radius", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: radius
    });
  }
  path(context) {
    context.moveTo(this.x + this.radius, this.y);
    context.arc(this.x, this.y, this.radius, 0, 2 * Math.PI);
  }
  // TODO handle skewing and rotation
  addBounds(bounds) {
    setPoint(bounds, { x: this.x - this.radius, y: this.y - this.radius });
    setPoint(bounds, { x: this.x + this.radius, y: this.y + this.radius });
  }
};
var DrawEllipse = class extends Op {
  constructor(x2, y2, radiusX, radiusY) {
    super();
    Object.defineProperty(this, "x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: x2
    });
    Object.defineProperty(this, "y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: y2
    });
    Object.defineProperty(this, "radiusX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: radiusX
    });
    Object.defineProperty(this, "radiusY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: radiusY
    });
  }
  path(context) {
    context.ellipse(0, 0, this.radiusX, this.radiusY, 0, 0, Math.PI * 2);
  }
  // TODO handle skewing and rotation
  addBounds(bounds) {
    setPoint(bounds, { x: this.x - this.radiusX, y: this.y - this.radiusY });
    setPoint(bounds, { x: this.x + this.radiusX, y: this.y + this.radiusY });
  }
};
var Arc = class extends Op {
  constructor(cx, cy, radius, startAngle, endAngle, anticlockwise) {
    super();
    Object.defineProperty(this, "cx", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: cx
    });
    Object.defineProperty(this, "cy", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: cy
    });
    Object.defineProperty(this, "radius", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: radius
    });
    Object.defineProperty(this, "startAngle", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: startAngle
    });
    Object.defineProperty(this, "endAngle", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: endAngle
    });
    Object.defineProperty(this, "anticlockwise", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: anticlockwise
    });
  }
  path(context) {
    if (this.radius > 0) {
      context.arc(this.cx, this.cy, this.radius, this.startAngle, this.endAngle, this.anticlockwise);
    }
  }
  addBounds(bounds) {
    let arcBounds = getArcBounds(this.cx, this.cy, this.startAngle * DEGREES, this.endAngle * DEGREES, this.radius);
    setPoint(bounds, { x: arcBounds.left, y: arcBounds.top });
    setPoint(bounds, { x: arcBounds.right, y: arcBounds.bottom });
  }
};
var ArcTo = class extends Op {
  constructor(x1, y1, x2, y2, radius) {
    super();
    Object.defineProperty(this, "x1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: x1
    });
    Object.defineProperty(this, "y1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: y1
    });
    Object.defineProperty(this, "x2", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: x2
    });
    Object.defineProperty(this, "y2", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: y2
    });
    Object.defineProperty(this, "radius", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: radius
    });
  }
  path(context) {
    if (this.radius > 0) {
      context.arcTo(this.x1, this.y1, this.x2, this.y2, this.radius);
    }
  }
  // TODO: add points
  addBounds(_bounds) {
  }
};
var LineTo = class extends Op {
  constructor(x2, y2) {
    super();
    Object.defineProperty(this, "x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: x2
    });
    Object.defineProperty(this, "y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: y2
    });
  }
  path(context) {
    context.lineTo(this.x, this.y);
  }
  addBounds(bounds) {
    setPoint(bounds, { x: this.x, y: this.y });
  }
};
var MoveTo = class extends Op {
  constructor(x2, y2) {
    super();
    Object.defineProperty(this, "x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: x2
    });
    Object.defineProperty(this, "y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: y2
    });
  }
  path(context) {
    context.moveTo(this.x, this.y);
  }
  addBounds(bounds) {
    setPoint(bounds, { x: this.x, y: this.y });
  }
};
var ClosePath = class extends Op {
  path(context) {
    context.closePath();
  }
};
var BezierCurveTo = class extends Op {
  constructor(cpX, cpY, cpX2, cpY2, toX, toY) {
    super();
    Object.defineProperty(this, "cpX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: cpX
    });
    Object.defineProperty(this, "cpY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: cpY
    });
    Object.defineProperty(this, "cpX2", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: cpX2
    });
    Object.defineProperty(this, "cpY2", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: cpY2
    });
    Object.defineProperty(this, "toX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: toX
    });
    Object.defineProperty(this, "toY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: toY
    });
  }
  path(context) {
    context.bezierCurveTo(this.cpX, this.cpY, this.cpX2, this.cpY2, this.toX, this.toY);
  }
  // TODO: OK?
  addBounds(bounds) {
    setPoint(bounds, { x: this.cpX, y: this.cpY });
    setPoint(bounds, { x: this.cpX2, y: this.cpY2 });
    setPoint(bounds, { x: this.toX, y: this.toY });
  }
};
var QuadraticCurveTo = class extends Op {
  constructor(cpX, cpY, toX, toY) {
    super();
    Object.defineProperty(this, "cpX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: cpX
    });
    Object.defineProperty(this, "cpY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: cpY
    });
    Object.defineProperty(this, "toX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: toX
    });
    Object.defineProperty(this, "toY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: toY
    });
  }
  path(context) {
    context.quadraticCurveTo(this.cpX, this.cpY, this.toX, this.toY);
  }
  // TODO: OK?
  addBounds(bounds) {
    setPoint(bounds, { x: this.cpX, y: this.cpY });
    setPoint(bounds, { x: this.toX, y: this.toY });
  }
};
var Shadow = class extends Op {
  constructor(color2, blur2, offsetX, offsetY, opacity) {
    super();
    Object.defineProperty(this, "color", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: color2
    });
    Object.defineProperty(this, "blur", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: blur2
    });
    Object.defineProperty(this, "offsetX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: offsetX
    });
    Object.defineProperty(this, "offsetY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: offsetY
    });
    Object.defineProperty(this, "opacity", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: opacity
    });
  }
  colorize(context, _forceColor) {
    if (this.opacity) {
      context.fillStyle = this.color;
    }
    context.shadowColor = this.color;
    context.shadowBlur = this.blur;
    context.shadowOffsetX = this.offsetX;
    context.shadowOffsetY = this.offsetY;
  }
};
var GraphicsImage = class extends Op {
  constructor(image, width, height, x2, y2) {
    super();
    Object.defineProperty(this, "image", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: image
    });
    Object.defineProperty(this, "width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: width
    });
    Object.defineProperty(this, "height", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: height
    });
    Object.defineProperty(this, "x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: x2
    });
    Object.defineProperty(this, "y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: y2
    });
  }
  path(context) {
    context.drawImage(this.image, this.x, this.y, this.width, this.height);
  }
  // TODO: OK?
  addBounds(bounds) {
    setPoint(bounds, { x: this.x, y: this.y });
    setPoint(bounds, { x: this.width, y: this.height });
  }
};
var CanvasGraphics = class extends CanvasDisplayObject {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_operations", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "blendMode", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: BlendMode.NORMAL
    });
    Object.defineProperty(this, "_hasShadows", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_fillAlpha", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_strokeAlpha", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  clear() {
    super.clear();
    this._operations.length = 0;
  }
  _pushOp(op) {
    this._operations.push(op);
  }
  beginFill(color2, alpha = 1) {
    this._fillAlpha = alpha;
    if (color2) {
      if (color2 instanceof Color) {
        this._pushOp(new BeginFill(color2.toCSS(alpha)));
      } else {
        this.isMeasured = true;
        this._pushOp(new BeginFill(color2));
      }
    } else {
      this._pushOp(new BeginFill("rgba(0, 0, 0, " + alpha + ")"));
    }
  }
  endFill() {
    this._pushOp(new EndFill(this._hasShadows));
  }
  endStroke() {
    this._pushOp(new EndStroke());
  }
  beginPath() {
    this._pushOp(new BeginPath());
  }
  lineStyle(width = 0, color2, alpha = 1, lineJoin) {
    this._strokeAlpha = alpha;
    if (color2) {
      if (color2 instanceof Color) {
        this._pushOp(new LineStyle(width, color2.toCSS(alpha), lineJoin));
      } else {
        this._pushOp(new LineStyle(width, color2, lineJoin));
      }
    } else {
      this._pushOp(new LineStyle(width, "rgba(0, 0, 0, " + alpha + ")", lineJoin));
    }
  }
  setLineDash(dash) {
    this._pushOp(new LineDash(dash ? dash : []));
  }
  setLineDashOffset(dashOffset = 0) {
    this._pushOp(new LineDashOffset(dashOffset));
  }
  drawRect(x2, y2, width, height) {
    this._pushOp(new DrawRect(x2, y2, width, height));
  }
  drawCircle(x2, y2, radius) {
    this._pushOp(new DrawCircle(x2, y2, radius));
  }
  drawEllipse(x2, y2, radiusX, radiusY) {
    this._pushOp(new DrawEllipse(x2, y2, radiusX, radiusY));
  }
  arc(cx, cy, radius, startAngle, endAngle, anticlockwise = false) {
    this._pushOp(new Arc(cx, cy, radius, startAngle, endAngle, anticlockwise));
  }
  arcTo(x1, y1, x2, y2, radius) {
    this._pushOp(new ArcTo(x1, y1, x2, y2, radius));
  }
  lineTo(x2, y2) {
    this._pushOp(new LineTo(x2, y2));
  }
  moveTo(x2, y2) {
    this._pushOp(new MoveTo(x2, y2));
  }
  bezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY) {
    this._pushOp(new BezierCurveTo(cpX, cpY, cpX2, cpY2, toX, toY));
  }
  quadraticCurveTo(cpX, cpY, toX, toY) {
    this._pushOp(new QuadraticCurveTo(cpX, cpY, toX, toY));
  }
  closePath() {
    this._pushOp(new ClosePath());
  }
  shadow(color2, blur2 = 0, offsetX = 0, offsetY = 0, opacity) {
    this._hasShadows = true;
    this._pushOp(new Shadow(opacity ? color2.toCSS(opacity) : color2.toCSS(this._fillAlpha || this._strokeAlpha), blur2, offsetX, offsetY));
  }
  image(image, width, height, x2, y2) {
    this._pushOp(new GraphicsImage(image, width, height, x2, y2));
  }
  // https://svgwg.org/svg2-draft/paths.html#DProperty
  // TODO better error checking
  svgPath(path2) {
    let x2 = 0;
    let y2 = 0;
    let cpx = null;
    let cpy = null;
    let qcpx = null;
    let qcpy = null;
    const SEGMENTS_REGEXP = /([MmZzLlHhVvCcSsQqTtAa])([^MmZzLlHhVvCcSsQqTtAa]*)/g;
    const ARGS_REGEXP = /[\u0009\u0020\u000A\u000C\u000D]*([\+\-]?[0-9]*\.?[0-9]+(?:[eE][\+\-]?[0-9]+)?)[\u0009\u0020\u000A\u000C\u000D]*,?/g;
    let match2;
    while ((match2 = SEGMENTS_REGEXP.exec(path2)) !== null) {
      const name = match2[1];
      const rest = match2[2];
      const args = [];
      while ((match2 = ARGS_REGEXP.exec(rest)) !== null) {
        args.push(match2[1]);
      }
      if (name !== "S" && name !== "s" && name !== "C" && name !== "c") {
        cpx = null;
        cpy = null;
      }
      if (name !== "Q" && name !== "q" && name !== "T" && name !== "t") {
        qcpx = null;
        qcpy = null;
      }
      switch (name) {
        case "M":
          checkEvenArgs(name, args.length, 2);
          x2 = +args[0];
          y2 = +args[1];
          this.moveTo(x2, y2);
          for (let i = 2; i < args.length; i += 2) {
            x2 = +args[i];
            y2 = +args[i + 1];
            this.lineTo(x2, y2);
          }
          break;
        case "m":
          checkEvenArgs(name, args.length, 2);
          x2 += +args[0];
          y2 += +args[1];
          this.moveTo(x2, y2);
          for (let i = 2; i < args.length; i += 2) {
            x2 += +args[i];
            y2 += +args[i + 1];
            this.lineTo(x2, y2);
          }
          break;
        case "L":
          checkEvenArgs(name, args.length, 2);
          for (let i = 0; i < args.length; i += 2) {
            x2 = +args[i];
            y2 = +args[i + 1];
            this.lineTo(x2, y2);
          }
          break;
        case "l":
          checkEvenArgs(name, args.length, 2);
          for (let i = 0; i < args.length; i += 2) {
            x2 += +args[i];
            y2 += +args[i + 1];
            this.lineTo(x2, y2);
          }
          break;
        case "H":
          checkMinArgs(name, args.length, 1);
          for (let i = 0; i < args.length; ++i) {
            x2 = +args[i];
            this.lineTo(x2, y2);
          }
          break;
        case "h":
          checkMinArgs(name, args.length, 1);
          for (let i = 0; i < args.length; ++i) {
            x2 += +args[i];
            this.lineTo(x2, y2);
          }
          break;
        case "V":
          checkMinArgs(name, args.length, 1);
          for (let i = 0; i < args.length; ++i) {
            y2 = +args[i];
            this.lineTo(x2, y2);
          }
          break;
        case "v":
          checkMinArgs(name, args.length, 1);
          for (let i = 0; i < args.length; ++i) {
            y2 += +args[i];
            this.lineTo(x2, y2);
          }
          break;
        case "C":
          checkEvenArgs(name, args.length, 6);
          for (let i = 0; i < args.length; i += 6) {
            const x1 = +args[i];
            const y1 = +args[i + 1];
            cpx = +args[i + 2];
            cpy = +args[i + 3];
            x2 = +args[i + 4];
            y2 = +args[i + 5];
            this.bezierCurveTo(x1, y1, cpx, cpy, x2, y2);
          }
          break;
        case "c":
          checkEvenArgs(name, args.length, 6);
          for (let i = 0; i < args.length; i += 6) {
            const x1 = +args[i] + x2;
            const y1 = +args[i + 1] + y2;
            cpx = +args[i + 2] + x2;
            cpy = +args[i + 3] + y2;
            x2 += +args[i + 4];
            y2 += +args[i + 5];
            this.bezierCurveTo(x1, y1, cpx, cpy, x2, y2);
          }
          break;
        case "S":
          checkEvenArgs(name, args.length, 4);
          if (cpx === null || cpy === null) {
            cpx = x2;
            cpy = y2;
          }
          for (let i = 0; i < args.length; i += 4) {
            const x1 = 2 * x2 - cpx;
            const y1 = 2 * y2 - cpy;
            cpx = +args[i];
            cpy = +args[i + 1];
            x2 = +args[i + 2];
            y2 = +args[i + 3];
            this.bezierCurveTo(x1, y1, cpx, cpy, x2, y2);
          }
          break;
        case "s":
          checkEvenArgs(name, args.length, 4);
          if (cpx === null || cpy === null) {
            cpx = x2;
            cpy = y2;
          }
          for (let i = 0; i < args.length; i += 4) {
            const x1 = 2 * x2 - cpx;
            const y1 = 2 * y2 - cpy;
            cpx = +args[i] + x2;
            cpy = +args[i + 1] + y2;
            x2 += +args[i + 2];
            y2 += +args[i + 3];
            this.bezierCurveTo(x1, y1, cpx, cpy, x2, y2);
          }
          break;
        case "Q":
          checkEvenArgs(name, args.length, 4);
          for (let i = 0; i < args.length; i += 4) {
            qcpx = +args[i];
            qcpy = +args[i + 1];
            x2 = +args[i + 2];
            y2 = +args[i + 3];
            this.quadraticCurveTo(qcpx, qcpy, x2, y2);
          }
          break;
        case "q":
          checkEvenArgs(name, args.length, 4);
          for (let i = 0; i < args.length; i += 4) {
            qcpx = +args[i] + x2;
            qcpy = +args[i + 1] + y2;
            x2 += +args[i + 2];
            y2 += +args[i + 3];
            this.quadraticCurveTo(qcpx, qcpy, x2, y2);
          }
          break;
        case "T":
          checkEvenArgs(name, args.length, 2);
          if (qcpx === null || qcpy === null) {
            qcpx = x2;
            qcpy = y2;
          }
          for (let i = 0; i < args.length; i += 2) {
            qcpx = 2 * x2 - qcpx;
            qcpy = 2 * y2 - qcpy;
            x2 = +args[i];
            y2 = +args[i + 1];
            this.quadraticCurveTo(qcpx, qcpy, x2, y2);
          }
          break;
        case "t":
          checkEvenArgs(name, args.length, 2);
          if (qcpx === null || qcpy === null) {
            qcpx = x2;
            qcpy = y2;
          }
          for (let i = 0; i < args.length; i += 2) {
            qcpx = 2 * x2 - qcpx;
            qcpy = 2 * y2 - qcpy;
            x2 += +args[i];
            y2 += +args[i + 1];
            this.quadraticCurveTo(qcpx, qcpy, x2, y2);
          }
          break;
        case "A":
        case "a":
          const relative = name === "a";
          splitArcFlags(args);
          checkEvenArgs(name, args.length, 7);
          for (let i = 0; i < args.length; i += 7) {
            let cx = +args[i + 5];
            let cy = +args[i + 6];
            if (relative) {
              cx += x2;
              cy += y2;
            }
            const bs = modules_default({
              px: x2,
              py: y2,
              rx: +args[i],
              ry: +args[i + 1],
              xAxisRotation: +args[i + 2],
              largeArcFlag: assertBinary(+args[i + 3]),
              sweepFlag: assertBinary(+args[i + 4]),
              cx,
              cy
            });
            each(bs, (b) => {
              this.bezierCurveTo(b.x1, b.y1, b.x2, b.y2, b.x, b.y);
              x2 = b.x;
              y2 = b.y;
            });
          }
          break;
        case "Z":
        case "z":
          checkArgs(name, args.length, 0);
          this.closePath();
          break;
      }
    }
  }
  _runPath(context) {
    context.beginPath();
    each(this._operations, (op) => {
      op.path(context);
    });
  }
  _render(status) {
    super._render(status);
    const layerDirty = status.layer.dirty;
    const interactive = this._isInteractive(status);
    if (layerDirty || interactive) {
      const context = status.layer.context;
      const ghostContext = this._renderer._ghostLayer.context;
      if (layerDirty) {
        context.globalCompositeOperation = this.blendMode;
        context.beginPath();
      }
      let color2;
      if (interactive) {
        ghostContext.beginPath();
        color2 = this._getColorId();
      }
      each(this._operations, (op) => {
        if (layerDirty) {
          op.path(context);
          op.colorize(context, void 0);
        }
        if (interactive) {
          op.path(ghostContext);
          op.colorize(ghostContext, color2);
        }
      });
    }
  }
  renderDetached(context) {
    if (this.visible) {
      this._setMatrix();
      context.save();
      const mask = this.mask;
      if (mask) {
        mask._setMatrix();
        mask._transform(context, 1);
        mask._runPath(context);
        context.clip();
      }
      context.globalAlpha = this.compoundAlpha * this.alpha;
      this._transform(context, 1);
      if (this.filter) {
        context.filter = this.filter;
      }
      context.globalCompositeOperation = this.blendMode;
      context.beginPath();
      each(this._operations, (op) => {
        op.path(context);
        op.colorize(context, void 0);
      });
      context.restore();
    }
  }
  _addBounds(bounds) {
    if (this.visible && this.isMeasured) {
      each(this._operations, (op) => {
        op.addBounds(bounds);
      });
    }
  }
};
var CanvasText = class extends CanvasDisplayObject {
  constructor(renderer, text, style2) {
    super(renderer);
    Object.defineProperty(this, "text", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "style", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "resolution", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "textVisible", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "_textInfo", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_originalScale", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    this.text = text;
    this.style = style2;
  }
  invalidateBounds() {
    super.invalidateBounds();
    this._textInfo = void 0;
  }
  _shared(context) {
    if (this.style.textAlign) {
      context.textAlign = this.style.textAlign;
    }
    if (this.style.direction) {
      context.direction = this.style.direction;
    }
    if (this.style.textBaseline) {
      context.textBaseline = this.style.textBaseline;
    }
  }
  _prerender(status, ignoreGhost = false, ignoreFontWeight = false) {
    super._render(status);
    const context = status.layer.context;
    const ghostContext = this._renderer._ghostLayer.context;
    const style2 = this.style;
    let fontStyle = this._getFontStyle(void 0, ignoreFontWeight);
    context.font = fontStyle;
    if (this._isInteractive(status) && !ignoreGhost) {
      ghostContext.font = fontStyle;
    }
    if (style2.fill) {
      if (style2.fill instanceof Color) {
        context.fillStyle = style2.fill.toCSS(style2.fillOpacity != void 0 ? style2.fillOpacity : 1);
      } else {
        context.fillStyle = style2.fill;
      }
    }
    if (style2.shadowColor) {
      status.layer.context.shadowColor = style2.shadowColor.toCSS(style2.shadowOpacity || 1);
    }
    if (style2.shadowBlur) {
      status.layer.context.shadowBlur = style2.shadowBlur;
    }
    if (style2.shadowOffsetX) {
      status.layer.context.shadowOffsetX = style2.shadowOffsetX;
    }
    if (style2.shadowOffsetY) {
      status.layer.context.shadowOffsetY = style2.shadowOffsetY;
    }
    this._shared(context);
    if (this._isInteractive(status) && !ignoreGhost) {
      ghostContext.fillStyle = this._getColorId();
      this._shared(ghostContext);
    }
  }
  _getFontStyle(style2, ignoreFontWeight = false) {
    const style3 = this.style;
    let fontStyle = [];
    if (style2 && style2.fontVariant) {
      fontStyle.push(style2.fontVariant);
    } else if (style3.fontVariant) {
      fontStyle.push(style3.fontVariant);
    }
    if (!ignoreFontWeight) {
      if (style2 && style2.fontWeight) {
        fontStyle.push(style2.fontWeight);
      } else if (style3.fontWeight) {
        fontStyle.push(style3.fontWeight);
      }
    }
    if (style2 && style2.fontStyle) {
      fontStyle.push(style2.fontStyle);
    } else if (style3.fontStyle) {
      fontStyle.push(style3.fontStyle);
    }
    if (style2 && style2.fontSize) {
      if (isNumber(style2.fontSize)) {
        style2.fontSize = style2.fontSize + "px";
      }
      fontStyle.push(style2.fontSize);
    } else if (style3.fontSize) {
      if (isNumber(style3.fontSize)) {
        style3.fontSize = style3.fontSize + "px";
      }
      fontStyle.push(style3.fontSize);
    }
    if (style2 && style2.fontFamily) {
      fontStyle.push(style2.fontFamily);
    } else if (style3.fontFamily) {
      fontStyle.push(style3.fontFamily);
    } else if (fontStyle.length) {
      fontStyle.push("Arial");
    }
    return fontStyle.join(" ");
  }
  _render(status) {
    if (!this._textInfo) {
      this._measure(status);
    }
    if (this.textVisible) {
      const interactive = this._isInteractive(status);
      const context = status.layer.context;
      const layerDirty = status.layer.dirty;
      const ghostContext = this._renderer._ghostLayer.context;
      context.save();
      ghostContext.save();
      this._prerender(status);
      each(this._textInfo, (line3, _index) => {
        each(line3.textChunks, (chunk, _index2) => {
          if (chunk.style) {
            context.save();
            ghostContext.save();
            context.font = chunk.style;
            if (this._isInteractive(status)) {
              ghostContext.font = chunk.style;
            }
          }
          if (chunk.fill) {
            context.save();
            context.fillStyle = chunk.fill.toCSS();
          }
          if (layerDirty) {
            context.fillText(chunk.text, chunk.offsetX, line3.offsetY + chunk.offsetY);
          }
          if (chunk.textDecoration == "underline" || chunk.textDecoration == "line-through") {
            let thickness = 1;
            let offset2 = 1;
            let fontSize = chunk.height;
            let offsetX = chunk.offsetX;
            switch (this.style.textAlign) {
              case "right":
              case "end":
                offsetX -= chunk.width;
                break;
              case "center":
                offsetX -= chunk.width / 2;
                break;
            }
            if (chunk.style) {
              const format2 = TextFormatter.getTextStyle(chunk.style);
              switch (format2.fontWeight) {
                case "bolder":
                case "bold":
                case "700":
                case "800":
                case "900":
                  thickness = 2;
                  break;
              }
            }
            if (fontSize) {
              offset2 = fontSize / 20;
            }
            let y2;
            if (chunk.textDecoration == "line-through") {
              y2 = thickness + line3.offsetY + chunk.offsetY - chunk.height / 2;
            } else {
              y2 = thickness + offset2 * 1.5 + line3.offsetY + chunk.offsetY;
            }
            context.save();
            context.beginPath();
            if (chunk.fill) {
              context.strokeStyle = chunk.fill.toCSS();
            } else if (this.style.fill && this.style.fill instanceof Color) {
              context.strokeStyle = this.style.fill.toCSS();
            }
            context.lineWidth = thickness * offset2;
            context.moveTo(offsetX, y2);
            context.lineTo(offsetX + chunk.width, y2);
            context.stroke();
            context.restore();
          }
          if (interactive && this.interactive) {
            ghostContext.fillText(chunk.text, chunk.offsetX, line3.offsetY + chunk.offsetY);
          }
          if (chunk.fill) {
            context.restore();
          }
          if (chunk.style) {
            context.restore();
            ghostContext.restore();
          }
        });
      });
      context.restore();
      ghostContext.restore();
    }
  }
  _addBounds(bounds) {
    if (this.visible && this.isMeasured) {
      const x2 = this._measure({
        inactive: this.inactive,
        layer: this.getLayer()
      });
      setPoint(bounds, { x: x2.left, y: x2.top });
      setPoint(bounds, { x: x2.right, y: x2.bottom });
    }
  }
  _ignoreFontWeight() {
    return /apple/i.test(navigator.vendor);
  }
  _measure(status) {
    const context = status.layer.context;
    const ghostContext = this._renderer._ghostLayer.context;
    const rtl = this.style.direction == "rtl";
    this._textInfo = [];
    const oversizedBehavior = this.style.oversizedBehavior;
    const maxWidth = this.style.maxWidth;
    const truncate = isNumber(maxWidth) && oversizedBehavior == "truncate";
    const wrap = isNumber(maxWidth) && (oversizedBehavior == "wrap" || oversizedBehavior == "wrap-no-break");
    context.save();
    ghostContext.save();
    this._prerender(status, true, this._ignoreFontWeight());
    const refText = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789 ";
    const lines = this.text.toString().replace(/\r/g, "").split(/\n/);
    let styleRestored = true;
    let minX = 0;
    let maxX = 0;
    let offsetY = 0;
    let currentStyle;
    each(lines, (line3, _index) => {
      let chunks;
      if (line3 == "") {
        chunks = [{
          type: "value",
          text: ""
        }];
      } else {
        chunks = TextFormatter.chunk(line3, false, this.style.ignoreFormatting);
      }
      while (chunks.length > 0) {
        let lineInfo = {
          offsetY,
          ascent: 0,
          width: 0,
          height: 0,
          left: 0,
          right: 0,
          textChunks: []
        };
        const metrics = this._measureText(refText, context);
        const height = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
        lineInfo.height = height;
        lineInfo.ascent = metrics.actualBoundingBoxAscent;
        let currentFormat;
        let currentDecoration = this.style.textDecoration;
        let currentFill;
        let currentChunkWidth;
        let skipFurtherText = false;
        let firstTextChunk = true;
        let leftoverChunks = [];
        let currentVerticalAlign;
        eachContinue(chunks, (chunk, index2) => {
          if (chunk.type == "format") {
            if (chunk.text == "[/]") {
              if (!styleRestored) {
                context.restore();
                ghostContext.restore();
                styleRestored = true;
              }
              currentFill = void 0;
              currentStyle = void 0;
              currentChunkWidth = void 0;
              currentDecoration = this.style.textDecoration;
              currentVerticalAlign = void 0;
              currentFormat = chunk.text;
            } else {
              if (!styleRestored) {
                context.restore();
                ghostContext.restore();
              }
              let format2 = TextFormatter.getTextStyle(chunk.text);
              const fontStyle = this._getFontStyle(format2);
              context.save();
              ghostContext.save();
              context.font = fontStyle;
              currentStyle = fontStyle;
              currentFormat = chunk.text;
              if (format2.textDecoration) {
                currentDecoration = format2.textDecoration;
              }
              if (format2.fill) {
                currentFill = format2.fill;
              }
              if (format2.width) {
                currentChunkWidth = toNumber(format2.width);
              }
              if (format2.verticalAlign) {
                currentVerticalAlign = format2.verticalAlign;
              }
              styleRestored = false;
              const metrics2 = this._measureText(refText, context);
              const height2 = metrics2.actualBoundingBoxAscent + metrics2.actualBoundingBoxDescent;
              if (height2 > lineInfo.height) {
                lineInfo.height = height2;
              }
              if (metrics2.actualBoundingBoxAscent > lineInfo.ascent) {
                lineInfo.ascent = metrics2.actualBoundingBoxAscent;
              }
            }
          } else if (chunk.type == "value" && !skipFurtherText) {
            const metrics2 = this._measureText(chunk.text, context);
            let chunkWidth = metrics2.actualBoundingBoxLeft + metrics2.actualBoundingBoxRight;
            if (truncate) {
              let breakWords = firstTextChunk || this.style.breakWords || false;
              const ellipsis = this.style.ellipsis || "";
              const ellipsisMetrics = this._measureText(ellipsis, context);
              const ellipsisWidth = ellipsisMetrics.actualBoundingBoxLeft + ellipsisMetrics.actualBoundingBoxRight;
              if (lineInfo.width + chunkWidth > maxWidth) {
                const excessWidth = maxWidth - lineInfo.width - ellipsisWidth;
                chunk.text = this._truncateText(context, chunk.text, excessWidth, breakWords);
                chunk.text += ellipsis;
                skipFurtherText = true;
              }
            } else if (wrap) {
              if (lineInfo.width + chunkWidth > maxWidth) {
                const excessWidth = maxWidth - lineInfo.width;
                const tmpText = this._truncateText(context, chunk.text, excessWidth, false, firstTextChunk && this.style.oversizedBehavior != "wrap-no-break");
                if (tmpText == "") {
                  this.textVisible = true;
                  return false;
                }
                leftoverChunks = chunks.slice(index2 + 1);
                if (trim2(tmpText) != trim2(chunk.text)) {
                  leftoverChunks.unshift({
                    type: "value",
                    text: chunk.text.substr(tmpText.length)
                  });
                  if (currentFormat) {
                    leftoverChunks.unshift({
                      type: "format",
                      text: currentFormat
                    });
                  }
                }
                chunk.text = trim2(tmpText);
                chunks = [];
                skipFurtherText = true;
              }
            }
            let leftBoundMod = 1;
            let rightBoundMod = 1;
            if (currentStyle && currentChunkWidth && currentChunkWidth > chunkWidth) {
              const boundsMod = chunkWidth / currentChunkWidth;
              switch (this.style.textAlign) {
                case "right":
                case "end":
                  leftBoundMod = boundsMod;
                  break;
                case "center":
                  leftBoundMod = boundsMod;
                  rightBoundMod = boundsMod;
                  break;
                default:
                  rightBoundMod = boundsMod;
              }
              chunkWidth = currentChunkWidth;
            }
            const chunkHeight = metrics2.actualBoundingBoxAscent + metrics2.actualBoundingBoxDescent;
            if (chunkHeight > lineInfo.height) {
              lineInfo.height = chunkHeight;
            }
            if (metrics2.actualBoundingBoxAscent > lineInfo.ascent) {
              lineInfo.ascent = metrics2.actualBoundingBoxAscent;
            }
            lineInfo.width += chunkWidth;
            lineInfo.left += metrics2.actualBoundingBoxLeft / leftBoundMod;
            lineInfo.right += metrics2.actualBoundingBoxRight / rightBoundMod;
            lineInfo.textChunks.push({
              style: currentStyle,
              fill: currentFill,
              text: chunk.text,
              width: chunkWidth,
              height: chunkHeight,
              left: metrics2.actualBoundingBoxLeft,
              right: metrics2.actualBoundingBoxRight,
              ascent: metrics2.actualBoundingBoxAscent,
              offsetX: 0,
              offsetY: 0,
              textDecoration: currentDecoration,
              verticalAlign: currentVerticalAlign
            });
            firstTextChunk = false;
          }
          if (leftoverChunks) {
          }
          return true;
        });
        if (this.style.lineHeight instanceof Percent) {
          lineInfo.height *= this.style.lineHeight.value;
          lineInfo.ascent *= this.style.lineHeight.value;
        } else {
          lineInfo.height *= this.style.lineHeight || 1.2;
          lineInfo.ascent *= this.style.lineHeight || 1.2;
        }
        if (minX < lineInfo.left) {
          minX = lineInfo.left;
        }
        if (maxX < lineInfo.right) {
          maxX = lineInfo.right;
        }
        this._textInfo.push(lineInfo);
        offsetY += lineInfo.height;
        chunks = leftoverChunks || [];
      }
    });
    if (!styleRestored) {
      context.restore();
      ghostContext.restore();
    }
    each(this._textInfo, (lineInfo, _index) => {
      let currentChunkOffset = 0;
      each(lineInfo.textChunks, (chunk) => {
        chunk.offsetX = currentChunkOffset + chunk.left - lineInfo.left;
        chunk.offsetY += lineInfo.height - lineInfo.height * (this.style.baselineRatio || 0.19);
        currentChunkOffset += chunk.width;
        if (chunk.verticalAlign) {
          switch (chunk.verticalAlign) {
            case "super":
              chunk.offsetY -= lineInfo.height / 2 - chunk.height / 2;
              break;
            case "sub":
              chunk.offsetY += chunk.height / 2;
              break;
          }
        }
      });
    });
    const bounds = {
      left: rtl ? -maxX : -minX,
      top: 0,
      right: rtl ? minX : maxX,
      bottom: offsetY
    };
    if (oversizedBehavior !== "none") {
      const ratio = this._fitRatio(bounds);
      if (ratio < 1) {
        if (oversizedBehavior == "fit") {
          if (isNumber(this.style.minScale) && ratio < this.style.minScale) {
            this.textVisible = false;
            bounds.left = 0;
            bounds.top = 0;
            bounds.right = 0;
            bounds.bottom = 0;
          } else {
            if (!this._originalScale || this._originalScale == 1) {
              this._originalScale = this.scale;
            }
            this.scale = ratio;
            this.textVisible = true;
          }
        } else if (oversizedBehavior == "hide") {
          this.textVisible = false;
          bounds.left = 0;
          bounds.top = 0;
          bounds.right = 0;
          bounds.bottom = 0;
        } else {
          switch (this.style.textAlign) {
            case "right":
            case "end":
              bounds.left = -maxWidth;
              bounds.right = 0;
              break;
            case "center":
              bounds.left = -maxWidth / 2;
              bounds.right = maxWidth / 2;
              break;
            default:
              bounds.left = 0;
              bounds.right = maxWidth;
          }
          this.scale = this._originalScale || 1;
          this._originalScale = void 0;
          this.textVisible = true;
        }
      } else {
        this.scale = this._originalScale || 1;
        this._originalScale = void 0;
        this.textVisible = true;
      }
    }
    context.restore();
    ghostContext.restore();
    return bounds;
  }
  _fitRatio(bounds) {
    const maxW = this.style.maxWidth;
    const maxH = this.style.maxHeight;
    if (!isNumber(maxW) && !isNumber(maxH)) {
      return 1;
    }
    const w = bounds.right - bounds.left;
    const h = bounds.bottom - bounds.top;
    return Math.min(maxW / w || 1, maxH / h || 1);
  }
  _truncateText(context, text, maxWidth, breakWords = false, fallbackBreakWords = true) {
    let width;
    do {
      if (breakWords) {
        text = text.slice(0, -1);
      } else {
        let tmp = text.replace(/[^,;:!?\\\/\s​]+[,;:!?\\\/\s​]*$/g, "");
        if ((tmp == "" || tmp === text) && fallbackBreakWords) {
          breakWords = true;
        } else if (tmp == "") {
          return text;
        } else {
          text = tmp;
        }
      }
      const metrics = this._measureText(text, context);
      width = metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight;
    } while (width > maxWidth && text != "");
    return text;
  }
  _measureText(text, context) {
    let metrics = context.measureText(text);
    let fakeMetrics = {};
    if (metrics.actualBoundingBoxAscent == null) {
      const div = document.createElement("div");
      div.innerText = text;
      div.style.visibility = "hidden";
      div.style.position = "absolute";
      div.style.top = "-1000000px;";
      div.style.fontFamily = this.style.fontFamily || "";
      div.style.fontSize = this.style.fontSize + "";
      document.body.appendChild(div);
      const bbox = div.getBoundingClientRect();
      document.body.removeChild(div);
      const h = bbox.height;
      const w2 = metrics.width;
      let left = 0;
      let right = w2;
      fakeMetrics = {
        actualBoundingBoxAscent: h,
        actualBoundingBoxDescent: 0,
        actualBoundingBoxLeft: left,
        actualBoundingBoxRight: right,
        fontBoundingBoxAscent: h,
        fontBoundingBoxDescent: 0,
        width: w2
      };
    } else {
      fakeMetrics = {
        actualBoundingBoxAscent: metrics.actualBoundingBoxAscent,
        actualBoundingBoxDescent: metrics.actualBoundingBoxDescent,
        actualBoundingBoxLeft: metrics.actualBoundingBoxLeft,
        actualBoundingBoxRight: metrics.actualBoundingBoxRight,
        fontBoundingBoxAscent: metrics.actualBoundingBoxAscent,
        fontBoundingBoxDescent: metrics.actualBoundingBoxDescent,
        width: metrics.width
      };
    }
    const w = metrics.width;
    switch (this.style.textAlign) {
      case "right":
      case "end":
        fakeMetrics.actualBoundingBoxLeft = w;
        fakeMetrics.actualBoundingBoxRight = 0;
        break;
      case "center":
        fakeMetrics.actualBoundingBoxLeft = w / 2;
        fakeMetrics.actualBoundingBoxRight = w / 2;
        break;
      default:
        fakeMetrics.actualBoundingBoxLeft = 0;
        fakeMetrics.actualBoundingBoxRight = w;
    }
    return fakeMetrics;
  }
};
var CanvasTextStyle = class {
  constructor() {
    Object.defineProperty(this, "fill", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "fillOpacity", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "textAlign", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "fontFamily", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "fontSize", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "fontWeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "fontStyle", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "fontVariant", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "textDecoration", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowColor", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowBlur", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowOffsetX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowOffsetY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowOpacity", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "lineHeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: percent(120)
    });
    Object.defineProperty(this, "baselineRatio", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0.19
    });
    Object.defineProperty(this, "direction", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "textBaseline", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "oversizedBehavior", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "none"
    });
    Object.defineProperty(this, "breakWords", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "ellipsis", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "\u2026"
    });
    Object.defineProperty(this, "maxWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "maxHeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "minScale", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "ignoreFormatting", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
  }
};
var CanvasRadialText = class extends CanvasText {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "textType", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "circular"
    });
    Object.defineProperty(this, "radius", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "startAngle", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "inside", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "orientation", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: "auto"
    });
    Object.defineProperty(this, "kerning", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_textReversed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
  }
  _render(status) {
    switch (this.textType) {
      case "circular":
        this._renderCircular(status);
        break;
      default:
        super._render(status);
        break;
    }
  }
  _renderCircular(status) {
    if (this.textVisible) {
      this._prerender(status);
      const interactive = this._isInteractive(status);
      const context = status.layer.context;
      const layerDirty = status.layer.dirty;
      const ghostContext = this._renderer._ghostLayer.context;
      context.save();
      if (interactive) {
        ghostContext.save();
      }
      if (!this._textInfo) {
        this._measure(status);
      }
      let radius = this.radius || 0;
      let startAngle = this.startAngle || 0;
      let deltaAngle = 0;
      let orientation = this.orientation;
      let inward = orientation == "auto" ? "auto" : orientation == "inward";
      const inside = this.inside;
      const align = this.style.textAlign || "left";
      const kerning = this.kerning || 0;
      let clockwise = align == "left" ? 1 : -1;
      const shouldReverse = !this._textReversed;
      if (inward == "auto") {
        let maxAngle = 0;
        let midAngle = 0;
        each(this._textInfo, (line3, _index) => {
          const deltaAngle2 = startAngle + line3.width / (radius - line3.height) / 2 * -clockwise;
          if (deltaAngle2 > maxAngle) {
            maxAngle = deltaAngle2;
          }
        });
        if (align == "left") {
          midAngle = (maxAngle + deltaAngle / 2) * DEGREES;
        } else if (align == "right") {
          midAngle = (maxAngle - deltaAngle / 2) * DEGREES;
        } else {
          midAngle = startAngle * DEGREES;
        }
        midAngle = normalizeAngle(midAngle);
        inward = midAngle >= 270 || midAngle <= 90;
      }
      if (inward == true && shouldReverse) {
        this._textInfo.reverse();
        this._textReversed = true;
      }
      each(this._textInfo, (line3, _index) => {
        const textHeight = line3.height;
        if (!inside) {
          radius += textHeight;
        }
        if ((clockwise == -1 && inward || clockwise == 1 && !inward) && shouldReverse) {
          line3.textChunks.reverse();
        }
        let lineStartAngle = startAngle;
        deltaAngle = 0;
        if (align == "center") {
          lineStartAngle += line3.width / (radius - textHeight) / 2 * -clockwise;
          deltaAngle = lineStartAngle - startAngle;
        }
        lineStartAngle += Math.PI * (inward ? 0 : 1);
        context.save();
        if (interactive) {
          ghostContext.save();
        }
        context.rotate(lineStartAngle);
        if (interactive) {
          ghostContext.rotate(lineStartAngle);
        }
        let angleShift = 0;
        each(line3.textChunks, (chunk, _index2) => {
          const char2 = chunk.text;
          const charWidth = chunk.width;
          angleShift = charWidth / 2 / (radius - textHeight) * clockwise;
          context.rotate(angleShift);
          if (interactive) {
            ghostContext.rotate(angleShift);
          }
          if (chunk.style) {
            context.save();
            ghostContext.save();
            context.font = chunk.style;
            if (interactive) {
              ghostContext.font = chunk.style;
            }
          }
          if (chunk.fill) {
            context.save();
            context.fillStyle = chunk.fill.toCSS();
          }
          context.textBaseline = "middle";
          context.textAlign = "center";
          if (interactive) {
            ghostContext.textBaseline = "middle";
            ghostContext.textAlign = "center";
          }
          if (layerDirty) {
            context.fillText(char2, 0, (inward ? 1 : -1) * (0 - radius + textHeight / 2));
          }
          if (interactive) {
            ghostContext.fillText(char2, 0, (inward ? 1 : -1) * (0 - radius + textHeight / 2));
          }
          if (chunk.fill) {
            context.restore();
          }
          if (chunk.style) {
            context.restore();
            ghostContext.restore();
          }
          angleShift = (charWidth / 2 + kerning) / (radius - textHeight) * clockwise;
          context.rotate(angleShift);
          if (interactive) {
            ghostContext.rotate(angleShift);
          }
        });
        context.restore();
        if (interactive) {
          ghostContext.restore();
        }
        if (inside) {
          radius -= textHeight;
        }
      });
      context.restore();
      if (interactive) {
        ghostContext.restore();
      }
    }
  }
  _measure(status) {
    switch (this.textType) {
      case "circular":
        return this._measureCircular(status);
      default:
        return super._measure(status);
    }
  }
  _measureCircular(status) {
    const context = status.layer.context;
    const ghostContext = this._renderer._ghostLayer.context;
    const rtl = this.style.direction == "rtl";
    const oversizedBehavior = this.style.oversizedBehavior;
    const maxWidth = this.style.maxWidth;
    const truncate = isNumber(maxWidth) && oversizedBehavior == "truncate";
    const ellipsis = this.style.ellipsis || "";
    let ellipsisMetrics;
    this.textVisible = true;
    this._textInfo = [];
    this._textReversed = false;
    context.save();
    ghostContext.save();
    this._prerender(status, true);
    const lines = this.text.toString().replace(/\r/g, "").split(/\n/);
    let styleRestored = true;
    let totalWidth = 0;
    let offsetY = 0;
    each(lines, (line3, _index) => {
      let chunks = TextFormatter.chunk(line3, false, this.style.ignoreFormatting);
      let lineInfo = {
        offsetY,
        ascent: 0,
        width: 0,
        height: 0,
        left: 0,
        right: 0,
        textChunks: []
      };
      let currentStyle;
      let currentFill;
      let currentChunkWidth;
      each(chunks, (chunk, _index2) => {
        if (chunk.type == "format") {
          if (chunk.text == "[/]") {
            if (!styleRestored) {
              context.restore();
              ghostContext.restore();
              styleRestored = true;
            }
            currentFill = void 0;
            currentStyle = void 0;
            currentChunkWidth = void 0;
          } else {
            let format2 = TextFormatter.getTextStyle(chunk.text);
            const fontStyle = this._getFontStyle(format2);
            context.save();
            ghostContext.save();
            context.font = fontStyle;
            currentStyle = fontStyle;
            if (format2.fill) {
              currentFill = format2.fill;
            }
            if (format2.width) {
              currentChunkWidth = toNumber(format2.width);
            }
            styleRestored = false;
          }
          if (truncate) {
            ellipsisMetrics = this._measureText(ellipsis, context);
          }
        } else if (chunk.type == "value") {
          const chars = chunk.text.match(/./ug) || [];
          if (rtl) {
            chars.reverse();
          }
          for (let i = 0; i < chars.length; i++) {
            const char2 = chars[i];
            const metrics = this._measureText(char2, context);
            let chunkWidth = metrics.width;
            if (currentStyle && currentChunkWidth && currentChunkWidth > chunkWidth) {
              chunkWidth = currentChunkWidth;
            }
            const chunkHeight = metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent;
            if (chunkHeight > lineInfo.height) {
              lineInfo.height = chunkHeight;
            }
            if (metrics.actualBoundingBoxAscent > lineInfo.ascent) {
              lineInfo.ascent = metrics.actualBoundingBoxAscent;
            }
            totalWidth += chunkWidth;
            if (truncate) {
              if (!ellipsisMetrics) {
                ellipsisMetrics = this._measureText(ellipsis, context);
              }
              const ellipsisWidth = ellipsisMetrics.actualBoundingBoxLeft + ellipsisMetrics.actualBoundingBoxRight;
              if (totalWidth + ellipsisWidth > maxWidth) {
                if (lineInfo.textChunks.length == 1) {
                  this.textVisible = false;
                } else {
                  lineInfo.width += ellipsisWidth;
                  lineInfo.left += ellipsisMetrics.actualBoundingBoxLeft;
                  lineInfo.right += ellipsisMetrics.actualBoundingBoxRight;
                  lineInfo.textChunks.push({
                    style: currentStyle,
                    fill: currentFill,
                    text: ellipsis,
                    width: ellipsisWidth,
                    height: chunkHeight + ellipsisMetrics.actualBoundingBoxDescent,
                    left: ellipsisMetrics.actualBoundingBoxLeft,
                    right: ellipsisMetrics.actualBoundingBoxRight,
                    ascent: ellipsisMetrics.actualBoundingBoxAscent,
                    offsetX: 0,
                    offsetY: chunkHeight,
                    textDecoration: void 0
                  });
                }
                break;
              }
            }
            lineInfo.width += chunkWidth;
            lineInfo.left += metrics.actualBoundingBoxLeft;
            lineInfo.right += metrics.actualBoundingBoxRight;
            lineInfo.textChunks.push({
              style: currentStyle,
              fill: currentFill,
              text: char2,
              width: chunkWidth,
              height: chunkHeight + metrics.actualBoundingBoxDescent,
              left: metrics.actualBoundingBoxLeft,
              right: metrics.actualBoundingBoxRight,
              ascent: metrics.actualBoundingBoxAscent,
              offsetX: 0,
              offsetY: chunkHeight,
              textDecoration: void 0
            });
            if (rtl) {
              break;
            }
          }
        }
      });
      if (this.style.lineHeight instanceof Percent) {
        lineInfo.height *= this.style.lineHeight.value;
      } else {
        lineInfo.height *= this.style.lineHeight || 1.2;
      }
      this._textInfo.push(lineInfo);
      offsetY += lineInfo.height;
    });
    if (!styleRestored) {
      context.restore();
      ghostContext.restore();
    }
    if (oversizedBehavior == "hide" && totalWidth > maxWidth) {
      this.textVisible = false;
    }
    each(this._textInfo, (lineInfo) => {
      each(lineInfo.textChunks, (chunk) => {
        chunk.offsetY += Math.round((lineInfo.height - chunk.height + (lineInfo.ascent - chunk.ascent)) / 2);
      });
    });
    context.restore();
    ghostContext.restore();
    return {
      left: 0,
      top: 0,
      right: 0,
      bottom: 0
    };
  }
};
var CanvasImage = class extends CanvasDisplayObject {
  constructor(renderer, image) {
    super(renderer);
    Object.defineProperty(this, "width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "height", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "image", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "tainted", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowColor", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowBlur", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowOffsetX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowOffsetY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "shadowOpacity", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_imageMask", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.image = image;
  }
  _dispose() {
    super._dispose();
    if (this._imageMask) {
      clearCanvas(this._imageMask);
    }
  }
  getLocalBounds() {
    if (!this._localBounds) {
      let w = 0;
      let h = 0;
      if (this.width) {
        w = this.width;
      }
      if (this.height) {
        h = this.height;
      }
      this._localBounds = {
        left: 0,
        top: 0,
        right: w,
        bottom: h
      };
      this._addBounds(this._localBounds);
    }
    return this._localBounds;
  }
  _render(status) {
    super._render(status);
    if (this.image) {
      if (this.tainted === void 0) {
        this.tainted = isTainted(this.image);
        status.layer.tainted = true;
      }
      if (this.tainted && this._renderer._omitTainted) {
        return;
      }
      if (status.layer.dirty) {
        if (this.shadowColor) {
          status.layer.context.shadowColor = this.shadowColor.toCSS(this.shadowOpacity || 1);
        }
        if (this.shadowBlur) {
          status.layer.context.shadowBlur = this.shadowBlur;
        }
        if (this.shadowOffsetX) {
          status.layer.context.shadowOffsetX = this.shadowOffsetX;
        }
        if (this.shadowOffsetY) {
          status.layer.context.shadowOffsetY = this.shadowOffsetY;
        }
        const width = this.width || this.image.naturalWidth;
        const height = this.height || this.image.naturalHeight;
        status.layer.context.drawImage(this.image, 0, 0, width, height);
      }
      if (this.interactive && this._isInteractive(status)) {
        const mask = this._getMask(this.image);
        this._renderer._ghostLayer.context.drawImage(mask, 0, 0);
      }
    }
  }
  clear() {
    super.clear();
    this.image = void 0;
    this._imageMask = void 0;
  }
  _getMask(image) {
    if (this._imageMask === void 0) {
      const width = this.width || image.naturalWidth;
      const height = this.height || image.naturalHeight;
      const canvas = document.createElement("canvas");
      canvas.width = width;
      canvas.height = height;
      const context = canvas.getContext("2d");
      context.imageSmoothingEnabled = false;
      context.fillStyle = this._getColorId();
      context.fillRect(0, 0, width, height);
      if (!isTainted(image)) {
        context.globalCompositeOperation = "destination-in";
        context.drawImage(image, 0, 0, width, height);
      }
      this._imageMask = canvas;
    }
    return this._imageMask;
  }
};
var CanvasRendererEvent = class {
  constructor(event, originalPoint, point2, bbox) {
    Object.defineProperty(this, "event", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: event
    });
    Object.defineProperty(this, "originalPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: originalPoint
    });
    Object.defineProperty(this, "point", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: point2
    });
    Object.defineProperty(this, "bbox", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: bbox
    });
    Object.defineProperty(this, "id", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "simulated", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "native", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    if (supports("touchevents") && event instanceof Touch) {
      this.id = event.identifier;
    } else {
      this.id = null;
    }
  }
};
var CanvasRenderer = class extends ArrayDisposer {
  constructor(resolution) {
    super();
    Object.defineProperty(this, "view", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: document.createElement("div")
    });
    Object.defineProperty(this, "_layerDom", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: document.createElement("div")
    });
    Object.defineProperty(this, "layers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_dirtyLayers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "defaultLayer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.getLayer(0)
    });
    Object.defineProperty(this, "_ghostLayer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new GhostLayer()
    });
    Object.defineProperty(this, "_patternCanvas", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: document.createElement("canvas")
    });
    Object.defineProperty(this, "_patternContext", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._patternCanvas.getContext("2d")
    });
    Object.defineProperty(this, "_realWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_realHeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_calculatedWidth", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_calculatedHeight", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "resolution", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "interactionsEnabled", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "_listeners", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_events", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_colorId", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_colorMap", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_forceInteractive", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_omitTainted", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_hovering", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: /* @__PURE__ */ new Set()
    });
    Object.defineProperty(this, "_dragging", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_mousedown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_lastPointerMoveEvent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "tapToActivate", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "tapToActivateTimeout", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 3e3
    });
    Object.defineProperty(this, "_touchActive", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_touchActiveTimeout", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    if (resolution == null) {
      this.resolution = window.devicePixelRatio;
    } else {
      this.resolution = resolution;
    }
    this.view.style.position = "absolute";
    this.view.setAttribute("aria-hidden", "true");
    this.view.appendChild(this._layerDom);
    this._disposers.push(new Disposer(() => {
      each2(this._events, (_key, events) => {
        events.disposer.dispose();
      });
      each(this.layers, (layer) => {
        clearCanvas(layer.view);
        if (layer.exportableView) {
          clearCanvas(layer.exportableView);
        }
      });
      clearCanvas(this._ghostLayer.view);
      clearCanvas(this._patternCanvas);
    }));
    this._disposers.push(onZoom(() => {
      if (resolution == null) {
        this.resolution = window.devicePixelRatio;
      }
    }));
    if (supports("touchevents")) {
      const listener = (ev) => {
        if (this._dragging.length !== 0) {
          eachContinue(this._dragging, (item) => {
            if (item.value.shouldCancelTouch()) {
              ev.preventDefault();
              return false;
            }
            return true;
          });
        }
        if (this._touchActiveTimeout) {
          this._delayTouchDeactivate();
        }
      };
      this._disposers.push(addEventListener(window, "touchstart", listener, { passive: false }));
      this._disposers.push(addEventListener(this.view, "touchstart", listener, { passive: false }));
      this._disposers.push(addEventListener(this.view, "touchmove", () => {
        if (this._touchActiveTimeout) {
          this._delayTouchDeactivate();
        }
      }, { passive: true }));
      this._disposers.push(addEventListener(window, "click", (_ev) => {
        this._touchActive = false;
      }, { passive: true }));
      this._disposers.push(addEventListener(this.view, "click", (_ev) => {
        window.setTimeout(() => {
          this._touchActive = true;
          this._delayTouchDeactivate();
        }, 100);
      }, { passive: true }));
    }
    if (supports("wheelevents")) {
      this._disposers.push(addEventListener(this.view, "wheel", (ev) => {
        let prevent = false;
        this._hovering.forEach((obj) => {
          if (obj.wheelable) {
            prevent = true;
            return false;
          }
        });
        if (prevent) {
          ev.preventDefault();
        }
      }, { passive: false }));
    }
  }
  /*protected _mouseMoveThrottler: Throttler = new Throttler(() => {
      this._dispatchGlobalMousemove(this._lastPointerMoveEvent.event, this._lastPointerMoveEvent.native);
  });
  */
  resetImageArray() {
    this._ghostLayer.imageArray = void 0;
  }
  _delayTouchDeactivate() {
    if (this._touchActiveTimeout) {
      clearTimeout(this._touchActiveTimeout);
    }
    if (this.tapToActivateTimeout > 0) {
      this._touchActiveTimeout = window.setTimeout(() => {
        this._touchActive = false;
      }, this.tapToActivateTimeout);
    }
  }
  get debugGhostView() {
    return !!this._ghostLayer.view.parentNode;
  }
  set debugGhostView(value) {
    if (value) {
      if (!this._ghostLayer.view.parentNode) {
        this.view.appendChild(this._ghostLayer.view);
      }
    } else {
      if (this._ghostLayer.view.parentNode) {
        this._ghostLayer.view.parentNode.removeChild(this._ghostLayer.view);
      }
    }
  }
  createLinearGradient(x1, y1, x2, y2) {
    return this.defaultLayer.context.createLinearGradient(x1, y1, x2, y2);
  }
  createRadialGradient(x1, y1, radius1, x2, y2, radius2) {
    return this.defaultLayer.context.createRadialGradient(x1, y1, radius1, x2, y2, radius2);
  }
  createPattern(graphics, background, repetition, width, height) {
    this._patternCanvas.width = width;
    this._patternCanvas.height = height;
    this._patternContext.clearRect(0, 0, width, height);
    background.renderDetached(this._patternContext);
    graphics.renderDetached(this._patternContext);
    return this._patternContext.createPattern(this._patternCanvas, repetition);
  }
  makeContainer() {
    return new CanvasContainer(this);
  }
  makeGraphics() {
    return new CanvasGraphics(this);
  }
  makeText(text, style2) {
    return new CanvasText(this, text, style2);
  }
  makeTextStyle() {
    return new CanvasTextStyle();
  }
  makeRadialText(text, style2) {
    return new CanvasRadialText(this, text, style2);
  }
  makePicture(image) {
    return new CanvasImage(this, image);
  }
  resizeLayer(layer) {
    layer.resize(this._calculatedWidth, this._calculatedHeight, this._calculatedWidth, this._calculatedHeight, this.resolution);
  }
  resizeGhost() {
    this._ghostLayer.resize(this._calculatedWidth, this._calculatedHeight, this._calculatedWidth, this._calculatedHeight, this.resolution);
  }
  resize(realWidth, realHeight, calculatedWidth, calculatedHeight) {
    this._realWidth = realWidth;
    this._realHeight = realHeight;
    this._calculatedWidth = calculatedWidth;
    this._calculatedHeight = calculatedHeight;
    each(this.layers, (layer) => {
      if (layer) {
        layer.dirty = true;
        this.resizeLayer(layer);
      }
    });
    this.resizeGhost();
    this.view.style.width = calculatedWidth + "px";
    this.view.style.height = calculatedHeight + "px";
  }
  createDetachedLayer(willReadFrequently = false) {
    const view = document.createElement("canvas");
    const context = view.getContext("2d", { willReadFrequently });
    const layer = new CanvasLayer(view, context);
    view.style.position = "absolute";
    view.style.top = "0px";
    view.style.left = "0px";
    return layer;
  }
  getLayerByOrder(order) {
    const layers = this.layers;
    const length2 = layers.length;
    for (let i = 0; i < length2; i++) {
      const layer = layers[i];
      if (layer.order == order) {
        return layer;
      }
    }
  }
  getLayer(order, visible = true) {
    let existingLayer = this.getLayerByOrder(order);
    if (existingLayer) {
      return existingLayer;
    }
    const layer = this.createDetachedLayer(order == 99);
    layer.order = order;
    layer.visible = visible;
    layer.view.className = "am5-layer-" + order;
    if (layer.visible) {
      this.resizeLayer(layer);
    }
    const layers = this.layers;
    layers.push(layer);
    layers.sort((a, b) => {
      if (a.order > b.order) {
        return 1;
      } else if (a.order < b.order) {
        return -1;
      } else {
        return 0;
      }
    });
    const length2 = layers.length;
    const layerIndex = indexOf(layers, layer);
    let next2;
    for (let i = layerIndex + 1; i < length2; i++) {
      if (layers[i].visible) {
        next2 = layers[i];
        break;
      }
    }
    if (layer.visible) {
      if (next2 === void 0) {
        this._layerDom.appendChild(layer.view);
      } else {
        this._layerDom.insertBefore(layer.view, next2.view);
      }
    }
    return layer;
  }
  render(root) {
    this._dirtyLayers.length = 0;
    each(this.layers, (layer) => {
      if (layer) {
        if (layer.dirty && layer.visible) {
          this._dirtyLayers.push(layer);
          layer.clear();
        }
      }
    });
    this._ghostLayer.clear();
    root.render({
      inactive: null,
      layer: this.defaultLayer
    });
    this._ghostLayer.context.restore();
    each(this.layers, (layer) => {
      if (layer) {
        const context = layer.context;
        context.beginPath();
        context.moveTo(0, 0);
        context.stroke();
      }
    });
    each(this._dirtyLayers, (layer) => {
      layer.context.restore();
      layer.dirty = false;
    });
    if (this._hovering.size && this._lastPointerMoveEvent) {
      const { events, target, native } = this._lastPointerMoveEvent;
      each(events, (event) => {
        this._dispatchGlobalMousemove(event, target, native);
      });
    }
  }
  paintId(obj) {
    const id = distributeId(++this._colorId);
    const color2 = Color.fromHex(id).toCSS();
    this._colorMap[color2] = obj;
    return color2;
  }
  _removeObject(obj) {
    if (obj._colorId !== void 0) {
      delete this._colorMap[obj._colorId];
    }
  }
  // protected _identifyObjectByColor(colorId: number): CanvasDisplayObject | undefined {
  // 	return this._colorMap[colorId];
  // }
  _adjustBoundingBox(bbox) {
    const margin = this._ghostLayer.margin;
    return new DOMRect(-margin.left, -margin.top, bbox.width + margin.left + margin.right, bbox.height + margin.top + margin.bottom);
  }
  getEvent(originalEvent, adjustPoint = true) {
    const bbox = this.view.getBoundingClientRect();
    const x2 = originalEvent.clientX || 0;
    const y2 = originalEvent.clientY || 0;
    const widthScale = this._calculatedWidth / this._realWidth;
    const heightScale = this._calculatedHeight / this._realHeight;
    const originalPoint = {
      x: x2 - bbox.left,
      y: y2 - bbox.top
    };
    const point2 = {
      x: (x2 - (adjustPoint ? bbox.left : 0)) * widthScale,
      y: (y2 - (adjustPoint ? bbox.top : 0)) * heightScale
    };
    return new CanvasRendererEvent(originalEvent, originalPoint, point2, this._adjustBoundingBox(bbox));
  }
  _getHitTarget(point2, bbox, target) {
    if (bbox.width === 0 || bbox.height === 0 || point2.x < bbox.left || point2.x > bbox.right || point2.y < bbox.top || point2.y > bbox.bottom) {
      return;
    }
    if (!target || !this._layerDom.contains(target)) {
      return;
    }
    const pixel = this._ghostLayer.getImageData(point2, bbox);
    if (pixel.data[0] === 0 && pixel.data[1] === 0 && pixel.data[2] === 0) {
      return false;
    }
    const colorId = Color.fromRGB(pixel.data[0], pixel.data[1], pixel.data[2]).toCSS();
    const hit = this._colorMap[colorId];
    return hit;
  }
  getObjectAtPoint(point2) {
    const data = this._ghostLayer.getImageArray(point2);
    if (data[0] === 0 && data[1] === 0 && data[2] === 0) {
      return void 0;
    }
    const colorId = Color.fromRGB(data[0], data[1], data[2]).toCSS();
    const hit = this._colorMap[colorId];
    return hit;
  }
  _withEvents(key, f) {
    const events = this._events[key];
    if (events !== void 0) {
      events.dispatching = true;
      try {
        f(events);
      } finally {
        events.dispatching = false;
        if (events.cleanup) {
          events.cleanup = false;
          keepIf(events.callbacks, (callback) => {
            return !callback.disposed;
          });
          if (events.callbacks.length === 0) {
            events.disposer.dispose();
            delete this._events[key];
          }
        }
      }
    }
  }
  _dispatchEventAll(key, event) {
    if (!this.interactionsEnabled) {
      return;
    }
    this._withEvents(key, (events) => {
      each(events.callbacks, (callback) => {
        if (!callback.disposed) {
          callback.callback.call(callback.context, event);
        }
      });
    });
  }
  _dispatchEvent(key, target, event) {
    if (!this.interactionsEnabled) {
      return false;
    }
    let dispatched = false;
    this._withEvents(key, (events) => {
      each(events.callbacks, (callback) => {
        if (!callback.disposed && callback.object === target) {
          callback.callback.call(callback.context, event);
          dispatched = true;
        }
      });
    });
    return dispatched;
  }
  _dispatchMousedown(originalEvent, originalTarget) {
    const button = originalEvent.button;
    if (button != 0 && button != 2 && button != 1 && button !== void 0) {
      return;
    }
    const event = this.getEvent(originalEvent);
    const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
    if (target) {
      const id = event.id;
      let dragged = false;
      eachTargets(target, (obj) => {
        const info = { id, value: obj };
        this._mousedown.push(info);
        if (!dragged && this._dispatchEvent("pointerdown", obj, event)) {
          dragged = true;
          const has = this._dragging.some((x2) => {
            return x2.value === obj && x2.id === id;
          });
          if (!has) {
            this._dragging.push(info);
          }
        }
        return true;
      });
    }
  }
  _dispatchGlobalMousemove(originalEvent, originalTarget, native) {
    const event = this.getEvent(originalEvent);
    const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
    event.native = native;
    if (target) {
      this._hovering.forEach((obj) => {
        if (!obj.contains(target)) {
          this._hovering.delete(obj);
          if (obj.cursorOverStyle) {
            setStyle(document.body, "cursor", obj._replacedCursorStyle);
          }
          this._dispatchEvent("pointerout", obj, event);
        }
      });
      if (event.native) {
        eachTargets(target, (obj) => {
          if (!this._hovering.has(obj)) {
            this._hovering.add(obj);
            if (obj.cursorOverStyle) {
              obj._replacedCursorStyle = getStyle2(document.body, "cursor");
              setStyle(document.body, "cursor", obj.cursorOverStyle);
            }
            this._dispatchEvent("pointerover", obj, event);
          }
          return true;
        });
      }
    } else {
      this._hovering.forEach((obj) => {
        if (obj.cursorOverStyle) {
          setStyle(document.body, "cursor", obj._replacedCursorStyle);
        }
        this._dispatchEvent("pointerout", obj, event);
      });
      this._hovering.clear();
    }
    this._dispatchEventAll("globalpointermove", event);
  }
  removeHovering(graphics) {
    this._hovering.delete(graphics);
    if (graphics.cursorOverStyle) {
      setStyle(document.body, "cursor", graphics._replacedCursorStyle);
    }
  }
  _dispatchGlobalMouseup(originalEvent, native) {
    const event = this.getEvent(originalEvent);
    event.native = native;
    this._dispatchEventAll("globalpointerup", event);
  }
  _dispatchDragMove(originalEvent) {
    if (this._dragging.length !== 0) {
      const event = this.getEvent(originalEvent);
      const id = event.id;
      this._dragging.forEach((obj) => {
        if (obj.id === id) {
          this._dispatchEvent("pointermove", obj.value, event);
        }
      });
    }
  }
  _dispatchDragEnd(originalEvent, originalTarget) {
    const button = originalEvent.button;
    let clickevent;
    if (button == 0 || button === void 0) {
      clickevent = "click";
    } else if (button == 2) {
      clickevent = "rightclick";
    } else if (button == 1) {
      clickevent = "middleclick";
    } else {
      return;
    }
    const event = this.getEvent(originalEvent);
    const id = event.id;
    if (this._mousedown.length !== 0) {
      const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
      if (target) {
        this._mousedown.forEach((obj) => {
          if (obj.id === id && obj.value.contains(target)) {
            this._dispatchEvent(clickevent, obj.value, event);
          }
        });
      }
      this._mousedown.length = 0;
    }
    if (this._dragging.length !== 0) {
      this._dragging.forEach((obj) => {
        if (obj.id === id) {
          this._dispatchEvent("pointerup", obj.value, event);
        }
      });
      this._dragging.length = 0;
    }
  }
  _dispatchDoubleClick(originalEvent, originalTarget) {
    const event = this.getEvent(originalEvent);
    const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
    if (target) {
      eachTargets(target, (obj) => {
        if (this._dispatchEvent("dblclick", obj, event)) {
          return false;
        } else {
          return true;
        }
      });
    }
  }
  _dispatchWheel(originalEvent, originalTarget) {
    const event = this.getEvent(originalEvent);
    const target = this._getHitTarget(event.originalPoint, event.bbox, originalTarget);
    if (target) {
      eachTargets(target, (obj) => {
        if (this._dispatchEvent("wheel", obj, event)) {
          return false;
        } else {
          return true;
        }
      });
    }
  }
  _makeSharedEvent(key, f) {
    if (this._listeners[key] === void 0) {
      const listener = f();
      this._listeners[key] = new CounterDisposer(() => {
        delete this._listeners[key];
        listener.dispose();
      });
    }
    return this._listeners[key].increment();
  }
  _onPointerEvent(name, f) {
    let native = false;
    let timer = null;
    function clear() {
      timer = null;
      native = false;
    }
    return new MultiDisposer([
      new Disposer(() => {
        if (timer !== null) {
          clearTimeout(timer);
        }
        clear();
      }),
      addEventListener(this.view, getRendererEvent(name), (_) => {
        native = true;
        if (timer !== null) {
          clearTimeout(timer);
        }
        timer = window.setTimeout(clear, 0);
      }),
      onPointerEvent(window, name, (ev, target) => {
        if (timer !== null) {
          clearTimeout(timer);
          timer = null;
        }
        f(ev, target, native);
        native = false;
      })
    ]);
  }
  // This ensures that only a single DOM event is added (e.g. only a single mousemove event listener)
  _initEvent(key) {
    switch (key) {
      case "globalpointermove":
      case "pointerover":
      case "pointerout":
        return this._makeSharedEvent("pointermove", () => {
          const listener = (events, target, native) => {
            this._lastPointerMoveEvent = { events, target, native };
            each(events, (event) => {
              this._dispatchGlobalMousemove(event, target, native);
            });
          };
          return new MultiDisposer([
            this._onPointerEvent("pointerdown", listener),
            this._onPointerEvent("pointermove", listener)
          ]);
        });
      case "globalpointerup":
        return this._makeSharedEvent("pointerup", () => {
          const mouseup = this._onPointerEvent("pointerup", (events, target, native) => {
            each(events, (event) => {
              this._dispatchGlobalMouseup(event, native);
            });
            this._lastPointerMoveEvent = { events, target, native };
          });
          const pointercancel = this._onPointerEvent("pointercancel", (events, target, native) => {
            each(events, (event) => {
              this._dispatchGlobalMouseup(event, native);
            });
            this._lastPointerMoveEvent = { events, target, native };
          });
          return new Disposer(() => {
            mouseup.dispose();
            pointercancel.dispose();
          });
        });
      case "click":
      case "rightclick":
      case "middleclick":
      case "pointerdown":
      case "pointermove":
      case "pointerup":
        return this._makeSharedEvent("pointerdown", () => {
          const mousedown = this._onPointerEvent("pointerdown", (events, target) => {
            each(events, (ev) => {
              this._dispatchMousedown(ev, target);
            });
          });
          const mousemove = this._onPointerEvent("pointermove", (ev) => {
            each(ev, (ev2) => {
              this._dispatchDragMove(ev2);
            });
          });
          const mouseup = this._onPointerEvent("pointerup", (ev, target) => {
            each(ev, (ev2) => {
              this._dispatchDragEnd(ev2, target);
            });
          });
          const pointercancel = this._onPointerEvent("pointercancel", (ev, target) => {
            each(ev, (ev2) => {
              this._dispatchDragEnd(ev2, target);
            });
          });
          return new Disposer(() => {
            mousedown.dispose();
            mousemove.dispose();
            mouseup.dispose();
            pointercancel.dispose();
          });
        });
      case "dblclick":
        return this._makeSharedEvent("dblclick", () => {
          return this._onPointerEvent("dblclick", (ev, target) => {
            each(ev, (ev2) => {
              this._dispatchDoubleClick(ev2, target);
            });
          });
        });
      case "wheel":
        return this._makeSharedEvent("wheel", () => {
          return addEventListener(window, getRendererEvent("wheel"), (event) => {
            this._dispatchWheel(event, getEventTarget(event));
          }, { passive: false });
        });
    }
  }
  _addEvent(object4, key, callback, context) {
    let events = this._events[key];
    if (events === void 0) {
      events = this._events[key] = {
        disposer: this._initEvent(key),
        callbacks: [],
        dispatching: false,
        cleanup: false
      };
    }
    const listener = { object: object4, context, callback, disposed: false };
    events.callbacks.push(listener);
    return new Disposer(() => {
      listener.disposed = true;
      if (events.dispatching) {
        events.cleanup = true;
      } else {
        removeFirst(events.callbacks, listener);
        if (events.callbacks.length === 0) {
          events.disposer.dispose();
          delete this._events[key];
        }
      }
    });
  }
  getCanvas(root, options) {
    this.render(root);
    if (!options) {
      options = {};
    }
    let scale = this.resolution;
    let canvasWidth = Math.floor(this._calculatedWidth * this.resolution);
    let canvasHeight = Math.floor(this._calculatedHeight * this.resolution);
    if (options.minWidth && options.minWidth > canvasWidth) {
      let minScale = options.minWidth / canvasWidth;
      if (minScale > scale) {
        scale = minScale * this.resolution;
      }
    }
    if (options.minHeight && options.minHeight > canvasHeight) {
      let minScale = options.minHeight / canvasHeight;
      if (minScale > scale) {
        scale = minScale * this.resolution;
      }
    }
    if (options.maxWidth && options.maxWidth < canvasWidth) {
      let maxScale = options.maxWidth / canvasWidth;
      if (maxScale < scale) {
        scale = maxScale * this.resolution;
      }
    }
    if (options.maxHeight && options.maxHeight > canvasHeight) {
      let maxScale = options.maxHeight / canvasHeight;
      if (maxScale < scale) {
        scale = maxScale * this.resolution;
      }
    }
    if (options.maintainPixelRatio) {
      scale /= this.resolution;
    }
    const canvases = [];
    let forceRender = false;
    const canvas = document.createElement("canvas");
    if (scale != this.resolution) {
      forceRender = true;
      canvasWidth = canvasWidth * scale / this.resolution;
      canvasHeight = canvasHeight * scale / this.resolution;
    }
    canvas.width = canvasWidth;
    canvas.height = canvasHeight;
    canvas.style.position = "fixed";
    canvas.style.top = "-10000px";
    this.view.appendChild(canvas);
    canvases.push(canvas);
    const context = canvas.getContext("2d");
    let width = 0;
    let height = 0;
    let needRerender = false;
    each(this.layers, (layer) => {
      if (layer && layer.visible) {
        if (layer.tainted || forceRender) {
          needRerender = true;
          layer.exportableView = layer.view;
          layer.exportableContext = layer.context;
          layer.view = document.createElement("canvas");
          layer.view.style.position = "fixed";
          layer.view.style.top = "-10000px";
          this.view.appendChild(layer.view);
          canvases.push(layer.view);
          let extraX = 0;
          let extraY = 0;
          if (layer.margin) {
            extraX += layer.margin.left || 0 + layer.margin.right || 0;
            extraY += layer.margin.top || 0 + layer.margin.bottom || 0;
          }
          layer.view.width = canvasWidth + extraX;
          layer.view.height = canvasHeight + extraY;
          layer.context = layer.view.getContext("2d");
          layer.dirty = true;
          layer.scale = scale;
        }
      }
    });
    if (needRerender) {
      this._omitTainted = true;
      this.render(root);
      this._omitTainted = false;
    }
    each(this.layers, (layer) => {
      if (layer && layer.visible) {
        let x2 = 0;
        let y2 = 0;
        if (layer.margin) {
          x2 = -(layer.margin.left || 0) * this.resolution;
          y2 = -(layer.margin.top || 0) * this.resolution;
        }
        context.drawImage(layer.view, x2, y2);
        if (layer.exportableView) {
          layer.view = layer.exportableView;
          layer.exportableView = void 0;
        }
        if (layer.exportableContext) {
          layer.context = layer.exportableContext;
          layer.exportableContext = void 0;
        }
        if (width < layer.view.clientWidth) {
          width = layer.view.clientWidth;
        }
        if (height < layer.view.clientHeight) {
          height = layer.view.clientHeight;
        }
        layer.scale = void 0;
      }
    });
    canvas.style.width = width + "px";
    canvas.style.height = height + "px";
    each(canvases, (canvas2) => {
      canvas2.style.position = "";
      canvas2.style.top = "";
      this.view.removeChild(canvas2);
    });
    return canvas;
  }
};
var GhostLayer = class {
  constructor() {
    Object.defineProperty(this, "view", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "context", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "margin", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }
    });
    Object.defineProperty(this, "_resolution", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "_width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_height", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "imageArray", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.view = document.createElement("canvas");
    this.context = this.view.getContext("2d", { alpha: false, willReadFrequently: true });
    this.context.imageSmoothingEnabled = false;
    this.view.style.position = "absolute";
    this.view.style.top = "0px";
    this.view.style.left = "0px";
  }
  resize(canvasWidth, canvasHeight, domWidth, domHeight, resolution) {
    this._resolution = resolution;
    canvasWidth += this.margin.left + this.margin.right;
    canvasHeight += this.margin.top + this.margin.bottom;
    domWidth += this.margin.left + this.margin.right;
    domHeight += this.margin.top + this.margin.bottom;
    this.view.style.left = -this.margin.left + "px";
    this.view.style.top = -this.margin.top + "px";
    this._width = Math.floor(canvasWidth * resolution);
    this._height = Math.floor(canvasHeight * resolution);
    this.view.width = this._width;
    this.view.style.width = domWidth + "px";
    this.view.height = this._height;
    this.view.style.height = domHeight + "px";
  }
  getImageData(point2, bbox) {
    return this.context.getImageData(
      // TODO should this round ?
      Math.round((point2.x - bbox.left) / bbox.width * this._width),
      Math.round((point2.y - bbox.top) / bbox.height * this._height),
      1,
      1
    );
  }
  getImageArray(point2) {
    if (!this.imageArray) {
      this.imageArray = this.context.getImageData(0, 0, this._width, this._height).data;
    }
    const data = this.imageArray;
    const x2 = Math.round(point2.x * this._resolution);
    const y2 = Math.round(point2.y * this._resolution);
    const i = (y2 * this._width + x2) * 4;
    return [data[i], data[i + 1], data[i + 2], data[i + 3]];
  }
  setMargin(layers) {
    this.margin.left = 0;
    this.margin.right = 0;
    this.margin.top = 0;
    this.margin.bottom = 0;
    each(layers, (layer) => {
      if (layer.margin) {
        this.margin.left = Math.max(this.margin.left, layer.margin.left);
        this.margin.right = Math.max(this.margin.right, layer.margin.right);
        this.margin.top = Math.max(this.margin.top, layer.margin.top);
        this.margin.bottom = Math.max(this.margin.bottom, layer.margin.bottom);
      }
    });
  }
  clear() {
    this.context.save();
    this.context.fillStyle = "#000";
    this.context.fillRect(0, 0, this._width, this._height);
  }
};
var CanvasLayer = class {
  constructor(view, context) {
    Object.defineProperty(this, "view", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "context", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "tainted", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "margin", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "order", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "visible", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "height", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "scale", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "dirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "exportableView", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "exportableContext", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_width", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_height", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    this.view = view;
    this.context = context;
  }
  resize(canvasWidth, canvasHeight, domWidth, domHeight, resolution) {
    if (this.width != null) {
      canvasWidth = this.width;
      domWidth = this.width;
    }
    if (this.height != null) {
      canvasHeight = this.height;
      domHeight = this.height;
    }
    if (this.margin) {
      canvasWidth += this.margin.left + this.margin.right;
      canvasHeight += this.margin.top + this.margin.bottom;
      domWidth += this.margin.left + this.margin.right;
      domHeight += this.margin.top + this.margin.bottom;
      this.view.style.left = -this.margin.left + "px";
      this.view.style.top = -this.margin.top + "px";
    } else {
      this.view.style.left = "0px";
      this.view.style.top = "0px";
    }
    this._width = Math.floor(canvasWidth * resolution);
    this._height = Math.floor(canvasHeight * resolution);
    this.view.width = this._width;
    this.view.style.width = domWidth + "px";
    this.view.height = this._height;
    this.view.style.height = domHeight + "px";
  }
  clear() {
    this.context.save();
    this.context.clearRect(0, 0, this._width, this._height);
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/Root.js
function rAF(fps, callback) {
  if (fps == null) {
    requestAnimationFrame(callback);
  } else {
    setTimeout(() => {
      requestAnimationFrame(callback);
    }, 1e3 / fps);
  }
}
var Root = class _Root {
  constructor(id, settings = {}, isReal) {
    Object.defineProperty(this, "dom", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_inner", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_settings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_isDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_isDirtyParents", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_dirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_dirtyParents", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_dirtyBounds", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_dirtyPositions", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_ticker", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, "_tickers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_updateTick", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "events", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new EventDispatcher()
    });
    Object.defineProperty(this, "animationTime", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: null
    });
    Object.defineProperty(this, "_animations", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_renderer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_rootContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "container", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "tooltipContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltipContainerSettings", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltip", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "language", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Language.new(this, {})
    });
    Object.defineProperty(this, "locale", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: en_default
    });
    Object.defineProperty(this, "utc", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "timezone", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "fps", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "numberFormatter", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: NumberFormatter.new(this, {})
    });
    Object.defineProperty(this, "dateFormatter", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: DateFormatter.new(this, {})
    });
    Object.defineProperty(this, "durationFormatter", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: DurationFormatter.new(this, {})
    });
    Object.defineProperty(this, "tabindex", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_tabindexes", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_a11yD", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_focusElementDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_focusElementContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_focusedSprite", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_isShift", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_keyboardDragPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltipElementContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_readerAlertElement", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_logo", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltipDiv", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "nonce", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "interfaceColors", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "verticalLayout", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: VerticalLayout.new(this, {})
    });
    Object.defineProperty(this, "horizontalLayout", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: HorizontalLayout.new(this, {})
    });
    Object.defineProperty(this, "gridLayout", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: GridLayout.new(this, {})
    });
    Object.defineProperty(this, "_paused", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "autoResize", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "_fontHash", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: ""
    });
    Object.defineProperty(this, "_isDisposed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_disposers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_resizeSensorDisposer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltips", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_htmlElementContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_htmlEnabledContainers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    if (!isReal) {
      throw new Error("You cannot use `new Class()`, instead use `Class.new()`");
    }
    this._settings = settings;
    if (settings.accessible == false) {
      this._a11yD = true;
    }
    if (settings.useSafeResolution == null) {
      settings.useSafeResolution = true;
    }
    let resolution;
    if (settings.useSafeResolution) {
      resolution = getSafeResolution();
    }
    this._renderer = new CanvasRenderer(resolution);
    let dom;
    if (id instanceof HTMLElement) {
      dom = id;
    } else {
      dom = document.getElementById(id);
    }
    each(registry.rootElements, (root) => {
      if (root.dom === dom) {
        throw new Error("You cannot have multiple Roots on the same DOM node");
      }
    });
    this.interfaceColors = InterfaceColors.new(this, {});
    if (dom === null) {
      throw new Error("Could not find HTML element with id `" + id + "`");
    }
    this.dom = dom;
    let inner = document.createElement("div");
    inner.style.position = "relative";
    inner.style.width = "100%";
    inner.style.height = "100%";
    dom.appendChild(inner);
    const tooltipContainerBounds = settings.tooltipContainerBounds;
    if (tooltipContainerBounds) {
      this._tooltipContainerSettings = tooltipContainerBounds;
    }
    this._inner = inner;
    this._updateComputedStyles();
    registry.rootElements.push(this);
  }
  static new(id, settings) {
    const root = new _Root(id, settings, true);
    root._init();
    return root;
  }
  moveDOM(id) {
    let dom;
    if (id instanceof HTMLElement) {
      dom = id;
    } else {
      dom = document.getElementById(id);
    }
    if (dom) {
      while (this.dom.childNodes.length > 0) {
        dom.appendChild(this.dom.childNodes[0]);
      }
      this.dom = dom;
      this._initResizeSensor();
      this.resize();
    }
  }
  _handleLogo() {
    if (this._logo) {
      const w = this.dom.offsetWidth;
      const h = this.dom.offsetHeight;
      if (w <= 150 || h <= 60) {
        this._logo.hide();
      } else {
        this._logo.show();
      }
    }
  }
  _showBranding() {
    if (!this._logo) {
      const logo = this.tooltipContainer.children.push(Container.new(this, {
        interactive: true,
        interactiveChildren: false,
        position: "absolute",
        setStateOnChildren: true,
        paddingTop: 9,
        paddingRight: 9,
        paddingBottom: 9,
        paddingLeft: 9,
        scale: 0.6,
        y: percent(100),
        centerY: p100,
        tooltipText: "Created using amCharts 5",
        tooltipX: p100,
        cursorOverStyle: "pointer",
        background: Rectangle.new(this, {
          fill: color(4671320),
          fillOpacity: 0,
          tooltipY: 5
        })
      }));
      const tooltip = Tooltip4.new(this, {
        pointerOrientation: "horizontal",
        paddingTop: 4,
        paddingRight: 7,
        paddingBottom: 4,
        paddingLeft: 7
      });
      tooltip.label.setAll({
        fontSize: 12
      });
      tooltip.get("background").setAll({
        fill: this.interfaceColors.get("background"),
        stroke: this.interfaceColors.get("grid"),
        strokeOpacity: 0.3
      });
      logo.set("tooltip", tooltip);
      logo.events.on("click", () => {
        window.open("https://www.amcharts.com/", "_blank");
      });
      logo.states.create("hover", {});
      const m = logo.children.push(Graphics.new(this, {
        stroke: color(13421772),
        strokeWidth: 3,
        svgPath: "M5 25 L13 25h13.6c3.4 0 6 0 10.3-4.3s5.2-12 8.6-12c3.4 0 4.3 8.6 7.7 8.6M83.4 25H79.8c-3.4 0-6 0-10.3-4.3s-5.2-12-8.6-12-4.3 8.6-7.7 8.6"
      }));
      m.states.create("hover", { stroke: color(3976191) });
      const a = logo.children.push(Graphics.new(this, {
        stroke: color(8947848),
        strokeWidth: 3,
        svgPath: "M83.4 25h-31C37 25 39.5 4.4 28.4 4.4S18.9 24.2 4.3 25H0"
      }));
      a.states.create("hover", { stroke: color(4671320) });
      this._logo = logo;
      this._handleLogo();
    }
  }
  _getRealSize() {
    return this.dom.getBoundingClientRect();
  }
  _getCalculatedSize(rect) {
    if (this._settings.calculateSize) {
      return this._settings.calculateSize(rect);
    } else {
      return {
        width: rect.width,
        height: rect.height
      };
    }
  }
  _init() {
    const settings = this._settings;
    if (settings.accessible !== false) {
      if (settings.focusable) {
        this._inner.setAttribute("focusable", "true");
        this._inner.setAttribute("tabindex", this.tabindex + "");
      }
      if (settings.ariaLabel) {
        this._inner.setAttribute("aria-label", settings.ariaLabel);
      }
      if (settings.role) {
        this._inner.setAttribute("role", settings.role);
      }
    }
    const renderer = this._renderer;
    const rect = this._getRealSize();
    const size = this._getCalculatedSize(rect);
    const width = Math.floor(size.width);
    const height = Math.floor(size.height);
    const realWidth = Math.floor(rect.width);
    const realHeight = Math.floor(rect.height);
    const rootContainer = Container.new(this, {
      visible: true,
      width,
      height
    });
    this._rootContainer = rootContainer;
    this._rootContainer._defaultThemes.push(DefaultTheme.new(this));
    const container = rootContainer.children.push(Container.new(this, { visible: true, width: p100, height: p100 }));
    this.container = container;
    renderer.resize(realWidth, realHeight, width, height);
    this._inner.appendChild(renderer.view);
    this._initResizeSensor();
    const htmlElementContainer = document.createElement("div");
    this._htmlElementContainer = htmlElementContainer;
    htmlElementContainer.className = "am5-html-container";
    htmlElementContainer.style.position = "absolute";
    htmlElementContainer.style.pointerEvents = "none";
    if (!this._tooltipContainerSettings) {
      htmlElementContainer.style.overflow = "hidden";
    }
    this._inner.appendChild(htmlElementContainer);
    if (this._a11yD !== true) {
      const readerAlertElement = document.createElement("div");
      readerAlertElement.className = "am5-reader-container";
      readerAlertElement.setAttribute("role", "alert");
      readerAlertElement.style.position = "absolute";
      readerAlertElement.style.width = "1px";
      readerAlertElement.style.height = "1px";
      readerAlertElement.style.overflow = "hidden";
      readerAlertElement.style.clip = "rect(1px, 1px, 1px, 1px)";
      this._readerAlertElement = readerAlertElement;
      this._inner.appendChild(this._readerAlertElement);
      const focusElementContainer = document.createElement("div");
      focusElementContainer.className = "am5-focus-container";
      focusElementContainer.style.position = "absolute";
      focusElementContainer.style.pointerEvents = "none";
      focusElementContainer.style.top = "0px";
      focusElementContainer.style.left = "0px";
      focusElementContainer.style.overflow = "hidden";
      focusElementContainer.style.width = width + "px";
      focusElementContainer.style.height = height + "px";
      focusElementContainer.setAttribute("role", "graphics-document");
      setInteractive(focusElementContainer, false);
      this._focusElementContainer = focusElementContainer;
      this._inner.appendChild(this._focusElementContainer);
      const tooltipElementContainer = document.createElement("div");
      this._tooltipElementContainer = tooltipElementContainer;
      tooltipElementContainer.className = "am5-tooltip-container";
      this._inner.appendChild(tooltipElementContainer);
      if (supports("keyboardevents")) {
        this._disposers.push(addEventListener(window, "keydown", (ev) => {
          if (ev.keyCode == 16) {
            this._isShift = true;
          } else if (ev.keyCode == 9) {
            this._isShift = ev.shiftKey;
          }
        }));
        this._disposers.push(addEventListener(window, "keyup", (ev) => {
          if (ev.keyCode == 16) {
            this._isShift = false;
          }
        }));
        this._disposers.push(addEventListener(focusElementContainer, "click", () => {
          const focusedSprite = this._focusedSprite;
          if (focusedSprite) {
            const downEvent = renderer.getEvent(new MouseEvent("click"));
            focusedSprite.events.dispatch("click", {
              type: "click",
              originalEvent: downEvent.event,
              point: downEvent.point,
              simulated: true,
              target: focusedSprite
            });
          }
        }));
        this._disposers.push(addEventListener(focusElementContainer, "keydown", (ev) => {
          const focusedSprite = this._focusedSprite;
          if (focusedSprite) {
            if (ev.keyCode == 27) {
              blur();
              this._focusedSprite = void 0;
            }
            let dragOffsetX = 0;
            let dragOffsetY = 0;
            switch (ev.keyCode) {
              case 13:
                ev.preventDefault();
                const downEvent = renderer.getEvent(new MouseEvent("click"));
                focusedSprite.events.dispatch("click", {
                  type: "click",
                  originalEvent: downEvent.event,
                  point: downEvent.point,
                  simulated: true,
                  target: focusedSprite
                });
                return;
              case 37:
                dragOffsetX = -6;
                break;
              case 39:
                dragOffsetX = 6;
                break;
              case 38:
                dragOffsetY = -6;
                break;
              case 40:
                dragOffsetY = 6;
                break;
              default:
                return;
            }
            if (dragOffsetX != 0 || dragOffsetY != 0) {
              ev.preventDefault();
              if (!focusedSprite.isDragging()) {
                this._keyboardDragPoint = {
                  x: 0,
                  y: 0
                };
                const downEvent = renderer.getEvent(new MouseEvent("mousedown", {
                  clientX: 0,
                  clientY: 0
                }));
                if (focusedSprite.events.isEnabled("pointerdown")) {
                  focusedSprite.events.dispatch("pointerdown", {
                    type: "pointerdown",
                    originalEvent: downEvent.event,
                    point: downEvent.point,
                    simulated: true,
                    target: focusedSprite
                  });
                }
              } else {
              }
              const dragPoint = this._keyboardDragPoint;
              dragPoint.x += dragOffsetX;
              dragPoint.y += dragOffsetY;
              const moveEvent = renderer.getEvent(new MouseEvent("mousemove", {
                clientX: dragPoint.x,
                clientY: dragPoint.y
              }), false);
              if (focusedSprite.events.isEnabled("globalpointermove")) {
                focusedSprite.events.dispatch("globalpointermove", {
                  type: "globalpointermove",
                  originalEvent: moveEvent.event,
                  point: moveEvent.point,
                  simulated: true,
                  target: focusedSprite
                });
              }
            }
          }
        }));
        this._disposers.push(addEventListener(focusElementContainer, "keyup", (ev) => {
          if (this._focusedSprite) {
            const focusedSprite = this._focusedSprite;
            const keyCode = ev.keyCode;
            switch (keyCode) {
              case 37:
              case 39:
              case 38:
              case 40:
                if (focusedSprite.isDragging()) {
                  const dragPoint = this._keyboardDragPoint;
                  const upEvent = renderer.getEvent(new MouseEvent("mouseup", {
                    clientX: dragPoint.x,
                    clientY: dragPoint.y
                  }));
                  if (focusedSprite.events.isEnabled("globalpointerup")) {
                    focusedSprite.events.dispatch("globalpointerup", {
                      type: "globalpointerup",
                      originalEvent: upEvent.event,
                      point: upEvent.point,
                      simulated: true,
                      target: focusedSprite
                    });
                  }
                  this._keyboardDragPoint = void 0;
                  return;
                } else if (focusedSprite.get("focusableGroup")) {
                  const group = focusedSprite.get("focusableGroup");
                  const items = this._tabindexes.filter((item) => {
                    return item.get("focusableGroup") == group && item.getPrivate("focusable") !== false ? true : false;
                  });
                  let index2 = items.indexOf(focusedSprite);
                  const lastIndex = items.length - 1;
                  index2 += keyCode == 39 || keyCode == 40 ? 1 : -1;
                  if (index2 < 0) {
                    index2 = lastIndex;
                  } else if (index2 > lastIndex) {
                    index2 = 0;
                  }
                  focus(items[index2].getPrivate("focusElement").dom);
                }
                break;
            }
          }
        }));
      }
    }
    this._startTicker();
    this.setThemes([]);
    this._addTooltip();
    if (!this._hasLicense()) {
      this._showBranding();
    }
  }
  _initResizeSensor() {
    if (this._resizeSensorDisposer) {
      this._resizeSensorDisposer.dispose();
    }
    this._resizeSensorDisposer = new ResizeSensor(this.dom, () => {
      if (this.autoResize) {
        this.resize();
      }
    });
    this._disposers.push(this._resizeSensorDisposer);
  }
  /**
   * If automatic resizing of char is disabled (`root.autoResize = false`), it
   * can be resized manually by calling this method.
   */
  resize() {
    const rect = this._getRealSize();
    const size = this._getCalculatedSize(rect);
    const w = Math.floor(size.width);
    const h = Math.floor(size.height);
    if (w > 0 && h > 0) {
      const realWidth = Math.floor(rect.width);
      const realHeight = Math.floor(rect.height);
      const htmlElementContainer = this._htmlElementContainer;
      htmlElementContainer.style.width = w + "px";
      htmlElementContainer.style.height = h + "px";
      if (this._a11yD !== true) {
        const focusElementContainer = this._focusElementContainer;
        focusElementContainer.style.width = w + "px";
        focusElementContainer.style.height = h + "px";
      }
      this._renderer.resize(realWidth, realHeight, w, h);
      const rootContainer = this._rootContainer;
      rootContainer.setPrivate("width", w);
      rootContainer.setPrivate("height", h);
      this._render();
      this._handleLogo();
    }
  }
  _render() {
    this._renderer.render(this._rootContainer._display);
    if (this._focusElementDirty) {
      this._updateCurrentFocus();
      this._focusElementDirty = false;
    }
  }
  _runTickers(currentTime) {
    each(this._tickers, (f) => {
      f(currentTime);
    });
  }
  _runAnimations(currentTime) {
    keepIf(this._animations, (animation) => {
      return animation._runAnimation(currentTime);
    });
  }
  _runDirties() {
    let allParents = {};
    while (this._isDirtyParents) {
      this._isDirtyParents = false;
      keys2(this._dirtyParents).forEach((key) => {
        const parent = this._dirtyParents[key];
        delete this._dirtyParents[key];
        if (!parent.isDisposed()) {
          allParents[parent.uid] = parent;
          parent._prepareChildren();
        }
      });
    }
    keys2(allParents).forEach((key) => {
      allParents[key]._updateChildren();
    });
    const objects = [];
    keys2(this._dirty).forEach((key) => {
      const entity = this._dirty[key];
      if (entity.isDisposed()) {
        delete this._dirty[entity.uid];
      } else {
        objects.push(entity);
        entity._beforeChanged();
      }
    });
    objects.forEach((entity) => {
      entity._changed();
      delete this._dirty[entity.uid];
      entity._clearDirty();
    });
    this._isDirty = false;
    const depths = {};
    const bounds = [];
    keys2(this._dirtyBounds).forEach((key) => {
      const entity = this._dirtyBounds[key];
      delete this._dirtyBounds[key];
      if (!entity.isDisposed()) {
        depths[entity.uid] = entity.depth();
        bounds.push(entity);
      }
    });
    this._positionHTMLElements();
    bounds.sort((x2, y2) => {
      return compare(depths[y2.uid], depths[x2.uid]);
    });
    bounds.forEach((entity) => {
      entity._updateBounds();
    });
    const dirtyPositions = this._dirtyPositions;
    keys2(dirtyPositions).forEach((key) => {
      const sprite = dirtyPositions[key];
      delete dirtyPositions[key];
      if (!sprite.isDisposed()) {
        sprite._updatePosition();
      }
    });
    objects.forEach((entity) => {
      entity._afterChanged();
    });
  }
  _renderFrame(currentTime) {
    if (this._updateTick) {
      if (this.events.isEnabled("framestarted")) {
        this.events.dispatch("framestarted", {
          type: "framestarted",
          target: this,
          timestamp: currentTime
        });
      }
      this._checkComputedStyles();
      this._runTickers(currentTime);
      this._runAnimations(currentTime);
      this._runDirties();
      this._render();
      this._renderer.resetImageArray();
      this._positionHTMLElements();
      if (this.events.isEnabled("frameended")) {
        this.events.dispatch("frameended", {
          type: "frameended",
          target: this,
          timestamp: currentTime
        });
      }
      return this._tickers.length === 0 && this._animations.length === 0 && !this._isDirty;
    } else {
      return true;
    }
  }
  _runTicker(currentTime, now) {
    if (!this.isDisposed()) {
      this.animationTime = currentTime;
      const done = this._renderFrame(currentTime);
      if (done) {
        this._ticker = null;
        this.animationTime = null;
      } else {
        if (!this._paused) {
          if (now) {
            this._ticker;
          } else {
            rAF(this.fps, this._ticker);
          }
        }
      }
    }
  }
  _runTickerNow(timeout = 1e4) {
    if (!this.isDisposed()) {
      const endTime = performance.now() + timeout;
      for (; ; ) {
        const currentTime = performance.now();
        if (currentTime >= endTime) {
          this.animationTime = null;
          break;
        }
        this.animationTime = currentTime;
        const done = this._renderFrame(currentTime);
        if (done) {
          this.animationTime = null;
          break;
        }
      }
    }
  }
  _startTicker() {
    if (this._ticker === null) {
      this.animationTime = null;
      this._ticker = (currentTime) => {
        this._runTicker(currentTime);
      };
      rAF(this.fps, this._ticker);
    }
  }
  /**
   * Returns whether the root is updating or not.
   */
  get updateTick() {
    return this._updateTick;
  }
  /**
   * Enables or disables the root updating.
   */
  set updateTick(value) {
    this._updateTick = value;
    if (value) {
      this._startTicker();
    }
  }
  _addDirtyEntity(entity) {
    if (this._dirty[entity.uid] === void 0) {
      this._isDirty = true;
      this._dirty[entity.uid] = entity;
      this._startTicker();
    }
  }
  _addDirtyParent(parent) {
    if (this._dirtyParents[parent.uid] === void 0) {
      this._isDirty = true;
      this._isDirtyParents = true;
      this._dirtyParents[parent.uid] = parent;
      this._startTicker();
    }
  }
  _addDirtyBounds(entity) {
    if (this._dirtyBounds[entity.uid] === void 0) {
      this._isDirty = true;
      this._dirtyBounds[entity.uid] = entity;
      this._startTicker();
    }
  }
  _addDirtyPosition(sprite) {
    if (this._dirtyPositions[sprite.uid] === void 0) {
      this._isDirty = true;
      this._dirtyPositions[sprite.uid] = sprite;
      this._startTicker();
    }
  }
  _addAnimation(animation) {
    if (this._animations.indexOf(animation) === -1) {
      this._animations.push(animation);
      this._startTicker();
    }
  }
  _markDirty() {
    this._isDirty = true;
  }
  _markDirtyRedraw() {
    this.events.once("frameended", () => {
      this._isDirty = true;
      this._startTicker();
    });
  }
  eachFrame(f) {
    this._tickers.push(f);
    this._startTicker();
    return new Disposer(() => {
      removeFirst(this._tickers, f);
    });
  }
  markDirtyGlobal(container) {
    if (!container) {
      container = this.container;
    }
    container.walkChildren((child) => {
      if (child instanceof Container) {
        this.markDirtyGlobal(child);
      }
      child.markDirty();
      child.markDirtyBounds();
    });
  }
  /**
   * Returns width of the target container, in pixels.
   *
   * @return Width
   */
  width() {
    return Math.floor(this._getCalculatedSize(this._getRealSize()).width);
  }
  /**
   * Returns height of the target container, in pixels.
   *
   * @return Height
   */
  height() {
    return Math.floor(this._getCalculatedSize(this._getRealSize()).height);
  }
  /**
   * Disposes root and all the content in it.
   */
  dispose() {
    if (!this._isDisposed) {
      this._isDisposed = true;
      this._rootContainer.dispose();
      this._renderer.dispose();
      this.horizontalLayout.dispose();
      this.verticalLayout.dispose();
      this.interfaceColors.dispose();
      each(this._disposers, (x2) => {
        x2.dispose();
      });
      if (this._inner) {
        removeElement(this._inner);
      }
      remove(registry.rootElements, this);
    }
  }
  /**
   * Returns `true` if root element is disposed.
   *
   * @return Disposed?
   */
  isDisposed() {
    return this._isDisposed;
  }
  /**
   * Triggers screen reader read out a message.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/accessibility/} for more info
   * @param  text  Alert text
   */
  readerAlert(text) {
    if (this._a11yD !== true) {
      this._readerAlertElement.innerHTML = stripTags(text);
    }
  }
  /**
   * Sets themes to be used for the chart.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/themes/} for more info
   * @param  themes  A list of themes
   */
  setThemes(themes) {
    this._rootContainer.set("themes", themes);
    const tooltipContainer = this.tooltipContainer;
    if (tooltipContainer) {
      tooltipContainer._applyThemes();
    }
    const interfaceColors = this.interfaceColors;
    if (interfaceColors) {
      interfaceColors._applyThemes();
    }
  }
  _addTooltip() {
    if (!this.tooltipContainer) {
      const tooltipContainerSettings = this._tooltipContainerSettings;
      const tooltipContainer = this._rootContainer.children.push(Container.new(this, {
        position: "absolute",
        isMeasured: false,
        width: p100,
        height: p100,
        layer: tooltipContainerSettings ? 35 : 30,
        layerMargin: tooltipContainerSettings ? tooltipContainerSettings : void 0
      }));
      this.tooltipContainer = tooltipContainer;
      const tooltip = Tooltip4.new(this, {});
      this.container.set("tooltip", tooltip);
      tooltip.hide(0);
      this._tooltip = tooltip;
    }
  }
  /**
   * Accesibility
   */
  _registerTabindexOrder(target) {
    if (this._a11yD == true) {
      return;
    }
    if (target.get("focusable")) {
      pushOne(this._tabindexes, target);
    } else {
      remove(this._tabindexes, target);
    }
    this._invalidateTabindexes();
  }
  _unregisterTabindexOrder(target) {
    if (this._a11yD == true) {
      return;
    }
    remove(this._tabindexes, target);
    this._invalidateTabindexes();
  }
  _invalidateTabindexes() {
    if (this._a11yD == true) {
      return;
    }
    this._tabindexes.sort((a, b) => {
      const aindex = a.get("tabindexOrder", 0);
      const bindex = b.get("tabindexOrder", 0);
      if (aindex == bindex) {
        return 0;
      } else if (aindex > bindex) {
        return 1;
      } else {
        return -1;
      }
    });
    const groups = [];
    each(this._tabindexes, (item, index2) => {
      if (!item.getPrivate("focusElement")) {
        this._makeFocusElement(index2, item);
      } else {
        this._moveFocusElement(index2, item);
      }
      const group = item.get("focusableGroup");
      if (group && item.getPrivate("focusable") !== false) {
        if (groups.indexOf(group) !== -1) {
          item.getPrivate("focusElement").dom.setAttribute("tabindex", "-1");
        } else {
          groups.push(group);
        }
      }
    });
  }
  _updateCurrentFocus() {
    if (this._a11yD == true) {
      return;
    }
    if (this._focusedSprite) {
      this._decorateFocusElement(this._focusedSprite);
      this._positionFocusElement(this._focusedSprite);
    }
  }
  _decorateFocusElement(target, focusElement) {
    if (this._a11yD == true) {
      return;
    }
    if (!focusElement) {
      focusElement = target.getPrivate("focusElement").dom;
    }
    if (!focusElement) {
      return;
    }
    const role = target.get("role");
    if (role) {
      focusElement.setAttribute("role", role);
    } else {
      focusElement.removeAttribute("role");
    }
    const ariaLabel = target.get("ariaLabel");
    if (ariaLabel) {
      const label = populateString(target, ariaLabel);
      focusElement.setAttribute("aria-label", label);
    } else {
      focusElement.removeAttribute("aria-label");
    }
    const ariaLive = target.get("ariaLive");
    if (ariaLive) {
      focusElement.setAttribute("aria-live", ariaLive);
    } else {
      focusElement.removeAttribute("aria-live");
    }
    const ariaChecked = target.get("ariaChecked");
    if (ariaChecked != null) {
      focusElement.setAttribute("aria-checked", ariaChecked ? "true" : "false");
    } else {
      focusElement.removeAttribute("aria-checked");
    }
    if (target.get("ariaHidden")) {
      focusElement.setAttribute("aria-hidden", "true");
    } else {
      focusElement.removeAttribute("aria-hidden");
    }
    const ariaOrientation = target.get("ariaOrientation");
    if (ariaOrientation) {
      focusElement.setAttribute("aria-orientation", ariaOrientation);
    } else {
      focusElement.removeAttribute("aria-orientation");
    }
    const ariaValueNow = target.get("ariaValueNow");
    if (ariaValueNow) {
      focusElement.setAttribute("aria-valuenow", ariaValueNow);
    } else {
      focusElement.removeAttribute("aria-valuenow");
    }
    const ariaValueMin = target.get("ariaValueMin");
    if (ariaValueMin) {
      focusElement.setAttribute("aria-valuemin", ariaValueMin);
    } else {
      focusElement.removeAttribute("aria-valuemin");
    }
    const ariaValueMax = target.get("ariaValueMax");
    if (ariaValueMax) {
      focusElement.setAttribute("aria-valuemax", ariaValueMax);
    } else {
      focusElement.removeAttribute("aria-valuemax");
    }
    const ariaValueText = target.get("ariaValueText");
    if (ariaValueText) {
      focusElement.setAttribute("aria-valuetext", ariaValueText);
    } else {
      focusElement.removeAttribute("aria-valuetext");
    }
    const ariaControls = target.get("ariaControls");
    if (ariaControls) {
      focusElement.setAttribute("aria-controls", ariaControls);
    } else {
      focusElement.removeAttribute("aria-controls");
    }
    if (target.get("visible") && target.get("opacity") !== 0 && target.get("role") != "tooltip" && !target.isHidden() && target.getPrivate("focusable") !== false) {
      if (focusElement.getAttribute("tabindex") != "-1") {
        focusElement.setAttribute("tabindex", "" + this.tabindex);
      }
      focusElement.removeAttribute("aria-hidden");
    } else {
      focusElement.removeAttribute("tabindex");
      focusElement.setAttribute("aria-hidden", "true");
    }
  }
  _makeFocusElement(index2, target) {
    if (target.getPrivate("focusElement") || this._a11yD == true) {
      return;
    }
    const focusElement = document.createElement("div");
    if (target.get("role") != "tooltip") {
      focusElement.tabIndex = this.tabindex;
    }
    focusElement.style.position = "absolute";
    setInteractive(focusElement, false);
    const disposers = [];
    target.setPrivate("focusElement", {
      dom: focusElement,
      disposers
    });
    this._decorateFocusElement(target);
    disposers.push(addEventListener(focusElement, "focus", (ev) => {
      this._handleFocus(ev, index2);
    }));
    disposers.push(addEventListener(focusElement, "blur", (ev) => {
      this._handleBlur(ev, index2);
    }));
    this._moveFocusElement(index2, target);
  }
  _removeFocusElement(target) {
    if (this._a11yD == true) {
      return;
    }
    remove(this._tabindexes, target);
    const focusElement = target.getPrivate("focusElement");
    if (focusElement) {
      const container = this._focusElementContainer;
      container.removeChild(focusElement.dom);
      each(focusElement.disposers, (x2) => {
        x2.dispose();
      });
    }
  }
  _hideFocusElement(target) {
    if (this._a11yD == true) {
      return;
    }
    const focusElement = target.getPrivate("focusElement");
    focusElement.dom.style.display = "none";
  }
  _moveFocusElement(index2, target) {
    if (this._a11yD == true) {
      return;
    }
    const container = this._focusElementContainer;
    const focusElement = target.getPrivate("focusElement").dom;
    if (focusElement === this._focusElementContainer.children[index2]) {
      return;
    }
    const next2 = this._focusElementContainer.children[index2 + 1];
    if (next2) {
      container.insertBefore(focusElement, next2);
    } else {
      container.append(focusElement);
    }
  }
  _positionFocusElement(target) {
    if (this._a11yD == true || target == void 0) {
      return;
    }
    const bounds = target.globalBounds();
    let width = bounds.right == bounds.left ? target.width() : bounds.right - bounds.left;
    let height = bounds.top == bounds.bottom ? target.height() : bounds.bottom - bounds.top;
    const padding = this._settings.focusPadding !== void 0 ? this._settings.focusPadding : 2;
    let x2 = bounds.left - padding;
    let y2 = bounds.top - padding;
    if (width < 0) {
      x2 += width;
      width = Math.abs(width);
    }
    if (height < 0) {
      y2 += height;
      height = Math.abs(height);
    }
    const focusElement = target.getPrivate("focusElement").dom;
    focusElement.style.top = y2 + "px";
    focusElement.style.left = x2 + "px";
    focusElement.style.width = width + padding * 2 + "px";
    focusElement.style.height = height + padding * 2 + "px";
  }
  _handleFocus(ev, index2) {
    if (this._a11yD == true) {
      return;
    }
    const focused = this._tabindexes[index2];
    if (!focused.isVisibleDeep()) {
      this._focusNext(ev.target, this._isShift ? -1 : 1);
      return;
    }
    this._positionFocusElement(focused);
    this._focusedSprite = focused;
    if (focused.events.isEnabled("focus")) {
      focused.events.dispatch("focus", {
        type: "focus",
        originalEvent: ev,
        target: focused
      });
    }
  }
  _focusNext(el, direction) {
    if (this._a11yD == true) {
      return;
    }
    const focusableElements = Array.from(document.querySelectorAll([
      "a[href]",
      "area[href]",
      "button:not([disabled])",
      "details",
      "input:not([disabled])",
      "iframe:not([disabled])",
      "select:not([disabled])",
      "textarea:not([disabled])",
      '[contentEditable=""]',
      '[contentEditable="true"]',
      '[contentEditable="TRUE"]',
      '[tabindex]:not([tabindex^="-"])'
      //':not([disabled])'
    ].join(",")));
    let index2 = focusableElements.indexOf(el) + direction;
    if (index2 < 0) {
      index2 = focusableElements.length - 1;
    } else if (index2 >= focusableElements.length) {
      index2 = 0;
    }
    focusableElements[index2].focus();
  }
  _handleBlur(ev, _index) {
    if (this._a11yD == true) {
      return;
    }
    const focused = this._focusedSprite;
    if (focused && !focused.isDisposed() && focused.events.isEnabled("blur")) {
      focused.events.dispatch("blur", {
        type: "blur",
        originalEvent: ev,
        target: focused
      });
    }
    this._focusedSprite = void 0;
  }
  /**
   * @ignore
   */
  updateTooltip(target) {
    if (this._a11yD == true) {
      return;
    }
    const text = stripTags(target._getText());
    let tooltipElement = target.getPrivate("tooltipElement");
    if (target.get("role") == "tooltip" && text != "") {
      if (!tooltipElement) {
        tooltipElement = this._makeTooltipElement(target);
      }
      if (tooltipElement.innerHTML != text) {
        tooltipElement.innerHTML = text;
      }
    } else if (tooltipElement) {
      tooltipElement.remove();
      target.removePrivate("tooltipElement");
    }
  }
  _makeTooltipElement(target) {
    const container = this._tooltipElementContainer;
    const tooltipElement = document.createElement("div");
    tooltipElement.style.position = "absolute";
    tooltipElement.style.width = "1px";
    tooltipElement.style.height = "1px";
    tooltipElement.style.overflow = "hidden";
    tooltipElement.style.clip = "rect(1px, 1px, 1px, 1px)";
    setInteractive(tooltipElement, false);
    this._decorateFocusElement(target, tooltipElement);
    container.append(tooltipElement);
    target.setPrivate("tooltipElement", tooltipElement);
    return tooltipElement;
  }
  _removeTooltipElement(target) {
    if (this._a11yD == true) {
      return;
    }
    const tooltipElement = target.getPrivate("tooltipElement");
    if (tooltipElement) {
      const parent = tooltipElement.parentElement;
      if (parent) {
        parent.removeChild(tooltipElement);
      }
    }
  }
  _invalidateAccessibility(target) {
    if (this._a11yD == true) {
      return;
    }
    this._focusElementDirty = true;
    const focusElement = target.getPrivate("focusElement");
    if (target.get("focusable")) {
      if (focusElement) {
        this._decorateFocusElement(target);
        this._positionFocusElement(target);
      }
    } else if (focusElement) {
      this._removeFocusElement(target);
    }
  }
  /**
   * Returns `true` if `target` is currently focused.
   *
   * @param   target  Target
   * @return          Focused?
   */
  focused(target) {
    return this._focusedSprite === target;
  }
  /**
   * Converts document coordinates to coordinates withing root element.
   *
   * @param   point  Document point
   * @return         Root point
   */
  documentPointToRoot(point2) {
    const rect = this._getRealSize();
    const size = this._getCalculatedSize(rect);
    const scaleWidth = size.width / rect.width;
    const scaleHeight = size.height / rect.height;
    return {
      x: (point2.x - rect.left) * scaleWidth,
      y: (point2.y - rect.top) * scaleHeight
    };
  }
  /**
   * Converts root coordinates to document
   *
   * @param   point  Document point
   * @return         Root point
   */
  rootPointToDocument(point2) {
    const rect = this._getRealSize();
    const size = this._getCalculatedSize(rect);
    const scaleWidth = size.width / rect.width;
    const scaleHeight = size.height / rect.height;
    return {
      x: point2.x / scaleWidth + rect.left,
      y: point2.y / scaleHeight + rect.top
    };
  }
  /**
   * @ignore
   */
  addDisposer(disposer) {
    this._disposers.push(disposer);
    return disposer;
  }
  _updateComputedStyles() {
    const styles = window.getComputedStyle(this.dom);
    let fontHash = "";
    each2(styles, (key, val) => {
      if (isString2(key) && key.match(/^font/)) {
        fontHash += val;
      }
    });
    const changed = fontHash != this._fontHash;
    if (changed) {
      this._fontHash = fontHash;
    }
    return changed;
  }
  _checkComputedStyles() {
    if (this._updateComputedStyles()) {
      this._invalidateLabelBounds(this.container);
    }
  }
  _invalidateLabelBounds(target) {
    if (target instanceof Container) {
      target.children.each((child) => {
        this._invalidateLabelBounds(child);
      });
    } else if (target instanceof Text2) {
      target.markDirtyBounds();
    }
  }
  /**
   * To all the clever heads out there. Yes, we did not make any attempts to
   * scramble this.
   *
   * This is a part of a tool meant for our users to manage their commercial
   * licenses for removal of amCharts branding from charts.
   *
   * The only legit way to do so is to purchase a commercial license for amCharts:
   * https://www.amcharts.com/online-store/
   *
   * Removing or altering this code, or disabling amCharts branding in any other
   * way is against the license and thus illegal.
   */
  _hasLicense() {
    for (let i = 0; i < registry.licenses.length; i++) {
      if (registry.licenses[i].match(/^AM5C.{5,}/i)) {
        return true;
      }
    }
    return false;
  }
  _licenseApplied() {
    if (this._logo) {
      this._logo.set("forceHidden", true);
    }
  }
  /**
   * @ignore
   */
  get debugGhostView() {
    return this._renderer.debugGhostView;
  }
  /**
   * @ignore
   */
  set debugGhostView(value) {
    this._renderer.debugGhostView = value;
  }
  /**
   * Set this to `true` if you need chart to require first a tap onto it before
   * touch gesture related functionality like zoom/pan is turned on.
   *
   * @see {@link https://www.amcharts.com/docs/v5/getting-started/root-element/#Touch_related_options} for more info
   * @default false
   * @since 5.2.9
   * @param  value  Needs a tap to activate touch functions
   */
  set tapToActivate(value) {
    this._renderer.tapToActivate = value;
  }
  /**
   * @return Needs a tap to activate touch functions
   */
  get tapToActivate() {
    return this._renderer.tapToActivate;
  }
  /**
   * If `tapToActivate` is set to `true`, this setting will determine number
   * of milliseconds the chart will stay "active", before releasing the
   * controls back to the page.
   *
   * @see {@link https://www.amcharts.com/docs/v5/getting-started/root-element/#Touch_related_options} for more info
   * @default 3000
   * @since 5.2.9
   * @param  value  Timeout
   */
  set tapToActivateTimeout(value) {
    this._renderer.tapToActivateTimeout = value;
  }
  /**
   * @return Timeout
   */
  get tapToActivateTimeout() {
    return this._renderer.tapToActivateTimeout;
  }
  _makeHTMLElement(target) {
    const container = this._htmlElementContainer;
    const htmlElement = document.createElement("div");
    target.setPrivate("htmlElement", htmlElement);
    htmlElement.style.position = "absolute";
    htmlElement.style.overflow = "auto";
    htmlElement.style.boxSizing = "border-box";
    setInteractive(htmlElement, target.get("interactive", false));
    if (target.events.isEnabled("click")) {
      setInteractive(htmlElement, true);
      this._disposers.push(addEventListener(htmlElement, "click", (ev) => {
        const downEvent = this._renderer.getEvent(ev);
        target.events.dispatch("click", {
          type: "click",
          originalEvent: downEvent.event,
          point: downEvent.point,
          simulated: false,
          target
        });
      }));
    }
    this._positionHTMLElement(target);
    container.append(htmlElement);
    pushOne(this._htmlEnabledContainers, target);
    return htmlElement;
  }
  _positionHTMLElements() {
    each(this._htmlEnabledContainers, (target) => {
      this._positionHTMLElement(target);
    });
  }
  _positionHTMLElement(target) {
    const htmlElement = target.getPrivate("htmlElement");
    if (htmlElement) {
      const visualSettings2 = ["paddingTop", "paddingRight", "paddingBottom", "paddingLeft", "minWidth", "minHeight", "maxWidth", "maxHeight"];
      each(visualSettings2, (setting) => {
        const value = target.get(setting);
        if (value) {
          htmlElement.style[setting] = value + "px";
        } else {
          htmlElement.style[setting] = "";
        }
      });
      const opacity = target.compositeOpacity();
      setTimeout(() => {
        htmlElement.style.opacity = opacity + "";
      }, 10);
      const visible = target.isVisibleDeep();
      if (visible) {
        htmlElement.style.display = "block";
      }
      const bounds = target.globalBounds();
      htmlElement.style.top = bounds.top + "px";
      htmlElement.style.left = bounds.left + "px";
      const width = target.get("width");
      const height = target.get("height");
      let w = 0;
      let h = 0;
      if (width) {
        w = target.width();
      }
      if (height) {
        h = target.height();
      }
      if (!width || !height) {
        htmlElement.style.position = "fixed";
        htmlElement.style.width = "";
        htmlElement.style.height = "";
        const bbox = htmlElement.getBoundingClientRect();
        htmlElement.style.position = "absolute";
        w = bbox.width;
        h = bbox.height;
        target._adjustedLocalBounds = { left: 0, right: 0, top: 0, bottom: 0 };
        target.setPrivate("minWidth", w);
        target.setPrivate("minHeight", h);
      } else {
        target.removePrivate("minWidth");
        target.removePrivate("minHeight");
      }
      if (w > 0) {
        htmlElement.style.minWidth = w + "px";
      }
      if (h > 0) {
        htmlElement.style.minHeight = h + "px";
      }
      if (!visible || opacity == 0) {
        htmlElement.style.display = "none";
      }
    }
  }
  _setHTMLContent(target, html) {
    let htmlElement = target.getPrivate("htmlElement");
    if (!htmlElement) {
      htmlElement = this._makeHTMLElement(target);
    }
    if (htmlElement.innerHTML != html) {
      htmlElement.innerHTML = html;
    }
  }
  _removeHTMLContent(target) {
    let htmlElement = target.getPrivate("htmlElement");
    if (htmlElement) {
      this._htmlElementContainer.removeChild(htmlElement);
      target.removePrivate("htmlElement");
    }
    remove(this._htmlEnabledContainers, target);
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Bullet.js
var Bullet = class extends Entity2 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_index", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "series", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  _afterNew() {
    super._afterNewApplyThemes();
  }
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("sprite")) {
      const sprite = this.get("sprite");
      if (sprite) {
        sprite.setAll({ position: "absolute", role: "figure" });
        this._disposers.push(sprite);
      }
    }
    if (this.isDirty("locationX") || this.isDirty("locationY")) {
      if (this.series) {
        this.series._positionBullet(this);
      }
    }
  }
};
Object.defineProperty(Bullet, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Bullet"
});
Object.defineProperty(Bullet, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Entity2.classNames.concat([Bullet.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/RoundedRectangle.js
var RoundedRectangle = class extends Rectangle {
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("cornerRadiusTL") || this.isDirty("cornerRadiusTR") || this.isDirty("cornerRadiusBR") || this.isDirty("cornerRadiusBL")) {
      this._clear = true;
    }
  }
  _draw() {
    let width = this.width();
    let height = this.height();
    let w = width;
    let h = height;
    let wSign = w / Math.abs(width);
    let hSign = h / Math.abs(height);
    if (isNumber(w) && isNumber(h)) {
      let minSide = Math.min(w, h) / 2;
      let crtl = relativeToValue(this.get("cornerRadiusTL", 8), minSide);
      let crtr = relativeToValue(this.get("cornerRadiusTR", 8), minSide);
      let crbr = relativeToValue(this.get("cornerRadiusBR", 8), minSide);
      let crbl = relativeToValue(this.get("cornerRadiusBL", 8), minSide);
      let maxcr = Math.min(Math.abs(w / 2), Math.abs(h / 2));
      crtl = fitToRange(crtl, 0, maxcr);
      crtr = fitToRange(crtr, 0, maxcr);
      crbr = fitToRange(crbr, 0, maxcr);
      crbl = fitToRange(crbl, 0, maxcr);
      const display = this._display;
      display.moveTo(crtl * wSign, 0);
      display.lineTo(w - crtr * wSign, 0);
      if (crtr > 0) {
        display.arcTo(w, 0, w, crtr * hSign, crtr);
      }
      display.lineTo(w, h - crbr * hSign);
      if (crbr > 0) {
        display.arcTo(w, h, w - crbr * wSign, h, crbr);
      }
      display.lineTo(crbl * wSign, h);
      if (crbl > 0) {
        display.arcTo(0, h, 0, h - crbl * hSign, crbl);
      }
      display.lineTo(0, crtl * hSign);
      if (crtl > 0) {
        display.arcTo(0, 0, crtl * wSign, 0, crtl);
      }
      display.closePath();
    }
  }
};
Object.defineProperty(RoundedRectangle, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "RoundedRectangle"
});
Object.defineProperty(RoundedRectangle, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Rectangle.classNames.concat([RoundedRectangle.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Button.js
var Button2 = class extends Container {
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["button"]);
    super._afterNew();
    if (!this._settings.background) {
      this.set("background", RoundedRectangle.new(this._root, {
        themeTags: mergeTags(this._settings.themeTags, ["background"])
      }));
    }
    this.setPrivate("trustBounds", true);
  }
  _prepareChildren() {
    super._prepareChildren();
    if (this.isDirty("icon")) {
      const previous = this._prevSettings.icon;
      const icon = this.get("icon");
      if (icon !== previous) {
        this._disposeProperty("icon");
        if (previous) {
          previous.dispose();
        }
        if (icon) {
          this.children.push(icon);
        }
        this._prevSettings.icon = icon;
      }
    }
    if (this.isDirty("label")) {
      const previous = this._prevSettings.label;
      const label = this.get("label");
      if (label !== previous) {
        this._disposeProperty("label");
        if (previous) {
          previous.dispose();
        }
        if (label) {
          this.children.push(label);
        }
        this._prevSettings.label = label;
      }
    }
  }
};
Object.defineProperty(Button2, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Button"
});
Object.defineProperty(Button2, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Button2.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Circle.js
var Circle = class extends Graphics {
  _afterNew() {
    super._afterNew();
    this._display.isMeasured = true;
    this.setPrivateRaw("trustBounds", true);
  }
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("radius")) {
      this._clear = true;
    }
  }
  _changed() {
    super._changed();
    if (this._clear) {
      this._display.drawCircle(0, 0, this.get("radius", 10));
    }
  }
};
Object.defineProperty(Circle, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Circle"
});
Object.defineProperty(Circle, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Graphics.classNames.concat([Circle.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Data.js
var ListData = class extends List3 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "processor", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  /**
   * @ignore
   */
  incrementRef() {
  }
  /**
   * @ignore
   */
  decrementRef() {
  }
  _onPush(newValue) {
    if (this.processor) {
      this.processor.processRow(newValue);
    }
    super._onPush(newValue);
  }
  _onInsertIndex(index2, newValue) {
    if (this.processor) {
      this.processor.processRow(newValue);
    }
    super._onInsertIndex(index2, newValue);
  }
  _onSetIndex(index2, oldValue, newValue) {
    if (this.processor) {
      this.processor.processRow(newValue);
    }
    super._onSetIndex(index2, oldValue, newValue);
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Component.js
var DataItem = class extends Settings {
  constructor(component, dataContext, settings) {
    super(settings);
    Object.defineProperty(this, "component", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "dataContext", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "bullets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "open", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "close", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    this.dataContext = dataContext;
    this.component = component;
    this._settings.visible = true;
    this._checkDirty();
  }
  /**
   * @ignore
   */
  markDirty() {
    this.component.markDirtyValues(this);
  }
  _startAnimation() {
    this.component._root._addAnimation(this);
  }
  _animationTime() {
    return this.component._root.animationTime;
  }
  _dispose() {
    if (this.component) {
      this.component.disposeDataItem(this);
    }
    super._dispose();
  }
  /**
   * Shows a data item that's currently hidden.
   */
  show(duration) {
    this.setRaw("visible", true);
    if (this.component) {
      this.component.showDataItem(this, duration);
    }
  }
  /**
   * Hides a data item that's currently visible.
   */
  hide(duration) {
    this.setRaw("visible", false);
    if (this.component) {
      this.component.hideDataItem(this, duration);
    }
  }
  isHidden() {
    return !this.get("visible");
  }
};
var Component5 = class extends Container {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_data", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListData()
    });
    Object.defineProperty(this, "_dataItems", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_mainDataItems", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._dataItems
    });
    Object.defineProperty(this, "valueFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "fields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: ["id"]
    });
    Object.defineProperty(this, "_valueFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_valueFieldsF", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_fields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_fieldsF", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_valuesDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_dataChanged", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_dataGrouped", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "inited", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
  }
  /**
   * Component's data.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/data/} for more info
   */
  set data(data) {
    data.incrementRef();
    this._data.decrementRef();
    this._data = data;
  }
  /**
   * @return  Data
   */
  get data() {
    return this._data;
  }
  _dispose() {
    super._dispose();
    this._data.decrementRef();
  }
  _onDataClear() {
  }
  _afterNew() {
    super._afterNew();
    this._data.incrementRef();
    this._updateFields();
    this._disposers.push(this.data.events.onAll((change) => {
      const dataItems = this._mainDataItems;
      this.markDirtyValues();
      this._markDirtyGroup();
      this._dataChanged = true;
      if (change.type === "clear") {
        each(dataItems, (dataItem) => {
          dataItem.dispose();
        });
        dataItems.length = 0;
        this._onDataClear();
      } else if (change.type === "push") {
        const dataItem = new DataItem(this, change.newValue, this._makeDataItem(change.newValue));
        dataItems.push(dataItem);
        this.processDataItem(dataItem);
      } else if (change.type === "setIndex") {
        const dataItem = dataItems[change.index];
        const properties = this._makeDataItem(change.newValue);
        if (dataItem.bullets && dataItem.bullets.length == 0) {
          dataItem.bullets = void 0;
        }
        keys2(properties).forEach((key) => {
          dataItem.animate({
            key,
            to: properties[key],
            duration: this.get("interpolationDuration", 0),
            easing: this.get("interpolationEasing")
          });
        });
        dataItem.dataContext = change.newValue;
      } else if (change.type === "insertIndex") {
        const dataItem = new DataItem(this, change.newValue, this._makeDataItem(change.newValue));
        dataItems.splice(change.index, 0, dataItem);
        this.processDataItem(dataItem);
      } else if (change.type === "removeIndex") {
        const dataItem = dataItems[change.index];
        dataItem.dispose();
        dataItems.splice(change.index, 1);
      } else if (change.type === "moveIndex") {
        const dataItem = dataItems[change.oldIndex];
        dataItems.splice(change.oldIndex, 1);
        dataItems.splice(change.newIndex, 0, dataItem);
      } else {
        throw new Error("Unknown IStreamEvent type");
      }
      this._afterDataChange();
    }));
  }
  _updateFields() {
    if (this.valueFields) {
      this._valueFields = [];
      this._valueFieldsF = {};
      each(this.valueFields, (key) => {
        const field = this.get(key + "Field");
        if (field) {
          this._valueFields.push(key);
          this._valueFieldsF[key] = { fieldKey: key + "Field", workingKey: key + "Working" };
        }
      });
    }
    if (this.fields) {
      this._fields = [];
      this._fieldsF = {};
      each(this.fields, (key) => {
        const field = this.get(key + "Field");
        if (field) {
          this._fields.push(key);
          this._fieldsF[key] = key + "Field";
        }
      });
    }
  }
  /**
   * A list of component's data items.
   *
   * @return  Data items
   */
  get dataItems() {
    return this._dataItems;
  }
  processDataItem(_dataItem) {
  }
  _makeDataItem(data) {
    const output = {};
    if (this._valueFields) {
      each(this._valueFields, (key) => {
        const field = this.get(this._valueFieldsF[key].fieldKey);
        output[key] = data[field];
        output[this._valueFieldsF[key].workingKey] = output[key];
      });
    }
    if (this._fields) {
      each(this._fields, (key) => {
        const field = this.get(this._fieldsF[key]);
        output[key] = data[field];
      });
    }
    return output;
  }
  /**
   * @ignore
   */
  makeDataItem(data) {
    let dataItem = new DataItem(this, void 0, data);
    this.processDataItem(dataItem);
    return dataItem;
  }
  /**
   * @ignore
   */
  pushDataItem(data) {
    const dataItem = this.makeDataItem(data);
    this._mainDataItems.push(dataItem);
    return dataItem;
  }
  /**
   * @ignore
   */
  disposeDataItem(_dataItem) {
  }
  /**
   * Shows component's data item.
   *
   * @param   dataItem   Data item
   * @param   _duration  Animation duration in milliseconds
   * @return             Promise
   */
  showDataItem(dataItem, _duration) {
    return __awaiter(this, void 0, void 0, function* () {
      dataItem.set("visible", true);
    });
  }
  /**
   * Hides component's data item.
   *
   * @param   dataItem   Data item
   * @param   _duration  Animation duration in milliseconds
   * @return             Promise
   */
  hideDataItem(dataItem, _duration) {
    return __awaiter(this, void 0, void 0, function* () {
      dataItem.set("visible", false);
    });
  }
  _clearDirty() {
    super._clearDirty();
    this._valuesDirty = false;
  }
  _afterDataChange() {
  }
  _afterChanged() {
    super._afterChanged();
    if (this._dataChanged) {
      const type4 = "datavalidated";
      if (this.events.isEnabled(type4)) {
        this.events.dispatch(type4, { type: type4, target: this });
      }
      this._dataChanged = false;
    }
    this.inited = true;
  }
  /**
   * Forces a repaint of the element which relies on data.
   *
   * @since 5.0.21
   */
  markDirtyValues(_dataItem) {
    this.markDirty();
    this._valuesDirty = true;
  }
  _markDirtyGroup() {
    this._dataGrouped = false;
  }
  /**
   * @ignore
   */
  markDirtySize() {
    this._sizeDirty = true;
    this.markDirty();
  }
};
Object.defineProperty(Component5, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Component"
});
Object.defineProperty(Component5, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Component5.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Time.js
function sleep(ms) {
  return new Promise((resolve, _reject) => {
    setTimeout(resolve, ms);
  });
}
var timeUnitDurations = {
  millisecond: 1,
  second: 1e3,
  minute: 6e4,
  hour: 36e5,
  day: 864e5,
  week: 6048e5,
  month: 365.242 / 12 * 864e5,
  year: 31536e6
};
function getDuration(unit3, count) {
  if (count == null) {
    count = 1;
  }
  return timeUnitDurations[unit3] * count;
}
function round2(date4, unit3, count, firstDateOfWeek, utc, firstDate, timezone) {
  if (!timezone || utc) {
    let timeZoneOffset = 0;
    if (!utc && unit3 != "millisecond") {
      timeZoneOffset = date4.getTimezoneOffset();
      date4.setUTCMinutes(date4.getUTCMinutes() - timeZoneOffset);
    }
    switch (unit3) {
      case "day":
        let day = date4.getUTCDate();
        if (count > 1) {
          if (firstDate) {
            firstDate = round2(firstDate, "day", 1);
            let difference = date4.getTime() - firstDate.getTime();
            let unitCount = Math.floor(difference / getDuration("day") / count);
            let duration = getDuration("day", unitCount * count);
            date4.setTime(firstDate.getTime() + duration - timeZoneOffset * getDuration("minute"));
          }
        } else {
          date4.setUTCDate(day);
        }
        date4.setUTCHours(0, 0, 0, 0);
        break;
      case "second":
        let seconds = date4.getUTCSeconds();
        if (count > 1) {
          seconds = Math.floor(seconds / count) * count;
        }
        date4.setUTCSeconds(seconds, 0);
        break;
      case "millisecond":
        if (count == 1) {
          return date4;
        }
        let milliseconds = date4.getUTCMilliseconds();
        milliseconds = Math.floor(milliseconds / count) * count;
        date4.setUTCMilliseconds(milliseconds);
        break;
      case "hour":
        let hours = date4.getUTCHours();
        if (count > 1) {
          hours = Math.floor(hours / count) * count;
        }
        date4.setUTCHours(hours, 0, 0, 0);
        break;
      case "minute":
        let minutes = date4.getUTCMinutes();
        if (count > 1) {
          minutes = Math.floor(minutes / count) * count;
        }
        date4.setUTCMinutes(minutes, 0, 0);
        break;
      case "month":
        let month = date4.getUTCMonth();
        if (count > 1) {
          month = Math.floor(month / count) * count;
        }
        date4.setUTCMonth(month, 1);
        date4.setUTCHours(0, 0, 0, 0);
        break;
      case "year":
        let year = date4.getUTCFullYear();
        if (count > 1) {
          year = Math.floor(year / count) * count;
        }
        date4.setUTCFullYear(year, 0, 1);
        date4.setUTCHours(0, 0, 0, 0);
        break;
      case "week":
        let wday = date4.getUTCDate();
        let weekDay = date4.getUTCDay();
        if (!isNumber(firstDateOfWeek)) {
          firstDateOfWeek = 1;
        }
        if (weekDay >= firstDateOfWeek) {
          wday = wday - weekDay + firstDateOfWeek;
        } else {
          wday = wday - (7 + weekDay) + firstDateOfWeek;
        }
        date4.setUTCDate(wday);
        date4.setUTCHours(0, 0, 0, 0);
        break;
    }
    if (!utc && unit3 != "millisecond") {
      date4.setUTCMinutes(date4.getUTCMinutes() + timeZoneOffset);
      if (unit3 == "day" || unit3 == "week" || unit3 == "month" || unit3 == "year") {
        let newTimeZoneOffset = date4.getTimezoneOffset();
        if (newTimeZoneOffset != timeZoneOffset) {
          let diff = newTimeZoneOffset - timeZoneOffset;
          date4.setUTCMinutes(date4.getUTCMinutes() + diff);
        }
      }
    }
    return date4;
  } else {
    if (isNaN(date4.getTime())) {
      return date4;
    }
    let tzoffset = timezone.offsetUTC(date4);
    let timeZoneOffset = date4.getTimezoneOffset();
    let parsedDate = timezone.parseDate(date4);
    let year = parsedDate.year;
    let month = parsedDate.month;
    let day = parsedDate.day;
    let hour = parsedDate.hour;
    let minute = parsedDate.minute;
    let second = parsedDate.second;
    let millisecond = parsedDate.millisecond;
    let weekday = parsedDate.weekday;
    let offsetDif = tzoffset - timeZoneOffset;
    switch (unit3) {
      case "day":
        if (count > 1 && firstDate) {
          firstDate = round2(firstDate, "day", 1, firstDateOfWeek, utc, void 0, timezone);
          let difference = date4.getTime() - firstDate.getTime();
          let unitCount = Math.floor(difference / getDuration("day") / count);
          let duration = getDuration("day", unitCount * count);
          date4.setTime(firstDate.getTime() + duration);
          parsedDate = timezone.parseDate(date4);
          year = parsedDate.year;
          month = parsedDate.month;
          day = parsedDate.day;
        }
        hour = 0;
        minute = offsetDif;
        second = 0;
        millisecond = 0;
        break;
      case "second":
        minute += offsetDif;
        if (count > 1) {
          second = Math.floor(second / count) * count;
        }
        millisecond = 0;
        break;
      case "millisecond":
        minute += offsetDif;
        if (count > 1) {
          millisecond = Math.floor(millisecond / count) * count;
        }
        break;
      case "hour":
        if (count > 1) {
          hour = Math.floor(hour / count) * count;
        }
        minute = offsetDif;
        second = 0;
        millisecond = 0;
        break;
      case "minute":
        if (count > 1) {
          minute = Math.floor(minute / count) * count;
        }
        minute += offsetDif;
        second = 0;
        millisecond = 0;
        break;
      case "month":
        if (count > 1) {
          month = Math.floor(month / count) * count;
        }
        day = 1;
        hour = 0;
        minute = offsetDif;
        second = 0;
        millisecond = 0;
        break;
      case "year":
        if (count > 1) {
          year = Math.floor(year / count) * count;
        }
        month = 0;
        day = 1;
        hour = 0;
        minute = offsetDif;
        second = 0;
        millisecond = 0;
        break;
      case "week":
        if (!isNumber(firstDateOfWeek)) {
          firstDateOfWeek = 1;
        }
        if (weekday >= firstDateOfWeek) {
          day = day - weekday + firstDateOfWeek;
        } else {
          day = day - (7 + weekday) + firstDateOfWeek;
        }
        hour = 0;
        minute = offsetDif;
        second = 0;
        millisecond = 0;
        break;
    }
    date4 = new Date(year, month, day, hour, minute, second, millisecond);
    let newTimeZoneOffset = date4.getTimezoneOffset();
    let newTzoffset = timezone.offsetUTC(date4);
    let newDiff = newTzoffset - newTimeZoneOffset;
    if (newDiff != offsetDif) {
      date4.setTime(date4.getTime() + (newDiff - offsetDif) * 6e4);
    }
    return date4;
  }
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Series.js
var Series = class extends Component5 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_aggregatesCalculated", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_selectionAggregatesCalculated", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_dataProcessed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_psi", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_pei", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "chart", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "bullets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new List3()
    });
    Object.defineProperty(this, "bulletsContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Container.new(this._root, { width: p100, height: p100, position: "absolute" })
    });
  }
  _afterNew() {
    this.valueFields.push("value", "customValue");
    super._afterNew();
    this.setPrivate("customData", {});
    this._disposers.push(this.bullets.events.onAll((change) => {
      if (change.type === "clear") {
        this._handleBullets(this.dataItems);
      } else if (change.type === "push") {
        this._handleBullets(this.dataItems);
      } else if (change.type === "setIndex") {
        this._handleBullets(this.dataItems);
      } else if (change.type === "insertIndex") {
        this._handleBullets(this.dataItems);
      } else if (change.type === "removeIndex") {
        this._handleBullets(this.dataItems);
      } else if (change.type === "moveIndex") {
        this._handleBullets(this.dataItems);
      } else {
        throw new Error("Unknown IListEvent type");
      }
    }));
  }
  _dispose() {
    this.bulletsContainer.dispose();
    super._dispose();
  }
  startIndex() {
    let len = this.dataItems.length;
    return Math.min(this.getPrivate("startIndex", 0), len);
  }
  endIndex() {
    let len = this.dataItems.length;
    return Math.min(this.getPrivate("endIndex", len), len);
  }
  _handleBullets(dataItems) {
    each(dataItems, (dataItem) => {
      const bullets = dataItem.bullets;
      if (bullets) {
        each(bullets, (bullet) => {
          bullet.dispose();
        });
        dataItem.bullets = void 0;
      }
    });
    this.markDirtyValues();
  }
  /**
   * Looks up and returns a data item by its ID.
   *
   * @param   id  ID
   * @return      Data item
   */
  getDataItemById(id) {
    return find(this.dataItems, (dataItem) => {
      return dataItem.get("id") == id;
    });
  }
  _makeBullets(dataItem) {
    if (this._shouldMakeBullet(dataItem)) {
      dataItem.bullets = [];
      this.bullets.each((bulletFunction) => {
        this._makeBullet(dataItem, bulletFunction);
      });
    }
  }
  _shouldMakeBullet(_dataItem) {
    return true;
  }
  _makeBullet(dataItem, bulletFunction, index2) {
    const bullet = bulletFunction(this._root, this, dataItem);
    if (bullet) {
      bullet._index = index2;
      this._makeBulletReal(dataItem, bullet);
    }
    return bullet;
  }
  _makeBulletReal(dataItem, bullet) {
    let sprite = bullet.get("sprite");
    if (sprite) {
      sprite._setDataItem(dataItem);
      sprite.setRaw("position", "absolute");
      this.bulletsContainer.children.push(sprite);
    }
    bullet.series = this;
    dataItem.bullets.push(bullet);
  }
  /**
   * Adds bullet directly to a data item.
   *
   * Please note: method accepts [[Bullet]] instance as a paramter, not a
   * reference to a function.
   *
   * You should add Bullet instance, not a method like you do it on series.
   *
   * @see {@link https://www.amcharts.com/docs/v5/concepts/common-elements/bullets/#Adding_directly_to_data_item} for more info
   * @since 5.6.0
   *
   * @param  dataItem  Target data item
   * @param  bullet    Bullet instance
   */
  addBullet(dataItem, bullet) {
    if (!dataItem.bullets) {
      dataItem.bullets = [];
    }
    if (bullet) {
      this._makeBulletReal(dataItem, bullet);
    }
  }
  _clearDirty() {
    super._clearDirty();
    this._aggregatesCalculated = false;
    this._selectionAggregatesCalculated = false;
  }
  _prepareChildren() {
    super._prepareChildren();
    let startIndex = this.startIndex();
    let endIndex = this.endIndex();
    if (this.isDirty("name")) {
      this.updateLegendValue();
    }
    if (this.isDirty("heatRules")) {
      this._valuesDirty = true;
    }
    if (this.isPrivateDirty("baseValueSeries")) {
      const baseValueSeries = this.getPrivate("baseValueSeries");
      if (baseValueSeries) {
        this._disposers.push(baseValueSeries.onPrivate("startIndex", () => {
          this.markDirtyValues();
        }));
      }
    }
    const calculateAggregates = this.get("calculateAggregates");
    if (calculateAggregates) {
      if (this._valuesDirty && !this._dataProcessed) {
        if (!this._aggregatesCalculated) {
          this._calculateAggregates(0, this.dataItems.length);
          this._aggregatesCalculated = true;
          if (startIndex != 0) {
            this._psi = void 0;
          }
        }
      }
      if ((this._psi != startIndex || this._pei != endIndex) && !this._selectionAggregatesCalculated) {
        if (startIndex === 0 && endIndex === this.dataItems.length && this._aggregatesCalculated) {
        } else {
          this._calculateAggregates(startIndex, endIndex);
        }
        this._selectionAggregatesCalculated = true;
      }
    }
    if (this.isDirty("tooltip")) {
      let tooltip = this.get("tooltip");
      if (tooltip) {
        tooltip.hide(0);
        tooltip.set("tooltipTarget", this);
      }
    }
    if (this.isDirty("fill") || this.isDirty("stroke")) {
      let markerRectangle;
      const legendDataItem = this.get("legendDataItem");
      if (legendDataItem) {
        markerRectangle = legendDataItem.get("markerRectangle");
        if (markerRectangle) {
          if (this.isVisible()) {
            if (this.isDirty("stroke")) {
              let stroke = this.get("stroke");
              markerRectangle.set("stroke", stroke);
            }
            if (this.isDirty("fill")) {
              let fill = this.get("fill");
              markerRectangle.set("fill", fill);
            }
          }
        }
      }
      this.updateLegendMarker(void 0);
    }
    if (this.bullets.length > 0) {
      let startIndex2 = this.startIndex();
      let endIndex2 = this.endIndex();
      if (endIndex2 < this.dataItems.length) {
        endIndex2++;
      }
      for (let i = startIndex2; i < endIndex2; i++) {
        let dataItem = this.dataItems[i];
        if (!dataItem.bullets) {
          this._makeBullets(dataItem);
        }
      }
    }
  }
  _calculateAggregates(startIndex, endIndex) {
    let fields = this._valueFields;
    if (!fields) {
      throw new Error("No value fields are set for the series.");
    }
    const sum = {};
    const absSum = {};
    const count = {};
    const low = {};
    const high = {};
    const open3 = {};
    const close = {};
    const average = {};
    const previous = {};
    each(fields, (key) => {
      sum[key] = 0;
      absSum[key] = 0;
      count[key] = 0;
    });
    each(fields, (key) => {
      let change = key + "Change";
      let changePercent = key + "ChangePercent";
      let changePrevious = key + "ChangePrevious";
      let changePreviousPercent = key + "ChangePreviousPercent";
      let changeSelection = key + "ChangeSelection";
      let changeSelectionPercent = key + "ChangeSelectionPercent";
      let openKey = "valueY";
      if (key == "valueX" || key == "openValueX" || key == "lowValueX" || key == "highValueX") {
        openKey = "valueX";
      }
      const baseValueSeries = this.getPrivate("baseValueSeries");
      for (let i = startIndex; i < endIndex; i++) {
        const dataItem = this.dataItems[i];
        let value = dataItem.get(key);
        if (value != null) {
          count[key]++;
          sum[key] += value;
          absSum[key] += Math.abs(value);
          average[key] = sum[key] / count[key];
          if (low[key] > value || low[key] == null) {
            low[key] = value;
          }
          if (high[key] < value || high[key] == null) {
            high[key] = value;
          }
          close[key] = value;
          if (open3[key] == null) {
            open3[key] = value;
            previous[key] = value;
            if (baseValueSeries) {
              open3[openKey] = baseValueSeries._getBase(openKey);
            }
          }
          if (startIndex === 0) {
            dataItem.setRaw(change, value - open3[openKey]);
            dataItem.setRaw(changePercent, (value - open3[openKey]) / open3[openKey] * 100);
          }
          dataItem.setRaw(changePrevious, value - previous[openKey]);
          dataItem.setRaw(changePreviousPercent, (value - previous[openKey]) / previous[openKey] * 100);
          dataItem.setRaw(changeSelection, value - open3[openKey]);
          dataItem.setRaw(changeSelectionPercent, (value - open3[openKey]) / open3[openKey] * 100);
          previous[key] = value;
        }
      }
    });
    each(fields, (key) => {
      this.setPrivate(key + "AverageSelection", average[key]);
      this.setPrivate(key + "CountSelection", count[key]);
      this.setPrivate(key + "SumSelection", sum[key]);
      this.setPrivate(key + "AbsoluteSumSelection", absSum[key]);
      this.setPrivate(key + "LowSelection", low[key]);
      this.setPrivate(key + "HighSelection", high[key]);
      this.setPrivate(key + "OpenSelection", open3[key]);
      this.setPrivate(key + "CloseSelection", close[key]);
    });
    if (startIndex === 0 && endIndex === this.dataItems.length) {
      each(fields, (key) => {
        this.setPrivate(key + "Average", average[key]);
        this.setPrivate(key + "Count", count[key]);
        this.setPrivate(key + "Sum", sum[key]);
        this.setPrivate(key + "AbsoluteSum", absSum[key]);
        this.setPrivate(key + "Low", low[key]);
        this.setPrivate(key + "High", high[key]);
        this.setPrivate(key + "Open", open3[key]);
        this.setPrivate(key + "Close", close[key]);
      });
    }
  }
  _updateChildren() {
    super._updateChildren();
    this._psi = this.startIndex();
    this._pei = this.endIndex();
    if (this.isDirty("visible")) {
      this.bulletsContainer.set("visible", this.get("visible"));
    }
    const rules2 = this.get("heatRules");
    if (this._valuesDirty && rules2 && rules2.length > 0) {
      each(rules2, (rule) => {
        const minValue = rule.minValue || this.getPrivate(rule.dataField + "Low") || 0;
        const maxValue = rule.maxValue || this.getPrivate(rule.dataField + "High") || 0;
        each(rule.target._entities, (target) => {
          const value = target.dataItem.get(rule.dataField);
          if (!isNumber(value)) {
            if (rule.neutral) {
              target.set(rule.key, rule.neutral);
            }
            const states = target.states;
            if (states) {
              const defaultState = states.lookup("default");
              if (defaultState) {
                defaultState.set(rule.key, rule.neutral);
              }
            }
            return;
          }
          if (rule.customFunction) {
            rule.customFunction.call(this, target, minValue, maxValue, value);
          } else {
            let percent2;
            if (rule.logarithmic) {
              percent2 = (Math.log(value) * Math.LOG10E - Math.log(minValue) * Math.LOG10E) / (Math.log(maxValue) * Math.LOG10E - Math.log(minValue) * Math.LOG10E);
            } else {
              percent2 = (value - minValue) / (maxValue - minValue);
            }
            if (isNumber(value) && (!isNumber(percent2) || Math.abs(percent2) == Infinity)) {
              percent2 = 0.5;
            }
            let propertyValue;
            if (isNumber(rule.min)) {
              propertyValue = rule.min + (rule.max - rule.min) * percent2;
            } else if (rule.min instanceof Color) {
              propertyValue = Color.interpolate(percent2, rule.min, rule.max);
            } else if (rule.min instanceof Percent) {
              propertyValue = percentInterpolate(percent2, rule.min, rule.max);
            }
            target.set(rule.key, propertyValue);
            const states = target.states;
            if (states) {
              const defaultState = states.lookup("default");
              if (defaultState) {
                defaultState.set(rule.key, propertyValue);
              }
            }
          }
        });
      });
    }
    if (this.get("visible")) {
      let count = this.dataItems.length;
      let startIndex = this.startIndex();
      let endIndex = this.endIndex();
      if (endIndex < count) {
        endIndex++;
      }
      if (startIndex > 0) {
        startIndex--;
      }
      for (let i = 0; i < startIndex; i++) {
        this._hideBullets(this.dataItems[i]);
      }
      for (let i = startIndex; i < endIndex; i++) {
        this._positionBullets(this.dataItems[i]);
      }
      for (let i = endIndex; i < count; i++) {
        this._hideBullets(this.dataItems[i]);
      }
    }
  }
  _positionBullets(dataItem) {
    if (dataItem.bullets) {
      each(dataItem.bullets, (bullet) => {
        this._positionBullet(bullet);
        const sprite = bullet.get("sprite");
        if (bullet.get("dynamic")) {
          if (sprite) {
            sprite._markDirtyKey("fill");
            sprite.markDirtySize();
          }
          if (sprite instanceof Container) {
            sprite.walkChildren((child) => {
              child._markDirtyKey("fill");
              child.markDirtySize();
              if (child instanceof Label) {
                child.text.markDirtyText();
              }
            });
          }
        }
        if (sprite instanceof Label && sprite.get("populateText")) {
          sprite.text.markDirtyText();
        }
      });
    }
  }
  _hideBullets(dataItem) {
    if (dataItem.bullets) {
      each(dataItem.bullets, (bullet) => {
        let sprite = bullet.get("sprite");
        if (sprite) {
          sprite.setPrivate("visible", false);
        }
      });
    }
  }
  _positionBullet(_bullet) {
  }
  _placeBulletsContainer(chart) {
    chart.bulletsContainer.children.moveValue(this.bulletsContainer);
  }
  _removeBulletsContainer() {
    const bulletsContainer = this.bulletsContainer;
    if (bulletsContainer.parent) {
      bulletsContainer.parent.children.removeValue(bulletsContainer);
    }
  }
  /**
   * @ignore
   */
  disposeDataItem(dataItem) {
    const bullets = dataItem.bullets;
    if (bullets) {
      each(bullets, (bullet) => {
        bullet.dispose();
      });
    }
  }
  _getItemReaderLabel() {
    return "";
  }
  /**
   * Shows series's data item.
   *
   * @param   dataItem  Data item
   * @param   duration  Animation duration in milliseconds
   * @return            Promise
   */
  showDataItem(dataItem, duration) {
    const _super = Object.create(null, {
      showDataItem: { get: () => super.showDataItem }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const promises = [_super.showDataItem.call(this, dataItem, duration)];
      const bullets = dataItem.bullets;
      if (bullets) {
        each(bullets, (bullet) => {
          const sprite = bullet.get("sprite");
          if (sprite) {
            promises.push(sprite.show(duration));
          }
        });
      }
      yield Promise.all(promises);
    });
  }
  /**
   * Hides series's data item.
   *
   * @param   dataItem  Data item
   * @param   duration  Animation duration in milliseconds
   * @return            Promise
   */
  hideDataItem(dataItem, duration) {
    const _super = Object.create(null, {
      hideDataItem: { get: () => super.hideDataItem }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const promises = [_super.hideDataItem.call(this, dataItem, duration)];
      const bullets = dataItem.bullets;
      if (bullets) {
        each(bullets, (bullet) => {
          const sprite = bullet.get("sprite");
          if (sprite) {
            promises.push(sprite.hide(duration));
          }
        });
      }
      yield Promise.all(promises);
    });
  }
  _sequencedShowHide(show, duration) {
    return __awaiter(this, void 0, void 0, function* () {
      if (this.get("sequencedInterpolation")) {
        if (!isNumber(duration)) {
          duration = this.get("interpolationDuration", 0);
        }
        if (duration > 0) {
          const startIndex = this.startIndex();
          const endIndex = this.endIndex();
          yield Promise.all(map(this.dataItems, (dataItem, i) => __awaiter(this, void 0, void 0, function* () {
            let realDuration = duration || 0;
            if (i < startIndex - 10 || i > endIndex + 10) {
              realDuration = 0;
            }
            let delay = this.get("sequencedDelay", 0) + realDuration / (endIndex - startIndex);
            yield sleep(delay * (i - startIndex));
            if (show) {
              yield this.showDataItem(dataItem, realDuration);
            } else {
              yield this.hideDataItem(dataItem, realDuration);
            }
          })));
        } else {
          yield Promise.all(map(this.dataItems, (dataItem) => {
            if (show) {
              return this.showDataItem(dataItem, 0);
            } else {
              return this.hideDataItem(dataItem, 0);
            }
          }));
        }
      }
    });
  }
  /**
   * @ignore
   */
  updateLegendValue(dataItem) {
    if (dataItem) {
      const legendDataItem = dataItem.get("legendDataItem");
      if (legendDataItem) {
        const valueLabel = legendDataItem.get("valueLabel");
        if (valueLabel) {
          const text = valueLabel.text;
          let txt = "";
          valueLabel._setDataItem(dataItem);
          txt = this.get("legendValueText", text.get("text", ""));
          valueLabel.set("text", txt);
          text.markDirtyText();
        }
        const label = legendDataItem.get("label");
        if (label) {
          const text = label.text;
          let txt = "";
          label._setDataItem(dataItem);
          txt = this.get("legendLabelText", text.get("text", ""));
          label.set("text", txt);
          text.markDirtyText();
        }
      }
    }
  }
  /**
   * @ignore
   */
  updateLegendMarker(_dataItem) {
  }
  _onHide() {
    super._onHide();
    const tooltip = this.getTooltip();
    if (tooltip) {
      tooltip.hide();
    }
  }
  /**
   * @ignore
   */
  hoverDataItem(_dataItem) {
  }
  /**
   * @ignore
   */
  unhoverDataItem(_dataItem) {
  }
  /**
   * @ignore
   */
  _getBase(key) {
    const dataItem = this.dataItems[this.startIndex()];
    if (dataItem) {
      return dataItem.get(key);
    }
    return 0;
  }
};
Object.defineProperty(Series, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Series"
});
Object.defineProperty(Series, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Component5.classNames.concat([Series.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Legend.js
var Legend = class extends Series {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "itemContainers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => Container._new(this._root, {
        themeTags: mergeTags(this.itemContainers.template.get("themeTags", []), ["legend", "item"]),
        themeTagsSelf: mergeTags(this.itemContainers.template.get("themeTagsSelf", []), ["itemcontainer"]),
        background: RoundedRectangle.new(this._root, {
          themeTags: mergeTags(this.itemContainers.template.get("themeTags", []), ["legend", "item", "background"]),
          themeTagsSelf: mergeTags(this.itemContainers.template.get("themeTagsSelf", []), ["itemcontainer"])
        })
      }, [this.itemContainers.template]))
    });
    Object.defineProperty(this, "markers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => Container._new(this._root, {
        themeTags: mergeTags(this.markers.template.get("themeTags", []), ["legend", "marker"])
      }, [this.markers.template]))
    });
    Object.defineProperty(this, "labels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => Label._new(this._root, {
        themeTags: mergeTags(this.labels.template.get("themeTags", []), ["legend", "label"])
      }, [this.labels.template]))
    });
    Object.defineProperty(this, "valueLabels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => Label._new(this._root, {
        themeTags: mergeTags(this.valueLabels.template.get("themeTags", []), ["legend", "label", "value"])
      }, [this.valueLabels.template]))
    });
    Object.defineProperty(this, "markerRectangles", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => RoundedRectangle._new(this._root, {
        themeTags: mergeTags(this.markerRectangles.template.get("themeTags", []), ["legend", "marker", "rectangle"])
      }, [this.markerRectangles.template]))
    });
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["legend"]);
    this.fields.push("name", "stroke", "fill");
    super._afterNew();
  }
  /**
   * @ignore
   */
  makeItemContainer(dataItem) {
    const itemContainer = this.children.push(this.itemContainers.make());
    itemContainer._setDataItem(dataItem);
    this.itemContainers.push(itemContainer);
    itemContainer.states.create("disabled", {});
    return itemContainer;
  }
  /**
   * @ignore
   */
  makeMarker() {
    const marker = this.markers.make();
    this.markers.push(marker);
    marker.states.create("disabled", {});
    return marker;
  }
  /**
   * @ignore
   */
  makeLabel() {
    const label = this.labels.make();
    label.states.create("disabled", {});
    return label;
  }
  /**
   * @ignore
   */
  makeValueLabel() {
    const valueLabel = this.valueLabels.make();
    valueLabel.states.create("disabled", {});
    return valueLabel;
  }
  /**
   * @ignore
   */
  makeMarkerRectangle() {
    const markerRectangle = this.markerRectangles.make();
    markerRectangle.states.create("disabled", {});
    return markerRectangle;
  }
  processDataItem(dataItem) {
    super.processDataItem(dataItem);
    const itemContainer = this.makeItemContainer(dataItem);
    const nameField = this.get("nameField");
    const fillField = this.get("fillField");
    const strokeField = this.get("strokeField");
    if (itemContainer) {
      const clickTarget = this.get("clickTarget", "itemContainer");
      const item = dataItem.dataContext;
      if (item && item.set) {
        item.set("legendDataItem", dataItem);
      }
      itemContainer._setDataItem(dataItem);
      dataItem.set("itemContainer", itemContainer);
      const marker = this.makeMarker();
      if (marker) {
        itemContainer.children.push(marker);
        marker._setDataItem(dataItem);
        dataItem.set("marker", marker);
        const useDefaultMarker = this.get("useDefaultMarker");
        const markerRectangle = marker.children.push(this.makeMarkerRectangle());
        let fill = dataItem.get("fill");
        let stroke = dataItem.get("stroke");
        dataItem.set("markerRectangle", markerRectangle);
        if (item && item.get) {
          fill = item.get(fillField, fill);
          stroke = item.get(strokeField, stroke);
        }
        if (!stroke) {
          stroke = fill;
        }
        if (!useDefaultMarker) {
          if (item && item.createLegendMarker) {
            item.createLegendMarker();
          }
        } else {
          if (item.on) {
            item.on(fillField, () => {
              markerRectangle.set("fill", item.get(fillField));
            });
            item.on(strokeField, () => {
              markerRectangle.set("stroke", item.get(strokeField));
            });
          }
        }
        markerRectangle.setAll({ fill, stroke });
        const component = item.component;
        if (component && component.updateLegendMarker) {
          component.updateLegendMarker(item);
        }
      }
      const label = this.makeLabel();
      if (label) {
        itemContainer.children.push(label);
        label._setDataItem(dataItem);
        dataItem.set("label", label);
        label.text.on("text", () => {
          itemContainer.setRaw("ariaLabel", label.text._getText() + (this.get("clickTarget") !== "none" ? "; " + this._t("Press ENTER to toggle") : ""));
          itemContainer.markDirtyAccessibility();
        });
        if (item && item.get) {
          dataItem.set("name", item.get(nameField));
        }
        let name = dataItem.get("name");
        if (name) {
          label.set("text", name);
        }
      }
      const valueLabel = this.makeValueLabel();
      if (valueLabel) {
        itemContainer.children.push(valueLabel);
        valueLabel._setDataItem(dataItem);
        dataItem.set("valueLabel", valueLabel);
      }
      if (item && item.show) {
        item.on("visible", (visible) => {
          itemContainer.set("disabled", !visible);
        });
        if (!item.get("visible")) {
          itemContainer.set("disabled", true);
        }
        if (clickTarget != "none") {
          let clickContainer = itemContainer;
          if (clickTarget == "marker") {
            clickContainer = marker;
          }
          this._addClickEvents(clickContainer, item, dataItem);
        }
      }
      this.children.values.sort((a, b) => {
        const targetA = a.dataItem.dataContext;
        const targetB = b.dataItem.dataContext;
        if (targetA && targetB) {
          const indexA = this.data.indexOf(targetA);
          const indexB = this.data.indexOf(targetB);
          if (indexA > indexB) {
            return 1;
          } else if (indexA < indexB) {
            return -1;
          }
        }
        return 0;
      });
      if (item && item.updateLegendValue) {
        item.updateLegendValue();
      }
    }
  }
  _addClickEvents(container, item, dataItem) {
    container.set("cursorOverStyle", "pointer");
    container.events.on("pointerover", () => {
      const component = item.component;
      if (component && component.hoverDataItem) {
        component.hoverDataItem(item);
      }
    });
    container.events.on("pointerout", () => {
      const component = item.component;
      if (component && component.hoverDataItem) {
        component.unhoverDataItem(item);
      }
    });
    container.events.on("click", () => {
      const labelText = dataItem.get("label").text._getText();
      if (item.show && item.isHidden && (item.isHidden() || item.get("visible") === false)) {
        item.show();
        container.set("disabled", false);
        this._root.readerAlert(this._t("%1 shown", this._root.locale, labelText));
      } else if (item.hide) {
        item.hide();
        container.set("disabled", true);
        this._root.readerAlert(this._t("%1 hidden", this._root.locale, labelText));
      }
    });
  }
  /**
   * @ignore
   */
  disposeDataItem(dataItem) {
    super.disposeDataItem(dataItem);
    const dataContext = dataItem.dataContext;
    if (dataContext && dataContext.get) {
      const di = dataContext.get("legendDataItem");
      if (di == dataItem) {
        dataContext.set("legendDataItem", void 0);
      }
    }
    let itemContainer = dataItem.get("itemContainer");
    if (itemContainer) {
      this.itemContainers.removeValue(itemContainer);
      itemContainer.dispose();
    }
    let marker = dataItem.get("marker");
    if (marker) {
      this.markers.removeValue(marker);
      marker.dispose();
    }
    let markerRectangle = dataItem.get("markerRectangle");
    if (markerRectangle) {
      this.markerRectangles.removeValue(markerRectangle);
      markerRectangle.dispose();
    }
    let label = dataItem.get("label");
    if (label) {
      this.labels.removeValue(label);
      label.dispose();
    }
    let valueLabel = dataItem.get("valueLabel");
    if (valueLabel) {
      this.valueLabels.removeValue(valueLabel);
      valueLabel.dispose();
    }
  }
};
Object.defineProperty(Legend, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Legend"
});
Object.defineProperty(Legend, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Series.classNames.concat([Legend.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/Draw.js
function segmentedLine(display, segments) {
  for (let s2 = 0, len = segments.length; s2 < len; s2++) {
    const groups = segments[s2];
    if (groups.length > 0) {
      let firstGroup = groups[0];
      if (firstGroup.length > 0) {
        let firstPoint = firstGroup[0];
        display.moveTo(firstPoint.x, firstPoint.y);
        for (let g = 0, len2 = groups.length; g < len2; g++) {
          line2(display, groups[g]);
        }
      }
    }
  }
}
function line2(display, points) {
  for (let p = 0, len = points.length; p < len; p++) {
    const point2 = points[p];
    display.lineTo(point2.x, point2.y);
  }
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Line.js
var Line = class extends Graphics {
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("points") || this.isDirty("segments") || this._sizeDirty || this.isPrivateDirty("width") || this.isPrivateDirty("height")) {
      this._clear = true;
    }
  }
  _changed() {
    super._changed();
    if (this._clear) {
      const points = this.get("points");
      const segments = this.get("segments");
      if (points && points.length > 0) {
        let point2 = points[0];
        this._display.moveTo(point2.x, point2.y);
        segmentedLine(this._display, [[points]]);
      } else if (segments) {
        segmentedLine(this._display, segments);
      } else if (!this.get("draw")) {
        let w = this.width();
        let h = this.height();
        this._display.moveTo(0, 0);
        this._display.lineTo(w, h);
      }
    }
  }
};
Object.defineProperty(Line, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Line"
});
Object.defineProperty(Line, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Graphics.classNames.concat([Line.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/RadialText.js
var RadialText = class extends Text2 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_display", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._root._renderer.makeRadialText("", this.textStyle)
    });
  }
  _afterNew() {
    super._afterNew();
  }
  _beforeChanged() {
    super._beforeChanged();
    this._display.clear();
    if (this.isDirty("textType")) {
      this._display.textType = this.get("textType");
      this.markDirtyBounds();
    }
    if (this.isDirty("radius")) {
      this._display.radius = this.get("radius");
      this.markDirtyBounds();
    }
    if (this.isDirty("startAngle")) {
      this._display.startAngle = (this.get("startAngle", 0) + 90) * RADIANS;
      this.markDirtyBounds();
    }
    if (this.isDirty("inside")) {
      this._display.inside = this.get("inside");
      this.markDirtyBounds();
    }
    if (this.isDirty("orientation")) {
      this._display.orientation = this.get("orientation");
      this.markDirtyBounds();
    }
    if (this.isDirty("kerning")) {
      this._display.kerning = this.get("kerning");
      this.markDirtyBounds();
    }
  }
};
Object.defineProperty(RadialText, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "RadialText"
});
Object.defineProperty(RadialText, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Text2.classNames.concat([RadialText.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/RadialLabel.js
var RadialLabel = class extends Label {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_flipped", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
  }
  _afterNew() {
    this._textKeys.push("textType", "kerning");
    super._afterNew();
  }
  _makeText() {
    this._text = this.children.push(RadialText.new(this._root, {}));
  }
  /**
   * Returns base radius in pixels.
   *
   * @return Base radius
   */
  baseRadius() {
    const radiusPrivate = this.getPrivate("radius", 0);
    const innerRadiusPrivate = this.getPrivate("innerRadius", 0);
    const baseRadius = this.get("baseRadius", 0);
    return innerRadiusPrivate + relativeToValue(baseRadius, radiusPrivate - innerRadiusPrivate);
  }
  /**
   * Returns radius adjustment in pixels.
   *
   * @return Radius
   */
  radius() {
    const inside = this.get("inside", false);
    return this.baseRadius() + this.get("radius", 0) * (inside ? -1 : 1);
  }
  _updateChildren() {
    super._updateChildren();
    if (this.isDirty("baseRadius") || this.isPrivateDirty("radius") || this.isPrivateDirty("innerRadius") || this.isDirty("labelAngle") || this.isDirty("radius") || this.isDirty("inside") || this.isDirty("orientation") || this.isDirty("textType")) {
      const textType = this.get("textType", "adjusted");
      const inside = this.get("inside", false);
      const orientation = this.get("orientation");
      let labelAngle = normalizeAngle(this.get("labelAngle", 0));
      this._text.set("startAngle", this.get("labelAngle", 0));
      this._text.set("inside", inside);
      const sin3 = sin(labelAngle);
      const cos3 = cos(labelAngle);
      let baseRadius = this.baseRadius();
      let radius = this.radius();
      this._display.angle = 0;
      if (textType == "circular") {
        this.setAll({
          paddingTop: 0,
          paddingBottom: 0,
          paddingLeft: 0,
          paddingRight: 0
        });
        this._text.set("orientation", orientation);
        this._text.set("radius", radius);
      } else {
        if (baseRadius == 0) {
          labelAngle = 0;
          radius = 0;
        }
        let x2 = radius * cos3;
        let y2 = radius * sin3;
        if (textType == "radial") {
          this.setRaw("x", x2);
          this.setRaw("y", y2);
          if (labelAngle < 90 || labelAngle > 270 || orientation != "auto") {
            this._display.angle = labelAngle;
            this._flipped = false;
          } else {
            this._display.angle = labelAngle + 180;
            this._flipped = true;
          }
          this._dirty.rotation = false;
        } else if (textType == "adjusted") {
          this.setRaw("centerX", p50);
          this.setRaw("centerY", p50);
          this.setRaw("x", x2);
          this.setRaw("y", y2);
        } else if (textType == "regular") {
          this.setRaw("x", x2);
          this.setRaw("y", y2);
        }
      }
      this.markDirtyPosition();
      this.markDirtyBounds();
    }
  }
  _updatePosition() {
    const textType = this.get("textType", "regular");
    const inside = this.get("inside", false);
    let dx = 0;
    let dy = 0;
    let labelAngle = this.get("labelAngle", 0);
    let bounds = this.localBounds();
    let w = bounds.right - bounds.left;
    let h = bounds.bottom - bounds.top;
    if (textType == "radial") {
      if (this._flipped) {
        let centerX = this.get("centerX");
        if (centerX instanceof Percent) {
          w = w * (1 - centerX.value * 2);
        }
        dx = w * cos(labelAngle);
        dy = w * sin(labelAngle);
      }
    } else if (!inside && textType == "adjusted") {
      dx = w / 2 * cos(labelAngle);
      dy = h / 2 * sin(labelAngle);
    }
    this.setRaw("dx", dx);
    this.setRaw("dy", dy);
    super._updatePosition();
  }
  /**
   * @ignore
   */
  get text() {
    return this._text;
  }
};
Object.defineProperty(RadialLabel, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "RadialLabel"
});
Object.defineProperty(RadialLabel, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Label.classNames.concat([RadialLabel.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Scrollbar.js
var Scrollbar = class extends Container {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "thumb", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._makeThumb()
    });
    Object.defineProperty(this, "startGrip", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._makeButton()
    });
    Object.defineProperty(this, "endGrip", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._makeButton()
    });
    Object.defineProperty(this, "_thumbBusy", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_startDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_endDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_thumbDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_gripDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  _addOrientationClass() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["scrollbar", this._settings.orientation]);
    if (!this._settings.background) {
      this._settings.background = RoundedRectangle.new(this._root, {
        themeTags: mergeTags(this._settings.themeTags, ["main", "background"])
      });
    }
  }
  _makeButton() {
    return this.children.push(Button2.new(this._root, {
      themeTags: ["resize", "button", this.get("orientation")],
      icon: Graphics.new(this._root, {
        themeTags: ["icon"]
      })
    }));
  }
  _makeThumb() {
    return this.children.push(RoundedRectangle.new(this._root, {
      themeTags: ["thumb", this.get("orientation")]
    }));
  }
  _handleAnimation(animation) {
    if (animation) {
      this._disposers.push(animation.events.on("stopped", () => {
        this.setPrivateRaw("isBusy", false);
        this._thumbBusy = false;
      }));
    }
  }
  _afterNew() {
    this._addOrientationClass();
    super._afterNew();
    const startGrip = this.startGrip;
    const endGrip = this.endGrip;
    const thumb = this.thumb;
    const background = this.get("background");
    if (background) {
      this._disposers.push(background.events.on("click", (event) => {
        this.setPrivateRaw("isBusy", true);
        const point2 = this._display.toLocal(event.point);
        const w = this.width();
        const h = this.height();
        const orientation = this.get("orientation");
        let newMiddle;
        if (orientation == "vertical") {
          newMiddle = (point2.y - thumb.height() / 2) / h;
        } else {
          newMiddle = (point2.x - thumb.width() / 2) / w;
        }
        let newCoordinate;
        let key;
        if (orientation == "vertical") {
          newCoordinate = newMiddle * h;
          key = "y";
        } else {
          newCoordinate = newMiddle * w;
          key = "x";
        }
        const duration = this.get("animationDuration", 0);
        if (duration > 0) {
          this._thumbBusy = true;
          this._handleAnimation(this.thumb.animate({ key, to: newCoordinate, duration, easing: this.get("animationEasing") }));
        } else {
          this.thumb.set(key, newCoordinate);
          this._root.events.once("frameended", () => {
            this.setPrivateRaw("isBusy", false);
          });
        }
      }));
    }
    this._disposers.push(thumb.events.on("dblclick", (event) => {
      if (!isLocalEvent(event.originalEvent, this)) {
        return;
      }
      const duration = this.get("animationDuration", 0);
      const easing = this.get("animationEasing");
      this.animate({ key: "start", to: 0, duration, easing });
      this.animate({ key: "end", to: 1, duration, easing });
    }));
    this._disposers.push(startGrip.events.on("pointerdown", () => {
      this.setPrivateRaw("isBusy", true);
      this._startDown = true;
      this._gripDown = "start";
    }));
    this._disposers.push(endGrip.events.on("pointerdown", () => {
      this.setPrivateRaw("isBusy", true);
      this._endDown = true;
      this._gripDown = "end";
    }));
    this._disposers.push(thumb.events.on("pointerdown", () => {
      this.setPrivateRaw("isBusy", true);
      this._thumbDown = true;
      this._gripDown = void 0;
    }));
    this._disposers.push(startGrip.events.on("globalpointerup", () => {
      if (this._startDown) {
        this.setPrivateRaw("isBusy", false);
      }
      this._startDown = false;
    }));
    this._disposers.push(endGrip.events.on("globalpointerup", () => {
      if (this._endDown) {
        this.setPrivateRaw("isBusy", false);
      }
      this._endDown = false;
    }));
    this._disposers.push(thumb.events.on("globalpointerup", () => {
      if (this._thumbDown) {
        this.setPrivateRaw("isBusy", false);
      }
      this._thumbDown = false;
    }));
    this._disposers.push(startGrip.on("x", () => {
      this._updateThumb();
    }));
    this._disposers.push(endGrip.on("x", () => {
      this._updateThumb();
    }));
    this._disposers.push(startGrip.on("y", () => {
      this._updateThumb();
    }));
    this._disposers.push(endGrip.on("y", () => {
      this._updateThumb();
    }));
    this._disposers.push(thumb.events.on("positionchanged", () => {
      this._updateGripsByThumb();
    }));
    if (this.get("orientation") == "vertical") {
      startGrip.set("x", 0);
      endGrip.set("x", 0);
      this._disposers.push(thumb.adapters.add("y", (value) => {
        return Math.max(Math.min(Number(value), this.height() - thumb.height()), 0);
      }));
      this._disposers.push(thumb.adapters.add("x", (_value) => {
        return this.width() / 2;
      }));
      this._disposers.push(startGrip.adapters.add("x", (_value) => {
        return this.width() / 2;
      }));
      this._disposers.push(endGrip.adapters.add("x", (_value) => {
        return this.width() / 2;
      }));
      this._disposers.push(startGrip.adapters.add("y", (value) => {
        return Math.max(Math.min(Number(value), this.height()), 0);
      }));
      this._disposers.push(endGrip.adapters.add("y", (value) => {
        return Math.max(Math.min(Number(value), this.height()), 0);
      }));
    } else {
      startGrip.set("y", 0);
      endGrip.set("y", 0);
      this._disposers.push(thumb.adapters.add("x", (value) => {
        return Math.max(Math.min(Number(value), this.width() - thumb.width()), 0);
      }));
      this._disposers.push(thumb.adapters.add("y", (_value) => {
        return this.height() / 2;
      }));
      this._disposers.push(startGrip.adapters.add("y", (_value) => {
        return this.height() / 2;
      }));
      this._disposers.push(endGrip.adapters.add("y", (_value) => {
        return this.height() / 2;
      }));
      this._disposers.push(startGrip.adapters.add("x", (value) => {
        return Math.max(Math.min(Number(value), this.width()), 0);
      }));
      this._disposers.push(endGrip.adapters.add("x", (value) => {
        return Math.max(Math.min(Number(value), this.width()), 0);
      }));
    }
  }
  _updateChildren() {
    super._updateChildren();
    if (this.isDirty("end") || this.isDirty("start") || this._sizeDirty) {
      this.updateGrips();
    }
  }
  _changed() {
    super._changed();
    if (this.isDirty("start") || this.isDirty("end")) {
      const eventType = "rangechanged";
      if (this.events.isEnabled(eventType)) {
        this.events.dispatch(eventType, { type: eventType, target: this, start: this.get("start", 0), end: this.get("end", 1), grip: this._gripDown });
      }
    }
  }
  /**
   * @ignore
   */
  updateGrips() {
    const startGrip = this.startGrip;
    const endGrip = this.endGrip;
    const orientation = this.get("orientation");
    const height = this.height();
    const width = this.width();
    if (orientation == "vertical") {
      startGrip.set("y", height * this.get("start", 0));
      endGrip.set("y", height * this.get("end", 1));
    } else {
      startGrip.set("x", width * this.get("start", 0));
      endGrip.set("x", width * this.get("end", 1));
    }
    const valueFunction = this.getPrivate("positionTextFunction");
    const from2 = Math.round(this.get("start", 0) * 100);
    const to = Math.round(this.get("end", 0) * 100);
    let fromValue;
    let toValue;
    if (valueFunction) {
      fromValue = valueFunction.call(this, this.get("start", 0));
      toValue = valueFunction.call(this, this.get("end", 0));
    } else {
      fromValue = from2 + "%";
      toValue = to + "%";
    }
    startGrip.set("ariaLabel", this._t("From %1", void 0, fromValue));
    startGrip.set("ariaValueNow", "" + from2);
    startGrip.set("ariaValueText", from2 + "%");
    startGrip.set("ariaValueMin", "0");
    startGrip.set("ariaValueMax", "100");
    endGrip.set("ariaLabel", this._t("To %1", void 0, toValue));
    endGrip.set("ariaValueNow", "" + to);
    endGrip.set("ariaValueText", to + "%");
    endGrip.set("ariaValueMin", "0");
    endGrip.set("ariaValueMax", "100");
  }
  _updateThumb() {
    const thumb = this.thumb;
    const startGrip = this.startGrip;
    const endGrip = this.endGrip;
    const height = this.height();
    const width = this.width();
    let x0 = startGrip.x();
    let x1 = endGrip.x();
    let y0 = startGrip.y();
    let y1 = endGrip.y();
    let start = 0;
    let end = 1;
    if (this.get("orientation") == "vertical") {
      if (isNumber(y0) && isNumber(y1)) {
        if (!this._thumbBusy && !thumb.isDragging()) {
          thumb.set("height", y1 - y0);
          thumb.set("y", y0);
        }
        start = y0 / height;
        end = y1 / height;
      }
    } else {
      if (isNumber(x0) && isNumber(x1)) {
        if (!this._thumbBusy && !thumb.isDragging()) {
          thumb.set("width", x1 - x0);
          thumb.set("x", x0);
        }
        start = x0 / width;
        end = x1 / width;
      }
    }
    if (this.getPrivate("isBusy") && (this.get("start") != start || this.get("end") != end)) {
      this.set("start", start);
      this.set("end", end);
    }
    const valueFunction = this.getPrivate("positionTextFunction");
    const from2 = Math.round(this.get("start", 0) * 100);
    const to = Math.round(this.get("end", 0) * 100);
    let fromValue;
    let toValue;
    if (valueFunction) {
      fromValue = valueFunction.call(this, this.get("start", 0));
      toValue = valueFunction.call(this, this.get("end", 0));
    } else {
      fromValue = from2 + "%";
      toValue = to + "%";
    }
    thumb.set("ariaLabel", this._t("From %1 to %2", void 0, fromValue, toValue));
    thumb.set("ariaValueNow", "" + from2);
    thumb.set("ariaValueText", from2 + "%");
  }
  _updateGripsByThumb() {
    const thumb = this.thumb;
    const startGrip = this.startGrip;
    const endGrip = this.endGrip;
    if (this.get("orientation") == "vertical") {
      const thumbSize = thumb.height();
      startGrip.set("y", thumb.y());
      endGrip.set("y", thumb.y() + thumbSize);
    } else {
      const thumbSize = thumb.width();
      startGrip.set("x", thumb.x());
      endGrip.set("x", thumb.x() + thumbSize);
    }
  }
};
Object.defineProperty(Scrollbar, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Scrollbar"
});
Object.defineProperty(Scrollbar, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Scrollbar.className])
});

// ../../node_modules/d3-shape/src/constant.js
function constant_default(x2) {
  return function constant() {
    return x2;
  };
}

// ../../node_modules/d3-shape/src/math.js
var abs2 = Math.abs;
var atan2 = Math.atan2;
var cos2 = Math.cos;
var max = Math.max;
var min = Math.min;
var sin2 = Math.sin;
var sqrt = Math.sqrt;
var epsilon = 1e-12;
var pi = Math.PI;
var halfPi = pi / 2;
var tau2 = 2 * pi;
function acos(x2) {
  return x2 > 1 ? 0 : x2 < -1 ? pi : Math.acos(x2);
}
function asin(x2) {
  return x2 >= 1 ? halfPi : x2 <= -1 ? -halfPi : Math.asin(x2);
}

// ../../node_modules/d3-path/src/path.js
var pi2 = Math.PI;
var tau3 = 2 * pi2;
var epsilon2 = 1e-6;
var tauEpsilon = tau3 - epsilon2;
function append2(strings) {
  this._ += strings[0];
  for (let i = 1, n = strings.length; i < n; ++i) {
    this._ += arguments[i] + strings[i];
  }
}
function appendRound(digits) {
  let d = Math.floor(digits);
  if (!(d >= 0))
    throw new Error(`invalid digits: ${digits}`);
  if (d > 15)
    return append2;
  const k = __pow(10, d);
  return function(strings) {
    this._ += strings[0];
    for (let i = 1, n = strings.length; i < n; ++i) {
      this._ += Math.round(arguments[i] * k) / k + strings[i];
    }
  };
}
var Path = class {
  constructor(digits) {
    this._x0 = this._y0 = // start of current subpath
    this._x1 = this._y1 = null;
    this._ = "";
    this._append = digits == null ? append2 : appendRound(digits);
  }
  moveTo(x2, y2) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}`;
  }
  closePath() {
    if (this._x1 !== null) {
      this._x1 = this._x0, this._y1 = this._y0;
      this._append`Z`;
    }
  }
  lineTo(x2, y2) {
    this._append`L${this._x1 = +x2},${this._y1 = +y2}`;
  }
  quadraticCurveTo(x1, y1, x2, y2) {
    this._append`Q${+x1},${+y1},${this._x1 = +x2},${this._y1 = +y2}`;
  }
  bezierCurveTo(x1, y1, x2, y2, x3, y3) {
    this._append`C${+x1},${+y1},${+x2},${+y2},${this._x1 = +x3},${this._y1 = +y3}`;
  }
  arcTo(x1, y1, x2, y2, r) {
    x1 = +x1, y1 = +y1, x2 = +x2, y2 = +y2, r = +r;
    if (r < 0)
      throw new Error(`negative radius: ${r}`);
    let x0 = this._x1, y0 = this._y1, x21 = x2 - x1, y21 = y2 - y1, x01 = x0 - x1, y01 = y0 - y1, l01_2 = x01 * x01 + y01 * y01;
    if (this._x1 === null) {
      this._append`M${this._x1 = x1},${this._y1 = y1}`;
    } else if (!(l01_2 > epsilon2))
      ;
    else if (!(Math.abs(y01 * x21 - y21 * x01) > epsilon2) || !r) {
      this._append`L${this._x1 = x1},${this._y1 = y1}`;
    } else {
      let x20 = x2 - x0, y20 = y2 - y0, l21_2 = x21 * x21 + y21 * y21, l20_2 = x20 * x20 + y20 * y20, l21 = Math.sqrt(l21_2), l01 = Math.sqrt(l01_2), l = r * Math.tan((pi2 - Math.acos((l21_2 + l01_2 - l20_2) / (2 * l21 * l01))) / 2), t01 = l / l01, t21 = l / l21;
      if (Math.abs(t01 - 1) > epsilon2) {
        this._append`L${x1 + t01 * x01},${y1 + t01 * y01}`;
      }
      this._append`A${r},${r},0,0,${+(y01 * x20 > x01 * y20)},${this._x1 = x1 + t21 * x21},${this._y1 = y1 + t21 * y21}`;
    }
  }
  arc(x2, y2, r, a0, a1, ccw) {
    x2 = +x2, y2 = +y2, r = +r, ccw = !!ccw;
    if (r < 0)
      throw new Error(`negative radius: ${r}`);
    let dx = r * Math.cos(a0), dy = r * Math.sin(a0), x0 = x2 + dx, y0 = y2 + dy, cw = 1 ^ ccw, da = ccw ? a0 - a1 : a1 - a0;
    if (this._x1 === null) {
      this._append`M${x0},${y0}`;
    } else if (Math.abs(this._x1 - x0) > epsilon2 || Math.abs(this._y1 - y0) > epsilon2) {
      this._append`L${x0},${y0}`;
    }
    if (!r)
      return;
    if (da < 0)
      da = da % tau3 + tau3;
    if (da > tauEpsilon) {
      this._append`A${r},${r},0,1,${cw},${x2 - dx},${y2 - dy}A${r},${r},0,1,${cw},${this._x1 = x0},${this._y1 = y0}`;
    } else if (da > epsilon2) {
      this._append`A${r},${r},0,${+(da >= pi2)},${cw},${this._x1 = x2 + r * Math.cos(a1)},${this._y1 = y2 + r * Math.sin(a1)}`;
    }
  }
  rect(x2, y2, w, h) {
    this._append`M${this._x0 = this._x1 = +x2},${this._y0 = this._y1 = +y2}h${w = +w}v${+h}h${-w}Z`;
  }
  toString() {
    return this._;
  }
};
function path() {
  return new Path();
}
path.prototype = Path.prototype;

// ../../node_modules/d3-shape/src/path.js
function withPath(shape) {
  let digits = 3;
  shape.digits = function(_) {
    if (!arguments.length)
      return digits;
    if (_ == null) {
      digits = null;
    } else {
      const d = Math.floor(_);
      if (!(d >= 0))
        throw new RangeError(`invalid digits: ${_}`);
      digits = d;
    }
    return shape;
  };
  return () => new Path(digits);
}

// ../../node_modules/d3-shape/src/arc.js
function arcInnerRadius(d) {
  return d.innerRadius;
}
function arcOuterRadius(d) {
  return d.outerRadius;
}
function arcStartAngle(d) {
  return d.startAngle;
}
function arcEndAngle(d) {
  return d.endAngle;
}
function arcPadAngle(d) {
  return d && d.padAngle;
}
function intersect(x0, y0, x1, y1, x2, y2, x3, y3) {
  var x10 = x1 - x0, y10 = y1 - y0, x32 = x3 - x2, y32 = y3 - y2, t = y32 * x10 - x32 * y10;
  if (t * t < epsilon)
    return;
  t = (x32 * (y0 - y2) - y32 * (x0 - x2)) / t;
  return [x0 + t * x10, y0 + t * y10];
}
function cornerTangents(x0, y0, x1, y1, r1, rc, cw) {
  var x01 = x0 - x1, y01 = y0 - y1, lo = (cw ? rc : -rc) / sqrt(x01 * x01 + y01 * y01), ox = lo * y01, oy = -lo * x01, x11 = x0 + ox, y11 = y0 + oy, x10 = x1 + ox, y10 = y1 + oy, x00 = (x11 + x10) / 2, y00 = (y11 + y10) / 2, dx = x10 - x11, dy = y10 - y11, d2 = dx * dx + dy * dy, r = r1 - rc, D = x11 * y10 - x10 * y11, d = (dy < 0 ? -1 : 1) * sqrt(max(0, r * r * d2 - D * D)), cx0 = (D * dy - dx * d) / d2, cy0 = (-D * dx - dy * d) / d2, cx1 = (D * dy + dx * d) / d2, cy1 = (-D * dx + dy * d) / d2, dx0 = cx0 - x00, dy0 = cy0 - y00, dx1 = cx1 - x00, dy1 = cy1 - y00;
  if (dx0 * dx0 + dy0 * dy0 > dx1 * dx1 + dy1 * dy1)
    cx0 = cx1, cy0 = cy1;
  return {
    cx: cx0,
    cy: cy0,
    x01: -ox,
    y01: -oy,
    x11: cx0 * (r1 / r - 1),
    y11: cy0 * (r1 / r - 1)
  };
}
function arc_default() {
  var innerRadius = arcInnerRadius, outerRadius = arcOuterRadius, cornerRadius = constant_default(0), padRadius = null, startAngle = arcStartAngle, endAngle = arcEndAngle, padAngle = arcPadAngle, context = null, path2 = withPath(arc);
  function arc() {
    var buffer, r, r0 = +innerRadius.apply(this, arguments), r1 = +outerRadius.apply(this, arguments), a0 = startAngle.apply(this, arguments) - halfPi, a1 = endAngle.apply(this, arguments) - halfPi, da = abs2(a1 - a0), cw = a1 > a0;
    if (!context)
      context = buffer = path2();
    if (r1 < r0)
      r = r1, r1 = r0, r0 = r;
    if (!(r1 > epsilon))
      context.moveTo(0, 0);
    else if (da > tau2 - epsilon) {
      context.moveTo(r1 * cos2(a0), r1 * sin2(a0));
      context.arc(0, 0, r1, a0, a1, !cw);
      if (r0 > epsilon) {
        context.moveTo(r0 * cos2(a1), r0 * sin2(a1));
        context.arc(0, 0, r0, a1, a0, cw);
      }
    } else {
      var a01 = a0, a11 = a1, a00 = a0, a10 = a1, da0 = da, da1 = da, ap = padAngle.apply(this, arguments) / 2, rp = ap > epsilon && (padRadius ? +padRadius.apply(this, arguments) : sqrt(r0 * r0 + r1 * r1)), rc = min(abs2(r1 - r0) / 2, +cornerRadius.apply(this, arguments)), rc0 = rc, rc1 = rc, t0, t1;
      if (rp > epsilon) {
        var p02 = asin(rp / r0 * sin2(ap)), p1 = asin(rp / r1 * sin2(ap));
        if ((da0 -= p02 * 2) > epsilon)
          p02 *= cw ? 1 : -1, a00 += p02, a10 -= p02;
        else
          da0 = 0, a00 = a10 = (a0 + a1) / 2;
        if ((da1 -= p1 * 2) > epsilon)
          p1 *= cw ? 1 : -1, a01 += p1, a11 -= p1;
        else
          da1 = 0, a01 = a11 = (a0 + a1) / 2;
      }
      var x01 = r1 * cos2(a01), y01 = r1 * sin2(a01), x10 = r0 * cos2(a10), y10 = r0 * sin2(a10);
      if (rc > epsilon) {
        var x11 = r1 * cos2(a11), y11 = r1 * sin2(a11), x00 = r0 * cos2(a00), y00 = r0 * sin2(a00), oc;
        if (da < pi) {
          if (oc = intersect(x01, y01, x00, y00, x11, y11, x10, y10)) {
            var ax = x01 - oc[0], ay = y01 - oc[1], bx = x11 - oc[0], by = y11 - oc[1], kc = 1 / sin2(acos((ax * bx + ay * by) / (sqrt(ax * ax + ay * ay) * sqrt(bx * bx + by * by))) / 2), lc = sqrt(oc[0] * oc[0] + oc[1] * oc[1]);
            rc0 = min(rc, (r0 - lc) / (kc - 1));
            rc1 = min(rc, (r1 - lc) / (kc + 1));
          } else {
            rc0 = rc1 = 0;
          }
        }
      }
      if (!(da1 > epsilon))
        context.moveTo(x01, y01);
      else if (rc1 > epsilon) {
        t0 = cornerTangents(x00, y00, x01, y01, r1, rc1, cw);
        t1 = cornerTangents(x11, y11, x10, y10, r1, rc1, cw);
        context.moveTo(t0.cx + t0.x01, t0.cy + t0.y01);
        if (rc1 < rc)
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
        else {
          context.arc(t0.cx, t0.cy, rc1, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r1, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), !cw);
          context.arc(t1.cx, t1.cy, rc1, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      } else
        context.moveTo(x01, y01), context.arc(0, 0, r1, a01, a11, !cw);
      if (!(r0 > epsilon) || !(da0 > epsilon))
        context.lineTo(x10, y10);
      else if (rc0 > epsilon) {
        t0 = cornerTangents(x10, y10, x11, y11, r0, -rc0, cw);
        t1 = cornerTangents(x01, y01, x00, y00, r0, -rc0, cw);
        context.lineTo(t0.cx + t0.x01, t0.cy + t0.y01);
        if (rc0 < rc)
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t1.y01, t1.x01), !cw);
        else {
          context.arc(t0.cx, t0.cy, rc0, atan2(t0.y01, t0.x01), atan2(t0.y11, t0.x11), !cw);
          context.arc(0, 0, r0, atan2(t0.cy + t0.y11, t0.cx + t0.x11), atan2(t1.cy + t1.y11, t1.cx + t1.x11), cw);
          context.arc(t1.cx, t1.cy, rc0, atan2(t1.y11, t1.x11), atan2(t1.y01, t1.x01), !cw);
        }
      } else
        context.arc(0, 0, r0, a10, a00, cw);
    }
    context.closePath();
    if (buffer)
      return context = null, buffer + "" || null;
  }
  arc.centroid = function() {
    var r = (+innerRadius.apply(this, arguments) + +outerRadius.apply(this, arguments)) / 2, a = (+startAngle.apply(this, arguments) + +endAngle.apply(this, arguments)) / 2 - pi / 2;
    return [cos2(a) * r, sin2(a) * r];
  };
  arc.innerRadius = function(_) {
    return arguments.length ? (innerRadius = typeof _ === "function" ? _ : constant_default(+_), arc) : innerRadius;
  };
  arc.outerRadius = function(_) {
    return arguments.length ? (outerRadius = typeof _ === "function" ? _ : constant_default(+_), arc) : outerRadius;
  };
  arc.cornerRadius = function(_) {
    return arguments.length ? (cornerRadius = typeof _ === "function" ? _ : constant_default(+_), arc) : cornerRadius;
  };
  arc.padRadius = function(_) {
    return arguments.length ? (padRadius = _ == null ? null : typeof _ === "function" ? _ : constant_default(+_), arc) : padRadius;
  };
  arc.startAngle = function(_) {
    return arguments.length ? (startAngle = typeof _ === "function" ? _ : constant_default(+_), arc) : startAngle;
  };
  arc.endAngle = function(_) {
    return arguments.length ? (endAngle = typeof _ === "function" ? _ : constant_default(+_), arc) : endAngle;
  };
  arc.padAngle = function(_) {
    return arguments.length ? (padAngle = typeof _ === "function" ? _ : constant_default(+_), arc) : padAngle;
  };
  arc.context = function(_) {
    return arguments.length ? (context = _ == null ? null : _, arc) : context;
  };
  return arc;
}

// ../../node_modules/d3-shape/src/array.js
var slice2 = Array.prototype.slice;
function array_default(x2) {
  return typeof x2 === "object" && "length" in x2 ? x2 : Array.from(x2);
}

// ../../node_modules/d3-shape/src/curve/linear.js
function Linear(context) {
  this._context = context;
}
Linear.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._point = 0;
  },
  lineEnd: function() {
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      default:
        this._context.lineTo(x2, y2);
        break;
    }
  }
};
function linear_default(context) {
  return new Linear(context);
}

// ../../node_modules/d3-shape/src/point.js
function x(p) {
  return p[0];
}
function y(p) {
  return p[1];
}

// ../../node_modules/d3-shape/src/line.js
function line_default(x2, y2) {
  var defined = constant_default(true), context = null, curve = linear_default, output = null, path2 = withPath(line3);
  x2 = typeof x2 === "function" ? x2 : x2 === void 0 ? x : constant_default(x2);
  y2 = typeof y2 === "function" ? y2 : y2 === void 0 ? y : constant_default(y2);
  function line3(data) {
    var i, n = (data = array_default(data)).length, d, defined0 = false, buffer;
    if (context == null)
      output = curve(buffer = path2());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0)
          output.lineStart();
        else
          output.lineEnd();
      }
      if (defined0)
        output.point(+x2(d, i, data), +y2(d, i, data));
    }
    if (buffer)
      return output = null, buffer + "" || null;
  }
  line3.x = function(_) {
    return arguments.length ? (x2 = typeof _ === "function" ? _ : constant_default(+_), line3) : x2;
  };
  line3.y = function(_) {
    return arguments.length ? (y2 = typeof _ === "function" ? _ : constant_default(+_), line3) : y2;
  };
  line3.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant_default(!!_), line3) : defined;
  };
  line3.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), line3) : curve;
  };
  line3.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), line3) : context;
  };
  return line3;
}

// ../../node_modules/d3-shape/src/area.js
function area_default(x0, y0, y1) {
  var x1 = null, defined = constant_default(true), context = null, curve = linear_default, output = null, path2 = withPath(area);
  x0 = typeof x0 === "function" ? x0 : x0 === void 0 ? x : constant_default(+x0);
  y0 = typeof y0 === "function" ? y0 : y0 === void 0 ? constant_default(0) : constant_default(+y0);
  y1 = typeof y1 === "function" ? y1 : y1 === void 0 ? y : constant_default(+y1);
  function area(data) {
    var i, j, k, n = (data = array_default(data)).length, d, defined0 = false, buffer, x0z = new Array(n), y0z = new Array(n);
    if (context == null)
      output = curve(buffer = path2());
    for (i = 0; i <= n; ++i) {
      if (!(i < n && defined(d = data[i], i, data)) === defined0) {
        if (defined0 = !defined0) {
          j = i;
          output.areaStart();
          output.lineStart();
        } else {
          output.lineEnd();
          output.lineStart();
          for (k = i - 1; k >= j; --k) {
            output.point(x0z[k], y0z[k]);
          }
          output.lineEnd();
          output.areaEnd();
        }
      }
      if (defined0) {
        x0z[i] = +x0(d, i, data), y0z[i] = +y0(d, i, data);
        output.point(x1 ? +x1(d, i, data) : x0z[i], y1 ? +y1(d, i, data) : y0z[i]);
      }
    }
    if (buffer)
      return output = null, buffer + "" || null;
  }
  function arealine() {
    return line_default().defined(defined).curve(curve).context(context);
  }
  area.x = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant_default(+_), x1 = null, area) : x0;
  };
  area.x0 = function(_) {
    return arguments.length ? (x0 = typeof _ === "function" ? _ : constant_default(+_), area) : x0;
  };
  area.x1 = function(_) {
    return arguments.length ? (x1 = _ == null ? null : typeof _ === "function" ? _ : constant_default(+_), area) : x1;
  };
  area.y = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant_default(+_), y1 = null, area) : y0;
  };
  area.y0 = function(_) {
    return arguments.length ? (y0 = typeof _ === "function" ? _ : constant_default(+_), area) : y0;
  };
  area.y1 = function(_) {
    return arguments.length ? (y1 = _ == null ? null : typeof _ === "function" ? _ : constant_default(+_), area) : y1;
  };
  area.lineX0 = area.lineY0 = function() {
    return arealine().x(x0).y(y0);
  };
  area.lineY1 = function() {
    return arealine().x(x0).y(y1);
  };
  area.lineX1 = function() {
    return arealine().x(x1).y(y0);
  };
  area.defined = function(_) {
    return arguments.length ? (defined = typeof _ === "function" ? _ : constant_default(!!_), area) : defined;
  };
  area.curve = function(_) {
    return arguments.length ? (curve = _, context != null && (output = curve(context)), area) : curve;
  };
  area.context = function(_) {
    return arguments.length ? (_ == null ? context = output = null : output = curve(context = _), area) : context;
  };
  return area;
}

// ../../node_modules/d3-shape/src/curve/step.js
function Step(context, t) {
  this._context = context;
  this._t = t;
}
Step.prototype = {
  areaStart: function() {
    this._line = 0;
  },
  areaEnd: function() {
    this._line = NaN;
  },
  lineStart: function() {
    this._x = this._y = NaN;
    this._point = 0;
  },
  lineEnd: function() {
    if (0 < this._t && this._t < 1 && this._point === 2)
      this._context.lineTo(this._x, this._y);
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    if (this._line >= 0)
      this._t = 1 - this._t, this._line = 1 - this._line;
  },
  point: function(x2, y2) {
    x2 = +x2, y2 = +y2;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
      default: {
        if (this._t <= 0) {
          this._context.lineTo(this._x, y2);
          this._context.lineTo(x2, y2);
        } else {
          var x1 = this._x * (1 - this._t) + x2 * this._t;
          this._context.lineTo(x1, this._y);
          this._context.lineTo(x1, y2);
        }
        break;
      }
    }
    this._x = x2, this._y = y2;
  }
};
function stepAfter(context) {
  return new Step(context, 1);
}

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Slice.js
var Slice = class extends Graphics {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "ix", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "iy", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_generator", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: arc_default()
    });
  }
  _getTooltipPoint() {
    let tooltipX = this.get("tooltipX");
    let tooltipY = this.get("tooltipY");
    let x2 = 0;
    let y2 = 0;
    if (isNumber(tooltipX)) {
      x2 = tooltipX;
    }
    if (isNumber(tooltipY)) {
      y2 = tooltipY;
    }
    let radius = this.get("radius", 0);
    let innerRadius = this.get("innerRadius", 0);
    let dRadius = this.get("dRadius", 0);
    let dInnerRadius = this.get("dInnerRadius", 0);
    radius += dRadius;
    innerRadius += dInnerRadius;
    if (innerRadius < 0) {
      innerRadius = radius + innerRadius;
    }
    if (tooltipX instanceof Percent) {
      x2 = this.ix * (innerRadius + (radius - innerRadius) * tooltipX.value);
    }
    if (tooltipY instanceof Percent) {
      y2 = this.iy * (innerRadius + (radius - innerRadius) * tooltipY.value);
    }
    if (this.get("arc") >= 360 && innerRadius == 0) {
      x2 = 0;
      y2 = 0;
    }
    return { x: x2, y: y2 };
  }
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("radius") || this.isDirty("arc") || this.isDirty("innerRadius") || this.isDirty("startAngle") || this.isDirty("dRadius") || this.isDirty("dInnerRadius") || this.isDirty("cornerRadius") || this.isDirty("shiftRadius")) {
      this._clear = true;
    }
  }
  _changed() {
    super._changed();
    if (this._clear) {
      let startAngle = this.get("startAngle", 0);
      let arc = this.get("arc", 0);
      const generator = this._generator;
      if (arc < 0) {
        startAngle = startAngle + arc;
        arc = arc * -1;
      }
      if (arc > 0.1) {
        generator.cornerRadius(this.get("cornerRadius", 0));
      }
      generator.context(this._display);
      let radius = this.get("radius", 0);
      let innerRadius = this.get("innerRadius", 0);
      let dRadius = this.get("dRadius", 0);
      let dInnerRadius = this.get("dInnerRadius", 0);
      radius += dRadius;
      innerRadius += dInnerRadius;
      if (innerRadius < 0) {
        innerRadius = radius + innerRadius;
      }
      generator({ innerRadius, outerRadius: radius, startAngle: (startAngle + 90) * RADIANS, endAngle: (startAngle + arc + 90) * RADIANS });
      let middleAngle = startAngle + arc / 2;
      this.ix = cos(middleAngle);
      this.iy = sin(middleAngle);
      const shiftRadius = this.get("shiftRadius", 0);
      this.setRaw("dx", this.ix * shiftRadius);
      this.setRaw("dy", this.iy * shiftRadius);
      this.markDirtyPosition();
    }
  }
};
Object.defineProperty(Slice, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Slice"
});
Object.defineProperty(Slice, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Graphics.classNames.concat([Slice.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Chart.js
var Chart = class extends Container {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "chartContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Container.new(this._root, { width: p100, height: p100, interactiveChildren: false }))
    });
    Object.defineProperty(this, "bulletsContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Container.new(this._root, { interactiveChildren: false, isMeasured: false, position: "absolute", width: p100, height: p100 })
    });
  }
};
Object.defineProperty(Chart, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Chart"
});
Object.defineProperty(Chart, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([Chart.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/SerialChart.js
var SerialChart = class extends Chart {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "seriesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Container.new(this._root, { width: p100, height: p100, isMeasured: false })
    });
    Object.defineProperty(this, "series", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListAutoDispose()
    });
  }
  _afterNew() {
    super._afterNew();
    this._disposers.push(this.series);
    const children = this.seriesContainer.children;
    this._disposers.push(this.series.events.onAll((change) => {
      if (change.type === "clear") {
        each(change.oldValues, (series) => {
          this._removeSeries(series);
        });
        const colors = this.get("colors");
        if (colors) {
          colors.reset();
        }
      } else if (change.type === "push") {
        children.moveValue(change.newValue);
        this._processSeries(change.newValue);
      } else if (change.type === "setIndex") {
        children.setIndex(change.index, change.newValue);
        this._processSeries(change.newValue);
      } else if (change.type === "insertIndex") {
        children.insertIndex(change.index, change.newValue);
        this._processSeries(change.newValue);
      } else if (change.type === "removeIndex") {
        this._removeSeries(change.oldValue);
      } else if (change.type === "moveIndex") {
        children.moveValue(change.value, change.newIndex);
        this._processSeries(change.value);
      } else {
        throw new Error("Unknown IListEvent type");
      }
    }));
  }
  _processSeries(series) {
    series.chart = this;
    series._placeBulletsContainer(this);
  }
  _removeSeries(series) {
    if (!series.isDisposed()) {
      this.seriesContainer.children.removeValue(series);
      series._removeBulletsContainer();
    }
  }
};
Object.defineProperty(SerialChart, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "SerialChart"
});
Object.defineProperty(SerialChart, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Chart.classNames.concat([SerialChart.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/Tick.js
var Tick = class extends Line {
};
Object.defineProperty(Tick, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Tick"
});
Object.defineProperty(Tick, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Line.classNames.concat([Tick.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/util/ColorSet.js
var ColorSet = class extends Entity2 {
  //protected _currentPass: number = 0;
  _afterNew() {
    super._afterNewApplyThemes();
    this._dirty["colors"] = false;
  }
  _beforeChanged() {
    if (this.isDirty("colors")) {
      this.reset();
    }
  }
  /**
   * @ignore
   */
  generateColors() {
    this.setPrivate("currentPass", this.getPrivate("currentPass", 0) + 1);
    const pass = this.getPrivate("currentPass");
    const colors = this.get("colors", [this.get("baseColor", Color.fromHex(16711680))]);
    if (!this.getPrivate("numColors")) {
      this.setPrivate("numColors", colors.length);
    }
    const len = this.getPrivate("numColors");
    const start = 0;
    const passOptions = this.get("passOptions");
    const reuse = this.get("reuse");
    for (let i = start; i < len; i++) {
      if (reuse) {
        colors.push(colors[i]);
      } else {
        const hsl = colors[i].toHSL();
        let h = hsl.h + (passOptions.hue || 0) * pass;
        while (h > 1)
          h -= 1;
        let s2 = hsl.s + (passOptions.saturation || 0) * pass;
        if (s2 > 1)
          s2 = 1;
        if (s2 < 0)
          s2 = 0;
        let l = hsl.l + (passOptions.lightness || 0) * pass;
        while (l > 1)
          l -= 1;
        colors.push(Color.fromHSL(h, s2, l));
      }
    }
  }
  /**
   * Returns a [[Color]] at specific index.
   *
   * If there's no color at this index, a new color is generated.
   *
   * @param   index  Index
   * @return         Color
   */
  getIndex(index2) {
    const colors = this.get("colors", []);
    const saturation = this.get("saturation");
    if (index2 >= colors.length) {
      this.generateColors();
      return this.getIndex(index2);
    }
    return saturation != null ? Color.saturate(colors[index2], saturation) : colors[index2];
  }
  /**
   * Returns next [[Color]] in the list.
   *
   * If the list is out of colors, new ones are generated dynamically.
   */
  next() {
    let currentStep = this.getPrivate("currentStep", this.get("startIndex", 0));
    this.setPrivate("currentStep", currentStep + this.get("step", 1));
    return this.getIndex(currentStep);
  }
  /**
   * Resets counter to the start of the list, so the next call for `next()` will
   * return the first color.
   */
  reset() {
    this.setPrivate("currentStep", this.get("startIndex", 0));
    this.setPrivate("currentPass", 0);
  }
};
Object.defineProperty(ColorSet, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "ColorSet"
});
Object.defineProperty(ColorSet, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Entity2.classNames.concat([ColorSet.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/XYChartDefaultTheme.js
var XYChartDefaultTheme = class extends Theme2 {
  setupDefaultRules() {
    super.setupDefaultRules();
    const ic = this._root.interfaceColors;
    const language = this._root.language;
    const r = this.rule.bind(this);
    r("XYChart").setAll({
      colors: ColorSet.new(this._root, {}),
      paddingLeft: 20,
      paddingRight: 20,
      paddingTop: 16,
      paddingBottom: 16,
      panX: false,
      panY: false,
      wheelStep: 0.25,
      arrangeTooltips: true,
      pinchZoomX: false,
      pinchZoomY: false
    });
    r("XYSeries").setAll({
      legendLabelText: "{name}"
    });
    r("XYChart", ["scrollbar", "chart"]).setAll({
      paddingBottom: 0,
      paddingLeft: 0,
      paddingTop: 0,
      paddingRight: 0,
      colors: ColorSet.new(this._root, {
        saturation: 0
      })
    });
    {
      const rule = r("Graphics", ["scrollbar", "overlay"]);
      rule.setAll({
        fillOpacity: 0.5
      });
      setColor(rule, "fill", ic, "background");
    }
    r("RoundedRectangle", ["xy", "scrollbar", "thumb"]).setAll({
      cornerRadiusTR: 0,
      cornerRadiusTL: 0,
      cornerRadiusBR: 0,
      cornerRadiusBL: 0,
      fillOpacity: 0,
      focusable: true
    });
    r("RoundedRectangle", ["xy", "scrollbar", "thumb"]).states.create("hover", { fillOpacity: 0.4 });
    r("RoundedRectangle", ["xy", "scrollbar", "chart", "background"]).setAll({
      cornerRadiusTL: 0,
      cornerRadiusBL: 0,
      cornerRadiusTR: 0,
      cornerRadiusBR: 0
    });
    r("RoundedRectangle", ["xy", "scrollbar", "chart", "background", "resize", "button"]).setAll({
      cornerRadiusBL: 40,
      cornerRadiusBR: 40,
      cornerRadiusTL: 40,
      cornerRadiusTR: 40
    });
    r("AxisRendererX", ["xy", "chart", "scrollbar"]).setAll({
      strokeOpacity: 0,
      inside: true
    });
    r("AxisRendererY", ["xy", "chart", "scrollbar"]).setAll({
      strokeOpacity: 0,
      inside: true,
      minGridDistance: 5
    });
    r("AxisLabel", ["xy", "scrollbar", "x"]).setAll({
      opacity: 0.5,
      centerY: p100,
      minPosition: 0.01,
      maxPosition: 0.99,
      fontSize: "0.8em"
    });
    r("AxisLabel", ["category"]).setAll({
      text: "{category}",
      populateText: true
    });
    r("AxisLabel", ["x"]).setAll({
      centerY: 0
    });
    r("AxisLabel", ["x", "inside"]).setAll({
      centerY: p100
    });
    r("AxisLabel", ["x", "inside", "opposite"]).setAll({
      centerY: 0
    });
    r("AxisLabel", ["x", "opposite"]).setAll({
      centerY: p100
    });
    r("AxisLabel", ["y"]).setAll({
      centerX: p100
    });
    r("AxisLabel", ["y", "inside"]).setAll({
      centerX: 0
    });
    r("AxisLabel", ["y", "inside", "opposite"]).setAll({
      centerX: p100
    });
    r("AxisLabel", ["y", "opposite"]).setAll({
      centerX: 0
    });
    r("AxisLabel", ["minor"]).setAll({
      fontSize: "0.6em"
    });
    r("AxisLabel", ["xy", "scrollbar", "y"]).setAll({
      visible: false
    });
    r("Grid", ["xy", "scrollbar", "y"]).setAll({
      visible: false
    });
    r("Grid", ["xy", "scrollbar", "x"]).setAll({
      opacity: 0.5
    });
    r("XYCursor").setAll({
      behavior: "none",
      layer: 30,
      exportable: false,
      snapToSeriesBy: "xy",
      moveThreshold: 1
    });
    {
      const rule = r("Grid", ["cursor", "x"]);
      rule.setAll({
        strokeOpacity: 0.8,
        strokeDasharray: [2, 2],
        ariaLabel: language.translate("Use left and right arrows to move selection")
      });
      setColor(rule, "stroke", ic, "alternativeBackground");
    }
    {
      const rule = r("Grid", ["cursor", "y"]);
      rule.setAll({
        strokeOpacity: 0.8,
        strokeDasharray: [2, 2],
        ariaLabel: language.translate("Use up and down arrows to move selection")
      });
      setColor(rule, "stroke", ic, "alternativeBackground");
    }
    {
      const rule = r("Graphics", ["cursor", "selection"]);
      rule.setAll({
        fillOpacity: 0.15
      });
      setColor(rule, "fill", ic, "alternativeBackground");
    }
    r("Axis").setAll({
      start: 0,
      end: 1,
      minZoomCount: 1,
      maxZoomCount: Infinity,
      maxZoomFactor: 1e3,
      maxDeviation: 0.1,
      snapTooltip: true,
      tooltipLocation: 0.5,
      panX: true,
      panY: true,
      zoomX: true,
      zoomY: true,
      fixAxisSize: true
    });
    r("AxisLabel").setAll({
      location: 0.5,
      multiLocation: 0,
      centerX: p50,
      centerY: p50,
      paddingTop: 3,
      paddingBottom: 3,
      paddingLeft: 5,
      paddingRight: 5
    });
    r("Container", ["axis", "header"]).setAll({
      layer: 30
    });
    r("Rectangle", ["axis", "header", "background"]).setAll({
      crisp: true
    });
    {
      const rule = r("AxisRenderer");
      rule.setAll({
        crisp: true,
        strokeOpacity: 0
      });
      setColor(rule, "stroke", ic, "grid");
    }
    r("AxisRendererX").setAll({
      minGridDistance: 120,
      opposite: false,
      inversed: false,
      cellStartLocation: 0,
      cellEndLocation: 1,
      width: p100
    });
    r("AxisRendererY").setAll({
      minGridDistance: 40,
      opposite: false,
      inversed: false,
      cellStartLocation: 0,
      cellEndLocation: 1,
      height: p100
    });
    {
      const rule = r("Rectangle", ["axis", "thumb"]);
      rule.setAll({
        fillOpacity: 0
      });
      setColor(rule, "fill", ic, "alternativeBackground");
      rule.states.create("hover", { fillOpacity: 0.1 });
    }
    r("Rectangle", ["axis", "thumb", "x"]).setAll({
      cursorOverStyle: "ew-resize"
    });
    r("Rectangle", ["axis", "thumb", "y"]).setAll({
      cursorOverStyle: "ns-resize"
    });
    {
      const rule = r("Grid");
      rule.setAll({
        location: 0,
        strokeOpacity: 0.15,
        crisp: true
      });
      setColor(rule, "stroke", ic, "grid");
    }
    {
      const rule = r("Grid", ["minor"]);
      rule.setAll({
        location: 0,
        strokeOpacity: 0.07,
        crisp: true
      });
      setColor(rule, "stroke", ic, "grid");
    }
    r("Grid", ["base"]).setAll({
      strokeOpacity: 0.3
    });
    {
      const rule = r("Graphics", ["axis", "fill"]);
      rule.setAll({
        visible: false,
        isMeasured: false,
        position: "absolute",
        fillOpacity: 0.05
      });
      setColor(rule, "fill", ic, "alternativeBackground");
    }
    r("Graphics", ["axis", "fill", "range"]).setAll({
      isMeasured: true
    });
    r("Graphics", ["series", "fill", "range"]).setAll({
      visible: false,
      isMeasured: true
    });
    r("Grid", ["series", "range"]).setAll({
      visible: false
    });
    r("AxisTick", ["series", "range"]).setAll({
      visible: false
    });
    r("AxisLabel", ["series", "range"]).setAll({
      visible: false
    });
    {
      const rule = r("AxisTick");
      rule.setAll({
        location: 0.5,
        multiLocation: 0,
        strokeOpacity: 1,
        isMeasured: false,
        position: "absolute",
        visible: false
      });
      setColor(rule, "stroke", ic, "grid");
    }
    r("CategoryAxis").setAll({
      startLocation: 0,
      endLocation: 1,
      fillRule: (dataItem, index2) => {
        const axisFill = dataItem.get("axisFill");
        if (axisFill) {
          if (!isNumber(index2) || index2 % 2 == 0) {
            axisFill.setPrivate("visible", true);
          } else {
            axisFill.setPrivate("visible", false);
          }
        }
      }
    });
    const gridIntervals = [
      { timeUnit: "millisecond", count: 1 },
      { timeUnit: "millisecond", count: 5 },
      { timeUnit: "millisecond", count: 10 },
      { timeUnit: "millisecond", count: 50 },
      { timeUnit: "millisecond", count: 100 },
      { timeUnit: "millisecond", count: 500 },
      { timeUnit: "second", count: 1 },
      { timeUnit: "second", count: 5 },
      { timeUnit: "second", count: 10 },
      { timeUnit: "second", count: 30 },
      { timeUnit: "minute", count: 1 },
      { timeUnit: "minute", count: 5 },
      { timeUnit: "minute", count: 10 },
      { timeUnit: "minute", count: 15 },
      { timeUnit: "minute", count: 30 },
      { timeUnit: "hour", count: 1 },
      { timeUnit: "hour", count: 3 },
      { timeUnit: "hour", count: 6 },
      { timeUnit: "hour", count: 12 },
      { timeUnit: "day", count: 1 },
      { timeUnit: "day", count: 2 },
      { timeUnit: "day", count: 3 },
      { timeUnit: "day", count: 4 },
      { timeUnit: "day", count: 5 },
      { timeUnit: "week", count: 1 },
      { timeUnit: "month", count: 1 },
      { timeUnit: "month", count: 2 },
      { timeUnit: "month", count: 3 },
      { timeUnit: "month", count: 6 },
      { timeUnit: "year", count: 1 },
      { timeUnit: "year", count: 2 },
      { timeUnit: "year", count: 5 },
      { timeUnit: "year", count: 10 },
      { timeUnit: "year", count: 50 },
      { timeUnit: "year", count: 100 },
      { timeUnit: "year", count: 200 },
      { timeUnit: "year", count: 500 },
      { timeUnit: "year", count: 1e3 },
      { timeUnit: "year", count: 2e3 },
      { timeUnit: "year", count: 5e3 },
      { timeUnit: "year", count: 1e4 },
      { timeUnit: "year", count: 1e5 }
    ];
    const dateFormats = {
      "millisecond": language.translate("_date_millisecond"),
      "second": language.translate("_date_second"),
      "minute": language.translate("_date_minute"),
      "hour": language.translate("_date_hour"),
      "day": language.translate("_date_day"),
      "week": language.translate("_date_day"),
      "month": language.translate("_date_month"),
      "year": language.translate("_date_year")
    };
    const periodChangeDateFormats = {
      "millisecond": language.translate("_date_millisecond"),
      "second": language.translate("_date_second"),
      "minute": language.translate("_date_minute"),
      "hour": language.translate("_date_day"),
      "day": language.translate("_date_day"),
      "week": language.translate("_date_day"),
      "month": language.translate("_date_month") + " " + language.translate("_date_year"),
      "year": language.translate("_date_year")
    };
    const tooltipDateFormats = {
      "millisecond": language.translate("_date_millisecond_full"),
      "second": language.translate("_date_second_full"),
      "minute": language.translate("_date_minute_full"),
      "hour": language.translate("_date_hour_full"),
      "day": language.translate("_date_day_full"),
      "week": language.translate("_date_week_full"),
      "month": language.translate("_date_month_full"),
      "year": language.translate("_date_year")
    };
    r("CategoryDateAxis").setAll({
      markUnitChange: true,
      gridIntervals: copy2(gridIntervals),
      dateFormats: copy3(dateFormats),
      periodChangeDateFormats: copy3(periodChangeDateFormats)
    });
    r("DateAxis").setAll({
      maxZoomFactor: null,
      strictMinMax: true,
      startLocation: 0,
      endLocation: 1,
      markUnitChange: true,
      groupData: false,
      groupCount: 500,
      gridIntervals: copy2(gridIntervals),
      dateFormats: copy3(dateFormats),
      periodChangeDateFormats: copy3(periodChangeDateFormats),
      tooltipDateFormats,
      groupIntervals: [
        { timeUnit: "millisecond", count: 1 },
        { timeUnit: "millisecond", count: 10 },
        { timeUnit: "millisecond", count: 100 },
        { timeUnit: "second", count: 1 },
        { timeUnit: "second", count: 10 },
        { timeUnit: "minute", count: 1 },
        { timeUnit: "minute", count: 10 },
        { timeUnit: "hour", count: 1 },
        { timeUnit: "day", count: 1 },
        { timeUnit: "week", count: 1 },
        { timeUnit: "month", count: 1 },
        { timeUnit: "year", count: 1 }
      ],
      fillRule: (dataItem) => {
        const axisFill = dataItem.get("axisFill");
        if (axisFill) {
          const axis = dataItem.component;
          const value = dataItem.get("value");
          const endValue = dataItem.get("endValue");
          const intervalDuration = axis.intervalDuration();
          const baseInterval = axis.getPrivate("baseInterval");
          const gridInterval = axis.getPrivate("gridInterval", baseInterval);
          let min3 = axis.getPrivate("min", 0);
          min3 = round2(new Date(min3), gridInterval.timeUnit, gridInterval.count, this._root.locale.firstDayOfWeek, this._root.utc, void 0, this._root.timezone).getTime();
          if (value != null && endValue != null) {
            const val = Math.round(Math.round((value - min3) / intervalDuration)) / 2;
            if (val == Math.round(val)) {
              axisFill.setPrivate("visible", true);
            } else {
              axisFill.setPrivate("visible", false);
            }
          }
        }
      }
    });
    r("GaplessDateAxis").setAll({
      fillRule: (dataItem) => {
        const axisFill = dataItem.get("axisFill");
        if (axisFill) {
          const index2 = dataItem.get("index");
          let visible = false;
          if (!isNumber(index2) || index2 % 2 == 0) {
            visible = true;
          }
          axisFill.setPrivate("visible", visible);
        }
      }
    });
    r("ValueAxis").setAll({
      baseValue: 0,
      logarithmic: false,
      strictMinMax: false,
      autoZoom: true,
      fillRule: (dataItem) => {
        const axisFill = dataItem.get("axisFill");
        if (axisFill) {
          const axis = dataItem.component;
          const value = dataItem.get("value");
          const step = axis.getPrivate("step");
          if (isNumber(value) && isNumber(step)) {
            if (round(value / step / 2, 5) == Math.round(value / step / 2)) {
              axisFill.setPrivate("visible", false);
            } else {
              axisFill.setPrivate("visible", true);
            }
          }
        }
      }
    });
    r("DurationAxis").setAll({
      baseUnit: "second"
    });
    r("XYSeries").setAll({
      maskBullets: true,
      stackToNegative: true,
      locationX: 0.5,
      locationY: 0.5,
      snapTooltip: false,
      openValueXGrouped: "open",
      openValueYGrouped: "open",
      valueXGrouped: "close",
      valueYGrouped: "close",
      seriesTooltipTarget: "series"
    });
    r("BaseColumnSeries").setAll({
      adjustBulletPosition: true
    });
    r("ColumnSeries").setAll({
      clustered: true
    });
    r("RoundedRectangle", ["series", "column"]).setAll({
      position: "absolute",
      isMeasured: false,
      width: percent(70),
      height: percent(70),
      strokeWidth: 1,
      strokeOpacity: 1,
      cornerRadiusBL: 0,
      cornerRadiusTL: 0,
      cornerRadiusBR: 0,
      cornerRadiusTR: 0,
      fillOpacity: 1,
      role: "figure"
    });
    r("LineSeries").setAll({
      connect: true,
      autoGapCount: 1.1,
      stackToNegative: false
    });
    r("Graphics", ["series", "stroke"]).setAll({
      position: "absolute",
      strokeWidth: 1,
      strokeOpacity: 1,
      isMeasured: false
    });
    r("Graphics", ["series", "fill"]).setAll({
      visible: false,
      fillOpacity: 0,
      position: "absolute",
      strokeWidth: 0,
      strokeOpacity: 0,
      isMeasured: false
    });
    r("Graphics", ["line", "series", "legend", "marker", "stroke"]).setAll({
      draw: (display, sprite) => {
        const parent = sprite.parent;
        if (parent) {
          const h = parent.height();
          const w = parent.width();
          display.moveTo(0, h / 2);
          display.lineTo(w, h / 2);
        }
      }
    });
    {
      const rule = r("Graphics", ["line", "series", "legend", "marker", "stroke"]).states.create("disabled", {});
      setColor(rule, "stroke", ic, "disabled");
    }
    r("Graphics", ["line", "series", "legend", "marker", "fill"]).setAll({
      draw: (display, sprite) => {
        const parent = sprite.parent;
        if (parent) {
          const h = parent.height();
          const w = parent.width();
          display.moveTo(0, 0);
          display.lineTo(w, 0);
          display.lineTo(w, h);
          display.lineTo(0, h);
          display.lineTo(0, 0);
        }
      }
    });
    {
      const rule = r("Graphics", ["line", "series", "legend", "marker", "fill"]).states.create("disabled", {});
      setColor(rule, "stroke", ic, "disabled");
    }
    r("SmoothedXYLineSeries").setAll({
      tension: 0.5
    });
    r("SmoothedXLineSeries").setAll({
      tension: 0.5
    });
    r("SmoothedYLineSeries").setAll({
      tension: 0.5
    });
    r("Candlestick").setAll({
      position: "absolute",
      isMeasured: false,
      width: percent(50),
      height: percent(50),
      strokeWidth: 1,
      strokeOpacity: 1,
      cornerRadiusBL: 0,
      cornerRadiusTL: 0,
      cornerRadiusBR: 0,
      cornerRadiusTR: 0,
      fillOpacity: 1,
      role: "figure"
    });
    r("OHLC").setAll({
      width: percent(80),
      height: percent(80)
    });
    r("CandlestickSeries").setAll({
      lowValueXGrouped: "low",
      lowValueYGrouped: "low",
      highValueXGrouped: "high",
      highValueYGrouped: "high",
      openValueXGrouped: "open",
      openValueYGrouped: "open",
      valueXGrouped: "close",
      valueYGrouped: "close"
    });
    {
      const rule = r("Rectangle", ["column", "autocolor"]).states.create("riseFromOpen", {});
      setColor(rule, "fill", ic, "positive");
      setColor(rule, "stroke", ic, "positive");
    }
    {
      const rule = r("Rectangle", ["column", "autocolor"]).states.create("dropFromOpen", {});
      setColor(rule, "fill", ic, "negative");
      setColor(rule, "stroke", ic, "negative");
    }
    r("Rectangle", ["column", "autocolor", "pro"]).states.create("riseFromOpen", { fillOpacity: 0 });
    r("Rectangle", ["column", "autocolor", "pro"]).states.create("dropFromOpen", { fillOpacity: 1 });
    {
      const rule = r("Rectangle", ["column", "autocolor", "pro"]).states.create("riseFromPrevious", {});
      setColor(rule, "fill", ic, "positive");
      setColor(rule, "stroke", ic, "positive");
    }
    {
      const rule = r("Rectangle", ["column", "autocolor", "pro"]).states.create("dropFromPrevious", {});
      setColor(rule, "fill", ic, "negative");
      setColor(rule, "stroke", ic, "negative");
    }
    {
      const rule = r("RoundedRectangle", ["rangegrip"]);
      rule.setAll({
        strokeOpacity: 0,
        fillOpacity: 0,
        strokeWidth: 1,
        width: 12,
        height: 12
      });
    }
    {
      const rule = r("Graphics", ["rangegrip", "button", "icon"]);
      rule.setAll({
        interactive: false,
        crisp: true,
        strokeOpacity: 0.5,
        draw: (display) => {
          display.moveTo(0, 0.5);
          display.lineTo(0, 12.5);
          display.moveTo(2, 0.5);
          display.lineTo(2, 12.5);
          display.moveTo(4, 0.5);
          display.lineTo(4, 12.5);
        }
      });
      setColor(rule, "stroke", ic, "secondaryButtonText");
    }
    r("Button", ["rangegrip"]).setAll({
      draggable: true,
      paddingTop: 0,
      paddingBottom: 0
    });
    r("Button", ["rangegrip", "vertical"]).setAll({
      rotation: 90,
      cursorOverStyle: "ns-resize",
      centerX: p50
    });
    r("Button", ["rangegrip", "horizontal"]).setAll({
      cursorOverStyle: "ew-resize",
      centerX: p50
    });
    r("Button", ["rangegrip", "vertical", "left"]).setAll({
      centerY: p100
    });
    r("Button", ["rangegrip", "vertical", "right"]).setAll({
      centerY: 0
    });
    r("Button", ["rangegrip", "horizontal", "top"]).setAll({
      centerY: 0
    });
    r("Button", ["rangegrip", "horizontal", "bottom"]).setAll({
      centerY: p100
    });
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/XYChart.js
var XYChart = class extends SerialChart {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "xAxes", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListAutoDispose()
    });
    Object.defineProperty(this, "yAxes", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListAutoDispose()
    });
    Object.defineProperty(this, "topAxesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.chartContainer.children.push(Container.new(this._root, { width: p100, layout: this._root.verticalLayout }))
    });
    Object.defineProperty(this, "yAxesAndPlotContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.chartContainer.children.push(Container.new(this._root, { width: p100, height: p100, layout: this._root.horizontalLayout }))
    });
    Object.defineProperty(this, "bottomAxesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.chartContainer.children.push(Container.new(this._root, { width: p100, layout: this._root.verticalLayout }))
    });
    Object.defineProperty(this, "leftAxesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.yAxesAndPlotContainer.children.push(Container.new(this._root, { height: p100, layout: this._root.horizontalLayout }))
    });
    Object.defineProperty(this, "plotsContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.yAxesAndPlotContainer.children.push(Container.new(this._root, { width: p100, height: p100, maskContent: false }))
    });
    Object.defineProperty(this, "plotContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.plotsContainer.children.push(Container.new(this._root, { width: p100, height: p100 }))
    });
    Object.defineProperty(this, "topPlotContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.plotsContainer.children.push(Container.new(this._root, { width: p100, height: p100 }))
    });
    Object.defineProperty(this, "gridContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.plotContainer.children.push(Container.new(this._root, { width: p100, height: p100, isMeasured: false }))
    });
    Object.defineProperty(this, "topGridContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Container.new(this._root, { width: p100, height: p100, isMeasured: false })
    });
    Object.defineProperty(this, "rightAxesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.yAxesAndPlotContainer.children.push(Container.new(this._root, { height: p100, layout: this._root.horizontalLayout }))
    });
    Object.defineProperty(this, "axisHeadersContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.plotContainer.children.push(Container.new(this._root, {}))
    });
    Object.defineProperty(this, "zoomOutButton", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.topPlotContainer.children.push(Button2.new(this._root, {
        themeTags: ["zoom"],
        icon: Graphics.new(this._root, {
          themeTags: ["button", "icon"]
        })
      }))
    });
    Object.defineProperty(this, "_movePoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: { x: 0, y: 0 }
    });
    Object.defineProperty(this, "_wheelDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_otherCharts", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_movePoints", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_downStartX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_downEndX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_downStartY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_downEndY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  _afterNew() {
    this._defaultThemes.push(XYChartDefaultTheme.new(this._root));
    super._afterNew();
    this._disposers.push(this.xAxes);
    this._disposers.push(this.yAxes);
    const root = this._root;
    let verticalLayout = this._root.verticalLayout;
    const zoomOutButton = this.zoomOutButton;
    zoomOutButton.events.on("click", () => {
      this.zoomOut();
    });
    zoomOutButton.hide(0);
    zoomOutButton.states.lookup("default").set("opacity", 1);
    this.chartContainer.set("layout", verticalLayout);
    const plotContainer = this.plotContainer;
    plotContainer.children.push(this.seriesContainer);
    this._disposers.push(this._processAxis(this.xAxes, this.bottomAxesContainer));
    this._disposers.push(this._processAxis(this.yAxes, this.leftAxesContainer));
    plotContainer.children.push(this.topGridContainer);
    plotContainer.children.push(this.bulletsContainer);
    plotContainer.set("interactive", true);
    plotContainer.set("interactiveChildren", false);
    plotContainer.set("background", Rectangle.new(root, {
      themeTags: ["xy", "background"],
      fill: Color.fromHex(0),
      fillOpacity: 0
    }));
    this._disposers.push(plotContainer.events.on("pointerdown", (event) => {
      this._handlePlotDown(event);
    }));
    this._disposers.push(plotContainer.events.on("globalpointerup", (event) => {
      this._handlePlotUp(event);
    }));
    this._disposers.push(plotContainer.events.on("globalpointermove", (event) => {
      this._handlePlotMove(event);
    }));
    this._maskGrid();
    this._setUpTouch();
  }
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("pinchZoomX") || this.isDirty("pinchZoomY") || this.get("panX") || this.get("panY")) {
      this._setUpTouch();
    }
  }
  _setUpTouch() {
    if (!this.plotContainer._display.cancelTouch) {
      this.plotContainer._display.cancelTouch = this.get("pinchZoomX") || this.get("pinchZoomY") || this.get("panX") || this.get("panY") ? true : false;
    }
  }
  _maskGrid() {
    this.gridContainer.set("maskContent", true);
    this.topGridContainer.set("maskContent", true);
  }
  _removeSeries(series) {
    series._unstack();
    if (series._posXDp) {
      series._posXDp.dispose();
    }
    if (series._posYDp) {
      series._posYDp.dispose();
    }
    series.set("baseAxis", void 0);
    const xAxis = series.get("xAxis");
    if (xAxis) {
      remove(xAxis.series, series);
      xAxis.markDirtyExtremes();
    }
    const yAxis = series.get("yAxis");
    if (yAxis) {
      remove(yAxis.series, series);
      yAxis.markDirtyExtremes();
    }
    const cursor = this.get("cursor");
    if (cursor) {
      const snapToSeries = cursor.get("snapToSeries");
      if (snapToSeries) {
        remove(snapToSeries, series);
      }
    }
    super._removeSeries(series);
  }
  /**
   * This method is invoked when mouse wheel is used over chart's plot
   * container, and handles zooming/pan.
   *
   * You can invoke this method manually, if you need to mimic chart's wheel
   * behavior over other elements of the chart.
   */
  handleWheel(event) {
    const wheelX = this.get("wheelX");
    const wheelY = this.get("wheelY");
    const plotContainer = this.plotContainer;
    const wheelEvent = event.originalEvent;
    if (isLocalEvent(wheelEvent, this)) {
      wheelEvent.preventDefault();
    } else {
      return;
    }
    const plotPoint = plotContainer.toLocal(event.point);
    const wheelStep = this.get("wheelStep", 0.2);
    const shiftY = wheelEvent.deltaY / 100;
    const shiftX = wheelEvent.deltaX / 100;
    const wheelZoomPositionX = this.get("wheelZoomPositionX");
    const wheelZoomPositionY = this.get("wheelZoomPositionY");
    if ((wheelX === "zoomX" || wheelX === "zoomXY") && shiftX != 0) {
      this.xAxes.each((axis) => {
        if (axis.get("zoomX")) {
          let start = axis.get("start");
          let end = axis.get("end");
          let position2 = axis.fixPosition(plotPoint.x / plotContainer.width());
          if (wheelZoomPositionX != null) {
            position2 = wheelZoomPositionX;
          }
          let newStart = start - wheelStep * (end - start) * shiftX * position2;
          let newEnd = end + wheelStep * (end - start) * shiftX * (1 - position2);
          if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) {
            this._handleWheelAnimation(axis.zoom(newStart, newEnd));
          }
        }
      });
    }
    if ((wheelY === "zoomX" || wheelY === "zoomXY") && shiftY != 0) {
      this.xAxes.each((axis) => {
        if (axis.get("zoomX")) {
          let start = axis.get("start");
          let end = axis.get("end");
          let position2 = axis.fixPosition(plotPoint.x / plotContainer.width());
          if (wheelZoomPositionX != null) {
            position2 = wheelZoomPositionX;
          }
          let newStart = start - wheelStep * (end - start) * shiftY * position2;
          let newEnd = end + wheelStep * (end - start) * shiftY * (1 - position2);
          if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) {
            this._handleWheelAnimation(axis.zoom(newStart, newEnd));
          }
        }
      });
    }
    if ((wheelX === "zoomY" || wheelX === "zoomXY") && shiftX != 0) {
      this.yAxes.each((axis) => {
        if (axis.get("zoomY")) {
          let start = axis.get("start");
          let end = axis.get("end");
          let position2 = axis.fixPosition(plotPoint.y / plotContainer.height());
          if (wheelZoomPositionY != null) {
            position2 = wheelZoomPositionY;
          }
          let newStart = start - wheelStep * (end - start) * shiftX * position2;
          let newEnd = end + wheelStep * (end - start) * shiftX * (1 - position2);
          if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) {
            this._handleWheelAnimation(axis.zoom(newStart, newEnd));
          }
        }
      });
    }
    if ((wheelY === "zoomY" || wheelY === "zoomXY") && shiftY != 0) {
      this.yAxes.each((axis) => {
        if (axis.get("zoomY")) {
          let start = axis.get("start");
          let end = axis.get("end");
          let position2 = axis.fixPosition(plotPoint.y / plotContainer.height());
          if (wheelZoomPositionY != null) {
            position2 = wheelZoomPositionY;
          }
          let newStart = start - wheelStep * (end - start) * shiftY * position2;
          let newEnd = end + wheelStep * (end - start) * shiftY * (1 - position2);
          if (1 / (newEnd - newStart) < axis.getPrivate("maxZoomFactor", Infinity) / axis.get("minZoomCount", 1)) {
            this._handleWheelAnimation(axis.zoom(newStart, newEnd));
          }
        }
      });
    }
    if ((wheelX === "panX" || wheelX === "panXY") && shiftX != 0) {
      this.xAxes.each((axis) => {
        if (axis.get("panX")) {
          let start = axis.get("start");
          let end = axis.get("end");
          let delta = this._getWheelSign(axis) * wheelStep * (end - start) * shiftX;
          let newStart = start + delta;
          let newEnd = end + delta;
          let se = this._fixWheel(newStart, newEnd);
          newStart = se[0];
          newEnd = se[1];
          this._handleWheelAnimation(axis.zoom(newStart, newEnd));
        }
      });
    }
    if ((wheelY === "panX" || wheelY === "panXY") && shiftY != 0) {
      this.xAxes.each((axis) => {
        if (axis.get("panX")) {
          let start = axis.get("start");
          let end = axis.get("end");
          let delta = this._getWheelSign(axis) * wheelStep * (end - start) * shiftY;
          let newStart = start + delta;
          let newEnd = end + delta;
          let se = this._fixWheel(newStart, newEnd);
          newStart = se[0];
          newEnd = se[1];
          this._handleWheelAnimation(axis.zoom(newStart, newEnd));
        }
      });
    }
    if ((wheelX === "panY" || wheelX === "panXY") && shiftX != 0) {
      this.yAxes.each((axis) => {
        if (axis.get("panY")) {
          let start = axis.get("start");
          let end = axis.get("end");
          let delta = this._getWheelSign(axis) * wheelStep * (end - start) * shiftX;
          let newStart = start + delta;
          let newEnd = end + delta;
          let se = this._fixWheel(newStart, newEnd);
          newStart = se[0];
          newEnd = se[1];
          this._handleWheelAnimation(axis.zoom(newStart, newEnd));
        }
      });
    }
    if ((wheelY === "panY" || wheelY === "panXY") && shiftY != 0) {
      this.yAxes.each((axis) => {
        if (axis.get("panY")) {
          let start = axis.get("start");
          let end = axis.get("end");
          let delta = this._getWheelSign(axis) * wheelStep * (end - start) * shiftY;
          let newStart = start - delta;
          let newEnd = end - delta;
          let se = this._fixWheel(newStart, newEnd);
          newStart = se[0];
          newEnd = se[1];
          this._handleWheelAnimation(axis.zoom(newStart, newEnd));
        }
      });
    }
  }
  _handleSetWheel() {
    const wheelX = this.get("wheelX");
    const wheelY = this.get("wheelY");
    const plotContainer = this.plotContainer;
    if (wheelX !== "none" || wheelY !== "none") {
      this._wheelDp = plotContainer.events.on("wheel", (event) => {
        const wheelEvent = event.originalEvent;
        if (wheelX !== "none" && Math.abs(wheelEvent.deltaX) != 0 || wheelY !== "none" && Math.abs(wheelEvent.deltaY) != 0) {
          this.handleWheel(event);
        }
      });
      this._disposers.push(this._wheelDp);
    } else {
      if (this._wheelDp) {
        this._wheelDp.dispose();
      }
    }
  }
  _getWheelSign(axis) {
    let sign2 = 1;
    if (axis.get("renderer").get("inversed")) {
      sign2 = -1;
    }
    return sign2;
  }
  _fixWheel(start, end) {
    const diff = end - start;
    if (start < 0) {
      start = 0;
      end = start + diff;
    }
    if (end > 1) {
      end = 1;
      start = end - diff;
    }
    return [start, end];
  }
  _handlePlotDown(event) {
    const originalEvent = event.originalEvent;
    if (originalEvent.button == 2) {
      return;
    }
    const plotContainer = this.plotContainer;
    let local = plotContainer.toLocal(event.point);
    if (this.get("pinchZoomX") || this.get("pinchZoomY")) {
      const pointerId = originalEvent.pointerId;
      if (pointerId) {
        if (keys2(plotContainer._downPoints).length > 0) {
          const xAxis = this.xAxes.getIndex(0);
          const yAxis = this.yAxes.getIndex(0);
          if (xAxis) {
            this._downStartX = xAxis.get("start", 0);
            this._downEndX = xAxis.get("end", 1);
          }
          if (yAxis) {
            this._downStartY = yAxis.get("start", 0);
            this._downEndY = yAxis.get("end", 1);
          }
        }
      }
    }
    if (this.get("panX") || this.get("panY")) {
      if (local.x >= 0 && local.y >= 0 && local.x <= plotContainer.width() && local.y <= this.height()) {
        this._downPoint = { x: originalEvent.clientX, y: originalEvent.clientY };
        const panX = this.get("panX");
        const panY = this.get("panY");
        if (panX) {
          this.xAxes.each((axis) => {
            axis._panStart = axis.get("start");
            axis._panEnd = axis.get("end");
          });
        }
        if (panY) {
          this.yAxes.each((axis) => {
            axis._panStart = axis.get("start");
            axis._panEnd = axis.get("end");
          });
        }
        const eventType = "panstarted";
        if (this.events.isEnabled(eventType)) {
          this.events.dispatch(eventType, { type: eventType, target: this, originalEvent: event.originalEvent });
        }
      }
    }
  }
  _handleWheelAnimation(animation) {
    if (animation) {
      animation.events.on("stopped", () => {
        this._dispatchWheelAnimation();
      });
    } else {
      this._dispatchWheelAnimation();
    }
  }
  _dispatchWheelAnimation() {
    const eventType = "wheelended";
    if (this.events.isEnabled(eventType)) {
      this.events.dispatch(eventType, { type: eventType, target: this });
    }
  }
  _handlePlotUp(event) {
    const downPoint = this._downPoint;
    if (downPoint) {
      if (this.get("panX") || this.get("panY")) {
        let local = this.plotContainer.toLocal(event.point);
        if (local.x == downPoint.x && local.y == downPoint.y) {
          const eventType2 = "pancancelled";
          if (this.events.isEnabled(eventType2)) {
            this.events.dispatch(eventType2, { type: eventType2, target: this, originalEvent: event.originalEvent });
          }
        }
        const eventType = "panended";
        if (this.events.isEnabled(eventType)) {
          this.events.dispatch(eventType, { type: eventType, target: this, originalEvent: event.originalEvent });
        }
      }
    }
    this._downPoint = void 0;
    this.xAxes.each((xAxis) => {
      xAxis._isPanning = false;
    });
    this.yAxes.each((yAxis) => {
      yAxis._isPanning = false;
    });
  }
  _handlePlotMove(event) {
    const plotContainer = this.plotContainer;
    if (this.get("pinchZoomX") || this.get("pinchZoomY")) {
      const touchEvent = event.originalEvent;
      const pointerId = touchEvent.pointerId;
      if (pointerId) {
        this._movePoints[pointerId] = event.point;
        if (keys2(plotContainer._downPoints).length > 1) {
          this._handlePinch();
          return;
        }
      }
    }
    let downPoint = this._downPoint;
    if (downPoint) {
      downPoint = plotContainer.toLocal(this._root.documentPointToRoot(downPoint));
      let local = plotContainer.toLocal(event.point);
      const panX = this.get("panX");
      const panY = this.get("panY");
      if (panX) {
        let scrollbarX = this.get("scrollbarX");
        if (scrollbarX) {
          scrollbarX.events.disableType("rangechanged");
        }
        this.xAxes.each((axis) => {
          if (axis.get("panX")) {
            axis._isPanning = true;
            let panStart = axis._panStart;
            let panEnd = axis._panEnd;
            let difference = panEnd - panStart;
            let deltaX = difference * (downPoint.x - local.x) / plotContainer.width();
            if (axis.get("renderer").get("inversed")) {
              deltaX *= -1;
            }
            let start = panStart + deltaX;
            let end = panEnd + deltaX;
            if (end - start < 1 + axis.get("maxDeviation", 1) * 2) {
              axis.set("start", start);
              axis.set("end", end);
            }
          }
        });
        if (scrollbarX) {
          scrollbarX.events.enableType("rangechanged");
        }
      }
      if (panY) {
        let scrollbarY = this.get("scrollbarY");
        if (scrollbarY) {
          scrollbarY.events.disableType("rangechanged");
        }
        this.yAxes.each((axis) => {
          if (axis.get("panY")) {
            axis._isPanning = true;
            let panStart = axis._panStart;
            let panEnd = axis._panEnd;
            let difference = panEnd - panStart;
            let deltaY = difference * (downPoint.y - local.y) / plotContainer.height();
            if (axis.get("renderer").get("inversed")) {
              deltaY *= -1;
            }
            let start = panStart - deltaY;
            let end = panEnd - deltaY;
            if (end - start < 1 + axis.get("maxDeviation", 1) * 2) {
              axis.set("start", start);
              axis.set("end", end);
            }
          }
        });
        if (scrollbarY) {
          scrollbarY.events.enableType("rangechanged");
        }
      }
    }
  }
  _handlePinch() {
    const plotContainer = this.plotContainer;
    let i = 0;
    let downPoints = [];
    let movePoints = [];
    each2(plotContainer._downPoints, (k, point2) => {
      downPoints[i] = point2;
      let movePoint = this._movePoints[k];
      if (movePoint) {
        movePoints[i] = movePoint;
      }
      i++;
    });
    if (downPoints.length > 1 && movePoints.length > 1) {
      const w = plotContainer.width();
      const h = plotContainer.height();
      let downPoint0 = downPoints[0];
      let downPoint1 = downPoints[1];
      let movePoint0 = movePoints[0];
      let movePoint1 = movePoints[1];
      if (downPoint0 && downPoint1 && movePoint0 && movePoint1) {
        movePoint0 = plotContainer.toLocal(movePoint0);
        movePoint1 = plotContainer.toLocal(movePoint1);
        downPoint0 = plotContainer.toLocal(downPoint0);
        downPoint1 = plotContainer.toLocal(downPoint1);
        if (this.get("pinchZoomX")) {
          const downStartX = this._downStartX;
          const downEndX = this._downEndX;
          if (downStartX != null && downEndX != null) {
            if (downPoint0.x > downPoint1.x) {
              [downPoint0, downPoint1] = [downPoint1, downPoint0];
              [movePoint0, movePoint1] = [movePoint1, movePoint0];
            }
            let downPos0 = downStartX + downPoint0.x / w * (downEndX - downStartX);
            let downPos1 = downStartX + downPoint1.x / w * (downEndX - downStartX);
            let movePos0 = downStartX + movePoint0.x / w * (downEndX - downStartX);
            let movePos1 = downStartX + movePoint1.x / w * (downEndX - downStartX);
            let initialDistance = Math.max(1e-3, downPos1 - downPos0);
            let currentDistance = Math.max(1e-3, movePos1 - movePos0);
            let d = initialDistance / currentDistance;
            let s2 = downStartX * d + downPos0 - movePos0 * d;
            let e = downEndX * d + downPos1 - movePos1 * d;
            this.xAxes.each((xAxis) => {
              let sa = xAxis.fixPosition(s2);
              let ea = xAxis.fixPosition(e);
              xAxis.zoom(sa, ea, 0);
            });
          }
        }
        if (this.get("pinchZoomY")) {
          const downStartY = this._downStartY;
          const downEndY = this._downEndY;
          if (downStartY != null && downEndY != null) {
            if (downPoint0.y < downPoint1.y) {
              [downPoint0, downPoint1] = [downPoint1, downPoint0];
              [movePoint0, movePoint1] = [movePoint1, movePoint0];
            }
            let downPos0 = downStartY + (1 - downPoint0.y / h) * (downEndY - downStartY);
            let downPos1 = downStartY + (1 - downPoint1.y / h) * (downEndY - downStartY);
            let movePos0 = downStartY + (1 - movePoint0.y / h) * (downEndY - downStartY);
            let movePos1 = downStartY + (1 - movePoint1.y / h) * (downEndY - downStartY);
            let initialDistance = Math.max(1e-3, downPos1 - downPos0);
            let currentDistance = Math.max(1e-3, movePos1 - movePos0);
            let d = initialDistance / currentDistance;
            let s2 = downStartY * d + downPos0 - movePos0 * d;
            let e = downEndY * d + downPos1 - movePos1 * d;
            this.yAxes.each((yAxis) => {
              let sa = yAxis.fixPosition(s2);
              let ea = yAxis.fixPosition(e);
              yAxis.zoom(sa, ea, 0);
            });
          }
        }
      }
    }
  }
  _handleCursorPosition() {
    const cursor = this.get("cursor");
    if (cursor) {
      const cursorPoint = cursor.getPrivate("point");
      let snapToSeries = cursor.get("snapToSeries");
      if (cursor._downPoint) {
        snapToSeries = void 0;
      }
      if (snapToSeries && cursorPoint) {
        const snapToSeriesBy = cursor.get("snapToSeriesBy");
        const dataItems = [];
        each(snapToSeries, (series) => {
          if (!series.isHidden() && !series.isHiding()) {
            if (snapToSeriesBy != "x!" && snapToSeriesBy != "y!") {
              const startIndex = series.startIndex();
              const endIndex = series.endIndex();
              for (let i = startIndex; i < endIndex; i++) {
                const dataItem = series.dataItems[i];
                if (dataItem && !dataItem.isHidden()) {
                  dataItems.push(dataItem);
                }
              }
            } else {
              const tooltipDataItem = series.get("tooltipDataItem");
              if (tooltipDataItem) {
                dataItems.push(tooltipDataItem);
              }
            }
          }
        });
        let minDistance = Infinity;
        let closestItem;
        each(dataItems, (dataItem) => {
          const point2 = dataItem.get("point");
          if (point2) {
            let distance = 0;
            if (snapToSeriesBy == "x" || snapToSeriesBy == "x!") {
              distance = Math.abs(cursorPoint.x - point2.x);
            } else if (snapToSeriesBy == "y" || snapToSeriesBy == "y!") {
              distance = Math.abs(cursorPoint.y - point2.y);
            } else {
              distance = Math.hypot(cursorPoint.x - point2.x, cursorPoint.y - point2.y);
            }
            if (distance < minDistance) {
              minDistance = distance;
              closestItem = dataItem;
            }
          }
        });
        each(snapToSeries, (series) => {
          const tooltip = series.get("tooltip");
          if (tooltip) {
            tooltip._setDataItem(void 0);
          }
        });
        if (closestItem) {
          let series = closestItem.component;
          series.showDataItemTooltip(closestItem);
          const point2 = closestItem.get("point");
          if (point2) {
            cursor.handleMove(series.toGlobal({ x: point2.x - series.x(), y: point2.y - series.y() }), true);
          }
        }
      }
    }
  }
  _updateCursor() {
    let cursor = this.get("cursor");
    if (cursor) {
      cursor.updateCursor();
    }
  }
  _addCursor(cursor) {
    this.plotContainer.children.push(cursor);
  }
  _prepareChildren() {
    super._prepareChildren();
    this.series.each((series) => {
      this._colorize(series);
    });
    if (this.isDirty("wheelX") || this.isDirty("wheelY")) {
      this._handleSetWheel();
    }
    if (this.isDirty("cursor")) {
      const previous = this._prevSettings.cursor;
      const cursor = this.get("cursor");
      if (cursor !== previous) {
        this._disposeProperty("cursor");
        if (previous) {
          previous.dispose();
        }
        if (cursor) {
          cursor._setChart(this);
          this._addCursor(cursor);
          this._pushPropertyDisposer("cursor", cursor.events.on("selectended", () => {
            this._handleCursorSelectEnd();
          }));
        }
        this._prevSettings.cursor = cursor;
      }
    }
    if (this.isDirty("scrollbarX")) {
      const previous = this._prevSettings.scrollbarX;
      const scrollbarX = this.get("scrollbarX");
      if (scrollbarX !== previous) {
        this._disposeProperty("scrollbarX");
        if (previous) {
          previous.dispose();
        }
        if (scrollbarX) {
          if (!scrollbarX.parent) {
            this.topAxesContainer.children.push(scrollbarX);
          }
          this._pushPropertyDisposer("scrollbarX", scrollbarX.events.on("rangechanged", (e) => {
            this._handleScrollbar(this.xAxes, e.start, e.end, e.grip);
          }));
          scrollbarX.setPrivate("positionTextFunction", (position2) => {
            const axis = this.xAxes.getIndex(0);
            return axis ? axis.getTooltipText(position2, false) || "" : "";
          });
        }
        this._prevSettings.scrollbarX = scrollbarX;
      }
    }
    if (this.isDirty("scrollbarY")) {
      const previous = this._prevSettings.scrollbarY;
      const scrollbarY = this.get("scrollbarY");
      if (scrollbarY !== previous) {
        this._disposeProperty("scrollbarY");
        if (previous) {
          previous.dispose();
        }
        if (scrollbarY) {
          if (!scrollbarY.parent) {
            this.rightAxesContainer.children.push(scrollbarY);
          }
          this._pushPropertyDisposer("scrollbarY", scrollbarY.events.on("rangechanged", (e) => {
            this._handleScrollbar(this.yAxes, e.start, e.end, e.grip);
          }));
          scrollbarY.setPrivate("positionTextFunction", (position2) => {
            const axis = this.yAxes.getIndex(0);
            return axis ? axis.getTooltipText(position2, false) || "" : "";
          });
        }
        this._prevSettings.scrollbarY = scrollbarY;
      }
    }
    this._handleZoomOut();
  }
  _processSeries(series) {
    super._processSeries(series);
    const xAxis = series.get("xAxis");
    const yAxis = series.get("yAxis");
    move2(xAxis.series, series);
    move2(yAxis.series, series);
    series._posXDp = series.addDisposer(xAxis.events.on("positionchanged", () => {
      series._fixPosition();
    }));
    series._posXDp = series.addDisposer(yAxis.events.on("positionchanged", () => {
      series._fixPosition();
    }));
    if (!series.get("baseAxis")) {
      if (yAxis.isType("CategoryAxis") || yAxis.isType("DateAxis")) {
        series.set("baseAxis", yAxis);
      } else {
        series.set("baseAxis", xAxis);
      }
    }
    if (series.get("stacked")) {
      series._markDirtyKey("stacked");
      each(series.dataItems, (dataItem) => {
        dataItem.set("stackToItemY", void 0);
        dataItem.set("stackToItemX", void 0);
      });
    }
    series._markDirtyAxes();
    yAxis.markDirtyExtremes();
    xAxis.markDirtyExtremes();
    this._colorize(series);
  }
  _colorize(series) {
    const colorSet = this.get("colors");
    if (colorSet) {
      if (series.get("fill") == null) {
        const color2 = colorSet.next();
        series._setSoft("stroke", color2);
        series._setSoft("fill", color2);
      }
    }
  }
  _handleCursorSelectEnd() {
    const cursor = this.get("cursor");
    const behavior = cursor.get("behavior");
    const downPositionX = cursor.getPrivate("downPositionX", 0);
    const downPositionY = cursor.getPrivate("downPositionY", 0);
    const positionX = Math.min(1, Math.max(0, cursor.getPrivate("positionX", 0.5)));
    const positionY = Math.min(1, Math.max(0, cursor.getPrivate("positionY", 0.5)));
    this.xAxes.each((axis) => {
      if (behavior === "zoomX" || behavior === "zoomXY") {
        let position0 = axis.toAxisPosition(downPositionX);
        let position1 = axis.toAxisPosition(positionX);
        axis.zoom(position0, position1);
      }
      axis.setPrivate("updateScrollbar", true);
    });
    this.yAxes.each((axis) => {
      if (behavior === "zoomY" || behavior === "zoomXY") {
        let position0 = axis.toAxisPosition(downPositionY);
        let position1 = axis.toAxisPosition(positionY);
        axis.zoom(position0, position1);
      }
      axis.setPrivate("updateScrollbar", true);
    });
  }
  _handleScrollbar(axes, start, end, priority) {
    axes.each((axis) => {
      let axisStart = axis.fixPosition(start);
      let axisEnd = axis.fixPosition(end);
      let zoomAnimation = axis.zoom(axisStart, axisEnd, void 0, priority);
      const updateScrollbar = "updateScrollbar";
      axis.setPrivateRaw(updateScrollbar, false);
      if (zoomAnimation) {
        zoomAnimation.events.on("stopped", () => {
          axis.setPrivateRaw(updateScrollbar, true);
        });
      } else {
        axis.setPrivateRaw(updateScrollbar, true);
      }
    });
  }
  _processAxis(axes, container) {
    return axes.events.onAll((change) => {
      if (change.type === "clear") {
        each(change.oldValues, (axis) => {
          this._removeAxis(axis);
        });
      } else if (change.type === "push") {
        container.children.push(change.newValue);
        change.newValue.processChart(this);
      } else if (change.type === "setIndex") {
        container.children.setIndex(change.index, change.newValue);
        change.newValue.processChart(this);
      } else if (change.type === "insertIndex") {
        container.children.insertIndex(change.index, change.newValue);
        change.newValue.processChart(this);
      } else if (change.type === "removeIndex") {
        this._removeAxis(change.oldValue);
      } else if (change.type === "moveIndex") {
        container.children.moveValue(change.value, change.newIndex);
        change.value.processChart(this);
      } else {
        throw new Error("Unknown IListEvent type");
      }
    });
  }
  _removeAxis(axis) {
    if (!axis.isDisposed()) {
      const axisParent = axis.parent;
      if (axisParent) {
        axisParent.children.removeValue(axis);
      }
      const gridContainer = axis.gridContainer;
      const gridParent = gridContainer.parent;
      if (gridParent) {
        gridParent.children.removeValue(gridContainer);
      }
      const topGridContainer = axis.topGridContainer;
      const topGridParent = topGridContainer.parent;
      if (topGridParent) {
        topGridParent.children.removeValue(topGridContainer);
      }
    }
  }
  _updateChartLayout() {
    const left = this.leftAxesContainer.width();
    const right = this.rightAxesContainer.width();
    const bottomAxesContainer = this.bottomAxesContainer;
    bottomAxesContainer.set("paddingLeft", left);
    bottomAxesContainer.set("paddingRight", right);
    const topAxesContainer = this.topAxesContainer;
    topAxesContainer.set("paddingLeft", left);
    topAxesContainer.set("paddingRight", right);
  }
  /**
   * @ignore
   */
  processAxis(axis) {
    var cursor = this.get("cursor");
    if (cursor) {
      this.addDisposer(axis.on("start", () => {
        this._updateCursor();
      }));
      this.addDisposer(axis.on("end", () => {
        this._updateCursor();
      }));
    }
  }
  _handleAxisSelection(axis, force) {
    let start = axis.fixPosition(axis.get("start", 0));
    let end = axis.fixPosition(axis.get("end", 1));
    if (start > end) {
      [start, end] = [end, start];
    }
    if (this.xAxes.indexOf(axis) != -1) {
      if (force || axis.getPrivate("updateScrollbar")) {
        let scrollbarX = this.get("scrollbarX");
        if (scrollbarX && (!scrollbarX.getPrivate("isBusy") || force)) {
          scrollbarX.setRaw("start", start);
          scrollbarX.setRaw("end", end);
          scrollbarX.updateGrips();
        }
      }
    } else if (this.yAxes.indexOf(axis) != -1) {
      if (force || axis.getPrivate("updateScrollbar")) {
        let scrollbarY = this.get("scrollbarY");
        if (scrollbarY && (!scrollbarY.getPrivate("isBusy") || force)) {
          scrollbarY.setRaw("start", start);
          scrollbarY.setRaw("end", end);
          scrollbarY.updateGrips();
        }
      }
    }
    this._handleZoomOut();
  }
  _handleZoomOut() {
    let zoomOutButton = this.zoomOutButton;
    if (zoomOutButton && zoomOutButton.parent) {
      let visible = false;
      this.xAxes.each((axis) => {
        if (axis.get("start") != 0 || axis.get("end") != 1) {
          visible = true;
        }
      });
      this.yAxes.each((axis) => {
        if (axis.get("start") != 0 || axis.get("end") != 1) {
          visible = true;
        }
      });
      if (visible) {
        if (zoomOutButton.isHidden()) {
          zoomOutButton.show();
        }
      } else {
        zoomOutButton.hide();
      }
    }
  }
  /**
   * Checks if point is within plot area.
   *
   * @param   point  Reference point
   * @return         Is within plot area?
   */
  inPlot(point2) {
    const plotContainer = this.plotContainer;
    const otherCharts = this.getPrivate("otherCharts", this._otherCharts);
    const global2 = plotContainer.toGlobal(point2);
    if (point2.x >= -0.5 && point2.y >= -0.5 && point2.x <= plotContainer.width() + 0.5 && point2.y <= plotContainer.height() + 0.5) {
      return true;
    }
    if (otherCharts) {
      for (let i = otherCharts.length - 1; i >= 0; i--) {
        const chart = otherCharts[i];
        if (chart != this) {
          const chartPlotContainer = chart.plotContainer;
          const documentPoint = this._root.rootPointToDocument(global2);
          const chartRoot = chart._root.documentPointToRoot(documentPoint);
          const local = chartPlotContainer.toLocal(chartRoot);
          if (local.x >= -0.1 && local.y >= -0.1 && local.x <= chartPlotContainer.width() + 0.1 && local.y <= chartPlotContainer.height() + 0.1) {
            return true;
          }
        }
      }
    }
    return false;
  }
  /**
   * @ignore
   */
  arrangeTooltips() {
    const plotContainer = this.plotContainer;
    const w = plotContainer.width();
    const h = plotContainer.height();
    const hh = this.height();
    let plotT = plotContainer._display.toGlobal({ x: 0, y: 0 });
    let plotB = plotContainer._display.toGlobal({ x: w, y: h });
    const tooltips = [];
    let sum = 0;
    let minDistance = Infinity;
    let movePoint = this._movePoint;
    let maxTooltipDistance = this.get("maxTooltipDistance");
    let maxTooltipDistanceBy = this.get("maxTooltipDistanceBy", "xy");
    let closest;
    let closestPoint;
    if (isNumber(maxTooltipDistance)) {
      this.series.each((series) => {
        if (!series.isHidden()) {
          const tooltip = series.get("tooltip");
          if (tooltip) {
            let point2 = tooltip.get("pointTo");
            if (point2) {
              let distance = Math.hypot(movePoint.x - point2.x, movePoint.y - point2.y);
              if (maxTooltipDistanceBy == "x") {
                distance = Math.abs(movePoint.x - point2.x);
              } else if (maxTooltipDistanceBy == "y") {
                distance = Math.abs(movePoint.y - point2.y);
              }
              if (distance < minDistance) {
                minDistance = distance;
                closest = series;
                closestPoint = point2;
              }
            }
          }
        }
      });
    }
    const tooltipSeries = [];
    this.series.each((series) => {
      const tooltip = series.get("tooltip");
      if (tooltip && !tooltip.get("forceHidden")) {
        let hidden = false;
        let point2 = tooltip.get("pointTo");
        if (point2) {
          if (maxTooltipDistance >= 0) {
            let point3 = tooltip.get("pointTo");
            if (point3 && closestPoint) {
              if (series != closest) {
                let distance = Math.hypot(closestPoint.x - point3.x, closestPoint.y - point3.y);
                if (maxTooltipDistanceBy == "x") {
                  distance = Math.abs(closestPoint.x - point3.x);
                } else if (maxTooltipDistanceBy == "y") {
                  distance = Math.abs(closestPoint.y - point3.y);
                }
                if (distance > maxTooltipDistance) {
                  hidden = true;
                }
              }
            }
          } else if (maxTooltipDistance == -1) {
            if (series != closest) {
              hidden = true;
            }
          }
          if (!this.inPlot(this._tooltipToLocal(point2)) || !tooltip.dataItem) {
            hidden = true;
          } else {
            if (!hidden) {
              sum += point2.y;
            }
          }
          if (hidden || series.isHidden() || series.isHiding()) {
            tooltip.hide(0);
          } else {
            tooltip.show();
            tooltips.push(tooltip);
            tooltipSeries.push(series);
          }
        }
      }
    });
    this.setPrivate("tooltipSeries", tooltipSeries);
    if (this.get("arrangeTooltips")) {
      const tooltipContainer = this._root.tooltipContainer;
      const count = tooltips.length;
      const average = sum / count;
      if (average > h / 2 + plotT.y) {
        tooltips.sort((a, b) => compareNumber(b.get("pointTo").y, a.get("pointTo").y));
        let prevY = plotB.y;
        each(tooltips, (tooltip) => {
          let height = tooltip.height();
          let centerY = tooltip.get("centerY");
          if (centerY instanceof Percent) {
            height *= centerY.value;
          }
          height += tooltip.get("marginBottom", 0);
          tooltip.set("bounds", { left: plotT.x, top: plotT.y, right: plotB.x, bottom: prevY });
          tooltip.setPrivate("customData", { left: plotT.x, top: plotT.y, right: plotB.x, bottom: prevY });
          prevY = Math.min(prevY - height, tooltip._fy - height);
          if (tooltip.parent == tooltipContainer) {
            tooltipContainer.children.moveValue(tooltip, 0);
          }
        });
        if (prevY < 0) {
          tooltips.reverse();
          let prevBottom = prevY;
          each(tooltips, (tooltip) => {
            let bounds = tooltip.get("bounds");
            if (bounds) {
              let top = bounds.top - prevY;
              let bottom = bounds.bottom - prevY;
              if (top < prevBottom) {
                top = prevBottom;
                bottom = top + tooltip.height();
              }
              tooltip.set("bounds", { left: bounds.left, top, right: bounds.right, bottom });
              prevBottom = bounds.bottom - prevY + tooltip.get("marginBottom", 0);
            }
          });
        }
      } else {
        tooltips.reverse();
        tooltips.sort((a, b) => compareNumber(a.get("pointTo").y, b.get("pointTo").y));
        let prevY = 0;
        each(tooltips, (tooltip) => {
          let height = tooltip.height();
          let centerY = tooltip.get("centerY");
          if (centerY instanceof Percent) {
            height *= centerY.value;
          }
          height += tooltip.get("marginBottom", 0);
          tooltip.set("bounds", { left: plotT.x, top: prevY, right: plotB.x, bottom: Math.max(plotT.y + hh, prevY + height) });
          if (tooltip.parent == tooltipContainer) {
            tooltipContainer.children.moveValue(tooltip, 0);
          }
          prevY = Math.max(prevY + height, tooltip._fy + height);
        });
        if (prevY > hh) {
          tooltips.reverse();
          let prevBottom = hh;
          each(tooltips, (tooltip) => {
            let bounds = tooltip.get("bounds");
            if (bounds) {
              let top = bounds.top - (hh - prevY);
              let bottom = bounds.bottom - (hh - prevY);
              if (bottom > prevBottom) {
                bottom = prevBottom;
                top = bottom - tooltip.height();
              }
              tooltip.set("bounds", { left: bounds.left, top, right: bounds.right, bottom });
              prevBottom = bottom - tooltip.height() - tooltip.get("marginBottom", 0);
            }
          });
        }
      }
    }
  }
  _tooltipToLocal(point2) {
    return this.plotContainer.toLocal(point2);
  }
  /**
   * Fully zooms out the chart.
   */
  zoomOut() {
    this.xAxes.each((axis) => {
      axis.setPrivate("updateScrollbar", true);
      axis.zoom(0, 1);
    });
    this.yAxes.each((axis) => {
      axis.setPrivate("updateScrollbar", true);
      axis.zoom(0, 1);
    });
  }
};
Object.defineProperty(XYChart, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "XYChart"
});
Object.defineProperty(XYChart, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: SerialChart.classNames.concat([XYChart.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/Grid.js
var Grid = class extends Graphics {
  _beforeChanged() {
    super._beforeChanged();
    if (this.isPrivateDirty("width") || this.isPrivateDirty("height")) {
      this._clear = true;
    }
  }
};
Object.defineProperty(Grid, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Grid"
});
Object.defineProperty(Grid, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Graphics.classNames.concat([Grid.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/XYCursor.js
var XYCursor = class extends Container {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "lineX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Grid.new(this._root, {
        themeTags: ["x"]
      }))
    });
    Object.defineProperty(this, "lineY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Grid.new(this._root, {
        themeTags: ["y"]
      }))
    });
    Object.defineProperty(this, "selection", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Graphics.new(this._root, {
        themeTags: ["selection", "cursor"],
        layer: 30
      }))
    });
    Object.defineProperty(this, "_movePoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_lastPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: { x: 0, y: 0 }
    });
    Object.defineProperty(this, "_tooltipX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_tooltipY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "chart", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_toX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_toY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["xy", "cursor"]);
    super._afterNew();
    this.setAll({ "width": p100, height: p100, isMeasured: true, position: "absolute" });
    this.states.create("hidden", { visible: true, opacity: 0 });
    this._drawLines();
    this.setPrivateRaw("visible", false);
    this._disposers.push(this.setTimeout(() => {
      this.setPrivate("visible", true);
    }, 500));
    this._disposers.push(this.lineX.events.on("positionchanged", () => {
      this._handleXLine();
    }));
    this._disposers.push(this.lineY.events.on("positionchanged", () => {
      this._handleYLine();
    }));
    this._disposers.push(this.lineX.events.on("focus", (ev) => this._handleLineFocus(ev.target)));
    this._disposers.push(this.lineX.events.on("blur", (ev) => this._handleLineBlur(ev.target)));
    this._disposers.push(this.lineY.events.on("focus", (ev) => this._handleLineFocus(ev.target)));
    this._disposers.push(this.lineY.events.on("blur", (ev) => this._handleLineBlur(ev.target)));
    if (supports("keyboardevents")) {
      this._disposers.push(addEventListener(document, "keydown", (ev) => {
        this._handleLineMove(ev.keyCode);
      }));
    }
  }
  _setUpTouch() {
    const chart = this.chart;
    if (chart) {
      chart.plotContainer._display.cancelTouch = this.get("behavior") != "none" ? true : false;
    }
  }
  _handleXLine() {
    let x2 = this.lineX.x();
    let visible = true;
    if (x2 < 0 || x2 > this.width()) {
      visible = false;
    }
    this.lineX.setPrivate("visible", visible);
  }
  _handleYLine() {
    let y2 = this.lineY.y();
    let visible = true;
    if (y2 < 0 || y2 > this.height()) {
      visible = false;
    }
    this.lineY.setPrivate("visible", visible);
  }
  _handleLineMove(keyCode) {
    let dir = "";
    let position2 = 0;
    let increment = 0.1;
    const chart = this.chart;
    if (this._root.focused(this.lineX)) {
      if (chart && chart.xAxes.length) {
        increment = chart.xAxes.getIndex(0).getCellWidthPosition();
      }
      position2 = this.getPrivate("positionX", 0);
      dir = "positionX";
      if (keyCode == 37) {
        position2 -= increment;
      } else if (keyCode == 39) {
        position2 += increment;
      }
    } else if (this._root.focused(this.lineY)) {
      if (chart && chart.yAxes.length) {
        increment = chart.yAxes.getIndex(0).getCellWidthPosition();
      }
      position2 = this.getPrivate("positionY", 0);
      dir = "positionY";
      if (keyCode == 38) {
        position2 -= increment;
      } else if (keyCode == 40) {
        position2 += increment;
      }
    }
    if (position2 < 0) {
      position2 = 0;
    } else if (position2 > 1) {
      position2 = 1;
    }
    if (dir != "") {
      this.set(dir, position2);
    }
  }
  _handleLineFocus(_line) {
    this.setAll({
      positionX: this.getPrivate("positionX"),
      positionY: this.getPrivate("positionY"),
      alwaysShow: true
    });
  }
  _handleLineBlur(_line) {
    this.setAll({
      positionX: void 0,
      positionY: void 0,
      alwaysShow: false
    });
  }
  _prepareChildren() {
    super._prepareChildren();
    if (this.isDirty("xAxis")) {
      this._tooltipX = false;
      const xAxis = this.get("xAxis");
      if (xAxis) {
        const tooltip = xAxis.get("tooltip");
        if (tooltip) {
          this._tooltipX = true;
          this._disposers.push(tooltip.on("pointTo", () => {
            this._updateXLine(tooltip);
          }));
        }
      }
    }
    if (this.isDirty("yAxis")) {
      this._tooltipY = false;
      const yAxis = this.get("yAxis");
      if (yAxis) {
        const tooltip = yAxis.get("tooltip");
        if (tooltip) {
          this._tooltipY = true;
          this._disposers.push(tooltip.on("pointTo", () => {
            this._updateYLine(tooltip);
          }));
        }
      }
    }
  }
  _handleSyncWith() {
    const chart = this.chart;
    if (chart) {
      const syncWith = this.get("syncWith");
      const otherCharts = [];
      if (syncWith) {
        each(syncWith, (cursor) => {
          const chart2 = cursor.chart;
          if (chart2) {
            otherCharts.push(chart2);
          }
        });
      }
      chart._otherCharts = otherCharts;
    }
  }
  _updateChildren() {
    super._updateChildren();
    this._handleSyncWith();
    if (this.isDirty("positionX") || this.isDirty("positionY")) {
      const positionX = this.get("positionX");
      const positionY = this.get("positionY");
      if (positionX == null && positionY == null) {
        this.hide(0);
      } else {
        this._movePoint = this.toGlobal(this._getPoint(this.get("positionX", 0), this.get("positionY", 0)));
        this.handleMove();
      }
    }
  }
  _updateXLine(tooltip) {
    let x2 = round(this._display.toLocal(tooltip.get("pointTo", { x: 0, y: 0 })).x, 2);
    if (this._toX != x2) {
      this.lineX.animate({ key: "x", to: x2, duration: tooltip.get("animationDuration", 0), easing: tooltip.get("animationEasing") });
      this._toX = x2;
    }
  }
  _updateYLine(tooltip) {
    let y2 = round(this._display.toLocal(tooltip.get("pointTo", { x: 0, y: 0 })).y, 2);
    if (this._toY != y2) {
      this.lineY.animate({ key: "y", to: y2, duration: tooltip.get("animationDuration", 0), easing: tooltip.get("animationEasing") });
      this._toY = y2;
    }
  }
  _drawLines() {
    this.lineX.set("draw", (display) => {
      display.moveTo(0, 0);
      display.lineTo(0, this.height());
    });
    this.lineY.set("draw", (display) => {
      display.moveTo(0, 0);
      display.lineTo(this.width(), 0);
    });
  }
  updateCursor() {
    if (this.get("alwaysShow")) {
      this._movePoint = this.toGlobal(this._getPoint(this.get("positionX", 0), this.get("positionY", 0)));
    }
    this.handleMove();
  }
  _setChart(chart) {
    this.chart = chart;
    this._handleSyncWith();
    const plotContainer = chart.plotContainer;
    this.events.on("boundschanged", () => {
      this._disposers.push(this.setTimeout(() => {
        this.updateCursor();
      }, 50));
    });
    if (supports("touchevents")) {
      this._disposers.push(plotContainer.events.on("click", (event) => {
        if (isTouchEvent(event.originalEvent)) {
          this._handleMove(event);
        }
      }));
      this._setUpTouch();
    }
    this._disposers.push(plotContainer.events.on("pointerdown", (event) => {
      this._handleCursorDown(event);
    }));
    this._disposers.push(plotContainer.events.on("globalpointerup", (event) => {
      this._handleCursorUp(event);
      if (!event.native && !this.isHidden()) {
        this._handleMove(event);
      }
    }));
    this._disposers.push(plotContainer.events.on("globalpointermove", (event) => {
      if (!this.get("syncWith")) {
        if (keys2(plotContainer._downPoints).length == 0 && !event.native && this.isHidden()) {
          return;
        }
      }
      this._handleMove(event);
    }));
    const parent = this.parent;
    if (parent) {
      parent.children.moveValue(this.selection);
    }
  }
  _inPlot(point2) {
    const chart = this.chart;
    if (chart) {
      return chart.inPlot(point2);
    }
    return false;
  }
  _handleCursorDown(event) {
    if (event.originalEvent.button == 2) {
      return;
    }
    const rootPoint = event.point;
    let local = this._display.toLocal(rootPoint);
    const chart = this.chart;
    this.selection.set("draw", () => {
    });
    if (chart && this._inPlot(local)) {
      this._downPoint = local;
      if (this.get("behavior") != "none") {
        this.selection.show();
        const type4 = "selectstarted";
        if (this.events.isEnabled(type4)) {
          this.events.dispatch(type4, { type: type4, target: this, originalEvent: event.originalEvent });
        }
      }
      let positionX = this._getPosition(local).x;
      let positionY = this._getPosition(local).y;
      this.setPrivate("downPositionX", positionX);
      this.setPrivate("downPositionY", positionY);
    }
  }
  _handleCursorUp(event) {
    if (this._downPoint) {
      const behavior = this.get("behavior", "none");
      if (behavior != "none") {
        if (behavior.charAt(0) === "z") {
          this.selection.hide();
        }
        const rootPoint = event.point;
        let local = this._display.toLocal(rootPoint);
        const downPoint = this._downPoint;
        const moveThreshold = this.get("moveThreshold", 1);
        if (local && downPoint) {
          let dispatch = false;
          if (behavior === "zoomX" || behavior === "zoomXY" || behavior === "selectX" || behavior === "selectXY") {
            if (Math.abs(local.x - downPoint.x) > moveThreshold) {
              dispatch = true;
            }
          }
          if (behavior === "zoomY" || behavior === "zoomXY" || behavior === "selectY" || behavior === "selectXY") {
            if (Math.abs(local.y - downPoint.y) > moveThreshold) {
              dispatch = true;
            }
          }
          if (dispatch) {
            const type4 = "selectended";
            if (this.events.isEnabled(type4)) {
              this.events.dispatch(type4, { type: type4, target: this, originalEvent: event.originalEvent });
            }
          } else {
            const type4 = "selectcancelled";
            if (this.events.isEnabled(type4)) {
              this.events.dispatch(type4, { type: type4, target: this, originalEvent: event.originalEvent });
            }
          }
        }
      }
    }
    this._downPoint = void 0;
  }
  _handleMove(event) {
    if (this.getPrivate("visible")) {
      const chart = this.chart;
      if (chart && keys2(chart.plotContainer._downPoints).length > 1) {
        this.set("forceHidden", true);
        return;
      } else {
        this.set("forceHidden", false);
      }
      const rootPoint = event.point;
      const lastPoint = this._lastPoint;
      if (Math.round(lastPoint.x) === Math.round(rootPoint.x) && Math.round(lastPoint.y) === Math.round(rootPoint.y)) {
        return;
      }
      this._lastPoint = rootPoint;
      this.setPrivate("lastPoint", rootPoint);
      this.handleMove({ x: rootPoint.x, y: rootPoint.y }, false, event.originalEvent);
    }
  }
  _getPosition(point2) {
    return { x: point2.x / this.width(), y: point2.y / this.height() };
  }
  /**
   * Moves the cursor to X/Y coordinates within chart container (`point`).
   *
   * If `skipEvent` parameter is set to `true`, the move will not invoke
   * the `"cursormoved"` event.
   *
   * @param  point      X/Y to move cursor to
   * @param  skipEvent  Do not fire "cursormoved" event
   */
  handleMove(point2, skipEvent, originalEvent) {
    if (!point2) {
      point2 = this._movePoint;
    }
    const alwaysShow = this.get("alwaysShow");
    if (!point2) {
      this.hide(0);
      return;
    }
    this._movePoint = point2;
    let local = this._display.toLocal(point2);
    let chart = this.chart;
    if (chart && (this._inPlot(local) || this._downPoint)) {
      chart._movePoint = point2;
      if (this.isHidden()) {
        this.show();
        const behavior = this.get("behavior", "");
        if (behavior.charAt(0) == "z") {
          this.selection.set("draw", () => {
          });
        }
      }
      let x2 = local.x;
      let y2 = local.y;
      let xyPos = this._getPosition(local);
      this.setPrivate("point", local);
      let snapToSeries = this.get("snapToSeries");
      if (this._downPoint) {
        snapToSeries = void 0;
      }
      let userPositionX = this.get("positionX");
      let positionX = xyPos.x;
      if (isNumber(userPositionX)) {
        positionX = userPositionX;
      }
      let userPositionY = this.get("positionY");
      let positionY = xyPos.y;
      if (isNumber(userPositionY)) {
        positionY = userPositionY;
      }
      this.setPrivate("positionX", positionX);
      this.setPrivate("positionY", positionY);
      const xy = this._getPoint(positionX, positionY);
      x2 = xy.x;
      y2 = xy.y;
      chart.xAxes.each((axis) => {
        axis._handleCursorPosition(positionX, snapToSeries);
        if (alwaysShow) {
          axis.handleCursorShow();
        }
      });
      chart.yAxes.each((axis) => {
        axis._handleCursorPosition(positionY, snapToSeries);
        if (alwaysShow) {
          axis.handleCursorShow();
        }
      });
      if (!skipEvent) {
        chart._handleCursorPosition();
        const type4 = "cursormoved";
        if (this.events.isEnabled(type4)) {
          this.events.dispatch(type4, { type: type4, target: this, point: point2, originalEvent });
        }
      }
      this._updateLines(x2, y2);
      chart.arrangeTooltips();
    } else if (!this._downPoint) {
      if (!alwaysShow) {
        this.hide(0);
        const type4 = "cursorhidden";
        if (this.events.isEnabled(type4)) {
          this.events.dispatch(type4, { type: type4, target: this });
        }
      }
    }
    if (this._downPoint && this.get("behavior") != "none") {
      this._updateSelection(local);
    }
  }
  _getPoint(positionX, positionY) {
    return { x: this.width() * positionX, y: this.height() * positionY };
  }
  _updateLines(x2, y2) {
    if (!this._tooltipX) {
      this.lineX.set("x", x2);
    }
    if (!this._tooltipY) {
      this.lineY.set("y", y2);
    }
    this._drawLines();
  }
  _updateSelection(point2) {
    const selection = this.selection;
    const behavior = this.get("behavior");
    const w = this.width();
    const h = this.height();
    if (point2.x < 0) {
      point2.x = 0;
    }
    if (point2.x > w) {
      point2.x = w;
    }
    if (point2.y < 0) {
      point2.y = 0;
    }
    if (point2.y > h) {
      point2.y = h;
    }
    selection.set("draw", (display) => {
      const downPoint = this._downPoint;
      if (downPoint) {
        if (behavior === "zoomXY" || behavior === "selectXY") {
          display.moveTo(downPoint.x, downPoint.y);
          display.lineTo(downPoint.x, point2.y);
          display.lineTo(point2.x, point2.y);
          display.lineTo(point2.x, downPoint.y);
          display.lineTo(downPoint.x, downPoint.y);
        } else if (behavior === "zoomX" || behavior === "selectX") {
          display.moveTo(downPoint.x, 0);
          display.lineTo(downPoint.x, h);
          display.lineTo(point2.x, h);
          display.lineTo(point2.x, 0);
          display.lineTo(downPoint.x, 0);
        } else if (behavior === "zoomY" || behavior === "selectY") {
          display.moveTo(0, downPoint.y);
          display.lineTo(w, downPoint.y);
          display.lineTo(w, point2.y);
          display.lineTo(0, point2.y);
          display.lineTo(0, downPoint.y);
        }
      }
    });
  }
  _onHide() {
    if (this.isHidden()) {
      let chart = this.chart;
      if (chart) {
        chart.xAxes.each((axis) => {
          axis.handleCursorHide();
        });
        chart.yAxes.each((axis) => {
          axis.handleCursorHide();
        });
        chart.series.each((series) => {
          series.handleCursorHide();
        });
      }
    }
    super._onHide();
  }
  _onShow() {
    if (!this.isHidden()) {
      let chart = this.chart;
      if (chart) {
        chart.xAxes.each((axis) => {
          axis.handleCursorShow();
        });
        chart.yAxes.each((axis) => {
          axis.handleCursorShow();
        });
      }
    }
    super._onShow();
  }
  _dispose() {
    super._dispose();
    this.selection.dispose();
  }
};
Object.defineProperty(XYCursor, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "XYCursor"
});
Object.defineProperty(XYCursor, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Container.classNames.concat([XYCursor.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/series/XYSeries.js
function min2(left, right) {
  if (left == null) {
    return right;
  } else if (right == null) {
    return left;
  } else if (right < left) {
    return right;
  } else {
    return left;
  }
}
function max2(left, right) {
  if (left == null) {
    return right;
  } else if (right == null) {
    return left;
  } else if (right > left) {
    return right;
  } else {
    return left;
  }
}
var XYSeries = class extends Series {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_xField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_yField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_xOpenField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_yOpenField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_xLowField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_xHighField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_yLowField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_yHighField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_axesDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_stackDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_selectionProcessed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_dataSets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_mainContainerMask", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_x", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_y", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_bullets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "mainContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Container.new(this._root, {}))
    });
    Object.defineProperty(this, "axisRanges", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new List3()
    });
    Object.defineProperty(this, "_skipped", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_couldStackTo", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_reallyStackedTo", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_stackedSeries", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(this, "_aLocationX0", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_aLocationX1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "_aLocationY0", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_aLocationY1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "_showBullets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    Object.defineProperty(this, "valueXFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: [
        "valueX",
        "openValueX",
        "lowValueX",
        "highValueX"
      ]
    });
    Object.defineProperty(this, "valueYFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: [
        "valueY",
        "openValueY",
        "lowValueY",
        "highValueY"
      ]
    });
    Object.defineProperty(this, "_valueXFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_valueYFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_valueXShowFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_valueYShowFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "__valueXShowFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "__valueYShowFields", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_emptyDataItem", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new DataItem(this, void 0, {})
    });
    Object.defineProperty(this, "_dataSetId", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltipFieldX", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_tooltipFieldY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_posXDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_posYDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  _afterNew() {
    this.fields.push("categoryX", "categoryY", "openCategoryX", "openCategoryY");
    this.valueFields.push("valueX", "valueY", "openValueX", "openValueY", "lowValueX", "lowValueY", "highValueX", "highValueY");
    this._setRawDefault("vcx", 1);
    this._setRawDefault("vcy", 1);
    this._setRawDefault("valueXShow", "valueXWorking");
    this._setRawDefault("valueYShow", "valueYWorking");
    this._setRawDefault("openValueXShow", "openValueXWorking");
    this._setRawDefault("openValueYShow", "openValueYWorking");
    this._setRawDefault("lowValueXShow", "lowValueXWorking");
    this._setRawDefault("lowValueYShow", "lowValueYWorking");
    this._setRawDefault("highValueXShow", "highValueXWorking");
    this._setRawDefault("highValueYShow", "highValueYWorking");
    this._setRawDefault("lowValueXGrouped", "low");
    this._setRawDefault("lowValueYGrouped", "low");
    this._setRawDefault("highValueXGrouped", "high");
    this._setRawDefault("highValueYGrouped", "high");
    super._afterNew();
    this.set("maskContent", true);
    this._disposers.push(this.axisRanges.events.onAll((change) => {
      if (change.type === "clear") {
        each(change.oldValues, (axisRange) => {
          this._removeAxisRange(axisRange);
        });
      } else if (change.type === "push") {
        this._processAxisRange(change.newValue);
      } else if (change.type === "setIndex") {
        this._processAxisRange(change.newValue);
      } else if (change.type === "insertIndex") {
        this._processAxisRange(change.newValue);
      } else if (change.type === "removeIndex") {
        this._removeAxisRange(change.oldValue);
      } else if (change.type === "moveIndex") {
        this._processAxisRange(change.value);
      } else {
        throw new Error("Unknown IStreamEvent type");
      }
    }));
    this.states.create("hidden", { opacity: 1, visible: false });
    this._makeFieldNames();
  }
  _processAxisRange(axisRange) {
    const container = Container.new(this._root, {});
    axisRange.container = container;
    this.children.push(container);
    axisRange.series = this;
    const axisDataItem = axisRange.axisDataItem;
    axisDataItem.setRaw("isRange", true);
    const axis = axisDataItem.component;
    if (axis) {
      axis._processAxisRange(axisDataItem, ["range", "series"]);
      const bullet = axisDataItem.get("bullet");
      if (bullet) {
        const sprite = bullet.get("sprite");
        if (sprite) {
          sprite.setPrivate("visible", false);
        }
      }
      const axisFill = axisDataItem.get("axisFill");
      if (axisFill) {
        container.set("mask", axisFill);
      }
      axis._seriesAxisRanges.push(axisDataItem);
    }
  }
  _removeAxisRange(axisRange) {
    const axisDataItem = axisRange.axisDataItem;
    const axis = axisDataItem.component;
    axis.disposeDataItem(axisDataItem);
    remove(axis._seriesAxisRanges, axisDataItem);
    const container = axisRange.container;
    if (container) {
      container.dispose();
    }
  }
  _updateFields() {
    super._updateFields();
    this._valueXFields = [];
    this._valueYFields = [];
    this._valueXShowFields = [];
    this._valueYShowFields = [];
    this.__valueXShowFields = [];
    this.__valueYShowFields = [];
    if (this.valueXFields) {
      each(this.valueXFields, (key) => {
        const field = this.get(key + "Field");
        if (field) {
          this._valueXFields.push(key);
          let field2 = this.get(key + "Show");
          this.__valueXShowFields.push(field2);
          if (field2.indexOf("Working") != -1) {
            this._valueXShowFields.push(field2.split("Working")[0]);
          } else {
            this._valueXShowFields.push(field2);
          }
        }
      });
    }
    if (this.valueYFields) {
      each(this.valueYFields, (key) => {
        const field = this.get(key + "Field");
        if (field) {
          this._valueYFields.push(key);
          let field2 = this.get(key + "Show");
          this.__valueYShowFields.push(field2);
          if (field2.indexOf("Working") != -1) {
            this._valueYShowFields.push(field2.split("Working")[0]);
          } else {
            this._valueYShowFields.push(field2);
          }
        }
      });
    }
  }
  _dispose() {
    super._dispose();
    this._bullets = {};
    const chart = this.chart;
    if (chart) {
      chart.series.removeValue(this);
    }
    removeFirst(this.get("xAxis").series, this);
    removeFirst(this.get("yAxis").series, this);
  }
  // TODO use  SelectKeys<this["_privateSettings"], number | undefined>
  _min(key, value) {
    let newValue = min2(this.getPrivate(key), value);
    this.setPrivate(key, newValue);
  }
  // TODO use  SelectKeys<this["_privateSettings"], number | undefined>
  _max(key, value) {
    let newValue = max2(this.getPrivate(key), value);
    this.setPrivate(key, newValue);
  }
  _shouldMakeBullet(dataItem) {
    const xAxis = this.get("xAxis");
    const yAxis = this.get("yAxis");
    const baseAxis = this.get("baseAxis");
    if (!xAxis.inited || !yAxis.inited) {
      return false;
    }
    const minBulletDistance = this.get("minBulletDistance", 0);
    if (minBulletDistance > 0) {
      let startIndex = this.startIndex();
      let endIndex = this.endIndex();
      let count = endIndex - startIndex;
      if (xAxis == baseAxis) {
        if (xAxis.get("renderer").axisLength() / count < minBulletDistance / 5) {
          return false;
        }
      } else if (yAxis == baseAxis) {
        if (yAxis.get("renderer").axisLength() / count < minBulletDistance / 5) {
          return false;
        }
      }
    }
    if (dataItem.get(this._xField) != null && dataItem.get(this._yField) != null) {
      return true;
    }
    return false;
  }
  _makeFieldNames() {
    const xAxis = this.get("xAxis");
    const yAxis = this.get("yAxis");
    const xName = xAxis.getPrivate("name");
    const xCapName = capitalizeFirst(xName);
    const yName = yAxis.getPrivate("name");
    const yCapName = capitalizeFirst(yName);
    const xLetter = xAxis.get("renderer").getPrivate("letter");
    const yLetter = yAxis.get("renderer").getPrivate("letter");
    const open3 = "open";
    const low = "low";
    const high = "high";
    const show = "Show";
    if (xAxis.className === "ValueAxis") {
      this._xField = this.get(xName + xLetter + show);
      this._xOpenField = this.get(open3 + xCapName + xLetter + show);
      this._xLowField = this.get(low + xCapName + xLetter + show);
      this._xHighField = this.get(high + xCapName + xLetter + show);
    } else {
      this._xField = xName + xLetter;
      this._xOpenField = open3 + xCapName + xLetter;
      this._xLowField = low + xCapName + xLetter;
      this._xHighField = high + xCapName + xLetter;
    }
    if (yAxis.className === "ValueAxis") {
      this._yField = this.get(yName + yLetter + show);
      this._yOpenField = this.get(open3 + yCapName + yLetter + show);
      this._yLowField = this.get(low + yCapName + yLetter + show);
      this._yHighField = this.get(high + yCapName + yLetter + show);
    } else {
      this._yField = yName + yLetter;
      this._yOpenField = open3 + yCapName + yLetter;
      this._yLowField = low + yCapName + yLetter;
      this._yHighField = high + yCapName + yLetter;
    }
  }
  _fixVC() {
    const xAxis = this.get("xAxis");
    const yAxis = this.get("yAxis");
    const baseAxis = this.get("baseAxis");
    const hiddenState = this.states.lookup("hidden");
    const sequencedInterpolation = this.get("sequencedInterpolation");
    if (hiddenState) {
      let value = 0;
      if (sequencedInterpolation) {
        value = 0.999999999999;
      }
      if (xAxis === baseAxis) {
        hiddenState.set("vcy", value);
      } else if (yAxis === baseAxis) {
        hiddenState.set("vcx", value);
      } else {
        hiddenState.set("vcy", value);
        hiddenState.set("vcx", value);
      }
    }
  }
  _handleMaskBullets() {
    if (this.isDirty("maskBullets")) {
      this.bulletsContainer.set("maskContent", this.get("maskBullets"));
    }
  }
  _fixPosition() {
    const xAxis = this.get("xAxis");
    const yAxis = this.get("yAxis");
    this.set("x", xAxis.x() - relativeToValue(xAxis.get("centerX", 0), xAxis.width()) - xAxis.parent.get("paddingLeft", 0));
    this.set("y", yAxis.y() - relativeToValue(yAxis.get("centerY", 0), yAxis.height()) - yAxis.parent.get("paddingTop", 0));
    this.bulletsContainer.set("y", this.y());
    this.bulletsContainer.set("x", this.x());
  }
  _prepareChildren() {
    super._prepareChildren();
    this._bullets = {};
    if (this.isDirty("valueYShow") || this.isDirty("valueXShow") || this.isDirty("openValueYShow") || this.isDirty("openValueXShow") || this.isDirty("lowValueYShow") || this.isDirty("lowValueXShow") || this.isDirty("highValueYShow") || this.isDirty("highValueXShow")) {
      this._updateFields();
      this._makeFieldNames();
      this._valuesDirty = true;
    }
    if (this.isDirty("xAxis") || this.isDirty("yAxis")) {
      this._valuesDirty = true;
    }
    this.set("width", this.get("xAxis").width());
    this.set("height", this.get("yAxis").height());
    this._handleMaskBullets();
    const xAxis = this.get("xAxis");
    const yAxis = this.get("yAxis");
    const baseAxis = this.get("baseAxis");
    const tooltipPositionX = this.get("tooltipPositionX");
    let tooltipFieldX;
    switch (tooltipPositionX) {
      case "open":
        tooltipFieldX = this._xOpenField;
        break;
      case "low":
        tooltipFieldX = this._xLowField;
        break;
      case "high":
        tooltipFieldX = this._xHighField;
        break;
      default:
        tooltipFieldX = this._xField;
    }
    this._tooltipFieldX = tooltipFieldX;
    const tooltipPositionY = this.get("tooltipPositionY");
    let tooltipFieldY;
    switch (tooltipPositionY) {
      case "open":
        tooltipFieldY = this._yOpenField;
        break;
      case "low":
        tooltipFieldY = this._yLowField;
        break;
      case "high":
        tooltipFieldY = this._yHighField;
        break;
      default:
        tooltipFieldY = this._yField;
    }
    this._tooltipFieldY = tooltipFieldY;
    if (this.isDirty("baseAxis")) {
      this._fixVC();
    }
    this._fixPosition();
    const stacked = this.get("stacked");
    if (this.isDirty("stacked")) {
      if (stacked) {
        if (this._valuesDirty && !this._dataProcessed) {
        } else {
          this._stack();
        }
      } else {
        this._unstack();
      }
    }
    if (this._valuesDirty && !this._dataProcessed) {
      this._dataProcessed = true;
      if (stacked) {
        this._stack();
      }
      each(this.dataItems, (dataItem) => {
        each(this._valueXShowFields, (key) => {
          let value = dataItem.get(key);
          if (value != null) {
            if (stacked) {
              value += this.getStackedXValue(dataItem, key);
            }
            this._min("minX", value);
            this._max("maxX", value);
          }
        });
        each(this._valueYShowFields, (key) => {
          let value = dataItem.get(key);
          if (value != null) {
            if (stacked) {
              value += this.getStackedYValue(dataItem, key);
            }
            this._min("minY", value);
            this._max("maxY", value);
          }
        });
        xAxis.processSeriesDataItem(dataItem, this._valueXFields);
        yAxis.processSeriesDataItem(dataItem, this._valueYFields);
      });
      xAxis._seriesValuesDirty = true;
      yAxis._seriesValuesDirty = true;
      if (!this.get("ignoreMinMax")) {
        if (this.isPrivateDirty("minX") || this.isPrivateDirty("maxX")) {
          xAxis.markDirtyExtremes();
        }
        if (this.isPrivateDirty("minY") || this.isPrivateDirty("maxY")) {
          yAxis.markDirtyExtremes();
        }
      }
      this._markStakedDirtyStack();
      if (!this.get("tooltipDataItem")) {
        this.updateLegendValue(void 0);
      }
    }
    if (this.isDirty("vcx") || this.isDirty("vcy")) {
      this._markStakedDirtyStack();
    }
    if (!this._dataGrouped) {
      xAxis._groupSeriesData(this);
      yAxis._groupSeriesData(this);
      this._dataGrouped = true;
    }
    if (this._valuesDirty || this.isPrivateDirty("startIndex") || this.isPrivateDirty("endIndex") || this.isDirty("vcx") || this.isDirty("vcy") || this._stackDirty) {
      let startIndex = this.startIndex();
      let endIndex = this.endIndex();
      let minBulletDistance = this.get("minBulletDistance", 0);
      if (minBulletDistance > 0 && baseAxis) {
        if (baseAxis.get("renderer").axisLength() / (endIndex - startIndex) > minBulletDistance) {
          this._showBullets = true;
        } else {
          this._showBullets = false;
        }
      }
      if ((this._psi != startIndex || this._pei != endIndex || this.isDirty("vcx") || this.isDirty("vcy") || this._stackDirty || this._valuesDirty) && !this._selectionProcessed) {
        this._selectionProcessed = true;
        const vcx = this.get("vcx", 1);
        const vcy = this.get("vcy", 1);
        const stacked2 = this.get("stacked", false);
        const outOfSelection = this.getPrivate("outOfSelection");
        if (baseAxis === xAxis || !baseAxis) {
          yAxis._calculateTotals();
          this.setPrivateRaw("selectionMinY", void 0);
          this.setPrivateRaw("selectionMaxY", void 0);
          if (!outOfSelection) {
            for (let i = startIndex; i < endIndex; i++) {
              this.processYSelectionDataItem(this.dataItems[i], vcy, stacked2);
            }
          } else {
            yAxis.markDirtySelectionExtremes();
          }
        }
        if (baseAxis === yAxis || !baseAxis) {
          xAxis._calculateTotals();
          this.setPrivateRaw("selectionMinX", void 0);
          this.setPrivateRaw("selectionMaxX", void 0);
          if (!outOfSelection) {
            for (let i = startIndex; i < endIndex; i++) {
              this.processXSelectionDataItem(this.dataItems[i], vcx, stacked2);
            }
          } else {
            yAxis.markDirtySelectionExtremes();
          }
        }
        if (baseAxis === xAxis || !baseAxis) {
          if (this.get("valueYShow") !== "valueYWorking") {
            const selectionMinY = this.getPrivate("selectionMinY");
            if (selectionMinY != null) {
              this.setPrivateRaw("minY", selectionMinY);
              yAxis.markDirtyExtremes();
            }
            const selectionMaxY = this.getPrivate("selectionMaxY");
            if (selectionMaxY != null) {
              this.setPrivateRaw("maxY", selectionMaxY);
              yAxis.markDirtyExtremes();
            }
          }
        }
        if (baseAxis === yAxis || !baseAxis) {
          if (this.get("valueXShow") !== "valueXWorking") {
            const selectionMinX = this.getPrivate("selectionMinX");
            if (selectionMinX != null) {
              this.setPrivateRaw("minX", selectionMinX);
              yAxis.markDirtyExtremes();
            }
            const selectionMaxX = this.getPrivate("selectionMaxX");
            if (selectionMaxX != null) {
              this.setPrivateRaw("maxX", selectionMaxX);
              xAxis.markDirtyExtremes();
            }
          }
        }
        if (this.isPrivateDirty("selectionMinX") || this.isPrivateDirty("selectionMaxX")) {
          xAxis.markDirtySelectionExtremes();
        }
        if (this.isPrivateDirty("selectionMinY") || this.isPrivateDirty("selectionMaxY")) {
          yAxis.markDirtySelectionExtremes();
        }
      }
    }
  }
  _makeRangeMask() {
    if (this.axisRanges.length > 0) {
      let mainContainerMask = this._mainContainerMask;
      if (mainContainerMask == null) {
        mainContainerMask = this.children.push(Graphics.new(this._root, {}));
        this._mainContainerMask = mainContainerMask;
        mainContainerMask.set("draw", (display, target) => {
          const parent = this.parent;
          if (parent) {
            const w = this._root.container.width();
            const h = this._root.container.height();
            display.moveTo(-w, -h);
            display.lineTo(-w, h * 2);
            display.lineTo(w * 2, h * 2);
            display.lineTo(w * 2, -h);
            display.lineTo(-w, -h);
            this.axisRanges.each((axisRange) => {
              const fill = axisRange.axisDataItem.get("axisFill");
              if (parent) {
                if (fill) {
                  let draw = fill.get("draw");
                  if (draw) {
                    draw(display, target);
                  }
                }
              }
            });
          }
          this.mainContainer._display.mask = mainContainerMask._display;
        });
      }
      mainContainerMask.markDirty();
      mainContainerMask._markDirtyKey("fill");
    } else {
      this.mainContainer._display.mask = null;
    }
  }
  _updateChildren() {
    super._updateChildren();
    this._x = this.x();
    this._y = this.y();
    this._makeRangeMask();
  }
  _stack() {
    const chart = this.chart;
    if (chart) {
      const seriesIndex = chart.series.indexOf(this);
      this._couldStackTo = [];
      if (seriesIndex > 0) {
        let series;
        for (let i = seriesIndex - 1; i >= 0; i--) {
          series = chart.series.getIndex(i);
          if (series.get("xAxis") === this.get("xAxis") && series.get("yAxis") === this.get("yAxis") && series.className === this.className) {
            this._couldStackTo.push(series);
            if (!series.get("stacked")) {
              break;
            }
          }
        }
      }
      this._stackDataItems();
    }
  }
  _unstack() {
    each2(this._reallyStackedTo, (_key, value) => {
      delete value._stackedSeries[this.uid];
    });
    this._reallyStackedTo = {};
    each(this.dataItems, (dataItem) => {
      dataItem.setRaw("stackToItemY", void 0);
      dataItem.setRaw("stackToItemX", void 0);
    });
  }
  _stackDataItems() {
    const baseAxis = this.get("baseAxis");
    const xAxis = this.get("xAxis");
    const yAxis = this.get("yAxis");
    let field;
    let stackToItemKey;
    if (baseAxis === xAxis) {
      field = "valueY";
      stackToItemKey = "stackToItemY";
    } else if (baseAxis === yAxis) {
      field = "valueX";
      stackToItemKey = "stackToItemX";
    }
    let len = this._couldStackTo.length;
    let index2 = 0;
    const stackToNegative = this.get("stackToNegative");
    this._reallyStackedTo = {};
    each(this.dataItems, (dataItem) => {
      for (let s2 = 0; s2 < len; s2++) {
        let stackToSeries = this._couldStackTo[s2];
        let stackToItem = stackToSeries.dataItems[index2];
        let value = dataItem.get(field);
        if (stackToItem) {
          let stackValue = stackToItem.get(field);
          if (stackToNegative) {
            if (isNumber(value)) {
              if (isNumber(stackValue)) {
                if (value >= 0 && stackValue >= 0) {
                  dataItem.setRaw(stackToItemKey, stackToItem);
                  this._reallyStackedTo[stackToSeries.uid] = stackToSeries;
                  stackToSeries._stackedSeries[this.uid] = this;
                  break;
                }
                if (value < 0 && stackValue < 0) {
                  dataItem.setRaw(stackToItemKey, stackToItem);
                  this._reallyStackedTo[stackToSeries.uid] = stackToSeries;
                  stackToSeries._stackedSeries[this.uid] = this;
                  break;
                }
              }
            } else {
              break;
            }
          } else {
            if (isNumber(value) && isNumber(stackValue)) {
              dataItem.setRaw(stackToItemKey, stackToItem);
              this._reallyStackedTo[stackToSeries.uid] = stackToSeries;
              stackToSeries._stackedSeries[this.uid] = this;
              break;
            }
          }
        }
      }
      index2++;
    });
  }
  processXSelectionDataItem(dataItem, vcx, stacked) {
    each(this.__valueXShowFields, (key) => {
      let value = dataItem.get(key);
      if (value != null) {
        if (stacked) {
          value += this.getStackedXValueWorking(dataItem, key);
        }
        this._min("selectionMinX", value);
        this._max("selectionMaxX", value * vcx);
      }
    });
  }
  processYSelectionDataItem(dataItem, vcy, stacked) {
    each(this.__valueYShowFields, (key) => {
      let value = dataItem.get(key);
      if (value != null) {
        if (stacked) {
          value += this.getStackedYValueWorking(dataItem, key);
        }
        this._min("selectionMinY", value);
        this._max("selectionMaxY", value * vcy);
      }
    });
  }
  /**
   * @ignore
   */
  getStackedYValueWorking(dataItem, key) {
    const stackToItem = dataItem.get("stackToItemY");
    if (stackToItem) {
      const stackedToSeries = stackToItem.component;
      return stackToItem.get(key, 0) * stackedToSeries.get("vcy", 1) + this.getStackedYValueWorking(stackToItem, key);
    }
    return 0;
  }
  /**
   * @ignore
   */
  getStackedXValueWorking(dataItem, key) {
    const stackToItem = dataItem.get("stackToItemX");
    if (stackToItem) {
      const stackedToSeries = stackToItem.component;
      return stackToItem.get(key, 0) * stackedToSeries.get("vcx", 1) + this.getStackedXValueWorking(stackToItem, key);
    }
    return 0;
  }
  /**
   * @ignore
   */
  getStackedYValue(dataItem, key) {
    const stackToItem = dataItem.get("stackToItemY");
    if (stackToItem) {
      return stackToItem.get(key, 0) + this.getStackedYValue(stackToItem, key);
    }
    return 0;
  }
  /**
   * @ignore
   */
  getStackedXValue(dataItem, key) {
    const stackToItem = dataItem.get("stackToItemX");
    if (stackToItem) {
      return stackToItem.get(key, 0) + this.getStackedXValue(stackToItem, key);
    }
    return 0;
  }
  /**
   * @ignore
   */
  createLegendMarker(_dataItem) {
    this.updateLegendMarker();
  }
  _markDirtyAxes() {
    this._axesDirty = true;
    this.markDirty();
  }
  _markDataSetDirty() {
    this._afterDataChange();
    this._valuesDirty = true;
    this._dataProcessed = false;
    this._aggregatesCalculated = false;
    this.markDirty();
  }
  _clearDirty() {
    super._clearDirty();
    this._axesDirty = false;
    this._selectionProcessed = false;
    this._stackDirty = false;
    this._dataProcessed = false;
  }
  _positionBullet(bullet) {
    let sprite = bullet.get("sprite");
    if (sprite) {
      let dataItem = sprite.dataItem;
      let locationX = bullet.get("locationX", dataItem.get("locationX", 0.5));
      let locationY = bullet.get("locationY", dataItem.get("locationY", 0.5));
      let xAxis = this.get("xAxis");
      let yAxis = this.get("yAxis");
      let positionX = xAxis.getDataItemPositionX(dataItem, this._xField, locationX, this.get("vcx", 1));
      let positionY = yAxis.getDataItemPositionY(dataItem, this._yField, locationY, this.get("vcy", 1));
      let point2 = this.getPoint(positionX, positionY);
      let left = dataItem.get("left", point2.x);
      let right = dataItem.get("right", point2.x);
      let top = dataItem.get("top", point2.y);
      let bottom = dataItem.get("bottom", point2.y);
      let x2 = 0;
      let y2 = 0;
      let w = right - left;
      let h = bottom - top;
      if (this._shouldShowBullet(positionX, positionY)) {
        sprite.setPrivate("visible", !bullet.getPrivate("hidden"));
        let field = bullet.get("field");
        const baseAxis = this.get("baseAxis");
        const xAxis2 = this.get("xAxis");
        const yAxis2 = this.get("yAxis");
        if (field != void 0) {
          let realField;
          if (baseAxis == xAxis2) {
            if (field == "value") {
              realField = this._yField;
            } else if (field == "open") {
              realField = this._yOpenField;
            } else if (field == "high") {
              realField = this._yHighField;
            } else if (field == "low") {
              realField = this._yLowField;
            }
            if (realField) {
              positionY = yAxis2.getDataItemPositionY(dataItem, realField, 0, this.get("vcy", 1));
              point2 = yAxis2.get("renderer").positionToPoint(positionY);
              y2 = point2.y;
              x2 = left + w * locationX;
            }
          } else {
            if (field == "value") {
              realField = this._xField;
            } else if (field == "open") {
              realField = this._xOpenField;
            } else if (field == "high") {
              realField = this._xHighField;
            } else if (field == "low") {
              realField = this._xLowField;
            }
            if (realField) {
              positionX = xAxis2.getDataItemPositionX(dataItem, realField, 0, this.get("vcx", 1));
              point2 = xAxis2.get("renderer").positionToPoint(positionX);
              x2 = point2.x;
              y2 = bottom - h * locationY;
            }
          }
        } else {
          x2 = left + w * locationX;
          y2 = bottom - h * locationY;
        }
        const stacked = bullet.get("stacked");
        if (stacked) {
          const chart = this.chart;
          if (baseAxis == xAxis2) {
            let previousBullet = this._bullets[positionX + "_" + positionY];
            if (previousBullet) {
              let previousBounds = previousBullet.bounds();
              let bounds = sprite.localBounds();
              let yo = y2;
              y2 = previousBounds.top;
              if (stacked == "down") {
                y2 = previousBounds.bottom - bounds.top;
              } else if (stacked == "auto") {
                if (chart) {
                  if (yo < chart.plotContainer.height() / 2) {
                    y2 = previousBounds.bottom - bounds.top;
                  } else {
                    y2 += bounds.bottom;
                  }
                }
              } else {
                y2 += bounds.bottom;
              }
            }
            this._bullets[positionX + "_" + positionY] = sprite;
          } else {
            let previousBullet = this._bullets[positionX + "_" + positionY];
            if (previousBullet) {
              let previousBounds = previousBullet.bounds();
              let bounds = sprite.localBounds();
              let xo = x2;
              x2 = previousBounds.right;
              if (stacked == "down") {
                x2 = previousBounds.left - bounds.right;
              } else if (stacked == "auto") {
                if (chart) {
                  if (xo < chart.plotContainer.width() / 2) {
                    x2 = previousBounds.left - bounds.right;
                  } else {
                    x2 -= bounds.left;
                  }
                }
              } else {
                x2 -= bounds.left;
              }
            }
            this._bullets[positionX + "_" + positionY] = sprite;
          }
        }
        if (sprite.isType("Label")) {
          sprite.setPrivate("maxWidth", Math.abs(w));
          sprite.setPrivate("maxHeight", Math.abs(h));
        }
        sprite.setAll({ x: x2, y: y2 });
      } else {
        sprite.setPrivate("visible", false);
      }
    }
  }
  _shouldShowBullet(_positionX, _positionY) {
    return this._showBullets;
  }
  /**
   * @ignore
   */
  setDataSet(id) {
    if (this._dataSets[id]) {
      this._handleDataSetChange();
      this._dataItems = this._dataSets[id];
      this._markDataSetDirty();
      this._dataSetId = id;
      const type4 = "datasetchanged";
      if (this.events.isEnabled(type4)) {
        this.events.dispatch(type4, { type: type4, target: this, id });
      }
    }
  }
  /**
   * @ignore
   */
  resetGrouping() {
    each2(this._dataSets, (_key, dataSet) => {
      if (dataSet != this._mainDataItems) {
        each(dataSet, (dataItem) => {
          this.disposeDataItem(dataItem);
        });
      }
    });
    this._dataSets = {};
    this._dataItems = this.mainDataItems;
  }
  _handleDataSetChange() {
    each(this._dataItems, (dataItem) => {
      let bullets = dataItem.bullets;
      if (bullets) {
        each(bullets, (bullet) => {
          if (bullet) {
            let sprite = bullet.get("sprite");
            if (sprite) {
              sprite.setPrivate("visible", false);
            }
          }
        });
      }
    });
    this._selectionProcessed = false;
  }
  /**
   * Shows hidden series.
   *
   * @param   duration  Duration of animation in milliseconds
   * @return            Animation promise
   */
  show(duration) {
    const _super = Object.create(null, {
      show: { get: () => super.show }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._fixVC();
      let promises = [];
      promises.push(_super.show.call(this, duration).then(() => {
        this._isShowing = false;
        let xAxis = this.get("xAxis");
        let yAxis = this.get("yAxis");
        let baseAxis = this.get("baseAxis");
        if (yAxis !== baseAxis) {
          yAxis.markDirtySelectionExtremes();
        }
        if (xAxis !== baseAxis) {
          xAxis.markDirtySelectionExtremes();
        }
      }));
      promises.push(this.bulletsContainer.show(duration));
      promises.push(this._sequencedShowHide(true, duration));
      yield Promise.all(promises);
    });
  }
  /**
   * Hides series.
   *
   * @param   duration  Duration of animation in milliseconds
   * @return            Animation promise
   */
  hide(duration) {
    const _super = Object.create(null, {
      hide: { get: () => super.hide }
    });
    return __awaiter(this, void 0, void 0, function* () {
      this._fixVC();
      let promises = [];
      promises.push(_super.hide.call(this, duration).then(() => {
        this._isHiding = false;
      }));
      promises.push(this.bulletsContainer.hide(duration));
      promises.push(this._sequencedShowHide(false, duration));
      yield Promise.all(promises);
    });
  }
  /**
   * Shows series's data item.
   *
   * @param   dataItem  Data item
   * @param   duration  Animation duration in milliseconds
   * @return            Promise
   */
  showDataItem(dataItem, duration) {
    const _super = Object.create(null, {
      showDataItem: { get: () => super.showDataItem }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const promises = [_super.showDataItem.call(this, dataItem, duration)];
      if (!isNumber(duration)) {
        duration = this.get("stateAnimationDuration", 0);
      }
      const easing = this.get("stateAnimationEasing");
      each(this._valueFields, (key) => {
        promises.push(dataItem.animate({ key: key + "Working", to: dataItem.get(key), duration, easing }).waitForStop());
      });
      yield Promise.all(promises);
    });
  }
  /**
   * Hides series's data item.
   *
   * @param   dataItem  Data item
   * @param   duration  Animation duration in milliseconds
   * @return            Promise
   */
  hideDataItem(dataItem, duration) {
    const _super = Object.create(null, {
      hideDataItem: { get: () => super.hideDataItem }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const promises = [_super.hideDataItem.call(this, dataItem, duration)];
      const hiddenState = this.states.create("hidden", {});
      if (!isNumber(duration)) {
        duration = hiddenState.get("stateAnimationDuration", this.get("stateAnimationDuration", 0));
      }
      const easing = hiddenState.get("stateAnimationEasing", this.get("stateAnimationEasing"));
      const xAxis = this.get("xAxis");
      const yAxis = this.get("yAxis");
      const baseAxis = this.get("baseAxis");
      const stacked = this.get("stacked");
      if (baseAxis === xAxis || !baseAxis) {
        each(this._valueYFields, (key) => {
          let min3 = yAxis.getPrivate("min");
          let baseValue = yAxis.baseValue();
          if (isNumber(min3) && min3 > baseValue) {
            baseValue = min3;
          }
          if (stacked) {
            baseValue = 0;
          }
          let value = dataItem.get(key);
          if (value != null) {
            promises.push(dataItem.animate({ key: key + "Working", to: baseValue, duration, easing }).waitForStop());
          }
        });
      }
      if (baseAxis === yAxis || !baseAxis) {
        let min3 = xAxis.getPrivate("min");
        let baseValue = xAxis.baseValue();
        if (isNumber(min3) && min3 > baseValue) {
          baseValue = min3;
        }
        if (stacked) {
          baseValue = 0;
        }
        each(this._valueXFields, (key) => {
          let value = dataItem.get(key);
          if (value != null) {
            promises.push(dataItem.animate({ key: key + "Working", to: baseValue, duration, easing }).waitForStop());
          }
        });
      }
      yield Promise.all(promises);
    });
  }
  _markDirtyStack() {
    this._stackDirty = true;
    this.markDirty();
    this._markStakedDirtyStack();
  }
  _markStakedDirtyStack() {
    const stackedSeries = this._stackedSeries;
    if (stackedSeries) {
      each2(stackedSeries, (_key, value) => {
        if (!value._stackDirty) {
          value._markDirtyStack();
        }
      });
    }
  }
  _afterChanged() {
    super._afterChanged();
    if (this._skipped) {
      this._markDirtyAxes();
      this._skipped = false;
    }
  }
  /**
   * Shows a tooltip for specific data item.
   *
   * @param  dataItem  Data item
   */
  showDataItemTooltip(dataItem) {
    if (!this.getPrivate("doNotUpdateLegend")) {
      this.updateLegendMarker(dataItem);
      this.updateLegendValue(dataItem);
    }
    const tooltip = this.get("tooltip");
    if (tooltip) {
      if (!this.isHidden()) {
        tooltip._setDataItem(dataItem);
        if (dataItem) {
          let locationX = this.get("locationX", 0);
          let locationY = this.get("locationY", 1);
          let itemLocationX = dataItem.get("locationX", locationX);
          let itemLocationY = dataItem.get("locationY", locationY);
          const xAxis = this.get("xAxis");
          const yAxis = this.get("yAxis");
          const vcx = this.get("vcx", 1);
          const vcy = this.get("vcy", 1);
          const xPos = xAxis.getDataItemPositionX(dataItem, this._tooltipFieldX, this._aLocationX0 + (this._aLocationX1 - this._aLocationX0) * itemLocationX, vcx);
          const yPos = yAxis.getDataItemPositionY(dataItem, this._tooltipFieldY, this._aLocationY0 + (this._aLocationY1 - this._aLocationY0) * itemLocationY, vcy);
          const point2 = this.getPoint(xPos, yPos);
          let show = true;
          each(this._valueFields, (field) => {
            if (dataItem.get(field) == null) {
              show = false;
            }
          });
          if (show) {
            const chart = this.chart;
            if (chart && chart.inPlot(point2)) {
              tooltip.label.text.markDirtyText();
              tooltip.set("tooltipTarget", this._getTooltipTarget(dataItem));
              tooltip.set("pointTo", this._display.toGlobal({ x: point2.x, y: point2.y }));
            } else {
              tooltip._setDataItem(void 0);
            }
          } else {
            tooltip._setDataItem(void 0);
          }
        }
      } else {
        this.hideTooltip();
      }
    }
  }
  hideTooltip() {
    const tooltip = this.get("tooltip");
    if (tooltip) {
      tooltip.set("tooltipTarget", this);
    }
    return super.hideTooltip();
  }
  _getTooltipTarget(dataItem) {
    if (this.get("seriesTooltipTarget") == "bullet") {
      const bullets = dataItem.bullets;
      if (bullets && bullets.length > 0) {
        const bullet = bullets[0];
        const sprite = bullet.get("sprite");
        if (sprite) {
          return sprite;
        }
      }
    }
    return this;
  }
  /**
   * @ignore
   */
  updateLegendValue(dataItem) {
    const legendDataItem = this.get("legendDataItem");
    if (legendDataItem) {
      const label = legendDataItem.get("label");
      if (label) {
        let txt = "";
        if (dataItem) {
          label._setDataItem(dataItem);
          txt = this.get("legendLabelText", label.get("text", this.get("name", "")));
        } else {
          label._setDataItem(this._emptyDataItem);
          txt = this.get("legendRangeLabelText", this.get("legendLabelText", label.get("text", this.get("name", ""))));
        }
        label.set("text", txt);
      }
      const valueLabel = legendDataItem.get("valueLabel");
      if (valueLabel) {
        let txt = "";
        if (dataItem) {
          valueLabel._setDataItem(dataItem);
          txt = this.get("legendValueText", valueLabel.get("text", ""));
        } else {
          valueLabel._setDataItem(this._emptyDataItem);
          txt = this.get("legendRangeValueText", valueLabel.get("text", ""));
        }
        valueLabel.set("text", txt);
      }
    }
  }
  _getItemReaderLabel() {
    let text = "X: {" + this._xField;
    if (this.get("xAxis").isType("DateAxis")) {
      text += ".formatDate()";
    }
    text += "}; Y: {" + this._yField;
    if (this.get("yAxis").isType("DateAxis")) {
      text += ".formatDate()";
    }
    text += "}";
    return text;
  }
  /**
   * @ignore
   */
  getPoint(positionX, positionY) {
    let x2 = this.get("xAxis").get("renderer").positionToCoordinate(positionX);
    let y2 = this.get("yAxis").get("renderer").positionToCoordinate(positionY);
    let max3 = 999999999;
    if (y2 < -max3) {
      y2 = -max3;
    }
    if (y2 > max3) {
      y2 = max3;
    }
    if (x2 < -max3) {
      x2 = -max3;
    }
    if (x2 > max3) {
      x2 = max3;
    }
    return { x: x2, y: y2 };
  }
  _shouldInclude(_position) {
    return true;
  }
  /**
   * @ignore
   */
  handleCursorHide() {
    this.hideTooltip();
    this.updateLegendValue(void 0);
    this.updateLegendMarker(void 0);
  }
  _afterDataChange() {
    super._afterDataChange();
    this.get("xAxis")._markDirtyKey("start");
    this.get("yAxis")._markDirtyKey("start");
    this.resetExtremes();
  }
  /**
   * Resets cached axis scale values.
   */
  resetExtremes() {
    this.setPrivate("selectionMinX", void 0);
    this.setPrivate("selectionMaxX", void 0);
    this.setPrivate("selectionMinY", void 0);
    this.setPrivate("selectionMaxY", void 0);
    this.setPrivate("minX", void 0);
    this.setPrivate("minY", void 0);
    this.setPrivate("maxX", void 0);
    this.setPrivate("maxY", void 0);
  }
  /**
   * Creates and returns an axis range object.
   *
   * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-ranges/} for more info
   * @param   axisDataItem  Axis data item
   * @return                Axis range
   */
  createAxisRange(axisDataItem) {
    return this.axisRanges.push({
      axisDataItem
    });
  }
  /**
   * A list of series's main (ungrouped) data items.
   *
   * @return  Data items
   */
  get mainDataItems() {
    return this._mainDataItems;
  }
};
Object.defineProperty(XYSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "XYSeries"
});
Object.defineProperty(XYSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Series.classNames.concat([XYSeries.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/series/BaseColumnSeries.js
var BaseColumnSeries = class _BaseColumnSeries extends XYSeries {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_ph", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_pw", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
  }
  _makeGraphics(listTemplate, dataItem) {
    return this.makeColumn(dataItem, listTemplate);
  }
  _makeFieldNames() {
    super._makeFieldNames();
    const xAxis = this.get("xAxis");
    const yAxis = this.get("yAxis");
    const categoryAxis = "CategoryAxis";
    const valueAxis = "ValueAxis";
    if (xAxis.isType(categoryAxis)) {
      if (!this.get("openCategoryXField")) {
        this._xOpenField = this._xField;
      }
    }
    if (xAxis.isType(valueAxis)) {
      if (!this.get("openValueXField")) {
        this._xOpenField = this._xField;
      }
    }
    if (yAxis.isType(categoryAxis)) {
      if (!this.get("openCategoryYField")) {
        this._yOpenField = this._yField;
      }
    }
    if (yAxis.isType(valueAxis)) {
      if (!this.get("openValueYField")) {
        this._yOpenField = this._yField;
      }
    }
  }
  _prepareChildren() {
    super._prepareChildren();
    const xAxis = this.get("xAxis");
    const yAxis = this.get("yAxis");
    const len = this.dataItems.length;
    const startIndex = Math.max(0, this.startIndex() - 2);
    const endIndex = Math.min(this.endIndex() + 2, len - 1);
    if (xAxis.inited && yAxis.inited) {
      for (let i = startIndex; i <= endIndex; i++) {
        let dataItem = this.dataItems[i];
        this._createGraphics(dataItem);
      }
    }
  }
  _updateChildren() {
    const chart = this.chart;
    if (chart) {
      this._ph = chart.plotContainer.height();
      this._pw = chart.plotContainer.width();
    }
    const xAxis = this.get("xAxis");
    const yAxis = this.get("yAxis");
    const baseAxis = this.get("baseAxis");
    const columnsTemplate = this.columns.template;
    if (this.isDirty("fill")) {
      if (columnsTemplate.get("fill") == null) {
        columnsTemplate.set("fill", this.get("fill"));
      }
    }
    if (this.isDirty("stroke")) {
      if (columnsTemplate.get("stroke") == null) {
        columnsTemplate.set("stroke", this.get("stroke"));
      }
    }
    let index2 = 0;
    let clusterCount = 0;
    let i = 0;
    each(baseAxis.series, (series) => {
      if (series instanceof _BaseColumnSeries) {
        const stacked = series.get("stacked");
        if (stacked && i == 0) {
          clusterCount++;
        }
        if (!stacked && series.get("clustered")) {
          clusterCount++;
        }
      }
      if (series === this) {
        index2 = clusterCount - 1;
      }
      i++;
    });
    if (!this.get("clustered")) {
      index2 = 0;
      clusterCount = 1;
    }
    if (clusterCount === 0) {
      clusterCount = 1;
      index2 = 0;
    }
    const xRenderer = xAxis.get("renderer");
    const yRenderer = yAxis.get("renderer");
    const cellStartLocation = "cellStartLocation";
    const cellEndLocation = "cellEndLocation";
    const cellLocationX0 = xRenderer.get(cellStartLocation, 0);
    const cellLocationX1 = xRenderer.get(cellEndLocation, 1);
    const cellLocationY0 = yRenderer.get(cellStartLocation, 0);
    const cellLocationY1 = yRenderer.get(cellEndLocation, 1);
    this._aLocationX0 = cellLocationX0 + index2 / clusterCount * (cellLocationX1 - cellLocationX0);
    this._aLocationX1 = cellLocationX0 + (index2 + 1) / clusterCount * (cellLocationX1 - cellLocationX0);
    ;
    this._aLocationY0 = cellLocationY0 + index2 / clusterCount * (cellLocationY1 - cellLocationY0);
    this._aLocationY1 = cellLocationY0 + (index2 + 1) / clusterCount * (cellLocationY1 - cellLocationY0);
    if (xAxis.inited && yAxis.inited) {
      if (this._axesDirty || this._valuesDirty || this._stackDirty || this.isDirty("vcx") || this.isDirty("vcy") || this._sizeDirty) {
        const len = this.dataItems.length;
        let startIndex = Math.max(0, this.startIndex() - 2);
        let endIndex = Math.min(this.endIndex() + 2, len - 1);
        for (let i2 = 0; i2 < startIndex; i2++) {
          this._toggleColumn(this.dataItems[i2], false);
        }
        let previous = this.dataItems[startIndex];
        for (let i2 = startIndex; i2 <= endIndex; i2++) {
          let dataItem = this.dataItems[i2];
          if (dataItem.get("valueX") != null && dataItem.get("valueY") != null) {
            previous = dataItem;
            if (i2 > 0 && startIndex > 0) {
              for (let j = i2 - 1; j >= 0; j--) {
                let dataItem2 = this.dataItems[j];
                if (dataItem2.get("valueX") != null && dataItem2.get("valueY") != null) {
                  previous = dataItem2;
                  break;
                }
              }
            }
            break;
          } else {
            this._toggleColumn(dataItem, false);
          }
        }
        for (let i2 = startIndex; i2 <= endIndex; i2++) {
          let dataItem = this.dataItems[i2];
          this._updateGraphics(dataItem, previous);
          if (dataItem.get("valueX") != null && dataItem.get("valueY") != null) {
            previous = dataItem;
          }
        }
        for (let i2 = endIndex + 1; i2 < len; i2++) {
          this._toggleColumn(this.dataItems[i2], false);
        }
      }
    } else {
      this._skipped = true;
    }
    this.updateLegendMarker(this.get("tooltipDataItem"));
    super._updateChildren();
  }
  _createGraphics(dataItem) {
    let graphics = dataItem.get("graphics");
    if (!graphics) {
      graphics = this._makeGraphics(this.columns, dataItem);
      dataItem.set("graphics", graphics);
      graphics._setDataItem(dataItem);
      const legendDataItem = dataItem.get("legendDataItem");
      if (legendDataItem) {
        const markerRectangle = legendDataItem.get("markerRectangle");
        if (markerRectangle) {
          const ds = markerRectangle.states.lookup("default");
          each(visualSettings, (setting) => {
            const value = graphics.get(setting, this.get(setting));
            markerRectangle.set(setting, value);
            ds.set(setting, value);
          });
        }
      }
      let graphicsArray = dataItem.get("rangeGraphics");
      if (graphicsArray) {
        each(graphicsArray, (graphics2) => {
          graphics2.dispose();
        });
      }
      graphicsArray = [];
      dataItem.setRaw("rangeGraphics", graphicsArray);
      this.axisRanges.each((axisRange) => {
        const container = axisRange.container;
        const rangeGraphics = this._makeGraphics(axisRange.columns, dataItem);
        if (graphicsArray) {
          graphicsArray.push(rangeGraphics);
        }
        rangeGraphics.setPrivate("list", axisRange.columns);
        container.children.push(rangeGraphics);
      });
    }
  }
  createAxisRange(axisDataItem) {
    each(this.dataItems, (dataItem) => {
      const graphics = dataItem.get("graphics");
      if (graphics) {
        graphics.dispose();
        dataItem.set("graphics", void 0);
      }
    });
    return super.createAxisRange(axisDataItem);
  }
  _updateGraphics(dataItem, previousDataItem) {
    let graphics = dataItem.get("graphics");
    const xField = this._xField;
    const yField = this._yField;
    const valueX = dataItem.get(xField);
    const valueY = dataItem.get(yField);
    if (valueX != null && valueY != null) {
      const xOpenField = this._xOpenField;
      const yOpenField = this._yOpenField;
      const locationX = this.get("locationX", dataItem.get("locationX", 0.5));
      const locationY = this.get("locationY", dataItem.get("locationY", 0.5));
      const openLocationX = this.get("openLocationX", dataItem.get("openLocationX", locationX));
      const openLocationY = this.get("openLocationY", dataItem.get("openLocationY", locationY));
      const width = graphics.get("width");
      const height = graphics.get("height");
      const stacked = this.get("stacked");
      const xAxis = this.get("xAxis");
      const yAxis = this.get("yAxis");
      const baseAxis = this.get("baseAxis");
      const xStart = xAxis.get("start");
      const xEnd = xAxis.get("end");
      const yStart = yAxis.get("start");
      const yEnd = yAxis.get("end");
      let l;
      let r;
      let t;
      let b;
      let vcy = this.get("vcy", 1);
      let vcx = this.get("vcx", 1);
      let fitW = false;
      let fitH = false;
      if (yAxis.isType("CategoryAxis") && xAxis.isType("CategoryAxis")) {
        let startLocation = this._aLocationX0 + openLocationX - 0.5;
        let endLocation = this._aLocationX1 + locationX - 0.5;
        if (width instanceof Percent) {
          let offset2 = (endLocation - startLocation) * (1 - width.value) / 2;
          startLocation += offset2;
          endLocation -= offset2;
        }
        l = xAxis.getDataItemPositionX(dataItem, xOpenField, startLocation, vcx);
        r = xAxis.getDataItemPositionX(dataItem, xField, endLocation, vcx);
        startLocation = this._aLocationY0 + openLocationY - 0.5;
        endLocation = this._aLocationY1 + locationY - 0.5;
        if (height instanceof Percent) {
          let offset2 = (endLocation - startLocation) * (1 - height.value) / 2;
          startLocation += offset2;
          endLocation -= offset2;
        }
        t = yAxis.getDataItemPositionY(dataItem, yOpenField, startLocation, vcy);
        b = yAxis.getDataItemPositionY(dataItem, yField, endLocation, vcy);
        dataItem.setRaw("point", { x: l + (r - l) / 2, y: t + (b - t) / 2 });
      } else if (xAxis === baseAxis) {
        let startLocation = this._aLocationX0 + openLocationX - 0.5;
        let endLocation = this._aLocationX1 + locationX - 0.5;
        if (width instanceof Percent) {
          let offset2 = (endLocation - startLocation) * (1 - width.value) / 2;
          startLocation += offset2;
          endLocation -= offset2;
        }
        l = xAxis.getDataItemPositionX(dataItem, xOpenField, startLocation, vcx);
        r = xAxis.getDataItemPositionX(dataItem, xField, endLocation, vcx);
        t = yAxis.getDataItemPositionY(dataItem, yField, locationY, vcy);
        if (this._yOpenField !== this._yField) {
          b = yAxis.getDataItemPositionY(dataItem, yOpenField, openLocationY, vcy);
        } else {
          if (stacked) {
            let stackToItemY = dataItem.get("stackToItemY");
            if (stackToItemY) {
              b = yAxis.getDataItemPositionY(stackToItemY, yField, openLocationY, stackToItemY.component.get("vcy"));
            } else {
              b = yAxis.basePosition();
            }
          } else {
            b = yAxis.basePosition();
          }
        }
        dataItem.setRaw("point", { x: l + (r - l) / 2, y: t });
        fitH = true;
      } else if (yAxis === baseAxis) {
        let startLocation = this._aLocationY0 + openLocationY - 0.5;
        let endLocation = this._aLocationY1 + locationY - 0.5;
        if (height instanceof Percent) {
          let offset2 = (endLocation - startLocation) * (1 - height.value) / 2;
          startLocation += offset2;
          endLocation -= offset2;
        }
        t = yAxis.getDataItemPositionY(dataItem, yOpenField, startLocation, vcy);
        b = yAxis.getDataItemPositionY(dataItem, yField, endLocation, vcy);
        r = xAxis.getDataItemPositionX(dataItem, xField, locationX, vcx);
        if (this._xOpenField !== this._xField) {
          l = xAxis.getDataItemPositionX(dataItem, xOpenField, openLocationX, vcx);
        } else {
          if (stacked) {
            let stackToItemX = dataItem.get("stackToItemX");
            if (stackToItemX) {
              l = xAxis.getDataItemPositionX(stackToItemX, xField, openLocationX, stackToItemX.component.get("vcx"));
            } else {
              l = xAxis.basePosition();
            }
          } else {
            l = xAxis.basePosition();
          }
        }
        fitW = true;
        dataItem.setRaw("point", { x: r, y: t + (b - t) / 2 });
      }
      this._updateSeriesGraphics(dataItem, graphics, l, r, t, b, fitW, fitH);
      if (l < xStart && r < xStart || l > xEnd && r > xEnd || t < yStart && b <= yStart || t >= yEnd && b > yEnd || isNaN2(l) || isNaN2(t)) {
        this._toggleColumn(dataItem, false);
      } else {
        this._toggleColumn(dataItem, true);
      }
      let rangeGraphics = dataItem.get("rangeGraphics");
      if (rangeGraphics) {
        each(rangeGraphics, (graphics2) => {
          this._updateSeriesGraphics(dataItem, graphics2, l, r, t, b, fitW, fitH);
        });
      }
      this._applyGraphicsStates(dataItem, previousDataItem);
    }
  }
  _updateSeriesGraphics(dataItem, graphics, l, r, t, b, fitW, fitH) {
    const width = graphics.get("width");
    const height = graphics.get("height");
    const maxWidth = graphics.get("maxWidth");
    const maxHeight = graphics.get("maxHeight");
    const ptl = this.getPoint(l, t);
    const pbr = this.getPoint(r, b);
    const tooltipPoint = dataItem.get("point");
    if (tooltipPoint) {
      const point2 = this.getPoint(tooltipPoint.x, tooltipPoint.y);
      tooltipPoint.x = point2.x + this._x;
      tooltipPoint.y = point2.y + this._y;
    }
    l = ptl.x;
    r = pbr.x;
    t = ptl.y;
    b = pbr.y;
    if (isNumber(width)) {
      const offset2 = (r - l - width) / 2;
      l += offset2;
      r -= offset2;
    }
    if (isNumber(maxWidth) && maxWidth < Math.abs(r - l)) {
      const offset2 = (r - l - maxWidth) / 2;
      l += offset2;
      r -= offset2;
    }
    if (isNumber(height)) {
      const offset2 = (b - t - height) / 2;
      t += offset2;
      b -= offset2;
    }
    if (isNumber(maxHeight) && maxHeight < Math.abs(b - t)) {
      const offset2 = (b - t - maxHeight) / 2;
      t += offset2;
      b -= offset2;
    }
    if (this.get("adjustBulletPosition")) {
      if (fitW) {
        r = Math.min(Math.max(0, r), this._pw);
        l = Math.min(Math.max(0, l), this._pw);
      }
      if (fitH) {
        t = Math.min(Math.max(0, t), this._ph);
        b = Math.min(Math.max(0, b), this._ph);
      }
    }
    dataItem.setRaw("left", l);
    dataItem.setRaw("right", r);
    dataItem.setRaw("top", t);
    dataItem.setRaw("bottom", b);
    graphics.setPrivate("width", r - l);
    graphics.setPrivate("height", b - t);
    graphics.set("x", l);
    graphics.set("y", b - (b - t));
  }
  _handleDataSetChange() {
    super._handleDataSetChange();
    each(this._dataItems, (dataItem) => {
      this._toggleColumn(dataItem, false);
    });
  }
  _applyGraphicsStates(dataItem, previousDataItem) {
    const graphics = dataItem.get("graphics");
    const dropFromOpen = graphics.states.lookup("dropFromOpen");
    const riseFromOpen = graphics.states.lookup("riseFromOpen");
    const dropFromPrevious = graphics.states.lookup("dropFromPrevious");
    const riseFromPrevious = graphics.states.lookup("riseFromPrevious");
    if (dropFromOpen || dropFromPrevious || riseFromOpen || riseFromPrevious) {
      const xAxis = this.get("xAxis");
      const yAxis = this.get("yAxis");
      const baseAxis = this.get("baseAxis");
      let open3;
      let close;
      let previousClose;
      if (baseAxis === xAxis && yAxis.isType("ValueAxis")) {
        open3 = dataItem.get(this._yOpenField);
        close = dataItem.get(this._yField);
        previousClose = previousDataItem.get(this._yField);
      } else if (baseAxis === yAxis && xAxis.isType("ValueAxis")) {
        open3 = dataItem.get(this._xOpenField);
        close = dataItem.get(this._xField);
        previousClose = previousDataItem.get(this._xField);
      }
      if (isNumber(open3) && isNumber(close)) {
        if (close < open3) {
          if (dropFromOpen) {
            dropFromOpen.apply();
          }
        } else {
          if (riseFromOpen) {
            riseFromOpen.apply();
          }
        }
        if (isNumber(previousClose)) {
          if (close < previousClose) {
            if (dropFromPrevious) {
              dropFromPrevious.apply();
            }
          } else {
            if (riseFromPrevious) {
              riseFromPrevious.apply();
            }
          }
        }
      }
    }
  }
  /**
   * @ignore
   */
  disposeDataItem(dataItem) {
    super.disposeDataItem(dataItem);
    const graphics = dataItem.get("graphics");
    if (graphics) {
      this.columns.removeValue(graphics);
      graphics.dispose();
    }
    const rangeGraphics = dataItem.get("rangeGraphics");
    if (rangeGraphics) {
      each(rangeGraphics, (graphics2) => {
        const list = graphics2.getPrivate("list");
        if (list) {
          list.removeValue(graphics2);
        }
        graphics2.dispose();
      });
    }
  }
  /**
   * Hides series's data item.
   *
   * @param   dataItem  Data item
   * @param   duration  Animation duration in milliseconds
   * @return            Promise
   */
  hideDataItem(dataItem, duration) {
    const _super = Object.create(null, {
      hideDataItem: { get: () => super.hideDataItem }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const promises = [_super.hideDataItem.call(this, dataItem, duration)];
      const graphics = dataItem.get("graphics");
      if (graphics) {
        promises.push(graphics.hide(duration));
      }
      const rangeGraphics = dataItem.get("rangeGraphics");
      if (rangeGraphics) {
        each(rangeGraphics, (graphics2) => {
          promises.push(graphics2.hide(duration));
        });
      }
      yield Promise.all(promises);
    });
  }
  _toggleColumn(dataItem, visible) {
    const graphics = dataItem.get("graphics");
    if (graphics) {
      graphics.setPrivate("visible", visible);
    }
    const rangeGraphics = dataItem.get("rangeGraphics");
    if (rangeGraphics) {
      each(rangeGraphics, (graphics2) => {
        graphics2.setPrivate("visible", visible);
      });
    }
    const bullets = dataItem.bullets;
    if (bullets) {
      each(bullets, (bullet) => {
        bullet.setPrivate("hidden", !visible);
      });
    }
  }
  /**
   * Shows series's data item.
   *
   * @param   dataItem  Data item
   * @param   duration  Animation duration in milliseconds
   * @return            Promise
   */
  showDataItem(dataItem, duration) {
    const _super = Object.create(null, {
      showDataItem: { get: () => super.showDataItem }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const promises = [_super.showDataItem.call(this, dataItem, duration)];
      const graphics = dataItem.get("graphics");
      if (graphics) {
        promises.push(graphics.show(duration));
      }
      const rangeGraphics = dataItem.get("rangeGraphics");
      if (rangeGraphics) {
        each(rangeGraphics, (graphics2) => {
          promises.push(graphics2.show(duration));
        });
      }
      yield Promise.all(promises);
    });
  }
  /**
   * @ignore
   */
  updateLegendMarker(dataItem) {
    let legendDataItem = this.get("legendDataItem");
    if (this.get("useLastColorForLegendMarker")) {
      if (!dataItem) {
        const lastDataItem = this.dataItems[this.endIndex() - 1];
        if (lastDataItem) {
          dataItem = lastDataItem;
        }
      }
    }
    if (legendDataItem) {
      let graphics = this.columns.template;
      if (dataItem) {
        let column2 = dataItem.get("graphics");
        if (column2) {
          graphics = column2;
        }
      }
      const markerRectangle = legendDataItem.get("markerRectangle");
      if (markerRectangle) {
        if (!legendDataItem.get("itemContainer").get("disabled")) {
          const ds = markerRectangle.states.lookup("default");
          each(visualSettings, (setting) => {
            const value = graphics.get(setting, this.get(setting));
            markerRectangle.set(setting, value);
            ds.set(setting, value);
          });
        }
      }
    }
  }
  _getTooltipTarget(dataItem) {
    if (this.get("seriesTooltipTarget") == "bullet") {
      return super._getTooltipTarget(dataItem);
    }
    let column2 = dataItem.get("graphics");
    if (column2) {
      return column2;
    }
    return this;
  }
};
Object.defineProperty(BaseColumnSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "BaseColumnSeries"
});
Object.defineProperty(BaseColumnSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: XYSeries.classNames.concat([BaseColumnSeries.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/Axis.js
var Axis = class extends Component5 {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_series", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_isPanning", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "minorDataItems", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "labelsContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Container.new(this._root, {}))
    });
    Object.defineProperty(this, "gridContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Container.new(this._root, { width: p100, height: p100 })
    });
    Object.defineProperty(this, "topGridContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Container.new(this._root, { width: p100, height: p100 })
    });
    Object.defineProperty(this, "bulletsContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Container.new(this._root, { isMeasured: false, width: p100, height: p100, position: "absolute" }))
    });
    Object.defineProperty(this, "chart", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_rangesDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_panStart", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_panEnd", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "_sAnimation", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_eAnimation", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_skipSync", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "axisRanges", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new List3()
    });
    Object.defineProperty(this, "_seriesAxisRanges", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "ghostLabel", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_cursorPosition", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: -1
    });
    Object.defineProperty(this, "_snapToSeries", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_seriesValuesDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "axisHeader", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Container.new(this._root, {
        themeTags: ["axis", "header"],
        position: "absolute",
        background: Rectangle.new(this._root, {
          themeTags: ["header", "background"],
          fill: this._root.interfaceColors.get("background")
        })
      }))
    });
    Object.defineProperty(this, "_bullets", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
  }
  _dispose() {
    this.gridContainer.dispose();
    this.topGridContainer.dispose();
    this.bulletsContainer.dispose();
    this.labelsContainer.dispose();
    this.axisHeader.dispose();
    super._dispose();
  }
  _afterNew() {
    super._afterNew();
    this.setPrivate("updateScrollbar", true);
    this._disposers.push(this.axisRanges.events.onAll((change) => {
      if (change.type === "clear") {
        each(change.oldValues, (dataItem) => {
          this.disposeDataItem(dataItem);
        });
      } else if (change.type === "push") {
        this._processAxisRange(change.newValue, ["range"]);
      } else if (change.type === "setIndex") {
        this._processAxisRange(change.newValue, ["range"]);
      } else if (change.type === "insertIndex") {
        this._processAxisRange(change.newValue, ["range"]);
      } else if (change.type === "removeIndex") {
        this.disposeDataItem(change.oldValue);
      } else if (change.type === "moveIndex") {
        this._processAxisRange(change.value, ["range"]);
      } else {
        throw new Error("Unknown IStreamEvent type");
      }
    }));
    const renderer = this.get("renderer");
    if (renderer) {
      renderer.axis = this;
      renderer.processAxis();
    }
    this.children.push(renderer);
    this.ghostLabel = renderer.makeLabel(new DataItem(this, void 0, {}), []);
    this.ghostLabel.adapters.disable("text");
    this.ghostLabel.setAll({ opacity: 0, tooltipText: void 0, tooltipHTML: void 0, interactive: false });
    this.ghostLabel.events.disable();
  }
  _updateFinals(_start, _end) {
  }
  /**
   * Zooms the axis to relative locations.
   *
   * Both `start` and `end` are relative: 0 means start of the axis, 1 - end.
   *
   * @param   start     Relative start
   * @param   end       Relative end
   * @param   duration  Duration of the zoom animation in milliseconds
   * @return            Zoom animation
   */
  zoom(start, end, duration, priority) {
    if (this.get("zoomable", true)) {
      this._updateFinals(start, end);
      if (this.get("start") !== start || this.get("end") != end) {
        let sAnimation = this._sAnimation;
        let eAnimation = this._eAnimation;
        let maxDeviation = this.get("maxDeviation", 0.5) * Math.min(1, end - start);
        if (start < -maxDeviation) {
          start = -maxDeviation;
        }
        if (end > 1 + maxDeviation) {
          end = 1 + maxDeviation;
        }
        if (start > end) {
          [start, end] = [end, start];
        }
        if (!isNumber(duration)) {
          duration = this.get("interpolationDuration", 0);
        }
        if (!priority) {
          priority = "end";
        }
        let maxZoomFactor = this.getPrivate("maxZoomFactor", this.get("maxZoomFactor", 100));
        let maxZoomFactorReal = maxZoomFactor;
        if (end === 1 && start !== 0) {
          if (start < this.get("start")) {
            priority = "start";
          } else {
            priority = "end";
          }
        }
        if (start === 0 && end !== 1) {
          if (end > this.get("end")) {
            priority = "end";
          } else {
            priority = "start";
          }
        }
        let minZoomCount = this.get("minZoomCount");
        let maxZoomCount = this.get("maxZoomCount");
        if (isNumber(minZoomCount)) {
          maxZoomFactor = maxZoomFactorReal / minZoomCount;
        }
        let minZoomFactor = 1;
        if (isNumber(maxZoomCount)) {
          minZoomFactor = maxZoomFactorReal / maxZoomCount;
        }
        if (priority === "start") {
          if (maxZoomCount > 0) {
            if (1 / (end - start) < minZoomFactor) {
              end = start + 1 / minZoomFactor;
            }
          }
          if (1 / (end - start) > maxZoomFactor) {
            end = start + 1 / maxZoomFactor;
          }
          if (end > 1 && end - start < 1 / maxZoomFactor) {
            start = end - 1 / maxZoomFactor;
          }
        } else {
          if (maxZoomCount > 0) {
            if (1 / (end - start) < minZoomFactor) {
              start = end - 1 / minZoomFactor;
            }
          }
          if (1 / (end - start) > maxZoomFactor) {
            start = end - 1 / maxZoomFactor;
          }
          if (start < 0 && end - start < 1 / maxZoomFactor) {
            end = start + 1 / maxZoomFactor;
          }
        }
        if (1 / (end - start) > maxZoomFactor) {
          end = start + 1 / maxZoomFactor;
        }
        if (1 / (end - start) > maxZoomFactor) {
          start = end - 1 / maxZoomFactor;
        }
        if (maxZoomCount != null && minZoomCount != null && (start == this.get("start") && end == this.get("end"))) {
          const chart = this.chart;
          if (chart) {
            chart._handleAxisSelection(this, true);
          }
        }
        if ((sAnimation && sAnimation.playing && sAnimation.to == start || this.get("start") == start) && (eAnimation && eAnimation.playing && eAnimation.to == end || this.get("end") == end)) {
          return;
        }
        if (duration > 0) {
          let easing = this.get("interpolationEasing");
          let sAnimation2, eAnimation2;
          if (this.get("start") != start) {
            sAnimation2 = this.animate({ key: "start", to: start, duration, easing });
          }
          if (this.get("end") != end) {
            eAnimation2 = this.animate({ key: "end", to: end, duration, easing });
          }
          this._sAnimation = sAnimation2;
          this._eAnimation = eAnimation2;
          if (sAnimation2) {
            return sAnimation2;
          } else if (eAnimation2) {
            return eAnimation2;
          }
        } else {
          this.set("start", start);
          this.set("end", end);
          this._root.events.once("frameended", () => {
            this._markDirtyKey("start");
            this._root._markDirty();
          });
        }
      } else {
        if (this._sAnimation) {
          this._sAnimation.stop();
        }
        if (this._eAnimation) {
          this._eAnimation.stop();
        }
      }
    }
  }
  /**
   * A list of series using this axis.
   *
   * @return Series
   */
  get series() {
    return this._series;
  }
  _processAxisRange(dataItem, themeTags) {
    dataItem.setRaw("isRange", true);
    this._createAssets(dataItem, themeTags);
    this._rangesDirty = true;
    this._prepareDataItem(dataItem);
    const above = dataItem.get("above");
    const container = this.topGridContainer;
    const grid = dataItem.get("grid");
    if (above && grid) {
      container.children.moveValue(grid);
    }
    const fill = dataItem.get("axisFill");
    if (above && fill) {
      container.children.moveValue(fill);
    }
  }
  _prepareDataItem(_dataItem, _index) {
  }
  /**
   * @ignore
   */
  markDirtyExtremes() {
  }
  /**
   * @ignore
   */
  markDirtySelectionExtremes() {
  }
  _calculateTotals() {
  }
  _updateAxisRanges() {
    this._bullets = {};
    this.axisRanges.each((axisRange) => {
      this._prepareDataItem(axisRange);
    });
    each(this._seriesAxisRanges, (axisRange) => {
      this._prepareDataItem(axisRange);
    });
  }
  _prepareChildren() {
    super._prepareChildren();
    if (this.get("fixAxisSize")) {
      this.ghostLabel.set("visible", true);
    } else {
      this.ghostLabel.set("visible", false);
    }
    if (this.isDirty("start") || this.isDirty("end")) {
      const chart = this.chart;
      if (chart) {
        chart._updateCursor();
      }
      let start = this.get("start", 0);
      let end = this.get("end", 1);
      let maxDeviation = this.get("maxDeviation", 0.5) * Math.min(1, end - start);
      if (start < -maxDeviation) {
        let delta = start + maxDeviation;
        start = -maxDeviation;
        this.setRaw("start", start);
        if (this.isDirty("end")) {
          this.setRaw("end", end - delta);
        }
      }
      if (end > 1 + maxDeviation) {
        let delta = end - 1 - maxDeviation;
        end = 1 + maxDeviation;
        this.setRaw("end", end);
        if (this.isDirty("start")) {
          this.setRaw("start", start - delta);
        }
      }
    }
    const renderer = this.get("renderer");
    renderer._start = this.get("start");
    renderer._end = this.get("end");
    renderer._inversed = renderer.get("inversed", false);
    renderer._axisLength = renderer.axisLength() / (renderer._end - renderer._start);
    renderer._updateLC();
    if (this.isDirty("tooltip")) {
      const tooltip = this.get("tooltip");
      if (tooltip) {
        const rendererTags = renderer.get("themeTags");
        tooltip.addTag("axis");
        tooltip.addTag(this.className.toLowerCase());
        tooltip._applyThemes();
        if (rendererTags) {
          tooltip.set("themeTags", mergeTags(tooltip.get("themeTags"), rendererTags));
          tooltip.label._applyThemes();
        }
      }
    }
  }
  _updateTooltipBounds() {
    const tooltip = this.get("tooltip");
    if (tooltip) {
      this.get("renderer").updateTooltipBounds(tooltip);
    }
  }
  _updateBounds() {
    super._updateBounds();
    this._updateTooltipBounds();
  }
  /**
   * @ignore
   */
  processChart(chart) {
    this.chart = chart;
    const renderer = this.get("renderer");
    renderer.chart = chart;
    chart.gridContainer.children.push(this.gridContainer);
    chart.topGridContainer.children.push(this.topGridContainer);
    chart.axisHeadersContainer.children.push(this.axisHeader);
    this.on("start", () => {
      chart._handleAxisSelection(this);
    });
    this.on("end", () => {
      chart._handleAxisSelection(this);
    });
    chart.plotContainer.onPrivate("width", () => {
      this.markDirtySize();
    });
    chart.plotContainer.onPrivate("height", () => {
      this.markDirtySize();
    });
    chart.processAxis(this);
  }
  /**
   * @ignore
   */
  hideDataItem(dataItem) {
    this._toggleFHDataItem(dataItem, true);
    return super.hideDataItem(dataItem);
  }
  /**
   * @ignore
   */
  showDataItem(dataItem) {
    this._toggleFHDataItem(dataItem, false);
    return super.showDataItem(dataItem);
  }
  _toggleFHDataItem(dataItem, forceHidden) {
    const fh = "forceHidden";
    const label = dataItem.get("label");
    if (label) {
      label.set(fh, forceHidden);
    }
    const grid = dataItem.get("grid");
    if (grid) {
      grid.set(fh, forceHidden);
    }
    const tick = dataItem.get("tick");
    if (tick) {
      tick.set(fh, forceHidden);
    }
    const axisFill = dataItem.get("axisFill");
    if (axisFill) {
      axisFill.set(fh, forceHidden);
    }
    const bullet = dataItem.get("bullet");
    if (bullet) {
      const sprite = bullet.get("sprite");
      if (sprite) {
        sprite.set(fh, forceHidden);
      }
    }
  }
  _toggleDataItem(dataItem, visible) {
    const label = dataItem.get("label");
    const v = "visible";
    if (label) {
      label.setPrivate(v, visible);
    }
    const grid = dataItem.get("grid");
    if (grid) {
      grid.setPrivate(v, visible);
    }
    const tick = dataItem.get("tick");
    if (tick) {
      tick.setPrivate(v, visible);
    }
    const axisFill = dataItem.get("axisFill");
    if (axisFill) {
      axisFill.setPrivate(v, visible);
    }
    const bullet = dataItem.get("bullet");
    if (bullet) {
      const sprite = bullet.get("sprite");
      if (sprite) {
        sprite.setPrivate(v, visible);
      }
    }
  }
  _createAssets(dataItem, tags, minor) {
    var _a, _b, _c;
    const renderer = this.get("renderer");
    let m = "minor";
    const label = dataItem.get("label");
    if (!label) {
      renderer.makeLabel(dataItem, tags);
    } else {
      let themeTags = label.get("themeTags");
      let remove2 = false;
      if (minor) {
        if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) == -1) {
          remove2 = true;
        }
      } else {
        if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) != -1) {
          remove2 = true;
        }
      }
      if (remove2) {
        (_a = label.parent) === null || _a === void 0 ? void 0 : _a.children.removeValue(label);
        renderer.makeLabel(dataItem, tags);
        label.dispose();
        renderer.labels.removeValue(label);
      }
    }
    const grid = dataItem.get("grid");
    if (!grid) {
      renderer.makeGrid(dataItem, tags);
    } else {
      let themeTags = grid.get("themeTags");
      let remove2 = false;
      if (minor) {
        if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) == -1) {
          remove2 = true;
        }
      } else {
        if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) != -1) {
          remove2 = true;
        }
      }
      if (remove2) {
        (_b = grid.parent) === null || _b === void 0 ? void 0 : _b.children.removeValue(grid);
        renderer.makeGrid(dataItem, tags);
        grid.dispose();
        renderer.grid.removeValue(grid);
      }
    }
    const tick = dataItem.get("tick");
    if (!tick) {
      renderer.makeTick(dataItem, tags);
    } else {
      let remove2 = false;
      let themeTags = tick.get("themeTags");
      if (minor) {
        if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) == -1) {
          remove2 = true;
        }
      } else {
        if ((themeTags === null || themeTags === void 0 ? void 0 : themeTags.indexOf(m)) != -1) {
          remove2 = true;
        }
      }
      if (remove2) {
        (_c = tick.parent) === null || _c === void 0 ? void 0 : _c.children.removeValue(tick);
        renderer.makeTick(dataItem, tags);
        tick.dispose();
        renderer.ticks.removeValue(tick);
      }
    }
    if (!minor && !dataItem.get("axisFill")) {
      renderer.makeAxisFill(dataItem, tags);
    }
    this._processBullet(dataItem);
  }
  _processBullet(dataItem) {
    let bullet = dataItem.get("bullet");
    let axisBullet = this.get("bullet");
    if (!bullet && axisBullet && !dataItem.get("isRange")) {
      bullet = axisBullet(this._root, this, dataItem);
    }
    if (bullet) {
      bullet.axis = this;
      const sprite = bullet.get("sprite");
      if (sprite) {
        sprite._setDataItem(dataItem);
        dataItem.setRaw("bullet", bullet);
        if (!sprite.parent) {
          this.bulletsContainer.children.push(sprite);
        }
      }
    }
  }
  _afterChanged() {
    super._afterChanged();
    const chart = this.chart;
    if (chart) {
      chart._updateChartLayout();
      chart.axisHeadersContainer.markDirtySize();
    }
    this.get("renderer")._updatePositions();
  }
  /**
   * @ignore
   */
  disposeDataItem(dataItem) {
    super.disposeDataItem(dataItem);
    const renderer = this.get("renderer");
    const label = dataItem.get("label");
    if (label) {
      renderer.labels.removeValue(label);
      label.dispose();
    }
    const tick = dataItem.get("tick");
    if (tick) {
      renderer.ticks.removeValue(tick);
      tick.dispose();
    }
    const grid = dataItem.get("grid");
    if (grid) {
      renderer.grid.removeValue(grid);
      grid.dispose();
    }
    const axisFill = dataItem.get("axisFill");
    if (axisFill) {
      renderer.axisFills.removeValue(axisFill);
      axisFill.dispose();
    }
    const bullet = dataItem.get("bullet");
    if (bullet) {
      bullet.dispose();
    }
  }
  _updateGhost() {
    this.setPrivate("cellWidth", this.getCellWidthPosition() * this.get("renderer").axisLength());
    const ghostLabel = this.ghostLabel;
    if (!ghostLabel.isHidden()) {
      const bounds = ghostLabel.localBounds();
      const gWidth = Math.ceil(bounds.right - bounds.left);
      let text = ghostLabel.get("text");
      each(this.dataItems, (dataItem) => {
        const label = dataItem.get("label");
        if (label && !label.isHidden()) {
          const bounds2 = label.localBounds();
          const w = Math.ceil(bounds2.right - bounds2.left);
          if (w > gWidth) {
            text = label.text._getText();
          }
        }
      });
      ghostLabel.set("text", text);
    }
    let start = this.get("start", 0);
    let end = this.get("end", 1);
    this.get("renderer").updateLabel(ghostLabel, start + (end - start) * 0.5);
  }
  _handleCursorPosition(position2, snapToSeries) {
    const renderer = this.get("renderer");
    position2 = renderer.toAxisPosition(position2);
    this._cursorPosition = position2;
    this._snapToSeries = snapToSeries;
    this.updateTooltip();
  }
  /**
   * Can be called when axis zoom changes and you need to update tooltip
   * position.
   */
  updateTooltip() {
    const snapToSeries = this._snapToSeries;
    let position2 = this._cursorPosition;
    const tooltip = this.get("tooltip");
    const renderer = this.get("renderer");
    if (isNumber(position2)) {
      each(this.series, (series) => {
        if (series.get("baseAxis") === this) {
          const dataItem = this.getSeriesItem(series, position2, this.get("tooltipLocation"));
          series.setRaw("tooltipDataItem", dataItem);
          if (snapToSeries && snapToSeries.indexOf(series) != -1) {
            series.updateLegendMarker(dataItem);
            series.updateLegendValue(dataItem);
          } else {
            series.showDataItemTooltip(dataItem);
          }
        }
      });
      if (tooltip) {
        renderer.updateTooltipBounds(tooltip);
        if (this.get("snapTooltip")) {
          position2 = this.roundAxisPosition(position2, this.get("tooltipLocation", 0.5));
        }
        if (!isNaN2(position2)) {
          this.setPrivateRaw("tooltipPosition", position2);
          this._updateTooltipText(tooltip, position2);
          renderer.positionTooltip(tooltip, position2);
          if (position2 < this.get("start") || position2 > this.get("end")) {
            tooltip.hide(0);
          } else {
            tooltip.show(0);
          }
        } else {
          tooltip.hide(0);
        }
      }
    }
  }
  _updateTooltipText(tooltip, position2) {
    tooltip.label.set("text", this.getTooltipText(position2));
  }
  /**
   * @ignore
   */
  roundAxisPosition(position2, _location) {
    return position2;
  }
  /**
   * @ignore
   */
  handleCursorShow() {
    let tooltip = this.get("tooltip");
    if (tooltip) {
      tooltip.show();
    }
  }
  /**
   * @ignore
   */
  handleCursorHide() {
    let tooltip = this.get("tooltip");
    if (tooltip) {
      tooltip.hide();
    }
  }
  /**
   * @ignore
   */
  processSeriesDataItem(_dataItem, _fields) {
  }
  _clearDirty() {
    super._clearDirty();
    this._sizeDirty = false;
    this._rangesDirty = false;
  }
  /**
   * Converts pixel coordinate to a relative position on axis.
   *
   * @param   coordinate  Coordinate
   * @return              Relative position
   */
  coordinateToPosition(coordinate) {
    const renderer = this.get("renderer");
    return renderer.toAxisPosition(coordinate / renderer.axisLength());
  }
  /**
   * Converts relative position of the plot area to relative position of the
   * axis with zoom taken into account.
   *
   * @param position Position
   * @return Relative position
   */
  toAxisPosition(position2) {
    return this.get("renderer").toAxisPosition(position2);
  }
  /**
   * Converts relative position of the axis to a global position taking current
   * zoom into account (opposite to what `toAxisPosition` does).
   *
   * @since 5.4.2
   * @param position Position
   * @return Global position
   */
  toGlobalPosition(position2) {
    return this.get("renderer").toGlobalPosition(position2);
  }
  /**
   * Adjusts position with inversed taken into account.
   *
   * @ignore
   */
  fixPosition(position2) {
    return this.get("renderer").fixPosition(position2);
  }
  /**
   * @ignore
   */
  shouldGap(_dataItem, _nextItem, _autoGapCount, _fieldName) {
    return false;
  }
  /**
   * Creates and returns an axis range object.
   *
   * @see {@link https://www.amcharts.com/docs/v5/charts/xy-chart/axes/axis-ranges/} for more info
   * @param   axisDataItem  Axis data item
   * @return                Axis range
   */
  createAxisRange(axisDataItem) {
    return this.axisRanges.push(axisDataItem);
  }
  /**
   * @ignore
   */
  _groupSeriesData(_series) {
  }
  /**
   * Returns relative position between two grid lines of the axis.
   *
   * @return Position
   */
  getCellWidthPosition() {
    return 0.05;
  }
};
Object.defineProperty(Axis, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Axis"
});
Object.defineProperty(Axis, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Component5.classNames.concat([Axis.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/CategoryAxis.js
var CategoryAxis = class _CategoryAxis extends Axis {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_frequency", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "_itemMap", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["axis"]);
    this.fields.push("category");
    this.setPrivateRaw("name", "category");
    this.addTag("category");
    super._afterNew();
  }
  _prepareChildren() {
    super._prepareChildren();
    const len = this.dataItems.length;
    let i = 0;
    if (this._valuesDirty) {
      this._itemMap = {};
      each(this.dataItems, (dataItem) => {
        dataItem.setRaw("index", i);
        this._itemMap[dataItem.get("category")] = dataItem;
        i++;
      });
      this.setPrivateRaw("maxZoomFactor", len);
    }
    this.setPrivateRaw("startIndex", Math.max(Math.round(this.get("start", 0) * len), 0));
    this.setPrivateRaw("endIndex", Math.min(Math.round(this.get("end", 1) * len), len));
    if (this._sizeDirty || this._valuesDirty || (this.isDirty("start") || this.isDirty("end") || this.isPrivateDirty("endIndex") || this.isPrivateDirty("startIndex") || this.isPrivateDirty("width") || this.isPrivateDirty("height"))) {
      if (this.dataItems.length > 0) {
        this._handleRangeChange();
        this._prepareAxisItems();
        this._updateAxisRanges();
      }
    }
  }
  _handleRangeChange() {
    each(this.series, (series) => {
      let startCategory = this.dataItems[this.startIndex()].get("category");
      let endCategory = this.dataItems[this.endIndex() - 1].get("category");
      let baseAxis = series.get("baseAxis");
      let xAxis = series.get("xAxis");
      let yAxis = series.get("yAxis");
      if (xAxis instanceof _CategoryAxis && yAxis instanceof _CategoryAxis) {
        series._markDirtyAxes();
      } else if (baseAxis === this) {
        let key;
        let openKey;
        let otherAxis = yAxis;
        if (xAxis === baseAxis) {
          if (series.get("categoryXField")) {
            key = "categoryX";
          }
          if (series.get("openCategoryXField")) {
            openKey = "openCategoryX";
          }
        } else if (yAxis === baseAxis) {
          if (series.get("categoryYField")) {
            key = "categoryY";
          }
          if (series.get("openCategoryYField")) {
            openKey = "openCategoryY";
          }
          otherAxis = xAxis;
        }
        if (otherAxis.className == "ValueAxis") {
          if (key || openKey) {
            let startDataItem;
            let endDataItem;
            for (let i = 0, len = series.dataItems.length; i < len; i++) {
              let dataItem = series.dataItems[i];
              if (key) {
                if (dataItem.get(key) === startCategory) {
                  startDataItem = dataItem;
                  break;
                }
              }
              if (openKey) {
                if (dataItem.get(openKey) === startCategory) {
                  startDataItem = dataItem;
                  break;
                }
              }
            }
            for (let i = series.dataItems.length - 1; i >= 0; i--) {
              let dataItem = series.dataItems[i];
              if (key) {
                if (dataItem.get(key) === endCategory) {
                  endDataItem = dataItem;
                  break;
                }
              }
              if (openKey) {
                if (dataItem.get(openKey) === endCategory) {
                  endDataItem = dataItem;
                  break;
                }
              }
            }
            let startIndex = 0;
            let endIndex = series.dataItems.length;
            if (startDataItem) {
              startIndex = series.dataItems.indexOf(startDataItem);
            }
            if (endDataItem) {
              endIndex = series.dataItems.indexOf(endDataItem) + 1;
            }
            series.setPrivate("startIndex", startIndex);
            series.setPrivate("endIndex", endIndex);
            let hasValue3 = false;
            for (let i = startIndex; i < endIndex; i++) {
              const dataItem = series.dataItems[i];
              each(series.__valueXShowFields, (key2) => {
                let value = dataItem.get(key2);
                if (value != null) {
                  hasValue3 = true;
                }
              });
              each(series.__valueYShowFields, (key2) => {
                let value = dataItem.get(key2);
                if (value != null) {
                  hasValue3 = true;
                }
              });
              if (hasValue3) {
                break;
              }
            }
            series.setPrivate("outOfSelection", !hasValue3);
          }
        }
        series._markDirtyAxes();
      }
    });
  }
  _prepareAxisItems() {
    var _a;
    const renderer = this.get("renderer");
    const len = this.dataItems.length;
    let startIndex = this.startIndex();
    if (startIndex > 0) {
      startIndex--;
    }
    let endIndex = this.endIndex();
    if (endIndex < len) {
      endIndex++;
    }
    const minorLabelsEnabled = renderer.get("minorLabelsEnabled");
    const minorGridEnabled = renderer.get("minorGridEnabled", minorLabelsEnabled);
    let maxCount = renderer.axisLength() / Math.max(renderer.get("minGridDistance"), 1);
    let frequency = Math.max(1, Math.min(len, Math.ceil((endIndex - startIndex) / maxCount)));
    startIndex = Math.floor(startIndex / frequency) * frequency;
    this._frequency = frequency;
    for (let j = 0; j < len; j++) {
      this._toggleDataItem(this.dataItems[j], false);
    }
    let f = this.dataItems[startIndex].get("index", 0);
    for (let i = startIndex; i < endIndex; i = i + frequency) {
      let dataItem = this.dataItems[i];
      this._createAssets(dataItem, []);
      this._toggleDataItem(dataItem, true);
      let count = frequency;
      if (minorGridEnabled) {
        count = 1;
      }
      this._prepareDataItem(dataItem, f, count);
      f++;
    }
    if (renderer.get("minorGridEnabled")) {
      for (let i = startIndex; i < endIndex; i++) {
        let dataItem = this.dataItems[i];
        if (i % frequency != 0) {
          this._createAssets(dataItem, ["minor"], true);
          this._toggleDataItem(dataItem, true);
          this._prepareDataItem(dataItem, 0, 1);
          if (!minorLabelsEnabled) {
            (_a = dataItem.get("label")) === null || _a === void 0 ? void 0 : _a.setPrivate("visible", false);
          }
        }
      }
    }
    this._updateGhost();
  }
  _prepareDataItem(dataItem, fillIndex, count) {
    let renderer = this.get("renderer");
    let categoryLocation = dataItem.get("categoryLocation", 0);
    let endCategoryLocation = dataItem.get("endCategoryLocation", 1);
    let index2 = dataItem.get("index");
    if (!isNumber(index2)) {
      index2 = this.categoryToIndex(dataItem.get("category"));
    }
    let position2 = this.indexToPosition(index2, categoryLocation);
    let endCategory = dataItem.get("endCategory");
    let endIndex;
    if (endCategory) {
      endIndex = this.categoryToIndex(endCategory);
      if (!isNumber(endIndex)) {
        endIndex = index2;
      }
    } else {
      endIndex = index2;
    }
    let endPosition = this.indexToPosition(endIndex, endCategoryLocation);
    let fillEndIndex;
    let fillEndPosition;
    if (dataItem.get("isRange")) {
      fillEndIndex = endIndex;
    } else {
      fillEndIndex = index2 + this._frequency - 1;
    }
    fillEndPosition = this.indexToPosition(fillEndIndex, endCategoryLocation);
    renderer.updateLabel(dataItem.get("label"), position2, endPosition, count);
    renderer.updateGrid(dataItem.get("grid"), position2, endPosition);
    renderer.updateTick(dataItem.get("tick"), position2, endPosition, count);
    renderer.updateFill(dataItem.get("axisFill"), position2, fillEndPosition);
    this._processBullet(dataItem);
    renderer.updateBullet(dataItem.get("bullet"), position2, endPosition);
    const fillRule = this.get("fillRule");
    if (fillRule) {
      fillRule(dataItem, fillIndex);
    }
  }
  startIndex() {
    let len = this.dataItems.length;
    return Math.min(Math.max(this.getPrivate("startIndex", 0), 0), len - 1);
  }
  endIndex() {
    let len = this.dataItems.length;
    return Math.max(1, Math.min(this.getPrivate("endIndex", len), len));
  }
  /**
   * @ignore
   */
  baseValue() {
  }
  /**
   * @ignore
   */
  basePosition() {
    return 0;
  }
  /**
   * Returns X coordinate in pixels corresponding to specific category index.
   *
   * @param   value  Index
   * @return         X coordinate
   */
  getX(value) {
    let axisDataItem = this._itemMap[value];
    if (axisDataItem) {
      return this._settings.renderer.positionToCoordinate(this.indexToPosition(axisDataItem.get("index", 0)));
    }
    return NaN;
  }
  /**
   * Returns Y coordinate in pixels corresponding to specific category index.
   *
   * @param   value  Index
   * @return         Y coordinate
   */
  getY(value) {
    let axisDataItem = this._itemMap[value];
    if (axisDataItem) {
      return this._settings.renderer.positionToCoordinate(this.indexToPosition(axisDataItem.get("index", 0)));
    }
    return NaN;
  }
  /**
   * @ignore
   */
  getDataItemPositionX(dataItem, field, cellLocation, _axisLocation) {
    const category = dataItem.get(field);
    const axisDataItem = this._itemMap[category];
    if (axisDataItem) {
      return this.indexToPosition(axisDataItem.get("index", 0), cellLocation);
    }
    return NaN;
  }
  /**
   * @ignore
   */
  getDataItemCoordinateX(dataItem, field, cellLocation, _axisLocation) {
    return this._settings.renderer.positionToCoordinate(this.getDataItemPositionX(dataItem, field, cellLocation, _axisLocation));
  }
  /**
   * @ignore
   */
  getDataItemPositionY(dataItem, field, cellLocation, _axisLocation) {
    const category = dataItem.get(field);
    const axisDataItem = this._itemMap[category];
    if (axisDataItem) {
      return this.indexToPosition(axisDataItem.get("index", 0), cellLocation);
    }
    return NaN;
  }
  /**
   * @ignore
   */
  getDataItemCoordinateY(dataItem, field, cellLocation, _axisLocation) {
    return this._settings.renderer.positionToCoordinate(this.getDataItemPositionY(dataItem, field, cellLocation, _axisLocation));
  }
  /**
   * Converts category index to a relative position.
   *
   * `location` indicates relative position within category: 0 - start, 1 - end.
   *
   * If not set, will use middle (0.5) of the category.
   *
   * @param   index     Index
   * @param   location  Location
   * @return            Index
   */
  indexToPosition(index2, location) {
    if (!isNumber(location)) {
      location = 0.5;
    }
    let len = this.dataItems.length;
    let startLocation = this.get("startLocation", 0);
    let endLocation = this.get("endLocation", 1);
    len -= startLocation;
    len -= 1 - endLocation;
    let position2 = (index2 + location - startLocation) / len;
    let dataItem = this.dataItems[index2];
    if (dataItem) {
      position2 += dataItem.get("deltaPosition", 0);
    }
    return position2;
  }
  /**
   * Returns an index of a category.
   *
   * @param   category  Category to look up
   * @return            Index
   */
  categoryToIndex(category) {
    let dataItem = this._itemMap[category];
    if (dataItem) {
      return dataItem.get("index");
    }
    return NaN;
  }
  /**
   * @ignore
   */
  dataItemToPosition(dataItem) {
    return this.indexToPosition(dataItem.get("index"));
  }
  /**
   * @ignore
   */
  roundAxisPosition(position2, location) {
    position2 += (0.5 - location) / this.dataItems.length;
    return this.indexToPosition(this.axisPositionToIndex(position2), location);
  }
  /**
   * Returns an index of the category that corresponds to specific pixel
   * position within axis.
   *
   * @param position  Position (px)
   * @return Category index
   */
  axisPositionToIndex(position2) {
    let len = this.dataItems.length;
    return fitToRange(Math.floor(position2 * len), 0, len - 1);
  }
  /**
   * Returns text to be used in an axis tooltip for specific relative position.
   *
   * @param   position  Position
   * @return            Tooltip text
   */
  getTooltipText(position2, _adjustPosition) {
    const dataItem = this.dataItems[this.axisPositionToIndex(position2)];
    if (dataItem) {
      const label = dataItem.get("label");
      if (label) {
        return populateString(label, this.get("tooltipText", ""));
      }
    }
  }
  _updateTooltipText(tooltip, position2) {
    tooltip._setDataItem(this.dataItems[this.axisPositionToIndex(position2)]);
    tooltip.label.text.markDirtyText();
  }
  /**
   * Returns a data item from series that is closest to the `position`.
   *
   * @param   series    Series
   * @param   position  Relative position
   * @return            Data item
   */
  getSeriesItem(series, position2) {
    if (this.dataItems.length > 0) {
      let fieldName = this.getPrivate("name") + this.get("renderer").getPrivate("letter");
      let index2 = this.axisPositionToIndex(position2);
      let seriesDataItem = series.dataItems[index2];
      let axisDataItem = this.dataItems[index2];
      let category = axisDataItem.get("category");
      if (seriesDataItem && axisDataItem) {
        if (seriesDataItem.get(fieldName) === category) {
          return seriesDataItem;
        }
      }
      for (let i = 0, len = series.dataItems.length; i < len; i++) {
        let dataItem = series.dataItems[i];
        if (dataItem.get(fieldName) === category) {
          return dataItem;
        }
      }
    }
  }
  /**
   * Zooms the axis to specific `start` and `end` indexes.
   *
   * Optional `duration` specifies duration of zoom animation in milliseconds.
   *
   * @param  start     Start index
   * @param  end       End index
   * @param  duration  Duration in milliseconds
   */
  zoomToIndexes(start, end, duration) {
    let len = this.dataItems.length;
    this.zoom(start / len, end / len, duration);
  }
  zoomToCategories(startCategory, endCategory, duration) {
    this.zoomToIndexes(this.categoryToIndex(startCategory), this.categoryToIndex(endCategory) + 1, duration);
  }
  /**
   * Returns position span between start and end of a single cell in axis.
   *
   * @since 5.2.30
   * @return Position
   */
  getCellWidthPosition() {
    return this._frequency / this.dataItems.length / (this.get("end", 1) - this.get("start", 0));
  }
};
Object.defineProperty(CategoryAxis, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "CategoryAxis"
});
Object.defineProperty(CategoryAxis, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Axis.classNames.concat([CategoryAxis.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/ValueAxis.js
var ValueAxis = class extends Axis {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_dirtyExtremes", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_dirtySelectionExtremes", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_deltaMinMax", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "_minReal", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_maxReal", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_baseValue", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_syncDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_minLogAdjusted", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
  }
  /**
   * @ignore
   */
  markDirtyExtremes() {
    this._dirtyExtremes = true;
    this.markDirty();
  }
  /**
   * @ignore
   */
  markDirtySelectionExtremes() {
    this._dirtySelectionExtremes = true;
    this.markDirty();
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["axis"]);
    this.setPrivateRaw("name", "value");
    this.addTag("value");
    super._afterNew();
  }
  _prepareChildren() {
    super._prepareChildren();
    if (this.isDirty("syncWithAxis")) {
      let previousValue = this._prevSettings.syncWithAxis;
      if (previousValue) {
        if (this._syncDp) {
          this._syncDp.dispose();
        }
      }
      let syncWithAxis = this.get("syncWithAxis");
      if (syncWithAxis) {
        this._syncDp = new MultiDisposer([
          syncWithAxis.onPrivate("selectionMinFinal", () => {
            this._dirtySelectionExtremes = true;
          }),
          syncWithAxis.onPrivate("selectionMaxFinal", () => {
            this._dirtySelectionExtremes = true;
          })
        ]);
      }
    }
    let someDirty = false;
    if (this.isDirty("min") || this.isDirty("max") || this.isDirty("maxPrecision") || this.isDirty("numberFormat")) {
      someDirty = true;
      this.ghostLabel.set("text", "");
    }
    if (this._sizeDirty || this._dirtyExtremes || this._valuesDirty || someDirty || this.isPrivateDirty("width") || this.isPrivateDirty("height") || this.isDirty("extraMin") || this.isDirty("extraMax") || this.isDirty("logarithmic") || this.isDirty("treatZeroAs") || this.isDirty("baseValue") || this.isDirty("strictMinMax") || this.isDirty("strictMinMaxSelection")) {
      this._getMinMax();
      this._dirtyExtremes = false;
    }
    if (this._dirtySelectionExtremes && !this._isPanning && this.get("autoZoom", true)) {
      this._getSelectionMinMax();
      this._dirtySelectionExtremes = false;
    }
    this._groupData();
    if (this._sizeDirty || this._valuesDirty || this.isDirty("start") || this.isDirty("end") || this.isPrivateDirty("min") || this.isPrivateDirty("selectionMax") || this.isPrivateDirty("selectionMin") || this.isPrivateDirty("max") || this.isPrivateDirty("step") || this.isPrivateDirty("width") || this.isPrivateDirty("height") || this.isDirty("logarithmic")) {
      this._handleRangeChange();
      this._prepareAxisItems();
      this._updateAxisRanges();
    }
    this._baseValue = this.baseValue();
  }
  _groupData() {
  }
  _formatText(value) {
    const numberFormat = this.get("numberFormat");
    const formatter = this.getNumberFormatter();
    let text = "";
    if (numberFormat) {
      text = formatter.format(value, numberFormat);
    } else {
      text = formatter.format(value, void 0, this.getPrivate("stepDecimalPlaces"));
    }
    return text;
  }
  _prepareAxisItems() {
    const min3 = this.getPrivate("min");
    const max3 = this.getPrivate("max");
    if (isNumber(min3) && isNumber(max3)) {
      const logarithmic = this.get("logarithmic");
      const step = this.getPrivate("step");
      const selectionMin = this.getPrivate("selectionMin");
      const selectionMax = this.getPrivate("selectionMax") + step;
      let value = selectionMin - step;
      let differencePower = 1;
      let minLog = min3;
      if (logarithmic) {
        value = this._minLogAdjusted;
        if (value < selectionMin) {
          while (value < selectionMin) {
            value += step;
          }
        }
        minLog = value;
        if (minLog <= 0) {
          minLog = 1;
          if (step < 1) {
            minLog = step;
          }
        }
        differencePower = Math.log(selectionMax - step) * Math.LOG10E - Math.log(minLog) * Math.LOG10E;
        if (differencePower > 2) {
          value = Math.pow(10, Math.log(minLog) * Math.LOG10E - 5);
        }
      }
      const renderer = this.get("renderer");
      const minorLabelsEnabled = renderer.get("minorLabelsEnabled");
      const minorGridEnabled = renderer.get("minorGridEnabled", minorLabelsEnabled);
      let stepPower = Math.pow(10, Math.floor(Math.log(Math.abs(step)) * Math.LOG10E));
      const stepAdjusted = Math.round(step / stepPower);
      let minorGridCount = 2;
      if (round(stepAdjusted / 5, 10) % 1 == 0) {
        minorGridCount = 5;
      }
      if (round(stepAdjusted / 10, 10) % 1 == 0) {
        minorGridCount = 10;
      }
      let minorStep = step / minorGridCount;
      let i = 0;
      let m = 0;
      let previous = -Infinity;
      while (value < selectionMax) {
        let dataItem;
        if (this.dataItems.length < i + 1) {
          dataItem = new DataItem(this, void 0, {});
          this._dataItems.push(dataItem);
          this.processDataItem(dataItem);
        } else {
          dataItem = this.dataItems[i];
        }
        this._createAssets(dataItem, []);
        this._toggleDataItem(dataItem, true);
        dataItem.setRaw("value", value);
        const label = dataItem.get("label");
        if (label) {
          label.set("text", this._formatText(value));
        }
        this._prepareDataItem(dataItem);
        let nextValue = value;
        if (!logarithmic) {
          nextValue += step;
        } else {
          if (differencePower > 2) {
            nextValue = Math.pow(10, Math.log(minLog) * Math.LOG10E + i - 5);
          } else {
            nextValue += step;
          }
        }
        if (minorGridEnabled) {
          let minorValue = value + minorStep;
          if (logarithmic) {
            if (differencePower > 2) {
              let minorMinMaxStep = this._adjustMinMax(value, nextValue, 10);
              minorStep = minorMinMaxStep.step;
            }
            minorValue = value + minorStep;
          }
          while (minorValue < nextValue - step * 1e-11) {
            let minorDataItem;
            if (this.minorDataItems.length < m + 1) {
              minorDataItem = new DataItem(this, void 0, {});
              this.minorDataItems.push(minorDataItem);
              this.processDataItem(minorDataItem);
            } else {
              minorDataItem = this.minorDataItems[m];
            }
            this._createAssets(minorDataItem, ["minor"], true);
            this._toggleDataItem(minorDataItem, true);
            minorDataItem.setRaw("value", minorValue);
            const minorLabel = minorDataItem.get("label");
            if (minorLabel) {
              if (minorLabelsEnabled) {
                minorLabel.set("text", this._formatText(minorValue));
              } else {
                minorLabel.setPrivate("visible", false);
              }
            }
            this._prepareDataItem(minorDataItem);
            minorValue += minorStep;
            m++;
          }
        }
        value = nextValue;
        if (previous == value) {
          break;
        }
        let stepPower2 = Math.pow(10, Math.floor(Math.log(Math.abs(step)) * Math.LOG10E));
        if (stepPower2 < 1) {
          let decCount = Math.round(Math.abs(Math.log(Math.abs(stepPower2)) * Math.LOG10E)) + 2;
          value = round(value, decCount);
        }
        i++;
        previous = value;
      }
      for (let j = i; j < this.dataItems.length; j++) {
        this._toggleDataItem(this.dataItems[j], false);
      }
      for (let j = m; j < this.minorDataItems.length; j++) {
        this._toggleDataItem(this.minorDataItems[j], false);
      }
      each(this.series, (series) => {
        if (series.inited) {
          series._markDirtyAxes();
        }
      });
      this._updateGhost();
    }
  }
  _prepareDataItem(dataItem, count) {
    let renderer = this.get("renderer");
    let value = dataItem.get("value");
    let endValue = dataItem.get("endValue");
    let position2 = this.valueToPosition(value);
    let endPosition = position2;
    let fillEndPosition = this.valueToPosition(value + this.getPrivate("step"));
    if (isNumber(endValue)) {
      endPosition = this.valueToPosition(endValue);
      fillEndPosition = endPosition;
    }
    if (dataItem.get("isRange")) {
      if (endValue == null) {
        fillEndPosition = position2;
      }
    }
    let labelEndPosition = endPosition;
    let labelEndValue = dataItem.get("labelEndValue");
    if (labelEndValue != null) {
      labelEndPosition = this.valueToPosition(labelEndValue);
    }
    renderer.updateLabel(dataItem.get("label"), position2, labelEndPosition, count);
    const grid = dataItem.get("grid");
    renderer.updateGrid(grid, position2, endPosition);
    if (grid) {
      if (value == this.get("baseValue", 0)) {
        grid.addTag("base");
        grid._applyThemes();
      } else if (grid.hasTag("base")) {
        grid.removeTag("base");
        grid._applyThemes();
      }
    }
    renderer.updateTick(dataItem.get("tick"), position2, labelEndPosition, count);
    renderer.updateFill(dataItem.get("axisFill"), position2, fillEndPosition);
    this._processBullet(dataItem);
    renderer.updateBullet(dataItem.get("bullet"), position2, endPosition);
    if (!dataItem.get("isRange")) {
      const fillRule = this.get("fillRule");
      if (fillRule) {
        fillRule(dataItem);
      }
    }
  }
  _handleRangeChange() {
    let selectionMin = this.positionToValue(this.get("start", 0));
    let selectionMax = this.positionToValue(this.get("end", 1));
    const gridCount = this.get("renderer").gridCount();
    let minMaxStep = this._adjustMinMax(selectionMin, selectionMax, gridCount, true);
    let stepDecimalPlaces = decimalPlaces(minMaxStep.step);
    this.setPrivateRaw("stepDecimalPlaces", stepDecimalPlaces);
    selectionMin = round(selectionMin, stepDecimalPlaces);
    selectionMax = round(selectionMax, stepDecimalPlaces);
    minMaxStep = this._adjustMinMax(selectionMin, selectionMax, gridCount, true);
    let step = minMaxStep.step;
    selectionMin = minMaxStep.min;
    selectionMax = minMaxStep.max;
    if (this.getPrivate("selectionMin") !== selectionMin || this.getPrivate("selectionMax") !== selectionMax || this.getPrivate("step") !== step) {
      this.setPrivateRaw("selectionMin", selectionMin);
      this.setPrivateRaw("selectionMax", selectionMax);
      this.setPrivateRaw("step", step);
    }
  }
  /**
   * Converts a relative position to a corresponding numeric value from axis
   * scale.
   *
   * @param   position  Relative position
   * @return            Value
   */
  positionToValue(position2) {
    const min3 = this.getPrivate("min");
    const max3 = this.getPrivate("max");
    if (!this.get("logarithmic")) {
      return position2 * (max3 - min3) + min3;
    } else {
      return Math.pow(Math.E, (position2 * (Math.log(max3) * Math.LOG10E - Math.log(min3) * Math.LOG10E) + Math.log(min3) * Math.LOG10E) / Math.LOG10E);
    }
  }
  /**
   * Convers value to a relative position on axis.
   *
   * @param   value  Value
   * @return         Relative position
   */
  valueToPosition(value) {
    const min3 = this.getPrivate("min");
    const max3 = this.getPrivate("max");
    if (!this.get("logarithmic")) {
      return (value - min3) / (max3 - min3);
    } else {
      if (value <= 0) {
        let treatZeroAs = this.get("treatZeroAs");
        if (isNumber(treatZeroAs)) {
          value = treatZeroAs;
        }
      }
      return (Math.log(value) * Math.LOG10E - Math.log(min3) * Math.LOG10E) / (Math.log(max3) * Math.LOG10E - Math.log(min3) * Math.LOG10E);
    }
  }
  /**
   * @ignore
   */
  valueToFinalPosition(value) {
    const min3 = this.getPrivate("minFinal");
    const max3 = this.getPrivate("maxFinal");
    if (!this.get("logarithmic")) {
      return (value - min3) / (max3 - min3);
    } else {
      if (value <= 0) {
        let treatZeroAs = this.get("treatZeroAs");
        if (isNumber(treatZeroAs)) {
          value = treatZeroAs;
        }
      }
      return (Math.log(value) * Math.LOG10E - Math.log(min3) * Math.LOG10E) / (Math.log(max3) * Math.LOG10E - Math.log(min3) * Math.LOG10E);
    }
  }
  /**
   * Returns X coordinate in pixels corresponding to specific value.
   *
   * @param   value     Numeric value
   * @param   location  Location
   * @param   baseValue Base value
   * @return            X coordinate
   */
  getX(value, location, baseValue) {
    value = baseValue + (value - baseValue) * location;
    const position2 = this.valueToPosition(value);
    return this._settings.renderer.positionToCoordinate(position2);
  }
  /**
   * Returns X coordinate in pixels corresponding to specific value.
   *
   * @param   value     Numeric value
   * @param   location  Location
   * @param   baseValue Base value
   * @return            X coordinate
   */
  getY(value, location, baseValue) {
    value = baseValue + (value - baseValue) * location;
    const position2 = this.valueToPosition(value);
    return this._settings.renderer.positionToCoordinate(position2);
  }
  /**
   * @ignore
   */
  getDataItemCoordinateX(dataItem, field, _cellLocation, axisLocation) {
    return this._settings.renderer.positionToCoordinate(this.getDataItemPositionX(dataItem, field, _cellLocation, axisLocation));
  }
  /**
   * @ignore
   */
  getDataItemPositionX(dataItem, field, _cellLocation, axisLocation) {
    let value = dataItem.get(field);
    const stackToItem = dataItem.get("stackToItemX");
    if (stackToItem) {
      const series = dataItem.component;
      value = value * axisLocation + series.getStackedXValueWorking(dataItem, field);
    } else {
      value = this._baseValue + (value - this._baseValue) * axisLocation;
    }
    return this.valueToPosition(value);
  }
  /**
   * @ignore
   */
  getDataItemCoordinateY(dataItem, field, _cellLocation, axisLocation) {
    return this._settings.renderer.positionToCoordinate(this.getDataItemPositionY(dataItem, field, _cellLocation, axisLocation));
  }
  /**
   * @ignore
   */
  getDataItemPositionY(dataItem, field, _cellLocation, axisLocation) {
    let value = dataItem.get(field);
    const stackToItem = dataItem.get("stackToItemY");
    if (stackToItem) {
      const series = dataItem.component;
      value = value * axisLocation + series.getStackedYValueWorking(dataItem, field);
    } else {
      value = this._baseValue + (value - this._baseValue) * axisLocation;
    }
    return this.valueToPosition(value);
  }
  /**
   * Returns relative position of axis' `baseValue`.
   *
   * @return  Base value position
   */
  basePosition() {
    return this.valueToPosition(this.baseValue());
  }
  /**
   * Base value of the [[ValueAxis]], which determines positive and negative
   * values.
   *
   * @return Base value
   */
  baseValue() {
    const min3 = Math.min(this.getPrivate("minFinal", -Infinity), this.getPrivate("selectionMin", -Infinity));
    const max3 = Math.max(this.getPrivate("maxFinal", Infinity), this.getPrivate("selectionMax", Infinity));
    let baseValue = this.get("baseValue", 0);
    if (baseValue < min3) {
      baseValue = min3;
    }
    if (baseValue > max3) {
      baseValue = max3;
    }
    return baseValue;
  }
  /**
   * @ignore
   */
  cellEndValue(value) {
    return value;
  }
  fixSmallStep(step) {
    if (1 + step === 1) {
      step *= 2;
      return this.fixSmallStep(step);
    }
    return step;
  }
  _fixMin(min3) {
    return min3;
  }
  _fixMax(max3) {
    return max3;
  }
  _calculateTotals() {
    if (this.get("calculateTotals")) {
      let series = this.series[0];
      if (series) {
        let startIndex = series.startIndex();
        if (series.dataItems.length > 0) {
          if (startIndex > 0) {
            startIndex--;
          }
          let endIndex = series.endIndex();
          if (endIndex < series.dataItems.length) {
            endIndex++;
          }
          let field;
          let vc;
          if (series.get("yAxis") == this) {
            field = "valueY";
            vc = "vcy";
          } else if (series.get("xAxis") == this) {
            field = "valueX";
            vc = "vcx";
          }
          let fieldWorking = field + "Working";
          if (field) {
            for (let i = startIndex; i < endIndex; i++) {
              let sum = 0;
              let total = 0;
              each(this.series, (series2) => {
                if (!series2.get("excludeFromTotal")) {
                  let dataItem = series2.dataItems[i];
                  if (dataItem) {
                    let value = dataItem.get(fieldWorking) * series2.get(vc);
                    if (!isNaN2(value)) {
                      sum += value;
                      total += Math.abs(value);
                    }
                  }
                }
              });
              each(this.series, (series2) => {
                if (!series2.get("excludeFromTotal")) {
                  let dataItem = series2.dataItems[i];
                  if (dataItem) {
                    let value = dataItem.get(fieldWorking) * series2.get(vc);
                    if (!isNaN2(value)) {
                      dataItem.set(field + "Total", total);
                      dataItem.set(field + "Sum", sum);
                      dataItem.set(field + "TotalPercent", value / total * 100);
                    }
                  }
                }
              });
            }
          }
        }
      }
    }
  }
  _getSelectionMinMax() {
    const min3 = this.getPrivate("minFinal");
    const max3 = this.getPrivate("maxFinal");
    const minDefined = this.get("min");
    const maxDefined = this.get("max");
    let extraMin = this.get("extraMin", 0);
    let extraMax = this.get("extraMax", 0);
    if (this.get("logarithmic")) {
      if (this.get("extraMin") == null) {
        extraMin = 0.1;
      }
      if (this.get("extraMax") == null) {
        extraMax = 0.2;
      }
    }
    const gridCount = this.get("renderer").gridCount();
    const selectionStrictMinMax = this.get("strictMinMaxSelection");
    let strictMinMax = this.get("strictMinMax");
    if (isNumber(min3) && isNumber(max3)) {
      let selectionMin = max3;
      let selectionMax = min3;
      each(this.series, (series) => {
        if (!series.get("ignoreMinMax")) {
          let seriesMin;
          let seriesMax;
          const outOfSelection = series.getPrivate("outOfSelection");
          if (series.get("xAxis") === this) {
            if (!outOfSelection) {
              let minX = series.getPrivate("minX");
              let maxX = series.getPrivate("maxX");
              if (series.startIndex() != 0 || series.endIndex() != series.dataItems.length) {
                minX = void 0;
                maxX = void 0;
              }
              seriesMin = series.getPrivate("selectionMinX", minX);
              seriesMax = series.getPrivate("selectionMaxX", maxX);
            }
          } else if (series.get("yAxis") === this) {
            if (!outOfSelection) {
              let minY = series.getPrivate("minY");
              let maxY = series.getPrivate("maxY");
              if (series.startIndex() != 0 || series.endIndex() != series.dataItems.length) {
                minY = void 0;
                maxY = void 0;
              }
              seriesMin = series.getPrivate("selectionMinY", minY);
              seriesMax = series.getPrivate("selectionMaxY", maxY);
            }
          }
          if (!series.isHidden() && !series.isShowing()) {
            if (isNumber(seriesMin)) {
              selectionMin = Math.min(selectionMin, seriesMin);
            }
            if (isNumber(seriesMax)) {
              selectionMax = Math.max(selectionMax, seriesMax);
            }
          }
        }
      });
      this.axisRanges.each((range4) => {
        if (range4.get("affectsMinMax")) {
          let value = range4.get("value");
          if (value != null) {
            selectionMin = Math.min(selectionMin, value);
            selectionMax = Math.max(selectionMax, value);
          }
          value = range4.get("endValue");
          if (value != null) {
            selectionMin = Math.min(selectionMin, value);
            selectionMax = Math.max(selectionMax, value);
          }
        }
      });
      if (selectionMin > selectionMax) {
        [selectionMin, selectionMax] = [selectionMax, selectionMin];
      }
      if (isNumber(minDefined)) {
        if (strictMinMax) {
          selectionMin = minDefined;
        } else {
          selectionMin = min3;
        }
      } else if (strictMinMax) {
        if (isNumber(this._minReal)) {
          selectionMin = this._minReal;
        }
      }
      if (isNumber(maxDefined)) {
        if (strictMinMax) {
          selectionMax = maxDefined;
        } else {
          selectionMax = max3;
        }
      } else if (strictMinMax) {
        if (isNumber(this._maxReal)) {
          selectionMax = this._maxReal;
        }
      }
      if (selectionMin === selectionMax) {
        let smin = selectionMin;
        selectionMin -= this._deltaMinMax;
        selectionMax += this._deltaMinMax;
        if (selectionMin < min3) {
          let d = smin - min3;
          if (d == 0) {
            d = this._deltaMinMax;
          }
          selectionMin = smin - d;
          selectionMax = smin + d;
          strictMinMax = true;
        }
        let minMaxStep2 = this._adjustMinMax(selectionMin, selectionMax, gridCount, strictMinMax);
        selectionMin = minMaxStep2.min;
        selectionMax = minMaxStep2.max;
      }
      let selectionMinReal = selectionMin;
      let selectionMaxReal = selectionMax;
      selectionMin -= (selectionMax - selectionMin) * extraMin;
      selectionMax += (selectionMax - selectionMin) * extraMax;
      let minMaxStep = this._adjustMinMax(selectionMin, selectionMax, gridCount);
      selectionMin = minMaxStep.min;
      selectionMax = minMaxStep.max;
      selectionMin = fitToRange(selectionMin, min3, max3);
      selectionMax = fitToRange(selectionMax, min3, max3);
      minMaxStep = this._adjustMinMax(selectionMin, selectionMax, gridCount, true);
      if (!strictMinMax) {
        selectionMin = minMaxStep.min;
        selectionMax = minMaxStep.max;
      }
      const syncWithAxis = this.get("syncWithAxis");
      if (syncWithAxis) {
        minMaxStep = this._syncAxes(selectionMin, selectionMax, minMaxStep.step, syncWithAxis.getPrivate("selectionMinFinal", syncWithAxis.getPrivate("minFinal", 0)), syncWithAxis.getPrivate("selectionMaxFinal", syncWithAxis.getPrivate("maxFinal", 1)), syncWithAxis.getPrivate("selectionStepFinal", syncWithAxis.getPrivate("step", 1)));
        selectionMin = minMaxStep.min;
        selectionMax = minMaxStep.max;
      }
      if (strictMinMax) {
        if (isNumber(minDefined)) {
          selectionMin = Math.max(selectionMin, minDefined);
        }
        if (isNumber(maxDefined)) {
          selectionMax = Math.min(selectionMax, maxDefined);
        }
      }
      if (selectionStrictMinMax) {
        selectionMin = selectionMinReal - (selectionMax - selectionMin) * extraMin;
        selectionMax = selectionMaxReal + (selectionMax - selectionMin) * extraMax;
      }
      if (this.get("logarithmic")) {
        if (selectionMin <= 0) {
          selectionMin = selectionMinReal * (1 - Math.min(extraMin, 0.99));
        }
        if (selectionMin < min3) {
          selectionMin = min3;
        }
        if (selectionMax > max3) {
          selectionMax = max3;
        }
      }
      let len = Math.min(20, Math.ceil(Math.log(this.getPrivate("maxZoomFactor", 100) + 1) / Math.LN10) + 2);
      let start = round(this.valueToFinalPosition(selectionMin), len);
      let end = round(this.valueToFinalPosition(selectionMax), len);
      this.setPrivateRaw("selectionMinFinal", selectionMin);
      this.setPrivateRaw("selectionMaxFinal", selectionMax);
      this.setPrivateRaw("selectionStepFinal", minMaxStep.step);
      this.zoom(start, end);
    }
  }
  _getMinMax() {
    let minDefined = this.get("min");
    let maxDefined = this.get("max");
    let min3 = Infinity;
    let max3 = -Infinity;
    let extraMin = this.get("extraMin", 0);
    let extraMax = this.get("extraMax", 0);
    if (this.get("logarithmic")) {
      if (this.get("extraMin") == null) {
        extraMin = 0.1;
      }
      if (this.get("extraMax") == null) {
        extraMax = 0.2;
      }
    }
    let minDiff = Infinity;
    each(this.series, (series) => {
      if (!series.get("ignoreMinMax")) {
        let seriesMin;
        let seriesMax;
        if (series.get("xAxis") === this) {
          seriesMin = series.getPrivate("minX");
          seriesMax = series.getPrivate("maxX");
        } else if (series.get("yAxis") === this) {
          seriesMin = series.getPrivate("minY");
          seriesMax = series.getPrivate("maxY");
        }
        if (isNumber(seriesMin) && isNumber(seriesMax)) {
          min3 = Math.min(min3, seriesMin);
          max3 = Math.max(max3, seriesMax);
          let diff = seriesMax - seriesMin;
          if (diff <= 0) {
            diff = Math.abs(seriesMax / 100);
          }
          if (diff < minDiff) {
            minDiff = diff;
          }
        }
      }
    });
    this.axisRanges.each((range4) => {
      if (range4.get("affectsMinMax")) {
        let value = range4.get("value");
        if (value != null) {
          min3 = Math.min(min3, value);
          max3 = Math.max(max3, value);
        }
        value = range4.get("endValue");
        if (value != null) {
          min3 = Math.min(min3, value);
          max3 = Math.max(max3, value);
        }
      }
    });
    if (this.get("logarithmic")) {
      let treatZeroAs = this.get("treatZeroAs");
      if (isNumber(treatZeroAs)) {
        if (min3 <= 0) {
          min3 = treatZeroAs;
        }
      }
      if (min3 <= 0) {
        new Error("Logarithmic value axis can not have values <= 0.");
      }
    }
    if (min3 === 0 && max3 === 0) {
      max3 = 0.9;
      min3 = -0.9;
    }
    if (isNumber(minDefined)) {
      min3 = minDefined;
    }
    if (isNumber(maxDefined)) {
      max3 = maxDefined;
    }
    if (min3 === Infinity || max3 === -Infinity) {
      this.setPrivate("minFinal", void 0);
      this.setPrivate("maxFinal", void 0);
      return;
    }
    const initialMin = min3;
    const initialMax = max3;
    let minAdapted = this.adapters.fold("min", min3);
    let maxAdapted = this.adapters.fold("max", max3);
    if (isNumber(minAdapted)) {
      min3 = minAdapted;
    }
    if (isNumber(maxAdapted)) {
      max3 = maxAdapted;
    }
    min3 = this._fixMin(min3);
    max3 = this._fixMax(max3);
    if (max3 - min3 <= 1 / Math.pow(10, 15)) {
      if (max3 - min3 !== 0) {
        this._deltaMinMax = (max3 - min3) / 2;
      } else {
        this._getDelta(max3);
      }
      min3 -= this._deltaMinMax;
      max3 += this._deltaMinMax;
    }
    min3 -= (max3 - min3) * extraMin;
    max3 += (max3 - min3) * extraMax;
    if (this.get("logarithmic")) {
      if (min3 < 0 && initialMin >= 0) {
        min3 = 0;
      }
      if (max3 > 0 && initialMax <= 0) {
        max3 = 0;
      }
    }
    this._minReal = min3;
    this._maxReal = max3;
    let strictMinMax = this.get("strictMinMax");
    let strictMinMaxSelection = this.get("strictMinMaxSelection", false);
    if (strictMinMaxSelection) {
      strictMinMax = strictMinMaxSelection;
    }
    let strict = strictMinMax;
    if (isNumber(maxDefined)) {
      strict = true;
    }
    let gridCount = this.get("renderer").gridCount();
    let minMaxStep = this._adjustMinMax(min3, max3, gridCount, strict);
    min3 = minMaxStep.min;
    max3 = minMaxStep.max;
    minMaxStep = this._adjustMinMax(min3, max3, gridCount, true);
    min3 = minMaxStep.min;
    max3 = minMaxStep.max;
    if (strictMinMax) {
      if (isNumber(minDefined)) {
        min3 = minDefined;
      } else {
        min3 = this._minReal;
      }
      if (isNumber(maxDefined)) {
        max3 = maxDefined;
      } else {
        max3 = this._maxReal;
      }
      if (max3 - min3 <= 1e-8) {
        min3 -= this._deltaMinMax;
        max3 += this._deltaMinMax;
      }
      min3 -= (max3 - min3) * extraMin;
      max3 += (max3 - min3) * extraMax;
    }
    minAdapted = this.adapters.fold("min", min3);
    maxAdapted = this.adapters.fold("max", max3);
    if (isNumber(minAdapted)) {
      min3 = minAdapted;
    }
    if (isNumber(maxAdapted)) {
      max3 = maxAdapted;
    }
    if (minDiff == Infinity) {
      minDiff = max3 - min3;
    }
    let decCount = Math.round(Math.abs(Math.log(Math.abs(max3 - min3)) * Math.LOG10E)) + 5;
    min3 = round(min3, decCount);
    max3 = round(max3, decCount);
    const syncWithAxis = this.get("syncWithAxis");
    if (syncWithAxis) {
      minMaxStep = this._syncAxes(min3, max3, minMaxStep.step, syncWithAxis.getPrivate("minFinal", syncWithAxis.getPrivate("min", 0)), syncWithAxis.getPrivate("maxFinal", syncWithAxis.getPrivate("max", 1)), syncWithAxis.getPrivate("step", 1));
      min3 = minMaxStep.min;
      max3 = minMaxStep.max;
    }
    this.setPrivateRaw("maxZoomFactor", Math.max(1, Math.ceil((max3 - min3) / minDiff * this.get("maxZoomFactor", 100))));
    this._fixZoomFactor();
    if (this.get("logarithmic")) {
      this._minLogAdjusted = min3;
      min3 = this._minReal;
      max3 = this._maxReal;
      if (min3 <= 0) {
        min3 = initialMin * (1 - Math.min(extraMin, 0.99));
      }
    }
    if (isNumber(min3) && isNumber(max3)) {
      if (this.getPrivate("minFinal") !== min3 || this.getPrivate("maxFinal") !== max3) {
        this.setPrivate("minFinal", min3);
        this.setPrivate("maxFinal", max3);
        this._saveMinMax(min3, max3);
        const duration = this.get("interpolationDuration", 0);
        const easing = this.get("interpolationEasing");
        this.animatePrivate({ key: "min", to: min3, duration, easing });
        this.animatePrivate({ key: "max", to: max3, duration, easing });
      }
    }
  }
  _fixZoomFactor() {
  }
  _getDelta(max3) {
    let exponent = Math.log(Math.abs(max3)) * Math.LOG10E;
    let power = Math.pow(10, Math.floor(exponent));
    power = power / 10;
    this._deltaMinMax = power;
  }
  _saveMinMax(_min, _max) {
  }
  _adjustMinMax(min3, max3, gridCount, strictMode) {
    if (gridCount <= 1) {
      gridCount = 1;
    }
    gridCount = Math.round(gridCount);
    let initialMin = min3;
    let initialMax = max3;
    let difference = max3 - min3;
    if (difference === 0) {
      difference = Math.abs(max3);
    }
    let exponent = Math.log(Math.abs(difference)) * Math.LOG10E;
    let power = Math.pow(10, Math.floor(exponent));
    power = power / 10;
    let extra = power;
    if (strictMode) {
      extra = 0;
    }
    if (strictMode) {
      min3 = Math.floor(min3 / power) * power;
      max3 = Math.ceil(max3 / power) * power;
    } else {
      min3 = Math.ceil(min3 / power) * power - extra;
      max3 = Math.floor(max3 / power) * power + extra;
    }
    if (min3 < 0 && initialMin >= 0) {
      min3 = 0;
    }
    if (max3 > 0 && initialMax <= 0) {
      max3 = 0;
    }
    exponent = Math.log(Math.abs(difference)) * Math.LOG10E;
    power = Math.pow(10, Math.floor(exponent));
    power = power / 100;
    let step = Math.ceil(difference / gridCount / power) * power;
    let stepPower = Math.pow(10, Math.floor(Math.log(Math.abs(step)) * Math.LOG10E));
    let stepDivisor = Math.ceil(step / stepPower);
    if (stepDivisor > 5) {
      stepDivisor = 10;
    } else if (stepDivisor <= 5 && stepDivisor > 2) {
      stepDivisor = 5;
    }
    step = Math.ceil(step / (stepPower * stepDivisor)) * stepPower * stepDivisor;
    let maxPrecision = this.get("maxPrecision");
    if (isNumber(maxPrecision)) {
      let ceiledStep = ceil(step, maxPrecision);
      if (maxPrecision < Number.MAX_VALUE && step !== ceiledStep) {
        step = ceiledStep;
      }
    }
    let decCount = 0;
    if (stepPower < 1) {
      decCount = Math.round(Math.abs(Math.log(Math.abs(stepPower)) * Math.LOG10E)) + 1;
      step = round(step, decCount);
    }
    let minCount = Math.floor(min3 / step);
    min3 = round(step * minCount, decCount);
    let maxCount;
    if (!strictMode) {
      maxCount = Math.ceil(max3 / step);
    } else {
      maxCount = Math.floor(max3 / step);
    }
    if (maxCount === minCount) {
      maxCount++;
    }
    max3 = round(step * maxCount, decCount);
    if (max3 < initialMax) {
      max3 = max3 + step;
    }
    if (min3 > initialMin) {
      min3 = min3 - step;
    }
    step = this.fixSmallStep(step);
    return { min: min3, max: max3, step };
  }
  /**
   * Returns text to be used in an axis tooltip for specific relative position.
   *
   * @param   position  Position
   * @return            Tooltip text
   */
  getTooltipText(position2, _adjustPosition) {
    const numberFormat = this.get("tooltipNumberFormat", this.get("numberFormat"));
    const formatter = this.getNumberFormatter();
    const extraDecimals = this.get("extraTooltipPrecision", 0);
    const decimals = this.getPrivate("stepDecimalPlaces", 0) + extraDecimals;
    const value = round(this.positionToValue(position2), decimals);
    if (numberFormat) {
      return formatter.format(value, numberFormat);
    } else {
      return formatter.format(value, void 0, decimals);
    }
  }
  /**
   * Returns a data item from series that is closest to the `position`.
   *
   * @param   series    Series
   * @param   position  Relative position
   * @return            Data item
   */
  getSeriesItem(series, position2) {
    let fieldName = this.getPrivate("name") + this.get("renderer").getPrivate("letter");
    let value = this.positionToValue(position2);
    let index2 = void 0;
    let oldDiff;
    each(series.dataItems, (dataItem, i) => {
      const diff = Math.abs(dataItem.get(fieldName) - value);
      if (index2 === void 0 || diff < oldDiff) {
        index2 = i;
        oldDiff = diff;
      }
    });
    if (index2 != null) {
      return series.dataItems[index2];
    }
  }
  /**
   * Zooms the axis to specific `start` and `end` values.
   *
   * Optional `duration` specifies duration of zoom animation in milliseconds.
   *
   * @param  start     Start value
   * @param  end       End value
   * @param  duration  Duration in milliseconds
   */
  zoomToValues(start, end, duration) {
    const min3 = this.getPrivate("minFinal", 0);
    const max3 = this.getPrivate("maxFinal", 0);
    if (this.getPrivate("min") != null && this.getPrivate("max") != null) {
      this.zoom((start - min3) / (max3 - min3), (end - min3) / (max3 - min3), duration);
    }
  }
  /**
   * Syncs with a target axis.
   *
   * @param  min  Min
   * @param  max  Max
   * @param  step Step
   */
  _syncAxes(min3, max3, step, syncMin, syncMax, syncStep) {
    let axis = this.get("syncWithAxis");
    if (axis) {
      let count = Math.round(syncMax - syncMin) / syncStep;
      let currentCount = Math.round((max3 - min3) / step);
      let gridCount = this.get("renderer").gridCount();
      if (isNumber(count) && isNumber(currentCount)) {
        let synced = false;
        let c = 0;
        let diff = (max3 - min3) * 0.01;
        let omin = min3;
        let omax = max3;
        let ostep = step;
        while (synced != true) {
          synced = this._checkSync(omin, omax, ostep, count);
          c++;
          if (c > 500) {
            synced = true;
          }
          if (!synced) {
            if (c / 3 == Math.round(c / 3)) {
              omin = min3 - diff * c;
              if (min3 >= 0 && omin < 0) {
                omin = 0;
              }
            } else {
              omax = max3 + diff * c;
              if (omax <= 0 && omax > 0) {
                omax = 0;
              }
            }
            let minMaxStep = this._adjustMinMax(omin, omax, gridCount, true);
            omin = minMaxStep.min;
            omax = minMaxStep.max;
            ostep = minMaxStep.step;
          } else {
            min3 = omin;
            max3 = omax;
            step = ostep;
          }
        }
      }
    }
    return { min: min3, max: max3, step };
  }
  /**
   * Returns `true` if axis needs to be resunced with some other axis.
   */
  _checkSync(min3, max3, step, count) {
    let currentCount = (max3 - min3) / step;
    for (let i = 1; i < count; i++) {
      if (round(currentCount / i, 1) == count || currentCount * i == count) {
        return true;
      }
    }
    return false;
  }
  /**
   * Returns relative position between two grid lines of the axis.
   *
   * @return Position
   */
  getCellWidthPosition() {
    let max3 = this.getPrivate("selectionMax", this.getPrivate("max"));
    let min3 = this.getPrivate("selectionMin", this.getPrivate("min"));
    if (isNumber(max3) && isNumber(min3)) {
      return this.getPrivate("step", 1) / (max3 - min3);
    }
    return 0.05;
  }
};
Object.defineProperty(ValueAxis, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "ValueAxis"
});
Object.defineProperty(ValueAxis, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Axis.classNames.concat([ValueAxis.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/AxisLabel.js
var AxisLabel = class extends Label {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_tickPoints", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
  }
};
Object.defineProperty(AxisLabel, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisLabel"
});
Object.defineProperty(AxisLabel, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Label.classNames.concat([AxisLabel.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/AxisLabelRadial.js
var AxisLabelRadial = class extends RadialLabel {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_tickPoints", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
  }
};
Object.defineProperty(AxisLabelRadial, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisLabelRadial"
});
Object.defineProperty(AxisLabelRadial, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: RadialLabel.classNames.concat([AxisLabelRadial.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/AxisTick.js
var AxisTick = class extends Tick {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_tickPoints", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
  }
};
Object.defineProperty(AxisTick, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisTick"
});
Object.defineProperty(AxisTick, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Tick.classNames.concat([AxisTick.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/AxisRenderer.js
var AxisRenderer = class extends Graphics {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_axisLength", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 100
    });
    Object.defineProperty(this, "_start", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_end", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "_inversed", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(this, "_minSize", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "chart", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_lc", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
    Object.defineProperty(this, "_ls", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_thumbDownPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_downStart", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_downEnd", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "ticks", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => AxisTick._new(this._root, {
        themeTags: mergeTags(this.ticks.template.get("themeTags", []), this.get("themeTags", []))
      }, [this.ticks.template]))
    });
    Object.defineProperty(this, "grid", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => Grid._new(this._root, {
        themeTags: mergeTags(this.grid.template.get("themeTags", []), this.get("themeTags", []))
      }, [this.grid.template]))
    });
    Object.defineProperty(this, "axisFills", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => Graphics._new(this._root, {
        themeTags: mergeTags(this.axisFills.template.get("themeTags", ["axis", "fill"]), this.get("themeTags", []))
      }, [this.axisFills.template]))
    });
    Object.defineProperty(this, "labels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => AxisLabel._new(this._root, {
        themeTags: mergeTags(this.labels.template.get("themeTags", []), this.get("themeTags", []))
      }, [this.labels.template]))
    });
    Object.defineProperty(this, "axis", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "thumb", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
  }
  /**
   * @ignore
   */
  makeTick(dataItem, themeTags) {
    const tick = this.ticks.make();
    tick._setDataItem(dataItem);
    dataItem.setRaw("tick", tick);
    tick.set("themeTags", mergeTags(tick.get("themeTags"), themeTags));
    this.axis.labelsContainer.children.push(tick);
    this.ticks.push(tick);
    return tick;
  }
  /**
   * @ignore
   */
  makeGrid(dataItem, themeTags) {
    const grid = this.grid.make();
    grid._setDataItem(dataItem);
    dataItem.setRaw("grid", grid);
    grid.set("themeTags", mergeTags(grid.get("themeTags"), themeTags));
    this.axis.gridContainer.children.push(grid);
    this.grid.push(grid);
    return grid;
  }
  /**
   * @ignore
   */
  makeAxisFill(dataItem, themeTags) {
    const axisFill = this.axisFills.make();
    axisFill._setDataItem(dataItem);
    axisFill.set("themeTags", mergeTags(axisFill.get("themeTags"), themeTags));
    this.axis.gridContainer.children.push(axisFill);
    dataItem.setRaw("axisFill", axisFill);
    this.axisFills.push(axisFill);
    return axisFill;
  }
  /**
   * @ignore
   */
  makeLabel(dataItem, themeTags) {
    const label = this.labels.make();
    label.set("themeTags", mergeTags(label.get("themeTags"), themeTags));
    this.axis.labelsContainer.children.moveValue(label, 0);
    label._setDataItem(dataItem);
    dataItem.setRaw("label", label);
    this.labels.push(label);
    return label;
  }
  axisLength() {
    return 0;
  }
  /**
   * @ignore
   */
  gridCount() {
    return this.axisLength() / this.get("minGridDistance", 50);
  }
  _updatePositions() {
  }
  _afterNew() {
    super._afterNew();
    this.set("isMeasured", false);
    const thumb = this.thumb;
    if (thumb) {
      this._disposers.push(thumb.events.on("pointerdown", (event) => {
        this._handleThumbDown(event);
      }));
      this._disposers.push(thumb.events.on("globalpointerup", (event) => {
        this._handleThumbUp(event);
      }));
      this._disposers.push(thumb.events.on("globalpointermove", (event) => {
        this._handleThumbMove(event);
      }));
    }
  }
  _beforeChanged() {
    super._beforeChanged();
    if (this.isDirty("minGridDistance")) {
      this.root.events.once("frameended", () => {
        this.axis.markDirtySize();
      });
    }
  }
  _changed() {
    super._changed();
    if (this.isDirty("pan")) {
      const thumb = this.thumb;
      if (thumb) {
        const labelsContainer = this.axis.labelsContainer;
        const pan = this.get("pan");
        if (pan == "zoom") {
          labelsContainer.children.push(thumb);
        } else if (pan == "none") {
          labelsContainer.children.removeValue(thumb);
        }
      }
    }
  }
  _handleThumbDown(event) {
    this._thumbDownPoint = this.toLocal(event.point);
    const axis = this.axis;
    this._downStart = axis.get("start");
    this._downEnd = axis.get("end");
  }
  _handleThumbUp(_event) {
    this._thumbDownPoint = void 0;
  }
  _handleThumbMove(event) {
    const downPoint = this._thumbDownPoint;
    if (downPoint) {
      const point2 = this.toLocal(event.point);
      const downStart = this._downStart;
      const downEnd = this._downEnd;
      const extra = this._getPan(point2, downPoint) * Math.min(1, downEnd - downStart) / 2;
      this.axis.zoom(downStart - extra, downEnd + extra, 0);
    }
  }
  _getPan(_point1, _point2) {
    return 0;
  }
  /**
   * Converts relative position (0-1) on axis to a pixel coordinate.
   *
   * @param position  Position (0-1)
   * @return Coordinate (px)
   */
  positionToCoordinate(position2) {
    if (this._inversed) {
      return (this._end - position2) * this._axisLength;
    } else {
      return (position2 - this._start) * this._axisLength;
    }
  }
  /**
   * @ignore
   */
  updateTooltipBounds(_tooltip) {
  }
  _updateSize() {
    this.markDirty();
    this._clear = true;
  }
  /**
   * @ignore
   */
  toAxisPosition(position2) {
    const start = this._start || 0;
    const end = this._end || 1;
    position2 = position2 * (end - start);
    if (!this.get("inversed")) {
      position2 = start + position2;
    } else {
      position2 = end - position2;
    }
    return position2;
  }
  /**
   * @ignore
   */
  toGlobalPosition(position2) {
    const start = this._start || 0;
    const end = this._end || 1;
    if (!this.get("inversed")) {
      position2 = position2 - start;
    } else {
      position2 = end - position2;
    }
    position2 = position2 / (end - start);
    return position2;
  }
  /**
   * @ignore
   */
  fixPosition(position2) {
    if (this.get("inversed")) {
      return 1 - position2;
    }
    return position2;
  }
  /**
   * @ignore
   */
  _updateLC() {
  }
  toggleVisibility(sprite, position2, minPosition, maxPosition) {
    let axis = this.axis;
    const start = axis.get("start", 0);
    const end = axis.get("end", 1);
    let updatedStart = start + (end - start) * (minPosition - 1e-4);
    let updatedEnd = start + (end - start) * (maxPosition + 1e-4);
    if (position2 < updatedStart || position2 > updatedEnd) {
      sprite.setPrivate("visible", false);
    } else {
      sprite.setPrivate("visible", true);
    }
  }
  _positionTooltip(tooltip, point2) {
    const chart = this.chart;
    if (chart) {
      if (chart.inPlot(point2)) {
        tooltip.set("pointTo", this._display.toGlobal(point2));
      } else {
        tooltip.hide();
      }
    }
  }
  processAxis() {
  }
};
Object.defineProperty(AxisRenderer, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisRenderer"
});
Object.defineProperty(AxisRenderer, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Graphics.classNames.concat([AxisRenderer.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/AxisRendererX.js
var AxisRendererX = class extends AxisRenderer {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "thumb", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Rectangle.new(this._root, { width: p100, isMeasured: false, themeTags: ["axis", "x", "thumb"] })
    });
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["renderer", "x"]);
    super._afterNew();
    this.setPrivateRaw("letter", "X");
    const gridTemplate = this.grid.template;
    gridTemplate.set("height", p100);
    gridTemplate.set("width", 0);
    gridTemplate.set("draw", (display, graphics) => {
      display.moveTo(0, 0);
      display.lineTo(0, graphics.height());
    });
    this.set("draw", (display, graphics) => {
      display.moveTo(0, 0);
      display.lineTo(graphics.width(), 0);
    });
  }
  _changed() {
    super._changed();
    const axis = this.axis;
    axis.ghostLabel.setPrivate("visible", !this.get("inside"));
    axis.ghostLabel.set("x", -1e3);
    const opposite = "opposite";
    const inside = "inside";
    if (this.isDirty(opposite) || this.isDirty(inside)) {
      const chart = this.chart;
      const axisChildren = axis.children;
      if (this.get(inside)) {
        axis.addTag(inside);
      } else {
        axis.removeTag(inside);
      }
      if (chart) {
        if (this.get(opposite)) {
          const children = chart.topAxesContainer.children;
          if (children.indexOf(axis) == -1) {
            children.insertIndex(0, axis);
          }
          axis.addTag(opposite);
          axisChildren.moveValue(this);
        } else {
          const children = chart.bottomAxesContainer.children;
          if (children.indexOf(axis) == -1) {
            children.moveValue(axis);
          }
          axis.removeTag(opposite);
          axisChildren.moveValue(this, 0);
        }
        axis.ghostLabel._applyThemes();
        this.labels.each((label) => {
          label._applyThemes();
        });
        this.root._markDirtyRedraw();
      }
      axis.markDirtySize();
    }
    this.thumb.setPrivate("height", axis.labelsContainer.height());
  }
  _getPan(point1, point2) {
    return (point2.x - point1.x) / this.width();
  }
  /**
   * @ignore
   */
  toAxisPosition(position2) {
    const start = this._start || 0;
    const end = this._end || 1;
    position2 -= this._ls;
    position2 = position2 * (end - start) / this._lc;
    if (!this.get("inversed")) {
      position2 = start + position2;
    } else {
      position2 = end - position2;
    }
    return position2;
  }
  /**
   * @ignore
   */
  toGlobalPosition(position2) {
    const start = this._start || 0;
    const end = this._end || 1;
    if (!this.get("inversed")) {
      position2 = position2 - start;
    } else {
      position2 = end - position2;
    }
    position2 = position2 / (end - start) * this._lc;
    position2 += this._ls;
    return position2;
  }
  /**
   * @ignore
   */
  _updateLC() {
    const axis = this.axis;
    const parent = axis.parent;
    if (parent) {
      const w = parent.innerWidth();
      this._lc = this.axisLength() / w;
      this._ls = (axis.x() - parent.get("paddingLeft", 0)) / w;
    }
  }
  /**
   * @ignore
   */
  _updatePositions() {
    const axis = this.axis;
    const x2 = axis.x() - relativeToValue(axis.get("centerX", 0), axis.width()) - axis.parent.get("paddingLeft", 0);
    axis.gridContainer.set("x", x2);
    axis.topGridContainer.set("x", x2);
    axis.bulletsContainer.set("y", this.y());
    const chart = axis.chart;
    if (chart) {
      const plotContainer = chart.plotContainer;
      const axisHeader = axis.axisHeader;
      let width = axis.get("marginLeft", 0);
      let x3 = axis.x() - width;
      const parent = axis.parent;
      if (parent) {
        x3 -= parent.get("paddingLeft", 0);
      }
      if (axisHeader.children.length > 0) {
        width = axis.axisHeader.width();
        axis.set("marginLeft", width + 1);
      } else {
        axisHeader.set("width", width);
      }
      axisHeader.setAll({ x: x3, y: -1, height: plotContainer.height() + 2 });
    }
  }
  /**
   * @ignore
   */
  processAxis() {
    super.processAxis();
    const axis = this.axis;
    if (axis.get("width") == null) {
      axis.set("width", p100);
    }
    ;
    const verticalLayout = this._root.verticalLayout;
    axis.set("layout", verticalLayout);
    axis.labelsContainer.set("width", p100);
    axis.axisHeader.setAll({ layout: verticalLayout });
  }
  /**
   * @ignore
   */
  axisLength() {
    return this.axis.width();
  }
  /**
   * Converts axis relative position to actual coordinate in pixels.
   *
   * @param   position  Position
   * @return            Point
   */
  positionToPoint(position2) {
    return { x: this.positionToCoordinate(position2), y: 0 };
  }
  /**
   * @ignore
   */
  updateTick(tick, position2, endPosition, count) {
    if (tick) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      let location = 0.5;
      if (isNumber(count) && count > 1) {
        location = tick.get("multiLocation", location);
      } else {
        location = tick.get("location", location);
      }
      if (isNumber(endPosition) && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      tick.set("x", this.positionToCoordinate(position2));
      let length2 = tick.get("length", 0);
      const inside = tick.get("inside", this.get("inside", false));
      if (this.get("opposite")) {
        tick.set("y", p100);
        if (!inside) {
          length2 *= -1;
        }
      } else {
        tick.set("y", 0);
        if (inside) {
          length2 *= -1;
        }
      }
      tick.set("draw", (display) => {
        display.moveTo(0, 0);
        display.lineTo(0, length2);
      });
      this.toggleVisibility(tick, position2, tick.get("minPosition", 0), tick.get("maxPosition", 1));
    }
  }
  /**
   * @ignore
   */
  updateLabel(label, position2, endPosition, count) {
    if (label) {
      let location = 0.5;
      if (isNumber(count) && count > 1) {
        location = label.get("multiLocation", location);
      } else {
        location = label.get("location", location);
      }
      if (!isNumber(position2)) {
        position2 = 0;
      }
      const inside = label.get("inside", this.get("inside", false));
      const opposite = this.get("opposite");
      if (opposite) {
        if (!inside) {
          label.set("position", "relative");
          label.set("y", p100);
        } else {
          label.set("position", "absolute");
          label.set("y", 0);
        }
      } else {
        if (!inside) {
          label.set("y", void 0);
          label.set("position", "relative");
        } else {
          label.set("y", 0);
          label.set("position", "absolute");
        }
      }
      if (isNumber(endPosition) && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      label.set("x", this.positionToCoordinate(position2));
      this.toggleVisibility(label, position2, label.get("minPosition", 0), label.get("maxPosition", 1));
    }
  }
  /**
   * @ignore
   */
  updateGrid(grid, position2, endPosition) {
    if (grid) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      let location = grid.get("location", 0.5);
      if (isNumber(endPosition) && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      grid.set("x", this.positionToCoordinate(position2));
      this.toggleVisibility(grid, position2, 0, 1);
    }
  }
  /**
   * @ignore
   */
  updateBullet(bullet, position2, endPosition) {
    if (bullet) {
      const sprite = bullet.get("sprite");
      if (sprite) {
        if (!isNumber(position2)) {
          position2 = 0;
        }
        let location = bullet.get("location", 0.5);
        if (isNumber(endPosition) && endPosition != position2) {
          position2 = position2 + (endPosition - position2) * location;
        }
        let bulletPosition = this.axis.roundAxisPosition(position2, location);
        let previousBullet = this.axis._bullets[bulletPosition];
        let d = -1;
        if (this.get("opposite")) {
          d = 1;
        }
        if (bullet.get("stacked")) {
          if (previousBullet) {
            let previousSprite = previousBullet.get("sprite");
            if (previousSprite) {
              sprite.set("y", previousSprite.y() + previousSprite.height() * d);
            }
          } else {
            sprite.set("y", 0);
          }
        }
        this.axis._bullets[bulletPosition] = bullet;
        sprite.set("x", this.positionToCoordinate(position2));
        this.toggleVisibility(sprite, position2, 0, 1);
      }
    }
  }
  /**
   * @ignore
   */
  updateFill(fill, position2, endPosition) {
    if (fill) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      if (!isNumber(endPosition)) {
        endPosition = 1;
      }
      let x0 = this.positionToCoordinate(position2);
      let x1 = this.positionToCoordinate(endPosition);
      this.fillDrawMethod(fill, x0, x1);
    }
  }
  fillDrawMethod(fill, x0, x1) {
    fill.set("draw", (display) => {
      const h = this.axis.gridContainer.height();
      const w = this.width();
      if (x1 < x0) {
        [x1, x0] = [x0, x1];
      }
      if (x0 > w || x1 < 0) {
        return;
      }
      display.moveTo(x0, 0);
      display.lineTo(x1, 0);
      display.lineTo(x1, h);
      display.lineTo(x0, h);
      display.lineTo(x0, 0);
    });
  }
  /**
   * @ignore
   */
  positionTooltip(tooltip, position2) {
    this._positionTooltip(tooltip, { x: this.positionToCoordinate(position2), y: 0 });
  }
  /**
   * @ignore
   */
  updateTooltipBounds(tooltip) {
    const inside = this.get("inside");
    const num = 1e5;
    let global2 = this._display.toGlobal({ x: 0, y: 0 });
    let x2 = global2.x;
    let y2 = 0;
    let w = this.axisLength();
    let h = num;
    let pointerOrientation = "up";
    if (this.get("opposite")) {
      if (inside) {
        pointerOrientation = "up";
        y2 = global2.y;
        h = num;
      } else {
        pointerOrientation = "down";
        y2 = global2.y - num;
        h = num;
      }
    } else {
      if (inside) {
        pointerOrientation = "down";
        y2 = global2.y - num;
        h = num;
      } else {
        pointerOrientation = "up";
        y2 = global2.y;
        h = num;
      }
    }
    const bounds = { left: x2, right: x2 + w, top: y2, bottom: y2 + h };
    const oldBounds = tooltip.get("bounds");
    if (!sameBounds(bounds, oldBounds)) {
      tooltip.set("bounds", bounds);
      tooltip.set("pointerOrientation", pointerOrientation);
    }
  }
};
Object.defineProperty(AxisRendererX, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisRendererX"
});
Object.defineProperty(AxisRendererX, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: AxisRenderer.classNames.concat([AxisRendererX.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/axes/AxisRendererY.js
var AxisRendererY = class extends AxisRenderer {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_downY", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "thumb", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: Rectangle.new(this._root, { height: p100, isMeasured: false, themeTags: ["axis", "y", "thumb"] })
    });
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["renderer", "y"]);
    if (this._settings.opposite) {
      this._settings.themeTags.push("opposite");
    }
    super._afterNew();
    this.setPrivateRaw("letter", "Y");
    const gridTemplate = this.grid.template;
    gridTemplate.set("width", p100);
    gridTemplate.set("height", 0);
    gridTemplate.set("draw", (display, graphics) => {
      display.moveTo(0, 0);
      display.lineTo(graphics.width(), 0);
    });
    this.set("draw", (display, renderer) => {
      display.moveTo(0, 0);
      display.lineTo(0, renderer.height());
    });
  }
  _getPan(point1, point2) {
    return (point1.y - point2.y) / this.height();
  }
  _changed() {
    super._changed();
    const axis = this.axis;
    axis.ghostLabel.setPrivate("visible", !this.get("inside"));
    axis.ghostLabel.set("y", -1e3);
    const thumb = this.thumb;
    const opposite = "opposite";
    const inside = "inside";
    const chart = this.chart;
    if (this.isDirty(opposite) || this.isDirty(inside)) {
      const axisChildren = axis.children;
      if (this.get(inside)) {
        axis.addTag(inside);
      } else {
        axis.removeTag(inside);
      }
      if (chart) {
        if (this.get(opposite)) {
          const children = chart.rightAxesContainer.children;
          if (children.indexOf(axis) == -1) {
            children.moveValue(axis, 0);
          }
          axis.addTag(opposite);
          axisChildren.moveValue(this, 0);
        } else {
          const children = chart.leftAxesContainer.children;
          if (children.indexOf(axis) == -1) {
            children.moveValue(axis);
          }
          axis.removeTag(opposite);
          axisChildren.moveValue(this);
        }
        axis.ghostLabel._applyThemes();
        this.labels.each((label) => {
          label._applyThemes();
        });
        this.root._markDirtyRedraw();
      }
      axis.markDirtySize();
    }
    const w = axis.labelsContainer.width();
    if (chart) {
      if (this.get(opposite)) {
        thumb.set("centerX", 0);
      } else {
        thumb.set("centerX", w);
      }
    }
    thumb.setPrivate("width", w);
  }
  /**
   * @ignore
   */
  processAxis() {
    super.processAxis();
    const axis = this.axis;
    if (axis.get("height") == null) {
      axis.set("height", p100);
    }
    const horizontalLayout = this._root.horizontalLayout;
    axis.set("layout", horizontalLayout);
    axis.labelsContainer.set("height", p100);
    axis.axisHeader.set("layout", horizontalLayout);
  }
  _updatePositions() {
    const axis = this.axis;
    const y2 = axis.y() - relativeToValue(axis.get("centerY", 0), axis.height());
    axis.gridContainer.set("y", y2);
    axis.topGridContainer.set("y", y2);
    axis.bulletsContainer.set("x", this.x());
    const chart = axis.chart;
    if (chart) {
      const plotContainer = chart.plotContainer;
      const axisHeader = axis.axisHeader;
      let height = axis.get("marginTop", 0);
      if (axisHeader.children.length > 0) {
        height = axis.axisHeader.height();
        axis.set("marginTop", height + 1);
      } else {
        axisHeader.set("height", height);
      }
      axisHeader.setAll({ y: axis.y() - height, x: -1, width: plotContainer.width() + 2 });
    }
  }
  /**
   * @ignore
   */
  axisLength() {
    return this.axis.innerHeight();
  }
  /**
   * Converts axis relative position to actual coordinate in pixels.
   *
   * @param   position  Position
   * @return            Point
   */
  positionToPoint(position2) {
    return { x: 0, y: this.positionToCoordinate(position2) };
  }
  /**
   * @ignore
   */
  updateLabel(label, position2, endPosition, count) {
    if (label) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      let location = 0.5;
      if (isNumber(count) && count > 1) {
        location = label.get("multiLocation", location);
      } else {
        location = label.get("location", location);
      }
      const opposite = this.get("opposite");
      const inside = label.get("inside", this.get("inside", false));
      if (opposite) {
        label.set("x", 0);
        if (inside) {
          label.set("position", "absolute");
        } else {
          label.set("position", "relative");
        }
      } else {
        if (inside) {
          label.set("x", 0);
          label.set("position", "absolute");
        } else {
          label.set("x", void 0);
          label.set("position", "relative");
        }
      }
      if (isNumber(endPosition) && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      label.set("y", this.positionToCoordinate(position2));
      this.toggleVisibility(label, position2, label.get("minPosition", 0), label.get("maxPosition", 1));
    }
  }
  /**
   * @ignore
   */
  updateGrid(grid, position2, endPosition) {
    if (grid) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      let location = grid.get("location", 0.5);
      if (isNumber(endPosition) && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      grid.set("y", this.positionToCoordinate(position2));
      this.toggleVisibility(grid, position2, 0, 1);
    }
  }
  /**
   * @ignore
   */
  updateTick(tick, position2, endPosition, count) {
    if (tick) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      let location = 0.5;
      if (isNumber(count) && count > 1) {
        location = tick.get("multiLocation", location);
      } else {
        location = tick.get("location", location);
      }
      if (isNumber(endPosition) && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      tick.set("y", this.positionToCoordinate(position2));
      let length2 = tick.get("length", 0);
      const inside = tick.get("inside", this.get("inside", false));
      if (this.get("opposite")) {
        tick.set("x", 0);
        if (inside) {
          length2 *= -1;
        }
      } else {
        if (!inside) {
          length2 *= -1;
        }
      }
      tick.set("draw", (display) => {
        display.moveTo(0, 0);
        display.lineTo(length2, 0);
      });
      this.toggleVisibility(tick, position2, tick.get("minPosition", 0), tick.get("maxPosition", 1));
    }
  }
  /**
   * @ignore
   */
  updateBullet(bullet, position2, endPosition) {
    if (bullet) {
      const sprite = bullet.get("sprite");
      if (sprite) {
        if (!isNumber(position2)) {
          position2 = 0;
        }
        let location = bullet.get("location", 0.5);
        if (isNumber(endPosition) && endPosition != position2) {
          position2 = position2 + (endPosition - position2) * location;
        }
        let bulletPosition = this.axis.roundAxisPosition(position2, location);
        let previousBullet = this.axis._bullets[bulletPosition];
        let d = 1;
        if (this.get("opposite")) {
          d = -1;
        }
        if (bullet.get("stacked")) {
          if (previousBullet) {
            let previousSprite = previousBullet.get("sprite");
            if (previousSprite) {
              sprite.set("x", previousSprite.x() + previousSprite.width() * d);
            }
          } else {
            sprite.set("x", 0);
          }
        }
        this.axis._bullets[bulletPosition] = bullet;
        sprite.set("y", this.positionToCoordinate(position2));
        this.toggleVisibility(sprite, position2, 0, 1);
      }
    }
  }
  /**
   * @ignore
   */
  updateFill(fill, position2, endPosition) {
    if (fill) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      if (!isNumber(endPosition)) {
        endPosition = 1;
      }
      let y0 = this.positionToCoordinate(position2);
      let y1 = this.positionToCoordinate(endPosition);
      this.fillDrawMethod(fill, y0, y1);
    }
  }
  fillDrawMethod(fill, y0, y1) {
    fill.set("draw", (display) => {
      const w = this.axis.gridContainer.width();
      const h = this.height();
      if (y1 < y0) {
        [y1, y0] = [y0, y1];
      }
      if (y0 > h || y1 < 0) {
        return;
      }
      display.moveTo(0, y0);
      display.lineTo(w, y0);
      display.lineTo(w, y1);
      display.lineTo(0, y1);
      display.lineTo(0, y0);
    });
  }
  /**
   * Converts relative position (0-1) on axis to a pixel coordinate.
   *
   * @param position  Position (0-1)
   * @return Coordinate (px)
   */
  positionToCoordinate(position2) {
    if (!this._inversed) {
      return (this._end - position2) * this._axisLength;
    } else {
      return (position2 - this._start) * this._axisLength;
    }
  }
  /**
   * @ignore
   */
  positionTooltip(tooltip, position2) {
    this._positionTooltip(tooltip, { x: 0, y: this.positionToCoordinate(position2) });
  }
  /**
   * @ignore
   */
  updateTooltipBounds(tooltip) {
    const inside = this.get("inside");
    const num = 1e5;
    let global2 = this._display.toGlobal({ x: 0, y: 0 });
    let y2 = global2.y;
    let x2 = 0;
    let h = this.axisLength();
    let w = num;
    let pointerOrientation = "right";
    if (this.get("opposite")) {
      if (inside) {
        pointerOrientation = "right";
        x2 = global2.x - num;
        w = num;
      } else {
        pointerOrientation = "left";
        x2 = global2.x;
        w = num;
      }
    } else {
      if (inside) {
        pointerOrientation = "left";
        x2 = global2.x;
        w = num;
      } else {
        pointerOrientation = "right";
        x2 = global2.x - num;
        w = num;
      }
    }
    const bounds = { left: x2, right: x2 + w, top: y2, bottom: y2 + h };
    const oldBounds = tooltip.get("bounds");
    if (!sameBounds(bounds, oldBounds)) {
      tooltip.set("bounds", bounds);
      tooltip.set("pointerOrientation", pointerOrientation);
    }
  }
  /**
   * @ignore
   */
  _updateLC() {
    const axis = this.axis;
    const parent = axis.parent;
    if (parent) {
      const h = parent.innerHeight();
      this._lc = this.axisLength() / h;
      this._ls = axis.y() / h;
    }
  }
  /**
   * @ignore
   */
  toAxisPosition(position2) {
    const start = this._start || 0;
    const end = this._end || 1;
    position2 -= this._ls;
    position2 = position2 * (end - start) / this._lc;
    if (this.get("inversed")) {
      position2 = start + position2;
    } else {
      position2 = end - position2;
    }
    return position2;
  }
  /**
   * @ignore
   */
  toGlobalPosition(position2) {
    const start = this._start || 0;
    const end = this._end || 1;
    if (this.get("inversed")) {
      position2 = position2 - start;
    } else {
      position2 = end - position2;
    }
    position2 = position2 / (end - start) * this._lc;
    position2 += this._ls;
    return position2;
  }
  /**
   * @ignore
   */
  fixPosition(position2) {
    if (!this.get("inversed")) {
      return 1 - position2;
    }
    return position2;
  }
};
Object.defineProperty(AxisRendererY, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisRendererY"
});
Object.defineProperty(AxisRendererY, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: AxisRenderer.classNames.concat([AxisRendererY.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/series/ColumnSeries.js
var ColumnSeries = class extends BaseColumnSeries {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "columns", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => RoundedRectangle._new(this._root, {
        position: "absolute",
        themeTags: mergeTags(this.columns.template.get("themeTags", []), ["series", "column"])
      }, [this.columns.template]))
    });
  }
  /**
   * @ignore
   */
  makeColumn(dataItem, listTemplate) {
    const column2 = this.mainContainer.children.push(listTemplate.make());
    column2._setDataItem(dataItem);
    listTemplate.push(column2);
    return column2;
  }
  _processAxisRange(axisRange) {
    super._processAxisRange(axisRange);
    axisRange.columns = new ListTemplate(Template.new({}), () => RoundedRectangle._new(this._root, {
      position: "absolute",
      themeTags: mergeTags(axisRange.columns.template.get("themeTags", []), ["series", "column"])
    }, [this.columns.template, axisRange.columns.template]));
  }
};
Object.defineProperty(ColumnSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "ColumnSeries"
});
Object.defineProperty(ColumnSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: BaseColumnSeries.classNames.concat([ColumnSeries.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/series/LineSeries.js
var LineSeries = class extends XYSeries {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_endIndex", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_strokeGenerator", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: line_default()
    });
    Object.defineProperty(this, "_fillGenerator", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: area_default()
    });
    Object.defineProperty(this, "_legendStroke", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_legendFill", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "strokes", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => Graphics._new(this._root, {
        themeTags: mergeTags(this.strokes.template.get("themeTags", []), ["line", "series", "stroke"])
      }, [this.strokes.template]))
    });
    Object.defineProperty(this, "fills", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => Graphics._new(this._root, {
        themeTags: mergeTags(this.strokes.template.get("themeTags", []), ["line", "series", "fill"])
      }, [this.fills.template]))
    });
    Object.defineProperty(this, "_fillTemplate", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_strokeTemplate", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_previousPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: [0, 0, 0, 0]
    });
    Object.defineProperty(this, "_dindex", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_sindex", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
  }
  _afterNew() {
    this._fillGenerator.y0(function(p) {
      return p[3];
    });
    this._fillGenerator.x0(function(p) {
      return p[2];
    });
    this._fillGenerator.y1(function(p) {
      return p[1];
    });
    this._fillGenerator.x1(function(p) {
      return p[0];
    });
    super._afterNew();
  }
  /**
   * @ignore
   */
  makeStroke(strokes) {
    const stroke = this.mainContainer.children.push(strokes.make());
    strokes.push(stroke);
    return stroke;
  }
  /**
   * @ignore
   */
  makeFill(fills) {
    const fill = this.mainContainer.children.push(fills.make());
    fills.push(fill);
    return fill;
  }
  _updateChildren() {
    this._strokeTemplate = void 0;
    this._fillTemplate = void 0;
    let xAxis = this.get("xAxis");
    let yAxis = this.get("yAxis");
    if (this.isDirty("stroke")) {
      const stroke = this.get("stroke");
      this.strokes.template.set("stroke", stroke);
      const legendStroke = this._legendStroke;
      if (legendStroke) {
        legendStroke.states.lookup("default").set("stroke", stroke);
      }
    }
    if (this.isDirty("fill")) {
      const fill = this.get("fill");
      this.fills.template.set("fill", fill);
      const legendFill = this._legendFill;
      if (legendFill) {
        legendFill.states.lookup("default").set("fill", fill);
      }
    }
    if (this.isDirty("curveFactory")) {
      const curveFactory = this.get("curveFactory");
      if (curveFactory) {
        this._strokeGenerator.curve(curveFactory);
        this._fillGenerator.curve(curveFactory);
      }
    }
    if (xAxis.inited && yAxis.inited) {
      if (this._axesDirty || this._valuesDirty || this._stackDirty || this.isDirty("vcx") || this.isDirty("vcy") || this._sizeDirty || this.isDirty("connect") || this.isDirty("curveFactory")) {
        this.fills.each((fill) => {
          fill.setPrivate("visible", false);
        });
        this.strokes.each((fill) => {
          fill.setPrivate("visible", false);
        });
        this.axisRanges.each((axisRange) => {
          let fills = axisRange.fills;
          if (fills) {
            fills.each((fill) => {
              fill.setPrivate("visible", false);
            });
          }
          let strokes = axisRange.strokes;
          if (strokes) {
            strokes.each((stroke) => {
              stroke.setPrivate("visible", false);
            });
          }
        });
        let startIndex = this.startIndex();
        let strokeTemplateField = this.strokes.template.get("templateField");
        let fillTemplateField = this.fills.template.get("templateField");
        let strokeTemplateFound = true;
        let fillTemplateFound = true;
        if (strokeTemplateField) {
          strokeTemplateFound = false;
        }
        if (fillTemplateField) {
          fillTemplateFound = false;
        }
        for (let i = startIndex - 1; i >= 0; i--) {
          let dataItem = this.dataItems[i];
          let hasValues = true;
          let dataContext = dataItem.dataContext;
          if (strokeTemplateField) {
            if (dataContext[strokeTemplateField]) {
              strokeTemplateFound = true;
            }
          }
          if (fillTemplateField) {
            if (dataContext[fillTemplateField]) {
              fillTemplateFound = true;
            }
          }
          each(this._valueFields, (field) => {
            if (!isNumber(dataItem.get(field))) {
              hasValues = false;
            }
          });
          if (hasValues && strokeTemplateFound && fillTemplateFound) {
            startIndex = i;
            break;
          }
        }
        let len = this.dataItems.length;
        let endIndex = this.endIndex();
        if (endIndex < len) {
          endIndex++;
          for (let i = endIndex; i < len; i++) {
            let dataItem = this.dataItems[i];
            let hasValues = true;
            each(this._valueFields, (field) => {
              if (!isNumber(dataItem.get(field))) {
                hasValues = false;
              }
            });
            if (hasValues) {
              endIndex = i + 1;
              break;
            }
          }
        }
        if (startIndex > 0) {
          startIndex--;
        }
        this._endIndex = endIndex;
        this._clearGraphics();
        this._sindex = 0;
        this._dindex = startIndex;
        if (this.dataItems.length == 1) {
          this._startSegment(0);
        } else {
          while (this._dindex < endIndex - 1) {
            this._startSegment(this._dindex);
            this._sindex++;
          }
        }
      }
    } else {
      this._skipped = true;
    }
    super._updateChildren();
  }
  _clearGraphics() {
    this.strokes.clear();
    this.fills.clear();
  }
  _startSegment(dataItemIndex) {
    let endIndex = this._endIndex;
    let currentEndIndex = endIndex;
    const autoGapCount = this.get("autoGapCount");
    const connect = this.get("connect");
    const fill = this.makeFill(this.fills);
    const fillTemplate = this._fillTemplate;
    const originalTemplate = this.fills.template;
    if (fillTemplate && fillTemplate != originalTemplate) {
      fill.template = fillTemplate;
    }
    fill.setPrivate("visible", true);
    const stroke = this.makeStroke(this.strokes);
    const strokeTemplate = this._strokeTemplate;
    if (strokeTemplate && strokeTemplate != this.strokes.template) {
      stroke.template = strokeTemplate;
    }
    stroke.setPrivate("visible", true);
    let xAxis = this.get("xAxis");
    let yAxis = this.get("yAxis");
    let baseAxis = this.get("baseAxis");
    let vcx = this.get("vcx", 1);
    let vcy = this.get("vcy", 1);
    let xField = this._xField;
    let yField = this._yField;
    let xOpenField = this._xOpenField;
    let yOpenField = this._yOpenField;
    const xOpenFieldValue = this.get("openValueXField");
    const yOpenFieldValue = this.get("openValueYField");
    if (!xOpenFieldValue) {
      xOpenField = this._xField;
    }
    if (!yOpenFieldValue) {
      yOpenField = this._yField;
    }
    const stacked = this.get("stacked");
    const basePosX = xAxis.basePosition();
    const basePosY = yAxis.basePosition();
    let baseField;
    if (baseAxis === yAxis) {
      baseField = this._yField;
    } else {
      baseField = this._xField;
    }
    const segments = [];
    let points = [];
    segments.push(points);
    const strokeTemplateField = this.strokes.template.get("templateField");
    const fillTemplateField = this.fills.template.get("templateField");
    let locationX = this.get("locationX", 0.5);
    let locationY = this.get("locationY", 0.5);
    let openLocationX = this.get("openLocationX", locationX);
    let openLocationY = this.get("openLocationY", locationY);
    const minDistance = this.get("minDistance", 0);
    let i;
    let fillVisible = this.fills.template.get("visible");
    if (this.axisRanges.length > 0) {
      fillVisible = true;
    }
    let getOpen = false;
    if (stacked || xOpenFieldValue || yOpenFieldValue) {
      getOpen = true;
    }
    const o = {
      points,
      segments,
      stacked,
      getOpen,
      basePosX,
      basePosY,
      fillVisible,
      xField,
      yField,
      xOpenField,
      yOpenField,
      vcx,
      vcy,
      baseAxis,
      xAxis,
      yAxis,
      locationX,
      locationY,
      openLocationX,
      openLocationY,
      minDistance
    };
    for (i = dataItemIndex; i < currentEndIndex; i++) {
      this._dindex = i;
      const dataItem = this._dataItems[i];
      let valueX = dataItem.get(xField);
      let valueY = dataItem.get(yField);
      if (valueX == null || valueY == null) {
        if (!connect) {
          points = [];
          segments.push(points);
          o.points = points;
        }
      } else {
        this._getPoints(dataItem, o);
      }
      if (strokeTemplateField) {
        let strokeTemplate2 = dataItem.dataContext[strokeTemplateField];
        if (strokeTemplate2) {
          if (!(strokeTemplate2 instanceof Template)) {
            strokeTemplate2 = Template.new(strokeTemplate2);
          }
          this._strokeTemplate = strokeTemplate2;
          if (i > dataItemIndex) {
            currentEndIndex = i;
            break;
          } else {
            stroke.template = strokeTemplate2;
          }
        }
      }
      if (fillTemplateField) {
        let fillTemplate2 = dataItem.dataContext[fillTemplateField];
        if (fillTemplate2) {
          if (!(fillTemplate2 instanceof Template)) {
            fillTemplate2 = Template.new(fillTemplate2);
          }
          this._fillTemplate = fillTemplate2;
          if (i > dataItemIndex) {
            currentEndIndex = i;
            break;
          } else {
            fill.template = fillTemplate2;
          }
        }
      }
      if (!connect) {
        let nextItem = this.dataItems[i + 1];
        if (nextItem) {
          if (baseAxis.shouldGap(dataItem, nextItem, autoGapCount, baseField)) {
            points = [];
            segments.push(points);
            o.points = points;
          }
        }
      }
    }
    fill.setRaw("userData", [dataItemIndex, i]);
    stroke.setRaw("userData", [dataItemIndex, i]);
    if (i === endIndex) {
      this._endLine(points, segments[0][0]);
    }
    if (stroke) {
      this._drawStroke(stroke, segments);
    }
    if (fill) {
      this._drawFill(fill, segments);
    }
    this.axisRanges.each((axisRange) => {
      const container = axisRange.container;
      const fills = axisRange.fills;
      const fill2 = this.makeFill(fills);
      if (container) {
        container.children.push(fill2);
      }
      fill2.setPrivate("visible", true);
      this._drawFill(fill2, segments);
      const strokes = axisRange.strokes;
      const stroke2 = this.makeStroke(strokes);
      if (container) {
        container.children.push(stroke2);
      }
      stroke2.setPrivate("visible", true);
      this._drawStroke(stroke2, segments);
      fill2.setRaw("userData", [dataItemIndex, i]);
      stroke2.setRaw("userData", [dataItemIndex, i]);
    });
  }
  _getPoints(dataItem, o) {
    let points = o.points;
    let itemLocationX = dataItem.get("locationX", o.locationX);
    let itemLocationY = dataItem.get("locationY", o.locationY);
    let xPos = o.xAxis.getDataItemPositionX(dataItem, o.xField, itemLocationX, o.vcx);
    let yPos = o.yAxis.getDataItemPositionY(dataItem, o.yField, itemLocationY, o.vcy);
    if (this._shouldInclude(xPos)) {
      const iPoint = this.getPoint(xPos, yPos);
      const point2 = [iPoint.x, iPoint.y];
      iPoint.x += this._x;
      iPoint.y += this._y;
      dataItem.set("point", iPoint);
      if (o.fillVisible) {
        let xPos0 = xPos;
        let yPos0 = yPos;
        if (o.baseAxis === o.xAxis) {
          yPos0 = o.basePosY;
        } else if (o.baseAxis === o.yAxis) {
          xPos0 = o.basePosX;
        }
        if (o.getOpen) {
          let valueX = dataItem.get(o.xOpenField);
          let valueY = dataItem.get(o.yOpenField);
          if (valueX != null && valueY != null) {
            let itemLocationX2 = dataItem.get("openLocationX", o.openLocationX);
            let itemLocationY2 = dataItem.get("openLocationY", o.openLocationY);
            if (o.stacked) {
              let stackToItemX = dataItem.get("stackToItemX");
              let stackToItemY = dataItem.get("stackToItemY");
              if (stackToItemX) {
                xPos0 = o.xAxis.getDataItemPositionX(stackToItemX, o.xField, itemLocationX2, stackToItemX.component.get("vcx"));
                if (isNaN2(xPos0)) {
                  xPos0 = o.basePosX;
                }
              } else {
                if (o.yAxis === o.baseAxis) {
                  xPos0 = o.basePosX;
                } else {
                  xPos0 = o.xAxis.getDataItemPositionX(dataItem, o.xOpenField, itemLocationX2, o.vcx);
                }
              }
              if (stackToItemY) {
                yPos0 = o.yAxis.getDataItemPositionY(stackToItemY, o.yField, itemLocationY2, stackToItemY.component.get("vcy"));
                if (isNaN2(yPos0)) {
                  yPos0 = o.basePosY;
                }
              } else {
                if (o.xAxis === o.baseAxis) {
                  yPos0 = o.basePosY;
                } else {
                  yPos0 = o.yAxis.getDataItemPositionY(dataItem, o.yOpenField, itemLocationY2, o.vcy);
                }
              }
            } else {
              xPos0 = o.xAxis.getDataItemPositionX(dataItem, o.xOpenField, itemLocationX2, o.vcx);
              yPos0 = o.yAxis.getDataItemPositionY(dataItem, o.yOpenField, itemLocationY2, o.vcy);
            }
          }
        }
        let closeIPoint = this.getPoint(xPos0, yPos0);
        point2[2] = closeIPoint.x;
        point2[3] = closeIPoint.y;
      }
      if (o.minDistance > 0) {
        const p02 = point2[0];
        const p1 = point2[1];
        const p2 = point2[2];
        const p3 = point2[3];
        const prev2 = this._previousPoint;
        const pp0 = prev2[0];
        const pp1 = prev2[1];
        const pp2 = prev2[2];
        const pp3 = prev2[3];
        if (Math.hypot(p02 - pp0, p1 - pp1) > o.minDistance || p2 && p3 && Math.hypot(p2 - pp2, p3 - pp3) > o.minDistance) {
          points.push(point2);
          this._previousPoint = point2;
        }
      } else {
        points.push(point2);
      }
    }
  }
  _endLine(_points, _firstPoint) {
  }
  _drawStroke(graphics, segments) {
    if (graphics.get("visible") && !graphics.get("forceHidden")) {
      graphics.set("draw", (display) => {
        each(segments, (segment) => {
          this._strokeGenerator.context(display);
          this._strokeGenerator(segment);
        });
      });
    }
  }
  _drawFill(graphics, segments) {
    if (graphics.get("visible") && !graphics.get("forceHidden")) {
      graphics.set("draw", (display) => {
        each(segments, (segment) => {
          this._fillGenerator.context(display);
          this._fillGenerator(segment);
        });
      });
    }
  }
  _processAxisRange(axisRange) {
    super._processAxisRange(axisRange);
    axisRange.fills = new ListTemplate(Template.new({}), () => Graphics._new(this._root, {
      themeTags: mergeTags(axisRange.fills.template.get("themeTags", []), ["line", "series", "fill"])
    }, [this.fills.template, axisRange.fills.template]));
    axisRange.strokes = new ListTemplate(Template.new({}), () => Graphics._new(this._root, {
      themeTags: mergeTags(axisRange.strokes.template.get("themeTags", []), ["line", "series", "stroke"])
    }, [this.strokes.template, axisRange.strokes.template]));
  }
  /**
   * @ignore
   */
  createLegendMarker(_dataItem) {
    const legendDataItem = this.get("legendDataItem");
    if (legendDataItem) {
      const marker = legendDataItem.get("marker");
      const markerRectangle = legendDataItem.get("markerRectangle");
      if (markerRectangle) {
        markerRectangle.setPrivate("visible", false);
      }
      marker.set("background", Rectangle.new(marker._root, { fillOpacity: 0, fill: color(0) }));
      const legendStroke = marker.children.push(Graphics._new(marker._root, {
        themeTags: ["line", "series", "legend", "marker", "stroke"],
        interactive: false
      }, [this.strokes.template]));
      this._legendStroke = legendStroke;
      const legendFill = marker.children.push(Graphics._new(marker._root, {
        themeTags: ["line", "series", "legend", "marker", "fill"]
      }, [this.fills.template]));
      this._legendFill = legendFill;
      const disabledColor = this._root.interfaceColors.get("disabled");
      legendStroke.states.create("disabled", { fill: disabledColor, stroke: disabledColor });
      legendFill.states.create("disabled", { fill: disabledColor, stroke: disabledColor });
      if (this.bullets.length > 0) {
        const bulletFunction = this.bullets.getIndex(0);
        if (bulletFunction) {
          const bullet = bulletFunction(marker._root, this, new DataItem(this, { legend: true }, {}));
          if (bullet) {
            const sprite = bullet.get("sprite");
            if (sprite instanceof Graphics) {
              sprite.states.create("disabled", { fill: disabledColor, stroke: disabledColor });
            }
            if (sprite) {
              sprite.set("tooltipText", void 0);
              sprite.set("tooltipHTML", void 0);
              marker.children.push(sprite);
              sprite.setAll({ x: marker.width() / 2, y: marker.height() / 2 });
              marker.events.on("boundschanged", () => {
                sprite.setAll({ x: marker.width() / 2, y: marker.height() / 2 });
              });
            }
          }
        }
      }
    }
  }
};
Object.defineProperty(LineSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "LineSeries"
});
Object.defineProperty(LineSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: XYSeries.classNames.concat([LineSeries.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/core/render/MonotoneXTension.js
var MonotoneXTension = class {
  constructor(context, tension) {
    Object.defineProperty(this, "_line", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_point", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_context", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(this, "_x0", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_x1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_y0", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_y1", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_t0", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    Object.defineProperty(this, "_tension", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 0
    });
    this._context = context;
    this._tension = tension;
  }
  areaStart() {
    this._line = 0;
  }
  areaEnd() {
    this._line = NaN;
  }
  lineStart() {
    this._x0 = this._x1 = this._y0 = this._y1 = this._t0 = NaN;
    this._point = 0;
  }
  lineEnd() {
    switch (this._point) {
      case 2:
        this._context.lineTo(this._x1, this._y1);
        break;
      case 3:
        point(this, this._t0, slope2(this, this._t0));
        break;
    }
    if (this._line || this._line !== 0 && this._point === 1)
      this._context.closePath();
    this._line = 1 - this._line;
  }
  point(x2, y2) {
    let t1 = NaN;
    x2 = +x2, y2 = +y2;
    if (x2 === this._x1 && y2 === this._y1)
      return;
    switch (this._point) {
      case 0:
        this._point = 1;
        this._line ? this._context.lineTo(x2, y2) : this._context.moveTo(x2, y2);
        break;
      case 1:
        this._point = 2;
        break;
      case 2:
        this._point = 3;
        point(this, slope2(this, t1 = slope3(this, x2, y2)), t1);
        break;
      default:
        point(this, this._t0, t1 = slope3(this, x2, y2));
        break;
    }
    this._x0 = this._x1, this._x1 = x2;
    this._y0 = this._y1, this._y1 = y2;
    this._t0 = t1;
  }
};
function curveMonotoneXTension(tension) {
  function monotoneXTension(context) {
    return new MonotoneXTension(context, tension);
  }
  return monotoneXTension;
}
function sign(x2) {
  return x2 < 0 ? -1 : 1;
}
function slope3(that, x2, y2) {
  let h0 = that._x1 - that._x0;
  let h1 = x2 - that._x1;
  let s0 = (that._y1 - that._y0) / (h0 || h1 < 0 && -0);
  let s1 = (y2 - that._y1) / (h1 || h0 < 0 && -0);
  let p = (s0 * h1 + s1 * h0) / (h0 + h1);
  return (sign(s0) + sign(s1)) * Math.min(Math.abs(s0), Math.abs(s1), 0.5 * Math.abs(p)) || 0;
}
function slope2(that, t) {
  let h = that._x1 - that._x0;
  return h ? (3 * (that._y1 - that._y0) / h - t) / 2 : t;
}
function point(that, t0, t1) {
  let x0 = that._x0, y0 = that._y0, x1 = that._x1, y1 = that._y1, dx = (x1 - x0) / 1.5 * (1 - that._tension);
  that._context.bezierCurveTo(x0 + dx, y0 + dx * t0, x1 - dx, y1 - dx * t1, x1, y1);
}

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/series/SmoothedXLineSeries.js
var SmoothedXLineSeries = class extends LineSeries {
  _afterNew() {
    this._setDefault("curveFactory", curveMonotoneXTension(this.get("tension", 0.5)));
    super._afterNew();
  }
  _updateChildren() {
    if (this.isDirty("tension")) {
      this.set("curveFactory", curveMonotoneXTension(this.get("tension", 0.5)));
      this._valuesDirty = true;
    }
    super._updateChildren();
  }
};
Object.defineProperty(SmoothedXLineSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "SmoothedXLineSeries"
});
Object.defineProperty(SmoothedXLineSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: LineSeries.classNames.concat([SmoothedXLineSeries.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/xy/series/StepLineSeries.js
var StepLineSeries = class extends LineSeries {
  _afterNew() {
    this._setDefault("curveFactory", stepAfter);
    super._afterNew();
  }
  _getPoints(dataItem, o) {
    let points = o.points;
    let width = this.get("stepWidth", p100).value / 2;
    let itemLocationX0 = dataItem.get("locationX", o.locationX);
    let itemLocationY0 = dataItem.get("locationY", o.locationY);
    let itemLocationX1 = itemLocationX0;
    let itemLocationY1 = itemLocationY0;
    if (o.baseAxis === o.xAxis) {
      itemLocationX0 -= width;
      itemLocationX1 += width;
    } else if (o.baseAxis === o.yAxis) {
      itemLocationY0 -= width;
      itemLocationY1 += width;
    }
    let xPos0 = o.xAxis.getDataItemPositionX(dataItem, o.xField, itemLocationX0, o.vcx);
    let yPos0 = o.yAxis.getDataItemPositionY(dataItem, o.yField, itemLocationY0, o.vcy);
    let xPos1 = o.xAxis.getDataItemPositionX(dataItem, o.xField, itemLocationX1, o.vcx);
    let yPos1 = o.yAxis.getDataItemPositionY(dataItem, o.yField, itemLocationY1, o.vcy);
    if (this._shouldInclude(xPos0)) {
      const iPoint0 = this.getPoint(xPos0, yPos0);
      const point0 = [iPoint0.x, iPoint0.y];
      const iPoint1 = this.getPoint(xPos1, yPos1);
      const point1 = [iPoint1.x, iPoint1.y];
      if (o.fillVisible) {
        let xOpenPos0 = xPos0;
        let yOpenPos0 = yPos0;
        let xOpenPos1 = xPos1;
        let yOpenPos1 = yPos1;
        if (o.baseAxis === o.xAxis) {
          yOpenPos0 = o.basePosY;
          yOpenPos1 = o.basePosY;
        } else if (o.baseAxis === o.yAxis) {
          xOpenPos0 = o.basePosX;
          xOpenPos1 = o.basePosX;
        }
        if (o.getOpen) {
          let valueX = dataItem.get(o.xOpenField);
          let valueY = dataItem.get(o.yOpenField);
          if (valueX != null && valueY != null) {
            itemLocationX0 = dataItem.get("openLocationX", o.openLocationX);
            itemLocationY0 = dataItem.get("openLocationY", o.openLocationY);
            itemLocationX1 = itemLocationX0;
            itemLocationY1 = itemLocationY0;
            if (o.baseAxis === o.xAxis) {
              itemLocationX0 -= width;
              itemLocationX1 += width;
            } else if (o.baseAxis === o.yAxis) {
              itemLocationY0 -= width;
              itemLocationY1 += width;
            }
            if (o.stacked) {
              let stackToItemX = dataItem.get("stackToItemX");
              let stackToItemY = dataItem.get("stackToItemY");
              if (stackToItemX) {
                xOpenPos0 = o.xAxis.getDataItemPositionX(stackToItemX, o.xField, itemLocationX0, stackToItemX.component.get("vcx"));
                xOpenPos1 = o.xAxis.getDataItemPositionX(stackToItemX, o.xField, itemLocationX1, stackToItemX.component.get("vcx"));
              } else {
                if (o.yAxis === o.baseAxis) {
                  xOpenPos0 = o.basePosX;
                  xOpenPos1 = o.basePosX;
                } else if (o.baseAxis === o.yAxis) {
                  xOpenPos0 = o.xAxis.getDataItemPositionX(dataItem, o.xOpenField, itemLocationX0, o.vcx);
                  xOpenPos1 = o.xAxis.getDataItemPositionX(dataItem, o.xOpenField, itemLocationX1, o.vcx);
                }
              }
              if (stackToItemY) {
                yOpenPos0 = o.yAxis.getDataItemPositionY(stackToItemY, o.yField, itemLocationY0, stackToItemY.component.get("vcy"));
                yOpenPos1 = o.yAxis.getDataItemPositionY(stackToItemY, o.yField, itemLocationY1, stackToItemY.component.get("vcy"));
              } else {
                if (o.xAxis === o.baseAxis) {
                  yOpenPos0 = o.basePosY;
                  yOpenPos1 = o.basePosY;
                } else if (o.baseAxis === o.yAxis) {
                  yOpenPos0 = o.yAxis.getDataItemPositionY(dataItem, o.yOpenField, itemLocationY0, o.vcy);
                  yOpenPos1 = o.yAxis.getDataItemPositionY(dataItem, o.yOpenField, itemLocationY1, o.vcy);
                }
              }
            } else {
              xOpenPos0 = o.xAxis.getDataItemPositionX(dataItem, o.xOpenField, itemLocationX0, o.vcx);
              yOpenPos0 = o.yAxis.getDataItemPositionY(dataItem, o.yOpenField, itemLocationY0, o.vcy);
              xOpenPos1 = o.xAxis.getDataItemPositionX(dataItem, o.xOpenField, itemLocationX1, o.vcx);
              yOpenPos1 = o.yAxis.getDataItemPositionY(dataItem, o.yOpenField, itemLocationY1, o.vcy);
            }
          }
        }
        let closeIPoint0 = this.getPoint(xOpenPos0, yOpenPos0);
        let closeIPoint1 = this.getPoint(xOpenPos1, yOpenPos1);
        point0[2] = closeIPoint0.x;
        point0[3] = closeIPoint0.y;
        point1[2] = closeIPoint1.x;
        point1[3] = closeIPoint1.y;
      }
      points.push(point0);
      points.push(point1);
      dataItem.set("point", { x: point0[0] + (point1[0] - point0[0]) / 2, y: point0[1] + (point1[1] - point0[1]) / 2 });
    }
    if (this.get("noRisers")) {
      o.points = [];
      o.segments.push(points);
    }
  }
};
Object.defineProperty(StepLineSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "StepLineSeries"
});
Object.defineProperty(StepLineSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: LineSeries.classNames.concat([StepLineSeries.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/themes/AnimatedTheme.js
var AnimatedTheme = class extends Theme2 {
  setupDefaultRules() {
    super.setupDefaultRules();
    this.rule("Component").setAll({
      interpolationDuration: 600
    });
    this.rule("Hierarchy").set("animationDuration", 600);
    this.rule("Scrollbar").set("animationDuration", 600);
    this.rule("Tooltip").set("animationDuration", 300);
    this.rule("MapChart").set("animationDuration", 1e3);
    this.rule("MapChart").set("wheelDuration", 300);
    this.rule("Entity").setAll({
      stateAnimationDuration: 600
    });
    this.rule("Sprite").states.create("default", { stateAnimationDuration: 600 });
    this.rule("Tooltip", ["axis"]).setAll({
      animationDuration: 200
    });
    this.rule("WordCloud").set("animationDuration", 500);
    this.rule("Polygon").set("animationDuration", 600);
    this.rule("ArcDiagram").set("animationDuration", 600);
  }
};

// ../../node_modules/@amcharts/amcharts5/themes/Animated.js
var Animated_default = AnimatedTheme;

// components/charts/constants.ts
var defaultChartColor = "#4974f6";

// utils/general/validators.ts
var isEmail = (email2) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email2);
};
var isEmpty = (obj) => obj === void 0 || obj === null || Array(obj).length === 0 || String(obj).trim() === "";
var isContainWhiteSpace = (str) => {
  if (typeof str === "string" || typeof str === "number") {
    return str.toString().trim().includes(" ");
  }
  return false;
};
var persistNumberEntry = (event) => {
  const specialCharRegex = new RegExp("[0-9.]");
  const pressedKey = String.fromCharCode(
    !event.charCode ? event.which : event.charCode
  );
  if (!specialCharRegex.test(pressedKey)) {
    event.preventDefault();
    return false;
  }
  return true;
};
var numberCommasFormer = (num) => {
  return num == null ? void 0 : num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};
var underScoreFormer = (str) => {
  const formatedStr = str == null ? void 0 : str.split("_").map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join(" ");
  return formatedStr;
};
var isValidUrl = (urlString) => {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};
var uuidV4Pattern = /\b([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})\b/;

// components/charts/BarChart.tsx
var import_jsx_runtime197 = require("react/jsx-runtime");
var BarChart = ({
  isEditable,
  chartId,
  data,
  isVertical,
  color: color2,
  hasLegend,
  seriesList,
  title,
  titleBold,
  titleColor,
  titleUnderline,
  titleItalic,
  subtitleBold,
  subtitleColor,
  subtitleUnderline,
  subtitleItalic,
  subTitle,
  selectedRows,
  selectedColumn,
  zoomLevel = 1,
  handleTitleChange,
  handleSubTitleChange,
  stackedBar,
  barRowLine,
  barRowLineColor,
  dataColumns,
  horizontalCellWidth,
  verticalCellWidth,
  verticalCellRight,
  enableFormattedNumbers,
  displayChartLabels
}) => {
  const [formattedData, setFormattedData] = (0, import_react74.useState)(data);
  const [startValue, setStartValue] = (0, import_react74.useState)(0);
  const settings = JSON.stringify({
    hasLegend,
    color: color2,
    seriesList,
    title,
    subTitle,
    isVertical,
    selectedRows,
    selectedColumn,
    stackedBar,
    barRowLine,
    barRowLineColor,
    horizontalCellWidth,
    verticalCellWidth,
    verticalCellRight,
    enableFormattedNumbers,
    displayChartLabels
  });
  (0, import_react74.useEffect)(() => {
    if (selectedColumn && selectedRows) {
      if (!isEmpty(selectedColumn[0]) && selectedRows[0] !== void 0) {
        if (selectedRows.length === 1) {
          setFormattedData(formatSimpleData(data));
        } else {
          setFormattedData(formatMultipleData(data));
          console.log("formattedData", formatMultipleData(data));
        }
      }
    }
  }, [settings]);
  const formatSimpleData = (rawData) => {
    if (selectedColumn && selectedRows) {
      const categoryCount = {};
      const newData = rawData == null ? void 0 : rawData.map((element) => {
        let baseCategory = element[selectedColumn[0]];
        let category = baseCategory;
        if (categoryCount[baseCategory] !== void 0) {
          categoryCount[baseCategory]++;
          category = `${baseCategory} (${categoryCount[baseCategory]})`;
        } else {
          categoryCount[baseCategory] = 1;
          category = `${baseCategory} (1)`;
        }
        return {
          originalCategory: baseCategory,
          category,
          value: parseFloat(element[selectedRows[0]]),
          [barRowLine ? barRowLine : ""]: element[barRowLine || ""]
        };
      });
      return newData;
    }
  };
  const formatMultipleData = (rawData) => {
    var _a;
    const transformedData = [];
    if (selectedColumn && selectedRows) {
      for (const yValue of selectedRows) {
        const categories = [];
        const categoryCounts = {};
        for (const item of rawData) {
          let categoryBase = item[selectedColumn[0]];
          let category = categoryBase;
          if (categoryCounts[categoryBase] !== void 0) {
            categoryCounts[categoryBase] += 1;
            category = `${categoryBase} (${categoryCounts[categoryBase]})`;
          } else {
            categoryCounts[categoryBase] = 1;
            category = `${categoryBase} (1)`;
          }
          categories.push({
            originalCategory: categoryBase,
            value: parseFloat(item[yValue]),
            category
          });
        }
        transformedData.push({
          categories,
          key: yValue,
          label: ((_a = dataColumns == null ? void 0 : dataColumns.find((column2) => column2.key === yValue)) == null ? void 0 : _a.alias) || yValue
        });
      }
    }
    return transformedData;
  };
  const chartElement = document.getElementById(chartId);
  if (chartElement) {
    const resizeObserver2 = new ResizeObserver((entries) => {
      var _a, _b;
      for (let entry of entries) {
        const newHeight = isVertical ? entry.contentRect.width : entry.contentRect.height;
        const isMultiple3 = (_a = formattedData[0]) == null ? void 0 : _a.label;
        const columnsLength = isMultiple3 ? (_b = formattedData[0]) == null ? void 0 : _b.categories.length : formattedData == null ? void 0 : formattedData.length;
        const visibleDataRange = newHeight / (horizontalCellWidth || 40);
        const newStartValue = Math.max(
          0,
          (columnsLength - visibleDataRange) / columnsLength
        );
        setStartValue(newStartValue);
      }
    });
    resizeObserver2.observe(chartElement);
  } else {
    console.error("Chart element not found or invalid.");
  }
  (0, import_react74.useLayoutEffect)(() => {
    var _a, _b, _c;
    const root = Root.new(chartId, {
      calculateSize: function(dimensions) {
        return {
          width: dimensions.width * (1 / zoomLevel),
          height: dimensions.height * (1 / zoomLevel)
        };
      }
    });
    root.fps = 30;
    (_a = root._logo) == null ? void 0 : _a.dispose();
    const customizedTheme = Theme2.new(root);
    customizedTheme.rule("Label").setAll({
      fontFamily: "SpaceGrotesk"
    });
    root.setThemes([Animated_default.new(root), customizedTheme]);
    const bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "B" },
      { number: 1e12, suffix: "T" },
      { number: 1e15, suffix: "Q" },
      { number: 1e18, suffix: "QQ" },
      { number: 1e21, suffix: "S" },
      { number: 1e24, suffix: "SS" },
      { number: 1e27, suffix: "O" },
      { number: 1e30, suffix: "N" },
      { number: 1e33, suffix: "D" },
      { number: 1e36, suffix: "UD" },
      { number: 1e39, suffix: "DD" },
      { number: 1e42, suffix: "TD" },
      { number: 1e45, suffix: "QD" },
      { number: 1e48, suffix: "QD" },
      { number: 1e51, suffix: "SD" },
      { number: 1e54, suffix: "SSD" },
      { number: 1e57, suffix: "OD" },
      { number: 1e60, suffix: "ND" },
      { number: 1e63, suffix: "VD" }
    ];
    let chart = root.container.children.push(
      XYChart.new(root, {
        panX: false,
        panY: false,
        // wheelX: "panX",
        // wheelY: "panY",
        [isVertical ? "pinchZoomX" : "pinchZoomY"]: false,
        layout: root.verticalLayout
      })
    );
    let cursor = chart.set("cursor", XYCursor.new(root, {}));
    if (isVertical)
      cursor.lineY.set("visible", false);
    else if (!isVertical)
      cursor.lineX.set("visible", false);
    let xRenderer = isVertical ? AxisRendererX.new(root, { minGridDistance: 10 }) : null;
    if (xRenderer !== null && isVertical) {
      xRenderer.labels.template.setAll({
        oversizedBehavior: "truncate",
        textAlign: "center"
      });
      xRenderer.grid.template.setAll({
        location: 1
      });
    }
    let yRenderer = !isVertical ? AxisRendererY.new(root, {
      minGridDistance: 10,
      opposite: verticalCellRight
    }) : null;
    let xAxis = chart.xAxes.push(
      isVertical && xRenderer != null ? CategoryAxis.new(root, {
        maxDeviation: 0.3,
        categoryField: "category",
        renderer: xRenderer
        // tooltip: am5.Tooltip.new(root, {}),
      }) : ValueAxis.new(root, {
        maxDeviation: 0.3,
        numberFormatter: enableFormattedNumbers ? NumberFormatter.new(root, {
          numberFormat: "###a",
          bigNumberPrefixes,
          numericFields: ["value"]
        }) : void 0,
        renderer: AxisRendererX.new(root, {
          strokeOpacity: 0.1
        })
      })
    );
    let yAxis = chart.yAxes.push(
      !isVertical && yRenderer ? CategoryAxis.new(root, {
        maxDeviation: 0.3,
        categoryField: "category",
        renderer: yRenderer
        // tooltip: am5.Tooltip.new(root, {}),
      }) : ValueAxis.new(root, {
        maxDeviation: 0.3,
        numberFormatter: enableFormattedNumbers ? NumberFormatter.new(root, {
          numberFormat: "###a",
          bigNumberPrefixes,
          numericFields: ["value"]
        }) : void 0,
        renderer: AxisRendererY.new(root, {
          opposite: verticalCellRight,
          strokeOpacity: 0.1
        })
      })
    );
    let xyRenderer = isVertical ? xRenderer : yRenderer;
    if (xyRenderer) {
      xyRenderer.labels.template.setAll({
        text: "{originalCategory}",
        tooltipText: "{originalCategory}",
        oversizedBehavior: "truncate",
        textAlign: "center",
        maxWidth: 100
      });
      xyRenderer.labels.template.setup = function(target) {
        target.set(
          "background",
          Rectangle.new(root, {
            fill: color(0),
            fillOpacity: 0
          })
        );
      };
    }
    if (xAxis instanceof CategoryAxis) {
      xAxis.onPrivate("cellWidth", function(cellWidth) {
        xRenderer.labels.template.set("maxWidth", cellWidth);
      });
    }
    if (yAxis instanceof ValueAxis) {
      yAxis.get("renderer").labels.template.setAll({
        tooltip: Tooltip4.new(root, {
          labelText: "{value}"
        }),
        oversizedBehavior: "truncate",
        textAlign: "center",
        maxWidth: (verticalCellWidth || 150) * 0.9
        // maxWidth: verticalCellWidth,
      });
    } else if (xAxis instanceof ValueAxis && yAxis instanceof CategoryAxis) {
      xAxis.get("renderer").labels.template.setAll({
        oversizedBehavior: "truncate",
        textAlign: "center",
        maxWidth: 150 * 0.9
      });
      yAxis.get("renderer").labels.template.setAll({
        // tooltip: am5.Tooltip.new(root, {
        //   labelText: "{category}",
        // }),
        oversizedBehavior: "truncate",
        textAlign: "center",
        maxWidth: (verticalCellWidth || 150) * 0.9
      });
    }
    var tooltip = xAxis.labelsContainer.set(
      "tooltip",
      Tooltip4.new(root, {
        pointerOrientation: "vertical"
      })
    );
    tooltip.label.setAll({
      maxWidth: 200,
      oversizedBehavior: "wrap"
    });
    var tooltipY = yAxis.labelsContainer.set(
      "tooltip",
      Tooltip4.new(root, {
        pointerOrientation: "horizontal"
      })
    );
    tooltipY.label.setAll({
      maxWidth: 200,
      oversizedBehavior: "wrap"
    });
    const isMultiple3 = (_b = formattedData[0]) == null ? void 0 : _b.label;
    if (isMultiple3) {
      let series2Added = true;
      formattedData.forEach(
        ({ label, key }, index2) => {
          makeSeries(
            formatMultipleChartData(formattedData),
            color2 == null ? void 0 : color2[key],
            label,
            series2Added
          );
          if (barRowLine && index2 === (formattedData == null ? void 0 : formattedData.length) - 2)
            series2Added = false;
        }
      );
    } else {
      makeSeries(
        formattedData,
        (_c = color2 == null ? void 0 : color2[seriesList == null ? void 0 : seriesList[0]]) != null ? _c : defaultChartColor
      );
    }
    if (hasLegend) {
      const legend = chart.children.push(
        Legend.new(root, {
          nameField: "name",
          fillField: "color",
          strokeField: "color",
          x: p0,
          centerX: p0,
          layout: root.horizontalLayout
        })
      );
      legend.data.setAll(chart.series.values);
    }
    const scrollbar = chart.set(
      isVertical ? "scrollbarX" : "scrollbarY",
      Scrollbar.new(root, {
        orientation: isVertical ? "horizontal" : "vertical",
        minWidth: 12,
        [isVertical ? "end" : "start"]: isVertical ? 1 - startValue : startValue
      })
    );
    isVertical ? chart.bottomAxesContainer.children.push(scrollbar) : chart.rightAxesContainer.children.push(scrollbar);
    scrollbar.startGrip.setAll({
      visible: false
    });
    scrollbar.endGrip.setAll({
      visible: false
    });
    scrollbar.thumb.setAll({
      visible: startValue !== 0
    });
    scrollbar.get("background").setAll({
      fill: startValue !== 0 ? color(15725053) : void 0
    });
    chart.zoomOutButton.set("forceHidden", true);
    function makeSeries(data2, color3 = defaultChartColor, key, series2Added = false) {
      var _a2, _b2;
      if (isVertical)
        xAxis.data.setAll(data2);
      else if (!isVertical)
        yAxis.data.setAll(data2);
      let series = chart.series.push(
        ColumnSeries.new(root, {
          name: key || (seriesList && seriesList.length > 0 ? ((_a2 = dataColumns == null ? void 0 : dataColumns.find((column2) => column2.key === seriesList[0])) == null ? void 0 : _a2.alias) || seriesList[0] : "Serie 1"),
          stacked: stackedBar,
          xAxis,
          yAxis,
          [isVertical ? "valueYField" : "valueXField"]: key || "value",
          [isVertical ? "categoryXField" : "categoryYField"]: "category",
          fill: color(color3),
          tooltip: Tooltip4.new(root, {
            labelText: isVertical ? "{valueY}" : "{valueX}"
          })
        })
      );
      if (!stackedBar)
        series.columns.template.setAll({
          [isVertical ? "cornerRadiusTL" : "cornerRadiusTR"]: 5,
          [isVertical ? "cornerRadiusTR" : "cornerRadiusBR"]: 5
        });
      if (!series2Added && barRowLine) {
        const series2 = chart.series.push(
          LineSeries.new(root, {
            xAxis,
            yAxis,
            [isVertical ? "valueYField" : "valueXField"]: isMultiple3 ? ((_b2 = dataColumns == null ? void 0 : dataColumns.find((column2) => column2.key === barRowLine)) == null ? void 0 : _b2.alias) || barRowLine : barRowLine,
            [isVertical ? "categoryXField" : "categoryYField"]: "category",
            sequencedInterpolation: true,
            tooltip: Tooltip4.new(root, {
              labelText: isVertical ? "[bold]{valueY}" : "[bold]{valueX}"
            }),
            stroke: color(barRowLineColor || defaultChartColor),
            fill: color(barRowLineColor || defaultChartColor)
          })
        );
        series2.strokes.template.setAll({
          strokeWidth: 2
        });
        series2.bullets.push(function() {
          return Bullet.new(root, {
            sprite: Circle.new(root, {
              radius: 5,
              stroke: color(barRowLineColor || defaultChartColor),
              strokeWidth: 2,
              fill: color(barRowLineColor || defaultChartColor)
            })
          });
        });
        series2.data.setAll(data2);
      }
      if (displayChartLabels)
        series.bullets.push(function() {
          return Bullet.new(root, {
            locationX: isVertical ? 0.5 : 1,
            locationY: isVertical ? 1.1 : 0.5,
            sprite: Label.new(root, {
              centerX: p50,
              centerY: isVertical ? percent(60) : p50,
              text: "{value}",
              fill: color(0),
              populateText: true
            })
          });
        });
      series.data.setAll(data2);
      series.appear();
    }
    chart.appear();
    return () => root.dispose();
  }, [
    chartId,
    formattedData,
    zoomLevel,
    startValue,
    horizontalCellWidth,
    verticalCellWidth
  ]);
  const formatMultipleChartData = (data2) => {
    const reformulatedData = data2.reduce((acc, curr) => {
      curr.categories.forEach(({ category, originalCategory, value }) => {
        const existingEntry = acc.find((entry) => entry.category === category);
        if (existingEntry) {
          existingEntry[curr.label] = value;
        } else {
          const newEntry = { category, originalCategory, [curr.label]: value };
          acc.push(newEntry);
        }
      });
      return acc;
    }, []);
    console.log("reformulatedData", reformulatedData);
    return reformulatedData;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime197.jsxs)(
    StyledBarChart,
    {
      $isEditable: isEditable,
      $coefficient: title && subTitle ? 5 : title || subTitle ? 4 : 3,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime197.jsx)(
          ChartHeader,
          __spreadValues({
            isEditable: !!isEditable,
            title: title || "",
            titleBold: titleBold || false,
            titleColor: titleColor || "",
            titleUnderline: titleUnderline || false,
            titleItalic: titleItalic || false,
            subtitleBold: subtitleBold || false,
            subtitleColor: subtitleColor || "",
            subtitleUnderline: subtitleUnderline || false,
            subtitleItalic: subtitleItalic || false,
            subTitle: subTitle || ""
          }, isEditable && {
            handleTitleChange,
            handleSubTitleChange
          })
        ),
        /* @__PURE__ */ (0, import_jsx_runtime197.jsx)("div", { id: chartId, className: "chart-container" })
      ]
    }
  );
};
var StyledBarChart = import_styled_components8.styled.div`
  height: calc(100% - 12px);
  width: 100%;
  min-width: 242px;
  min-height: 182px;

  .chart-container {
    height: calc(100% - ${(p) => 10 * p.$coefficient}px);
    width: 100%;
    min-width: 242px;
    min-height: 182px;
    margin-inline: auto;
  }

  ${(p) => !p.$isEditable && `h3, h5 {
    margin-block: 0 !important;
  }`}

  ${(p) => p.$isEditable !== void 0 && `  .ant-typography + h5.ant-typography {
    // margin-top: 15px !important;
  }`}
`;

// components/charts/ChartSelection.tsx
var import_styled_components9 = require("styled-components");

// interfaces/search.interface.ts
var chartType = /* @__PURE__ */ ((chartType2) => {
  chartType2["DEFAULT"] = "0";
  chartType2["LINE"] = "Line";
  chartType2["BAR"] = "Bar";
  chartType2["PIE"] = "Pie";
  chartType2["RADAR"] = "Radar";
  chartType2["CARD"] = "Card";
  chartType2["EDITOR"] = "EDITOR";
  chartType2["TABLE"] = "TABLE";
  return chartType2;
})(chartType || {});

// components/charts/ChartSelection.config.tsx
var import_jsx_runtime198 = require("react/jsx-runtime");
var dashboardCharts = [
  {
    key: "0" /* DEFAULT */,
    icon: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(GalaxyStarIcon, {})
  },
  {
    key: "Line" /* LINE */,
    icon: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(LineChartIcon, {})
  },
  {
    key: "Bar" /* BAR */,
    icon: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(BarChartIcon, {})
  },
  {
    key: "Pie" /* PIE */,
    icon: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(PieChartIcon, {})
  },
  {
    key: "Radar" /* RADAR */,
    icon: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(RadarChartIcon, {})
  },
  {
    key: "Card" /* CARD */,
    icon: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(CardChartIcon, {})
  },
  {
    key: "EDITOR" /* EDITOR */,
    icon: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(EditorIcon, {})
  },
  {
    key: "TABLE" /* TABLE */,
    icon: /* @__PURE__ */ (0, import_jsx_runtime198.jsx)(TableIcon, {})
  }
];

// components/charts/ChartSelection.tsx
var import_react75 = require("react");
var import_jsx_runtime199 = require("react/jsx-runtime");
var ChartSelection = (props) => {
  const {
    selection,
    defaultSelected,
    isSelection,
    onSelectedChange,
    onChartTypeClick,
    selectedKey,
    chartResponce
  } = props;
  const [selectedChart, setSelectedChart] = (0, import_react75.useState)(
    defaultSelected || "0" /* DEFAULT */
  );
  const [hoveredChart, setHoveredChart] = (0, import_react75.useState)("0" /* DEFAULT */);
  const handleChartClick = (key) => {
    onChartTypeClick && onChartTypeClick({ chartType: key });
    if (isSelection) {
      setSelectedChart(key);
      onSelectedChange && onSelectedChange(key);
    }
  };
  const chartsSelection = selection ? dashboardCharts.filter(({ key }) => selection.includes(key)) : dashboardCharts;
  return /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(StyledChartSelection, { chartResponce, children: chartsSelection.map((chart) => {
    return /* @__PURE__ */ (0, import_jsx_runtime199.jsx)(
      Styledcharts,
      {
        onClick: () => handleChartClick(chart.key),
        onMouseEnter: () => setHoveredChart(chart.key),
        onMouseLeave: () => setHoveredChart("0" /* DEFAULT */),
        hovred: [selectedChart, hoveredChart, selectedKey].includes(chart.key) ? true : false,
        chartResponce,
        children: chart.icon
      }
    );
  }) });
};
var StyledChartSelection = import_styled_components9.styled.div`
  display: flex;
  justify-content: ${(props) => props.chartResponce ? "space-between" : "space-around"};
  flex-wrap: ${(props) => props.chartResponce ? "wrap" : "nowrap"};
`;
var Styledcharts = import_styled_components9.styled.div`
  height: ${(props) => props.chartResponce ? "50px" : "38px"};
  margin-right: ${(props) => props.chartResponce ? "auto" : "20px"};
  margin-bottom: ${(props) => props.chartResponce ? "10px" : "auto"};
  width: ${(props) => props.chartResponce ? "calc(50% - 4px)" : "auto"};
  cursor: pointer;
  padding: ${(props) => props.chartResponce ? "16px 16px" : "10px 31px"};
  border-radius: 7px;
  background: ${(props) => props.hovred ? "#fff" : "#eff1fd"};
  color: ${(props) => props.hovred ? "#1677FF" : "#1C1B1F"};
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: ${(props) => props.chartResponce ? "1px solid #4974f640" : "none"};
`;

// components/charts/LineChart.tsx
var import_react76 = require("react");
var import_styled_components10 = require("styled-components");
var import_react77 = require("react");
var import_jsx_runtime200 = require("react/jsx-runtime");
var LineChart = ({
  isEditable,
  chartId,
  data,
  hasLegend,
  color: color2,
  seriesList,
  title,
  titleBold,
  titleColor,
  titleUnderline,
  titleItalic,
  subtitleBold,
  subtitleColor,
  subtitleUnderline,
  subtitleItalic,
  subTitle,
  lineFillColor,
  lineChartType,
  target,
  targetValue,
  underTargetColors,
  selectedRows,
  selectedColumn,
  dataColumns,
  zoomLevel = 1,
  horizontalCellWidth,
  verticalCellWidth,
  verticalCellRight,
  enableFormattedNumbers,
  displayChartLabels,
  handleTitleChange,
  handleSubTitleChange
}) => {
  const [formattedData, setFormattedData] = (0, import_react77.useState)(data);
  const [startValue, setStartValue] = (0, import_react77.useState)(0);
  const settings = JSON.stringify({
    hasLegend,
    color: color2,
    seriesList,
    title,
    subTitle,
    selectedRows,
    selectedColumn,
    lineFillColor,
    lineChartType,
    target,
    targetValue,
    underTargetColors,
    horizontalCellWidth,
    verticalCellWidth,
    verticalCellRight,
    enableFormattedNumbers,
    displayChartLabels
  });
  (0, import_react76.useEffect)(() => {
    if (selectedColumn && selectedRows) {
      if (!isEmpty(selectedColumn[0]) && selectedRows[0] !== void 0) {
        if (selectedRows.length === 1) {
          setFormattedData(formatSimpleData(data));
        } else {
          setFormattedData(formatMultipleData(data));
        }
      }
    }
  }, [settings]);
  const formatSimpleData = (rawData) => {
    if (selectedColumn && selectedRows) {
      const categoryCount = {};
      const newData = rawData == null ? void 0 : rawData.map((element) => {
        let baseCategory = element[selectedColumn[0]];
        let category = baseCategory;
        if (categoryCount[baseCategory] !== void 0) {
          categoryCount[baseCategory]++;
          category = `${baseCategory} (${categoryCount[baseCategory]})`;
        } else {
          categoryCount[baseCategory] = 1;
          category = `${baseCategory} (1)`;
        }
        return {
          originalCategory: baseCategory,
          category,
          value: parseFloat(element[selectedRows[0]])
        };
      });
      return newData;
    }
  };
  const formatMultipleData = (rawData) => {
    var _a;
    const transformedData = [];
    if (selectedColumn && selectedRows) {
      for (const yValue of selectedRows) {
        const categories = [];
        const categoryCounts = {};
        for (const item of rawData) {
          let categoryBase = item[selectedColumn[0]];
          let category = categoryBase;
          if (categoryCounts[categoryBase] !== void 0) {
            categoryCounts[categoryBase] += 1;
            category = `${categoryBase} (${categoryCounts[categoryBase]})`;
          } else {
            categoryCounts[categoryBase] = 1;
            category = `${categoryBase} (1)`;
          }
          categories.push({
            originalCategory: categoryBase,
            value: parseFloat(item[yValue]),
            category
          });
        }
        transformedData.push({
          categories,
          key: yValue,
          label: ((_a = dataColumns == null ? void 0 : dataColumns.find((column2) => column2.key === yValue)) == null ? void 0 : _a.alias) || yValue
        });
      }
    }
    return transformedData;
  };
  const chartElement = document.getElementById(chartId);
  if (chartElement) {
    const resizeObserver2 = new ResizeObserver((entries) => {
      var _a, _b;
      for (let entry of entries) {
        const newWidth = entry.contentRect.width;
        const isMultiple3 = (_a = formattedData[0]) == null ? void 0 : _a.label;
        const columnsLength = isMultiple3 ? (_b = formattedData[0]) == null ? void 0 : _b.categories.length : formattedData == null ? void 0 : formattedData.length;
        const visibleDataRange = newWidth / (horizontalCellWidth || 40);
        const newStartValue = Math.max(
          0,
          (columnsLength - visibleDataRange) / columnsLength
        );
        setStartValue(newStartValue);
      }
    });
    resizeObserver2.observe(chartElement);
  } else {
    console.error("Chart element not found or invalid.");
  }
  (0, import_react76.useLayoutEffect)(() => {
    var _a, _b, _c;
    const root = Root.new(chartId, {
      calculateSize: function(dimensions) {
        return {
          width: dimensions.width * (1 / zoomLevel),
          height: dimensions.height * (1 / zoomLevel)
        };
      }
    });
    root.fps = 30;
    (_a = root._logo) == null ? void 0 : _a.dispose();
    const customizedTheme = Theme2.new(root);
    customizedTheme.rule("Label").setAll({
      fontFamily: "SpaceGrotesk"
    });
    root.setThemes([Animated_default.new(root), customizedTheme]);
    const bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "B" },
      { number: 1e12, suffix: "T" },
      { number: 1e15, suffix: "Q" },
      { number: 1e18, suffix: "QQ" },
      { number: 1e21, suffix: "S" },
      { number: 1e24, suffix: "SS" },
      { number: 1e27, suffix: "O" },
      { number: 1e30, suffix: "N" },
      { number: 1e33, suffix: "D" },
      { number: 1e36, suffix: "UD" },
      { number: 1e39, suffix: "DD" },
      { number: 1e42, suffix: "TD" },
      { number: 1e45, suffix: "QD" },
      { number: 1e48, suffix: "QD" },
      { number: 1e51, suffix: "SD" },
      { number: 1e54, suffix: "SSD" },
      { number: 1e57, suffix: "OD" },
      { number: 1e60, suffix: "ND" },
      { number: 1e63, suffix: "VD" }
    ];
    const chart = root.container.children.push(
      XYChart.new(root, {
        panX: false,
        panY: false,
        // wheelX: "none",
        // wheelY: "none",
        pinchZoomX: false,
        layout: root.verticalLayout
      })
    );
    const yAxis = chart.yAxes.push(
      ValueAxis.new(root, {
        min: 0,
        maxDeviation: 0.3,
        numberFormatter: enableFormattedNumbers ? NumberFormatter.new(root, {
          numberFormat: "###a",
          bigNumberPrefixes,
          numericFields: ["value"]
        }) : void 0,
        renderer: AxisRendererY.new(root, {
          opposite: verticalCellRight
        })
      })
    );
    yAxis.get("renderer").labels.template.setAll({
      oversizedBehavior: "truncate",
      textAlign: "center",
      maxWidth: (verticalCellWidth || 40) * 0.9
    });
    const cursor = chart.set("cursor", XYCursor.new(root, {}));
    cursor.lineY.set("visible", false);
    const xAxis = chart.xAxes.push(
      CategoryAxis.new(root, {
        maxDeviation: 0.3,
        categoryField: "category",
        renderer: AxisRendererX.new(root, {
          minGridDistance: 10
        })
        // tooltip: am5.Tooltip.new(root, {}),
      })
    );
    xAxis.get("renderer").labels.template.setAll({
      text: "{originalCategory}",
      tooltipText: "{originalCategory}",
      oversizedBehavior: "truncate",
      textAlign: "center"
      // maxWidth: horizontalCellWidth! * 0.9 * zoomLevel,
    });
    xAxis.onPrivate("cellWidth", function(cellWidth) {
      xAxis.get("renderer").labels.template.set("maxWidth", cellWidth);
    });
    xAxis.get("renderer").labels.template.setup = function(target2) {
      target2.set(
        "background",
        Rectangle.new(root, {
          fill: color(0),
          fillOpacity: 0
        })
      );
    };
    var tooltip = xAxis.labelsContainer.set(
      "tooltip",
      Tooltip4.new(root, {
        pointerOrientation: "vertical"
      })
    );
    tooltip.label.setAll({
      maxWidth: 200,
      oversizedBehavior: "wrap"
    });
    const isMultiple3 = (_b = formattedData[0]) == null ? void 0 : _b.label;
    if (isMultiple3)
      formattedData.forEach(({ label, key }) => {
        makeSeries(
          formatMultipleChartData(formattedData),
          color2 == null ? void 0 : color2[key],
          label,
          underTargetColors == null ? void 0 : underTargetColors[key]
        );
      });
    else
      makeSeries(
        formattedData,
        (_c = color2 == null ? void 0 : color2[seriesList == null ? void 0 : seriesList[0]]) != null ? _c : defaultChartColor,
        void 0,
        underTargetColors == null ? void 0 : underTargetColors[seriesList == null ? void 0 : seriesList[0]]
      );
    if (hasLegend) {
      const legend = chart.children.push(
        Legend.new(root, {
          x: p0,
          centerX: p0,
          layout: root.horizontalLayout
        })
      );
      legend.data.setAll(chart.series.values);
    }
    const scrollbar = chart.set(
      "scrollbarX",
      Scrollbar.new(root, {
        orientation: "horizontal",
        minWidth: 12,
        end: 1 - startValue
      })
    );
    chart.bottomAxesContainer.children.push(scrollbar);
    scrollbar.startGrip.setAll({
      visible: false
    });
    scrollbar.endGrip.setAll({
      visible: false
    });
    scrollbar.thumb.setAll({
      visible: startValue !== 0
    });
    scrollbar.get("background").setAll({
      fill: startValue !== 0 ? color(15725053) : void 0
    });
    chart.zoomOutButton.set("forceHidden", true);
    chart.appear();
    function makeSeries(data2, color3 = defaultChartColor, key, targetColor = "#000000") {
      var _a2, _b2, _c2, _d, _e, _f, _g, _h;
      xAxis.data.setAll(data2);
      let seriesType = lineChartType === "SMOOTH" ? SmoothedXLineSeries : lineChartType === "STEP" ? StepLineSeries : LineSeries;
      const series = chart.series.push(
        seriesType.new(root, {
          name: key || (seriesList && seriesList.length > 0 ? ((_a2 = dataColumns == null ? void 0 : dataColumns.find((column2) => column2.key === seriesList[0])) == null ? void 0 : _a2.alias) || seriesList[0] : "Serie 1"),
          xAxis,
          yAxis,
          valueYField: key || "value",
          categoryXField: "category",
          stroke: color(color3),
          fill: color(color3),
          tooltip: Tooltip4.new(root, {
            labelText: "{valueY}",
            autoTextColor: false
          })
        })
      );
      series.strokes.template.setAll({
        strokeWidth: 2
      });
      if (lineFillColor)
        series.fills.template.setAll({
          fillOpacity: 0.5,
          visible: true
        });
      (_c2 = (_b2 = series == null ? void 0 : series.get("tooltip")) == null ? void 0 : _b2.get("background")) == null ? void 0 : _c2.adapters.add("fill", () => {
        return color(color3);
      });
      if (displayChartLabels)
        series.bullets.push(function() {
          return Bullet.new(root, {
            locationX: 0.5,
            locationY: 1.2,
            sprite: Label.new(root, {
              centerX: p50,
              centerY: percent(75),
              text: "{value}",
              fill: color(0),
              populateText: true
            })
          });
        });
      series.data.setAll(data2);
      if (target && targetValue) {
        var seriesRangeDataItem = yAxis.makeDataItem({
          value: targetValue,
          endValue: 0
        });
        var seriesRange = series.createAxisRange(seriesRangeDataItem);
        (_d = seriesRange.fills) == null ? void 0 : _d.template.setAll({
          visible: true,
          opacity: 0.3
        });
        (_e = seriesRange.fills) == null ? void 0 : _e.template.set("fill", color(targetColor));
        (_f = seriesRange.strokes) == null ? void 0 : _f.template.set("stroke", color(targetColor));
        (_g = seriesRangeDataItem.get("grid")) == null ? void 0 : _g.setAll({
          strokeOpacity: 1,
          visible: true,
          stroke: color(0),
          strokeDasharray: [2, 2]
        });
        (_h = seriesRangeDataItem.get("label")) == null ? void 0 : _h.setAll({
          location: 0,
          visible: true,
          text: "Target",
          inside: true,
          centerX: 0,
          centerY: p100,
          fontWeight: "bold"
        });
      }
      series.appear();
    }
    return () => root.dispose();
  }, [
    chartId,
    formattedData,
    zoomLevel,
    startValue,
    verticalCellWidth,
    horizontalCellWidth
  ]);
  const formatMultipleChartData = (data2) => {
    const reformulatedData = data2.reduce((acc, curr) => {
      curr.categories.forEach(({ category, originalCategory, value }) => {
        const existingEntry = acc.find((entry) => entry.category === category);
        if (existingEntry) {
          existingEntry[curr.label] = value;
        } else {
          const newEntry = { category, originalCategory, [curr.label]: value };
          acc.push(newEntry);
        }
      });
      return acc;
    }, []);
    console.log("reformulatedData", reformulatedData);
    return reformulatedData;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime200.jsxs)(
    StyledLineChart,
    {
      $isEditable: isEditable,
      $coefficient: title && subTitle ? 5 : title || subTitle ? 4 : 3,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime200.jsx)(
          ChartHeader,
          __spreadValues({
            isEditable: !!isEditable,
            title: title || "",
            titleBold: titleBold || false,
            titleColor: titleColor || "",
            titleUnderline: titleUnderline || false,
            titleItalic: titleItalic || false,
            subtitleBold: subtitleBold || false,
            subtitleColor: subtitleColor || "",
            subtitleUnderline: subtitleUnderline || false,
            subtitleItalic: subtitleItalic || false,
            subTitle: subTitle || ""
          }, isEditable && {
            handleTitleChange,
            handleSubTitleChange
          })
        ),
        /* @__PURE__ */ (0, import_jsx_runtime200.jsx)("div", { id: chartId, className: "chart-container" })
      ]
    }
  );
};
var StyledLineChart = import_styled_components10.styled.div`
  height: calc(100% - 12px);
  width: 100%;
  min-width: 242px;
  min-height: 182px;

  .chart-container {
    height: calc(100% - ${(p) => 10 * p.$coefficient}px);
    width: 100%;
    min-width: 242px;
    min-height: 182px;
    margin-inline: auto;
  }

  ${(p) => !p.$isEditable && `h3, h5 {
    margin-block: 0 !important;
  }`}

  ${(p) => p.$isEditable !== void 0 && `  .ant-typography + h5.ant-typography {
    // margin-top: 15px !important;
  }`}
`;

// components/charts/PieChart.tsx
var import_styled_components11 = require("styled-components");
var import_react78 = require("react");

// ../../node_modules/@amcharts/amcharts5/.internal/charts/percent/PercentDefaultTheme.js
var PercentDefaultTheme = class extends Theme2 {
  setupDefaultRules() {
    super.setupDefaultRules();
    const ic = this._root.interfaceColors;
    const r = this.rule.bind(this);
    r("PercentSeries").setAll({
      legendLabelText: "{category}",
      legendValueText: "{valuePercentTotal.formatNumber('0.00p')}",
      colors: ColorSet.new(this._root, {}),
      width: p100,
      height: p100
    });
    r("PieChart").setAll({
      radius: percent(80),
      startAngle: -90,
      endAngle: 270
    });
    r("PieSeries").setAll({
      alignLabels: true,
      startAngle: -90,
      endAngle: 270
    });
    r("PieSeries").states.create("hidden", { endAngle: -90, opacity: 0 });
    r("Slice", ["pie"]).setAll({
      position: "absolute",
      isMeasured: false,
      x: 0,
      y: 0,
      toggleKey: "active",
      tooltipText: "{category}: {valuePercentTotal.formatNumber('0.00p')}",
      strokeWidth: 1,
      strokeOpacity: 1,
      role: "figure",
      lineJoin: "round"
    });
    r("Slice", ["pie"]).states.create("active", { shiftRadius: 20, scale: 1 });
    r("Slice", ["pie"]).states.create("hoverActive", { scale: 1.04 });
    r("Slice", ["pie"]).states.create("hover", { scale: 1.04 });
    r("RadialLabel", ["pie"]).setAll({
      textType: "aligned",
      radius: 10,
      text: "{category}: {valuePercentTotal.formatNumber('0.00p')}",
      paddingTop: 5,
      paddingBottom: 5,
      populateText: true
    });
    r("Tick", ["pie"]).setAll({
      location: 1
    });
    r("SlicedChart").setAll({
      paddingLeft: 10,
      paddingRight: 10,
      paddingTop: 10,
      paddingBottom: 10
    });
    r("FunnelSeries").setAll({
      startLocation: 0,
      endLocation: 1,
      orientation: "vertical",
      alignLabels: true,
      sequencedInterpolation: true
    });
    r("FunnelSlice").setAll({
      interactive: true,
      expandDistance: 0
      //tooltipText: "{category}: {valuePercentTotal.formatNumber('0.00p')}"
    });
    r("FunnelSlice").states.create("hover", { expandDistance: 0.15 });
    r("Label", ["funnel"]).setAll({
      populateText: true,
      text: "{category}: {valuePercentTotal.formatNumber('0.00p')}",
      centerY: p50
    });
    r("Label", ["funnel", "horizontal"]).setAll({
      centerX: 0,
      centerY: p50,
      rotation: -90
    });
    r("Label", ["funnel", "vertical"]).setAll({
      centerY: p50,
      centerX: 0
    });
    r("Tick", ["funnel"]).setAll({
      location: 1
    });
    r("FunnelSlice", ["funnel", "link"]).setAll({
      fillOpacity: 0.5,
      strokeOpacity: 0,
      expandDistance: -0.1
    });
    r("FunnelSlice", ["funnel", "link", "vertical"]).setAll({
      height: 10
    });
    r("FunnelSlice", ["funnel", "link", "horizontal"]).setAll({
      width: 10
    });
    r("PyramidSeries").setAll({
      valueIs: "area"
    });
    r("FunnelSlice", ["pyramid", "link"]).setAll({
      fillOpacity: 0.5
    });
    r("FunnelSlice", ["pyramid", "link", "vertical"]).setAll({
      height: 0
    });
    r("FunnelSlice", ["pyramid", "link", "horizontal"]).setAll({
      width: 0
    });
    r("FunnelSlice", ["pyramid"]).setAll({
      interactive: true,
      expandDistance: 0
    });
    r("FunnelSlice", ["pyramid"]).states.create("hover", { expandDistance: 0.15 });
    r("Label", ["pyramid"]).setAll({
      populateText: true,
      text: "{category}: {valuePercentTotal.formatNumber('0.00p')}",
      centerY: p50
    });
    r("Label", ["pyramid", "horizontal"]).setAll({
      centerX: 0,
      centerY: p50,
      rotation: -90
    });
    r("Label", ["pyramid", "vertical"]).setAll({
      centerY: p50,
      centerX: 0
    });
    r("Tick", ["pyramid"]).setAll({
      location: 1
    });
    r("FunnelSlice", ["pictorial"]).setAll({
      interactive: true,
      tooltipText: "{category}: {valuePercentTotal.formatNumber('0.00p')}"
    });
    r("Label", ["pictorial"]).setAll({
      populateText: true,
      text: "{category}: {valuePercentTotal.formatNumber('0.00p')}",
      centerY: p50
    });
    r("Label", ["pictorial", "horizontal"]).setAll({
      centerX: 0,
      centerY: p50,
      rotation: -90
    });
    r("Label", ["pictorial", "vertical"]).setAll({
      centerY: p50,
      centerX: 0
    });
    r("FunnelSlice", ["pictorial", "link"]).setAll({
      fillOpacity: 0.5,
      width: 0,
      height: 0
    });
    r("Tick", ["pictorial"]).setAll({
      location: 0.5
    });
    {
      const rule = r("Graphics", ["pictorial", "background"]);
      rule.setAll({
        fillOpacity: 0.2
      });
      setColor(rule, "fill", ic, "alternativeBackground");
    }
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/charts/percent/PercentChart.js
var PercentChart = class extends SerialChart {
  _afterNew() {
    this._defaultThemes.push(PercentDefaultTheme.new(this._root));
    super._afterNew();
    this.chartContainer.children.push(this.seriesContainer);
    this.seriesContainer.children.push(this.bulletsContainer);
  }
  _processSeries(series) {
    super._processSeries(series);
    this.seriesContainer.children.moveValue(this.bulletsContainer, this.seriesContainer.children.length - 1);
  }
};
Object.defineProperty(PercentChart, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "PercentChart"
});
Object.defineProperty(PercentChart, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: SerialChart.classNames.concat([PercentChart.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/percent/PercentSeries.js
var PercentSeries = class extends Series {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "slicesContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Container.new(this._root, { position: "absolute", isMeasured: false }))
    });
    Object.defineProperty(this, "labelsContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Container.new(this._root, { position: "absolute", isMeasured: false }))
    });
    Object.defineProperty(this, "ticksContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.children.push(Container.new(this._root, { position: "absolute", isMeasured: false }))
    });
    Object.defineProperty(this, "_lLabels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_rLabels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "_hLabels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: []
    });
    Object.defineProperty(this, "slices", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._makeSlices()
    });
    Object.defineProperty(this, "labels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._makeLabels()
    });
    Object.defineProperty(this, "ticks", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this._makeTicks()
    });
  }
  /**
   * @ignore
   */
  makeSlice(dataItem) {
    const slice3 = this.slicesContainer.children.push(this.slices.make());
    slice3.on("fill", () => {
      this.updateLegendMarker(dataItem);
    });
    slice3.on("stroke", () => {
      this.updateLegendMarker(dataItem);
    });
    slice3._setDataItem(dataItem);
    dataItem.set("slice", slice3);
    this.slices.push(slice3);
    return slice3;
  }
  /**
   * @ignore
   */
  makeLabel(dataItem) {
    const label = this.labelsContainer.children.push(this.labels.make());
    label._setDataItem(dataItem);
    dataItem.set("label", label);
    this.labels.push(label);
    return label;
  }
  _shouldMakeBullet(dataItem) {
    if (dataItem.get("value") != null) {
      return true;
    }
    return false;
  }
  /**
   * @ignore
   */
  makeTick(dataItem) {
    const tick = this.ticksContainer.children.push(this.ticks.make());
    tick._setDataItem(dataItem);
    dataItem.set("tick", tick);
    this.ticks.push(tick);
    return tick;
  }
  _afterNew() {
    this.fields.push("category", "fill");
    super._afterNew();
  }
  _onDataClear() {
    const colors = this.get("colors");
    if (colors) {
      colors.reset();
    }
  }
  _prepareChildren() {
    super._prepareChildren();
    this._lLabels = [];
    this._rLabels = [];
    this._hLabels = [];
    if (this._valuesDirty) {
      let sum = 0;
      let absSum = 0;
      let valueHigh = 0;
      let valueLow = Infinity;
      let count = 0;
      each(this._dataItems, (dataItem) => {
        let valueWorking = dataItem.get("valueWorking", 0);
        sum += valueWorking;
        absSum += Math.abs(valueWorking);
      });
      each(this._dataItems, (dataItem) => {
        let value = dataItem.get("valueWorking", 0);
        if (value > valueHigh) {
          valueHigh = value;
        }
        if (value < valueLow) {
          valueLow = value;
        }
        count++;
        let percentTotal = value / absSum;
        if (absSum == 0) {
          percentTotal = 0;
        }
        dataItem.setRaw("valuePercentTotal", percentTotal * 100);
      });
      this.setPrivateRaw("valueLow", valueLow);
      this.setPrivateRaw("valueHigh", valueHigh);
      this.setPrivateRaw("valueSum", sum);
      this.setPrivateRaw("valueAverage", sum / count);
      this.setPrivateRaw("valueAbsoluteSum", absSum);
    }
  }
  /**
   * Shows hidden series.
   *
   * @param   duration  Animation duration in milliseconds
   * @return            Animation promise
   */
  show(duration) {
    const _super = Object.create(null, {
      show: { get: () => super.show }
    });
    return __awaiter(this, void 0, void 0, function* () {
      let promises = [];
      promises.push(_super.show.call(this, duration));
      promises.push(this._sequencedShowHide(true, duration));
      yield Promise.all(promises);
    });
  }
  /**
   * Hide whole series.
   *
   * @param   duration  Animation duration in milliseconds
   * @return            Animation promise
   */
  hide(duration) {
    const _super = Object.create(null, {
      hide: { get: () => super.hide }
    });
    return __awaiter(this, void 0, void 0, function* () {
      let promises = [];
      promises.push(_super.hide.call(this, duration));
      promises.push(this._sequencedShowHide(false, duration));
      yield Promise.all(promises);
    });
  }
  /**
   * @ignore
   */
  _updateChildren() {
    super._updateChildren();
    if (this._valuesDirty) {
      each(this._dataItems, (dataItem) => {
        dataItem.get("label").text.markDirtyText();
      });
    }
    if (this.isDirty("legendLabelText") || this.isDirty("legendValueText")) {
      each(this._dataItems, (dataItem) => {
        this.updateLegendValue(dataItem);
      });
    }
    this._arrange();
  }
  _arrange() {
    this._arrangeDown(this._lLabels);
    this._arrangeUp(this._lLabels);
    this._arrangeDown(this._rLabels);
    this._arrangeUp(this._rLabels);
    this._arrangeLeft(this._hLabels);
    this._arrangeRight(this._hLabels);
    each(this.dataItems, (dataItem) => {
      this._updateTick(dataItem);
    });
  }
  _afterChanged() {
    super._afterChanged();
    this._arrange();
  }
  processDataItem(dataItem) {
    super.processDataItem(dataItem);
    if (dataItem.get("fill") == null) {
      let colors = this.get("colors");
      if (colors) {
        dataItem.setRaw("fill", colors.next());
      }
    }
  }
  /**
   * Shows series's data item.
   *
   * @param   dataItem  Data item
   * @param   duration  Animation duration in milliseconds
   * @return            Promise
   */
  showDataItem(dataItem, duration) {
    const _super = Object.create(null, {
      showDataItem: { get: () => super.showDataItem }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const promises = [_super.showDataItem.call(this, dataItem, duration)];
      if (!isNumber(duration)) {
        duration = this.get("stateAnimationDuration", 0);
      }
      const easing = this.get("stateAnimationEasing");
      let value = dataItem.get("value");
      const animation = dataItem.animate({ key: "valueWorking", to: value, duration, easing });
      if (animation) {
        promises.push(animation.waitForStop());
      }
      const tick = dataItem.get("tick");
      if (tick) {
        promises.push(tick.show(duration));
      }
      const label = dataItem.get("label");
      if (label) {
        promises.push(label.show(duration));
      }
      const slice3 = dataItem.get("slice");
      if (slice3) {
        promises.push(slice3.show(duration));
      }
      if (slice3.get("active")) {
        slice3.states.applyAnimate("active");
      }
      yield Promise.all(promises);
    });
  }
  /**
   * Hides series's data item.
   *
   * @param   dataItem  Data item
   * @param   duration  Animation duration in milliseconds
   * @return            Promise
   */
  hideDataItem(dataItem, duration) {
    const _super = Object.create(null, {
      hideDataItem: { get: () => super.hideDataItem }
    });
    return __awaiter(this, void 0, void 0, function* () {
      const promises = [_super.hideDataItem.call(this, dataItem, duration)];
      const hiddenState = this.states.create("hidden", {});
      if (!isNumber(duration)) {
        duration = hiddenState.get("stateAnimationDuration", this.get("stateAnimationDuration", 0));
      }
      const easing = hiddenState.get("stateAnimationEasing", this.get("stateAnimationEasing"));
      const animation = dataItem.animate({ key: "valueWorking", to: 0, duration, easing });
      if (animation) {
        promises.push(animation.waitForStop());
      }
      const tick = dataItem.get("tick");
      if (tick) {
        promises.push(tick.hide(duration));
      }
      const label = dataItem.get("label");
      if (label) {
        promises.push(label.hide(duration));
      }
      const slice3 = dataItem.get("slice");
      slice3.hideTooltip();
      if (slice3) {
        promises.push(slice3.hide(duration));
      }
      yield Promise.all(promises);
    });
  }
  /**
   * @ignore
   */
  disposeDataItem(dataItem) {
    super.disposeDataItem(dataItem);
    let label = dataItem.get("label");
    if (label) {
      this.labels.removeValue(label);
      label.dispose();
    }
    let tick = dataItem.get("tick");
    if (tick) {
      this.ticks.removeValue(tick);
      tick.dispose();
    }
    let slice3 = dataItem.get("slice");
    if (slice3) {
      this.slices.removeValue(slice3);
      slice3.dispose();
    }
  }
  /**
   * Triggers hover on a series data item.
   *
   * @since 5.0.7
   * @param  dataItem  Target data item
   */
  hoverDataItem(dataItem) {
    const slice3 = dataItem.get("slice");
    if (slice3 && !slice3.isHidden()) {
      slice3.hover();
    }
  }
  /**
   * Triggers un-hover on a series data item.
   *
   * @since 5.0.7
   * @param  dataItem  Target data item
   */
  unhoverDataItem(dataItem) {
    const slice3 = dataItem.get("slice");
    if (slice3) {
      slice3.unhover();
    }
  }
  /**
   * @ignore
   */
  updateLegendMarker(dataItem) {
    if (dataItem) {
      const slice3 = dataItem.get("slice");
      if (slice3) {
        const legendDataItem = dataItem.get("legendDataItem");
        if (legendDataItem) {
          const markerRectangle = legendDataItem.get("markerRectangle");
          each(visualSettings, (setting) => {
            if (slice3.get(setting) != null) {
              markerRectangle.set(setting, slice3.get(setting));
            }
          });
        }
      }
    }
  }
  _arrangeDown(labels) {
    if (labels) {
      let next2 = this._getNextDown();
      labels.sort((a, b) => {
        if (a.y > b.y) {
          return 1;
        } else if (a.y < b.y) {
          return -1;
        } else {
          return 0;
        }
      });
      each(labels, (l) => {
        const bounds = l.label.adjustedLocalBounds();
        let labelTop = bounds.top;
        if (l.y + labelTop < next2) {
          l.y = next2 - labelTop;
        }
        l.label.set("y", l.y);
        next2 = l.y + bounds.bottom;
      });
    }
  }
  _getNextUp() {
    return this.labelsContainer.maxHeight();
  }
  _getNextDown() {
    return 0;
  }
  _arrangeUp(labels) {
    if (labels) {
      let next2 = this._getNextUp();
      labels.sort((a, b) => {
        if (a.y < b.y) {
          return 1;
        } else if (a.y > b.y) {
          return -1;
        } else {
          return 0;
        }
      });
      each(labels, (l) => {
        const bounds = l.label.adjustedLocalBounds();
        let labelBottom = bounds.bottom;
        if (l.y + labelBottom > next2) {
          l.y = next2 - labelBottom;
        }
        l.label.set("y", l.y);
        next2 = l.y + bounds.top;
      });
    }
  }
  _arrangeRight(labels) {
    if (labels) {
      let next2 = 0;
      labels.sort((a, b) => {
        if (a.y > b.y) {
          return 1;
        } else if (a.y < b.y) {
          return -1;
        } else {
          return 0;
        }
      });
      each(labels, (l) => {
        const bounds = l.label.adjustedLocalBounds();
        let labelLeft = bounds.left;
        if (l.y + labelLeft < next2) {
          l.y = next2 - labelLeft;
        }
        l.label.set("x", l.y);
        next2 = l.y + bounds.right;
      });
    }
  }
  _arrangeLeft(labels) {
    if (labels) {
      let next2 = this.labelsContainer.maxWidth();
      labels.sort((a, b) => {
        if (a.y < b.y) {
          return 1;
        } else if (a.y > b.y) {
          return -1;
        } else {
          return 0;
        }
      });
      each(labels, (l) => {
        const bounds = l.label.adjustedLocalBounds();
        let labelRight = bounds.right;
        if (l.y + labelRight > next2) {
          l.y = next2 - labelRight;
        }
        l.label.set("x", l.y);
        next2 = l.y + bounds.left;
      });
    }
  }
  _updateSize() {
    super._updateSize();
    this.markDirty();
  }
  _updateTick(_dataItem) {
  }
  _dispose() {
    super._dispose();
    const chart = this.chart;
    if (chart) {
      chart.series.removeValue(this);
    }
  }
};
Object.defineProperty(PercentSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "PercentSeries"
});
Object.defineProperty(PercentSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Series.classNames.concat([PercentSeries.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/pie/PieChart.js
var PieChart = class extends PercentChart {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_maxRadius", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
  }
  _afterNew() {
    super._afterNew();
    this.seriesContainer.setAll({ x: p50, y: p50 });
  }
  _prepareChildren() {
    super._prepareChildren();
    const chartContainer = this.chartContainer;
    const w = chartContainer.innerWidth();
    const h = chartContainer.innerHeight();
    const startAngle = this.get("startAngle", 0);
    const endAngle = this.get("endAngle", 0);
    const innerRadius = this.get("innerRadius");
    let bounds = getArcBounds(0, 0, startAngle, endAngle, 1);
    const wr = w / (bounds.right - bounds.left);
    const hr = h / (bounds.bottom - bounds.top);
    let innerBounds = { left: 0, right: 0, top: 0, bottom: 0 };
    if (innerRadius instanceof Percent) {
      let value = innerRadius.value;
      let mr = Math.min(wr, hr);
      value = Math.max(mr * value, mr - Math.min(h, w)) / mr;
      innerBounds = getArcBounds(0, 0, startAngle, endAngle, value);
      this.setPrivateRaw("irModifyer", value / innerRadius.value);
    }
    bounds = mergeBounds([bounds, innerBounds]);
    const prevRadius = this._maxRadius;
    this._maxRadius = Math.min(wr, hr);
    const radius = relativeToValue(this.get("radius", 0), this._maxRadius);
    this.seriesContainer.setAll({
      dy: -radius * (bounds.bottom + bounds.top) / 2,
      dx: -radius * (bounds.right + bounds.left) / 2
    });
    if (this.isDirty("startAngle") || this.isDirty("endAngle") || prevRadius != this._maxRadius) {
      this.series.each((series) => {
        series._markDirtyKey("startAngle");
      });
    }
    if (this.isDirty("innerRadius") || this.isDirty("radius")) {
      this.series.each((series) => {
        series._markDirtyKey("innerRadius");
      });
    }
  }
  /**
   * Returns outer radius in pixels.
   *
   * If optional series parameter is passed in, it will return outer radius
   * of that particular series.
   *
   * @param   series  Series
   * @return          Radius in pixels
   */
  radius(series) {
    let radius = relativeToValue(this.get("radius", 0), this._maxRadius);
    let innerRadius = relativeToValue(this.get("innerRadius", 0), radius);
    if (series) {
      let index2 = this.series.indexOf(series);
      let length2 = this.series.length;
      let seriesRadius = series.get("radius");
      if (seriesRadius != null) {
        return innerRadius + relativeToValue(seriesRadius, radius - innerRadius);
      } else {
        return innerRadius + (radius - innerRadius) / length2 * (index2 + 1);
      }
    }
    return radius;
  }
  /**
   * Returns inner radius in pixels.
   *
   * If optional series parameter is passed in, it will return inner radius
   * of that particular series.
   *
   * @param   series  Series
   * @return          Radius in pixels
   */
  innerRadius(series) {
    const radius = this.radius();
    let innerRadius = relativeToValue(this.get("innerRadius", 0), radius);
    if (innerRadius < 0) {
      innerRadius = radius + innerRadius;
    }
    if (series) {
      let index2 = this.series.indexOf(series);
      let length2 = this.series.length;
      let seriesInnerRadius = series.get("innerRadius");
      if (seriesInnerRadius != null) {
        return innerRadius + relativeToValue(seriesInnerRadius, radius - innerRadius);
      } else {
        return innerRadius + (radius - innerRadius) / length2 * index2;
      }
    }
    return innerRadius;
  }
};
Object.defineProperty(PieChart, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "PieChart"
});
Object.defineProperty(PieChart, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: PercentChart.classNames.concat([PieChart.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/pie/PieSeries.js
var PieSeries = class extends PercentSeries {
  _makeSlices() {
    return new ListTemplate(Template.new({}), () => Slice._new(this._root, {
      themeTags: mergeTags(this.slices.template.get("themeTags", []), ["pie", "series"])
    }, [this.slices.template]));
  }
  _makeLabels() {
    return new ListTemplate(Template.new({}), () => RadialLabel._new(this._root, {
      themeTags: mergeTags(this.labels.template.get("themeTags", []), ["pie", "series"])
    }, [this.labels.template]));
  }
  _makeTicks() {
    return new ListTemplate(Template.new({}), () => Tick._new(this._root, {
      themeTags: mergeTags(this.ticks.template.get("themeTags", []), ["pie", "series"])
    }, [this.ticks.template]));
  }
  processDataItem(dataItem) {
    super.processDataItem(dataItem);
    const slice3 = this.makeSlice(dataItem);
    slice3.on("scale", () => {
      this._updateTick(dataItem);
    });
    slice3.on("shiftRadius", () => {
      this._updateTick(dataItem);
    });
    slice3.events.on("positionchanged", () => {
      this._updateTick(dataItem);
    });
    const label = this.makeLabel(dataItem);
    label.events.on("positionchanged", () => {
      this._updateTick(dataItem);
    });
    this.makeTick(dataItem);
    slice3.events.on("positionchanged", () => {
      label.markDirty();
    });
  }
  _getNextUp() {
    const chart = this.chart;
    if (chart) {
      return chart._maxRadius;
    }
    return this.labelsContainer.maxHeight() / 2;
  }
  _getNextDown() {
    const chart = this.chart;
    if (chart) {
      return -chart._maxRadius;
    }
    return -this.labelsContainer.maxHeight() / 2;
  }
  _prepareChildren() {
    super._prepareChildren();
    const chart = this.chart;
    if (chart) {
      if (this.isDirty("alignLabels")) {
        let labelsTemplate = this.labels.template;
        if (this.get("alignLabels")) {
          labelsTemplate.set("textType", "aligned");
        } else {
          let textType = labelsTemplate.get("textType");
          if (textType == null || textType == "aligned") {
            labelsTemplate.set("textType", "adjusted");
          }
        }
      }
      if (this._valuesDirty || this.isDirty("radius") || this.isDirty("innerRadius") || this.isDirty("startAngle") || this.isDirty("endAngle") || this.isDirty("alignLabels")) {
        this.markDirtyBounds();
        const startAngle = this.get("startAngle", chart.get("startAngle", -90));
        const endAngle = this.get("endAngle", chart.get("endAngle", 270));
        const arc = endAngle - startAngle;
        let currentAngle = startAngle;
        const radius = chart.radius(this);
        this.setPrivateRaw("radius", radius);
        let innerRadius = chart.innerRadius(this) * chart.getPrivate("irModifyer", 1);
        if (innerRadius < 0) {
          innerRadius = radius + innerRadius;
        }
        each(this._dataItems, (dataItem) => {
          this.updateLegendValue(dataItem);
          let currentArc = arc * dataItem.get("valuePercentTotal") / 100;
          const slice3 = dataItem.get("slice");
          if (slice3) {
            slice3.set("radius", radius);
            slice3.set("innerRadius", innerRadius);
            slice3.set("startAngle", currentAngle);
            slice3.set("arc", currentArc);
            const color2 = dataItem.get("fill");
            slice3._setDefault("fill", color2);
            slice3._setDefault("stroke", color2);
          }
          let middleAngle = normalizeAngle(currentAngle + currentArc / 2);
          const label = dataItem.get("label");
          if (label) {
            label.setPrivate("radius", radius);
            label.setPrivate("innerRadius", innerRadius);
            label.set("labelAngle", middleAngle);
            if (label.get("textType") == "aligned") {
              let labelRadius = radius + label.get("radius", 0);
              let y2 = radius * sin(middleAngle);
              if (middleAngle > 90 && middleAngle <= 270) {
                if (!label.isHidden() && !label.isHiding()) {
                  this._lLabels.push({ label, y: y2 });
                }
                labelRadius *= -1;
                labelRadius -= this.labelsContainer.get("paddingLeft", 0);
                label.set("centerX", p100);
                label.setPrivateRaw("left", true);
              } else {
                if (!label.isHidden() && !label.isHiding()) {
                  this._rLabels.push({ label, y: y2 });
                }
                labelRadius += this.labelsContainer.get("paddingRight", 0);
                label.set("centerX", 0);
                label.setPrivateRaw("left", false);
              }
              label.set("x", labelRadius);
              label.set("y", radius * sin(middleAngle));
            }
          }
          currentAngle += currentArc;
          this._updateTick(dataItem);
        });
      }
    }
  }
  _updateTick(dataItem) {
    const tick = dataItem.get("tick");
    const label = dataItem.get("label");
    const slice3 = dataItem.get("slice");
    const location = tick.get("location", 1);
    if (tick && label && slice3) {
      const radius = (slice3.get("shiftRadius", 0) + slice3.get("radius", 0)) * slice3.get("scale", 1) * location;
      const labelAngle = label.get("labelAngle", 0);
      const cos3 = cos(labelAngle);
      const sin3 = sin(labelAngle);
      const labelsContainer = this.labelsContainer;
      const pl = labelsContainer.get("paddingLeft", 0);
      const pr = labelsContainer.get("paddingRight", 0);
      let x2 = 0;
      let y2 = 0;
      x2 = label.x();
      y2 = label.y();
      let points = [];
      if (x2 != 0 && y2 != 0) {
        if (label.get("textType") == "circular") {
          const labelRadius = label.radius() - label.get("paddingBottom", 0);
          const labelAngle2 = label.get("labelAngle", 0);
          x2 = labelRadius * cos(labelAngle2);
          y2 = labelRadius * sin(labelAngle2);
        }
        let dx = -pr;
        if (label.getPrivate("left")) {
          dx = pl;
        }
        points = [{ x: slice3.x() + radius * cos3, y: slice3.y() + radius * sin3 }, { x: x2 + dx, y: y2 }, { x: x2, y: y2 }];
      }
      tick.set("points", points);
    }
  }
  _positionBullet(bullet) {
    const sprite = bullet.get("sprite");
    if (sprite) {
      const dataItem = sprite.dataItem;
      const slice3 = dataItem.get("slice");
      if (slice3) {
        const innerRadius = slice3.get("innerRadius", 0);
        const radius = slice3.get("radius", 0);
        const startAngle = slice3.get("startAngle", 0);
        const arc = slice3.get("arc", 0);
        const locationX = bullet.get("locationX", 0.5);
        const locationY = bullet.get("locationY", 0.5);
        const angle = startAngle + arc * locationX;
        const r = innerRadius + (radius - innerRadius) * locationY;
        sprite.setAll({ x: cos(angle) * r, y: sin(angle) * r });
      }
    }
  }
};
Object.defineProperty(PieSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "PieSeries"
});
Object.defineProperty(PieSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: PercentSeries.classNames.concat([PieSeries.className])
});

// components/charts/PieChart.tsx
var import_react79 = require("react");
var import_jsx_runtime201 = require("react/jsx-runtime");
var PieChart2 = ({
  isEditable,
  chartId,
  data,
  type: type4,
  color: color2,
  hasLegend,
  title,
  titleBold,
  titleColor,
  titleUnderline,
  titleItalic,
  subtitleBold,
  subtitleColor,
  subtitleUnderline,
  subtitleItalic,
  subTitle,
  seriesList,
  selectedRows,
  selectedColumn,
  zoomLevel = 1,
  handleTitleChange,
  handleSubTitleChange,
  isDonut,
  donutLabel,
  displayChartLabels
}) => {
  const [formattedData, setFormattedData] = (0, import_react79.useState)(data);
  const settings = JSON.stringify({
    hasLegend,
    color: color2,
    seriesList,
    title,
    subTitle,
    selectedRows,
    selectedColumn,
    isDonut,
    donutLabel,
    displayChartLabels
  });
  (0, import_react79.useEffect)(() => {
    if (selectedColumn && selectedRows) {
      if (!isEmpty(selectedColumn[0]) && selectedRows[0] !== void 0 && selectedRows.length === 1) {
        setFormattedData(formatSimpleData(data));
      }
    }
  }, [settings]);
  const formatSimpleData = (rawData) => {
    if (selectedColumn && selectedRows) {
      const newData = rawData == null ? void 0 : rawData.map(
        (element) => ({
          category: element[selectedColumn[0]],
          value: parseFloat(element[selectedRows[0]])
        })
      );
      return newData;
    }
  };
  (0, import_react78.useLayoutEffect)(() => {
    var _a, _b, _c;
    let root = Root.new(chartId, {
      calculateSize: function(dimensions) {
        return {
          width: dimensions.width * (1 / zoomLevel),
          height: dimensions.height * (1 / zoomLevel)
        };
      }
    });
    root.fps = 30;
    (_a = root._logo) == null ? void 0 : _a.dispose();
    const customizedTheme = Theme2.new(root);
    customizedTheme.rule("Label").setAll({
      fontFamily: "SpaceGrotesk"
    });
    root.setThemes([Animated_default.new(root), customizedTheme]);
    let chart;
    if (isDonut) {
      chart = root.container.children.push(
        PieChart.new(root, {
          radius: percent(95),
          innerRadius: percent(50),
          layout: root.verticalLayout
        })
      );
    } else {
      chart = root.container.children.push(
        PieChart.new(root, { layout: root.verticalLayout })
      );
    }
    var series = chart.series.push(
      PieSeries.new(root, {
        name: "Series",
        valueField: "value",
        categoryField: "category",
        legendLabelText: "{category}",
        legendValueText: "{value}",
        endAngle: 270,
        alignLabels: true
      })
    );
    series.ticks.template.set("forceHidden", !displayChartLabels);
    if (displayChartLabels)
      series.labels.template.setAll({
        textType: "aligned",
        text: "{category}:{valuePercentTotal.formatNumber('0.00')}%",
        maxWidth: 180,
        oversizedBehavior: "truncate"
      });
    if (isDonut) {
      if (donutLabel) {
        let label = series.children.push(
          Label.new(root, {
            text: donutLabel,
            fontSize: 40,
            centerX: percent(50),
            centerY: percent(50),
            populateText: true,
            oversizedBehavior: "fit"
          })
        );
        series.onPrivate("width", function(h) {
          label.set("maxWidth", h * 0.1);
        });
      }
    }
    series.states.create("hidden", {
      endAngle: -90
    });
    series.labels.template.set("forceHidden", !displayChartLabels);
    (_c = series.get("colors")) == null ? void 0 : _c.set("colors", [
      color((_b = color2 == null ? void 0 : color2[seriesList == null ? void 0 : seriesList[0]]) != null ? _b : defaultChartColor)
    ]);
    series.slices.template.states.create("active", {
      shiftRadius: 0
    });
    series.slices.template.states.create("hover", {
      scale: 1
    });
    series.data.setAll(formattedData);
    let legend = null;
    if (hasLegend) {
      legend = chart.children.push(
        Legend.new(root, {
          // centerX: am5.percent(100),
          width: percent(100),
          // x: am5.percent(100),
          maxHeight: 30,
          // layout: root.horizontalLayout,
          // height: am5.percent(100),
          verticalScrollbar: Scrollbar.new(root, {
            orientation: "vertical",
            marginLeft: 0
          })
        })
      );
      legend.valueLabels.template.set("forceHidden", true);
      legend.data.setAll(series.dataItems);
    }
    series.appear();
    return () => root.dispose();
  }, [chartId, formattedData, zoomLevel]);
  return /* @__PURE__ */ (0, import_jsx_runtime201.jsxs)(
    StyledPieChart,
    {
      $isEditable: isEditable,
      $coefficient: title && subTitle ? 6 : title || subTitle ? 5 : 3.5,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime201.jsx)(
          ChartHeader,
          __spreadValues({
            isEditable: !!isEditable,
            title: title || "",
            titleBold: titleBold || false,
            titleColor: titleColor || "",
            titleUnderline: titleUnderline || false,
            titleItalic: titleItalic || false,
            subtitleBold: subtitleBold || false,
            subtitleColor: subtitleColor || "",
            subtitleUnderline: subtitleUnderline || false,
            subtitleItalic: subtitleItalic || false,
            subTitle: subTitle || ""
          }, isEditable && {
            handleTitleChange,
            handleSubTitleChange
          })
        ),
        /* @__PURE__ */ (0, import_jsx_runtime201.jsx)("div", { id: chartId, className: "chart-container" })
      ]
    }
  );
};
var StyledPieChart = import_styled_components11.styled.div`
  height: calc(100% - 12px);
  width: 100%;
  min-width: 242px;
  min-height: 182px;

  .chart-container {
    height: calc(100% - ${(p) => 10 * p.$coefficient}px);
    width: 100%;
    min-width: 242px;
    min-height: 182px;
    margin-inline: auto;
  }

  ${(p) => !p.$isEditable && `h3, h5 {
    margin-block: 0 !important;
  }`}

  ${(p) => p.$isEditable !== void 0 && `  .ant-typography + h5.ant-typography {
    // margin-top: 15px !important;
  }`}
`;

// components/charts/RadarChart.tsx
var import_styled_components12 = require("styled-components");
var import_react80 = require("react");

// ../../node_modules/@amcharts/amcharts5/.internal/charts/radar/AxisRendererCircular.js
var AxisRendererCircular = class extends AxisRenderer {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "labels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => AxisLabelRadial._new(this._root, {
        themeTags: mergeTags(this.labels.template.get("themeTags", []), this.get("themeTags", []))
      }, [this.labels.template]))
    });
    Object.defineProperty(this, "axisFills", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => Slice._new(this._root, {
        themeTags: mergeTags(this.axisFills.template.get("themeTags", ["fill"]), this.get("themeTags", []))
      }, [this.axisFills.template]))
    });
    Object.defineProperty(this, "_fillGenerator", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: arc_default()
    });
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["renderer", "circular"]);
    super._afterNew();
    this.setPrivateRaw("letter", "X");
    this.setRaw("position", "absolute");
  }
  _changed() {
    super._changed();
    if (this.isDirty("radius") || this.isDirty("innerRadius") || this.isDirty("startAngle") || this.isDirty("endAngle")) {
      this.updateLayout();
    }
  }
  /**
   * @ignore
   */
  processAxis() {
    super.processAxis();
    const axis = this.axis;
    axis.labelsContainer.set("isMeasured", false);
  }
  /**
   * @ignore
   */
  updateLayout() {
    const chart = this.chart;
    if (chart) {
      const radius = chart.getPrivate("radius", 0);
      let r = relativeToValue(this.get("radius", p100), radius);
      if (r < 0) {
        r = radius + r;
      }
      this.setPrivate("radius", r);
      let ir = relativeToValue(this.get("innerRadius", chart.getPrivate("innerRadius", 0)), radius) * chart.getPrivate("irModifyer", 1);
      if (ir < 0) {
        ir = r + ir;
      }
      this.setPrivate("innerRadius", ir);
      let startAngle = this.get("startAngle", chart.get("startAngle", -90));
      let endAngle = this.get("endAngle", chart.get("endAngle", 270));
      this.setPrivate("startAngle", startAngle);
      this.setPrivate("endAngle", endAngle);
      this.set("draw", (display) => {
        const p02 = this.positionToPoint(0);
        display.moveTo(p02.x, p02.y);
        if (startAngle > endAngle) {
          [startAngle, endAngle] = [endAngle, startAngle];
        }
        display.arc(0, 0, r, startAngle * RADIANS, endAngle * RADIANS);
      });
      this.axis.markDirtySize();
    }
  }
  /**
   * @ignore
   */
  updateGrid(grid, position2, endPosition) {
    if (grid) {
      if (position2 == null) {
        position2 = 0;
      }
      let location = grid.get("location", 0.5);
      if (endPosition != null && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      let radius = this.getPrivate("radius", 0);
      let innerRadius = this.getPrivate("innerRadius", 0);
      let angle = this.positionToAngle(position2);
      this.toggleVisibility(grid, position2, 0, 1);
      if (radius != null) {
        grid.set("draw", (display) => {
          display.moveTo(innerRadius * cos(angle), innerRadius * sin(angle));
          display.lineTo(radius * cos(angle), radius * sin(angle));
        });
      }
    }
  }
  /**
   * Converts relative position to angle.
   *
   * @param   position  Position
   * @return            Angle
   */
  positionToAngle(position2) {
    const axis = this.axis;
    const startAngle = this.getPrivate("startAngle", 0);
    const endAngle = this.getPrivate("endAngle", 360);
    const start = axis.get("start", 0);
    const end = axis.get("end", 1);
    let arc = (endAngle - startAngle) / (end - start);
    let angle;
    if (this.get("inversed")) {
      angle = startAngle + (end - position2) * arc;
    } else {
      angle = startAngle + (position2 - start) * arc;
    }
    return angle;
  }
  // do not delete
  _handleOpposite() {
  }
  /**
   * Converts relative position to an X/Y coordinate.
   *
   * @param   position  Position
   * @return            Point
   */
  positionToPoint(position2) {
    const radius = this.getPrivate("radius", 0);
    const angle = this.positionToAngle(position2);
    return { x: radius * cos(angle), y: radius * sin(angle) };
  }
  /**
   * @ignore
   */
  updateLabel(label, position2, endPosition, count) {
    if (label) {
      if (position2 == null) {
        position2 = 0;
      }
      let location = 0.5;
      if (count != null && count > 1) {
        location = label.get("multiLocation", location);
      } else {
        location = label.get("location", location);
      }
      if (endPosition != null && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      const radius = this.getPrivate("radius", 0);
      const innerRadius = this.getPrivate("innerRadius", 0);
      const angle = this.positionToAngle(position2);
      label.setPrivate("radius", radius);
      label.setPrivate("innerRadius", innerRadius);
      label.set("labelAngle", angle);
      this.toggleVisibility(label, position2, label.get("minPosition", 0), label.get("maxPosition", 1));
    }
  }
  /**
   * @ignore
   */
  fillDrawMethod(fill, startAngle, endAngle) {
    fill.set("draw", (display) => {
      if (startAngle == null) {
        startAngle = this.getPrivate("startAngle", 0);
      }
      if (endAngle == null) {
        endAngle = this.getPrivate("endAngle", 0);
      }
      const y0 = this.getPrivate("innerRadius", 0);
      const y1 = this.getPrivate("radius", 0);
      this._fillGenerator.context(display);
      this._fillGenerator({ innerRadius: y0, outerRadius: y1, startAngle: (startAngle + 90) * RADIANS, endAngle: (endAngle + 90) * RADIANS });
    });
  }
  /**
   * @ignore
   */
  updateTick(tick, position2, endPosition, count) {
    if (tick) {
      if (position2 == null) {
        position2 = 0;
      }
      let location = 0.5;
      if (count != null && count > 1) {
        location = tick.get("multiLocation", location);
      } else {
        location = tick.get("location", location);
      }
      if (endPosition != null && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      let length2 = tick.get("length", 0);
      const inside = tick.get("inside");
      if (inside) {
        length2 *= -1;
      }
      let radius = this.getPrivate("radius", 0);
      let angle = this.positionToAngle(position2);
      this.toggleVisibility(tick, position2, tick.get("minPosition", 0), tick.get("maxPosition", 1));
      if (radius != null) {
        tick.set("draw", (display) => {
          display.moveTo(radius * cos(angle), radius * sin(angle));
          radius += length2;
          display.lineTo(radius * cos(angle), radius * sin(angle));
        });
      }
    }
  }
  /**
   * @ignore
   */
  updateBullet(bullet, position2, endPosition) {
    if (bullet) {
      const sprite = bullet.get("sprite");
      if (sprite) {
        if (position2 == null) {
          position2 = 0;
        }
        let location = bullet.get("location", 0.5);
        if (endPosition != null && endPosition != position2) {
          position2 = position2 + (endPosition - position2) * location;
        }
        let radius = this.getPrivate("radius", 0);
        let angle = this.positionToAngle(position2);
        this.toggleVisibility(sprite, position2, 0, 1);
        sprite.setAll({ rotation: angle, x: radius * cos(angle), y: radius * sin(angle) });
      }
    }
  }
  /**
   * @ignore
   */
  updateFill(fill, position2, endPosition) {
    if (fill) {
      if (position2 == null) {
        position2 = 0;
      }
      if (endPosition == null) {
        endPosition = 1;
      }
      let startAngle = this.fitAngle(this.positionToAngle(position2));
      let endAngle = this.fitAngle(this.positionToAngle(endPosition));
      fill.setAll({ startAngle, arc: endAngle - startAngle });
      fill._setSoft("innerRadius", this.getPrivate("innerRadius"));
      fill._setSoft("radius", this.getPrivate("radius"));
    }
  }
  /**
   * @ignore
   */
  fitAngle(angle) {
    const startAngle = this.getPrivate("startAngle", 0);
    const endAngle = this.getPrivate("endAngle", 0);
    const minAngle = Math.min(startAngle, endAngle);
    const maxAngle = Math.max(startAngle, endAngle);
    if (angle < minAngle) {
      angle = minAngle;
    }
    if (angle > maxAngle) {
      angle = maxAngle;
    }
    return angle;
  }
  /**
   * Returns axis length in pixels.
   *
   * @return Length
   */
  axisLength() {
    return Math.abs(this.getPrivate("radius", 0) * Math.PI * 2 * (this.getPrivate("endAngle", 360) - this.getPrivate("startAngle", 0)) / 360);
  }
  /**
   * @ignore
   */
  positionTooltip(tooltip, position2) {
    let radius = this.getPrivate("radius", 0);
    const angle = this.positionToAngle(position2);
    this._positionTooltip(tooltip, { x: radius * cos(angle), y: radius * sin(angle) });
  }
  /**
   * @ignore
   */
  updateTooltipBounds(_tooltip) {
  }
};
Object.defineProperty(AxisRendererCircular, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisRendererCircular"
});
Object.defineProperty(AxisRendererCircular, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: AxisRenderer.classNames.concat([AxisRendererCircular.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/radar/AxisRendererRadial.js
var AxisRendererRadial = class extends AxisRenderer {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_fillGenerator", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: arc_default()
    });
    Object.defineProperty(this, "labels", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: new ListTemplate(Template.new({}), () => AxisLabelRadial._new(this._root, {
        themeTags: mergeTags(this.labels.template.get("themeTags", []), this.get("themeTags", []))
      }, [this.labels.template]))
    });
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["renderer", "radial"]);
    super._afterNew();
    this.setPrivate("letter", "Y");
    this.setRaw("position", "absolute");
  }
  _changed() {
    super._changed();
    if (this.isDirty("radius") || this.isDirty("innerRadius") || this.isDirty("startAngle") || this.isDirty("endAngle")) {
      this.updateLayout();
    }
  }
  /**
   * @ignore
   */
  processAxis() {
    super.processAxis();
  }
  /**
   * @ignore
   */
  updateLayout() {
    const chart = this.chart;
    if (chart) {
      const radius = chart.getPrivate("radius", 0);
      let r = relativeToValue(this.get("radius", p100), radius);
      let ir = relativeToValue(this.get("innerRadius", chart.getPrivate("innerRadius", 0)), radius) * chart.getPrivate("irModifyer", 1);
      if (ir < 0) {
        ir = r + ir;
      }
      this.setPrivate("radius", r);
      this.setPrivate("innerRadius", ir);
      let startAngle = this.get("startAngle", chart.get("startAngle", -90));
      let endAngle = this.get("endAngle", chart.get("endAngle", 270));
      this.setPrivate("startAngle", startAngle);
      this.setPrivate("endAngle", endAngle);
      const axisAngle = this.get("axisAngle", 0);
      this.set("draw", (display) => {
        display.moveTo(ir * cos(axisAngle), ir * sin(axisAngle));
        display.lineTo(r * cos(axisAngle), r * sin(axisAngle));
      });
      this.axis.markDirtySize();
    }
  }
  /**
   * @ignore
   */
  updateGrid(grid, position2, endPosition) {
    if (grid) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      let location = grid.get("location", 0.5);
      if (isNumber(endPosition) && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      let radius = this.positionToCoordinate(position2) + this.getPrivate("innerRadius", 0);
      this.toggleVisibility(grid, position2, 0, 1);
      if (isNumber(radius)) {
        grid.set("draw", (display) => {
          let startAngle = this.getPrivate("startAngle", 0) * RADIANS;
          let endAngle = this.getPrivate("endAngle", 0) * RADIANS;
          display.arc(0, 0, Math.max(0, radius), Math.min(startAngle, endAngle), Math.max(startAngle, endAngle));
        });
      }
    }
  }
  // do not delete
  _handleOpposite() {
  }
  /**
   * Converts relative position to X/Y point.
   *
   * @param   position  Position
   * @return            Point
   */
  positionToPoint(position2) {
    const innerRadius = this.getPrivate("innerRadius", 0);
    const radius = this.positionToCoordinate(position2) + innerRadius;
    const axisAngle = this.get("axisAngle", 0);
    return { x: radius * cos(axisAngle), y: radius * sin(axisAngle) };
  }
  /**
   * @ignore
   */
  updateLabel(label, position2, endPosition, count) {
    if (label) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      let location = 0.5;
      if (isNumber(count) && count > 1) {
        location = label.get("multiLocation", location);
      } else {
        location = label.get("location", location);
      }
      if (isNumber(endPosition) && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      const point2 = this.positionToPoint(position2);
      let radius = Math.hypot(point2.x, point2.y);
      label.setPrivate("radius", radius);
      label.setPrivate("innerRadius", radius);
      label.set("labelAngle", this.get("axisAngle"));
      this.toggleVisibility(label, position2, label.get("minPosition", 0), label.get("maxPosition", 1));
    }
  }
  fillDrawMethod(fill, y0, y1) {
    fill.set("draw", (display) => {
      y0 = Math.max(0, y0);
      y1 = Math.max(0, y1);
      this._fillGenerator.context(display);
      let startAngle = (this.getPrivate("startAngle", 0) + 90) * RADIANS;
      let endAngle = (this.getPrivate("endAngle", 0) + 90) * RADIANS;
      if (endAngle < startAngle) {
        [startAngle, endAngle] = [endAngle, startAngle];
      }
      this._fillGenerator({ innerRadius: y0, outerRadius: y1, startAngle, endAngle });
    });
  }
  /**
   * @ignore
   */
  updateTick(tick, position2, endPosition, count) {
    if (tick) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      let location = 0.5;
      if (isNumber(count) && count > 1) {
        location = tick.get("multiLocation", location);
      } else {
        location = tick.get("location", location);
      }
      if (isNumber(endPosition) && endPosition != position2) {
        position2 = position2 + (endPosition - position2) * location;
      }
      const point2 = this.positionToPoint(position2);
      tick.set("x", point2.x);
      tick.set("y", point2.y);
      let length2 = tick.get("length", 0);
      const inside = tick.get("inside");
      if (inside) {
        length2 *= -1;
      }
      const axisAngle = this.get("axisAngle", 0) + 90;
      tick.set("draw", (display) => {
        display.moveTo(0, 0);
        display.lineTo(length2 * cos(axisAngle), length2 * sin(axisAngle));
      });
      this.toggleVisibility(tick, position2, tick.get("minPosition", 0), tick.get("maxPosition", 1));
    }
  }
  /**
   * @ignore
   */
  updateBullet(bullet, position2, endPosition) {
    if (bullet) {
      const sprite = bullet.get("sprite");
      if (sprite) {
        if (!isNumber(position2)) {
          position2 = 0;
        }
        let location = bullet.get("location", 0.5);
        if (isNumber(endPosition) && endPosition != position2) {
          position2 = position2 + (endPosition - position2) * location;
        }
        const point2 = this.positionToPoint(position2);
        sprite.setAll({ x: point2.x, y: point2.y });
        this.toggleVisibility(sprite, position2, 0, 1);
      }
    }
  }
  /**
   * @ignore
   */
  updateFill(fill, position2, endPosition) {
    if (fill) {
      if (!isNumber(position2)) {
        position2 = 0;
      }
      if (!isNumber(endPosition)) {
        endPosition = 1;
      }
      const innerRadius = this.getPrivate("innerRadius", 0);
      let y0 = this.positionToCoordinate(position2) + innerRadius;
      let y1 = this.positionToCoordinate(endPosition) + innerRadius;
      this.fillDrawMethod(fill, y0, y1);
    }
  }
  /**
   * Returns axis length in pixels.
   *
   * @return Length
   */
  axisLength() {
    return this.getPrivate("radius", 0) - this.getPrivate("innerRadius", 0);
  }
  /**
   * @ignore
   */
  updateTooltipBounds(_tooltip) {
  }
  /**
   * Converts relative position to pixels.
   *
   * @param   position  Position
   * @return            Pixels
   */
  positionToCoordinate(position2) {
    if (this._inversed) {
      position2 = Math.min(this._end, position2);
      return (this._end - position2) * this._axisLength;
    } else {
      position2 = Math.max(this._start, position2);
      return (position2 - this._start) * this._axisLength;
    }
  }
  /**
   * @ignore
   */
  positionTooltip(tooltip, position2) {
    let radius = this.getPrivate("innerRadius", 0) + this.positionToCoordinate(position2);
    const angle = this.get("axisAngle", 0);
    this._positionTooltip(tooltip, { x: radius * cos(angle), y: radius * sin(angle) });
  }
};
Object.defineProperty(AxisRendererRadial, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "AxisRendererRadial"
});
Object.defineProperty(AxisRendererRadial, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: AxisRenderer.classNames.concat([AxisRendererRadial.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/radar/RadarDefaultTheme.js
var RadarDefaultTheme = class extends Theme2 {
  setupDefaultRules() {
    super.setupDefaultRules();
    const r = this.rule.bind(this);
    const ic = this._root.interfaceColors;
    r("RadarChart").setAll({
      radius: percent(80),
      innerRadius: 0,
      startAngle: -90,
      endAngle: 270
    });
    r("RadarColumnSeries").setAll({
      clustered: true
    });
    r("Slice", ["radar", "column", "series"]).setAll({
      width: percent(80),
      height: percent(80)
    });
    r("RadarLineSeries").setAll({
      connectEnds: true
    });
    r("SmoothedRadarLineSeries").setAll({
      tension: 0.5
    });
    r("AxisRendererRadial").setAll({
      minGridDistance: 40,
      axisAngle: -90,
      inversed: false,
      cellStartLocation: 0,
      cellEndLocation: 1
    });
    r("AxisRendererCircular").setAll({
      minGridDistance: 100,
      inversed: false,
      cellStartLocation: 0,
      cellEndLocation: 1
    });
    r("RadialLabel", ["circular"]).setAll({
      textType: "circular",
      paddingTop: 1,
      paddingRight: 0,
      paddingBottom: 1,
      paddingLeft: 0,
      centerX: 0,
      centerY: 0,
      radius: 8
    });
    r("AxisLabelRadial", ["category"]).setAll({
      text: "{category}",
      populateText: true
    });
    r("RadialLabel", ["radial"]).setAll({
      textType: "regular",
      centerX: 0,
      textAlign: "right"
    });
    r("RadarChart", ["gauge"]).setAll({
      startAngle: 180,
      endAngle: 360,
      innerRadius: percent(90)
    });
    r("ClockHand").setAll({
      topWidth: 1,
      bottomWidth: 10,
      radius: percent(90),
      pinRadius: 10
    });
    {
      const rule = r("Graphics", ["clock", "hand"]);
      rule.setAll({
        fillOpacity: 1
      });
      setColor(rule, "fill", ic, "alternativeBackground");
    }
    {
      const rule = r("Graphics", ["clock", "pin"]);
      rule.setAll({
        fillOpacity: 1
      });
      setColor(rule, "fill", ic, "alternativeBackground");
    }
  }
};

// ../../node_modules/@amcharts/amcharts5/.internal/charts/radar/RadarChart.js
var RadarChart = class extends XYChart {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "radarContainer", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: this.plotContainer.children.push(Container.new(this._root, { x: p50, y: p50 }))
    });
    Object.defineProperty(this, "_arcGenerator", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: arc_default()
    });
    Object.defineProperty(this, "_maxRadius", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: 1
    });
  }
  _afterNew() {
    this._defaultThemes.push(RadarDefaultTheme.new(this._root));
    super._afterNew();
    const radarContainer = this.radarContainer;
    const gridContainer = this.gridContainer;
    const topGridContainer = this.topGridContainer;
    const seriesContainer = this.seriesContainer;
    const bulletsContainer = this.bulletsContainer;
    radarContainer.children.pushAll([gridContainer, seriesContainer, topGridContainer, bulletsContainer]);
    seriesContainer.set("mask", Graphics.new(this._root, {}));
    gridContainer.set("mask", Graphics.new(this._root, {}));
    this._disposers.push(this.plotContainer.events.on("boundschanged", () => {
      this._updateRadius();
    }));
  }
  _maskGrid() {
  }
  _prepareChildren() {
    super._prepareChildren();
    if (this._sizeDirty || this.isDirty("radius") || this.isDirty("innerRadius") || this.isDirty("startAngle") || this.isDirty("endAngle")) {
      const chartContainer = this.chartContainer;
      const w = chartContainer.innerWidth();
      const h = chartContainer.innerHeight();
      const startAngle = this.get("startAngle", 0);
      const endAngle = this.get("endAngle", 0);
      const innerRadius = this.get("innerRadius");
      let bounds = getArcBounds(0, 0, startAngle, endAngle, 1);
      const wr = w / (bounds.right - bounds.left);
      const hr = h / (bounds.bottom - bounds.top);
      let innerBounds = { left: 0, right: 0, top: 0, bottom: 0 };
      if (innerRadius instanceof Percent) {
        let value = innerRadius.value;
        let mr = Math.min(wr, hr);
        value = Math.max(mr * value, mr - Math.min(h, w)) / mr;
        innerBounds = getArcBounds(0, 0, startAngle, endAngle, value);
        this.setPrivateRaw("irModifyer", value / innerRadius.value);
      }
      bounds = mergeBounds([bounds, innerBounds]);
      this._maxRadius = Math.max(0, Math.min(wr, hr));
      const radius = relativeToValue(this.get("radius", 0), this._maxRadius);
      this.radarContainer.setAll({
        dy: -radius * (bounds.bottom + bounds.top) / 2,
        dx: -radius * (bounds.right + bounds.left) / 2
      });
      this._updateRadius();
    }
  }
  _addCursor(cursor) {
    this.radarContainer.children.push(cursor);
  }
  // do not delete
  _updateRadius() {
    const radius = relativeToValue(this.get("radius", percent(80)), this._maxRadius);
    this.setPrivateRaw("radius", radius);
    let innerRadius = relativeToValue(this.get("innerRadius", 0), radius);
    if (innerRadius < 0) {
      innerRadius = radius + innerRadius;
    }
    this.setPrivateRaw("innerRadius", innerRadius);
    this.xAxes.each((axis) => {
      const renderer = axis.get("renderer");
      renderer.updateLayout();
    });
    this.yAxes.each((axis) => {
      const renderer = axis.get("renderer");
      renderer.updateLayout();
    });
    this._updateMask(this.seriesContainer, innerRadius, radius);
    this._updateMask(this.gridContainer, innerRadius, radius);
    this.series.each((series) => {
      if (series.get("maskBullets")) {
        this._updateMask(series.bulletsContainer, innerRadius, radius);
      } else {
        series.bulletsContainer.remove("mask");
      }
    });
    const cursor = this.get("cursor");
    if (cursor) {
      cursor.updateLayout();
    }
  }
  /**
   * @ignore
   */
  _updateMask(container, innerRadius, radius) {
    const mask = container.get("mask");
    if (mask) {
      mask.set("draw", (display) => {
        this._arcGenerator.context(display);
        this._arcGenerator({ innerRadius, outerRadius: radius + 0.5, startAngle: (this.get("startAngle", 0) + 90) * RADIANS, endAngle: (this.get("endAngle", 0) + 90) * RADIANS });
      });
    }
  }
  /**
   * @ignore
   */
  processAxis(axis) {
    this.radarContainer.children.push(axis);
  }
  /**
   * @ignore
   */
  inPlot(point2, radius, innerRadius) {
    const r = Math.hypot(point2.x, point2.y);
    const angle = normalizeAngle(Math.atan2(point2.y, point2.x) * DEGREES);
    let startAngle = normalizeAngle(this.get("startAngle", 0));
    let endAngle = normalizeAngle(this.get("endAngle", 0));
    let inArc = false;
    if (startAngle < endAngle) {
      if (startAngle < angle && angle < endAngle) {
        inArc = true;
      }
    }
    if (startAngle > endAngle) {
      if (angle > startAngle) {
        inArc = true;
      }
      if (angle < endAngle) {
        inArc = true;
      }
    }
    if (startAngle == endAngle) {
      inArc = true;
    }
    if (!inArc) {
      return false;
    }
    if (radius == null) {
      radius = this.getPrivate("radius", 0);
    }
    if (innerRadius == null) {
      innerRadius = this.getPrivate("innerRadius", 0);
    }
    if (innerRadius > radius) {
      [innerRadius, radius] = [radius, innerRadius];
    }
    if (r <= radius + 0.5 && r >= innerRadius - 0.5) {
      return true;
    }
    return false;
  }
  _tooltipToLocal(point2) {
    return this.radarContainer._display.toLocal(point2);
  }
  _handlePinch() {
  }
};
Object.defineProperty(RadarChart, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "RadarChart"
});
Object.defineProperty(RadarChart, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: XYChart.classNames.concat([RadarChart.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/radar/RadarCursor.js
var RadarCursor = class extends XYCursor {
  constructor() {
    super(...arguments);
    Object.defineProperty(this, "_fillGenerator", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: arc_default()
    });
  }
  _afterNew() {
    this._settings.themeTags = mergeTags(this._settings.themeTags, ["radar", "cursor"]);
    super._afterNew();
  }
  _handleXLine() {
  }
  _handleYLine() {
  }
  _getPosition(point2) {
    const radius = Math.hypot(point2.x, point2.y);
    let angle = normalizeAngle(Math.atan2(point2.y, point2.x) * DEGREES);
    const innerRadius = this.getPrivate("innerRadius");
    let startAngle = normalizeAngle(this.getPrivate("startAngle"));
    let endAngle = normalizeAngle(this.getPrivate("endAngle"));
    if (endAngle < startAngle || endAngle == startAngle) {
      if (angle < startAngle) {
        angle += 360;
      }
      endAngle = endAngle + 360;
    }
    let xPos = (angle - startAngle) / (endAngle - startAngle);
    if (xPos < 0) {
      xPos = 1 + xPos;
    }
    if (xPos < 3e-3) {
      xPos = 0;
    }
    if (xPos > 0.997) {
      xPos = 1;
    }
    return { x: xPos, y: (radius - innerRadius) / (this.getPrivate("radius") - innerRadius) };
  }
  _getPoint(positionX, positionY) {
    const innerRadius = this.getPrivate("innerRadius");
    const startAngle = this.getPrivate("startAngle");
    const endAngle = this.getPrivate("endAngle");
    const radius = this.getPrivate("radius");
    const angle = startAngle + positionX * (endAngle - startAngle);
    const r = innerRadius + (radius - innerRadius) * positionY;
    return { x: r * cos(angle), y: r * sin(angle) };
  }
  /**
   * @ignore
   */
  updateLayout() {
    const chart = this.chart;
    if (chart) {
      const radius = chart.getPrivate("radius", 0);
      this.setPrivate("radius", relativeToValue(this.get("radius", p100), radius));
      let innerRadius = relativeToValue(this.get("innerRadius", chart.getPrivate("innerRadius", 0)), radius);
      if (innerRadius < 0) {
        innerRadius = radius + innerRadius;
      }
      this.setPrivate("innerRadius", innerRadius);
      let startAngle = this.get("startAngle", chart.get("startAngle", -90));
      let endAngle = this.get("endAngle", chart.get("endAngle", 270));
      this.setPrivate("startAngle", startAngle);
      this.setPrivate("endAngle", endAngle);
    }
  }
  _updateLines(x2, y2) {
    if (!this._tooltipX) {
      this._drawXLine(x2, y2);
    }
    if (!this._tooltipY) {
      this._drawYLine(x2, y2);
    }
  }
  _drawXLine(x2, y2) {
    const innerRadius = this.getPrivate("innerRadius");
    const radius = this.getPrivate("radius");
    const angle = Math.atan2(y2, x2);
    this.lineX.set("draw", (display) => {
      display.moveTo(innerRadius * Math.cos(angle), innerRadius * Math.sin(angle));
      display.lineTo(radius * Math.cos(angle), radius * Math.sin(angle));
    });
  }
  _drawYLine(x2, y2) {
    const positionRadius = Math.hypot(x2, y2);
    this.lineY.set("draw", (display) => {
      display.arc(0, 0, positionRadius, this.getPrivate("startAngle", 0) * RADIANS, this.getPrivate("endAngle", 0) * RADIANS);
    });
  }
  _updateXLine(tooltip) {
    let point2 = tooltip.get("pointTo");
    if (point2) {
      point2 = this._display.toLocal(point2);
      this._drawXLine(point2.x, point2.y);
    }
  }
  _updateYLine(tooltip) {
    let point2 = tooltip.get("pointTo");
    if (point2) {
      point2 = this._display.toLocal(point2);
      this._drawYLine(point2.x, point2.y);
    }
  }
  _inPlot(point2) {
    const chart = this.chart;
    if (chart) {
      return chart.inPlot(point2, this.getPrivate("radius"), this.getPrivate("innerRadius"));
    }
    return false;
  }
  _updateSelection(point2) {
    this.selection.set("draw", (display) => {
      const behavior = this.get("behavior");
      const downPoint = this._downPoint;
      const cursorStartAngle = this.getPrivate("startAngle");
      const cursorEndAngle = this.getPrivate("endAngle");
      let cursorRadius = this.getPrivate("radius");
      let cursorInnerRadius = this.getPrivate("innerRadius");
      if (cursorRadius < cursorInnerRadius) {
        [cursorRadius, cursorInnerRadius] = [cursorInnerRadius, cursorRadius];
      }
      let startAngle = cursorStartAngle;
      let endAngle = cursorEndAngle;
      let radius = cursorRadius;
      let innerRadius = cursorInnerRadius;
      if (downPoint) {
        if (behavior == "zoomXY" || behavior == "selectXY") {
          startAngle = Math.atan2(downPoint.y, downPoint.x) * DEGREES;
          endAngle = Math.atan2(point2.y, point2.x) * DEGREES;
          innerRadius = Math.hypot(downPoint.x, downPoint.y);
          radius = Math.hypot(point2.x, point2.y);
        } else if (behavior == "zoomX" || behavior == "selectX") {
          startAngle = Math.atan2(downPoint.y, downPoint.x) * DEGREES;
          endAngle = Math.atan2(point2.y, point2.x) * DEGREES;
        } else if (behavior == "zoomY" || behavior == "selectY") {
          innerRadius = Math.hypot(downPoint.x, downPoint.y);
          radius = Math.hypot(point2.x, point2.y);
        }
      }
      innerRadius = fitToRange(innerRadius, cursorInnerRadius, cursorRadius);
      radius = fitToRange(radius, cursorInnerRadius, cursorRadius);
      startAngle = fitAngleToRange(startAngle, cursorStartAngle, cursorEndAngle);
      endAngle = fitAngleToRange(endAngle, cursorStartAngle, cursorEndAngle);
      if (startAngle == endAngle) {
        endAngle = startAngle + 360;
      }
      startAngle *= RADIANS;
      endAngle *= RADIANS;
      this._fillGenerator.context(display);
      this._fillGenerator({ innerRadius, outerRadius: radius, startAngle: startAngle + Math.PI / 2, endAngle: endAngle + Math.PI / 2 });
    });
  }
};
Object.defineProperty(RadarCursor, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "RadarCursor"
});
Object.defineProperty(RadarCursor, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: XYCursor.classNames.concat([RadarCursor.className])
});

// ../../node_modules/@amcharts/amcharts5/.internal/charts/radar/RadarLineSeries.js
var RadarLineSeries = class extends LineSeries {
  _afterNew() {
    super._afterNew();
    this.set("maskContent", false);
    this.bulletsContainer.set("maskContent", false);
    this.bulletsContainer.set("mask", Graphics.new(this._root, {}));
  }
  _handleMaskBullets() {
  }
  getPoint(positionX, positionY) {
    const yAxis = this.get("yAxis");
    const xAxis = this.get("xAxis");
    const rendererY = yAxis.get("renderer");
    const radius = rendererY.positionToCoordinate(positionY) + rendererY.getPrivate("innerRadius", 0);
    const rendererX = xAxis.get("renderer");
    const angle = rendererX.positionToAngle(positionX);
    return { x: radius * cos(angle), y: radius * sin(angle) };
  }
  _endLine(points, firstPoint) {
    if (this.get("connectEnds") && firstPoint) {
      points.push(firstPoint);
    }
  }
  _shouldInclude(position2) {
    const xAxis = this.get("xAxis");
    if (position2 < xAxis.get("start") || position2 > xAxis.get("end")) {
      return false;
    }
    return true;
  }
  _shouldShowBullet(positionX, _positionY) {
    const xAxis = this.get("xAxis");
    if (positionX < xAxis.get("start") || positionX > xAxis.get("end")) {
      return false;
    }
    return this._showBullets;
  }
  _positionBullet(bullet) {
    let sprite = bullet.get("sprite");
    if (sprite) {
      let dataItem = sprite.dataItem;
      let locationX = bullet.get("locationX", dataItem.get("locationX", 0.5));
      let locationY = bullet.get("locationY", dataItem.get("locationY", 0.5));
      let xAxis = this.get("xAxis");
      let yAxis = this.get("yAxis");
      const positionX = xAxis.getDataItemPositionX(dataItem, this._xField, locationX, this.get("vcx", 1));
      const positionY = yAxis.getDataItemPositionY(dataItem, this._yField, locationY, this.get("vcy", 1));
      let point2 = this.getPoint(positionX, positionY);
      if (this._shouldShowBullet(positionX, positionY)) {
        sprite.setPrivate("visible", true);
        sprite.set("x", point2.x);
        sprite.set("y", point2.y);
      } else {
        sprite.setPrivate("visible", false);
      }
    }
  }
};
Object.defineProperty(RadarLineSeries, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "RadarLineSeries"
});
Object.defineProperty(RadarLineSeries, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: LineSeries.classNames.concat([RadarLineSeries.className])
});

// components/charts/RadarChart.tsx
var import_react81 = require("react");
var import_jsx_runtime202 = require("react/jsx-runtime");
var RadarChart2 = ({
  isEditable,
  chartId,
  data,
  color: color2,
  seriesList,
  title,
  titleBold,
  titleColor,
  titleUnderline,
  titleItalic,
  subtitleBold,
  subtitleColor,
  subtitleUnderline,
  subtitleItalic,
  subTitle,
  selectedRows,
  selectedColumn,
  hasLegend,
  dataColumns,
  zoomLevel = 1,
  enableFormattedNumbers,
  handleTitleChange,
  handleSubTitleChange,
  lineFillColor
}) => {
  const [formattedData, setFormattedData] = (0, import_react81.useState)(data);
  const settings = JSON.stringify({
    hasLegend,
    color: color2,
    seriesList,
    title,
    subTitle,
    selectedRows,
    selectedColumn,
    lineFillColor,
    enableFormattedNumbers
  });
  (0, import_react81.useEffect)(() => {
    if (selectedColumn && selectedRows) {
      if (!isEmpty(selectedColumn[0]) && selectedRows[0] !== void 0) {
        if (selectedRows.length === 1) {
          setFormattedData(formatSimpleData(data));
        } else {
          setFormattedData(formatMultipleData(data));
        }
      }
    }
  }, [settings]);
  const formatSimpleData = (rawData) => {
    if (selectedColumn && selectedRows) {
      const categoryCount = {};
      const newData = rawData == null ? void 0 : rawData.map(
        (element) => {
          let baseCategory = element[selectedColumn[0]];
          let category = baseCategory;
          if (categoryCount[baseCategory] !== void 0) {
            categoryCount[baseCategory]++;
            category = `${baseCategory} (${categoryCount[baseCategory]})`;
          } else {
            categoryCount[baseCategory] = 1;
            category = `${baseCategory} (1)`;
          }
          return {
            originalCategory: baseCategory,
            category,
            value: parseFloat(element[selectedRows[0]])
          };
        }
      );
      return newData;
    }
  };
  const formatMultipleData = (rawData) => {
    var _a;
    const transformedData = [];
    if (selectedColumn && selectedRows) {
      for (const yValue of selectedRows) {
        const categories = [];
        const categoryCounts = {};
        for (const item of rawData) {
          let categoryBase = item[selectedColumn[0]];
          let category = categoryBase;
          if (categoryCounts[categoryBase] !== void 0) {
            categoryCounts[categoryBase] += 1;
            category = `${categoryBase} (${categoryCounts[categoryBase]})`;
          } else {
            categoryCounts[categoryBase] = 1;
            category = `${categoryBase} (1)`;
          }
          categories.push({
            originalCategory: categoryBase,
            value: parseFloat(item[yValue]),
            category
          });
        }
        transformedData.push({
          categories,
          key: yValue,
          label: ((_a = dataColumns == null ? void 0 : dataColumns.find((column2) => column2.key === yValue)) == null ? void 0 : _a.alias) || yValue
        });
      }
    }
    return transformedData;
  };
  (0, import_react80.useLayoutEffect)(() => {
    var _a, _b, _c;
    const root = Root.new(chartId, {
      calculateSize: function(dimensions) {
        return {
          width: dimensions.width * (1 / zoomLevel),
          height: dimensions.height * (1 / zoomLevel)
        };
      }
    });
    root.fps = 30;
    (_a = root._logo) == null ? void 0 : _a.dispose();
    const customizedTheme = Theme2.new(root);
    customizedTheme.rule("Label").setAll({
      fontFamily: "SpaceGrotesk"
    });
    root.setThemes([Animated_default.new(root), customizedTheme]);
    const bigNumberPrefixes = [
      { number: 1e3, suffix: "K" },
      { number: 1e6, suffix: "M" },
      { number: 1e9, suffix: "B" },
      { number: 1e12, suffix: "T" },
      { number: 1e15, suffix: "Q" },
      { number: 1e18, suffix: "QQ" },
      { number: 1e21, suffix: "S" },
      { number: 1e24, suffix: "SS" },
      { number: 1e27, suffix: "O" },
      { number: 1e30, suffix: "N" },
      { number: 1e33, suffix: "D" },
      { number: 1e36, suffix: "UD" },
      { number: 1e39, suffix: "DD" },
      { number: 1e42, suffix: "TD" },
      { number: 1e45, suffix: "QD" },
      { number: 1e48, suffix: "QD" },
      { number: 1e51, suffix: "SD" },
      { number: 1e54, suffix: "SSD" },
      { number: 1e57, suffix: "OD" },
      { number: 1e60, suffix: "ND" },
      { number: 1e63, suffix: "VD" }
    ];
    const chart = root.container.children.push(
      RadarChart.new(root, {
        panX: false,
        panY: false,
        wheelX: "none",
        wheelY: "none",
        layout: root.verticalLayout
      })
    );
    const cursor = chart.set("cursor", RadarCursor.new(root, {}));
    cursor.lineY.set("visible", false);
    const xRenderer = AxisRendererCircular.new(root, {});
    const xAxis = chart.xAxes.push(
      CategoryAxis.new(root, {
        maxDeviation: 0,
        categoryField: "category",
        renderer: xRenderer
        // tooltip: am5.Tooltip.new(root, {}),
      })
    );
    xRenderer.labels.template.setAll({
      textType: "adjusted",
      text: "{originalCategory}",
      radius: 10,
      // tooltipText: "{category}",
      oversizedBehavior: "truncate",
      textAlign: "center"
    });
    xAxis.onPrivate("cellWidth", function(cellWidth) {
      xRenderer.labels.template.set("maxWidth", cellWidth);
    });
    const yAxis = chart.yAxes.push(
      ValueAxis.new(root, {
        numberFormatter: NumberFormatter.new(root, {
          numberFormat: "###a",
          bigNumberPrefixes,
          numericFields: ["value"]
        }),
        renderer: AxisRendererRadial.new(root, {})
      })
    );
    var tooltip = xAxis.labelsContainer.set(
      "tooltip",
      Tooltip4.new(root, {
        pointerOrientation: "vertical"
      })
    );
    tooltip.label.setAll({
      maxWidth: 200,
      oversizedBehavior: "wrap"
    });
    const isMultiple3 = (_b = formattedData[0]) == null ? void 0 : _b.label;
    if (isMultiple3) {
      formattedData.forEach(({ label, key }) => {
        makeSeries(
          formatMultipleChartData(formattedData),
          color2 == null ? void 0 : color2[key],
          label
        );
      });
    } else {
      makeSeries(
        formattedData,
        (_c = color2 == null ? void 0 : color2[seriesList == null ? void 0 : seriesList[0]]) != null ? _c : defaultChartColor
      );
    }
    if (hasLegend) {
      const legend = chart.children.push(
        Legend.new(root, {
          x: p0,
          centerX: p0,
          layout: root.horizontalLayout
        })
      );
      legend.data.setAll(chart.series.values);
    }
    function makeSeries(data2, color3 = defaultChartColor, key) {
      var _a2, _b2, _c2;
      xAxis.data.setAll(data2);
      let series = chart.series.push(
        RadarLineSeries.new(root, {
          name: key || (seriesList && seriesList.length > 0 ? ((_a2 = dataColumns == null ? void 0 : dataColumns.find((column2) => column2.key === seriesList[0])) == null ? void 0 : _a2.alias) || seriesList[0] : "Serie 1"),
          xAxis,
          yAxis,
          valueYField: key || "value",
          categoryXField: "category",
          tooltip: Tooltip4.new(root, {
            labelText: "{valueY}"
          }),
          stroke: color(color3),
          fill: color(color3)
        })
      );
      (_c2 = (_b2 = series == null ? void 0 : series.get("tooltip")) == null ? void 0 : _b2.get("background")) == null ? void 0 : _c2.adapters.add("fill", () => {
        return color(color3);
      });
      if (lineFillColor)
        series.fills.template.setAll({
          fillOpacity: 0.5,
          visible: true
        });
      series.bullets.push(function(root2, series2, dataItem) {
        return Bullet.new(root2, {
          sprite: Circle.new(root2, {
            radius: 7,
            fill: color(color3)
          })
        });
      });
      series.data.setAll(data2);
      series.appear();
    }
    chart.appear();
    return () => root.dispose();
  }, [chartId, formattedData, zoomLevel]);
  const formatMultipleChartData = (data2) => {
    const reformulatedData = data2.reduce((acc, curr) => {
      curr.categories.forEach(({ category, originalCategory, value }) => {
        const existingEntry = acc.find((entry) => entry.category === category);
        if (existingEntry) {
          existingEntry[curr.label] = value;
        } else {
          const newEntry = { category, originalCategory, [curr.label]: value };
          acc.push(newEntry);
        }
      });
      return acc;
    }, []);
    console.log("reformulatedData", reformulatedData);
    return reformulatedData;
  };
  return /* @__PURE__ */ (0, import_jsx_runtime202.jsxs)(
    StyledRadarChart,
    {
      $isEditable: isEditable,
      $coefficient: title && subTitle ? 5 : title || subTitle ? 4 : 3,
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime202.jsx)(
          ChartHeader,
          __spreadValues({
            isEditable: !!isEditable,
            title: title || "",
            titleBold: titleBold || false,
            titleColor: titleColor || "",
            titleUnderline: titleUnderline || false,
            titleItalic: titleItalic || false,
            subtitleBold: subtitleBold || false,
            subtitleColor: subtitleColor || "",
            subtitleUnderline: subtitleUnderline || false,
            subtitleItalic: subtitleItalic || false,
            subTitle: subTitle || ""
          }, isEditable && {
            handleTitleChange,
            handleSubTitleChange
          })
        ),
        /* @__PURE__ */ (0, import_jsx_runtime202.jsx)("div", { id: chartId, className: "chart-container" })
      ]
    }
  );
};
var StyledRadarChart = import_styled_components12.styled.div`
  height: calc(100% - 12px);
  width: 100%;
  min-width: 242px;
  min-height: 182px;

  .chart-container {
    height: calc(100% - ${(p) => 10 * p.$coefficient}px);
    width: 100%;
    min-width: 242px;
    min-height: 182px;
    margin-inline: auto;
  }

  ${(p) => !p.$isEditable && `h3, h5 {
    margin-block: 0 !important;
  }`}

  ${(p) => p.$isEditable !== void 0 && `  .ant-typography + h5.ant-typography {
    // margin-top: 15px !important;
  }`}
`;

// components/charts/CardChart.tsx
var import_styled_components13 = require("styled-components");

// interfaces/grid.interface.ts
var PositionType = /* @__PURE__ */ ((PositionType2) => {
  PositionType2["START"] = "START";
  PositionType2["CENTER"] = "CENTER";
  PositionType2["END"] = "END";
  return PositionType2;
})(PositionType || {});
var GridItemType = /* @__PURE__ */ ((GridItemType2) => {
  GridItemType2["CHART"] = "CHART";
  GridItemType2["EDITOR"] = "EDITOR";
  GridItemType2["TABLE"] = "TABLE";
  return GridItemType2;
})(GridItemType || {});

// components/charts/CardChart.tsx
var import_react82 = require("react");
var import_jsx_runtime203 = require("react/jsx-runtime");
var CardChart = ({
  isEditable,
  data,
  title,
  titleBold,
  titleColor,
  titleUnderline,
  titleItalic,
  subtitleBold,
  subtitleColor,
  subtitleUnderline,
  subtitleItalic,
  subTitle,
  selectedColumn,
  cardColumnLigneIndex,
  cardIntroValue,
  cardIntroItalic,
  cardIntroBold,
  cardIntroUnderline,
  cardIntroFontSize,
  cardIntroColor,
  cardValueItalic,
  cardValueBold,
  cardValueUnderline,
  cardValueFontSize,
  cardValueColor,
  cardValuePosition,
  cardOutroValue,
  cardOutroItalic,
  cardOutroBold,
  cardOutroUnderline,
  cardOutroFontSize,
  cardOutroColor,
  cardImage,
  cardImagePosition,
  handleChartChange
}) => {
  var _a;
  const cardContainerStyle = {
    display: "flex",
    flexDirection: "column",
    paddingTop: cardImage ? "0px" : "15px",
    // minHeight: `calc(100%${
    //   isEditable
    //     ? " - 62px"
    //     : `${title ? " - 31px" : ""}${subTitle ? " - 31px" : ""}`
    // }${cardImage ? " - 50px" : ""} - 4px)`,
    minHeight: `calc(100%${isEditable ? " - 62px" : `${title ? " - 0px" : ""}${subTitle ? " - 0px" : ""}`}${cardImage ? " - 66px" : ""} - 10px)`,
    justifyContent: cardValuePosition || "start"
  };
  const cardIntroStyle = {
    fontWeight: cardIntroBold ? "bold" : "normal",
    color: cardIntroColor,
    fontSize: `${cardIntroFontSize || "20"}px`,
    textDecoration: cardIntroUnderline ? "underline" : "none",
    fontStyle: cardIntroItalic ? "italic" : "normal",
    height: `${cardIntroFontSize && cardIntroFontSize >= 50 ? cardIntroFontSize - 7 : cardIntroFontSize && cardIntroFontSize >= 32 ? cardIntroFontSize : cardIntroFontSize && cardIntroFontSize >= 30 ? 34 : 32}px`
  };
  const cardValueStyle = {
    fontWeight: cardValueBold ? "bold" : "normal",
    color: cardValueColor,
    fontSize: `${cardValueFontSize || "20"}px`,
    textDecoration: cardValueUnderline ? "underline" : "none",
    fontStyle: cardValueItalic ? "italic" : "normal"
  };
  const cardOutroStyle = {
    fontWeight: cardOutroBold ? "bold" : "normal",
    color: cardOutroColor,
    fontSize: `${cardOutroFontSize || "20"}px`,
    textDecoration: cardOutroUnderline ? "underline" : "none",
    fontStyle: cardOutroItalic ? "italic" : "normal",
    height: `${cardOutroFontSize && cardOutroFontSize >= 50 ? cardOutroFontSize - 7 : cardOutroFontSize && cardOutroFontSize >= 32 ? cardOutroFontSize : cardOutroFontSize && cardOutroFontSize >= 30 ? 34 : 32}px`
  };
  const cardImageStyle = {
    marginTop: cardImage ? "21px" : "6px",
    display: "flex",
    marginInline: cardImagePosition === "CENTER" /* CENTER */ ? "auto" : cardImagePosition === "END" /* END */ ? "auto 20px" : "20px"
  };
  const [showTitleEditIcon, setShowTitleEditIcon] = (0, import_react82.useState)(false);
  const [showSubTitleEditIcon, setShowSubTitleEditIcon] = (0, import_react82.useState)(false);
  const handleEditTitleClick = () => {
    setShowTitleEditIcon(true);
  };
  const handleEditSubTitleClick = () => {
    setShowSubTitleEditIcon(true);
  };
  return /* @__PURE__ */ (0, import_jsx_runtime203.jsxs)(
    StyledCardChart,
    {
      $isEditable: isEditable,
      $coefficient: title && subTitle ? 6 : title || subTitle ? 5 : 3.5,
      children: [
        cardImage && /* @__PURE__ */ (0, import_jsx_runtime203.jsx)("img", { height: 45, width: 45, src: cardImage, style: cardImageStyle }),
        /* @__PURE__ */ (0, import_jsx_runtime203.jsxs)("div", { style: cardContainerStyle, children: [
          /* @__PURE__ */ (0, import_jsx_runtime203.jsxs)(StyledTitle2, { cardIntroFontSize, children: [
            /* @__PURE__ */ (0, import_jsx_runtime203.jsx)(
              typography_default.Title,
              __spreadProps(__spreadValues({}, isEditable && {
                editable: {
                  tooltip: false,
                  enterIcon: null,
                  onChange: (value) => {
                    setShowTitleEditIcon(false);
                    handleChartChange == null ? void 0 : handleChartChange("cardIntroValue", value);
                  },
                  text: cardIntroValue,
                  triggerType: ["text"],
                  editing: isEditable && showTitleEditIcon
                }
              }), {
                level: 5,
                style: cardIntroStyle,
                children: cardIntroValue
              })
            ),
            isEditable && !showTitleEditIcon && /* @__PURE__ */ (0, import_jsx_runtime203.jsx)("div", { className: "edit-icon", onClick: handleEditTitleClick, children: /* @__PURE__ */ (0, import_jsx_runtime203.jsx)(EditIcon, {}) })
          ] }),
          /* @__PURE__ */ (0, import_jsx_runtime203.jsx)("h5", { style: cardValueStyle, children: (_a = data == null ? void 0 : data[cardColumnLigneIndex != null ? cardColumnLigneIndex : 0]) == null ? void 0 : _a[selectedColumn != null ? selectedColumn : ""] }),
          /* @__PURE__ */ (0, import_jsx_runtime203.jsxs)(StyledSubTitle2, { cardOutroFontSize, children: [
            /* @__PURE__ */ (0, import_jsx_runtime203.jsx)(
              typography_default.Title,
              __spreadProps(__spreadValues({}, isEditable && {
                editable: {
                  tooltip: false,
                  enterIcon: null,
                  onChange: (value) => {
                    setShowSubTitleEditIcon(false);
                    handleChartChange == null ? void 0 : handleChartChange("cardOutroValue", value);
                  },
                  text: cardOutroValue,
                  triggerType: ["text"],
                  editing: isEditable && showSubTitleEditIcon
                }
              }), {
                level: 5,
                style: cardOutroStyle,
                children: cardOutroValue
              })
            ),
            isEditable && !showSubTitleEditIcon && /* @__PURE__ */ (0, import_jsx_runtime203.jsx)("div", { className: "edit-icon", onClick: handleEditSubTitleClick, children: /* @__PURE__ */ (0, import_jsx_runtime203.jsx)(EditIcon, {}) })
          ] })
        ] })
      ]
    }
  );
};
var StyledCardChart = import_styled_components13.styled.div`
  height: 100%;
  width: 100%;
  min-width: 242px;
  min-height: 182px;
  display: flex;
  flex-direction: column;

  .chart-container {
    height: calc(100% - ${(p) => 10 * p.$coefficient}px);
    width: 100%;
    min-width: 242px;
    min-height: 182px;
    margin-inline: auto;
  }

  h5 {
    margin: 0;
    margin-left: 20px;
  }

  ${(p) => !p.$isEditable && `h3, h5 {
    margin-block: 0 !important;
  }`}

  ${(p) => p.$isEditable !== void 0 && `  .ant-typography + h5.ant-typography {
    // margin-top: 15px !important;
  }`}
`;
var StyledTitle2 = import_styled_components13.styled.div`
  display: flex;
  align-items: center;
  .edit-icon {
    font-size: 18px;
    display: flex;
    color: #1677ff;
    cursor: pointer;
  }
  .ant-typography-edit-content {
    width: 93% !important;
    &.ant-typography-h5 textarea {
      line-height: ${(props) => props.cardIntroFontSize && props.cardIntroFontSize >= 32 ? "15 !important" : "20px !important"};
      font-size: ${(props) => props.cardIntroFontSize ? `${props.cardIntroFontSize}px` : "20px"};
    }
    textarea {
      height: ${(props) => props.cardIntroFontSize && props.cardIntroFontSize >= 32 ? `${props.cardIntroFontSize - 8}px !important` : "32px !important"};
      overflow: hidden;
      resize: none;
      white-space: nowrap;
    }
  }
  .ant-typography {
    line-height: ${(props) => props.cardIntroFontSize && props.cardIntroFontSize >= 40 ? `${props.cardIntroFontSize - 10}px` : props.cardIntroFontSize && props.cardIntroFontSize <= 22 ? `${props.cardIntroFontSize + 10}px` : "30px"};
    margin-left: 20px;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
    max-width: 93%;
    width: fit-content;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    position: relative;
    overflow: hidden;
    word-break: break-all;
    padding: 0px !important;
    &:is(h5) {
      margin-right: 8px;
    }
    .ant-typography-edit {
      position: relative;
      right: 0;
      top: 0;
    }
  }
`;
var StyledSubTitle2 = import_styled_components13.styled.div`
  display: flex;
  align-items: center;
  .edit-icon {
    font-size: 18px;
    display: flex;
    color: #1677ff;
    cursor: pointer;
  }
  .ant-typography-edit-content {
    width: 93% !important;
    &.ant-typography-h5 textarea {
      line-height: ${(props) => props.cardOutroFontSize && props.cardOutroFontSize >= 32 ? "15 !important" : "20px !important"};
      font-size: ${(props) => props.cardOutroFontSize ? `${props.cardOutroFontSize}px` : "20px"};
    }
    textarea {
      height: ${(props) => props.cardOutroFontSize && props.cardOutroFontSize >= 32 ? `${props.cardOutroFontSize - 8}px !important` : "32px !important"};
      overflow: hidden;
      resize: none;
      white-space: nowrap;
    }
  }
  .ant-typography {
    line-height: ${(props) => props.cardOutroFontSize && props.cardOutroFontSize >= 40 ? `${props.cardOutroFontSize - 10}px` : props.cardOutroFontSize && props.cardOutroFontSize <= 22 ? `${props.cardOutroFontSize + 10}px` : "30px"};
    margin-left: 20px;
    margin-bottom: 0px !important;
    margin-top: 0px !important;
    max-width: 93%;
    width: fit-content;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    position: relative;
    overflow: hidden;
    word-break: break-all;
    padding: 0px !important;
    &:is(h5) {
      margin-right: 8px;
    }
    .ant-typography-edit {
      position: relative;
      right: 0;
      top: 0;
    }
  }
`;

// utils/general/formats.ts
var Kilobyte = 1024;
var FORMAT = {
  MAX_IMAGE_SIZE: 2 * __pow(Kilobyte, 2),
  // 2 MB
  MAX_DOC_SIZE: 16 * __pow(Kilobyte, 2),
  // 16 MB
  image: {
    types: ["image/jpeg", "image/webp", "image/png"],
    extensions: [".jpg", ".jpeg", ".webp", ".png"]
  },
  document: {
    types: [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/pdf",
      "application/vnd.oasis.opendocument.text",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    extensions: ".doc,.docx,.pdf,.odt"
  },
  word: {
    types: [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
    ],
    extensions: [".doc", ".docx"]
  },
  pdf: {
    types: ["application/pdf"],
    extensions: [".pdf"]
  },
  excel: {
    types: [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    ],
    extensions: [".xls", ".xlsx"]
  },
  csv: {
    types: ["text/csv"],
    extensions: [".csv"]
  },
  txt: {
    types: ["text/plain"],
    extensions: [".txt"]
  },
  spreadsheet: {
    types: [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "application/vnd.oasis.opendocument.spreadsheet"
    ],
    extensions: ".xls,.xlsx,.ods"
  },
  pptx: {
    types: [
      "application/vnd.ms-powerpoint",
      "application/vnd.openxmlformats-officedocument.presentationml.presentation"
    ],
    extensions: [".ppt", ".pptx"]
  },
  video: {
    types: ["video/mp4"],
    extensions: ".mp4"
  }
};

// ../../node_modules/@tanstack/query-core/build/lib/subscribable.mjs
var Subscribable = class {
  constructor() {
    this.listeners = /* @__PURE__ */ new Set();
    this.subscribe = this.subscribe.bind(this);
  }
  subscribe(listener) {
    const identity = {
      listener
    };
    this.listeners.add(identity);
    this.onSubscribe();
    return () => {
      this.listeners.delete(identity);
      this.onUnsubscribe();
    };
  }
  hasListeners() {
    return this.listeners.size > 0;
  }
  onSubscribe() {
  }
  onUnsubscribe() {
  }
};

// ../../node_modules/@tanstack/query-core/build/lib/utils.mjs
var isServer = typeof window === "undefined" || "Deno" in window;
function noop6() {
  return void 0;
}
function isValidTimeout(value) {
  return typeof value === "number" && value >= 0 && value !== Infinity;
}
function timeUntilStale(updatedAt, staleTime2) {
  return Math.max(updatedAt + (staleTime2 || 0) - Date.now(), 0);
}
function parseFilterArgs(arg1, arg2, arg3) {
  return isQueryKey(arg1) ? [__spreadProps(__spreadValues({}, arg2), {
    queryKey: arg1
  }), arg3] : [arg1 || {}, arg2];
}
function matchQuery(filters, query) {
  const {
    type: type4 = "all",
    exact,
    fetchStatus,
    predicate,
    queryKey,
    stale
  } = filters;
  if (isQueryKey(queryKey)) {
    if (exact) {
      if (query.queryHash !== hashQueryKeyByOptions(queryKey, query.options)) {
        return false;
      }
    } else if (!partialMatchKey(query.queryKey, queryKey)) {
      return false;
    }
  }
  if (type4 !== "all") {
    const isActive2 = query.isActive();
    if (type4 === "active" && !isActive2) {
      return false;
    }
    if (type4 === "inactive" && isActive2) {
      return false;
    }
  }
  if (typeof stale === "boolean" && query.isStale() !== stale) {
    return false;
  }
  if (typeof fetchStatus !== "undefined" && fetchStatus !== query.state.fetchStatus) {
    return false;
  }
  if (predicate && !predicate(query)) {
    return false;
  }
  return true;
}
function matchMutation(filters, mutation) {
  const {
    exact,
    fetching,
    predicate,
    mutationKey
  } = filters;
  if (isQueryKey(mutationKey)) {
    if (!mutation.options.mutationKey) {
      return false;
    }
    if (exact) {
      if (hashQueryKey(mutation.options.mutationKey) !== hashQueryKey(mutationKey)) {
        return false;
      }
    } else if (!partialMatchKey(mutation.options.mutationKey, mutationKey)) {
      return false;
    }
  }
  if (typeof fetching === "boolean" && mutation.state.status === "loading" !== fetching) {
    return false;
  }
  if (predicate && !predicate(mutation)) {
    return false;
  }
  return true;
}
function hashQueryKeyByOptions(queryKey, options) {
  const hashFn = (options == null ? void 0 : options.queryKeyHashFn) || hashQueryKey;
  return hashFn(queryKey);
}
function hashQueryKey(queryKey) {
  return JSON.stringify(queryKey, (_, val) => isPlainObject(val) ? Object.keys(val).sort().reduce((result, key) => {
    result[key] = val[key];
    return result;
  }, {}) : val);
}
function partialMatchKey(a, b) {
  return partialDeepEqual(a, b);
}
function partialDeepEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== typeof b) {
    return false;
  }
  if (a && b && typeof a === "object" && typeof b === "object") {
    return !Object.keys(b).some((key) => !partialDeepEqual(a[key], b[key]));
  }
  return false;
}
function replaceEqualDeep(a, b) {
  if (a === b) {
    return a;
  }
  const array4 = isPlainArray(a) && isPlainArray(b);
  if (array4 || isPlainObject(a) && isPlainObject(b)) {
    const aSize = array4 ? a.length : Object.keys(a).length;
    const bItems = array4 ? b : Object.keys(b);
    const bSize = bItems.length;
    const copy4 = array4 ? [] : {};
    let equalItems = 0;
    for (let i = 0; i < bSize; i++) {
      const key = array4 ? i : bItems[i];
      copy4[key] = replaceEqualDeep(a[key], b[key]);
      if (copy4[key] === a[key]) {
        equalItems++;
      }
    }
    return aSize === bSize && equalItems === aSize ? a : copy4;
  }
  return b;
}
function isPlainArray(value) {
  return Array.isArray(value) && value.length === Object.keys(value).length;
}
function isPlainObject(o) {
  if (!hasObjectPrototype(o)) {
    return false;
  }
  const ctor = o.constructor;
  if (typeof ctor === "undefined") {
    return true;
  }
  const prot = ctor.prototype;
  if (!hasObjectPrototype(prot)) {
    return false;
  }
  if (!prot.hasOwnProperty("isPrototypeOf")) {
    return false;
  }
  return true;
}
function hasObjectPrototype(o) {
  return Object.prototype.toString.call(o) === "[object Object]";
}
function isQueryKey(value) {
  return Array.isArray(value);
}
function sleep2(timeout) {
  return new Promise((resolve) => {
    setTimeout(resolve, timeout);
  });
}
function scheduleMicrotask(callback) {
  sleep2(0).then(callback);
}
function getAbortController() {
  if (typeof AbortController === "function") {
    return new AbortController();
  }
  return;
}
function replaceData(prevData, data, options) {
  if (options.isDataEqual != null && options.isDataEqual(prevData, data)) {
    return prevData;
  } else if (typeof options.structuralSharing === "function") {
    return options.structuralSharing(prevData, data);
  } else if (options.structuralSharing !== false) {
    return replaceEqualDeep(prevData, data);
  }
  return data;
}

// ../../node_modules/@tanstack/query-core/build/lib/focusManager.mjs
var FocusManager = class extends Subscribable {
  constructor() {
    super();
    this.setup = (onFocus) => {
      if (!isServer && window.addEventListener) {
        const listener = () => onFocus();
        window.addEventListener("visibilitychange", listener, false);
        window.addEventListener("focus", listener, false);
        return () => {
          window.removeEventListener("visibilitychange", listener);
          window.removeEventListener("focus", listener);
        };
      }
      return;
    };
  }
  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;
      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = void 0;
    }
  }
  setEventListener(setup) {
    var _this$cleanup2;
    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup((focused) => {
      if (typeof focused === "boolean") {
        this.setFocused(focused);
      } else {
        this.onFocus();
      }
    });
  }
  setFocused(focused) {
    const changed = this.focused !== focused;
    if (changed) {
      this.focused = focused;
      this.onFocus();
    }
  }
  onFocus() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }
  isFocused() {
    if (typeof this.focused === "boolean") {
      return this.focused;
    }
    if (typeof document === "undefined") {
      return true;
    }
    return [void 0, "visible", "prerender"].includes(document.visibilityState);
  }
};
var focusManager = new FocusManager();

// ../../node_modules/@tanstack/query-core/build/lib/onlineManager.mjs
var onlineEvents = ["online", "offline"];
var OnlineManager = class extends Subscribable {
  constructor() {
    super();
    this.setup = (onOnline) => {
      if (!isServer && window.addEventListener) {
        const listener = () => onOnline();
        onlineEvents.forEach((event) => {
          window.addEventListener(event, listener, false);
        });
        return () => {
          onlineEvents.forEach((event) => {
            window.removeEventListener(event, listener);
          });
        };
      }
      return;
    };
  }
  onSubscribe() {
    if (!this.cleanup) {
      this.setEventListener(this.setup);
    }
  }
  onUnsubscribe() {
    if (!this.hasListeners()) {
      var _this$cleanup;
      (_this$cleanup = this.cleanup) == null ? void 0 : _this$cleanup.call(this);
      this.cleanup = void 0;
    }
  }
  setEventListener(setup) {
    var _this$cleanup2;
    this.setup = setup;
    (_this$cleanup2 = this.cleanup) == null ? void 0 : _this$cleanup2.call(this);
    this.cleanup = setup((online) => {
      if (typeof online === "boolean") {
        this.setOnline(online);
      } else {
        this.onOnline();
      }
    });
  }
  setOnline(online) {
    const changed = this.online !== online;
    if (changed) {
      this.online = online;
      this.onOnline();
    }
  }
  onOnline() {
    this.listeners.forEach(({
      listener
    }) => {
      listener();
    });
  }
  isOnline() {
    if (typeof this.online === "boolean") {
      return this.online;
    }
    if (typeof navigator === "undefined" || typeof navigator.onLine === "undefined") {
      return true;
    }
    return navigator.onLine;
  }
};
var onlineManager = new OnlineManager();

// ../../node_modules/@tanstack/query-core/build/lib/retryer.mjs
function defaultRetryDelay(failureCount) {
  return Math.min(1e3 * __pow(2, failureCount), 3e4);
}
function canFetch(networkMode) {
  return (networkMode != null ? networkMode : "online") === "online" ? onlineManager.isOnline() : true;
}
var CancelledError = class {
  constructor(options) {
    this.revert = options == null ? void 0 : options.revert;
    this.silent = options == null ? void 0 : options.silent;
  }
};
function isCancelledError(value) {
  return value instanceof CancelledError;
}
function createRetryer(config) {
  let isRetryCancelled = false;
  let failureCount = 0;
  let isResolved = false;
  let continueFn;
  let promiseResolve;
  let promiseReject;
  const promise = new Promise((outerResolve, outerReject) => {
    promiseResolve = outerResolve;
    promiseReject = outerReject;
  });
  const cancel = (cancelOptions) => {
    if (!isResolved) {
      reject(new CancelledError(cancelOptions));
      config.abort == null ? void 0 : config.abort();
    }
  };
  const cancelRetry = () => {
    isRetryCancelled = true;
  };
  const continueRetry = () => {
    isRetryCancelled = false;
  };
  const shouldPause = () => !focusManager.isFocused() || config.networkMode !== "always" && !onlineManager.isOnline();
  const resolve = (value) => {
    if (!isResolved) {
      isResolved = true;
      config.onSuccess == null ? void 0 : config.onSuccess(value);
      continueFn == null ? void 0 : continueFn();
      promiseResolve(value);
    }
  };
  const reject = (value) => {
    if (!isResolved) {
      isResolved = true;
      config.onError == null ? void 0 : config.onError(value);
      continueFn == null ? void 0 : continueFn();
      promiseReject(value);
    }
  };
  const pause = () => {
    return new Promise((continueResolve) => {
      continueFn = (value) => {
        const canContinue = isResolved || !shouldPause();
        if (canContinue) {
          continueResolve(value);
        }
        return canContinue;
      };
      config.onPause == null ? void 0 : config.onPause();
    }).then(() => {
      continueFn = void 0;
      if (!isResolved) {
        config.onContinue == null ? void 0 : config.onContinue();
      }
    });
  };
  const run = () => {
    if (isResolved) {
      return;
    }
    let promiseOrValue;
    try {
      promiseOrValue = config.fn();
    } catch (error) {
      promiseOrValue = Promise.reject(error);
    }
    Promise.resolve(promiseOrValue).then(resolve).catch((error) => {
      var _config$retry, _config$retryDelay;
      if (isResolved) {
        return;
      }
      const retry = (_config$retry = config.retry) != null ? _config$retry : 3;
      const retryDelay = (_config$retryDelay = config.retryDelay) != null ? _config$retryDelay : defaultRetryDelay;
      const delay = typeof retryDelay === "function" ? retryDelay(failureCount, error) : retryDelay;
      const shouldRetry = retry === true || typeof retry === "number" && failureCount < retry || typeof retry === "function" && retry(failureCount, error);
      if (isRetryCancelled || !shouldRetry) {
        reject(error);
        return;
      }
      failureCount++;
      config.onFail == null ? void 0 : config.onFail(failureCount, error);
      sleep2(delay).then(() => {
        if (shouldPause()) {
          return pause();
        }
        return;
      }).then(() => {
        if (isRetryCancelled) {
          reject(error);
        } else {
          run();
        }
      });
    });
  };
  if (canFetch(config.networkMode)) {
    run();
  } else {
    pause().then(run);
  }
  return {
    promise,
    cancel,
    continue: () => {
      const didContinue = continueFn == null ? void 0 : continueFn();
      return didContinue ? promise : Promise.resolve();
    },
    cancelRetry,
    continueRetry
  };
}

// ../../node_modules/@tanstack/query-core/build/lib/logger.mjs
var defaultLogger = console;

// ../../node_modules/@tanstack/query-core/build/lib/notifyManager.mjs
function createNotifyManager() {
  let queue = [];
  let transactions = 0;
  let notifyFn = (callback) => {
    callback();
  };
  let batchNotifyFn = (callback) => {
    callback();
  };
  const batch = (callback) => {
    let result;
    transactions++;
    try {
      result = callback();
    } finally {
      transactions--;
      if (!transactions) {
        flush();
      }
    }
    return result;
  };
  const schedule = (callback) => {
    if (transactions) {
      queue.push(callback);
    } else {
      scheduleMicrotask(() => {
        notifyFn(callback);
      });
    }
  };
  const batchCalls = (callback) => {
    return (...args) => {
      schedule(() => {
        callback(...args);
      });
    };
  };
  const flush = () => {
    const originalQueue = queue;
    queue = [];
    if (originalQueue.length) {
      scheduleMicrotask(() => {
        batchNotifyFn(() => {
          originalQueue.forEach((callback) => {
            notifyFn(callback);
          });
        });
      });
    }
  };
  const setNotifyFunction = (fn) => {
    notifyFn = fn;
  };
  const setBatchNotifyFunction = (fn) => {
    batchNotifyFn = fn;
  };
  return {
    batch,
    batchCalls,
    schedule,
    setNotifyFunction,
    setBatchNotifyFunction
  };
}
var notifyManager = createNotifyManager();

// ../../node_modules/@tanstack/query-core/build/lib/removable.mjs
var Removable = class {
  destroy() {
    this.clearGcTimeout();
  }
  scheduleGc() {
    this.clearGcTimeout();
    if (isValidTimeout(this.cacheTime)) {
      this.gcTimeout = setTimeout(() => {
        this.optionalRemove();
      }, this.cacheTime);
    }
  }
  updateCacheTime(newCacheTime) {
    this.cacheTime = Math.max(this.cacheTime || 0, newCacheTime != null ? newCacheTime : isServer ? Infinity : 5 * 60 * 1e3);
  }
  clearGcTimeout() {
    if (this.gcTimeout) {
      clearTimeout(this.gcTimeout);
      this.gcTimeout = void 0;
    }
  }
};

// ../../node_modules/@tanstack/query-core/build/lib/query.mjs
var Query = class extends Removable {
  constructor(config) {
    super();
    this.abortSignalConsumed = false;
    this.defaultOptions = config.defaultOptions;
    this.setOptions(config.options);
    this.observers = [];
    this.cache = config.cache;
    this.logger = config.logger || defaultLogger;
    this.queryKey = config.queryKey;
    this.queryHash = config.queryHash;
    this.initialState = config.state || getDefaultState(this.options);
    this.state = this.initialState;
    this.scheduleGc();
  }
  get meta() {
    return this.options.meta;
  }
  setOptions(options) {
    this.options = __spreadValues(__spreadValues({}, this.defaultOptions), options);
    this.updateCacheTime(this.options.cacheTime);
  }
  optionalRemove() {
    if (!this.observers.length && this.state.fetchStatus === "idle") {
      this.cache.remove(this);
    }
  }
  setData(newData, options) {
    const data = replaceData(this.state.data, newData, this.options);
    this.dispatch({
      data,
      type: "success",
      dataUpdatedAt: options == null ? void 0 : options.updatedAt,
      manual: options == null ? void 0 : options.manual
    });
    return data;
  }
  setState(state, setStateOptions) {
    this.dispatch({
      type: "setState",
      state,
      setStateOptions
    });
  }
  cancel(options) {
    var _this$retryer;
    const promise = this.promise;
    (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.cancel(options);
    return promise ? promise.then(noop6).catch(noop6) : Promise.resolve();
  }
  destroy() {
    super.destroy();
    this.cancel({
      silent: true
    });
  }
  reset() {
    this.destroy();
    this.setState(this.initialState);
  }
  isActive() {
    return this.observers.some((observer2) => observer2.options.enabled !== false);
  }
  isDisabled() {
    return this.getObserversCount() > 0 && !this.isActive();
  }
  isStale() {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || this.observers.some((observer2) => observer2.getCurrentResult().isStale);
  }
  isStaleByTime(staleTime2 = 0) {
    return this.state.isInvalidated || !this.state.dataUpdatedAt || !timeUntilStale(this.state.dataUpdatedAt, staleTime2);
  }
  onFocus() {
    var _this$retryer2;
    const observer2 = this.observers.find((x2) => x2.shouldFetchOnWindowFocus());
    if (observer2) {
      observer2.refetch({
        cancelRefetch: false
      });
    }
    (_this$retryer2 = this.retryer) == null ? void 0 : _this$retryer2.continue();
  }
  onOnline() {
    var _this$retryer3;
    const observer2 = this.observers.find((x2) => x2.shouldFetchOnReconnect());
    if (observer2) {
      observer2.refetch({
        cancelRefetch: false
      });
    }
    (_this$retryer3 = this.retryer) == null ? void 0 : _this$retryer3.continue();
  }
  addObserver(observer2) {
    if (!this.observers.includes(observer2)) {
      this.observers.push(observer2);
      this.clearGcTimeout();
      this.cache.notify({
        type: "observerAdded",
        query: this,
        observer: observer2
      });
    }
  }
  removeObserver(observer2) {
    if (this.observers.includes(observer2)) {
      this.observers = this.observers.filter((x2) => x2 !== observer2);
      if (!this.observers.length) {
        if (this.retryer) {
          if (this.abortSignalConsumed) {
            this.retryer.cancel({
              revert: true
            });
          } else {
            this.retryer.cancelRetry();
          }
        }
        this.scheduleGc();
      }
      this.cache.notify({
        type: "observerRemoved",
        query: this,
        observer: observer2
      });
    }
  }
  getObserversCount() {
    return this.observers.length;
  }
  invalidate() {
    if (!this.state.isInvalidated) {
      this.dispatch({
        type: "invalidate"
      });
    }
  }
  fetch(options, fetchOptions) {
    var _this$options$behavio, _context$fetchOptions;
    if (this.state.fetchStatus !== "idle") {
      if (this.state.dataUpdatedAt && fetchOptions != null && fetchOptions.cancelRefetch) {
        this.cancel({
          silent: true
        });
      } else if (this.promise) {
        var _this$retryer4;
        (_this$retryer4 = this.retryer) == null ? void 0 : _this$retryer4.continueRetry();
        return this.promise;
      }
    }
    if (options) {
      this.setOptions(options);
    }
    if (!this.options.queryFn) {
      const observer2 = this.observers.find((x2) => x2.options.queryFn);
      if (observer2) {
        this.setOptions(observer2.options);
      }
    }
    if (process.env.NODE_ENV !== "production") {
      if (!Array.isArray(this.options.queryKey)) {
        this.logger.error("As of v4, queryKey needs to be an Array. If you are using a string like 'repoData', please change it to an Array, e.g. ['repoData']");
      }
    }
    const abortController = getAbortController();
    const queryFnContext = {
      queryKey: this.queryKey,
      pageParam: void 0,
      meta: this.meta
    };
    const addSignalProperty = (object4) => {
      Object.defineProperty(object4, "signal", {
        enumerable: true,
        get: () => {
          if (abortController) {
            this.abortSignalConsumed = true;
            return abortController.signal;
          }
          return void 0;
        }
      });
    };
    addSignalProperty(queryFnContext);
    const fetchFn = () => {
      if (!this.options.queryFn) {
        return Promise.reject("Missing queryFn for queryKey '" + this.options.queryHash + "'");
      }
      this.abortSignalConsumed = false;
      return this.options.queryFn(queryFnContext);
    };
    const context = {
      fetchOptions,
      options: this.options,
      queryKey: this.queryKey,
      state: this.state,
      fetchFn
    };
    addSignalProperty(context);
    (_this$options$behavio = this.options.behavior) == null ? void 0 : _this$options$behavio.onFetch(context);
    this.revertState = this.state;
    if (this.state.fetchStatus === "idle" || this.state.fetchMeta !== ((_context$fetchOptions = context.fetchOptions) == null ? void 0 : _context$fetchOptions.meta)) {
      var _context$fetchOptions2;
      this.dispatch({
        type: "fetch",
        meta: (_context$fetchOptions2 = context.fetchOptions) == null ? void 0 : _context$fetchOptions2.meta
      });
    }
    const onError = (error) => {
      if (!(isCancelledError(error) && error.silent)) {
        this.dispatch({
          type: "error",
          error
        });
      }
      if (!isCancelledError(error)) {
        var _this$cache$config$on, _this$cache$config, _this$cache$config$on2, _this$cache$config2;
        (_this$cache$config$on = (_this$cache$config = this.cache.config).onError) == null ? void 0 : _this$cache$config$on.call(_this$cache$config, error, this);
        (_this$cache$config$on2 = (_this$cache$config2 = this.cache.config).onSettled) == null ? void 0 : _this$cache$config$on2.call(_this$cache$config2, this.state.data, error, this);
        if (process.env.NODE_ENV !== "production") {
          this.logger.error(error);
        }
      }
      if (!this.isFetchingOptimistic) {
        this.scheduleGc();
      }
      this.isFetchingOptimistic = false;
    };
    this.retryer = createRetryer({
      fn: context.fetchFn,
      abort: abortController == null ? void 0 : abortController.abort.bind(abortController),
      onSuccess: (data) => {
        var _this$cache$config$on3, _this$cache$config3, _this$cache$config$on4, _this$cache$config4;
        if (typeof data === "undefined") {
          if (process.env.NODE_ENV !== "production") {
            this.logger.error("Query data cannot be undefined. Please make sure to return a value other than undefined from your query function. Affected query key: " + this.queryHash);
          }
          onError(new Error(this.queryHash + " data is undefined"));
          return;
        }
        this.setData(data);
        (_this$cache$config$on3 = (_this$cache$config3 = this.cache.config).onSuccess) == null ? void 0 : _this$cache$config$on3.call(_this$cache$config3, data, this);
        (_this$cache$config$on4 = (_this$cache$config4 = this.cache.config).onSettled) == null ? void 0 : _this$cache$config$on4.call(_this$cache$config4, data, this.state.error, this);
        if (!this.isFetchingOptimistic) {
          this.scheduleGc();
        }
        this.isFetchingOptimistic = false;
      },
      onError,
      onFail: (failureCount, error) => {
        this.dispatch({
          type: "failed",
          failureCount,
          error
        });
      },
      onPause: () => {
        this.dispatch({
          type: "pause"
        });
      },
      onContinue: () => {
        this.dispatch({
          type: "continue"
        });
      },
      retry: context.options.retry,
      retryDelay: context.options.retryDelay,
      networkMode: context.options.networkMode
    });
    this.promise = this.retryer.promise;
    return this.promise;
  }
  dispatch(action) {
    const reducer = (state) => {
      var _action$meta, _action$dataUpdatedAt;
      switch (action.type) {
        case "failed":
          return __spreadProps(__spreadValues({}, state), {
            fetchFailureCount: action.failureCount,
            fetchFailureReason: action.error
          });
        case "pause":
          return __spreadProps(__spreadValues({}, state), {
            fetchStatus: "paused"
          });
        case "continue":
          return __spreadProps(__spreadValues({}, state), {
            fetchStatus: "fetching"
          });
        case "fetch":
          return __spreadValues(__spreadProps(__spreadValues({}, state), {
            fetchFailureCount: 0,
            fetchFailureReason: null,
            fetchMeta: (_action$meta = action.meta) != null ? _action$meta : null,
            fetchStatus: canFetch(this.options.networkMode) ? "fetching" : "paused"
          }), !state.dataUpdatedAt && {
            error: null,
            status: "loading"
          });
        case "success":
          return __spreadValues(__spreadProps(__spreadValues({}, state), {
            data: action.data,
            dataUpdateCount: state.dataUpdateCount + 1,
            dataUpdatedAt: (_action$dataUpdatedAt = action.dataUpdatedAt) != null ? _action$dataUpdatedAt : Date.now(),
            error: null,
            isInvalidated: false,
            status: "success"
          }), !action.manual && {
            fetchStatus: "idle",
            fetchFailureCount: 0,
            fetchFailureReason: null
          });
        case "error":
          const error = action.error;
          if (isCancelledError(error) && error.revert && this.revertState) {
            return __spreadProps(__spreadValues({}, this.revertState), {
              fetchStatus: "idle"
            });
          }
          return __spreadProps(__spreadValues({}, state), {
            error,
            errorUpdateCount: state.errorUpdateCount + 1,
            errorUpdatedAt: Date.now(),
            fetchFailureCount: state.fetchFailureCount + 1,
            fetchFailureReason: error,
            fetchStatus: "idle",
            status: "error"
          });
        case "invalidate":
          return __spreadProps(__spreadValues({}, state), {
            isInvalidated: true
          });
        case "setState":
          return __spreadValues(__spreadValues({}, state), action.state);
      }
    };
    this.state = reducer(this.state);
    notifyManager.batch(() => {
      this.observers.forEach((observer2) => {
        observer2.onQueryUpdate(action);
      });
      this.cache.notify({
        query: this,
        type: "updated",
        action
      });
    });
  }
};
function getDefaultState(options) {
  const data = typeof options.initialData === "function" ? options.initialData() : options.initialData;
  const hasData = typeof data !== "undefined";
  const initialDataUpdatedAt = hasData ? typeof options.initialDataUpdatedAt === "function" ? options.initialDataUpdatedAt() : options.initialDataUpdatedAt : 0;
  return {
    data,
    dataUpdateCount: 0,
    dataUpdatedAt: hasData ? initialDataUpdatedAt != null ? initialDataUpdatedAt : Date.now() : 0,
    error: null,
    errorUpdateCount: 0,
    errorUpdatedAt: 0,
    fetchFailureCount: 0,
    fetchFailureReason: null,
    fetchMeta: null,
    isInvalidated: false,
    status: hasData ? "success" : "loading",
    fetchStatus: "idle"
  };
}

// ../../node_modules/@tanstack/query-core/build/lib/queryCache.mjs
var QueryCache = class extends Subscribable {
  constructor(config) {
    super();
    this.config = config || {};
    this.queries = [];
    this.queriesMap = {};
  }
  build(client, options, state) {
    var _options$queryHash;
    const queryKey = options.queryKey;
    const queryHash = (_options$queryHash = options.queryHash) != null ? _options$queryHash : hashQueryKeyByOptions(queryKey, options);
    let query = this.get(queryHash);
    if (!query) {
      query = new Query({
        cache: this,
        logger: client.getLogger(),
        queryKey,
        queryHash,
        options: client.defaultQueryOptions(options),
        state,
        defaultOptions: client.getQueryDefaults(queryKey)
      });
      this.add(query);
    }
    return query;
  }
  add(query) {
    if (!this.queriesMap[query.queryHash]) {
      this.queriesMap[query.queryHash] = query;
      this.queries.push(query);
      this.notify({
        type: "added",
        query
      });
    }
  }
  remove(query) {
    const queryInMap = this.queriesMap[query.queryHash];
    if (queryInMap) {
      query.destroy();
      this.queries = this.queries.filter((x2) => x2 !== query);
      if (queryInMap === query) {
        delete this.queriesMap[query.queryHash];
      }
      this.notify({
        type: "removed",
        query
      });
    }
  }
  clear() {
    notifyManager.batch(() => {
      this.queries.forEach((query) => {
        this.remove(query);
      });
    });
  }
  get(queryHash) {
    return this.queriesMap[queryHash];
  }
  getAll() {
    return this.queries;
  }
  find(arg1, arg2) {
    const [filters] = parseFilterArgs(arg1, arg2);
    if (typeof filters.exact === "undefined") {
      filters.exact = true;
    }
    return this.queries.find((query) => matchQuery(filters, query));
  }
  findAll(arg1, arg2) {
    const [filters] = parseFilterArgs(arg1, arg2);
    return Object.keys(filters).length > 0 ? this.queries.filter((query) => matchQuery(filters, query)) : this.queries;
  }
  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach(({
        listener
      }) => {
        listener(event);
      });
    });
  }
  onFocus() {
    notifyManager.batch(() => {
      this.queries.forEach((query) => {
        query.onFocus();
      });
    });
  }
  onOnline() {
    notifyManager.batch(() => {
      this.queries.forEach((query) => {
        query.onOnline();
      });
    });
  }
};

// ../../node_modules/@tanstack/query-core/build/lib/mutation.mjs
var Mutation = class extends Removable {
  constructor(config) {
    super();
    this.defaultOptions = config.defaultOptions;
    this.mutationId = config.mutationId;
    this.mutationCache = config.mutationCache;
    this.logger = config.logger || defaultLogger;
    this.observers = [];
    this.state = config.state || getDefaultState2();
    this.setOptions(config.options);
    this.scheduleGc();
  }
  setOptions(options) {
    this.options = __spreadValues(__spreadValues({}, this.defaultOptions), options);
    this.updateCacheTime(this.options.cacheTime);
  }
  get meta() {
    return this.options.meta;
  }
  setState(state) {
    this.dispatch({
      type: "setState",
      state
    });
  }
  addObserver(observer2) {
    if (!this.observers.includes(observer2)) {
      this.observers.push(observer2);
      this.clearGcTimeout();
      this.mutationCache.notify({
        type: "observerAdded",
        mutation: this,
        observer: observer2
      });
    }
  }
  removeObserver(observer2) {
    this.observers = this.observers.filter((x2) => x2 !== observer2);
    this.scheduleGc();
    this.mutationCache.notify({
      type: "observerRemoved",
      mutation: this,
      observer: observer2
    });
  }
  optionalRemove() {
    if (!this.observers.length) {
      if (this.state.status === "loading") {
        this.scheduleGc();
      } else {
        this.mutationCache.remove(this);
      }
    }
  }
  continue() {
    var _this$retryer$continu, _this$retryer;
    return (_this$retryer$continu = (_this$retryer = this.retryer) == null ? void 0 : _this$retryer.continue()) != null ? _this$retryer$continu : this.execute();
  }
  execute() {
    return __async(this, null, function* () {
      const executeMutation = () => {
        var _this$options$retry;
        this.retryer = createRetryer({
          fn: () => {
            if (!this.options.mutationFn) {
              return Promise.reject("No mutationFn found");
            }
            return this.options.mutationFn(this.state.variables);
          },
          onFail: (failureCount, error) => {
            this.dispatch({
              type: "failed",
              failureCount,
              error
            });
          },
          onPause: () => {
            this.dispatch({
              type: "pause"
            });
          },
          onContinue: () => {
            this.dispatch({
              type: "continue"
            });
          },
          retry: (_this$options$retry = this.options.retry) != null ? _this$options$retry : 0,
          retryDelay: this.options.retryDelay,
          networkMode: this.options.networkMode
        });
        return this.retryer.promise;
      };
      const restored = this.state.status === "loading";
      try {
        var _this$mutationCache$c3, _this$mutationCache$c4, _this$options$onSucce, _this$options2, _this$mutationCache$c5, _this$mutationCache$c6, _this$options$onSettl, _this$options3;
        if (!restored) {
          var _this$mutationCache$c, _this$mutationCache$c2, _this$options$onMutat, _this$options;
          this.dispatch({
            type: "loading",
            variables: this.options.variables
          });
          yield (_this$mutationCache$c = (_this$mutationCache$c2 = this.mutationCache.config).onMutate) == null ? void 0 : _this$mutationCache$c.call(_this$mutationCache$c2, this.state.variables, this);
          const context = yield (_this$options$onMutat = (_this$options = this.options).onMutate) == null ? void 0 : _this$options$onMutat.call(_this$options, this.state.variables);
          if (context !== this.state.context) {
            this.dispatch({
              type: "loading",
              context,
              variables: this.state.variables
            });
          }
        }
        const data = yield executeMutation();
        yield (_this$mutationCache$c3 = (_this$mutationCache$c4 = this.mutationCache.config).onSuccess) == null ? void 0 : _this$mutationCache$c3.call(_this$mutationCache$c4, data, this.state.variables, this.state.context, this);
        yield (_this$options$onSucce = (_this$options2 = this.options).onSuccess) == null ? void 0 : _this$options$onSucce.call(_this$options2, data, this.state.variables, this.state.context);
        yield (_this$mutationCache$c5 = (_this$mutationCache$c6 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c5.call(_this$mutationCache$c6, data, null, this.state.variables, this.state.context, this);
        yield (_this$options$onSettl = (_this$options3 = this.options).onSettled) == null ? void 0 : _this$options$onSettl.call(_this$options3, data, null, this.state.variables, this.state.context);
        this.dispatch({
          type: "success",
          data
        });
        return data;
      } catch (error) {
        try {
          var _this$mutationCache$c7, _this$mutationCache$c8, _this$options$onError, _this$options4, _this$mutationCache$c9, _this$mutationCache$c10, _this$options$onSettl2, _this$options5;
          yield (_this$mutationCache$c7 = (_this$mutationCache$c8 = this.mutationCache.config).onError) == null ? void 0 : _this$mutationCache$c7.call(_this$mutationCache$c8, error, this.state.variables, this.state.context, this);
          if (process.env.NODE_ENV !== "production") {
            this.logger.error(error);
          }
          yield (_this$options$onError = (_this$options4 = this.options).onError) == null ? void 0 : _this$options$onError.call(_this$options4, error, this.state.variables, this.state.context);
          yield (_this$mutationCache$c9 = (_this$mutationCache$c10 = this.mutationCache.config).onSettled) == null ? void 0 : _this$mutationCache$c9.call(_this$mutationCache$c10, void 0, error, this.state.variables, this.state.context, this);
          yield (_this$options$onSettl2 = (_this$options5 = this.options).onSettled) == null ? void 0 : _this$options$onSettl2.call(_this$options5, void 0, error, this.state.variables, this.state.context);
          throw error;
        } finally {
          this.dispatch({
            type: "error",
            error
          });
        }
      }
    });
  }
  dispatch(action) {
    const reducer = (state) => {
      switch (action.type) {
        case "failed":
          return __spreadProps(__spreadValues({}, state), {
            failureCount: action.failureCount,
            failureReason: action.error
          });
        case "pause":
          return __spreadProps(__spreadValues({}, state), {
            isPaused: true
          });
        case "continue":
          return __spreadProps(__spreadValues({}, state), {
            isPaused: false
          });
        case "loading":
          return __spreadProps(__spreadValues({}, state), {
            context: action.context,
            data: void 0,
            failureCount: 0,
            failureReason: null,
            error: null,
            isPaused: !canFetch(this.options.networkMode),
            status: "loading",
            variables: action.variables
          });
        case "success":
          return __spreadProps(__spreadValues({}, state), {
            data: action.data,
            failureCount: 0,
            failureReason: null,
            error: null,
            status: "success",
            isPaused: false
          });
        case "error":
          return __spreadProps(__spreadValues({}, state), {
            data: void 0,
            error: action.error,
            failureCount: state.failureCount + 1,
            failureReason: action.error,
            isPaused: false,
            status: "error"
          });
        case "setState":
          return __spreadValues(__spreadValues({}, state), action.state);
      }
    };
    this.state = reducer(this.state);
    notifyManager.batch(() => {
      this.observers.forEach((observer2) => {
        observer2.onMutationUpdate(action);
      });
      this.mutationCache.notify({
        mutation: this,
        type: "updated",
        action
      });
    });
  }
};
function getDefaultState2() {
  return {
    context: void 0,
    data: void 0,
    error: null,
    failureCount: 0,
    failureReason: null,
    isPaused: false,
    status: "idle",
    variables: void 0
  };
}

// ../../node_modules/@tanstack/query-core/build/lib/mutationCache.mjs
var MutationCache = class extends Subscribable {
  constructor(config) {
    super();
    this.config = config || {};
    this.mutations = [];
    this.mutationId = 0;
  }
  build(client, options, state) {
    const mutation = new Mutation({
      mutationCache: this,
      logger: client.getLogger(),
      mutationId: ++this.mutationId,
      options: client.defaultMutationOptions(options),
      state,
      defaultOptions: options.mutationKey ? client.getMutationDefaults(options.mutationKey) : void 0
    });
    this.add(mutation);
    return mutation;
  }
  add(mutation) {
    this.mutations.push(mutation);
    this.notify({
      type: "added",
      mutation
    });
  }
  remove(mutation) {
    this.mutations = this.mutations.filter((x2) => x2 !== mutation);
    this.notify({
      type: "removed",
      mutation
    });
  }
  clear() {
    notifyManager.batch(() => {
      this.mutations.forEach((mutation) => {
        this.remove(mutation);
      });
    });
  }
  getAll() {
    return this.mutations;
  }
  find(filters) {
    if (typeof filters.exact === "undefined") {
      filters.exact = true;
    }
    return this.mutations.find((mutation) => matchMutation(filters, mutation));
  }
  findAll(filters) {
    return this.mutations.filter((mutation) => matchMutation(filters, mutation));
  }
  notify(event) {
    notifyManager.batch(() => {
      this.listeners.forEach(({
        listener
      }) => {
        listener(event);
      });
    });
  }
  resumePausedMutations() {
    var _this$resuming;
    this.resuming = ((_this$resuming = this.resuming) != null ? _this$resuming : Promise.resolve()).then(() => {
      const pausedMutations = this.mutations.filter((x2) => x2.state.isPaused);
      return notifyManager.batch(() => pausedMutations.reduce((promise, mutation) => promise.then(() => mutation.continue().catch(noop6)), Promise.resolve()));
    }).then(() => {
      this.resuming = void 0;
    });
    return this.resuming;
  }
};

// services/auth.service.ts
var servicePath = "/account";
var login = (values) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${servicePath}/login`,
    values
  );
  return data;
});
var register2 = (values) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(`${servicePath}/sign_up`, values);
  return data;
});
var confirmRegistration = (values) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${servicePath}/confirm_sign_up`,
    values
  );
  return data;
});
var currentUser = () => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(`${servicePath}/userinfo`);
  return data;
});
var updateUser = (values) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(`${servicePath}/updateUserInfo`, values);
  return data;
});
var resendConfirmationCode = (email2) => __async(void 0, null, function* () {
  const formData = new FormData();
  formData.append("input", email2);
  const { data } = yield axios_default.post(
    `${servicePath}/resend_confirm_code`,
    formData
  );
  return data;
});
var refreshToken = (refreshToken2) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${servicePath}/refresh-token`,
    refreshToken2
  );
  return data;
});
var resetPassword = (values) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(`${servicePath}/reset_password`, values);
  return data;
});
var enableTourVisited = (tour) => __async(void 0, null, function* () {
  const { data } = yield axios_default.patch(`${servicePath}/tour/${tour}`);
  return data;
});
var changePassword = (values) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${servicePath}/confirm-forgot-password`,
    values
  );
  return data;
});
var forgetPassword = (username) => __async(void 0, null, function* () {
  const formData = new FormData();
  formData.append("username", username);
  const { data } = yield axios_default.post(
    `${servicePath}/forgot-password`,
    formData
  );
  return data;
});

// components/icons/NotificationIcon.tsx
var import_jsx_runtime204 = require("react/jsx-runtime");
var NotificationIcon2 = () => {
  return /* @__PURE__ */ (0, import_jsx_runtime204.jsxs)(
    "svg",
    {
      width: "30",
      height: "28",
      viewBox: "0 0 30 28",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ (0, import_jsx_runtime204.jsx)(
          "path",
          {
            id: "Exclude",
            "fill-rule": "evenodd",
            "clip-rule": "evenodd",
            d: "M19.1297 7.41091L26.9999 5.52232C26.1506 4.01623 24.9198 2.79503 23.3017 1.8607C21.1567 0.62156 18.7011 0 15.9289 0C13.5519 0 11.3735 0.545857 9.39561 1.6296C7.4138 2.71733 5.85273 4.2035 4.7124 6.09208C3.57207 7.97868 2.99994 10.1043 2.99994 12.3933C2.99994 14.6824 3.57207 16.7722 4.7124 18.6607C5.85273 20.5493 7.4079 22.0415 9.37792 23.1392C9.74165 23.3424 10.1113 23.5256 10.4888 23.691V20.3521C10.4888 18.597 10.9783 17.1447 11.8434 15.9912C11.8591 15.9693 11.8748 15.9494 11.8906 15.9295C11.6271 15.6406 11.3971 15.3258 11.2024 14.9892C10.8092 14.2062 10.5871 13.3197 10.5871 12.3814C10.5871 9.25168 13.0506 6.70767 16.1196 6.62798C16.1442 6.62798 16.1688 6.62748 16.1934 6.62698C16.2179 6.62648 16.2425 6.62599 16.2671 6.62599C16.3064 6.62599 16.3457 6.62599 16.385 6.62798C16.4342 6.62997 16.4853 6.63196 16.5345 6.63196C16.5443 6.63296 16.5536 6.63346 16.563 6.63396C16.5723 6.63445 16.5817 6.63495 16.5915 6.63595C17.5136 6.68974 18.3767 6.96466 19.1297 7.41091ZM17.9208 17.1884V11.6162L26.8606 8.16379V18.6845C26.3867 19.3897 25.8264 20.0571 25.1796 20.6866C24.4777 21.3719 23.7286 21.9596 22.9343 22.4497C22.6453 22.629 22.3484 22.7944 22.0456 22.9478C21.8903 23.0274 21.733 23.1031 21.5738 23.1749V15.1524L21.5639 15.1583L20.8404 15.5608L17.9208 17.1884Z",
            fill: "currentColor"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime204.jsx)(
          "path",
          {
            d: "M0 12.793H30C30 20.9706 23.3707 27.5998 15.1931 27.5998H14.8069C6.62926 27.5998 0 20.9706 0 12.793Z",
            fill: "url(#paint0_angular_7218_24202)"
          }
        ),
        /* @__PURE__ */ (0, import_jsx_runtime204.jsxs)(
          "radialGradient",
          {
            id: "paint0_angular_7218_24202",
            cx: "0",
            cy: "0",
            r: "1",
            gradientUnits: "userSpaceOnUse",
            gradientTransform: "translate(15.72 17.3535) rotate(91.2414) scale(33.2344 28.5318)",
            children: [
              /* @__PURE__ */ (0, import_jsx_runtime204.jsx)("stop", { "stop-color": "white", "stop-opacity": "0.4" }),
              /* @__PURE__ */ (0, import_jsx_runtime204.jsx)("stop", { offset: "1", "stop-color": "white", "stop-opacity": "0" })
            ]
          }
        )
      ]
    }
  );
};
var NotificationIcon_default = NotificationIcon2;

// utils/helpers/open-notification.tsx
var import_jsx_runtime205 = require("react/jsx-runtime");
var notificationContent = {
  success: {
    icon: /* @__PURE__ */ (0, import_jsx_runtime205.jsx)("span", { style: { color: "#52C41A" }, children: /* @__PURE__ */ (0, import_jsx_runtime205.jsx)(NotificationIcon_default, {}) }),
    message: "Success"
  },
  error: {
    icon: /* @__PURE__ */ (0, import_jsx_runtime205.jsx)("span", { style: { color: "#FF0000" }, children: /* @__PURE__ */ (0, import_jsx_runtime205.jsx)(NotificationIcon_default, {}) }),
    message: "Error"
  },
  warning: {
    icon: /* @__PURE__ */ (0, import_jsx_runtime205.jsx)("span", { style: { color: "#FAAD14" }, children: /* @__PURE__ */ (0, import_jsx_runtime205.jsx)(NotificationIcon_default, {}) }),
    message: "Warning"
  },
  info: {
    icon: /* @__PURE__ */ (0, import_jsx_runtime205.jsx)("span", { style: { color: "#1677FF" }, children: /* @__PURE__ */ (0, import_jsx_runtime205.jsx)(NotificationIcon_default, {}) }),
    message: "Info"
  }
};
var openNotification = (description, type4 = "success", duration = 4) => {
  notification_default.open({
    type: type4,
    description,
    message: notificationContent[type4].message,
    icon: notificationContent[type4].icon,
    duration
  });
};

// utils/general/query-error-handler.ts
var isRedirecting = false;
var errorHandler = (error, query, mutation, variables) => {
  var _a, _b, _c, _d, _e, _f, _g, _h, _i, _j, _k, _l;
  const { status, data, config } = error.response;
  if (status === 401 && (((_a = data == null ? void 0 : data.message) == null ? void 0 : _a.startsWith("Failed to validate the token")) || ((_b = data == null ? void 0 : data.message) == null ? void 0 : _b.startsWith(
    "An error occurred while attempting to decode the Jwt"
  )) || (data == null ? void 0 : data.message) === "Full authentication is required to access this resource") || ((_c = data == null ? void 0 : data.message) == null ? void 0 : _c.toLowerCase().includes("jwt expired"))) {
    if (mutation)
      refreshTokenAndRetry(void 0, mutation, variables);
    else
      refreshTokenAndRetry(query);
  } else if (!(((_d = config == null ? void 0 : config.url) == null ? void 0 : _d.startsWith("/smartsearch/search/last")) || ((_e = config == null ? void 0 : config.url) == null ? void 0 : _e.startsWith("/account/sign_up")) || ((_f = config == null ? void 0 : config.url) == null ? void 0 : _f.endsWith("/datacenter/database")) || ((_g = config == null ? void 0 : config.url) == null ? void 0 : _g.endsWith("/datacenter/file")) || ((_h = config == null ? void 0 : config.url) == null ? void 0 : _h.endsWith("/datacenter/enterprise-connector")) || ((_i = config == null ? void 0 : config.url) == null ? void 0 : _i.endsWith("/smartsearch/search/create")) || ((_j = config == null ? void 0 : config.url) == null ? void 0 : _j.endsWith("/smartsearch/last")) || ((_k = config == null ? void 0 : config.url) == null ? void 0 : _k.endsWith("/account/confirm-phone-number")) || ((_l = config == null ? void 0 : config.url) == null ? void 0 : _l.endsWith("/account/confirm_sign_up")))) {
    if ((data == null ? void 0 : data.message) === "Your subscription has expired. Please proceed to reactivate it.")
      openNotification(data == null ? void 0 : data.message, "info");
    else
      openNotification(data == null ? void 0 : data.message, "error");
  }
};
var queryErrorHandler = (error, query) => {
  errorHandler(error, query);
};
var mutationErrorHandler = (error, variables, context, mutation) => {
  errorHandler(error, void 0, mutation, variables);
};
var refreshTokenAndRetry = (query, mutation, variables) => __async(void 0, null, function* () {
  try {
    const { accessToken, refreshToken: refreshTkn } = yield refreshToken({
      username: getUsernameAccessToken(),
      refreshToken: getRefreshToken()
    });
    setAccessToken(accessToken);
    setRefreshToken(refreshTkn);
    if (mutation) {
      const { options } = mutation;
      mutation.setOptions(__spreadProps(__spreadValues({}, options), { variables }));
      mutation.execute();
    } else
      query.fetch();
  } catch (e) {
    removeAccessToken();
    removeRefreshToken();
    if (!isRedirecting) {
      isRedirecting = true;
      window.location.href = "/auth/sign-in?sessionExpired=true";
    }
  }
});

// utils/general/query-client.ts
var convertMultiplier = 6e4;
var cacheTime = 0;
var staleTime = 0;
var queryClientConfig = {
  defaultOptions: {
    queries: {
      retry: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      refetchOnWindowFocus: false,
      refetchIntervalInBackground: false,
      suspense: false,
      refetchInterval: 0,
      cacheTime: cacheTime * convertMultiplier,
      staleTime: staleTime * convertMultiplier
    },
    mutations: {
      retry: false
    }
  },
  queryCache: new QueryCache({
    onError: queryErrorHandler
  }),
  mutationCache: new MutationCache({
    onError: mutationErrorHandler
  })
};
var getRelatedCacheKey = (queryClient, targetKey) => {
  return queryClient.getQueryCache().getAll().map((query) => query.queryKey).filter((key) => {
    return Array.isArray(key) ? key[0] === targetKey[0] : key === targetKey[0];
  });
};

// interfaces/dashboard.interface.ts
var PageType = /* @__PURE__ */ ((PageType2) => {
  PageType2["PORTRAIT"] = "PORTRAIT";
  PageType2["LANDSCAPE"] = "LANDSCAPE";
  return PageType2;
})(PageType || {});

// utils/general/formatters.ts
var transformItemsToMappedObject = (arr) => {
  return arr.reduce((result, item) => {
    result[item.key] = item.label || "";
    return result;
  }, {});
};
var dashboardDateFormatter = (value) => {
  const originalDate = new Date(value);
  return `${(originalDate.getUTCDay() + 1).toString().padStart(2, "0")}-${(originalDate.getUTCMonth() + 1).toString().padStart(2, "0")}-${originalDate.getUTCFullYear()} | ${originalDate.getUTCHours().toString().padStart(2, "0")}:${originalDate.getUTCMinutes().toString().padStart(2, "0")}`;
};
var generatePageGrids = (type4) => {
  return type4 === "LANDSCAPE" /* LANDSCAPE */ ? Array(8).fill(0).map(() => Array(12).fill(0)) : Array(12).fill(0).map(() => Array(8).fill(0));
};
var datasetDateFormatter = (value) => {
  const originalDate = new Date(value);
  const currentDate = /* @__PURE__ */ new Date();
  const timeDifference = currentDate.getTime() - originalDate.getTime();
  const oneDay = 24 * 60 * 60 * 1e3;
  const oneWeek = 7 * oneDay;
  if (timeDifference < oneDay) {
    return " Modified Today";
  } else if (timeDifference < 2 * oneDay) {
    return " Modified 1 day ago";
  } else if (timeDifference < oneWeek) {
    const daysAgo = Math.floor(timeDifference / oneDay);
    return ` Modified ${daysAgo} days ago`;
  } else if (timeDifference < 2 * oneWeek) {
    return " Modified a week ago";
  } else {
    return ` ${(originalDate.getUTCDay() + 1).toString().padStart(2, "0")}-${(originalDate.getUTCMonth() + 1).toString().padStart(2, "0")}-${originalDate.getUTCFullYear()} | ${originalDate.getUTCHours().toString().padStart(2, "0")}:${originalDate.getUTCMinutes().toString().padStart(2, "0")}`;
  }
};
var jsonParseSingleQuotes = (value) => {
  return (0, eval)("(" + value + ")");
};
var updatePageGridMatrice = (matrice, items) => {
  for (const item of items) {
    const { x: x2, y: y2, w, h } = item;
    const startY = Math.max(0, y2);
    const endY = Math.min(matrice.length, y2 + h);
    const startX = Math.max(0, x2);
    const endX = Math.min(matrice[0].length, x2 + w);
    for (let i = startY; i < endY; i++) {
      for (let j = startX; j < endX; j++) {
        matrice[i][j] = 1;
      }
    }
  }
  return matrice;
};
var formatDate = (date4) => new Date(date4).toISOString().split("T")[0];

// utils/general/constants.ts
var dataRole = [
  "Business Owner",
  "HR Trainer",
  "Marketer - at a company",
  "Marketer - freelance",
  "Teacher/Educator",
  "Sales",
  "Designer/Developer",
  "Hobbyist/Personal User",
  "Data Scientist",
  "Other"
];
var dataCompany = [
  "eCommerce",
  "Retail",
  "Advertising",
  "Marketing Agency",
  "Training/Education",
  "Finance",
  "Insurance",
  "News/Media/Press",
  "Software/Online Service",
  "Medical/Health Care",
  "Entertainment/Games/Sport",
  "Other"
];

// utils/helpers/queries.ts
var QUERIES = {
  CHAT_CONVERSATIONS: "chat-conversations",
  DISCUSSION_MESSAGES: "discussion-messages",
  DASHBOARDS: "dashboards",
  DASHBOARD: "dashboard",
  SEARCH_HISTORY: "search-history",
  SEARCH_MARKED_HISTORY: "marked-search-history",
  SEARCH_SUGGESTIONS: "search-suggestions",
  SEARCH: "search",
  CREATE_DATABASE: "create-database",
  DATA_SETS: "data-sets",
  PAGE: "page",
  PAGE_GRID: "page-grid",
  USER_INFO: "user-info",
  DOCUMENTS: "documents",
  PLANS: "plans",
  PAYMENT_CARDS: "payment-cards",
  GRID_ITEM: "grid-item",
  INVOICES: "invoices",
  SEARCH_USAGE: "search-usage",
  USAGE: "usage",
  RECENT_SEARCHES: "recent-searches",
  LATEST_SEARCH: "latest-search",
  RESET_SEARCH: "reset-search",
  DOC_SUMMARY: "doc-summary",
  DASHBOARD_NAME: "dashboard-name",
  DEMO_SUGGESTIONS: "demo-suggestions"
};

// utils/styles/mixins.tsx
var import_styled_components14 = require("styled-components");
var scrollBarStyles = () => import_styled_components14.css`
  &::-webkit-scrollbar {
    width: 10px;
    height: 10px;
  }

  &::-webkit-scrollbar-track {
    background-color: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #8b8b8b;
    border-radius: 7px;
  }

  &::-webkit-scrollbar-button {
    display: block;
    height: 16px;
    width: 16px;
    background-color: transparent;
    border: none;
  }

  &::-webkit-scrollbar-button:single-button:vertical:decrement {
    height: 12px;
    width: 16px;
    background-position: center 6px;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='50,00 0,50 100,50'/></svg>");
  }

  &::-webkit-scrollbar-button:single-button:vertical:increment {
    height: 12px;
    width: 16px;
    background-position: center center;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='0,0 100,0 50,50'/></svg>");
  }

  &::-webkit-scrollbar-button:single-button:horizontal:decrement {
    height: 12px;
    width: 16px;
    background-position: 10px center;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='0,50 50,0 50,100'/></svg>");
  }

  &::-webkit-scrollbar-button:single-button:horizontal:increment {
    height: 12px;
    width: 16px;
    background-position: 6px center;
    background-image: url("data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='100' height='100' fill='rgb(96, 96, 96)'><polygon points='50,00 100,50 50,100'/></svg>");
  }
`;

// temp/smart-search.temp.ts
var documents = [
  {
    key: "1",
    typeIndex: "pdf",
    label: "Client_Names",
    date: "24-10-2023 09:16:58"
  },
  {
    key: "2",
    typeIndex: "doc",
    label: "New_Produ",
    date: "24-10-2023 09:16:58"
  },
  {
    key: "3",
    typeIndex: "pdf",
    label: "Pieces",
    date: "24-10-2023 09:16:58"
  },
  {
    key: "4",
    typeIndex: "txt",
    label: "lastSuggestions",
    date: "24-10-2023 09:16:58"
  },
  {
    key: "5",
    typeIndex: "xls",
    label: "Something",
    date: "24-10-2023 09:16:58"
  },
  {
    key: "6",
    typeIndex: "pdf",
    label: "Client_Names",
    date: "24-10-2023 09:16:58"
  },
  {
    key: "7",
    typeIndex: "pdf",
    label: "Pieces",
    date: "24-10-2023 09:16:58"
  },
  {
    key: "9",
    typeIndex: "txt",
    label: "lastSuggestions",
    date: "24-10-2023 09:16:58"
  },
  {
    key: "10",
    typeIndex: "doc",
    label: "New_Produ",
    date: "24-10-2023 09:16:58"
  }
];

// services/smart-search.service.ts
var servicePath2 = "/smartsearch";
var getDiscussionsHistory = (pageNo) => __async(void 0, null, function* () {
  const { data } = yield axios.get(
    `${servicePath2}/conversation/all`,
    { params: { pageNo } }
  );
  return data;
});
var getDiscussionMessages = (_0) => __async(void 0, [_0], function* ({
  conversationID,
  pageNo,
  beforeDate
}) {
  const { data } = yield axios.get(
    `${servicePath2}/message/all`,
    { params: { conversationId: conversationID, pageNo, beforeDate } }
  );
  return data;
});
var CreateMessages = (message2) => __async(void 0, null, function* () {
  const updatedMessage = __spreadProps(__spreadValues({}, message2), {
    dataSources: isEmpty(message2.dataSources) ? null : message2.dataSources
  });
  const token2 = getAccessToken();
  const response = yield fetch(`${BASE_URL}${servicePath2}/message`, {
    method: "POST",
    body: JSON.stringify(updatedMessage),
    headers: {
      "Content-Type": "application/json",
      authorization: `Bearer ${token2}`
    }
  });
  return response;
});
var getSearchHistory = () => __async(void 0, null, function* () {
  const { data } = yield axios.get(
    `${servicePath2}/all/not-marked`,
    { params: { pageNo: 0 } }
  );
  return data;
});
var deleteConversation = (ids) => __async(void 0, null, function* () {
  const { data } = yield axios.delete(
    `${servicePath2}/conversation`,
    { data: ids }
  );
  return data;
});
var UpdateConversation = (conversation) => __async(void 0, null, function* () {
  const { data } = yield axios.put(
    `${servicePath2}/conversation`,
    conversation
  );
  return data;
});
var getMarkedSearchHistory = () => __async(void 0, null, function* () {
  const { data } = yield axios.get(
    `${servicePath2}/all/marked`,
    { params: { pageNo: 0 } }
  );
  return data;
});
var switchMarkedSearchHistory = (id) => __async(void 0, null, function* () {
  const { data } = yield axios.get(`${servicePath2}/${id}`);
  return data;
});
var deleteSearchHistory = (id) => __async(void 0, null, function* () {
  const { data } = yield axios.delete(
    `${servicePath2}/${id}`
  );
  return data;
});
var getSearchSuggestions = (searchRquest) => __async(void 0, null, function* () {
  const { data } = yield axios.post(
    `${servicePath2}/auto-complete`,
    searchRquest
  );
  return data;
});
var searchWhisper = (_0) => __async(void 0, [_0], function* ({ audio, filename }) {
  const formData = new FormData();
  formData.append("file", audio, filename);
  const { data } = yield axios.post(
    `${servicePath2}/whisper`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
  return data;
});
var search = (searchRquest) => __async(void 0, null, function* () {
  const { data } = yield axios.post(
    `${servicePath2}/search/create`,
    searchRquest
  );
  return data;
});
var searchSettings = (searchRquest) => __async(void 0, null, function* () {
  const { data } = yield axios.post(
    `${servicePath2}/search/settings`,
    searchRquest
  );
  return data;
});
var getdocuments = () => __async(void 0, null, function* () {
  return documents;
});
var checkSearchSession = (databaseId) => __async(void 0, null, function* () {
  const { status } = yield axios.get(
    `${servicePath2}/session/check/${databaseId}`
  );
  return status;
});
var resetSearchSession = (databaseId) => __async(void 0, null, function* () {
  const { status } = yield axios.get(
    `${servicePath2}/session/reset/${databaseId}`
  );
  return status;
});
var getSearchSession = (databaseId) => __async(void 0, null, function* () {
  const { data } = yield axios.get(
    `${servicePath2}/search/last/${databaseId}`
  );
  return data;
});
var getLatestSearch = () => __async(void 0, null, function* () {
  const { data } = yield axios.get(
    `${servicePath2}/last`
  );
  return data;
});
var getSearchSessionById = (searchId) => __async(void 0, null, function* () {
  const { data } = yield axios.get(
    `${servicePath2}/search/${searchId}`
  );
  return data;
});
var getRecentSearch = (_0) => __async(void 0, [_0], function* ({
  body,
  pageNo
}) {
  const { data } = yield axios.get(
    `${servicePath2}/recent-search/${body}`,
    { params: { pageNo, pageSize: 5 } }
  );
  return data;
});
var getSmartSearchUsage = (usageRequest) => __async(void 0, null, function* () {
  const { data } = yield axios.post(
    `${servicePath2}/usage`,
    usageRequest
  );
  return data;
});
var getDataSourceSummary = (id) => __async(void 0, null, function* () {
  const { data } = yield axios.get(
    `${servicePath2}/doc-summary/${id}`
  );
  return data;
});

// services/dashboard.service.ts
var servicePath3 = "/dashboard";
var getDashboards = (_0) => __async(void 0, [_0], function* ({
  body,
  pageNo,
  beforeDate,
  sortBy,
  sort
}) {
  const { data } = yield axios_default.post(
    `${servicePath3}/all`,
    body,
    { params: { pageNo, sortBy, sort, beforeDate } }
  );
  return data;
});
var createDashboard = (dashboard) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${servicePath3}/create`,
    dashboard
  );
  return data;
});
var updateDashboard = (dashboard) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${servicePath3}/update`,
    dashboard
  );
  return data;
});
var shareDashboard = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.patch(
    `${servicePath3}/share/${id}`
  );
  return data;
});
var deleteDashboards = (ids) => __async(void 0, null, function* () {
  const { data } = yield axios_default.delete(
    `${servicePath3}/delete`,
    { data: ids }
  );
  return data;
});
var getDashboardById = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${servicePath3}/${id}`
  );
  return data;
});
var getPageGridItems = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${servicePath3}/page/${id}`
  );
  return data;
});
var createPage = (_0) => __async(void 0, [_0], function* ({
  dashboardId,
  page
}) {
  const { data } = yield axios_default.post(
    `${servicePath3}/page/${dashboardId}`,
    page
  );
  return data;
});
var updatePage = (page) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${servicePath3}/page`,
    page
  );
  return data;
});
var deletePages = (ids) => __async(void 0, null, function* () {
  const { data } = yield axios_default.delete(
    `${servicePath3}/page`,
    { data: ids }
  );
  return data;
});
var updateSettings = (searchRquest) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${servicePath3}/settings`,
    searchRquest
  );
  return data.data;
});
var getSearchSettings = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${servicePath3}/settings/${id}`
  );
  return data;
});
var associatePageChartGridItem = (_0) => __async(void 0, [_0], function* ({
  pageId,
  settingsId,
  gridItem
}) {
  const { data } = yield axios_default.post(
    `${servicePath3}/grid-item/chart/create/${pageId}/${settingsId}`,
    gridItem
  );
  return data;
});
var associatePageTableGridItem = (_0) => __async(void 0, [_0], function* ({
  pageId,
  settingsId,
  gridItem
}) {
  const { data } = yield axios_default.post(
    `${servicePath3}/grid-item/table/create/${pageId}/${settingsId}`,
    gridItem
  );
  return data;
});
var getPageGridItem = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(`${servicePath3}/grid-item/${id}`);
  return data;
});
var createPageGridItem = (_0) => __async(void 0, [_0], function* ({
  pageId,
  gridItem
}) {
  const { data } = yield axios_default.post(
    `${servicePath3}/grid-item/create/${pageId}`,
    gridItem
  );
  return data;
});
var deletePageGridItem = (value) => __async(void 0, null, function* () {
  const { data } = yield axios_default.delete(
    `${servicePath3}/grid-item/delete`,
    { data: value }
  );
  return data;
});
var updatePageGridItemsPlacement = (pageGridItems) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${servicePath3}/page/grid-items`,
    pageGridItems
  );
  return data;
});
var updatePagesOrder = (pages) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(`${servicePath3}/page/order`, pages);
  return data;
});
var updateGridItem = (chartItem) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${servicePath3}/grid-item/update`,
    chartItem
  );
  return data;
});
var promptUpdate = (promptRequest) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${servicePath3}/settings/prompt`,
    promptRequest
  );
  return data;
});
var refreshGridItemData = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${servicePath3}/grid-item/refresh/${id}`
  );
  return data;
});
var exportSearchResponseExcel = (settingId) => __async(void 0, null, function* () {
  axios_default.get(`${servicePath3}/settings/${settingId}/excel`, {
    responseType: "blob"
  }).then((response) => {
    const url2 = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url2;
    link.setAttribute("download", `dataTable.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
});

// services/datacenter.service.ts
var servicePath4 = "/datacenter";
var getDataSources = (_0) => __async(void 0, [_0], function* ({
  body,
  pageNo,
  beforeDate,
  pageSize,
  sortBy,
  sort
}) {
  const { data } = yield axios_default.post(
    `${servicePath4}/datasource`,
    body,
    { params: { pageNo, sortBy, sort, pageSize, beforeDate } }
  );
  return data;
});
var switchDataSourceStatus = (databaseId) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${servicePath4}/datasource/status/${databaseId}`
  );
  return data;
});
var getDatabases = () => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(`${servicePath4}/database/all`);
  return data;
});
var createDatabase = (database) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${servicePath4}/database`,
    database
  );
  return data;
});
var updateDatabase = (database) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${servicePath4}/database`,
    database
  );
  return data;
});
var getDatabase = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${servicePath4}/database/${id}`
  );
  return data;
});
var testConnectionDataBase = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${servicePath4}/database/connection/${id}`
  );
  return data;
});
var createFile = (file) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${servicePath4}/file`,
    file
  );
  return data;
});
var updateFile = (file) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${servicePath4}/file`,
    file
  );
  return data;
});
var getFile = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(`${servicePath4}/file/${id}`);
  return data;
});
var createEnterpriseConnector = (enterpriseConnector) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(`${servicePath4}/enterprise-connector`, enterpriseConnector);
  return data;
});
var updateEnterpriseConnector = (enterpriseConnector) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(`${servicePath4}/enterprise-connector`, enterpriseConnector);
  return data;
});
var getEnterpriseConnector = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${servicePath4}/enterprise-connector/${id}`
  );
  return data;
});
var deleteDatasources = (ids) => __async(void 0, null, function* () {
  const { data } = yield axios_default.delete(
    `${servicePath4}/datasource`,
    { data: ids }
  );
  return data;
});
var getTopics = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${servicePath4}/datasource/topic/${id}`
  );
  return data.topics;
});

// services/package.service.ts
var packagePath = "/package";
var getAllPackages = () => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(`${packagePath}/all`);
  return data;
});
var createPackage = (plan) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${packagePath}/create`,
    plan
  );
  return data;
});
var getPackageById = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(`${packagePath}/${id}`);
  return data;
});
var deletePackage = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.delete(
    `${packagePath}/${id}`
  );
  return data;
});
var updatePackage = (id, plan) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${packagePath}/${id}`,
    plan
  );
  return data;
});
var updatePackagesOrder = (ids) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${packagePath}/order`,
    ids
  );
  return data;
});
var getAllProducts = () => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(`${packagePath}/product/all`);
  return data;
});
var getAllUsage = () => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(`${packagePath}/product/all`);
  return data;
});
var addUsagePackage = (values) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${packagePath}/product/create`,
    values
  );
  return data;
});
var deleteUsageCard = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.delete(
    `${packagePath}/product/${id}`
  );
  return data;
});
var editUsageProduct = (values) => __async(void 0, null, function* () {
  const { data } = yield axios_default.put(
    `${packagePath}/product/update`,
    values
  );
  return data;
});

// services/payment.service.ts
var paymentPath = "/payment";
var subscribeToPackage = (_0) => __async(void 0, [_0], function* ({
  packageId,
  isYearly
}) {
  const { data } = yield axios_default.post(
    `${paymentPath}/subscribe/${packageId}${isYearly ? "/yearly" : ""}`
  );
  return data;
});
var addPaymentCard = (tokenId) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${paymentPath}/stripe/card`,
    void 0,
    {
      headers: { tokenId }
    }
  );
  return data;
});
var getPaymentCards = () => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${paymentPath}/stripe/cards`
  );
  return data;
});
var setDefaultPaymentCard = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${paymentPath}/stripe/card/${id}`
  );
  return data;
});
var deletePaymentCard = (id) => __async(void 0, null, function* () {
  const { data } = yield axios_default.delete(
    `${paymentPath}/stripe/card/${id}`
  );
  return data;
});
var cancelSubscription = () => __async(void 0, null, function* () {
  const { data } = yield axios_default.delete(
    `${paymentPath}/stripe/subscription`
  );
  return data;
});
var getInvoicesData = () => __async(void 0, null, function* () {
  const { data } = yield axios_default.get(
    `${paymentPath}/invoice`
  );
  return data;
});
var increaseUsage = (request) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${paymentPath}/charge`,
    {
      type: request.Type,
      quantity: request.quantity
    },
    { params: { cardId: request.cardId } }
  );
  return data;
});

// services/storage.service.ts
var storagepath = "/storage";
var uploadFile = (file) => __async(void 0, null, function* () {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = yield axios_default.post(`${storagepath}/public`, formData, {
    headers: {
      "Content-Type": "multipart/form-data"
    }
  });
  return data.fileKey;
});
var downloadFile = (fileName) => __async(void 0, null, function* () {
  axios_default.get(`${storagepath}/public/${fileName}`, {
    responseType: "blob"
  }).then((response) => {
    const url2 = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url2;
    link.setAttribute("download", `${fileName}`);
    document.body.appendChild(link);
    link.click();
  });
});

// services/notification.service.ts
var notificationPath = "/notification";
var contactEnterprisePackage = (body) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${notificationPath}/enterprise-package-contact`,
    body
  );
  return data;
});
var contactSupport = (body) => __async(void 0, null, function* () {
  const { data } = yield axios_default.post(
    `${notificationPath}/support-contact`,
    body
  );
  return data;
});

// services/trial-demo.service.ts
var import_axios11 = __toESM(require_axios2());
var BASE_URL2 = "https://onegate-ai-trial.peaqock.com";
var TEMP_BASE_URL = "https://onegate-ai-temp.peaqock.com";
var axios2 = import_axios11.default.create({
  baseURL: BASE_URL2
});
var tempAxios = import_axios11.default.create({
  baseURL: TEMP_BASE_URL
});
var searchChat = (_0) => __async(void 0, [_0], function* ({ path: path2, message: message2 }) {
  const response = yield fetch(`${TEMP_BASE_URL}/${path2}`, {
    method: "POST",
    body: JSON.stringify({
      session_id: "3fa85f64-5717-4562-b3fc-2c963f66afa2",
      message: message2
    }),
    headers: {
      "Content-Type": "application/json"
    }
  });
  return response;
});
var searchTools = (_0) => __async(void 0, [_0], function* ({ prefix, values }) {
  const { data } = yield tempAxios.post(
    `/${prefix}/tools`,
    {
      tools: values.map((value) => ({
        name: value.name,
        args: __spreadProps(__spreadValues({}, value.args), {
          chart_prompt: value.chart_prompt
        })
      }))
    }
  );
  return data;
});
var getDashboardName = (_0) => __async(void 0, [_0], function* ({
  values,
  type: type4
}) {
  const { data } = yield tempAxios.post(
    `/${type4}/dashboard_name`,
    { data: values }
  );
  return data;
});
var updateSearchReport = (_0) => __async(void 0, [_0], function* ({
  content,
  prompt
}) {
  const response = yield fetch(`${BASE_URL2}/reporting/update_report`, {
    method: "POST",
    body: JSON.stringify({
      session_id: "3fa85f64-5717-4562-b3fc-2c963f66afa2",
      content,
      prompt
    }),
    headers: {
      "Content-Type": "application/json"
    }
  });
  return response;
});
var getSearchRecommendations = (_0) => __async(void 0, [_0], function* ({
  chartData,
  type: type4
}) {
  const { data } = yield axios2.post(
    `/${type4}/analyze_data`,
    {
      data: [chartData]
    }
  );
  return data;
});
var demoChat = (_0) => __async(void 0, [_0], function* ({ id, sector, prompt }) {
  const response = yield fetch(`${BASE_URL2}/${sector}/chat`, {
    method: "POST",
    body: JSON.stringify({
      id,
      prompt
    }),
    headers: {
      "Content-Type": "application/json"
    }
  });
  return response;
});
var demoExecuteSQL = (_0) => __async(void 0, [_0], function* ({ sector, id }) {
  const response = yield fetch(`${BASE_URL2}/${sector}/run`, {
    method: "POST",
    body: JSON.stringify({
      id
    }),
    headers: {
      "Content-Type": "application/json"
    }
  });
  return response;
});
var demoExecuteSuggestion = (_a) => __async(void 0, null, function* () {
  var _b = _a, {
    sector
  } = _b, payload = __objRest(_b, [
    "sector"
  ]);
  const response = yield fetch(`${BASE_URL2}/${sector}/run_suggestions`, {
    method: "POST",
    body: JSON.stringify(payload),
    headers: {
      "Content-Type": "application/json"
    }
  });
  return response;
});
var demoSuggestions = (sector) => __async(void 0, null, function* () {
  const { data } = yield axios2.get(
    `/${sector}/suggestions`
  );
  return data;
});
var demoAttempts = (id) => __async(void 0, null, function* () {
  const { data } = yield axios2.post(`/attempts/`, {
    id
  });
  return data;
});
var demoChatWhisper = (_0) => __async(void 0, [_0], function* ({
  audio,
  filename
}) {
  const formData = new FormData();
  formData.append("file", audio, filename);
  const { data } = yield axios2.post(
    "/whisper/",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data"
      }
    }
  );
  return data;
});

// interfaces/chat.interface.ts
var chatType = /* @__PURE__ */ ((chatType2) => {
  chatType2["model"] = "MODEL";
  chatType2["data"] = "DATA";
  chatType2["website"] = "website";
  chatType2["web_data"] = "web_data";
  chatType2["jira"] = "jira";
  return chatType2;
})(chatType || {});

// interfaces/auth.interface.ts
var Authority = /* @__PURE__ */ ((Authority2) => {
  Authority2["OG_GUEST"] = "OG_GUEST";
  Authority2["OG_SUBSCRIBER"] = "OG_SUBSCRIBER";
  Authority2["OG_SUBSCRIBER_EX"] = "OG_SUBSCRIBER_EX";
  Authority2["OG_ADMIN"] = "OG_ADMIN";
  return Authority2;
})(Authority || {});
var ProductTourType = /* @__PURE__ */ ((ProductTourType2) => {
  ProductTourType2["SMART_SEARCH_TOUR"] = "SMART_SEARCH_TOUR";
  ProductTourType2["SEARCH_VISUALIZATION_TOUR"] = "SEARCH_VISUALIZATION_TOUR";
  ProductTourType2["DASHBOARD_TOUR"] = "DASHBOARD_TOUR";
  return ProductTourType2;
})(ProductTourType || {});

// interfaces/package.interface.ts
var PackageType = /* @__PURE__ */ ((PackageType2) => {
  PackageType2["PLAN"] = "PLAN";
  PackageType2["FREE_TRIAL"] = "FREE_TRIAL";
  PackageType2["ENTERPRISE"] = "ENTERPRISE";
  return PackageType2;
})(PackageType || {});

// interfaces/product.interface.ts
var IProductType = /* @__PURE__ */ ((IProductType2) => {
  IProductType2["CHAT"] = "CHAT";
  IProductType2["SEARCH"] = "SEARCH";
  IProductType2["PROMPT_CHART_UPDATE"] = "PROMPT_CHART_UPDATE";
  return IProductType2;
})(IProductType || {});

// interfaces/notification.interface.ts
var NotificationType = /* @__PURE__ */ ((NotificationType2) => {
  NotificationType2["TOPIC"] = "topic";
  NotificationType2["NOTIFICATION"] = "notification";
  NotificationType2["SUBSCRIPTION_CREATED"] = "subscription created";
  NotificationType2["PAYMENT_FAILED"] = "payment failed";
  return NotificationType2;
})(NotificationType || {});

// interfaces/trial-demo.interface.ts
var ComponentType = /* @__PURE__ */ ((ComponentType2) => {
  ComponentType2["CHART"] = "CHART";
  return ComponentType2;
})(ComponentType || {});
var AgentTool = /* @__PURE__ */ ((AgentTool2) => {
  AgentTool2["calculate_total_stock_value"] = "calculate_total_stock_value";
  AgentTool2["calculate_stock_shortage_by_region"] = "calculate_stock_shortage_by_region";
  AgentTool2["calculate_average_stock_duration"] = "calculate_average_stock_duration";
  AgentTool2["calculate_logistics_cost_per_unit"] = "calculate_logistics_cost_per_unit";
  AgentTool2["calculate_supplier_performance"] = "calculate_supplier_performance";
  AgentTool2["calculate_replenishment_time"] = "calculate_replenishment_time";
  AgentTool2["calculate_warehouse_utilization"] = "calculate_warehouse_utilization";
  AgentTool2["calculate_ca"] = "calculate_ca";
  AgentTool2["get_top_20_profitable_products"] = "get_top_20_profitable_products";
  AgentTool2["calculate_saturation_index"] = "calculate_saturation_index";
  AgentTool2["calculate_stock_turnover_rate"] = "calculate_stock_turnover_rate";
  AgentTool2["calculate_loyalty_rate"] = "calculate_loyalty_rate";
  AgentTool2["calculate_bio_contribution"] = "calculate_bio_contribution";
  AgentTool2["calculate_online_vs_physical_sales"] = "calculate_online_vs_physical_sales";
  AgentTool2["calculate_customer_satisfaction_rate"] = "calculate_customer_satisfaction_rate";
  AgentTool2["calculate_nps"] = "calculate_nps";
  AgentTool2["calculate_average_customer_loyalty"] = "calculate_average_customer_loyalty";
  AgentTool2["calculate_clv"] = "calculate_clv";
  AgentTool2["calculate_promotion_sensitivity"] = "calculate_promotion_sensitivity";
  AgentTool2["calculate_marketing_conversion_rate"] = "calculate_marketing_conversion_rate";
  AgentTool2["calculate_return_rate"] = "calculate_return_rate";
  AgentTool2["calculate_employee_performance"] = "calculate_employee_performance";
  AgentTool2["calculate_checkout_utilization"] = "calculate_checkout_utilization";
  AgentTool2["calculate_employee_turnover"] = "calculate_employee_turnover";
  AgentTool2["calculate_absenteeism_rate"] = "calculate_absenteeism_rate";
  AgentTool2["calculate_sales_per_employee"] = "calculate_sales_per_employee";
  AgentTool2["calculate_checkout_wait_time"] = "calculate_checkout_wait_time";
  AgentTool2["calculate_service_efficiency_rate"] = "calculate_service_efficiency_rate";
  AgentTool2["calculate_regional_growth"] = "calculate_regional_growth";
  AgentTool2["calculate_market_share"] = "calculate_market_share";
  AgentTool2["calculate_regional_costs"] = "calculate_regional_costs";
  AgentTool2["calculate_ad_campaign_impact"] = "calculate_ad_campaign_impact";
  return AgentTool2;
})(AgentTool || {});
var gridStackCoordinates = {
  0: [],
  1: [
    {
      x: 0,
      y: 0,
      w: 12,
      h: 8
    }
  ],
  2: [
    {
      x: 0,
      y: 0,
      w: 6,
      h: 8
    },
    {
      x: 6,
      y: 0,
      w: 6,
      h: 8
    }
  ],
  3: [
    {
      x: 0,
      y: 0,
      w: 6,
      h: 8
    },
    {
      x: 6,
      y: 0,
      w: 6,
      h: 4
    },
    {
      x: 6,
      y: 4,
      w: 6,
      h: 4
    }
  ],
  4: [
    {
      x: 0,
      y: 0,
      w: 6,
      h: 4
    },
    {
      x: 0,
      y: 4,
      w: 6,
      h: 4
    },
    {
      x: 6,
      y: 0,
      w: 6,
      h: 4
    },
    {
      x: 6,
      y: 4,
      w: 6,
      h: 4
    }
  ],
  5: [
    {
      x: 0,
      y: 0,
      w: 4,
      h: 4
    },
    {
      x: 4,
      y: 0,
      w: 4,
      h: 4
    },
    {
      x: 8,
      y: 0,
      w: 4,
      h: 4
    },
    {
      x: 0,
      y: 4,
      w: 6,
      h: 4
    },
    {
      x: 6,
      y: 4,
      w: 6,
      h: 4
    }
  ],
  6: [
    {
      x: 0,
      y: 0,
      w: 4,
      h: 4
    },
    {
      x: 4,
      y: 0,
      w: 4,
      h: 4
    },
    {
      x: 8,
      y: 0,
      w: 4,
      h: 4
    },
    {
      x: 0,
      y: 4,
      w: 4,
      h: 4
    },
    {
      x: 4,
      y: 4,
      w: 4,
      h: 4
    },
    {
      x: 8,
      y: 4,
      w: 4,
      h: 4
    }
  ]
};
var ComponentType = /* @__PURE__ */ ((ComponentType2) => {
  ComponentType2["REPORT"] = "REPORT";
  ComponentType2["POLICY"] = "POLICY";
  ComponentType2["DASHBOARD"] = "DASHBOARD";
  return ComponentType2;
})(ComponentType || {});
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  APP_URL,
  AgentTool,
  Authority,
  BASE_URL,
  BarChart,
  CardChart,
  ChartHeader,
  ChartSelection,
  ColorPicker,
  ComponentType,
  CreateMessages,
  DataSourceStatus,
  DataSourceType,
  DatabaseType,
  DeleteModal,
  Editor,
  Empty,
  EnterpriseConnectorType,
  FORMAT,
  FileType,
  GridItemType,
  IProductType,
  LineChart,
  Loading,
  NotificationType,
  PackageType,
  PageType,
  PaginationComponent,
  PieChart,
  PositionType,
  ProductTourType,
  QUERIES,
  RadarChart,
  STRIPE_TOKEN,
  UpdateConversation,
  WHITELISTED_URLS,
  addPaymentCard,
  addUsagePackage,
  associatePageChartGridItem,
  associatePageTableGridItem,
  axios,
  cancelSubscription,
  changePassword,
  chartType,
  chatType,
  checkSearchSession,
  confirmRegistration,
  contactEnterprisePackage,
  contactSupport,
  createDashboard,
  createDatabase,
  createEnterpriseConnector,
  createFile,
  createPackage,
  createPage,
  createPageGridItem,
  currentUser,
  dashboardCharts,
  dashboardDateFormatter,
  dataCompany,
  dataRole,
  datasetDateFormatter,
  deleteConversation,
  deleteDashboards,
  deleteDatasources,
  deletePackage,
  deletePageGridItem,
  deletePages,
  deletePaymentCard,
  deleteSearchHistory,
  deleteUsageCard,
  demoAttempts,
  demoChat,
  demoChatWhisper,
  demoExecuteSQL,
  demoExecuteSuggestion,
  demoSuggestions,
  downloadFile,
  editUsageProduct,
  enableTourVisited,
  exportSearchResponseExcel,
  forgetPassword,
  formatDate,
  generatePageGrids,
  getAccessToken,
  getAllPackages,
  getAllProducts,
  getAllUsage,
  getDashboardById,
  getDashboardName,
  getDashboards,
  getDataSourceSummary,
  getDataSources,
  getDatabase,
  getDatabases,
  getDiscussionMessages,
  getDiscussionsHistory,
  getEnterpriseConnector,
  getFile,
  getInvoicesData,
  getLatestSearch,
  getMarkedSearchHistory,
  getPackageById,
  getPageGridItem,
  getPageGridItems,
  getPaymentCards,
  getRecentSearch,
  getRefreshToken,
  getRelatedCacheKey,
  getSearchHistory,
  getSearchRecommendations,
  getSearchSession,
  getSearchSessionById,
  getSearchSettings,
  getSearchSuggestions,
  getSmartSearchUsage,
  getTopics,
  getUsernameAccessToken,
  getdocuments,
  gridStackCoordinates,
  increaseUsage,
  isContainWhiteSpace,
  isEmail,
  isEmpty,
  isValidUrl,
  jsonParseSingleQuotes,
  login,
  numberCommasFormer,
  openNotification,
  persistNumberEntry,
  promptUpdate,
  queryClientConfig,
  refreshGridItemData,
  refreshToken,
  register,
  removeAccessToken,
  removeRefreshToken,
  resendConfirmationCode,
  resetPassword,
  resetSearchSession,
  scrollBarStyles,
  search,
  searchChat,
  searchSettings,
  searchTools,
  searchWhisper,
  setAccessToken,
  setDefaultPaymentCard,
  setRefreshToken,
  shareDashboard,
  subscribeToPackage,
  switchDataSourceStatus,
  switchMarkedSearchHistory,
  testConnectionDataBase,
  transformItemsToMappedObject,
  underScoreFormer,
  updateDashboard,
  updateDatabase,
  updateEnterpriseConnector,
  updateFile,
  updateGridItem,
  updatePackage,
  updatePackagesOrder,
  updatePage,
  updatePageGridItemsPlacement,
  updatePageGridMatrice,
  updatePagesOrder,
  updateSearchReport,
  updateSettings,
  updateUser,
  uploadFile,
  useAppLayout,
  useDebounce,
  useDocumentTitle,
  useMountedEffect,
  uuidV4Pattern
});
/*! Bundled license information:

classnames/index.js:
  (*!
  	Copyright (c) 2018 Jed Watson.
  	Licensed under the MIT License (MIT), see
  	http://jedwatson.github.io/classnames
  *)

react-is/cjs/react-is.production.min.js:
  (**
   * @license React
   * react-is.production.min.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

react-is/cjs/react-is.development.js:
  (**
   * @license React
   * react-is.development.js
   *
   * Copyright (c) Facebook, Inc. and its affiliates.
   *
   * This source code is licensed under the MIT license found in the
   * LICENSE file in the root directory of this source tree.
   *)

@ckeditor/ckeditor5-react/dist/index.js:
  (*!
   * @license Copyright (c) 2003-2023, CKSource Holding sp. z o.o. All rights reserved.
   * For licensing, see LICENSE.md.
   *)

mime-db/index.js:
  (*!
   * mime-db
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2015-2022 Douglas Christopher Wilson
   * MIT Licensed
   *)

mime-types/index.js:
  (*!
   * mime-types
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2015 Douglas Christopher Wilson
   * MIT Licensed
   *)

@babel/runtime/helpers/esm/regeneratorRuntime.js:
  (*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE *)
*/
